/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 35615:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var map = {
	"./algoliaAnalytics.engine.js": [
		33520,
		520
	],
	"./deviceIdTargeting.engine.js": [
		84806,
		806
	],
	"./estatTag.engine.js": [
		44128,
		128
	],
	"./example.engine.js": [
		81140,
		140
	],
	"./facebook.engine.js": [
		5168,
		168
	],
	"./gemius.engine.js": [
		89992,
		992
	],
	"./googleAds.engine.js": [
		83537,
		98,
		537
	],
	"./googleAnalytics.engine.js": [
		99051,
		51
	],
	"./googleAnalyticsMeasurementProtocolTrackingService.engine.js": [
		69132,
		132
	],
	"./googleGlobalSiteTag.engine.js": [
		52098,
		98
	],
	"./krxd.engine.js": [
		31260,
		260
	],
	"./newrelic.engine.js": [
		2489,
		489
	],
	"./nielsen.engine.js": [
		71254,
		254
	],
	"./pianoDmp.engine.js": [
		37767,
		767
	],
	"./snapchat.engine.js": [
		16077,
		77
	],
	"./snowplow.engine.js": [
		90103,
		103
	],
	"./ssaTealiumHttp.engine.js": [
		54312
	],
	"./tealium.engine.js": [
		22473,
		473
	],
	"./tiktok.engine.js": [
		86425,
		425
	],
	"./usabilla.engine.js": [
		82853,
		853
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 35615;
module.exports = webpackAsyncContext;

/***/ }),

/***/ 39814:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   k: () => (/* binding */ FetchError)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77402);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67478);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50851);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9924);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(54183);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99711);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23885);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42615);
/* harmony import */ var _babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(43515);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65439);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_5__);









function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(t); if (r) { var s = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var FetchError = function (_Error) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(FetchError, _Error);
  var _super = _createSuper(FetchError);
  function FetchError() {
    var _this;
    var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var request = arguments.length > 1 ? arguments[1] : undefined;
    var response = arguments.length > 2 ? arguments[2] : undefined;
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(this, FetchError);
    _this = _super.call(this);
    try {
      _this.name = _this.constructor.name;
      _this.message = error instanceof Error ? error.toString() : error;
      _this.type = null;
      _this.request = request;
      _this.stack = error instanceof Error ? error.stack : new Error().stack;
    } catch (_a) {}
    if (response) {
      var xBackendServer = lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(response, ['headers', 'x-backend-server'], '');
      _this.response = response;
      _this.status = response.status;
      _this.xBackendServer = xBackendServer;
    }
    return _this;
  }
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(FetchError);
}((0,_babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(Error));

/***/ }),

/***/ 94031:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   n: () => (/* binding */ fido)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8032);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90565);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57031);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89652);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54183);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9924);
/* harmony import */ var lodash_forEach__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17489);
/* harmony import */ var lodash_forEach__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_forEach__WEBPACK_IMPORTED_MODULE_2__);







var Fido = function () {
  function Fido() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, Fido);
    this._platformCode = null;
    this._customerCode = null;
    this._appVersion = null;
    this._clientCode = null;
    this._localDeviceId = null;
    this._localHomeId = null;
    this._saltAndSugar = null;
    this._getCurrentTime = function () {
      return Date.now();
    };
    this._waitTimeout = 10000;
    this._maxTimeout = 60000;
    this._imageSalt = '54b55408a530954b553ff79e98';
    this._usedCapacityToken = null;
    this.baseUrlsByAPIType = {};
    this.isInitialized = false;
  }
  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(Fido, [{
    key: "init",
    value: function init() {
      var _this = this;
      var immutableProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var services = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      if (!this.isInitialized) {
        lodash_forEach__WEBPACK_IMPORTED_MODULE_2___default()(immutableProps, function (value, key) {
          var privateKey = "_".concat(key);
          if (key !== 'isInitialized' && key !== 'baseUrlsByAPIType' && _this[privateKey] !== undefined) {
            _this[privateKey] = value;
          }
        });
        if (immutableProps.baseUrlsByAPIType) {
          this.baseUrlsByAPIType = Object.assign({}, immutableProps.baseUrlsByAPIType);
        }
        this.isInitialized = true;
      }
      services.forEach(function (service) {
        if (Array.isArray(service)) {
          var _service = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(service, 2),
            serviceInstance = _service[0],
            _service$ = _service[1],
            params = _service$ === void 0 ? [] : _service$;
          serviceInstance.init.apply(serviceInstance, (0,_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(params));
        } else {
          service.init();
        }
      });
    }
  }, {
    key: "get",
    value: function get(key) {
      this.checkInit();
      var privateKey = "_".concat(key);
      return this[privateKey];
    }
  }, {
    key: "set",
    value: function set(key, value) {
      this.checkInit();
      var privateKey = "_".concat(key);
      this[privateKey] = value;
    }
  }, {
    key: "setBaseUrls",
    value: function setBaseUrls(baseUrlsByAPIType) {
      var _this2 = this;
      this.checkInit();
      lodash_forEach__WEBPACK_IMPORTED_MODULE_2___default()(baseUrlsByAPIType, function (value, key) {
        _this2.baseUrlsByAPIType[key] = value;
      });
    }
  }, {
    key: "getBaseUrl",
    value: function getBaseUrl(apiType) {
      this.checkInit();
      return this.baseUrlsByAPIType[apiType];
    }
  }, {
    key: "checkInit",
    value: function checkInit() {
      if (!this.isInitialized) {
        throw new Error('You should init Fido before using it');
      }
    }
  }]);
  return Fido;
}();
var fido = new Fido();

/***/ }),

/***/ 1445:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  x: () => (/* binding */ FetcherService)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(29548);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(77402);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__(45190);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(28610);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__(49747);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__(8612);
// EXTERNAL MODULE: ./node_modules/.pnpm/regenerator-runtime@0.13.11/node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__(90250);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(39342);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(54183);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(9924);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(18790);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(69033);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/fido.js
var fido = __webpack_require__(94031);
// EXTERNAL MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/utils/fetch.js
var fetch = __webpack_require__(20280);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__(8032);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/utils/fido.utils.js


var addFidoPropertyIfDefined = function addFidoPropertyIfDefined() {
  var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var fidoConfigKey = arguments.length > 1 ? arguments[1] : undefined;
  var targetPropertyName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : fidoConfigKey;
  return function () {
    var cloneTarget = Object.assign({}, target);
    if (fido/* fido */.n.get(fidoConfigKey)) {
      cloneTarget[targetPropertyName] = fido/* fido */.n.get(fidoConfigKey);
    }
    return cloneTarget;
  };
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/authentication/decorators/decorators-builder.js

var createAddHeaderDecorator = function createAddHeaderDecorator() {
  var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  var applyToArgument = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return function (target, name, descriptor) {
    var fn = descriptor.value;
    descriptor.value = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var argument = args[applyToArgument] || {
        headers: {}
      };
      var headersToAdd = callback.apply(void 0, args);
      if (headersToAdd) {
        argument.headers = Object.assign(Object.assign({}, headersToAdd), argument.headers);
        args[applyToArgument] = argument;
      }
      return fn.apply(this, args);
    };
    return descriptor;
  };
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/authentication/decorators/withCustomerHeader.js


var withCustomerHeader = function withCustomerHeader() {
  var applyToArgument = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return createAddHeaderDecorator(addFidoPropertyIfDefined({}, 'customerCode', 'X-Customer-Name'), applyToArgument);
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/authentication/decorators/withRequestTimeoutHeader.js


var withRequestTimeoutHeader = function withRequestTimeoutHeader() {
  var applyToArgument = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return createAddHeaderDecorator(function (url) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return {
      'Request-Timeout': String(options.waitTimeout || fido/* fido */.n.get('waitTimeout'))
    };
  }, applyToArgument);
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/authentication/decorators/withVersionHeader.js


var withVersionHeader = function withVersionHeader() {
  var applyToArgument = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return createAddHeaderDecorator(addFidoPropertyIfDefined({}, 'appVersion', 'X-Client-Release'), applyToArgument);
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/fetcherService.js












var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,esm_typeof/* default */.Z)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var FetcherService = function () {
  function FetcherService() {
    (0,classCallCheck/* default */.Z)(this, FetcherService);
    this.isInitialized = false;
    this.basePath = '';
    this.apiType = '';
    this.displayName = '';
  }
  (0,createClass/* default */.Z)(FetcherService, [{
    key: "init",
    value: function init() {
      throw new Error("You should implement the init function of Fido's ".concat(this.getName()));
    }
  }, {
    key: "externalFetch",
    value: (function () {
      var _externalFetch = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(url, options) {
        var _yield$fetchUtils, body;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0,fetch/* fetch */.h)(url, options);
            case 2:
              _yield$fetchUtils = _context.sent;
              body = _yield$fetchUtils.body;
              return _context.abrupt("return", body);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function externalFetch(_x, _x2) {
        return _externalFetch.apply(this, arguments);
      }
      return externalFetch;
    }())
  }, {
    key: "fetch",
    value: function () {
      var _fetch = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2(url, options) {
        var _yield$this$fetchWith, body;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.fetchWithResponse(url, options);
            case 2:
              _yield$this$fetchWith = _context2.sent;
              body = _yield$this$fetchWith.body;
              return _context2.abrupt("return", body);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetch(_x3, _x4) {
        return _fetch.apply(this, arguments);
      }
      return fetch;
    }()
  }, {
    key: "fetchWithoutVersionHeaders",
    value: function () {
      var _fetchWithoutVersionHeaders = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee3(url, options) {
        var _yield$fetchUtils2, body;
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return (0,fetch/* fetch */.h)(url, options);
            case 2:
              _yield$fetchUtils2 = _context3.sent;
              body = _yield$fetchUtils2.body;
              return _context3.abrupt("return", body);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function fetchWithoutVersionHeaders(_x5, _x6) {
        return _fetchWithoutVersionHeaders.apply(this, arguments);
      }
      return fetchWithoutVersionHeaders;
    }()
  }, {
    key: "fetchWithResponse",
    value: function fetchWithResponse(url, options) {
      return (0,fetch/* fetch */.h)(url, options);
    }
  }, {
    key: "fetchWithStatus",
    value: function () {
      var _fetchWithStatus = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee4(url, options) {
        var _yield$fetchUtils3, status, response;
        return regenerator_default().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return (0,fetch/* fetch */.h)(url, options);
            case 3:
              _yield$fetchUtils3 = _context4.sent;
              status = _yield$fetchUtils3.status;
              return _context4.abrupt("return", status);
            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](0);
              response = _context4.t0.response;
              if (!response) {
                _context4.next = 13;
                break;
              }
              return _context4.abrupt("return", response.status);
            case 13:
              return _context4.abrupt("return", 0);
            case 14:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 8]]);
      }));
      function fetchWithStatus(_x7, _x8) {
        return _fetchWithStatus.apply(this, arguments);
      }
      return fetchWithStatus;
    }()
  }, {
    key: "getName",
    value: function getName() {
      return this.displayName || this.constructor.name;
    }
  }, {
    key: "getRoutePath",
    value: function getRoutePath(endpoint) {
      var withVersion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var path = "/".concat(this.basePath ? "".concat(this.basePath, "/") : '').concat(endpoint);
      if (withVersion) {
        var baseUrl = fido/* fido */.n.getBaseUrl(this.apiType);
        var matches = baseUrl.match(/\/(v[0-9])$/);
        if (matches) {
          return "/".concat(matches[1]).concat(path);
        }
      }
      return path;
    }
  }, {
    key: "getRouteUrl",
    value: function getRouteUrl() {
      var endpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var clientCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : fido/* fido */.n.get('clientCode');
      var platformCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : fido/* fido */.n.get('platformCode');
      this.checkInit();
      if (!this.apiType) {
        throw new Error("You should define an API type for Fido's ".concat(this.getName()));
      }
      return "".concat(fido/* fido */.n.getBaseUrl(this.apiType).replace('%(clientCode)s', clientCode)).concat(this.getRoutePath(endpoint).replace('%(platformCode)s', platformCode));
    }
  }, {
    key: "getHomeOrDeviceId",
    value: function getHomeOrDeviceId() {
      var prefixedId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.checkInit();
      var deviceId = fido/* fido */.n.get('localDeviceId');
      var homeId = fido/* fido */.n.get('localHomeId');
      if (homeId) {
        return prefixedId ? "homeid-".concat(homeId) : "".concat(homeId);
      }
      return prefixedId ? "deviceid-".concat(deviceId) : "".concat(deviceId);
    }
  }, {
    key: "checkInit",
    value: function checkInit(apiType) {
      if (!this.isInitialized) {
        throw new Error("You should init Fido's ".concat(this.getName(), " before using it"));
      }
      if (!fido/* fido */.n.getBaseUrl(apiType || this.apiType)) {
        throw new Error("You should set baseUrl for ".concat(this.getName(), " before using it"));
      }
    }
  }]);
  return FetcherService;
}();
__decorate([withVersionHeader(1), withCustomerHeader(1), withRequestTimeoutHeader(1)], FetcherService.prototype, "fetch", null);
__decorate([withCustomerHeader(1), withRequestTimeoutHeader(1)], FetcherService.prototype, "fetchWithoutVersionHeaders", null);
__decorate([withVersionHeader(1), withCustomerHeader(1), withRequestTimeoutHeader(1)], FetcherService.prototype, "fetchWithResponse", null);
__decorate([withVersionHeader(1), withCustomerHeader(1), withRequestTimeoutHeader(1)], FetcherService.prototype, "fetchWithStatus", null);

/***/ }),

/***/ 29461:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   K_: () => (/* binding */ frontspaces),
/* harmony export */   bL: () => (/* binding */ navigationTargets),
/* harmony export */   j3: () => (/* binding */ aliases),
/* harmony export */   jF: () => (/* binding */ entities)
/* harmony export */ });
/* unused harmony export appPages */
var entities = {
  service: 'service',
  program: 'program',
  folder: 'folder',
  frontspace: 'frontspace',
  alias: 'alias',
  video: 'video',
  audio: 'audio',
  live: 'live',
  radio: 'radio',
  app: 'app',
  article: 'article',
  season: 'season'
};
var aliases = {
  home: 'home',
  kids: 'kids'
};
var frontspaces = {
  bookmarks: 'bookmarks',
  landing: 'landing',
  offers: 'offers',
  profilesgate: 'profilesgate',
  search: 'search',
  tvapppreview: 'tvapppreview',
  screensaver: 'screensaver',
  devicesmanagementcenter: 'devicesmanagementcenter',
  devicesgate: 'devicesgate',
  epggrid: 'epggrid'
};
var navigationTargets = {
  desktop: 'desktop',
  mobile: 'mobile',
  smarttv: 'smarttv',
  tv: 'tv',
  webview: 'webview'
};
var appPages = {
  account: 'account',
  account_billing: 'account_billing',
  account_bookmarks: 'account_bookmarks',
  account_informations: 'account_informations',
  account_legalconditions: 'account_legalconditions',
  account_pairing: 'account_pairing',
  account_newsletters: 'account_newsletters',
  account_overview: 'account_overview',
  account_parentalcontrol: 'account_parentalcontrol',
  account_parentalfilter: 'account_parentalfilter',
  account_profilesmanagement: 'account_profilesmanagement',
  account_profilesmanagement_profilecreation: 'account_profilesmanagement_profilecreation',
  account_preferences: 'account_preferences',
  consentsmanagement_account: 'consentsmanagement_account',
  consentsmanagement_device: 'consentsmanagement_device',
  privacy_policy: 'privacy_policy'
};

/***/ }),

/***/ 17301:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   q: () => (/* binding */ AbstractTrackingEngine)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29548);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8032);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28610);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6938);
/* harmony import */ var core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54183);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9924);






var AbstractTrackingEngine = function () {
  function AbstractTrackingEngine() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, AbstractTrackingEngine);
    this.currentVariants = [];
    this.attributesKeysMapping = {};
    this.events = {};
  }
  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(AbstractTrackingEngine, [{
    key: "init",
    value: function init(_ref) {
      var _ref$deviceAttributes = _ref.deviceAttributes,
        deviceAttributes = _ref$deviceAttributes === void 0 ? {} : _ref$deviceAttributes,
        _ref$events = _ref.events,
        events = _ref$events === void 0 ? {} : _ref$events,
        _ref$attributesKeysMa = _ref.attributesKeysMapping,
        attributesKeysMapping = _ref$attributesKeysMa === void 0 ? {} : _ref$attributesKeysMa,
        _ref$isDeviceBrowser = _ref.isDeviceBrowser,
        isDeviceBrowser = _ref$isDeviceBrowser === void 0 ? false : _ref$isDeviceBrowser,
        _ref$initialAbTestVar = _ref.initialAbTestVariants,
        initialAbTestVariants = _ref$initialAbTestVar === void 0 ? [] : _ref$initialAbTestVar;
      this.events = events;
      this.currentVariants = initialAbTestVariants;
      this.isDeviceBrowser = isDeviceBrowser;
      this.deviceAttributes = deviceAttributes;
      this.attributesKeysMapping = attributesKeysMapping;
    }
  }, {
    key: "setUser",
    value: function setUser(_ref2) {
      var variants = _ref2.variants;
      this.currentVariants = variants;
    }
  }, {
    key: "getBrowserLayer",
    value: function getBrowserLayer() {
      var getUserAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (this.isDeviceBrowser) {
        return Object.assign({
          'dom.url': window.location.href,
          page_url: window.location.href,
          page_path: window.location.pathname,
          page_title: document.title,
          page_query_params: window.location.search,
          referrer: document.referrer,
          device_resolution: "".concat(window.screen.width, "x").concat(window.screen.height),
          viewport_size: "".concat(window.innerWidth, "x").concat(window.innerHeight),
          pixel_depth: window.screen.pixelDepth,
          device_language: navigator.language
        }, getUserAgent && {
          user_agent: navigator.userAgent
        });
      }
      return {};
    }
  }]);
  return AbstractTrackingEngine;
}();

/***/ }),

/***/ 46262:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Bg: () => (/* binding */ TEALIUM_MAPPING),
/* harmony export */   Pb: () => (/* binding */ DEFAULT_INIT_DELAY_IN_MS),
/* harmony export */   kr: () => (/* binding */ MOCK_THIRDPARTY_OBJECT_KEY),
/* harmony export */   ks: () => (/* binding */ ENGINES_METHODS),
/* harmony export */   oc: () => (/* binding */ NAMESPACE_ERROR),
/* harmony export */   qy: () => (/* binding */ ENGINES_EVENT_METHODS),
/* harmony export */   xI: () => (/* binding */ DEPENDANT_ENGINES)
/* harmony export */ });
var MOCK_THIRDPARTY_OBJECT_KEY = 'thirdParties';
var NAMESPACE_ERROR = 'app:thirdParties:error';
var DEFAULT_INIT_DELAY_IN_MS = 5000;
var DEPENDANT_ENGINES = ['googleAds'];
var ENGINES_EVENT_METHODS = {
  sendEvent: 'sendEvent',
  sendClickEvent: 'sendClickEvent',
  sendPrintEvent: 'sendPrintEvent'
};
var ENGINES_METHODS = {
  sendErrorEvent: 'sendErrorEvent',
  sendPageViewEvent: 'sendPageViewEvent',
  disableEngine: 'disableEngine',
  getEpics: 'getEpics',
  userChange: 'setUser',
  gdprChange: 'gdprChange',
  setContentGroup: 'setContentGroup',
  setCustomAttributes: 'setCustomAttributes',
  getCustomAttributes: 'getCustomAttributes',
  setEnhancedECommerceAction: 'setEnhancedECommerceAction',
  setEnhancedECommerceAddProduct: 'setEnhancedECommerceAddProduct',
  setEnhancedECommerceProductCheckout: 'setEnhancedECommerceProductCheckout',
  setEnhancedECommerceProductPurchase: 'setEnhancedECommerceProductPurchase'
};
var TEALIUM_MAPPING = {
  dimension1: 'gigya_id',
  dimension2: 'device_id',
  dimension3: 'ip_hashed',
  dimension4: 'bedrock_platform_code',
  dimension5: 'authenticated',
  dimension6: 'user_type',
  dimension7: 'freemium_pack',
  dimension8: 'persona',
  dimension9: 'auth_method',
  dimension10: 'current_entity_type',
  dimension11: 'service',
  dimension12: 'publication_type',
  dimension13: 'clip_type',
  dimension14: 'program_category',
  dimension15: 'program_title',
  dimension16: 'clip_title',
  dimension17: 'clip_id',
  dimension18: 'player_audio',
  dimension19: 'player_subtitles',
  dimension20: 'position',
  dimension21: 'first_connexion',
  dimension22: 'player_screen_mode',
  dimension23: 'support',
  dimension24: 'template_name',
  dimension25: 'cast',
  dimension26: 'autoplay',
  dimension27: 'switch_language',
  dimension28: 'subtitle_active',
  dimension29: 'from',
  dimension30: 'ad_blocker',
  dimension31: 'block_title',
  dimension32: 'profile_id',
  dimension33: 'layout_id',
  dimension34: 'user_status',
  dimension35: 'section',
  dimension36: 'user_segments',
  dimension37: 'operator',
  dimension38: 'tv_brand',
  dimension39: 'user_agent',
  dimension40: 'tv_year',
  dimension41: 'connection_type',
  dimension42: 'device_orientation',
  dimension43: 'app_version',
  dimension44: 'app_os_version',
  dimension45: 'network_id',
  dimension46: 'block_rank',
  dimension47: 'box_type',
  dimension48: 'survey_id',
  dimension49: 'app_referer',
  dimension50: 'heartbeat_session',
  dimension51: 'a_b_test',
  dimension52: 'next_video',
  dimension53: 'current_entity_id',
  dimension54: 'player_current_timecode',
  dimension55: 'airplay',
  dimension56: 'picture_in_picture',
  dimension57: 'offers_name',
  dimension58: 'previous_offers',
  dimension59: 'user_age',
  dimension60: 'user_gender',
  dimension61: 'user_offer',
  dimension62: 'user_offers_number',
  dimension63: 'gdpr_consent_tracking',
  dimension64: 'gdpr_consent_adtargeting',
  dimension65: 'age_restriction',
  dimension66: 'consent_level',
  dimension67: 'timestamp',
  dimension68: 'analytics_cookie_value',
  dimension69: 'current_page_group_types',
  dimension70: 'device_model',
  dimension71: 'content_status',
  dimension72: 'salesforce_user_id',
  dimension73: 'program_customer_key_id',
  dimension74: 'special_event_name',
  dimension75: 'clip_customer_key_id',
  pageName: 'page_name',
  eventAction: 'event_action',
  eventLabel: 'event_label',
  eventCategory: 'event_category'
};

/***/ }),

/***/ 21781:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   r: () => (/* binding */ googleAttributesValuesMapping)
/* harmony export */ });
var yesOrNo = function yesOrNo(value) {
  return value ? 'yes' : 'no';
};
var googleAttributesValuesMapping = {
  adBlockEnabled: yesOrNo,
  isNewUser: yesOrNo
};

/***/ }),

/***/ 54312:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29548);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10115);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93485);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53252);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97343);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8032);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67478);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96317);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(75287);
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(28610);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50851);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(94978);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(49747);
/* harmony import */ var core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(74389);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(97072);
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(87807);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(90250);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(39342);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(54183);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(9924);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(47552);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(99711);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(23885);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(42615);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(69033);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(65439);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(82691);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var lodash_isNil__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(46207);
/* harmony import */ var lodash_isNil__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(lodash_isNil__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var lodash_omitBy__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(24465);
/* harmony import */ var lodash_omitBy__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(lodash_omitBy__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _fido__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(94031);
/* harmony import */ var _utils_fetch__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(20280);
/* harmony import */ var _utils_queryParamSerializer__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(97605);
/* harmony import */ var _abstract_abstractTrackingEngine__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(17301);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(46262);
/* harmony import */ var _constants_googleAttributesMappings_constant__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(21781);
/* harmony import */ var _event_utils__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(84155);
/* harmony import */ var _gaAttributesToTealium__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(29432);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(14698);

























function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(t); if (r) { var s = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }













var isBlockerError = function isBlockerError(error) {
  var isTimeout = error && error.message && error.message.includes('timeout');
  return !lodash_get__WEBPACK_IMPORTED_MODULE_19___default()(error, 'response.status') && !isTimeout;
};
var SsaTealiumHttp = function (_AbstractTrackingEngi) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(SsaTealiumHttp, _AbstractTrackingEngi);
  var _super = _createSuper(SsaTealiumHttp);
  function SsaTealiumHttp() {
    var _this;
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(this, SsaTealiumHttp);
    _this = _super.apply(this, arguments);
    _this.customAttributes = {};
    _this.tealiumAttributes = {};
    _this.attributesValuesMapping = {};
    _this.snowplowLayer = {};
    _this.eventsWaitingList = [];
    _this.retryingBatchingEvents = false;
    _this.isSendingBatchedEvents = false;
    return _this;
  }
  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)(SsaTealiumHttp, [{
    key: "init",
    value: function init(params) {
      var _this2 = this;
      var _params$endpoint = params.endpoint,
        endpoint = _params$endpoint === void 0 ? 'https://collect.tealiumiq.com/event' : _params$endpoint,
        _params$batchingEndpo = params.batchingEndpoint,
        batchingEndpoint = _params$batchingEndpo === void 0 ? 'https://collect.tealiumiq.com/bulk-event' : _params$batchingEndpo,
        env = params.env,
        account = params.account,
        dataSource = params.dataSource,
        profile = params.profile,
        _params$traceId = params.traceId,
        traceId = _params$traceId === void 0 ? null : _params$traceId,
        _params$thirdPartyKey = params.thirdPartyKey,
        thirdPartyKey = _params$thirdPartyKey === void 0 ? 'googleAnalytics' : _params$thirdPartyKey,
        deviceConsents = params.deviceConsents,
        _params$backendEventN = params.backendEventName,
        backendEventName = _params$backendEventN === void 0 ? 'layout_event' : _params$backendEventN,
        _params$eventNameAttr = params.eventNameAttribute,
        eventNameAttribute = _params$eventNameAttr === void 0 ? 'eventName' : _params$eventNameAttr,
        _params$initialAbTest = params.initialAbTestVariants,
        initialAbTestVariants = _params$initialAbTest === void 0 ? [] : _params$initialAbTest,
        _params$httpMethod = params.httpMethod,
        httpMethod = _params$httpMethod === void 0 ? 'GET' : _params$httpMethod,
        _params$googleAnalyti = params.googleAnalyticsTrackersIds,
        googleAnalyticsTrackersIds = _params$googleAnalyti === void 0 ? [] : _params$googleAnalyti,
        _params$isSnowplowEna = params.isSnowplowEnabled,
        isSnowplowEnabled = _params$isSnowplowEna === void 0 ? false : _params$isSnowplowEna,
        _params$isBatchingEna = params.isBatchingEnabled,
        isBatchingEnabled = _params$isBatchingEna === void 0 ? false : _params$isBatchingEna,
        _params$batchingInter = params.batchingInterval,
        batchingInterval = _params$batchingInter === void 0 ? 1000 : _params$batchingInter,
        _params$additionalGen = params.additionalGenericAttributes,
        additionalGenericAttributes = _params$additionalGen === void 0 ? {} : _params$additionalGen;
      this.isSnowplowEnabled = isSnowplowEnabled;
      this.endpoint = endpoint;
      this.batchingEndpoint = batchingEndpoint;
      this.thirdPartyKey = thirdPartyKey;
      this.attributesValuesMapping = _constants_googleAttributesMappings_constant__WEBPACK_IMPORTED_MODULE_26__/* .googleAttributesValuesMapping */ .r;
      this.backendEventName = backendEventName;
      this.deviceId = _fido__WEBPACK_IMPORTED_MODULE_27__/* .fido */ .n.get('localDeviceId') || _fido__WEBPACK_IMPORTED_MODULE_27__/* .fido */ .n.get('localHomeId');
      this.eventNameAttribute = eventNameAttribute;
      this.gdprChange(deviceConsents);
      this.currentVariants = initialAbTestVariants;
      this.httpMethod = httpMethod;
      this.googleAnalyticsTrackersIds = googleAnalyticsTrackersIds;
      (0,_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z)((0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(SsaTealiumHttp.prototype), "init", this).call(this, params);
      this.sessionId = this.getSessionId();
      this.isBatchingEnabled = isBatchingEnabled;
      this.additionalGenericAttributes = additionalGenericAttributes;
      this.tealiumAttributes = {
        tealium_account: account,
        tealium_profile: profile,
        tealium_environment: env,
        tealium_visitor_id: this.deviceId,
        tealium_datasource: dataSource,
        tealium_trace_id: traceId
      };
      if (isBatchingEnabled) {
        setInterval(function () {
          _this2.sendBatchedEvent();
        }, batchingInterval);
      }
    }
  }, {
    key: "sendBatchedEvent",
    value: (function () {
      var _sendBatchedEvent = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default().mark(function _callee() {
        var _this3 = this;
        var eventsToSend;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(this.eventsWaitingList.length === 0 || this.isSendingBatchedEvents)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return", Promise.resolve());
            case 2:
              this.isSendingBatchedEvents = true;
              eventsToSend = this.eventsWaitingList.slice(0, 10).map(function (_ref) {
                var allAttributes = _ref.allAttributes;
                return allAttributes;
              });
              _context.prev = 4;
              _context.next = 7;
              return (0,_utils_fetch__WEBPACK_IMPORTED_MODULE_30__/* .fetch */ .h)(this.batchingEndpoint, {
                method: 'POST',
                body: JSON.stringify({
                  events: eventsToSend,
                  shared: Object.assign({}, this.tealiumAttributes)
                }),
                headers: {
                  'Content-Type': 'application/json'
                }
              }).then(function () {
                _this3.eventsWaitingList.map(function (_ref2) {
                  var recordingProps = _ref2.recordingProps;
                  return (0,_utils__WEBPACK_IMPORTED_MODULE_31__/* .storeThirdpartyCallForPlayground */ .UA)(Object.assign({
                    status: 'SUCCESS'
                  }, recordingProps));
                });
                _this3.eventsWaitingList = _this3.eventsWaitingList.slice(10);
                _this3.retryingBatchingEvents = false;
                _this3.isSendingBatchedEvents = false;
              }, function () {
                _this3.eventsWaitingList.map(function (_ref3) {
                  var recordingProps = _ref3.recordingProps;
                  return (0,_utils__WEBPACK_IMPORTED_MODULE_31__/* .storeThirdpartyCallForPlayground */ .UA)(Object.assign({
                    status: 'FAILED'
                  }, recordingProps));
                });
                if (_this3.retryingBatchingEvents) {
                  _this3.retryingBatchingEvents = false;
                  _this3.eventsWaitingList = _this3.eventsWaitingList.slice(10);
                } else {
                  _this3.retryingBatchingEvents = true;
                }
                _this3.isSendingBatchedEvents = false;
              });
            case 7:
              return _context.abrupt("return", _context.sent);
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](4);
              if (isBlockerError(_context.t0)) {
                this.detectBlocker();
              }
              this.eventsWaitingList.map(function (_ref4) {
                var recordingProps = _ref4.recordingProps;
                return (0,_utils__WEBPACK_IMPORTED_MODULE_31__/* .storeThirdpartyCallForPlayground */ .UA)(Object.assign({
                  status: 'FAILED'
                }, recordingProps));
              });
              if (this.retryingBatchingEvents) {
                this.retryingBatchingEvents = false;
                this.eventsWaitingList = [];
              } else {
                this.retryingBatchingEvents = true;
              }
              this.isSendingBatchedEvents = false;
              return _context.abrupt("return", Promise.resolve());
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[4, 10]]);
      }));
      function sendBatchedEvent() {
        return _sendBatchedEvent.apply(this, arguments);
      }
      return sendBatchedEvent;
    }())
  }, {
    key: "gdprChange",
    value: function gdprChange(deviceConsents) {
      if (deviceConsents) {
        this.deviceConsents = {
          gdpr_consent_tracking: lodash_get__WEBPACK_IMPORTED_MODULE_19___default()(deviceConsents, 'tracking.consent'),
          gdpr_consent_adtargeting: lodash_get__WEBPACK_IMPORTED_MODULE_19___default()(deviceConsents, 'adTargeting.consent'),
          gdpr_consent_multidevice_matching: lodash_get__WEBPACK_IMPORTED_MODULE_19___default()(deviceConsents, 'multiDeviceMatching.consent'),
          gdpr_consent_personalization: lodash_get__WEBPACK_IMPORTED_MODULE_19___default()(deviceConsents, 'personalization.consent')
        };
      }
    }
  }, {
    key: "getSessionId",
    value: function getSessionId() {
      var sessionId = parseInt(sessionStorage.getItem('tealium_session_id'), 10);
      if (!sessionId) {
        var tealiumSessionIdLength = 13;
        sessionId = Math.floor(Math.random() * Math.pow(10, tealiumSessionIdLength));
        sessionStorage.setItem('tealium_session_id', sessionId);
      }
      return sessionId;
    }
  }, {
    key: "setSnowplowLayer",
    value: function () {
      var _setSnowplowLayer = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default().mark(function _callee2() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return (0,_utils__WEBPACK_IMPORTED_MODULE_31__/* .waitForGlobal */ .Zy)('isSnowplowInit');
            case 3:
              this.snowplowLayer = {
                sp_session_id: sessionStorage.getItem('sp_session_id'),
                sp_user_id: localStorage.getItem('sp_user_id'),
                sp_previous_session_id: sessionStorage.getItem('sp_previous_session_id'),
                sp_storage_mechanism: localStorage.getItem('sp_storage_mechanism'),
                sp_page_id: localStorage.getItem('sp_page_id'),
                sp_session_index: sessionStorage.getItem('sp_session_index')
              };
              _context2.next = 9;
              break;
            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](0);
              console.warn('Cannot retrieve Snowplow mandatory attributes, sdk is not initialised', _context2.t0);
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 6]]);
      }));
      function setSnowplowLayer() {
        return _setSnowplowLayer.apply(this, arguments);
      }
      return setSnowplowLayer;
    }()
  }, {
    key: "getGenericAttributes",
    value: function getGenericAttributes() {
      var gaAttributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return Object.assign((0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)({
        a_b_test: this.currentVariants,
        device_id: this.deviceId
      }, _constants__WEBPACK_IMPORTED_MODULE_33__/* .TEALIUM_MAPPING */ .Bg.dimension72, lodash_get__WEBPACK_IMPORTED_MODULE_19___default()(gaAttributes, 'dimension72', null)), this.additionalGenericAttributes);
    }
  }, {
    key: "sendToTealium",
    value: (function () {
      var _sendToTealium = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default().mark(function _callee3() {
        var genericAttributes,
          specificAttributes,
          allAttributes,
          recordingProps,
          queryStrings,
          _args3 = arguments;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              genericAttributes = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
              specificAttributes = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
              if (!this.isSnowplowEnabled) {
                _context3.next = 5;
                break;
              }
              _context3.next = 5;
              return this.setSnowplowLayer();
            case 5:
              allAttributes = Object.assign(Object.assign({}, genericAttributes), this.snowplowLayer);
              recordingProps = {
                name: 'tealium',
                isRecording: this.isRecording,
                data: {
                  allAttributes: (0,_utils__WEBPACK_IMPORTED_MODULE_31__/* .sortObject */ .CV)(allAttributes),
                  specificAttributes: (0,_utils__WEBPACK_IMPORTED_MODULE_31__/* .sortObject */ .CV)(specificAttributes)
                }
              };
              _context3.prev = 7;
              if (!(this.httpMethod === 'GET')) {
                _context3.next = 13;
                break;
              }
              queryStrings = (0,_utils_queryParamSerializer__WEBPACK_IMPORTED_MODULE_34__/* .serialize */ .q)(allAttributes, function (_ref5) {
                var value = _ref5.value;
                return value != null;
              });
              _context3.next = 12;
              return (0,_utils_fetch__WEBPACK_IMPORTED_MODULE_30__/* .fetch */ .h)("".concat(this.endpoint, "?").concat(queryStrings));
            case 12:
              return _context3.abrupt("return", _context3.sent);
            case 13:
              if (!this.isBatchingEnabled) {
                _context3.next = 16;
                break;
              }
              this.eventsWaitingList.push({
                allAttributes: allAttributes,
                recordingProps: recordingProps
              });
              return _context3.abrupt("return", Promise.resolve());
            case 16:
              _context3.next = 18;
              return (0,_utils_fetch__WEBPACK_IMPORTED_MODULE_30__/* .fetch */ .h)(this.endpoint, {
                method: 'POST',
                body: JSON.stringify(allAttributes),
                headers: {
                  'Content-Type': 'application/json'
                }
              }).then(function () {
                return (0,_utils__WEBPACK_IMPORTED_MODULE_31__/* .storeThirdpartyCallForPlayground */ .UA)(Object.assign({
                  status: 'SUCCESS'
                }, recordingProps));
              }, function () {
                return (0,_utils__WEBPACK_IMPORTED_MODULE_31__/* .storeThirdpartyCallForPlayground */ .UA)(Object.assign({
                  status: 'FAILED'
                }, recordingProps));
              });
            case 18:
              return _context3.abrupt("return", _context3.sent);
            case 21:
              _context3.prev = 21;
              _context3.t0 = _context3["catch"](7);
              if (isBlockerError(_context3.t0)) {
                this.detectBlocker();
              }
              (0,_utils__WEBPACK_IMPORTED_MODULE_31__/* .storeThirdpartyCallForPlayground */ .UA)(Object.assign({
                status: 'FAILED'
              }, recordingProps));
              return _context3.abrupt("return", Promise.resolve());
            case 26:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[7, 21]]);
      }));
      function sendToTealium() {
        return _sendToTealium.apply(this, arguments);
      }
      return sendToTealium;
    }())
  }, {
    key: "getGoogleAnalyticsLayer",
    value: function getGoogleAnalyticsLayer() {
      var _a, _b, _c, _d;
      var firstGoogleAnalytics4Id = this.googleAnalyticsTrackersIds.find(function (id) {
        return id.startsWith('G-');
      });
      var isGoogleAnalyticsVersion4 = !!firstGoogleAnalytics4Id;
      if (!isGoogleAnalyticsVersion4) {
        return {};
      }
      var clientId = (_a = document.cookie.match(/_ga=GA1\.\d\.(.+?)(?:;|$)/)) === null || _a === void 0 ? void 0 : _a[1];
      var ga4TrackerId = firstGoogleAnalytics4Id.substring(2);
      var ga4SessionCookieRegexp = new RegExp("_ga_".concat(ga4TrackerId, "=GS\\d\\.\\d\\.(.+?)(?:;|$)"));
      var ga4SessionCookieContent = ((_b = document.cookie.match(ga4SessionCookieRegexp)) === null || _b === void 0 ? void 0 : _b[1]) || '';
      var gaData = ga4SessionCookieContent.split('$') || [];
      var sessionId = (_c = gaData.find(function (data) {
        return data[0] === 's';
      })) === null || _c === void 0 ? void 0 : _c.substring(1);
      var sessionNumber = (_d = gaData.find(function (data) {
        return data[0] === 'o';
      })) === null || _d === void 0 ? void 0 : _d.substring(1);
      if (!sessionId || !sessionNumber) {
        return {};
      }
      return {
        ga_session_id: sessionId,
        client_id: clientId,
        ga_session_number: sessionNumber
      };
    }
  }, {
    key: "sendPageViewEvent",
    value: function sendPageViewEvent(params, location) {
      var attributesByThirdParties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var basicLayer = Object.assign({
        timestamp_unix_milliseconds: Date.now(),
        tealium_session_id: this.sessionId,
        tealium_event: 'page_view'
      }, this.tealiumAttributes);
      this.currentPageLayer = this.getBrowserLayer();
      return this.sendToTealium(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, basicLayer), this.currentPageLayer), this.getGoogleAnalyticsLayer()), (0,_gaAttributesToTealium__WEBPACK_IMPORTED_MODULE_35__/* .toTealiumAttributes */ .L)(this.customAttributes)), (0,_gaAttributesToTealium__WEBPACK_IMPORTED_MODULE_35__/* .toTealiumAttributes */ .L)(attributesByThirdParties[this.thirdPartyKey])), this.deviceAttributes), this.deviceConsents), this.getGenericAttributes(attributesByThirdParties[this.thirdPartyKey])));
    }
  }, {
    key: "getCustomAttributes",
    value: function getCustomAttributes(key) {
      if (key) {
        return (0,_utils__WEBPACK_IMPORTED_MODULE_31__/* .getCustomAttribute */ .v7)(key, this.customAttributes, this.attributesKeysMapping);
      }
      return this.customAttributes;
    }
  }, {
    key: "setCustomAttributes",
    value: function setCustomAttributes(customAttributes) {
      if (!customAttributes) {
        return;
      }
      this.customAttributes = Object.assign(Object.assign({}, this.customAttributes), (0,_utils__WEBPACK_IMPORTED_MODULE_31__/* .transformAttributes */ .qX)(customAttributes, this.attributesKeysMapping, this.attributesValuesMapping));
    }
  }, {
    key: "sendEvent",
    value: function sendEvent(params) {
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'automatic';
      var eventFields = arguments.length > 2 ? arguments[2] : undefined;
      var bffAnalyticAttributes = arguments.length > 3 ? arguments[3] : undefined;
      var isEventInTaggingPlan = params.key && !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_20___default()(this.events[params.key]);
      var isBackendEvent = params[this.thirdPartyKey];
      if (!isEventInTaggingPlan && !isBackendEvent) {
        return null;
      }
      var event = {};
      if (isBackendEvent) {
        event = {
          tealium_event: isBackendEvent[this.eventNameAttribute] || this.backendEventName
        };
      }
      if (isEventInTaggingPlan) {
        var eventInTaggingPlan = this.events[params.key];
        var templatedEventAttributes = (0,_event_utils__WEBPACK_IMPORTED_MODULE_36__/* .getTemplatedEvent */ .D)(eventInTaggingPlan, params);
        event = Object.assign({
          tealium_event: templatedEventAttributes[this.eventNameAttribute]
        }, templatedEventAttributes);
      }
      var basicLayer = Object.assign(Object.assign({
        timestamp_unix_milliseconds: Date.now(),
        tealium_session_id: this.sessionId,
        tealium_event_type: action
      }, this.tealiumAttributes), event);
      var customAttributes = Object.assign(Object.assign({}, this.customAttributes), lodash_omitBy__WEBPACK_IMPORTED_MODULE_22___default()(bffAnalyticAttributes[this.thirdPartyKey], (lodash_isNil__WEBPACK_IMPORTED_MODULE_21___default())));
      if (isBackendEvent) {
        customAttributes = Object.assign(Object.assign({}, customAttributes), params[this.thirdPartyKey]);
      }
      return this.sendToTealium(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, basicLayer), this.currentPageLayer || Object.assign({}, this.getBrowserLayer(true))), (0,_gaAttributesToTealium__WEBPACK_IMPORTED_MODULE_35__/* .toTealiumAttributes */ .L)(customAttributes)), this.getGoogleAnalyticsLayer()), this.deviceAttributes), this.deviceConsents), this.getGenericAttributes(bffAnalyticAttributes[this.thirdPartyKey])), event);
    }
  }, {
    key: "sendPrintEvent",
    value: function sendPrintEvent(params, action, eventFields, attributesByThirdParties) {
      this.sendEvent(params, 'automatic', eventFields, attributesByThirdParties);
    }
  }, {
    key: "sendClickEvent",
    value: function sendClickEvent(params, action, eventFields, attributesByThirdParties) {
      this.sendEvent(params, 'click', eventFields, attributesByThirdParties);
    }
  }]);
  return SsaTealiumHttp;
}(_abstract_abstractTrackingEngine__WEBPACK_IMPORTED_MODULE_37__/* .AbstractTrackingEngine */ .q);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (new SsaTealiumHttp());

/***/ }),

/***/ 84155:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   D: () => (/* binding */ getTemplatedEvent)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28610);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_transform__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68742);
/* harmony import */ var lodash_transform__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_transform__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var sprintf_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24131);
/* harmony import */ var sprintf_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(sprintf_js__WEBPACK_IMPORTED_MODULE_2__);



var PARAM_REGEX = /^%\((\w+)\)(.)$/;
var getTemplatedEvent = function getTemplatedEvent(event, params) {
  return params ? lodash_transform__WEBPACK_IMPORTED_MODULE_1___default()(event, function (templatedParams, value, key) {
    var paramsRegex = PARAM_REGEX.exec(value);
    if (paramsRegex === null || paramsRegex[2] === 's') {
      templatedParams[key] = (0,sprintf_js__WEBPACK_IMPORTED_MODULE_2__.sprintf)(value, params);
    } else {
      templatedParams[key] = params[paramsRegex[1]];
    }
  }, {}) : event;
};

/***/ }),

/***/ 29432:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   L: () => (/* binding */ toTealiumAttributes)
/* harmony export */ });
/* harmony import */ var lodash_forOwn__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14287);
/* harmony import */ var lodash_forOwn__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_forOwn__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65439);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46262);



var toTealiumAttributes = function toTealiumAttributes(gaAttributes) {
  var tealiumAttributes = {};
  lodash_forOwn__WEBPACK_IMPORTED_MODULE_0___default()(gaAttributes, function (value, key) {
    if (value != null) {
      tealiumAttributes[lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(_constants__WEBPACK_IMPORTED_MODULE_2__/* .TEALIUM_MAPPING */ .Bg, key, key)] = value;
    }
  });
  return tealiumAttributes;
};

/***/ }),

/***/ 14698:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A5: () => (/* binding */ updateMockEvent),
/* harmony export */   CV: () => (/* binding */ sortObject),
/* harmony export */   IC: () => (/* binding */ generateImagePixel),
/* harmony export */   UA: () => (/* binding */ storeThirdpartyCallForPlayground),
/* harmony export */   Zy: () => (/* binding */ waitForGlobal),
/* harmony export */   c6: () => (/* binding */ storeCallForMock),
/* harmony export */   f6: () => (/* binding */ getFormattedEvent),
/* harmony export */   qX: () => (/* binding */ transformAttributes),
/* harmony export */   sA: () => (/* binding */ getActiveEngineWithMethod),
/* harmony export */   v7: () => (/* binding */ getCustomAttribute),
/* harmony export */   wQ: () => (/* binding */ lazyLoadEngine)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59724);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10115);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_flat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62853);
/* harmony import */ var core_js_modules_es_array_flat__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_flat__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53252);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34479);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30382);
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_unscopables_flat__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35628);
/* harmony import */ var core_js_modules_es_array_unscopables_flat__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_unscopables_flat__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(77402);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8032);
/* harmony import */ var core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(65759);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67478);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(42578);
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(96317);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(87807);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(90250);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(39342);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(69033);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(65439);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var lodash_identity__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(48148);
/* harmony import */ var lodash_identity__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(lodash_identity__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var lodash_isObject__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(36838);
/* harmony import */ var lodash_isObject__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(lodash_isObject__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(67929);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(59245);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var lodash_reduce__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(6355);
/* harmony import */ var lodash_reduce__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(lodash_reduce__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var lodash_set__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(35609);
/* harmony import */ var lodash_set__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(lodash_set__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var lodash_uniqueId__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(53274);
/* harmony import */ var lodash_uniqueId__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(lodash_uniqueId__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var sprintf_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(24131);
/* harmony import */ var sprintf_js__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(sprintf_js__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _fido__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(94031);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(46262);




























var generateImagePixel = function generateImagePixel(url) {
  new Image().src = url;
};
var lazyLoadEngine = function lazyLoadEngine(name) {
  return (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_14___default().mark(function _callee() {
    var module;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_14___default().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return __webpack_require__(35615)("./".concat(name, ".engine.js"));
        case 3:
          module = _context.sent;
          return _context.abrupt("return", module.default);
        case 7:
          _context.prev = 7;
          _context.t0 = _context["catch"](0);
          return _context.abrupt("return", undefined);
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 7]]);
  }));
};
var mergeObject = function mergeObject(array) {
  return lodash_reduce__WEBPACK_IMPORTED_MODULE_20___default()(array, function (accumulator, value) {
    if (!value) return accumulator;
    var param = lodash_isObject__WEBPACK_IMPORTED_MODULE_17___default()(value) ? value : {
      value: value
    };
    return Object.assign(Object.assign({}, accumulator), param);
  }, {});
};
var storeCallForMock = function storeCallForMock(name, method) {
  for (var _len = arguments.length, engineArgs = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    engineArgs[_key - 2] = arguments[_key];
  }
  if (!lodash_isObject__WEBPACK_IMPORTED_MODULE_17___default()(window[_constants__WEBPACK_IMPORTED_MODULE_25__/* .MOCK_THIRDPARTY_OBJECT_KEY */ .kr])) {
    return;
  }
  if (!window[_constants__WEBPACK_IMPORTED_MODULE_25__/* .MOCK_THIRDPARTY_OBJECT_KEY */ .kr][name]) {
    lodash_set__WEBPACK_IMPORTED_MODULE_21___default()(window[_constants__WEBPACK_IMPORTED_MODULE_25__/* .MOCK_THIRDPARTY_OBJECT_KEY */ .kr], name, []);
  }
  var timestamp = _fido__WEBPACK_IMPORTED_MODULE_26__/* .fido */ .n.get('getCurrentTime')();
  var finalArgs = engineArgs.map(function (arg) {
    var eventKey = lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(arg, 'eventKey');
    if (!lodash_isObject__WEBPACK_IMPORTED_MODULE_17___default()(eventKey)) return arg;
    var stdEvent = engineArgs[0];
    return {
      eventKey: Object.assign(Object.assign({}, eventKey), {
        label: (0,sprintf_js__WEBPACK_IMPORTED_MODULE_23__.sprintf)(eventKey.label, stdEvent),
        action: (0,sprintf_js__WEBPACK_IMPORTED_MODULE_23__.sprintf)(eventKey.action, stdEvent)
      })
    };
  });
  window[_constants__WEBPACK_IMPORTED_MODULE_25__/* .MOCK_THIRDPARTY_OBJECT_KEY */ .kr][name].push(Object.assign({
    mockUID: lodash_uniqueId__WEBPACK_IMPORTED_MODULE_22___default()(),
    name: name,
    timestamp: timestamp,
    method: method
  }, mergeObject(finalArgs)));
};
var updateMockEvent = function updateMockEvent(_ref2, data) {
  var uuid = _ref2.uuid;
  var mockedEvent = Object.values(window[_constants__WEBPACK_IMPORTED_MODULE_25__/* .MOCK_THIRDPARTY_OBJECT_KEY */ .kr]).flat().find(function (event) {
    return event.uuid === uuid;
  });
  lodash_merge__WEBPACK_IMPORTED_MODULE_18___default()(mockedEvent, data);
};
var getActiveEngineWithMethod = function getActiveEngineWithMethod() {
  var thirdParties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var method = arguments.length > 1 ? arguments[1] : undefined;
  return thirdParties.filter(function (_ref3) {
    var engine = _ref3.engine,
      rejected = _ref3.rejected,
      initialized = _ref3.initialized;
    return engine && (!initialized || typeof engine[method] === 'function') && !rejected;
  });
};
var getFormattedEvent = function getFormattedEvent(event, thirdParty) {
  if (typeof event === 'string') {
    return {
      key: event
    };
  }
  var eventEngineAnalytics = lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(event, ['analytics', thirdParty.key]);
  if (eventEngineAnalytics) {
    return Object.assign(Object.assign({}, lodash_omit__WEBPACK_IMPORTED_MODULE_19___default()(event, ['analytics'])), eventEngineAnalytics);
  }
  return lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(event, [thirdParty.key], event);
};
var transformAttributes = function transformAttributes(customAttributes, attributesKeysMapping, attributesValuesMapping) {
  return lodash_reduce__WEBPACK_IMPORTED_MODULE_20___default()(customAttributes, function (acc, attributeValue, attributeKey) {
    var correspondingKey = attributesKeysMapping[attributeKey];
    if (!correspondingKey) return acc;
    var correponspondingValue = lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(attributesValuesMapping, attributeKey, (lodash_identity__WEBPACK_IMPORTED_MODULE_16___default()))(attributeValue);
    return Object.assign(Object.assign({}, acc), (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)({}, correspondingKey, correponspondingValue));
  }, {});
};
var getCustomAttribute = function getCustomAttribute(key, customAttributes, attributesKeysMapping) {
  var targetKey = lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(attributesKeysMapping, key, key);
  return customAttributes[targetKey] ? customAttributes[targetKey] : undefined;
};
var sortObject = function sortObject(unorderedObject) {
  return Object.keys(unorderedObject).sort().reduce(function (object, key) {
    object[key] = unorderedObject[key];
    return object;
  }, {});
};
var storeThirdpartyCallForPlayground = function storeThirdpartyCallForPlayground(_ref4) {
  var name = _ref4.name,
    isRecording = _ref4.isRecording,
    status = _ref4.status,
    data = _ref4.data;
  if (!isRecording) {
    return;
  }
  var THIRD_PARTY_OBJECT = "".concat(name, "Calls");
  if (!lodash_isObject__WEBPACK_IMPORTED_MODULE_17___default()(window[THIRD_PARTY_OBJECT])) {
    lodash_set__WEBPACK_IMPORTED_MODULE_21___default()(window, THIRD_PARTY_OBJECT, []);
  }
  var timestamp = _fido__WEBPACK_IMPORTED_MODULE_26__/* .fido */ .n.get('getCurrentTime')();
  window[THIRD_PARTY_OBJECT].push({
    mockUID: lodash_uniqueId__WEBPACK_IMPORTED_MODULE_22___default()(),
    timestamp: timestamp,
    status: status,
    data: data
  });
};
var waitForGlobal = function waitForGlobal(globalKey) {
  var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref5$iterationTime = _ref5.iterationTime,
    iterationTime = _ref5$iterationTime === void 0 ? 200 : _ref5$iterationTime,
    _ref5$retries = _ref5.retries,
    retries = _ref5$retries === void 0 ? 10 : _ref5$retries;
  return new Promise(function (resolve, reject) {
    var iterations = retries;
    var intervalId = setInterval(function () {
      if (window[globalKey]) {
        clearInterval(intervalId);
        resolve();
      } else {
        iterations -= 1;
        if (iterations === 0) {
          clearInterval(intervalId);
          reject();
        }
      }
    }, iterationTime);
  });
};

/***/ }),

/***/ 20280:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   h: () => (/* binding */ fetch)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29548);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67478);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96317);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var superagent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54247);
/* harmony import */ var superagent__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(superagent__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _errors_fetch_error__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39814);
/* harmony import */ var _fido__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94031);






var canSendBody = {
  PATCH: true,
  POST: true,
  PUT: true
};
var buildRequest = function buildRequest(url, _ref) {
  var method = _ref.method,
    _ref$body = _ref.body,
    body = _ref$body === void 0 ? {} : _ref$body,
    query = _ref.query,
    headers = _ref.headers,
    responseType = _ref.responseType;
  var req = superagent__WEBPACK_IMPORTED_MODULE_3___default()(method, url);
  if (headers) {
    req.set(headers);
  }
  if (query) {
    req.query(query);
  }
  if (responseType) {
    req.responseType(responseType);
  }
  if (canSendBody[method]) {
    return req.send(body);
  }
  return req;
};
var fetch = function fetch(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return new Promise(function (resolve, reject) {
    options.method = options.method || 'GET';
    options.maxTimeout = options.maxTimeout || _fido__WEBPACK_IMPORTED_MODULE_4__/* .fido */ .n.get('maxTimeout');
    options.waitTimeout = options.waitTimeout || _fido__WEBPACK_IMPORTED_MODULE_4__/* .fido */ .n.get('waitTimeout');
    var req = buildRequest(url, options);
    if (options.withCredentials) {
      req.withCredentials();
    }
    if (options.signal) {
      options.signal.addEventListener('abort', function () {
        req.abort();
      });
    }
    if (options.retry) {
      req.retry(options.retry.count, options.retry.callback(options.retry.apiType, options.method));
    }
    req.timeout({
      response: options.waitTimeout,
      deadline: options.maxTimeout
    }).end(function (err, response) {
      if (err) {
        return reject(new _errors_fetch_error__WEBPACK_IMPORTED_MODULE_5__/* .FetchError */ .k(err, {
          url: url,
          options: options
        }, response));
      }
      if (response.ok) {
        return resolve(response);
      }
      var error = new _errors_fetch_error__WEBPACK_IMPORTED_MODULE_5__/* .FetchError */ .k("".concat(response.statusText, ":").concat(response.status), {
        url: url,
        options: options
      }, response);
      return reject(error);
    });
  });
};

/***/ }),

/***/ 97605:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   q: () => (/* binding */ serialize)
/* harmony export */ });
/* unused harmony export formatDate */
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29548);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59724);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30415);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53252);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30382);
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65759);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);






var serialize = function serialize() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return true;
  };
  var paramKeys = Object.keys(params);
  if (!paramKeys.length) {
    return '';
  }
  return paramKeys.map(function (key) {
    return {
      key: key,
      value: params[key]
    };
  }).filter(filter).sort(function (_ref, _ref2) {
    var key1 = _ref.key;
    var key2 = _ref2.key;
    return key1 <= key2 ? -1 : 1;
  }).map(function (_ref3) {
    var key = _ref3.key,
      value = _ref3.value;
    return "".concat(key, "=").concat(encodeURIComponent(value));
  }).join('&');
};
var dateElementToString = function dateElementToString(element) {
  return "".concat(element < 10 ? '0' : '').concat(element);
};
var formatDate = function formatDate(date) {
  if (!(date instanceof Date)) {
    throw Error('The argument should be an instance of Date');
  }
  var dateParts = [date.getMonth() + 1, date.getDate()].map(dateElementToString);
  dateParts.unshift(date.getFullYear());
  var timeParts = [date.getHours(), date.getMinutes(), date.getSeconds()].map(dateElementToString);
  return "".concat(dateParts.join('-'), " ").concat(timeParts.join(':'));
};

/***/ }),

/***/ 70579:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;__webpack_require__(30415);
__webpack_require__(97343);
__webpack_require__(72578);
__webpack_require__(28610);
__webpack_require__(8612);
__webpack_require__(74389);
var _typeof = __webpack_require__(45129);
;
(function (root) {
  var freeExports = ( false ? 0 : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;
  var freeModule = ( false ? 0 : _typeof(module)) == 'object' && module && !module.nodeType && module;
  var freeGlobal = (typeof __webpack_require__.g === "undefined" ? "undefined" : _typeof(__webpack_require__.g)) == 'object' && __webpack_require__.g;
  if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) {
    root = freeGlobal;
  }
  var punycode,
    maxInt = 2147483647,
    base = 36,
    tMin = 1,
    tMax = 26,
    skew = 38,
    damp = 700,
    initialBias = 72,
    initialN = 128,
    delimiter = '-',
    regexPunycode = /^xn--/,
    regexNonASCII = /[^\x20-\x7E]/,
    regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g,
    errors = {
      'overflow': 'Overflow: input needs wider integers to process',
      'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
      'invalid-input': 'Invalid input'
    },
    baseMinusTMin = base - tMin,
    floor = Math.floor,
    stringFromCharCode = String.fromCharCode,
    key;
  function error(type) {
    throw new RangeError(errors[type]);
  }
  function map(array, fn) {
    var length = array.length;
    var result = [];
    while (length--) {
      result[length] = fn(array[length]);
    }
    return result;
  }
  function mapDomain(string, fn) {
    var parts = string.split('@');
    var result = '';
    if (parts.length > 1) {
      result = parts[0] + '@';
      string = parts[1];
    }
    string = string.replace(regexSeparators, '\x2E');
    var labels = string.split('.');
    var encoded = map(labels, fn).join('.');
    return result + encoded;
  }
  function ucs2decode(string) {
    var output = [],
      counter = 0,
      length = string.length,
      value,
      extra;
    while (counter < length) {
      value = string.charCodeAt(counter++);
      if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
        extra = string.charCodeAt(counter++);
        if ((extra & 0xFC00) == 0xDC00) {
          output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
        } else {
          output.push(value);
          counter--;
        }
      } else {
        output.push(value);
      }
    }
    return output;
  }
  function ucs2encode(array) {
    return map(array, function (value) {
      var output = '';
      if (value > 0xFFFF) {
        value -= 0x10000;
        output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
        value = 0xDC00 | value & 0x3FF;
      }
      output += stringFromCharCode(value);
      return output;
    }).join('');
  }
  function basicToDigit(codePoint) {
    if (codePoint - 48 < 10) {
      return codePoint - 22;
    }
    if (codePoint - 65 < 26) {
      return codePoint - 65;
    }
    if (codePoint - 97 < 26) {
      return codePoint - 97;
    }
    return base;
  }
  function digitToBasic(digit, flag) {
    return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
  }
  function adapt(delta, numPoints, firstTime) {
    var k = 0;
    delta = firstTime ? floor(delta / damp) : delta >> 1;
    delta += floor(delta / numPoints);
    for (; delta > baseMinusTMin * tMax >> 1; k += base) {
      delta = floor(delta / baseMinusTMin);
    }
    return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
  }
  function decode(input) {
    var output = [],
      inputLength = input.length,
      out,
      i = 0,
      n = initialN,
      bias = initialBias,
      basic,
      j,
      index,
      oldi,
      w,
      k,
      digit,
      t,
      baseMinusT;
    basic = input.lastIndexOf(delimiter);
    if (basic < 0) {
      basic = 0;
    }
    for (j = 0; j < basic; ++j) {
      if (input.charCodeAt(j) >= 0x80) {
        error('not-basic');
      }
      output.push(input.charCodeAt(j));
    }
    for (index = basic > 0 ? basic + 1 : 0; index < inputLength;) {
      for (oldi = i, w = 1, k = base;; k += base) {
        if (index >= inputLength) {
          error('invalid-input');
        }
        digit = basicToDigit(input.charCodeAt(index++));
        if (digit >= base || digit > floor((maxInt - i) / w)) {
          error('overflow');
        }
        i += digit * w;
        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
        if (digit < t) {
          break;
        }
        baseMinusT = base - t;
        if (w > floor(maxInt / baseMinusT)) {
          error('overflow');
        }
        w *= baseMinusT;
      }
      out = output.length + 1;
      bias = adapt(i - oldi, out, oldi == 0);
      if (floor(i / out) > maxInt - n) {
        error('overflow');
      }
      n += floor(i / out);
      i %= out;
      output.splice(i++, 0, n);
    }
    return ucs2encode(output);
  }
  function encode(input) {
    var n,
      delta,
      handledCPCount,
      basicLength,
      bias,
      j,
      m,
      q,
      k,
      t,
      currentValue,
      output = [],
      inputLength,
      handledCPCountPlusOne,
      baseMinusT,
      qMinusT;
    input = ucs2decode(input);
    inputLength = input.length;
    n = initialN;
    delta = 0;
    bias = initialBias;
    for (j = 0; j < inputLength; ++j) {
      currentValue = input[j];
      if (currentValue < 0x80) {
        output.push(stringFromCharCode(currentValue));
      }
    }
    handledCPCount = basicLength = output.length;
    if (basicLength) {
      output.push(delimiter);
    }
    while (handledCPCount < inputLength) {
      for (m = maxInt, j = 0; j < inputLength; ++j) {
        currentValue = input[j];
        if (currentValue >= n && currentValue < m) {
          m = currentValue;
        }
      }
      handledCPCountPlusOne = handledCPCount + 1;
      if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
        error('overflow');
      }
      delta += (m - n) * handledCPCountPlusOne;
      n = m;
      for (j = 0; j < inputLength; ++j) {
        currentValue = input[j];
        if (currentValue < n && ++delta > maxInt) {
          error('overflow');
        }
        if (currentValue == n) {
          for (q = delta, k = base;; k += base) {
            t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
            if (q < t) {
              break;
            }
            qMinusT = q - t;
            baseMinusT = base - t;
            output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
            q = floor(qMinusT / baseMinusT);
          }
          output.push(stringFromCharCode(digitToBasic(q, 0)));
          bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
          delta = 0;
          ++handledCPCount;
        }
      }
      ++delta;
      ++n;
    }
    return output.join('');
  }
  function toUnicode(input) {
    return mapDomain(input, function (string) {
      return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
    });
  }
  function toASCII(input) {
    return mapDomain(input, function (string) {
      return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
    });
  }
  punycode = {
    'version': '1.4.1',
    'ucs2': {
      'decode': ucs2decode,
      'encode': ucs2encode
    },
    'decode': decode,
    'encode': encode,
    'toASCII': toASCII,
    'toUnicode': toUnicode
  };
  if ( true && _typeof(__webpack_require__.amdO) == 'object' && __webpack_require__.amdO) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return punycode;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (freeExports && freeModule) {
    if (module.exports == freeExports) {
      freeModule.exports = punycode;
    } else {
      for (key in punycode) {
        punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
      }
    }
  } else {
    root.punycode = punycode;
  }
})(this);

/***/ }),

/***/ 32820:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(38051);
var AdapterConstants = __webpack_require__(59881);
var Chrono = __webpack_require__(2589);
var AdapterAdsMixin = {
  getPosition: function getPosition() {
    return null;
  },
  getGivenBreaks: function getGivenBreaks() {
    return null;
  },
  getExpectedBreaks: function getExpectedBreaks() {
    return null;
  },
  getExpectedPattern: function getExpectedPattern() {
    return null;
  },
  getBreaksTime: function getBreaksTime() {
    return null;
  },
  getGivenAds: function getGivenAds() {
    return null;
  },
  getExpectedAds: function getExpectedAds() {
    return null;
  },
  getIsVisible: function getIsVisible() {
    return true;
  },
  getAudioEnabled: function getAudioEnabled() {
    return null;
  },
  getIsSkippable: function getIsSkippable() {
    return null;
  },
  getIsFullscreen: function getIsFullscreen() {
    return null;
  },
  getCampaign: function getCampaign() {
    return null;
  },
  getCreativeId: function getCreativeId() {
    return null;
  },
  getProvider: function getProvider() {
    return null;
  },
  getAdInsertionType: function getAdInsertionType() {
    return null;
  },
  fireClick: function fireClick(params) {
    if (typeof params === 'string') {
      params = {
        url: params
      };
    }
    this.emit(AdapterConstants.Event.CLICK, {
      params: params
    });
  },
  fireQuartile: function fireQuartile(quartile) {
    if (this.flags.isStarted && typeof quartile === 'number' && quartile > this.flags.lastQuartileSent && quartile < 4) {
      this.flags.lastQuartileSent++;
      this.emit(AdapterConstants.Event.QUARTILE, {
        params: {
          quartile: quartile
        }
      });
    }
  },
  startChronoView: function startChronoView() {
    if (this.getIsVisible() && !this.plugin.backgroundDetector.isInBackground) {
      var max = this.chronos.viewedMax;
      if (max.length === 0 || max[max.length - 1].stopTime !== 0) {
        max.push(new Chrono());
        max[max.length - 1].start();
      }
    }
  },
  stopChronoView: function stopChronoView() {
    var max = this.chronos.viewedMax;
    if (max[0] && max.length > 0 && max[max.length - 1].stopTime === 0) {
      max[max.length - 1].stop();
    }
  },
  fireManifest: function fireManifest(params, message) {
    var paramsObject = {
      params: params
    };
    if (typeof params === 'string') {
      paramsObject = {
        params: {
          errorType: params,
          errorMessage: message
        }
      };
    }
    this.emit(AdapterConstants.Event.MANIFEST, paramsObject);
  },
  fireSkip: function fireSkip(params) {
    if (params === undefined) {
      params = {};
    }
    params.skipped = true;
    this.fireStop(params);
  },
  fireBreakStart: function fireBreakStart(params) {
    this.emit(AdapterConstants.Event.PODSTART, {
      params: params
    });
  },
  fireBreakStop: function fireBreakStop(params) {
    this.emit(AdapterConstants.Event.PODSTOP, {
      params: params
    });
  }
};
module.exports = AdapterAdsMixin;

/***/ }),

/***/ 99322:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(26677);
__webpack_require__(77402);
__webpack_require__(67478);
__webpack_require__(38051);
__webpack_require__(65000);
var AdapterConstants = __webpack_require__(59881);
var Log = __webpack_require__(60244);
var AdapterContentMixin = {
  getPlayrate: function getPlayrate() {
    return !this.flags.isPaused ? 1 : 0;
  },
  getFramesPerSecond: function getFramesPerSecond() {
    return null;
  },
  getDroppedFrames: function getDroppedFrames() {
    return null;
  },
  getThroughput: function getThroughput() {
    return null;
  },
  getRendition: function getRendition() {
    return null;
  },
  getTitle2: function getTitle2() {
    return null;
  },
  getIsLive: function getIsLive() {
    return null;
  },
  getCdnTraffic: function getCdnTraffic() {
    return null;
  },
  getP2PTraffic: function getP2PTraffic() {
    return null;
  },
  getUploadTraffic: function getUploadTraffic() {
    return null;
  },
  getIsP2PEnabled: function getIsP2PEnabled() {
    return null;
  },
  getSegmentDuration: function getSegmentDuration() {
    return null;
  },
  getHouseholdId: function getHouseholdId() {
    return null;
  },
  getLatency: function getLatency() {
    return null;
  },
  getPacketLoss: function getPacketLoss() {
    return null;
  },
  getPacketSent: function getPacketSent() {
    return null;
  },
  getMetrics: function getMetrics() {
    return null;
  },
  getAudioCodec: function getAudioCodec() {
    return null;
  },
  getVideoCodec: function getVideoCodec() {
    return null;
  },
  getURLToParse: function getURLToParse() {
    return null;
  },
  fireSeekBegin: function fireSeekBegin(params, convertFromBuffer, triggeredEvent) {
    this._discardFalseBuffers();
    if (this.plugin && this.plugin.getIsLive() && this.plugin.options['content.isLive.noSeek']) return null;
    if (this.flags.isJoined && !this.flags.isSeeking) {
      if (this.flags.isBuffering) {
        if (convertFromBuffer !== false) {
          Log.notice('Converting current buffer to seek');
          this.chronos.seek = this.chronos.buffer.clone();
          this.chronos.buffer.reset();
          this.flags.isBuffering = false;
        } else {
          return;
        }
      } else {
        this.chronos.seek.start();
      }
      try {
        this.fireEventsStruct.seek = [];
        if (triggeredEvent) {
          this.fireEventsStruct.seek.push(triggeredEvent);
        } else {
          this.fireEventsStruct.seek.push('undefinedEvent');
        }
      } catch (e) {}
      this.flags.isSeeking = true;
      this.emit(AdapterConstants.Event.SEEK_BEGIN, {
        params: params
      });
    }
  },
  fireSeekEnd: function fireSeekEnd(params, triggeredEvent) {
    if (this.plugin && this.plugin.getIsLive() && this.plugin.options['content.isLive.noSeek']) return null;
    if (this.flags.isJoined && this.flags.isSeeking) {
      try {
        if (triggeredEvent) {
          this.fireEventsStruct.seek.push(triggeredEvent);
        } else {
          this.fireEventsStruct.seek.push('undefinedEvent');
        }
      } catch (e) {}
      params = params || {};
      params.triggeredEvents = this.fireEventsStruct.seek;
      this.cancelSeek();
      this.emit(AdapterConstants.Event.SEEK_END, {
        params: params
      });
    }
  },
  cancelSeek: function cancelSeek(params) {
    if (this.flags.isJoined && this.flags.isSeeking) {
      this.flags.isSeeking = false;
      this.chronos.seek.stop();
      if (this.monitor) this.monitor.skipNextTick();
    }
  },
  fireEvent: function fireEvent(eventName, dimensions, values, topLevelDimensions) {
    var returnparams = topLevelDimensions || {};
    returnparams.name = eventName || '';
    returnparams.dimensions = dimensions || {};
    returnparams.values = values || {};
    this.emit(AdapterConstants.Event.VIDEO_EVENT, {
      params: returnparams
    });
  }
};
module.exports = AdapterContentMixin;

/***/ }),

/***/ 74366:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(30415);
__webpack_require__(72578);
__webpack_require__(67478);
__webpack_require__(38051);
__webpack_require__(50851);
var Emitter = __webpack_require__(51973);
var Log = __webpack_require__(60244);
var Util = __webpack_require__(29021);
var version = __webpack_require__(11618);
var PlaybackChronos = __webpack_require__(67144);
var PlaybackFlags = __webpack_require__(17762);
var PlayheadMonitor = __webpack_require__(19534);
var StateMonitor = __webpack_require__(21262);
var AdapterConstants = __webpack_require__(59881);
var Adapter = Emitter.extend({
  constructor: function constructor(player) {
    this.flags = new PlaybackFlags();
    this.chronos = new PlaybackChronos();
    this.fireEventsStruct = {};
    this.fireEventsStruct.buffer = [];
    this.fireEventsStruct.seek = [];
    this.monitor = null;
    this.plugin = null;
    this.player = null;
    this._isAdsAdapter = null;
    this.setPlayer(player);
    this.tag = this.player;
    Log.notice('Adapter ' + this.getVersion() + ' with Lib ' + version + ' is ready.');
  },
  setPlayer: function setPlayer(player) {
    if (this.player) this.unregisterListeners();
    if (typeof player === 'string' && typeof document !== 'undefined') {
      this.player = document.getElementById(player);
    } else {
      this.player = player;
    }
    this.registerListeners();
  },
  registerListeners: function registerListeners() {},
  unregisterListeners: function unregisterListeners() {},
  dispose: function dispose() {
    this.stopMonitor();
    this.stopReadyStateMonitor();
    this.fireStop();
    this.unregisterListeners();
    this.player = null;
    this.tag = null;
  },
  monitorPlayhead: function monitorPlayhead(monitorBuffers, monitorSeeks, interval) {
    this.stopMonitor();
    var type = 0;
    if (monitorBuffers) type |= PlayheadMonitor.Type.BUFFER;
    if (monitorSeeks) type |= PlayheadMonitor.Type.SEEK;
    if (!this.monitor || !this.monitor._timer.isRunning) {
      this.monitor = new PlayheadMonitor(this, type, interval);
    } else {
      this.monitor.skipNextTick();
    }
  },
  stopMonitor: function stopMonitor() {
    if (this.monitor) this.monitor.stop();
  },
  monitorReadyState: function monitorReadyState(intervalMilliseconds) {
    this.stopReadyStateMonitor();
    this.stateMonitor = new StateMonitor(this, intervalMilliseconds);
  },
  startReadyStateMonitor: function startReadyStateMonitor() {
    if (this.stateMonitor) this.stateMonitor.start();
  },
  stopReadyStateMonitor: function stopReadyStateMonitor() {
    if (this.stateMonitor) this.stateMonitor.stop();
  },
  checkReadyState: function checkReadyState(readyState, triggeredEvent) {
    try {
      if (this.plugin && this.plugin.getReadyStateMonitorEnabled()) {
        if (readyState) {
          if (readyState > 3 && !this.flags.isSeeking) {
            if (this.flags.isBuffering) {
              this.fireBufferEnd({}, triggeredEvent + '-readyState');
            } else if (!this.flags.isJoined) {
              this.fireJoin({}, triggeredEvent + '-readyState');
            }
          } else if (readyState < 4 && !this.flags.isBuffering) {
            this.fireBufferBegin({}, false, triggeredEvent + '-readyState', true);
          }
        }
      }
    } catch (e) {
      Log.error('Can\'t check readyState property correctly');
    }
  },
  getPlayhead: function getPlayhead() {
    return null;
  },
  getDuration: function getDuration() {
    return null;
  },
  getBitrate: function getBitrate() {
    return null;
  },
  getTotalBytes: function getTotalBytes() {
    return null;
  },
  getTitle: function getTitle() {
    return null;
  },
  getResource: function getResource() {
    return null;
  },
  getPlayerVersion: function getPlayerVersion() {
    return null;
  },
  getPlayerName: function getPlayerName() {
    return null;
  },
  getVersion: function getVersion() {
    return version + '-generic-js';
  },
  getVideoObject: function getVideoObject() {
    return null;
  },
  fireInit: function fireInit(params, triggeredEvent) {
    if (this.plugin) this.plugin.fireInit(params, triggeredEvent);
  },
  fireStart: function fireStart(params, triggeredEvent) {
    if (this.plugin && this.plugin.backgroundDetector && this.plugin.backgroundDetector.canBlockStartCalls()) {
      return null;
    }
    if (!this.flags.isStarted) {
      this.flags.isStarted = true;
      this.chronos.total.start();
      this.chronos.join.start();
      if (triggeredEvent) {
        params = params || {};
        params.triggeredEvents = [triggeredEvent];
      }
      this.startReadyStateMonitor();
      this.emit(AdapterConstants.Event.START, {
        params: params
      });
    }
  },
  fireJoin: function fireJoin(params, triggeredEvent) {
    if (!this.flags.isJoined && !this.flags.isStarted && !this._isAds() && this.plugin && this.plugin.isInitiated) {
      this.fireStart({}, triggeredEvent);
    }
    if (this.flags.isStarted && !this.flags.isJoined) {
      this.flags.isStarted = true;
      if (this.monitor) this.monitor.start();
      this.flags.isJoined = true;
      this.chronos.join.stop();
      if (triggeredEvent) {
        params = params || {};
        params.triggeredEvents = [triggeredEvent];
      }
      this.emit(AdapterConstants.Event.JOIN, {
        params: params
      });
    }
  },
  firePause: function firePause(params, triggeredEvent) {
    this._discardFalseBuffers();
    if (this.flags.isBuffering) {
      this.fireBufferEnd(null, 'firePauseCall');
    }
    if (this.flags.isJoined && !this.flags.isPaused) {
      this.flags.isPaused = true;
      this.chronos.pause.start();
      if (triggeredEvent) {
        params = params || {};
        params.triggeredEvents = [triggeredEvent];
      }
      this.emit(AdapterConstants.Event.PAUSE, {
        params: params
      });
    }
  },
  fireResume: function fireResume(params, triggeredEvent) {
    this._discardFalseBuffers();
    if (this.flags.isJoined && this.flags.isPaused) {
      this.flags.isPaused = false;
      this.chronos.pause.stop();
      if (this.monitor) this.monitor.skipNextTick();
      if (triggeredEvent) {
        params = params || {};
        params.triggeredEvents = [triggeredEvent];
      }
      this.emit(AdapterConstants.Event.RESUME, {
        params: params
      });
    }
  },
  fireBufferBegin: function fireBufferBegin(params, convertFromSeek, triggeredEvent, triggeredByStateProperty) {
    triggeredByStateProperty = triggeredByStateProperty || false;
    if (this.flags.isJoined && !this.flags.isBuffering) {
      if (this.flags.isSeeking) {
        if (convertFromSeek) {
          Log.notice('Converting current buffer to seek');
          this.chronos.buffer = this.chronos.seek.clone();
          this.chronos.seek.reset();
          this.flags.isSeeking = false;
        } else {
          return;
        }
      } else {
        this.chronos.buffer.start();
      }
      try {
        this.fireEventsStruct.buffer = [];
        if (triggeredEvent) {
          this.fireEventsStruct.buffer.push(triggeredEvent);
        } else {
          this.fireEventsStruct.buffer.push('undefinedEvent');
        }
      } catch (e) {}
      this.flags.isBuffering = true;
      this.flags.isVideoStateBuffering = triggeredByStateProperty;
      this.emit(AdapterConstants.Event.BUFFER_BEGIN, {
        params: params
      });
    }
  },
  fireBufferEnd: function fireBufferEnd(params, triggeredEvent) {
    if (this.flags.isJoined && this.flags.isBuffering) {
      try {
        if (triggeredEvent) {
          this.fireEventsStruct.buffer.push(triggeredEvent);
        } else {
          this.fireEventsStruct.buffer.push('undefinedEvent');
        }
      } catch (e) {}
      params = params || {};
      params.triggeredEvents = this.fireEventsStruct.buffer;
      this.cancelBuffer();
      this.emit(AdapterConstants.Event.BUFFER_END, {
        params: params
      });
    }
  },
  _discardFalseBuffers: function _discardFalseBuffers() {
    try {
      if (this.flags.isBuffering && this.flags.isVideoStateBuffering && this._getDeltaBufferTime() <= 100) {
        this.cancelBuffer();
      }
    } catch (e) {}
  },
  cancelBuffer: function cancelBuffer(params) {
    if (this.flags.isJoined && this.flags.isBuffering) {
      this.flags.isBuffering = false;
      this.flags.isVideoStateBuffering = false;
      this.chronos.buffer.stop();
      if (this.monitor) this.monitor.skipNextTick();
    }
  },
  _getDeltaBufferTime: function _getDeltaBufferTime() {
    if (this.chronos && this.chronos.buffer) {
      return this.chronos.buffer.getDeltaTime(false);
    }
    return 0;
  },
  fireStop: function fireStop(params, triggeredEvent) {
    if (this._isAds() || this.plugin && this.plugin._isStopReady()) {
      if (this._isAds() && this.flags.isStarted || !this._isAds() && (this.flags.isStarted || this.plugin && this.plugin.isInitiated)) {
        this.stopMonitor();
        this.stopReadyStateMonitor();
        this.flags.reset();
        this.chronos.total.stop();
        this.chronos.join.reset();
        this.chronos.pause.stop();
        this.chronos.buffer.stop();
        this.chronos.seek.stop();
        if (triggeredEvent) {
          params = params || {};
          params.triggeredEvents = [triggeredEvent];
        }
        this.emit(AdapterConstants.Event.STOP, {
          params: params
        });
        this.chronos.pause.reset();
        this.chronos.buffer.reset();
        this.chronos.seek.reset();
        this.chronos.viewedMax.splice(0, this.chronos.viewedMax.length);
      }
    }
  },
  setIsAds: function setIsAds(value) {
    this._isAdsAdapter = value;
  },
  _isAds: function _isAds() {
    return this._isAdsAdapter;
  },
  fireCasted: function fireCasted(params, triggeredEvent) {
    if (!params) params = {};
    params.casted = true;
    this.fireStop(params, triggeredEvent);
  },
  fireError: function fireError(code, msg, metadata, level, triggeredEvent) {
    var params = Util.buildErrorParams(code, msg, metadata, level);
    if (params.code) {
      delete params.code;
    }
    if (triggeredEvent) {
      params = params || {};
      params.triggeredEvents = [triggeredEvent];
    }
    var options = this.plugin ? this.plugin.options : {};
    if (typeof params.errorCode !== 'undefined' && options['errors.ignore'] && options['errors.ignore'].indexOf(params.errorCode.toString()) > -1) {} else {
      this.emit(AdapterConstants.Event.ERROR, {
        params: params
      });
      if (typeof params.errorCode !== 'undefined' && options['errors.fatal'] && options['errors.fatal'].indexOf(params.errorCode.toString()) > -1) {
        this.fireStop({}, triggeredEvent);
      }
    }
  },
  fireFatalError: function fireFatalError(code, msg, metadata, level, triggeredEvent) {
    var options = this.plugin ? this.plugin.options : {};
    if (typeof code !== 'undefined' && options['errors.ignore'] && options['errors.ignore'].indexOf(code.toString()) > -1) {} else {
      if (this.monitor) this.monitor.stop();
      this.fireError(code, msg, metadata, level, triggeredEvent);
      if (typeof code !== 'undefined' && options['errors.nonFatal'] && options['errors.nonFatal'].indexOf(code.toString()) > -1) {} else {
        this.fireStop({}, triggeredEvent);
      }
    }
  }
}, {
  Event: AdapterConstants.Event
});
Util.assign(Adapter.prototype, __webpack_require__(32820));
Util.assign(Adapter.prototype, __webpack_require__(99322));
module.exports = Adapter;

/***/ }),

/***/ 67144:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(30415);
var YouboraObject = __webpack_require__(14074);
var Chrono = __webpack_require__(2589);
var PlaybackChronos = YouboraObject.extend({
  constructor: function constructor() {
    this.reset();
  },
  reset: function reset() {
    this.join = new Chrono();
    this.seek = new Chrono();
    this.pause = new Chrono();
    this.buffer = new Chrono();
    this.total = new Chrono();
    this.viewedMax = [];
  }
});
module.exports = PlaybackChronos;

/***/ }),

/***/ 17762:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var YouboraObject = __webpack_require__(14074);
var PlaybackFlags = YouboraObject.extend({
  constructor: function constructor() {
    this.reset();
  },
  reset: function reset() {
    this.isStarted = false;
    this.isJoined = false;
    this.isPaused = false;
    this.isSeeking = false;
    this.isBuffering = false;
    this.isVideoStateBuffering = false;
    this.isEnded = false;
    this.isStopped = false;
    this.lastQuartileSent = 0;
  }
});
module.exports = PlaybackFlags;

/***/ }),

/***/ 19534:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(38051);
var YouboraObject = __webpack_require__(14074);
var Timer = __webpack_require__(42189);
var Chrono = __webpack_require__(2589);
var PlayheadMonitor = YouboraObject.extend({
  constructor: function constructor(adapter, type, interval) {
    this._adapter = adapter;
    this._seekEnabled = type & PlayheadMonitor.Type.SEEK;
    this._bufferEnabled = type & PlayheadMonitor.Type.BUFFER;
    interval = interval || 800;
    this._chrono = new Chrono();
    this._lastPlayhead = 0;
    if (interval > 0) {
      this._timer = new Timer(this.progress.bind(this), interval);
    }
  },
  start: function start() {
    this.stop();
    if (this.canBeUsed()) this._timer.start();
  },
  stop: function stop() {
    this._lastPlayhead = 0;
    if (this._timer) this._timer.stop();
  },
  skipNextTick: function skipNextTick() {
    this._lastPlayhead = 0;
  },
  progress: function progress() {
    var deltaTime = this._chrono.stop();
    this._chrono.start();
    var bufferThreshold = deltaTime * PlayheadMonitor.kBUFFER_THRESHOLD_RATIO;
    var seekThreshold = deltaTime * PlayheadMonitor.kSEEK_THRESHOLD_RATIO;
    if (this._adapter.getPlayrate && this._adapter.getPlayrate() && this._adapter.getPlayrate() !== 1) {
      bufferThreshold *= this._adapter.getPlayrate();
      seekThreshold *= this._adapter.getPlayrate();
    }
    var currentPlayhead = this._getPlayhead();
    var diffPlayhead = Math.abs(this._lastPlayhead - currentPlayhead) * 1000;
    if (diffPlayhead < bufferThreshold) {
      if (this._bufferEnabled && this._lastPlayhead > 0 && !this._adapter.flags.isPaused && !this._adapter.flags.isSeeking) {
        this._adapter.fireBufferBegin(null, false, 'playheadMonitor');
      }
    } else if (diffPlayhead > seekThreshold) {
      if (this._seekEnabled && this._lastPlayhead > 0) {
        this._adapter.fireSeekBegin(null, false, 'playheadMonitor');
      }
    } else {
      if (this._seekEnabled) {
        this._adapter.fireSeekEnd(null, 'playheadMonitor');
      }
      if (this._bufferEnabled) {
        this._adapter.fireBufferEnd(null, 'playheadMonitor');
      }
    }
    this._lastPlayhead = currentPlayhead;
  },
  canBeUsed: function canBeUsed() {
    var plugin = this._adapter.plugin;
    if (plugin && plugin.getPlayheadMonitorEnabled() && (this._seekEnabled || this._bufferEnabled)) {
      return plugin.getIsLive() ? !plugin.options['content.isLive.noMonitor'] : true;
    } else {
      return false;
    }
  },
  _getPlayhead: function _getPlayhead() {
    return this._adapter.getPlayhead();
  }
}, {
  Type: {
    NONE: 0,
    BUFFER: 1,
    SEEK: 2
  },
  kBUFFER_THRESHOLD_RATIO: 0.5,
  kSEEK_THRESHOLD_RATIO: 2
});
module.exports = PlayheadMonitor;

/***/ }),

/***/ 21262:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(38051);
var YouboraObject = __webpack_require__(14074);
var Log = __webpack_require__(60244);
var StateMonitor = YouboraObject.extend({
  constructor: function constructor(adapter, intervalMilliseconds) {
    this._adapter = adapter;
    this._videoElement = adapter.getVideoObject();
    this._startedStateCheck = false;
    this._intervalCheckId = null;
    this._intervalMilliseconds = intervalMilliseconds || 300;
  },
  start: function start() {
    var plugin = this._adapter.plugin;
    if (plugin && plugin.getReadyStateMonitorEnabled()) {
      if (this._videoElement && !this._startedStateCheck) {
        this._intervalCheckId = setInterval(this.checkStateProperty.bind(this), this._intervalMilliseconds);
        this._startedStateCheck = true;
      }
    }
  },
  stop: function stop() {
    try {
      if (this._startedStateCheck && this._intervalCheckId) {
        clearInterval(this._intervalCheckId);
      }
      this._intervalCheckId = null;
      this._startedStateCheck = false;
    } catch (e) {
      Log.error('Produced error stopping the network monitor');
    }
  },
  checkStateProperty: function checkStateProperty(e) {
    try {
      if (this._videoElement && this._adapter) {
        if (this._videoElement.readyState) {
          if (this._videoElement.readyState > 3 && !this._adapter.flags.isSeeking) {
            if (this._adapter.flags.isBuffering) {
              this.fireBufferEnd({}, 'stateMonitor');
            } else if (!this._adapter.flags.isJoined) {
              this.fireJoin({}, 'stateMonitor');
            }
          } else if (this._videoElement.readyState < 4 && !this._adapter.flags.isBuffering) {
            this.fireBufferBegin({}, false, 'stateMonitor', true);
          }
        }
      }
    } catch (e) {}
  }
});
module.exports = StateMonitor;

/***/ }),

/***/ 2589:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var YouboraObject = __webpack_require__(14074);
var Chrono = YouboraObject.extend({
  constructor: function constructor() {
    this.reset();
  },
  reset: function reset() {
    this.startTime = 0;
    this.stopTime = 0;
    this.pauseTime = 0;
    this.offset = 0;
  },
  getDeltaTime: function getDeltaTime(stop) {
    var retValue = -1;
    var now = new Date().getTime();
    if (this.startTime) {
      if (stop && !this.stopTime) {
        this.stopTime = now;
      }
      var tempOffset = this.pauseTime ? now - this.pauseTime : 0;
      var tempStop = this.stopTime ? this.stopTime : now;
      retValue = this.offset - tempOffset + (tempStop - this.startTime);
    }
    return retValue;
  },
  start: function start() {
    this.startTime = new Date().getTime();
    this.stopTime = 0;
    this.offset = 0;
  },
  stop: function stop() {
    if (this.pauseTime) this.resume();
    this.stopTime = new Date().getTime();
    return this.startTime ? this.offset + (this.stopTime - this.startTime) : -1;
  },
  pause: function pause() {
    this.pauseTime = new Date().getTime();
  },
  resume: function resume() {
    this.offset -= new Date().getTime() - this.pauseTime;
    this.pauseTime = 0;
  },
  clone: function clone() {
    var chrono = new Chrono();
    chrono.startTime = this.startTime;
    chrono.stopTime = this.stopTime;
    chrono.offset = this.offset;
    return chrono;
  }
});
module.exports = Chrono;

/***/ }),

/***/ 60502:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(72578);
__webpack_require__(90565);
var YouboraObject = __webpack_require__(14074);
var Log = __webpack_require__(60244);
var YBRequest = __webpack_require__(41142);
var Transform = __webpack_require__(79877);
var Communication = YouboraObject.extend({
  constructor: function constructor(pluginref) {
    this.transforms = [];
    this.pluginRef = pluginref;
    this._requests = [];
  },
  sendRequest: function sendRequest(request, callback, callbackParams) {
    if (request) {
      if (typeof callback === 'function') request.on(YBRequest.Event.SUCCESS, callback, callbackParams);
      this._registerRequest(request);
    }
  },
  buildRequest: function buildRequest(host, service, params, callback) {
    params = params || {};
    var request = new YBRequest(host, service, params);
    if (typeof callback === 'function') request.on(YBRequest.Event.SUCCESS, callback);
    this._registerRequest(request);
  },
  addTransform: function addTransform(transform) {
    if (transform.parse && transform.isBlocking) {
      this.transforms.push(transform);
      transform.on(Transform.Event.DONE, this._processRequests.bind(this));
    } else {
      Log.warn(transform + ' is not a valid RequestTransform.');
    }
  },
  removeTransform: function removeTransform(transform) {
    var pos = this.transforms.indexOf(transform);
    if (pos !== -1) {
      this.transforms.splice(pos, 1);
    } else {
      Log.warn('Trying to remove unexisting Transform \'' + transform + '\'.');
    }
  },
  _registerRequest: function _registerRequest(request) {
    if (this.pluginRef) {
      var options = this.pluginRef.options;
      if (options.authToken) {
        request.options.requestHeaders.Authorization = options.authType + ' ' + options.authToken;
      }
    }
    this._requests.push(request);
    this._processRequests();
  },
  _processRequests: function _processRequests() {
    var workingQueue = this._requests;
    this._requests = [];
    var rejected = [];
    while (workingQueue.length) {
      var request = workingQueue.shift();
      var transformState = this._transform(request);
      if (transformState === Transform.STATE_NO_BLOCKED) {
        if (this.pluginRef) request.host = this.pluginRef.getHost();
        request.send();
      } else if (transformState === Transform.STATE_BLOCKED) {
        rejected.push(request);
      }
    }
    while (rejected.length) {
      this._requests.push(rejected.shift());
    }
  },
  _transform: function _transform(request) {
    var ret = Transform.STATE_NO_BLOCKED;
    this.transforms.forEach(function (transform) {
      if (transform.isBlocking(request)) {
        ret = Transform.STATE_BLOCKED;
        return;
      } else {
        transform.parse(request);
      }
      if (transform.getState() === Transform.STATE_OFFLINE) {
        ret = Transform.STATE_OFFLINE;
      }
    });
    return ret;
  }
});
module.exports = Communication;

/***/ }),

/***/ 41142:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(97343);
__webpack_require__(72578);
__webpack_require__(90565);
var _typeof = __webpack_require__(45129);
var YouboraObject = __webpack_require__(14074);
var Log = __webpack_require__(60244);
var Util = __webpack_require__(29021);
var YBRequest = YouboraObject.extend({
  constructor: function constructor(host, service, params, options) {
    this.xhr = this.createXHR();
    this.host = host || '';
    this.service = service || '';
    this.params = params || {};
    this.options = Util.assign({}, YBRequest.defaultOptions, options);
    this.retries = 0;
    this.sendPostRequest = false;
    this.preparedPostRequest = false;
    if (!this.options.cache) {
      this.setParam('timemark', new Date().getTime());
    }
  },
  createXHR: function createXHR() {
    var xhr = {};
    try {
      if (XMLHttpRequest) {
        xhr = new XMLHttpRequest();
      } else {
        xhr = new ActiveXObject('Microsoft.XMLHTTP');
      }
    } catch (err) {
      Log.error(err);
    }
    return xhr;
  },
  getXHR: function getXHR() {
    return this.xhr;
  },
  getResponse: function getResponse() {
    return this.xhr.response;
  },
  getResponseText: function getResponseText() {
    return this.xhr.responseText;
  },
  getResponseHeaders: function getResponseHeaders() {
    return this.xhr.getAllResponseHeaders();
  },
  getUrl: function getUrl() {
    return this.host + this.service + this.getParamString();
  },
  on: function on(event, callback, callbackParams) {
    if (this.xhr.addEventListener) {
      this.xhr.addEventListener(event, callback.bind(this, this, callbackParams));
    } else {
      if (event === YBRequest.Event.SUCCESS) {
        this.xhr.onreadystatechange = function () {
          if (this.xhr.readyState === 4) {
            callback.bind(this, this, callbackParams);
          }
        }.bind(this);
      }
    }
    return this;
  },
  off: function off(event, callback) {
    this.xhr.removeEventListener(event, callback);
    return this;
  },
  getParamString: function getParamString() {
    try {
      var params = '?';
      for (var key in this.params) {
        var param = this.params[key];
        if (param !== null && _typeof(param) === 'object') {
          var string = JSON.stringify(param);
          if (string !== '{}') {
            params += encodeURIComponent(key) + '=' + encodeURIComponent(string) + '&';
          }
        } else if (param !== null && typeof param !== 'undefined' && param !== '') {
          params += encodeURIComponent(key) + '=' + encodeURIComponent(param) + '&';
        }
      }
      return params.slice(0, -1);
    } catch (err) {
      Log.error(err);
      return '';
    }
  },
  getParam: function getParam(key) {
    return this.params[key];
  },
  setParam: function setParam(key, value) {
    this.params[key] = value;
    return this;
  },
  setBody: function setBody(body) {
    this.body = body;
  },
  setPostRequest: function setPostRequest(sendPostRequest) {
    this.sendPostRequest = sendPostRequest;
  },
  getParamsForPostMessages: function getParamsForPostMessages() {
    var params = {};
    try {
      var timemark = this.getParam('timemark');
      var code = this.getParam('code');
      var sessionRoot = this.getParam('sessionRoot');
      var sessionId = this.getParam('sessionId');
      if (timemark) {
        params.timemark = timemark;
      }
      if (code) {
        params.code = code;
      }
      if (sessionRoot) {
        params.sessionRoot = sessionRoot;
      }
      if (sessionId) {
        params.sessionId = sessionId;
      }
    } catch (err) {
      Log.error(err);
    }
    return params;
  },
  send: function send() {
    try {
      try {
        if (this.sendPostRequest && !this.preparedPostRequest) {
          this.options.method = 'POST';
          this.body = JSON.stringify(this.params);
          this.params = this.getParamsForPostMessages();
          this.preparedPostRequest = true;
        }
      } catch (err) {}
      this.xhr.open(this.options.method, this.getUrl(), true);
      if (this.options.requestHeaders) {
        for (var key in this.options.requestHeaders) {
          if (this.options.requestHeaders.hasOwnProperty(key)) {
            this.xhr.setRequestHeader(key, this.options.requestHeaders[key]);
          }
        }
      }
      if (this.options.retryAfter > 0 && this.options.maxRetries > 0) {
        var genericError = function genericError() {
          if (this.retries >= this.options.maxRetries) {
            Log.error('Aborting failed request "' + this.service + '". Max retries reached.');
          } else {
            Log.warn('YBRequest "' + this.service + '" failed. Retry ' + (this.retries + 1) + ' of ' + this.options.maxRetries + ' in ' + this.options.retryAfter + 'ms.');
            try {
              setTimeout(function () {
                this.retries += 1;
                this.send();
              }.bind(this), this.options.retryAfter);
            } catch (err) {
              if (typeof atv !== 'undefined') {
                atv.setTimeout(function () {
                  this.retries += 1;
                  this.send();
                }.bind(this), this.options.retryAfter);
              } else {
                Log.error(err);
              }
            }
          }
        };
        if (this.retries === 0) {
          this.on(YBRequest.Event.ERROR, genericError.bind(this));
        }
      }
      if (Log.logLevel <= Log.Level.VERBOSE) {
        Log.verbose('XHR Req: ' + this.getUrl());
      }
      for (var event in YBRequest._globalListeners) {
        YBRequest._globalListeners[event].forEach(function (callback) {
          this.on(event, callback);
        }.bind(this));
      }
      return this.xhr.send(this.body);
    } catch (err) {
      Log.error(err);
    }
  }
}, {
  Event: {
    SUCCESS: 'load',
    LOAD: 'load',
    ERROR: 'error',
    ABORT: 'abort'
  },
  defaultOptions: {
    method: 'GET',
    requestHeaders: {},
    maxRetries: 3,
    retryAfter: 5000,
    cache: false
  },
  _globalListeners: {},
  onEvery: function onEvery(event, callback) {
    YBRequest._globalListeners[event] = YBRequest._globalListeners[event] || [];
    YBRequest._globalListeners[event].push(callback);
  },
  offEvery: function offEvery(event, callback) {
    if (YBRequest._globalListeners[event]) {
      var index = YBRequest._globalListeners[event].indexOf(callback);
      if (index !== -1) {
        YBRequest._globalListeners[event].splice(index, 1);
      }
    }
  }
});
module.exports = YBRequest;

/***/ }),

/***/ 830:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Transform = __webpack_require__(79877);
var Constants = __webpack_require__(47905);
var FlowTransform = Transform.extend({
  _services: [Constants.Service.INIT, Constants.Service.START, Constants.Service.OFFLINE_EVENTS],
  isBlocking: function isBlocking(request) {
    if (this._isBusy && request != null) {
      if (this._services.indexOf(request.service) !== -1) {
        this.done();
      } else if (request.service === Constants.Service.ERROR) {
        return false;
      }
    }
    return Transform.prototype.isBlocking.apply(this, arguments);
  }
});
module.exports = FlowTransform;

/***/ }),

/***/ 19427:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Transform = __webpack_require__(79877);
var OfflineTransform = Transform.extend({
  constructor: function constructor(plugin, session) {
    this._sendRequest = false;
    this._isBusy = false;
    this.plugin = plugin;
    this.session = session;
    this.transformName = 'Offline';
  },
  parse: function parse(request) {
    if (request && this.plugin.offlineStorage) {
      this.plugin.offlineStorage.addEvent(request.service, request.params);
    }
  },
  hasToSend: function hasToSend(request) {
    return false;
  },
  getState: function getState() {
    return Transform.STATE_OFFLINE;
  }
});
module.exports = OfflineTransform;

/***/ }),

/***/ 50522:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(97343);
var Transform = __webpack_require__(79877);
var HlsParser = __webpack_require__(75694);
var CdnParser = __webpack_require__(57360);
var CdnSwitch = __webpack_require__(42168);
var DashParser = __webpack_require__(80654);
var Parser = __webpack_require__(65018);
var LocationheaderParser = __webpack_require__(5571);
var Log = __webpack_require__(60244);
var Constants = __webpack_require__(47905);
var ResourceTransform = Transform.extend({
  constructor: function constructor(plugin) {
    ResourceTransform.__super__.constructor.apply(this, arguments);
    this._plugin = plugin;
    this._realResource = null;
    this._transportFormat = null;
    this._initResource = null;
    this._cdnName = null;
    this._cdnNodeHost = null;
    this._cdnNodeTypeString = null;
    this._cdnNodeType = null;
    this._responses = {};
    this._isBusy = false;
    this.transformName = 'Resource';
  },
  getResource: function getResource() {
    return this._realResource;
  },
  _getInitialCdnResource: function _getInitialCdnResource() {
    return this._realResource || this._initResource;
  },
  getTransportFormat: function getTransportFormat() {
    return this._transportFormat;
  },
  getCdnName: function getCdnName() {
    return this._cdnName;
  },
  getNodeHost: function getNodeHost() {
    return this._cdnNodeHost;
  },
  getNodeTypeString: function getNodeTypeString() {
    return this._cdnNodeTypeString;
  },
  getNodeType: function getNodeType() {
    return this._cdnNodeType;
  },
  init: function init(resource) {
    if (!resource) {
      this.done();
      return;
    }
    if (!this._isBusy) {
      this._isBusy = true;
      this._initResource = resource;
      this._parseManifestEnabled = this._plugin.isParseManifest();
      this._cdnEnabled = this._plugin.isParseCdnNode();
      this._cdnList = this._plugin.getParseCdnNodeList().slice();
      CdnParser.setBalancerHeaderName(this._plugin.getParseCdnNodeNameHeader(), this._plugin.getParseNodeHeader());
      this._setTimeout();
      if (this._parseManifestEnabled) {
        if (!this._isFinalUrl(this._initResource)) {
          this.parseManifest();
        } else {
          this._realResource = this._initResource;
          this.done();
        }
      } else {
        this._parseCDN();
      }
    }
  },
  _isFinalUrl: function _isFinalUrl(url) {
    var segmentExtensions = ['.ts', '.mp4', '.m4s', '.cmfv'];
    url = url || '';
    for (var i in segmentExtensions) {
      var ext = segmentExtensions[i];
      if (url.lastIndexOf(ext) === url.length - ext.length) {
        return true;
      }
    }
    return false;
  },
  _setTimeout: function _setTimeout() {
    var timeoutComplete = function () {
      if (this._isBusy) {
        this.done();
        Log.warn('ResourceTransform has exceded the maximum execution time (3s) and will be aborted.');
      }
    }.bind(this);
    try {
      this._parseTimeout = setTimeout(timeoutComplete, 3000);
    } catch (err) {
      if (typeof atv !== 'undefined') {
        this._parseTimeout = atv.setTimeout(timeoutComplete, 3000);
      } else {
        Log.error(err);
      }
    }
  },
  parseManifest: function parseManifest(lastManifest, lastSrc) {
    var headers = this._plugin.options['parse.manifest.auth'];
    var parserArray = [new LocationheaderParser(headers), new DashParser(headers), new HlsParser(headers)];
    this._parseManifest(parserArray, lastManifest, lastSrc || this._initResource);
  },
  _parseManifest: function _parseManifest(parserArray, lastManifest, lastSrc, format) {
    if (parserArray.length > 0) {
      var parser = parserArray[0];
      if (parser.shouldExecute(lastManifest)) {
        parser.on(Parser.Event.DONE, function () {
          this._parseManifest(parserArray.slice(1, parserArray.length), parser.getLastManifest(), parser.getResource(), parser.getTransportFormat() || format);
        }.bind(this));
        parser.parse(lastSrc, lastManifest);
      } else {
        this._parseManifest(parserArray.slice(1, parserArray.length), lastManifest, lastSrc, format);
      }
    } else {
      this._transportFormat = format;
      this._realResource = lastSrc;
      this._parseCDN();
    }
  },
  _parseCDN: function _parseCDN() {
    if (this._plugin.isCdnSwitch()) {
      this.switchDetector = new CdnSwitch(this._plugin);
      this.switchDetector.on(CdnSwitch.Events.DONE, function (resp) {
        this._cdnName = resp.data;
        this.done();
      }.bind(this));
      this.switchDetector.on(CdnSwitch.Events.ERROR, function () {
        this.done();
      }.bind(this));
      this.switchDetector.init();
    } else if (this._cdnEnabled && this._cdnList.length > 0) {
      var cdn = this._cdnList.shift();
      if (this.getNodeHost()) return;
      var cdnParser = CdnParser.create(cdn);
      if (cdnParser) {
        cdnParser.on(CdnParser.Event.DONE, function () {
          this._responses = cdnParser.getResponses();
          this._cdnName = cdnParser.getParsedCdnName();
          this._cdnNodeHost = cdnParser.getParsedNodeHost();
          this._cdnNodeTypeString = cdnParser.getParsedNodeTypeString();
          this._cdnNodeType = cdnParser.getParsedNodeType();
          if (this.getNodeHost()) {
            this.done();
          } else {
            this._parseCDN();
          }
        }.bind(this));
        cdnParser.parse(this._getInitialCdnResource(), this._responses);
      } else {
        this._parseCDN();
      }
    } else {
      this.done();
    }
  },
  parse: function parse(request) {
    if (request.service === Constants.Service.START) {
      var lastSent = this._plugin.requestBuilder.lastSent;
      lastSent.parsedResource = request.params.parsedResource = this.getResource() || request.params.parsedResource;
      lastSent.transportFormat = request.params.transportFormat = this.getTransportFormat() || request.params.transportFormat;
      if (this._cdnEnabled) {
        lastSent.cdn = request.params.cdn = request.params.cdn || this.getCdnName();
        lastSent.nodeHost = request.params.nodeHost = this.getNodeHost() || request.params.nodeHost;
        lastSent.nodeType = request.params.nodeType = this.getNodeType() || request.params.nodeType;
        lastSent.nodeTypeString = request.params.nodeTypeString = this.getNodeTypeString() || request.params.nodeTypeString;
      }
    }
  }
});
module.exports = ResourceTransform;

/***/ }),

/***/ 42168:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(28610);
__webpack_require__(38051);
__webpack_require__(8612);
__webpack_require__(74389);
var Emitter = __webpack_require__(51973);
var Log = __webpack_require__(60244);
var YBRequest = __webpack_require__(41142);
var CdnSwitch = Emitter.extend({
  constructor: function constructor(plugin) {
    this.plugin = plugin;
    this.headerName = 'x-cdn';
  },
  init: function init() {
    var url = null;
    if (this.plugin) {
      if (this.plugin.getAdapter() && this.plugin.getAdapter().getURLToParse()) {
        url = this.plugin.getAdapter().getURLToParse();
      } else {
        url = this.plugin.getResource();
      }
    }
    if (this.plugin && this.plugin.getAdapter() && this.plugin.getAdapter().flags.isStarted) {
      this._request(url);
    }
  },
  done: function done(data) {
    this.emit(CdnSwitch.Events.DONE, data);
  },
  error: function error() {
    this.emit(CdnSwitch.Events.ERROR);
  },
  _successfulRequest: function _successfulRequest(resp) {
    setTimeout(this.init.bind(this), parseInt(this.plugin.options['parse.cdnTTL']) * 1000);
    var headers = resp.getResponseHeaders().split('\n');
    var cdn = null;
    for (var i in headers) {
      var line = headers[i];
      var index = line.indexOf(this.headerName);
      if (index > -1) {
        cdn = line.substring(index + this.headerName.length + 1, line.length - 1).replace(' ', '');
      }
    }
    this.done(cdn);
  },
  _failedRequest: function _failedRequest() {
    setTimeout(this.init.bind(this), parseInt(this.plugin.options['parse.cdnTTL']) * 1000);
    Log.warn('CDN switch detection request failed');
    this.error();
  },
  _request: function _request(url) {
    var request = new YBRequest(url, null, null, {
      method: 'HEAD',
      cache: true
    });
    request.on(YBRequest.Event.SUCCESS, this._successfulRequest.bind(this));
    request.on(YBRequest.Event.ERROR, this._failedRequest.bind(this));
    request.send();
  }
}, {
  Events: {
    DONE: 'done',
    ERROR: 'error'
  }
});
module.exports = CdnSwitch;

/***/ }),

/***/ 57360:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(97343);
__webpack_require__(28610);
__webpack_require__(74389);
__webpack_require__(91057);
__webpack_require__(90565);
var Emitter = __webpack_require__(51973);
var Log = __webpack_require__(60244);
var Util = __webpack_require__(29021);
var YBRequest = __webpack_require__(41142);
var CdnParser = Emitter.extend({
  constructor: function constructor(options) {
    this._options = Util.assign({
      cdnName: null,
      parsers: [],
      requestMethod: 'HEAD',
      requestHeaders: {},
      parseType: function parseType() {
        return 0;
      }
    }, options);
    this._responses = {};
  },
  done: function done() {
    this.emit(CdnParser.Event.DONE);
  },
  addParser: function addParser(parser) {
    this._options.parsers.push(parser);
    return this;
  },
  setCdnName: function setCdnName(name) {
    this._options.cdnName = name;
    return this;
  },
  setRequestMethod: function setRequestMethod(method) {
    this._options.requestMethod = method;
    return this;
  },
  setRequestHeader: function setRequestHeader(key, value) {
    this._options.requestHeaders[key] = value;
    return this;
  },
  setParseType: function setParseType(parser) {
    this._options.parseType = parser;
    return this;
  },
  getParsedCdnName: function getParsedCdnName() {
    return this._cdnName;
  },
  getParsedNodeHost: function getParsedNodeHost() {
    return this._cdnNodeHost;
  },
  getParsedNodeTypeString: function getParsedNodeTypeString() {
    return this._cdnNodeTypeString;
  },
  getParsedNodeType: function getParsedNodeType() {
    return this._cdnNodeType;
  },
  getResponses: function getResponses() {
    return this._responses;
  },
  parse: function parse(url, responses) {
    this._responses = responses || {};
    var headerString = JSON.stringify(this._options.requestHeaders);
    if (this._responses[headerString]) {
      this._parseResponse(this._responses[headerString]);
    } else {
      this._requestResponse(url);
    }
  },
  _requestResponse: function _requestResponse(url) {
    var headerString = JSON.stringify(this._options.requestHeaders);
    var useheaders = headerString !== '{}';
    var request = new YBRequest(url, null, null, {
      method: this._options.requestMethod,
      maxRetries: 0,
      requestHeaders: this._options.requestHeaders,
      cache: true
    });
    request.on(YBRequest.Event.SUCCESS, function (resp) {
      this._responses[headerString] = resp.getResponseHeaders();
      this._parseResponse(this._responses[headerString]);
    }.bind(this));
    request.on(YBRequest.Event.ERROR, function (resp) {
      if (useheaders) {
        this._options.requestHeaders = {};
        this._requestResponse(url);
      } else {
        this.done();
      }
    }.bind(this));
    request.send();
  },
  _parseResponse: function _parseResponse(headers) {
    this._options.parsers.forEach(function (parser) {
      var headerName = parser.headerName ? parser.headerName.toLowerCase() : '';
      if (headerName) {
        headers.split('\n').forEach(function (line) {
          var index = line.indexOf(':');
          if (index !== -1) {
            var key = line.slice(0, index).toLowerCase();
            if (key === headerName) {
              this._executeParser(parser, line.slice(index + 1));
            }
          }
        }.bind(this));
      }
    }.bind(this));
    this.done();
  },
  _executeParser: function _executeParser(parser, value) {
    try {
      var matches = parser.regex.exec(value.trim());
      if (matches !== null) {
        if (this._options.cdnName) this._cdnName = this._options.cdnName;
        switch (parser.element) {
          case CdnParser.ElementType.HOST:
            this._cdnNodeHost = matches[1];
            break;
          case CdnParser.ElementType.TYPE:
            this._cdnNodeTypeString = matches[1];
            this._cdnNodeType = this._options.parseType(this._cdnNodeTypeString);
            break;
          case CdnParser.ElementType.HOST_AND_TYPE:
            this._cdnNodeHost = matches[1];
            this._cdnNodeTypeString = matches[2];
            this._cdnNodeType = this._options.parseType(this._cdnNodeTypeString);
            break;
          case CdnParser.ElementType.TYPE_AND_HOST:
            this._cdnNodeTypeString = matches[1];
            this._cdnNodeType = this._options.parseType(this._cdnNodeTypeString);
            this._cdnNodeHost = matches[2];
            break;
          case CdnParser.ElementType.NAME:
            this._cdnName = matches[1].toUpperCase();
            break;
        }
      }
    } catch (err) {
      Log.warn('CDN parsing for ' + this._options.cdnName + ' could not parse header value ' + value);
    }
  },
  shouldExecute: function shouldExecute() {
    return true;
  }
}, {
  Event: {
    DONE: 'done'
  },
  ElementType: {
    HOST: 'host',
    TYPE: 'type',
    HOST_AND_TYPE: 'host+type',
    TYPE_AND_HOST: 'type+host',
    NAME: 'name'
  },
  _cdnConfigs: {},
  setBalancerHeaderName: function setBalancerHeaderName(name, nodename) {
    CdnParser._cdnConfigs.Balancer.parsers[0].headerName = name;
    CdnParser._cdnConfigs.Balancer.parsers[1].headerName = nodename;
  },
  create: function create(key) {
    if (CdnParser._cdnConfigs[key]) {
      return new CdnParser(CdnParser._cdnConfigs[key]);
    } else {
      Log.warn('Tried to create an unexisting CdnParser named ' + key);
    }
  },
  add: function add(key, config) {
    CdnParser._cdnConfigs[key] = config;
  }
});
CdnParser.add('Level3', __webpack_require__(48302));
CdnParser.add('Cloudfront', __webpack_require__(61633));
CdnParser.add('Akamai', __webpack_require__(99753));
CdnParser.add('Highwinds', __webpack_require__(89581));
CdnParser.add('Fastly', __webpack_require__(45382));
CdnParser.add('Telefonica', __webpack_require__(97823));
CdnParser.add('Amazon', __webpack_require__(85920));
CdnParser.add('Edgecast', __webpack_require__(67878));
CdnParser.add('Balancer', __webpack_require__(80255));
CdnParser.add('NosOtt', __webpack_require__(77305));
module.exports = CdnParser;

/***/ }),

/***/ 99753:
/***/ ((module) => {

module.exports = {
  cdnName: 'AKAMAI',
  parsers: [{
    element: 'type+host',
    headerName: 'X-Cache',
    regex: /(.+)\sfrom.+AkamaiGHost\/(.+)\).+/
  }, {
    element: 'host',
    headerName: 'akamai-mon-iucid-del',
    regex: /(.*)/
  }, {
    element: 'type',
    headerName: 'akamai-cache-status',
    regex: /(.+)\sfrom\schild/
  }],
  requestHeaders: {
    Pragma: 'akamai-x-cache-on'
  },
  parseType: function parseType(type) {
    var t = type.toLowerCase();
    if (t.indexOf('hit') !== -1) {
      return 1;
    } else if (t.indexOf('miss') !== -1) {
      return 2;
    }
    return 0;
  }
};

/***/ }),

/***/ 85920:
/***/ ((module) => {

module.exports = {
  cdnName: 'AMAZON',
  parsers: [{
    element: 'host',
    headerName: 'x-amz-cf-pop',
    regex: /(.+)/
  }, {
    element: 'type',
    headerName: 'x-cache',
    regex: /(.+)\sfrom.+/
  }],
  parseType: function parseType(type) {
    if (type.toLowerCase().indexOf('hit') !== -1) {
      return 1;
    } else if (type.toLowerCase().indexOf('miss') !== -1) {
      return 2;
    }
    return 0;
  }
};

/***/ }),

/***/ 80255:
/***/ ((module) => {

module.exports = {
  parsers: [{
    element: 'name',
    headerName: null,
    regex: /(.+)/
  }, {
    element: 'host',
    headerName: null,
    regex: /(.+)/
  }]
};

/***/ }),

/***/ 61633:
/***/ ((module) => {

module.exports = {
  cdnName: 'CLOUDFRT',
  parsers: [{
    element: 'host',
    headerName: 'X-Amz-Cf-Id',
    regex: /(.+)/
  }, {
    element: 'type',
    headerName: 'X-Cache',
    regex: /(\S+)\s.+/
  }],
  parseType: function parseType(type) {
    switch (type) {
      case 'Hit':
        return 1;
      case 'Miss':
        return 2;
      default:
        return 0;
    }
  }
};

/***/ }),

/***/ 67878:
/***/ ((module) => {

module.exports = {
  cdnName: 'EDGECAST',
  parsers: [{
    element: 'host',
    headerName: 'Server',
    regex: /\((.+)\/.+\)/
  }, {
    element: 'type',
    headerName: 'X-Cache',
    regex: /(.+)/
  }],
  parseType: function parseType(type) {
    switch (type) {
      case 'HIT':
        return 1;
      case 'MISS':
      default:
        return 2;
    }
  }
};

/***/ }),

/***/ 45382:
/***/ ((module) => {

module.exports = {
  cdnName: 'FASTLY',
  parsers: [{
    element: 'host',
    headerName: 'X-Served-By',
    regex: /([^,\s]+)$/
  }, {
    element: 'type',
    headerName: 'X-Cache',
    regex: /([^,\s]+)$/
  }],
  parseType: function parseType(type) {
    switch (type) {
      case 'HIT':
        return 1;
      case 'MISS':
        return 2;
      default:
        return 0;
    }
  }
};

/***/ }),

/***/ 89581:
/***/ ((module) => {

module.exports = {
  cdnName: 'HIGHNEGR',
  parsers: [{
    element: 'host+type',
    headerName: 'X-HW',
    regex: /.+,[0-9]+\.(.+)\.(.+)/
  }],
  parseType: function parseType(type) {
    switch (type) {
      case 'c':
      case 'x':
        return 1;
      default:
        return 2;
    }
  }
};

/***/ }),

/***/ 48302:
/***/ ((module) => {

module.exports = {
  cdnName: 'LEVEL3',
  parsers: [{
    element: 'host+type',
    headerName: 'X-WR-Diag',
    regex: /Host:(.+)\sType:(.+)/
  }],
  requestHeaders: {
    'X-WR-Diag': 'host'
  },
  parseType: function parseType(type) {
    if (type) {
      if (type.indexOf('TCP_HIT') === 0 || type.indexOf('TCP_MEM_HIT') === 0 || type.indexOf('TCP_IMS_HIT') === 0) {
        return 1;
      } else if (type.indexOf('TCP_MISS') === 0) {
        return 2;
      }
    }
    return 0;
  }
};

/***/ }),

/***/ 77305:
/***/ ((module) => {

module.exports = {
  cdnName: 'NOSOTT',
  parsers: [{
    element: 'host',
    headerName: 'X-NOS-Server',
    regex: /(.+)/
  }, {
    element: 'type',
    headerName: 'X-Cache',
    regex: /(.*)/
  }],
  parseType: function parseType(type) {
    switch (type) {
      case 'Hit':
        return 1;
      case 'Miss':
        return 2;
      default:
        return 0;
    }
  }
};

/***/ }),

/***/ 97823:
/***/ ((module) => {

module.exports = {
  cdnName: 'TELEFO',
  parsers: [{
    element: 'host+type',
    headerName: 'x-tcdn',
    regex: /Host:(.+)\sType:(.+)/
  }],
  requestHeaders: {
    'x-tcdn': 'host'
  },
  parseType: function parseType(type) {
    if (type) {
      if (type.indexOf('p') !== -1 || type.indexOf('c') !== -1) {
        return 1;
      } else if (type.indexOf('i') !== -1 || type.indexOf('m') !== -1) {
        return 2;
      }
    }
    return 0;
  }
};

/***/ }),

/***/ 80654:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(75287);
__webpack_require__(28610);
__webpack_require__(50851);
__webpack_require__(8612);
var YBRequest = __webpack_require__(41142);
var Parser = __webpack_require__(65018);
var Log = __webpack_require__(60244);
var TransportFormat = __webpack_require__(63642);
var DashParser = Parser.extend({
  parse: function parse(resource, lastManifest) {
    if (!lastManifest) {
      var request = new YBRequest(resource, null, null, {
        cache: true,
        requestHeaders: this._headers
      });
      request.on(YBRequest.Event.SUCCESS, function (resp) {
        this.parseLocation(resp, resource);
      }.bind(this));
      request.on(YBRequest.Event.ERROR, function (resp) {
        this.done();
      }.bind(this));
      request.send();
    } else {
      this.parseLocation(lastManifest, resource);
    }
  },
  parseLocation: function parseLocation(lastManifest, resource) {
    this.iterations--;
    var locationRegexp = new RegExp(/<Location>([\s\S]+)<\/Location>/);
    try {
      this._lastManifest = lastManifest;
      var manifest = lastManifest.getResponseText();
      var matches = locationRegexp.exec(manifest);
      if (matches && matches[1]) {
        var newRes = this._htmlDecode(matches[1].replace('\n', ''));
      }
      if (newRes && newRes !== resource && this.iterations > 0) {
        this.parse(newRes);
      } else {
        this.parseFinalResource(manifest, resource);
      }
    } catch (err) {
      Log.warn('Dash parse failed');
      this.done();
    }
  },
  _htmlDecode: function _htmlDecode(input) {
    if (typeof document !== 'undefined' && typeof document.createElement === 'function') {
      var e = document.createElement('textarea');
      e.innerHTML = input;
      return e.childNodes && e.childNodes.length ? e.childNodes[0].nodeValue : input;
    }
    return input;
  },
  parseFinalResource: function parseFinalResource(manifest, resource) {
    var baseUrlRegexp = new RegExp(/<BaseURL>[\r\n]*(.*?)[\r\n]*<\/BaseURL>/);
    var segmentUrlRegexp = new RegExp(/<SegmentURL[\s\S]*media="([^"]+)/);
    var segmentTemplateRegexp = new RegExp(/<SegmentTemplate[\s\S]*media="([^"]+)/);
    var matches = null;
    try {
      matches = baseUrlRegexp.exec(manifest) || segmentTemplateRegexp.exec(manifest) || segmentUrlRegexp.exec(manifest);
      this._getManifestMetadata(manifest);
      if (matches && matches[1] && this._isFullUrl(matches[1])) {
        if (matches[1].indexOf('"') > 0) {
          this._realResource = matches[1].substr(0, matches[1].indexOf('"')).replace('\n', '');
        } else {
          this._realResource = matches[1].replace('\n', '');
        }
      } else {
        this._realResource = resource;
      }
    } catch (err) {
      Log.warn('Dash manifest parse failed');
    }
    this.done();
  },
  _getManifestMetadata: function _getManifestMetadata(manifest) {
    try {
      var transportFormatRegexp = new RegExp(/<AdaptationSet[\s\S]*mimeType="video\/([^"]+)/);
      var matches = transportFormatRegexp.exec(manifest);
      var ret = null;
      switch (matches[1]) {
        case 'mp4':
        case 'm4s':
          ret = TransportFormat.MP4;
          break;
        case 'mp2t':
          ret = TransportFormat.MPEG2;
          break;
        case 'cmfv':
          ret = TransportFormat.CMF;
          break;
      }
      this._transportFormat = ret;
    } catch (err) {
      Log.warn('Couldnt find the transport format');
    }
  },
  _isFullUrl: function _isFullUrl(url) {
    return url.indexOf('http') !== -1;
  },
  shouldExecute: function shouldExecute(lastManifest) {
    var ret = true;
    if (lastManifest) {
      var response = lastManifest.getResponseText();
      ret = response.indexOf('<MPD') !== -1;
    }
    return ret;
  }
});
module.exports = DashParser;

/***/ }),

/***/ 75694:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(97343);
__webpack_require__(28610);
__webpack_require__(91057);
var YBRequest = __webpack_require__(41142);
var Parser = __webpack_require__(65018);
var Log = __webpack_require__(60244);
var TransportFormat = __webpack_require__(63642);
var HlsParser = Parser.extend({
  parse: function parse(resource, lastManifest, parentResource) {
    parentResource = parentResource || '';
    var matches = null;
    try {
      matches = /((\S*?)(\.m3u8|\.m3u|\.ts|\.m4s|\.mp4|\.cmfv|\.m4a)((\?|;)\S*|\n|\r|$))/i.exec(resource.replaceAll(',URI=', '\n').replaceAll('"', '').replaceAll(',', '\n'));
    } catch (err) {
      Log.warn('Parse HLS Regex failed', err);
      this.done();
    }
    if (matches !== null) {
      var res = matches[1].trim();
      var prevParent = '';
      var index = parentResource.lastIndexOf('/');
      if (res.indexOf('http') !== 0 && index !== -1) {
        if (res[0] === '/' && res[1] !== '/') {
          var ind = parentResource.indexOf('/') + 1;
          ind += parentResource.substr(ind, parentResource.length).indexOf('/') + 1;
          ind += parentResource.substr(ind, parentResource.length).indexOf('/');
          res = parentResource.slice(0, ind) + res;
        } else {
          res = parentResource.slice(0, index) + '/' + res;
        }
        prevParent = parentResource.slice(0, index) + '/';
      }
      if (matches[3] === '.m3u8' || matches[3] === '.m3u') {
        if (!lastManifest) {
          var request = new YBRequest(res, null, null, {
            cache: true,
            requestHeaders: this._headers
          });
          request.on(YBRequest.Event.SUCCESS, function (resp) {
            this._parseWithManifest(resp, prevParent, matches);
          }.bind(this));
          request.on(YBRequest.Event.ERROR, function (resp) {
            this.done();
          }.bind(this));
          request.send();
        } else {
          this._parseWithManifest(lastManifest, prevParent, matches);
        }
      } else {
        switch (matches[3]) {
          case '.mp4':
          case '.m4s':
          case '.m4a':
            this._transportFormat = TransportFormat.MP4;
            break;
          case '.ts':
            this._transportFormat = TransportFormat.MPEG2;
            break;
          case '.cmfv':
            this._transportFormat = TransportFormat.CMF;
        }
        this._realResource = res;
        this.done();
      }
    } else {
      this.done();
    }
  },
  _parseWithManifest: function _parseWithManifest(resp, prevParent, matches) {
    this._lastManifest = resp;
    this.parse(resp.getResponseText(), null, prevParent + matches[2]);
  },
  shouldExecute: function shouldExecute(lastManifest) {
    var ret = true;
    if (lastManifest) {
      var response = lastManifest.getResponseText();
      ret = response.indexOf('#EXTM3U') !== -1;
    }
    return ret;
  }
});
module.exports = HlsParser;

/***/ }),

/***/ 5571:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(97343);
__webpack_require__(28610);
__webpack_require__(74389);
__webpack_require__(97072);
__webpack_require__(90565);
var YBRequest = __webpack_require__(41142);
var Parser = __webpack_require__(65018);
var LocationheaderParser = Parser.extend({
  parse: function parse(url, lastManifest) {
    if (!lastManifest) {
      this._realResource = url;
      var request = new YBRequest(url, null, null, {
        cache: true,
        requestHeaders: this._headers
      });
      request.on(YBRequest.Event.SUCCESS, function (resp) {
        this._parseWithManifest(resp);
      }.bind(this));
      request.on(YBRequest.Event.ERROR, function (resp) {
        this.done();
      }.bind(this));
      request.send();
    } else {
      this._parseWithManifest(lastManifest);
    }
  },
  _parseWithManifest: function _parseWithManifest(resp) {
    this._lastManifest = resp;
    var response = resp.getResponseHeaders();
    var found = false;
    if (resp && resp.xhr && resp.xhr.responseURL && resp.xhr.responseURL !== this._realResource) {
      this._realResource = resp.xhr.responseURL;
      this.parse(this._realResource);
      found = true;
    } else {
      response.split('\n').forEach(function (line) {
        if (line.startsWith('Location:')) {
          this._realResource = line.slice(10);
          this.parse(this._realResource);
          found = true;
        }
      }.bind(this));
    }
    if (!found) {
      this.done();
    }
  }
});
module.exports = LocationheaderParser;

/***/ }),

/***/ 65018:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Emitter = __webpack_require__(51973);
var Parser = Emitter.extend({
  constructor: function constructor(headers) {
    this._realResource = null;
    this._lastManifest = null;
    this._transportFormat = null;
    this.iterations = 3;
    this._headers = headers;
  },
  done: function done() {
    this.iterations = 3;
    this.emit(Parser.Event.DONE);
  },
  parse: function parse(resource, lastManifest) {},
  getResource: function getResource() {
    return this._realResource;
  },
  getTransportFormat: function getTransportFormat() {
    return this._transportFormat;
  },
  getLastManifest: function getLastManifest() {
    return this._lastManifest;
  },
  shouldExecute: function shouldExecute(lastManifest) {
    return true;
  }
}, {
  Event: {
    DONE: 'done'
  }
});
module.exports = Parser;

/***/ }),

/***/ 79877:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Emitter = __webpack_require__(51973);
var Transform = Emitter.extend({
  constructor: function constructor() {
    this._isBusy = true;
    this._sendRequest = true;
    this.transformName = 'Transform';
  },
  parse: function parse(request) {},
  isBlocking: function isBlocking(request) {
    return this._isBusy;
  },
  done: function done() {
    this._isBusy = false;
    this.emit(Transform.Event.DONE);
  },
  hasToSend: function hasToSend(request) {
    return this._sendRequest;
  },
  getState: function getState() {
    if (!this._sendRequest) {
      return this.STATE_OFFLINE;
    }
    if (this._isBusy) {
      return this.STATE_BLOCKED;
    }
    return this.STATE_NO_BLOCKED;
  }
}, {
  STATE_OFFLINE: 2,
  STATE_BLOCKED: 1,
  STATE_NO_BLOCKED: 0,
  Event: {
    DONE: 'done'
  }
});
module.exports = Transform;

/***/ }),

/***/ 97672:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(47865);
__webpack_require__(28610);
__webpack_require__(8612);
var YBRequest = __webpack_require__(41142);
var Transform = __webpack_require__(79877);
var Log = __webpack_require__(60244);
var Util = __webpack_require__(29021);
var Constants = __webpack_require__(47905);
var ViewTransform = Transform.extend({
  constructor: function constructor(plugin, session) {
    Transform.prototype.constructor.apply(this, arguments);
    this.response = {};
    this._viewIndex = new Date().getTime();
    this._session = session;
    this._httpSecure = plugin.options['app.https'];
    this._plugin = plugin;
    this.transformName = 'View';
  },
  init: function init() {
    if (this._plugin.options && this._plugin.options.offline) {
      this.response.host = 'OFFLINE';
      this.response.code = 'OFFLINE';
      this.response.pingTime = 60;
      this.response.beatTime = 60;
      this.done();
      return null;
    }
    if (this._plugin.storage.isEnabled()) {
      var now = new Date().getTime();
      if (now < this._plugin.sessionExpire + (Number(this._plugin.getDataTime()) || 0) && this._plugin.getStoredData()) {
        this.setData(this._plugin.getStoredData());
        return null;
      }
    }
    var service = Constants.Service.DATA;
    var params = {
      outputformat: 'json'
    };
    params = this._plugin.requestBuilder.buildParams(params, service);
    if (params !== null) {
      Log.notice(service + ' ' + params.system);
      if (params.system === 'nicetest') {
        Log.error('No accountCode has been set. Please set your accountCode inside plugin\'s options.');
      }
      new YBRequest(this._plugin.getHost(), service, params).on(YBRequest.Event.SUCCESS, this._receiveData.bind(this)).on(YBRequest.Event.ERROR, this._failedData.bind(this)).send();
    }
  },
  setData: function setData(response) {
    try {
      var resp = JSON.parse(response);
      if (this._plugin.options['parse.fdsResponseHost']) {
        response = response.replace(resp.q.h, this._plugin.options['parse.fdsResponseHost'](resp.q.h));
        resp = JSON.parse(response);
      }
      this.response.msg = response;
      this.response.host = Util.addProtocol(resp.q.h, this._httpSecure);
      this.response.code = resp.q.c;
      this.response.pingTime = resp.q.pt || 5;
      this.response.beatTime = resp.q.i ? resp.q.i.bt || 30 : 30;
      this.response.sessionExpire = resp.q.i ? resp.q.i.exp || 300 : 300;
      this._plugin.storage.setLocal('sessionExpire', this.response.sessionExpire);
      this.done();
    } catch (err) {
      Log.error('Fastdata response is invalid.');
    }
  },
  _receiveData: function _receiveData(req, e) {
    var msg = req.getResponse();
    this.setData(msg);
  },
  _failedData: function _failedData(req, e) {
    Log.error('Fastdata request has failed.');
  },
  nextView: function nextView() {
    this._viewIndex = new Date().getTime();
    return this.getViewCode();
  },
  getViewCode: function getViewCode() {
    return this.response.code + '_' + this._viewIndex;
  },
  getSession: function getSession() {
    return this._session;
  },
  setSession: function setSession(session) {
    this._session = session;
  },
  setHost: function setHost(host) {
    this.response.host = host;
  },
  parse: function parse(request) {
    request.host = request.host || this.response.host;
    request.params.system = this._plugin.getAccountCode();
    request.params.sessionRoot = request.params.sessionRoot || this.getSession();
    if (ViewTransform.EventList.PingTime.indexOf(request.service) !== -1) {
      request.params.pingTime = request.params.pingTime || this.response.pingTime;
    }
    if (ViewTransform.EventList.Infinity.indexOf(request.service) === -1) {
      request.params.code = request.params.code || this.getViewCode();
    } else {
      request.params.sessionId = request.params.sessionRoot;
    }
    if (ViewTransform.EventList.CreateView.indexOf(request.service) !== -1) {
      if (this._plugin.infinity.infinityStarted || this._plugin.storage.isEnabled() && this._plugin.storage.getLocal('infinityStarted')) {
        request.params.parentId = request.params.sessionRoot;
        request.params.navContext = request.params.navContext || this._plugin.getContext();
      }
    }
  }
}, {
  EventList: {
    CreateView: [Constants.Service.START, Constants.Service.INIT, Constants.Service.ERROR],
    Infinity: [Constants.Service.NAV, Constants.Service.SESSION_START, Constants.Service.SESSION_STOP, Constants.Service.EVENT, Constants.Service.BEAT],
    PingTime: [Constants.Service.START, Constants.Service.PING]
  }
});
module.exports = ViewTransform;

/***/ }),

/***/ 78331:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Transform = __webpack_require__(79877);
var WrongTransform = Transform.extend({
  isBlocking: function isBlocking(request) {
    if (!request.params.sessionId) {
      return true;
    }
    return false;
  }
});
module.exports = WrongTransform;

/***/ }),

/***/ 47905:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var AdPosition = __webpack_require__(6174);
var Adapter = __webpack_require__(59881);
var ManifestError = __webpack_require__(26568);
var RequestMethod = __webpack_require__(78856);
var Service = __webpack_require__(53681);
var WillSendEvent = __webpack_require__(5779);
var AdInsertionType = __webpack_require__(35935);
var Constants = {
  AdPosition: AdPosition,
  ManifestError: ManifestError,
  RequestMethod: RequestMethod,
  Service: Service,
  WillSendEvent: WillSendEvent,
  AdInsertionType: AdInsertionType,
  Adapter: Adapter
};
module.exports = Constants;

/***/ }),

/***/ 35935:
/***/ ((module) => {

var InsertionType = {
  ClientSide: 'csai',
  ServerSide: 'ssai'
};
module.exports = InsertionType;

/***/ }),

/***/ 6174:
/***/ ((module) => {

var AdPosition = {
  Preroll: 'pre',
  Midroll: 'mid',
  Postroll: 'post'
};
module.exports = AdPosition;

/***/ }),

/***/ 59881:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Event = __webpack_require__(75489);
var Adapter = {
  Event: Event
};
module.exports = Adapter;

/***/ }),

/***/ 75489:
/***/ ((module) => {

var Event = {
  START: 'start',
  JOIN: 'join',
  PAUSE: 'pause',
  RESUME: 'resume',
  SEEK_BEGIN: 'seek-begin',
  SEEK_END: 'seek-end',
  BUFFER_BEGIN: 'buffer-begin',
  BUFFER_END: 'buffer-end',
  ERROR: 'error',
  STOP: 'stop',
  CLICK: 'click',
  MANIFEST: 'manifest',
  PODSTART: 'break-start',
  PODSTOP: 'break-stop',
  QUARTILE: 'quartile',
  VIDEO_EVENT: 'video-event'
};
module.exports = Event;

/***/ }),

/***/ 26568:
/***/ ((module) => {

var ManifestError = {
  NO_RESPONSE: 'NO_RESPONSE',
  EMPTY: 'EMPTY_RESPONSE',
  WRONG: 'WRONG_RESPONSE'
};
module.exports = ManifestError;

/***/ }),

/***/ 78856:
/***/ ((module) => {

var RequestMethod = {
  GET: 'get',
  POST: 'post'
};
module.exports = RequestMethod;

/***/ }),

/***/ 53681:
/***/ ((module) => {

var Service = {
  DATA: '/data',
  INIT: '/init',
  START: '/start',
  JOIN: '/joinTime',
  PAUSE: '/pause',
  RESUME: '/resume',
  SEEK: '/seek',
  BUFFER: '/bufferUnderrun',
  ERROR: '/error',
  STOP: '/stop',
  PING: '/ping',
  VIDEO_EVENT: '/infinity/video/event',
  AD_INIT: '/adInit',
  AD_START: '/adStart',
  AD_JOIN: '/adJoin',
  AD_PAUSE: '/adPause',
  AD_RESUME: '/adResume',
  AD_BUFFER: '/adBufferUnderrun',
  AD_STOP: '/adStop',
  AD_CLICK: '/adClick',
  AD_ERROR: '/adError',
  AD_MANIFEST: '/adManifest',
  AD_POD_START: '/adBreakStart',
  AD_POD_STOP: '/adBreakStop',
  AD_QUARTILE: '/adQuartile',
  EVENT: '/infinity/session/event',
  SESSION_START: '/infinity/session/start',
  SESSION_STOP: '/infinity/session/stop',
  NAV: '/infinity/session/nav',
  BEAT: '/infinity/session/beat',
  OFFLINE_EVENTS: '/offlineEvents'
};
module.exports = Service;

/***/ }),

/***/ 96308:
/***/ ((module) => {

var StreamingProtocol = {
  HDS: 'HDS',
  HLS: 'HLS',
  MSS: 'MSS',
  DASH: 'DASH',
  RTMP: 'RTMP',
  RTP: 'RTP',
  RTSP: 'RTSP',
  DVB: 'DVB',
  MULTICAST: 'MULTICAST'
};
module.exports = StreamingProtocol;

/***/ }),

/***/ 63642:
/***/ ((module) => {

var TransportFormat = {
  MP4: 'MP4',
  MPEG2: 'TS',
  CMF: 'CMF'
};
module.exports = TransportFormat;

/***/ }),

/***/ 5779:
/***/ ((module) => {

var WillSendEvent = {
  WILL_SEND_INIT: 'will-send-init',
  WILL_SEND_START: 'will-send-start',
  WILL_SEND_JOIN: 'will-send-join',
  WILL_SEND_PAUSE: 'will-send-pause',
  WILL_SEND_RESUME: 'will-send-resume',
  WILL_SEND_SEEK: 'will-send-seek',
  WILL_SEND_BUFFER: 'will-send-buffer',
  WILL_SEND_ERROR: 'will-send-error',
  WILL_SEND_FATAL_ERROR: 'will-send-fatal-error',
  WILL_SEND_STOP: 'will-send-stop',
  WILL_SEND_PING: 'will-send-ping',
  WILL_SEND_VIDEO_EVENT: 'will-send-video-event',
  WILL_SEND_AD_START: 'will-send-ad-start',
  WILL_SEND_AD_JOIN: 'will-send-ad-join',
  WILL_SEND_AD_PAUSE: 'will-send-ad-pause',
  WILL_SEND_AD_RESUME: 'will-send-ad-resume',
  WILL_SEND_AD_BUFFER: 'will-send-ad-buffer',
  WILL_SEND_AD_STOP: 'will-send-ad-stop',
  WILL_SEND_AD_CLICK: 'will-send-ad-click',
  WILL_SEND_AD_ERROR: 'will-send-ad-error',
  WILL_SEND_AD_MANIFEST: 'will-send-ad-manifest',
  WILL_SEND_AD_POD_START: 'will-send-ad-break-start',
  WILL_SEND_AD_POD_STOP: 'will-send-ad-break-stop',
  WILL_SEND_AD_QUARTILE: 'will-send-ad-quartile',
  WILL_SEND_SESSION_START: 'will-send-session-start',
  WILL_SEND_SESSION_STOP: 'will-send-session-stop',
  WILL_SEND_NAV: 'will-send-nav',
  WILL_SEND_BEAT: 'will-send-beat',
  WILL_SEND_EVENT: 'will-send-event',
  WILL_SEND_OFFLINE_EVENTS: 'will-send-offline-events'
};
module.exports = WillSendEvent;

/***/ }),

/***/ 60337:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var YouboraObject = __webpack_require__(14074);
var BackgroundDetector = YouboraObject.extend({
  constructor: function constructor(plugin) {
    this.plugin = plugin;
    this.isInBackground = false;
    this.listenerReference = this._visibilityListener.bind(this);
    this._reset();
  },
  startDetection: function startDetection() {
    if (!this.isBackgroundDetectorStarted && typeof document !== 'undefined') {
      this.isBackgroundDetectorStarted = true;
      document.addEventListener('visibilitychange', this.listenerReference);
    }
  },
  stopDetection: function stopDetection() {
    if (this.isBackgroundDetectorStarted && typeof document !== 'undefined') {
      document.removeEventListener('visibilitychange', this.listenerReference);
      this._reset();
    }
  },
  _reset: function _reset() {
    this.isBackgroundDetectorStarted = false;
  },
  _visibilityListener: function _visibilityListener(e) {
    if (typeof document !== 'undefined') {
      var settings = this._getSettings();
      if (document.visibilityState === 'hidden') {
        this._toBackground(settings);
      } else if (document.visibilityState === 'visible') {
        this._toForeground(settings);
      }
    }
  },
  _toBackground: function _toBackground(settings) {
    this.isInBackground = true;
    if (this.plugin && this.plugin._adsAdapter) {
      this.plugin._adsAdapter.stopChronoView();
    }
    if (typeof settings === 'string') {
      switch (settings) {
        case 'stop':
          this._fireStop();
          break;
        case 'pause':
          this._firePause();
          break;
      }
      if (this.plugin.infinity.infinityStarted) {
        this.lastBeatTime = new Date().getTime();
        var difftime = this.plugin._beat.chrono.startTime ? this.lastBeatTime - this.plugin._beat.chrono.startTime : 0;
        this.plugin._sendBeat(difftime);
        this.plugin._beat.stop();
      }
    }
  },
  _toForeground: function _toForeground(settings) {
    this.isInBackground = false;
    if (this.plugin && this.plugin._adsAdapter) {
      this.plugin._adsAdapter.startChronoView();
    }
    if (typeof settings === 'string' && settings) {
      if (this.plugin.infinity.infinityStarted) {
        var now = new Date().getTime();
        if (now - this.lastBeatTime < this.plugin.sessionExpire) {
          this.plugin._sendBeat(now - this.lastBeatTime);
          this.plugin._beat.start();
        } else {
          this.plugin.infinity.newSession();
        }
      }
    }
  },
  _getSettings: function _getSettings() {
    if (typeof this.plugin.options['background.settings'] === 'string' && this.plugin.options['background.settings']) {
      return this.plugin.options['background.settings'];
    }
    if (this.plugin.deviceDetector.isSmartTV()) {
      return this.plugin.options['background.settings.tv'];
    }
    if (this.plugin.deviceDetector.isDesktop()) {
      return this.plugin.options['background.settings.desktop'];
    }
    if (this.plugin.deviceDetector.isAndroid()) {
      return this.plugin.options['background.settings.android'];
    }
    if (this.plugin.deviceDetector.isIphone()) {
      return this.plugin.options['background.settings.iOS'];
    }
    if (this.plugin.deviceDetector.isPlayStation()) {
      return this.plugin.options['background.settings.playstation'];
    }
  },
  _firePause: function _firePause() {
    this._fireX('firePause');
  },
  _fireStop: function _fireStop() {
    this._fireX('fireStop');
    this.plugin.fireStop();
  },
  _fireX: function _fireX(fireMethod) {
    this.adsAdapter = this.plugin.getAdsAdapter();
    if (this.adsAdapter) {
      this.adsAdapter[fireMethod]();
    }
    this.contentAdapter = this.plugin.getAdapter();
    if (this.contentAdapter) {
      this.contentAdapter[fireMethod]();
    }
  },
  canBlockStartCalls: function canBlockStartCalls() {
    return this.isInBackground && this.plugin.options['background.enabled'] === true && this._getSettings();
  }
});
module.exports = BackgroundDetector;

/***/ }),

/***/ 38803:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(28610);
__webpack_require__(49747);
var YouboraObject = __webpack_require__(14074);
var DeviceDetector = YouboraObject.extend({
  constructor: function constructor() {
    if (typeof navigator !== 'undefined' && navigator.userAgent) {
      this._isSmartTVDevice = navigator.userAgent.toLowerCase().match(/smarttv/) || navigator.userAgent.toLowerCase().match(/smart-tv/) || navigator.userAgent.toLowerCase().match(/appletv/) || navigator.userAgent.toLowerCase().match(/apple tv/);
      this._isPlaystationDevice = navigator.userAgent.match(/PlayStation/) !== null;
      this._isIphoneDevice = navigator.userAgent.match(/iPhone|iPad|iPod/i) !== null;
      this._isAndroidDevice = navigator.userAgent.match(/Android/) !== null;
      this._isSmartphoneDevice = !this._isSmartTVDevice && !this._isPlaystationDevice && (this._isIphoneDevice || this._isAndroidDevice);
      this._isDesktopDevice = !this._isSmartphoneDevice && !this._isSmartTVDevice && !this._isPlaystationDevice;
    }
  },
  isIphone: function isIphone() {
    return this._isIphoneDevice;
  },
  isAndroid: function isAndroid() {
    return this._isAndroidDevice;
  },
  isSmartphone: function isSmartphone() {
    return this._isSmartphoneDevice;
  },
  isDesktop: function isDesktop() {
    return this._isDesktopDevice;
  },
  isSmartTV: function isSmartTV() {
    return this._isSmartTVDevice;
  },
  isPlayStation: function isPlayStation() {
    return this._isPlaystationDevice;
  }
});
module.exports = DeviceDetector;

/***/ }),

/***/ 59406:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(74391);
__webpack_require__(38051);
var YouboraObject = __webpack_require__(14074);
var ResizeScrollDetector = YouboraObject.extend({
  constructor: function constructor(plugin) {
    this.pluginref = plugin;
    this.listenerReference = this._changeListener.bind(this);
    this.loadReference = this._loadListener.bind(this);
    this.isEnabled = false;
    this.pageHeight = 0;
    this.maxHeight = 0;
    this.startDetection();
  },
  startDetection: function startDetection() {
    if (!this.isEnabled && typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
      window.addEventListener('scroll', this.listenerReference);
      window.addEventListener('resize', this.listenerReference);
      window.addEventListener('load', this.loadReference);
      this.isEnabled = true;
    }
  },
  stopDetection: function stopDetection() {
    if (this.isEnabled && typeof window !== 'undefined' && typeof window.removeEventListener === 'function') {
      window.removeEventListener('scroll', this.listenerReference);
      window.removeEventListener('resize', this.listenerReference);
      window.removeEventListener('load', this.loadReference);
      this.isEnabled = false;
    }
  },
  getScrollDepth: function getScrollDepth() {
    var ret = null;
    if (this.maxHeight && this.pageHeight) {
      ret = Math.min(Math.trunc(this.maxHeight / this.pageHeight * 100), 100);
    }
    return ret;
  },
  _loadListener: function _loadListener() {
    if (typeof document !== 'undefined') {
      var docEl = document.documentElement;
      if (docEl) {
        this.pageHeight = Math.round(docEl.scrollHeight, docEl.clientHeight, docEl.offsetHeight);
        this.maxHeight = window.innerHeight;
        this._updateCompletionRate();
      }
    }
  },
  _changeListener: function _changeListener() {
    if (this.pageHeight) {
      var prevHeight = this.maxHeight;
      this.maxHeight = Math.max(this.maxHeight, window.pageYOffset + window.innerHeight);
      if (prevHeight !== this.maxHeight) {
        this._updateCompletionRate();
      }
    }
    var adsAdapter = this.pluginref.getAdsAdapter();
    if (adsAdapter && adsAdapter.flags.isStarted) {
      if (!adsAdapter.getIsVisible()) {
        adsAdapter.stopChronoView();
      } else {
        adsAdapter.startChronoView();
      }
    }
  },
  _updateCompletionRate: function _updateCompletionRate() {
    setTimeout(function () {
      this.pluginref.storage.setSession('pageScrollDepth', this.getScrollDepth());
    }.bind(this), 3000);
  }
});
module.exports = ResizeScrollDetector;

/***/ }),

/***/ 67671:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(52318);
__webpack_require__(11256);
__webpack_require__(77402);
__webpack_require__(67478);
__webpack_require__(50851);
var _typeof = __webpack_require__(45129);
var YouboraObject = __webpack_require__(14074);
var DataExtractor = YouboraObject.extend({
  constructor: function constructor(plugin) {
    this.plugin = plugin;
  },
  getAllData: function getAllData() {
    var returnValue = this.getNonRandomData();
    returnValue.timestamp = this.getTimestamp();
    return returnValue;
  },
  getNonRandomData: function getNonRandomData() {
    var returnValue = {};
    returnValue.userAgent = this.getUserAgent();
    returnValue.threads = this.getVirtualCores();
    returnValue.language = this.getLanguage();
    returnValue.langList = this.getAvailableLanguages();
    returnValue.resolution = this.getResolution();
    returnValue.colorDepth = this.getColorDepth();
    returnValue.deviceMemory = this.getMemory();
    returnValue.touchscreen = this.getTouchscreen();
    returnValue.localStorage = this.getLocalStorage();
    returnValue.sessionStorage = this.getSessionStorage();
    returnValue.cookiesAvailable = this.getCookiesAvailable();
    returnValue.flashAvailable = this.getHasFlash();
    returnValue.timeZone = this.getTimeZone();
    returnValue.plugins = this.getPluginList();
    return returnValue;
  },
  getUserAgent: function getUserAgent() {
    return this._getNavigatorValue('userAgent');
  },
  getVirtualCores: function getVirtualCores() {
    return this._getNavigatorValue('hardwareConcurrency');
  },
  getLanguage: function getLanguage() {
    return this._getNavigatorValue('language');
  },
  getAvailableLanguages: function getAvailableLanguages() {
    return this._getNavigatorValue('languages');
  },
  getResolution: function getResolution() {
    var ret = null;
    try {
      if (this._getNavigatorValue('screen')) {
        ret = navigator.screen.width.toString() + navigator.screen.height.toString();
      }
    } catch (err) {}
    return ret;
  },
  getColorDepth: function getColorDepth() {
    var ret = null;
    try {
      if (this._getNavigatorValue('screen')) {
        ret = navigator.screen.colorDepth;
      }
    } catch (err) {}
    return ret;
  },
  getMemory: function getMemory() {
    return this._getNavigatorValue('deviceMemory');
  },
  getTouchscreen: function getTouchscreen() {
    return this._getNavigatorValue('maxTouchPoints') || false;
  },
  getLocalStorage: function getLocalStorage() {
    var ret = false;
    try {
      ret = typeof localStorage !== 'undefined';
    } catch (err) {}
    return ret;
  },
  getSessionStorage: function getSessionStorage() {
    var ret = false;
    try {
      ret = typeof sessionStorage !== 'undefined';
    } catch (err) {}
    return ret;
  },
  getCookiesAvailable: function getCookiesAvailable() {
    return this._getNavigatorValue('cookieEnabled') || false;
  },
  getHasFlash: function getHasFlash() {
    var ret = false;
    try {
      var plugins = this._getNavigatorValue('plugins');
      ret = plugins && _typeof(plugins['Shockwave Flash']) === 'object' || typeof window !== 'undefined' && window.ActiveXObject && new ActiveXObject('ShockwaveFlash.ShockwaveFlash') !== false;
    } catch (err) {}
    return ret;
  },
  getPluginList: function getPluginList() {
    var ret = null;
    try {
      var plugins = this._getNavigatorValue('plugins');
      if (plugins && plugins.length !== 0) {
        var pluginlist = '';
        for (var counter = 0; counter < navigator.plugins.length; counter++) {
          pluginlist += navigator.plugins[counter].description + ' ' + navigator.plugins[counter].filename + ' ' + navigator.plugins[counter].name + ' ';
        }
        ret = pluginlist;
      }
    } catch (err) {}
    return ret;
  },
  getTimeZone: function getTimeZone() {
    var ret = null;
    try {
      var date = new Date();
      ret = date.getTimezoneOffset().toString();
    } catch (err) {}
    return ret;
  },
  getTimestamp: function getTimestamp() {
    return new Date().getTime();
  },
  _navigatorCheck: function _navigatorCheck() {
    return typeof navigator !== 'undefined';
  },
  _getNavigatorValue: function _getNavigatorValue(key) {
    var ret = null;
    try {
      if (this._navigatorCheck()) {
        ret = navigator[key];
      }
    } catch (err) {}
    return ret;
  }
});
module.exports = DataExtractor;

/***/ }),

/***/ 43582:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var DataExtractor = __webpack_require__(67671);
var YouboraObject = __webpack_require__(14074);
var MD5 = __webpack_require__(36952);
var HashGenerator = YouboraObject.extend({
  constructor: function constructor(plugin) {
    this.plugin = plugin;
    this.dataExtractor = new DataExtractor();
    this.key = this.getPreviousKey();
  },
  generateHashKey: function generateHashKey() {
    if (!this.key) {
      var data = this.dataExtractor.getAllData();
      this.key = this._hashFunction(data);
      this.plugin.storage.setLocal('youboraDeviceUUID', this.key);
    }
  },
  getKey: function getKey() {
    if (!this.key) this.generateHashKey();
    return this.key;
  },
  _hashFunction: function _hashFunction(inputString) {
    var outputString = inputString;
    if (typeof inputString !== 'string') {
      outputString = JSON.stringify(inputString);
    }
    return MD5(outputString);
  },
  _reset: function _reset() {
    this.key = undefined;
  },
  getPreviousKey: function getPreviousKey() {
    return this.plugin.storage.getLocal('youboraDeviceUUID');
  }
});
module.exports = HashGenerator;

/***/ }),

/***/ 36952:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(67478);
__webpack_require__(28610);
__webpack_require__(50851);
__webpack_require__(8612);
var MD5 = function MD5(s) {
  function L(k, d) {
    return k << d | k >>> 32 - d;
  }
  function K(G, k) {
    var I, d, F, H, x;
    F = G & 2147483648;
    H = k & 2147483648;
    I = G & 1073741824;
    d = k & 1073741824;
    x = (G & 1073741823) + (k & 1073741823);
    if (I & d) {
      return x ^ 2147483648 ^ F ^ H;
    }
    if (I | d) {
      if (x & 1073741824) {
        return x ^ 3221225472 ^ F ^ H;
      } else {
        return x ^ 1073741824 ^ F ^ H;
      }
    } else {
      return x ^ F ^ H;
    }
  }
  function r(d, F, k) {
    return d & F | ~d & k;
  }
  function q(d, F, k) {
    return d & k | F & ~k;
  }
  function p(d, F, k) {
    return d ^ F ^ k;
  }
  function n(d, F, k) {
    return F ^ (d | ~k);
  }
  function u(G, F, aa, Z, k, H, I) {
    G = K(G, K(K(r(F, aa, Z), k), I));
    return K(L(G, H), F);
  }
  function f(G, F, aa, Z, k, H, I) {
    G = K(G, K(K(q(F, aa, Z), k), I));
    return K(L(G, H), F);
  }
  function D(G, F, aa, Z, k, H, I) {
    G = K(G, K(K(p(F, aa, Z), k), I));
    return K(L(G, H), F);
  }
  function t(G, F, aa, Z, k, H, I) {
    G = K(G, K(K(n(F, aa, Z), k), I));
    return K(L(G, H), F);
  }
  function e(G) {
    var Z;
    var F = G.length;
    var x = F + 8;
    var k = (x - x % 64) / 64;
    var I = (k + 1) * 16;
    var aa = Array(I - 1);
    var d = 0;
    var H = 0;
    while (H < F) {
      Z = (H - H % 4) / 4;
      d = H % 4 * 8;
      aa[Z] = aa[Z] | G.charCodeAt(H) << d;
      H++;
    }
    Z = (H - H % 4) / 4;
    d = H % 4 * 8;
    aa[Z] = aa[Z] | 128 << d;
    aa[I - 2] = F << 3;
    aa[I - 1] = F >>> 29;
    return aa;
  }
  function B(x) {
    var k = "",
      F = "",
      G,
      d;
    for (d = 0; d <= 3; d++) {
      G = x >>> d * 8 & 255;
      F = "0" + G.toString(16);
      k = k + F.substr(F.length - 2, 2);
    }
    return k;
  }
  function J(k) {
    k = k.replace(/rn/g, "n");
    var d = "";
    for (var F = 0; F < k.length; F++) {
      var x = k.charCodeAt(F);
      if (x < 128) {
        d += String.fromCharCode(x);
      } else {
        if (x > 127 && x < 2048) {
          d += String.fromCharCode(x >> 6 | 192);
          d += String.fromCharCode(x & 63 | 128);
        } else {
          d += String.fromCharCode(x >> 12 | 224);
          d += String.fromCharCode(x >> 6 & 63 | 128);
          d += String.fromCharCode(x & 63 | 128);
        }
      }
    }
    return d;
  }
  var C = Array();
  var P, h, E, v, g, Y, X, W, V;
  var S = 7,
    Q = 12,
    N = 17,
    M = 22;
  var A = 5,
    z = 9,
    y = 14,
    w = 20;
  var o = 4,
    m = 11,
    l = 16,
    j = 23;
  var U = 6,
    T = 10,
    R = 15,
    O = 21;
  s = J(s);
  C = e(s);
  Y = 1732584193;
  X = 4023233417;
  W = 2562383102;
  V = 271733878;
  for (P = 0; P < C.length; P += 16) {
    h = Y;
    E = X;
    v = W;
    g = V;
    Y = u(Y, X, W, V, C[P + 0], S, 3614090360);
    V = u(V, Y, X, W, C[P + 1], Q, 3905402710);
    W = u(W, V, Y, X, C[P + 2], N, 606105819);
    X = u(X, W, V, Y, C[P + 3], M, 3250441966);
    Y = u(Y, X, W, V, C[P + 4], S, 4118548399);
    V = u(V, Y, X, W, C[P + 5], Q, 1200080426);
    W = u(W, V, Y, X, C[P + 6], N, 2821735955);
    X = u(X, W, V, Y, C[P + 7], M, 4249261313);
    Y = u(Y, X, W, V, C[P + 8], S, 1770035416);
    V = u(V, Y, X, W, C[P + 9], Q, 2336552879);
    W = u(W, V, Y, X, C[P + 10], N, 4294925233);
    X = u(X, W, V, Y, C[P + 11], M, 2304563134);
    Y = u(Y, X, W, V, C[P + 12], S, 1804603682);
    V = u(V, Y, X, W, C[P + 13], Q, 4254626195);
    W = u(W, V, Y, X, C[P + 14], N, 2792965006);
    X = u(X, W, V, Y, C[P + 15], M, 1236535329);
    Y = f(Y, X, W, V, C[P + 1], A, 4129170786);
    V = f(V, Y, X, W, C[P + 6], z, 3225465664);
    W = f(W, V, Y, X, C[P + 11], y, 643717713);
    X = f(X, W, V, Y, C[P + 0], w, 3921069994);
    Y = f(Y, X, W, V, C[P + 5], A, 3593408605);
    V = f(V, Y, X, W, C[P + 10], z, 38016083);
    W = f(W, V, Y, X, C[P + 15], y, 3634488961);
    X = f(X, W, V, Y, C[P + 4], w, 3889429448);
    Y = f(Y, X, W, V, C[P + 9], A, 568446438);
    V = f(V, Y, X, W, C[P + 14], z, 3275163606);
    W = f(W, V, Y, X, C[P + 3], y, 4107603335);
    X = f(X, W, V, Y, C[P + 8], w, 1163531501);
    Y = f(Y, X, W, V, C[P + 13], A, 2850285829);
    V = f(V, Y, X, W, C[P + 2], z, 4243563512);
    W = f(W, V, Y, X, C[P + 7], y, 1735328473);
    X = f(X, W, V, Y, C[P + 12], w, 2368359562);
    Y = D(Y, X, W, V, C[P + 5], o, 4294588738);
    V = D(V, Y, X, W, C[P + 8], m, 2272392833);
    W = D(W, V, Y, X, C[P + 11], l, 1839030562);
    X = D(X, W, V, Y, C[P + 14], j, 4259657740);
    Y = D(Y, X, W, V, C[P + 1], o, 2763975236);
    V = D(V, Y, X, W, C[P + 4], m, 1272893353);
    W = D(W, V, Y, X, C[P + 7], l, 4139469664);
    X = D(X, W, V, Y, C[P + 10], j, 3200236656);
    Y = D(Y, X, W, V, C[P + 13], o, 681279174);
    V = D(V, Y, X, W, C[P + 0], m, 3936430074);
    W = D(W, V, Y, X, C[P + 3], l, 3572445317);
    X = D(X, W, V, Y, C[P + 6], j, 76029189);
    Y = D(Y, X, W, V, C[P + 9], o, 3654602809);
    V = D(V, Y, X, W, C[P + 12], m, 3873151461);
    W = D(W, V, Y, X, C[P + 15], l, 530742520);
    X = D(X, W, V, Y, C[P + 2], j, 3299628645);
    Y = t(Y, X, W, V, C[P + 0], U, 4096336452);
    V = t(V, Y, X, W, C[P + 7], T, 1126891415);
    W = t(W, V, Y, X, C[P + 14], R, 2878612391);
    X = t(X, W, V, Y, C[P + 5], O, 4237533241);
    Y = t(Y, X, W, V, C[P + 12], U, 1700485571);
    V = t(V, Y, X, W, C[P + 3], T, 2399980690);
    W = t(W, V, Y, X, C[P + 10], R, 4293915773);
    X = t(X, W, V, Y, C[P + 1], O, 2240044497);
    Y = t(Y, X, W, V, C[P + 8], U, 1873313359);
    V = t(V, Y, X, W, C[P + 15], T, 4264355552);
    W = t(W, V, Y, X, C[P + 6], R, 2734768916);
    X = t(X, W, V, Y, C[P + 13], O, 1309151649);
    Y = t(Y, X, W, V, C[P + 4], U, 4149444226);
    V = t(V, Y, X, W, C[P + 11], T, 3174756917);
    W = t(W, V, Y, X, C[P + 2], R, 718787259);
    X = t(X, W, V, Y, C[P + 9], O, 3951481745);
    Y = K(Y, h);
    X = K(X, E);
    W = K(W, v);
    V = K(V, g);
  }
  var i = B(Y) + B(X) + B(W) + B(V);
  return i.toLowerCase();
};
module.exports = MD5;

/***/ }),

/***/ 51973:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(72578);
__webpack_require__(90565);
var YouboraObject = __webpack_require__(14074);
var isArray = __webpack_require__(46821);
var Emitter = YouboraObject.extend({
  on: function on(event, callback) {
    this._listeners = this._listeners || {};
    if (typeof callback === 'function') {
      this._listeners[event] = this._listeners[event] || [];
      this._listeners[event].push(callback);
      return this;
    }
  },
  off: function off(event, callback) {
    this._listeners = this._listeners || {};
    if (this._listeners[event]) {
      var index = this._listeners[event].indexOf(callback);
      if (index !== -1) {
        this._listeners[event].splice(index, 1);
      }
    }
    return this;
  },
  emit: function emit(event, data) {
    this._listeners = this._listeners || {};
    data = data || {};
    if (isArray(this._listeners[event])) {
      this._listeners[event].forEach(this._eachCallback.bind(this, event, data));
    }
    if (isArray(this._listeners['*'])) {
      this._listeners['*'].forEach(this._eachCallback.bind(this, event, data));
    }
    return this;
  },
  _eachCallback: function _eachCallback(event, data, callback) {
    if (typeof callback === 'function') {
      var callbackArguments = {
        type: event,
        data: data,
        target: this
      };
      callback(callbackArguments);
    }
  }
});
module.exports = Emitter;

/***/ }),

/***/ 82063:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(26677);
__webpack_require__(77402);
__webpack_require__(47865);
__webpack_require__(67478);
__webpack_require__(65000);
var Emitter = __webpack_require__(51973);
var Comm = __webpack_require__(60502);
var WrongTransform = __webpack_require__(78331);
var Util = __webpack_require__(29021);
var YouboraInfinity = Emitter.extend({
  constructor: function constructor(plugin) {
    this._plugin = plugin;
    this.infinityStopped = false;
    this.infinityStarted = false;
  },
  andBeyond: function andBeyond() {
    YouboraInfinity.prototype.begin.apply(this, arguments);
  },
  begin: function begin(dimensions, forceNewSession) {
    forceNewSession = forceNewSession || false;
    if (forceNewSession) {
      this._plugin.storage.removeStorages('infinityStarted');
      this._plugin.storage.removeStorages('data');
      this._plugin.restartViewTransform();
    }
    this._comm = new Comm(this._plugin);
    this._comm.addTransform(this._plugin.viewTransform);
    this._comm.addTransform(new WrongTransform(this._plugin));
    if (this._plugin && this._plugin.storage && typeof this._plugin.storage.getLocal === 'function') {
      this._registeredProperties = this._plugin.storage.getLocal('inifnityRegisteredProperties');
    }
    this.fireSessionStart(dimensions);
  },
  _setLastActive: function _setLastActive() {
    if (!this._firstActive) {
      this._firstActive = this.getFirstActive();
    }
    this._plugin.storage.setStorages('lastactive', new Date().getTime());
  },
  getFirstActive: function getFirstActive() {
    return Number(this._plugin.getLastActive()) || 0;
  },
  getComm: function getComm() {
    return this._comm;
  },
  fireSessionStart: function fireSessionStart(dimensions) {
    if (this.infinityStopped) {
      this._plugin.restartViewTransform();
      this._comm = new Comm(this._plugin);
      this._comm.addTransform(this._plugin.viewTransform);
      this._comm.addTransform(new WrongTransform(this._plugin));
      this.infinityStopped = false;
    }
    if (!this.infinityStarted) {
      this._plugin.storage.setLocal('infinityStarted', 'true');
      this.infinityStarted = true;
      this.emit(YouboraInfinity.Event.SESSION_START, this._getParamsJson(dimensions, null, null, true, true));
      this._setLastActive();
    }
  },
  fireSessionStop: function fireSessionStop(params) {
    if (this.infinityStarted) {
      this.infinityStopped = true;
      this.infinityStarted = false;
      this._plugin.storage.removeStorages('infinityStarted');
      this.emit(YouboraInfinity.Event.SESSION_STOP, params);
      this._plugin.storage.removeStorages('data');
      this._plugin.storage.removeStorages('session');
      this._plugin.storage.removeStorages('lastactive');
    }
  },
  newSession: function newSession(options, params) {
    if (this.isActive()) {
      if (this.infinityStarted) {
        this.fireSessionStop();
      } else {
        this._plugin.storage.removeStorages('infinityStarted');
        this._plugin.storage.removeStorages('data');
        if (this._comm) this._comm.removeTransform(this._plugin.viewTransform);
        this._plugin.restartViewTransform();
        if (this._comm) this._comm.addTransform(this._plugin.viewTransform);
      }
    }
    this._plugin.setOptions(options);
    this.begin(params);
  },
  fireNav: function fireNav(dimensions) {
    if (this.isActive()) {
      this.infinityStarted = true;
      this.emit(YouboraInfinity.Event.NAV, this._getParamsJson(dimensions, null, null, true));
    }
  },
  _sendExtraBeat: function _sendExtraBeat() {
    if (this._plugin && this._plugin._beat) {
      var now = new Date().getTime();
      var time = this._plugin._beat.chrono.startTime ? now - this._plugin._beat.chrono.startTime : 0;
      this._plugin._sendBeat(time);
      this._plugin._beat.chrono.startTime = now;
    }
    this._setLastActive();
  },
  fireEvent: function fireEvent(eventName, dimensions, values, topLevelDimensions) {
    if (this.infinityStarted) {
      var builtParams = this._getParamsJson(dimensions, values, eventName);
      Util.assign(builtParams.params, topLevelDimensions || {});
      this.emit(YouboraInfinity.Event.EVENT, builtParams);
      this._setLastActive();
    }
  },
  register: function register(dimensions, values) {
    this._registeredProperties = {
      dimensions: dimensions,
      values: values
    };
    this._plugin.storage.setLocal('inifnityRegisteredProperties', JSON.stringify(this._registeredProperties));
  },
  registerOnce: function registerOnce(dimensions, values) {
    if (!this._registeredProperties) {
      this.register(dimensions, values);
    }
  },
  unregister: function unregister() {
    this._registeredProperties = null;
    this._plugin.storage.removeLocal('inifnityRegisteredProperties');
  },
  _getParamsJson: function _getParamsJson(dimensions, values, eventName, isNavigaton, isStart) {
    var returnparams = {};
    if (eventName) returnparams.name = eventName;
    returnparams.dimensions = dimensions || {};
    returnparams.values = values || {};
    if (this._registeredProperties) {
      for (var key in this._registeredProperties.dimensions) {
        returnparams.dimensions[key] = this._registeredProperties.dimensions[key];
      }
      for (var key2 in this._registeredProperties.values) {
        returnparams.values[key2] = this._registeredProperties.values[key2];
      }
    }
    var paramsObject = {
      params: returnparams
    };
    if (isNavigaton) {
      if (paramsObject.params.dimensions.page) {
        paramsObject.params.page = paramsObject.params.dimensions.page;
        delete paramsObject.params.dimensions.page;
      }
      if (paramsObject.params.dimensions.route) {
        paramsObject.params.route = paramsObject.params.dimensions.route;
        delete paramsObject.params.dimensions.route;
      }
      if (!isStart) {
        delete paramsObject.params.dimensions;
      }
      delete paramsObject.params.values;
    }
    return paramsObject;
  },
  isActive: function isActive() {
    var started = this._plugin.storage.getLocal('infinityStarted');
    if (this.infinityStarted || started && started !== 'false') {
      return true;
    }
    var now = new Date().getTime();
    if (Number(this._plugin.getLastActive()) + this._plugin.sessionExpire > now) {
      return true;
    }
    return false;
  }
}, {
  Event: {
    NAV: 'nav',
    SESSION_START: 'sessionStart',
    SESSION_STOP: 'sessionStop',
    BEAT: 'beat',
    EVENT: 'event'
  }
});
module.exports = YouboraInfinity;

/***/ }),

/***/ 60244:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(97343);
__webpack_require__(72578);
__webpack_require__(28610);
__webpack_require__(6938);
var Emitter = __webpack_require__(51973);
var isArray = __webpack_require__(46821);
var Log = {
  _emitter: new Emitter(),
  on: function on() {
    Log._emitter.on.apply(Log._emitter, arguments);
  },
  off: function off() {
    Log._emitter.off.apply(Log._emitter, arguments);
  },
  emit: function emit() {
    Log._emitter.emit.apply(Log._emitter, arguments);
  },
  Level: {
    SILENT: 6,
    ERROR: 5,
    WARNING: 4,
    NOTICE: 3,
    DEBUG: 2,
    VERBOSE: 1
  },
  Event: {
    LOG: 'log'
  },
  logLevel: 5,
  plainLogs: false,
  report: function report(msg, level, color) {
    if (typeof console !== 'undefined' && console.log && typeof document !== 'undefined') {
      level = level || Log.Level.NOTICE;
      color = color || 'darkcyan';
      var letters = {
        5: 'e',
        4: 'w',
        3: 'n',
        2: 'd',
        1: 'v'
      };
      var letter = letters[level];
      var prefix = '[Youbora]' + Log._getCurrentTime() + ' ' + letter + ':';
      this.emit('log', {
        level: level,
        msg: msg,
        prefix: prefix
      });
      if (Log.logLevel <= level) {
        if (Log.plainLogs || document.documentMode) {
          Log._plainReport(msg, prefix);
        } else {
          var logMethod;
          if (level === Log.Level.ERROR && console.error) {
            logMethod = console.error;
          } else if (level === Log.Level.WARNING && console.warn) {
            logMethod = console.warn;
          } else if (level === Log.Level.DEBUG && console.debug) {
            logMethod = console.debug;
          } else {
            logMethod = console.log;
          }
          prefix = '%c' + prefix;
          if (isArray(msg)) {
            msg.splice(0, 0, prefix, 'color: ' + color);
            logMethod.apply(console, msg);
          } else {
            logMethod.call(console, prefix, 'color: ' + color, msg);
          }
        }
      }
    }
  },
  _getCurrentTime: function _getCurrentTime() {
    var d = new Date();
    var hh = ('0' + d.getDate()).slice(-2);
    var mm = ('0' + d.getMinutes()).slice(-2);
    var ss = ('0' + d.getSeconds()).slice(-2);
    var mmm = ('00' + d.getMilliseconds()).slice(-3);
    return '[' + hh + ':' + mm + ':' + ss + '.' + mmm + ']';
  },
  _plainReport: function _plainReport(msg, prefix) {
    if (msg instanceof Array) {
      for (var m in msg) {
        Log._plainReport(msg[m], prefix);
      }
    } else {
      if (typeof msg === 'string') {
        console.log(prefix + ' ' + msg);
      } else {
        console.log(prefix + ' <next line>');
        console.log(msg);
      }
    }
  },
  error: function error() {
    Log.report([].slice.call(arguments), Log.Level.ERROR, 'darkred');
  },
  warn: function warn() {
    Log.report([].slice.call(arguments), Log.Level.WARNING, 'darkorange');
  },
  notice: function notice() {
    Log.report([].slice.call(arguments), Log.Level.NOTICE, 'darkgreen');
  },
  debug: function debug() {
    Log.report([].slice.call(arguments), Log.Level.DEBUG, 'indigo');
  },
  verbose: function verbose() {
    Log.report([].slice.call(arguments), Log.Level.VERBOSE, 'navy');
  },
  loadLevelFromUrl: function loadLevelFromUrl() {
    if (typeof window !== 'undefined' && window.location) {
      this._parseLevelFromUrl(window.location.search);
    }
  },
  _parseLevelFromUrl: function _parseLevelFromUrl(url) {
    if (url) {
      var m = /\?.*&*youbora-debug=(.+)/i.exec(url);
      if (m !== null) {
        Log.logLevel = m[1];
      }
      var m2 = /\?.*&*youbora-debug=plain/i.exec(url);
      if (m2 !== null) {
        Log.plainLogs = true;
      }
    }
  }
};
module.exports = Log;

/***/ }),

/***/ 34027:
/***/ ((module) => {

module.exports = function (target) {
  if (target === undefined || target === null) {
    throw new TypeError('Cannot convert undefined or null to object');
  }
  var output = Object(target);
  for (var index = 1; index < arguments.length; index++) {
    var source = arguments[index];
    if (source !== undefined && source !== null) {
      for (var nextKey in source) {
        if (source.hasOwnProperty(nextKey)) {
          output[nextKey] = source[nextKey];
        }
      }
    }
  }
  return output;
};

/***/ }),

/***/ 75814:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _typeof = __webpack_require__(45129);
var F = function F() {};
module.exports = function (o) {
  if (arguments.length > 1) {
    throw Error('Second argument not supported');
  }
  if (o === null) {
    throw Error('Cannot set a null [[Prototype]]');
  }
  if (_typeof(o) !== 'object') {
    throw TypeError('Argument must be an object');
  }
  F.prototype = o;
  return new F();
};

/***/ }),

/***/ 46821:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(67478);
__webpack_require__(50851);
module.exports = function (obj) {
  return Object.prototype.toString.call(obj) === '[object Array]';
};

/***/ }),

/***/ 60957:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(77402);
var YouboraObject = __webpack_require__(14074);
var RUMSpeedIndex = __webpack_require__(87722);
var BrowserLoadTimes = YouboraObject.extend({
  constructor: function constructor(plugin) {
    this.infinity = plugin.infinity;
    this.timeObject = null;
    this.playerSetup = null;
    this.perfObject = null;
    this.myTimesObject = {};
    if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
      window.addEventListener('load', this._windowLoaded.bind(this));
      if (window.performance && window.performance.timing) {
        try {
          if (typeof window.performance.getEntriesByType === 'function') {
            this.perfObject = window.performance;
          }
        } catch (err) {}
        this.timeObject = window.performance.timing;
      }
    }
    try {
      if (typeof PerformanceObserver === 'function') {
        var observer = new PerformanceObserver(function (list, obj) {
          var entries = list.getEntries();
          this.myTimesObject.largestContentfulPaint = entries[entries.length - 1].renderTime;
        }.bind(this));
        if (PerformanceObserver.supportedEntryTypes.indexOf('largest-contentful-paint') > -1) {
          observer.observe({
            entryTypes: ['largest-contentful-paint']
          });
        }
      }
    } catch (err) {}
  },
  _windowLoaded: function _windowLoaded() {
    this.myTimesObject.onLoad = new Date().getTime();
    this._getEnoughFPS();
    setTimeout(this._fireLoadTimesEvent.bind(this), 1000);
  },
  _fireLoadTimesEvent: function _fireLoadTimesEvent() {
    this._getLastMetrics();
    this.infinity.fireEvent('loadTimes', {}, this._getAllValues());
  },
  _getAllValues: function _getAllValues() {
    var ret = {
      PageLoadTime: this.getPageLoadTime(),
      DNSTime: this.getDnsTime(),
      TCPTime: this.getTcpTime(),
      HandshakeTime: this.getHandshakeTime(),
      DomReadyTime: this.getDomReadyTime(),
      BackendTime: this.getBackendTime(),
      FrontendTime: this.getFrontendTime(),
      VisualReady: this.getTimeToVisuallyReady(),
      TimeToInteractive: this.getTimeToInteractive(),
      JsTime: this.getJSTime(),
      CssTime: this.getCSSTime(),
      ImageTime: this.getImageTime(),
      FontTime: this.getFontTime(),
      AvgReqLatency: this.getAvgReqLatency(),
      MaxReqLatency: this.getMaxReqLatency(),
      FirstPaint: this.getFirstPaint(),
      FirstContentfulPaint: this.getFirstContentfulPaint(),
      LargestContentfulPaint: this.getLargestContentfulPaint(),
      SpeedIndex: this.getSpeedIndex()
    };
    for (var key in ret) {
      if (ret[key] === null || ret[key] === undefined || ret[key] < 0) {
        delete ret[key];
      } else {
        ret[key] = Math.round(ret[key]);
      }
    }
    return ret;
  },
  getPageLoadTime: function getPageLoadTime() {
    var ret = null;
    if (this.timeObject) {
      ret = this.timeObject.loadEventEnd - this.timeObject.navigationStart;
    }
    return ret;
  },
  getPlayerStartupTime: function getPlayerStartupTime() {
    var ret = null;
    if (this.timeObject && this.playerSetup) {
      ret = this.playerSetup - this.timeObject.navigationStart;
    }
    return ret;
  },
  getDnsTime: function getDnsTime() {
    var ret = null;
    if (this.timeObject) {
      ret = this.timeObject.domainLookupEnd - this.timeObject.domainLookupStart;
    }
    return ret;
  },
  getTcpTime: function getTcpTime() {
    var ret = null;
    if (this.timeObject) {
      ret = this.timeObject.connectEnd - this.timeObject.connectStart;
    }
    return ret;
  },
  getHandshakeTime: function getHandshakeTime() {
    var ret = null;
    if (this.timeObject && this.timeObject.secureConnectionStart) {
      ret = this.timeObject.connectEnd - this.timeObject.secureConnectionStart;
    }
    return ret;
  },
  getDomReadyTime: function getDomReadyTime() {
    var ret = null;
    if (this.timeObject) {
      ret = this.timeObject.domComplete - this.timeObject.navigationStart;
    }
    return ret;
  },
  getBackendTime: function getBackendTime() {
    var ret = null;
    if (this.timeObject) {
      ret = this.timeObject.responseStart - this.timeObject.navigationStart;
    }
    return ret;
  },
  getFrontendTime: function getFrontendTime() {
    var ret = null;
    if (this.timeObject) {
      ret = this.myTimesObject.onLoad - this.timeObject.responseStart;
    }
    return ret;
  },
  getTimeToVisuallyReady: function getTimeToVisuallyReady() {
    var ret = this.myTimesObject.firstPaint || 0;
    if (this.timeObject) {
      return Math.max(ret, this.timeObject.domContentLoadedEventEnd - this.timeObject.navigationStart || 0);
    }
    return ret || null;
  },
  getTimeToInteractive: function getTimeToInteractive() {
    if (this.myTimesObject.fps && this.getTimeToVisuallyReady()) {
      return Math.max(this.myTimesObject.fps, this.getTimeToVisuallyReady());
    } else {
      setTimeout(function () {
        this.getTimeToInteractive();
      }.bind(this), 500);
    }
  },
  getJSTime: function getJSTime() {
    return this._getXTime('script');
  },
  getCSSTime: function getCSSTime() {
    return this._getXTime('css');
  },
  getImageTime: function getImageTime() {
    return this._getXTime('img');
  },
  getFontTime: function getFontTime() {
    return this._getXTime('css', ['.woff', '.otf', '.ttf']);
  },
  getAvgReqLatency: function getAvgReqLatency() {
    try {
      if (this.perfObject && typeof this.perfObject.getEntriesByType === 'function') {
        var count = 0;
        var latency = 0;
        var scripts = this.perfObject.getEntriesByType('resource');
        for (var i in scripts) {
          if (scripts[i].requestStart && scripts[i].responseStart) {
            latency += scripts[i].responseStart - scripts[i].requestStart;
          }
          count++;
        }
        return latency / count;
      }
    } catch (err) {}
    return null;
  },
  getFirstPaint: function getFirstPaint() {
    return this.myTimesObject ? this.myTimesObject.firstPaint : null;
  },
  getFirstContentfulPaint: function getFirstContentfulPaint() {
    return this.myTimesObject ? this.myTimesObject.firstContentfulPaint : null;
  },
  getLargestContentfulPaint: function getLargestContentfulPaint() {
    return this.myTimesObject ? this.myTimesObject.largestContentfulPaint : null;
  },
  getMaxReqLatency: function getMaxReqLatency() {
    try {
      if (this.perfObject && typeof this.perfObject.getEntriesByType === 'function') {
        var scripts = this.perfObject.getEntriesByType('resource');
        var latency = 0;
        for (var i in scripts) {
          if (scripts[i].requestStart && scripts[i].responseStart) {
            latency = Math.max(latency, scripts[i].responseStart - scripts[i].requestStart);
          }
        }
        return latency;
      }
    } catch (err) {}
    return null;
  },
  getSpeedIndex: function getSpeedIndex() {
    var ret = null;
    if (typeof window !== 'undefined' && window.performance && typeof window.performance.getEntriesByType === 'function') {
      try {
        ret = RUMSpeedIndex();
      } catch (e) {}
    }
    return ret;
  },
  _getXTime: function _getXTime(type, validExtensions) {
    var ret = 0;
    try {
      if (this.perfObject && typeof this.perfObject.getEntriesByType === 'function') {
        var scripts = this.perfObject.getEntriesByType('resource');
        for (var i in scripts) {
          if (scripts[i].initiatorType === type) {
            if (!validExtensions) {
              ret += scripts[i].duration;
            } else {
              var valid = false;
              for (var ext in validExtensions) {
                if (scripts[i].name.indexOf(validExtensions[ext] > 0)) {
                  valid = true;
                }
              }
              if (valid) {
                ret += scripts[i].duration;
              }
            }
          }
        }
      }
    } catch (err) {}
    return Math.round(ret) || null;
  },
  _getLastMetrics: function _getLastMetrics() {
    var firstPaint = null;
    var contentfulPaint = null;
    try {
      if (this.perfObject && typeof this.perfObject.getEntriesByType === 'function') {
        var entries = this.perfObject.getEntriesByType('paint');
        for (var i in entries) {
          if (entries[i].name === 'first-paint') {
            firstPaint = entries[i].startTime;
          } else if (entries[i].name === 'first-contentful-paint') {
            contentfulPaint = entries[i].startTime;
          }
        }
      }
    } catch (err) {}
    if (!firstPaint && this.timeObject) {
      firstPaint = this.timeObject.msFirstPaint - this.timeObject.navigationStart;
    }
    this.myTimesObject.firstPaint = firstPaint;
    this.myTimesObject.firstContentfulPaint = contentfulPaint;
    this.getTimeToInteractive();
  },
  _getEnoughFPS: function _getEnoughFPS() {
    if (this.timeObject && typeof window !== 'undefined') {
      var req = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || function () {};
      this.preFPS = new Date().getTime();
      req(function () {
        var now = new Date().getTime();
        if (now < this.preFPS + 50) {
          this.myTimesObject.fps = now - this.timeObject.navigationStart;
        } else {
          setTimeout(function () {
            return this._getEnoughFPS();
          }.bind(this), 50);
        }
      }.bind(this));
    } else {
      return true;
    }
  },
  setPlayerSetupTime: function setPlayerSetupTime() {
    this.playerSetup = this.playerSetup || new Date().getTime();
  }
});
module.exports = BrowserLoadTimes;

/***/ }),

/***/ 63157:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(77402);
__webpack_require__(90565);
var YouboraObject = __webpack_require__(14074);
var HybridNetowrk = YouboraObject.extend({
  getCdnTraffic: function getCdnTraffic() {
    var ret = null;
    if (typeof CdnBalancerStats !== 'undefined' && CdnBalancerStats.cdn) {
      ret = CdnBalancerStats.cdn.totalDownloadedBytes;
    } else if (typeof Streamroot !== 'undefined') {
      ret = this._getStreamrootPeerObject('cdn', false) || this._getStreamrootInstanceObject('cdnDownload');
    } else if (typeof peer5 !== 'undefined' && peer5.getStats) {
      ret = peer5.getStats().totalHttpDownloaded;
    } else if (typeof teltoo !== 'undefined' && teltoo.getStats) {
      var stats = teltoo.getStats();
      ret = stats.totalReceivedBytes - stats.p2pReceivedBytes;
    }
    return ret;
  },
  getMultiCdnInfo: function getMultiCdnInfo() {
    var ret = null;
    if (typeof CdnBalancerStats !== 'undefined' && CdnBalancerStats.cdn && CdnBalancerStats.cdn.cdns) {
      var p2p = CdnBalancerStats.p2p;
      ret = {
        P2P: {
          downloaded_bytes: p2p.downloadedBytes,
          uploaded_bytes: p2p.uploadedBytes,
          downloaded_chunks: p2p.downloadedSegments,
          uploaded_chunks: p2p.uploadedSegments,
          errors: p2p.failedRequests ? p2p.failedRequests.total : 0,
          missed_downloaded_chunks: p2p.failedRequests ? p2p.failedRequests.absent : 0,
          timeout_errors: p2p.failedRequests ? p2p.failedRequests.timeout : 0,
          other_errors: p2p.failedRequests ? p2p.failedRequests.error : 0,
          late_uploaded_chunks: p2p.discardedUploadedSegments,
          late_uploaded_bytes: p2p.discardedUploadedBytes,
          late_downloaded_bytes: p2p.discardedDownloadedBytes,
          time: p2p.downloadMillis,
          active_peers: p2p.activePeers,
          peers: p2p.totalPeers
        }
      };
      CdnBalancerStats.cdn.cdns.forEach(function (cdn) {
        ret[cdn.name] = {
          downloaded_bytes: cdn.bytes,
          downloaded_chunks: cdn.chunks,
          errors: cdn.failures,
          time: cdn.downloadMillis
        };
      });
    }
    return ret;
  },
  getSegmentDuration: function getSegmentDuration() {
    var ret = null;
    if (typeof CdnBalancerStats !== 'undefined' && CdnBalancerStats.segmentDuration) {
      return CdnBalancerStats.segmentDuration;
    }
    return ret;
  },
  getBalancerResponseId: function getBalancerResponseId() {
    var ret = null;
    if (typeof CdnBalancerStats !== 'undefined' && CdnBalancerStats.cdn) {
      return CdnBalancerStats.cdn.responseUUID;
    }
    return ret;
  },
  getP2PTraffic: function getP2PTraffic() {
    var ret = null;
    if (typeof CdnBalancerStats !== 'undefined' && CdnBalancerStats.p2p) {
      ret = CdnBalancerStats.p2p.downloadedBytes;
    } else if (typeof Streamroot !== 'undefined') {
      ret = this._getStreamrootPeerObject('p2p', true) || this._getStreamrootInstanceObject('dnaDownload');
    } else if (typeof peer5 !== 'undefined' && peer5.getStats) {
      ret = peer5.getStats().totalP2PDownloaded;
    } else if (typeof teltoo !== 'undefined' && teltoo.getStats) {
      ret = teltoo.getStats().p2pReceivedBytes;
    }
    return ret;
  },
  getUploadTraffic: function getUploadTraffic() {
    var ret = null;
    if (typeof CdnBalancerStats !== 'undefined' && CdnBalancerStats.p2p) {
      ret = CdnBalancerStats.p2p.uploadedBytes;
    } else if (typeof Streamroot !== 'undefined') {
      ret = this._getStreamrootPeerObject('upload', true) || this._getStreamrootInstanceObject('dnaUpload');
    } else if (typeof peer5 !== 'undefined' && peer5.getStats) {
      ret = peer5.getStats().totalP2PUploaded;
    }
    return ret;
  },
  getIsP2PEnabled: function getIsP2PEnabled() {
    var ret = false;
    if (typeof CdnBalancerStats !== 'undefined' && CdnBalancerStats.p2p) {
      ret = CdnBalancerStats.p2p.downloadEnabled;
    } else if (typeof Streamroot !== 'undefined') {
      if (Streamroot.p2pAvailable && Streamroot.peerAgents) {
        for (var agent in Streamroot.peerAgents) {
          ret = ret || Streamroot.peerAgents[agent].isP2PEnabled;
        }
      } else if (Streamroot.instances) {
        Streamroot.instances.forEach(function (instance) {
          ret = ret || instance.dnaDownloadEnabled || instance.dnaUploadEnabled;
        });
      }
    } else if (typeof peer5 !== 'undefined' && peer5.isEnabled) {
      ret = peer5.isEnabled();
    } else if (typeof teltoo !== 'undefined') {
      ret = true;
    }
    return ret;
  },
  _getStreamrootPeerObject: function _getStreamrootPeerObject(objectName, check) {
    var ret = null;
    if (Streamroot.p2pAvailable && Streamroot.peerAgents) {
      for (var agent in Streamroot.peerAgents) {
        var agentInst = Streamroot.peerAgents[agent];
        if (agentInst.stats && (!check || agentInst.isP2PEnabled)) {
          ret += agentInst.stats[objectName];
        }
      }
    }
    return ret;
  },
  _getStreamrootInstanceObject: function _getStreamrootInstanceObject(objectName) {
    var ret = null;
    if (Streamroot.instances) {
      Streamroot.instances.forEach(function (instance) {
        if (instance.stats && instance.stats.currentContent) {
          ret += instance.stats.currentContent[objectName];
        }
      });
    }
    return ret;
  }
});
module.exports = HybridNetowrk;

/***/ }),

/***/ 87722:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(30382);
__webpack_require__(77402);
__webpack_require__(28610);
__webpack_require__(8612);
var RUMSpeedIndex = function RUMSpeedIndex(win) {
  win = win || window;
  var doc = win.document;
  var GetElementViewportRect = function GetElementViewportRect(el) {
    var intersect = false;
    if (el.getBoundingClientRect) {
      var elRect = el.getBoundingClientRect();
      intersect = {
        top: Math.max(elRect.top, 0),
        left: Math.max(elRect.left, 0),
        bottom: Math.min(elRect.bottom, win.innerHeight || doc.documentElement.clientHeight),
        right: Math.min(elRect.right, win.innerWidth || doc.documentElement.clientWidth)
      };
      if (intersect.bottom <= intersect.top || intersect.right <= intersect.left) {
        intersect = false;
      } else {
        intersect.area = (intersect.bottom - intersect.top) * (intersect.right - intersect.left);
      }
    }
    return intersect;
  };
  var CheckElement = function CheckElement(el, url) {
    if (url) {
      var rect = GetElementViewportRect(el);
      if (rect) {
        rects.push({
          url: url,
          area: rect.area,
          rect: rect
        });
      }
    }
  };
  var GetRects = function GetRects() {
    var elements = doc.getElementsByTagName('*');
    var re = /url\(.*(http.*)\)/ig;
    for (var i = 0; i < elements.length; i++) {
      var el = elements[i];
      var style = win.getComputedStyle(el);
      if (el.tagName === 'IMG') {
        CheckElement(el, el.src);
      }
      if (style['background-image']) {
        re.lastIndex = 0;
        var matches = re.exec(style['background-image']);
        if (matches && matches.length > 1) {
          CheckElement(el, matches[1].replace('"', ''));
        }
      }
      if (el.tagName === 'IFRAME') {
        try {
          var rect = GetElementViewportRect(el);
          if (rect) {
            var tm = RUMSpeedIndex(el.contentWindow);
            if (tm) {
              rects.push({
                tm: tm,
                area: rect.area,
                rect: rect
              });
            }
          }
        } catch (e) {}
      }
    }
  };
  var GetRectTimings = function GetRectTimings() {
    var timings = {};
    var requests = win.performance.getEntriesByType('resource');
    for (var i = 0; i < requests.length; i++) {
      timings[requests[i].name] = requests[i].responseEnd;
    }
    for (var j = 0; j < rects.length; j++) {
      if (!('tm' in rects[j])) {
        rects[j].tm = timings[rects[j].url] !== undefined ? timings[rects[j].url] : 0;
      }
    }
  };
  var GetFirstPaint = function GetFirstPaint() {
    if ('msFirstPaint' in win.performance.timing) {
      firstPaint = win.performance.timing.msFirstPaint - navStart;
    }
    var paintMetrics = win.performance.getEntriesByType('paint');
    for (var k = 0; k < paintMetrics.length; k++) {
      if (paintMetrics[k].name === 'first-paint') {
        firstPaint = paintMetrics[k].startTime;
      }
    }
    if (firstPaint === undefined || firstPaint < 0 || firstPaint > 120000) {
      firstPaint = win.performance.timing.responseStart - navStart;
      var headURLs = {};
      var headElements = doc.getElementsByTagName('head')[0].children;
      for (var i = 0; i < headElements.length; i++) {
        var el = headElements[i];
        if (el.tagName === 'SCRIPT' && el.src && !el.async) {
          headURLs[el.src] = true;
        }
        if (el.tagName === 'LINK' && el.rel === 'stylesheet' && el.href) {
          headURLs[el.href] = true;
        }
      }
      var requests = win.performance.getEntriesByType('resource');
      var doneCritical = false;
      for (var j = 0; j < requests.length; j++) {
        if (!doneCritical && headURLs[requests[j].name] && (requests[j].initiatorType === 'script' || requests[j].initiatorType === 'link')) {
          var requestEnd = requests[j].responseEnd;
          if (firstPaint === undefined || requestEnd > firstPaint) {
            firstPaint = requestEnd;
          }
        } else {
          doneCritical = true;
        }
      }
    }
    firstPaint = Math.max(firstPaint, 0);
  };
  var CalculateVisualProgress = function CalculateVisualProgress() {
    var paints = {
      0: 0
    };
    var total = 0;
    for (var i = 0; i < rects.length; i++) {
      var tm = firstPaint;
      if ('tm' in rects[i] && rects[i].tm > firstPaint) {
        tm = rects[i].tm;
      }
      if (paints[tm] === undefined) {
        paints[tm] = 0;
      }
      paints[tm] += rects[i].area;
      total += rects[i].area;
    }
    var pixels = Math.max(doc.documentElement.clientWidth, win.innerWidth || 0) * Math.max(doc.documentElement.clientHeight, win.innerHeight || 0);
    if (pixels > 0) {
      pixels = Math.max(pixels - total, 0) * pageBackgroundWeight;
      if (paints[firstPaint] === undefined) {
        paints[firstPaint] = 0;
      }
      paints[firstPaint] += pixels;
      total += pixels;
    }
    if (total) {
      for (var time in paints) {
        if (paints.hasOwnProperty(time)) {
          progress.push({
            tm: time,
            area: paints[time]
          });
        }
      }
      progress.sort(function (a, b) {
        return a.tm - b.tm;
      });
      var accumulated = 0;
      for (var j = 0; j < progress.length; j++) {
        accumulated += progress[j].area;
        progress[j].progress = accumulated / total;
      }
    }
  };
  var CalculateSpeedIndex = function CalculateSpeedIndex() {
    if (progress.length) {
      SpeedIndex = 0;
      var lastTime = 0;
      var lastProgress = 0;
      for (var i = 0; i < progress.length; i++) {
        var elapsed = progress[i].tm - lastTime;
        if (elapsed > 0 && lastProgress < 1) {
          SpeedIndex += (1 - lastProgress) * elapsed;
        }
        lastTime = progress[i].tm;
        lastProgress = progress[i].progress;
      }
    } else {
      SpeedIndex = firstPaint;
    }
  };
  var rects = [];
  var progress = [];
  var firstPaint;
  var SpeedIndex;
  var pageBackgroundWeight = 0.1;
  try {
    var navStart = win.performance.timing.navigationStart;
    GetRects();
    GetRectTimings();
    GetFirstPaint();
    CalculateVisualProgress();
    CalculateSpeedIndex();
  } catch (e) {}
  return SpeedIndex;
};
module.exports = RUMSpeedIndex;

/***/ }),

/***/ 14074:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assign = __webpack_require__(34027);
var createObject = __webpack_require__(75814);
var YouboraObject = function YouboraObject() {};
YouboraObject.prototype = {
  constructor: function constructor() {}
};
YouboraObject.extend = function (protoProps, staticProps) {
  var parent = this;
  var child;
  if (protoProps && protoProps.hasOwnProperty('constructor')) {
    child = protoProps.constructor;
  } else {
    child = function child() {
      return parent.apply(this, arguments);
    };
  }
  assign(child, parent, staticProps);
  child.prototype = createObject(parent.prototype);
  if (protoProps) assign(child.prototype, protoProps);
  child.prototype.constructor = child;
  child.__super__ = parent.prototype;
  return child;
};
module.exports = YouboraObject;

/***/ }),

/***/ 19042:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var YouboraObject = __webpack_require__(14074);
var Log = __webpack_require__(60244);
var DeprecatedOptions = YouboraObject.extend({
  exists: function exists(optionName) {
    return DeprecatedOptions.Dictionary.hasOwnProperty(optionName);
  },
  getNewName: function getNewName(optionName) {
    var newName = DeprecatedOptions.Dictionary[optionName];
    Log.warn('The option "' + optionName + '" is deprecated, use "' + newName + '" instead');
    return newName;
  }
}, {
  Dictionary: {
    httpSecure: 'app.https',
    username: 'user.name',
    anonymousUser: 'user.anonymousId',
    obfuscateIp: 'user.obfuscateIp',
    userType: 'user.type',
    'content.title2': 'content.program',
    'background.settings.iphone': 'background.settings.iOS',
    'parse.hls': 'parse.manifest',
    'parse.dash': 'parse.manifest',
    'parse.locationHeader': 'parse.manifest',
    'extraparam.1': 'content.customDimension.1',
    'extraparam.2': 'content.customDimension.2',
    'extraparam.3': 'content.customDimension.3',
    'extraparam.4': 'content.customDimension.4',
    'extraparam.5': 'content.customDimension.5',
    'extraparam.6': 'content.customDimension.6',
    'extraparam.7': 'content.customDimension.7',
    'extraparam.8': 'content.customDimension.8',
    'extraparam.9': 'content.customDimension.9',
    'extraparam.10': 'content.customDimension.10',
    'extraparam.11': 'content.customDimension.11',
    'extraparam.12': 'content.customDimension.12',
    'extraparam.13': 'content.customDimension.13',
    'extraparam.14': 'content.customDimension.14',
    'extraparam.15': 'content.customDimension.15',
    'extraparam.16': 'content.customDimension.16',
    'extraparam.17': 'content.customDimension.17',
    'extraparam.18': 'content.customDimension.18',
    'extraparam.19': 'content.customDimension.19',
    'extraparam.20': 'content.customDimension.20',
    'ad.extraparam.1': 'ad.customDimension.1',
    'ad.extraparam.2': 'ad.customDimension.2',
    'ad.extraparam.3': 'ad.customDimension.3',
    'ad.extraparam.4': 'ad.customDimension.4',
    'ad.extraparam.5': 'ad.customDimension.5',
    'ad.extraparam.6': 'ad.customDimension.6',
    'ad.extraparam.7': 'ad.customDimension.7',
    'ad.extraparam.8': 'ad.customDimension.8',
    'ad.extraparam.9': 'ad.customDimension.9',
    'ad.extraparam.10': 'ad.customDimension.10'
  }
});
module.exports = DeprecatedOptions;

/***/ }),

/***/ 49274:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(97343);
__webpack_require__(72578);
__webpack_require__(67478);
__webpack_require__(28610);
__webpack_require__(50851);
__webpack_require__(8612);
__webpack_require__(74389);
var _typeof = __webpack_require__(45129);
var YouboraObject = __webpack_require__(14074);
var Storage = __webpack_require__(86820);
var OfflineStorage = YouboraObject.extend({
  constructor: function constructor() {
    this.storage = new Storage('youboraOffline', true);
    this.actualView = null;
    this.viewList = [];
    this.givenIds = [];
    this._getOldViewList();
  },
  _newView: function _newView() {
    var viewId = this._getValidId();
    this.storage.setLocal(viewId, '');
    this.viewList.push(viewId);
    this.storage.setLocal('views', this.viewList);
    this.actualView = viewId;
  },
  addEvent: function addEvent(event, params) {
    if (event === '/start') this._newView();
    if (event === '/init') return null;
    if (!this.actualView) return null;
    var fullEvent = '{"request":"' + event.slice(1) + '",';
    fullEvent += '"unixtime":' + Date.now() + ',';
    for (var param in params) {
      if (params[param] === undefined) break;
      fullEvent += '"' + param + '":';
      if (param === 'code') {
        fullEvent += '"' + 'CODE_PLACEHOLDER' + '",';
      } else if (param === 'sessionId') {
        fullEvent += '"' + 'SESSION_PLACEHOLDER' + '",';
      } else if (param === 'sessionRoot') {
        fullEvent += '"' + 'ROOT_PLACEHOLDER' + '",';
      } else if (typeof params[param] === 'string') {
        fullEvent += '"' + params[param] + '",';
      } else if (_typeof(params[param]) === 'object') {
        fullEvent += '"' + JSON.stringify(params[param]).replace(/"/g, '\\"') + '",';
      } else {
        fullEvent += params[param] + ',';
      }
    }
    fullEvent = fullEvent.slice(0, -1);
    fullEvent += '}';
    var temp = this.storage.getLocal(this.actualView);
    if (temp !== '') temp = temp + ',';
    this.storage.setLocal(this.actualView, temp + fullEvent);
  },
  getView: function getView() {
    if (this.viewList.length > this.givenIds.length) {
      var position = 0;
      while (true) {
        var idToSend = this.viewList[position];
        if (this.givenIds.indexOf(idToSend) < 0) {
          this.givenIds.push(idToSend);
          return ['[' + this.storage.getLocal(idToSend) + ']', idToSend];
        }
        position++;
      }
    }
    return [null, null];
  },
  removeView: function removeView(id) {
    this.storage.removeLocal(id);
    var position = this.viewList.indexOf(id);
    if (position !== -1) this.viewList.splice(position, 1);
    position = this.givenIds.indexOf(id);
    if (position !== -1) this.givenIds.splice(position, 1);
    this.storage.setLocal('views', this.viewList.toString());
    if (id === this.actualView) this.actualView = null;
  },
  _getOldViewList: function _getOldViewList() {
    var stringList = '';
    if (this.storage.getLocal('views')) {
      stringList = this.storage.getLocal('views');
    } else {
      this.storage.setLocal('views', '');
    }
    if (stringList === '') {
      this.viewList = [];
    } else if (typeof stringList.split === 'function') {
      this.viewList = stringList.split(',');
    }
  },
  _getValidId: function _getValidId() {
    var id = Math.floor(Math.random() * 1e8).toString();
    if (this.viewList.indexOf(id) >= 0) {
      return this._getValidId();
    }
    return id;
  },
  sent: function sent() {
    this.givenIds = [];
  }
});
module.exports = OfflineStorage;

/***/ }),

/***/ 94208:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(97343);
__webpack_require__(67478);
__webpack_require__(50851);
__webpack_require__(90565);
var _typeof = __webpack_require__(45129);
var YouboraObject = __webpack_require__(14074);
var DeprecatedOptions = __webpack_require__(19042);
var Log = __webpack_require__(60244);
var TransportFormat = __webpack_require__(63642);
var StreamingProtocol = __webpack_require__(96308);
var RequestMethod = __webpack_require__(78856);
var Options = YouboraObject.extend({
  constructor: function constructor(options) {
    this.enabled = true;
    this.host = 'a-fds.youborafds01.com';
    this.accountCode = 'nicetest';
    this.authToken = null;
    this.authType = 'Bearer';
    this.preventZombieViews = true;
    this.offline = false;
    this.referer = null;
    this.referral = null;
    this.disableCookies = true;
    this.forceCookies = false;
    this.disableStorage = false;
    this['user.email'] = null;
    this['user.type'] = null;
    this['user.name'] = null;
    this['user.obfuscateIp'] = false;
    this['user.anonymousId'] = null;
    this['user.privacyProtocol'] = null;
    this['parse.manifest'] = false;
    this['parse.manifest.auth'] = {};
    this['parse.cdnNameHeader'] = 'x-cdn-forward';
    this['parse.cdnNodeHeader'] = '';
    this['parse.cdnNode'] = false;
    this['parse.cdnNode.list'] = ['Akamai', 'Amazon', 'Cloudfront', 'Level3', 'Fastly', 'Highwinds', 'Telefonica', 'Edgecast', 'NosOtt'];
    this['parse.fdsResponseHost'] = null;
    this['parse.cdnSwitchHeader'] = false;
    this['parse.cdnTTL'] = 60;
    this['network.ip'] = null;
    this['network.isp'] = null;
    this['network.connectionType'] = null;
    this['device.id'] = null;
    this['device.code'] = null;
    this['device.model'] = null;
    this['device.brand'] = null;
    this['device.type'] = null;
    this['device.name'] = null;
    this['device.osName'] = null;
    this['device.osVersion'] = null;
    this['device.browserName'] = null;
    this['device.browserVersion'] = null;
    this['device.browserType'] = null;
    this['device.browserEngine'] = null;
    this['device.EDID'] = null;
    this['device.isAnonymous'] = false;
    this['content.transactionCode'] = null;
    this['content.resource'] = null;
    this['content.isLive'] = null;
    this['content.isLive.noSeek'] = false;
    this['content.isLive.noMonitor'] = false;
    this['content.title'] = null;
    this['content.program'] = null;
    this['content.duration'] = null;
    this['content.fps'] = null;
    this['content.segmentDuration'] = null;
    this['content.bitrate'] = null;
    this['content.totalBytes'] = null;
    this['content.sendTotalBytes'] = false;
    this['content.throughput'] = null;
    this['content.rendition'] = null;
    this['content.cdn'] = null;
    this['content.cdnNode'] = null;
    this['content.cdnType'] = null;
    this['content.metadata'] = {};
    this['content.metrics'] = {};
    this['content.streamingProtocol'] = null;
    this['content.transportFormat'] = null;
    this['content.package'] = null;
    this['content.saga'] = null;
    this['content.tvShow'] = null;
    this['content.season'] = null;
    this['content.episodeTitle'] = null;
    this['content.channel'] = null;
    this['content.id'] = null;
    this['content.imdbId'] = null;
    this['content.gracenoteId'] = null;
    this['content.type'] = null;
    this['content.genre'] = null;
    this['content.language'] = null;
    this['content.autodetect.language'] = true;
    this['content.subtitles'] = null;
    this['content.autodetect.subtitles'] = true;
    this['content.contractedResolution'] = null;
    this['content.cost'] = null;
    this['content.price'] = null;
    this['content.playbackType'] = null;
    this['content.drm'] = null;
    this['content.encoding.videoCodec'] = null;
    this['content.encoding.audioCodec'] = null;
    this['content.encoding.codecSettings'] = null;
    this['content.encoding.codecProfile'] = null;
    this['content.encoding.containerFormat'] = null;
    this['ad.metadata'] = {};
    this['ad.campaign'] = null;
    this['ad.creativeId'] = null;
    this['ad.provider'] = null;
    this['ad.resource'] = null;
    this['ad.title'] = null;
    this['ad.duration'] = null;
    this['ad.expectedPattern'] = null;
    this['ad.givenAds'] = null;
    this['ad.breaksTime'] = null;
    this['ad.expectedBreaks'] = null;
    this['ad.givenBreaks'] = null;
    this['ad.ignore'] = false;
    this['ad.blockerDetected'] = null;
    this['app.name'] = null;
    this['app.releaseVersion'] = null;
    this['app.https'] = false;
    this['background.enabled'] = true;
    this['background.settings'] = null;
    this['background.settings.android'] = 'stop';
    this['background.settings.iOS'] = 'stop';
    this['background.settings.desktop'] = null;
    this['background.settings.tv'] = 'stop';
    this['background.settings.playstation'] = 'stop';
    this['smartswitch.configCode'] = null;
    this['smartswitch.groupCode'] = null;
    this['smartswitch.contractCode'] = null;
    this['content.customDimensions'] = {};
    this['content.customDimension.1'] = null;
    this['content.customDimension.2'] = null;
    this['content.customDimension.3'] = null;
    this['content.customDimension.4'] = null;
    this['content.customDimension.5'] = null;
    this['content.customDimension.6'] = null;
    this['content.customDimension.7'] = null;
    this['content.customDimension.8'] = null;
    this['content.customDimension.9'] = null;
    this['content.customDimension.10'] = null;
    this['content.customDimension.11'] = null;
    this['content.customDimension.12'] = null;
    this['content.customDimension.13'] = null;
    this['content.customDimension.14'] = null;
    this['content.customDimension.15'] = null;
    this['content.customDimension.16'] = null;
    this['content.customDimension.17'] = null;
    this['content.customDimension.18'] = null;
    this['content.customDimension.19'] = null;
    this['content.customDimension.20'] = null;
    this['ad.customDimension.1'] = null;
    this['ad.customDimension.2'] = null;
    this['ad.customDimension.3'] = null;
    this['ad.customDimension.4'] = null;
    this['ad.customDimension.5'] = null;
    this['ad.customDimension.6'] = null;
    this['ad.customDimension.7'] = null;
    this['ad.customDimension.8'] = null;
    this['ad.customDimension.9'] = null;
    this['ad.customDimension.10'] = null;
    this.forceInit = false;
    this['session.metrics'] = {};
    this['session.context'] = false;
    this['errors.fatal'] = [];
    this['errors.nonFatal'] = [];
    this['errors.ignore'] = [];
    this.linkedViewId = null;
    this.waitForMetadata = false;
    this.pendingMetadata = [];
    this.method = RequestMethod.GET;
    this['playhead.monitor'] = true;
    this['readyState.monitor'] = true;
    this.setOptions(options);
  },
  setOptions: function setOptions(options, base) {
    var isInBase = false;
    if (base === undefined) {
      base = this;
      isInBase = true;
      var deprecatedOptions = new DeprecatedOptions();
    }
    if (typeof options !== 'undefined') {
      for (var key in options) {
        var deprecated = false;
        var newKey = null;
        if (isInBase) {
          if (!this.hasOwnProperty(key)) {
            if (deprecatedOptions.exists(key)) {
              newKey = deprecatedOptions.getNewName(key);
              deprecated = true;
            } else {
              Log.warn('The option "' + key + '" does not exist, so it cannot be set');
            }
          }
        }
        if (_typeof(base[key]) === 'object' && base[key] !== null && !Array.isArray(base[key]) && key === 'parse.cdnNode.list') {
          this.setOptions(options[key], base[key]);
        } else {
          if (deprecated) {
            base[newKey] = options[key];
          } else {
            base[key] = options[key];
          }
        }
      }
    }
  },
  setExtraParams: function setExtraParams(paramsArray) {
    var maxLength = 20;
    if (_typeof(paramsArray) !== 'object' || !paramsArray.length) return;
    if (paramsArray.length >= maxLength) paramsArray = paramsArray.slice(0, maxLength);
    while (paramsArray.length < maxLength) {
      paramsArray.push(null);
    }
    paramsArray.forEach(function (param, index) {
      this['content.customDimension.' + (index + 1).toString()] = param;
    }.bind(this));
  },
  setCustomDimensions: function setCustomDimensions() {
    Options.prototype.setExtraParams.apply(this, arguments);
  },
  setAdExtraParams: function setAdExtraParams(paramsArray) {
    var maxLength = 10;
    if (_typeof(paramsArray) !== 'object' || !paramsArray.length) return;
    if (paramsArray.length >= maxLength) paramsArray = paramsArray.slice(0, maxLength);
    while (paramsArray.length < maxLength) {
      paramsArray.push(null);
    }
    paramsArray.forEach(function (param, index) {
      this['ad.customDimension.' + (index + 1).toString()] = param;
    }.bind(this));
  },
  setAdCustomDimensions: function setAdCustomDimensions() {
    Options.prototype.setAdExtraParams.apply(this, arguments);
  }
}, {
  StreamingProtocol: StreamingProtocol,
  TransportFormat: TransportFormat,
  RequestMethod: RequestMethod
});
module.exports = Options;

/***/ }),

/***/ 36819:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(29548);
__webpack_require__(30415);
__webpack_require__(38051);
__webpack_require__(90565);
var Log = __webpack_require__(60244);
var Util = __webpack_require__(29021);
var Constants = __webpack_require__(47905);
var PluginAdsGettersMixin = {
  getAdPlayerVersion: function getAdPlayerVersion() {
    return this._safeGetterAdsAdapter('getPlayerVersion') || '';
  },
  getAdPosition: function getAdPosition() {
    var ret = Constants.AdPosition.Preroll;
    if (this._adsAdapter) {
      try {
        var temporalRet = this._adsAdapter.getPosition();
        if (Constants.AdPosition.Preroll === temporalRet || Constants.AdPosition.Midroll === temporalRet || Constants.AdPosition.Postroll === temporalRet) {
          ret = temporalRet;
        }
      } catch (err) {
        Log.warn('An error occured while calling getAdPosition', err);
      }
    }
    if (!ret && this._adapter) {
      ret = this._adapter.flags.isJoined ? Constants.AdPosition.Midroll : Constants.AdPosition.Preroll;
    }
    return ret;
  },
  getAdNumber: function getAdNumber() {
    return this.requestBuilder.lastSent.adNumber || 0;
  },
  getAdNumberInBreak: function getAdNumberInBreak() {
    return this.requestBuilder.lastSent.adNumberInBreak || 0;
  },
  getBreakNumber: function getBreakNumber() {
    return this.requestBuilder.lastSent.breakNumber || 0;
  },
  getAdPlayhead: function getAdPlayhead() {
    var ret = this._safeGetterAdsAdapter('getPlayhead');
    return Util.parseNumber(ret, 0);
  },
  getAdDuration: function getAdDuration() {
    var ret = this._safeGetterAdsAdapter('getDuration', 'ad.duration');
    return Util.parseNumber(ret, 0);
  },
  getAdBitrate: function getAdBitrate() {
    var ret = this._safeGetterAdsAdapter('getBitrate');
    if (!ret || ret === -1) {
      ret = this.getWebkitAdBitrate();
    }
    return Util.parseNumber(ret, -1);
  },
  getWebkitAdBitrate: function getWebkitAdBitrate() {
    if (this._adsAdapter && this._adsAdapter.tag && this._adsAdapter.tag.webkitVideoDecodedByteCount) {
      var bitrate = this._adsAdapter.tag.webkitVideoDecodedByteCount;
      if (this._lastWebkitAdBitrate) {
        var delta = this._adsAdapter.tag.webkitVideoDecodedByteCount - this._lastWebkitAdBitrate;
        bitrate = Math.round(delta / this.viewTransform.response.pingTime * 8);
      }
      this._lastWebkitAdBitrate = this._adsAdapter.tag.webkitVideoDecodedByteCount;
      return bitrate !== 0 ? bitrate : -1;
    }
  },
  getAdTitle: function getAdTitle() {
    return this._safeGetterAdsAdapter('getTitle', 'ad.title');
  },
  getAdResource: function getAdResource() {
    return this._safeGetterAdsAdapter('getResource', 'ad.resource');
  },
  getAdCampaign: function getAdCampaign() {
    return this._safeGetterAdsAdapter('getCampaign', 'ad.campaign');
  },
  getAdCreativeId: function getAdCreativeId() {
    return this._safeGetterAdsAdapter('getCreativeId', 'ad.creativeId');
  },
  getAdProvider: function getAdProvider() {
    return this._safeGetterAdsAdapter('getProvider', 'ad.provider');
  },
  getAdAdapterVersion: function getAdAdapterVersion() {
    return this._safeGetterAdsAdapter('getVersion');
  },
  getAdMetadata: function getAdMetadata() {
    return this.options['ad.metadata'];
  },
  getAdInsertionType: function getAdInsertionType() {
    return this._safeGetterAdsAdapter('getAdInsertionType');
  },
  getGivenBreaks: function getGivenBreaks() {
    return this._safeGetterAdsAdapter('getGivenBreaks', 'ad.givenBreaks');
  },
  getExpectedBreaks: function getExpectedBreaks() {
    var ret = null;
    var expBreaks = this.options['ad.expectedBreaks'];
    var expPattern = this.options['ad.expectedPattern'];
    if (expBreaks) {
      ret = expBreaks;
    } else if (expPattern) {
      ret = 0;
      ret = expPattern.pre ? expPattern.pre.length : 0;
      ret += expPattern.mid ? expPattern.mid.length : 0;
      ret += expPattern.post ? expPattern.post.length : 0;
    } else if (this._adsAdapter) {
      try {
        ret = this._adsAdapter.getExpectedBreaks();
      } catch (err) {
        Log.warn('An error occured while calling expectedBreaks', err);
      }
    }
    return ret;
  },
  getExpectedPattern: function getExpectedPattern() {
    return this._safeGetterAdsAdapter('getExpectedPattern', 'ad.expectedPattern');
  },
  getBreaksTime: function getBreaksTime() {
    return this._safeGetterAdsAdapter('getBreaksTime', 'ad.breaksTime');
  },
  getGivenAds: function getGivenAds() {
    return this._safeGetterAdsAdapter('getGivenAds', 'ad.givenAds');
  },
  getExpectedAds: function getExpectedAds() {
    var ret = null;
    try {
      if (this._adsAdapter) {
        var pattern = this.options['ad.expectedPattern'];
        if (pattern && this.getAdPosition()) {
          var list = [];
          if (pattern.pre) list = list.concat(pattern.pre);
          if (pattern.mid) list = list.concat(pattern.mid);
          if (pattern.post) list = list.concat(pattern.post);
          if (list.length > 0) {
            var position = this.requestBuilder.lastSent.breakNumber;
            if (position > list.length) position = list.length;
            ret = list[position - 1];
          }
        } else {
          ret = this._adsAdapter.getExpectedAds();
        }
      }
    } catch (err) {
      Log.warn('An error occured while calling expectedAds', err);
    }
    return ret;
  },
  getAdsExpected: function getAdsExpected() {
    var ret = null;
    try {
      ret = this.getExpectedPattern() || this.getGivenAds() || false;
    } catch (err) {
      Log.warn('An error occured while calling givenAds or expectedPattern', err);
    }
    return ret;
  },
  getAdJoinDuration: function getAdJoinDuration() {
    return this._adsAdapter ? this._adsAdapter.chronos.join.getDeltaTime(false) : -1;
  },
  getAdBufferDuration: function getAdBufferDuration() {
    return this._adsAdapter ? this._adsAdapter.chronos.buffer.getDeltaTime(false) : -1;
  },
  getAdPauseDuration: function getAdPauseDuration() {
    return this._adsAdapter ? this._adsAdapter.chronos.pause.getDeltaTime(false) : 0;
  },
  getAdTotalDuration: function getAdTotalDuration() {
    return this._adsAdapter ? this._adsAdapter.chronos.total.getDeltaTime(false) : -1;
  },
  getAdViewedDuration: function getAdViewedDuration() {
    return this._getTimeMaxOrAcum(true);
  },
  getAdViewability: function getAdViewability() {
    return this._getTimeMaxOrAcum();
  },
  _getTimeMaxOrAcum: function _getTimeMaxOrAcum(acum) {
    var maxTime = 0;
    if (this._adsAdapter) {
      this._adsAdapter.chronos.viewedMax.forEach(function (chrono) {
        if (acum) {
          maxTime += chrono.getDeltaTime(false);
        } else {
          maxTime = Math.max(chrono.getDeltaTime(false), maxTime);
        }
      });
    }
    return maxTime;
  },
  getAudioEnabled: function getAudioEnabled() {
    return this._safeGetterAdsAdapter('getAudioEnabled');
  },
  getIsSkippable: function getIsSkippable() {
    return this._safeGetterAdsAdapter('getIsSkippable');
  },
  getIsFullscreen: function getIsFullscreen() {
    return this._safeGetterAdsAdapter('getIsFullscreen');
  },
  _safeGetterAdsAdapter: function _safeGetterAdsAdapter(func, option) {
    var ret = null;
    if (option && this.options[option]) {
      ret = this.options[option];
    } else {
      try {
        if (this._adsAdapter && typeof this._adsAdapter[func] === 'function') {
          ret = this._adsAdapter[func]();
        }
      } catch (err) {
        Log.warn('An error occured while calling ' + func, err);
      }
    }
    return ret;
  }
};
module.exports = PluginAdsGettersMixin;

/***/ }),

/***/ 81732:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(30415);
__webpack_require__(38051);
var Log = __webpack_require__(60244);
var Constants = __webpack_require__(47905);
var Adapter = __webpack_require__(74366);
var Util = __webpack_require__(29021);
var PluginAdsMixin = {
  getAdsAdapter: function getAdsAdapter() {
    return this._adsAdapter;
  },
  setAdsAdapter: function setAdsAdapter(adsAdapter) {
    if (adsAdapter.plugin) {
      Log.warn('Adapters can only be added to a single plugin');
    } else {
      this.removeAdsAdapter();
      adsAdapter.plugin = this;
      this._adsAdapter = adsAdapter;
      adsAdapter.setIsAds(true);
      this.adsAdapterListeners = {};
      this.adsAdapterListeners[Adapter.Event.START] = this._adStartListener.bind(this);
      this.adsAdapterListeners[Adapter.Event.JOIN] = this._adJoinListener.bind(this);
      this.adsAdapterListeners[Adapter.Event.PAUSE] = this._adPauseListener.bind(this);
      this.adsAdapterListeners[Adapter.Event.RESUME] = this._adResumeListener.bind(this);
      this.adsAdapterListeners[Adapter.Event.BUFFER_BEGIN] = this._adBufferBeginListener.bind(this);
      this.adsAdapterListeners[Adapter.Event.BUFFER_END] = this._adBufferEndListener.bind(this);
      this.adsAdapterListeners[Adapter.Event.STOP] = this._adStopListener.bind(this);
      this.adsAdapterListeners[Adapter.Event.ERROR] = this._adErrorListener.bind(this);
      this.adsAdapterListeners[Adapter.Event.CLICK] = this._adClickListener.bind(this);
      this.adsAdapterListeners[Adapter.Event.MANIFEST] = this._adManifestListener.bind(this);
      this.adsAdapterListeners[Adapter.Event.PODSTART] = this._adBreakStartListener.bind(this);
      this.adsAdapterListeners[Adapter.Event.PODSTOP] = this._adBreakStopListener.bind(this);
      this.adsAdapterListeners[Adapter.Event.QUARTILE] = this._adQuartileListener.bind(this);
      for (var key in this.adsAdapterListeners) {
        this._adsAdapter.on(key, this.adsAdapterListeners[key]);
      }
    }
  },
  removeAdsAdapter: function removeAdsAdapter() {
    if (this._adsAdapter) {
      this._adsAdapter.dispose();
      this._adsAdapter.plugin = null;
      if (this.adsAdapterListeners) {
        for (var key in this.adsAdapterListeners) {
          this._adsAdapter.off(key, this.adsAdapterListeners[key]);
        }
        delete this.adsAdapterListeners;
      }
      this.resizeScrollDetector.stopDetection();
      this._adsAdapter = null;
    }
  },
  _adStartListener: function _adStartListener(e) {
    if (this._adapter) {
      this._adapter.fireBufferEnd(null, 'adStartListener');
      this._adapter.fireSeekEnd(null, 'adStartListener');
      if (!this.isInitiated && !this._adapter.flags.isStarted) this._adapter.fireStart();
      if (this._adapter.flags.isPaused) this._adapter.chronos.pause.reset();
    } else {
      this.fireInit();
    }
    if (this._adsAdapter) {
      this._adsAdapter.chronos.viewedMax = [];
    }
    var params = e.data.params || {};
    params.adNumber = this.requestBuilder.getNewAdNumber();
    var allParamsReady = (this.getAdResource() || this.getAdTitle()) && typeof this.getAdDuration() === 'number';
    if (allParamsReady) {
      this.adStartSent = true;
      this._adsAdapter.fireManifest();
      this._adsAdapter.fireBreakStart();
      params.adNumberInBreak = this.requestBuilder.getNewAdNumberInBreak();
      this._sendAdEventIfAllowed(Constants.WillSendEvent.WILL_SEND_AD_START, Constants.Service.AD_START, params);
    } else {
      this.adInitSent = true;
      params.adNumberInBreak = this.requestBuilder.getNewAdNumberInBreak();
      this._sendAdEventIfAllowed(Constants.WillSendEvent.WILL_SEND_AD_INIT, Constants.Service.AD_INIT, params);
    }
  },
  _adJoinListener: function _adJoinListener(e) {
    var params = {};
    Util.assign(params, e.data.params || {});
    if (this.adInitSent && !this.adStartSent) {
      this._adsAdapter.fireManifest();
      this._adsAdapter.fireBreakStart();
      this._sendAdEventIfAllowed(Constants.WillSendEvent.WILL_SEND_AD_START, Constants.Service.AD_START, params);
    }
    this._adsAdapter.startChronoView();
    if (this.adConnected) {
      this._adsAdapter.chronos.join.startTime = this.adConnectedTime;
      this._adsAdapter.chronos.total.startTime = this.adConnectedTime;
      this.adConnectedTime = 0;
      this.adConnected = false;
    }
    params = e.data.params || {};
    this._sendAdEventIfAllowed(Constants.WillSendEvent.WILL_SEND_AD_JOIN, Constants.Service.AD_JOIN, params);
    this.adInitSent = false;
    this.adStartSent = false;
  },
  _adPauseListener: function _adPauseListener(e) {
    var params = e.data.params || {};
    this._adsAdapter.stopChronoView();
    this._sendAdEventIfAllowed(Constants.WillSendEvent.WILL_SEND_AD_PAUSE, Constants.Service.AD_PAUSE, params);
  },
  _adResumeListener: function _adResumeListener(e) {
    var params = e.data.params || {};
    this._adsAdapter.startChronoView();
    this._sendAdEventIfAllowed(Constants.WillSendEvent.WILL_SEND_AD_RESUME, Constants.Service.AD_RESUME, params);
  },
  _adBufferBeginListener: function _adBufferBeginListener(e) {
    Log.notice('Ad Buffer Begin');
    this._adsAdapter.stopChronoView();
    if (this._adsAdapter && this._adsAdapter.flags.isPaused) {
      this._adsAdapter.chronos.pause.reset();
    }
  },
  _adBufferEndListener: function _adBufferEndListener(e) {
    var params = e.data.params || {};
    this._adsAdapter.startChronoView();
    this._sendAdEventIfAllowed(Constants.WillSendEvent.WILL_SEND_AD_BUFFER, Constants.Service.AD_BUFFER, params);
  },
  _adStopListener: function _adStopListener(e) {
    this._adsAdapter.stopChronoView();
    this._adsAdapter.flags.reset();
    this._totalPrerollsTime = (this._totalPrerollsTime || 0) + this._adsAdapter.chronos.total.getDeltaTime();
    var params = e.data.params || {};
    params.position = this.requestBuilder.lastSent.position;
    this._sendAdEventIfAllowed(Constants.WillSendEvent.WILL_SEND_AD_STOP, Constants.Service.AD_STOP, params);
    if (this.requestBuilder.lastSent.position === Constants.AdPosition.Postroll) {
      var pat = this.options['ad.expectedPattern'];
      this.playedPostrolls++;
      if (this.requestBuilder.lastSent.givenAds && this.requestBuilder.lastSent.givenAds <= this.playedPostrolls || !this.requestBuilder.lastSent.givenAds && pat && pat.post && pat.post[0] && pat.post[0] <= this.playedPostrolls) {
        this.fireStop();
      }
    }
    this.adConnected = true;
    this.adConnectedTime = new Date().getTime();
  },
  _adErrorListener: function _adErrorListener(e) {
    var params = e.data.params || {};
    if (this._adapter && !this._adapter.flags.isStarted && !this.isInitiated) {
      this._savedAdError = e;
      return null;
    }
    if (this._blockAdError(e.data.params)) return null;
    if (this._adsAdapter) {
      this._adsAdapter.fireManifest();
      this._adsAdapter.fireBreakStart();
    }
    if (!this._adsAdapter || !this._adsAdapter.flags.isStarted) {
      params.adNumber = this.requestBuilder.getNewAdNumber();
      params.adNumberInBreak = this.requestBuilder.getNewAdNumberInBreak();
    }
    if (!this.isBreakStarted) {
      params.breakNumber = this.requestBuilder.getNewBreakNumber();
    }
    this._sendAdEventIfAllowed(Constants.WillSendEvent.WILL_SEND_AD_ERROR, Constants.Service.AD_ERROR, params);
  },
  _adSavedError: function _adSavedError() {
    if (this._savedAdError) {
      this._adErrorListener(this._savedAdError);
      this._savedAdError = null;
    }
  },
  _adSavedManifest: function _adSavedManifest() {
    if (this._savedAdManifest) {
      this._adManifestListener(this._savedAdManifest);
      this._savedAdManifest = null;
    }
  },
  _blockAdError: function _blockAdError(errorParams) {
    var now = Date.now();
    var sameError = this._lastAdErrorParams && this._lastAdErrorParams.errorCode === errorParams.errorCode && this._lastAdErrorParams.msg === errorParams.msg && this._lastAdErrorParams.adCreativeId === this.getAdCreativeId();
    if (sameError && this._lastAdErrorTime + 5000 > now) {
      this._lastAdErrorTime = now;
      return true;
    }
    this._lastAdErrorTime = now;
    this._lastAdErrorParams = errorParams;
    return false;
  },
  _adClickListener: function _adClickListener(e) {
    var params = e.data.params || {};
    this._adsAdapter.stopChronoView();
    this._sendAdEventIfAllowed(Constants.WillSendEvent.WILL_SEND_AD_CLICK, Constants.Service.AD_CLICK, params);
  },
  _adManifestListener: function _adManifestListener(e) {
    if (!this.isAdsManifestSent) {
      if (this._adapter && !this._adapter.flags.isStarted && !this.isInitiated) {
        this._savedAdManifest = e;
        return null;
      }
      var params = e.data.params || {};
      this.isAdsManifestSent = true;
      this._sendAdEventIfAllowed(Constants.WillSendEvent.WILL_SEND_AD_MANIFEST, Constants.Service.AD_MANIFEST, params);
    }
  },
  _adBreakStartListener: function _adBreakStartListener(e) {
    if (!this.isBreakStarted) {
      this.isBreakStarted = true;
      if (this._adapter) this._adapter.firePause();
      var params = e.data.params || {};
      params.breakNumber = this.requestBuilder.getNewBreakNumber();
      this._sendAdEventIfAllowed(Constants.WillSendEvent.WILL_SEND_AD_POD_START, Constants.Service.AD_POD_START, params);
      this.adConnected = false;
    }
  },
  _adBreakStopListener: function _adBreakStopListener(e) {
    if (this.isBreakStarted) {
      this.isBreakStarted = false;
      var params = e.data.params || {};
      params.position = this.requestBuilder.lastSent.position;
      this._sendAdEventIfAllowed(Constants.WillSendEvent.WILL_SEND_AD_POD_STOP, Constants.Service.AD_POD_STOP, params);
      this.adConnected = false;
      if (this._adapter) this._adapter.fireResume();
    }
  },
  _adQuartileListener: function _adQuartileListener(e) {
    var params = e.data.params || {};
    if (params.quartile) {
      this._sendAdEventIfAllowed(Constants.WillSendEvent.WILL_SEND_AD_QUARTILE, Constants.Service.AD_QUARTILE, params);
    }
  },
  _sendAdEventIfAllowed: function _sendAdEventIfAllowed(willSend, service, params) {
    if (!this.options['ad.ignore']) this._send(willSend, service, params);
    Log.notice(service);
  }
};
module.exports = PluginAdsMixin;

/***/ }),

/***/ 63771:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(30415);
__webpack_require__(38051);
var Log = __webpack_require__(60244);
var Util = __webpack_require__(29021);
var version = __webpack_require__(11618);
var TransportFormat = __webpack_require__(63642);
var StreamingProtocol = __webpack_require__(96308);
var PluginContentGetterMixin = {
  getPlayhead: function getPlayhead() {
    var ret = this._safeGetterAdapter('getPlayhead');
    return Util.parseNumber(ret, 0);
  },
  getPlayrate: function getPlayrate() {
    var ret = 0;
    if (this._adapter && this._adapter.flags && !this._adapter.flags.isPaused) {
      try {
        ret = this._adapter.getPlayrate();
      } catch (err) {
        Log.warn('An error occured while calling getPlayrate', err);
      }
    }
    return ret;
  },
  getFramesPerSecond: function getFramesPerSecond() {
    return this._safeGetterAdapter('getFramesPerSecond', 'content.fps');
  },
  getSegmentDuration: function getSegmentDuration() {
    return this.hybridNetwork.getSegmentDuration() || this._safeGetterAdapter('getSegmentDuration', 'content.segmentDuration');
  },
  getDroppedFrames: function getDroppedFrames() {
    var ret = this._safeGetterAdapter('getDroppedFrames');
    if (!ret) {
      ret = this.getWebkitDroppedFrames();
    }
    return Util.parseNumber(ret, 0);
  },
  getWebkitDroppedFrames: function getWebkitDroppedFrames() {
    if (this._adapter && this._adapter.tag && this._adapter.tag.webkitDroppedFrameCount) {
      return this._adapter.tag.webkitDroppedFrameCount;
    }
    return null;
  },
  getDuration: function getDuration() {
    var ret = this._safeGetterAdapter('getDuration', 'content.duration') || null;
    return Util.parseNumber(Math.round(ret), null);
  },
  getBitrate: function getBitrate() {
    var ret = this._safeGetterAdapter('getBitrate', 'content.bitrate');
    if (!ret || ret === -1) {
      ret = this.getWebkitBitrate();
    }
    return Util.parseNumber(ret, -1);
  },
  getTotalBytes: function getTotalBytes() {
    return this.options['content.sendTotalBytes'] ? this._safeGetterAdapter('getTotalBytes', 'content.totalBytes') : null;
  },
  getWebkitBitrate: function getWebkitBitrate() {
    if (this._adapter && this._adapter.tag && this._adapter.tag.webkitVideoDecodedByteCount) {
      var bitrate = this._adapter.tag.webkitVideoDecodedByteCount;
      if (this._lastWebkitBitrate) {
        var delta = this._adapter.tag.webkitVideoDecodedByteCount - this._lastWebkitBitrate;
        bitrate = Math.round(delta / this.viewTransform.response.pingTime * 8);
      }
      this._lastWebkitBitrate = this._adapter.tag.webkitVideoDecodedByteCount;
      return bitrate !== 0 ? bitrate : -1;
    }
  },
  getThroughput: function getThroughput() {
    var ret = this._safeGetterAdapter('getThroughput', 'content.throughput');
    return Util.parseNumber(ret, -1);
  },
  getRendition: function getRendition() {
    return this._safeGetterAdapter('getRendition', 'content.rendition');
  },
  getTitle: function getTitle() {
    return this._safeGetterAdapter('getTitle', 'content.title');
  },
  getTitle2: function getTitle2() {
    return this._safeGetterAdapter('getTitle2', 'content.program');
  },
  getIsLive: function getIsLive() {
    var ret = this.options['content.isLive'];
    if (!ret && ret !== false) {
      ret = this._safeGetterAdapter('getIsLive') || false;
    }
    return ret;
  },
  getResource: function getResource() {
    return this._safeGetterAdapter('getResource', 'content.resource');
  },
  getParsedResource: function getParsedResource() {
    var ret = null;
    if (!this.resourceTransform.isBlocking()) {
      ret = this.resourceTransform.getResource();
    }
    ret = ret || this._safeGetterAdapter('getURLToParse');
    return ret === this.getResource() ? null : ret;
  },
  getTransactionCode: function getTransactionCode() {
    return this.options['content.transactionCode'];
  },
  getMetadata: function getMetadata() {
    return this.options['content.metadata'];
  },
  getPlayerVersion: function getPlayerVersion() {
    return this._safeGetterAdapter('getPlayerVersion') || '';
  },
  getPlayerName: function getPlayerName() {
    return this._safeGetterAdapter('getPlayerName') || '';
  },
  getCdn: function getCdn() {
    var ret = null;
    if (!this.resourceTransform.isBlocking()) {
      ret = this.resourceTransform.getCdnName();
    }
    return ret || this.options['content.cdn'];
  },
  getPluginVersion: function getPluginVersion() {
    var ret = this.getAdapterVersion();
    if (!ret) ret = version + '-adapterless-js';
    return ret;
  },
  getLibVersion: function getLibVersion() {
    return version;
  },
  getAdapterVersion: function getAdapterVersion() {
    return this._safeGetterAdapter('getVersion');
  },
  getCdnTraffic: function getCdnTraffic() {
    return this._safeGetterAdapter('getCdnTraffic') || this.hybridNetwork.getCdnTraffic();
  },
  getMultiCdnInfo: function getMultiCdnInfo() {
    return this.hybridNetwork.getMultiCdnInfo();
  },
  getBalancerResponseId: function getBalancerResponseId() {
    return this.hybridNetwork.getBalancerResponseId();
  },
  getP2PTraffic: function getP2PTraffic() {
    return this._safeGetterAdapter('getP2PTraffic') || this.hybridNetwork.getP2PTraffic();
  },
  getUploadTraffic: function getUploadTraffic() {
    return this._safeGetterAdapter('getUploadTraffic') || this.hybridNetwork.getUploadTraffic();
  },
  getIsP2PEnabled: function getIsP2PEnabled() {
    return this._safeGetterAdapter('getIsP2PEnabled') || this.hybridNetwork.getIsP2PEnabled();
  },
  getStreamingProtocol: function getStreamingProtocol() {
    var ret = this.options['content.streamingProtocol'];
    if (ret) {
      for (var i in StreamingProtocol) {
        if (StreamingProtocol[i] === ret) {
          return ret;
        }
      }
    }
    return null;
  },
  getTransportFormat: function getTransportFormat() {
    var ret = this.options['content.transportFormat'];
    if (!ret && this.options['parse.manifest'] && !this.resourceTransform.isBlocking()) {
      ret = this.resourceTransform.getTransportFormat();
    }
    if (ret) {
      for (var i in TransportFormat) {
        if (TransportFormat[i] === ret) {
          return ret;
        }
      }
    }
    return null;
  },
  getHouseholdId: function getHouseholdId() {
    return this._safeGetterAdapter('getHouseholdId');
  },
  getLatency: function getLatency() {
    return this.getIsLive() ? this._safeGetterAdapter('getLatency') : null;
  },
  getPacketLoss: function getPacketLoss() {
    return this._safeGetterAdapter('getPacketLoss');
  },
  getPacketSent: function getPacketSent() {
    return this._safeGetterAdapter('getPacketSent');
  },
  getVideoMetrics: function getVideoMetrics() {
    return Util.getMetricsFrom(this._adapter ? this._adapter.getMetrics() : null, this.options['content.metrics']);
  },
  getPlayerStartupTime: function getPlayerStartupTime() {
    return this.browserLoadTimes.getPlayerStartupTime();
  },
  getJoinDuration: function getJoinDuration() {
    return this._adapter ? this._adapter.chronos.join.getDeltaTime(false) : -1;
  },
  getBufferDuration: function getBufferDuration() {
    return this._adapter ? this._adapter.chronos.buffer.getDeltaTime(false) : -1;
  },
  getSeekDuration: function getSeekDuration() {
    return this._adapter ? this._adapter.chronos.seek.getDeltaTime(false) : -1;
  },
  getPauseDuration: function getPauseDuration() {
    return this._adapter ? this._adapter.chronos.pause.getDeltaTime(false) : 0;
  },
  getPackage: function getPackage() {
    return this.options['content.package'];
  },
  getSaga: function getSaga() {
    return this.options['content.saga'];
  },
  getTvShow: function getTvShow() {
    return this.options['content.tvShow'];
  },
  getSeason: function getSeason() {
    return this.options['content.season'];
  },
  getEpisodeTitle: function getEpisodeTitle() {
    return this.options['content.episodeTitle'];
  },
  getChannel: function getChannel() {
    return this.options['content.channel'];
  },
  getID: function getID() {
    return this.options['content.id'];
  },
  getImdbId: function getImdbId() {
    return this.options['content.imdbId'];
  },
  getGracenoteID: function getGracenoteID() {
    return this.options['content.gracenoteId'];
  },
  getType: function getType() {
    return this.options['content.type'];
  },
  getGenre: function getGenre() {
    return this.options['content.genre'];
  },
  getVideoLanguage: function getVideoLanguage() {
    return this.options['content.language'];
  },
  getSubtitles: function getSubtitles() {
    return this.options['content.subtitles'];
  },
  getContractedResolution: function getContractedResolution() {
    return this.options['content.contractedResolution'];
  },
  getCost: function getCost() {
    return this.options['content.cost'];
  },
  getPrice: function getPrice() {
    return this.options['content.price'];
  },
  getPlaybackType: function getPlaybackType() {
    var ret = this.options['content.playbackType'];
    if (!ret) {
      var isLive = this.options['content.isLive'];
      if (typeof isLive !== 'boolean') {
        isLive = this._safeGetterAdapter('getIsLive');
      }
      if (typeof isLive === 'boolean') {
        ret = isLive ? 'Live' : 'VoD';
      }
    }
    return ret;
  },
  getDRM: function getDRM() {
    return this.options['content.drm'];
  },
  getVideoCodec: function getVideoCodec() {
    return this._safeGetterAdapter('getVideoCodec', 'content.encoding.videoCodec');
  },
  getAudioCodec: function getAudioCodec() {
    return this._safeGetterAdapter('getAudioCodec', 'content.encoding.audioCodec');
  },
  getCodecSettings: function getCodecSettings() {
    return this.options['content.encoding.codecSettings'];
  },
  getCodecProfile: function getCodecProfile() {
    return this.options['content.encoding.codecProfile'];
  },
  getContainerFormat: function getContainerFormat() {
    return this.options['content.encoding.containerFormat'];
  },
  getLinkedViewId: function getLinkedViewId() {
    return this.options.linkedViewId;
  },
  _safeGetterAdapter: function _safeGetterAdapter(functionName, optionName) {
    var ret = null;
    if (optionName && this.options[optionName]) {
      ret = this.options[optionName];
    } else {
      try {
        if (this._adapter && typeof this._adapter[functionName] === 'function') {
          ret = this._adapter[functionName]();
        }
      } catch (err) {
        Log.warn('An error occured while calling ' + functionName, err);
      }
    }
    return ret;
  }
};
module.exports = PluginContentGetterMixin;

/***/ }),

/***/ 83756:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(93485);
__webpack_require__(30415);
__webpack_require__(53252);
__webpack_require__(38051);
__webpack_require__(94978);
var Log = __webpack_require__(60244);
var Constants = __webpack_require__(47905);
var Util = __webpack_require__(29021);
var Adapter = __webpack_require__(74366);
var PluginContentMixin = {
  setAdapter: function setAdapter(adapter) {
    if (this.browserLoadTimes) this.browserLoadTimes.setPlayerSetupTime();
    if (adapter.plugin) {
      Log.warn('Adapters can only be added to a single plugin');
    } else {
      this.removeAdapter();
      this._adapter = adapter;
      adapter.plugin = this;
      adapter.setIsAds(false);
      this.contentAdapterListeners = {};
      this.contentAdapterListeners[Adapter.Event.START] = this._startListener.bind(this);
      this.contentAdapterListeners[Adapter.Event.JOIN] = this._joinListener.bind(this);
      this.contentAdapterListeners[Adapter.Event.PAUSE] = this._pauseListener.bind(this);
      this.contentAdapterListeners[Adapter.Event.RESUME] = this._resumeListener.bind(this);
      this.contentAdapterListeners[Adapter.Event.SEEK_BEGIN] = this._seekBufferBeginListener.bind(this);
      this.contentAdapterListeners[Adapter.Event.SEEK_END] = this._seekEndListener.bind(this);
      this.contentAdapterListeners[Adapter.Event.BUFFER_BEGIN] = this._seekBufferBeginListener.bind(this);
      this.contentAdapterListeners[Adapter.Event.BUFFER_END] = this._bufferEndListener.bind(this);
      this.contentAdapterListeners[Adapter.Event.ERROR] = this._errorListener.bind(this);
      this.contentAdapterListeners[Adapter.Event.STOP] = this._stopListener.bind(this);
      this.contentAdapterListeners[Adapter.Event.VIDEO_EVENT] = this._videoEventListener.bind(this);
      for (var key in this.contentAdapterListeners) {
        this._adapter.on(key, this.contentAdapterListeners[key]);
      }
    }
  },
  getAdapter: function getAdapter() {
    return this._adapter;
  },
  removeAdapter: function removeAdapter() {
    if (this._adapter) {
      this._adapter.dispose();
      this._adapter.plugin = null;
      if (this.contentAdapterListeners) {
        for (var key in this.contentAdapterListeners) {
          this._adapter.off(key, this.contentAdapterListeners[key]);
        }
        delete this.contentAdapterListeners;
      }
      this._adapter = null;
    }
  },
  _startListener: function _startListener(e) {
    if (!this.isInitiated) {
      this.viewTransform.nextView();
      this._initComm();
      this._startPings();
    } else if (this.initChrono.startTime !== 0) {
      this._adapter.chronos.join.startTime = this.initChrono.startTime;
    }
    var params = e.data.params || {};
    var allParamsReady = this.getResource() && typeof this.getIsLive() === 'boolean' && (this.getIsLive() || typeof this.getDuration() === 'number' && this.getDuration() > 0) && this.getTitle();
    allParamsReady = this.options.forceInit ? false : allParamsReady && this._isExtraMetadataReady();
    if (allParamsReady && !this.isInitiated) {
      this._send(Constants.WillSendEvent.WILL_SEND_START, Constants.Service.START, params);
      this._adSavedError();
      this._adSavedManifest();
      Log.notice(Constants.Service.START + ' ' + (params.title || params.mediaResource));
      this.isStarted = true;
    } else if (!this.isInitiated) {
      this.isInitiated = true;
      this._adapter.chronos.join.start();
      this._send(Constants.WillSendEvent.WILL_SEND_INIT, Constants.Service.INIT, params);
      this._adSavedError();
      this._adSavedManifest();
      Log.notice(Constants.Service.INIT + ' ' + (params.title || params.mediaResource));
    }
  },
  _retryStart: function _retryStart(e) {
    if (this._isExtraMetadataReady()) {
      this._send(Constants.WillSendEvent.WILL_SEND_START, Constants.Service.START, {});
      this.startDelayed = false;
    }
  },
  _joinListener: function _joinListener(e) {
    var params = {};
    Util.assign(params, e.data.params || {});
    if (!this._adsAdapter || !this._adsAdapter.flags.isStarted) {
      if (this._adapter) {
        this._adapter.chronos.join.startTime = Math.min(this._adapter.chronos.join.startTime + (this._totalPrerollsTime || 0), new Date().getTime());
        this._totalPrerollsTime = 0;
      }
      if (this.isInitiated && !this.isStarted) {
        if (this._isExtraMetadataReady()) {
          this._send(Constants.WillSendEvent.WILL_SEND_START, Constants.Service.START, params);
        } else {
          this.startDelayed = true;
        }
        this._adSavedError();
        this._adSavedManifest();
        Log.notice(Constants.Service.START + ' ' + (params.title || params.mediaResource));
        this.isStarted = true;
      }
      params = e.data.params || {};
      if (this._adsAdapter && this.isBreakStarted) {
        this._adsAdapter.fireBreakStop();
      }
      this._send(Constants.WillSendEvent.WILL_SEND_JOIN, Constants.Service.JOIN, params);
      Log.notice(Constants.Service.JOIN + ' ' + params.joinDuration + 'ms');
    } else {
      if (this._adapter.monitor) this._adapter.monitor.stop();
      this._adapter.flags.isJoined = false;
      this._adapter.chronos.join.stopTime = 0;
    }
  },
  _pauseListener: function _pauseListener(e) {
    if (this._adapter) {
      if (this._adapter.flags.isBuffering || this._adapter.flags.isSeeking || this._adsAdapter && this._adsAdapter.flags.isStarted) {
        this._adapter.chronos.pause.reset();
      }
    }
    var params = e.data.params || {};
    this._send(Constants.WillSendEvent.WILL_SEND_PAUSE, Constants.Service.PAUSE, params);
    Log.notice(Constants.Service.PAUSE + ' at ' + params.playhead + 's');
  },
  _resumeListener: function _resumeListener(e) {
    if (this._adsAdapter && this.isBreakStarted && !this._adsAdapter.flags.isStarted) {
      this._adsAdapter.fireBreakStop();
    }
    var params = e.data.params || {};
    this._send(Constants.WillSendEvent.WILL_SEND_RESUME, Constants.Service.RESUME, params);
    Log.notice(Constants.Service.RESUME + ' ' + params.pauseDuration + 'ms');
    this._adapter.chronos.pause.reset();
  },
  _seekBufferBeginListener: function _seekBufferBeginListener(e) {
    if (this._adapter && this._adapter.flags.isPaused) this._adapter.chronos.pause.reset();
    if (e.type && e.type.includes('buffer')) {
      Log.notice(e.type + ', eventsTriggered: ' + this._adapter.fireEventsStruct.buffer);
    } else {
      Log.notice(e.type + ', eventsTriggered: ' + this._adapter.fireEventsStruct.seek);
    }
  },
  _seekEndListener: function _seekEndListener(e) {
    var params = e.data.params || {};
    this._send(Constants.WillSendEvent.WILL_SEND_SEEK, Constants.Service.SEEK, params);
    Log.notice(Constants.Service.SEEK + ' to ' + params.playhead + ' in ' + params.seekDuration + 'ms' + (params.triggeredEvents ? ', eventsTriggered: ' + params.triggeredEvents : ''));
  },
  _bufferEndListener: function _bufferEndListener(e) {
    var params = e.data.params || {};
    this._send(Constants.WillSendEvent.WILL_SEND_BUFFER, Constants.Service.BUFFER, params);
    Log.notice(Constants.Service.BUFFER + ' to ' + params.playhead + ' in ' + params.bufferDuration + 'ms' + (params.triggeredEvents ? ', eventsTriggered: ' + params.triggeredEvents : ''));
  },
  _errorListener: function _errorListener(e) {
    if (!this._blockError(e.data.params)) {
      this.fireError(e.data.params || {});
      this._adSavedError();
      this._adSavedManifest();
    }
  },
  _blockError: function _blockError(errorParams) {
    var now = Date.now();
    var sameError = this._lastErrorParams ? this._lastErrorParams.errorCode === errorParams.errorCode && this._lastErrorParams.msg === errorParams.msg : false;
    if (sameError && this._lastErrorTime + 5000 > now) {
      this._lastErrorTime = now;
      return true;
    }
    this._lastErrorTime = now;
    this._lastErrorParams = errorParams;
    return false;
  },
  _stopListener: function _stopListener(e) {
    this.fireStop(e.data.params || {});
  },
  _isStopReady: function _isStopReady(e) {
    var ret = false;
    if (!this.requestBuilder.lastSent.live && this._adsAdapter && this._adapter && (!this._adapter.getPlayhead() || this._adapter.getPlayhead() >= this.requestBuilder.lastSent.mediaDuration - 1)) {
      var expectedPostrolls = 0;
      var pat = this.options['ad.expectedPattern'];
      if (pat && pat.post && pat.post[0]) {
        expectedPostrolls = pat.post[0];
      } else if (this.requestBuilder.lastSent.breaksTime) {
        if (this.requestBuilder.lastSent.position === Constants.AdPosition.Postroll) {
          expectedPostrolls = this.requestBuilder.lastSent.givenAds;
        }
        if (!expectedPostrolls && this.requestBuilder.lastSent.breaksTime) {
          var breaks = this.requestBuilder.lastSent.breaksTime;
          if (breaks.length > 0 && this.requestBuilder.lastSent.mediaDuration) {
            var lastTimePosition = Math.round(breaks[breaks.length - 1]);
            if (lastTimePosition + 1 >= this.requestBuilder.lastSent.mediaDuration) {
              expectedPostrolls = 1;
            }
          }
        }
      } else {
        ret = true;
      }
      if (expectedPostrolls <= this.playedPostrolls) {
        ret = true;
      }
    } else {
      ret = true;
    }
    return ret;
  },
  _videoEventListener: function _videoEventListener(e) {
    this._send(Constants.WillSendEvent.WILL_SEND_VIDEO_EVENT, Constants.Service.VIDEO_EVENT, e.data.params);
  },
  _isExtraMetadataReady: function _isExtraMetadataReady(e) {
    if (!this.options.waitForMetadata || this.options.pendingMetadata.length < 1) return true;
    var getters = this.requestBuilder.getGetters();
    return this.options.pendingMetadata.map(function (element) {
      if (getters.hasOwnProperty(element)) {
        return !!this[getters[element]]();
      }
    }.bind(this)).indexOf(false) < 0;
  }
};
module.exports = PluginContentMixin;

/***/ }),

/***/ 23891:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(30415);
__webpack_require__(67478);
__webpack_require__(28610);
__webpack_require__(38051);
__webpack_require__(50851);
__webpack_require__(8612);
var Log = __webpack_require__(60244);
var Util = __webpack_require__(29021);
var Constants = __webpack_require__(47905);
var Transform = __webpack_require__(79877);
var PluginFireMixin = {
  fireInit: function fireInit(params, triggeredEvent) {
    if (!this.isInitiated) {
      if (!this.getAdapter() || this.getAdapter() && !this.getAdapter().flags.isStarted) {
        this.viewTransform.nextView();
        this._initComm();
        this._startPings();
        this.initChrono.start();
        this.isInitiated = true;
        params = params || {};
        if (triggeredEvent) {
          params.triggeredEvents = [triggeredEvent];
        }
        this._send(Constants.WillSendEvent.WILL_SEND_INIT, Constants.Service.INIT, params);
        this._adSavedError();
        this._adSavedManifest();
        Log.notice(Constants.Service.INIT + ' ' + (params.title || params.mediaResource));
      }
    }
  },
  fireError: function fireError(object, msg, metadata, level) {
    this.fireInit();
    var params = Util.buildErrorParams(object, msg, metadata, level);
    if (params.code) {
      delete params.code;
    }
    this._send(Constants.WillSendEvent.WILL_SEND_ERROR, Constants.Service.ERROR, params);
    this._adSavedError();
    this._adSavedManifest();
    Log.notice(Constants.Service.ERROR + ' ' + params.errorLevel + ' ' + params.errorCode);
    if (params.errorLevel === 'fatal') {
      this.fireStop();
    }
  },
  fireFatalError: function fireFatalError(object, msg, metadata, level) {
    this.fireError(object, msg, metadata, level);
    this.fireStop();
  },
  fireStop: function fireStop(params) {
    if (this.isInitiated || this.isStarted) {
      if (this._adapter) {
        this._adapter.flags.isStopped = true;
        if (this._adapter.monitor) this._adapter.monitor.stop();
      }
      if (this._adsAdapter && this.isBreakStarted) {
        this._adsAdapter.fireStop();
        this._adsAdapter.fireBreakStop();
      }
      params = params || {};
      this._send(Constants.WillSendEvent.WILL_SEND_STOP, Constants.Service.STOP, params);
      var chronos = this._adapter ? this._adapter.chronos : null;
      if (chronos) {
        chronos.total.stop();
        chronos.join.reset();
        chronos.pause.reset();
        chronos.buffer.reset();
        chronos.seek.reset();
      }
      Log.notice(Constants.Service.STOP + ' at ' + params.playhead + 's');
      this._reset();
    }
  },
  fireOfflineEvents: function fireOfflineEvents(params) {
    if (this.options && !this.options.offline) {
      if (!this.isInitiated && (!this._adapter || !this._adapter.flags.isStarted) && (!this._adsAdapter || !this._adsAdapter.flags.isStarted)) {
        this._offlineParams = params;
        if (this.viewTransform.response.code && this.viewTransform.response.host) {
          this._generateAndSendOffline();
        } else {
          this.offlineReference = this._generateAndSendOffline.bind(this);
          this.viewTransform.on(Transform.Event.DONE, this.offlineReference);
        }
      } else {
        Log.error('Adapters have to be stopped');
      }
    } else {
      Log.error('To send offline events, offline option must be disabled');
    }
  },
  _generateAndSendOffline: function _generateAndSendOffline() {
    if (this.options.disableStorage) return null;
    var params = this._offlineParams;
    this._initComm();
    while (true) {
      var bodyAndId = this.requestBuilder.buildBody(Constants.Service.OFFLINE_EVENTS).viewJson;
      if (bodyAndId[0] === null) break;
      var newViewCode = this.viewTransform.nextView();
      var body = bodyAndId[0].replace(/CODE_PLACEHOLDER/g, newViewCode.toString()).replace(/,"sessionId":"SESSION_PLACEHOLDER"/g, '').replace(/,"sessionRoot":"ROOT_PLACEHOLDER"/g, '');
      this._send(Constants.WillSendEvent.WILL_SEND_OFFLINE_EVENTS, Constants.Service.OFFLINE_EVENTS, params, body, 'POST', function (a, callbackParams) {
        this.offlineStorage.removeView(callbackParams.offlineId);
      }.bind(this), {
        offlineId: bodyAndId[1]
      });
    }
    this.offlineStorage.sent();
    this._offlineParams = null;
  }
};
module.exports = PluginFireMixin;

/***/ }),

/***/ 83323:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(67478);
__webpack_require__(50851);
var _typeof = __webpack_require__(45129);
var Util = __webpack_require__(29021);
var version = __webpack_require__(11618);
var RequestMethod = __webpack_require__(78856);
var PluginGetterMixin = {
  getHost: function getHost() {
    var host = this.options.host;
    if (this.viewTransform && this.viewTransform.response && this.viewTransform.response.host) {
      host = this.viewTransform.response.host;
    }
    return Util.addProtocol(Util.stripProtocol(host), this.options['app.https']);
  },
  getUserType: function getUserType() {
    return this.options['user.type'];
  },
  isParseManifest: function isParseManifest() {
    return this.options['parse.manifest'];
  },
  isParseCdnNode: function isParseCdnNode() {
    return this.options['parse.cdnNode'];
  },
  isCdnSwitch: function isCdnSwitch() {
    return this.options['parse.cdnSwitchHeader'];
  },
  getParseCdnNodeList: function getParseCdnNodeList() {
    return this.options['parse.cdnNode.list'];
  },
  getParseCdnNodeNameHeader: function getParseCdnNodeNameHeader() {
    return this.options['parse.cdnNameHeader'];
  },
  getParseNodeHeader: function getParseNodeHeader() {
    return this.options['parse.cdnNodeHeader'];
  },
  getObfuscateIp: function getObfuscateIp() {
    return this.options['user.obfuscateIp'];
  },
  getPrivacyProtocol: function getPrivacyProtocol() {
    var ret = this.options['user.privacyProtocol'];
    if (typeof ret === 'string') {
      ret = ret.toLowerCase();
    }
    return ret === 'optin' || ret === 'optout' ? ret : null;
  },
  getCustomDimensions: function getCustomDimensions() {
    var dim = this.options['content.customDimensions'];
    return _typeof(dim) === 'object' ? dim : null;
  },
  getExtraparam1: function getExtraparam1() {
    return this.options['content.customDimension.1'];
  },
  getExtraparam2: function getExtraparam2() {
    return this.options['content.customDimension.2'];
  },
  getExtraparam3: function getExtraparam3() {
    return this.options['content.customDimension.3'];
  },
  getExtraparam4: function getExtraparam4() {
    return this.options['content.customDimension.4'];
  },
  getExtraparam5: function getExtraparam5() {
    return this.options['content.customDimension.5'];
  },
  getExtraparam6: function getExtraparam6() {
    return this.options['content.customDimension.6'];
  },
  getExtraparam7: function getExtraparam7() {
    return this.options['content.customDimension.7'];
  },
  getExtraparam8: function getExtraparam8() {
    return this.options['content.customDimension.8'];
  },
  getExtraparam9: function getExtraparam9() {
    return this.options['content.customDimension.9'];
  },
  getExtraparam10: function getExtraparam10() {
    return this.options['content.customDimension.10'];
  },
  getExtraparam11: function getExtraparam11() {
    return this.options['content.customDimension.11'];
  },
  getExtraparam12: function getExtraparam12() {
    return this.options['content.customDimension.12'];
  },
  getExtraparam13: function getExtraparam13() {
    return this.options['content.customDimension.13'];
  },
  getExtraparam14: function getExtraparam14() {
    return this.options['content.customDimension.14'];
  },
  getExtraparam15: function getExtraparam15() {
    return this.options['content.customDimension.15'];
  },
  getExtraparam16: function getExtraparam16() {
    return this.options['content.customDimension.16'];
  },
  getExtraparam17: function getExtraparam17() {
    return this.options['content.customDimension.17'];
  },
  getExtraparam18: function getExtraparam18() {
    return this.options['content.customDimension.18'];
  },
  getExtraparam19: function getExtraparam19() {
    return this.options['content.customDimension.19'];
  },
  getExtraparam20: function getExtraparam20() {
    return this.options['content.customDimension.20'];
  },
  getAdExtraparam1: function getAdExtraparam1() {
    return this.options['ad.customDimension.1'];
  },
  getAdExtraparam2: function getAdExtraparam2() {
    return this.options['ad.customDimension.2'];
  },
  getAdExtraparam3: function getAdExtraparam3() {
    return this.options['ad.customDimension.3'];
  },
  getAdExtraparam4: function getAdExtraparam4() {
    return this.options['ad.customDimension.4'];
  },
  getAdExtraparam5: function getAdExtraparam5() {
    return this.options['ad.customDimension.5'];
  },
  getAdExtraparam6: function getAdExtraparam6() {
    return this.options['ad.customDimension.6'];
  },
  getAdExtraparam7: function getAdExtraparam7() {
    return this.options['ad.customDimension.7'];
  },
  getAdExtraparam8: function getAdExtraparam8() {
    return this.options['ad.customDimension.8'];
  },
  getAdExtraparam9: function getAdExtraparam9() {
    return this.options['ad.customDimension.9'];
  },
  getAdExtraparam10: function getAdExtraparam10() {
    return this.options['ad.customDimension.10'];
  },
  getPluginInfo: function getPluginInfo() {
    var ret = {
      lib: version,
      adapter: this.getAdapterVersion(),
      adAdapter: this.getAdAdapterVersion()
    };
    return ret;
  },
  getIp: function getIp() {
    return this.options['network.ip'];
  },
  getIsp: function getIsp() {
    return this.options['network.isp'];
  },
  getConnectionType: function getConnectionType() {
    return this.options['network.connectionType'];
  },
  getDeviceInfo: function getDeviceInfo() {
    var info = {};
    if (this.getDeviceCode()) info.deviceCode = this.getDeviceCode();
    if (this.getModel()) info.model = this.getModel();
    if (this.getBrand()) info.brand = this.getBrand();
    if (this.getDeviceType()) info.deviceType = this.getDeviceType();
    if (this.getDeviceName()) info.deviceName = this.getDeviceName();
    if (this.getOsName()) info.osName = this.getOsName();
    if (this.getOsVersion()) info.osVersion = this.getOsVersion();
    if (this.getBrowserName()) info.browserName = this.getBrowserName();
    if (this.getBrowserVersion()) info.browserVersion = this.getBrowserVersion();
    if (this.getBrowserType()) info.browserType = this.getBrowserType();
    if (this.getBrowserEngine()) info.browserEngine = this.getBrowserEngine();
    return info !== {} ? info : null;
  },
  getEDID: function getEDID() {
    var edid = this.options['device.EDID'];
    return edid ? edid.toString() : null;
  },
  getDeviceCode: function getDeviceCode() {
    return this.options['device.code'];
  },
  getModel: function getModel() {
    return this.options['device.model'];
  },
  getBrand: function getBrand() {
    return this.options['device.brand'];
  },
  getDeviceType: function getDeviceType() {
    return this.options['device.type'];
  },
  getDeviceName: function getDeviceName() {
    return this.options['device.name'];
  },
  getOsName: function getOsName() {
    return this.options['device.osName'];
  },
  getOsVersion: function getOsVersion() {
    return this.options['device.osVersion'];
  },
  getBrowserName: function getBrowserName() {
    return this.options['device.browserName'];
  },
  getBrowserVersion: function getBrowserVersion() {
    return this.options['device.browserVersion'];
  },
  getBrowserType: function getBrowserType() {
    return this.options['device.browserType'];
  },
  getBrowserEngine: function getBrowserEngine() {
    return this.options['device.browserEngine'];
  },
  getAccountCode: function getAccountCode() {
    return this.options.accountCode;
  },
  getUsername: function getUsername() {
    return this.options['user.name'];
  },
  getAnonymousUser: function getAnonymousUser() {
    return this.options['user.anonymousId'];
  },
  getEmail: function getEmail() {
    return this.options['user.email'];
  },
  getReferer: function getReferer() {
    var ret = this.options.referer || '';
    if (!ret && typeof window !== 'undefined' && window.location) {
      ret = window.location.href;
    }
    return ret;
  },
  getReferral: function getReferral() {
    var ret = this.options.referral || '';
    if (!ret && typeof document !== 'undefined') {
      ret = document.referrer;
    }
    return ret;
  },
  getLanguage: function getLanguage() {
    var ret = null;
    if (typeof navigator !== 'undefined') {
      ret = navigator.language;
    }
    return ret;
  },
  getNodeHost: function getNodeHost() {
    return this.options['content.cdnNode'] || this.resourceTransform.getNodeHost();
  },
  getNodeType: function getNodeType() {
    return this.options['content.cdnType'] || this.resourceTransform.getNodeType();
  },
  getNodeTypeString: function getNodeTypeString() {
    return this.resourceTransform.getNodeTypeString();
  },
  getRequestNumber: function getRequestNumber() {
    return Math.random();
  },
  getOfflineView: function getOfflineView() {
    var ret = null;
    if (this.offlineStorage) {
      ret = this.offlineStorage.getView();
    }
    return ret;
  },
  getDeviceUUID: function getDeviceUUID() {
    var id = null;
    if (!this.options['device.isAnonymous']) {
      id = this.options['device.id'] || this.uuidGenerator.getKey();
    }
    return id;
  },
  getSmartswitchConfigCode: function getSmartswitchConfigCode() {
    return this.options['smartswitch.configCode'];
  },
  getSmartswitchGroupCode: function getSmartswitchGroupCode() {
    return this.options['smartswitch.groupCode'];
  },
  getSmartswitchContractCode: function getSmartswitchContractCode() {
    return this.options['smartswitch.contractCode'];
  },
  getAppName: function getAppName() {
    return this.options['app.name'];
  },
  getAppReleaseVersion: function getAppReleaseVersion() {
    return this.options['app.releaseVersion'];
  },
  getIsBlocked: function getIsBlocked() {
    return this.options['ad.blockerDetected'];
  },
  isMethodPostEnabled: function isMethodPostEnabled() {
    return this.options.method && this.options.method.toLowerCase() === RequestMethod.POST;
  },
  getPlayheadMonitorEnabled: function getPlayheadMonitorEnabled() {
    return this.options['playhead.monitor'];
  },
  getReadyStateMonitorEnabled: function getReadyStateMonitorEnabled() {
    return this.options['readyState.monitor'];
  }
};
module.exports = PluginGetterMixin;

/***/ }),

/***/ 84410:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Util = __webpack_require__(29021);
var PluginInfinityGettersMixin = {
  getContext: function getContext() {
    return 'Default';
  },
  getScrollDepth: function getScrollDepth() {
    var ret = this.storage.getSession('pageScrollDepth');
    this.storage.removeSession('pageScrollDepth');
    return ret;
  },
  getSession: function getSession() {
    var ret = this.storage.getStorages('session');
    if (ret === 'undefined') {
      ret = undefined;
    }
    if (!ret) {
      var data = this.getStoredData();
      if (data) {
        try {
          ret = JSON.parse(data).q.c;
        } catch (err) {}
      }
    }
    return ret;
  },
  getStorageHost: function getStorageHost() {
    var ret = null;
    var data = this.getStoredData();
    if (data) {
      try {
        ret = JSON.parse(data).q.h;
      } catch (err) {}
    }
    return ret ? Util.addProtocol(ret, this.options['app.https']) : ret;
  },
  getStoredData: function getStoredData() {
    return this.storage.getStorages('data');
  },
  getDataTime: function getDataTime() {
    return this.storage.getStorages('dataTime');
  },
  getLastActive: function getLastActive() {
    return this.storage.getStorages('lastactive');
  },
  setStoredData: function setStoredData(data) {
    this.storage.setStorages('data', data);
  },
  setSession: function setSession(session) {
    this.storage.setStorages('session', session);
  },
  setDataTime: function setDataTime(time) {
    this.storage.setStorages('dataTime', time);
  },
  setLastActive: function setLastActive(last) {
    this.storage.setStorages('lastactive', last);
  },
  getPageName: function getPageName() {
    if (typeof document !== 'undefined' && document.title) {
      return document.title;
    }
  },
  getPageLoadTime: function getPageLoadTime() {
    return this.browserLoadTimes.getPageLoadTime();
  },
  getIsSessionExpired: function getIsSessionExpired() {
    var now = new Date().getTime();
    return !this.getSession() || this.infinity.getFirstActive() < now - this.sessionExpire;
  },
  getIsDataExpired: function getIsDataExpired() {
    var now = new Date().getTime();
    return !this.storage.isEnabled() || !this.getStoredData() || this.infinity.getFirstActive() < now - this.sessionExpire;
  }
};
module.exports = PluginInfinityGettersMixin;

/***/ }),

/***/ 11916:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(77402);
var Constants = __webpack_require__(47905);
var Log = __webpack_require__(60244);
var YBRequest = __webpack_require__(41142);
var Util = __webpack_require__(29021);
var YouboraInfinity = __webpack_require__(82063);
var PluginInfinityMixin = {
  _initInfinity: function _initInfinity() {
    this.infinity.on(YouboraInfinity.Event.NAV, this._navListener.bind(this));
    this.infinity.on(YouboraInfinity.Event.SESSION_START, this._sessionStartListener.bind(this));
    this.infinity.on(YouboraInfinity.Event.SESSION_STOP, this._sessionStopListener.bind(this));
    this.infinity.on(YouboraInfinity.Event.EVENT, this._eventListener.bind(this));
  },
  _sendInfinity: function _sendInfinity(willSendEvent, service, params) {
    params = this.requestBuilder.buildParams(params, service);
    var data = {
      params: params,
      plugin: this,
      adapter: this.getAdapter(),
      adsAdapter: this.getAdsAdapter()
    };
    this.emit(willSendEvent, data);
    if (this.infinity._comm && params !== null && this.options.enabled) {
      this.lastServeiceSent = service;
      var request = new YBRequest(null, service, params);
      if (this.isMethodPostEnabled()) {
        request.setPostRequest(true);
      }
      this.infinity._comm.sendRequest(request);
    }
  },
  _navListener: function _navListener(e) {
    var params = e.data.params || {};
    this._sendInfinity(Constants.WillSendEvent.WILL_SEND_NAV, Constants.Service.NAV, params);
    if (!this._beat.isRunning) this._beat.start();
    Log.notice(Constants.Service.NAV + ' ' + params.route);
  },
  _sessionStartListener: function _sessionStartListener(e) {
    var params = e.data.params || {};
    this._sendInfinity(Constants.WillSendEvent.WILL_SEND_SESSION_START, Constants.Service.SESSION_START, params);
    if (!this._beat.isRunning) this._beat.start();
    Log.notice(Constants.Service.SESSION_START + ' ' + params.route);
  },
  _sessionStopListener: function _sessionStopListener(e) {
    var params = e.data.params || {};
    this._sendInfinity(Constants.WillSendEvent.WILL_SEND_SESSION_STOP, Constants.Service.SESSION_STOP, params);
    if (this._beat.isRunning) this._beat.stop();
    Log.notice(Constants.Service.SESSION_STOP + ' ' + params.route);
  },
  _eventListener: function _eventListener(e) {
    var params = e.data.params || {};
    this._sendInfinity(Constants.WillSendEvent.WILL_SEND_EVENT, Constants.Service.EVENT, params);
    Log.notice(Constants.Service.EVENT + ' ' + params.name);
  },
  _sendBeat: function _sendBeat(diffTime) {
    var params = {
      diffTime: diffTime
    };
    this._sendInfinity(Constants.WillSendEvent.WILL_SEND_BEAT, Constants.Service.BEAT, params);
    if (this.infinity) {
      this.infinity._setLastActive();
    }
    Log.verbose(Constants.Service.BEAT);
  },
  getSessionMetrics: function getSessionMetrics() {
    return Util.getMetricsFrom(this.options['session.metrics']);
  }
};
module.exports = PluginInfinityMixin;

/***/ }),

/***/ 56852:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(38051);
var Log = __webpack_require__(60244);
var Constants = __webpack_require__(47905);
var PluginPingMixin = {
  _startPings: function _startPings() {
    if (!this._ping.isRunning) this._ping.start();
  },
  _stopPings: function _stopPings() {
    this._ping.stop();
  },
  _sendPing: function _sendPing(diffTime) {
    var params = {
      diffTime: diffTime,
      entities: this.requestBuilder.getChangedEntities()
    };
    if (this._adapter) {
      if (this._adapter.flags.isPaused) {
        params = this.requestBuilder.fetchParams(params, ['pauseDuration']);
      } else {
        params = this.requestBuilder.fetchParams(params, ['bitrate', 'throughput', 'fps']);
      }
      if (this._adapter.flags.isJoined) {
        params = this.requestBuilder.fetchParams(params, ['playhead']);
      }
      if (this._adapter.flags.isBuffering) {
        params = this.requestBuilder.fetchParams(params, ['bufferDuration']);
      }
      if (this._adapter.flags.isSeeking) {
        params = this.requestBuilder.fetchParams(params, ['seekDuration']);
      }
    }
    if (this._adsAdapter && !this.options['ad.ignore']) {
      if (this._adsAdapter.flags.isStarted) {
        params = this.requestBuilder.fetchParams(params, ['adPlayhead', 'adViewedDuration', 'adViewability']);
        if (this._adsAdapter.flags.isPaused) {
          params = this.requestBuilder.fetchParams(params, ['adPauseDuration']);
        } else {
          params = this.requestBuilder.fetchParams(params, ['adBitrate']);
        }
      }
      if (this._adsAdapter.flags.isBuffering) {
        params = this.requestBuilder.fetchParams(params, ['adBufferDuration']);
      }
    }
    this._send(Constants.WillSendEvent.WILL_SEND_PING, Constants.Service.PING, params);
    if (this.startDelayed) {
      this._retryStart();
    }
    Log.verbose(Constants.Service.PING);
  }
};
module.exports = PluginPingMixin;

/***/ }),

/***/ 68533:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(47865);
__webpack_require__(38051);
var Emitter = __webpack_require__(51973);
var Timer = __webpack_require__(42189);
var Chrono = __webpack_require__(2589);
var Constants = __webpack_require__(47905);
var Util = __webpack_require__(29021);
var YBRequest = __webpack_require__(41142);
var Communication = __webpack_require__(60502);
var FlowTransform = __webpack_require__(830);
var ViewTransform = __webpack_require__(97672);
var ResourceTransform = __webpack_require__(50522);
var OfflineTransform = __webpack_require__(19427);
var Options = __webpack_require__(94208);
var YouboraStorage = __webpack_require__(86820);
var OfflineStorage = __webpack_require__(49274);
var RequestBuilder = __webpack_require__(57829);
var YouboraInfinity = __webpack_require__(82063);
var HybridNetwork = __webpack_require__(63157);
var BrowserLoadTimes = __webpack_require__(60957);
var BackgroundDetector = __webpack_require__(60337);
var DeviceDetector = __webpack_require__(38803);
var ResizeScrollDetector = __webpack_require__(59406);
var UUIDGenerator = __webpack_require__(43582);
var Plugin = Emitter.extend({
  constructor: function constructor(options, adapter, dataReq) {
    if (typeof adapter === 'string' && !dataReq) {
      dataReq = adapter;
      adapter = null;
    }
    this.storage = new YouboraStorage();
    this.uuidGenerator = new UUIDGenerator(this);
    this.infinity = new YouboraInfinity(this);
    this.isInitiated = false;
    this.isAdsManifestSent = false;
    this.playedPostrolls = 0;
    this.isBreakStarted = false;
    this.initChrono = new Chrono();
    this.options = new Options(options);
    this.storage = new YouboraStorage(null, this.options.disableCookies, this.options.forceCookies, this.options.disableStorage);
    if (!this.options.disableStorage) {
      this.offlineStorage = new OfflineStorage();
    }
    this._adapter = null;
    this._adsAdapter = null;
    this._ping = new Timer(this._sendPing.bind(this), 5000);
    this._beat = new Timer(this._sendBeat.bind(this), 30000);
    this._refreshData = new Timer(this._checkOldData.bind(this), 3600000);
    this._refreshData.start();
    this.sessionExpire = Number(this.storage.getLocal('sessionExpire')) * 1000 || 180000;
    this.requestBuilder = new RequestBuilder(this);
    this.resourceTransform = new ResourceTransform(this);
    this.lastEventTime = null;
    this.restartViewTransform(dataReq);
    this._initInfinity();
    this.hybridNetwork = new HybridNetwork();
    this.browserLoadTimes = new BrowserLoadTimes(this);
    this.deviceDetector = new DeviceDetector();
    this.backgroundDetector = new BackgroundDetector(this);
    this.resizeScrollDetector = new ResizeScrollDetector(this);
    if (this.options['background.enabled']) this.backgroundDetector.startDetection();
    if (adapter) this.setAdapter(adapter);
  },
  _checkOldData: function _checkOldData() {
    if (this._adapter && this._adapter.flags.isStarted) return;
    if (this.infinity.infinityStarted) return;
    this.restartViewTransform();
  },
  restartViewTransform: function restartViewTransform(response) {
    this.viewTransform = new ViewTransform(this);
    this.viewTransform.on(ViewTransform.Event.DONE, this._receiveData.bind(this));
    if (response) {
      this.viewTransform.setData(response);
      return;
    }
    if (this.getIsDataExpired() || !this.getStorageHost() || this.storage.getLocal('accCode') !== this.options.accountCode && this.storage.getSession('accCode') !== this.options.accountCode) {
      this.storage.removeStorages('data');
      this.storage.removeStorages('session');
      this.storage.removeLocal('infinityStarted');
      this.viewTransform.init();
    } else {
      this.viewTransform.setData(this.getStoredData());
    }
  },
  _receiveData: function _receiveData(e) {
    this._ping.interval = e.target.response.pingTime * 1000;
    this._beat.interval = e.target.response.beatTime * 1000;
    this.sessionExpire = e.target.response.sessionExpire * 1000;
    this.storage.setStorages('data', e.target.response.msg);
    this.storage.setStorages('dataTime', new Date().getTime());
    this.storage.setStorages('accCode', this.options.accountCode);
    if (this.getIsSessionExpired()) {
      this.viewTransform.setSession(this.viewTransform.response.code);
      this.storage.setStorages('session', this.viewTransform.response.code);
      this.storage.setStorages('host', this.viewTransform.response.host);
    } else {
      this.viewTransform.setSession(this.getSession());
      this.viewTransform.setHost(this.getStorageHost());
    }
  },
  _reset: function _reset() {
    this._stopPings();
    this.resourceTransform = new ResourceTransform(this);
    if (this._adapter) {
      this._adapter.flags.reset();
    }
    this.isInitiated = false;
    this.isStarted = false;
    this.startDelayed = false;
    this.isAdsManifestSent = false;
    this.initChrono.reset();
    this._totalPrerollsTime = 0;
    this.requestBuilder.lastSent.breakNumber = 0;
    this.requestBuilder.lastSent.adNumber = 0;
    this._savedAdManifest = null;
    this._savedAdError = null;
    this.playedPostrolls = 0;
    this.isBreakStarted = false;
  },
  _send: function _send(willSendEvent, service, params, body, method, callback, callbackParams) {
    var now = new Date().getTime();
    if (this.options.preventZombieViews && this.lastEventTime && now > this.lastEventTime + 600 * 1000) {
      this.viewTransform.nextView();
    }
    this.lastEventTime = service === Constants.Service.STOP ? null : now;
    params = this.requestBuilder.buildParams(params, service);
    if (this.getIsLive()) {
      params.mediaDuration = this.options['content.duration'];
      params.playhead = undefined;
    }
    var data = {
      params: params,
      plugin: this,
      adapter: this.getAdapter(),
      adsAdapter: this.getAdsAdapter()
    };
    this.emit(willSendEvent, data);
    if (this._comm && (params !== null || typeof method !== 'undefined') && this.options.enabled) {
      this.lastServeiceSent = service;
      var options = {};
      if (typeof method !== 'undefined' && method !== 'GET') {
        options.method = method;
      }
      var request = new YBRequest(null, service, params, options);
      if (body) request.setBody(body);
      if (this.isMethodPostEnabled()) {
        request.setPostRequest(true);
      }
      this._comm.sendRequest(request, callback, callbackParams);
    }
  },
  _initComm: function _initComm() {
    var resource = this.getResource();
    if (this._adapter && this._adapter.getURLToParse()) {
      resource = this._adapter.getURLToParse();
    }
    this.resourceTransform.init(resource);
    this._comm = new Communication();
    this._comm.addTransform(new FlowTransform());
    this._comm.addTransform(this.viewTransform);
    if (this.options && this.options.offline) {
      this._comm.addTransform(new OfflineTransform(this));
    } else {
      this._comm.addTransform(this.resourceTransform);
    }
  },
  getComm: function getComm() {
    return this._comm;
  },
  setOptions: function setOptions(options) {
    if (options) {
      this.options.setOptions(options);
      if (typeof options['background.enabled'] === 'boolean') {
        if (options['background.enabled']) {
          this.backgroundDetector.startDetection();
        } else {
          this.backgroundDetector.stopDetection();
        }
      }
    }
  },
  getFastDataConfig: function getFastDataConfig() {
    return this.viewTransform.response.msg;
  },
  disable: function disable() {
    this.setOptions({
      enabled: false
    });
  },
  enable: function enable() {
    this.setOptions({
      enabled: true
    });
  }
}, {
  Event: Constants.WillSendEvent
});
Util.assign(Plugin.prototype, __webpack_require__(83756));
Util.assign(Plugin.prototype, __webpack_require__(83323));
Util.assign(Plugin.prototype, __webpack_require__(63771));
Util.assign(Plugin.prototype, __webpack_require__(81732));
Util.assign(Plugin.prototype, __webpack_require__(36819));
Util.assign(Plugin.prototype, __webpack_require__(56852));
Util.assign(Plugin.prototype, __webpack_require__(23891));
Util.assign(Plugin.prototype, __webpack_require__(11916));
Util.assign(Plugin.prototype, __webpack_require__(84410));
module.exports = Plugin;

/***/ }),

/***/ 57829:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(29548);
var YouboraObject = __webpack_require__(14074);
var Log = __webpack_require__(60244);
var startParams = ['accountCode', 'username', 'anonymousUser', 'rendition', 'deviceInfo', 'player', 'title', 'title2', 'live', 'segmentDuration', 'mediaDuration', 'mediaResource', 'parsedResource', 'transactionCode', 'properties', 'cdn', 'playerVersion', 'param1', 'param2', 'param3', 'param4', 'param5', 'param6', 'param7', 'param8', 'param9', 'param10', 'param11', 'param12', 'param13', 'param14', 'param15', 'param16', 'param17', 'param18', 'param19', 'param20', 'dimensions', 'playerStartupTime', 'obfuscateIp', 'privacyProtocol', 'p2pEnabled', 'pluginVersion', 'pluginInfo', 'isp', 'connectionType', 'ip', 'referer', 'userType', 'streamingProtocol', 'transportFormat', 'householdId', 'adsBlocked', 'adsExpected', 'deviceUUID', 'smartswitchConfigCode', 'smartswitchGroupCode', 'smartswitchContractCode', 'libVersion', 'nodeHost', 'nodeType', 'appName', 'appReleaseVersion', 'package', 'saga', 'tvshow', 'season', 'titleEpisode', 'channel', 'imdbID', 'gracenoteID', 'contentType', 'genre', 'contentLanguage', 'subtitles', 'cost', 'price', 'playbackType', 'email', 'drm', 'videoCodec', 'audioCodec', 'codecSettings', 'codecProfile', 'containerFormat', 'contentId', 'contractedResolution', 'linkedViewId', 'edid', 'cdnBalancerResponseUUID', 'triggeredEvents'];
var adStartParams = ['player', 'playhead', 'adTitle', 'position', 'adDuration', 'adCampaign', 'adCreativeId', 'adProvider', 'adResource', 'adPlayerVersion', 'adProperties', 'adAdapterVersion', 'adInsertionType', 'extraparam1', 'extraparam2', 'extraparam3', 'extraparam4', 'extraparam5', 'extraparam6', 'extraparam7', 'extraparam8', 'extraparam9', 'extraparam10', 'fullscreen', 'audio', 'skippable', 'adNumber', 'adNumberInBreak', 'breakNumber'];
var RequestBuilder = YouboraObject.extend({
  constructor: function constructor(plugin) {
    this._plugin = plugin;
    this._adNumber = 0;
    this._adNumberInBreak = 0;
    this.lastSent = {};
  },
  fetchParams: function fetchParams(params, paramList, onlyDifferent) {
    params = params || {};
    paramList = paramList || [];
    for (var i = 0; i < paramList.length; i++) {
      var param = paramList[i];
      if (params[param]) {
        continue;
      }
      var getterName = RequestBuilder.getters[param];
      if (this._plugin[getterName]) {
        var value = this._plugin[getterName]();
        if (value !== null && (!onlyDifferent || this.lastSent[param] !== value)) {
          params[param] = value;
          this.lastSent[param] = value;
        }
      } else {
        Log.warn('Trying to call undefined getter ' + param + ':' + getterName);
      }
    }
    return params;
  },
  getGetters: function getGetters() {
    return RequestBuilder.getters;
  },
  buildBody: function buildBody(service) {
    var body = null;
    return this.fetchParams(body, RequestBuilder.bodyParams[service], false);
  },
  buildParams: function buildParams(params, service) {
    params = params || {};
    this.fetchParams(params, RequestBuilder.params[service], false);
    this.fetchParams(params, RequestBuilder.differentParams[service], true);
    return params;
  },
  getNewAdNumber: function getNewAdNumber() {
    var adNumber = this.lastSent.adNumber;
    if (adNumber && this.lastSent.position === this._plugin.getAdPosition()) {
      adNumber += 1;
    } else {
      adNumber = 1;
    }
    this.lastSent.adNumber = adNumber;
    return adNumber;
  },
  getNewAdNumberInBreak: function getNewAdNumberInBreak() {
    this._adNumberInBreak++;
    this.lastSent.adNumberInBreak = this._adNumberInBreak;
    return this._adNumberInBreak;
  },
  getNewBreakNumber: function getNewBreakNumber() {
    var breakNumber = 1;
    this._adNumberInBreak = 0;
    if (this.lastSent.breakNumber) {
      breakNumber = this.lastSent.breakNumber + 1;
    }
    this.lastSent.breakNumber = breakNumber;
    return breakNumber;
  },
  getChangedEntities: function getChangedEntities() {
    return this.fetchParams({}, RequestBuilder.differentParams.entities, true);
  }
}, {
  params: {
    '/data': ['system', 'pluginVersion', 'requestNumber', 'username'],
    '/init': startParams,
    '/start': startParams,
    '/joinTime': ['joinDuration', 'playhead', 'bitrate', 'triggeredEvents'],
    '/pause': ['playhead', 'triggeredEvents'],
    '/resume': ['pauseDuration', 'playhead', 'triggeredEvents'],
    '/seek': ['seekDuration', 'playhead', 'triggeredEvents'],
    '/bufferUnderrun': ['bufferDuration', 'playhead', 'triggeredEvents'],
    '/error': ['player', 'playhead', 'triggeredEvents'].concat(startParams),
    '/stop': ['bitrate', 'totalBytes', 'playhead', 'pauseDuration', 'metrics', 'cdnDownloadedTraffic', 'multiCdnInfo', 'p2pDownloadedTraffic', 'uploadTraffic', 'triggeredEvents'],
    '/infinity/video/event': [],
    '/adInit': adStartParams,
    '/adStart': adStartParams,
    '/adJoin': ['playhead', 'position', 'adJoinDuration', 'adPlayhead', 'adNumber', 'adNumberInBreak', 'breakNumber'],
    '/adPause': ['playhead', 'position', 'adPlayhead', 'adNumber', 'adNumberInBreak', 'breakNumber'],
    '/adResume': ['playhead', 'position', 'adPlayhead', 'adPauseDuration', 'adNumber', 'adNumberInBreak', 'breakNumber'],
    '/adBufferUnderrun': ['playhead', 'position', 'adPlayhead', 'adBufferDuration', 'adNumber', 'adNumberInBreak', 'breakNumber'],
    '/adStop': ['playhead', 'position', 'adPlayhead', 'adBitrate', 'adTotalDuration', 'pauseDuration', 'adViewedDuration', 'adViewability', 'adNumber', 'adNumberInBreak', 'breakNumber'],
    '/adClick': ['playhead', 'position', 'adPlayhead', 'adNumber', 'adNumberInBreak', 'breakNumber'],
    '/adError': ['playhead'].concat(adStartParams),
    '/adManifest': ['givenBreaks', 'expectedBreaks', 'expectedPattern', 'breaksTime'],
    '/adBreakStart': ['position', 'givenAds', 'expectedAds', 'breakNumber', 'adInsertionType'],
    '/adBreakStop': ['position', 'breakNumber'],
    '/adQuartile': ['position', 'adViewedDuration', 'adViewability', 'adNumber', 'adNumberInBreak', 'breakNumber'],
    '/ping': ['droppedFrames', 'playrate', 'cdnDownloadedTraffic', 'multiCdnInfo', 'p2pDownloadedTraffic', 'uploadTraffic', 'latency', 'packetLoss', 'packetSent', 'metrics', 'totalBytes', 'segmentDuration'],
    '/infinity/session/start': ['accountCode', 'username', 'userType', 'anonymousUser', 'route', 'page', 'referer', 'referral', 'language', 'deviceInfo', 'adsBlocked', 'deviceUUID', 'libVersion', 'appName', 'appReleaseVersion', 'isp', 'connectionType', 'ip', 'obfuscateIp', 'privacyProtocol', 'dimensions', 'param1', 'param2', 'param3', 'param4', 'param5', 'param6', 'param7', 'param8', 'param9', 'param10', 'param11', 'param12', 'param13', 'param14', 'param15', 'param16', 'param17', 'param18', 'param19', 'param20', 'edid'],
    '/infinity/session/stop': ['sessionMetrics'],
    '/infinity/session/nav': ['route', 'page', 'scrollDepth'],
    '/infinity/session/beat': ['sessionMetrics'],
    '/infinity/session/event': ['accountCode'],
    '/offlineEvents': {}
  },
  bodyParams: {
    '/offlineEvents': ['viewJson']
  },
  differentParams: {
    entities: ['rendition', 'title', 'title2', 'param1', 'param2', 'param3', 'param4', 'param5', 'param6', 'param7', 'param8', 'param9', 'param10', 'param11', 'param12', 'param13', 'param14', 'param15', 'param16', 'param17', 'param18', 'param19', 'param20', 'cdn', 'nodeHost', 'nodeType', 'nodeTypeString', 'subtitles', 'contentLanguage']
  },
  getters: {
    requestNumber: 'getRequestNumber',
    playhead: 'getPlayhead',
    playrate: 'getPlayrate',
    fps: 'getFramesPerSecond',
    segmentDuration: 'getSegmentDuration',
    droppedFrames: 'getDroppedFrames',
    mediaDuration: 'getDuration',
    bitrate: 'getBitrate',
    totalBytes: 'getTotalBytes',
    throughput: 'getThroughput',
    rendition: 'getRendition',
    title: 'getTitle',
    title2: 'getTitle2',
    live: 'getIsLive',
    mediaResource: 'getResource',
    parsedResource: 'getParsedResource',
    transactionCode: 'getTransactionCode',
    properties: 'getMetadata',
    playerVersion: 'getPlayerVersion',
    player: 'getPlayerName',
    cdn: 'getCdn',
    pluginVersion: 'getPluginVersion',
    libVersion: 'getLibVersion',
    userType: 'getUserType',
    streamingProtocol: 'getStreamingProtocol',
    transportFormat: 'getTransportFormat',
    obfuscateIp: 'getObfuscateIp',
    privacyProtocol: 'getPrivacyProtocol',
    householdId: 'getHouseholdId',
    latency: 'getLatency',
    packetLoss: 'getPacketLoss',
    packetSent: 'getPacketSent',
    metrics: 'getVideoMetrics',
    dimensions: 'getCustomDimensions',
    param1: 'getExtraparam1',
    param2: 'getExtraparam2',
    param3: 'getExtraparam3',
    param4: 'getExtraparam4',
    param5: 'getExtraparam5',
    param6: 'getExtraparam6',
    param7: 'getExtraparam7',
    param8: 'getExtraparam8',
    param9: 'getExtraparam9',
    param10: 'getExtraparam10',
    param11: 'getExtraparam11',
    param12: 'getExtraparam12',
    param13: 'getExtraparam13',
    param14: 'getExtraparam14',
    param15: 'getExtraparam15',
    param16: 'getExtraparam16',
    param17: 'getExtraparam17',
    param18: 'getExtraparam18',
    param19: 'getExtraparam19',
    param20: 'getExtraparam20',
    extraparam1: 'getAdExtraparam1',
    extraparam2: 'getAdExtraparam2',
    extraparam3: 'getAdExtraparam3',
    extraparam4: 'getAdExtraparam4',
    extraparam5: 'getAdExtraparam5',
    extraparam6: 'getAdExtraparam6',
    extraparam7: 'getAdExtraparam7',
    extraparam8: 'getAdExtraparam8',
    extraparam9: 'getAdExtraparam9',
    extraparam10: 'getAdExtraparam10',
    position: 'getAdPosition',
    adNumber: 'getAdNumber',
    adNumberInBreak: 'getAdNumberInBreak',
    breakNumber: 'getBreakNumber',
    adPlayhead: 'getAdPlayhead',
    adDuration: 'getAdDuration',
    adCampaign: 'getAdCampaign',
    adCreativeId: 'getAdCreativeId',
    adBitrate: 'getAdBitrate',
    adTitle: 'getAdTitle',
    adResource: 'getAdResource',
    adPlayerVersion: 'getAdPlayerVersion',
    adProperties: 'getAdMetadata',
    adAdapterVersion: 'getAdAdapterVersion',
    givenBreaks: 'getGivenBreaks',
    expectedBreaks: 'getExpectedBreaks',
    expectedPattern: 'getExpectedPattern',
    breaksTime: 'getBreaksTime',
    givenAds: 'getGivenAds',
    expectedAds: 'getExpectedAds',
    adsExpected: 'getAdsExpected',
    adViewedDuration: 'getAdViewedDuration',
    adViewability: 'getAdViewability',
    fullscreen: 'getIsFullscreen',
    audio: 'getAudioEnabled',
    skippable: 'getIsSkippable',
    adProvider: 'getAdProvider',
    adInsertionType: 'getAdInsertionType',
    pluginInfo: 'getPluginInfo',
    isp: 'getIsp',
    connectionType: 'getConnectionType',
    ip: 'getIp',
    deviceInfo: 'getDeviceInfo',
    edid: 'getEDID',
    system: 'getAccountCode',
    accountCode: 'getAccountCode',
    username: 'getUsername',
    anonymousUser: 'getAnonymousUser',
    joinDuration: 'getJoinDuration',
    bufferDuration: 'getBufferDuration',
    seekDuration: 'getSeekDuration',
    pauseDuration: 'getPauseDuration',
    adJoinDuration: 'getAdJoinDuration',
    adBufferDuration: 'getAdBufferDuration',
    adPauseDuration: 'getAdPauseDuration',
    adTotalDuration: 'getAdTotalDuration',
    referer: 'getReferer',
    referral: 'getReferral',
    language: 'getLanguage',
    nodeHost: 'getNodeHost',
    nodeType: 'getNodeType',
    nodeTypeString: 'getNodeTypeString',
    route: 'getReferer',
    page: 'getPageName',
    playerStartupTime: 'getPlayerStartupTime',
    pageLoadTime: 'getPageLoadTime',
    cdnDownloadedTraffic: 'getCdnTraffic',
    multiCdnInfo: 'getMultiCdnInfo',
    p2pDownloadedTraffic: 'getP2PTraffic',
    p2pEnabled: 'getIsP2PEnabled',
    uploadTraffic: 'getUploadTraffic',
    cdnBalancerResponseUUID: 'getBalancerResponseId',
    viewJson: 'getOfflineView',
    deviceUUID: 'getDeviceUUID',
    sessionMetrics: 'getSessionMetrics',
    scrollDepth: 'getScrollDepth',
    adsBlocked: 'getIsBlocked',
    linkedViewId: 'getLinkedViewId',
    smartswitchConfigCode: 'getSmartswitchConfigCode',
    smartswitchGroupCode: 'getSmartswitchGroupCode',
    smartswitchContractCode: 'getSmartswitchContractCode',
    appName: 'getAppName',
    appReleaseVersion: 'getAppReleaseVersion',
    package: 'getPackage',
    saga: 'getSaga',
    tvshow: 'getTvShow',
    season: 'getSeason',
    titleEpisode: 'getEpisodeTitle',
    channel: 'getChannel',
    drm: 'getDRM',
    videoCodec: 'getVideoCodec',
    audioCodec: 'getAudioCodec',
    codecSettings: 'getCodecSettings',
    codecProfile: 'getCodecProfile',
    containerFormat: 'getContainerFormat',
    contentId: 'getID',
    imdbID: 'getImdbId',
    gracenoteID: 'getGracenoteID',
    contentType: 'getType',
    genre: 'getGenre',
    contentLanguage: 'getVideoLanguage',
    subtitles: 'getSubtitles',
    contractedResolution: 'getContractedResolution',
    cost: 'getCost',
    price: 'getPrice',
    playbackType: 'getPlaybackType',
    email: 'getEmail'
  }
});
module.exports = RequestBuilder;

/***/ }),

/***/ 86820:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(30415);
__webpack_require__(72578);
__webpack_require__(28610);
__webpack_require__(74389);
var YouboraObject = __webpack_require__(14074);
var Log = __webpack_require__(60244);
var YouboraStorage = YouboraObject.extend({
  constructor: function constructor(prefix, disableCookies, forceCookies, disable) {
    this.prefix = prefix || 'youbora';
    this.disableCookies = disableCookies;
    this.forceCookies = forceCookies;
    this.disabled = disable;
  },
  isEnabled: function isEnabled() {
    if (this.disabled) return false;
    var ret = true;
    if (!this.forceCookies) {
      try {
        localStorage.setItem(this.prefix + '.' + 'test', 'true');
        localStorage.removeItem(this.prefix + '.' + 'test');
      } catch (err) {
        ret = false;
      }
    }
    return ret;
  },
  setLocal: function setLocal(key, value) {
    if (this.disabled) return null;
    var ret = null;
    try {
      if (this.forceCookies || (typeof localStorage === 'undefined' || !localStorage) && !this.disableCookies) {
        ret = this._setCookie(this.prefix + '.local.' + key, value);
      } else {
        ret = localStorage.setItem(this.prefix + '.' + key, value);
      }
    } catch (err) {
      Log.error('Youbora Infinity needs localStorage or cookies, not supported by your browser.');
    }
    return ret;
  },
  getLocal: function getLocal(key) {
    if (this.disabled) return null;
    return this._localGetRemove('getItem', '_getCookie', key);
  },
  removeLocal: function removeLocal(key) {
    if (this.disabled) return null;
    return this._localGetRemove('removeItem', '_removeCookie', key);
  },
  _localGetRemove: function _localGetRemove(storageMethod, cookieMethod, key) {
    var ret = null;
    try {
      if (this.forceCookies || (typeof localStorage === 'undefined' || !localStorage) && !this.disableCookies) {
        ret = this[cookieMethod](this.prefix + '.local.' + key);
      } else {
        ret = localStorage[storageMethod](this.prefix + '.' + key);
      }
    } catch (err) {
      Log.error('Youbora Infinity needs localStorage or cookies, not supported by your browser.');
    }
    return ret;
  },
  setSession: function setSession(key, value) {
    if (this.disabled) return null;
    var ret = null;
    try {
      if (this.forceCookies || (typeof sessionStorage === 'undefined' || !sessionStorage) && !this.disableCookies) {
        ret = this._setCookie(this.prefix + '.session.' + key, value);
      } else {
        ret = sessionStorage.setItem(this.prefix + '.' + key, value);
      }
    } catch (err) {
      Log.error('Youbora Infinity needs sessionStorage or cookies, not supported by your browser.');
    }
    return ret;
  },
  getSession: function getSession(key) {
    if (this.disabled) return null;
    return this._sessionGetRemove('getItem', '_getCookie', key);
  },
  removeSession: function removeSession(key) {
    if (this.disabled) return null;
    return this._sessionGetRemove('removeItem', '_removeCookie', key);
  },
  _sessionGetRemove: function _sessionGetRemove(storageMethod, cookieMethod, key) {
    var ret = null;
    try {
      if (this.forceCookies || (typeof sessionStorage === 'undefined' || !sessionStorage) && !this.disableCookies) {
        ret = this[cookieMethod](this.prefix + '.session.' + key);
      } else {
        ret = sessionStorage[storageMethod](this.prefix + '.' + key);
      }
    } catch (err) {
      Log.error('Youbora Infinity needs sessionStorage or cookies, not supported by your browser.');
    }
    return ret;
  },
  getStorages: function getStorages(key) {
    return this.getSession(key) || this.getLocal(key);
  },
  setStorages: function setStorages(key, value) {
    this.setSession(key, value);
    this.setLocal(key, value);
  },
  removeStorages: function removeStorages(key) {
    this.removeSession(key);
    this.removeLocal(key);
  },
  _setCookie: function _setCookie(cname, cvalue) {
    if (typeof document !== 'undefined') {
      var domain = ';';
      if (typeof location !== 'undefined') {
        domain += 'domain=' + location.host.split('.').reverse().splice(0, 2).reverse().join('.') + ';path=/;';
      }
      document.cookie = cname + '=' + cvalue + domain;
    }
  },
  _getCookie: function _getCookie(cname) {
    if (typeof document !== 'undefined') {
      var name = cname + '=';
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
    }
    return null;
  },
  _removeCookie: function _removeCookie(cname) {
    this._setCookie(cname, '');
  }
});
module.exports = YouboraStorage;

/***/ }),

/***/ 57548:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(29548);
__webpack_require__(97343);
__webpack_require__(74391);
__webpack_require__(90565);
var applyPolyfills = function applyPolyfills() {
  Function.prototype.bind = Function.prototype.bind || function (context) {
    var slice = Array.prototype.slice;
    var func = this;
    var args = slice.call(arguments, 1);
    function bound() {
      var invokedAsConstructor = func.prototype && this instanceof func;
      return func.apply(!invokedAsConstructor && context || this, args.concat(slice.call(arguments)));
    }
    bound.prototype = func.prototype;
    return bound;
  };
  Array.prototype.forEach = Array.prototype.forEach || function (callback, thisArg) {
    if (typeof callback !== 'function') {
      throw new TypeError(callback + ' is not a function!');
    }
    var len = this.length;
    for (var i = 0; i < len; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
  Math.trunc = Math.trunc || function (x) {
    if (isNaN(x)) {
      return NaN;
    }
    if (x > 0) {
      return Math.floor(x);
    }
    return Math.ceil(x);
  };
};
module.exports = applyPolyfills;

/***/ }),

/***/ 42189:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var YouboraObject = __webpack_require__(14074);
var Chrono = __webpack_require__(2589);
var Timer = YouboraObject.extend({
  constructor: function constructor(callback, interval) {
    this.callback = callback;
    this.interval = interval || 5000;
    this.isRunning = false;
    this._timer = null;
    this.chrono = new Chrono();
  },
  start: function start() {
    if (!this.isRunning) {
      this.isRunning = true;
      this._setTick();
    }
  },
  stop: function stop() {
    this.isRunning = false;
    if (this._timer) {
      try {
        clearTimeout(this._timer);
        this._timer = null;
      } catch (err) {
        if (typeof atv !== 'undefined') {
          atv.clearTimeout(this._timer);
          this._timer = null;
        }
      }
    }
  },
  _setTick: function _setTick() {
    if (this.isRunning) {
      this.chrono.start();
      try {
        this._timer = setTimeout(function () {
          this.callback(this.chrono.stop());
          this._setTick();
        }.bind(this), this.interval);
      } catch (err) {
        if (typeof atv !== 'undefined') {
          this._timer = atv.setTimeout(function () {
            this.callback(this.chrono.stop());
            this._setTick();
          }.bind(this), this.interval);
        }
      }
    }
  }
});
module.exports = Timer;

/***/ }),

/***/ 29021:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(29548);
__webpack_require__(74391);
__webpack_require__(28610);
__webpack_require__(8612);
var _typeof = __webpack_require__(45129);
var Log = __webpack_require__(60244);
var Util = {
  stripProtocol: function stripProtocol(url) {
    var strippedUrl = url;
    try {
      strippedUrl = url.replace(/^(.*?:\/\/|\/\/)/i, '');
    } catch (err) {
      Log.warn(err);
    }
    return strippedUrl;
  },
  addProtocol: function addProtocol(url, httpSecure) {
    var serviceUrl = 'http://localhost/';
    try {
      serviceUrl = 'http://' + url;
      if (httpSecure || typeof window !== 'undefined' && window.location.protocol.indexOf('https') === 0) {
        serviceUrl = 'https://' + url;
      } else if (typeof window !== 'undefined' && window.location.protocol.indexOf('http') === 0) {
        serviceUrl = '//' + url;
      }
    } catch (err) {
      Log.warn(err);
    }
    return serviceUrl;
  },
  parseNumber: function parseNumber(n, def) {
    return !isNaN(n) && n >= 0 && n !== Infinity && n !== -Infinity && n !== null && typeof n !== 'undefined' ? n : def;
  },
  logAllEvents: function logAllEvents(o, extraEvents, report) {
    try {
      if (Log.logLevel <= Log.Level.DEBUG) {
        report = report || function (e) {
          Log.debug('Event: ' + e.type);
        };
        var playerEvents = ['canplay', 'buffering', 'waiting', 'ended', 'play', 'playing', 'pause', 'resume', 'error', 'abort', 'seek', 'seeking', 'seeked', 'stalled', 'dispose', 'loadeddata', 'loadstart'];
        if (extraEvents) {
          if (extraEvents[0] === null) {
            extraEvents.shift();
            playerEvents = extraEvents;
          } else {
            playerEvents = playerEvents.concat(extraEvents);
          }
        }
        for (var i = 0; i < playerEvents.length; i++) {
          if (typeof o === 'function') {
            o.call(window, playerEvents[i], report);
          } else if (o.on) {
            o.on(playerEvents[i], report);
          } else if (o.addEventListener) {
            o.addEventListener(playerEvents[i], report);
          }
        }
      }
    } catch (err) {
      Log.error(err);
    }
  },
  buildRenditionString: function buildRenditionString(width, height, bitrate) {
    if (arguments.length === 1) {
      bitrate = width;
      width = null;
      height = null;
    }
    var ret = null;
    if (width && height) {
      ret = width + 'x' + height;
    }
    if (typeof bitrate === 'number' && !isNaN(bitrate) && bitrate >= 1) {
      if (ret) {
        ret += '@';
      } else {
        ret = '';
      }
      if (bitrate < 1e3) {
        ret += Math.round(bitrate) + 'bps';
      } else if (bitrate < 1e6) {
        bitrate = Math.round(bitrate / 1e3);
        ret += bitrate + 'Kbps';
      } else {
        bitrate = Math.round(bitrate / 1e4) / 1e2;
        ret += bitrate + 'Mbps';
      }
    }
    return ret;
  },
  buildErrorParams: function buildErrorParams(code, msg, metadata, level) {
    var params = {};
    if (_typeof(code) === 'object' && code !== null) {
      params = code;
    } else {
      params.errorCode = code || 'FAILURE';
      params.msg = msg || params.errorCode;
      params.errorMetadata = metadata;
      params.errorLevel = level;
    }
    return params;
  },
  calculateAdViewability: function calculateAdViewability(player, screenPercent) {
    var isVisible = true;
    if (typeof window !== 'undefined' && player && typeof player.getBoundingClientRect === 'function') {
      var box = player.getBoundingClientRect();
      if (box.top >= window.innerHeight || box.bottom <= 0 || box.right <= 0 || box.left >= window.innerWidth) {
        isVisible = false;
      } else {
        var pixels = Math.trunc(box.height * box.width);
        var x1 = box.top > 0 ? box.top : 0;
        var x2 = box.bottom > window.innerHeight ? window.innerHeight : box.bottom;
        var y1 = box.left > 0 ? box.left : 0;
        var y2 = box.right > window.innerWidth ? window.innerWidth : box.right;
        var inScreenPixels = (y2 - y1) * (x2 - x1);
        isVisible = inScreenPixels * 100 > pixels * (screenPercent || 50);
      }
    }
    return isVisible;
  },
  getMetricsFrom: function getMetricsFrom(op1, op2) {
    var metrics = op1 || op2;
    for (var metric in metrics) {
      if (_typeof(metrics[metric]) !== 'object' || !metrics[metric].value) {
        var temporal = {};
        temporal.value = metrics[metric];
        metrics[metric] = temporal;
      }
    }
    return metrics;
  },
  assign: __webpack_require__(34027),
  isArray: __webpack_require__(46821)
};
module.exports = Util;

/***/ }),

/***/ 11618:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(34705).version;

/***/ }),

/***/ 90894:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var previousYoubora = youbora;
var youbora = {};
youbora.noConflict = function () {
  youbora = previousYoubora;
  return this;
};
youbora.VERSION = __webpack_require__(11618);
youbora.polyfills = __webpack_require__(57548);
youbora.polyfills();
youbora.Object = __webpack_require__(14074);
youbora.Emitter = __webpack_require__(51973);
youbora.Log = __webpack_require__(60244);
youbora.Log.loadLevelFromUrl();
youbora.Util = __webpack_require__(29021);
youbora.HybridNetwork = __webpack_require__(63157);
youbora.Chrono = __webpack_require__(2589);
youbora.Timer = __webpack_require__(42189);
youbora.Constants = __webpack_require__(47905);
youbora.Request = __webpack_require__(41142);
youbora.Communication = __webpack_require__(60502);
youbora.Transform = __webpack_require__(79877);
youbora.ViewTransform = __webpack_require__(97672);
youbora.ResourceTransform = __webpack_require__(50522);
youbora.CdnParser = __webpack_require__(57360);
youbora.HlsParser = __webpack_require__(75694);
youbora.DashParser = __webpack_require__(80654);
youbora.OfflineParser = __webpack_require__(19427);
youbora.LocationheaderParser = __webpack_require__(5571);
youbora.Options = __webpack_require__(94208);
youbora.Plugin = __webpack_require__(68533);
youbora.Storage = __webpack_require__(86820);
youbora.RequestBuilder = __webpack_require__(57829);
youbora.PlayheadMonitor = __webpack_require__(19534);
youbora.Adapter = __webpack_require__(74366);
youbora.adapters = {};
youbora.Infinity = __webpack_require__(82063);
youbora.BackgroundDetector = __webpack_require__(60337);
youbora.DeviceDetector = __webpack_require__(38803);
youbora.UUIDGenerator = __webpack_require__(43582);
youbora.registerAdapter = function (key, Adapter) {
  this.adapters[key] = Adapter;
}.bind(youbora);
youbora.unregisterAdapter = function (key) {
  this.adapters[key] = null;
}.bind(youbora);
module.exports = youbora;

/***/ }),

/***/ 62352:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(29548);
var _defineProperty = __webpack_require__(47572);
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var isPlainObject = __webpack_require__(69143);
var _require = __webpack_require__(59554),
  appEnableEnvOverride = _require.appEnableEnvOverride,
  appEnv = _require.appEnv,
  appCustomer = _require.appCustomer,
  appPlatform = _require.appPlatform;
var config = {};
if (false) {} else {
  config = __webpack_require__(12208);
  if (appEnableEnvOverride) {
    if (!isPlainObject(config.configByEnv)) {
      throw new Error("Cannot get config for \"".concat(appEnv, "\" env: `config.configByEnv` is not a valid object.\nEnsure that you have pre-built the config with env override flag: `APP_ENABLE_ENV_OVERRIDE=true ... pnpm build-config`"));
    }
    if (!isPlainObject(config.configByEnv[appEnv])) {
      throw new Error("Cannot get config for \"".concat(appEnv, "\" env: `config.configByEnv['").concat(appEnv, "']` is not a valid object."));
    }
    config = _objectSpread({}, config.configByEnv[appEnv]);
  }
}
module.exports = config;

/***/ }),

/***/ 98026:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   drmErrorStates: () => (/* binding */ drmErrorStates),
/* harmony export */   playerErrorStates: () => (/* binding */ playerErrorStates),
/* harmony export */   playerStates: () => (/* binding */ playerStates)
/* harmony export */ });
var playerErrorStates = {
  0: {
    message: 'A/V format not supported',
    code: 4032
  },
  1: {
    message: 'Cannot connect to server or connection lost',
    code: 1001
  },
  2: {
    message: 'Unidentified error',
    code: 3016
  },
  3: {
    message: 'Insufficient resources',
    code: 3016
  },
  4: {
    message: 'Content corrupt or invalid',
    code: 4032
  },
  5: {
    message: 'Content not available',
    code: 1001
  },
  6: {
    message: 'Content not available at given position',
    code: 3016
  },
  7: {
    message: 'Content blocked due to parental control',
    code: 3016
  }
};
var drmErrorStates = {
  0: {
    message: 'No license, consumption of the content is blocked',
    code: 6001
  },
  1: {
    message: 'Invalid license, consumption of the content is blocked',
    code: 6004
  },
  2: {
    message: 'Valid license, consumption of the content is unblocked',
    code: 0
  }
};
var playerStates = {
  STOPPED: 0,
  PLAYING: 1,
  PAUSED: 2,
  CONNECTING: 3,
  BUFFERING: 4,
  FINISHED: 5,
  ERROR: 6
};

/***/ }),

/***/ 57568:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(10115);
__webpack_require__(47865);
__webpack_require__(86602);
__webpack_require__(28610);
__webpack_require__(8612);
var youbora = __webpack_require__(90894);
var _require = __webpack_require__(98026),
  playerErrorStates = _require.playerErrorStates;
youbora.adapters.VodafoneOIPF = youbora.Adapter.extend({
  getPlayerName: function getPlayerName() {
    return 'vodafone-oipf';
  },
  getPlayerVersion: function getPlayerVersion() {
    return 'bedrock-vodafone-oipf-v1.0.0';
  },
  getPlayhead: function getPlayhead() {
    if (!this.player) {
      return Number.isFinite(this._lastPlaybackPosition) ? this._lastPlaybackPosition : 0;
    }
    this._lastPlaybackPosition = this.player.playPosition / 1000;
    return this._lastPlaybackPosition;
  },
  getDuration: function getDuration() {
    if (!this.player) {
      return 0;
    }
    return this.player.playTime / 1000;
  },
  getBitrate: function getBitrate() {
    if (!this.player) {
      return null;
    }
    var result = this.player.currentRepresentation;
    return Number.isFinite(result) ? result : null;
  },
  getResource: function getResource() {
    if (!this.player) {
      return '';
    }
    var url = this.player.data || this.player.src;
    if (!url) {
      return '';
    }
    return url.replace(/&custom_data.*$/i, '');
  },
  getRendition: function getRendition() {
    try {
      var tracks = this.player.representations;
      var bitrate = this.getBitrate();
      var track = tracks.find(function (_ref) {
        var bandwidth = _ref.bandwidth;
        return bandwidth == bitrate;
      });
      return youbora.Util.buildRenditionString(track.width, track.height, this.getBitrate());
    } catch (error) {
      return '';
    }
  },
  registerListeners: function registerListeners() {
    var _this = this;
    this.monitorPlayhead(true, true);
    if (!this.player) {
      youbora.Log.error('The player reference set to the adapter is invalid.');
      return;
    }
    this.states = {
      STOPPED: 0,
      PLAYING: 1,
      PAUSED: 2,
      CONNECTING: 3,
      BUFFERING: 4,
      FINISHED: 5,
      ERROR: 6
    };
    var playerEngineStateListener = this.player.onPlayStateChange;
    this.player.onPlayStateChange = function () {
      _this.playStateChangeListener();
      if (playerEngineStateListener) {
        playerEngineStateListener();
      }
    };
    var playerEnginePositionListener = this.player.onPlayPositionChanged;
    this.player.onPlayPositionChanged = function () {
      _this.playPositionChangeListener();
      if (playerEnginePositionListener) {
        playerEnginePositionListener();
      }
    };
  },
  unregisterListeners: function unregisterListeners() {
    if (this.player) {
      this.player.onPlayStateChange = null;
      this.player.onPlayPositionChanged = null;
    }
    if (this.monitor) {
      this.monitor.stop();
    }
    this.player = undefined;
  },
  disconnect: function disconnect() {
    this.unregisterListeners();
  },
  connect: function connect(player) {
    this.player = player;
    this.registerListeners();
  },
  playStateChangeListener: function playStateChangeListener() {
    if (!this.player) {
      return;
    }
    switch (this.player.playState) {
      case this.states.STOPPED:
        this.fireStop();
        break;
      case this.states.PLAYING:
        this.fireInit({}, 'contentSelected');
        this.fireResume({}, 'playingListener');
        this.fireSeekEnd();
        break;
      case this.states.PAUSED:
        this.firePause({}, 'pauseListener');
        break;
      case this.states.CONNECTING:
      case this.states.BUFFERING:
        this.fireInit({}, 'contentSelected');
        break;
      case this.states.FINISHED:
        this.fireStop({}, 'endedListener');
        break;
      case this.states.ERROR:
        {
          var _ref2 = playerErrorStates[this.player.error] || {},
            code = _ref2.code,
            message = _ref2.message;
          this.fireFatalError(code, message, undefined, undefined, 'errorListener');
          break;
        }
      default:
        break;
    }
  },
  playPositionChangeListener: function playPositionChangeListener() {
    this.fireJoin({}, 'timeupdateListener');
  }
});
module.exports = youbora.adapters.VodafoneOIPF;

/***/ }),

/***/ 59554:
/***/ ((module) => {

var DEVELOPMENT = 'development';
var DETECTIVE = 'detective';
var STAGING = 'staging';
var PROD = 'prod';
var TEST = 'test';
var DEFAULT_APP_CUSTOMER = 'default';
var appEnv = "prod";
var appVersion = "1.48.0";
var appCustomer = {"PELO_PLATFORM":"vodafone","APP_VERSION":"1.48.0","OPTIONS":"{\"platform\":\"vodafone\",\"packaged\":false,\"debug\":false,\"skipHook\":false,\"skipNativeBuild\":true,\"skipBundler\":false}","GITHUB_STATE":"/runner/_work/_temp/_runner_file_commands/save_state_6041b297-2e35-451c-a738-c808c6587fef","npm_package_dependencies__babel_runtime":"7.22.3","npm_package_dependencies__pelo_plugins_screen":"workspace:*","npm_package_dependencies_regenerator_runtime":"0.13.11","npm_package_devDependencies_identity_obj_proxy":"3.0.0","npm_package_scripts_build_config_rtlnl":"APP_CUSTOMER=rtlnl node scripts/build-config","KUBERNETES_SERVICE_PORT":"443","KUBERNETES_PORT":"tcp://[fd39:f9c4:855c::1]:443","npm_package_dependencies_immutable_set":"2.1.0","npm_package_devDependencies__storybook_addon_knobs":"6.2.9","npm_package_devDependencies_prettier_eslint_cli":"7.1.0","npm_package_scripts_preinstall":"npx only-allow pnpm","npm_package_devDependencies__storybook_addon_docs":"6.2.9","npm_package_devDependencies_jest":"29.5.0","npm_package_devDependencies_webpack_bundle_analyzer":"4.10.2","npm_package_scripts_dev_rtlnl":"APP_CUSTOMER=rtlnl pnpm dev","npm_config_user_agent":"pnpm/9.14.4 npm/? node/v22.19.0 linux x64","CI":"true","npm_package_dependencies__bedrock_rdk_constants":"workspace:*","npm_package_dependencies__tornado_rdk_theme":"workspace:*","npm_package_dependencies_abortcontroller_polyfill":"1.7.8","npm_package_devDependencies__lightningjs_cli":"2.2.0","npm_package_scripts_build_config_rtlhu":"APP_CUSTOMER=rtlhu node scripts/build-config","npm_package_scripts_prod_rtlnl":"APP_CUSTOMER=rtlnl pnpm prod","HOSTNAME":"app-bedrock-rdk-deploy-wsgds-d6wcd","RUNNER_ENVIRONMENT":"self-hosted","GITHUB_ENV":"/runner/_work/_temp/_runner_file_commands/set_env_6041b297-2e35-451c-a738-c808c6587fef","UPLOAD_SOURCE_MAPS":"false","npm_package_dependencies__bedrock_rdk_utils":"workspace:*","npm_node_execpath":"/opt/hostedtoolcache/node/22.19.0/x64/bin/node","GITHUB_ACTIONS_RUNNER_EXTRA_USER_AGENT":"actions-runner-controller/v0.27.6","RUNNER_EPHEMERAL":"true","SHLVL":"4","npm_package_packageManager":"pnpm@9.14.4","npm_package_dependencies__bedrock_rdk_lng_storybook":"workspace:*","npm_package_dependencies_html_webpack_plugin":"5.5.0","npm_package_devDependencies__swc_core":"1.3.95","npm_package_scripts_dev_rtlhu":"APP_CUSTOMER=rtlhu pnpm dev","npm_package_scripts_nr_create_browser_applications":"node scripts/createNewRelicApps.js","HOME":"/home/runner","npm_package_devDependencies__babel_plugin_proposal_class_properties":"7.18.6","npm_package_devDependencies__bedrock_package_json_loader":"1.2.4","npm_package_devDependencies_jest_webgl_canvas_mock":"0.2.3","npm_package_scripts_prod_rtlhu":"APP_CUSTOMER=rtlhu pnpm prod","RUNNER_ORG":"","AWS_ROLE_ARN":"arn:aws:iam::374115518324:role/irsa/runners/app-bedrock-rdk-deploy","RUNNER_TEMP":"/runner/_work/_temp","GITHUB_EVENT_PATH":"/runner/_work/_temp/_github_workflow/event.json","npm_package_devDependencies_eslint_config_prettier":"9.0.0","npm_package_scripts_lint_filenames":"node scripts/checkFileScopes.js","npm_package_scripts_server":"http-server -c-1 build","npm_package_scripts_storybook_rtlde":"APP_CUSTOMER=rtlde start-storybook -p 6006","DOCKER_ENABLED":"true","GITHUB_REPOSITORY_OWNER":"m6web","npm_package_engines_node":"22.x","npm_package_dependencies__bedrock_html5_engine":"3.6.8","npm_package_devDependencies__6play_ryp":"3.2.4","npm_package_devDependencies__bedrock_github_api_utils":"1.0.1","npm_package_scripts_lint_json":"pnpm sort-keys:json --lint && prettier-eslint --list-different '/{.,}*.json' --ignore-path '**/package.json'","RUNNER_WORKDIR":"/runner/_work","GENERATE_SOURCEMAP":"true","AWS_WEB_IDENTITY_TOKEN_FILE":"/var/run/secrets/eks.amazonaws.com/serviceaccount/token","GITHUB_RETENTION_DAYS":"7","npm_package_devDependencies__pelo_platforms_vodafone":"10.0.0-alpha.1","npm_package_devDependencies_minimist":"1.2.5","npm_package_scripts_i18n_pull":"node ./scripts/i18nPull.js","npm_package_scripts_lint_md":"pnpm prettier-eslint --list-different $PWD/'**/*.md' $PWD/'.*/**/*.md'","GITHUB_REPOSITORY_OWNER_ID":"5","GITHUB_HEAD_REF":"","npm_package_dependencies_redux_thunk":"2.3.0","ACTIONS_RUNNER_HOOK_JOB_STARTED":"/etc/arc/hooks/job-started.sh","npm_package_dependencies_copy_webpack_plugin":"11.0.0","npm_package_devDependencies__swc_plugin_transform_imports":"1.5.94","npm_package_devDependencies_source_map_explorer":"1.6.0","npm_package_cypress_cucumber_preprocessor_stepDefinitions_0":"cypress/e2e/common/*.js","GITHUB_GRAPHQL_URL":"https://github.m6web.fr/api/graphql","REF":"v1.48.0","npm_package_dependencies__tornado_rdk_icons":"workspace:*","npm_package_dependencies_algoliasearch":"4.12.1","npm_package_dependencies_superagent":"3.8.3","npm_package_devDependencies_slack":"11.0.2","npm_package_scripts_build_config":"node scripts/build-config","npm_package_cypress_cucumber_preprocessor_stepDefinitions_1":"cypress/e2e/[filepart]/**/*.js","npm_package_dependencies_jwt_decode":"2.2.0","npm_package_devDependencies__babel_preset_env":"7.12.1","npm_package_scripts_e2e_rtlnl":"APP_CUSTOMER=rtlnl pnpm cypress open --e2e -b chrome","npm_package_pnpm_overrides__lightningjs_core":"2.9.0","npm_package_cypress_cucumber_preprocessor_stepDefinitions_2":"cypress/e2e/[filepart].js","GITHUB_URL":"https://github.m6web.fr/","RUNNER_ASSETS_DIR":"/runnertmp","npm_package_devDependencies__babel_plugin_transform_runtime":"7.22.4","npm_package_devDependencies_inquirer":"8.1.5","npm_package_scripts_dev":"APP_ENV=development pelo run","RUNNER_OS":"Linux","GITHUB_API_URL":"https://github.m6web.fr/api/v3","MAXPROC":"8","RUNNER_LABELS":"self-hosted,app-bedrock-rdk-deploy","npm_package_devDependencies__pelo_platforms_ziggo":"10.0.0-alpha.1","npm_package_devDependencies_eslint_plugin_import":"2.28.1","npm_package_scripts_logs":"node scripts/logs.js","npm_package_scripts_prod":"APP_ENV=prod pelo run","_":"/home/runner/setup-pnpm/node_modules/.bin/pnpm","RUNNER_GROUP":"green-gha-eks-bedrock-tech","HELM_REGISTRY_CONFIG":"/home/runner/.docker/config.json","GITHUB_WORKFLOW":"🏷 Release staging","npm_package_private":"true","npm_package_dependencies_sprintf_js":"1.1.2","npm_package_devDependencies__m6web_eslint_config":"3.5.0","npm_package_devDependencies_jsonlint":"1.6.3","npm_package_scripts_build_rtlnl":"APP_CUSTOMER=rtlnl pnpm build","npm_package_dependencies__bedrock_rdk_media_engine":"workspace:*","npm_package_dependencies_lightningjs_redux":"workspace:*","npm_package_devDependencies__babel_plugin_proposal_decorators":"7.22.3","npm_package_scripts_lint":"pnpm lint:js && pnpm lint:md && pnpm lint:json && pnpm lint:filenames","npm_config_registry":"https://verdaccio.bedrock.tech","GITHUB_RUN_ID":"3165446","npm_package_dependencies__bedrock_fido_sdk":"29.30.0","npm_package_dependencies_core_js":"3.32.1","npm_package_devDependencies__swc_jest":"0.2.29","npm_package_scripts_lint_tf":"terraform fmt -check -recursive -diff .cloud/terraform","npm_package_scripts_sort_keys_json":"node ./scripts/sortKeysJson.js","npm_package_pnpm_overrides_lodash":"4.17.21","GITHUB_REF_TYPE":"branch","GITHUB_WORKFLOW_SHA":"4ff2b3c7a982f2634428e9d3f25c715365c487e8","KUBERNETES_PORT_443_TCP_ADDR":"fd39:f9c4:855c::1","GITHUB_BASE_REF":"","ImageOS":"ubuntu22","npm_package_devDependencies_dotenv_expand":"5.1.0","npm_package_scripts_build_rtlhu":"APP_CUSTOMER=rtlhu pnpm build","GITHUB_WORKFLOW_REF":"m6web/app-bedrock-rdk/.github/workflows/release-deploy-staging.yml@refs/heads/master","GITHUB_ACTION_REPOSITORY":"","npm_config_node_gyp":"/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/dist/node_modules/node-gyp/bin/node-gyp.js","PATH":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.bin:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/dist/node-gyp-bin:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.bin:/opt/hostedtoolcache/node/22.19.0/x64/bin:/home/runner/setup-pnpm/node_modules/.bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin:/home/runner/.local/bin/","RUNNER_TRACKING_ID":"github_d6d391a5-4033-4ac4-8937-906499292394","RUNNER_TOOL_CACHE":"/opt/hostedtoolcache","npm_package_name":"app-bedrock-rdk","npm_package_repository_type":"git","npm_package_dependencies_serve":"14.1.2","npm_package_devDependencies__babel_eslint_parser":"7.22.15","npm_package_scripts_lint_js":"pnpm eslint --max-warnings=0 .pelo.config.js src/ packages/ platforms/ --cache","NODE":"/opt/hostedtoolcache/node/22.19.0/x64/bin/node","GITHUB_ACTION":"__run_4","GITHUB_RUN_NUMBER":"312","GITHUB_TRIGGERING_ACTOR":"skovalchuk-externe","RUNNER_ARCH":"X64","KUBERNETES_PORT_443_TCP_PORT":"443","npm_package_devDependencies_eslint_config_airbnb_base":"15.0.0","npm_package_scripts_analyze":"APP_ENV=detective pnpm build","npm_package_scripts_build_config_rtlde":"APP_CUSTOMER=rtlde node scripts/build-config","npm_config_frozen_lockfile":"","RUN_URL":"https://github.m6web.fr/m6web/app-bedrock-rdk/actions/runs/3165446","KUBERNETES_PORT_443_TCP_PROTO":"tcp","npm_package_dependencies__pelo_plugins_device":"workspace:*","npm_package_devDependencies__bedrock_deploy_event":"0.11.0","npm_package_devDependencies__pelo_platforms_web":"10.0.0-alpha.1","npm_package_devDependencies__swc_helpers":"0.5.3","npm_package_devDependencies_glob":"7.1.6","npm_package_devDependencies_prettier_eslint":"15.0.1","npm_package_dependencies__lightningjs_core":"2.9.0","npm_package_dependencies_history":"4.9.0","npm_package_dependencies_redux":"4.0.5","npm_package_dependencies_swc_minify_webpack_plugin":"2.1.1","npm_package_devDependencies__storybook_theming":"6.2.9","npm_package_devDependencies_eslint":"8.50.0","npm_package_devDependencies_webpack":"5.88.2","npm_package_scripts_dev_rtlde":"APP_CUSTOMER=rtlde pnpm dev","npm_package_scripts_format_md":"prettier-eslint --write $PWD/'**/*.md' $PWD/'.*/**/*.md'","npm_package_scripts_storybook_rtlnl":"APP_CUSTOMER=rtlnl start-storybook -p 6006","RUNNER_NAME":"app-bedrock-rdk-deploy-wsgds-d6wcd","GITHUB_REF_NAME":"master","GITHUB_REPOSITORY":"m6web/app-bedrock-rdk","S3_PATH":"s3://bedrock-rdk-rtlde-staging-vodafone","npm_package_devDependencies__storybook_html":"6.2.9","npm_package_devDependencies_dotenv":"16.0.3","npm_package_scripts_e2e":"pnpm cypress open --e2e -b chrome","npm_package_scripts_prod_rtlde":"APP_CUSTOMER=rtlde pnpm prod","npm_lifecycle_script":"pelo build \"vodafone\" \"--skip-native-build\"","GITHUB_ACTION_REF":"","DEBIAN_FRONTEND":"noninteractive","npm_package_devDependencies__babel_runtime_corejs3":"7.22.3","npm_package_devDependencies__cypress_webpack_preprocessor":"6.0.0","npm_package_devDependencies__pelo_core":"10.0.0-alpha.1","npm_package_devDependencies__storybook_addons":"6.2.9","npm_package_scripts_test":"PELO_PLATFORM=rdk APP_ENV=test node scripts/test --config=config/jest/config.js","GITHUB_REPOSITORY_ID":"2571","GITHUB_ACTIONS":"true","GOPROXY":"https://goproxy.services.bedrock.tech","NODE_PATH":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules/@pelo/cli/bin/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules/@pelo/cli/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules/@pelo/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/bin/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/node_modules","npm_package_repository_url":"https://github.m6web.fr/m6web/app-bedrock-rdk.git","npm_package_version":"1.48.0","npm_package_dependencies__bedrock_ad_engine":"5.29.4","npm_package_devDependencies__m6web_eslint_plugin_i18n":"2.0.1","npm_package_devDependencies_jest_environment_jsdom":"29.5.0","npm_package_scripts_storybook_rtlhu":"APP_CUSTOMER=rtlhu start-storybook -p 6006","npm_package_pnpm_overrides__lightningjs_sdk":"5.5.5","npm_lifecycle_event":"build","ACTIONS_RUNNER_HOOK_JOB_COMPLETED":"/etc/arc/hooks/job-completed.sh","GITHUB_REF_PROTECTED":"true","GONOSUMDB":"github.m6web.fr","GONOPROXY":"none","npm_package_dependencies_uuid":"10.0.0","npm_package_scripts_build":"pelo build \"vodafone\" \"--skip-native-build\"","npm_package_scripts_upload":"node scripts/uploadToMetrologicalAppStore","GITHUB_WORKSPACE":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","GITHUB_JOB":"build","npm_package_author":"Bedrock","npm_package_engines_pnpm":"9.x.x","npm_package_dependencies__bedrock_youbora_adapter_adengine":"1.7.22","npm_package_dependencies_lodash":"4.17.21","npm_package_devDependencies_cypress":"13.3.0","npm_package_devDependencies_http_server":"14.1.1","npm_package_scripts_test_coverage":"PELO_PLATFORM=rdk APP_ENV=test node scripts/test --config=config/jest/config.js --coverage","GITHUB_SHA":"4ff2b3c7a982f2634428e9d3f25c715365c487e8","GOMAXPROC":"8","GITHUB_RUN_ATTEMPT":"1","DOCKER_HOST":"unix:///run/docker.sock","npm_package_dependencies__bedrock_media_engine":"4.13.0","npm_package_devDependencies__pelo_cli":"10.0.0-alpha.1","KUBERNETES_SERVICE_PORT_HTTPS":"443","GOPRIVATE":"*.m6web.fr,*.bedrock.tech","GITHUB_REF":"refs/heads/master","KUBERNETES_PORT_443_TCP":"tcp://[fd39:f9c4:855c::1]:443","GITHUB_ACTOR":"skovalchuk-externe","npm_package_license":"UNLICENSED","npm_package_dependencies_markdown_it":"12.2.0","DOCKERD_IN_RUNNER":"false","npm_package_dependencies_crypto_js":"3.1.9-1","npm_package_dependencies_qrcode":"1.5.4","npm_package_dependencies_stream_browserify":"3.0.0","npm_package_devDependencies_eslint_plugin_prettier":"5.0.0","npm_package_scripts_format":"pnpm format:js && pnpm format:md && pnpm format:lang","npm_package_scripts_update_lang":"run-s 'i18n:pull {1}' format:lang --","GITHUB_PATH":"/runner/_work/_temp/_runner_file_commands/add_path_6041b297-2e35-451c-a738-c808c6587fef","PWD":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","IS_STAGING":"true","APP_ENV":"prod","GITHUB_ACTOR_ID":"627","KUBERNETES_SERVICE_HOST":"fd39:f9c4:855c::1","RUNNER_WORKSPACE":"/runner/_work/app-bedrock-rdk","npm_package_dependencies_path_to_regexp":"3.0.0","npm_package_scripts_explore":"source-map-explorer build/static/js/main.*","npm_package_scripts_format_tf":"terraform fmt -recursive -write=true .cloud/terraform","npm_execpath":"/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/bin/pnpm.cjs","GITHUB_EVENT_NAME":"workflow_dispatch","GITHUB_SERVER_URL":"https://github.m6web.fr","GITHUB_OUTPUT":"/runner/_work/_temp/_runner_file_commands/set_output_6041b297-2e35-451c-a738-c808c6587fef","npm_package_dependencies__bedrock_rdk_config":"workspace:*","npm_package_devDependencies__pelo_platforms_kpn":"10.0.0-alpha.1","npm_package_devDependencies_es_check":"7.1.1","npm_package_devDependencies_fs_extra":"9.1.0","npm_package_devDependencies_swc_mut_cjs_exports":"0.86.17","RUNNER_STATUS_UPDATE_HOOK":"false","npm_package_dependencies_browser_cookies":"1.2.0","npm_package_dependencies_date_fns":"2.28.0","npm_package_devDependencies__badeball_cypress_cucumber_preprocessor":"18.0.6","npm_package_devDependencies_svgo_loader":"3.0.1","npm_package_scripts_build_storybook":"build-storybook -o dist-storybook","npm_command":"run-script","PNPM_SCRIPT_SRC_DIR":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","APP_CUSTOMER":"rtlde","npm_package_dependencies_storybook_addon_themes":"6.1.0","npm_package_devDependencies__storybook_addon_essentials":"6.2.9","npm_package_scripts_format_js":"prettier-eslint --write $PWD/'src/**/*.js' $PWD/'packages/**/*.js' $PWD/'platforms/**/*.js' $PWD/'config/**/*.js'","PNPM_HOME":"/home/runner/setup-pnpm/node_modules/.bin","RUNNER_ENTERPRISE":"","npm_package_dependencies__tornado_rdk_typography":"workspace:*","npm_package_dependencies_babel_loader":"9.1.2","GITHUB_STEP_SUMMARY":"/runner/_work/_temp/_runner_file_commands/step_summary_6041b297-2e35-451c-a738-c808c6587fef","npm_package_dependencies__lightningjs_sdk":"5.5.5","npm_package_dependencies__pelo_plugins_keys":"workspace:*","npm_package_devDependencies_swc_loader":"0.2.3","npm_package_scripts_build_rtlde":"APP_CUSTOMER=rtlde pnpm build","npm_package_scripts_format_lang":"prettier-eslint --write $PWD/'lang/**/*.json'","npm_package_pnpm_overrides_webpack":"5.88.2","npm_package_pnpm_peerDependencyRules_allowedVersions_webpack":"5","INIT_CWD":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","NODE_ENV":"production"}.APP_CUSTOMER || DEFAULT_APP_CUSTOMER;
var appPlatform = "vodafone";
var isDevelopmentApp = appEnv === DEVELOPMENT;
var isDetectiveApp = appEnv === DETECTIVE;
var isStagingApp = appEnv === STAGING;
var isProdApp = appEnv === PROD;
var isTestApp = appEnv === TEST;
module.exports = {
  appCustomer: appCustomer,
  appEnv: appEnv,
  appPlatform: appPlatform,
  appVersion: appVersion,
  isDetectiveApp: isDetectiveApp,
  isDevelopmentApp: isDevelopmentApp,
  isProdApp: isProdApp,
  isStagingApp: isStagingApp,
  isTestApp: isTestApp
};

/***/ }),

/***/ 15645:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(29548);
var _typeof = __webpack_require__(45129);
(function (e, n) {
  function t(e) {
    return _typeof(e) === 'object' ? JSON.parse(JSON.stringify(e)) : e;
  }
  e[n] = e[n] || {
    nlsQ: function nlsQ(o, r, c) {
      var s = e.document;
      var a = s.createElement('script');
      a.async = 1;
      a.src = "".concat(e.location.protocol === 'http:' ? 'http:' : 'https:', "//cdn-gl.nmrodam.com/conf/").concat(o, ".js#name=").concat(r, "&ns=").concat(n);
      var i = s.getElementsByTagName('script')[0];
      return i.parentNode.insertBefore(a, i), e[n][r] = e[n][r] || {
        g: c || {},
        ggPM: function ggPM(o, c, s, a, i) {
          e[n][r].q = e[n][r].q || [];
          try {
            var l = t([o, c, s, a, i]);
            e[n][r].q.push(l);
          } catch (e) {
            console && console.log && console.log('Error: Cannot register event in Nielsen SDK queue.');
          }
        },
        trackEvent: function trackEvent(o) {
          e[n][r].te = e[n][r].te || [];
          try {
            var _c = t(o);
            e[n][r].te.push(_c);
          } catch (e) {
            console && console.log && console.log('Error: Cannot register event in Nielsen SDK queue.');
          }
        }
      }, e[n][r];
    }
  };
})(window, 'NOLBUNDLE');

/***/ }),

/***/ 65415:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 91620:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(65415)
var ieee754 = __webpack_require__(30551)
var customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

var K_MAX_LENGTH = 0x7fffffff
exports.kMaxLength = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    var proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    var copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        Buffer.from(buf).copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (var i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = (function () {
  var alphabet = '0123456789abcdef'
  var table = new Array(256)
  for (var i = 0; i < 16; ++i) {
    var i16 = i * 16
    for (var j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()


/***/ }),

/***/ 63099:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__(72870);

var callBind = __webpack_require__(72755);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),

/***/ 72755:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var bind = __webpack_require__(48794);
var GetIntrinsic = __webpack_require__(72870);

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),

/***/ 14907:
/***/ ((module) => {


/**
 * Expose `Emitter`.
 */

if (true) {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }

  // Remove event specific arrays for event types that no
  // one is subscribed for to avoid memory leak.
  if (callbacks.length === 0) {
    delete this._callbacks['$' + event];
  }

  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};

  var args = new Array(arguments.length - 1)
    , callbacks = this._callbacks['$' + event];

  for (var i = 1; i < arguments.length; i++) {
    args[i - 1] = arguments[i];
  }

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),

/***/ 44596:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isCallable = __webpack_require__(31808);
var tryToString = __webpack_require__(38151);

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw $TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ 67877:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isConstructor = __webpack_require__(92701);
var tryToString = __webpack_require__(38151);

var $TypeError = TypeError;

// `Assert: IsConstructor(argument) is true`
module.exports = function (argument) {
  if (isConstructor(argument)) return argument;
  throw $TypeError(tryToString(argument) + ' is not a constructor');
};


/***/ }),

/***/ 9316:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isCallable = __webpack_require__(31808);

var $String = String;
var $TypeError = TypeError;

module.exports = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw $TypeError("Can't set " + $String(argument) + ' as a prototype');
};


/***/ }),

/***/ 58521:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var wellKnownSymbol = __webpack_require__(15537);
var create = __webpack_require__(91026);
var defineProperty = (__webpack_require__(3002).f);

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] === undefined) {
  defineProperty(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ 12051:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var charAt = (__webpack_require__(97124).charAt);

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),

/***/ 87787:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isPrototypeOf = __webpack_require__(88304);

var $TypeError = TypeError;

module.exports = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw $TypeError('Incorrect invocation');
};


/***/ }),

/***/ 79308:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isObject = __webpack_require__(27627);

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw $TypeError($String(argument) + ' is not an object');
};


/***/ }),

/***/ 11940:
/***/ ((module) => {

"use strict";

// eslint-disable-next-line es/no-typed-arrays -- safe
module.exports = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';


/***/ }),

/***/ 15611:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it
var fails = __webpack_require__(79645);

module.exports = fails(function () {
  if (typeof ArrayBuffer == 'function') {
    var buffer = new ArrayBuffer(8);
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
    if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', { value: 8 });
  }
});


/***/ }),

/***/ 63214:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var NATIVE_ARRAY_BUFFER = __webpack_require__(11940);
var DESCRIPTORS = __webpack_require__(40369);
var global = __webpack_require__(27990);
var isCallable = __webpack_require__(31808);
var isObject = __webpack_require__(27627);
var hasOwn = __webpack_require__(48496);
var classof = __webpack_require__(25786);
var tryToString = __webpack_require__(38151);
var createNonEnumerableProperty = __webpack_require__(60859);
var defineBuiltIn = __webpack_require__(96561);
var defineBuiltInAccessor = __webpack_require__(4259);
var isPrototypeOf = __webpack_require__(88304);
var getPrototypeOf = __webpack_require__(56285);
var setPrototypeOf = __webpack_require__(27323);
var wellKnownSymbol = __webpack_require__(15537);
var uid = __webpack_require__(40160);
var InternalStateModule = __webpack_require__(47776);

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var Int8Array = global.Int8Array;
var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
var Uint8ClampedArray = global.Uint8ClampedArray;
var Uint8ClampedArrayPrototype = Uint8ClampedArray && Uint8ClampedArray.prototype;
var TypedArray = Int8Array && getPrototypeOf(Int8Array);
var TypedArrayPrototype = Int8ArrayPrototype && getPrototypeOf(Int8ArrayPrototype);
var ObjectPrototype = Object.prototype;
var TypeError = global.TypeError;

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var TYPED_ARRAY_TAG = uid('TYPED_ARRAY_TAG');
var TYPED_ARRAY_CONSTRUCTOR = 'TypedArrayConstructor';
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var NATIVE_ARRAY_BUFFER_VIEWS = NATIVE_ARRAY_BUFFER && !!setPrototypeOf && classof(global.opera) !== 'Opera';
var TYPED_ARRAY_TAG_REQUIRED = false;
var NAME, Constructor, Prototype;

var TypedArrayConstructorsList = {
  Int8Array: 1,
  Uint8Array: 1,
  Uint8ClampedArray: 1,
  Int16Array: 2,
  Uint16Array: 2,
  Int32Array: 4,
  Uint32Array: 4,
  Float32Array: 4,
  Float64Array: 8
};

var BigIntArrayConstructorsList = {
  BigInt64Array: 8,
  BigUint64Array: 8
};

var isView = function isView(it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return klass === 'DataView'
    || hasOwn(TypedArrayConstructorsList, klass)
    || hasOwn(BigIntArrayConstructorsList, klass);
};

var getTypedArrayConstructor = function (it) {
  var proto = getPrototypeOf(it);
  if (!isObject(proto)) return;
  var state = getInternalState(proto);
  return (state && hasOwn(state, TYPED_ARRAY_CONSTRUCTOR)) ? state[TYPED_ARRAY_CONSTRUCTOR] : getTypedArrayConstructor(proto);
};

var isTypedArray = function (it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return hasOwn(TypedArrayConstructorsList, klass)
    || hasOwn(BigIntArrayConstructorsList, klass);
};

var aTypedArray = function (it) {
  if (isTypedArray(it)) return it;
  throw TypeError('Target is not a typed array');
};

var aTypedArrayConstructor = function (C) {
  if (isCallable(C) && (!setPrototypeOf || isPrototypeOf(TypedArray, C))) return C;
  throw TypeError(tryToString(C) + ' is not a typed array constructor');
};

var exportTypedArrayMethod = function (KEY, property, forced, options) {
  if (!DESCRIPTORS) return;
  if (forced) for (var ARRAY in TypedArrayConstructorsList) {
    var TypedArrayConstructor = global[ARRAY];
    if (TypedArrayConstructor && hasOwn(TypedArrayConstructor.prototype, KEY)) try {
      delete TypedArrayConstructor.prototype[KEY];
    } catch (error) {
      // old WebKit bug - some methods are non-configurable
      try {
        TypedArrayConstructor.prototype[KEY] = property;
      } catch (error2) { /* empty */ }
    }
  }
  if (!TypedArrayPrototype[KEY] || forced) {
    defineBuiltIn(TypedArrayPrototype, KEY, forced ? property
      : NATIVE_ARRAY_BUFFER_VIEWS && Int8ArrayPrototype[KEY] || property, options);
  }
};

var exportTypedArrayStaticMethod = function (KEY, property, forced) {
  var ARRAY, TypedArrayConstructor;
  if (!DESCRIPTORS) return;
  if (setPrototypeOf) {
    if (forced) for (ARRAY in TypedArrayConstructorsList) {
      TypedArrayConstructor = global[ARRAY];
      if (TypedArrayConstructor && hasOwn(TypedArrayConstructor, KEY)) try {
        delete TypedArrayConstructor[KEY];
      } catch (error) { /* empty */ }
    }
    if (!TypedArray[KEY] || forced) {
      // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
      try {
        return defineBuiltIn(TypedArray, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && TypedArray[KEY] || property);
      } catch (error) { /* empty */ }
    } else return;
  }
  for (ARRAY in TypedArrayConstructorsList) {
    TypedArrayConstructor = global[ARRAY];
    if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) {
      defineBuiltIn(TypedArrayConstructor, KEY, property);
    }
  }
};

for (NAME in TypedArrayConstructorsList) {
  Constructor = global[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
  else NATIVE_ARRAY_BUFFER_VIEWS = false;
}

for (NAME in BigIntArrayConstructorsList) {
  Constructor = global[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
}

// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!NATIVE_ARRAY_BUFFER_VIEWS || !isCallable(TypedArray) || TypedArray === Function.prototype) {
  // eslint-disable-next-line no-shadow -- safe
  TypedArray = function TypedArray() {
    throw TypeError('Incorrect invocation');
  };
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
    if (global[NAME]) setPrototypeOf(global[NAME], TypedArray);
  }
}

if (!NATIVE_ARRAY_BUFFER_VIEWS || !TypedArrayPrototype || TypedArrayPrototype === ObjectPrototype) {
  TypedArrayPrototype = TypedArray.prototype;
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
    if (global[NAME]) setPrototypeOf(global[NAME].prototype, TypedArrayPrototype);
  }
}

// WebKit bug - one more object in Uint8ClampedArray prototype chain
if (NATIVE_ARRAY_BUFFER_VIEWS && getPrototypeOf(Uint8ClampedArrayPrototype) !== TypedArrayPrototype) {
  setPrototypeOf(Uint8ClampedArrayPrototype, TypedArrayPrototype);
}

if (DESCRIPTORS && !hasOwn(TypedArrayPrototype, TO_STRING_TAG)) {
  TYPED_ARRAY_TAG_REQUIRED = true;
  defineBuiltInAccessor(TypedArrayPrototype, TO_STRING_TAG, {
    configurable: true,
    get: function () {
      return isObject(this) ? this[TYPED_ARRAY_TAG] : undefined;
    }
  });
  for (NAME in TypedArrayConstructorsList) if (global[NAME]) {
    createNonEnumerableProperty(global[NAME], TYPED_ARRAY_TAG, NAME);
  }
}

module.exports = {
  NATIVE_ARRAY_BUFFER_VIEWS: NATIVE_ARRAY_BUFFER_VIEWS,
  TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQUIRED && TYPED_ARRAY_TAG,
  aTypedArray: aTypedArray,
  aTypedArrayConstructor: aTypedArrayConstructor,
  exportTypedArrayMethod: exportTypedArrayMethod,
  exportTypedArrayStaticMethod: exportTypedArrayStaticMethod,
  getTypedArrayConstructor: getTypedArrayConstructor,
  isView: isView,
  isTypedArray: isTypedArray,
  TypedArray: TypedArray,
  TypedArrayPrototype: TypedArrayPrototype
};


/***/ }),

/***/ 4503:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(27990);
var uncurryThis = __webpack_require__(52058);
var DESCRIPTORS = __webpack_require__(40369);
var NATIVE_ARRAY_BUFFER = __webpack_require__(11940);
var FunctionName = __webpack_require__(92697);
var createNonEnumerableProperty = __webpack_require__(60859);
var defineBuiltInAccessor = __webpack_require__(4259);
var defineBuiltIns = __webpack_require__(38308);
var fails = __webpack_require__(79645);
var anInstance = __webpack_require__(87787);
var toIntegerOrInfinity = __webpack_require__(9163);
var toLength = __webpack_require__(60468);
var toIndex = __webpack_require__(19854);
var IEEE754 = __webpack_require__(42227);
var getPrototypeOf = __webpack_require__(56285);
var setPrototypeOf = __webpack_require__(27323);
var getOwnPropertyNames = (__webpack_require__(88766).f);
var arrayFill = __webpack_require__(7769);
var arraySlice = __webpack_require__(14501);
var setToStringTag = __webpack_require__(71508);
var InternalStateModule = __webpack_require__(47776);

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length';
var WRONG_INDEX = 'Wrong index';
var getInternalArrayBufferState = InternalStateModule.getterFor(ARRAY_BUFFER);
var getInternalDataViewState = InternalStateModule.getterFor(DATA_VIEW);
var setInternalState = InternalStateModule.set;
var NativeArrayBuffer = global[ARRAY_BUFFER];
var $ArrayBuffer = NativeArrayBuffer;
var ArrayBufferPrototype = $ArrayBuffer && $ArrayBuffer[PROTOTYPE];
var $DataView = global[DATA_VIEW];
var DataViewPrototype = $DataView && $DataView[PROTOTYPE];
var ObjectPrototype = Object.prototype;
var Array = global.Array;
var RangeError = global.RangeError;
var fill = uncurryThis(arrayFill);
var reverse = uncurryThis([].reverse);

var packIEEE754 = IEEE754.pack;
var unpackIEEE754 = IEEE754.unpack;

var packInt8 = function (number) {
  return [number & 0xFF];
};

var packInt16 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF];
};

var packInt32 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF, number >> 16 & 0xFF, number >> 24 & 0xFF];
};

var unpackInt32 = function (buffer) {
  return buffer[3] << 24 | buffer[2] << 16 | buffer[1] << 8 | buffer[0];
};

var packFloat32 = function (number) {
  return packIEEE754(number, 23, 4);
};

var packFloat64 = function (number) {
  return packIEEE754(number, 52, 8);
};

var addGetter = function (Constructor, key, getInternalState) {
  defineBuiltInAccessor(Constructor[PROTOTYPE], key, {
    configurable: true,
    get: function () {
      return getInternalState(this)[key];
    }
  });
};

var get = function (view, count, index, isLittleEndian) {
  var store = getInternalDataViewState(view);
  var intIndex = toIndex(index);
  var boolIsLittleEndian = !!isLittleEndian;
  if (intIndex + count > store.byteLength) throw RangeError(WRONG_INDEX);
  var bytes = store.bytes;
  var start = intIndex + store.byteOffset;
  var pack = arraySlice(bytes, start, start + count);
  return boolIsLittleEndian ? pack : reverse(pack);
};

var set = function (view, count, index, conversion, value, isLittleEndian) {
  var store = getInternalDataViewState(view);
  var intIndex = toIndex(index);
  var pack = conversion(+value);
  var boolIsLittleEndian = !!isLittleEndian;
  if (intIndex + count > store.byteLength) throw RangeError(WRONG_INDEX);
  var bytes = store.bytes;
  var start = intIndex + store.byteOffset;
  for (var i = 0; i < count; i++) bytes[start + i] = pack[boolIsLittleEndian ? i : count - i - 1];
};

if (!NATIVE_ARRAY_BUFFER) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, ArrayBufferPrototype);
    var byteLength = toIndex(length);
    setInternalState(this, {
      type: ARRAY_BUFFER,
      bytes: fill(Array(byteLength), 0),
      byteLength: byteLength
    });
    if (!DESCRIPTORS) {
      this.byteLength = byteLength;
      this.detached = false;
    }
  };

  ArrayBufferPrototype = $ArrayBuffer[PROTOTYPE];

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, DataViewPrototype);
    anInstance(buffer, ArrayBufferPrototype);
    var bufferState = getInternalArrayBufferState(buffer);
    var bufferLength = bufferState.byteLength;
    var offset = toIntegerOrInfinity(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    setInternalState(this, {
      type: DATA_VIEW,
      buffer: buffer,
      byteLength: byteLength,
      byteOffset: offset,
      bytes: bufferState.bytes
    });
    if (!DESCRIPTORS) {
      this.buffer = buffer;
      this.byteLength = byteLength;
      this.byteOffset = offset;
    }
  };

  DataViewPrototype = $DataView[PROTOTYPE];

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, 'byteLength', getInternalArrayBufferState);
    addGetter($DataView, 'buffer', getInternalDataViewState);
    addGetter($DataView, 'byteLength', getInternalDataViewState);
    addGetter($DataView, 'byteOffset', getInternalDataViewState);
  }

  defineBuiltIns(DataViewPrototype, {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : false);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : false);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false)) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false), 23);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments.length > 1 ? arguments[1] : false), 52);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packInt8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packInt8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : false);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : false);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : false);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : false);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packFloat32, value, arguments.length > 2 ? arguments[2] : false);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packFloat64, value, arguments.length > 2 ? arguments[2] : false);
    }
  });
} else {
  var INCORRECT_ARRAY_BUFFER_NAME = PROPER_FUNCTION_NAME && NativeArrayBuffer.name !== ARRAY_BUFFER;
  /* eslint-disable no-new -- required for testing */
  if (!fails(function () {
    NativeArrayBuffer(1);
  }) || !fails(function () {
    new NativeArrayBuffer(-1);
  }) || fails(function () {
    new NativeArrayBuffer();
    new NativeArrayBuffer(1.5);
    new NativeArrayBuffer(NaN);
    return NativeArrayBuffer.length !== 1 || INCORRECT_ARRAY_BUFFER_NAME && !CONFIGURABLE_FUNCTION_NAME;
  })) {
    /* eslint-enable no-new -- required for testing */
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, ArrayBufferPrototype);
      return new NativeArrayBuffer(toIndex(length));
    };

    $ArrayBuffer[PROTOTYPE] = ArrayBufferPrototype;

    for (var keys = getOwnPropertyNames(NativeArrayBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) {
        createNonEnumerableProperty($ArrayBuffer, key, NativeArrayBuffer[key]);
      }
    }

    ArrayBufferPrototype.constructor = $ArrayBuffer;
  } else if (INCORRECT_ARRAY_BUFFER_NAME && CONFIGURABLE_FUNCTION_NAME) {
    createNonEnumerableProperty(NativeArrayBuffer, 'name', ARRAY_BUFFER);
  }

  // WebKit bug - the same parent prototype for typed arrays and data view
  if (setPrototypeOf && getPrototypeOf(DataViewPrototype) !== ObjectPrototype) {
    setPrototypeOf(DataViewPrototype, ObjectPrototype);
  }

  // iOS Safari 7.x bug
  var testView = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = uncurryThis(DataViewPrototype.setInt8);
  testView.setInt8(0, 2147483648);
  testView.setInt8(1, 2147483649);
  if (testView.getInt8(0) || !testView.getInt8(1)) defineBuiltIns(DataViewPrototype, {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8(this, byteOffset, value << 24 >> 24);
    }
  }, { unsafe: true });
}

setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);

module.exports = {
  ArrayBuffer: $ArrayBuffer,
  DataView: $DataView
};


/***/ }),

/***/ 41208:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toObject = __webpack_require__(76075);
var toAbsoluteIndex = __webpack_require__(97913);
var lengthOfArrayLike = __webpack_require__(2103);
var deletePropertyOrThrow = __webpack_require__(39929);

var min = Math.min;

// `Array.prototype.copyWithin` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.copywithin
// eslint-disable-next-line es/no-array-prototype-copywithin -- safe
module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = lengthOfArrayLike(O);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else deletePropertyOrThrow(O, to);
    to += inc;
    from += inc;
  } return O;
};


/***/ }),

/***/ 7769:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toObject = __webpack_require__(76075);
var toAbsoluteIndex = __webpack_require__(97913);
var lengthOfArrayLike = __webpack_require__(2103);

// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = lengthOfArrayLike(O);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
  var end = argumentsLength > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),

/***/ 9320:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $forEach = (__webpack_require__(28695).forEach);
var arrayMethodIsStrict = __webpack_require__(77437);

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;


/***/ }),

/***/ 96524:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var lengthOfArrayLike = __webpack_require__(2103);

module.exports = function (Constructor, list) {
  var index = 0;
  var length = lengthOfArrayLike(list);
  var result = new Constructor(length);
  while (length > index) result[index] = list[index++];
  return result;
};


/***/ }),

/***/ 27530:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var bind = __webpack_require__(82144);
var call = __webpack_require__(17725);
var toObject = __webpack_require__(76075);
var callWithSafeIterationClosing = __webpack_require__(99266);
var isArrayIteratorMethod = __webpack_require__(95409);
var isConstructor = __webpack_require__(92701);
var lengthOfArrayLike = __webpack_require__(2103);
var createProperty = __webpack_require__(88990);
var getIterator = __webpack_require__(34431);
var getIteratorMethod = __webpack_require__(19463);

var $Array = Array;

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var IS_CONSTRUCTOR = isConstructor(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod && !(this === $Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    result = IS_CONSTRUCTOR ? new this() : [];
    for (;!(step = call(next, iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = lengthOfArrayLike(O);
    result = IS_CONSTRUCTOR ? new this(length) : $Array(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};


/***/ }),

/***/ 96039:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toIndexedObject = __webpack_require__(17794);
var toAbsoluteIndex = __webpack_require__(97913);
var lengthOfArrayLike = __webpack_require__(2103);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ 28695:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var bind = __webpack_require__(82144);
var uncurryThis = __webpack_require__(52058);
var IndexedObject = __webpack_require__(29860);
var toObject = __webpack_require__(76075);
var lengthOfArrayLike = __webpack_require__(2103);
var arraySpeciesCreate = __webpack_require__(87745);

var push = uncurryThis([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE === 1;
  var IS_FILTER = TYPE === 2;
  var IS_SOME = TYPE === 3;
  var IS_EVERY = TYPE === 4;
  var IS_FIND_INDEX = TYPE === 6;
  var IS_FILTER_REJECT = TYPE === 7;
  var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that);
    var length = lengthOfArrayLike(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


/***/ }),

/***/ 79621:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

/* eslint-disable es/no-array-prototype-lastindexof -- safe */
var apply = __webpack_require__(59878);
var toIndexedObject = __webpack_require__(17794);
var toIntegerOrInfinity = __webpack_require__(9163);
var lengthOfArrayLike = __webpack_require__(2103);
var arrayMethodIsStrict = __webpack_require__(77437);

var min = Math.min;
var $lastIndexOf = [].lastIndexOf;
var NEGATIVE_ZERO = !!$lastIndexOf && 1 / [1].lastIndexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('lastIndexOf');
var FORCED = NEGATIVE_ZERO || !STRICT_METHOD;

// `Array.prototype.lastIndexOf` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
module.exports = FORCED ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
  // convert -0 to +0
  if (NEGATIVE_ZERO) return apply($lastIndexOf, this, arguments) || 0;
  var O = toIndexedObject(this);
  var length = lengthOfArrayLike(O);
  var index = length - 1;
  if (arguments.length > 1) index = min(index, toIntegerOrInfinity(arguments[1]));
  if (index < 0) index = length + index;
  for (;index >= 0; index--) if (index in O && O[index] === searchElement) return index || 0;
  return -1;
} : $lastIndexOf;


/***/ }),

/***/ 1825:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fails = __webpack_require__(79645);
var wellKnownSymbol = __webpack_require__(15537);
var V8_VERSION = __webpack_require__(1579);

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ 77437:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fails = __webpack_require__(79645);

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};


/***/ }),

/***/ 16138:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var aCallable = __webpack_require__(44596);
var toObject = __webpack_require__(76075);
var IndexedObject = __webpack_require__(29860);
var lengthOfArrayLike = __webpack_require__(2103);

var $TypeError = TypeError;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aCallable(callbackfn);
    var O = toObject(that);
    var self = IndexedObject(O);
    var length = lengthOfArrayLike(O);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw $TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

module.exports = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};


/***/ }),

/***/ 22781:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__(40369);
var isArray = __webpack_require__(81113);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();

module.exports = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray(O) && !getOwnPropertyDescriptor(O, 'length').writable) {
    throw $TypeError('Cannot set read only .length');
  } return O.length = length;
} : function (O, length) {
  return O.length = length;
};


/***/ }),

/***/ 14501:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toAbsoluteIndex = __webpack_require__(97913);
var lengthOfArrayLike = __webpack_require__(2103);
var createProperty = __webpack_require__(88990);

var $Array = Array;
var max = Math.max;

module.exports = function (O, start, end) {
  var length = lengthOfArrayLike(O);
  var k = toAbsoluteIndex(start, length);
  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
  var result = $Array(max(fin - k, 0));
  var n = 0;
  for (; k < fin; k++, n++) createProperty(result, n, O[k]);
  result.length = n;
  return result;
};


/***/ }),

/***/ 59591:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(52058);

module.exports = uncurryThis([].slice);


/***/ }),

/***/ 626:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var arraySlice = __webpack_require__(14501);

var floor = Math.floor;

var mergeSort = function (array, comparefn) {
  var length = array.length;
  var middle = floor(length / 2);
  return length < 8 ? insertionSort(array, comparefn) : merge(
    array,
    mergeSort(arraySlice(array, 0, middle), comparefn),
    mergeSort(arraySlice(array, middle), comparefn),
    comparefn
  );
};

var insertionSort = function (array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;

  while (i < length) {
    j = i;
    element = array[i];
    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }
    if (j !== i++) array[j] = element;
  } return array;
};

var merge = function (array, left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;

  while (lindex < llength || rindex < rlength) {
    array[lindex + rindex] = (lindex < llength && rindex < rlength)
      ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
      : lindex < llength ? left[lindex++] : right[rindex++];
  } return array;
};

module.exports = mergeSort;


/***/ }),

/***/ 57747:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isArray = __webpack_require__(81113);
var isConstructor = __webpack_require__(92701);
var isObject = __webpack_require__(27627);
var wellKnownSymbol = __webpack_require__(15537);

var SPECIES = wellKnownSymbol('species');
var $Array = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array : C;
};


/***/ }),

/***/ 87745:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var arraySpeciesConstructor = __webpack_require__(57747);

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


/***/ }),

/***/ 99266:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var anObject = __webpack_require__(79308);
var iteratorClose = __webpack_require__(55887);

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};


/***/ }),

/***/ 27506:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var wellKnownSymbol = __webpack_require__(15537);

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ 38555:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(52058);

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ 25786:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(32709);
var isCallable = __webpack_require__(31808);
var classofRaw = __webpack_require__(38555);
var wellKnownSymbol = __webpack_require__(15537);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) === 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ 4055:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var create = __webpack_require__(91026);
var defineBuiltInAccessor = __webpack_require__(4259);
var defineBuiltIns = __webpack_require__(38308);
var bind = __webpack_require__(82144);
var anInstance = __webpack_require__(87787);
var isNullOrUndefined = __webpack_require__(80276);
var iterate = __webpack_require__(41851);
var defineIterator = __webpack_require__(58994);
var createIterResultObject = __webpack_require__(62526);
var setSpecies = __webpack_require__(74004);
var DESCRIPTORS = __webpack_require__(40369);
var fastKey = (__webpack_require__(34926).fastKey);
var InternalStateModule = __webpack_require__(47776);

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var Constructor = wrapper(function (that, iterable) {
      anInstance(that, Prototype);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        index: create(null),
        first: undefined,
        last: undefined,
        size: 0
      });
      if (!DESCRIPTORS) that.size = 0;
      if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var Prototype = Constructor.prototype;

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var entry = getEntry(that, key);
      var previous, index;
      // change existing entry
      if (entry) {
        entry.value = value;
      // create new entry
      } else {
        state.last = entry = {
          index: index = fastKey(key, true),
          key: key,
          value: value,
          previous: previous = state.last,
          next: undefined,
          removed: false
        };
        if (!state.first) state.first = entry;
        if (previous) previous.next = entry;
        if (DESCRIPTORS) state.size++;
        else that.size++;
        // add to index
        if (index !== 'F') state.index[index] = entry;
      } return that;
    };

    var getEntry = function (that, key) {
      var state = getInternalState(that);
      // fast case
      var index = fastKey(key);
      var entry;
      if (index !== 'F') return state.index[index];
      // frozen object case
      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key === key) return entry;
      }
    };

    defineBuiltIns(Prototype, {
      // `{ Map, Set }.prototype.clear()` methods
      // https://tc39.es/ecma262/#sec-map.prototype.clear
      // https://tc39.es/ecma262/#sec-set.prototype.clear
      clear: function clear() {
        var that = this;
        var state = getInternalState(that);
        var data = state.index;
        var entry = state.first;
        while (entry) {
          entry.removed = true;
          if (entry.previous) entry.previous = entry.previous.next = undefined;
          delete data[entry.index];
          entry = entry.next;
        }
        state.first = state.last = undefined;
        if (DESCRIPTORS) state.size = 0;
        else that.size = 0;
      },
      // `{ Map, Set }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.delete
      // https://tc39.es/ecma262/#sec-set.prototype.delete
      'delete': function (key) {
        var that = this;
        var state = getInternalState(that);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev) prev.next = next;
          if (next) next.previous = prev;
          if (state.first === entry) state.first = next;
          if (state.last === entry) state.last = prev;
          if (DESCRIPTORS) state.size--;
          else that.size--;
        } return !!entry;
      },
      // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.foreach
      // https://tc39.es/ecma262/#sec-set.prototype.foreach
      forEach: function forEach(callbackfn /* , that = undefined */) {
        var state = getInternalState(this);
        var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var entry;
        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this);
          // revert to the last existing entry
          while (entry && entry.removed) entry = entry.previous;
        }
      },
      // `{ Map, Set}.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.has
      // https://tc39.es/ecma262/#sec-set.prototype.has
      has: function has(key) {
        return !!getEntry(this, key);
      }
    });

    defineBuiltIns(Prototype, IS_MAP ? {
      // `Map.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-map.prototype.get
      get: function get(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      // `Map.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-map.prototype.set
      set: function set(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      // `Set.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-set.prototype.add
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (DESCRIPTORS) defineBuiltInAccessor(Prototype, 'size', {
      configurable: true,
      get: function () {
        return getInternalState(this).size;
      }
    });
    return Constructor;
  },
  setStrong: function (Constructor, CONSTRUCTOR_NAME, IS_MAP) {
    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
    var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
    // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
    // https://tc39.es/ecma262/#sec-map.prototype.entries
    // https://tc39.es/ecma262/#sec-map.prototype.keys
    // https://tc39.es/ecma262/#sec-map.prototype.values
    // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
    // https://tc39.es/ecma262/#sec-set.prototype.entries
    // https://tc39.es/ecma262/#sec-set.prototype.keys
    // https://tc39.es/ecma262/#sec-set.prototype.values
    // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
    defineIterator(Constructor, CONSTRUCTOR_NAME, function (iterated, kind) {
      setInternalState(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind: kind,
        last: undefined
      });
    }, function () {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var entry = state.last;
      // revert to the last existing entry
      while (entry && entry.removed) entry = entry.previous;
      // get next entry
      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        // or finish the iteration
        state.target = undefined;
        return createIterResultObject(undefined, true);
      }
      // return step by kind
      if (kind === 'keys') return createIterResultObject(entry.key, false);
      if (kind === 'values') return createIterResultObject(entry.value, false);
      return createIterResultObject([entry.key, entry.value], false);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // `{ Map, Set }.prototype[@@species]` accessors
    // https://tc39.es/ecma262/#sec-get-map-@@species
    // https://tc39.es/ecma262/#sec-get-set-@@species
    setSpecies(CONSTRUCTOR_NAME);
  }
};


/***/ }),

/***/ 75430:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var global = __webpack_require__(27990);
var uncurryThis = __webpack_require__(52058);
var isForced = __webpack_require__(69168);
var defineBuiltIn = __webpack_require__(96561);
var InternalMetadataModule = __webpack_require__(34926);
var iterate = __webpack_require__(41851);
var anInstance = __webpack_require__(87787);
var isCallable = __webpack_require__(31808);
var isNullOrUndefined = __webpack_require__(80276);
var isObject = __webpack_require__(27627);
var fails = __webpack_require__(79645);
var checkCorrectnessOfIteration = __webpack_require__(27506);
var setToStringTag = __webpack_require__(71508);
var inheritIfRequired = __webpack_require__(74240);

module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var exported = {};

  var fixMethod = function (KEY) {
    var uncurriedNativeMethod = uncurryThis(NativePrototype[KEY]);
    defineBuiltIn(NativePrototype, KEY,
      KEY === 'add' ? function add(value) {
        uncurriedNativeMethod(this, value === 0 ? 0 : value);
        return this;
      } : KEY === 'delete' ? function (key) {
        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY === 'get' ? function get(key) {
        return IS_WEAK && !isObject(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY === 'has' ? function has(key) {
        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : function set(key, value) {
        uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
        return this;
      }
    );
  };

  var REPLACE = isForced(
    CONSTRUCTOR_NAME,
    !isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
      new NativeConstructor().entries().next();
    }))
  );

  if (REPLACE) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule.enable();
  } else if (isForced(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) !== instance;
    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new -- required for testing
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (dummy, iterable) {
        anInstance(dummy, NativePrototype);
        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
        if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

    // weak collections should not contains .clear method
    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;
  $({ global: true, constructor: true, forced: Constructor !== NativeConstructor }, exported);

  setToStringTag(Constructor, CONSTRUCTOR_NAME);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};


/***/ }),

/***/ 85609:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var hasOwn = __webpack_require__(48496);
var ownKeys = __webpack_require__(7464);
var getOwnPropertyDescriptorModule = __webpack_require__(94086);
var definePropertyModule = __webpack_require__(3002);

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),

/***/ 63970:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var wellKnownSymbol = __webpack_require__(15537);

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};


/***/ }),

/***/ 16382:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fails = __webpack_require__(79645);

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ 86449:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(52058);
var requireObjectCoercible = __webpack_require__(98622);
var toString = __webpack_require__(70158);

var quot = /"/g;
var replace = uncurryThis(''.replace);

// `CreateHTML` abstract operation
// https://tc39.es/ecma262/#sec-createhtml
module.exports = function (string, tag, attribute, value) {
  var S = toString(requireObjectCoercible(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + replace(toString(value), quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};


/***/ }),

/***/ 62526:
/***/ ((module) => {

"use strict";

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
module.exports = function (value, done) {
  return { value: value, done: done };
};


/***/ }),

/***/ 60859:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__(40369);
var definePropertyModule = __webpack_require__(3002);
var createPropertyDescriptor = __webpack_require__(56373);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ 56373:
/***/ ((module) => {

"use strict";

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ 88990:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toPropertyKey = __webpack_require__(7171);
var definePropertyModule = __webpack_require__(3002);
var createPropertyDescriptor = __webpack_require__(56373);

module.exports = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ 4259:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var makeBuiltIn = __webpack_require__(32303);
var defineProperty = __webpack_require__(3002);

module.exports = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};


/***/ }),

/***/ 96561:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isCallable = __webpack_require__(31808);
var definePropertyModule = __webpack_require__(3002);
var makeBuiltIn = __webpack_require__(32303);
var defineGlobalProperty = __webpack_require__(91105);

module.exports = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};


/***/ }),

/***/ 38308:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var defineBuiltIn = __webpack_require__(96561);

module.exports = function (target, src, options) {
  for (var key in src) defineBuiltIn(target, key, src[key], options);
  return target;
};


/***/ }),

/***/ 91105:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(27990);

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ 39929:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var tryToString = __webpack_require__(38151);

var $TypeError = TypeError;

module.exports = function (O, P) {
  if (!delete O[P]) throw $TypeError('Cannot delete property ' + tryToString(P) + ' of ' + tryToString(O));
};


/***/ }),

/***/ 40369:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fails = __webpack_require__(79645);

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});


/***/ }),

/***/ 71857:
/***/ ((module) => {

"use strict";

var documentAll = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var IS_HTMLDDA = typeof documentAll == 'undefined' && documentAll !== undefined;

module.exports = {
  all: documentAll,
  IS_HTMLDDA: IS_HTMLDDA
};


/***/ }),

/***/ 54799:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(27990);
var isObject = __webpack_require__(27627);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ 64023:
/***/ ((module) => {

"use strict";

var $TypeError = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

module.exports = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
  return it;
};


/***/ }),

/***/ 28685:
/***/ ((module) => {

"use strict";

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ 53981:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = __webpack_require__(54799);

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;


/***/ }),

/***/ 95676:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var userAgent = __webpack_require__(17366);

var firefox = userAgent.match(/firefox\/(\d+)/i);

module.exports = !!firefox && +firefox[1];


/***/ }),

/***/ 39422:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var IS_DENO = __webpack_require__(98194);
var IS_NODE = __webpack_require__(28018);

module.exports = !IS_DENO && !IS_NODE
  && typeof window == 'object'
  && typeof document == 'object';


/***/ }),

/***/ 98194:
/***/ ((module) => {

"use strict";

/* global Deno -- Deno case */
module.exports = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';


/***/ }),

/***/ 79619:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var UA = __webpack_require__(17366);

module.exports = /MSIE|Trident/.test(UA);


/***/ }),

/***/ 69462:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var userAgent = __webpack_require__(17366);

module.exports = /ipad|iphone|ipod/i.test(userAgent) && typeof Pebble != 'undefined';


/***/ }),

/***/ 27970:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var userAgent = __webpack_require__(17366);

// eslint-disable-next-line redos/no-vulnerable -- safe
module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);


/***/ }),

/***/ 28018:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(27990);
var classof = __webpack_require__(38555);

module.exports = classof(global.process) === 'process';


/***/ }),

/***/ 32573:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var userAgent = __webpack_require__(17366);

module.exports = /web0s(?!.*chrome)/i.test(userAgent);


/***/ }),

/***/ 17366:
/***/ ((module) => {

"use strict";

module.exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';


/***/ }),

/***/ 1579:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(27990);
var userAgent = __webpack_require__(17366);

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ 42861:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var userAgent = __webpack_require__(17366);

var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);

module.exports = !!webkit && +webkit[1];


/***/ }),

/***/ 54577:
/***/ ((module) => {

"use strict";

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ 88903:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(27990);
var getOwnPropertyDescriptor = (__webpack_require__(94086).f);
var createNonEnumerableProperty = __webpack_require__(60859);
var defineBuiltIn = __webpack_require__(96561);
var defineGlobalProperty = __webpack_require__(91105);
var copyConstructorProperties = __webpack_require__(85609);
var isForced = __webpack_require__(69168);

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ 79645:
/***/ ((module) => {

"use strict";

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ 84902:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__(28610);
var uncurryThis = __webpack_require__(2330);
var defineBuiltIn = __webpack_require__(96561);
var regexpExec = __webpack_require__(34530);
var fails = __webpack_require__(79645);
var wellKnownSymbol = __webpack_require__(15537);
var createNonEnumerableProperty = __webpack_require__(60859);

var SPECIES = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

module.exports = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) !== 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = uncurryThis(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = uncurryThis(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn(String.prototype, KEY, methods[0]);
    defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};


/***/ }),

/***/ 45598:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isArray = __webpack_require__(81113);
var lengthOfArrayLike = __webpack_require__(2103);
var doesNotExceedSafeInteger = __webpack_require__(64023);
var bind = __webpack_require__(82144);

// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var flattenIntoArray = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? bind(mapper, thisArg) : false;
  var element, elementLen;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      if (depth > 0 && isArray(element)) {
        elementLen = lengthOfArrayLike(element);
        targetIndex = flattenIntoArray(target, original, element, elementLen, targetIndex, depth - 1) - 1;
      } else {
        doesNotExceedSafeInteger(targetIndex + 1);
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
};

module.exports = flattenIntoArray;


/***/ }),

/***/ 5541:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fails = __webpack_require__(79645);

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});


/***/ }),

/***/ 59878:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var NATIVE_BIND = __webpack_require__(62023);

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});


/***/ }),

/***/ 82144:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(2330);
var aCallable = __webpack_require__(44596);
var NATIVE_BIND = __webpack_require__(62023);

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ 62023:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fails = __webpack_require__(79645);

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),

/***/ 17725:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var NATIVE_BIND = __webpack_require__(62023);

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ 92697:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__(40369);
var hasOwn = __webpack_require__(48496);

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ 65911:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(52058);
var aCallable = __webpack_require__(44596);

module.exports = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};


/***/ }),

/***/ 2330:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var classofRaw = __webpack_require__(38555);
var uncurryThis = __webpack_require__(52058);

module.exports = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis(fn);
};


/***/ }),

/***/ 52058:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var NATIVE_BIND = __webpack_require__(62023);

var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ 91553:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(27990);
var isCallable = __webpack_require__(31808);

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ 19463:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var classof = __webpack_require__(25786);
var getMethod = __webpack_require__(30692);
var isNullOrUndefined = __webpack_require__(80276);
var Iterators = __webpack_require__(33820);
var wellKnownSymbol = __webpack_require__(15537);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR)
    || getMethod(it, '@@iterator')
    || Iterators[classof(it)];
};


/***/ }),

/***/ 34431:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var call = __webpack_require__(17725);
var aCallable = __webpack_require__(44596);
var anObject = __webpack_require__(79308);
var tryToString = __webpack_require__(38151);
var getIteratorMethod = __webpack_require__(19463);

var $TypeError = TypeError;

module.exports = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
  throw $TypeError(tryToString(argument) + ' is not iterable');
};


/***/ }),

/***/ 17061:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(52058);
var isArray = __webpack_require__(81113);
var isCallable = __webpack_require__(31808);
var classof = __webpack_require__(38555);
var toString = __webpack_require__(70158);

var push = uncurryThis([].push);

module.exports = function (replacer) {
  if (isCallable(replacer)) return replacer;
  if (!isArray(replacer)) return;
  var rawLength = replacer.length;
  var keys = [];
  for (var i = 0; i < rawLength; i++) {
    var element = replacer[i];
    if (typeof element == 'string') push(keys, element);
    else if (typeof element == 'number' || classof(element) === 'Number' || classof(element) === 'String') push(keys, toString(element));
  }
  var keysLength = keys.length;
  var root = true;
  return function (key, value) {
    if (root) {
      root = false;
      return value;
    }
    if (isArray(this)) return value;
    for (var j = 0; j < keysLength; j++) if (keys[j] === key) return value;
  };
};


/***/ }),

/***/ 30692:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var aCallable = __webpack_require__(44596);
var isNullOrUndefined = __webpack_require__(80276);

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};


/***/ }),

/***/ 20378:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(52058);
var toObject = __webpack_require__(76075);

var floor = Math.floor;
var charAt = uncurryThis(''.charAt);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice(str, 0, position);
      case "'": return stringSlice(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};


/***/ }),

/***/ 27990:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof __webpack_require__.g == 'object' && __webpack_require__.g) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || this || Function('return this')();


/***/ }),

/***/ 48496:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(52058);
var toObject = __webpack_require__(76075);

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ 80642:
/***/ ((module) => {

"use strict";

module.exports = {};


/***/ }),

/***/ 79294:
/***/ ((module) => {

"use strict";

module.exports = function (a, b) {
  try {
    // eslint-disable-next-line no-console -- safe
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  } catch (error) { /* empty */ }
};


/***/ }),

/***/ 62086:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var getBuiltIn = __webpack_require__(91553);

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ 16938:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__(40369);
var fails = __webpack_require__(79645);
var createElement = __webpack_require__(54799);

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});


/***/ }),

/***/ 42227:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// IEEE754 conversions based on https://github.com/feross/ieee754
var sign = __webpack_require__(22689);
var trunc = __webpack_require__(6357);

var $Array = Array;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;

var roundToEven = function (number) {
  var truncated = trunc(number);
  var delta = abs(number - truncated);
  if (delta > 0.5 || delta === 0.5 && truncated % 2 !== 0) {
    return truncated + sign(number);
  } return truncated;
};

var pack = function (number, mantissaLength, bytes) {
  var buffer = $Array(bytes);
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var rt = mantissaLength === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var s = number < 0 || number === 0 && 1 / number < 0 ? 1 : 0;
  var index = 0;
  var exponent, mantissa, c;
  number = abs(number);
  // eslint-disable-next-line no-self-compare -- NaN check
  if (number !== number || number === Infinity) {
    // eslint-disable-next-line no-self-compare -- NaN check
    mantissa = number !== number ? 1 : 0;
    exponent = eMax;
  } else {
    exponent = floor(log(number) / LN2);
    c = pow(2, -exponent);
    if (number * c < 1) {
      exponent--;
      c *= 2;
    }
    if (exponent + eBias >= 1) {
      number += rt / c;
    } else {
      number += rt * pow(2, 1 - eBias);
    }
    if (number * c >= 2) {
      exponent++;
      c /= 2;
    }
    if (exponent + eBias >= eMax) {
      mantissa = 0;
      exponent = eMax;
    } else if (exponent + eBias >= 1) {
      mantissa = roundToEven((number * c - 1) * pow(2, mantissaLength));
      exponent = exponent + eBias;
    } else {
      mantissa = roundToEven(number * pow(2, eBias - 1) * pow(2, mantissaLength));
      exponent = 0;
    }
  }
  while (mantissaLength >= 8) {
    buffer[index++] = mantissa & 255;
    mantissa /= 256;
    mantissaLength -= 8;
  }
  exponent = exponent << mantissaLength | mantissa;
  exponentLength += mantissaLength;
  while (exponentLength > 0) {
    buffer[index++] = exponent & 255;
    exponent /= 256;
    exponentLength -= 8;
  }
  buffer[--index] |= s * 128;
  return buffer;
};

var unpack = function (buffer, mantissaLength) {
  var bytes = buffer.length;
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var nBits = exponentLength - 7;
  var index = bytes - 1;
  var s = buffer[index--];
  var exponent = s & 127;
  var mantissa;
  s >>= 7;
  while (nBits > 0) {
    exponent = exponent * 256 + buffer[index--];
    nBits -= 8;
  }
  mantissa = exponent & (1 << -nBits) - 1;
  exponent >>= -nBits;
  nBits += mantissaLength;
  while (nBits > 0) {
    mantissa = mantissa * 256 + buffer[index--];
    nBits -= 8;
  }
  if (exponent === 0) {
    exponent = 1 - eBias;
  } else if (exponent === eMax) {
    return mantissa ? NaN : s ? -Infinity : Infinity;
  } else {
    mantissa = mantissa + pow(2, mantissaLength);
    exponent = exponent - eBias;
  } return (s ? -1 : 1) * mantissa * pow(2, exponent - mantissaLength);
};

module.exports = {
  pack: pack,
  unpack: unpack
};


/***/ }),

/***/ 29860:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(52058);
var fails = __webpack_require__(79645);
var classof = __webpack_require__(38555);

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) === 'String' ? split(it, '') : $Object(it);
} : $Object;


/***/ }),

/***/ 74240:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isCallable = __webpack_require__(31808);
var isObject = __webpack_require__(27627);
var setPrototypeOf = __webpack_require__(27323);

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ 30449:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(52058);
var isCallable = __webpack_require__(31808);
var store = __webpack_require__(57322);

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ 34926:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var uncurryThis = __webpack_require__(52058);
var hiddenKeys = __webpack_require__(80642);
var isObject = __webpack_require__(27627);
var hasOwn = __webpack_require__(48496);
var defineProperty = (__webpack_require__(3002).f);
var getOwnPropertyNamesModule = __webpack_require__(88766);
var getOwnPropertyNamesExternalModule = __webpack_require__(47092);
var isExtensible = __webpack_require__(30026);
var uid = __webpack_require__(40160);
var FREEZING = __webpack_require__(5541);

var REQUIRED = false;
var METADATA = uid('meta');
var id = 0;

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + id++, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!hasOwn(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!hasOwn(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZING && REQUIRED && isExtensible(it) && !hasOwn(it, METADATA)) setMetadata(it);
  return it;
};

var enable = function () {
  meta.enable = function () { /* empty */ };
  REQUIRED = true;
  var getOwnPropertyNames = getOwnPropertyNamesModule.f;
  var splice = uncurryThis([].splice);
  var test = {};
  test[METADATA] = 1;

  // prevent exposing of metadata key
  if (getOwnPropertyNames(test).length) {
    getOwnPropertyNamesModule.f = function (it) {
      var result = getOwnPropertyNames(it);
      for (var i = 0, length = result.length; i < length; i++) {
        if (result[i] === METADATA) {
          splice(result, i, 1);
          break;
        }
      } return result;
    };

    $({ target: 'Object', stat: true, forced: true }, {
      getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
    });
  }
};

var meta = module.exports = {
  enable: enable,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;


/***/ }),

/***/ 47776:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var NATIVE_WEAK_MAP = __webpack_require__(19514);
var global = __webpack_require__(27990);
var isObject = __webpack_require__(27627);
var createNonEnumerableProperty = __webpack_require__(60859);
var hasOwn = __webpack_require__(48496);
var shared = __webpack_require__(57322);
var sharedKey = __webpack_require__(53273);
var hiddenKeys = __webpack_require__(80642);

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ 95409:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var wellKnownSymbol = __webpack_require__(15537);
var Iterators = __webpack_require__(33820);

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ 81113:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var classof = __webpack_require__(38555);

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) === 'Array';
};


/***/ }),

/***/ 24220:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var classof = __webpack_require__(25786);

module.exports = function (it) {
  var klass = classof(it);
  return klass === 'BigInt64Array' || klass === 'BigUint64Array';
};


/***/ }),

/***/ 31808:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $documentAll = __webpack_require__(71857);

var documentAll = $documentAll.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = $documentAll.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ 92701:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(52058);
var fails = __webpack_require__(79645);
var isCallable = __webpack_require__(31808);
var classof = __webpack_require__(25786);
var getBuiltIn = __webpack_require__(91553);
var inspectSource = __webpack_require__(30449);

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;


/***/ }),

/***/ 69168:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fails = __webpack_require__(79645);
var isCallable = __webpack_require__(31808);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ 29965:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isObject = __webpack_require__(27627);

var floor = Math.floor;

// `IsIntegralNumber` abstract operation
// https://tc39.es/ecma262/#sec-isintegralnumber
// eslint-disable-next-line es/no-number-isinteger -- safe
module.exports = Number.isInteger || function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),

/***/ 80276:
/***/ ((module) => {

"use strict";

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function (it) {
  return it === null || it === undefined;
};


/***/ }),

/***/ 27627:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isCallable = __webpack_require__(31808);
var $documentAll = __webpack_require__(71857);

var documentAll = $documentAll.all;

module.exports = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ 81566:
/***/ ((module) => {

"use strict";

module.exports = false;


/***/ }),

/***/ 95522:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isObject = __webpack_require__(27627);
var classof = __webpack_require__(38555);
var wellKnownSymbol = __webpack_require__(15537);

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) === 'RegExp');
};


/***/ }),

/***/ 44003:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var getBuiltIn = __webpack_require__(91553);
var isCallable = __webpack_require__(31808);
var isPrototypeOf = __webpack_require__(88304);
var USE_SYMBOL_AS_UID = __webpack_require__(40144);

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};


/***/ }),

/***/ 41851:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var bind = __webpack_require__(82144);
var call = __webpack_require__(17725);
var anObject = __webpack_require__(79308);
var tryToString = __webpack_require__(38151);
var isArrayIteratorMethod = __webpack_require__(95409);
var lengthOfArrayLike = __webpack_require__(2103);
var isPrototypeOf = __webpack_require__(88304);
var getIterator = __webpack_require__(34431);
var getIteratorMethod = __webpack_require__(19463);
var iteratorClose = __webpack_require__(55887);

var $TypeError = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw $TypeError(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};


/***/ }),

/***/ 55887:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var call = __webpack_require__(17725);
var anObject = __webpack_require__(79308);
var getMethod = __webpack_require__(30692);

module.exports = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};


/***/ }),

/***/ 32282:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var IteratorPrototype = (__webpack_require__(8678).IteratorPrototype);
var create = __webpack_require__(91026);
var createPropertyDescriptor = __webpack_require__(56373);
var setToStringTag = __webpack_require__(71508);
var Iterators = __webpack_require__(33820);

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ 58994:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var call = __webpack_require__(17725);
var IS_PURE = __webpack_require__(81566);
var FunctionName = __webpack_require__(92697);
var isCallable = __webpack_require__(31808);
var createIteratorConstructor = __webpack_require__(32282);
var getPrototypeOf = __webpack_require__(56285);
var setPrototypeOf = __webpack_require__(27323);
var setToStringTag = __webpack_require__(71508);
var createNonEnumerableProperty = __webpack_require__(60859);
var defineBuiltIn = __webpack_require__(96561);
var wellKnownSymbol = __webpack_require__(15537);
var Iterators = __webpack_require__(33820);
var IteratorsCore = __webpack_require__(8678);

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
          defineBuiltIn(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    defineBuiltIn(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
  }
  Iterators[NAME] = defaultIterator;

  return methods;
};


/***/ }),

/***/ 8678:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fails = __webpack_require__(79645);
var isCallable = __webpack_require__(31808);
var isObject = __webpack_require__(27627);
var create = __webpack_require__(91026);
var getPrototypeOf = __webpack_require__(56285);
var defineBuiltIn = __webpack_require__(96561);
var wellKnownSymbol = __webpack_require__(15537);
var IS_PURE = __webpack_require__(81566);

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype) || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  defineBuiltIn(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ 33820:
/***/ ((module) => {

"use strict";

module.exports = {};


/***/ }),

/***/ 2103:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toLength = __webpack_require__(60468);

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ 32303:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(52058);
var fails = __webpack_require__(79645);
var isCallable = __webpack_require__(31808);
var hasOwn = __webpack_require__(48496);
var DESCRIPTORS = __webpack_require__(40369);
var CONFIGURABLE_FUNCTION_NAME = (__webpack_require__(92697).CONFIGURABLE);
var inspectSource = __webpack_require__(30449);
var InternalStateModule = __webpack_require__(47776);

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var stringSlice = uncurryThis(''.slice);
var replace = uncurryThis(''.replace);
var join = uncurryThis([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
    name = '[' + replace($String(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');


/***/ }),

/***/ 22689:
/***/ ((module) => {

"use strict";

// `Math.sign` method implementation
// https://tc39.es/ecma262/#sec-math.sign
// eslint-disable-next-line es/no-math-sign -- safe
module.exports = Math.sign || function sign(x) {
  var n = +x;
  // eslint-disable-next-line no-self-compare -- NaN check
  return n === 0 || n !== n ? n : n < 0 ? -1 : 1;
};


/***/ }),

/***/ 6357:
/***/ ((module) => {

"use strict";

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};


/***/ }),

/***/ 73586:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(27990);
var bind = __webpack_require__(82144);
var getOwnPropertyDescriptor = (__webpack_require__(94086).f);
var macrotask = (__webpack_require__(24657).set);
var Queue = __webpack_require__(8390);
var IS_IOS = __webpack_require__(27970);
var IS_IOS_PEBBLE = __webpack_require__(69462);
var IS_WEBOS_WEBKIT = __webpack_require__(32573);
var IS_NODE = __webpack_require__(28018);

var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
var document = global.document;
var process = global.process;
var Promise = global.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
var microtask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;
var notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!microtask) {
  var queue = new Queue();

  var flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (fn = queue.get()) try {
      fn();
    } catch (error) {
      if (queue.head) notify();
      throw error;
    }
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise;
    then = bind(promise.then, promise);
    notify = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // `webpack` dev server bug on IE global methods - use bind(fn, global)
    macrotask = bind(macrotask, global);
    notify = function () {
      macrotask(flush);
    };
  }

  microtask = function (fn) {
    if (!queue.head) notify();
    queue.add(fn);
  };
}

module.exports = microtask;


/***/ }),

/***/ 50606:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var aCallable = __webpack_require__(44596);

var $TypeError = TypeError;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw $TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable(resolve);
  this.reject = aCallable(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ 82990:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isRegExp = __webpack_require__(95522);

var $TypeError = TypeError;

module.exports = function (it) {
  if (isRegExp(it)) {
    throw $TypeError("The method doesn't accept regular expressions");
  } return it;
};


/***/ }),

/***/ 43403:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(27990);

var globalIsFinite = global.isFinite;

// `Number.isFinite` method
// https://tc39.es/ecma262/#sec-number.isfinite
// eslint-disable-next-line es/no-number-isfinite -- safe
module.exports = Number.isFinite || function isFinite(it) {
  return typeof it == 'number' && globalIsFinite(it);
};


/***/ }),

/***/ 26779:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__(40369);
var uncurryThis = __webpack_require__(52058);
var call = __webpack_require__(17725);
var fails = __webpack_require__(79645);
var objectKeys = __webpack_require__(88071);
var getOwnPropertySymbolsModule = __webpack_require__(28559);
var propertyIsEnumerableModule = __webpack_require__(43740);
var toObject = __webpack_require__(76075);
var IndexedObject = __webpack_require__(29860);

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;
var concat = uncurryThis([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol('assign detection');
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] !== 7 || objectKeys($assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ 91026:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__(79308);
var definePropertiesModule = __webpack_require__(48065);
var enumBugKeys = __webpack_require__(54577);
var hiddenKeys = __webpack_require__(80642);
var html = __webpack_require__(62086);
var documentCreateElement = __webpack_require__(54799);
var sharedKey = __webpack_require__(53273);

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};


/***/ }),

/***/ 48065:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__(40369);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(30446);
var definePropertyModule = __webpack_require__(3002);
var anObject = __webpack_require__(79308);
var toIndexedObject = __webpack_require__(17794);
var objectKeys = __webpack_require__(88071);

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};


/***/ }),

/***/ 3002:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__(40369);
var IE8_DOM_DEFINE = __webpack_require__(16938);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(30446);
var anObject = __webpack_require__(79308);
var toPropertyKey = __webpack_require__(7171);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 94086:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__(40369);
var call = __webpack_require__(17725);
var propertyIsEnumerableModule = __webpack_require__(43740);
var createPropertyDescriptor = __webpack_require__(56373);
var toIndexedObject = __webpack_require__(17794);
var toPropertyKey = __webpack_require__(7171);
var hasOwn = __webpack_require__(48496);
var IE8_DOM_DEFINE = __webpack_require__(16938);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ 47092:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

/* eslint-disable es/no-object-getownpropertynames -- safe */
var classof = __webpack_require__(38555);
var toIndexedObject = __webpack_require__(17794);
var $getOwnPropertyNames = (__webpack_require__(88766).f);
var arraySlice = __webpack_require__(14501);

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return arraySlice(windowNames);
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && classof(it) === 'Window'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ 88766:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

var internalObjectKeys = __webpack_require__(15848);
var enumBugKeys = __webpack_require__(54577);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ 28559:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 56285:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var hasOwn = __webpack_require__(48496);
var isCallable = __webpack_require__(31808);
var toObject = __webpack_require__(76075);
var sharedKey = __webpack_require__(53273);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(16382);

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};


/***/ }),

/***/ 30026:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fails = __webpack_require__(79645);
var isObject = __webpack_require__(27627);
var classof = __webpack_require__(38555);
var ARRAY_BUFFER_NON_EXTENSIBLE = __webpack_require__(15611);

// eslint-disable-next-line es/no-object-isextensible -- safe
var $isExtensible = Object.isExtensible;
var FAILS_ON_PRIMITIVES = fails(function () { $isExtensible(1); });

// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
module.exports = (FAILS_ON_PRIMITIVES || ARRAY_BUFFER_NON_EXTENSIBLE) ? function isExtensible(it) {
  if (!isObject(it)) return false;
  if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) === 'ArrayBuffer') return false;
  return $isExtensible ? $isExtensible(it) : true;
} : $isExtensible;


/***/ }),

/***/ 88304:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(52058);

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ 15848:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(52058);
var hasOwn = __webpack_require__(48496);
var toIndexedObject = __webpack_require__(17794);
var indexOf = (__webpack_require__(96039).indexOf);
var hiddenKeys = __webpack_require__(80642);

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ 88071:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var internalObjectKeys = __webpack_require__(15848);
var enumBugKeys = __webpack_require__(54577);

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ 43740:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ 8833:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var IS_PURE = __webpack_require__(81566);
var global = __webpack_require__(27990);
var fails = __webpack_require__(79645);
var WEBKIT = __webpack_require__(42861);

// Forced replacement object prototype accessors methods
module.exports = IS_PURE || !fails(function () {
  // This feature detection crashes old WebKit
  // https://github.com/zloirock/core-js/issues/232
  if (WEBKIT && WEBKIT < 535) return;
  var key = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call, es/no-legacy-object-prototype-accessor-methods -- required for testing
  __defineSetter__.call(null, key, function () { /* empty */ });
  delete global[key];
});


/***/ }),

/***/ 27323:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = __webpack_require__(65911);
var anObject = __webpack_require__(79308);
var aPossiblePrototype = __webpack_require__(9316);

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ 99842:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__(40369);
var fails = __webpack_require__(79645);
var uncurryThis = __webpack_require__(52058);
var objectGetPrototypeOf = __webpack_require__(56285);
var objectKeys = __webpack_require__(88071);
var toIndexedObject = __webpack_require__(17794);
var $propertyIsEnumerable = (__webpack_require__(43740).f);

var propertyIsEnumerable = uncurryThis($propertyIsEnumerable);
var push = uncurryThis([].push);

// in some IE versions, `propertyIsEnumerable` returns incorrect result on integer keys
// of `null` prototype objects
var IE_BUG = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-create -- safe
  var O = Object.create(null);
  O[2] = 2;
  return !propertyIsEnumerable(O, 2);
});

// `Object.{ entries, values }` methods implementation
var createMethod = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys(O);
    var IE_WORKAROUND = IE_BUG && objectGetPrototypeOf(O) === null;
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || (IE_WORKAROUND ? key in O : propertyIsEnumerable(O, key))) {
        push(result, TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

module.exports = {
  // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries
  entries: createMethod(true),
  // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values
  values: createMethod(false)
};


/***/ }),

/***/ 52009:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(32709);
var classof = __webpack_require__(25786);

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ 30173:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var call = __webpack_require__(17725);
var isCallable = __webpack_require__(31808);
var isObject = __webpack_require__(27627);

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw $TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 7464:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var getBuiltIn = __webpack_require__(91553);
var uncurryThis = __webpack_require__(52058);
var getOwnPropertyNamesModule = __webpack_require__(88766);
var getOwnPropertySymbolsModule = __webpack_require__(28559);
var anObject = __webpack_require__(79308);

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ 84231:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(27990);

module.exports = global;


/***/ }),

/***/ 43639:
/***/ ((module) => {

"use strict";

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};


/***/ }),

/***/ 32862:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(27990);
var NativePromiseConstructor = __webpack_require__(29952);
var isCallable = __webpack_require__(31808);
var isForced = __webpack_require__(69168);
var inspectSource = __webpack_require__(30449);
var wellKnownSymbol = __webpack_require__(15537);
var IS_BROWSER = __webpack_require__(39422);
var IS_DENO = __webpack_require__(98194);
var IS_PURE = __webpack_require__(81566);
var V8_VERSION = __webpack_require__(1579);

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var SPECIES = wellKnownSymbol('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT = isCallable(global.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR = isForced('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
  if (IS_PURE && !(NativePromisePrototype['catch'] && NativePromisePrototype['finally'])) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new NativePromiseConstructor(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (IS_BROWSER || IS_DENO) && !NATIVE_PROMISE_REJECTION_EVENT;
});

module.exports = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT,
  SUBCLASSING: SUBCLASSING
};


/***/ }),

/***/ 29952:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(27990);

module.exports = global.Promise;


/***/ }),

/***/ 21513:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var anObject = __webpack_require__(79308);
var isObject = __webpack_require__(27627);
var newPromiseCapability = __webpack_require__(50606);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ 95289:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var NativePromiseConstructor = __webpack_require__(29952);
var checkCorrectnessOfIteration = __webpack_require__(27506);
var FORCED_PROMISE_CONSTRUCTOR = (__webpack_require__(32862).CONSTRUCTOR);

module.exports = FORCED_PROMISE_CONSTRUCTOR || !checkCorrectnessOfIteration(function (iterable) {
  NativePromiseConstructor.all(iterable).then(undefined, function () { /* empty */ });
});


/***/ }),

/***/ 83204:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var defineProperty = (__webpack_require__(3002).f);

module.exports = function (Target, Source, key) {
  key in Target || defineProperty(Target, key, {
    configurable: true,
    get: function () { return Source[key]; },
    set: function (it) { Source[key] = it; }
  });
};


/***/ }),

/***/ 8390:
/***/ ((module) => {

"use strict";

var Queue = function () {
  this.head = null;
  this.tail = null;
};

Queue.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    var tail = this.tail;
    if (tail) tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      var next = this.head = entry.next;
      if (next === null) this.tail = null;
      return entry.item;
    }
  }
};

module.exports = Queue;


/***/ }),

/***/ 19637:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var call = __webpack_require__(17725);
var anObject = __webpack_require__(79308);
var isCallable = __webpack_require__(31808);
var classof = __webpack_require__(38555);
var regexpExec = __webpack_require__(34530);

var $TypeError = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (isCallable(exec)) {
    var result = call(exec, R, S);
    if (result !== null) anObject(result);
    return result;
  }
  if (classof(R) === 'RegExp') return call(regexpExec, R, S);
  throw $TypeError('RegExp#exec called on incompatible receiver');
};


/***/ }),

/***/ 34530:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call = __webpack_require__(17725);
var uncurryThis = __webpack_require__(52058);
var toString = __webpack_require__(70158);
var regexpFlags = __webpack_require__(50323);
var stickyHelpers = __webpack_require__(8373);
var shared = __webpack_require__(69808);
var create = __webpack_require__(91026);
var getInternalState = (__webpack_require__(47776).get);
var UNSUPPORTED_DOT_ALL = __webpack_require__(47784);
var UNSUPPORTED_NCG = __webpack_require__(60546);

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt = uncurryThis(''.charAt);
var indexOf = uncurryThis(''.indexOf);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call(nativeExec, re1, 'a');
  call(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice(match.input, charsAdded);
        match[0] = stringSlice(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ 50323:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var anObject = __webpack_require__(79308);

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ 7660:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var call = __webpack_require__(17725);
var hasOwn = __webpack_require__(48496);
var isPrototypeOf = __webpack_require__(88304);
var regExpFlags = __webpack_require__(50323);

var RegExpPrototype = RegExp.prototype;

module.exports = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype) && !hasOwn(R, 'flags') && isPrototypeOf(RegExpPrototype, R)
    ? call(regExpFlags, R) : flags;
};


/***/ }),

/***/ 8373:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fails = __webpack_require__(79645);
var global = __webpack_require__(27990);

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp = global.RegExp;

var UNSUPPORTED_Y = fails(function () {
  var re = $RegExp('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') !== null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y || fails(function () {
  return !$RegExp('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y || fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') !== null;
});

module.exports = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y
};


/***/ }),

/***/ 47784:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fails = __webpack_require__(79645);
var global = __webpack_require__(27990);

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});


/***/ }),

/***/ 60546:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fails = __webpack_require__(79645);
var global = __webpack_require__(27990);

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});


/***/ }),

/***/ 98622:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isNullOrUndefined = __webpack_require__(80276);

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (isNullOrUndefined(it)) throw $TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ 67178:
/***/ ((module) => {

"use strict";

// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x !== x && y !== y;
};


/***/ }),

/***/ 74004:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var getBuiltIn = __webpack_require__(91553);
var defineBuiltInAccessor = __webpack_require__(4259);
var wellKnownSymbol = __webpack_require__(15537);
var DESCRIPTORS = __webpack_require__(40369);

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineBuiltInAccessor(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),

/***/ 71508:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var defineProperty = (__webpack_require__(3002).f);
var hasOwn = __webpack_require__(48496);
var wellKnownSymbol = __webpack_require__(15537);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn(target, TO_STRING_TAG)) {
    defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ 53273:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var shared = __webpack_require__(69808);
var uid = __webpack_require__(40160);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ 57322:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(27990);
var defineGlobalProperty = __webpack_require__(91105);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || defineGlobalProperty(SHARED, {});

module.exports = store;


/***/ }),

/***/ 69808:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var IS_PURE = __webpack_require__(81566);
var store = __webpack_require__(57322);

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.32.1',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.32.1/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),

/***/ 6178:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var anObject = __webpack_require__(79308);
var aConstructor = __webpack_require__(67877);
var isNullOrUndefined = __webpack_require__(80276);
var wellKnownSymbol = __webpack_require__(15537);

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined(S = anObject(C)[SPECIES]) ? defaultConstructor : aConstructor(S);
};


/***/ }),

/***/ 83793:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fails = __webpack_require__(79645);

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
module.exports = function (METHOD_NAME) {
  return fails(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};


/***/ }),

/***/ 97124:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(52058);
var toIntegerOrInfinity = __webpack_require__(9163);
var toString = __webpack_require__(70158);
var requireObjectCoercible = __webpack_require__(98622);

var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var stringSlice = uncurryThis(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ 28956:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js
var uncurryThis = __webpack_require__(52058);

var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = '-'; // '\x2D'
var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var baseMinusTMin = base - tMin;

var $RangeError = RangeError;
var exec = uncurryThis(regexSeparators.exec);
var floor = Math.floor;
var fromCharCode = String.fromCharCode;
var charCodeAt = uncurryThis(''.charCodeAt);
var join = uncurryThis([].join);
var push = uncurryThis([].push);
var replace = uncurryThis(''.replace);
var split = uncurryThis(''.split);
var toLowerCase = uncurryThis(''.toLowerCase);

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */
var ucs2decode = function (string) {
  var output = [];
  var counter = 0;
  var length = string.length;
  while (counter < length) {
    var value = charCodeAt(string, counter++);
    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // It's a high surrogate, and there is a next character.
      var extra = charCodeAt(string, counter++);
      if ((extra & 0xFC00) === 0xDC00) { // Low surrogate.
        push(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // It's an unmatched surrogate; only append this code unit, in case the
        // next code unit is the high surrogate of a surrogate pair.
        push(output, value);
        counter--;
      }
    } else {
      push(output, value);
    }
  }
  return output;
};

/**
 * Converts a digit/integer into a basic code point.
 */
var digitToBasic = function (digit) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */
var adapt = function (delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor(delta / damp) : delta >> 1;
  delta += floor(delta / numPoints);
  while (delta > baseMinusTMin * tMax >> 1) {
    delta = floor(delta / baseMinusTMin);
    k += base;
  }
  return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */
var encode = function (input) {
  var output = [];

  // Convert the input in UCS-2 to an array of Unicode code points.
  input = ucs2decode(input);

  // Cache the length.
  var inputLength = input.length;

  // Initialize the state.
  var n = initialN;
  var delta = 0;
  var bias = initialBias;
  var i, currentValue;

  // Handle the basic code points.
  for (i = 0; i < input.length; i++) {
    currentValue = input[i];
    if (currentValue < 0x80) {
      push(output, fromCharCode(currentValue));
    }
  }

  var basicLength = output.length; // number of basic code points.
  var handledCPCount = basicLength; // number of code points that have been handled;

  // Finish the basic string with a delimiter unless it's empty.
  if (basicLength) {
    push(output, delimiter);
  }

  // Main encoding loop:
  while (handledCPCount < inputLength) {
    // All non-basic code points < n have been handled already. Find the next larger one:
    var m = maxInt;
    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    }

    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
    var handledCPCountPlusOne = handledCPCount + 1;
    if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
      throw $RangeError(OVERFLOW_ERROR);
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue < n && ++delta > maxInt) {
        throw $RangeError(OVERFLOW_ERROR);
      }
      if (currentValue === n) {
        // Represent delta as a generalized variable-length integer.
        var q = delta;
        var k = base;
        while (true) {
          var t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
          if (q < t) break;
          var qMinusT = q - t;
          var baseMinusT = base - t;
          push(output, fromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
          q = floor(qMinusT / baseMinusT);
          k += base;
        }

        push(output, fromCharCode(digitToBasic(q)));
        bias = adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
        delta = 0;
        handledCPCount++;
      }
    }

    delta++;
    n++;
  }
  return join(output, '');
};

module.exports = function (input) {
  var encoded = [];
  var labels = split(replace(toLowerCase(input), regexSeparators, '\u002E'), '.');
  var i, label;
  for (i = 0; i < labels.length; i++) {
    label = labels[i];
    push(encoded, exec(regexNonASCII, label) ? 'xn--' + encode(label) : label);
  }
  return join(encoded, '.');
};


/***/ }),

/***/ 69523:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toIntegerOrInfinity = __webpack_require__(9163);
var toString = __webpack_require__(70158);
var requireObjectCoercible = __webpack_require__(98622);

var $RangeError = RangeError;

// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
module.exports = function repeat(count) {
  var str = toString(requireObjectCoercible(this));
  var result = '';
  var n = toIntegerOrInfinity(count);
  if (n < 0 || n === Infinity) throw $RangeError('Wrong number of repetitions');
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
  return result;
};


/***/ }),

/***/ 38768:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var PROPER_FUNCTION_NAME = (__webpack_require__(92697).PROPER);
var fails = __webpack_require__(79645);
var whitespaces = __webpack_require__(88898);

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
module.exports = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME);
  });
};


/***/ }),

/***/ 84610:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(52058);
var requireObjectCoercible = __webpack_require__(98622);
var toString = __webpack_require__(70158);
var whitespaces = __webpack_require__(88898);

var replace = uncurryThis(''.replace);
var ltrim = RegExp('^[' + whitespaces + ']+');
var rtrim = RegExp('(^|[^' + whitespaces + '])[' + whitespaces + ']+$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString(requireObjectCoercible($this));
    if (TYPE & 1) string = replace(string, ltrim, '');
    if (TYPE & 2) string = replace(string, rtrim, '$1');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ 97987:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__(1579);
var fails = __webpack_require__(79645);
var global = __webpack_require__(27990);

var $String = global.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ 52411:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var call = __webpack_require__(17725);
var getBuiltIn = __webpack_require__(91553);
var wellKnownSymbol = __webpack_require__(15537);
var defineBuiltIn = __webpack_require__(96561);

module.exports = function () {
  var Symbol = getBuiltIn('Symbol');
  var SymbolPrototype = Symbol && Symbol.prototype;
  var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
  var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

  if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) {
    // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    defineBuiltIn(SymbolPrototype, TO_PRIMITIVE, function (hint) {
      return call(valueOf, this);
    }, { arity: 1 });
  }
};


/***/ }),

/***/ 53482:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var NATIVE_SYMBOL = __webpack_require__(97987);

/* eslint-disable es/no-symbol -- safe */
module.exports = NATIVE_SYMBOL && !!Symbol['for'] && !!Symbol.keyFor;


/***/ }),

/***/ 24657:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(27990);
var apply = __webpack_require__(59878);
var bind = __webpack_require__(82144);
var isCallable = __webpack_require__(31808);
var hasOwn = __webpack_require__(48496);
var fails = __webpack_require__(79645);
var html = __webpack_require__(62086);
var arraySlice = __webpack_require__(59591);
var createElement = __webpack_require__(54799);
var validateArgumentsLength = __webpack_require__(9823);
var IS_IOS = __webpack_require__(27970);
var IS_NODE = __webpack_require__(28018);

var set = global.setImmediate;
var clear = global.clearImmediate;
var process = global.process;
var Dispatch = global.Dispatch;
var Function = global.Function;
var MessageChannel = global.MessageChannel;
var String = global.String;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;

fails(function () {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = global.location;
});

var run = function (id) {
  if (hasOwn(queue, id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var eventListener = function (event) {
  run(event.data);
};

var globalPostMessageDefer = function (id) {
  // old engines have not location.origin
  global.postMessage(String(id), $location.protocol + '//' + $location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable(handler) ? handler : Function(handler);
    var args = arraySlice(arguments, 1);
    queue[++counter] = function () {
      apply(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (IS_NODE) {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = eventListener;
    defer = bind(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global.addEventListener &&
    isCallable(global.postMessage) &&
    !global.importScripts &&
    $location && $location.protocol !== 'file:' &&
    !fails(globalPostMessageDefer)
  ) {
    defer = globalPostMessageDefer;
    global.addEventListener('message', eventListener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};


/***/ }),

/***/ 67065:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(52058);

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
module.exports = uncurryThis(1.0.valueOf);


/***/ }),

/***/ 97913:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toIntegerOrInfinity = __webpack_require__(9163);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ 90797:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toPrimitive = __webpack_require__(69182);

var $TypeError = TypeError;

// `ToBigInt` abstract operation
// https://tc39.es/ecma262/#sec-tobigint
module.exports = function (argument) {
  var prim = toPrimitive(argument, 'number');
  if (typeof prim == 'number') throw $TypeError("Can't convert number to bigint");
  // eslint-disable-next-line es/no-bigint -- safe
  return BigInt(prim);
};


/***/ }),

/***/ 19854:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toIntegerOrInfinity = __webpack_require__(9163);
var toLength = __webpack_require__(60468);

var $RangeError = RangeError;

// `ToIndex` abstract operation
// https://tc39.es/ecma262/#sec-toindex
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toIntegerOrInfinity(it);
  var length = toLength(number);
  if (number !== length) throw $RangeError('Wrong length or index');
  return length;
};


/***/ }),

/***/ 17794:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(29860);
var requireObjectCoercible = __webpack_require__(98622);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ 9163:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var trunc = __webpack_require__(6357);

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};


/***/ }),

/***/ 60468:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toIntegerOrInfinity = __webpack_require__(9163);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ 76075:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var requireObjectCoercible = __webpack_require__(98622);

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ 10756:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toPositiveInteger = __webpack_require__(73123);

var $RangeError = RangeError;

module.exports = function (it, BYTES) {
  var offset = toPositiveInteger(it);
  if (offset % BYTES) throw $RangeError('Wrong offset');
  return offset;
};


/***/ }),

/***/ 73123:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toIntegerOrInfinity = __webpack_require__(9163);

var $RangeError = RangeError;

module.exports = function (it) {
  var result = toIntegerOrInfinity(it);
  if (result < 0) throw $RangeError("The argument can't be less than 0");
  return result;
};


/***/ }),

/***/ 69182:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var call = __webpack_require__(17725);
var isObject = __webpack_require__(27627);
var isSymbol = __webpack_require__(44003);
var getMethod = __webpack_require__(30692);
var ordinaryToPrimitive = __webpack_require__(30173);
var wellKnownSymbol = __webpack_require__(15537);

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ 7171:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toPrimitive = __webpack_require__(69182);
var isSymbol = __webpack_require__(44003);

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ 32709:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var wellKnownSymbol = __webpack_require__(15537);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ 70158:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var classof = __webpack_require__(25786);

var $String = String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};


/***/ }),

/***/ 64503:
/***/ ((module) => {

"use strict";

var round = Math.round;

module.exports = function (it) {
  var value = round(it);
  return value < 0 ? 0 : value > 0xFF ? 0xFF : value & 0xFF;
};


/***/ }),

/***/ 38151:
/***/ ((module) => {

"use strict";

var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ 1233:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var global = __webpack_require__(27990);
var call = __webpack_require__(17725);
var DESCRIPTORS = __webpack_require__(40369);
var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = __webpack_require__(45958);
var ArrayBufferViewCore = __webpack_require__(63214);
var ArrayBufferModule = __webpack_require__(4503);
var anInstance = __webpack_require__(87787);
var createPropertyDescriptor = __webpack_require__(56373);
var createNonEnumerableProperty = __webpack_require__(60859);
var isIntegralNumber = __webpack_require__(29965);
var toLength = __webpack_require__(60468);
var toIndex = __webpack_require__(19854);
var toOffset = __webpack_require__(10756);
var toUint8Clamped = __webpack_require__(64503);
var toPropertyKey = __webpack_require__(7171);
var hasOwn = __webpack_require__(48496);
var classof = __webpack_require__(25786);
var isObject = __webpack_require__(27627);
var isSymbol = __webpack_require__(44003);
var create = __webpack_require__(91026);
var isPrototypeOf = __webpack_require__(88304);
var setPrototypeOf = __webpack_require__(27323);
var getOwnPropertyNames = (__webpack_require__(88766).f);
var typedArrayFrom = __webpack_require__(18110);
var forEach = (__webpack_require__(28695).forEach);
var setSpecies = __webpack_require__(74004);
var defineBuiltInAccessor = __webpack_require__(4259);
var definePropertyModule = __webpack_require__(3002);
var getOwnPropertyDescriptorModule = __webpack_require__(94086);
var InternalStateModule = __webpack_require__(47776);
var inheritIfRequired = __webpack_require__(74240);

var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var enforceInternalState = InternalStateModule.enforce;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var RangeError = global.RangeError;
var ArrayBuffer = ArrayBufferModule.ArrayBuffer;
var ArrayBufferPrototype = ArrayBuffer.prototype;
var DataView = ArrayBufferModule.DataView;
var NATIVE_ARRAY_BUFFER_VIEWS = ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;
var TYPED_ARRAY_TAG = ArrayBufferViewCore.TYPED_ARRAY_TAG;
var TypedArray = ArrayBufferViewCore.TypedArray;
var TypedArrayPrototype = ArrayBufferViewCore.TypedArrayPrototype;
var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor;
var isTypedArray = ArrayBufferViewCore.isTypedArray;
var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
var WRONG_LENGTH = 'Wrong length';

var fromList = function (C, list) {
  aTypedArrayConstructor(C);
  var index = 0;
  var length = list.length;
  var result = new C(length);
  while (length > index) result[index] = list[index++];
  return result;
};

var addGetter = function (it, key) {
  defineBuiltInAccessor(it, key, {
    configurable: true,
    get: function () {
      return getInternalState(this)[key];
    }
  });
};

var isArrayBuffer = function (it) {
  var klass;
  return isPrototypeOf(ArrayBufferPrototype, it) || (klass = classof(it)) === 'ArrayBuffer' || klass === 'SharedArrayBuffer';
};

var isTypedArrayIndex = function (target, key) {
  return isTypedArray(target)
    && !isSymbol(key)
    && key in target
    && isIntegralNumber(+key)
    && key >= 0;
};

var wrappedGetOwnPropertyDescriptor = function getOwnPropertyDescriptor(target, key) {
  key = toPropertyKey(key);
  return isTypedArrayIndex(target, key)
    ? createPropertyDescriptor(2, target[key])
    : nativeGetOwnPropertyDescriptor(target, key);
};

var wrappedDefineProperty = function defineProperty(target, key, descriptor) {
  key = toPropertyKey(key);
  if (isTypedArrayIndex(target, key)
    && isObject(descriptor)
    && hasOwn(descriptor, 'value')
    && !hasOwn(descriptor, 'get')
    && !hasOwn(descriptor, 'set')
    // TODO: add validation descriptor w/o calling accessors
    && !descriptor.configurable
    && (!hasOwn(descriptor, 'writable') || descriptor.writable)
    && (!hasOwn(descriptor, 'enumerable') || descriptor.enumerable)
  ) {
    target[key] = descriptor.value;
    return target;
  } return nativeDefineProperty(target, key, descriptor);
};

if (DESCRIPTORS) {
  if (!NATIVE_ARRAY_BUFFER_VIEWS) {
    getOwnPropertyDescriptorModule.f = wrappedGetOwnPropertyDescriptor;
    definePropertyModule.f = wrappedDefineProperty;
    addGetter(TypedArrayPrototype, 'buffer');
    addGetter(TypedArrayPrototype, 'byteOffset');
    addGetter(TypedArrayPrototype, 'byteLength');
    addGetter(TypedArrayPrototype, 'length');
  }

  $({ target: 'Object', stat: true, forced: !NATIVE_ARRAY_BUFFER_VIEWS }, {
    getOwnPropertyDescriptor: wrappedGetOwnPropertyDescriptor,
    defineProperty: wrappedDefineProperty
  });

  module.exports = function (TYPE, wrapper, CLAMPED) {
    var BYTES = TYPE.match(/\d+/)[0] / 8;
    var CONSTRUCTOR_NAME = TYPE + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + TYPE;
    var SETTER = 'set' + TYPE;
    var NativeTypedArrayConstructor = global[CONSTRUCTOR_NAME];
    var TypedArrayConstructor = NativeTypedArrayConstructor;
    var TypedArrayConstructorPrototype = TypedArrayConstructor && TypedArrayConstructor.prototype;
    var exported = {};

    var getter = function (that, index) {
      var data = getInternalState(that);
      return data.view[GETTER](index * BYTES + data.byteOffset, true);
    };

    var setter = function (that, index, value) {
      var data = getInternalState(that);
      data.view[SETTER](index * BYTES + data.byteOffset, CLAMPED ? toUint8Clamped(value) : value, true);
    };

    var addElement = function (that, index) {
      nativeDefineProperty(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };

    if (!NATIVE_ARRAY_BUFFER_VIEWS) {
      TypedArrayConstructor = wrapper(function (that, data, offset, $length) {
        anInstance(that, TypedArrayConstructorPrototype);
        var index = 0;
        var byteOffset = 0;
        var buffer, byteLength, length;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new ArrayBuffer(byteLength);
        } else if (isArrayBuffer(data)) {
          buffer = data;
          byteOffset = toOffset(offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - byteOffset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + byteOffset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (isTypedArray(data)) {
          return fromList(TypedArrayConstructor, data);
        } else {
          return call(typedArrayFrom, TypedArrayConstructor, data);
        }
        setInternalState(that, {
          buffer: buffer,
          byteOffset: byteOffset,
          byteLength: byteLength,
          length: length,
          view: new DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });

      if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
      TypedArrayConstructorPrototype = TypedArrayConstructor.prototype = create(TypedArrayPrototype);
    } else if (TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS) {
      TypedArrayConstructor = wrapper(function (dummy, data, typedArrayOffset, $length) {
        anInstance(dummy, TypedArrayConstructorPrototype);
        return inheritIfRequired(function () {
          if (!isObject(data)) return new NativeTypedArrayConstructor(toIndex(data));
          if (isArrayBuffer(data)) return $length !== undefined
            ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES), $length)
            : typedArrayOffset !== undefined
              ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES))
              : new NativeTypedArrayConstructor(data);
          if (isTypedArray(data)) return fromList(TypedArrayConstructor, data);
          return call(typedArrayFrom, TypedArrayConstructor, data);
        }(), dummy, TypedArrayConstructor);
      });

      if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
      forEach(getOwnPropertyNames(NativeTypedArrayConstructor), function (key) {
        if (!(key in TypedArrayConstructor)) {
          createNonEnumerableProperty(TypedArrayConstructor, key, NativeTypedArrayConstructor[key]);
        }
      });
      TypedArrayConstructor.prototype = TypedArrayConstructorPrototype;
    }

    if (TypedArrayConstructorPrototype.constructor !== TypedArrayConstructor) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, 'constructor', TypedArrayConstructor);
    }

    enforceInternalState(TypedArrayConstructorPrototype).TypedArrayConstructor = TypedArrayConstructor;

    if (TYPED_ARRAY_TAG) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, TYPED_ARRAY_TAG, CONSTRUCTOR_NAME);
    }

    var FORCED = TypedArrayConstructor !== NativeTypedArrayConstructor;

    exported[CONSTRUCTOR_NAME] = TypedArrayConstructor;

    $({ global: true, constructor: true, forced: FORCED, sham: !NATIVE_ARRAY_BUFFER_VIEWS }, exported);

    if (!(BYTES_PER_ELEMENT in TypedArrayConstructor)) {
      createNonEnumerableProperty(TypedArrayConstructor, BYTES_PER_ELEMENT, BYTES);
    }

    if (!(BYTES_PER_ELEMENT in TypedArrayConstructorPrototype)) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, BYTES_PER_ELEMENT, BYTES);
    }

    setSpecies(CONSTRUCTOR_NAME);
  };
} else module.exports = function () { /* empty */ };


/***/ }),

/***/ 45958:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

/* eslint-disable no-new -- required for testing */
var global = __webpack_require__(27990);
var fails = __webpack_require__(79645);
var checkCorrectnessOfIteration = __webpack_require__(27506);
var NATIVE_ARRAY_BUFFER_VIEWS = (__webpack_require__(63214).NATIVE_ARRAY_BUFFER_VIEWS);

var ArrayBuffer = global.ArrayBuffer;
var Int8Array = global.Int8Array;

module.exports = !NATIVE_ARRAY_BUFFER_VIEWS || !fails(function () {
  Int8Array(1);
}) || !fails(function () {
  new Int8Array(-1);
}) || !checkCorrectnessOfIteration(function (iterable) {
  new Int8Array();
  new Int8Array(null);
  new Int8Array(1.5);
  new Int8Array(iterable);
}, true) || fails(function () {
  // Safari (11+) bug - a reason why even Safari 13 should load a typed array polyfill
  return new Int8Array(new ArrayBuffer(2), 1, undefined).length !== 1;
});


/***/ }),

/***/ 66252:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var arrayFromConstructorAndList = __webpack_require__(96524);
var typedArraySpeciesConstructor = __webpack_require__(61444);

module.exports = function (instance, list) {
  return arrayFromConstructorAndList(typedArraySpeciesConstructor(instance), list);
};


/***/ }),

/***/ 18110:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var bind = __webpack_require__(82144);
var call = __webpack_require__(17725);
var aConstructor = __webpack_require__(67877);
var toObject = __webpack_require__(76075);
var lengthOfArrayLike = __webpack_require__(2103);
var getIterator = __webpack_require__(34431);
var getIteratorMethod = __webpack_require__(19463);
var isArrayIteratorMethod = __webpack_require__(95409);
var isBigIntArray = __webpack_require__(24220);
var aTypedArrayConstructor = (__webpack_require__(63214).aTypedArrayConstructor);
var toBigInt = __webpack_require__(90797);

module.exports = function from(source /* , mapfn, thisArg */) {
  var C = aConstructor(this);
  var O = toObject(source);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod(O);
  var i, length, result, thisIsBigIntArray, value, step, iterator, next;
  if (iteratorMethod && !isArrayIteratorMethod(iteratorMethod)) {
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    O = [];
    while (!(step = call(next, iterator)).done) {
      O.push(step.value);
    }
  }
  if (mapping && argumentsLength > 2) {
    mapfn = bind(mapfn, arguments[2]);
  }
  length = lengthOfArrayLike(O);
  result = new (aTypedArrayConstructor(C))(length);
  thisIsBigIntArray = isBigIntArray(result);
  for (i = 0; length > i; i++) {
    value = mapping ? mapfn(O[i], i) : O[i];
    // FF30- typed arrays doesn't properly convert objects to typed array values
    result[i] = thisIsBigIntArray ? toBigInt(value) : +value;
  }
  return result;
};


/***/ }),

/***/ 61444:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(63214);
var speciesConstructor = __webpack_require__(6178);

var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;

// a part of `TypedArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#typedarray-species-create
module.exports = function (originalArray) {
  return aTypedArrayConstructor(speciesConstructor(originalArray, getTypedArrayConstructor(originalArray)));
};


/***/ }),

/***/ 40160:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(52058);

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ 88682:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fails = __webpack_require__(79645);
var wellKnownSymbol = __webpack_require__(15537);
var DESCRIPTORS = __webpack_require__(40369);
var IS_PURE = __webpack_require__(81566);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = !fails(function () {
  // eslint-disable-next-line unicorn/relative-url-style -- required for testing
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var params = url.searchParams;
  var params2 = new URLSearchParams('a=1&a=2&b=3');
  var result = '';
  url.pathname = 'c%20d';
  params.forEach(function (value, key) {
    params['delete']('b');
    result += key + value;
  });
  params2['delete']('a', 2);
  // `undefined` case is a Chromium 117 bug
  // https://bugs.chromium.org/p/v8/issues/detail?id=14222
  params2['delete']('b', undefined);
  return (IS_PURE && (!url.toJSON || !params2.has('a', 1) || params2.has('a', 2) || !params2.has('a', undefined) || params2.has('b')))
    || (!params.size && (IS_PURE || !DESCRIPTORS))
    || !params.sort
    || url.href !== 'http://a/c%20d?a=1&c=3'
    || params.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !params[ITERATOR]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('http://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('http://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('http://x', undefined).host !== 'x';
});


/***/ }),

/***/ 40144:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__(97987);

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ 30446:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__(40369);
var fails = __webpack_require__(79645);

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});


/***/ }),

/***/ 9823:
/***/ ((module) => {

"use strict";

var $TypeError = TypeError;

module.exports = function (passed, required) {
  if (passed < required) throw $TypeError('Not enough arguments');
  return passed;
};


/***/ }),

/***/ 19514:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(27990);
var isCallable = __webpack_require__(31808);

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));


/***/ }),

/***/ 94534:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var path = __webpack_require__(84231);
var hasOwn = __webpack_require__(48496);
var wrappedWellKnownSymbolModule = __webpack_require__(45134);
var defineProperty = (__webpack_require__(3002).f);

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!hasOwn(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ 45134:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

var wellKnownSymbol = __webpack_require__(15537);

exports.f = wellKnownSymbol;


/***/ }),

/***/ 15537:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(27990);
var shared = __webpack_require__(69808);
var hasOwn = __webpack_require__(48496);
var uid = __webpack_require__(40160);
var NATIVE_SYMBOL = __webpack_require__(97987);
var USE_SYMBOL_AS_UID = __webpack_require__(40144);

var Symbol = global.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
      ? Symbol[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ 88898:
/***/ ((module) => {

"use strict";

// a string of all valid unicode whitespaces
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ 87327:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var global = __webpack_require__(27990);
var arrayBufferModule = __webpack_require__(4503);
var setSpecies = __webpack_require__(74004);

var ARRAY_BUFFER = 'ArrayBuffer';
var ArrayBuffer = arrayBufferModule[ARRAY_BUFFER];
var NativeArrayBuffer = global[ARRAY_BUFFER];

// `ArrayBuffer` constructor
// https://tc39.es/ecma262/#sec-arraybuffer-constructor
$({ global: true, constructor: true, forced: NativeArrayBuffer !== ArrayBuffer }, {
  ArrayBuffer: ArrayBuffer
});

setSpecies(ARRAY_BUFFER);


/***/ }),

/***/ 29548:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var fails = __webpack_require__(79645);
var isArray = __webpack_require__(81113);
var isObject = __webpack_require__(27627);
var toObject = __webpack_require__(76075);
var lengthOfArrayLike = __webpack_require__(2103);
var doesNotExceedSafeInteger = __webpack_require__(64023);
var createProperty = __webpack_require__(88990);
var arraySpeciesCreate = __webpack_require__(87745);
var arrayMethodHasSpeciesSupport = __webpack_require__(1825);
var wellKnownSymbol = __webpack_require__(15537);
var V8_VERSION = __webpack_require__(1579);

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !arrayMethodHasSpeciesSupport('concat');

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike(E);
        doesNotExceedSafeInteger(n + len);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        doesNotExceedSafeInteger(n + 1);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ 86100:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var fill = __webpack_require__(7769);
var addToUnscopables = __webpack_require__(58521);

// `Array.prototype.fill` method
// https://tc39.es/ecma262/#sec-array.prototype.fill
$({ target: 'Array', proto: true }, {
  fill: fill
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('fill');


/***/ }),

/***/ 59724:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var $filter = (__webpack_require__(28695).filter);
var arrayMethodHasSpeciesSupport = __webpack_require__(1825);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 96573:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var $findIndex = (__webpack_require__(28695).findIndex);
var addToUnscopables = __webpack_require__(58521);

var FIND_INDEX = 'findIndex';
var SKIPS_HOLES = true;

// Shouldn't skip holes
// eslint-disable-next-line es/no-array-prototype-findindex -- testing
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });

// `Array.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findindex
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND_INDEX);


/***/ }),

/***/ 10115:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var $find = (__webpack_require__(28695).find);
var addToUnscopables = __webpack_require__(58521);

var FIND = 'find';
var SKIPS_HOLES = true;

// Shouldn't skip holes
// eslint-disable-next-line es/no-array-prototype-find -- testing
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);


/***/ }),

/***/ 45538:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var flattenIntoArray = __webpack_require__(45598);
var aCallable = __webpack_require__(44596);
var toObject = __webpack_require__(76075);
var lengthOfArrayLike = __webpack_require__(2103);
var arraySpeciesCreate = __webpack_require__(87745);

// `Array.prototype.flatMap` method
// https://tc39.es/ecma262/#sec-array.prototype.flatmap
$({ target: 'Array', proto: true }, {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen = lengthOfArrayLike(O);
    var A;
    aCallable(callbackfn);
    A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    return A;
  }
});


/***/ }),

/***/ 62853:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var flattenIntoArray = __webpack_require__(45598);
var toObject = __webpack_require__(76075);
var lengthOfArrayLike = __webpack_require__(2103);
var toIntegerOrInfinity = __webpack_require__(9163);
var arraySpeciesCreate = __webpack_require__(87745);

// `Array.prototype.flat` method
// https://tc39.es/ecma262/#sec-array.prototype.flat
$({ target: 'Array', proto: true }, {
  flat: function flat(/* depthArg = 1 */) {
    var depthArg = arguments.length ? arguments[0] : undefined;
    var O = toObject(this);
    var sourceLen = lengthOfArrayLike(O);
    var A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toIntegerOrInfinity(depthArg));
    return A;
  }
});


/***/ }),

/***/ 62975:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var from = __webpack_require__(27530);
var checkCorrectnessOfIteration = __webpack_require__(27506);

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  // eslint-disable-next-line es/no-array-from -- required for testing
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),

/***/ 93485:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var $includes = (__webpack_require__(96039).includes);
var fails = __webpack_require__(79645);
var addToUnscopables = __webpack_require__(58521);

// FF99+ bug
var BROKEN_ON_SPARSE = fails(function () {
  // eslint-disable-next-line es/no-array-prototype-includes -- detection
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),

/***/ 26677:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toIndexedObject = __webpack_require__(17794);
var addToUnscopables = __webpack_require__(58521);
var Iterators = __webpack_require__(33820);
var InternalStateModule = __webpack_require__(47776);
var defineProperty = (__webpack_require__(3002).f);
var defineIterator = __webpack_require__(58994);
var createIterResultObject = __webpack_require__(62526);
var IS_PURE = __webpack_require__(81566);
var DESCRIPTORS = __webpack_require__(40369);

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  switch (kind) {
    case 'keys': return createIterResultObject(index, false);
    case 'values': return createIterResultObject(target[index], false);
  } return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (!IS_PURE && DESCRIPTORS && values.name !== 'values') try {
  defineProperty(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }


/***/ }),

/***/ 30415:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var uncurryThis = __webpack_require__(52058);
var IndexedObject = __webpack_require__(29860);
var toIndexedObject = __webpack_require__(17794);
var arrayMethodIsStrict = __webpack_require__(77437);

var nativeJoin = uncurryThis([].join);

var ES3_STRINGS = IndexedObject !== Object;
var FORCED = ES3_STRINGS || !arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: FORCED }, {
  join: function join(separator) {
    return nativeJoin(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),

/***/ 53252:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var $map = (__webpack_require__(28695).map);
var arrayMethodHasSpeciesSupport = __webpack_require__(1825);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 76300:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var $reduceRight = (__webpack_require__(16138).right);
var arrayMethodIsStrict = __webpack_require__(77437);
var CHROME_VERSION = __webpack_require__(1579);
var IS_NODE = __webpack_require__(28018);

// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;
var FORCED = CHROME_BUG || !arrayMethodIsStrict('reduceRight');

// `Array.prototype.reduceRight` method
// https://tc39.es/ecma262/#sec-array.prototype.reduceright
$({ target: 'Array', proto: true, forced: FORCED }, {
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduceRight(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 34479:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var $reduce = (__webpack_require__(16138).left);
var arrayMethodIsStrict = __webpack_require__(77437);
var CHROME_VERSION = __webpack_require__(1579);
var IS_NODE = __webpack_require__(28018);

// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;
var FORCED = CHROME_BUG || !arrayMethodIsStrict('reduce');

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$({ target: 'Array', proto: true, forced: FORCED }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var length = arguments.length;
    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 97343:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var isArray = __webpack_require__(81113);
var isConstructor = __webpack_require__(92701);
var isObject = __webpack_require__(27627);
var toAbsoluteIndex = __webpack_require__(97913);
var lengthOfArrayLike = __webpack_require__(2103);
var toIndexedObject = __webpack_require__(17794);
var createProperty = __webpack_require__(88990);
var wellKnownSymbol = __webpack_require__(15537);
var arrayMethodHasSpeciesSupport = __webpack_require__(1825);
var nativeSlice = __webpack_require__(59591);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

var SPECIES = wellKnownSymbol('species');
var $Array = Array;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = lengthOfArrayLike(O);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (isConstructor(Constructor) && (Constructor === $Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === $Array || Constructor === undefined) {
        return nativeSlice(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? $Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ 30382:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var uncurryThis = __webpack_require__(52058);
var aCallable = __webpack_require__(44596);
var toObject = __webpack_require__(76075);
var lengthOfArrayLike = __webpack_require__(2103);
var deletePropertyOrThrow = __webpack_require__(39929);
var toString = __webpack_require__(70158);
var fails = __webpack_require__(79645);
var internalSort = __webpack_require__(626);
var arrayMethodIsStrict = __webpack_require__(77437);
var FF = __webpack_require__(95676);
var IE_OR_EDGE = __webpack_require__(79619);
var V8 = __webpack_require__(1579);
var WEBKIT = __webpack_require__(42861);

var test = [];
var nativeSort = uncurryThis(test.sort);
var push = uncurryThis(test.push);

// IE8-
var FAILS_ON_UNDEFINED = fails(function () {
  test.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails(function () {
  test.sort(null);
});
// Old WebKit
var STRICT_METHOD = arrayMethodIsStrict('sort');

var STABLE_SORT = !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 70;
  if (FF && FF > 3) return;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 603;

  var result = '';
  var code, chr, value, index;

  // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);

    switch (code) {
      case 66: case 69: case 70: case 72: value = 3; break;
      case 68: case 71: value = 4; break;
      default: value = 2;
    }

    for (index = 0; index < 47; index++) {
      test.push({ k: chr + index, v: value });
    }
  }

  test.sort(function (a, b) { return b.v - a.v; });

  for (index = 0; index < test.length; index++) {
    chr = test[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }

  return result !== 'DGBEFHACIJK';
});

var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return toString(x) > toString(y) ? 1 : -1;
  };
};

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$({ target: 'Array', proto: true, forced: FORCED }, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aCallable(comparefn);

    var array = toObject(this);

    if (STABLE_SORT) return comparefn === undefined ? nativeSort(array) : nativeSort(array, comparefn);

    var items = [];
    var arrayLength = lengthOfArrayLike(array);
    var itemsLength, index;

    for (index = 0; index < arrayLength; index++) {
      if (index in array) push(items, array[index]);
    }

    internalSort(items, getSortCompare(comparefn));

    itemsLength = lengthOfArrayLike(items);
    index = 0;

    while (index < itemsLength) array[index] = items[index++];
    while (index < arrayLength) deletePropertyOrThrow(array, index++);

    return array;
  }
});


/***/ }),

/***/ 72578:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var toObject = __webpack_require__(76075);
var toAbsoluteIndex = __webpack_require__(97913);
var toIntegerOrInfinity = __webpack_require__(9163);
var lengthOfArrayLike = __webpack_require__(2103);
var setArrayLength = __webpack_require__(22781);
var doesNotExceedSafeInteger = __webpack_require__(64023);
var arraySpeciesCreate = __webpack_require__(87745);
var createProperty = __webpack_require__(88990);
var deletePropertyOrThrow = __webpack_require__(39929);
var arrayMethodHasSpeciesSupport = __webpack_require__(1825);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');

var max = Math.max;
var min = Math.min;

// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max(toIntegerOrInfinity(deleteCount), 0), len - actualStart);
    }
    doesNotExceedSafeInteger(len + insertCount - actualDeleteCount);
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else deletePropertyOrThrow(O, to);
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) deletePropertyOrThrow(O, k - 1);
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else deletePropertyOrThrow(O, to);
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    setArrayLength(O, len - actualDeleteCount + insertCount);
    return A;
  }
});


/***/ }),

/***/ 20423:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = __webpack_require__(58521);

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('flatMap');


/***/ }),

/***/ 35628:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = __webpack_require__(58521);

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('flat');


/***/ }),

/***/ 77402:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__(40369);
var FUNCTION_NAME_EXISTS = (__webpack_require__(92697).EXISTS);
var uncurryThis = __webpack_require__(52058);
var defineBuiltInAccessor = __webpack_require__(4259);

var FunctionPrototype = Function.prototype;
var functionToString = uncurryThis(FunctionPrototype.toString);
var nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var regExpExec = uncurryThis(nameRE.exec);
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !FUNCTION_NAME_EXISTS) {
  defineBuiltInAccessor(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return regExpExec(nameRE, functionToString(this))[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),

/***/ 83066:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var getBuiltIn = __webpack_require__(91553);
var apply = __webpack_require__(59878);
var call = __webpack_require__(17725);
var uncurryThis = __webpack_require__(52058);
var fails = __webpack_require__(79645);
var isCallable = __webpack_require__(31808);
var isSymbol = __webpack_require__(44003);
var arraySlice = __webpack_require__(59591);
var getReplacerFunction = __webpack_require__(17061);
var NATIVE_SYMBOL = __webpack_require__(97987);

var $String = String;
var $stringify = getBuiltIn('JSON', 'stringify');
var exec = uncurryThis(/./.exec);
var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var replace = uncurryThis(''.replace);
var numberToString = uncurryThis(1.0.toString);

var tester = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var WRONG_SYMBOLS_CONVERSION = !NATIVE_SYMBOL || fails(function () {
  var symbol = getBuiltIn('Symbol')('stringify detection');
  // MS Edge converts symbol values to JSON as {}
  return $stringify([symbol]) !== '[null]'
    // WebKit converts symbol values to JSON as null
    || $stringify({ a: symbol }) !== '{}'
    // V8 throws on boxed symbols
    || $stringify(Object(symbol)) !== '{}';
});

// https://github.com/tc39/proposal-well-formed-stringify
var ILL_FORMED_UNICODE = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

var stringifyWithSymbolsFix = function (it, replacer) {
  var args = arraySlice(arguments);
  var $replacer = getReplacerFunction(replacer);
  if (!isCallable($replacer) && (it === undefined || isSymbol(it))) return; // IE8 returns string on undefined
  args[1] = function (key, value) {
    // some old implementations (like WebKit) could pass numbers as keys
    if (isCallable($replacer)) value = call($replacer, this, $String(key), value);
    if (!isSymbol(value)) return value;
  };
  return apply($stringify, null, args);
};

var fixIllFormed = function (match, offset, string) {
  var prev = charAt(string, offset - 1);
  var next = charAt(string, offset + 1);
  if ((exec(low, match) && !exec(hi, next)) || (exec(hi, match) && !exec(low, prev))) {
    return '\\u' + numberToString(charCodeAt(match, 0), 16);
  } return match;
};

if ($stringify) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  $({ target: 'JSON', stat: true, arity: 3, forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice(arguments);
      var result = apply(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
      return ILL_FORMED_UNICODE && typeof result == 'string' ? replace(result, tester, fixIllFormed) : result;
    }
  });
}


/***/ }),

/***/ 39367:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var collection = __webpack_require__(75430);
var collectionStrong = __webpack_require__(4055);

// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
collection('Map', function (init) {
  return function Map() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),

/***/ 90398:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__(39367);


/***/ }),

/***/ 74391:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var trunc = __webpack_require__(6357);

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
$({ target: 'Math', stat: true }, {
  trunc: trunc
});


/***/ }),

/***/ 47865:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var IS_PURE = __webpack_require__(81566);
var DESCRIPTORS = __webpack_require__(40369);
var global = __webpack_require__(27990);
var path = __webpack_require__(84231);
var uncurryThis = __webpack_require__(52058);
var isForced = __webpack_require__(69168);
var hasOwn = __webpack_require__(48496);
var inheritIfRequired = __webpack_require__(74240);
var isPrototypeOf = __webpack_require__(88304);
var isSymbol = __webpack_require__(44003);
var toPrimitive = __webpack_require__(69182);
var fails = __webpack_require__(79645);
var getOwnPropertyNames = (__webpack_require__(88766).f);
var getOwnPropertyDescriptor = (__webpack_require__(94086).f);
var defineProperty = (__webpack_require__(3002).f);
var thisNumberValue = __webpack_require__(67065);
var trim = (__webpack_require__(84610).trim);

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var PureNumberNamespace = path[NUMBER];
var NumberPrototype = NativeNumber.prototype;
var TypeError = global.TypeError;
var stringSlice = uncurryThis(''.slice);
var charCodeAt = uncurryThis(''.charCodeAt);

// `ToNumeric` abstract operation
// https://tc39.es/ecma262/#sec-tonumeric
var toNumeric = function (value) {
  var primValue = toPrimitive(value, 'number');
  return typeof primValue == 'bigint' ? primValue : toNumber(primValue);
};

// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, 'number');
  var first, third, radix, maxCode, digits, length, index, code;
  if (isSymbol(it)) throw TypeError('Cannot convert a Symbol value to a number');
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = charCodeAt(it, 0);
    if (first === 43 || first === 45) {
      third = charCodeAt(it, 2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (charCodeAt(it, 1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = stringSlice(it, 2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = charCodeAt(digits, index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

var FORCED = isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'));

var calledWithNew = function (dummy) {
  // includes check on 1..constructor(foo) case
  return isPrototypeOf(NumberPrototype, dummy) && fails(function () { thisNumberValue(dummy); });
};

// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
var NumberWrapper = function Number(value) {
  var n = arguments.length < 1 ? 0 : NativeNumber(toNumeric(value));
  return calledWithNew(this) ? inheritIfRequired(Object(n), this, NumberWrapper) : n;
};

NumberWrapper.prototype = NumberPrototype;
if (FORCED && !IS_PURE) NumberPrototype.constructor = NumberWrapper;

$({ global: true, constructor: true, wrap: true, forced: FORCED }, {
  Number: NumberWrapper
});

// Use `internal/copy-constructor-properties` helper in `core-js@4`
var copyConstructorProperties = function (target, source) {
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(source) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,' +
    // ESNext
    'fromString,range'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (hasOwn(source, key = keys[j]) && !hasOwn(target, key)) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

if (IS_PURE && PureNumberNamespace) copyConstructorProperties(path[NUMBER], PureNumberNamespace);
if (FORCED || IS_PURE) copyConstructorProperties(path[NUMBER], NativeNumber);


/***/ }),

/***/ 86602:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var numberIsFinite = __webpack_require__(43403);

// `Number.isFinite` method
// https://tc39.es/ecma262/#sec-number.isfinite
$({ target: 'Number', stat: true }, { isFinite: numberIsFinite });


/***/ }),

/***/ 35056:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var isIntegralNumber = __webpack_require__(29965);

// `Number.isInteger` method
// https://tc39.es/ecma262/#sec-number.isinteger
$({ target: 'Number', stat: true }, {
  isInteger: isIntegralNumber
});


/***/ }),

/***/ 33807:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var uncurryThis = __webpack_require__(52058);
var toIntegerOrInfinity = __webpack_require__(9163);
var thisNumberValue = __webpack_require__(67065);
var $repeat = __webpack_require__(69523);
var fails = __webpack_require__(79645);

var $RangeError = RangeError;
var $String = String;
var floor = Math.floor;
var repeat = uncurryThis($repeat);
var stringSlice = uncurryThis(''.slice);
var nativeToFixed = uncurryThis(1.0.toFixed);

var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};

var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

var multiply = function (data, n, c) {
  var index = -1;
  var c2 = c;
  while (++index < 6) {
    c2 += n * data[index];
    data[index] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};

var divide = function (data, n) {
  var index = 6;
  var c = 0;
  while (--index >= 0) {
    c += data[index];
    data[index] = floor(c / n);
    c = (c % n) * 1e7;
  }
};

var dataToString = function (data) {
  var index = 6;
  var s = '';
  while (--index >= 0) {
    if (s !== '' || index === 0 || data[index] !== 0) {
      var t = $String(data[index]);
      s = s === '' ? t : s + repeat('0', 7 - t.length) + t;
    }
  } return s;
};

var FORCED = fails(function () {
  return nativeToFixed(0.00008, 3) !== '0.000' ||
    nativeToFixed(0.9, 0) !== '1' ||
    nativeToFixed(1.255, 2) !== '1.25' ||
    nativeToFixed(1000000000000000128.0, 0) !== '1000000000000000128';
}) || !fails(function () {
  // V8 ~ Android 4.3-
  nativeToFixed({});
});

// `Number.prototype.toFixed` method
// https://tc39.es/ecma262/#sec-number.prototype.tofixed
$({ target: 'Number', proto: true, forced: FORCED }, {
  toFixed: function toFixed(fractionDigits) {
    var number = thisNumberValue(this);
    var fractDigits = toIntegerOrInfinity(fractionDigits);
    var data = [0, 0, 0, 0, 0, 0];
    var sign = '';
    var result = '0';
    var e, z, j, k;

    // TODO: ES2018 increased the maximum number of fraction digits to 100, need to improve the implementation
    if (fractDigits < 0 || fractDigits > 20) throw $RangeError('Incorrect fraction digits');
    // eslint-disable-next-line no-self-compare -- NaN check
    if (number !== number) return 'NaN';
    if (number <= -1e21 || number >= 1e21) return $String(number);
    if (number < 0) {
      sign = '-';
      number = -number;
    }
    if (number > 1e-21) {
      e = log(number * pow(2, 69, 1)) - 69;
      z = e < 0 ? number * pow(2, -e, 1) : number / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(data, 0, z);
        j = fractDigits;
        while (j >= 7) {
          multiply(data, 1e7, 0);
          j -= 7;
        }
        multiply(data, pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(data, 1 << 23);
          j -= 23;
        }
        divide(data, 1 << j);
        multiply(data, 1, 1);
        divide(data, 2);
        result = dataToString(data);
      } else {
        multiply(data, 0, z);
        multiply(data, 1 << -e, 0);
        result = dataToString(data) + repeat('0', fractDigits);
      }
    }
    if (fractDigits > 0) {
      k = result.length;
      result = sign + (k <= fractDigits
        ? '0.' + repeat('0', fractDigits - k) + result
        : stringSlice(result, 0, k - fractDigits) + '.' + stringSlice(result, k - fractDigits));
    } else {
      result = sign + result;
    } return result;
  }
});


/***/ }),

/***/ 8032:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var assign = __webpack_require__(26779);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ }),

/***/ 59232:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var DESCRIPTORS = __webpack_require__(40369);
var FORCED = __webpack_require__(8833);
var aCallable = __webpack_require__(44596);
var toObject = __webpack_require__(76075);
var definePropertyModule = __webpack_require__(3002);

// `Object.prototype.__defineGetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__defineGetter__
if (DESCRIPTORS) {
  $({ target: 'Object', proto: true, forced: FORCED }, {
    __defineGetter__: function __defineGetter__(P, getter) {
      definePropertyModule.f(toObject(this), P, { get: aCallable(getter), enumerable: true, configurable: true });
    }
  });
}


/***/ }),

/***/ 72338:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var DESCRIPTORS = __webpack_require__(40369);
var FORCED = __webpack_require__(8833);
var aCallable = __webpack_require__(44596);
var toObject = __webpack_require__(76075);
var definePropertyModule = __webpack_require__(3002);

// `Object.prototype.__defineSetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__defineSetter__
if (DESCRIPTORS) {
  $({ target: 'Object', proto: true, forced: FORCED }, {
    __defineSetter__: function __defineSetter__(P, setter) {
      definePropertyModule.f(toObject(this), P, { set: aCallable(setter), enumerable: true, configurable: true });
    }
  });
}


/***/ }),

/***/ 8262:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var $entries = (__webpack_require__(99842).entries);

// `Object.entries` method
// https://tc39.es/ecma262/#sec-object.entries
$({ target: 'Object', stat: true }, {
  entries: function entries(O) {
    return $entries(O);
  }
});


/***/ }),

/***/ 76105:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var FREEZING = __webpack_require__(5541);
var fails = __webpack_require__(79645);
var isObject = __webpack_require__(27627);
var onFreeze = (__webpack_require__(34926).onFreeze);

// eslint-disable-next-line es/no-object-freeze -- safe
var $freeze = Object.freeze;
var FAILS_ON_PRIMITIVES = fails(function () { $freeze(1); });

// `Object.freeze` method
// https://tc39.es/ecma262/#sec-object.freeze
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !FREEZING }, {
  freeze: function freeze(it) {
    return $freeze && isObject(it) ? $freeze(onFreeze(it)) : it;
  }
});


/***/ }),

/***/ 45190:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var fails = __webpack_require__(79645);
var toIndexedObject = __webpack_require__(17794);
var nativeGetOwnPropertyDescriptor = (__webpack_require__(94086).f);
var DESCRIPTORS = __webpack_require__(40369);

var FORCED = !DESCRIPTORS || fails(function () { nativeGetOwnPropertyDescriptor(1); });

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),

/***/ 13714:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var fails = __webpack_require__(79645);
var getOwnPropertyNames = (__webpack_require__(47092).f);

// eslint-disable-next-line es/no-object-getownpropertynames -- required for testing
var FAILS_ON_PRIMITIVES = fails(function () { return !Object.getOwnPropertyNames(1); });

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  getOwnPropertyNames: getOwnPropertyNames
});


/***/ }),

/***/ 60530:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var NATIVE_SYMBOL = __webpack_require__(97987);
var fails = __webpack_require__(79645);
var getOwnPropertySymbolsModule = __webpack_require__(28559);
var toObject = __webpack_require__(76075);

// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FORCED = !NATIVE_SYMBOL || fails(function () { getOwnPropertySymbolsModule.f(1); });

// `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
$({ target: 'Object', stat: true, forced: FORCED }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    var $getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    return $getOwnPropertySymbols ? $getOwnPropertySymbols(toObject(it)) : [];
  }
});


/***/ }),

/***/ 22319:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var fails = __webpack_require__(79645);
var toObject = __webpack_require__(76075);
var nativeGetPrototypeOf = __webpack_require__(56285);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(16382);

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetPrototypeOf(1); });

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(it) {
    return nativeGetPrototypeOf(toObject(it));
  }
});



/***/ }),

/***/ 65759:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var toObject = __webpack_require__(76075);
var nativeKeys = __webpack_require__(88071);
var fails = __webpack_require__(79645);

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ 67478:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(32709);
var defineBuiltIn = __webpack_require__(96561);
var toString = __webpack_require__(52009);

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  defineBuiltIn(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ 42578:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var $values = (__webpack_require__(99842).values);

// `Object.values` method
// https://tc39.es/ecma262/#sec-object.values
$({ target: 'Object', stat: true }, {
  values: function values(O) {
    return $values(O);
  }
});


/***/ }),

/***/ 3009:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var call = __webpack_require__(17725);
var aCallable = __webpack_require__(44596);
var newPromiseCapabilityModule = __webpack_require__(50606);
var perform = __webpack_require__(43639);
var iterate = __webpack_require__(41851);
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__(95289);

// `Promise.allSettled` method
// https://tc39.es/ecma262/#sec-promise.allsettled
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  allSettled: function allSettled(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call(promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'fulfilled', value: value };
          --remaining || resolve(values);
        }, function (error) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'rejected', reason: error };
          --remaining || resolve(values);
        });
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ 88801:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var call = __webpack_require__(17725);
var aCallable = __webpack_require__(44596);
var newPromiseCapabilityModule = __webpack_require__(50606);
var perform = __webpack_require__(43639);
var iterate = __webpack_require__(41851);
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__(95289);

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ 16094:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var IS_PURE = __webpack_require__(81566);
var FORCED_PROMISE_CONSTRUCTOR = (__webpack_require__(32862).CONSTRUCTOR);
var NativePromiseConstructor = __webpack_require__(29952);
var getBuiltIn = __webpack_require__(91553);
var isCallable = __webpack_require__(31808);
var defineBuiltIn = __webpack_require__(96561);

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (!IS_PURE && isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn('Promise').prototype['catch'];
  if (NativePromisePrototype['catch'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'catch', method, { unsafe: true });
  }
}


/***/ }),

/***/ 97362:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var IS_PURE = __webpack_require__(81566);
var IS_NODE = __webpack_require__(28018);
var global = __webpack_require__(27990);
var call = __webpack_require__(17725);
var defineBuiltIn = __webpack_require__(96561);
var setPrototypeOf = __webpack_require__(27323);
var setToStringTag = __webpack_require__(71508);
var setSpecies = __webpack_require__(74004);
var aCallable = __webpack_require__(44596);
var isCallable = __webpack_require__(31808);
var isObject = __webpack_require__(27627);
var anInstance = __webpack_require__(87787);
var speciesConstructor = __webpack_require__(6178);
var task = (__webpack_require__(24657).set);
var microtask = __webpack_require__(73586);
var hostReportErrors = __webpack_require__(79294);
var perform = __webpack_require__(43639);
var Queue = __webpack_require__(8390);
var InternalStateModule = __webpack_require__(47776);
var NativePromiseConstructor = __webpack_require__(29952);
var PromiseConstructorDetection = __webpack_require__(32862);
var newPromiseCapabilityModule = __webpack_require__(50606);

var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var setInternalState = InternalStateModule.set;
var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var PromiseConstructor = NativePromiseConstructor;
var PromisePrototype = NativePromisePrototype;
var TypeError = global.TypeError;
var document = global.document;
var process = global.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;

var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && isCallable(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state === FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(TypeError('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call(task, global, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call(task, global, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call(then, value,
            bind(internalResolve, wrapper, state),
            bind(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable(executor);
    call(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind(internalResolve, state), bind(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable(onRejected) && onRejected;
    reaction.domain = IS_NODE ? process.domain : undefined;
    if (state.state === PENDING) state.reactions.add(reaction);
    else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, state);
    this.reject = bind(internalReject, state);
  };

  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && isCallable(NativePromiseConstructor) && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype, PromisePrototype);
    }
  }
}

$({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);


/***/ }),

/***/ 45142:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var IS_PURE = __webpack_require__(81566);
var NativePromiseConstructor = __webpack_require__(29952);
var fails = __webpack_require__(79645);
var getBuiltIn = __webpack_require__(91553);
var isCallable = __webpack_require__(31808);
var speciesConstructor = __webpack_require__(6178);
var promiseResolve = __webpack_require__(21513);
var defineBuiltIn = __webpack_require__(96561);

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var NON_GENERIC = !!NativePromiseConstructor && fails(function () {
  // eslint-disable-next-line unicorn/no-thenable -- required for testing
  NativePromisePrototype['finally'].call({ then: function () { /* empty */ } }, function () { /* empty */ });
});

// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$({ target: 'Promise', proto: true, real: true, forced: NON_GENERIC }, {
  'finally': function (onFinally) {
    var C = speciesConstructor(this, getBuiltIn('Promise'));
    var isFunction = isCallable(onFinally);
    return this.then(
      isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () { return x; });
      } : onFinally,
      isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () { throw e; });
      } : onFinally
    );
  }
});

// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (!IS_PURE && isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn('Promise').prototype['finally'];
  if (NativePromisePrototype['finally'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'finally', method, { unsafe: true });
  }
}


/***/ }),

/***/ 96317:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__(97362);
__webpack_require__(88801);
__webpack_require__(16094);
__webpack_require__(84874);
__webpack_require__(2001);
__webpack_require__(37141);


/***/ }),

/***/ 84874:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var call = __webpack_require__(17725);
var aCallable = __webpack_require__(44596);
var newPromiseCapabilityModule = __webpack_require__(50606);
var perform = __webpack_require__(43639);
var iterate = __webpack_require__(41851);
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__(95289);

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      iterate(iterable, function (promise) {
        call($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ 2001:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var call = __webpack_require__(17725);
var newPromiseCapabilityModule = __webpack_require__(50606);
var FORCED_PROMISE_CONSTRUCTOR = (__webpack_require__(32862).CONSTRUCTOR);

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule.f(this);
    call(capability.reject, undefined, r);
    return capability.promise;
  }
});


/***/ }),

/***/ 37141:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var getBuiltIn = __webpack_require__(91553);
var IS_PURE = __webpack_require__(81566);
var NativePromiseConstructor = __webpack_require__(29952);
var FORCED_PROMISE_CONSTRUCTOR = (__webpack_require__(32862).CONSTRUCTOR);
var promiseResolve = __webpack_require__(21513);

var PromiseConstructorWrapper = getBuiltIn('Promise');
var CHECK_WRAPPER = IS_PURE && !FORCED_PROMISE_CONSTRUCTOR;

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$({ target: 'Promise', stat: true, forced: IS_PURE || FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve(CHECK_WRAPPER && this === PromiseConstructorWrapper ? NativePromiseConstructor : this, x);
  }
});


/***/ }),

/***/ 75287:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__(40369);
var global = __webpack_require__(27990);
var uncurryThis = __webpack_require__(52058);
var isForced = __webpack_require__(69168);
var inheritIfRequired = __webpack_require__(74240);
var createNonEnumerableProperty = __webpack_require__(60859);
var getOwnPropertyNames = (__webpack_require__(88766).f);
var isPrototypeOf = __webpack_require__(88304);
var isRegExp = __webpack_require__(95522);
var toString = __webpack_require__(70158);
var getRegExpFlags = __webpack_require__(7660);
var stickyHelpers = __webpack_require__(8373);
var proxyAccessor = __webpack_require__(83204);
var defineBuiltIn = __webpack_require__(96561);
var fails = __webpack_require__(79645);
var hasOwn = __webpack_require__(48496);
var enforceInternalState = (__webpack_require__(47776).enforce);
var setSpecies = __webpack_require__(74004);
var wellKnownSymbol = __webpack_require__(15537);
var UNSUPPORTED_DOT_ALL = __webpack_require__(47784);
var UNSUPPORTED_NCG = __webpack_require__(60546);

var MATCH = wellKnownSymbol('match');
var NativeRegExp = global.RegExp;
var RegExpPrototype = NativeRegExp.prototype;
var SyntaxError = global.SyntaxError;
var exec = uncurryThis(RegExpPrototype.exec);
var charAt = uncurryThis(''.charAt);
var replace = uncurryThis(''.replace);
var stringIndexOf = uncurryThis(''.indexOf);
var stringSlice = uncurryThis(''.slice);
// TODO: Use only proper RegExpIdentifierName
var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var MISSED_STICKY = stickyHelpers.MISSED_STICKY;
var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;

var BASE_FORCED = DESCRIPTORS &&
  (!CORRECT_NEW || MISSED_STICKY || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG || fails(function () {
    re2[MATCH] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    return NativeRegExp(re1) !== re1 || NativeRegExp(re2) === re2 || String(NativeRegExp(re1, 'i')) !== '/a/i';
  }));

var handleDotAll = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var brackets = false;
  var chr;
  for (; index <= length; index++) {
    chr = charAt(string, index);
    if (chr === '\\') {
      result += chr + charAt(string, ++index);
      continue;
    }
    if (!brackets && chr === '.') {
      result += '[\\s\\S]';
    } else {
      if (chr === '[') {
        brackets = true;
      } else if (chr === ']') {
        brackets = false;
      } result += chr;
    }
  } return result;
};

var handleNCG = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var named = [];
  var names = {};
  var brackets = false;
  var ncg = false;
  var groupid = 0;
  var groupname = '';
  var chr;
  for (; index <= length; index++) {
    chr = charAt(string, index);
    if (chr === '\\') {
      chr = chr + charAt(string, ++index);
    } else if (chr === ']') {
      brackets = false;
    } else if (!brackets) switch (true) {
      case chr === '[':
        brackets = true;
        break;
      case chr === '(':
        if (exec(IS_NCG, stringSlice(string, index + 1))) {
          index += 2;
          ncg = true;
        }
        result += chr;
        groupid++;
        continue;
      case chr === '>' && ncg:
        if (groupname === '' || hasOwn(names, groupname)) {
          throw new SyntaxError('Invalid capture group name');
        }
        names[groupname] = true;
        named[named.length] = [groupname, groupid];
        ncg = false;
        groupname = '';
        continue;
    }
    if (ncg) groupname += chr;
    else result += chr;
  } return [result, named];
};

// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if (isForced('RegExp', BASE_FORCED)) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = isPrototypeOf(RegExpPrototype, this);
    var patternIsRegExp = isRegExp(pattern);
    var flagsAreUndefined = flags === undefined;
    var groups = [];
    var rawPattern = pattern;
    var rawFlags, dotAll, sticky, handled, result, state;

    if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) {
      return pattern;
    }

    if (patternIsRegExp || isPrototypeOf(RegExpPrototype, pattern)) {
      pattern = pattern.source;
      if (flagsAreUndefined) flags = getRegExpFlags(rawPattern);
    }

    pattern = pattern === undefined ? '' : toString(pattern);
    flags = flags === undefined ? '' : toString(flags);
    rawPattern = pattern;

    if (UNSUPPORTED_DOT_ALL && 'dotAll' in re1) {
      dotAll = !!flags && stringIndexOf(flags, 's') > -1;
      if (dotAll) flags = replace(flags, /s/g, '');
    }

    rawFlags = flags;

    if (MISSED_STICKY && 'sticky' in re1) {
      sticky = !!flags && stringIndexOf(flags, 'y') > -1;
      if (sticky && UNSUPPORTED_Y) flags = replace(flags, /y/g, '');
    }

    if (UNSUPPORTED_NCG) {
      handled = handleNCG(pattern);
      pattern = handled[0];
      groups = handled[1];
    }

    result = inheritIfRequired(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype, RegExpWrapper);

    if (dotAll || sticky || groups.length) {
      state = enforceInternalState(result);
      if (dotAll) {
        state.dotAll = true;
        state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
      }
      if (sticky) state.sticky = true;
      if (groups.length) state.groups = groups;
    }

    if (pattern !== rawPattern) try {
      // fails in old engines, but we have no alternatives for unsupported regex syntax
      createNonEnumerableProperty(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
    } catch (error) { /* empty */ }

    return result;
  };

  for (var keys = getOwnPropertyNames(NativeRegExp), index = 0; keys.length > index;) {
    proxyAccessor(RegExpWrapper, NativeRegExp, keys[index++]);
  }

  RegExpPrototype.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype;
  defineBuiltIn(global, 'RegExp', RegExpWrapper, { constructor: true });
}

// https://tc39.es/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');


/***/ }),

/***/ 28610:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var exec = __webpack_require__(34530);

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),

/***/ 38051:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(27990);
var DESCRIPTORS = __webpack_require__(40369);
var defineBuiltInAccessor = __webpack_require__(4259);
var regExpFlags = __webpack_require__(50323);
var fails = __webpack_require__(79645);

// babel-minify and Closure Compiler transpiles RegExp('.', 'd') -> /./d and it causes SyntaxError
var RegExp = global.RegExp;
var RegExpPrototype = RegExp.prototype;

var FORCED = DESCRIPTORS && fails(function () {
  var INDICES_SUPPORT = true;
  try {
    RegExp('.', 'd');
  } catch (error) {
    INDICES_SUPPORT = false;
  }

  var O = {};
  // modern V8 bug
  var calls = '';
  var expected = INDICES_SUPPORT ? 'dgimsy' : 'gimsy';

  var addGetter = function (key, chr) {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty(O, key, { get: function () {
      calls += chr;
      return true;
    } });
  };

  var pairs = {
    dotAll: 's',
    global: 'g',
    ignoreCase: 'i',
    multiline: 'm',
    sticky: 'y'
  };

  if (INDICES_SUPPORT) pairs.hasIndices = 'd';

  for (var key in pairs) addGetter(key, pairs[key]);

  // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
  var result = Object.getOwnPropertyDescriptor(RegExpPrototype, 'flags').get.call(O);

  return result !== expected || calls !== expected;
});

// `RegExp.prototype.flags` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
if (FORCED) defineBuiltInAccessor(RegExpPrototype, 'flags', {
  configurable: true,
  get: regExpFlags
});


/***/ }),

/***/ 50851:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var PROPER_FUNCTION_NAME = (__webpack_require__(92697).PROPER);
var defineBuiltIn = __webpack_require__(96561);
var anObject = __webpack_require__(79308);
var $toString = __webpack_require__(70158);
var fails = __webpack_require__(79645);
var getRegExpFlags = __webpack_require__(7660);

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) !== '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && nativeToString.name !== TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var pattern = $toString(R.source);
    var flags = $toString(getRegExpFlags(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}


/***/ }),

/***/ 88282:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var collection = __webpack_require__(75430);
var collectionStrong = __webpack_require__(4055);

// `Set` constructor
// https://tc39.es/ecma262/#sec-set-objects
collection('Set', function (init) {
  return function Set() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),

/***/ 50823:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__(88282);


/***/ }),

/***/ 59074:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var createHTML = __webpack_require__(86449);
var forcedStringHTMLMethod = __webpack_require__(83793);

// `String.prototype.bold` method
// https://tc39.es/ecma262/#sec-string.prototype.bold
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('bold') }, {
  bold: function bold() {
    return createHTML(this, 'b', '', '');
  }
});


/***/ }),

/***/ 6285:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var uncurryThis = __webpack_require__(2330);
var getOwnPropertyDescriptor = (__webpack_require__(94086).f);
var toLength = __webpack_require__(60468);
var toString = __webpack_require__(70158);
var notARegExp = __webpack_require__(82990);
var requireObjectCoercible = __webpack_require__(98622);
var correctIsRegExpLogic = __webpack_require__(63970);
var IS_PURE = __webpack_require__(81566);

// eslint-disable-next-line es/no-string-prototype-endswith -- safe
var nativeEndsWith = uncurryThis(''.endsWith);
var slice = uncurryThis(''.slice);
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('endsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'endsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.endsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.endswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = toString(requireObjectCoercible(this));
    notARegExp(searchString);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = that.length;
    var end = endPosition === undefined ? len : min(toLength(endPosition), len);
    var search = toString(searchString);
    return nativeEndsWith
      ? nativeEndsWith(that, search, end)
      : slice(that, end - search.length, end) === search;
  }
});


/***/ }),

/***/ 94978:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var uncurryThis = __webpack_require__(52058);
var notARegExp = __webpack_require__(82990);
var requireObjectCoercible = __webpack_require__(98622);
var toString = __webpack_require__(70158);
var correctIsRegExpLogic = __webpack_require__(63970);

var stringIndexOf = uncurryThis(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf(
      toString(requireObjectCoercible(this)),
      toString(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});


/***/ }),

/***/ 33414:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var charAt = (__webpack_require__(97124).charAt);
var toString = __webpack_require__(70158);
var InternalStateModule = __webpack_require__(47776);
var defineIterator = __webpack_require__(58994);
var createIterResultObject = __webpack_require__(62526);

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: toString(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return createIterResultObject(undefined, true);
  point = charAt(string, index);
  state.index += point.length;
  return createIterResultObject(point, false);
});


/***/ }),

/***/ 49747:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var call = __webpack_require__(17725);
var fixRegExpWellKnownSymbolLogic = __webpack_require__(84902);
var anObject = __webpack_require__(79308);
var isNullOrUndefined = __webpack_require__(80276);
var toLength = __webpack_require__(60468);
var toString = __webpack_require__(70158);
var requireObjectCoercible = __webpack_require__(98622);
var getMethod = __webpack_require__(30692);
var advanceStringIndex = __webpack_require__(12051);
var regExpExec = __webpack_require__(19637);

// @@match logic
fixRegExpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, MATCH);
      return matcher ? call(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeMatch, rx, S);

      if (res.done) return res.value;

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = toString(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),

/***/ 87169:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var repeat = __webpack_require__(69523);

// `String.prototype.repeat` method
// https://tc39.es/ecma262/#sec-string.prototype.repeat
$({ target: 'String', proto: true }, {
  repeat: repeat
});


/***/ }),

/***/ 8612:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var apply = __webpack_require__(59878);
var call = __webpack_require__(17725);
var uncurryThis = __webpack_require__(52058);
var fixRegExpWellKnownSymbolLogic = __webpack_require__(84902);
var fails = __webpack_require__(79645);
var anObject = __webpack_require__(79308);
var isCallable = __webpack_require__(31808);
var isNullOrUndefined = __webpack_require__(80276);
var toIntegerOrInfinity = __webpack_require__(9163);
var toLength = __webpack_require__(60468);
var toString = __webpack_require__(70158);
var requireObjectCoercible = __webpack_require__(98622);
var advanceStringIndex = __webpack_require__(12051);
var getMethod = __webpack_require__(30692);
var getSubstitution = __webpack_require__(20378);
var regExpExec = __webpack_require__(19637);
var wellKnownSymbol = __webpack_require__(15537);

var REPLACE = wellKnownSymbol('replace');
var max = Math.max;
var min = Math.min;
var concat = uncurryThis([].concat);
var push = uncurryThis([].push);
var stringIndexOf = uncurryThis(''.indexOf);
var stringSlice = uncurryThis(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = isNullOrUndefined(searchValue) ? undefined : getMethod(searchValue, REPLACE);
      return replacer
        ? call(replacer, searchValue, O, replaceValue)
        : call(nativeReplace, toString(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject(this);
      var S = toString(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable(replaceValue);
      if (!functionalReplace) replaceValue = toString(replaceValue);

      var global = rx.global;
      var fullUnicode;
      if (global) {
        fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }

      var results = [];
      var result;
      while (true) {
        result = regExpExec(rx, S);
        if (result === null) break;

        push(results, result);
        if (!global) break;

        var matchStr = toString(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString(result[0]);
        var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        var replacement;
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
          replacement = toString(apply(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }

      return accumulatedResult + stringSlice(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


/***/ }),

/***/ 6938:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var call = __webpack_require__(17725);
var fixRegExpWellKnownSymbolLogic = __webpack_require__(84902);
var anObject = __webpack_require__(79308);
var isNullOrUndefined = __webpack_require__(80276);
var requireObjectCoercible = __webpack_require__(98622);
var sameValue = __webpack_require__(67178);
var toString = __webpack_require__(70158);
var getMethod = __webpack_require__(30692);
var regExpExec = __webpack_require__(19637);

// @@search logic
fixRegExpWellKnownSymbolLogic('search', function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible(this);
      var searcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, SEARCH);
      return searcher ? call(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeSearch, rx, S);

      if (res.done) return res.value;

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),

/***/ 74389:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var apply = __webpack_require__(59878);
var call = __webpack_require__(17725);
var uncurryThis = __webpack_require__(52058);
var fixRegExpWellKnownSymbolLogic = __webpack_require__(84902);
var anObject = __webpack_require__(79308);
var isNullOrUndefined = __webpack_require__(80276);
var isRegExp = __webpack_require__(95522);
var requireObjectCoercible = __webpack_require__(98622);
var speciesConstructor = __webpack_require__(6178);
var advanceStringIndex = __webpack_require__(12051);
var toLength = __webpack_require__(60468);
var toString = __webpack_require__(70158);
var getMethod = __webpack_require__(30692);
var arraySlice = __webpack_require__(14501);
var callRegExpExec = __webpack_require__(19637);
var regexpExec = __webpack_require__(34530);
var stickyHelpers = __webpack_require__(8373);
var fails = __webpack_require__(79645);

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
var MAX_UINT32 = 0xFFFFFFFF;
var min = Math.min;
var $push = [].push;
var exec = uncurryThis(/./.exec);
var push = uncurryThis($push);
var stringSlice = uncurryThis(''.slice);

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

// @@split logic
fixRegExpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] === 'c' ||
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length !== 4 ||
    'ab'.split(/(?:ab)*/).length !== 2 ||
    '.'.split(/(.?)(.?)/).length !== 4 ||
    // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = toString(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) {
        return call(nativeSplit, string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = call(regexpExec, separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          push(output, stringSlice(string, lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) apply($push, output, arraySlice(match, 1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !exec(separatorCopy, '')) push(output, '');
      } else push(output, stringSlice(string, lastLastIndex));
      return output.length > lim ? arraySlice(output, 0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : call(nativeSplit, this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = isNullOrUndefined(separator) ? undefined : getMethod(separator, SPLIT);
      return splitter
        ? call(splitter, separator, O, limit)
        : call(internalSplit, toString(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (string, limit) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);

      if (res.done) return res.value;

      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y ? 'g' : 'y');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
        var z = callRegExpExec(splitter, UNSUPPORTED_Y ? stringSlice(S, q) : S);
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          push(A, stringSlice(S, p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            push(A, z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      push(A, stringSlice(S, p));
      return A;
    }
  ];
}, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);


/***/ }),

/***/ 97072:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var uncurryThis = __webpack_require__(2330);
var getOwnPropertyDescriptor = (__webpack_require__(94086).f);
var toLength = __webpack_require__(60468);
var toString = __webpack_require__(70158);
var notARegExp = __webpack_require__(82990);
var requireObjectCoercible = __webpack_require__(98622);
var correctIsRegExpLogic = __webpack_require__(63970);
var IS_PURE = __webpack_require__(81566);

// eslint-disable-next-line es/no-string-prototype-startswith -- safe
var nativeStartsWith = uncurryThis(''.startsWith);
var stringSlice = uncurryThis(''.slice);
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = toString(requireObjectCoercible(this));
    notARegExp(searchString);
    var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = toString(searchString);
    return nativeStartsWith
      ? nativeStartsWith(that, search, index)
      : stringSlice(that, index, index + search.length) === search;
  }
});


/***/ }),

/***/ 91057:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var $trim = (__webpack_require__(84610).trim);
var forcedStringTrimMethod = __webpack_require__(38768);

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});


/***/ }),

/***/ 4482:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var global = __webpack_require__(27990);
var call = __webpack_require__(17725);
var uncurryThis = __webpack_require__(52058);
var IS_PURE = __webpack_require__(81566);
var DESCRIPTORS = __webpack_require__(40369);
var NATIVE_SYMBOL = __webpack_require__(97987);
var fails = __webpack_require__(79645);
var hasOwn = __webpack_require__(48496);
var isPrototypeOf = __webpack_require__(88304);
var anObject = __webpack_require__(79308);
var toIndexedObject = __webpack_require__(17794);
var toPropertyKey = __webpack_require__(7171);
var $toString = __webpack_require__(70158);
var createPropertyDescriptor = __webpack_require__(56373);
var nativeObjectCreate = __webpack_require__(91026);
var objectKeys = __webpack_require__(88071);
var getOwnPropertyNamesModule = __webpack_require__(88766);
var getOwnPropertyNamesExternal = __webpack_require__(47092);
var getOwnPropertySymbolsModule = __webpack_require__(28559);
var getOwnPropertyDescriptorModule = __webpack_require__(94086);
var definePropertyModule = __webpack_require__(3002);
var definePropertiesModule = __webpack_require__(48065);
var propertyIsEnumerableModule = __webpack_require__(43740);
var defineBuiltIn = __webpack_require__(96561);
var defineBuiltInAccessor = __webpack_require__(4259);
var shared = __webpack_require__(69808);
var sharedKey = __webpack_require__(53273);
var hiddenKeys = __webpack_require__(80642);
var uid = __webpack_require__(40160);
var wellKnownSymbol = __webpack_require__(15537);
var wrappedWellKnownSymbolModule = __webpack_require__(45134);
var defineWellKnownSymbol = __webpack_require__(94534);
var defineSymbolToPrimitive = __webpack_require__(52411);
var setToStringTag = __webpack_require__(71508);
var InternalStateModule = __webpack_require__(47776);
var $forEach = (__webpack_require__(28695).forEach);

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';

var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);

var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
var TypeError = global.TypeError;
var QObject = global.QObject;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var push = uncurryThis([].push);

var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var WellKnownSymbolsStore = shared('wks');

// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a !== 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPropertyKey(P);
  anObject(Attributes);
  if (hasOwn(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!hasOwn(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (hasOwn(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPropertyKey(V);
  var enumerable = call(nativePropertyIsEnumerable, this, P);
  if (this === ObjectPrototype && hasOwn(AllSymbols, P) && !hasOwn(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !hasOwn(this, P) || !hasOwn(AllSymbols, P) || hasOwn(this, HIDDEN) && this[HIDDEN][P]
    ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPropertyKey(P);
  if (it === ObjectPrototype && hasOwn(AllSymbols, key) && !hasOwn(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && hasOwn(AllSymbols, key) && !(hasOwn(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!hasOwn(AllSymbols, key) && !hasOwn(hiddenKeys, key)) push(result, key);
  });
  return result;
};

var $getOwnPropertySymbols = function (O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (hasOwn(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn(ObjectPrototype, key))) {
      push(result, AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (isPrototypeOf(SymbolPrototype, this)) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) call(setter, ObjectPrototypeSymbols, value);
      if (hasOwn(this, HIDDEN) && hasOwn(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  SymbolPrototype = $Symbol[PROTOTYPE];

  defineBuiltIn(SymbolPrototype, 'toString', function toString() {
    return getInternalState(this).tag;
  });

  defineBuiltIn($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  definePropertiesModule.f = $defineProperties;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    defineBuiltInAccessor(SymbolPrototype, 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      defineBuiltIn(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, constructor: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames
});

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive();

// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ 11256:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__(88903);
var DESCRIPTORS = __webpack_require__(40369);
var global = __webpack_require__(27990);
var uncurryThis = __webpack_require__(52058);
var hasOwn = __webpack_require__(48496);
var isCallable = __webpack_require__(31808);
var isPrototypeOf = __webpack_require__(88304);
var toString = __webpack_require__(70158);
var defineBuiltInAccessor = __webpack_require__(4259);
var copyConstructorProperties = __webpack_require__(85609);

var NativeSymbol = global.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
    var result = isPrototypeOf(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('description detection')) === 'Symbol(description detection)';
  var thisSymbolValue = uncurryThis(SymbolPrototype.valueOf);
  var symbolDescriptiveString = uncurryThis(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace = uncurryThis(''.replace);
  var stringSlice = uncurryThis(''.slice);

  defineBuiltInAccessor(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ 98840:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var getBuiltIn = __webpack_require__(91553);
var hasOwn = __webpack_require__(48496);
var toString = __webpack_require__(70158);
var shared = __webpack_require__(69808);
var NATIVE_SYMBOL_REGISTRY = __webpack_require__(53482);

var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  'for': function (key) {
    var string = toString(key);
    if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = getBuiltIn('Symbol')(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  }
});


/***/ }),

/***/ 52318:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__(4482);
__webpack_require__(98840);
__webpack_require__(19573);
__webpack_require__(83066);
__webpack_require__(60530);


/***/ }),

/***/ 19573:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var hasOwn = __webpack_require__(48496);
var isSymbol = __webpack_require__(44003);
var tryToString = __webpack_require__(38151);
var shared = __webpack_require__(69808);
var NATIVE_SYMBOL_REGISTRY = __webpack_require__(53482);

var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(tryToString(sym) + ' is not a symbol');
    if (hasOwn(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  }
});


/***/ }),

/***/ 5894:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(52058);
var ArrayBufferViewCore = __webpack_require__(63214);
var $ArrayCopyWithin = __webpack_require__(41208);

var u$ArrayCopyWithin = uncurryThis($ArrayCopyWithin);
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.copyWithin` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.copywithin
exportTypedArrayMethod('copyWithin', function copyWithin(target, start /* , end */) {
  return u$ArrayCopyWithin(aTypedArray(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
});


/***/ }),

/***/ 46896:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(63214);
var $every = (__webpack_require__(28695).every);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.every` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.every
exportTypedArrayMethod('every', function every(callbackfn /* , thisArg */) {
  return $every(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 18527:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(63214);
var $fill = __webpack_require__(7769);
var toBigInt = __webpack_require__(90797);
var classof = __webpack_require__(25786);
var call = __webpack_require__(17725);
var uncurryThis = __webpack_require__(52058);
var fails = __webpack_require__(79645);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var slice = uncurryThis(''.slice);

// V8 ~ Chrome < 59, Safari < 14.1, FF < 55, Edge <=18
var CONVERSION_BUG = fails(function () {
  var count = 0;
  // eslint-disable-next-line es/no-typed-arrays -- safe
  new Int8Array(2).fill({ valueOf: function () { return count++; } });
  return count !== 1;
});

// `%TypedArray%.prototype.fill` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.fill
exportTypedArrayMethod('fill', function fill(value /* , start, end */) {
  var length = arguments.length;
  aTypedArray(this);
  var actualValue = slice(classof(this), 0, 3) === 'Big' ? toBigInt(value) : +value;
  return call($fill, this, actualValue, length > 1 ? arguments[1] : undefined, length > 2 ? arguments[2] : undefined);
}, CONVERSION_BUG);


/***/ }),

/***/ 75858:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(63214);
var $filter = (__webpack_require__(28695).filter);
var fromSpeciesAndList = __webpack_require__(66252);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.filter` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.filter
exportTypedArrayMethod('filter', function filter(callbackfn /* , thisArg */) {
  var list = $filter(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  return fromSpeciesAndList(this, list);
});


/***/ }),

/***/ 20523:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(63214);
var $findIndex = (__webpack_require__(28695).findIndex);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.findindex
exportTypedArrayMethod('findIndex', function findIndex(predicate /* , thisArg */) {
  return $findIndex(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 30001:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(63214);
var $find = (__webpack_require__(28695).find);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.find` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.find
exportTypedArrayMethod('find', function find(predicate /* , thisArg */) {
  return $find(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 97115:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var createTypedArrayConstructor = __webpack_require__(1233);

// `Float32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Float32', function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ 91398:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(63214);
var $forEach = (__webpack_require__(28695).forEach);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.forEach` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.foreach
exportTypedArrayMethod('forEach', function forEach(callbackfn /* , thisArg */) {
  $forEach(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 27053:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = __webpack_require__(45958);
var exportTypedArrayStaticMethod = (__webpack_require__(63214).exportTypedArrayStaticMethod);
var typedArrayFrom = __webpack_require__(18110);

// `%TypedArray%.from` method
// https://tc39.es/ecma262/#sec-%typedarray%.from
exportTypedArrayStaticMethod('from', typedArrayFrom, TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS);


/***/ }),

/***/ 43334:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(63214);
var $includes = (__webpack_require__(96039).includes);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.includes` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.includes
exportTypedArrayMethod('includes', function includes(searchElement /* , fromIndex */) {
  return $includes(aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 82138:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(63214);
var $indexOf = (__webpack_require__(96039).indexOf);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.indexof
exportTypedArrayMethod('indexOf', function indexOf(searchElement /* , fromIndex */) {
  return $indexOf(aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 11721:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var createTypedArrayConstructor = __webpack_require__(1233);

// `Int32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Int32', function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ 66033:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var createTypedArrayConstructor = __webpack_require__(1233);

// `Int8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Int8', function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ 44127:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(27990);
var fails = __webpack_require__(79645);
var uncurryThis = __webpack_require__(52058);
var ArrayBufferViewCore = __webpack_require__(63214);
var ArrayIterators = __webpack_require__(26677);
var wellKnownSymbol = __webpack_require__(15537);

var ITERATOR = wellKnownSymbol('iterator');
var Uint8Array = global.Uint8Array;
var arrayValues = uncurryThis(ArrayIterators.values);
var arrayKeys = uncurryThis(ArrayIterators.keys);
var arrayEntries = uncurryThis(ArrayIterators.entries);
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var TypedArrayPrototype = Uint8Array && Uint8Array.prototype;

var GENERIC = !fails(function () {
  TypedArrayPrototype[ITERATOR].call([1]);
});

var ITERATOR_IS_VALUES = !!TypedArrayPrototype
  && TypedArrayPrototype.values
  && TypedArrayPrototype[ITERATOR] === TypedArrayPrototype.values
  && TypedArrayPrototype.values.name === 'values';

var typedArrayValues = function values() {
  return arrayValues(aTypedArray(this));
};

// `%TypedArray%.prototype.entries` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.entries
exportTypedArrayMethod('entries', function entries() {
  return arrayEntries(aTypedArray(this));
}, GENERIC);
// `%TypedArray%.prototype.keys` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.keys
exportTypedArrayMethod('keys', function keys() {
  return arrayKeys(aTypedArray(this));
}, GENERIC);
// `%TypedArray%.prototype.values` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.values
exportTypedArrayMethod('values', typedArrayValues, GENERIC || !ITERATOR_IS_VALUES, { name: 'values' });
// `%TypedArray%.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype-@@iterator
exportTypedArrayMethod(ITERATOR, typedArrayValues, GENERIC || !ITERATOR_IS_VALUES, { name: 'values' });


/***/ }),

/***/ 84991:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(63214);
var uncurryThis = __webpack_require__(52058);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var $join = uncurryThis([].join);

// `%TypedArray%.prototype.join` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.join
exportTypedArrayMethod('join', function join(separator) {
  return $join(aTypedArray(this), separator);
});


/***/ }),

/***/ 88194:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(63214);
var apply = __webpack_require__(59878);
var $lastIndexOf = __webpack_require__(79621);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.lastindexof
exportTypedArrayMethod('lastIndexOf', function lastIndexOf(searchElement /* , fromIndex */) {
  var length = arguments.length;
  return apply($lastIndexOf, aTypedArray(this), length > 1 ? [searchElement, arguments[1]] : [searchElement]);
});


/***/ }),

/***/ 90779:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(63214);
var $map = (__webpack_require__(28695).map);
var typedArraySpeciesConstructor = __webpack_require__(61444);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.map` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.map
exportTypedArrayMethod('map', function map(mapfn /* , thisArg */) {
  return $map(aTypedArray(this), mapfn, arguments.length > 1 ? arguments[1] : undefined, function (O, length) {
    return new (typedArraySpeciesConstructor(O))(length);
  });
});


/***/ }),

/***/ 63794:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(63214);
var $reduceRight = (__webpack_require__(16138).right);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.reduceRight` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduceright
exportTypedArrayMethod('reduceRight', function reduceRight(callbackfn /* , initialValue */) {
  var length = arguments.length;
  return $reduceRight(aTypedArray(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 26849:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(63214);
var $reduce = (__webpack_require__(16138).left);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.reduce` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduce
exportTypedArrayMethod('reduce', function reduce(callbackfn /* , initialValue */) {
  var length = arguments.length;
  return $reduce(aTypedArray(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 91944:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(63214);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var floor = Math.floor;

// `%TypedArray%.prototype.reverse` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reverse
exportTypedArrayMethod('reverse', function reverse() {
  var that = this;
  var length = aTypedArray(that).length;
  var middle = floor(length / 2);
  var index = 0;
  var value;
  while (index < middle) {
    value = that[index];
    that[index++] = that[--length];
    that[length] = value;
  } return that;
});


/***/ }),

/***/ 87937:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(27990);
var call = __webpack_require__(17725);
var ArrayBufferViewCore = __webpack_require__(63214);
var lengthOfArrayLike = __webpack_require__(2103);
var toOffset = __webpack_require__(10756);
var toIndexedObject = __webpack_require__(76075);
var fails = __webpack_require__(79645);

var RangeError = global.RangeError;
var Int8Array = global.Int8Array;
var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
var $set = Int8ArrayPrototype && Int8ArrayPrototype.set;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

var WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS = !fails(function () {
  // eslint-disable-next-line es/no-typed-arrays -- required for testing
  var array = new Uint8ClampedArray(2);
  call($set, array, { length: 1, 0: 3 }, 1);
  return array[1] !== 3;
});

// https://bugs.chromium.org/p/v8/issues/detail?id=11294 and other
var TO_OBJECT_BUG = WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS && ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS && fails(function () {
  var array = new Int8Array(2);
  array.set(1);
  array.set('2', 1);
  return array[0] !== 0 || array[1] !== 2;
});

// `%TypedArray%.prototype.set` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
exportTypedArrayMethod('set', function set(arrayLike /* , offset */) {
  aTypedArray(this);
  var offset = toOffset(arguments.length > 1 ? arguments[1] : undefined, 1);
  var src = toIndexedObject(arrayLike);
  if (WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS) return call($set, this, src, offset);
  var length = this.length;
  var len = lengthOfArrayLike(src);
  var index = 0;
  if (len + offset > length) throw RangeError('Wrong length');
  while (index < len) this[offset + index] = src[index++];
}, !WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS || TO_OBJECT_BUG);


/***/ }),

/***/ 86968:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(63214);
var typedArraySpeciesConstructor = __webpack_require__(61444);
var fails = __webpack_require__(79645);
var arraySlice = __webpack_require__(59591);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

var FORCED = fails(function () {
  // eslint-disable-next-line es/no-typed-arrays -- required for testing
  new Int8Array(1).slice();
});

// `%TypedArray%.prototype.slice` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.slice
exportTypedArrayMethod('slice', function slice(start, end) {
  var list = arraySlice(aTypedArray(this), start, end);
  var C = typedArraySpeciesConstructor(this);
  var index = 0;
  var length = list.length;
  var result = new C(length);
  while (length > index) result[index] = list[index++];
  return result;
}, FORCED);


/***/ }),

/***/ 8501:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(63214);
var $some = (__webpack_require__(28695).some);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.some` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.some
exportTypedArrayMethod('some', function some(callbackfn /* , thisArg */) {
  return $some(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 55019:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(27990);
var uncurryThis = __webpack_require__(2330);
var fails = __webpack_require__(79645);
var aCallable = __webpack_require__(44596);
var internalSort = __webpack_require__(626);
var ArrayBufferViewCore = __webpack_require__(63214);
var FF = __webpack_require__(95676);
var IE_OR_EDGE = __webpack_require__(79619);
var V8 = __webpack_require__(1579);
var WEBKIT = __webpack_require__(42861);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var Uint16Array = global.Uint16Array;
var nativeSort = Uint16Array && uncurryThis(Uint16Array.prototype.sort);

// WebKit
var ACCEPT_INCORRECT_ARGUMENTS = !!nativeSort && !(fails(function () {
  nativeSort(new Uint16Array(2), null);
}) && fails(function () {
  nativeSort(new Uint16Array(2), {});
}));

var STABLE_SORT = !!nativeSort && !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 74;
  if (FF) return FF < 67;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 602;

  var array = new Uint16Array(516);
  var expected = Array(516);
  var index, mod;

  for (index = 0; index < 516; index++) {
    mod = index % 4;
    array[index] = 515 - index;
    expected[index] = index - 2 * mod + 3;
  }

  nativeSort(array, function (a, b) {
    return (a / 4 | 0) - (b / 4 | 0);
  });

  for (index = 0; index < 516; index++) {
    if (array[index] !== expected[index]) return true;
  }
});

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    // eslint-disable-next-line no-self-compare -- NaN check
    if (y !== y) return -1;
    // eslint-disable-next-line no-self-compare -- NaN check
    if (x !== x) return 1;
    if (x === 0 && y === 0) return 1 / x > 0 && 1 / y < 0 ? 1 : -1;
    return x > y;
  };
};

// `%TypedArray%.prototype.sort` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.sort
exportTypedArrayMethod('sort', function sort(comparefn) {
  if (comparefn !== undefined) aCallable(comparefn);
  if (STABLE_SORT) return nativeSort(this, comparefn);

  return internalSort(aTypedArray(this), getSortCompare(comparefn));
}, !STABLE_SORT || ACCEPT_INCORRECT_ARGUMENTS);


/***/ }),

/***/ 47273:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(63214);
var toLength = __webpack_require__(60468);
var toAbsoluteIndex = __webpack_require__(97913);
var typedArraySpeciesConstructor = __webpack_require__(61444);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.subarray` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.subarray
exportTypedArrayMethod('subarray', function subarray(begin, end) {
  var O = aTypedArray(this);
  var length = O.length;
  var beginIndex = toAbsoluteIndex(begin, length);
  var C = typedArraySpeciesConstructor(O);
  return new C(
    O.buffer,
    O.byteOffset + beginIndex * O.BYTES_PER_ELEMENT,
    toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - beginIndex)
  );
});


/***/ }),

/***/ 17082:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(27990);
var apply = __webpack_require__(59878);
var ArrayBufferViewCore = __webpack_require__(63214);
var fails = __webpack_require__(79645);
var arraySlice = __webpack_require__(59591);

var Int8Array = global.Int8Array;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var $toLocaleString = [].toLocaleString;

// iOS Safari 6.x fails here
var TO_LOCALE_STRING_BUG = !!Int8Array && fails(function () {
  $toLocaleString.call(new Int8Array(1));
});

var FORCED = fails(function () {
  return [1, 2].toLocaleString() !== new Int8Array([1, 2]).toLocaleString();
}) || !fails(function () {
  Int8Array.prototype.toLocaleString.call([1, 2]);
});

// `%TypedArray%.prototype.toLocaleString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tolocalestring
exportTypedArrayMethod('toLocaleString', function toLocaleString() {
  return apply(
    $toLocaleString,
    TO_LOCALE_STRING_BUG ? arraySlice(aTypedArray(this)) : aTypedArray(this),
    arraySlice(arguments)
  );
}, FORCED);


/***/ }),

/***/ 80827:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var exportTypedArrayMethod = (__webpack_require__(63214).exportTypedArrayMethod);
var fails = __webpack_require__(79645);
var global = __webpack_require__(27990);
var uncurryThis = __webpack_require__(52058);

var Uint8Array = global.Uint8Array;
var Uint8ArrayPrototype = Uint8Array && Uint8Array.prototype || {};
var arrayToString = [].toString;
var join = uncurryThis([].join);

if (fails(function () { arrayToString.call({}); })) {
  arrayToString = function toString() {
    return join(this);
  };
}

var IS_NOT_ARRAY_METHOD = Uint8ArrayPrototype.toString !== arrayToString;

// `%TypedArray%.prototype.toString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tostring
exportTypedArrayMethod('toString', arrayToString, IS_NOT_ARRAY_METHOD);


/***/ }),

/***/ 57419:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var createTypedArrayConstructor = __webpack_require__(1233);

// `Uint16Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Uint16', function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ 23353:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var createTypedArrayConstructor = __webpack_require__(1233);

// `Uint32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Uint32', function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ 82463:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var createTypedArrayConstructor = __webpack_require__(1233);

// `Uint8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Uint8', function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ 80229:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var createTypedArrayConstructor = __webpack_require__(1233);

// `Uint8ClampedArray` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Uint8', function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),

/***/ 90565:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(27990);
var DOMIterables = __webpack_require__(28685);
var DOMTokenListPrototype = __webpack_require__(53981);
var forEach = __webpack_require__(9320);
var createNonEnumerableProperty = __webpack_require__(60859);

var handlePrototype = function (CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  if (DOMIterables[COLLECTION_NAME]) {
    handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype);
  }
}

handlePrototype(DOMTokenListPrototype);


/***/ }),

/***/ 65000:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(27990);
var DOMIterables = __webpack_require__(28685);
var DOMTokenListPrototype = __webpack_require__(53981);
var ArrayIteratorMethods = __webpack_require__(26677);
var createNonEnumerableProperty = __webpack_require__(60859);
var wellKnownSymbol = __webpack_require__(15537);

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');


/***/ }),

/***/ 23851:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
__webpack_require__(26677);
var $ = __webpack_require__(88903);
var global = __webpack_require__(27990);
var call = __webpack_require__(17725);
var uncurryThis = __webpack_require__(52058);
var DESCRIPTORS = __webpack_require__(40369);
var USE_NATIVE_URL = __webpack_require__(88682);
var defineBuiltIn = __webpack_require__(96561);
var defineBuiltInAccessor = __webpack_require__(4259);
var defineBuiltIns = __webpack_require__(38308);
var setToStringTag = __webpack_require__(71508);
var createIteratorConstructor = __webpack_require__(32282);
var InternalStateModule = __webpack_require__(47776);
var anInstance = __webpack_require__(87787);
var isCallable = __webpack_require__(31808);
var hasOwn = __webpack_require__(48496);
var bind = __webpack_require__(82144);
var classof = __webpack_require__(25786);
var anObject = __webpack_require__(79308);
var isObject = __webpack_require__(27627);
var $toString = __webpack_require__(70158);
var create = __webpack_require__(91026);
var createPropertyDescriptor = __webpack_require__(56373);
var getIterator = __webpack_require__(34431);
var getIteratorMethod = __webpack_require__(19463);
var validateArgumentsLength = __webpack_require__(9823);
var wellKnownSymbol = __webpack_require__(15537);
var arraySort = __webpack_require__(626);

var ITERATOR = wellKnownSymbol('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState = InternalStateModule.set;
var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Avoid NodeJS experimental warning
var safeGetBuiltIn = function (name) {
  if (!DESCRIPTORS) return global[name];
  var descriptor = getOwnPropertyDescriptor(global, name);
  return descriptor && descriptor.value;
};

var nativeFetch = safeGetBuiltIn('fetch');
var NativeRequest = safeGetBuiltIn('Request');
var Headers = safeGetBuiltIn('Headers');
var RequestPrototype = NativeRequest && NativeRequest.prototype;
var HeadersPrototype = Headers && Headers.prototype;
var RegExp = global.RegExp;
var TypeError = global.TypeError;
var decodeURIComponent = global.decodeURIComponent;
var encodeURIComponent = global.encodeURIComponent;
var charAt = uncurryThis(''.charAt);
var join = uncurryThis([].join);
var push = uncurryThis([].push);
var replace = uncurryThis(''.replace);
var shift = uncurryThis([].shift);
var splice = uncurryThis([].splice);
var split = uncurryThis(''.split);
var stringSlice = uncurryThis(''.slice);

var plus = /\+/g;
var sequences = Array(4);

var percentSequence = function (bytes) {
  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode = function (sequence) {
  try {
    return decodeURIComponent(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize = function (it) {
  var result = replace(it, plus, ' ');
  var bytes = 4;
  try {
    return decodeURIComponent(result);
  } catch (error) {
    while (bytes) {
      result = replace(result, percentSequence(bytes--), percentDecode);
    }
    return result;
  }
};

var find = /[!'()~]|%20/g;

var replacements = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replacements[match];
};

var serialize = function (it) {
  return replace(encodeURIComponent(it), find, replacer);
};

var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
  setInternalState(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    iterator: getIterator(getInternalParamsState(params).entries),
    kind: kind
  });
}, 'Iterator', function next() {
  var state = getInternalIteratorState(this);
  var kind = state.kind;
  var step = state.iterator.next();
  var entry = step.value;
  if (!step.done) {
    step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
  } return step;
}, true);

var URLSearchParamsState = function (init) {
  this.entries = [];
  this.url = null;

  if (init !== undefined) {
    if (isObject(init)) this.parseObject(init);
    else this.parseQuery(typeof init == 'string' ? charAt(init, 0) === '?' ? stringSlice(init, 1) : init : $toString(init));
  }
};

URLSearchParamsState.prototype = {
  type: URL_SEARCH_PARAMS,
  bindURL: function (url) {
    this.url = url;
    this.update();
  },
  parseObject: function (object) {
    var iteratorMethod = getIteratorMethod(object);
    var iterator, next, step, entryIterator, entryNext, first, second;

    if (iteratorMethod) {
      iterator = getIterator(object, iteratorMethod);
      next = iterator.next;
      while (!(step = call(next, iterator)).done) {
        entryIterator = getIterator(anObject(step.value));
        entryNext = entryIterator.next;
        if (
          (first = call(entryNext, entryIterator)).done ||
          (second = call(entryNext, entryIterator)).done ||
          !call(entryNext, entryIterator).done
        ) throw TypeError('Expected sequence with length 2');
        push(this.entries, { key: $toString(first.value), value: $toString(second.value) });
      }
    } else for (var key in object) if (hasOwn(object, key)) {
      push(this.entries, { key: key, value: $toString(object[key]) });
    }
  },
  parseQuery: function (query) {
    if (query) {
      var attributes = split(query, '&');
      var index = 0;
      var attribute, entry;
      while (index < attributes.length) {
        attribute = attributes[index++];
        if (attribute.length) {
          entry = split(attribute, '=');
          push(this.entries, {
            key: deserialize(shift(entry)),
            value: deserialize(join(entry, '='))
          });
        }
      }
    }
  },
  serialize: function () {
    var entries = this.entries;
    var result = [];
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      push(result, serialize(entry.key) + '=' + serialize(entry.value));
    } return join(result, '&');
  },
  update: function () {
    this.entries.length = 0;
    this.parseQuery(this.url.query);
  },
  updateURL: function () {
    if (this.url) this.url.update();
  }
};

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance(this, URLSearchParamsPrototype);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  var state = setInternalState(this, new URLSearchParamsState(init));
  if (!DESCRIPTORS) this.size = state.entries.length;
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

defineBuiltIns(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    var state = getInternalParamsState(this);
    validateArgumentsLength(arguments.length, 2);
    push(state.entries, { key: $toString(name), value: $toString(value) });
    if (!DESCRIPTORS) this.length++;
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name /* , value */) {
    var state = getInternalParamsState(this);
    var length = validateArgumentsLength(arguments.length, 1);
    var entries = state.entries;
    var key = $toString(name);
    var $value = length < 2 ? undefined : arguments[1];
    var value = $value === undefined ? $value : $toString($value);
    var index = 0;
    while (index < entries.length) {
      var entry = entries[index];
      if (entry.key === key && (value === undefined || entry.value === value)) {
        splice(entries, index, 1);
        if (value !== undefined) break;
      } else index++;
    }
    if (!DESCRIPTORS) this.size = entries.length;
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    var entries = getInternalParamsState(this).entries;
    validateArgumentsLength(arguments.length, 1);
    var key = $toString(name);
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    var entries = getInternalParamsState(this).entries;
    validateArgumentsLength(arguments.length, 1);
    var key = $toString(name);
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) push(result, entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name /* , value */) {
    var entries = getInternalParamsState(this).entries;
    var length = validateArgumentsLength(arguments.length, 1);
    var key = $toString(name);
    var $value = length < 2 ? undefined : arguments[1];
    var value = $value === undefined ? $value : $toString($value);
    var index = 0;
    while (index < entries.length) {
      var entry = entries[index++];
      if (entry.key === key && (value === undefined || entry.value === value)) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    var state = getInternalParamsState(this);
    validateArgumentsLength(arguments.length, 1);
    var entries = state.entries;
    var found = false;
    var key = $toString(name);
    var val = $toString(value);
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) splice(entries, index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) push(entries, { key: key, value: val });
    if (!DESCRIPTORS) this.size = entries.length;
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    arraySort(state.entries, function (a, b) {
      return a.key > b.key ? 1 : -1;
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
defineBuiltIn(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries, { name: 'entries' });

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
defineBuiltIn(URLSearchParamsPrototype, 'toString', function toString() {
  return getInternalParamsState(this).serialize();
}, { enumerable: true });

// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if (DESCRIPTORS) defineBuiltInAccessor(URLSearchParamsPrototype, 'size', {
  get: function size() {
    return getInternalParamsState(this).entries.length;
  },
  configurable: true,
  enumerable: true
});

setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

$({ global: true, constructor: true, forced: !USE_NATIVE_URL }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!USE_NATIVE_URL && isCallable(Headers)) {
  var headersHas = uncurryThis(HeadersPrototype.has);
  var headersSet = uncurryThis(HeadersPrototype.set);

  var wrapRequestOptions = function (init) {
    if (isObject(init)) {
      var body = init.body;
      var headers;
      if (classof(body) === URL_SEARCH_PARAMS) {
        headers = init.headers ? new Headers(init.headers) : new Headers();
        if (!headersHas(headers, 'content-type')) {
          headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
        return create(init, {
          body: createPropertyDescriptor(0, $toString(body)),
          headers: createPropertyDescriptor(0, headers)
        });
      }
    } return init;
  };

  if (isCallable(nativeFetch)) {
    $({ global: true, enumerable: true, dontCallGetSet: true, forced: true }, {
      fetch: function fetch(input /* , init */) {
        return nativeFetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
      }
    });
  }

  if (isCallable(NativeRequest)) {
    var RequestConstructor = function Request(input /* , init */) {
      anInstance(this, RequestPrototype);
      return new NativeRequest(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
    };

    RequestPrototype.constructor = RequestConstructor;
    RequestConstructor.prototype = RequestPrototype;

    $({ global: true, constructor: true, dontCallGetSet: true, forced: true }, {
      Request: RequestConstructor
    });
  }
}

module.exports = {
  URLSearchParams: URLSearchParamsConstructor,
  getState: getInternalParamsState
};


/***/ }),

/***/ 37828:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
__webpack_require__(33414);
var $ = __webpack_require__(88903);
var DESCRIPTORS = __webpack_require__(40369);
var USE_NATIVE_URL = __webpack_require__(88682);
var global = __webpack_require__(27990);
var bind = __webpack_require__(82144);
var uncurryThis = __webpack_require__(52058);
var defineBuiltIn = __webpack_require__(96561);
var defineBuiltInAccessor = __webpack_require__(4259);
var anInstance = __webpack_require__(87787);
var hasOwn = __webpack_require__(48496);
var assign = __webpack_require__(26779);
var arrayFrom = __webpack_require__(27530);
var arraySlice = __webpack_require__(14501);
var codeAt = (__webpack_require__(97124).codeAt);
var toASCII = __webpack_require__(28956);
var $toString = __webpack_require__(70158);
var setToStringTag = __webpack_require__(71508);
var validateArgumentsLength = __webpack_require__(9823);
var URLSearchParamsModule = __webpack_require__(23851);
var InternalStateModule = __webpack_require__(47776);

var setInternalState = InternalStateModule.set;
var getInternalURLState = InternalStateModule.getterFor('URL');
var URLSearchParams = URLSearchParamsModule.URLSearchParams;
var getInternalSearchParamsState = URLSearchParamsModule.getState;

var NativeURL = global.URL;
var TypeError = global.TypeError;
var parseInt = global.parseInt;
var floor = Math.floor;
var pow = Math.pow;
var charAt = uncurryThis(''.charAt);
var exec = uncurryThis(/./.exec);
var join = uncurryThis([].join);
var numberToString = uncurryThis(1.0.toString);
var pop = uncurryThis([].pop);
var push = uncurryThis([].push);
var replace = uncurryThis(''.replace);
var shift = uncurryThis([].shift);
var split = uncurryThis(''.split);
var stringSlice = uncurryThis(''.slice);
var toLowerCase = uncurryThis(''.toLowerCase);
var unshift = uncurryThis([].unshift);

var INVALID_AUTHORITY = 'Invalid authority';
var INVALID_SCHEME = 'Invalid scheme';
var INVALID_HOST = 'Invalid host';
var INVALID_PORT = 'Invalid port';

var ALPHA = /[a-z]/i;
// eslint-disable-next-line regexp/no-obscure-range -- safe
var ALPHANUMERIC = /[\d+-.a-z]/i;
var DIGIT = /\d/;
var HEX_START = /^0x/i;
var OCT = /^[0-7]+$/;
var DEC = /^\d+$/;
var HEX = /^[\da-f]+$/i;
/* eslint-disable regexp/no-control-character -- safe */
var FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var LEADING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+/;
var TRAILING_C0_CONTROL_OR_SPACE = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/;
var TAB_AND_NEW_LINE = /[\t\n\r]/g;
/* eslint-enable regexp/no-control-character -- safe */
var EOF;

// https://url.spec.whatwg.org/#ipv4-number-parser
var parseIPv4 = function (input) {
  var parts = split(input, '.');
  var partsLength, numbers, index, part, radix, number, ipv4;
  if (parts.length && parts[parts.length - 1] === '') {
    parts.length--;
  }
  partsLength = parts.length;
  if (partsLength > 4) return input;
  numbers = [];
  for (index = 0; index < partsLength; index++) {
    part = parts[index];
    if (part === '') return input;
    radix = 10;
    if (part.length > 1 && charAt(part, 0) === '0') {
      radix = exec(HEX_START, part) ? 16 : 8;
      part = stringSlice(part, radix === 8 ? 1 : 2);
    }
    if (part === '') {
      number = 0;
    } else {
      if (!exec(radix === 10 ? DEC : radix === 8 ? OCT : HEX, part)) return input;
      number = parseInt(part, radix);
    }
    push(numbers, number);
  }
  for (index = 0; index < partsLength; index++) {
    number = numbers[index];
    if (index === partsLength - 1) {
      if (number >= pow(256, 5 - partsLength)) return null;
    } else if (number > 255) return null;
  }
  ipv4 = pop(numbers);
  for (index = 0; index < numbers.length; index++) {
    ipv4 += numbers[index] * pow(256, 3 - index);
  }
  return ipv4;
};

// https://url.spec.whatwg.org/#concept-ipv6-parser
// eslint-disable-next-line max-statements -- TODO
var parseIPv6 = function (input) {
  var address = [0, 0, 0, 0, 0, 0, 0, 0];
  var pieceIndex = 0;
  var compress = null;
  var pointer = 0;
  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

  var chr = function () {
    return charAt(input, pointer);
  };

  if (chr() === ':') {
    if (charAt(input, 1) !== ':') return;
    pointer += 2;
    pieceIndex++;
    compress = pieceIndex;
  }
  while (chr()) {
    if (pieceIndex === 8) return;
    if (chr() === ':') {
      if (compress !== null) return;
      pointer++;
      pieceIndex++;
      compress = pieceIndex;
      continue;
    }
    value = length = 0;
    while (length < 4 && exec(HEX, chr())) {
      value = value * 16 + parseInt(chr(), 16);
      pointer++;
      length++;
    }
    if (chr() === '.') {
      if (length === 0) return;
      pointer -= length;
      if (pieceIndex > 6) return;
      numbersSeen = 0;
      while (chr()) {
        ipv4Piece = null;
        if (numbersSeen > 0) {
          if (chr() === '.' && numbersSeen < 4) pointer++;
          else return;
        }
        if (!exec(DIGIT, chr())) return;
        while (exec(DIGIT, chr())) {
          number = parseInt(chr(), 10);
          if (ipv4Piece === null) ipv4Piece = number;
          else if (ipv4Piece === 0) return;
          else ipv4Piece = ipv4Piece * 10 + number;
          if (ipv4Piece > 255) return;
          pointer++;
        }
        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
        numbersSeen++;
        if (numbersSeen === 2 || numbersSeen === 4) pieceIndex++;
      }
      if (numbersSeen !== 4) return;
      break;
    } else if (chr() === ':') {
      pointer++;
      if (!chr()) return;
    } else if (chr()) return;
    address[pieceIndex++] = value;
  }
  if (compress !== null) {
    swaps = pieceIndex - compress;
    pieceIndex = 7;
    while (pieceIndex !== 0 && swaps > 0) {
      swap = address[pieceIndex];
      address[pieceIndex--] = address[compress + swaps - 1];
      address[compress + --swaps] = swap;
    }
  } else if (pieceIndex !== 8) return;
  return address;
};

var findLongestZeroSequence = function (ipv6) {
  var maxIndex = null;
  var maxLength = 1;
  var currStart = null;
  var currLength = 0;
  var index = 0;
  for (; index < 8; index++) {
    if (ipv6[index] !== 0) {
      if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
      }
      currStart = null;
      currLength = 0;
    } else {
      if (currStart === null) currStart = index;
      ++currLength;
    }
  }
  if (currLength > maxLength) {
    maxIndex = currStart;
    maxLength = currLength;
  }
  return maxIndex;
};

// https://url.spec.whatwg.org/#host-serializing
var serializeHost = function (host) {
  var result, index, compress, ignore0;
  // ipv4
  if (typeof host == 'number') {
    result = [];
    for (index = 0; index < 4; index++) {
      unshift(result, host % 256);
      host = floor(host / 256);
    } return join(result, '.');
  // ipv6
  } else if (typeof host == 'object') {
    result = '';
    compress = findLongestZeroSequence(host);
    for (index = 0; index < 8; index++) {
      if (ignore0 && host[index] === 0) continue;
      if (ignore0) ignore0 = false;
      if (compress === index) {
        result += index ? ':' : '::';
        ignore0 = true;
      } else {
        result += numberToString(host[index], 16);
        if (index < 7) result += ':';
      }
    }
    return '[' + result + ']';
  } return host;
};

var C0ControlPercentEncodeSet = {};
var fragmentPercentEncodeSet = assign({}, C0ControlPercentEncodeSet, {
  ' ': 1, '"': 1, '<': 1, '>': 1, '`': 1
});
var pathPercentEncodeSet = assign({}, fragmentPercentEncodeSet, {
  '#': 1, '?': 1, '{': 1, '}': 1
});
var userinfoPercentEncodeSet = assign({}, pathPercentEncodeSet, {
  '/': 1, ':': 1, ';': 1, '=': 1, '@': 1, '[': 1, '\\': 1, ']': 1, '^': 1, '|': 1
});

var percentEncode = function (chr, set) {
  var code = codeAt(chr, 0);
  return code > 0x20 && code < 0x7F && !hasOwn(set, chr) ? chr : encodeURIComponent(chr);
};

// https://url.spec.whatwg.org/#special-scheme
var specialSchemes = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
};

// https://url.spec.whatwg.org/#windows-drive-letter
var isWindowsDriveLetter = function (string, normalized) {
  var second;
  return string.length === 2 && exec(ALPHA, charAt(string, 0))
    && ((second = charAt(string, 1)) === ':' || (!normalized && second === '|'));
};

// https://url.spec.whatwg.org/#start-with-a-windows-drive-letter
var startsWithWindowsDriveLetter = function (string) {
  var third;
  return string.length > 1 && isWindowsDriveLetter(stringSlice(string, 0, 2)) && (
    string.length === 2 ||
    ((third = charAt(string, 2)) === '/' || third === '\\' || third === '?' || third === '#')
  );
};

// https://url.spec.whatwg.org/#single-dot-path-segment
var isSingleDot = function (segment) {
  return segment === '.' || toLowerCase(segment) === '%2e';
};

// https://url.spec.whatwg.org/#double-dot-path-segment
var isDoubleDot = function (segment) {
  segment = toLowerCase(segment);
  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
};

// States:
var SCHEME_START = {};
var SCHEME = {};
var NO_SCHEME = {};
var SPECIAL_RELATIVE_OR_AUTHORITY = {};
var PATH_OR_AUTHORITY = {};
var RELATIVE = {};
var RELATIVE_SLASH = {};
var SPECIAL_AUTHORITY_SLASHES = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var AUTHORITY = {};
var HOST = {};
var HOSTNAME = {};
var PORT = {};
var FILE = {};
var FILE_SLASH = {};
var FILE_HOST = {};
var PATH_START = {};
var PATH = {};
var CANNOT_BE_A_BASE_URL_PATH = {};
var QUERY = {};
var FRAGMENT = {};

var URLState = function (url, isBase, base) {
  var urlString = $toString(url);
  var baseState, failure, searchParams;
  if (isBase) {
    failure = this.parse(urlString);
    if (failure) throw TypeError(failure);
    this.searchParams = null;
  } else {
    if (base !== undefined) baseState = new URLState(base, true);
    failure = this.parse(urlString, null, baseState);
    if (failure) throw TypeError(failure);
    searchParams = getInternalSearchParamsState(new URLSearchParams());
    searchParams.bindURL(this);
    this.searchParams = searchParams;
  }
};

URLState.prototype = {
  type: 'URL',
  // https://url.spec.whatwg.org/#url-parsing
  // eslint-disable-next-line max-statements -- TODO
  parse: function (input, stateOverride, base) {
    var url = this;
    var state = stateOverride || SCHEME_START;
    var pointer = 0;
    var buffer = '';
    var seenAt = false;
    var seenBracket = false;
    var seenPasswordToken = false;
    var codePoints, chr, bufferCodePoints, failure;

    input = $toString(input);

    if (!stateOverride) {
      url.scheme = '';
      url.username = '';
      url.password = '';
      url.host = null;
      url.port = null;
      url.path = [];
      url.query = null;
      url.fragment = null;
      url.cannotBeABaseURL = false;
      input = replace(input, LEADING_C0_CONTROL_OR_SPACE, '');
      input = replace(input, TRAILING_C0_CONTROL_OR_SPACE, '$1');
    }

    input = replace(input, TAB_AND_NEW_LINE, '');

    codePoints = arrayFrom(input);

    while (pointer <= codePoints.length) {
      chr = codePoints[pointer];
      switch (state) {
        case SCHEME_START:
          if (chr && exec(ALPHA, chr)) {
            buffer += toLowerCase(chr);
            state = SCHEME;
          } else if (!stateOverride) {
            state = NO_SCHEME;
            continue;
          } else return INVALID_SCHEME;
          break;

        case SCHEME:
          if (chr && (exec(ALPHANUMERIC, chr) || chr === '+' || chr === '-' || chr === '.')) {
            buffer += toLowerCase(chr);
          } else if (chr === ':') {
            if (stateOverride && (
              (url.isSpecial() !== hasOwn(specialSchemes, buffer)) ||
              (buffer === 'file' && (url.includesCredentials() || url.port !== null)) ||
              (url.scheme === 'file' && !url.host)
            )) return;
            url.scheme = buffer;
            if (stateOverride) {
              if (url.isSpecial() && specialSchemes[url.scheme] === url.port) url.port = null;
              return;
            }
            buffer = '';
            if (url.scheme === 'file') {
              state = FILE;
            } else if (url.isSpecial() && base && base.scheme === url.scheme) {
              state = SPECIAL_RELATIVE_OR_AUTHORITY;
            } else if (url.isSpecial()) {
              state = SPECIAL_AUTHORITY_SLASHES;
            } else if (codePoints[pointer + 1] === '/') {
              state = PATH_OR_AUTHORITY;
              pointer++;
            } else {
              url.cannotBeABaseURL = true;
              push(url.path, '');
              state = CANNOT_BE_A_BASE_URL_PATH;
            }
          } else if (!stateOverride) {
            buffer = '';
            state = NO_SCHEME;
            pointer = 0;
            continue;
          } else return INVALID_SCHEME;
          break;

        case NO_SCHEME:
          if (!base || (base.cannotBeABaseURL && chr !== '#')) return INVALID_SCHEME;
          if (base.cannotBeABaseURL && chr === '#') {
            url.scheme = base.scheme;
            url.path = arraySlice(base.path);
            url.query = base.query;
            url.fragment = '';
            url.cannotBeABaseURL = true;
            state = FRAGMENT;
            break;
          }
          state = base.scheme === 'file' ? FILE : RELATIVE;
          continue;

        case SPECIAL_RELATIVE_OR_AUTHORITY:
          if (chr === '/' && codePoints[pointer + 1] === '/') {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
            pointer++;
          } else {
            state = RELATIVE;
            continue;
          } break;

        case PATH_OR_AUTHORITY:
          if (chr === '/') {
            state = AUTHORITY;
            break;
          } else {
            state = PATH;
            continue;
          }

        case RELATIVE:
          url.scheme = base.scheme;
          if (chr === EOF) {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = base.query;
          } else if (chr === '/' || (chr === '\\' && url.isSpecial())) {
            state = RELATIVE_SLASH;
          } else if (chr === '?') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = '';
            state = QUERY;
          } else if (chr === '#') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = base.query;
            url.fragment = '';
            state = FRAGMENT;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.path.length--;
            state = PATH;
            continue;
          } break;

        case RELATIVE_SLASH:
          if (url.isSpecial() && (chr === '/' || chr === '\\')) {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          } else if (chr === '/') {
            state = AUTHORITY;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            state = PATH;
            continue;
          } break;

        case SPECIAL_AUTHORITY_SLASHES:
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          if (chr !== '/' || charAt(buffer, pointer + 1) !== '/') continue;
          pointer++;
          break;

        case SPECIAL_AUTHORITY_IGNORE_SLASHES:
          if (chr !== '/' && chr !== '\\') {
            state = AUTHORITY;
            continue;
          } break;

        case AUTHORITY:
          if (chr === '@') {
            if (seenAt) buffer = '%40' + buffer;
            seenAt = true;
            bufferCodePoints = arrayFrom(buffer);
            for (var i = 0; i < bufferCodePoints.length; i++) {
              var codePoint = bufferCodePoints[i];
              if (codePoint === ':' && !seenPasswordToken) {
                seenPasswordToken = true;
                continue;
              }
              var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
              if (seenPasswordToken) url.password += encodedCodePoints;
              else url.username += encodedCodePoints;
            }
            buffer = '';
          } else if (
            chr === EOF || chr === '/' || chr === '?' || chr === '#' ||
            (chr === '\\' && url.isSpecial())
          ) {
            if (seenAt && buffer === '') return INVALID_AUTHORITY;
            pointer -= arrayFrom(buffer).length + 1;
            buffer = '';
            state = HOST;
          } else buffer += chr;
          break;

        case HOST:
        case HOSTNAME:
          if (stateOverride && url.scheme === 'file') {
            state = FILE_HOST;
            continue;
          } else if (chr === ':' && !seenBracket) {
            if (buffer === '') return INVALID_HOST;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PORT;
            if (stateOverride === HOSTNAME) return;
          } else if (
            chr === EOF || chr === '/' || chr === '?' || chr === '#' ||
            (chr === '\\' && url.isSpecial())
          ) {
            if (url.isSpecial() && buffer === '') return INVALID_HOST;
            if (stateOverride && buffer === '' && (url.includesCredentials() || url.port !== null)) return;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PATH_START;
            if (stateOverride) return;
            continue;
          } else {
            if (chr === '[') seenBracket = true;
            else if (chr === ']') seenBracket = false;
            buffer += chr;
          } break;

        case PORT:
          if (exec(DIGIT, chr)) {
            buffer += chr;
          } else if (
            chr === EOF || chr === '/' || chr === '?' || chr === '#' ||
            (chr === '\\' && url.isSpecial()) ||
            stateOverride
          ) {
            if (buffer !== '') {
              var port = parseInt(buffer, 10);
              if (port > 0xFFFF) return INVALID_PORT;
              url.port = (url.isSpecial() && port === specialSchemes[url.scheme]) ? null : port;
              buffer = '';
            }
            if (stateOverride) return;
            state = PATH_START;
            continue;
          } else return INVALID_PORT;
          break;

        case FILE:
          url.scheme = 'file';
          if (chr === '/' || chr === '\\') state = FILE_SLASH;
          else if (base && base.scheme === 'file') {
            switch (chr) {
              case EOF:
                url.host = base.host;
                url.path = arraySlice(base.path);
                url.query = base.query;
                break;
              case '?':
                url.host = base.host;
                url.path = arraySlice(base.path);
                url.query = '';
                state = QUERY;
                break;
              case '#':
                url.host = base.host;
                url.path = arraySlice(base.path);
                url.query = base.query;
                url.fragment = '';
                state = FRAGMENT;
                break;
              default:
                if (!startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ''))) {
                  url.host = base.host;
                  url.path = arraySlice(base.path);
                  url.shortenPath();
                }
                state = PATH;
                continue;
            }
          } else {
            state = PATH;
            continue;
          } break;

        case FILE_SLASH:
          if (chr === '/' || chr === '\\') {
            state = FILE_HOST;
            break;
          }
          if (base && base.scheme === 'file' && !startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ''))) {
            if (isWindowsDriveLetter(base.path[0], true)) push(url.path, base.path[0]);
            else url.host = base.host;
          }
          state = PATH;
          continue;

        case FILE_HOST:
          if (chr === EOF || chr === '/' || chr === '\\' || chr === '?' || chr === '#') {
            if (!stateOverride && isWindowsDriveLetter(buffer)) {
              state = PATH;
            } else if (buffer === '') {
              url.host = '';
              if (stateOverride) return;
              state = PATH_START;
            } else {
              failure = url.parseHost(buffer);
              if (failure) return failure;
              if (url.host === 'localhost') url.host = '';
              if (stateOverride) return;
              buffer = '';
              state = PATH_START;
            } continue;
          } else buffer += chr;
          break;

        case PATH_START:
          if (url.isSpecial()) {
            state = PATH;
            if (chr !== '/' && chr !== '\\') continue;
          } else if (!stateOverride && chr === '?') {
            url.query = '';
            state = QUERY;
          } else if (!stateOverride && chr === '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr !== EOF) {
            state = PATH;
            if (chr !== '/') continue;
          } break;

        case PATH:
          if (
            chr === EOF || chr === '/' ||
            (chr === '\\' && url.isSpecial()) ||
            (!stateOverride && (chr === '?' || chr === '#'))
          ) {
            if (isDoubleDot(buffer)) {
              url.shortenPath();
              if (chr !== '/' && !(chr === '\\' && url.isSpecial())) {
                push(url.path, '');
              }
            } else if (isSingleDot(buffer)) {
              if (chr !== '/' && !(chr === '\\' && url.isSpecial())) {
                push(url.path, '');
              }
            } else {
              if (url.scheme === 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
                if (url.host) url.host = '';
                buffer = charAt(buffer, 0) + ':'; // normalize windows drive letter
              }
              push(url.path, buffer);
            }
            buffer = '';
            if (url.scheme === 'file' && (chr === EOF || chr === '?' || chr === '#')) {
              while (url.path.length > 1 && url.path[0] === '') {
                shift(url.path);
              }
            }
            if (chr === '?') {
              url.query = '';
              state = QUERY;
            } else if (chr === '#') {
              url.fragment = '';
              state = FRAGMENT;
            }
          } else {
            buffer += percentEncode(chr, pathPercentEncodeSet);
          } break;

        case CANNOT_BE_A_BASE_URL_PATH:
          if (chr === '?') {
            url.query = '';
            state = QUERY;
          } else if (chr === '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr !== EOF) {
            url.path[0] += percentEncode(chr, C0ControlPercentEncodeSet);
          } break;

        case QUERY:
          if (!stateOverride && chr === '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr !== EOF) {
            if (chr === "'" && url.isSpecial()) url.query += '%27';
            else if (chr === '#') url.query += '%23';
            else url.query += percentEncode(chr, C0ControlPercentEncodeSet);
          } break;

        case FRAGMENT:
          if (chr !== EOF) url.fragment += percentEncode(chr, fragmentPercentEncodeSet);
          break;
      }

      pointer++;
    }
  },
  // https://url.spec.whatwg.org/#host-parsing
  parseHost: function (input) {
    var result, codePoints, index;
    if (charAt(input, 0) === '[') {
      if (charAt(input, input.length - 1) !== ']') return INVALID_HOST;
      result = parseIPv6(stringSlice(input, 1, -1));
      if (!result) return INVALID_HOST;
      this.host = result;
    // opaque host
    } else if (!this.isSpecial()) {
      if (exec(FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT, input)) return INVALID_HOST;
      result = '';
      codePoints = arrayFrom(input);
      for (index = 0; index < codePoints.length; index++) {
        result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
      }
      this.host = result;
    } else {
      input = toASCII(input);
      if (exec(FORBIDDEN_HOST_CODE_POINT, input)) return INVALID_HOST;
      result = parseIPv4(input);
      if (result === null) return INVALID_HOST;
      this.host = result;
    }
  },
  // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
  cannotHaveUsernamePasswordPort: function () {
    return !this.host || this.cannotBeABaseURL || this.scheme === 'file';
  },
  // https://url.spec.whatwg.org/#include-credentials
  includesCredentials: function () {
    return this.username !== '' || this.password !== '';
  },
  // https://url.spec.whatwg.org/#is-special
  isSpecial: function () {
    return hasOwn(specialSchemes, this.scheme);
  },
  // https://url.spec.whatwg.org/#shorten-a-urls-path
  shortenPath: function () {
    var path = this.path;
    var pathSize = path.length;
    if (pathSize && (this.scheme !== 'file' || pathSize !== 1 || !isWindowsDriveLetter(path[0], true))) {
      path.length--;
    }
  },
  // https://url.spec.whatwg.org/#concept-url-serializer
  serialize: function () {
    var url = this;
    var scheme = url.scheme;
    var username = url.username;
    var password = url.password;
    var host = url.host;
    var port = url.port;
    var path = url.path;
    var query = url.query;
    var fragment = url.fragment;
    var output = scheme + ':';
    if (host !== null) {
      output += '//';
      if (url.includesCredentials()) {
        output += username + (password ? ':' + password : '') + '@';
      }
      output += serializeHost(host);
      if (port !== null) output += ':' + port;
    } else if (scheme === 'file') output += '//';
    output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
    if (query !== null) output += '?' + query;
    if (fragment !== null) output += '#' + fragment;
    return output;
  },
  // https://url.spec.whatwg.org/#dom-url-href
  setHref: function (href) {
    var failure = this.parse(href);
    if (failure) throw TypeError(failure);
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-origin
  getOrigin: function () {
    var scheme = this.scheme;
    var port = this.port;
    if (scheme === 'blob') try {
      return new URLConstructor(scheme.path[0]).origin;
    } catch (error) {
      return 'null';
    }
    if (scheme === 'file' || !this.isSpecial()) return 'null';
    return scheme + '://' + serializeHost(this.host) + (port !== null ? ':' + port : '');
  },
  // https://url.spec.whatwg.org/#dom-url-protocol
  getProtocol: function () {
    return this.scheme + ':';
  },
  setProtocol: function (protocol) {
    this.parse($toString(protocol) + ':', SCHEME_START);
  },
  // https://url.spec.whatwg.org/#dom-url-username
  getUsername: function () {
    return this.username;
  },
  setUsername: function (username) {
    var codePoints = arrayFrom($toString(username));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.username = '';
    for (var i = 0; i < codePoints.length; i++) {
      this.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-password
  getPassword: function () {
    return this.password;
  },
  setPassword: function (password) {
    var codePoints = arrayFrom($toString(password));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.password = '';
    for (var i = 0; i < codePoints.length; i++) {
      this.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-host
  getHost: function () {
    var host = this.host;
    var port = this.port;
    return host === null ? ''
      : port === null ? serializeHost(host)
      : serializeHost(host) + ':' + port;
  },
  setHost: function (host) {
    if (this.cannotBeABaseURL) return;
    this.parse(host, HOST);
  },
  // https://url.spec.whatwg.org/#dom-url-hostname
  getHostname: function () {
    var host = this.host;
    return host === null ? '' : serializeHost(host);
  },
  setHostname: function (hostname) {
    if (this.cannotBeABaseURL) return;
    this.parse(hostname, HOSTNAME);
  },
  // https://url.spec.whatwg.org/#dom-url-port
  getPort: function () {
    var port = this.port;
    return port === null ? '' : $toString(port);
  },
  setPort: function (port) {
    if (this.cannotHaveUsernamePasswordPort()) return;
    port = $toString(port);
    if (port === '') this.port = null;
    else this.parse(port, PORT);
  },
  // https://url.spec.whatwg.org/#dom-url-pathname
  getPathname: function () {
    var path = this.path;
    return this.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
  },
  setPathname: function (pathname) {
    if (this.cannotBeABaseURL) return;
    this.path = [];
    this.parse(pathname, PATH_START);
  },
  // https://url.spec.whatwg.org/#dom-url-search
  getSearch: function () {
    var query = this.query;
    return query ? '?' + query : '';
  },
  setSearch: function (search) {
    search = $toString(search);
    if (search === '') {
      this.query = null;
    } else {
      if (charAt(search, 0) === '?') search = stringSlice(search, 1);
      this.query = '';
      this.parse(search, QUERY);
    }
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-searchparams
  getSearchParams: function () {
    return this.searchParams.facade;
  },
  // https://url.spec.whatwg.org/#dom-url-hash
  getHash: function () {
    var fragment = this.fragment;
    return fragment ? '#' + fragment : '';
  },
  setHash: function (hash) {
    hash = $toString(hash);
    if (hash === '') {
      this.fragment = null;
      return;
    }
    if (charAt(hash, 0) === '#') hash = stringSlice(hash, 1);
    this.fragment = '';
    this.parse(hash, FRAGMENT);
  },
  update: function () {
    this.query = this.searchParams.serialize() || null;
  }
};

// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var URLConstructor = function URL(url /* , base */) {
  var that = anInstance(this, URLPrototype);
  var base = validateArgumentsLength(arguments.length, 1) > 1 ? arguments[1] : undefined;
  var state = setInternalState(that, new URLState(url, false, base));
  if (!DESCRIPTORS) {
    that.href = state.serialize();
    that.origin = state.getOrigin();
    that.protocol = state.getProtocol();
    that.username = state.getUsername();
    that.password = state.getPassword();
    that.host = state.getHost();
    that.hostname = state.getHostname();
    that.port = state.getPort();
    that.pathname = state.getPathname();
    that.search = state.getSearch();
    that.searchParams = state.getSearchParams();
    that.hash = state.getHash();
  }
};

var URLPrototype = URLConstructor.prototype;

var accessorDescriptor = function (getter, setter) {
  return {
    get: function () {
      return getInternalURLState(this)[getter]();
    },
    set: setter && function (value) {
      return getInternalURLState(this)[setter](value);
    },
    configurable: true,
    enumerable: true
  };
};

if (DESCRIPTORS) {
  // `URL.prototype.href` accessors pair
  // https://url.spec.whatwg.org/#dom-url-href
  defineBuiltInAccessor(URLPrototype, 'href', accessorDescriptor('serialize', 'setHref'));
  // `URL.prototype.origin` getter
  // https://url.spec.whatwg.org/#dom-url-origin
  defineBuiltInAccessor(URLPrototype, 'origin', accessorDescriptor('getOrigin'));
  // `URL.prototype.protocol` accessors pair
  // https://url.spec.whatwg.org/#dom-url-protocol
  defineBuiltInAccessor(URLPrototype, 'protocol', accessorDescriptor('getProtocol', 'setProtocol'));
  // `URL.prototype.username` accessors pair
  // https://url.spec.whatwg.org/#dom-url-username
  defineBuiltInAccessor(URLPrototype, 'username', accessorDescriptor('getUsername', 'setUsername'));
  // `URL.prototype.password` accessors pair
  // https://url.spec.whatwg.org/#dom-url-password
  defineBuiltInAccessor(URLPrototype, 'password', accessorDescriptor('getPassword', 'setPassword'));
  // `URL.prototype.host` accessors pair
  // https://url.spec.whatwg.org/#dom-url-host
  defineBuiltInAccessor(URLPrototype, 'host', accessorDescriptor('getHost', 'setHost'));
  // `URL.prototype.hostname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hostname
  defineBuiltInAccessor(URLPrototype, 'hostname', accessorDescriptor('getHostname', 'setHostname'));
  // `URL.prototype.port` accessors pair
  // https://url.spec.whatwg.org/#dom-url-port
  defineBuiltInAccessor(URLPrototype, 'port', accessorDescriptor('getPort', 'setPort'));
  // `URL.prototype.pathname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-pathname
  defineBuiltInAccessor(URLPrototype, 'pathname', accessorDescriptor('getPathname', 'setPathname'));
  // `URL.prototype.search` accessors pair
  // https://url.spec.whatwg.org/#dom-url-search
  defineBuiltInAccessor(URLPrototype, 'search', accessorDescriptor('getSearch', 'setSearch'));
  // `URL.prototype.searchParams` getter
  // https://url.spec.whatwg.org/#dom-url-searchparams
  defineBuiltInAccessor(URLPrototype, 'searchParams', accessorDescriptor('getSearchParams'));
  // `URL.prototype.hash` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hash
  defineBuiltInAccessor(URLPrototype, 'hash', accessorDescriptor('getHash', 'setHash'));
}

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
defineBuiltIn(URLPrototype, 'toJSON', function toJSON() {
  return getInternalURLState(this).serialize();
}, { enumerable: true });

// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
defineBuiltIn(URLPrototype, 'toString', function toString() {
  return getInternalURLState(this).serialize();
}, { enumerable: true });

if (NativeURL) {
  var nativeCreateObjectURL = NativeURL.createObjectURL;
  var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
  // `URL.createObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
  if (nativeCreateObjectURL) defineBuiltIn(URLConstructor, 'createObjectURL', bind(nativeCreateObjectURL, NativeURL));
  // `URL.revokeObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
  if (nativeRevokeObjectURL) defineBuiltIn(URLConstructor, 'revokeObjectURL', bind(nativeRevokeObjectURL, NativeURL));
}

setToStringTag(URLConstructor, 'URL');

$({ global: true, constructor: true, forced: !USE_NATIVE_URL, sham: !DESCRIPTORS }, {
  URL: URLConstructor
});


/***/ }),

/***/ 87767:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__(37828);


/***/ }),

/***/ 79509:
/***/ (function(module, exports) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory();
	}
	else {}
}(this, function () {

	/**
	 * CryptoJS core components.
	 */
	var CryptoJS = CryptoJS || (function (Math, undefined) {
	    /*
	     * Local polyfil of Object.create
	     */
	    var create = Object.create || (function () {
	        function F() {};

	        return function (obj) {
	            var subtype;

	            F.prototype = obj;

	            subtype = new F();

	            F.prototype = null;

	            return subtype;
	        };
	    }())

	    /**
	     * CryptoJS namespace.
	     */
	    var C = {};

	    /**
	     * Library namespace.
	     */
	    var C_lib = C.lib = {};

	    /**
	     * Base object for prototypal inheritance.
	     */
	    var Base = C_lib.Base = (function () {


	        return {
	            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */
	            extend: function (overrides) {
	                // Spawn
	                var subtype = create(this);

	                // Augment
	                if (overrides) {
	                    subtype.mixIn(overrides);
	                }

	                // Create default initializer
	                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
	                    subtype.init = function () {
	                        subtype.$super.init.apply(this, arguments);
	                    };
	                }

	                // Initializer's prototype is the subtype object
	                subtype.init.prototype = subtype;

	                // Reference supertype
	                subtype.$super = this;

	                return subtype;
	            },

	            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */
	            create: function () {
	                var instance = this.extend();
	                instance.init.apply(instance, arguments);

	                return instance;
	            },

	            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */
	            init: function () {
	            },

	            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */
	            mixIn: function (properties) {
	                for (var propertyName in properties) {
	                    if (properties.hasOwnProperty(propertyName)) {
	                        this[propertyName] = properties[propertyName];
	                    }
	                }

	                // IE won't copy toString using the loop above
	                if (properties.hasOwnProperty('toString')) {
	                    this.toString = properties.toString;
	                }
	            },

	            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */
	            clone: function () {
	                return this.init.prototype.extend(this);
	            }
	        };
	    }());

	    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var WordArray = C_lib.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 4;
	            }
	        },

	        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */
	        toString: function (encoder) {
	            return (encoder || Hex).stringify(this);
	        },

	        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */
	        concat: function (wordArray) {
	            // Shortcuts
	            var thisWords = this.words;
	            var thatWords = wordArray.words;
	            var thisSigBytes = this.sigBytes;
	            var thatSigBytes = wordArray.sigBytes;

	            // Clamp excess bits
	            this.clamp();

	            // Concat
	            if (thisSigBytes % 4) {
	                // Copy one byte at a time
	                for (var i = 0; i < thatSigBytes; i++) {
	                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
	                }
	            } else {
	                // Copy one word at a time
	                for (var i = 0; i < thatSigBytes; i += 4) {
	                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
	                }
	            }
	            this.sigBytes += thatSigBytes;

	            // Chainable
	            return this;
	        },

	        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */
	        clamp: function () {
	            // Shortcuts
	            var words = this.words;
	            var sigBytes = this.sigBytes;

	            // Clamp
	            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
	            words.length = Math.ceil(sigBytes / 4);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone.words = this.words.slice(0);

	            return clone;
	        },

	        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */
	        random: function (nBytes) {
	            var words = [];

	            var r = (function (m_w) {
	                var m_w = m_w;
	                var m_z = 0x3ade68b1;
	                var mask = 0xffffffff;

	                return function () {
	                    m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
	                    m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
	                    var result = ((m_z << 0x10) + m_w) & mask;
	                    result /= 0x100000000;
	                    result += 0.5;
	                    return result * (Math.random() > .5 ? 1 : -1);
	                }
	            });

	            for (var i = 0, rcache; i < nBytes; i += 4) {
	                var _r = r((rcache || Math.random()) * 0x100000000);

	                rcache = _r() * 0x3ade67b7;
	                words.push((_r() * 0x100000000) | 0);
	            }

	            return new WordArray.init(words, nBytes);
	        }
	    });

	    /**
	     * Encoder namespace.
	     */
	    var C_enc = C.enc = {};

	    /**
	     * Hex encoding strategy.
	     */
	    var Hex = C_enc.Hex = {
	        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var hexChars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                hexChars.push((bite >>> 4).toString(16));
	                hexChars.push((bite & 0x0f).toString(16));
	            }

	            return hexChars.join('');
	        },

	        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */
	        parse: function (hexStr) {
	            // Shortcut
	            var hexStrLength = hexStr.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < hexStrLength; i += 2) {
	                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
	            }

	            return new WordArray.init(words, hexStrLength / 2);
	        }
	    };

	    /**
	     * Latin1 encoding strategy.
	     */
	    var Latin1 = C_enc.Latin1 = {
	        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var latin1Chars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                latin1Chars.push(String.fromCharCode(bite));
	            }

	            return latin1Chars.join('');
	        },

	        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */
	        parse: function (latin1Str) {
	            // Shortcut
	            var latin1StrLength = latin1Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < latin1StrLength; i++) {
	                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
	            }

	            return new WordArray.init(words, latin1StrLength);
	        }
	    };

	    /**
	     * UTF-8 encoding strategy.
	     */
	    var Utf8 = C_enc.Utf8 = {
	        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            try {
	                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	            } catch (e) {
	                throw new Error('Malformed UTF-8 data');
	            }
	        },

	        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */
	        parse: function (utf8Str) {
	            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	        }
	    };

	    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */
	        reset: function () {
	            // Initial values
	            this._data = new WordArray.init();
	            this._nDataBytes = 0;
	        },

	        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */
	        _append: function (data) {
	            // Convert string to WordArray, else assume WordArray already
	            if (typeof data == 'string') {
	                data = Utf8.parse(data);
	            }

	            // Append
	            this._data.concat(data);
	            this._nDataBytes += data.sigBytes;
	        },

	        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */
	        _process: function (doFlush) {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var dataSigBytes = data.sigBytes;
	            var blockSize = this.blockSize;
	            var blockSizeBytes = blockSize * 4;

	            // Count blocks ready
	            var nBlocksReady = dataSigBytes / blockSizeBytes;
	            if (doFlush) {
	                // Round up to include partial blocks
	                nBlocksReady = Math.ceil(nBlocksReady);
	            } else {
	                // Round down to include only full blocks,
	                // less the number of blocks that must remain in the buffer
	                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	            }

	            // Count words ready
	            var nWordsReady = nBlocksReady * blockSize;

	            // Count bytes ready
	            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

	            // Process blocks
	            if (nWordsReady) {
	                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                    // Perform concrete-algorithm logic
	                    this._doProcessBlock(dataWords, offset);
	                }

	                // Remove processed words
	                var processedWords = dataWords.splice(0, nWordsReady);
	                data.sigBytes -= nBytesReady;
	            }

	            // Return processed words
	            return new WordArray.init(processedWords, nBytesReady);
	        },

	        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone._data = this._data.clone();

	            return clone;
	        },

	        _minBufferSize: 0
	    });

	    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */
	    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         */
	        cfg: Base.extend(),

	        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */
	        init: function (cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-hasher logic
	            this._doReset();
	        },

	        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            // Append
	            this._append(messageUpdate);

	            // Update the hash
	            this._process();

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Final message update
	            if (messageUpdate) {
	                this._append(messageUpdate);
	            }

	            // Perform concrete-hasher logic
	            var hash = this._doFinalize();

	            return hash;
	        },

	        blockSize: 512/32,

	        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */
	        _createHelper: function (hasher) {
	            return function (message, cfg) {
	                return new hasher.init(cfg).finalize(message);
	            };
	        },

	        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */
	        _createHmacHelper: function (hasher) {
	            return function (message, key) {
	                return new C_algo.HMAC.init(hasher, key).finalize(message);
	            };
	        }
	    });

	    /**
	     * Algorithm namespace.
	     */
	    var C_algo = C.algo = {};

	    return C;
	}(Math));


	return CryptoJS;

}));

/***/ }),

/***/ 85734:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(79509));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-1 hash algorithm.
	     */
	    var SHA1 = C_algo.SHA1 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476,
	                0xc3d2e1f0
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];

	            // Computation
	            for (var i = 0; i < 80; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
	                    W[i] = (n << 1) | (n >>> 31);
	                }

	                var t = ((a << 5) | (a >>> 27)) + e + W[i];
	                if (i < 20) {
	                    t += ((b & c) | (~b & d)) + 0x5a827999;
	                } else if (i < 40) {
	                    t += (b ^ c ^ d) + 0x6ed9eba1;
	                } else if (i < 60) {
	                    t += ((b & c) | (b & d) | (c & d)) - 0x70e44324;
	                } else /* if (i < 80) */ {
	                    t += (b ^ c ^ d) - 0x359d3e2a;
	                }

	                e = d;
	                d = c;
	                c = (b << 30) | (b >>> 2);
	                b = a;
	                a = t;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */
	    C.SHA1 = Hasher._createHelper(SHA1);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */
	    C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
	}());


	return CryptoJS.SHA1;

}));

/***/ }),

/***/ 49635:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(79509));
	}
	else {}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Initialization and round constants tables
	    var H = [];
	    var K = [];

	    // Compute constants
	    (function () {
	        function isPrime(n) {
	            var sqrtN = Math.sqrt(n);
	            for (var factor = 2; factor <= sqrtN; factor++) {
	                if (!(n % factor)) {
	                    return false;
	                }
	            }

	            return true;
	        }

	        function getFractionalBits(n) {
	            return ((n - (n | 0)) * 0x100000000) | 0;
	        }

	        var n = 2;
	        var nPrime = 0;
	        while (nPrime < 64) {
	            if (isPrime(n)) {
	                if (nPrime < 8) {
	                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
	                }
	                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

	                nPrime++;
	            }

	            n++;
	        }
	    }());

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-256 hash algorithm.
	     */
	    var SHA256 = C_algo.SHA256 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init(H.slice(0));
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];
	            var f = H[5];
	            var g = H[6];
	            var h = H[7];

	            // Computation
	            for (var i = 0; i < 64; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var gamma0x = W[i - 15];
	                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
	                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
	                                   (gamma0x >>> 3);

	                    var gamma1x = W[i - 2];
	                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
	                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
	                                   (gamma1x >>> 10);

	                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
	                }

	                var ch  = (e & f) ^ (~e & g);
	                var maj = (a & b) ^ (a & c) ^ (b & c);

	                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
	                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));

	                var t1 = h + sigma1 + ch + K[i] + W[i];
	                var t2 = sigma0 + maj;

	                h = g;
	                g = f;
	                f = e;
	                e = (d + t1) | 0;
	                d = c;
	                c = b;
	                b = a;
	                a = (t1 + t2) | 0;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	            H[5] = (H[5] + f) | 0;
	            H[6] = (H[6] + g) | 0;
	            H[7] = (H[7] + h) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */
	    C.SHA256 = Hasher._createHelper(SHA256);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */
	    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
	}(Math));


	return CryptoJS.SHA256;

}));

/***/ }),

/***/ 55807:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory();
	}
	else {}
}(this, function () {

	/*globals window, global, require*/

	/**
	 * CryptoJS core components.
	 */
	var CryptoJS = CryptoJS || (function (Math, undefined) {

	    var crypto;

	    // Native crypto from window (Browser)
	    if (typeof window !== 'undefined' && window.crypto) {
	        crypto = window.crypto;
	    }

	    // Native (experimental IE 11) crypto from window (Browser)
	    if (!crypto && typeof window !== 'undefined' && window.msCrypto) {
	        crypto = window.msCrypto;
	    }

	    // Native crypto from global (NodeJS)
	    if (!crypto && typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.crypto) {
	        crypto = __webpack_require__.g.crypto;
	    }

	    // Native crypto import via require (NodeJS)
	    if (!crypto && "function" === 'function') {
	        try {
	            crypto = __webpack_require__(16180);
	        } catch (err) {}
	    }

	    /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */
	    var cryptoSecureRandomInt = function () {
	        if (crypto) {
	            // Use getRandomValues method (Browser)
	            if (typeof crypto.getRandomValues === 'function') {
	                try {
	                    return crypto.getRandomValues(new Uint32Array(1))[0];
	                } catch (err) {}
	            }

	            // Use randomBytes method (NodeJS)
	            if (typeof crypto.randomBytes === 'function') {
	                try {
	                    return crypto.randomBytes(4).readInt32LE();
	                } catch (err) {}
	            }
	        }

	        throw new Error('Native crypto module could not be used to get secure random number.');
	    };

	    /*
	     * Local polyfill of Object.create

	     */
	    var create = Object.create || (function () {
	        function F() {}

	        return function (obj) {
	            var subtype;

	            F.prototype = obj;

	            subtype = new F();

	            F.prototype = null;

	            return subtype;
	        };
	    }())

	    /**
	     * CryptoJS namespace.
	     */
	    var C = {};

	    /**
	     * Library namespace.
	     */
	    var C_lib = C.lib = {};

	    /**
	     * Base object for prototypal inheritance.
	     */
	    var Base = C_lib.Base = (function () {


	        return {
	            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */
	            extend: function (overrides) {
	                // Spawn
	                var subtype = create(this);

	                // Augment
	                if (overrides) {
	                    subtype.mixIn(overrides);
	                }

	                // Create default initializer
	                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
	                    subtype.init = function () {
	                        subtype.$super.init.apply(this, arguments);
	                    };
	                }

	                // Initializer's prototype is the subtype object
	                subtype.init.prototype = subtype;

	                // Reference supertype
	                subtype.$super = this;

	                return subtype;
	            },

	            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */
	            create: function () {
	                var instance = this.extend();
	                instance.init.apply(instance, arguments);

	                return instance;
	            },

	            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */
	            init: function () {
	            },

	            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */
	            mixIn: function (properties) {
	                for (var propertyName in properties) {
	                    if (properties.hasOwnProperty(propertyName)) {
	                        this[propertyName] = properties[propertyName];
	                    }
	                }

	                // IE won't copy toString using the loop above
	                if (properties.hasOwnProperty('toString')) {
	                    this.toString = properties.toString;
	                }
	            },

	            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */
	            clone: function () {
	                return this.init.prototype.extend(this);
	            }
	        };
	    }());

	    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var WordArray = C_lib.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 4;
	            }
	        },

	        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */
	        toString: function (encoder) {
	            return (encoder || Hex).stringify(this);
	        },

	        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */
	        concat: function (wordArray) {
	            // Shortcuts
	            var thisWords = this.words;
	            var thatWords = wordArray.words;
	            var thisSigBytes = this.sigBytes;
	            var thatSigBytes = wordArray.sigBytes;

	            // Clamp excess bits
	            this.clamp();

	            // Concat
	            if (thisSigBytes % 4) {
	                // Copy one byte at a time
	                for (var i = 0; i < thatSigBytes; i++) {
	                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
	                }
	            } else {
	                // Copy one word at a time
	                for (var i = 0; i < thatSigBytes; i += 4) {
	                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
	                }
	            }
	            this.sigBytes += thatSigBytes;

	            // Chainable
	            return this;
	        },

	        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */
	        clamp: function () {
	            // Shortcuts
	            var words = this.words;
	            var sigBytes = this.sigBytes;

	            // Clamp
	            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
	            words.length = Math.ceil(sigBytes / 4);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone.words = this.words.slice(0);

	            return clone;
	        },

	        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */
	        random: function (nBytes) {
	            var words = [];

	            for (var i = 0; i < nBytes; i += 4) {
	                words.push(cryptoSecureRandomInt());
	            }

	            return new WordArray.init(words, nBytes);
	        }
	    });

	    /**
	     * Encoder namespace.
	     */
	    var C_enc = C.enc = {};

	    /**
	     * Hex encoding strategy.
	     */
	    var Hex = C_enc.Hex = {
	        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var hexChars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                hexChars.push((bite >>> 4).toString(16));
	                hexChars.push((bite & 0x0f).toString(16));
	            }

	            return hexChars.join('');
	        },

	        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */
	        parse: function (hexStr) {
	            // Shortcut
	            var hexStrLength = hexStr.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < hexStrLength; i += 2) {
	                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
	            }

	            return new WordArray.init(words, hexStrLength / 2);
	        }
	    };

	    /**
	     * Latin1 encoding strategy.
	     */
	    var Latin1 = C_enc.Latin1 = {
	        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var latin1Chars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                latin1Chars.push(String.fromCharCode(bite));
	            }

	            return latin1Chars.join('');
	        },

	        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */
	        parse: function (latin1Str) {
	            // Shortcut
	            var latin1StrLength = latin1Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < latin1StrLength; i++) {
	                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
	            }

	            return new WordArray.init(words, latin1StrLength);
	        }
	    };

	    /**
	     * UTF-8 encoding strategy.
	     */
	    var Utf8 = C_enc.Utf8 = {
	        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            try {
	                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	            } catch (e) {
	                throw new Error('Malformed UTF-8 data');
	            }
	        },

	        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */
	        parse: function (utf8Str) {
	            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	        }
	    };

	    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */
	        reset: function () {
	            // Initial values
	            this._data = new WordArray.init();
	            this._nDataBytes = 0;
	        },

	        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */
	        _append: function (data) {
	            // Convert string to WordArray, else assume WordArray already
	            if (typeof data == 'string') {
	                data = Utf8.parse(data);
	            }

	            // Append
	            this._data.concat(data);
	            this._nDataBytes += data.sigBytes;
	        },

	        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */
	        _process: function (doFlush) {
	            var processedWords;

	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var dataSigBytes = data.sigBytes;
	            var blockSize = this.blockSize;
	            var blockSizeBytes = blockSize * 4;

	            // Count blocks ready
	            var nBlocksReady = dataSigBytes / blockSizeBytes;
	            if (doFlush) {
	                // Round up to include partial blocks
	                nBlocksReady = Math.ceil(nBlocksReady);
	            } else {
	                // Round down to include only full blocks,
	                // less the number of blocks that must remain in the buffer
	                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	            }

	            // Count words ready
	            var nWordsReady = nBlocksReady * blockSize;

	            // Count bytes ready
	            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

	            // Process blocks
	            if (nWordsReady) {
	                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                    // Perform concrete-algorithm logic
	                    this._doProcessBlock(dataWords, offset);
	                }

	                // Remove processed words
	                processedWords = dataWords.splice(0, nWordsReady);
	                data.sigBytes -= nBytesReady;
	            }

	            // Return processed words
	            return new WordArray.init(processedWords, nBytesReady);
	        },

	        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone._data = this._data.clone();

	            return clone;
	        },

	        _minBufferSize: 0
	    });

	    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */
	    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         */
	        cfg: Base.extend(),

	        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */
	        init: function (cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-hasher logic
	            this._doReset();
	        },

	        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            // Append
	            this._append(messageUpdate);

	            // Update the hash
	            this._process();

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Final message update
	            if (messageUpdate) {
	                this._append(messageUpdate);
	            }

	            // Perform concrete-hasher logic
	            var hash = this._doFinalize();

	            return hash;
	        },

	        blockSize: 512/32,

	        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */
	        _createHelper: function (hasher) {
	            return function (message, cfg) {
	                return new hasher.init(cfg).finalize(message);
	            };
	        },

	        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */
	        _createHmacHelper: function (hasher) {
	            return function (message, key) {
	                return new C_algo.HMAC.init(hasher, key).finalize(message);
	            };
	        }
	    });

	    /**
	     * Algorithm namespace.
	     */
	    var C_algo = C.algo = {};

	    return C;
	}(Math));


	return CryptoJS;

}));

/***/ }),

/***/ 43911:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(55807), __webpack_require__(3183), __webpack_require__(15199));
	}
	else {}
}(this, function (CryptoJS) {

	return CryptoJS.HmacSHA1;

}));

/***/ }),

/***/ 15199:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(55807));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var C_algo = C.algo;

	    /**
	     * HMAC algorithm.
	     */
	    var HMAC = C_algo.HMAC = Base.extend({
	        /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */
	        init: function (hasher, key) {
	            // Init hasher
	            hasher = this._hasher = new hasher.init();

	            // Convert string to WordArray, else assume WordArray already
	            if (typeof key == 'string') {
	                key = Utf8.parse(key);
	            }

	            // Shortcuts
	            var hasherBlockSize = hasher.blockSize;
	            var hasherBlockSizeBytes = hasherBlockSize * 4;

	            // Allow arbitrary length keys
	            if (key.sigBytes > hasherBlockSizeBytes) {
	                key = hasher.finalize(key);
	            }

	            // Clamp excess bits
	            key.clamp();

	            // Clone key for inner and outer pads
	            var oKey = this._oKey = key.clone();
	            var iKey = this._iKey = key.clone();

	            // Shortcuts
	            var oKeyWords = oKey.words;
	            var iKeyWords = iKey.words;

	            // XOR keys with pad constants
	            for (var i = 0; i < hasherBlockSize; i++) {
	                oKeyWords[i] ^= 0x5c5c5c5c;
	                iKeyWords[i] ^= 0x36363636;
	            }
	            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */
	        reset: function () {
	            // Shortcut
	            var hasher = this._hasher;

	            // Reset
	            hasher.reset();
	            hasher.update(this._iKey);
	        },

	        /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            this._hasher.update(messageUpdate);

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Shortcut
	            var hasher = this._hasher;

	            // Compute HMAC
	            var innerHash = hasher.finalize(messageUpdate);
	            hasher.reset();
	            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));

	            return hmac;
	        }
	    });
	}());


}));

/***/ }),

/***/ 3183:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(55807));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-1 hash algorithm.
	     */
	    var SHA1 = C_algo.SHA1 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476,
	                0xc3d2e1f0
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];

	            // Computation
	            for (var i = 0; i < 80; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
	                    W[i] = (n << 1) | (n >>> 31);
	                }

	                var t = ((a << 5) | (a >>> 27)) + e + W[i];
	                if (i < 20) {
	                    t += ((b & c) | (~b & d)) + 0x5a827999;
	                } else if (i < 40) {
	                    t += (b ^ c ^ d) + 0x6ed9eba1;
	                } else if (i < 60) {
	                    t += ((b & c) | (b & d) | (c & d)) - 0x70e44324;
	                } else /* if (i < 80) */ {
	                    t += (b ^ c ^ d) - 0x359d3e2a;
	                }

	                e = d;
	                d = c;
	                c = (b << 30) | (b >>> 2);
	                b = a;
	                a = t;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */
	    C.SHA1 = Hasher._createHelper(SHA1);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */
	    C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
	}());


	return CryptoJS.SHA1;

}));

/***/ }),

/***/ 41182:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory();
	}
	else {}
}(this, function () {

	/*globals window, global, require*/

	/**
	 * CryptoJS core components.
	 */
	var CryptoJS = CryptoJS || (function (Math, undefined) {

	    var crypto;

	    // Native crypto from window (Browser)
	    if (typeof window !== 'undefined' && window.crypto) {
	        crypto = window.crypto;
	    }

	    // Native crypto in web worker (Browser)
	    if (typeof self !== 'undefined' && self.crypto) {
	        crypto = self.crypto;
	    }

	    // Native crypto from worker
	    if (typeof globalThis !== 'undefined' && globalThis.crypto) {
	        crypto = globalThis.crypto;
	    }

	    // Native (experimental IE 11) crypto from window (Browser)
	    if (!crypto && typeof window !== 'undefined' && window.msCrypto) {
	        crypto = window.msCrypto;
	    }

	    // Native crypto from global (NodeJS)
	    if (!crypto && typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.crypto) {
	        crypto = __webpack_require__.g.crypto;
	    }

	    // Native crypto import via require (NodeJS)
	    if (!crypto && "function" === 'function') {
	        try {
	            crypto = __webpack_require__(91054);
	        } catch (err) {}
	    }

	    /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */
	    var cryptoSecureRandomInt = function () {
	        if (crypto) {
	            // Use getRandomValues method (Browser)
	            if (typeof crypto.getRandomValues === 'function') {
	                try {
	                    return crypto.getRandomValues(new Uint32Array(1))[0];
	                } catch (err) {}
	            }

	            // Use randomBytes method (NodeJS)
	            if (typeof crypto.randomBytes === 'function') {
	                try {
	                    return crypto.randomBytes(4).readInt32LE();
	                } catch (err) {}
	            }
	        }

	        throw new Error('Native crypto module could not be used to get secure random number.');
	    };

	    /*
	     * Local polyfill of Object.create

	     */
	    var create = Object.create || (function () {
	        function F() {}

	        return function (obj) {
	            var subtype;

	            F.prototype = obj;

	            subtype = new F();

	            F.prototype = null;

	            return subtype;
	        };
	    }());

	    /**
	     * CryptoJS namespace.
	     */
	    var C = {};

	    /**
	     * Library namespace.
	     */
	    var C_lib = C.lib = {};

	    /**
	     * Base object for prototypal inheritance.
	     */
	    var Base = C_lib.Base = (function () {


	        return {
	            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */
	            extend: function (overrides) {
	                // Spawn
	                var subtype = create(this);

	                // Augment
	                if (overrides) {
	                    subtype.mixIn(overrides);
	                }

	                // Create default initializer
	                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
	                    subtype.init = function () {
	                        subtype.$super.init.apply(this, arguments);
	                    };
	                }

	                // Initializer's prototype is the subtype object
	                subtype.init.prototype = subtype;

	                // Reference supertype
	                subtype.$super = this;

	                return subtype;
	            },

	            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */
	            create: function () {
	                var instance = this.extend();
	                instance.init.apply(instance, arguments);

	                return instance;
	            },

	            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */
	            init: function () {
	            },

	            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */
	            mixIn: function (properties) {
	                for (var propertyName in properties) {
	                    if (properties.hasOwnProperty(propertyName)) {
	                        this[propertyName] = properties[propertyName];
	                    }
	                }

	                // IE won't copy toString using the loop above
	                if (properties.hasOwnProperty('toString')) {
	                    this.toString = properties.toString;
	                }
	            },

	            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */
	            clone: function () {
	                return this.init.prototype.extend(this);
	            }
	        };
	    }());

	    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var WordArray = C_lib.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 4;
	            }
	        },

	        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */
	        toString: function (encoder) {
	            return (encoder || Hex).stringify(this);
	        },

	        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */
	        concat: function (wordArray) {
	            // Shortcuts
	            var thisWords = this.words;
	            var thatWords = wordArray.words;
	            var thisSigBytes = this.sigBytes;
	            var thatSigBytes = wordArray.sigBytes;

	            // Clamp excess bits
	            this.clamp();

	            // Concat
	            if (thisSigBytes % 4) {
	                // Copy one byte at a time
	                for (var i = 0; i < thatSigBytes; i++) {
	                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
	                }
	            } else {
	                // Copy one word at a time
	                for (var j = 0; j < thatSigBytes; j += 4) {
	                    thisWords[(thisSigBytes + j) >>> 2] = thatWords[j >>> 2];
	                }
	            }
	            this.sigBytes += thatSigBytes;

	            // Chainable
	            return this;
	        },

	        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */
	        clamp: function () {
	            // Shortcuts
	            var words = this.words;
	            var sigBytes = this.sigBytes;

	            // Clamp
	            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
	            words.length = Math.ceil(sigBytes / 4);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone.words = this.words.slice(0);

	            return clone;
	        },

	        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */
	        random: function (nBytes) {
	            var words = [];

	            for (var i = 0; i < nBytes; i += 4) {
	                words.push(cryptoSecureRandomInt());
	            }

	            return new WordArray.init(words, nBytes);
	        }
	    });

	    /**
	     * Encoder namespace.
	     */
	    var C_enc = C.enc = {};

	    /**
	     * Hex encoding strategy.
	     */
	    var Hex = C_enc.Hex = {
	        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var hexChars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                hexChars.push((bite >>> 4).toString(16));
	                hexChars.push((bite & 0x0f).toString(16));
	            }

	            return hexChars.join('');
	        },

	        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */
	        parse: function (hexStr) {
	            // Shortcut
	            var hexStrLength = hexStr.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < hexStrLength; i += 2) {
	                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
	            }

	            return new WordArray.init(words, hexStrLength / 2);
	        }
	    };

	    /**
	     * Latin1 encoding strategy.
	     */
	    var Latin1 = C_enc.Latin1 = {
	        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var latin1Chars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                latin1Chars.push(String.fromCharCode(bite));
	            }

	            return latin1Chars.join('');
	        },

	        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */
	        parse: function (latin1Str) {
	            // Shortcut
	            var latin1StrLength = latin1Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < latin1StrLength; i++) {
	                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
	            }

	            return new WordArray.init(words, latin1StrLength);
	        }
	    };

	    /**
	     * UTF-8 encoding strategy.
	     */
	    var Utf8 = C_enc.Utf8 = {
	        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            try {
	                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	            } catch (e) {
	                throw new Error('Malformed UTF-8 data');
	            }
	        },

	        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */
	        parse: function (utf8Str) {
	            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	        }
	    };

	    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */
	        reset: function () {
	            // Initial values
	            this._data = new WordArray.init();
	            this._nDataBytes = 0;
	        },

	        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */
	        _append: function (data) {
	            // Convert string to WordArray, else assume WordArray already
	            if (typeof data == 'string') {
	                data = Utf8.parse(data);
	            }

	            // Append
	            this._data.concat(data);
	            this._nDataBytes += data.sigBytes;
	        },

	        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */
	        _process: function (doFlush) {
	            var processedWords;

	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var dataSigBytes = data.sigBytes;
	            var blockSize = this.blockSize;
	            var blockSizeBytes = blockSize * 4;

	            // Count blocks ready
	            var nBlocksReady = dataSigBytes / blockSizeBytes;
	            if (doFlush) {
	                // Round up to include partial blocks
	                nBlocksReady = Math.ceil(nBlocksReady);
	            } else {
	                // Round down to include only full blocks,
	                // less the number of blocks that must remain in the buffer
	                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	            }

	            // Count words ready
	            var nWordsReady = nBlocksReady * blockSize;

	            // Count bytes ready
	            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

	            // Process blocks
	            if (nWordsReady) {
	                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                    // Perform concrete-algorithm logic
	                    this._doProcessBlock(dataWords, offset);
	                }

	                // Remove processed words
	                processedWords = dataWords.splice(0, nWordsReady);
	                data.sigBytes -= nBytesReady;
	            }

	            // Return processed words
	            return new WordArray.init(processedWords, nBytesReady);
	        },

	        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone._data = this._data.clone();

	            return clone;
	        },

	        _minBufferSize: 0
	    });

	    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */
	    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         */
	        cfg: Base.extend(),

	        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */
	        init: function (cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-hasher logic
	            this._doReset();
	        },

	        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            // Append
	            this._append(messageUpdate);

	            // Update the hash
	            this._process();

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Final message update
	            if (messageUpdate) {
	                this._append(messageUpdate);
	            }

	            // Perform concrete-hasher logic
	            var hash = this._doFinalize();

	            return hash;
	        },

	        blockSize: 512/32,

	        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */
	        _createHelper: function (hasher) {
	            return function (message, cfg) {
	                return new hasher.init(cfg).finalize(message);
	            };
	        },

	        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */
	        _createHmacHelper: function (hasher) {
	            return function (message, key) {
	                return new C_algo.HMAC.init(hasher, key).finalize(message);
	            };
	        }
	    });

	    /**
	     * Algorithm namespace.
	     */
	    var C_algo = C.algo = {};

	    return C;
	}(Math));


	return CryptoJS;

}));

/***/ }),

/***/ 33490:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(41182));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * Base64 encoding strategy.
	     */
	    var Base64 = C_enc.Base64 = {
	        /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;
	            var map = this._map;

	            // Clamp excess bits
	            wordArray.clamp();

	            // Convert
	            var base64Chars = [];
	            for (var i = 0; i < sigBytes; i += 3) {
	                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
	                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
	                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

	                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

	                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
	                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
	                }
	            }

	            // Add padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                while (base64Chars.length % 4) {
	                    base64Chars.push(paddingChar);
	                }
	            }

	            return base64Chars.join('');
	        },

	        /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */
	        parse: function (base64Str) {
	            // Shortcuts
	            var base64StrLength = base64Str.length;
	            var map = this._map;
	            var reverseMap = this._reverseMap;

	            if (!reverseMap) {
	                    reverseMap = this._reverseMap = [];
	                    for (var j = 0; j < map.length; j++) {
	                        reverseMap[map.charCodeAt(j)] = j;
	                    }
	            }

	            // Ignore padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                var paddingIndex = base64Str.indexOf(paddingChar);
	                if (paddingIndex !== -1) {
	                    base64StrLength = paddingIndex;
	                }
	            }

	            // Convert
	            return parseLoop(base64Str, base64StrLength, reverseMap);

	        },

	        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
	    };

	    function parseLoop(base64Str, base64StrLength, reverseMap) {
	      var words = [];
	      var nBytes = 0;
	      for (var i = 0; i < base64StrLength; i++) {
	          if (i % 4) {
	              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
	              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
	              var bitsCombined = bits1 | bits2;
	              words[nBytes >>> 2] |= bitsCombined << (24 - (nBytes % 4) * 8);
	              nBytes++;
	          }
	      }
	      return WordArray.create(words, nBytes);
	    }
	}());


	return CryptoJS.enc.Base64;

}));

/***/ }),

/***/ 2447:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(41182));
	}
	else {}
}(this, function (CryptoJS) {

	return CryptoJS.enc.Hex;

}));

/***/ }),

/***/ 26551:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(41182));
	}
	else {}
}(this, function (CryptoJS) {

	return CryptoJS.enc.Utf8;

}));

/***/ }),

/***/ 69764:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(41182), __webpack_require__(99968), __webpack_require__(77892));
	}
	else {}
}(this, function (CryptoJS) {

	return CryptoJS.HmacSHA1;

}));

/***/ }),

/***/ 77892:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(41182));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var C_algo = C.algo;

	    /**
	     * HMAC algorithm.
	     */
	    var HMAC = C_algo.HMAC = Base.extend({
	        /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */
	        init: function (hasher, key) {
	            // Init hasher
	            hasher = this._hasher = new hasher.init();

	            // Convert string to WordArray, else assume WordArray already
	            if (typeof key == 'string') {
	                key = Utf8.parse(key);
	            }

	            // Shortcuts
	            var hasherBlockSize = hasher.blockSize;
	            var hasherBlockSizeBytes = hasherBlockSize * 4;

	            // Allow arbitrary length keys
	            if (key.sigBytes > hasherBlockSizeBytes) {
	                key = hasher.finalize(key);
	            }

	            // Clamp excess bits
	            key.clamp();

	            // Clone key for inner and outer pads
	            var oKey = this._oKey = key.clone();
	            var iKey = this._iKey = key.clone();

	            // Shortcuts
	            var oKeyWords = oKey.words;
	            var iKeyWords = iKey.words;

	            // XOR keys with pad constants
	            for (var i = 0; i < hasherBlockSize; i++) {
	                oKeyWords[i] ^= 0x5c5c5c5c;
	                iKeyWords[i] ^= 0x36363636;
	            }
	            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */
	        reset: function () {
	            // Shortcut
	            var hasher = this._hasher;

	            // Reset
	            hasher.reset();
	            hasher.update(this._iKey);
	        },

	        /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            this._hasher.update(messageUpdate);

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Shortcut
	            var hasher = this._hasher;

	            // Compute HMAC
	            var innerHash = hasher.finalize(messageUpdate);
	            hasher.reset();
	            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));

	            return hmac;
	        }
	    });
	}());


}));

/***/ }),

/***/ 59834:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(41182));
	}
	else {}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var T = [];

	    // Compute constants
	    (function () {
	        for (var i = 0; i < 64; i++) {
	            T[i] = (Math.abs(Math.sin(i + 1)) * 0x100000000) | 0;
	        }
	    }());

	    /**
	     * MD5 hash algorithm.
	     */
	    var MD5 = C_algo.MD5 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }

	            // Shortcuts
	            var H = this._hash.words;

	            var M_offset_0  = M[offset + 0];
	            var M_offset_1  = M[offset + 1];
	            var M_offset_2  = M[offset + 2];
	            var M_offset_3  = M[offset + 3];
	            var M_offset_4  = M[offset + 4];
	            var M_offset_5  = M[offset + 5];
	            var M_offset_6  = M[offset + 6];
	            var M_offset_7  = M[offset + 7];
	            var M_offset_8  = M[offset + 8];
	            var M_offset_9  = M[offset + 9];
	            var M_offset_10 = M[offset + 10];
	            var M_offset_11 = M[offset + 11];
	            var M_offset_12 = M[offset + 12];
	            var M_offset_13 = M[offset + 13];
	            var M_offset_14 = M[offset + 14];
	            var M_offset_15 = M[offset + 15];

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];

	            // Computation
	            a = FF(a, b, c, d, M_offset_0,  7,  T[0]);
	            d = FF(d, a, b, c, M_offset_1,  12, T[1]);
	            c = FF(c, d, a, b, M_offset_2,  17, T[2]);
	            b = FF(b, c, d, a, M_offset_3,  22, T[3]);
	            a = FF(a, b, c, d, M_offset_4,  7,  T[4]);
	            d = FF(d, a, b, c, M_offset_5,  12, T[5]);
	            c = FF(c, d, a, b, M_offset_6,  17, T[6]);
	            b = FF(b, c, d, a, M_offset_7,  22, T[7]);
	            a = FF(a, b, c, d, M_offset_8,  7,  T[8]);
	            d = FF(d, a, b, c, M_offset_9,  12, T[9]);
	            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
	            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
	            a = FF(a, b, c, d, M_offset_12, 7,  T[12]);
	            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
	            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
	            b = FF(b, c, d, a, M_offset_15, 22, T[15]);

	            a = GG(a, b, c, d, M_offset_1,  5,  T[16]);
	            d = GG(d, a, b, c, M_offset_6,  9,  T[17]);
	            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
	            b = GG(b, c, d, a, M_offset_0,  20, T[19]);
	            a = GG(a, b, c, d, M_offset_5,  5,  T[20]);
	            d = GG(d, a, b, c, M_offset_10, 9,  T[21]);
	            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
	            b = GG(b, c, d, a, M_offset_4,  20, T[23]);
	            a = GG(a, b, c, d, M_offset_9,  5,  T[24]);
	            d = GG(d, a, b, c, M_offset_14, 9,  T[25]);
	            c = GG(c, d, a, b, M_offset_3,  14, T[26]);
	            b = GG(b, c, d, a, M_offset_8,  20, T[27]);
	            a = GG(a, b, c, d, M_offset_13, 5,  T[28]);
	            d = GG(d, a, b, c, M_offset_2,  9,  T[29]);
	            c = GG(c, d, a, b, M_offset_7,  14, T[30]);
	            b = GG(b, c, d, a, M_offset_12, 20, T[31]);

	            a = HH(a, b, c, d, M_offset_5,  4,  T[32]);
	            d = HH(d, a, b, c, M_offset_8,  11, T[33]);
	            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
	            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
	            a = HH(a, b, c, d, M_offset_1,  4,  T[36]);
	            d = HH(d, a, b, c, M_offset_4,  11, T[37]);
	            c = HH(c, d, a, b, M_offset_7,  16, T[38]);
	            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
	            a = HH(a, b, c, d, M_offset_13, 4,  T[40]);
	            d = HH(d, a, b, c, M_offset_0,  11, T[41]);
	            c = HH(c, d, a, b, M_offset_3,  16, T[42]);
	            b = HH(b, c, d, a, M_offset_6,  23, T[43]);
	            a = HH(a, b, c, d, M_offset_9,  4,  T[44]);
	            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
	            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
	            b = HH(b, c, d, a, M_offset_2,  23, T[47]);

	            a = II(a, b, c, d, M_offset_0,  6,  T[48]);
	            d = II(d, a, b, c, M_offset_7,  10, T[49]);
	            c = II(c, d, a, b, M_offset_14, 15, T[50]);
	            b = II(b, c, d, a, M_offset_5,  21, T[51]);
	            a = II(a, b, c, d, M_offset_12, 6,  T[52]);
	            d = II(d, a, b, c, M_offset_3,  10, T[53]);
	            c = II(c, d, a, b, M_offset_10, 15, T[54]);
	            b = II(b, c, d, a, M_offset_1,  21, T[55]);
	            a = II(a, b, c, d, M_offset_8,  6,  T[56]);
	            d = II(d, a, b, c, M_offset_15, 10, T[57]);
	            c = II(c, d, a, b, M_offset_6,  15, T[58]);
	            b = II(b, c, d, a, M_offset_13, 21, T[59]);
	            a = II(a, b, c, d, M_offset_4,  6,  T[60]);
	            d = II(d, a, b, c, M_offset_11, 10, T[61]);
	            c = II(c, d, a, b, M_offset_2,  15, T[62]);
	            b = II(b, c, d, a, M_offset_9,  21, T[63]);

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);

	            var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
	            var nBitsTotalL = nBitsTotal;
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = (
	                (((nBitsTotalH << 8)  | (nBitsTotalH >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalH << 24) | (nBitsTotalH >>> 8))  & 0xff00ff00)
	            );
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotalL << 8)  | (nBitsTotalL >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalL << 24) | (nBitsTotalL >>> 8))  & 0xff00ff00)
	            );

	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                // Shortcut
	                var H_i = H[i];

	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    function FF(a, b, c, d, x, s, t) {
	        var n = a + ((b & c) | (~b & d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function GG(a, b, c, d, x, s, t) {
	        var n = a + ((b & d) | (c & ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function HH(a, b, c, d, x, s, t) {
	        var n = a + (b ^ c ^ d) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function II(a, b, c, d, x, s, t) {
	        var n = a + (c ^ (b | ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */
	    C.MD5 = Hasher._createHelper(MD5);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */
	    C.HmacMD5 = Hasher._createHmacHelper(MD5);
	}(Math));


	return CryptoJS.MD5;

}));

/***/ }),

/***/ 99968:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(41182));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-1 hash algorithm.
	     */
	    var SHA1 = C_algo.SHA1 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476,
	                0xc3d2e1f0
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];

	            // Computation
	            for (var i = 0; i < 80; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
	                    W[i] = (n << 1) | (n >>> 31);
	                }

	                var t = ((a << 5) | (a >>> 27)) + e + W[i];
	                if (i < 20) {
	                    t += ((b & c) | (~b & d)) + 0x5a827999;
	                } else if (i < 40) {
	                    t += (b ^ c ^ d) + 0x6ed9eba1;
	                } else if (i < 60) {
	                    t += ((b & c) | (b & d) | (c & d)) - 0x70e44324;
	                } else /* if (i < 80) */ {
	                    t += (b ^ c ^ d) - 0x359d3e2a;
	                }

	                e = d;
	                d = c;
	                c = (b << 30) | (b >>> 2);
	                b = a;
	                a = t;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */
	    C.SHA1 = Hasher._createHelper(SHA1);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */
	    C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
	}());


	return CryptoJS.SHA1;

}));

/***/ }),

/***/ 57735:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(41182));
	}
	else {}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Initialization and round constants tables
	    var H = [];
	    var K = [];

	    // Compute constants
	    (function () {
	        function isPrime(n) {
	            var sqrtN = Math.sqrt(n);
	            for (var factor = 2; factor <= sqrtN; factor++) {
	                if (!(n % factor)) {
	                    return false;
	                }
	            }

	            return true;
	        }

	        function getFractionalBits(n) {
	            return ((n - (n | 0)) * 0x100000000) | 0;
	        }

	        var n = 2;
	        var nPrime = 0;
	        while (nPrime < 64) {
	            if (isPrime(n)) {
	                if (nPrime < 8) {
	                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
	                }
	                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

	                nPrime++;
	            }

	            n++;
	        }
	    }());

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-256 hash algorithm.
	     */
	    var SHA256 = C_algo.SHA256 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init(H.slice(0));
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];
	            var f = H[5];
	            var g = H[6];
	            var h = H[7];

	            // Computation
	            for (var i = 0; i < 64; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var gamma0x = W[i - 15];
	                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
	                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
	                                   (gamma0x >>> 3);

	                    var gamma1x = W[i - 2];
	                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
	                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
	                                   (gamma1x >>> 10);

	                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
	                }

	                var ch  = (e & f) ^ (~e & g);
	                var maj = (a & b) ^ (a & c) ^ (b & c);

	                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
	                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));

	                var t1 = h + sigma1 + ch + K[i] + W[i];
	                var t2 = sigma0 + maj;

	                h = g;
	                g = f;
	                f = e;
	                e = (d + t1) | 0;
	                d = c;
	                c = b;
	                b = a;
	                a = (t1 + t2) | 0;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	            H[5] = (H[5] + f) | 0;
	            H[6] = (H[6] + g) | 0;
	            H[7] = (H[7] + h) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */
	    C.SHA256 = Hasher._createHelper(SHA256);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */
	    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
	}(Math));


	return CryptoJS.SHA256;

}));

/***/ }),

/***/ 12454:
/***/ ((module) => {

"use strict";


var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function getMergeFunction(key, options) {
	if (!options.customMerge) {
		return deepmerge
	}
	var customMerge = options.customMerge(key);
	return typeof customMerge === 'function' ? customMerge : deepmerge
}

function getEnumerableOwnPropertySymbols(target) {
	return Object.getOwnPropertySymbols
		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
			return Object.propertyIsEnumerable.call(target, symbol)
		})
		: []
}

function getKeys(target) {
	return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
}

function propertyIsOnObject(object, property) {
	try {
		return property in object
	} catch(_) {
		return false
	}
}

// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
	return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		getKeys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	getKeys(source).forEach(function(key) {
		if (propertyIsUnsafe(target, key)) {
			return
		}

		if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
		} else {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
	// implementations can use it. The caller may not replace it.
	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

module.exports = deepmerge_1;


/***/ }),

/***/ 35376:
/***/ ((module) => {

"use strict";


/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/
var dijkstra = {
  single_source_shortest_paths: function(graph, s, d) {
    // Predecessor map for each node that has been encountered.
    // node ID => predecessor node ID
    var predecessors = {};

    // Costs of shortest paths from s to all nodes encountered.
    // node ID => cost
    var costs = {};
    costs[s] = 0;

    // Costs of shortest paths from s to all nodes encountered; differs from
    // `costs` in that it provides easy access to the node that currently has
    // the known shortest path from s.
    // XXX: Do we actually need both `costs` and `open`?
    var open = dijkstra.PriorityQueue.make();
    open.push(s, 0);

    var closest,
        u, v,
        cost_of_s_to_u,
        adjacent_nodes,
        cost_of_e,
        cost_of_s_to_u_plus_cost_of_e,
        cost_of_s_to_v,
        first_visit;
    while (!open.empty()) {
      // In the nodes remaining in graph that have a known cost from s,
      // find the node, u, that currently has the shortest path from s.
      closest = open.pop();
      u = closest.value;
      cost_of_s_to_u = closest.cost;

      // Get nodes adjacent to u...
      adjacent_nodes = graph[u] || {};

      // ...and explore the edges that connect u to those nodes, updating
      // the cost of the shortest paths to any or all of those nodes as
      // necessary. v is the node across the current edge from u.
      for (v in adjacent_nodes) {
        if (adjacent_nodes.hasOwnProperty(v)) {
          // Get the cost of the edge running from u to v.
          cost_of_e = adjacent_nodes[v];

          // Cost of s to u plus the cost of u to v across e--this is *a*
          // cost from s to v that may or may not be less than the current
          // known cost to v.
          cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;

          // If we haven't visited v yet OR if the current known cost from s to
          // v is greater than the new cost we just found (cost of s to u plus
          // cost of u to v across e), update v's cost in the cost list and
          // update v's predecessor in the predecessor list (it's now u).
          cost_of_s_to_v = costs[v];
          first_visit = (typeof costs[v] === 'undefined');
          if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
            costs[v] = cost_of_s_to_u_plus_cost_of_e;
            open.push(v, cost_of_s_to_u_plus_cost_of_e);
            predecessors[v] = u;
          }
        }
      }
    }

    if (typeof d !== 'undefined' && typeof costs[d] === 'undefined') {
      var msg = ['Could not find a path from ', s, ' to ', d, '.'].join('');
      throw new Error(msg);
    }

    return predecessors;
  },

  extract_shortest_path_from_predecessor_list: function(predecessors, d) {
    var nodes = [];
    var u = d;
    var predecessor;
    while (u) {
      nodes.push(u);
      predecessor = predecessors[u];
      u = predecessors[u];
    }
    nodes.reverse();
    return nodes;
  },

  find_path: function(graph, s, d) {
    var predecessors = dijkstra.single_source_shortest_paths(graph, s, d);
    return dijkstra.extract_shortest_path_from_predecessor_list(
      predecessors, d);
  },

  /**
   * A very naive priority queue implementation.
   */
  PriorityQueue: {
    make: function (opts) {
      var T = dijkstra.PriorityQueue,
          t = {},
          key;
      opts = opts || {};
      for (key in T) {
        if (T.hasOwnProperty(key)) {
          t[key] = T[key];
        }
      }
      t.queue = [];
      t.sorter = opts.sorter || T.default_sorter;
      return t;
    },

    default_sorter: function (a, b) {
      return a.cost - b.cost;
    },

    /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */
    push: function (value, cost) {
      var item = {value: value, cost: cost};
      this.queue.push(item);
      this.queue.sort(this.sorter);
    },

    /**
     * Return the highest priority element in the queue.
     */
    pop: function () {
      return this.queue.shift();
    },

    empty: function () {
      return this.queue.length === 0;
    }
  }
};


// node.js module exports
if (true) {
  module.exports = dijkstra;
}


/***/ }),

/***/ 72100:
/***/ ((module) => {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}


/***/ }),

/***/ 61406:
/***/ ((module) => {

module.exports = stringify
stringify.default = stringify
stringify.stable = deterministicStringify
stringify.stableStringify = deterministicStringify

var LIMIT_REPLACE_NODE = '[...]'
var CIRCULAR_REPLACE_NODE = '[Circular]'

var arr = []
var replacerStack = []

function defaultOptions () {
  return {
    depthLimit: Number.MAX_SAFE_INTEGER,
    edgesLimit: Number.MAX_SAFE_INTEGER
  }
}

// Regular stringify
function stringify (obj, replacer, spacer, options) {
  if (typeof options === 'undefined') {
    options = defaultOptions()
  }

  decirc(obj, '', 0, [], undefined, 0, options)
  var res
  try {
    if (replacerStack.length === 0) {
      res = JSON.stringify(obj, replacer, spacer)
    } else {
      res = JSON.stringify(obj, replaceGetterValues(replacer), spacer)
    }
  } catch (_) {
    return JSON.stringify('[unable to serialize, circular reference is too complex to analyze]')
  } finally {
    while (arr.length !== 0) {
      var part = arr.pop()
      if (part.length === 4) {
        Object.defineProperty(part[0], part[1], part[3])
      } else {
        part[0][part[1]] = part[2]
      }
    }
  }
  return res
}

function setReplace (replace, val, k, parent) {
  var propertyDescriptor = Object.getOwnPropertyDescriptor(parent, k)
  if (propertyDescriptor.get !== undefined) {
    if (propertyDescriptor.configurable) {
      Object.defineProperty(parent, k, { value: replace })
      arr.push([parent, k, val, propertyDescriptor])
    } else {
      replacerStack.push([val, k, replace])
    }
  } else {
    parent[k] = replace
    arr.push([parent, k, val])
  }
}

function decirc (val, k, edgeIndex, stack, parent, depth, options) {
  depth += 1
  var i
  if (typeof val === 'object' && val !== null) {
    for (i = 0; i < stack.length; i++) {
      if (stack[i] === val) {
        setReplace(CIRCULAR_REPLACE_NODE, val, k, parent)
        return
      }
    }

    if (
      typeof options.depthLimit !== 'undefined' &&
      depth > options.depthLimit
    ) {
      setReplace(LIMIT_REPLACE_NODE, val, k, parent)
      return
    }

    if (
      typeof options.edgesLimit !== 'undefined' &&
      edgeIndex + 1 > options.edgesLimit
    ) {
      setReplace(LIMIT_REPLACE_NODE, val, k, parent)
      return
    }

    stack.push(val)
    // Optimize for Arrays. Big arrays could kill the performance otherwise!
    if (Array.isArray(val)) {
      for (i = 0; i < val.length; i++) {
        decirc(val[i], i, i, stack, val, depth, options)
      }
    } else {
      var keys = Object.keys(val)
      for (i = 0; i < keys.length; i++) {
        var key = keys[i]
        decirc(val[key], key, i, stack, val, depth, options)
      }
    }
    stack.pop()
  }
}

// Stable-stringify
function compareFunction (a, b) {
  if (a < b) {
    return -1
  }
  if (a > b) {
    return 1
  }
  return 0
}

function deterministicStringify (obj, replacer, spacer, options) {
  if (typeof options === 'undefined') {
    options = defaultOptions()
  }

  var tmp = deterministicDecirc(obj, '', 0, [], undefined, 0, options) || obj
  var res
  try {
    if (replacerStack.length === 0) {
      res = JSON.stringify(tmp, replacer, spacer)
    } else {
      res = JSON.stringify(tmp, replaceGetterValues(replacer), spacer)
    }
  } catch (_) {
    return JSON.stringify('[unable to serialize, circular reference is too complex to analyze]')
  } finally {
    // Ensure that we restore the object as it was.
    while (arr.length !== 0) {
      var part = arr.pop()
      if (part.length === 4) {
        Object.defineProperty(part[0], part[1], part[3])
      } else {
        part[0][part[1]] = part[2]
      }
    }
  }
  return res
}

function deterministicDecirc (val, k, edgeIndex, stack, parent, depth, options) {
  depth += 1
  var i
  if (typeof val === 'object' && val !== null) {
    for (i = 0; i < stack.length; i++) {
      if (stack[i] === val) {
        setReplace(CIRCULAR_REPLACE_NODE, val, k, parent)
        return
      }
    }
    try {
      if (typeof val.toJSON === 'function') {
        return
      }
    } catch (_) {
      return
    }

    if (
      typeof options.depthLimit !== 'undefined' &&
      depth > options.depthLimit
    ) {
      setReplace(LIMIT_REPLACE_NODE, val, k, parent)
      return
    }

    if (
      typeof options.edgesLimit !== 'undefined' &&
      edgeIndex + 1 > options.edgesLimit
    ) {
      setReplace(LIMIT_REPLACE_NODE, val, k, parent)
      return
    }

    stack.push(val)
    // Optimize for Arrays. Big arrays could kill the performance otherwise!
    if (Array.isArray(val)) {
      for (i = 0; i < val.length; i++) {
        deterministicDecirc(val[i], i, i, stack, val, depth, options)
      }
    } else {
      // Create a temporary object in the required way
      var tmp = {}
      var keys = Object.keys(val).sort(compareFunction)
      for (i = 0; i < keys.length; i++) {
        var key = keys[i]
        deterministicDecirc(val[key], key, i, stack, val, depth, options)
        tmp[key] = val[key]
      }
      if (typeof parent !== 'undefined') {
        arr.push([parent, k, val])
        parent[k] = tmp
      } else {
        return tmp
      }
    }
    stack.pop()
  }
}

// wraps replacer function to handle values we couldn't replace
// and mark them as replaced value
function replaceGetterValues (replacer) {
  replacer =
    typeof replacer !== 'undefined'
      ? replacer
      : function (k, v) {
        return v
      }
  return function (key, val) {
    if (replacerStack.length > 0) {
      for (var i = 0; i < replacerStack.length; i++) {
        var part = replacerStack[i]
        if (part[1] === key && part[0] === val) {
          val = part[2]
          replacerStack.splice(i, 1)
          break
        }
      }
    }
    return replacer.call(this, key, val)
  }
}


/***/ }),

/***/ 60059:
/***/ ((module) => {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),

/***/ 48794:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var implementation = __webpack_require__(60059);

module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ 72870:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(91143)();
var hasProto = __webpack_require__(43413)();

var getProto = Object.getPrototypeOf || (
	hasProto
		? function (x) { return x.__proto__; } // eslint-disable-line no-proto
		: null
);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(48794);
var hasOwn = __webpack_require__(79545);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ 43413:
/***/ ((module) => {

"use strict";


var test = {
	foo: {}
};

var $Object = Object;

module.exports = function hasProto() {
	return { __proto__: test }.foo === test.foo && !({ __proto__: null } instanceof $Object);
};


/***/ }),

/***/ 91143:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(79985);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),

/***/ 79985:
/***/ ((module) => {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ 79545:
/***/ ((module) => {

"use strict";


var hasOwnProperty = {}.hasOwnProperty;
var call = Function.prototype.call;

module.exports = call.bind ? call.bind(hasOwnProperty) : function (O, P) {
  return call.call(hasOwnProperty, O, P);
};


/***/ }),

/***/ 30551:
/***/ ((__unused_webpack_module, exports) => {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 36449:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.Z = safeSet;

var _utils = __webpack_require__(60364);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Compute next base in recursion
 * @param base current base
 * @param key current key in the path
 * @param nextKey next key in the path
 * @param withArrays create arrays instead of object when nextKey is a number and key has no value in the current base
 */
var nextBase = function nextBase(base, key, nextKey, withArrays) {
  return base[key] || (withArrays && typeof nextKey === 'number' ? [] : {});
};

/**
 * Reduce multiple elements in the accumulator using the setFunction when base is an Array
 * @param setFunction
 */
var reduceWithArray = function reduceWithArray(setFunction) {
  return (
    /**
     * Reduce multiple elements in the accumulator
     * @param base current base
     * @param path current path
     * @param keys list of keys ; we know there that keys is an array or set
     * @param nextKey next key in the path
     * @param values list of values, has to be an array
     * @param withArrays
     * @param accumulator new instance of the array at the current level
     * @returns {*} the accumulator with the new elements
     */
    function (base, path, keys, nextKey, values, _ref, accumulator) {
      var withArrays = _ref.withArrays,
          sameValue = _ref.sameValue;

      if (!Array.isArray(values) && !sameValue) {
        throw new Error('Can not use object values with array in path');
      }

      return keys.reduce(function (acc, key, index) {
        var value = sameValue ? values : values[index];
        var newValue = setFunction(nextBase(base, key, nextKey, withArrays), path.slice(1), value, {
          withArrays: withArrays,
          sameValue: sameValue
        });

        if (key < acc.length) {
          acc[key] = newValue;
        } else {
          acc.push(newValue);
        }

        return acc;
      }, accumulator);
    }
  );
};

/**
 * Reduce multiple elements in an new Object using the setFunction when base is an Object
 * @param setFunction
 */
var reduceWithObject = function reduceWithObject(fn) {
  return (
    /**
     * Reduce multiple elements in an new Object
     * @param base current base
     * @param path current path
     * @param keys list of keys ; we know there that keys is an array or set
     * @param nextKey next key in the path
     * @param values list of values, could be an array or an object
     * @param withArrays
     * @returns {*} a set of the new elements
     */
    function (base, path, keys, nextKey, values, _ref2) {
      var withArrays = _ref2.withArrays,
          sameValue = _ref2.sameValue;

      if (Array.isArray(values)) {
        return keys.reduce(function (acc, key, index) {
          var value = sameValue ? values : values[index];
          acc[key] = fn(nextBase(base, key, nextKey, withArrays), path.slice(1), value, { withArrays: withArrays, sameValue: sameValue });

          return acc;
        }, {});
      }

      return keys.reduce(function (acc, key) {
        var value = sameValue ? values : values[key];
        acc[key] = fn(nextBase(base, key, nextKey, withArrays), path.slice(1), value, { withArrays: withArrays, sameValue: sameValue });

        return acc;
      }, {});
    }
  );
};

/**
 * Recursive immutable set
 * @param base current base
 * @param path current path
 * @param value current value
 * @param config
 *  - withArrays create arrays instead of object when nextKey is a number and key has no value in the current base
 *  - sameValue use the same value for each element
 * @returns {*} a new instance of the given level
 */
function set(base, path, value, _ref3) {
  var withArrays = _ref3.withArrays,
      sameValue = _ref3.sameValue;

  if (path.length === 0) {
    return value;
  }

  var _path = _slicedToArray(path, 2),
      key = _path[0],
      nextKey = _path[1];

  var isArrayKeys = Array.isArray(key);
  var currentBase = base;

  if (!base || (typeof base === 'undefined' ? 'undefined' : _typeof(base)) !== 'object') {
    currentBase = isArrayKeys && typeof key[0] === 'number' || withArrays && typeof key === 'number' ? [] : {};
  }

  if (isArrayKeys) {
    if (Array.isArray(currentBase)) {
      return reduceWithArray(set)(currentBase, path, key, nextKey, value, { withArrays: withArrays, sameValue: sameValue }, [].concat(_toConsumableArray(currentBase)));
    }

    return _extends({}, currentBase, reduceWithObject(set)(currentBase, path, key, nextKey, value, { withArrays: withArrays, sameValue: sameValue }, {}));
  }

  if (Array.isArray(currentBase)) {
    return [].concat(_toConsumableArray(currentBase.slice(0, key)), [set(nextBase(currentBase, key, nextKey, withArrays), path.slice(1), value, { withArrays: withArrays, sameValue: sameValue })], _toConsumableArray(currentBase.slice(key + 1)));
  }

  return _extends({}, currentBase, _defineProperty({}, key, set(nextBase(currentBase, key, nextKey, withArrays), path.slice(1), value, { withArrays: withArrays, sameValue: sameValue })));
}

/**
 * Main function, recursive immutable set
 * @param base base object
 * @param initialPath path to the place where the value is going to be set
 * @param value value to set
 * @param options options
 * @returns {*} new instance of the base if it has been modified, the base otherwise
 */
function safeSet(base, initialPath, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _options$withArrays = options.withArrays,
      withArrays = _options$withArrays === undefined ? false : _options$withArrays,
      equality = options.equality,
      _options$sameValue = options.sameValue,
      sameValue = _options$sameValue === undefined ? false : _options$sameValue;

  var path = initialPath;

  // Handle string path
  if (typeof path === 'string' && path.length > 0) {
    path = path.split('.');
    path = path.reduce(function (acc, key) {
      var groupe = /\[([0-9]*)\]/.exec(key);

      if (groupe) {
        acc.push(key.substr(0, groupe.index), Number(groupe[1]));
      } else {
        acc.push(key);
      }

      return acc;
    }, []);
  }

  if (!Array.isArray(path) || path.length < 1) {
    return base === value ? base : value;
  }

  // If the value is already here we just need to return the base
  if ((0, _utils.isSafe)(value, options) && (0, _utils.recursiveEqual)(base, path, value, equality)) {
    return base;
  }

  return set(base, path, value, { withArrays: withArrays, sameValue: sameValue });
}

/***/ }),

/***/ 60364:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.isSafe = isSafe;
exports.recursiveEqual = recursiveEqual;
function isSafe(value) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$safe = _ref.safe,
      safe = _ref$safe === undefined ? false : _ref$safe;

  if (safe) return true;

  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value !== null) {
    if (value.length) {
      return !value.find(function (subValue) {
        return !isSafe(subValue);
      });
    }

    return safe;
  }

  return true;
}

/**
 * Recursive equality tester. Return true if the top down element of the path in the base is equal to the given value
 * @param base current base
 * @param path current path
 * @param value value to verify
 * @param equality override the equality assertion
 * @returns {boolean} true if the value is in the base at the end of the path
 */
function recursiveEqual(base, path, value, equality) {
  if (!base || (typeof base === 'undefined' ? 'undefined' : _typeof(base)) !== 'object') {
    return false;
  }

  var _path = _slicedToArray(path, 2),
      key = _path[0],
      nextKey = _path[1];

  if (nextKey === undefined) {
    return equality ? equality(base[key], value) : base[key] === value;
  }

  return recursiveEqual(base[key], path.slice(1), value, equality);
}

/***/ }),

/***/ 85459:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

try {
  var util = __webpack_require__(53827);
  /* istanbul ignore next */
  if (typeof util.inherits !== 'function') throw '';
  module.exports = util.inherits;
} catch (e) {
  /* istanbul ignore next */
  module.exports = __webpack_require__(2937);
}


/***/ }),

/***/ 2937:
/***/ ((module) => {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),

/***/ 99580:
/***/ ((module) => {

/**
 * The code was extracted from:
 * https://github.com/davidchambers/Base64.js
 */

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function InvalidCharacterError(message) {
  this.message = message;
}

InvalidCharacterError.prototype = new Error();
InvalidCharacterError.prototype.name = 'InvalidCharacterError';

function polyfill (input) {
  var str = String(input).replace(/=+$/, '');
  if (str.length % 4 == 1) {
    throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
  }
  for (
    // initialize result and counters
    var bc = 0, bs, buffer, idx = 0, output = '';
    // get next character
    buffer = str.charAt(idx++);
    // character found in table? initialize bit storage and add its ascii value;
    ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
      // and if not first of each 4 characters,
      // convert the first 8 bits to one ascii character
      bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
  ) {
    // try to find character in table (0-63, not found => -1)
    buffer = chars.indexOf(buffer);
  }
  return output;
}


module.exports = typeof window !== 'undefined' && window.atob && window.atob.bind(window) || polyfill;


/***/ }),

/***/ 4727:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var atob = __webpack_require__(99580);

function b64DecodeUnicode(str) {
  return decodeURIComponent(atob(str).replace(/(.)/g, function (m, p) {
    var code = p.charCodeAt(0).toString(16).toUpperCase();
    if (code.length < 2) {
      code = '0' + code;
    }
    return '%' + code;
  }));
}

module.exports = function(str) {
  var output = str.replace(/-/g, "+").replace(/_/g, "/");
  switch (output.length % 4) {
    case 0:
      break;
    case 2:
      output += "==";
      break;
    case 3:
      output += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }

  try{
    return b64DecodeUnicode(output);
  } catch (err) {
    return atob(output);
  }
};


/***/ }),

/***/ 30588:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var base64_url_decode = __webpack_require__(4727);

function InvalidTokenError(message) {
  this.message = message;
}

InvalidTokenError.prototype = new Error();
InvalidTokenError.prototype.name = 'InvalidTokenError';

module.exports = function (token,options) {
  if (typeof token !== 'string') {
    throw new InvalidTokenError('Invalid token specified');
  }

  options = options || {};
  var pos = options.header === true ? 0 : 1;
  try {
    return JSON.parse(base64_url_decode(token.split('.')[pos]));
  } catch (e) {
    throw new InvalidTokenError('Invalid token specified: ' + e.message);
  }
};

module.exports.InvalidTokenError = InvalidTokenError;


/***/ }),

/***/ 70870:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";



////////////////////////////////////////////////////////////////////////////////
// Helpers

// Merge objects
//
function assign(obj /*from1, from2, from3, ...*/) {
  var sources = Array.prototype.slice.call(arguments, 1);

  sources.forEach(function (source) {
    if (!source) { return; }

    Object.keys(source).forEach(function (key) {
      obj[key] = source[key];
    });
  });

  return obj;
}

function _class(obj) { return Object.prototype.toString.call(obj); }
function isString(obj) { return _class(obj) === '[object String]'; }
function isObject(obj) { return _class(obj) === '[object Object]'; }
function isRegExp(obj) { return _class(obj) === '[object RegExp]'; }
function isFunction(obj) { return _class(obj) === '[object Function]'; }


function escapeRE(str) { return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&'); }

////////////////////////////////////////////////////////////////////////////////


var defaultOptions = {
  fuzzyLink: true,
  fuzzyEmail: true,
  fuzzyIP: false
};


function isOptionsObj(obj) {
  return Object.keys(obj || {}).reduce(function (acc, k) {
    return acc || defaultOptions.hasOwnProperty(k);
  }, false);
}


var defaultSchemas = {
  'http:': {
    validate: function (text, pos, self) {
      var tail = text.slice(pos);

      if (!self.re.http) {
        // compile lazily, because "host"-containing variables can change on tlds update.
        self.re.http =  new RegExp(
          '^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i'
        );
      }
      if (self.re.http.test(tail)) {
        return tail.match(self.re.http)[0].length;
      }
      return 0;
    }
  },
  'https:':  'http:',
  'ftp:':    'http:',
  '//':      {
    validate: function (text, pos, self) {
      var tail = text.slice(pos);

      if (!self.re.no_http) {
      // compile lazily, because "host"-containing variables can change on tlds update.
        self.re.no_http =  new RegExp(
          '^' +
          self.re.src_auth +
          // Don't allow single-level domains, because of false positives like '//test'
          // with code comments
          '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' +
          self.re.src_port +
          self.re.src_host_terminator +
          self.re.src_path,

          'i'
        );
      }

      if (self.re.no_http.test(tail)) {
        // should not be `://` & `///`, that protects from errors in protocol name
        if (pos >= 3 && text[pos - 3] === ':') { return 0; }
        if (pos >= 3 && text[pos - 3] === '/') { return 0; }
        return tail.match(self.re.no_http)[0].length;
      }
      return 0;
    }
  },
  'mailto:': {
    validate: function (text, pos, self) {
      var tail = text.slice(pos);

      if (!self.re.mailto) {
        self.re.mailto =  new RegExp(
          '^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i'
        );
      }
      if (self.re.mailto.test(tail)) {
        return tail.match(self.re.mailto)[0].length;
      }
      return 0;
    }
  }
};

/*eslint-disable max-len*/

// RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';

// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var tlds_default = 'biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф'.split('|');

/*eslint-enable max-len*/

////////////////////////////////////////////////////////////////////////////////

function resetScanCache(self) {
  self.__index__ = -1;
  self.__text_cache__   = '';
}

function createValidator(re) {
  return function (text, pos) {
    var tail = text.slice(pos);

    if (re.test(tail)) {
      return tail.match(re)[0].length;
    }
    return 0;
  };
}

function createNormalizer() {
  return function (match, self) {
    self.normalize(match);
  };
}

// Schemas compiler. Build regexps.
//
function compile(self) {

  // Load & clone RE patterns.
  var re = self.re = __webpack_require__(87028)(self.__opts__);

  // Define dynamic patterns
  var tlds = self.__tlds__.slice();

  self.onCompile();

  if (!self.__tlds_replaced__) {
    tlds.push(tlds_2ch_src_re);
  }
  tlds.push(re.src_xn);

  re.src_tlds = tlds.join('|');

  function untpl(tpl) { return tpl.replace('%TLDS%', re.src_tlds); }

  re.email_fuzzy      = RegExp(untpl(re.tpl_email_fuzzy), 'i');
  re.link_fuzzy       = RegExp(untpl(re.tpl_link_fuzzy), 'i');
  re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
  re.host_fuzzy_test  = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');

  //
  // Compile each schema
  //

  var aliases = [];

  self.__compiled__ = {}; // Reset compiled data

  function schemaError(name, val) {
    throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
  }

  Object.keys(self.__schemas__).forEach(function (name) {
    var val = self.__schemas__[name];

    // skip disabled methods
    if (val === null) { return; }

    var compiled = { validate: null, link: null };

    self.__compiled__[name] = compiled;

    if (isObject(val)) {
      if (isRegExp(val.validate)) {
        compiled.validate = createValidator(val.validate);
      } else if (isFunction(val.validate)) {
        compiled.validate = val.validate;
      } else {
        schemaError(name, val);
      }

      if (isFunction(val.normalize)) {
        compiled.normalize = val.normalize;
      } else if (!val.normalize) {
        compiled.normalize = createNormalizer();
      } else {
        schemaError(name, val);
      }

      return;
    }

    if (isString(val)) {
      aliases.push(name);
      return;
    }

    schemaError(name, val);
  });

  //
  // Compile postponed aliases
  //

  aliases.forEach(function (alias) {
    if (!self.__compiled__[self.__schemas__[alias]]) {
      // Silently fail on missed schemas to avoid errons on disable.
      // schemaError(alias, self.__schemas__[alias]);
      return;
    }

    self.__compiled__[alias].validate =
      self.__compiled__[self.__schemas__[alias]].validate;
    self.__compiled__[alias].normalize =
      self.__compiled__[self.__schemas__[alias]].normalize;
  });

  //
  // Fake record for guessed links
  //
  self.__compiled__[''] = { validate: null, normalize: createNormalizer() };

  //
  // Build schema condition
  //
  var slist = Object.keys(self.__compiled__)
                      .filter(function (name) {
                        // Filter disabled & fake schemas
                        return name.length > 0 && self.__compiled__[name];
                      })
                      .map(escapeRE)
                      .join('|');
  // (?!_) cause 1.5x slowdown
  self.re.schema_test   = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
  self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');

  self.re.pretest = RegExp(
    '(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@',
    'i'
  );

  //
  // Cleanup
  //

  resetScanCache(self);
}

/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/
function Match(self, shift) {
  var start = self.__index__,
      end   = self.__last_index__,
      text  = self.__text_cache__.slice(start, end);

  /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/
  this.schema    = self.__schema__.toLowerCase();
  /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/
  this.index     = start + shift;
  /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/
  this.lastIndex = end + shift;
  /**
   * Match#raw -> String
   *
   * Matched string.
   **/
  this.raw       = text;
  /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/
  this.text      = text;
  /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/
  this.url       = text;
}

function createMatch(self, shift) {
  var match = new Match(self, shift);

  self.__compiled__[match.schema].normalize(match, self);

  return match;
}


/**
 * class LinkifyIt
 **/

/**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/
function LinkifyIt(schemas, options) {
  if (!(this instanceof LinkifyIt)) {
    return new LinkifyIt(schemas, options);
  }

  if (!options) {
    if (isOptionsObj(schemas)) {
      options = schemas;
      schemas = {};
    }
  }

  this.__opts__           = assign({}, defaultOptions, options);

  // Cache last tested result. Used to skip repeating steps on next `match` call.
  this.__index__          = -1;
  this.__last_index__     = -1; // Next scan position
  this.__schema__         = '';
  this.__text_cache__     = '';

  this.__schemas__        = assign({}, defaultSchemas, schemas);
  this.__compiled__       = {};

  this.__tlds__           = tlds_default;
  this.__tlds_replaced__  = false;

  this.re = {};

  compile(this);
}


/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/
LinkifyIt.prototype.add = function add(schema, definition) {
  this.__schemas__[schema] = definition;
  compile(this);
  return this;
};


/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/
LinkifyIt.prototype.set = function set(options) {
  this.__opts__ = assign(this.__opts__, options);
  return this;
};


/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/
LinkifyIt.prototype.test = function test(text) {
  // Reset scan cache
  this.__text_cache__ = text;
  this.__index__      = -1;

  if (!text.length) { return false; }

  var m, ml, me, len, shift, next, re, tld_pos, at_pos;

  // try to scan for link with schema - that's the most simple rule
  if (this.re.schema_test.test(text)) {
    re = this.re.schema_search;
    re.lastIndex = 0;
    while ((m = re.exec(text)) !== null) {
      len = this.testSchemaAt(text, m[2], re.lastIndex);
      if (len) {
        this.__schema__     = m[2];
        this.__index__      = m.index + m[1].length;
        this.__last_index__ = m.index + m[0].length + len;
        break;
      }
    }
  }

  if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
    // guess schemaless links
    tld_pos = text.search(this.re.host_fuzzy_test);
    if (tld_pos >= 0) {
      // if tld is located after found link - no need to check fuzzy pattern
      if (this.__index__ < 0 || tld_pos < this.__index__) {
        if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {

          shift = ml.index + ml[1].length;

          if (this.__index__ < 0 || shift < this.__index__) {
            this.__schema__     = '';
            this.__index__      = shift;
            this.__last_index__ = ml.index + ml[0].length;
          }
        }
      }
    }
  }

  if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
    // guess schemaless emails
    at_pos = text.indexOf('@');
    if (at_pos >= 0) {
      // We can't skip this check, because this cases are possible:
      // 192.168.1.1@gmail.com, my.in@example.com
      if ((me = text.match(this.re.email_fuzzy)) !== null) {

        shift = me.index + me[1].length;
        next  = me.index + me[0].length;

        if (this.__index__ < 0 || shift < this.__index__ ||
            (shift === this.__index__ && next > this.__last_index__)) {
          this.__schema__     = 'mailto:';
          this.__index__      = shift;
          this.__last_index__ = next;
        }
      }
    }
  }

  return this.__index__ >= 0;
};


/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/
LinkifyIt.prototype.pretest = function pretest(text) {
  return this.re.pretest.test(text);
};


/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/
LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
  // If not supported schema check requested - terminate
  if (!this.__compiled__[schema.toLowerCase()]) {
    return 0;
  }
  return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};


/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/
LinkifyIt.prototype.match = function match(text) {
  var shift = 0, result = [];

  // Try to take previous element from cache, if .test() called before
  if (this.__index__ >= 0 && this.__text_cache__ === text) {
    result.push(createMatch(this, shift));
    shift = this.__last_index__;
  }

  // Cut head if cache was used
  var tail = shift ? text.slice(shift) : text;

  // Scan string until end reached
  while (this.test(tail)) {
    result.push(createMatch(this, shift));

    tail = tail.slice(this.__last_index__);
    shift += this.__last_index__;
  }

  if (result.length) {
    return result;
  }

  return null;
};


/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/
LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
  list = Array.isArray(list) ? list : [ list ];

  if (!keepOld) {
    this.__tlds__ = list.slice();
    this.__tlds_replaced__ = true;
    compile(this);
    return this;
  }

  this.__tlds__ = this.__tlds__.concat(list)
                                  .sort()
                                  .filter(function (el, idx, arr) {
                                    return el !== arr[idx - 1];
                                  })
                                  .reverse();

  compile(this);
  return this;
};

/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/
LinkifyIt.prototype.normalize = function normalize(match) {

  // Do minimal possible changes by default. Need to collect feedback prior
  // to move forward https://github.com/markdown-it/linkify-it/issues/1

  if (!match.schema) { match.url = 'http://' + match.url; }

  if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) {
    match.url = 'mailto:' + match.url;
  }
};


/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/
LinkifyIt.prototype.onCompile = function onCompile() {
};


module.exports = LinkifyIt;


/***/ }),

/***/ 87028:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";



module.exports = function (opts) {
  var re = {};

  // Use direct extract instead of `regenerate` to reduse browserified size
  re.src_Any = (__webpack_require__(50757).source);
  re.src_Cc  = (__webpack_require__(18436).source);
  re.src_Z   = (__webpack_require__(87613).source);
  re.src_P   = (__webpack_require__(97942).source);

  // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
  re.src_ZPCc = [ re.src_Z, re.src_P, re.src_Cc ].join('|');

  // \p{\Z\Cc} (white spaces + control)
  re.src_ZCc = [ re.src_Z, re.src_Cc ].join('|');

  // Experimental. List of chars, completely prohibited in links
  // because can separate it from other part of text
  var text_separators = '[><\uff5c]';

  // All possible word characters (everything without punctuation, spaces & controls)
  // Defined via punctuation & spaces to save space
  // Should be something like \p{\L\N\S\M} (\w but without `_`)
  re.src_pseudo_letter       = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
  // The same as abothe but without [0-9]
  // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';

  ////////////////////////////////////////////////////////////////////////////////

  re.src_ip4 =

    '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';

  // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
  re.src_auth    = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';

  re.src_port =

    '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';

  re.src_host_terminator =

    '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';

  re.src_path =

    '(?:' +
      '[/?#]' +
        '(?:' +
          '(?!' + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' +
          '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' +
          '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' +
          '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' +
          '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' +
          "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" +
          "\\'(?=" + re.src_pseudo_letter + '|[-]).|' +  // allow `I'm_king` if no pair found
          '\\.{2,}[a-zA-Z0-9%/&]|' + // google has many dots in "google search" links (#66, #81).
                                     // github has ... in commit range links,
                                     // Restrict to
                                     // - english
                                     // - percent-encoded
                                     // - parts of file path
                                     // - params separator
                                     // until more examples found.
          '\\.(?!' + re.src_ZCc + '|[.]).|' +
          (opts && opts['---'] ?
            '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
            :
            '\\-+|'
          ) +
          ',(?!' + re.src_ZCc + ').|' +       // allow `,,,` in paths
          ';(?!' + re.src_ZCc + ').|' +       // allow `;` if not followed by space-like char
          '\\!+(?!' + re.src_ZCc + '|[!]).|' +  // allow `!!!` in paths, but not at the end
          '\\?(?!' + re.src_ZCc + '|[?]).' +
        ')+' +
      '|\\/' +
    ')?';

  // Allow anything in markdown spec, forbid quote (") at the first position
  // because emails enclosed in quotes are far more common
  re.src_email_name =

    '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';

  re.src_xn =

    'xn--[a-z0-9\\-]{1,59}';

  // More to read about domain names
  // http://serverfault.com/questions/638260/

  re.src_domain_root =

    // Allow letters & digits (http://test1)
    '(?:' +
      re.src_xn +
      '|' +
      re.src_pseudo_letter + '{1,63}' +
    ')';

  re.src_domain =

    '(?:' +
      re.src_xn +
      '|' +
      '(?:' + re.src_pseudo_letter + ')' +
      '|' +
      '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' +
    ')';

  re.src_host =

    '(?:' +
    // Don't need IP check, because digits are already allowed in normal domain names
    //   src_ip4 +
    // '|' +
      '(?:(?:(?:' + re.src_domain + ')\\.)*' + re.src_domain/*_root*/ + ')' +
    ')';

  re.tpl_host_fuzzy =

    '(?:' +
      re.src_ip4 +
    '|' +
      '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' +
    ')';

  re.tpl_host_no_ip_fuzzy =

    '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';

  re.src_host_strict =

    re.src_host + re.src_host_terminator;

  re.tpl_host_fuzzy_strict =

    re.tpl_host_fuzzy + re.src_host_terminator;

  re.src_host_port_strict =

    re.src_host + re.src_port + re.src_host_terminator;

  re.tpl_host_port_fuzzy_strict =

    re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;

  re.tpl_host_port_no_ip_fuzzy_strict =

    re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;


  ////////////////////////////////////////////////////////////////////////////////
  // Main rules

  // Rude test fuzzy links by host, for quick deny
  re.tpl_host_fuzzy_test =

    'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';

  re.tpl_email_fuzzy =

      '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' +
      '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';

  re.tpl_link_fuzzy =
      // Fuzzy link can't be prepended with .:/\- and non punctuation.
      // but can start with > (markdown blockquote)
      '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' +
      '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';

  re.tpl_link_no_ip_fuzzy =
      // Fuzzy link can't be prepended with .:/\- and non punctuation.
      // but can start with > (markdown blockquote)
      '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' +
      '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';

  return re;
};


/***/ }),

/***/ 87269:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758),
    root = __webpack_require__(29165);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 88987:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var hashClear = __webpack_require__(71519),
    hashDelete = __webpack_require__(82999),
    hashGet = __webpack_require__(76111),
    hashHas = __webpack_require__(50506),
    hashSet = __webpack_require__(80845);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 43933:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseCreate = __webpack_require__(91348),
    baseLodash = __webpack_require__(35309);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),

/***/ 175:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var listCacheClear = __webpack_require__(2173),
    listCacheDelete = __webpack_require__(33752),
    listCacheGet = __webpack_require__(10548),
    listCacheHas = __webpack_require__(63410),
    listCacheSet = __webpack_require__(3564);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 24868:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseCreate = __webpack_require__(91348),
    baseLodash = __webpack_require__(35309);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),

/***/ 35922:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758),
    root = __webpack_require__(29165);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 9440:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var mapCacheClear = __webpack_require__(7140),
    mapCacheDelete = __webpack_require__(56504),
    mapCacheGet = __webpack_require__(88833),
    mapCacheHas = __webpack_require__(80953),
    mapCacheSet = __webpack_require__(70724);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 6795:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758),
    root = __webpack_require__(29165);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 81956:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758),
    root = __webpack_require__(29165);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 78188:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var MapCache = __webpack_require__(9440),
    setCacheAdd = __webpack_require__(96659),
    setCacheHas = __webpack_require__(97230);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ 5929:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var ListCache = __webpack_require__(175),
    stackClear = __webpack_require__(40551),
    stackDelete = __webpack_require__(4090),
    stackGet = __webpack_require__(47694),
    stackHas = __webpack_require__(86220),
    stackSet = __webpack_require__(68958);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 74396:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var root = __webpack_require__(29165);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 92210:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var root = __webpack_require__(29165);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 69477:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758),
    root = __webpack_require__(29165);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 93501:
/***/ ((module) => {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ 21662:
/***/ ((module) => {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),

/***/ 48969:
/***/ ((module) => {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 79809:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseTimes = __webpack_require__(39739),
    isArguments = __webpack_require__(30353),
    isArray = __webpack_require__(24669),
    isBuffer = __webpack_require__(61563),
    isIndex = __webpack_require__(91010),
    isTypedArray = __webpack_require__(73806);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 75697:
/***/ ((module) => {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 28486:
/***/ ((module) => {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 30695:
/***/ ((module) => {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),

/***/ 84330:
/***/ ((module) => {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ 74202:
/***/ ((module) => {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),

/***/ 81034:
/***/ ((module) => {

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

module.exports = asciiWords;


/***/ }),

/***/ 72340:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseAssignValue = __webpack_require__(30404),
    eq = __webpack_require__(42448);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),

/***/ 93719:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseAssignValue = __webpack_require__(30404),
    eq = __webpack_require__(42448);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ 62718:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var eq = __webpack_require__(42448);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 43472:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var copyObject = __webpack_require__(92434),
    keys = __webpack_require__(50579);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),

/***/ 7254:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var copyObject = __webpack_require__(92434),
    keysIn = __webpack_require__(37390);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),

/***/ 30404:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var defineProperty = __webpack_require__(34082);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ 54527:
/***/ ((module) => {

/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

module.exports = baseClamp;


/***/ }),

/***/ 67410:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Stack = __webpack_require__(5929),
    arrayEach = __webpack_require__(21662),
    assignValue = __webpack_require__(93719),
    baseAssign = __webpack_require__(43472),
    baseAssignIn = __webpack_require__(7254),
    cloneBuffer = __webpack_require__(39767),
    copyArray = __webpack_require__(47165),
    copySymbols = __webpack_require__(8782),
    copySymbolsIn = __webpack_require__(2667),
    getAllKeys = __webpack_require__(69698),
    getAllKeysIn = __webpack_require__(21699),
    getTag = __webpack_require__(81887),
    initCloneArray = __webpack_require__(12195),
    initCloneByTag = __webpack_require__(46740),
    initCloneObject = __webpack_require__(36404),
    isArray = __webpack_require__(24669),
    isBuffer = __webpack_require__(61563),
    isMap = __webpack_require__(32924),
    isObject = __webpack_require__(36838),
    isSet = __webpack_require__(45380),
    keys = __webpack_require__(50579),
    keysIn = __webpack_require__(37390);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),

/***/ 91348:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isObject = __webpack_require__(36838);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ 30438:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseForOwn = __webpack_require__(61343),
    createBaseEach = __webpack_require__(8202);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),

/***/ 88286:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseEach = __webpack_require__(30438);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),

/***/ 92504:
/***/ ((module) => {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),

/***/ 98768:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayPush = __webpack_require__(28486),
    isFlattenable = __webpack_require__(89465);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),

/***/ 91030:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var createBaseFor = __webpack_require__(29);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ 61343:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseFor = __webpack_require__(91030),
    keys = __webpack_require__(50579);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),

/***/ 97499:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var castPath = __webpack_require__(60399),
    toKey = __webpack_require__(77817);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ 38084:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayPush = __webpack_require__(28486),
    isArray = __webpack_require__(24669);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 80732:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Symbol = __webpack_require__(74396),
    getRawTag = __webpack_require__(31239),
    objectToString = __webpack_require__(57058);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 45435:
/***/ ((module) => {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),

/***/ 71664:
/***/ ((module) => {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ 13807:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseFindIndex = __webpack_require__(92504),
    baseIsNaN = __webpack_require__(99940),
    strictIndexOf = __webpack_require__(3729);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),

/***/ 96023:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var apply = __webpack_require__(93501),
    castPath = __webpack_require__(60399),
    last = __webpack_require__(25674),
    parent = __webpack_require__(39118),
    toKey = __webpack_require__(77817);

/**
 * The base implementation of `_.invoke` without support for individual
 * method arguments.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the method to invoke.
 * @param {Array} args The arguments to invoke the method with.
 * @returns {*} Returns the result of the invoked method.
 */
function baseInvoke(object, path, args) {
  path = castPath(path, object);
  object = parent(object, path);
  var func = object == null ? object : object[toKey(last(path))];
  return func == null ? undefined : apply(func, object, args);
}

module.exports = baseInvoke;


/***/ }),

/***/ 84742:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(80732),
    isObjectLike = __webpack_require__(55073);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 6620:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsEqualDeep = __webpack_require__(83977),
    isObjectLike = __webpack_require__(55073);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ 83977:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Stack = __webpack_require__(5929),
    equalArrays = __webpack_require__(22684),
    equalByTag = __webpack_require__(7456),
    equalObjects = __webpack_require__(18120),
    getTag = __webpack_require__(81887),
    isArray = __webpack_require__(24669),
    isBuffer = __webpack_require__(61563),
    isTypedArray = __webpack_require__(73806);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ 64033:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getTag = __webpack_require__(81887),
    isObjectLike = __webpack_require__(55073);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),

/***/ 27122:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Stack = __webpack_require__(5929),
    baseIsEqual = __webpack_require__(6620);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ 99940:
/***/ ((module) => {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),

/***/ 58939:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isFunction = __webpack_require__(92042),
    isMasked = __webpack_require__(90654),
    isObject = __webpack_require__(36838),
    toSource = __webpack_require__(51059);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 28264:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getTag = __webpack_require__(81887),
    isObjectLike = __webpack_require__(55073);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),

/***/ 22882:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(80732),
    isLength = __webpack_require__(17216),
    isObjectLike = __webpack_require__(55073);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 5673:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseMatches = __webpack_require__(3772),
    baseMatchesProperty = __webpack_require__(30493),
    identity = __webpack_require__(48148),
    isArray = __webpack_require__(24669),
    property = __webpack_require__(51798);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ 87473:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isPrototype = __webpack_require__(92963),
    nativeKeys = __webpack_require__(14457);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 52506:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isObject = __webpack_require__(36838),
    isPrototype = __webpack_require__(92963),
    nativeKeysIn = __webpack_require__(10814);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),

/***/ 35309:
/***/ ((module) => {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),

/***/ 66494:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseEach = __webpack_require__(30438),
    isArrayLike = __webpack_require__(47428);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),

/***/ 3772:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsMatch = __webpack_require__(27122),
    getMatchData = __webpack_require__(67487),
    matchesStrictComparable = __webpack_require__(78857);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ 30493:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsEqual = __webpack_require__(6620),
    get = __webpack_require__(65439),
    hasIn = __webpack_require__(28281),
    isKey = __webpack_require__(2610),
    isStrictComparable = __webpack_require__(92769),
    matchesStrictComparable = __webpack_require__(78857),
    toKey = __webpack_require__(77817);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ 97254:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Stack = __webpack_require__(5929),
    assignMergeValue = __webpack_require__(72340),
    baseFor = __webpack_require__(91030),
    baseMergeDeep = __webpack_require__(10715),
    isObject = __webpack_require__(36838),
    keysIn = __webpack_require__(37390),
    safeGet = __webpack_require__(72014);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),

/***/ 10715:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assignMergeValue = __webpack_require__(72340),
    cloneBuffer = __webpack_require__(39767),
    cloneTypedArray = __webpack_require__(27136),
    copyArray = __webpack_require__(47165),
    initCloneObject = __webpack_require__(36404),
    isArguments = __webpack_require__(30353),
    isArray = __webpack_require__(24669),
    isArrayLikeObject = __webpack_require__(57348),
    isBuffer = __webpack_require__(61563),
    isFunction = __webpack_require__(92042),
    isObject = __webpack_require__(36838),
    isPlainObject = __webpack_require__(69143),
    isTypedArray = __webpack_require__(73806),
    safeGet = __webpack_require__(72014),
    toPlainObject = __webpack_require__(85111);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),

/***/ 84994:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayMap = __webpack_require__(75697),
    baseGet = __webpack_require__(97499),
    baseIteratee = __webpack_require__(5673),
    baseMap = __webpack_require__(66494),
    baseSortBy = __webpack_require__(16584),
    baseUnary = __webpack_require__(58792),
    compareMultiple = __webpack_require__(35395),
    identity = __webpack_require__(48148),
    isArray = __webpack_require__(24669);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (isArray(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }

  var index = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),

/***/ 54822:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var basePickBy = __webpack_require__(32648),
    hasIn = __webpack_require__(28281);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),

/***/ 32648:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGet = __webpack_require__(97499),
    baseSet = __webpack_require__(85713),
    castPath = __webpack_require__(60399);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),

/***/ 17498:
/***/ ((module) => {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ 71000:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGet = __webpack_require__(97499);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ 243:
/***/ ((module) => {

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

module.exports = basePropertyOf;


/***/ }),

/***/ 75857:
/***/ ((module) => {

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


/***/ }),

/***/ 5125:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var identity = __webpack_require__(48148),
    overRest = __webpack_require__(20323),
    setToString = __webpack_require__(71564);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ 85713:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assignValue = __webpack_require__(93719),
    castPath = __webpack_require__(60399),
    isIndex = __webpack_require__(91010),
    isObject = __webpack_require__(36838),
    toKey = __webpack_require__(77817);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),

/***/ 56447:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var constant = __webpack_require__(64806),
    defineProperty = __webpack_require__(34082),
    identity = __webpack_require__(48148);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ 43846:
/***/ ((module) => {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),

/***/ 16584:
/***/ ((module) => {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),

/***/ 39739:
/***/ ((module) => {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 73150:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Symbol = __webpack_require__(74396),
    arrayMap = __webpack_require__(75697),
    isArray = __webpack_require__(24669),
    isSymbol = __webpack_require__(16764);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 33124:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var trimmedEndIndex = __webpack_require__(82996);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 58792:
/***/ ((module) => {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 42933:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var castPath = __webpack_require__(60399),
    last = __webpack_require__(25674),
    parent = __webpack_require__(39118),
    toKey = __webpack_require__(77817);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),

/***/ 44290:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayMap = __webpack_require__(75697);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),

/***/ 29880:
/***/ ((module) => {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ 97008:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var identity = __webpack_require__(48148);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),

/***/ 60399:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isArray = __webpack_require__(24669),
    isKey = __webpack_require__(2610),
    stringToPath = __webpack_require__(77057),
    toString = __webpack_require__(8389);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ 20167:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseSlice = __webpack_require__(43846);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),

/***/ 78925:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Uint8Array = __webpack_require__(92210);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ 39767:
/***/ ((module, exports, __webpack_require__) => {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(29165);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;


/***/ }),

/***/ 56157:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var cloneArrayBuffer = __webpack_require__(78925);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),

/***/ 80101:
/***/ ((module) => {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),

/***/ 54920:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Symbol = __webpack_require__(74396);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),

/***/ 27136:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var cloneArrayBuffer = __webpack_require__(78925);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ 24687:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isSymbol = __webpack_require__(16764);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),

/***/ 35395:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var compareAscending = __webpack_require__(24687);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),

/***/ 47165:
/***/ ((module) => {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ 92434:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assignValue = __webpack_require__(93719),
    baseAssignValue = __webpack_require__(30404);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ 8782:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var copyObject = __webpack_require__(92434),
    getSymbols = __webpack_require__(97482);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),

/***/ 2667:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var copyObject = __webpack_require__(92434),
    getSymbolsIn = __webpack_require__(41288);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),

/***/ 36633:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var root = __webpack_require__(29165);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 77991:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseRest = __webpack_require__(5125),
    isIterateeCall = __webpack_require__(97616);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),

/***/ 8202:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isArrayLike = __webpack_require__(47428);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),

/***/ 29:
/***/ ((module) => {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ 23684:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var castSlice = __webpack_require__(20167),
    hasUnicode = __webpack_require__(30080),
    stringToArray = __webpack_require__(30078),
    toString = __webpack_require__(8389);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),

/***/ 51471:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayReduce = __webpack_require__(30695),
    deburr = __webpack_require__(26357),
    words = __webpack_require__(71055);

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

module.exports = createCompounder;


/***/ }),

/***/ 88700:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var LodashWrapper = __webpack_require__(24868),
    flatRest = __webpack_require__(54874),
    getData = __webpack_require__(61736),
    getFuncName = __webpack_require__(75517),
    isArray = __webpack_require__(24669),
    isLaziable = __webpack_require__(48747);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */
function createFlow(fromRight) {
  return flatRest(function(funcs) {
    var length = funcs.length,
        index = length,
        prereq = LodashWrapper.prototype.thru;

    if (fromRight) {
      funcs.reverse();
    }
    while (index--) {
      var func = funcs[index];
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
        var wrapper = new LodashWrapper([], true);
      }
    }
    index = wrapper ? index : length;
    while (++index < length) {
      func = funcs[index];

      var funcName = getFuncName(func),
          data = funcName == 'wrapper' ? getData(func) : undefined;

      if (data && isLaziable(data[0]) &&
            data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
            !data[4].length && data[9] == 1
          ) {
        wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
      } else {
        wrapper = (func.length == 1 && isLaziable(func))
          ? wrapper[funcName]()
          : wrapper.thru(func);
      }
    }
    return function() {
      var args = arguments,
          value = args[0];

      if (wrapper && args.length == 1 && isArray(value)) {
        return wrapper.plant(value).value();
      }
      var index = 0,
          result = length ? funcs[index].apply(this, args) : value;

      while (++index < length) {
        result = funcs[index].call(this, result);
      }
      return result;
    };
  });
}

module.exports = createFlow;


/***/ }),

/***/ 59211:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isPlainObject = __webpack_require__(69143);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),

/***/ 92523:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var basePropertyOf = __webpack_require__(243);

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

module.exports = deburrLetter;


/***/ }),

/***/ 34082:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ 22684:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var SetCache = __webpack_require__(78188),
    arraySome = __webpack_require__(84330),
    cacheHas = __webpack_require__(29880);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ 7456:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Symbol = __webpack_require__(74396),
    Uint8Array = __webpack_require__(92210),
    eq = __webpack_require__(42448),
    equalArrays = __webpack_require__(22684),
    mapToArray = __webpack_require__(7523),
    setToArray = __webpack_require__(79967);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ 18120:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getAllKeys = __webpack_require__(69698);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ 54874:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var flatten = __webpack_require__(22612),
    overRest = __webpack_require__(20323),
    setToString = __webpack_require__(71564);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),

/***/ 96476:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 69698:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetAllKeys = __webpack_require__(38084),
    getSymbols = __webpack_require__(97482),
    keys = __webpack_require__(50579);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 21699:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetAllKeys = __webpack_require__(38084),
    getSymbolsIn = __webpack_require__(41288),
    keysIn = __webpack_require__(37390);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),

/***/ 61736:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var metaMap = __webpack_require__(22556),
    noop = __webpack_require__(43226);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),

/***/ 75517:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var realNames = __webpack_require__(52051);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),

/***/ 67707:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isKeyable = __webpack_require__(3880);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 67487:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isStrictComparable = __webpack_require__(92769),
    keys = __webpack_require__(50579);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ 47758:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsNative = __webpack_require__(58939),
    getValue = __webpack_require__(9149);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 11389:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var overArg = __webpack_require__(75542);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ 31239:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Symbol = __webpack_require__(74396);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 97482:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayFilter = __webpack_require__(48969),
    stubArray = __webpack_require__(68036);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 41288:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayPush = __webpack_require__(28486),
    getPrototype = __webpack_require__(11389),
    getSymbols = __webpack_require__(97482),
    stubArray = __webpack_require__(68036);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),

/***/ 81887:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var DataView = __webpack_require__(87269),
    Map = __webpack_require__(35922),
    Promise = __webpack_require__(6795),
    Set = __webpack_require__(81956),
    WeakMap = __webpack_require__(69477),
    baseGetTag = __webpack_require__(80732),
    toSource = __webpack_require__(51059);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 9149:
/***/ ((module) => {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 18554:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var castPath = __webpack_require__(60399),
    isArguments = __webpack_require__(30353),
    isArray = __webpack_require__(24669),
    isIndex = __webpack_require__(91010),
    isLength = __webpack_require__(17216),
    toKey = __webpack_require__(77817);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ 30080:
/***/ ((module) => {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),

/***/ 37854:
/***/ ((module) => {

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

module.exports = hasUnicodeWord;


/***/ }),

/***/ 71519:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var nativeCreate = __webpack_require__(37722);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 82999:
/***/ ((module) => {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 76111:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var nativeCreate = __webpack_require__(37722);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 50506:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var nativeCreate = __webpack_require__(37722);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 80845:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var nativeCreate = __webpack_require__(37722);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 12195:
/***/ ((module) => {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),

/***/ 46740:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var cloneArrayBuffer = __webpack_require__(78925),
    cloneDataView = __webpack_require__(56157),
    cloneRegExp = __webpack_require__(80101),
    cloneSymbol = __webpack_require__(54920),
    cloneTypedArray = __webpack_require__(27136);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),

/***/ 36404:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseCreate = __webpack_require__(91348),
    getPrototype = __webpack_require__(11389),
    isPrototype = __webpack_require__(92963);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ 89465:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Symbol = __webpack_require__(74396),
    isArguments = __webpack_require__(30353),
    isArray = __webpack_require__(24669);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),

/***/ 91010:
/***/ ((module) => {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 97616:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var eq = __webpack_require__(42448),
    isArrayLike = __webpack_require__(47428),
    isIndex = __webpack_require__(91010),
    isObject = __webpack_require__(36838);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ 2610:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isArray = __webpack_require__(24669),
    isSymbol = __webpack_require__(16764);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ 3880:
/***/ ((module) => {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 48747:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var LazyWrapper = __webpack_require__(43933),
    getData = __webpack_require__(61736),
    getFuncName = __webpack_require__(75517),
    lodash = __webpack_require__(63385);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),

/***/ 90654:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var coreJsData = __webpack_require__(36633);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 92963:
/***/ ((module) => {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 92769:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isObject = __webpack_require__(36838);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ 2173:
/***/ ((module) => {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 33752:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assocIndexOf = __webpack_require__(62718);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 10548:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assocIndexOf = __webpack_require__(62718);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 63410:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assocIndexOf = __webpack_require__(62718);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 3564:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assocIndexOf = __webpack_require__(62718);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 7140:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Hash = __webpack_require__(88987),
    ListCache = __webpack_require__(175),
    Map = __webpack_require__(35922);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 56504:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getMapData = __webpack_require__(67707);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 88833:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getMapData = __webpack_require__(67707);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 80953:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getMapData = __webpack_require__(67707);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 70724:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getMapData = __webpack_require__(67707);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 7523:
/***/ ((module) => {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ 78857:
/***/ ((module) => {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ 45171:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var memoize = __webpack_require__(34736);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 22556:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var WeakMap = __webpack_require__(69477);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),

/***/ 37722:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 14457:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var overArg = __webpack_require__(75542);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 10814:
/***/ ((module) => {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ 8478:
/***/ ((module, exports, __webpack_require__) => {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(96476);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 57058:
/***/ ((module) => {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 75542:
/***/ ((module) => {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 20323:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var apply = __webpack_require__(93501);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ 39118:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGet = __webpack_require__(97499),
    baseSlice = __webpack_require__(43846);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),

/***/ 52051:
/***/ ((module) => {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),

/***/ 29165:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var freeGlobal = __webpack_require__(96476);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 72014:
/***/ ((module) => {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),

/***/ 96659:
/***/ ((module) => {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ 97230:
/***/ ((module) => {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ 79967:
/***/ ((module) => {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ 71564:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseSetToString = __webpack_require__(56447),
    shortOut = __webpack_require__(15509);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ 15509:
/***/ ((module) => {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ 40551:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var ListCache = __webpack_require__(175);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 4090:
/***/ ((module) => {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 47694:
/***/ ((module) => {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 86220:
/***/ ((module) => {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 68958:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var ListCache = __webpack_require__(175),
    Map = __webpack_require__(35922),
    MapCache = __webpack_require__(9440);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 3729:
/***/ ((module) => {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ 30078:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var asciiToArray = __webpack_require__(74202),
    hasUnicode = __webpack_require__(30080),
    unicodeToArray = __webpack_require__(95611);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),

/***/ 77057:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var memoizeCapped = __webpack_require__(45171);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 77817:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isSymbol = __webpack_require__(16764);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 51059:
/***/ ((module) => {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 82996:
/***/ ((module) => {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 95611:
/***/ ((module) => {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),

/***/ 24155:
/***/ ((module) => {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

module.exports = unicodeWords;


/***/ }),

/***/ 24281:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var LazyWrapper = __webpack_require__(43933),
    LodashWrapper = __webpack_require__(24868),
    copyArray = __webpack_require__(47165);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),

/***/ 41255:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseSlice = __webpack_require__(43846),
    isIterateeCall = __webpack_require__(97616),
    toInteger = __webpack_require__(20426);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */
function chunk(array, size, guard) {
  if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
    size = 1;
  } else {
    size = nativeMax(toInteger(size), 0);
  }
  var length = array == null ? 0 : array.length;
  if (!length || size < 1) {
    return [];
  }
  var index = 0,
      resIndex = 0,
      result = Array(nativeCeil(length / size));

  while (index < length) {
    result[resIndex++] = baseSlice(array, index, (index += size));
  }
  return result;
}

module.exports = chunk;


/***/ }),

/***/ 35636:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseClamp = __webpack_require__(54527),
    toNumber = __webpack_require__(12448);

/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */
function clamp(number, lower, upper) {
  if (upper === undefined) {
    upper = lower;
    lower = undefined;
  }
  if (upper !== undefined) {
    upper = toNumber(upper);
    upper = upper === upper ? upper : 0;
  }
  if (lower !== undefined) {
    lower = toNumber(lower);
    lower = lower === lower ? lower : 0;
  }
  return baseClamp(toNumber(number), lower, upper);
}

module.exports = clamp;


/***/ }),

/***/ 55824:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseClone = __webpack_require__(67410);

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),

/***/ 64806:
/***/ ((module) => {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ 66292:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isObject = __webpack_require__(36838),
    now = __webpack_require__(76668),
    toNumber = __webpack_require__(12448);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 26357:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var deburrLetter = __webpack_require__(92523),
    toString = __webpack_require__(8389);

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

module.exports = deburr;


/***/ }),

/***/ 42448:
/***/ ((module) => {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 31521:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseFindIndex = __webpack_require__(92504),
    baseIteratee = __webpack_require__(5673),
    toInteger = __webpack_require__(20426);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */
function findLastIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = length - 1;
  if (fromIndex !== undefined) {
    index = toInteger(fromIndex);
    index = fromIndex < 0
      ? nativeMax(length + index, 0)
      : nativeMin(index, length - 1);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index, true);
}

module.exports = findLastIndex;


/***/ }),

/***/ 47812:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseFlatten = __webpack_require__(98768),
    map = __webpack_require__(65512);

/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */
function flatMap(collection, iteratee) {
  return baseFlatten(map(collection, iteratee), 1);
}

module.exports = flatMap;


/***/ }),

/***/ 22612:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseFlatten = __webpack_require__(98768);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),

/***/ 14459:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var createFlow = __webpack_require__(88700);

/**
 * Creates a function that returns the result of invoking the given functions
 * with the `this` binding of the created function, where each successive
 * invocation is supplied the return value of the previous.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flowRight
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flow([_.add, square]);
 * addSquare(1, 2);
 * // => 9
 */
var flow = createFlow();

module.exports = flow;


/***/ }),

/***/ 17489:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayEach = __webpack_require__(21662),
    baseEach = __webpack_require__(30438),
    castFunction = __webpack_require__(97008),
    isArray = __webpack_require__(24669);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),

/***/ 14287:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseForOwn = __webpack_require__(61343),
    castFunction = __webpack_require__(97008);

/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forOwn(object, iteratee) {
  return object && baseForOwn(object, castFunction(iteratee));
}

module.exports = forOwn;


/***/ }),

/***/ 65439:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGet = __webpack_require__(97499);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 56611:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseHas = __webpack_require__(45435),
    hasPath = __webpack_require__(18554);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),

/***/ 28281:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseHasIn = __webpack_require__(71664),
    hasPath = __webpack_require__(18554);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ 48148:
/***/ ((module) => {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 44840:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIndexOf = __webpack_require__(13807),
    isArrayLike = __webpack_require__(47428),
    isString = __webpack_require__(56549),
    toInteger = __webpack_require__(20426),
    values = __webpack_require__(61017);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

module.exports = includes;


/***/ }),

/***/ 8957:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseInvoke = __webpack_require__(96023),
    baseRest = __webpack_require__(5125);

/**
 * Invokes the method at `path` of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the method to invoke.
 * @param {...*} [args] The arguments to invoke the method with.
 * @returns {*} Returns the result of the invoked method.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
 *
 * _.invoke(object, 'a[0].b.c.slice', 1, 3);
 * // => [2, 3]
 */
var invoke = baseRest(baseInvoke);

module.exports = invoke;


/***/ }),

/***/ 30353:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsArguments = __webpack_require__(84742),
    isObjectLike = __webpack_require__(55073);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 24669:
/***/ ((module) => {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 47428:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isFunction = __webpack_require__(92042),
    isLength = __webpack_require__(17216);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 57348:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isArrayLike = __webpack_require__(47428),
    isObjectLike = __webpack_require__(55073);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ 61563:
/***/ ((module, exports, __webpack_require__) => {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(29165),
    stubFalse = __webpack_require__(84193);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 82691:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseKeys = __webpack_require__(87473),
    getTag = __webpack_require__(81887),
    isArguments = __webpack_require__(30353),
    isArray = __webpack_require__(24669),
    isArrayLike = __webpack_require__(47428),
    isBuffer = __webpack_require__(61563),
    isPrototype = __webpack_require__(92963),
    isTypedArray = __webpack_require__(73806);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),

/***/ 31223:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsEqual = __webpack_require__(6620);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),

/***/ 92042:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(80732),
    isObject = __webpack_require__(36838);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 96789:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toInteger = __webpack_require__(20426);

/**
 * Checks if `value` is an integer.
 *
 * **Note:** This method is based on
 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
 * @example
 *
 * _.isInteger(3);
 * // => true
 *
 * _.isInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isInteger(Infinity);
 * // => false
 *
 * _.isInteger('3');
 * // => false
 */
function isInteger(value) {
  return typeof value == 'number' && value == toInteger(value);
}

module.exports = isInteger;


/***/ }),

/***/ 17216:
/***/ ((module) => {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 32924:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsMap = __webpack_require__(64033),
    baseUnary = __webpack_require__(58792),
    nodeUtil = __webpack_require__(8478);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),

/***/ 46207:
/***/ ((module) => {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),

/***/ 59933:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(80732),
    isObjectLike = __webpack_require__(55073);

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

module.exports = isNumber;


/***/ }),

/***/ 36838:
/***/ ((module) => {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 55073:
/***/ ((module) => {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 69143:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(80732),
    getPrototype = __webpack_require__(11389),
    isObjectLike = __webpack_require__(55073);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ 45380:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsSet = __webpack_require__(28264),
    baseUnary = __webpack_require__(58792),
    nodeUtil = __webpack_require__(8478);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),

/***/ 56549:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(80732),
    isArray = __webpack_require__(24669),
    isObjectLike = __webpack_require__(55073);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),

/***/ 16764:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(80732),
    isObjectLike = __webpack_require__(55073);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 73806:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsTypedArray = __webpack_require__(22882),
    baseUnary = __webpack_require__(58792),
    nodeUtil = __webpack_require__(8478);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 50579:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayLikeKeys = __webpack_require__(79809),
    baseKeys = __webpack_require__(87473),
    isArrayLike = __webpack_require__(47428);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 37390:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayLikeKeys = __webpack_require__(79809),
    baseKeysIn = __webpack_require__(52506),
    isArrayLike = __webpack_require__(47428);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),

/***/ 25674:
/***/ ((module) => {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),

/***/ 32699:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));


/***/ }),

/***/ 65512:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayMap = __webpack_require__(75697),
    baseIteratee = __webpack_require__(5673),
    baseMap = __webpack_require__(66494),
    isArray = __webpack_require__(24669);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),

/***/ 48347:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseAssignValue = __webpack_require__(30404),
    baseForOwn = __webpack_require__(61343),
    baseIteratee = __webpack_require__(5673);

/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */
function mapKeys(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, iteratee(value, key, object), value);
  });
  return result;
}

module.exports = mapKeys;


/***/ }),

/***/ 34736:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var MapCache = __webpack_require__(9440);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 67929:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseMerge = __webpack_require__(97254),
    createAssigner = __webpack_require__(77991);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),

/***/ 53954:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseMerge = __webpack_require__(97254),
    createAssigner = __webpack_require__(77991);

/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
  baseMerge(object, source, srcIndex, customizer);
});

module.exports = mergeWith;


/***/ }),

/***/ 2226:
/***/ ((module) => {

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */
function negate(predicate) {
  if (typeof predicate != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return function() {
    var args = arguments;
    switch (args.length) {
      case 0: return !predicate.call(this);
      case 1: return !predicate.call(this, args[0]);
      case 2: return !predicate.call(this, args[0], args[1]);
      case 3: return !predicate.call(this, args[0], args[1], args[2]);
    }
    return !predicate.apply(this, args);
  };
}

module.exports = negate;


/***/ }),

/***/ 43226:
/***/ ((module) => {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ 76668:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var root = __webpack_require__(29165);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 59245:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayMap = __webpack_require__(75697),
    baseClone = __webpack_require__(67410),
    baseUnset = __webpack_require__(42933),
    castPath = __webpack_require__(60399),
    copyObject = __webpack_require__(92434),
    customOmitClone = __webpack_require__(59211),
    flatRest = __webpack_require__(54874),
    getAllKeysIn = __webpack_require__(21699);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),

/***/ 24465:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIteratee = __webpack_require__(5673),
    negate = __webpack_require__(2226),
    pickBy = __webpack_require__(12557);

/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */
function omitBy(object, predicate) {
  return pickBy(object, negate(baseIteratee(predicate)));
}

module.exports = omitBy;


/***/ }),

/***/ 19334:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var basePick = __webpack_require__(54822),
    flatRest = __webpack_require__(54874);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),

/***/ 12557:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayMap = __webpack_require__(75697),
    baseIteratee = __webpack_require__(5673),
    basePickBy = __webpack_require__(32648),
    getAllKeysIn = __webpack_require__(21699);

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = arrayMap(getAllKeysIn(object), function(prop) {
    return [prop];
  });
  predicate = baseIteratee(predicate);
  return basePickBy(object, props, function(value, path) {
    return predicate(value, path[0]);
  });
}

module.exports = pickBy;


/***/ }),

/***/ 51798:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseProperty = __webpack_require__(17498),
    basePropertyDeep = __webpack_require__(71000),
    isKey = __webpack_require__(2610),
    toKey = __webpack_require__(77817);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ 6355:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayReduce = __webpack_require__(30695),
    baseEach = __webpack_require__(30438),
    baseIteratee = __webpack_require__(5673),
    baseReduce = __webpack_require__(75857),
    isArray = __webpack_require__(24669);

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;


/***/ }),

/***/ 8207:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayFilter = __webpack_require__(48969),
    baseFilter = __webpack_require__(88286),
    baseIteratee = __webpack_require__(5673),
    isArray = __webpack_require__(24669),
    negate = __webpack_require__(2226);

/**
 * The opposite of `_.filter`; this method returns the elements of `collection`
 * that `predicate` does **not** return truthy for.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.filter
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': true }
 * ];
 *
 * _.reject(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.reject(users, { 'age': 40, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.reject(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.reject(users, 'active');
 * // => objects for ['barney']
 */
function reject(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, negate(baseIteratee(predicate, 3)));
}

module.exports = reject;


/***/ }),

/***/ 35609:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseSet = __webpack_require__(85713);

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),

/***/ 45943:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseSet = __webpack_require__(85713);

/**
 * This method is like `_.set` except that it accepts `customizer` which is
 * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
 * path creation is handled by the method instead. The `customizer` is invoked
 * with three arguments: (nsValue, key, nsObject).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {};
 *
 * _.setWith(object, '[0][1]', 'a', Object);
 * // => { '0': { '1': 'a' } }
 */
function setWith(object, path, value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return object == null ? object : baseSet(object, path, value, customizer);
}

module.exports = setWith;


/***/ }),

/***/ 69113:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var createCompounder = __webpack_require__(51471);

/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */
var snakeCase = createCompounder(function(result, word, index) {
  return result + (index ? '_' : '') + word.toLowerCase();
});

module.exports = snakeCase;


/***/ }),

/***/ 84715:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseFlatten = __webpack_require__(98768),
    baseOrderBy = __webpack_require__(84994),
    baseRest = __webpack_require__(5125),
    isIterateeCall = __webpack_require__(97616);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),

/***/ 47889:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var createCompounder = __webpack_require__(51471),
    upperFirst = __webpack_require__(42950);

/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */
var startCase = createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + upperFirst(word);
});

module.exports = startCase;


/***/ }),

/***/ 68036:
/***/ ((module) => {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 84193:
/***/ ((module) => {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 38209:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var debounce = __webpack_require__(66292),
    isObject = __webpack_require__(36838);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),

/***/ 70986:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toNumber = __webpack_require__(12448);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),

/***/ 20426:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toFinite = __webpack_require__(70986);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),

/***/ 12448:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseTrim = __webpack_require__(33124),
    isObject = __webpack_require__(36838),
    isSymbol = __webpack_require__(16764);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 85111:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var copyObject = __webpack_require__(92434),
    keysIn = __webpack_require__(37390);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),

/***/ 8389:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseToString = __webpack_require__(73150);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 68742:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayEach = __webpack_require__(21662),
    baseCreate = __webpack_require__(91348),
    baseForOwn = __webpack_require__(61343),
    baseIteratee = __webpack_require__(5673),
    getPrototype = __webpack_require__(11389),
    isArray = __webpack_require__(24669),
    isBuffer = __webpack_require__(61563),
    isFunction = __webpack_require__(92042),
    isObject = __webpack_require__(36838),
    isTypedArray = __webpack_require__(73806);

/**
 * An alternative to `_.reduce`; this method transforms `object` to a new
 * `accumulator` object which is the result of running each of its own
 * enumerable string keyed properties thru `iteratee`, with each invocation
 * potentially mutating the `accumulator` object. If `accumulator` is not
 * provided, a new object with the same `[[Prototype]]` will be used. The
 * iteratee is invoked with four arguments: (accumulator, value, key, object).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The custom accumulator value.
 * @returns {*} Returns the accumulated value.
 * @example
 *
 * _.transform([2, 3, 4], function(result, n) {
 *   result.push(n *= n);
 *   return n % 2 == 0;
 * }, []);
 * // => [4, 9]
 *
 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] }
 */
function transform(object, iteratee, accumulator) {
  var isArr = isArray(object),
      isArrLike = isArr || isBuffer(object) || isTypedArray(object);

  iteratee = baseIteratee(iteratee, 4);
  if (accumulator == null) {
    var Ctor = object && object.constructor;
    if (isArrLike) {
      accumulator = isArr ? new Ctor : [];
    }
    else if (isObject(object)) {
      accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
    }
    else {
      accumulator = {};
    }
  }
  (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
    return iteratee(accumulator, value, index, object);
  });
  return accumulator;
}

module.exports = transform;


/***/ }),

/***/ 53274:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toString = __webpack_require__(8389);

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

module.exports = uniqueId;


/***/ }),

/***/ 42950:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var createCaseFirst = __webpack_require__(23684);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),

/***/ 61017:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseValues = __webpack_require__(44290),
    keys = __webpack_require__(50579);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),

/***/ 71055:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var asciiWords = __webpack_require__(81034),
    hasUnicodeWord = __webpack_require__(37854),
    toString = __webpack_require__(8389),
    unicodeWords = __webpack_require__(24155);

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = words;


/***/ }),

/***/ 63385:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var LazyWrapper = __webpack_require__(43933),
    LodashWrapper = __webpack_require__(24868),
    baseLodash = __webpack_require__(35309),
    isArray = __webpack_require__(24669),
    isObjectLike = __webpack_require__(55073),
    wrapperClone = __webpack_require__(24281);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),

/***/ 19404:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";



module.exports = __webpack_require__(73109);


/***/ }),

/***/ 83630:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// HTML5 entities map: { name -> utf16string }
//


/*eslint quotes:0*/
module.exports = __webpack_require__(83992);


/***/ }),

/***/ 57932:
/***/ ((module) => {

"use strict";
// List of valid html blocks names, accorting to commonmark spec
// http://jgm.github.io/CommonMark/spec.html#html-blocks




module.exports = [
  'address',
  'article',
  'aside',
  'base',
  'basefont',
  'blockquote',
  'body',
  'caption',
  'center',
  'col',
  'colgroup',
  'dd',
  'details',
  'dialog',
  'dir',
  'div',
  'dl',
  'dt',
  'fieldset',
  'figcaption',
  'figure',
  'footer',
  'form',
  'frame',
  'frameset',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'head',
  'header',
  'hr',
  'html',
  'iframe',
  'legend',
  'li',
  'link',
  'main',
  'menu',
  'menuitem',
  'nav',
  'noframes',
  'ol',
  'optgroup',
  'option',
  'p',
  'param',
  'section',
  'source',
  'summary',
  'table',
  'tbody',
  'td',
  'tfoot',
  'th',
  'thead',
  'title',
  'tr',
  'track',
  'ul'
];


/***/ }),

/***/ 26517:
/***/ ((module) => {

"use strict";
// Regexps to match html elements



var attr_name     = '[a-zA-Z_:][a-zA-Z0-9:._-]*';

var unquoted      = '[^"\'=<>`\\x00-\\x20]+';
var single_quoted = "'[^']*'";
var double_quoted = '"[^"]*"';

var attr_value  = '(?:' + unquoted + '|' + single_quoted + '|' + double_quoted + ')';

var attribute   = '(?:\\s+' + attr_name + '(?:\\s*=\\s*' + attr_value + ')?)';

var open_tag    = '<[A-Za-z][A-Za-z0-9\\-]*' + attribute + '*\\s*\\/?>';

var close_tag   = '<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>';
var comment     = '<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->';
var processing  = '<[?][\\s\\S]*?[?]>';
var declaration = '<![A-Z]+\\s+[^>]*>';
var cdata       = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>';

var HTML_TAG_RE = new RegExp('^(?:' + open_tag + '|' + close_tag + '|' + comment +
                        '|' + processing + '|' + declaration + '|' + cdata + ')');
var HTML_OPEN_CLOSE_TAG_RE = new RegExp('^(?:' + open_tag + '|' + close_tag + ')');

module.exports.n = HTML_TAG_RE;
module.exports.q = HTML_OPEN_CLOSE_TAG_RE;


/***/ }),

/***/ 26212:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
// Utilities
//



function _class(obj) { return Object.prototype.toString.call(obj); }

function isString(obj) { return _class(obj) === '[object String]'; }

var _hasOwnProperty = Object.prototype.hasOwnProperty;

function has(object, key) {
  return _hasOwnProperty.call(object, key);
}

// Merge objects
//
function assign(obj /*from1, from2, from3, ...*/) {
  var sources = Array.prototype.slice.call(arguments, 1);

  sources.forEach(function (source) {
    if (!source) { return; }

    if (typeof source !== 'object') {
      throw new TypeError(source + 'must be object');
    }

    Object.keys(source).forEach(function (key) {
      obj[key] = source[key];
    });
  });

  return obj;
}

// Remove element from array and put another array at those position.
// Useful for some operations with tokens
function arrayReplaceAt(src, pos, newElements) {
  return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
}

////////////////////////////////////////////////////////////////////////////////

function isValidEntityCode(c) {
  /*eslint no-bitwise:0*/
  // broken sequence
  if (c >= 0xD800 && c <= 0xDFFF) { return false; }
  // never used
  if (c >= 0xFDD0 && c <= 0xFDEF) { return false; }
  if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) { return false; }
  // control codes
  if (c >= 0x00 && c <= 0x08) { return false; }
  if (c === 0x0B) { return false; }
  if (c >= 0x0E && c <= 0x1F) { return false; }
  if (c >= 0x7F && c <= 0x9F) { return false; }
  // out of range
  if (c > 0x10FFFF) { return false; }
  return true;
}

function fromCodePoint(c) {
  /*eslint no-bitwise:0*/
  if (c > 0xffff) {
    c -= 0x10000;
    var surrogate1 = 0xd800 + (c >> 10),
        surrogate2 = 0xdc00 + (c & 0x3ff);

    return String.fromCharCode(surrogate1, surrogate2);
  }
  return String.fromCharCode(c);
}


var UNESCAPE_MD_RE  = /\\([!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~])/g;
var ENTITY_RE       = /&([a-z#][a-z0-9]{1,31});/gi;
var UNESCAPE_ALL_RE = new RegExp(UNESCAPE_MD_RE.source + '|' + ENTITY_RE.source, 'gi');

var DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))/i;

var entities = __webpack_require__(83630);

function replaceEntityPattern(match, name) {
  var code = 0;

  if (has(entities, name)) {
    return entities[name];
  }

  if (name.charCodeAt(0) === 0x23/* # */ && DIGITAL_ENTITY_TEST_RE.test(name)) {
    code = name[1].toLowerCase() === 'x' ?
      parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);

    if (isValidEntityCode(code)) {
      return fromCodePoint(code);
    }
  }

  return match;
}

/*function replaceEntities(str) {
  if (str.indexOf('&') < 0) { return str; }

  return str.replace(ENTITY_RE, replaceEntityPattern);
}*/

function unescapeMd(str) {
  if (str.indexOf('\\') < 0) { return str; }
  return str.replace(UNESCAPE_MD_RE, '$1');
}

function unescapeAll(str) {
  if (str.indexOf('\\') < 0 && str.indexOf('&') < 0) { return str; }

  return str.replace(UNESCAPE_ALL_RE, function (match, escaped, entity) {
    if (escaped) { return escaped; }
    return replaceEntityPattern(match, entity);
  });
}

////////////////////////////////////////////////////////////////////////////////

var HTML_ESCAPE_TEST_RE = /[&<>"]/;
var HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
var HTML_REPLACEMENTS = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;'
};

function replaceUnsafeChar(ch) {
  return HTML_REPLACEMENTS[ch];
}

function escapeHtml(str) {
  if (HTML_ESCAPE_TEST_RE.test(str)) {
    return str.replace(HTML_ESCAPE_REPLACE_RE, replaceUnsafeChar);
  }
  return str;
}

////////////////////////////////////////////////////////////////////////////////

var REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;

function escapeRE(str) {
  return str.replace(REGEXP_ESCAPE_RE, '\\$&');
}

////////////////////////////////////////////////////////////////////////////////

function isSpace(code) {
  switch (code) {
    case 0x09:
    case 0x20:
      return true;
  }
  return false;
}

// Zs (unicode class) || [\t\f\v\r\n]
function isWhiteSpace(code) {
  if (code >= 0x2000 && code <= 0x200A) { return true; }
  switch (code) {
    case 0x09: // \t
    case 0x0A: // \n
    case 0x0B: // \v
    case 0x0C: // \f
    case 0x0D: // \r
    case 0x20:
    case 0xA0:
    case 0x1680:
    case 0x202F:
    case 0x205F:
    case 0x3000:
      return true;
  }
  return false;
}

////////////////////////////////////////////////////////////////////////////////

/*eslint-disable max-len*/
var UNICODE_PUNCT_RE = __webpack_require__(97942);

// Currently without astral characters support.
function isPunctChar(ch) {
  return UNICODE_PUNCT_RE.test(ch);
}


// Markdown ASCII punctuation characters.
//
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
//
// Don't confuse with unicode punctuation !!! It lacks some chars in ascii range.
//
function isMdAsciiPunct(ch) {
  switch (ch) {
    case 0x21/* ! */:
    case 0x22/* " */:
    case 0x23/* # */:
    case 0x24/* $ */:
    case 0x25/* % */:
    case 0x26/* & */:
    case 0x27/* ' */:
    case 0x28/* ( */:
    case 0x29/* ) */:
    case 0x2A/* * */:
    case 0x2B/* + */:
    case 0x2C/* , */:
    case 0x2D/* - */:
    case 0x2E/* . */:
    case 0x2F/* / */:
    case 0x3A/* : */:
    case 0x3B/* ; */:
    case 0x3C/* < */:
    case 0x3D/* = */:
    case 0x3E/* > */:
    case 0x3F/* ? */:
    case 0x40/* @ */:
    case 0x5B/* [ */:
    case 0x5C/* \ */:
    case 0x5D/* ] */:
    case 0x5E/* ^ */:
    case 0x5F/* _ */:
    case 0x60/* ` */:
    case 0x7B/* { */:
    case 0x7C/* | */:
    case 0x7D/* } */:
    case 0x7E/* ~ */:
      return true;
    default:
      return false;
  }
}

// Hepler to unify [reference labels].
//
function normalizeReference(str) {
  // Trim and collapse whitespace
  //
  str = str.trim().replace(/\s+/g, ' ');

  // In node v10 'ẞ'.toLowerCase() === 'Ṿ', which is presumed to be a bug
  // fixed in v12 (couldn't find any details).
  //
  // So treat this one as a special case
  // (remove this when node v10 is no longer supported).
  //
  if ('ẞ'.toLowerCase() === 'Ṿ') {
    str = str.replace(/ẞ/g, 'ß');
  }

  // .toLowerCase().toUpperCase() should get rid of all differences
  // between letter variants.
  //
  // Simple .toLowerCase() doesn't normalize 125 code points correctly,
  // and .toUpperCase doesn't normalize 6 of them (list of exceptions:
  // İ, ϴ, ẞ, Ω, K, Å - those are already uppercased, but have differently
  // uppercased versions).
  //
  // Here's an example showing how it happens. Lets take greek letter omega:
  // uppercase U+0398 (Θ), U+03f4 (ϴ) and lowercase U+03b8 (θ), U+03d1 (ϑ)
  //
  // Unicode entries:
  // 0398;GREEK CAPITAL LETTER THETA;Lu;0;L;;;;;N;;;;03B8;
  // 03B8;GREEK SMALL LETTER THETA;Ll;0;L;;;;;N;;;0398;;0398
  // 03D1;GREEK THETA SYMBOL;Ll;0;L;<compat> 03B8;;;;N;GREEK SMALL LETTER SCRIPT THETA;;0398;;0398
  // 03F4;GREEK CAPITAL THETA SYMBOL;Lu;0;L;<compat> 0398;;;;N;;;;03B8;
  //
  // Case-insensitive comparison should treat all of them as equivalent.
  //
  // But .toLowerCase() doesn't change ϑ (it's already lowercase),
  // and .toUpperCase() doesn't change ϴ (already uppercase).
  //
  // Applying first lower then upper case normalizes any character:
  // '\u0398\u03f4\u03b8\u03d1'.toLowerCase().toUpperCase() === '\u0398\u0398\u0398\u0398'
  //
  // Note: this is equivalent to unicode case folding; unicode normalization
  // is a different step that is not required here.
  //
  // Final result should be uppercased, because it's later stored in an object
  // (this avoid a conflict with Object.prototype members,
  // most notably, `__proto__`)
  //
  return str.toLowerCase().toUpperCase();
}

////////////////////////////////////////////////////////////////////////////////

// Re-export libraries commonly used in both markdown-it and its plugins,
// so plugins won't have to depend on them explicitly, which reduces their
// bundled size (e.g. a browser build).
//
exports.lib                 = {};
exports.lib.mdurl = __webpack_require__(12449);
exports.lib.ucmicro = __webpack_require__(21977);

exports.assign              = assign;
exports.isString            = isString;
exports.has                 = has;
exports.unescapeMd          = unescapeMd;
exports.unescapeAll         = unescapeAll;
exports.isValidEntityCode   = isValidEntityCode;
exports.fromCodePoint       = fromCodePoint;
// exports.replaceEntities     = replaceEntities;
exports.escapeHtml          = escapeHtml;
exports.arrayReplaceAt      = arrayReplaceAt;
exports.isSpace             = isSpace;
exports.isWhiteSpace        = isWhiteSpace;
exports.isMdAsciiPunct      = isMdAsciiPunct;
exports.isPunctChar         = isPunctChar;
exports.escapeRE            = escapeRE;
exports.normalizeReference  = normalizeReference;


/***/ }),

/***/ 29060:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
// Just a shortcut for bulk export



exports.parseLinkLabel = __webpack_require__(78430);
exports.parseLinkDestination = __webpack_require__(87951);
exports.parseLinkTitle = __webpack_require__(63973);


/***/ }),

/***/ 87951:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Parse link destination
//



var unescapeAll = (__webpack_require__(26212).unescapeAll);


module.exports = function parseLinkDestination(str, pos, max) {
  var code, level,
      lines = 0,
      start = pos,
      result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ''
      };

  if (str.charCodeAt(pos) === 0x3C /* < */) {
    pos++;
    while (pos < max) {
      code = str.charCodeAt(pos);
      if (code === 0x0A /* \n */) { return result; }
      if (code === 0x3C /* < */) { return result; }
      if (code === 0x3E /* > */) {
        result.pos = pos + 1;
        result.str = unescapeAll(str.slice(start + 1, pos));
        result.ok = true;
        return result;
      }
      if (code === 0x5C /* \ */ && pos + 1 < max) {
        pos += 2;
        continue;
      }

      pos++;
    }

    // no closing '>'
    return result;
  }

  // this should be ... } else { ... branch

  level = 0;
  while (pos < max) {
    code = str.charCodeAt(pos);

    if (code === 0x20) { break; }

    // ascii control characters
    if (code < 0x20 || code === 0x7F) { break; }

    if (code === 0x5C /* \ */ && pos + 1 < max) {
      if (str.charCodeAt(pos + 1) === 0x20) { break; }
      pos += 2;
      continue;
    }

    if (code === 0x28 /* ( */) {
      level++;
      if (level > 32) { return result; }
    }

    if (code === 0x29 /* ) */) {
      if (level === 0) { break; }
      level--;
    }

    pos++;
  }

  if (start === pos) { return result; }
  if (level !== 0) { return result; }

  result.str = unescapeAll(str.slice(start, pos));
  result.lines = lines;
  result.pos = pos;
  result.ok = true;
  return result;
};


/***/ }),

/***/ 78430:
/***/ ((module) => {

"use strict";
// Parse link label
//
// this function assumes that first character ("[") already matches;
// returns the end of the label
//


module.exports = function parseLinkLabel(state, start, disableNested) {
  var level, found, marker, prevPos,
      labelEnd = -1,
      max = state.posMax,
      oldPos = state.pos;

  state.pos = start + 1;
  level = 1;

  while (state.pos < max) {
    marker = state.src.charCodeAt(state.pos);
    if (marker === 0x5D /* ] */) {
      level--;
      if (level === 0) {
        found = true;
        break;
      }
    }

    prevPos = state.pos;
    state.md.inline.skipToken(state);
    if (marker === 0x5B /* [ */) {
      if (prevPos === state.pos - 1) {
        // increase level if we find text `[`, which is not a part of any token
        level++;
      } else if (disableNested) {
        state.pos = oldPos;
        return -1;
      }
    }
  }

  if (found) {
    labelEnd = state.pos;
  }

  // restore old state
  state.pos = oldPos;

  return labelEnd;
};


/***/ }),

/***/ 63973:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Parse link title
//



var unescapeAll = (__webpack_require__(26212).unescapeAll);


module.exports = function parseLinkTitle(str, pos, max) {
  var code,
      marker,
      lines = 0,
      start = pos,
      result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ''
      };

  if (pos >= max) { return result; }

  marker = str.charCodeAt(pos);

  if (marker !== 0x22 /* " */ && marker !== 0x27 /* ' */ && marker !== 0x28 /* ( */) { return result; }

  pos++;

  // if opening marker is "(", switch it to closing marker ")"
  if (marker === 0x28) { marker = 0x29; }

  while (pos < max) {
    code = str.charCodeAt(pos);
    if (code === marker) {
      result.pos = pos + 1;
      result.lines = lines;
      result.str = unescapeAll(str.slice(start + 1, pos));
      result.ok = true;
      return result;
    } else if (code === 0x28 /* ( */ && marker === 0x29 /* ) */) {
      return result;
    } else if (code === 0x0A) {
      lines++;
    } else if (code === 0x5C /* \ */ && pos + 1 < max) {
      pos++;
      if (str.charCodeAt(pos) === 0x0A) {
        lines++;
      }
    }

    pos++;
  }

  return result;
};


/***/ }),

/***/ 73109:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Main parser class




var utils        = __webpack_require__(26212);
var helpers      = __webpack_require__(29060);
var Renderer     = __webpack_require__(30247);
var ParserCore   = __webpack_require__(54439);
var ParserBlock  = __webpack_require__(95168);
var ParserInline = __webpack_require__(50442);
var LinkifyIt    = __webpack_require__(70870);
var mdurl        = __webpack_require__(12449);
var punycode     = __webpack_require__(70579);


var config = {
  default: __webpack_require__(74333),
  zero: __webpack_require__(29142),
  commonmark: __webpack_require__(43648)
};

////////////////////////////////////////////////////////////////////////////////
//
// This validator can prohibit more than really needed to prevent XSS. It's a
// tradeoff to keep code simple and to be secure by default.
//
// If you need different setup - override validator method as you wish. Or
// replace it with dummy function and use external sanitizer.
//

var BAD_PROTO_RE = /^(vbscript|javascript|file|data):/;
var GOOD_DATA_RE = /^data:image\/(gif|png|jpeg|webp);/;

function validateLink(url) {
  // url should be normalized at this point, and existing entities are decoded
  var str = url.trim().toLowerCase();

  return BAD_PROTO_RE.test(str) ? (GOOD_DATA_RE.test(str) ? true : false) : true;
}

////////////////////////////////////////////////////////////////////////////////


var RECODE_HOSTNAME_FOR = [ 'http:', 'https:', 'mailto:' ];

function normalizeLink(url) {
  var parsed = mdurl.parse(url, true);

  if (parsed.hostname) {
    // Encode hostnames in urls like:
    // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
    //
    // We don't encode unknown schemas, because it's likely that we encode
    // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
    //
    if (!parsed.protocol || RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) {
      try {
        parsed.hostname = punycode.toASCII(parsed.hostname);
      } catch (er) { /**/ }
    }
  }

  return mdurl.encode(mdurl.format(parsed));
}

function normalizeLinkText(url) {
  var parsed = mdurl.parse(url, true);

  if (parsed.hostname) {
    // Encode hostnames in urls like:
    // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
    //
    // We don't encode unknown schemas, because it's likely that we encode
    // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
    //
    if (!parsed.protocol || RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) {
      try {
        parsed.hostname = punycode.toUnicode(parsed.hostname);
      } catch (er) { /**/ }
    }
  }

  // add '%' to exclude list because of https://github.com/markdown-it/markdown-it/issues/720
  return mdurl.decode(mdurl.format(parsed), mdurl.decode.defaultChars + '%');
}


/**
 * class MarkdownIt
 *
 * Main parser/renderer class.
 *
 * ##### Usage
 *
 * ```javascript
 * // node.js, "classic" way:
 * var MarkdownIt = require('markdown-it'),
 *     md = new MarkdownIt();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // node.js, the same, but with sugar:
 * var md = require('markdown-it')();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // browser without AMD, added to "window" on script load
 * // Note, there are no dash.
 * var md = window.markdownit();
 * var result = md.render('# markdown-it rulezz!');
 * ```
 *
 * Single line rendering, without paragraph wrap:
 *
 * ```javascript
 * var md = require('markdown-it')();
 * var result = md.renderInline('__markdown-it__ rulezz!');
 * ```
 **/

/**
 * new MarkdownIt([presetName, options])
 * - presetName (String): optional, `commonmark` / `zero`
 * - options (Object)
 *
 * Creates parser instanse with given config. Can be called without `new`.
 *
 * ##### presetName
 *
 * MarkdownIt provides named presets as a convenience to quickly
 * enable/disable active syntax rules and options for common use cases.
 *
 * - ["commonmark"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/commonmark.js) -
 *   configures parser to strict [CommonMark](http://commonmark.org/) mode.
 * - [default](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/default.js) -
 *   similar to GFM, used when no preset name given. Enables all available rules,
 *   but still without html, typographer & autolinker.
 * - ["zero"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/zero.js) -
 *   all rules disabled. Useful to quickly setup your config via `.enable()`.
 *   For example, when you need only `bold` and `italic` markup and nothing else.
 *
 * ##### options:
 *
 * - __html__ - `false`. Set `true` to enable HTML tags in source. Be careful!
 *   That's not safe! You may need external sanitizer to protect output from XSS.
 *   It's better to extend features via plugins, instead of enabling HTML.
 * - __xhtmlOut__ - `false`. Set `true` to add '/' when closing single tags
 *   (`<br />`). This is needed only for full CommonMark compatibility. In real
 *   world you will need HTML output.
 * - __breaks__ - `false`. Set `true` to convert `\n` in paragraphs into `<br>`.
 * - __langPrefix__ - `language-`. CSS language class prefix for fenced blocks.
 *   Can be useful for external highlighters.
 * - __linkify__ - `false`. Set `true` to autoconvert URL-like text to links.
 * - __typographer__  - `false`. Set `true` to enable [some language-neutral
 *   replacement](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/replacements.js) +
 *   quotes beautification (smartquotes).
 * - __quotes__ - `“”‘’`, String or Array. Double + single quotes replacement
 *   pairs, when typographer enabled and smartquotes on. For example, you can
 *   use `'«»„“'` for Russian, `'„“‚‘'` for German, and
 *   `['«\xA0', '\xA0»', '‹\xA0', '\xA0›']` for French (including nbsp).
 * - __highlight__ - `null`. Highlighter function for fenced code blocks.
 *   Highlighter `function (str, lang)` should return escaped HTML. It can also
 *   return empty string if the source was not changed and should be escaped
 *   externaly. If result starts with <pre... internal wrapper is skipped.
 *
 * ##### Example
 *
 * ```javascript
 * // commonmark mode
 * var md = require('markdown-it')('commonmark');
 *
 * // default mode
 * var md = require('markdown-it')();
 *
 * // enable everything
 * var md = require('markdown-it')({
 *   html: true,
 *   linkify: true,
 *   typographer: true
 * });
 * ```
 *
 * ##### Syntax highlighting
 *
 * ```js
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return hljs.highlight(str, { language: lang, ignoreIllegals: true }).value;
 *       } catch (__) {}
 *     }
 *
 *     return ''; // use external default escaping
 *   }
 * });
 * ```
 *
 * Or with full wrapper override (if you need assign class to `<pre>`):
 *
 * ```javascript
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * // Actual default values
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return '<pre class="hljs"><code>' +
 *                hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
 *                '</code></pre>';
 *       } catch (__) {}
 *     }
 *
 *     return '<pre class="hljs"><code>' + md.utils.escapeHtml(str) + '</code></pre>';
 *   }
 * });
 * ```
 *
 **/
function MarkdownIt(presetName, options) {
  if (!(this instanceof MarkdownIt)) {
    return new MarkdownIt(presetName, options);
  }

  if (!options) {
    if (!utils.isString(presetName)) {
      options = presetName || {};
      presetName = 'default';
    }
  }

  /**
   * MarkdownIt#inline -> ParserInline
   *
   * Instance of [[ParserInline]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/
  this.inline = new ParserInline();

  /**
   * MarkdownIt#block -> ParserBlock
   *
   * Instance of [[ParserBlock]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/
  this.block = new ParserBlock();

  /**
   * MarkdownIt#core -> Core
   *
   * Instance of [[Core]] chain executor. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/
  this.core = new ParserCore();

  /**
   * MarkdownIt#renderer -> Renderer
   *
   * Instance of [[Renderer]]. Use it to modify output look. Or to add rendering
   * rules for new token types, generated by plugins.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * function myToken(tokens, idx, options, env, self) {
   *   //...
   *   return result;
   * };
   *
   * md.renderer.rules['my_token'] = myToken
   * ```
   *
   * See [[Renderer]] docs and [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js).
   **/
  this.renderer = new Renderer();

  /**
   * MarkdownIt#linkify -> LinkifyIt
   *
   * [linkify-it](https://github.com/markdown-it/linkify-it) instance.
   * Used by [linkify](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js)
   * rule.
   **/
  this.linkify = new LinkifyIt();

  /**
   * MarkdownIt#validateLink(url) -> Boolean
   *
   * Link validation function. CommonMark allows too much in links. By default
   * we disable `javascript:`, `vbscript:`, `file:` schemas, and almost all `data:...` schemas
   * except some embedded image types.
   *
   * You can change this behaviour:
   *
   * ```javascript
   * var md = require('markdown-it')();
   * // enable everything
   * md.validateLink = function () { return true; }
   * ```
   **/
  this.validateLink = validateLink;

  /**
   * MarkdownIt#normalizeLink(url) -> String
   *
   * Function used to encode link url to a machine-readable format,
   * which includes url-encoding, punycode, etc.
   **/
  this.normalizeLink = normalizeLink;

  /**
   * MarkdownIt#normalizeLinkText(url) -> String
   *
   * Function used to decode link url to a human-readable format`
   **/
  this.normalizeLinkText = normalizeLinkText;


  // Expose utils & helpers for easy acces from plugins

  /**
   * MarkdownIt#utils -> utils
   *
   * Assorted utility functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/common/utils.js).
   **/
  this.utils = utils;

  /**
   * MarkdownIt#helpers -> helpers
   *
   * Link components parser functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/helpers).
   **/
  this.helpers = utils.assign({}, helpers);


  this.options = {};
  this.configure(presetName);

  if (options) { this.set(options); }
}


/** chainable
 * MarkdownIt.set(options)
 *
 * Set parser options (in the same format as in constructor). Probably, you
 * will never need it, but you can change options after constructor call.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .set({ html: true, breaks: true })
 *             .set({ typographer, true });
 * ```
 *
 * __Note:__ To achieve the best possible performance, don't modify a
 * `markdown-it` instance options on the fly. If you need multiple configurations
 * it's best to create multiple instances and initialize each with separate
 * config.
 **/
MarkdownIt.prototype.set = function (options) {
  utils.assign(this.options, options);
  return this;
};


/** chainable, internal
 * MarkdownIt.configure(presets)
 *
 * Batch load of all options and compenent settings. This is internal method,
 * and you probably will not need it. But if you will - see available presets
 * and data structure [here](https://github.com/markdown-it/markdown-it/tree/master/lib/presets)
 *
 * We strongly recommend to use presets instead of direct config loads. That
 * will give better compatibility with next versions.
 **/
MarkdownIt.prototype.configure = function (presets) {
  var self = this, presetName;

  if (utils.isString(presets)) {
    presetName = presets;
    presets = config[presetName];
    if (!presets) { throw new Error('Wrong `markdown-it` preset "' + presetName + '", check name'); }
  }

  if (!presets) { throw new Error('Wrong `markdown-it` preset, can\'t be empty'); }

  if (presets.options) { self.set(presets.options); }

  if (presets.components) {
    Object.keys(presets.components).forEach(function (name) {
      if (presets.components[name].rules) {
        self[name].ruler.enableOnly(presets.components[name].rules);
      }
      if (presets.components[name].rules2) {
        self[name].ruler2.enableOnly(presets.components[name].rules2);
      }
    });
  }
  return this;
};


/** chainable
 * MarkdownIt.enable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to enable
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable list or rules. It will automatically find appropriate components,
 * containing rules with given names. If rule not found, and `ignoreInvalid`
 * not set - throws exception.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .enable(['sub', 'sup'])
 *             .disable('smartquotes');
 * ```
 **/
MarkdownIt.prototype.enable = function (list, ignoreInvalid) {
  var result = [];

  if (!Array.isArray(list)) { list = [ list ]; }

  [ 'core', 'block', 'inline' ].forEach(function (chain) {
    result = result.concat(this[chain].ruler.enable(list, true));
  }, this);

  result = result.concat(this.inline.ruler2.enable(list, true));

  var missed = list.filter(function (name) { return result.indexOf(name) < 0; });

  if (missed.length && !ignoreInvalid) {
    throw new Error('MarkdownIt. Failed to enable unknown rule(s): ' + missed);
  }

  return this;
};


/** chainable
 * MarkdownIt.disable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * The same as [[MarkdownIt.enable]], but turn specified rules off.
 **/
MarkdownIt.prototype.disable = function (list, ignoreInvalid) {
  var result = [];

  if (!Array.isArray(list)) { list = [ list ]; }

  [ 'core', 'block', 'inline' ].forEach(function (chain) {
    result = result.concat(this[chain].ruler.disable(list, true));
  }, this);

  result = result.concat(this.inline.ruler2.disable(list, true));

  var missed = list.filter(function (name) { return result.indexOf(name) < 0; });

  if (missed.length && !ignoreInvalid) {
    throw new Error('MarkdownIt. Failed to disable unknown rule(s): ' + missed);
  }
  return this;
};


/** chainable
 * MarkdownIt.use(plugin, params)
 *
 * Load specified plugin with given params into current parser instance.
 * It's just a sugar to call `plugin(md, params)` with curring.
 *
 * ##### Example
 *
 * ```javascript
 * var iterator = require('markdown-it-for-inline');
 * var md = require('markdown-it')()
 *             .use(iterator, 'foo_replace', 'text', function (tokens, idx) {
 *               tokens[idx].content = tokens[idx].content.replace(/foo/g, 'bar');
 *             });
 * ```
 **/
MarkdownIt.prototype.use = function (plugin /*, params, ... */) {
  var args = [ this ].concat(Array.prototype.slice.call(arguments, 1));
  plugin.apply(plugin, args);
  return this;
};


/** internal
 * MarkdownIt.parse(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Parse input string and return list of block tokens (special token type
 * "inline" will contain list of inline tokens). You should not call this
 * method directly, until you write custom renderer (for example, to produce
 * AST).
 *
 * `env` is used to pass data between "distributed" rules and return additional
 * metadata like reference info, needed for the renderer. It also can be used to
 * inject data in specific cases. Usually, you will be ok to pass `{}`,
 * and then pass updated object to renderer.
 **/
MarkdownIt.prototype.parse = function (src, env) {
  if (typeof src !== 'string') {
    throw new Error('Input data should be a String');
  }

  var state = new this.core.State(src, this, env);

  this.core.process(state);

  return state.tokens;
};


/**
 * MarkdownIt.render(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Render markdown string into html. It does all magic for you :).
 *
 * `env` can be used to inject additional metadata (`{}` by default).
 * But you will not need it with high probability. See also comment
 * in [[MarkdownIt.parse]].
 **/
MarkdownIt.prototype.render = function (src, env) {
  env = env || {};

  return this.renderer.render(this.parse(src, env), this.options, env);
};


/** internal
 * MarkdownIt.parseInline(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * The same as [[MarkdownIt.parse]] but skip all block rules. It returns the
 * block tokens list with the single `inline` element, containing parsed inline
 * tokens in `children` property. Also updates `env` object.
 **/
MarkdownIt.prototype.parseInline = function (src, env) {
  var state = new this.core.State(src, this, env);

  state.inlineMode = true;
  this.core.process(state);

  return state.tokens;
};


/**
 * MarkdownIt.renderInline(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Similar to [[MarkdownIt.render]] but for single paragraph content. Result
 * will NOT be wrapped into `<p>` tags.
 **/
MarkdownIt.prototype.renderInline = function (src, env) {
  env = env || {};

  return this.renderer.render(this.parseInline(src, env), this.options, env);
};


module.exports = MarkdownIt;


/***/ }),

/***/ 95168:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/** internal
 * class ParserBlock
 *
 * Block-level tokenizer.
 **/



var Ruler           = __webpack_require__(81284);


var _rules = [
  // First 2 params - rule name & source. Secondary array - list of rules,
  // which can be terminated by this one.
  [ 'table',      __webpack_require__(83010),      [ 'paragraph', 'reference' ] ],
  [ 'code',       __webpack_require__(75740) ],
  [ 'fence',      __webpack_require__(10130),      [ 'paragraph', 'reference', 'blockquote', 'list' ] ],
  [ 'blockquote', __webpack_require__(74599), [ 'paragraph', 'reference', 'blockquote', 'list' ] ],
  [ 'hr',         __webpack_require__(17242),         [ 'paragraph', 'reference', 'blockquote', 'list' ] ],
  [ 'list',       __webpack_require__(3557),       [ 'paragraph', 'reference', 'blockquote' ] ],
  [ 'reference',  __webpack_require__(2534) ],
  [ 'html_block', __webpack_require__(29690), [ 'paragraph', 'reference', 'blockquote' ] ],
  [ 'heading',    __webpack_require__(40899),    [ 'paragraph', 'reference', 'blockquote' ] ],
  [ 'lheading',   __webpack_require__(76091) ],
  [ 'paragraph',  __webpack_require__(37370) ]
];


/**
 * new ParserBlock()
 **/
function ParserBlock() {
  /**
   * ParserBlock#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of block rules.
   **/
  this.ruler = new Ruler();

  for (var i = 0; i < _rules.length; i++) {
    this.ruler.push(_rules[i][0], _rules[i][1], { alt: (_rules[i][2] || []).slice() });
  }
}


// Generate tokens for input range
//
ParserBlock.prototype.tokenize = function (state, startLine, endLine) {
  var ok, i,
      rules = this.ruler.getRules(''),
      len = rules.length,
      line = startLine,
      hasEmptyLines = false,
      maxNesting = state.md.options.maxNesting;

  while (line < endLine) {
    state.line = line = state.skipEmptyLines(line);
    if (line >= endLine) { break; }

    // Termination condition for nested calls.
    // Nested calls currently used for blockquotes & lists
    if (state.sCount[line] < state.blkIndent) { break; }

    // If nesting level exceeded - skip tail to the end. That's not ordinary
    // situation and we should not care about content.
    if (state.level >= maxNesting) {
      state.line = endLine;
      break;
    }

    // Try all possible rules.
    // On success, rule should:
    //
    // - update `state.line`
    // - update `state.tokens`
    // - return true

    for (i = 0; i < len; i++) {
      ok = rules[i](state, line, endLine, false);
      if (ok) { break; }
    }

    // set state.tight if we had an empty line before current tag
    // i.e. latest empty line should not count
    state.tight = !hasEmptyLines;

    // paragraph might "eat" one newline after it in nested lists
    if (state.isEmpty(state.line - 1)) {
      hasEmptyLines = true;
    }

    line = state.line;

    if (line < endLine && state.isEmpty(line)) {
      hasEmptyLines = true;
      line++;
      state.line = line;
    }
  }
};


/**
 * ParserBlock.parse(str, md, env, outTokens)
 *
 * Process input string and push block tokens into `outTokens`
 **/
ParserBlock.prototype.parse = function (src, md, env, outTokens) {
  var state;

  if (!src) { return; }

  state = new this.State(src, md, env, outTokens);

  this.tokenize(state, state.line, state.lineMax);
};


ParserBlock.prototype.State = __webpack_require__(49677);


module.exports = ParserBlock;


/***/ }),

/***/ 54439:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/** internal
 * class Core
 *
 * Top-level rules executor. Glues block/inline parsers and does intermediate
 * transformations.
 **/



var Ruler  = __webpack_require__(81284);


var _rules = [
  [ 'normalize',      __webpack_require__(75272)      ],
  [ 'block',          __webpack_require__(84965)          ],
  [ 'inline',         __webpack_require__(80458)         ],
  [ 'linkify',        __webpack_require__(68961)        ],
  [ 'replacements',   __webpack_require__(30806)   ],
  [ 'smartquotes',    __webpack_require__(62839)    ]
];


/**
 * new Core()
 **/
function Core() {
  /**
   * Core#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of core rules.
   **/
  this.ruler = new Ruler();

  for (var i = 0; i < _rules.length; i++) {
    this.ruler.push(_rules[i][0], _rules[i][1]);
  }
}


/**
 * Core.process(state)
 *
 * Executes core chain rules.
 **/
Core.prototype.process = function (state) {
  var i, l, rules;

  rules = this.ruler.getRules('');

  for (i = 0, l = rules.length; i < l; i++) {
    rules[i](state);
  }
};

Core.prototype.State = __webpack_require__(67681);


module.exports = Core;


/***/ }),

/***/ 50442:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/** internal
 * class ParserInline
 *
 * Tokenizes paragraph content.
 **/



var Ruler           = __webpack_require__(81284);


////////////////////////////////////////////////////////////////////////////////
// Parser rules

var _rules = [
  [ 'text',            __webpack_require__(11854) ],
  [ 'newline',         __webpack_require__(40183) ],
  [ 'escape',          __webpack_require__(95674) ],
  [ 'backticks',       __webpack_require__(5691) ],
  [ 'strikethrough',   (__webpack_require__(26472)/* .tokenize */ .w) ],
  [ 'emphasis',        (__webpack_require__(36522)/* .tokenize */ .w) ],
  [ 'link',            __webpack_require__(70027) ],
  [ 'image',           __webpack_require__(29192) ],
  [ 'autolink',        __webpack_require__(34627) ],
  [ 'html_inline',     __webpack_require__(97845) ],
  [ 'entity',          __webpack_require__(72105) ]
];

var _rules2 = [
  [ 'balance_pairs',   __webpack_require__(40469) ],
  [ 'strikethrough',   (__webpack_require__(26472)/* .postProcess */ .g) ],
  [ 'emphasis',        (__webpack_require__(36522)/* .postProcess */ .g) ],
  [ 'text_collapse',   __webpack_require__(83514) ]
];


/**
 * new ParserInline()
 **/
function ParserInline() {
  var i;

  /**
   * ParserInline#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of inline rules.
   **/
  this.ruler = new Ruler();

  for (i = 0; i < _rules.length; i++) {
    this.ruler.push(_rules[i][0], _rules[i][1]);
  }

  /**
   * ParserInline#ruler2 -> Ruler
   *
   * [[Ruler]] instance. Second ruler used for post-processing
   * (e.g. in emphasis-like rules).
   **/
  this.ruler2 = new Ruler();

  for (i = 0; i < _rules2.length; i++) {
    this.ruler2.push(_rules2[i][0], _rules2[i][1]);
  }
}


// Skip single token by running all rules in validation mode;
// returns `true` if any rule reported success
//
ParserInline.prototype.skipToken = function (state) {
  var ok, i, pos = state.pos,
      rules = this.ruler.getRules(''),
      len = rules.length,
      maxNesting = state.md.options.maxNesting,
      cache = state.cache;


  if (typeof cache[pos] !== 'undefined') {
    state.pos = cache[pos];
    return;
  }

  if (state.level < maxNesting) {
    for (i = 0; i < len; i++) {
      // Increment state.level and decrement it later to limit recursion.
      // It's harmless to do here, because no tokens are created. But ideally,
      // we'd need a separate private state variable for this purpose.
      //
      state.level++;
      ok = rules[i](state, true);
      state.level--;

      if (ok) { break; }
    }
  } else {
    // Too much nesting, just skip until the end of the paragraph.
    //
    // NOTE: this will cause links to behave incorrectly in the following case,
    //       when an amount of `[` is exactly equal to `maxNesting + 1`:
    //
    //       [[[[[[[[[[[[[[[[[[[[[foo]()
    //
    // TODO: remove this workaround when CM standard will allow nested links
    //       (we can replace it by preventing links from being parsed in
    //       validation mode)
    //
    state.pos = state.posMax;
  }

  if (!ok) { state.pos++; }
  cache[pos] = state.pos;
};


// Generate tokens for input range
//
ParserInline.prototype.tokenize = function (state) {
  var ok, i,
      rules = this.ruler.getRules(''),
      len = rules.length,
      end = state.posMax,
      maxNesting = state.md.options.maxNesting;

  while (state.pos < end) {
    // Try all possible rules.
    // On success, rule should:
    //
    // - update `state.pos`
    // - update `state.tokens`
    // - return true

    if (state.level < maxNesting) {
      for (i = 0; i < len; i++) {
        ok = rules[i](state, false);
        if (ok) { break; }
      }
    }

    if (ok) {
      if (state.pos >= end) { break; }
      continue;
    }

    state.pending += state.src[state.pos++];
  }

  if (state.pending) {
    state.pushPending();
  }
};


/**
 * ParserInline.parse(str, md, env, outTokens)
 *
 * Process input string and push inline tokens into `outTokens`
 **/
ParserInline.prototype.parse = function (str, md, env, outTokens) {
  var i, rules, len;
  var state = new this.State(str, md, env, outTokens);

  this.tokenize(state);

  rules = this.ruler2.getRules('');
  len = rules.length;

  for (i = 0; i < len; i++) {
    rules[i](state);
  }
};


ParserInline.prototype.State = __webpack_require__(62418);


module.exports = ParserInline;


/***/ }),

/***/ 43648:
/***/ ((module) => {

"use strict";
// Commonmark default options




module.exports = {
  options: {
    html:         true,         // Enable HTML tags in source
    xhtmlOut:     true,         // Use '/' to close single tags (<br />)
    breaks:       false,        // Convert '\n' in paragraphs into <br>
    langPrefix:   'language-',  // CSS language prefix for fenced blocks
    linkify:      false,        // autoconvert URL-like texts to links

    // Enable some language-neutral replacements + quotes beautification
    typographer:  false,

    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: '\u201c\u201d\u2018\u2019', /* “”‘’ */

    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,

    maxNesting:   20            // Internal protection, recursion limit
  },

  components: {

    core: {
      rules: [
        'normalize',
        'block',
        'inline'
      ]
    },

    block: {
      rules: [
        'blockquote',
        'code',
        'fence',
        'heading',
        'hr',
        'html_block',
        'lheading',
        'list',
        'reference',
        'paragraph'
      ]
    },

    inline: {
      rules: [
        'autolink',
        'backticks',
        'emphasis',
        'entity',
        'escape',
        'html_inline',
        'image',
        'link',
        'newline',
        'text'
      ],
      rules2: [
        'balance_pairs',
        'emphasis',
        'text_collapse'
      ]
    }
  }
};


/***/ }),

/***/ 74333:
/***/ ((module) => {

"use strict";
// markdown-it default options




module.exports = {
  options: {
    html:         false,        // Enable HTML tags in source
    xhtmlOut:     false,        // Use '/' to close single tags (<br />)
    breaks:       false,        // Convert '\n' in paragraphs into <br>
    langPrefix:   'language-',  // CSS language prefix for fenced blocks
    linkify:      false,        // autoconvert URL-like texts to links

    // Enable some language-neutral replacements + quotes beautification
    typographer:  false,

    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: '\u201c\u201d\u2018\u2019', /* “”‘’ */

    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,

    maxNesting:   100            // Internal protection, recursion limit
  },

  components: {

    core: {},
    block: {},
    inline: {}
  }
};


/***/ }),

/***/ 29142:
/***/ ((module) => {

"use strict";
// "Zero" preset, with nothing enabled. Useful for manual configuring of simple
// modes. For example, to parse bold/italic only.




module.exports = {
  options: {
    html:         false,        // Enable HTML tags in source
    xhtmlOut:     false,        // Use '/' to close single tags (<br />)
    breaks:       false,        // Convert '\n' in paragraphs into <br>
    langPrefix:   'language-',  // CSS language prefix for fenced blocks
    linkify:      false,        // autoconvert URL-like texts to links

    // Enable some language-neutral replacements + quotes beautification
    typographer:  false,

    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: '\u201c\u201d\u2018\u2019', /* “”‘’ */

    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,

    maxNesting:   20            // Internal protection, recursion limit
  },

  components: {

    core: {
      rules: [
        'normalize',
        'block',
        'inline'
      ]
    },

    block: {
      rules: [
        'paragraph'
      ]
    },

    inline: {
      rules: [
        'text'
      ],
      rules2: [
        'balance_pairs',
        'text_collapse'
      ]
    }
  }
};


/***/ }),

/***/ 30247:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/**
 * class Renderer
 *
 * Generates HTML from parsed token stream. Each instance has independent
 * copy of rules. Those can be rewritten with ease. Also, you can add new
 * rules if you create plugin and adds new token types.
 **/



var assign          = (__webpack_require__(26212).assign);
var unescapeAll     = (__webpack_require__(26212).unescapeAll);
var escapeHtml      = (__webpack_require__(26212).escapeHtml);


////////////////////////////////////////////////////////////////////////////////

var default_rules = {};


default_rules.code_inline = function (tokens, idx, options, env, slf) {
  var token = tokens[idx];

  return  '<code' + slf.renderAttrs(token) + '>' +
          escapeHtml(tokens[idx].content) +
          '</code>';
};


default_rules.code_block = function (tokens, idx, options, env, slf) {
  var token = tokens[idx];

  return  '<pre' + slf.renderAttrs(token) + '><code>' +
          escapeHtml(tokens[idx].content) +
          '</code></pre>\n';
};


default_rules.fence = function (tokens, idx, options, env, slf) {
  var token = tokens[idx],
      info = token.info ? unescapeAll(token.info).trim() : '',
      langName = '',
      langAttrs = '',
      highlighted, i, arr, tmpAttrs, tmpToken;

  if (info) {
    arr = info.split(/(\s+)/g);
    langName = arr[0];
    langAttrs = arr.slice(2).join('');
  }

  if (options.highlight) {
    highlighted = options.highlight(token.content, langName, langAttrs) || escapeHtml(token.content);
  } else {
    highlighted = escapeHtml(token.content);
  }

  if (highlighted.indexOf('<pre') === 0) {
    return highlighted + '\n';
  }

  // If language exists, inject class gently, without modifying original token.
  // May be, one day we will add .deepClone() for token and simplify this part, but
  // now we prefer to keep things local.
  if (info) {
    i        = token.attrIndex('class');
    tmpAttrs = token.attrs ? token.attrs.slice() : [];

    if (i < 0) {
      tmpAttrs.push([ 'class', options.langPrefix + langName ]);
    } else {
      tmpAttrs[i] = tmpAttrs[i].slice();
      tmpAttrs[i][1] += ' ' + options.langPrefix + langName;
    }

    // Fake token just to render attributes
    tmpToken = {
      attrs: tmpAttrs
    };

    return  '<pre><code' + slf.renderAttrs(tmpToken) + '>'
          + highlighted
          + '</code></pre>\n';
  }


  return  '<pre><code' + slf.renderAttrs(token) + '>'
        + highlighted
        + '</code></pre>\n';
};


default_rules.image = function (tokens, idx, options, env, slf) {
  var token = tokens[idx];

  // "alt" attr MUST be set, even if empty. Because it's mandatory and
  // should be placed on proper position for tests.
  //
  // Replace content with actual value

  token.attrs[token.attrIndex('alt')][1] =
    slf.renderInlineAsText(token.children, options, env);

  return slf.renderToken(tokens, idx, options);
};


default_rules.hardbreak = function (tokens, idx, options /*, env */) {
  return options.xhtmlOut ? '<br />\n' : '<br>\n';
};
default_rules.softbreak = function (tokens, idx, options /*, env */) {
  return options.breaks ? (options.xhtmlOut ? '<br />\n' : '<br>\n') : '\n';
};


default_rules.text = function (tokens, idx /*, options, env */) {
  return escapeHtml(tokens[idx].content);
};


default_rules.html_block = function (tokens, idx /*, options, env */) {
  return tokens[idx].content;
};
default_rules.html_inline = function (tokens, idx /*, options, env */) {
  return tokens[idx].content;
};


/**
 * new Renderer()
 *
 * Creates new [[Renderer]] instance and fill [[Renderer#rules]] with defaults.
 **/
function Renderer() {

  /**
   * Renderer#rules -> Object
   *
   * Contains render rules for tokens. Can be updated and extended.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * md.renderer.rules.strong_open  = function () { return '<b>'; };
   * md.renderer.rules.strong_close = function () { return '</b>'; };
   *
   * var result = md.renderInline(...);
   * ```
   *
   * Each rule is called as independent static function with fixed signature:
   *
   * ```javascript
   * function my_token_render(tokens, idx, options, env, renderer) {
   *   // ...
   *   return renderedHTML;
   * }
   * ```
   *
   * See [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js)
   * for more details and examples.
   **/
  this.rules = assign({}, default_rules);
}


/**
 * Renderer.renderAttrs(token) -> String
 *
 * Render token attributes to string.
 **/
Renderer.prototype.renderAttrs = function renderAttrs(token) {
  var i, l, result;

  if (!token.attrs) { return ''; }

  result = '';

  for (i = 0, l = token.attrs.length; i < l; i++) {
    result += ' ' + escapeHtml(token.attrs[i][0]) + '="' + escapeHtml(token.attrs[i][1]) + '"';
  }

  return result;
};


/**
 * Renderer.renderToken(tokens, idx, options) -> String
 * - tokens (Array): list of tokens
 * - idx (Numbed): token index to render
 * - options (Object): params of parser instance
 *
 * Default token renderer. Can be overriden by custom function
 * in [[Renderer#rules]].
 **/
Renderer.prototype.renderToken = function renderToken(tokens, idx, options) {
  var nextToken,
      result = '',
      needLf = false,
      token = tokens[idx];

  // Tight list paragraphs
  if (token.hidden) {
    return '';
  }

  // Insert a newline between hidden paragraph and subsequent opening
  // block-level tag.
  //
  // For example, here we should insert a newline before blockquote:
  //  - a
  //    >
  //
  if (token.block && token.nesting !== -1 && idx && tokens[idx - 1].hidden) {
    result += '\n';
  }

  // Add token name, e.g. `<img`
  result += (token.nesting === -1 ? '</' : '<') + token.tag;

  // Encode attributes, e.g. `<img src="foo"`
  result += this.renderAttrs(token);

  // Add a slash for self-closing tags, e.g. `<img src="foo" /`
  if (token.nesting === 0 && options.xhtmlOut) {
    result += ' /';
  }

  // Check if we need to add a newline after this tag
  if (token.block) {
    needLf = true;

    if (token.nesting === 1) {
      if (idx + 1 < tokens.length) {
        nextToken = tokens[idx + 1];

        if (nextToken.type === 'inline' || nextToken.hidden) {
          // Block-level tag containing an inline tag.
          //
          needLf = false;

        } else if (nextToken.nesting === -1 && nextToken.tag === token.tag) {
          // Opening tag + closing tag of the same type. E.g. `<li></li>`.
          //
          needLf = false;
        }
      }
    }
  }

  result += needLf ? '>\n' : '>';

  return result;
};


/**
 * Renderer.renderInline(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to renter
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * The same as [[Renderer.render]], but for single token of `inline` type.
 **/
Renderer.prototype.renderInline = function (tokens, options, env) {
  var type,
      result = '',
      rules = this.rules;

  for (var i = 0, len = tokens.length; i < len; i++) {
    type = tokens[i].type;

    if (typeof rules[type] !== 'undefined') {
      result += rules[type](tokens, i, options, env, this);
    } else {
      result += this.renderToken(tokens, i, options);
    }
  }

  return result;
};


/** internal
 * Renderer.renderInlineAsText(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to renter
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Special kludge for image `alt` attributes to conform CommonMark spec.
 * Don't try to use it! Spec requires to show `alt` content with stripped markup,
 * instead of simple escaping.
 **/
Renderer.prototype.renderInlineAsText = function (tokens, options, env) {
  var result = '';

  for (var i = 0, len = tokens.length; i < len; i++) {
    if (tokens[i].type === 'text') {
      result += tokens[i].content;
    } else if (tokens[i].type === 'image') {
      result += this.renderInlineAsText(tokens[i].children, options, env);
    } else if (tokens[i].type === 'softbreak') {
      result += '\n';
    }
  }

  return result;
};


/**
 * Renderer.render(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to renter
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Takes token stream and generates HTML. Probably, you will never need to call
 * this method directly.
 **/
Renderer.prototype.render = function (tokens, options, env) {
  var i, len, type,
      result = '',
      rules = this.rules;

  for (i = 0, len = tokens.length; i < len; i++) {
    type = tokens[i].type;

    if (type === 'inline') {
      result += this.renderInline(tokens[i].children, options, env);
    } else if (typeof rules[type] !== 'undefined') {
      result += rules[tokens[i].type](tokens, i, options, env, this);
    } else {
      result += this.renderToken(tokens, i, options, env);
    }
  }

  return result;
};

module.exports = Renderer;


/***/ }),

/***/ 81284:
/***/ ((module) => {

"use strict";
/**
 * class Ruler
 *
 * Helper class, used by [[MarkdownIt#core]], [[MarkdownIt#block]] and
 * [[MarkdownIt#inline]] to manage sequences of functions (rules):
 *
 * - keep rules in defined order
 * - assign the name to each rule
 * - enable/disable rules
 * - add/replace rules
 * - allow assign rules to additional named chains (in the same)
 * - cacheing lists of active rules
 *
 * You will not need use this class directly until write plugins. For simple
 * rules control use [[MarkdownIt.disable]], [[MarkdownIt.enable]] and
 * [[MarkdownIt.use]].
 **/



/**
 * new Ruler()
 **/
function Ruler() {
  // List of added rules. Each element is:
  //
  // {
  //   name: XXX,
  //   enabled: Boolean,
  //   fn: Function(),
  //   alt: [ name2, name3 ]
  // }
  //
  this.__rules__ = [];

  // Cached rule chains.
  //
  // First level - chain name, '' for default.
  // Second level - diginal anchor for fast filtering by charcodes.
  //
  this.__cache__ = null;
}

////////////////////////////////////////////////////////////////////////////////
// Helper methods, should not be used directly


// Find rule index by name
//
Ruler.prototype.__find__ = function (name) {
  for (var i = 0; i < this.__rules__.length; i++) {
    if (this.__rules__[i].name === name) {
      return i;
    }
  }
  return -1;
};


// Build rules lookup cache
//
Ruler.prototype.__compile__ = function () {
  var self = this;
  var chains = [ '' ];

  // collect unique names
  self.__rules__.forEach(function (rule) {
    if (!rule.enabled) { return; }

    rule.alt.forEach(function (altName) {
      if (chains.indexOf(altName) < 0) {
        chains.push(altName);
      }
    });
  });

  self.__cache__ = {};

  chains.forEach(function (chain) {
    self.__cache__[chain] = [];
    self.__rules__.forEach(function (rule) {
      if (!rule.enabled) { return; }

      if (chain && rule.alt.indexOf(chain) < 0) { return; }

      self.__cache__[chain].push(rule.fn);
    });
  });
};


/**
 * Ruler.at(name, fn [, options])
 * - name (String): rule name to replace.
 * - fn (Function): new rule function.
 * - options (Object): new rule options (not mandatory).
 *
 * Replace rule by name with new function & options. Throws error if name not
 * found.
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * Replace existing typographer replacement rule with new one:
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.at('replacements', function replace(state) {
 *   //...
 * });
 * ```
 **/
Ruler.prototype.at = function (name, fn, options) {
  var index = this.__find__(name);
  var opt = options || {};

  if (index === -1) { throw new Error('Parser rule not found: ' + name); }

  this.__rules__[index].fn = fn;
  this.__rules__[index].alt = opt.alt || [];
  this.__cache__ = null;
};


/**
 * Ruler.before(beforeName, ruleName, fn [, options])
 * - beforeName (String): new rule will be added before this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain before one with given name. See also
 * [[Ruler.after]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.block.ruler.before('paragraph', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/
Ruler.prototype.before = function (beforeName, ruleName, fn, options) {
  var index = this.__find__(beforeName);
  var opt = options || {};

  if (index === -1) { throw new Error('Parser rule not found: ' + beforeName); }

  this.__rules__.splice(index, 0, {
    name: ruleName,
    enabled: true,
    fn: fn,
    alt: opt.alt || []
  });

  this.__cache__ = null;
};


/**
 * Ruler.after(afterName, ruleName, fn [, options])
 * - afterName (String): new rule will be added after this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain after one with given name. See also
 * [[Ruler.before]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.inline.ruler.after('text', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/
Ruler.prototype.after = function (afterName, ruleName, fn, options) {
  var index = this.__find__(afterName);
  var opt = options || {};

  if (index === -1) { throw new Error('Parser rule not found: ' + afterName); }

  this.__rules__.splice(index + 1, 0, {
    name: ruleName,
    enabled: true,
    fn: fn,
    alt: opt.alt || []
  });

  this.__cache__ = null;
};

/**
 * Ruler.push(ruleName, fn [, options])
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Push new rule to the end of chain. See also
 * [[Ruler.before]], [[Ruler.after]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.push('my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/
Ruler.prototype.push = function (ruleName, fn, options) {
  var opt = options || {};

  this.__rules__.push({
    name: ruleName,
    enabled: true,
    fn: fn,
    alt: opt.alt || []
  });

  this.__cache__ = null;
};


/**
 * Ruler.enable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to enable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.disable]], [[Ruler.enableOnly]].
 **/
Ruler.prototype.enable = function (list, ignoreInvalid) {
  if (!Array.isArray(list)) { list = [ list ]; }

  var result = [];

  // Search by name and enable
  list.forEach(function (name) {
    var idx = this.__find__(name);

    if (idx < 0) {
      if (ignoreInvalid) { return; }
      throw new Error('Rules manager: invalid rule name ' + name);
    }
    this.__rules__[idx].enabled = true;
    result.push(name);
  }, this);

  this.__cache__ = null;
  return result;
};


/**
 * Ruler.enableOnly(list [, ignoreInvalid])
 * - list (String|Array): list of rule names to enable (whitelist).
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names, and disable everything else. If any rule name
 * not found - throw Error. Errors can be disabled by second param.
 *
 * See also [[Ruler.disable]], [[Ruler.enable]].
 **/
Ruler.prototype.enableOnly = function (list, ignoreInvalid) {
  if (!Array.isArray(list)) { list = [ list ]; }

  this.__rules__.forEach(function (rule) { rule.enabled = false; });

  this.enable(list, ignoreInvalid);
};


/**
 * Ruler.disable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Disable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.enable]], [[Ruler.enableOnly]].
 **/
Ruler.prototype.disable = function (list, ignoreInvalid) {
  if (!Array.isArray(list)) { list = [ list ]; }

  var result = [];

  // Search by name and disable
  list.forEach(function (name) {
    var idx = this.__find__(name);

    if (idx < 0) {
      if (ignoreInvalid) { return; }
      throw new Error('Rules manager: invalid rule name ' + name);
    }
    this.__rules__[idx].enabled = false;
    result.push(name);
  }, this);

  this.__cache__ = null;
  return result;
};


/**
 * Ruler.getRules(chainName) -> Array
 *
 * Return array of active functions (rules) for given chain name. It analyzes
 * rules configuration, compiles caches if not exists and returns result.
 *
 * Default chain name is `''` (empty string). It can't be skipped. That's
 * done intentionally, to keep signature monomorphic for high speed.
 **/
Ruler.prototype.getRules = function (chainName) {
  if (this.__cache__ === null) {
    this.__compile__();
  }

  // Chain can be empty, if rules disabled. But we still have to return Array.
  return this.__cache__[chainName] || [];
};

module.exports = Ruler;


/***/ }),

/***/ 74599:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Block quotes



var isSpace = (__webpack_require__(26212).isSpace);


module.exports = function blockquote(state, startLine, endLine, silent) {
  var adjustTab,
      ch,
      i,
      initial,
      l,
      lastLineEmpty,
      lines,
      nextLine,
      offset,
      oldBMarks,
      oldBSCount,
      oldIndent,
      oldParentType,
      oldSCount,
      oldTShift,
      spaceAfterMarker,
      terminate,
      terminatorRules,
      token,
      isOutdented,
      oldLineMax = state.lineMax,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) { return false; }

  // check the block quote marker
  if (state.src.charCodeAt(pos++) !== 0x3E/* > */) { return false; }

  // we know that it's going to be a valid blockquote,
  // so no point trying to find the end of it in silent mode
  if (silent) { return true; }

  // set offset past spaces and ">"
  initial = offset = state.sCount[startLine] + 1;

  // skip one optional space after '>'
  if (state.src.charCodeAt(pos) === 0x20 /* space */) {
    // ' >   test '
    //     ^ -- position start of line here:
    pos++;
    initial++;
    offset++;
    adjustTab = false;
    spaceAfterMarker = true;
  } else if (state.src.charCodeAt(pos) === 0x09 /* tab */) {
    spaceAfterMarker = true;

    if ((state.bsCount[startLine] + offset) % 4 === 3) {
      // '  >\t  test '
      //       ^ -- position start of line here (tab has width===1)
      pos++;
      initial++;
      offset++;
      adjustTab = false;
    } else {
      // ' >\t  test '
      //    ^ -- position start of line here + shift bsCount slightly
      //         to make extra space appear
      adjustTab = true;
    }
  } else {
    spaceAfterMarker = false;
  }

  oldBMarks = [ state.bMarks[startLine] ];
  state.bMarks[startLine] = pos;

  while (pos < max) {
    ch = state.src.charCodeAt(pos);

    if (isSpace(ch)) {
      if (ch === 0x09) {
        offset += 4 - (offset + state.bsCount[startLine] + (adjustTab ? 1 : 0)) % 4;
      } else {
        offset++;
      }
    } else {
      break;
    }

    pos++;
  }

  oldBSCount = [ state.bsCount[startLine] ];
  state.bsCount[startLine] = state.sCount[startLine] + 1 + (spaceAfterMarker ? 1 : 0);

  lastLineEmpty = pos >= max;

  oldSCount = [ state.sCount[startLine] ];
  state.sCount[startLine] = offset - initial;

  oldTShift = [ state.tShift[startLine] ];
  state.tShift[startLine] = pos - state.bMarks[startLine];

  terminatorRules = state.md.block.ruler.getRules('blockquote');

  oldParentType = state.parentType;
  state.parentType = 'blockquote';

  // Search the end of the block
  //
  // Block ends with either:
  //  1. an empty line outside:
  //     ```
  //     > test
  //
  //     ```
  //  2. an empty line inside:
  //     ```
  //     >
  //     test
  //     ```
  //  3. another tag:
  //     ```
  //     > test
  //      - - -
  //     ```
  for (nextLine = startLine + 1; nextLine < endLine; nextLine++) {
    // check if it's outdented, i.e. it's inside list item and indented
    // less than said list item:
    //
    // ```
    // 1. anything
    //    > current blockquote
    // 2. checking this line
    // ```
    isOutdented = state.sCount[nextLine] < state.blkIndent;

    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    max = state.eMarks[nextLine];

    if (pos >= max) {
      // Case 1: line is not inside the blockquote, and this line is empty.
      break;
    }

    if (state.src.charCodeAt(pos++) === 0x3E/* > */ && !isOutdented) {
      // This line is inside the blockquote.

      // set offset past spaces and ">"
      initial = offset = state.sCount[nextLine] + 1;

      // skip one optional space after '>'
      if (state.src.charCodeAt(pos) === 0x20 /* space */) {
        // ' >   test '
        //     ^ -- position start of line here:
        pos++;
        initial++;
        offset++;
        adjustTab = false;
        spaceAfterMarker = true;
      } else if (state.src.charCodeAt(pos) === 0x09 /* tab */) {
        spaceAfterMarker = true;

        if ((state.bsCount[nextLine] + offset) % 4 === 3) {
          // '  >\t  test '
          //       ^ -- position start of line here (tab has width===1)
          pos++;
          initial++;
          offset++;
          adjustTab = false;
        } else {
          // ' >\t  test '
          //    ^ -- position start of line here + shift bsCount slightly
          //         to make extra space appear
          adjustTab = true;
        }
      } else {
        spaceAfterMarker = false;
      }

      oldBMarks.push(state.bMarks[nextLine]);
      state.bMarks[nextLine] = pos;

      while (pos < max) {
        ch = state.src.charCodeAt(pos);

        if (isSpace(ch)) {
          if (ch === 0x09) {
            offset += 4 - (offset + state.bsCount[nextLine] + (adjustTab ? 1 : 0)) % 4;
          } else {
            offset++;
          }
        } else {
          break;
        }

        pos++;
      }

      lastLineEmpty = pos >= max;

      oldBSCount.push(state.bsCount[nextLine]);
      state.bsCount[nextLine] = state.sCount[nextLine] + 1 + (spaceAfterMarker ? 1 : 0);

      oldSCount.push(state.sCount[nextLine]);
      state.sCount[nextLine] = offset - initial;

      oldTShift.push(state.tShift[nextLine]);
      state.tShift[nextLine] = pos - state.bMarks[nextLine];
      continue;
    }

    // Case 2: line is not inside the blockquote, and the last line was empty.
    if (lastLineEmpty) { break; }

    // Case 3: another tag found.
    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }

    if (terminate) {
      // Quirk to enforce "hard termination mode" for paragraphs;
      // normally if you call `tokenize(state, startLine, nextLine)`,
      // paragraphs will look below nextLine for paragraph continuation,
      // but if blockquote is terminated by another tag, they shouldn't
      state.lineMax = nextLine;

      if (state.blkIndent !== 0) {
        // state.blkIndent was non-zero, we now set it to zero,
        // so we need to re-calculate all offsets to appear as
        // if indent wasn't changed
        oldBMarks.push(state.bMarks[nextLine]);
        oldBSCount.push(state.bsCount[nextLine]);
        oldTShift.push(state.tShift[nextLine]);
        oldSCount.push(state.sCount[nextLine]);
        state.sCount[nextLine] -= state.blkIndent;
      }

      break;
    }

    oldBMarks.push(state.bMarks[nextLine]);
    oldBSCount.push(state.bsCount[nextLine]);
    oldTShift.push(state.tShift[nextLine]);
    oldSCount.push(state.sCount[nextLine]);

    // A negative indentation means that this is a paragraph continuation
    //
    state.sCount[nextLine] = -1;
  }

  oldIndent = state.blkIndent;
  state.blkIndent = 0;

  token        = state.push('blockquote_open', 'blockquote', 1);
  token.markup = '>';
  token.map    = lines = [ startLine, 0 ];

  state.md.block.tokenize(state, startLine, nextLine);

  token        = state.push('blockquote_close', 'blockquote', -1);
  token.markup = '>';

  state.lineMax = oldLineMax;
  state.parentType = oldParentType;
  lines[1] = state.line;

  // Restore original tShift; this might not be necessary since the parser
  // has already been here, but just to make sure we can do that.
  for (i = 0; i < oldTShift.length; i++) {
    state.bMarks[i + startLine] = oldBMarks[i];
    state.tShift[i + startLine] = oldTShift[i];
    state.sCount[i + startLine] = oldSCount[i];
    state.bsCount[i + startLine] = oldBSCount[i];
  }
  state.blkIndent = oldIndent;

  return true;
};


/***/ }),

/***/ 75740:
/***/ ((module) => {

"use strict";
// Code block (4 spaces padded)




module.exports = function code(state, startLine, endLine/*, silent*/) {
  var nextLine, last, token;

  if (state.sCount[startLine] - state.blkIndent < 4) { return false; }

  last = nextLine = startLine + 1;

  while (nextLine < endLine) {
    if (state.isEmpty(nextLine)) {
      nextLine++;
      continue;
    }

    if (state.sCount[nextLine] - state.blkIndent >= 4) {
      nextLine++;
      last = nextLine;
      continue;
    }
    break;
  }

  state.line = last;

  token         = state.push('code_block', 'code', 0);
  token.content = state.getLines(startLine, last, 4 + state.blkIndent, false) + '\n';
  token.map     = [ startLine, state.line ];

  return true;
};


/***/ }),

/***/ 10130:
/***/ ((module) => {

"use strict";
// fences (``` lang, ~~~ lang)




module.exports = function fence(state, startLine, endLine, silent) {
  var marker, len, params, nextLine, mem, token, markup,
      haveEndMarker = false,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) { return false; }

  if (pos + 3 > max) { return false; }

  marker = state.src.charCodeAt(pos);

  if (marker !== 0x7E/* ~ */ && marker !== 0x60 /* ` */) {
    return false;
  }

  // scan marker length
  mem = pos;
  pos = state.skipChars(pos, marker);

  len = pos - mem;

  if (len < 3) { return false; }

  markup = state.src.slice(mem, pos);
  params = state.src.slice(pos, max);

  if (marker === 0x60 /* ` */) {
    if (params.indexOf(String.fromCharCode(marker)) >= 0) {
      return false;
    }
  }

  // Since start is found, we can report success here in validation mode
  if (silent) { return true; }

  // search end of block
  nextLine = startLine;

  for (;;) {
    nextLine++;
    if (nextLine >= endLine) {
      // unclosed block should be autoclosed by end of document.
      // also block seems to be autoclosed by end of parent
      break;
    }

    pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
    max = state.eMarks[nextLine];

    if (pos < max && state.sCount[nextLine] < state.blkIndent) {
      // non-empty line with negative indent should stop the list:
      // - ```
      //  test
      break;
    }

    if (state.src.charCodeAt(pos) !== marker) { continue; }

    if (state.sCount[nextLine] - state.blkIndent >= 4) {
      // closing fence should be indented less than 4 spaces
      continue;
    }

    pos = state.skipChars(pos, marker);

    // closing code fence must be at least as long as the opening one
    if (pos - mem < len) { continue; }

    // make sure tail has spaces only
    pos = state.skipSpaces(pos);

    if (pos < max) { continue; }

    haveEndMarker = true;
    // found!
    break;
  }

  // If a fence has heading spaces, they should be removed from its inner block
  len = state.sCount[startLine];

  state.line = nextLine + (haveEndMarker ? 1 : 0);

  token         = state.push('fence', 'code', 0);
  token.info    = params;
  token.content = state.getLines(startLine + 1, nextLine, len, true);
  token.markup  = markup;
  token.map     = [ startLine, state.line ];

  return true;
};


/***/ }),

/***/ 40899:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// heading (#, ##, ...)



var isSpace = (__webpack_require__(26212).isSpace);


module.exports = function heading(state, startLine, endLine, silent) {
  var ch, level, tmp, token,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) { return false; }

  ch  = state.src.charCodeAt(pos);

  if (ch !== 0x23/* # */ || pos >= max) { return false; }

  // count heading level
  level = 1;
  ch = state.src.charCodeAt(++pos);
  while (ch === 0x23/* # */ && pos < max && level <= 6) {
    level++;
    ch = state.src.charCodeAt(++pos);
  }

  if (level > 6 || (pos < max && !isSpace(ch))) { return false; }

  if (silent) { return true; }

  // Let's cut tails like '    ###  ' from the end of string

  max = state.skipSpacesBack(max, pos);
  tmp = state.skipCharsBack(max, 0x23, pos); // #
  if (tmp > pos && isSpace(state.src.charCodeAt(tmp - 1))) {
    max = tmp;
  }

  state.line = startLine + 1;

  token        = state.push('heading_open', 'h' + String(level), 1);
  token.markup = '########'.slice(0, level);
  token.map    = [ startLine, state.line ];

  token          = state.push('inline', '', 0);
  token.content  = state.src.slice(pos, max).trim();
  token.map      = [ startLine, state.line ];
  token.children = [];

  token        = state.push('heading_close', 'h' + String(level), -1);
  token.markup = '########'.slice(0, level);

  return true;
};


/***/ }),

/***/ 17242:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Horizontal rule



var isSpace = (__webpack_require__(26212).isSpace);


module.exports = function hr(state, startLine, endLine, silent) {
  var marker, cnt, ch, token,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) { return false; }

  marker = state.src.charCodeAt(pos++);

  // Check hr marker
  if (marker !== 0x2A/* * */ &&
      marker !== 0x2D/* - */ &&
      marker !== 0x5F/* _ */) {
    return false;
  }

  // markers can be mixed with spaces, but there should be at least 3 of them

  cnt = 1;
  while (pos < max) {
    ch = state.src.charCodeAt(pos++);
    if (ch !== marker && !isSpace(ch)) { return false; }
    if (ch === marker) { cnt++; }
  }

  if (cnt < 3) { return false; }

  if (silent) { return true; }

  state.line = startLine + 1;

  token        = state.push('hr', 'hr', 0);
  token.map    = [ startLine, state.line ];
  token.markup = Array(cnt + 1).join(String.fromCharCode(marker));

  return true;
};


/***/ }),

/***/ 29690:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// HTML block




var block_names = __webpack_require__(57932);
var HTML_OPEN_CLOSE_TAG_RE = (__webpack_require__(26517)/* .HTML_OPEN_CLOSE_TAG_RE */ .q);

// An array of opening and corresponding closing sequences for html tags,
// last argument defines whether it can terminate a paragraph or not
//
var HTML_SEQUENCES = [
  [ /^<(script|pre|style|textarea)(?=(\s|>|$))/i, /<\/(script|pre|style|textarea)>/i, true ],
  [ /^<!--/,        /-->/,   true ],
  [ /^<\?/,         /\?>/,   true ],
  [ /^<![A-Z]/,     />/,     true ],
  [ /^<!\[CDATA\[/, /\]\]>/, true ],
  [ new RegExp('^</?(' + block_names.join('|') + ')(?=(\\s|/?>|$))', 'i'), /^$/, true ],
  [ new RegExp(HTML_OPEN_CLOSE_TAG_RE.source + '\\s*$'),  /^$/, false ]
];


module.exports = function html_block(state, startLine, endLine, silent) {
  var i, nextLine, token, lineText,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) { return false; }

  if (!state.md.options.html) { return false; }

  if (state.src.charCodeAt(pos) !== 0x3C/* < */) { return false; }

  lineText = state.src.slice(pos, max);

  for (i = 0; i < HTML_SEQUENCES.length; i++) {
    if (HTML_SEQUENCES[i][0].test(lineText)) { break; }
  }

  if (i === HTML_SEQUENCES.length) { return false; }

  if (silent) {
    // true if this sequence can be a terminator, false otherwise
    return HTML_SEQUENCES[i][2];
  }

  nextLine = startLine + 1;

  // If we are here - we detected HTML block.
  // Let's roll down till block end.
  if (!HTML_SEQUENCES[i][1].test(lineText)) {
    for (; nextLine < endLine; nextLine++) {
      if (state.sCount[nextLine] < state.blkIndent) { break; }

      pos = state.bMarks[nextLine] + state.tShift[nextLine];
      max = state.eMarks[nextLine];
      lineText = state.src.slice(pos, max);

      if (HTML_SEQUENCES[i][1].test(lineText)) {
        if (lineText.length !== 0) { nextLine++; }
        break;
      }
    }
  }

  state.line = nextLine;

  token         = state.push('html_block', '', 0);
  token.map     = [ startLine, nextLine ];
  token.content = state.getLines(startLine, nextLine, state.blkIndent, true);

  return true;
};


/***/ }),

/***/ 76091:
/***/ ((module) => {

"use strict";
// lheading (---, ===)




module.exports = function lheading(state, startLine, endLine/*, silent*/) {
  var content, terminate, i, l, token, pos, max, level, marker,
      nextLine = startLine + 1, oldParentType,
      terminatorRules = state.md.block.ruler.getRules('paragraph');

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) { return false; }

  oldParentType = state.parentType;
  state.parentType = 'paragraph'; // use paragraph to match terminatorRules

  // jump line-by-line until empty one or EOF
  for (; nextLine < endLine && !state.isEmpty(nextLine); nextLine++) {
    // this would be a code block normally, but after paragraph
    // it's considered a lazy continuation regardless of what's there
    if (state.sCount[nextLine] - state.blkIndent > 3) { continue; }

    //
    // Check for underline in setext header
    //
    if (state.sCount[nextLine] >= state.blkIndent) {
      pos = state.bMarks[nextLine] + state.tShift[nextLine];
      max = state.eMarks[nextLine];

      if (pos < max) {
        marker = state.src.charCodeAt(pos);

        if (marker === 0x2D/* - */ || marker === 0x3D/* = */) {
          pos = state.skipChars(pos, marker);
          pos = state.skipSpaces(pos);

          if (pos >= max) {
            level = (marker === 0x3D/* = */ ? 1 : 2);
            break;
          }
        }
      }
    }

    // quirk for blockquotes, this line should already be checked by that rule
    if (state.sCount[nextLine] < 0) { continue; }

    // Some tags can terminate paragraph without empty line.
    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }
    if (terminate) { break; }
  }

  if (!level) {
    // Didn't find valid underline
    return false;
  }

  content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();

  state.line = nextLine + 1;

  token          = state.push('heading_open', 'h' + String(level), 1);
  token.markup   = String.fromCharCode(marker);
  token.map      = [ startLine, state.line ];

  token          = state.push('inline', '', 0);
  token.content  = content;
  token.map      = [ startLine, state.line - 1 ];
  token.children = [];

  token          = state.push('heading_close', 'h' + String(level), -1);
  token.markup   = String.fromCharCode(marker);

  state.parentType = oldParentType;

  return true;
};


/***/ }),

/***/ 3557:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Lists



var isSpace = (__webpack_require__(26212).isSpace);


// Search `[-+*][\n ]`, returns next pos after marker on success
// or -1 on fail.
function skipBulletListMarker(state, startLine) {
  var marker, pos, max, ch;

  pos = state.bMarks[startLine] + state.tShift[startLine];
  max = state.eMarks[startLine];

  marker = state.src.charCodeAt(pos++);
  // Check bullet
  if (marker !== 0x2A/* * */ &&
      marker !== 0x2D/* - */ &&
      marker !== 0x2B/* + */) {
    return -1;
  }

  if (pos < max) {
    ch = state.src.charCodeAt(pos);

    if (!isSpace(ch)) {
      // " -test " - is not a list item
      return -1;
    }
  }

  return pos;
}

// Search `\d+[.)][\n ]`, returns next pos after marker on success
// or -1 on fail.
function skipOrderedListMarker(state, startLine) {
  var ch,
      start = state.bMarks[startLine] + state.tShift[startLine],
      pos = start,
      max = state.eMarks[startLine];

  // List marker should have at least 2 chars (digit + dot)
  if (pos + 1 >= max) { return -1; }

  ch = state.src.charCodeAt(pos++);

  if (ch < 0x30/* 0 */ || ch > 0x39/* 9 */) { return -1; }

  for (;;) {
    // EOL -> fail
    if (pos >= max) { return -1; }

    ch = state.src.charCodeAt(pos++);

    if (ch >= 0x30/* 0 */ && ch <= 0x39/* 9 */) {

      // List marker should have no more than 9 digits
      // (prevents integer overflow in browsers)
      if (pos - start >= 10) { return -1; }

      continue;
    }

    // found valid marker
    if (ch === 0x29/* ) */ || ch === 0x2e/* . */) {
      break;
    }

    return -1;
  }


  if (pos < max) {
    ch = state.src.charCodeAt(pos);

    if (!isSpace(ch)) {
      // " 1.test " - is not a list item
      return -1;
    }
  }
  return pos;
}

function markTightParagraphs(state, idx) {
  var i, l,
      level = state.level + 2;

  for (i = idx + 2, l = state.tokens.length - 2; i < l; i++) {
    if (state.tokens[i].level === level && state.tokens[i].type === 'paragraph_open') {
      state.tokens[i + 2].hidden = true;
      state.tokens[i].hidden = true;
      i += 2;
    }
  }
}


module.exports = function list(state, startLine, endLine, silent) {
  var ch,
      contentStart,
      i,
      indent,
      indentAfterMarker,
      initial,
      isOrdered,
      itemLines,
      l,
      listLines,
      listTokIdx,
      markerCharCode,
      markerValue,
      max,
      nextLine,
      offset,
      oldListIndent,
      oldParentType,
      oldSCount,
      oldTShift,
      oldTight,
      pos,
      posAfterMarker,
      prevEmptyEnd,
      start,
      terminate,
      terminatorRules,
      token,
      isTerminatingParagraph = false,
      tight = true;

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) { return false; }

  // Special case:
  //  - item 1
  //   - item 2
  //    - item 3
  //     - item 4
  //      - this one is a paragraph continuation
  if (state.listIndent >= 0 &&
      state.sCount[startLine] - state.listIndent >= 4 &&
      state.sCount[startLine] < state.blkIndent) {
    return false;
  }

  // limit conditions when list can interrupt
  // a paragraph (validation mode only)
  if (silent && state.parentType === 'paragraph') {
    // Next list item should still terminate previous list item;
    //
    // This code can fail if plugins use blkIndent as well as lists,
    // but I hope the spec gets fixed long before that happens.
    //
    if (state.tShift[startLine] >= state.blkIndent) {
      isTerminatingParagraph = true;
    }
  }

  // Detect list type and position after marker
  if ((posAfterMarker = skipOrderedListMarker(state, startLine)) >= 0) {
    isOrdered = true;
    start = state.bMarks[startLine] + state.tShift[startLine];
    markerValue = Number(state.src.slice(start, posAfterMarker - 1));

    // If we're starting a new ordered list right after
    // a paragraph, it should start with 1.
    if (isTerminatingParagraph && markerValue !== 1) return false;

  } else if ((posAfterMarker = skipBulletListMarker(state, startLine)) >= 0) {
    isOrdered = false;

  } else {
    return false;
  }

  // If we're starting a new unordered list right after
  // a paragraph, first line should not be empty.
  if (isTerminatingParagraph) {
    if (state.skipSpaces(posAfterMarker) >= state.eMarks[startLine]) return false;
  }

  // We should terminate list on style change. Remember first one to compare.
  markerCharCode = state.src.charCodeAt(posAfterMarker - 1);

  // For validation mode we can terminate immediately
  if (silent) { return true; }

  // Start list
  listTokIdx = state.tokens.length;

  if (isOrdered) {
    token       = state.push('ordered_list_open', 'ol', 1);
    if (markerValue !== 1) {
      token.attrs = [ [ 'start', markerValue ] ];
    }

  } else {
    token       = state.push('bullet_list_open', 'ul', 1);
  }

  token.map    = listLines = [ startLine, 0 ];
  token.markup = String.fromCharCode(markerCharCode);

  //
  // Iterate list items
  //

  nextLine = startLine;
  prevEmptyEnd = false;
  terminatorRules = state.md.block.ruler.getRules('list');

  oldParentType = state.parentType;
  state.parentType = 'list';

  while (nextLine < endLine) {
    pos = posAfterMarker;
    max = state.eMarks[nextLine];

    initial = offset = state.sCount[nextLine] + posAfterMarker - (state.bMarks[startLine] + state.tShift[startLine]);

    while (pos < max) {
      ch = state.src.charCodeAt(pos);

      if (ch === 0x09) {
        offset += 4 - (offset + state.bsCount[nextLine]) % 4;
      } else if (ch === 0x20) {
        offset++;
      } else {
        break;
      }

      pos++;
    }

    contentStart = pos;

    if (contentStart >= max) {
      // trimming space in "-    \n  3" case, indent is 1 here
      indentAfterMarker = 1;
    } else {
      indentAfterMarker = offset - initial;
    }

    // If we have more than 4 spaces, the indent is 1
    // (the rest is just indented code block)
    if (indentAfterMarker > 4) { indentAfterMarker = 1; }

    // "  -  test"
    //  ^^^^^ - calculating total length of this thing
    indent = initial + indentAfterMarker;

    // Run subparser & write tokens
    token        = state.push('list_item_open', 'li', 1);
    token.markup = String.fromCharCode(markerCharCode);
    token.map    = itemLines = [ startLine, 0 ];
    if (isOrdered) {
      token.info = state.src.slice(start, posAfterMarker - 1);
    }

    // change current state, then restore it after parser subcall
    oldTight = state.tight;
    oldTShift = state.tShift[startLine];
    oldSCount = state.sCount[startLine];

    //  - example list
    // ^ listIndent position will be here
    //   ^ blkIndent position will be here
    //
    oldListIndent = state.listIndent;
    state.listIndent = state.blkIndent;
    state.blkIndent = indent;

    state.tight = true;
    state.tShift[startLine] = contentStart - state.bMarks[startLine];
    state.sCount[startLine] = offset;

    if (contentStart >= max && state.isEmpty(startLine + 1)) {
      // workaround for this case
      // (list item is empty, list terminates before "foo"):
      // ~~~~~~~~
      //   -
      //
      //     foo
      // ~~~~~~~~
      state.line = Math.min(state.line + 2, endLine);
    } else {
      state.md.block.tokenize(state, startLine, endLine, true);
    }

    // If any of list item is tight, mark list as tight
    if (!state.tight || prevEmptyEnd) {
      tight = false;
    }
    // Item become loose if finish with empty line,
    // but we should filter last element, because it means list finish
    prevEmptyEnd = (state.line - startLine) > 1 && state.isEmpty(state.line - 1);

    state.blkIndent = state.listIndent;
    state.listIndent = oldListIndent;
    state.tShift[startLine] = oldTShift;
    state.sCount[startLine] = oldSCount;
    state.tight = oldTight;

    token        = state.push('list_item_close', 'li', -1);
    token.markup = String.fromCharCode(markerCharCode);

    nextLine = startLine = state.line;
    itemLines[1] = nextLine;
    contentStart = state.bMarks[startLine];

    if (nextLine >= endLine) { break; }

    //
    // Try to check if list is terminated or continued.
    //
    if (state.sCount[nextLine] < state.blkIndent) { break; }

    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) { break; }

    // fail if terminating block found
    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }
    if (terminate) { break; }

    // fail if list has another type
    if (isOrdered) {
      posAfterMarker = skipOrderedListMarker(state, nextLine);
      if (posAfterMarker < 0) { break; }
      start = state.bMarks[nextLine] + state.tShift[nextLine];
    } else {
      posAfterMarker = skipBulletListMarker(state, nextLine);
      if (posAfterMarker < 0) { break; }
    }

    if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) { break; }
  }

  // Finalize list
  if (isOrdered) {
    token = state.push('ordered_list_close', 'ol', -1);
  } else {
    token = state.push('bullet_list_close', 'ul', -1);
  }
  token.markup = String.fromCharCode(markerCharCode);

  listLines[1] = nextLine;
  state.line = nextLine;

  state.parentType = oldParentType;

  // mark paragraphs tight if needed
  if (tight) {
    markTightParagraphs(state, listTokIdx);
  }

  return true;
};


/***/ }),

/***/ 37370:
/***/ ((module) => {

"use strict";
// Paragraph




module.exports = function paragraph(state, startLine/*, endLine*/) {
  var content, terminate, i, l, token, oldParentType,
      nextLine = startLine + 1,
      terminatorRules = state.md.block.ruler.getRules('paragraph'),
      endLine = state.lineMax;

  oldParentType = state.parentType;
  state.parentType = 'paragraph';

  // jump line-by-line until empty one or EOF
  for (; nextLine < endLine && !state.isEmpty(nextLine); nextLine++) {
    // this would be a code block normally, but after paragraph
    // it's considered a lazy continuation regardless of what's there
    if (state.sCount[nextLine] - state.blkIndent > 3) { continue; }

    // quirk for blockquotes, this line should already be checked by that rule
    if (state.sCount[nextLine] < 0) { continue; }

    // Some tags can terminate paragraph without empty line.
    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }
    if (terminate) { break; }
  }

  content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();

  state.line = nextLine;

  token          = state.push('paragraph_open', 'p', 1);
  token.map      = [ startLine, state.line ];

  token          = state.push('inline', '', 0);
  token.content  = content;
  token.map      = [ startLine, state.line ];
  token.children = [];

  token          = state.push('paragraph_close', 'p', -1);

  state.parentType = oldParentType;

  return true;
};


/***/ }),

/***/ 2534:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";



var normalizeReference   = (__webpack_require__(26212).normalizeReference);
var isSpace              = (__webpack_require__(26212).isSpace);


module.exports = function reference(state, startLine, _endLine, silent) {
  var ch,
      destEndPos,
      destEndLineNo,
      endLine,
      href,
      i,
      l,
      label,
      labelEnd,
      oldParentType,
      res,
      start,
      str,
      terminate,
      terminatorRules,
      title,
      lines = 0,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine],
      nextLine = startLine + 1;

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) { return false; }

  if (state.src.charCodeAt(pos) !== 0x5B/* [ */) { return false; }

  // Simple check to quickly interrupt scan on [link](url) at the start of line.
  // Can be useful on practice: https://github.com/markdown-it/markdown-it/issues/54
  while (++pos < max) {
    if (state.src.charCodeAt(pos) === 0x5D /* ] */ &&
        state.src.charCodeAt(pos - 1) !== 0x5C/* \ */) {
      if (pos + 1 === max) { return false; }
      if (state.src.charCodeAt(pos + 1) !== 0x3A/* : */) { return false; }
      break;
    }
  }

  endLine = state.lineMax;

  // jump line-by-line until empty one or EOF
  terminatorRules = state.md.block.ruler.getRules('reference');

  oldParentType = state.parentType;
  state.parentType = 'reference';

  for (; nextLine < endLine && !state.isEmpty(nextLine); nextLine++) {
    // this would be a code block normally, but after paragraph
    // it's considered a lazy continuation regardless of what's there
    if (state.sCount[nextLine] - state.blkIndent > 3) { continue; }

    // quirk for blockquotes, this line should already be checked by that rule
    if (state.sCount[nextLine] < 0) { continue; }

    // Some tags can terminate paragraph without empty line.
    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }
    if (terminate) { break; }
  }

  str = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
  max = str.length;

  for (pos = 1; pos < max; pos++) {
    ch = str.charCodeAt(pos);
    if (ch === 0x5B /* [ */) {
      return false;
    } else if (ch === 0x5D /* ] */) {
      labelEnd = pos;
      break;
    } else if (ch === 0x0A /* \n */) {
      lines++;
    } else if (ch === 0x5C /* \ */) {
      pos++;
      if (pos < max && str.charCodeAt(pos) === 0x0A) {
        lines++;
      }
    }
  }

  if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A/* : */) { return false; }

  // [label]:   destination   'title'
  //         ^^^ skip optional whitespace here
  for (pos = labelEnd + 2; pos < max; pos++) {
    ch = str.charCodeAt(pos);
    if (ch === 0x0A) {
      lines++;
    } else if (isSpace(ch)) {
      /*eslint no-empty:0*/
    } else {
      break;
    }
  }

  // [label]:   destination   'title'
  //            ^^^^^^^^^^^ parse this
  res = state.md.helpers.parseLinkDestination(str, pos, max);
  if (!res.ok) { return false; }

  href = state.md.normalizeLink(res.str);
  if (!state.md.validateLink(href)) { return false; }

  pos = res.pos;
  lines += res.lines;

  // save cursor state, we could require to rollback later
  destEndPos = pos;
  destEndLineNo = lines;

  // [label]:   destination   'title'
  //                       ^^^ skipping those spaces
  start = pos;
  for (; pos < max; pos++) {
    ch = str.charCodeAt(pos);
    if (ch === 0x0A) {
      lines++;
    } else if (isSpace(ch)) {
      /*eslint no-empty:0*/
    } else {
      break;
    }
  }

  // [label]:   destination   'title'
  //                          ^^^^^^^ parse this
  res = state.md.helpers.parseLinkTitle(str, pos, max);
  if (pos < max && start !== pos && res.ok) {
    title = res.str;
    pos = res.pos;
    lines += res.lines;
  } else {
    title = '';
    pos = destEndPos;
    lines = destEndLineNo;
  }

  // skip trailing spaces until the rest of the line
  while (pos < max) {
    ch = str.charCodeAt(pos);
    if (!isSpace(ch)) { break; }
    pos++;
  }

  if (pos < max && str.charCodeAt(pos) !== 0x0A) {
    if (title) {
      // garbage at the end of the line after title,
      // but it could still be a valid reference if we roll back
      title = '';
      pos = destEndPos;
      lines = destEndLineNo;
      while (pos < max) {
        ch = str.charCodeAt(pos);
        if (!isSpace(ch)) { break; }
        pos++;
      }
    }
  }

  if (pos < max && str.charCodeAt(pos) !== 0x0A) {
    // garbage at the end of the line
    return false;
  }

  label = normalizeReference(str.slice(1, labelEnd));
  if (!label) {
    // CommonMark 0.20 disallows empty labels
    return false;
  }

  // Reference can not terminate anything. This check is for safety only.
  /*istanbul ignore if*/
  if (silent) { return true; }

  if (typeof state.env.references === 'undefined') {
    state.env.references = {};
  }
  if (typeof state.env.references[label] === 'undefined') {
    state.env.references[label] = { title: title, href: href };
  }

  state.parentType = oldParentType;

  state.line = startLine + lines + 1;
  return true;
};


/***/ }),

/***/ 49677:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Parser state class



var Token = __webpack_require__(98114);
var isSpace = (__webpack_require__(26212).isSpace);


function StateBlock(src, md, env, tokens) {
  var ch, s, start, pos, len, indent, offset, indent_found;

  this.src = src;

  // link to parser instance
  this.md     = md;

  this.env = env;

  //
  // Internal state vartiables
  //

  this.tokens = tokens;

  this.bMarks = [];  // line begin offsets for fast jumps
  this.eMarks = [];  // line end offsets for fast jumps
  this.tShift = [];  // offsets of the first non-space characters (tabs not expanded)
  this.sCount = [];  // indents for each line (tabs expanded)

  // An amount of virtual spaces (tabs expanded) between beginning
  // of each line (bMarks) and real beginning of that line.
  //
  // It exists only as a hack because blockquotes override bMarks
  // losing information in the process.
  //
  // It's used only when expanding tabs, you can think about it as
  // an initial tab length, e.g. bsCount=21 applied to string `\t123`
  // means first tab should be expanded to 4-21%4 === 3 spaces.
  //
  this.bsCount = [];

  // block parser variables
  this.blkIndent  = 0; // required block content indent (for example, if we are
                       // inside a list, it would be positioned after list marker)
  this.line       = 0; // line index in src
  this.lineMax    = 0; // lines count
  this.tight      = false;  // loose/tight mode for lists
  this.ddIndent   = -1; // indent of the current dd block (-1 if there isn't any)
  this.listIndent = -1; // indent of the current list block (-1 if there isn't any)

  // can be 'blockquote', 'list', 'root', 'paragraph' or 'reference'
  // used in lists to determine if they interrupt a paragraph
  this.parentType = 'root';

  this.level = 0;

  // renderer
  this.result = '';

  // Create caches
  // Generate markers.
  s = this.src;
  indent_found = false;

  for (start = pos = indent = offset = 0, len = s.length; pos < len; pos++) {
    ch = s.charCodeAt(pos);

    if (!indent_found) {
      if (isSpace(ch)) {
        indent++;

        if (ch === 0x09) {
          offset += 4 - offset % 4;
        } else {
          offset++;
        }
        continue;
      } else {
        indent_found = true;
      }
    }

    if (ch === 0x0A || pos === len - 1) {
      if (ch !== 0x0A) { pos++; }
      this.bMarks.push(start);
      this.eMarks.push(pos);
      this.tShift.push(indent);
      this.sCount.push(offset);
      this.bsCount.push(0);

      indent_found = false;
      indent = 0;
      offset = 0;
      start = pos + 1;
    }
  }

  // Push fake entry to simplify cache bounds checks
  this.bMarks.push(s.length);
  this.eMarks.push(s.length);
  this.tShift.push(0);
  this.sCount.push(0);
  this.bsCount.push(0);

  this.lineMax = this.bMarks.length - 1; // don't count last fake line
}

// Push new token to "stream".
//
StateBlock.prototype.push = function (type, tag, nesting) {
  var token = new Token(type, tag, nesting);
  token.block = true;

  if (nesting < 0) this.level--; // closing tag
  token.level = this.level;
  if (nesting > 0) this.level++; // opening tag

  this.tokens.push(token);
  return token;
};

StateBlock.prototype.isEmpty = function isEmpty(line) {
  return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};

StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
  for (var max = this.lineMax; from < max; from++) {
    if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) {
      break;
    }
  }
  return from;
};

// Skip spaces from given position.
StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
  var ch;

  for (var max = this.src.length; pos < max; pos++) {
    ch = this.src.charCodeAt(pos);
    if (!isSpace(ch)) { break; }
  }
  return pos;
};

// Skip spaces from given position in reverse.
StateBlock.prototype.skipSpacesBack = function skipSpacesBack(pos, min) {
  if (pos <= min) { return pos; }

  while (pos > min) {
    if (!isSpace(this.src.charCodeAt(--pos))) { return pos + 1; }
  }
  return pos;
};

// Skip char codes from given position
StateBlock.prototype.skipChars = function skipChars(pos, code) {
  for (var max = this.src.length; pos < max; pos++) {
    if (this.src.charCodeAt(pos) !== code) { break; }
  }
  return pos;
};

// Skip char codes reverse from given position - 1
StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
  if (pos <= min) { return pos; }

  while (pos > min) {
    if (code !== this.src.charCodeAt(--pos)) { return pos + 1; }
  }
  return pos;
};

// cut lines range from source.
StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
  var i, lineIndent, ch, first, last, queue, lineStart,
      line = begin;

  if (begin >= end) {
    return '';
  }

  queue = new Array(end - begin);

  for (i = 0; line < end; line++, i++) {
    lineIndent = 0;
    lineStart = first = this.bMarks[line];

    if (line + 1 < end || keepLastLF) {
      // No need for bounds check because we have fake entry on tail.
      last = this.eMarks[line] + 1;
    } else {
      last = this.eMarks[line];
    }

    while (first < last && lineIndent < indent) {
      ch = this.src.charCodeAt(first);

      if (isSpace(ch)) {
        if (ch === 0x09) {
          lineIndent += 4 - (lineIndent + this.bsCount[line]) % 4;
        } else {
          lineIndent++;
        }
      } else if (first - lineStart < this.tShift[line]) {
        // patched tShift masked characters to look like spaces (blockquotes, list markers)
        lineIndent++;
      } else {
        break;
      }

      first++;
    }

    if (lineIndent > indent) {
      // partially expanding tabs in code blocks, e.g '\t\tfoobar'
      // with indent=2 becomes '  \tfoobar'
      queue[i] = new Array(lineIndent - indent + 1).join(' ') + this.src.slice(first, last);
    } else {
      queue[i] = this.src.slice(first, last);
    }
  }

  return queue.join('');
};

// re-export Token class to use in block rules
StateBlock.prototype.Token = Token;


module.exports = StateBlock;


/***/ }),

/***/ 83010:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// GFM table, https://github.github.com/gfm/#tables-extension-



var isSpace = (__webpack_require__(26212).isSpace);


function getLine(state, line) {
  var pos = state.bMarks[line] + state.tShift[line],
      max = state.eMarks[line];

  return state.src.substr(pos, max - pos);
}

function escapedSplit(str) {
  var result = [],
      pos = 0,
      max = str.length,
      ch,
      isEscaped = false,
      lastPos = 0,
      current = '';

  ch  = str.charCodeAt(pos);

  while (pos < max) {
    if (ch === 0x7c/* | */) {
      if (!isEscaped) {
        // pipe separating cells, '|'
        result.push(current + str.substring(lastPos, pos));
        current = '';
        lastPos = pos + 1;
      } else {
        // escaped pipe, '\|'
        current += str.substring(lastPos, pos - 1);
        lastPos = pos;
      }
    }

    isEscaped = (ch === 0x5c/* \ */);
    pos++;

    ch = str.charCodeAt(pos);
  }

  result.push(current + str.substring(lastPos));

  return result;
}


module.exports = function table(state, startLine, endLine, silent) {
  var ch, lineText, pos, i, l, nextLine, columns, columnCount, token,
      aligns, t, tableLines, tbodyLines, oldParentType, terminate,
      terminatorRules, firstCh, secondCh;

  // should have at least two lines
  if (startLine + 2 > endLine) { return false; }

  nextLine = startLine + 1;

  if (state.sCount[nextLine] < state.blkIndent) { return false; }

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[nextLine] - state.blkIndent >= 4) { return false; }

  // first character of the second line should be '|', '-', ':',
  // and no other characters are allowed but spaces;
  // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp

  pos = state.bMarks[nextLine] + state.tShift[nextLine];
  if (pos >= state.eMarks[nextLine]) { return false; }

  firstCh = state.src.charCodeAt(pos++);
  if (firstCh !== 0x7C/* | */ && firstCh !== 0x2D/* - */ && firstCh !== 0x3A/* : */) { return false; }

  if (pos >= state.eMarks[nextLine]) { return false; }

  secondCh = state.src.charCodeAt(pos++);
  if (secondCh !== 0x7C/* | */ && secondCh !== 0x2D/* - */ && secondCh !== 0x3A/* : */ && !isSpace(secondCh)) {
    return false;
  }

  // if first character is '-', then second character must not be a space
  // (due to parsing ambiguity with list)
  if (firstCh === 0x2D/* - */ && isSpace(secondCh)) { return false; }

  while (pos < state.eMarks[nextLine]) {
    ch = state.src.charCodeAt(pos);

    if (ch !== 0x7C/* | */ && ch !== 0x2D/* - */ && ch !== 0x3A/* : */ && !isSpace(ch)) { return false; }

    pos++;
  }

  lineText = getLine(state, startLine + 1);

  columns = lineText.split('|');
  aligns = [];
  for (i = 0; i < columns.length; i++) {
    t = columns[i].trim();
    if (!t) {
      // allow empty columns before and after table, but not in between columns;
      // e.g. allow ` |---| `, disallow ` ---||--- `
      if (i === 0 || i === columns.length - 1) {
        continue;
      } else {
        return false;
      }
    }

    if (!/^:?-+:?$/.test(t)) { return false; }
    if (t.charCodeAt(t.length - 1) === 0x3A/* : */) {
      aligns.push(t.charCodeAt(0) === 0x3A/* : */ ? 'center' : 'right');
    } else if (t.charCodeAt(0) === 0x3A/* : */) {
      aligns.push('left');
    } else {
      aligns.push('');
    }
  }

  lineText = getLine(state, startLine).trim();
  if (lineText.indexOf('|') === -1) { return false; }
  if (state.sCount[startLine] - state.blkIndent >= 4) { return false; }
  columns = escapedSplit(lineText);
  if (columns.length && columns[0] === '') columns.shift();
  if (columns.length && columns[columns.length - 1] === '') columns.pop();

  // header row will define an amount of columns in the entire table,
  // and align row should be exactly the same (the rest of the rows can differ)
  columnCount = columns.length;
  if (columnCount === 0 || columnCount !== aligns.length) { return false; }

  if (silent) { return true; }

  oldParentType = state.parentType;
  state.parentType = 'table';

  // use 'blockquote' lists for termination because it's
  // the most similar to tables
  terminatorRules = state.md.block.ruler.getRules('blockquote');

  token     = state.push('table_open', 'table', 1);
  token.map = tableLines = [ startLine, 0 ];

  token     = state.push('thead_open', 'thead', 1);
  token.map = [ startLine, startLine + 1 ];

  token     = state.push('tr_open', 'tr', 1);
  token.map = [ startLine, startLine + 1 ];

  for (i = 0; i < columns.length; i++) {
    token          = state.push('th_open', 'th', 1);
    if (aligns[i]) {
      token.attrs  = [ [ 'style', 'text-align:' + aligns[i] ] ];
    }

    token          = state.push('inline', '', 0);
    token.content  = columns[i].trim();
    token.children = [];

    token          = state.push('th_close', 'th', -1);
  }

  token     = state.push('tr_close', 'tr', -1);
  token     = state.push('thead_close', 'thead', -1);

  for (nextLine = startLine + 2; nextLine < endLine; nextLine++) {
    if (state.sCount[nextLine] < state.blkIndent) { break; }

    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }

    if (terminate) { break; }
    lineText = getLine(state, nextLine).trim();
    if (!lineText) { break; }
    if (state.sCount[nextLine] - state.blkIndent >= 4) { break; }
    columns = escapedSplit(lineText);
    if (columns.length && columns[0] === '') columns.shift();
    if (columns.length && columns[columns.length - 1] === '') columns.pop();

    if (nextLine === startLine + 2) {
      token     = state.push('tbody_open', 'tbody', 1);
      token.map = tbodyLines = [ startLine + 2, 0 ];
    }

    token     = state.push('tr_open', 'tr', 1);
    token.map = [ nextLine, nextLine + 1 ];

    for (i = 0; i < columnCount; i++) {
      token          = state.push('td_open', 'td', 1);
      if (aligns[i]) {
        token.attrs  = [ [ 'style', 'text-align:' + aligns[i] ] ];
      }

      token          = state.push('inline', '', 0);
      token.content  = columns[i] ? columns[i].trim() : '';
      token.children = [];

      token          = state.push('td_close', 'td', -1);
    }
    token = state.push('tr_close', 'tr', -1);
  }

  if (tbodyLines) {
    token = state.push('tbody_close', 'tbody', -1);
    tbodyLines[1] = nextLine;
  }

  token = state.push('table_close', 'table', -1);
  tableLines[1] = nextLine;

  state.parentType = oldParentType;
  state.line = nextLine;
  return true;
};


/***/ }),

/***/ 84965:
/***/ ((module) => {

"use strict";



module.exports = function block(state) {
  var token;

  if (state.inlineMode) {
    token          = new state.Token('inline', '', 0);
    token.content  = state.src;
    token.map      = [ 0, 1 ];
    token.children = [];
    state.tokens.push(token);
  } else {
    state.md.block.parse(state.src, state.md, state.env, state.tokens);
  }
};


/***/ }),

/***/ 80458:
/***/ ((module) => {

"use strict";


module.exports = function inline(state) {
  var tokens = state.tokens, tok, i, l;

  // Parse inlines
  for (i = 0, l = tokens.length; i < l; i++) {
    tok = tokens[i];
    if (tok.type === 'inline') {
      state.md.inline.parse(tok.content, state.md, state.env, tok.children);
    }
  }
};


/***/ }),

/***/ 68961:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Replace link-like texts with link nodes.
//
// Currently restricted by `md.validateLink()` to http/https/ftp
//



var arrayReplaceAt = (__webpack_require__(26212).arrayReplaceAt);


function isLinkOpen(str) {
  return /^<a[>\s]/i.test(str);
}
function isLinkClose(str) {
  return /^<\/a\s*>/i.test(str);
}


module.exports = function linkify(state) {
  var i, j, l, tokens, token, currentToken, nodes, ln, text, pos, lastPos,
      level, htmlLinkLevel, url, fullUrl, urlText,
      blockTokens = state.tokens,
      links;

  if (!state.md.options.linkify) { return; }

  for (j = 0, l = blockTokens.length; j < l; j++) {
    if (blockTokens[j].type !== 'inline' ||
        !state.md.linkify.pretest(blockTokens[j].content)) {
      continue;
    }

    tokens = blockTokens[j].children;

    htmlLinkLevel = 0;

    // We scan from the end, to keep position when new tags added.
    // Use reversed logic in links start/end match
    for (i = tokens.length - 1; i >= 0; i--) {
      currentToken = tokens[i];

      // Skip content of markdown links
      if (currentToken.type === 'link_close') {
        i--;
        while (tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open') {
          i--;
        }
        continue;
      }

      // Skip content of html tag links
      if (currentToken.type === 'html_inline') {
        if (isLinkOpen(currentToken.content) && htmlLinkLevel > 0) {
          htmlLinkLevel--;
        }
        if (isLinkClose(currentToken.content)) {
          htmlLinkLevel++;
        }
      }
      if (htmlLinkLevel > 0) { continue; }

      if (currentToken.type === 'text' && state.md.linkify.test(currentToken.content)) {

        text = currentToken.content;
        links = state.md.linkify.match(text);

        // Now split string to nodes
        nodes = [];
        level = currentToken.level;
        lastPos = 0;

        for (ln = 0; ln < links.length; ln++) {

          url = links[ln].url;
          fullUrl = state.md.normalizeLink(url);
          if (!state.md.validateLink(fullUrl)) { continue; }

          urlText = links[ln].text;

          // Linkifier might send raw hostnames like "example.com", where url
          // starts with domain name. So we prepend http:// in those cases,
          // and remove it afterwards.
          //
          if (!links[ln].schema) {
            urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
          } else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) {
            urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
          } else {
            urlText = state.md.normalizeLinkText(urlText);
          }

          pos = links[ln].index;

          if (pos > lastPos) {
            token         = new state.Token('text', '', 0);
            token.content = text.slice(lastPos, pos);
            token.level   = level;
            nodes.push(token);
          }

          token         = new state.Token('link_open', 'a', 1);
          token.attrs   = [ [ 'href', fullUrl ] ];
          token.level   = level++;
          token.markup  = 'linkify';
          token.info    = 'auto';
          nodes.push(token);

          token         = new state.Token('text', '', 0);
          token.content = urlText;
          token.level   = level;
          nodes.push(token);

          token         = new state.Token('link_close', 'a', -1);
          token.level   = --level;
          token.markup  = 'linkify';
          token.info    = 'auto';
          nodes.push(token);

          lastPos = links[ln].lastIndex;
        }
        if (lastPos < text.length) {
          token         = new state.Token('text', '', 0);
          token.content = text.slice(lastPos);
          token.level   = level;
          nodes.push(token);
        }

        // replace current node
        blockTokens[j].children = tokens = arrayReplaceAt(tokens, i, nodes);
      }
    }
  }
};


/***/ }),

/***/ 75272:
/***/ ((module) => {

"use strict";
// Normalize input string




// https://spec.commonmark.org/0.29/#line-ending
var NEWLINES_RE  = /\r\n?|\n/g;
var NULL_RE      = /\0/g;


module.exports = function normalize(state) {
  var str;

  // Normalize newlines
  str = state.src.replace(NEWLINES_RE, '\n');

  // Replace NULL characters
  str = str.replace(NULL_RE, '\uFFFD');

  state.src = str;
};


/***/ }),

/***/ 30806:
/***/ ((module) => {

"use strict";
// Simple typographic replacements
//
// (c) (C) → ©
// (tm) (TM) → ™
// (r) (R) → ®
// +- → ±
// (p) (P) -> §
// ... → … (also ?.... → ?.., !.... → !..)
// ???????? → ???, !!!!! → !!!, `,,` → `,`
// -- → &ndash;, --- → &mdash;
//


// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - miltiplication 2 x 4 -> 2 × 4

var RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;

// Workaround for phantomjs - need regex without /g flag,
// or root check will fail every second time
var SCOPED_ABBR_TEST_RE = /\((c|tm|r|p)\)/i;

var SCOPED_ABBR_RE = /\((c|tm|r|p)\)/ig;
var SCOPED_ABBR = {
  c: '©',
  r: '®',
  p: '§',
  tm: '™'
};

function replaceFn(match, name) {
  return SCOPED_ABBR[name.toLowerCase()];
}

function replace_scoped(inlineTokens) {
  var i, token, inside_autolink = 0;

  for (i = inlineTokens.length - 1; i >= 0; i--) {
    token = inlineTokens[i];

    if (token.type === 'text' && !inside_autolink) {
      token.content = token.content.replace(SCOPED_ABBR_RE, replaceFn);
    }

    if (token.type === 'link_open' && token.info === 'auto') {
      inside_autolink--;
    }

    if (token.type === 'link_close' && token.info === 'auto') {
      inside_autolink++;
    }
  }
}

function replace_rare(inlineTokens) {
  var i, token, inside_autolink = 0;

  for (i = inlineTokens.length - 1; i >= 0; i--) {
    token = inlineTokens[i];

    if (token.type === 'text' && !inside_autolink) {
      if (RARE_RE.test(token.content)) {
        token.content = token.content
          .replace(/\+-/g, '±')
          // .., ..., ....... -> …
          // but ?..... & !..... -> ?.. & !..
          .replace(/\.{2,}/g, '…').replace(/([?!])…/g, '$1..')
          .replace(/([?!]){4,}/g, '$1$1$1').replace(/,{2,}/g, ',')
          // em-dash
          .replace(/(^|[^-])---(?=[^-]|$)/mg, '$1\u2014')
          // en-dash
          .replace(/(^|\s)--(?=\s|$)/mg, '$1\u2013')
          .replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, '$1\u2013');
      }
    }

    if (token.type === 'link_open' && token.info === 'auto') {
      inside_autolink--;
    }

    if (token.type === 'link_close' && token.info === 'auto') {
      inside_autolink++;
    }
  }
}


module.exports = function replace(state) {
  var blkIdx;

  if (!state.md.options.typographer) { return; }

  for (blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--) {

    if (state.tokens[blkIdx].type !== 'inline') { continue; }

    if (SCOPED_ABBR_TEST_RE.test(state.tokens[blkIdx].content)) {
      replace_scoped(state.tokens[blkIdx].children);
    }

    if (RARE_RE.test(state.tokens[blkIdx].content)) {
      replace_rare(state.tokens[blkIdx].children);
    }

  }
};


/***/ }),

/***/ 62839:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Convert straight quotation marks to typographic ones
//



var isWhiteSpace   = (__webpack_require__(26212).isWhiteSpace);
var isPunctChar    = (__webpack_require__(26212).isPunctChar);
var isMdAsciiPunct = (__webpack_require__(26212).isMdAsciiPunct);

var QUOTE_TEST_RE = /['"]/;
var QUOTE_RE = /['"]/g;
var APOSTROPHE = '\u2019'; /* ’ */


function replaceAt(str, index, ch) {
  return str.substr(0, index) + ch + str.substr(index + 1);
}

function process_inlines(tokens, state) {
  var i, token, text, t, pos, max, thisLevel, item, lastChar, nextChar,
      isLastPunctChar, isNextPunctChar, isLastWhiteSpace, isNextWhiteSpace,
      canOpen, canClose, j, isSingle, stack, openQuote, closeQuote;

  stack = [];

  for (i = 0; i < tokens.length; i++) {
    token = tokens[i];

    thisLevel = tokens[i].level;

    for (j = stack.length - 1; j >= 0; j--) {
      if (stack[j].level <= thisLevel) { break; }
    }
    stack.length = j + 1;

    if (token.type !== 'text') { continue; }

    text = token.content;
    pos = 0;
    max = text.length;

    /*eslint no-labels:0,block-scoped-var:0*/
    OUTER:
    while (pos < max) {
      QUOTE_RE.lastIndex = pos;
      t = QUOTE_RE.exec(text);
      if (!t) { break; }

      canOpen = canClose = true;
      pos = t.index + 1;
      isSingle = (t[0] === "'");

      // Find previous character,
      // default to space if it's the beginning of the line
      //
      lastChar = 0x20;

      if (t.index - 1 >= 0) {
        lastChar = text.charCodeAt(t.index - 1);
      } else {
        for (j = i - 1; j >= 0; j--) {
          if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // lastChar defaults to 0x20
          if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'

          lastChar = tokens[j].content.charCodeAt(tokens[j].content.length - 1);
          break;
        }
      }

      // Find next character,
      // default to space if it's the end of the line
      //
      nextChar = 0x20;

      if (pos < max) {
        nextChar = text.charCodeAt(pos);
      } else {
        for (j = i + 1; j < tokens.length; j++) {
          if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // nextChar defaults to 0x20
          if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'

          nextChar = tokens[j].content.charCodeAt(0);
          break;
        }
      }

      isLastPunctChar = isMdAsciiPunct(lastChar) || isPunctChar(String.fromCharCode(lastChar));
      isNextPunctChar = isMdAsciiPunct(nextChar) || isPunctChar(String.fromCharCode(nextChar));

      isLastWhiteSpace = isWhiteSpace(lastChar);
      isNextWhiteSpace = isWhiteSpace(nextChar);

      if (isNextWhiteSpace) {
        canOpen = false;
      } else if (isNextPunctChar) {
        if (!(isLastWhiteSpace || isLastPunctChar)) {
          canOpen = false;
        }
      }

      if (isLastWhiteSpace) {
        canClose = false;
      } else if (isLastPunctChar) {
        if (!(isNextWhiteSpace || isNextPunctChar)) {
          canClose = false;
        }
      }

      if (nextChar === 0x22 /* " */ && t[0] === '"') {
        if (lastChar >= 0x30 /* 0 */ && lastChar <= 0x39 /* 9 */) {
          // special case: 1"" - count first quote as an inch
          canClose = canOpen = false;
        }
      }

      if (canOpen && canClose) {
        // Replace quotes in the middle of punctuation sequence, but not
        // in the middle of the words, i.e.:
        //
        // 1. foo " bar " baz - not replaced
        // 2. foo-"-bar-"-baz - replaced
        // 3. foo"bar"baz     - not replaced
        //
        canOpen = isLastPunctChar;
        canClose = isNextPunctChar;
      }

      if (!canOpen && !canClose) {
        // middle of word
        if (isSingle) {
          token.content = replaceAt(token.content, t.index, APOSTROPHE);
        }
        continue;
      }

      if (canClose) {
        // this could be a closing quote, rewind the stack to get a match
        for (j = stack.length - 1; j >= 0; j--) {
          item = stack[j];
          if (stack[j].level < thisLevel) { break; }
          if (item.single === isSingle && stack[j].level === thisLevel) {
            item = stack[j];

            if (isSingle) {
              openQuote = state.md.options.quotes[2];
              closeQuote = state.md.options.quotes[3];
            } else {
              openQuote = state.md.options.quotes[0];
              closeQuote = state.md.options.quotes[1];
            }

            // replace token.content *before* tokens[item.token].content,
            // because, if they are pointing at the same token, replaceAt
            // could mess up indices when quote length != 1
            token.content = replaceAt(token.content, t.index, closeQuote);
            tokens[item.token].content = replaceAt(
              tokens[item.token].content, item.pos, openQuote);

            pos += closeQuote.length - 1;
            if (item.token === i) { pos += openQuote.length - 1; }

            text = token.content;
            max = text.length;

            stack.length = j;
            continue OUTER;
          }
        }
      }

      if (canOpen) {
        stack.push({
          token: i,
          pos: t.index,
          single: isSingle,
          level: thisLevel
        });
      } else if (canClose && isSingle) {
        token.content = replaceAt(token.content, t.index, APOSTROPHE);
      }
    }
  }
}


module.exports = function smartquotes(state) {
  /*eslint max-depth:0*/
  var blkIdx;

  if (!state.md.options.typographer) { return; }

  for (blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--) {

    if (state.tokens[blkIdx].type !== 'inline' ||
        !QUOTE_TEST_RE.test(state.tokens[blkIdx].content)) {
      continue;
    }

    process_inlines(state.tokens[blkIdx].children, state);
  }
};


/***/ }),

/***/ 67681:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Core state object
//


var Token = __webpack_require__(98114);


function StateCore(src, md, env) {
  this.src = src;
  this.env = env;
  this.tokens = [];
  this.inlineMode = false;
  this.md = md; // link to parser instance
}

// re-export Token class to use in core rules
StateCore.prototype.Token = Token;


module.exports = StateCore;


/***/ }),

/***/ 34627:
/***/ ((module) => {

"use strict";
// Process autolinks '<protocol:...>'




/*eslint max-len:0*/
var EMAIL_RE    = /^([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/;
var AUTOLINK_RE = /^([a-zA-Z][a-zA-Z0-9+.\-]{1,31}):([^<>\x00-\x20]*)$/;


module.exports = function autolink(state, silent) {
  var url, fullUrl, token, ch, start, max,
      pos = state.pos;

  if (state.src.charCodeAt(pos) !== 0x3C/* < */) { return false; }

  start = state.pos;
  max = state.posMax;

  for (;;) {
    if (++pos >= max) return false;

    ch = state.src.charCodeAt(pos);

    if (ch === 0x3C /* < */) return false;
    if (ch === 0x3E /* > */) break;
  }

  url = state.src.slice(start + 1, pos);

  if (AUTOLINK_RE.test(url)) {
    fullUrl = state.md.normalizeLink(url);
    if (!state.md.validateLink(fullUrl)) { return false; }

    if (!silent) {
      token         = state.push('link_open', 'a', 1);
      token.attrs   = [ [ 'href', fullUrl ] ];
      token.markup  = 'autolink';
      token.info    = 'auto';

      token         = state.push('text', '', 0);
      token.content = state.md.normalizeLinkText(url);

      token         = state.push('link_close', 'a', -1);
      token.markup  = 'autolink';
      token.info    = 'auto';
    }

    state.pos += url.length + 2;
    return true;
  }

  if (EMAIL_RE.test(url)) {
    fullUrl = state.md.normalizeLink('mailto:' + url);
    if (!state.md.validateLink(fullUrl)) { return false; }

    if (!silent) {
      token         = state.push('link_open', 'a', 1);
      token.attrs   = [ [ 'href', fullUrl ] ];
      token.markup  = 'autolink';
      token.info    = 'auto';

      token         = state.push('text', '', 0);
      token.content = state.md.normalizeLinkText(url);

      token         = state.push('link_close', 'a', -1);
      token.markup  = 'autolink';
      token.info    = 'auto';
    }

    state.pos += url.length + 2;
    return true;
  }

  return false;
};


/***/ }),

/***/ 5691:
/***/ ((module) => {

"use strict";
// Parse backticks




module.exports = function backtick(state, silent) {
  var start, max, marker, token, matchStart, matchEnd, openerLength, closerLength,
      pos = state.pos,
      ch = state.src.charCodeAt(pos);

  if (ch !== 0x60/* ` */) { return false; }

  start = pos;
  pos++;
  max = state.posMax;

  // scan marker length
  while (pos < max && state.src.charCodeAt(pos) === 0x60/* ` */) { pos++; }

  marker = state.src.slice(start, pos);
  openerLength = marker.length;

  if (state.backticksScanned && (state.backticks[openerLength] || 0) <= start) {
    if (!silent) state.pending += marker;
    state.pos += openerLength;
    return true;
  }

  matchStart = matchEnd = pos;

  // Nothing found in the cache, scan until the end of the line (or until marker is found)
  while ((matchStart = state.src.indexOf('`', matchEnd)) !== -1) {
    matchEnd = matchStart + 1;

    // scan marker length
    while (matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60/* ` */) { matchEnd++; }

    closerLength = matchEnd - matchStart;

    if (closerLength === openerLength) {
      // Found matching closer length.
      if (!silent) {
        token     = state.push('code_inline', 'code', 0);
        token.markup  = marker;
        token.content = state.src.slice(pos, matchStart)
          .replace(/\n/g, ' ')
          .replace(/^ (.+) $/, '$1');
      }
      state.pos = matchEnd;
      return true;
    }

    // Some different length found, put it in cache as upper limit of where closer can be found
    state.backticks[closerLength] = matchStart;
  }

  // Scanned through the end, didn't find anything
  state.backticksScanned = true;

  if (!silent) state.pending += marker;
  state.pos += openerLength;
  return true;
};


/***/ }),

/***/ 40469:
/***/ ((module) => {

"use strict";
// For each opening emphasis-like marker find a matching closing one
//



function processDelimiters(state, delimiters) {
  var closerIdx, openerIdx, closer, opener, minOpenerIdx, newMinOpenerIdx,
      isOddMatch, lastJump,
      openersBottom = {},
      max = delimiters.length;

  for (closerIdx = 0; closerIdx < max; closerIdx++) {
    closer = delimiters[closerIdx];

    // Length is only used for emphasis-specific "rule of 3",
    // if it's not defined (in strikethrough or 3rd party plugins),
    // we can default it to 0 to disable those checks.
    //
    closer.length = closer.length || 0;

    if (!closer.close) continue;

    // Previously calculated lower bounds (previous fails)
    // for each marker, each delimiter length modulo 3,
    // and for whether this closer can be an opener;
    // https://github.com/commonmark/cmark/commit/34250e12ccebdc6372b8b49c44fab57c72443460
    if (!openersBottom.hasOwnProperty(closer.marker)) {
      openersBottom[closer.marker] = [ -1, -1, -1, -1, -1, -1 ];
    }

    minOpenerIdx = openersBottom[closer.marker][(closer.open ? 3 : 0) + (closer.length % 3)];

    openerIdx = closerIdx - closer.jump - 1;

    // avoid crash if `closer.jump` is pointing outside of the array, see #742
    if (openerIdx < -1) openerIdx = -1;

    newMinOpenerIdx = openerIdx;

    for (; openerIdx > minOpenerIdx; openerIdx -= opener.jump + 1) {
      opener = delimiters[openerIdx];

      if (opener.marker !== closer.marker) continue;

      if (opener.open && opener.end < 0) {

        isOddMatch = false;

        // from spec:
        //
        // If one of the delimiters can both open and close emphasis, then the
        // sum of the lengths of the delimiter runs containing the opening and
        // closing delimiters must not be a multiple of 3 unless both lengths
        // are multiples of 3.
        //
        if (opener.close || closer.open) {
          if ((opener.length + closer.length) % 3 === 0) {
            if (opener.length % 3 !== 0 || closer.length % 3 !== 0) {
              isOddMatch = true;
            }
          }
        }

        if (!isOddMatch) {
          // If previous delimiter cannot be an opener, we can safely skip
          // the entire sequence in future checks. This is required to make
          // sure algorithm has linear complexity (see *_*_*_*_*_... case).
          //
          lastJump = openerIdx > 0 && !delimiters[openerIdx - 1].open ?
            delimiters[openerIdx - 1].jump + 1 :
            0;

          closer.jump  = closerIdx - openerIdx + lastJump;
          closer.open  = false;
          opener.end   = closerIdx;
          opener.jump  = lastJump;
          opener.close = false;
          newMinOpenerIdx = -1;
          break;
        }
      }
    }

    if (newMinOpenerIdx !== -1) {
      // If match for this delimiter run failed, we want to set lower bound for
      // future lookups. This is required to make sure algorithm has linear
      // complexity.
      //
      // See details here:
      // https://github.com/commonmark/cmark/issues/178#issuecomment-270417442
      //
      openersBottom[closer.marker][(closer.open ? 3 : 0) + ((closer.length || 0) % 3)] = newMinOpenerIdx;
    }
  }
}


module.exports = function link_pairs(state) {
  var curr,
      tokens_meta = state.tokens_meta,
      max = state.tokens_meta.length;

  processDelimiters(state, state.delimiters);

  for (curr = 0; curr < max; curr++) {
    if (tokens_meta[curr] && tokens_meta[curr].delimiters) {
      processDelimiters(state, tokens_meta[curr].delimiters);
    }
  }
};


/***/ }),

/***/ 36522:
/***/ ((module) => {

"use strict";
// Process *this* and _that_
//



// Insert each marker as a separate text token, and add it to delimiter list
//
module.exports.w = function emphasis(state, silent) {
  var i, scanned, token,
      start = state.pos,
      marker = state.src.charCodeAt(start);

  if (silent) { return false; }

  if (marker !== 0x5F /* _ */ && marker !== 0x2A /* * */) { return false; }

  scanned = state.scanDelims(state.pos, marker === 0x2A);

  for (i = 0; i < scanned.length; i++) {
    token         = state.push('text', '', 0);
    token.content = String.fromCharCode(marker);

    state.delimiters.push({
      // Char code of the starting marker (number).
      //
      marker: marker,

      // Total length of these series of delimiters.
      //
      length: scanned.length,

      // An amount of characters before this one that's equivalent to
      // current one. In plain English: if this delimiter does not open
      // an emphasis, neither do previous `jump` characters.
      //
      // Used to skip sequences like "*****" in one step, for 1st asterisk
      // value will be 0, for 2nd it's 1 and so on.
      //
      jump:   i,

      // A position of the token this delimiter corresponds to.
      //
      token:  state.tokens.length - 1,

      // If this delimiter is matched as a valid opener, `end` will be
      // equal to its position, otherwise it's `-1`.
      //
      end:    -1,

      // Boolean flags that determine if this delimiter could open or close
      // an emphasis.
      //
      open:   scanned.can_open,
      close:  scanned.can_close
    });
  }

  state.pos += scanned.length;

  return true;
};


function postProcess(state, delimiters) {
  var i,
      startDelim,
      endDelim,
      token,
      ch,
      isStrong,
      max = delimiters.length;

  for (i = max - 1; i >= 0; i--) {
    startDelim = delimiters[i];

    if (startDelim.marker !== 0x5F/* _ */ && startDelim.marker !== 0x2A/* * */) {
      continue;
    }

    // Process only opening markers
    if (startDelim.end === -1) {
      continue;
    }

    endDelim = delimiters[startDelim.end];

    // If the previous delimiter has the same marker and is adjacent to this one,
    // merge those into one strong delimiter.
    //
    // `<em><em>whatever</em></em>` -> `<strong>whatever</strong>`
    //
    isStrong = i > 0 &&
               delimiters[i - 1].end === startDelim.end + 1 &&
               delimiters[i - 1].token === startDelim.token - 1 &&
               delimiters[startDelim.end + 1].token === endDelim.token + 1 &&
               delimiters[i - 1].marker === startDelim.marker;

    ch = String.fromCharCode(startDelim.marker);

    token         = state.tokens[startDelim.token];
    token.type    = isStrong ? 'strong_open' : 'em_open';
    token.tag     = isStrong ? 'strong' : 'em';
    token.nesting = 1;
    token.markup  = isStrong ? ch + ch : ch;
    token.content = '';

    token         = state.tokens[endDelim.token];
    token.type    = isStrong ? 'strong_close' : 'em_close';
    token.tag     = isStrong ? 'strong' : 'em';
    token.nesting = -1;
    token.markup  = isStrong ? ch + ch : ch;
    token.content = '';

    if (isStrong) {
      state.tokens[delimiters[i - 1].token].content = '';
      state.tokens[delimiters[startDelim.end + 1].token].content = '';
      i--;
    }
  }
}


// Walk through delimiter list and replace text tokens with tags
//
module.exports.g = function emphasis(state) {
  var curr,
      tokens_meta = state.tokens_meta,
      max = state.tokens_meta.length;

  postProcess(state, state.delimiters);

  for (curr = 0; curr < max; curr++) {
    if (tokens_meta[curr] && tokens_meta[curr].delimiters) {
      postProcess(state, tokens_meta[curr].delimiters);
    }
  }
};


/***/ }),

/***/ 72105:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Process html entity - &#123;, &#xAF;, &quot;, ...



var entities          = __webpack_require__(83630);
var has               = (__webpack_require__(26212).has);
var isValidEntityCode = (__webpack_require__(26212).isValidEntityCode);
var fromCodePoint     = (__webpack_require__(26212).fromCodePoint);


var DIGITAL_RE = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i;
var NAMED_RE   = /^&([a-z][a-z0-9]{1,31});/i;


module.exports = function entity(state, silent) {
  var ch, code, match, pos = state.pos, max = state.posMax;

  if (state.src.charCodeAt(pos) !== 0x26/* & */) { return false; }

  if (pos + 1 < max) {
    ch = state.src.charCodeAt(pos + 1);

    if (ch === 0x23 /* # */) {
      match = state.src.slice(pos).match(DIGITAL_RE);
      if (match) {
        if (!silent) {
          code = match[1][0].toLowerCase() === 'x' ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
          state.pending += isValidEntityCode(code) ? fromCodePoint(code) : fromCodePoint(0xFFFD);
        }
        state.pos += match[0].length;
        return true;
      }
    } else {
      match = state.src.slice(pos).match(NAMED_RE);
      if (match) {
        if (has(entities, match[1])) {
          if (!silent) { state.pending += entities[match[1]]; }
          state.pos += match[0].length;
          return true;
        }
      }
    }
  }

  if (!silent) { state.pending += '&'; }
  state.pos++;
  return true;
};


/***/ }),

/***/ 95674:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Process escaped chars and hardbreaks



var isSpace = (__webpack_require__(26212).isSpace);

var ESCAPED = [];

for (var i = 0; i < 256; i++) { ESCAPED.push(0); }

'\\!"#$%&\'()*+,./:;<=>?@[]^_`{|}~-'
  .split('').forEach(function (ch) { ESCAPED[ch.charCodeAt(0)] = 1; });


module.exports = function escape(state, silent) {
  var ch, pos = state.pos, max = state.posMax;

  if (state.src.charCodeAt(pos) !== 0x5C/* \ */) { return false; }

  pos++;

  if (pos < max) {
    ch = state.src.charCodeAt(pos);

    if (ch < 256 && ESCAPED[ch] !== 0) {
      if (!silent) { state.pending += state.src[pos]; }
      state.pos += 2;
      return true;
    }

    if (ch === 0x0A) {
      if (!silent) {
        state.push('hardbreak', 'br', 0);
      }

      pos++;
      // skip leading whitespaces from next line
      while (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!isSpace(ch)) { break; }
        pos++;
      }

      state.pos = pos;
      return true;
    }
  }

  if (!silent) { state.pending += '\\'; }
  state.pos++;
  return true;
};


/***/ }),

/***/ 97845:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Process html tags




var HTML_TAG_RE = (__webpack_require__(26517)/* .HTML_TAG_RE */ .n);


function isLetter(ch) {
  /*eslint no-bitwise:0*/
  var lc = ch | 0x20; // to lower case
  return (lc >= 0x61/* a */) && (lc <= 0x7a/* z */);
}


module.exports = function html_inline(state, silent) {
  var ch, match, max, token,
      pos = state.pos;

  if (!state.md.options.html) { return false; }

  // Check start
  max = state.posMax;
  if (state.src.charCodeAt(pos) !== 0x3C/* < */ ||
      pos + 2 >= max) {
    return false;
  }

  // Quick fail on second char
  ch = state.src.charCodeAt(pos + 1);
  if (ch !== 0x21/* ! */ &&
      ch !== 0x3F/* ? */ &&
      ch !== 0x2F/* / */ &&
      !isLetter(ch)) {
    return false;
  }

  match = state.src.slice(pos).match(HTML_TAG_RE);
  if (!match) { return false; }

  if (!silent) {
    token         = state.push('html_inline', '', 0);
    token.content = state.src.slice(pos, pos + match[0].length);
  }
  state.pos += match[0].length;
  return true;
};


/***/ }),

/***/ 29192:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Process ![image](<src> "title")



var normalizeReference   = (__webpack_require__(26212).normalizeReference);
var isSpace              = (__webpack_require__(26212).isSpace);


module.exports = function image(state, silent) {
  var attrs,
      code,
      content,
      label,
      labelEnd,
      labelStart,
      pos,
      ref,
      res,
      title,
      token,
      tokens,
      start,
      href = '',
      oldPos = state.pos,
      max = state.posMax;

  if (state.src.charCodeAt(state.pos) !== 0x21/* ! */) { return false; }
  if (state.src.charCodeAt(state.pos + 1) !== 0x5B/* [ */) { return false; }

  labelStart = state.pos + 2;
  labelEnd = state.md.helpers.parseLinkLabel(state, state.pos + 1, false);

  // parser failed to find ']', so it's not a valid link
  if (labelEnd < 0) { return false; }

  pos = labelEnd + 1;
  if (pos < max && state.src.charCodeAt(pos) === 0x28/* ( */) {
    //
    // Inline link
    //

    // [link](  <href>  "title"  )
    //        ^^ skipping these spaces
    pos++;
    for (; pos < max; pos++) {
      code = state.src.charCodeAt(pos);
      if (!isSpace(code) && code !== 0x0A) { break; }
    }
    if (pos >= max) { return false; }

    // [link](  <href>  "title"  )
    //          ^^^^^^ parsing link destination
    start = pos;
    res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
    if (res.ok) {
      href = state.md.normalizeLink(res.str);
      if (state.md.validateLink(href)) {
        pos = res.pos;
      } else {
        href = '';
      }
    }

    // [link](  <href>  "title"  )
    //                ^^ skipping these spaces
    start = pos;
    for (; pos < max; pos++) {
      code = state.src.charCodeAt(pos);
      if (!isSpace(code) && code !== 0x0A) { break; }
    }

    // [link](  <href>  "title"  )
    //                  ^^^^^^^ parsing link title
    res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
    if (pos < max && start !== pos && res.ok) {
      title = res.str;
      pos = res.pos;

      // [link](  <href>  "title"  )
      //                         ^^ skipping these spaces
      for (; pos < max; pos++) {
        code = state.src.charCodeAt(pos);
        if (!isSpace(code) && code !== 0x0A) { break; }
      }
    } else {
      title = '';
    }

    if (pos >= max || state.src.charCodeAt(pos) !== 0x29/* ) */) {
      state.pos = oldPos;
      return false;
    }
    pos++;
  } else {
    //
    // Link reference
    //
    if (typeof state.env.references === 'undefined') { return false; }

    if (pos < max && state.src.charCodeAt(pos) === 0x5B/* [ */) {
      start = pos + 1;
      pos = state.md.helpers.parseLinkLabel(state, pos);
      if (pos >= 0) {
        label = state.src.slice(start, pos++);
      } else {
        pos = labelEnd + 1;
      }
    } else {
      pos = labelEnd + 1;
    }

    // covers label === '' and label === undefined
    // (collapsed reference link and shortcut reference link respectively)
    if (!label) { label = state.src.slice(labelStart, labelEnd); }

    ref = state.env.references[normalizeReference(label)];
    if (!ref) {
      state.pos = oldPos;
      return false;
    }
    href = ref.href;
    title = ref.title;
  }

  //
  // We found the end of the link, and know for a fact it's a valid link;
  // so all that's left to do is to call tokenizer.
  //
  if (!silent) {
    content = state.src.slice(labelStart, labelEnd);

    state.md.inline.parse(
      content,
      state.md,
      state.env,
      tokens = []
    );

    token          = state.push('image', 'img', 0);
    token.attrs    = attrs = [ [ 'src', href ], [ 'alt', '' ] ];
    token.children = tokens;
    token.content  = content;

    if (title) {
      attrs.push([ 'title', title ]);
    }
  }

  state.pos = pos;
  state.posMax = max;
  return true;
};


/***/ }),

/***/ 70027:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Process [link](<to> "stuff")



var normalizeReference   = (__webpack_require__(26212).normalizeReference);
var isSpace              = (__webpack_require__(26212).isSpace);


module.exports = function link(state, silent) {
  var attrs,
      code,
      label,
      labelEnd,
      labelStart,
      pos,
      res,
      ref,
      token,
      href = '',
      title = '',
      oldPos = state.pos,
      max = state.posMax,
      start = state.pos,
      parseReference = true;

  if (state.src.charCodeAt(state.pos) !== 0x5B/* [ */) { return false; }

  labelStart = state.pos + 1;
  labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);

  // parser failed to find ']', so it's not a valid link
  if (labelEnd < 0) { return false; }

  pos = labelEnd + 1;
  if (pos < max && state.src.charCodeAt(pos) === 0x28/* ( */) {
    //
    // Inline link
    //

    // might have found a valid shortcut link, disable reference parsing
    parseReference = false;

    // [link](  <href>  "title"  )
    //        ^^ skipping these spaces
    pos++;
    for (; pos < max; pos++) {
      code = state.src.charCodeAt(pos);
      if (!isSpace(code) && code !== 0x0A) { break; }
    }
    if (pos >= max) { return false; }

    // [link](  <href>  "title"  )
    //          ^^^^^^ parsing link destination
    start = pos;
    res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
    if (res.ok) {
      href = state.md.normalizeLink(res.str);
      if (state.md.validateLink(href)) {
        pos = res.pos;
      } else {
        href = '';
      }

      // [link](  <href>  "title"  )
      //                ^^ skipping these spaces
      start = pos;
      for (; pos < max; pos++) {
        code = state.src.charCodeAt(pos);
        if (!isSpace(code) && code !== 0x0A) { break; }
      }

      // [link](  <href>  "title"  )
      //                  ^^^^^^^ parsing link title
      res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
      if (pos < max && start !== pos && res.ok) {
        title = res.str;
        pos = res.pos;

        // [link](  <href>  "title"  )
        //                         ^^ skipping these spaces
        for (; pos < max; pos++) {
          code = state.src.charCodeAt(pos);
          if (!isSpace(code) && code !== 0x0A) { break; }
        }
      }
    }

    if (pos >= max || state.src.charCodeAt(pos) !== 0x29/* ) */) {
      // parsing a valid shortcut link failed, fallback to reference
      parseReference = true;
    }
    pos++;
  }

  if (parseReference) {
    //
    // Link reference
    //
    if (typeof state.env.references === 'undefined') { return false; }

    if (pos < max && state.src.charCodeAt(pos) === 0x5B/* [ */) {
      start = pos + 1;
      pos = state.md.helpers.parseLinkLabel(state, pos);
      if (pos >= 0) {
        label = state.src.slice(start, pos++);
      } else {
        pos = labelEnd + 1;
      }
    } else {
      pos = labelEnd + 1;
    }

    // covers label === '' and label === undefined
    // (collapsed reference link and shortcut reference link respectively)
    if (!label) { label = state.src.slice(labelStart, labelEnd); }

    ref = state.env.references[normalizeReference(label)];
    if (!ref) {
      state.pos = oldPos;
      return false;
    }
    href = ref.href;
    title = ref.title;
  }

  //
  // We found the end of the link, and know for a fact it's a valid link;
  // so all that's left to do is to call tokenizer.
  //
  if (!silent) {
    state.pos = labelStart;
    state.posMax = labelEnd;

    token        = state.push('link_open', 'a', 1);
    token.attrs  = attrs = [ [ 'href', href ] ];
    if (title) {
      attrs.push([ 'title', title ]);
    }

    state.md.inline.tokenize(state);

    token        = state.push('link_close', 'a', -1);
  }

  state.pos = pos;
  state.posMax = max;
  return true;
};


/***/ }),

/***/ 40183:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Proceess '\n'



var isSpace = (__webpack_require__(26212).isSpace);


module.exports = function newline(state, silent) {
  var pmax, max, pos = state.pos;

  if (state.src.charCodeAt(pos) !== 0x0A/* \n */) { return false; }

  pmax = state.pending.length - 1;
  max = state.posMax;

  // '  \n' -> hardbreak
  // Lookup in pending chars is bad practice! Don't copy to other rules!
  // Pending string is stored in concat mode, indexed lookups will cause
  // convertion to flat mode.
  if (!silent) {
    if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
      if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
        state.pending = state.pending.replace(/ +$/, '');
        state.push('hardbreak', 'br', 0);
      } else {
        state.pending = state.pending.slice(0, -1);
        state.push('softbreak', 'br', 0);
      }

    } else {
      state.push('softbreak', 'br', 0);
    }
  }

  pos++;

  // skip heading spaces for next line
  while (pos < max && isSpace(state.src.charCodeAt(pos))) { pos++; }

  state.pos = pos;
  return true;
};


/***/ }),

/***/ 62418:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Inline parser state




var Token          = __webpack_require__(98114);
var isWhiteSpace   = (__webpack_require__(26212).isWhiteSpace);
var isPunctChar    = (__webpack_require__(26212).isPunctChar);
var isMdAsciiPunct = (__webpack_require__(26212).isMdAsciiPunct);


function StateInline(src, md, env, outTokens) {
  this.src = src;
  this.env = env;
  this.md = md;
  this.tokens = outTokens;
  this.tokens_meta = Array(outTokens.length);

  this.pos = 0;
  this.posMax = this.src.length;
  this.level = 0;
  this.pending = '';
  this.pendingLevel = 0;

  // Stores { start: end } pairs. Useful for backtrack
  // optimization of pairs parse (emphasis, strikes).
  this.cache = {};

  // List of emphasis-like delimiters for current tag
  this.delimiters = [];

  // Stack of delimiter lists for upper level tags
  this._prev_delimiters = [];

  // backtick length => last seen position
  this.backticks = {};
  this.backticksScanned = false;
}


// Flush pending text
//
StateInline.prototype.pushPending = function () {
  var token = new Token('text', '', 0);
  token.content = this.pending;
  token.level = this.pendingLevel;
  this.tokens.push(token);
  this.pending = '';
  return token;
};


// Push new token to "stream".
// If pending text exists - flush it as text token
//
StateInline.prototype.push = function (type, tag, nesting) {
  if (this.pending) {
    this.pushPending();
  }

  var token = new Token(type, tag, nesting);
  var token_meta = null;

  if (nesting < 0) {
    // closing tag
    this.level--;
    this.delimiters = this._prev_delimiters.pop();
  }

  token.level = this.level;

  if (nesting > 0) {
    // opening tag
    this.level++;
    this._prev_delimiters.push(this.delimiters);
    this.delimiters = [];
    token_meta = { delimiters: this.delimiters };
  }

  this.pendingLevel = this.level;
  this.tokens.push(token);
  this.tokens_meta.push(token_meta);
  return token;
};


// Scan a sequence of emphasis-like markers, and determine whether
// it can start an emphasis sequence or end an emphasis sequence.
//
//  - start - position to scan from (it should point at a valid marker);
//  - canSplitWord - determine if these markers can be found inside a word
//
StateInline.prototype.scanDelims = function (start, canSplitWord) {
  var pos = start, lastChar, nextChar, count, can_open, can_close,
      isLastWhiteSpace, isLastPunctChar,
      isNextWhiteSpace, isNextPunctChar,
      left_flanking = true,
      right_flanking = true,
      max = this.posMax,
      marker = this.src.charCodeAt(start);

  // treat beginning of the line as a whitespace
  lastChar = start > 0 ? this.src.charCodeAt(start - 1) : 0x20;

  while (pos < max && this.src.charCodeAt(pos) === marker) { pos++; }

  count = pos - start;

  // treat end of the line as a whitespace
  nextChar = pos < max ? this.src.charCodeAt(pos) : 0x20;

  isLastPunctChar = isMdAsciiPunct(lastChar) || isPunctChar(String.fromCharCode(lastChar));
  isNextPunctChar = isMdAsciiPunct(nextChar) || isPunctChar(String.fromCharCode(nextChar));

  isLastWhiteSpace = isWhiteSpace(lastChar);
  isNextWhiteSpace = isWhiteSpace(nextChar);

  if (isNextWhiteSpace) {
    left_flanking = false;
  } else if (isNextPunctChar) {
    if (!(isLastWhiteSpace || isLastPunctChar)) {
      left_flanking = false;
    }
  }

  if (isLastWhiteSpace) {
    right_flanking = false;
  } else if (isLastPunctChar) {
    if (!(isNextWhiteSpace || isNextPunctChar)) {
      right_flanking = false;
    }
  }

  if (!canSplitWord) {
    can_open  = left_flanking  && (!right_flanking || isLastPunctChar);
    can_close = right_flanking && (!left_flanking  || isNextPunctChar);
  } else {
    can_open  = left_flanking;
    can_close = right_flanking;
  }

  return {
    can_open:  can_open,
    can_close: can_close,
    length:    count
  };
};


// re-export Token class to use in block rules
StateInline.prototype.Token = Token;


module.exports = StateInline;


/***/ }),

/***/ 26472:
/***/ ((module) => {

"use strict";
// ~~strike through~~
//



// Insert each marker as a separate text token, and add it to delimiter list
//
module.exports.w = function strikethrough(state, silent) {
  var i, scanned, token, len, ch,
      start = state.pos,
      marker = state.src.charCodeAt(start);

  if (silent) { return false; }

  if (marker !== 0x7E/* ~ */) { return false; }

  scanned = state.scanDelims(state.pos, true);
  len = scanned.length;
  ch = String.fromCharCode(marker);

  if (len < 2) { return false; }

  if (len % 2) {
    token         = state.push('text', '', 0);
    token.content = ch;
    len--;
  }

  for (i = 0; i < len; i += 2) {
    token         = state.push('text', '', 0);
    token.content = ch + ch;

    state.delimiters.push({
      marker: marker,
      length: 0,     // disable "rule of 3" length checks meant for emphasis
      jump:   i / 2, // for `~~` 1 marker = 2 characters
      token:  state.tokens.length - 1,
      end:    -1,
      open:   scanned.can_open,
      close:  scanned.can_close
    });
  }

  state.pos += scanned.length;

  return true;
};


function postProcess(state, delimiters) {
  var i, j,
      startDelim,
      endDelim,
      token,
      loneMarkers = [],
      max = delimiters.length;

  for (i = 0; i < max; i++) {
    startDelim = delimiters[i];

    if (startDelim.marker !== 0x7E/* ~ */) {
      continue;
    }

    if (startDelim.end === -1) {
      continue;
    }

    endDelim = delimiters[startDelim.end];

    token         = state.tokens[startDelim.token];
    token.type    = 's_open';
    token.tag     = 's';
    token.nesting = 1;
    token.markup  = '~~';
    token.content = '';

    token         = state.tokens[endDelim.token];
    token.type    = 's_close';
    token.tag     = 's';
    token.nesting = -1;
    token.markup  = '~~';
    token.content = '';

    if (state.tokens[endDelim.token - 1].type === 'text' &&
        state.tokens[endDelim.token - 1].content === '~') {

      loneMarkers.push(endDelim.token - 1);
    }
  }

  // If a marker sequence has an odd number of characters, it's splitted
  // like this: `~~~~~` -> `~` + `~~` + `~~`, leaving one marker at the
  // start of the sequence.
  //
  // So, we have to move all those markers after subsequent s_close tags.
  //
  while (loneMarkers.length) {
    i = loneMarkers.pop();
    j = i + 1;

    while (j < state.tokens.length && state.tokens[j].type === 's_close') {
      j++;
    }

    j--;

    if (i !== j) {
      token = state.tokens[j];
      state.tokens[j] = state.tokens[i];
      state.tokens[i] = token;
    }
  }
}


// Walk through delimiter list and replace text tokens with tags
//
module.exports.g = function strikethrough(state) {
  var curr,
      tokens_meta = state.tokens_meta,
      max = state.tokens_meta.length;

  postProcess(state, state.delimiters);

  for (curr = 0; curr < max; curr++) {
    if (tokens_meta[curr] && tokens_meta[curr].delimiters) {
      postProcess(state, tokens_meta[curr].delimiters);
    }
  }
};


/***/ }),

/***/ 11854:
/***/ ((module) => {

"use strict";
// Skip text characters for text token, place those to pending buffer
// and increment current pos




// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions

// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~

// !!!! Don't confuse with "Markdown ASCII Punctuation" chars
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
function isTerminatorChar(ch) {
  switch (ch) {
    case 0x0A/* \n */:
    case 0x21/* ! */:
    case 0x23/* # */:
    case 0x24/* $ */:
    case 0x25/* % */:
    case 0x26/* & */:
    case 0x2A/* * */:
    case 0x2B/* + */:
    case 0x2D/* - */:
    case 0x3A/* : */:
    case 0x3C/* < */:
    case 0x3D/* = */:
    case 0x3E/* > */:
    case 0x40/* @ */:
    case 0x5B/* [ */:
    case 0x5C/* \ */:
    case 0x5D/* ] */:
    case 0x5E/* ^ */:
    case 0x5F/* _ */:
    case 0x60/* ` */:
    case 0x7B/* { */:
    case 0x7D/* } */:
    case 0x7E/* ~ */:
      return true;
    default:
      return false;
  }
}

module.exports = function text(state, silent) {
  var pos = state.pos;

  while (pos < state.posMax && !isTerminatorChar(state.src.charCodeAt(pos))) {
    pos++;
  }

  if (pos === state.pos) { return false; }

  if (!silent) { state.pending += state.src.slice(state.pos, pos); }

  state.pos = pos;

  return true;
};

// Alternative implementation, for memory.
//
// It costs 10% of performance, but allows extend terminators list, if place it
// to `ParcerInline` property. Probably, will switch to it sometime, such
// flexibility required.

/*
var TERMINATOR_RE = /[\n!#$%&*+\-:<=>@[\\\]^_`{}~]/;

module.exports = function text(state, silent) {
  var pos = state.pos,
      idx = state.src.slice(pos).search(TERMINATOR_RE);

  // first char is terminator -> empty text
  if (idx === 0) { return false; }

  // no terminator -> text till end of string
  if (idx < 0) {
    if (!silent) { state.pending += state.src.slice(pos); }
    state.pos = state.src.length;
    return true;
  }

  if (!silent) { state.pending += state.src.slice(pos, pos + idx); }

  state.pos += idx;

  return true;
};*/


/***/ }),

/***/ 83514:
/***/ ((module) => {

"use strict";
// Clean up tokens after emphasis and strikethrough postprocessing:
// merge adjacent text nodes into one and re-calculate all token levels
//
// This is necessary because initially emphasis delimiter markers (*, _, ~)
// are treated as their own separate text tokens. Then emphasis rule either
// leaves them as text (needed to merge with adjacent text) or turns them
// into opening/closing tags (which messes up levels inside).
//



module.exports = function text_collapse(state) {
  var curr, last,
      level = 0,
      tokens = state.tokens,
      max = state.tokens.length;

  for (curr = last = 0; curr < max; curr++) {
    // re-calculate levels after emphasis/strikethrough turns some text nodes
    // into opening/closing tags
    if (tokens[curr].nesting < 0) level--; // closing tag
    tokens[curr].level = level;
    if (tokens[curr].nesting > 0) level++; // opening tag

    if (tokens[curr].type === 'text' &&
        curr + 1 < max &&
        tokens[curr + 1].type === 'text') {

      // collapse two adjacent text nodes
      tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
    } else {
      if (curr !== last) { tokens[last] = tokens[curr]; }

      last++;
    }
  }

  if (curr !== last) {
    tokens.length = last;
  }
};


/***/ }),

/***/ 98114:
/***/ ((module) => {

"use strict";
// Token class




/**
 * class Token
 **/

/**
 * new Token(type, tag, nesting)
 *
 * Create new token and fill passed properties.
 **/
function Token(type, tag, nesting) {
  /**
   * Token#type -> String
   *
   * Type of the token (string, e.g. "paragraph_open")
   **/
  this.type     = type;

  /**
   * Token#tag -> String
   *
   * html tag name, e.g. "p"
   **/
  this.tag      = tag;

  /**
   * Token#attrs -> Array
   *
   * Html attributes. Format: `[ [ name1, value1 ], [ name2, value2 ] ]`
   **/
  this.attrs    = null;

  /**
   * Token#map -> Array
   *
   * Source map info. Format: `[ line_begin, line_end ]`
   **/
  this.map      = null;

  /**
   * Token#nesting -> Number
   *
   * Level change (number in {-1, 0, 1} set), where:
   *
   * -  `1` means the tag is opening
   * -  `0` means the tag is self-closing
   * - `-1` means the tag is closing
   **/
  this.nesting  = nesting;

  /**
   * Token#level -> Number
   *
   * nesting level, the same as `state.level`
   **/
  this.level    = 0;

  /**
   * Token#children -> Array
   *
   * An array of child nodes (inline and img tokens)
   **/
  this.children = null;

  /**
   * Token#content -> String
   *
   * In a case of self-closing tag (code, html, fence, etc.),
   * it has contents of this tag.
   **/
  this.content  = '';

  /**
   * Token#markup -> String
   *
   * '*' or '_' for emphasis, fence string for fence, etc.
   **/
  this.markup   = '';

  /**
   * Token#info -> String
   *
   * Additional information:
   *
   * - Info string for "fence" tokens
   * - The value "auto" for autolink "link_open" and "link_close" tokens
   * - The string value of the item marker for ordered-list "list_item_open" tokens
   **/
  this.info     = '';

  /**
   * Token#meta -> Object
   *
   * A place for plugins to store an arbitrary data
   **/
  this.meta     = null;

  /**
   * Token#block -> Boolean
   *
   * True for block-level tokens, false for inline tokens.
   * Used in renderer to calculate line breaks
   **/
  this.block    = false;

  /**
   * Token#hidden -> Boolean
   *
   * If it's true, ignore this element when rendering. Used for tight lists
   * to hide paragraphs.
   **/
  this.hidden   = false;
}


/**
 * Token.attrIndex(name) -> Number
 *
 * Search attribute index by name.
 **/
Token.prototype.attrIndex = function attrIndex(name) {
  var attrs, i, len;

  if (!this.attrs) { return -1; }

  attrs = this.attrs;

  for (i = 0, len = attrs.length; i < len; i++) {
    if (attrs[i][0] === name) { return i; }
  }
  return -1;
};


/**
 * Token.attrPush(attrData)
 *
 * Add `[ name, value ]` attribute to list. Init attrs if necessary
 **/
Token.prototype.attrPush = function attrPush(attrData) {
  if (this.attrs) {
    this.attrs.push(attrData);
  } else {
    this.attrs = [ attrData ];
  }
};


/**
 * Token.attrSet(name, value)
 *
 * Set `name` attribute to `value`. Override old value if exists.
 **/
Token.prototype.attrSet = function attrSet(name, value) {
  var idx = this.attrIndex(name),
      attrData = [ name, value ];

  if (idx < 0) {
    this.attrPush(attrData);
  } else {
    this.attrs[idx] = attrData;
  }
};


/**
 * Token.attrGet(name)
 *
 * Get the value of attribute `name`, or null if it does not exist.
 **/
Token.prototype.attrGet = function attrGet(name) {
  var idx = this.attrIndex(name), value = null;
  if (idx >= 0) {
    value = this.attrs[idx][1];
  }
  return value;
};


/**
 * Token.attrJoin(name, value)
 *
 * Join value to existing attribute via space. Or create new attribute if not
 * exists. Useful to operate with token classes.
 **/
Token.prototype.attrJoin = function attrJoin(name, value) {
  var idx = this.attrIndex(name);

  if (idx < 0) {
    this.attrPush([ name, value ]);
  } else {
    this.attrs[idx][1] = this.attrs[idx][1] + ' ' + value;
  }
};


module.exports = Token;


/***/ }),

/***/ 18585:
/***/ ((module) => {

"use strict";




/* eslint-disable no-bitwise */

var decodeCache = {};

function getDecodeCache(exclude) {
  var i, ch, cache = decodeCache[exclude];
  if (cache) { return cache; }

  cache = decodeCache[exclude] = [];

  for (i = 0; i < 128; i++) {
    ch = String.fromCharCode(i);
    cache.push(ch);
  }

  for (i = 0; i < exclude.length; i++) {
    ch = exclude.charCodeAt(i);
    cache[ch] = '%' + ('0' + ch.toString(16).toUpperCase()).slice(-2);
  }

  return cache;
}


// Decode percent-encoded string.
//
function decode(string, exclude) {
  var cache;

  if (typeof exclude !== 'string') {
    exclude = decode.defaultChars;
  }

  cache = getDecodeCache(exclude);

  return string.replace(/(%[a-f0-9]{2})+/gi, function(seq) {
    var i, l, b1, b2, b3, b4, chr,
        result = '';

    for (i = 0, l = seq.length; i < l; i += 3) {
      b1 = parseInt(seq.slice(i + 1, i + 3), 16);

      if (b1 < 0x80) {
        result += cache[b1];
        continue;
      }

      if ((b1 & 0xE0) === 0xC0 && (i + 3 < l)) {
        // 110xxxxx 10xxxxxx
        b2 = parseInt(seq.slice(i + 4, i + 6), 16);

        if ((b2 & 0xC0) === 0x80) {
          chr = ((b1 << 6) & 0x7C0) | (b2 & 0x3F);

          if (chr < 0x80) {
            result += '\ufffd\ufffd';
          } else {
            result += String.fromCharCode(chr);
          }

          i += 3;
          continue;
        }
      }

      if ((b1 & 0xF0) === 0xE0 && (i + 6 < l)) {
        // 1110xxxx 10xxxxxx 10xxxxxx
        b2 = parseInt(seq.slice(i + 4, i + 6), 16);
        b3 = parseInt(seq.slice(i + 7, i + 9), 16);

        if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
          chr = ((b1 << 12) & 0xF000) | ((b2 << 6) & 0xFC0) | (b3 & 0x3F);

          if (chr < 0x800 || (chr >= 0xD800 && chr <= 0xDFFF)) {
            result += '\ufffd\ufffd\ufffd';
          } else {
            result += String.fromCharCode(chr);
          }

          i += 6;
          continue;
        }
      }

      if ((b1 & 0xF8) === 0xF0 && (i + 9 < l)) {
        // 111110xx 10xxxxxx 10xxxxxx 10xxxxxx
        b2 = parseInt(seq.slice(i + 4, i + 6), 16);
        b3 = parseInt(seq.slice(i + 7, i + 9), 16);
        b4 = parseInt(seq.slice(i + 10, i + 12), 16);

        if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80 && (b4 & 0xC0) === 0x80) {
          chr = ((b1 << 18) & 0x1C0000) | ((b2 << 12) & 0x3F000) | ((b3 << 6) & 0xFC0) | (b4 & 0x3F);

          if (chr < 0x10000 || chr > 0x10FFFF) {
            result += '\ufffd\ufffd\ufffd\ufffd';
          } else {
            chr -= 0x10000;
            result += String.fromCharCode(0xD800 + (chr >> 10), 0xDC00 + (chr & 0x3FF));
          }

          i += 9;
          continue;
        }
      }

      result += '\ufffd';
    }

    return result;
  });
}


decode.defaultChars   = ';/?:@&=+$,#';
decode.componentChars = '';


module.exports = decode;


/***/ }),

/***/ 5704:
/***/ ((module) => {

"use strict";




var encodeCache = {};


// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function getEncodeCache(exclude) {
  var i, ch, cache = encodeCache[exclude];
  if (cache) { return cache; }

  cache = encodeCache[exclude] = [];

  for (i = 0; i < 128; i++) {
    ch = String.fromCharCode(i);

    if (/^[0-9a-z]$/i.test(ch)) {
      // always allow unencoded alphanumeric characters
      cache.push(ch);
    } else {
      cache.push('%' + ('0' + i.toString(16).toUpperCase()).slice(-2));
    }
  }

  for (i = 0; i < exclude.length; i++) {
    cache[exclude.charCodeAt(i)] = exclude[i];
  }

  return cache;
}


// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function encode(string, exclude, keepEscaped) {
  var i, l, code, nextCode, cache,
      result = '';

  if (typeof exclude !== 'string') {
    // encode(string, keepEscaped)
    keepEscaped  = exclude;
    exclude = encode.defaultChars;
  }

  if (typeof keepEscaped === 'undefined') {
    keepEscaped = true;
  }

  cache = getEncodeCache(exclude);

  for (i = 0, l = string.length; i < l; i++) {
    code = string.charCodeAt(i);

    if (keepEscaped && code === 0x25 /* % */ && i + 2 < l) {
      if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
        result += string.slice(i, i + 3);
        i += 2;
        continue;
      }
    }

    if (code < 128) {
      result += cache[code];
      continue;
    }

    if (code >= 0xD800 && code <= 0xDFFF) {
      if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
        nextCode = string.charCodeAt(i + 1);
        if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
          result += encodeURIComponent(string[i] + string[i + 1]);
          i++;
          continue;
        }
      }
      result += '%EF%BF%BD';
      continue;
    }

    result += encodeURIComponent(string[i]);
  }

  return result;
}

encode.defaultChars   = ";/?:@&=+$,-_.!~*'()#";
encode.componentChars = "-_.!~*'()";


module.exports = encode;


/***/ }),

/***/ 39481:
/***/ ((module) => {

"use strict";




module.exports = function format(url) {
  var result = '';

  result += url.protocol || '';
  result += url.slashes ? '//' : '';
  result += url.auth ? url.auth + '@' : '';

  if (url.hostname && url.hostname.indexOf(':') !== -1) {
    // ipv6 address
    result += '[' + url.hostname + ']';
  } else {
    result += url.hostname || '';
  }

  result += url.port ? ':' + url.port : '';
  result += url.pathname || '';
  result += url.search || '';
  result += url.hash || '';

  return result;
};


/***/ }),

/***/ 12449:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";



module.exports.encode = __webpack_require__(5704);
module.exports.decode = __webpack_require__(18585);
module.exports.format = __webpack_require__(39481);
module.exports.parse = __webpack_require__(25979);


/***/ }),

/***/ 25979:
/***/ ((module) => {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



//
// Changes from joyent/node:
//
// 1. No leading slash in paths,
//    e.g. in `url.parse('http://foo?bar')` pathname is ``, not `/`
//
// 2. Backslashes are not replaced with slashes,
//    so `http:\\example.org\` is treated like a relative path
//
// 3. Trailing colon is treated like a part of the path,
//    i.e. in `http://example.org:foo` pathname is `:foo`
//
// 4. Nothing is URL-encoded in the resulting object,
//    (in joyent/node some chars in auth and paths are encoded)
//
// 5. `url.parse()` does not have `parseQueryString` argument
//
// 6. Removed extraneous result properties: `host`, `path`, `query`, etc.,
//    which can be constructed using other parts of the url.
//


function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.pathname = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = [ '<', '>', '"', '`', ' ', '\r', '\n', '\t' ],

    // RFC 2396: characters not allowed for various reasons.
    unwise = [ '{', '}', '|', '\\', '^', '`' ].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = [ '\'' ].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = [ '%', '/', '?', ';', '#' ].concat(autoEscape),
    hostEndingChars = [ '/', '?', '#' ],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    /* eslint-disable no-script-url */
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    };
    /* eslint-enable no-script-url */

function urlParse(url, slashesDenoteHost) {
  if (url && url instanceof Url) { return url; }

  var u = new Url();
  u.parse(url, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, slashesDenoteHost) {
  var i, l, lowerProto, hec, slashes,
      rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    lowerProto = proto.toLowerCase();
    this.protocol = proto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (i = 0; i < hostEndingChars.length; i++) {
      hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) {
        hostEnd = hec;
      }
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = auth;
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (i = 0; i < nonHostChars.length; i++) {
      hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) {
        hostEnd = hec;
      }
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1) {
      hostEnd = rest.length;
    }

    if (rest[hostEnd - 1] === ':') { hostEnd--; }
    var host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost(host);

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) { continue; }
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    }

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
    }
  }

  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    rest = rest.slice(0, qm);
  }
  if (rest) { this.pathname = rest; }
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '';
  }

  return this;
};

Url.prototype.parseHost = function(host) {
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) { this.hostname = host; }
};

module.exports = urlParse;


/***/ }),

/***/ 34538:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(57002);
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}


/***/ }),

/***/ 14224:
/***/ ((module) => {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 20061:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


const canPromise = __webpack_require__(2999)

const QRCode = __webpack_require__(43451)
const CanvasRenderer = __webpack_require__(42513)
const SvgRenderer = __webpack_require__(51478)

function renderCanvas (renderFunc, canvas, text, opts, cb) {
  const args = [].slice.call(arguments, 1)
  const argsNum = args.length
  const isLastArgCb = typeof args[argsNum - 1] === 'function'

  if (!isLastArgCb && !canPromise()) {
    throw new Error('Callback required as last argument')
  }

  if (isLastArgCb) {
    if (argsNum < 2) {
      throw new Error('Too few arguments provided')
    }

    if (argsNum === 2) {
      cb = text
      text = canvas
      canvas = opts = undefined
    } else if (argsNum === 3) {
      if (canvas.getContext && typeof cb === 'undefined') {
        cb = opts
        opts = undefined
      } else {
        cb = opts
        opts = text
        text = canvas
        canvas = undefined
      }
    }
  } else {
    if (argsNum < 1) {
      throw new Error('Too few arguments provided')
    }

    if (argsNum === 1) {
      text = canvas
      canvas = opts = undefined
    } else if (argsNum === 2 && !canvas.getContext) {
      opts = text
      text = canvas
      canvas = undefined
    }

    return new Promise(function (resolve, reject) {
      try {
        const data = QRCode.create(text, opts)
        resolve(renderFunc(data, canvas, opts))
      } catch (e) {
        reject(e)
      }
    })
  }

  try {
    const data = QRCode.create(text, opts)
    cb(null, renderFunc(data, canvas, opts))
  } catch (e) {
    cb(e)
  }
}

exports.create = QRCode.create
exports.toCanvas = renderCanvas.bind(null, CanvasRenderer.render)
exports.toDataURL = renderCanvas.bind(null, CanvasRenderer.renderToDataURL)

// only svg for now.
exports.toString = renderCanvas.bind(null, function (data, _, opts) {
  return SvgRenderer.render(data, opts)
})


/***/ }),

/***/ 2999:
/***/ ((module) => {

// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157

module.exports = function () {
  return typeof Promise === 'function' && Promise.prototype && Promise.prototype.then
}


/***/ }),

/***/ 96684:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */

const getSymbolSize = (__webpack_require__(79006).getSymbolSize)

/**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */
exports.getRowColCoords = function getRowColCoords (version) {
  if (version === 1) return []

  const posCount = Math.floor(version / 7) + 2
  const size = getSymbolSize(version)
  const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2
  const positions = [size - 7] // Last coord is always (size - 7)

  for (let i = 1; i < posCount - 1; i++) {
    positions[i] = positions[i - 1] - intervals
  }

  positions.push(6) // First coord is always 6

  return positions.reverse()
}

/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */
exports.getPositions = function getPositions (version) {
  const coords = []
  const pos = exports.getRowColCoords(version)
  const posLength = pos.length

  for (let i = 0; i < posLength; i++) {
    for (let j = 0; j < posLength; j++) {
      // Skip if position is occupied by finder patterns
      if ((i === 0 && j === 0) || // top-left
          (i === 0 && j === posLength - 1) || // bottom-left
          (i === posLength - 1 && j === 0)) { // top-right
        continue
      }

      coords.push([pos[i], pos[j]])
    }
  }

  return coords
}


/***/ }),

/***/ 89012:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

const Mode = __webpack_require__(21493)

/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */
const ALPHA_NUM_CHARS = [
  '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
  'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
  'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
  ' ', '$', '%', '*', '+', '-', '.', '/', ':'
]

function AlphanumericData (data) {
  this.mode = Mode.ALPHANUMERIC
  this.data = data
}

AlphanumericData.getBitsLength = function getBitsLength (length) {
  return 11 * Math.floor(length / 2) + 6 * (length % 2)
}

AlphanumericData.prototype.getLength = function getLength () {
  return this.data.length
}

AlphanumericData.prototype.getBitsLength = function getBitsLength () {
  return AlphanumericData.getBitsLength(this.data.length)
}

AlphanumericData.prototype.write = function write (bitBuffer) {
  let i

  // Input data characters are divided into groups of two characters
  // and encoded as 11-bit binary codes.
  for (i = 0; i + 2 <= this.data.length; i += 2) {
    // The character value of the first character is multiplied by 45
    let value = ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45

    // The character value of the second digit is added to the product
    value += ALPHA_NUM_CHARS.indexOf(this.data[i + 1])

    // The sum is then stored as 11-bit binary number
    bitBuffer.put(value, 11)
  }

  // If the number of input data characters is not a multiple of two,
  // the character value of the final character is encoded as a 6-bit binary number.
  if (this.data.length % 2) {
    bitBuffer.put(ALPHA_NUM_CHARS.indexOf(this.data[i]), 6)
  }
}

module.exports = AlphanumericData


/***/ }),

/***/ 16597:
/***/ ((module) => {

function BitBuffer () {
  this.buffer = []
  this.length = 0
}

BitBuffer.prototype = {

  get: function (index) {
    const bufIndex = Math.floor(index / 8)
    return ((this.buffer[bufIndex] >>> (7 - index % 8)) & 1) === 1
  },

  put: function (num, length) {
    for (let i = 0; i < length; i++) {
      this.putBit(((num >>> (length - i - 1)) & 1) === 1)
    }
  },

  getLengthInBits: function () {
    return this.length
  },

  putBit: function (bit) {
    const bufIndex = Math.floor(this.length / 8)
    if (this.buffer.length <= bufIndex) {
      this.buffer.push(0)
    }

    if (bit) {
      this.buffer[bufIndex] |= (0x80 >>> (this.length % 8))
    }

    this.length++
  }
}

module.exports = BitBuffer


/***/ }),

/***/ 79913:
/***/ ((module) => {

/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */
function BitMatrix (size) {
  if (!size || size < 1) {
    throw new Error('BitMatrix size must be defined and greater than 0')
  }

  this.size = size
  this.data = new Uint8Array(size * size)
  this.reservedBit = new Uint8Array(size * size)
}

/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */
BitMatrix.prototype.set = function (row, col, value, reserved) {
  const index = row * this.size + col
  this.data[index] = value
  if (reserved) this.reservedBit[index] = true
}

/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */
BitMatrix.prototype.get = function (row, col) {
  return this.data[row * this.size + col]
}

/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */
BitMatrix.prototype.xor = function (row, col, value) {
  this.data[row * this.size + col] ^= value
}

/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */
BitMatrix.prototype.isReserved = function (row, col) {
  return this.reservedBit[row * this.size + col]
}

module.exports = BitMatrix


/***/ }),

/***/ 89735:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

const Mode = __webpack_require__(21493)

function ByteData (data) {
  this.mode = Mode.BYTE
  if (typeof (data) === 'string') {
    this.data = new TextEncoder().encode(data)
  } else {
    this.data = new Uint8Array(data)
  }
}

ByteData.getBitsLength = function getBitsLength (length) {
  return length * 8
}

ByteData.prototype.getLength = function getLength () {
  return this.data.length
}

ByteData.prototype.getBitsLength = function getBitsLength () {
  return ByteData.getBitsLength(this.data.length)
}

ByteData.prototype.write = function (bitBuffer) {
  for (let i = 0, l = this.data.length; i < l; i++) {
    bitBuffer.put(this.data[i], 8)
  }
}

module.exports = ByteData


/***/ }),

/***/ 13675:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

const ECLevel = __webpack_require__(17630)

const EC_BLOCKS_TABLE = [
// L  M  Q  H
  1, 1, 1, 1,
  1, 1, 1, 1,
  1, 1, 2, 2,
  1, 2, 2, 4,
  1, 2, 4, 4,
  2, 4, 4, 4,
  2, 4, 6, 5,
  2, 4, 6, 6,
  2, 5, 8, 8,
  4, 5, 8, 8,
  4, 5, 8, 11,
  4, 8, 10, 11,
  4, 9, 12, 16,
  4, 9, 16, 16,
  6, 10, 12, 18,
  6, 10, 17, 16,
  6, 11, 16, 19,
  6, 13, 18, 21,
  7, 14, 21, 25,
  8, 16, 20, 25,
  8, 17, 23, 25,
  9, 17, 23, 34,
  9, 18, 25, 30,
  10, 20, 27, 32,
  12, 21, 29, 35,
  12, 23, 34, 37,
  12, 25, 34, 40,
  13, 26, 35, 42,
  14, 28, 38, 45,
  15, 29, 40, 48,
  16, 31, 43, 51,
  17, 33, 45, 54,
  18, 35, 48, 57,
  19, 37, 51, 60,
  19, 38, 53, 63,
  20, 40, 56, 66,
  21, 43, 59, 70,
  22, 45, 62, 74,
  24, 47, 65, 77,
  25, 49, 68, 81
]

const EC_CODEWORDS_TABLE = [
// L  M  Q  H
  7, 10, 13, 17,
  10, 16, 22, 28,
  15, 26, 36, 44,
  20, 36, 52, 64,
  26, 48, 72, 88,
  36, 64, 96, 112,
  40, 72, 108, 130,
  48, 88, 132, 156,
  60, 110, 160, 192,
  72, 130, 192, 224,
  80, 150, 224, 264,
  96, 176, 260, 308,
  104, 198, 288, 352,
  120, 216, 320, 384,
  132, 240, 360, 432,
  144, 280, 408, 480,
  168, 308, 448, 532,
  180, 338, 504, 588,
  196, 364, 546, 650,
  224, 416, 600, 700,
  224, 442, 644, 750,
  252, 476, 690, 816,
  270, 504, 750, 900,
  300, 560, 810, 960,
  312, 588, 870, 1050,
  336, 644, 952, 1110,
  360, 700, 1020, 1200,
  390, 728, 1050, 1260,
  420, 784, 1140, 1350,
  450, 812, 1200, 1440,
  480, 868, 1290, 1530,
  510, 924, 1350, 1620,
  540, 980, 1440, 1710,
  570, 1036, 1530, 1800,
  570, 1064, 1590, 1890,
  600, 1120, 1680, 1980,
  630, 1204, 1770, 2100,
  660, 1260, 1860, 2220,
  720, 1316, 1950, 2310,
  750, 1372, 2040, 2430
]

/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */
exports.getBlocksCount = function getBlocksCount (version, errorCorrectionLevel) {
  switch (errorCorrectionLevel) {
    case ECLevel.L:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 0]
    case ECLevel.M:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 1]
    case ECLevel.Q:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 2]
    case ECLevel.H:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 3]
    default:
      return undefined
  }
}

/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */
exports.getTotalCodewordsCount = function getTotalCodewordsCount (version, errorCorrectionLevel) {
  switch (errorCorrectionLevel) {
    case ECLevel.L:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 0]
    case ECLevel.M:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 1]
    case ECLevel.Q:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 2]
    case ECLevel.H:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 3]
    default:
      return undefined
  }
}


/***/ }),

/***/ 17630:
/***/ ((__unused_webpack_module, exports) => {

exports.L = { bit: 1 }
exports.M = { bit: 0 }
exports.Q = { bit: 3 }
exports.H = { bit: 2 }

function fromString (string) {
  if (typeof string !== 'string') {
    throw new Error('Param is not a string')
  }

  const lcStr = string.toLowerCase()

  switch (lcStr) {
    case 'l':
    case 'low':
      return exports.L

    case 'm':
    case 'medium':
      return exports.M

    case 'q':
    case 'quartile':
      return exports.Q

    case 'h':
    case 'high':
      return exports.H

    default:
      throw new Error('Unknown EC Level: ' + string)
  }
}

exports.isValid = function isValid (level) {
  return level && typeof level.bit !== 'undefined' &&
    level.bit >= 0 && level.bit < 4
}

exports.from = function from (value, defaultValue) {
  if (exports.isValid(value)) {
    return value
  }

  try {
    return fromString(value)
  } catch (e) {
    return defaultValue
  }
}


/***/ }),

/***/ 80844:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

const getSymbolSize = (__webpack_require__(79006).getSymbolSize)
const FINDER_PATTERN_SIZE = 7

/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */
exports.getPositions = function getPositions (version) {
  const size = getSymbolSize(version)

  return [
    // top-left
    [0, 0],
    // top-right
    [size - FINDER_PATTERN_SIZE, 0],
    // bottom-left
    [0, size - FINDER_PATTERN_SIZE]
  ]
}


/***/ }),

/***/ 20114:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

const Utils = __webpack_require__(79006)

const G15 = (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0)
const G15_MASK = (1 << 14) | (1 << 12) | (1 << 10) | (1 << 4) | (1 << 1)
const G15_BCH = Utils.getBCHDigit(G15)

/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */
exports.getEncodedBits = function getEncodedBits (errorCorrectionLevel, mask) {
  const data = ((errorCorrectionLevel.bit << 3) | mask)
  let d = data << 10

  while (Utils.getBCHDigit(d) - G15_BCH >= 0) {
    d ^= (G15 << (Utils.getBCHDigit(d) - G15_BCH))
  }

  // xor final data with mask pattern in order to ensure that
  // no combination of Error Correction Level and data mask pattern
  // will result in an all-zero data string
  return ((data << 10) | d) ^ G15_MASK
}


/***/ }),

/***/ 63278:
/***/ ((__unused_webpack_module, exports) => {

const EXP_TABLE = new Uint8Array(512)
const LOG_TABLE = new Uint8Array(256)
/**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */
;(function initTables () {
  let x = 1
  for (let i = 0; i < 255; i++) {
    EXP_TABLE[i] = x
    LOG_TABLE[x] = i

    x <<= 1 // multiply by 2

    // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
    // This means that when a number is 256 or larger, it should be XORed with 0x11D.
    if (x & 0x100) { // similar to x >= 256, but a lot faster (because 0x100 == 256)
      x ^= 0x11D
    }
  }

  // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
  // stay inside the bounds (because we will mainly use this table for the multiplication of
  // two GF numbers, no more).
  // @see {@link mul}
  for (let i = 255; i < 512; i++) {
    EXP_TABLE[i] = EXP_TABLE[i - 255]
  }
}())

/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */
exports.log = function log (n) {
  if (n < 1) throw new Error('log(' + n + ')')
  return LOG_TABLE[n]
}

/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */
exports.exp = function exp (n) {
  return EXP_TABLE[n]
}

/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */
exports.mul = function mul (x, y) {
  if (x === 0 || y === 0) return 0

  // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
  // @see {@link initTables}
  return EXP_TABLE[LOG_TABLE[x] + LOG_TABLE[y]]
}


/***/ }),

/***/ 59359:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

const Mode = __webpack_require__(21493)
const Utils = __webpack_require__(79006)

function KanjiData (data) {
  this.mode = Mode.KANJI
  this.data = data
}

KanjiData.getBitsLength = function getBitsLength (length) {
  return length * 13
}

KanjiData.prototype.getLength = function getLength () {
  return this.data.length
}

KanjiData.prototype.getBitsLength = function getBitsLength () {
  return KanjiData.getBitsLength(this.data.length)
}

KanjiData.prototype.write = function (bitBuffer) {
  let i

  // In the Shift JIS system, Kanji characters are represented by a two byte combination.
  // These byte values are shifted from the JIS X 0208 values.
  // JIS X 0208 gives details of the shift coded representation.
  for (i = 0; i < this.data.length; i++) {
    let value = Utils.toSJIS(this.data[i])

    // For characters with Shift JIS values from 0x8140 to 0x9FFC:
    if (value >= 0x8140 && value <= 0x9FFC) {
      // Subtract 0x8140 from Shift JIS value
      value -= 0x8140

    // For characters with Shift JIS values from 0xE040 to 0xEBBF
    } else if (value >= 0xE040 && value <= 0xEBBF) {
      // Subtract 0xC140 from Shift JIS value
      value -= 0xC140
    } else {
      throw new Error(
        'Invalid SJIS character: ' + this.data[i] + '\n' +
        'Make sure your charset is UTF-8')
    }

    // Multiply most significant byte of result by 0xC0
    // and add least significant byte to product
    value = (((value >>> 8) & 0xff) * 0xC0) + (value & 0xff)

    // Convert result to a 13-bit binary string
    bitBuffer.put(value, 13)
  }
}

module.exports = KanjiData


/***/ }),

/***/ 95040:
/***/ ((__unused_webpack_module, exports) => {

/**
 * Data mask pattern reference
 * @type {Object}
 */
exports.Patterns = {
  PATTERN000: 0,
  PATTERN001: 1,
  PATTERN010: 2,
  PATTERN011: 3,
  PATTERN100: 4,
  PATTERN101: 5,
  PATTERN110: 6,
  PATTERN111: 7
}

/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */
const PenaltyScores = {
  N1: 3,
  N2: 3,
  N3: 40,
  N4: 10
}

/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */
exports.isValid = function isValid (mask) {
  return mask != null && mask !== '' && !isNaN(mask) && mask >= 0 && mask <= 7
}

/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */
exports.from = function from (value) {
  return exports.isValid(value) ? parseInt(value, 10) : undefined
}

/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/
exports.getPenaltyN1 = function getPenaltyN1 (data) {
  const size = data.size
  let points = 0
  let sameCountCol = 0
  let sameCountRow = 0
  let lastCol = null
  let lastRow = null

  for (let row = 0; row < size; row++) {
    sameCountCol = sameCountRow = 0
    lastCol = lastRow = null

    for (let col = 0; col < size; col++) {
      let module = data.get(row, col)
      if (module === lastCol) {
        sameCountCol++
      } else {
        if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5)
        lastCol = module
        sameCountCol = 1
      }

      module = data.get(col, row)
      if (module === lastRow) {
        sameCountRow++
      } else {
        if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5)
        lastRow = module
        sameCountRow = 1
      }
    }

    if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5)
    if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5)
  }

  return points
}

/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */
exports.getPenaltyN2 = function getPenaltyN2 (data) {
  const size = data.size
  let points = 0

  for (let row = 0; row < size - 1; row++) {
    for (let col = 0; col < size - 1; col++) {
      const last = data.get(row, col) +
        data.get(row, col + 1) +
        data.get(row + 1, col) +
        data.get(row + 1, col + 1)

      if (last === 4 || last === 0) points++
    }
  }

  return points * PenaltyScores.N2
}

/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */
exports.getPenaltyN3 = function getPenaltyN3 (data) {
  const size = data.size
  let points = 0
  let bitsCol = 0
  let bitsRow = 0

  for (let row = 0; row < size; row++) {
    bitsCol = bitsRow = 0
    for (let col = 0; col < size; col++) {
      bitsCol = ((bitsCol << 1) & 0x7FF) | data.get(row, col)
      if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++

      bitsRow = ((bitsRow << 1) & 0x7FF) | data.get(col, row)
      if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++
    }
  }

  return points * PenaltyScores.N3
}

/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */
exports.getPenaltyN4 = function getPenaltyN4 (data) {
  let darkCount = 0
  const modulesCount = data.data.length

  for (let i = 0; i < modulesCount; i++) darkCount += data.data[i]

  const k = Math.abs(Math.ceil((darkCount * 100 / modulesCount) / 5) - 10)

  return k * PenaltyScores.N4
}

/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */
function getMaskAt (maskPattern, i, j) {
  switch (maskPattern) {
    case exports.Patterns.PATTERN000: return (i + j) % 2 === 0
    case exports.Patterns.PATTERN001: return i % 2 === 0
    case exports.Patterns.PATTERN010: return j % 3 === 0
    case exports.Patterns.PATTERN011: return (i + j) % 3 === 0
    case exports.Patterns.PATTERN100: return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0
    case exports.Patterns.PATTERN101: return (i * j) % 2 + (i * j) % 3 === 0
    case exports.Patterns.PATTERN110: return ((i * j) % 2 + (i * j) % 3) % 2 === 0
    case exports.Patterns.PATTERN111: return ((i * j) % 3 + (i + j) % 2) % 2 === 0

    default: throw new Error('bad maskPattern:' + maskPattern)
  }
}

/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */
exports.applyMask = function applyMask (pattern, data) {
  const size = data.size

  for (let col = 0; col < size; col++) {
    for (let row = 0; row < size; row++) {
      if (data.isReserved(row, col)) continue
      data.xor(row, col, getMaskAt(pattern, row, col))
    }
  }
}

/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */
exports.getBestMask = function getBestMask (data, setupFormatFunc) {
  const numPatterns = Object.keys(exports.Patterns).length
  let bestPattern = 0
  let lowerPenalty = Infinity

  for (let p = 0; p < numPatterns; p++) {
    setupFormatFunc(p)
    exports.applyMask(p, data)

    // Calculate penalty
    const penalty =
      exports.getPenaltyN1(data) +
      exports.getPenaltyN2(data) +
      exports.getPenaltyN3(data) +
      exports.getPenaltyN4(data)

    // Undo previously applied mask
    exports.applyMask(p, data)

    if (penalty < lowerPenalty) {
      lowerPenalty = penalty
      bestPattern = p
    }
  }

  return bestPattern
}


/***/ }),

/***/ 21493:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

const VersionCheck = __webpack_require__(43327)
const Regex = __webpack_require__(95270)

/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */
exports.NUMERIC = {
  id: 'Numeric',
  bit: 1 << 0,
  ccBits: [10, 12, 14]
}

/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */
exports.ALPHANUMERIC = {
  id: 'Alphanumeric',
  bit: 1 << 1,
  ccBits: [9, 11, 13]
}

/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */
exports.BYTE = {
  id: 'Byte',
  bit: 1 << 2,
  ccBits: [8, 16, 16]
}

/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */
exports.KANJI = {
  id: 'Kanji',
  bit: 1 << 3,
  ccBits: [8, 10, 12]
}

/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */
exports.MIXED = {
  bit: -1
}

/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */
exports.getCharCountIndicator = function getCharCountIndicator (mode, version) {
  if (!mode.ccBits) throw new Error('Invalid mode: ' + mode)

  if (!VersionCheck.isValid(version)) {
    throw new Error('Invalid version: ' + version)
  }

  if (version >= 1 && version < 10) return mode.ccBits[0]
  else if (version < 27) return mode.ccBits[1]
  return mode.ccBits[2]
}

/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */
exports.getBestModeForData = function getBestModeForData (dataStr) {
  if (Regex.testNumeric(dataStr)) return exports.NUMERIC
  else if (Regex.testAlphanumeric(dataStr)) return exports.ALPHANUMERIC
  else if (Regex.testKanji(dataStr)) return exports.KANJI
  else return exports.BYTE
}

/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */
exports.toString = function toString (mode) {
  if (mode && mode.id) return mode.id
  throw new Error('Invalid mode')
}

/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */
exports.isValid = function isValid (mode) {
  return mode && mode.bit && mode.ccBits
}

/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */
function fromString (string) {
  if (typeof string !== 'string') {
    throw new Error('Param is not a string')
  }

  const lcStr = string.toLowerCase()

  switch (lcStr) {
    case 'numeric':
      return exports.NUMERIC
    case 'alphanumeric':
      return exports.ALPHANUMERIC
    case 'kanji':
      return exports.KANJI
    case 'byte':
      return exports.BYTE
    default:
      throw new Error('Unknown mode: ' + string)
  }
}

/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */
exports.from = function from (value, defaultValue) {
  if (exports.isValid(value)) {
    return value
  }

  try {
    return fromString(value)
  } catch (e) {
    return defaultValue
  }
}


/***/ }),

/***/ 92818:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

const Mode = __webpack_require__(21493)

function NumericData (data) {
  this.mode = Mode.NUMERIC
  this.data = data.toString()
}

NumericData.getBitsLength = function getBitsLength (length) {
  return 10 * Math.floor(length / 3) + ((length % 3) ? ((length % 3) * 3 + 1) : 0)
}

NumericData.prototype.getLength = function getLength () {
  return this.data.length
}

NumericData.prototype.getBitsLength = function getBitsLength () {
  return NumericData.getBitsLength(this.data.length)
}

NumericData.prototype.write = function write (bitBuffer) {
  let i, group, value

  // The input data string is divided into groups of three digits,
  // and each group is converted to its 10-bit binary equivalent.
  for (i = 0; i + 3 <= this.data.length; i += 3) {
    group = this.data.substr(i, 3)
    value = parseInt(group, 10)

    bitBuffer.put(value, 10)
  }

  // If the number of input digits is not an exact multiple of three,
  // the final one or two digits are converted to 4 or 7 bits respectively.
  const remainingNum = this.data.length - i
  if (remainingNum > 0) {
    group = this.data.substr(i)
    value = parseInt(group, 10)

    bitBuffer.put(value, remainingNum * 3 + 1)
  }
}

module.exports = NumericData


/***/ }),

/***/ 42631:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

const GF = __webpack_require__(63278)

/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */
exports.mul = function mul (p1, p2) {
  const coeff = new Uint8Array(p1.length + p2.length - 1)

  for (let i = 0; i < p1.length; i++) {
    for (let j = 0; j < p2.length; j++) {
      coeff[i + j] ^= GF.mul(p1[i], p2[j])
    }
  }

  return coeff
}

/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */
exports.mod = function mod (divident, divisor) {
  let result = new Uint8Array(divident)

  while ((result.length - divisor.length) >= 0) {
    const coeff = result[0]

    for (let i = 0; i < divisor.length; i++) {
      result[i] ^= GF.mul(divisor[i], coeff)
    }

    // remove all zeros from buffer head
    let offset = 0
    while (offset < result.length && result[offset] === 0) offset++
    result = result.slice(offset)
  }

  return result
}

/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */
exports.generateECPolynomial = function generateECPolynomial (degree) {
  let poly = new Uint8Array([1])
  for (let i = 0; i < degree; i++) {
    poly = exports.mul(poly, new Uint8Array([1, GF.exp(i)]))
  }

  return poly
}


/***/ }),

/***/ 43451:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

const Utils = __webpack_require__(79006)
const ECLevel = __webpack_require__(17630)
const BitBuffer = __webpack_require__(16597)
const BitMatrix = __webpack_require__(79913)
const AlignmentPattern = __webpack_require__(96684)
const FinderPattern = __webpack_require__(80844)
const MaskPattern = __webpack_require__(95040)
const ECCode = __webpack_require__(13675)
const ReedSolomonEncoder = __webpack_require__(87057)
const Version = __webpack_require__(13761)
const FormatInfo = __webpack_require__(20114)
const Mode = __webpack_require__(21493)
const Segments = __webpack_require__(17506)

/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/

/**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */
function setupFinderPattern (matrix, version) {
  const size = matrix.size
  const pos = FinderPattern.getPositions(version)

  for (let i = 0; i < pos.length; i++) {
    const row = pos[i][0]
    const col = pos[i][1]

    for (let r = -1; r <= 7; r++) {
      if (row + r <= -1 || size <= row + r) continue

      for (let c = -1; c <= 7; c++) {
        if (col + c <= -1 || size <= col + c) continue

        if ((r >= 0 && r <= 6 && (c === 0 || c === 6)) ||
          (c >= 0 && c <= 6 && (r === 0 || r === 6)) ||
          (r >= 2 && r <= 4 && c >= 2 && c <= 4)) {
          matrix.set(row + r, col + c, true, true)
        } else {
          matrix.set(row + r, col + c, false, true)
        }
      }
    }
  }
}

/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */
function setupTimingPattern (matrix) {
  const size = matrix.size

  for (let r = 8; r < size - 8; r++) {
    const value = r % 2 === 0
    matrix.set(r, 6, value, true)
    matrix.set(6, r, value, true)
  }
}

/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */
function setupAlignmentPattern (matrix, version) {
  const pos = AlignmentPattern.getPositions(version)

  for (let i = 0; i < pos.length; i++) {
    const row = pos[i][0]
    const col = pos[i][1]

    for (let r = -2; r <= 2; r++) {
      for (let c = -2; c <= 2; c++) {
        if (r === -2 || r === 2 || c === -2 || c === 2 ||
          (r === 0 && c === 0)) {
          matrix.set(row + r, col + c, true, true)
        } else {
          matrix.set(row + r, col + c, false, true)
        }
      }
    }
  }
}

/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */
function setupVersionInfo (matrix, version) {
  const size = matrix.size
  const bits = Version.getEncodedBits(version)
  let row, col, mod

  for (let i = 0; i < 18; i++) {
    row = Math.floor(i / 3)
    col = i % 3 + size - 8 - 3
    mod = ((bits >> i) & 1) === 1

    matrix.set(row, col, mod, true)
    matrix.set(col, row, mod, true)
  }
}

/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */
function setupFormatInfo (matrix, errorCorrectionLevel, maskPattern) {
  const size = matrix.size
  const bits = FormatInfo.getEncodedBits(errorCorrectionLevel, maskPattern)
  let i, mod

  for (i = 0; i < 15; i++) {
    mod = ((bits >> i) & 1) === 1

    // vertical
    if (i < 6) {
      matrix.set(i, 8, mod, true)
    } else if (i < 8) {
      matrix.set(i + 1, 8, mod, true)
    } else {
      matrix.set(size - 15 + i, 8, mod, true)
    }

    // horizontal
    if (i < 8) {
      matrix.set(8, size - i - 1, mod, true)
    } else if (i < 9) {
      matrix.set(8, 15 - i - 1 + 1, mod, true)
    } else {
      matrix.set(8, 15 - i - 1, mod, true)
    }
  }

  // fixed module
  matrix.set(size - 8, 8, 1, true)
}

/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */
function setupData (matrix, data) {
  const size = matrix.size
  let inc = -1
  let row = size - 1
  let bitIndex = 7
  let byteIndex = 0

  for (let col = size - 1; col > 0; col -= 2) {
    if (col === 6) col--

    while (true) {
      for (let c = 0; c < 2; c++) {
        if (!matrix.isReserved(row, col - c)) {
          let dark = false

          if (byteIndex < data.length) {
            dark = (((data[byteIndex] >>> bitIndex) & 1) === 1)
          }

          matrix.set(row, col - c, dark)
          bitIndex--

          if (bitIndex === -1) {
            byteIndex++
            bitIndex = 7
          }
        }
      }

      row += inc

      if (row < 0 || size <= row) {
        row -= inc
        inc = -inc
        break
      }
    }
  }
}

/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */
function createData (version, errorCorrectionLevel, segments) {
  // Prepare data buffer
  const buffer = new BitBuffer()

  segments.forEach(function (data) {
    // prefix data with mode indicator (4 bits)
    buffer.put(data.mode.bit, 4)

    // Prefix data with character count indicator.
    // The character count indicator is a string of bits that represents the
    // number of characters that are being encoded.
    // The character count indicator must be placed after the mode indicator
    // and must be a certain number of bits long, depending on the QR version
    // and data mode
    // @see {@link Mode.getCharCountIndicator}.
    buffer.put(data.getLength(), Mode.getCharCountIndicator(data.mode, version))

    // add binary data sequence to buffer
    data.write(buffer)
  })

  // Calculate required number of bits
  const totalCodewords = Utils.getSymbolTotalCodewords(version)
  const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel)
  const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8

  // Add a terminator.
  // If the bit string is shorter than the total number of required bits,
  // a terminator of up to four 0s must be added to the right side of the string.
  // If the bit string is more than four bits shorter than the required number of bits,
  // add four 0s to the end.
  if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) {
    buffer.put(0, 4)
  }

  // If the bit string is fewer than four bits shorter, add only the number of 0s that
  // are needed to reach the required number of bits.

  // After adding the terminator, if the number of bits in the string is not a multiple of 8,
  // pad the string on the right with 0s to make the string's length a multiple of 8.
  while (buffer.getLengthInBits() % 8 !== 0) {
    buffer.putBit(0)
  }

  // Add pad bytes if the string is still shorter than the total number of required bits.
  // Extend the buffer to fill the data capacity of the symbol corresponding to
  // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
  // and 00010001 (0x11) alternately.
  const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8
  for (let i = 0; i < remainingByte; i++) {
    buffer.put(i % 2 ? 0x11 : 0xEC, 8)
  }

  return createCodewords(buffer, version, errorCorrectionLevel)
}

/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */
function createCodewords (bitBuffer, version, errorCorrectionLevel) {
  // Total codewords for this QR code version (Data + Error correction)
  const totalCodewords = Utils.getSymbolTotalCodewords(version)

  // Total number of error correction codewords
  const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel)

  // Total number of data codewords
  const dataTotalCodewords = totalCodewords - ecTotalCodewords

  // Total number of blocks
  const ecTotalBlocks = ECCode.getBlocksCount(version, errorCorrectionLevel)

  // Calculate how many blocks each group should contain
  const blocksInGroup2 = totalCodewords % ecTotalBlocks
  const blocksInGroup1 = ecTotalBlocks - blocksInGroup2

  const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks)

  const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks)
  const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1

  // Number of EC codewords is the same for both groups
  const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1

  // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
  const rs = new ReedSolomonEncoder(ecCount)

  let offset = 0
  const dcData = new Array(ecTotalBlocks)
  const ecData = new Array(ecTotalBlocks)
  let maxDataSize = 0
  const buffer = new Uint8Array(bitBuffer.buffer)

  // Divide the buffer into the required number of blocks
  for (let b = 0; b < ecTotalBlocks; b++) {
    const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2

    // extract a block of data from buffer
    dcData[b] = buffer.slice(offset, offset + dataSize)

    // Calculate EC codewords for this data block
    ecData[b] = rs.encode(dcData[b])

    offset += dataSize
    maxDataSize = Math.max(maxDataSize, dataSize)
  }

  // Create final data
  // Interleave the data and error correction codewords from each block
  const data = new Uint8Array(totalCodewords)
  let index = 0
  let i, r

  // Add data codewords
  for (i = 0; i < maxDataSize; i++) {
    for (r = 0; r < ecTotalBlocks; r++) {
      if (i < dcData[r].length) {
        data[index++] = dcData[r][i]
      }
    }
  }

  // Apped EC codewords
  for (i = 0; i < ecCount; i++) {
    for (r = 0; r < ecTotalBlocks; r++) {
      data[index++] = ecData[r][i]
    }
  }

  return data
}

/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */
function createSymbol (data, version, errorCorrectionLevel, maskPattern) {
  let segments

  if (Array.isArray(data)) {
    segments = Segments.fromArray(data)
  } else if (typeof data === 'string') {
    let estimatedVersion = version

    if (!estimatedVersion) {
      const rawSegments = Segments.rawSplit(data)

      // Estimate best version that can contain raw splitted segments
      estimatedVersion = Version.getBestVersionForData(rawSegments, errorCorrectionLevel)
    }

    // Build optimized segments
    // If estimated version is undefined, try with the highest version
    segments = Segments.fromString(data, estimatedVersion || 40)
  } else {
    throw new Error('Invalid data')
  }

  // Get the min version that can contain data
  const bestVersion = Version.getBestVersionForData(segments, errorCorrectionLevel)

  // If no version is found, data cannot be stored
  if (!bestVersion) {
    throw new Error('The amount of data is too big to be stored in a QR Code')
  }

  // If not specified, use min version as default
  if (!version) {
    version = bestVersion

  // Check if the specified version can contain the data
  } else if (version < bestVersion) {
    throw new Error('\n' +
      'The chosen QR Code version cannot contain this amount of data.\n' +
      'Minimum version required to store current data is: ' + bestVersion + '.\n'
    )
  }

  const dataBits = createData(version, errorCorrectionLevel, segments)

  // Allocate matrix buffer
  const moduleCount = Utils.getSymbolSize(version)
  const modules = new BitMatrix(moduleCount)

  // Add function modules
  setupFinderPattern(modules, version)
  setupTimingPattern(modules)
  setupAlignmentPattern(modules, version)

  // Add temporary dummy bits for format info just to set them as reserved.
  // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
  // since the masking operation must be performed only on the encoding region.
  // These blocks will be replaced with correct values later in code.
  setupFormatInfo(modules, errorCorrectionLevel, 0)

  if (version >= 7) {
    setupVersionInfo(modules, version)
  }

  // Add data codewords
  setupData(modules, dataBits)

  if (isNaN(maskPattern)) {
    // Find best mask pattern
    maskPattern = MaskPattern.getBestMask(modules,
      setupFormatInfo.bind(null, modules, errorCorrectionLevel))
  }

  // Apply mask pattern
  MaskPattern.applyMask(maskPattern, modules)

  // Replace format info bits with correct values
  setupFormatInfo(modules, errorCorrectionLevel, maskPattern)

  return {
    modules: modules,
    version: version,
    errorCorrectionLevel: errorCorrectionLevel,
    maskPattern: maskPattern,
    segments: segments
  }
}

/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */
exports.create = function create (data, options) {
  if (typeof data === 'undefined' || data === '') {
    throw new Error('No input text')
  }

  let errorCorrectionLevel = ECLevel.M
  let version
  let mask

  if (typeof options !== 'undefined') {
    // Use higher error correction level as default
    errorCorrectionLevel = ECLevel.from(options.errorCorrectionLevel, ECLevel.M)
    version = Version.from(options.version)
    mask = MaskPattern.from(options.maskPattern)

    if (options.toSJISFunc) {
      Utils.setToSJISFunction(options.toSJISFunc)
    }
  }

  return createSymbol(data, version, errorCorrectionLevel, mask)
}


/***/ }),

/***/ 87057:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

const Polynomial = __webpack_require__(42631)

function ReedSolomonEncoder (degree) {
  this.genPoly = undefined
  this.degree = degree

  if (this.degree) this.initialize(this.degree)
}

/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */
ReedSolomonEncoder.prototype.initialize = function initialize (degree) {
  // create an irreducible generator polynomial
  this.degree = degree
  this.genPoly = Polynomial.generateECPolynomial(this.degree)
}

/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */
ReedSolomonEncoder.prototype.encode = function encode (data) {
  if (!this.genPoly) {
    throw new Error('Encoder not initialized')
  }

  // Calculate EC for this data block
  // extends data size to data+genPoly size
  const paddedData = new Uint8Array(data.length + this.degree)
  paddedData.set(data)

  // The error correction codewords are the remainder after dividing the data codewords
  // by a generator polynomial
  const remainder = Polynomial.mod(paddedData, this.genPoly)

  // return EC data blocks (last n byte, where n is the degree of genPoly)
  // If coefficients number in remainder are less than genPoly degree,
  // pad with 0s to the left to reach the needed number of coefficients
  const start = this.degree - remainder.length
  if (start > 0) {
    const buff = new Uint8Array(this.degree)
    buff.set(remainder, start)

    return buff
  }

  return remainder
}

module.exports = ReedSolomonEncoder


/***/ }),

/***/ 95270:
/***/ ((__unused_webpack_module, exports) => {

const numeric = '[0-9]+'
const alphanumeric = '[A-Z $%*+\\-./:]+'
let kanji = '(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|' +
  '[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|' +
  '[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|' +
  '[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+'
kanji = kanji.replace(/u/g, '\\u')

const byte = '(?:(?![A-Z0-9 $%*+\\-./:]|' + kanji + ')(?:.|[\r\n]))+'

exports.KANJI = new RegExp(kanji, 'g')
exports.BYTE_KANJI = new RegExp('[^A-Z0-9 $%*+\\-./:]+', 'g')
exports.BYTE = new RegExp(byte, 'g')
exports.NUMERIC = new RegExp(numeric, 'g')
exports.ALPHANUMERIC = new RegExp(alphanumeric, 'g')

const TEST_KANJI = new RegExp('^' + kanji + '$')
const TEST_NUMERIC = new RegExp('^' + numeric + '$')
const TEST_ALPHANUMERIC = new RegExp('^[A-Z0-9 $%*+\\-./:]+$')

exports.testKanji = function testKanji (str) {
  return TEST_KANJI.test(str)
}

exports.testNumeric = function testNumeric (str) {
  return TEST_NUMERIC.test(str)
}

exports.testAlphanumeric = function testAlphanumeric (str) {
  return TEST_ALPHANUMERIC.test(str)
}


/***/ }),

/***/ 17506:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

const Mode = __webpack_require__(21493)
const NumericData = __webpack_require__(92818)
const AlphanumericData = __webpack_require__(89012)
const ByteData = __webpack_require__(89735)
const KanjiData = __webpack_require__(59359)
const Regex = __webpack_require__(95270)
const Utils = __webpack_require__(79006)
const dijkstra = __webpack_require__(35376)

/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */
function getStringByteLength (str) {
  return unescape(encodeURIComponent(str)).length
}

/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */
function getSegments (regex, mode, str) {
  const segments = []
  let result

  while ((result = regex.exec(str)) !== null) {
    segments.push({
      data: result[0],
      index: result.index,
      mode: mode,
      length: result[0].length
    })
  }

  return segments
}

/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */
function getSegmentsFromString (dataStr) {
  const numSegs = getSegments(Regex.NUMERIC, Mode.NUMERIC, dataStr)
  const alphaNumSegs = getSegments(Regex.ALPHANUMERIC, Mode.ALPHANUMERIC, dataStr)
  let byteSegs
  let kanjiSegs

  if (Utils.isKanjiModeEnabled()) {
    byteSegs = getSegments(Regex.BYTE, Mode.BYTE, dataStr)
    kanjiSegs = getSegments(Regex.KANJI, Mode.KANJI, dataStr)
  } else {
    byteSegs = getSegments(Regex.BYTE_KANJI, Mode.BYTE, dataStr)
    kanjiSegs = []
  }

  const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs)

  return segs
    .sort(function (s1, s2) {
      return s1.index - s2.index
    })
    .map(function (obj) {
      return {
        data: obj.data,
        mode: obj.mode,
        length: obj.length
      }
    })
}

/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */
function getSegmentBitsLength (length, mode) {
  switch (mode) {
    case Mode.NUMERIC:
      return NumericData.getBitsLength(length)
    case Mode.ALPHANUMERIC:
      return AlphanumericData.getBitsLength(length)
    case Mode.KANJI:
      return KanjiData.getBitsLength(length)
    case Mode.BYTE:
      return ByteData.getBitsLength(length)
  }
}

/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */
function mergeSegments (segs) {
  return segs.reduce(function (acc, curr) {
    const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null
    if (prevSeg && prevSeg.mode === curr.mode) {
      acc[acc.length - 1].data += curr.data
      return acc
    }

    acc.push(curr)
    return acc
  }, [])
}

/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */
function buildNodes (segs) {
  const nodes = []
  for (let i = 0; i < segs.length; i++) {
    const seg = segs[i]

    switch (seg.mode) {
      case Mode.NUMERIC:
        nodes.push([seg,
          { data: seg.data, mode: Mode.ALPHANUMERIC, length: seg.length },
          { data: seg.data, mode: Mode.BYTE, length: seg.length }
        ])
        break
      case Mode.ALPHANUMERIC:
        nodes.push([seg,
          { data: seg.data, mode: Mode.BYTE, length: seg.length }
        ])
        break
      case Mode.KANJI:
        nodes.push([seg,
          { data: seg.data, mode: Mode.BYTE, length: getStringByteLength(seg.data) }
        ])
        break
      case Mode.BYTE:
        nodes.push([
          { data: seg.data, mode: Mode.BYTE, length: getStringByteLength(seg.data) }
        ])
    }
  }

  return nodes
}

/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */
function buildGraph (nodes, version) {
  const table = {}
  const graph = { start: {} }
  let prevNodeIds = ['start']

  for (let i = 0; i < nodes.length; i++) {
    const nodeGroup = nodes[i]
    const currentNodeIds = []

    for (let j = 0; j < nodeGroup.length; j++) {
      const node = nodeGroup[j]
      const key = '' + i + j

      currentNodeIds.push(key)
      table[key] = { node: node, lastCount: 0 }
      graph[key] = {}

      for (let n = 0; n < prevNodeIds.length; n++) {
        const prevNodeId = prevNodeIds[n]

        if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
          graph[prevNodeId][key] =
            getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) -
            getSegmentBitsLength(table[prevNodeId].lastCount, node.mode)

          table[prevNodeId].lastCount += node.length
        } else {
          if (table[prevNodeId]) table[prevNodeId].lastCount = node.length

          graph[prevNodeId][key] = getSegmentBitsLength(node.length, node.mode) +
            4 + Mode.getCharCountIndicator(node.mode, version) // switch cost
        }
      }
    }

    prevNodeIds = currentNodeIds
  }

  for (let n = 0; n < prevNodeIds.length; n++) {
    graph[prevNodeIds[n]].end = 0
  }

  return { map: graph, table: table }
}

/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */
function buildSingleSegment (data, modesHint) {
  let mode
  const bestMode = Mode.getBestModeForData(data)

  mode = Mode.from(modesHint, bestMode)

  // Make sure data can be encoded
  if (mode !== Mode.BYTE && mode.bit < bestMode.bit) {
    throw new Error('"' + data + '"' +
      ' cannot be encoded with mode ' + Mode.toString(mode) +
      '.\n Suggested mode is: ' + Mode.toString(bestMode))
  }

  // Use Mode.BYTE if Kanji support is disabled
  if (mode === Mode.KANJI && !Utils.isKanjiModeEnabled()) {
    mode = Mode.BYTE
  }

  switch (mode) {
    case Mode.NUMERIC:
      return new NumericData(data)

    case Mode.ALPHANUMERIC:
      return new AlphanumericData(data)

    case Mode.KANJI:
      return new KanjiData(data)

    case Mode.BYTE:
      return new ByteData(data)
  }
}

/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */
exports.fromArray = function fromArray (array) {
  return array.reduce(function (acc, seg) {
    if (typeof seg === 'string') {
      acc.push(buildSingleSegment(seg, null))
    } else if (seg.data) {
      acc.push(buildSingleSegment(seg.data, seg.mode))
    }

    return acc
  }, [])
}

/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */
exports.fromString = function fromString (data, version) {
  const segs = getSegmentsFromString(data, Utils.isKanjiModeEnabled())

  const nodes = buildNodes(segs)
  const graph = buildGraph(nodes, version)
  const path = dijkstra.find_path(graph.map, 'start', 'end')

  const optimizedSegs = []
  for (let i = 1; i < path.length - 1; i++) {
    optimizedSegs.push(graph.table[path[i]].node)
  }

  return exports.fromArray(mergeSegments(optimizedSegs))
}

/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */
exports.rawSplit = function rawSplit (data) {
  return exports.fromArray(
    getSegmentsFromString(data, Utils.isKanjiModeEnabled())
  )
}


/***/ }),

/***/ 79006:
/***/ ((__unused_webpack_module, exports) => {

let toSJISFunction
const CODEWORDS_COUNT = [
  0, // Not used
  26, 44, 70, 100, 134, 172, 196, 242, 292, 346,
  404, 466, 532, 581, 655, 733, 815, 901, 991, 1085,
  1156, 1258, 1364, 1474, 1588, 1706, 1828, 1921, 2051, 2185,
  2323, 2465, 2611, 2761, 2876, 3034, 3196, 3362, 3532, 3706
]

/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */
exports.getSymbolSize = function getSymbolSize (version) {
  if (!version) throw new Error('"version" cannot be null or undefined')
  if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40')
  return version * 4 + 17
}

/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */
exports.getSymbolTotalCodewords = function getSymbolTotalCodewords (version) {
  return CODEWORDS_COUNT[version]
}

/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */
exports.getBCHDigit = function (data) {
  let digit = 0

  while (data !== 0) {
    digit++
    data >>>= 1
  }

  return digit
}

exports.setToSJISFunction = function setToSJISFunction (f) {
  if (typeof f !== 'function') {
    throw new Error('"toSJISFunc" is not a valid function.')
  }

  toSJISFunction = f
}

exports.isKanjiModeEnabled = function () {
  return typeof toSJISFunction !== 'undefined'
}

exports.toSJIS = function toSJIS (kanji) {
  return toSJISFunction(kanji)
}


/***/ }),

/***/ 43327:
/***/ ((__unused_webpack_module, exports) => {

/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */
exports.isValid = function isValid (version) {
  return !isNaN(version) && version >= 1 && version <= 40
}


/***/ }),

/***/ 13761:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

const Utils = __webpack_require__(79006)
const ECCode = __webpack_require__(13675)
const ECLevel = __webpack_require__(17630)
const Mode = __webpack_require__(21493)
const VersionCheck = __webpack_require__(43327)

// Generator polynomial used to encode version information
const G18 = (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0)
const G18_BCH = Utils.getBCHDigit(G18)

function getBestVersionForDataLength (mode, length, errorCorrectionLevel) {
  for (let currentVersion = 1; currentVersion <= 40; currentVersion++) {
    if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, mode)) {
      return currentVersion
    }
  }

  return undefined
}

function getReservedBitsCount (mode, version) {
  // Character count indicator + mode indicator bits
  return Mode.getCharCountIndicator(mode, version) + 4
}

function getTotalBitsFromDataArray (segments, version) {
  let totalBits = 0

  segments.forEach(function (data) {
    const reservedBits = getReservedBitsCount(data.mode, version)
    totalBits += reservedBits + data.getBitsLength()
  })

  return totalBits
}

function getBestVersionForMixedData (segments, errorCorrectionLevel) {
  for (let currentVersion = 1; currentVersion <= 40; currentVersion++) {
    const length = getTotalBitsFromDataArray(segments, currentVersion)
    if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, Mode.MIXED)) {
      return currentVersion
    }
  }

  return undefined
}

/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */
exports.from = function from (value, defaultValue) {
  if (VersionCheck.isValid(value)) {
    return parseInt(value, 10)
  }

  return defaultValue
}

/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */
exports.getCapacity = function getCapacity (version, errorCorrectionLevel, mode) {
  if (!VersionCheck.isValid(version)) {
    throw new Error('Invalid QR Code version')
  }

  // Use Byte mode as default
  if (typeof mode === 'undefined') mode = Mode.BYTE

  // Total codewords for this QR code version (Data + Error correction)
  const totalCodewords = Utils.getSymbolTotalCodewords(version)

  // Total number of error correction codewords
  const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel)

  // Total number of data codewords
  const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8

  if (mode === Mode.MIXED) return dataTotalCodewordsBits

  const usableBits = dataTotalCodewordsBits - getReservedBitsCount(mode, version)

  // Return max number of storable codewords
  switch (mode) {
    case Mode.NUMERIC:
      return Math.floor((usableBits / 10) * 3)

    case Mode.ALPHANUMERIC:
      return Math.floor((usableBits / 11) * 2)

    case Mode.KANJI:
      return Math.floor(usableBits / 13)

    case Mode.BYTE:
    default:
      return Math.floor(usableBits / 8)
  }
}

/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */
exports.getBestVersionForData = function getBestVersionForData (data, errorCorrectionLevel) {
  let seg

  const ecl = ECLevel.from(errorCorrectionLevel, ECLevel.M)

  if (Array.isArray(data)) {
    if (data.length > 1) {
      return getBestVersionForMixedData(data, ecl)
    }

    if (data.length === 0) {
      return 1
    }

    seg = data[0]
  } else {
    seg = data
  }

  return getBestVersionForDataLength(seg.mode, seg.getLength(), ecl)
}

/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */
exports.getEncodedBits = function getEncodedBits (version) {
  if (!VersionCheck.isValid(version) || version < 7) {
    throw new Error('Invalid QR Code version')
  }

  let d = version << 12

  while (Utils.getBCHDigit(d) - G18_BCH >= 0) {
    d ^= (G18 << (Utils.getBCHDigit(d) - G18_BCH))
  }

  return (version << 12) | d
}


/***/ }),

/***/ 42513:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

const Utils = __webpack_require__(93878)

function clearCanvas (ctx, canvas, size) {
  ctx.clearRect(0, 0, canvas.width, canvas.height)

  if (!canvas.style) canvas.style = {}
  canvas.height = size
  canvas.width = size
  canvas.style.height = size + 'px'
  canvas.style.width = size + 'px'
}

function getCanvasElement () {
  try {
    return document.createElement('canvas')
  } catch (e) {
    throw new Error('You need to specify a canvas element')
  }
}

exports.render = function render (qrData, canvas, options) {
  let opts = options
  let canvasEl = canvas

  if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
    opts = canvas
    canvas = undefined
  }

  if (!canvas) {
    canvasEl = getCanvasElement()
  }

  opts = Utils.getOptions(opts)
  const size = Utils.getImageWidth(qrData.modules.size, opts)

  const ctx = canvasEl.getContext('2d')
  const image = ctx.createImageData(size, size)
  Utils.qrToImageData(image.data, qrData, opts)

  clearCanvas(ctx, canvasEl, size)
  ctx.putImageData(image, 0, 0)

  return canvasEl
}

exports.renderToDataURL = function renderToDataURL (qrData, canvas, options) {
  let opts = options

  if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
    opts = canvas
    canvas = undefined
  }

  if (!opts) opts = {}

  const canvasEl = exports.render(qrData, canvas, opts)

  const type = opts.type || 'image/png'
  const rendererOpts = opts.rendererOpts || {}

  return canvasEl.toDataURL(type, rendererOpts.quality)
}


/***/ }),

/***/ 51478:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

const Utils = __webpack_require__(93878)

function getColorAttrib (color, attrib) {
  const alpha = color.a / 255
  const str = attrib + '="' + color.hex + '"'

  return alpha < 1
    ? str + ' ' + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"'
    : str
}

function svgCmd (cmd, x, y) {
  let str = cmd + x
  if (typeof y !== 'undefined') str += ' ' + y

  return str
}

function qrToPath (data, size, margin) {
  let path = ''
  let moveBy = 0
  let newRow = false
  let lineLength = 0

  for (let i = 0; i < data.length; i++) {
    const col = Math.floor(i % size)
    const row = Math.floor(i / size)

    if (!col && !newRow) newRow = true

    if (data[i]) {
      lineLength++

      if (!(i > 0 && col > 0 && data[i - 1])) {
        path += newRow
          ? svgCmd('M', col + margin, 0.5 + row + margin)
          : svgCmd('m', moveBy, 0)

        moveBy = 0
        newRow = false
      }

      if (!(col + 1 < size && data[i + 1])) {
        path += svgCmd('h', lineLength)
        lineLength = 0
      }
    } else {
      moveBy++
    }
  }

  return path
}

exports.render = function render (qrData, options, cb) {
  const opts = Utils.getOptions(options)
  const size = qrData.modules.size
  const data = qrData.modules.data
  const qrcodesize = size + opts.margin * 2

  const bg = !opts.color.light.a
    ? ''
    : '<path ' + getColorAttrib(opts.color.light, 'fill') +
      ' d="M0 0h' + qrcodesize + 'v' + qrcodesize + 'H0z"/>'

  const path =
    '<path ' + getColorAttrib(opts.color.dark, 'stroke') +
    ' d="' + qrToPath(data, size, opts.margin) + '"/>'

  const viewBox = 'viewBox="' + '0 0 ' + qrcodesize + ' ' + qrcodesize + '"'

  const width = !opts.width ? '' : 'width="' + opts.width + '" height="' + opts.width + '" '

  const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + '</svg>\n'

  if (typeof cb === 'function') {
    cb(null, svgTag)
  }

  return svgTag
}


/***/ }),

/***/ 93878:
/***/ ((__unused_webpack_module, exports) => {

function hex2rgba (hex) {
  if (typeof hex === 'number') {
    hex = hex.toString()
  }

  if (typeof hex !== 'string') {
    throw new Error('Color should be defined as hex string')
  }

  let hexCode = hex.slice().replace('#', '').split('')
  if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) {
    throw new Error('Invalid hex color: ' + hex)
  }

  // Convert from short to long form (fff -> ffffff)
  if (hexCode.length === 3 || hexCode.length === 4) {
    hexCode = Array.prototype.concat.apply([], hexCode.map(function (c) {
      return [c, c]
    }))
  }

  // Add default alpha value
  if (hexCode.length === 6) hexCode.push('F', 'F')

  const hexValue = parseInt(hexCode.join(''), 16)

  return {
    r: (hexValue >> 24) & 255,
    g: (hexValue >> 16) & 255,
    b: (hexValue >> 8) & 255,
    a: hexValue & 255,
    hex: '#' + hexCode.slice(0, 6).join('')
  }
}

exports.getOptions = function getOptions (options) {
  if (!options) options = {}
  if (!options.color) options.color = {}

  const margin = typeof options.margin === 'undefined' ||
    options.margin === null ||
    options.margin < 0
    ? 4
    : options.margin

  const width = options.width && options.width >= 21 ? options.width : undefined
  const scale = options.scale || 4

  return {
    width: width,
    scale: width ? 4 : scale,
    margin: margin,
    color: {
      dark: hex2rgba(options.color.dark || '#000000ff'),
      light: hex2rgba(options.color.light || '#ffffffff')
    },
    type: options.type,
    rendererOpts: options.rendererOpts || {}
  }
}

exports.getScale = function getScale (qrSize, opts) {
  return opts.width && opts.width >= qrSize + opts.margin * 2
    ? opts.width / (qrSize + opts.margin * 2)
    : opts.scale
}

exports.getImageWidth = function getImageWidth (qrSize, opts) {
  const scale = exports.getScale(qrSize, opts)
  return Math.floor((qrSize + opts.margin * 2) * scale)
}

exports.qrToImageData = function qrToImageData (imgData, qr, opts) {
  const size = qr.modules.size
  const data = qr.modules.data
  const scale = exports.getScale(size, opts)
  const symbolSize = Math.floor((size + opts.margin * 2) * scale)
  const scaledMargin = opts.margin * scale
  const palette = [opts.color.light, opts.color.dark]

  for (let i = 0; i < symbolSize; i++) {
    for (let j = 0; j < symbolSize; j++) {
      let posDst = (i * symbolSize + j) * 4
      let pxColor = opts.color.light

      if (i >= scaledMargin && j >= scaledMargin &&
        i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
        const iSrc = Math.floor((i - scaledMargin) / scale)
        const jSrc = Math.floor((j - scaledMargin) / scale)
        pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0]
      }

      imgData[posDst++] = pxColor.r
      imgData[posDst++] = pxColor.g
      imgData[posDst++] = pxColor.b
      imgData[posDst] = pxColor.a
    }
  }
}


/***/ }),

/***/ 96687:
/***/ ((module) => {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),

/***/ 14015:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var stringify = __webpack_require__(97224);
var parse = __webpack_require__(48761);
var formats = __webpack_require__(96687);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),

/***/ 48761:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(71575);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== '__proto__') {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ }),

/***/ 97224:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var getSideChannel = __webpack_require__(65714);
var utils = __webpack_require__(71575);
var formats = __webpack_require__(96687);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? prefix + '[]' : prefix;

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + key : '[' + key + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            strictNullHandling,
            skipNulls,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
    if (opts && 'commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }
    var commaRoundTrip = generateArrayPrefix === 'comma' && opts && opts.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),

/***/ 71575:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var formats = __webpack_require__(96687);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
            || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        /* eslint operator-linebreak: [2, "before"] */
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),

/***/ 82382:
/***/ ((module) => {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),

/***/ 69787:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var stringify = __webpack_require__(10977);
var parse = __webpack_require__(62106);
var formats = __webpack_require__(82382);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),

/***/ 62106:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(90471);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = { __proto__: null };

    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== '__proto__') {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ }),

/***/ 10977:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var getSideChannel = __webpack_require__(65714);
var utils = __webpack_require__(90471);
var formats = __webpack_require__(82382);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? prefix + '[]' : prefix;

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + key : '[' + key + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            strictNullHandling,
            skipNulls,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
    if (opts && 'commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }
    var commaRoundTrip = generateArrayPrefix === 'comma' && opts && opts.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),

/***/ 90471:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var formats = __webpack_require__(82382);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
            || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        /* eslint operator-linebreak: [2, "before"] */
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),

/***/ 60981:
/***/ ((module) => {

"use strict";


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var codes = {};

function createErrorType(code, message, Base) {
  if (!Base) {
    Base = Error;
  }

  function getMessage(arg1, arg2, arg3) {
    if (typeof message === 'string') {
      return message;
    } else {
      return message(arg1, arg2, arg3);
    }
  }

  var NodeError =
  /*#__PURE__*/
  function (_Base) {
    _inheritsLoose(NodeError, _Base);

    function NodeError(arg1, arg2, arg3) {
      return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
    }

    return NodeError;
  }(Base);

  NodeError.prototype.name = Base.name;
  NodeError.prototype.code = code;
  codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js


function oneOf(expected, thing) {
  if (Array.isArray(expected)) {
    var len = expected.length;
    expected = expected.map(function (i) {
      return String(i);
    });

    if (len > 2) {
      return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
    } else if (len === 2) {
      return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
    } else {
      return "of ".concat(thing, " ").concat(expected[0]);
    }
  } else {
    return "of ".concat(thing, " ").concat(String(expected));
  }
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith


function startsWith(str, search, pos) {
  return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith


function endsWith(str, search, this_len) {
  if (this_len === undefined || this_len > str.length) {
    this_len = str.length;
  }

  return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes


function includes(str, search, start) {
  if (typeof start !== 'number') {
    start = 0;
  }

  if (start + search.length > str.length) {
    return false;
  } else {
    return str.indexOf(search, start) !== -1;
  }
}

createErrorType('ERR_INVALID_OPT_VALUE', function (name, value) {
  return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
createErrorType('ERR_INVALID_ARG_TYPE', function (name, expected, actual) {
  // determiner: 'must be' or 'must not be'
  var determiner;

  if (typeof expected === 'string' && startsWith(expected, 'not ')) {
    determiner = 'must not be';
    expected = expected.replace(/^not /, '');
  } else {
    determiner = 'must be';
  }

  var msg;

  if (endsWith(name, ' argument')) {
    // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  } else {
    var type = includes(name, '.') ? 'property' : 'argument';
    msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  }

  msg += ". Received type ".concat(typeof actual);
  return msg;
}, TypeError);
createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function (name) {
  return 'The ' + name + ' method is not implemented';
});
createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
createErrorType('ERR_STREAM_DESTROYED', function (name) {
  return 'Cannot call ' + name + ' after a stream was destroyed';
});
createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
createErrorType('ERR_UNKNOWN_ENCODING', function (arg) {
  return 'Unknown encoding: ' + arg;
}, TypeError);
createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
module.exports.q = codes;


/***/ }),

/***/ 93337:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__(14224);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
};
/*</replacement>*/

module.exports = Duplex;
var Readable = __webpack_require__(25294);
var Writable = __webpack_require__(86481);
__webpack_require__(85459)(Duplex, Readable);
{
  // Allow the keys array to be GC'ed.
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}
function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);
  Readable.call(this, options);
  Writable.call(this, options);
  this.allowHalfOpen = true;
  if (options) {
    if (options.readable === false) this.readable = false;
    if (options.writable === false) this.writable = false;
    if (options.allowHalfOpen === false) {
      this.allowHalfOpen = false;
      this.once('end', onend);
    }
  }
}
Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});
Object.defineProperty(Duplex.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
Object.defineProperty(Duplex.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});

// the no-half-open enforcer
function onend() {
  // If the writable side ended, then we're ok.
  if (this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  process.nextTick(onEndNT, this);
}
function onEndNT(self) {
  self.end();
}
Object.defineProperty(Duplex.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

/***/ }),

/***/ 68797:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;
var Transform = __webpack_require__(41683);
__webpack_require__(85459)(PassThrough, Transform);
function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);
  Transform.call(this, options);
}
PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),

/***/ 25294:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__(14224);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



module.exports = Readable;

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = (__webpack_require__(72100).EventEmitter);
var EElistenerCount = function EElistenerCount(emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(26922);
/*</replacement>*/

var Buffer = (__webpack_require__(91620).Buffer);
var OurUint8Array = (typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*<replacement>*/
var debugUtil = __webpack_require__(82880);
var debug;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function debug() {};
}
/*</replacement>*/

var BufferList = __webpack_require__(96292);
var destroyImpl = __webpack_require__(33591);
var _require = __webpack_require__(16084),
  getHighWaterMark = _require.getHighWaterMark;
var _require$codes = (__webpack_require__(60981)/* .codes */ .q),
  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
  ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;

// Lazy loaded to improve the startup performance.
var StringDecoder;
var createReadableStreamAsyncIterator;
var from;
__webpack_require__(85459)(Readable, Stream);
var errorOrDestroy = destroyImpl.errorOrDestroy;
var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}
function ReadableState(options, stream, isDuplex) {
  Duplex = Duplex || __webpack_require__(93337);
  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  this.highWaterMark = getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;
  this.paused = true;

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = options.emitClose !== false;

  // Should .destroy() be called after 'end' (and potentially 'finish')
  this.autoDestroy = !!options.autoDestroy;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;
  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = (__webpack_require__(72699)/* .StringDecoder */ .s);
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}
function Readable(options) {
  Duplex = Duplex || __webpack_require__(93337);
  if (!(this instanceof Readable)) return new Readable(options);

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the ReadableState constructor, at least with V8 6.5
  var isDuplex = this instanceof Duplex;
  this._readableState = new ReadableState(options, this, isDuplex);

  // legacy
  this.readable = true;
  if (options) {
    if (typeof options.read === 'function') this._read = options.read;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }
  Stream.call(this);
}
Object.defineProperty(Readable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});
Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;
  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }
  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};
function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  debug('readableAddChunk', chunk);
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      errorOrDestroy(stream, er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }
      if (addToFront) {
        if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
      } else if (state.destroyed) {
        return false;
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
      maybeReadMore(stream, state);
    }
  }

  // We can push more data if we are below the highWaterMark.
  // Also, if we have no data yet, we can stand some more bytes.
  // This is to work around cases where hwm=0, such as the repl.
  return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    state.awaitDrain = 0;
    stream.emit('data', chunk);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}
function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer', 'Uint8Array'], chunk);
  }
  return er;
}
Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = (__webpack_require__(72699)/* .StringDecoder */ .s);
  var decoder = new StringDecoder(enc);
  this._readableState.decoder = decoder;
  // If setEncoding(null), decoder.encoding equals utf8
  this._readableState.encoding = this._readableState.decoder.encoding;

  // Iterate over current buffer to convert already stored Buffers:
  var p = this._readableState.buffer.head;
  var content = '';
  while (p !== null) {
    content += decoder.write(p.data);
    p = p.next;
  }
  this._readableState.buffer.clear();
  if (content !== '') this._readableState.buffer.push(content);
  this._readableState.length = content.length;
  return this;
};

// Don't raise the hwm > 1GB
var MAX_HWM = 0x40000000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;
  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }
  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }
  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;
  if (ret === null) {
    state.needReadable = state.length <= state.highWaterMark;
    n = 0;
  } else {
    state.length -= n;
    state.awaitDrain = 0;
  }
  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }
  if (ret !== null) this.emit('data', ret);
  return ret;
};
function onEofChunk(stream, state) {
  debug('onEofChunk');
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;
  if (state.sync) {
    // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    emitReadable(stream);
  } else {
    // emit 'readable' now to make sure it gets picked up.
    state.needReadable = false;
    if (!state.emittedReadable) {
      state.emittedReadable = true;
      emitReadable_(stream);
    }
  }
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  debug('emitReadable', state.needReadable, state.emittedReadable);
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    process.nextTick(emitReadable_, stream);
  }
}
function emitReadable_(stream) {
  var state = stream._readableState;
  debug('emitReadable_', state.destroyed, state.length, state.ended);
  if (!state.destroyed && (state.length || state.ended)) {
    stream.emit('readable');
    state.emittedReadable = false;
  }

  // The stream needs another readable event if
  // 1. It is not flowing, as the flow mechanism will take
  //    care of it.
  // 2. It is not ended.
  // 3. It is below the highWaterMark, so we can schedule
  //    another readable later.
  state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    process.nextTick(maybeReadMore_, stream, state);
  }
}
function maybeReadMore_(stream, state) {
  // Attempt to read more data if we should.
  //
  // The conditions for reading more data are (one of):
  // - Not enough data buffered (state.length < state.highWaterMark). The loop
  //   is responsible for filling the buffer with enough data if such data
  //   is available. If highWaterMark is 0 and we are not in the flowing mode
  //   we should _not_ attempt to buffer any extra data. We'll get more data
  //   when the stream consumer calls read() instead.
  // - No data in the buffer, and the stream is in flowing mode. In this mode
  //   the loop below is responsible for ensuring read() is called. Failing to
  //   call read here would abort the flow and there's no other mechanism for
  //   continuing the flow if the stream consumer has just subscribed to the
  //   'data' event.
  //
  // In addition to the above conditions to keep reading data, the following
  // conditions prevent the data from being read:
  // - The stream has ended (state.ended).
  // - There is already a pending 'read' operation (state.reading). This is a
  //   case where the the stream has called the implementation defined _read()
  //   method, but they are processing the call asynchronously and have _not_
  //   called push() with new data. In this case we skip performing more
  //   read()s. The execution ends in this method again after the _read() ends
  //   up calling push() with more data.
  while (!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)) {
    var len = state.length;
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;
  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) process.nextTick(endFn);else src.once('end', endFn);
  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }
  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);
  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);
    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    var ret = dest.write(chunk);
    debug('dest.write', ret);
    if (ret === false) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', state.awaitDrain);
        state.awaitDrain++;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) errorOrDestroy(dest, er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);
  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }
  return dest;
};
function pipeOnDrain(src) {
  return function pipeOnDrainFunctionResult() {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}
Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = {
    hasUnpiped: false
  };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;
    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    for (var i = 0; i < len; i++) dests[i].emit('unpipe', this, {
      hasUnpiped: false
    });
    return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;
  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];
  dest.emit('unpipe', this, unpipeInfo);
  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);
  var state = this._readableState;
  if (ev === 'data') {
    // update readableListening so that resume() may be a no-op
    // a few lines down. This is needed to support once('readable').
    state.readableListening = this.listenerCount('readable') > 0;

    // Try start flowing on next tick if stream isn't explicitly paused
    if (state.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.flowing = false;
      state.emittedReadable = false;
      debug('on readable', state.length, state.reading);
      if (state.length) {
        emitReadable(this);
      } else if (!state.reading) {
        process.nextTick(nReadingNextTick, this);
      }
    }
  }
  return res;
};
Readable.prototype.addListener = Readable.prototype.on;
Readable.prototype.removeListener = function (ev, fn) {
  var res = Stream.prototype.removeListener.call(this, ev, fn);
  if (ev === 'readable') {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }
  return res;
};
Readable.prototype.removeAllListeners = function (ev) {
  var res = Stream.prototype.removeAllListeners.apply(this, arguments);
  if (ev === 'readable' || ev === undefined) {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }
  return res;
};
function updateReadableListening(self) {
  var state = self._readableState;
  state.readableListening = self.listenerCount('readable') > 0;
  if (state.resumeScheduled && !state.paused) {
    // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;

    // crude way to check if we should resume
  } else if (self.listenerCount('data') > 0) {
    self.resume();
  }
}
function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    // we flow only if there is no one listening
    // for readable, but we still have to call
    // resume()
    state.flowing = !state.readableListening;
    resume(this, state);
  }
  state.paused = false;
  return this;
};
function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    process.nextTick(resume_, stream, state);
  }
}
function resume_(stream, state) {
  debug('resume', state.reading);
  if (!state.reading) {
    stream.read(0);
  }
  state.resumeScheduled = false;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}
Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (this._readableState.flowing !== false) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  this._readableState.paused = true;
  return this;
};
function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null);
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;
  var state = this._readableState;
  var paused = false;
  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }
    _this.push(null);
  });
  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };
  return this;
};
if (typeof Symbol === 'function') {
  Readable.prototype[Symbol.asyncIterator] = function () {
    if (createReadableStreamAsyncIterator === undefined) {
      createReadableStreamAsyncIterator = __webpack_require__(29954);
    }
    return createReadableStreamAsyncIterator(this);
  };
}
Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.highWaterMark;
  }
});
Object.defineProperty(Readable.prototype, 'readableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState && this._readableState.buffer;
  }
});
Object.defineProperty(Readable.prototype, 'readableFlowing', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.flowing;
  },
  set: function set(state) {
    if (this._readableState) {
      this._readableState.flowing = state;
    }
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;
Object.defineProperty(Readable.prototype, 'readableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.length;
  }
});

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;
  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.first();else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = state.buffer.consume(n, state.decoder);
  }
  return ret;
}
function endReadable(stream) {
  var state = stream._readableState;
  debug('endReadable', state.endEmitted);
  if (!state.endEmitted) {
    state.ended = true;
    process.nextTick(endReadableNT, state, stream);
  }
}
function endReadableNT(state, stream) {
  debug('endReadableNT', state.endEmitted, state.length);

  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
    if (state.autoDestroy) {
      // In case of duplex streams we need a way to detect
      // if the writable side is ready for autoDestroy as well
      var wState = stream._writableState;
      if (!wState || wState.autoDestroy && wState.finished) {
        stream.destroy();
      }
    }
  }
}
if (typeof Symbol === 'function') {
  Readable.from = function (iterable, opts) {
    if (from === undefined) {
      from = __webpack_require__(82037);
    }
    return from(Readable, iterable, opts);
  };
}
function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}

/***/ }),

/***/ 41683:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;
var _require$codes = (__webpack_require__(60981)/* .codes */ .q),
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
  ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING,
  ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
var Duplex = __webpack_require__(93337);
__webpack_require__(85459)(Transform, Duplex);
function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;
  var cb = ts.writecb;
  if (cb === null) {
    return this.emit('error', new ERR_MULTIPLE_CALLBACK());
  }
  ts.writechunk = null;
  ts.writecb = null;
  if (data != null)
    // single equals check for both `null` and `undefined`
    this.push(data);
  cb(er);
  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}
function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);
  Duplex.call(this, options);
  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;
  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;
    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}
function prefinish() {
  var _this = this;
  if (typeof this._flush === 'function' && !this._readableState.destroyed) {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}
Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;
  if (ts.writechunk !== null && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};
Transform.prototype._destroy = function (err, cb) {
  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
  });
};
function done(stream, er, data) {
  if (er) return stream.emit('error', er);
  if (data != null)
    // single equals check for both `null` and `undefined`
    stream.push(data);

  // TODO(BridgeAR): Write a test for these two error cases
  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
  if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
  return stream.push(null);
}

/***/ }),

/***/ 86481:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__(14224);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;
  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(30403)
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(26922);
/*</replacement>*/

var Buffer = (__webpack_require__(91620).Buffer);
var OurUint8Array = (typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
var destroyImpl = __webpack_require__(33591);
var _require = __webpack_require__(16084),
  getHighWaterMark = _require.getHighWaterMark;
var _require$codes = (__webpack_require__(60981)/* .codes */ .q),
  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
  ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE,
  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED,
  ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES,
  ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END,
  ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
var errorOrDestroy = destroyImpl.errorOrDestroy;
__webpack_require__(85459)(Writable, Stream);
function nop() {}
function WritableState(options, stream, isDuplex) {
  Duplex = Duplex || __webpack_require__(93337);
  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream,
  // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  this.highWaterMark = getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;
  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = options.emitClose !== false;

  // Should .destroy() be called after 'finish' (and potentially 'end')
  this.autoDestroy = !!options.autoDestroy;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}
WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};
(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function writableStateBufferGetter() {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function value(object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;
      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function realHasInstance(object) {
    return object instanceof this;
  };
}
function Writable(options) {
  Duplex = Duplex || __webpack_require__(93337);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the WritableState constructor, at least with V8 6.5
  var isDuplex = this instanceof Duplex;
  if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
  this._writableState = new WritableState(options, this, isDuplex);

  // legacy.
  this.writable = true;
  if (options) {
    if (typeof options.write === 'function') this._write = options.write;
    if (typeof options.writev === 'function') this._writev = options.writev;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
    if (typeof options.final === 'function') this._final = options.final;
  }
  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
};
function writeAfterEnd(stream, cb) {
  var er = new ERR_STREAM_WRITE_AFTER_END();
  // TODO: defer error events consistently everywhere, not just the cb
  errorOrDestroy(stream, er);
  process.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var er;
  if (chunk === null) {
    er = new ERR_STREAM_NULL_VALUES();
  } else if (typeof chunk !== 'string' && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer'], chunk);
  }
  if (er) {
    errorOrDestroy(stream, er);
    process.nextTick(cb, er);
    return false;
  }
  return true;
}
Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);
  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }
  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }
  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
  if (typeof cb !== 'function') cb = nop;
  if (state.ending) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }
  return ret;
};
Writable.prototype.cork = function () {
  this._writableState.corked++;
};
Writable.prototype.uncork = function () {
  var state = this._writableState;
  if (state.corked) {
    state.corked--;
    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};
Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};
Object.defineProperty(Writable.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}
Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;
  state.length += len;
  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;
  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }
  return ret;
}
function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED('write'));else if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}
function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;
  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    process.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    process.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}
function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}
function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;
  if (typeof cb !== 'function') throw new ERR_MULTIPLE_CALLBACK();
  onwriteStateUpdate(state);
  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state) || stream.destroyed;
    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }
    if (sync) {
      process.nextTick(afterWrite, stream, state, finished, cb);
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}
function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;
  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;
    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;
    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;
      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }
    if (entry === null) state.lastBufferedRequest = null;
  }
  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}
Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
Writable.prototype._writev = null;
Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;
  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }
  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending) endWritable(this, state, cb);
  return this;
};
Object.defineProperty(Writable.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});
function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      errorOrDestroy(stream, err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function' && !state.destroyed) {
      state.pendingcb++;
      state.finalCalled = true;
      process.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}
function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
      if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well
        var rState = stream._readableState;
        if (!rState || rState.autoDestroy && rState.endEmitted) {
          stream.destroy();
        }
      }
    }
  }
  return need;
}
function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) process.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}
function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }

  // reuse the free corkReq.
  state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty(Writable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});
Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  cb(err);
};

/***/ }),

/***/ 29954:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__(14224);


var _Object$setPrototypeO;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var finished = __webpack_require__(43675);
var kLastResolve = Symbol('lastResolve');
var kLastReject = Symbol('lastReject');
var kError = Symbol('error');
var kEnded = Symbol('ended');
var kLastPromise = Symbol('lastPromise');
var kHandlePromise = Symbol('handlePromise');
var kStream = Symbol('stream');
function createIterResult(value, done) {
  return {
    value: value,
    done: done
  };
}
function readAndResolve(iter) {
  var resolve = iter[kLastResolve];
  if (resolve !== null) {
    var data = iter[kStream].read();
    // we defer if data is null
    // we can be expecting either 'end' or
    // 'error'
    if (data !== null) {
      iter[kLastPromise] = null;
      iter[kLastResolve] = null;
      iter[kLastReject] = null;
      resolve(createIterResult(data, false));
    }
  }
}
function onReadable(iter) {
  // we wait for the next tick, because it might
  // emit an error with process.nextTick
  process.nextTick(readAndResolve, iter);
}
function wrapForNext(lastPromise, iter) {
  return function (resolve, reject) {
    lastPromise.then(function () {
      if (iter[kEnded]) {
        resolve(createIterResult(undefined, true));
        return;
      }
      iter[kHandlePromise](resolve, reject);
    }, reject);
  };
}
var AsyncIteratorPrototype = Object.getPrototypeOf(function () {});
var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
  get stream() {
    return this[kStream];
  },
  next: function next() {
    var _this = this;
    // if we have detected an error in the meanwhile
    // reject straight away
    var error = this[kError];
    if (error !== null) {
      return Promise.reject(error);
    }
    if (this[kEnded]) {
      return Promise.resolve(createIterResult(undefined, true));
    }
    if (this[kStream].destroyed) {
      // We need to defer via nextTick because if .destroy(err) is
      // called, the error will be emitted via nextTick, and
      // we cannot guarantee that there is no error lingering around
      // waiting to be emitted.
      return new Promise(function (resolve, reject) {
        process.nextTick(function () {
          if (_this[kError]) {
            reject(_this[kError]);
          } else {
            resolve(createIterResult(undefined, true));
          }
        });
      });
    }

    // if we have multiple next() calls
    // we will wait for the previous Promise to finish
    // this logic is optimized to support for await loops,
    // where next() is only called once at a time
    var lastPromise = this[kLastPromise];
    var promise;
    if (lastPromise) {
      promise = new Promise(wrapForNext(lastPromise, this));
    } else {
      // fast path needed to support multiple this.push()
      // without triggering the next() queue
      var data = this[kStream].read();
      if (data !== null) {
        return Promise.resolve(createIterResult(data, false));
      }
      promise = new Promise(this[kHandlePromise]);
    }
    this[kLastPromise] = promise;
    return promise;
  }
}, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function () {
  return this;
}), _defineProperty(_Object$setPrototypeO, "return", function _return() {
  var _this2 = this;
  // destroy(err, cb) is a private API
  // we can guarantee we have that here, because we control the
  // Readable class this is attached to
  return new Promise(function (resolve, reject) {
    _this2[kStream].destroy(null, function (err) {
      if (err) {
        reject(err);
        return;
      }
      resolve(createIterResult(undefined, true));
    });
  });
}), _Object$setPrototypeO), AsyncIteratorPrototype);
var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
  var _Object$create;
  var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
    value: stream,
    writable: true
  }), _defineProperty(_Object$create, kLastResolve, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kLastReject, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kError, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kEnded, {
    value: stream._readableState.endEmitted,
    writable: true
  }), _defineProperty(_Object$create, kHandlePromise, {
    value: function value(resolve, reject) {
      var data = iterator[kStream].read();
      if (data) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        resolve(createIterResult(data, false));
      } else {
        iterator[kLastResolve] = resolve;
        iterator[kLastReject] = reject;
      }
    },
    writable: true
  }), _Object$create));
  iterator[kLastPromise] = null;
  finished(stream, function (err) {
    if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
      var reject = iterator[kLastReject];
      // reject if we are waiting for data in the Promise
      // returned by next() and store the error
      if (reject !== null) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        reject(err);
      }
      iterator[kError] = err;
      return;
    }
    var resolve = iterator[kLastResolve];
    if (resolve !== null) {
      iterator[kLastPromise] = null;
      iterator[kLastResolve] = null;
      iterator[kLastReject] = null;
      resolve(createIterResult(undefined, true));
    }
    iterator[kEnded] = true;
  });
  stream.on('readable', onReadable.bind(null, iterator));
  return iterator;
};
module.exports = createReadableStreamAsyncIterator;

/***/ }),

/***/ 96292:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _require = __webpack_require__(91620),
  Buffer = _require.Buffer;
var _require2 = __webpack_require__(87942),
  inspect = _require2.inspect;
var custom = inspect && inspect.custom || 'inspect';
function copyBuffer(src, target, offset) {
  Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/function () {
  function BufferList() {
    _classCallCheck(this, BufferList);
    this.head = null;
    this.tail = null;
    this.length = 0;
  }
  _createClass(BufferList, [{
    key: "push",
    value: function push(v) {
      var entry = {
        data: v,
        next: null
      };
      if (this.length > 0) this.tail.next = entry;else this.head = entry;
      this.tail = entry;
      ++this.length;
    }
  }, {
    key: "unshift",
    value: function unshift(v) {
      var entry = {
        data: v,
        next: this.head
      };
      if (this.length === 0) this.tail = entry;
      this.head = entry;
      ++this.length;
    }
  }, {
    key: "shift",
    value: function shift() {
      if (this.length === 0) return;
      var ret = this.head.data;
      if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
      --this.length;
      return ret;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.head = this.tail = null;
      this.length = 0;
    }
  }, {
    key: "join",
    value: function join(s) {
      if (this.length === 0) return '';
      var p = this.head;
      var ret = '' + p.data;
      while (p = p.next) ret += s + p.data;
      return ret;
    }
  }, {
    key: "concat",
    value: function concat(n) {
      if (this.length === 0) return Buffer.alloc(0);
      var ret = Buffer.allocUnsafe(n >>> 0);
      var p = this.head;
      var i = 0;
      while (p) {
        copyBuffer(p.data, ret, i);
        i += p.data.length;
        p = p.next;
      }
      return ret;
    }

    // Consumes a specified amount of bytes or characters from the buffered data.
  }, {
    key: "consume",
    value: function consume(n, hasStrings) {
      var ret;
      if (n < this.head.data.length) {
        // `slice` is the same for buffers and strings.
        ret = this.head.data.slice(0, n);
        this.head.data = this.head.data.slice(n);
      } else if (n === this.head.data.length) {
        // First chunk is a perfect match.
        ret = this.shift();
      } else {
        // Result spans more than one buffer.
        ret = hasStrings ? this._getString(n) : this._getBuffer(n);
      }
      return ret;
    }
  }, {
    key: "first",
    value: function first() {
      return this.head.data;
    }

    // Consumes a specified amount of characters from the buffered data.
  }, {
    key: "_getString",
    value: function _getString(n) {
      var p = this.head;
      var c = 1;
      var ret = p.data;
      n -= ret.length;
      while (p = p.next) {
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
          if (nb === str.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = str.slice(nb);
          }
          break;
        }
        ++c;
      }
      this.length -= c;
      return ret;
    }

    // Consumes a specified amount of bytes from the buffered data.
  }, {
    key: "_getBuffer",
    value: function _getBuffer(n) {
      var ret = Buffer.allocUnsafe(n);
      var p = this.head;
      var c = 1;
      p.data.copy(ret);
      n -= p.data.length;
      while (p = p.next) {
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
          if (nb === buf.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = buf.slice(nb);
          }
          break;
        }
        ++c;
      }
      this.length -= c;
      return ret;
    }

    // Make sure the linked list only shows the minimal necessary information.
  }, {
    key: custom,
    value: function value(_, options) {
      return inspect(this, _objectSpread(_objectSpread({}, options), {}, {
        // Only inspect one level.
        depth: 0,
        // It should not recurse.
        customInspect: false
      }));
    }
  }]);
  return BufferList;
}();

/***/ }),

/***/ 33591:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__(14224);


// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;
  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;
  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err) {
      if (!this._writableState) {
        process.nextTick(emitErrorNT, this, err);
      } else if (!this._writableState.errorEmitted) {
        this._writableState.errorEmitted = true;
        process.nextTick(emitErrorNT, this, err);
      }
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }
  this._destroy(err || null, function (err) {
    if (!cb && err) {
      if (!_this._writableState) {
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else if (!_this._writableState.errorEmitted) {
        _this._writableState.errorEmitted = true;
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else {
        process.nextTick(emitCloseNT, _this);
      }
    } else if (cb) {
      process.nextTick(emitCloseNT, _this);
      cb(err);
    } else {
      process.nextTick(emitCloseNT, _this);
    }
  });
  return this;
}
function emitErrorAndCloseNT(self, err) {
  emitErrorNT(self, err);
  emitCloseNT(self);
}
function emitCloseNT(self) {
  if (self._writableState && !self._writableState.emitClose) return;
  if (self._readableState && !self._readableState.emitClose) return;
  self.emit('close');
}
function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }
  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finalCalled = false;
    this._writableState.prefinished = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}
function emitErrorNT(self, err) {
  self.emit('error', err);
}
function errorOrDestroy(stream, err) {
  // We have tests that rely on errors being emitted
  // in the same tick, so changing this is semver major.
  // For now when you opt-in to autoDestroy we allow
  // the error to be emitted nextTick. In a future
  // semver major update we should change the default to this.

  var rState = stream._readableState;
  var wState = stream._writableState;
  if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);else stream.emit('error', err);
}
module.exports = {
  destroy: destroy,
  undestroy: undestroy,
  errorOrDestroy: errorOrDestroy
};

/***/ }),

/***/ 43675:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).



var ERR_STREAM_PREMATURE_CLOSE = (__webpack_require__(60981)/* .codes.ERR_STREAM_PREMATURE_CLOSE */ .q.ERR_STREAM_PREMATURE_CLOSE);
function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    callback.apply(this, args);
  };
}
function noop() {}
function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}
function eos(stream, opts, callback) {
  if (typeof opts === 'function') return eos(stream, null, opts);
  if (!opts) opts = {};
  callback = once(callback || noop);
  var readable = opts.readable || opts.readable !== false && stream.readable;
  var writable = opts.writable || opts.writable !== false && stream.writable;
  var onlegacyfinish = function onlegacyfinish() {
    if (!stream.writable) onfinish();
  };
  var writableEnded = stream._writableState && stream._writableState.finished;
  var onfinish = function onfinish() {
    writable = false;
    writableEnded = true;
    if (!readable) callback.call(stream);
  };
  var readableEnded = stream._readableState && stream._readableState.endEmitted;
  var onend = function onend() {
    readable = false;
    readableEnded = true;
    if (!writable) callback.call(stream);
  };
  var onerror = function onerror(err) {
    callback.call(stream, err);
  };
  var onclose = function onclose() {
    var err;
    if (readable && !readableEnded) {
      if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
    if (writable && !writableEnded) {
      if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
  };
  var onrequest = function onrequest() {
    stream.req.on('finish', onfinish);
  };
  if (isRequest(stream)) {
    stream.on('complete', onfinish);
    stream.on('abort', onclose);
    if (stream.req) onrequest();else stream.on('request', onrequest);
  } else if (writable && !stream._writableState) {
    // legacy streams
    stream.on('end', onlegacyfinish);
    stream.on('close', onlegacyfinish);
  }
  stream.on('end', onend);
  stream.on('finish', onfinish);
  if (opts.error !== false) stream.on('error', onerror);
  stream.on('close', onclose);
  return function () {
    stream.removeListener('complete', onfinish);
    stream.removeListener('abort', onclose);
    stream.removeListener('request', onrequest);
    if (stream.req) stream.req.removeListener('finish', onfinish);
    stream.removeListener('end', onlegacyfinish);
    stream.removeListener('close', onlegacyfinish);
    stream.removeListener('finish', onfinish);
    stream.removeListener('end', onend);
    stream.removeListener('error', onerror);
    stream.removeListener('close', onclose);
  };
}
module.exports = eos;

/***/ }),

/***/ 82037:
/***/ ((module) => {

module.exports = function () {
  throw new Error('Readable.from is not available in the browser')
};


/***/ }),

/***/ 95597:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).



var eos;
function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    callback.apply(void 0, arguments);
  };
}
var _require$codes = (__webpack_require__(60981)/* .codes */ .q),
  ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS,
  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
function noop(err) {
  // Rethrow the error if it exists to avoid swallowing it
  if (err) throw err;
}
function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}
function destroyer(stream, reading, writing, callback) {
  callback = once(callback);
  var closed = false;
  stream.on('close', function () {
    closed = true;
  });
  if (eos === undefined) eos = __webpack_require__(43675);
  eos(stream, {
    readable: reading,
    writable: writing
  }, function (err) {
    if (err) return callback(err);
    closed = true;
    callback();
  });
  var destroyed = false;
  return function (err) {
    if (closed) return;
    if (destroyed) return;
    destroyed = true;

    // request.destroy just do .end - .abort is what we want
    if (isRequest(stream)) return stream.abort();
    if (typeof stream.destroy === 'function') return stream.destroy();
    callback(err || new ERR_STREAM_DESTROYED('pipe'));
  };
}
function call(fn) {
  fn();
}
function pipe(from, to) {
  return from.pipe(to);
}
function popCallback(streams) {
  if (!streams.length) return noop;
  if (typeof streams[streams.length - 1] !== 'function') return noop;
  return streams.pop();
}
function pipeline() {
  for (var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++) {
    streams[_key] = arguments[_key];
  }
  var callback = popCallback(streams);
  if (Array.isArray(streams[0])) streams = streams[0];
  if (streams.length < 2) {
    throw new ERR_MISSING_ARGS('streams');
  }
  var error;
  var destroys = streams.map(function (stream, i) {
    var reading = i < streams.length - 1;
    var writing = i > 0;
    return destroyer(stream, reading, writing, function (err) {
      if (!error) error = err;
      if (err) destroys.forEach(call);
      if (reading) return;
      destroys.forEach(call);
      callback(error);
    });
  });
  return streams.reduce(pipe);
}
module.exports = pipeline;

/***/ }),

/***/ 16084:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var ERR_INVALID_OPT_VALUE = (__webpack_require__(60981)/* .codes.ERR_INVALID_OPT_VALUE */ .q.ERR_INVALID_OPT_VALUE);
function highWaterMarkFrom(options, isDuplex, duplexKey) {
  return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function getHighWaterMark(state, options, duplexKey, isDuplex) {
  var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
  if (hwm != null) {
    if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
      var name = isDuplex ? duplexKey : 'highWaterMark';
      throw new ERR_INVALID_OPT_VALUE(name, hwm);
    }
    return Math.floor(hwm);
  }

  // Default value
  return state.objectMode ? 16 : 16 * 1024;
}
module.exports = {
  getHighWaterMark: getHighWaterMark
};

/***/ }),

/***/ 26922:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(72100).EventEmitter;


/***/ }),

/***/ 90250:
/***/ ((module) => {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; };
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) });

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: true });
  defineProperty(
    GeneratorFunctionPrototype,
    "constructor",
    { value: GeneratorFunction, configurable: true }
  );
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    defineProperty(this, "_invoke", { value: enqueue });
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method;
    var method = delegate.iterator[methodName];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method, or a missing .next mehtod, always terminate the
      // yield* loop.
      context.delegate = null;

      // Note: ["return"] must be used for ES3 parsing compatibility.
      if (methodName === "throw" && delegate.iterator["return"]) {
        // If the delegate iterator has a return method, give it a
        // chance to clean up.
        context.method = "return";
        context.arg = undefined;
        maybeInvokeDelegate(delegate, context);

        if (context.method === "throw") {
          // If maybeInvokeDelegate(context) changed context.method from
          // "return" to "throw", let that override the TypeError below.
          return ContinueSentinel;
        }
      }
      if (methodName !== "return") {
        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a '" + methodName + "' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(val) {
    var object = Object(val);
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : 0
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),

/***/ 10380:
/***/ ((module, exports, __webpack_require__) => {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(91620)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ 61874:
/***/ ((module, exports, __webpack_require__) => {

/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(91620)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ 69499:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

;(function (sax) { // wrapper for non-node envs
  sax.parser = function (strict, opt) { return new SAXParser(strict, opt) }
  sax.SAXParser = SAXParser
  sax.SAXStream = SAXStream
  sax.createStream = createStream

  // When we pass the MAX_BUFFER_LENGTH position, start checking for buffer overruns.
  // When we check, schedule the next check for MAX_BUFFER_LENGTH - (max(buffer lengths)),
  // since that's the earliest that a buffer overrun could occur.  This way, checks are
  // as rare as required, but as often as necessary to ensure never crossing this bound.
  // Furthermore, buffers are only tested at most once per write(), so passing a very
  // large string into write() might have undesirable effects, but this is manageable by
  // the caller, so it is assumed to be safe.  Thus, a call to write() may, in the extreme
  // edge case, result in creating at most one complete copy of the string passed in.
  // Set to Infinity to have unlimited buffers.
  sax.MAX_BUFFER_LENGTH = 64 * 1024

  var buffers = [
    'comment', 'sgmlDecl', 'textNode', 'tagName', 'doctype',
    'procInstName', 'procInstBody', 'entity', 'attribName',
    'attribValue', 'cdata', 'script'
  ]

  sax.EVENTS = [
    'text',
    'processinginstruction',
    'sgmldeclaration',
    'doctype',
    'comment',
    'opentagstart',
    'attribute',
    'opentag',
    'closetag',
    'opencdata',
    'cdata',
    'closecdata',
    'error',
    'end',
    'ready',
    'script',
    'opennamespace',
    'closenamespace'
  ]

  function SAXParser (strict, opt) {
    if (!(this instanceof SAXParser)) {
      return new SAXParser(strict, opt)
    }

    var parser = this
    clearBuffers(parser)
    parser.q = parser.c = ''
    parser.bufferCheckPosition = sax.MAX_BUFFER_LENGTH
    parser.opt = opt || {}
    parser.opt.lowercase = parser.opt.lowercase || parser.opt.lowercasetags
    parser.looseCase = parser.opt.lowercase ? 'toLowerCase' : 'toUpperCase'
    parser.tags = []
    parser.closed = parser.closedRoot = parser.sawRoot = false
    parser.tag = parser.error = null
    parser.strict = !!strict
    parser.noscript = !!(strict || parser.opt.noscript)
    parser.state = S.BEGIN
    parser.strictEntities = parser.opt.strictEntities
    parser.ENTITIES = parser.strictEntities ? Object.create(sax.XML_ENTITIES) : Object.create(sax.ENTITIES)
    parser.attribList = []

    // namespaces form a prototype chain.
    // it always points at the current tag,
    // which protos to its parent tag.
    if (parser.opt.xmlns) {
      parser.ns = Object.create(rootNS)
    }

    // mostly just for error reporting
    parser.trackPosition = parser.opt.position !== false
    if (parser.trackPosition) {
      parser.position = parser.line = parser.column = 0
    }
    emit(parser, 'onready')
  }

  if (!Object.create) {
    Object.create = function (o) {
      function F () {}
      F.prototype = o
      var newf = new F()
      return newf
    }
  }

  if (!Object.keys) {
    Object.keys = function (o) {
      var a = []
      for (var i in o) if (o.hasOwnProperty(i)) a.push(i)
      return a
    }
  }

  function checkBufferLength (parser) {
    var maxAllowed = Math.max(sax.MAX_BUFFER_LENGTH, 10)
    var maxActual = 0
    for (var i = 0, l = buffers.length; i < l; i++) {
      var len = parser[buffers[i]].length
      if (len > maxAllowed) {
        // Text/cdata nodes can get big, and since they're buffered,
        // we can get here under normal conditions.
        // Avoid issues by emitting the text node now,
        // so at least it won't get any bigger.
        switch (buffers[i]) {
          case 'textNode':
            closeText(parser)
            break

          case 'cdata':
            emitNode(parser, 'oncdata', parser.cdata)
            parser.cdata = ''
            break

          case 'script':
            emitNode(parser, 'onscript', parser.script)
            parser.script = ''
            break

          default:
            error(parser, 'Max buffer length exceeded: ' + buffers[i])
        }
      }
      maxActual = Math.max(maxActual, len)
    }
    // schedule the next check for the earliest possible buffer overrun.
    var m = sax.MAX_BUFFER_LENGTH - maxActual
    parser.bufferCheckPosition = m + parser.position
  }

  function clearBuffers (parser) {
    for (var i = 0, l = buffers.length; i < l; i++) {
      parser[buffers[i]] = ''
    }
  }

  function flushBuffers (parser) {
    closeText(parser)
    if (parser.cdata !== '') {
      emitNode(parser, 'oncdata', parser.cdata)
      parser.cdata = ''
    }
    if (parser.script !== '') {
      emitNode(parser, 'onscript', parser.script)
      parser.script = ''
    }
  }

  SAXParser.prototype = {
    end: function () { end(this) },
    write: write,
    resume: function () { this.error = null; return this },
    close: function () { return this.write(null) },
    flush: function () { flushBuffers(this) }
  }

  var Stream
  try {
    Stream = (__webpack_require__(76835).Stream)
  } catch (ex) {
    Stream = function () {}
  }

  var streamWraps = sax.EVENTS.filter(function (ev) {
    return ev !== 'error' && ev !== 'end'
  })

  function createStream (strict, opt) {
    return new SAXStream(strict, opt)
  }

  function SAXStream (strict, opt) {
    if (!(this instanceof SAXStream)) {
      return new SAXStream(strict, opt)
    }

    Stream.apply(this)

    this._parser = new SAXParser(strict, opt)
    this.writable = true
    this.readable = true

    var me = this

    this._parser.onend = function () {
      me.emit('end')
    }

    this._parser.onerror = function (er) {
      me.emit('error', er)

      // if didn't throw, then means error was handled.
      // go ahead and clear error, so we can write again.
      me._parser.error = null
    }

    this._decoder = null

    streamWraps.forEach(function (ev) {
      Object.defineProperty(me, 'on' + ev, {
        get: function () {
          return me._parser['on' + ev]
        },
        set: function (h) {
          if (!h) {
            me.removeAllListeners(ev)
            me._parser['on' + ev] = h
            return h
          }
          me.on(ev, h)
        },
        enumerable: true,
        configurable: false
      })
    })
  }

  SAXStream.prototype = Object.create(Stream.prototype, {
    constructor: {
      value: SAXStream
    }
  })

  SAXStream.prototype.write = function (data) {
    if (typeof Buffer === 'function' &&
      typeof Buffer.isBuffer === 'function' &&
      Buffer.isBuffer(data)) {
      if (!this._decoder) {
        var SD = (__webpack_require__(68861)/* .StringDecoder */ .s)
        this._decoder = new SD('utf8')
      }
      data = this._decoder.write(data)
    }

    this._parser.write(data.toString())
    this.emit('data', data)
    return true
  }

  SAXStream.prototype.end = function (chunk) {
    if (chunk && chunk.length) {
      this.write(chunk)
    }
    this._parser.end()
    return true
  }

  SAXStream.prototype.on = function (ev, handler) {
    var me = this
    if (!me._parser['on' + ev] && streamWraps.indexOf(ev) !== -1) {
      me._parser['on' + ev] = function () {
        var args = arguments.length === 1 ? [arguments[0]] : Array.apply(null, arguments)
        args.splice(0, 0, ev)
        me.emit.apply(me, args)
      }
    }

    return Stream.prototype.on.call(me, ev, handler)
  }

  // this really needs to be replaced with character classes.
  // XML allows all manner of ridiculous numbers and digits.
  var CDATA = '[CDATA['
  var DOCTYPE = 'DOCTYPE'
  var XML_NAMESPACE = 'http://www.w3.org/XML/1998/namespace'
  var XMLNS_NAMESPACE = 'http://www.w3.org/2000/xmlns/'
  var rootNS = { xml: XML_NAMESPACE, xmlns: XMLNS_NAMESPACE }

  // http://www.w3.org/TR/REC-xml/#NT-NameStartChar
  // This implementation works on strings, a single character at a time
  // as such, it cannot ever support astral-plane characters (10000-EFFFF)
  // without a significant breaking change to either this  parser, or the
  // JavaScript language.  Implementation of an emoji-capable xml parser
  // is left as an exercise for the reader.
  var nameStart = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/

  var nameBody = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/

  var entityStart = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/
  var entityBody = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/

  function isWhitespace (c) {
    return c === ' ' || c === '\n' || c === '\r' || c === '\t'
  }

  function isQuote (c) {
    return c === '"' || c === '\''
  }

  function isAttribEnd (c) {
    return c === '>' || isWhitespace(c)
  }

  function isMatch (regex, c) {
    return regex.test(c)
  }

  function notMatch (regex, c) {
    return !isMatch(regex, c)
  }

  var S = 0
  sax.STATE = {
    BEGIN: S++, // leading byte order mark or whitespace
    BEGIN_WHITESPACE: S++, // leading whitespace
    TEXT: S++, // general stuff
    TEXT_ENTITY: S++, // &amp and such.
    OPEN_WAKA: S++, // <
    SGML_DECL: S++, // <!BLARG
    SGML_DECL_QUOTED: S++, // <!BLARG foo "bar
    DOCTYPE: S++, // <!DOCTYPE
    DOCTYPE_QUOTED: S++, // <!DOCTYPE "//blah
    DOCTYPE_DTD: S++, // <!DOCTYPE "//blah" [ ...
    DOCTYPE_DTD_QUOTED: S++, // <!DOCTYPE "//blah" [ "foo
    COMMENT_STARTING: S++, // <!-
    COMMENT: S++, // <!--
    COMMENT_ENDING: S++, // <!-- blah -
    COMMENT_ENDED: S++, // <!-- blah --
    CDATA: S++, // <![CDATA[ something
    CDATA_ENDING: S++, // ]
    CDATA_ENDING_2: S++, // ]]
    PROC_INST: S++, // <?hi
    PROC_INST_BODY: S++, // <?hi there
    PROC_INST_ENDING: S++, // <?hi "there" ?
    OPEN_TAG: S++, // <strong
    OPEN_TAG_SLASH: S++, // <strong /
    ATTRIB: S++, // <a
    ATTRIB_NAME: S++, // <a foo
    ATTRIB_NAME_SAW_WHITE: S++, // <a foo _
    ATTRIB_VALUE: S++, // <a foo=
    ATTRIB_VALUE_QUOTED: S++, // <a foo="bar
    ATTRIB_VALUE_CLOSED: S++, // <a foo="bar"
    ATTRIB_VALUE_UNQUOTED: S++, // <a foo=bar
    ATTRIB_VALUE_ENTITY_Q: S++, // <foo bar="&quot;"
    ATTRIB_VALUE_ENTITY_U: S++, // <foo bar=&quot
    CLOSE_TAG: S++, // </a
    CLOSE_TAG_SAW_WHITE: S++, // </a   >
    SCRIPT: S++, // <script> ...
    SCRIPT_ENDING: S++ // <script> ... <
  }

  sax.XML_ENTITIES = {
    'amp': '&',
    'gt': '>',
    'lt': '<',
    'quot': '"',
    'apos': "'"
  }

  sax.ENTITIES = {
    'amp': '&',
    'gt': '>',
    'lt': '<',
    'quot': '"',
    'apos': "'",
    'AElig': 198,
    'Aacute': 193,
    'Acirc': 194,
    'Agrave': 192,
    'Aring': 197,
    'Atilde': 195,
    'Auml': 196,
    'Ccedil': 199,
    'ETH': 208,
    'Eacute': 201,
    'Ecirc': 202,
    'Egrave': 200,
    'Euml': 203,
    'Iacute': 205,
    'Icirc': 206,
    'Igrave': 204,
    'Iuml': 207,
    'Ntilde': 209,
    'Oacute': 211,
    'Ocirc': 212,
    'Ograve': 210,
    'Oslash': 216,
    'Otilde': 213,
    'Ouml': 214,
    'THORN': 222,
    'Uacute': 218,
    'Ucirc': 219,
    'Ugrave': 217,
    'Uuml': 220,
    'Yacute': 221,
    'aacute': 225,
    'acirc': 226,
    'aelig': 230,
    'agrave': 224,
    'aring': 229,
    'atilde': 227,
    'auml': 228,
    'ccedil': 231,
    'eacute': 233,
    'ecirc': 234,
    'egrave': 232,
    'eth': 240,
    'euml': 235,
    'iacute': 237,
    'icirc': 238,
    'igrave': 236,
    'iuml': 239,
    'ntilde': 241,
    'oacute': 243,
    'ocirc': 244,
    'ograve': 242,
    'oslash': 248,
    'otilde': 245,
    'ouml': 246,
    'szlig': 223,
    'thorn': 254,
    'uacute': 250,
    'ucirc': 251,
    'ugrave': 249,
    'uuml': 252,
    'yacute': 253,
    'yuml': 255,
    'copy': 169,
    'reg': 174,
    'nbsp': 160,
    'iexcl': 161,
    'cent': 162,
    'pound': 163,
    'curren': 164,
    'yen': 165,
    'brvbar': 166,
    'sect': 167,
    'uml': 168,
    'ordf': 170,
    'laquo': 171,
    'not': 172,
    'shy': 173,
    'macr': 175,
    'deg': 176,
    'plusmn': 177,
    'sup1': 185,
    'sup2': 178,
    'sup3': 179,
    'acute': 180,
    'micro': 181,
    'para': 182,
    'middot': 183,
    'cedil': 184,
    'ordm': 186,
    'raquo': 187,
    'frac14': 188,
    'frac12': 189,
    'frac34': 190,
    'iquest': 191,
    'times': 215,
    'divide': 247,
    'OElig': 338,
    'oelig': 339,
    'Scaron': 352,
    'scaron': 353,
    'Yuml': 376,
    'fnof': 402,
    'circ': 710,
    'tilde': 732,
    'Alpha': 913,
    'Beta': 914,
    'Gamma': 915,
    'Delta': 916,
    'Epsilon': 917,
    'Zeta': 918,
    'Eta': 919,
    'Theta': 920,
    'Iota': 921,
    'Kappa': 922,
    'Lambda': 923,
    'Mu': 924,
    'Nu': 925,
    'Xi': 926,
    'Omicron': 927,
    'Pi': 928,
    'Rho': 929,
    'Sigma': 931,
    'Tau': 932,
    'Upsilon': 933,
    'Phi': 934,
    'Chi': 935,
    'Psi': 936,
    'Omega': 937,
    'alpha': 945,
    'beta': 946,
    'gamma': 947,
    'delta': 948,
    'epsilon': 949,
    'zeta': 950,
    'eta': 951,
    'theta': 952,
    'iota': 953,
    'kappa': 954,
    'lambda': 955,
    'mu': 956,
    'nu': 957,
    'xi': 958,
    'omicron': 959,
    'pi': 960,
    'rho': 961,
    'sigmaf': 962,
    'sigma': 963,
    'tau': 964,
    'upsilon': 965,
    'phi': 966,
    'chi': 967,
    'psi': 968,
    'omega': 969,
    'thetasym': 977,
    'upsih': 978,
    'piv': 982,
    'ensp': 8194,
    'emsp': 8195,
    'thinsp': 8201,
    'zwnj': 8204,
    'zwj': 8205,
    'lrm': 8206,
    'rlm': 8207,
    'ndash': 8211,
    'mdash': 8212,
    'lsquo': 8216,
    'rsquo': 8217,
    'sbquo': 8218,
    'ldquo': 8220,
    'rdquo': 8221,
    'bdquo': 8222,
    'dagger': 8224,
    'Dagger': 8225,
    'bull': 8226,
    'hellip': 8230,
    'permil': 8240,
    'prime': 8242,
    'Prime': 8243,
    'lsaquo': 8249,
    'rsaquo': 8250,
    'oline': 8254,
    'frasl': 8260,
    'euro': 8364,
    'image': 8465,
    'weierp': 8472,
    'real': 8476,
    'trade': 8482,
    'alefsym': 8501,
    'larr': 8592,
    'uarr': 8593,
    'rarr': 8594,
    'darr': 8595,
    'harr': 8596,
    'crarr': 8629,
    'lArr': 8656,
    'uArr': 8657,
    'rArr': 8658,
    'dArr': 8659,
    'hArr': 8660,
    'forall': 8704,
    'part': 8706,
    'exist': 8707,
    'empty': 8709,
    'nabla': 8711,
    'isin': 8712,
    'notin': 8713,
    'ni': 8715,
    'prod': 8719,
    'sum': 8721,
    'minus': 8722,
    'lowast': 8727,
    'radic': 8730,
    'prop': 8733,
    'infin': 8734,
    'ang': 8736,
    'and': 8743,
    'or': 8744,
    'cap': 8745,
    'cup': 8746,
    'int': 8747,
    'there4': 8756,
    'sim': 8764,
    'cong': 8773,
    'asymp': 8776,
    'ne': 8800,
    'equiv': 8801,
    'le': 8804,
    'ge': 8805,
    'sub': 8834,
    'sup': 8835,
    'nsub': 8836,
    'sube': 8838,
    'supe': 8839,
    'oplus': 8853,
    'otimes': 8855,
    'perp': 8869,
    'sdot': 8901,
    'lceil': 8968,
    'rceil': 8969,
    'lfloor': 8970,
    'rfloor': 8971,
    'lang': 9001,
    'rang': 9002,
    'loz': 9674,
    'spades': 9824,
    'clubs': 9827,
    'hearts': 9829,
    'diams': 9830
  }

  Object.keys(sax.ENTITIES).forEach(function (key) {
    var e = sax.ENTITIES[key]
    var s = typeof e === 'number' ? String.fromCharCode(e) : e
    sax.ENTITIES[key] = s
  })

  for (var s in sax.STATE) {
    sax.STATE[sax.STATE[s]] = s
  }

  // shorthand
  S = sax.STATE

  function emit (parser, event, data) {
    parser[event] && parser[event](data)
  }

  function emitNode (parser, nodeType, data) {
    if (parser.textNode) closeText(parser)
    emit(parser, nodeType, data)
  }

  function closeText (parser) {
    parser.textNode = textopts(parser.opt, parser.textNode)
    if (parser.textNode) emit(parser, 'ontext', parser.textNode)
    parser.textNode = ''
  }

  function textopts (opt, text) {
    if (opt.trim) text = text.trim()
    if (opt.normalize) text = text.replace(/\s+/g, ' ')
    return text
  }

  function error (parser, er) {
    closeText(parser)
    if (parser.trackPosition) {
      er += '\nLine: ' + parser.line +
        '\nColumn: ' + parser.column +
        '\nChar: ' + parser.c
    }
    er = new Error(er)
    parser.error = er
    emit(parser, 'onerror', er)
    return parser
  }

  function end (parser) {
    if (parser.sawRoot && !parser.closedRoot) strictFail(parser, 'Unclosed root tag')
    if ((parser.state !== S.BEGIN) &&
      (parser.state !== S.BEGIN_WHITESPACE) &&
      (parser.state !== S.TEXT)) {
      error(parser, 'Unexpected end')
    }
    closeText(parser)
    parser.c = ''
    parser.closed = true
    emit(parser, 'onend')
    SAXParser.call(parser, parser.strict, parser.opt)
    return parser
  }

  function strictFail (parser, message) {
    if (typeof parser !== 'object' || !(parser instanceof SAXParser)) {
      throw new Error('bad call to strictFail')
    }
    if (parser.strict) {
      error(parser, message)
    }
  }

  function newTag (parser) {
    if (!parser.strict) parser.tagName = parser.tagName[parser.looseCase]()
    var parent = parser.tags[parser.tags.length - 1] || parser
    var tag = parser.tag = { name: parser.tagName, attributes: {} }

    // will be overridden if tag contails an xmlns="foo" or xmlns:foo="bar"
    if (parser.opt.xmlns) {
      tag.ns = parent.ns
    }
    parser.attribList.length = 0
    emitNode(parser, 'onopentagstart', tag)
  }

  function qname (name, attribute) {
    var i = name.indexOf(':')
    var qualName = i < 0 ? [ '', name ] : name.split(':')
    var prefix = qualName[0]
    var local = qualName[1]

    // <x "xmlns"="http://foo">
    if (attribute && name === 'xmlns') {
      prefix = 'xmlns'
      local = ''
    }

    return { prefix: prefix, local: local }
  }

  function attrib (parser) {
    if (!parser.strict) {
      parser.attribName = parser.attribName[parser.looseCase]()
    }

    if (parser.attribList.indexOf(parser.attribName) !== -1 ||
      parser.tag.attributes.hasOwnProperty(parser.attribName)) {
      parser.attribName = parser.attribValue = ''
      return
    }

    if (parser.opt.xmlns) {
      var qn = qname(parser.attribName, true)
      var prefix = qn.prefix
      var local = qn.local

      if (prefix === 'xmlns') {
        // namespace binding attribute. push the binding into scope
        if (local === 'xml' && parser.attribValue !== XML_NAMESPACE) {
          strictFail(parser,
            'xml: prefix must be bound to ' + XML_NAMESPACE + '\n' +
            'Actual: ' + parser.attribValue)
        } else if (local === 'xmlns' && parser.attribValue !== XMLNS_NAMESPACE) {
          strictFail(parser,
            'xmlns: prefix must be bound to ' + XMLNS_NAMESPACE + '\n' +
            'Actual: ' + parser.attribValue)
        } else {
          var tag = parser.tag
          var parent = parser.tags[parser.tags.length - 1] || parser
          if (tag.ns === parent.ns) {
            tag.ns = Object.create(parent.ns)
          }
          tag.ns[local] = parser.attribValue
        }
      }

      // defer onattribute events until all attributes have been seen
      // so any new bindings can take effect. preserve attribute order
      // so deferred events can be emitted in document order
      parser.attribList.push([parser.attribName, parser.attribValue])
    } else {
      // in non-xmlns mode, we can emit the event right away
      parser.tag.attributes[parser.attribName] = parser.attribValue
      emitNode(parser, 'onattribute', {
        name: parser.attribName,
        value: parser.attribValue
      })
    }

    parser.attribName = parser.attribValue = ''
  }

  function openTag (parser, selfClosing) {
    if (parser.opt.xmlns) {
      // emit namespace binding events
      var tag = parser.tag

      // add namespace info to tag
      var qn = qname(parser.tagName)
      tag.prefix = qn.prefix
      tag.local = qn.local
      tag.uri = tag.ns[qn.prefix] || ''

      if (tag.prefix && !tag.uri) {
        strictFail(parser, 'Unbound namespace prefix: ' +
          JSON.stringify(parser.tagName))
        tag.uri = qn.prefix
      }

      var parent = parser.tags[parser.tags.length - 1] || parser
      if (tag.ns && parent.ns !== tag.ns) {
        Object.keys(tag.ns).forEach(function (p) {
          emitNode(parser, 'onopennamespace', {
            prefix: p,
            uri: tag.ns[p]
          })
        })
      }

      // handle deferred onattribute events
      // Note: do not apply default ns to attributes:
      //   http://www.w3.org/TR/REC-xml-names/#defaulting
      for (var i = 0, l = parser.attribList.length; i < l; i++) {
        var nv = parser.attribList[i]
        var name = nv[0]
        var value = nv[1]
        var qualName = qname(name, true)
        var prefix = qualName.prefix
        var local = qualName.local
        var uri = prefix === '' ? '' : (tag.ns[prefix] || '')
        var a = {
          name: name,
          value: value,
          prefix: prefix,
          local: local,
          uri: uri
        }

        // if there's any attributes with an undefined namespace,
        // then fail on them now.
        if (prefix && prefix !== 'xmlns' && !uri) {
          strictFail(parser, 'Unbound namespace prefix: ' +
            JSON.stringify(prefix))
          a.uri = prefix
        }
        parser.tag.attributes[name] = a
        emitNode(parser, 'onattribute', a)
      }
      parser.attribList.length = 0
    }

    parser.tag.isSelfClosing = !!selfClosing

    // process the tag
    parser.sawRoot = true
    parser.tags.push(parser.tag)
    emitNode(parser, 'onopentag', parser.tag)
    if (!selfClosing) {
      // special case for <script> in non-strict mode.
      if (!parser.noscript && parser.tagName.toLowerCase() === 'script') {
        parser.state = S.SCRIPT
      } else {
        parser.state = S.TEXT
      }
      parser.tag = null
      parser.tagName = ''
    }
    parser.attribName = parser.attribValue = ''
    parser.attribList.length = 0
  }

  function closeTag (parser) {
    if (!parser.tagName) {
      strictFail(parser, 'Weird empty close tag.')
      parser.textNode += '</>'
      parser.state = S.TEXT
      return
    }

    if (parser.script) {
      if (parser.tagName !== 'script') {
        parser.script += '</' + parser.tagName + '>'
        parser.tagName = ''
        parser.state = S.SCRIPT
        return
      }
      emitNode(parser, 'onscript', parser.script)
      parser.script = ''
    }

    // first make sure that the closing tag actually exists.
    // <a><b></c></b></a> will close everything, otherwise.
    var t = parser.tags.length
    var tagName = parser.tagName
    if (!parser.strict) {
      tagName = tagName[parser.looseCase]()
    }
    var closeTo = tagName
    while (t--) {
      var close = parser.tags[t]
      if (close.name !== closeTo) {
        // fail the first time in strict mode
        strictFail(parser, 'Unexpected close tag')
      } else {
        break
      }
    }

    // didn't find it.  we already failed for strict, so just abort.
    if (t < 0) {
      strictFail(parser, 'Unmatched closing tag: ' + parser.tagName)
      parser.textNode += '</' + parser.tagName + '>'
      parser.state = S.TEXT
      return
    }
    parser.tagName = tagName
    var s = parser.tags.length
    while (s-- > t) {
      var tag = parser.tag = parser.tags.pop()
      parser.tagName = parser.tag.name
      emitNode(parser, 'onclosetag', parser.tagName)

      var x = {}
      for (var i in tag.ns) {
        x[i] = tag.ns[i]
      }

      var parent = parser.tags[parser.tags.length - 1] || parser
      if (parser.opt.xmlns && tag.ns !== parent.ns) {
        // remove namespace bindings introduced by tag
        Object.keys(tag.ns).forEach(function (p) {
          var n = tag.ns[p]
          emitNode(parser, 'onclosenamespace', { prefix: p, uri: n })
        })
      }
    }
    if (t === 0) parser.closedRoot = true
    parser.tagName = parser.attribValue = parser.attribName = ''
    parser.attribList.length = 0
    parser.state = S.TEXT
  }

  function parseEntity (parser) {
    var entity = parser.entity
    var entityLC = entity.toLowerCase()
    var num
    var numStr = ''

    if (parser.ENTITIES[entity]) {
      return parser.ENTITIES[entity]
    }
    if (parser.ENTITIES[entityLC]) {
      return parser.ENTITIES[entityLC]
    }
    entity = entityLC
    if (entity.charAt(0) === '#') {
      if (entity.charAt(1) === 'x') {
        entity = entity.slice(2)
        num = parseInt(entity, 16)
        numStr = num.toString(16)
      } else {
        entity = entity.slice(1)
        num = parseInt(entity, 10)
        numStr = num.toString(10)
      }
    }
    entity = entity.replace(/^0+/, '')
    if (isNaN(num) || numStr.toLowerCase() !== entity) {
      strictFail(parser, 'Invalid character entity')
      return '&' + parser.entity + ';'
    }

    return String.fromCodePoint(num)
  }

  function beginWhiteSpace (parser, c) {
    if (c === '<') {
      parser.state = S.OPEN_WAKA
      parser.startTagPosition = parser.position
    } else if (!isWhitespace(c)) {
      // have to process this as a text node.
      // weird, but happens.
      strictFail(parser, 'Non-whitespace before first tag.')
      parser.textNode = c
      parser.state = S.TEXT
    }
  }

  function charAt (chunk, i) {
    var result = ''
    if (i < chunk.length) {
      result = chunk.charAt(i)
    }
    return result
  }

  function write (chunk) {
    var parser = this
    if (this.error) {
      throw this.error
    }
    if (parser.closed) {
      return error(parser,
        'Cannot write after close. Assign an onready handler.')
    }
    if (chunk === null) {
      return end(parser)
    }
    if (typeof chunk === 'object') {
      chunk = chunk.toString()
    }
    var i = 0
    var c = ''
    while (true) {
      c = charAt(chunk, i++)
      parser.c = c

      if (!c) {
        break
      }

      if (parser.trackPosition) {
        parser.position++
        if (c === '\n') {
          parser.line++
          parser.column = 0
        } else {
          parser.column++
        }
      }

      switch (parser.state) {
        case S.BEGIN:
          parser.state = S.BEGIN_WHITESPACE
          if (c === '\uFEFF') {
            continue
          }
          beginWhiteSpace(parser, c)
          continue

        case S.BEGIN_WHITESPACE:
          beginWhiteSpace(parser, c)
          continue

        case S.TEXT:
          if (parser.sawRoot && !parser.closedRoot) {
            var starti = i - 1
            while (c && c !== '<' && c !== '&') {
              c = charAt(chunk, i++)
              if (c && parser.trackPosition) {
                parser.position++
                if (c === '\n') {
                  parser.line++
                  parser.column = 0
                } else {
                  parser.column++
                }
              }
            }
            parser.textNode += chunk.substring(starti, i - 1)
          }
          if (c === '<' && !(parser.sawRoot && parser.closedRoot && !parser.strict)) {
            parser.state = S.OPEN_WAKA
            parser.startTagPosition = parser.position
          } else {
            if (!isWhitespace(c) && (!parser.sawRoot || parser.closedRoot)) {
              strictFail(parser, 'Text data outside of root node.')
            }
            if (c === '&') {
              parser.state = S.TEXT_ENTITY
            } else {
              parser.textNode += c
            }
          }
          continue

        case S.SCRIPT:
          // only non-strict
          if (c === '<') {
            parser.state = S.SCRIPT_ENDING
          } else {
            parser.script += c
          }
          continue

        case S.SCRIPT_ENDING:
          if (c === '/') {
            parser.state = S.CLOSE_TAG
          } else {
            parser.script += '<' + c
            parser.state = S.SCRIPT
          }
          continue

        case S.OPEN_WAKA:
          // either a /, ?, !, or text is coming next.
          if (c === '!') {
            parser.state = S.SGML_DECL
            parser.sgmlDecl = ''
          } else if (isWhitespace(c)) {
            // wait for it...
          } else if (isMatch(nameStart, c)) {
            parser.state = S.OPEN_TAG
            parser.tagName = c
          } else if (c === '/') {
            parser.state = S.CLOSE_TAG
            parser.tagName = ''
          } else if (c === '?') {
            parser.state = S.PROC_INST
            parser.procInstName = parser.procInstBody = ''
          } else {
            strictFail(parser, 'Unencoded <')
            // if there was some whitespace, then add that in.
            if (parser.startTagPosition + 1 < parser.position) {
              var pad = parser.position - parser.startTagPosition
              c = new Array(pad).join(' ') + c
            }
            parser.textNode += '<' + c
            parser.state = S.TEXT
          }
          continue

        case S.SGML_DECL:
          if ((parser.sgmlDecl + c).toUpperCase() === CDATA) {
            emitNode(parser, 'onopencdata')
            parser.state = S.CDATA
            parser.sgmlDecl = ''
            parser.cdata = ''
          } else if (parser.sgmlDecl + c === '--') {
            parser.state = S.COMMENT
            parser.comment = ''
            parser.sgmlDecl = ''
          } else if ((parser.sgmlDecl + c).toUpperCase() === DOCTYPE) {
            parser.state = S.DOCTYPE
            if (parser.doctype || parser.sawRoot) {
              strictFail(parser,
                'Inappropriately located doctype declaration')
            }
            parser.doctype = ''
            parser.sgmlDecl = ''
          } else if (c === '>') {
            emitNode(parser, 'onsgmldeclaration', parser.sgmlDecl)
            parser.sgmlDecl = ''
            parser.state = S.TEXT
          } else if (isQuote(c)) {
            parser.state = S.SGML_DECL_QUOTED
            parser.sgmlDecl += c
          } else {
            parser.sgmlDecl += c
          }
          continue

        case S.SGML_DECL_QUOTED:
          if (c === parser.q) {
            parser.state = S.SGML_DECL
            parser.q = ''
          }
          parser.sgmlDecl += c
          continue

        case S.DOCTYPE:
          if (c === '>') {
            parser.state = S.TEXT
            emitNode(parser, 'ondoctype', parser.doctype)
            parser.doctype = true // just remember that we saw it.
          } else {
            parser.doctype += c
            if (c === '[') {
              parser.state = S.DOCTYPE_DTD
            } else if (isQuote(c)) {
              parser.state = S.DOCTYPE_QUOTED
              parser.q = c
            }
          }
          continue

        case S.DOCTYPE_QUOTED:
          parser.doctype += c
          if (c === parser.q) {
            parser.q = ''
            parser.state = S.DOCTYPE
          }
          continue

        case S.DOCTYPE_DTD:
          parser.doctype += c
          if (c === ']') {
            parser.state = S.DOCTYPE
          } else if (isQuote(c)) {
            parser.state = S.DOCTYPE_DTD_QUOTED
            parser.q = c
          }
          continue

        case S.DOCTYPE_DTD_QUOTED:
          parser.doctype += c
          if (c === parser.q) {
            parser.state = S.DOCTYPE_DTD
            parser.q = ''
          }
          continue

        case S.COMMENT:
          if (c === '-') {
            parser.state = S.COMMENT_ENDING
          } else {
            parser.comment += c
          }
          continue

        case S.COMMENT_ENDING:
          if (c === '-') {
            parser.state = S.COMMENT_ENDED
            parser.comment = textopts(parser.opt, parser.comment)
            if (parser.comment) {
              emitNode(parser, 'oncomment', parser.comment)
            }
            parser.comment = ''
          } else {
            parser.comment += '-' + c
            parser.state = S.COMMENT
          }
          continue

        case S.COMMENT_ENDED:
          if (c !== '>') {
            strictFail(parser, 'Malformed comment')
            // allow <!-- blah -- bloo --> in non-strict mode,
            // which is a comment of " blah -- bloo "
            parser.comment += '--' + c
            parser.state = S.COMMENT
          } else {
            parser.state = S.TEXT
          }
          continue

        case S.CDATA:
          if (c === ']') {
            parser.state = S.CDATA_ENDING
          } else {
            parser.cdata += c
          }
          continue

        case S.CDATA_ENDING:
          if (c === ']') {
            parser.state = S.CDATA_ENDING_2
          } else {
            parser.cdata += ']' + c
            parser.state = S.CDATA
          }
          continue

        case S.CDATA_ENDING_2:
          if (c === '>') {
            if (parser.cdata) {
              emitNode(parser, 'oncdata', parser.cdata)
            }
            emitNode(parser, 'onclosecdata')
            parser.cdata = ''
            parser.state = S.TEXT
          } else if (c === ']') {
            parser.cdata += ']'
          } else {
            parser.cdata += ']]' + c
            parser.state = S.CDATA
          }
          continue

        case S.PROC_INST:
          if (c === '?') {
            parser.state = S.PROC_INST_ENDING
          } else if (isWhitespace(c)) {
            parser.state = S.PROC_INST_BODY
          } else {
            parser.procInstName += c
          }
          continue

        case S.PROC_INST_BODY:
          if (!parser.procInstBody && isWhitespace(c)) {
            continue
          } else if (c === '?') {
            parser.state = S.PROC_INST_ENDING
          } else {
            parser.procInstBody += c
          }
          continue

        case S.PROC_INST_ENDING:
          if (c === '>') {
            emitNode(parser, 'onprocessinginstruction', {
              name: parser.procInstName,
              body: parser.procInstBody
            })
            parser.procInstName = parser.procInstBody = ''
            parser.state = S.TEXT
          } else {
            parser.procInstBody += '?' + c
            parser.state = S.PROC_INST_BODY
          }
          continue

        case S.OPEN_TAG:
          if (isMatch(nameBody, c)) {
            parser.tagName += c
          } else {
            newTag(parser)
            if (c === '>') {
              openTag(parser)
            } else if (c === '/') {
              parser.state = S.OPEN_TAG_SLASH
            } else {
              if (!isWhitespace(c)) {
                strictFail(parser, 'Invalid character in tag name')
              }
              parser.state = S.ATTRIB
            }
          }
          continue

        case S.OPEN_TAG_SLASH:
          if (c === '>') {
            openTag(parser, true)
            closeTag(parser)
          } else {
            strictFail(parser, 'Forward-slash in opening tag not followed by >')
            parser.state = S.ATTRIB
          }
          continue

        case S.ATTRIB:
          // haven't read the attribute name yet.
          if (isWhitespace(c)) {
            continue
          } else if (c === '>') {
            openTag(parser)
          } else if (c === '/') {
            parser.state = S.OPEN_TAG_SLASH
          } else if (isMatch(nameStart, c)) {
            parser.attribName = c
            parser.attribValue = ''
            parser.state = S.ATTRIB_NAME
          } else {
            strictFail(parser, 'Invalid attribute name')
          }
          continue

        case S.ATTRIB_NAME:
          if (c === '=') {
            parser.state = S.ATTRIB_VALUE
          } else if (c === '>') {
            strictFail(parser, 'Attribute without value')
            parser.attribValue = parser.attribName
            attrib(parser)
            openTag(parser)
          } else if (isWhitespace(c)) {
            parser.state = S.ATTRIB_NAME_SAW_WHITE
          } else if (isMatch(nameBody, c)) {
            parser.attribName += c
          } else {
            strictFail(parser, 'Invalid attribute name')
          }
          continue

        case S.ATTRIB_NAME_SAW_WHITE:
          if (c === '=') {
            parser.state = S.ATTRIB_VALUE
          } else if (isWhitespace(c)) {
            continue
          } else {
            strictFail(parser, 'Attribute without value')
            parser.tag.attributes[parser.attribName] = ''
            parser.attribValue = ''
            emitNode(parser, 'onattribute', {
              name: parser.attribName,
              value: ''
            })
            parser.attribName = ''
            if (c === '>') {
              openTag(parser)
            } else if (isMatch(nameStart, c)) {
              parser.attribName = c
              parser.state = S.ATTRIB_NAME
            } else {
              strictFail(parser, 'Invalid attribute name')
              parser.state = S.ATTRIB
            }
          }
          continue

        case S.ATTRIB_VALUE:
          if (isWhitespace(c)) {
            continue
          } else if (isQuote(c)) {
            parser.q = c
            parser.state = S.ATTRIB_VALUE_QUOTED
          } else {
            strictFail(parser, 'Unquoted attribute value')
            parser.state = S.ATTRIB_VALUE_UNQUOTED
            parser.attribValue = c
          }
          continue

        case S.ATTRIB_VALUE_QUOTED:
          if (c !== parser.q) {
            if (c === '&') {
              parser.state = S.ATTRIB_VALUE_ENTITY_Q
            } else {
              parser.attribValue += c
            }
            continue
          }
          attrib(parser)
          parser.q = ''
          parser.state = S.ATTRIB_VALUE_CLOSED
          continue

        case S.ATTRIB_VALUE_CLOSED:
          if (isWhitespace(c)) {
            parser.state = S.ATTRIB
          } else if (c === '>') {
            openTag(parser)
          } else if (c === '/') {
            parser.state = S.OPEN_TAG_SLASH
          } else if (isMatch(nameStart, c)) {
            strictFail(parser, 'No whitespace between attributes')
            parser.attribName = c
            parser.attribValue = ''
            parser.state = S.ATTRIB_NAME
          } else {
            strictFail(parser, 'Invalid attribute name')
          }
          continue

        case S.ATTRIB_VALUE_UNQUOTED:
          if (!isAttribEnd(c)) {
            if (c === '&') {
              parser.state = S.ATTRIB_VALUE_ENTITY_U
            } else {
              parser.attribValue += c
            }
            continue
          }
          attrib(parser)
          if (c === '>') {
            openTag(parser)
          } else {
            parser.state = S.ATTRIB
          }
          continue

        case S.CLOSE_TAG:
          if (!parser.tagName) {
            if (isWhitespace(c)) {
              continue
            } else if (notMatch(nameStart, c)) {
              if (parser.script) {
                parser.script += '</' + c
                parser.state = S.SCRIPT
              } else {
                strictFail(parser, 'Invalid tagname in closing tag.')
              }
            } else {
              parser.tagName = c
            }
          } else if (c === '>') {
            closeTag(parser)
          } else if (isMatch(nameBody, c)) {
            parser.tagName += c
          } else if (parser.script) {
            parser.script += '</' + parser.tagName
            parser.tagName = ''
            parser.state = S.SCRIPT
          } else {
            if (!isWhitespace(c)) {
              strictFail(parser, 'Invalid tagname in closing tag')
            }
            parser.state = S.CLOSE_TAG_SAW_WHITE
          }
          continue

        case S.CLOSE_TAG_SAW_WHITE:
          if (isWhitespace(c)) {
            continue
          }
          if (c === '>') {
            closeTag(parser)
          } else {
            strictFail(parser, 'Invalid characters in closing tag')
          }
          continue

        case S.TEXT_ENTITY:
        case S.ATTRIB_VALUE_ENTITY_Q:
        case S.ATTRIB_VALUE_ENTITY_U:
          var returnState
          var buffer
          switch (parser.state) {
            case S.TEXT_ENTITY:
              returnState = S.TEXT
              buffer = 'textNode'
              break

            case S.ATTRIB_VALUE_ENTITY_Q:
              returnState = S.ATTRIB_VALUE_QUOTED
              buffer = 'attribValue'
              break

            case S.ATTRIB_VALUE_ENTITY_U:
              returnState = S.ATTRIB_VALUE_UNQUOTED
              buffer = 'attribValue'
              break
          }

          if (c === ';') {
            parser[buffer] += parseEntity(parser)
            parser.entity = ''
            parser.state = returnState
          } else if (isMatch(parser.entity.length ? entityBody : entityStart, c)) {
            parser.entity += c
          } else {
            strictFail(parser, 'Invalid character in entity name')
            parser[buffer] += '&' + parser.entity + c
            parser.entity = ''
            parser.state = returnState
          }

          continue

        default:
          throw new Error(parser, 'Unknown state: ' + parser.state)
      }
    } // while

    if (parser.position >= parser.bufferCheckPosition) {
      checkBufferLength(parser)
    }
    return parser
  }

  /*! http://mths.be/fromcodepoint v0.1.0 by @mathias */
  /* istanbul ignore next */
  if (!String.fromCodePoint) {
    (function () {
      var stringFromCharCode = String.fromCharCode
      var floor = Math.floor
      var fromCodePoint = function () {
        var MAX_SIZE = 0x4000
        var codeUnits = []
        var highSurrogate
        var lowSurrogate
        var index = -1
        var length = arguments.length
        if (!length) {
          return ''
        }
        var result = ''
        while (++index < length) {
          var codePoint = Number(arguments[index])
          if (
            !isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
            codePoint < 0 || // not a valid Unicode code point
            codePoint > 0x10FFFF || // not a valid Unicode code point
            floor(codePoint) !== codePoint // not an integer
          ) {
            throw RangeError('Invalid code point: ' + codePoint)
          }
          if (codePoint <= 0xFFFF) { // BMP code point
            codeUnits.push(codePoint)
          } else { // Astral code point; split in surrogate halves
            // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
            codePoint -= 0x10000
            highSurrogate = (codePoint >> 10) + 0xD800
            lowSurrogate = (codePoint % 0x400) + 0xDC00
            codeUnits.push(highSurrogate, lowSurrogate)
          }
          if (index + 1 === length || codeUnits.length > MAX_SIZE) {
            result += stringFromCharCode.apply(null, codeUnits)
            codeUnits.length = 0
          }
        }
        return result
      }
      /* istanbul ignore next */
      if (Object.defineProperty) {
        Object.defineProperty(String, 'fromCodePoint', {
          value: fromCodePoint,
          configurable: true,
          writable: true
        })
      } else {
        String.fromCodePoint = fromCodePoint
      }
    }())
  }
})( false ? 0 : exports)


/***/ }),

/***/ 65714:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__(72870);
var callBound = __webpack_require__(63099);
var inspect = __webpack_require__(34538);

var $TypeError = GetIntrinsic('%TypeError%');
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			curr.next = list.next;
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = { // eslint-disable-line no-param-reassign
			key: key,
			next: objects.next,
			value: value
		};
	}
};
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

module.exports = function getSideChannel() {
	var $wm;
	var $m;
	var $o;
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					/*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};


/***/ }),

/***/ 24131:
/***/ ((module, exports, __webpack_require__) => {

var __WEBPACK_AMD_DEFINE_RESULT__;/* global window, exports, define */

!function() {
    'use strict'

    var re = {
        not_string: /[^s]/,
        not_bool: /[^t]/,
        not_type: /[^T]/,
        not_primitive: /[^v]/,
        number: /[diefg]/,
        numeric_arg: /[bcdiefguxX]/,
        json: /[j]/,
        not_json: /[^j]/,
        text: /^[^\x25]+/,
        modulo: /^\x25{2}/,
        placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
        key: /^([a-z_][a-z_\d]*)/i,
        key_access: /^\.([a-z_][a-z_\d]*)/i,
        index_access: /^\[(\d+)\]/,
        sign: /^[+-]/
    }

    function sprintf(key) {
        // `arguments` is not an array, but should be fine for this call
        return sprintf_format(sprintf_parse(key), arguments)
    }

    function vsprintf(fmt, argv) {
        return sprintf.apply(null, [fmt].concat(argv || []))
    }

    function sprintf_format(parse_tree, argv) {
        var cursor = 1, tree_length = parse_tree.length, arg, output = '', i, k, ph, pad, pad_character, pad_length, is_positive, sign
        for (i = 0; i < tree_length; i++) {
            if (typeof parse_tree[i] === 'string') {
                output += parse_tree[i]
            }
            else if (typeof parse_tree[i] === 'object') {
                ph = parse_tree[i] // convenience purposes only
                if (ph.keys) { // keyword argument
                    arg = argv[cursor]
                    for (k = 0; k < ph.keys.length; k++) {
                        if (arg == undefined) {
                            throw new Error(sprintf('[sprintf] Cannot access property "%s" of undefined value "%s"', ph.keys[k], ph.keys[k-1]))
                        }
                        arg = arg[ph.keys[k]]
                    }
                }
                else if (ph.param_no) { // positional argument (explicit)
                    arg = argv[ph.param_no]
                }
                else { // positional argument (implicit)
                    arg = argv[cursor++]
                }

                if (re.not_type.test(ph.type) && re.not_primitive.test(ph.type) && arg instanceof Function) {
                    arg = arg()
                }

                if (re.numeric_arg.test(ph.type) && (typeof arg !== 'number' && isNaN(arg))) {
                    throw new TypeError(sprintf('[sprintf] expecting number but found %T', arg))
                }

                if (re.number.test(ph.type)) {
                    is_positive = arg >= 0
                }

                switch (ph.type) {
                    case 'b':
                        arg = parseInt(arg, 10).toString(2)
                        break
                    case 'c':
                        arg = String.fromCharCode(parseInt(arg, 10))
                        break
                    case 'd':
                    case 'i':
                        arg = parseInt(arg, 10)
                        break
                    case 'j':
                        arg = JSON.stringify(arg, null, ph.width ? parseInt(ph.width) : 0)
                        break
                    case 'e':
                        arg = ph.precision ? parseFloat(arg).toExponential(ph.precision) : parseFloat(arg).toExponential()
                        break
                    case 'f':
                        arg = ph.precision ? parseFloat(arg).toFixed(ph.precision) : parseFloat(arg)
                        break
                    case 'g':
                        arg = ph.precision ? String(Number(arg.toPrecision(ph.precision))) : parseFloat(arg)
                        break
                    case 'o':
                        arg = (parseInt(arg, 10) >>> 0).toString(8)
                        break
                    case 's':
                        arg = String(arg)
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 't':
                        arg = String(!!arg)
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 'T':
                        arg = Object.prototype.toString.call(arg).slice(8, -1).toLowerCase()
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 'u':
                        arg = parseInt(arg, 10) >>> 0
                        break
                    case 'v':
                        arg = arg.valueOf()
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 'x':
                        arg = (parseInt(arg, 10) >>> 0).toString(16)
                        break
                    case 'X':
                        arg = (parseInt(arg, 10) >>> 0).toString(16).toUpperCase()
                        break
                }
                if (re.json.test(ph.type)) {
                    output += arg
                }
                else {
                    if (re.number.test(ph.type) && (!is_positive || ph.sign)) {
                        sign = is_positive ? '+' : '-'
                        arg = arg.toString().replace(re.sign, '')
                    }
                    else {
                        sign = ''
                    }
                    pad_character = ph.pad_char ? ph.pad_char === '0' ? '0' : ph.pad_char.charAt(1) : ' '
                    pad_length = ph.width - (sign + arg).length
                    pad = ph.width ? (pad_length > 0 ? pad_character.repeat(pad_length) : '') : ''
                    output += ph.align ? sign + arg + pad : (pad_character === '0' ? sign + pad + arg : pad + sign + arg)
                }
            }
        }
        return output
    }

    var sprintf_cache = Object.create(null)

    function sprintf_parse(fmt) {
        if (sprintf_cache[fmt]) {
            return sprintf_cache[fmt]
        }

        var _fmt = fmt, match, parse_tree = [], arg_names = 0
        while (_fmt) {
            if ((match = re.text.exec(_fmt)) !== null) {
                parse_tree.push(match[0])
            }
            else if ((match = re.modulo.exec(_fmt)) !== null) {
                parse_tree.push('%')
            }
            else if ((match = re.placeholder.exec(_fmt)) !== null) {
                if (match[2]) {
                    arg_names |= 1
                    var field_list = [], replacement_field = match[2], field_match = []
                    if ((field_match = re.key.exec(replacement_field)) !== null) {
                        field_list.push(field_match[1])
                        while ((replacement_field = replacement_field.substring(field_match[0].length)) !== '') {
                            if ((field_match = re.key_access.exec(replacement_field)) !== null) {
                                field_list.push(field_match[1])
                            }
                            else if ((field_match = re.index_access.exec(replacement_field)) !== null) {
                                field_list.push(field_match[1])
                            }
                            else {
                                throw new SyntaxError('[sprintf] failed to parse named argument key')
                            }
                        }
                    }
                    else {
                        throw new SyntaxError('[sprintf] failed to parse named argument key')
                    }
                    match[2] = field_list
                }
                else {
                    arg_names |= 2
                }
                if (arg_names === 3) {
                    throw new Error('[sprintf] mixing positional and named placeholders is not (yet) supported')
                }

                parse_tree.push(
                    {
                        placeholder: match[0],
                        param_no:    match[1],
                        keys:        match[2],
                        sign:        match[3],
                        pad_char:    match[4],
                        align:       match[5],
                        width:       match[6],
                        precision:   match[7],
                        type:        match[8]
                    }
                )
            }
            else {
                throw new SyntaxError('[sprintf] unexpected placeholder')
            }
            _fmt = _fmt.substring(match[0].length)
        }
        return sprintf_cache[fmt] = parse_tree
    }

    /**
     * export to either browser or node.js
     */
    /* eslint-disable quote-props */
    if (true) {
        exports.sprintf = sprintf
        exports.vsprintf = vsprintf
    }
    if (typeof window !== 'undefined') {
        window['sprintf'] = sprintf
        window['vsprintf'] = vsprintf

        if (true) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
                return {
                    'sprintf': sprintf,
                    'vsprintf': vsprintf
                }
            }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
        }
    }
    /* eslint-enable quote-props */
}(); // eslint-disable-line


/***/ }),

/***/ 76835:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = (__webpack_require__(72100).EventEmitter);
var inherits = __webpack_require__(85459);

inherits(Stream, EE);
Stream.Readable = __webpack_require__(25294);
Stream.Writable = __webpack_require__(86481);
Stream.Duplex = __webpack_require__(93337);
Stream.Transform = __webpack_require__(41683);
Stream.PassThrough = __webpack_require__(68797);
Stream.finished = __webpack_require__(43675)
Stream.pipeline = __webpack_require__(95597)

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),

/***/ 68861:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = (__webpack_require__(10380).Buffer);
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.s = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),

/***/ 72699:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = (__webpack_require__(61874).Buffer);
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.s = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),

/***/ 14364:
/***/ ((module) => {

function Agent() {
  this._defaults = [];
}

["use", "on", "once", "set", "query", "type", "accept", "auth", "withCredentials", "sortQuery", "retry", "ok", "redirects",
 "timeout", "buffer", "serialize", "parse", "ca", "key", "pfx", "cert"].forEach(function(fn) {
  /** Default setting for all requests from this agent */
  Agent.prototype[fn] = function(/*varargs*/) {
    this._defaults.push({fn:fn, arguments:arguments});
    return this;
  }
});

Agent.prototype._setDefaults = function(req) {
    this._defaults.forEach(function(def) {
      req[def.fn].apply(req, def.arguments);
    });
};

module.exports = Agent;


/***/ }),

/***/ 84628:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Root reference for iframes.
 */

var root;
if (typeof window !== 'undefined') { // Browser window
  root = window;
} else if (typeof self !== 'undefined') { // Web Worker
  root = self;
} else { // Other environments
  console.warn("Using browser-only version of superagent in non-browser environment");
  root = this;
}

var Emitter = __webpack_require__(14907);
var RequestBase = __webpack_require__(36151);
var isObject = __webpack_require__(33863);
var ResponseBase = __webpack_require__(19200);
var Agent = __webpack_require__(14364);

/**
 * Noop.
 */

function noop(){};

/**
 * Expose `request`.
 */

var request = exports = module.exports = function(method, url) {
  // callback
  if ('function' == typeof url) {
    return new exports.Request('GET', method).end(url);
  }

  // url first
  if (1 == arguments.length) {
    return new exports.Request('GET', method);
  }

  return new exports.Request(method, url);
}

exports.Request = Request;

/**
 * Determine XHR.
 */

request.getXHR = function () {
  if (root.XMLHttpRequest
      && (!root.location || 'file:' != root.location.protocol
          || !root.ActiveXObject)) {
    return new XMLHttpRequest;
  } else {
    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
  }
  throw Error("Browser-only version of superagent could not find XHR");
};

/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */

var trim = ''.trim
  ? function(s) { return s.trim(); }
  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };

/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */

function serialize(obj) {
  if (!isObject(obj)) return obj;
  var pairs = [];
  for (var key in obj) {
    pushEncodedKeyValuePair(pairs, key, obj[key]);
  }
  return pairs.join('&');
}

/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */

function pushEncodedKeyValuePair(pairs, key, val) {
  if (val != null) {
    if (Array.isArray(val)) {
      val.forEach(function(v) {
        pushEncodedKeyValuePair(pairs, key, v);
      });
    } else if (isObject(val)) {
      for(var subkey in val) {
        pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
      }
    } else {
      pairs.push(encodeURIComponent(key)
        + '=' + encodeURIComponent(val));
    }
  } else if (val === null) {
    pairs.push(encodeURIComponent(key));
  }
}

/**
 * Expose serialization method.
 */

request.serializeObject = serialize;

/**
  * Parse the given x-www-form-urlencoded `str`.
  *
  * @param {String} str
  * @return {Object}
  * @api private
  */

function parseString(str) {
  var obj = {};
  var pairs = str.split('&');
  var pair;
  var pos;

  for (var i = 0, len = pairs.length; i < len; ++i) {
    pair = pairs[i];
    pos = pair.indexOf('=');
    if (pos == -1) {
      obj[decodeURIComponent(pair)] = '';
    } else {
      obj[decodeURIComponent(pair.slice(0, pos))] =
        decodeURIComponent(pair.slice(pos + 1));
    }
  }

  return obj;
}

/**
 * Expose parser.
 */

request.parseString = parseString;

/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */

request.types = {
  html: 'text/html',
  json: 'application/json',
  xml: 'text/xml',
  urlencoded: 'application/x-www-form-urlencoded',
  'form': 'application/x-www-form-urlencoded',
  'form-data': 'application/x-www-form-urlencoded'
};

/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */

request.serialize = {
  'application/x-www-form-urlencoded': serialize,
  'application/json': JSON.stringify
};

/**
  * Default parsers.
  *
  *     superagent.parse['application/xml'] = function(str){
  *       return { object parsed from str };
  *     };
  *
  */

request.parse = {
  'application/x-www-form-urlencoded': parseString,
  'application/json': JSON.parse
};

/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function parseHeader(str) {
  var lines = str.split(/\r?\n/);
  var fields = {};
  var index;
  var line;
  var field;
  var val;

  for (var i = 0, len = lines.length; i < len; ++i) {
    line = lines[i];
    index = line.indexOf(':');
    if (index === -1) { // could be empty line, just skip it
      continue;
    }
    field = line.slice(0, index).toLowerCase();
    val = trim(line.slice(index + 1));
    fields[field] = val;
  }

  return fields;
}

/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */

function isJSON(mime) {
  // should match /json or +json
  // but not /json-seq
  return /[\/+]json($|[^-\w])/.test(mime);
}

/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */

function Response(req) {
  this.req = req;
  this.xhr = this.req.xhr;
  // responseText is accessible only if responseType is '' or 'text' and on older browsers
  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
     ? this.xhr.responseText
     : null;
  this.statusText = this.req.xhr.statusText;
  var status = this.xhr.status;
  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
  if (status === 1223) {
    status = 204;
  }
  this._setStatusProperties(status);
  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
  // getResponseHeader still works. so we get content-type even if getting
  // other headers fails.
  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
  this._setHeaderProperties(this.header);

  if (null === this.text && req._responseType) {
    this.body = this.xhr.response;
  } else {
    this.body = this.req.method != 'HEAD'
      ? this._parseBody(this.text ? this.text : this.xhr.response)
      : null;
  }
}

ResponseBase(Response.prototype);

/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */

Response.prototype._parseBody = function(str) {
  var parse = request.parse[this.type];
  if (this.req._parser) {
    return this.req._parser(this, str);
  }
  if (!parse && isJSON(this.type)) {
    parse = request.parse['application/json'];
  }
  return parse && str && (str.length || str instanceof Object)
    ? parse(str)
    : null;
};

/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */

Response.prototype.toError = function(){
  var req = this.req;
  var method = req.method;
  var url = req.url;

  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
  var err = new Error(msg);
  err.status = this.status;
  err.method = method;
  err.url = url;

  return err;
};

/**
 * Expose `Response`.
 */

request.Response = Response;

/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */

function Request(method, url) {
  var self = this;
  this._query = this._query || [];
  this.method = method;
  this.url = url;
  this.header = {}; // preserves header name case
  this._header = {}; // coerces header names to lowercase
  this.on('end', function(){
    var err = null;
    var res = null;

    try {
      res = new Response(self);
    } catch(e) {
      err = new Error('Parser is unable to parse the response');
      err.parse = true;
      err.original = e;
      // issue #675: return the raw response if the response parsing fails
      if (self.xhr) {
        // ie9 doesn't have 'response' property
        err.rawResponse = typeof self.xhr.responseType == 'undefined' ? self.xhr.responseText : self.xhr.response;
        // issue #876: return the http status code if the response parsing fails
        err.status = self.xhr.status ? self.xhr.status : null;
        err.statusCode = err.status; // backwards-compat only
      } else {
        err.rawResponse = null;
        err.status = null;
      }

      return self.callback(err);
    }

    self.emit('response', res);

    var new_err;
    try {
      if (!self._isResponseOK(res)) {
        new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
      }
    } catch(custom_err) {
      new_err = custom_err; // ok() callback can throw
    }

    // #1000 don't catch errors from the callback to avoid double calling it
    if (new_err) {
      new_err.original = err;
      new_err.response = res;
      new_err.status = res.status;
      self.callback(new_err, res);
    } else {
      self.callback(null, res);
    }
  });
}

/**
 * Mixin `Emitter` and `RequestBase`.
 */

Emitter(Request.prototype);
RequestBase(Request.prototype);

/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.type = function(type){
  this.set('Content-Type', request.types[type] || type);
  return this;
};

/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.accept = function(type){
  this.set('Accept', request.types[type] || type);
  return this;
};

/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} [pass] optional in case of using 'bearer' as type
 * @param {Object} options with 'type' property 'auto', 'basic' or 'bearer' (default 'basic')
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.auth = function(user, pass, options){
  if (1 === arguments.length) pass = '';
  if (typeof pass === 'object' && pass !== null) { // pass is optional and can be replaced with options
    options = pass;
    pass = '';
  }
  if (!options) {
    options = {
      type: 'function' === typeof btoa ? 'basic' : 'auto',
    };
  }

  var encoder = function(string) {
    if ('function' === typeof btoa) {
      return btoa(string);
    }
    throw new Error('Cannot use basic auth, btoa is not a function');
  };

  return this._auth(user, pass, options, encoder);
};

/**
 * Add query-string `val`.
 *
 * Examples:
 *
 *   request.get('/shoes')
 *     .query('size=10')
 *     .query({ color: 'blue' })
 *
 * @param {Object|String} val
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.query = function(val){
  if ('string' != typeof val) val = serialize(val);
  if (val) this._query.push(val);
  return this;
};

/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `options` (or filename).
 *
 * ``` js
 * request.post('/upload')
 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String|Object} options
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.attach = function(field, file, options){
  if (file) {
    if (this._data) {
      throw Error("superagent can't mix .send() and .attach()");
    }

    this._getFormData().append(field, file, options || file.name);
  }
  return this;
};

Request.prototype._getFormData = function(){
  if (!this._formData) {
    this._formData = new root.FormData();
  }
  return this._formData;
};

/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */

Request.prototype.callback = function(err, res){
  if (this._shouldRetry(err, res)) {
    return this._retry();
  }

  var fn = this._callback;
  this.clearTimeout();

  if (err) {
    if (this._maxRetries) err.retries = this._retries - 1;
    this.emit('error', err);
  }

  fn(err, res);
};

/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */

Request.prototype.crossDomainError = function(){
  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
  err.crossDomain = true;

  err.status = this.status;
  err.method = this.method;
  err.url = this.url;

  this.callback(err);
};

// This only warns, because the request is still likely to work
Request.prototype.buffer = Request.prototype.ca = Request.prototype.agent = function(){
  console.warn("This is not supported in browser version of superagent");
  return this;
};

// This throws, because it can't send/receive data as expected
Request.prototype.pipe = Request.prototype.write = function(){
  throw Error("Streaming is not supported in browser version of superagent");
};

/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */
Request.prototype._isHost = function _isHost(obj) {
  // Native objects stringify to [object File], [object Blob], [object FormData], etc.
  return obj && 'object' === typeof obj && !Array.isArray(obj) && Object.prototype.toString.call(obj) !== '[object Object]';
}

/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.end = function(fn){
  if (this._endCalled) {
    console.warn("Warning: .end() was called twice. This is not supported in superagent");
  }
  this._endCalled = true;

  // store callback
  this._callback = fn || noop;

  // querystring
  this._finalizeQueryString();

  return this._end();
};

Request.prototype._end = function() {
  var self = this;
  var xhr = (this.xhr = request.getXHR());
  var data = this._formData || this._data;

  this._setTimeouts();

  // state change
  xhr.onreadystatechange = function(){
    var readyState = xhr.readyState;
    if (readyState >= 2 && self._responseTimeoutTimer) {
      clearTimeout(self._responseTimeoutTimer);
    }
    if (4 != readyState) {
      return;
    }

    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
    // result in the error "Could not complete the operation due to error c00c023f"
    var status;
    try { status = xhr.status } catch(e) { status = 0; }

    if (!status) {
      if (self.timedout || self._aborted) return;
      return self.crossDomainError();
    }
    self.emit('end');
  };

  // progress
  var handleProgress = function(direction, e) {
    if (e.total > 0) {
      e.percent = e.loaded / e.total * 100;
    }
    e.direction = direction;
    self.emit('progress', e);
  };
  if (this.hasListeners('progress')) {
    try {
      xhr.onprogress = handleProgress.bind(null, 'download');
      if (xhr.upload) {
        xhr.upload.onprogress = handleProgress.bind(null, 'upload');
      }
    } catch(e) {
      // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
      // Reported here:
      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
    }
  }

  // initiate request
  try {
    if (this.username && this.password) {
      xhr.open(this.method, this.url, true, this.username, this.password);
    } else {
      xhr.open(this.method, this.url, true);
    }
  } catch (err) {
    // see #1149
    return this.callback(err);
  }

  // CORS
  if (this._withCredentials) xhr.withCredentials = true;

  // body
  if (!this._formData && 'GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
    // serialize stuff
    var contentType = this._header['content-type'];
    var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
    if (!serialize && isJSON(contentType)) {
      serialize = request.serialize['application/json'];
    }
    if (serialize) data = serialize(data);
  }

  // set header fields
  for (var field in this.header) {
    if (null == this.header[field]) continue;

    if (this.header.hasOwnProperty(field))
      xhr.setRequestHeader(field, this.header[field]);
  }

  if (this._responseType) {
    xhr.responseType = this._responseType;
  }

  // send stuff
  this.emit('request', this);

  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
  // We need null here if data is undefined
  xhr.send(typeof data !== 'undefined' ? data : null);
  return this;
};

request.agent = function() {
  return new Agent();
};

["GET", "POST", "OPTIONS", "PATCH", "PUT", "DELETE"].forEach(function(method) {
  Agent.prototype[method.toLowerCase()] = function(url, fn) {
    var req = new request.Request(method, url);
    this._setDefaults(req);
    if (fn) {
      req.end(fn);
    }
    return req;
  };
});

Agent.prototype.del = Agent.prototype['delete'];

/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.get = function(url, data, fn) {
  var req = request('GET', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.head = function(url, data, fn) {
  var req = request('HEAD', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * OPTIONS query to `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.options = function(url, data, fn) {
  var req = request('OPTIONS', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * DELETE `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

function del(url, data, fn) {
  var req = request('DELETE', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
}

request['del'] = del;
request['delete'] = del;

/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.patch = function(url, data, fn) {
  var req = request('PATCH', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.post = function(url, data, fn) {
  var req = request('POST', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.put = function(url, data, fn) {
  var req = request('PUT', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};


/***/ }),

/***/ 33863:
/***/ ((module) => {

"use strict";


/**
 * Check if `obj` is an object.
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */

function isObject(obj) {
  return null !== obj && 'object' === typeof obj;
}

module.exports = isObject;


/***/ }),

/***/ 36151:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/**
 * Module of mixed-in functions shared between node and client code
 */
var isObject = __webpack_require__(33863);

/**
 * Expose `RequestBase`.
 */

module.exports = RequestBase;

/**
 * Initialize a new `RequestBase`.
 *
 * @api public
 */

function RequestBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in RequestBase.prototype) {
    obj[key] = RequestBase.prototype[key];
  }
  return obj;
}

/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.clearTimeout = function _clearTimeout(){
  clearTimeout(this._timer);
  clearTimeout(this._responseTimeoutTimer);
  delete this._timer;
  delete this._responseTimeoutTimer;
  return this;
};

/**
 * Override default response body parser
 *
 * This function will be called to convert incoming data into request.body
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.parse = function parse(fn){
  this._parser = fn;
  return this;
};

/**
 * Set format of binary response body.
 * In browser valid formats are 'blob' and 'arraybuffer',
 * which return Blob and ArrayBuffer, respectively.
 *
 * In Node all values result in Buffer.
 *
 * Examples:
 *
 *      req.get('/')
 *        .responseType('blob')
 *        .end(callback);
 *
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.responseType = function(val){
  this._responseType = val;
  return this;
};

/**
 * Override default request body serializer
 *
 * This function will be called to convert data set via .send or .attach into payload to send
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.serialize = function serialize(fn){
  this._serializer = fn;
  return this;
};

/**
 * Set timeouts.
 *
 * - response timeout is time between sending request and receiving the first byte of the response. Includes DNS and connection time.
 * - deadline is the time from start of the request to receiving response body in full. If the deadline is too short large files may not load at all on slow connections.
 *
 * Value of 0 or false means no timeout.
 *
 * @param {Number|Object} ms or {response, deadline}
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.timeout = function timeout(options){
  if (!options || 'object' !== typeof options) {
    this._timeout = options;
    this._responseTimeout = 0;
    return this;
  }

  for(var option in options) {
    switch(option) {
      case 'deadline':
        this._timeout = options.deadline;
        break;
      case 'response':
        this._responseTimeout = options.response;
        break;
      default:
        console.warn("Unknown timeout option", option);
    }
  }
  return this;
};

/**
 * Set number of retry attempts on error.
 *
 * Failed requests will be retried 'count' times if timeout or err.code >= 500.
 *
 * @param {Number} count
 * @param {Function} [fn]
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.retry = function retry(count, fn){
  // Default to 1 if no count passed or true
  if (arguments.length === 0 || count === true) count = 1;
  if (count <= 0) count = 0;
  this._maxRetries = count;
  this._retries = 0;
  this._retryCallback = fn;
  return this;
};

var ERROR_CODES = [
  'ECONNRESET',
  'ETIMEDOUT',
  'EADDRINFO',
  'ESOCKETTIMEDOUT'
];

/**
 * Determine if a request should be retried.
 * (Borrowed from segmentio/superagent-retry)
 *
 * @param {Error} err
 * @param {Response} [res]
 * @returns {Boolean}
 */
RequestBase.prototype._shouldRetry = function(err, res) {
  if (!this._maxRetries || this._retries++ >= this._maxRetries) {
    return false;
  }
  if (this._retryCallback) {
    try {
      var override = this._retryCallback(err, res);
      if (override === true) return true;
      if (override === false) return false;
      // undefined falls back to defaults
    } catch(e) {
      console.error(e);
    }
  }
  if (res && res.status && res.status >= 500 && res.status != 501) return true;
  if (err) {
    if (err.code && ~ERROR_CODES.indexOf(err.code)) return true;
    // Superagent timeout
    if (err.timeout && err.code == 'ECONNABORTED') return true;
    if (err.crossDomain) return true;
  }
  return false;
};

/**
 * Retry request
 *
 * @return {Request} for chaining
 * @api private
 */

RequestBase.prototype._retry = function() {

  this.clearTimeout();

  // node
  if (this.req) {
    this.req = null;
    this.req = this.request();
  }

  this._aborted = false;
  this.timedout = false;

  return this._end();
};

/**
 * Promise support
 *
 * @param {Function} resolve
 * @param {Function} [reject]
 * @return {Request}
 */

RequestBase.prototype.then = function then(resolve, reject) {
  if (!this._fullfilledPromise) {
    var self = this;
    if (this._endCalled) {
      console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises");
    }
    this._fullfilledPromise = new Promise(function(innerResolve, innerReject) {
      self.end(function(err, res) {
        if (err) innerReject(err);
        else innerResolve(res);
      });
    });
  }
  return this._fullfilledPromise.then(resolve, reject);
};

RequestBase.prototype['catch'] = function(cb) {
  return this.then(undefined, cb);
};

/**
 * Allow for extension
 */

RequestBase.prototype.use = function use(fn) {
  fn(this);
  return this;
};

RequestBase.prototype.ok = function(cb) {
  if ('function' !== typeof cb) throw Error("Callback required");
  this._okCallback = cb;
  return this;
};

RequestBase.prototype._isResponseOK = function(res) {
  if (!res) {
    return false;
  }

  if (this._okCallback) {
    return this._okCallback(res);
  }

  return res.status >= 200 && res.status < 300;
};

/**
 * Get request header `field`.
 * Case-insensitive.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

RequestBase.prototype.get = function(field){
  return this._header[field.toLowerCase()];
};

/**
 * Get case-insensitive header `field` value.
 * This is a deprecated internal API. Use `.get(field)` instead.
 *
 * (getHeader is no longer used internally by the superagent code base)
 *
 * @param {String} field
 * @return {String}
 * @api private
 * @deprecated
 */

RequestBase.prototype.getHeader = RequestBase.prototype.get;

/**
 * Set header `field` to `val`, or multiple fields with one object.
 * Case-insensitive.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.set = function(field, val){
  if (isObject(field)) {
    for (var key in field) {
      this.set(key, field[key]);
    }
    return this;
  }
  this._header[field.toLowerCase()] = val;
  this.header[field] = val;
  return this;
};

/**
 * Remove header `field`.
 * Case-insensitive.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field
 */
RequestBase.prototype.unset = function(field){
  delete this._header[field.toLowerCase()];
  delete this.header[field];
  return this;
};

/**
 * Write the field `name` and `val`, or multiple fields with one object
 * for "multipart/form-data" request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 *
 * request.post('/upload')
 *   .field({ foo: 'bar', baz: 'qux' })
 *   .end(callback);
 * ```
 *
 * @param {String|Object} name
 * @param {String|Blob|File|Buffer|fs.ReadStream} val
 * @return {Request} for chaining
 * @api public
 */
RequestBase.prototype.field = function(name, val) {
  // name should be either a string or an object.
  if (null === name || undefined === name) {
    throw new Error('.field(name, val) name can not be empty');
  }

  if (this._data) {
    console.error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObject(name)) {
    for (var key in name) {
      this.field(key, name[key]);
    }
    return this;
  }

  if (Array.isArray(val)) {
    for (var i in val) {
      this.field(name, val[i]);
    }
    return this;
  }

  // val should be defined now
  if (null === val || undefined === val) {
    throw new Error('.field(name, val) val can not be empty');
  }
  if ('boolean' === typeof val) {
    val = '' + val;
  }
  this._getFormData().append(name, val);
  return this;
};

/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request}
 * @api public
 */
RequestBase.prototype.abort = function(){
  if (this._aborted) {
    return this;
  }
  this._aborted = true;
  this.xhr && this.xhr.abort(); // browser
  this.req && this.req.abort(); // node
  this.clearTimeout();
  this.emit('abort');
  return this;
};

RequestBase.prototype._auth = function(user, pass, options, base64Encoder) {
  switch (options.type) {
    case 'basic':
      this.set('Authorization', 'Basic ' + base64Encoder(user + ':' + pass));
      break;

    case 'auto':
      this.username = user;
      this.password = pass;
      break;

    case 'bearer': // usage would be .auth(accessToken, { type: 'bearer' })
      this.set('Authorization', 'Bearer ' + user);
      break;
  }
  return this;
};

/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 *
 * @api public
 */

RequestBase.prototype.withCredentials = function(on) {
  // This is browser-only functionality. Node side is no-op.
  if (on == undefined) on = true;
  this._withCredentials = on;
  return this;
};

/**
 * Set the max redirects to `n`. Does noting in browser XHR implementation.
 *
 * @param {Number} n
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.redirects = function(n){
  this._maxRedirects = n;
  return this;
};

/**
 * Maximum size of buffered response body, in bytes. Counts uncompressed size.
 * Default 200MB.
 *
 * @param {Number} n
 * @return {Request} for chaining
 */
RequestBase.prototype.maxResponseSize = function(n){
  if ('number' !== typeof n) {
    throw TypeError("Invalid argument");
  }
  this._maxResponseSize = n;
  return this;
};

/**
 * Convert to a plain javascript object (not JSON string) of scalar properties.
 * Note as this method is designed to return a useful non-this value,
 * it cannot be chained.
 *
 * @return {Object} describing method, url, and data of this request
 * @api public
 */

RequestBase.prototype.toJSON = function() {
  return {
    method: this.method,
    url: this.url,
    data: this._data,
    headers: this._header,
  };
};

/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
 *      request.post('/user')
 *        .send('name=tobi')
 *        .send('species=ferret')
 *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.send = function(data){
  var isObj = isObject(data);
  var type = this._header['content-type'];

  if (this._formData) {
    console.error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObj && !this._data) {
    if (Array.isArray(data)) {
      this._data = [];
    } else if (!this._isHost(data)) {
      this._data = {};
    }
  } else if (data && this._data && this._isHost(this._data)) {
    throw Error("Can't merge these send calls");
  }

  // merge
  if (isObj && isObject(this._data)) {
    for (var key in data) {
      this._data[key] = data[key];
    }
  } else if ('string' == typeof data) {
    // default to x-www-form-urlencoded
    if (!type) this.type('form');
    type = this._header['content-type'];
    if ('application/x-www-form-urlencoded' == type) {
      this._data = this._data
        ? this._data + '&' + data
        : data;
    } else {
      this._data = (this._data || '') + data;
    }
  } else {
    this._data = data;
  }

  if (!isObj || this._isHost(data)) {
    return this;
  }

  // default to json
  if (!type) this.type('json');
  return this;
};

/**
 * Sort `querystring` by the sort function
 *
 *
 * Examples:
 *
 *       // default order
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery()
 *         .end(callback)
 *
 *       // customized sort function
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery(function(a, b){
 *           return a.length - b.length;
 *         })
 *         .end(callback)
 *
 *
 * @param {Function} sort
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.sortQuery = function(sort) {
  // _sort default to true but otherwise can be a function or boolean
  this._sort = typeof sort === 'undefined' ? true : sort;
  return this;
};

/**
 * Compose querystring to append to req.url
 *
 * @api private
 */
RequestBase.prototype._finalizeQueryString = function(){
  var query = this._query.join('&');
  if (query) {
    this.url += (this.url.indexOf('?') >= 0 ? '&' : '?') + query;
  }
  this._query.length = 0; // Makes the call idempotent

  if (this._sort) {
    var index = this.url.indexOf('?');
    if (index >= 0) {
      var queryArr = this.url.substring(index + 1).split('&');
      if ('function' === typeof this._sort) {
        queryArr.sort(this._sort);
      } else {
        queryArr.sort();
      }
      this.url = this.url.substring(0, index) + '?' + queryArr.join('&');
    }
  }
};

// For backwards compat only
RequestBase.prototype._appendQueryString = function() {console.trace("Unsupported");}

/**
 * Invoke callback with timeout error.
 *
 * @api private
 */

RequestBase.prototype._timeoutError = function(reason, timeout, errno){
  if (this._aborted) {
    return;
  }
  var err = new Error(reason + timeout + 'ms exceeded');
  err.timeout = timeout;
  err.code = 'ECONNABORTED';
  err.errno = errno;
  this.timedout = true;
  this.abort();
  this.callback(err);
};

RequestBase.prototype._setTimeouts = function() {
  var self = this;

  // deadline
  if (this._timeout && !this._timer) {
    this._timer = setTimeout(function(){
      self._timeoutError('Timeout of ', self._timeout, 'ETIME');
    }, this._timeout);
  }
  // response timeout
  if (this._responseTimeout && !this._responseTimeoutTimer) {
    this._responseTimeoutTimer = setTimeout(function(){
      self._timeoutError('Response timeout of ', self._responseTimeout, 'ETIMEDOUT');
    }, this._responseTimeout);
  }
};


/***/ }),

/***/ 19200:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/**
 * Module dependencies.
 */

var utils = __webpack_require__(57953);

/**
 * Expose `ResponseBase`.
 */

module.exports = ResponseBase;

/**
 * Initialize a new `ResponseBase`.
 *
 * @api public
 */

function ResponseBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in ResponseBase.prototype) {
    obj[key] = ResponseBase.prototype[key];
  }
  return obj;
}

/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

ResponseBase.prototype.get = function(field) {
  return this.header[field.toLowerCase()];
};

/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */

ResponseBase.prototype._setHeaderProperties = function(header){
    // TODO: moar!
    // TODO: make this a util

    // content-type
    var ct = header['content-type'] || '';
    this.type = utils.type(ct);

    // params
    var params = utils.params(ct);
    for (var key in params) this[key] = params[key];

    this.links = {};

    // links
    try {
        if (header.link) {
            this.links = utils.parseLinks(header.link);
        }
    } catch (err) {
        // ignore
    }
};

/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */

ResponseBase.prototype._setStatusProperties = function(status){
    var type = status / 100 | 0;

    // status / class
    this.status = this.statusCode = status;
    this.statusType = type;

    // basics
    this.info = 1 == type;
    this.ok = 2 == type;
    this.redirect = 3 == type;
    this.clientError = 4 == type;
    this.serverError = 5 == type;
    this.error = (4 == type || 5 == type)
        ? this.toError()
        : false;

    // sugar
    this.created = 201 == status;
    this.accepted = 202 == status;
    this.noContent = 204 == status;
    this.badRequest = 400 == status;
    this.unauthorized = 401 == status;
    this.notAcceptable = 406 == status;
    this.forbidden = 403 == status;
    this.notFound = 404 == status;
    this.unprocessableEntity = 422 == status;
};


/***/ }),

/***/ 57953:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

exports.type = function(str){
  return str.split(/ *; */).shift();
};

/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.params = function(str){
  return str.split(/ *; */).reduce(function(obj, str){
    var parts = str.split(/ *= */);
    var key = parts.shift();
    var val = parts.shift();

    if (key && val) obj[key] = val;
    return obj;
  }, {});
};

/**
 * Parse Link header fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.parseLinks = function(str){
  return str.split(/ *, */).reduce(function(obj, str){
    var parts = str.split(/ *; */);
    var url = parts[0].slice(1, -1);
    var rel = parts[1].split(/ *= */)[1].slice(1, -1);
    obj[rel] = url;
    return obj;
  }, {});
};

/**
 * Strip content related fields from `header`.
 *
 * @param {Object} header
 * @return {Object} header
 * @api private
 */

exports.cleanHeader = function(header, changesOrigin){
  delete header['content-type'];
  delete header['content-length'];
  delete header['transfer-encoding'];
  delete header['host'];
  // secuirty
  if (changesOrigin) {
    delete header['authorization'];
    delete header['cookie'];
  }
  return header;
};


/***/ }),

/***/ 80509:
/***/ ((module) => {

"use strict";


function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function Agent() {
  this._defaults = [];
}

['use', 'on', 'once', 'set', 'query', 'type', 'accept', 'auth', 'withCredentials', 'sortQuery', 'retry', 'ok', 'redirects', 'timeout', 'buffer', 'serialize', 'parse', 'ca', 'key', 'pfx', 'cert', 'disableTLSCerts'].forEach(function (fn) {
  // Default setting for all requests from this agent
  Agent.prototype[fn] = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    this._defaults.push({
      fn: fn,
      args: args
    });

    return this;
  };
});

Agent.prototype._setDefaults = function (req) {
  this._defaults.forEach(function (def) {
    req[def.fn].apply(req, _toConsumableArray(def.args));
  });
};

module.exports = Agent;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 48104:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Root reference for iframes.
 */
var root;

if (typeof window !== 'undefined') {
  // Browser window
  root = window;
} else if (typeof self === 'undefined') {
  // Other environments
  console.warn('Using browser-only version of superagent in non-browser environment');
  root = void 0;
} else {
  // Web Worker
  root = self;
}

var Emitter = __webpack_require__(14907);

var safeStringify = __webpack_require__(61406);

var qs = __webpack_require__(14015);

var RequestBase = __webpack_require__(11183);

var isObject = __webpack_require__(92338);

var ResponseBase = __webpack_require__(44259);

var Agent = __webpack_require__(80509);
/**
 * Noop.
 */


function noop() {}
/**
 * Expose `request`.
 */


module.exports = function (method, url) {
  // callback
  if (typeof url === 'function') {
    return new exports.Request('GET', method).end(url);
  } // url first


  if (arguments.length === 1) {
    return new exports.Request('GET', method);
  }

  return new exports.Request(method, url);
};

exports = module.exports;
var request = exports;
exports.Request = Request;
/**
 * Determine XHR.
 */

request.getXHR = function () {
  if (root.XMLHttpRequest && (!root.location || root.location.protocol !== 'file:' || !root.ActiveXObject)) {
    return new XMLHttpRequest();
  }

  try {
    return new ActiveXObject('Microsoft.XMLHTTP');
  } catch (_unused) {}

  try {
    return new ActiveXObject('Msxml2.XMLHTTP.6.0');
  } catch (_unused2) {}

  try {
    return new ActiveXObject('Msxml2.XMLHTTP.3.0');
  } catch (_unused3) {}

  try {
    return new ActiveXObject('Msxml2.XMLHTTP');
  } catch (_unused4) {}

  throw new Error('Browser-only version of superagent could not find XHR');
};
/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */


var trim = ''.trim ? function (s) {
  return s.trim();
} : function (s) {
  return s.replace(/(^\s*|\s*$)/g, '');
};
/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */

function serialize(obj) {
  if (!isObject(obj)) return obj;
  var pairs = [];

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) pushEncodedKeyValuePair(pairs, key, obj[key]);
  }

  return pairs.join('&');
}
/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */


function pushEncodedKeyValuePair(pairs, key, val) {
  if (val === undefined) return;

  if (val === null) {
    pairs.push(encodeURI(key));
    return;
  }

  if (Array.isArray(val)) {
    val.forEach(function (v) {
      pushEncodedKeyValuePair(pairs, key, v);
    });
  } else if (isObject(val)) {
    for (var subkey in val) {
      if (Object.prototype.hasOwnProperty.call(val, subkey)) pushEncodedKeyValuePair(pairs, "".concat(key, "[").concat(subkey, "]"), val[subkey]);
    }
  } else {
    pairs.push(encodeURI(key) + '=' + encodeURIComponent(val));
  }
}
/**
 * Expose serialization method.
 */


request.serializeObject = serialize;
/**
 * Parse the given x-www-form-urlencoded `str`.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function parseString(str) {
  var obj = {};
  var pairs = str.split('&');
  var pair;
  var pos;

  for (var i = 0, len = pairs.length; i < len; ++i) {
    pair = pairs[i];
    pos = pair.indexOf('=');

    if (pos === -1) {
      obj[decodeURIComponent(pair)] = '';
    } else {
      obj[decodeURIComponent(pair.slice(0, pos))] = decodeURIComponent(pair.slice(pos + 1));
    }
  }

  return obj;
}
/**
 * Expose parser.
 */


request.parseString = parseString;
/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */

request.types = {
  html: 'text/html',
  json: 'application/json',
  xml: 'text/xml',
  urlencoded: 'application/x-www-form-urlencoded',
  form: 'application/x-www-form-urlencoded',
  'form-data': 'application/x-www-form-urlencoded'
};
/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */

request.serialize = {
  'application/x-www-form-urlencoded': qs.stringify,
  'application/json': safeStringify
};
/**
 * Default parsers.
 *
 *     superagent.parse['application/xml'] = function(str){
 *       return { object parsed from str };
 *     };
 *
 */

request.parse = {
  'application/x-www-form-urlencoded': parseString,
  'application/json': JSON.parse
};
/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function parseHeader(str) {
  var lines = str.split(/\r?\n/);
  var fields = {};
  var index;
  var line;
  var field;
  var val;

  for (var i = 0, len = lines.length; i < len; ++i) {
    line = lines[i];
    index = line.indexOf(':');

    if (index === -1) {
      // could be empty line, just skip it
      continue;
    }

    field = line.slice(0, index).toLowerCase();
    val = trim(line.slice(index + 1));
    fields[field] = val;
  }

  return fields;
}
/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */


function isJSON(mime) {
  // should match /json or +json
  // but not /json-seq
  return /[/+]json($|[^-\w])/i.test(mime);
}
/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */


function Response(req) {
  this.req = req;
  this.xhr = this.req.xhr; // responseText is accessible only if responseType is '' or 'text' and on older browsers

  this.text = this.req.method !== 'HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text') || typeof this.xhr.responseType === 'undefined' ? this.xhr.responseText : null;
  this.statusText = this.req.xhr.statusText;
  var status = this.xhr.status; // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request

  if (status === 1223) {
    status = 204;
  }

  this._setStatusProperties(status);

  this.headers = parseHeader(this.xhr.getAllResponseHeaders());
  this.header = this.headers; // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
  // getResponseHeader still works. so we get content-type even if getting
  // other headers fails.

  this.header['content-type'] = this.xhr.getResponseHeader('content-type');

  this._setHeaderProperties(this.header);

  if (this.text === null && req._responseType) {
    this.body = this.xhr.response;
  } else {
    this.body = this.req.method === 'HEAD' ? null : this._parseBody(this.text ? this.text : this.xhr.response);
  }
} // eslint-disable-next-line new-cap


ResponseBase(Response.prototype);
/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */

Response.prototype._parseBody = function (str) {
  var parse = request.parse[this.type];

  if (this.req._parser) {
    return this.req._parser(this, str);
  }

  if (!parse && isJSON(this.type)) {
    parse = request.parse['application/json'];
  }

  return parse && str && (str.length > 0 || str instanceof Object) ? parse(str) : null;
};
/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */


Response.prototype.toError = function () {
  var req = this.req;
  var method = req.method;
  var url = req.url;
  var msg = "cannot ".concat(method, " ").concat(url, " (").concat(this.status, ")");
  var err = new Error(msg);
  err.status = this.status;
  err.method = method;
  err.url = url;
  return err;
};
/**
 * Expose `Response`.
 */


request.Response = Response;
/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */

function Request(method, url) {
  var self = this;
  this._query = this._query || [];
  this.method = method;
  this.url = url;
  this.header = {}; // preserves header name case

  this._header = {}; // coerces header names to lowercase

  this.on('end', function () {
    var err = null;
    var res = null;

    try {
      res = new Response(self);
    } catch (err_) {
      err = new Error('Parser is unable to parse the response');
      err.parse = true;
      err.original = err_; // issue #675: return the raw response if the response parsing fails

      if (self.xhr) {
        // ie9 doesn't have 'response' property
        err.rawResponse = typeof self.xhr.responseType === 'undefined' ? self.xhr.responseText : self.xhr.response; // issue #876: return the http status code if the response parsing fails

        err.status = self.xhr.status ? self.xhr.status : null;
        err.statusCode = err.status; // backwards-compat only
      } else {
        err.rawResponse = null;
        err.status = null;
      }

      return self.callback(err);
    }

    self.emit('response', res);
    var new_err;

    try {
      if (!self._isResponseOK(res)) {
        new_err = new Error(res.statusText || res.text || 'Unsuccessful HTTP response');
      }
    } catch (err_) {
      new_err = err_; // ok() callback can throw
    } // #1000 don't catch errors from the callback to avoid double calling it


    if (new_err) {
      new_err.original = err;
      new_err.response = res;
      new_err.status = res.status;
      self.callback(new_err, res);
    } else {
      self.callback(null, res);
    }
  });
}
/**
 * Mixin `Emitter` and `RequestBase`.
 */
// eslint-disable-next-line new-cap


Emitter(Request.prototype); // eslint-disable-next-line new-cap

RequestBase(Request.prototype);
/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.type = function (type) {
  this.set('Content-Type', request.types[type] || type);
  return this;
};
/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */


Request.prototype.accept = function (type) {
  this.set('Accept', request.types[type] || type);
  return this;
};
/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} [pass] optional in case of using 'bearer' as type
 * @param {Object} options with 'type' property 'auto', 'basic' or 'bearer' (default 'basic')
 * @return {Request} for chaining
 * @api public
 */


Request.prototype.auth = function (user, pass, options) {
  if (arguments.length === 1) pass = '';

  if (_typeof(pass) === 'object' && pass !== null) {
    // pass is optional and can be replaced with options
    options = pass;
    pass = '';
  }

  if (!options) {
    options = {
      type: typeof btoa === 'function' ? 'basic' : 'auto'
    };
  }

  var encoder = function encoder(string) {
    if (typeof btoa === 'function') {
      return btoa(string);
    }

    throw new Error('Cannot use basic auth, btoa is not a function');
  };

  return this._auth(user, pass, options, encoder);
};
/**
 * Add query-string `val`.
 *
 * Examples:
 *
 *   request.get('/shoes')
 *     .query('size=10')
 *     .query({ color: 'blue' })
 *
 * @param {Object|String} val
 * @return {Request} for chaining
 * @api public
 */


Request.prototype.query = function (val) {
  if (typeof val !== 'string') val = serialize(val);
  if (val) this._query.push(val);
  return this;
};
/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `options` (or filename).
 *
 * ``` js
 * request.post('/upload')
 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String|Object} options
 * @return {Request} for chaining
 * @api public
 */


Request.prototype.attach = function (field, file, options) {
  if (file) {
    if (this._data) {
      throw new Error("superagent can't mix .send() and .attach()");
    }

    this._getFormData().append(field, file, options || file.name);
  }

  return this;
};

Request.prototype._getFormData = function () {
  if (!this._formData) {
    this._formData = new root.FormData();
  }

  return this._formData;
};
/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */


Request.prototype.callback = function (err, res) {
  if (this._shouldRetry(err, res)) {
    return this._retry();
  }

  var fn = this._callback;
  this.clearTimeout();

  if (err) {
    if (this._maxRetries) err.retries = this._retries - 1;
    this.emit('error', err);
  }

  fn(err, res);
};
/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */


Request.prototype.crossDomainError = function () {
  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
  err.crossDomain = true;
  err.status = this.status;
  err.method = this.method;
  err.url = this.url;
  this.callback(err);
}; // This only warns, because the request is still likely to work


Request.prototype.agent = function () {
  console.warn('This is not supported in browser version of superagent');
  return this;
};

Request.prototype.ca = Request.prototype.agent;
Request.prototype.buffer = Request.prototype.ca; // This throws, because it can't send/receive data as expected

Request.prototype.write = function () {
  throw new Error('Streaming is not supported in browser version of superagent');
};

Request.prototype.pipe = Request.prototype.write;
/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * @param {Object} obj host object
 * @return {Boolean} is a host object
 * @api private
 */

Request.prototype._isHost = function (obj) {
  // Native objects stringify to [object File], [object Blob], [object FormData], etc.
  return obj && _typeof(obj) === 'object' && !Array.isArray(obj) && Object.prototype.toString.call(obj) !== '[object Object]';
};
/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */


Request.prototype.end = function (fn) {
  if (this._endCalled) {
    console.warn('Warning: .end() was called twice. This is not supported in superagent');
  }

  this._endCalled = true; // store callback

  this._callback = fn || noop; // querystring

  this._finalizeQueryString();

  this._end();
};

Request.prototype._setUploadTimeout = function () {
  var self = this; // upload timeout it's wokrs only if deadline timeout is off

  if (this._uploadTimeout && !this._uploadTimeoutTimer) {
    this._uploadTimeoutTimer = setTimeout(function () {
      self._timeoutError('Upload timeout of ', self._uploadTimeout, 'ETIMEDOUT');
    }, this._uploadTimeout);
  }
}; // eslint-disable-next-line complexity


Request.prototype._end = function () {
  if (this._aborted) return this.callback(new Error('The request has been aborted even before .end() was called'));
  var self = this;
  this.xhr = request.getXHR();
  var xhr = this.xhr;
  var data = this._formData || this._data;

  this._setTimeouts(); // state change


  xhr.onreadystatechange = function () {
    var readyState = xhr.readyState;

    if (readyState >= 2 && self._responseTimeoutTimer) {
      clearTimeout(self._responseTimeoutTimer);
    }

    if (readyState !== 4) {
      return;
    } // In IE9, reads to any property (e.g. status) off of an aborted XHR will
    // result in the error "Could not complete the operation due to error c00c023f"


    var status;

    try {
      status = xhr.status;
    } catch (_unused5) {
      status = 0;
    }

    if (!status) {
      if (self.timedout || self._aborted) return;
      return self.crossDomainError();
    }

    self.emit('end');
  }; // progress


  var handleProgress = function handleProgress(direction, e) {
    if (e.total > 0) {
      e.percent = e.loaded / e.total * 100;

      if (e.percent === 100) {
        clearTimeout(self._uploadTimeoutTimer);
      }
    }

    e.direction = direction;
    self.emit('progress', e);
  };

  if (this.hasListeners('progress')) {
    try {
      xhr.addEventListener('progress', handleProgress.bind(null, 'download'));

      if (xhr.upload) {
        xhr.upload.addEventListener('progress', handleProgress.bind(null, 'upload'));
      }
    } catch (_unused6) {// Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
      // Reported here:
      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
    }
  }

  if (xhr.upload) {
    this._setUploadTimeout();
  } // initiate request


  try {
    if (this.username && this.password) {
      xhr.open(this.method, this.url, true, this.username, this.password);
    } else {
      xhr.open(this.method, this.url, true);
    }
  } catch (err) {
    // see #1149
    return this.callback(err);
  } // CORS


  if (this._withCredentials) xhr.withCredentials = true; // body

  if (!this._formData && this.method !== 'GET' && this.method !== 'HEAD' && typeof data !== 'string' && !this._isHost(data)) {
    // serialize stuff
    var contentType = this._header['content-type'];

    var _serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];

    if (!_serialize && isJSON(contentType)) {
      _serialize = request.serialize['application/json'];
    }

    if (_serialize) data = _serialize(data);
  } // set header fields


  for (var field in this.header) {
    if (this.header[field] === null) continue;
    if (Object.prototype.hasOwnProperty.call(this.header, field)) xhr.setRequestHeader(field, this.header[field]);
  }

  if (this._responseType) {
    xhr.responseType = this._responseType;
  } // send stuff


  this.emit('request', this); // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
  // We need null here if data is undefined

  xhr.send(typeof data === 'undefined' ? null : data);
};

request.agent = function () {
  return new Agent();
};

['GET', 'POST', 'OPTIONS', 'PATCH', 'PUT', 'DELETE'].forEach(function (method) {
  Agent.prototype[method.toLowerCase()] = function (url, fn) {
    var req = new request.Request(method, url);

    this._setDefaults(req);

    if (fn) {
      req.end(fn);
    }

    return req;
  };
});
Agent.prototype.del = Agent.prototype.delete;
/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.get = function (url, data, fn) {
  var req = request('GET', url);

  if (typeof data === 'function') {
    fn = data;
    data = null;
  }

  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};
/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */


request.head = function (url, data, fn) {
  var req = request('HEAD', url);

  if (typeof data === 'function') {
    fn = data;
    data = null;
  }

  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};
/**
 * OPTIONS query to `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */


request.options = function (url, data, fn) {
  var req = request('OPTIONS', url);

  if (typeof data === 'function') {
    fn = data;
    data = null;
  }

  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};
/**
 * DELETE `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */


function del(url, data, fn) {
  var req = request('DELETE', url);

  if (typeof data === 'function') {
    fn = data;
    data = null;
  }

  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
}

request.del = del;
request.delete = del;
/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.patch = function (url, data, fn) {
  var req = request('PATCH', url);

  if (typeof data === 'function') {
    fn = data;
    data = null;
  }

  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};
/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */


request.post = function (url, data, fn) {
  var req = request('POST', url);

  if (typeof data === 'function') {
    fn = data;
    data = null;
  }

  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};
/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */


request.put = function (url, data, fn) {
  var req = request('PUT', url);

  if (typeof data === 'function') {
    fn = data;
    data = null;
  }

  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 92338:
/***/ ((module) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Check if `obj` is an object.
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */
function isObject(obj) {
  return obj !== null && _typeof(obj) === 'object';
}

module.exports = isObject;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pcy1vYmplY3QuanMiXSwibmFtZXMiOlsiaXNPYmplY3QiLCJvYmoiLCJtb2R1bGUiLCJleHBvcnRzIl0sIm1hcHBpbmdzIjoiOzs7O0FBQUE7Ozs7Ozs7QUFRQSxTQUFTQSxRQUFULENBQWtCQyxHQUFsQixFQUF1QjtBQUNyQixTQUFPQSxHQUFHLEtBQUssSUFBUixJQUFnQixRQUFPQSxHQUFQLE1BQWUsUUFBdEM7QUFDRDs7QUFFREMsTUFBTSxDQUFDQyxPQUFQLEdBQWlCSCxRQUFqQiIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ2hlY2sgaWYgYG9iamAgaXMgYW4gb2JqZWN0LlxuICpcbiAqIEBwYXJhbSB7T2JqZWN0fSBvYmpcbiAqIEByZXR1cm4ge0Jvb2xlYW59XG4gKiBAYXBpIHByaXZhdGVcbiAqL1xuXG5mdW5jdGlvbiBpc09iamVjdChvYmopIHtcbiAgcmV0dXJuIG9iaiAhPT0gbnVsbCAmJiB0eXBlb2Ygb2JqID09PSAnb2JqZWN0Jztcbn1cblxubW9kdWxlLmV4cG9ydHMgPSBpc09iamVjdDtcbiJdfQ==

/***/ }),

/***/ 11183:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Module of mixed-in functions shared between node and client code
 */
var isObject = __webpack_require__(92338);
/**
 * Expose `RequestBase`.
 */


module.exports = RequestBase;
/**
 * Initialize a new `RequestBase`.
 *
 * @api public
 */

function RequestBase(object) {
  if (object) return mixin(object);
}
/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */


function mixin(object) {
  for (var key in RequestBase.prototype) {
    if (Object.prototype.hasOwnProperty.call(RequestBase.prototype, key)) object[key] = RequestBase.prototype[key];
  }

  return object;
}
/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */


RequestBase.prototype.clearTimeout = function () {
  clearTimeout(this._timer);
  clearTimeout(this._responseTimeoutTimer);
  clearTimeout(this._uploadTimeoutTimer);
  delete this._timer;
  delete this._responseTimeoutTimer;
  delete this._uploadTimeoutTimer;
  return this;
};
/**
 * Override default response body parser
 *
 * This function will be called to convert incoming data into request.body
 *
 * @param {Function}
 * @api public
 */


RequestBase.prototype.parse = function (fn) {
  this._parser = fn;
  return this;
};
/**
 * Set format of binary response body.
 * In browser valid formats are 'blob' and 'arraybuffer',
 * which return Blob and ArrayBuffer, respectively.
 *
 * In Node all values result in Buffer.
 *
 * Examples:
 *
 *      req.get('/')
 *        .responseType('blob')
 *        .end(callback);
 *
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */


RequestBase.prototype.responseType = function (value) {
  this._responseType = value;
  return this;
};
/**
 * Override default request body serializer
 *
 * This function will be called to convert data set via .send or .attach into payload to send
 *
 * @param {Function}
 * @api public
 */


RequestBase.prototype.serialize = function (fn) {
  this._serializer = fn;
  return this;
};
/**
 * Set timeouts.
 *
 * - response timeout is time between sending request and receiving the first byte of the response. Includes DNS and connection time.
 * - deadline is the time from start of the request to receiving response body in full. If the deadline is too short large files may not load at all on slow connections.
 * - upload is the time  since last bit of data was sent or received. This timeout works only if deadline timeout is off
 *
 * Value of 0 or false means no timeout.
 *
 * @param {Number|Object} ms or {response, deadline}
 * @return {Request} for chaining
 * @api public
 */


RequestBase.prototype.timeout = function (options) {
  if (!options || _typeof(options) !== 'object') {
    this._timeout = options;
    this._responseTimeout = 0;
    this._uploadTimeout = 0;
    return this;
  }

  for (var option in options) {
    if (Object.prototype.hasOwnProperty.call(options, option)) {
      switch (option) {
        case 'deadline':
          this._timeout = options.deadline;
          break;

        case 'response':
          this._responseTimeout = options.response;
          break;

        case 'upload':
          this._uploadTimeout = options.upload;
          break;

        default:
          console.warn('Unknown timeout option', option);
      }
    }
  }

  return this;
};
/**
 * Set number of retry attempts on error.
 *
 * Failed requests will be retried 'count' times if timeout or err.code >= 500.
 *
 * @param {Number} count
 * @param {Function} [fn]
 * @return {Request} for chaining
 * @api public
 */


RequestBase.prototype.retry = function (count, fn) {
  // Default to 1 if no count passed or true
  if (arguments.length === 0 || count === true) count = 1;
  if (count <= 0) count = 0;
  this._maxRetries = count;
  this._retries = 0;
  this._retryCallback = fn;
  return this;
}; //
// NOTE: we do not include ESOCKETTIMEDOUT because that is from `request` package
//       <https://github.com/sindresorhus/got/pull/537>
//
// NOTE: we do not include EADDRINFO because it was removed from libuv in 2014
//       <https://github.com/libuv/libuv/commit/02e1ebd40b807be5af46343ea873331b2ee4e9c1>
//       <https://github.com/request/request/search?q=ESOCKETTIMEDOUT&unscoped_q=ESOCKETTIMEDOUT>
//
//
// TODO: expose these as configurable defaults
//


var ERROR_CODES = new Set(['ETIMEDOUT', 'ECONNRESET', 'EADDRINUSE', 'ECONNREFUSED', 'EPIPE', 'ENOTFOUND', 'ENETUNREACH', 'EAI_AGAIN']);
var STATUS_CODES = new Set([408, 413, 429, 500, 502, 503, 504, 521, 522, 524]); // TODO: we would need to make this easily configurable before adding it in (e.g. some might want to add POST)
// const METHODS = new Set(['GET', 'PUT', 'HEAD', 'DELETE', 'OPTIONS', 'TRACE']);

/**
 * Determine if a request should be retried.
 * (Inspired by https://github.com/sindresorhus/got#retry)
 *
 * @param {Error} err an error
 * @param {Response} [res] response
 * @returns {Boolean} if segment should be retried
 */

RequestBase.prototype._shouldRetry = function (err, res) {
  if (!this._maxRetries || this._retries++ >= this._maxRetries) {
    return false;
  }

  if (this._retryCallback) {
    try {
      var override = this._retryCallback(err, res);

      if (override === true) return true;
      if (override === false) return false; // undefined falls back to defaults
    } catch (err_) {
      console.error(err_);
    }
  } // TODO: we would need to make this easily configurable before adding it in (e.g. some might want to add POST)

  /*
  if (
    this.req &&
    this.req.method &&
    !METHODS.has(this.req.method.toUpperCase())
  )
    return false;
  */


  if (res && res.status && STATUS_CODES.has(res.status)) return true;

  if (err) {
    if (err.code && ERROR_CODES.has(err.code)) return true; // Superagent timeout

    if (err.timeout && err.code === 'ECONNABORTED') return true;
    if (err.crossDomain) return true;
  }

  return false;
};
/**
 * Retry request
 *
 * @return {Request} for chaining
 * @api private
 */


RequestBase.prototype._retry = function () {
  this.clearTimeout(); // node

  if (this.req) {
    this.req = null;
    this.req = this.request();
  }

  this._aborted = false;
  this.timedout = false;
  this.timedoutError = null;
  return this._end();
};
/**
 * Promise support
 *
 * @param {Function} resolve
 * @param {Function} [reject]
 * @return {Request}
 */


RequestBase.prototype.then = function (resolve, reject) {
  var _this = this;

  if (!this._fullfilledPromise) {
    var self = this;

    if (this._endCalled) {
      console.warn('Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises');
    }

    this._fullfilledPromise = new Promise(function (resolve, reject) {
      self.on('abort', function () {
        if (_this._maxRetries && _this._maxRetries > _this._retries) {
          return;
        }

        if (_this.timedout && _this.timedoutError) {
          reject(_this.timedoutError);
          return;
        }

        var err = new Error('Aborted');
        err.code = 'ABORTED';
        err.status = _this.status;
        err.method = _this.method;
        err.url = _this.url;
        reject(err);
      });
      self.end(function (err, res) {
        if (err) reject(err);else resolve(res);
      });
    });
  }

  return this._fullfilledPromise.then(resolve, reject);
};

RequestBase.prototype.catch = function (cb) {
  return this.then(undefined, cb);
};
/**
 * Allow for extension
 */


RequestBase.prototype.use = function (fn) {
  fn(this);
  return this;
};

RequestBase.prototype.ok = function (cb) {
  if (typeof cb !== 'function') throw new Error('Callback required');
  this._okCallback = cb;
  return this;
};

RequestBase.prototype._isResponseOK = function (res) {
  if (!res) {
    return false;
  }

  if (this._okCallback) {
    return this._okCallback(res);
  }

  return res.status >= 200 && res.status < 300;
};
/**
 * Get request header `field`.
 * Case-insensitive.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */


RequestBase.prototype.get = function (field) {
  return this._header[field.toLowerCase()];
};
/**
 * Get case-insensitive header `field` value.
 * This is a deprecated internal API. Use `.get(field)` instead.
 *
 * (getHeader is no longer used internally by the superagent code base)
 *
 * @param {String} field
 * @return {String}
 * @api private
 * @deprecated
 */


RequestBase.prototype.getHeader = RequestBase.prototype.get;
/**
 * Set header `field` to `val`, or multiple fields with one object.
 * Case-insensitive.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.set = function (field, value) {
  if (isObject(field)) {
    for (var key in field) {
      if (Object.prototype.hasOwnProperty.call(field, key)) this.set(key, field[key]);
    }

    return this;
  }

  this._header[field.toLowerCase()] = value;
  this.header[field] = value;
  return this;
};
/**
 * Remove header `field`.
 * Case-insensitive.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field field name
 */


RequestBase.prototype.unset = function (field) {
  delete this._header[field.toLowerCase()];
  delete this.header[field];
  return this;
};
/**
 * Write the field `name` and `val`, or multiple fields with one object
 * for "multipart/form-data" request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 *
 * request.post('/upload')
 *   .field({ foo: 'bar', baz: 'qux' })
 *   .end(callback);
 * ```
 *
 * @param {String|Object} name name of field
 * @param {String|Blob|File|Buffer|fs.ReadStream} val value of field
 * @return {Request} for chaining
 * @api public
 */


RequestBase.prototype.field = function (name, value) {
  // name should be either a string or an object.
  if (name === null || undefined === name) {
    throw new Error('.field(name, val) name can not be empty');
  }

  if (this._data) {
    throw new Error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObject(name)) {
    for (var key in name) {
      if (Object.prototype.hasOwnProperty.call(name, key)) this.field(key, name[key]);
    }

    return this;
  }

  if (Array.isArray(value)) {
    for (var i in value) {
      if (Object.prototype.hasOwnProperty.call(value, i)) this.field(name, value[i]);
    }

    return this;
  } // val should be defined now


  if (value === null || undefined === value) {
    throw new Error('.field(name, val) val can not be empty');
  }

  if (typeof value === 'boolean') {
    value = String(value);
  }

  this._getFormData().append(name, value);

  return this;
};
/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request} request
 * @api public
 */


RequestBase.prototype.abort = function () {
  if (this._aborted) {
    return this;
  }

  this._aborted = true;
  if (this.xhr) this.xhr.abort(); // browser

  if (this.req) this.req.abort(); // node

  this.clearTimeout();
  this.emit('abort');
  return this;
};

RequestBase.prototype._auth = function (user, pass, options, base64Encoder) {
  switch (options.type) {
    case 'basic':
      this.set('Authorization', "Basic ".concat(base64Encoder("".concat(user, ":").concat(pass))));
      break;

    case 'auto':
      this.username = user;
      this.password = pass;
      break;

    case 'bearer':
      // usage would be .auth(accessToken, { type: 'bearer' })
      this.set('Authorization', "Bearer ".concat(user));
      break;

    default:
      break;
  }

  return this;
};
/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 *
 * @api public
 */


RequestBase.prototype.withCredentials = function (on) {
  // This is browser-only functionality. Node side is no-op.
  if (on === undefined) on = true;
  this._withCredentials = on;
  return this;
};
/**
 * Set the max redirects to `n`. Does nothing in browser XHR implementation.
 *
 * @param {Number} n
 * @return {Request} for chaining
 * @api public
 */


RequestBase.prototype.redirects = function (n) {
  this._maxRedirects = n;
  return this;
};
/**
 * Maximum size of buffered response body, in bytes. Counts uncompressed size.
 * Default 200MB.
 *
 * @param {Number} n number of bytes
 * @return {Request} for chaining
 */


RequestBase.prototype.maxResponseSize = function (n) {
  if (typeof n !== 'number') {
    throw new TypeError('Invalid argument');
  }

  this._maxResponseSize = n;
  return this;
};
/**
 * Convert to a plain javascript object (not JSON string) of scalar properties.
 * Note as this method is designed to return a useful non-this value,
 * it cannot be chained.
 *
 * @return {Object} describing method, url, and data of this request
 * @api public
 */


RequestBase.prototype.toJSON = function () {
  return {
    method: this.method,
    url: this.url,
    data: this._data,
    headers: this._header
  };
};
/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
 *      request.post('/user')
 *        .send('name=tobi')
 *        .send('species=ferret')
 *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */
// eslint-disable-next-line complexity


RequestBase.prototype.send = function (data) {
  var isObject_ = isObject(data);
  var type = this._header['content-type'];

  if (this._formData) {
    throw new Error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObject_ && !this._data) {
    if (Array.isArray(data)) {
      this._data = [];
    } else if (!this._isHost(data)) {
      this._data = {};
    }
  } else if (data && this._data && this._isHost(this._data)) {
    throw new Error("Can't merge these send calls");
  } // merge


  if (isObject_ && isObject(this._data)) {
    for (var key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) this._data[key] = data[key];
    }
  } else if (typeof data === 'string') {
    // default to x-www-form-urlencoded
    if (!type) this.type('form');
    type = this._header['content-type'];
    if (type) type = type.toLowerCase().trim();

    if (type === 'application/x-www-form-urlencoded') {
      this._data = this._data ? "".concat(this._data, "&").concat(data) : data;
    } else {
      this._data = (this._data || '') + data;
    }
  } else {
    this._data = data;
  }

  if (!isObject_ || this._isHost(data)) {
    return this;
  } // default to json


  if (!type) this.type('json');
  return this;
};
/**
 * Sort `querystring` by the sort function
 *
 *
 * Examples:
 *
 *       // default order
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery()
 *         .end(callback)
 *
 *       // customized sort function
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery(function(a, b){
 *           return a.length - b.length;
 *         })
 *         .end(callback)
 *
 *
 * @param {Function} sort
 * @return {Request} for chaining
 * @api public
 */


RequestBase.prototype.sortQuery = function (sort) {
  // _sort default to true but otherwise can be a function or boolean
  this._sort = typeof sort === 'undefined' ? true : sort;
  return this;
};
/**
 * Compose querystring to append to req.url
 *
 * @api private
 */


RequestBase.prototype._finalizeQueryString = function () {
  var query = this._query.join('&');

  if (query) {
    this.url += (this.url.includes('?') ? '&' : '?') + query;
  }

  this._query.length = 0; // Makes the call idempotent

  if (this._sort) {
    var index = this.url.indexOf('?');

    if (index >= 0) {
      var queryArray = this.url.slice(index + 1).split('&');

      if (typeof this._sort === 'function') {
        queryArray.sort(this._sort);
      } else {
        queryArray.sort();
      }

      this.url = this.url.slice(0, index) + '?' + queryArray.join('&');
    }
  }
}; // For backwards compat only


RequestBase.prototype._appendQueryString = function () {
  console.warn('Unsupported');
};
/**
 * Invoke callback with timeout error.
 *
 * @api private
 */


RequestBase.prototype._timeoutError = function (reason, timeout, errno) {
  if (this._aborted) {
    return;
  }

  var err = new Error("".concat(reason + timeout, "ms exceeded"));
  err.timeout = timeout;
  err.code = 'ECONNABORTED';
  err.errno = errno;
  this.timedout = true;
  this.timedoutError = err;
  this.abort();
  this.callback(err);
};

RequestBase.prototype._setTimeouts = function () {
  var self = this; // deadline

  if (this._timeout && !this._timer) {
    this._timer = setTimeout(function () {
      self._timeoutError('Timeout of ', self._timeout, 'ETIME');
    }, this._timeout);
  } // response timeout


  if (this._responseTimeout && !this._responseTimeoutTimer) {
    this._responseTimeoutTimer = setTimeout(function () {
      self._timeoutError('Response timeout of ', self._responseTimeout, 'ETIMEDOUT');
    }, this._responseTimeout);
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 44259:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/**
 * Module dependencies.
 */
var utils = __webpack_require__(98346);
/**
 * Expose `ResponseBase`.
 */


module.exports = ResponseBase;
/**
 * Initialize a new `ResponseBase`.
 *
 * @api public
 */

function ResponseBase(obj) {
  if (obj) return mixin(obj);
}
/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */


function mixin(obj) {
  for (var key in ResponseBase.prototype) {
    if (Object.prototype.hasOwnProperty.call(ResponseBase.prototype, key)) obj[key] = ResponseBase.prototype[key];
  }

  return obj;
}
/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */


ResponseBase.prototype.get = function (field) {
  return this.header[field.toLowerCase()];
};
/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */


ResponseBase.prototype._setHeaderProperties = function (header) {
  // TODO: moar!
  // TODO: make this a util
  // content-type
  var ct = header['content-type'] || '';
  this.type = utils.type(ct); // params

  var params = utils.params(ct);

  for (var key in params) {
    if (Object.prototype.hasOwnProperty.call(params, key)) this[key] = params[key];
  }

  this.links = {}; // links

  try {
    if (header.link) {
      this.links = utils.parseLinks(header.link);
    }
  } catch (_unused) {// ignore
  }
};
/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */


ResponseBase.prototype._setStatusProperties = function (status) {
  var type = status / 100 | 0; // status / class

  this.statusCode = status;
  this.status = this.statusCode;
  this.statusType = type; // basics

  this.info = type === 1;
  this.ok = type === 2;
  this.redirect = type === 3;
  this.clientError = type === 4;
  this.serverError = type === 5;
  this.error = type === 4 || type === 5 ? this.toError() : false; // sugar

  this.created = status === 201;
  this.accepted = status === 202;
  this.noContent = status === 204;
  this.badRequest = status === 400;
  this.unauthorized = status === 401;
  this.notAcceptable = status === 406;
  this.forbidden = status === 403;
  this.notFound = status === 404;
  this.unprocessableEntity = status === 422;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 98346:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */
exports.type = function (str) {
  return str.split(/ *; */).shift();
};
/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */


exports.params = function (val) {
  var obj = {};

  var _iterator = _createForOfIteratorHelper(val.split(/ *; */)),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var str = _step.value;
      var parts = str.split(/ *= */);
      var key = parts.shift();

      var _val = parts.shift();

      if (key && _val) obj[key] = _val;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return obj;
};
/**
 * Parse Link header fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */


exports.parseLinks = function (val) {
  var obj = {};

  var _iterator2 = _createForOfIteratorHelper(val.split(/ *, */)),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var str = _step2.value;
      var parts = str.split(/ *; */);
      var url = parts[0].slice(1, -1);
      var rel = parts[1].split(/ *= */)[1].slice(1, -1);
      obj[rel] = url;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return obj;
};
/**
 * Strip content related fields from `header`.
 *
 * @param {Object} header
 * @return {Object} header
 * @api private
 */


exports.cleanHeader = function (header, changesOrigin) {
  delete header['content-type'];
  delete header['content-length'];
  delete header['transfer-encoding'];
  delete header.host; // secuirty

  if (changesOrigin) {
    delete header.authorization;
    delete header.cookie;
  }

  return header;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 95856:
/***/ ((module) => {

"use strict";


function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function Agent() {
  this._defaults = [];
}
for (var _i = 0, _arr = ['use', 'on', 'once', 'set', 'query', 'type', 'accept', 'auth', 'withCredentials', 'sortQuery', 'retry', 'ok', 'redirects', 'timeout', 'buffer', 'serialize', 'parse', 'ca', 'key', 'pfx', 'cert', 'disableTLSCerts']; _i < _arr.length; _i++) {
  const fn = _arr[_i];
  // Default setting for all requests from this agent
  Agent.prototype[fn] = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    this._defaults.push({
      fn,
      args
    });
    return this;
  };
}
Agent.prototype._setDefaults = function (request) {
  var _iterator = _createForOfIteratorHelper(this._defaults),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      const def = _step.value;
      request[def.fn](...def.args);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};
module.exports = Agent;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 54247:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/**
 * Root reference for iframes.
 */

let root;
if (typeof window !== 'undefined') {
  // Browser window
  root = window;
} else if (typeof self === 'undefined') {
  // Other environments
  console.warn('Using browser-only version of superagent in non-browser environment');
  root = void 0;
} else {
  // Web Worker
  root = self;
}
const Emitter = __webpack_require__(14907);
const safeStringify = __webpack_require__(61406);
const qs = __webpack_require__(69787);
const RequestBase = __webpack_require__(39745);
const _require = __webpack_require__(73316),
  isObject = _require.isObject,
  mixin = _require.mixin,
  hasOwn = _require.hasOwn;
const ResponseBase = __webpack_require__(76031);
const Agent = __webpack_require__(95856);

/**
 * Noop.
 */

function noop() {}

/**
 * Expose `request`.
 */

module.exports = function (method, url) {
  // callback
  if (typeof url === 'function') {
    return new exports.Request('GET', method).end(url);
  }

  // url first
  if (arguments.length === 1) {
    return new exports.Request('GET', method);
  }
  return new exports.Request(method, url);
};
exports = module.exports;
const request = exports;
exports.Request = Request;

/**
 * Determine XHR.
 */

request.getXHR = () => {
  if (root.XMLHttpRequest) {
    return new root.XMLHttpRequest();
  }
  throw new Error('Browser-only version of superagent could not find XHR');
};

/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */

const trim = ''.trim ? s => s.trim() : s => s.replace(/(^\s*|\s*$)/g, '');

/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */

function serialize(object) {
  if (!isObject(object)) return object;
  const pairs = [];
  for (const key in object) {
    if (hasOwn(object, key)) pushEncodedKeyValuePair(pairs, key, object[key]);
  }
  return pairs.join('&');
}

/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */

function pushEncodedKeyValuePair(pairs, key, value) {
  if (value === undefined) return;
  if (value === null) {
    pairs.push(encodeURI(key));
    return;
  }
  if (Array.isArray(value)) {
    var _iterator = _createForOfIteratorHelper(value),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        const v = _step.value;
        pushEncodedKeyValuePair(pairs, key, v);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  } else if (isObject(value)) {
    for (const subkey in value) {
      if (hasOwn(value, subkey)) pushEncodedKeyValuePair(pairs, `${key}[${subkey}]`, value[subkey]);
    }
  } else {
    pairs.push(encodeURI(key) + '=' + encodeURIComponent(value));
  }
}

/**
 * Expose serialization method.
 */

request.serializeObject = serialize;

/**
 * Parse the given x-www-form-urlencoded `str`.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function parseString(string_) {
  const object = {};
  const pairs = string_.split('&');
  let pair;
  let pos;
  for (let i = 0, length_ = pairs.length; i < length_; ++i) {
    pair = pairs[i];
    pos = pair.indexOf('=');
    if (pos === -1) {
      object[decodeURIComponent(pair)] = '';
    } else {
      object[decodeURIComponent(pair.slice(0, pos))] = decodeURIComponent(pair.slice(pos + 1));
    }
  }
  return object;
}

/**
 * Expose parser.
 */

request.parseString = parseString;

/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */

request.types = {
  html: 'text/html',
  json: 'application/json',
  xml: 'text/xml',
  urlencoded: 'application/x-www-form-urlencoded',
  form: 'application/x-www-form-urlencoded',
  'form-data': 'application/x-www-form-urlencoded'
};

/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */

request.serialize = {
  'application/x-www-form-urlencoded': qs.stringify,
  'application/json': safeStringify
};

/**
 * Default parsers.
 *
 *     superagent.parse['application/xml'] = function(str){
 *       return { object parsed from str };
 *     };
 *
 */

request.parse = {
  'application/x-www-form-urlencoded': parseString,
  'application/json': JSON.parse
};

/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function parseHeader(string_) {
  const lines = string_.split(/\r?\n/);
  const fields = {};
  let index;
  let line;
  let field;
  let value;
  for (let i = 0, length_ = lines.length; i < length_; ++i) {
    line = lines[i];
    index = line.indexOf(':');
    if (index === -1) {
      // could be empty line, just skip it
      continue;
    }
    field = line.slice(0, index).toLowerCase();
    value = trim(line.slice(index + 1));
    fields[field] = value;
  }
  return fields;
}

/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */

function isJSON(mime) {
  // should match /json or +json
  // but not /json-seq
  return /[/+]json($|[^-\w])/i.test(mime);
}

/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */

function Response(request_) {
  this.req = request_;
  this.xhr = this.req.xhr;
  // responseText is accessible only if responseType is '' or 'text' and on older browsers
  this.text = this.req.method !== 'HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text') || typeof this.xhr.responseType === 'undefined' ? this.xhr.responseText : null;
  this.statusText = this.req.xhr.statusText;
  let status = this.xhr.status;
  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
  if (status === 1223) {
    status = 204;
  }
  this._setStatusProperties(status);
  this.headers = parseHeader(this.xhr.getAllResponseHeaders());
  this.header = this.headers;
  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
  // getResponseHeader still works. so we get content-type even if getting
  // other headers fails.
  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
  this._setHeaderProperties(this.header);
  if (this.text === null && request_._responseType) {
    this.body = this.xhr.response;
  } else {
    this.body = this.req.method === 'HEAD' ? null : this._parseBody(this.text ? this.text : this.xhr.response);
  }
}
mixin(Response.prototype, ResponseBase.prototype);

/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */

Response.prototype._parseBody = function (string_) {
  let parse = request.parse[this.type];
  if (this.req._parser) {
    return this.req._parser(this, string_);
  }
  if (!parse && isJSON(this.type)) {
    parse = request.parse['application/json'];
  }
  return parse && string_ && (string_.length > 0 || string_ instanceof Object) ? parse(string_) : null;
};

/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */

Response.prototype.toError = function () {
  const req = this.req;
  const method = req.method;
  const url = req.url;
  const message = `cannot ${method} ${url} (${this.status})`;
  const error = new Error(message);
  error.status = this.status;
  error.method = method;
  error.url = url;
  return error;
};

/**
 * Expose `Response`.
 */

request.Response = Response;

/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */

function Request(method, url) {
  const self = this;
  this._query = this._query || [];
  this.method = method;
  this.url = url;
  this.header = {}; // preserves header name case
  this._header = {}; // coerces header names to lowercase
  this.on('end', () => {
    let error = null;
    let res = null;
    try {
      res = new Response(self);
    } catch (err) {
      error = new Error('Parser is unable to parse the response');
      error.parse = true;
      error.original = err;
      // issue #675: return the raw response if the response parsing fails
      if (self.xhr) {
        // ie9 doesn't have 'response' property
        error.rawResponse = typeof self.xhr.responseType === 'undefined' ? self.xhr.responseText : self.xhr.response;
        // issue #876: return the http status code if the response parsing fails
        error.status = self.xhr.status ? self.xhr.status : null;
        error.statusCode = error.status; // backwards-compat only
      } else {
        error.rawResponse = null;
        error.status = null;
      }
      return self.callback(error);
    }
    self.emit('response', res);
    let new_error;
    try {
      if (!self._isResponseOK(res)) {
        new_error = new Error(res.statusText || res.text || 'Unsuccessful HTTP response');
      }
    } catch (err) {
      new_error = err; // ok() callback can throw
    }

    // #1000 don't catch errors from the callback to avoid double calling it
    if (new_error) {
      new_error.original = error;
      new_error.response = res;
      new_error.status = new_error.status || res.status;
      self.callback(new_error, res);
    } else {
      self.callback(null, res);
    }
  });
}

/**
 * Mixin `Emitter` and `RequestBase`.
 */

// eslint-disable-next-line new-cap
Emitter(Request.prototype);
mixin(Request.prototype, RequestBase.prototype);

/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.type = function (type) {
  this.set('Content-Type', request.types[type] || type);
  return this;
};

/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.accept = function (type) {
  this.set('Accept', request.types[type] || type);
  return this;
};

/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} [pass] optional in case of using 'bearer' as type
 * @param {Object} options with 'type' property 'auto', 'basic' or 'bearer' (default 'basic')
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.auth = function (user, pass, options) {
  if (arguments.length === 1) pass = '';
  if (typeof pass === 'object' && pass !== null) {
    // pass is optional and can be replaced with options
    options = pass;
    pass = '';
  }
  if (!options) {
    options = {
      type: typeof btoa === 'function' ? 'basic' : 'auto'
    };
  }
  const encoder = options.encoder ? options.encoder : string => {
    if (typeof btoa === 'function') {
      return btoa(string);
    }
    throw new Error('Cannot use basic auth, btoa is not a function');
  };
  return this._auth(user, pass, options, encoder);
};

/**
 * Add query-string `val`.
 *
 * Examples:
 *
 *   request.get('/shoes')
 *     .query('size=10')
 *     .query({ color: 'blue' })
 *
 * @param {Object|String} val
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.query = function (value) {
  if (typeof value !== 'string') value = serialize(value);
  if (value) this._query.push(value);
  return this;
};

/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `options` (or filename).
 *
 * ``` js
 * request.post('/upload')
 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String|Object} options
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.attach = function (field, file, options) {
  if (file) {
    if (this._data) {
      throw new Error("superagent can't mix .send() and .attach()");
    }
    this._getFormData().append(field, file, options || file.name);
  }
  return this;
};
Request.prototype._getFormData = function () {
  if (!this._formData) {
    this._formData = new root.FormData();
  }
  return this._formData;
};

/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */

Request.prototype.callback = function (error, res) {
  if (this._shouldRetry(error, res)) {
    return this._retry();
  }
  const fn = this._callback;
  this.clearTimeout();
  if (error) {
    if (this._maxRetries) error.retries = this._retries - 1;
    this.emit('error', error);
  }
  fn(error, res);
};

/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */

Request.prototype.crossDomainError = function () {
  const error = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
  error.crossDomain = true;
  error.status = this.status;
  error.method = this.method;
  error.url = this.url;
  this.callback(error);
};

// This only warns, because the request is still likely to work
Request.prototype.agent = function () {
  console.warn('This is not supported in browser version of superagent');
  return this;
};
Request.prototype.ca = Request.prototype.agent;
Request.prototype.buffer = Request.prototype.ca;

// This throws, because it can't send/receive data as expected
Request.prototype.write = () => {
  throw new Error('Streaming is not supported in browser version of superagent');
};
Request.prototype.pipe = Request.prototype.write;

/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * @param {Object} obj host object
 * @return {Boolean} is a host object
 * @api private
 */
Request.prototype._isHost = function (object) {
  // Native objects stringify to [object File], [object Blob], [object FormData], etc.
  return object && typeof object === 'object' && !Array.isArray(object) && Object.prototype.toString.call(object) !== '[object Object]';
};

/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.end = function (fn) {
  if (this._endCalled) {
    console.warn('Warning: .end() was called twice. This is not supported in superagent');
  }
  this._endCalled = true;

  // store callback
  this._callback = fn || noop;

  // querystring
  this._finalizeQueryString();
  this._end();
};
Request.prototype._setUploadTimeout = function () {
  const self = this;

  // upload timeout it's wokrs only if deadline timeout is off
  if (this._uploadTimeout && !this._uploadTimeoutTimer) {
    this._uploadTimeoutTimer = setTimeout(() => {
      self._timeoutError('Upload timeout of ', self._uploadTimeout, 'ETIMEDOUT');
    }, this._uploadTimeout);
  }
};

// eslint-disable-next-line complexity
Request.prototype._end = function () {
  if (this._aborted) return this.callback(new Error('The request has been aborted even before .end() was called'));
  const self = this;
  this.xhr = request.getXHR();
  const xhr = this.xhr;
  let data = this._formData || this._data;
  this._setTimeouts();

  // state change
  xhr.addEventListener('readystatechange', () => {
    const readyState = xhr.readyState;
    if (readyState >= 2 && self._responseTimeoutTimer) {
      clearTimeout(self._responseTimeoutTimer);
    }
    if (readyState !== 4) {
      return;
    }

    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
    // result in the error "Could not complete the operation due to error c00c023f"
    let status;
    try {
      status = xhr.status;
    } catch (err) {
      status = 0;
    }
    if (!status) {
      if (self.timedout || self._aborted) return;
      return self.crossDomainError();
    }
    self.emit('end');
  });

  // progress
  const handleProgress = (direction, e) => {
    if (e.total > 0) {
      e.percent = e.loaded / e.total * 100;
      if (e.percent === 100) {
        clearTimeout(self._uploadTimeoutTimer);
      }
    }
    e.direction = direction;
    self.emit('progress', e);
  };
  if (this.hasListeners('progress')) {
    try {
      xhr.addEventListener('progress', handleProgress.bind(null, 'download'));
      if (xhr.upload) {
        xhr.upload.addEventListener('progress', handleProgress.bind(null, 'upload'));
      }
    } catch (err) {
      // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
      // Reported here:
      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
    }
  }
  if (xhr.upload) {
    this._setUploadTimeout();
  }

  // initiate request
  try {
    if (this.username && this.password) {
      xhr.open(this.method, this.url, true, this.username, this.password);
    } else {
      xhr.open(this.method, this.url, true);
    }
  } catch (err) {
    // see #1149
    return this.callback(err);
  }

  // CORS
  if (this._withCredentials) xhr.withCredentials = true;

  // body
  if (!this._formData && this.method !== 'GET' && this.method !== 'HEAD' && typeof data !== 'string' && !this._isHost(data)) {
    // serialize stuff
    const contentType = this._header['content-type'];
    let serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
    if (!serialize && isJSON(contentType)) {
      serialize = request.serialize['application/json'];
    }
    if (serialize) data = serialize(data);
  }

  // set header fields
  for (const field in this.header) {
    if (this.header[field] === null) continue;
    if (hasOwn(this.header, field)) xhr.setRequestHeader(field, this.header[field]);
  }
  if (this._responseType) {
    xhr.responseType = this._responseType;
  }

  // send stuff
  this.emit('request', this);

  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
  // We need null here if data is undefined
  xhr.send(typeof data === 'undefined' ? null : data);
};
request.agent = () => new Agent();
for (var _i = 0, _arr = ['GET', 'POST', 'OPTIONS', 'PATCH', 'PUT', 'DELETE']; _i < _arr.length; _i++) {
  const method = _arr[_i];
  Agent.prototype[method.toLowerCase()] = function (url, fn) {
    const request_ = new request.Request(method, url);
    this._setDefaults(request_);
    if (fn) {
      request_.end(fn);
    }
    return request_;
  };
}
Agent.prototype.del = Agent.prototype.delete;

/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.get = (url, data, fn) => {
  const request_ = request('GET', url);
  if (typeof data === 'function') {
    fn = data;
    data = null;
  }
  if (data) request_.query(data);
  if (fn) request_.end(fn);
  return request_;
};

/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.head = (url, data, fn) => {
  const request_ = request('HEAD', url);
  if (typeof data === 'function') {
    fn = data;
    data = null;
  }
  if (data) request_.query(data);
  if (fn) request_.end(fn);
  return request_;
};

/**
 * OPTIONS query to `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.options = (url, data, fn) => {
  const request_ = request('OPTIONS', url);
  if (typeof data === 'function') {
    fn = data;
    data = null;
  }
  if (data) request_.send(data);
  if (fn) request_.end(fn);
  return request_;
};

/**
 * DELETE `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

function del(url, data, fn) {
  const request_ = request('DELETE', url);
  if (typeof data === 'function') {
    fn = data;
    data = null;
  }
  if (data) request_.send(data);
  if (fn) request_.end(fn);
  return request_;
}
request.del = del;
request.delete = del;

/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.patch = (url, data, fn) => {
  const request_ = request('PATCH', url);
  if (typeof data === 'function') {
    fn = data;
    data = null;
  }
  if (data) request_.send(data);
  if (fn) request_.end(fn);
  return request_;
};

/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.post = (url, data, fn) => {
  const request_ = request('POST', url);
  if (typeof data === 'function') {
    fn = data;
    data = null;
  }
  if (data) request_.send(data);
  if (fn) request_.end(fn);
  return request_;
};

/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.put = (url, data, fn) => {
  const request_ = request('PUT', url);
  if (typeof data === 'function') {
    fn = data;
    data = null;
  }
  if (data) request_.send(data);
  if (fn) request_.end(fn);
  return request_;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 39745:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__(14224);


const semver = __webpack_require__(47401);

/**
 * Module of mixed-in functions shared between node and client code
 */
const _require = __webpack_require__(73316),
  isObject = _require.isObject,
  hasOwn = _require.hasOwn;

/**
 * Expose `RequestBase`.
 */

module.exports = RequestBase;

/**
 * Initialize a new `RequestBase`.
 *
 * @api public
 */

function RequestBase() {}

/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.clearTimeout = function () {
  clearTimeout(this._timer);
  clearTimeout(this._responseTimeoutTimer);
  clearTimeout(this._uploadTimeoutTimer);
  delete this._timer;
  delete this._responseTimeoutTimer;
  delete this._uploadTimeoutTimer;
  return this;
};

/**
 * Override default response body parser
 *
 * This function will be called to convert incoming data into request.body
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.parse = function (fn) {
  this._parser = fn;
  return this;
};

/**
 * Set format of binary response body.
 * In browser valid formats are 'blob' and 'arraybuffer',
 * which return Blob and ArrayBuffer, respectively.
 *
 * In Node all values result in Buffer.
 *
 * Examples:
 *
 *      req.get('/')
 *        .responseType('blob')
 *        .end(callback);
 *
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.responseType = function (value) {
  this._responseType = value;
  return this;
};

/**
 * Override default request body serializer
 *
 * This function will be called to convert data set via .send or .attach into payload to send
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.serialize = function (fn) {
  this._serializer = fn;
  return this;
};

/**
 * Set timeouts.
 *
 * - response timeout is time between sending request and receiving the first byte of the response. Includes DNS and connection time.
 * - deadline is the time from start of the request to receiving response body in full. If the deadline is too short large files may not load at all on slow connections.
 * - upload is the time  since last bit of data was sent or received. This timeout works only if deadline timeout is off
 *
 * Value of 0 or false means no timeout.
 *
 * @param {Number|Object} ms or {response, deadline}
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.timeout = function (options) {
  if (!options || typeof options !== 'object') {
    this._timeout = options;
    this._responseTimeout = 0;
    this._uploadTimeout = 0;
    return this;
  }
  for (const option in options) {
    if (hasOwn(options, option)) {
      switch (option) {
        case 'deadline':
          this._timeout = options.deadline;
          break;
        case 'response':
          this._responseTimeout = options.response;
          break;
        case 'upload':
          this._uploadTimeout = options.upload;
          break;
        default:
          console.warn('Unknown timeout option', option);
      }
    }
  }
  return this;
};

/**
 * Set number of retry attempts on error.
 *
 * Failed requests will be retried 'count' times if timeout or err.code >= 500.
 *
 * @param {Number} count
 * @param {Function} [fn]
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.retry = function (count, fn) {
  // Default to 1 if no count passed or true
  if (arguments.length === 0 || count === true) count = 1;
  if (count <= 0) count = 0;
  this._maxRetries = count;
  this._retries = 0;
  this._retryCallback = fn;
  return this;
};

//
// NOTE: we do not include ESOCKETTIMEDOUT because that is from `request` package
//       <https://github.com/sindresorhus/got/pull/537>
//
// NOTE: we do not include EADDRINFO because it was removed from libuv in 2014
//       <https://github.com/libuv/libuv/commit/02e1ebd40b807be5af46343ea873331b2ee4e9c1>
//       <https://github.com/request/request/search?q=ESOCKETTIMEDOUT&unscoped_q=ESOCKETTIMEDOUT>
//
//
// TODO: expose these as configurable defaults
//
const ERROR_CODES = new Set(['ETIMEDOUT', 'ECONNRESET', 'EADDRINUSE', 'ECONNREFUSED', 'EPIPE', 'ENOTFOUND', 'ENETUNREACH', 'EAI_AGAIN']);
const STATUS_CODES = new Set([408, 413, 429, 500, 502, 503, 504, 521, 522, 524]);

// TODO: we would need to make this easily configurable before adding it in (e.g. some might want to add POST)
// const METHODS = new Set(['GET', 'PUT', 'HEAD', 'DELETE', 'OPTIONS', 'TRACE']);

/**
 * Determine if a request should be retried.
 * (Inspired by https://github.com/sindresorhus/got#retry)
 *
 * @param {Error} err an error
 * @param {Response} [res] response
 * @returns {Boolean} if segment should be retried
 */
RequestBase.prototype._shouldRetry = function (error, res) {
  if (!this._maxRetries || this._retries++ >= this._maxRetries) {
    return false;
  }
  if (this._retryCallback) {
    try {
      const override = this._retryCallback(error, res);
      if (override === true) return true;
      if (override === false) return false;
      // undefined falls back to defaults
    } catch (err) {
      console.error(err);
    }
  }

  // TODO: we would need to make this easily configurable before adding it in (e.g. some might want to add POST)
  /*
  if (
    this.req &&
    this.req.method &&
    !METHODS.has(this.req.method.toUpperCase())
  )
    return false;
  */
  if (res && res.status && STATUS_CODES.has(res.status)) return true;
  if (error) {
    if (error.code && ERROR_CODES.has(error.code)) return true;
    // Superagent timeout
    if (error.timeout && error.code === 'ECONNABORTED') return true;
    if (error.crossDomain) return true;
  }
  return false;
};

/**
 * Retry request
 *
 * @return {Request} for chaining
 * @api private
 */

RequestBase.prototype._retry = function () {
  this.clearTimeout();

  // node
  if (this.req) {
    this.req = null;
    this.req = this.request();
  }
  this._aborted = false;
  this.timedout = false;
  this.timedoutError = null;
  return this._end();
};

/**
 * Promise support
 *
 * @param {Function} resolve
 * @param {Function} [reject]
 * @return {Request}
 */

RequestBase.prototype.then = function (resolve, reject) {
  if (!this._fullfilledPromise) {
    const self = this;
    if (this._endCalled) {
      console.warn('Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises');
    }
    this._fullfilledPromise = new Promise((resolve, reject) => {
      self.on('abort', () => {
        if (this._maxRetries && this._maxRetries > this._retries) {
          return;
        }
        if (this.timedout && this.timedoutError) {
          reject(this.timedoutError);
          return;
        }
        const error = new Error('Aborted');
        error.code = 'ABORTED';
        error.status = this.status;
        error.method = this.method;
        error.url = this.url;
        reject(error);
      });
      self.end((error, res) => {
        if (error) reject(error);else resolve(res);
      });
    });
  }
  return this._fullfilledPromise.then(resolve, reject);
};
RequestBase.prototype.catch = function (callback) {
  return this.then(undefined, callback);
};

/**
 * Allow for extension
 */

RequestBase.prototype.use = function (fn) {
  fn(this);
  return this;
};
RequestBase.prototype.ok = function (callback) {
  if (typeof callback !== 'function') throw new Error('Callback required');
  this._okCallback = callback;
  return this;
};
RequestBase.prototype._isResponseOK = function (res) {
  if (!res) {
    return false;
  }
  if (this._okCallback) {
    return this._okCallback(res);
  }
  return res.status >= 200 && res.status < 300;
};

/**
 * Get request header `field`.
 * Case-insensitive.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

RequestBase.prototype.get = function (field) {
  return this._header[field.toLowerCase()];
};

/**
 * Get case-insensitive header `field` value.
 * This is a deprecated internal API. Use `.get(field)` instead.
 *
 * (getHeader is no longer used internally by the superagent code base)
 *
 * @param {String} field
 * @return {String}
 * @api private
 * @deprecated
 */

RequestBase.prototype.getHeader = RequestBase.prototype.get;

/**
 * Set header `field` to `val`, or multiple fields with one object.
 * Case-insensitive.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.set = function (field, value) {
  if (isObject(field)) {
    for (const key in field) {
      if (hasOwn(field, key)) this.set(key, field[key]);
    }
    return this;
  }
  this._header[field.toLowerCase()] = value;
  this.header[field] = value;
  return this;
};

/**
 * Remove header `field`.
 * Case-insensitive.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field field name
 */
RequestBase.prototype.unset = function (field) {
  delete this._header[field.toLowerCase()];
  delete this.header[field];
  return this;
};

/**
 * Write the field `name` and `val`, or multiple fields with one object
 * for "multipart/form-data" request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 *
 * request.post('/upload')
 *   .field({ foo: 'bar', baz: 'qux' })
 *   .end(callback);
 * ```
 *
 * @param {String|Object} name name of field
 * @param {String|Blob|File|Buffer|fs.ReadStream} val value of field
 * @param {String} options extra options, e.g. 'blob'
 * @return {Request} for chaining
 * @api public
 */
RequestBase.prototype.field = function (name, value, options) {
  // name should be either a string or an object.
  if (name === null || undefined === name) {
    throw new Error('.field(name, val) name can not be empty');
  }
  if (this._data) {
    throw new Error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
  }
  if (isObject(name)) {
    for (const key in name) {
      if (hasOwn(name, key)) this.field(key, name[key]);
    }
    return this;
  }
  if (Array.isArray(value)) {
    for (const i in value) {
      if (hasOwn(value, i)) this.field(name, value[i]);
    }
    return this;
  }

  // val should be defined now
  if (value === null || undefined === value) {
    throw new Error('.field(name, val) val can not be empty');
  }
  if (typeof value === 'boolean') {
    value = String(value);
  }

  // fix https://github.com/ladjs/superagent/issues/1680
  if (options) this._getFormData().append(name, value, options);else this._getFormData().append(name, value);
  return this;
};

/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request} request
 * @api public
 */
RequestBase.prototype.abort = function () {
  if (this._aborted) {
    return this;
  }
  this._aborted = true;
  if (this.xhr) this.xhr.abort(); // browser
  if (this.req) {
    // Node v13 has major differences in `abort()`
    // https://github.com/nodejs/node/blob/v12.x/lib/internal/streams/end-of-stream.js
    // https://github.com/nodejs/node/blob/v13.x/lib/internal/streams/end-of-stream.js
    // https://github.com/nodejs/node/blob/v14.x/lib/internal/streams/end-of-stream.js
    // (if you run a diff across these you will see the differences)
    //
    // References:
    // <https://github.com/nodejs/node/issues/31630>
    // <https://github.com/ladjs/superagent/pull/1084/commits/dc18679a7c5ccfc6046d882015e5126888973bc8>
    //
    // Thanks to @shadowgate15 and @niftylettuce
    if (semver.gte(process.version, 'v13.0.0') && semver.lt(process.version, 'v14.0.0')) {
      // Note that the reason this doesn't work is because in v13 as compared to v14
      // there is no `callback = nop` set in end-of-stream.js above
      throw new Error('Superagent does not work in v13 properly with abort() due to Node.js core changes');
    } else if (semver.gte(process.version, 'v14.0.0')) {
      // We have to manually set `destroyed` to `true` in order for this to work
      // (see core internals of end-of-stream.js above in v14 branch as compared to v12)
      this.req.destroyed = true;
    }
    this.req.abort(); // node
  }

  this.clearTimeout();
  this.emit('abort');
  return this;
};
RequestBase.prototype._auth = function (user, pass, options, base64Encoder) {
  switch (options.type) {
    case 'basic':
      this.set('Authorization', `Basic ${base64Encoder(`${user}:${pass}`)}`);
      break;
    case 'auto':
      this.username = user;
      this.password = pass;
      break;
    case 'bearer':
      // usage would be .auth(accessToken, { type: 'bearer' })
      this.set('Authorization', `Bearer ${user}`);
      break;
    default:
      break;
  }
  return this;
};

/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 * @param {Boolean} [on=true] - Set 'withCredentials' state
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.withCredentials = function (on) {
  // This is browser-only functionality. Node side is no-op.
  if (on === undefined) on = true;
  this._withCredentials = on;
  return this;
};

/**
 * Set the max redirects to `n`. Does nothing in browser XHR implementation.
 *
 * @param {Number} n
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.redirects = function (n) {
  this._maxRedirects = n;
  return this;
};

/**
 * Maximum size of buffered response body, in bytes. Counts uncompressed size.
 * Default 200MB.
 *
 * @param {Number} n number of bytes
 * @return {Request} for chaining
 */
RequestBase.prototype.maxResponseSize = function (n) {
  if (typeof n !== 'number') {
    throw new TypeError('Invalid argument');
  }
  this._maxResponseSize = n;
  return this;
};

/**
 * Convert to a plain javascript object (not JSON string) of scalar properties.
 * Note as this method is designed to return a useful non-this value,
 * it cannot be chained.
 *
 * @return {Object} describing method, url, and data of this request
 * @api public
 */

RequestBase.prototype.toJSON = function () {
  return {
    method: this.method,
    url: this.url,
    data: this._data,
    headers: this._header
  };
};

/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
 *      request.post('/user')
 *        .send('name=tobi')
 *        .send('species=ferret')
 *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */

// eslint-disable-next-line complexity
RequestBase.prototype.send = function (data) {
  const isObject_ = isObject(data);
  let type = this._header['content-type'];
  if (this._formData) {
    throw new Error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
  }
  if (isObject_ && !this._data) {
    if (Array.isArray(data)) {
      this._data = [];
    } else if (!this._isHost(data)) {
      this._data = {};
    }
  } else if (data && this._data && this._isHost(this._data)) {
    throw new Error("Can't merge these send calls");
  }

  // merge
  if (isObject_ && isObject(this._data)) {
    for (const key in data) {
      if (hasOwn(data, key)) this._data[key] = data[key];
    }
  } else if (typeof data === 'string') {
    // default to x-www-form-urlencoded
    if (!type) this.type('form');
    type = this._header['content-type'];
    if (type) type = type.toLowerCase().trim();
    if (type === 'application/x-www-form-urlencoded') {
      this._data = this._data ? `${this._data}&${data}` : data;
    } else {
      this._data = (this._data || '') + data;
    }
  } else {
    this._data = data;
  }
  if (!isObject_ || this._isHost(data)) {
    return this;
  }

  // default to json
  if (!type) this.type('json');
  return this;
};

/**
 * Sort `querystring` by the sort function
 *
 *
 * Examples:
 *
 *       // default order
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery()
 *         .end(callback)
 *
 *       // customized sort function
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery(function(a, b){
 *           return a.length - b.length;
 *         })
 *         .end(callback)
 *
 *
 * @param {Function} sort
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.sortQuery = function (sort) {
  // _sort default to true but otherwise can be a function or boolean
  this._sort = typeof sort === 'undefined' ? true : sort;
  return this;
};

/**
 * Compose querystring to append to req.url
 *
 * @api private
 */
RequestBase.prototype._finalizeQueryString = function () {
  const query = this._query.join('&');
  if (query) {
    this.url += (this.url.includes('?') ? '&' : '?') + query;
  }
  this._query.length = 0; // Makes the call idempotent

  if (this._sort) {
    const index = this.url.indexOf('?');
    if (index >= 0) {
      const queryArray = this.url.slice(index + 1).split('&');
      if (typeof this._sort === 'function') {
        queryArray.sort(this._sort);
      } else {
        queryArray.sort();
      }
      this.url = this.url.slice(0, index) + '?' + queryArray.join('&');
    }
  }
};

// For backwards compat only
RequestBase.prototype._appendQueryString = () => {
  console.warn('Unsupported');
};

/**
 * Invoke callback with timeout error.
 *
 * @api private
 */

RequestBase.prototype._timeoutError = function (reason, timeout, errno) {
  if (this._aborted) {
    return;
  }
  const error = new Error(`${reason + timeout}ms exceeded`);
  error.timeout = timeout;
  error.code = 'ECONNABORTED';
  error.errno = errno;
  this.timedout = true;
  this.timedoutError = error;
  this.abort();
  this.callback(error);
};
RequestBase.prototype._setTimeouts = function () {
  const self = this;

  // deadline
  if (this._timeout && !this._timer) {
    this._timer = setTimeout(() => {
      self._timeoutError('Timeout of ', self._timeout, 'ETIME');
    }, this._timeout);
  }

  // response timeout
  if (this._responseTimeout && !this._responseTimeoutTimer) {
    this._responseTimeoutTimer = setTimeout(() => {
      self._timeoutError('Response timeout of ', self._responseTimeout, 'ETIMEDOUT');
    }, this._responseTimeout);
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 76031:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/**
 * Module dependencies.
 */

const utils = __webpack_require__(73316);

/**
 * Expose `ResponseBase`.
 */

module.exports = ResponseBase;

/**
 * Initialize a new `ResponseBase`.
 *
 * @api public
 */

function ResponseBase() {}

/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

ResponseBase.prototype.get = function (field) {
  return this.header[field.toLowerCase()];
};

/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */

ResponseBase.prototype._setHeaderProperties = function (header) {
  // TODO: moar!
  // TODO: make this a util

  // content-type
  const ct = header['content-type'] || '';
  this.type = utils.type(ct);

  // params
  const parameters = utils.params(ct);
  for (const key in parameters) {
    if (Object.prototype.hasOwnProperty.call(parameters, key)) this[key] = parameters[key];
  }
  this.links = {};

  // links
  try {
    if (header.link) {
      this.links = utils.parseLinks(header.link);
    }
  } catch (err) {
    // ignore
  }
};

/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */

ResponseBase.prototype._setStatusProperties = function (status) {
  const type = Math.trunc(status / 100);

  // status / class
  this.statusCode = status;
  this.status = this.statusCode;
  this.statusType = type;

  // basics
  this.info = type === 1;
  this.ok = type === 2;
  this.redirect = type === 3;
  this.clientError = type === 4;
  this.serverError = type === 5;
  this.error = type === 4 || type === 5 ? this.toError() : false;

  // sugar
  this.created = status === 201;
  this.accepted = status === 202;
  this.noContent = status === 204;
  this.badRequest = status === 400;
  this.unauthorized = status === 401;
  this.notAcceptable = status === 406;
  this.forbidden = status === 403;
  this.notFound = status === 404;
  this.unprocessableEntity = status === 422;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 73316:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

exports.type = string_ => string_.split(/ *; */).shift();

/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.params = value => {
  const object = {};
  var _iterator = _createForOfIteratorHelper(value.split(/ *; */)),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      const string_ = _step.value;
      const parts = string_.split(/ *= */);
      const key = parts.shift();
      const value = parts.shift();
      if (key && value) object[key] = value;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return object;
};

/**
 * Parse Link header fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.parseLinks = value => {
  const object = {};
  var _iterator2 = _createForOfIteratorHelper(value.split(/ *, */)),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      const string_ = _step2.value;
      const parts = string_.split(/ *; */);
      const url = parts[0].slice(1, -1);
      const rel = parts[1].split(/ *= */)[1].slice(1, -1);
      object[rel] = url;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return object;
};

/**
 * Strip content related fields from `header`.
 *
 * @param {Object} header
 * @return {Object} header
 * @api private
 */

exports.cleanHeader = (header, changesOrigin) => {
  delete header['content-type'];
  delete header['content-length'];
  delete header['transfer-encoding'];
  delete header.host;
  // secuirty
  if (changesOrigin) {
    delete header.authorization;
    delete header.cookie;
  }
  return header;
};

/**
 * Check if `obj` is an object.
 *
 * @param {Object} object
 * @return {Boolean}
 * @api private
 */
exports.isObject = object => {
  return object !== null && typeof object === 'object';
};

/**
 * Object.hasOwn fallback/polyfill.
 *
 * @type {(object: object, property: string) => boolean} object
 * @api private
 */
exports.hasOwn = Object.hasOwn || function (object, property) {
  if (object == null) {
    throw new TypeError('Cannot convert undefined or null to object');
  }
  return Object.prototype.hasOwnProperty.call(new Object(object), property);
};
exports.mixin = (target, source) => {
  for (const key in source) {
    if (exports.hasOwn(source, key)) {
      target[key] = source[key];
    }
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 61603:
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ es)
});

;// CONCATENATED MODULE: ./node_modules/.pnpm/symbol-observable@1.2.0/node_modules/symbol-observable/es/ponyfill.js
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/symbol-observable@1.2.0/node_modules/symbol-observable/es/index.js
/* module decorator */ module = __webpack_require__.hmd(module);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof __webpack_require__.g !== 'undefined') {
  root = __webpack_require__.g;
} else if (true) {
  root = module;
} else {}

var result = symbolObservablePonyfill(root);
/* harmony default export */ const es = (result);


/***/ }),

/***/ 18436:
/***/ ((module) => {

module.exports=/[\0-\x1F\x7F-\x9F]/

/***/ }),

/***/ 74163:
/***/ ((module) => {

module.exports=/[\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/

/***/ }),

/***/ 97942:
/***/ ((module) => {

module.exports=/[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4E\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDC3B\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/

/***/ }),

/***/ 87613:
/***/ ((module) => {

module.exports=/[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/

/***/ }),

/***/ 21977:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


exports.Any = __webpack_require__(50757);
exports.Cc = __webpack_require__(18436);
exports.Cf = __webpack_require__(74163);
exports.P = __webpack_require__(97942);
exports.Z = __webpack_require__(87613);


/***/ }),

/***/ 50757:
/***/ ((module) => {

module.exports=/[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/

/***/ }),

/***/ 30403:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


/**
 * For Node.js, simply re-export the core `util.deprecate` function.
 */

module.exports = __webpack_require__(94823).deprecate;


/***/ }),

/***/ 16180:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 91054:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 53827:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 57002:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 87942:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 82880:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 47401:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 94823:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 47572:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toPropertyKey = __webpack_require__(33587);
function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 3800:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _typeof = (__webpack_require__(45129)["default"]);
function _regeneratorRuntime() {
  "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function value(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 87774:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _typeof = (__webpack_require__(45129)["default"]);
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 33587:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _typeof = (__webpack_require__(45129)["default"]);
var toPrimitive = __webpack_require__(87774);
function _toPropertyKey(arg) {
  var key = toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 45129:
/***/ ((module) => {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 69033:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// TODO(Babel 8): Remove this file.

var runtime = __webpack_require__(3800)();
module.exports = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),

/***/ 25346:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (/* binding */ _arrayLikeToArray)
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

/***/ }),

/***/ 32675:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (/* binding */ _assertThisInitialized)
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/***/ }),

/***/ 39342:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (/* binding */ _asyncToGenerator)
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}

/***/ }),

/***/ 54183:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (/* binding */ _classCallCheck)
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 9924:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (/* binding */ _createClass)
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83524);

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),

/***/ 87807:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (/* binding */ _defineProperty)
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83524);

function _defineProperty(obj, key, value) {
  key = (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),

/***/ 47552:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (/* binding */ _get)
/* harmony export */ });
/* harmony import */ var _superPropBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74533);

function _get() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get.bind();
  } else {
    _get = function _get(target, property, receiver) {
      var base = (0,_superPropBase_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get.apply(this, arguments);
}

/***/ }),

/***/ 42615:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (/* binding */ _getPrototypeOf)
/* harmony export */ });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ 99711:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (/* binding */ _inherits)
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42867);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}

/***/ }),

/***/ 23885:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (/* binding */ _possibleConstructorReturn)
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18790);
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32675);


function _possibleConstructorReturn(self, call) {
  if (call && ((0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(self);
}

/***/ }),

/***/ 42867:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (/* binding */ _setPrototypeOf)
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ 89652:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ _slicedToArray)
});

;// CONCATENATED MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(83169);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || _nonIterableRest();
}

/***/ }),

/***/ 74533:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (/* binding */ _superPropBase)
/* harmony export */ });
/* harmony import */ var _getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42615);

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = (0,_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(object);
    if (object === null) break;
  }
  return object;
}

/***/ }),

/***/ 57031:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ _toConsumableArray)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(25346);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,arrayLikeToArray/* default */.Z)(arr);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(83169);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || _nonIterableSpread();
}

/***/ }),

/***/ 83524:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ _toPropertyKey)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(18790);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function _toPrimitive(input, hint) {
  if ((0,esm_typeof/* default */.Z)(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if ((0,esm_typeof/* default */.Z)(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return (0,esm_typeof/* default */.Z)(key) === "symbol" ? key : String(key);
}

/***/ }),

/***/ 18790:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (/* binding */ _typeof)
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),

/***/ 83169:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (/* binding */ _unsupportedIterableToArray)
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25346);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}

/***/ }),

/***/ 43515:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ _wrapNativeSuper)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(42615);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
var setPrototypeOf = __webpack_require__(42867);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/isNativeFunction.js
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/construct.js


function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) (0,setPrototypeOf/* default */.Z)(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js




function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, (0,getPrototypeOf/* default */.Z)(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return (0,setPrototypeOf/* default */.Z)(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}

/***/ }),

/***/ 83992:
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('{"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"\'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\\"","QUOT":"\\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}');

/***/ }),

/***/ 34705:
/***/ ((module) => {

"use strict";
module.exports = {"version":"6.8.41"};

/***/ }),

/***/ 12208:
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('{"ads":{"adJingleDurationInMilliseconds":1500,"pauseAdRefreshTimeoutInSeconds":30},"algolia":{"id":"NHACVIVXXK","indices":{"default":"rtlde_prod_bedrock_layout_items_v2_rtlde_main","kids":"rtlde_prod_bedrock_layout_items_v2_rtlde_kids"},"key":"5fce02cb376fb2cda773be8a8404598a","platformCode":"ott_boxes"},"analytics":{"attributesKeysMapping":{"googleAnalytics":{"adBlockEnabled":"dimension30","authentified":"dimension5","appVersion":"dimension43","authMethod":"dimension9","boxType":"dimension47","deviceBrand":"dimension38","deviceID":"dimension2","deviceModel":"dimension40","deviceVersion":"dimension44","entityType":"dimension10","GigyaID":"dimension1","IPhash":"dimension3","platformCode":"dimension4","playerActiveAudioLanguage":"dimension18","playerActiveTextLanguage":"dimension19","userAgent":"dimension39","userStatus":"dimension34","dimension73":"dimension73","dimension75":"dimension75"},"newrelic":{"appCustomer":"customer","appPlatform":"platform","deviceBrand":"deviceBrand","deviceModel":"deviceModel","deviceID":"deviceId","userId":"userId","homeId":"homeId","appVersion":"appVersion","project":"project","appTenant":"tenant","appEnv":"env"},"ssaTealiumHttp":{"adBlockEnabled":"ad_blocker","appVersion":"app_version","authMethod":"auth_method","authenticated":"authentified","currentTime":"player_current_timecode","deviceBrand":"box_type","dimension73":"program_customer_key_id","dimension50":"heartbeat_session","dimension75":"clip_customer_key_id","heartbeatSessionId":"heartbeat_session","ga_session_id":"ga_session_id","ga_session_number":"ga_session_number","ga_client_id":"client_id","platformCode":"bedrock_platform_code","support":"support"}},"initParams":{"gemius":{"gemiusAgeBrackets":[],"gemiusParams":[],"gemiusUserMetrics":false,"usePPGemius":false,"useLayout":false,"lang":"fr","i18nNames":{"appDisplayName":"Bedrock"},"globals":{"pp_gemius_identifier":null,"pp_gemius_prefix":null}},"gemiusPlayer":{"id":""},"krxd":{"appId":"","consent":{"al":false,"cd":false,"dc":false,"re":false,"sh":false,"tg":false},"ns":""},"lotame":{"lotameClientId":""},"onesdk":{"appId":""},"snowplow":{"appId":"tv","contexts":{"webPage":true,"session":true,"browser":true,"performanceTiming":true},"platform":"web","plugins":[]},"ssaTealiumHttp":{"account":"bedrock","dataSource":"aclwgy","endpoint":"https://collect.tealiumiq.com/event","env":"prod","httpMethod":"POST","isDeviceBrowser":true,"profile":"rtlde"},"nielsenMediametrie":{"appId":"P2CD70606-29FE-4F0D-8004-5CE1657A3003","instanceName":"ott_boxes","shouldLoadMetadataAfterInterruption":true,"sdkDebugEnabled":false}},"taggingPlans":{"gemiusPlayer":{"autoPlay":{"action":"programstart","category":"player","label":"programstart"},"start":{"action":"start","category":"player","label":"start"},"playVideo":{"action":"play","category":"player","label":"play"},"pauseVideo":{"action":"pause","category":"player","label":"pause"},"pressBackButtonDuringVideo":{"action":"close","category":"player","label":"close"},"buffering":{"action":"buffering","category":"player","label":"buffering"},"seek":{"action":"seek","category":"player","label":"seek"},"complete":{"action":"complete","category":"player","label":"complete"}},"gemius":{"ViewContent":{}},"googleAnalytics":{"appInit":{"category":"Application","label":"AppInit"},"autoPlay":{"action":"start","category":"player","label":"effective"},"autoPlayNextVideo":{"action":"endscreen","category":"player","label":"auto_play"},"audioTrackChanged":{"action":"tracks_modal","category":"player","label":"language_%(language)s"},"backNextVideo":{"action":"endscreen","category":"player","label":"back"},"backward":{"action":"seek","category":"player","label":"backward"},"bookmarksListBack":{"action":"bookmark_list","category":"account","label":"back"},"closeMoreInfo":{"action":"browsing","category":"feature.info_by_program","label":"close_info"},"completion25":{"action":"completion","category":"player","label":"25"},"completion50":{"action":"completion","category":"player","label":"50"},"completion75":{"action":"completion","category":"player","label":"75"},"endscreenDisplayed":{"action":"endscreen","category":"player","label":"displayed"},"forward":{"action":"seek","category":"player","label":"forward"},"language_en":{"action":"tracks_modal","category":"player","label":"language_en"},"language_fr":{"action":"tracks_modal","category":"player","label":"language_fr"},"language_qaa":{"action":"tracks_modal","category":"player","label":"language_qaa"},"language_qad":{"action":"tracks_modal","category":"player","label":"language_qad"},"migrateDeviceID":{"category":"Cookie","label":"NewDeviceID"},"navigationPanelReplay":{"action":"navigation_panel_replay","category":"player","label":"%(clipId)s"},"pairingFail":{"action":"pairing","category":"onboarding","label":"fail"},"pairingSuccess":{"action":"pairing","category":"onboarding","label":"success"},"pauseVideo":{"action":"remote_control","category":"player","label":"pause"},"playNextVideo":{"action":"endscreen","category":"player","label":"manual_play"},"playVideo":{"action":"remote_control","category":"player","label":"play"},"pressAudioSettingsVideo":{"action":"tracks_modal","category":"player","label":"open_tracks_modal"},"pressBackButtonDuringVideo":{"action":"remote_control","category":"player","label":"back"},"prerollBegins":{"action":"advertising","category":"player","label":"preroll"},"midrollBegins":{"action":"advertising","category":"player","label":"midroll"},"postMidroll":{"action":"start","category":"player","label":"post_midroll"},"pressBackButtonDuringPreroll":{"action":"advertising","category":"player","label":"back_preroll"},"pressBackButtonDuringMidroll":{"action":"advertising","category":"player","label":"back_midroll"},"pressBlueButtonLive":{"category":"Startover","label":"Live"},"pressBookmarksButton":{"action":"bookmark","category":"account","label":"explore"},"pressConnectButton":{"action":"pairing","category":"onboarding","label":"login_pairing"},"pressCookieBannerConsentButton":{"action":"cookie","category":"data_collection","label":"consent"},"pressCookieBannerSetupButton":{"action":"cookie","category":"data_collection","label":"setup"},"pressGreenButtonLive":{"category":"Service","label":"Live"},"pressLoginRetryBackButton":{"action":"pairing","category":"onboarding","label":"login_retry"},"pressLogoutButton":{"action":"menu","category":"account","label":"log_out"},"pressMoreInfo":{"action":"browsing","category":"feature.info_by_program","label":"more_info"},"pressParametersButtonMenu":{"category":"Parameters","label":"Interface"},"pressProfileSwitchButton":{"action":"menu","category":"account","label":"profile_switch"},"pressRedButtonLive":{"action":"click","category":"onboarding","label":"live"},"pressRedButtonMenu":{"category":"RedButton","label":"Interface"},"pressRedButtonPopup":{"action":"click","category":"onboarding","label":"pop_up"},"pressRegisterBackButton":{"action":"register","category":"onboarding","label":"back"},"pressServiceButtonMenu":{"category":"Service","label":"Interface"},"pressStartOverVideo":{"action":"control_screen","category":"player","label":"startover"},"pressSynopsis":{"eventName":"player_information"},"pressBackToLiveVideo":{"action":"control_screen","category":"player","label":"back_to_live"},"pressStartoverButtonMenu":{"category":"Startover","label":"Interface"},"pressStartoverButtonPopup":{"category":"Startover","label":"Popup"},"pressSubscribeButton":{"action":"register","category":"onboarding","label":"register_pairing"},"pressSwitchProfileButton":{"action":"menu","category":"account","label":"switch_profile"},"pressTokenBackButton":{"action":"pairing","category":"onboarding","label":"back"},"pressViewRelatedVideo":{"action":"control_player","category":"player","label":"open_recommandation"},"pressYellowButtonLive":{"category":"Parameters","label":"Live"},"replayNextVideo":{"action":"endscreen","category":"player","label":"replay"},"searchInput":{"action":"search","category":"search","label":"%(input)s"},"showApplicationPopup":{"category":"Popup","label":"Application"},"showCookiePreferences":{"category":"CookiesPreferences","label":"CookiesPreferencesScreen"},"showGdprNotice":{"category":"GdprNotice","label":"GdprNoticeScreen"},"showLegalNotice":{"category":"LegalNotice","label":"LegalNoticeScreen"},"showPlayer":{"category":"Player","label":"PlayerScreen"},"showStartoverPopup":{"category":"Popup","label":"Startover"},"skipCredits":{"action":"skip","category":"player","label":"skip_credits"},"skipIntro":{"action":"skip","category":"player","label":"skip_intro"},"smartclipDisplay":{"category":"Campaign","label":"Smartclip"},"storageError":{"category":"Device","label":"StorageSpace"},"storageSupport":{"category":"Device","label":"StorageSupport"},"subtitlesTrackChanged":{"action":"tracks_modal","category":"player","label":"subtitle_%(language)s"}},"krxd":{"bookmarkAdd":{"eventId":"N-2UrtJA","label":"videoWatchListAdd","device":"TV","OS":"%(appPlatform)s","configID":"%(configID)s","profileType_kids":"%(profileType_kids)s","Gender":"%(Gender)s","Birthyear":"%(Birthyear)s","RTL_ID":"%(RTL_ID)s","Video_Genre_1":"%(Video_Genre_1)s","Video_Genre_2":"%(Video_Genre_2)s","Video_Genre_3":"%(Video_Genre_3)s","program_title":"%(program_title)s","video_title":"%(video_title)s","registration_available":"%(registration_available)s","registration_price":"%(registration_price)s","registration_rateplan":"%(registration_rateplan)s","registration_subscription_amount":"%(registration_subscription_amount)s","tier":"%(tier)s","personContactId":"%(personContactId)s","HEM":"%(HEM)s","appname":"%(appname)s","screenview":"%(screenview)s","screentitle":"%(screentitle)s","navigation_1":"%(navigation_1)s","navigation_2":"%(navigation_2)s","category":"%(category)s","visitor_type":"%(visitor_type)s","account_holder":"%(account_holder)s","platform_code":"%(platform_code)s","key":"%(key)s"},"bookmarkRemove":{"eventId":"N-2ViIZm","label":"videoWatchListRemove","device":"TV","OS":"%(appPlatform)s","configID":"%(configID)s","profileType_kids":"%(profileType_kids)s","Gender":"%(Gender)s","Birthyear":"%(Birthyear)s","RTL_ID":"%(RTL_ID)s","Video_Genre_1":"%(Video_Genre_1)s","Video_Genre_2":"%(Video_Genre_2)s","Video_Genre_3":"%(Video_Genre_3)s","program_title":"%(program_title)s","video_title":"%(video_title)s","registration_available":"%(registration_available)s","registration_price":"%(registration_price)s","registration_rateplan":"%(registration_rateplan)s","registration_subscription_amount":"%(registration_subscription_amount)s","tier":"%(tier)s","personContactId":"%(personContactId)s","HEM":"%(HEM)s","appname":"%(appname)s","screenview":"%(screenview)s","screentitle":"%(screentitle)s","navigation_1":"%(navigation_1)s","navigation_2":"%(navigation_2)s","category":"%(category)s","visitor_type":"%(visitor_type)s","account_holder":"%(account_holder)s","platform_code":"%(platform_code)s","key":"%(key)s"}},"ssaTealiumHttp":{"bookmark":{"content_name":"%(eventLabel)s","eventName":"block_bookmark"},"folder":{"eventName":"block_page_folders","service":"%(eventLabel)s"},"gdprAccept":{"consent_name":"%(consentNames)s","eventName":"gdpr_accept"},"gdprChangeConsents":{"consent_name":"%(consentNames)s","eventName":"gdpr_change_consent"},"gdprRefuse":{"eventName":"gdpr_refusal"},"gdprSetup":{"eventName":"gdpr_setup"},"menu":{"content_type":"%(eventLabel)s","eventName":"entry_nav_bar"},"menu_account":{"content_type":"%(eventLabel)s","eventName":"entry_nav_bar"},"menu_channel":{"content_type":"%(eventLabel)s","eventName":"select_channel_folder"},"pressMoreInfo":{"eventName":"block_program_info"},"program":{"content_name":"%(eventLabel)s","eventName":"block_page_program"},"searchInput":{"eventName":"search_bar","search_result_number":"%(results)s","search_term":"%(input)s"},"searchResult":{"content_id":"%(id)s","content_name":"%(name)s","eventName":"search_result_clicked","search_term":"%(input)s"},"service":{"eventName":"block_page_services","service":"%(eventLabel)s"},"showStartoverPopup":{"category":"Popup","label":"Startover"},"unbookmark":{"content_name":"%(eventLabel)s","eventName":"block_unbookmark"},"epgDateSelect":{"eventName":"epg_date_select","label":"%(date)s"},"epgModalOpen":{"eventName":"epg_modal_open","label":"%(date)s"},"epgModalClose":{"eventName":"epg_modal_close","label":"%(date)s"},"autoPlayNextVideo":{"eventName":"player_next_video","player_control_system":"remote"},"backNextVideo":{"eventName":"player_endscreen_back","player_control_system":"remote"},"backward":{"direction":"backward","eventName":"player_seek","player_control_system":"remote"},"closeSideGlass":{"eventName":"player_sideglass_close","player_control_system":"remote"},"completion100":{"duration":"100","eventName":"player_completion_100","player_control_system":"remote"},"completion25":{"duration":"25","eventName":"player_completion_25","player_control_system":"remote"},"completion50":{"duration":"50","eventName":"player_completion_50","player_control_system":"remote"},"completion75":{"duration":"75","eventName":"player_completion_75","player_control_system":"remote"},"forward":{"direction":"forward","eventName":"player_seek","player_control_system":"remote"},"midrollBegins":{"eventName":"ad_midroll_start","player_control_system":"remote"},"openSideGlass":{"eventName":"player_sideglass_open","player_control_system":"remote"},"pauseVideo":{"duration":"%(duration)s","eventName":"player_pause","player_control_system":"remote"},"playbackStarted":{"eventName":"player_play_effective","player_control_system":"remote"},"playNextVideo":{"eventName":"player_next_video","player_control_system":"remote"},"playVideo":{"eventName":"player_play","player_control_system":"remote"},"prerollBegins":{"eventName":"ad_preroll_start","player_control_system":"remote"},"postMidroll":{"eventName":"ad_midroll_end","player_control_system":"remote"},"postPreroll":{"eventName":"ad_preroll_end","player_control_system":"remote"},"playerTracksPanelClose":{"eventName":"player_modal_close","player_control_system":"remote","player_type":"subtitle"},"playerTracksPanelOpen":{"eventName":"player_modal_open","player_control_system":"remote","player_type":"subtitle"},"pressBackButtonDuringMidroll":{"break_type":"midroll","eventName":"ad_break_back","player_control_system":"remote"},"pressBackButtonDuringPreroll":{"break_type":"preroll","eventName":"ad_break_back","player_control_system":"remote"},"pressBackButtonDuringVideo":{"eventName":"player_back","player_control_system":"remote"},"pressBackToLiveVideo":{"eventName":"player_backtolive","player_control_system":"remote"},"pressStartOverLive":{"eventName":"player_startover_live","player_control_system":"remote"},"pressSynopsis":{"eventName":"player_information","player_control_system":"remote"},"replayNextVideo":{"eventName":"player_endscreen_replay","player_control_system":"remote"},"skipCredits":{"eventName":"player_ignore_credit","player_control_system":"remote"},"skipIntro":{"eventName":"player_ignore_introduction","player_control_system":"remote"},"skipRecap":{"eventName":"player_ignore_recap","player_control_system":"remote"},"skipToNextVideo":{"eventName":"player_next_video","player_control_system":"remote"}}},"engines":["ssaTealiumHttp","nielsenMediametrie"]},"assetsBundle":{"bundleBaseUrl":"https://assets-bundle.rtlde.bedrock.tech","bundleVersion":9},"bannedFeatures":[],"cta":{"supportedActions":["bookmark","account_bookmarks","unbookmark","live","lives","program","video","service","alias","services","account","search","settings","account_settings","tos","termsofsubscription","account_legalconditions","folders","folder","account_informations","close","consentsmanagement_device","privacy_policy","account_confidentiality","lock","logout","frontspace","help","feedback","profilesgate","play"]},"customizer":"https://customizer.rtlde.bedrock.tech/v2/platforms/%(platform)s/users/%(uid)s/apps/%(app)s/versions/%(version)s","debug":false,"featureFlipping":{"adFeature":true,"animateFeature":true,"bookmarksFeature":true,"broadcastLiveFeature":true,"browsingByChannelFeature":true,"checkGeoFeature":true,"concurrentStreamFeature":true,"contentAdvisorFeature":true,"customizerFeature":true,"displayLostConnectionFeature":true,"endingCreditsFeature":true,"freemiumFeature":true,"gaFeature":true,"gdprNoticeFeature":true,"heartbeatFeature":true,"homeLiveFeature":true,"kidsScreensaverFeature":true,"kidsSectionFeature":true,"kidsSectionLeaveFeature":true,"leftCornerFocus":false,"liveSeekFeature":false,"liveSuppressionOnEPGFeature":false,"menuFeature":true,"menuPopupFeature":true,"monitoringFeature":true,"multiAudioFeature":true,"multiProfilesGateAlwaysDisplayed":true,"multiSubtitlesFeature":true,"multiprofile":true,"newRelicFeature":true,"nextVideoFeature":true,"openCatalogFeature":true,"openCreditsFeature":true,"pairingFeature":true,"parentalFilterFeature":true,"player_adFeature":true,"player_adLazyVmap":true,"player_adsCount":true,"player_analyticsFeature":true,"player_jingleFeature":true,"player_lBanner":true,"player_longSeek":true,"player_nextVideoFeature":true,"player_pauseAd":false,"player_relatedVideosFeature":true,"player_returnFeature":true,"player_startOverFeature":true,"player_thirdPartiesFeature":true,"player_timeShiftingFeature":true,"player_trackPreferencesFeature":false,"player_trailer":false,"player_trailer_sound":false,"premiumFeature":true,"privilegeNavigationFeature":true,"profileFeature":true,"promptBeforeExitFeature":true,"screensaverFeature":true,"searchFeature":true,"servicePageFeature":true,"sideGlassRecomendationsFeature":true,"singleModeAdFeature":true,"smartclipFeature":true,"splashScreenFeature":true,"startoverFeature":true,"startoverPopupFeature":true,"storyboardFeature":true,"topMenuFeature":true,"upsellFlow":true,"userApiFeature":true,"watchAgainFeature":true,"youboraAdsAdapter":false},"fido":{"applaunch":{"maxAge":60,"timeout":5000,"version":"1.0.0"},"baseUrlsByAPIType":{"applaunch":"https://d16w83149ahatb.6cloud.fr","auth":"https://front-auth.rtlde.bedrock.tech/v2","drm":"https://drm.rtlde.bedrock.tech/v1","geo":"https://geo.rtlde.bedrock.tech/v1","heartbeatv2":"https://heartbeat-v2.rtlde.bedrock.tech/v2","heartbeatv3":"https://heartbeat-v3.rtlde.bedrock.tech/v3","image":"https://images-fio.rtlde.bedrock.tech/v2","layout":"https://layout.rtlde.bedrock.tech/front/v1","linkConverter":"https://link-converter.rtlde.bedrock.tech","middlewarev2":"https://hbbtv.middleware.rtlde.bedrock.tech/6play/v2","stores":"https://stores.rtlde.bedrock.tech/premium/v4","time":"https://time.rtlde.bedrock.tech","userv2":"https://users.rtlde.bedrock.tech/v2","userv3":"https://users.rtlde.bedrock.tech/v3","userv4":"https://users.rtlde.bedrock.tech/v4"},"layoutService":{"capacityToken":"token-ott-boxes-1"},"imageSalt":"x9vGg4RNeNBqV2nBfhqLV6cN4n","saltAndSugar":"f57894679724c3ee04083f2e38707653667e61e1","serviceImageUrl":"https://images-fio.rtlde.bedrock.tech/v2/images/%(id)d/raw"},"gdpr":{"gdprNoticeDuration":20000},"i18nNames":{"appDisplayName":"RTLDE"},"heartbeat":{"heartbeatInterval":240000},"monitoring":{"pattern":{"increment":"https://mon.m6web.fr/statsd/%(node)s/increment?token=%(token)s","timer":"https://mon.m6web.fr/statsd/%(node)s/timer/%(time)d?token=%(token)s"},"prefix":"m6web.hbbtv.client","salt":"e56f5a32a32a65232"},"newRelic":{"applicationID":null},"oidc":{"baseUrl":"https://auth.rtl.de/auth/realms/rtlplus/protocol/openid-connect","clientId":"bedrock-ott-vodafone","clientSecret":"4bfeb73f-1c4a-4e9f-a7fa-96aa1ad3d94c","customApi":"https://auth.rtl.de/auth/realms/rtlplus/api","endpoints":{"AUTHORIZATION":"auth","CUSTOM_LOGOUT":"custom-logout","DEVICE_AUTHORIZATION":"auth/device","LOGOUT":"logout","REVOCATION":"revoke","TOKEN":"token","USERINFO":"userinfo"},"ssiApi":null},"pairing":{"pairingPollInterval":6000,"pairingTimeout":300000,"upsellURL":"https://my.plus.rtl.de/buchen/initial/v1","ssiURL":"","subscriptionURL":"https://my.plus.rtl.de/buchen"},"parentalCode":{"length":4,"reinitializedCodeTimeout":2500},"qrCode":{"links":{"account_settings":{"short":"https://bit.ly/4hHSa8Z","long":"https://rtlplus-front.rtlde.bedrock.tech/mein-konto/tv-synchronisierung?platformCode=ott_boxes"},"faq":{"short":"https://bit.ly/4bhC7xm","long":"https://community.plus.rtl.de/s/hilfecenter?platformCode=ott_boxes"},"feedback":{"short":"https://bit.ly/43ba0xv","long":"http://rtlplus.com/austausch?platformCode=ott_boxes"},"information":{"short":"https://bit.ly/43Fny4H","long":"https://my.plus.rtl.de/account?platformCode=ott_boxes"}}},"skeleton":{"patterns":[{"path":"app/alias/home","preset":"generic"},{"path":"app/service/.*","preset":"generic"}]},"staticFiles":{"base":"https://static-content.rtlde.bedrock.tech","files":{"termsOfUsage":"5/67cafaa27e803.md","legalConditions":"4/67cafa871d686.md","privacyPolicy":"2/6776ac5eac22f.md"}},"startover":{"startoverJingleDuration":1000,"startoverMaxDepth":60,"startoverMaxPercentage":90,"startoverMinDepth":10,"startoverMinPercentage":10},"thirdParties":{"engines":[]},"video":{"programParams":{"with":"links,subcats,rights"},"drm":{"com.microsoft.playready":{"serverURL":"https://lic.drmtoday.com/license-proxy-headerauth/drmtoday/RightsManager.asmx"},"com.widevine.alpha":{"serverURL":"https://lic.drmtoday.com/license-proxy-widevine/cenc/"},"merchantId":"m6","sessionId":"6play"}},"youbora":{"accountCode":"m6"},"clientCode":"local_stb","country":"nl","customerCode":"rtlde","defaultService":"rtlde","gdprCookies":["audienceMeasurement","personalization","targetedAdvertising"],"language":"de","platformCode":"ott_boxes","tenant":"rtlde","app":"rtlde-vodafone"}');

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/amd options */
/******/ 	(() => {
/******/ 		__webpack_require__.amdO = {};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/create fake namespace object */
/******/ 	(() => {
/******/ 		var getProto = Object.getPrototypeOf ? (obj) => (Object.getPrototypeOf(obj)) : (obj) => (obj.__proto__);
/******/ 		var leafPrototypes;
/******/ 		// create a fake namespace object
/******/ 		// mode & 1: value is a module id, require it
/******/ 		// mode & 2: merge all properties of value into the ns
/******/ 		// mode & 4: return value when already ns object
/******/ 		// mode & 16: return value when it's Promise-like
/******/ 		// mode & 8|1: behave like require
/******/ 		__webpack_require__.t = function(value, mode) {
/******/ 			if(mode & 1) value = this(value);
/******/ 			if(mode & 8) return value;
/******/ 			if(typeof value === 'object' && value) {
/******/ 				if((mode & 4) && value.__esModule) return value;
/******/ 				if((mode & 16) && typeof value.then === 'function') return value;
/******/ 			}
/******/ 			var ns = Object.create(null);
/******/ 			__webpack_require__.r(ns);
/******/ 			var def = {};
/******/ 			leafPrototypes = leafPrototypes || [null, getProto({}), getProto([]), getProto(getProto)];
/******/ 			for(var current = mode & 2 && value; typeof current == 'object' && !~leafPrototypes.indexOf(current); current = getProto(current)) {
/******/ 				Object.getOwnPropertyNames(current).forEach((key) => (def[key] = () => (value[key])));
/******/ 			}
/******/ 			def['default'] = () => (value);
/******/ 			__webpack_require__.d(ns, def);
/******/ 			return ns;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/ensure chunk */
/******/ 	(() => {
/******/ 		__webpack_require__.f = {};
/******/ 		// This file contains only the entry chunk.
/******/ 		// The chunk loading function for additional chunks
/******/ 		__webpack_require__.e = (chunkId) => {
/******/ 			return Promise.all(Object.keys(__webpack_require__.f).reduce((promises, key) => {
/******/ 				__webpack_require__.f[key](chunkId, promises);
/******/ 				return promises;
/******/ 			}, []));
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/get javascript chunk filename */
/******/ 	(() => {
/******/ 		// This function allow to reference async chunks
/******/ 		__webpack_require__.u = (chunkId) => {
/******/ 			// return url for filenames based on template
/******/ 			return "static/js/" + chunkId + "." + {"51":"9d380aaa","77":"63240252","98":"f0c7ebc6","103":"f929fc3a","128":"be58cee6","132":"4b10112e","140":"188149a0","168":"bacccf5a","241":"6e320750","254":"f1dd1239","260":"4bb76822","421":"5144291e","425":"9e287d0b","473":"91206a06","489":"6349992a","520":"a85ebfe8","537":"c7a35dcc","767":"ed6eb777","806":"4c0c7d09","853":"b135ab15","927":"b025875d","992":"411366df"}[chunkId] + ".js";
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/harmony module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.hmd = (module) => {
/******/ 			module = Object.create(module);
/******/ 			if (!module.children) module.children = [];
/******/ 			Object.defineProperty(module, 'exports', {
/******/ 				enumerable: true,
/******/ 				set: () => {
/******/ 					throw new Error('ES Modules may not assign module.exports or exports.*, Use ESM export syntax, instead: ' + module.id);
/******/ 				}
/******/ 			});
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/load script */
/******/ 	(() => {
/******/ 		var inProgress = {};
/******/ 		var dataWebpackPrefix = "app-bedrock-rdk:";
/******/ 		// loadScript function to load a script via script tag
/******/ 		__webpack_require__.l = (url, done, key, chunkId) => {
/******/ 			if(inProgress[url]) { inProgress[url].push(done); return; }
/******/ 			var script, needAttach;
/******/ 			if(key !== undefined) {
/******/ 				var scripts = document.getElementsByTagName("script");
/******/ 				for(var i = 0; i < scripts.length; i++) {
/******/ 					var s = scripts[i];
/******/ 					if(s.getAttribute("src") == url || s.getAttribute("data-webpack") == dataWebpackPrefix + key) { script = s; break; }
/******/ 				}
/******/ 			}
/******/ 			if(!script) {
/******/ 				needAttach = true;
/******/ 				script = document.createElement('script');
/******/ 		
/******/ 				script.charset = 'utf-8';
/******/ 				script.timeout = 120;
/******/ 				if (__webpack_require__.nc) {
/******/ 					script.setAttribute("nonce", __webpack_require__.nc);
/******/ 				}
/******/ 				script.setAttribute("data-webpack", dataWebpackPrefix + key);
/******/ 		
/******/ 				script.src = url;
/******/ 			}
/******/ 			inProgress[url] = [done];
/******/ 			var onScriptComplete = (prev, event) => {
/******/ 				// avoid mem leaks in IE.
/******/ 				script.onerror = script.onload = null;
/******/ 				clearTimeout(timeout);
/******/ 				var doneFns = inProgress[url];
/******/ 				delete inProgress[url];
/******/ 				script.parentNode && script.parentNode.removeChild(script);
/******/ 				doneFns && doneFns.forEach((fn) => (fn(event)));
/******/ 				if(prev) return prev(event);
/******/ 			}
/******/ 			var timeout = setTimeout(onScriptComplete.bind(null, undefined, { type: 'timeout', target: script }), 120000);
/******/ 			script.onerror = onScriptComplete.bind(null, script.onerror);
/******/ 			script.onload = onScriptComplete.bind(null, script.onload);
/******/ 			needAttach && document.head.appendChild(script);
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__webpack_require__.p = "/";
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			179: 0
/******/ 		};
/******/ 		
/******/ 		__webpack_require__.f.j = (chunkId, promises) => {
/******/ 				// JSONP chunk loading for javascript
/******/ 				var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
/******/ 				if(installedChunkData !== 0) { // 0 means "already installed".
/******/ 		
/******/ 					// a Promise means "currently loading".
/******/ 					if(installedChunkData) {
/******/ 						promises.push(installedChunkData[2]);
/******/ 					} else {
/******/ 						if(true) { // all chunks have JS
/******/ 							// setup Promise in chunk cache
/******/ 							var promise = new Promise((resolve, reject) => (installedChunkData = installedChunks[chunkId] = [resolve, reject]));
/******/ 							promises.push(installedChunkData[2] = promise);
/******/ 		
/******/ 							// start chunk loading
/******/ 							var url = __webpack_require__.p + __webpack_require__.u(chunkId);
/******/ 							// create error before stack unwound to get useful stacktrace later
/******/ 							var error = new Error();
/******/ 							var loadingEnded = (event) => {
/******/ 								if(__webpack_require__.o(installedChunks, chunkId)) {
/******/ 									installedChunkData = installedChunks[chunkId];
/******/ 									if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
/******/ 									if(installedChunkData) {
/******/ 										var errorType = event && (event.type === 'load' ? 'missing' : event.type);
/******/ 										var realSrc = event && event.target && event.target.src;
/******/ 										error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
/******/ 										error.name = 'ChunkLoadError';
/******/ 										error.type = errorType;
/******/ 										error.request = realSrc;
/******/ 										installedChunkData[1](error);
/******/ 									}
/******/ 								}
/******/ 							};
/******/ 							__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
/******/ 						}
/******/ 					}
/******/ 				}
/******/ 		};
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		// no on chunks loaded
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 		
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkapp_bedrock_rdk"] = self["webpackChunkapp_bedrock_rdk"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";

// NAMESPACE OBJECT: ./packages/tornado-rdk/typography/src/fonts/RTLUnited/RTLUnited.descriptors.js
var RTLUnited_descriptors_namespaceObject = {};
__webpack_require__.r(RTLUnited_descriptors_namespaceObject);
__webpack_require__.d(RTLUnited_descriptors_namespaceObject, {
  descriptors: () => (descriptors),
  fontFamily: () => (fontFamily),
  fontWeightMap: () => (fontWeightMap)
});

// NAMESPACE OBJECT: ./node_modules/.pnpm/@bedrock+media-engine@4.13.0/node_modules/@bedrock/media-engine/lib/const/video.events.js
var video_events_namespaceObject = {};
__webpack_require__.r(video_events_namespaceObject);
__webpack_require__.d(video_events_namespaceObject, {
  ABORT: () => (ABORT),
  CAN_PLAY: () => (CAN_PLAY),
  CAN_PLAY_THROUGH: () => (CAN_PLAY_THROUGH),
  DURATION_CHANGE: () => (DURATION_CHANGE),
  EMPTIED: () => (EMPTIED),
  ENCRYPTED: () => (ENCRYPTED),
  ENDED: () => (ENDED),
  ERROR: () => (ERROR),
  FALLBACK_QUALITY: () => (FALLBACK_QUALITY),
  FALLBACK_SOURCE: () => (FALLBACK_SOURCE),
  FRAGMENT_CHANGED: () => (FRAGMENT_CHANGED),
  FRAGMENT_RETRY: () => (FRAGMENT_RETRY),
  FRAGMENT_RETRY_FAILED: () => (FRAGMENT_RETRY_FAILED),
  FRAGMENT_RETRY_SUCCESS: () => (FRAGMENT_RETRY_SUCCESS),
  LOADED_DATA: () => (LOADED_DATA),
  LOADED_DRM_LICENSE_DATA: () => (LOADED_DRM_LICENSE_DATA),
  LOADED_METADATA: () => (LOADED_METADATA),
  LOAD_START: () => (LOAD_START),
  PAUSE: () => (PAUSE),
  PLAY: () => (video_events_PLAY),
  PLAYING: () => (PLAYING),
  PREFERRED_QUALITY_CHANGE: () => (PREFERRED_QUALITY_CHANGE),
  PROGRESS: () => (PROGRESS),
  QUALITY_CHANGE: () => (QUALITY_CHANGE),
  RATE_CHANGE: () => (RATE_CHANGE),
  RECOVER_FAULTY_SEGMENT: () => (RECOVER_FAULTY_SEGMENT),
  RETRY: () => (RETRY),
  RETRY_FAILED: () => (RETRY_FAILED),
  RETRY_SUCCESS: () => (RETRY_SUCCESS),
  SCTE: () => (SCTE),
  SEEKED: () => (SEEKED),
  SEEKING: () => (SEEKING),
  STALLED: () => (STALLED),
  SUSPEND: () => (SUSPEND),
  TIMED_METADATA: () => (TIMED_METADATA),
  TIME_UPDATE: () => (TIME_UPDATE),
  TRACKS_CHANGE: () => (TRACKS_CHANGE),
  VOLUME_CHANGE: () => (VOLUME_CHANGE),
  WAITING: () => (WAITING)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__(96317);
// EXTERNAL MODULE: ./node_modules/.pnpm/regenerator-runtime@0.13.11/node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__(90250);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(39342);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(69033);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(26677);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.promise.all-settled.js
var es_promise_all_settled = __webpack_require__(3009);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(33414);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(65000);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(89652);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/lodash.js
var lodash = __webpack_require__(32699);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
;// CONCATENATED MODULE: ./packages/pelo-plugins/device/src/platform/vodafone/device.js



var getDeviceId = function () {
  var _ref = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee() {
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          return _context.abrupt("return", window.oipfObjectFactory.createConfigurationObject().localSystem.deviceID || '');
        case 4:
          _context.prev = 4;
          _context.t0 = _context["catch"](0);
          return _context.abrupt("return", '');
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 4]]);
  }));
  return function getDeviceId() {
    return _ref.apply(this, arguments);
  };
}();
var getVersion = function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2() {
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          return _context2.abrupt("return", window.oipfObjectFactory.createConfigurationObject().localSystem.softwareVersion || '');
        case 4:
          _context2.prev = 4;
          _context2.t0 = _context2["catch"](0);
          return _context2.abrupt("return", '');
        case 7:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 4]]);
  }));
  return function getVersion() {
    return _ref2.apply(this, arguments);
  };
}();
var getModel = function () {
  var _ref3 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee3() {
    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          return _context3.abrupt("return", window.oipfObjectFactory.createConfigurationObject().localSystem.modelName || '');
        case 4:
          _context3.prev = 4;
          _context3.t0 = _context3["catch"](0);
          return _context3.abrupt("return", '');
        case 7:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 4]]);
  }));
  return function getModel() {
    return _ref3.apply(this, arguments);
  };
}();
var getBrand = function () {
  var _ref4 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee4() {
    return regenerator_default().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          return _context4.abrupt("return", 'vodafone');
        case 1:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function getBrand() {
    return _ref4.apply(this, arguments);
  };
}();
var getDeviceType = function () {
  var _ref5 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee5() {
    return regenerator_default().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          return _context5.abrupt("return", '');
        case 1:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function getDeviceType() {
    return _ref5.apply(this, arguments);
  };
}();
var getModelCode = function () {
  var _ref6 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee6() {
    return regenerator_default().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          return _context6.abrupt("return", '');
        case 1:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return function getModelCode() {
    return _ref6.apply(this, arguments);
  };
}();
;// CONCATENATED MODULE: ./packages/pelo-plugins/device/index.js













var getAllDeviceInfo = function () {
  var _ref = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee() {
    var _yield$Promise$allSet, _yield$Promise$allSet2, brand, deviceId, deviceType, model, modelCode, version;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return Promise.allSettled([getBrand(), getDeviceId(), getDeviceType(), getModel(), getModelCode(), getVersion()]);
        case 2:
          _yield$Promise$allSet = _context.sent;
          _yield$Promise$allSet2 = (0,slicedToArray/* default */.Z)(_yield$Promise$allSet, 6);
          brand = _yield$Promise$allSet2[0];
          deviceId = _yield$Promise$allSet2[1];
          deviceType = _yield$Promise$allSet2[2];
          model = _yield$Promise$allSet2[3];
          modelCode = _yield$Promise$allSet2[4];
          version = _yield$Promise$allSet2[5];
          return _context.abrupt("return", lodash_default().mapValues({
            brand: brand,
            deviceId: deviceId,
            deviceType: deviceType,
            model: model,
            modelCode: modelCode,
            version: version
          }, function (promiseSettledValue, key) {
            if (promiseSettledValue.status === 'fulfilled') {
              return promiseSettledValue.value;
            }
            console.warn("Getting ".concat(key, " failed"), promiseSettledValue.reason);
            return '';
          }));
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getAllDeviceInfo() {
    return _ref.apply(this, arguments);
  };
}();
var deviceInfo = {
  getBrand: getBrand,
  getDeviceId: getDeviceId,
  getDeviceType: getDeviceType,
  getModel: getModel,
  getModelCode: getModelCode,
  getVersion: getVersion,
  getAllDeviceInfo: getAllDeviceInfo
};
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__(34479);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(97343);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(65759);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__(75287);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(28610);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(50851);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__(8612);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/web.url.js
var web_url = __webpack_require__(87767);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(87807);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/merge.js
var merge = __webpack_require__(67929);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/memoize.js
var memoize = __webpack_require__(34736);
var memoize_default = /*#__PURE__*/__webpack_require__.n(memoize);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(62975);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__(96573);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.array.splice.js
var es_array_splice = __webpack_require__(72578);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.object.get-own-property-names.js
var es_object_get_own_property_names = __webpack_require__(13714);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__(74389);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__(90565);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(18790);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Settings/index.js








function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var settings = {};
var subscribers = {};
var initSettings = function initSettings(appSettings, platformSettings) {
  settings['app'] = appSettings;
  settings['platform'] = platformSettings;
  settings['user'] = {};
};
var publish = function publish(key, value) {
  subscribers[key] && subscribers[key].forEach(function (subscriber) {
    return subscriber(value);
  });
};
var dotGrab = function dotGrab() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var key = arguments.length > 1 ? arguments[1] : undefined;
  if (obj === null) return undefined;
  var keys = key.split('.');
  for (var i = 0; i < keys.length; i++) {
    obj = obj[keys[i]] = obj[keys[i]] !== undefined ? obj[keys[i]] : {};
  }
  return (0,esm_typeof/* default */.Z)(obj) === 'object' && obj !== null ? Object.keys(obj).length ? obj : undefined : obj;
};
/* harmony default export */ const src_Settings = ({
  get: function get(type, key) {
    var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    var val = dotGrab(settings[type], key);
    return val !== undefined ? val : fallback;
  },
  has: function has(type, key) {
    return !!this.get(type, key);
  },
  set: function set(key, value) {
    settings['user'][key] = value;
    publish(key, value);
  },
  subscribe: function subscribe(key, callback) {
    subscribers[key] = subscribers[key] || [];
    subscribers[key].push(callback);
  },
  unsubscribe: function unsubscribe(key, callback) {
    if (callback) {
      var index = subscribers[key] && subscribers[key].findIndex(function (cb) {
        return cb === callback;
      });
      index > -1 && subscribers[key].splice(index, 1);
    } else {
      if (key in subscribers) {
        subscribers[key] = [];
      }
    }
  },
  clearSubscribers: function clearSubscribers() {
    var _iterator = _createForOfIteratorHelper(Object.getOwnPropertyNames(subscribers)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var key = _step.value;
        delete subscribers[key];
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Log/index.js



var prepLog = function prepLog(type, args) {
  var colors = {
    Info: 'green',
    Debug: 'gray',
    Warn: 'orange',
    Error: 'red'
  };
  args = Array.from(args);
  return ['%c' + (args.length > 1 && typeof args[0] === 'string' ? args.shift() : type), 'background-color: ' + colors[type] + '; color: white; padding: 2px 4px; border-radius: 2px', args];
};
/* harmony default export */ const Log = ({
  info: function info() {
    src_Settings.get('platform', 'log') && console.log.apply(console, prepLog('Info', arguments));
  },
  debug: function debug() {
    src_Settings.get('platform', 'log') && console.debug.apply(console, prepLog('Debug', arguments));
  },
  error: function error() {
    src_Settings.get('platform', 'log') && console.error.apply(console, prepLog('Error', arguments));
  },
  warn: function warn() {
    src_Settings.get('platform', 'log') && console.warn.apply(console, prepLog('Warn', arguments));
  }
});
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(29548);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(9924);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(54183);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(99711);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(23885);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(42615);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/get.js
var esm_get = __webpack_require__(47552);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(59724);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(53252);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__(30382);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.map.js
var es_map = __webpack_require__(90398);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.set.js
var es_set = __webpack_require__(50823);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(57031);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__(30415);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__(8032);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.string.starts-with.js
var es_string_starts_with = __webpack_require__(97072);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(32675);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(77402);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.number.to-fixed.js
var es_number_to_fixed = __webpack_require__(33807);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/tree/StageUtils.mjs





var StageUtils = function () {
  function StageUtils() {
    (0,classCallCheck/* default */.Z)(this, StageUtils);
  }
  (0,createClass/* default */.Z)(StageUtils, null, [{
    key: "mergeNumbers",
    value: function mergeNumbers(v1, v2, p) {
      return v1 * p + v2 * (1 - p);
    }
  }, {
    key: "rgb",
    value: function rgb(r, g, b) {
      return (r << 16) + (g << 8) + b + 255 * 16777216;
    }
  }, {
    key: "rgba",
    value: function rgba(r, g, b, a) {
      return (r << 16) + (g << 8) + b + (a * 255 | 0) * 16777216;
    }
  }, {
    key: "getRgbString",
    value: function getRgbString(color) {
      var r = (color / 65536 | 0) % 256;
      var g = (color / 256 | 0) % 256;
      var b = color % 256;
      return 'rgb(' + r + ',' + g + ',' + b + ')';
    }
  }, {
    key: "getRgbaString",
    value: function getRgbaString(color) {
      var r = (color / 65536 | 0) % 256;
      var g = (color / 256 | 0) % 256;
      var b = color % 256;
      var a = (color / 16777216 | 0) / 255;
      return 'rgba(' + r + ',' + g + ',' + b + ',' + a.toFixed(4) + ')';
    }
  }, {
    key: "getRgbaStringFromArray",
    value: function getRgbaStringFromArray(color) {
      var r = Math.floor(color[0] * 255);
      var g = Math.floor(color[1] * 255);
      var b = Math.floor(color[2] * 255);
      var a = Math.floor(color[3] * 255) / 255;
      return 'rgba(' + r + ',' + g + ',' + b + ',' + a.toFixed(4) + ')';
    }
  }, {
    key: "getRgbaComponentsNormalized",
    value: function getRgbaComponentsNormalized(argb) {
      var r = (argb / 65536 | 0) % 256;
      var g = (argb / 256 | 0) % 256;
      var b = argb % 256;
      var a = argb / 16777216 | 0;
      return [r / 255, g / 255, b / 255, a / 255];
    }
  }, {
    key: "getRgbComponentsNormalized",
    value: function getRgbComponentsNormalized(argb) {
      var r = (argb / 65536 | 0) % 256;
      var g = (argb / 256 | 0) % 256;
      var b = argb % 256;
      return [r / 255, g / 255, b / 255];
    }
  }, {
    key: "getRgbaComponents",
    value: function getRgbaComponents(argb) {
      var r = (argb / 65536 | 0) % 256;
      var g = (argb / 256 | 0) % 256;
      var b = argb % 256;
      var a = argb / 16777216 | 0;
      return [r, g, b, a];
    }
  }, {
    key: "getArgbNumber",
    value: function getArgbNumber(rgba) {
      rgba[0] = Math.max(0, Math.min(255, rgba[0]));
      rgba[1] = Math.max(0, Math.min(255, rgba[1]));
      rgba[2] = Math.max(0, Math.min(255, rgba[2]));
      rgba[3] = Math.max(0, Math.min(255, rgba[3]));
      var v = ((rgba[3] | 0) << 24) + ((rgba[0] | 0) << 16) + ((rgba[1] | 0) << 8) + (rgba[2] | 0);
      if (v < 0) {
        v = 0xFFFFFFFF + v + 1;
      }
      return v;
    }
  }, {
    key: "mergeColors",
    value: function mergeColors(c1, c2, p) {
      var r1 = (c1 / 65536 | 0) % 256;
      var g1 = (c1 / 256 | 0) % 256;
      var b1 = c1 % 256;
      var a1 = c1 / 16777216 | 0;
      var r2 = (c2 / 65536 | 0) % 256;
      var g2 = (c2 / 256 | 0) % 256;
      var b2 = c2 % 256;
      var a2 = c2 / 16777216 | 0;
      var r = r1 * p + r2 * (1 - p);
      var g = g1 * p + g2 * (1 - p);
      var b = b1 * p + b2 * (1 - p);
      var a = a1 * p + a2 * (1 - p);
      return Math.round(a) * 16777216 + Math.round(r) * 65536 + Math.round(g) * 256 + Math.round(b);
    }
  }, {
    key: "mergeMultiColors",
    value: function mergeMultiColors(c, p) {
      var r = 0,
        g = 0,
        b = 0,
        a = 0,
        t = 0;
      var n = c.length;
      for (var i = 0; i < n; i++) {
        var r1 = (c[i] / 65536 | 0) % 256;
        var g1 = (c[i] / 256 | 0) % 256;
        var b1 = c[i] % 256;
        var a1 = c[i] / 16777216 | 0;
        r += r1 * p[i];
        g += g1 * p[i];
        b += b1 * p[i];
        a += a1 * p[i];
        t += p[i];
      }
      t = 1 / t;
      return Math.round(a * t) * 16777216 + Math.round(r * t) * 65536 + Math.round(g * t) * 256 + Math.round(b * t);
    }
  }, {
    key: "mergeMultiColorsEqual",
    value: function mergeMultiColorsEqual(c) {
      var r = 0,
        g = 0,
        b = 0,
        a = 0,
        t = 0;
      var n = c.length;
      for (var i = 0; i < n; i++) {
        var r1 = (c[i] / 65536 | 0) % 256;
        var g1 = (c[i] / 256 | 0) % 256;
        var b1 = c[i] % 256;
        var a1 = c[i] / 16777216 | 0;
        r += r1;
        g += g1;
        b += b1;
        a += a1;
        t += 1.0;
      }
      t = 1 / t;
      return Math.round(a * t) * 16777216 + Math.round(r * t) * 65536 + Math.round(g * t) * 256 + Math.round(b * t);
    }
  }, {
    key: "mergeColorAlpha",
    value: function mergeColorAlpha(c, alpha) {
      var a = (c / 16777216 | 0) * alpha | 0;
      return ((c >> 16 & 0xff) * a / 255 & 0xff) + ((c & 0xff00) * a / 255 & 0xff00) + (((c & 0xff) << 16) * a / 255 & 0xff0000) + (a << 24);
    }
  }, {
    key: "rad",
    value: function rad(deg) {
      return deg * (Math.PI / 180);
    }
  }, {
    key: "getTimingBezier",
    value: function getTimingBezier(a, b, c, d) {
      var xc = 3.0 * a;
      var xb = 3.0 * (c - a) - xc;
      var xa = 1.0 - xc - xb;
      var yc = 3.0 * b;
      var yb = 3.0 * (d - b) - yc;
      var ya = 1.0 - yc - yb;
      return function (time) {
        if (time >= 1.0) {
          return 1;
        }
        if (time <= 0) {
          return 0;
        }
        var t = 0.5,
          cbx,
          cbxd,
          dx;
        for (var it = 0; it < 20; it++) {
          cbx = t * (t * (t * xa + xb) + xc);
          dx = time - cbx;
          if (dx > -1e-8 && dx < 1e-8) {
            return t * (t * (t * ya + yb) + yc);
          }
          cbxd = t * (t * (3 * xa) + 2 * xb) + xc;
          if (cbxd > 1e-10 && cbxd < 1e-10) {
            break;
          }
          t += dx / cbxd;
        }
        var minT = 0;
        var maxT = 1;
        for (var _it = 0; _it < 20; _it++) {
          t = 0.5 * (minT + maxT);
          cbx = t * (t * (t * xa + xb) + xc);
          dx = time - cbx;
          if (dx > -1e-8 && dx < 1e-8) {
            return t * (t * (t * ya + yb) + yc);
          }
          if (dx < 0) {
            maxT = t;
          } else {
            minT = t;
          }
        }
      };
    }
  }, {
    key: "getTimingFunction",
    value: function getTimingFunction(str) {
      switch (str) {
        case "linear":
          return function (time) {
            return time;
          };
        case "ease":
          return StageUtils.getTimingBezier(0.25, 0.1, 0.25, 1.0);
        case "ease-in":
          return StageUtils.getTimingBezier(0.42, 0, 1.0, 1.0);
        case "ease-out":
          return StageUtils.getTimingBezier(0, 0, 0.58, 1.0);
        case "ease-in-out":
          return StageUtils.getTimingBezier(0.42, 0, 0.58, 1.0);
        case "step-start":
          return function () {
            return 1;
          };
        case "step-end":
          return function (time) {
            return time === 1 ? 1 : 0;
          };
        default:
          var s = "cubic-bezier(";
          if (str && str.indexOf(s) === 0) {
            var parts = str.substr(s.length, str.length - s.length - 1).split(",");
            if (parts.length !== 4) {
              console.warn("[Lightning] Unknown timing function: " + str);
              return function (time) {
                return time;
              };
            }
            var a = parseFloat(parts[0]);
            var b = parseFloat(parts[1]);
            var c = parseFloat(parts[2]);
            var d = parseFloat(parts[3]);
            if (isNaN(a) || isNaN(b) || isNaN(c) || isNaN(d)) {
              console.warn("[Lightning] Unknown timing function: " + str);
              return function (time) {
                return time;
              };
            }
            return StageUtils.getTimingBezier(a, b, c, d);
          } else {
            console.warn("[Lightning] Unknown timing function: " + str);
            return function (time) {
              return time;
            };
          }
      }
    }
  }]);
  return StageUtils;
}();

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/tree/Utils.mjs





var Utils_Utils = function () {
  function Utils() {
    (0,classCallCheck/* default */.Z)(this, Utils);
  }
  (0,createClass/* default */.Z)(Utils, null, [{
    key: "isFunction",
    value: function isFunction(value) {
      return typeof value === 'function';
    }
  }, {
    key: "isNumber",
    value: function isNumber(value) {
      return typeof value === 'number';
    }
  }, {
    key: "isInteger",
    value: function isInteger(value) {
      return typeof value === 'number' && value % 1 === 0;
    }
  }, {
    key: "isBoolean",
    value: function isBoolean(value) {
      return value === true || value === false;
    }
  }, {
    key: "isString",
    value: function isString(value) {
      return typeof value === 'string';
    }
  }, {
    key: "clone",
    value: function clone(v) {
      if (Utils.isObjectLiteral(v) || Array.isArray(v)) {
        return Utils.getDeepClone(v);
      } else {
        return v;
      }
    }
  }, {
    key: "cloneObjShallow",
    value: function cloneObjShallow(obj) {
      var keys = Object.keys(obj);
      var clone = {};
      for (var i = 0; i < keys.length; i++) {
        clone[keys[i]] = obj[keys[i]];
      }
      return clone;
    }
  }, {
    key: "merge",
    value: function merge(obj1, obj2) {
      var keys = Object.keys(obj2);
      for (var i = 0; i < keys.length; i++) {
        obj1[keys[i]] = obj2[keys[i]];
      }
      return obj1;
    }
  }, {
    key: "isObject",
    value: function isObject(value) {
      var type = (0,esm_typeof/* default */.Z)(value);
      return !!value && (type === 'object' || type === 'function');
    }
  }, {
    key: "isPlainObject",
    value: function isPlainObject(value) {
      var type = (0,esm_typeof/* default */.Z)(value);
      return !!value && type === 'object';
    }
  }, {
    key: "isObjectLiteral",
    value: function isObjectLiteral(value) {
      return (0,esm_typeof/* default */.Z)(value) === 'object' && value && value.constructor === Object;
    }
  }, {
    key: "getArrayIndex",
    value: function getArrayIndex(index, arr) {
      return Utils.getModuloIndex(index, arr.length);
    }
  }, {
    key: "getModuloIndex",
    value: function getModuloIndex(index, len) {
      if (len === 0) return index;
      while (index < 0) {
        index += Math.ceil(-index / len) * len;
      }
      index = index % len;
      return index;
    }
  }, {
    key: "getDeepClone",
    value: function getDeepClone(obj) {
      var i, c;
      if (Utils.isFunction(obj)) {
        return obj;
      }
      if (Array.isArray(obj)) {
        c = [];
        var keys = Object.keys(obj);
        for (i = 0; i < keys.length; i++) {
          c[keys[i]] = Utils.getDeepClone(obj[keys[i]]);
        }
        return c;
      } else if (Utils.isObject(obj)) {
        c = {};
        var _keys = Object.keys(obj);
        for (i = 0; i < _keys.length; i++) {
          c[_keys[i]] = Utils.getDeepClone(obj[_keys[i]]);
        }
        return c;
      } else {
        return obj;
      }
    }
  }, {
    key: "equalValues",
    value: function equalValues(v1, v2) {
      if ((0,esm_typeof/* default */.Z)(v1) !== (0,esm_typeof/* default */.Z)(v2)) return false;
      if (Utils.isObjectLiteral(v1)) {
        return Utils.isObjectLiteral(v2) && Utils.equalObjectLiterals(v1, v2);
      } else if (Array.isArray(v1)) {
        return Array.isArray(v2) && Utils.equalArrays(v1, v2);
      } else {
        return v1 === v2;
      }
    }
  }, {
    key: "equalObjectLiterals",
    value: function equalObjectLiterals(obj1, obj2) {
      var keys1 = Object.keys(obj1);
      var keys2 = Object.keys(obj2);
      if (keys1.length !== keys2.length) {
        return false;
      }
      for (var i = 0, n = keys1.length; i < n; i++) {
        var k1 = keys1[i];
        var k2 = keys2[i];
        if (k1 !== k2) {
          return false;
        }
        var v1 = obj1[k1];
        var v2 = obj2[k2];
        if (!Utils.equalValues(v1, v2)) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "equalArrays",
    value: function equalArrays(v1, v2) {
      if (v1.length !== v2.length) {
        return false;
      }
      for (var i = 0, n = v1.length; i < n; i++) {
        if (!this.equalValues(v1[i], v2[i])) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "setToArray",
    value: function setToArray(s) {
      var result = [];
      s.forEach(function (value) {
        result.push(value);
      });
      return result;
    }
  }, {
    key: "iteratorToArray",
    value: function iteratorToArray(iterator) {
      var result = [];
      var iteratorResult = iterator.next();
      while (!iteratorResult.done) {
        result.push(iteratorResult.value);
        iteratorResult = iterator.next();
      }
      return result;
    }
  }, {
    key: "isUcChar",
    value: function isUcChar(charcode) {
      return charcode >= 65 && charcode <= 90;
    }
  }]);
  return Utils;
}();

Utils_Utils.isWeb = typeof window !== "undefined" && typeof sparkscene === "undefined";
Utils_Utils.isWPE = Utils_Utils.isWeb && navigator.userAgent.indexOf("WPE") !== -1;
Utils_Utils.isSpark = typeof sparkscene !== "undefined";
Utils_Utils.isNode = typeof window === "undefined" || Utils_Utils.isSpark;
Utils_Utils.isPS4 = Utils_Utils.isWeb && navigator.userAgent.indexOf("PlayStation 4") !== -1;
Utils_Utils.isZiggo = Utils_Utils.isWeb && (navigator.userAgent.indexOf("EOSSTB") !== -1 || navigator.userAgent.indexOf("HZNSTB") !== -1);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/tree/Base.mjs



var Base = function () {
  function Base() {
    (0,classCallCheck/* default */.Z)(this, Base);
  }
  (0,createClass/* default */.Z)(Base, null, [{
    key: "defaultSetter",
    value: function defaultSetter(obj, name, value) {
      obj[name] = value;
    }
  }, {
    key: "patchObject",
    value: function patchObject(obj, settings) {
      if (!Utils_Utils.isObjectLiteral(settings)) {
        console.error("[Lightning] Settings must be object literal");
      } else {
        var names = Object.keys(settings);
        for (var i = 0, n = names.length; i < n; i++) {
          var name = names[i];
          this.patchObjectProperty(obj, name, settings[name]);
        }
      }
    }
  }, {
    key: "patchObjectProperty",
    value: function patchObjectProperty(obj, name, value) {
      var setter = obj.setSetting || Base.defaultSetter;
      if (name.charAt(0) === "_") {
        if (name !== "__create") {
          console.error("[Lightning] Patch of private property '" + name + "' is not allowed");
        }
      } else if (name !== "type") {
        if (Utils_Utils.isFunction(value) && value.__local) {
          value = value.__local(obj);
        }
        setter(obj, name, value);
      }
    }
  }, {
    key: "local",
    value: function local(func) {
      func.__local = true;
    }
  }]);
  return Base;
}();


;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/flex/layout/SpacingCalculator.mjs


var SpacingCalculator = function () {
  function SpacingCalculator() {
    (0,classCallCheck/* default */.Z)(this, SpacingCalculator);
  }
  (0,createClass/* default */.Z)(SpacingCalculator, null, [{
    key: "getSpacing",
    value: function getSpacing(mode, numberOfItems, remainingSpace) {
      var itemGaps = numberOfItems - 1;
      var spacePerGap;
      var spacingBefore, spacingBetween;
      switch (mode) {
        case "flex-start":
          spacingBefore = 0;
          spacingBetween = 0;
          break;
        case "flex-end":
          spacingBefore = remainingSpace;
          spacingBetween = 0;
          break;
        case "center":
          spacingBefore = remainingSpace / 2;
          spacingBetween = 0;
          break;
        case "space-between":
          spacingBefore = 0;
          spacingBetween = Math.max(0, remainingSpace) / itemGaps;
          break;
        case "space-around":
          if (remainingSpace < 0) {
            return this.getSpacing("center", numberOfItems, remainingSpace);
          } else {
            spacePerGap = remainingSpace / (itemGaps + 1);
            spacingBefore = 0.5 * spacePerGap;
            spacingBetween = spacePerGap;
          }
          break;
        case "space-evenly":
          if (remainingSpace < 0) {
            return this.getSpacing("center", numberOfItems, remainingSpace);
          } else {
            spacePerGap = remainingSpace / (itemGaps + 2);
            spacingBefore = spacePerGap;
            spacingBetween = spacePerGap;
          }
          break;
        case "stretch":
          spacingBefore = 0;
          spacingBetween = 0;
          break;
        default:
          throw new Error("Unknown mode: " + mode);
      }
      return {
        spacingBefore: spacingBefore,
        spacingBetween: spacingBetween
      };
    }
  }]);
  return SpacingCalculator;
}();

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/flex/layout/ContentAligner.mjs



var ContentAligner = function () {
  function ContentAligner(layout) {
    (0,classCallCheck/* default */.Z)(this, ContentAligner);
    this._layout = layout;
    this._totalCrossAxisSize = 0;
  }
  (0,createClass/* default */.Z)(ContentAligner, [{
    key: "_lines",
    get: function get() {
      return this._layout._lines;
    }
  }, {
    key: "init",
    value: function init() {
      this._totalCrossAxisSize = this._getTotalCrossAxisSize();
    }
  }, {
    key: "align",
    value: function align() {
      var crossAxisSize = this._layout.crossAxisSize;
      var remainingSpace = crossAxisSize - this._totalCrossAxisSize;
      var _this$_getSpacing = this._getSpacing(remainingSpace),
        spacingBefore = _this$_getSpacing.spacingBefore,
        spacingBetween = _this$_getSpacing.spacingBetween;
      var lines = this._lines;
      var mode = this._layout._flexContainer.alignContent;
      var growSize = 0;
      if (mode === "stretch" && lines.length && remainingSpace > 0) {
        growSize = remainingSpace / lines.length;
      }
      var currentPos = spacingBefore;
      for (var i = 0, n = lines.length; i < n; i++) {
        var crossAxisLayoutOffset = currentPos;
        var aligner = lines[i].createItemAligner();
        var finalCrossAxisLayoutSize = lines[i].crossAxisLayoutSize + growSize;
        aligner.setCrossAxisLayoutSize(finalCrossAxisLayoutSize);
        aligner.setCrossAxisLayoutOffset(crossAxisLayoutOffset);
        aligner.align();
        if (aligner.recursiveResizeOccured) {
          lines[i].setItemPositions();
        }
        currentPos += finalCrossAxisLayoutSize;
        currentPos += spacingBetween;
      }
    }
  }, {
    key: "totalCrossAxisSize",
    get: function get() {
      return this._totalCrossAxisSize;
    }
  }, {
    key: "_getTotalCrossAxisSize",
    value: function _getTotalCrossAxisSize() {
      var lines = this._lines;
      var total = 0;
      for (var i = 0, n = lines.length; i < n; i++) {
        var line = lines[i];
        total += line.crossAxisLayoutSize;
      }
      return total;
    }
  }, {
    key: "_getSpacing",
    value: function _getSpacing(remainingSpace) {
      var mode = this._layout._flexContainer.alignContent;
      var numberOfItems = this._lines.length;
      return SpacingCalculator.getSpacing(mode, numberOfItems, remainingSpace);
    }
  }]);
  return ContentAligner;
}();

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/flex/FlexUtils.mjs


var FlexUtils = function () {
  function FlexUtils() {
    (0,classCallCheck/* default */.Z)(this, FlexUtils);
  }
  (0,createClass/* default */.Z)(FlexUtils, null, [{
    key: "getParentAxisSizeWithPadding",
    value: function getParentAxisSizeWithPadding(item, horizontal) {
      var target = item.target;
      var parent = target.getParent();
      if (!parent) {
        return 0;
      } else {
        var flexParent = item.flexParent;
        if (flexParent) {
          return this.getAxisLayoutSize(flexParent, horizontal) + this.getTotalPadding(flexParent, horizontal);
        } else {
          return horizontal ? parent.w : parent.h;
        }
      }
    }
  }, {
    key: "getRelAxisSize",
    value: function getRelAxisSize(item, horizontal) {
      if (horizontal) {
        if (item.funcW) {
          if (this._allowRelAxisSizeFunction(item, true)) {
            return item.funcW(this.getParentAxisSizeWithPadding(item, true));
          } else {
            return 0;
          }
        } else {
          return item.originalWidth;
        }
      } else {
        if (item.funcH) {
          if (this._allowRelAxisSizeFunction(item, false)) {
            return item.funcH(this.getParentAxisSizeWithPadding(item, false));
          } else {
            return 0;
          }
        } else {
          return item.originalHeight;
        }
      }
    }
  }, {
    key: "_allowRelAxisSizeFunction",
    value: function _allowRelAxisSizeFunction(item, horizontal) {
      var flexParent = item.flexParent;
      if (flexParent && flexParent._flex._layout.isAxisFitToContents(horizontal)) {
        return false;
      }
      return true;
    }
  }, {
    key: "isZeroAxisSize",
    value: function isZeroAxisSize(item, horizontal) {
      if (horizontal) {
        return !item.originalWidth && !item.funcW;
      } else {
        return !item.originalHeight && !item.funcH;
      }
    }
  }, {
    key: "getAxisLayoutPos",
    value: function getAxisLayoutPos(item, horizontal) {
      return horizontal ? item.x : item.y;
    }
  }, {
    key: "getAxisLayoutSize",
    value: function getAxisLayoutSize(item, horizontal) {
      return horizontal ? item.w : item.h;
    }
  }, {
    key: "setAxisLayoutPos",
    value: function setAxisLayoutPos(item, horizontal, pos) {
      if (horizontal) {
        item.x = pos;
      } else {
        item.y = pos;
      }
    }
  }, {
    key: "setAxisLayoutSize",
    value: function setAxisLayoutSize(item, horizontal, size) {
      if (horizontal) {
        item.w = size;
      } else {
        item.h = size;
      }
    }
  }, {
    key: "getAxisMinSize",
    value: function getAxisMinSize(item, horizontal) {
      var minSize = this.getPlainAxisMinSize(item, horizontal);
      var flexItemMinSize = 0;
      if (item.isFlexItemEnabled()) {
        flexItemMinSize = item._flexItem._getMinSizeSetting(horizontal);
      }
      var hasLimitedMinSize = flexItemMinSize > 0;
      if (hasLimitedMinSize) {
        minSize = Math.max(minSize, flexItemMinSize);
      }
      return minSize;
    }
  }, {
    key: "getPlainAxisMinSize",
    value: function getPlainAxisMinSize(item, horizontal) {
      if (item.isFlexEnabled()) {
        return item._flex._layout.getAxisMinSize(horizontal);
      } else {
        var isShrinkable = item.flexItem.shrink !== 0;
        if (isShrinkable) {
          return 0;
        } else {
          return this.getRelAxisSize(item, horizontal);
        }
      }
    }
  }, {
    key: "resizeAxis",
    value: function resizeAxis(item, horizontal, size) {
      if (item.isFlexEnabled()) {
        var isMainAxis = item._flex._horizontal === horizontal;
        if (isMainAxis) {
          item._flex._layout.resizeMainAxis(size);
        } else {
          item._flex._layout.resizeCrossAxis(size);
        }
      } else {
        this.setAxisLayoutSize(item, horizontal, size);
      }
    }
  }, {
    key: "getPaddingOffset",
    value: function getPaddingOffset(item, horizontal) {
      if (item.isFlexEnabled()) {
        var flex = item._flex;
        if (horizontal) {
          return flex.paddingLeft;
        } else {
          return flex.paddingTop;
        }
      } else {
        return 0;
      }
    }
  }, {
    key: "getTotalPadding",
    value: function getTotalPadding(item, horizontal) {
      if (item.isFlexEnabled()) {
        var flex = item._flex;
        if (horizontal) {
          return flex.paddingRight + flex.paddingLeft;
        } else {
          return flex.paddingTop + flex.paddingBottom;
        }
      } else {
        return 0;
      }
    }
  }, {
    key: "getMarginOffset",
    value: function getMarginOffset(item, horizontal) {
      var flexItem = item.flexItem;
      if (flexItem) {
        if (horizontal) {
          return flexItem.marginLeft;
        } else {
          return flexItem.marginTop;
        }
      } else {
        return 0;
      }
    }
  }, {
    key: "getTotalMargin",
    value: function getTotalMargin(item, horizontal) {
      var flexItem = item.flexItem;
      if (flexItem) {
        if (horizontal) {
          return flexItem.marginRight + flexItem.marginLeft;
        } else {
          return flexItem.marginTop + flexItem.marginBottom;
        }
      } else {
        return 0;
      }
    }
  }]);
  return FlexUtils;
}();

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/flex/layout/line/SizeShrinker.mjs


var SizeShrinker = function () {
  function SizeShrinker(line) {
    (0,classCallCheck/* default */.Z)(this, SizeShrinker);
    this._line = line;
    this._amountRemaining = 0;
    this._shrunkSize = 0;
  }
  (0,createClass/* default */.Z)(SizeShrinker, [{
    key: "shrink",
    value: function shrink(amount) {
      this._shrunkSize = 0;
      this._amountRemaining = amount;
      var totalShrinkAmount = this._getTotalShrinkAmount();
      if (totalShrinkAmount) {
        var items = this._line.items;
        do {
          var amountPerShrink = this._amountRemaining / totalShrinkAmount;
          for (var i = this._line.startIndex; i <= this._line.endIndex; i++) {
            var item = items[i];
            var flexItem = item.flexItem;
            var shrinkAmount = flexItem.shrink;
            var isShrinkableItem = shrinkAmount > 0;
            if (isShrinkableItem) {
              var shrink = shrinkAmount * amountPerShrink;
              var minSize = flexItem._getMainAxisMinSize();
              var size = flexItem._getMainAxisLayoutSize();
              if (size > minSize) {
                var maxShrink = size - minSize;
                var isFullyShrunk = shrink >= maxShrink;
                if (isFullyShrunk) {
                  shrink = maxShrink;
                  totalShrinkAmount -= shrinkAmount;
                }
                var finalSize = size - shrink;
                flexItem._resizeMainAxis(finalSize);
                this._shrunkSize += shrink;
                this._amountRemaining -= shrink;
                if (Math.abs(this._amountRemaining) < 10e-6) {
                  return;
                }
              }
            }
          }
        } while (totalShrinkAmount && Math.abs(this._amountRemaining) > 10e-6);
      }
    }
  }, {
    key: "_getTotalShrinkAmount",
    value: function _getTotalShrinkAmount() {
      var total = 0;
      var items = this._line.items;
      for (var i = this._line.startIndex; i <= this._line.endIndex; i++) {
        var item = items[i];
        var flexItem = item.flexItem;
        if (flexItem.shrink) {
          var minSize = flexItem._getMainAxisMinSize();
          var size = flexItem._getMainAxisLayoutSize();
          if (size > minSize) {
            total += flexItem.shrink;
          }
        }
      }
      return total;
    }
  }, {
    key: "getShrunkSize",
    value: function getShrunkSize() {
      return this._shrunkSize;
    }
  }]);
  return SizeShrinker;
}();

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/flex/layout/line/SizeGrower.mjs


var SizeGrower = function () {
  function SizeGrower(line) {
    (0,classCallCheck/* default */.Z)(this, SizeGrower);
    this._line = line;
    this._amountRemaining = 0;
    this._grownSize = 0;
  }
  (0,createClass/* default */.Z)(SizeGrower, [{
    key: "grow",
    value: function grow(amount) {
      this._grownSize = 0;
      this._amountRemaining = amount;
      var totalGrowAmount = this._getTotalGrowAmount();
      if (totalGrowAmount) {
        var items = this._line.items;
        do {
          var amountPerGrow = this._amountRemaining / totalGrowAmount;
          for (var i = this._line.startIndex; i <= this._line.endIndex; i++) {
            var item = items[i];
            var flexItem = item.flexItem;
            var growAmount = flexItem.grow;
            var isGrowableItem = growAmount > 0;
            if (isGrowableItem) {
              var grow = growAmount * amountPerGrow;
              var maxSize = flexItem._getMainAxisMaxSizeSetting();
              var size = flexItem._getMainAxisLayoutSize();
              if (maxSize > 0) {
                if (size >= maxSize) {
                  grow = 0;
                } else {
                  var maxGrow = maxSize - size;
                  var isFullyGrown = grow >= maxGrow;
                  if (isFullyGrown) {
                    grow = maxGrow;
                    totalGrowAmount -= growAmount;
                  }
                }
              }
              if (grow > 0) {
                var finalSize = size + grow;
                flexItem._resizeMainAxis(finalSize);
                this._grownSize += grow;
                this._amountRemaining -= grow;
                if (Math.abs(this._amountRemaining) < 10e-6) {
                  return;
                }
              }
            }
          }
        } while (totalGrowAmount && Math.abs(this._amountRemaining) > 10e-6);
      }
    }
  }, {
    key: "_getTotalGrowAmount",
    value: function _getTotalGrowAmount() {
      var total = 0;
      var items = this._line.items;
      for (var i = this._line.startIndex; i <= this._line.endIndex; i++) {
        var item = items[i];
        var flexItem = item.flexItem;
        if (flexItem.grow) {
          var maxSize = flexItem._getMainAxisMaxSizeSetting();
          var size = flexItem._getMainAxisLayoutSize();
          if (maxSize === 0 || size < maxSize) {
            total += flexItem.grow;
          }
        }
      }
      return total;
    }
  }, {
    key: "getGrownSize",
    value: function getGrownSize() {
      return this._grownSize;
    }
  }]);
  return SizeGrower;
}();

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/flex/layout/line/ItemPositioner.mjs



var ItemPositioner = function () {
  function ItemPositioner(lineLayout) {
    (0,classCallCheck/* default */.Z)(this, ItemPositioner);
    this._line = lineLayout;
  }
  (0,createClass/* default */.Z)(ItemPositioner, [{
    key: "_layout",
    get: function get() {
      return this._line._layout;
    }
  }, {
    key: "position",
    value: function position() {
      var _this$_getSpacing = this._getSpacing(),
        spacingBefore = _this$_getSpacing.spacingBefore,
        spacingBetween = _this$_getSpacing.spacingBetween;
      var currentPos = spacingBefore;
      var items = this._line.items;
      for (var i = this._line.startIndex; i <= this._line.endIndex; i++) {
        var item = items[i];
        item.flexItem._setMainAxisLayoutPos(currentPos);
        currentPos += item.flexItem._getMainAxisLayoutSizeWithPaddingAndMargin();
        currentPos += spacingBetween;
      }
    }
  }, {
    key: "_getSpacing",
    value: function _getSpacing() {
      var remainingSpace = this._line._availableSpace;
      var mode = this._layout._flexContainer.justifyContent;
      var numberOfItems = this._line.numberOfItems;
      return SpacingCalculator.getSpacing(mode, numberOfItems, remainingSpace);
    }
  }]);
  return ItemPositioner;
}();

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/flex/layout/line/ItemAligner.mjs


var ItemAligner = function () {
  function ItemAligner(line) {
    (0,classCallCheck/* default */.Z)(this, ItemAligner);
    this._line = line;
    this._crossAxisLayoutSize = 0;
    this._crossAxisLayoutOffset = 0;
    this._alignItemsSetting = null;
    this._recursiveResizeOccured = false;
    this._isCrossAxisFitToContents = false;
  }
  (0,createClass/* default */.Z)(ItemAligner, [{
    key: "_layout",
    get: function get() {
      return this._line._layout;
    }
  }, {
    key: "_flexContainer",
    get: function get() {
      return this._layout._flexContainer;
    }
  }, {
    key: "setCrossAxisLayoutSize",
    value: function setCrossAxisLayoutSize(size) {
      this._crossAxisLayoutSize = size;
    }
  }, {
    key: "setCrossAxisLayoutOffset",
    value: function setCrossAxisLayoutOffset(offset) {
      this._crossAxisLayoutOffset = offset;
    }
  }, {
    key: "align",
    value: function align() {
      this._alignItemsSetting = this._flexContainer.alignItems;
      this._isCrossAxisFitToContents = this._layout.isAxisFitToContents(!this._flexContainer._horizontal);
      this._recursiveResizeOccured = false;
      var items = this._line.items;
      for (var i = this._line.startIndex; i <= this._line.endIndex; i++) {
        var item = items[i];
        this._alignItem(item);
      }
    }
  }, {
    key: "recursiveResizeOccured",
    get: function get() {
      return this._recursiveResizeOccured;
    }
  }, {
    key: "_alignItem",
    value: function _alignItem(item) {
      var flexItem = item.flexItem;
      var align = flexItem.alignSelf || this._alignItemsSetting;
      if (align === "stretch" && this._preventStretch(flexItem)) {
        align = "flex-start";
      }
      if (align !== "stretch" && !this._isCrossAxisFitToContents) {
        if (flexItem._hasRelCrossAxisSize()) {
          flexItem._resetCrossAxisLayoutSize();
        }
      }
      switch (align) {
        case "flex-start":
          this._alignItemFlexStart(flexItem);
          break;
        case "flex-end":
          this._alignItemFlexEnd(flexItem);
          break;
        case "center":
          this._alignItemFlexCenter(flexItem);
          break;
        case "stretch":
          this._alignItemStretch(flexItem);
          break;
      }
    }
  }, {
    key: "_alignItemFlexStart",
    value: function _alignItemFlexStart(flexItem) {
      flexItem._setCrossAxisLayoutPos(this._crossAxisLayoutOffset);
    }
  }, {
    key: "_alignItemFlexEnd",
    value: function _alignItemFlexEnd(flexItem) {
      var itemCrossAxisSize = flexItem._getCrossAxisLayoutSizeWithPaddingAndMargin();
      flexItem._setCrossAxisLayoutPos(this._crossAxisLayoutOffset + (this._crossAxisLayoutSize - itemCrossAxisSize));
    }
  }, {
    key: "_alignItemFlexCenter",
    value: function _alignItemFlexCenter(flexItem) {
      var itemCrossAxisSize = flexItem._getCrossAxisLayoutSizeWithPaddingAndMargin();
      var center = (this._crossAxisLayoutSize - itemCrossAxisSize) / 2;
      flexItem._setCrossAxisLayoutPos(this._crossAxisLayoutOffset + center);
    }
  }, {
    key: "_alignItemStretch",
    value: function _alignItemStretch(flexItem) {
      flexItem._setCrossAxisLayoutPos(this._crossAxisLayoutOffset);
      var mainAxisLayoutSizeBeforeResize = flexItem._getMainAxisLayoutSize();
      var size = this._crossAxisLayoutSize - flexItem._getCrossAxisMargin() - flexItem._getCrossAxisPadding();
      var crossAxisMinSizeSetting = flexItem._getCrossAxisMinSizeSetting();
      if (crossAxisMinSizeSetting > 0) {
        size = Math.max(size, crossAxisMinSizeSetting);
      }
      var crossAxisMaxSizeSetting = flexItem._getCrossAxisMaxSizeSetting();
      var crossAxisMaxSizeSettingEnabled = crossAxisMaxSizeSetting > 0;
      if (crossAxisMaxSizeSettingEnabled) {
        size = Math.min(size, crossAxisMaxSizeSetting);
      }
      flexItem._resizeCrossAxis(size);
      var mainAxisLayoutSizeAfterResize = flexItem._getMainAxisLayoutSize();
      var recursiveResize = mainAxisLayoutSizeAfterResize !== mainAxisLayoutSizeBeforeResize;
      if (recursiveResize) {
        this._recursiveResizeOccured = true;
      }
    }
  }, {
    key: "_preventStretch",
    value: function _preventStretch(flexItem) {
      var hasFixedCrossAxisSize = flexItem._hasFixedCrossAxisSize();
      var forceStretch = flexItem.alignSelf === "stretch";
      return hasFixedCrossAxisSize && !forceStretch;
    }
  }]);
  return ItemAligner;
}();

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/flex/layout/line/LineLayout.mjs






var LineLayout = function () {
  function LineLayout(layout, startIndex, endIndex, availableSpace) {
    (0,classCallCheck/* default */.Z)(this, LineLayout);
    this._layout = layout;
    this.items = layout.items;
    this.startIndex = startIndex;
    this.endIndex = endIndex;
    this._availableSpace = availableSpace;
  }
  (0,createClass/* default */.Z)(LineLayout, [{
    key: "performLayout",
    value: function performLayout() {
      this._setItemSizes();
      this.setItemPositions();
      this._calcLayoutInfo();
    }
  }, {
    key: "_setItemSizes",
    value: function _setItemSizes() {
      if (this._availableSpace > 0) {
        this._growItemSizes(this._availableSpace);
      } else if (this._availableSpace < 0) {
        this._shrinkItemSizes(-this._availableSpace);
      }
    }
  }, {
    key: "_growItemSizes",
    value: function _growItemSizes(amount) {
      var grower = new SizeGrower(this);
      grower.grow(amount);
      this._availableSpace -= grower.getGrownSize();
    }
  }, {
    key: "_shrinkItemSizes",
    value: function _shrinkItemSizes(amount) {
      var shrinker = new SizeShrinker(this);
      shrinker.shrink(amount);
      this._availableSpace += shrinker.getShrunkSize();
    }
  }, {
    key: "setItemPositions",
    value: function setItemPositions() {
      var positioner = new ItemPositioner(this);
      positioner.position();
    }
  }, {
    key: "createItemAligner",
    value: function createItemAligner() {
      return new ItemAligner(this);
    }
  }, {
    key: "_calcLayoutInfo",
    value: function _calcLayoutInfo() {
      this._calcCrossAxisMaxLayoutSize();
    }
  }, {
    key: "getMainAxisMinSize",
    value: function getMainAxisMinSize() {
      var mainAxisMinSize = 0;
      for (var i = this.startIndex; i <= this.endIndex; i++) {
        var item = this.items[i];
        mainAxisMinSize += item.flexItem._getMainAxisMinSizeWithPaddingAndMargin();
      }
      return mainAxisMinSize;
    }
  }, {
    key: "numberOfItems",
    get: function get() {
      return this.endIndex - this.startIndex + 1;
    }
  }, {
    key: "crossAxisLayoutSize",
    get: function get() {
      var noSpecifiedCrossAxisSize = this._layout.isCrossAxisFitToContents() && !this._layout.resizingCrossAxis;
      var shouldFitToContents = this._layout.isWrapping() || noSpecifiedCrossAxisSize;
      if (shouldFitToContents) {
        return this._crossAxisMaxLayoutSize;
      } else {
        return this._layout.crossAxisSize;
      }
    }
  }, {
    key: "_calcCrossAxisMaxLayoutSize",
    value: function _calcCrossAxisMaxLayoutSize() {
      this._crossAxisMaxLayoutSize = this._getCrossAxisMaxLayoutSize();
    }
  }, {
    key: "_getCrossAxisMaxLayoutSize",
    value: function _getCrossAxisMaxLayoutSize() {
      var crossAxisMaxSize = 0;
      for (var i = this.startIndex; i <= this.endIndex; i++) {
        var item = this.items[i];
        crossAxisMaxSize = Math.max(crossAxisMaxSize, item.flexItem._getCrossAxisLayoutSizeWithPaddingAndMargin());
      }
      return crossAxisMaxSize;
    }
  }]);
  return LineLayout;
}();

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/flex/layout/LineLayouter.mjs



var LineLayouter = function () {
  function LineLayouter(layout) {
    (0,classCallCheck/* default */.Z)(this, LineLayouter);
    this._layout = layout;
    this._mainAxisMinSize = -1;
    this._crossAxisMinSize = -1;
    this._mainAxisContentSize = 0;
  }
  (0,createClass/* default */.Z)(LineLayouter, [{
    key: "lines",
    get: function get() {
      return this._lines;
    }
  }, {
    key: "mainAxisMinSize",
    get: function get() {
      if (this._mainAxisMinSize === -1) {
        this._mainAxisMinSize = this._getMainAxisMinSize();
      }
      return this._mainAxisMinSize;
    }
  }, {
    key: "crossAxisMinSize",
    get: function get() {
      if (this._crossAxisMinSize === -1) {
        this._crossAxisMinSize = this._getCrossAxisMinSize();
      }
      return this._crossAxisMinSize;
    }
  }, {
    key: "mainAxisContentSize",
    get: function get() {
      return this._mainAxisContentSize;
    }
  }, {
    key: "layoutLines",
    value: function layoutLines() {
      this._setup();
      var items = this._layout.items;
      var wrap = this._layout.isWrapping();
      var startIndex = 0;
      var i;
      var n = items.length;
      for (i = 0; i < n; i++) {
        var item = items[i];
        this._layoutFlexItem(item);
        var itemMainAxisSize = item.flexItem._getMainAxisLayoutSizeWithPaddingAndMargin();
        if (wrap && i > startIndex) {
          var isOverflowing = this._curMainAxisPos + itemMainAxisSize > this._mainAxisSize;
          if (isOverflowing) {
            this._layoutLine(startIndex, i - 1);
            this._curMainAxisPos = 0;
            startIndex = i;
          }
        }
        this._addToMainAxisPos(itemMainAxisSize);
      }
      if (startIndex < i) {
        this._layoutLine(startIndex, i - 1);
      }
    }
  }, {
    key: "_layoutFlexItem",
    value: function _layoutFlexItem(item) {
      if (item.isFlexEnabled()) {
        item.flexLayout.updateTreeLayout();
      } else {
        item.flexItem._resetLayoutSize();
      }
    }
  }, {
    key: "_setup",
    value: function _setup() {
      this._mainAxisSize = this._layout.mainAxisSize;
      this._curMainAxisPos = 0;
      this._maxMainAxisPos = 0;
      this._lines = [];
      this._mainAxisMinSize = -1;
      this._crossAxisMinSize = -1;
      this._mainAxisContentSize = 0;
    }
  }, {
    key: "_addToMainAxisPos",
    value: function _addToMainAxisPos(itemMainAxisSize) {
      this._curMainAxisPos += itemMainAxisSize;
      if (this._curMainAxisPos > this._maxMainAxisPos) {
        this._maxMainAxisPos = this._curMainAxisPos;
      }
    }
  }, {
    key: "_layoutLine",
    value: function _layoutLine(startIndex, endIndex) {
      var availableSpace = this._getAvailableMainAxisLayoutSpace();
      var line = new LineLayout(this._layout, startIndex, endIndex, availableSpace);
      line.performLayout();
      this._lines.push(line);
      if (this._mainAxisContentSize === 0 || this._curMainAxisPos > this._mainAxisContentSize) {
        this._mainAxisContentSize = this._curMainAxisPos;
      }
    }
  }, {
    key: "_getAvailableMainAxisLayoutSpace",
    value: function _getAvailableMainAxisLayoutSpace() {
      if (!this._layout.resizingMainAxis && this._layout.isMainAxisFitToContents()) {
        return 0;
      } else {
        return this._mainAxisSize - this._curMainAxisPos;
      }
    }
  }, {
    key: "_getCrossAxisMinSize",
    value: function _getCrossAxisMinSize() {
      var crossAxisMinSize = 0;
      var items = this._layout.items;
      for (var i = 0, n = items.length; i < n; i++) {
        var item = items[i];
        var itemCrossAxisMinSize = item.flexItem._getCrossAxisMinSizeWithPaddingAndMargin();
        crossAxisMinSize = Math.max(crossAxisMinSize, itemCrossAxisMinSize);
      }
      return crossAxisMinSize;
    }
  }, {
    key: "_getMainAxisMinSize",
    value: function _getMainAxisMinSize() {
      if (this._lines.length === 1) {
        return this._lines[0].getMainAxisMinSize();
      } else {
        return this._layout.mainAxisSize;
      }
    }
  }]);
  return LineLayouter;
}();

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/flex/layout/ItemCoordinatesUpdater.mjs



var ItemCoordinatesUpdater = function () {
  function ItemCoordinatesUpdater(layout) {
    (0,classCallCheck/* default */.Z)(this, ItemCoordinatesUpdater);
    this._layout = layout;
    this._isReverse = this._flexContainer._reverse;
    this._horizontalPaddingOffset = this._layout._getHorizontalPaddingOffset();
    this._verticalPaddingOffset = this._layout._getVerticalPaddingOffset();
  }
  (0,createClass/* default */.Z)(ItemCoordinatesUpdater, [{
    key: "_flexContainer",
    get: function get() {
      return this._layout._flexContainer;
    }
  }, {
    key: "finalize",
    value: function finalize() {
      var parentFlex = this._layout.getParentFlexContainer();
      if (parentFlex) {
        var updater = new ItemCoordinatesUpdater(parentFlex._layout);
        updater._finalizeItemAndChildren(this._flexContainer.item);
      } else {
        this._finalizeRoot();
        this._finalizeItems();
      }
    }
  }, {
    key: "_finalizeRoot",
    value: function _finalizeRoot() {
      var item = this._flexContainer.item;
      var x = FlexUtils.getAxisLayoutPos(item, true);
      var y = FlexUtils.getAxisLayoutPos(item, false);
      var w = FlexUtils.getAxisLayoutSize(item, true);
      var h = FlexUtils.getAxisLayoutSize(item, false);
      w += this._layout._getHorizontalPadding();
      h += this._layout._getVerticalPadding();
      item.clearRecalcFlag();
      item.setLayout(x, y, w, h);
    }
  }, {
    key: "_finalizeItems",
    value: function _finalizeItems() {
      var items = this._layout.items;
      for (var i = 0, n = items.length; i < n; i++) {
        var item = items[i];
        var validCache = this._validateItemCache(item);
        this._finalizeItem(item);
        if (!validCache) {
          this._finalizeItemChildren(item);
        }
      }
    }
  }, {
    key: "_validateItemCache",
    value: function _validateItemCache(item) {
      if (item.recalc === 0) {
        if (item.isFlexEnabled()) {
          var layout = item._flex._layout;
          var dimensionsMatchPreviousResult = item.w === item.target.w && item.h === item.target.h;
          if (dimensionsMatchPreviousResult) {
            return true;
          } else {
            var crossAxisSize = layout.crossAxisSize;
            layout.performResizeMainAxis(layout.mainAxisSize);
            layout.performResizeCrossAxis(crossAxisSize);
          }
        }
      }
      return false;
    }
  }, {
    key: "_finalizeItemAndChildren",
    value: function _finalizeItemAndChildren(item) {
      this._finalizeItem(item);
      this._finalizeItemChildren(item);
    }
  }, {
    key: "_finalizeItem",
    value: function _finalizeItem(item) {
      if (this._isReverse) {
        this._reverseMainAxisLayoutPos(item);
      }
      var x = FlexUtils.getAxisLayoutPos(item, true);
      var y = FlexUtils.getAxisLayoutPos(item, false);
      var w = FlexUtils.getAxisLayoutSize(item, true);
      var h = FlexUtils.getAxisLayoutSize(item, false);
      x += this._horizontalPaddingOffset;
      y += this._verticalPaddingOffset;
      var flex = item.flex;
      if (flex) {
        w += item._flex._layout._getHorizontalPadding();
        h += item._flex._layout._getVerticalPadding();
      }
      var flexItem = item.flexItem;
      if (flexItem) {
        x += flexItem._getHorizontalMarginOffset();
        y += flexItem._getVerticalMarginOffset();
      }
      item.clearRecalcFlag();
      item.setLayout(x, y, w, h);
    }
  }, {
    key: "_finalizeItemChildren",
    value: function _finalizeItemChildren(item) {
      var flex = item._flex;
      if (flex) {
        var updater = new ItemCoordinatesUpdater(flex._layout);
        updater._finalizeItems();
      }
    }
  }, {
    key: "_reverseMainAxisLayoutPos",
    value: function _reverseMainAxisLayoutPos(item) {
      var endPos = item.flexItem._getMainAxisLayoutPos() + item.flexItem._getMainAxisLayoutSizeWithPaddingAndMargin();
      var reversedPos = this._layout.mainAxisSize - endPos;
      item.flexItem._setMainAxisLayoutPos(reversedPos);
    }
  }]);
  return ItemCoordinatesUpdater;
}();

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/flex/layout/FlexLayout.mjs






var FlexLayout = function () {
  function FlexLayout(flexContainer) {
    (0,classCallCheck/* default */.Z)(this, FlexLayout);
    this._flexContainer = flexContainer;
    this._lineLayouter = new LineLayouter(this);
    this._resizingMainAxis = false;
    this._resizingCrossAxis = false;
    this._cachedMainAxisSizeAfterLayout = 0;
    this._cachedCrossAxisSizeAfterLayout = 0;
    this._shrunk = false;
  }
  (0,createClass/* default */.Z)(FlexLayout, [{
    key: "shrunk",
    get: function get() {
      return this._shrunk;
    }
  }, {
    key: "recalc",
    get: function get() {
      return this.item.recalc;
    }
  }, {
    key: "layoutTree",
    value: function layoutTree() {
      var isSubTree = this.item.flexParent !== null;
      if (isSubTree) {
        this._updateSubTreeLayout();
      } else {
        this.updateTreeLayout();
      }
      this.updateItemCoords();
    }
  }, {
    key: "updateTreeLayout",
    value: function updateTreeLayout() {
      if (this.recalc) {
        this._performUpdateLayoutTree();
      } else {
        this._performUpdateLayoutTreeFromCache();
      }
    }
  }, {
    key: "_performUpdateLayoutTree",
    value: function _performUpdateLayoutTree() {
      this._setInitialAxisSizes();
      this._layoutAxes();
      this._refreshLayoutCache();
    }
  }, {
    key: "_refreshLayoutCache",
    value: function _refreshLayoutCache() {
      this._cachedMainAxisSizeAfterLayout = this.mainAxisSize;
      this._cachedCrossAxisSizeAfterLayout = this.crossAxisSize;
    }
  }, {
    key: "_performUpdateLayoutTreeFromCache",
    value: function _performUpdateLayoutTreeFromCache() {
      var sizeMightHaveChanged = this.item.funcW || this.item.funcH;
      if (sizeMightHaveChanged) {
        this.item.enableLocalRecalcFlag();
        this._performUpdateLayoutTree();
      } else {
        this.mainAxisSize = this._cachedMainAxisSizeAfterLayout;
        this.crossAxisSize = this._cachedCrossAxisSizeAfterLayout;
      }
    }
  }, {
    key: "updateItemCoords",
    value: function updateItemCoords() {
      var updater = new ItemCoordinatesUpdater(this);
      updater.finalize();
    }
  }, {
    key: "_updateSubTreeLayout",
    value: function _updateSubTreeLayout() {
      var crossAxisSize = this.crossAxisSize;
      this._layoutMainAxis();
      this.performResizeCrossAxis(crossAxisSize);
    }
  }, {
    key: "_setInitialAxisSizes",
    value: function _setInitialAxisSizes() {
      if (this.item.isFlexItemEnabled()) {
        this.item.flexItem._resetLayoutSize();
      } else {
        this.mainAxisSize = this._getMainAxisBasis();
        this.crossAxisSize = this._getCrossAxisBasis();
      }
      this._resizingMainAxis = false;
      this._resizingCrossAxis = false;
      this._shrunk = false;
    }
  }, {
    key: "_layoutAxes",
    value: function _layoutAxes() {
      this._layoutMainAxis();
      this._layoutCrossAxis();
    }
  }, {
    key: "_layoutMainAxis",
    value: function _layoutMainAxis() {
      this._layoutLines();
      this._fitMainAxisSizeToContents();
    }
  }, {
    key: "_layoutLines",
    value: function _layoutLines() {
      this._lineLayouter.layoutLines();
    }
  }, {
    key: "_lines",
    get: function get() {
      return this._lineLayouter.lines;
    }
  }, {
    key: "_fitMainAxisSizeToContents",
    value: function _fitMainAxisSizeToContents() {
      if (!this._resizingMainAxis) {
        if (this.isMainAxisFitToContents()) {
          this.mainAxisSize = this._lineLayouter.mainAxisContentSize;
        }
      }
    }
  }, {
    key: "_layoutCrossAxis",
    value: function _layoutCrossAxis() {
      var aligner = new ContentAligner(this);
      aligner.init();
      this._totalCrossAxisSize = aligner.totalCrossAxisSize;
      this._fitCrossAxisSizeToContents();
      aligner.align();
    }
  }, {
    key: "_fitCrossAxisSizeToContents",
    value: function _fitCrossAxisSizeToContents() {
      if (!this._resizingCrossAxis) {
        if (this.isCrossAxisFitToContents()) {
          this.crossAxisSize = this._totalCrossAxisSize;
        }
      }
    }
  }, {
    key: "isWrapping",
    value: function isWrapping() {
      return this._flexContainer.wrap;
    }
  }, {
    key: "isAxisFitToContents",
    value: function isAxisFitToContents(horizontal) {
      if (this._horizontal === horizontal) {
        return this.isMainAxisFitToContents();
      } else {
        return this.isCrossAxisFitToContents();
      }
    }
  }, {
    key: "isMainAxisFitToContents",
    value: function isMainAxisFitToContents() {
      return !this.isWrapping() && !this._hasFixedMainAxisBasis();
    }
  }, {
    key: "isCrossAxisFitToContents",
    value: function isCrossAxisFitToContents() {
      return !this._hasFixedCrossAxisBasis();
    }
  }, {
    key: "_hasFixedMainAxisBasis",
    value: function _hasFixedMainAxisBasis() {
      return !FlexUtils.isZeroAxisSize(this.item, this._horizontal);
    }
  }, {
    key: "_hasFixedCrossAxisBasis",
    value: function _hasFixedCrossAxisBasis() {
      return !FlexUtils.isZeroAxisSize(this.item, !this._horizontal);
    }
  }, {
    key: "getAxisMinSize",
    value: function getAxisMinSize(horizontal) {
      if (this._horizontal === horizontal) {
        return this._getMainAxisMinSize();
      } else {
        return this._getCrossAxisMinSize();
      }
    }
  }, {
    key: "_getMainAxisMinSize",
    value: function _getMainAxisMinSize() {
      return this._lineLayouter.mainAxisMinSize;
    }
  }, {
    key: "_getCrossAxisMinSize",
    value: function _getCrossAxisMinSize() {
      return this._lineLayouter.crossAxisMinSize;
    }
  }, {
    key: "resizeMainAxis",
    value: function resizeMainAxis(size) {
      if (this.mainAxisSize !== size) {
        if (this.recalc > 0) {
          this.performResizeMainAxis(size);
        } else {
          if (this._checkValidCacheMainAxisResize()) {
            this.mainAxisSize = size;
            this._fitCrossAxisSizeToContents();
          } else {
            this.item.enableLocalRecalcFlag();
            this.performResizeMainAxis(size);
          }
        }
      }
    }
  }, {
    key: "_checkValidCacheMainAxisResize",
    value: function _checkValidCacheMainAxisResize(size) {
      var isFinalMainAxisSize = size === this.targetMainAxisSize;
      if (isFinalMainAxisSize) {
        return true;
      }
      var canIgnoreCacheMiss = !this.isCrossAxisFitToContents();
      if (canIgnoreCacheMiss) {
        return true;
      }
      return false;
    }
  }, {
    key: "performResizeMainAxis",
    value: function performResizeMainAxis(size) {
      var isShrinking = size < this.mainAxisSize;
      this._shrunk = isShrinking;
      this.mainAxisSize = size;
      this._resizingMainAxis = true;
      this._layoutAxes();
      this._resizingMainAxis = false;
    }
  }, {
    key: "resizeCrossAxis",
    value: function resizeCrossAxis(size) {
      if (this.crossAxisSize !== size) {
        if (this.recalc > 0) {
          this.performResizeCrossAxis(size);
        } else {
          this.crossAxisSize = size;
        }
      }
    }
  }, {
    key: "performResizeCrossAxis",
    value: function performResizeCrossAxis(size) {
      this.crossAxisSize = size;
      this._resizingCrossAxis = true;
      this._layoutCrossAxis();
      this._resizingCrossAxis = false;
    }
  }, {
    key: "targetMainAxisSize",
    get: function get() {
      return this._horizontal ? this.item.target.w : this.item.target.h;
    }
  }, {
    key: "targetCrossAxisSize",
    get: function get() {
      return this._horizontal ? this.item.target.h : this.item.target.w;
    }
  }, {
    key: "getParentFlexContainer",
    value: function getParentFlexContainer() {
      return this.item.isFlexItemEnabled() ? this.item.flexItem.ctr : null;
    }
  }, {
    key: "_getHorizontalPadding",
    value: function _getHorizontalPadding() {
      return FlexUtils.getTotalPadding(this.item, true);
    }
  }, {
    key: "_getVerticalPadding",
    value: function _getVerticalPadding() {
      return FlexUtils.getTotalPadding(this.item, false);
    }
  }, {
    key: "_getHorizontalPaddingOffset",
    value: function _getHorizontalPaddingOffset() {
      return FlexUtils.getPaddingOffset(this.item, true);
    }
  }, {
    key: "_getVerticalPaddingOffset",
    value: function _getVerticalPaddingOffset() {
      return FlexUtils.getPaddingOffset(this.item, false);
    }
  }, {
    key: "_getMainAxisBasis",
    value: function _getMainAxisBasis() {
      return FlexUtils.getRelAxisSize(this.item, this._horizontal);
    }
  }, {
    key: "_getCrossAxisBasis",
    value: function _getCrossAxisBasis() {
      return FlexUtils.getRelAxisSize(this.item, !this._horizontal);
    }
  }, {
    key: "_horizontal",
    get: function get() {
      return this._flexContainer._horizontal;
    }
  }, {
    key: "_reverse",
    get: function get() {
      return this._flexContainer._reverse;
    }
  }, {
    key: "item",
    get: function get() {
      return this._flexContainer.item;
    }
  }, {
    key: "items",
    get: function get() {
      return this.item.items;
    }
  }, {
    key: "resizingMainAxis",
    get: function get() {
      return this._resizingMainAxis;
    }
  }, {
    key: "resizingCrossAxis",
    get: function get() {
      return this._resizingCrossAxis;
    }
  }, {
    key: "numberOfItems",
    get: function get() {
      return this.items.length;
    }
  }, {
    key: "mainAxisSize",
    get: function get() {
      return FlexUtils.getAxisLayoutSize(this.item, this._horizontal);
    },
    set: function set(v) {
      FlexUtils.setAxisLayoutSize(this.item, this._horizontal, v);
    }
  }, {
    key: "crossAxisSize",
    get: function get() {
      return FlexUtils.getAxisLayoutSize(this.item, !this._horizontal);
    },
    set: function set(v) {
      FlexUtils.setAxisLayoutSize(this.item, !this._horizontal, v);
    }
  }]);
  return FlexLayout;
}();

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/flex/FlexContainer.mjs





var FlexContainer = function () {
  function FlexContainer(item) {
    (0,classCallCheck/* default */.Z)(this, FlexContainer);
    this._item = item;
    this._layout = new FlexLayout(this);
    this._horizontal = true;
    this._reverse = false;
    this._wrap = false;
    this._alignItems = 'stretch';
    this._justifyContent = 'flex-start';
    this._alignContent = 'flex-start';
    this._paddingLeft = 0;
    this._paddingTop = 0;
    this._paddingRight = 0;
    this._paddingBottom = 0;
  }
  (0,createClass/* default */.Z)(FlexContainer, [{
    key: "item",
    get: function get() {
      return this._item;
    }
  }, {
    key: "_changedDimensions",
    value: function _changedDimensions() {
      this._item.changedDimensions();
    }
  }, {
    key: "_changedContents",
    value: function _changedContents() {
      this._item.changedContents();
    }
  }, {
    key: "direction",
    get: function get() {
      return (this._horizontal ? "row" : "column") + (this._reverse ? "-reverse" : "");
    },
    set: function set(f) {
      if (this.direction === f) return;
      this._horizontal = f === 'row' || f === 'row-reverse';
      this._reverse = f === 'row-reverse' || f === 'column-reverse';
      this._changedContents();
    }
  }, {
    key: "wrap",
    get: function get() {
      return this._wrap;
    },
    set: function set(v) {
      this._wrap = v;
      this._changedContents();
    }
  }, {
    key: "alignItems",
    get: function get() {
      return this._alignItems;
    },
    set: function set(v) {
      if (this._alignItems === v) return;
      if (FlexContainer.ALIGN_ITEMS.indexOf(v) === -1) {
        throw new Error("Unknown alignItems, options: " + FlexContainer.ALIGN_ITEMS.join(","));
      }
      this._alignItems = v;
      this._changedContents();
    }
  }, {
    key: "alignContent",
    get: function get() {
      return this._alignContent;
    },
    set: function set(v) {
      if (this._alignContent === v) return;
      if (FlexContainer.ALIGN_CONTENT.indexOf(v) === -1) {
        throw new Error("Unknown alignContent, options: " + FlexContainer.ALIGN_CONTENT.join(","));
      }
      this._alignContent = v;
      this._changedContents();
    }
  }, {
    key: "justifyContent",
    get: function get() {
      return this._justifyContent;
    },
    set: function set(v) {
      if (this._justifyContent === v) return;
      if (FlexContainer.JUSTIFY_CONTENT.indexOf(v) === -1) {
        throw new Error("Unknown justifyContent, options: " + FlexContainer.JUSTIFY_CONTENT.join(","));
      }
      this._justifyContent = v;
      this._changedContents();
    }
  }, {
    key: "padding",
    get: function get() {
      return this.paddingLeft;
    },
    set: function set(v) {
      this.paddingLeft = v;
      this.paddingTop = v;
      this.paddingRight = v;
      this.paddingBottom = v;
    }
  }, {
    key: "paddingLeft",
    get: function get() {
      return this._paddingLeft;
    },
    set: function set(v) {
      this._paddingLeft = v;
      this._changedDimensions();
    }
  }, {
    key: "paddingTop",
    get: function get() {
      return this._paddingTop;
    },
    set: function set(v) {
      this._paddingTop = v;
      this._changedDimensions();
    }
  }, {
    key: "paddingRight",
    get: function get() {
      return this._paddingRight;
    },
    set: function set(v) {
      this._paddingRight = v;
      this._changedDimensions();
    }
  }, {
    key: "paddingBottom",
    get: function get() {
      return this._paddingBottom;
    },
    set: function set(v) {
      this._paddingBottom = v;
      this._changedDimensions();
    }
  }, {
    key: "patch",
    value: function patch(settings) {
      Base.patchObject(this, settings);
    }
  }]);
  return FlexContainer;
}();

FlexContainer.ALIGN_ITEMS = ["flex-start", "flex-end", "center", "stretch"];
FlexContainer.ALIGN_CONTENT = ["flex-start", "flex-end", "center", "space-between", "space-around", "space-evenly", "stretch"];
FlexContainer.JUSTIFY_CONTENT = ["flex-start", "flex-end", "center", "space-between", "space-around", "space-evenly"];
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/flex/FlexItem.mjs






var FlexItem = function () {
  function FlexItem(item) {
    (0,classCallCheck/* default */.Z)(this, FlexItem);
    this._ctr = null;
    this._item = item;
    this._grow = 0;
    this._shrink = FlexItem.SHRINK_AUTO;
    this._alignSelf = undefined;
    this._minWidth = 0;
    this._minHeight = 0;
    this._maxWidth = 0;
    this._maxHeight = 0;
    this._marginLeft = 0;
    this._marginTop = 0;
    this._marginRight = 0;
    this._marginBottom = 0;
  }
  (0,createClass/* default */.Z)(FlexItem, [{
    key: "item",
    get: function get() {
      return this._item;
    }
  }, {
    key: "grow",
    get: function get() {
      return this._grow;
    },
    set: function set(v) {
      if (this._grow === v) return;
      this._grow = parseInt(v) || 0;
      this._changed();
    }
  }, {
    key: "shrink",
    get: function get() {
      if (this._shrink === FlexItem.SHRINK_AUTO) {
        return this._getDefaultShrink();
      }
      return this._shrink;
    },
    set: function set(v) {
      if (this._shrink === v) return;
      this._shrink = parseInt(v) || 0;
      this._changed();
    }
  }, {
    key: "_getDefaultShrink",
    value: function _getDefaultShrink() {
      if (this.item.isFlexEnabled()) {
        return 1;
      } else {
        return 0;
      }
    }
  }, {
    key: "alignSelf",
    get: function get() {
      return this._alignSelf;
    },
    set: function set(v) {
      if (this._alignSelf === v) return;
      if (v === undefined) {
        this._alignSelf = undefined;
      } else {
        if (FlexContainer.ALIGN_ITEMS.indexOf(v) === -1) {
          throw new Error("Unknown alignSelf, options: " + FlexContainer.ALIGN_ITEMS.join(","));
        }
        this._alignSelf = v;
      }
      this._changed();
    }
  }, {
    key: "minWidth",
    get: function get() {
      return this._minWidth;
    },
    set: function set(v) {
      this._minWidth = Math.max(0, v);
      this._item.changedDimensions(true, false);
    }
  }, {
    key: "minHeight",
    get: function get() {
      return this._minHeight;
    },
    set: function set(v) {
      this._minHeight = Math.max(0, v);
      this._item.changedDimensions(false, true);
    }
  }, {
    key: "maxWidth",
    get: function get() {
      return this._maxWidth;
    },
    set: function set(v) {
      this._maxWidth = Math.max(0, v);
      this._item.changedDimensions(true, false);
    }
  }, {
    key: "maxHeight",
    get: function get() {
      return this._maxHeight;
    },
    set: function set(v) {
      this._maxHeight = Math.max(0, v);
      this._item.changedDimensions(false, true);
    }
  }, {
    key: "margin",
    get: function get() {
      return this.marginLeft;
    },
    set: function set(v) {
      this.marginLeft = v;
      this.marginTop = v;
      this.marginRight = v;
      this.marginBottom = v;
    }
  }, {
    key: "marginLeft",
    get: function get() {
      return this._marginLeft;
    },
    set: function set(v) {
      this._marginLeft = v;
      this._changed();
    }
  }, {
    key: "marginTop",
    get: function get() {
      return this._marginTop;
    },
    set: function set(v) {
      this._marginTop = v;
      this._changed();
    }
  }, {
    key: "marginRight",
    get: function get() {
      return this._marginRight;
    },
    set: function set(v) {
      this._marginRight = v;
      this._changed();
    }
  }, {
    key: "marginBottom",
    get: function get() {
      return this._marginBottom;
    },
    set: function set(v) {
      this._marginBottom = v;
      this._changed();
    }
  }, {
    key: "_changed",
    value: function _changed() {
      if (this.ctr) this.ctr._changedContents();
    }
  }, {
    key: "ctr",
    get: function get() {
      return this._ctr;
    },
    set: function set(v) {
      this._ctr = v;
    }
  }, {
    key: "patch",
    value: function patch(settings) {
      Base.patchObject(this, settings);
    }
  }, {
    key: "_resetLayoutSize",
    value: function _resetLayoutSize() {
      this._resetHorizontalAxisLayoutSize();
      this._resetVerticalAxisLayoutSize();
    }
  }, {
    key: "_resetCrossAxisLayoutSize",
    value: function _resetCrossAxisLayoutSize() {
      if (this.ctr._horizontal) {
        this._resetVerticalAxisLayoutSize();
      } else {
        this._resetHorizontalAxisLayoutSize();
      }
    }
  }, {
    key: "_resetHorizontalAxisLayoutSize",
    value: function _resetHorizontalAxisLayoutSize() {
      var w = FlexUtils.getRelAxisSize(this.item, true);
      if (this._minWidth) {
        w = Math.max(this._minWidth, w);
      }
      if (this._maxWidth) {
        w = Math.min(this._maxWidth, w);
      }
      FlexUtils.setAxisLayoutSize(this.item, true, w);
    }
  }, {
    key: "_resetVerticalAxisLayoutSize",
    value: function _resetVerticalAxisLayoutSize() {
      var h = FlexUtils.getRelAxisSize(this.item, false);
      if (this._minHeight) {
        h = Math.max(this._minHeight, h);
      }
      if (this._maxHeight) {
        h = Math.min(this._maxHeight, h);
      }
      FlexUtils.setAxisLayoutSize(this.item, false, h);
    }
  }, {
    key: "_getCrossAxisMinSizeSetting",
    value: function _getCrossAxisMinSizeSetting() {
      return this._getMinSizeSetting(!this.ctr._horizontal);
    }
  }, {
    key: "_getCrossAxisMaxSizeSetting",
    value: function _getCrossAxisMaxSizeSetting() {
      return this._getMaxSizeSetting(!this.ctr._horizontal);
    }
  }, {
    key: "_getMainAxisMaxSizeSetting",
    value: function _getMainAxisMaxSizeSetting() {
      return this._getMaxSizeSetting(this.ctr._horizontal);
    }
  }, {
    key: "_getMinSizeSetting",
    value: function _getMinSizeSetting(horizontal) {
      if (horizontal) {
        return this._minWidth;
      } else {
        return this._minHeight;
      }
    }
  }, {
    key: "_getMaxSizeSetting",
    value: function _getMaxSizeSetting(horizontal) {
      if (horizontal) {
        return this._maxWidth;
      } else {
        return this._maxHeight;
      }
    }
  }, {
    key: "_getMainAxisMinSize",
    value: function _getMainAxisMinSize() {
      return FlexUtils.getAxisMinSize(this.item, this.ctr._horizontal);
    }
  }, {
    key: "_getCrossAxisMinSize",
    value: function _getCrossAxisMinSize() {
      return FlexUtils.getAxisMinSize(this.item, !this.ctr._horizontal);
    }
  }, {
    key: "_getMainAxisLayoutSize",
    value: function _getMainAxisLayoutSize() {
      return FlexUtils.getAxisLayoutSize(this.item, this.ctr._horizontal);
    }
  }, {
    key: "_getMainAxisLayoutPos",
    value: function _getMainAxisLayoutPos() {
      return FlexUtils.getAxisLayoutPos(this.item, this.ctr._horizontal);
    }
  }, {
    key: "_setMainAxisLayoutPos",
    value: function _setMainAxisLayoutPos(pos) {
      return FlexUtils.setAxisLayoutPos(this.item, this.ctr._horizontal, pos);
    }
  }, {
    key: "_setCrossAxisLayoutPos",
    value: function _setCrossAxisLayoutPos(pos) {
      return FlexUtils.setAxisLayoutPos(this.item, !this.ctr._horizontal, pos);
    }
  }, {
    key: "_getCrossAxisLayoutSize",
    value: function _getCrossAxisLayoutSize() {
      return FlexUtils.getAxisLayoutSize(this.item, !this.ctr._horizontal);
    }
  }, {
    key: "_resizeCrossAxis",
    value: function _resizeCrossAxis(size) {
      return FlexUtils.resizeAxis(this.item, !this.ctr._horizontal, size);
    }
  }, {
    key: "_resizeMainAxis",
    value: function _resizeMainAxis(size) {
      return FlexUtils.resizeAxis(this.item, this.ctr._horizontal, size);
    }
  }, {
    key: "_getMainAxisPadding",
    value: function _getMainAxisPadding() {
      return FlexUtils.getTotalPadding(this.item, this.ctr._horizontal);
    }
  }, {
    key: "_getCrossAxisPadding",
    value: function _getCrossAxisPadding() {
      return FlexUtils.getTotalPadding(this.item, !this.ctr._horizontal);
    }
  }, {
    key: "_getMainAxisMargin",
    value: function _getMainAxisMargin() {
      return FlexUtils.getTotalMargin(this.item, this.ctr._horizontal);
    }
  }, {
    key: "_getCrossAxisMargin",
    value: function _getCrossAxisMargin() {
      return FlexUtils.getTotalMargin(this.item, !this.ctr._horizontal);
    }
  }, {
    key: "_getHorizontalMarginOffset",
    value: function _getHorizontalMarginOffset() {
      return FlexUtils.getMarginOffset(this.item, true);
    }
  }, {
    key: "_getVerticalMarginOffset",
    value: function _getVerticalMarginOffset() {
      return FlexUtils.getMarginOffset(this.item, false);
    }
  }, {
    key: "_getMainAxisMinSizeWithPaddingAndMargin",
    value: function _getMainAxisMinSizeWithPaddingAndMargin() {
      return this._getMainAxisMinSize() + this._getMainAxisPadding() + this._getMainAxisMargin();
    }
  }, {
    key: "_getCrossAxisMinSizeWithPaddingAndMargin",
    value: function _getCrossAxisMinSizeWithPaddingAndMargin() {
      return this._getCrossAxisMinSize() + this._getCrossAxisPadding() + this._getCrossAxisMargin();
    }
  }, {
    key: "_getMainAxisLayoutSizeWithPaddingAndMargin",
    value: function _getMainAxisLayoutSizeWithPaddingAndMargin() {
      return this._getMainAxisLayoutSize() + this._getMainAxisPadding() + this._getMainAxisMargin();
    }
  }, {
    key: "_getCrossAxisLayoutSizeWithPaddingAndMargin",
    value: function _getCrossAxisLayoutSizeWithPaddingAndMargin() {
      return this._getCrossAxisLayoutSize() + this._getCrossAxisPadding() + this._getCrossAxisMargin();
    }
  }, {
    key: "_hasFixedCrossAxisSize",
    value: function _hasFixedCrossAxisSize() {
      return !FlexUtils.isZeroAxisSize(this.item, !this.ctr._horizontal);
    }
  }, {
    key: "_hasRelCrossAxisSize",
    value: function _hasRelCrossAxisSize() {
      return !!(this.ctr._horizontal ? this.item.funcH : this.item.funcW);
    }
  }]);
  return FlexItem;
}();

FlexItem.SHRINK_AUTO = -1;
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/flex/FlexTarget.mjs





var FlexTarget = function () {
  function FlexTarget(target) {
    (0,classCallCheck/* default */.Z)(this, FlexTarget);
    this._target = target;
    this._recalc = 0;
    this._enabled = false;
    this.x = 0;
    this.y = 0;
    this.w = 0;
    this.h = 0;
    this._originalX = 0;
    this._originalY = 0;
    this._originalWidth = 0;
    this._originalHeight = 0;
    this._flex = null;
    this._flexItem = null;
    this._flexItemDisabled = false;
    this._items = null;
  }
  (0,createClass/* default */.Z)(FlexTarget, [{
    key: "flexLayout",
    get: function get() {
      return this.flex ? this.flex._layout : null;
    }
  }, {
    key: "layoutFlexTree",
    value: function layoutFlexTree() {
      if (this.isFlexEnabled() && this.isChanged()) {
        this.flexLayout.layoutTree();
      }
    }
  }, {
    key: "target",
    get: function get() {
      return this._target;
    }
  }, {
    key: "flex",
    get: function get() {
      return this._flex;
    },
    set: function set(v) {
      if (!v) {
        if (this.isFlexEnabled()) {
          this._disableFlex();
        }
      } else {
        if (!this.isFlexEnabled()) {
          this._enableFlex();
        }
        this._flex.patch(v);
      }
    }
  }, {
    key: "flexItem",
    get: function get() {
      if (this._flexItemDisabled) {
        return false;
      }
      this._ensureFlexItem();
      return this._flexItem;
    },
    set: function set(v) {
      if (v === false) {
        if (!this._flexItemDisabled) {
          var parent = this.flexParent;
          this._flexItemDisabled = true;
          this._checkEnabled();
          if (parent) {
            parent._clearFlexItemsCache();
            parent.changedContents();
          }
        }
      } else {
        this._ensureFlexItem();
        this._flexItem.patch(v);
        if (this._flexItemDisabled) {
          this._flexItemDisabled = false;
          this._checkEnabled();
          var _parent = this.flexParent;
          if (_parent) {
            _parent._clearFlexItemsCache();
            _parent.changedContents();
          }
        }
      }
    }
  }, {
    key: "_enableFlex",
    value: function _enableFlex() {
      this._flex = new FlexContainer(this);
      this._checkEnabled();
      this.changedDimensions();
      this._enableChildrenAsFlexItems();
    }
  }, {
    key: "_disableFlex",
    value: function _disableFlex() {
      this.changedDimensions();
      this._flex = null;
      this._checkEnabled();
      this._disableChildrenAsFlexItems();
    }
  }, {
    key: "_enableChildrenAsFlexItems",
    value: function _enableChildrenAsFlexItems() {
      var children = this._target._children;
      if (children) {
        for (var i = 0, n = children.length; i < n; i++) {
          var child = children[i];
          child.layout._enableFlexItem();
        }
      }
    }
  }, {
    key: "_disableChildrenAsFlexItems",
    value: function _disableChildrenAsFlexItems() {
      var children = this._target._children;
      if (children) {
        for (var i = 0, n = children.length; i < n; i++) {
          var child = children[i];
          child.layout._disableFlexItem();
        }
      }
    }
  }, {
    key: "_enableFlexItem",
    value: function _enableFlexItem() {
      this._ensureFlexItem();
      var flexParent = this._target._parent._layout;
      this._flexItem.ctr = flexParent._flex;
      flexParent.changedContents();
      this._checkEnabled();
    }
  }, {
    key: "_disableFlexItem",
    value: function _disableFlexItem() {
      if (this._flexItem) {
        this._flexItem.ctr = null;
      }
      this._checkEnabled();
      this._resetOffsets();
    }
  }, {
    key: "_resetOffsets",
    value: function _resetOffsets() {
      this.x = 0;
      this.y = 0;
    }
  }, {
    key: "_ensureFlexItem",
    value: function _ensureFlexItem() {
      if (!this._flexItem) {
        this._flexItem = new FlexItem(this);
      }
    }
  }, {
    key: "_checkEnabled",
    value: function _checkEnabled() {
      var enabled = this.isEnabled();
      if (this._enabled !== enabled) {
        if (enabled) {
          this._enable();
        } else {
          this._disable();
        }
        this._enabled = enabled;
      }
    }
  }, {
    key: "_enable",
    value: function _enable() {
      this._setupTargetForFlex();
      this._target.enableFlexLayout();
    }
  }, {
    key: "_disable",
    value: function _disable() {
      this._restoreTargetToNonFlex();
      this._target.disableFlexLayout();
    }
  }, {
    key: "isEnabled",
    value: function isEnabled() {
      return this.isFlexEnabled() || this.isFlexItemEnabled();
    }
  }, {
    key: "isFlexEnabled",
    value: function isFlexEnabled() {
      return this._flex !== null;
    }
  }, {
    key: "isFlexItemEnabled",
    value: function isFlexItemEnabled() {
      return this.flexParent !== null;
    }
  }, {
    key: "_restoreTargetToNonFlex",
    value: function _restoreTargetToNonFlex() {
      var target = this._target;
      target.x = this._originalX;
      target.y = this._originalY;
      target.setDimensions(this._originalWidth, this._originalHeight);
    }
  }, {
    key: "_setupTargetForFlex",
    value: function _setupTargetForFlex() {
      var target = this._target;
      this._originalX = target._x;
      this._originalY = target._y;
      this._originalWidth = target._w;
      this._originalHeight = target._h;
    }
  }, {
    key: "setParent",
    value: function setParent(from, to) {
      if (from && from.isFlexContainer()) {
        from._layout._changedChildren();
      }
      if (to && to.isFlexContainer()) {
        this._enableFlexItem();
        to._layout._changedChildren();
      }
      this._checkEnabled();
    }
  }, {
    key: "flexParent",
    get: function get() {
      if (this._flexItemDisabled) {
        return null;
      }
      var parent = this._target._parent;
      if (parent && parent.isFlexContainer()) {
        return parent._layout;
      }
      return null;
    }
  }, {
    key: "setVisible",
    value: function setVisible(v) {
      var parent = this.flexParent;
      if (parent) {
        parent._changedChildren();
      }
    }
  }, {
    key: "items",
    get: function get() {
      if (!this._items) {
        this._items = this._getFlexItems();
      }
      return this._items;
    }
  }, {
    key: "_getFlexItems",
    value: function _getFlexItems() {
      var items = [];
      var children = this._target._children;
      if (children) {
        for (var i = 0, n = children.length; i < n; i++) {
          var item = children[i];
          if (item.visible) {
            if (item.isFlexItem()) {
              items.push(item.layout);
            }
          }
        }
      }
      return items;
    }
  }, {
    key: "_changedChildren",
    value: function _changedChildren() {
      this._clearFlexItemsCache();
      this.changedContents();
    }
  }, {
    key: "_clearFlexItemsCache",
    value: function _clearFlexItemsCache() {
      this._items = null;
    }
  }, {
    key: "setLayout",
    value: function setLayout(x, y, w, h) {
      var originalX = this._originalX;
      var originalY = this._originalY;
      if (this.funcX) {
        originalX = this.funcX(FlexUtils.getParentAxisSizeWithPadding(this, true));
      }
      if (this.funcY) {
        originalY = this.funcY(FlexUtils.getParentAxisSizeWithPadding(this, false));
      }
      if (this.isFlexItemEnabled()) {
        this.target.setLayout(x + originalX, y + originalY, w, h);
      } else {
        this.target.setLayout(originalX, originalY, w, h);
      }
    }
  }, {
    key: "changedDimensions",
    value: function changedDimensions() {
      var changeWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var changeHeight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this._updateRecalc(changeWidth, changeHeight);
    }
  }, {
    key: "changedContents",
    value: function changedContents() {
      this._updateRecalc();
    }
  }, {
    key: "forceLayout",
    value: function forceLayout() {
      this._updateRecalc();
    }
  }, {
    key: "isChanged",
    value: function isChanged() {
      return this._recalc > 0;
    }
  }, {
    key: "_updateRecalc",
    value: function _updateRecalc() {
      var changeExternalWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var changeExternalHeight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (this.isFlexEnabled()) {
        var layout = this._flex._layout;
        changeExternalWidth = changeExternalWidth || layout.isAxisFitToContents(true);
        changeExternalHeight = changeExternalHeight || layout.isAxisFitToContents(false);
      }
      var recalc = 1 + (changeExternalWidth ? 2 : 0) + (changeExternalHeight ? 4 : 0);
      var newRecalcFlags = this.getNewRecalcFlags(recalc);
      this._recalc |= recalc;
      if (newRecalcFlags > 1) {
        if (this.flexParent) {
          this.flexParent._updateRecalcBottomUp(recalc);
        } else {
          this._target.triggerLayout();
        }
      } else {
        this._target.triggerLayout();
      }
    }
  }, {
    key: "getNewRecalcFlags",
    value: function getNewRecalcFlags(flags) {
      return 7 - this._recalc & flags;
    }
  }, {
    key: "_updateRecalcBottomUp",
    value: function _updateRecalcBottomUp(childRecalc) {
      var newRecalc = this._getRecalcFromChangedChildRecalc(childRecalc);
      var newRecalcFlags = this.getNewRecalcFlags(newRecalc);
      this._recalc |= newRecalc;
      if (newRecalcFlags > 1) {
        var flexParent = this.flexParent;
        if (flexParent) {
          flexParent._updateRecalcBottomUp(newRecalc);
        } else {
          this._target.triggerLayout();
        }
      } else {
        this._target.triggerLayout();
      }
    }
  }, {
    key: "_getRecalcFromChangedChildRecalc",
    value: function _getRecalcFromChangedChildRecalc(childRecalc) {
      var layout = this._flex._layout;
      var mainAxisRecalcFlag = layout._horizontal ? 1 : 2;
      var crossAxisRecalcFlag = layout._horizontal ? 2 : 1;
      var crossAxisDimensionsChangedInChild = childRecalc & crossAxisRecalcFlag;
      if (!crossAxisDimensionsChangedInChild) {
        var mainAxisDimensionsChangedInChild = childRecalc & mainAxisRecalcFlag;
        if (mainAxisDimensionsChangedInChild) {
          var mainAxisIsWrapping = layout.isWrapping();
          if (mainAxisIsWrapping) {
            var crossAxisIsFitToContents = layout.isCrossAxisFitToContents();
            if (crossAxisIsFitToContents) {
              childRecalc += crossAxisRecalcFlag;
            }
          }
        }
      }
      var isWidthDynamic = layout.isAxisFitToContents(true);
      var isHeightDynamic = layout.isAxisFitToContents(false);
      if (layout.shrunk) {
        if (layout._horizontal) {
          isWidthDynamic = true;
        } else {
          isHeightDynamic = true;
        }
      }
      var localRecalc = 1 + (isWidthDynamic ? 2 : 0) + (isHeightDynamic ? 4 : 0);
      var combinedRecalc = childRecalc & localRecalc;
      return combinedRecalc;
    }
  }, {
    key: "recalc",
    get: function get() {
      return this._recalc;
    }
  }, {
    key: "clearRecalcFlag",
    value: function clearRecalcFlag() {
      this._recalc = 0;
    }
  }, {
    key: "enableLocalRecalcFlag",
    value: function enableLocalRecalcFlag() {
      this._recalc = 1;
    }
  }, {
    key: "originalX",
    get: function get() {
      return this._originalX;
    }
  }, {
    key: "setOriginalXWithoutUpdatingLayout",
    value: function setOriginalXWithoutUpdatingLayout(v) {
      this._originalX = v;
    }
  }, {
    key: "originalY",
    get: function get() {
      return this._originalY;
    }
  }, {
    key: "setOriginalYWithoutUpdatingLayout",
    value: function setOriginalYWithoutUpdatingLayout(v) {
      this._originalY = v;
    }
  }, {
    key: "originalWidth",
    get: function get() {
      return this._originalWidth;
    },
    set: function set(v) {
      if (this._originalWidth !== v) {
        this._originalWidth = v;
        this.changedDimensions(true, false);
      }
    }
  }, {
    key: "originalHeight",
    get: function get() {
      return this._originalHeight;
    },
    set: function set(v) {
      if (this._originalHeight !== v) {
        this._originalHeight = v;
        this.changedDimensions(false, true);
      }
    }
  }, {
    key: "funcX",
    get: function get() {
      return this._target.funcX;
    }
  }, {
    key: "funcY",
    get: function get() {
      return this._target.funcY;
    }
  }, {
    key: "funcW",
    get: function get() {
      return this._target.funcW;
    }
  }, {
    key: "funcH",
    get: function get() {
      return this._target.funcH;
    }
  }]);
  return FlexTarget;
}();

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/tree/TextureSource.mjs









var TextureSource = function () {
  function TextureSource(manager) {
    var loader = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    (0,classCallCheck/* default */.Z)(this, TextureSource);
    this.id = TextureSource.id++;
    this.manager = manager;
    this.stage = manager.stage;
    this.textures = new Set();
    this._activeTextureCount = 0;
    this.loader = loader;
    this.lookupId = null;
    this._cancelCb = null;
    this.loadingSince = 0;
    this.w = 0;
    this.h = 0;
    this._nativeTexture = null;
    this.permanent = false;
    this.renderInfo = null;
    this._isResultTexture = !this.loader;
    this._loadError = null;
    this._imageRef = null;
    this._hasAlpha = false;
  }
  (0,createClass/* default */.Z)(TextureSource, [{
    key: "hasAlpha",
    get: function get() {
      return this._hasAlpha;
    }
  }, {
    key: "loadError",
    get: function get() {
      return this._loadError;
    }
  }, {
    key: "addTexture",
    value: function addTexture(v) {
      if (!this.textures.has(v)) {
        this.textures.add(v);
      }
    }
  }, {
    key: "removeTexture",
    value: function removeTexture(v) {
      this.textures.delete(v);
    }
  }, {
    key: "incActiveTextureCount",
    value: function incActiveTextureCount() {
      this._activeTextureCount++;
      if (this._activeTextureCount === 1) {
        this.becomesUsed();
      }
    }
  }, {
    key: "decActiveTextureCount",
    value: function decActiveTextureCount() {
      this._activeTextureCount--;
      if (this._activeTextureCount === 0) {
        this.becomesUnused();
      }
    }
  }, {
    key: "isResultTexture",
    get: function get() {
      return this._isResultTexture;
    },
    set: function set(v) {
      this._isResultTexture = v;
    }
  }, {
    key: "forEachEnabledElement",
    value: function forEachEnabledElement(cb) {
      this.textures.forEach(function (texture) {
        texture.elements.forEach(cb);
      });
    }
  }, {
    key: "hasEnabledElements",
    value: function hasEnabledElements() {
      return this.textures.size > 0;
    }
  }, {
    key: "forEachActiveElement",
    value: function forEachActiveElement(cb) {
      this.textures.forEach(function (texture) {
        texture.elements.forEach(function (element) {
          if (element.active) {
            cb(element);
          }
        });
      });
    }
  }, {
    key: "getRenderWidth",
    value: function getRenderWidth() {
      return this.w;
    }
  }, {
    key: "getRenderHeight",
    value: function getRenderHeight() {
      return this.h;
    }
  }, {
    key: "allowCleanup",
    value: function allowCleanup() {
      return !this.permanent && !this.isUsed();
    }
  }, {
    key: "becomesUsed",
    value: function becomesUsed() {
      this.load();
    }
  }, {
    key: "becomesUnused",
    value: function becomesUnused() {
      this.cancel();
    }
  }, {
    key: "cancel",
    value: function cancel() {
      if (this.isLoading()) {
        if (this._cancelCb) {
          this._cancelCb(this);
          this._cancelCb = null;
        }
        this.loadingSince = 0;
      }
    }
  }, {
    key: "isLoaded",
    value: function isLoaded() {
      return !!this._nativeTexture;
    }
  }, {
    key: "isLoading",
    value: function isLoading() {
      return this.loadingSince > 0;
    }
  }, {
    key: "isError",
    value: function isError() {
      return !!this._loadError;
    }
  }, {
    key: "reload",
    value: function reload() {
      this.free();
      if (this.isUsed()) {
        this.load();
      }
    }
  }, {
    key: "load",
    value: function load() {
      var _this = this;
      var forceSync = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (this.isResultTexture) {
        return;
      }
      if (!this._nativeTexture && !this.isLoading()) {
        this.loadingSince = new Date().getTime();
        this._cancelCb = this.loader(function (err, options) {
          if (_this.isLoading()) {
            _this._cancelCb = null;
            if (_this.manager.stage.destroyed) {
              return;
            }
            if (err) {
              _this.onError(err);
            } else if (options && options.source) {
              if (!_this.stage.isUpdatingFrame() && !forceSync && options.throttle !== false) {
                var textureThrottler = _this.stage.textureThrottler;
                _this._cancelCb = textureThrottler.genericCancelCb;
                textureThrottler.add(_this, options);
              } else {
                _this.processLoadedSource(options);
              }
            }
          }
        }, this);
      }
    }
  }, {
    key: "processLoadedSource",
    value: function processLoadedSource(options) {
      this.loadingSince = 0;
      this.setSource(options);
    }
  }, {
    key: "setSource",
    value: function setSource(options) {
      var source = options.source;
      this._hasAlpha = options ? options.hasAlpha || false : false;
      this.w = source.width || options && options.w || 0;
      this.h = source.height || options && options.h || 0;
      if (options && options.renderInfo) {
        this.renderInfo = options.renderInfo;
      }
      this.permanent = !!options.permanent;
      if (options && options.imageRef) this._imageRef = options.imageRef;
      if (options && options.flipTextureY) {
        this._flipTextureY = options.flipTextureY;
      } else {
        this._flipTextureY = false;
      }
      if (this._isNativeTexture(source)) {
        this._nativeTexture = source;
        this.w = this.w || source.w;
        this.h = this.h || source.h;
        this.permanent = options.hasOwnProperty('permanent') ? options.permanent : true;
      } else {
        this.manager.uploadTextureSource(this, options);
      }
      this._loadError = null;
      this.onLoad();
    }
  }, {
    key: "isUsed",
    value: function isUsed() {
      return this._activeTextureCount > 0;
    }
  }, {
    key: "onLoad",
    value: function onLoad() {
      if (this.isUsed()) {
        this.textures.forEach(function (texture) {
          texture.onLoad();
        });
      }
    }
  }, {
    key: "forceRenderUpdate",
    value: function forceRenderUpdate() {
      if (this._nativeTexture) {
        this._nativeTexture.update = this.stage.frameCounter;
      }
      this.forEachActiveElement(function (element) {
        element.forceRenderUpdate();
      });
    }
  }, {
    key: "forceUpdateRenderCoords",
    value: function forceUpdateRenderCoords() {
      this.forEachActiveElement(function (element) {
        element._updateTextureCoords();
      });
    }
  }, {
    key: "nativeTexture",
    get: function get() {
      return this._nativeTexture;
    }
  }, {
    key: "clearNativeTexture",
    value: function clearNativeTexture() {
      this._nativeTexture = null;
      this._imageRef = null;
    }
  }, {
    key: "replaceNativeTexture",
    value: function replaceNativeTexture(newNativeTexture, w, h) {
      var prevNativeTexture = this._nativeTexture;
      this._nativeTexture = newNativeTexture;
      this.w = w;
      this.h = h;
      if (!prevNativeTexture && this._nativeTexture) {
        this.forEachActiveElement(function (element) {
          return element.onTextureSourceLoaded();
        });
      }
      if (!this._nativeTexture) {
        this.forEachActiveElement(function (element) {
          return element._setDisplayedTexture(null);
        });
      }
      this.forEachEnabledElement(function (element) {
        return element._updateDimensions();
      });
    }
  }, {
    key: "onError",
    value: function onError(e) {
      this._loadError = e;
      this.loadingSince = 0;
      console.error('[Lightning] texture load error', e, this.lookupId);
      this.forEachActiveElement(function (element) {
        return element.onTextureSourceLoadError(e);
      });
    }
  }, {
    key: "free",
    value: function free() {
      if (this.isLoaded()) {
        this.manager.freeTextureSource(this);
      }
    }
  }, {
    key: "_isNativeTexture",
    value: function _isNativeTexture(source) {
      if (Utils_Utils.isNode) {
        return source.constructor.name === "WebGLTexture";
      }
      if ('WebGLTexture' in window) {
        return source instanceof WebGLTexture;
      }
      return false;
    }
  }]);
  return TextureSource;
}();

TextureSource.prototype.isTextureSource = true;
TextureSource.id = 1;

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/tree/core/ElementTexturizer.mjs



var ElementTexturizer = function () {
  function ElementTexturizer(elementCore) {
    (0,classCallCheck/* default */.Z)(this, ElementTexturizer);
    this._element = elementCore.element;
    this._core = elementCore;
    this.ctx = this._core.ctx;
    this._enabled = false;
    this.lazy = false;
    this._colorize = false;
    this._renderTexture = null;
    this._renderTextureReused = false;
    this._resultTextureSource = null;
    this._renderOffscreen = false;
    this.empty = false;
  }
  (0,createClass/* default */.Z)(ElementTexturizer, [{
    key: "enabled",
    get: function get() {
      return this._enabled;
    },
    set: function set(v) {
      this._enabled = v;
      this._core.updateRenderToTextureEnabled();
    }
  }, {
    key: "renderOffscreen",
    get: function get() {
      return this._renderOffscreen;
    },
    set: function set(v) {
      this._renderOffscreen = v;
      this._core.setHasRenderUpdates(1);
      this._core._setRecalc(6);
    }
  }, {
    key: "colorize",
    get: function get() {
      return this._colorize;
    },
    set: function set(v) {
      if (this._colorize !== v) {
        this._colorize = v;
        this._core.setHasRenderUpdates(1);
      }
    }
  }, {
    key: "_getTextureSource",
    value: function _getTextureSource() {
      if (!this._resultTextureSource) {
        this._resultTextureSource = new TextureSource(this._element.stage.textureManager);
        this.updateResultTexture();
      }
      return this._resultTextureSource;
    }
  }, {
    key: "hasResultTexture",
    value: function hasResultTexture() {
      return !!this._resultTextureSource;
    }
  }, {
    key: "resultTextureInUse",
    value: function resultTextureInUse() {
      return this._resultTextureSource && this._resultTextureSource.hasEnabledElements();
    }
  }, {
    key: "updateResultTexture",
    value: function updateResultTexture() {
      var resultTexture = this.getResultTexture();
      if (this._resultTextureSource) {
        if (this._resultTextureSource.nativeTexture !== resultTexture) {
          var w = resultTexture ? resultTexture.w : 0;
          var h = resultTexture ? resultTexture.h : 0;
          this._resultTextureSource.replaceNativeTexture(resultTexture, w, h);
        }
        this._resultTextureSource.forEachEnabledElement(function (element) {
          element._updateDimensions();
          element.core.setHasRenderUpdates(3);
        });
      }
    }
  }, {
    key: "mustRenderToTexture",
    value: function mustRenderToTexture() {
      if (this._enabled && !this.lazy) {
        return true;
      } else if (this._enabled && this.lazy && this._core._hasRenderUpdates < 3) {
        return true;
      }
      return false;
    }
  }, {
    key: "deactivate",
    value: function deactivate() {
      this.release();
    }
  }, {
    key: "renderTextureReused",
    get: function get() {
      return this._renderTextureReused;
    }
  }, {
    key: "release",
    value: function release() {
      this.releaseRenderTexture();
    }
  }, {
    key: "releaseRenderTexture",
    value: function releaseRenderTexture() {
      if (this._renderTexture) {
        if (!this._renderTextureReused) {
          this.ctx.releaseRenderTexture(this._renderTexture);
        }
        this._renderTexture = null;
        this._renderTextureReused = false;
        this.updateResultTexture();
      }
    }
  }, {
    key: "reuseTextureAsRenderTexture",
    value: function reuseTextureAsRenderTexture(nativeTexture) {
      if (this._renderTexture !== nativeTexture) {
        this.releaseRenderTexture();
        this._renderTexture = nativeTexture;
        this._renderTextureReused = true;
      }
    }
  }, {
    key: "hasRenderTexture",
    value: function hasRenderTexture() {
      return !!this._renderTexture;
    }
  }, {
    key: "getRenderTexture",
    value: function getRenderTexture() {
      if (!this._renderTexture) {
        this._renderTexture = this.ctx.allocateRenderTexture(this._core._w, this._core._h);
        this._renderTextureReused = false;
      }
      return this._renderTexture;
    }
  }, {
    key: "getResultTexture",
    value: function getResultTexture() {
      return this._renderTexture;
    }
  }]);
  return ElementTexturizer;
}();

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/tree/core/ElementCore.mjs







var ElementCore = function () {
  function ElementCore(element) {
    (0,classCallCheck/* default */.Z)(this, ElementCore);
    this._element = element;
    this.ctx = element.stage.ctx;
    this._recalc = 0;
    this._parent = null;
    this._onUpdate = null;
    this._pRecalc = 0;
    this._worldContext = new ElementCoreContext();
    this._hasUpdates = false;
    this._localAlpha = 1;
    this._onAfterCalcs = null;
    this._onAfterUpdate = null;
    this._localPx = 0;
    this._localPy = 0;
    this._localTa = 1;
    this._localTb = 0;
    this._localTc = 0;
    this._localTd = 1;
    this._isComplex = false;
    this._dimsUnknown = false;
    this._clipping = false;
    this._zSort = false;
    this._outOfBounds = 0;
    this._displayedTextureSource = null;
    this._zContextUsage = 0;
    this._children = null;
    this._hasRenderUpdates = 0;
    this._zIndexedChildren = null;
    this._renderContext = this._worldContext;
    this.renderState = this.ctx.renderState;
    this._scissor = null;
    this._shaderOwner = null;
    this._updateTreeOrder = 0;
    this._colorUl = this._colorUr = this._colorBl = this._colorBr = 0xFFFFFFFF;
    this._x = 0;
    this._y = 0;
    this._w = 0;
    this._h = 0;
    this._optFlags = 0;
    this._funcX = null;
    this._funcY = null;
    this._funcW = null;
    this._funcH = null;
    this._scaleX = 1;
    this._scaleY = 1;
    this._pivotX = 0.5;
    this._pivotY = 0.5;
    this._mountX = 0;
    this._mountY = 0;
    this._rotation = 0;
    this._alpha = 1;
    this._visible = true;
    this._ulx = 0;
    this._uly = 0;
    this._brx = 1;
    this._bry = 1;
    this._zIndex = 0;
    this._forceZIndexContext = false;
    this._zParent = null;
    this._isRoot = false;
    this._zIndexResort = false;
    this._shader = null;
    this._renderToTextureEnabled = false;
    this._texturizer = null;
    this._useRenderToTexture = false;
    this._boundsMargin = null;
    this._recBoundsMargin = null;
    this._withinBoundsMargin = false;
    this._viewport = null;
    this._clipbox = true;
    this.render = this._renderSimple;
    this._layout = null;
  }
  (0,createClass/* default */.Z)(ElementCore, [{
    key: "offsetX",
    get: function get() {
      if (this._funcX) {
        return this._funcX;
      } else {
        if (this.hasFlexLayout()) {
          return this._layout.originalX;
        } else {
          return this._x;
        }
      }
    },
    set: function set(v) {
      if (Utils_Utils.isFunction(v)) {
        this.funcX = v;
      } else {
        this._disableFuncX();
        if (this.hasFlexLayout()) {
          this.x += v - this._layout.originalX;
          this._layout.setOriginalXWithoutUpdatingLayout(v);
        } else {
          this.x = v;
        }
      }
    }
  }, {
    key: "x",
    get: function get() {
      return this._x;
    },
    set: function set(v) {
      if (v !== this._x) {
        this._updateLocalTranslateDelta(v - this._x, 0);
        this._x = v;
      }
    }
  }, {
    key: "funcX",
    get: function get() {
      return this._optFlags & 1 ? this._funcX : null;
    },
    set: function set(v) {
      if (this._funcX !== v) {
        this._optFlags |= 1;
        this._funcX = v;
        if (this.hasFlexLayout()) {
          this._layout.setOriginalXWithoutUpdatingLayout(0);
          this.layout.forceLayout();
        } else {
          this._x = 0;
          this._triggerRecalcTranslate();
        }
      }
    }
  }, {
    key: "_disableFuncX",
    value: function _disableFuncX() {
      this._optFlags = this._optFlags & 0xFFFF - 1;
      this._funcX = null;
    }
  }, {
    key: "offsetY",
    get: function get() {
      if (this._funcY) {
        return this._funcY;
      } else {
        if (this.hasFlexLayout()) {
          return this._layout.originalY;
        } else {
          return this._y;
        }
      }
    },
    set: function set(v) {
      if (Utils_Utils.isFunction(v)) {
        this.funcY = v;
      } else {
        this._disableFuncY();
        if (this.hasFlexLayout()) {
          this.y += v - this._layout.originalY;
          this._layout.setOriginalYWithoutUpdatingLayout(v);
        } else {
          this.y = v;
        }
      }
    }
  }, {
    key: "y",
    get: function get() {
      return this._y;
    },
    set: function set(v) {
      if (v !== this._y) {
        this._updateLocalTranslateDelta(0, v - this._y);
        this._y = v;
      }
    }
  }, {
    key: "funcY",
    get: function get() {
      return this._optFlags & 2 ? this._funcY : null;
    },
    set: function set(v) {
      if (this._funcY !== v) {
        this._optFlags |= 2;
        this._funcY = v;
        if (this.hasFlexLayout()) {
          this._layout.setOriginalYWithoutUpdatingLayout(0);
          this.layout.forceLayout();
        } else {
          this._y = 0;
          this._triggerRecalcTranslate();
        }
      }
    }
  }, {
    key: "_disableFuncY",
    value: function _disableFuncY() {
      this._optFlags = this._optFlags & 0xFFFF - 2;
      this._funcY = null;
    }
  }, {
    key: "funcW",
    get: function get() {
      return this._optFlags & 4 ? this._funcW : null;
    },
    set: function set(v) {
      if (this._funcW !== v) {
        this._optFlags |= 4;
        this._funcW = v;
        if (this.hasFlexLayout()) {
          this._layout._originalWidth = 0;
          this.layout.changedDimensions(true, false);
        } else {
          this._w = 0;
          this._triggerRecalcTranslate();
        }
      }
    }
  }, {
    key: "disableFuncW",
    value: function disableFuncW() {
      this._optFlags = this._optFlags & 0xFFFF - 4;
      this._funcW = null;
    }
  }, {
    key: "funcH",
    get: function get() {
      return this._optFlags & 8 ? this._funcH : null;
    },
    set: function set(v) {
      if (this._funcH !== v) {
        this._optFlags |= 8;
        this._funcH = v;
        if (this.hasFlexLayout()) {
          this._layout._originalHeight = 0;
          this.layout.changedDimensions(false, true);
        } else {
          this._h = 0;
          this._triggerRecalcTranslate();
        }
      }
    }
  }, {
    key: "disableFuncH",
    value: function disableFuncH() {
      this._optFlags = this._optFlags & 0xFFFF - 8;
      this._funcH = null;
    }
  }, {
    key: "w",
    get: function get() {
      return this._w;
    }
  }, {
    key: "getRenderWidth",
    value: function getRenderWidth() {
      if (this.hasFlexLayout()) {
        return this._layout.originalWidth;
      } else {
        return this._w;
      }
    }
  }, {
    key: "h",
    get: function get() {
      return this._h;
    }
  }, {
    key: "getRenderHeight",
    value: function getRenderHeight() {
      if (this.hasFlexLayout()) {
        return this._layout.originalHeight;
      } else {
        return this._h;
      }
    }
  }, {
    key: "scaleX",
    get: function get() {
      return this._scaleX;
    },
    set: function set(v) {
      if (this._scaleX !== v) {
        this._scaleX = v;
        this._updateLocalTransform();
      }
    }
  }, {
    key: "scaleY",
    get: function get() {
      return this._scaleY;
    },
    set: function set(v) {
      if (this._scaleY !== v) {
        this._scaleY = v;
        this._updateLocalTransform();
      }
    }
  }, {
    key: "scale",
    get: function get() {
      return this.scaleX;
    },
    set: function set(v) {
      if (this._scaleX !== v || this._scaleY !== v) {
        this._scaleX = v;
        this._scaleY = v;
        this._updateLocalTransform();
      }
    }
  }, {
    key: "pivotX",
    get: function get() {
      return this._pivotX;
    },
    set: function set(v) {
      if (this._pivotX !== v) {
        this._pivotX = v;
        this._updateLocalTranslate();
      }
    }
  }, {
    key: "pivotY",
    get: function get() {
      return this._pivotY;
    },
    set: function set(v) {
      if (this._pivotY !== v) {
        this._pivotY = v;
        this._updateLocalTranslate();
      }
    }
  }, {
    key: "pivot",
    get: function get() {
      return this._pivotX;
    },
    set: function set(v) {
      if (this._pivotX !== v || this._pivotY !== v) {
        this._pivotX = v;
        this._pivotY = v;
        this._updateLocalTranslate();
      }
    }
  }, {
    key: "mountX",
    get: function get() {
      return this._mountX;
    },
    set: function set(v) {
      if (this._mountX !== v) {
        this._mountX = v;
        this._updateLocalTranslate();
      }
    }
  }, {
    key: "mountY",
    get: function get() {
      return this._mountY;
    },
    set: function set(v) {
      if (this._mountY !== v) {
        this._mountY = v;
        this._updateLocalTranslate();
      }
    }
  }, {
    key: "mount",
    get: function get() {
      return this._mountX;
    },
    set: function set(v) {
      if (this._mountX !== v || this._mountY !== v) {
        this._mountX = v;
        this._mountY = v;
        this._updateLocalTranslate();
      }
    }
  }, {
    key: "rotation",
    get: function get() {
      return this._rotation;
    },
    set: function set(v) {
      if (this._rotation !== v) {
        this._rotation = v;
        this._updateLocalTransform();
      }
    }
  }, {
    key: "alpha",
    get: function get() {
      return this._alpha;
    },
    set: function set(v) {
      v = v > 1 ? 1 : v < 1e-14 ? 0 : v;
      if (this._alpha !== v) {
        var prev = this._alpha;
        this._alpha = v;
        this._updateLocalAlpha();
        if (prev === 0 !== (v === 0)) {
          this._element._updateEnabledFlag();
        }
      }
    }
  }, {
    key: "visible",
    get: function get() {
      return this._visible;
    },
    set: function set(v) {
      if (this._visible !== v) {
        this._visible = v;
        this._updateLocalAlpha();
        this._element._updateEnabledFlag();
        if (this.hasFlexLayout()) {
          this.layout.setVisible(v);
        }
      }
    }
  }, {
    key: "_updateLocalTransform",
    value: function _updateLocalTransform() {
      if (this._rotation !== 0 && this._rotation % (2 * Math.PI)) {
        var _sr = Math.sin(this._rotation);
        var _cr = Math.cos(this._rotation);
        this._setLocalTransform(_cr * this._scaleX, -_sr * this._scaleY, _sr * this._scaleX, _cr * this._scaleY);
      } else {
        this._setLocalTransform(this._scaleX, 0, 0, this._scaleY);
      }
      this._updateLocalTranslate();
    }
  }, {
    key: "_updateLocalTranslate",
    value: function _updateLocalTranslate() {
      this._recalcLocalTranslate();
      this._triggerRecalcTranslate();
    }
  }, {
    key: "_recalcLocalTranslate",
    value: function _recalcLocalTranslate() {
      var pivotXMul = this._pivotX * this._w;
      var pivotYMul = this._pivotY * this._h;
      var px = this._x - (pivotXMul * this._localTa + pivotYMul * this._localTb) + pivotXMul;
      var py = this._y - (pivotXMul * this._localTc + pivotYMul * this._localTd) + pivotYMul;
      px -= this._mountX * this._w;
      py -= this._mountY * this._h;
      this._localPx = px;
      this._localPy = py;
    }
  }, {
    key: "_updateLocalTranslateDelta",
    value: function _updateLocalTranslateDelta(dx, dy) {
      this._addLocalTranslate(dx, dy);
    }
  }, {
    key: "_updateLocalAlpha",
    value: function _updateLocalAlpha() {
      this._setLocalAlpha(this._visible ? this._alpha : 0);
    }
  }, {
    key: "setHasRenderUpdates",
    value: function setHasRenderUpdates(type) {
      if (this._worldContext.alpha) {
        var p = this;
        p._hasRenderUpdates = Math.max(type, p._hasRenderUpdates);
        while ((p = p._parent) && p._hasRenderUpdates !== 3) {
          p._hasRenderUpdates = 3;
        }
      }
    }
  }, {
    key: "_setRecalc",
    value: function _setRecalc(type) {
      this._recalc |= type;
      this._setHasUpdates();
      if (this._parent) {
        this._parent.setHasRenderUpdates(3);
      }
    }
  }, {
    key: "_setHasUpdates",
    value: function _setHasUpdates() {
      var p = this;
      while (p && !p._hasUpdates) {
        p._hasUpdates = true;
        p = p._parent;
      }
    }
  }, {
    key: "getParent",
    value: function getParent() {
      return this._parent;
    }
  }, {
    key: "setParent",
    value: function setParent(parent) {
      if (parent !== this._parent) {
        var prevIsZContext = this.isZContext();
        var prevParent = this._parent;
        this._parent = parent;
        if (this._layout || parent && parent.isFlexContainer()) {
          this.layout.setParent(prevParent, parent);
        }
        if (prevParent) {
          prevParent.setHasRenderUpdates(3);
        }
        this._setRecalc(1 + 2 + 4);
        if (this._parent) {
          this._parent._setHasUpdates();
        }
        if (this._zIndex === 0) {
          this.setZParent(parent);
        } else {
          this.setZParent(parent ? parent.findZContext() : null);
        }
        if (prevIsZContext !== this.isZContext()) {
          if (!this.isZContext()) {
            this.disableZContext();
          } else {
            this.enableZContext(prevParent.findZContext());
          }
        }
        this._zIndexResort = true;
        if (this._zParent) {
          this._zParent.enableZSort();
        }
        if (!this._shader) {
          var newShaderOwner = parent && !parent._renderToTextureEnabled ? parent._shaderOwner : null;
          if (newShaderOwner !== this._shaderOwner) {
            this.setHasRenderUpdates(1);
            this._setShaderOwnerRecursive(newShaderOwner);
          }
        }
      }
    }
  }, {
    key: "enableZSort",
    value: function enableZSort() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (!this._zSort && this._zContextUsage > 0) {
        this._zSort = true;
        if (force) {
          this.ctx.forceZSort(this);
        }
      }
    }
  }, {
    key: "addChildAt",
    value: function addChildAt(index, child) {
      if (!this._children) this._children = [];
      this._children.splice(index, 0, child);
      child.setParent(this);
    }
  }, {
    key: "setChildAt",
    value: function setChildAt(index, child) {
      if (!this._children) this._children = [];
      this._children[index].setParent(null);
      this._children[index] = child;
      child.setParent(this);
    }
  }, {
    key: "removeChildAt",
    value: function removeChildAt(index) {
      var child = this._children[index];
      this._children.splice(index, 1);
      child.setParent(null);
    }
  }, {
    key: "removeChildren",
    value: function removeChildren() {
      if (this._children) {
        for (var i = 0, n = this._children.length; i < n; i++) {
          this._children[i].setParent(null);
        }
        this._children.splice(0);
        if (this._zIndexedChildren) {
          this._zIndexedChildren.splice(0);
        }
      }
    }
  }, {
    key: "syncChildren",
    value: function syncChildren(removed, added, order) {
      this._children = order;
      for (var i = 0, n = removed.length; i < n; i++) {
        removed[i].setParent(null);
      }
      for (var _i = 0, _n = added.length; _i < _n; _i++) {
        added[_i].setParent(this);
      }
    }
  }, {
    key: "moveChild",
    value: function moveChild(fromIndex, toIndex) {
      var c = this._children[fromIndex];
      this._children.splice(fromIndex, 1);
      this._children.splice(toIndex, 0, c);
      this._zIndexResort = true;
      if (this._zParent) {
        this._zParent.enableZSort();
      }
    }
  }, {
    key: "_setLocalTransform",
    value: function _setLocalTransform(a, b, c, d) {
      this._setRecalc(4);
      this._localTa = a;
      this._localTb = b;
      this._localTc = c;
      this._localTd = d;
      this._isComplex = b !== 0 || c !== 0 || a < 0 || d < 0;
    }
  }, {
    key: "_addLocalTranslate",
    value: function _addLocalTranslate(dx, dy) {
      this._localPx += dx;
      this._localPy += dy;
      this._triggerRecalcTranslate();
    }
  }, {
    key: "_setLocalAlpha",
    value: function _setLocalAlpha(a) {
      if (!this._worldContext.alpha && this._parent && this._parent._worldContext.alpha && a) {
        this._setRecalc(1 + 128);
      } else {
        this._setRecalc(1);
      }
      if (a < 1e-14) {
        a = 0;
      }
      this._localAlpha = a;
    }
  }, {
    key: "setDimensions",
    value: function setDimensions(w, h) {
      var isEstimate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this._dimsUnknown;
      this._dimsUnknown = isEstimate;
      if (this.hasFlexLayout()) {
        this._layout.originalWidth = w;
        this._layout.originalHeight = h;
      } else {
        if (this._w !== w || this._h !== h) {
          this._updateDimensions(w, h);
          return true;
        }
      }
      return false;
    }
  }, {
    key: "_updateDimensions",
    value: function _updateDimensions(w, h) {
      if (this._w !== w || this._h !== h) {
        this._w = w;
        this._h = h;
        this._triggerRecalcTranslate();
        if (this._texturizer) {
          this._texturizer.releaseRenderTexture();
          this._texturizer.updateResultTexture();
        }
        this._updateLocalTranslate();
      }
    }
  }, {
    key: "setTextureCoords",
    value: function setTextureCoords(ulx, uly, brx, bry) {
      this.setHasRenderUpdates(3);
      this._ulx = ulx;
      this._uly = uly;
      this._brx = brx;
      this._bry = bry;
    }
  }, {
    key: "displayedTextureSource",
    get: function get() {
      return this._displayedTextureSource;
    }
  }, {
    key: "setDisplayedTextureSource",
    value: function setDisplayedTextureSource(textureSource) {
      this.setHasRenderUpdates(3);
      this._displayedTextureSource = textureSource;
    }
  }, {
    key: "isRoot",
    get: function get() {
      return this._isRoot;
    }
  }, {
    key: "setAsRoot",
    value: function setAsRoot() {
      this._parent = new ElementCore(this._element);
      this._parent._hasRenderUpdates = 3;
      this._parent._hasUpdates = true;
      this._isRoot = true;
      this.ctx.root = this;
      this._parent._viewport = [0, 0, this.ctx.stage.coordsWidth, this.ctx.stage.coordsHeight];
      this._parent._scissor = this._parent._viewport;
      this._parent._recBoundsMargin = null;
      this._setRecalc(1 + 2 + 4);
    }
  }, {
    key: "isAncestorOf",
    value: function isAncestorOf(c) {
      var p = c;
      while (p = p._parent) {
        if (this === p) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: "isZContext",
    value: function isZContext() {
      return this._forceZIndexContext || this._renderToTextureEnabled || this._zIndex !== 0 || this._isRoot || !this._parent;
    }
  }, {
    key: "findZContext",
    value: function findZContext() {
      if (this.isZContext()) {
        return this;
      } else {
        return this._parent.findZContext();
      }
    }
  }, {
    key: "setZParent",
    value: function setZParent(newZParent) {
      if (this._zParent !== newZParent) {
        if (this._zParent !== null) {
          if (this._zIndex !== 0) {
            this._zParent.decZContextUsage();
          }
          this._zParent.enableZSort();
        }
        if (newZParent !== null) {
          var hadZContextUsage = newZParent._zContextUsage > 0;
          if (this._zIndex !== 0) {
            newZParent.incZContextUsage();
          }
          if (newZParent._zContextUsage > 0) {
            if (!hadZContextUsage && this._parent === newZParent) {} else {
              newZParent._zIndexedChildren.push(this);
            }
            newZParent.enableZSort();
          }
        }
        this._zParent = newZParent;
        this._zIndexResort = true;
      }
    }
  }, {
    key: "incZContextUsage",
    value: function incZContextUsage() {
      this._zContextUsage++;
      if (this._zContextUsage === 1) {
        if (!this._zIndexedChildren) {
          this._zIndexedChildren = [];
        }
        if (this._children) {
          for (var i = 0, n = this._children.length; i < n; i++) {
            this._zIndexedChildren.push(this._children[i]);
          }
          this._zSort = false;
        }
      }
    }
  }, {
    key: "decZContextUsage",
    value: function decZContextUsage() {
      this._zContextUsage--;
      if (this._zContextUsage === 0) {
        this._zSort = false;
        this._zIndexedChildren.splice(0);
      }
    }
  }, {
    key: "zIndex",
    get: function get() {
      return this._zIndex;
    },
    set: function set(zIndex) {
      if (this._zIndex !== zIndex) {
        this.setHasRenderUpdates(1);
        var newZParent = this._zParent;
        var prevIsZContext = this.isZContext();
        if (zIndex === 0 && this._zIndex !== 0) {
          if (this._parent === this._zParent) {
            if (this._zParent) {
              this._zParent.decZContextUsage();
            }
          } else {
            newZParent = this._parent;
          }
        } else if (zIndex !== 0 && this._zIndex === 0) {
          newZParent = this._parent ? this._parent.findZContext() : null;
          if (newZParent === this._zParent) {
            if (this._zParent) {
              this._zParent.incZContextUsage();
              this._zParent.enableZSort();
            }
          }
        } else if (zIndex !== this._zIndex) {
          if (this._zParent && this._zParent._zContextUsage) {
            this._zParent.enableZSort();
          }
        }
        if (newZParent !== this._zParent) {
          this.setZParent(null);
        }
        this._zIndex = zIndex;
        if (newZParent !== this._zParent) {
          this.setZParent(newZParent);
        }
        if (prevIsZContext !== this.isZContext()) {
          if (!this.isZContext()) {
            this.disableZContext();
          } else {
            this.enableZContext(this._parent.findZContext());
          }
        }
        this._zIndexResort = true;
        if (this._zParent) {
          this._zParent.enableZSort();
        }
      }
    }
  }, {
    key: "forceZIndexContext",
    get: function get() {
      return this._forceZIndexContext;
    },
    set: function set(v) {
      this.setHasRenderUpdates(1);
      var prevIsZContext = this.isZContext();
      this._forceZIndexContext = v;
      if (prevIsZContext !== this.isZContext()) {
        if (!this.isZContext()) {
          this.disableZContext();
        } else {
          this.enableZContext(this._parent.findZContext());
        }
      }
    }
  }, {
    key: "enableZContext",
    value: function enableZContext(prevZContext) {
      var _this = this;
      if (prevZContext && prevZContext._zContextUsage > 0) {
        var results = this._getZIndexedDescs();
        results.forEach(function (c) {
          if (_this.isAncestorOf(c) && c._zIndex !== 0) {
            c.setZParent(_this);
          }
        });
      }
    }
  }, {
    key: "_getZIndexedDescs",
    value: function _getZIndexedDescs() {
      var results = [];
      if (this._children) {
        for (var i = 0, n = this._children.length; i < n; i++) {
          this._children[i]._getZIndexedDescsRec(results);
        }
      }
      return results;
    }
  }, {
    key: "_getZIndexedDescsRec",
    value: function _getZIndexedDescsRec(results) {
      if (this._zIndex) {
        results.push(this);
      } else if (this._children && !this.isZContext()) {
        for (var i = 0, n = this._children.length; i < n; i++) {
          this._children[i]._getZIndexedDescsRec(results);
        }
      }
    }
  }, {
    key: "disableZContext",
    value: function disableZContext() {
      if (this._zContextUsage > 0) {
        var newZParent = this._parent.findZContext();
        if (this._zSort) {
          this.sortZIndexedChildren();
        }
        this._zIndexedChildren.slice().forEach(function (c) {
          if (c._zIndex !== 0) {
            c.setZParent(newZParent);
          }
        });
      }
    }
  }, {
    key: "colorUl",
    get: function get() {
      return this._colorUl;
    },
    set: function set(color) {
      if (this._colorUl !== color) {
        this.setHasRenderUpdates(this._displayedTextureSource ? 3 : 1);
        this._colorUl = color;
      }
    }
  }, {
    key: "colorUr",
    get: function get() {
      return this._colorUr;
    },
    set: function set(color) {
      if (this._colorUr !== color) {
        this.setHasRenderUpdates(this._displayedTextureSource ? 3 : 1);
        this._colorUr = color;
      }
    }
  }, {
    key: "colorBl",
    get: function get() {
      return this._colorBl;
    },
    set: function set(color) {
      if (this._colorBl !== color) {
        this.setHasRenderUpdates(this._displayedTextureSource ? 3 : 1);
        this._colorBl = color;
      }
    }
  }, {
    key: "colorBr",
    get: function get() {
      return this._colorBr;
    },
    set: function set(color) {
      if (this._colorBr !== color) {
        this.setHasRenderUpdates(this._displayedTextureSource ? 3 : 1);
        this._colorBr = color;
      }
    }
  }, {
    key: "onUpdate",
    set: function set(f) {
      this._onUpdate = f;
      this._setRecalc(7);
    }
  }, {
    key: "onAfterUpdate",
    set: function set(f) {
      this._onAfterUpdate = f;
      this._setRecalc(7);
    }
  }, {
    key: "onAfterCalcs",
    set: function set(f) {
      this._onAfterCalcs = f;
      this._setRecalc(7);
    }
  }, {
    key: "shader",
    get: function get() {
      return this._shader;
    },
    set: function set(v) {
      this.setHasRenderUpdates(1);
      var prevShader = this._shader;
      this._shader = v;
      if (!v && prevShader) {
        var newShaderOwner = this._parent && !this._parent._renderToTextureEnabled ? this._parent._shaderOwner : null;
        this._setShaderOwnerRecursive(newShaderOwner);
      } else if (v) {
        this._setShaderOwnerRecursive(this);
      }
    }
  }, {
    key: "activeShader",
    get: function get() {
      return this._shaderOwner ? this._shaderOwner.shader : this.renderState.defaultShader;
    }
  }, {
    key: "activeShaderOwner",
    get: function get() {
      return this._shaderOwner;
    }
  }, {
    key: "clipping",
    get: function get() {
      return this._clipping;
    },
    set: function set(v) {
      if (this._clipping !== v) {
        this._clipping = v;
        this._setRecalc(1 + 2);
      }
    }
  }, {
    key: "clipbox",
    get: function get() {
      return this._clipbox;
    },
    set: function set(v) {
      this._clipbox = v;
    }
  }, {
    key: "_setShaderOwnerRecursive",
    value: function _setShaderOwnerRecursive(elementCore) {
      this._shaderOwner = elementCore;
      if (this._children && !this._renderToTextureEnabled) {
        for (var i = 0, n = this._children.length; i < n; i++) {
          var c = this._children[i];
          if (!c._shader) {
            c._setShaderOwnerRecursive(elementCore);
            c._hasRenderUpdates = 3;
          }
        }
      }
    }
  }, {
    key: "_setShaderOwnerChildrenRecursive",
    value: function _setShaderOwnerChildrenRecursive(elementCore) {
      if (this._children) {
        for (var i = 0, n = this._children.length; i < n; i++) {
          var c = this._children[i];
          if (!c._shader) {
            c._setShaderOwnerRecursive(elementCore);
            c._hasRenderUpdates = 3;
          }
        }
      }
    }
  }, {
    key: "_hasRenderContext",
    value: function _hasRenderContext() {
      return this._renderContext !== this._worldContext;
    }
  }, {
    key: "renderContext",
    get: function get() {
      return this._renderContext;
    }
  }, {
    key: "updateRenderToTextureEnabled",
    value: function updateRenderToTextureEnabled() {
      var v = this.texturizer._enabled;
      if (v) {
        this._enableRenderToTexture();
      } else {
        this._disableRenderToTexture();
        this._texturizer.releaseRenderTexture();
      }
    }
  }, {
    key: "_enableRenderToTexture",
    value: function _enableRenderToTexture() {
      if (!this._renderToTextureEnabled) {
        var prevIsZContext = this.isZContext();
        this._renderToTextureEnabled = true;
        this._renderContext = new ElementCoreContext();
        this._setShaderOwnerChildrenRecursive(null);
        if (!prevIsZContext) {
          this.enableZContext(this._parent ? this._parent.findZContext() : null);
        }
        this.setHasRenderUpdates(3);
        this._setRecalc(7);
        this.render = this._renderAdvanced;
      }
    }
  }, {
    key: "_disableRenderToTexture",
    value: function _disableRenderToTexture() {
      if (this._renderToTextureEnabled) {
        this._renderToTextureEnabled = false;
        this._setShaderOwnerChildrenRecursive(this._shaderOwner);
        this._renderContext = this._worldContext;
        if (!this.isZContext()) {
          this.disableZContext();
        }
        this._setRecalc(7);
        this.setHasRenderUpdates(3);
        this.render = this._renderSimple;
      }
    }
  }, {
    key: "isWhite",
    value: function isWhite() {
      return this._colorUl === 0xFFFFFFFF && this._colorUr === 0xFFFFFFFF && this._colorBl === 0xFFFFFFFF && this._colorBr === 0xFFFFFFFF;
    }
  }, {
    key: "hasSimpleTexCoords",
    value: function hasSimpleTexCoords() {
      return this._ulx === 0 && this._uly === 0 && this._brx === 1 && this._bry === 1;
    }
  }, {
    key: "_stashTexCoords",
    value: function _stashTexCoords() {
      this._stashedTexCoords = [this._ulx, this._uly, this._brx, this._bry];
      this._ulx = 0;
      this._uly = 0;
      this._brx = 1;
      this._bry = 1;
    }
  }, {
    key: "_unstashTexCoords",
    value: function _unstashTexCoords() {
      this._ulx = this._stashedTexCoords[0];
      this._uly = this._stashedTexCoords[1];
      this._brx = this._stashedTexCoords[2];
      this._bry = this._stashedTexCoords[3];
      this._stashedTexCoords = null;
    }
  }, {
    key: "_stashColors",
    value: function _stashColors() {
      this._stashedColors = [this._colorUl, this._colorUr, this._colorBr, this._colorBl];
      this._colorUl = 0xFFFFFFFF;
      this._colorUr = 0xFFFFFFFF;
      this._colorBr = 0xFFFFFFFF;
      this._colorBl = 0xFFFFFFFF;
    }
  }, {
    key: "_unstashColors",
    value: function _unstashColors() {
      this._colorUl = this._stashedColors[0];
      this._colorUr = this._stashedColors[1];
      this._colorBr = this._stashedColors[2];
      this._colorBl = this._stashedColors[3];
      this._stashedColors = null;
    }
  }, {
    key: "isVisible",
    value: function isVisible() {
      return this._localAlpha > 1e-14;
    }
  }, {
    key: "outOfBounds",
    get: function get() {
      return this._outOfBounds;
    }
  }, {
    key: "boundsMargin",
    get: function get() {
      return this._boundsMargin;
    },
    set: function set(v) {
      this._boundsMargin = v ? v.slice() : null;
      this._triggerRecalcTranslate();
    }
  }, {
    key: "update",
    value: function update() {
      this._recalc |= this._parent._pRecalc;
      if (this._layout && this._layout.isEnabled()) {
        if (this._recalc & 256) {
          this._layout.layoutFlexTree();
        }
      } else if (this._recalc & 2 && this._optFlags) {
        this._applyRelativeDimFuncs();
      }
      if (this._onUpdate) {
        this._hasUpdates = true;
        this._onUpdate(this.element, this);
      }
      var pw = this._parent._worldContext;
      var w = this._worldContext;
      var visible = pw.alpha && this._localAlpha;
      if (this._hasUpdates || this._recalc && visible || w.alpha && !visible) {
        var recalc = this._recalc;
        if (recalc & 1) {
          if (!w.alpha && visible) {
            this._hasRenderUpdates = 3;
          }
          w.alpha = pw.alpha * this._localAlpha;
          if (w.alpha < 1e-14) {
            w.alpha = 0;
          }
        }
        if (recalc & 6) {
          w.px = pw.px + this._localPx * pw.ta;
          w.py = pw.py + this._localPy * pw.td;
          if (pw.tb !== 0) w.px += this._localPy * pw.tb;
          if (pw.tc !== 0) w.py += this._localPx * pw.tc;
        }
        if (recalc & 4) {
          w.ta = this._localTa * pw.ta;
          w.tb = this._localTd * pw.tb;
          w.tc = this._localTa * pw.tc;
          w.td = this._localTd * pw.td;
          if (this._isComplex) {
            w.ta += this._localTc * pw.tb;
            w.tb += this._localTb * pw.ta;
            w.tc += this._localTc * pw.td;
            w.td += this._localTb * pw.tc;
          }
        }
        var pr = this._parent._renderContext;
        if (this._parent._hasRenderContext()) {
          var init = this._renderContext === this._worldContext;
          if (init) {
            this._renderContext = new ElementCoreContext();
          }
          var _r = this._renderContext;
          if (init || recalc & 1) {
            _r.alpha = pr.alpha * this._localAlpha;
            if (_r.alpha < 1e-14) {
              _r.alpha = 0;
            }
          }
          if (init || recalc & 6) {
            _r.px = pr.px + this._localPx * pr.ta;
            _r.py = pr.py + this._localPy * pr.td;
            if (pr.tb !== 0) _r.px += this._localPy * pr.tb;
            if (pr.tc !== 0) _r.py += this._localPx * pr.tc;
          }
          if (init) {
            recalc |= 2;
          }
          if (init || recalc & 4) {
            _r.ta = this._localTa * pr.ta;
            _r.tb = this._localTd * pr.tb;
            _r.tc = this._localTa * pr.tc;
            _r.td = this._localTd * pr.td;
            if (this._isComplex) {
              _r.ta += this._localTc * pr.tb;
              _r.tb += this._localTb * pr.ta;
              _r.tc += this._localTc * pr.td;
              _r.td += this._localTb * pr.tc;
            }
          }
        } else {
          this._renderContext = this._worldContext;
        }
        if (this.ctx.updateTreeOrder === -1) {
          this.ctx.updateTreeOrder = this._updateTreeOrder + 1;
        } else {
          this._updateTreeOrder = this.ctx.updateTreeOrder++;
        }
        var useRenderToTexture = this._renderToTextureEnabled && this._texturizer.mustRenderToTexture();
        if (this._useRenderToTexture !== useRenderToTexture) {
          this._recalc |= 2 + 4;
          recalc |= 2;
          if (!this._useRenderToTexture) {
            this._texturizer.release();
          }
        }
        this._useRenderToTexture = useRenderToTexture;
        var r = this._renderContext;
        var bboxW = this._dimsUnknown ? 2048 : this._w;
        var bboxH = this._dimsUnknown ? 2048 : this._h;
        var sx, sy, ex, ey;
        var rComplex = r.tb !== 0 || r.tc !== 0 || r.ta < 0 || r.td < 0;
        if (rComplex) {
          sx = Math.min(0, bboxW * r.ta, bboxW * r.ta + bboxH * r.tb, bboxH * r.tb) + r.px;
          ex = Math.max(0, bboxW * r.ta, bboxW * r.ta + bboxH * r.tb, bboxH * r.tb) + r.px;
          sy = Math.min(0, bboxW * r.tc, bboxW * r.tc + bboxH * r.td, bboxH * r.td) + r.py;
          ey = Math.max(0, bboxW * r.tc, bboxW * r.tc + bboxH * r.td, bboxH * r.td) + r.py;
        } else {
          sx = r.px;
          ex = r.px + r.ta * bboxW;
          sy = r.py;
          ey = r.py + r.td * bboxH;
        }
        if (this._dimsUnknown && (rComplex || this._localTa < 1 || this._localTb < 1)) {
          var nx = this._x * pr.ta + this._y * pr.tb + pr.px;
          var ny = this._x * pr.tc + this._y * pr.td + pr.py;
          if (nx < sx) sx = nx;
          if (ny < sy) sy = ny;
          if (nx > ex) ex = nx;
          if (ny > ey) ey = ny;
        }
        if (recalc & 6 || !this._scissor) {
          if (this._clipping && r.isSquare()) {
            var area = this._parent._useRenderToTexture ? this._parent._viewport : this._parent._scissor;
            if (area) {
              var lx = Math.max(area[0], sx);
              var ly = Math.max(area[1], sy);
              this._scissor = [lx, ly, Math.min(area[2] + area[0], ex) - lx, Math.min(area[3] + area[1], ey) - ly];
            } else {
              this._scissor = [sx, sy, ex - sx, ey - sy];
            }
          } else {
            this._scissor = this._parent._useRenderToTexture ? this._parent._viewport : this._parent._scissor;
          }
        }
        if (this._boundsMargin) {
          this._recBoundsMargin = this._boundsMargin;
        } else {
          this._recBoundsMargin = this._parent._recBoundsMargin;
        }
        if (this._onAfterCalcs) {
          if (this._onAfterCalcs(this.element)) {
            if (rComplex) {
              sx = Math.min(0, bboxW * r.ta, bboxW * r.ta + bboxH * r.tb, bboxH * r.tb) + r.px;
              ex = Math.max(0, bboxW * r.ta, bboxW * r.ta + bboxH * r.tb, bboxH * r.tb) + r.px;
              sy = Math.min(0, bboxW * r.tc, bboxW * r.tc + bboxH * r.td, bboxH * r.td) + r.py;
              ey = Math.max(0, bboxW * r.tc, bboxW * r.tc + bboxH * r.td, bboxH * r.td) + r.py;
            } else {
              sx = r.px;
              ex = r.px + r.ta * bboxW;
              sy = r.py;
              ey = r.py + r.td * bboxH;
            }
            if (this._dimsUnknown && (rComplex || this._localTa < 1 || this._localTb < 1)) {
              var _nx = this._x * pr.ta + this._y * pr.tb + pr.px;
              var _ny = this._x * pr.tc + this._y * pr.td + pr.py;
              if (_nx < sx) sx = _nx;
              if (_ny < sy) sy = _ny;
              if (_nx > ex) ex = _nx;
              if (_ny > ey) ey = _ny;
            }
          }
        }
        if (this._parent._outOfBounds === 2) {
          this._outOfBounds = 2;
          if (this._withinBoundsMargin) {
            this._withinBoundsMargin = false;
            this.element._disableWithinBoundsMargin();
          }
        } else {
          if (recalc & 6) {
            this._outOfBounds = 0;
            var withinMargin = true;
            if (!this._renderToTextureEnabled || !this._texturizer || !this._texturizer.renderOffscreen) {
              if (this._scissor && (this._scissor[2] <= 0 || this._scissor[3] <= 0)) {
                this._outOfBounds = 2;
              } else {
                if (this._scissor[0] > ex || this._scissor[1] > ey || sx > this._scissor[0] + this._scissor[2] || sy > this._scissor[1] + this._scissor[3]) {
                  this._outOfBounds = 1;
                }
                if (this._outOfBounds) {
                  if (this._clipping || this._useRenderToTexture || this._clipbox && bboxW && bboxH) {
                    this._outOfBounds = 2;
                  }
                }
              }
              withinMargin = this._outOfBounds === 0;
              if (!withinMargin) {
                if (this._recBoundsMargin) {
                  withinMargin = !(ex < this._scissor[0] - this._recBoundsMargin[2] || ey < this._scissor[1] - this._recBoundsMargin[3] || sx > this._scissor[0] + this._scissor[2] + this._recBoundsMargin[0] || sy > this._scissor[1] + this._scissor[3] + this._recBoundsMargin[1]);
                } else {
                  withinMargin = !(ex < this._scissor[0] - 100 || ey < this._scissor[1] - 100 || sx > this._scissor[0] + this._scissor[2] + 100 || sy > this._scissor[1] + this._scissor[3] + 100);
                }
                if (withinMargin && this._outOfBounds === 2) {
                  this._outOfBounds = 1;
                }
              }
            }
            if (this._withinBoundsMargin !== withinMargin) {
              this._withinBoundsMargin = withinMargin;
              if (this._withinBoundsMargin) {
                this._hasUpdates = true;
                var _recalc = this._recalc;
                this._recalc = 0;
                this.element._enableWithinBoundsMargin();
                if (this._recalc) {
                  return this.update();
                }
                this._recalc = _recalc;
              } else {
                this.element._disableWithinBoundsMargin();
              }
            }
          }
        }
        if (this._useRenderToTexture) {
          if (this._viewport) {
            this._viewport[2] = bboxW;
            this._viewport[3] = bboxH;
          } else {
            this._viewport = [0, 0, bboxW, bboxH];
          }
        }
        this._pRecalc = this._recalc & 135;
        this._recalc = 0;
        this._hasUpdates = false;
        if (this._outOfBounds < 2) {
          if (this._useRenderToTexture) {
            if (this._worldContext.isIdentity()) {
              this._renderContext = this._worldContext;
            } else {
              this._renderContext = ElementCoreContext.IDENTITY;
            }
          }
          if (this._children) {
            for (var i = 0, n = this._children.length; i < n; i++) {
              this._children[i].update();
            }
          }
          if (this._useRenderToTexture) {
            this._renderContext = r;
          }
        } else {
          if (this._children) {
            for (var _i2 = 0, _n2 = this._children.length; _i2 < _n2; _i2++) {
              if (this._children[_i2]._hasUpdates) {
                this._children[_i2].update();
              } else {
                this._children[_i2]._recalc |= this._pRecalc;
                this._children[_i2].updateOutOfBounds();
              }
            }
          }
        }
        if (this._onAfterUpdate) {
          this._onAfterUpdate(this.element);
        }
      } else {
        if (this.ctx.updateTreeOrder === -1 || this._updateTreeOrder >= this.ctx.updateTreeOrder) {
          this.ctx.updateTreeOrder = -1;
        } else {
          this.updateTreeOrder();
        }
      }
    }
  }, {
    key: "_applyRelativeDimFuncs",
    value: function _applyRelativeDimFuncs() {
      if (this._optFlags & 1) {
        var x = this._funcX(this._parent.w);
        if (x !== this._x) {
          this._localPx += x - this._x;
          this._x = x;
        }
      }
      if (this._optFlags & 2) {
        var y = this._funcY(this._parent.h);
        if (y !== this._y) {
          this._localPy += y - this._y;
          this._y = y;
        }
      }
      var changedDims = false;
      if (this._optFlags & 4) {
        var w = this._funcW(this._parent.w);
        if (w !== this._w) {
          this._w = w;
          changedDims = true;
        }
      }
      if (this._optFlags & 8) {
        var h = this._funcH(this._parent.h);
        if (h !== this._h) {
          this._h = h;
          changedDims = true;
        }
      }
      if (changedDims) {
        this._recalcLocalTranslate();
        this.element.onDimensionsChanged(this._w, this._h);
      }
    }
  }, {
    key: "updateOutOfBounds",
    value: function updateOutOfBounds() {
      if (this._outOfBounds !== 2 && this._renderContext.alpha > 0) {
        this._outOfBounds = 2;
        if (this._withinBoundsMargin) {
          this._withinBoundsMargin = false;
          this.element._disableWithinBoundsMargin();
        }
        if (this._children) {
          for (var i = 0, n = this._children.length; i < n; i++) {
            this._children[i].updateOutOfBounds();
          }
        }
      }
    }
  }, {
    key: "updateTreeOrder",
    value: function updateTreeOrder() {
      if (this._localAlpha && this._outOfBounds !== 2) {
        this._updateTreeOrder = this.ctx.updateTreeOrder++;
        if (this._children) {
          for (var i = 0, n = this._children.length; i < n; i++) {
            this._children[i].updateTreeOrder();
          }
        }
      }
    }
  }, {
    key: "_renderSimple",
    value: function _renderSimple() {
      this._hasRenderUpdates = 0;
      if (this._zSort) {
        this.sortZIndexedChildren();
      }
      if (this._outOfBounds < 2 && this._renderContext.alpha) {
        var renderState = this.renderState;
        if (this._outOfBounds === 0 && this._displayedTextureSource) {
          renderState.setShader(this.activeShader, this._shaderOwner);
          renderState.setScissor(this._scissor);
          this.renderState.addQuad(this);
        }
        if (this._children) {
          if (this._zContextUsage) {
            for (var i = 0, n = this._zIndexedChildren.length; i < n; i++) {
              this._zIndexedChildren[i].render();
            }
          } else {
            for (var _i3 = 0, _n3 = this._children.length; _i3 < _n3; _i3++) {
              if (this._children[_i3]._zIndex === 0) {
                this._children[_i3].render();
              }
            }
          }
        }
      }
    }
  }, {
    key: "_renderAdvanced",
    value: function _renderAdvanced() {
      var hasRenderUpdates = this._hasRenderUpdates;
      this._hasRenderUpdates = 0;
      if (this._zSort) {
        this.sortZIndexedChildren();
      }
      if (this._outOfBounds < 2 && this._renderContext.alpha) {
        var renderState = this.renderState;
        var mustRenderChildren = true;
        var renderTextureInfo;
        var prevRenderTextureInfo;
        if (this._useRenderToTexture) {
          if (this._w === 0 || this._h === 0) {
            return;
          } else if (!this._texturizer.hasRenderTexture() || hasRenderUpdates >= 3) {
            this.ctx.renderToTextureCount++;
            renderState.setShader(renderState.defaultShader, this);
            prevRenderTextureInfo = renderState.renderTextureInfo;
            renderTextureInfo = {
              nativeTexture: null,
              offset: 0,
              w: this._w,
              h: this._h,
              empty: true,
              cleared: false,
              ignore: false,
              cache: false
            };
            if (this._texturizer.hasResultTexture() || !renderState.isCachingTexturizer && hasRenderUpdates < 3) {
              renderTextureInfo.cache = true;
              renderState.isCachingTexturizer = true;
            }
            if (!this._texturizer.hasResultTexture()) {
              this._texturizer.releaseRenderTexture();
            }
            renderState.setRenderTextureInfo(renderTextureInfo);
            renderState.setScissor(null);
            if (this._displayedTextureSource) {
              var r = this._renderContext;
              this._renderContext = ElementCoreContext.IDENTITY;
              this.renderState.addQuad(this);
              this._renderContext = r;
            }
          } else {
            mustRenderChildren = false;
          }
        } else {
          if (this._outOfBounds === 0 && this._displayedTextureSource) {
            renderState.setShader(this.activeShader, this._shaderOwner);
            renderState.setScissor(this._scissor);
            this.renderState.addQuad(this);
          }
        }
        if (mustRenderChildren && this._children) {
          if (this._zContextUsage) {
            for (var i = 0, n = this._zIndexedChildren.length; i < n; i++) {
              this._zIndexedChildren[i].render();
            }
          } else {
            for (var _i4 = 0, _n4 = this._children.length; _i4 < _n4; _i4++) {
              if (this._children[_i4]._zIndex === 0) {
                this._children[_i4].render();
              }
            }
          }
        }
        if (this._useRenderToTexture) {
          var updateResultTexture = false;
          if (mustRenderChildren) {
            renderState.finishedRenderTexture();
            this._texturizer.empty = renderTextureInfo.empty;
            if (renderTextureInfo.empty) {
              this._texturizer.releaseRenderTexture();
            } else if (renderTextureInfo.nativeTexture) {
              this._texturizer.reuseTextureAsRenderTexture(renderTextureInfo.nativeTexture);
              renderTextureInfo.ignore = true;
            } else {
              if (this._texturizer.renderTextureReused) {
                this._texturizer.releaseRenderTexture();
              }
              renderTextureInfo.nativeTexture = this._texturizer.getRenderTexture();
            }
            renderState.setRenderTextureInfo(prevRenderTextureInfo);
            updateResultTexture = true;
          }
          if (!this._texturizer.empty) {
            var resultTexture = this._texturizer.getResultTexture();
            if (updateResultTexture) {
              if (resultTexture) {
                resultTexture.update = renderState.stage.frameCounter;
              }
              this._texturizer.updateResultTexture();
            }
            if (!this._texturizer.renderOffscreen) {
              renderState.setShader(this.activeShader, this._shaderOwner);
              renderState.setScissor(this._scissor);
              var cache = !renderTextureInfo || renderTextureInfo.cache;
              renderState.setTexturizer(this._texturizer, cache);
              this._stashTexCoords();
              if (!this._texturizer.colorize) this._stashColors();
              this.renderState.addQuad(this, true);
              if (!this._texturizer.colorize) this._unstashColors();
              this._unstashTexCoords();
              renderState.setTexturizer(null);
            }
          }
        }
        if (renderTextureInfo && renderTextureInfo.cache) {
          renderState.isCachingTexturizer = false;
        }
      }
    }
  }, {
    key: "zSort",
    get: function get() {
      return this._zSort;
    }
  }, {
    key: "sortZIndexedChildren",
    value: function sortZIndexedChildren() {
      var n = this._zIndexedChildren.length;
      var ptr = 0;
      var a = this._zIndexedChildren;
      var b = [];
      for (var i = 0; i < n; i++) {
        if (a[i]._zParent === this) {
          if (a[i]._zIndexResort) {
            b.push(a[i]);
          } else {
            if (ptr !== i) {
              a[ptr] = a[i];
            }
            ptr++;
          }
        }
      }
      var m = b.length;
      if (m) {
        for (var j = 0; j < m; j++) {
          b[j]._zIndexResort = false;
        }
        b.sort(ElementCore.sortZIndexedChildren);
        var _n5 = ptr;
        if (!_n5) {
          ptr = 0;
          var _j = 0;
          do {
            a[ptr++] = b[_j++];
          } while (_j < m);
          if (a.length > ptr) {
            a.splice(ptr);
          }
        } else {
          ptr = 0;
          var _i5 = 0;
          var _j2 = 0;
          var mergeResult = [];
          do {
            var v = a[_i5]._zIndex === b[_j2]._zIndex ? a[_i5]._updateTreeOrder - b[_j2]._updateTreeOrder : a[_i5]._zIndex - b[_j2]._zIndex;
            var add = v > 0 ? b[_j2++] : a[_i5++];
            if (ptr === 0 || mergeResult[ptr - 1] !== add) {
              mergeResult[ptr++] = add;
            }
            if (_i5 >= _n5) {
              do {
                var _add = b[_j2++];
                if (ptr === 0 || mergeResult[ptr - 1] !== _add) {
                  mergeResult[ptr++] = _add;
                }
              } while (_j2 < m);
              break;
            } else if (_j2 >= m) {
              do {
                var _add2 = a[_i5++];
                if (ptr === 0 || mergeResult[ptr - 1] !== _add2) {
                  mergeResult[ptr++] = _add2;
                }
              } while (_i5 < _n5);
              break;
            }
          } while (true);
          this._zIndexedChildren = mergeResult;
        }
      } else {
        if (a.length > ptr) {
          a.splice(ptr);
        }
      }
      this._zSort = false;
    }
  }, {
    key: "localTa",
    get: function get() {
      return this._localTa;
    }
  }, {
    key: "localTb",
    get: function get() {
      return this._localTb;
    }
  }, {
    key: "localTc",
    get: function get() {
      return this._localTc;
    }
  }, {
    key: "localTd",
    get: function get() {
      return this._localTd;
    }
  }, {
    key: "element",
    get: function get() {
      return this._element;
    }
  }, {
    key: "renderUpdates",
    get: function get() {
      return this._hasRenderUpdates;
    }
  }, {
    key: "texturizer",
    get: function get() {
      if (!this._texturizer) {
        this._texturizer = new ElementTexturizer(this);
      }
      return this._texturizer;
    }
  }, {
    key: "getCornerPoints",
    value: function getCornerPoints() {
      var w = this._worldContext;
      return [w.px, w.py, w.px + this._w * w.ta, w.py + this._w * w.tc, w.px + this._w * w.ta + this._h * w.tb, w.py + this._w * w.tc + this._h * w.td, w.px + this._h * w.tb, w.py + this._h * w.td];
    }
  }, {
    key: "getRenderTextureCoords",
    value: function getRenderTextureCoords(relX, relY) {
      var r = this._renderContext;
      return [r.px + r.ta * relX + r.tb * relY, r.py + r.tc * relX + r.td * relY];
    }
  }, {
    key: "getAbsoluteCoords",
    value: function getAbsoluteCoords(relX, relY) {
      var w = this._renderContext;
      return [w.px + w.ta * relX + w.tb * relY, w.py + w.tc * relX + w.td * relY];
    }
  }, {
    key: "collectAtCoord",
    value: function collectAtCoord(x, y, children) {
      if (this._renderContext.alpha === 0) {
        return;
      }
      if (this.inBound(x, y)) {
        if (this._scissor) {
          if (this.inScissor()) {
            children.push(this);
          }
        } else {
          children.push(this);
        }
      }
      if (this._children) {
        var j = this._children.length;
        for (var i = 0; i < j; i++) {
          this._children[i].collectAtCoord(x, y, children);
        }
      }
      return children.sort(ElementCore.sortZIndexedChildren);
    }
  }, {
    key: "inBound",
    value: function inBound(tx, ty) {
      var c = this.getCornerPoints();
      return tx > c[0] && tx < c[2] && ty > c[1] && ty < c[7];
    }
  }, {
    key: "inScissor",
    value: function inScissor() {
      var sc = this._scissor;
      var c = this.getCornerPoints();
      return c[2] >= sc[0] && c[0] <= sc[0] + sc[2] && c[7] >= sc[1] && c[1] <= sc[1] + sc[3];
    }
  }, {
    key: "layout",
    get: function get() {
      this._ensureLayout();
      return this._layout;
    }
  }, {
    key: "flex",
    get: function get() {
      return this._layout ? this._layout.flex : null;
    },
    set: function set(v) {
      this.layout.flex = v;
    }
  }, {
    key: "flexItem",
    get: function get() {
      return this._layout ? this._layout.flexItem : null;
    },
    set: function set(v) {
      this.layout.flexItem = v;
    }
  }, {
    key: "isFlexItem",
    value: function isFlexItem() {
      return !!this._layout && this._layout.isFlexItemEnabled();
    }
  }, {
    key: "isFlexContainer",
    value: function isFlexContainer() {
      return !!this._layout && this._layout.isFlexEnabled();
    }
  }, {
    key: "enableFlexLayout",
    value: function enableFlexLayout() {
      this._ensureLayout();
    }
  }, {
    key: "_ensureLayout",
    value: function _ensureLayout() {
      if (!this._layout) {
        this._layout = new FlexTarget(this);
      }
    }
  }, {
    key: "disableFlexLayout",
    value: function disableFlexLayout() {
      this._triggerRecalcTranslate();
    }
  }, {
    key: "hasFlexLayout",
    value: function hasFlexLayout() {
      return this._layout && this._layout.isEnabled();
    }
  }, {
    key: "setLayout",
    value: function setLayout(x, y, w, h) {
      this.x = x;
      this.y = y;
      this._updateDimensions(w, h);
    }
  }, {
    key: "triggerLayout",
    value: function triggerLayout() {
      this._setRecalc(256);
    }
  }, {
    key: "_triggerRecalcTranslate",
    value: function _triggerRecalcTranslate() {
      this._setRecalc(2);
    }
  }]);
  return ElementCore;
}();

var ElementCoreContext = function () {
  function ElementCoreContext() {
    (0,classCallCheck/* default */.Z)(this, ElementCoreContext);
    this.alpha = 1;
    this.px = 0;
    this.py = 0;
    this.ta = 1;
    this.tb = 0;
    this.tc = 0;
    this.td = 1;
  }
  (0,createClass/* default */.Z)(ElementCoreContext, [{
    key: "isIdentity",
    value: function isIdentity() {
      return this.alpha === 1 && this.px === 0 && this.py === 0 && this.ta === 1 && this.tb === 0 && this.tc === 0 && this.td === 1;
    }
  }, {
    key: "isSquare",
    value: function isSquare() {
      return this.tb === 0 && this.tc === 0;
    }
  }]);
  return ElementCoreContext;
}();
ElementCoreContext.IDENTITY = new ElementCoreContext();
ElementCore.sortZIndexedChildren = function (a, b) {
  return a._zIndex === b._zIndex ? a._updateTreeOrder - b._updateTreeOrder : a._zIndex - b._zIndex;
};


;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/EventEmitter.mjs





function EventEmitter_createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = EventEmitter_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function EventEmitter_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return EventEmitter_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? EventEmitter_arrayLikeToArray(r, a) : void 0; } }
function EventEmitter_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var EventEmitter = function () {
  function EventEmitter() {
    (0,classCallCheck/* default */.Z)(this, EventEmitter);
    this._hasEventListeners = false;
  }
  (0,createClass/* default */.Z)(EventEmitter, [{
    key: "on",
    value: function on(name, listener) {
      if (!this._hasEventListeners) {
        this._eventFunction = {};
        this._eventListeners = {};
        this._hasEventListeners = true;
      }
      var current = this._eventFunction[name];
      if (!current) {
        this._eventFunction[name] = listener;
      } else {
        if (this._eventFunction[name] !== EventEmitter.combiner) {
          this._eventListeners[name] = [this._eventFunction[name], listener];
          this._eventFunction[name] = EventEmitter.combiner;
        } else {
          this._eventListeners[name].push(listener);
        }
      }
    }
  }, {
    key: "once",
    value: function once(name, listener) {
      var _this = this;
      var wrapper = function wrapper(arg1, arg2, arg3) {
        listener(arg1, arg2, arg3);
        _this.off(name, wrapper);
      };
      wrapper.__originalFunc = listener;
      this.on(name, wrapper);
    }
  }, {
    key: "has",
    value: function has(name, listener) {
      if (this._hasEventListeners) {
        var current = this._eventFunction[name];
        if (current) {
          if (current === EventEmitter.combiner) {
            var listeners = this._eventListeners[name];
            var _iterator = EventEmitter_createForOfIteratorHelper(listeners),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var l = _step.value;
                if (l === listener || l.__originalFunc == listener) {
                  return true;
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          } else if (this._eventFunction[name] === listener || this._eventFunction[name].__originalFunc === listener) {
            return true;
          }
        }
      }
      return false;
    }
  }, {
    key: "off",
    value: function off(name, listener) {
      if (this._hasEventListeners) {
        var current = this._eventFunction[name];
        if (current) {
          if (current === EventEmitter.combiner) {
            var listeners = this._eventListeners[name];
            var index = listeners.indexOf(listener);
            if (index >= 0) {
              listeners.splice(index, 1);
            }
            index = listeners.map(function (l) {
              return l.__originalFunc;
            }).indexOf(listener);
            if (index >= 0) {
              listeners.splice(index, 1);
            }
            if (listeners.length === 1) {
              this._eventFunction[name] = listeners[0];
              this._eventListeners[name] = undefined;
            }
          } else if (this._eventFunction[name] === listener || this._eventFunction[name].__originalFunc === listener) {
            this._eventFunction[name] = undefined;
          }
        }
      }
    }
  }, {
    key: "removeListener",
    value: function removeListener(name, listener) {
      this.off(name, listener);
    }
  }, {
    key: "emit",
    value: function emit(name, arg1, arg2, arg3) {
      if (this._hasEventListeners) {
        var func = this._eventFunction[name];
        if (func) {
          if (func === EventEmitter.combiner) {
            func(this, name, arg1, arg2, arg3);
          } else {
            func(arg1, arg2, arg3);
          }
        }
      }
    }
  }, {
    key: "listenerCount",
    value: function listenerCount(name) {
      if (this._hasEventListeners) {
        var func = this._eventFunction[name];
        if (func) {
          if (func === EventEmitter.combiner) {
            return this._eventListeners[name].length;
          } else {
            return 1;
          }
        }
      }
      return 0;
    }
  }, {
    key: "removeAllListeners",
    value: function removeAllListeners(name) {
      if (this._hasEventListeners) {
        delete this._eventFunction[name];
        delete this._eventListeners[name];
      }
    }
  }]);
  return EventEmitter;
}();

EventEmitter.combiner = function (object, name, arg1, arg2, arg3) {
  var listeners = object._eventListeners[name];
  if (listeners) {
    for (var _i = 0, _arr = (0,toConsumableArray/* default */.Z)(listeners); _i < _arr.length; _i++) {
      var listener = _arr[_i];
      listener(arg1, arg2, arg3);
    }
  }
};
EventEmitter.addAsMixin = function (cls) {
  cls.prototype.on = EventEmitter.prototype.on;
  cls.prototype.once = EventEmitter.prototype.once;
  cls.prototype.has = EventEmitter.prototype.has;
  cls.prototype.off = EventEmitter.prototype.off;
  cls.prototype.removeListener = EventEmitter.prototype.removeListener;
  cls.prototype.emit = EventEmitter.prototype.emit;
  cls.prototype.listenerCount = EventEmitter.prototype.listenerCount;
  cls.prototype.removeAllListeners = EventEmitter.prototype.removeAllListeners;
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/tree/Shader.mjs










var Shader = function () {
  function Shader(coreContext) {
    (0,classCallCheck/* default */.Z)(this, Shader);
    this._initialized = false;
    this.ctx = coreContext;
    this._elements = new Set();
  }
  (0,createClass/* default */.Z)(Shader, [{
    key: "addElement",
    value: function addElement(elementCore) {
      this._elements.add(elementCore);
    }
  }, {
    key: "removeElement",
    value: function removeElement(elementCore) {
      this._elements.delete(elementCore);
      if (!this._elements) {
        this.cleanup();
      }
    }
  }, {
    key: "redraw",
    value: function redraw() {
      this._elements.forEach(function (elementCore) {
        elementCore.setHasRenderUpdates(2);
      });
    }
  }, {
    key: "patch",
    value: function patch(settings) {
      Base.patchObject(this, settings);
    }
  }, {
    key: "useDefault",
    value: function useDefault() {
      return false;
    }
  }, {
    key: "addEmpty",
    value: function addEmpty() {
      return false;
    }
  }, {
    key: "cleanup",
    value: function cleanup() {}
  }, {
    key: "isShader",
    get: function get() {
      return true;
    }
  }], [{
    key: "create",
    value: function create(stage, v) {
      var shader;
      if (Utils_Utils.isObjectLiteral(v)) {
        if (v.type) {
          shader = stage.renderer.createShader(stage.ctx, v);
        } else {
          shader = this.shader;
        }
        if (shader) {
          Base.patchObject(shader, v);
        }
      } else if (v === null) {
        shader = stage.ctx.renderState.defaultShader;
      } else if (v === undefined) {
        shader = null;
      } else {
        if (v.isShader) {
          if (!stage.renderer.isValidShaderType(v.constructor)) {
            console.error("[Lightning] Invalid shader type");
            v = null;
          }
          shader = v;
        } else {
          console.error("[Lightning] Please specify a shader type.");
          return;
        }
      }
      return shader;
    }
  }, {
    key: "getWebGL",
    value: function getWebGL() {
      return undefined;
    }
  }, {
    key: "getC2d",
    value: function getC2d() {
      return undefined;
    }
  }]);
  return Shader;
}();

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/tree/Texture.mjs









var Texture = function () {
  function Texture(stage) {
    (0,classCallCheck/* default */.Z)(this, Texture);
    this.stage = stage;
    this.manager = this.stage.textureManager;
    this.id = Texture.id++;
    this.elements = new Set();
    this._activeCount = 0;
    this._source = null;
    this._resizeMode = null;
    this._x = 0;
    this._y = 0;
    this._w = 0;
    this._h = 0;
    this._precision = 1;
    this.mw = 0;
    this.mh = 0;
    this.clipping = false;
    this._mustUpdate = true;
  }
  (0,createClass/* default */.Z)(Texture, [{
    key: "source",
    get: function get() {
      if (this._mustUpdate || this.stage.hasUpdateSourceTexture(this)) {
        this._performUpdateSource(true);
        this.stage.removeUpdateSourceTexture(this);
      }
      return this._source;
    }
  }, {
    key: "addElement",
    value: function addElement(v) {
      if (!this.elements.has(v)) {
        this.elements.add(v);
        if (this.elements.size === 1) {
          if (this._source) {
            this._source.addTexture(this);
          }
        }
        if (v.active) {
          this.incActiveCount();
        }
      }
    }
  }, {
    key: "removeElement",
    value: function removeElement(v) {
      if (this.elements.delete(v)) {
        if (this.elements.size === 0) {
          if (this._source) {
            this._source.removeTexture(this);
          }
        }
        if (v.active) {
          this.decActiveCount();
        }
      }
    }
  }, {
    key: "incActiveCount",
    value: function incActiveCount() {
      var source = this.source;
      if (source) {
        this._checkForNewerReusableTextureSource();
      }
      this._activeCount++;
      if (this._activeCount === 1) {
        this.becomesUsed();
      }
    }
  }, {
    key: "decActiveCount",
    value: function decActiveCount() {
      var source = this.source;
      this._activeCount--;
      if (!this._activeCount) {
        this.becomesUnused();
      }
    }
  }, {
    key: "becomesUsed",
    value: function becomesUsed() {
      if (this.source) {
        this.source.incActiveTextureCount();
      }
    }
  }, {
    key: "onLoad",
    value: function onLoad() {
      if (this._resizeMode) {
        this._applyResizeMode();
      }
      this.elements.forEach(function (element) {
        if (element.active) {
          element.onTextureSourceLoaded();
        }
      });
    }
  }, {
    key: "_checkForNewerReusableTextureSource",
    value: function _checkForNewerReusableTextureSource() {
      var source = this.source;
      if (!source.isLoaded()) {
        var reusable = this._getReusableTextureSource();
        if (reusable && reusable.isLoaded() && reusable !== source) {
          this._replaceTextureSource(reusable);
        }
      } else {
        if (this._resizeMode) {
          this._applyResizeMode();
        }
      }
    }
  }, {
    key: "becomesUnused",
    value: function becomesUnused() {
      if (this.source) {
        this.source.decActiveTextureCount();
      }
    }
  }, {
    key: "isUsed",
    value: function isUsed() {
      return this._activeCount > 0;
    }
  }, {
    key: "_getLookupId",
    value: function _getLookupId() {
      return null;
    }
  }, {
    key: "_getSourceLoader",
    value: function _getSourceLoader() {
      throw new Error("Texture.generate must be implemented.");
    }
  }, {
    key: "isValid",
    get: function get() {
      return this._getIsValid();
    }
  }, {
    key: "_getIsValid",
    value: function _getIsValid() {
      return true;
    }
  }, {
    key: "_changed",
    value: function _changed() {
      if (this.isUsed()) {
        this._updateSource();
      } else {
        this._mustUpdate = true;
      }
    }
  }, {
    key: "_updateSource",
    value: function _updateSource() {
      this.stage.addUpdateSourceTexture(this);
    }
  }, {
    key: "_performUpdateSource",
    value: function _performUpdateSource() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (force || this.isUsed()) {
        this._mustUpdate = false;
        var source = this._getTextureSource();
        this._replaceTextureSource(source);
      }
    }
  }, {
    key: "_getTextureSource",
    value: function _getTextureSource() {
      var source = null;
      if (this._getIsValid()) {
        var lookupId = this._getLookupId();
        source = this._getReusableTextureSource(lookupId);
        if (!source) {
          source = this.manager.getTextureSource(this._getSourceLoader(), lookupId);
        }
      }
      return source;
    }
  }, {
    key: "_getReusableTextureSource",
    value: function _getReusableTextureSource() {
      var lookupId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._getLookupId();
      if (this._getIsValid()) {
        if (lookupId) {
          return this.manager.getReusableTextureSource(lookupId);
        }
      }
      return null;
    }
  }, {
    key: "_replaceTextureSource",
    value: function _replaceTextureSource() {
      var _this = this;
      var newSource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var oldSource = this._source;
      this._source = newSource;
      if (this.elements.size) {
        if (oldSource) {
          if (this._activeCount) {
            oldSource.decActiveTextureCount();
          }
          oldSource.removeTexture(this);
          if (this['text'] && !oldSource.isUsed()) {
            this.manager.freeTextureSource(oldSource);
          }
        }
        if (newSource) {
          newSource.addTexture(this);
          if (this._activeCount) {
            newSource.incActiveTextureCount();
          }
        }
      }
      if (this.isUsed()) {
        if (newSource) {
          if (newSource.isLoaded()) {
            if (this._resizeMode) {
              this._applyResizeMode();
            }
            this.elements.forEach(function (element) {
              if (element.active) {
                element._setDisplayedTexture(_this);
              }
            });
          } else {
            var loadError = newSource.loadError;
            if (loadError) {
              this.elements.forEach(function (element) {
                if (element.active) {
                  element.onTextureSourceLoadError(loadError);
                }
              });
            }
          }
        } else {
          this.elements.forEach(function (element) {
            if (element.active) {
              element._setDisplayedTexture(null);
            }
          });
        }
      }
    }
  }, {
    key: "load",
    value: function load() {
      if (this.source) {
        if (!this.isLoaded()) {
          this.source.load(true);
        }
      }
    }
  }, {
    key: "isLoaded",
    value: function isLoaded() {
      return this._source && this._source.isLoaded();
    }
  }, {
    key: "loadError",
    get: function get() {
      return this._source && this._source.loadError;
    }
  }, {
    key: "free",
    value: function free() {
      if (this._source) {
        this._source.free();
      }
    }
  }, {
    key: "resizeMode",
    get: function get() {
      return this._resizeMode;
    },
    set: function set(_ref) {
      var _ref$type = _ref.type,
        type = _ref$type === void 0 ? "cover" : _ref$type,
        _ref$w = _ref.w,
        w = _ref$w === void 0 ? 0 : _ref$w,
        _ref$h = _ref.h,
        h = _ref$h === void 0 ? 0 : _ref$h,
        _ref$clipX = _ref.clipX,
        clipX = _ref$clipX === void 0 ? 0.5 : _ref$clipX,
        _ref$clipY = _ref.clipY,
        clipY = _ref$clipY === void 0 ? 0.5 : _ref$clipY;
      this._resizeMode = {
        type: type,
        w: w,
        h: h,
        clipX: clipX,
        clipY: clipY
      };
      if (this.isLoaded()) {
        this._applyResizeMode();
      }
    }
  }, {
    key: "_clearResizeMode",
    value: function _clearResizeMode() {
      this._resizeMode = null;
    }
  }, {
    key: "_applyResizeMode",
    value: function _applyResizeMode() {
      if (this._resizeMode.type === "cover") {
        this._applyResizeCover();
      } else if (this._resizeMode.type === "contain") {
        this._applyResizeContain();
      }
      this._updatePrecision();
      this._updateClipping();
    }
  }, {
    key: "_applyResizeCover",
    value: function _applyResizeCover() {
      var scaleX = this._resizeMode.w / this._source.w;
      var scaleY = this._resizeMode.h / this._source.h;
      var scale = Math.max(scaleX, scaleY);
      if (!scale) return;
      this._precision = 1 / scale;
      if (scaleX && scaleX < scale) {
        var desiredSize = this._precision * this._resizeMode.w;
        var choppedOffPixels = this._source.w - desiredSize;
        this._x = choppedOffPixels * this._resizeMode.clipX;
        this._w = this._source.w - choppedOffPixels;
      }
      if (scaleY && scaleY < scale) {
        var _desiredSize = this._precision * this._resizeMode.h;
        var _choppedOffPixels = this._source.h - _desiredSize;
        this._y = _choppedOffPixels * this._resizeMode.clipY;
        this._h = this._source.h - _choppedOffPixels;
      }
    }
  }, {
    key: "_applyResizeContain",
    value: function _applyResizeContain() {
      var scaleX = this._resizeMode.w / this._source.w;
      var scaleY = this._resizeMode.h / this._source.h;
      var scale = scaleX;
      if (!scale || scaleY < scale) {
        scale = scaleY;
      }
      if (!scale) return;
      this._precision = 1 / scale;
    }
  }, {
    key: "enableClipping",
    value: function enableClipping(x, y, w, h) {
      this._clearResizeMode();
      x *= this._precision;
      y *= this._precision;
      w *= this._precision;
      h *= this._precision;
      if (this._x !== x || this._y !== y || this._w !== w || this._h !== h) {
        this._x = x;
        this._y = y;
        this._w = w;
        this._h = h;
        this._updateClipping(true);
      }
    }
  }, {
    key: "disableClipping",
    value: function disableClipping() {
      this._clearResizeMode();
      if (this._x || this._y || this._w || this._h) {
        this._x = 0;
        this._y = 0;
        this._w = 0;
        this._h = 0;
        this._updateClipping();
      }
    }
  }, {
    key: "_updateClipping",
    value: function _updateClipping() {
      this.clipping = !!(this._x || this._y || this._w || this._h);
      var self = this;
      this.elements.forEach(function (element) {
        if (element.displayedTexture === self) {
          element.onDisplayedTextureClippingChanged();
        }
      });
    }
  }, {
    key: "_updatePrecision",
    value: function _updatePrecision() {
      var self = this;
      this.elements.forEach(function (element) {
        if (element.displayedTexture === self) {
          element.onPrecisionChanged();
        }
      });
    }
  }, {
    key: "getNonDefaults",
    value: function getNonDefaults() {
      var nonDefaults = {};
      nonDefaults['type'] = this.constructor.name;
      if (this.x !== 0) nonDefaults['x'] = this.x;
      if (this.y !== 0) nonDefaults['y'] = this.y;
      if (this.w !== 0) nonDefaults['w'] = this.w;
      if (this.h !== 0) nonDefaults['h'] = this.h;
      if (this.precision !== 1) nonDefaults['precision'] = this.precision;
      return nonDefaults;
    }
  }, {
    key: "px",
    get: function get() {
      return this._x;
    }
  }, {
    key: "py",
    get: function get() {
      return this._y;
    }
  }, {
    key: "pw",
    get: function get() {
      return this._w;
    }
  }, {
    key: "ph",
    get: function get() {
      return this._h;
    }
  }, {
    key: "x",
    get: function get() {
      return this._x / this._precision;
    },
    set: function set(v) {
      this._clearResizeMode();
      v = v * this._precision;
      if (this._x !== v) {
        this._x = v;
        this._updateClipping();
      }
    }
  }, {
    key: "y",
    get: function get() {
      return this._y / this._precision;
    },
    set: function set(v) {
      this._clearResizeMode();
      v = v * this._precision;
      if (this._y !== v) {
        this._y = v;
        this._updateClipping();
      }
    }
  }, {
    key: "w",
    get: function get() {
      return this._w / this._precision;
    },
    set: function set(v) {
      this._clearResizeMode();
      v = v * this._precision;
      if (this._w !== v) {
        this._w = v;
        this._updateClipping();
      }
    }
  }, {
    key: "h",
    get: function get() {
      return this._h / this._precision;
    },
    set: function set(v) {
      this._clearResizeMode();
      v = v * this._precision;
      if (this._h !== v) {
        this._h = v;
        this._updateClipping();
      }
    }
  }, {
    key: "precision",
    get: function get() {
      return this._precision;
    },
    set: function set(v) {
      this._clearResizeMode();
      if (this._precision !== v) {
        this._precision = v;
        this._updatePrecision();
      }
    }
  }, {
    key: "isAutosizeTexture",
    value: function isAutosizeTexture() {
      return true;
    }
  }, {
    key: "getRenderWidth",
    value: function getRenderWidth() {
      if (!this.isAutosizeTexture()) {
        return 0;
      }
      return (this._w || (this._source ? this._source.getRenderWidth() - this._x : 0)) / this._precision;
    }
  }, {
    key: "getRenderHeight",
    value: function getRenderHeight() {
      if (!this.isAutosizeTexture()) {
        return 0;
      }
      return (this._h || (this._source ? this._source.getRenderHeight() - this._y : 0)) / this._precision;
    }
  }, {
    key: "patch",
    value: function patch(settings) {
      Base.patchObject(this, settings);
    }
  }]);
  return Texture;
}();

Texture.prototype.isTexture = true;
Texture.id = 0;

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/textures/ImageTexture.mjs






function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var ImageTexture = function (_Texture) {
  (0,inherits/* default */.Z)(ImageTexture, _Texture);
  var _super = _createSuper(ImageTexture);
  function ImageTexture(stage) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, ImageTexture);
    _this = _super.call(this, stage);
    _this._src = undefined;
    _this._hasAlpha = false;
    return _this;
  }
  (0,createClass/* default */.Z)(ImageTexture, [{
    key: "src",
    get: function get() {
      return this._src;
    },
    set: function set(v) {
      if (this._src !== v) {
        this._src = v;
        this._changed();
      }
    }
  }, {
    key: "hasAlpha",
    get: function get() {
      return this._hasAlpha;
    },
    set: function set(v) {
      if (this._hasAlpha !== v) {
        this._hasAlpha = v;
        this._changed();
      }
    }
  }, {
    key: "_getIsValid",
    value: function _getIsValid() {
      return !!this._src;
    }
  }, {
    key: "_getLookupId",
    value: function _getLookupId() {
      return this._src;
    }
  }, {
    key: "_getSourceLoader",
    value: function _getSourceLoader() {
      var _this2 = this;
      var src = this._src;
      var hasAlpha = this._hasAlpha;
      if (this.stage.getOption('srcBasePath')) {
        var fc = src.charCodeAt(0);
        if (src.indexOf("//") === -1 && (fc >= 65 && fc <= 90 || fc >= 97 && fc <= 122 || fc == 46)) {
          src = this.stage.getOption('srcBasePath') + src;
        }
      }
      return function (cb) {
        return _this2.stage.platform.loadSrcTexture({
          src: src,
          hasAlpha: hasAlpha
        }, cb);
      };
    }
  }, {
    key: "getNonDefaults",
    value: function getNonDefaults() {
      var obj = (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(ImageTexture.prototype), "getNonDefaults", this).call(this);
      if (this._src) {
        obj.src = this._src;
      }
      return obj;
    }
  }]);
  return ImageTexture;
}(Texture);

// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/superPropBase.js
var superPropBase = __webpack_require__(74533);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/set.js


function set(target, property, value, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.set) {
    set = Reflect.set;
  } else {
    set = function set(target, property, value, receiver) {
      var base = (0,superPropBase/* default */.Z)(target, property);
      var desc;
      if (base) {
        desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.set) {
          desc.set.call(receiver, value);
          return true;
        } else if (!desc.writable) {
          return false;
        }
      }
      desc = Object.getOwnPropertyDescriptor(receiver, property);
      if (desc) {
        if (!desc.writable) {
          return false;
        }
        desc.value = value;
        Object.defineProperty(receiver, property, desc);
      } else {
        (0,defineProperty/* default */.Z)(receiver, property, value);
      }
      return true;
    };
  }
  return set(target, property, value, receiver);
}
function _set(target, property, value, receiver, isStrict) {
  var s = set(target, property, value, receiver || target);
  if (!s && isStrict) {
    throw new TypeError('failed to set property');
  }
  return value;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/textures/TextTextureRendererUtils.mjs


function getFontSetting(fontFace, fontStyle, fontSize, precision, defaultFontFace) {
  var ff = fontFace;
  if (!Array.isArray(ff)) {
    ff = [ff];
  }
  var ffs = [];
  for (var i = 0, n = ff.length; i < n; i++) {
    var curFf = ff[i];
    if (curFf === null) {
      curFf = defaultFontFace;
    }
    if (curFf === "serif" || curFf === "sans-serif") {
      ffs.push(curFf);
    } else {
      ffs.push("\"".concat(curFf, "\""));
    }
  }
  return "".concat(fontStyle, " ").concat(fontSize * precision, "px ").concat(ffs.join(","));
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/textures/TextTextureRenderer.mjs











var TextTextureRenderer = function () {
  function TextTextureRenderer(stage, canvas, settings) {
    (0,classCallCheck/* default */.Z)(this, TextTextureRenderer);
    this._stage = stage;
    this._canvas = canvas;
    this._context = this._canvas.getContext('2d');
    this._settings = settings;
  }
  (0,createClass/* default */.Z)(TextTextureRenderer, [{
    key: "getPrecision",
    value: function getPrecision() {
      return this._settings.precision;
    }
  }, {
    key: "setFontProperties",
    value: function setFontProperties() {
      this._context.font = getFontSetting(this._settings.fontFace, this._settings.fontStyle, this._settings.fontSize, this.getPrecision(), this._stage.getOption('defaultFontFace'));
      this._context.textBaseline = this._settings.textBaseline;
    }
  }, {
    key: "_load",
    value: function _load() {
      var _this = this;
      if (Utils_Utils.isWeb && document.fonts) {
        var fontSetting = getFontSetting(this._settings.fontFace, this._settings.fontStyle, this._settings.fontSize, this.getPrecision(), this._stage.getOption('defaultFontFace'));
        try {
          if (!document.fonts.check(fontSetting, this._settings.text)) {
            return document.fonts.load(fontSetting, this._settings.text).catch(function (err) {
              console.warn('[Lightning] Font load error', err, fontSetting);
            }).then(function () {
              if (!document.fonts.check(fontSetting, _this._settings.text)) {
                console.warn('[Lightning] Font not found', fontSetting);
              }
            });
          }
        } catch (e) {
          console.warn("[Lightning] Can't check font loading for " + fontSetting);
        }
      }
    }
  }, {
    key: "draw",
    value: function draw() {
      var _this2 = this;
      var loadPromise = this._load();
      if (!loadPromise) {
        return Utils_Utils.isSpark ? this._stage.platform.drawText(this) : this._draw();
      } else {
        return loadPromise.then(function () {
          return Utils_Utils.isSpark ? _this2._stage.platform.drawText(_this2) : _this2._draw();
        });
      }
    }
  }, {
    key: "_calculateRenderInfo",
    value: function _calculateRenderInfo() {
      var renderInfo = {};
      var precision = this.getPrecision();
      var paddingLeft = this._settings.paddingLeft * precision;
      var paddingRight = this._settings.paddingRight * precision;
      var fontSize = this._settings.fontSize * precision;
      var offsetY = this._settings.offsetY === null ? null : this._settings.offsetY * precision;
      var lineHeight = this._settings.lineHeight * precision;
      var w = this._settings.w * precision;
      var h = this._settings.h * precision;
      var wordWrapWidth = this._settings.wordWrapWidth * precision;
      var cutSx = this._settings.cutSx * precision;
      var cutEx = this._settings.cutEx * precision;
      var cutSy = this._settings.cutSy * precision;
      var cutEy = this._settings.cutEy * precision;
      var letterSpacing = (this._settings.letterSpacing || 0) * precision;
      var textIndent = this._settings.textIndent * precision;
      this.setFontProperties();
      var width = w || 2048 / this.getPrecision();
      var innerWidth = width - paddingLeft;
      if (innerWidth < 10) {
        width += 10 - innerWidth;
        innerWidth = 10;
      }
      if (!wordWrapWidth) {
        wordWrapWidth = innerWidth;
      }
      if (this._settings.textOverflow && !this._settings.wordWrap) {
        var suffix;
        switch (this._settings.textOverflow) {
          case 'clip':
            suffix = '';
            break;
          case 'ellipsis':
            suffix = this._settings.maxLinesSuffix;
            break;
          default:
            suffix = this._settings.textOverflow;
        }
        this._settings.text = this.wrapWord(this._settings.text, wordWrapWidth - textIndent, suffix);
      }
      var linesInfo;
      if (this._settings.wordWrap) {
        linesInfo = this.wrapText(this._settings.text, wordWrapWidth, letterSpacing, textIndent);
      } else {
        linesInfo = {
          l: this._settings.text.split(/(?:\r\n|\r|\n)/),
          n: []
        };
        var i,
          n = linesInfo.l.length;
        for (var _i = 0; _i < n - 1; _i++) {
          linesInfo.n.push(_i);
        }
      }
      var lines = linesInfo.l;
      if (this._settings.maxLines && lines.length > this._settings.maxLines) {
        var usedLines = lines.slice(0, this._settings.maxLines);
        var otherLines = null;
        if (this._settings.maxLinesSuffix) {
          var _w = this._settings.maxLinesSuffix ? this.measureText(this._settings.maxLinesSuffix) : 0;
          var al = this.wrapText(usedLines[usedLines.length - 1], wordWrapWidth - _w, letterSpacing, textIndent);
          usedLines[usedLines.length - 1] = al.l[0] + this._settings.maxLinesSuffix;
          otherLines = [al.l.length > 1 ? al.l[1] : ''];
        } else {
          otherLines = [''];
        }
        var _i2,
          _n = lines.length;
        var j = 0;
        var m = linesInfo.n.length;
        for (_i2 = this._settings.maxLines; _i2 < _n; _i2++) {
          otherLines[j] += (otherLines[j] ? " " : "") + lines[_i2];
          if (_i2 + 1 < m && linesInfo.n[_i2 + 1]) {
            j++;
          }
        }
        renderInfo.remainingText = otherLines.join("\n");
        renderInfo.moreTextLines = true;
        lines = usedLines;
      } else {
        renderInfo.moreTextLines = false;
        renderInfo.remainingText = "";
      }
      var maxLineWidth = 0;
      var lineWidths = [];
      for (var _i3 = 0; _i3 < lines.length; _i3++) {
        var lineWidth = this.measureText(lines[_i3], letterSpacing) + (_i3 === 0 ? textIndent : 0);
        lineWidths.push(lineWidth);
        maxLineWidth = Math.max(maxLineWidth, lineWidth);
      }
      renderInfo.lineWidths = lineWidths;
      if (!w) {
        width = maxLineWidth + paddingLeft + paddingRight;
        innerWidth = maxLineWidth;
      }
      lineHeight = lineHeight || fontSize;
      var height;
      if (h) {
        height = h;
      } else {
        var baselineOffset = this._settings.textBaseline != 'bottom' ? 0.5 * fontSize : 0;
        height = lineHeight * (lines.length - 1) + baselineOffset + Math.max(lineHeight, fontSize) + offsetY;
      }
      if (offsetY === null) {
        offsetY = fontSize;
      }
      renderInfo.w = width;
      renderInfo.h = height;
      renderInfo.lines = lines;
      renderInfo.precision = precision;
      if (!width) {
        width = 1;
      }
      if (!height) {
        height = 1;
      }
      if (cutSx || cutEx) {
        width = Math.min(width, cutEx - cutSx);
      }
      if (cutSy || cutEy) {
        height = Math.min(height, cutEy - cutSy);
      }
      renderInfo.width = width;
      renderInfo.innerWidth = innerWidth;
      renderInfo.height = height;
      renderInfo.fontSize = fontSize;
      renderInfo.cutSx = cutSx;
      renderInfo.cutSy = cutSy;
      renderInfo.cutEx = cutEx;
      renderInfo.cutEy = cutEy;
      renderInfo.lineHeight = lineHeight;
      renderInfo.lineWidths = lineWidths;
      renderInfo.offsetY = offsetY;
      renderInfo.paddingLeft = paddingLeft;
      renderInfo.paddingRight = paddingRight;
      renderInfo.letterSpacing = letterSpacing;
      renderInfo.textIndent = textIndent;
      return renderInfo;
    }
  }, {
    key: "_draw",
    value: function _draw() {
      var renderInfo = this._calculateRenderInfo();
      var precision = this.getPrecision();
      this._canvas.width = Math.ceil(renderInfo.width + this._stage.getOption('textRenderIssueMargin'));
      this._canvas.height = Math.ceil(renderInfo.height);
      this.setFontProperties();
      if (renderInfo.fontSize >= 128) {
        this._context.globalAlpha = 0.01;
        this._context.fillRect(0, 0, 0.01, 0.01);
        this._context.globalAlpha = 1.0;
      }
      if (renderInfo.cutSx || renderInfo.cutSy) {
        this._context.translate(-renderInfo.cutSx, -renderInfo.cutSy);
      }
      var linePositionX;
      var linePositionY;
      var drawLines = [];
      for (var i = 0, n = renderInfo.lines.length; i < n; i++) {
        linePositionX = i === 0 ? renderInfo.textIndent : 0;
        linePositionY = i * renderInfo.lineHeight + renderInfo.offsetY;
        if (this._settings.verticalAlign == 'middle') {
          linePositionY += (renderInfo.lineHeight - renderInfo.fontSize) / 2;
        } else if (this._settings.verticalAlign == 'bottom') {
          linePositionY += renderInfo.lineHeight - renderInfo.fontSize;
        }
        if (this._settings.textAlign === 'right') {
          linePositionX += renderInfo.innerWidth - renderInfo.lineWidths[i];
        } else if (this._settings.textAlign === 'center') {
          linePositionX += (renderInfo.innerWidth - renderInfo.lineWidths[i]) / 2;
        }
        linePositionX += renderInfo.paddingLeft;
        drawLines.push({
          text: renderInfo.lines[i],
          x: linePositionX,
          y: linePositionY,
          w: renderInfo.lineWidths[i]
        });
      }
      if (this._settings.highlight) {
        var color = this._settings.highlightColor || 0x00000000;
        var hlHeight = this._settings.highlightHeight * precision || renderInfo.fontSize * 1.5;
        var offset = this._settings.highlightOffset * precision;
        var hlPaddingLeft = this._settings.highlightPaddingLeft !== null ? this._settings.highlightPaddingLeft * precision : renderInfo.paddingLeft;
        var hlPaddingRight = this._settings.highlightPaddingRight !== null ? this._settings.highlightPaddingRight * precision : renderInfo.paddingRight;
        this._context.fillStyle = StageUtils.getRgbaString(color);
        for (var _i4 = 0; _i4 < drawLines.length; _i4++) {
          var drawLine = drawLines[_i4];
          this._context.fillRect(drawLine.x - hlPaddingLeft, drawLine.y - renderInfo.offsetY + offset, drawLine.w + hlPaddingRight + hlPaddingLeft, hlHeight);
        }
      }
      var prevShadowSettings = null;
      if (this._settings.shadow) {
        prevShadowSettings = [this._context.shadowColor, this._context.shadowOffsetX, this._context.shadowOffsetY, this._context.shadowBlur];
        this._context.shadowColor = StageUtils.getRgbaString(this._settings.shadowColor);
        this._context.shadowOffsetX = this._settings.shadowOffsetX * precision;
        this._context.shadowOffsetY = this._settings.shadowOffsetY * precision;
        this._context.shadowBlur = this._settings.shadowBlur * precision;
      }
      this._context.fillStyle = StageUtils.getRgbaString(this._settings.textColor);
      for (var _i5 = 0, _n2 = drawLines.length; _i5 < _n2; _i5++) {
        var _drawLine = drawLines[_i5];
        if (renderInfo.letterSpacing === 0) {
          this._context.fillText(_drawLine.text, _drawLine.x, _drawLine.y);
        } else {
          var textSplit = _drawLine.text.split('');
          var x = _drawLine.x;
          for (var _i6 = 0, j = textSplit.length; _i6 < j; _i6++) {
            this._context.fillText(textSplit[_i6], x, _drawLine.y);
            x += this.measureText(textSplit[_i6], renderInfo.letterSpacing);
          }
        }
      }
      if (prevShadowSettings) {
        this._context.shadowColor = prevShadowSettings[0];
        this._context.shadowOffsetX = prevShadowSettings[1];
        this._context.shadowOffsetY = prevShadowSettings[2];
        this._context.shadowBlur = prevShadowSettings[3];
      }
      if (renderInfo.cutSx || renderInfo.cutSy) {
        this._context.translate(renderInfo.cutSx, renderInfo.cutSy);
      }
      this.renderInfo = renderInfo;
    }
  }, {
    key: "wrapWord",
    value: function wrapWord(word, wordWrapWidth, suffix) {
      var suffixWidth = this._context.measureText(suffix).width;
      var wordLen = word.length;
      var wordWidth = this._context.measureText(word).width;
      if (wordWidth <= wordWrapWidth) {
        return word;
      }
      var cutoffIndex = Math.floor(wordWrapWidth * wordLen / wordWidth);
      var truncWordWidth = this._context.measureText(word.substring(0, cutoffIndex)).width + suffixWidth;
      if (truncWordWidth > wordWrapWidth) {
        while (cutoffIndex > 0) {
          truncWordWidth = this._context.measureText(word.substring(0, cutoffIndex)).width + suffixWidth;
          if (truncWordWidth > wordWrapWidth) {
            cutoffIndex -= 1;
          } else {
            break;
          }
        }
      } else {
        while (cutoffIndex < wordLen) {
          truncWordWidth = this._context.measureText(word.substring(0, cutoffIndex)).width + suffixWidth;
          if (truncWordWidth < wordWrapWidth) {
            cutoffIndex += 1;
          } else {
            cutoffIndex -= 1;
            break;
          }
        }
      }
      return word.substring(0, cutoffIndex) + (wordWrapWidth >= suffixWidth ? suffix : '');
    }
  }, {
    key: "wrapText",
    value: function wrapText(text, wordWrapWidth, letterSpacing) {
      var indent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var lines = text.split(/\r?\n/g);
      var allLines = [];
      var realNewlines = [];
      for (var i = 0; i < lines.length; i++) {
        var resultLines = [];
        var result = '';
        var spaceLeft = wordWrapWidth - indent;
        var words = lines[i].split(' ');
        for (var j = 0; j < words.length; j++) {
          var wordWidth = this.measureText(words[j], letterSpacing);
          var wordWidthWithSpace = wordWidth + this.measureText(' ', letterSpacing);
          if (j === 0 || wordWidthWithSpace > spaceLeft) {
            if (j > 0) {
              resultLines.push(result);
              result = '';
            }
            result += words[j];
            spaceLeft = wordWrapWidth - wordWidth - (j === 0 ? indent : 0);
          } else {
            spaceLeft -= wordWidthWithSpace;
            result += ' ' + words[j];
          }
        }
        resultLines.push(result);
        result = '';
        allLines = allLines.concat(resultLines);
        if (i < lines.length - 1) {
          realNewlines.push(allLines.length);
        }
      }
      return {
        l: allLines,
        n: realNewlines
      };
    }
  }, {
    key: "measureText",
    value: function measureText(word) {
      var _this3 = this;
      var space = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      if (!space) {
        return this._context.measureText(word).width;
      }
      return word.split('').reduce(function (acc, char) {
        return acc + _this3._context.measureText(char).width + space;
      }, 0);
    }
  }]);
  return TextTextureRenderer;
}();

// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__(49747);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.string.bold.js
var es_string_bold = __webpack_require__(59074);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/textures/TextTextureRendererAdvanced.mjs














function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function TextTextureRendererAdvanced_createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = TextTextureRendererAdvanced_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function TextTextureRendererAdvanced_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return TextTextureRendererAdvanced_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? TextTextureRendererAdvanced_arrayLikeToArray(r, a) : void 0; } }
function TextTextureRendererAdvanced_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }



var TextTextureRendererAdvanced = function () {
  function TextTextureRendererAdvanced(stage, canvas, settings) {
    (0,classCallCheck/* default */.Z)(this, TextTextureRendererAdvanced);
    this._stage = stage;
    this._canvas = canvas;
    this._context = this._canvas.getContext('2d');
    this._settings = settings;
  }
  (0,createClass/* default */.Z)(TextTextureRendererAdvanced, [{
    key: "getPrecision",
    value: function getPrecision() {
      return this._settings.precision;
    }
  }, {
    key: "setFontProperties",
    value: function setFontProperties() {
      var font = getFontSetting(this._settings.fontFace, this._settings.fontStyle, this._settings.fontSize, this.getPrecision(), this._stage.getOption('defaultFontFace'));
      this._context.font = font;
      this._context.textBaseline = this._settings.textBaseline;
      return font;
    }
  }, {
    key: "_load",
    value: function _load() {
      var _this = this;
      if (Utils_Utils.isWeb && document.fonts) {
        var fontSetting = getFontSetting(this._settings.fontFace, this._settings.fontStyle, this._settings.fontSize, this.getPrecision(), this._stage.getOption('defaultFontFace'));
        try {
          if (!document.fonts.check(fontSetting, this._settings.text)) {
            return document.fonts.load(fontSetting, this._settings.text).catch(function (err) {
              console.warn('Font load error', err, fontSetting);
            }).then(function () {
              if (!document.fonts.check(fontSetting, _this._settings.text)) {
                console.warn('Font not found', fontSetting);
              }
            });
          }
        } catch (e) {
          console.warn("Can't check font loading for " + fontSetting);
        }
      }
    }
  }, {
    key: "draw",
    value: function draw() {
      var _this2 = this;
      var loadPromise = this._load();
      if (!loadPromise) {
        return Utils_Utils.isSpark ? this._stage.platform.drawText(this) : this._draw();
      } else {
        return loadPromise.then(function () {
          return Utils_Utils.isSpark ? _this2._stage.platform.drawText(_this2) : _this2._draw();
        });
      }
    }
  }, {
    key: "_calculateRenderInfo",
    value: function _calculateRenderInfo() {
      var _this3 = this;
      var renderInfo = {};
      var precision = this.getPrecision();
      var paddingLeft = this._settings.paddingLeft * precision;
      var paddingRight = this._settings.paddingRight * precision;
      var fontSize = this._settings.fontSize * precision;
      var lineHeight = this._settings.lineHeight * precision || fontSize;
      var w = this._settings.w != 0 ? this._settings.w * precision : 2048 / precision;
      var wordWrapWidth = this._settings.wordWrapWidth * precision;
      var cutSx = this._settings.cutSx * precision;
      var cutEx = this._settings.cutEx * precision;
      var cutSy = this._settings.cutSy * precision;
      var cutEy = this._settings.cutEy * precision;
      var letterSpacing = this._settings.letterSpacing || 0;
      renderInfo.baseFont = this.setFontProperties();
      renderInfo.w = w;
      renderInfo.width = w;
      renderInfo.text = this._settings.text;
      renderInfo.precision = precision;
      renderInfo.fontSize = fontSize;
      renderInfo.fontBaselineRatio = this._settings.fontBaselineRatio;
      renderInfo.lineHeight = lineHeight;
      renderInfo.letterSpacing = letterSpacing;
      renderInfo.textAlign = this._settings.textAlign;
      renderInfo.textColor = this._settings.textColor;
      renderInfo.verticalAlign = this._settings.verticalAlign;
      renderInfo.highlight = this._settings.highlight;
      renderInfo.highlightColor = this._settings.highlightColor;
      renderInfo.highlightHeight = this._settings.highlightHeight;
      renderInfo.highlightPaddingLeft = this._settings.highlightPaddingLeft;
      renderInfo.highlightPaddingRight = this._settings.highlightPaddingRight;
      renderInfo.highlightOffset = this._settings.highlightOffset;
      renderInfo.paddingLeft = this._settings.paddingLeft;
      renderInfo.paddingRight = this._settings.paddingRight;
      renderInfo.maxLines = this._settings.maxLines;
      renderInfo.maxLinesSuffix = this._settings.maxLinesSuffix;
      renderInfo.textOverflow = this._settings.textOverflow;
      renderInfo.wordWrap = this._settings.wordWrap;
      renderInfo.wordWrapWidth = wordWrapWidth;
      renderInfo.shadow = this._settings.shadow;
      renderInfo.shadowColor = this._settings.shadowColor;
      renderInfo.shadowOffsetX = this._settings.shadowOffsetX;
      renderInfo.shadowOffsetY = this._settings.shadowOffsetY;
      renderInfo.shadowBlur = this._settings.shadowBlur;
      renderInfo.cutSx = cutSx;
      renderInfo.cutEx = cutEx;
      renderInfo.cutSy = cutSy;
      renderInfo.cutEy = cutEy;
      renderInfo.textIndent = this._settings.textIndent * precision;
      renderInfo.wordBreak = this._settings.wordBreak;
      var text = renderInfo.text;
      var wrapWidth = renderInfo.wordWrap ? renderInfo.wordWrapWidth || renderInfo.width : renderInfo.width;
      if (renderInfo.textOverflow && !renderInfo.wordWrap) {
        var suffix;
        switch (this._settings.textOverflow) {
          case 'clip':
            suffix = '';
            break;
          case 'ellipsis':
            suffix = this._settings.maxLinesSuffix;
            break;
          default:
            suffix = this._settings.textOverflow;
        }
        text = this.wrapWord(text, wordWrapWidth || renderInfo.w, suffix);
      }
      text = this.tokenize(text);
      text = this.parse(text);
      text = this.measure(text, letterSpacing, renderInfo.baseFont);
      if (renderInfo.textIndent) {
        text = this.indent(text, renderInfo.textIndent);
      }
      if (renderInfo.wordBreak) {
        text = text.reduce(function (acc, t) {
          return acc.concat(_this3.wordBreak(t, wrapWidth, renderInfo.baseFont));
        }, []);
        this.resetFontStyle();
      }
      var x = paddingLeft;
      var lineNo = 0;
      var _iterator = TextTextureRendererAdvanced_createForOfIteratorHelper(text),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var t = _step.value;
          if (renderInfo.wordWrap && x + t.width > wrapWidth || t.text == '\n') {
            x = paddingLeft;
            lineNo += 1;
          }
          t.lineNo = lineNo;
          if (t.text == '\n') {
            continue;
          }
          t.x = x;
          x += t.width;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      renderInfo.lineNum = lineNo + 1;
      if (this._settings.h) {
        renderInfo.h = this._settings.h;
      } else if (renderInfo.maxLines && renderInfo.maxLines < renderInfo.lineNum) {
        renderInfo.h = renderInfo.maxLines * renderInfo.lineHeight + fontSize / 2;
      } else {
        renderInfo.h = renderInfo.lineNum * renderInfo.lineHeight + fontSize / 2;
      }
      var baselineOffsetInPx = renderInfo.fontBaselineRatio * renderInfo.fontSize;
      var vaOffset = 0;
      if (renderInfo.verticalAlign == 'top' && this._context.textBaseline == 'alphabetic') {
        vaOffset = -baselineOffsetInPx;
      } else if (renderInfo.verticalAlign == 'middle') {
        vaOffset = (renderInfo.lineHeight - renderInfo.fontSize - baselineOffsetInPx) / 2;
      } else if (this._settings.verticalAlign == 'bottom') {
        vaOffset = renderInfo.lineHeight - renderInfo.fontSize;
      }
      renderInfo.lines = [];
      for (var i = 0; i < renderInfo.lineNum; i++) {
        renderInfo.lines[i] = {
          width: 0,
          x: 0,
          y: renderInfo.lineHeight * i + vaOffset,
          text: []
        };
      }
      var _iterator2 = TextTextureRendererAdvanced_createForOfIteratorHelper(text),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _t = _step2.value;
          renderInfo.lines[_t.lineNo].text.push(_t);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      var _iterator3 = TextTextureRendererAdvanced_createForOfIteratorHelper(renderInfo.lines),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _l2 = _step3.value;
          if (_l2.text.length == 0) {
            continue;
          }
          var firstWord = _l2.text[0].text;
          var lastWord = _l2.text[_l2.text.length - 1].text;
          if (firstWord == '\n') {
            _l2.text.shift();
          }
          if (lastWord == ' ' || lastWord == '\n') {
            _l2.text.pop();
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      var _iterator4 = TextTextureRendererAdvanced_createForOfIteratorHelper(renderInfo.lines),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _l3 = _step4.value;
          _l3.width = _l3.text.reduce(function (acc, t) {
            return acc + t.width;
          }, 0);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      renderInfo.width = this._settings.w != 0 ? this._settings.w * precision : Math.max.apply(Math, (0,toConsumableArray/* default */.Z)(renderInfo.lines.map(function (l) {
        return l.width;
      }))) + paddingRight;
      renderInfo.w = renderInfo.width;
      if (renderInfo.maxLines && renderInfo.lineNum > renderInfo.maxLines && renderInfo.maxLinesSuffix) {
        var index = renderInfo.maxLines - 1;
        var lastLineText = text.filter(function (t) {
          return t.lineNo == index;
        });
        var _suffix = renderInfo.maxLinesSuffix;
        _suffix = this.tokenize(_suffix);
        _suffix = this.parse(_suffix);
        _suffix = this.measure(_suffix, renderInfo.letterSpacing, renderInfo.baseFont);
        var _iterator5 = TextTextureRendererAdvanced_createForOfIteratorHelper(_suffix),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var s = _step5.value;
            s.lineNo = index;
            s.x = 0;
            lastLineText.push(s);
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
        var spl = _suffix.length + 1;
        var _w = lastLineText.reduce(function (acc, t) {
          return acc + t.width;
        }, 0);
        while (_w > renderInfo.width || lastLineText[lastLineText.length - spl].text == ' ') {
          lastLineText.splice(lastLineText.length - spl, 1);
          _w = lastLineText.reduce(function (acc, t) {
            return acc + t.width;
          }, 0);
          if (lastLineText.length < spl) {
            break;
          }
        }
        this.alignLine(lastLineText, lastLineText[0].x);
        renderInfo.lines[index].text = lastLineText;
        renderInfo.lines[index].width = _w;
      }
      if (renderInfo.textAlign == 'center') {
        var _iterator6 = TextTextureRendererAdvanced_createForOfIteratorHelper(renderInfo.lines),
          _step6;
        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var l = _step6.value;
            l.x = (renderInfo.width - l.width - paddingLeft) / 2;
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      } else if (renderInfo.textAlign == 'right') {
        var _iterator7 = TextTextureRendererAdvanced_createForOfIteratorHelper(renderInfo.lines),
          _step7;
        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var _l = _step7.value;
            _l.x = renderInfo.width - _l.width - paddingLeft;
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }
      }
      return renderInfo;
    }
  }, {
    key: "_draw",
    value: function _draw() {
      var renderInfo = this._calculateRenderInfo();
      var precision = this.getPrecision();
      var paddingLeft = renderInfo.paddingLeft * precision;
      var canvasWidth = renderInfo.w || renderInfo.width;
      if (renderInfo.cutSx || renderInfo.cutEx) {
        canvasWidth = Math.min(renderInfo.w, renderInfo.cutEx - renderInfo.cutSx);
      }
      var canvasHeight = renderInfo.h;
      if (renderInfo.cutSy || renderInfo.cutEy) {
        canvasHeight = Math.min(renderInfo.h, renderInfo.cutEy - renderInfo.cutSy);
      }
      this._canvas.width = Math.ceil(canvasWidth + this._stage.getOption('textRenderIssueMargin'));
      this._canvas.height = Math.ceil(canvasHeight);
      this.setFontProperties();
      if (renderInfo.fontSize >= 128) {
        this._context.globalAlpha = 0.01;
        this._context.fillRect(0, 0, 0.01, 0.01);
        this._context.globalAlpha = 1.0;
      }
      if (renderInfo.cutSx || renderInfo.cutSy) {
        this._context.translate(-renderInfo.cutSx, -renderInfo.cutSy);
      }
      if (renderInfo.highlight) {
        var hlColor = renderInfo.highlightColor || 0x00000000;
        var hlHeight = renderInfo.highlightHeight ? renderInfo.highlightHeight * precision : renderInfo.fontSize * 1.5;
        var hlOffset = renderInfo.highlightOffset ? renderInfo.highlightOffset * precision : 0;
        var hlPaddingLeft = renderInfo.highlightPaddingLeft !== null ? renderInfo.highlightPaddingLeft * precision : renderInfo.paddingLeft;
        var hlPaddingRight = renderInfo.highlightPaddingRight !== null ? renderInfo.highlightPaddingRight * precision : renderInfo.paddingRight;
        this._context.fillStyle = StageUtils.getRgbaString(hlColor);
        var lineNum = renderInfo.maxLines ? Math.min(renderInfo.maxLines, renderInfo.lineNum) : renderInfo.lineNum;
        for (var i = 0; i < lineNum; i++) {
          var l = renderInfo.lines[i];
          this._context.fillRect(l.x - hlPaddingLeft + paddingLeft, l.y + hlOffset, l.width + hlPaddingLeft + hlPaddingRight, hlHeight);
        }
      }
      var prevShadowSettings = null;
      if (this._settings.shadow) {
        prevShadowSettings = [this._context.shadowColor, this._context.shadowOffsetX, this._context.shadowOffsetY, this._context.shadowBlur];
        this._context.shadowColor = StageUtils.getRgbaString(this._settings.shadowColor);
        this._context.shadowOffsetX = this._settings.shadowOffsetX * precision;
        this._context.shadowOffsetY = this._settings.shadowOffsetY * precision;
        this._context.shadowBlur = this._settings.shadowBlur * precision;
      }
      var defaultColor = StageUtils.getRgbaString(this._settings.textColor);
      var currentColor = defaultColor;
      this._context.fillStyle = defaultColor;
      var _iterator8 = TextTextureRendererAdvanced_createForOfIteratorHelper(renderInfo.lines),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var line = _step8.value;
          var _iterator9 = TextTextureRendererAdvanced_createForOfIteratorHelper(line.text),
            _step9;
          try {
            for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
              var t = _step9.value;
              var lx = 0;
              if (t.text == '\n') {
                continue;
              }
              if (renderInfo.maxLines && t.lineNo >= renderInfo.maxLines) {
                continue;
              }
              if (t.color != currentColor) {
                currentColor = t.color;
                this._context.fillStyle = currentColor;
              }
              this._context.font = t.fontStyle;
              if (t.letters) {
                var _iterator0 = TextTextureRendererAdvanced_createForOfIteratorHelper(t.letters),
                  _step0;
                try {
                  for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
                    var _l4 = _step0.value;
                    var _x = renderInfo.lines[t.lineNo].x + t.x + lx;
                    this._context.fillText(_l4.text, _x, renderInfo.lines[t.lineNo].y + renderInfo.fontSize);
                    lx += _l4.width;
                  }
                } catch (err) {
                  _iterator0.e(err);
                } finally {
                  _iterator0.f();
                }
              } else {
                var _x2 = renderInfo.lines[t.lineNo].x + t.x;
                this._context.fillText(t.text, _x2, renderInfo.lines[t.lineNo].y + renderInfo.fontSize);
              }
            }
          } catch (err) {
            _iterator9.e(err);
          } finally {
            _iterator9.f();
          }
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
      if (prevShadowSettings) {
        this._context.shadowColor = prevShadowSettings[0];
        this._context.shadowOffsetX = prevShadowSettings[1];
        this._context.shadowOffsetY = prevShadowSettings[2];
        this._context.shadowBlur = prevShadowSettings[3];
      }
      if (renderInfo.cutSx || renderInfo.cutSy) {
        this._context.translate(renderInfo.cutSx, renderInfo.cutSy);
      }
      renderInfo.lines = renderInfo.lines.map(function (l) {
        return l.text.reduce(function (acc, v) {
          return acc + v.text;
        }, '');
      });
      if (renderInfo.maxLines) {
        renderInfo.lines = renderInfo.lines.slice(0, renderInfo.maxLines);
      }
      this.renderInfo = renderInfo;
    }
  }, {
    key: "measureText",
    value: function measureText(word) {
      var _this4 = this;
      var space = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      if (!space) {
        return this._context.measureText(word).width;
      }
      return word.split('').reduce(function (acc, char) {
        return acc + _this4._context.measureText(char).width + space;
      }, 0);
    }
  }, {
    key: "tokenize",
    value: function tokenize(text) {
      var re = / |\n|<i>|<\/i>|<b>|<\/b>|<color=0[xX][0-9a-fA-F]{8}>|<\/color>/g;
      var delimeters = text.match(re) || [];
      var words = text.split(re) || [];
      var final = [];
      for (var i = 0; i < words.length; i++) {
        final.push(words[i], delimeters[i]);
      }
      final.pop();
      return final.filter(function (word) {
        return word != '';
      });
    }
  }, {
    key: "parse",
    value: function parse(tokens) {
      var italic = 0;
      var bold = 0;
      var colorStack = [StageUtils.getRgbaString(this._settings.textColor)];
      var color = 0;
      var colorRegexp = /<color=(0[xX][0-9a-fA-F]{8})>/;
      return tokens.map(function (t) {
        if (t == '<i>') {
          italic += 1;
          t = '';
        } else if (t == '</i>' && italic > 0) {
          italic -= 1;
          t = '';
        } else if (t == '<b>') {
          bold += 1;
          t = '';
        } else if (t == '</b>' && bold > 0) {
          bold -= 1;
          t = '';
        } else if (t == '</color>') {
          if (colorStack.length > 1) {
            color -= 1;
            colorStack.pop();
          }
          t = '';
        } else if (colorRegexp.test(t)) {
          var matched = colorRegexp.exec(t);
          colorStack.push(StageUtils.getRgbaString(parseInt(matched[1])));
          color += 1;
          t = '';
        }
        return {
          text: t,
          italic: italic,
          bold: bold,
          color: colorStack[color]
        };
      }).filter(function (o) {
        return o.text != '';
      });
    }
  }, {
    key: "applyFontStyle",
    value: function applyFontStyle(word, baseFont) {
      var font = baseFont;
      if (word.bold) {
        font = 'bold ' + font;
      }
      if (word.italic) {
        font = 'italic ' + font;
      }
      this._context.font = font;
      word.fontStyle = font;
    }
  }, {
    key: "resetFontStyle",
    value: function resetFontStyle(baseFont) {
      this._context.font = baseFont;
    }
  }, {
    key: "measure",
    value: function measure(parsed) {
      var letterSpacing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var baseFont = arguments.length > 2 ? arguments[2] : undefined;
      var _iterator1 = TextTextureRendererAdvanced_createForOfIteratorHelper(parsed),
        _step1;
      try {
        for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
          var p = _step1.value;
          this.applyFontStyle(p, baseFont);
          p.width = this.measureText(p.text, letterSpacing);
          if (letterSpacing > 0) {
            p.letters = p.text.split('').map(function (l) {
              return {
                text: l
              };
            });
            var _iterator10 = TextTextureRendererAdvanced_createForOfIteratorHelper(p.letters),
              _step10;
            try {
              for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                var l = _step10.value;
                l.width = this.measureText(l.text, letterSpacing);
              }
            } catch (err) {
              _iterator10.e(err);
            } finally {
              _iterator10.f();
            }
          }
        }
      } catch (err) {
        _iterator1.e(err);
      } finally {
        _iterator1.f();
      }
      this.resetFontStyle(baseFont);
      return parsed;
    }
  }, {
    key: "indent",
    value: function indent(parsed, textIndent) {
      parsed.splice(0, 0, {
        text: "",
        width: textIndent
      });
      return parsed;
    }
  }, {
    key: "wrapWord",
    value: function wrapWord(word, wordWrapWidth, suffix) {
      var suffixWidth = this._context.measureText(suffix).width;
      var wordLen = word.length;
      var wordWidth = this._context.measureText(word).width;
      if (wordWidth <= wordWrapWidth) {
        return word;
      }
      var cutoffIndex = Math.floor(wordWrapWidth * wordLen / wordWidth);
      var truncWordWidth = this._context.measureText(word.substring(0, cutoffIndex)).width + suffixWidth;
      if (truncWordWidth > wordWrapWidth) {
        while (cutoffIndex > 0) {
          truncWordWidth = this._context.measureText(word.substring(0, cutoffIndex)).width + suffixWidth;
          if (truncWordWidth > wordWrapWidth) {
            cutoffIndex -= 1;
          } else {
            break;
          }
        }
      } else {
        while (cutoffIndex < wordLen) {
          truncWordWidth = this._context.measureText(word.substring(0, cutoffIndex)).width + suffixWidth;
          if (truncWordWidth < wordWrapWidth) {
            cutoffIndex += 1;
          } else {
            cutoffIndex -= 1;
            break;
          }
        }
      }
      return word.substring(0, cutoffIndex) + (wordWrapWidth >= suffixWidth ? suffix : '');
    }
  }, {
    key: "_getBreakIndex",
    value: function _getBreakIndex(word, width) {
      var wordLen = word.length;
      var wordWidth = this.measureText(word);
      if (wordWidth <= width) {
        return {
          breakIndex: word.length,
          truncWordWidth: wordWidth
        };
      }
      var breakIndex = Math.floor(width * wordLen / wordWidth);
      var truncWordWidth = this.measureText(word.substring(0, breakIndex));
      if (truncWordWidth > width) {
        while (breakIndex > 0) {
          truncWordWidth = this.measureText(word.substring(0, breakIndex));
          if (truncWordWidth > width) {
            breakIndex -= 1;
          } else {
            break;
          }
        }
      } else {
        while (breakIndex < wordLen) {
          truncWordWidth = this.measureText(word.substring(0, breakIndex));
          if (truncWordWidth < width) {
            breakIndex += 1;
          } else {
            breakIndex -= 1;
            truncWordWidth = this.measureText(word.substring(0, breakIndex));
            break;
          }
        }
      }
      return {
        breakIndex: breakIndex,
        truncWordWidth: truncWordWidth
      };
    }
  }, {
    key: "wordBreak",
    value: function wordBreak(word, width, baseFont) {
      if (!word.text) {
        return word;
      }
      this.applyFontStyle(word, baseFont);
      var parts = [];
      var text = word.text;
      if (!word.letters) {
        while (true) {
          var _this$_getBreakIndex = this._getBreakIndex(text, width),
            breakIndex = _this$_getBreakIndex.breakIndex,
            truncWordWidth = _this$_getBreakIndex.truncWordWidth;
          parts.push(_objectSpread({}, word));
          parts[parts.length - 1].text = text.slice(0, breakIndex);
          parts[parts.length - 1].width = truncWordWidth;
          if (breakIndex === text.length) {
            break;
          }
          text = text.slice(breakIndex);
        }
      } else {
        var totalWidth = 0;
        var letters = [];
        var _breakIndex = 0;
        var _iterator11 = TextTextureRendererAdvanced_createForOfIteratorHelper(word.letters),
          _step11;
        try {
          for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
            var l = _step11.value;
            if (totalWidth + l.width >= width) {
              parts.push(_objectSpread({}, word));
              parts[parts.length - 1].text = text.slice(0, _breakIndex);
              parts[parts.length - 1].width = totalWidth;
              parts[parts.length - 1].letters = letters;
              text = text.slice(_breakIndex);
              totalWidth = 0;
              letters = [];
              _breakIndex = 0;
            } else {
              _breakIndex += 1;
              letters.push(l);
              totalWidth += l.width;
            }
          }
        } catch (err) {
          _iterator11.e(err);
        } finally {
          _iterator11.f();
        }
        if (totalWidth > 0) {
          parts.push(_objectSpread({}, word));
          parts[parts.length - 1].text = text.slice(0, _breakIndex);
          parts[parts.length - 1].width = totalWidth;
          parts[parts.length - 1].letters = letters;
        }
      }
      return parts;
    }
  }, {
    key: "alignLine",
    value: function alignLine(parsed) {
      var initialX = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var prevWidth = 0;
      var prevX = initialX;
      var _iterator12 = TextTextureRendererAdvanced_createForOfIteratorHelper(parsed),
        _step12;
      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var word = _step12.value;
          if (word.text == '\n') {
            continue;
          }
          word.x = prevX + prevWidth;
          prevX = word.x;
          prevWidth = word.width;
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
    }
  }]);
  return TextTextureRendererAdvanced;
}();

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/textures/TextTexture.mjs











function TextTexture_createSuper(t) { var r = TextTexture_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function TextTexture_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (TextTexture_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }


var TextTexture = function (_Texture) {
  (0,inherits/* default */.Z)(TextTexture, _Texture);
  var _super = TextTexture_createSuper(TextTexture);
  function TextTexture(stage) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, TextTexture);
    _this = _super.call(this, stage);
    _this._precision = _this.stage.getOption('precision');
    return _this;
  }
  (0,createClass/* default */.Z)(TextTexture, [{
    key: "text",
    get: function get() {
      return this._text;
    },
    set: function set(v) {
      if (this._text !== v) {
        this._text = "" + v;
        this._changed();
      }
    }
  }, {
    key: "w",
    get: function get() {
      return this._w;
    },
    set: function set(v) {
      if (this._w !== v) {
        this._w = v;
        this._changed();
      }
    }
  }, {
    key: "h",
    get: function get() {
      return this._h;
    },
    set: function set(v) {
      if (this._h !== v) {
        this._h = v;
        this._changed();
      }
    }
  }, {
    key: "fontStyle",
    get: function get() {
      return this._fontStyle;
    },
    set: function set(v) {
      if (this._fontStyle !== v) {
        this._fontStyle = v;
        this._changed();
      }
    }
  }, {
    key: "fontBaselineRatio",
    get: function get() {
      return this._fontBaselineRatio;
    },
    set: function set(v) {
      if (this._fontBaselineRatio !== v) {
        this._fontBaselineRatio = v;
        this._changed();
      }
    }
  }, {
    key: "fontSize",
    get: function get() {
      return this._fontSize;
    },
    set: function set(v) {
      if (this._fontSize !== v) {
        this._fontSize = v;
        this._changed();
      }
    }
  }, {
    key: "fontFace",
    get: function get() {
      return this._fontFace;
    },
    set: function set(v) {
      if (this._fontFace !== v) {
        this._fontFace = v;
        this._changed();
      }
    }
  }, {
    key: "wordWrap",
    get: function get() {
      return this._wordWrap;
    },
    set: function set(v) {
      if (this._wordWrap !== v) {
        this._wordWrap = v;
        this._changed();
      }
    }
  }, {
    key: "wordWrapWidth",
    get: function get() {
      return this._wordWrapWidth;
    },
    set: function set(v) {
      if (this._wordWrapWidth !== v) {
        this._wordWrapWidth = v;
        this._changed();
      }
    }
  }, {
    key: "wordBreak",
    get: function get() {
      return this._wordBreak;
    },
    set: function set(v) {
      if (this._wordBreak !== v) {
        this._wordBreak = v;
        this._changed();
      }
    }
  }, {
    key: "textOverflow",
    get: function get() {
      return this._textOverflow;
    },
    set: function set(v) {
      if (v != this._textOverflow) {
        this._textOverflow = v;
        this._changed();
      }
    }
  }, {
    key: "lineHeight",
    get: function get() {
      return this._lineHeight;
    },
    set: function set(v) {
      if (this._lineHeight !== v) {
        this._lineHeight = v;
        this._changed();
      }
    }
  }, {
    key: "textBaseline",
    get: function get() {
      return this._textBaseline;
    },
    set: function set(v) {
      if (this._textBaseline !== v) {
        this._textBaseline = v;
        this._changed();
      }
    }
  }, {
    key: "textAlign",
    get: function get() {
      return this._textAlign;
    },
    set: function set(v) {
      if (this._textAlign !== v) {
        this._textAlign = v;
        this._changed();
      }
    }
  }, {
    key: "verticalAlign",
    get: function get() {
      return this._verticalAlign;
    },
    set: function set(v) {
      if (this._verticalAlign !== v) {
        this._verticalAlign = v;
        this._changed();
      }
    }
  }, {
    key: "offsetY",
    get: function get() {
      return this._offsetY;
    },
    set: function set(v) {
      if (this._offsetY !== v) {
        this._offsetY = v;
        this._changed();
      }
    }
  }, {
    key: "maxLines",
    get: function get() {
      return this._maxLines;
    },
    set: function set(v) {
      if (this._maxLines !== v) {
        this._maxLines = v;
        this._changed();
      }
    }
  }, {
    key: "maxLinesSuffix",
    get: function get() {
      return this._maxLinesSuffix;
    },
    set: function set(v) {
      if (this._maxLinesSuffix !== v) {
        this._maxLinesSuffix = v;
        this._changed();
      }
    }
  }, {
    key: "textColor",
    get: function get() {
      return this._textColor;
    },
    set: function set(v) {
      if (this._textColor !== v) {
        this._textColor = v;
        this._changed();
      }
    }
  }, {
    key: "paddingLeft",
    get: function get() {
      return this._paddingLeft;
    },
    set: function set(v) {
      if (this._paddingLeft !== v) {
        this._paddingLeft = v;
        this._changed();
      }
    }
  }, {
    key: "paddingRight",
    get: function get() {
      return this._paddingRight;
    },
    set: function set(v) {
      if (this._paddingRight !== v) {
        this._paddingRight = v;
        this._changed();
      }
    }
  }, {
    key: "shadow",
    get: function get() {
      return this._shadow;
    },
    set: function set(v) {
      if (this._shadow !== v) {
        this._shadow = v;
        this._changed();
      }
    }
  }, {
    key: "shadowColor",
    get: function get() {
      return this._shadowColor;
    },
    set: function set(v) {
      if (this._shadowColor !== v) {
        this._shadowColor = v;
        this._changed();
      }
    }
  }, {
    key: "shadowOffsetX",
    get: function get() {
      return this._shadowOffsetX;
    },
    set: function set(v) {
      if (this._shadowOffsetX !== v) {
        this._shadowOffsetX = v;
        this._changed();
      }
    }
  }, {
    key: "shadowOffsetY",
    get: function get() {
      return this._shadowOffsetY;
    },
    set: function set(v) {
      if (this._shadowOffsetY !== v) {
        this._shadowOffsetY = v;
        this._changed();
      }
    }
  }, {
    key: "shadowBlur",
    get: function get() {
      return this._shadowBlur;
    },
    set: function set(v) {
      if (this._shadowBlur !== v) {
        this._shadowBlur = v;
        this._changed();
      }
    }
  }, {
    key: "highlight",
    get: function get() {
      return this._highlight;
    },
    set: function set(v) {
      if (this._highlight !== v) {
        this._highlight = v;
        this._changed();
      }
    }
  }, {
    key: "highlightHeight",
    get: function get() {
      return this._highlightHeight;
    },
    set: function set(v) {
      if (this._highlightHeight !== v) {
        this._highlightHeight = v;
        this._changed();
      }
    }
  }, {
    key: "highlightColor",
    get: function get() {
      return this._highlightColor;
    },
    set: function set(v) {
      if (this._highlightColor !== v) {
        this._highlightColor = v;
        this._changed();
      }
    }
  }, {
    key: "highlightOffset",
    get: function get() {
      return this._highlightOffset;
    },
    set: function set(v) {
      if (this._highlightOffset !== v) {
        this._highlightOffset = v;
        this._changed();
      }
    }
  }, {
    key: "highlightPaddingLeft",
    get: function get() {
      return this._highlightPaddingLeft;
    },
    set: function set(v) {
      if (this._highlightPaddingLeft !== v) {
        this._highlightPaddingLeft = v;
        this._changed();
      }
    }
  }, {
    key: "highlightPaddingRight",
    get: function get() {
      return this._highlightPaddingRight;
    },
    set: function set(v) {
      if (this._highlightPaddingRight !== v) {
        this._highlightPaddingRight = v;
        this._changed();
      }
    }
  }, {
    key: "cutSx",
    get: function get() {
      return this._cutSx;
    },
    set: function set(v) {
      if (this._cutSx !== v) {
        this._cutSx = v;
        this._changed();
      }
    }
  }, {
    key: "cutEx",
    get: function get() {
      return this._cutEx;
    },
    set: function set(v) {
      if (this._cutEx !== v) {
        this._cutEx = v;
        this._changed();
      }
    }
  }, {
    key: "cutSy",
    get: function get() {
      return this._cutSy;
    },
    set: function set(v) {
      if (this._cutSy !== v) {
        this._cutSy = v;
        this._changed();
      }
    }
  }, {
    key: "cutEy",
    get: function get() {
      return this._cutEy;
    },
    set: function set(v) {
      if (this._cutEy !== v) {
        this._cutEy = v;
        this._changed();
      }
    }
  }, {
    key: "advancedRenderer",
    get: function get() {
      return this._advancedRenderer;
    },
    set: function set(v) {
      if (this._advancedRenderer !== v) {
        this._advancedRenderer = v;
        this._changed();
      }
    }
  }, {
    key: "letterSpacing",
    get: function get() {
      return this._letterSpacing;
    },
    set: function set(v) {
      if (this._letterSpacing !== v) {
        this._letterSpacing = v;
        this._changed();
      }
    }
  }, {
    key: "textIndent",
    get: function get() {
      return this._textIndent;
    },
    set: function set(v) {
      if (this._textIndent !== v) {
        this._textIndent = v;
        this._changed();
      }
    }
  }, {
    key: "precision",
    get: function get() {
      return (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(TextTexture.prototype), "precision", this);
    },
    set: function set(v) {
      if (this.precision !== v) {
        _set((0,getPrototypeOf/* default */.Z)(TextTexture.prototype), "precision", v, this, true);
        this._changed();
      }
    }
  }, {
    key: "_getIsValid",
    value: function _getIsValid() {
      return !!this.text;
    }
  }, {
    key: "_getLookupId",
    value: function _getLookupId() {
      var parts = [];
      if (this.w !== 0) parts.push("w " + this.w);
      if (this.h !== 0) parts.push("h " + this.h);
      if (this.fontStyle !== "normal") parts.push("fS" + this.fontStyle);
      if (this.fontSize !== 40) parts.push("fs" + this.fontSize);
      if (this.fontBaselineRatio !== 0) parts.push('fb' + this.fontBaselineRatio);
      if (this.fontFace !== null) parts.push("ff" + (Array.isArray(this.fontFace) ? this.fontFace.join(",") : this.fontFace));
      if (this.wordWrap !== true) parts.push("wr" + (this.wordWrap ? 1 : 0));
      if (this.wordWrapWidth !== 0) parts.push("ww" + this.wordWrapWidth);
      if (this.wordBreak !== false) parts.push("wb" + this.wordBreak ? 1 : 0);
      if (this.textOverflow != "") parts.push("to" + this.textOverflow);
      if (this.lineHeight !== null) parts.push("lh" + this.lineHeight);
      if (this.textBaseline !== "alphabetic") parts.push("tb" + this.textBaseline);
      if (this.textAlign !== "left") parts.push("ta" + this.textAlign);
      if (this.verticalAlign !== "top") parts.push("va" + this.verticalAlign);
      if (this.offsetY !== null) parts.push("oy" + this.offsetY);
      if (this.maxLines !== 0) parts.push("ml" + this.maxLines);
      if (this.maxLinesSuffix !== "..") parts.push("ms" + this.maxLinesSuffix);
      parts.push("pc" + this.precision);
      if (this.textColor !== 0xffffffff) parts.push("co" + this.textColor.toString(16));
      if (this.paddingLeft !== 0) parts.push("pl" + this.paddingLeft);
      if (this.paddingRight !== 0) parts.push("pr" + this.paddingRight);
      if (this.shadow !== false) parts.push("sh" + (this.shadow ? 1 : 0));
      if (this.shadowColor !== 0xff000000) parts.push("sc" + this.shadowColor.toString(16));
      if (this.shadowOffsetX !== 0) parts.push("sx" + this.shadowOffsetX);
      if (this.shadowOffsetY !== 0) parts.push("sy" + this.shadowOffsetY);
      if (this.shadowBlur !== 5) parts.push("sb" + this.shadowBlur);
      if (this.highlight !== false) parts.push("hL" + (this.highlight ? 1 : 0));
      if (this.highlightHeight !== 0) parts.push("hh" + this.highlightHeight);
      if (this.highlightColor !== 0xff000000) parts.push("hc" + this.highlightColor.toString(16));
      if (this.highlightOffset !== null) parts.push("ho" + this.highlightOffset);
      if (this.highlightPaddingLeft !== null) parts.push("hl" + this.highlightPaddingLeft);
      if (this.highlightPaddingRight !== null) parts.push("hr" + this.highlightPaddingRight);
      if (this.letterSpacing !== null) parts.push("ls" + this.letterSpacing);
      if (this.textIndent !== null) parts.push("ti" + this.textIndent);
      if (this.cutSx) parts.push("csx" + this.cutSx);
      if (this.cutEx) parts.push("cex" + this.cutEx);
      if (this.cutSy) parts.push("csy" + this.cutSy);
      if (this.cutEy) parts.push("cey" + this.cutEy);
      if (this.advancedRenderer) parts.push("aR" + this.advancedRenderer ? 1 : 0);
      var id = "TX$" + parts.join("|") + ":" + this.text;
      return id;
    }
  }, {
    key: "_getSourceLoader",
    value: function _getSourceLoader() {
      var args = this.cloneArgs();
      var gl = this.stage.gl;
      return function (cb) {
        var _this2 = this;
        var canvas = this.stage.platform.getDrawingCanvas();
        var renderer = args.advancedRenderer ? new TextTextureRendererAdvanced(this.stage, canvas, args) : new TextTextureRenderer(this.stage, canvas, args);
        var p = renderer.draw();
        var texParams = {};
        var sharpCfg = this.stage.getOption('fontSharp');
        var sharpen = false;
        if (Utils_Utils.isBoolean(sharpCfg)) {
          sharpen = sharpCfg;
        } else if (Utils_Utils.isObject(sharpCfg)) {
          var precision = this.stage.getRenderPrecision();
          sharpen = precision <= sharpCfg.precision && args.fontSize <= sharpCfg.fontSize;
        }
        if (gl && sharpen) {
          texParams[gl.TEXTURE_MAG_FILTER] = gl.NEAREST;
        }
        if (p) {
          p.then(function () {
            cb(null, Object.assign({
              renderInfo: renderer.renderInfo,
              throttle: false,
              texParams: texParams
            }, _this2.stage.platform.getTextureOptionsForDrawingCanvas(canvas)));
          }).catch(function (err) {
            cb(err);
          });
        } else {
          cb(null, Object.assign({
            renderInfo: renderer.renderInfo,
            throttle: false,
            texParams: texParams
          }, this.stage.platform.getTextureOptionsForDrawingCanvas(canvas)));
        }
      };
    }
  }, {
    key: "getNonDefaults",
    value: function getNonDefaults() {
      var nonDefaults = (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(TextTexture.prototype), "getNonDefaults", this).call(this);
      if (this.text !== "") nonDefaults['text'] = this.text;
      if (this.w !== 0) nonDefaults['w'] = this.w;
      if (this.h !== 0) nonDefaults['h'] = this.h;
      if (this.fontStyle !== "normal") nonDefaults['fontStyle'] = this.fontStyle;
      if (this.fontSize !== 40) nonDefaults["fontSize"] = this.fontSize;
      if (this.fontBaselineRatio !== 0) nonDefaults['fontBaselineRatio'] = this.fontBaselineRatio;
      if (this.fontFace !== null) nonDefaults["fontFace"] = this.fontFace;
      if (this.wordWrap !== true) nonDefaults["wordWrap"] = this.wordWrap;
      if (this.wordWrapWidth !== 0) nonDefaults["wordWrapWidth"] = this.wordWrapWidth;
      if (this.wordBreak !== false) nonDefaults["wordBreak"] = this.wordBreak;
      if (this.textOverflow != "") nonDefaults["textOverflow"] = this.textOverflow;
      if (this.lineHeight !== null) nonDefaults["lineHeight"] = this.lineHeight;
      if (this.textBaseline !== "alphabetic") nonDefaults["textBaseline"] = this.textBaseline;
      if (this.textAlign !== "left") nonDefaults["textAlign"] = this.textAlign;
      if (this.verticalAlign !== "top") nonDefaults["verticalAlign"] = this.verticalAlign;
      if (this.offsetY !== null) nonDefaults["offsetY"] = this.offsetY;
      if (this.maxLines !== 0) nonDefaults["maxLines"] = this.maxLines;
      if (this.maxLinesSuffix !== "..") nonDefaults["maxLinesSuffix"] = this.maxLinesSuffix;
      if (this.precision !== this.stage.getOption('precision')) nonDefaults["precision"] = this.precision;
      if (this.textColor !== 0xffffffff) nonDefaults["textColor"] = this.textColor;
      if (this.paddingLeft !== 0) nonDefaults["paddingLeft"] = this.paddingLeft;
      if (this.paddingRight !== 0) nonDefaults["paddingRight"] = this.paddingRight;
      if (this.shadow !== false) nonDefaults["shadow"] = this.shadow;
      if (this.shadowColor !== 0xff000000) nonDefaults["shadowColor"] = this.shadowColor;
      if (this.shadowOffsetX !== 0) nonDefaults["shadowOffsetX"] = this.shadowOffsetX;
      if (this.shadowOffsetY !== 0) nonDefaults["shadowOffsetY"] = this.shadowOffsetY;
      if (this.shadowBlur !== 5) nonDefaults["shadowBlur"] = this.shadowBlur;
      if (this.highlight !== false) nonDefaults["highlight"] = this.highlight;
      if (this.highlightHeight !== 0) nonDefaults["highlightHeight"] = this.highlightHeight;
      if (this.highlightColor !== 0xff000000) nonDefaults["highlightColor"] = this.highlightColor;
      if (this.highlightOffset !== 0) nonDefaults["highlightOffset"] = this.highlightOffset;
      if (this.highlightPaddingLeft !== 0) nonDefaults["highlightPaddingLeft"] = this.highlightPaddingLeft;
      if (this.highlightPaddingRight !== 0) nonDefaults["highlightPaddingRight"] = this.highlightPaddingRight;
      if (this.letterSpacing !== 0) nonDefaults["letterSpacing"] = this.letterSpacing;
      if (this.textIndent !== 0) nonDefaults["textIndent"] = this.textIndent;
      if (this.cutSx) nonDefaults["cutSx"] = this.cutSx;
      if (this.cutEx) nonDefaults["cutEx"] = this.cutEx;
      if (this.cutSy) nonDefaults["cutSy"] = this.cutSy;
      if (this.cutEy) nonDefaults["cutEy"] = this.cutEy;
      if (this.advancedRenderer) nonDefaults["renderer"] = this.advancedRenderer;
      return nonDefaults;
    }
  }, {
    key: "cloneArgs",
    value: function cloneArgs() {
      var obj = {};
      obj.text = this._text;
      obj.w = this._w;
      obj.h = this._h;
      obj.fontStyle = this._fontStyle;
      obj.fontSize = this._fontSize;
      obj.fontBaselineRatio = this._fontBaselineRatio;
      obj.fontFace = this._fontFace;
      obj.wordWrap = this._wordWrap;
      obj.wordWrapWidth = this._wordWrapWidth;
      obj.wordBreak = this._wordBreak;
      obj.textOverflow = this._textOverflow;
      obj.lineHeight = this._lineHeight;
      obj.textBaseline = this._textBaseline;
      obj.textAlign = this._textAlign;
      obj.verticalAlign = this._verticalAlign;
      obj.offsetY = this._offsetY;
      obj.maxLines = this._maxLines;
      obj.maxLinesSuffix = this._maxLinesSuffix;
      obj.precision = this._precision;
      obj.textColor = this._textColor;
      obj.paddingLeft = this._paddingLeft;
      obj.paddingRight = this._paddingRight;
      obj.shadow = this._shadow;
      obj.shadowColor = this._shadowColor;
      obj.shadowOffsetX = this._shadowOffsetX;
      obj.shadowOffsetY = this._shadowOffsetY;
      obj.shadowBlur = this._shadowBlur;
      obj.highlight = this._highlight;
      obj.highlightHeight = this._highlightHeight;
      obj.highlightColor = this._highlightColor;
      obj.highlightOffset = this._highlightOffset;
      obj.highlightPaddingLeft = this._highlightPaddingLeft;
      obj.highlightPaddingRight = this._highlightPaddingRight;
      obj.letterSpacing = this._letterSpacing;
      obj.textIndent = this._textIndent;
      obj.cutSx = this._cutSx;
      obj.cutEx = this._cutEx;
      obj.cutSy = this._cutSy;
      obj.cutEy = this._cutEy;
      obj.advancedRenderer = this._advancedRenderer;
      return obj;
    }
  }], [{
    key: "renderer",
    value: function renderer(stage, canvas, settings) {
      if (this.advancedRenderer) {
        return new TextTextureRendererAdvanced(stage, canvas, settings);
      } else {
        return new TextTextureRenderer(stage, canvas, settings);
      }
    }
  }]);
  return TextTexture;
}(Texture);

var proto = TextTexture.prototype;
proto._text = "";
proto._w = 0;
proto._h = 0;
proto._fontStyle = "normal";
proto._fontSize = 40;
proto._fontFace = null;
proto._wordWrap = true;
proto._wordWrapWidth = 0;
proto._wordBreak = false;
proto._textOverflow = "";
proto._lineHeight = null;
proto._textBaseline = "alphabetic";
proto._textAlign = "left";
proto._verticalAlign = "top";
proto._offsetY = null;
proto._maxLines = 0;
proto._maxLinesSuffix = "..";
proto._textColor = 0xFFFFFFFF;
proto._paddingLeft = 0;
proto._paddingRight = 0;
proto._shadow = false;
proto._shadowColor = 0xFF000000;
proto._shadowOffsetX = 0;
proto._shadowOffsetY = 0;
proto._shadowBlur = 5;
proto._highlight = false;
proto._highlightHeight = 0;
proto._highlightColor = 0xFF000000;
proto._highlightOffset = 0;
proto._highlightPaddingLeft = 0;
proto._highlightPaddingRight = 0;
proto._letterSpacing = 0;
proto._textIndent = 0;
proto._cutSx = 0;
proto._cutEx = 0;
proto._cutSy = 0;
proto._cutEy = 0;
proto._advancedRenderer = false;
proto._fontBaselineRatio = 0;


;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/textures/SourceTexture.mjs





function SourceTexture_createSuper(t) { var r = SourceTexture_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function SourceTexture_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (SourceTexture_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var SourceTexture = function (_Texture) {
  (0,inherits/* default */.Z)(SourceTexture, _Texture);
  var _super = SourceTexture_createSuper(SourceTexture);
  function SourceTexture(stage) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, SourceTexture);
    _this = _super.call(this, stage);
    _this._textureSource = undefined;
    return _this;
  }
  (0,createClass/* default */.Z)(SourceTexture, [{
    key: "textureSource",
    get: function get() {
      return this._textureSource;
    },
    set: function set(v) {
      if (v !== this._textureSource) {
        if (v.isResultTexture) {
          this._precision = this.stage.getRenderPrecision();
        }
        this._textureSource = v;
        this._changed();
      }
    }
  }, {
    key: "_getTextureSource",
    value: function _getTextureSource() {
      return this._textureSource;
    }
  }]);
  return SourceTexture;
}(Texture);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/animation/Transition.mjs





function Transition_createSuper(t) { var r = Transition_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function Transition_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (Transition_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var Transition = function (_EventEmitter) {
  (0,inherits/* default */.Z)(Transition, _EventEmitter);
  var _super = Transition_createSuper(Transition);
  function Transition(manager, settings, element, property) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, Transition);
    _this = _super.call(this);
    _this.manager = manager;
    _this._settings = settings;
    _this._element = element;
    _this._getter = element.constructor.getGetter(property);
    _this._setter = element.constructor.getSetter(property);
    _this._merger = settings.merger;
    if (!_this._merger) {
      _this._merger = element.constructor.getMerger(property);
    }
    _this._startValue = _this._getter(_this._element);
    _this._targetValue = _this._startValue;
    _this._p = 1;
    _this._delayLeft = 0;
    return _this;
  }
  (0,createClass/* default */.Z)(Transition, [{
    key: "start",
    value: function start(targetValue) {
      this._startValue = this._getter(this._element);
      if (!this.isAttached()) {
        this._targetValue = targetValue;
        this._p = 1;
        this._updateDrawValue();
      } else {
        if (targetValue === this._startValue) {
          this.reset(targetValue, 1);
        } else {
          this._targetValue = targetValue;
          this._p = 0;
          this._delayLeft = this._settings.delay;
          this.emit('start');
          this.add();
        }
      }
    }
  }, {
    key: "finish",
    value: function finish() {
      if (this._p < 1) {
        this._p = 1;
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      this.emit('stop');
      this.manager.removeActive(this);
    }
  }, {
    key: "pause",
    value: function pause() {
      this.stop();
    }
  }, {
    key: "play",
    value: function play() {
      this.manager.addActive(this);
    }
  }, {
    key: "reset",
    value: function reset(targetValue, p) {
      if (!this.isAttached()) {
        this._startValue = this._getter(this._element);
        this._targetValue = targetValue;
        this._p = 1;
        this._updateDrawValue();
      } else {
        this._startValue = this._getter(this._element);
        this._targetValue = targetValue;
        this._p = p;
        this.add();
      }
    }
  }, {
    key: "_updateDrawValue",
    value: function _updateDrawValue() {
      this._setter(this._element, this.getDrawValue());
    }
  }, {
    key: "add",
    value: function add() {
      this.manager.addActive(this);
    }
  }, {
    key: "isAttached",
    value: function isAttached() {
      return this._element.attached;
    }
  }, {
    key: "isRunning",
    value: function isRunning() {
      return this._p < 1.0;
    }
  }, {
    key: "progress",
    value: function progress(dt) {
      if (!this.isAttached()) {
        this._p = 1;
      }
      if (this.p < 1) {
        if (this.delayLeft > 0) {
          this._delayLeft -= dt;
          if (this.delayLeft < 0) {
            dt = -this.delayLeft;
            this._delayLeft = 0;
            this.emit('delayEnd');
          } else {
            return;
          }
        }
        if (this._settings.duration == 0) {
          this._p = 1;
        } else {
          this._p += dt / this._settings.duration;
        }
        if (this._p >= 1) {
          this._p = 1;
        }
      }
      this._updateDrawValue();
      this.invokeListeners();
    }
  }, {
    key: "invokeListeners",
    value: function invokeListeners() {
      this.emit('progress', this.p);
      if (this.p === 1) {
        this.emit('finish');
      }
    }
  }, {
    key: "updateTargetValue",
    value: function updateTargetValue(targetValue) {
      var t = this._settings.timingFunctionImpl(this.p);
      if (t === 1) {
        this._targetValue = targetValue;
      } else if (t === 0) {
        this._startValue = this._targetValue;
        this._targetValue = targetValue;
      } else {
        this._startValue = targetValue - (targetValue - this._targetValue) / (1 - t);
        this._targetValue = targetValue;
      }
    }
  }, {
    key: "getDrawValue",
    value: function getDrawValue() {
      if (this.p >= 1) {
        return this.targetValue;
      } else {
        var v = this._settings._timingFunctionImpl(this.p);
        return this._merger(this.targetValue, this.startValue, v);
      }
    }
  }, {
    key: "skipDelay",
    value: function skipDelay() {
      this._delayLeft = 0;
    }
  }, {
    key: "startValue",
    get: function get() {
      return this._startValue;
    }
  }, {
    key: "targetValue",
    get: function get() {
      return this._targetValue;
    }
  }, {
    key: "p",
    get: function get() {
      return this._p;
    }
  }, {
    key: "delayLeft",
    get: function get() {
      return this._delayLeft;
    }
  }, {
    key: "element",
    get: function get() {
      return this._element;
    }
  }, {
    key: "settings",
    get: function get() {
      return this._settings;
    },
    set: function set(v) {
      this._settings = v;
    }
  }]);
  return Transition;
}(EventEmitter);

Transition.prototype.isTransition = true;
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/tree/ObjectList.mjs











var ObjectList = function () {
  function ObjectList() {
    (0,classCallCheck/* default */.Z)(this, ObjectList);
    this._items = [];
    this._refs = {};
  }
  (0,createClass/* default */.Z)(ObjectList, [{
    key: "get",
    value: function get() {
      return this._items;
    }
  }, {
    key: "first",
    get: function get() {
      return this._items[0];
    }
  }, {
    key: "last",
    get: function get() {
      return this._items.length ? this._items[this._items.length - 1] : undefined;
    }
  }, {
    key: "add",
    value: function add(item) {
      this.addAt(item, this._items.length);
    }
  }, {
    key: "addAt",
    value: function addAt(item, index) {
      if (index >= 0 && index <= this._items.length) {
        var currentIndex = this._items.indexOf(item);
        if (currentIndex === index) {
          return item;
        }
        if (Utils_Utils.isObjectLiteral(item)) {
          var o = item;
          item = this.createItem(o);
          item.patch(o);
        }
        if (currentIndex != -1) {
          this.setAt(item, index);
        } else {
          if (item.ref) {
            this._refs[item.ref] = item;
          }
          this._items.splice(index, 0, item);
          this.onAdd(item, index);
        }
      } else {
        throw new Error('addAt: The index ' + index + ' is out of bounds ' + this._items.length);
      }
    }
  }, {
    key: "replaceByRef",
    value: function replaceByRef(item) {
      if (item.ref) {
        var existingItem = this.getByRef(item.ref);
        if (!existingItem) {
          throw new Error('replaceByRef: no item found with reference: ' + item.ref);
        }
        this.replace(item, existingItem);
      } else {
        throw new Error('replaceByRef: no ref specified in item');
      }
      this.addAt(item, this._items.length);
    }
  }, {
    key: "replace",
    value: function replace(item, prevItem) {
      var index = this.getIndex(prevItem);
      if (index === -1) {
        throw new Error('replace: The previous item does not exist');
      }
      this.setAt(item, index);
    }
  }, {
    key: "setAt",
    value: function setAt(item, index) {
      if (index >= 0 && index < this._items.length) {
        if (Utils_Utils.isObjectLiteral(item)) {
          var o = item;
          item = this.createItem(o);
          item.patch(o);
        }
        var currentIndex = this._items.indexOf(item);
        if (currentIndex != -1) {
          if (currentIndex !== index) {
            var fromIndex = currentIndex;
            if (fromIndex !== index) {
              this._items.splice(fromIndex, 1);
              this._items.splice(index, 0, item);
              this.onMove(item, fromIndex, index);
            }
          }
        } else {
          if (index < this._items.length) {
            if (this._items[index].ref) {
              this._refs[this._items[index].ref] = undefined;
            }
          }
          var prevItem = this._items[index];
          this._items[index] = item;
          if (item.ref) {
            this._refs[item.ref] = item;
          }
          this.onSet(item, index, prevItem);
        }
      } else {
        throw new Error('setAt: The index ' + index + ' is out of bounds ' + this._items.length);
      }
    }
  }, {
    key: "getAt",
    value: function getAt(index) {
      return this._items[index];
    }
  }, {
    key: "getIndex",
    value: function getIndex(item) {
      return this._items.indexOf(item);
    }
  }, {
    key: "remove",
    value: function remove(item) {
      var index = this._items.indexOf(item);
      if (index !== -1) {
        this.removeAt(index);
      }
    }
  }, {
    key: "removeAt",
    value: function removeAt(index) {
      if (index >= 0 && index < this._items.length) {
        var item = this._items[index];
        if (item.ref) {
          this._refs[item.ref] = undefined;
        }
        this._items.splice(index, 1);
        this.onRemove(item, index);
        return item;
      } else {
        throw new Error("removeAt: The index ".concat(index, " is out of bounds ").concat(this._items.length - 1));
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      var n = this._items.length;
      if (n) {
        var prev = this._items;
        this._items = [];
        this._refs = {};
        this.onSync(prev, [], []);
      }
    }
  }, {
    key: "a",
    value: function a(o) {
      if (Utils_Utils.isObjectLiteral(o)) {
        var c = this.createItem(o);
        c.patch(o);
        this.add(c);
        return c;
      } else if (Array.isArray(o)) {
        for (var i = 0, n = o.length; i < n; i++) {
          this.a(o[i]);
        }
        return null;
      } else if (this.isItem(o)) {
        this.add(o);
        return o;
      }
    }
  }, {
    key: "length",
    get: function get() {
      return this._items.length;
    }
  }, {
    key: "_getRefs",
    value: function _getRefs() {
      return this._refs;
    }
  }, {
    key: "getByRef",
    value: function getByRef(ref) {
      return this._refs[ref];
    }
  }, {
    key: "clearRef",
    value: function clearRef(ref) {
      delete this._refs[ref];
    }
  }, {
    key: "setRef",
    value: function setRef(ref, child) {
      this._refs[ref] = child;
    }
  }, {
    key: "patch",
    value: function patch(settings) {
      if (Utils_Utils.isObjectLiteral(settings)) {
        this._setByObject(settings);
      } else if (Array.isArray(settings)) {
        this._setByArray(settings);
      }
    }
  }, {
    key: "_setByObject",
    value: function _setByObject(settings) {
      var refs = this._getRefs();
      var crefs = Object.keys(settings);
      for (var i = 0, n = crefs.length; i < n; i++) {
        var cref = crefs[i];
        var s = settings[cref];
        var c = refs[cref];
        if (!c) {
          if (this.isItem(s)) {
            s.ref = cref;
            this.add(s);
          } else {
            c = this.createItem(s);
            c.ref = cref;
            c.patch(s);
            this.add(c);
          }
        } else {
          if (this.isItem(s)) {
            if (c !== s) {
              var idx = this.getIndex(c);
              s.ref = cref;
              this.setAt(s, idx);
            }
          } else {
            c.patch(s);
          }
        }
      }
    }
  }, {
    key: "_equalsArray",
    value: function _equalsArray(array) {
      var same = true;
      if (array.length === this._items.length) {
        for (var i = 0, n = this._items.length; i < n && same; i++) {
          same = same && this._items[i] === array[i];
        }
      } else {
        same = false;
      }
      return same;
    }
  }, {
    key: "_setByArray",
    value: function _setByArray(array) {
      if (this._equalsArray(array)) {
        return;
      }
      for (var i = 0, n = this._items.length; i < n; i++) {
        this._items[i].marker = true;
      }
      var refs;
      var newItems = [];
      for (var _i = 0, _n = array.length; _i < _n; _i++) {
        var s = array[_i];
        if (this.isItem(s)) {
          s.marker = false;
          newItems.push(s);
        } else {
          var cref = s.ref;
          var c = void 0;
          if (cref) {
            if (!refs) refs = this._getRefs();
            c = refs[cref];
          }
          if (!c) {
            c = this.createItem(s);
          } else {
            c.marker = false;
          }
          if (Utils_Utils.isObjectLiteral(s)) {
            c.patch(s);
          }
          newItems.push(c);
        }
      }
      this._setItems(newItems);
    }
  }, {
    key: "_setItems",
    value: function _setItems(newItems) {
      var prevItems = this._items;
      this._items = newItems;
      var removed = prevItems.filter(function (item) {
        var m = item.marker;
        delete item.marker;
        return m;
      });
      var added = newItems.filter(function (item) {
        return prevItems.indexOf(item) === -1;
      });
      if (removed.length || added.length) {
        this._refs = {};
        for (var i = 0, n = this._items.length; i < n; i++) {
          var ref = this._items[i].ref;
          if (ref) {
            this._refs[ref] = this._items[i];
          }
        }
      }
      this.onSync(removed, added, newItems);
    }
  }, {
    key: "sort",
    value: function sort(f) {
      var items = this._items.slice();
      items.sort(f);
      this._setByArray(items);
    }
  }, {
    key: "onAdd",
    value: function onAdd(item, index) {}
  }, {
    key: "onRemove",
    value: function onRemove(item, index) {}
  }, {
    key: "onSync",
    value: function onSync(removed, added, order) {}
  }, {
    key: "onSet",
    value: function onSet(item, index, prevItem) {}
  }, {
    key: "onMove",
    value: function onMove(item, fromIndex, toIndex) {}
  }, {
    key: "createItem",
    value: function createItem(object) {
      throw new Error("ObjectList.createItem must create and return a new object");
    }
  }, {
    key: "isItem",
    value: function isItem(object) {
      return false;
    }
  }, {
    key: "forEach",
    value: function forEach(f) {
      this.get().forEach(f);
    }
  }]);
  return ObjectList;
}();


;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/tree/ElementChildList.mjs







function ElementChildList_createSuper(t) { var r = ElementChildList_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function ElementChildList_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (ElementChildList_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var ElementChildList = function (_ObjectList) {
  (0,inherits/* default */.Z)(ElementChildList, _ObjectList);
  var _super = ElementChildList_createSuper(ElementChildList);
  function ElementChildList(element) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, ElementChildList);
    _this = _super.call(this);
    _this._element = element;
    return _this;
  }
  (0,createClass/* default */.Z)(ElementChildList, [{
    key: "_connectParent",
    value: function _connectParent(item) {
      var prevParent = item.parent;
      if (prevParent && prevParent !== this._element) {
        var prevChildList = item.parent.childList;
        var index = prevChildList.getIndex(item);
        if (item.ref) {
          prevChildList._refs[item.ref] = undefined;
        }
        prevChildList._items.splice(index, 1);
        prevParent.core.removeChildAt(index);
      }
      item._setParent(this._element);
    }
  }, {
    key: "onAdd",
    value: function onAdd(item, index) {
      this._connectParent(item);
      this._element.core.addChildAt(index, item.core);
    }
  }, {
    key: "onRemove",
    value: function onRemove(item, index) {
      item._setParent(null);
      this._element.core.removeChildAt(index);
    }
  }, {
    key: "onSync",
    value: function onSync(removed, added, order) {
      for (var i = 0, n = removed.length; i < n; i++) {
        removed[i]._setParent(null);
      }
      for (var _i = 0, _n = added.length; _i < _n; _i++) {
        this._connectParent(added[_i]);
      }
      var gc = function gc(i) {
        return i.core;
      };
      this._element.core.syncChildren(removed.map(gc), added.map(gc), order.map(gc));
    }
  }, {
    key: "onSet",
    value: function onSet(item, index, prevItem) {
      prevItem._setParent(null);
      this._connectParent(item);
      this._element.core.setChildAt(index, item.core);
    }
  }, {
    key: "onMove",
    value: function onMove(item, fromIndex, toIndex) {
      this._element.core.moveChild(fromIndex, toIndex);
    }
  }, {
    key: "createItem",
    value: function createItem(object) {
      if (object.type) {
        return new object.type(this._element.stage);
      } else {
        return this._element.stage.createElement();
      }
    }
  }, {
    key: "isItem",
    value: function isItem(object) {
      return object.isElement;
    }
  }]);
  return ElementChildList;
}(ObjectList);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/tree/Element.mjs




















function Element_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Element_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Element_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Element_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






var Element = function () {
  function Element(stage) {
    (0,classCallCheck/* default */.Z)(this, Element);
    this.stage = stage;
    this.__id = Element.id++;
    this.__start();
    this._hasEventListeners = false;
    this.__core = new ElementCore(this);
    this.__ref = null;
    this.__attached = false;
    this.__enabled = false;
    this.__active = false;
    this.__parent = null;
    this.__texture = null;
    this.__displayedTexture = null;
    this.__tags = null;
    this.__treeTags = null;
    this.__tagRoot = false;
    this.__childList = null;
    this._w = 0;
    this._h = 0;
  }
  (0,createClass/* default */.Z)(Element, [{
    key: "__start",
    value: function __start() {}
  }, {
    key: "id",
    get: function get() {
      return this.__id;
    }
  }, {
    key: "ref",
    get: function get() {
      return this.__ref;
    },
    set: function set(ref) {
      if (this.__ref !== ref) {
        var charcode = ref.charCodeAt(0);
        if (!Utils_Utils.isUcChar(charcode)) {
          this._throwError("Ref must start with an upper case character: " + ref);
        }
        if (this.__ref !== null) {
          this.removeTag(this.__ref);
          if (this.__parent) {
            this.__parent.__childList.clearRef(this.__ref);
          }
        }
        this.__ref = ref;
        if (this.__ref) {
          this._addTag(this.__ref);
          if (this.__parent) {
            this.__parent.__childList.setRef(this.__ref, this);
          }
        }
      }
    }
  }, {
    key: "core",
    get: function get() {
      return this.__core;
    }
  }, {
    key: "setAsRoot",
    value: function setAsRoot() {
      this.__core.setAsRoot();
      this._updateAttachedFlag();
      this._updateEnabledFlag();
    }
  }, {
    key: "isRoot",
    get: function get() {
      return this.__core.isRoot;
    }
  }, {
    key: "_setParent",
    value: function _setParent(parent) {
      if (this.__parent === parent) return;
      if (this.__parent) {
        this._unsetTagsParent();
      }
      this.__parent = parent;
      if (parent) {
        this._setTagsParent();
      }
      this._updateAttachedFlag();
      this._updateEnabledFlag();
      this._updateCollision();
      if (this.isRoot && parent) {
        this._throwError("Root should not be added as a child! Results are unspecified!");
      }
    }
  }, {
    key: "getDepth",
    value: function getDepth() {
      var depth = 0;
      var p = this.__parent;
      while (p) {
        depth++;
        p = p.__parent;
      }
      return depth;
    }
  }, {
    key: "getAncestor",
    value: function getAncestor(l) {
      var p = this;
      while (l > 0 && p.__parent) {
        p = p.__parent;
        l--;
      }
      return p;
    }
  }, {
    key: "getAncestors",
    value: function getAncestors() {
      var a = [];
      var p = this;
      while (p) {
        a.push(p);
        p = p.__parent;
      }
      return a;
    }
  }, {
    key: "getAncestorAtDepth",
    value: function getAncestorAtDepth(depth) {
      var levels = this.getDepth() - depth;
      if (levels < 0) {
        return null;
      }
      return this.getAncestor(levels);
    }
  }, {
    key: "isAncestorOf",
    value: function isAncestorOf(c) {
      var p = c;
      while (p = p.parent) {
        if (this === p) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: "getSharedAncestor",
    value: function getSharedAncestor(c) {
      var o1 = this;
      var o2 = c;
      var l1 = o1.getDepth();
      var l2 = o2.getDepth();
      if (l1 > l2) {
        o1 = o1.getAncestor(l1 - l2);
      } else if (l2 > l1) {
        o2 = o2.getAncestor(l2 - l1);
      }
      do {
        if (o1 === o2) {
          return o1;
        }
        o1 = o1.__parent;
        o2 = o2.__parent;
      } while (o1 && o2);
      return null;
    }
  }, {
    key: "attached",
    get: function get() {
      return this.__attached;
    }
  }, {
    key: "enabled",
    get: function get() {
      return this.__enabled;
    }
  }, {
    key: "active",
    get: function get() {
      return this.__active;
    }
  }, {
    key: "_isAttached",
    value: function _isAttached() {
      return this.__parent ? this.__parent.__attached : this.stage.root === this;
    }
  }, {
    key: "_isEnabled",
    value: function _isEnabled() {
      return this.__core.visible && this.__core.alpha > 0 && (this.__parent ? this.__parent.__enabled : this.stage.root === this);
    }
  }, {
    key: "_isActive",
    value: function _isActive() {
      return this._isEnabled() && this.withinBoundsMargin;
    }
  }, {
    key: "_updateAttachedFlag",
    value: function _updateAttachedFlag() {
      var newAttached = this._isAttached();
      if (this.__attached !== newAttached) {
        this.__attached = newAttached;
        if (newAttached) {
          this._onSetup();
        }
        var children = this._children.get();
        if (children) {
          var m = children.length;
          if (m > 0) {
            for (var i = 0; i < m; i++) {
              children[i]._updateAttachedFlag();
            }
          }
        }
        if (newAttached) {
          this._onAttach();
        } else {
          this._onDetach();
        }
      }
    }
  }, {
    key: "_updateEnabledFlag",
    value: function _updateEnabledFlag() {
      var newEnabled = this._isEnabled();
      if (this.__enabled !== newEnabled) {
        if (newEnabled) {
          this._onEnabled();
          this._setEnabledFlag();
        } else {
          this._onDisabled();
          this._unsetEnabledFlag();
        }
        var children = this._children.get();
        if (children) {
          var m = children.length;
          if (m > 0) {
            for (var i = 0; i < m; i++) {
              children[i]._updateEnabledFlag();
            }
          }
        }
      }
    }
  }, {
    key: "_setEnabledFlag",
    value: function _setEnabledFlag() {
      this.__enabled = true;
      this._updateDimensions();
      this._updateTextureCoords();
      if (this.__texture) {
        this.__texture.addElement(this);
      }
      if (this.withinBoundsMargin) {
        this._setActiveFlag();
      }
      if (this.__core.shader) {
        this.__core.shader.addElement(this.__core);
      }
    }
  }, {
    key: "_unsetEnabledFlag",
    value: function _unsetEnabledFlag() {
      var _this = this;
      if (this.__active) {
        this._unsetActiveFlag();
      }
      if (this.__texture) {
        this.__texture.removeElement(this);
      }
      if (this.__core.shader) {
        this.__core.shader.removeElement(this.__core);
      }
      if (this._texturizer) {
        this.texturizer.filters.forEach(function (filter) {
          return filter.removeElement(_this.__core);
        });
      }
      this.__enabled = false;
    }
  }, {
    key: "_setActiveFlag",
    value: function _setActiveFlag() {
      this.__active = true;
      if (this.__texture) {
        this.__texture.incActiveCount();
      }
      if (this.__texture) {
        this._enableTexture();
      }
      this._onActive();
    }
  }, {
    key: "_unsetActiveFlag",
    value: function _unsetActiveFlag() {
      if (this.__texture) {
        this.__texture.decActiveCount();
      }
      this.__active = false;
      if (this.__texture) {
        this._disableTexture();
      }
      if (this._hasTexturizer()) {
        this.texturizer.deactivate();
      }
      this._onInactive();
    }
  }, {
    key: "_onSetup",
    value: function _onSetup() {}
  }, {
    key: "_onAttach",
    value: function _onAttach() {}
  }, {
    key: "_onDetach",
    value: function _onDetach() {}
  }, {
    key: "_onEnabled",
    value: function _onEnabled() {}
  }, {
    key: "_onDisabled",
    value: function _onDisabled() {}
  }, {
    key: "_onActive",
    value: function _onActive() {}
  }, {
    key: "_onInactive",
    value: function _onInactive() {}
  }, {
    key: "_onResize",
    value: function _onResize() {}
  }, {
    key: "_getRenderWidth",
    value: function _getRenderWidth() {
      if (this._w) {
        return this._w;
      } else if (this.__displayedTexture) {
        return this.__displayedTexture.getRenderWidth();
      } else if (this.__texture) {
        return this.__texture.getRenderWidth();
      } else {
        return 0;
      }
    }
  }, {
    key: "_getRenderHeight",
    value: function _getRenderHeight() {
      if (this._h) {
        return this._h;
      } else if (this.__displayedTexture) {
        return this.__displayedTexture.getRenderHeight();
      } else if (this.__texture) {
        return this.__texture.getRenderHeight();
      } else {
        return 0;
      }
    }
  }, {
    key: "renderWidth",
    get: function get() {
      if (this.__enabled) {
        return this.__core.getRenderWidth();
      } else {
        return this._getRenderWidth();
      }
    }
  }, {
    key: "renderHeight",
    get: function get() {
      if (this.__enabled) {
        return this.__core.getRenderHeight();
      } else {
        return this._getRenderHeight();
      }
    }
  }, {
    key: "finalX",
    get: function get() {
      return this.__core.x;
    }
  }, {
    key: "finalY",
    get: function get() {
      return this.__core.y;
    }
  }, {
    key: "finalW",
    get: function get() {
      return this.__core.w;
    }
  }, {
    key: "finalH",
    get: function get() {
      return this.__core.h;
    }
  }, {
    key: "textureIsLoaded",
    value: function textureIsLoaded() {
      return this.__texture && this.__texture.isLoaded();
    }
  }, {
    key: "loadTexture",
    value: function loadTexture() {
      if (this.__texture) {
        this.__texture.load();
        if (!this.__texture.isUsed() || !this._isEnabled()) {
          this._updateDimensions();
        }
      }
    }
  }, {
    key: "_enableTextureError",
    value: function _enableTextureError() {
      var loadError = this.__texture.loadError;
      if (loadError) {
        this.emit('txError', loadError, this.__texture._source);
      }
    }
  }, {
    key: "_enableTexture",
    value: function _enableTexture() {
      if (this.__texture.isLoaded()) {
        this._setDisplayedTexture(this.__texture);
      } else {
        this._setDisplayedTexture(null);
        this._enableTextureError();
      }
    }
  }, {
    key: "_disableTexture",
    value: function _disableTexture() {
      this._setDisplayedTexture(null);
    }
  }, {
    key: "texture",
    get: function get() {
      return this.__texture;
    },
    set: function set(v) {
      var texture;
      if (Utils_Utils.isObjectLiteral(v)) {
        if (v.type) {
          texture = new v.type(this.stage);
        } else {
          texture = this.texture;
        }
        if (texture) {
          Base.patchObject(texture, v);
        }
      } else if (!v) {
        texture = null;
      } else {
        if (v.isTexture) {
          texture = v;
        } else if (v.isTextureSource) {
          texture = new SourceTexture(this.stage);
          texture.textureSource = v;
        } else {
          console.error("[Lightning] Please specify a texture type.");
          return;
        }
      }
      var prevTexture = this.__texture;
      if (texture !== prevTexture) {
        this.__texture = texture;
        if (this.__texture) {
          if (this.__enabled) {
            this.__texture.addElement(this);
            if (this.withinBoundsMargin) {
              if (this.__texture.isLoaded()) {
                this._setDisplayedTexture(this.__texture);
              } else {
                this._enableTextureError();
              }
            }
          }
        } else {
          this._setDisplayedTexture(null);
        }
        if (prevTexture && prevTexture !== this.__displayedTexture) {
          prevTexture.removeElement(this);
        }
        this._updateDimensions();
      }
    }
  }, {
    key: "displayedTexture",
    get: function get() {
      return this.__displayedTexture;
    }
  }, {
    key: "_setDisplayedTexture",
    value: function _setDisplayedTexture(v) {
      var prevTexture = this.__displayedTexture;
      if (prevTexture && v !== prevTexture) {
        if (this.__texture !== prevTexture) {
          prevTexture.removeElement(this);
        }
      }
      var prevSource = this.__core.displayedTextureSource ? this.__core.displayedTextureSource._source : null;
      var sourceChanged = (v ? v._source : null) !== prevSource;
      this.__displayedTexture = v;
      this._updateDimensions();
      if (this.__displayedTexture) {
        if (sourceChanged) {
          this._updateTextureCoords();
          this.__core.setDisplayedTextureSource(this.__displayedTexture._source);
        }
      } else {
        this.__core.setDisplayedTextureSource(null);
      }
      if (sourceChanged) {
        if (this.__displayedTexture) {
          this.emit('txLoaded', this.__displayedTexture);
        } else {
          this.emit('txUnloaded', this.__displayedTexture);
        }
      }
    }
  }, {
    key: "onTextureSourceLoaded",
    value: function onTextureSourceLoaded() {
      if (this.active) {
        this._setDisplayedTexture(this.__texture);
      }
    }
  }, {
    key: "onTextureSourceLoadError",
    value: function onTextureSourceLoadError(e) {
      this.emit('txError', e, this.__texture._source);
    }
  }, {
    key: "forceRenderUpdate",
    value: function forceRenderUpdate() {
      this.__core.setHasRenderUpdates(3);
    }
  }, {
    key: "onDisplayedTextureClippingChanged",
    value: function onDisplayedTextureClippingChanged() {
      this._updateDimensions();
      this._updateTextureCoords();
    }
  }, {
    key: "onPrecisionChanged",
    value: function onPrecisionChanged() {
      this._updateDimensions();
    }
  }, {
    key: "onDimensionsChanged",
    value: function onDimensionsChanged(w, h) {
      if (this.texture instanceof TextTexture) {
        this.texture.w = w;
        this.texture.h = h;
        this.w = w;
        this.h = h;
      }
    }
  }, {
    key: "_updateDimensions",
    value: function _updateDimensions() {
      var w = this._getRenderWidth();
      var h = this._getRenderHeight();
      var unknownSize = false;
      if (!w || !h) {
        if (!this.__displayedTexture && this.__texture) {
          w = w || this.__texture.mw;
          h = h || this.__texture.mh;
          if ((!w || !h) && this.__texture.isAutosizeTexture()) {
            unknownSize = true;
          }
        }
      }
      if (this.__core.setDimensions(w, h, unknownSize)) {
        this._onResize();
      }
    }
  }, {
    key: "_updateTextureCoords",
    value: function _updateTextureCoords() {
      if (this.displayedTexture && this.displayedTexture._source) {
        var displayedTexture = this.displayedTexture;
        var displayedTextureSource = this.displayedTexture._source;
        var tx1 = 0,
          ty1 = 0,
          tx2 = 1.0,
          ty2 = 1.0;
        if (displayedTexture.clipping) {
          var w = displayedTextureSource.getRenderWidth();
          var h = displayedTextureSource.getRenderHeight();
          var iw, ih, rw, rh;
          iw = 1 / w;
          ih = 1 / h;
          if (displayedTexture.pw) {
            rw = displayedTexture.pw * iw;
          } else {
            rw = (w - displayedTexture.px) * iw;
          }
          if (displayedTexture.ph) {
            rh = displayedTexture.ph * ih;
          } else {
            rh = (h - displayedTexture.py) * ih;
          }
          iw *= displayedTexture.px;
          ih *= displayedTexture.py;
          tx1 = iw;
          ty1 = ih;
          tx2 = tx2 * rw + iw;
          ty2 = ty2 * rh + ih;
          tx1 = Math.max(0, tx1);
          ty1 = Math.max(0, ty1);
          tx2 = Math.min(1, tx2);
          ty2 = Math.min(1, ty2);
        }
        if (displayedTextureSource._flipTextureY) {
          var tempty = ty2;
          ty2 = ty1;
          ty1 = tempty;
        }
        this.__core.setTextureCoords(tx1, ty1, tx2, ty2);
      }
    }
  }, {
    key: "getCornerPoints",
    value: function getCornerPoints() {
      return this.__core.getCornerPoints();
    }
  }, {
    key: "_unsetTagsParent",
    value: function _unsetTagsParent() {
      var _this2 = this;
      if (this.__tags) {
        this.__tags.forEach(function (tag) {
          var p = _this2;
          while (p = p.__parent) {
            var parentTreeTags = p.__treeTags.get(tag);
            parentTreeTags.delete(_this2);
            if (p.__tagRoot) {
              break;
            }
          }
        });
      }
      var tags = null;
      var n = 0;
      if (this.__treeTags) {
        if (!this.__tagRoot) {
          tags = Utils_Utils.iteratorToArray(this.__treeTags.keys());
          n = tags.length;
          if (n > 0) {
            for (var i = 0; i < n; i++) {
              var tagSet = this.__treeTags.get(tags[i]);
              var p = this;
              var _loop = function _loop() {
                var parentTreeTags = p.__treeTags.get(tags[i]);
                tagSet.forEach(function (comp) {
                  parentTreeTags.delete(comp);
                });
                if (p.__tagRoot) {
                  return "break";
                }
              };
              while (p = p.__parent) {
                var _ret = _loop();
                if (_ret === "break") break;
              }
            }
          }
        }
      }
    }
  }, {
    key: "_setTagsParent",
    value: function _setTagsParent() {
      var _this3 = this;
      if (this.__tags) {
        this.__tags.forEach(function (tag) {
          var p = _this3;
          while (p = p.__parent) {
            if (!p.__treeTags) {
              p.__treeTags = new Map();
            }
            var s = p.__treeTags.get(tag);
            if (!s) {
              s = new Set();
              p.__treeTags.set(tag, s);
            }
            s.add(_this3);
            if (p.__tagRoot) {
              break;
            }
          }
        });
      }
      if (this.__treeTags && this.__treeTags.size) {
        if (!this.__tagRoot) {
          this.__treeTags.forEach(function (tagSet, tag) {
            var p = _this3;
            var _loop2 = function _loop2() {
              if (p.__tagRoot) {}
              if (!p.__treeTags) {
                p.__treeTags = new Map();
              }
              var s = p.__treeTags.get(tag);
              if (!s) {
                s = new Set();
                p.__treeTags.set(tag, s);
              }
              tagSet.forEach(function (comp) {
                s.add(comp);
              });
            };
            while (!p.__tagRoot && (p = p.__parent)) {
              _loop2();
            }
          });
        }
      }
    }
  }, {
    key: "_getByTag",
    value: function _getByTag(tag) {
      if (!this.__treeTags) {
        return [];
      }
      var t = this.__treeTags.get(tag);
      return t ? Utils_Utils.setToArray(t) : [];
    }
  }, {
    key: "getTags",
    value: function getTags() {
      return this.__tags ? this.__tags : [];
    }
  }, {
    key: "setTags",
    value: function setTags(tags) {
      tags = tags.reduce(function (acc, tag) {
        return acc.concat(tag.split(' '));
      }, []);
      if (this.__ref) {
        tags.push(this.__ref);
      }
      var i,
        n = tags.length;
      var removes = [];
      var adds = [];
      for (i = 0; i < n; i++) {
        if (!this.hasTag(tags[i])) {
          adds.push(tags[i]);
        }
      }
      var currentTags = this.tags || [];
      n = currentTags.length;
      for (i = 0; i < n; i++) {
        if (tags.indexOf(currentTags[i]) == -1) {
          removes.push(currentTags[i]);
        }
      }
      for (i = 0; i < removes.length; i++) {
        this.removeTag(removes[i]);
      }
      for (i = 0; i < adds.length; i++) {
        this.addTag(adds[i]);
      }
    }
  }, {
    key: "addTag",
    value: function addTag(tag) {
      if (tag.indexOf(' ') === -1) {
        if (Utils_Utils.isUcChar(tag.charCodeAt(0))) {
          this._throwError("Tag may not start with an upper case character.");
        }
        this._addTag(tag);
      } else {
        var tags = tag.split(' ');
        for (var i = 0, m = tags.length; i < m; i++) {
          var _tag2 = tags[i];
          if (Utils_Utils.isUcChar(_tag2.charCodeAt(0))) {
            this._throwError("Tag may not start with an upper case character.");
          }
          this._addTag(_tag2);
        }
      }
    }
  }, {
    key: "_addTag",
    value: function _addTag(tag) {
      if (!this.__tags) {
        this.__tags = [];
      }
      if (this.__tags.indexOf(tag) === -1) {
        this.__tags.push(tag);
        var p = this.__parent;
        if (p) {
          do {
            if (!p.__treeTags) {
              p.__treeTags = new Map();
            }
            var s = p.__treeTags.get(tag);
            if (!s) {
              s = new Set();
              p.__treeTags.set(tag, s);
            }
            s.add(this);
          } while (!p.__tagRoot && (p = p.__parent));
        }
      }
    }
  }, {
    key: "removeTag",
    value: function removeTag(tag) {
      var i = this.__tags.indexOf(tag);
      if (i !== -1) {
        this.__tags.splice(i, 1);
        var p = this.__parent;
        if (p) {
          do {
            var list = p.__treeTags.get(tag);
            if (list) {
              list.delete(this);
            }
          } while (!p.__tagRoot && (p = p.__parent));
        }
      }
    }
  }, {
    key: "hasTag",
    value: function hasTag(tag) {
      return this.__tags && this.__tags.indexOf(tag) !== -1;
    }
  }, {
    key: "_tag",
    value: function _tag(tag) {
      if (tag.indexOf(".") !== -1) {
        return this.mtag(tag)[0];
      } else {
        if (this.__treeTags) {
          var t = this.__treeTags.get(tag);
          if (t) {
            var item = t.values().next();
            return item ? item.value : undefined;
          }
        }
      }
    }
  }, {
    key: "tag",
    get: function get() {
      return this._tag;
    },
    set: function set(t) {
      this.tags = t;
    }
  }, {
    key: "mtag",
    value: function mtag(tag) {
      var idx = tag.indexOf(".");
      if (idx >= 0) {
        var parts = tag.split('.');
        var res = this._getByTag(parts[0]);
        var level = 1;
        var c = parts.length;
        while (res.length && level < c) {
          var resn = [];
          for (var j = 0, n = res.length; j < n; j++) {
            resn = resn.concat(res[j]._getByTag(parts[level]));
          }
          res = resn;
          level++;
        }
        return res;
      } else {
        return this._getByTag(tag);
      }
    }
  }, {
    key: "stag",
    value: function stag(tag, settings) {
      var t = this.mtag(tag);
      var n = t.length;
      for (var i = 0; i < n; i++) {
        Base.patchObject(t[i], settings);
      }
    }
  }, {
    key: "tagRoot",
    get: function get() {
      return this.__tagRoot;
    },
    set: function set(v) {
      if (this.__tagRoot !== v) {
        if (!v) {
          this._setTagsParent();
        } else {
          this._unsetTagsParent();
        }
        this.__tagRoot = v;
      }
    }
  }, {
    key: "sel",
    value: function sel(path) {
      var results = this.select(path);
      if (results.length) {
        return results[0];
      } else {
        return undefined;
      }
    }
  }, {
    key: "select",
    value: function select(path) {
      if (path.indexOf(",") !== -1) {
        var selectors = path.split(',');
        var res = [];
        for (var i = 0; i < selectors.length; i++) {
          res = res.concat(this._select(selectors[i]));
        }
        return res;
      } else {
        return this._select(path);
      }
    }
  }, {
    key: "_select",
    value: function _select(path) {
      if (path === "") return [this];
      var pointIdx = path.indexOf(".");
      var arrowIdx = path.indexOf(">");
      if (pointIdx === -1 && arrowIdx === -1) {
        return this.mtag(path);
      }
      var isRef;
      if (arrowIdx === 0) {
        isRef = true;
        path = path.substr(1);
      } else if (pointIdx === 0) {
        isRef = false;
        path = path.substr(1);
      } else {
        isRef = false;
      }
      return this._selectChilds(path, isRef);
    }
  }, {
    key: "_selectChilds",
    value: function _selectChilds(path, isRef) {
      var pointIdx = path.indexOf(".");
      var arrowIdx = path.indexOf(">");
      if (pointIdx === -1 && arrowIdx === -1) {
        if (isRef) {
          var ref = this.getByRef(path);
          return ref ? [ref] : [];
        } else {
          return this.mtag(path);
        }
      }
      if (arrowIdx === -1 || pointIdx !== -1 && pointIdx < arrowIdx) {
        var next;
        var str = path.substr(0, pointIdx);
        if (isRef) {
          var _ref = this.getByRef(str);
          next = _ref ? [_ref] : [];
        } else {
          next = this.mtag(str);
        }
        var total = [];
        var subPath = path.substr(pointIdx + 1);
        for (var i = 0, n = next.length; i < n; i++) {
          total = total.concat(next[i]._selectChilds(subPath, false));
        }
        return total;
      } else {
        var _next;
        var _str = path.substr(0, arrowIdx);
        if (isRef) {
          var _ref2 = this.getByRef(_str);
          _next = _ref2 ? [_ref2] : [];
        } else {
          _next = this.mtag(_str);
        }
        var _total = [];
        var _subPath = path.substr(arrowIdx + 1);
        for (var _i = 0, _n = _next.length; _i < _n; _i++) {
          _total = _total.concat(_next[_i]._selectChilds(_subPath, true));
        }
        return _total;
      }
    }
  }, {
    key: "getByRef",
    value: function getByRef(ref) {
      return this.childList.getByRef(ref);
    }
  }, {
    key: "getLocationString",
    value: function getLocationString() {
      var i;
      i = this.__parent ? this.__parent._children.getIndex(this) : "R";
      var localTags = this.getTags();
      var str = this.__parent ? this.__parent.getLocationString() : "";
      if (this.ref) {
        str += ":[" + i + "]" + this.ref;
      } else if (localTags.length) {
        str += ":[" + i + "]" + localTags.join(",");
      } else {
        str += ":[" + i + "]#" + this.id;
      }
      return str;
    }
  }, {
    key: "toString",
    value: function toString() {
      var obj = this.getSettings();
      return Element.getPrettyString(obj, "");
    }
  }, {
    key: "getSettings",
    value: function getSettings() {
      var settings = this.getNonDefaults();
      var children = this._children.get();
      if (children) {
        var n = children.length;
        if (n) {
          var childArray = [];
          var missing = false;
          for (var i = 0; i < n; i++) {
            childArray.push(children[i].getSettings());
            missing = missing || !children[i].ref;
          }
          if (!missing) {
            settings.children = {};
            childArray.forEach(function (child) {
              settings.children[child.ref] = child;
            });
          } else {
            settings.children = childArray;
          }
        }
      }
      settings.id = this.id;
      return settings;
    }
  }, {
    key: "getNonDefaults",
    value: function getNonDefaults() {
      var settings = {};
      if (this.constructor !== Element) {
        settings.type = this.constructor.name;
      }
      if (this.__ref) {
        settings.ref = this.__ref;
      }
      if (this.__tags && this.__tags.length) {
        settings.tags = this.__tags;
      }
      if (this.x !== 0) settings.x = this.x;
      if (this.y !== 0) settings.y = this.y;
      if (this.w !== 0) settings.w = this.w;
      if (this.h !== 0) settings.h = this.h;
      if (this.scaleX === this.scaleY) {
        if (this.scaleX !== 1) settings.scale = this.scaleX;
      } else {
        if (this.scaleX !== 1) settings.scaleX = this.scaleX;
        if (this.scaleY !== 1) settings.scaleY = this.scaleY;
      }
      if (this.pivotX === this.pivotY) {
        if (this.pivotX !== 0.5) settings.pivot = this.pivotX;
      } else {
        if (this.pivotX !== 0.5) settings.pivotX = this.pivotX;
        if (this.pivotY !== 0.5) settings.pivotY = this.pivotY;
      }
      if (this.mountX === this.mountY) {
        if (this.mountX !== 0) settings.mount = this.mountX;
      } else {
        if (this.mountX !== 0) settings.mountX = this.mountX;
        if (this.mountY !== 0) settings.mountY = this.mountY;
      }
      if (this.alpha !== 1) settings.alpha = this.alpha;
      if (!this.visible) settings.visible = false;
      if (this.rotation !== 0) settings.rotation = this.rotation;
      if (this.colorUl === this.colorUr && this.colorBl === this.colorBr && this.colorUl === this.colorBl) {
        if (this.colorUl !== 0xFFFFFFFF) settings.color = this.colorUl.toString(16);
      } else {
        if (this.colorUl !== 0xFFFFFFFF) settings.colorUl = this.colorUl.toString(16);
        if (this.colorUr !== 0xFFFFFFFF) settings.colorUr = this.colorUr.toString(16);
        if (this.colorBl !== 0xFFFFFFFF) settings.colorBl = this.colorBl.toString(16);
        if (this.colorBr !== 0xFFFFFFFF) settings.colorBr = this.colorBr.toString(16);
      }
      if (this.zIndex) settings.zIndex = this.zIndex;
      if (this.forceZIndexContext) settings.forceZIndexContext = true;
      if (this.clipping) settings.clipping = this.clipping;
      if (!this.clipbox) settings.clipbox = this.clipbox;
      if (this.__texture) {
        var tnd = this.__texture.getNonDefaults();
        if (Object.keys(tnd).length) {
          settings.texture = tnd;
        }
      }
      if (this.shader && Utils_Utils.isFunction(this.shader.getNonDefaults)) {
        var _tnd = this.shader.getNonDefaults();
        if (Object.keys(_tnd).length) {
          settings.shader = _tnd;
        }
      }
      if (this._hasTexturizer()) {
        if (this.texturizer.enabled) {
          settings.renderToTexture = this.texturizer.enabled;
        }
        if (this.texturizer.lazy) {
          settings.renderToTextureLazy = this.texturizer.lazy;
        }
        if (this.texturizer.colorize) {
          settings.colorizeResultTexture = this.texturizer.colorize;
        }
        if (this.texturizer.renderOffscreen) {
          settings.renderOffscreen = this.texturizer.renderOffscreen;
        }
      }
      return settings;
    }
  }, {
    key: "withinBoundsMargin",
    get: function get() {
      return this.__core._withinBoundsMargin;
    }
  }, {
    key: "_enableWithinBoundsMargin",
    value: function _enableWithinBoundsMargin() {
      if (this.__enabled) {
        this._setActiveFlag();
      }
    }
  }, {
    key: "_disableWithinBoundsMargin",
    value: function _disableWithinBoundsMargin() {
      if (this.__active) {
        this._unsetActiveFlag();
      }
    }
  }, {
    key: "boundsMargin",
    get: function get() {
      return this.__core.boundsMargin;
    },
    set: function set(v) {
      if (!Array.isArray(v) && v !== null) {
        throw new Error("boundsMargin should be an array of left-top-right-bottom values or null (inherit margin)");
      }
      this.__core.boundsMargin = v;
    }
  }, {
    key: "x",
    get: function get() {
      return this.__core.offsetX;
    },
    set: function set(v) {
      this.__core.offsetX = v;
    }
  }, {
    key: "y",
    get: function get() {
      return this.__core.offsetY;
    },
    set: function set(v) {
      this.__core.offsetY = v;
    }
  }, {
    key: "w",
    get: function get() {
      return this._w;
    },
    set: function set(v) {
      if (Utils_Utils.isFunction(v)) {
        this._w = 0;
        this.__core.funcW = v;
      } else {
        v = Math.max(v, 0);
        if (this._w !== v) {
          this.__core.disableFuncW();
          this._w = v;
          this._updateDimensions();
        }
      }
    }
  }, {
    key: "h",
    get: function get() {
      return this._h;
    },
    set: function set(v) {
      if (Utils_Utils.isFunction(v)) {
        this._h = 0;
        this.__core.funcH = v;
      } else {
        v = Math.max(v, 0);
        if (this._h !== v) {
          this.__core.disableFuncH();
          this._h = v;
          this._updateDimensions();
        }
      }
    }
  }, {
    key: "collision",
    get: function get() {
      return this._collision;
    },
    set: function set(v) {
      this._collision = v;
    }
  }, {
    key: "_updateCollision",
    value: function _updateCollision() {
      if (this.collision && this.__parent && this.__parent.collision === undefined) {
        this.__parent.collision = 2;
      }
    }
  }, {
    key: "scaleX",
    get: function get() {
      return this.__core.scaleX;
    },
    set: function set(v) {
      this.__core.scaleX = v;
    }
  }, {
    key: "scaleY",
    get: function get() {
      return this.__core.scaleY;
    },
    set: function set(v) {
      this.__core.scaleY = v;
    }
  }, {
    key: "scale",
    get: function get() {
      return this.__core.scale;
    },
    set: function set(v) {
      this.__core.scale = v;
    }
  }, {
    key: "pivotX",
    get: function get() {
      return this.__core.pivotX;
    },
    set: function set(v) {
      this.__core.pivotX = v;
    }
  }, {
    key: "pivotY",
    get: function get() {
      return this.__core.pivotY;
    },
    set: function set(v) {
      this.__core.pivotY = v;
    }
  }, {
    key: "pivot",
    get: function get() {
      return this.__core.pivot;
    },
    set: function set(v) {
      this.__core.pivot = v;
    }
  }, {
    key: "mountX",
    get: function get() {
      return this.__core.mountX;
    },
    set: function set(v) {
      this.__core.mountX = v;
    }
  }, {
    key: "mountY",
    get: function get() {
      return this.__core.mountY;
    },
    set: function set(v) {
      this.__core.mountY = v;
    }
  }, {
    key: "mount",
    get: function get() {
      return this.__core.mount;
    },
    set: function set(v) {
      this.__core.mount = v;
    }
  }, {
    key: "rotation",
    get: function get() {
      return this.__core.rotation;
    },
    set: function set(v) {
      this.__core.rotation = v;
    }
  }, {
    key: "alpha",
    get: function get() {
      return this.__core.alpha;
    },
    set: function set(v) {
      this.__core.alpha = v;
    }
  }, {
    key: "visible",
    get: function get() {
      return this.__core.visible;
    },
    set: function set(v) {
      this.__core.visible = v;
    }
  }, {
    key: "colorUl",
    get: function get() {
      return this.__core.colorUl;
    },
    set: function set(v) {
      this.__core.colorUl = v;
    }
  }, {
    key: "colorUr",
    get: function get() {
      return this.__core.colorUr;
    },
    set: function set(v) {
      this.__core.colorUr = v;
    }
  }, {
    key: "colorBl",
    get: function get() {
      return this.__core.colorBl;
    },
    set: function set(v) {
      this.__core.colorBl = v;
    }
  }, {
    key: "colorBr",
    get: function get() {
      return this.__core.colorBr;
    },
    set: function set(v) {
      this.__core.colorBr = v;
    }
  }, {
    key: "color",
    get: function get() {
      return this.__core.colorUl;
    },
    set: function set(v) {
      if (this.colorUl !== v || this.colorUr !== v || this.colorBl !== v || this.colorBr !== v) {
        this.colorUl = v;
        this.colorUr = v;
        this.colorBl = v;
        this.colorBr = v;
      }
    }
  }, {
    key: "colorTop",
    get: function get() {
      return this.colorUl;
    },
    set: function set(v) {
      if (this.colorUl !== v || this.colorUr !== v) {
        this.colorUl = v;
        this.colorUr = v;
      }
    }
  }, {
    key: "colorBottom",
    get: function get() {
      return this.colorBl;
    },
    set: function set(v) {
      if (this.colorBl !== v || this.colorBr !== v) {
        this.colorBl = v;
        this.colorBr = v;
      }
    }
  }, {
    key: "colorLeft",
    get: function get() {
      return this.colorUl;
    },
    set: function set(v) {
      if (this.colorUl !== v || this.colorBl !== v) {
        this.colorUl = v;
        this.colorBl = v;
      }
    }
  }, {
    key: "colorRight",
    get: function get() {
      return this.colorUr;
    },
    set: function set(v) {
      if (this.colorUr !== v || this.colorBr !== v) {
        this.colorUr = v;
        this.colorBr = v;
      }
    }
  }, {
    key: "zIndex",
    get: function get() {
      return this.__core.zIndex;
    },
    set: function set(v) {
      this.__core.zIndex = v;
    }
  }, {
    key: "forceZIndexContext",
    get: function get() {
      return this.__core.forceZIndexContext;
    },
    set: function set(v) {
      this.__core.forceZIndexContext = v;
    }
  }, {
    key: "clipping",
    get: function get() {
      return this.__core.clipping;
    },
    set: function set(v) {
      this.__core.clipping = v;
    }
  }, {
    key: "clipbox",
    get: function get() {
      return this.__core.clipbox;
    },
    set: function set(v) {
      this.__core.clipbox = v;
    }
  }, {
    key: "tags",
    get: function get() {
      return this.getTags();
    },
    set: function set(v) {
      if (!Array.isArray(v)) v = [v];
      this.setTags(v);
    }
  }, {
    key: "t",
    set: function set(v) {
      this.tags = v;
    }
  }, {
    key: "_children",
    get: function get() {
      if (!this.__childList) {
        this.__childList = new ElementChildList(this, false);
      }
      return this.__childList;
    }
  }, {
    key: "childList",
    get: function get() {
      if (!this._allowChildrenAccess()) {
        this._throwError("Direct access to children is not allowed in " + this.getLocationString());
      }
      return this._children;
    }
  }, {
    key: "hasChildren",
    value: function hasChildren() {
      return this._allowChildrenAccess() && this.__childList && this.__childList.length > 0;
    }
  }, {
    key: "_allowChildrenAccess",
    value: function _allowChildrenAccess() {
      return true;
    }
  }, {
    key: "children",
    get: function get() {
      return this.childList.get();
    },
    set: function set(children) {
      this.childList.patch(children);
    }
  }, {
    key: "add",
    value: function add(o) {
      return this.childList.a(o);
    }
  }, {
    key: "p",
    get: function get() {
      return this.__parent;
    }
  }, {
    key: "parent",
    get: function get() {
      return this.__parent;
    }
  }, {
    key: "src",
    get: function get() {
      if (this.texture && this.texture instanceof ImageTexture) {
        return this.texture._src;
      } else {
        return undefined;
      }
    },
    set: function set(v) {
      var texture = new ImageTexture(this.stage);
      texture.src = v;
      this.texture = texture;
    }
  }, {
    key: "mw",
    set: function set(v) {
      if (this.texture) {
        this.texture.mw = v;
        this._updateDimensions();
      } else {
        this._throwError('Please set mw after setting a texture.');
      }
    }
  }, {
    key: "mh",
    set: function set(v) {
      if (this.texture) {
        this.texture.mh = v;
        this._updateDimensions();
      } else {
        this._throwError('Please set mh after setting a texture.');
      }
    }
  }, {
    key: "rect",
    get: function get() {
      return this.texture === this.stage.rectangleTexture;
    },
    set: function set(v) {
      if (v) {
        this.texture = this.stage.rectangleTexture;
      } else {
        this.texture = null;
      }
    }
  }, {
    key: "enableTextTexture",
    value: function enableTextTexture() {
      if (!this.texture || !(this.texture instanceof TextTexture)) {
        this.texture = new TextTexture(this.stage);
        if (!this.texture.w && !this.texture.h) {
          this.texture.w = this.w;
          this.texture.h = this.h;
        }
      }
      return this.texture;
    }
  }, {
    key: "text",
    get: function get() {
      if (this.texture && this.texture instanceof TextTexture) {
        return this.texture;
      } else {
        return null;
      }
    },
    set: function set(v) {
      if (!this.texture || !(this.texture instanceof TextTexture)) {
        this.enableTextTexture();
      }
      if (Utils_Utils.isString(v)) {
        this.texture.text = v;
      } else {
        this.texture.patch(v);
      }
    }
  }, {
    key: "onUpdate",
    set: function set(f) {
      this.__core.onUpdate = f;
    }
  }, {
    key: "onAfterCalcs",
    set: function set(f) {
      this.__core.onAfterCalcs = f;
    }
  }, {
    key: "onAfterUpdate",
    set: function set(f) {
      this.__core.onAfterUpdate = f;
    }
  }, {
    key: "forceUpdate",
    value: function forceUpdate() {
      this.__core._setHasUpdates();
    }
  }, {
    key: "shader",
    get: function get() {
      return this.__core.shader;
    },
    set: function set(v) {
      if (Utils_Utils.isObjectLiteral(v) && !v.type) {
        if (this.shader) {
          this.shader.patch(v);
        }
      } else {
        var shader = Shader.create(this.stage, v);
        if (this.__enabled && this.__core.shader) {
          this.__core.shader.removeElement(this.__core);
        }
        this.__core.shader = shader;
        if (this.__enabled && this.__core.shader) {
          this.__core.shader.addElement(this.__core);
        }
      }
    }
  }, {
    key: "_hasTexturizer",
    value: function _hasTexturizer() {
      return !!this.__core._texturizer;
    }
  }, {
    key: "renderToTexture",
    get: function get() {
      return this.rtt;
    },
    set: function set(v) {
      this.rtt = v;
    }
  }, {
    key: "rtt",
    get: function get() {
      return this._hasTexturizer() && this.texturizer.enabled;
    },
    set: function set(v) {
      this.texturizer.enabled = v;
    }
  }, {
    key: "rttLazy",
    get: function get() {
      return this._hasTexturizer() && this.texturizer.lazy;
    },
    set: function set(v) {
      this.texturizer.lazy = v;
    }
  }, {
    key: "renderOffscreen",
    get: function get() {
      return this._hasTexturizer() && this.texturizer.renderOffscreen;
    },
    set: function set(v) {
      this.texturizer.renderOffscreen = v;
    }
  }, {
    key: "colorizeResultTexture",
    get: function get() {
      return this._hasTexturizer() && this.texturizer.colorize;
    },
    set: function set(v) {
      this.texturizer.colorize = v;
    }
  }, {
    key: "getTexture",
    value: function getTexture() {
      return this.texturizer._getTextureSource();
    }
  }, {
    key: "texturizer",
    get: function get() {
      return this.__core.texturizer;
    }
  }, {
    key: "patch",
    value: function patch(settings) {
      var paths = Object.keys(settings);
      for (var i = 0, n = paths.length; i < n; i++) {
        var path = paths[i];
        var v = settings[path];
        var firstCharCode = path.charCodeAt(0);
        if (Utils_Utils.isUcChar(firstCharCode)) {
          var child = this.getByRef(path);
          if (!child) {
            if (v !== undefined) {
              var c = void 0;
              if (Utils_Utils.isObjectLiteral(v)) {
                c = this.childList.createItem(v);
                c.patch(v);
              } else if (Utils_Utils.isObject(v)) {
                c = v;
              }
              if (c.isElement) {
                c.ref = path;
              }
              this.childList.a(c);
            }
          } else {
            if (v === undefined) {
              if (child.parent) {
                child.parent.childList.remove(child);
              }
            } else if (Utils_Utils.isObjectLiteral(v)) {
              child.patch(v);
            } else if (v.isElement) {
              v.ref = path;
              this.childList.replace(v, child);
            } else {
              this._throwError("Unexpected value for path: " + path);
            }
          }
        } else {
          Base.patchObjectProperty(this, path, v);
        }
      }
    }
  }, {
    key: "_throwError",
    value: function _throwError(message) {
      throw new Error(this.constructor.name + " (" + this.getLocationString() + "): " + message);
    }
  }, {
    key: "animation",
    value: function animation(settings) {
      return this.stage.animations.createAnimation(this, settings);
    }
  }, {
    key: "transition",
    value: function transition(property) {
      var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (settings === null) {
        return this._getTransition(property);
      } else {
        this._setTransition(property, settings);
        return null;
      }
    }
  }, {
    key: "transitions",
    set: function set(object) {
      var _this4 = this;
      var keys = Object.keys(object);
      keys.forEach(function (property) {
        _this4.transition(property, object[property]);
      });
    }
  }, {
    key: "smooth",
    set: function set(object) {
      var _this5 = this;
      var keys = Object.keys(object);
      keys.forEach(function (property) {
        var value = object[property];
        if (Array.isArray(value)) {
          _this5.setSmooth(property, value[0], value[1]);
        } else {
          _this5.setSmooth(property, value);
        }
      });
    }
  }, {
    key: "fastForward",
    value: function fastForward(property) {
      if (this._transitions) {
        var t = this._transitions[property];
        if (t && t.isTransition) {
          t.finish();
        }
      }
    }
  }, {
    key: "_getTransition",
    value: function _getTransition(property) {
      if (!this._transitions) {
        this._transitions = {};
      }
      var t = this._transitions[property];
      if (!t) {
        t = new Transition(this.stage.transitions, this.stage.transitions.defaultTransitionSettings, this, property);
      } else if (t.isTransitionSettings) {
        t = new Transition(this.stage.transitions, t, this, property);
      }
      this._transitions[property] = t;
      return t;
    }
  }, {
    key: "_setTransition",
    value: function _setTransition(property, settings) {
      if (!settings) {
        this._removeTransition(property);
      } else {
        if (Utils_Utils.isObjectLiteral(settings)) {
          settings = this.stage.transitions.createSettings(settings);
        }
        if (!this._transitions) {
          this._transitions = {};
        }
        var current = this._transitions[property];
        if (current && current.isTransition) {
          current.settings = settings;
          return current;
        } else {
          this._transitions[property] = settings;
        }
      }
    }
  }, {
    key: "_removeTransition",
    value: function _removeTransition(property) {
      if (this._transitions) {
        delete this._transitions[property];
      }
    }
  }, {
    key: "getSmooth",
    value: function getSmooth(property, v) {
      var t = this._getTransition(property);
      if (t && t.isAttached()) {
        return t.targetValue;
      } else {
        return v;
      }
    }
  }, {
    key: "setSmooth",
    value: function setSmooth(property, v, settings) {
      if (settings) {
        this._setTransition(property, settings);
      }
      var t = this._getTransition(property);
      t.start(v);
      return t;
    }
  }, {
    key: "flex",
    get: function get() {
      return this.__core.flex;
    },
    set: function set(v) {
      this.__core.flex = v;
    }
  }, {
    key: "flexItem",
    get: function get() {
      return this.__core.flexItem;
    },
    set: function set(v) {
      this.__core.flexItem = v;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var ref = ["".concat(this.constructor.name)];
      var tree = {};
      tree[ref] = {};
      if (this.hasChildren()) {
        Element.collectChildren(tree[ref], this.__childList);
      } else {
        tree[ref] = Element_objectSpread({}, Element.getProperties(this));
      }
      return tree;
    }
  }], [{
    key: "getPrettyString",
    value: function getPrettyString(obj, indent) {
      var children = obj.children;
      delete obj.children;
      var colorKeys = ["color", "colorUl", "colorUr", "colorBl", "colorBr"];
      var str = JSON.stringify(obj, function (k, v) {
        if (colorKeys.indexOf(k) !== -1) {
          return "COLOR[" + v.toString(16) + "]";
        }
        return v;
      });
      str = str.replace(/"COLOR\[([a-f0-9]{1,8})\]"/g, "0x$1");
      if (children) {
        var childStr = "";
        if (Utils_Utils.isObjectLiteral(children)) {
          var refs = Object.keys(children);
          childStr = "";
          for (var i = 0, n = refs.length; i < n; i++) {
            childStr += "\n".concat(indent, "  \"").concat(refs[i], "\":");
            delete children[refs[i]].ref;
            childStr += Element.getPrettyString(children[refs[i]], indent + "  ") + (i < n - 1 ? "," : "");
          }
          var isEmpty = str === "{}";
          str = str.substr(0, str.length - 1) + (isEmpty ? "" : ",") + childStr + "\n" + indent + "}";
        } else {
          var _n2 = children.length;
          childStr = "[";
          for (var _i2 = 0; _i2 < _n2; _i2++) {
            childStr += Element.getPrettyString(children[_i2], indent + "  ") + (_i2 < _n2 - 1 ? "," : "") + "\n";
          }
          childStr += indent + "]}";
          var _isEmpty = str === "{}";
          str = str.substr(0, str.length - 1) + (_isEmpty ? "" : ",") + "\"children\":\n" + indent + childStr + "}";
        }
      }
      return str;
    }
  }, {
    key: "getGetter",
    value: function getGetter(propertyPath) {
      var getter = Element.PROP_GETTERS.get(propertyPath);
      if (!getter) {
        getter = new Function('obj', 'return obj.' + propertyPath);
        Element.PROP_GETTERS.set(propertyPath, getter);
      }
      return getter;
    }
  }, {
    key: "getSetter",
    value: function getSetter(propertyPath) {
      var setter = Element.PROP_SETTERS.get(propertyPath);
      if (!setter) {
        setter = new Function('obj', 'v', 'obj.' + propertyPath + ' = v');
        Element.PROP_SETTERS.set(propertyPath, setter);
      }
      return setter;
    }
  }, {
    key: "isColorProperty",
    value: function isColorProperty(property) {
      return property.toLowerCase().indexOf("color") >= 0;
    }
  }, {
    key: "getMerger",
    value: function getMerger(property) {
      if (Element.isColorProperty(property)) {
        return StageUtils.mergeColors;
      } else {
        return StageUtils.mergeNumbers;
      }
    }
  }, {
    key: "collectChildren",
    value: function collectChildren(tree, children) {
      var childList = children;
      for (var i = 0, j = childList.length; i < j; i++) {
        var element = childList.getAt(i);
        var ref = "".concat(element.__ref || "Element-".concat(element.id));
        var properties = this.getProperties(element);
        tree[ref] = Element_objectSpread({}, properties);
        if (element.hasChildren()) {
          tree[ref].children = {};
          this.collectChildren(tree[ref].children, element.__childList);
        }
      }
    }
  }, {
    key: "getProperties",
    value: function getProperties(element) {
      var props = {};
      var list = ["alpha", "active", "attached", "boundsMargin", "color", "clipping", "enabled", "h", "id", "isComponent", "mount", "mountY", "mountX", "pivot", "pivotX", "pivotY", "ref", "renderOfScreen", "renderToTexture", "scale", "scaleX", "scaleY", "state", "tag", "visible", "w", "x", "y", "zIndex", "!!flex", "!!flexItem", "hasFocus()", "hasFinalFocus()"];
      var n = list.length;
      while (n--) {
        var key = list[n];
        var getBoolean = /^!{2}/;
        var isFunction = /\(\)$/;
        if (getBoolean.test(key)) {
          key = key.substring(2, key.length);
          props[key] = !!element[key];
        } else if (isFunction.test(key)) {
          key = key.substring(0, key.length - 2);
          if (typeof element[key] === "function") {
            props[key] = element[key]();
          }
        } else {
          props[key] = element[key];
        }
      }
      return Element_objectSpread(Element_objectSpread({}, props), element.getNonDefaults());
    }
  }]);
  return Element;
}();

EventEmitter.addAsMixin(Element);
Element.prototype.isElement = 1;
Element.id = 1;
Element.PROP_GETTERS = new Map();
Element.PROP_SETTERS = new Map();






// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__(45190);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__(22319);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/application/StateMachine.mjs






















function StateMachine_createSuper(t) { var r = StateMachine_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function StateMachine_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (StateMachine_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var StateMachine = function () {
  function StateMachine() {
    (0,classCallCheck/* default */.Z)(this, StateMachine);
    StateMachine.setupStateMachine(this);
  }
  (0,createClass/* default */.Z)(StateMachine, [{
    key: "fire",
    value: function fire(event) {
      if (this._hasMethod(event)) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        return this[event].apply(this, args);
      }
    }
  }, {
    key: "_getState",
    value: function _getState() {
      return this._state.__path;
    }
  }, {
    key: "_inState",
    value: function _inState(statePath) {
      var currentStatePath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._state.__path;
      var state = this._sm.getStateByPath(statePath);
      var currentState = this._sm.getStateByPath(currentStatePath);
      var level = state.__level;
      var stateAtLevel = StateMachine._getStateAtLevel(currentState, level);
      return stateAtLevel === state;
    }
  }, {
    key: "_hasMember",
    value: function _hasMember(name) {
      return !!this.constructor.prototype[name];
    }
  }, {
    key: "_hasMethod",
    value: function _hasMethod(name) {
      var member = this.constructor.prototype[name];
      return !!member && typeof member === "function";
    }
  }, {
    key: "_setState",
    value: function _setState(statePath, args) {
      var setStateId = ++this._setStateCounter;
      this._setStateId = setStateId;
      if (this._state.__path !== statePath) {
        var newState = this._sm._stateMap[statePath];
        if (!newState) {
          newState = this._sm.getStateByPath(statePath);
        }
        var prevState = this._state;
        var hasDifferentEnterMethod = newState.prototype.$enter !== this._state.prototype.$enter;
        var hasDifferentExitMethod = newState.prototype.$exit !== this._state.prototype.$exit;
        if (hasDifferentEnterMethod || hasDifferentExitMethod) {
          var sharedState = StateMachine._getSharedState(this._state, newState);
          var context = {
            newState: newState.__path,
            prevState: prevState.__path,
            sharedState: sharedState.__path
          };
          var sharedLevel = sharedState.__level;
          if (hasDifferentExitMethod) {
            var exitStates = StateMachine._getStatesUntilLevel(this._state, sharedLevel);
            for (var i = 0, n = exitStates.length; i < n; i++) {
              this.__setState(exitStates[i]);
              this._callExit(this._state, args, context);
              var stateChangeOverridden = this._setStateId !== setStateId;
              if (stateChangeOverridden) {
                return;
              }
            }
          }
          if (hasDifferentEnterMethod) {
            var enterStates = StateMachine._getStatesUntilLevel(newState, sharedLevel).reverse();
            for (var _i = 0, _n = enterStates.length; _i < _n; _i++) {
              this.__setState(enterStates[_i]);
              this._callEnter(this._state, args, context);
              var _stateChangeOverridden = this._setStateId !== setStateId;
              if (_stateChangeOverridden) {
                return;
              }
            }
          }
        }
        this.__setState(newState);
        if (this._changedState) {
          var _context = {
            newState: newState.__path,
            prevState: prevState.__path
          };
          if (args) {
            this._changedState.apply(this, [_context].concat((0,toConsumableArray/* default */.Z)(args)));
          } else {
            this._changedState(_context);
          }
        }
        if (this._onStateChange) {
          var _context2 = {
            newState: newState.__path,
            prevState: prevState.__path
          };
          this._onStateChange(_context2);
        }
      }
    }
  }, {
    key: "_callEnter",
    value: function _callEnter(state) {
      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var context = arguments.length > 2 ? arguments[2] : undefined;
      var hasParent = !!state.__parent;
      if (state.prototype.$enter) {
        if (!hasParent || state.__parent.prototype.$enter !== state.prototype.$enter) {
          state.prototype.$enter.apply(this, [context].concat((0,toConsumableArray/* default */.Z)(args)));
        }
      }
    }
  }, {
    key: "_callExit",
    value: function _callExit(state) {
      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var context = arguments.length > 2 ? arguments[2] : undefined;
      var hasParent = !!state.__parent;
      if (state.prototype.$exit) {
        if (!hasParent || state.__parent.prototype.$exit !== state.prototype.$exit) {
          state.prototype.$exit.apply(this, [context].concat((0,toConsumableArray/* default */.Z)(args)));
        }
      }
    }
  }, {
    key: "__setState",
    value: function __setState(state) {
      this._state = state;
      this._stateIndex = state.__index;
      this.constructor = state;
    }
  }, {
    key: "_initStateMachine",
    value: function _initStateMachine() {
      this._state = null;
      this._stateIndex = 0;
      this._setStateCounter = 0;
      this._sm = this._routedType._sm;
      this.__setState(this._sm.getStateByPath(""));
      var context = {
        newState: "",
        prevState: undefined,
        sharedState: undefined
      };
      this._callEnter(this._state, [], context);
      this._onStateChange = undefined;
    }
  }, {
    key: "_getMostSpecificHandledMember",
    value: function _getMostSpecificHandledMember(memberNames) {
      var cur = this._state;
      do {
        for (var i = 0, n = memberNames.length; i < n; i++) {
          var memberName = memberNames[i];
          if (!cur.__parent) {
            if (cur.prototype[memberName]) {
              return memberName;
            }
          } else {
            var alias = StateMachineType.getStateMemberAlias(cur.__path, memberName);
            if (this[alias]) {
              return memberName;
            }
          }
        }
        cur = cur.__parent;
      } while (cur);
    }
  }], [{
    key: "setupStateMachine",
    value: function setupStateMachine(target) {
      var targetConstructor = target.constructor;
      var router = StateMachine.create(targetConstructor);
      Object.setPrototypeOf(target, router.prototype);
      target.constructor = targetConstructor;
      target._initStateMachine();
    }
  }, {
    key: "create",
    value: function create(type) {
      if (!type.hasOwnProperty('_sm')) {
        var stateMachineType = new StateMachineType(type);
        type._sm = stateMachineType;
      }
      return type._sm.router;
    }
  }, {
    key: "_getStatesUntilLevel",
    value: function _getStatesUntilLevel(state, level) {
      var states = [];
      while (state.__level > level) {
        states.push(state);
        state = state.__parent;
      }
      return states;
    }
  }, {
    key: "_getSharedState",
    value: function _getSharedState(state1, state2) {
      var state1Array = StateMachine._getAncestorStates(state1);
      var state2Array = StateMachine._getAncestorStates(state2);
      var n = Math.min(state1Array.length, state2Array.length);
      for (var i = 0; i < n; i++) {
        if (state1Array[i] !== state2Array[i]) {
          return state1Array[i - 1];
        }
      }
      return state1Array[n - 1];
    }
  }, {
    key: "_getAncestorStates",
    value: function _getAncestorStates(state) {
      var result = [];
      do {
        result.push(state);
      } while (state = state.__parent);
      return result.reverse();
    }
  }, {
    key: "_getStateAtLevel",
    value: function _getStateAtLevel(state, level) {
      if (level > state.__level) {
        return undefined;
      }
      while (level < state.__level) {
        state = state.__parent;
      }
      return state;
    }
  }]);
  return StateMachine;
}();

var StateMachineType = function () {
  function StateMachineType(type) {
    (0,classCallCheck/* default */.Z)(this, StateMachineType);
    this._type = type;
    this._router = null;
    this.init();
  }
  (0,createClass/* default */.Z)(StateMachineType, [{
    key: "router",
    get: function get() {
      return this._router;
    }
  }, {
    key: "init",
    value: function init() {
      this._router = this._createRouter();
      this._stateMap = this._getStateMap();
      this._addStateMemberDelegatorsToRouter();
    }
  }, {
    key: "_createRouter",
    value: function _createRouter() {
      var type = this._type;
      var router = function (_type) {
        (0,inherits/* default */.Z)(StateMachineRouter, _type);
        var _super = StateMachine_createSuper(StateMachineRouter);
        function StateMachineRouter() {
          var _this;
          (0,classCallCheck/* default */.Z)(this, StateMachineRouter);
          _this = _super.apply(this, arguments);
          if (!_this.constructor.hasOwnProperty('_isRouter')) {
            throw new Error("You need to extend ".concat(type.name, ".original instead of ").concat(type.name, "."));
          }
          return _this;
        }
        return (0,createClass/* default */.Z)(StateMachineRouter);
      }(type);
      router._isRouter = true;
      router.prototype._routedType = type;
      router.original = type;
      this._mixinStateMachineMethods(router);
      return router;
    }
  }, {
    key: "_mixinStateMachineMethods",
    value: function _mixinStateMachineMethods(router) {
      var names = Object.getOwnPropertyNames(StateMachine.prototype);
      for (var i = 0, n = names.length; i < n; i++) {
        var name = names[i];
        if (name !== "constructor") {
          var descriptor = Object.getOwnPropertyDescriptor(StateMachine.prototype, name);
          Object.defineProperty(router.prototype, name, descriptor);
        }
      }
    }
  }, {
    key: "_addStateMemberDelegatorsToRouter",
    value: function _addStateMemberDelegatorsToRouter() {
      var _this2 = this;
      var members = this._getAllMemberNames();
      members.forEach(function (member) {
        _this2._addMemberRouter(member);
      });
    }
  }, {
    key: "_addMemberRouter",
    value: function _addMemberRouter(member) {
      var _this3 = this;
      var statePaths = Object.keys(this._stateMap);
      var descriptors = [];
      var aliases = [];
      statePaths.forEach(function (statePath, index) {
        var state = _this3._stateMap[statePath];
        var descriptor = _this3._getDescriptor(state, member);
        if (descriptor) {
          descriptors[index] = descriptor;
          var alias = StateMachineType.getStateMemberAlias(descriptor._source.__path, member);
          aliases[index] = alias;
          if (!_this3._router.prototype.hasOwnProperty(alias)) {
            Object.defineProperty(_this3._router.prototype, alias, descriptor);
          }
        } else {
          descriptors[index] = null;
          aliases[index] = null;
        }
      });
      var type = undefined;
      descriptors.forEach(function (descriptor) {
        if (descriptor) {
          var descType = _this3._getDescriptorType(descriptor);
          if (type && type !== descType) {
            console.warn("[Lightning] Member ".concat(member, " in ").concat(_this3._type.name, " has inconsistent types."));
            return;
          }
          type = descType;
        }
      });
      switch (type) {
        case "method":
          this._addMethodRouter(member, descriptors, aliases);
          break;
        case "getter":
          this._addGetterSetterRouters(member);
          break;
        case "property":
          console.warn("[Lightning] Fixed properties are not supported; please use a getter instead!");
          break;
      }
    }
  }, {
    key: "_getDescriptor",
    value: function _getDescriptor(state, member) {
      var isValid = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
        return true;
      };
      var type = state;
      var curState = state;
      do {
        var descriptor = Object.getOwnPropertyDescriptor(type.prototype, member);
        if (descriptor) {
          if (isValid(descriptor)) {
            descriptor._source = curState;
            return descriptor;
          }
        }
        type = Object.getPrototypeOf(type);
        if (type && type.hasOwnProperty('__state')) {
          curState = type;
        }
      } while (type && type.prototype);
      return undefined;
    }
  }, {
    key: "_getDescriptorType",
    value: function _getDescriptorType(descriptor) {
      if (descriptor.get || descriptor.set) {
        return 'getter';
      } else {
        if (typeof descriptor.value === "function") {
          return 'method';
        } else {
          return 'property';
        }
      }
    }
  }, {
    key: "_addMethodRouter",
    value: function _addMethodRouter(member, descriptors, aliases) {
      var code = ["//@ sourceURL=StateMachineRouter.js", "var i = this._stateIndex;"];
      var cur = aliases[0];
      var supportsSpread = StateMachineType._supportsSpread();
      for (var i = 1, n = aliases.length; i < n; i++) {
        var alias = aliases[i];
        if (alias !== cur) {
          if (cur) {
            if (supportsSpread) {
              code.push("if (i < ".concat(i, ") return this[\"").concat(cur, "\"](...arguments); else"));
            } else {
              code.push("if (i < ".concat(i, ") return this[\"").concat(cur, "\"].apply(this, arguments); else"));
            }
          } else {
            code.push("if (i < ".concat(i, ") return ; else"));
          }
        }
        cur = alias;
      }
      if (cur) {
        if (supportsSpread) {
          code.push("return this[\"".concat(cur, "\"](...arguments);"));
        } else {
          code.push("return this[\"".concat(cur, "\"].apply(this, arguments);"));
        }
      } else {
        code.push(";");
      }
      var functionBody = code.join("\n");
      var router = new Function([], functionBody);
      var descriptor = {
        value: router
      };
      Object.defineProperty(this._router.prototype, member, descriptor);
    }
  }, {
    key: "_addGetterSetterRouters",
    value: function _addGetterSetterRouters(member) {
      var getter = this._getGetterRouter(member);
      var setter = this._getSetterRouter(member);
      var descriptor = {
        get: getter,
        set: setter
      };
      Object.defineProperty(this._router.prototype, member, descriptor);
    }
  }, {
    key: "_getGetterRouter",
    value: function _getGetterRouter(member) {
      var _this4 = this;
      var statePaths = Object.keys(this._stateMap);
      var descriptors = [];
      var aliases = [];
      statePaths.forEach(function (statePath, index) {
        var state = _this4._stateMap[statePath];
        var descriptor = _this4._getDescriptor(state, member, function (descriptor) {
          return descriptor.get;
        });
        if (descriptor) {
          descriptors[index] = descriptor;
          var alias = StateMachineType.getStateMemberAlias(descriptor._source.__path, member);
          aliases[index] = alias;
          if (!_this4._router.prototype.hasOwnProperty(alias)) {
            Object.defineProperty(_this4._router.prototype, alias, descriptor);
          }
        } else {
          descriptors[index] = null;
          aliases[index] = null;
        }
      });
      var code = ["//@ sourceURL=StateMachineRouter.js", "var i = this._stateIndex;"];
      var cur = aliases[0];
      for (var i = 1, n = aliases.length; i < n; i++) {
        var alias = aliases[i];
        if (alias !== cur) {
          if (cur) {
            code.push("if (i < ".concat(i, ") return this[\"").concat(cur, "\"]; else"));
          } else {
            code.push("if (i < ".concat(i, ") return ; else"));
          }
        }
        cur = alias;
      }
      if (cur) {
        code.push("return this[\"".concat(cur, "\"];"));
      } else {
        code.push(";");
      }
      var functionBody = code.join("\n");
      var router = new Function([], functionBody);
      return router;
    }
  }, {
    key: "_getSetterRouter",
    value: function _getSetterRouter(member) {
      var _this5 = this;
      var statePaths = Object.keys(this._stateMap);
      var descriptors = [];
      var aliases = [];
      statePaths.forEach(function (statePath, index) {
        var state = _this5._stateMap[statePath];
        var descriptor = _this5._getDescriptor(state, member, function (descriptor) {
          return descriptor.set;
        });
        if (descriptor) {
          descriptors[index] = descriptor;
          var alias = StateMachineType.getStateMemberAlias(descriptor._source.__path, member);
          aliases[index] = alias;
          if (!_this5._router.prototype.hasOwnProperty(alias)) {
            Object.defineProperty(_this5._router.prototype, alias, descriptor);
          }
        } else {
          descriptors[index] = null;
          aliases[index] = null;
        }
      });
      var code = ["//@ sourceURL=StateMachineRouter.js", "var i = this._stateIndex;"];
      var cur = aliases[0];
      for (var i = 1, n = aliases.length; i < n; i++) {
        var alias = aliases[i];
        if (alias !== cur) {
          if (cur) {
            code.push("if (i < ".concat(i, ") this[\"").concat(cur, "\"] = arg; else"));
          } else {
            code.push("if (i < ".concat(i, ") ; else"));
          }
        }
        cur = alias;
      }
      if (cur) {
        code.push("this[\"".concat(cur, "\"] = arg;"));
      } else {
        code.push(";");
      }
      var functionBody = code.join("\n");
      var router = new Function(["arg"], functionBody);
      return router;
    }
  }, {
    key: "_getAllMemberNames",
    value: function _getAllMemberNames() {
      var _this6 = this;
      var stateMap = this._stateMap;
      var map = Object.keys(stateMap);
      var members = new Set();
      map.forEach(function (statePath) {
        if (statePath === "") {
          return;
        }
        var state = stateMap[statePath];
        var names = _this6._getStateMemberNames(state);
        names.forEach(function (name) {
          members.add(name);
        });
      });
      return (0,toConsumableArray/* default */.Z)(members);
    }
  }, {
    key: "_getStateMemberNames",
    value: function _getStateMemberNames(state) {
      var type = state;
      var members = new Set();
      var isRoot = this._type === state;
      do {
        var names = this._getStateMemberNamesForType(type);
        names.forEach(function (name) {
          members.add(name);
        });
        type = Object.getPrototypeOf(type);
      } while (type && type.prototype && (!type.hasOwnProperty("__state") || isRoot));
      return members;
    }
  }, {
    key: "_getStateMemberNamesForType",
    value: function _getStateMemberNamesForType(type) {
      var memberNames = Object.getOwnPropertyNames(type.prototype);
      return memberNames.filter(function (memberName) {
        return memberName !== "constructor" && !StateMachineType._isStateLocalMember(memberName);
      });
    }
  }, {
    key: "getStateByPath",
    value: function getStateByPath(statePath) {
      if (this._stateMap[statePath]) {
        return this._stateMap[statePath];
      }
      var parts = statePath.split(".");
      while (parts.pop()) {
        var _statePath = parts.join(".");
        if (this._stateMap[_statePath]) {
          return this._stateMap[_statePath];
        }
      }
    }
  }, {
    key: "_getStateMap",
    value: function _getStateMap() {
      if (!this._stateMap) {
        this._stateMap = this._createStateMap();
      }
      return this._stateMap;
    }
  }, {
    key: "_createStateMap",
    value: function _createStateMap() {
      var stateMap = {};
      this._addState(this._type, null, "", stateMap);
      return stateMap;
    }
  }, {
    key: "_addState",
    value: function _addState(state, parentState, name, stateMap) {
      var _this7 = this;
      state.__state = true;
      state.__name = name;
      this._addStaticStateProperty(state, parentState);
      var parentPath = parentState ? parentState.__path : "";
      var path = (parentPath ? parentPath + "." : "") + name;
      state.__path = path;
      state.__level = parentState ? parentState.__level + 1 : 0;
      state.__parent = parentState;
      state.__index = Object.keys(stateMap).length;
      stateMap[path] = state;
      var states = state._states;
      if (states) {
        var isInheritedFromParent = parentState && parentState._states === states;
        if (!isInheritedFromParent) {
          var subStates = state._states();
          subStates.forEach(function (subState) {
            var stateName = StateMachineType._getStateName(subState);
            _this7._addState(subState, state, stateName, stateMap);
          });
        }
      }
    }
  }, {
    key: "_addStaticStateProperty",
    value: function _addStaticStateProperty(state, parentState) {
      if (parentState) {
        var isClassStateLevel = parentState && !parentState.__parent;
        if (isClassStateLevel) {
          this._router[state.__name] = state;
        } else {
          parentState[state.__name] = state;
        }
      }
    }
  }], [{
    key: "_supportsSpread",
    value: function _supportsSpread() {
      if (this.__supportsSpread === undefined) {
        this.__supportsSpread = false;
        try {
          var func = new Function("return [].concat(...arguments);");
          func();
          this.__supportsSpread = true;
        } catch (e) {}
      }
      return this.__supportsSpread;
    }
  }, {
    key: "getStateMemberAlias",
    value: function getStateMemberAlias(path, member) {
      return "$" + (path ? path + "." : "") + member;
    }
  }, {
    key: "_isStateLocalMember",
    value: function _isStateLocalMember(memberName) {
      return memberName === "$enter" || memberName === "$exit";
    }
  }, {
    key: "_getStateName",
    value: function _getStateName(state) {
      var name = state.name;
      var index = name.indexOf('$');
      if (index > 0) {
        return name.substr(0, index);
      }
      return name;
    }
  }]);
  return StateMachineType;
}();
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/application/Component.mjs















function Component_createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = Component_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function Component_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return Component_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? Component_arrayLikeToArray(r, a) : void 0; } }
function Component_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function Component_createSuper(t) { var r = Component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function Component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (Component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }



var Component = function (_Element) {
  (0,inherits/* default */.Z)(Component, _Element);
  var _super = Component_createSuper(Component);
  function Component(stage, properties) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, Component);
    _this = _super.call(this, stage);
    _this.tagRoot = true;
    if (Utils_Utils.isObjectLiteral(properties)) {
      Object.assign((0,assertThisInitialized/* default */.Z)(_this), properties);
    }
    _this.__initialized = false;
    _this.__firstActive = false;
    _this.__firstEnable = false;
    _this.__signals = undefined;
    _this.__passSignals = undefined;
    _this.__construct();
    var func = _this.constructor.getTemplateFunc((0,assertThisInitialized/* default */.Z)(_this));
    func.f((0,assertThisInitialized/* default */.Z)(_this), func.a);
    _this._build();
    return _this;
  }
  (0,createClass/* default */.Z)(Component, [{
    key: "__start",
    value: function __start() {
      StateMachine.setupStateMachine(this);
      this._onStateChange = Component.prototype.__onStateChange;
    }
  }, {
    key: "state",
    get: function get() {
      return this._getState();
    }
  }, {
    key: "__onStateChange",
    value: function __onStateChange() {
      if (this.application) {
        this.application.updateFocusPath();
      }
    }
  }, {
    key: "_refocus",
    value: function _refocus() {
      if (this.application) {
        this.application.updateFocusPath();
      }
    }
  }, {
    key: "__bindProperty",
    value: function __bindProperty(propObj, targetObj, targetProp) {
      var _this2 = this;
      var obj = targetObj;
      var prop = targetProp;
      var propDependencies = Array.isArray(propObj.__name) ? propObj.__name : [propObj.__name];
      var _loop = function _loop() {
        var propName = propDependencies[i];
        var func = propObj.__func ? propObj.__func : function (context) {
          return context[propName];
        };
        if (!_this2.hasOwnProperty(propName)) {
          _this2["__prop_bindings_".concat(propName)] = [{
            __obj: obj,
            __prop: prop,
            __func: func
          }];
          Object.defineProperty(_this2, propName, {
            set: function set(value) {
              _this2["__prop_".concat(propName)] = value;
              var _iterator = Component_createForOfIteratorHelper(_this2["__prop_bindings_".concat(propName)]),
                _step;
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var _step$value = _step.value,
                    __obj = _step$value.__obj,
                    __prop = _step$value.__prop,
                    __func = _step$value.__func;
                  __obj[__prop] = __func(_this2);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            },
            get: function get() {
              return _this2["__prop_".concat(propName)];
            }
          });
        } else {
          _this2["__prop_bindings_".concat(propName)].push({
            __obj: obj,
            __prop: prop,
            __func: func
          });
        }
      };
      for (var i = 0; i < propDependencies.length; i++) {
        _loop();
      }
    }
  }, {
    key: "_onSetup",
    value: function _onSetup() {
      if (!this.__initialized) {
        this._setup();
      }
    }
  }, {
    key: "_setup",
    value: function _setup() {}
  }, {
    key: "_onAttach",
    value: function _onAttach() {
      if (!this.__initialized) {
        this.__init();
        this.__initialized = true;
      }
      this._attach();
    }
  }, {
    key: "_attach",
    value: function _attach() {}
  }, {
    key: "_onDetach",
    value: function _onDetach() {
      this._detach();
    }
  }, {
    key: "_detach",
    value: function _detach() {}
  }, {
    key: "_onEnabled",
    value: function _onEnabled() {
      if (!this.__firstEnable) {
        this._firstEnable();
        this.__firstEnable = true;
      }
      this._enable();
    }
  }, {
    key: "_firstEnable",
    value: function _firstEnable() {}
  }, {
    key: "_enable",
    value: function _enable() {}
  }, {
    key: "_onDisabled",
    value: function _onDisabled() {
      this._disable();
    }
  }, {
    key: "_disable",
    value: function _disable() {}
  }, {
    key: "_onActive",
    value: function _onActive() {
      if (!this.__firstActive) {
        this._firstActive();
        this.__firstActive = true;
      }
      this._active();
    }
  }, {
    key: "_firstActive",
    value: function _firstActive() {}
  }, {
    key: "_active",
    value: function _active() {}
  }, {
    key: "_onInactive",
    value: function _onInactive() {
      this._inactive();
    }
  }, {
    key: "_inactive",
    value: function _inactive() {}
  }, {
    key: "application",
    get: function get() {
      return this.stage.application;
    }
  }, {
    key: "__construct",
    value: function __construct() {
      this._construct();
    }
  }, {
    key: "_construct",
    value: function _construct() {}
  }, {
    key: "_build",
    value: function _build() {}
  }, {
    key: "__init",
    value: function __init() {
      this._init();
    }
  }, {
    key: "_init",
    value: function _init() {}
  }, {
    key: "_focus",
    value: function _focus(newTarget, prevTarget) {}
  }, {
    key: "_unfocus",
    value: function _unfocus(newTarget) {}
  }, {
    key: "_focusChange",
    value: function _focusChange(target, newTarget) {}
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this;
    }
  }, {
    key: "_setFocusSettings",
    value: function _setFocusSettings(settings) {}
  }, {
    key: "_handleFocusSettings",
    value: function _handleFocusSettings(settings) {}
  }, {
    key: "hasFinalFocus",
    value: function hasFinalFocus() {
      var path = this.application._focusPath;
      return path && path.length && path[path.length - 1] === this;
    }
  }, {
    key: "hasFocus",
    value: function hasFocus() {
      var path = this.application._focusPath;
      return path && path.indexOf(this) >= 0;
    }
  }, {
    key: "cparent",
    get: function get() {
      return Component.getParent(this);
    }
  }, {
    key: "seekAncestorByType",
    value: function seekAncestorByType(type) {
      var c = this.cparent;
      while (c) {
        if (c.constructor === type) {
          return c;
        }
        c = c.cparent;
      }
    }
  }, {
    key: "getSharedAncestorComponent",
    value: function getSharedAncestorComponent(element) {
      var ancestor = this.getSharedAncestor(element);
      while (ancestor && !ancestor.isComponent) {
        ancestor = ancestor.parent;
      }
      return ancestor;
    }
  }, {
    key: "signals",
    get: function get() {
      return this.__signals;
    },
    set: function set(v) {
      if (!Utils_Utils.isObjectLiteral(v)) {
        this._throwError("Signals: specify an object with signal-to-fire mappings");
      }
      this.__signals = v;
    }
  }, {
    key: "alterSignals",
    set: function set(v) {
      if (!Utils_Utils.isObjectLiteral(v)) {
        this._throwError("Signals: specify an object with signal-to-fire mappings");
      }
      if (!this.__signals) {
        this.__signals = {};
      }
      for (var key in v) {
        var d = v[key];
        if (d === undefined) {
          delete this.__signals[key];
        } else {
          this.__signals[key] = v;
        }
      }
    }
  }, {
    key: "passSignals",
    get: function get() {
      return this.__passSignals || {};
    },
    set: function set(v) {
      this.__passSignals = Object.assign(this.__passSignals || {}, v);
    }
  }, {
    key: "alterPassSignals",
    set: function set(v) {
      if (!Utils_Utils.isObjectLiteral(v)) {
        this._throwError("Signals: specify an object with signal-to-fire mappings");
      }
      if (!this.__passSignals) {
        this.__passSignals = {};
      }
      for (var key in v) {
        var d = v[key];
        if (d === undefined) {
          delete this.__passSignals[key];
        } else {
          this.__passSignals[key] = v;
        }
      }
    }
  }, {
    key: "signal",
    value: function signal(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      return this._signal(event, args);
    }
  }, {
    key: "_signal",
    value: function _signal(event, args) {
      var signalParent = this._getParentSignalHandler();
      if (signalParent) {
        if (this.__signals) {
          var fireEvent = this.__signals[event];
          if (fireEvent === false) {
            return;
          }
          if (fireEvent) {
            if (fireEvent === true) {
              fireEvent = event;
            }
            if (Utils_Utils.isFunction(fireEvent)) {
              return fireEvent.apply(void 0, (0,toConsumableArray/* default */.Z)(args));
            }
            if (signalParent._hasMethod(fireEvent)) {
              return signalParent[fireEvent].apply(signalParent, (0,toConsumableArray/* default */.Z)(args));
            }
          }
        }
        var passSignal = this.__passSignals && this.__passSignals[event];
        if (passSignal) {
          if (passSignal && passSignal !== true) {
            event = passSignal;
          }
          return signalParent._signal(event, args);
        }
      }
    }
  }, {
    key: "_getParentSignalHandler",
    value: function _getParentSignalHandler() {
      return this.cparent ? this.cparent._getSignalHandler() : null;
    }
  }, {
    key: "_getSignalHandler",
    value: function _getSignalHandler() {
      if (this._signalProxy) {
        return this.cparent ? this.cparent._getSignalHandler() : null;
      }
      return this;
    }
  }, {
    key: "_signalProxy",
    get: function get() {
      return false;
    }
  }, {
    key: "fireAncestors",
    value: function fireAncestors(name) {
      if (!name.startsWith('$')) {
        throw new Error("Ancestor event name must be prefixed by dollar sign.");
      }
      var parent = this._getParentSignalHandler();
      if (parent) {
        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }
        return parent._doFireAncestors(name, args);
      }
    }
  }, {
    key: "_doFireAncestors",
    value: function _doFireAncestors(name, args) {
      if (this._hasMethod(name)) {
        return this.fire.apply(this, [name].concat((0,toConsumableArray/* default */.Z)(args)));
      } else {
        var signalParent = this._getParentSignalHandler();
        if (signalParent) {
          return signalParent._doFireAncestors(name, args);
        }
      }
    }
  }], [{
    key: "bindProp",
    value: function bindProp(name) {
      var func = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return {
        __propertyBinding: true,
        __name: name,
        __func: func
      };
    }
  }, {
    key: "getTemplateFunc",
    value: function getTemplateFunc(ctx) {
      var name = "_templateFunc";
      var hasName = '__has' + name;
      if (this[hasName] !== this) {
        this[hasName] = this;
        this[name] = this.parseTemplate(this._template(ctx));
      }
      return this[name];
    }
  }, {
    key: "parseTemplate",
    value: function parseTemplate(obj) {
      var context = {
        loc: [],
        store: [],
        rid: 0
      };
      this.parseTemplateRec(obj, context, "element");
      var code = context.loc.join(";\n");
      var f = new Function("element", "store", code);
      return {
        f: f,
        a: context.store
      };
    }
  }, {
    key: "parseTemplateRec",
    value: function parseTemplateRec(obj, context, cursor) {
      var _this3 = this;
      var store = context.store;
      var loc = context.loc;
      var keys = Object.keys(obj);
      keys.forEach(function (key) {
        var value = obj[key];
        if (Utils_Utils.isUcChar(key.charCodeAt(0))) {
          if (Utils_Utils.isObjectLiteral(value)) {
            var childCursor = "r".concat(key.replace(/[^a-z0-9]/gi, "") + context.rid);
            var type = value.type ? value.type : Element;
            if (type === Element) {
              loc.push("var ".concat(childCursor, " = element.stage.createElement()"));
            } else {
              store.push(type);
              loc.push("var ".concat(childCursor, " = new store[").concat(store.length - 1, "](").concat(cursor, ".stage)"));
            }
            loc.push("".concat(childCursor, ".ref = \"").concat(key, "\""));
            context.rid++;
            _this3.parseTemplateRec(value, context, childCursor);
            loc.push("".concat(cursor, ".childList.add(").concat(childCursor, ")"));
          } else if (Utils_Utils.isObject(value)) {
            store.push(value);
            loc.push("".concat(cursor, ".childList.add(store[").concat(store.length - 1, "])"));
          }
        } else {
          if (key === "text") {
            var propKey = cursor + "__text";
            loc.push("var ".concat(propKey, " = ").concat(cursor, ".enableTextTexture()"));
            if (value.__propertyBinding === true) {
              store.push(value);
              loc.push("element.__bindProperty(store[".concat(store.length - 1, "], ").concat(cursor, ", \"").concat(key, "\")"));
            } else {
              _this3.parseTemplatePropRec(value, context, propKey);
            }
          } else if (key === "shader" && Utils_Utils.isObjectLiteral(value)) {
            var shaderCursor = "".concat(cursor, "[\"shader\"]");
            store.push(value);
            loc.push("".concat(cursor, "[\"").concat(key, "\"] = store[").concat(store.length - 1, "]"));
            _this3.parsePropertyBindings(value, context, shaderCursor);
          } else if (key === "texture" && Utils_Utils.isObjectLiteral(value)) {
            var _propKey = cursor + "__texture";
            var _type = value.type;
            if (_type) {
              store.push(_type);
              loc.push("var ".concat(_propKey, " = new store[").concat(store.length - 1, "](").concat(cursor, ".stage)"));
              _this3.parseTemplatePropRec(value, context, _propKey);
              loc.push("".concat(cursor, "[\"").concat(key, "\"] = ").concat(_propKey));
            } else {
              loc.push("".concat(_propKey, " = ").concat(cursor, ".texture"));
              _this3.parseTemplatePropRec(value, context, _propKey);
            }
          } else if (Utils_Utils.isObjectLiteral(value) && value.__propertyBinding === true) {
            store.push(value);
            loc.push("element.__bindProperty(store[".concat(store.length - 1, "], ").concat(cursor, ", \"").concat(key, "\")"));
          } else {
            if (Utils_Utils.isNumber(value)) {
              loc.push("".concat(cursor, "[\"").concat(key, "\"] = ").concat(value));
            } else if (Utils_Utils.isBoolean(value)) {
              loc.push("".concat(cursor, "[\"").concat(key, "\"] = ").concat(value ? "true" : "false"));
            } else if (Utils_Utils.isObject(value) || Array.isArray(value)) {
              store.push(value);
              loc.push("".concat(cursor, "[\"").concat(key, "\"] = store[").concat(store.length - 1, "]"));
            } else {
              loc.push("".concat(cursor, "[\"").concat(key, "\"] = ").concat(JSON.stringify(value)));
            }
          }
        }
      });
    }
  }, {
    key: "parseTemplatePropRec",
    value: function parseTemplatePropRec(obj, context, cursor) {
      var store = context.store;
      var loc = context.loc;
      var keys = Object.keys(obj);
      keys.forEach(function (key) {
        if (key !== "type") {
          var value = obj[key];
          if (Utils_Utils.isNumber(value)) {
            loc.push("".concat(cursor, "[\"").concat(key, "\"] = ").concat(value));
          } else if (Utils_Utils.isBoolean(value)) {
            loc.push("".concat(cursor, "[\"").concat(key, "\"] = ").concat(value ? "true" : "false"));
          } else if (Utils_Utils.isObject(value) && value.__propertyBinding === true) {
            store.push(value);
            loc.push("element.__bindProperty(store[".concat(store.length - 1, "], ").concat(cursor, ", \"").concat(key, "\")"));
          } else if (Utils_Utils.isObject(value) || Array.isArray(value)) {
            store.push(value);
            loc.push("".concat(cursor, "[\"").concat(key, "\"] = store[").concat(store.length - 1, "]"));
          } else {
            loc.push("".concat(cursor, "[\"").concat(key, "\"] = ").concat(JSON.stringify(value)));
          }
        }
      });
    }
  }, {
    key: "parsePropertyBindings",
    value: function parsePropertyBindings(obj, context, cursor) {
      var store = context.store;
      var loc = context.loc;
      var keys = Object.keys(obj);
      keys.forEach(function (key) {
        if (key !== "type") {
          var value = obj[key];
          if (Utils_Utils.isObjectLiteral(value) && value.__propertyBinding === true) {
            store.push(value);
            loc.push("element.__bindProperty(store[".concat(store.length - 1, "], ").concat(cursor, ", \"").concat(key, "\")"));
          }
        }
      });
    }
  }, {
    key: "_template",
    value: function _template() {
      return {};
    }
  }, {
    key: "collectSubComponents",
    value: function collectSubComponents(subs, element) {
      if (element.hasChildren()) {
        var childList = element.__childList;
        for (var i = 0, n = childList.length; i < n; i++) {
          var child = childList.getAt(i);
          if (child.isComponent) {
            subs.push(child);
          } else {
            Component.collectSubComponents(subs, child);
          }
        }
      }
    }
  }, {
    key: "getComponent",
    value: function getComponent(element) {
      var parent = element;
      while (parent && !parent.isComponent) {
        parent = parent.parent;
      }
      return parent;
    }
  }, {
    key: "getParent",
    value: function getParent(element) {
      return Component.getComponent(element.parent);
    }
  }]);
  return Component;
}(Element);

Component.prototype.isComponent = true;
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.typed-array.float32-array.js
var es_typed_array_float32_array = __webpack_require__(97115);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.typed-array.copy-within.js
var es_typed_array_copy_within = __webpack_require__(5894);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.typed-array.every.js
var es_typed_array_every = __webpack_require__(46896);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.typed-array.fill.js
var es_typed_array_fill = __webpack_require__(18527);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.typed-array.filter.js
var es_typed_array_filter = __webpack_require__(75858);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.typed-array.find.js
var es_typed_array_find = __webpack_require__(30001);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.typed-array.find-index.js
var es_typed_array_find_index = __webpack_require__(20523);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.typed-array.for-each.js
var es_typed_array_for_each = __webpack_require__(91398);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.typed-array.includes.js
var es_typed_array_includes = __webpack_require__(43334);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.typed-array.index-of.js
var es_typed_array_index_of = __webpack_require__(82138);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.typed-array.iterator.js
var es_typed_array_iterator = __webpack_require__(44127);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.typed-array.join.js
var es_typed_array_join = __webpack_require__(84991);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.typed-array.last-index-of.js
var es_typed_array_last_index_of = __webpack_require__(88194);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.typed-array.map.js
var es_typed_array_map = __webpack_require__(90779);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.typed-array.reduce.js
var es_typed_array_reduce = __webpack_require__(26849);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.typed-array.reduce-right.js
var es_typed_array_reduce_right = __webpack_require__(63794);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.typed-array.reverse.js
var es_typed_array_reverse = __webpack_require__(91944);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.typed-array.set.js
var es_typed_array_set = __webpack_require__(87937);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.typed-array.slice.js
var es_typed_array_slice = __webpack_require__(86968);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.typed-array.some.js
var es_typed_array_some = __webpack_require__(8501);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.typed-array.sort.js
var es_typed_array_sort = __webpack_require__(55019);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.typed-array.subarray.js
var es_typed_array_subarray = __webpack_require__(47273);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.typed-array.to-locale-string.js
var es_typed_array_to_locale_string = __webpack_require__(17082);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.typed-array.to-string.js
var es_typed_array_to_string = __webpack_require__(80827);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.array-buffer.constructor.js
var es_array_buffer_constructor = __webpack_require__(87327);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.typed-array.uint32-array.js
var es_typed_array_uint32_array = __webpack_require__(23353);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/tree/core/CoreQuadList.mjs


var CoreQuadList = function () {
  function CoreQuadList(ctx) {
    (0,classCallCheck/* default */.Z)(this, CoreQuadList);
    this.ctx = ctx;
    this.quadTextures = [];
    this.quadElements = [];
  }
  (0,createClass/* default */.Z)(CoreQuadList, [{
    key: "length",
    get: function get() {
      return this.quadTextures.length;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.quadTextures = [];
      this.quadElements = [];
      this.dataLength = 0;
    }
  }, {
    key: "getElement",
    value: function getElement(index) {
      return this.quadElements[index]._element;
    }
  }, {
    key: "getElementCore",
    value: function getElementCore(index) {
      return this.quadElements[index];
    }
  }, {
    key: "getTexture",
    value: function getTexture(index) {
      return this.quadTextures[index];
    }
  }, {
    key: "getTextureWidth",
    value: function getTextureWidth(index) {
      var nativeTexture = this.quadTextures[index];
      if (nativeTexture.w) {
        return nativeTexture.w;
      } else {
        return this.quadElements[index]._displayedTextureSource.w;
      }
    }
  }, {
    key: "getTextureHeight",
    value: function getTextureHeight(index) {
      var nativeTexture = this.quadTextures[index];
      if (nativeTexture.h) {
        return nativeTexture.h;
      } else {
        return this.quadElements[index]._displayedTextureSource.h;
      }
    }
  }]);
  return CoreQuadList;
}();

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/renderer/webgl/WebGLCoreQuadList.mjs


































function WebGLCoreQuadList_createSuper(t) { var r = WebGLCoreQuadList_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function WebGLCoreQuadList_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (WebGLCoreQuadList_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var WebGLCoreQuadList = function (_CoreQuadList) {
  (0,inherits/* default */.Z)(WebGLCoreQuadList, _CoreQuadList);
  var _super = WebGLCoreQuadList_createSuper(WebGLCoreQuadList);
  function WebGLCoreQuadList(ctx) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, WebGLCoreQuadList);
    _this = _super.call(this, ctx);
    var byteSize = ctx.stage.getOption('bufferMemory');
    _this.dataLength = 0;
    _this.data = new ArrayBuffer(byteSize);
    _this.floats = new Float32Array(_this.data);
    _this.uints = new Uint32Array(_this.data);
    return _this;
  }
  (0,createClass/* default */.Z)(WebGLCoreQuadList, [{
    key: "getAttribsDataByteOffset",
    value: function getAttribsDataByteOffset(index) {
      return index * 80;
    }
  }, {
    key: "getQuadContents",
    value: function getQuadContents() {
      var floats = this.floats;
      var uints = this.uints;
      var lines = [];
      for (var i = 1; i <= this.length; i++) {
        var str = 'entry ' + i + ': ';
        for (var j = 0; j < 4; j++) {
          var b = i * 20 + j * 4;
          str += floats[b] + ',' + floats[b + 1] + ':' + floats[b + 2] + ',' + floats[b + 3] + '[' + uints[b + 4].toString(16) + '] ';
        }
        lines.push(str);
      }
      return lines;
    }
  }]);
  return WebGLCoreQuadList;
}(CoreQuadList);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/tree/core/CoreQuadOperation.mjs


var CoreQuadOperation = function () {
  function CoreQuadOperation(ctx, shader, shaderOwner, renderTextureInfo, scissor, index) {
    (0,classCallCheck/* default */.Z)(this, CoreQuadOperation);
    this.ctx = ctx;
    this.shader = shader;
    this.shaderOwner = shaderOwner;
    this.renderTextureInfo = renderTextureInfo;
    this.scissor = scissor;
    this.index = index;
    this.length = 0;
  }
  (0,createClass/* default */.Z)(CoreQuadOperation, [{
    key: "quads",
    get: function get() {
      return this.ctx.renderState.quads;
    }
  }, {
    key: "getTexture",
    value: function getTexture(index) {
      return this.quads.getTexture(this.index + index);
    }
  }, {
    key: "getElementCore",
    value: function getElementCore(index) {
      return this.quads.getElementCore(this.index + index);
    }
  }, {
    key: "getElement",
    value: function getElement(index) {
      return this.quads.getElement(this.index + index);
    }
  }, {
    key: "getElementWidth",
    value: function getElementWidth(index) {
      return this.getElement(index).renderWidth;
    }
  }, {
    key: "getElementHeight",
    value: function getElementHeight(index) {
      return this.getElement(index).renderHeight;
    }
  }, {
    key: "getTextureWidth",
    value: function getTextureWidth(index) {
      return this.quads.getTextureWidth(this.index + index);
    }
  }, {
    key: "getTextureHeight",
    value: function getTextureHeight(index) {
      return this.quads.getTextureHeight(this.index + index);
    }
  }, {
    key: "getRenderWidth",
    value: function getRenderWidth() {
      if (this.renderTextureInfo) {
        return this.renderTextureInfo.w;
      } else {
        return this.ctx.stage.w;
      }
    }
  }, {
    key: "getRenderHeight",
    value: function getRenderHeight() {
      if (this.renderTextureInfo) {
        return this.renderTextureInfo.h;
      } else {
        return this.ctx.stage.h;
      }
    }
  }]);
  return CoreQuadOperation;
}();

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/renderer/webgl/WebGLCoreQuadOperation.mjs





function WebGLCoreQuadOperation_createSuper(t) { var r = WebGLCoreQuadOperation_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function WebGLCoreQuadOperation_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (WebGLCoreQuadOperation_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var WebGLCoreQuadOperation = function (_CoreQuadOperation) {
  (0,inherits/* default */.Z)(WebGLCoreQuadOperation, _CoreQuadOperation);
  var _super = WebGLCoreQuadOperation_createSuper(WebGLCoreQuadOperation);
  function WebGLCoreQuadOperation(ctx, shader, shaderOwner, renderTextureInfo, scissor, index) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, WebGLCoreQuadOperation);
    _this = _super.call(this, ctx, shader, shaderOwner, renderTextureInfo, scissor, index);
    _this.extraAttribsDataByteOffset = 0;
    return _this;
  }
  (0,createClass/* default */.Z)(WebGLCoreQuadOperation, [{
    key: "getAttribsDataByteOffset",
    value: function getAttribsDataByteOffset(index) {
      return this.quads.getAttribsDataByteOffset(this.index + index);
    }
  }, {
    key: "getNormalRenderTextureCoords",
    value: function getNormalRenderTextureCoords(x, y) {
      var coords = this.shaderOwner.getRenderTextureCoords(x, y);
      coords[0] /= this.getRenderWidth();
      coords[1] /= this.getRenderHeight();
      coords[0] = coords[0] * 2 - 1;
      coords[1] = 1 - coords[1] * 2;
      return coords;
    }
  }, {
    key: "getProjection",
    value: function getProjection() {
      if (this.renderTextureInfo === null) {
        return this.ctx.renderExec._projection;
      } else {
        return this.renderTextureInfo.nativeTexture.projection;
      }
    }
  }]);
  return WebGLCoreQuadOperation;
}(CoreQuadOperation);

// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.typed-array.uint16-array.js
var es_typed_array_uint16_array = __webpack_require__(57419);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/tree/core/CoreRenderExecutor.mjs


var CoreRenderExecutor = function () {
  function CoreRenderExecutor(ctx) {
    (0,classCallCheck/* default */.Z)(this, CoreRenderExecutor);
    this.ctx = ctx;
    this.renderState = ctx.renderState;
    this.gl = this.ctx.stage.gl;
  }
  (0,createClass/* default */.Z)(CoreRenderExecutor, [{
    key: "destroy",
    value: function destroy() {}
  }, {
    key: "_reset",
    value: function _reset() {
      this._bindRenderTexture(null);
      this._setScissor(null);
      this._clearRenderTexture();
    }
  }, {
    key: "execute",
    value: function execute() {
      this._reset();
      var qops = this.renderState.quadOperations;
      var i = 0,
        j = 0,
        n = qops.length;
      while (i < n) {
        this._processQuadOperation(qops[i]);
        i++;
      }
    }
  }, {
    key: "_processQuadOperation",
    value: function _processQuadOperation(quadOperation) {
      if (quadOperation.renderTextureInfo && quadOperation.renderTextureInfo.ignore) {
        return;
      }
      this._setupQuadOperation(quadOperation);
      this._execQuadOperation(quadOperation);
    }
  }, {
    key: "_setupQuadOperation",
    value: function _setupQuadOperation(quadOperation) {}
  }, {
    key: "_execQuadOperation",
    value: function _execQuadOperation(op) {
      var nativeTexture = op.renderTextureInfo ? op.renderTextureInfo.nativeTexture : null;
      if (this._renderTexture !== nativeTexture) {
        this._bindRenderTexture(nativeTexture);
      }
      if (op.renderTextureInfo && !op.renderTextureInfo.cleared) {
        this._setScissor(null);
        this._clearRenderTexture();
        op.renderTextureInfo.cleared = true;
        this._setScissor(op.scissor);
      } else {
        this._setScissor(op.scissor);
      }
      this._renderQuadOperation(op);
    }
  }, {
    key: "_renderQuadOperation",
    value: function _renderQuadOperation(op) {}
  }, {
    key: "_bindRenderTexture",
    value: function _bindRenderTexture(renderTexture) {
      this._renderTexture = renderTexture;
    }
  }, {
    key: "_clearRenderTexture",
    value: function _clearRenderTexture(renderTexture) {}
  }, {
    key: "_setScissor",
    value: function _setScissor(area) {}
  }]);
  return CoreRenderExecutor;
}();

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/renderer/webgl/WebGLCoreRenderExecutor.mjs

































function WebGLCoreRenderExecutor_createSuper(t) { var r = WebGLCoreRenderExecutor_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function WebGLCoreRenderExecutor_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (WebGLCoreRenderExecutor_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var WebGLCoreRenderExecutor = function (_CoreRenderExecutor) {
  (0,inherits/* default */.Z)(WebGLCoreRenderExecutor, _CoreRenderExecutor);
  var _super = WebGLCoreRenderExecutor_createSuper(WebGLCoreRenderExecutor);
  function WebGLCoreRenderExecutor(ctx) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, WebGLCoreRenderExecutor);
    _this = _super.call(this, ctx);
    _this.gl = _this.ctx.stage.gl;
    _this.init();
    return _this;
  }
  (0,createClass/* default */.Z)(WebGLCoreRenderExecutor, [{
    key: "init",
    value: function init() {
      var gl = this.gl;
      this._attribsBuffer = gl.createBuffer();
      var maxQuads = Math.floor(this.renderState.quads.data.byteLength / 80);
      var allIndices = new Uint16Array(maxQuads * 6);
      for (var i = 0, j = 0; i < maxQuads; i += 6, j += 4) {
        allIndices[i] = j;
        allIndices[i + 1] = j + 1;
        allIndices[i + 2] = j + 2;
        allIndices[i + 3] = j;
        allIndices[i + 4] = j + 2;
        allIndices[i + 5] = j + 3;
      }
      this._quadsBuffer = gl.createBuffer();
      gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this._quadsBuffer);
      gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, allIndices, gl.STATIC_DRAW);
      this._projection = new Float32Array([2 / this.ctx.stage.coordsWidth, -2 / this.ctx.stage.coordsHeight]);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(WebGLCoreRenderExecutor.prototype), "destroy", this).call(this);
      this.gl.deleteBuffer(this._attribsBuffer);
      this.gl.deleteBuffer(this._quadsBuffer);
    }
  }, {
    key: "_reset",
    value: function _reset() {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(WebGLCoreRenderExecutor.prototype), "_reset", this).call(this);
      var gl = this.gl;
      gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
      gl.enable(gl.BLEND);
      gl.disable(gl.DEPTH_TEST);
      this._stopShaderProgram();
      this._setupBuffers();
    }
  }, {
    key: "_setupBuffers",
    value: function _setupBuffers() {
      var gl = this.gl;
      gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this._quadsBuffer);
      var element = new Float32Array(this.renderState.quads.data, 0, this.renderState.quads.dataLength);
      gl.bindBuffer(gl.ARRAY_BUFFER, this._attribsBuffer);
      gl.bufferData(gl.ARRAY_BUFFER, element, gl.DYNAMIC_DRAW);
    }
  }, {
    key: "_setupQuadOperation",
    value: function _setupQuadOperation(quadOperation) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(WebGLCoreRenderExecutor.prototype), "_setupQuadOperation", this).call(this, quadOperation);
      this._useShaderProgram(quadOperation.shader, quadOperation);
    }
  }, {
    key: "_renderQuadOperation",
    value: function _renderQuadOperation(op) {
      var shader = op.shader;
      if (op.length || op.shader.addEmpty()) {
        shader.beforeDraw(op);
        shader.draw(op);
        shader.afterDraw(op);
      }
    }
  }, {
    key: "_useShaderProgram",
    value: function _useShaderProgram(shader, operation) {
      if (!shader.hasSameProgram(this._currentShaderProgram)) {
        if (this._currentShaderProgram) {
          this._currentShaderProgram.stopProgram();
        }
        shader.useProgram();
        this._currentShaderProgram = shader;
      }
      shader.setupUniforms(operation);
    }
  }, {
    key: "_stopShaderProgram",
    value: function _stopShaderProgram() {
      if (this._currentShaderProgram) {
        this._currentShaderProgram.stopProgram();
        this._currentShaderProgram = null;
      }
    }
  }, {
    key: "_bindRenderTexture",
    value: function _bindRenderTexture(renderTexture) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(WebGLCoreRenderExecutor.prototype), "_bindRenderTexture", this).call(this, renderTexture);
      var gl = this.gl;
      if (!this._renderTexture) {
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        gl.viewport(0, 0, this.ctx.stage.w, this.ctx.stage.h);
      } else {
        gl.bindFramebuffer(gl.FRAMEBUFFER, this._renderTexture.framebuffer);
        gl.viewport(0, 0, this._renderTexture.w, this._renderTexture.h);
      }
    }
  }, {
    key: "_clearRenderTexture",
    value: function _clearRenderTexture() {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(WebGLCoreRenderExecutor.prototype), "_clearRenderTexture", this).call(this);
      var gl = this.gl;
      if (!this._renderTexture) {
        var glClearColor = this.ctx.stage.getClearColor();
        if (glClearColor) {
          gl.clearColor(glClearColor[0] * glClearColor[3], glClearColor[1] * glClearColor[3], glClearColor[2] * glClearColor[3], glClearColor[3]);
          gl.clear(gl.COLOR_BUFFER_BIT);
        }
      } else {
        gl.clearColor(0, 0, 0, 0);
        gl.clear(gl.COLOR_BUFFER_BIT);
      }
    }
  }, {
    key: "_setScissor",
    value: function _setScissor(area) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(WebGLCoreRenderExecutor.prototype), "_setScissor", this).call(this, area);
      if (this._scissor === area) {
        return;
      }
      this._scissor = area;
      var gl = this.gl;
      if (!area) {
        gl.disable(gl.SCISSOR_TEST);
      } else {
        gl.enable(gl.SCISSOR_TEST);
        var precision = this.ctx.stage.getRenderPrecision();
        var y = area[1];
        if (this._renderTexture === null) {
          y = this.ctx.stage.h / precision - (area[1] + area[3]);
        }
        gl.scissor(Math.round(area[0] * precision), Math.round(y * precision), Math.round(area[2] * precision), Math.round(area[3] * precision));
      }
    }
  }]);
  return WebGLCoreRenderExecutor;
}(CoreRenderExecutor);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/tree/core/CoreRenderState.mjs


var CoreRenderState = function () {
  function CoreRenderState(ctx) {
    (0,classCallCheck/* default */.Z)(this, CoreRenderState);
    this.ctx = ctx;
    this.stage = ctx.stage;
    this.defaultShader = this.stage.renderer.getDefaultShader(ctx);
    this.renderer = ctx.stage.renderer;
    this.quads = this.renderer.createCoreQuadList(ctx);
  }
  (0,createClass/* default */.Z)(CoreRenderState, [{
    key: "reset",
    value: function reset() {
      this._renderTextureInfo = null;
      this._scissor = null;
      this._shader = null;
      this._shaderOwner = null;
      this._realShader = null;
      this._check = false;
      this.quadOperations = [];
      this._texturizer = null;
      this._texturizerTemporary = false;
      this._quadOperation = null;
      this.quads.reset();
      this._temporaryTexturizers = [];
      this._isCachingTexturizer = false;
    }
  }, {
    key: "length",
    get: function get() {
      return this.quads.quadTextures.length;
    }
  }, {
    key: "setShader",
    value: function setShader(shader, owner) {
      if (this._shaderOwner !== owner || this._realShader !== shader) {
        this._realShader = shader;
        if (shader.useDefault()) {
          shader = this.defaultShader;
        }
        if (this._shader !== shader || this._shaderOwner !== owner) {
          this._shader = shader;
          this._shaderOwner = owner;
          this._check = true;
        }
      }
    }
  }, {
    key: "renderTextureInfo",
    get: function get() {
      return this._renderTextureInfo;
    }
  }, {
    key: "setScissor",
    value: function setScissor(area) {
      if (this._scissor !== area) {
        if (area) {
          this._scissor = area;
        } else {
          this._scissor = null;
        }
        this._check = true;
      }
    }
  }, {
    key: "getScissor",
    value: function getScissor() {
      return this._scissor;
    }
  }, {
    key: "setRenderTextureInfo",
    value: function setRenderTextureInfo(renderTextureInfo) {
      if (this._renderTextureInfo !== renderTextureInfo) {
        this._renderTextureInfo = renderTextureInfo;
        this._scissor = null;
        this._check = true;
      }
    }
  }, {
    key: "setTexturizer",
    value: function setTexturizer(texturizer) {
      var cache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this._texturizer = texturizer;
      this._cacheTexturizer = cache;
    }
  }, {
    key: "isCachingTexturizer",
    get: function get() {
      return this._isCachingTexturizer;
    },
    set: function set(v) {
      this._isCachingTexturizer = v;
    }
  }, {
    key: "addQuad",
    value: function addQuad(elementCore) {
      if (!this._quadOperation) {
        this._createQuadOperation();
      } else if (this._check && this._hasChanges()) {
        this._finishQuadOperation();
        this._check = false;
      }
      var nativeTexture = null;
      if (this._texturizer) {
        nativeTexture = this._texturizer.getResultTexture();
        if (!this._cacheTexturizer) {
          this._temporaryTexturizers.push(this._texturizer);
        }
      }
      if (!nativeTexture) {
        nativeTexture = elementCore._displayedTextureSource.nativeTexture;
      }
      if (this._renderTextureInfo) {
        if (this._shader === this.defaultShader && this._renderTextureInfo.empty) {
          this._renderTextureInfo.nativeTexture = nativeTexture;
          this._renderTextureInfo.offset = this.length;
        } else {
          this._renderTextureInfo.nativeTexture = null;
        }
        this._renderTextureInfo.empty = false;
      }
      this.quads.quadTextures.push(nativeTexture);
      this.quads.quadElements.push(elementCore);
      this._quadOperation.length++;
      this.renderer.addQuad(this, this.quads, this.length - 1);
    }
  }, {
    key: "finishedRenderTexture",
    value: function finishedRenderTexture() {
      if (this._renderTextureInfo.nativeTexture) {
        if (!this._isRenderTextureReusable()) {
          this._renderTextureInfo.nativeTexture = null;
        }
      }
    }
  }, {
    key: "_isRenderTextureReusable",
    value: function _isRenderTextureReusable() {
      var offset = this._renderTextureInfo.offset;
      return this.quads.quadTextures[offset].w === this._renderTextureInfo.w && this.quads.quadTextures[offset].h === this._renderTextureInfo.h && this.renderer.isRenderTextureReusable(this, this._renderTextureInfo);
    }
  }, {
    key: "_hasChanges",
    value: function _hasChanges() {
      var q = this._quadOperation;
      if (this._shader !== q.shader) return true;
      if (this._shaderOwner !== q.shaderOwner) return true;
      if (this._renderTextureInfo !== q.renderTextureInfo) return true;
      if (this._scissor !== q.scissor) {
        if (this._scissor[0] !== q.scissor[0] || this._scissor[1] !== q.scissor[1] || this._scissor[2] !== q.scissor[2] || this._scissor[3] !== q.scissor[3]) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: "_finishQuadOperation",
    value: function _finishQuadOperation() {
      var create = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (this._quadOperation) {
        if (this._quadOperation.length || this._shader.addEmpty()) {
          if (!this._quadOperation.scissor || this._quadOperation.scissor[2] > 0 && this._quadOperation.scissor[3] > 0) {
            this.quadOperations.push(this._quadOperation);
          }
        }
        if (this._temporaryTexturizers.length) {
          for (var i = 0, n = this._temporaryTexturizers.length; i < n; i++) {
            this._temporaryTexturizers[i].releaseRenderTexture();
          }
          this._temporaryTexturizers = [];
        }
        this._quadOperation = null;
      }
      if (create) {
        this._createQuadOperation();
      }
    }
  }, {
    key: "_createQuadOperation",
    value: function _createQuadOperation() {
      this._quadOperation = this.renderer.createCoreQuadOperation(this.ctx, this._shader, this._shaderOwner, this._renderTextureInfo, this._scissor, this.length);
      this._check = false;
    }
  }, {
    key: "finish",
    value: function finish() {
      if (this._quadOperation) {
        this._finishQuadOperation(false);
      }
      this.renderer.finishRenderState(this);
    }
  }]);
  return CoreRenderState;
}();

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/renderer/webgl/WebGLShaderProgram.mjs













var WebGLShaderProgram = function () {
  function WebGLShaderProgram(vertexShaderSource, fragmentShaderSource) {
    (0,classCallCheck/* default */.Z)(this, WebGLShaderProgram);
    this.vertexShaderSource = vertexShaderSource;
    this.fragmentShaderSource = fragmentShaderSource;
    this._program = null;
    this._uniformLocations = new Map();
    this._attributeLocations = new Map();
    this._currentUniformValues = {};
  }
  (0,createClass/* default */.Z)(WebGLShaderProgram, [{
    key: "compile",
    value: function compile(gl) {
      if (this._program) return;
      this.gl = gl;
      this._program = gl.createProgram();
      var glVertShader = this._glCompile(gl.VERTEX_SHADER, this.vertexShaderSource);
      var glFragShader = this._glCompile(gl.FRAGMENT_SHADER, this.fragmentShaderSource);
      gl.attachShader(this._program, glVertShader);
      gl.attachShader(this._program, glFragShader);
      gl.linkProgram(this._program);
      if (!gl.getProgramParameter(this._program, gl.LINK_STATUS)) {
        console.error('[Lightning] Error: Could not initialize shader.');
        console.error('[Lightning] gl.VALIDATE_STATUS', gl.getProgramParameter(this._program, gl.VALIDATE_STATUS));
        console.error('[Lightning] gl.getError()', gl.getError());
        if (gl.getProgramInfoLog(this._program) !== '') {
          console.warn('[Lightning] Warning: gl.getProgramInfoLog()', gl.getProgramInfoLog(this._program));
        }
        gl.deleteProgram(this._program);
        this._program = null;
      }
      gl.deleteShader(glVertShader);
      gl.deleteShader(glFragShader);
    }
  }, {
    key: "_glCompile",
    value: function _glCompile(type, src) {
      var shader = this.gl.createShader(type);
      this.gl.shaderSource(shader, src);
      this.gl.compileShader(shader);
      if (!this.gl.getShaderParameter(shader, this.gl.COMPILE_STATUS)) {
        console.error('[Lightning]', this.constructor.name, 'Type: ' + (type === this.gl.VERTEX_SHADER ? 'vertex shader' : 'fragment shader'));
        console.error('[Lightning]', this.gl.getShaderInfoLog(shader));
        var idx = 0;
        console.error('[Lightning]', "========== source ==========\n" + src.split("\n").map(function (line) {
          return "" + ++idx + ": " + line;
        }).join("\n"));
        return null;
      }
      return shader;
    }
  }, {
    key: "getUniformLocation",
    value: function getUniformLocation(name) {
      var location = this._uniformLocations.get(name);
      if (location === undefined) {
        location = this.gl.getUniformLocation(this._program, name);
        this._uniformLocations.set(name, location);
      }
      return location;
    }
  }, {
    key: "getAttribLocation",
    value: function getAttribLocation(name) {
      var location = this._attributeLocations.get(name);
      if (location === undefined) {
        location = this.gl.getAttribLocation(this._program, name);
        this._attributeLocations.set(name, location);
      }
      return location;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this._program) {
        this.gl.deleteProgram(this._program);
        this._program = null;
      }
    }
  }, {
    key: "glProgram",
    get: function get() {
      return this._program;
    }
  }, {
    key: "compiled",
    get: function get() {
      return !!this._program;
    }
  }, {
    key: "_valueEquals",
    value: function _valueEquals(v1, v2) {
      if (v1.length && v2.length) {
        for (var i = 0, n = v1.length; i < n; i++) {
          if (v1[i] !== v2[i]) return false;
        }
        return true;
      } else {
        return v1 === v2;
      }
    }
  }, {
    key: "_valueClone",
    value: function _valueClone(v) {
      if (v.length) {
        return v.slice(0);
      } else {
        return v;
      }
    }
  }, {
    key: "setUniformValue",
    value: function setUniformValue(name, value, glFunction) {
      var v = this._currentUniformValues[name];
      if (v === undefined || !this._valueEquals(v, value)) {
        var clonedValue = this._valueClone(value);
        this._currentUniformValues[name] = clonedValue;
        var loc = this.getUniformLocation(name);
        if (loc) {
          var isMatrix = glFunction === this.gl.uniformMatrix2fv || glFunction === this.gl.uniformMatrix3fv || glFunction === this.gl.uniformMatrix4fv;
          if (isMatrix) {
            glFunction.call(this.gl, loc, false, clonedValue);
          } else {
            glFunction.call(this.gl, loc, clonedValue);
          }
        }
      }
    }
  }]);
  return WebGLShaderProgram;
}();

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/renderer/webgl/WebGLShader.mjs





function WebGLShader_createSuper(t) { var r = WebGLShader_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function WebGLShader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (WebGLShader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }


var WebGLShader = function (_Shader) {
  (0,inherits/* default */.Z)(WebGLShader, _Shader);
  var _super = WebGLShader_createSuper(WebGLShader);
  function WebGLShader(ctx) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, WebGLShader);
    _this = _super.call(this, ctx);
    var stage = ctx.stage;
    _this._program = stage.renderer.shaderPrograms.get(_this.constructor);
    if (!_this._program) {
      _this._program = new WebGLShaderProgram(_this.constructor.vertexShaderSource, _this.constructor.fragmentShaderSource);
      stage.renderer.shaderPrograms.set(_this.constructor, _this._program);
    }
    _this.gl = stage.gl;
    return _this;
  }
  (0,createClass/* default */.Z)(WebGLShader, [{
    key: "glProgram",
    get: function get() {
      return this._program.glProgram;
    }
  }, {
    key: "_init",
    value: function _init() {
      if (!this._initialized) {
        this.initialize();
        this._initialized = true;
      }
    }
  }, {
    key: "initialize",
    value: function initialize() {
      this._program.compile(this.gl);
    }
  }, {
    key: "initialized",
    get: function get() {
      return this._initialized;
    }
  }, {
    key: "_uniform",
    value: function _uniform(name) {
      return this._program.getUniformLocation(name);
    }
  }, {
    key: "_attrib",
    value: function _attrib(name) {
      return this._program.getAttribLocation(name);
    }
  }, {
    key: "_setUniform",
    value: function _setUniform(name, value, glFunction) {
      this._program.setUniformValue(name, value, glFunction);
    }
  }, {
    key: "useProgram",
    value: function useProgram() {
      this._init();
      this.gl.useProgram(this.glProgram);
      this.beforeUsage();
      this.enableAttribs();
    }
  }, {
    key: "stopProgram",
    value: function stopProgram() {
      this.afterUsage();
      this.disableAttribs();
    }
  }, {
    key: "hasSameProgram",
    value: function hasSameProgram(other) {
      return other && (other === this || other._program === this._program);
    }
  }, {
    key: "beforeUsage",
    value: function beforeUsage() {}
  }, {
    key: "afterUsage",
    value: function afterUsage() {}
  }, {
    key: "enableAttribs",
    value: function enableAttribs() {}
  }, {
    key: "disableAttribs",
    value: function disableAttribs() {}
  }, {
    key: "getExtraAttribBytesPerVertex",
    value: function getExtraAttribBytesPerVertex() {
      return 0;
    }
  }, {
    key: "getVertexAttribPointerOffset",
    value: function getVertexAttribPointerOffset(operation) {
      return operation.extraAttribsDataByteOffset - operation.index * 4 * this.getExtraAttribBytesPerVertex();
    }
  }, {
    key: "setExtraAttribsInBuffer",
    value: function setExtraAttribsInBuffer(operation) {}
  }, {
    key: "setupUniforms",
    value: function setupUniforms(operation) {}
  }, {
    key: "_getProjection",
    value: function _getProjection(operation) {
      return operation.getProjection();
    }
  }, {
    key: "getFlipY",
    value: function getFlipY(operation) {
      return this._getProjection(operation)[1] < 0;
    }
  }, {
    key: "beforeDraw",
    value: function beforeDraw(operation) {}
  }, {
    key: "draw",
    value: function draw(operation) {}
  }, {
    key: "afterDraw",
    value: function afterDraw(operation) {}
  }, {
    key: "cleanup",
    value: function cleanup() {
      this._initialized = false;
    }
  }]);
  return WebGLShader;
}(Shader);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/renderer/webgl/shaders/DefaultShader.mjs





function DefaultShader_createSuper(t) { var r = DefaultShader_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function DefaultShader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (DefaultShader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var DefaultShader = function (_WebGLShader) {
  (0,inherits/* default */.Z)(DefaultShader, _WebGLShader);
  var _super = DefaultShader_createSuper(DefaultShader);
  function DefaultShader() {
    (0,classCallCheck/* default */.Z)(this, DefaultShader);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(DefaultShader, [{
    key: "enableAttribs",
    value: function enableAttribs() {
      var gl = this.gl;
      gl.vertexAttribPointer(this._attrib("aVertexPosition"), 2, gl.FLOAT, false, 20, 0);
      gl.enableVertexAttribArray(this._attrib("aVertexPosition"));
      if (this._attrib("aTextureCoord") !== -1) {
        gl.vertexAttribPointer(this._attrib("aTextureCoord"), 2, gl.FLOAT, false, 20, 2 * 4);
        gl.enableVertexAttribArray(this._attrib("aTextureCoord"));
      }
      if (this._attrib("aColor") !== -1) {
        gl.vertexAttribPointer(this._attrib("aColor"), 4, gl.UNSIGNED_BYTE, true, 20, 4 * 4);
        gl.enableVertexAttribArray(this._attrib("aColor"));
      }
    }
  }, {
    key: "disableAttribs",
    value: function disableAttribs() {
      var gl = this.gl;
      gl.disableVertexAttribArray(this._attrib("aVertexPosition"));
      if (this._attrib("aTextureCoord") !== -1) {
        gl.disableVertexAttribArray(this._attrib("aTextureCoord"));
      }
      if (this._attrib("aColor") !== -1) {
        gl.disableVertexAttribArray(this._attrib("aColor"));
      }
    }
  }, {
    key: "setupUniforms",
    value: function setupUniforms(operation) {
      this._setUniform("projection", this._getProjection(operation), this.gl.uniform2fv, false);
    }
  }, {
    key: "draw",
    value: function draw(operation) {
      var gl = this.gl;
      var length = operation.length;
      if (length) {
        var glTexture = operation.getTexture(0);
        var pos = 0;
        for (var i = 0; i < length; i++) {
          var tx = operation.getTexture(i);
          if (glTexture !== tx) {
            gl.bindTexture(gl.TEXTURE_2D, glTexture);
            gl.drawElements(gl.TRIANGLES, 6 * (i - pos), gl.UNSIGNED_SHORT, (pos + operation.index) * 6 * 2);
            glTexture = tx;
            pos = i;
          }
        }
        if (pos < length) {
          gl.bindTexture(gl.TEXTURE_2D, glTexture);
          gl.drawElements(gl.TRIANGLES, 6 * (length - pos), gl.UNSIGNED_SHORT, (pos + operation.index) * 6 * 2);
        }
      }
    }
  }]);
  return DefaultShader;
}(WebGLShader);

DefaultShader.vertexShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    attribute vec2 aVertexPosition;\n    attribute vec2 aTextureCoord;\n    attribute vec4 aColor;\n    uniform vec2 projection;\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    void main(void){\n        gl_Position = vec4(aVertexPosition.x * projection.x - 1.0, aVertexPosition.y * -abs(projection.y) + 1.0, 0.0, 1.0);\n        vTextureCoord = aTextureCoord;\n        vColor = aColor;\n        gl_Position.y = -sign(projection.y) * gl_Position.y;\n    }\n";
DefaultShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    uniform sampler2D uSampler;\n    void main(void){\n        gl_FragColor = texture2D(uSampler, vTextureCoord) * vColor;\n    }\n";
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/renderer/Renderer.mjs



var Renderer = function () {
  function Renderer(stage) {
    (0,classCallCheck/* default */.Z)(this, Renderer);
    this.stage = stage;
    this._defaultShader = undefined;
  }
  (0,createClass/* default */.Z)(Renderer, [{
    key: "gc",
    value: function gc(aggressive) {}
  }, {
    key: "destroy",
    value: function destroy() {}
  }, {
    key: "getDefaultShader",
    value: function getDefaultShader() {
      var ctx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.stage.ctx;
      if (!this._defaultShader) {
        this._defaultShader = this._createDefaultShader(ctx);
      }
      return this._defaultShader;
    }
  }, {
    key: "_createDefaultShader",
    value: function _createDefaultShader(ctx) {}
  }, {
    key: "isValidShaderType",
    value: function isValidShaderType(shaderType) {
      return shaderType.prototype instanceof this._getShaderBaseType();
    }
  }, {
    key: "createShader",
    value: function createShader(ctx, settings) {
      var shaderType = settings.type;
      if (!this.isValidShaderType(shaderType)) {
        var convertedShaderType = this._getShaderAlternative(shaderType);
        if (!convertedShaderType) {
          console.warn("[Lightning] Shader has no implementation for render target: " + shaderType.name);
          return this._createDefaultShader(ctx);
        }
        return new convertedShaderType(ctx);
      } else {
        var shader = new shaderType(ctx);
        Base.patchObject(this, settings);
        return shader;
      }
    }
  }, {
    key: "_getShaderBaseType",
    value: function _getShaderBaseType() {}
  }, {
    key: "_getShaderAlternative",
    value: function _getShaderAlternative(shaderType) {
      return this.getDefaultShader();
    }
  }, {
    key: "copyRenderTexture",
    value: function copyRenderTexture(renderTexture, nativeTexture, options) {
      console.warn('[Lightning] copyRenderTexture not supported by renderer');
    }
  }]);
  return Renderer;
}();


;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/renderer/webgl/WebGLRenderer.mjs




































function WebGLRenderer_createSuper(t) { var r = WebGLRenderer_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function WebGLRenderer_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (WebGLRenderer_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }









var WebGLRenderer = function (_Renderer) {
  (0,inherits/* default */.Z)(WebGLRenderer, _Renderer);
  var _super = WebGLRenderer_createSuper(WebGLRenderer);
  function WebGLRenderer(stage) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, WebGLRenderer);
    _this = _super.call(this, stage);
    _this.shaderPrograms = new Map();
    _this._compressedTextureExtensions = {
      astc: stage.gl.getExtension('WEBGL_compressed_texture_astc'),
      etc1: stage.gl.getExtension('WEBGL_compressed_texture_etc1'),
      s3tc: stage.gl.getExtension('WEBGL_compressed_texture_s3tc'),
      pvrtc: stage.gl.getExtension('WEBGL_compressed_texture_pvrtc')
    };
    return _this;
  }
  (0,createClass/* default */.Z)(WebGLRenderer, [{
    key: "getCompressedTextureExtensions",
    value: function getCompressedTextureExtensions() {
      return this._compressedTextureExtensions;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.shaderPrograms.forEach(function (shaderProgram) {
        return shaderProgram.destroy();
      });
    }
  }, {
    key: "_createDefaultShader",
    value: function _createDefaultShader(ctx) {
      return new DefaultShader(ctx);
    }
  }, {
    key: "_getShaderBaseType",
    value: function _getShaderBaseType() {
      return WebGLShader;
    }
  }, {
    key: "_getShaderAlternative",
    value: function _getShaderAlternative(shaderType) {
      return shaderType.getWebGL && shaderType.getWebGL();
    }
  }, {
    key: "createCoreQuadList",
    value: function createCoreQuadList(ctx) {
      return new WebGLCoreQuadList(ctx);
    }
  }, {
    key: "createCoreQuadOperation",
    value: function createCoreQuadOperation(ctx, shader, shaderOwner, renderTextureInfo, scissor, index) {
      return new WebGLCoreQuadOperation(ctx, shader, shaderOwner, renderTextureInfo, scissor, index);
    }
  }, {
    key: "createCoreRenderExecutor",
    value: function createCoreRenderExecutor(ctx) {
      return new WebGLCoreRenderExecutor(ctx);
    }
  }, {
    key: "createCoreRenderState",
    value: function createCoreRenderState(ctx) {
      return new CoreRenderState(ctx);
    }
  }, {
    key: "createRenderTexture",
    value: function createRenderTexture(w, h, pw, ph) {
      var gl = this.stage.gl;
      var glTexture = gl.createTexture();
      gl.bindTexture(gl.TEXTURE_2D, glTexture);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, pw, ph, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      glTexture.params = {};
      glTexture.params[gl.TEXTURE_MAG_FILTER] = gl.LINEAR;
      glTexture.params[gl.TEXTURE_MIN_FILTER] = gl.LINEAR;
      glTexture.params[gl.TEXTURE_WRAP_S] = gl.CLAMP_TO_EDGE;
      glTexture.params[gl.TEXTURE_WRAP_T] = gl.CLAMP_TO_EDGE;
      glTexture.options = {
        format: gl.RGBA,
        internalFormat: gl.RGBA,
        type: gl.UNSIGNED_BYTE
      };
      glTexture.framebuffer = gl.createFramebuffer();
      glTexture.projection = new Float32Array([2 / w, 2 / h]);
      gl.bindFramebuffer(gl.FRAMEBUFFER, glTexture.framebuffer);
      gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, glTexture, 0);
      return glTexture;
    }
  }, {
    key: "freeRenderTexture",
    value: function freeRenderTexture(glTexture) {
      var gl = this.stage.gl;
      gl.deleteFramebuffer(glTexture.framebuffer);
      gl.deleteTexture(glTexture);
    }
  }, {
    key: "_getBytesPerPixel",
    value: function _getBytesPerPixel(fmt, type) {
      var gl = this.stage.gl;
      if (fmt === gl.RGBA) {
        switch (type) {
          case gl.UNSIGNED_BYTE:
            return 4;
          case gl.UNSIGNED_SHORT_4_4_4_4:
            return 2;
          case gl.UNSIGNED_SHORT_5_5_5_1:
            return 2;
          default:
            throw new Error('Invalid type specified for GL_RGBA format');
        }
      } else if (fmt === gl.RGB) {
        switch (type) {
          case gl.UNSIGNED_BYTE:
            return 3;
          case gl.UNSIGNED_BYTE_5_6_5:
            return 2;
          default:
            throw new Error('Invalid type specified for GL_RGB format');
        }
      } else {
        throw new Error('Invalid format specified in call to _getBytesPerPixel()');
      }
    }
  }, {
    key: "uploadTextureSource",
    value: function uploadTextureSource(textureSource, options) {
      var gl = this.stage.gl;
      var source = options.source;
      var compressed = false;
      if (options.renderInfo) {
        compressed = options.renderInfo.compressed || false;
      }
      var format = {
        premultiplyAlpha: true,
        hasAlpha: true
      };
      if (options && options.hasOwnProperty('premultiplyAlpha')) {
        format.premultiplyAlpha = options.premultiplyAlpha;
      }
      if (options && options.hasOwnProperty('flipBlueRed')) {
        format.flipBlueRed = options.flipBlueRed;
      }
      if (options && options.hasOwnProperty('hasAlpha')) {
        format.hasAlpha = options.hasAlpha;
      }
      if (!format.hasAlpha) {
        format.premultiplyAlpha = false;
      }
      format.texParams = options.texParams || {};
      format.texOptions = options.texOptions || {};
      var glTexture = gl.createTexture();
      gl.bindTexture(gl.TEXTURE_2D, glTexture);
      gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, format.premultiplyAlpha);
      if (Utils_Utils.isNode) {
        gl.pixelStorei(gl.UNPACK_FLIP_BLUE_RED, !!format.flipBlueRed);
      }
      var texParams = format.texParams;
      if (!texParams[gl.TEXTURE_MAG_FILTER]) texParams[gl.TEXTURE_MAG_FILTER] = gl.LINEAR;
      if (!texParams[gl.TEXTURE_MIN_FILTER]) texParams[gl.TEXTURE_MIN_FILTER] = gl.LINEAR;
      if (!texParams[gl.TEXTURE_WRAP_S]) texParams[gl.TEXTURE_WRAP_S] = gl.CLAMP_TO_EDGE;
      if (!texParams[gl.TEXTURE_WRAP_T]) texParams[gl.TEXTURE_WRAP_T] = gl.CLAMP_TO_EDGE;
      Object.keys(texParams).forEach(function (key) {
        var value = texParams[key];
        gl.texParameteri(gl.TEXTURE_2D, parseInt(key), value);
      });
      if (compressed) {
        this.stage.platform.uploadCompressedGlTexture(gl, textureSource, source);
        return glTexture;
      }
      var texOptions = format.texOptions;
      texOptions.format = texOptions.format || (format.hasAlpha ? gl.RGBA : gl.RGB);
      texOptions.type = texOptions.type || gl.UNSIGNED_BYTE;
      texOptions.internalFormat = texOptions.internalFormat || texOptions.format;
      if (options && options.imageRef) {
        texOptions.imageRef = options.imageRef;
      }
      this.stage.platform.uploadGlTexture(gl, textureSource, source, texOptions);
      glTexture.params = Utils_Utils.cloneObjShallow(texParams);
      glTexture.options = Utils_Utils.cloneObjShallow(texOptions);
      glTexture.bytesPerPixel = this._getBytesPerPixel(texOptions.format, texOptions.type);
      return glTexture;
    }
  }, {
    key: "freeTextureSource",
    value: function freeTextureSource(textureSource) {
      this.stage.gl.deleteTexture(textureSource.nativeTexture);
    }
  }, {
    key: "addQuad",
    value: function addQuad(renderState, quads, index) {
      var offset = index * 20;
      var elementCore = quads.quadElements[index];
      var r = elementCore._renderContext;
      var floats = renderState.quads.floats;
      var uints = renderState.quads.uints;
      var mca = StageUtils.mergeColorAlpha;
      if (r.tb !== 0 || r.tc !== 0) {
        floats[offset++] = r.px;
        floats[offset++] = r.py;
        floats[offset++] = elementCore._ulx;
        floats[offset++] = elementCore._uly;
        uints[offset++] = mca(elementCore._colorUl, r.alpha);
        floats[offset++] = r.px + elementCore._w * r.ta;
        floats[offset++] = r.py + elementCore._w * r.tc;
        floats[offset++] = elementCore._brx;
        floats[offset++] = elementCore._uly;
        uints[offset++] = mca(elementCore._colorUr, r.alpha);
        floats[offset++] = r.px + elementCore._w * r.ta + elementCore._h * r.tb;
        floats[offset++] = r.py + elementCore._w * r.tc + elementCore._h * r.td;
        floats[offset++] = elementCore._brx;
        floats[offset++] = elementCore._bry;
        uints[offset++] = mca(elementCore._colorBr, r.alpha);
        floats[offset++] = r.px + elementCore._h * r.tb;
        floats[offset++] = r.py + elementCore._h * r.td;
        floats[offset++] = elementCore._ulx;
        floats[offset++] = elementCore._bry;
        uints[offset] = mca(elementCore._colorBl, r.alpha);
      } else {
        var cx = r.px + elementCore._w * r.ta;
        var cy = r.py + elementCore._h * r.td;
        floats[offset++] = r.px;
        floats[offset++] = r.py;
        floats[offset++] = elementCore._ulx;
        floats[offset++] = elementCore._uly;
        uints[offset++] = mca(elementCore._colorUl, r.alpha);
        floats[offset++] = cx;
        floats[offset++] = r.py;
        floats[offset++] = elementCore._brx;
        floats[offset++] = elementCore._uly;
        uints[offset++] = mca(elementCore._colorUr, r.alpha);
        floats[offset++] = cx;
        floats[offset++] = cy;
        floats[offset++] = elementCore._brx;
        floats[offset++] = elementCore._bry;
        uints[offset++] = mca(elementCore._colorBr, r.alpha);
        floats[offset++] = r.px;
        floats[offset++] = cy;
        floats[offset++] = elementCore._ulx;
        floats[offset++] = elementCore._bry;
        uints[offset] = mca(elementCore._colorBl, r.alpha);
      }
    }
  }, {
    key: "isRenderTextureReusable",
    value: function isRenderTextureReusable(renderState, renderTextureInfo) {
      var offset = renderState._renderTextureInfo.offset * 80 / 4;
      var floats = renderState.quads.floats;
      var uints = renderState.quads.uints;
      return floats[offset] === 0 && floats[offset + 1] === 0 && floats[offset + 2] === 0 && floats[offset + 3] === 0 && uints[offset + 4] === 0xFFFFFFFF && floats[offset + 5] === renderTextureInfo.w && floats[offset + 6] === 0 && floats[offset + 7] === 1 && floats[offset + 8] === 0 && uints[offset + 9] === 0xFFFFFFFF && floats[offset + 10] === renderTextureInfo.w && floats[offset + 11] === renderTextureInfo.h && floats[offset + 12] === 1 && floats[offset + 13] === 1 && uints[offset + 14] === 0xFFFFFFFF && floats[offset + 15] === 0 && floats[offset + 16] === renderTextureInfo.h && floats[offset + 17] === 0 && floats[offset + 18] === 1 && uints[offset + 19] === 0xFFFFFFFF;
    }
  }, {
    key: "finishRenderState",
    value: function finishRenderState(renderState) {
      var offset = renderState.length * 80;
      for (var i = 0, n = renderState.quadOperations.length; i < n; i++) {
        renderState.quadOperations[i].extraAttribsDataByteOffset = offset;
        var extra = renderState.quadOperations[i].shader.getExtraAttribBytesPerVertex() * 4 * renderState.quadOperations[i].length;
        offset += extra;
        if (extra) {
          renderState.quadOperations[i].shader.setExtraAttribsInBuffer(renderState.quadOperations[i], renderState.quads);
        }
      }
      renderState.quads.dataLength = offset;
    }
  }, {
    key: "copyRenderTexture",
    value: function copyRenderTexture(renderTexture, nativeTexture, options) {
      var gl = this.stage.gl;
      gl.bindTexture(gl.TEXTURE_2D, nativeTexture);
      gl.bindFramebuffer(gl.FRAMEBUFFER, renderTexture.framebuffer);
      var precision = renderTexture.precision;
      gl.copyTexSubImage2D(gl.TEXTURE_2D, 0, precision * (options.sx || 0), precision * (options.sy || 0), precision * (options.x || 0), precision * (options.y || 0), precision * (options.w || renderTexture.ow), precision * (options.h || renderTexture.oh));
    }
  }]);
  return WebGLRenderer;
}(Renderer);

// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.typed-array.uint8-clamped-array.js
var es_typed_array_uint8_clamped_array = __webpack_require__(80229);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/renderer/c2d/C2dCoreQuadList.mjs





function C2dCoreQuadList_createSuper(t) { var r = C2dCoreQuadList_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function C2dCoreQuadList_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (C2dCoreQuadList_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var C2dCoreQuadList = function (_CoreQuadList) {
  (0,inherits/* default */.Z)(C2dCoreQuadList, _CoreQuadList);
  var _super = C2dCoreQuadList_createSuper(C2dCoreQuadList);
  function C2dCoreQuadList(ctx) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, C2dCoreQuadList);
    _this = _super.call(this, ctx);
    _this.renderContexts = [];
    _this.modes = [];
    return _this;
  }
  (0,createClass/* default */.Z)(C2dCoreQuadList, [{
    key: "setRenderContext",
    value: function setRenderContext(index, v) {
      this.renderContexts[index] = v;
    }
  }, {
    key: "setSimpleTc",
    value: function setSimpleTc(index, v) {
      if (v) {
        this.modes[index] |= 1;
      } else {
        this.modes[index] -= this.modes[index] & 1;
      }
    }
  }, {
    key: "setWhite",
    value: function setWhite(index, v) {
      if (v) {
        this.modes[index] |= 2;
      } else {
        this.modes[index] -= this.modes[index] & 2;
      }
    }
  }, {
    key: "getRenderContext",
    value: function getRenderContext(index) {
      return this.renderContexts[index];
    }
  }, {
    key: "getSimpleTc",
    value: function getSimpleTc(index) {
      return this.modes[index] & 1;
    }
  }, {
    key: "getWhite",
    value: function getWhite(index) {
      return this.modes[index] & 2;
    }
  }]);
  return C2dCoreQuadList;
}(CoreQuadList);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/renderer/c2d/C2dCoreQuadOperation.mjs





function C2dCoreQuadOperation_createSuper(t) { var r = C2dCoreQuadOperation_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function C2dCoreQuadOperation_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (C2dCoreQuadOperation_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var C2dCoreQuadOperation = function (_CoreQuadOperation) {
  (0,inherits/* default */.Z)(C2dCoreQuadOperation, _CoreQuadOperation);
  var _super = C2dCoreQuadOperation_createSuper(C2dCoreQuadOperation);
  function C2dCoreQuadOperation() {
    (0,classCallCheck/* default */.Z)(this, C2dCoreQuadOperation);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(C2dCoreQuadOperation, [{
    key: "getRenderContext",
    value: function getRenderContext(index) {
      return this.quads.getRenderContext(this.index + index);
    }
  }, {
    key: "getSimpleTc",
    value: function getSimpleTc(index) {
      return this.quads.getSimpleTc(this.index + index);
    }
  }, {
    key: "getWhite",
    value: function getWhite(index) {
      return this.quads.getWhite(this.index + index);
    }
  }]);
  return C2dCoreQuadOperation;
}(CoreQuadOperation);

// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.array.fill.js
var es_array_fill = __webpack_require__(86100);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/renderer/c2d/C2dCoreRenderExecutor.mjs






function C2dCoreRenderExecutor_createSuper(t) { var r = C2dCoreRenderExecutor_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function C2dCoreRenderExecutor_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (C2dCoreRenderExecutor_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }



var C2dCoreRenderExecutor = function (_CoreRenderExecutor) {
  (0,inherits/* default */.Z)(C2dCoreRenderExecutor, _CoreRenderExecutor);
  var _super = C2dCoreRenderExecutor_createSuper(C2dCoreRenderExecutor);
  function C2dCoreRenderExecutor() {
    (0,classCallCheck/* default */.Z)(this, C2dCoreRenderExecutor);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(C2dCoreRenderExecutor, [{
    key: "init",
    value: function init() {
      this._mainRenderTexture = this.ctx.stage.getCanvas();
    }
  }, {
    key: "_renderQuadOperation",
    value: function _renderQuadOperation(op) {
      var shader = op.shader;
      if (op.length || op.shader.addEmpty()) {
        var target = this._renderTexture || this._mainRenderTexture;
        shader.beforeDraw(op, target);
        shader.draw(op, target);
        shader.afterDraw(op, target);
      }
    }
  }, {
    key: "_clearRenderTexture",
    value: function _clearRenderTexture() {
      var ctx = this._getContext();
      var clearColor = [0, 0, 0, 0];
      if (this._mainRenderTexture.ctx === ctx) {
        clearColor = this.ctx.stage.getClearColor();
      }
      var renderTexture = ctx.canvas;
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      if (!clearColor[0] && !clearColor[1] && !clearColor[2] && !clearColor[3]) {
        ctx.clearRect(0, 0, renderTexture.width, renderTexture.height);
      } else {
        ctx.fillStyle = StageUtils.getRgbaStringFromArray(clearColor);
        ctx.globalCompositeOperation = 'copy';
        ctx.beginPath();
        ctx.rect(0, 0, renderTexture.width, renderTexture.height);
        ctx.closePath();
        ctx.fill();
        ctx.globalCompositeOperation = 'source-over';
      }
    }
  }, {
    key: "_getContext",
    value: function _getContext() {
      if (this._renderTexture) {
        return this._renderTexture.ctx;
      } else {
        return this._mainRenderTexture.ctx;
      }
    }
  }, {
    key: "_restoreContext",
    value: function _restoreContext() {
      var ctx = this._getContext();
      ctx.restore();
      ctx.save();
      ctx._scissor = null;
    }
  }, {
    key: "_setScissor",
    value: function _setScissor(area) {
      var ctx = this._getContext();
      if (!C2dCoreRenderExecutor._equalScissorAreas(ctx.canvas, ctx._scissor, area)) {
        this._restoreContext();
        var precision = this.ctx.stage.getRenderPrecision();
        if (area) {
          ctx.beginPath();
          ctx.rect(Math.round(area[0] * precision), Math.round(area[1] * precision), Math.round(area[2] * precision), Math.round(area[3] * precision));
          ctx.closePath();
          ctx.clip();
        }
        ctx._scissor = area;
      }
    }
  }], [{
    key: "_equalScissorAreas",
    value: function _equalScissorAreas(canvas, area, current) {
      if (!area) {
        area = [0, 0, canvas.width, canvas.height];
      }
      if (!current) {
        current = [0, 0, canvas.width, canvas.height];
      }
      return Utils_Utils.equalValues(area, current);
    }
  }]);
  return C2dCoreRenderExecutor;
}(CoreRenderExecutor);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/renderer/c2d/C2dShader.mjs





function C2dShader_createSuper(t) { var r = C2dShader_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function C2dShader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (C2dShader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var C2dShader = function (_Shader) {
  (0,inherits/* default */.Z)(C2dShader, _Shader);
  var _super = C2dShader_createSuper(C2dShader);
  function C2dShader() {
    (0,classCallCheck/* default */.Z)(this, C2dShader);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(C2dShader, [{
    key: "beforeDraw",
    value: function beforeDraw(operation) {}
  }, {
    key: "draw",
    value: function draw(operation) {}
  }, {
    key: "afterDraw",
    value: function afterDraw(operation) {}
  }]);
  return C2dShader;
}(Shader);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/renderer/c2d/shaders/DefaultShader.mjs





function shaders_DefaultShader_createSuper(t) { var r = shaders_DefaultShader_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function shaders_DefaultShader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (shaders_DefaultShader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }


var DefaultShader_DefaultShader = function (_C2dShader) {
  (0,inherits/* default */.Z)(DefaultShader, _C2dShader);
  var _super = shaders_DefaultShader_createSuper(DefaultShader);
  function DefaultShader(ctx) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, DefaultShader);
    _this = _super.call(this, ctx);
    _this._rectangleTexture = ctx.stage.rectangleTexture.source.nativeTexture;
    _this._tintManager = _this.ctx.stage.renderer.tintManager;
    return _this;
  }
  (0,createClass/* default */.Z)(DefaultShader, [{
    key: "draw",
    value: function draw(operation, target) {
      var ctx = target.ctx;
      var length = operation.length;
      for (var i = 0; i < length; i++) {
        var tx = operation.getTexture(i);
        var vc = operation.getElementCore(i);
        var rc = operation.getRenderContext(i);
        var white = operation.getWhite(i);
        var stc = operation.getSimpleTc(i);
        var precision = this.ctx.stage.getRenderPrecision();
        ctx.setTransform(rc.ta * precision, rc.tc * precision, rc.tb * precision, rc.td * precision, rc.px * precision, rc.py * precision);
        var rect = tx === this._rectangleTexture;
        var info = {
          operation: operation,
          target: target,
          index: i,
          rect: rect
        };
        if (rect) {
          if (white) {
            ctx.fillStyle = 'white';
          } else {
            this._setColorGradient(ctx, vc);
          }
          ctx.globalAlpha = rc.alpha;
          this._beforeDrawEl(info);
          ctx.fillRect(0, 0, vc.w, vc.h);
          this._afterDrawEl(info);
          ctx.globalAlpha = 1.0;
        } else {
          ctx.globalAlpha = rc.alpha;
          this._beforeDrawEl(info);
          var sourceX = stc ? 0 : vc._ulx * tx.w;
          var sourceY = stc ? 0 : vc._uly * tx.h;
          var sourceW = (stc ? 1 : vc._brx - vc._ulx) * tx.w;
          var sourceH = (stc ? 1 : vc._bry - vc._uly) * tx.h;
          var colorize = !white;
          if (colorize) {
            var color = vc._colorUl;
            if (vc._colorUl !== vc._colorUr || vc._colorUr !== vc._colorBl || vc._colorBr !== vc._colorBl) {
              color = StageUtils.mergeMultiColorsEqual([vc._colorUl, vc._colorUr, vc._colorBl, vc._colorBr]);
            }
            var alpha = (color / 16777216 | 0) / 255.0;
            ctx.globalAlpha *= alpha;
            var rgb = color & 0x00FFFFFF;
            var tintTexture = this._tintManager.getTintTexture(tx, rgb);
            ctx.fillStyle = 'white';
            ctx.drawImage(tintTexture, sourceX, sourceY, sourceW, sourceH, 0, 0, vc.w, vc.h);
          } else {
            ctx.fillStyle = 'white';
            ctx.drawImage(tx, sourceX, sourceY, sourceW, sourceH, 0, 0, vc.w, vc.h);
          }
          this._afterDrawEl(info);
          ctx.globalAlpha = 1.0;
        }
      }
    }
  }, {
    key: "_setColorGradient",
    value: function _setColorGradient(ctx, vc) {
      var w = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : vc.w;
      var h = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : vc.h;
      var transparency = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
      var color = vc._colorUl;
      var gradient;
      if (vc._colorUl === vc._colorUr) {
        if (vc._colorBl === vc._colorBr) {
          if (vc._colorUl === vc.colorBl) {} else {
            gradient = ctx.createLinearGradient(0, 0, 0, h);
            if (transparency) {
              gradient.addColorStop(0, StageUtils.getRgbaString(vc._colorUl));
              gradient.addColorStop(1, StageUtils.getRgbaString(vc._colorBl));
            } else {
              gradient.addColorStop(0, StageUtils.getRgbString(vc._colorUl));
              gradient.addColorStop(1, StageUtils.getRgbString(vc._colorBl));
            }
          }
        } else {}
      } else {
        if (vc._colorUl === vc._colorBl && vc._colorUr === vc._colorBr) {
          gradient = ctx.createLinearGradient(0, 0, w, 0);
          if (transparency) {
            gradient.addColorStop(0, StageUtils.getRgbaString(vc._colorUl));
            gradient.addColorStop(1, StageUtils.getRgbaString(vc._colorBr));
          } else {
            gradient.addColorStop(0, StageUtils.getRgbString(vc._colorUl));
            gradient.addColorStop(1, StageUtils.getRgbString(vc._colorBr));
          }
        }
      }
      if (gradient) {
        ctx.fillStyle = gradient;
      } else {
        ctx.fillStyle = transparency ? StageUtils.getRgbaString(color) : StageUtils.getRgbString(color);
      }
    }
  }, {
    key: "_beforeDrawEl",
    value: function _beforeDrawEl(info) {}
  }, {
    key: "_afterDrawEl",
    value: function _afterDrawEl(info) {}
  }]);
  return DefaultShader;
}(C2dShader);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/renderer/c2d/C2dTextureTintManager.mjs










var C2dTextureTintManager = function () {
  function C2dTextureTintManager(stage) {
    (0,classCallCheck/* default */.Z)(this, C2dTextureTintManager);
    this.stage = stage;
    this._usedMemory = 0;
    this._cachedNativeTextures = new Set();
  }
  (0,createClass/* default */.Z)(C2dTextureTintManager, [{
    key: "destroy",
    value: function destroy() {
      this.gc(true);
    }
  }, {
    key: "_addMemoryUsage",
    value: function _addMemoryUsage(delta) {
      this._usedMemory += delta;
      this.stage.addMemoryUsage(delta);
    }
  }, {
    key: "delete",
    value: function _delete(nativeTexture) {
      if (this._hasCache(nativeTexture)) {
        var cache = this._getCache(nativeTexture);
        var prevMemUsage = cache.memoryUsage;
        cache.clear();
        this._cachedNativeTextures.delete(nativeTexture);
        this._addMemoryUsage(cache.memoryUsage - prevMemUsage);
      }
    }
  }, {
    key: "getTintTexture",
    value: function getTintTexture(nativeTexture, color) {
      var frame = this.stage.frameCounter;
      this._cachedNativeTextures.add(nativeTexture);
      var cache = this._getCache(nativeTexture);
      var item = cache.get(color);
      item.lf = frame;
      if (item.tx) {
        if (nativeTexture.update > item.u) {
          this._tintTexture(item.tx, nativeTexture, color);
        }
        return item.tx;
      } else {
        var before = cache.memoryUsage;
        var target = cache.reuseTexture(frame);
        if (target) {
          target.ctx.clearRect(0, 0, target.width, target.height);
        } else {
          target = document.createElement('canvas');
          target.width = nativeTexture.w;
          target.height = nativeTexture.h;
          target.ctx = target.getContext('2d');
        }
        this._tintTexture(target, nativeTexture, color);
        cache.set(color, target, frame);
        var after = cache.memoryUsage;
        if (after !== before) {
          this._addMemoryUsage(after - before);
        }
        return target;
      }
    }
  }, {
    key: "_tintTexture",
    value: function _tintTexture(target, source, color) {
      var col = color.toString(16);
      while (col.length < 6) {
        col = "0" + col;
      }
      target.ctx.fillStyle = '#' + col;
      target.ctx.globalCompositeOperation = 'copy';
      target.ctx.fillRect(0, 0, source.w, source.h);
      target.ctx.globalCompositeOperation = 'multiply';
      target.ctx.drawImage(source, 0, 0, source.w, source.h, 0, 0, target.width, target.height);
      target.ctx.globalCompositeOperation = 'destination-in';
      target.ctx.drawImage(source, 0, 0, source.w, source.h, 0, 0, target.width, target.height);
    }
  }, {
    key: "_hasCache",
    value: function _hasCache(nativeTexture) {
      return !!nativeTexture._tintCache;
    }
  }, {
    key: "_getCache",
    value: function _getCache(nativeTexture) {
      if (!nativeTexture._tintCache) {
        nativeTexture._tintCache = new C2dTintCache(nativeTexture);
      }
      return nativeTexture._tintCache;
    }
  }, {
    key: "gc",
    value: function gc() {
      var _this = this;
      var aggressive = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var frame = this.stage.frameCounter;
      var delta = 0;
      this._cachedNativeTextures.forEach(function (texture) {
        var cache = _this._getCache(texture);
        if (aggressive) {
          delta += cache.memoryUsage;
          cache.clear();
        } else {
          var before = cache.memoryUsage;
          cache.cleanup(frame);
          cache.releaseBlancoTextures();
          delta += cache.memoryUsage - before;
        }
      });
      if (aggressive) {
        this._cachedNativeTextures.clear();
      }
      if (delta) {
        this._addMemoryUsage(delta);
      }
    }
  }]);
  return C2dTextureTintManager;
}();

var C2dTintCache = function () {
  function C2dTintCache(nativeTexture) {
    (0,classCallCheck/* default */.Z)(this, C2dTintCache);
    this._tx = nativeTexture;
    this._colors = new Map();
    this._blancoTextures = null;
    this._lastCleanupFrame = 0;
    this._memTextures = 0;
  }
  (0,createClass/* default */.Z)(C2dTintCache, [{
    key: "memoryUsage",
    get: function get() {
      return this._memTextures * this._tx.w * this._tx.h;
    }
  }, {
    key: "releaseBlancoTextures",
    value: function releaseBlancoTextures() {
      this._memTextures -= this._blancoTextures.length;
      this._blancoTextures = [];
    }
  }, {
    key: "clear",
    value: function clear() {
      this._blancoTextures = null;
      this._colors.clear();
      this._memTextures = 0;
    }
  }, {
    key: "get",
    value: function get(color) {
      var item = this._colors.get(color);
      if (!item) {
        item = {
          lf: -1,
          tx: undefined,
          u: -1
        };
        this._colors.set(color, item);
      }
      return item;
    }
  }, {
    key: "set",
    value: function set(color, texture, frame) {
      var item = this.get(color);
      item.lf = frame;
      item.tx = texture;
      item.u = frame;
      this._memTextures++;
    }
  }, {
    key: "cleanup",
    value: function cleanup(frame) {
      var _this2 = this;
      if (this._lastCleanupFrame !== frame) {
        this._blancoTextures = [];
        this._colors.forEach(function (item, color) {
          if (item.lf < frame - 1) {
            if (item.tx) {
              _this2._blancoTextures.push(item.tx);
            }
            _this2._colors.delete(color);
          }
        });
        this._lastCleanupFrame = frame;
      }
    }
  }, {
    key: "reuseTexture",
    value: function reuseTexture(frame) {
      this.cleanup(frame);
      if (this._blancoTextures && this._blancoTextures.length) {
        this._memTextures--;
        return this._blancoTextures.pop();
      }
    }
  }]);
  return C2dTintCache;
}();
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/renderer/c2d/C2dRenderer.mjs































function C2dRenderer_createSuper(t) { var r = C2dRenderer_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function C2dRenderer_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (C2dRenderer_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }








var C2dRenderer = function (_Renderer) {
  (0,inherits/* default */.Z)(C2dRenderer, _Renderer);
  var _super = C2dRenderer_createSuper(C2dRenderer);
  function C2dRenderer(stage) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, C2dRenderer);
    _this = _super.call(this, stage);
    _this.tintManager = new C2dTextureTintManager(stage);
    _this.setupC2d(_this.stage.c2d.canvas);
    return _this;
  }
  (0,createClass/* default */.Z)(C2dRenderer, [{
    key: "destroy",
    value: function destroy() {
      this.tintManager.destroy();
    }
  }, {
    key: "_createDefaultShader",
    value: function _createDefaultShader(ctx) {
      return new DefaultShader_DefaultShader(ctx);
    }
  }, {
    key: "_getShaderBaseType",
    value: function _getShaderBaseType() {
      return C2dShader;
    }
  }, {
    key: "_getShaderAlternative",
    value: function _getShaderAlternative(shaderType) {
      return shaderType.getC2d && shaderType.getC2d();
    }
  }, {
    key: "createCoreQuadList",
    value: function createCoreQuadList(ctx) {
      return new C2dCoreQuadList(ctx);
    }
  }, {
    key: "createCoreQuadOperation",
    value: function createCoreQuadOperation(ctx, shader, shaderOwner, renderTextureInfo, scissor, index) {
      return new C2dCoreQuadOperation(ctx, shader, shaderOwner, renderTextureInfo, scissor, index);
    }
  }, {
    key: "createCoreRenderExecutor",
    value: function createCoreRenderExecutor(ctx) {
      return new C2dCoreRenderExecutor(ctx);
    }
  }, {
    key: "createCoreRenderState",
    value: function createCoreRenderState(ctx) {
      return new CoreRenderState(ctx);
    }
  }, {
    key: "createRenderTexture",
    value: function createRenderTexture(w, h, pw, ph) {
      var canvas = document.createElement('canvas');
      canvas.width = pw;
      canvas.height = ph;
      this.setupC2d(canvas);
      return canvas;
    }
  }, {
    key: "freeRenderTexture",
    value: function freeRenderTexture(nativeTexture) {
      this.tintManager.delete(nativeTexture);
    }
  }, {
    key: "gc",
    value: function gc(aggressive) {
      this.tintManager.gc(aggressive);
    }
  }, {
    key: "uploadTextureSource",
    value: function uploadTextureSource(textureSource, options) {
      if (options.source.buffer) {
        var canvas = document.createElement('canvas');
        canvas.width = options.w;
        canvas.height = options.h;
        var imageData = new ImageData(new Uint8ClampedArray(options.source.buffer), options.w, options.h);
        canvas.getContext('2d').putImageData(imageData, 0, 0);
        return canvas;
      }
      return options.source;
    }
  }, {
    key: "freeTextureSource",
    value: function freeTextureSource(textureSource) {
      this.tintManager.delete(textureSource.nativeTexture);
    }
  }, {
    key: "addQuad",
    value: function addQuad(renderState, quads, index) {
      var elementCore = quads.quadElements[index];
      quads.setRenderContext(index, elementCore._renderContext);
      quads.setWhite(index, elementCore.isWhite());
      quads.setSimpleTc(index, elementCore.hasSimpleTexCoords());
    }
  }, {
    key: "isRenderTextureReusable",
    value: function isRenderTextureReusable(renderState, renderTextureInfo) {
      return false;
    }
  }, {
    key: "finishRenderState",
    value: function finishRenderState(renderState) {}
  }, {
    key: "setupC2d",
    value: function setupC2d(canvas) {
      var ctx = canvas.getContext('2d');
      canvas.ctx = ctx;
      ctx._scissor = null;
      canvas.ctx.save();
    }
  }]);
  return C2dRenderer;
}(Renderer);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/renderer/spark/shaders/SparkShader.mjs





function SparkShader_createSuper(t) { var r = SparkShader_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function SparkShader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (SparkShader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var SparkShader = function (_WebGLShader) {
  (0,inherits/* default */.Z)(SparkShader, _WebGLShader);
  var _super = SparkShader_createSuper(SparkShader);
  function SparkShader() {
    (0,classCallCheck/* default */.Z)(this, SparkShader);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(SparkShader, [{
    key: "enableAttribs",
    value: function enableAttribs() {
      var gl = this.gl;
      gl.vertexAttribPointer(this._attrib("aVertexPosition"), 2, gl.FLOAT, false, 20, 0);
      gl.enableVertexAttribArray(this._attrib("aVertexPosition"));
      if (this._attrib("aTextureCoord") !== -1) {
        gl.vertexAttribPointer(this._attrib("aTextureCoord"), 2, gl.FLOAT, false, 20, 2 * 4);
        gl.enableVertexAttribArray(this._attrib("aTextureCoord"));
      }
      if (this._attrib("aColor") !== -1) {
        gl.vertexAttribPointer(this._attrib("aColor"), 4, gl.UNSIGNED_BYTE, true, 20, 4 * 4);
        gl.enableVertexAttribArray(this._attrib("aColor"));
      }
    }
  }, {
    key: "disableAttribs",
    value: function disableAttribs() {
      var gl = this.gl;
      gl.disableVertexAttribArray(this._attrib("aVertexPosition"));
      if (this._attrib("aTextureCoord") !== -1) {
        gl.disableVertexAttribArray(this._attrib("aTextureCoord"));
      }
      if (this._attrib("aColor") !== -1) {
        gl.disableVertexAttribArray(this._attrib("aColor"));
      }
    }
  }, {
    key: "setupUniforms",
    value: function setupUniforms(operation) {
      this._setUniform("projection", this._getProjection(operation), this.gl.uniform2fv, false);
    }
  }, {
    key: "draw",
    value: function draw(operation) {
      var gl = this.gl;
      var length = operation.length;
      if (length) {
        var glTexture = operation.getTexture(0);
        var pos = 0;
        for (var i = 0; i < length; i++) {
          var tx = operation.getTexture(i);
          if (glTexture !== tx) {
            if (glTexture.options && glTexture.options.imageRef) {
              var elementPostion = i > 0 ? i - 1 : i;
              var precision = this.ctx.stage.getOption('precision');
              var vc = operation.getElementCore(elementPostion);
              this.ctx.stage.platform.paint(gl, glTexture.options.imageRef, vc._worldContext.px * precision, vc._worldContext.py * precision, vc._colorUl, vc);
            } else {
              gl.bindTexture(gl.TEXTURE_2D, glTexture);
              gl.drawElements(gl.TRIANGLES, 6 * (i - pos), gl.UNSIGNED_SHORT, (pos + operation.index) * 6 * 2);
            }
            glTexture = tx;
            pos = i;
          }
        }
        if (pos < length) {
          if (glTexture.options && glTexture.options.imageRef) {
            var _precision = this.ctx.stage.getOption('precision');
            var _vc = operation.getElementCore(pos);
            this.ctx.stage.platform.paint(gl, glTexture.options.imageRef, _vc._worldContext.px * _precision, _vc._worldContext.py * _precision, _vc._colorUl, _vc);
          } else {
            gl.bindTexture(gl.TEXTURE_2D, glTexture);
            gl.drawElements(gl.TRIANGLES, 6 * (length - pos), gl.UNSIGNED_SHORT, (pos + operation.index) * 6 * 2);
          }
        }
      }
    }
  }]);
  return SparkShader;
}(WebGLShader);

SparkShader.vertexShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    attribute vec2 aVertexPosition;\n    attribute vec2 aTextureCoord;\n    attribute vec4 aColor;\n    uniform vec2 projection;\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    void main(void){\n        gl_Position = vec4(aVertexPosition.x * projection.x - 1.0, aVertexPosition.y * -abs(projection.y) + 1.0, 0.0, 1.0);\n        vTextureCoord = aTextureCoord;\n        vColor = aColor;\n        gl_Position.y = -sign(projection.y) * gl_Position.y;\n    }\n";
SparkShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    uniform sampler2D uSampler;\n    void main(void){\n        gl_FragColor = texture2D(uSampler, vTextureCoord) * vColor;\n    }\n";
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/renderer/spark/SparkRenderer.mjs






function SparkRenderer_createSuper(t) { var r = SparkRenderer_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function SparkRenderer_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (SparkRenderer_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }


var SparkRenderer = function (_WebGLRenderer) {
  (0,inherits/* default */.Z)(SparkRenderer, _WebGLRenderer);
  var _super = SparkRenderer_createSuper(SparkRenderer);
  function SparkRenderer(stage) {
    (0,classCallCheck/* default */.Z)(this, SparkRenderer);
    return _super.call(this, stage);
  }
  (0,createClass/* default */.Z)(SparkRenderer, [{
    key: "_createDefaultShader",
    value: function _createDefaultShader(ctx) {
      return new SparkShader(ctx);
    }
  }, {
    key: "createCoreRenderExecutor",
    value: function createCoreRenderExecutor(ctx) {
      global.beginDrawing();
      var ret = (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(SparkRenderer.prototype), "createCoreRenderExecutor", this).call(this, ctx);
      global.endDrawing();
      return ret;
    }
  }]);
  return SparkRenderer;
}(WebGLRenderer);

// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__(93485);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__(42578);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__(94978);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.typed-array.int32-array.js
var es_typed_array_int32_array = __webpack_require__(11721);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.typed-array.uint8-array.js
var es_typed_array_uint8_array = __webpack_require__(82463);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/platforms/browser/ImageWorker.mjs













var ImageWorker = function () {
  function ImageWorker() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0,classCallCheck/* default */.Z)(this, ImageWorker);
    this._items = new Map();
    this._id = 0;
    this._initWorker();
  }
  (0,createClass/* default */.Z)(ImageWorker, [{
    key: "destroy",
    value: function destroy() {
      if (this._worker) {
        this._worker.terminate();
      }
    }
  }, {
    key: "_initWorker",
    value: function _initWorker() {
      var _this = this;
      var code = "(".concat(createWorker.toString(), ")()");
      var blob = new Blob([code.replace('"use strict";', '')]);
      var blobURL = (window.URL ? URL : webkitURL).createObjectURL(blob, {
        type: 'application/javascript; charset=utf-8'
      });
      this._worker = new Worker(blobURL);
      this._worker.postMessage({
        type: 'config',
        config: {
          path: window.location.href,
          protocol: window.location.protocol
        }
      });
      this._worker.onmessage = function (e) {
        if (e.data && e.data.id) {
          var id = e.data.id;
          var item = _this._items.get(id);
          if (item) {
            if (e.data.type == 'data') {
              _this.finish(item, e.data.info);
            } else {
              _this.error(item, e.data.info);
            }
          }
        }
      };
    }
  }, {
    key: "create",
    value: function create(src) {
      var id = ++this._id;
      var item = new ImageWorkerImage(this, id, src);
      this._items.set(id, item);
      this._worker.postMessage({
        type: "add",
        id: id,
        src: src
      });
      return item;
    }
  }, {
    key: "cancel",
    value: function cancel(image) {
      this._worker.postMessage({
        type: "cancel",
        id: image.id
      });
      this._items.delete(image.id);
    }
  }, {
    key: "error",
    value: function error(image, info) {
      image.error(info);
      this._items.delete(image.id);
    }
  }, {
    key: "finish",
    value: function finish(image, info) {
      image.load(info);
      this._items.delete(image.id);
    }
  }]);
  return ImageWorker;
}();

var ImageWorkerImage = function () {
  function ImageWorkerImage(manager, id, src) {
    (0,classCallCheck/* default */.Z)(this, ImageWorkerImage);
    this._manager = manager;
    this._id = id;
    this._src = src;
    this._onError = null;
    this._onLoad = null;
  }
  (0,createClass/* default */.Z)(ImageWorkerImage, [{
    key: "id",
    get: function get() {
      return this._id;
    }
  }, {
    key: "src",
    get: function get() {
      return this._src;
    }
  }, {
    key: "onError",
    set: function set(f) {
      this._onError = f;
    }
  }, {
    key: "onLoad",
    set: function set(f) {
      this._onLoad = f;
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this._manager.cancel(this);
    }
  }, {
    key: "load",
    value: function load(info) {
      if (this._onLoad) {
        this._onLoad(info);
      }
    }
  }, {
    key: "error",
    value: function error(info) {
      if (this._onError) {
        this._onError(info);
      }
    }
  }]);
  return ImageWorkerImage;
}();
var createWorker = function createWorker() {
  function ImageWorkerServer() {
    this.items = new Map();
    var t = this;
    onmessage = function onmessage(e) {
      t._receiveMessage(e);
    };
  }
  ImageWorkerServer.isPathAbsolute = function (path) {
    return /^(?:\/|[a-z]+:\/\/)/.test(path) || path.substr(0, 5) == 'data:';
  };
  ImageWorkerServer.prototype._receiveMessage = function (e) {
    if (e.data.type === 'config') {
      this.config = e.data.config;
      var base = this.config.path;
      var hasHashPath = /#.*?\//;
      if (hasHashPath.test(base)) {
        base = base.replace(/#.*$/, '');
      }
      var parts = base.split("/");
      parts.pop();
      this._relativeBase = parts.join("/") + "/";
    } else if (e.data.type === 'add') {
      this.add(e.data.id, e.data.src);
    } else if (e.data.type === 'cancel') {
      this.cancel(e.data.id);
    }
  };
  ImageWorkerServer.prototype.add = function (id, src) {
    if (!ImageWorkerServer.isPathAbsolute(src)) {
      src = this._relativeBase + src;
    }
    if (src.substr(0, 2) === "//") {
      src = this.config.protocol + src;
    }
    var item = new ImageWorkerServerItem(id, src);
    var t = this;
    item.onFinish = function (result) {
      t.finish(item, result);
    };
    item.onError = function (info) {
      t.error(item, info);
    };
    this.items.set(id, item);
    item.start();
  };
  ImageWorkerServer.prototype.cancel = function (id) {
    var item = this.items.get(id);
    if (item) {
      item.cancel();
      this.items.delete(id);
    }
  };
  ImageWorkerServer.prototype.finish = function (item, _ref) {
    var imageBitmap = _ref.imageBitmap,
      hasAlphaChannel = _ref.hasAlphaChannel;
    postMessage({
      type: "data",
      id: item.id,
      info: {
        imageBitmap: imageBitmap,
        hasAlphaChannel: hasAlphaChannel
      }
    }, [imageBitmap]);
    this.items.delete(item.id);
  };
  ImageWorkerServer.prototype.error = function (item, _ref2) {
    var type = _ref2.type,
      message = _ref2.message;
    postMessage({
      type: "error",
      id: item.id,
      info: {
        type: type,
        message: message
      }
    });
    this.items.delete(item.id);
  };
  ImageWorkerServer.isWPEBrowser = function () {
    return navigator.userAgent.indexOf("WPE") !== -1;
  };
  function ImageWorkerServerItem(id, src) {
    this._onError = undefined;
    this._onFinish = undefined;
    this._id = id;
    this._src = src;
    this._xhr = undefined;
    this._mimeType = undefined;
    this._canceled = false;
  }
  Object.defineProperty(ImageWorkerServerItem.prototype, 'id', {
    get: function get() {
      return this._id;
    }
  });
  Object.defineProperty(ImageWorkerServerItem.prototype, 'onFinish', {
    get: function get() {
      return this._onFinish;
    },
    set: function set(f) {
      this._onFinish = f;
    }
  });
  Object.defineProperty(ImageWorkerServerItem.prototype, 'onError', {
    get: function get() {
      return this._onError;
    },
    set: function set(f) {
      this._onError = f;
    }
  });
  ImageWorkerServerItem.prototype.start = function () {
    this._xhr = new XMLHttpRequest();
    this._xhr.open("GET", this._src, true);
    this._xhr.responseType = "blob";
    var t = this;
    this._xhr.onerror = function (oEvent) {
      t.error({
        type: "connection",
        message: "Connection error"
      });
    };
    this._xhr.onload = function (oEvent) {
      var blob = t._xhr.response;
      t._mimeType = blob.type;
      t._createImageBitmap(blob);
    };
    this._xhr.send();
  };
  ImageWorkerServerItem.prototype._createImageBitmap = function (blob) {
    var t = this;
    createImageBitmap(blob, {
      premultiplyAlpha: 'premultiply',
      colorSpaceConversion: 'none',
      imageOrientation: 'none'
    }).then(function (imageBitmap) {
      t.finish({
        imageBitmap: imageBitmap,
        hasAlphaChannel: t._hasAlphaChannel()
      });
    }).catch(function (e) {
      t.error({
        type: "parse",
        message: "Error parsing image data"
      });
    });
  };
  ImageWorkerServerItem.prototype._hasAlphaChannel = function () {
    if (ImageWorkerServer.isWPEBrowser()) {
      return true;
    } else {
      return this._mimeType.indexOf("image/png") !== -1;
    }
  };
  ImageWorkerServerItem.prototype.cancel = function () {
    if (this._canceled) return;
    if (this._xhr) {
      this._xhr.abort();
    }
    this._canceled = true;
  };
  ImageWorkerServerItem.prototype.error = function (type, message) {
    if (!this._canceled && this._onError) {
      this._onError({
        type: type,
        message: message
      });
    }
  };
  ImageWorkerServerItem.prototype.finish = function (info) {
    if (!this._canceled && this._onFinish) {
      this._onFinish(info);
    }
  };
  var worker = new ImageWorkerServer();
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/platforms/browser/WebPlatform.mjs







































var WebPlatform = function () {
  function WebPlatform() {
    (0,classCallCheck/* default */.Z)(this, WebPlatform);
  }
  (0,createClass/* default */.Z)(WebPlatform, [{
    key: "init",
    value: function init(stage) {
      this.stage = stage;
      this._looping = false;
      this._awaitingLoop = false;
      this._loopHandler = null;
      this._idleLoopCounter = 0;
      this._idleLoopDelay = 60;
      if (this.stage.getOption("useImageWorker")) {
        if (!window.createImageBitmap || !window.Worker) {
          console.warn("[Lightning] Can't use image worker because browser does not have createImageBitmap and Web Worker support");
        } else {
          this._imageWorker = new ImageWorker();
        }
      }
      this._registerVisibilityChangeHandler();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this._imageWorker) {
        this._imageWorker.destroy();
      }
      this._removeKeyHandler();
      this._removeClickHandler();
      this._removeHoverHandler();
      this._removeScrollWheelHandler();
      this._removeVisibilityChangeHandler();
    }
  }, {
    key: "startLoop",
    value: function startLoop() {
      this._looping = true;
      if (!this._awaitingLoop) {
        this.loop();
      }
    }
  }, {
    key: "stopLoop",
    value: function stopLoop() {
      this._looping = false;
    }
  }, {
    key: "switchLoop",
    value: function switchLoop() {
      var _this = this;
      if (this._idleLoopCounter < this._idleLoopDelay) {
        this._idleLoopCounter++;
        return;
      }
      if (!this.stage.ctx.hasRenderUpdates()) {
        this.stopLoop();
        this._loopHandler = setInterval(function () {
          _this.stage.updateFrame();
          _this.stage.idleFrame();
          if (_this.stage.ctx.hasRenderUpdates()) {
            clearInterval(_this._loopHandler);
            _this.startLoop();
          }
          ;
        }, 1000 / 60);
      } else {
        this._idleLoopCounter = 0;
      }
    }
  }, {
    key: "loop",
    value: function loop() {
      var self = this;
      var lp = function lp() {
        self._awaitingLoop = false;
        if (self._looping) {
          self.stage.updateFrame();
          if (self.stage.getOption("pauseRafLoopOnIdle")) {
            self.switchLoop();
          }
          self.stage.renderFrame();
          requestAnimationFrame(lp);
          self._awaitingLoop = true;
        }
      };
      requestAnimationFrame(lp);
    }
  }, {
    key: "uploadCompressedGlTexture",
    value: function uploadCompressedGlTexture(gl, textureSource, source, options) {
      var view = !source.pvr ? new DataView(source.mipmaps[0]) : source.mipmaps[0];
      gl.compressedTexImage2D(gl.TEXTURE_2D, 0, source.glInternalFormat, source.pixelWidth, source.pixelHeight, 0, view);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    }
  }, {
    key: "uploadGlTexture",
    value: function uploadGlTexture(gl, textureSource, source, options) {
      if (source instanceof ImageData || source instanceof HTMLImageElement || source instanceof HTMLVideoElement || window.ImageBitmap && source instanceof ImageBitmap) {
        gl.texImage2D(gl.TEXTURE_2D, 0, options.internalFormat, options.format, options.type, source);
      } else if (source instanceof HTMLCanvasElement) {
        if (Utils_Utils.isZiggo || this.stage.getOption("forceTxCanvasSource")) {
          gl.texImage2D(gl.TEXTURE_2D, 0, options.internalFormat, options.format, options.type, source);
        } else if (source.width > 0 && source.height > 0) {
          var ctx = source.getContext('2d');
          gl.texImage2D(gl.TEXTURE_2D, 0, options.internalFormat, options.format, options.type, ctx.getImageData(0, 0, source.width, source.height));
        }
      } else {
        gl.texImage2D(gl.TEXTURE_2D, 0, options.internalFormat, textureSource.w, textureSource.h, 0, options.format, options.type, source);
      }
    }
  }, {
    key: "handleKtxLoad",
    value: function handleKtxLoad(cb, src) {
      var self = this;
      return function () {
        var arraybuffer = this.response;
        var view = new DataView(arraybuffer);
        var targetIdentifier = 3632701469;
        if (targetIdentifier !== view.getUint32(0) + view.getUint32(4) + view.getUint32(8)) {
          cb('Parsing failed: identifier ktx mismatch:', src);
        }
        var littleEndian = view.getUint32(12) === 16909060 ? true : false;
        var data = {
          glType: view.getUint32(16, littleEndian),
          glTypeSize: view.getUint32(20, littleEndian),
          glFormat: view.getUint32(24, littleEndian),
          glInternalFormat: view.getUint32(28, littleEndian),
          glBaseInternalFormat: view.getUint32(32, littleEndian),
          pixelWidth: view.getUint32(36, littleEndian),
          pixelHeight: view.getUint32(40, littleEndian),
          pixelDepth: view.getUint32(44, littleEndian),
          numberOfArrayElements: view.getUint32(48, littleEndian),
          numberOfFaces: view.getUint32(52, littleEndian),
          numberOfMipmapLevels: view.getUint32(56, littleEndian),
          bytesOfKeyValueData: view.getUint32(60, littleEndian),
          kvps: [],
          mipmaps: [],
          get width() {
            return this.pixelWidth;
          },
          get height() {
            return this.pixelHeight;
          }
        };
        var props = function props(obj) {
          var p = [];
          for (var v in obj) {
            p.push(obj[v]);
          }
          return p;
        };
        var formats = Object.values(self.stage.renderer.getCompressedTextureExtensions()).filter(function (obj) {
          return obj != null;
        }).map(function (obj) {
          return props(obj);
        }).reduce(function (prev, current) {
          return prev.concat(current);
        });
        if (!formats.includes(data.glInternalFormat)) {
          console.warn("[Lightning] Unrecognized texture extension format:", src, data.glInternalFormat, self.stage.renderer.getCompressedTextureExtensions());
        }
        var offset = 64;
        offset += data.bytesOfKeyValueData;
        for (var i = 0; i < data.numberOfMipmapLevels; i++) {
          var imageSize = view.getUint32(offset);
          offset += 4;
          data.mipmaps.push(view.buffer.slice(offset, imageSize));
          offset += imageSize;
        }
        cb(null, {
          source: data,
          renderInfo: {
            src: src,
            compressed: true
          }
        });
      };
    }
  }, {
    key: "handlePvrLoad",
    value: function handlePvrLoad(cb, src) {
      return function () {
        var pvrHeaderLength = 13;
        var pvrFormatEtc1 = 0x8D64;
        var pvrWidth = 7;
        var pvrHeight = 6;
        var pvrMipmapCount = 11;
        var pvrMetadata = 12;
        var arrayBuffer = this.response;
        var header = new Int32Array(arrayBuffer, 0, pvrHeaderLength);
        var dataOffset = header[pvrMetadata] + 52;
        var pvrtcData = new Uint8Array(arrayBuffer, dataOffset);
        var data = {
          glInternalFormat: pvrFormatEtc1,
          pixelWidth: header[pvrWidth],
          pixelHeight: header[pvrHeight],
          numberOfMipmapLevels: header[pvrMipmapCount],
          mipmaps: [],
          pvr: true,
          get width() {
            return this.pixelWidth;
          },
          get height() {
            return this.pixelHeight;
          }
        };
        var offset = 0;
        var width = data.pixelWidth;
        var height = data.pixelHeight;
        for (var i = 0; i < data.numberOfMipmapLevels; i++) {
          var level = (width + 3 >> 2) * (height + 3 >> 2) * 8;
          var view = new Uint8Array(arrayBuffer, pvrtcData.byteOffset + offset, level);
          data.mipmaps.push(view);
          offset += level;
          width = width >> 1;
          height = height >> 1;
        }
        cb(null, {
          source: data,
          renderInfo: {
            src: src,
            compressed: true
          }
        });
      };
    }
  }, {
    key: "loadSrcTexture",
    value: function loadSrcTexture(_ref, cb) {
      var src = _ref.src,
        hasAlpha = _ref.hasAlpha;
      var cancelCb = undefined;
      var isPng = src.indexOf(".png") >= 0 || src.substr(0, 21) == 'data:image/png;base64';
      var isKtx = src.indexOf('.ktx') >= 0;
      var isPvr = src.indexOf('.pvr') >= 0;
      if (isKtx || isPvr) {
        var request = new XMLHttpRequest();
        request.addEventListener("load", isKtx ? this.handleKtxLoad(cb, src) : this.handlePvrLoad(cb, src));
        request.open("GET", src);
        request.responseType = "arraybuffer";
        request.send();
        cancelCb = function cancelCb() {
          request.abort();
        };
      } else if (this._imageWorker) {
        var image = this._imageWorker.create(src);
        image.onError = function (err) {
          return cb("Image load error");
        };
        image.onLoad = function (_ref2) {
          var imageBitmap = _ref2.imageBitmap,
            hasAlphaChannel = _ref2.hasAlphaChannel;
          cb(null, {
            source: imageBitmap,
            renderInfo: {
              src: src,
              compressed: false
            },
            hasAlpha: hasAlphaChannel,
            premultiplyAlpha: true
          });
        };
        cancelCb = function cancelCb() {
          image.cancel();
        };
      } else {
        var _image = new Image();
        if (!(src.substr(0, 5) == "data:") && !Utils_Utils.isPS4) {
          _image.crossOrigin = "Anonymous";
        }
        _image.onerror = function (err) {
          if (_image.src) {
            return cb("Image load error");
          }
        };
        _image.onload = function () {
          cb(null, {
            source: _image,
            renderInfo: {
              src: src,
              compressed: false
            },
            hasAlpha: isPng || hasAlpha
          });
        };
        _image.src = src;
        cancelCb = function cancelCb() {
          _image.onerror = null;
          _image.onload = null;
          _image.removeAttribute('src');
        };
      }
      return cancelCb;
    }
  }, {
    key: "createWebGLContext",
    value: function createWebGLContext(w, h) {
      var canvas = this.stage.getOption('canvas') || document.createElement('canvas');
      if (w && h) {
        canvas.width = w;
        canvas.height = h;
      }
      var opts = {
        alpha: true,
        antialias: false,
        premultipliedAlpha: true,
        stencil: true,
        preserveDrawingBuffer: false
      };
      var gl = canvas.getContext('webgl', opts) || canvas.getContext('experimental-webgl', opts);
      if (!gl) {
        throw new Error('This browser does not support webGL.');
      }
      return gl;
    }
  }, {
    key: "createCanvasContext",
    value: function createCanvasContext(w, h) {
      var canvas = this.stage.getOption('canvas') || document.createElement('canvas');
      if (w && h) {
        canvas.width = w;
        canvas.height = h;
      }
      var c2d = canvas.getContext('2d');
      if (!c2d) {
        throw new Error('This browser does not support 2d canvas.');
      }
      return c2d;
    }
  }, {
    key: "getHrTime",
    value: function getHrTime() {
      return window.performance ? window.performance.now() : new Date().getTime();
    }
  }, {
    key: "getDrawingCanvas",
    value: function getDrawingCanvas() {
      return document.createElement('canvas');
    }
  }, {
    key: "getTextureOptionsForDrawingCanvas",
    value: function getTextureOptionsForDrawingCanvas(canvas) {
      var options = {};
      options.source = canvas;
      return options;
    }
  }, {
    key: "nextFrame",
    value: function nextFrame(changes) {}
  }, {
    key: "registerKeydownHandler",
    value: function registerKeydownHandler(keyhandler) {
      this._keydownListener = function (e) {
        keyhandler(e);
      };
      window.addEventListener('keydown', this._keydownListener);
    }
  }, {
    key: "registerKeyupHandler",
    value: function registerKeyupHandler(keyhandler) {
      this._keyupListener = function (e) {
        keyhandler(e);
      };
      window.addEventListener('keyup', this._keyupListener);
    }
  }, {
    key: "_removeKeyHandler",
    value: function _removeKeyHandler() {
      if (this._keydownListener) {
        window.removeEventListener('keydown', this._keydownListener);
      }
      if (this._keyupListener) {
        window.removeEventListener('keyup', this._keyupListener);
      }
    }
  }, {
    key: "registerClickHandler",
    value: function registerClickHandler(clickHandler) {
      this._clickListener = function (e) {
        clickHandler(e);
      };
      window.addEventListener('mousedown', this._clickListener);
    }
  }, {
    key: "_removeClickHandler",
    value: function _removeClickHandler() {
      if (this._clickListener) {
        window.removeEventListener('mousedown', this._clickListener);
      }
    }
  }, {
    key: "registerHoverHandler",
    value: function registerHoverHandler(hoverHandler) {
      this._hoverListener = function (e) {
        hoverHandler(e);
      };
      window.addEventListener('mousemove', this._hoverListener);
    }
  }, {
    key: "_removeHoverHandler",
    value: function _removeHoverHandler() {
      if (this._hoverListener) {
        window.removeEventListener('mousemove', this._hoverListener);
      }
    }
  }, {
    key: "registerScrollWheelHandler",
    value: function registerScrollWheelHandler(_registerScrollWheelHandler) {
      this._scrollWheelListener = function (e) {
        _registerScrollWheelHandler(e);
      };
      window.addEventListener('wheel', this._scrollWheelListener);
    }
  }, {
    key: "_removeScrollWheelHandler",
    value: function _removeScrollWheelHandler() {
      if (this._scrollWheelListener) {
        window.removeEventListener('wheel', this._scrollWheelListener);
      }
    }
  }, {
    key: "_registerVisibilityChangeHandler",
    value: function _registerVisibilityChangeHandler() {
      var _this2 = this;
      this._visibilityChangeHandler = function () {
        if (document.visibilityState === 'visible') {
          _this2.stage.root.core.setHasRenderUpdates(2);
          _this2.stage.renderFrame();
        }
      };
      document.addEventListener('visibilitychange', this._visibilityChangeHandler);
    }
  }, {
    key: "_removeVisibilityChangeHandler",
    value: function _removeVisibilityChangeHandler() {
      if (this._visibilityChangeHandler) {
        document.removeEventListener('visibilitychange', this._visibilityChangeHandler);
      }
    }
  }]);
  return WebPlatform;
}();

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/platforms/PlatformLoader.mjs



var PlatformLoader = function () {
  function PlatformLoader() {
    (0,classCallCheck/* default */.Z)(this, PlatformLoader);
  }
  (0,createClass/* default */.Z)(PlatformLoader, null, [{
    key: "load",
    value: function load(options) {
      if (options.platform) {
        return options.platform;
      } else {
        return WebPlatform;
      }
    }
  }]);
  return PlatformLoader;
}();

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/tools/WebGLStateManager.mjs













var WebGLStateManager_Utils = function () {
  function Utils() {
    (0,classCallCheck/* default */.Z)(this, Utils);
  }
  (0,createClass/* default */.Z)(Utils, null, [{
    key: "isFunction",
    value: function isFunction(value) {
      return typeof value === 'function';
    }
  }, {
    key: "isNumber",
    value: function isNumber(value) {
      return typeof value === 'number';
    }
  }, {
    key: "isInteger",
    value: function isInteger(value) {
      return typeof value === 'number' && value % 1 === 0;
    }
  }, {
    key: "isBoolean",
    value: function isBoolean(value) {
      return value === true || value === false;
    }
  }, {
    key: "isString",
    value: function isString(value) {
      return typeof value == 'string';
    }
  }, {
    key: "isObject",
    value: function isObject(value) {
      var type = (0,esm_typeof/* default */.Z)(value);
      return !!value && (type == 'object' || type == 'function');
    }
  }, {
    key: "isPlainObject",
    value: function isPlainObject(value) {
      var type = (0,esm_typeof/* default */.Z)(value);
      return !!value && type == 'object';
    }
  }, {
    key: "isObjectLiteral",
    value: function isObjectLiteral(value) {
      return (0,esm_typeof/* default */.Z)(value) === 'object' && value && value.constructor === Object;
    }
  }, {
    key: "getArrayIndex",
    value: function getArrayIndex(index, arr) {
      return Utils.getModuloIndex(index, arr.length);
    }
  }, {
    key: "equalValues",
    value: function equalValues(v1, v2) {
      if ((0,esm_typeof/* default */.Z)(v1) !== (0,esm_typeof/* default */.Z)(v2)) return false;
      if (Utils.isObjectLiteral(v1)) {
        return Utils.isObjectLiteral(v2) && Utils.equalObjectLiterals(v1, v2);
      } else if (Array.isArray(v1)) {
        return Array.isArray(v2) && Utils.equalArrays(v1, v2);
      } else {
        return v1 === v2;
      }
    }
  }, {
    key: "equalObjectLiterals",
    value: function equalObjectLiterals(obj1, obj2) {
      var keys1 = Object.keys(obj1);
      var keys2 = Object.keys(obj2);
      if (keys1.length !== keys2.length) {
        return false;
      }
      for (var i = 0, n = keys1.length; i < n; i++) {
        var k1 = keys1[i];
        var k2 = keys2[i];
        if (k1 !== k2) {
          return false;
        }
        var v1 = obj1[k1];
        var v2 = obj2[k2];
        if (!Utils.equalValues(v1, v2)) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "equalArrays",
    value: function equalArrays(v1, v2) {
      if (v1.length !== v2.length) {
        return false;
      }
      for (var i = 0, n = v1.length; i < n; i++) {
        if (!this.equalValues(v1[i], v2[i])) {
          return false;
        }
      }
      return true;
    }
  }]);
  return Utils;
}();
var WebGLState = function () {
  function WebGLState(id, gl) {
    (0,classCallCheck/* default */.Z)(this, WebGLState);
    this._id = id;
    this._gl = gl;
    this._program = undefined;
    this._buffers = new Map();
    this._framebuffers = new Map();
    this._renderbuffers = new Map();
    this._vertexAttribs = new Array(16);
    this._nonDefaultFlags = new Set();
    this._settings = new Map();
    this._textures = new Array(8);
    this._maxTexture = 0;
    this._activeTexture = gl.TEXTURE0;
    this._pixelStorei = new Array(5);
  }
  (0,createClass/* default */.Z)(WebGLState, [{
    key: "_getDefaultFlag",
    value: function _getDefaultFlag(cap) {
      return cap === this._gl.DITHER;
    }
  }, {
    key: "setFlag",
    value: function setFlag(cap, v) {
      var def = this._getDefaultFlag(cap);
      if (v === def) {
        return this._nonDefaultFlags.delete(cap);
      } else {
        if (!this._nonDefaultFlags.has(cap)) {
          this._nonDefaultFlags.add(cap);
          return true;
        } else {
          return false;
        }
      }
    }
  }, {
    key: "setBuffer",
    value: function setBuffer(target, buffer) {
      var change = this._buffers.get(target) !== buffer;
      this._buffers.set(target, buffer);
      if (change && target === this._gl.ARRAY_BUFFER) {
        this._vertexAttribs = [];
      }
      return change;
    }
  }, {
    key: "setFramebuffer",
    value: function setFramebuffer(target, buffer) {
      var change = this._framebuffers.get(target) !== buffer;
      this._framebuffers.set(target, buffer);
      return change;
    }
  }, {
    key: "setRenderbuffer",
    value: function setRenderbuffer(target, buffer) {
      var change = this._renderbuffers.get(target) !== buffer;
      this._renderbuffers.set(target, buffer);
      return change;
    }
  }, {
    key: "setProgram",
    value: function setProgram(program) {
      var change = this._program !== program;
      this._program = program;
      return change;
    }
  }, {
    key: "setSetting",
    value: function setSetting(func, v) {
      var s = this._settings.get(func);
      var change = !s || !WebGLStateManager_Utils.equalValues(s, v);
      this._settings.set(func, v);
      return change;
    }
  }, {
    key: "disableVertexAttribArray",
    value: function disableVertexAttribArray(index) {
      var va = this._vertexAttribs[index];
      if (va && va[5]) {
        va[5] = false;
        return true;
      }
      return false;
    }
  }, {
    key: "enableVertexAttribArray",
    value: function enableVertexAttribArray(index) {
      var va = this._vertexAttribs[index];
      if (va) {
        if (!va[0]) {
          va[0] = true;
          return true;
        }
      } else {
        this._vertexAttribs[index] = [0, 0, 0, 0, 0, true];
        return true;
      }
      return false;
    }
  }, {
    key: "vertexAttribPointer",
    value: function vertexAttribPointer(index, props) {
      var va = this._vertexAttribs[index];
      var equal = false;
      if (va) {
        equal = va[0] === props[0] && va[1] === props[1] && va[2] === props[2] && va[3] === props[3] && va[4] === props[4];
      }
      if (equal) {
        return false;
      } else {
        props[5] = va ? va[5] : false;
        return true;
      }
    }
  }, {
    key: "setActiveTexture",
    value: function setActiveTexture(texture) {
      var changed = this._activeTexture !== texture;
      this._activeTexture = texture;
      return changed;
    }
  }, {
    key: "bindTexture",
    value: function bindTexture(target, texture) {
      var activeIndex = WebGLState._getTextureIndex(this._activeTexture);
      this._maxTexture = Math.max(this._maxTexture, activeIndex + 1);
      var current = this._textures[activeIndex];
      var targetIndex = WebGLState._getTextureTargetIndex(target);
      if (current) {
        if (current[targetIndex] === texture) {
          return false;
        }
        current[targetIndex] = texture;
        return true;
      } else {
        if (texture) {
          this._textures[activeIndex] = [];
          this._textures[activeIndex][targetIndex] = texture;
          return true;
        } else {
          return false;
        }
      }
    }
  }, {
    key: "setPixelStorei",
    value: function setPixelStorei(pname, param) {
      var i = WebGLState._getPixelStoreiIndex(pname);
      var change = !WebGLStateManager_Utils.equalValues(this._pixelStorei[i], param);
      this._pixelStorei[i] = param;
      return change;
    }
  }, {
    key: "migrate",
    value: function migrate(s) {
      var t = this;
      this._migrateFlags(t, s);
      if (s._program !== t._program) {
        this._gl._useProgram(s._program);
      }
      this._migrateFramebuffers(t, s);
      this._migrateRenderbuffers(t, s);
      var buffersChanged = this._migrateBuffers(t, s);
      this._migrateAttributes(t, s, buffersChanged);
      this._migrateFlags(t, s);
      this._migrateSettings(t, s);
      this._migratePixelStorei(t, s);
      this._migrateTextures(t, s);
    }
  }, {
    key: "_migratePixelStorei",
    value: function _migratePixelStorei(t, s) {
      for (var i = 0, n = t._pixelStorei.length; i < n; i++) {
        if (t._pixelStorei[i] !== s._pixelStorei[i]) {
          var value = s._pixelStorei[i] !== undefined ? s._pixelStorei[i] : WebGLState._getDefaultPixelStoreiByIndex(i);
          this._gl._pixelStorei(WebGLState._getPixelStoreiByIndex(i), value);
        }
      }
    }
  }, {
    key: "_migrateTextures",
    value: function _migrateTextures(t, s) {
      var max = Math.max(t._maxTexture, s._maxTexture);
      var activeTexture = t._activeTexture;
      for (var i = 0; i < max; i++) {
        var sTargets = s._textures[i];
        var tTargets = t._textures[i];
        var textureNumb = WebGLState._getTextureByIndex(i);
        var targetMax = Math.max(tTargets ? tTargets.length : 0, sTargets ? sTargets.length : 0);
        for (var j = 0, n = targetMax; j < n; j++) {
          var target = WebGLState._getTextureTargetByIndex(j);
          if (activeTexture !== textureNumb) {
            this._gl._activeTexture(textureNumb);
            activeTexture = textureNumb;
          }
          var texture = sTargets && sTargets[j] || null;
          this._gl._bindTexture(target, texture);
        }
      }
      if (s._activeTexture !== activeTexture) {
        this._gl._activeTexture(s._activeTexture);
      }
    }
  }, {
    key: "_migrateBuffers",
    value: function _migrateBuffers(t, s) {
      var _this = this;
      s._buffers.forEach(function (framebuffer, target) {
        if (t._buffers.get(target) !== framebuffer) {
          _this._gl._bindBuffer(target, framebuffer);
        }
      });
      t._buffers.forEach(function (buffer, target) {
        var b = s._buffers.get(target);
        if (b === undefined) {
          _this._gl._bindBuffer(target, null);
        }
      });
      return s._buffers.get(this._gl.ARRAY_BUFFER) !== t._buffers.get(this._gl.ARRAY_BUFFER);
    }
  }, {
    key: "_migrateFramebuffers",
    value: function _migrateFramebuffers(t, s) {
      var _this2 = this;
      s._framebuffers.forEach(function (framebuffer, target) {
        if (t._framebuffers.get(target) !== framebuffer) {
          _this2._gl._bindFramebuffer(target, framebuffer);
        }
      });
      t._framebuffers.forEach(function (framebuffer, target) {
        var fb = s._framebuffers.get(target);
        if (fb === undefined) {
          _this2._gl._bindFramebuffer(target, null);
        }
      });
    }
  }, {
    key: "_migrateRenderbuffers",
    value: function _migrateRenderbuffers(t, s) {
      var _this3 = this;
      s._renderbuffers.forEach(function (renderbuffer, target) {
        if (t._renderbuffers.get(target) !== renderbuffer) {
          _this3._gl._bindRenderbuffer(target, renderbuffer);
        }
      });
      t._renderbuffers.forEach(function (renderbuffer, target) {
        var fb = s._renderbuffers.get(target);
        if (fb === undefined) {
          _this3._gl._bindRenderbuffer(target, null);
        }
      });
    }
  }, {
    key: "_migrateAttributes",
    value: function _migrateAttributes(t, s, buffersChanged) {
      var _this4 = this;
      if (!buffersChanged) {
        t._vertexAttribs.forEach(function (attrib, index) {
          if (!s._vertexAttribs[index]) {
            _this4._gl._disableVertexAttribArray(index);
          }
        });
        s._vertexAttribs.forEach(function (attrib, index) {
          _this4._gl._vertexAttribPointer(index, attrib[0], attrib[1], attrib[2], attrib[4]);
          if (attrib[5]) {
            _this4._gl._enableVertexAttribArray(index);
          } else {
            _this4._gl._disableVertexAttribArray(index);
          }
        });
      } else {
        s._vertexAttribs.forEach(function (attrib, index) {
          if (attrib[0]) {
            _this4._gl._vertexAttribPointer(index, attrib[0], attrib[1], attrib[2], attrib[3], attrib[4]);
          }
          if (attrib[5]) {
            _this4._gl._enableVertexAttribArray(index);
          }
        });
      }
    }
  }, {
    key: "_migrateSettings",
    value: function _migrateSettings(t, s) {
      var _this5 = this;
      var defaults = this.constructor.getDefaultSettings();
      t._settings.forEach(function (value, func) {
        var name = func.name || func.xname;
        if (!s._settings.has(func)) {
          var args = defaults.get(name);
          if (WebGLStateManager_Utils.isFunction(args)) {
            args = args(_this5._gl);
          }
          s._settings.set(func, args);
          func.apply(_this5._gl, args);
        }
      });
      s._settings.forEach(function (value, func) {
        var tValue = t._settings.get(func);
        if (!tValue || !WebGLStateManager_Utils.equalValues(tValue, value)) {
          func.apply(_this5._gl, value);
        }
      });
    }
  }, {
    key: "_migrateFlags",
    value: function _migrateFlags(t, s) {
      var _this6 = this;
      t._nonDefaultFlags.forEach(function (setting) {
        if (!s._nonDefaultFlags.has(setting)) {
          if (_this6._getDefaultFlag(setting)) {
            _this6._gl._enable(setting);
          } else {
            _this6._gl._disable(setting);
          }
        }
      });
      s._nonDefaultFlags.forEach(function (setting) {
        if (!t._nonDefaultFlags.has(setting)) {
          if (_this6._getDefaultFlag(setting)) {
            _this6._gl._disable(setting);
          } else {
            _this6._gl._enable(setting);
          }
        }
      });
    }
  }], [{
    key: "getDefaultSettings",
    value: function getDefaultSettings() {
      if (!this._defaultSettings) {
        this._defaultSettings = new Map();
        var d = this._defaultSettings;
        var g = WebGLRenderingContext.prototype;
        d.set("viewport", function (gl) {
          return [0, 0, gl.canvas.width, gl.canvas.height];
        });
        d.set("scissor", function (gl) {
          return [0, 0, gl.canvas.width, gl.canvas.height];
        });
        d.set("blendColor", [0, 0, 0, 0]);
        d.set("blendEquation", [g.FUNC_ADD]);
        d.set("blendEquationSeparate", [g.FUNC_ADD, g.FUNC_ADD]);
        d.set("blendFunc", [g.ONE, g.ZERO]);
        d.set("blendFuncSeparate", [g.ONE, g.ZERO, g.ONE, g.ZERO]);
        d.set("clearColor", [0, 0, 0, 0]);
        d.set("clearDepth", [1]);
        d.set("clearStencil", [0]);
        d.set("colorMask", [true, true, true, true]);
        d.set("cullFace", [g.BACK]);
        d.set("depthFunc", [g.LESS]);
        d.set("depthMask", [true]);
        d.set("depthRange", [0, 1]);
        d.set("frontFace", [g.CCW]);
        d.set("lineWidth", [1]);
        d.set("polygonOffset", [0, 0]);
        d.set("sampleCoverage", [1, false]);
        d.set("stencilFunc", [g.ALWAYS, 0, 1]);
        d.set("_stencilFuncSeparateFront", [g.ALWAYS, 0, 1]);
        d.set("_stencilFuncSeparateBack", [g.ALWAYS, 0, 1]);
        d.set("_stencilFuncSeparateFrontAndBack", [g.ALWAYS, 0, 1]);
        d.set("stencilMask", [1]);
        d.set("_stencilMaskSeparateFront", [1]);
        d.set("_stencilMaskSeparateBack", [1]);
        d.set("_stencilMaskSeparateFrontAndBack", [1]);
        d.set("stencilOp", [g.KEEP, g.KEEP, g.KEEP]);
        d.set("_stencilOpSeparateFront", [g.KEEP, g.KEEP, g.KEEP]);
        d.set("_stencilOpSeparateBack", [g.KEEP, g.KEEP, g.KEEP]);
        d.set("_stencilOpSeparateFrontAndBack", [g.KEEP, g.KEEP, g.KEEP]);
        d.set("vertexAttrib1f", []);
        d.set("vertexAttrib1fv", []);
        d.set("vertexAttrib2f", []);
        d.set("vertexAttrib2fv", []);
        d.set("vertexAttrib3f", []);
        d.set("vertexAttrib3fv", []);
        d.set("vertexAttrib4f", []);
        d.set("vertexAttrib4fv", []);
      }
      return this._defaultSettings;
    }
  }, {
    key: "_getTextureTargetIndex",
    value: function _getTextureTargetIndex(target) {
      switch (target) {
        case 0x0DE1:
          return 0;
        case 0x8513:
          return 1;
        default:
          throw new Error('Unknown texture target: ' + target);
      }
    }
  }, {
    key: "_getTextureTargetByIndex",
    value: function _getTextureTargetByIndex(index) {
      if (!this._textureTargetIndices) {
        this._textureTargetIndices = [0x0DE1, 0x8513];
      }
      return this._textureTargetIndices[index];
    }
  }, {
    key: "_getTextureIndex",
    value: function _getTextureIndex(index) {
      return index - 0x84C0;
    }
  }, {
    key: "_getTextureByIndex",
    value: function _getTextureByIndex(index) {
      return index + 0x84C0;
    }
  }, {
    key: "_getPixelStoreiIndex",
    value: function _getPixelStoreiIndex(pname) {
      switch (pname) {
        case 0x0D05:
          return 0;
        case 0x0CF5:
          return 1;
        case 0x9240:
          return 2;
        case 0x9241:
          return 3;
        case 0x9243:
          return 4;
        case 0x9245:
          return 5;
        default:
          throw new Error('Unknown pixelstorei: ' + pname);
      }
    }
  }, {
    key: "_getPixelStoreiByIndex",
    value: function _getPixelStoreiByIndex(index) {
      if (!this._pixelStoreiIndices) {
        this._pixelStoreiIndices = [0x0D05, 0x0CF5, 0x9240, 0x9241, 0x9243];
      }
      return this._pixelStoreiIndices[index];
    }
  }, {
    key: "_getDefaultPixelStoreiByIndex",
    value: function _getDefaultPixelStoreiByIndex(index) {
      if (!this._pixelStoreiDefaults) {
        this._pixelStoreiDefaults = [4, 4, false, false, WebGLRenderingContext.prototype.BROWSER_DEFAULT_WEBGL];
      }
      return this._pixelStoreiDefaults[index];
    }
  }]);
  return WebGLState;
}();
var WebGLStateManager = function () {
  function WebGLStateManager() {
    (0,classCallCheck/* default */.Z)(this, WebGLStateManager);
  }
  (0,createClass/* default */.Z)(WebGLStateManager, [{
    key: "_initStateManager",
    value: function _initStateManager() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "default";
      this._states = {};
      this._state = this._getState(id);
    }
  }, {
    key: "_getState",
    value: function _getState(id) {
      if (!this._states[id]) {
        this._states[id] = new WebGLState(id, this);
      }
      return this._states[id];
    }
  }, {
    key: "switchState",
    value: function switchState() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "default";
      if (this._state._id !== id) {
        var newState = this._getState(id);
        this._state.migrate(newState);
        this._state = newState;
      }
    }
  }, {
    key: "$useProgram",
    value: function $useProgram(program) {
      if (this._state.setProgram(program)) this._useProgram(program);
    }
  }, {
    key: "$bindBuffer",
    value: function $bindBuffer(target, fb) {
      if (this._state.setBuffer(target, fb)) this._bindBuffer(target, fb);
    }
  }, {
    key: "$bindFramebuffer",
    value: function $bindFramebuffer(target, fb) {
      if (this._state.setFramebuffer(target, fb)) this._bindFramebuffer(target, fb);
    }
  }, {
    key: "$bindRenderbuffer",
    value: function $bindRenderbuffer(target, fb) {
      if (this._state.setRenderbuffer(target, fb)) this._bindRenderbuffer(target, fb);
    }
  }, {
    key: "$enable",
    value: function $enable(cap) {
      if (this._state.setFlag(cap, true)) this._enable(cap);
    }
  }, {
    key: "$disable",
    value: function $disable(cap) {
      if (this._state.setFlag(cap, false)) this._disable(cap);
    }
  }, {
    key: "$viewport",
    value: function $viewport(x, y, w, h) {
      if (this._state.setSetting(this._viewport, [x, y, w, h])) this._viewport(x, y, w, h);
    }
  }, {
    key: "$scissor",
    value: function $scissor(x, y, w, h) {
      if (this._state.setSetting(this._scissor, [x, y, w, h])) this._scissor(x, y, w, h);
    }
  }, {
    key: "$disableVertexAttribArray",
    value: function $disableVertexAttribArray(index) {
      if (this._state.disableVertexAttribArray(index)) this._disableVertexAttribArray(index);
    }
  }, {
    key: "$enableVertexAttribArray",
    value: function $enableVertexAttribArray(index) {
      if (this._state.enableVertexAttribArray(index)) this._enableVertexAttribArray(index);
    }
  }, {
    key: "$vertexAttribPointer",
    value: function $vertexAttribPointer(index, size, type, normalized, stride, offset) {
      if (this._state.vertexAttribPointer(index, [size, type, normalized, stride, offset])) this._vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
  }, {
    key: "$activeTexture",
    value: function $activeTexture(texture) {
      if (this._state.setActiveTexture(texture)) this._activeTexture(texture);
    }
  }, {
    key: "$bindTexture",
    value: function $bindTexture(target, texture) {
      if (this._state.bindTexture(target, texture)) this._bindTexture(target, texture);
    }
  }, {
    key: "$pixelStorei",
    value: function $pixelStorei(pname, param) {
      if (this._state.setPixelStorei(pname, param)) {
        this._pixelStorei(pname, param);
      }
    }
  }, {
    key: "$stencilFuncSeparate",
    value: function $stencilFuncSeparate(face, func, ref, mask) {
      var f;
      switch (face) {
        case this.FRONT:
          f = this._stencilFuncSeparateFront;
          break;
        case this.BACK:
          f = this._stencilFuncSeparateBack;
          break;
        case this.FRONT_AND_BACK:
          f = this._stencilFuncSeparateFrontAndBack;
          break;
      }
      if (this._state.setSetting(f, [func, ref, mask])) f.apply(this, [func, ref, mask]);
    }
  }, {
    key: "_stencilFuncSeparateFront",
    value: function _stencilFuncSeparateFront(func, ref, mask) {
      this._stencilFuncSeparate(this.FRONT, func, ref, mask);
    }
  }, {
    key: "_stencilFuncSeparateBack",
    value: function _stencilFuncSeparateBack(func, ref, mask) {
      this._stencilFuncSeparate(this.BACK, func, ref, mask);
    }
  }, {
    key: "_stencilFuncSeparateFrontAndBack",
    value: function _stencilFuncSeparateFrontAndBack(func, ref, mask) {
      this._stencilFuncSeparate(this.FRONT_AND_BACK, func, ref, mask);
    }
  }, {
    key: "$stencilMaskSeparate",
    value: function $stencilMaskSeparate(face, mask) {
      var f;
      switch (face) {
        case this.FRONT:
          f = this._stencilMaskSeparateFront;
          break;
        case this.BACK:
          f = this._stencilMaskSeparateBack;
          break;
        case this.FRONT_AND_BACK:
          f = this._stencilMaskSeparateFrontAndBack;
          break;
      }
      if (this._state.setSetting(f, [mask])) f.apply(this, [mask]);
    }
  }, {
    key: "_stencilMaskSeparateFront",
    value: function _stencilMaskSeparateFront(mask) {
      this._stencilMaskSeparate(this.FRONT, mask);
    }
  }, {
    key: "_stencilMaskSeparateBack",
    value: function _stencilMaskSeparateBack(mask) {
      this._stencilMaskSeparate(this.BACK, mask);
    }
  }, {
    key: "_stencilMaskSeparateFrontAndBack",
    value: function _stencilMaskSeparateFrontAndBack(mask) {
      this._stencilMaskSeparate(this.FRONT_AND_BACK, mask);
    }
  }, {
    key: "$stencilOpSeparate",
    value: function $stencilOpSeparate(face, fail, zfail, zpass) {
      var f;
      switch (face) {
        case this.FRONT:
          f = this._stencilOpSeparateFront;
          break;
        case this.BACK:
          f = this._stencilOpSeparateBack;
          break;
        case this.FRONT_AND_BACK:
          f = this._stencilOpSeparateFrontAndBack;
          break;
      }
      if (this._state.setSetting(f, [fail, zfail, zpass])) f.apply(this, [fail, zfail, zpass]);
    }
  }, {
    key: "_stencilOpSeparateFront",
    value: function _stencilOpSeparateFront(fail, zfail, zpass) {
      this._stencilOpSeparate(this.FRONT, fail, zfail, zpass);
    }
  }, {
    key: "_stencilOpSeparateBack",
    value: function _stencilOpSeparateBack(fail, zfail, zpass) {
      this._stencilOpSeparate(this.BACK, fail, zfail, zpass);
    }
  }, {
    key: "_stencilOpSeparateFrontAndBack",
    value: function _stencilOpSeparateFrontAndBack(fail, zfail, zpass) {
      this._stencilOpSeparate(this.FRONT_AND_BACK, fail, zfail, zpass);
    }
  }, {
    key: "$blendColor",
    value: function $blendColor(red, green, blue, alpha) {
      if (this._state.setSetting(this._blendColor, [red, green, blue, alpha])) this._blendColor(red, green, blue, alpha);
    }
  }, {
    key: "$blendEquation",
    value: function $blendEquation(mode) {
      if (this._state.setSetting(this._blendEquation, [mode])) this._blendEquation(mode);
    }
  }, {
    key: "$blendEquationSeparate",
    value: function $blendEquationSeparate(modeRGB, modeAlpha) {
      if (this._state.setSetting(this._blendEquationSeparate, [modeRGB, modeAlpha])) this._blendEquationSeparate(modeRGB, modeAlpha);
    }
  }, {
    key: "$blendFunc",
    value: function $blendFunc(sfactor, dfactor) {
      if (this._state.setSetting(this._blendFunc, [sfactor, dfactor])) this._blendFunc(sfactor, dfactor);
    }
  }, {
    key: "$blendFuncSeparate",
    value: function $blendFuncSeparate(srcRGB, dstRGB, srcAlpha, dstAlpha) {
      if (this._state.setSetting(this._blendFuncSeparate, [srcRGB, dstRGB, srcAlpha, dstAlpha])) this._blendFuncSeparate(srcRGB, dstRGB, srcAlpha, dstAlpha);
    }
  }, {
    key: "$clearColor",
    value: function $clearColor(red, green, blue, alpha) {
      if (this._state.setSetting(this._clearColor, [red, green, blue, alpha])) this._clearColor(red, green, blue, alpha);
    }
  }, {
    key: "$clearDepth",
    value: function $clearDepth(depth) {
      if (this._state.setSetting(this._clearDepth, [depth])) this._clearDepth(depth);
    }
  }, {
    key: "$clearStencil",
    value: function $clearStencil(s) {
      if (this._state.setSetting(this._clearStencil, [s])) this._clearStencil(s);
    }
  }, {
    key: "$colorMask",
    value: function $colorMask(red, green, blue, alpha) {
      if (this._state.setSetting(this._colorMask, [red, green, blue, alpha])) this._colorMask(red, green, blue, alpha);
    }
  }, {
    key: "$cullFace",
    value: function $cullFace(mode) {
      if (this._state.setSetting(this._cullFace, [mode])) this._cullFace(mode);
    }
  }, {
    key: "$depthFunc",
    value: function $depthFunc(func) {
      if (this._state.setSetting(this._depthFunc, [func])) this._depthFunc(func);
    }
  }, {
    key: "$depthMask",
    value: function $depthMask(flag) {
      if (this._state.setSetting(this._depthMask, [flag])) this._depthMask(flag);
    }
  }, {
    key: "$depthRange",
    value: function $depthRange(zNear, zFar) {
      if (this._state.setSetting(this._depthRange, [zNear, zFar])) this._depthRange(zNear, zFar);
    }
  }, {
    key: "$frontFace",
    value: function $frontFace(mode) {
      if (this._state.setSetting(this._frontFace, [mode])) this._frontFace(mode);
    }
  }, {
    key: "$lineWidth",
    value: function $lineWidth(width) {
      if (this._state.setSetting(this._lineWidth, [width])) this._lineWidth(width);
    }
  }, {
    key: "$polygonOffset",
    value: function $polygonOffset(factor, units) {
      if (this._state.setSetting(this._polygonOffset, [factor, units])) this._polygonOffset(factor, units);
    }
  }, {
    key: "$sampleCoverage",
    value: function $sampleCoverage(value, invert) {
      if (this._state.setSetting(this._sampleCoverage, [value, invert])) this._sampleCoverage(value, invert);
    }
  }, {
    key: "$stencilFunc",
    value: function $stencilFunc(func, ref, mask) {
      if (this._state.setSetting(this._stencilFunc, [func, ref, mask])) this._stencilFunc(func, ref, mask);
    }
  }, {
    key: "$stencilMask",
    value: function $stencilMask(mask) {
      if (this._state.setSetting(this._stencilMask, [mask])) this._stencilMask(mask);
    }
  }, {
    key: "$stencilOp",
    value: function $stencilOp(fail, zfail, zpass) {
      if (this._state.setSetting(this._stencilOp, [fail, zfail, zpass])) this._stencilOp(fail, zfail, zpass);
    }
  }, {
    key: "$vertexAttrib1f",
    value: function $vertexAttrib1f(indx, x) {
      if (this._state.setSetting(this._vertexAttrib1f, [indx, x])) this._vertexAttrib1f(indx, x);
    }
  }, {
    key: "$vertexAttrib1fv",
    value: function $vertexAttrib1fv(indx, values) {
      if (this._state.setSetting(this._vertexAttrib1fv, [indx, values])) this._vertexAttrib1fv(indx, values);
    }
  }, {
    key: "$vertexAttrib2f",
    value: function $vertexAttrib2f(indx, x, y) {
      if (this._state.setSetting(this._vertexAttrib2f, [indx, x, y])) this._vertexAttrib2f(indx, x, y);
    }
  }, {
    key: "$vertexAttrib2fv",
    value: function $vertexAttrib2fv(indx, values) {
      if (this._state.setSetting(this._vertexAttrib2fv, [indx, values])) this._vertexAttrib2fv(indx, values);
    }
  }, {
    key: "$vertexAttrib3f",
    value: function $vertexAttrib3f(indx, x, y, z) {
      if (this._state.setSetting(this._vertexAttrib3f, [indx, x, y, z])) this._vertexAttrib3f(indx, x, y, z);
    }
  }, {
    key: "$vertexAttrib3fv",
    value: function $vertexAttrib3fv(indx, values) {
      if (this._state.setSetting(this._vertexAttrib3fv, [indx, values])) this._vertexAttrib3fv(indx, values);
    }
  }, {
    key: "$vertexAttrib4f",
    value: function $vertexAttrib4f(indx, x, y, z, w) {
      if (this._state.setSetting(this._vertexAttrib4f, [indx, x, y, z, w])) this._vertexAttrib4f(indx, x, y, z, w);
    }
  }, {
    key: "$vertexAttrib4fv",
    value: function $vertexAttrib4fv(indx, values) {
      if (this._state.setSetting(this._vertexAttrib4fv, [indx, values])) this._vertexAttrib4fv(indx, values);
    }
  }], [{
    key: "enable",
    value: function enable(gl) {
      var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "default";
      var names = Object.getOwnPropertyNames(WebGLStateManager.prototype);
      var WebGLRenderingContextProto = gl.__proto__;
      names.forEach(function (name) {
        if (name !== "constructor") {
          var method = WebGLStateManager.prototype[name];
          if (name.charAt(0) === "$") {
            name = name.substr(1);
          }
          if (gl[name] !== method) {
            if (gl[name]) {
              if (!gl[name].name) {
                gl[name].xname = name;
              }
              gl['_' + name] = gl[name];
            }
            gl[name] = method;
          }
        }
      });
      WebGLStateManager.prototype._initStateManager.call(gl, id);
      return gl;
    }
  }]);
  return WebGLStateManager;
}();
/* harmony default export */ const tools_WebGLStateManager = (WebGLStateManager);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/tree/TextureManager.mjs











var TextureManager = function () {
  function TextureManager(stage) {
    (0,classCallCheck/* default */.Z)(this, TextureManager);
    this.stage = stage;
    this._usedMemory = 0;
    this._uploadedTextureSources = [];
    this.textureSourceHashmap = new Map();
  }
  (0,createClass/* default */.Z)(TextureManager, [{
    key: "usedMemory",
    get: function get() {
      return this._usedMemory;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      for (var i = 0, n = this._uploadedTextureSources.length; i < n; i++) {
        this._nativeFreeTextureSource(this._uploadedTextureSources[i]);
      }
      this.textureSourceHashmap.clear();
      this._usedMemory = 0;
    }
  }, {
    key: "getReusableTextureSource",
    value: function getReusableTextureSource(id) {
      return this.textureSourceHashmap.get(id);
    }
  }, {
    key: "getTextureSource",
    value: function getTextureSource(func, id) {
      var textureSource = id ? this.textureSourceHashmap.get(id) : null;
      if (!textureSource) {
        textureSource = new TextureSource(this, func);
        if (id) {
          textureSource.lookupId = id;
          this.textureSourceHashmap.set(id, textureSource);
        }
      }
      return textureSource;
    }
  }, {
    key: "uploadTextureSource",
    value: function uploadTextureSource(textureSource, options) {
      if (textureSource.isLoaded()) return;
      this._addMemoryUsage(textureSource.w * textureSource.h);
      var nativeTexture = this._nativeUploadTextureSource(textureSource, options);
      textureSource._nativeTexture = nativeTexture;
      nativeTexture.w = textureSource.w;
      nativeTexture.h = textureSource.h;
      nativeTexture.update = this.stage.frameCounter;
      this._uploadedTextureSources.push(textureSource);
      this.addToLookupMap(textureSource);
      this._updateVramUsage(textureSource, 1);
    }
  }, {
    key: "_addMemoryUsage",
    value: function _addMemoryUsage(delta) {
      this._usedMemory += delta;
      this.stage.addMemoryUsage(delta);
    }
  }, {
    key: "_updateVramUsage",
    value: function _updateVramUsage(textureSource, sign) {
      var nativeTexture = textureSource.nativeTexture;
      var usage;
      if (!Stage.isWebglSupported()) return;
      if (!textureSource.isLoaded()) return;
      if (!nativeTexture.hasOwnProperty('bytesPerPixel') || isNaN(nativeTexture.bytesPerPixel)) return;
      usage = sign * (textureSource.w * textureSource.h * nativeTexture.bytesPerPixel);
      this.stage.addVramUsage(usage, textureSource.hasAlpha);
    }
  }, {
    key: "addToLookupMap",
    value: function addToLookupMap(textureSource) {
      var lookupId = textureSource.lookupId;
      if (lookupId) {
        if (!this.textureSourceHashmap.has(lookupId)) {
          this.textureSourceHashmap.set(lookupId, textureSource);
        }
      }
    }
  }, {
    key: "gc",
    value: function gc() {
      this.freeUnusedTextureSources();
      this._cleanupLookupMap();
    }
  }, {
    key: "freeUnusedTextureSources",
    value: function freeUnusedTextureSources() {
      var remainingTextureSources = [];
      for (var i = 0, n = this._uploadedTextureSources.length; i < n; i++) {
        var ts = this._uploadedTextureSources[i];
        if (ts.allowCleanup()) {
          this._freeManagedTextureSource(ts);
        } else {
          remainingTextureSources.push(ts);
        }
      }
      this._uploadedTextureSources = remainingTextureSources;
      this._cleanupLookupMap();
    }
  }, {
    key: "_freeManagedTextureSource",
    value: function _freeManagedTextureSource(textureSource) {
      if (textureSource.isLoaded()) {
        this._nativeFreeTextureSource(textureSource);
        this._addMemoryUsage(-textureSource.w * textureSource.h);
        this._updateVramUsage(textureSource, -1);
      }
      textureSource.loadingSince = null;
    }
  }, {
    key: "_cleanupLookupMap",
    value: function _cleanupLookupMap() {
      var _this = this;
      this.textureSourceHashmap.forEach(function (textureSource, lookupId) {
        if (!(textureSource.isLoaded() || textureSource.isLoading()) && !textureSource.isUsed()) {
          _this.textureSourceHashmap.delete(lookupId);
        }
      });
    }
  }, {
    key: "freeTextureSource",
    value: function freeTextureSource(textureSource) {
      var index = this._uploadedTextureSources.indexOf(textureSource);
      var managed = index !== -1;
      if (textureSource.isLoaded()) {
        if (managed) {
          this._addMemoryUsage(-textureSource.w * textureSource.h);
          this._uploadedTextureSources.splice(index, 1);
        }
        this._nativeFreeTextureSource(textureSource);
      }
      textureSource.loadingSince = null;
    }
  }, {
    key: "_nativeUploadTextureSource",
    value: function _nativeUploadTextureSource(textureSource, options) {
      return this.stage.renderer.uploadTextureSource(textureSource, options);
    }
  }, {
    key: "_nativeFreeTextureSource",
    value: function _nativeFreeTextureSource(textureSource) {
      this.stage.renderer.freeTextureSource(textureSource);
      textureSource.clearNativeTexture();
    }
  }]);
  return TextureManager;
}();

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/tree/TextureThrottler.mjs



var TextureThrottler = function () {
  function TextureThrottler(stage) {
    var _this = this;
    (0,classCallCheck/* default */.Z)(this, TextureThrottler);
    this.stage = stage;
    this.genericCancelCb = function (textureSource) {
      _this._remove(textureSource);
    };
    this._sources = [];
    this._data = [];
  }
  (0,createClass/* default */.Z)(TextureThrottler, [{
    key: "destroy",
    value: function destroy() {
      this._sources = [];
      this._data = [];
    }
  }, {
    key: "processSome",
    value: function processSome() {
      if (this._sources.length) {
        var start = Date.now();
        do {
          this._processItem();
        } while (this._sources.length && Date.now() - start < TextureThrottler.MAX_UPLOAD_TIME_PER_FRAME);
      }
    }
  }, {
    key: "_processItem",
    value: function _processItem() {
      var source = this._sources.pop();
      var data = this._data.pop();
      if (source.isLoading()) {
        source.processLoadedSource(data);
      }
    }
  }, {
    key: "add",
    value: function add(textureSource, data) {
      this._sources.push(textureSource);
      this._data.push(data);
    }
  }, {
    key: "_remove",
    value: function _remove(textureSource) {
      var index = this._sources.indexOf(textureSource);
      if (index >= 0) {
        this._sources.splice(index, 1);
        this._data.splice(index, 1);
      }
    }
  }]);
  return TextureThrottler;
}();

TextureThrottler.MAX_UPLOAD_TIME_PER_FRAME = 10;
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/tree/core/CoreContext.mjs































var CoreContext = function () {
  function CoreContext(stage) {
    (0,classCallCheck/* default */.Z)(this, CoreContext);
    this.stage = stage;
    this.root = null;
    this.updateTreeOrder = 0;
    this.renderState = this.stage.renderer.createCoreRenderState(this);
    this.renderExec = this.stage.renderer.createCoreRenderExecutor(this);
    this.renderExec.init();
    this._usedMemory = 0;
    this._renderTexturePool = [];
    this._renderTextureId = 1;
    this._zSorts = [];
    this.renderToTextureCount = 0;
  }
  (0,createClass/* default */.Z)(CoreContext, [{
    key: "usedMemory",
    get: function get() {
      return this._usedMemory;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this = this;
      this._renderTexturePool.forEach(function (texture) {
        return _this._freeRenderTexture(texture);
      });
      this._usedMemory = 0;
    }
  }, {
    key: "hasRenderUpdates",
    value: function hasRenderUpdates() {
      return !!this.root._parent._hasRenderUpdates;
    }
  }, {
    key: "render",
    value: function render() {
      this.root._parent._hasRenderUpdates = 0;
      this._render();
    }
  }, {
    key: "update",
    value: function update() {
      this._update();
      if (this.root._hasUpdates) {
        this._update();
      }
      this._performForcedZSorts();
    }
  }, {
    key: "_performForcedZSorts",
    value: function _performForcedZSorts() {
      var n = this._zSorts.length;
      if (n) {
        for (var i = 0, _n = this._zSorts.length; i < _n; i++) {
          if (this._zSorts[i].zSort) {
            this._zSorts[i].sortZIndexedChildren();
          }
        }
        this._zSorts = [];
      }
    }
  }, {
    key: "_update",
    value: function _update() {
      this.updateTreeOrder = 0;
      this.root.update();
    }
  }, {
    key: "_render",
    value: function _render() {
      var debugFrame = this.stage.getOption('debugFrame');
      this._fillRenderState();
      if (this.stage.getOption('readPixelsBeforeDraw')) {
        this._readPixels();
      }
      this._performRender();
      if (debugFrame) {
        console.log("[Lightning] RTT Renders in frame: ".concat(this.renderToTextureCount));
      }
      if (this.stage.getOption('readPixelsAfterDraw') && this.renderToTextureCount >= this.stage.getOption('readPixelsAfterDrawThreshold')) {
        if (debugFrame) {
          console.log("[Lightning] readPixelsAfterDraw behavior triggered");
        }
        this._readPixels();
      }
      this.renderToTextureCount = 0;
    }
  }, {
    key: "_readPixels",
    value: function _readPixels() {
      var pixels = new Uint8Array(4);
      var gl = this.stage.gl;
      gl.readPixels(0, 0, 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, pixels);
    }
  }, {
    key: "_fillRenderState",
    value: function _fillRenderState() {
      this.renderState.reset();
      this.root.render();
      this.renderState.finish();
    }
  }, {
    key: "_performRender",
    value: function _performRender() {
      this.renderExec.execute();
    }
  }, {
    key: "_addMemoryUsage",
    value: function _addMemoryUsage(delta) {
      this._usedMemory += delta;
      this.stage.addMemoryUsage(delta);
    }
  }, {
    key: "allocateRenderTexture",
    value: function allocateRenderTexture(w, h) {
      var prec = this.stage.getRenderPrecision();
      var pw = Math.max(1, Math.round(w * prec));
      var ph = Math.max(1, Math.round(h * prec));
      var n = this._renderTexturePool.length;
      for (var i = n - 1; i >= 0; i--) {
        var _texture = this._renderTexturePool[i];
        if (_texture.w === pw && _texture.h === ph && _texture.update !== this.stage.frameCounter) {
          _texture.f = this.stage.frameCounter;
          this._renderTexturePool.splice(i, 1);
          return _texture;
        }
      }
      var texture = this._createRenderTexture(w, h, pw, ph);
      texture.precision = prec;
      return texture;
    }
  }, {
    key: "releaseRenderTexture",
    value: function releaseRenderTexture(texture) {
      this._renderTexturePool.push(texture);
    }
  }, {
    key: "freeUnusedRenderTextures",
    value: function freeUnusedRenderTextures() {
      var _this2 = this;
      var maxAge = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 60;
      var limit = this.stage.frameCounter - maxAge;
      this._renderTexturePool = this._renderTexturePool.filter(function (texture) {
        if (texture.f <= limit) {
          _this2._freeRenderTexture(texture);
          return false;
        }
        return true;
      });
    }
  }, {
    key: "_createRenderTexture",
    value: function _createRenderTexture(w, h, pw, ph) {
      this._addMemoryUsage(pw * ph);
      var texture = this.stage.renderer.createRenderTexture(w, h, pw, ph);
      texture.id = this._renderTextureId++;
      texture.f = this.stage.frameCounter;
      texture.ow = w;
      texture.oh = h;
      texture.w = pw;
      texture.h = ph;
      return texture;
    }
  }, {
    key: "_freeRenderTexture",
    value: function _freeRenderTexture(nativeTexture) {
      this.stage.renderer.freeRenderTexture(nativeTexture);
      this._addMemoryUsage(-nativeTexture.w * nativeTexture.h);
    }
  }, {
    key: "copyRenderTexture",
    value: function copyRenderTexture(renderTexture, nativeTexture, options) {
      this.stage.renderer.copyRenderTexture(renderTexture, nativeTexture, options);
    }
  }, {
    key: "forceZSort",
    value: function forceZSort(elementCore) {
      this._zSorts.push(elementCore);
    }
  }]);
  return CoreContext;
}();

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/animation/TransitionSettings.mjs




var TransitionSettings = function () {
  function TransitionSettings(stage) {
    (0,classCallCheck/* default */.Z)(this, TransitionSettings);
    this.stage = stage;
    this._timingFunction = 'ease';
    this._timingFunctionImpl = StageUtils.getTimingFunction(this._timingFunction);
    this.delay = 0;
    this.duration = 0.2;
    this.merger = null;
  }
  (0,createClass/* default */.Z)(TransitionSettings, [{
    key: "timingFunction",
    get: function get() {
      return this._timingFunction;
    },
    set: function set(v) {
      this._timingFunction = v;
      this._timingFunctionImpl = StageUtils.getTimingFunction(v);
    }
  }, {
    key: "timingFunctionImpl",
    get: function get() {
      return this._timingFunctionImpl;
    }
  }, {
    key: "patch",
    value: function patch(settings) {
      Base.patchObject(this, settings);
    }
  }]);
  return TransitionSettings;
}();

TransitionSettings.prototype.isTransitionSettings = true;
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/animation/TransitionManager.mjs










var TransitionManager = function () {
  function TransitionManager(stage) {
    var _this = this;
    (0,classCallCheck/* default */.Z)(this, TransitionManager);
    this.stage = stage;
    this.stage.on('frameStart', function () {
      return _this.progress();
    });
    this.active = new Set();
    this.defaultTransitionSettings = new TransitionSettings(this.stage);
  }
  (0,createClass/* default */.Z)(TransitionManager, [{
    key: "progress",
    value: function progress() {
      if (this.active.size) {
        var dt = this.stage.dt;
        var filter = false;
        this.active.forEach(function (a) {
          a.progress(dt);
          if (!a.isRunning()) {
            filter = true;
          }
        });
        if (filter) {
          this.active = new Set((0,toConsumableArray/* default */.Z)(this.active).filter(function (t) {
            return t.isRunning();
          }));
        }
      }
    }
  }, {
    key: "createSettings",
    value: function createSettings(settings) {
      var transitionSettings = new TransitionSettings();
      Base.patchObject(transitionSettings, settings);
      return transitionSettings;
    }
  }, {
    key: "addActive",
    value: function addActive(transition) {
      this.active.add(transition);
    }
  }, {
    key: "removeActive",
    value: function removeActive(transition) {
      this.active.delete(transition);
    }
  }]);
  return TransitionManager;
}();




// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.string.repeat.js
var es_string_repeat = __webpack_require__(87169);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/tools/MultiSpline.mjs




var MultiSpline = function () {
  function MultiSpline() {
    (0,classCallCheck/* default */.Z)(this, MultiSpline);
    this._clear();
  }
  (0,createClass/* default */.Z)(MultiSpline, [{
    key: "_clear",
    value: function _clear() {
      this._p = [];
      this._pe = [];
      this._idp = [];
      this._f = [];
      this._v = [];
      this._lv = [];
      this._sm = [];
      this._s = [];
      this._ve = [];
      this._sme = [];
      this._se = [];
      this._length = 0;
    }
  }, {
    key: "parse",
    value: function parse(rgba, def) {
      var i, n;
      if (!Utils_Utils.isObjectLiteral(def)) {
        def = {
          0: def
        };
      }
      var defaultSmoothness = 0.5;
      var items = [];
      for (var key in def) {
        if (def.hasOwnProperty(key)) {
          var obj = def[key];
          if (!Utils_Utils.isObjectLiteral(obj)) {
            obj = {
              v: obj
            };
          }
          var p = parseFloat(key);
          if (key === "sm") {
            defaultSmoothness = obj.v;
          } else if (!isNaN(p) && p >= 0 && p <= 2) {
            obj.p = p;
            obj.f = Utils_Utils.isFunction(obj.v);
            obj.lv = obj.f ? obj.v(0, 0) : obj.v;
            items.push(obj);
          }
        }
      }
      items = items.sort(function (a, b) {
        return a.p - b.p;
      });
      n = items.length;
      for (i = 0; i < n; i++) {
        var last = i === n - 1;
        if (!items[i].hasOwnProperty('pe')) {
          items[i].pe = last ? items[i].p <= 1 ? 1 : 2 : items[i + 1].p;
        } else {
          var max = i < n - 1 ? items[i + 1].p : 1;
          if (items[i].pe > max) {
            items[i].pe = max;
          }
        }
        if (items[i].pe === items[i].p) {
          items[i].idp = 0;
        } else {
          items[i].idp = 1 / (items[i].pe - items[i].p);
        }
      }
      for (i = 0; i < n; i++) {
        if (!items[i].hasOwnProperty('sm')) {
          items[i].sm = defaultSmoothness;
        }
        if (!items[i].hasOwnProperty('s')) {
          if (i === 0 || i === n - 1 || items[i].p === 1) {
            items[i].s = rgba ? [0, 0, 0, 0] : 0;
          } else {
            var pi = items[i - 1];
            var ni = items[i + 1];
            if (pi.p === ni.p) {
              items[i].s = rgba ? [0, 0, 0, 0] : 0;
            } else {
              if (rgba) {
                var nc = MultiSpline.getRgbaComponents(ni.lv);
                var pc = MultiSpline.getRgbaComponents(pi.lv);
                var d = 1 / (ni.p - pi.p);
                items[i].s = [d * (nc[0] - pc[0]), d * (nc[1] - pc[1]), d * (nc[2] - pc[2]), d * (nc[3] - pc[3])];
              } else {
                items[i].s = (ni.lv - pi.lv) / (ni.p - pi.p);
              }
            }
          }
        }
      }
      for (i = 0; i < n - 1; i++) {
        if (!items[i].f) {
          var _last = i === n - 1;
          if (!items[i].hasOwnProperty('ve')) {
            items[i].ve = _last ? items[i].lv : items[i + 1].lv;
          }
          if (Utils_Utils.isNumber(items[i].v) && Utils_Utils.isNumber(items[i].lv)) {
            if (!items[i].hasOwnProperty('sme')) {
              items[i].sme = _last ? defaultSmoothness : items[i + 1].sm;
            }
            if (!items[i].hasOwnProperty('se')) {
              items[i].se = _last ? rgba ? [0, 0, 0, 0] : 0 : items[i + 1].s;
            }
            if (rgba) {
              items[i].v = MultiSpline.getSplineRgbaValueFunction(items[i].v, items[i].ve, items[i].p, items[i].pe, items[i].sm, items[i].sme, items[i].s, items[i].se);
            } else {
              items[i].v = MultiSpline.getSplineValueFunction(items[i].v, items[i].ve, items[i].p, items[i].pe, items[i].sm, items[i].sme, items[i].s, items[i].se);
            }
            items[i].f = true;
          }
        }
      }
      if (this.length) {
        this._clear();
      }
      for (i = 0, n = items.length; i < n; i++) {
        this._add(items[i]);
      }
    }
  }, {
    key: "_add",
    value: function _add(item) {
      this._p.push(item.p || 0);
      this._pe.push(item.pe || 0);
      this._idp.push(item.idp || 0);
      this._f.push(item.f || false);
      this._v.push(item.hasOwnProperty('v') ? item.v : 0);
      this._lv.push(item.lv || 0);
      this._sm.push(item.sm || 0);
      this._s.push(item.s || 0);
      this._ve.push(item.ve || 0);
      this._sme.push(item.sme || 0);
      this._se.push(item.se || 0);
      this._length++;
    }
  }, {
    key: "_getItem",
    value: function _getItem(p) {
      var n = this._length;
      if (!n) {
        return -1;
      }
      if (p < this._p[0]) {
        return 0;
      }
      for (var i = 0; i < n; i++) {
        if (this._p[i] <= p && p < this._pe[i]) {
          return i;
        }
      }
      return n - 1;
    }
  }, {
    key: "getValue",
    value: function getValue(p) {
      var i = this._getItem(p);
      if (i === -1) {
        return undefined;
      } else {
        if (this._f[i]) {
          var o = Math.min(1, Math.max(0, (p - this._p[i]) * this._idp[i]));
          return this._v[i](o);
        } else {
          return this._v[i];
        }
      }
    }
  }, {
    key: "length",
    get: function get() {
      return this._length;
    }
  }], [{
    key: "getRgbaComponents",
    value: function getRgbaComponents(argb) {
      var r = (argb / 65536 | 0) % 256;
      var g = (argb / 256 | 0) % 256;
      var b = argb % 256;
      var a = argb / 16777216 | 0;
      return [r, g, b, a];
    }
  }, {
    key: "getSplineValueFunction",
    value: function getSplineValueFunction(v1, v2, p1, p2, o1, i2, s1, s2) {
      var dp = p2 - p1;
      s1 *= dp;
      s2 *= dp;
      var helpers = MultiSpline.getSplineHelpers(v1, v2, o1, i2, s1, s2);
      if (!helpers) {
        return function (p) {
          if (p === 0) return v1;
          if (p === 1) return v2;
          return v2 * p + v1 * (1 - p);
        };
      } else {
        return function (p) {
          if (p === 0) return v1;
          if (p === 1) return v2;
          return MultiSpline.calculateSpline(helpers, p);
        };
      }
    }
  }, {
    key: "getSplineRgbaValueFunction",
    value: function getSplineRgbaValueFunction(v1, v2, p1, p2, o1, i2, s1, s2) {
      var dp = p2 - p1;
      s1[0] *= dp;
      s1[1] *= dp;
      s1[2] *= dp;
      s1[3] *= dp;
      s2[0] *= dp;
      s2[1] *= dp;
      s2[2] *= dp;
      s2[3] *= dp;
      var cv1 = MultiSpline.getRgbaComponents(v1);
      var cv2 = MultiSpline.getRgbaComponents(v2);
      var helpers = [MultiSpline.getSplineHelpers(cv1[0], cv2[0], o1, i2, s1[0], s2[0]), MultiSpline.getSplineHelpers(cv1[1], cv2[1], o1, i2, s1[1], s2[1]), MultiSpline.getSplineHelpers(cv1[2], cv2[2], o1, i2, s1[2], s2[2]), MultiSpline.getSplineHelpers(cv1[3], cv2[3], o1, i2, s1[3], s2[3])];
      if (!helpers[0]) {
        return function (p) {
          if (p === 0) return v1;
          if (p === 1) return v2;
          return MultiSpline.mergeColors(v2, v1, p);
        };
      } else {
        return function (p) {
          if (p === 0) return v1;
          if (p === 1) return v2;
          return MultiSpline.getArgbNumber([Math.min(255, MultiSpline.calculateSpline(helpers[0], p)), Math.min(255, MultiSpline.calculateSpline(helpers[1], p)), Math.min(255, MultiSpline.calculateSpline(helpers[2], p)), Math.min(255, MultiSpline.calculateSpline(helpers[3], p))]);
        };
      }
    }
  }, {
    key: "getSplineHelpers",
    value: function getSplineHelpers(v1, v2, o1, i2, s1, s2) {
      if (!o1 && !i2) {
        return null;
      }
      var csx = o1;
      var csy = v1 + s1 * o1;
      var cex = 1 - i2;
      var cey = v2 - s2 * i2;
      var xa = 3 * csx - 3 * cex + 1;
      var xb = -6 * csx + 3 * cex;
      var xc = 3 * csx;
      var ya = 3 * csy - 3 * cey + v2 - v1;
      var yb = 3 * (cey + v1) - 6 * csy;
      var yc = 3 * (csy - v1);
      var yd = v1;
      return [xa, xb, xc, ya, yb, yc, yd];
    }
  }, {
    key: "calculateSpline",
    value: function calculateSpline(helpers, p) {
      var xa = helpers[0];
      var xb = helpers[1];
      var xc = helpers[2];
      var ya = helpers[3];
      var yb = helpers[4];
      var yc = helpers[5];
      var yd = helpers[6];
      if (xa === -2 && ya === -2 && xc === 0 && yc === 0) {
        return p;
      }
      var t = 0.5,
        cbx,
        dx;
      for (var it = 0; it < 20; it++) {
        cbx = t * (t * (t * xa + xb) + xc);
        dx = p - cbx;
        if (dx > -1e-8 && dx < 1e-8) {
          return t * (t * (t * ya + yb) + yc) + yd;
        }
        var cbxd = t * (t * (3 * xa) + 2 * xb) + xc;
        if (cbxd > 1e-10 && cbxd < 1e-10) {
          break;
        }
        t += dx / cbxd;
      }
      var minT = 0;
      var maxT = 1;
      for (var _it = 0; _it < 20; _it++) {
        t = 0.5 * (minT + maxT);
        cbx = t * (t * (t * xa + xb) + xc);
        dx = p - cbx;
        if (dx > -1e-8 && dx < 1e-8) {
          return t * (t * (t * ya + yb) + yc) + yd;
        }
        if (dx < 0) {
          maxT = t;
        } else {
          minT = t;
        }
      }
      return t;
    }
  }, {
    key: "mergeColors",
    value: function mergeColors(c1, c2, p) {
      var r1 = (c1 / 65536 | 0) % 256;
      var g1 = (c1 / 256 | 0) % 256;
      var b1 = c1 % 256;
      var a1 = c1 / 16777216 | 0;
      var r2 = (c2 / 65536 | 0) % 256;
      var g2 = (c2 / 256 | 0) % 256;
      var b2 = c2 % 256;
      var a2 = c2 / 16777216 | 0;
      var r = r1 * p + r2 * (1 - p);
      var g = g1 * p + g2 * (1 - p);
      var b = b1 * p + b2 * (1 - p);
      var a = a1 * p + a2 * (1 - p);
      return Math.round(a) * 16777216 + Math.round(r) * 65536 + Math.round(g) * 256 + Math.round(b);
    }
  }, {
    key: "getArgbNumber",
    value: function getArgbNumber(rgba) {
      rgba[0] = Math.max(0, Math.min(255, rgba[0]));
      rgba[1] = Math.max(0, Math.min(255, rgba[1]));
      rgba[2] = Math.max(0, Math.min(255, rgba[2]));
      rgba[3] = Math.max(0, Math.min(255, rgba[3]));
      var v = ((rgba[3] | 0) << 24) + ((rgba[0] | 0) << 16) + ((rgba[1] | 0) << 8) + (rgba[2] | 0);
      if (v < 0) {
        v = 0xFFFFFFFF + v + 1;
      }
      return v;
    }
  }]);
  return MultiSpline;
}();

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/animation/AnimationActionSettings.mjs



var AnimationActionSettings = function () {
  function AnimationActionSettings(animationSettings) {
    (0,classCallCheck/* default */.Z)(this, AnimationActionSettings);
    this.animationSettings = animationSettings;
    this._selector = "";
    this._items = new MultiSpline();
    this._props = [];
    this._propSetters = [];
    this._resetValue = undefined;
    this._hasResetValue = false;
    this._hasColorProperty = undefined;
  }
  (0,createClass/* default */.Z)(AnimationActionSettings, [{
    key: "getResetValue",
    value: function getResetValue() {
      if (this._hasResetValue) {
        return this._resetValue;
      } else {
        return this._items.getValue(0);
      }
    }
  }, {
    key: "apply",
    value: function apply(element, p, factor) {
      var elements = this.getAnimatedElements(element);
      var v = this._items.getValue(p);
      if (v === undefined || !elements.length) {
        return;
      }
      if (factor !== 1) {
        var sv = this.getResetValue();
        if (Utils_Utils.isNumber(v) && Utils_Utils.isNumber(sv)) {
          if (this.hasColorProperty()) {
            v = StageUtils.mergeColors(v, sv, factor);
          } else {
            v = StageUtils.mergeNumbers(v, sv, factor);
          }
        }
      }
      var n = this._propSetters.length;
      var m = elements.length;
      for (var j = 0; j < m; j++) {
        for (var i = 0; i < n; i++) {
          this._propSetters[i](elements[j], v);
        }
      }
    }
  }, {
    key: "getAnimatedElements",
    value: function getAnimatedElements(element) {
      return element.select(this._selector);
    }
  }, {
    key: "reset",
    value: function reset(element) {
      var elements = this.getAnimatedElements(element);
      var v = this.getResetValue();
      if (v === undefined || !elements.length) {
        return;
      }
      var n = this._propSetters.length;
      var m = elements.length;
      for (var j = 0; j < m; j++) {
        for (var i = 0; i < n; i++) {
          this._propSetters[i](elements[j], v);
        }
      }
    }
  }, {
    key: "selector",
    set: function set(v) {
      this._selector = v;
    }
  }, {
    key: "t",
    set: function set(v) {
      this.selector = v;
    }
  }, {
    key: "resetValue",
    get: function get() {
      return this._resetValue;
    },
    set: function set(v) {
      this._resetValue = v;
      this._hasResetValue = v !== undefined;
    }
  }, {
    key: "rv",
    set: function set(v) {
      this.resetValue = v;
    }
  }, {
    key: "value",
    set: function set(v) {
      this._items.parse(this.hasColorProperty(), v);
    }
  }, {
    key: "v",
    set: function set(v) {
      this.value = v;
    }
  }, {
    key: "properties",
    set: function set(v) {
      var _this = this;
      if (!Array.isArray(v)) {
        v = [v];
      }
      this._props = [];
      v.forEach(function (prop) {
        _this._props.push(prop);
        _this._propSetters.push(Element.getSetter(prop));
      });
    }
  }, {
    key: "property",
    set: function set(v) {
      this._hasColorProperty = undefined;
      this.properties = v;
    }
  }, {
    key: "p",
    set: function set(v) {
      this.properties = v;
    }
  }, {
    key: "patch",
    value: function patch(settings) {
      Base.patchObject(this, settings);
    }
  }, {
    key: "hasColorProperty",
    value: function hasColorProperty() {
      if (this._hasColorProperty === undefined) {
        this._hasColorProperty = this._props.length ? Element.isColorProperty(this._props[0]) : false;
      }
      return this._hasColorProperty;
    }
  }]);
  return AnimationActionSettings;
}();

AnimationActionSettings.prototype.isAnimationActionSettings = true;





;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/animation/AnimationSettings.mjs







var AnimationSettings = function () {
  function AnimationSettings() {
    (0,classCallCheck/* default */.Z)(this, AnimationSettings);
    this._actions = [];
    this.delay = 0;
    this.duration = 1;
    this.repeat = 0;
    this.repeatOffset = 0;
    this.repeatDelay = 0;
    this.autostop = false;
    this.stopMethod = AnimationSettings.STOP_METHODS.FADE;
    this._stopTimingFunction = 'ease';
    this._stopTimingFunctionImpl = StageUtils.getTimingFunction(this._stopTimingFunction);
    this.stopDuration = 0;
    this.stopDelay = 0;
  }
  (0,createClass/* default */.Z)(AnimationSettings, [{
    key: "actions",
    get: function get() {
      return this._actions;
    },
    set: function set(v) {
      this._actions = [];
      for (var i = 0, n = v.length; i < n; i++) {
        var e = v[i];
        if (!e.isAnimationActionSettings) {
          var aas = new AnimationActionSettings(this);
          aas.patch(e);
          this._actions.push(aas);
        } else {
          this._actions.push(e);
        }
      }
    }
  }, {
    key: "apply",
    value: function apply(element, p) {
      var factor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      this._actions.forEach(function (action) {
        action.apply(element, p, factor);
      });
    }
  }, {
    key: "reset",
    value: function reset(element) {
      this._actions.forEach(function (action) {
        action.reset(element);
      });
    }
  }, {
    key: "stopTimingFunction",
    get: function get() {
      return this._stopTimingFunction;
    },
    set: function set(v) {
      this._stopTimingFunction = v;
      this._stopTimingFunctionImpl = StageUtils.getTimingFunction(v);
    }
  }, {
    key: "stopTimingFunctionImpl",
    get: function get() {
      return this._stopTimingFunctionImpl;
    }
  }, {
    key: "patch",
    value: function patch(settings) {
      Base.patchObject(this, settings);
    }
  }]);
  return AnimationSettings;
}();

AnimationSettings.STOP_METHODS = {
  FADE: 'fade',
  REVERSE: 'reverse',
  FORWARD: 'forward',
  IMMEDIATE: 'immediate',
  ONETOTWO: 'onetotwo'
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/animation/Animation.mjs






function Animation_createSuper(t) { var r = Animation_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function Animation_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (Animation_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }


var Animation = function (_EventEmitter) {
  (0,inherits/* default */.Z)(Animation, _EventEmitter);
  var _super = Animation_createSuper(Animation);
  function Animation(manager, settings, element) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, Animation);
    _this = _super.call(this);
    _this.manager = manager;
    _this._settings = settings;
    _this._element = element;
    _this._state = Animation.STATES.IDLE;
    _this._p = 0;
    _this._delayLeft = 0;
    _this._repeatsLeft = 0;
    _this._stopDelayLeft = 0;
    _this._stopP = 0;
    return _this;
  }
  (0,createClass/* default */.Z)(Animation, [{
    key: "start",
    value: function start() {
      if (this._element && this._element.attached) {
        this._p = 0;
        this._delayLeft = this.settings.delay;
        this._repeatsLeft = this.settings.repeat;
        this._state = Animation.STATES.PLAYING;
        this.emit('start');
        this.checkActive();
      } else {
        console.warn("[Lightning] Element must be attached before starting animation");
      }
    }
  }, {
    key: "play",
    value: function play() {
      if (this._state === Animation.STATES.PAUSED) {
        this._state = Animation.STATES.PLAYING;
        this.checkActive();
        this.emit('resume');
      } else if (this._state == Animation.STATES.STOPPING && this.settings.stopMethod == AnimationSettings.STOP_METHODS.REVERSE) {
        this._state = Animation.STATES.PLAYING;
        this.emit('stopContinue');
      } else if (this._state != Animation.STATES.PLAYING && this._state != Animation.STATES.FINISHED) {
        this.start();
      }
    }
  }, {
    key: "pause",
    value: function pause() {
      if (this._state === Animation.STATES.PLAYING) {
        this._state = Animation.STATES.PAUSED;
        this.emit('pause');
      }
    }
  }, {
    key: "replay",
    value: function replay() {
      if (this._state == Animation.STATES.FINISHED) {
        this.start();
      } else {
        this.play();
      }
    }
  }, {
    key: "skipDelay",
    value: function skipDelay() {
      this._delayLeft = 0;
      this._stopDelayLeft = 0;
    }
  }, {
    key: "finish",
    value: function finish() {
      if (this._state === Animation.STATES.PLAYING) {
        this._delayLeft = 0;
        this._p = 1;
      } else if (this._state === Animation.STATES.STOPPING) {
        this._stopDelayLeft = 0;
        this._p = 0;
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this._state === Animation.STATES.STOPPED || this._state === Animation.STATES.IDLE) return;
      this._stopDelayLeft = this.settings.stopDelay || 0;
      if (this.settings.stopMethod === AnimationSettings.STOP_METHODS.IMMEDIATE && !this._stopDelayLeft || this._delayLeft > 0) {
        this._state = Animation.STATES.STOPPING;
        this.emit('stop');
      } else {
        if (this.settings.stopMethod === AnimationSettings.STOP_METHODS.FADE) {
          this._stopP = 0;
        }
        this._state = Animation.STATES.STOPPING;
        this.emit('stop');
      }
      this.checkActive();
    }
  }, {
    key: "stopNow",
    value: function stopNow() {
      if (this._state !== Animation.STATES.STOPPED || this._state !== Animation.STATES.IDLE) {
        this._state = Animation.STATES.STOPPING;
        this._p = 0;
        this.emit('stop');
        this.reset();
        this._state = Animation.STATES.STOPPED;
        this.emit('stopFinish');
      }
    }
  }, {
    key: "isPaused",
    value: function isPaused() {
      return this._state === Animation.STATES.PAUSED;
    }
  }, {
    key: "isPlaying",
    value: function isPlaying() {
      return this._state === Animation.STATES.PLAYING;
    }
  }, {
    key: "isStopping",
    value: function isStopping() {
      return this._state === Animation.STATES.STOPPING;
    }
  }, {
    key: "isFinished",
    value: function isFinished() {
      return this._state === Animation.STATES.FINISHED;
    }
  }, {
    key: "checkActive",
    value: function checkActive() {
      if (this.isActive()) {
        this.manager.addActive(this);
      }
    }
  }, {
    key: "isActive",
    value: function isActive() {
      return (this._state == Animation.STATES.PLAYING || this._state == Animation.STATES.STOPPING) && this._element && this._element.attached;
    }
  }, {
    key: "progress",
    value: function progress(dt) {
      if (!this._element) return;
      this._progress(dt);
      this.apply();
    }
  }, {
    key: "_progress",
    value: function _progress(dt) {
      if (this._state == Animation.STATES.STOPPING) {
        this._stopProgress(dt);
        return;
      }
      if (this._state != Animation.STATES.PLAYING) {
        return;
      }
      if (this._delayLeft > 0) {
        this._delayLeft -= dt;
        if (this._delayLeft < 0) {
          dt = -this._delayLeft;
          this._delayLeft = 0;
          this.emit('delayEnd');
        } else {
          return;
        }
      }
      if (this.settings.duration === 0) {
        this._p = 1;
      } else if (this.settings.duration > 0) {
        this._p += dt / this.settings.duration;
      }
      if (this._p >= 1) {
        if (this.settings.repeat == -1 || this._repeatsLeft > 0) {
          if (this._repeatsLeft > 0) {
            this._repeatsLeft--;
          }
          this._p = this.settings.repeatOffset;
          this.emit('progress', this._p);
          if (this.settings.repeatDelay) {
            this._delayLeft = this.settings.repeatDelay;
          }
          this.emit('repeat', this._repeatsLeft);
        } else {
          this._p = 1;
          this.emit('progress', this._p);
          this._state = Animation.STATES.FINISHED;
          this.emit('finish');
          if (this.settings.autostop) {
            this.stop();
          }
        }
      } else {
        this.emit('progress', this._p);
      }
    }
  }, {
    key: "_stopProgress",
    value: function _stopProgress(dt) {
      var duration = this._getStopDuration();
      if (this._stopDelayLeft > 0) {
        this._stopDelayLeft -= dt;
        if (this._stopDelayLeft < 0) {
          dt = -this._stopDelayLeft;
          this._stopDelayLeft = 0;
          this.emit('stopDelayEnd');
        } else {
          return;
        }
      }
      if (this.settings.stopMethod == AnimationSettings.STOP_METHODS.IMMEDIATE) {
        this._state = Animation.STATES.STOPPED;
        this.emit('stopFinish');
      } else if (this.settings.stopMethod == AnimationSettings.STOP_METHODS.REVERSE) {
        if (duration === 0) {
          this._p = 0;
        } else if (duration > 0) {
          this._p -= dt / duration;
        }
        if (this._p <= 0) {
          this._p = 0;
          this._state = Animation.STATES.STOPPED;
          this.emit('stopFinish');
        }
      } else if (this.settings.stopMethod == AnimationSettings.STOP_METHODS.FADE) {
        this._progressStopTransition(dt);
        if (this._stopP >= 1) {
          this._p = 0;
          this._state = Animation.STATES.STOPPED;
          this.emit('stopFinish');
        }
      } else if (this.settings.stopMethod == AnimationSettings.STOP_METHODS.ONETOTWO) {
        if (this._p < 2) {
          if (duration === 0) {
            this._p = 2;
          } else if (duration > 0) {
            if (this._p < 1) {
              this._p += dt / this.settings.duration;
            } else {
              this._p += dt / duration;
            }
          }
          if (this._p >= 2) {
            this._p = 2;
            this._state = Animation.STATES.STOPPED;
            this.emit('stopFinish');
          } else {
            this.emit('progress', this._p);
          }
        }
      } else if (this.settings.stopMethod == AnimationSettings.STOP_METHODS.FORWARD) {
        if (this._p < 1) {
          if (this.settings.duration == 0) {
            this._p = 1;
          } else {
            this._p += dt / this.settings.duration;
          }
          if (this._p >= 1) {
            if (this.settings.stopMethod == AnimationSettings.STOP_METHODS.FORWARD) {
              this._p = 1;
              this._state = Animation.STATES.STOPPED;
              this.emit('stopFinish');
            } else {
              if (this._repeatsLeft > 0) {
                this._repeatsLeft--;
                this._p = 0;
                this.emit('repeat', this._repeatsLeft);
              } else {
                this._p = 1;
                this._state = Animation.STATES.STOPPED;
                this.emit('stopFinish');
              }
            }
          } else {
            this.emit('progress', this._p);
          }
        }
      }
    }
  }, {
    key: "_progressStopTransition",
    value: function _progressStopTransition(dt) {
      if (this._stopP < 1) {
        if (this._stopDelayLeft > 0) {
          this._stopDelayLeft -= dt;
          if (this._stopDelayLeft < 0) {
            dt = -this._stopDelayLeft;
            this._stopDelayLeft = 0;
            this.emit('delayEnd');
          } else {
            return;
          }
        }
        var duration = this._getStopDuration();
        if (duration == 0) {
          this._stopP = 1;
        } else {
          this._stopP += dt / duration;
        }
        if (this._stopP >= 1) {
          this._stopP = 1;
        }
      }
    }
  }, {
    key: "_getStopDuration",
    value: function _getStopDuration() {
      return this.settings.stopDuration || this.settings.duration;
    }
  }, {
    key: "apply",
    value: function apply() {
      if (this._state === Animation.STATES.STOPPED) {
        this.reset();
      } else {
        var factor = 1;
        if (this._state === Animation.STATES.STOPPING && this.settings.stopMethod === AnimationSettings.STOP_METHODS.FADE) {
          factor = 1 - this.settings.stopTimingFunctionImpl(this._stopP);
        }
        this._settings.apply(this._element, this._p, factor);
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      this._settings.reset(this._element);
    }
  }, {
    key: "state",
    get: function get() {
      return this._state;
    }
  }, {
    key: "p",
    get: function get() {
      return this._p;
    }
  }, {
    key: "delayLeft",
    get: function get() {
      return this._delayLeft;
    }
  }, {
    key: "element",
    get: function get() {
      return this._element;
    }
  }, {
    key: "frame",
    get: function get() {
      return Math.round(this._p * this._settings.duration * 60);
    }
  }, {
    key: "settings",
    get: function get() {
      return this._settings;
    }
  }]);
  return Animation;
}(EventEmitter);

Animation.STATES = {
  IDLE: 0,
  PLAYING: 1,
  STOPPING: 2,
  STOPPED: 3,
  FINISHED: 4,
  PAUSED: 5
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/animation/AnimationManager.mjs










var AnimationManager = function () {
  function AnimationManager(stage) {
    var _this = this;
    (0,classCallCheck/* default */.Z)(this, AnimationManager);
    this.stage = stage;
    this.stage.on('frameStart', function () {
      return _this.progress();
    });
    this.active = new Set();
  }
  (0,createClass/* default */.Z)(AnimationManager, [{
    key: "progress",
    value: function progress() {
      if (this.active.size) {
        var dt = this.stage.dt;
        var filter = false;
        this.active.forEach(function (a) {
          if (a.isActive()) {
            a.progress(dt);
          } else {
            filter = true;
          }
        });
        if (filter) {
          this.active = new Set((0,toConsumableArray/* default */.Z)(this.active).filter(function (t) {
            return t.isActive();
          }));
        }
      }
    }
  }, {
    key: "createAnimation",
    value: function createAnimation(element, settings) {
      if (Utils_Utils.isObjectLiteral(settings)) {
        settings = this.createSettings(settings);
      }
      return new Animation(this, settings, element);
    }
  }, {
    key: "createSettings",
    value: function createSettings(settings) {
      var animationSettings = new AnimationSettings();
      Base.patchObject(animationSettings, settings);
      return animationSettings;
    }
  }, {
    key: "addActive",
    value: function addActive(transition) {
      this.active.add(transition);
    }
  }]);
  return AnimationManager;
}();





;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/textures/RectangleTexture.mjs































function RectangleTexture_createSuper(t) { var r = RectangleTexture_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function RectangleTexture_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (RectangleTexture_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var RectangleTexture = function (_Texture) {
  (0,inherits/* default */.Z)(RectangleTexture, _Texture);
  var _super = RectangleTexture_createSuper(RectangleTexture);
  function RectangleTexture() {
    (0,classCallCheck/* default */.Z)(this, RectangleTexture);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(RectangleTexture, [{
    key: "_getLookupId",
    value: function _getLookupId() {
      return '__whitepix';
    }
  }, {
    key: "_getSourceLoader",
    value: function _getSourceLoader() {
      return function (cb) {
        var whitePixel = new Uint8Array([255, 255, 255, 255]);
        cb(null, {
          source: whitePixel,
          w: 1,
          h: 1,
          permanent: true
        });
      };
    }
  }, {
    key: "isAutosizeTexture",
    value: function isAutosizeTexture() {
      return false;
    }
  }]);
  return RectangleTexture;
}(Texture);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/tree/Stage.mjs














function Stage_createSuper(t) { var r = Stage_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function Stage_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (Stage_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }








var Stage = function (_EventEmitter) {
  (0,inherits/* default */.Z)(Stage, _EventEmitter);
  var _super = Stage_createSuper(Stage);
  function Stage() {
    var _this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0,classCallCheck/* default */.Z)(this, Stage);
    _this = _super.call(this);
    _this._setOptions(options);
    _this._usedMemory = 0;
    _this._lastGcFrame = 0;
    _this._usedVramAlpha = 0;
    _this._usedVramNonAlpha = 0;
    var platformType = Stage.platform ? Stage.platform : PlatformLoader.load(options);
    _this.platform = new platformType();
    if (_this.platform.init) {
      _this.platform.init((0,assertThisInitialized/* default */.Z)(_this));
    }
    _this.gl = null;
    _this.c2d = null;
    var context = _this.getOption('context');
    if (context) {
      if (context.useProgram) {
        _this.gl = context;
      } else {
        _this.c2d = context;
      }
    } else {
      if (Utils_Utils.isWeb && (!Stage.isWebglSupported() || _this.getOption('canvas2d'))) {
        _this.c2d = _this.platform.createCanvasContext(_this.getOption('w'), _this.getOption('h'));
      } else {
        _this.gl = _this.platform.createWebGLContext(_this.getOption('w'), _this.getOption('h'));
      }
    }
    if (_this.gl) {
      tools_WebGLStateManager.enable(_this.gl, "lightning");
    }
    _this._mode = _this.gl ? 0 : 1;
    if (_this.getCanvas()) {
      _this._options.w = _this.getCanvas().width;
      _this._options.h = _this.getCanvas().height;
    }
    if (_this._mode === 0) {
      if (Utils_Utils.isSpark) {
        _this._renderer = new SparkRenderer((0,assertThisInitialized/* default */.Z)(_this));
      } else {
        _this._renderer = new WebGLRenderer((0,assertThisInitialized/* default */.Z)(_this));
      }
    } else {
      _this._renderer = new C2dRenderer((0,assertThisInitialized/* default */.Z)(_this));
    }
    _this.setClearColor(_this.getOption('clearColor'));
    _this.frameCounter = 0;
    _this.transitions = new TransitionManager((0,assertThisInitialized/* default */.Z)(_this));
    _this.animations = new AnimationManager((0,assertThisInitialized/* default */.Z)(_this));
    _this.textureManager = new TextureManager((0,assertThisInitialized/* default */.Z)(_this));
    _this.textureThrottler = new TextureThrottler((0,assertThisInitialized/* default */.Z)(_this));
    _this.startTime = 0;
    _this.currentTime = 0;
    _this.dt = 0;
    _this.rectangleTexture = new RectangleTexture((0,assertThisInitialized/* default */.Z)(_this));
    _this.rectangleTexture.load();
    _this.rectangleTexture.source.permanent = true;
    _this.ctx = new CoreContext((0,assertThisInitialized/* default */.Z)(_this));
    _this._updateSourceTextures = new Set();
    return _this;
  }
  (0,createClass/* default */.Z)(Stage, [{
    key: "renderer",
    get: function get() {
      return this._renderer;
    }
  }, {
    key: "mode",
    get: function get() {
      return this._mode;
    }
  }, {
    key: "isWebgl",
    value: function isWebgl() {
      return this.mode === 0;
    }
  }, {
    key: "isC2d",
    value: function isC2d() {
      return this.mode === 1;
    }
  }, {
    key: "getOption",
    value: function getOption(name) {
      return this._options[name];
    }
  }, {
    key: "_setOptions",
    value: function _setOptions(o) {
      var _this2 = this;
      this._options = {};
      var opt = function opt(name, def) {
        var value = o[name];
        if (value === undefined) {
          _this2._options[name] = def;
        } else {
          _this2._options[name] = value;
        }
      };
      opt('canvas', null);
      opt('context', null);
      opt('w', 1920);
      opt('h', 1080);
      opt('srcBasePath', null);
      opt('memoryPressure', 24e6);
      opt('bufferMemory', 2e6);
      opt('textRenderIssueMargin', 0);
      opt('fontSharp', {
        precision: 0.6666666667,
        fontSize: 24
      });
      opt('clearColor', [0, 0, 0, 0]);
      opt('defaultFontFace', 'sans-serif');
      opt('fixedDt', 0);
      opt('useImageWorker', true);
      opt('autostart', true);
      opt('precision', 1);
      opt('canvas2d', false);
      opt('platform', null);
      opt('readPixelsBeforeDraw', false);
      opt('readPixelsAfterDraw', false);
      opt('readPixelsAfterDrawThreshold', 0);
      opt('debugFrame', false);
      opt('forceTxCanvasSource', false);
      opt('pauseRafLoopOnIdle', false);
    }
  }, {
    key: "setApplication",
    value: function setApplication(app) {
      this.application = app;
    }
  }, {
    key: "init",
    value: function init() {
      if (this.application.getOption('debug') && this.platform._imageWorker) {
        console.log('[Lightning] Using image worker!');
      }
      if (this.application.getOption('debug') && this.c2d) {
        console.log('[Lightning] Using canvas2d renderer');
      }
      this.application.setAsRoot();
      if (this.getOption('autostart')) {
        this.platform.startLoop();
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.platform.stopLoop();
      this.platform.destroy();
      this.ctx.destroy();
      this.textureManager.destroy();
      this._renderer.destroy();
    }
  }, {
    key: "stop",
    value: function stop() {
      this.platform.stopLoop();
    }
  }, {
    key: "resume",
    value: function resume() {
      this.platform.startLoop();
    }
  }, {
    key: "root",
    get: function get() {
      return this.application;
    }
  }, {
    key: "getCanvas",
    value: function getCanvas() {
      return this._mode ? this.c2d.canvas : this.gl.canvas;
    }
  }, {
    key: "getRenderPrecision",
    value: function getRenderPrecision() {
      return this._options.precision;
    }
  }, {
    key: "addUpdateSourceTexture",
    value: function addUpdateSourceTexture(texture) {
      if (this._updatingFrame) {
        texture._performUpdateSource();
      } else {
        this._updateSourceTextures.add(texture);
      }
    }
  }, {
    key: "removeUpdateSourceTexture",
    value: function removeUpdateSourceTexture(texture) {
      if (this._updateSourceTextures) {
        this._updateSourceTextures.delete(texture);
      }
    }
  }, {
    key: "hasUpdateSourceTexture",
    value: function hasUpdateSourceTexture(texture) {
      return this._updateSourceTextures && this._updateSourceTextures.has(texture);
    }
  }, {
    key: "_performUpdateSource",
    value: function _performUpdateSource() {
      if (this._updateSourceTextures.size) {
        this._updateSourceTextures.forEach(function (texture) {
          texture._performUpdateSource();
        });
        this._updateSourceTextures = new Set();
      }
    }
  }, {
    key: "_calculateDt",
    value: function _calculateDt() {
      this.startTime = this.currentTime;
      this.currentTime = this.platform.getHrTime();
      if (this._options.fixedDt) {
        this.dt = this._options.fixedDt;
      } else {
        this.dt = !this.startTime ? .02 : .001 * (this.currentTime - this.startTime);
      }
    }
  }, {
    key: "updateFrame",
    value: function updateFrame() {
      this._calculateDt();
      this.emit('frameStart');
      this._performUpdateSource();
      this.emit('update');
    }
  }, {
    key: "idleFrame",
    value: function idleFrame() {
      this.textureThrottler.processSome();
      this.emit('frameEnd');
      this.frameCounter++;
    }
  }, {
    key: "renderFrame",
    value: function renderFrame() {
      var changes = this.ctx.hasRenderUpdates();
      this.textureThrottler.processSome();
      if (changes) {
        this._updatingFrame = true;
        this.ctx.update();
        this.ctx.render();
        this._updatingFrame = false;
      }
      this.platform.nextFrame(changes);
      this.emit('frameEnd');
      this.frameCounter++;
    }
  }, {
    key: "isUpdatingFrame",
    value: function isUpdatingFrame() {
      return this._updatingFrame;
    }
  }, {
    key: "drawFrame",
    value: function drawFrame() {
      this.updateFrame();
      this.renderFrame();
    }
  }, {
    key: "forceRenderUpdate",
    value: function forceRenderUpdate() {
      if (this.root) {
        this.root.core._parent.setHasRenderUpdates(1);
      }
    }
  }, {
    key: "setClearColor",
    value: function setClearColor(clearColor) {
      this.forceRenderUpdate();
      if (clearColor === null) {
        this._clearColor = null;
      } else if (Array.isArray(clearColor)) {
        this._clearColor = clearColor;
      } else {
        this._clearColor = StageUtils.getRgbaComponentsNormalized(clearColor);
      }
    }
  }, {
    key: "getClearColor",
    value: function getClearColor() {
      return this._clearColor;
    }
  }, {
    key: "createElement",
    value: function createElement(settings) {
      if (settings) {
        return this.element(settings);
      } else {
        return new Element(this);
      }
    }
  }, {
    key: "createShader",
    value: function createShader(settings) {
      return Shader.create(this, settings);
    }
  }, {
    key: "element",
    value: function element(settings) {
      if (settings.isElement) return settings;
      var element;
      if (settings.type) {
        element = new settings.type(this);
      } else {
        element = new Element(this);
      }
      element.patch(settings);
      return element;
    }
  }, {
    key: "c",
    value: function c(settings) {
      return this.element(settings);
    }
  }, {
    key: "w",
    get: function get() {
      return this._options.w;
    }
  }, {
    key: "h",
    get: function get() {
      return this._options.h;
    }
  }, {
    key: "coordsWidth",
    get: function get() {
      return this.w / this._options.precision;
    }
  }, {
    key: "coordsHeight",
    get: function get() {
      return this.h / this._options.precision;
    }
  }, {
    key: "addMemoryUsage",
    value: function addMemoryUsage(delta) {
      this._usedMemory += delta;
      if (this._lastGcFrame !== this.frameCounter) {
        if (this._usedMemory > this.getOption('memoryPressure')) {
          this.gc(false);
          if (this._usedMemory > this.getOption('memoryPressure') - 2e6) {
            this.gc(true);
          }
        }
      }
    }
  }, {
    key: "usedMemory",
    get: function get() {
      return this._usedMemory;
    }
  }, {
    key: "addVramUsage",
    value: function addVramUsage(delta, alpha) {
      if (alpha) {
        this._usedVramAlpha += delta;
      } else {
        this._usedVramNonAlpha += delta;
      }
    }
  }, {
    key: "usedVramAlpha",
    get: function get() {
      return this._usedVramAlpha;
    }
  }, {
    key: "usedVramNonAlpha",
    get: function get() {
      return this._usedVramNonAlpha;
    }
  }, {
    key: "usedVram",
    get: function get() {
      return this._usedVramAlpha + this._usedVramNonAlpha;
    }
  }, {
    key: "gc",
    value: function gc(aggressive) {
      if (this._lastGcFrame !== this.frameCounter) {
        this._lastGcFrame = this.frameCounter;
        var memoryUsageBefore = this._usedMemory;
        this.gcTextureMemory(aggressive);
        this.gcRenderTextureMemory(aggressive);
        this.renderer.gc(aggressive);
        if (this.application.getOption('debug')) {
          console.log("[Lightning] GC".concat(aggressive ? "[aggressive]" : "", "! Frame ").concat(this._lastGcFrame, " Freed ").concat(((memoryUsageBefore - this._usedMemory) / 1e6).toFixed(2), "MP from GPU memory. Remaining: ").concat((this._usedMemory / 1e6).toFixed(2), "MP"));
          var other = this._usedMemory - this.textureManager.usedMemory - this.ctx.usedMemory;
          console.log("[Lightning] Textures: ".concat((this.textureManager.usedMemory / 1e6).toFixed(2), "MP, Render Textures: ").concat((this.ctx.usedMemory / 1e6).toFixed(2), "MP, Renderer caches: ").concat((other / 1e6).toFixed(2), "MP"));
        }
      }
    }
  }, {
    key: "gcTextureMemory",
    value: function gcTextureMemory() {
      var aggressive = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (aggressive && this.ctx.root.visible) {
        this.ctx.root.visible = false;
        this.textureManager.gc();
        this.ctx.root.visible = true;
      } else {
        this.textureManager.gc();
      }
    }
  }, {
    key: "gcRenderTextureMemory",
    value: function gcRenderTextureMemory() {
      var aggressive = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (aggressive && this.root.visible) {
        this.root.visible = false;
        this.ctx.freeUnusedRenderTextures(0);
        this.root.visible = true;
      } else {
        this.ctx.freeUnusedRenderTextures(0);
      }
    }
  }, {
    key: "getDrawingCanvas",
    value: function getDrawingCanvas() {
      return this.platform.getDrawingCanvas();
    }
  }, {
    key: "update",
    value: function update() {
      this.ctx.update();
    }
  }, {
    key: "addServiceProvider",
    value: function addServiceProvider(serviceprovider) {
      if (Utils_Utils.isSpark) {
        this.platform.addServiceProvider(serviceprovider);
      }
    }
  }, {
    key: "getChildrenByPosition",
    value: function getChildrenByPosition(x, y) {
      var children = [];
      this.root.core.update();
      this.root.core.collectAtCoord(x, y, children);
      return children;
    }
  }], [{
    key: "isWebglSupported",
    value: function isWebglSupported() {
      if (Utils_Utils.isNode) {
        return true;
      }
      try {
        return !!window.WebGLRenderingContext;
      } catch (e) {
        return false;
      }
    }
  }]);
  return Stage;
}(EventEmitter);









;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/application/Application.mjs


















function Application_createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = Application_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n5 = 0, F = function F() {}; return { s: F, n: function n() { return _n5 >= r.length ? { done: !0 } : { done: !1, value: r[_n5++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function Application_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return Application_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? Application_arrayLikeToArray(r, a) : void 0; } }
function Application_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function Application_createSuper(t) { var r = Application_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function Application_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (Application_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }


var Application = function (_Component) {
  (0,inherits/* default */.Z)(Application, _Component);
  var _super = Application_createSuper(Application);
  function Application() {
    var _this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var properties = arguments.length > 1 ? arguments[1] : undefined;
    (0,classCallCheck/* default */.Z)(this, Application);
    Application._temp_options = options;
    Application.booting = true;
    var stage = new Stage(options.stage);
    _this = _super.call(this, stage, properties);
    Application.booting = false;
    _this.__updateFocusCounter = 0;
    _this.__keypressTimers = new Map();
    _this.__hoveredChild = null;
    _this.stage.init();
    _this.updateFocusSettings();
    _this.__keymap = _this.getOption('keys');
    if (_this.__keymap) {
      _this.stage.platform.registerKeydownHandler(function (e) {
        _this._receiveKeydown(e);
      });
      _this.stage.platform.registerKeyupHandler(function (e) {
        _this._receiveKeyup(e);
      });
    }
    if (_this.getOption("enablePointer")) {
      _this.stage.platform.registerClickHandler(function (e) {
        _this._receiveClick(e);
      });
      _this.stage.platform.registerHoverHandler(function (e) {
        _this._receiveHover(e);
      });
      _this.stage.platform.registerScrollWheelHandler(function (e) {
        _this._recieveScrollWheel(e);
      });
      _this.cursor = 'default';
    }
    return _this;
  }
  (0,createClass/* default */.Z)(Application, [{
    key: "getOption",
    value: function getOption(name) {
      return this.__options[name];
    }
  }, {
    key: "_setOptions",
    value: function _setOptions(o) {
      var _this2 = this;
      this.__options = {};
      var opt = function opt(name, def) {
        var value = o[name];
        if (value === undefined) {
          _this2.__options[name] = def;
        } else {
          _this2.__options[name] = value;
        }
      };
      opt('debug', false);
      opt('keys', {
        38: "Up",
        40: "Down",
        37: "Left",
        39: "Right",
        13: "Enter",
        8: "Back",
        27: "Exit"
      });
      opt('enablePointer', false);
    }
  }, {
    key: "__construct",
    value: function __construct() {
      this.stage.setApplication(this);
      this._setOptions(Application._temp_options);
      delete Application._temp_options;
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(Application.prototype), "__construct", this).call(this);
    }
  }, {
    key: "__init",
    value: function __init() {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(Application.prototype), "__init", this).call(this);
      this.__updateFocus();
    }
  }, {
    key: "updateFocusPath",
    value: function updateFocusPath() {
      this.__updateFocus();
    }
  }, {
    key: "__updateFocus",
    value: function __updateFocus() {
      var notOverridden = this.__updateFocusRec();
      if (!Application.booting && notOverridden) {
        this.updateFocusSettings();
      }
    }
  }, {
    key: "__updateFocusRec",
    value: function __updateFocusRec() {
      var updateFocusId = ++this.__updateFocusCounter;
      this.__updateFocusId = updateFocusId;
      var newFocusPath = this.__getFocusPath();
      var newFocusedComponent = newFocusPath[newFocusPath.length - 1];
      var prevFocusedComponent = this._focusPath ? this._focusPath[this._focusPath.length - 1] : undefined;
      if (!prevFocusedComponent) {
        this._focusPath = [];
        for (var i = 0, n = newFocusPath.length; i < n; i++) {
          this._focusPath.push(newFocusPath[i]);
          this._focusPath[i]._focus(newFocusedComponent, undefined);
          var focusOverridden = this.__updateFocusId !== updateFocusId;
          if (focusOverridden) {
            return false;
          }
        }
        return true;
      } else {
        var m = Math.min(this._focusPath.length, newFocusPath.length);
        var index;
        for (index = 0; index < m; index++) {
          if (this._focusPath[index] !== newFocusPath[index]) {
            break;
          }
        }
        if (this._focusPath.length !== newFocusPath.length || index !== newFocusPath.length) {
          if (this.getOption('debug')) {
            console.log('[Lightning] Focus changed: ' + newFocusedComponent.getLocationString());
          }
          for (var _i = this._focusPath.length - 1; _i >= index; _i--) {
            var unfocusedElement = this._focusPath.pop();
            unfocusedElement._unfocus(newFocusedComponent, prevFocusedComponent);
            var _focusOverridden = this.__updateFocusId !== updateFocusId;
            if (_focusOverridden) {
              return false;
            }
          }
          for (var _i2 = index, _n = newFocusPath.length; _i2 < _n; _i2++) {
            this._focusPath.push(newFocusPath[_i2]);
            this._focusPath[_i2]._focus(newFocusedComponent, prevFocusedComponent);
            var _focusOverridden2 = this.__updateFocusId !== updateFocusId;
            if (_focusOverridden2) {
              return false;
            }
          }
          for (var _i3 = 0; _i3 < index; _i3++) {
            this._focusPath[_i3]._focusChange(newFocusedComponent, prevFocusedComponent);
          }
        }
      }
      return true;
    }
  }, {
    key: "updateFocusSettings",
    value: function updateFocusSettings() {
      var focusedComponent = this._focusPath[this._focusPath.length - 1];
      var focusSettings = {};
      var defaultSetFocusSettings = Component.prototype._setFocusSettings;
      for (var i = 0, n = this._focusPath.length; i < n; i++) {
        if (this._focusPath[i]._setFocusSettings !== defaultSetFocusSettings) {
          this._focusPath[i]._setFocusSettings(focusSettings);
        }
      }
      var defaultHandleFocusSettings = Component.prototype._handleFocusSettings;
      for (var _i4 = 0, _n2 = this._focusPath.length; _i4 < _n2; _i4++) {
        if (this._focusPath[_i4]._handleFocusSettings !== defaultHandleFocusSettings) {
          this._focusPath[_i4]._handleFocusSettings(focusSettings, this.__prevFocusSettings, focusedComponent);
        }
      }
      this.__prevFocusSettings = focusSettings;
    }
  }, {
    key: "_handleFocusSettings",
    value: function _handleFocusSettings(settings, prevSettings, focused, prevFocused) {}
  }, {
    key: "__getFocusPath",
    value: function __getFocusPath() {
      var path = [this];
      var current = this;
      do {
        var nextFocus = current._getFocused();
        if (!nextFocus || nextFocus === current) {
          break;
        }
        var ptr = nextFocus.cparent;
        if (ptr === current) {
          path.push(nextFocus);
        } else {
          var newParts = [nextFocus];
          do {
            if (!ptr) {
              current._throwError("Return value for _getFocused must be an attached descendant component but its '" + nextFocus.getLocationString() + "'");
            }
            newParts.push(ptr);
            ptr = ptr.cparent;
          } while (ptr !== current);
          for (var i = 0, n = newParts.length; i < n; i++) {
            path.push(newParts[n - i - 1]);
          }
        }
        current = nextFocus;
      } while (true);
      return path;
    }
  }, {
    key: "focusPath",
    get: function get() {
      return this._focusPath;
    }
  }, {
    key: "focusTopDownEvent",
    value: function focusTopDownEvent(events) {
      var path = this.focusPath;
      var n = path.length;
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      for (var i = 0; i < n; i++) {
        var event = path[i]._getMostSpecificHandledMember(events);
        if (event !== undefined) {
          var _path$i;
          var returnValue = (_path$i = path[i])[event].apply(_path$i, args);
          if (returnValue !== false) {
            return true;
          }
        }
      }
      return false;
    }
  }, {
    key: "focusBottomUpEvent",
    value: function focusBottomUpEvent(events) {
      var path = this.focusPath;
      var n = path.length;
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      for (var i = n - 1; i >= 0; i--) {
        var event = path[i]._getMostSpecificHandledMember(events);
        if (event !== undefined) {
          var _path$i2;
          var returnValue = (_path$i2 = path[i])[event].apply(_path$i2, args);
          if (returnValue !== false) {
            return true;
          }
        }
      }
      return false;
    }
  }, {
    key: "_receiveKeydown",
    value: function _receiveKeydown(e) {
      var obj = e;
      var key = this.__keymap[e.keyCode];
      var path = this.focusPath;
      var keys;
      if (key) {
        keys = Array.isArray(key) ? key : [key];
      }
      if (keys) {
        for (var i = 0, n = keys.length; i < n; i++) {
          var hasTimer = this.__keypressTimers.has(keys[i]);
          if (path[path.length - 1].longpress && hasTimer) {
            return;
          }
          if (!this.stage.application.focusTopDownEvent(["_capture".concat(keys[i]), "_captureKey"], obj)) {
            this.stage.application.focusBottomUpEvent(["_handle".concat(keys[i]), "_handleKey"], obj);
          }
        }
      } else {
        if (!this.stage.application.focusTopDownEvent(["_captureKey"], obj)) {
          this.stage.application.focusBottomUpEvent(["_handleKey"], obj);
        }
      }
      this.updateFocusPath();
      var consumer = path[path.length - 1];
      if (keys && consumer.longpress) {
        for (var _i5 = 0, _n3 = keys.length; _i5 < _n3; _i5++) {
          this._startLongpressTimer(keys[_i5], consumer);
        }
      }
    }
  }, {
    key: "_receiveKeyup",
    value: function _receiveKeyup(e) {
      var obj = e;
      var key = this.__keymap[e.keyCode];
      var keys;
      if (key) {
        keys = Array.isArray(key) ? key : [key];
      }
      if (keys) {
        for (var i = 0, n = keys.length; i < n; i++) {
          if (!this.stage.application.focusTopDownEvent(["_capture".concat(keys[i], "Release"), "_captureKeyRelease"], obj)) {
            this.stage.application.focusBottomUpEvent(["_handle".concat(keys[i], "Release"), "_handleKeyRelease"], obj);
          }
        }
      } else {
        if (!this.stage.application.focusTopDownEvent(["_captureKeyRelease"], obj)) {
          this.stage.application.focusBottomUpEvent(["_handleKeyRelease"], obj);
        }
      }
      this.updateFocusPath();
      if (keys) {
        for (var _i6 = 0, _n4 = keys.length; _i6 < _n4; _i6++) {
          if (this.__keypressTimers.has(keys[_i6])) {
            clearTimeout(this.__keypressTimers.get(keys[_i6]));
            this.__keypressTimers.delete(keys[_i6]);
          }
        }
      }
    }
  }, {
    key: "_startLongpressTimer",
    value: function _startLongpressTimer(key, element) {
      var _this3 = this;
      var config = element.longpress;
      var lookup = key.toLowerCase();
      if (config[lookup]) {
        var timeout = config[lookup];
        if (!Utils_Utils.isNumber(timeout)) {
          element._throwError("config value for longpress must be a number");
        } else {
          this.__keypressTimers.set(key, setTimeout(function () {
            if (!_this3.stage.application.focusTopDownEvent(["_capture".concat(key, "Long"), "_captureKey"], {})) {
              _this3.stage.application.focusBottomUpEvent(["_handle".concat(key, "Long"), "_handleKey"], {});
            }
            _this3.__keypressTimers.delete(key);
          }, timeout || 500));
        }
      }
      return;
    }
  }, {
    key: "_recieveScrollWheel",
    value: function _recieveScrollWheel(e) {
      var obj = e;
      var clientX = obj.clientX,
        clientY = obj.clientY;
      if (clientX <= this.stage.w && clientY <= this.stage.h) {
        if (!this.fireTopDownScrollWheelHandler("_captureScroll", obj)) {
          this.fireBottomUpScrollWheelHandler("_handleScroll", obj);
        }
      }
    }
  }, {
    key: "fireTopDownScrollWheelHandler",
    value: function fireTopDownScrollWheelHandler(event, obj) {
      var children = this.stage.application.children;
      var affected = this._findChildren([], children).reverse();
      var n = affected.length;
      while (n--) {
        var child = affected[n];
        if (child && child[event]) {
          child._captureScroll(obj);
          return true;
        }
      }
      return false;
    }
  }, {
    key: "fireBottomUpScrollWheelHandler",
    value: function fireBottomUpScrollWheelHandler(event, obj) {
      var clientX = obj.clientX,
        clientY = obj.clientY;
      var target = this._getTargetChild(clientX, clientY);
      var child = target;
      while (child !== null) {
        if (child && child[event]) {
          child._handleScroll(obj);
          return true;
        }
        child = child.parent;
      }
      return false;
    }
  }, {
    key: "_receiveClick",
    value: function _receiveClick(e) {
      var obj = e;
      var clientX = obj.clientX,
        clientY = obj.clientY;
      if (clientX <= this.stage.w && clientY <= this.stage.h) {
        this.stage.application.fireBottomUpClickHandler(obj);
      }
    }
  }, {
    key: "fireBottomUpClickHandler",
    value: function fireBottomUpClickHandler(obj) {
      var clientX = obj.clientX,
        clientY = obj.clientY;
      var target = this._getTargetChild(clientX, clientY);
      var child = target;
      while (child !== null) {
        if (child && child["_handleClick"]) {
          child._handleClick(target);
          break;
        }
        child = child.parent;
      }
    }
  }, {
    key: "_receiveHover",
    value: function _receiveHover(e) {
      var obj = e;
      var clientX = obj.clientX,
        clientY = obj.clientY;
      if (clientX <= this.stage.w && clientY <= this.stage.h) {
        this.stage.application.fireBottomUpHoverHandler(obj);
      }
    }
  }, {
    key: "fireBottomUpHoverHandler",
    value: function fireBottomUpHoverHandler(obj) {
      var clientX = obj.clientX,
        clientY = obj.clientY;
      var target = this._getTargetChild(clientX, clientY);
      if (target !== this.__hoveredChild) {
        var hoveredBranch = new Set();
        var newHoveredBranch = new Set();
        if (target) {
          newHoveredBranch = new Set(target.getAncestors());
        }
        if (this.__hoveredChild) {
          hoveredBranch = new Set(this.__hoveredChild.getAncestors());
          var _iterator = Application_createForOfIteratorHelper((0,toConsumableArray/* default */.Z)(hoveredBranch).filter(function (e) {
              return !newHoveredBranch.has(e);
            })),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var elem = _step.value;
              var c = Component.getComponent(elem);
              if (c["_handleUnhover"]) {
                c._handleUnhover(elem);
              }
              if (elem.parent && elem.parent.cursor) {
                this.stage.getCanvas().style.cursor = elem.parent.cursor;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
        this.__hoveredChild = target;
        var diffBranch = (0,toConsumableArray/* default */.Z)(newHoveredBranch).filter(function (e) {
          return !hoveredBranch.has(e);
        });
        var _iterator2 = Application_createForOfIteratorHelper(diffBranch),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _elem = _step2.value;
            var _c2 = Component.getComponent(_elem);
            if (_c2["_handleHover"]) {
              _c2._handleHover(_elem);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        var lastElement = diffBranch[0];
        if (lastElement && lastElement.cursor) {
          this.stage.getCanvas().style.cursor = lastElement.cursor;
        }
        if (diffBranch.length === 0 && target) {
          var _c = Component.getComponent(target);
          if (_c["_handleHover"]) {
            _c._handleHover(target);
          }
        }
      }
    }
  }, {
    key: "_getTargetChild",
    value: function _getTargetChild(clientX, clientY) {
      var children = this.stage.application.children;
      var affected = this._findChildren([], children);
      var hoverableChildren = this._withinClickableRange(affected, clientX, clientY);
      hoverableChildren.sort(function (a, b) {
        if (a.zIndex > b.zIndex) {
          return 1;
        } else if (a.zIndex < b.zIndex) {
          return -1;
        } else {
          return a.id > b.id ? 1 : -1;
        }
      });
      if (hoverableChildren.length) {
        return hoverableChildren.slice(-1)[0];
      } else {
        return null;
      }
    }
  }, {
    key: "_findChildren",
    value: function _findChildren(bucket, children) {
      var n = children.length;
      while (n--) {
        var child = children[n];
        if (child.__active && child.collision) {
          if (child.collision === true) {
            bucket.push(child);
          }
          if (child.hasChildren()) {
            this._findChildren(bucket, child.children);
          }
        }
      }
      return bucket;
    }
  }, {
    key: "_withinClickableRange",
    value: function _withinClickableRange(affectedChildren, cursorX, cursorY) {
      var _this4 = this;
      var n = affectedChildren.length;
      var candidates = [];
      var _loop = function _loop() {
        var child = affectedChildren[n];
        var precision = _this4.stage.getRenderPrecision();
        var ctx = child.core._worldContext;
        var cx = ctx.px * precision;
        var cy = ctx.py * precision;
        var cw = child.finalW * ctx.ta * precision;
        var ch = child.finalH * ctx.td * precision;
        if (cx > _this4.stage.w || cy > _this4.stage.h) {
          return "continue";
        }
        if (child.parent.core._scissor) {
          var scissor = child.parent.core._scissor.map(function (v) {
            return v * precision;
          });
          if (!_this4._testCollision.apply(_this4, [cursorX, cursorY].concat((0,toConsumableArray/* default */.Z)(scissor)))) return "continue";
        }
        if (_this4._testCollision(cursorX, cursorY, cx, cy, cw, ch)) {
          candidates.push(child);
        }
      };
      while (n--) {
        var _ret = _loop();
        if (_ret === "continue") continue;
      }
      return candidates;
    }
  }, {
    key: "_testCollision",
    value: function _testCollision(px, py, cx, cy, cw, ch) {
      if (px >= cx && px <= cx + cw && py >= cy && py <= cy + ch) {
        return true;
      }
      return false;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (!this._destroyed) {
        this._destroy();
        this.stage.destroy();
        this._destroyed = true;
      }
    }
  }, {
    key: "_destroy",
    value: function _destroy() {
      this.stage.setApplication(undefined);
      this._updateAttachedFlag();
      this._updateEnabledFlag();
      if (this.__keypressTimers.size) {
        var _iterator3 = Application_createForOfIteratorHelper(this.__keypressTimers.values()),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var timer = _step3.value;
            clearTimeout(timer);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        this.__keypressTimers.clear();
      }
    }
  }, {
    key: "getCanvas",
    value: function getCanvas() {
      return this.stage.getCanvas();
    }
  }]);
  return Application;
}(Component);


;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/textures/StaticCanvasTexture.mjs





function StaticCanvasTexture_createSuper(t) { var r = StaticCanvasTexture_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function StaticCanvasTexture_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (StaticCanvasTexture_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var StaticCanvasTexture = function (_Texture) {
  (0,inherits/* default */.Z)(StaticCanvasTexture, _Texture);
  var _super = StaticCanvasTexture_createSuper(StaticCanvasTexture);
  function StaticCanvasTexture(stage) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, StaticCanvasTexture);
    _this = _super.call(this, stage);
    _this._factory = undefined;
    _this._lookupId = undefined;
    return _this;
  }
  (0,createClass/* default */.Z)(StaticCanvasTexture, [{
    key: "content",
    set: function set(_ref) {
      var factory = _ref.factory,
        _ref$lookupId = _ref.lookupId,
        lookupId = _ref$lookupId === void 0 ? undefined : _ref$lookupId;
      this._factory = factory;
      this._lookupId = lookupId;
      this._changed();
    }
  }, {
    key: "_getIsValid",
    value: function _getIsValid() {
      return !!this._factory;
    }
  }, {
    key: "_getLookupId",
    value: function _getLookupId() {
      return this._lookupId;
    }
  }, {
    key: "_getSourceLoader",
    value: function _getSourceLoader() {
      var _this2 = this;
      var f = this._factory;
      return function (cb) {
        return f(function (err, canvas) {
          if (err) {
            return cb(err);
          }
          cb(null, _this2.stage.platform.getTextureOptionsForDrawingCanvas(canvas));
        }, _this2.stage);
      };
    }
  }]);
  return StaticCanvasTexture;
}(Texture);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/tools/Tools.mjs








var Tools = function () {
  function Tools() {
    (0,classCallCheck/* default */.Z)(this, Tools);
  }
  (0,createClass/* default */.Z)(Tools, null, [{
    key: "getCanvasTexture",
    value: function getCanvasTexture(canvasFactory, lookupId) {
      return {
        type: StaticCanvasTexture,
        content: {
          factory: canvasFactory,
          lookupId: lookupId
        }
      };
    }
  }, {
    key: "getRoundRect",
    value: function getRoundRect(w, h, radius, strokeWidth, strokeColor, fill, fillColor) {
      var _this = this;
      if (!Array.isArray(radius)) {
        radius = [radius, radius, radius, radius];
      }
      var factory = function factory(cb, stage) {
        if (Utils_Utils.isSpark) {
          stage.platform.createRoundRect(cb, stage, w, h, radius, strokeWidth, strokeColor, fill, fillColor);
        } else {
          cb(null, _this.createRoundRect(stage, w, h, radius, strokeWidth, strokeColor, fill, fillColor));
        }
      };
      var id = 'rect' + [w, h, strokeWidth, strokeColor, fill ? 1 : 0, fillColor].concat(radius).join(",");
      return Tools.getCanvasTexture(factory, id);
    }
  }, {
    key: "createRoundRect",
    value: function createRoundRect(stage, w, h, radius, strokeWidth, strokeColor, fill, fillColor) {
      if (fill === undefined) fill = true;
      if (strokeWidth === undefined) strokeWidth = 0;
      var canvas = stage.platform.getDrawingCanvas();
      var ctx = canvas.getContext('2d');
      ctx.imageSmoothingEnabled = true;
      canvas.width = w + strokeWidth + 2;
      canvas.height = h + strokeWidth + 2;
      ctx.beginPath();
      var x = 0.5 * strokeWidth + 1,
        y = 0.5 * strokeWidth + 1;
      ctx.moveTo(x + radius[0], y);
      ctx.lineTo(x + w - radius[1], y);
      ctx.arcTo(x + w, y, x + w, y + radius[1], radius[1]);
      ctx.lineTo(x + w, y + h - radius[2]);
      ctx.arcTo(x + w, y + h, x + w - radius[2], y + h, radius[2]);
      ctx.lineTo(x + radius[3], y + h);
      ctx.arcTo(x, y + h, x, y + h - radius[3], radius[3]);
      ctx.lineTo(x, y + radius[0]);
      ctx.arcTo(x, y, x + radius[0], y, radius[0]);
      ctx.closePath();
      if (fill) {
        if (Utils_Utils.isNumber(fillColor)) {
          ctx.fillStyle = StageUtils.getRgbaString(fillColor);
        } else {
          ctx.fillStyle = "white";
        }
        ctx.fill();
      }
      if (strokeWidth) {
        if (Utils_Utils.isNumber(strokeColor)) {
          ctx.strokeStyle = StageUtils.getRgbaString(strokeColor);
        } else {
          ctx.strokeStyle = "white";
        }
        ctx.lineWidth = strokeWidth;
        ctx.stroke();
      }
      return canvas;
    }
  }, {
    key: "getShadowRect",
    value: function getShadowRect(w, h) {
      var _this2 = this;
      var radius = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var blur = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 5;
      var margin = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : blur * 2;
      if (!Array.isArray(radius)) {
        radius = [radius, radius, radius, radius];
      }
      var factory = function factory(cb, stage) {
        if (Utils_Utils.isSpark) {
          stage.platform.createShadowRect(cb, stage, w, h, radius, blur, margin);
        } else {
          cb(null, _this2.createShadowRect(stage, w, h, radius, blur, margin));
        }
      };
      var id = 'shadow' + [w, h, blur, margin].concat(radius).join(",");
      return Tools.getCanvasTexture(factory, id);
    }
  }, {
    key: "createShadowRect",
    value: function createShadowRect(stage, w, h, radius, blur, margin) {
      var canvas = stage.platform.getDrawingCanvas();
      var ctx = canvas.getContext('2d');
      ctx.imageSmoothingEnabled = true;
      canvas.width = w + margin * 2;
      canvas.height = h + margin * 2;
      ctx.globalAlpha = 0.01;
      ctx.fillRect(0, 0, 0.01, 0.01);
      ctx.globalAlpha = 1.0;
      ctx.shadowColor = StageUtils.getRgbaString(0xFFFFFFFF);
      ctx.fillStyle = StageUtils.getRgbaString(0xFFFFFFFF);
      ctx.shadowBlur = blur;
      ctx.shadowOffsetX = w + 10 + margin;
      ctx.shadowOffsetY = margin;
      ctx.beginPath();
      var x = -(w + 10);
      var y = 0;
      ctx.moveTo(x + radius[0], y);
      ctx.lineTo(x + w - radius[1], y);
      ctx.arcTo(x + w, y, x + w, y + radius[1], radius[1]);
      ctx.lineTo(x + w, y + h - radius[2]);
      ctx.arcTo(x + w, y + h, x + w - radius[2], y + h, radius[2]);
      ctx.lineTo(x + radius[3], y + h);
      ctx.arcTo(x, y + h, x, y + h - radius[3], radius[3]);
      ctx.lineTo(x, y + radius[0]);
      ctx.arcTo(x, y, x + radius[0], y, radius[0]);
      ctx.closePath();
      ctx.fill();
      return canvas;
    }
  }, {
    key: "getSvgTexture",
    value: function getSvgTexture(url, w, h) {
      var _this3 = this;
      var factory = function factory(cb, stage) {
        if (Utils_Utils.isSpark) {
          stage.platform.createSvg(cb, stage, url, w, h);
        } else {
          _this3.createSvg(cb, stage, url, w, h);
        }
      };
      var id = 'svg' + [w, h, url].join(",");
      return Tools.getCanvasTexture(factory, id);
    }
  }, {
    key: "createSvg",
    value: function createSvg(cb, stage, url, w, h) {
      var canvas = stage.platform.getDrawingCanvas();
      var ctx = canvas.getContext('2d');
      ctx.imageSmoothingEnabled = true;
      var img = new Image();
      img.onload = function () {
        canvas.width = w;
        canvas.height = h;
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        cb(null, canvas);
      };
      img.onError = function (err) {
        cb(err);
      };
      if (!Utils_Utils.isPS4) {
        img.crossOrigin = "Anonymous";
      }
      img.src = url;
    }
  }]);
  return Tools;
}();

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/tools/ObjMerger.mjs




var ObjMerger = function () {
  function ObjMerger() {
    (0,classCallCheck/* default */.Z)(this, ObjMerger);
  }
  (0,createClass/* default */.Z)(ObjMerger, null, [{
    key: "isMf",
    value: function isMf(f) {
      return Utils_Utils.isFunction(f) && f.__mf;
    }
  }, {
    key: "mf",
    value: function mf(f) {
      f.__mf = true;
      return f;
    }
  }, {
    key: "merge",
    value: function merge(a, b) {
      var aks = Object.keys(a);
      var bks = Object.keys(b);
      if (!bks.length) {
        return a;
      }
      var ai = {};
      var bi = {};
      for (var i = 0, n = bks.length; i < n; i++) {
        var key = bks[i];
        ai[key] = -1;
        bi[key] = i;
      }
      for (var _i = 0, _n = aks.length; _i < _n; _i++) {
        var _key = aks[_i];
        ai[_key] = _i;
        if (bi[_key] === undefined) {
          bi[_key] = -1;
        }
      }
      var aksl = aks.length;
      var result = {};
      for (var _i2 = 0, _n2 = bks.length; _i2 < _n2; _i2++) {
        var _key2 = bks[_i2];
        var aIndex = ai[_key2];
        var _curIndex = aIndex;
        while (--_curIndex >= 0) {
          var akey = aks[_curIndex];
          if (bi[akey] !== -1) {
            break;
          }
        }
        while (++_curIndex < aIndex) {
          var _akey = aks[_curIndex];
          result[_akey] = a[_akey];
        }
        var bv = b[_key2];
        var av = a[_key2];
        var r = void 0;
        if (this.isMf(bv)) {
          r = bv(av);
        } else {
          if (!Utils_Utils.isObjectLiteral(av) || !Utils_Utils.isObjectLiteral(bv)) {
            r = bv;
          } else {
            r = ObjMerger.merge(av, bv);
          }
        }
        if (r !== undefined) {
          result[_key2] = r;
        }
      }
      var curIndex = aksl;
      while (--curIndex >= 0) {
        var _akey2 = aks[curIndex];
        if (bi[_akey2] !== -1) {
          break;
        }
      }
      while (++curIndex < aksl) {
        var _akey3 = aks[curIndex];
        result[_akey3] = a[_akey3];
      }
      return result;
    }
  }]);
  return ObjMerger;
}();

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/tools/ObjectListProxy.mjs





function ObjectListProxy_createSuper(t) { var r = ObjectListProxy_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function ObjectListProxy_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (ObjectListProxy_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var ObjectListProxy = function (_ObjectList) {
  (0,inherits/* default */.Z)(ObjectListProxy, _ObjectList);
  var _super = ObjectListProxy_createSuper(ObjectListProxy);
  function ObjectListProxy(target) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, ObjectListProxy);
    _this = _super.call(this);
    _this._target = target;
    return _this;
  }
  (0,createClass/* default */.Z)(ObjectListProxy, [{
    key: "onAdd",
    value: function onAdd(item, index) {
      this._target.addAt(item, index);
    }
  }, {
    key: "onRemove",
    value: function onRemove(item, index) {
      this._target.removeAt(index);
    }
  }, {
    key: "onSync",
    value: function onSync(removed, added, order) {
      this._target._setByArray(order);
    }
  }, {
    key: "onSet",
    value: function onSet(item, index) {
      this._target.setAt(item, index);
    }
  }, {
    key: "onMove",
    value: function onMove(item, fromIndex, toIndex) {
      this._target.setAt(item, toIndex);
    }
  }, {
    key: "createItem",
    value: function createItem(object) {
      return this._target.createItem(object);
    }
  }, {
    key: "isItem",
    value: function isItem(object) {
      return this._target.isItem(object);
    }
  }]);
  return ObjectListProxy;
}(ObjectList);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/tools/ObjectListWrapper.mjs








function ObjectListWrapper_createSuper(t) { var r = ObjectListWrapper_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function ObjectListWrapper_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (ObjectListWrapper_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var ObjectListWrapper = function (_ObjectListProxy) {
  (0,inherits/* default */.Z)(ObjectListWrapper, _ObjectListProxy);
  var _super = ObjectListWrapper_createSuper(ObjectListWrapper);
  function ObjectListWrapper(target, wrap) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, ObjectListWrapper);
    _this = _super.call(this, target);
    _this._wrap = wrap;
    return _this;
  }
  (0,createClass/* default */.Z)(ObjectListWrapper, [{
    key: "wrap",
    value: function wrap(item) {
      var wrapper = this._wrap(item);
      item._wrapper = wrapper;
      return wrapper;
    }
  }, {
    key: "onAdd",
    value: function onAdd(item, index) {
      item = this.wrap(item);
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(ObjectListWrapper.prototype), "onAdd", this).call(this, item, index);
    }
  }, {
    key: "onRemove",
    value: function onRemove(item, index) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(ObjectListWrapper.prototype), "onRemove", this).call(this, item, index);
    }
  }, {
    key: "onSync",
    value: function onSync(removed, added, order) {
      var _this2 = this;
      added.forEach(function (a) {
        return _this2.wrap(a);
      });
      order = order.map(function (a) {
        return a._wrapper;
      });
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(ObjectListWrapper.prototype), "onSync", this).call(this, removed, added, order);
    }
  }, {
    key: "onSet",
    value: function onSet(item, index) {
      item = this.wrap(item);
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(ObjectListWrapper.prototype), "onSet", this).call(this, item, index);
    }
  }, {
    key: "onMove",
    value: function onMove(item, fromIndex, toIndex) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(ObjectListWrapper.prototype), "onMove", this).call(this, item, fromIndex, toIndex);
    }
  }]);
  return ObjectListWrapper;
}(ObjectListProxy);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/textures/NoiseTexture.mjs































function NoiseTexture_createSuper(t) { var r = NoiseTexture_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function NoiseTexture_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (NoiseTexture_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var NoiseTexture = function (_Texture) {
  (0,inherits/* default */.Z)(NoiseTexture, _Texture);
  var _super = NoiseTexture_createSuper(NoiseTexture);
  function NoiseTexture() {
    (0,classCallCheck/* default */.Z)(this, NoiseTexture);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(NoiseTexture, [{
    key: "_getLookupId",
    value: function _getLookupId() {
      return '__noise';
    }
  }, {
    key: "_getSourceLoader",
    value: function _getSourceLoader() {
      var gl = this.stage.gl;
      return function (cb) {
        var noise = new Uint8Array(128 * 128 * 4);
        for (var i = 0; i < 128 * 128 * 4; i += 4) {
          var v = Math.floor(Math.random() * 256);
          noise[i] = v;
          noise[i + 1] = v;
          noise[i + 2] = v;
          noise[i + 3] = 255;
        }
        var texParams = {};
        if (gl) {
          texParams[gl.TEXTURE_WRAP_S] = gl.REPEAT;
          texParams[gl.TEXTURE_WRAP_T] = gl.REPEAT;
          texParams[gl.TEXTURE_MIN_FILTER] = gl.NEAREST;
          texParams[gl.TEXTURE_MAG_FILTER] = gl.NEAREST;
        }
        cb(null, {
          source: noise,
          w: 128,
          h: 128,
          texParams: texParams
        });
      };
    }
  }]);
  return NoiseTexture;
}(Texture);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/textures/HtmlTexture.mjs





function HtmlTexture_createSuper(t) { var r = HtmlTexture_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function HtmlTexture_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (HtmlTexture_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var HtmlTexture = function (_Texture) {
  (0,inherits/* default */.Z)(HtmlTexture, _Texture);
  var _super = HtmlTexture_createSuper(HtmlTexture);
  function HtmlTexture(stage) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, HtmlTexture);
    _this = _super.call(this, stage);
    _this._htmlElement = undefined;
    _this._scale = 1;
    return _this;
  }
  (0,createClass/* default */.Z)(HtmlTexture, [{
    key: "htmlElement",
    get: function get() {
      return this._htmlElement;
    },
    set: function set(v) {
      this._htmlElement = v;
      this._changed();
    }
  }, {
    key: "scale",
    get: function get() {
      return this._scale;
    },
    set: function set(v) {
      this._scale = v;
      this._changed();
    }
  }, {
    key: "html",
    get: function get() {
      return this._htmlElement.innerHTML;
    },
    set: function set(v) {
      if (!v) {
        this.htmlElement = undefined;
      } else {
        var d = document.createElement('div');
        d.innerHTML = "<div>" + v + "</div>";
        this.htmlElement = d.firstElementChild;
      }
    }
  }, {
    key: "_getIsValid",
    value: function _getIsValid() {
      return this.htmlElement;
    }
  }, {
    key: "_getLookupId",
    value: function _getLookupId() {
      return this._scale + ":" + this._htmlElement.innerHTML;
    }
  }, {
    key: "_getSourceLoader",
    value: function _getSourceLoader() {
      var htmlElement = this._htmlElement;
      var scale = this._scale;
      return function (cb) {
        if (!window.html2canvas) {
          return cb(new Error("Please include html2canvas (https://html2canvas.hertzen.com/)"));
        }
        var area = HtmlTexture.getPreloadArea();
        area.appendChild(htmlElement);
        html2canvas(htmlElement, {
          backgroundColor: null,
          scale: scale
        }).then(function (canvas) {
          area.removeChild(htmlElement);
          if (canvas.height === 0) {
            return cb(new Error("Canvas height is 0"));
          }
          cb(null, {
            source: canvas,
            width: canvas.width,
            height: canvas.height
          });
        }).catch(function (e) {
          console.error('[Lightning]', e);
        });
      };
    }
  }], [{
    key: "getPreloadArea",
    value: function getPreloadArea() {
      if (!this._preloadArea) {
        this._preloadArea = document.createElement('div');
        if (this._preloadArea.attachShadow) {
          this._preloadArea.attachShadow({
            mode: 'closed'
          });
        }
        this._preloadArea.style.opacity = 0;
        this._preloadArea.style.pointerEvents = 'none';
        this._preloadArea.style.position = 'fixed';
        this._preloadArea.style.display = 'block';
        this._preloadArea.style.top = '100vh';
        this._preloadArea.style.overflow = 'hidden';
        document.body.appendChild(this._preloadArea);
      }
      return this._preloadArea;
    }
  }]);
  return HtmlTexture;
}(Texture);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/textures/StaticTexture.mjs





function StaticTexture_createSuper(t) { var r = StaticTexture_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function StaticTexture_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (StaticTexture_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var StaticTexture = function (_Texture) {
  (0,inherits/* default */.Z)(StaticTexture, _Texture);
  var _super = StaticTexture_createSuper(StaticTexture);
  function StaticTexture(stage, options) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, StaticTexture);
    _this = _super.call(this, stage);
    _this._options = options;
    return _this;
  }
  (0,createClass/* default */.Z)(StaticTexture, [{
    key: "options",
    get: function get() {
      return this._options;
    },
    set: function set(v) {
      if (this._options !== v) {
        this._options = v;
        this._changed();
      }
    }
  }, {
    key: "_getIsValid",
    value: function _getIsValid() {
      return !!this._options;
    }
  }, {
    key: "_getSourceLoader",
    value: function _getSourceLoader() {
      var _this2 = this;
      return function (cb) {
        cb(null, _this2._options);
      };
    }
  }]);
  return StaticTexture;
}(Texture);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/components/ListComponent.mjs













function ListComponent_createSuper(t) { var r = ListComponent_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function ListComponent_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (ListComponent_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var ListComponent = function (_Component) {
  (0,inherits/* default */.Z)(ListComponent, _Component);
  var _super = ListComponent_createSuper(ListComponent);
  function ListComponent(stage) {
    var _thisSuper, _this;
    (0,classCallCheck/* default */.Z)(this, ListComponent);
    _this = _super.call(this, stage);
    _this._wrapper = (0,esm_get/* default */.Z)((_thisSuper = (0,assertThisInitialized/* default */.Z)(_this), (0,getPrototypeOf/* default */.Z)(ListComponent.prototype)), "_children", _thisSuper).a({});
    _this._reloadVisibleElements = false;
    _this._visibleItems = new Set();
    _this._index = 0;
    _this._started = false;
    _this._scrollTransitionSettings = _this.stage.transitions.createSettings({});
    _this._itemSize = 100;
    _this._viewportScrollOffset = 0;
    _this._itemScrollOffset = 0;
    _this._roll = false;
    _this._rollMin = 0;
    _this._rollMax = 0;
    _this._progressAnimation = null;
    _this._invertDirection = false;
    _this._horizontal = true;
    _this.itemList = new ListItems((0,assertThisInitialized/* default */.Z)(_this));
    return _this;
  }
  (0,createClass/* default */.Z)(ListComponent, [{
    key: "_allowChildrenAccess",
    value: function _allowChildrenAccess() {
      return false;
    }
  }, {
    key: "items",
    get: function get() {
      return this.itemList.get();
    },
    set: function set(children) {
      this.itemList.patch(children);
    }
  }, {
    key: "start",
    value: function start() {
      var _this2 = this;
      this._wrapper.transition(this.property, this._scrollTransitionSettings);
      this._scrollTransition = this._wrapper.transition(this.property);
      this._scrollTransition.on('progress', function (p) {
        return _this2.update();
      });
      this.setIndex(0, true, true);
      this._started = true;
      this.update();
    }
  }, {
    key: "setIndex",
    value: function setIndex(index) {
      var immediate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var closest = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var nElements = this.length;
      if (!nElements) return;
      this.emit('unfocus', this.getElement(this.realIndex), this._index, this.realIndex);
      if (closest) {
        var offset = Utils_Utils.getModuloIndex(index, nElements);
        var o = Utils_Utils.getModuloIndex(this.index, nElements);
        var diff = offset - o;
        if (diff > 0.5 * nElements) {
          diff -= nElements;
        } else if (diff < -0.5 * nElements) {
          diff += nElements;
        }
        this._index += diff;
      } else {
        this._index = index;
      }
      if (this._roll || this.viewportSize > this._itemSize * nElements) {
        this._index = Utils_Utils.getModuloIndex(this._index, nElements);
      }
      var direction = this._horizontal ^ this._invertDirection ? -1 : 1;
      var value = direction * this._index * this._itemSize;
      if (this._roll) {
        var min, max, scrollDelta;
        if (direction == 1) {
          max = (nElements - 1) * this._itemSize;
          scrollDelta = this._viewportScrollOffset * this.viewportSize - this._itemScrollOffset * this._itemSize;
          max -= scrollDelta;
          min = this.viewportSize - (this._itemSize + scrollDelta);
          if (this._rollMin) min -= this._rollMin;
          if (this._rollMax) max += this._rollMax;
          value = Math.max(Math.min(value, max), min);
        } else {
          max = nElements * this._itemSize - this.viewportSize;
          scrollDelta = this._viewportScrollOffset * this.viewportSize - this._itemScrollOffset * this._itemSize;
          max += scrollDelta;
          var _min = scrollDelta;
          if (this._rollMin) _min -= this._rollMin;
          if (this._rollMax) max += this._rollMax;
          value = Math.min(Math.max(-max, value), -_min);
        }
      }
      this._scrollTransition.start(value);
      if (immediate) {
        this._scrollTransition.finish();
      }
      this.emit('focus', this.getElement(this.realIndex), this._index, this.realIndex);
    }
  }, {
    key: "getAxisPosition",
    value: function getAxisPosition() {
      var target = -this._scrollTransition._targetValue;
      var direction = this._horizontal ^ this._invertDirection ? -1 : 1;
      var value = -direction * this._index * this._itemSize;
      return this._viewportScrollOffset * this.viewportSize + (value - target);
    }
  }, {
    key: "update",
    value: function update() {
      if (!this._started) return;
      var nElements = this.length;
      if (!nElements) return;
      var direction = this._horizontal ^ this._invertDirection ? -1 : 1;
      var v = this._horizontal ? this._wrapper.x : this._wrapper.y;
      var viewportSize = this.viewportSize;
      var scrollDelta = this._viewportScrollOffset * viewportSize - this._itemScrollOffset * this._itemSize;
      v += scrollDelta;
      var s, e, ps, pe;
      if (direction == -1) {
        s = Math.floor(-v / this._itemSize);
        ps = 1 - (-v / this._itemSize - s);
        e = Math.floor((viewportSize - v) / this._itemSize);
        pe = (viewportSize - v) / this._itemSize - e;
      } else {
        s = Math.ceil(v / this._itemSize);
        ps = 1 + v / this._itemSize - s;
        e = Math.ceil((v - viewportSize) / this._itemSize);
        pe = e - (v - viewportSize) / this._itemSize;
      }
      if (this._roll || viewportSize > this._itemSize * nElements) {
        if (e >= nElements) {
          e = nElements - 1;
          pe = 1;
        }
        if (s >= nElements) {
          s = nElements - 1;
          ps = 1;
        }
        if (e <= -1) {
          e = 0;
          pe = 1;
        }
        if (s <= -1) {
          s = 0;
          ps = 1;
        }
      }
      var offset = -direction * s * this._itemSize;
      var item;
      for (var index = s; direction == -1 ? index <= e : index >= e; direction == -1 ? index++ : index--) {
        var realIndex = Utils_Utils.getModuloIndex(index, nElements);
        var element = this.getElement(realIndex);
        item = element.parent;
        this._visibleItems.delete(item);
        if (this._horizontal) {
          item.x = offset + scrollDelta;
        } else {
          item.y = offset + scrollDelta;
        }
        var wasVisible = item.visible;
        item.visible = true;
        if (!wasVisible || this._reloadVisibleElements) {
          this.emit('visible', index, realIndex);
        }
        if (this._progressAnimation) {
          var p = 1;
          if (index == s) {
            p = ps;
          } else if (index == e) {
            p = pe;
          }
          this._progressAnimation.apply(element, p);
        }
        offset += this._itemSize;
      }
      var self = this;
      this._visibleItems.forEach(function (invisibleItem) {
        invisibleItem.visible = false;
        self._visibleItems.delete(invisibleItem);
      });
      for (var _index = s; direction == -1 ? _index <= e : _index >= e; direction == -1 ? _index++ : _index--) {
        var _realIndex = Utils_Utils.getModuloIndex(_index, nElements);
        this._visibleItems.add(this.getWrapper(_realIndex));
      }
      this._reloadVisibleElements = false;
    }
  }, {
    key: "setPrevious",
    value: function setPrevious() {
      this.setIndex(this._index - 1);
    }
  }, {
    key: "setNext",
    value: function setNext() {
      this.setIndex(this._index + 1);
    }
  }, {
    key: "getWrapper",
    value: function getWrapper(index) {
      return this._wrapper.children[index];
    }
  }, {
    key: "getElement",
    value: function getElement(index) {
      var e = this._wrapper.children[index];
      return e ? e.children[0] : null;
    }
  }, {
    key: "reload",
    value: function reload() {
      this._reloadVisibleElements = true;
      this.update();
    }
  }, {
    key: "element",
    get: function get() {
      var e = this._wrapper.children[this.realIndex];
      return e ? e.children[0] : null;
    }
  }, {
    key: "length",
    get: function get() {
      return this._wrapper.children.length;
    }
  }, {
    key: "property",
    get: function get() {
      return this._horizontal ? 'x' : 'y';
    }
  }, {
    key: "viewportSize",
    get: function get() {
      return this._horizontal ? this.w : this.h;
    }
  }, {
    key: "index",
    get: function get() {
      return this._index;
    }
  }, {
    key: "realIndex",
    get: function get() {
      return Utils_Utils.getModuloIndex(this._index, this.length);
    }
  }, {
    key: "itemSize",
    get: function get() {
      return this._itemSize;
    },
    set: function set(v) {
      this._itemSize = v;
      this.update();
    }
  }, {
    key: "viewportScrollOffset",
    get: function get() {
      return this._viewportScrollOffset;
    },
    set: function set(v) {
      this._viewportScrollOffset = v;
      this.update();
    }
  }, {
    key: "itemScrollOffset",
    get: function get() {
      return this._itemScrollOffset;
    },
    set: function set(v) {
      this._itemScrollOffset = v;
      this.update();
    }
  }, {
    key: "scrollTransitionSettings",
    get: function get() {
      return this._scrollTransitionSettings;
    },
    set: function set(v) {
      this._scrollTransitionSettings.patch(v);
    }
  }, {
    key: "scrollTransition",
    get: function get() {
      return this._scrollTransition;
    },
    set: function set(v) {
      this._scrollTransitionSettings.patch(v);
    }
  }, {
    key: "progressAnimation",
    get: function get() {
      return this._progressAnimation;
    },
    set: function set(v) {
      if (Utils_Utils.isObjectLiteral(v)) {
        this._progressAnimation = this.stage.animations.createSettings(v);
      } else {
        this._progressAnimation = v;
      }
      this.update();
    }
  }, {
    key: "roll",
    get: function get() {
      return this._roll;
    },
    set: function set(v) {
      this._roll = v;
      this.update();
    }
  }, {
    key: "rollMin",
    get: function get() {
      return this._rollMin;
    },
    set: function set(v) {
      this._rollMin = v;
      this.update();
    }
  }, {
    key: "rollMax",
    get: function get() {
      return this._rollMax;
    },
    set: function set(v) {
      this._rollMax = v;
      this.update();
    }
  }, {
    key: "invertDirection",
    get: function get() {
      return this._invertDirection;
    },
    set: function set(v) {
      if (!this._started) {
        this._invertDirection = v;
      }
    }
  }, {
    key: "horizontal",
    get: function get() {
      return this._horizontal;
    },
    set: function set(v) {
      if (v !== this._horizontal) {
        if (!this._started) {
          this._horizontal = v;
        }
      }
    }
  }]);
  return ListComponent;
}(Component);


var ListItems = function (_ObjectListWrapper) {
  (0,inherits/* default */.Z)(ListItems, _ObjectListWrapper);
  var _super2 = ListComponent_createSuper(ListItems);
  function ListItems(list) {
    var _this3;
    (0,classCallCheck/* default */.Z)(this, ListItems);
    var wrap = function wrap(item) {
      var parent = item.stage.createElement();
      parent.add(item);
      parent.visible = false;
      return parent;
    };
    _this3 = _super2.call(this, list._wrapper._children, wrap);
    _this3.list = list;
    return _this3;
  }
  (0,createClass/* default */.Z)(ListItems, [{
    key: "onAdd",
    value: function onAdd(item, index) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(ListItems.prototype), "onAdd", this).call(this, item, index);
      this.checkStarted(index);
    }
  }, {
    key: "checkStarted",
    value: function checkStarted(index) {
      this.list._reloadVisibleElements = true;
      if (!this.list._started) {
        this.list.start();
      } else {
        if (this.list.length === 1) {
          this.list.setIndex(0, true, true);
        } else {
          if (this.list._index >= this.list.length) {
            this.list.setIndex(0);
          }
        }
        this.list.update();
      }
    }
  }, {
    key: "onRemove",
    value: function onRemove(item, index) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(ListItems.prototype), "onRemove", this).call(this, item, index);
      var ri = this.list.realIndex;
      if (ri === index) {
        if (ri === this.list.length) {
          ri--;
        }
        if (ri >= 0) {
          this.list.setIndex(ri);
        }
      } else if (ri > index) {
        this.list.setIndex(ri - 1);
      }
      this.list._reloadVisibleElements = true;
    }
  }, {
    key: "onSet",
    value: function onSet(item, index) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(ListItems.prototype), "onSet", this).call(this, item, index);
      this.checkStarted(index);
    }
  }, {
    key: "onSync",
    value: function onSync(removed, added, order) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(ListItems.prototype), "onSync", this).call(this, removed, added, order);
      this.checkStarted(0);
    }
  }, {
    key: "_signalProxy",
    get: function get() {
      return true;
    }
  }]);
  return ListItems;
}(ObjectListWrapper);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/renderer/webgl/shaders/LinearBlurShader.mjs
































function LinearBlurShader_createSuper(t) { var r = LinearBlurShader_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function LinearBlurShader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (LinearBlurShader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var LinearBlurShader = function (_DefaultShader) {
  (0,inherits/* default */.Z)(LinearBlurShader, _DefaultShader);
  var _super = LinearBlurShader_createSuper(LinearBlurShader);
  function LinearBlurShader(context) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, LinearBlurShader);
    _this = _super.call(this, context);
    _this._direction = new Float32Array([1, 0]);
    _this._kernelRadius = 1;
    return _this;
  }
  (0,createClass/* default */.Z)(LinearBlurShader, [{
    key: "x",
    get: function get() {
      return this._direction[0];
    },
    set: function set(v) {
      this._direction[0] = v;
      this.redraw();
    }
  }, {
    key: "y",
    get: function get() {
      return this._direction[1];
    },
    set: function set(v) {
      this._direction[1] = v;
      this.redraw();
    }
  }, {
    key: "kernelRadius",
    get: function get() {
      return this._kernelRadius;
    },
    set: function set(v) {
      this._kernelRadius = v;
      this.redraw();
    }
  }, {
    key: "useDefault",
    value: function useDefault() {
      return this._kernelRadius === 0;
    }
  }, {
    key: "setupUniforms",
    value: function setupUniforms(operation) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(LinearBlurShader.prototype), "setupUniforms", this).call(this, operation);
      this._setUniform("direction", this._direction, this.gl.uniform2fv);
      this._setUniform("kernelRadius", this._kernelRadius, this.gl.uniform1i);
      var w = operation.getRenderWidth();
      var h = operation.getRenderHeight();
      this._setUniform("resolution", new Float32Array([w, h]), this.gl.uniform2fv);
    }
  }]);
  return LinearBlurShader;
}(DefaultShader);

LinearBlurShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    uniform vec2 resolution;\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    uniform sampler2D uSampler;\n    uniform vec2 direction;\n    uniform int kernelRadius;\n    \n    vec4 blur1(sampler2D image, vec2 uv, vec2 resolution, vec2 direction) {\n        vec4 color = vec4(0.0);\n        vec2 off1 = vec2(1.3333333333333333) * direction;\n        color += texture2D(image, uv) * 0.29411764705882354;\n        color += texture2D(image, uv + (off1 / resolution)) * 0.35294117647058826;\n        color += texture2D(image, uv - (off1 / resolution)) * 0.35294117647058826;\n        return color; \n    }\n    \n    vec4 blur2(sampler2D image, vec2 uv, vec2 resolution, vec2 direction) {\n        vec4 color = vec4(0.0);\n        vec2 off1 = vec2(1.3846153846) * direction;\n        vec2 off2 = vec2(3.2307692308) * direction;\n        color += texture2D(image, uv) * 0.2270270270;\n        color += texture2D(image, uv + (off1 / resolution)) * 0.3162162162;\n        color += texture2D(image, uv - (off1 / resolution)) * 0.3162162162;\n        color += texture2D(image, uv + (off2 / resolution)) * 0.0702702703;\n        color += texture2D(image, uv - (off2 / resolution)) * 0.0702702703;\n        return color;\n    }\n    \n    vec4 blur3(sampler2D image, vec2 uv, vec2 resolution, vec2 direction) {\n        vec4 color = vec4(0.0);\n        vec2 off1 = vec2(1.411764705882353) * direction;\n        vec2 off2 = vec2(3.2941176470588234) * direction;\n        vec2 off3 = vec2(5.176470588235294) * direction;\n        color += texture2D(image, uv) * 0.1964825501511404;\n        color += texture2D(image, uv + (off1 / resolution)) * 0.2969069646728344;\n        color += texture2D(image, uv - (off1 / resolution)) * 0.2969069646728344;\n        color += texture2D(image, uv + (off2 / resolution)) * 0.09447039785044732;\n        color += texture2D(image, uv - (off2 / resolution)) * 0.09447039785044732;\n        color += texture2D(image, uv + (off3 / resolution)) * 0.010381362401148057;\n        color += texture2D(image, uv - (off3 / resolution)) * 0.010381362401148057;\n        return color;\n    }    \n\n    void main(void){\n        if (kernelRadius == 1) {\n            gl_FragColor = blur1(uSampler, vTextureCoord, resolution, direction) * vColor;\n        } else if (kernelRadius == 2) {\n            gl_FragColor = blur2(uSampler, vTextureCoord, resolution, direction) * vColor;\n        } else {\n            gl_FragColor = blur3(uSampler, vTextureCoord, resolution, direction) * vColor;\n        }\n    }\n";
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/renderer/webgl/shaders/BoxBlurShader.mjs
































function BoxBlurShader_createSuper(t) { var r = BoxBlurShader_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function BoxBlurShader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (BoxBlurShader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var BoxBlurShader = function (_DefaultShader) {
  (0,inherits/* default */.Z)(BoxBlurShader, _DefaultShader);
  var _super = BoxBlurShader_createSuper(BoxBlurShader);
  function BoxBlurShader() {
    (0,classCallCheck/* default */.Z)(this, BoxBlurShader);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(BoxBlurShader, [{
    key: "setupUniforms",
    value: function setupUniforms(operation) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(BoxBlurShader.prototype), "setupUniforms", this).call(this, operation);
      var dx = 1.0 / operation.getTextureWidth(0);
      var dy = 1.0 / operation.getTextureHeight(0);
      this._setUniform("stepTextureCoord", new Float32Array([dx, dy]), this.gl.uniform2fv);
    }
  }]);
  return BoxBlurShader;
}(DefaultShader);

BoxBlurShader.vertexShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    uniform vec2 stepTextureCoord;\n    attribute vec2 aVertexPosition;\n    attribute vec2 aTextureCoord;\n    attribute vec4 aColor;\n    uniform vec2 projection;\n    varying vec4 vColor;\n    varying vec2 vTextureCoordUl;\n    varying vec2 vTextureCoordUr;\n    varying vec2 vTextureCoordBl;\n    varying vec2 vTextureCoordBr;\n    void main(void){\n        gl_Position = vec4(aVertexPosition.x * projection.x - 1.0, aVertexPosition.y * -abs(projection.y) + 1.0, 0.0, 1.0);\n        vTextureCoordUl = aTextureCoord - stepTextureCoord;\n        vTextureCoordBr = aTextureCoord + stepTextureCoord;\n        vTextureCoordUr = vec2(vTextureCoordBr.x, vTextureCoordUl.y);\n        vTextureCoordBl = vec2(vTextureCoordUl.x, vTextureCoordBr.y);\n        vColor = aColor;\n        gl_Position.y = -sign(projection.y) * gl_Position.y;\n    }\n";
BoxBlurShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    varying vec2 vTextureCoordUl;\n    varying vec2 vTextureCoordUr;\n    varying vec2 vTextureCoordBl;\n    varying vec2 vTextureCoordBr;\n    varying vec4 vColor;\n    uniform sampler2D uSampler;\n    void main(void){\n        vec4 color = 0.25 * (texture2D(uSampler, vTextureCoordUl) + texture2D(uSampler, vTextureCoordUr) + texture2D(uSampler, vTextureCoordBl) + texture2D(uSampler, vTextureCoordBr));\n        gl_FragColor = color * vColor;\n    }\n";
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/renderer/c2d/shaders/BlurShader.mjs






function BlurShader_createSuper(t) { var r = BlurShader_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function BlurShader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (BlurShader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var BlurShader = function (_DefaultShader) {
  (0,inherits/* default */.Z)(BlurShader, _DefaultShader);
  var _super = BlurShader_createSuper(BlurShader);
  function BlurShader(context) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, BlurShader);
    _this = _super.call(this, context);
    _this._kernelRadius = 1;
    return _this;
  }
  (0,createClass/* default */.Z)(BlurShader, [{
    key: "kernelRadius",
    get: function get() {
      return this._kernelRadius;
    },
    set: function set(v) {
      this._kernelRadius = v;
      this.redraw();
    }
  }, {
    key: "useDefault",
    value: function useDefault() {
      return this._amount === 0;
    }
  }, {
    key: "_beforeDrawEl",
    value: function _beforeDrawEl(_ref) {
      var target = _ref.target;
      target.ctx.filter = "blur(" + this._kernelRadius + "px)";
    }
  }, {
    key: "_afterDrawEl",
    value: function _afterDrawEl(_ref2) {
      var target = _ref2.target;
      target.ctx.filter = "none";
    }
  }]);
  return BlurShader;
}(DefaultShader_DefaultShader);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/components/FastBlurComponent.mjs









function FastBlurComponent_createSuper(t) { var r = FastBlurComponent_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function FastBlurComponent_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (FastBlurComponent_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }







var FastBlurComponent = function (_Component) {
  (0,inherits/* default */.Z)(FastBlurComponent, _Component);
  var _super = FastBlurComponent_createSuper(FastBlurComponent);
  function FastBlurComponent() {
    (0,classCallCheck/* default */.Z)(this, FastBlurComponent);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(FastBlurComponent, [{
    key: "wrap",
    get: function get() {
      return this.tag("Wrap");
    }
  }, {
    key: "content",
    get: function get() {
      return this.wrap.content;
    },
    set: function set(v) {
      return this.wrap.content = v;
    }
  }, {
    key: "padding",
    set: function set(v) {
      this.wrap._paddingX = v;
      this.wrap._paddingY = v;
      this.wrap._updateBlurSize();
    }
  }, {
    key: "paddingX",
    set: function set(v) {
      this.wrap._paddingX = v;
      this.wrap._updateBlurSize();
    }
  }, {
    key: "paddingY",
    set: function set(v) {
      this.wrap._paddingY = v;
      this.wrap._updateBlurSize();
    }
  }, {
    key: "amount",
    get: function get() {
      return this.wrap.amount;
    },
    set: function set(v) {
      return this.wrap.amount = v;
    }
  }, {
    key: "_onResize",
    value: function _onResize() {
      this.wrap.w = this.renderWidth;
      this.wrap.h = this.renderHeight;
    }
  }, {
    key: "_signalProxy",
    get: function get() {
      return true;
    }
  }, {
    key: "_build",
    value: function _build() {
      this.patch({
        Wrap: {
          type: this.stage.gl ? WebGLFastBlurComponent : C2dFastBlurComponent
        }
      });
    }
  }], [{
    key: "_template",
    value: function _template() {
      return {};
    }
  }]);
  return FastBlurComponent;
}(Component);

var C2dFastBlurComponent = function (_Component2) {
  (0,inherits/* default */.Z)(C2dFastBlurComponent, _Component2);
  var _super2 = FastBlurComponent_createSuper(C2dFastBlurComponent);
  function C2dFastBlurComponent(stage) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, C2dFastBlurComponent);
    _this = _super2.call(this, stage);
    _this._textwrap = _this.sel("Textwrap");
    _this._wrapper = _this.sel("Textwrap>Content");
    _this._amount = 0;
    _this._paddingX = 0;
    _this._paddingY = 0;
    return _this;
  }
  (0,createClass/* default */.Z)(C2dFastBlurComponent, [{
    key: "content",
    get: function get() {
      return this.sel('Textwrap>Content');
    },
    set: function set(v) {
      this.sel('Textwrap>Content').patch(v, true);
    }
  }, {
    key: "padding",
    set: function set(v) {
      this._paddingX = v;
      this._paddingY = v;
      this._updateBlurSize();
    }
  }, {
    key: "paddingX",
    set: function set(v) {
      this._paddingX = v;
      this._updateBlurSize();
    }
  }, {
    key: "paddingY",
    set: function set(v) {
      this._paddingY = v;
      this._updateBlurSize();
    }
  }, {
    key: "_updateBlurSize",
    value: function _updateBlurSize() {
      var w = this.renderWidth;
      var h = this.renderHeight;
      var paddingX = this._paddingX;
      var paddingY = this._paddingY;
      this._wrapper.x = paddingX;
      this._textwrap.x = -paddingX;
      this._wrapper.y = paddingY;
      this._textwrap.y = -paddingY;
      this._textwrap.w = w + paddingX * 2;
      this._textwrap.h = h + paddingY * 2;
    }
  }, {
    key: "amount",
    get: function get() {
      return this._amount;
    },
    set: function set(v) {
      this._amount = v;
      this._textwrap.shader.kernelRadius = C2dFastBlurComponent._amountToKernelRadius(v);
    }
  }, {
    key: "_signalProxy",
    get: function get() {
      return true;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return {
        forceZIndexContext: true,
        rtt: true,
        Textwrap: {
          shader: {
            type: BlurShader
          },
          Content: {}
        }
      };
    }
  }, {
    key: "getSpline",
    value: function getSpline() {
      if (!this._multiSpline) {
        this._multiSpline = new MultiSpline();
        this._multiSpline.parse(false, {
          0: 0,
          0.25: 1.5,
          0.5: 5.5,
          0.75: 18,
          1: 39
        });
      }
      return this._multiSpline;
    }
  }, {
    key: "_amountToKernelRadius",
    value: function _amountToKernelRadius(v) {
      return C2dFastBlurComponent.getSpline().getValue(Math.min(1, v * 0.25));
    }
  }]);
  return C2dFastBlurComponent;
}(Component);
var WebGLFastBlurComponent = function (_Component3) {
  (0,inherits/* default */.Z)(WebGLFastBlurComponent, _Component3);
  var _super3 = FastBlurComponent_createSuper(WebGLFastBlurComponent);
  function WebGLFastBlurComponent(stage) {
    var _this2;
    (0,classCallCheck/* default */.Z)(this, WebGLFastBlurComponent);
    _this2 = _super3.call(this, stage);
    _this2._textwrap = _this2.sel("Textwrap");
    _this2._wrapper = _this2.sel("Textwrap>Content");
    _this2._layers = _this2.sel("Layers");
    _this2._output = _this2.sel("Result");
    _this2._amount = 0;
    _this2._paddingX = 0;
    _this2._paddingY = 0;
    return _this2;
  }
  (0,createClass/* default */.Z)(WebGLFastBlurComponent, [{
    key: "_signalProxy",
    get: function get() {
      return true;
    }
  }, {
    key: "_buildLayers",
    value: function _buildLayers() {
      var _this3 = this;
      var filterShaderSettings = [{
        x: 1,
        y: 0,
        kernelRadius: 1
      }, {
        x: 0,
        y: 1,
        kernelRadius: 1
      }, {
        x: 1.5,
        y: 0,
        kernelRadius: 1
      }, {
        x: 0,
        y: 1.5,
        kernelRadius: 1
      }];
      var filterShaders = filterShaderSettings.map(function (s) {
        var shader = Shader.create(_this3.stage, Object.assign({
          type: LinearBlurShader
        }, s));
        return shader;
      });
      this._setLayerTexture(this.getLayerContents(0), this._textwrap.getTexture(), []);
      this._setLayerTexture(this.getLayerContents(1), this.getLayer(0).getTexture(), [filterShaders[0], filterShaders[1]]);
      this._setLayerTexture(this.getLayerContents(2), this.getLayer(1).getTexture(), [filterShaders[0], filterShaders[1], filterShaders[2], filterShaders[3]]);
      this._setLayerTexture(this.getLayerContents(3), this.getLayer(2).getTexture(), [filterShaders[0], filterShaders[1], filterShaders[2], filterShaders[3]]);
    }
  }, {
    key: "_setLayerTexture",
    value: function _setLayerTexture(element, texture, steps) {
      if (!steps.length) {
        element.texture = texture;
      } else {
        var step = steps.pop();
        var child = element.stage.c({
          rtt: true,
          shader: step
        });
        this._setLayerTexture(child, texture, steps);
        element.childList.add(child);
      }
      return element;
    }
  }, {
    key: "content",
    get: function get() {
      return this.sel('Textwrap>Content');
    },
    set: function set(v) {
      this.sel('Textwrap>Content').patch(v, true);
    }
  }, {
    key: "padding",
    set: function set(v) {
      this._paddingX = v;
      this._paddingY = v;
      this._updateBlurSize();
    }
  }, {
    key: "paddingX",
    set: function set(v) {
      this._paddingX = v;
      this._updateBlurSize();
    }
  }, {
    key: "paddingY",
    set: function set(v) {
      this._paddingY = v;
      this._updateBlurSize();
    }
  }, {
    key: "getLayer",
    value: function getLayer(i) {
      return this._layers.sel("L" + i);
    }
  }, {
    key: "getLayerContents",
    value: function getLayerContents(i) {
      return this.getLayer(i).sel("Content");
    }
  }, {
    key: "_onResize",
    value: function _onResize() {
      this._updateBlurSize();
    }
  }, {
    key: "_updateBlurSize",
    value: function _updateBlurSize() {
      var w = this.renderWidth;
      var h = this.renderHeight;
      var paddingX = this._paddingX;
      var paddingY = this._paddingY;
      var fw = w + paddingX * 2;
      var fh = h + paddingY * 2;
      this._textwrap.w = fw;
      this._wrapper.x = paddingX;
      this.getLayer(0).w = this.getLayerContents(0).w = fw / 2;
      this.getLayer(1).w = this.getLayerContents(1).w = fw / 4;
      this.getLayer(2).w = this.getLayerContents(2).w = fw / 8;
      this.getLayer(3).w = this.getLayerContents(3).w = fw / 16;
      this._output.x = -paddingX;
      this._textwrap.x = -paddingX;
      this._output.w = fw;
      this._textwrap.h = fh;
      this._wrapper.y = paddingY;
      this.getLayer(0).h = this.getLayerContents(0).h = fh / 2;
      this.getLayer(1).h = this.getLayerContents(1).h = fh / 4;
      this.getLayer(2).h = this.getLayerContents(2).h = fh / 8;
      this.getLayer(3).h = this.getLayerContents(3).h = fh / 16;
      this._output.y = -paddingY;
      this._textwrap.y = -paddingY;
      this._output.h = fh;
      this.w = w;
      this.h = h;
    }
  }, {
    key: "amount",
    get: function get() {
      return this._amount;
    },
    set: function set(v) {
      this._amount = v;
      this._update();
    }
  }, {
    key: "_update",
    value: function _update() {
      var v = Math.min(4, Math.max(0, this._amount));
      if (v === 0) {
        this._textwrap.renderToTexture = false;
        this._output.shader.otherTextureSource = null;
        this._output.visible = false;
      } else {
        this._textwrap.renderToTexture = true;
        this._output.visible = true;
        this.getLayer(0).visible = v > 0;
        this.getLayer(1).visible = v > 1;
        this.getLayer(2).visible = v > 2;
        this.getLayer(3).visible = v > 3;
        if (v <= 1) {
          this._output.texture = this._textwrap.getTexture();
          this._output.shader.otherTextureSource = this.getLayer(0).getTexture();
          this._output.shader.a = v;
        } else if (v <= 2) {
          this._output.texture = this.getLayer(0).getTexture();
          this._output.shader.otherTextureSource = this.getLayer(1).getTexture();
          this._output.shader.a = v - 1;
        } else if (v <= 3) {
          this._output.texture = this.getLayer(1).getTexture();
          this._output.shader.otherTextureSource = this.getLayer(2).getTexture();
          this._output.shader.a = v - 2;
        } else if (v <= 4) {
          this._output.texture = this.getLayer(2).getTexture();
          this._output.shader.otherTextureSource = this.getLayer(3).getTexture();
          this._output.shader.a = v - 3;
        }
      }
    }
  }, {
    key: "shader",
    set: function set(s) {
      _set((0,getPrototypeOf/* default */.Z)(WebGLFastBlurComponent.prototype), "shader", s, this, true);
      if (!this.renderToTexture) {
        console.warn("[Lightning] Please enable renderToTexture to use with a shader.");
      }
    }
  }, {
    key: "_firstActive",
    value: function _firstActive() {
      this._buildLayers();
    }
  }], [{
    key: "_template",
    value: function _template() {
      var onUpdate = function onUpdate(element, elementCore) {
        if (elementCore._recalc & 2 + 128) {
          var w = elementCore.w;
          var h = elementCore.h;
          var cur = elementCore;
          do {
            cur = cur._children[0];
            cur._element.w = w;
            cur._element.h = h;
          } while (cur._children);
        }
      };
      return {
        Textwrap: {
          rtt: true,
          forceZIndexContext: true,
          renderOffscreen: true,
          Content: {}
        },
        Layers: {
          L0: {
            rtt: true,
            onUpdate: onUpdate,
            renderOffscreen: true,
            visible: false,
            Content: {
              shader: {
                type: BoxBlurShader
              }
            }
          },
          L1: {
            rtt: true,
            onUpdate: onUpdate,
            renderOffscreen: true,
            visible: false,
            Content: {
              shader: {
                type: BoxBlurShader
              }
            }
          },
          L2: {
            rtt: true,
            onUpdate: onUpdate,
            renderOffscreen: true,
            visible: false,
            Content: {
              shader: {
                type: BoxBlurShader
              }
            }
          },
          L3: {
            rtt: true,
            onUpdate: onUpdate,
            renderOffscreen: true,
            visible: false,
            Content: {
              shader: {
                type: BoxBlurShader
              }
            }
          }
        },
        Result: {
          shader: {
            type: FastBlurOutputShader
          },
          visible: false
        }
      };
    }
  }]);
  return WebGLFastBlurComponent;
}(Component);
var FastBlurOutputShader = function (_DefaultShader) {
  (0,inherits/* default */.Z)(FastBlurOutputShader, _DefaultShader);
  var _super4 = FastBlurComponent_createSuper(FastBlurOutputShader);
  function FastBlurOutputShader(ctx) {
    var _this4;
    (0,classCallCheck/* default */.Z)(this, FastBlurOutputShader);
    _this4 = _super4.call(this, ctx);
    _this4._a = 0;
    _this4._otherTextureSource = null;
    return _this4;
  }
  (0,createClass/* default */.Z)(FastBlurOutputShader, [{
    key: "a",
    get: function get() {
      return this._a;
    },
    set: function set(v) {
      this._a = v;
      this.redraw();
    }
  }, {
    key: "otherTextureSource",
    set: function set(v) {
      this._otherTextureSource = v;
      this.redraw();
    }
  }, {
    key: "setupUniforms",
    value: function setupUniforms(operation) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(FastBlurOutputShader.prototype), "setupUniforms", this).call(this, operation);
      this._setUniform("a", this._a, this.gl.uniform1f);
      this._setUniform("uSampler2", 1, this.gl.uniform1i);
    }
  }, {
    key: "beforeDraw",
    value: function beforeDraw(operation) {
      var glTexture = this._otherTextureSource ? this._otherTextureSource.nativeTexture : null;
      var gl = this.gl;
      gl.activeTexture(gl.TEXTURE1);
      gl.bindTexture(gl.TEXTURE_2D, glTexture);
      gl.activeTexture(gl.TEXTURE0);
    }
  }]);
  return FastBlurOutputShader;
}(DefaultShader);
FastBlurOutputShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    uniform sampler2D uSampler;\n    uniform sampler2D uSampler2;\n    uniform float a;\n    void main(void){\n        if (a == 1.0) {\n            gl_FragColor = texture2D(uSampler2, vTextureCoord) * vColor;\n        } else {\n            gl_FragColor = ((1.0 - a) * texture2D(uSampler, vTextureCoord) + (a * texture2D(uSampler2, vTextureCoord))) * vColor;\n        }\n    }\n";
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/components/BloomComponent.mjs








function BloomComponent_createSuper(t) { var r = BloomComponent_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function BloomComponent_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (BloomComponent_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }




var BloomComponent = function (_Component) {
  (0,inherits/* default */.Z)(BloomComponent, _Component);
  var _super = BloomComponent_createSuper(BloomComponent);
  function BloomComponent(stage) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, BloomComponent);
    _this = _super.call(this, stage);
    _this._textwrap = _this.sel("Textwrap");
    _this._wrapper = _this.sel("Textwrap.Content");
    _this._layers = _this.sel("Layers");
    _this._amount = 0;
    _this._paddingX = 0;
    _this._paddingY = 0;
    return _this;
  }
  (0,createClass/* default */.Z)(BloomComponent, [{
    key: "_signalProxy",
    get: function get() {
      return true;
    }
  }, {
    key: "_build",
    value: function _build() {
      var _this2 = this;
      var filterShaderSettings = [{
        x: 1,
        y: 0,
        kernelRadius: 3
      }, {
        x: 0,
        y: 1,
        kernelRadius: 3
      }, {
        x: 1.5,
        y: 0,
        kernelRadius: 3
      }, {
        x: 0,
        y: 1.5,
        kernelRadius: 3
      }];
      var filterShaders = filterShaderSettings.map(function (s) {
        var shader = _this2.stage.createShader(Object.assign({
          type: LinearBlurShader
        }, s));
        return shader;
      });
      this._setLayerTexture(this.getLayerContents(0), this._textwrap.getTexture(), []);
      this._setLayerTexture(this.getLayerContents(1), this.getLayer(0).getTexture(), [filterShaders[0], filterShaders[1]]);
      this._setLayerTexture(this.getLayerContents(2), this.getLayer(1).getTexture(), [filterShaders[0], filterShaders[1], filterShaders[2], filterShaders[3]]);
      this._setLayerTexture(this.getLayerContents(3), this.getLayer(2).getTexture(), [filterShaders[0], filterShaders[1], filterShaders[2], filterShaders[3]]);
    }
  }, {
    key: "_setLayerTexture",
    value: function _setLayerTexture(element, texture, steps) {
      if (!steps.length) {
        element.texture = texture;
      } else {
        var step = steps.pop();
        var child = element.stage.c({
          rtt: true,
          shader: step
        });
        this._setLayerTexture(child, texture, steps);
        element.childList.add(child);
      }
      return element;
    }
  }, {
    key: "content",
    get: function get() {
      return this.sel('Textwrap.Content');
    },
    set: function set(v) {
      this.sel('Textwrap.Content').patch(v);
    }
  }, {
    key: "padding",
    set: function set(v) {
      this._paddingX = v;
      this._paddingY = v;
      this._updateBlurSize();
    }
  }, {
    key: "paddingX",
    set: function set(v) {
      this._paddingX = v;
      this._updateBlurSize();
    }
  }, {
    key: "paddingY",
    set: function set(v) {
      this._paddingY = v;
      this._updateBlurSize();
    }
  }, {
    key: "getLayer",
    value: function getLayer(i) {
      return this._layers.sel("L" + i);
    }
  }, {
    key: "getLayerContents",
    value: function getLayerContents(i) {
      return this.getLayer(i).sel("Content");
    }
  }, {
    key: "_onResize",
    value: function _onResize() {
      this._updateBlurSize();
    }
  }, {
    key: "_updateBlurSize",
    value: function _updateBlurSize() {
      var w = this.renderWidth;
      var h = this.renderHeight;
      var paddingX = this._paddingX;
      var paddingY = this._paddingY;
      var fw = w + paddingX * 2;
      var fh = h + paddingY * 2;
      this._textwrap.w = fw;
      this._wrapper.x = paddingX;
      this.getLayer(0).w = this.getLayerContents(0).w = fw / 2;
      this.getLayer(1).w = this.getLayerContents(1).w = fw / 4;
      this.getLayer(2).w = this.getLayerContents(2).w = fw / 8;
      this.getLayer(3).w = this.getLayerContents(3).w = fw / 16;
      this._textwrap.x = -paddingX;
      this._textwrap.h = fh;
      this._wrapper.y = paddingY;
      this.getLayer(0).h = this.getLayerContents(0).h = fh / 2;
      this.getLayer(1).h = this.getLayerContents(1).h = fh / 4;
      this.getLayer(2).h = this.getLayerContents(2).h = fh / 8;
      this.getLayer(3).h = this.getLayerContents(3).h = fh / 16;
      this._textwrap.y = -paddingY;
      this.w = w;
      this.h = h;
    }
  }, {
    key: "amount",
    get: function get() {
      return this._amount;
    },
    set: function set(v) {
      this._amount = v;
      this._update();
    }
  }, {
    key: "_update",
    value: function _update() {
      var v = Math.min(4, Math.max(0, this._amount));
      if (v > 0) {
        this.getLayer(0).visible = v > 0;
        this.getLayer(1).visible = v > 1;
        this.getLayer(2).visible = v > 2;
        this.getLayer(3).visible = v > 3;
      }
    }
  }, {
    key: "shader",
    set: function set(s) {
      _set((0,getPrototypeOf/* default */.Z)(BloomComponent.prototype), "shader", s, this, true);
      if (!this.renderToTexture) {
        console.warn("[Lightning] Please enable renderToTexture to use with a shader.");
      }
    }
  }, {
    key: "_firstActive",
    value: function _firstActive() {
      this._build();
    }
  }], [{
    key: "_template",
    value: function _template() {
      var onUpdate = function onUpdate(element, elementCore) {
        if (elementCore._recalc & 2 + 128) {
          var w = elementCore.w;
          var h = elementCore.h;
          var cur = elementCore;
          do {
            cur = cur._children[0];
            cur._element.w = w;
            cur._element.h = h;
          } while (cur._children);
        }
      };
      return {
        Textwrap: {
          rtt: true,
          forceZIndexContext: true,
          renderOffscreen: true,
          BloomBase: {
            shader: {
              type: BloomBaseShader
            },
            Content: {}
          }
        },
        Layers: {
          L0: {
            rtt: true,
            onUpdate: onUpdate,
            scale: 2,
            pivot: 0,
            visible: false,
            Content: {
              shader: {
                type: BoxBlurShader
              }
            }
          },
          L1: {
            rtt: true,
            onUpdate: onUpdate,
            scale: 4,
            pivot: 0,
            visible: false,
            Content: {
              shader: {
                type: BoxBlurShader
              }
            }
          },
          L2: {
            rtt: true,
            onUpdate: onUpdate,
            scale: 8,
            pivot: 0,
            visible: false,
            Content: {
              shader: {
                type: BoxBlurShader
              }
            }
          },
          L3: {
            rtt: true,
            onUpdate: onUpdate,
            scale: 16,
            pivot: 0,
            visible: false,
            Content: {
              shader: {
                type: BoxBlurShader
              }
            }
          }
        }
      };
    }
  }]);
  return BloomComponent;
}(Component);

var BloomBaseShader = function (_DefaultShader) {
  (0,inherits/* default */.Z)(BloomBaseShader, _DefaultShader);
  var _super2 = BloomComponent_createSuper(BloomBaseShader);
  function BloomBaseShader() {
    (0,classCallCheck/* default */.Z)(this, BloomBaseShader);
    return _super2.apply(this, arguments);
  }
  return (0,createClass/* default */.Z)(BloomBaseShader);
}(DefaultShader);
BloomBaseShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    uniform sampler2D uSampler;\n    void main(void){\n        vec4 color = texture2D(uSampler, vTextureCoord) * vColor;\n        float m = max(max(color.r, color.g), color.b);\n        float c = max(0.0, (m - 0.80)) * 5.0;\n        color = color * c;\n        gl_FragColor = color;\n    }\n";
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/components/SmoothScaleComponent.mjs





function SmoothScaleComponent_createSuper(t) { var r = SmoothScaleComponent_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function SmoothScaleComponent_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (SmoothScaleComponent_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var SmoothScaleComponent = function (_Component) {
  (0,inherits/* default */.Z)(SmoothScaleComponent, _Component);
  var _super = SmoothScaleComponent_createSuper(SmoothScaleComponent);
  function SmoothScaleComponent(stage) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, SmoothScaleComponent);
    _this = _super.call(this, stage);
    _this._smoothScale = 1;
    _this._iterations = 0;
    return _this;
  }
  (0,createClass/* default */.Z)(SmoothScaleComponent, [{
    key: "content",
    get: function get() {
      return this.tag('Content');
    },
    set: function set(v) {
      this.tag('Content').patch(v, true);
    }
  }, {
    key: "smoothScale",
    get: function get() {
      return this._smoothScale;
    },
    set: function set(v) {
      if (this._smoothScale !== v) {
        var its = 0;
        while (v < 0.5 && its < 12) {
          its++;
          v = v * 2;
        }
        this.scale = v;
        this._setIterations(its);
        this._smoothScale = v;
      }
    }
  }, {
    key: "_setIterations",
    value: function _setIterations(its) {
      if (this._iterations !== its) {
        var scalers = this.sel("Scale").childList;
        var content = this.sel("ContentWrap");
        while (scalers.length < its) {
          var first = scalers.length === 0;
          var texture = first ? content.getTexture() : scalers.last.getTexture();
          scalers.a({
            rtt: true,
            renderOffscreen: true,
            texture: texture
          });
        }
        SmoothScaleComponent._updateDimensions(this.tag("ContentWrap"), true);
        var useScalers = its > 0;
        this.patch({
          ContentWrap: {
            renderToTexture: useScalers
          },
          Scale: {
            visible: useScalers
          }
        });
        for (var i = 0, n = scalers.length; i < n; i++) {
          scalers.getAt(i).patch({
            visible: i < its,
            renderOffscreen: i !== its - 1
          });
        }
        this._iterations = its;
      }
    }
  }, {
    key: "_signalProxy",
    get: function get() {
      return true;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return {
        ContentWrap: {
          renderOffscreen: true,
          forceZIndexContext: true,
          onAfterUpdate: SmoothScaleComponent._updateDimensions,
          Content: {}
        },
        Scale: {
          visible: false
        }
      };
    }
  }, {
    key: "_updateDimensions",
    value: function _updateDimensions(contentWrap, force) {
      var content = contentWrap.children[0];
      var w = content.renderWidth;
      var h = content.renderHeight;
      if (w !== contentWrap.w || h !== contentWrap.h || force) {
        contentWrap.w = w;
        contentWrap.h = h;
        var scalers = contentWrap.parent.tag("Scale").children;
        for (var i = 0, n = scalers.length; i < n; i++) {
          w = w * 0.5;
          h = h * 0.5;
          scalers[i].w = w;
          scalers[i].h = h;
        }
      }
    }
  }]);
  return SmoothScaleComponent;
}(Component);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/components/BorderComponent.mjs





function BorderComponent_createSuper(t) { var r = BorderComponent_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function BorderComponent_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (BorderComponent_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var BorderComponent = function (_Component) {
  (0,inherits/* default */.Z)(BorderComponent, _Component);
  var _super = BorderComponent_createSuper(BorderComponent);
  function BorderComponent(stage) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, BorderComponent);
    _this = _super.call(this, stage);
    _this._borderTop = _this.tag("Top");
    _this._borderRight = _this.tag("Right");
    _this._borderBottom = _this.tag("Bottom");
    _this._borderLeft = _this.tag("Left");
    _this.onAfterUpdate = function (element) {
      var content = element.childList.first;
      var w = element.core.w || content.renderWidth;
      var h = element.core.h || content.renderHeight;
      element._borderTop.w = w;
      element._borderBottom.y = h;
      element._borderBottom.w = w;
      element._borderLeft.h = h + element._borderTop.h + element._borderBottom.h;
      element._borderLeft.y = -element._borderTop.h;
      element._borderRight.x = w;
      element._borderRight.h = h + element._borderTop.h + element._borderBottom.h;
      element._borderRight.y = -element._borderTop.h;
    };
    _this.borderWidth = 1;
    return _this;
  }
  (0,createClass/* default */.Z)(BorderComponent, [{
    key: "_signalProxy",
    get: function get() {
      return true;
    }
  }, {
    key: "content",
    get: function get() {
      return this.sel('Content');
    },
    set: function set(v) {
      this.sel('Content').patch(v, true);
    }
  }, {
    key: "borderWidth",
    get: function get() {
      return this.borderWidthTop;
    },
    set: function set(v) {
      this.borderWidthTop = v;
      this.borderWidthRight = v;
      this.borderWidthBottom = v;
      this.borderWidthLeft = v;
    }
  }, {
    key: "borderWidthTop",
    get: function get() {
      return this._borderTop.h;
    },
    set: function set(v) {
      this._borderTop.h = v;
      this._borderTop.visible = v > 0;
    }
  }, {
    key: "borderWidthRight",
    get: function get() {
      return this._borderRight.w;
    },
    set: function set(v) {
      this._borderRight.w = v;
      this._borderRight.visible = v > 0;
    }
  }, {
    key: "borderWidthBottom",
    get: function get() {
      return this._borderBottom.h;
    },
    set: function set(v) {
      this._borderBottom.h = v;
      this._borderBottom.visible = v > 0;
    }
  }, {
    key: "borderWidthLeft",
    get: function get() {
      return this._borderLeft.w;
    },
    set: function set(v) {
      this._borderLeft.w = v;
      this._borderLeft.visible = v > 0;
    }
  }, {
    key: "colorBorder",
    get: function get() {
      return this.colorBorderTop;
    },
    set: function set(v) {
      this.colorBorderTop = v;
      this.colorBorderRight = v;
      this.colorBorderBottom = v;
      this.colorBorderLeft = v;
    }
  }, {
    key: "colorBorderTop",
    get: function get() {
      return this._borderTop.color;
    },
    set: function set(v) {
      this._borderTop.color = v;
    }
  }, {
    key: "colorBorderRight",
    get: function get() {
      return this._borderRight.color;
    },
    set: function set(v) {
      this._borderRight.color = v;
    }
  }, {
    key: "colorBorderBottom",
    get: function get() {
      return this._borderBottom.color;
    },
    set: function set(v) {
      this._borderBottom.color = v;
    }
  }, {
    key: "colorBorderLeft",
    get: function get() {
      return this._borderLeft.color;
    },
    set: function set(v) {
      this._borderLeft.color = v;
    }
  }, {
    key: "borderTop",
    get: function get() {
      return this._borderTop;
    },
    set: function set(settings) {
      this.borderTop.patch(settings);
    }
  }, {
    key: "borderRight",
    get: function get() {
      return this._borderRight;
    },
    set: function set(settings) {
      this.borderRight.patch(settings);
    }
  }, {
    key: "borderBottom",
    get: function get() {
      return this._borderBottom;
    },
    set: function set(settings) {
      this.borderBottom.patch(settings);
    }
  }, {
    key: "borderLeft",
    get: function get() {
      return this._borderLeft;
    },
    set: function set(settings) {
      this.borderLeft.patch(settings);
    }
  }, {
    key: "borders",
    set: function set(settings) {
      this.borderTop = settings;
      this.borderLeft = settings;
      this.borderBottom = settings;
      this.borderRight = settings;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return {
        Content: {},
        Borders: {
          Top: {
            rect: true,
            visible: false,
            mountY: 1
          },
          Right: {
            rect: true,
            visible: false
          },
          Bottom: {
            rect: true,
            visible: false
          },
          Left: {
            rect: true,
            visible: false,
            mountX: 1
          }
        }
      };
    }
  }]);
  return BorderComponent;
}(Component);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/renderer/common/shaders/GrayscaleShader.mjs







function GrayscaleShader_createSuper(t) { var r = GrayscaleShader_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function GrayscaleShader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (GrayscaleShader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }


var WebGLGrayscaleShader = function (_WebGLDefaultShader) {
  (0,inherits/* default */.Z)(WebGLGrayscaleShader, _WebGLDefaultShader);
  var _super = GrayscaleShader_createSuper(WebGLGrayscaleShader);
  function WebGLGrayscaleShader(context) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, WebGLGrayscaleShader);
    _this = _super.call(this, context);
    _this._amount = 1;
    return _this;
  }
  (0,createClass/* default */.Z)(WebGLGrayscaleShader, [{
    key: "amount",
    get: function get() {
      return this._amount;
    },
    set: function set(v) {
      this._amount = v;
      this.redraw();
    }
  }, {
    key: "useDefault",
    value: function useDefault() {
      return this._amount === 0;
    }
  }, {
    key: "setupUniforms",
    value: function setupUniforms(operation) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(WebGLGrayscaleShader.prototype), "setupUniforms", this).call(this, operation);
      this._setUniform("amount", this._amount, this.gl.uniform1f);
    }
  }], [{
    key: "getC2d",
    value: function getC2d() {
      return C2dGrayscaleShader;
    }
  }]);
  return WebGLGrayscaleShader;
}(DefaultShader);
WebGLGrayscaleShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    uniform sampler2D uSampler;\n    uniform float amount;\n    void main(void){\n        vec4 color = texture2D(uSampler, vTextureCoord) * vColor;\n        float grayness = 0.2 * color.r + 0.6 * color.g + 0.2 * color.b;\n        gl_FragColor = vec4(amount * vec3(grayness, grayness, grayness) + (1.0 - amount) * color.rgb, color.a);\n    }\n";
var C2dGrayscaleShader = function (_C2dDefaultShader) {
  (0,inherits/* default */.Z)(C2dGrayscaleShader, _C2dDefaultShader);
  var _super2 = GrayscaleShader_createSuper(C2dGrayscaleShader);
  function C2dGrayscaleShader(context) {
    var _this2;
    (0,classCallCheck/* default */.Z)(this, C2dGrayscaleShader);
    _this2 = _super2.call(this, context);
    _this2._amount = 1;
    return _this2;
  }
  (0,createClass/* default */.Z)(C2dGrayscaleShader, [{
    key: "amount",
    get: function get() {
      return this._amount;
    },
    set: function set(v) {
      this._amount = v;
      this.redraw();
    }
  }, {
    key: "useDefault",
    value: function useDefault() {
      return this._amount === 0;
    }
  }, {
    key: "_beforeDrawEl",
    value: function _beforeDrawEl(_ref) {
      var target = _ref.target;
      target.ctx.filter = "grayscale(" + this._amount + ")";
    }
  }, {
    key: "_afterDrawEl",
    value: function _afterDrawEl(_ref2) {
      var target = _ref2.target;
      target.ctx.filter = "none";
    }
  }], [{
    key: "getWebGL",
    value: function getWebGL() {
      return WebGLGrayscaleShader;
    }
  }]);
  return C2dGrayscaleShader;
}(DefaultShader_DefaultShader);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/renderer/webgl/shaders/DitheringShader.mjs






function DitheringShader_createSuper(t) { var r = DitheringShader_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function DitheringShader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (DitheringShader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }


var DitheringShader = function (_DefaultShader) {
  (0,inherits/* default */.Z)(DitheringShader, _DefaultShader);
  var _super = DitheringShader_createSuper(DitheringShader);
  function DitheringShader(ctx) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, DitheringShader);
    _this = _super.call(this, ctx);
    _this._noiseTexture = new NoiseTexture(ctx.stage);
    _this._graining = 1 / 256;
    _this._random = false;
    return _this;
  }
  (0,createClass/* default */.Z)(DitheringShader, [{
    key: "graining",
    set: function set(v) {
      this._graining = v;
      this.redraw();
    }
  }, {
    key: "random",
    set: function set(v) {
      this._random = v;
      this.redraw();
    }
  }, {
    key: "setExtraAttribsInBuffer",
    value: function setExtraAttribsInBuffer(operation) {
      this._noiseTexture.load();
      var offset = operation.extraAttribsDataByteOffset / 4;
      var floats = operation.quads.floats;
      var length = operation.length;
      for (var i = 0; i < length; i++) {
        var brx = operation.getElementWidth(i) / this._noiseTexture.getRenderWidth();
        var bry = operation.getElementHeight(i) / this._noiseTexture.getRenderHeight();
        var ulx = 0;
        var uly = 0;
        if (this._random) {
          ulx = Math.random();
          uly = Math.random();
          brx += ulx;
          bry += uly;
          if (Math.random() < 0.5) {
            var t = ulx;
            ulx = brx;
            brx = t;
          }
          if (Math.random() < 0.5) {
            var _t = uly;
            uly = bry;
            bry = _t;
          }
        }
        floats[offset] = ulx;
        floats[offset + 1] = uly;
        floats[offset + 2] = brx;
        floats[offset + 3] = uly;
        floats[offset + 4] = brx;
        floats[offset + 5] = bry;
        floats[offset + 6] = ulx;
        floats[offset + 7] = bry;
        offset += 8;
      }
    }
  }, {
    key: "beforeDraw",
    value: function beforeDraw(operation) {
      var gl = this.gl;
      gl.vertexAttribPointer(this._attrib("aNoiseTextureCoord"), 2, gl.FLOAT, false, 8, this.getVertexAttribPointerOffset(operation));
      var glTexture = this._noiseTexture.source.nativeTexture;
      gl.activeTexture(gl.TEXTURE1);
      gl.bindTexture(gl.TEXTURE_2D, glTexture);
      gl.activeTexture(gl.TEXTURE0);
    }
  }, {
    key: "getExtraAttribBytesPerVertex",
    value: function getExtraAttribBytesPerVertex() {
      return 8;
    }
  }, {
    key: "setupUniforms",
    value: function setupUniforms(operation) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(DitheringShader.prototype), "setupUniforms", this).call(this, operation);
      this._setUniform("uNoiseSampler", 1, this.gl.uniform1i);
      this._setUniform("graining", 2 * this._graining, this.gl.uniform1f);
    }
  }, {
    key: "enableAttribs",
    value: function enableAttribs() {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(DitheringShader.prototype), "enableAttribs", this).call(this);
      var gl = this.gl;
      gl.enableVertexAttribArray(this._attrib("aNoiseTextureCoord"));
    }
  }, {
    key: "disableAttribs",
    value: function disableAttribs() {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(DitheringShader.prototype), "disableAttribs", this).call(this);
      var gl = this.gl;
      gl.disableVertexAttribArray(this._attrib("aNoiseTextureCoord"));
    }
  }, {
    key: "useDefault",
    value: function useDefault() {
      return this._graining === 0;
    }
  }, {
    key: "afterDraw",
    value: function afterDraw(operation) {
      if (this._random) {
        this.redraw();
      }
    }
  }]);
  return DitheringShader;
}(DefaultShader);

DitheringShader.vertexShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    attribute vec2 aVertexPosition;\n    attribute vec2 aTextureCoord;\n    attribute vec2 aNoiseTextureCoord;\n    attribute vec4 aColor;\n    uniform vec2 projection;\n    varying vec2 vTextureCoord;\n    varying vec2 vNoiseTextureCoord;\n    varying vec4 vColor;\n    void main(void){\n        gl_Position = vec4(aVertexPosition.x * projection.x - 1.0, aVertexPosition.y * -abs(projection.y) + 1.0, 0.0, 1.0);\n        vTextureCoord = aTextureCoord;\n        vNoiseTextureCoord = aNoiseTextureCoord;\n        vColor = aColor;\n        gl_Position.y = -sign(projection.y) * gl_Position.y;\n    }\n";
DitheringShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    varying vec2 vTextureCoord;\n    varying vec2 vNoiseTextureCoord;\n    varying vec4 vColor;\n    uniform sampler2D uSampler;\n    uniform sampler2D uNoiseSampler;\n    uniform float graining;\n    void main(void){\n        vec4 noise = texture2D(uNoiseSampler, vNoiseTextureCoord);\n        vec4 color = texture2D(uSampler, vTextureCoord);\n        gl_FragColor = (color * vColor) + graining * (noise.r - 0.5);\n    }\n";
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/renderer/webgl/shaders/CircularPushShader.mjs
































function CircularPushShader_createSuper(t) { var r = CircularPushShader_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function CircularPushShader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (CircularPushShader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }


var CircularPushShader = function (_DefaultShader) {
  (0,inherits/* default */.Z)(CircularPushShader, _DefaultShader);
  var _super = CircularPushShader_createSuper(CircularPushShader);
  function CircularPushShader(ctx) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, CircularPushShader);
    _this = _super.call(this, ctx);
    _this._inputValue = 0;
    _this._maxDerivative = 0.01;
    _this._normalizedValue = 0;
    _this._offset = 0;
    _this._amount = 0.1;
    _this._aspectRatio = 1;
    _this._offsetX = 0;
    _this._offsetY = 0;
    _this.buckets = 100;
    return _this;
  }
  (0,createClass/* default */.Z)(CircularPushShader, [{
    key: "aspectRatio",
    get: function get() {
      return this._aspectRatio;
    },
    set: function set(v) {
      this._aspectRatio = v;
      this.redraw();
    }
  }, {
    key: "offsetX",
    get: function get() {
      return this._offsetX;
    },
    set: function set(v) {
      this._offsetX = v;
      this.redraw();
    }
  }, {
    key: "offsetY",
    get: function get() {
      return this._offsetY;
    },
    set: function set(v) {
      this._offsetY = v;
      this.redraw();
    }
  }, {
    key: "amount",
    get: function get() {
      return this._amount;
    },
    set: function set(v) {
      this._amount = v;
      this.redraw();
    }
  }, {
    key: "inputValue",
    get: function get() {
      return this._inputValue;
    },
    set: function set(v) {
      this._inputValue = v;
    }
  }, {
    key: "maxDerivative",
    get: function get() {
      return this._maxDerivative;
    },
    set: function set(v) {
      this._maxDerivative = v;
    }
  }, {
    key: "buckets",
    get: function get() {
      return this._buckets;
    },
    set: function set(v) {
      if (v > 100) {
        console.warn("[Lightning] CircularPushShader: supports max 100 buckets");
        v = 100;
      }
      this._buckets = v;
      this._values = new Uint8Array(this._getValues(v));
      this.redraw();
    }
  }, {
    key: "_getValues",
    value: function _getValues(n) {
      var v = [];
      for (var i = 0; i < n; i++) {
        v.push(this._inputValue);
      }
      return v;
    }
  }, {
    key: "progress",
    value: function progress(o) {
      this._offset += o * this._buckets;
      var full = Math.floor(this._offset);
      this._offset -= full;
      this._shiftBuckets(full);
      this.redraw();
    }
  }, {
    key: "_shiftBuckets",
    value: function _shiftBuckets(n) {
      for (var i = this._buckets - 1; i >= 0; i--) {
        var targetIndex = i - n;
        if (targetIndex < 0) {
          this._normalizedValue = Math.min(this._normalizedValue + this._maxDerivative, Math.max(this._normalizedValue - this._maxDerivative, this._inputValue));
          this._values[i] = 255 * this._normalizedValue;
        } else {
          this._values[i] = this._values[targetIndex];
        }
      }
    }
  }, {
    key: "offset",
    set: function set(v) {
      this._offset = v;
      this.redraw();
    }
  }, {
    key: "setupUniforms",
    value: function setupUniforms(operation) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(CircularPushShader.prototype), "setupUniforms", this).call(this, operation);
      this._setUniform("aspectRatio", this._aspectRatio, this.gl.uniform1f);
      this._setUniform("offsetX", this._offsetX, this.gl.uniform1f);
      this._setUniform("offsetY", this._offsetY, this.gl.uniform1f);
      this._setUniform("amount", this._amount, this.gl.uniform1f);
      this._setUniform("offset", this._offset, this.gl.uniform1f);
      this._setUniform("buckets", this._buckets, this.gl.uniform1f);
      this._setUniform("uValueSampler", 1, this.gl.uniform1i);
    }
  }, {
    key: "useDefault",
    value: function useDefault() {
      return this._amount === 0;
    }
  }, {
    key: "beforeDraw",
    value: function beforeDraw(operation) {
      var gl = this.gl;
      gl.activeTexture(gl.TEXTURE1);
      if (!this._valuesTexture) {
        this._valuesTexture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, this._valuesTexture);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        if (Utils_Utils.isNode) {
          gl.pixelStorei(gl.UNPACK_FLIP_BLUE_RED, false);
        }
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
      } else {
        gl.bindTexture(gl.TEXTURE_2D, this._valuesTexture);
      }
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.ALPHA, this._buckets, 1, 0, gl.ALPHA, gl.UNSIGNED_BYTE, this._values);
      gl.activeTexture(gl.TEXTURE0);
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      if (this._valuesTexture) {
        this.gl.deleteTexture(this._valuesTexture);
      }
    }
  }]);
  return CircularPushShader;
}(DefaultShader);

CircularPushShader.vertexShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    attribute vec2 aVertexPosition;\n    attribute vec2 aTextureCoord;\n    attribute vec4 aColor;\n    uniform vec2 projection;\n    uniform float offsetX;\n    uniform float offsetY;\n    uniform float aspectRatio;\n    varying vec2 vTextureCoord;\n    varying vec2 vPos;\n    varying vec4 vColor;\n    void main(void){\n        gl_Position = vec4(aVertexPosition.x * projection.x - 1.0, aVertexPosition.y * -abs(projection.y) + 1.0, 0.0, 1.0);\n        vTextureCoord = aTextureCoord;\n        vPos = vTextureCoord * 2.0 - 1.0;\n        vPos.y = vPos.y * aspectRatio;\n        vPos.y = vPos.y + offsetY;\n        vPos.x = vPos.x + offsetX;\n        vColor = aColor;\n        gl_Position.y = -sign(projection.y) * gl_Position.y;\n    }\n";
CircularPushShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    varying vec2 vPos;\n    uniform float amount;\n    uniform float offset;\n    uniform float values[100];\n    uniform float buckets;\n    uniform sampler2D uSampler;\n    uniform sampler2D uValueSampler;\n    void main(void){\n        float l = length(vPos);\n        float m = (l * buckets * 0.678 - offset) / buckets;\n        float f = texture2D(uValueSampler, vec2(m, 0.0)).a * amount;\n        vec2 unit = vPos / l;\n        gl_FragColor = texture2D(uSampler, vTextureCoord - f * unit) * vColor;\n    }\n";
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/renderer/webgl/shaders/InversionShader.mjs






function InversionShader_createSuper(t) { var r = InversionShader_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function InversionShader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (InversionShader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var InversionShader = function (_DefaultShader) {
  (0,inherits/* default */.Z)(InversionShader, _DefaultShader);
  var _super = InversionShader_createSuper(InversionShader);
  function InversionShader(context) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, InversionShader);
    _this = _super.call(this, context);
    _this._amount = 1;
    return _this;
  }
  (0,createClass/* default */.Z)(InversionShader, [{
    key: "amount",
    get: function get() {
      return this._amount;
    },
    set: function set(v) {
      this._amount = v;
      this.redraw();
    }
  }, {
    key: "useDefault",
    value: function useDefault() {
      return this._amount === 0;
    }
  }, {
    key: "setupUniforms",
    value: function setupUniforms(operation) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(InversionShader.prototype), "setupUniforms", this).call(this, operation);
      this._setUniform("amount", this._amount, this.gl.uniform1f);
    }
  }]);
  return InversionShader;
}(DefaultShader);

InversionShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    uniform sampler2D uSampler;\n    uniform float amount;\n    void main(void){\n        vec4 color = texture2D(uSampler, vTextureCoord);\n        color.rgb = color.rgb * (1.0 - amount) + amount * (1.0 * color.a - color.rgb); \n        gl_FragColor = color * vColor;\n    }\n";
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/renderer/webgl/shaders/OutlineShader.mjs
































function OutlineShader_createSuper(t) { var r = OutlineShader_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function OutlineShader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (OutlineShader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }


var OutlineShader = function (_DefaultShader) {
  (0,inherits/* default */.Z)(OutlineShader, _DefaultShader);
  var _super = OutlineShader_createSuper(OutlineShader);
  function OutlineShader(ctx) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, OutlineShader);
    _this = _super.call(this, ctx);
    _this._width = 5;
    _this._col = 0xFFFFFFFF;
    _this._color = [1, 1, 1, 1];
    return _this;
  }
  (0,createClass/* default */.Z)(OutlineShader, [{
    key: "width",
    set: function set(v) {
      this._width = v;
      this.redraw();
    }
  }, {
    key: "color",
    get: function get() {
      return this._col;
    },
    set: function set(v) {
      if (this._col !== v) {
        var col = StageUtils.getRgbaComponentsNormalized(v);
        col[0] = col[0] * col[3];
        col[1] = col[1] * col[3];
        col[2] = col[2] * col[3];
        this._color = col;
        this.redraw();
        this._col = v;
      }
    }
  }, {
    key: "useDefault",
    value: function useDefault() {
      return this._width === 0 || this._col[3] === 0;
    }
  }, {
    key: "setupUniforms",
    value: function setupUniforms(operation) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(OutlineShader.prototype), "setupUniforms", this).call(this, operation);
      var gl = this.gl;
      this._setUniform("color", new Float32Array(this._color), gl.uniform4fv);
    }
  }, {
    key: "enableAttribs",
    value: function enableAttribs() {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(OutlineShader.prototype), "enableAttribs", this).call(this);
      this.gl.enableVertexAttribArray(this._attrib("aCorner"));
    }
  }, {
    key: "disableAttribs",
    value: function disableAttribs() {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(OutlineShader.prototype), "disableAttribs", this).call(this);
      this.gl.disableVertexAttribArray(this._attrib("aCorner"));
    }
  }, {
    key: "setExtraAttribsInBuffer",
    value: function setExtraAttribsInBuffer(operation) {
      var offset = operation.extraAttribsDataByteOffset / 4;
      var floats = operation.quads.floats;
      var length = operation.length;
      for (var i = 0; i < length; i++) {
        var elementCore = operation.getElementCore(i);
        var ddw = this._width / elementCore.w;
        var dw = ddw / (1 - 2 * ddw);
        var ddh = this._width / elementCore.h;
        var dh = ddh / (1 - 2 * ddh);
        floats[offset] = -dw;
        floats[offset + 1] = -dh;
        floats[offset + 2] = 1 + dw;
        floats[offset + 3] = -dh;
        floats[offset + 4] = 1 + dw;
        floats[offset + 5] = 1 + dh;
        floats[offset + 6] = -dw;
        floats[offset + 7] = 1 + dh;
        offset += 8;
      }
    }
  }, {
    key: "beforeDraw",
    value: function beforeDraw(operation) {
      var gl = this.gl;
      gl.vertexAttribPointer(this._attrib("aCorner"), 2, gl.FLOAT, false, 8, this.getVertexAttribPointerOffset(operation));
    }
  }, {
    key: "getExtraAttribBytesPerVertex",
    value: function getExtraAttribBytesPerVertex() {
      return 8;
    }
  }]);
  return OutlineShader;
}(DefaultShader);

OutlineShader.vertexShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    attribute vec2 aVertexPosition;\n    attribute vec2 aTextureCoord;\n    attribute vec4 aColor;\n    attribute vec2 aCorner;\n    uniform vec2 projection;\n    varying vec2 vTextureCoord;\n    varying vec2 vCorner;\n    varying vec4 vColor;\n    void main(void){\n        gl_Position = vec4(aVertexPosition.x * projection.x - 1.0, aVertexPosition.y * -abs(projection.y) + 1.0, 0.0, 1.0);\n        vTextureCoord = aTextureCoord;\n        vCorner = aCorner;\n        vColor = aColor;\n        gl_Position.y = -sign(projection.y) * gl_Position.y;\n    }\n";
OutlineShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    varying vec2 vCorner;\n    uniform vec4 color;\n    uniform sampler2D uSampler;\n    void main(void){\n        vec2 m = min(vCorner, 1.0 - vCorner);\n        float value = step(0.0, min(m.x, m.y));\n        gl_FragColor = mix(color, texture2D(uSampler, vTextureCoord) * vColor, value);\n    }\n";
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/renderer/webgl/shaders/PixelateShader.mjs
































function PixelateShader_createSuper(t) { var r = PixelateShader_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function PixelateShader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (PixelateShader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var PixelateShader = function (_DefaultShader) {
  (0,inherits/* default */.Z)(PixelateShader, _DefaultShader);
  var _super = PixelateShader_createSuper(PixelateShader);
  function PixelateShader(ctx) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, PixelateShader);
    _this = _super.call(this, ctx);
    _this._size = new Float32Array([4, 4]);
    return _this;
  }
  (0,createClass/* default */.Z)(PixelateShader, [{
    key: "x",
    get: function get() {
      return this._size[0];
    },
    set: function set(v) {
      this._size[0] = v;
      this.redraw();
    }
  }, {
    key: "y",
    get: function get() {
      return this._size[1];
    },
    set: function set(v) {
      this._size[1] = v;
      this.redraw();
    }
  }, {
    key: "size",
    get: function get() {
      return this._size[0];
    },
    set: function set(v) {
      this._size[0] = v;
      this._size[1] = v;
      this.redraw();
    }
  }, {
    key: "useDefault",
    value: function useDefault() {
      return this._size[0] === 0 && this._size[1] === 0;
    }
  }, {
    key: "setupUniforms",
    value: function setupUniforms(operation) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(PixelateShader.prototype), "setupUniforms", this).call(this, operation);
      var gl = this.gl;
      this._setUniform("size", new Float32Array(this._size), gl.uniform2fv);
    }
  }, {
    key: "getExtraAttribBytesPerVertex",
    value: function getExtraAttribBytesPerVertex() {
      return 8;
    }
  }, {
    key: "enableAttribs",
    value: function enableAttribs() {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(PixelateShader.prototype), "enableAttribs", this).call(this);
      this.gl.enableVertexAttribArray(this._attrib("aTextureRes"));
    }
  }, {
    key: "disableAttribs",
    value: function disableAttribs() {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(PixelateShader.prototype), "disableAttribs", this).call(this);
      this.gl.disableVertexAttribArray(this._attrib("aTextureRes"));
    }
  }, {
    key: "setExtraAttribsInBuffer",
    value: function setExtraAttribsInBuffer(operation) {
      var offset = operation.extraAttribsDataByteOffset / 4;
      var floats = operation.quads.floats;
      var length = operation.length;
      for (var i = 0; i < length; i++) {
        var w = operation.quads.getTextureWidth(operation.index + i);
        var h = operation.quads.getTextureHeight(operation.index + i);
        floats[offset] = w;
        floats[offset + 1] = h;
        floats[offset + 2] = w;
        floats[offset + 3] = h;
        floats[offset + 4] = w;
        floats[offset + 5] = h;
        floats[offset + 6] = w;
        floats[offset + 7] = h;
        offset += 8;
      }
    }
  }, {
    key: "beforeDraw",
    value: function beforeDraw(operation) {
      var gl = this.gl;
      gl.vertexAttribPointer(this._attrib("aTextureRes"), 2, gl.FLOAT, false, this.getExtraAttribBytesPerVertex(), this.getVertexAttribPointerOffset(operation));
    }
  }], [{
    key: "getWebGLImpl",
    value: function getWebGLImpl() {
      return WebGLPixelateShaderImpl;
    }
  }]);
  return PixelateShader;
}(DefaultShader);

PixelateShader.vertexShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    attribute vec2 aVertexPosition;\n    attribute vec2 aTextureCoord;\n    attribute vec4 aColor;\n    attribute vec2 aTextureRes;\n    uniform vec2 projection;\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    varying vec2 vTextureRes;\n    void main(void){\n        gl_Position = vec4(aVertexPosition.x * projection.x - 1.0, aVertexPosition.y * -abs(projection.y) + 1.0, 0.0, 1.0);\n        vTextureCoord = aTextureCoord;\n        vColor = aColor;\n        vTextureRes = aTextureRes;\n        gl_Position.y = -sign(projection.y) * gl_Position.y;\n    }\n";
PixelateShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    varying vec2 vTextureRes;\n\n    uniform vec2 size;\n    uniform sampler2D uSampler;\n    \n    vec2 mapCoord( vec2 coord )\n    {\n        coord *= vTextureRes.xy;\n        return coord;\n    }\n    \n    vec2 unmapCoord( vec2 coord )\n    {\n        coord /= vTextureRes.xy;\n        return coord;\n    }\n    \n    vec2 pixelate(vec2 coord, vec2 size)\n    {\n        return floor( coord / size ) * size;\n    }\n    \n    void main(void)\n    {\n        vec2 coord = mapCoord(vTextureCoord);\n        coord = pixelate(coord, size);\n        coord = unmapCoord(coord);\n        gl_FragColor = texture2D(uSampler, coord) * vColor;\n    }\n";
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/renderer/webgl/shaders/RadialFilterShader.mjs






function RadialFilterShader_createSuper(t) { var r = RadialFilterShader_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function RadialFilterShader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (RadialFilterShader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var RadialFilterShader = function (_DefaultShader) {
  (0,inherits/* default */.Z)(RadialFilterShader, _DefaultShader);
  var _super = RadialFilterShader_createSuper(RadialFilterShader);
  function RadialFilterShader(context) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, RadialFilterShader);
    _this = _super.call(this, context);
    _this._radius = 0;
    _this._cutoff = 1;
    return _this;
  }
  (0,createClass/* default */.Z)(RadialFilterShader, [{
    key: "radius",
    get: function get() {
      return this._radius;
    },
    set: function set(v) {
      this._radius = v;
      this.redraw();
    }
  }, {
    key: "cutoff",
    get: function get() {
      return this._cutoff;
    },
    set: function set(v) {
      this._cutoff = v;
      this.redraw();
    }
  }, {
    key: "useDefault",
    value: function useDefault() {
      return this._radius === 0;
    }
  }, {
    key: "setupUniforms",
    value: function setupUniforms(operation) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(RadialFilterShader.prototype), "setupUniforms", this).call(this, operation);
      this._setUniform("radius", 2 * (this._radius - 0.5) / operation.getRenderWidth(), this.gl.uniform1f);
      this._setUniform("cutoff", 0.5 * operation.getRenderWidth() / this._cutoff, this.gl.uniform1f);
    }
  }]);
  return RadialFilterShader;
}(DefaultShader);

RadialFilterShader.vertexShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    attribute vec2 aVertexPosition;\n    attribute vec2 aTextureCoord;\n    attribute vec4 aColor;\n    uniform vec2 projection;\n    varying vec2 pos;\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    void main(void){\n        gl_Position = vec4(aVertexPosition.x * projection.x - 1.0, aVertexPosition.y * -abs(projection.y) + 1.0, 0.0, 1.0);\n        vTextureCoord = aTextureCoord;\n        vColor = aColor;\n        gl_Position.y = -sign(projection.y) * gl_Position.y;\n        pos = gl_Position.xy;\n    }\n";
RadialFilterShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    varying vec2 vTextureCoord;\n    varying vec2 pos;\n    varying vec4 vColor;\n    uniform sampler2D uSampler;\n    uniform float radius;\n    uniform float cutoff;\n    void main(void){\n        vec4 color = texture2D(uSampler, vTextureCoord);\n        float f = max(0.0, min(1.0, 1.0 - (length(pos) - radius) * cutoff));\n        gl_FragColor = texture2D(uSampler, vTextureCoord) * vColor * f;\n    }\n";
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/renderer/webgl/shaders/RoundedRectangleShader.mjs

































function RoundedRectangleShader_createSuper(t) { var r = RoundedRectangleShader_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function RoundedRectangleShader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (RoundedRectangleShader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }


var RoundedRectangleShader = function (_DefaultShader) {
  (0,inherits/* default */.Z)(RoundedRectangleShader, _DefaultShader);
  var _super = RoundedRectangleShader_createSuper(RoundedRectangleShader);
  function RoundedRectangleShader(context) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, RoundedRectangleShader);
    _this = _super.call(this, context);
    _this._blend = 0;
    _this._radius = [1, 1, 1, 1];
    _this._stroke = 0;
    _this._fc = 0x00ffffff;
    _this._fillColor = _this._getNormalizedColor(0xffffffff);
    _this._strokeColor = _this._getNormalizedColor(0x00ffffff);
    return _this;
  }
  (0,createClass/* default */.Z)(RoundedRectangleShader, [{
    key: "blend",
    set: function set(p) {
      this._blend = Math.min(Math.max(p, 0), 1);
    }
  }, {
    key: "radius",
    get: function get() {
      return this._radius;
    },
    set: function set(v) {
      if (Array.isArray(v)) {
        if (v.length === 2) {
          this._radius = [v[0], v[1], v[0], v[1]];
        } else if (v.length === 3) {
          this._radius = [v[0], v[1], v[2], this._radius[3]];
        } else if (v.length === 4) {
          this._radius = v;
        } else {
          this._radius = [v[0], v[0], v[0], v[0]];
        }
      } else {
        this._radius = [v, v, v, v];
      }
      this.redraw();
    }
  }, {
    key: "topLeft",
    get: function get() {
      return this._radius[0];
    },
    set: function set(num) {
      this._radius[0] = num;
      this.redraw();
    }
  }, {
    key: "topRight",
    get: function get() {
      return this._radius[1];
    },
    set: function set(num) {
      this._radius[1] = num;
      this.redraw();
    }
  }, {
    key: "bottomRight",
    get: function get() {
      return this._radius[2];
    },
    set: function set(num) {
      this._radius[2] = num;
      this.redraw();
    }
  }, {
    key: "bottomLeft",
    get: function get() {
      return this._radius[4];
    },
    set: function set(num) {
      this._radius[3] = num;
      this.redraw();
    }
  }, {
    key: "strokeColor",
    get: function get() {
      return this._sc;
    },
    set: function set(argb) {
      this._sc = argb;
      this._strokeColor = this._getNormalizedColor(argb);
      this.redraw();
    }
  }, {
    key: "fillColor",
    get: function get() {
      return this._fc;
    },
    set: function set(argb) {
      this._fc = argb;
      this._fillColor = this._getNormalizedColor(argb);
      this.redraw();
    }
  }, {
    key: "stroke",
    get: function get() {
      return this._stroke;
    },
    set: function set(num) {
      this._stroke = num;
      this.redraw();
    }
  }, {
    key: "_getNormalizedColor",
    value: function _getNormalizedColor(color) {
      var col = StageUtils.getRgbaComponentsNormalized(color);
      col[0] *= col[3];
      col[1] *= col[3];
      col[2] *= col[3];
      return new Float32Array(col);
    }
  }, {
    key: "setupUniforms",
    value: function setupUniforms(operation) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(RoundedRectangleShader.prototype), "setupUniforms", this).call(this, operation);
      var owner = operation.shaderOwner;
      var renderPrecision = this.ctx.stage.getRenderPrecision();
      var _radius = this._radius.map(function (r) {
        return (r + 0.5) * renderPrecision;
      });
      this._setUniform('radius', new Float32Array(_radius), this.gl.uniform4fv);
      this._setUniform('alpha', operation.getElementCore(0).renderContext.alpha, this.gl.uniform1f);
      this._setUniform('blend', this._blend, this.gl.uniform1f);
      this._setUniform('strokeColor', this._strokeColor, this.gl.uniform4fv);
      this._setUniform('fillColor', this._fillColor, this.gl.uniform4fv);
      this._setUniform('stroke', this._stroke * renderPrecision, this.gl.uniform1f);
      this._setUniform('resolution', new Float32Array([owner._w * renderPrecision, owner._h * renderPrecision]), this.gl.uniform2fv);
    }
  }]);
  return RoundedRectangleShader;
}(DefaultShader);

RoundedRectangleShader.vertexShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    attribute vec2 aVertexPosition;\n    attribute vec2 aTextureCoord;\n\n    attribute vec4 aColor;\n    uniform vec2 projection;\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n\n    void main(void){\n        gl_Position = vec4(aVertexPosition.x * projection.x - 1.0, aVertexPosition.y * -abs(projection.y) + 1.0, 0.0, 1.0);\n        vTextureCoord = aTextureCoord;\n        vColor = aColor;\n        gl_Position.y = -sign(projection.y) * gl_Position.y;\n    }\n";
RoundedRectangleShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n\n    #define PI 3.14159265359\n\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n\n    uniform sampler2D uSampler;\n    uniform vec2 resolution;\n    uniform vec4 radius;\n    uniform float stroke;\n    uniform vec4 strokeColor;\n    uniform vec4 fillColor;\n    uniform float alpha;\n    uniform float fill;\n    uniform float blend;\n    \n    float boxDist(vec2 p, vec2 size, float radius){\n        size -= vec2(radius);\n        vec2 d = abs(p) - size;\n        return min(max(d.x, d.y), 0.0) + length(max(d, 0.0)) - radius;\n    }\n    \n    float fillMask(float dist){\n        return clamp(-dist, 0.0, 1.0);\n    }\n    \n    float innerBorderMask(float dist, float width){\n        float alpha1 = clamp(dist + width, 0.0, 1.0);\n        float alpha2 = clamp(dist, 0.0, 1.0);\n        return alpha1 - alpha2;\n    }\n\n    void main() {\n        vec2 halfRes = 0.5 * resolution.xy;\n        float r = 0.0;\n        if (vTextureCoord.x < 0.5 && vTextureCoord.y < 0.5) {\n            r = radius[0];\n        } else if (vTextureCoord.x >= 0.5 && vTextureCoord.y < 0.5) {\n            r = radius[1];\n        } else if (vTextureCoord.x >= 0.5 && vTextureCoord.y >= 0.5) {\n            r = radius[2];\n        } else {\n            r = radius[3];\n        }\n        \n        float b = boxDist(vTextureCoord.xy * resolution - halfRes, halfRes - 0.005, r);\n        vec4 tex = texture2D(uSampler, vTextureCoord) * vColor;\n        vec4 blend = mix(vec4(1.0) * alpha, tex, blend);     \n        vec4 layer1 = mix(vec4(0.0), tex * fillColor, fillMask(b));\n        gl_FragColor = mix(layer1, blend * strokeColor, innerBorderMask(b, stroke));\n    }\n";
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/renderer/webgl/shaders/FadeOutShader.mjs

































function FadeOutShader_createSuper(t) { var r = FadeOutShader_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function FadeOutShader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (FadeOutShader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var FadeOutShader = function (_DefaultShader) {
  (0,inherits/* default */.Z)(FadeOutShader, _DefaultShader);
  var _super = FadeOutShader_createSuper(FadeOutShader);
  function FadeOutShader(context) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, FadeOutShader);
    _this = _super.call(this, context);
    _this._fade = [0, 0, 0, 0];
    return _this;
  }
  (0,createClass/* default */.Z)(FadeOutShader, [{
    key: "top",
    get: function get() {
      return this._fade[0];
    },
    set: function set(num) {
      this._fade[0] = num;
      this.redraw();
    }
  }, {
    key: "right",
    get: function get() {
      return this._fade[1];
    },
    set: function set(num) {
      this._fade[1] = num;
      this.redraw();
    }
  }, {
    key: "bottom",
    get: function get() {
      return this._fade[2];
    },
    set: function set(num) {
      this._fade[2] = num;
      this.redraw();
    }
  }, {
    key: "left",
    get: function get() {
      return this._fade[3];
    },
    set: function set(num) {
      this._fade[3] = num;
      this.redraw();
    }
  }, {
    key: "fade",
    get: function get() {
      return this._fade;
    },
    set: function set(v) {
      if (Array.isArray(v)) {
        if (v.length === 2) {
          this._fade = [v[0], v[1], v[0], v[1]];
        } else if (v.length === 3) {
          this._fade = [v[0], v[1], v[2], this._fade[3]];
        } else if (v.length === 4) {
          this._fade = v;
        } else {
          this._fade = [v[0], v[0], v[0], v[0]];
        }
      } else {
        this._fade = [v, v, v, v];
      }
      this.redraw();
    }
  }, {
    key: "setupUniforms",
    value: function setupUniforms(operation) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(FadeOutShader.prototype), "setupUniforms", this).call(this, operation);
      var owner = operation.shaderOwner;
      var renderPrecision = this.ctx.stage.getRenderPrecision();
      var fade = this._fade.map(function (f) {
        return f * renderPrecision;
      });
      this._setUniform('fade', new Float32Array(fade), this.gl.uniform4fv);
      this._setUniform('resolution', new Float32Array([owner._w * renderPrecision, owner._h * renderPrecision]), this.gl.uniform2fv);
    }
  }]);
  return FadeOutShader;
}(DefaultShader);

FadeOutShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    uniform sampler2D uSampler;\n    uniform vec2 resolution;\n    uniform vec4 fade;\n    \n    void main() {\n        vec4 color = texture2D(uSampler, vTextureCoord) * vColor;\n        vec2 halfRes = 0.5 * resolution.xy;\n        vec2 point = vTextureCoord.xy * resolution.xy;\n        \n        vec2 pos1;\n        vec2 pos2;\n        vec2 d;\n        float c;\n        float t = 0.0;\n             \n        if(fade[0] > 0.0) {\n            pos1 = vec2(point.x, point.y);\n            pos2 = vec2(point.x, point.y + fade[0]);\n            d = pos2 - pos1;\n            c = dot(pos1, d) / dot(d, d);\n            t = smoothstep(0.0, 1.0, clamp(c, 0.0, 1.0));\n            color = mix(vec4(0.0), color, t);\n        }\n        \n        if(fade[1] > 0.0) {\n            vec2 pos1 = vec2(point.x - resolution.x - fade[1], vTextureCoord.y);\n            vec2 pos2 = vec2(point.x - resolution.x, vTextureCoord.y);\n            d = pos1 - pos2;\n            c = dot(pos2, d) / dot(d, d);\n            t = smoothstep(0.0, 1.0, clamp(c, 0.0, 1.0));\n            color = mix(vec4(0.0), color, t);\n        }\n        \n        if(fade[2] > 0.0) {\n            vec2 pos1 = vec2(vTextureCoord.x, point.y - resolution.y - fade[2]);\n            vec2 pos2 = vec2(vTextureCoord.x, point.y - resolution.y);\n            d = pos1 - pos2;\n            c = dot(pos2, d) / dot(d, d);\n            t = smoothstep(0.0, 1.0, clamp(c, 0.0, 1.0));\n            color = mix(vec4(0.0), color, t);\n        }\n        \n        if(fade[3] > 0.0) {\n            pos1 = vec2(point.x, point.y);\n            pos2 = vec2(point.x + fade[3], point.y);\n            d = pos2 - pos1;\n            c = dot(pos1, d) / dot(d, d);\n            t = smoothstep(0.0, 1.0, clamp(c, 0.0, 1.0));\n            color = mix(vec4(0.0), color, t);\n        }\n        \n        gl_FragColor = color;\n    }\n";
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/renderer/webgl/shaders/VignetteShader.mjs
































function VignetteShader_createSuper(t) { var r = VignetteShader_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function VignetteShader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (VignetteShader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var VignetteShader = function (_DefaultShader) {
  (0,inherits/* default */.Z)(VignetteShader, _DefaultShader);
  var _super = VignetteShader_createSuper(VignetteShader);
  function VignetteShader(context) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, VignetteShader);
    _this = _super.call(this, context);
    _this._magnitude = 1.3;
    _this._intensity = 0.7;
    _this._pivot = [0.5, 0.5];
    return _this;
  }
  (0,createClass/* default */.Z)(VignetteShader, [{
    key: "setupUniforms",
    value: function setupUniforms(operation) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(VignetteShader.prototype), "setupUniforms", this).call(this, operation);
      this._setUniform("magnitude", this._magnitude, this.gl.uniform1f);
      this._setUniform("intensity", this._intensity, this.gl.uniform1f);
      this._setUniform('pivot', new Float32Array(this._pivot), this.gl.uniform2fv);
      this.redraw();
    }
  }, {
    key: "pivot",
    set: function set(v) {
      if (Array.isArray(v)) {
        this._pivot = v;
      } else {
        this._pivot = [v, v];
      }
      this.redraw();
    }
  }, {
    key: "pivotX",
    get: function get() {
      return this._pivot[0];
    },
    set: function set(v) {
      this._pivot[0] = v;
      this.redraw();
    }
  }, {
    key: "pivotY",
    get: function get() {
      return this._pivot[1];
    },
    set: function set(v) {
      this._pivot[1] = v;
      this.redraw();
    }
  }, {
    key: "intensity",
    get: function get() {
      return this._intensity;
    },
    set: function set(v) {
      this._intensity = v;
      this.redraw();
    }
  }, {
    key: "magnitude",
    get: function get() {
      return this._magnitude;
    },
    set: function set(v) {
      this._magnitude = v;
      this.redraw();
    }
  }]);
  return VignetteShader;
}(DefaultShader);

VignetteShader.vertexShaderSource = DefaultShader.vertexShaderSource;
VignetteShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    uniform sampler2D uSampler;\n\n    uniform float magnitude;\n    uniform float intensity;\n    uniform vec2 pivot;\n\n    void main() {\n        vec2 uv = vTextureCoord.xy - pivot + vec2(0.5);\n        uv.x = clamp(uv.x, 0.0, 1.0);\n        uv.y = clamp(uv.y, 0.0, 1.0);\n   \n        uv *=  1.00 - uv.yx;\n        float vig = uv.x * uv.y * 25.0 * intensity;\n        vig = pow(vig, 0.45 * magnitude);\n        vec4 fragColor = vec4(vig) * vColor;\n        gl_FragColor = texture2D(uSampler, vTextureCoord) * fragColor;\n\n    }\n";
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/renderer/webgl/shaders/SpinnerShader.mjs
































function SpinnerShader_createSuper(t) { var r = SpinnerShader_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function SpinnerShader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (SpinnerShader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }


var SpinnerShader = function (_DefaultShader) {
  (0,inherits/* default */.Z)(SpinnerShader, _DefaultShader);
  var _super = SpinnerShader_createSuper(SpinnerShader);
  function SpinnerShader(ctx) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, SpinnerShader);
    _this = _super.call(this, ctx);
    _this._radius = 100;
    _this._width = 50;
    _this._period = 1;
    _this._angle = 0.5;
    _this._smooth = 0.005;
    _this._color = 0xffffffff;
    _this._backgroundColor = 0xff000000;
    _this._time = Date.now();
    return _this;
  }
  (0,createClass/* default */.Z)(SpinnerShader, [{
    key: "radius",
    set: function set(v) {
      this._radius = v;
      this.redraw();
    }
  }, {
    key: "width",
    set: function set(v) {
      this._width = v;
      this.redraw();
    }
  }, {
    key: "period",
    set: function set(v) {
      this._period = v;
      this.redraw();
    }
  }, {
    key: "angle",
    set: function set(v) {
      this._angle = v;
      this.redraw();
    }
  }, {
    key: "smooth",
    set: function set(v) {
      this._smooth = v;
      this.redraw();
    }
  }, {
    key: "color",
    set: function set(v) {
      this._color = v;
      this.redraw();
    }
  }, {
    key: "backgroundColor",
    set: function set(v) {
      this._backgroundColor = v;
      this.redraw();
    }
  }, {
    key: "setupUniforms",
    value: function setupUniforms(operation) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(SpinnerShader.prototype), "setupUniforms", this).call(this, operation);
      var owner = operation.shaderOwner;
      this._setUniform("iTime", Date.now() - this._time, this.gl.uniform1f);
      var renderPrecision = this.ctx.stage.getRenderPrecision();
      this._setUniform('radius', this._radius * renderPrecision, this.gl.uniform1f);
      this._setUniform('width', this._width * renderPrecision, this.gl.uniform1f);
      this._setUniform('period', this._period, this.gl.uniform1f);
      this._setUniform('angle', this._angle, this.gl.uniform1f);
      this._setUniform('smooth', this._smooth, this.gl.uniform1f);
      this._setUniform('color', new Float32Array(StageUtils.getRgbaComponentsNormalized(this._color)), this.gl.uniform4fv);
      this._setUniform('backgroundColor', new Float32Array(StageUtils.getRgbaComponentsNormalized(this._backgroundColor)), this.gl.uniform4fv);
      this._setUniform('resolution', new Float32Array([owner._w * renderPrecision, owner._h * renderPrecision]), this.gl.uniform2fv);
      this.redraw();
    }
  }]);
  return SpinnerShader;
}(DefaultShader);

SpinnerShader.vertexShaderSource = DefaultShader.vertexShaderSource;
SpinnerShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    uniform sampler2D uSampler;\n\n    uniform float iTime;\n    uniform float radius;\n    uniform float width;\n    uniform float period;\n    uniform float angle;\n    uniform float smooth;\n    uniform vec2 resolution;\n\n    uniform vec4 color;\n    uniform vec4 backgroundColor;\n\n    float ratio = resolution.y / resolution.x;\n\n    vec2 transpose_pos(vec2 pos) {\n        if (ratio < 1.) {\n            float diff = 0.5 - pos.x;\n            pos.x = 0.5 - diff / ratio;\n        } else {\n            float diff = 0.5 - pos.y;\n            pos.y = 0.5 - diff * ratio;\n        }\n        return pos;\n    }\n\n    float get_angle(vec2 pos) {\n        pos = transpose_pos(pos);\n        float a = atan(pos.y - 0.5, pos.x - 0.5);\n        a = (1.0+a/3.14159)/2.0;\n        \n        return a;\n    }\n\n    float dist(vec2 pos1, vec2 pos2) {\n        pos1 = transpose_pos(pos1);\n        return distance(pos1, pos2);\n    }\n\n    void main()\n    {\n        vec2 fragCoord = vTextureCoord;\n        vec4 fragColor = vColor;\n        \n        vec2 st = vTextureCoord;\n        float pct = dist(st, vec2(0.5));\n\n        float a = get_angle(st);\n        float t = iTime / 1000.0 / period;\n\n        float inner = max((radius - width) / resolution.x, (radius - width) / resolution.y);\n        float outer = max(radius / resolution.x, radius / resolution.y);\n\n        float x1 = mod(t, 1.0);\n        float x2 = mod(t + angle, 1.0);\n\n        if (x1 < x2) {\n            if (a > x1 && a < x2) {\n                float val = (1.0 - (x2 - a) / angle) * smoothstep(0.0, 3. * smooth, (x2 - a));\n                fragColor = mix(backgroundColor, color, val);\n            } else {\n                fragColor = backgroundColor;\n            }\n        } else {\n            if (a < x2) {\n                float val = (1.0 - (x2 - a) / angle) * smoothstep(0.0, 3. * smooth, (x2 - a));\n                fragColor = mix(backgroundColor, color, val);\n            } else if (a > x1) {\n                float val = (1.0 - (1.0 + x2 - a) / angle) * smoothstep(0.0, 3. * smooth, (1.0 + x2 - a));\n                fragColor = mix(backgroundColor, color, val);\n            } else {\n                fragColor = backgroundColor;\n            }\n        }\n\n        float s = smoothstep(inner, inner + smooth + 0.00001, pct) * (1.0 - smoothstep(outer, outer + smooth + 0.00001, pct));\n        gl_FragColor = texture2D(uSampler, fragCoord) * vColor * (1. - s * fragColor.a) + fragColor * s;\n    }\n";
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/renderer/webgl/shaders/HoleShader.mjs
































function HoleShader_createSuper(t) { var r = HoleShader_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function HoleShader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (HoleShader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var HoleShader = function (_DefaultShader) {
  (0,inherits/* default */.Z)(HoleShader, _DefaultShader);
  var _super = HoleShader_createSuper(HoleShader);
  function HoleShader(context) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, HoleShader);
    _this = _super.call(this, context);
    _this._x = 0;
    _this._y = 0;
    _this._w = 0;
    _this._h = 0;
    _this._radius = 0;
    return _this;
  }
  (0,createClass/* default */.Z)(HoleShader, [{
    key: "x",
    get: function get() {
      return this._x;
    },
    set: function set(v) {
      this._x = v;
      this.redraw();
    }
  }, {
    key: "y",
    get: function get() {
      return this._y;
    },
    set: function set(v) {
      this._y = v;
      this.redraw();
    }
  }, {
    key: "w",
    get: function get() {
      return this._w;
    },
    set: function set(v) {
      this._w = v;
      this.redraw();
    }
  }, {
    key: "h",
    get: function get() {
      return this._h;
    },
    set: function set(v) {
      this._h = v;
      this.redraw();
    }
  }, {
    key: "radius",
    get: function get() {
      return this._radius;
    },
    set: function set(v) {
      this._radius = v;
      this.redraw();
    }
  }, {
    key: "setupUniforms",
    value: function setupUniforms(operation) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(HoleShader.prototype), "setupUniforms", this).call(this, operation);
      var owner = operation.shaderOwner;
      var renderPrecision = this.ctx.stage.getRenderPrecision();
      this._setUniform("x", this._x * renderPrecision, this.gl.uniform1f);
      this._setUniform("y", this._y * renderPrecision, this.gl.uniform1f);
      this._setUniform("w", this._w * renderPrecision, this.gl.uniform1f);
      this._setUniform("h", this._h * renderPrecision, this.gl.uniform1f);
      this._setUniform('radius', (this._radius + .5) * renderPrecision, this.gl.uniform1f);
      this._setUniform('resolution', new Float32Array([owner._w * renderPrecision, owner._h * renderPrecision]), this.gl.uniform2fv);
    }
  }, {
    key: "useDefault",
    value: function useDefault() {
      return this._x === 0 && this._y === 0 && this._w === 0 && this._h === 0;
    }
  }]);
  return HoleShader;
}(DefaultShader);

HoleShader.vertexShaderSource = DefaultShader.vertexShaderSource;
HoleShader.fragmentShaderSource = "\n   #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    uniform sampler2D uSampler;\n    uniform float x;\n    uniform float y;\n    uniform float w;\n    uniform float h;\n    uniform vec2 resolution;\n    uniform float radius;\n\n    float roundBox(vec2 p, vec2 b, float r) {\n        float d = length(max(abs(p)-b+r, 0.1))-r;\n        return smoothstep(1.0, 0.0, d);\n    }\n\n    void main(void){\n        vec4 color = texture2D(uSampler, vTextureCoord);\n        vec2 pos = vTextureCoord.xy * resolution - vec2(x, y) - vec2(w, h) / 2.0;\n        vec2 size = vec2(w, h) / 2.0;\n        float b = roundBox(pos, size, radius);\n        gl_FragColor = mix(color, vec4(0.0), b);\n    }\n";
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/renderer/webgl/shaders/RadialGradientShader.mjs
































function RadialGradientShader_createSuper(t) { var r = RadialGradientShader_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function RadialGradientShader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (RadialGradientShader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }


var RadialGradientShader = function (_DefaultShader) {
  (0,inherits/* default */.Z)(RadialGradientShader, _DefaultShader);
  var _super = RadialGradientShader_createSuper(RadialGradientShader);
  function RadialGradientShader(context) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, RadialGradientShader);
    _this = _super.call(this, context);
    _this._pivot = [0, 0];
    _this._ic = 0xffffffff;
    _this._normalizedIC = _this._getNormalizedColor(_this._ic);
    _this._oc = 0x00ffffff;
    _this._normalizedOC = _this._getNormalizedColor(_this._oc);
    _this._radius = 0;
    return _this;
  }
  (0,createClass/* default */.Z)(RadialGradientShader, [{
    key: "radiusX",
    get: function get() {
      return this._radius;
    },
    set: function set(v) {
      this.radius = v;
    }
  }, {
    key: "radiusY",
    get: function get() {
      return this._radiusY;
    },
    set: function set(v) {
      this._radiusY = v;
      this.redraw();
    }
  }, {
    key: "radius",
    set: function set(v) {
      this._radius = v;
      this.redraw();
    }
  }, {
    key: "innerColor",
    get: function get() {
      return this._ic;
    },
    set: function set(argb) {
      this._ic = argb;
      this._normalizedIC = this._getNormalizedColor(argb);
      this.redraw();
    }
  }, {
    key: "outerColor",
    get: function get() {
      return this._ic;
    },
    set: function set(argb) {
      this._oc = argb;
      this._normalizedOC = this._getNormalizedColor(argb);
      this.redraw();
    }
  }, {
    key: "color",
    get: function get() {
      return this.innerColor;
    },
    set: function set(argb) {
      this.innerColor = argb;
    }
  }, {
    key: "x",
    set: function set(f) {
      this._x = f;
      this.redraw();
    }
  }, {
    key: "y",
    set: function set(f) {
      this._y = f;
      this.redraw();
    }
  }, {
    key: "pivot",
    get: function get() {
      return this._pivot[0];
    },
    set: function set(v) {
      if (Array.isArray(v) && v.length === 2) {
        this._pivot = v;
      } else if (Array.isArray(v)) {
        this._pivot = [v[0], v[1] || v[0]];
      } else {
        this._pivot = [v, v];
      }
      this.redraw();
    }
  }, {
    key: "pivotY",
    get: function get() {
      return this._pivot[1];
    },
    set: function set(f) {
      this._pivot[1] = f;
      this.redraw();
    }
  }, {
    key: "pivotX",
    get: function get() {
      return this._pivot[0];
    },
    set: function set(f) {
      this._pivot[0] = f;
      this.redraw();
    }
  }, {
    key: "_getNormalizedColor",
    value: function _getNormalizedColor(color) {
      var col = StageUtils.getRgbaComponentsNormalized(color);
      col[0] *= col[3];
      col[1] *= col[3];
      col[2] *= col[3];
      return new Float32Array(col);
    }
  }, {
    key: "setupUniforms",
    value: function setupUniforms(operation) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(RadialGradientShader.prototype), "setupUniforms", this).call(this, operation);
      var owner = operation.shaderOwner;
      if (this._x) {
        this._pivot[0] = this._x / owner.w;
      }
      if (this._y) {
        this._pivot[1] = this._y / owner.h;
      }
      if (this._radius === 0) {
        this._radius = owner.w * 0.5;
      }
      this._setUniform('innerColor', this._normalizedIC, this.gl.uniform4fv);
      this._setUniform('fill', StageUtils.getRgbaComponentsNormalized(this._oc)[3], this.gl.uniform1f);
      this._setUniform('outerColor', this._normalizedOC, this.gl.uniform4fv);
      this._setUniform('pivot', new Float32Array(this._pivot), this.gl.uniform2fv);
      this._setUniform('resolution', new Float32Array([owner._w, owner._h]), this.gl.uniform2fv);
      this._setUniform('alpha', operation.getElementCore(0).renderContext.alpha, this.gl.uniform1f);
      this._setUniform('radius', this._radius, this.gl.uniform1f);
      this._setUniform('radiusY', this._radiusY || this._radius, this.gl.uniform1f);
    }
  }]);
  return RadialGradientShader;
}(DefaultShader);

RadialGradientShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    \n    #define PI 3.14159265359\n    \n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    uniform sampler2D uSampler;\n    uniform vec2 resolution;\n    uniform vec2 pivot;\n    uniform vec4 innerColor;\n    uniform vec4 outerColor;\n    uniform float radius;\n    uniform float radiusY;\n    uniform float alpha;\n    uniform float fill;\n    uniform float aspectRatio;\n    \n    void main() {\n        vec2 point = vTextureCoord.xy * resolution;\n        vec2 projection = vec2(pivot.x * resolution.x, pivot.y * resolution.y);\n        float d = length((point - projection) / vec2(radius * 2.0, radiusY * 2.0));\n        vec4 color = mix(texture2D(uSampler, vTextureCoord) * vColor, outerColor * alpha, fill);\n        gl_FragColor = mix(innerColor * alpha, color, smoothstep(0.0, 1.0, d));\n    }\n";
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/renderer/webgl/shaders/Light3dShader.mjs
































function Light3dShader_createSuper(t) { var r = Light3dShader_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function Light3dShader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (Light3dShader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var Light3dShader = function (_DefaultShader) {
  (0,inherits/* default */.Z)(Light3dShader, _DefaultShader);
  var _super = Light3dShader_createSuper(Light3dShader);
  function Light3dShader(ctx) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, Light3dShader);
    _this = _super.call(this, ctx);
    _this._strength = 0.5;
    _this._ambient = 0.5;
    _this._fudge = 0.4;
    _this._rx = 0;
    _this._ry = 0;
    _this._z = 0;
    _this._pivotX = NaN;
    _this._pivotY = NaN;
    _this._pivotZ = 0;
    _this._lightY = 0;
    _this._lightZ = 0;
    return _this;
  }
  (0,createClass/* default */.Z)(Light3dShader, [{
    key: "setupUniforms",
    value: function setupUniforms(operation) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(Light3dShader.prototype), "setupUniforms", this).call(this, operation);
      var vr = operation.shaderOwner;
      var element = vr.element;
      var pivotX = isNaN(this._pivotX) ? element.pivotX * vr.w : this._pivotX;
      var pivotY = isNaN(this._pivotY) ? element.pivotY * vr.h : this._pivotY;
      var coords = vr.getRenderTextureCoords(pivotX, pivotY);
      var rz = -Math.atan2(vr._renderContext.tc, vr._renderContext.ta);
      var gl = this.gl;
      this._setUniform("pivot", new Float32Array([coords[0], coords[1], this._pivotZ]), gl.uniform3fv);
      this._setUniform("rot", new Float32Array([this._rx, this._ry, rz]), gl.uniform3fv);
      this._setUniform("z", this._z, gl.uniform1f);
      this._setUniform("lightY", this.lightY, gl.uniform1f);
      this._setUniform("lightZ", this.lightZ, gl.uniform1f);
      this._setUniform("strength", this._strength, gl.uniform1f);
      this._setUniform("ambient", this._ambient, gl.uniform1f);
      this._setUniform("fudge", this._fudge, gl.uniform1f);
    }
  }, {
    key: "strength",
    get: function get() {
      return this._strength;
    },
    set: function set(v) {
      this._strength = v;
      this.redraw();
    }
  }, {
    key: "ambient",
    get: function get() {
      return this._ambient;
    },
    set: function set(v) {
      this._ambient = v;
      this.redraw();
    }
  }, {
    key: "fudge",
    get: function get() {
      return this._fudge;
    },
    set: function set(v) {
      this._fudge = v;
      this.redraw();
    }
  }, {
    key: "rx",
    get: function get() {
      return this._rx;
    },
    set: function set(v) {
      this._rx = v;
      this.redraw();
    }
  }, {
    key: "ry",
    get: function get() {
      return this._ry;
    },
    set: function set(v) {
      this._ry = v;
      this.redraw();
    }
  }, {
    key: "z",
    get: function get() {
      return this._z;
    },
    set: function set(v) {
      this._z = v;
      this.redraw();
    }
  }, {
    key: "pivotX",
    get: function get() {
      return this._pivotX;
    },
    set: function set(v) {
      this._pivotX = v + 1;
      this.redraw();
    }
  }, {
    key: "pivotY",
    get: function get() {
      return this._pivotY;
    },
    set: function set(v) {
      this._pivotY = v + 1;
      this.redraw();
    }
  }, {
    key: "lightY",
    get: function get() {
      return this._lightY;
    },
    set: function set(v) {
      this._lightY = v;
      this.redraw();
    }
  }, {
    key: "pivotZ",
    get: function get() {
      return this._pivotZ;
    },
    set: function set(v) {
      this._pivotZ = v;
      this.redraw();
    }
  }, {
    key: "lightZ",
    get: function get() {
      return this._lightZ;
    },
    set: function set(v) {
      this._lightZ = v;
      this.redraw();
    }
  }, {
    key: "useDefault",
    value: function useDefault() {
      return this._rx === 0 && this._ry === 0 && this._z === 0 && this._strength === 0 && this._ambient === 1;
    }
  }]);
  return Light3dShader;
}(DefaultShader);

Light3dShader.vertexShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    attribute vec2 aVertexPosition;\n    attribute vec2 aTextureCoord;\n    attribute vec4 aColor;\n    uniform vec2 projection;\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n\n    uniform float fudge;\n    uniform float strength;\n    uniform float ambient;\n    uniform float z;\n    uniform float lightY;\n    uniform float lightZ;\n    uniform vec3 pivot;\n    uniform vec3 rot;\n    varying vec3 pos;\n\n    void main(void) {\n        pos = vec3(aVertexPosition.xy, z);\n        \n        pos -= pivot;\n        \n        // Undo XY rotation\n        mat2 iRotXy = mat2( cos(rot.z), sin(rot.z), \n                           -sin(rot.z), cos(rot.z));\n        pos.xy = iRotXy * pos.xy;\n        \n        // Perform 3d rotations\n        gl_Position.x = cos(rot.x) * pos.x - sin(rot.x) * pos.z;\n        gl_Position.y = pos.y;\n        gl_Position.z = sin(rot.x) * pos.x + cos(rot.x) * pos.z;\n        \n        pos.x = gl_Position.x;\n        pos.y = cos(rot.y) * gl_Position.y - sin(rot.y) * gl_Position.z;\n        pos.z = sin(rot.y) * gl_Position.y + cos(rot.y) * gl_Position.z;\n        \n        // Redo XY rotation\n        iRotXy[0][1] = -iRotXy[0][1];\n        iRotXy[1][0] = -iRotXy[1][0];\n        pos.xy = iRotXy * pos.xy; \n\n        // Undo translate to pivot position\n        pos.xyz += pivot;\n\n        pos = vec3(pos.x * projection.x - 1.0, pos.y * -abs(projection.y) + 1.0, pos.z * projection.x);\n        \n        // Set depth perspective\n        float perspective = 1.0 + fudge * pos.z;\n\n        pos.z += lightZ * projection.x;\n\n        // Map coords to gl coordinate space.\n        // Set z to 0 because we don't want to perform z-clipping\n        gl_Position = vec4(pos.xy, 0.0, perspective);\n\n        // Correct light source position.\n        pos.y += lightY * abs(projection.y);\n\n        vTextureCoord = aTextureCoord;\n        vColor = aColor;\n        \n        gl_Position.y = -sign(projection.y) * gl_Position.y;\n    }\n";
Light3dShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    varying vec3 pos;\n    uniform sampler2D uSampler;\n    uniform float ambient;\n    uniform float strength;\n    void main(void){\n        vec4 rgba = texture2D(uSampler, vTextureCoord);\n        float d = length(pos);\n        float n = 1.0 / max(0.1, d);\n        rgba.rgb = rgba.rgb * (strength * n + ambient);\n        gl_FragColor = rgba * vColor;\n    }\n";
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/renderer/webgl/shaders/PerspectiveShader.mjs
































function PerspectiveShader_createSuper(t) { var r = PerspectiveShader_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function PerspectiveShader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (PerspectiveShader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var PerspectiveShader = function (_DefaultShader) {
  (0,inherits/* default */.Z)(PerspectiveShader, _DefaultShader);
  var _super = PerspectiveShader_createSuper(PerspectiveShader);
  function PerspectiveShader(ctx) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, PerspectiveShader);
    _this = _super.call(this, ctx);
    _this._fudge = 0.2;
    _this._rx = 0;
    _this._ry = 0;
    _this._z = 1.0;
    return _this;
  }
  (0,createClass/* default */.Z)(PerspectiveShader, [{
    key: "setupUniforms",
    value: function setupUniforms(operation) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(PerspectiveShader.prototype), "setupUniforms", this).call(this, operation);
      var vr = operation.shaderOwner;
      var element = vr.element;
      var pivotX = element.pivotX * vr.w;
      var pivotY = element.pivotY * vr.h;
      var coords = vr.getRenderTextureCoords(pivotX, pivotY);
      var rz = -Math.atan2(vr._renderContext.tc, vr._renderContext.ta);
      var gl = this.gl;
      this._setUniform("pivot", new Float32Array([coords[0], coords[1], 0]), gl.uniform3fv);
      this._setUniform("rot", new Float32Array([this._rx, this._ry, rz]), gl.uniform3fv);
      this._setUniform("z", this._z, gl.uniform1f);
      this._setUniform("fudge", this._fudge, gl.uniform1f);
    }
  }, {
    key: "fudge",
    get: function get() {
      return this._fudge;
    },
    set: function set(v) {
      this._fudge = v;
      this.redraw();
    }
  }, {
    key: "rx",
    get: function get() {
      return this._rx;
    },
    set: function set(v) {
      this._rx = v;
      this.redraw();
    }
  }, {
    key: "ry",
    get: function get() {
      return this._ry;
    },
    set: function set(v) {
      this._ry = v;
      this.redraw();
    }
  }, {
    key: "z",
    get: function get() {
      return this._z;
    },
    set: function set(v) {
      this._z = v;
      this.redraw();
    }
  }, {
    key: "useDefault",
    value: function useDefault() {
      return this._rx === 0 && this._ry === 0 && this._z === 0;
    }
  }]);
  return PerspectiveShader;
}(DefaultShader);

PerspectiveShader.vertexShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    attribute vec2 aVertexPosition;\n    attribute vec2 aTextureCoord;\n    attribute vec4 aColor;\n    uniform vec2 projection;\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n\n    uniform float z;\n    uniform vec3 pivot;\n    uniform vec3 rot;\n    varying vec3 pos;\n\n    void main(void) {\n        pos = vec3(aVertexPosition.xy, z);\n        \n        pos -= pivot;\n        \n        // Undo XY rotation\n        mat2 iRotXy = mat2( cos(rot.z), sin(rot.z), \n                           -sin(rot.z), cos(rot.z));\n        pos.xy = iRotXy * pos.xy;\n        \n        // Perform 3d rotations\n        gl_Position.x = cos(rot.x) * pos.x - sin(rot.x) * pos.z;\n        gl_Position.y = pos.y;\n        gl_Position.z = sin(rot.x) * pos.x + cos(rot.x) * pos.z;\n        \n        pos.x = gl_Position.x;\n        pos.y = cos(rot.y) * gl_Position.y - sin(rot.y) * gl_Position.z;\n        pos.z = sin(rot.y) * gl_Position.y + cos(rot.y) * gl_Position.z;\n        \n        // Redo XY rotation\n        iRotXy[0][1] = -iRotXy[0][1];\n        iRotXy[1][0] = -iRotXy[1][0];\n        pos.xy = iRotXy * pos.xy; \n\n        // Undo translate to pivot position\n        pos.xyz += pivot;\n\n        pos = vec3(pos.x * projection.x - 1.0, pos.y * -abs(projection.y) + 1.0, pos.z * projection.x);\n        \n        // Map coords to gl coordinate space.\n        // Set z to 0 because we don't want to perform z-clipping\n        gl_Position = vec4(pos.xy, 0.0, z);\n\n        vTextureCoord = aTextureCoord;\n        vColor = aColor;\n        \n        gl_Position.y = -sign(projection.y) * gl_Position.y;\n    }\n";
PerspectiveShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    uniform sampler2D uSampler;\n\n    uniform vec3 rot;\n    uniform float fudge;\n\n    void main(void) {\n        vec2 coords = vTextureCoord;\n\n        coords.xy -= vec2(0.5);\n        coords.y = coords.y + (sign(rot[0]) * 0.5 - coords.x) * sin(rot[0]) * fudge * coords.y;\n        coords.x = coords.x + (sign(rot[1]) * 0.5 - coords.y) * sin(rot[1]) * fudge * coords.x;\n        coords.xy += vec2(0.5);\n\n        if (coords.x < 0.0 || coords.x > 1.0 || coords.y < 0.0 || coords.y > 1.0) {\n            gl_FragColor = vec4(0.0);\n        } else {\n            gl_FragColor = texture2D(uSampler, coords) * vColor;\n        }\n    }\n";
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/renderer/webgl/shaders/MagnifierShader.mjs
































function MagnifierShader_createSuper(t) { var r = MagnifierShader_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function MagnifierShader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (MagnifierShader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var MagnifierShader = function (_DefaultShader) {
  (0,inherits/* default */.Z)(MagnifierShader, _DefaultShader);
  var _super = MagnifierShader_createSuper(MagnifierShader);
  function MagnifierShader(context) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, MagnifierShader);
    _this = _super.call(this, context);
    _this._x = 0;
    _this._y = 0;
    _this._w = 0;
    _this._h = 0;
    _this._radius = 0;
    _this._magnification = 0.6;
    return _this;
  }
  (0,createClass/* default */.Z)(MagnifierShader, [{
    key: "x",
    get: function get() {
      return this._x;
    },
    set: function set(v) {
      this._x = v;
      this.redraw();
    }
  }, {
    key: "y",
    get: function get() {
      return this._y;
    },
    set: function set(v) {
      this._y = v;
      this.redraw();
    }
  }, {
    key: "w",
    get: function get() {
      return this._w;
    },
    set: function set(v) {
      this._w = v;
      this.redraw();
    }
  }, {
    key: "h",
    get: function get() {
      return this._h;
    },
    set: function set(v) {
      this._h = v;
      this.redraw();
    }
  }, {
    key: "magnification",
    get: function get() {
      return this._magnification;
    },
    set: function set(v) {
      this._magnification = v;
      this.redraw();
    }
  }, {
    key: "radius",
    get: function get() {
      return this._radius;
    },
    set: function set(v) {
      this._radius = v;
      this.redraw();
    }
  }, {
    key: "setupUniforms",
    value: function setupUniforms(operation) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(MagnifierShader.prototype), "setupUniforms", this).call(this, operation);
      var owner = operation.shaderOwner;
      var renderPrecision = this.ctx.stage.getRenderPrecision();
      this._setUniform('x', this._x * renderPrecision, this.gl.uniform1f);
      this._setUniform('y', this._y * renderPrecision, this.gl.uniform1f);
      this._setUniform('w', this._w * renderPrecision, this.gl.uniform1f);
      this._setUniform('h', this._h * renderPrecision, this.gl.uniform1f);
      this._setUniform('magnification', this._magnification, this.gl.uniform1f);
      this._setUniform('radius', (this._radius + 0.5) * renderPrecision, this.gl.uniform1f);
      this._setUniform('resolution', new Float32Array([owner._w * renderPrecision, owner._h * renderPrecision]), this.gl.uniform2fv);
    }
  }, {
    key: "useDefault",
    value: function useDefault() {
      return this._w === 0 && this._h === 0;
    }
  }]);
  return MagnifierShader;
}(DefaultShader);

MagnifierShader.vertexShaderSource = DefaultShader.vertexShaderSource;
MagnifierShader.fragmentShaderSource = "\n\t  #ifdef GL_ES\n\t\t# ifdef GL_FRAGMENT_PRECISION_HIGH\n\t\tprecision highp float;\n\t\t# else\n\t\tprecision lowp float;\n\t\t# endif\n\t  #endif\n\n\t  varying vec2 vTextureCoord;\n\t  varying vec4 vColor;\n\t  uniform sampler2D uSampler;\n\t  uniform float x;\n\t  uniform float y;\n\t  uniform float w;\n\t  uniform float h;\n\t  uniform vec2 resolution;\n\t  uniform float radius;\n\t  uniform float magnification;\n  \n\t  float roundBox(vec2 p, vec2 b, float r) {\n\t\t  float d = length(max(abs(p)-b+r, 0.1))-r;\n\t\t  return smoothstep(1.0, 0.0, d);\n\t  }\n\n\t  float inside(vec2 v) {\n\t\tvec2 s = step(vec2(0.0, 0.0), v) - step(vec2(1.0, 1.0), v);\n\t\treturn s.x * s.y;   \n      }\n  \n\t  void main(void) {\n\t\tvec4 color = texture2D(uSampler, vTextureCoord);\n\t\tvec2 pos = vTextureCoord.xy * resolution - vec2(x, y) - vec2(w, h) / 2.0;\n\t\tvec2 size = vec2(w, h) / 2.0;\n\t\tfloat b = roundBox(pos, size, radius);\n\t\tvec2 pos2 = (vTextureCoord.xy * magnification * resolution + vec2(x, y) * magnification) / resolution;\n\t\tgl_FragColor = mix(color, texture2D(uSampler, pos2) * inside(pos2), b) * vColor;\n\t  }\n  ";
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/renderer/webgl/shaders/SpinnerShader2.mjs
































function SpinnerShader2_createSuper(t) { var r = SpinnerShader2_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function SpinnerShader2_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (SpinnerShader2_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }


var SpinnerShader2 = function (_DefaultShader) {
  (0,inherits/* default */.Z)(SpinnerShader2, _DefaultShader);
  var _super = SpinnerShader2_createSuper(SpinnerShader2);
  function SpinnerShader2(context) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, SpinnerShader2);
    _this = _super.call(this, context);
    _this._period = 1;
    _this._stroke = 0;
    _this._showDot = true;
    _this._clockwise = true;
    _this._bc = 0xff000000;
    _this._normalizedBC = _this._getNormalizedColor(_this._bc);
    _this._c = 0xffffffff;
    _this._normalizedC = _this._getNormalizedColor(_this._c);
    return _this;
  }
  (0,createClass/* default */.Z)(SpinnerShader2, [{
    key: "radius",
    set: function set(v) {
      if (v === 0) {
        v = 1;
      }
      this._radius = v;
    }
  }, {
    key: "stroke",
    get: function get() {
      return this._stroke;
    },
    set: function set(value) {
      this._stroke = Math.abs(value);
    }
  }, {
    key: "color",
    get: function get() {
      return this._c;
    },
    set: function set(argb) {
      this._c = argb;
      this._normalizedC = this._getNormalizedColor(argb);
    }
  }, {
    key: "backgroundColor",
    get: function get() {
      return this._sc;
    },
    set: function set(argb) {
      this._bc = argb;
      this._normalizedBC = this._getNormalizedColor(argb);
    }
  }, {
    key: "showDot",
    get: function get() {
      return this._showDot;
    },
    set: function set(bool) {
      this._showDot = bool;
    }
  }, {
    key: "clockwise",
    get: function get() {
      return this._clockwise;
    },
    set: function set(bool) {
      this._clockwise = bool;
    }
  }, {
    key: "period",
    get: function get() {
      return this._period;
    },
    set: function set(v) {
      this._period = v;
    }
  }, {
    key: "_getNormalizedColor",
    value: function _getNormalizedColor(color) {
      var col = StageUtils.getRgbaComponentsNormalized(color);
      col[0] *= col[3];
      col[1] *= col[3];
      col[2] *= col[3];
      return new Float32Array(col);
    }
  }, {
    key: "setupUniforms",
    value: function setupUniforms(operation) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(SpinnerShader2.prototype), "setupUniforms", this).call(this, operation);
      var owner = operation.shaderOwner;
      var radius = this._radius || owner._w / 2;
      if (this._stroke === 0) {
        this._stroke = radius * 0.33;
      }
      this._setUniform('resolution', new Float32Array([owner._w, owner._h]), this.gl.uniform2fv);
      this._setUniform('color', this._normalizedC, this.gl.uniform4fv);
      this._setUniform('backgroundColor', this._normalizedBC, this.gl.uniform4fv);
      this._setUniform('stroke', this._stroke, this.gl.uniform1f);
      this._setUniform('radius', radius, this.gl.uniform1f);
      this._setUniform('direction', this._clockwise ? -1 : 1, this.gl.uniform1f);
      this._setUniform('showDot', !!this._showDot, this.gl.uniform1f);
      this._setUniform('time', Date.now() - SpinnerShader2.spinSync, this.gl.uniform1f);
      this._setUniform('period', this._period, this.gl.uniform1f);
      this._setUniform('alpha', operation.getElementCore(0).renderContext.alpha, this.gl.uniform1f);
      if (this._sc !== this._bc || this._stroke !== radius * 0.5) {
        this.redraw();
      }
    }
  }]);
  return SpinnerShader2;
}(DefaultShader);

SpinnerShader2.spinSync = Date.now();
SpinnerShader2.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    \n    #define PI 3.14159265359\n    \n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    \n    uniform sampler2D uSampler;\n    uniform vec2 resolution;\n    uniform vec4 color;\n    uniform vec4 backgroundColor;\n    uniform float direction;\n    uniform float radius;\n    uniform float time;\n    uniform float stroke;\n    uniform float showDot;\n    uniform float period;\n    uniform float alpha;\n    \n    float circleDist(vec2 p, float radius){\n        return length(p) - radius;\n    }\n    \n    float fillMask(float dist){\n        return clamp(-dist, 0.0, 1.0);\n    }\n    \n    void main() {\n        vec2 halfRes = 0.5 * resolution.xy;\n        vec2 center = vTextureCoord.xy * resolution - halfRes;\n        \n        float c = max(-circleDist(center, radius - stroke), circleDist(center, radius));\n        float rot = -(time / 1000.0 / period) * 6.0 * direction;\n        center *= mat2(cos(rot), sin(rot), -sin(rot), cos(rot));\n        \n        float a = direction * atan(center.x, center.y) * PI * 0.05 + 0.45;\n        \n        float strokeRad = stroke * 0.5;\n        a = mix(a, max(a, fillMask(circleDist(vec2(center.x, center.y + (radius - strokeRad)), strokeRad))), showDot);\n        vec4 base = mix(vec4(0.0), backgroundColor * alpha, fillMask(c));\n        gl_FragColor = mix(base, color * alpha, fillMask(c) * a);\n    }\n";
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/src/lightning.mjs





















































var lightning = {
  Application: Application,
  Component: Component,
  Base: Base,
  Utils: Utils_Utils,
  StageUtils: StageUtils,
  Element: Element,
  Tools: Tools,
  Stage: Stage,
  ElementCore: ElementCore,
  ElementTexturizer: ElementTexturizer,
  Texture: Texture,
  EventEmitter: EventEmitter,
  shaders: {
    Grayscale: WebGLGrayscaleShader,
    BoxBlur: BoxBlurShader,
    Dithering: DitheringShader,
    CircularPush: CircularPushShader,
    Inversion: InversionShader,
    LinearBlur: LinearBlurShader,
    Outline: OutlineShader,
    Pixelate: PixelateShader,
    RadialFilter: RadialFilterShader,
    RoundedRectangle: RoundedRectangleShader,
    Spinner2: SpinnerShader2,
    FadeOut: FadeOutShader,
    Hole: HoleShader,
    Vignette: VignetteShader,
    Spinner: SpinnerShader,
    RadialGradient: RadialGradientShader,
    Light3d: Light3dShader,
    Perspective: PerspectiveShader,
    Magnifier: MagnifierShader,
    WebGLShader: WebGLShader,
    WebGLDefaultShader: DefaultShader,
    C2dShader: C2dShader,
    C2dDefaultShader: DefaultShader_DefaultShader,
    c2d: {
      Grayscale: C2dGrayscaleShader,
      Blur: BlurShader
    }
  },
  textures: {
    RectangleTexture: RectangleTexture,
    NoiseTexture: NoiseTexture,
    TextTexture: TextTexture,
    ImageTexture: ImageTexture,
    HtmlTexture: HtmlTexture,
    StaticTexture: StaticTexture,
    StaticCanvasTexture: StaticCanvasTexture,
    SourceTexture: SourceTexture
  },
  components: {
    FastBlurComponent: FastBlurComponent,
    BloomComponent: BloomComponent,
    SmoothScaleComponent: SmoothScaleComponent,
    BorderComponent: BorderComponent,
    ListComponent: ListComponent
  },
  tools: {
    ObjMerger: ObjMerger,
    ObjectListProxy: ObjectListProxy,
    ObjectListWrapper: ObjectListWrapper
  }
};
if (Utils_Utils.isWeb) {
  window.lng = lightning;
}
/* harmony default export */ const src_lightning = (lightning);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+core@2.9.0/node_modules/@lightningjs/core/index.js

/* harmony default export */ const core = (src_lightning);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Lightning/index.js

/* harmony default export */ const src_Lightning = (core);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Accessibility/shaders/ColorShift.js






function ColorShift_createSuper(t) { var r = ColorShift_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function ColorShift_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (ColorShift_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var ColorShift = function (_Lightning$shaders$We) {
  (0,inherits/* default */.Z)(ColorShift, _Lightning$shaders$We);
  var _super = ColorShift_createSuper(ColorShift);
  function ColorShift() {
    (0,classCallCheck/* default */.Z)(this, ColorShift);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(ColorShift, [{
    key: "brightness",
    set: function set(v) {
      this._brightness = (v - 50) / 100;
      this.redraw();
    }
  }, {
    key: "contrast",
    set: function set(v) {
      this._contrast = (v + 50) / 100;
      this.redraw();
    }
  }, {
    key: "gamma",
    set: function set(v) {
      this._gamma = (v + 50) / 100;
      this.redraw();
    }
  }, {
    key: "setupUniforms",
    value: function setupUniforms(operation) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(ColorShift.prototype), "setupUniforms", this).call(this, operation);
      var gl = this.gl;
      this._setUniform('colorAdjust', [this._brightness || 0.0, this._contrast || 1.0, this._gamma || 1.0], gl.uniform3fv);
    }
  }]);
  return ColorShift;
}(src_Lightning.shaders.WebGLDefaultShader);

ColorShift.before = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n        \n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    uniform sampler2D uSampler;\n    uniform vec3 colorAdjust;\n    \n    const mat3 RGBtoOpponentMat = mat3(0.2814, -0.0971, -0.0930, 0.6938, 0.1458,-0.2529, 0.0638, -0.0250, 0.4665);\n    const mat3 OpponentToRGBMat = mat3(1.1677, 0.9014, 0.7214, -6.4315, 2.5970, 0.1257, -0.5044, 0.0159, 2.0517);    \n";
ColorShift.after = "    \n    vec3 brightnessContrast(vec3 value, float brightness, float contrast)\n    {\n        return (value - 0.5) * contrast + 0.5 + brightness;\n    }   \n    \n    vec3 updateGamma(vec3 value, float param)\n    {\n        return vec3(pow(abs(value.r), param),pow(abs(value.g), param),pow(abs(value.b), param));\n    } \n       \n    void main(void){\n        vec4 fragColor = texture2D(uSampler, vTextureCoord);        \n        vec4 color = filter(fragColor) * vColor;       \n        \n        vec3 bc = brightnessContrast(color.rgb,colorAdjust[0],colorAdjust[1]);        \n        vec3 ga = updateGamma(bc.rgb, colorAdjust[2]);  \n              \n        gl_FragColor = vec4(ga.rgb, color.a);          \n    }    \n";
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Accessibility/shaders/ProtanopiaShader.js






function ProtanopiaShader_createSuper(t) { var r = ProtanopiaShader_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function ProtanopiaShader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (ProtanopiaShader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var ProtanopiaShader = function (_ColorShift) {
  (0,inherits/* default */.Z)(ProtanopiaShader, _ColorShift);
  var _super = ProtanopiaShader_createSuper(ProtanopiaShader);
  function ProtanopiaShader() {
    (0,classCallCheck/* default */.Z)(this, ProtanopiaShader);
    return _super.apply(this, arguments);
  }
  return (0,createClass/* default */.Z)(ProtanopiaShader);
}(ColorShift);

ProtanopiaShader.fragmentShaderSource = "\n    ".concat(ColorShift.before, "    \n    vec4 vision(vec4 color)\n    {\n        vec4 r = vec4( 0.20,  0.99, -0.19, 0.0);\n        vec4 g = vec4( 0.16,  0.79,  0.04, 0.0);\n        vec4 b = vec4( 0.01, -0.01,  1.00, 0.0);\n       \n        return vec4(dot(color, r), dot(color, g), dot(color, b), color.a);\t\n    }\n    \n    vec4 filter( vec4 color )\n    {   \n        vec3 opponentColor = RGBtoOpponentMat * vec3(color.r, color.g, color.b);\n        opponentColor.x -= opponentColor.y * 1.5; \n        vec3 rgbColor = OpponentToRGBMat * opponentColor;\n        return vision(vec4(rgbColor.r, rgbColor.g, rgbColor.b, color.a));      \n    }    \n    ").concat(ColorShift.after, " \n");
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Accessibility/shaders/DeuteranopiaShader.js






function DeuteranopiaShader_createSuper(t) { var r = DeuteranopiaShader_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function DeuteranopiaShader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (DeuteranopiaShader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var DeuteranopiaShader = function (_ColorShift) {
  (0,inherits/* default */.Z)(DeuteranopiaShader, _ColorShift);
  var _super = DeuteranopiaShader_createSuper(DeuteranopiaShader);
  function DeuteranopiaShader() {
    (0,classCallCheck/* default */.Z)(this, DeuteranopiaShader);
    return _super.apply(this, arguments);
  }
  return (0,createClass/* default */.Z)(DeuteranopiaShader);
}(ColorShift);

DeuteranopiaShader.fragmentShaderSource = "\n    ".concat(ColorShift.before, "\n    vec4 vision(vec4 color)\n    {\n        vec4 r = vec4( 0.43,  0.72, -0.15, 0.0 );\n        vec4 g = vec4( 0.34,  0.57,  0.09, 0.0 );\n        vec4 b = vec4(-0.02,  0.03,  1.00, 0.0 );\n       \n        return vec4(dot(color, r), dot(color, g), dot(color, b), color.a);\t\n    }\n       \n    vec4 filter( vec4 color )\n    {   \n        vec3 opponentColor = RGBtoOpponentMat * vec3(color.r, color.g, color.b);\n        opponentColor.x -= opponentColor.y * 1.5; \n        vec3 rgbColor = OpponentToRGBMat * opponentColor;\n        return vision(vec4(rgbColor.r, rgbColor.g, rgbColor.b, color.a));    \n    }\n    ").concat(ColorShift.after, "    \n");
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Accessibility/shaders/TritanopiaShader.js






function TritanopiaShader_createSuper(t) { var r = TritanopiaShader_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function TritanopiaShader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (TritanopiaShader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var TritanopiaShader = function (_ColorShift) {
  (0,inherits/* default */.Z)(TritanopiaShader, _ColorShift);
  var _super = TritanopiaShader_createSuper(TritanopiaShader);
  function TritanopiaShader() {
    (0,classCallCheck/* default */.Z)(this, TritanopiaShader);
    return _super.apply(this, arguments);
  }
  return (0,createClass/* default */.Z)(TritanopiaShader);
}(ColorShift);

TritanopiaShader.fragmentShaderSource = "\n    ".concat(ColorShift.before, "    \n    vec4 vision(vec4 color)\n    {\n        vec4 r = vec4( 0.97,  0.11, -0.08, 0.0 );\n        vec4 g = vec4( 0.02,  0.82,  0.16, 0.0 );\n        vec4 b = vec4(-0.06,  0.88,  0.18, 0.0 );\n       \n        return vec4(dot(color, r), dot(color, g), dot(color, b), color.a);\t\n    }   \n    \n    vec4 filter( vec4 color )\n    {   \n        vec3 opponentColor = RGBtoOpponentMat * vec3(color.r, color.g, color.b);\n        opponentColor.x -= ((3.0 * opponentColor.z) - opponentColor.y) * 0.25;\n        vec3 rgbColor = OpponentToRGBMat * opponentColor;\n        return vision(vec4(rgbColor.r, rgbColor.g, rgbColor.b, color.a));\n    }   \n    ").concat(ColorShift.after, " \n");
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Accessibility/shaders/NormalShader.js






function NormalShader_createSuper(t) { var r = NormalShader_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function NormalShader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (NormalShader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var NeutralShader = function (_ColorShift) {
  (0,inherits/* default */.Z)(NeutralShader, _ColorShift);
  var _super = NormalShader_createSuper(NeutralShader);
  function NeutralShader() {
    (0,classCallCheck/* default */.Z)(this, NeutralShader);
    return _super.apply(this, arguments);
  }
  return (0,createClass/* default */.Z)(NeutralShader);
}(ColorShift);

NeutralShader.fragmentShaderSource = "\n    ".concat(ColorShift.before, "\n    vec4 filter( vec4 color )\n    {\n        return color;\n    }\n    ").concat(ColorShift.after, "\n");
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Accessibility/shaders/MonochromacyShader.js






function MonochromacyShader_createSuper(t) { var r = MonochromacyShader_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function MonochromacyShader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (MonochromacyShader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var MonochromacyShader = function (_ColorShift) {
  (0,inherits/* default */.Z)(MonochromacyShader, _ColorShift);
  var _super = MonochromacyShader_createSuper(MonochromacyShader);
  function MonochromacyShader() {
    (0,classCallCheck/* default */.Z)(this, MonochromacyShader);
    return _super.apply(this, arguments);
  }
  return (0,createClass/* default */.Z)(MonochromacyShader);
}(ColorShift);

MonochromacyShader.fragmentShaderSource = "\n    ".concat(ColorShift.before, "\n    vec4 filter( vec4 color )\n    {   \n        float grey = dot(color.rgb, vec3(0.299, 0.587, 0.114));\n        return vec4(vec3(grey, grey, grey), 1.0 ); \n    }\n    ").concat(ColorShift.after, "\n");
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Accessibility/shaders/index.js






var colorshiftShader = function colorshiftShader(type) {
  var shadersMap = {
    normal: NeutralShader,
    monochromacy: MonochromacyShader,
    deuteranopia: DeuteranopiaShader,
    tritanopia: TritanopiaShader,
    protanopia: ProtanopiaShader
  };
  type = typeof type === 'string' && type.toLowerCase() || null;
  return Object.keys(shadersMap).indexOf(type) > -1 ? shadersMap[type] : false;
};
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.promise.finally.js
var es_promise_finally = __webpack_require__(45142);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Accessibility/Announcer/Speech.js













function flattenStrings() {
  var series = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var flattenedSeries = [];
  for (var i = 0; i < series.length; i++) {
    if (typeof series[i] === 'string' && !series[i].includes('PAUSE-')) {
      flattenedSeries.push(series[i]);
    } else {
      break;
    }
  }
  return [flattenedSeries.join(',\b ')].concat(series.slice(i));
}
function delay(pause) {
  return new Promise(function (resolve) {
    setTimeout(resolve, pause);
  });
}
function speak(phrase, utterances) {
  var lang = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en-US';
  var synth = window.speechSynthesis;
  return new Promise(function (resolve, reject) {
    var utterance = new SpeechSynthesisUtterance(phrase);
    utterance.lang = lang;
    utterance.onend = function () {
      resolve();
    };
    utterance.onerror = function (e) {
      reject(e);
    };
    utterances.push(utterance);
    synth.speak(utterance);
  });
}
function speakSeries(series, lang) {
  var root = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var synth = window.speechSynthesis;
  var remainingPhrases = flattenStrings(Array.isArray(series) ? series : [series]);
  var nestedSeriesResults = [];
  var utterances = [];
  var active = true;
  var seriesChain = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee() {
    var phrase, pause, totalRetries, retriesLeft, seriesResult, _seriesResult;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
        case 1:
          if (!(active && remainingPhrases.length)) {
            _context.next = 62;
            break;
          }
          _context.next = 4;
          return Promise.resolve(remainingPhrases.shift());
        case 4:
          phrase = _context.sent;
          if (active) {
            _context.next = 9;
            break;
          }
          return _context.abrupt("break", 62);
        case 9:
          if (!(typeof phrase === 'string' && phrase.includes('PAUSE-'))) {
            _context.next = 16;
            break;
          }
          pause = phrase.split('PAUSE-')[1] * 1000;
          if (isNaN(pause)) {
            pause = 0;
          }
          _context.next = 14;
          return delay(pause);
        case 14:
          _context.next = 60;
          break;
        case 16:
          if (!(typeof phrase === 'string' && phrase.length)) {
            _context.next = 48;
            break;
          }
          totalRetries = 3;
          retriesLeft = totalRetries;
        case 19:
          if (!(active && retriesLeft > 0)) {
            _context.next = 46;
            break;
          }
          _context.prev = 20;
          _context.next = 23;
          return speak(phrase, utterances, lang);
        case 23:
          retriesLeft = 0;
          _context.next = 44;
          break;
        case 26:
          _context.prev = 26;
          _context.t0 = _context["catch"](20);
          if (!(_context.t0 instanceof SpeechSynthesisErrorEvent)) {
            _context.next = 43;
            break;
          }
          if (!(_context.t0.error === 'network')) {
            _context.next = 36;
            break;
          }
          retriesLeft--;
          console.warn("Speech synthesis network error. Retries left: ".concat(retriesLeft));
          _context.next = 34;
          return delay(500 * (totalRetries - retriesLeft));
        case 34:
          _context.next = 41;
          break;
        case 36:
          if (!(_context.t0.error === 'canceled' || _context.t0.error === 'interrupted')) {
            _context.next = 40;
            break;
          }
          retriesLeft = 0;
          _context.next = 41;
          break;
        case 40:
          throw new Error("SpeechSynthesisErrorEvent: ".concat(_context.t0.error));
        case 41:
          _context.next = 44;
          break;
        case 43:
          throw _context.t0;
        case 44:
          _context.next = 19;
          break;
        case 46:
          _context.next = 60;
          break;
        case 48:
          if (!(typeof phrase === 'function')) {
            _context.next = 55;
            break;
          }
          seriesResult = speakSeries(phrase(), lang, false);
          nestedSeriesResults.push(seriesResult);
          _context.next = 53;
          return seriesResult.series;
        case 53:
          _context.next = 60;
          break;
        case 55:
          if (!Array.isArray(phrase)) {
            _context.next = 60;
            break;
          }
          _seriesResult = speakSeries(phrase, lang, false);
          nestedSeriesResults.push(_seriesResult);
          _context.next = 60;
          return _seriesResult.series;
        case 60:
          _context.next = 1;
          break;
        case 62:
          _context.prev = 62;
          active = false;
          return _context.finish(62);
        case 65:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0,, 62, 65], [20, 26]]);
  }))();
  return {
    series: seriesChain,
    get active() {
      return active;
    },
    append: function append(toSpeak) {
      remainingPhrases.push(toSpeak);
    },
    cancel: function cancel() {
      if (!active) {
        return;
      }
      if (root) {
        synth.cancel();
      }
      nestedSeriesResults.forEach(function (nestedSeriesResults) {
        nestedSeriesResults.cancel();
      });
      active = false;
    }
  };
}
var currentSeries;
/* harmony default export */ function Speech(toSpeak, lang) {
  currentSeries && currentSeries.cancel();
  currentSeries = speakSeries(toSpeak, lang);
  return currentSeries;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Accessibility/Announcer/utils.js

function getElmName(elm) {
  return elm.ref || elm.constructor.name;
}
function debounce(func, wait, immediate) {
  var timeout, args, context, timestamp, result;
  if (null == wait) wait = 100;
  function later() {
    var last = Date.now() - timestamp;
    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        context = args = null;
      }
    }
  }
  var debounced = function debounced() {
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }
    return result;
  };
  debounced.clear = function () {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  debounced.flush = function () {
    if (timeout) {
      result = func.apply(context, args);
      context = args = null;
      clearTimeout(timeout);
      timeout = null;
    }
  };
  return debounced;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Accessibility/Announcer/index.js











var resetFocusPathTimer;
var prevFocusPath = [];
var currentlySpeaking;
var voiceOutDisabled = false;
var fiveMinutes = 300000;
function onFocusChangeCore() {
  var focusPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  if (!Announcer.enabled) {
    return;
  }
  var loaded = focusPath.every(function (elm) {
    return !elm.loading;
  });
  var focusDiff = focusPath.filter(function (elm) {
    return !prevFocusPath.includes(elm);
  });
  resetFocusPathTimer();
  if (!loaded) {
    Announcer.onFocusChange();
    return;
  }
  prevFocusPath = focusPath.slice(0);
  var toAnnounceText = [];
  var toAnnounce = focusDiff.reduce(function (acc, elm) {
    if (elm.announce) {
      acc.push([getElmName(elm), 'Announce', elm.announce]);
      toAnnounceText.push(elm.announce);
    } else if (elm.title) {
      acc.push([getElmName(elm), 'Title', elm.title]);
      toAnnounceText.push(elm.title);
    }
    return acc;
  }, []);
  focusDiff.reverse().reduce(function (acc, elm) {
    if (elm.announceContext) {
      acc.push([getElmName(elm), 'Context', elm.announceContext]);
      toAnnounceText.push(elm.announceContext);
    } else {
      acc.push([getElmName(elm), 'No Context', '']);
    }
    return acc;
  }, toAnnounce);
  if (Announcer.debug) {
    console.table(toAnnounce);
  }
  if (toAnnounceText.length) {
    return Announcer.speak(toAnnounceText.reduce(function (acc, val) {
      return acc.concat(val);
    }, []));
  }
}
function textToSpeech(toSpeak) {
  if (voiceOutDisabled) {
    return;
  }
  return currentlySpeaking = Speech(toSpeak);
}
var Announcer = {
  enabled: true,
  debug: false,
  cancel: function cancel() {
    currentlySpeaking && currentlySpeaking.cancel();
  },
  clearPrevFocus: function clearPrevFocus() {
    var depth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    prevFocusPath = prevFocusPath.slice(0, depth);
    resetFocusPathTimer();
  },
  speak: function speak(text) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$append = _ref.append,
      append = _ref$append === void 0 ? false : _ref$append,
      _ref$notification = _ref.notification,
      notification = _ref$notification === void 0 ? false : _ref$notification;
    if (Announcer.enabled) {
      Announcer.onFocusChange.flush();
      if (append && currentlySpeaking && currentlySpeaking.active) {
        currentlySpeaking.append(text);
      } else {
        Announcer.cancel();
        textToSpeech(text);
      }
      if (notification) {
        voiceOutDisabled = true;
        currentlySpeaking.series.finally(function () {
          voiceOutDisabled = false;
          Announcer.refresh();
        });
      }
    }
    return currentlySpeaking;
  },
  setupTimers: function setupTimers() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$focusDebounce = _ref2.focusDebounce,
      focusDebounce = _ref2$focusDebounce === void 0 ? 400 : _ref2$focusDebounce,
      _ref2$focusChangeTime = _ref2.focusChangeTimeout,
      focusChangeTimeout = _ref2$focusChangeTime === void 0 ? fiveMinutes : _ref2$focusChangeTime;
    Announcer.onFocusChange = debounce(onFocusChangeCore, focusDebounce);
    resetFocusPathTimer = debounce(function () {
      prevFocusPath = [];
    }, focusChangeTimeout);
  }
};
Announcer.setupTimers();
/* harmony default export */ const Accessibility_Announcer = (Announcer);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Accessibility/index.js

function Accessibility_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Accessibility_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Accessibility_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Accessibility_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



/* harmony default export */ const Accessibility = ({
  Announcer: Accessibility_Announcer,
  colorshift: function colorshift(component) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
      brightness: 50,
      contrast: 50,
      gamma: 50
    };
    config = Accessibility_objectSpread(Accessibility_objectSpread({}, {
      brightness: 50,
      contrast: 50,
      gamma: 50
    }), config);
    var shader = type && colorshiftShader(type);
    if (shader) {
      Log.info('Accessibility Colorshift', type, config);
      component.rtt = true;
      component.shader = Accessibility_objectSpread({
        type: shader
      }, config);
    } else {
      Log.info('Accessibility Colorshift', 'Disabled');
      component.rtt = false;
      component.shader = null;
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/@metrological+sdk@1.0.2/node_modules/@metrological/sdk/src/Metadata/index.js



var metadata = {};
var initMetadata = function initMetadata(metadataObj) {
  metadata = metadataObj;
};
/* harmony default export */ const src_Metadata = ({
  get: function get(key) {
    var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    return key in metadata ? metadata[key] : fallback;
  },
  appId: function appId() {
    return this.get('id');
  },
  safeAppId: function safeAppId() {
    return this.get('id').replace(/[^0-9a-zA-Z_$]/g, '_');
  },
  appName: function appName() {
    return this.get('name');
  },
  appVersion: function appVersion() {
    return (this.get('version') || '').split('-').shift();
  },
  appIcon: function appIcon() {
    return this.get('icon');
  },
  appFullVersion: function appFullVersion() {
    return this.get('version');
  }
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/@metrological+sdk@1.0.2/node_modules/@metrological/sdk/src/LightningSdkPlugins/index.js
var LightningSdkPlugins_Log;
var LightningSdkPlugins_Settings;
var ApplicationInstance;
var Ads;
var LightningSdkPlugins_Lightning;
var initLightningSdkPlugin = {
  set log(v) {
    LightningSdkPlugins_Log = v;
  },
  set settings(v) {
    LightningSdkPlugins_Settings = v;
  },
  set ads(v) {
    Ads = v;
  },
  set lightning(v) {
    LightningSdkPlugins_Lightning = v;
  },
  set appInstance(v) {
    ApplicationInstance = v;
  }
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@metrological+sdk@1.0.2/node_modules/@metrological/sdk/src/Metrics/index.js



function Metrics_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Metrics_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Metrics_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Metrics_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var initMetrics = function initMetrics(config) {
  sendMetric = config.sendMetric;
};
var sendMetric = function sendMetric(type, event, params) {
  LightningSdkPlugins_Log.info('Sending metric', type, event, params);
};
var metrics = {
  app: ['launch', 'loaded', 'ready', 'close'],
  page: ['view', 'leave'],
  user: ['click', 'input'],
  media: ['abort', 'canplay', 'ended', 'pause', 'play', 'volumechange', 'waiting', 'seeking', 'seeked']
};
var errorMetric = function errorMetric(type, message, code, visible) {
  var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  params = Metrics_objectSpread({
    params: params
  }, {
    message: message,
    code: code,
    visible: visible
  });
  sendMetric(type, 'error', params);
};
var Metric = function Metric(type, events) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return events.reduce(function (obj, event) {
    obj[event] = function (name) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      params = Metrics_objectSpread(Metrics_objectSpread(Metrics_objectSpread({}, options), name ? {
        name: name
      } : {}), params);
      sendMetric(type, event, params);
    };
    return obj;
  }, {
    error: function error(message, code, params) {
      errorMetric(type, message, code, params);
    },
    event: function event(name, params) {
      sendMetric(type, name, params);
    }
  });
};
var Metrics = function Metrics(types) {
  return Object.keys(types).reduce(function (obj, type) {
    type === 'media' ? obj[type] = function (url) {
      return Metric(type, types[type], {
        url: url
      });
    } : obj[type] = Metric(type, types[type]);
    return obj;
  }, {
    error: errorMetric,
    event: sendMetric
  });
};
/* harmony default export */ const src_Metrics = (Metrics(metrics));
;// CONCATENATED MODULE: ./node_modules/.pnpm/@metrological+sdk@1.0.2/node_modules/@metrological/sdk/src/Profile/helpers.js





var formatLocale = function formatLocale(locale) {
  if (locale && locale.length === 2) {
    return "".concat(locale.toLowerCase(), "-").concat(locale.toUpperCase());
  } else {
    return locale;
  }
};
var getLocale = function getLocale(defaultValue) {
  if ('language' in navigator) {
    var locale = formatLocale(navigator.language);
    return Promise.resolve(locale);
  } else {
    return Promise.resolve(defaultValue);
  }
};
var getLanguage = function getLanguage(defaultValue) {
  if ('language' in navigator) {
    var language = formatLocale(navigator.language).slice(0, 2);
    return Promise.resolve(language);
  } else {
    return Promise.resolve(defaultValue);
  }
};
var getCountryCode = function getCountryCode(defaultValue) {
  if ('language' in navigator) {
    var countryCode = formatLocale(navigator.language).slice(3, 5);
    return Promise.resolve(countryCode);
  } else {
    return Promise.resolve(defaultValue);
  }
};
var hasOrAskForGeoLocationPermission = function hasOrAskForGeoLocationPermission() {
  return new Promise(function (resolve) {
    if (LightningSdkPlugins_Settings.get('platform', 'forceBrowserGeolocation') === true) resolve(true);
    if ('permissions' in navigator && typeof navigator.permissions.query === 'function') {
      navigator.permissions.query({
        name: 'geolocation'
      }).then(function (status) {
        resolve(status.state === 'granted' || status.status === 'granted');
      });
    } else {
      resolve(false);
    }
  });
};
var getLatLon = function getLatLon(defaultValue) {
  return new Promise(function (resolve) {
    hasOrAskForGeoLocationPermission().then(function (granted) {
      if (granted === true) {
        if ('geolocation' in navigator) {
          navigator.geolocation.getCurrentPosition(function (result) {
            return result && result.coords && resolve([result.coords.latitude, result.coords.longitude]);
          }, function () {
            return resolve(defaultValue);
          }, {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
          });
        } else {
          return queryForLatLon().then(function (result) {
            return resolve(result || defaultValue);
          });
        }
      } else {
        return queryForLatLon().then(function (result) {
          return resolve(result || defaultValue);
        });
      }
    });
  });
};
var queryForLatLon = function queryForLatLon() {
  return new Promise(function (resolve) {
    fetch('https://geolocation-db.com/json/').then(function (response) {
      return response.json();
    }).then(function (_ref) {
      var latitude = _ref.latitude,
        longitude = _ref.longitude;
      return latitude && longitude ? resolve([latitude, longitude]) : resolve(false);
    }).catch(function () {
      return resolve(false);
    });
  });
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@metrological+sdk@1.0.2/node_modules/@metrological/sdk/src/Profile/defaults.js

var defaultProfile = {
  ageRating: 'adult',
  city: 'New York',
  zipCode: '27505',
  countryCode: function countryCode() {
    return getCountryCode('US');
  },
  ip: '127.0.0.1',
  household: 'b2244e9d4c04826ccd5a7b2c2a50e7d4',
  language: function language() {
    return getLanguage('en');
  },
  latlon: function latlon() {
    return getLatLon([40.7128, 74.006]);
  },
  locale: function locale() {
    return getLocale('en-US');
  },
  mac: '00:00:00:00:00:00',
  operator: 'metrological',
  platform: 'metrological',
  packages: [],
  uid: 'ee6723b8-7ab3-462c-8d93-dbf61227998e',
  stbType: 'metrological'
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@metrological+sdk@1.0.2/node_modules/@metrological/sdk/src/Profile/index.js



function Profile_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Profile_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Profile_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Profile_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


var getInfo = function getInfo(key) {
  var profile = Profile_objectSpread(Profile_objectSpread({}, defaultProfile), LightningSdkPlugins_Settings.get('platform', 'profile'));
  return Promise.resolve(typeof profile[key] === 'function' ? profile[key]() : profile[key]);
};
var setInfo = function setInfo(key, params) {
  if (key in defaultProfile) return defaultProfile[key] = params;
};
var initProfile = function initProfile(config) {
  getInfo = config.getInfo ? config.getInfo : getInfo;
  setInfo = config.setInfo ? config.setInfo : setInfo;
};
var getOrSet = function getOrSet(key, params) {
  return params ? setInfo(key, params) : getInfo(key);
};
/* harmony default export */ const src_Profile = ({
  ageRating: function ageRating(params) {
    return getOrSet('ageRating', params);
  },
  city: function city(params) {
    return getOrSet('city', params);
  },
  zipCode: function zipCode(params) {
    return getOrSet('zipCode', params);
  },
  countryCode: function countryCode(params) {
    return getOrSet('countryCode', params);
  },
  ip: function ip(params) {
    return getOrSet('ip', params);
  },
  household: function household(params) {
    return getOrSet('household', params);
  },
  language: function language(params) {
    return getOrSet('language', params);
  },
  latlon: function latlon(params) {
    return getOrSet('latlon', params);
  },
  locale: function locale(params) {
    return getOrSet('locale', params);
  },
  mac: function mac(params) {
    return getOrSet('mac', params);
  },
  operator: function operator(params) {
    return getOrSet('operator', params);
  },
  platform: function platform(params) {
    return getOrSet('platform', params);
  },
  packages: function packages(params) {
    return getOrSet('packages', params);
  },
  uid: function uid(params) {
    return getOrSet('uid', params);
  },
  stbType: function stbType(params) {
    return getOrSet('stbType', params);
  }
});
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.string.search.js
var es_string_search = __webpack_require__(6938);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@metrological+sdk@1.0.2/node_modules/@metrological/sdk/src/helpers/sequence.js



/* harmony default export */ const sequence = (function (steps) {
  return steps.reduce(function (promise, method) {
    return promise.then(function () {
      return method.apply(void 0, arguments);
    }).catch(function (e) {
      return Promise.reject(e);
    });
  }, Promise.resolve(null));
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/@metrological+sdk@1.0.2/node_modules/@metrological/sdk/src/Purchase/index.js















function Purchase_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Purchase_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Purchase_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Purchase_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



var cspUrl = 'http://payment-csp-example.metrological.com:8080/';
var billingUrl = 'https://payment-sdk.metrological.com/';
var cspEndpoints = {
  assets: {
    uri: '/assets',
    method: 'GET'
  },
  asset: {
    uri: '/assets/:id',
    method: 'GET'
  },
  signature: {
    uri: '/assets/:id/signature',
    method: 'POST'
  },
  subscribe: {
    uri: '/assets/:id/subscribe',
    method: 'POST'
  },
  unsubscribe: {
    uri: '/assets/:id/unsubscribe',
    method: 'POST'
  }
};
var initPurchase = function initPurchase(config) {
  if (config.billingUrl) billingUrl = config.billingUrl;
};
var createUrl = function createUrl(uri, baseUrl) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return new URL(Object.keys(params).reduce(function (res, key) {
    return res.replace(new RegExp(':' + key, 'g'), params[key]);
  }, uri).replace(/^\//, ''), /\/$/.test(baseUrl) ? baseUrl : baseUrl.replace(/$/, '/'));
};
var request = function request(url) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
  var data = arguments.length > 2 ? arguments[2] : undefined;
  var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  if (method === 'GET' && data) {
    url.search = new URLSearchParams(data);
  }
  return new Promise(function (resolve, reject) {
    fetch(url, {
      headers: Purchase_objectSpread(Purchase_objectSpread({}, {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }), headers),
      method: method,
      body: method !== 'GET' && data ? JSON.stringify(data) : null
    }).then(function (response) {
      return response.ok ? resolve(response.json()) : reject(response.statusText);
    }).catch(reject);
  });
};
var cspRequest = function cspRequest(type) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return new Promise(function (resolve, reject) {
    var endpoint = cspEndpoints[type];
    if (!endpoint) {
      reject('No endpoint found for "' + type + '" call');
    } else {
      if (endpoint.callback && typeof endpoint.callback === 'function') {
        endpoint.callback(data, params).then(resolve).catch(reject);
      } else {
        request(createUrl(endpoint.uri, cspUrl, params), endpoint.method, Purchase_objectSpread(Purchase_objectSpread({}, endpoint.data || {}), data), endpoint.headers || {}).then(resolve).catch(reject);
      }
    }
  });
};
var billingRequest = function billingRequest(uri, data) {
  var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'POST';
  return new Promise(function (resolve, reject) {
    request(createUrl(uri, billingUrl), method, data).then(resolve).catch(reject);
  });
};
/* harmony default export */ const src_Purchase = ({
  setup: function setup(config) {
    if (config.cspUrl) cspUrl = config.cspUrl;
    if (config.endpoints) cspEndpoints = Purchase_objectSpread({
      cspEndpoints: cspEndpoints
    }, config.endpoints);
  },
  assets: function assets() {
    return new Promise(function (resolve, reject) {
      src_Profile.household().then(function (household) {
        cspRequest('assets', {
          household: household
        }).then(resolve).catch(reject);
      });
    });
  },
  asset: function asset(id) {
    return new Promise(function (resolve, reject) {
      src_Profile.household().then(function (household) {
        cspRequest('asset', {
          household: household
        }, {
          id: id
        }).then(resolve).catch(reject);
      });
    });
  },
  signature: function signature(id) {
    return new Promise(function (resolve, reject) {
      Promise.all([src_Profile.household()]).then(function (_ref) {
        var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 1),
          household = _ref2[0];
        cspRequest('signature', {
          household: household
        }, {
          id: id
        }).then(resolve).catch(reject);
      });
    });
  },
  subscribe: function subscribe(id, transaction) {
    return new Promise(function (resolve, reject) {
      cspRequest('subscribe', Purchase_objectSpread({}, transaction), {
        id: id
      }).then(resolve).catch(reject);
    });
  },
  unsubscribe: function unsubscribe(id) {
    return new Promise(function (resolve, reject) {
      src_Profile.household().then(function (household) {
        cspRequest('unsubscribe', {
          household: household
        }, {
          id: id
        }).then(resolve).catch(reject);
      });
    });
  },
  payment: function payment() {
    var signature = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'in-app';
    return new Promise(function (resolve, reject) {
      Promise.all([src_Profile.household(), src_Profile.countryCode(), src_Profile.operator(), src_Profile.mac(), src_Profile.uid()]).then(function (_ref3) {
        var _ref4 = (0,slicedToArray/* default */.Z)(_ref3, 5),
          household = _ref4[0],
          country = _ref4[1],
          operator = _ref4[2],
          mac = _ref4[3],
          uid = _ref4[4];
        billingRequest('/', {
          purchase: signature,
          identifier: LightningSdkPlugins_Settings.get('app', 'id'),
          name: LightningSdkPlugins_Settings.get('app', 'id'),
          household: household,
          country: country,
          operator: operator,
          mac: mac,
          uid: uid,
          type: type
        }).then(resolve).catch(reject);
      }).catch(reject);
    });
  },
  confirm: function confirm(transactionId) {
    return new Promise(function (resolve, reject) {
      billingRequest('/confirm', {
        transactionId: transactionId
      }).then(resolve).catch(reject);
    });
  },
  buy: function buy(assetId, type) {
    var _this = this;
    return new Promise(function (resolve, reject) {
      var transactionId;
      sequence([function () {
        return _this.signature(assetId);
      }, function (signature) {
        return _this.payment(signature, type);
      }, function (transaction) {
        transactionId = transaction.transactionId;
        return _this.subscribe(assetId, transaction);
      }, function () {
        return _this.confirm(transactionId);
      }]).then(resolve).catch(reject);
    });
  }
});
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__(10115);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@metrological+sdk@1.0.2/node_modules/@metrological/sdk/src/TV/defaults.js

var defaultChannels = [{
  number: 1,
  name: 'Metro News 1',
  description: 'New York Cable News Channel',
  entitled: true,
  program: {
    title: 'The Morning Show',
    description: "New York's best morning show",
    startTime: new Date(new Date() - 60 * 5 * 1000).toUTCString(),
    duration: 60 * 30,
    ageRating: 0
  }
}, {
  number: 2,
  name: 'MTV',
  description: 'Music Television',
  entitled: true,
  program: {
    title: 'Beavis and Butthead',
    description: 'American adult animated sitcom created by Mike Judge',
    startTime: new Date(new Date() - 60 * 20 * 1000).toUTCString(),
    duration: 60 * 45,
    ageRating: 18
  }
}, {
  number: 3,
  name: 'NBC',
  description: 'NBC TV Network',
  entitled: false,
  program: {
    title: 'The Tonight Show Starring Jimmy Fallon',
    description: 'Late-night talk show hosted by Jimmy Fallon on NBC',
    startTime: new Date(new Date() - 60 * 10 * 1000).toUTCString(),
    duration: 60 * 60,
    ageRating: 10
  }
}];
var channels = function channels() {
  return LightningSdkPlugins_Settings.get('platform', 'tv', defaultChannels);
};
var randomChannel = function randomChannel() {
  return channels()[~~(channels.length * Math.random())];
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@metrological+sdk@1.0.2/node_modules/@metrological/sdk/src/TV/index.js






function TV_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function TV_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? TV_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TV_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


var currentChannel;
var callbacks = {};
var emit = function emit(event) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  callbacks[event] && callbacks[event].forEach(function (cb) {
    cb.apply(null, args);
  });
};
var methods = {
  getChannel: function getChannel() {
    if (!currentChannel) currentChannel = randomChannel();
    return new Promise(function (resolve, reject) {
      if (currentChannel) {
        var channel = TV_objectSpread({}, currentChannel);
        delete channel.program;
        resolve(channel);
      } else {
        reject('No channel found');
      }
    });
  },
  getProgram: function getProgram() {
    if (!currentChannel) currentChannel = randomChannel();
    return new Promise(function (resolve, reject) {
      currentChannel.program ? resolve(currentChannel.program) : reject('No program found');
    });
  },
  setChannel: function setChannel(number) {
    return new Promise(function (resolve, reject) {
      if (number) {
        var newChannel = channels().find(function (c) {
          return c.number === number;
        });
        if (newChannel) {
          currentChannel = newChannel;
          var channel = TV_objectSpread({}, currentChannel);
          delete channel.program;
          emit('channelChange', channel);
          resolve(channel);
        } else {
          reject('Channel not found');
        }
      } else {
        reject('No channel number supplied');
      }
    });
  }
};
var initTV = function initTV(config) {
  methods = {};
  if (config.getChannel && typeof config.getChannel === 'function') {
    methods.getChannel = config.getChannel;
  }
  if (config.getProgram && typeof config.getProgram === 'function') {
    methods.getProgram = config.getProgram;
  }
  if (config.setChannel && typeof config.setChannel === 'function') {
    methods.setChannel = config.setChannel;
  }
  if (config.emit && typeof config.emit === 'function') {
    config.emit(emit);
  }
};
/* harmony default export */ const src_TV = ({
  channel: function channel() {
    var number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return new Promise(function (resolve, reject) {
      try {
        methods[number ? 'setChannel' : 'getChannel'](number).then(function (channel) {
          resolve(channel);
        }).catch(reject);
      } catch (e) {
        reject(e);
      }
    });
  },
  program: function program() {
    return new Promise(function (resolve, reject) {
      try {
        methods.getProgram().then(function (program) {
          resolve(program);
        }).catch(reject);
      } catch (e) {
        reject(e);
      }
    });
  },
  entitled: function entitled() {
    return new Promise(function (resolve, reject) {
      try {
        methods.getChannel().then(function (channel) {
          'entitled' in channel ? resolve(!!channel.entitled) : reject();
        }).catch(reject);
      } catch (e) {
        reject(e);
      }
    });
  },
  addEventListener: function addEventListener(event, cb) {
    if (typeof cb === 'function') {
      callbacks[event] = callbacks[event] || [];
      callbacks[event].push(cb);
    } else {
      LightningSdkPlugins_Log.error('Please provide a function as a callback');
    }
  },
  removeEventListener: function removeEventListener(event) {
    var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (callbacks[event] && callbacks[event].length) {
      callbacks[event] = cb ? callbacks[event].filter(function (_cb) {
        return _cb === cb;
      }) : [];
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/@metrological+sdk@1.0.2/node_modules/@metrological/sdk/src/Pin/dialog.js









function dialog_createSuper(t) { var r = dialog_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function dialog_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (dialog_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }


var PinInput = function PinInput() {
  return function (_Lightning$Component) {
    (0,inherits/* default */.Z)(PinInput, _Lightning$Component);
    var _super = dialog_createSuper(PinInput);
    function PinInput() {
      (0,classCallCheck/* default */.Z)(this, PinInput);
      return _super.apply(this, arguments);
    }
    (0,createClass/* default */.Z)(PinInput, [{
      key: "index",
      set: function set(v) {
        this.x = v * (120 + 24);
      }
    }, {
      key: "nr",
      set: function set(v) {
        var _this = this;
        this._timeout && clearTimeout(this._timeout);
        if (v) {
          this.setSmooth('alpha', 1);
        } else {
          this.setSmooth('alpha', 0.5);
        }
        this.tag('Nr').patch({
          text: {
            text: v && v.toString() || '',
            fontSize: v === '*' ? 120 : 80
          }
        });
        if (v && v !== '*') {
          this._timeout = setTimeout(function () {
            _this._timeout = null;
            _this.nr = '*';
          }, 750);
        }
      }
    }], [{
      key: "_template",
      value: function _template() {
        return {
          w: 120,
          h: 150,
          rect: true,
          color: 0xff949393,
          alpha: 0.5,
          shader: {
            type: LightningSdkPlugins_Lightning.shaders.RoundedRectangle,
            radius: 10
          },
          Nr: {
            w: function w(_w) {
              return _w;
            },
            y: 24,
            text: {
              text: '',
              textColor: 0xff333333,
              fontSize: 80,
              textAlign: 'center',
              verticalAlign: 'middle'
            }
          }
        };
      }
    }]);
    return PinInput;
  }(LightningSdkPlugins_Lightning.Component);
};
/* harmony default export */ const dialog = (function () {
  return function (_Lightning$Component2) {
    (0,inherits/* default */.Z)(PinDialog, _Lightning$Component2);
    var _super2 = dialog_createSuper(PinDialog);
    function PinDialog() {
      (0,classCallCheck/* default */.Z)(this, PinDialog);
      return _super2.apply(this, arguments);
    }
    (0,createClass/* default */.Z)(PinDialog, [{
      key: "_init",
      value: function _init() {
        var children = [];
        for (var i = 0; i < 4; i++) {
          children.push({
            type: PinInput(),
            index: i
          });
        }
        this.tag('Code').children = children;
      }
    }, {
      key: "pin",
      get: function get() {
        if (!this._pin) this._pin = '';
        return this._pin;
      },
      set: function set(v) {
        if (v.length <= 4) {
          var maskedPin = new Array(Math.max(v.length - 1, 0)).fill('*', 0, v.length - 1);
          v.length && maskedPin.push(v.length > this._pin.length ? v.slice(-1) : '*');
          for (var i = 0; i < 4; i++) {
            this.tag('Code').children[i].nr = maskedPin[i] || '';
          }
          this._pin = v;
        }
      }
    }, {
      key: "msg",
      get: function get() {
        if (!this._msg) this._msg = '';
        return this._msg;
      },
      set: function set(v) {
        var _this2 = this;
        this._timeout && clearTimeout(this._timeout);
        this._msg = v;
        if (this._msg) {
          this.tag('Msg').text = this._msg;
          this.tag('Info').setSmooth('alpha', 0.5);
          this.tag('Code').setSmooth('alpha', 0.5);
        } else {
          this.tag('Msg').text = '';
          this.tag('Info').setSmooth('alpha', 1);
          this.tag('Code').setSmooth('alpha', 1);
        }
        this._timeout = setTimeout(function () {
          _this2.msg = '';
        }, 2000);
      }
    }, {
      key: "_firstActive",
      value: function _firstActive() {
        this.setSmooth('alpha', 1);
      }
    }, {
      key: "_handleKey",
      value: function _handleKey(event) {
        if (this.msg) {
          this.msg = false;
        } else {
          var val = parseInt(event.key);
          if (val > -1) {
            this.pin += val;
          }
        }
      }
    }, {
      key: "_handleBack",
      value: function _handleBack() {
        if (this.msg) {
          this.msg = false;
        } else {
          if (this.pin.length) {
            this.pin = this.pin.slice(0, this.pin.length - 1);
          } else {
            src_Pin.hide();
            this.resolve(false);
          }
        }
      }
    }, {
      key: "_handleEnter",
      value: function _handleEnter() {
        var _this3 = this;
        if (this.msg) {
          this.msg = false;
        } else {
          src_Pin.submit(this.pin).then(function (val) {
            _this3.msg = 'Unlocking ...';
            setTimeout(function () {
              src_Pin.hide();
            }, 1000);
            _this3.resolve(val);
          }).catch(function (e) {
            _this3.msg = e;
            _this3.reject(e);
          });
        }
      }
    }], [{
      key: "_template",
      value: function _template() {
        return {
          zIndex: 1,
          w: function w(_w2) {
            return _w2;
          },
          h: function h(_h) {
            return _h;
          },
          rect: true,
          color: 0xdd000000,
          alpha: 0.000001,
          Dialog: {
            w: 648,
            h: 320,
            y: function y(h) {
              return (h - 320) / 2;
            },
            x: function x(w) {
              return (w - 648) / 2;
            },
            rect: true,
            color: 0xdd333333,
            shader: {
              type: LightningSdkPlugins_Lightning.shaders.RoundedRectangle,
              radius: 10
            },
            Info: {
              y: 24,
              x: 48,
              text: {
                text: 'Please enter your PIN',
                fontSize: 32
              }
            },
            Msg: {
              y: 260,
              x: 48,
              text: {
                text: '',
                fontSize: 28,
                textColor: 0xffffffff
              }
            },
            Code: {
              x: 48,
              y: 96
            }
          }
        };
      }
    }]);
    return PinDialog;
  }(LightningSdkPlugins_Lightning.Component);
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/@metrological+sdk@1.0.2/node_modules/@metrological/sdk/src/Pin/index.js








var unlocked = false;
var contextItems = ['purchase', 'parental'];
var _submit = function submit(pin, context) {
  return new Promise(function (resolve, reject) {
    if (pin.toString() === LightningSdkPlugins_Settings.get('platform', 'pin', '0000').toString()) {
      unlocked = true;
      resolve(unlocked);
    } else {
      reject('Incorrect pin');
    }
  });
};
var check = function check(context) {
  return new Promise(function (resolve) {
    resolve(unlocked);
  });
};
var initPin = function initPin(config) {
  if (config.submit && typeof config.submit === 'function') {
    _submit = config.submit;
  }
  if (config.check && typeof config.check === 'function') {
    check = config.check;
  }
};
var pinDialog = null;
var contextCheck = function contextCheck(context) {
  if (context === undefined) {
    LightningSdkPlugins_Log.info('Please provide context explicitly');
    return contextItems[0];
  } else if (!contextItems.includes(context)) {
    LightningSdkPlugins_Log.warn('Incorrect context provided');
    return false;
  }
  return context;
};
/* harmony default export */ const src_Pin = ({
  show: function show() {
    return new Promise(function (resolve, reject) {
      pinDialog = ApplicationInstance.stage.c({
        ref: 'PinDialog',
        type: dialog(),
        resolve: resolve,
        reject: reject
      });
      ApplicationInstance.childList.a(pinDialog);
      ApplicationInstance.focus = pinDialog;
    });
  },
  hide: function hide() {
    ApplicationInstance.focus = null;
    ApplicationInstance.children = ApplicationInstance.children.map(function (child) {
      return child !== pinDialog && child;
    });
    pinDialog = null;
  },
  submit: function submit(pin, context) {
    return new Promise(function (resolve, reject) {
      try {
        context = contextCheck(context);
        if (context) {
          _submit(pin, context).then(resolve).catch(reject);
        } else {
          reject('Incorrect Context provided');
        }
      } catch (e) {
        reject(e);
      }
    });
  },
  unlocked: function unlocked(context) {
    return new Promise(function (resolve, reject) {
      try {
        context = contextCheck(context);
        if (context) {
          check(context).then(resolve).catch(reject);
        } else {
          reject('Incorrect Context provided');
        }
      } catch (e) {
        reject(e);
      }
    });
  },
  locked: function locked(context) {
    return new Promise(function (resolve, reject) {
      try {
        context = contextCheck(context);
        if (context) {
          check(context).then(function (unlocked) {
            return resolve(!!!unlocked);
          }).catch(reject);
        } else {
          reject('Incorrect Context provided');
        }
      } catch (e) {
        reject(e);
      }
    });
  }
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/@michieljs+execute-as-promise@1.0.0/node_modules/@michieljs/execute-as-promise/src/execute-as-promise.js



/* harmony default export */ const execute_as_promise = (function (method) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var result;
  if (method && typeof method === 'function') {
    try {
      result = method.apply(context, args);
    } catch (e) {
      result = e;
    }
  } else {
    result = method;
  }
  if (result !== null && (0,esm_typeof/* default */.Z)(result) === 'object' && result.then && typeof result.then === 'function') {
    return result;
  } else {
    return new Promise(function (resolve, reject) {
      if (result instanceof Error) {
        reject(result);
      } else {
        resolve(result);
      }
    });
  }
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/@metrological+sdk@1.0.2/node_modules/@metrological/sdk/src/VideoPlayer/events.js
/* harmony default export */ const events = ({
  abort: 'Abort',
  canplay: 'CanPlay',
  canplaythrough: 'CanPlayThrough',
  durationchange: 'DurationChange',
  emptied: 'Emptied',
  encrypted: 'Encrypted',
  ended: 'Ended',
  error: 'Error',
  interruptbegin: 'InterruptBegin',
  interruptend: 'InterruptEnd',
  loadeddata: 'LoadedData',
  loadedmetadata: 'LoadedMetadata',
  loadstart: 'LoadStart',
  pause: 'Pause',
  play: 'Play',
  playing: 'Playing',
  progress: 'Progress',
  ratechange: 'Ratechange',
  seeked: 'Seeked',
  seeking: 'Seeking',
  stalled: 'Stalled',
  timeupdate: 'TimeUpdate',
  volumechange: 'VolumeChange',
  waiting: 'Waiting'
});
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.object.define-getter.js
var es_object_define_getter = __webpack_require__(59232);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.object.define-setter.js
var es_object_define_setter = __webpack_require__(72338);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@metrological+sdk@1.0.2/node_modules/@metrological/sdk/src/helpers/autoSetupMixin.js





/* harmony default export */ const autoSetupMixin = (function (sourceObject) {
  var setup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  var ready = false;
  var doSetup = function doSetup() {
    if (ready === false) {
      setup();
      ready = true;
    }
  };
  return Object.keys(sourceObject).reduce(function (obj, key) {
    if (typeof sourceObject[key] === 'function') {
      obj[key] = function () {
        doSetup();
        return sourceObject[key].apply(sourceObject, arguments);
      };
    } else if (typeof Object.getOwnPropertyDescriptor(sourceObject, key).get === 'function') {
      obj.__defineGetter__(key, function () {
        doSetup();
        return Object.getOwnPropertyDescriptor(sourceObject, key).get.apply(sourceObject);
      });
    } else if (typeof Object.getOwnPropertyDescriptor(sourceObject, key).set === 'function') {
      obj.__defineSetter__(key, function () {
        doSetup();
        return Object.getOwnPropertyDescriptor(sourceObject, key).set.sourceObject[key].apply(sourceObject, arguments);
      });
    } else {
      obj[key] = sourceObject[key];
    }
    return obj;
  }, {});
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/@metrological+sdk@1.0.2/node_modules/@metrological/sdk/src/helpers/easeExecution.js
var timeout = null;
/* harmony default export */ const easeExecution = (function (cb, delay) {
  clearTimeout(timeout);
  timeout = setTimeout(function () {
    cb();
  }, delay);
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/@metrological+sdk@1.0.2/node_modules/@metrological/sdk/src/VideoPlayer/VideoTexture.js





function VideoTexture_createSuper(t) { var r = VideoTexture_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function VideoTexture_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (VideoTexture_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

/* harmony default export */ const VideoTexture = (function () {
  return function (_Lightning$Component) {
    (0,inherits/* default */.Z)(VideoTexture, _Lightning$Component);
    var _super = VideoTexture_createSuper(VideoTexture);
    function VideoTexture() {
      (0,classCallCheck/* default */.Z)(this, VideoTexture);
      return _super.apply(this, arguments);
    }
    (0,createClass/* default */.Z)(VideoTexture, [{
      key: "videoEl",
      get: function get() {
        return this._videoEl;
      },
      set: function set(v) {
        this._videoEl = v;
      }
    }, {
      key: "videoView",
      get: function get() {
        return this.tag('Video');
      }
    }, {
      key: "videoTexture",
      get: function get() {
        return this.videoView.texture;
      }
    }, {
      key: "isVisible",
      get: function get() {
        return this.videoView.alpha === 1 && this.videoView.visible === true;
      }
    }, {
      key: "_init",
      value: function _init() {
        this._createVideoTexture();
      }
    }, {
      key: "_createVideoTexture",
      value: function _createVideoTexture() {
        var stage = this.stage;
        var gl = stage.gl;
        var glTexture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, glTexture);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        this.videoTexture.options = {
          source: glTexture,
          w: this.videoEl.width,
          h: this.videoEl.height
        };
        this.videoView.w = this.videoEl.width / this.stage.getRenderPrecision();
        this.videoView.h = this.videoEl.height / this.stage.getRenderPrecision();
      }
    }, {
      key: "start",
      value: function start() {
        var _this = this;
        var stage = this.stage;
        this._lastTime = 0;
        if (!this._updateVideoTexture) {
          this._updateVideoTexture = function () {
            if (_this.videoTexture.options.source && _this.videoEl.videoWidth && _this.active) {
              var gl = stage.gl;
              var currentTime = new Date().getTime();
              var getVideoPlaybackQuality = _this.videoEl.getVideoPlaybackQuality();
              var frameCount = getVideoPlaybackQuality ? getVideoPlaybackQuality.totalVideoFrames : _this.videoEl.webkitDecodedFrameCount;
              var mustUpdate = frameCount ? _this._lastFrame !== frameCount : _this._lastTime < currentTime - 30;
              if (mustUpdate) {
                _this._lastTime = currentTime;
                _this._lastFrame = frameCount;
                try {
                  gl.bindTexture(gl.TEXTURE_2D, _this.videoTexture.options.source);
                  gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
                  gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, _this.videoEl);
                  _this._lastFrame = _this.videoEl.webkitDecodedFrameCount;
                  _this.videoView.visible = true;
                  _this.videoTexture.options.w = _this.videoEl.width;
                  _this.videoTexture.options.h = _this.videoEl.height;
                  var expectedAspectRatio = _this.videoView.w / _this.videoView.h;
                  var realAspectRatio = _this.videoEl.width / _this.videoEl.height;
                  if (expectedAspectRatio > realAspectRatio) {
                    _this.videoView.scaleX = realAspectRatio / expectedAspectRatio;
                    _this.videoView.scaleY = 1;
                  } else {
                    _this.videoView.scaleY = expectedAspectRatio / realAspectRatio;
                    _this.videoView.scaleX = 1;
                  }
                } catch (e) {
                  LightningSdkPlugins_Log.error('texImage2d video', e);
                  _this.stop();
                }
                _this.videoTexture.source.forceRenderUpdate();
              }
            }
          };
        }
        if (!this._updatingVideoTexture) {
          stage.on('frameStart', this._updateVideoTexture);
          this._updatingVideoTexture = true;
        }
      }
    }, {
      key: "stop",
      value: function stop() {
        var stage = this.stage;
        stage.removeListener('frameStart', this._updateVideoTexture);
        this._updatingVideoTexture = false;
        this.videoView.visible = false;
        if (this.videoTexture.options.source) {
          var gl = stage.gl;
          gl.bindTexture(gl.TEXTURE_2D, this.videoTexture.options.source);
          gl.clearColor(0, 0, 0, 1);
          gl.clear(gl.COLOR_BUFFER_BIT);
        }
      }
    }, {
      key: "position",
      value: function position(top, left) {
        this.videoView.patch({
          x: left,
          y: top
        });
      }
    }, {
      key: "size",
      value: function size(width, height) {
        this.videoView.patch({
          w: width,
          h: height
        });
      }
    }, {
      key: "show",
      value: function show() {
        this.videoView.alpha = 1;
      }
    }, {
      key: "hide",
      value: function hide() {
        this.videoView.alpha = 0;
      }
    }], [{
      key: "_template",
      value: function _template() {
        return {
          Video: {
            alpha: 1,
            visible: false,
            pivot: 0.5,
            texture: {
              type: LightningSdkPlugins_Lightning.textures.StaticTexture,
              options: {}
            }
          }
        };
      }
    }]);
    return VideoTexture;
  }(LightningSdkPlugins_Lightning.Component);
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/@metrological+sdk@1.0.2/node_modules/@metrological/sdk/src/VideoPlayer/index.js











var mediaUrl = function mediaUrl(url) {
  return url;
};
var videoEl;
var videoTexture;
var VideoPlayer_metrics;
var _consumer;
var precision = 1;
var textureMode = false;
var initVideoPlayer = function initVideoPlayer(config) {
  if (config.mediaUrl) {
    mediaUrl = config.mediaUrl;
  }
};
var eventHandlers = {};
var state = {
  adsEnabled: false,
  playing: false,
  _playingAds: false,
  get playingAds() {
    return this._playingAds;
  },
  set playingAds(val) {
    if (this._playingAds !== val) {
      this._playingAds = val;
      fireOnConsumer(val === true ? 'AdStart' : 'AdEnd');
    }
  },
  skipTime: false,
  playAfterSeek: null
};
var hooks = {
  play: function play() {
    state.playing = true;
  },
  pause: function pause() {
    state.playing = false;
  },
  seeked: function seeked() {
    state.playAfterSeek === true && videoPlayerPlugin.play();
    state.playAfterSeek = null;
  },
  abort: function abort() {
    deregisterEventListeners();
  }
};
var withPrecision = function withPrecision(val) {
  return Math.round(precision * val) + 'px';
};
var fireOnConsumer = function fireOnConsumer(event, args) {
  if (_consumer) {
    _consumer.fire('$videoPlayer' + event, args, videoEl.currentTime);
    _consumer.fire('$videoPlayerEvent', event, args, videoEl.currentTime);
  }
};
var fireHook = function fireHook(event, args) {
  hooks[event] && typeof hooks[event] === 'function' && hooks[event].call(null, event, args);
};
var customLoader = null;
var customUnloader = null;
var loader = function loader(url, videoEl, config) {
  return customLoader && typeof customLoader === 'function' ? customLoader(url, videoEl, config) : new Promise(function (resolve) {
    url = mediaUrl(url);
    videoEl.setAttribute('src', url);
    videoEl.load();
    resolve();
  });
};
var unloader = function unloader(videoEl) {
  return customUnloader && typeof customUnloader === 'function' ? customUnloader(videoEl) : new Promise(function (resolve) {
    videoEl.removeAttribute('src');
    videoEl.load();
    resolve();
  });
};
var setupVideoTag = function setupVideoTag() {
  var videoEls = document.getElementsByTagName('video');
  if (videoEls && videoEls.length) {
    return videoEls[0];
  } else {
    var _videoEl = document.createElement('video');
    var platformSettingsWidth = LightningSdkPlugins_Settings.get('platform', 'width') ? LightningSdkPlugins_Settings.get('platform', 'width') : 1920;
    var platformSettingsHeight = LightningSdkPlugins_Settings.get('platform', 'height') ? LightningSdkPlugins_Settings.get('platform', 'height') : 1080;
    _videoEl.setAttribute('id', 'video-player');
    _videoEl.setAttribute('width', withPrecision(platformSettingsWidth));
    _videoEl.setAttribute('height', withPrecision(platformSettingsHeight));
    _videoEl.style.position = 'absolute';
    _videoEl.style.zIndex = '1';
    _videoEl.style.display = 'none';
    _videoEl.style.visibility = 'hidden';
    _videoEl.style.top = withPrecision(0);
    _videoEl.style.left = withPrecision(0);
    _videoEl.style.width = withPrecision(platformSettingsWidth);
    _videoEl.style.height = withPrecision(platformSettingsHeight);
    document.body.appendChild(_videoEl);
    return _videoEl;
  }
};
var setUpVideoTexture = function setUpVideoTexture() {
  if (!ApplicationInstance.tag('VideoTexture')) {
    var el = ApplicationInstance.stage.c({
      type: VideoTexture(),
      ref: 'VideoTexture',
      zIndex: 0,
      videoEl: videoEl
    });
    ApplicationInstance.childList.addAt(el, 0);
  }
  return ApplicationInstance.tag('VideoTexture');
};
var registerEventListeners = function registerEventListeners() {
  LightningSdkPlugins_Log.info('VideoPlayer', 'Registering event listeners');
  Object.keys(events).forEach(function (event) {
    var handler = function handler(e) {
      if (VideoPlayer_metrics && VideoPlayer_metrics[event] && typeof VideoPlayer_metrics[event] === 'function') {
        VideoPlayer_metrics[event]({
          currentTime: videoEl.currentTime
        });
      }
      fireHook(event, {
        videoElement: videoEl,
        event: e
      });
      fireOnConsumer(events[event], {
        videoElement: videoEl,
        event: e
      });
    };
    eventHandlers[event] = handler;
    videoEl.addEventListener(event, handler);
  });
};
var deregisterEventListeners = function deregisterEventListeners() {
  LightningSdkPlugins_Log.info('VideoPlayer', 'Deregistering event listeners');
  Object.keys(eventHandlers).forEach(function (event) {
    videoEl.removeEventListener(event, eventHandlers[event]);
  });
  eventHandlers = {};
};
var videoPlayerPlugin = {
  consumer: function consumer(component) {
    _consumer = component;
  },
  loader: function loader(loaderFn) {
    customLoader = loaderFn;
  },
  unloader: function unloader(unloaderFn) {
    customUnloader = unloaderFn;
  },
  position: function position() {
    var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var left = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    videoEl.style.left = withPrecision(left);
    videoEl.style.top = withPrecision(top);
    if (textureMode === true) {
      videoTexture.position(top, left);
    }
  },
  size: function size() {
    var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1920;
    var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1080;
    videoEl.style.width = withPrecision(width);
    videoEl.style.height = withPrecision(height);
    videoEl.width = parseFloat(videoEl.style.width);
    videoEl.height = parseFloat(videoEl.style.height);
    if (textureMode === true) {
      videoTexture.size(width, height);
    }
  },
  area: function area() {
    var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var right = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1920;
    var bottom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1080;
    var left = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    this.position(top, left);
    this.size(right - left, bottom - top);
  },
  open: function open(url) {
    var _this = this;
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!this.canInteract) return;
    VideoPlayer_metrics = src_Metrics.media(url);
    this.hide();
    deregisterEventListeners();
    if (this.src == url) {
      this.clear().then(this.open(url, config));
    } else {
      var adConfig = {
        enabled: state.adsEnabled,
        duration: 300
      };
      if (config.videoId) {
        adConfig.caid = config.videoId;
      }
      Ads.get(adConfig, _consumer).then(function (ads) {
        state.playingAds = true;
        ads.prerolls().then(function () {
          state.playingAds = false;
          loader(url, videoEl, config).then(function () {
            registerEventListeners();
            _this.show();
            _this.play();
          }).catch(function (e) {
            fireOnConsumer('Error', {
              videoElement: videoEl,
              event: e
            });
            fireOnConsumer('error', {
              videoElement: videoEl,
              event: e
            });
          });
        });
      });
    }
  },
  reload: function reload() {
    if (!this.canInteract) return;
    var url = videoEl.getAttribute('src');
    this.close();
    this.open(url);
  },
  close: function close() {
    var _this2 = this;
    Ads.cancel();
    if (state.playingAds) {
      state.playingAds = false;
      Ads.stop();
      setTimeout(function () {
        _this2.close();
      });
    }
    if (!this.canInteract) return;
    this.clear();
    this.hide();
    deregisterEventListeners();
  },
  clear: function clear() {
    if (!this.canInteract) return;
    this.pause();
    if (textureMode === true) videoTexture.stop();
    return unloader(videoEl).then(function () {
      fireOnConsumer('Clear', {
        videoElement: videoEl
      });
    });
  },
  play: function play() {
    if (!this.canInteract) return;
    if (textureMode === true) videoTexture.start();
    execute_as_promise(videoEl.play, null, videoEl).catch(function (e) {
      fireOnConsumer('Error', {
        videoElement: videoEl,
        event: e
      });
      fireOnConsumer('error', {
        videoElement: videoEl,
        event: e
      });
    });
  },
  pause: function pause() {
    if (!this.canInteract) return;
    videoEl.pause();
  },
  playPause: function playPause() {
    if (!this.canInteract) return;
    this.playing === true ? this.pause() : this.play();
  },
  mute: function mute() {
    var muted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    if (!this.canInteract) return;
    videoEl.muted = muted;
  },
  loop: function loop() {
    var looped = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    videoEl.loop = looped;
  },
  seek: function seek(time) {
    if (!this.canInteract) return;
    if (!this.src) return;
    if (state.playAfterSeek === null) {
      state.playAfterSeek = !!state.playing;
    }
    this.pause();
    videoEl.currentTime = Math.max(0, Math.min(time, this.duration - 0.1));
  },
  skip: function skip(seconds) {
    var _this3 = this;
    if (!this.canInteract) return;
    if (!this.src) return;
    state.skipTime = (state.skipTime || videoEl.currentTime) + seconds;
    easeExecution(function () {
      _this3.seek(state.skipTime);
      state.skipTime = false;
    }, 300);
  },
  show: function show() {
    if (!this.canInteract) return;
    if (textureMode === true) {
      videoTexture.show();
    } else {
      videoEl.style.display = 'block';
      videoEl.style.visibility = 'visible';
    }
  },
  hide: function hide() {
    if (!this.canInteract) return;
    if (textureMode === true) {
      videoTexture.hide();
    } else {
      videoEl.style.display = 'none';
      videoEl.style.visibility = 'hidden';
    }
  },
  enableAds: function enableAds() {
    var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    state.adsEnabled = enabled;
  },
  get duration() {
    return videoEl && (isNaN(videoEl.duration) ? Infinity : videoEl.duration);
  },
  get currentTime() {
    return videoEl && videoEl.currentTime;
  },
  get muted() {
    return videoEl && videoEl.muted;
  },
  get looped() {
    return videoEl && videoEl.loop;
  },
  get src() {
    return videoEl && videoEl.getAttribute('src');
  },
  get playing() {
    return state.playing;
  },
  get playingAds() {
    return state.playingAds;
  },
  get canInteract() {
    return state.playingAds === false;
  },
  get top() {
    return videoEl && parseFloat(videoEl.style.top);
  },
  get left() {
    return videoEl && parseFloat(videoEl.style.left);
  },
  get bottom() {
    return videoEl && parseFloat(videoEl.style.top - videoEl.style.height);
  },
  get right() {
    return videoEl && parseFloat(videoEl.style.left - videoEl.style.width);
  },
  get width() {
    return videoEl && parseFloat(videoEl.style.width);
  },
  get height() {
    return videoEl && parseFloat(videoEl.style.height);
  },
  get visible() {
    if (textureMode === true) {
      return videoTexture.isVisible;
    } else {
      return videoEl && videoEl.style.display === 'block';
    }
  },
  get adsEnabled() {
    return state.adsEnabled;
  },
  get _videoEl() {
    return videoEl;
  },
  get _consumer() {
    return _consumer;
  }
};
/* harmony default export */ const src_VideoPlayer = (autoSetupMixin(videoPlayerPlugin, function () {
  precision = ApplicationInstance && ApplicationInstance.stage && ApplicationInstance.stage.getRenderPrecision() || precision;
  videoEl = setupVideoTag();
  textureMode = LightningSdkPlugins_Settings.get('platform', 'textureMode', false);
  if (textureMode === true) {
    videoEl.setAttribute('crossorigin', 'anonymous');
    videoTexture = setUpVideoTexture();
  }
}));
;// CONCATENATED MODULE: ./node_modules/.pnpm/@metrological+sdk@1.0.2/node_modules/@metrological/sdk/index.js








;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Ads/index.js







var consumer;
var getAds = function getAds() {
  return Promise.resolve({
    prerolls: [],
    midrolls: [],
    postrolls: []
  });
};
var initAds = function initAds(config) {
  if (config.getAds) {
    getAds = config.getAds;
  }
};
var Ads_state = {
  active: false
};
var playSlot = function playSlot() {
  var slot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return slot.reduce(function (promise, ad) {
    return promise.then(function () {
      return playAd(ad);
    });
  }, Promise.resolve(null));
};
var playAd = function playAd(ad) {
  return new Promise(function (resolve) {
    if (Ads_state.active === false) {
      Log.info('Ad', 'Skipping add due to inactive state');
      return resolve();
    }
    var videoEl = document.getElementsByTagName('video')[0];
    videoEl.style.display = 'block';
    videoEl.style.visibility = 'visible';
    videoEl.src = mediaUrl(ad.url);
    videoEl.load();
    var timeEvents = null;
    var timeout;
    var cleanup = function cleanup() {
      Object.keys(handlers).forEach(function (handler) {
        return videoEl.removeEventListener(handler, handlers[handler]);
      });
      resolve();
    };
    var handlers = {
      play: function play() {
        Log.info('Ad', 'Play ad', ad.url);
        Ads_fireOnConsumer('Play', ad);
        sendBeacon(ad.callbacks, 'defaultImpression');
      },
      ended: function ended() {
        Ads_fireOnConsumer('Ended', ad);
        sendBeacon(ad.callbacks, 'complete');
        cleanup();
      },
      timeupdate: function timeupdate() {
        if (!timeEvents && videoEl.duration) {
          timeEvents = {
            firstQuartile: videoEl.duration / 4,
            midPoint: videoEl.duration / 2,
            thirdQuartile: videoEl.duration / 4 * 3
          };
          Log.info('Ad', 'Calculated quartiles times', {
            timeEvents: timeEvents
          });
        }
        if (timeEvents && timeEvents.firstQuartile && videoEl.currentTime >= timeEvents.firstQuartile) {
          Ads_fireOnConsumer('FirstQuartile', ad);
          delete timeEvents.firstQuartile;
          sendBeacon(ad.callbacks, 'firstQuartile');
        }
        if (timeEvents && timeEvents.midPoint && videoEl.currentTime >= timeEvents.midPoint) {
          Ads_fireOnConsumer('MidPoint', ad);
          delete timeEvents.midPoint;
          sendBeacon(ad.callbacks, 'midPoint');
        }
        if (timeEvents && timeEvents.thirdQuartile && videoEl.currentTime >= timeEvents.thirdQuartile) {
          Ads_fireOnConsumer('ThirdQuartile', ad);
          delete timeEvents.thirdQuartile;
          sendBeacon(ad.callbacks, 'thirdQuartile');
        }
      },
      stalled: function stalled() {
        Ads_fireOnConsumer('Stalled', ad);
        timeout = setTimeout(function () {
          cleanup();
        }, 5000);
      },
      canplay: function canplay() {
        timeout && clearTimeout(timeout);
      },
      error: function error() {
        Ads_fireOnConsumer('Error', ad);
        cleanup();
      },
      abort: function abort() {
        cleanup();
      }
    };
    Object.keys(handlers).forEach(function (handler) {
      return videoEl.addEventListener(handler, handlers[handler]);
    });
    videoEl.play();
  });
};
var sendBeacon = function sendBeacon(callbacks, event) {
  if (callbacks && callbacks[event]) {
    Log.info('Ad', 'Sending beacon', event, callbacks[event]);
    return callbacks[event].reduce(function (promise, url) {
      return promise.then(function () {
        return fetch(url).then(function (response) {
          if (response.status === 200) {
            Ads_fireOnConsumer('Beacon' + event + 'Sent');
          } else {
            Ads_fireOnConsumer('Beacon' + event + 'Failed' + response.status);
          }
          Promise.resolve(null);
        }).catch(function () {
          Promise.resolve(null);
        });
      });
    }, Promise.resolve(null));
  } else {
    Log.info('Ad', 'No callback found for ' + event);
  }
};
var Ads_fireOnConsumer = function fireOnConsumer(event, args) {
  if (consumer) {
    consumer.fire('$ad' + event, args);
    consumer.fire('$adEvent', event, args);
  }
};
/* harmony default export */ const src_Ads = ({
  get: function get(config, videoPlayerConsumer) {
    if (config.enabled === false) {
      return Promise.resolve({
        prerolls: function prerolls() {
          return Promise.resolve();
        }
      });
    }
    consumer = videoPlayerConsumer;
    return new Promise(function (resolve) {
      Log.info('Ad', 'Starting session');
      getAds(config).then(function (ads) {
        Log.info('Ad', 'API result', ads);
        resolve({
          prerolls: function prerolls() {
            if (ads.preroll) {
              Ads_state.active = true;
              Ads_fireOnConsumer('PrerollSlotImpression', ads);
              sendBeacon(ads.preroll.callbacks, 'slotImpression');
              return playSlot(ads.preroll.ads).then(function () {
                Ads_fireOnConsumer('PrerollSlotEnd', ads);
                sendBeacon(ads.preroll.callbacks, 'slotEnd');
                Ads_state.active = false;
              });
            }
            return Promise.resolve();
          },
          midrolls: function midrolls() {
            return Promise.resolve();
          },
          postrolls: function postrolls() {
            return Promise.resolve();
          }
        });
      });
    });
  },
  cancel: function cancel() {
    Log.info('Ad', 'Cancel Ad');
    Ads_state.active = false;
  },
  stop: function stop() {
    Log.info('Ad', 'Stop Ad');
    Ads_state.active = false;
    var videoEl = document.getElementsByTagName('video')[0];
    videoEl.pause();
    videoEl.removeAttribute('src');
  }
});
// EXTERNAL MODULE: ./node_modules/.pnpm/deepmerge@4.3.1/node_modules/deepmerge/dist/cjs.js
var cjs = __webpack_require__(12454);
var cjs_default = /*#__PURE__*/__webpack_require__.n(cjs);
;// CONCATENATED MODULE: ./node_modules/.pnpm/is-plain-object@5.0.0/node_modules/is-plain-object/dist/is-plain-object.mjs
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */

function isObject(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}

function isPlainObject(o) {
  var ctor,prot;

  if (isObject(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (ctor === undefined) return true;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObject(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
}



// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js + 3 modules
var wrapNativeSuper = __webpack_require__(43515);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Locale/index.js
















function Locale_createSuper(t) { var r = Locale_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function Locale_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (Locale_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }


var warned = false;
var deprecated = function deprecated() {
  var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  if (force === true || warned === false) {
    console.warn(["The 'Locale'-plugin in the Lightning-SDK is deprecated and will be removed in future releases.", "Please consider using the new 'Language'-plugin instead.", 'https://rdkcentral.github.io/Lightning-SDK/#/plugins/language'].join('\n\n'));
  }
  warned = true;
};
var Locale = function () {
  function Locale() {
    (0,classCallCheck/* default */.Z)(this, Locale);
    this.__enabled = false;
  }
  (0,createClass/* default */.Z)(Locale, [{
    key: "load",
    value: (function () {
      var _load = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(path) {
        var _this = this;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.__enabled) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return fetch(path).then(function (resp) {
                return resp.json();
              }).then(function (resp) {
                _this.loadFromObject(resp);
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function load(_x) {
        return _load.apply(this, arguments);
      }
      return load;
    }())
  }, {
    key: "setLanguage",
    value: function setLanguage(lang) {
      deprecated();
      this.__enabled = true;
      this.language = lang;
    }
  }, {
    key: "tr",
    get: function get() {
      deprecated(true);
      return this.__trObj[this.language];
    }
  }, {
    key: "loadFromObject",
    value: function loadFromObject(trObj) {
      deprecated();
      var fallbackLanguage = 'en';
      if (Object.keys(trObj).indexOf(this.language) === -1) {
        Log.warn('No translations found for: ' + this.language);
        if (Object.keys(trObj).indexOf(fallbackLanguage) > -1) {
          Log.warn('Using fallback language: ' + fallbackLanguage);
          this.language = fallbackLanguage;
        } else {
          var error = 'No translations found for fallback language: ' + fallbackLanguage;
          Log.error(error);
          throw Error(error);
        }
      }
      this.__trObj = trObj;
      for (var _i = 0, _Object$values = Object.values(this.__trObj); _i < _Object$values.length; _i++) {
        var lang = _Object$values[_i];
        for (var _i2 = 0, _Object$keys = Object.keys(lang); _i2 < _Object$keys.length; _i2++) {
          var str = _Object$keys[_i2];
          lang[str] = new LocalizedString(lang[str]);
        }
      }
    }
  }]);
  return Locale;
}();
var LocalizedString = function (_String) {
  (0,inherits/* default */.Z)(LocalizedString, _String);
  var _super = Locale_createSuper(LocalizedString);
  function LocalizedString() {
    (0,classCallCheck/* default */.Z)(this, LocalizedString);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(LocalizedString, [{
    key: "format",
    value: function format() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var sub = args.reduce(function (string, arg, index) {
        return string.split("{".concat(index, "}")).join(arg);
      }, this);
      return new LocalizedString(sub);
    }
  }]);
  return LocalizedString;
}((0,wrapNativeSuper/* default */.Z)(String));
/* harmony default export */ const src_Locale = (new Locale());
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Metrics/index.js

/* harmony default export */ const sdk_src_Metrics = (src_Metrics);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/VersionLabel/index.js






function VersionLabel_createSuper(t) { var r = VersionLabel_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function VersionLabel_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (VersionLabel_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var VersionLabel = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(VersionLabel, _Lightning$Component);
  var _super = VersionLabel_createSuper(VersionLabel);
  function VersionLabel() {
    (0,classCallCheck/* default */.Z)(this, VersionLabel);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(VersionLabel, [{
    key: "_firstActive",
    value: function _firstActive() {
      this.tag('Text').text = "APP - v".concat(this.version, "\nSDK - v").concat(this.sdkVersion);
      this.tag('Text').loadTexture();
      this.w = this.tag('Text').renderWidth + 40;
      this.h = this.tag('Text').renderHeight + 5;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return {
        rect: true,
        color: 0xbb0078ac,
        h: 40,
        w: 100,
        x: function x(w) {
          return w - 50;
        },
        y: function y(h) {
          return h - 50;
        },
        mount: 1,
        Text: {
          w: function w(_w) {
            return _w;
          },
          h: function h(_h) {
            return _h;
          },
          y: 5,
          x: 20,
          text: {
            fontSize: 22,
            lineHeight: 26
          }
        }
      };
    }
  }]);
  return VersionLabel;
}(src_Lightning.Component);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/FpsCounter/index.js






function FpsCounter_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function FpsCounter_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? FpsCounter_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : FpsCounter_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function FpsCounter_createSuper(t) { var r = FpsCounter_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function FpsCounter_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (FpsCounter_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }



var FpsIndicator = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(FpsIndicator, _Lightning$Component);
  var _super = FpsCounter_createSuper(FpsIndicator);
  function FpsIndicator() {
    (0,classCallCheck/* default */.Z)(this, FpsIndicator);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(FpsIndicator, [{
    key: "_setup",
    value: function _setup() {
      var _this = this;
      this.config = FpsCounter_objectSpread(FpsCounter_objectSpread({}, {
        log: false,
        interval: 500,
        threshold: 1
      }), src_Settings.get('platform', 'showFps'));
      this.fps = 0;
      this.lastFps = this.fps - this.config.threshold;
      var fpsCalculator = function fpsCalculator() {
        _this.fps = ~~(1 / _this.stage.dt);
      };
      this.stage.on('frameStart', fpsCalculator);
      this.stage.off('framestart', fpsCalculator);
      this.interval = setInterval(this.showFps.bind(this), this.config.interval);
    }
  }, {
    key: "_firstActive",
    value: function _firstActive() {
      this.showFps();
    }
  }, {
    key: "_detach",
    value: function _detach() {
      clearInterval(this.interval);
    }
  }, {
    key: "showFps",
    value: function showFps() {
      if (Math.abs(this.lastFps - this.fps) <= this.config.threshold) return;
      this.lastFps = this.fps;
      var bgColor = 0xff008000;
      if (this.fps <= 40 && this.fps > 20) bgColor = 0xffffa500;else if (this.fps <= 20) bgColor = 0xffff0000;
      this.tag('Background').setSmooth('color', bgColor);
      this.tag('Counter').text = "".concat(this.fps);
      this.config.log && Log.info('FPS', this.fps);
    }
  }], [{
    key: "_template",
    value: function _template() {
      return {
        rect: true,
        color: 0xffffffff,
        texture: src_Lightning.Tools.getRoundRect(80, 80, 40),
        h: 80,
        w: 80,
        x: 100,
        y: 100,
        mount: 1,
        Background: {
          x: 3,
          y: 3,
          texture: src_Lightning.Tools.getRoundRect(72, 72, 36),
          color: 0xff008000
        },
        Counter: {
          w: function w(_w) {
            return _w;
          },
          h: function h(_h) {
            return _h;
          },
          y: 10,
          text: {
            fontSize: 32,
            textAlign: 'center'
          }
        },
        Text: {
          w: function w(_w2) {
            return _w2;
          },
          h: function h(_h2) {
            return _h2;
          },
          y: 48,
          text: {
            fontSize: 15,
            textAlign: 'center',
            text: 'FPS'
          }
        }
      };
    }
  }]);
  return FpsIndicator;
}(src_Lightning.Component);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/helpers/fetchJson.js


/* harmony default export */ const fetchJson = (function (file) {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
      if (xhr.readyState == XMLHttpRequest.DONE) {
        if (xhr.status === 0 || xhr.status === 200) resolve(JSON.parse(xhr.responseText));else reject(xhr.statusText);
      }
    };
    xhr.open('GET', file);
    xhr.send(null);
  });
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Utils/index.js






var basePath;
var _proxyUrl;
var initUtils = function initUtils(config) {
  basePath = _ensureUrlWithProtocol(makeFullStaticPath(window.location.pathname, config.path || '/'));
  if (config.proxyUrl) {
    _proxyUrl = _ensureUrlWithProtocol(config.proxyUrl);
  }
};
/* harmony default export */ const src_Utils = ({
  asset: function asset(relPath) {
    return basePath + relPath;
  },
  proxyUrl: function proxyUrl(url) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _proxyUrl ? _proxyUrl + '?' + _makeQueryString(url, options) : url;
  },
  makeQueryString: function makeQueryString() {
    return _makeQueryString.apply(void 0, arguments);
  },
  ensureUrlWithProtocol: function ensureUrlWithProtocol() {
    return _ensureUrlWithProtocol.apply(void 0, arguments);
  }
});
var _ensureUrlWithProtocol = function _ensureUrlWithProtocol(url) {
  if (/^\/[^/]/i.test(url) && /^(?:file:)/i.test(window.location.protocol)) {
    return window.location.protocol + '//' + url;
  }
  if (/^\/\//.test(url)) {
    return window.location.protocol + url;
  }
  if (!/^(?:https?:)/i.test(url)) {
    return window.location.origin + url;
  }
  return url;
};

var makeFullStaticPath = function makeFullStaticPath() {
  var pathname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
  var path = arguments.length > 1 ? arguments[1] : undefined;
  path = path.charAt(path.length - 1) !== '/' ? path + '/' : path;
  if (/^(?:https?:)?(?:\/\/)/.test(path)) {
    return path;
  }
  if (path.charAt(0) === '/') {
    return path;
  } else {
    pathname = cleanUpPathName(pathname);
    path = path.charAt(0) === '.' ? path.substr(1) : path;
    path = path.charAt(0) !== '/' ? '/' + path : path;
    return pathname + path;
  }
};
var cleanUpPathName = function cleanUpPathName(pathname) {
  if (pathname.slice(-1) === '/') return pathname.slice(0, -1);
  var parts = pathname.split('/');
  if (parts[parts.length - 1].indexOf('.') > -1) parts.pop();
  return parts.join('/');
};
var _makeQueryString = function _makeQueryString(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'url';
  options.operator = 'metrological';
  options[type] = url;
  return Object.keys(options).map(function (key) {
    return encodeURIComponent(key) + '=' + encodeURIComponent('' + options[key]);
  }).join('&');
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Language/index.js













function Language_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Language_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Language_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Language_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



var meta = {};
var translations = {};
var language = null;
var dictionary = null;
var initLanguage = function initLanguage(file) {
  var language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return new Promise(function (resolve, reject) {
    fetchJson(file).then(function (json) {
      setTranslations(json);
      (0,esm_typeof/* default */.Z)(language) === 'object' && 'then' in language && typeof language.then === 'function' ? language.then(function (lang) {
        return setLanguage(lang).then(resolve).catch(reject);
      }).catch(function (e) {
        Log.error(e);
        reject(e);
      }) : setLanguage(language).then(resolve).catch(reject);
    }).catch(function () {
      var error = 'Language file ' + file + ' not found';
      Log.error(error);
      reject(error);
    });
  });
};
var setTranslations = function setTranslations(obj) {
  if ('meta' in obj) {
    meta = Language_objectSpread({}, obj.meta);
    delete obj.meta;
  }
  translations = obj;
};
var Language_getLanguage = function getLanguage() {
  return language;
};
var setLanguage = function setLanguage(lng) {
  language = null;
  dictionary = null;
  return new Promise(function (resolve, reject) {
    if (lng in translations) {
      language = lng;
    } else {
      if ('map' in meta && lng in meta.map && meta.map[lng] in translations) {
        language = meta.map[lng];
      } else if ('default' in meta && meta.default in translations) {
        var error = 'Translations for Language ' + language + ' not found. Using default language ' + meta.default;
        Log.warn(error);
        language = meta.default;
      } else {
        var _error = 'Translations for Language ' + language + ' not found.';
        Log.error(_error);
        reject(_error);
      }
    }
    if (language) {
      Log.info('Setting language to', language);
      var translationsObj = translations[language];
      if ((0,esm_typeof/* default */.Z)(translationsObj) === 'object') {
        dictionary = translationsObj;
        resolve();
      } else if (typeof translationsObj === 'string') {
        var url = src_Utils.asset(translationsObj);
        fetchJson(url).then(function (json) {
          translations[language] = json;
          dictionary = json;
          resolve();
        }).catch(function (e) {
          var error = 'Error while fetching ' + url;
          Log.error(error, e);
          reject(error);
        });
      }
    }
  });
};
/* harmony default export */ const Language = ({
  translate: function translate(key) {
    var replacements = Array.prototype.slice.call(arguments).slice(1);
    if (replacements.length === 0) {
      return dictionary && dictionary[key] || key;
    } else {
      if (replacements.length === 1 && (0,esm_typeof/* default */.Z)(replacements[0]) === 'object') {
        replacements = replacements.pop();
      }
      return Object.keys(Array.isArray(replacements) ? Object.assign({}, replacements) : replacements).reduce(function (text, replacementKey) {
        return text.replace(new RegExp('{\\s?' + replacementKey + '\\s?}', 'g'), replacements[replacementKey]);
      }, dictionary && dictionary[key] || key);
    }
  },
  translations: function translations(obj) {
    setTranslations(obj);
  },
  set: function set(language) {
    return setLanguage(language);
  },
  get: function get() {
    return Language_getLanguage();
  },
  available: function available() {
    var languageKeys = Object.keys(translations);
    return languageKeys.map(function (key) {
      return {
        code: key,
        name: meta.names && meta.names[key] || key
      };
    });
  }
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Registry/index.js







var registry = {
  eventListeners: [],
  timeouts: [],
  intervals: [],
  targets: []
};
/* harmony default export */ const Registry = ({
  setTimeout: function (_setTimeout) {
    function setTimeout(_x, _x2) {
      return _setTimeout.apply(this, arguments);
    }
    setTimeout.toString = function () {
      return _setTimeout.toString();
    };
    return setTimeout;
  }(function (cb, timeout) {
    for (var _len = arguments.length, params = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      params[_key - 2] = arguments[_key];
    }
    var timeoutId = setTimeout(function () {
      registry.timeouts = registry.timeouts.filter(function (id) {
        return id !== timeoutId;
      });
      cb.apply(null, params);
    }, timeout, params);
    Log.info('Set Timeout', 'ID: ' + timeoutId);
    registry.timeouts.push(timeoutId);
    return timeoutId;
  }),
  clearTimeout: function (_clearTimeout) {
    function clearTimeout(_x3) {
      return _clearTimeout.apply(this, arguments);
    }
    clearTimeout.toString = function () {
      return _clearTimeout.toString();
    };
    return clearTimeout;
  }(function (timeoutId) {
    if (registry.timeouts.indexOf(timeoutId) > -1) {
      registry.timeouts = registry.timeouts.filter(function (id) {
        return id !== timeoutId;
      });
      Log.info('Clear Timeout', 'ID: ' + timeoutId);
      clearTimeout(timeoutId);
    } else {
      Log.error('Clear Timeout', 'ID ' + timeoutId + ' not found');
    }
  }),
  clearTimeouts: function clearTimeouts() {
    var _this = this;
    registry.timeouts.forEach(function (timeoutId) {
      _this.clearTimeout(timeoutId);
    });
  },
  setInterval: function (_setInterval) {
    function setInterval(_x4, _x5) {
      return _setInterval.apply(this, arguments);
    }
    setInterval.toString = function () {
      return _setInterval.toString();
    };
    return setInterval;
  }(function (cb, interval) {
    for (var _len2 = arguments.length, params = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      params[_key2 - 2] = arguments[_key2];
    }
    var intervalId = setInterval(function () {
      registry.intervals.filter(function (id) {
        return id !== intervalId;
      });
      cb.apply(null, params);
    }, interval, params);
    Log.info('Set Interval', 'ID: ' + intervalId);
    registry.intervals.push(intervalId);
    return intervalId;
  }),
  clearInterval: function (_clearInterval) {
    function clearInterval(_x6) {
      return _clearInterval.apply(this, arguments);
    }
    clearInterval.toString = function () {
      return _clearInterval.toString();
    };
    return clearInterval;
  }(function (intervalId) {
    if (registry.intervals.indexOf(intervalId) > -1) {
      registry.intervals = registry.intervals.filter(function (id) {
        return id !== intervalId;
      });
      Log.info('Clear Interval', 'ID: ' + intervalId);
      clearInterval(intervalId);
    } else {
      Log.error('Clear Interval', 'ID ' + intervalId + ' not found');
    }
  }),
  clearIntervals: function clearIntervals() {
    var _this2 = this;
    registry.intervals.forEach(function (intervalId) {
      _this2.clearInterval(intervalId);
    });
  },
  addEventListener: function addEventListener(target, event, handler) {
    target.addEventListener(event, handler);
    var targetIndex = registry.targets.indexOf(target) > -1 ? registry.targets.indexOf(target) : registry.targets.push(target) - 1;
    registry.eventListeners[targetIndex] = registry.eventListeners[targetIndex] || {};
    registry.eventListeners[targetIndex][event] = registry.eventListeners[targetIndex][event] || [];
    registry.eventListeners[targetIndex][event].push(handler);
    Log.info('Add eventListener', 'Target:', target, 'Event: ' + event, 'Handler:', handler.toString());
  },
  removeEventListener: function removeEventListener(target, event, handler) {
    var targetIndex = registry.targets.indexOf(target);
    if (targetIndex > -1 && registry.eventListeners[targetIndex] && registry.eventListeners[targetIndex][event] && registry.eventListeners[targetIndex][event].indexOf(handler) > -1) {
      registry.eventListeners[targetIndex][event] = registry.eventListeners[targetIndex][event].filter(function (fn) {
        return fn !== handler;
      });
      Log.info('Remove eventListener', 'Target:', target, 'Event: ' + event, 'Handler:', handler.toString());
      target.removeEventListener(event, handler);
      Object.keys(registry.eventListeners[targetIndex]).forEach(function (event) {
        if (registry.eventListeners[targetIndex][event].length === 0) {
          delete registry.eventListeners[targetIndex][event];
        }
      });
      if (Object.keys(registry.eventListeners[targetIndex]).length === 0) {
        registry.targets.splice(targetIndex, 1);
        registry.eventListeners.splice(targetIndex, 1);
      }
    } else {
      Log.error('Remove eventListener', 'Not found', 'Target', target, 'Event: ' + event, 'Handler', handler.toString());
    }
  },
  removeEventListeners: function removeEventListeners(target, event) {
    var _this3 = this;
    if (target && event) {
      var targetIndex = registry.targets.indexOf(target);
      if (targetIndex > -1) {
        registry.eventListeners[targetIndex][event].forEach(function (handler) {
          _this3.removeEventListener(target, event, handler);
        });
      }
    } else if (target) {
      var _targetIndex = registry.targets.indexOf(target);
      if (_targetIndex > -1) {
        Object.keys(registry.eventListeners[_targetIndex]).forEach(function (_event) {
          _this3.removeEventListeners(target, _event);
        });
      }
    } else {
      Object.keys(registry.eventListeners).forEach(function (targetIndex) {
        _this3.removeEventListeners(registry.targets[targetIndex]);
      });
    }
  },
  clear: function clear() {
    this.clearTimeouts();
    this.clearIntervals();
    this.removeEventListeners();
    registry.eventListeners = [];
    registry.timeouts = [];
    registry.intervals = [];
    registry.targets = [];
  }
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Colors/utils.js

var utils_isObject = function isObject(v) {
  return (0,esm_typeof/* default */.Z)(v) === 'object' && v !== null;
};
var utils_isString = function isString(v) {
  return typeof v === 'string';
};
var getRgbaComponents = function getRgbaComponents(argb) {
  return {
    r: (argb / 65536 | 0) % 256,
    g: (argb / 256 | 0) % 256,
    b: argb * 1 % 256,
    a: argb / 16777216 | 0
  };
};
var limitWithinRange = function limitWithinRange(num, min, max) {
  return Math.min(Math.max(num, min), max);
};
var mergeColors = function mergeColors(c1, c2, p) {
  var r1 = (c1 / 65536 | 0) % 256;
  var g1 = (c1 / 256 | 0) % 256;
  var b1 = c1 % 256;
  var a1 = c1 / 16777216 | 0;
  var r2 = (c2 / 65536 | 0) % 256;
  var g2 = (c2 / 256 | 0) % 256;
  var b2 = c2 % 256;
  var a2 = c2 / 16777216 | 0;
  var r = r1 * p + r2 * (1 - p);
  var g = g1 * p + g2 * (1 - p);
  var b = b1 * p + b2 * (1 - p);
  var a = a1 * p + a2 * (1 - p);
  return Math.round(a) * 16777216 + Math.round(r) * 65536 + Math.round(g) * 256 + Math.round(b);
};
var calculateAlpha = function calculateAlpha(argb, p) {
  if (p > 1) {
    p /= 100;
  } else if (p < 0) {
    p = 0;
  }
  var r = (argb / 65536 | 0) % 256;
  var g = (argb / 256 | 0) % 256;
  var b = argb % 256;
  return (r << 16) + (g << 8) + b + (Math.round(p * 255) | 0) * 16777216;
};
var mergeColorAlpha = function mergeColorAlpha(c, alpha) {
  var a = (c / 16777216 | 0) * alpha | 0;
  return ((c >> 16 & 0xff) * a / 255 & 0xff) + ((c & 0xff00) * a / 255 & 0xff00) + (((c & 0xff) << 16) * a / 255 & 0xff0000) + (a << 24);
};
var getArgbNumber = function getArgbNumber(rgba) {
  rgba[0] = Math.max(0, Math.min(255, rgba[0]));
  rgba[1] = Math.max(0, Math.min(255, rgba[1]));
  rgba[2] = Math.max(0, Math.min(255, rgba[2]));
  rgba[3] = Math.max(0, Math.min(255, rgba[3]));
  var v = ((rgba[3] | 0) << 24) + ((rgba[0] | 0) << 16) + ((rgba[1] | 0) << 8) + (rgba[2] | 0);
  if (v < 0) {
    v = 0xffffffff + v + 1;
  }
  return v;
};
var argbToHsva = function argbToHsva(argb) {
  var color = getRgbaComponents(argb);
  var r = color.r / 255;
  var g = color.g / 255;
  var b = color.b / 255;
  var h = 0;
  var s = 0;
  var cMax = Math.max(r, g, b);
  var cMin = Math.min(r, g, b);
  var delta = cMax - cMin;
  if (delta < 0.00001) {
    h = 0;
  } else if (cMax !== 0 || cMin !== 0) {
    if (r === cMax) {
      h = (60 * ((g - b) / delta) + 360) % 360;
    } else if (g === cMax) {
      h = (60 * ((b - r) / delta) + 120) % 360;
    } else if (b === cMax) {
      h = (60 * ((r - g) / delta) + 240) % 360;
    }
  }
  if (cMax > 0) {
    s = delta / cMax;
  }
  return {
    h: h,
    s: s,
    v: cMax,
    a: color.a / 255
  };
};
var hsvaToArgb = function hsvaToArgb(color) {
  var h = color.h;
  var c = color.v * color.s;
  var m = color.v - c;
  var x = c * (1.0 - Math.abs(h / 60 % 2 - 1));
  var r = 0;
  var g = 0;
  var b = 0;
  if (0 <= h && h < 60) {
    r = c;
    g = x;
  } else if (60 <= h && h < 120) {
    r = x;
    g = c;
  } else if (120 <= h && h < 180) {
    g = c;
    b = x;
  } else if (180 <= h && h < 240) {
    g = x;
    b = c;
  } else if (240 <= h && h < 300) {
    r = x;
    b = c;
  } else if (300 <= h && h < 360) {
    r = c;
    b = x;
  }
  r = Math.round((r + m) * 255.0);
  g = Math.round((g + m) * 255.0);
  b = Math.round((b + m) * 255.0);
  return getArgbNumber([r, g, b, color.a * 255]);
};
var argbToHSLA = function argbToHSLA(argb) {
  var col = getRgbaComponents(argb);
  var r = col.r / 255;
  var g = col.g / 255;
  var b = col.b / 255;
  var max = Math.max(r, g, b);
  var min = Math.min(r, g, b);
  var h = 0;
  var s = 0;
  var l = (min + max) * 0.5;
  if (l > 0) {
    var maxMin = max - min;
    if (maxMin > 0) {
      var r2 = (max - r) / maxMin;
      var g2 = (max - g) / maxMin;
      var b2 = (max - b) / maxMin;
      if (l < 0.5) {
        s = max + min;
      } else {
        s = 2 - max - min;
      }
      if (r === max && g === min) {
        h = 5.0 + b2;
      } else if (r === max) {
        h = 1.0 - g2;
      } else if (g === max && b === min) {
        h = 1.0 + r2;
      } else if (g === max) {
        h = 3.0 - b2;
      } else if (b === max) {
        h = 3.0 + g2;
      } else {
        h = 5.0 - r2;
      }
      h = h / 6;
    }
  }
  return {
    h: h % 1,
    s: s,
    l: l,
    a: col.a
  };
};
var hslaToARGB = function hslaToARGB(hsla) {
  var r = 1;
  var g = 1;
  var b = 1;
  var h = hsla.h;
  var s = hsla.s;
  var l = hsla.l;
  if (h < 0) {
    h += 1;
  }
  var max = 0;
  if (l <= 0.5) {
    max = l * (1.0 + s);
  } else {
    max = l + s - l * s;
  }
  if (max > 0) {
    h *= 6.0;
    var min = l + l - max;
    var minMax = (max - min) / max;
    var sextant = Math.floor(h);
    var fract = h - sextant;
    var minMaxFract = max * minMax * fract;
    var mid1 = min + minMaxFract;
    var mid2 = max - minMaxFract;
    if (sextant === 0) {
      r = max;
      g = mid1;
      b = min;
    }
    if (sextant === 1) {
      r = mid2;
      g = max;
      b = min;
    }
    if (sextant === 2) {
      r = min;
      g = max;
      b = mid1;
    }
    if (sextant === 3) {
      r = min;
      g = mid2;
      b = max;
    }
    if (sextant === 4) {
      r = mid1;
      g = min;
      b = max;
    }
    if (sextant === 5) {
      r = max;
      g = min;
      b = mid2;
    }
  }
  return getArgbNumber([Math.floor(r * 255), Math.floor(g * 255), Math.floor(b * 255), hsla.a]);
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Colors/index.js













var colors = {
  white: '#ffffff',
  black: '#000000',
  red: '#ff0000',
  green: '#00ff00',
  blue: '#0000ff',
  yellow: '#feff00',
  cyan: '#00feff',
  magenta: '#ff00ff'
};
var normalizedColors = {};
var addColors = function addColors(colorsToAdd, value) {
  if (utils_isObject(colorsToAdd)) {
    Object.keys(colorsToAdd).forEach(function (color) {
      return cleanUpNormalizedColors(color);
    });
    colors = Object.assign({}, colors, colorsToAdd);
  } else if (utils_isString(colorsToAdd) && value) {
    cleanUpNormalizedColors(colorsToAdd);
    colors[colorsToAdd] = value;
  }
};
var cleanUpNormalizedColors = function cleanUpNormalizedColors(color) {
  for (var c in normalizedColors) {
    if (c.indexOf(color) > -1) {
      delete normalizedColors[c];
    }
  }
};
var initColors = function initColors(file) {
  return new Promise(function (resolve, reject) {
    if ((0,esm_typeof/* default */.Z)(file) === 'object') {
      addColors(file);
      return resolve();
    }
    fetchJson(file).then(function (json) {
      addColors(json);
      return resolve();
    }).catch(function () {
      var error = 'Colors file ' + file + ' not found';
      Log.error(error);
      return reject(error);
    });
  });
};
var normalizeColorToARGB = function normalizeColorToARGB(color) {
  var targetColor = normalizedColors[color] || colors[color] || color;
  if (!targetColor) {
    targetColor = color;
  }
  var check = /^#([0-9A-F]{3}|[0-9A-F]{6}|[0-9A-F]{8})$/i;
  if (utils_isString(targetColor) && check.test(targetColor)) {
    var hex = check.exec(targetColor)[1];
    if (hex.length === 3) {
      hex = hex.split('').map(function (value) {
        return value + value;
      }).join('');
    }
    targetColor = (hex.length === 8 ? "0x".concat(hex) : "0xff".concat(hex)) * 1;
  }
  if (!normalizedColors[color]) {
    normalizedColors[color] = targetColor;
  }
  return targetColor || 0xffffffff;
};
/* harmony default export */ const Colors = (function (color) {
  return Color.generate(color);
});
var Color = {
  color: null,
  generate: function generate() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.color;
    if (normalizedColors[value]) {
      this.color = normalizedColors[value];
    } else {
      this.color = normalizeColorToARGB(value);
    }
    return this;
  },
  get: function get() {
    return this.color;
  },
  alpha: function alpha(percentage) {
    this.color = calculateAlpha(this.color, Math.abs(percentage));
    return this;
  },
  darker: function darker(percentage) {
    var hsl = argbToHSLA(this.color);
    hsl.l = hsl.l * (1 - percentage);
    this.color = hslaToARGB(hsl);
    return this;
  },
  lighter: function lighter(percentage) {
    var hsl = argbToHSLA(this.color);
    hsl.l = hsl.l + (1 - hsl.l) * percentage;
    this.color = hslaToARGB(hsl);
    return this;
  },
  saturation: function saturation(percentage) {
    var hsl = argbToHSLA(this.color);
    hsl.s = percentage;
    this.color = hslaToARGB(hsl);
    return this;
  },
  lightness: function lightness(percentage) {
    var hsl = argbToHSLA(this.color);
    hsl.l = percentage;
    this.color = hslaToARGB(hsl);
    return this;
  },
  hue: function hue(degrees) {
    var hsl = argbToHSLA(this.color);
    hsl.h = degrees;
    this.color = hslaToARGB(hsl);
    return this;
  },
  mix: function mix(argb, p) {
    this.color = mergeColors(this.color, argb, p);
    return this;
  }
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/package.json
const package_namespaceObject = {"i8":"5.5.5"};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Application/index.js
















function src_Application_createSuper(t) { var r = src_Application_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function src_Application_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (src_Application_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }















var AppInstance;
var AppData;
var defaultOptions = {
  stage: {
    w: 1920,
    h: 1080,
    precision: 1,
    clearColor: 0x00000000,
    canvas2d: false
  },
  debug: false,
  defaultFontFace: 'RobotoRegular',
  keys: {
    8: 'Back',
    13: 'Enter',
    27: 'Menu',
    37: 'Left',
    38: 'Up',
    39: 'Right',
    40: 'Down',
    174: 'ChannelDown',
    175: 'ChannelUp',
    178: 'Stop',
    250: 'PlayPause',
    191: 'Search',
    409: 'Search'
  }
};
var customFontFaces = [];
var fontLoader = function fontLoader(fonts, store) {
  return new Promise(function (resolve, reject) {
    fonts.map(function (_ref) {
      var family = _ref.family,
        url = _ref.url,
        urls = _ref.urls,
        descriptors = _ref.descriptors;
      return function () {
        var src = urls ? urls.map(function (url) {
          return 'url(' + url + ')';
        }) : 'url(' + url + ')';
        var fontFace = new FontFace(family, src, descriptors || {});
        store.push(fontFace);
        Log.info('Loading font', family);
        document.fonts.add(fontFace);
        return fontFace.load();
      };
    }).reduce(function (promise, method) {
      return promise.then(function () {
        return method();
      });
    }, Promise.resolve(null)).then(resolve).catch(reject);
  });
};
/* harmony default export */ function src_Application(App, appData, platformSettings) {
  var width = platformSettings.width,
    height = platformSettings.height;
  if (width && height) {
    defaultOptions.stage['w'] = width;
    defaultOptions.stage['h'] = height;
    defaultOptions.stage['precision'] = width / 1920;
  }
  if (!width && !height && window.innerHeight === 720) {
    defaultOptions.stage['w'] = 1280;
    defaultOptions.stage['h'] = 720;
    defaultOptions.stage['precision'] = 1280 / 1920;
  }
  return function (_Lightning$Applicatio) {
    (0,inherits/* default */.Z)(Application, _Lightning$Applicatio);
    var _super = src_Application_createSuper(Application);
    function Application(options) {
      var _this;
      (0,classCallCheck/* default */.Z)(this, Application);
      var config = cjs_default()(defaultOptions, options, {
        isMergeableObject: isPlainObject
      });
      _this = _super.call(this, config);
      _this.config = config;
      return _this;
    }
    (0,createClass/* default */.Z)(Application, [{
      key: "colorshift",
      value: function colorshift() {
        var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        Accessibility.colorshift(this, type, config);
      }
    }, {
      key: "keymapping",
      get: function get() {
        return this.stage.application.config.keys;
      }
    }, {
      key: "overrideKeyMap",
      value: function overrideKeyMap(customKeyMap) {
        var keepDuplicates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var baseKeyMap = this.stage.application.config.keys;
        Object.keys(customKeyMap).reduce(function (keymapping, key) {
          if (!keepDuplicates) {
            Object.keys(baseKeyMap).forEach(function (baseKey) {
              if (baseKey != key && baseKeyMap[baseKey] == customKeyMap[key]) {
                delete keymapping[baseKey];
              }
            });
          }
          keymapping[key] = customKeyMap[key];
          return keymapping;
        }, baseKeyMap);
        return baseKeyMap;
      }
    }, {
      key: "_setup",
      value: function _setup() {
        var _this2 = this;
        Promise.all([this.loadFonts(App.config && App.config.fonts || App.getFonts && App.getFonts() || []), src_Locale.load(App.config && App.config.locale || App.getLocale && App.getLocale()), App.language && this.loadLanguage(App.language()), App.colors && this.loadColors(App.colors())]).then(function () {
          sdk_src_Metrics.app.loaded();
          _this2.w = _this2.config.stage.w / _this2.config.stage.precision;
          _this2.h = _this2.config.stage.h / _this2.config.stage.precision;
          AppData = appData;
          AppInstance = _this2.stage.c({
            ref: 'App',
            type: App,
            zIndex: 1,
            forceZIndexContext: !!platformSettings.showVersion || !!platformSettings.showFps
          });
          _this2.childList.a(AppInstance);
          _this2._refocus();
          Log.info('App version', _this2.config.version);
          Log.info('SDK version', package_namespaceObject.i8);
          if (platformSettings.showVersion) {
            _this2.childList.a({
              ref: 'VersionLabel',
              type: VersionLabel,
              version: _this2.config.version,
              sdkVersion: package_namespaceObject.i8,
              zIndex: 1
            });
          }
          if (platformSettings.showFps) {
            _this2.childList.a({
              ref: 'FpsCounter',
              type: FpsIndicator,
              zIndex: 1
            });
          }
          (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(Application.prototype), "_setup", _this2).call(_this2);
        }).catch(console.error);
      }
    }, {
      key: "_handleBack",
      value: function _handleBack() {
        this.closeApp();
      }
    }, {
      key: "_handleExit",
      value: function _handleExit() {
        this.closeApp();
      }
    }, {
      key: "closeApp",
      value: function closeApp() {
        Log.info('Signaling App Close');
        if (platformSettings.onClose && typeof platformSettings.onClose === 'function') {
          platformSettings.onClose.apply(platformSettings, arguments);
        } else {
          this.close();
        }
      }
    }, {
      key: "close",
      value: function close() {
        Log.info('Closing App');
        src_Settings.clearSubscribers();
        Registry.clear();
        this.childList.remove(this.tag('App'));
        this.cleanupFonts();
        this.stage.gc();
        this.destroy();
      }
    }, {
      key: "loadFonts",
      value: function loadFonts(fonts) {
        return platformSettings.fontLoader && typeof platformSettings.fontLoader === 'function' ? platformSettings.fontLoader(fonts, customFontFaces) : fontLoader(fonts, customFontFaces);
      }
    }, {
      key: "cleanupFonts",
      value: function cleanupFonts() {
        if ('delete' in document.fonts) {
          customFontFaces.forEach(function (fontFace) {
            Log.info('Removing font', fontFace.family);
            document.fonts.delete(fontFace);
          });
        } else {
          Log.info('No support for removing manually-added fonts');
        }
      }
    }, {
      key: "loadLanguage",
      value: function loadLanguage(config) {
        var file = src_Utils.asset('translations.json');
        var language = config;
        if ((0,esm_typeof/* default */.Z)(language) === 'object') {
          language = config.language || null;
          file = config.file || file;
        }
        return initLanguage(file, language);
      }
    }, {
      key: "loadColors",
      value: function loadColors(config) {
        var file = src_Utils.asset('colors.json');
        if (config && (typeof config === 'string' || (0,esm_typeof/* default */.Z)(config) === 'object')) {
          file = config;
        }
        return initColors(file);
      }
    }, {
      key: "focus",
      set: function set(v) {
        this._focussed = v;
        this._refocus();
      }
    }, {
      key: "_getFocused",
      value: function _getFocused() {
        return this._focussed || this.tag('App');
      }
    }], [{
      key: "_template",
      value: function _template() {
        return {
          w: 1920,
          h: 1080
        };
      }
    }]);
    return Application;
  }(src_Lightning.Application);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/AudioPlayer/index.js


var AudioPlayer = (0,createClass/* default */.Z)(function AudioPlayer() {
  (0,classCallCheck/* default */.Z)(this, AudioPlayer);
});

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Img/ScaledImageTexture.js







function ScaledImageTexture_createSuper(t) { var r = ScaledImageTexture_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function ScaledImageTexture_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (ScaledImageTexture_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var ScaledImageTexture_ScaledImageTexture = function (_Lightning$textures$I) {
  (0,inherits/* default */.Z)(ScaledImageTexture, _Lightning$textures$I);
  var _super = ScaledImageTexture_createSuper(ScaledImageTexture);
  function ScaledImageTexture(stage) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, ScaledImageTexture);
    _this = _super.call(this, stage);
    _this._scalingOptions = undefined;
    return _this;
  }
  (0,createClass/* default */.Z)(ScaledImageTexture, [{
    key: "options",
    set: function set(options) {
      this.resizeMode = this._scalingOptions = options;
    }
  }, {
    key: "_getLookupId",
    value: function _getLookupId() {
      return "".concat(this._src, "-").concat(this._scalingOptions.type, "-").concat(this._scalingOptions.w, "-").concat(this._scalingOptions.h);
    }
  }, {
    key: "getNonDefaults",
    value: function getNonDefaults() {
      var obj = (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(ScaledImageTexture.prototype), "getNonDefaults", this).call(this);
      if (this._src) {
        obj.src = this._src;
      }
      return obj;
    }
  }]);
  return ScaledImageTexture;
}(src_Lightning.textures.ImageTexture);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Img/index.js



function Img_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Img_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Img_ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Img_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



/* harmony default export */ const Img = (function (imageUrl, options) {
  var imageServerUrl = Settings.get('platform', 'imageServerUrl');
  var make = function make(options) {
    if (!/^(?:https?:)?\/\//i.test(imageUrl) && !imageUrl.includes('data:image/png;base64')) {
      imageUrl = Utils.asset(imageUrl);
    }
    if (imageServerUrl && imageUrl.indexOf(window.location.origin) === -1) {
      imageUrl = Utils.ensureUrlWithProtocol(imageServerUrl + '?' + Utils.makeQueryString(imageUrl, options));
    } else {
      if (options.type !== 'cover') {
        if (options.type === 'crop') options.type = 'cover';else options.type = 'contain';
      }
    }
    return {
      type: ScaledImageTexture,
      src: imageUrl,
      options: options
    };
  };
  var setOptions = function setOptions(options) {
    options = Img_objectSpread(Img_objectSpread({}, {
      type: 'contain',
      w: 0,
      h: 0
    }), options);
    var imageQuality = Math.max(0.1, Math.min(1, (parseFloat(Settings.get('platform', 'image.quality')) || 100) / 100));
    options.w = options.w * imageQuality;
    options.h = options.h * imageQuality;
    return options;
  };
  if (options) {
    return make(setOptions(options));
  }
  return {
    exact: function exact(w, h) {
      return make(setOptions({
        type: 'exact',
        w: w,
        h: h
      }));
    },
    landscape: function landscape(w) {
      return make(setOptions({
        type: 'landscape',
        w: w
      }));
    },
    portrait: function portrait(h) {
      return make(setOptions({
        type: 'portrait',
        h: h
      }));
    },
    cover: function cover(w, h) {
      return make(setOptions({
        type: 'cover',
        w: w,
        h: h
      }));
    },
    contain: function contain(w, h) {
      return make(setOptions({
        type: 'contain',
        w: w,
        h: h
      }));
    },
    original: function original() {
      return make(setOptions({
        type: 'contain'
      }));
    }
  };
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Keyboard/index.js
/* harmony default export */ const Keyboard = ({});
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.typed-array.int8-array.js
var es_typed_array_int8_array = __webpack_require__(66033);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/MediaPlayer/index.js



































function MediaPlayer_createSuper(t) { var r = MediaPlayer_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function MediaPlayer_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (MediaPlayer_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }




var MediaPlayer_events = ['timeupdate', 'error', 'ended', 'loadeddata', 'canplay', 'play', 'playing', 'pause', 'loadstart', 'seeking', 'seeked', 'encrypted'];
var MediaPlayer_mediaUrl = function mediaUrl(url) {
  return url;
};
var initMediaPlayer = function initMediaPlayer(config) {
  if (config.mediaUrl) {
    MediaPlayer_mediaUrl = config.mediaUrl;
  }
};
var Mediaplayer = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Mediaplayer, _Lightning$Component);
  var _super = MediaPlayer_createSuper(Mediaplayer);
  function Mediaplayer() {
    (0,classCallCheck/* default */.Z)(this, Mediaplayer);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Mediaplayer, [{
    key: "_construct",
    value: function _construct() {
      this._skipRenderToTexture = false;
      this._metrics = null;
      this._textureMode = src_Settings.get('platform', 'textureMode') || false;
      Log.info('Texture mode: ' + this._textureMode);
      console.warn(["The 'MediaPlayer'-plugin in the Lightning-SDK is deprecated and will be removed in future releases.", "Please consider using the new 'VideoPlayer'-plugin instead.", 'https://rdkcentral.github.io/Lightning-SDK/#/plugins/videoplayer'].join('\n\n'));
    }
  }, {
    key: "skipRenderToTexture",
    set: function set(v) {
      this._skipRenderToTexture = v;
    }
  }, {
    key: "textureMode",
    get: function get() {
      return this._textureMode;
    }
  }, {
    key: "videoView",
    get: function get() {
      return this.tag('Video');
    }
  }, {
    key: "_init",
    value: function _init() {
      var videoEls = document.getElementsByTagName('video');
      if (videoEls && videoEls.length > 0) this.videoEl = videoEls[0];else {
        this.videoEl = document.createElement('video');
        this.videoEl.setAttribute('id', 'video-player');
        this.videoEl.style.position = 'absolute';
        this.videoEl.style.zIndex = '1';
        this.videoEl.style.display = 'none';
        this.videoEl.setAttribute('width', '100%');
        this.videoEl.setAttribute('height', '100%');
        this.videoEl.style.visibility = this.textureMode ? 'hidden' : 'visible';
        document.body.appendChild(this.videoEl);
      }
      if (this.textureMode && !this._skipRenderToTexture) {
        this._createVideoTexture();
      }
      this.eventHandlers = [];
    }
  }, {
    key: "_registerListeners",
    value: function _registerListeners() {
      var _this = this;
      MediaPlayer_events.forEach(function (event) {
        var handler = function handler(e) {
          if (_this._metrics && _this._metrics[event] && typeof _this._metrics[event] === 'function') {
            _this._metrics[event]({
              currentTime: _this.videoEl.currentTime
            });
          }
          _this.fire(event, {
            videoElement: _this.videoEl,
            event: e
          });
        };
        _this.eventHandlers.push(handler);
        _this.videoEl.addEventListener(event, handler);
      });
    }
  }, {
    key: "_deregisterListeners",
    value: function _deregisterListeners() {
      var _this2 = this;
      Log.info('Deregistering event listeners MediaPlayer');
      MediaPlayer_events.forEach(function (event, index) {
        _this2.videoEl.removeEventListener(event, _this2.eventHandlers[index]);
      });
      this.eventHandlers = [];
    }
  }, {
    key: "_attach",
    value: function _attach() {
      this._registerListeners();
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this._deregisterListeners();
      this.close();
    }
  }, {
    key: "_createVideoTexture",
    value: function _createVideoTexture() {
      var stage = this.stage;
      var gl = stage.gl;
      var glTexture = gl.createTexture();
      gl.bindTexture(gl.TEXTURE_2D, glTexture);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      this.videoTexture.options = {
        source: glTexture,
        w: this.videoEl.width,
        h: this.videoEl.height
      };
    }
  }, {
    key: "_startUpdatingVideoTexture",
    value: function _startUpdatingVideoTexture() {
      var _this3 = this;
      if (this.textureMode && !this._skipRenderToTexture) {
        var stage = this.stage;
        if (!this._updateVideoTexture) {
          this._updateVideoTexture = function () {
            if (_this3.videoTexture.options.source && _this3.videoEl.videoWidth && _this3.active) {
              var gl = stage.gl;
              var currentTime = new Date().getTime();
              var frameCount = _this3.videoEl.webkitDecodedFrameCount;
              var mustUpdate = frameCount ? _this3._lastFrame !== frameCount : _this3._lastTime < currentTime - 30;
              if (mustUpdate) {
                _this3._lastTime = currentTime;
                _this3._lastFrame = frameCount;
                try {
                  gl.bindTexture(gl.TEXTURE_2D, _this3.videoTexture.options.source);
                  gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
                  gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, _this3.videoEl);
                  _this3._lastFrame = _this3.videoEl.webkitDecodedFrameCount;
                  _this3.videoTextureView.visible = true;
                  _this3.videoTexture.options.w = _this3.videoEl.videoWidth;
                  _this3.videoTexture.options.h = _this3.videoEl.videoHeight;
                  var expectedAspectRatio = _this3.videoTextureView.w / _this3.videoTextureView.h;
                  var realAspectRatio = _this3.videoEl.videoWidth / _this3.videoEl.videoHeight;
                  if (expectedAspectRatio > realAspectRatio) {
                    _this3.videoTextureView.scaleX = realAspectRatio / expectedAspectRatio;
                    _this3.videoTextureView.scaleY = 1;
                  } else {
                    _this3.videoTextureView.scaleY = expectedAspectRatio / realAspectRatio;
                    _this3.videoTextureView.scaleX = 1;
                  }
                } catch (e) {
                  Log.error('texImage2d video', e);
                  _this3._stopUpdatingVideoTexture();
                  _this3.videoTextureView.visible = false;
                }
                _this3.videoTexture.source.forceRenderUpdate();
              }
            }
          };
        }
        if (!this._updatingVideoTexture) {
          stage.on('frameStart', this._updateVideoTexture);
          this._updatingVideoTexture = true;
        }
      }
    }
  }, {
    key: "_stopUpdatingVideoTexture",
    value: function _stopUpdatingVideoTexture() {
      if (this.textureMode) {
        var stage = this.stage;
        stage.removeListener('frameStart', this._updateVideoTexture);
        this._updatingVideoTexture = false;
        this.videoTextureView.visible = false;
        if (this.videoTexture.options.source) {
          var gl = stage.gl;
          gl.bindTexture(gl.TEXTURE_2D, this.videoTexture.options.source);
          gl.clearColor(0, 0, 0, 1);
          gl.clear(gl.COLOR_BUFFER_BIT);
        }
      }
    }
  }, {
    key: "updateSettings",
    value: function updateSettings() {
      var _this4 = this;
      var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this._consumer = settings.consumer;
      if (this._consumer && this._consumer.getMediaplayerSettings) {
        settings = Object.assign(settings, this._consumer.getMediaplayerSettings());
      }
      if (!src_Lightning.Utils.equalValues(this._stream, settings.stream)) {
        if (settings.stream && settings.stream.keySystem) {
          navigator.requestMediaKeySystemAccess(settings.stream.keySystem.id, settings.stream.keySystem.config).then(function (keySystemAccess) {
            return keySystemAccess.createMediaKeys();
          }).then(function (createdMediaKeys) {
            return _this4.videoEl.setMediaKeys(createdMediaKeys);
          }).then(function () {
            if (settings.stream && settings.stream.src) _this4.open(settings.stream.src);
          }).catch(function () {
            console.error('Failed to set up MediaKeys');
          });
        } else if (settings.stream && settings.stream.src) {
          if (src_Settings.get('app', 'hls')) {
            if (!window.Hls) {
              window.Hls = function () {
                function Hls() {
                  (0,classCallCheck/* default */.Z)(this, Hls);
                }
                (0,createClass/* default */.Z)(Hls, null, [{
                  key: "isSupported",
                  value: function isSupported() {
                    console.warn('hls-light not included');
                    return false;
                  }
                }]);
                return Hls;
              }();
            }
            if (window.Hls.isSupported()) {
              if (!this._hls) this._hls = new window.Hls({
                liveDurationInfinity: true
              });
              this._hls.loadSource(settings.stream.src);
              this._hls.attachMedia(this.videoEl);
              this.videoEl.style.display = 'block';
            }
          } else {
            this.open(settings.stream.src);
          }
        } else {
          this.close();
        }
        this._stream = settings.stream;
      }
      this._setHide(settings.hide);
      this._setVideoArea(settings.videoPos);
    }
  }, {
    key: "_setHide",
    value: function _setHide(hide) {
      if (this.textureMode) {
        this.tag('Video').setSmooth('alpha', hide ? 0 : 1);
      } else {
        this.videoEl.style.visibility = hide ? 'hidden' : 'visible';
      }
    }
  }, {
    key: "open",
    value: function open(url) {
      var _this5 = this;
      var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        hide: false,
        videoPosition: null
      };
      url = MediaPlayer_mediaUrl(url);
      this._metrics = sdk_src_Metrics.media(url);
      Log.info('Playing stream', url);
      if (this.application.noVideo) {
        Log.info('noVideo option set, so ignoring: ' + url);
        return;
      }
      if (this.videoEl.getAttribute('src') === url) {
        this.close();
      }
      this.videoEl.setAttribute('src', url);
      this.videoEl.style.visibility = 'hidden';
      this.videoEl.style.display = 'none';
      setTimeout(function () {
        _this5.videoEl.style.display = 'block';
        _this5.videoEl.style.visibility = 'visible';
      });
      this._setHide(settings.hide);
      this._setVideoArea(settings.videoPosition || [0, 0, 1920, 1080]);
    }
  }, {
    key: "close",
    value: function close() {
      this.videoEl.pause();
      this.videoEl.removeAttribute('src');
      this.videoEl.load();
      this._clearSrc();
      this.videoEl.style.display = 'none';
    }
  }, {
    key: "playPause",
    value: function playPause() {
      if (this.isPlaying()) {
        this.doPause();
      } else {
        this.doPlay();
      }
    }
  }, {
    key: "muted",
    get: function get() {
      return this.videoEl.muted;
    },
    set: function set(v) {
      this.videoEl.muted = v;
    }
  }, {
    key: "loop",
    get: function get() {
      return this.videoEl.loop;
    },
    set: function set(v) {
      this.videoEl.loop = v;
    }
  }, {
    key: "isPlaying",
    value: function isPlaying() {
      return this._getState() === 'Playing';
    }
  }, {
    key: "doPlay",
    value: function doPlay() {
      this.videoEl.play();
    }
  }, {
    key: "doPause",
    value: function doPause() {
      this.videoEl.pause();
    }
  }, {
    key: "reload",
    value: function reload() {
      var url = this.videoEl.getAttribute('src');
      this.close();
      this.videoEl.src = url;
    }
  }, {
    key: "getPosition",
    value: function getPosition() {
      return Promise.resolve(this.videoEl.currentTime);
    }
  }, {
    key: "setPosition",
    value: function setPosition(pos) {
      this.videoEl.currentTime = pos;
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return Promise.resolve(this.videoEl.duration);
    }
  }, {
    key: "seek",
    value: function seek(time) {
      var absolute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (absolute) {
        this.videoEl.currentTime = time;
      } else {
        this.videoEl.currentTime += time;
      }
    }
  }, {
    key: "videoTextureView",
    get: function get() {
      return this.tag('Video').tag('VideoTexture');
    }
  }, {
    key: "videoTexture",
    get: function get() {
      return this.videoTextureView.texture;
    }
  }, {
    key: "_setVideoArea",
    value: function _setVideoArea(videoPos) {
      if (src_Lightning.Utils.equalValues(this._videoPos, videoPos)) {
        return;
      }
      this._videoPos = videoPos;
      if (this.textureMode) {
        this.videoTextureView.patch({
          smooth: {
            x: videoPos[0],
            y: videoPos[1],
            w: videoPos[2] - videoPos[0],
            h: videoPos[3] - videoPos[1]
          }
        });
      } else {
        var precision = this.stage.getRenderPrecision();
        this.videoEl.style.left = Math.round(videoPos[0] * precision) + 'px';
        this.videoEl.style.top = Math.round(videoPos[1] * precision) + 'px';
        this.videoEl.style.width = Math.round((videoPos[2] - videoPos[0]) * precision) + 'px';
        this.videoEl.style.height = Math.round((videoPos[3] - videoPos[1]) * precision) + 'px';
      }
    }
  }, {
    key: "_fireConsumer",
    value: function _fireConsumer(event, args) {
      if (this._consumer) {
        this._consumer.fire(event, args);
      }
    }
  }, {
    key: "_equalInitData",
    value: function _equalInitData(buf1, buf2) {
      if (!buf1 || !buf2) return false;
      if (buf1.byteLength != buf2.byteLength) return false;
      var dv1 = new Int8Array(buf1);
      var dv2 = new Int8Array(buf2);
      for (var i = 0; i != buf1.byteLength; i++) if (dv1[i] != dv2[i]) return false;
      return true;
    }
  }, {
    key: "error",
    value: function error(args) {
      this._fireConsumer('$mediaplayerError', args);
      this._setState('');
      return '';
    }
  }, {
    key: "loadeddata",
    value: function loadeddata(args) {
      this._fireConsumer('$mediaplayerLoadedData', args);
    }
  }, {
    key: "play",
    value: function play(args) {
      this._fireConsumer('$mediaplayerPlay', args);
    }
  }, {
    key: "playing",
    value: function playing(args) {
      this._fireConsumer('$mediaplayerPlaying', args);
      this._setState('Playing');
    }
  }, {
    key: "canplay",
    value: function canplay(args) {
      this.videoEl.play();
      this._fireConsumer('$mediaplayerStart', args);
    }
  }, {
    key: "loadstart",
    value: function loadstart(args) {
      this._fireConsumer('$mediaplayerLoad', args);
    }
  }, {
    key: "seeked",
    value: function seeked() {
      this._fireConsumer('$mediaplayerSeeked', {
        currentTime: this.videoEl.currentTime,
        duration: this.videoEl.duration || 1
      });
    }
  }, {
    key: "seeking",
    value: function seeking() {
      this._fireConsumer('$mediaplayerSeeking', {
        currentTime: this.videoEl.currentTime,
        duration: this.videoEl.duration || 1
      });
    }
  }, {
    key: "durationchange",
    value: function durationchange(args) {
      this._fireConsumer('$mediaplayerDurationChange', args);
    }
  }, {
    key: "encrypted",
    value: function encrypted(args) {
      var video = args.videoElement;
      var event = args.event;
      if (video.mediaKeys && !this._equalInitData(this._previousInitData, event.initData)) {
        this._previousInitData = event.initData;
        this._fireConsumer('$mediaplayerEncrypted', args);
      }
    }
  }], [{
    key: "_template",
    value: function _template() {
      return {
        Video: {
          VideoWrap: {
            VideoTexture: {
              visible: false,
              pivot: 0.5,
              texture: {
                type: src_Lightning.textures.StaticTexture,
                options: {}
              }
            }
          }
        }
      };
    }
  }, {
    key: "_states",
    value: function _states() {
      return [function (_this6) {
        (0,inherits/* default */.Z)(Playing, _this6);
        var _super2 = MediaPlayer_createSuper(Playing);
        function Playing() {
          (0,classCallCheck/* default */.Z)(this, Playing);
          return _super2.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(Playing, [{
          key: "$enter",
          value: function $enter() {
            this._startUpdatingVideoTexture();
          }
        }, {
          key: "$exit",
          value: function $exit() {
            this._stopUpdatingVideoTexture();
          }
        }, {
          key: "timeupdate",
          value: function timeupdate() {
            this._fireConsumer('$mediaplayerProgress', {
              currentTime: this.videoEl.currentTime,
              duration: this.videoEl.duration || 1
            });
          }
        }, {
          key: "ended",
          value: function ended(args) {
            this._fireConsumer('$mediaplayerEnded', args);
            this._setState('');
          }
        }, {
          key: "pause",
          value: function pause(args) {
            this._fireConsumer('$mediaplayerPause', args);
            this._setState('Playing.Paused');
          }
        }, {
          key: "_clearSrc",
          value: function _clearSrc() {
            this._fireConsumer('$mediaplayerStop', {});
            this._setState('');
          }
        }], [{
          key: "_states",
          value: function _states() {
            return [function (_this7) {
              (0,inherits/* default */.Z)(Paused, _this7);
              var _super3 = MediaPlayer_createSuper(Paused);
              function Paused() {
                (0,classCallCheck/* default */.Z)(this, Paused);
                return _super3.apply(this, arguments);
              }
              return (0,createClass/* default */.Z)(Paused);
            }(this)];
          }
        }]);
        return Playing;
      }(this)];
    }
  }]);
  return Mediaplayer;
}(src_Lightning.Component);

;// CONCATENATED MODULE: ./node_modules/.pnpm/localcookies@2.0.0/node_modules/localcookies/module/localCookie.js












var localCookie = function () {
  function localCookie(e) {
    (0,classCallCheck/* default */.Z)(this, localCookie);
    return e = e || {}, this.forceCookies = e.forceCookies || !1, !0 === this._checkIfLocalStorageWorks() && !0 !== e.forceCookies ? {
      getItem: this._getItemLocalStorage,
      setItem: this._setItemLocalStorage,
      removeItem: this._removeItemLocalStorage,
      clear: this._clearLocalStorage,
      keys: this._getLocalStorageKeys
    } : {
      getItem: this._getItemCookie,
      setItem: this._setItemCookie,
      removeItem: this._removeItemCookie,
      clear: this._clearCookies,
      keys: this._getCookieKeys
    };
  }
  (0,createClass/* default */.Z)(localCookie, [{
    key: "_checkIfLocalStorageWorks",
    value: function _checkIfLocalStorageWorks() {
      if ("undefined" == typeof localStorage) return !1;
      try {
        return localStorage.setItem("feature_test", "yes"), "yes" === localStorage.getItem("feature_test") && (localStorage.removeItem("feature_test"), !0);
      } catch (e) {
        return !1;
      }
    }
  }, {
    key: "_getItemLocalStorage",
    value: function _getItemLocalStorage(e) {
      return window.localStorage.getItem(e);
    }
  }, {
    key: "_setItemLocalStorage",
    value: function _setItemLocalStorage(e, t) {
      return window.localStorage.setItem(e, t);
    }
  }, {
    key: "_removeItemLocalStorage",
    value: function _removeItemLocalStorage(e) {
      return window.localStorage.removeItem(e);
    }
  }, {
    key: "_clearLocalStorage",
    value: function _clearLocalStorage() {
      return window.localStorage.clear();
    }
  }, {
    key: "_getLocalStorageKeys",
    value: function _getLocalStorageKeys() {
      return Object.keys(window.localStorage);
    }
  }, {
    key: "_getItemCookie",
    value: function _getItemCookie(e) {
      var t = document.cookie.match(RegExp("(?:^|;\\s*)" + function (e) {
        return e.replace(/([.*+?\^${}()|\[\]\/\\])/g, "\\$1");
      }(e) + "=([^;]*)"));
      return t && "" === t[1] && (t[1] = null), t ? t[1] : null;
    }
  }, {
    key: "_setItemCookie",
    value: function _setItemCookie(e, t) {
      var o = new Date(),
        r = new Date(o.getTime() + 15768e7);
      document.cookie = "".concat(e, "=").concat(t, "; expires=").concat(r.toUTCString(), ";");
    }
  }, {
    key: "_removeItemCookie",
    value: function _removeItemCookie(e) {
      document.cookie = "".concat(e, "=;Max-Age=-99999999;");
    }
  }, {
    key: "_clearCookies",
    value: function _clearCookies() {
      document.cookie.split(";").forEach(function (e) {
        document.cookie = e.replace(/^ +/, "").replace(/=.*/, "=;expires=Max-Age=-99999999");
      });
    }
  }, {
    key: "_getCookieKeys",
    value: function _getCookieKeys() {
      return document.cookie.split(";").map(function (e) {
        return e.split("=")[0];
      });
    }
  }]);
  return localCookie;
}();
/* harmony default export */ const module_localCookie = (localCookie);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Storage/index.js







var namespace;
var lc;
var initStorage = function initStorage() {
  namespace = src_Settings.get('platform', 'id');
  lc = new module_localCookie();
};
var namespacedKey = function namespacedKey(key) {
  return namespace ? [namespace, key].join('.') : key;
};
/* harmony default export */ const Storage = ({
  get: function get(key) {
    try {
      return JSON.parse(lc.getItem(namespacedKey(key)));
    } catch (e) {
      return null;
    }
  },
  set: function set(key, value) {
    try {
      lc.setItem(namespacedKey(key), JSON.stringify(value));
      return true;
    } catch (e) {
      return false;
    }
  },
  remove: function remove(key) {
    lc.removeItem(namespacedKey(key));
  },
  clear: function clear() {
    if (namespace) {
      lc.keys().forEach(function (key) {
        key.indexOf(namespace + '.') === 0 ? lc.removeItem(key) : null;
      });
    } else {
      lc.clear();
    }
  }
});
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(52318);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(11256);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Router/utils/regex.js


var hasRegex = /\{\/(.*?)\/([igm]{0,3})\}/g;
var isWildcard = /^[!*$]$/;
var hasLookupId = /\/:\w+?@@([0-9]+?)@@/;
var isNamedGroup = /^\/:/;
var stripRegex = function stripRegex(route) {
  var char = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'R';
  if (hasRegex.test(route)) {
    route = route.replace(hasRegex, char);
  }
  return route;
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Router/utils/register.js










var createRegister = function createRegister(flags) {
  var reg = new Map();
  [].concat((0,toConsumableArray/* default */.Z)(Object.keys(flags)), (0,toConsumableArray/* default */.Z)(Object.getOwnPropertySymbols(flags))).forEach(function (key) {
    reg.set(key, flags[key]);
  });
  return reg;
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Router/model/Request.js










var Request = function () {
  function Request() {
    var hash = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var navArgs = arguments.length > 1 ? arguments[1] : undefined;
    var storeCaller = arguments.length > 2 ? arguments[2] : undefined;
    (0,classCallCheck/* default */.Z)(this, Request);
    this._hash = hash;
    this._storeCaller = storeCaller;
    this._register = new Map();
    this._isCreated = false;
    this._isSharedInstance = false;
    this._cancelled = false;
    this._copiedHistoryState = null;
    if (helpers_isObject(navArgs)) {
      this._register = createRegister(navArgs);
    } else if (isBoolean(navArgs)) {
      this._storeCaller = navArgs;
    }
    this._register.set(symbols.store, this._storeCaller);
  }
  (0,createClass/* default */.Z)(Request, [{
    key: "cancel",
    value: function cancel() {
      Log.debug('[router]:', "cancelled ".concat(this._hash));
      this._cancelled = true;
    }
  }, {
    key: "url",
    get: function get() {
      return this._hash;
    }
  }, {
    key: "register",
    get: function get() {
      return this._register;
    }
  }, {
    key: "hash",
    get: function get() {
      return this._hash;
    },
    set: function set(args) {
      this._hash = args;
    }
  }, {
    key: "route",
    get: function get() {
      return this._route;
    },
    set: function set(args) {
      this._route = args;
    }
  }, {
    key: "provider",
    get: function get() {
      return this._provider;
    },
    set: function set(args) {
      this._provider = args;
    }
  }, {
    key: "providerType",
    get: function get() {
      return this._providerType;
    },
    set: function set(args) {
      this._providerType = args;
    }
  }, {
    key: "page",
    get: function get() {
      return this._page;
    },
    set: function set(args) {
      this._page = args;
    }
  }, {
    key: "isCreated",
    get: function get() {
      return this._isCreated;
    },
    set: function set(args) {
      this._isCreated = args;
    }
  }, {
    key: "isSharedInstance",
    get: function get() {
      return this._isSharedInstance;
    },
    set: function set(args) {
      this._isSharedInstance = args;
    }
  }, {
    key: "isCancelled",
    get: function get() {
      return this._cancelled;
    }
  }, {
    key: "copiedHistoryState",
    get: function get() {
      return this._copiedHistoryState;
    },
    set: function set(v) {
      this._copiedHistoryState = v;
    }
  }]);
  return Request;
}();

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Router/model/Route.js





var Route = function () {
  function Route() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0,classCallCheck/* default */.Z)(this, Route);
    var type = ['on', 'before', 'after'].reduce(function (acc, type) {
      return helpers_isFunction(config[type]) ? type : acc;
    }, undefined);
    this._cfg = config;
    if (type) {
      this._provider = {
        type: type,
        request: config[type]
      };
    }
  }
  (0,createClass/* default */.Z)(Route, [{
    key: "path",
    get: function get() {
      return this._cfg.path;
    }
  }, {
    key: "name",
    get: function get() {
      return this._cfg.name;
    }
  }, {
    key: "component",
    get: function get() {
      return this._cfg.component;
    }
  }, {
    key: "options",
    get: function get() {
      return this._cfg.options;
    }
  }, {
    key: "widgets",
    get: function get() {
      return this._cfg.widgets;
    }
  }, {
    key: "cache",
    get: function get() {
      return this._cfg.cache;
    }
  }, {
    key: "hook",
    get: function get() {
      return this._cfg.hook;
    }
  }, {
    key: "beforeNavigate",
    get: function get() {
      return this._cfg.beforeNavigate;
    }
  }, {
    key: "provider",
    get: function get() {
      return this._provider;
    }
  }]);
  return Route;
}();

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Router/utils/route.js



















function route_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function route_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? route_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : route_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function route_createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = route_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function route_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return route_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? route_arrayLikeToArray(r, a) : void 0; } }
function route_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }





var getFloor = function getFloor(route) {
  return stripRegex(route).split('/').length;
};
var getRoutesByFloor = function getRoutesByFloor(floor) {
  var matches = [];
  var _iterator = route_createForOfIteratorHelper(routes.entries()),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = (0,slicedToArray/* default */.Z)(_step.value, 1),
        route = _step$value[0];
      if (getFloor(route) === floor) {
        matches.push(route);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return matches;
};
var getRouteByHash = function getRouteByHash(hash) {
  hash = hash.replace(/^#/, '');
  var getUrlParts = /(\/?:?[^/]+)/g;
  var candidates = getRoutesByFloor(getFloor(hash));
  var hashParts = hash.match(getUrlParts) || [];
  var regexStore = [];
  var matches = candidates.filter(function (route) {
    var isMatching = true;
    if (hasRegex.test(route)) {
      var regMatches = route.match(hasRegex);
      if (regMatches && regMatches.length) {
        route = regMatches.reduce(function (fullRoute, regex) {
          var lookupId = regexStore.length;
          fullRoute = fullRoute.replace(regex, "@@".concat(lookupId, "@@"));
          regexStore.push(regex.substring(1, regex.length - 1));
          return fullRoute;
        }, route);
      }
    }
    var routeParts = route.match(getUrlParts) || [];
    for (var i = 0, j = routeParts.length; i < j; i++) {
      var routePart = routeParts[i];
      var hashPart = hashParts[i];
      if (hasLookupId.test(routePart)) {
        var routeMatches = hasLookupId.exec(routePart);
        var storeId = routeMatches[1];
        var routeRegex = regexStore[storeId];
        var _regMatches = /\/([^\/]+)\/([igm]{0,3})/.exec(routeRegex);
        if (_regMatches && _regMatches.length) {
          var expression = _regMatches[1];
          var modifiers = _regMatches[2];
          var regex = new RegExp("^/".concat(expression, "$"), modifiers);
          if (!regex.test(hashPart)) {
            isMatching = false;
          }
        }
      } else if (isNamedGroup.test(routePart)) {
        continue;
      } else if (hashPart && routePart.toLowerCase() !== hashPart.toLowerCase()) {
        isMatching = false;
      }
    }
    return isMatching;
  });
  if (matches.length) {
    if (matches.indexOf(hash) !== -1) {
      var match = matches[matches.indexOf(hash)];
      return routes.get(match);
    } else {
      matches = matches.sort(function (a) {
        return isNamedGroup.test(a) ? -1 : 1;
      });
      if (routeExists(matches[0])) {
        return routes.get(matches[0]);
      }
    }
  }
  return false;
};
var getValuesFromHash = function getValuesFromHash() {
  var hash = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var path = arguments.length > 1 ? arguments[1] : undefined;
  path = stripRegex(path, '');
  var getUrlParts = /(\/?:?[\w%\s:.-]+)/g;
  var hashParts = hash.match(getUrlParts) || [];
  var routeParts = path.match(getUrlParts) || [];
  var getNamedGroup = /^\/:([\w-]+)\/?/;
  return routeParts.reduce(function (storage, value, index) {
    var match = getNamedGroup.exec(value);
    if (match && match.length) {
      storage.set(match[1], decodeURIComponent(hashParts[index].replace(/^\//, '')));
    }
    return storage;
  }, new Map());
};
var getOption = function getOption(stack, prop) {
  if (stack && stack.hasOwnProperty(prop)) {
    return stack[prop];
  }
};
var createRoute = function createRoute(config) {
  if (config.path === '$') {
    var options = {
      preventStorage: true
    };
    if (helpers_isObject(config.options)) {
      options = route_objectSpread(route_objectSpread({}, config.options), options);
    }
    config.options = options;
    if (bootRequest) {
      config.after = bootRequest;
    }
  }
  return new Route(config);
};
var createRequest = function createRequest(url, args, store) {
  return new Request(url, args, store);
};
var getHashByName = function getHashByName(obj) {
  if (!obj.to && !obj.name) {
    return false;
  }
  var route = getRouteByName(obj.to || obj.name);
  var hasDynamicGroup = /\/:([\w-]+)\/?/;
  var hash = route;
  if (hasDynamicGroup.test(route)) {
    if (obj.params) {
      var keys = Object.keys(obj.params);
      hash = keys.reduce(function (acc, key) {
        return acc.replace(":".concat(key), obj.params[key]);
      }, route);
    }
    if (obj.query) {
      return "".concat(hash).concat(objectToQueryString(obj.query));
    }
  }
  return hash;
};
var getRouteByName = function getRouteByName(name) {
  var _iterator2 = route_createForOfIteratorHelper(routes.entries()),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _step2$value = (0,slicedToArray/* default */.Z)(_step2.value, 2),
        path = _step2$value[0],
        route = _step2$value[1];
      if (route.name === name) {
        return path;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return false;
};
var keepActivePageAlive = function keepActivePageAlive(route, request) {
  if (helpers_isString(route)) {
    var _routes = getRoutes();
    if (_routes.has(route)) {
      route = _routes.get(route);
    } else {
      return false;
    }
  }
  var register = request.register;
  var routeOptions = route.options;
  if (register.has('keepAlive')) {
    return register.get('keepAlive');
  } else if (routeOptions && routeOptions.keepAlive) {
    return routeOptions.keepAlive;
  }
  return false;
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Router/utils/emit.js


/* harmony default export */ const utils_emit = (function (page) {
  var events = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!isArray(events)) {
    events = [events];
  }
  events.forEach(function (e) {
    var event = "_on".concat(ucfirst(e));
    if (helpers_isFunction(page[event])) {
      page[event](params);
    }
  });
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Router/utils/widgets.js






var activeWidget = null;
var getReferences = function getReferences() {
  if (!widgetsHost) {
    return;
  }
  return widgetsHost.get().reduce(function (storage, widget) {
    var key = widget.ref.toLowerCase();
    storage[key] = widget;
    return storage;
  }, {});
};
var updateWidgets = function updateWidgets(widgets, page) {
  var configured = (widgets || []).map(function (ref) {
    return ref.toLowerCase();
  });
  widgetsHost.forEach(function (widget) {
    widget.visible = configured.indexOf(widget.ref.toLowerCase()) !== -1;
    if (widget.visible) {
      utils_emit(widget, ['activated'], page);
    }
  });
  if (app.state === 'Widgets' && activeWidget && !activeWidget.visible) {
    app._setState('');
  }
};
var getWidgetByName = function getWidgetByName(name) {
  name = ucfirst(name);
  return widgetsHost.getByRef(name) || false;
};
var focusWidget = function focusWidget(name) {
  var widget = getWidgetByName(name);
  if (widget) {
    setActiveWidget(widget);
    if (app.state === 'Widgets') {
      app.reload(activeWidget);
    } else {
      app._setState('Widgets', [activeWidget]);
    }
  }
};
var handleRemote = function handleRemote(type, name) {
  if (type === 'widget') {
    focusWidget(name);
  } else if (type === 'page') {
    restoreFocus();
  }
};
var restoreFocus = function restoreFocus() {
  activeWidget = null;
  app._setState('');
};
var getActiveWidget = function getActiveWidget() {
  return activeWidget;
};
var setActiveWidget = function setActiveWidget(instance) {
  activeWidget = instance;
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Router/utils/components.js

var createComponent = function createComponent(stage, type) {
  return stage.c({
    type: type,
    visible: false,
    widgets: getReferences()
  });
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Router/utils/history.js








var history_history = [];
var updateHistory = function updateHistory(request) {
  var hash = getActiveHash();
  if (!hash) {
    return;
  }
  var register = request.register;
  var forceNavigateStore = register.get(symbols.store);
  var activeRoute = getRouteByHash(hash);
  var preventStorage = getOption(activeRoute.options, 'preventStorage');
  var store = isBoolean(forceNavigateStore) ? forceNavigateStore : !preventStorage;
  if (store) {
    var toStore = hash.replace(/^\//, '');
    var location = locationInHistory(toStore);
    var stateObject = getStateObject(router_getActivePage(), request);
    var routerConfig = getRouterConfig();
    if (location === -1 || routerConfig.get('storeSameHash')) {
      history_history.push({
        hash: toStore,
        state: stateObject
      });
    } else {
      var prev = history_history.splice(location, 1)[0];
      history_history.push({
        hash: prev.hash,
        state: stateObject
      });
    }
  }
};
var locationInHistory = function locationInHistory(hash) {
  for (var i = 0; i < history_history.length; i++) {
    if (history_history[i].hash === hash) {
      return i;
    }
  }
  return -1;
};
var getHistoryState = function getHistoryState(hash) {
  var state = null;
  if (history_history.length) {
    if (!hash) {
      var record = history_history[history_history.length - 1];
      state = record.state;
    } else {
      if (locationInHistory(hash) !== -1) {
        var _record = history_history[locationInHistory(hash)];
        state = _record.state;
      }
    }
  }
  return state;
};
var replaceHistoryState = function replaceHistoryState() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var hash = arguments.length > 1 ? arguments[1] : undefined;
  if (!history_history.length) {
    return;
  }
  var location = hash ? locationInHistory(hash) : history_history.length - 1;
  if (location !== -1 && helpers_isObject(state)) {
    history_history[location].state = state;
  }
};
var getStateObject = function getStateObject(page, request) {
  if (request.isSharedInstance) {
    if (request.copiedHistoryState) {
      return request.copiedHistoryState;
    }
  } else if (page && helpers_isFunction(page.historyState)) {
    return page.historyState();
  }
  return null;
};
var getHistory = function getHistory() {
  return history_history.slice(0);
};
var setHistory = function setHistory() {
  var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  if (isArray(arr)) {
    history_history = arr;
  }
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Router/utils/router.js









function router_createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = router_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function router_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return router_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? router_arrayLikeToArray(r, a) : void 0; } }
function router_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function router_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function router_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? router_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : router_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }











var application;
var app;
var pagesHost;
var stage;
var routerConfig;
var widgetsHost;
var rootHash;
var bootRequest;
var updateHash = true;
var beforeEachRoute = function () {
  var _ref = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(from, to) {
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", true);
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function beforeEachRoute(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var afterEachRoute = function afterEachRoute() {};
var routes = new Map();
var components = new Map();
var initialised = false;
var activePage = null;
var activeHash;
var activeRoute;
var lastAcceptedHash;
var previousState;
var mixin = function mixin(app) {
  if (app.pages) {
    pagesHost = app.pages.childList;
  }
  if (app.widgets && app.widgets.children) {
    widgetsHost = app.widgets.childList;
    widgetsHost.forEach(function (w) {
      return w.visible = false;
    });
  }
  app._handleBack = function (e) {
    step(-1);
    e.preventDefault();
  };
};
var bootRouter = function bootRouter(config, instance) {
  var appInstance = config.appInstance,
    routes = config.routes;
  if (instance && isPage(instance)) {
    app = instance;
  }
  if (!app) {
    app = appInstance || AppInstance;
  }
  application = app.application;
  pagesHost = application.childList;
  stage = app.stage;
  routerConfig = getConfigMap();
  mixin(app);
  if (isArray(routes)) {
    setup(config);
  } else if (helpers_isFunction(routes)) {
    console.warn('[Router]: Calling Router.route() directly is deprecated.');
    console.warn('Use object config: https://rdkcentral.github.io/Lightning-SDK/#/plugins/router/configuration');
  }
};
var setup = function setup(config) {
  if (!initialised) {
    init(config);
  }
  config.routes.forEach(function (r) {
    var path = cleanHash(r.path);
    if (!routeExists(path)) {
      var route = createRoute(r);
      routes.set(path, route);
      if (route.component) {
        var type = route.component;
        if (isComponentConstructor(type)) {
          if (!routerConfig.get('lazyCreate')) {
            type = createComponent(stage, type);
            pagesHost.a(type);
          }
        }
        components.set(path, type);
      }
    } else {
      console.error("".concat(path, " already exists in routes configuration"));
    }
  });
};
var init = function init(config) {
  rootHash = config.root;
  if (helpers_isFunction(config.boot)) {
    bootRequest = config.boot;
  }
  if (isBoolean(config.updateHash)) {
    updateHash = config.updateHash;
  }
  if (helpers_isFunction(config.beforeEachRoute)) {
    beforeEachRoute = config.beforeEachRoute;
  }
  if (helpers_isFunction(config.afterEachRoute)) {
    afterEachRoute = config.afterEachRoute;
  }
  if (config.bootComponent) {
    console.warn('[Router]: Boot Component is now available as a special router: https://rdkcentral.github.io/Lightning-SDK/#/plugins/router/configuration?id=special-routes');
    console.warn('[Router]: setting { bootComponent } property will be deprecated in a future release');
    if (isPage(config.bootComponent)) {
      config.routes.push({
        path: '$',
        component: config.bootComponent,
        after: bootRequest || null,
        options: {
          preventStorage: true
        }
      });
    } else {
      console.error("[Router]: ".concat(config.bootComponent, " is not a valid boot component"));
    }
  }
  config.routes.forEach(function (item) {
    var strippedPath = stripRegex(item.path);
    var pattern = /(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*\/:(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\?$/;
    if (pattern.test(strippedPath)) {
      var optionalPath = item.path.substring(0, item.path.lastIndexOf('/'));
      var originalPath = item.path.substring(0, item.path.lastIndexOf('?'));
      item.path = originalPath;
      var optionalItem = router_objectSpread({}, item);
      optionalItem.path = optionalPath;
      config.routes.push(optionalItem);
    }
  });
  initialised = true;
};
var storeComponent = function storeComponent(route, type) {
  if (components.has(route)) {
    components.set(route, type);
  }
};
var getComponent = function getComponent(route) {
  if (components.has(route)) {
    return components.get(route);
  }
  return null;
};
var deleteCurrentInstance = function deleteCurrentInstance(route) {
  if (components.has(route) && pagesHost.getIndex(components.get(route)) !== -1) {
    pagesHost.remove(components.get(route));
    storeComponent(route, components.get(route)._routedType || components.get(route).constructor);
  }
};
var mustUpdateLocationHash = function mustUpdateLocationHash() {
  if (!routerConfig || !routerConfig.size) {
    return false;
  }
  var updateConfig = routerConfig.get('updateHash');
  return !(isBoolean(updateConfig) && !updateConfig || isBoolean(updateHash) && !updateHash);
};
var onRequestResolved = function onRequestResolved(request) {
  var hash = request.hash;
  var route = request.route;
  var register = request.register;
  var page = request.page;
  if (getOption(route.options, 'clearHistory')) {
    setHistory([]);
  } else if (hash && !isWildcard.test(route.path)) {
    updateHistory(request);
  }
  storeComponent(route.path, page);
  if (request.isSharedInstance || !request.isCreated) {
    utils_emit(page, 'changed');
  } else if (request.isCreated) {
    utils_emit(page, 'mounted');
  }
  if (widgetsHost) {
    updateWidgets(route.widgets, page);
  }
  if (router_getActivePage() && !request.isSharedInstance) {
    cleanUp(activePage, request);
  }
  if (register.get(symbols.historyState) && helpers_isFunction(page.historyState)) {
    page.historyState(register.get(symbols.historyState));
  }
  setActivePage(page);
  activeHash = request.hash;
  activeRoute = route.path;
  var _iterator = router_createForOfIteratorHelper(navigateQueue.values()),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _request = _step.value;
      if (_request.isCancelled && _request.hash) {
        navigateQueue.delete(_request.hash);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  afterEachRoute(request);
  Log.info('[route]:', route.path);
  Log.info('[hash]:', hash);
};
var cleanUp = function cleanUp(page, request) {
  var route = activeRoute;
  var register = request.register;
  var lazyDestroy = routerConfig.get('lazyDestroy');
  var destroyOnBack = routerConfig.get('destroyOnHistoryBack');
  var keepAlive = register.get('keepAlive');
  var isFromHistory = register.get(symbols.backtrack);
  var doCleanup = false;
  if (isFromHistory && (destroyOnBack || lazyDestroy)) {
    doCleanup = true;
  }
  if (lazyDestroy && !keepAlive) {
    doCleanup = true;
  }
  if (activeRoute === request.route.path) {
    doCleanup = true;
  }
  if (doCleanup) {
    storeComponent(route, page._routedType || page.constructor);
    pagesHost.remove(page);
    if (routerConfig.get('gcOnUnload')) {
      stage.gc();
    }
  } else {
    page.patch({
      x: 0,
      y: 0,
      scale: 1,
      visible: false,
      alpha: 1
    });
  }
};
var getActiveHash = function getActiveHash() {
  return activeHash;
};
var setActiveHash = function setActiveHash(hash) {
  activeHash = hash;
};
var setActivePage = function setActivePage(page) {
  activePage = page;
};
var router_getActivePage = function getActivePage() {
  return activePage;
};
var getActiveRoute = function getActiveRoute() {
  return activeRoute;
};
var getLastHash = function getLastHash() {
  return lastAcceptedHash;
};
var setLastHash = function setLastHash(hash) {
  lastAcceptedHash = hash;
};
var setPreviousState = function setPreviousState(state) {
  previousState = state;
};
var getPreviousState = function getPreviousState() {
  return previousState;
};
var routeExists = function routeExists(key) {
  return routes.has(key);
};
var getRootHash = function getRootHash() {
  return rootHash;
};
var getBootRequest = function getBootRequest() {
  return bootRequest;
};
var getRouterConfig = function getRouterConfig() {
  return routerConfig;
};
var getRoutes = function getRoutes() {
  return routes;
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Router/utils/helpers.js




















function helpers_createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = helpers_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function helpers_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return helpers_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? helpers_arrayLikeToArray(r, a) : void 0; } }
function helpers_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }




var helpers_isFunction = function isFunction(v) {
  return typeof v === 'function';
};
var helpers_isObject = function isObject(v) {
  return (0,esm_typeof/* default */.Z)(v) === 'object' && v !== null;
};
var isBoolean = function isBoolean(v) {
  return typeof v === 'boolean';
};
var isPage = function isPage(v) {
  if (v instanceof src_Lightning.Element || isComponentConstructor(v)) {
    return true;
  }
  return false;
};
var isComponentConstructor = function isComponentConstructor(type) {
  return type.prototype && 'isComponent' in type.prototype;
};
var isArray = function isArray(v) {
  return Array.isArray(v);
};
var ucfirst = function ucfirst(v) {
  return "".concat(v.charAt(0).toUpperCase()).concat(v.slice(1));
};
var helpers_isString = function isString(v) {
  return typeof v === 'string';
};
var isPromise = function isPromise(method) {
  var result;
  if (helpers_isFunction(method)) {
    try {
      result = method.apply(null);
    } catch (e) {
      result = e;
    }
  } else {
    result = method;
  }
  return helpers_isObject(result) && helpers_isFunction(result.then);
};
var cleanHash = function cleanHash() {
  var hash = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return hash.replace(/^#/, '').replace(/\/+$/, '');
};
var getConfigMap = function getConfigMap() {
  var routerSettings = src_Settings.get('platform', 'router');
  var isObj = helpers_isObject(routerSettings);
  return ['backtrack', 'gcOnUnload', 'destroyOnHistoryBack', 'lazyCreate', 'lazyDestroy', 'reuseInstance', 'autoRestoreRemote', 'numberNavigation', 'updateHash', 'storeSameHash'].reduce(function (config, key) {
    config.set(key, isObj ? routerSettings[key] : src_Settings.get('platform', key));
    return config;
  }, new Map());
};
var incorrectParams = function incorrectParams(cb, route) {
  var isIncorrect = /^\w*?\s?\(\s?\{.*?\}\s?\)/i;
  if (isIncorrect.test(cb.toString())) {
    console.warn(["DEPRECATION: The data-provider for route: ".concat(route, " is not correct."), '"page" is no longer a property of the params object but is now the first function parameter: ', 'https://github.com/rdkcentral/Lightning-SDK/blob/feature/router/docs/plugins/router/dataproviding.md#data-providing', "It's supported for now but will be removed in a future release."].join('\n'));
    return true;
  }
  return false;
};
var getQueryStringParams = function getQueryStringParams() {
  var hash = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getActiveHash();
  var resumeHash = getResumeHash();
  if ((hash === '$' || !hash) && resumeHash) {
    if (helpers_isString(resumeHash)) {
      hash = resumeHash;
    }
  }
  var parse = '';
  var getQuery = /([?&].*)/;
  var matches = getQuery.exec(hash);
  var params = {};
  if (document.location && document.location.search) {
    parse = document.location.search;
  }
  if (matches && matches.length) {
    var hashParams = matches[1];
    if (parse) {
      hashParams = hashParams.replace(/^\?/, '');
      parse = "".concat(parse, "&").concat(hashParams);
    } else {
      parse = hashParams;
    }
  }
  if (parse) {
    var urlParams = new URLSearchParams(parse);
    var _iterator = helpers_createForOfIteratorHelper(urlParams.entries()),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = (0,slicedToArray/* default */.Z)(_step.value, 2),
          key = _step$value[0],
          value = _step$value[1];
        params[key] = value;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return params;
  } else {
    return false;
  }
};
var objectToQueryString = function objectToQueryString(obj) {
  if (!helpers_isObject(obj)) {
    return '';
  }
  return '?' + Object.keys(obj).map(function (key) {
    return "".concat(key, "=").concat(obj[key]);
  }).join('&');
};
var symbols = {
  route: Symbol('route'),
  hash: Symbol('hash'),
  store: Symbol('store'),
  fromHistory: Symbol('fromHistory'),
  expires: Symbol('expires'),
  resume: Symbol('resume'),
  backtrack: Symbol('backtrack'),
  historyState: Symbol('historyState'),
  queryParams: Symbol('queryParams')
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Router/utils/provider.js










function provider_createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = provider_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function provider_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return provider_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? provider_arrayLikeToArray(r, a) : void 0; } }
function provider_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function provider_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function provider_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? provider_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : provider_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }




var dataHooks = {
  on: function on(request) {
    setPreviousState(app.state || '');
    app._setState('Loading');
    return execProvider(request);
  },
  before: function before(request) {
    return execProvider(request);
  },
  after: function after(request) {
    try {
      execProvider(request, true);
    } catch (e) {}
    return Promise.resolve();
  }
};
var execProvider = function execProvider(request, emitProvided) {
  var route = request.route;
  var provider = route.provider;
  var expires = route.cache ? route.cache * 1000 : 0;
  var params = addPersistData(request);
  return provider.request(request.page, provider_objectSpread({}, params)).then(function () {
    request.page[symbols.expires] = Date.now() + expires;
    if (emitProvided) {
      utils_emit(request.page, 'dataProvided');
    }
  }).catch(function (e) {
    request.page[symbols.expires] = Date.now();
    throw e;
  });
};
var addPersistData = function addPersistData(_ref) {
  var page = _ref.page,
    route = _ref.route,
    hash = _ref.hash,
    _ref$register = _ref.register,
    register = _ref$register === void 0 ? new Map() : _ref$register;
  var urlValues = getValuesFromHash(hash, route.path);
  var queryParams = getQueryStringParams(hash);
  var pageData = new Map([].concat((0,toConsumableArray/* default */.Z)(urlValues), (0,toConsumableArray/* default */.Z)(register)));
  var params = {};
  var _iterator = provider_createForOfIteratorHelper(pageData),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = (0,slicedToArray/* default */.Z)(_step.value, 2),
        name = _step$value[0],
        value = _step$value[1];
      params[name] = value;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (queryParams) {
    params[symbols.queryParams] = queryParams;
  }
  if (register.size) {
    var obj = {};
    var _iterator2 = provider_createForOfIteratorHelper(register),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _step2$value = (0,slicedToArray/* default */.Z)(_step2.value, 2),
          k = _step2$value[0],
          v = _step2$value[1];
        obj[k] = v;
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    page.persist = obj;
  }
  page.params = params;
  utils_emit(page, ['urlParams'], params);
  return params;
};
var isPageExpired = function isPageExpired(page) {
  if (!page[symbols.expires]) {
    return false;
  }
  var expires = page[symbols.expires];
  var now = Date.now();
  return now >= expires;
};
var hasProvider = function hasProvider(path) {
  if (routeExists(path)) {
    var record = routes.get(path);
    return !!record.provider;
  }
  return false;
};
var getProvider = function getProvider(route) {
  if (routeExists(route.path)) {
    var _routes$get = routes.get(route.path),
      provider = _routes$get.provider;
    return {
      type: provider.type,
      provider: provider.request
    };
  }
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Router/transitions.js



var fade = function fade(i, o) {
  return new Promise(function (resolve) {
    i.patch({
      alpha: 0,
      visible: true,
      smooth: {
        alpha: [1, {
          duration: 0.5,
          delay: 0.1
        }]
      }
    });
    i.transition('alpha').on('finish', function () {
      if (o) {
        o.visible = false;
      }
      resolve();
    });
  });
};
var crossFade = function crossFade(i, o) {
  return new Promise(function (resolve) {
    i.patch({
      alpha: 0,
      visible: true,
      smooth: {
        alpha: [1, {
          duration: 0.5,
          delay: 0.1
        }]
      }
    });
    if (o) {
      o.patch({
        smooth: {
          alpha: [0, {
            duration: 0.5,
            delay: 0.3
          }]
        }
      });
    }
    i.transition('alpha').on('finish', function () {
      resolve();
    });
  });
};
var moveOnAxes = function moveOnAxes(axis, direction, i, o) {
  var bounds = axis === 'x' ? 1920 : 1080;
  return new Promise(function (resolve) {
    var _i$patch;
    i.patch((_i$patch = {}, (0,defineProperty/* default */.Z)(_i$patch, "".concat(axis), direction ? bounds * -1 : bounds), (0,defineProperty/* default */.Z)(_i$patch, "visible", true), (0,defineProperty/* default */.Z)(_i$patch, "smooth", (0,defineProperty/* default */.Z)({}, "".concat(axis), [0, {
      duration: 0.4,
      delay: 0.2
    }])), _i$patch));
    if (o) {
      var _o$patch;
      o.patch((_o$patch = {}, (0,defineProperty/* default */.Z)(_o$patch, "".concat(axis), 0), (0,defineProperty/* default */.Z)(_o$patch, "smooth", (0,defineProperty/* default */.Z)({}, "".concat(axis), [direction ? bounds : bounds * -1, {
        duration: 0.4,
        delay: 0.2
      }])), _o$patch));
    }
    i.transition(axis).on('finish', function () {
      resolve();
    });
  });
};
var up = function up(i, o) {
  return moveOnAxes('y', 0, i, o);
};
var down = function down(i, o) {
  return moveOnAxes('y', 1, i, o);
};
var left = function left(i, o) {
  return moveOnAxes('x', 0, i, o);
};
var right = function right(i, o) {
  return moveOnAxes('x', 1, i, o);
};
/* harmony default export */ const transitions = ({
  fade: fade,
  crossFade: crossFade,
  up: up,
  down: down,
  left: left,
  right: right
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Router/utils/transition.js





var executeTransition = function executeTransition(pageIn) {
  var pageOut = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var transition = pageIn.pageTransition || pageIn.easing;
  var hasCustomTransitions = !!(pageIn.smoothIn || pageIn.smoothInOut || transition);
  var transitionsDisabled = getRouterConfig().get('disableTransitions');
  if (pageIn.easing) {
    console.warn('easing() method is deprecated and will be removed. Use pageTransition()');
  }
  if (!hasCustomTransitions || transitionsDisabled) {
    pageIn.visible = true;
    if (pageOut) {
      pageOut.visible = false;
    }
    return Promise.resolve();
  }
  if (transition) {
    var type;
    try {
      type = transition.call(pageIn, pageIn, pageOut);
    } catch (e) {
      type = 'crossFade';
    }
    if (isPromise(type)) {
      return type;
    }
    if (helpers_isString(type)) {
      var fn = transitions[type];
      if (fn) {
        return fn(pageIn, pageOut);
      }
    }
    if (pageIn.smoothIn) {
      var smooth = function smooth(p, v) {
        var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return new Promise(function (resolve) {
          pageIn.visible = true;
          pageIn.setSmooth(p, v, args);
          pageIn.transition(p).on('finish', function () {
            resolve();
          });
        });
      };
      return pageIn.smoothIn({
        pageIn: pageIn,
        smooth: smooth
      });
    }
  }
  return transitions.crossFade(pageIn, pageOut);
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Router/utils/loader.js


















var load = function () {
  var _ref = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(request) {
    var expired, route;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          expired = false;
          _context.prev = 1;
          _context.next = 4;
          return loader_loader(request);
        case 4:
          request = _context.sent;
          if (!(request && !request.isCancelled)) {
            _context.next = 12;
            break;
          }
          if (app.state === 'Loading') {
            if (getPreviousState() === 'Widgets') {
              app._setState('Widgets', [getActiveWidget()]);
            } else {
              app._setState('');
            }
          }
          if (!(!request.isSharedInstance && !request.isCancelled)) {
            _context.next = 10;
            break;
          }
          _context.next = 10;
          return executeTransition(request.page, router_getActivePage());
        case 10:
          _context.next = 13;
          break;
        case 12:
          expired = true;
        case 13:
          if (!(expired || request.isCancelled)) {
            _context.next = 18;
            break;
          }
          Log.debug('[router]:', "Rejected ".concat(request.hash, " because route to ").concat(getLastHash(), " started"));
          if (request.isCreated && !request.isSharedInstance) {
            pagesHost.remove(request.page);
          }
          _context.next = 20;
          break;
        case 18:
          onRequestResolved(request);
          return _context.abrupt("return", request.page);
        case 20:
          _context.next = 25;
          break;
        case 22:
          _context.prev = 22;
          _context.t0 = _context["catch"](1);
          if (!_context.t0.route) {
            console.error(_context.t0);
          } else if (!expired) {
            route = _context.t0.route;
            if (getOption(route.options, 'clearHistory')) {
              setHistory([]);
            } else if (!isWildcard.test(route.path)) {
              updateHistory(_context.t0);
            }
            if (_context.t0.isCreated && !_context.t0.isSharedInstance) {
              pagesHost.remove(_context.t0.page);
            }
            handleError(_context.t0);
          }
        case 25:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 22]]);
  }));
  return function load(_x) {
    return _ref.apply(this, arguments);
  };
}();
var loader_loader = function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2(request) {
    var route, hash, register, type, isConstruct, provide, currentRoute, _getProvider, loadType, provider;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          route = request.route;
          hash = request.hash;
          register = request.register;
          type = getComponent(route.path);
          isConstruct = isComponentConstructor(type);
          provide = false;
          if (!isConstruct && !register.get(symbols.backtrack)) {
            if (!mustReuse(route)) {
              type = type.constructor;
              isConstruct = true;
            }
          }
          if (!isConstruct) {
            request.page = type;
            if (hasProvider(route.path)) {
              if (isPageExpired(type) || type[symbols.hash] !== hash) {
                provide = true;
              }
            }
            currentRoute = router_getActivePage() && router_getActivePage()[symbols.route];
            if (route.path === currentRoute) {
              request.isSharedInstance = true;
              if (helpers_isFunction(request.page.historyState)) {
                request.copiedHistoryState = request.page.historyState();
              }
            }
          } else {
            request.page = createComponent(stage, type);
            pagesHost.a(request.page);
            if (hasProvider(route.path)) {
              provide = true;
            }
            request.isCreated = true;
          }
          request.page[symbols.hash] = hash;
          request.page[symbols.route] = route.path;
          _context2.prev = 10;
          if (!provide) {
            _context2.next = 25;
            break;
          }
          _getProvider = getProvider(route), loadType = _getProvider.type, provider = _getProvider.provider;
          request.provider = provider;
          request.providerType = loadType;
          _context2.next = 17;
          return dataHooks[loadType](request);
        case 17:
          if (!(hash !== getLastHash())) {
            _context2.next = 21;
            break;
          }
          return _context2.abrupt("return", false);
        case 21:
          if (request.providerType !== 'after') {
            utils_emit(request.page, 'dataProvided');
          }
          return _context2.abrupt("return", request);
        case 23:
          _context2.next = 27;
          break;
        case 25:
          addPersistData(request);
          return _context2.abrupt("return", request);
        case 27:
          _context2.next = 33;
          break;
        case 29:
          _context2.prev = 29;
          _context2.t0 = _context2["catch"](10);
          request.error = _context2.t0;
          return _context2.abrupt("return", Promise.reject(request));
        case 33:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[10, 29]]);
  }));
  return function loader(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var handleError = function handleError(request) {
  if (request && request.error) {
    console.error(request.error);
  } else if (request) {
    Log.error(request);
  }
  if (request.page && routeExists('!')) {
    Router_navigate('!', {
      request: request
    }, false);
  }
};
var mustReuse = function mustReuse(route) {
  var opt = getOption(route.options, 'reuseInstance');
  var config = routerConfig.get('reuseInstance');
  if (isBoolean(opt)) {
    return opt;
  }
  return !(isBoolean(config) && config === false);
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Router/base.js





function base_createSuper(t) { var r = base_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function base_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (base_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }




var RoutedApp = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(RoutedApp, _Lightning$Component);
  var _super = base_createSuper(RoutedApp);
  function RoutedApp() {
    (0,classCallCheck/* default */.Z)(this, RoutedApp);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(RoutedApp, [{
    key: "pages",
    get: function get() {
      return this.tag('Pages');
    }
  }, {
    key: "widgets",
    get: function get() {
      return this.tag('Widgets');
    }
  }, {
    key: "_handleBack",
    value: function _handleBack() {}
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return Router.getActivePage();
    }
  }], [{
    key: "_template",
    value: function _template() {
      return {
        Pages: {
          forceZIndexContext: true
        },
        Loading: {
          rect: true,
          w: 1920,
          h: 1080,
          color: 0xff000000,
          visible: false,
          zIndex: 99,
          Label: {
            mount: 0.5,
            x: 960,
            y: 540,
            text: {
              text: 'Loading..'
            }
          }
        }
      };
    }
  }, {
    key: "_states",
    value: function _states() {
      return [function (_this) {
        (0,inherits/* default */.Z)(Loading, _this);
        var _super2 = base_createSuper(Loading);
        function Loading() {
          (0,classCallCheck/* default */.Z)(this, Loading);
          return _super2.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(Loading, [{
          key: "$enter",
          value: function $enter() {
            this.tag('Loading').visible = true;
          }
        }, {
          key: "$exit",
          value: function $exit() {
            this.tag('Loading').visible = false;
          }
        }]);
        return Loading;
      }(this), function (_this2) {
        (0,inherits/* default */.Z)(Widgets, _this2);
        var _super3 = base_createSuper(Widgets);
        function Widgets() {
          (0,classCallCheck/* default */.Z)(this, Widgets);
          return _super3.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(Widgets, [{
          key: "$enter",
          value: function $enter(args, widget) {
            this._widget = widget;
            this._refocus();
          }
        }, {
          key: "_getFocused",
          value: function _getFocused() {
            return this._widget;
          }
        }, {
          key: "reload",
          value: function reload(widget) {
            this._widget = widget;
            this._refocus();
          }
        }, {
          key: "_handleKey",
          value: function _handleKey() {
            var restoreFocus = routerConfig.get('autoRestoreRemote');
            if (!isBoolean(restoreFocus) || restoreFocus === true) {
              Router.focusPage();
            }
          }
        }]);
        return Widgets;
      }(this)];
    }
  }]);
  return RoutedApp;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Router/index.js











function Router_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Router_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Router_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Router_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Router_createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = Router_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function Router_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return Router_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? Router_arrayLikeToArray(r, a) : void 0; } }
function Router_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }









var navigateQueue = new Map();
var forcedHash = '';
var resumeHash = '';
var startRouter = function startRouter(config, instance) {
  bootRouter(config, instance);
  registerListener();
  start();
};
var start = function start() {
  var hash = (getHash() || '').replace(/^#/, '');
  var bootKey = '$';
  var params = getQueryStringParams(hash);
  var bootRequest = getBootRequest();
  var rootHash = getRootHash();
  var isDirectLoad = hash.indexOf(bootKey) !== -1;
  if (isWildcard.test(hash) && hash !== bootKey) {
    hash = '';
  }
  resumeHash = isDirectLoad ? rootHash : hash || rootHash;
  var ready = function ready() {
    if (!hash && rootHash) {
      if (helpers_isString(rootHash)) {
        Router_navigate(rootHash);
      } else if (helpers_isFunction(rootHash)) {
        rootHash().then(function (res) {
          if (helpers_isObject(res)) {
            Router_navigate(res.path, res.params);
          } else {
            Router_navigate(res);
          }
        });
      }
    } else {
      queue(hash);
      handleHashChange().then(function () {
        app._refocus();
      }).catch(function (e) {
        console.error(e);
      });
    }
  };
  if (routeExists(bootKey)) {
    if (hash && !isDirectLoad) {
      if (!getRouteByHash(hash)) {
        Router_navigate('*', {
          failedHash: hash
        });
        return;
      }
    }
    Router_navigate(bootKey, {
      resume: resumeHash,
      reload: bootKey === hash
    }, false);
  } else if (helpers_isFunction(bootRequest)) {
    bootRequest(params).then(function () {
      ready();
    }).catch(function (e) {
      handleBootError(e);
    });
  } else {
    ready();
  }
};
var handleBootError = function handleBootError(e) {
  if (routeExists('!')) {
    Router_navigate('!', {
      request: {
        error: e
      }
    });
  } else {
    console.error(e);
  }
};
var Router_navigate = function navigate(url) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var store = arguments.length > 2 ? arguments[2] : undefined;
  if (helpers_isObject(url)) {
    url = getHashByName(url);
    if (!url) {
      return;
    }
  }
  var hash = getHash();
  if (!mustUpdateLocationHash() && forcedHash) {
    hash = forcedHash;
  }
  if (hash.replace(/^#/, '') !== url) {
    queue(url, args, store);
    if (mustUpdateLocationHash()) {
      setHash(url);
    } else {
      forcedHash = url;
      handleHashChange(url).then(function () {
        app._refocus();
      }).catch(function (e) {
        console.error(e);
      });
    }
  } else if (args.reload) {
    queue(url, args, store);
    handleHashChange(url).then(function () {
      app._refocus();
    }).catch(function (e) {
      console.error(e);
    });
  }
};
var queue = function queue(hash) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var store = arguments.length > 2 ? arguments[2] : undefined;
  hash = cleanHash(hash);
  if (!navigateQueue.has(hash)) {
    var _iterator = Router_createForOfIteratorHelper(navigateQueue.values()),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _request = _step.value;
        _request.cancel();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    var request = createRequest(hash, args, store);
    navigateQueue.set(decodeURIComponent(hash), request);
    return request;
  }
  return false;
};
var handleHashChange = function () {
  var _ref = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(override) {
    var hash, queueId, request, route, result, store;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          hash = cleanHash(override || getHash());
          queueId = decodeURIComponent(hash);
          request = navigateQueue.get(queueId);
          if (!request && !navigateQueue.size) {
            request = queue(hash);
          }
          route = getRouteByHash(hash);
          if (route) {
            _context.next = 8;
            break;
          }
          if (routeExists('*')) {
            Router_navigate('*', {
              failedHash: hash
            });
          } else {
            console.error("Unable to navigate to: ".concat(hash));
          }
          return _context.abrupt("return");
        case 8:
          request.hash = hash;
          request.route = route;
          _context.next = 12;
          return beforeEachRoute(getActiveHash(), request);
        case 12:
          result = _context.sent;
          if (!(result && route.beforeNavigate)) {
            _context.next = 17;
            break;
          }
          _context.next = 16;
          return route.beforeNavigate(getActiveHash(), request);
        case 16:
          result = _context.sent;
        case 17:
          if (!isBoolean(result)) {
            _context.next = 22;
            break;
          }
          if (!result) {
            _context.next = 20;
            break;
          }
          return _context.abrupt("return", resolveHashChange(request));
        case 20:
          _context.next = 25;
          break;
        case 22:
          request.cancel();
          navigateQueue.delete(queueId);
          if (helpers_isString(result)) {
            Router_navigate(result);
          } else if (helpers_isObject(result)) {
            store = true;
            if (isBoolean(result.store)) {
              store = result.store;
            }
            Router_navigate(result.path, result.params, store);
          }
        case 25:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function handleHashChange(_x) {
    return _ref.apply(this, arguments);
  };
}();
var resolveHashChange = function resolveHashChange(request) {
  var hash = request.hash;
  var route = request.route;
  var queueId = decodeURIComponent(hash);
  setLastHash(hash);
  if (route.path) {
    var component = getComponent(route.path);
    if (helpers_isFunction(route.hook)) {
      var urlParams = getValuesFromHash(hash, route.path);
      var params = {};
      var _iterator2 = Router_createForOfIteratorHelper(urlParams.keys()),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var key = _step2.value;
          params[key] = urlParams.get(key);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      route.hook(app, Router_objectSpread({}, params));
    }
    if (component) {
      var activePage = router_getActivePage();
      if (activePage) {
        var keepAlive = keepActivePageAlive(getActiveRoute(), request);
        if (activePage && route.path === getActiveRoute() && !keepAlive) {
          activePage._setState('');
        }
      }
      if (isPage(component, stage)) {
        load(request).then(function () {
          app._refocus();
          navigateQueue.delete(queueId);
        });
      } else {
        component().then(function (contents) {
          return contents.default;
        }).then(function (module) {
          storeComponent(route.path, module);
          return load(request);
        }).then(function () {
          app._refocus();
          navigateQueue.delete(queueId);
        });
      }
    } else {
      navigateQueue.delete(queueId);
    }
  }
};
var step = function step() {
  var level = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  if (!level || isNaN(level)) {
    return false;
  }
  var history = getHistory();
  level = Math.abs(level);
  if (history.length) {
    var _navigate;
    var route = history.splice(history.length - level, level)[0];
    setHistory(history);
    return Router_navigate(route.hash, (_navigate = {}, (0,defineProperty/* default */.Z)(_navigate, symbols.backtrack, true), (0,defineProperty/* default */.Z)(_navigate, symbols.historyState, route.state), _navigate), false);
  } else if (routerConfig.get('backtrack')) {
    var hashLastPart = /(\/:?[\w%\s-]+)$/;
    var hash = stripRegex(getHash());
    var floor = getFloor(hash);
    if (floor > 1) {
      while (floor--) {
        hash = hash.replace(hashLastPart, '');
        if (getRouteByHash(hash)) {
          return Router_navigate(hash, (0,defineProperty/* default */.Z)({}, symbols.backtrack, true), false);
        }
      }
    }
  }
  if (level > history.length) {
    if (helpers_isFunction(app._handleAppClose)) {
      return app._handleAppClose();
    }
    return app.application.closeApp();
  }
  return false;
};
var resume = function resume() {
  if (helpers_isString(resumeHash)) {
    Router_navigate(resumeHash, false);
    resumeHash = '';
  } else if (helpers_isFunction(resumeHash)) {
    resumeHash().then(function (res) {
      resumeHash = '';
      if (helpers_isObject(res)) {
        Router_navigate(res.path, res.params);
      } else {
        Router_navigate(res);
      }
    });
  } else {
    console.warn('[Router]: resume() called but no hash found');
  }
};
var reload = function reload() {
  if (!isNavigating()) {
    var hash = getActiveHash();
    Router_navigate(hash, {
      reload: true
    }, false);
  }
};
var isNavigating = function isNavigating() {
  if (navigateQueue.size) {
    var isProcessing = false;
    var _iterator3 = Router_createForOfIteratorHelper(navigateQueue.values()),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var request = _step3.value;
        if (!request.isCancelled) {
          isProcessing = true;
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
    return isProcessing;
  }
  return false;
};
var getResumeHash = function getResumeHash() {
  return resumeHash;
};
var getHash = function getHash() {
  return document.location.hash;
};
var setHash = function setHash(url) {
  document.location.hash = url;
};
var initRouter = function initRouter(config) {
  if (config.getHash) {
    getHash = config.getHash;
  }
  if (config.setHash) {
    setHash = config.setHash;
  }
};
var registerListener = function registerListener() {
  Registry.addEventListener(window, 'hashchange', (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2() {
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!mustUpdateLocationHash()) {
            _context2.next = 9;
            break;
          }
          _context2.prev = 1;
          _context2.next = 4;
          return handleHashChange();
        case 4:
          _context2.next = 9;
          break;
        case 6:
          _context2.prev = 6;
          _context2.t0 = _context2["catch"](1);
          console.error(_context2.t0);
        case 9:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[1, 6]]);
  })));
};
var root = function root() {
  var rootHash = getRootHash();
  if (helpers_isString(rootHash)) {
    Router_navigate(rootHash);
  } else if (helpers_isFunction(rootHash)) {
    rootHash().then(function (res) {
      if (helpers_isObject(res)) {
        Router_navigate(res.path, res.params);
      } else {
        Router_navigate(res);
      }
    });
  }
};
var deletePage = function deletePage(param) {
  deleteCurrentInstance(param);
};
/* harmony default export */ const Router = ({
  startRouter: startRouter,
  navigate: Router_navigate,
  resume: resume,
  step: step,
  go: step,
  back: step.bind(null, -1),
  activePage: router_getActivePage,
  getActivePage: function getActivePage() {
    return router_getActivePage();
  },
  deletePage: deletePage,
  getActiveRoute: getActiveRoute,
  getActiveHash: getActiveHash,
  focusWidget: focusWidget,
  getActiveWidget: getActiveWidget,
  restoreFocus: restoreFocus,
  isNavigating: isNavigating,
  getHistory: getHistory,
  setHistory: setHistory,
  getHistoryState: getHistoryState,
  replaceHistoryState: replaceHistoryState,
  getQueryStringParams: getQueryStringParams,
  reload: reload,
  symbols: symbols,
  App: RoutedApp,
  focusPage: restoreFocus,
  root: root,
  setupRoutes: function setupRoutes() {
    console.warn('Router: setupRoutes is deprecated, consolidate your configuration');
    console.warn('https://rdkcentral.github.io/Lightning-SDK/#/plugins/router/configuration');
  },
  on: function on() {
    console.warn('Router.on() is deprecated, consolidate your configuration');
    console.warn('https://rdkcentral.github.io/Lightning-SDK/#/plugins/router/configuration');
  },
  before: function before() {
    console.warn('Router.before() is deprecated, consolidate your configuration');
    console.warn('https://rdkcentral.github.io/Lightning-SDK/#/plugins/router/configuration');
  },
  after: function after() {
    console.warn('Router.after() is deprecated, consolidate your configuration');
    console.warn('https://rdkcentral.github.io/Lightning-SDK/#/plugins/router/configuration');
  }
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Launch/index.js



















var Launch_ApplicationInstance;
/* harmony default export */ const Launch = (function (App, appSettings, platformSettings, appData) {
  initSettings(appSettings, platformSettings);
  initUtils(platformSettings);
  initMetadata(appSettings);
  initStorage();
  if (platformSettings.plugins) {
    platformSettings.plugins.profile && initProfile(platformSettings.plugins.profile);
    platformSettings.plugins.metrics && initMetrics(platformSettings.plugins.metrics);
    platformSettings.plugins.mediaPlayer && initMediaPlayer(platformSettings.plugins.mediaPlayer);
    platformSettings.plugins.mediaPlayer && initVideoPlayer(platformSettings.plugins.mediaPlayer);
    platformSettings.plugins.ads && initAds(platformSettings.plugins.ads);
    platformSettings.plugins.router && initRouter(platformSettings.plugins.router);
    platformSettings.plugins.tv && initTV(platformSettings.plugins.tv);
    platformSettings.plugins.purchase && initPurchase(platformSettings.plugins.purchase);
    platformSettings.plugins.pin && initPin(platformSettings.plugins.pin);
  }
  var app = src_Application(App, appData, platformSettings);
  initLightningSdkPlugin.log = Log;
  initLightningSdkPlugin.settings = src_Settings;
  initLightningSdkPlugin.ads = src_Ads;
  initLightningSdkPlugin.lightning = src_Lightning;
  Launch_ApplicationInstance = new app(appSettings);
  initLightningSdkPlugin.appInstance = Launch_ApplicationInstance;
  return Launch_ApplicationInstance;
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Pin/index.js

/* harmony default export */ const sdk_src_Pin = ((/* unused pure expression or super */ null && (Pin)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Profile/index.js

/* harmony default export */ const sdk_src_Profile = ((/* unused pure expression or super */ null && (Profile)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Purchase/index.js

/* harmony default export */ const sdk_src_Purchase = ((/* unused pure expression or super */ null && (Purchase)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/TV/index.js

/* harmony default export */ const sdk_src_TV = ((/* unused pure expression or super */ null && (TV)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/VideoPlayer/index.js

/* harmony default export */ const sdk_src_VideoPlayer = ((/* unused pure expression or super */ null && (VideoPlayer)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Metadata/index.js

/* harmony default export */ const sdk_src_Metadata = ((/* unused pure expression or super */ null && (Metadata)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Subtitles/SubtitleComponent.js






function SubtitleComponent_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function SubtitleComponent_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? SubtitleComponent_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SubtitleComponent_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function SubtitleComponent_createSuper(t) { var r = SubtitleComponent_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function SubtitleComponent_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (SubtitleComponent_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var SubtitleComponent = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(SubtitleComponent, _Lightning$Component);
  var _super = SubtitleComponent_createSuper(SubtitleComponent);
  function SubtitleComponent() {
    (0,classCallCheck/* default */.Z)(this, SubtitleComponent);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(SubtitleComponent, [{
    key: "_init",
    value: function _init() {
      var _this = this;
      this._textTextureDefaults = new src_Lightning.textures.TextTexture(this.stage).cloneArgs();
      this.tag('Text').on('txLoaded', function (_ref) {
        var _source = _ref._source;
        _this.w = _source.w + _this.tag('Text').x * 2;
        _this.h = _source.h;
        _this.position();
      });
    }
  }, {
    key: "textFormat",
    get: function get() {
      var textTag = this.tag('Text').text;
      return {
        fontFace: textTag.fontFace || 'sans-serif',
        fontSize: textTag.fontSize,
        lineHeight: textTag.lineHeight,
        textAlign: textTag.textAlign,
        wordWrap: true,
        maxLines: textTag.maxLines
      };
    }
  }, {
    key: "show",
    value: function show() {
      this.visible = true;
    }
  }, {
    key: "hide",
    value: function hide() {
      this.visible = false;
    }
  }, {
    key: "position",
    value: function position() {
      this.x = this._calculateX(this.xPos);
      this.y = this._calculateY(this.yPos);
    }
  }, {
    key: "viewportW",
    get: function get() {
      return this._viewportW || this.application.finalW;
    },
    set: function set(v) {
      this._viewportW = v;
      this.x = this._calculateX(this.xPos);
    }
  }, {
    key: "viewportH",
    get: function get() {
      return this._viewportH || this.application.finalH;
    },
    set: function set(v) {
      this._viewportH = v;
      this.y = this._calculateY(this.yPos);
    }
  }, {
    key: "_calculateX",
    value: function _calculateX(x) {
      if (x === 'center') {
        x = (this.viewportW - this.finalW) / 2;
      } else if (x === 'left') {
        x = 60;
      } else if (x === 'right') {
        x = this.viewportW - this.finalW - 60;
      }
      return x;
    }
  }, {
    key: "xPos",
    get: function get() {
      return this._x || 'center';
    },
    set: function set(v) {
      this._x = v;
      this.x = this._calculateX(v);
    }
  }, {
    key: "_calculateY",
    value: function _calculateY(y) {
      if (y === 'center') {
        return (this.viewportH - this.finalH) / 2;
      } else if (y === 'top') {
        return 60;
      } else if (y === 'bottom') {
        return this.viewportH - this.finalH - 60;
      }
      return y;
    }
  }, {
    key: "yPos",
    get: function get() {
      return this._y || 'bottom';
    },
    set: function set(v) {
      this._y = v;
      this.y = this._calculateY(v);
    }
  }, {
    key: "fontFamily",
    set: function set(v) {
      this.tag('Text').text.fontFace = v;
    }
  }, {
    key: "fontSize",
    set: function set(v) {
      this.tag('Text').text.fontSize = v;
      this.tag('Text').text.lineHeight = v * 1.3;
    }
  }, {
    key: "fontColor",
    set: function set(v) {
      this.tag('Text').color = v;
    }
  }, {
    key: "backgroundColor",
    set: function set(v) {
      this.color = v;
    }
  }, {
    key: "_defineBreakpoint",
    value: function _defineBreakpoint(text, breakpoint) {
      if (breakpoint >= this.maxWidth) return this.maxWidth;
      var info = src_Lightning.textures.TextTexture.renderer(this.stage, this.stage.platform.getDrawingCanvas(), SubtitleComponent_objectSpread(SubtitleComponent_objectSpread(SubtitleComponent_objectSpread(SubtitleComponent_objectSpread({}, this._textTextureDefaults), this.textFormat), {
        wordWrapWidth: breakpoint
      }), {}, {
        text: text
      }))._calculateRenderInfo();
      if (info.width <= breakpoint && info.lines.length <= 2) {
        return breakpoint;
      } else {
        return this._defineBreakpoint(text, breakpoint * 1.25);
      }
    }
  }, {
    key: "text",
    set: function set(v) {
      this.alpha = 0;
      if (v && v.length) {
        var breakpoint = this._defineBreakpoint(v, 640);
        this.tag('Text').text.wordWrapWidth = breakpoint;
        this.tag('Text').text = v;
        this.alpha = 1;
      }
    }
  }, {
    key: "textAlign",
    set: function set(v) {
      this._textAlign = v;
      this.tag('Text').text.textAlign = v;
    }
  }, {
    key: "maxWidth",
    get: function get() {
      return (this._maxWidth || 1200) - this.tag('Text').x * 2;
    },
    set: function set(v) {
      this._maxWidth = v;
    }
  }, {
    key: "maxLines",
    set: function set(v) {
      this.tag('Text').text.maxLines = v;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return {
        visible: false,
        rect: true,
        color: 0x90000000,
        shader: {
          type: src_Lightning.shaders.RoundedRectangle,
          radius: 5
        },
        Text: {
          y: 5,
          x: 20,
          text: {
            textColor: 0xffffffff,
            fontSize: 38,
            lineHeight: 38 * 1.4,
            textAlign: 'center',
            wordWrap: true,
            maxLines: 3,
            shadow: true,
            shadowColor: 0xff333333
          }
        }
      };
    }
  }]);
  return SubtitleComponent;
}(src_Lightning.Component);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/src/Subtitles/index.js




var subtitlesComponent;
var getOrCreateSubtitlesComponent = function getOrCreateSubtitlesComponent() {
  return subtitlesComponent ? subtitlesComponent : subtitlesComponent = AppInstance.application.tag('Subtitles') || AppInstance.application.childList.a(AppInstance.stage.c({
    ref: 'Subtitles',
    type: SubtitleComponent,
    forceZIndexContext: true,
    zIndex: 2
  }));
};
/* harmony default export */ const Subtitles = ({
  show: function show() {
    var subtitles = getOrCreateSubtitlesComponent();
    subtitles.show();
  },
  hide: function hide() {
    var subtitles = getOrCreateSubtitlesComponent();
    subtitles.hide();
  },
  styles: function styles(v) {
    var _this = this;
    Object.keys(v).forEach(function (key) {
      if (key in _this && typeof _this[key] === 'function') {
        _this[key](v[key]);
      }
    });
  },
  fontFamily: function fontFamily(v) {
    var subtitles = getOrCreateSubtitlesComponent();
    subtitles.fontFamily = v;
  },
  fontSize: function fontSize(v) {
    var subtitles = getOrCreateSubtitlesComponent();
    subtitles.fontSize = v;
  },
  fontColor: function fontColor(v) {
    var subtitles = getOrCreateSubtitlesComponent();
    subtitles.fontColor = v;
  },
  backgroundColor: function backgroundColor(v) {
    var subtitles = getOrCreateSubtitlesComponent();
    subtitles.backgroundColor = v;
  },
  textAlign: function textAlign(v) {
    var subtitles = getOrCreateSubtitlesComponent();
    subtitles.textAlign = v;
  },
  textAlignVertical: function textAlignVertical(v) {
    var subtitles = getOrCreateSubtitlesComponent();
    subtitles.textAlignVertical = v;
  },
  viewport: function viewport(w, h) {
    var subtitles = getOrCreateSubtitlesComponent();
    subtitles.viewportW = w;
    subtitles.viewportH = h;
  },
  position: function position(x, y) {
    var subtitles = getOrCreateSubtitlesComponent();
    subtitles.xPos = x;
    subtitles.yPos = y;
  },
  maxWidth: function maxWidth(v) {
    var subtitles = getOrCreateSubtitlesComponent();
    subtitles.maxWidth = v;
  },
  maxLines: function maxLines(v) {
    var subtitles = getOrCreateSubtitlesComponent();
    subtitles.maxLines = v;
  },
  text: function text(v) {
    var subtitles = getOrCreateSubtitlesComponent();
    subtitles.text = v;
  },
  clear: function clear() {
    var subtitles = getOrCreateSubtitlesComponent();
    subtitles.text = '';
  }
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/@lightningjs+sdk@5.5.5/node_modules/@lightningjs/sdk/index.js



























;// CONCATENATED MODULE: ./packages/pelo-plugins/keys/src/common/constants.js
var numericKeys = {
  KEY_ZERO: 'zero',
  KEY_ONE: 'one',
  KEY_TWO: 'two',
  KEY_THREE: 'three',
  KEY_FOUR: 'four',
  KEY_FIVE: 'five',
  KEY_SIX: 'six',
  KEY_SEVEN: 'seven',
  KEY_EIGHT: 'eight',
  KEY_NINE: 'nine'
};
var actionsKeys = {
  KEY_SPACE: 'space',
  KEY_UP: 'up',
  KEY_DOWN: 'down',
  KEY_RIGHT: 'right',
  KEY_LEFT: 'left',
  KEY_ENTER: 'enter',
  KEY_RED: 'red',
  KEY_GREEN: 'green',
  KEY_YELLOW: 'yellow',
  KEY_BLUE: 'blue',
  KEY_PLAY: 'play',
  KEY_PAUSE: 'pause',
  KEY_BACK: 'back',
  KEY_REWIND: 'rewind',
  KEY_FASTFORWARD: 'fastForward',
  KEY_STOP: 'stop',
  KEY_REWIND_LONGPRESS: 'rewindLongPress',
  KEY_FASTFORWARD_LONGPRESS: 'fastForwardLongPress',
  KEY_SKIP_REWIND: 'skipRewind',
  KEY_SKIP_FASTFORWARD: 'skipFastForward',
  KEY_PLAY_PAUSE: 'playPause',
  KEY_DONE: 'done'
};
;// CONCATENATED MODULE: ./packages/pelo-plugins/keys/src/platform/vodafone/mapping.js

var keyCodes = {
  48: numericKeys.KEY_ZERO,
  49: numericKeys.KEY_ONE,
  50: numericKeys.KEY_TWO,
  51: numericKeys.KEY_THREE,
  52: numericKeys.KEY_FOUR,
  53: numericKeys.KEY_FIVE,
  54: numericKeys.KEY_SIX,
  55: numericKeys.KEY_SEVEN,
  56: numericKeys.KEY_EIGHT,
  57: numericKeys.KEY_NINE,
  38: actionsKeys.KEY_UP,
  40: actionsKeys.KEY_DOWN,
  39: actionsKeys.KEY_RIGHT,
  37: actionsKeys.KEY_LEFT,
  13: actionsKeys.KEY_ENTER,
  403: actionsKeys.KEY_RED,
  404: actionsKeys.KEY_GREEN,
  405: actionsKeys.KEY_YELLOW,
  406: actionsKeys.KEY_BLUE,
  415: actionsKeys.KEY_PLAY,
  19: actionsKeys.KEY_PAUSE,
  413: actionsKeys.KEY_STOP,
  463: actionsKeys.KEY_PLAY_PAUSE,
  412: actionsKeys.KEY_REWIND,
  417: actionsKeys.KEY_FASTFORWARD,
  461: actionsKeys.KEY_BACK
};
var getKeymap = function getKeymap() {};
;// CONCATENATED MODULE: ./packages/pelo-plugins/keys/src/platform/default/registration.js



var updateKeysRegistration = function () {
  var _ref = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee() {
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function updateKeysRegistration() {
    return _ref.apply(this, arguments);
  };
}();
var initializeKeys = function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2() {
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function initializeKeys() {
    return _ref2.apply(this, arguments);
  };
}();
;// CONCATENATED MODULE: ./packages/pelo-plugins/keys/src/common/available.js


var availableNumerics = [numericKeys.KEY_ZERO, numericKeys.KEY_ONE, numericKeys.KEY_TWO, numericKeys.KEY_THREE, numericKeys.KEY_FOUR, numericKeys.KEY_FIVE, numericKeys.KEY_SIX, numericKeys.KEY_SEVEN, numericKeys.KEY_EIGHT, numericKeys.KEY_NINE];
var availableDirections = [actionsKeys.KEY_UP, actionsKeys.KEY_DOWN, actionsKeys.KEY_RIGHT, actionsKeys.KEY_LEFT, actionsKeys.KEY_ENTER, actionsKeys.KEY_BACK];
var availableActions = [].concat(availableNumerics, availableDirections, [actionsKeys.KEY_RED, actionsKeys.KEY_GREEN, actionsKeys.KEY_YELLOW, actionsKeys.KEY_BLUE, actionsKeys.KEY_PLAY, actionsKeys.KEY_PAUSE, actionsKeys.KEY_REWIND, actionsKeys.KEY_FASTFORWARD, actionsKeys.KEY_STOP, actionsKeys.KEY_SPACE, actionsKeys.KEY_REWIND_LONGPRESS, actionsKeys.KEY_FASTFORWARD_LONGPRESS]);
;// CONCATENATED MODULE: ./packages/pelo-plugins/keys/index.js




;// CONCATENATED MODULE: ./src/modules/settings/platform/vodafone.js


var getAdvancedConfig = function getAdvancedConfig() {
  var config = {};
  config.appSettings = {
    stage: {
      memoryPressure: 521600
    }
  };
  return config;
};
var getKeyCodes = function getKeyCodes() {
  return keyCodes;
};
var vodafone_getSettings = function getSettings() {
  var advancedConfig = getAdvancedConfig();
  return merge_default()({
    appSettings: {
      stage: {
        forceTxCanvasSource: true
      }
    },
    platformSettings: {
      router: {
        updateHash: false
      }
    }
  }, advancedConfig);
};
;// CONCATENATED MODULE: ./src/modules/settings/app.settings.js













function app_settings_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function app_settings_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? app_settings_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : app_settings_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }




var STATIC_DIRECTORY = 'static';
var capitalizeKeyActions = memoize_default()(function (codes) {
  return Object.keys(codes).reduce(function (previous, key) {
    var value = codes[key];
    previous[key] = value.charAt(0).toUpperCase() + value.slice(1);
    return previous;
  }, {});
});
var getSettings = function getSettings() {
  var appSettings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  var platformSettings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var sizes = window.innerHeight <= 720 ? {
    w: 1280,
    h: 720
  } : {
    w: 1920,
    h: 1080
  };
  var forcedStageSettings = {
    precision: 1,
    clearColor: 0x00000000
  };
  var canvas2d;
  var inspector;
  try {
    var query = new URL(document.location).searchParams;
    canvas2d = query.get('canvas2d') === 'true';
    inspector = query.get('inspector') === 'true';
  } catch (error) {
    canvas2d = false;
    inspector = false;
  }
  var commonSettings = {
    appSettings: {
      keys: capitalizeKeyActions(getKeyCodes()),
      stage: app_settings_objectSpread({
        useImageWorker: true,
        canvas2d: canvas2d
      }, sizes),
      debug: false
    },
    platformSettings: {
      inspector: inspector,
      path: "./".concat(STATIC_DIRECTORY),
      log: true,
      showVersion: false,
      router: {
        disableTransitions: false,
        lazyCreate: true,
        lazyDestroy: true,
        destroyOnHistoryBack: true,
        reuseInstance: false
      }
    }
  };
  var overrides = merge_default()({
    appSettings: appSettings,
    platformSettings: platformSettings
  }, {
    appSettings: {
      stage: app_settings_objectSpread({}, forcedStageSettings)
    }
  });
  return merge_default()(commonSettings, vodafone_getSettings(), overrides);
};
var STATIC_DIRECTORY_REG_EXP = new RegExp("^/".concat(STATIC_DIRECTORY, "/"));
var getFullPath = function getFullPath(url) {
  if (!url) {
    return '';
  }
  var hostedUrlPublicPath = "./public" || 0;
  var base = src_Utils.asset(url.replace(hostedUrlPublicPath, '/').replace(STATIC_DIRECTORY_REG_EXP, ''));
  var pathname = window.location.pathname;
  if (!pathname || pathname === '/') {
    return base;
  }
  return  false ? 0 : base.replace(pathname, '');
};
// EXTERNAL MODULE: ./packages/bedrock-rdk/config/src/index.js
var src = __webpack_require__(62352);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
// EXTERNAL MODULE: ./node_modules/.pnpm/superagent@3.8.3/node_modules/superagent/lib/client.js
var client = __webpack_require__(84628);
var client_default = /*#__PURE__*/__webpack_require__.n(client);
// EXTERNAL MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/layout/layout.constants.js
var layout_constants = __webpack_require__(29461);
;// CONCATENATED MODULE: ./src/modules/routes/routes.utils.js





var APP_PATH = 'app';
var SERVICES_ENTITY = 'services';
var FOLDERS_ENTITY = 'folders';
var PROFILE_ENTITY = 'profile';
var LIVES_ENTITY = 'lives';
var FOLDER_ENTITY = layout_constants/* entities */.jF.folder;
var PROGRAM_ENTITY = layout_constants/* entities */.jF.program;
var SEARCH_ENTITY = "".concat(layout_constants/* entities */.jF.frontspace, "/").concat(layout_constants/* frontspaces */.K_.search);
var SERVICE_ENTITY = layout_constants/* entities */.jF.service;
var BOOKMARKS_ENTITY = "".concat(layout_constants/* entities */.jF.frontspace, "/").concat(layout_constants/* frontspaces */.K_.bookmarks);
var BOOKMARKS_PATH = "".concat(APP_PATH, "/").concat(BOOKMARKS_ENTITY);
var FOLDER_PATH = "".concat(APP_PATH, "/").concat(FOLDER_ENTITY);
var SERVICES_PATH = "".concat(APP_PATH, "/").concat(SERVICES_ENTITY);
var PROFILE_PATH = "".concat(APP_PATH, "/").concat(PROFILE_ENTITY);
var PROGRAM_PATH = "".concat(APP_PATH, "/").concat(PROGRAM_ENTITY);
var SEARCH_PATH = "".concat(APP_PATH, "/").concat(SEARCH_ENTITY);
var SERVICE_PATH = "".concat(APP_PATH, "/").concat(SERVICE_ENTITY);
var HOME_PATH = "".concat(APP_PATH, "/").concat(layout_constants/* entities */.jF.alias, "/").concat(layout_constants/* aliases */.j3.home);
var FRONTSPACE_PATH = "".concat(APP_PATH, "/").concat(layout_constants/* entities */.jF.frontspace);
var FOLDERS_PATH = "".concat(APP_PATH, "/").concat(FOLDERS_ENTITY);
var LIVES_PATH = "".concat(APP_PATH, "/").concat(LIVES_ENTITY);
var AUDIO_PATH = layout_constants/* entities */.jF.audio;
var RADIO_PATH = layout_constants/* entities */.jF.radio;
var VIDEO_PATH = layout_constants/* entities */.jF.video;
var LIVE_PATH = layout_constants/* entities */.jF.live;
var CORE_PATH = 'core';
var PAIRING_PATH = "".concat(CORE_PATH, "/pairing");
var LANDING_PATH = 'landing';
var SSI_PATH = 'ssi';
var DEVICE_GATE_PATH = 'device-gate';
var INFORMATION_PATH = '/information';
var USAGE_TERMS_PATH = '/terms-of-usage';
var PRIVACY_POLICY_PATH = '/privacy-policy';
var SUBSCRIPTION_TERMS_PATH = '/terms-of-subscription';
var LEGAL_CONDITIONS_PATH = '/legal-conditions';
var SETTINGS_PATH = '/settings';
var FAQ_PATH = '/faq';
var FEEDBACK_PATH = '/feedback';
var ACCOUNT_SETTINGS_PATH = '/account_settings';
var EXPIRED_SUBSCRIPTION_PATH = "".concat(CORE_PATH, "/expired-subscription");
var HISTORY_CLEANUP_PAGES = [HOME_PATH, LANDING_PATH];
var DEEP_LINK_EXCLUSIONS = [HOME_PATH, LANDING_PATH, PAIRING_PATH, SSI_PATH, INFORMATION_PATH, USAGE_TERMS_PATH, PRIVACY_POLICY_PATH, SUBSCRIPTION_TERMS_PATH, LEGAL_CONDITIONS_PATH, SETTINGS_PATH, FAQ_PATH, FEEDBACK_PATH, ACCOUNT_SETTINGS_PATH, EXPIRED_SUBSCRIPTION_PATH, DEVICE_GATE_PATH];
var navigateTo = function navigateTo() {
  return Router.navigate.apply(Router, arguments);
};
var navigateToAliasHome = function navigateToAliasHome() {
  for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
    params[_key] = arguments[_key];
  }
  return navigateTo.apply(void 0, [HOME_PATH].concat(params));
};
var navigateToFrontspace = function navigateToFrontspace(entityId) {
  for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    params[_key2 - 1] = arguments[_key2];
  }
  return navigateTo.apply(void 0, ["".concat(FRONTSPACE_PATH, "/").concat(entityId)].concat(params));
};
var navigateToBookmarksPage = function navigateToBookmarksPage() {
  for (var _len3 = arguments.length, params = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    params[_key3] = arguments[_key3];
  }
  return navigateTo.apply(void 0, [BOOKMARKS_PATH].concat(params));
};
var navigateToFolderPage = function navigateToFolderPage(entityId) {
  for (var _len4 = arguments.length, params = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    params[_key4 - 1] = arguments[_key4];
  }
  return navigateTo.apply(void 0, ["".concat(FOLDER_PATH, "/").concat(entityId)].concat(params));
};
var navigateToServicesPage = function navigateToServicesPage() {
  for (var _len5 = arguments.length, params = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    params[_key5] = arguments[_key5];
  }
  return navigateTo.apply(void 0, [SERVICES_PATH].concat(params));
};
var navigateToProfilePage = function navigateToProfilePage() {
  for (var _len6 = arguments.length, params = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    params[_key6] = arguments[_key6];
  }
  return navigateTo.apply(void 0, [PROFILE_PATH].concat(params));
};
var navigateToProgramPage = function navigateToProgramPage(entityId) {
  for (var _len7 = arguments.length, params = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    params[_key7 - 1] = arguments[_key7];
  }
  return navigateTo.apply(void 0, ["".concat(PROGRAM_PATH, "/").concat(entityId)].concat(params));
};
var navigateToSearchPage = function navigateToSearchPage() {
  for (var _len8 = arguments.length, params = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
    params[_key8] = arguments[_key8];
  }
  return navigateTo.apply(void 0, [SEARCH_PATH].concat(params));
};
var navigateToServicePage = function navigateToServicePage(entityId) {
  for (var _len9 = arguments.length, params = new Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
    params[_key9 - 1] = arguments[_key9];
  }
  return navigateTo.apply(void 0, ["".concat(SERVICE_PATH, "/").concat(entityId)].concat(params));
};
var navigateToFoldersPage = function navigateToFoldersPage() {
  for (var _len0 = arguments.length, params = new Array(_len0), _key0 = 0; _key0 < _len0; _key0++) {
    params[_key0] = arguments[_key0];
  }
  return navigateTo.apply(void 0, [FOLDERS_PATH].concat(params));
};
var navigateToLivesPage = function navigateToLivesPage() {
  for (var _len1 = arguments.length, params = new Array(_len1), _key1 = 0; _key1 < _len1; _key1++) {
    params[_key1] = arguments[_key1];
  }
  return navigateTo.apply(void 0, [LIVES_PATH].concat(params));
};
var navigateToPairingPage = function navigateToPairingPage() {
  for (var _len10 = arguments.length, params = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
    params[_key10] = arguments[_key10];
  }
  return navigateTo.apply(void 0, [PAIRING_PATH].concat(params));
};
var navigateToAudioPage = function navigateToAudioPage(entityId) {
  for (var _len11 = arguments.length, params = new Array(_len11 > 1 ? _len11 - 1 : 0), _key11 = 1; _key11 < _len11; _key11++) {
    params[_key11 - 1] = arguments[_key11];
  }
  return navigateTo.apply(void 0, ["".concat(AUDIO_PATH, "/").concat(entityId)].concat(params));
};
var navigateToRadioPage = function navigateToRadioPage(entityId) {
  for (var _len12 = arguments.length, params = new Array(_len12 > 1 ? _len12 - 1 : 0), _key12 = 1; _key12 < _len12; _key12++) {
    params[_key12 - 1] = arguments[_key12];
  }
  return navigateTo.apply(void 0, ["".concat(RADIO_PATH, "/").concat(entityId)].concat(params));
};
var navigateToVodPage = function navigateToVodPage(entityId) {
  for (var _len13 = arguments.length, params = new Array(_len13 > 1 ? _len13 - 1 : 0), _key13 = 1; _key13 < _len13; _key13++) {
    params[_key13 - 1] = arguments[_key13];
  }
  return navigateTo.apply(void 0, ["".concat(VIDEO_PATH, "/").concat(entityId)].concat(params));
};
var navigateToLivePage = function navigateToLivePage(entityId) {
  for (var _len14 = arguments.length, params = new Array(_len14 > 1 ? _len14 - 1 : 0), _key14 = 1; _key14 < _len14; _key14++) {
    params[_key14 - 1] = arguments[_key14];
  }
  return navigateTo.apply(void 0, ["".concat(LIVE_PATH, "/").concat(entityId)].concat(params));
};
var navigateToLandingPage = function navigateToLandingPage() {
  for (var _len15 = arguments.length, params = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
    params[_key15] = arguments[_key15];
  }
  return navigateTo.apply(void 0, [LANDING_PATH].concat(params));
};
var navigateToExpiredSubscriptionPage = function navigateToExpiredSubscriptionPage() {
  for (var _len16 = arguments.length, params = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
    params[_key16] = arguments[_key16];
  }
  return navigateTo.apply(void 0, [EXPIRED_SUBSCRIPTION_PATH].concat(params));
};
var navigateToSettingsPage = function navigateToSettingsPage() {
  for (var _len17 = arguments.length, params = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
    params[_key17] = arguments[_key17];
  }
  return navigateTo.apply(void 0, [SETTINGS_PATH].concat(params));
};
var navigateToInformationPage = function navigateToInformationPage() {
  for (var _len18 = arguments.length, params = new Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
    params[_key18] = arguments[_key18];
  }
  return navigateTo.apply(void 0, [INFORMATION_PATH].concat(params));
};
var navigateToUsageTermsPage = function navigateToUsageTermsPage() {
  for (var _len19 = arguments.length, params = new Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
    params[_key19] = arguments[_key19];
  }
  return navigateTo.apply(void 0, [USAGE_TERMS_PATH].concat(params));
};
var navigateToLegalConditionsPage = function navigateToLegalConditionsPage() {
  for (var _len20 = arguments.length, params = new Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {
    params[_key20] = arguments[_key20];
  }
  return navigateTo.apply(void 0, [LEGAL_CONDITIONS_PATH].concat(params));
};
var navigateToPrivacyPolicyPage = function navigateToPrivacyPolicyPage() {
  for (var _len21 = arguments.length, params = new Array(_len21), _key21 = 0; _key21 < _len21; _key21++) {
    params[_key21] = arguments[_key21];
  }
  return navigateTo.apply(void 0, [PRIVACY_POLICY_PATH].concat(params));
};
var navigateToFAQPage = function navigateToFAQPage() {
  for (var _len22 = arguments.length, params = new Array(_len22), _key22 = 0; _key22 < _len22; _key22++) {
    params[_key22] = arguments[_key22];
  }
  return navigateTo.apply(void 0, [FAQ_PATH].concat(params));
};
var navigateToFeedbackPage = function navigateToFeedbackPage() {
  for (var _len23 = arguments.length, params = new Array(_len23), _key23 = 0; _key23 < _len23; _key23++) {
    params[_key23] = arguments[_key23];
  }
  return navigateTo.apply(void 0, [FEEDBACK_PATH].concat(params));
};
var navigateToAccountSettingsPage = function navigateToAccountSettingsPage() {
  for (var _len24 = arguments.length, params = new Array(_len24), _key24 = 0; _key24 < _len24; _key24++) {
    params[_key24] = arguments[_key24];
  }
  return navigateTo.apply(void 0, [ACCOUNT_SETTINGS_PATH].concat(params));
};
;// CONCATENATED MODULE: ./src/modules/app/utils/customer/rtlde/deeplink.utils.js














var DEEPLINK_REGEX = /\/video-tv\/(filme|serien|live-tv|shows|live)\/(\S+)-(\d+)/gi;
var DEFAULT_PATH = HOME_PATH;
var VOD_PREFIX = 'clip_';
var redirect = function redirect(path) {
  window.history.replaceState(null, document.title, "/".concat(window.location.search, "#").concat(path));
};
var patchPath = function patchPath(path) {
  if (!path.startsWith('video/')) {
    return path;
  }
  var id = path.split('/').pop();
  return "video/".concat(id.startsWith(VOD_PREFIX) ? id : "".concat(VOD_PREFIX).concat(id));
};
var handleDeeplink = function () {
  var _ref = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee() {
    var pathname, result, deeplink;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          pathname = document.location.pathname;
          if (!DEEPLINK_REGEX.test(pathname)) {
            _context.next = 14;
            break;
          }
          _context.prev = 2;
          _context.next = 5;
          return client_default().get("".concat((src_default()).fido.baseUrlsByAPIType.linkConverter, "/internal-paths")).query({
            'external-path': pathname
          }).then(function (response) {
            return response.body.internalPaths;
          });
        case 5:
          result = _context.sent;
          deeplink = result.find(function (_ref2) {
            var scopes = _ref2.scopes;
            return scopes.includes('rdk');
          });
          redirect(deeplink.path ? patchPath(deeplink.path) : DEFAULT_PATH);
          _context.next = 14;
          break;
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](2);
          console.error('[deeplink] Can not handle deeplink request, rerouting to the home screen');
          redirect(DEFAULT_PATH);
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 10]]);
  }));
  return function handleDeeplink() {
    return _ref.apply(this, arguments);
  };
}();
;// CONCATENATED MODULE: ./src/modules/app/utils/deeplink.utils.js

;// CONCATENATED MODULE: ./packages/lightningjs-redux/src/control.js


var CALLBACK_ERROR = "An error occurred while executing your controller's callback";
var SELECTOR_ERROR = "An error occurred inside your controller's selector";
var PREDICATE_ERROR = "An error occurred inside your controller's predicate";
var defaultCondition = function defaultCondition(_ref) {
  var currentProp = _ref.currentProp,
    previousProp = _ref.previousProp;
  return currentProp !== previousProp;
};
var controlUpdates = function controlUpdates(controllers, getState) {
  return function () {
    var state = getState();
    var keys = Object.keys(controllers);
    for (var i = 0; i < keys.length; i += 1) {
      var controller = controllers[keys[i]];
      var condition = controller.condition,
        selector = controller.selector,
        callback = controller.callback,
        _previousProp = controller._previousProp;
      var predicate = condition || defaultCondition;
      var currentProp = void 0;
      try {
        currentProp = selector(state);
      } catch (error) {
        throw new Error("".concat(SELECTOR_ERROR, " \"").concat(keys[i], "\": ").concat(error.stack));
      }
      var shouldUpdate = void 0;
      try {
        shouldUpdate = predicate({
          previousProp: _previousProp,
          currentProp: currentProp
        });
      } catch (error) {
        throw new Error("".concat(PREDICATE_ERROR, " \"").concat(keys[i], "\": ").concat(error.stack));
      }
      if (shouldUpdate) {
        controller._previousProp = currentProp;
        callback(currentProp);
      }
    }
  };
};
;// CONCATENATED MODULE: ./packages/lightningjs-redux/index.js








var Store = function () {
  function Store() {
    var _this = this;
    (0,classCallCheck/* default */.Z)(this, Store);
    this.cleanup = function () {
      _this._subscriptions.forEach(function (unsubscribe) {
        unsubscribe();
      });
      _this.dispatch = null;
      _this.getState = null;
      _this.subscribe = null;
      _this.replaceReducers = null;
      _this._subscriptions = [];
    };
  }
  (0,createClass/* default */.Z)(Store, [{
    key: "init",
    value: function init(_ref) {
      var dispatch = _ref.dispatch,
        getState = _ref.getState,
        subscribe = _ref.subscribe,
        replaceReducer = _ref.replaceReducer;
      this.dispatch = dispatch;
      this.getState = getState;
      this.subscribe = subscribe;
      this.replaceReducers = replaceReducer;
      this._subscriptions = [];
    }
  }, {
    key: "control",
    value: function control(controllers) {
      var _this2 = this;
      return function (instance) {
        var controllersToSubscribe = controllers(instance);
        var state = _this2.getState();
        var orderControllers = Array.isArray(controllersToSubscribe) ? controllersToSubscribe : Object.values(controllersToSubscribe);
        orderControllers.forEach(function (_ref2) {
          var selector = _ref2.selector,
            callback = _ref2.callback,
            shouldBeInvokedOnConnect = _ref2.shouldBeInvokedOnConnect;
          if (shouldBeInvokedOnConnect && callback && selector) {
            callback(selector(state));
          }
        });
        var unsubscribe = _this2.subscribe(controlUpdates(controllersToSubscribe, _this2.getState));
        var result = function result() {
          var keys = Object.keys(controllers);
          for (var i = 0; i < keys.length; i += 1) {
            var controller = controllers[keys[i]];
            controller._previousProp = undefined;
          }
          _this2._subscriptions = _this2._subscriptions.filter(function (subscription) {
            return subscription !== result;
          });
          unsubscribe();
        };
        _this2._subscriptions.push(result);
        return result;
      };
    }
  }]);
  return Store;
}();
/* harmony default export */ const lightningjs_redux = (new Store());
;// CONCATENATED MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@babel+runtime@7.22.3/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js

function objectWithoutProperties_objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/get.js
var lodash_get = __webpack_require__(65439);
var get_default = /*#__PURE__*/__webpack_require__.n(lodash_get);
;// CONCATENATED MODULE: ./packages/bedrock-rdk/constants/src/customer/default/common.constants.js
var OPTOUT = 'consentsmanagement_device';
;// CONCATENATED MODULE: ./packages/bedrock-rdk/constants/src/common.constants.js

var AUDIO = 'audio';
var BOOKMARK = 'bookmark';
var UNBOOKMARK = 'unbookmark';
var LIVE = 'live';
var LIVES = 'lives';
var PROGRAM = 'program';
var VIDEO = 'video';
var SERVICE = 'service';
var HOME_ALIAS = 'alias';
var SERVICES = 'services';
var PROFILE = 'account';
var SEARCH = 'search';
var SETTINGS = 'settings';
var FOLDERS = 'folders';
var FOLDER = 'folder';
var CLOSE = 'close';
var SIDENAV = 'sidenav';
var NAV_BACK = 'backNavigation';
var EXPLORE = 'explore';
var DISCONNECT_FOCUS_NAME = 'disconnectButton';
var AVATAR_LIST_FOCUS_NAME = 'avatarList';
var LAYOUT_FIRST_BLOCK = 'block_0';
var LOCK = 'lock';
var LOGOUT = 'logout';
var common_constants_FRONTSPACE = 'frontspace';
var PROFILES_GATE = 'profilesgate';
var PLAY = 'play';
var RADIO = 'radio';
var BOOKMARKS = 'account_bookmarks';
var ACCOUNT_SETTINGS = 'account_settings';
var INFORMATION = 'account_informations';
var common_constants_OPTOUT = OPTOUT;
var USAGE_TERMS = 'tos';
var LEGAL_CONDITIONS = 'account_legalconditions';
var PRIVACY_POLICY = 'privacy_policy';
var HELP = 'help';
var FEEDBACK = 'feedback';
var SUBSCRIPTION_TERMS = 'termsofsubscription';
var HD = 'HD';
var FULL_HD = 'FULL_HD';
var ULTRA_HD = 'ULTRA_HD';
;// CONCATENATED MODULE: ./packages/bedrock-rdk/constants/src/imageFormat.constants.js
var IMAGE_FORMAT_JPEG = 'jpeg';
var IMAGE_FORMAT_PNG = 'png';
var IMAGE_FORMAT_WEBP = 'webp';
;// CONCATENATED MODULE: ./packages/bedrock-rdk/constants/src/platform/default.js

var DEFAULT_IMAGE_FORMAT = IMAGE_FORMAT_WEBP;
var TRANSPARENT_IMAGE_FORMAT = IMAGE_FORMAT_PNG;
;// CONCATENATED MODULE: ./packages/bedrock-rdk/constants/src/image.constants.js



var IMAGE_FIT_SCALE_CROP = 'scale_crop';
var IMAGE_FIT_CROP = 'crop';
var IMAGE_FIT_MAX = 'max';
var IMAGE_QUALITY = 80;
var IMAGE_ITEMS_DEFAULT_OPTIONS = {
  image: {
    fit: IMAGE_FIT_SCALE_CROP,
    quality: IMAGE_QUALITY,
    format: DEFAULT_IMAGE_FORMAT,
    interlace: 1,
    blur: 0,
    width: 256,
    height: 256
  },
  logo: {
    fit: IMAGE_FIT_SCALE_CROP,
    quality: IMAGE_QUALITY,
    format: TRANSPARENT_IMAGE_FORMAT,
    interlace: 1
  }
};
;// CONCATENATED MODULE: ./packages/bedrock-rdk/constants/src/style.constants.js
var safetyMargins = {
  horizontal: {
    HD: 64,
    FULL_HD: 96
  },
  vertical: {
    HD: 40,
    FULL_HD: 56
  }
};
;// CONCATENATED MODULE: ./packages/bedrock-rdk/constants/src/index.js




// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.array.flat-map.js
var es_array_flat_map = __webpack_require__(45538);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.array.unscopables.flat-map.js
var es_array_unscopables_flat_map = __webpack_require__(20423);
;// CONCATENATED MODULE: ./packages/tornado-rdk/typography/src/constants.js
var FONT_TYPE = {
  MAIN: 'main',
  ALTERNATE: 'alternate'
};
var OPEN_TYPE_WEIGHT = {
  THIN: 100,
  EXTRA_LIGHT: 200,
  LIGHT: 300,
  REGULAR: 400,
  MEDIUM: 500,
  SEMIBOLD: 600,
  BOLD: 700,
  EXTRA_BOLD: 800,
  BLACK: 900
};
var FONT_WEIGHT = {
  ID_1: 'FONT_WEIGHT_1',
  ID_2: 'FONT_WEIGHT_2',
  ID_3: 'FONT_WEIGHT_3',
  ID_4: 'FONT_WEIGHT_4'
};
var constants_FONT = {
  TOKYO_4: 'tokyo_4',
  OSLO_1: 'oslo_1',
  OSLO_2: 'oslo_2',
  OSLO_3: 'oslo_3',
  PARIS_1: 'paris_1',
  PARIS_2: 'paris_2',
  PARIS_3: 'paris_3',
  KINSHASA_1: 'kinshasa_1',
  KINSHASA_2: 'kinshasa_2',
  KINSHASA_3: 'kinshasa_3',
  OTTAWA_1: 'ottawa_1',
  OTTAWA_2: 'ottawa_2',
  OTTAWA_3: 'ottawa_3',
  BERLIN_1: 'berlin_1',
  BERLIN_2: 'berlin_2',
  BERLIN_3: 'berlin_3',
  MADRID_1: 'madrid_1',
  MADRID_2: 'madrid_2',
  MADRID_3: 'madrid_3',
  BOSTON_1: 'boston_1',
  BOSTON_2: 'boston_2',
  BOSTON_3: 'boston_3',
  MEXICO_1: 'mexico_1',
  MEXICO_2: 'mexico_2',
  MEXICO_3: 'mexico_3',
  LYON_1: 'lyon_1',
  LYON_2: 'lyon_2',
  LYON_3: 'lyon_3'
};
;// CONCATENATED MODULE: ./packages/tornado-rdk/typography/src/fonts/RTLUnited/RTLUnitedText-Regular.woff
const RTLUnitedText_Regular_namespaceObject = __webpack_require__.p + "static/media/RTLUnitedText-Regular.086ac38f.woff";
;// CONCATENATED MODULE: ./packages/tornado-rdk/typography/src/fonts/RTLUnited/RTLUnitedText-Bold.woff
const RTLUnitedText_Bold_namespaceObject = __webpack_require__.p + "static/media/RTLUnitedText-Bold.26c120c5.woff";
;// CONCATENATED MODULE: ./packages/tornado-rdk/typography/src/utils.js
var makeFontDescriptor = function makeFontDescriptor(family, url, weight) {
  return {
    family: family,
    url: url,
    descriptors: {
      weight: weight
    }
  };
};
;// CONCATENATED MODULE: ./packages/tornado-rdk/typography/src/fonts/RTLUnited/RTLUnited.descriptors.js

var _fontWeightMap;




var fontFamily = 'Source Sans Pro';
var fontWeightMap = (_fontWeightMap = {}, (0,defineProperty/* default */.Z)(_fontWeightMap, FONT_WEIGHT.ID_1, OPEN_TYPE_WEIGHT.REGULAR), (0,defineProperty/* default */.Z)(_fontWeightMap, FONT_WEIGHT.ID_2, OPEN_TYPE_WEIGHT.REGULAR), (0,defineProperty/* default */.Z)(_fontWeightMap, FONT_WEIGHT.ID_3, OPEN_TYPE_WEIGHT.BOLD), (0,defineProperty/* default */.Z)(_fontWeightMap, FONT_WEIGHT.ID_4, OPEN_TYPE_WEIGHT.BOLD), _fontWeightMap);
var makeCurrentFontDescriptor = function makeCurrentFontDescriptor(url, weight) {
  return makeFontDescriptor(fontFamily, url, weight);
};
var descriptors = [makeCurrentFontDescriptor(RTLUnitedText_Regular_namespaceObject, fontWeightMap[FONT_WEIGHT.ID_1]), makeCurrentFontDescriptor(RTLUnitedText_Regular_namespaceObject, fontWeightMap[FONT_WEIGHT.ID_2]), makeCurrentFontDescriptor(RTLUnitedText_Bold_namespaceObject, fontWeightMap[FONT_WEIGHT.ID_3])];
;// CONCATENATED MODULE: ./packages/tornado-rdk/typography/src/customer/rtlde/fonts.js



var fonts = (0,defineProperty/* default */.Z)({}, FONT_TYPE.MAIN, RTLUnited_descriptors_namespaceObject);
;// CONCATENATED MODULE: ./packages/tornado-rdk/typography/src/dictionary.js





var _FONTS;
function dictionary_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function dictionary_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? dictionary_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : dictionary_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }




var dictionary_descriptors = Object.keys(fonts).flatMap(function (key) {
  return fonts[key].descriptors;
});
var byFontType = function byFontType(reducer) {
  return Object.keys(fonts).reduce(function (result, fontType) {
    return dictionary_objectSpread(dictionary_objectSpread({}, result), {}, (0,defineProperty/* default */.Z)({}, fontType, reducer(fonts[fontType])));
  }, {});
};
var makeFont = function makeFont(fontSize, lineHeight, weight) {
  return byFontType(function (_ref) {
    var fontFamily = _ref.fontFamily,
      fontWeightMap = _ref.fontWeightMap;
    return {
      fontSize: fontSize,
      lineHeight: lineHeight,
      fontFace: fontFamily,
      fontStyle: fontWeightMap[weight],
      textBaseline: 'bottom'
    };
  });
};
var makeFontTokyo = function makeFontTokyo(weight) {
  var _ref2;
  return _ref2 = {}, (0,defineProperty/* default */.Z)(_ref2, HD, makeFont(48, 62, weight)), (0,defineProperty/* default */.Z)(_ref2, FULL_HD, makeFont(64, 83, weight)), _ref2;
};
var makeFontOslo = function makeFontOslo(weight) {
  var _ref3;
  return _ref3 = {}, (0,defineProperty/* default */.Z)(_ref3, HD, makeFont(40, 52, weight)), (0,defineProperty/* default */.Z)(_ref3, FULL_HD, makeFont(48, 62, weight)), _ref3;
};
var makeFontParis = function makeFontParis(weight) {
  var _ref4;
  return _ref4 = {}, (0,defineProperty/* default */.Z)(_ref4, HD, makeFont(32, 48, weight)), (0,defineProperty/* default */.Z)(_ref4, FULL_HD, makeFont(36, 48, weight)), _ref4;
};
var makeFontKinshasa = function makeFontKinshasa(weight) {
  var _ref5;
  return _ref5 = {}, (0,defineProperty/* default */.Z)(_ref5, HD, makeFont(24, 36, weight)), (0,defineProperty/* default */.Z)(_ref5, FULL_HD, makeFont(32, 48, weight)), _ref5;
};
var makeFontOttawa = function makeFontOttawa(weight) {
  var _ref6;
  return _ref6 = {}, (0,defineProperty/* default */.Z)(_ref6, HD, makeFont(20, 30, weight)), (0,defineProperty/* default */.Z)(_ref6, FULL_HD, makeFont(24, 36, weight)), _ref6;
};
var makeFontBerlin = function makeFontBerlin(weight) {
  var _ref7;
  return _ref7 = {}, (0,defineProperty/* default */.Z)(_ref7, HD, makeFont(16, 24, weight)), (0,defineProperty/* default */.Z)(_ref7, FULL_HD, makeFont(20, 30, weight)), _ref7;
};
var makeFontMadrid = function makeFontMadrid(weight) {
  var _ref8;
  return _ref8 = {}, (0,defineProperty/* default */.Z)(_ref8, HD, makeFont(14, 21, weight)), (0,defineProperty/* default */.Z)(_ref8, FULL_HD, makeFont(18, 27, weight)), _ref8;
};
var makeFontBoston = function makeFontBoston(weight) {
  var _ref9;
  return _ref9 = {}, (0,defineProperty/* default */.Z)(_ref9, HD, makeFont(12, 18, weight)), (0,defineProperty/* default */.Z)(_ref9, FULL_HD, makeFont(16, 24, weight)), _ref9;
};
var makeFontMexico = function makeFontMexico(weight) {
  var _ref0;
  return _ref0 = {}, (0,defineProperty/* default */.Z)(_ref0, HD, makeFont(10, 15, weight)), (0,defineProperty/* default */.Z)(_ref0, FULL_HD, makeFont(14, 21, weight)), _ref0;
};
var makeFontLyon = function makeFontLyon(weight) {
  var _ref1;
  return _ref1 = {}, (0,defineProperty/* default */.Z)(_ref1, HD, makeFont(12, 12, weight)), (0,defineProperty/* default */.Z)(_ref1, FULL_HD, makeFont(24, 31, weight)), _ref1;
};
var FONTS = (_FONTS = {}, (0,defineProperty/* default */.Z)(_FONTS, constants_FONT.TOKYO_4, makeFontTokyo(FONT_WEIGHT.ID_4)), (0,defineProperty/* default */.Z)(_FONTS, constants_FONT.OSLO_1, makeFontOslo(FONT_WEIGHT.ID_1)), (0,defineProperty/* default */.Z)(_FONTS, constants_FONT.OSLO_2, makeFontOslo(FONT_WEIGHT.ID_2)), (0,defineProperty/* default */.Z)(_FONTS, constants_FONT.OSLO_3, makeFontOslo(FONT_WEIGHT.ID_3)), (0,defineProperty/* default */.Z)(_FONTS, constants_FONT.PARIS_1, makeFontParis(FONT_WEIGHT.ID_1)), (0,defineProperty/* default */.Z)(_FONTS, constants_FONT.PARIS_2, makeFontParis(FONT_WEIGHT.ID_2)), (0,defineProperty/* default */.Z)(_FONTS, constants_FONT.PARIS_3, makeFontParis(FONT_WEIGHT.ID_3)), (0,defineProperty/* default */.Z)(_FONTS, constants_FONT.KINSHASA_1, makeFontKinshasa(FONT_WEIGHT.ID_1)), (0,defineProperty/* default */.Z)(_FONTS, constants_FONT.KINSHASA_2, makeFontKinshasa(FONT_WEIGHT.ID_2)), (0,defineProperty/* default */.Z)(_FONTS, constants_FONT.KINSHASA_3, makeFontKinshasa(FONT_WEIGHT.ID_3)), (0,defineProperty/* default */.Z)(_FONTS, constants_FONT.OTTAWA_1, makeFontOttawa(FONT_WEIGHT.ID_1)), (0,defineProperty/* default */.Z)(_FONTS, constants_FONT.OTTAWA_2, makeFontOttawa(FONT_WEIGHT.ID_2)), (0,defineProperty/* default */.Z)(_FONTS, constants_FONT.OTTAWA_3, makeFontOttawa(FONT_WEIGHT.ID_3)), (0,defineProperty/* default */.Z)(_FONTS, constants_FONT.BERLIN_1, makeFontBerlin(FONT_WEIGHT.ID_1)), (0,defineProperty/* default */.Z)(_FONTS, constants_FONT.BERLIN_2, makeFontBerlin(FONT_WEIGHT.ID_2)), (0,defineProperty/* default */.Z)(_FONTS, constants_FONT.BERLIN_3, makeFontBerlin(FONT_WEIGHT.ID_3)), (0,defineProperty/* default */.Z)(_FONTS, constants_FONT.MADRID_1, makeFontMadrid(FONT_WEIGHT.ID_1)), (0,defineProperty/* default */.Z)(_FONTS, constants_FONT.MADRID_2, makeFontMadrid(FONT_WEIGHT.ID_2)), (0,defineProperty/* default */.Z)(_FONTS, constants_FONT.MADRID_3, makeFontMadrid(FONT_WEIGHT.ID_3)), (0,defineProperty/* default */.Z)(_FONTS, constants_FONT.BOSTON_1, makeFontBoston(FONT_WEIGHT.ID_1)), (0,defineProperty/* default */.Z)(_FONTS, constants_FONT.BOSTON_2, makeFontBoston(FONT_WEIGHT.ID_2)), (0,defineProperty/* default */.Z)(_FONTS, constants_FONT.BOSTON_3, makeFontBoston(FONT_WEIGHT.ID_3)), (0,defineProperty/* default */.Z)(_FONTS, constants_FONT.MEXICO_1, makeFontMexico(FONT_WEIGHT.ID_1)), (0,defineProperty/* default */.Z)(_FONTS, constants_FONT.MEXICO_2, makeFontMexico(FONT_WEIGHT.ID_2)), (0,defineProperty/* default */.Z)(_FONTS, constants_FONT.MEXICO_3, makeFontMexico(FONT_WEIGHT.ID_3)), (0,defineProperty/* default */.Z)(_FONTS, constants_FONT.LYON_1, makeFontLyon(FONT_WEIGHT.ID_1)), (0,defineProperty/* default */.Z)(_FONTS, constants_FONT.LYON_2, makeFontLyon(FONT_WEIGHT.ID_2)), (0,defineProperty/* default */.Z)(_FONTS, constants_FONT.LYON_3, makeFontLyon(FONT_WEIGHT.ID_3)), _FONTS);
;// CONCATENATED MODULE: ./packages/tornado-rdk/typography/src/index.js






var src_getFont = function getFont(name) {
  var resolution = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : FULL_HD;
  var fontType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : FONT_TYPE.MAIN;
  return get_default()(FONTS, [name, resolution, fontType], {});
};
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/mapKeys.js
var mapKeys = __webpack_require__(48347);
var mapKeys_default = /*#__PURE__*/__webpack_require__.n(mapKeys);
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/Accessibility.svg
const default_Accessibility_namespaceObject = __webpack_require__.p + "static/media/Accessibility.3f01f1ca.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/ActionPlan.svg
const ActionPlan_namespaceObject = __webpack_require__.p + "static/media/ActionPlan.b671873e.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Agenda.svg
const Agenda_namespaceObject = __webpack_require__.p + "static/media/Agenda.51bba883.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/Ages.svg
const Ages_namespaceObject = __webpack_require__.p + "static/media/Ages.2e7aaf9d.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/AirPlay.svg
const AirPlay_namespaceObject = __webpack_require__.p + "static/media/AirPlay.59da0576.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/AirPlayOff.svg
const AirPlayOff_namespaceObject = __webpack_require__.p + "static/media/AirPlayOff.59da0576.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/AirPlayOn.svg
const AirPlayOn_namespaceObject = __webpack_require__.p + "static/media/AirPlayOn.8ee4b338.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Alert.svg
const Alert_namespaceObject = __webpack_require__.p + "static/media/Alert.2eb73e88.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/AlertOff.svg
const AlertOff_namespaceObject = __webpack_require__.p + "static/media/AlertOff.eec16dc5.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/AlertOn.svg
const AlertOn_namespaceObject = __webpack_require__.p + "static/media/AlertOn.aae665ab.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/AlertUnread.svg
const AlertUnread_namespaceObject = __webpack_require__.p + "static/media/AlertUnread.57f39b2f.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/Android.svg
const Android_namespaceObject = __webpack_require__.p + "static/media/Android.c1c47c4e.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/Apple.svg
const Apple_namespaceObject = __webpack_require__.p + "static/media/Apple.d7b1cd91.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/ArrowDown.svg
const ArrowDown_namespaceObject = __webpack_require__.p + "static/media/ArrowDown.dc418c28.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/ArrowLeft.svg
const ArrowLeft_namespaceObject = __webpack_require__.p + "static/media/ArrowLeft.701bb55d.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/ArrowLeftWithBase.svg
const ArrowLeftWithBase_namespaceObject = __webpack_require__.p + "static/media/ArrowLeftWithBase.e6a2cbc5.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/ArrowRight.svg
const ArrowRight_namespaceObject = __webpack_require__.p + "static/media/ArrowRight.91479f31.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/ArrowRightWithBase.svg
const ArrowRightWithBase_namespaceObject = __webpack_require__.p + "static/media/ArrowRightWithBase.e11dc139.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/ArrowSideNav.svg
const ArrowSideNav_namespaceObject = __webpack_require__.p + "static/media/ArrowSideNav.91479f31.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/ArrowUp.svg
const ArrowUp_namespaceObject = __webpack_require__.p + "static/media/ArrowUp.57cca1bd.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Article.svg
const Article_namespaceObject = __webpack_require__.p + "static/media/Article.24e019d3.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Audio.svg
const Audio_namespaceObject = __webpack_require__.p + "static/media/Audio.96483395.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/Audiobook.svg
const Audiobook_namespaceObject = __webpack_require__.p + "static/media/Audiobook.d5e3acc4.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/BackSpace.svg
const BackSpace_namespaceObject = __webpack_require__.p + "static/media/BackSpace.f70b565e.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/BackToLive.svg
const BackToLive_namespaceObject = __webpack_require__.p + "static/media/BackToLive.a51a1c1a.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/BankCard.svg
const BankCard_namespaceObject = __webpack_require__.p + "static/media/BankCard.560a95bb.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Brightness.svg
const Brightness_namespaceObject = __webpack_require__.p + "static/media/Brightness.12a1c007.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Brightness1.svg
const Brightness1_namespaceObject = __webpack_require__.p + "static/media/Brightness1.7ddc253f.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Brightness2.svg
const Brightness2_namespaceObject = __webpack_require__.p + "static/media/Brightness2.b18cd040.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Brightness3.svg
const Brightness3_namespaceObject = __webpack_require__.p + "static/media/Brightness3.12a1c007.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Brightness4.svg
const Brightness4_namespaceObject = __webpack_require__.p + "static/media/Brightness4.36bdb7f9.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/BrightnessFilled.svg
const BrightnessFilled_namespaceObject = __webpack_require__.p + "static/media/BrightnessFilled.36bdb7f9.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Buffering.svg
const Buffering_namespaceObject = __webpack_require__.p + "static/media/Buffering.f768e774.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/CapsLock.svg
const CapsLock_namespaceObject = __webpack_require__.p + "static/media/CapsLock.c8decaa2.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Category.svg
const Category_namespaceObject = __webpack_require__.p + "static/media/Category.6e0ab06c.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/CategoryFocused.svg
const CategoryFocused_namespaceObject = __webpack_require__.p + "static/media/CategoryFocused.d4181b61.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/Chapter.svg
const Chapter_namespaceObject = __webpack_require__.p + "static/media/Chapter.3e4d37fc.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Check.svg
const Check_namespaceObject = __webpack_require__.p + "static/media/Check.9bbf6ece.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/CheckFocused.svg
const CheckFocused_namespaceObject = __webpack_require__.p + "static/media/CheckFocused.a227dc10.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/Chromecast.svg
const Chromecast_namespaceObject = __webpack_require__.p + "static/media/Chromecast.70471c47.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/ChromecastOff.svg
const ChromecastOff_namespaceObject = __webpack_require__.p + "static/media/ChromecastOff.70471c47.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/ChromecastOff1.svg
const ChromecastOff1_namespaceObject = __webpack_require__.p + "static/media/ChromecastOff1.82a5c113.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/ChromecastOff2.svg
const ChromecastOff2_namespaceObject = __webpack_require__.p + "static/media/ChromecastOff2.83de6ef9.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/ChromecastOn.svg
const ChromecastOn_namespaceObject = __webpack_require__.p + "static/media/ChromecastOn.e40dc116.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/ChromecastOn1.svg
const ChromecastOn1_namespaceObject = __webpack_require__.p + "static/media/ChromecastOn1.7a22a973.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/ChromecastOn2.svg
const ChromecastOn2_namespaceObject = __webpack_require__.p + "static/media/ChromecastOn2.5250aac6.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Clock.svg
const Clock_namespaceObject = __webpack_require__.p + "static/media/Clock.1f28e722.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Connected.svg
const Connected_namespaceObject = __webpack_require__.p + "static/media/Connected.2d1875f6.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/ConnectedFocused.svg
const ConnectedFocused_namespaceObject = __webpack_require__.p + "static/media/ConnectedFocused.47a8f31e.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/ConnectedPremium.svg
const ConnectedPremium_namespaceObject = __webpack_require__.p + "static/media/ConnectedPremium.d259f374.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/ConnectedPremiumColor.svg
const ConnectedPremiumColor_namespaceObject = __webpack_require__.p + "static/media/ConnectedPremiumColor.6dfb1b49.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/ConnectedPremiumFocused.svg
const ConnectedPremiumFocused_namespaceObject = __webpack_require__.p + "static/media/ConnectedPremiumFocused.5e35aa60.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/ConnectedPremiumFocusedColor.svg
const ConnectedPremiumFocusedColor_namespaceObject = __webpack_require__.p + "static/media/ConnectedPremiumFocusedColor.6dfb1b49.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Contact.svg
const Contact_namespaceObject = __webpack_require__.p + "static/media/Contact.d59e0b8e.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Cross.svg
const Cross_namespaceObject = __webpack_require__.p + "static/media/Cross.0e935258.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Csa10.svg
const Csa10_namespaceObject = __webpack_require__.p + "static/media/Csa10.218028de.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Csa12.svg
const Csa12_namespaceObject = __webpack_require__.p + "static/media/Csa12.c92fda9d.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Csa14.svg
const Csa14_namespaceObject = __webpack_require__.p + "static/media/Csa14.b5260e24.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Csa15.svg
const Csa15_namespaceObject = __webpack_require__.p + "static/media/Csa15.e7eac622.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Csa16.svg
const Csa16_namespaceObject = __webpack_require__.p + "static/media/Csa16.042df594.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Csa18.svg
const Csa18_namespaceObject = __webpack_require__.p + "static/media/Csa18.308ecfdf.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Csa6.svg
const Csa6_namespaceObject = __webpack_require__.p + "static/media/Csa6.8ed662f9.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Csa9.svg
const Csa9_namespaceObject = __webpack_require__.p + "static/media/Csa9.1ca71ac2.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/CsaAL.svg
const CsaAL_namespaceObject = __webpack_require__.p + "static/media/CsaAL.69e843ef.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Disconnected.svg
const Disconnected_namespaceObject = __webpack_require__.p + "static/media/Disconnected.47a8f31e.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Download.svg
const Download_namespaceObject = __webpack_require__.p + "static/media/Download.f159b918.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/DownloadIssue.svg
const DownloadIssue_namespaceObject = __webpack_require__.p + "static/media/DownloadIssue.50fd0ba4.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/DownloadPause.svg
const DownloadPause_namespaceObject = __webpack_require__.p + "static/media/DownloadPause.bb452e61.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/DownloadToGo.svg
const DownloadToGo_namespaceObject = __webpack_require__.p + "static/media/DownloadToGo.f159b918.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Downloaded.svg
const Downloaded_namespaceObject = __webpack_require__.p + "static/media/Downloaded.dc7d3e9d.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Downloading.svg
const Downloading_namespaceObject = __webpack_require__.p + "static/media/Downloading.aa89c972.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Ear.svg
const Ear_namespaceObject = __webpack_require__.p + "static/media/Ear.e5553986.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Edit.svg
const Edit_namespaceObject = __webpack_require__.p + "static/media/Edit.4098c025.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/EditFocused.svg
const EditFocused_namespaceObject = __webpack_require__.p + "static/media/EditFocused.c4899380.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Embed.svg
const Embed_namespaceObject = __webpack_require__.p + "static/media/Embed.aaa9f1fd.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Error.svg
const Error_namespaceObject = __webpack_require__.p + "static/media/Error.3d838715.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/ErrorEmoji.svg
const ErrorEmoji_namespaceObject = __webpack_require__.p + "static/media/ErrorEmoji.786b51cb.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/EyeOff.svg
const EyeOff_namespaceObject = __webpack_require__.p + "static/media/EyeOff.0867e3ce.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/EyeOn.svg
const EyeOn_namespaceObject = __webpack_require__.p + "static/media/EyeOn.65ddfbf6.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/Facebook.svg
const Facebook_namespaceObject = __webpack_require__.p + "static/media/Facebook.abd1f461.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/FacebookRectangle.svg
const FacebookRectangle_namespaceObject = __webpack_require__.p + "static/media/FacebookRectangle.e79df523.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/Fire.svg
const Fire_namespaceObject = __webpack_require__.p + "static/media/Fire.5f6b9079.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/FontType.svg
const FontType_namespaceObject = __webpack_require__.p + "static/media/FontType.010c054c.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Football.svg
const Football_namespaceObject = __webpack_require__.p + "static/media/Football.b2476838.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/FootballFocused.svg
const FootballFocused_namespaceObject = __webpack_require__.p + "static/media/FootballFocused.642a2829.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/FreemiumLock.svg
const FreemiumLock_namespaceObject = __webpack_require__.p + "static/media/FreemiumLock.dce9335d.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Genres.svg
const Genres_namespaceObject = __webpack_require__.p + "static/media/Genres.d3cf2dce.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Gift.svg
const Gift_namespaceObject = __webpack_require__.p + "static/media/Gift.8b792f8b.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/GoBack.svg
const GoBack_namespaceObject = __webpack_require__.p + "static/media/GoBack.701bb55d.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/Google.svg
const Google_namespaceObject = __webpack_require__.p + "static/media/Google.2ba98535.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/GooglePodcast.svg
const GooglePodcast_namespaceObject = __webpack_require__.p + "static/media/GooglePodcast.d9f03a09.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Help.svg
const Help_namespaceObject = __webpack_require__.p + "static/media/Help.d56df2f3.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/History.svg
const History_namespaceObject = __webpack_require__.p + "static/media/History.4ce97f77.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Home.svg
const Home_namespaceObject = __webpack_require__.p + "static/media/Home.f0e76f65.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/HomeFocused.svg
const HomeFocused_namespaceObject = __webpack_require__.p + "static/media/HomeFocused.70dd3403.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/IdealColor.svg
const IdealColor_namespaceObject = __webpack_require__.p + "static/media/IdealColor.5d84fef7.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/IdealDefault.svg
const IdealDefault_namespaceObject = __webpack_require__.p + "static/media/IdealDefault.5d84fef7.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Info.svg
const Info_namespaceObject = __webpack_require__.p + "static/media/Info.4b463f32.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/InfoFocused.svg
const InfoFocused_namespaceObject = __webpack_require__.p + "static/media/InfoFocused.8a5a6c4d.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/InfoLight.svg
const InfoLight_namespaceObject = __webpack_require__.p + "static/media/InfoLight.39a740d6.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/Instagram.svg
const Instagram_namespaceObject = __webpack_require__.p + "static/media/Instagram.c1174cb7.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/Itunes.svg
const Itunes_namespaceObject = __webpack_require__.p + "static/media/Itunes.e5ad4d2c.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/JustIn.svg
const JustIn_namespaceObject = __webpack_require__.p + "static/media/JustIn.2c86094e.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/KebabMenu.svg
const KebabMenu_namespaceObject = __webpack_require__.p + "static/media/KebabMenu.574cfca0.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/Kids.svg
const Kids_namespaceObject = __webpack_require__.p + "static/media/Kids.fb35edd5.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/KidsAge1.svg
const KidsAge1_namespaceObject = __webpack_require__.p + "static/media/KidsAge1.f9097369.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/KidsAge3.svg
const KidsAge3_namespaceObject = __webpack_require__.p + "static/media/KidsAge3.eee3e5a4.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/KidsAge4.svg
const KidsAge4_namespaceObject = __webpack_require__.p + "static/media/KidsAge4.c4256189.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/KidsAge6.svg
const KidsAge6_namespaceObject = __webpack_require__.p + "static/media/KidsAge6.88074c7d.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/KidsAge7.svg
const KidsAge7_namespaceObject = __webpack_require__.p + "static/media/KidsAge7.d2c31272.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/KidsFamily.svg
const KidsFamily_namespaceObject = __webpack_require__.p + "static/media/KidsFamily.2675a42e.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/KidsHome.svg
const KidsHome_namespaceObject = __webpack_require__.p + "static/media/KidsHome.5fc54cd2.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/KidsLeave.svg
const KidsLeave_namespaceObject = __webpack_require__.p + "static/media/KidsLeave.f589b794.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/KidsMovie.svg
const KidsMovie_namespaceObject = __webpack_require__.p + "static/media/KidsMovie.ee1abcfc.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/KidsSearch.svg
const KidsSearch_namespaceObject = __webpack_require__.p + "static/media/KidsSearch.421575bc.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/KidsSeries.svg
const KidsSeries_namespaceObject = __webpack_require__.p + "static/media/KidsSeries.a1013f7f.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Laptop.svg
const Laptop_namespaceObject = __webpack_require__.p + "static/media/Laptop.ee2a78c0.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Leaf1.svg
const Leaf1_namespaceObject = __webpack_require__.p + "static/media/Leaf1.c45ecb44.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Leaf2.svg
const Leaf2_namespaceObject = __webpack_require__.p + "static/media/Leaf2.a272da10.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Like.svg
const Like_namespaceObject = __webpack_require__.p + "static/media/Like.8dce879c.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Liked.svg
const Liked_namespaceObject = __webpack_require__.p + "static/media/Liked.31ccb34a.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Link.svg
const Link_namespaceObject = __webpack_require__.p + "static/media/Link.c8f099e4.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/ListAdd.svg
const ListAdd_namespaceObject = __webpack_require__.p + "static/media/ListAdd.8dce879c.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/ListAdded.svg
const ListAdded_namespaceObject = __webpack_require__.p + "static/media/ListAdded.31ccb34a.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/ListRemoved.svg
const ListRemoved_namespaceObject = __webpack_require__.p + "static/media/ListRemoved.8dce879c.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Live.svg
const Live_namespaceObject = __webpack_require__.p + "static/media/Live.bfc0cdc4.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Loading.svg
const Loading_namespaceObject = __webpack_require__.p + "static/media/Loading.f768e774.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Lock.svg
const Lock_namespaceObject = __webpack_require__.p + "static/media/Lock.48998dee.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Logout.svg
const Logout_namespaceObject = __webpack_require__.p + "static/media/Logout.dc53a946.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/MagicWand.svg
const MagicWand_namespaceObject = __webpack_require__.p + "static/media/MagicWand.87db276e.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/Monogram.svg
const Monogram_namespaceObject = __webpack_require__.p + "static/media/Monogram.25201bd6.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Movies.svg
const Movies_namespaceObject = __webpack_require__.p + "static/media/Movies.4d309d4f.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Offline.svg
const Offline_namespaceObject = __webpack_require__.p + "static/media/Offline.57a84db8.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/ParentalGuidanceDiscrimination.svg
const ParentalGuidanceDiscrimination_namespaceObject = __webpack_require__.p + "static/media/ParentalGuidanceDiscrimination.fe8ccaf0.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/ParentalGuidanceDrugs.svg
const ParentalGuidanceDrugs_namespaceObject = __webpack_require__.p + "static/media/ParentalGuidanceDrugs.839ecdf0.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/ParentalGuidanceFoulLanguage.svg
const ParentalGuidanceFoulLanguage_namespaceObject = __webpack_require__.p + "static/media/ParentalGuidanceFoulLanguage.855beb50.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/ParentalGuidanceScary.svg
const ParentalGuidanceScary_namespaceObject = __webpack_require__.p + "static/media/ParentalGuidanceScary.4d20dafd.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/ParentalGuidanceSex.svg
const ParentalGuidanceSex_namespaceObject = __webpack_require__.p + "static/media/ParentalGuidanceSex.4dda3902.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/ParentalGuidanceViolence.svg
const ParentalGuidanceViolence_namespaceObject = __webpack_require__.p + "static/media/ParentalGuidanceViolence.f5039447.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Pause.svg
const Pause_namespaceObject = __webpack_require__.p + "static/media/Pause.ce2552e7.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/Paypal.svg
const Paypal_namespaceObject = __webpack_require__.p + "static/media/Paypal.f8838067.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Phone.svg
const Phone_namespaceObject = __webpack_require__.p + "static/media/Phone.6391e561.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/Pinterest.svg
const Pinterest_namespaceObject = __webpack_require__.p + "static/media/Pinterest.12c4ddfc.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Play.svg
const Play_namespaceObject = __webpack_require__.p + "static/media/Play.dbd48217.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Playlist.svg
const Playlist_namespaceObject = __webpack_require__.p + "static/media/Playlist.e2219c0d.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/PlaylistFocused.svg
const PlaylistFocused_namespaceObject = __webpack_require__.p + "static/media/PlaylistFocused.bd9d628e.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Plus.svg
const Plus_namespaceObject = __webpack_require__.p + "static/media/Plus.81838775.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Podcast.svg
const Podcast_namespaceObject = __webpack_require__.p + "static/media/Podcast.c6f6038b.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Premium.svg
const Premium_namespaceObject = __webpack_require__.p + "static/media/Premium.a809bd90.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/PremiumColor.svg
const PremiumColor_namespaceObject = __webpack_require__.p + "static/media/PremiumColor.a809bd90.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/PrincipalProfile.svg
const PrincipalProfile_namespaceObject = __webpack_require__.p + "static/media/PrincipalProfile.0ddf32b5.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/ProductPlacement.svg
const ProductPlacement_namespaceObject = __webpack_require__.p + "static/media/ProductPlacement.757b8cf5.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Programs.svg
const Programs_namespaceObject = __webpack_require__.p + "static/media/Programs.e3e66f47.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Purchase.svg
const rtlde_Purchase_namespaceObject = __webpack_require__.p + "static/media/Purchase.7fcc50cf.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/QRCode.svg
const QRCode_namespaceObject = __webpack_require__.p + "static/media/QRCode.fa4e7703.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/RSS.svg
const RSS_namespaceObject = __webpack_require__.p + "static/media/RSS.1556f067.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Refresh.svg
const Refresh_namespaceObject = __webpack_require__.p + "static/media/Refresh.22716b43.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/RelatedVideos.svg
const RelatedVideos_namespaceObject = __webpack_require__.p + "static/media/RelatedVideos.c01a79da.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/RelatedVideosFocused.svg
const RelatedVideosFocused_namespaceObject = __webpack_require__.p + "static/media/RelatedVideosFocused.368f06ba.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Remote.svg
const Remote_namespaceObject = __webpack_require__.p + "static/media/Remote.6e849ee4.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Remove.svg
const Remove_namespaceObject = __webpack_require__.p + "static/media/Remove.99a4505d.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Search.svg
const Search_namespaceObject = __webpack_require__.p + "static/media/Search.c369209d.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/SearchFocused.svg
const SearchFocused_namespaceObject = __webpack_require__.p + "static/media/SearchFocused.f7a1ee64.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/SeekBackward.svg
const SeekBackward_namespaceObject = __webpack_require__.p + "static/media/SeekBackward.2eedae38.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/SeekBackwardFeedback.svg
const SeekBackwardFeedback_namespaceObject = __webpack_require__.p + "static/media/SeekBackwardFeedback.8f2c4654.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/SeekForward.svg
const SeekForward_namespaceObject = __webpack_require__.p + "static/media/SeekForward.3bdcbb6e.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/SeekForwardFeedback.svg
const SeekForwardFeedback_namespaceObject = __webpack_require__.p + "static/media/SeekForwardFeedback.c6deac2e.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Series.svg
const Series_namespaceObject = __webpack_require__.p + "static/media/Series.83a552fc.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Settings.svg
const rtlde_Settings_namespaceObject = __webpack_require__.p + "static/media/Settings.593cf370.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/SettingsEco1.svg
const SettingsEco1_namespaceObject = __webpack_require__.p + "static/media/SettingsEco1.9772158c.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/SettingsEco2.svg
const SettingsEco2_namespaceObject = __webpack_require__.p + "static/media/SettingsEco2.8a3ad2e3.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Share.svg
const Share_namespaceObject = __webpack_require__.p + "static/media/Share.eb551fc1.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/Share_Android.svg
const Share_Android_namespaceObject = __webpack_require__.p + "static/media/Share_Android.9dcbe71d.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/Share_iOS.svg
const Share_iOS_namespaceObject = __webpack_require__.p + "static/media/Share_iOS.a53140e9.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Shield.svg
const Shield_namespaceObject = __webpack_require__.p + "static/media/Shield.c04be000.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/SkipNext.svg
const SkipNext_namespaceObject = __webpack_require__.p + "static/media/SkipNext.4c0c5c7d.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/SkipNextFocused.svg
const SkipNextFocused_namespaceObject = __webpack_require__.p + "static/media/SkipNextFocused.a0011677.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/SkipPrevious.svg
const SkipPrevious_namespaceObject = __webpack_require__.p + "static/media/SkipPrevious.30fc6402.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/SkipPreviousFocused.svg
const SkipPreviousFocused_namespaceObject = __webpack_require__.p + "static/media/SkipPreviousFocused.1c6ff669.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Sliders.svg
const Sliders_namespaceObject = __webpack_require__.p + "static/media/Sliders.29e351e5.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/Slot.svg
const Slot_namespaceObject = __webpack_require__.p + "static/media/Slot.1c3e5c15.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Space.svg
const Space_namespaceObject = __webpack_require__.p + "static/media/Space.7e3d7271.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Speed.svg
const Speed_namespaceObject = __webpack_require__.p + "static/media/Speed.d43c749a.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/Star.svg
const Star_namespaceObject = __webpack_require__.p + "static/media/Star.4aec07a1.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/StartOver.svg
const StartOver_namespaceObject = __webpack_require__.p + "static/media/StartOver.78e63f1a.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Television.svg
const Television_namespaceObject = __webpack_require__.p + "static/media/Television.f7b6acb9.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/TelevisionFocused.svg
const TelevisionFocused_namespaceObject = __webpack_require__.p + "static/media/TelevisionFocused.3cdcfd85.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/TextIncrease.svg
const TextIncrease_namespaceObject = __webpack_require__.p + "static/media/TextIncrease.48e580f9.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/Tiktok.svg
const Tiktok_namespaceObject = __webpack_require__.p + "static/media/Tiktok.87d66c0f.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Timer.svg
const Timer_namespaceObject = __webpack_require__.p + "static/media/Timer.d3caf82c.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/TimerFocused.svg
const TimerFocused_namespaceObject = __webpack_require__.p + "static/media/TimerFocused.65d5087f.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Tracks.svg
const Tracks_namespaceObject = __webpack_require__.p + "static/media/Tracks.db48f176.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/TracksFilled.svg
const TracksFilled_namespaceObject = __webpack_require__.p + "static/media/TracksFilled.ec92a309.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Trailer.svg
const Trailer_namespaceObject = __webpack_require__.p + "static/media/Trailer.6b7f9678.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/Trash.svg
const Trash_namespaceObject = __webpack_require__.p + "static/media/Trash.5ec2abe7.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/Twitter.svg
const Twitter_namespaceObject = __webpack_require__.p + "static/media/Twitter.0254069d.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/UEFA.svg
const UEFA_namespaceObject = __webpack_require__.p + "static/media/UEFA.62eec7ae.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Univers.svg
const Univers_namespaceObject = __webpack_require__.p + "static/media/Univers.434cd91c.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Unlock.svg
const Unlock_namespaceObject = __webpack_require__.p + "static/media/Unlock.a4534c45.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Usabilla.svg
const Usabilla_namespaceObject = __webpack_require__.p + "static/media/Usabilla.b63e5a10.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Vocal.svg
const Vocal_namespaceObject = __webpack_require__.p + "static/media/Vocal.96483395.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Volume.svg
const Volume_namespaceObject = __webpack_require__.p + "static/media/Volume.768880c2.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Volume1.svg
const Volume1_namespaceObject = __webpack_require__.p + "static/media/Volume1.48fe1d19.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Volume2.svg
const Volume2_namespaceObject = __webpack_require__.p + "static/media/Volume2.92c430ba.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Volume3.svg
const Volume3_namespaceObject = __webpack_require__.p + "static/media/Volume3.bb8116df.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Volume4.svg
const Volume4_namespaceObject = __webpack_require__.p + "static/media/Volume4.768880c2.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/VolumeDown.svg
const VolumeDown_namespaceObject = __webpack_require__.p + "static/media/VolumeDown.bb8116df.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/VolumeFilled.svg
const VolumeFilled_namespaceObject = __webpack_require__.p + "static/media/VolumeFilled.6ab9624b.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/VolumeOff.svg
const VolumeOff_namespaceObject = __webpack_require__.p + "static/media/VolumeOff.01981d0e.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/VolumeUp.svg
const VolumeUp_namespaceObject = __webpack_require__.p + "static/media/VolumeUp.6ab9624b.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/Voting.svg
const Voting_namespaceObject = __webpack_require__.p + "static/media/Voting.06cc4244.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Warning.svg
const Warning_namespaceObject = __webpack_require__.p + "static/media/Warning.ef0ec3d3.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Wave.svg
const Wave_namespaceObject = __webpack_require__.p + "static/media/Wave.29e3dc6f.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Wave1.svg
const Wave1_namespaceObject = __webpack_require__.p + "static/media/Wave1.0dd0fc26.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Wave2.svg
const Wave2_namespaceObject = __webpack_require__.p + "static/media/Wave2.b19a7326.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Wave3.svg
const Wave3_namespaceObject = __webpack_require__.p + "static/media/Wave3.1d8560fa.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/Wave4.svg
const Wave4_namespaceObject = __webpack_require__.p + "static/media/Wave4.8d956451.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/WhatsApp.svg
const WhatsApp_namespaceObject = __webpack_require__.p + "static/media/WhatsApp.dad95280.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/Youtube.svg
const Youtube_namespaceObject = __webpack_require__.p + "static/media/Youtube.91e1e3c0.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/basic.js



























































































































































































































/* harmony default export */ const basic = ({
  Accessibility: default_Accessibility_namespaceObject,
  ActionPlan: ActionPlan_namespaceObject,
  Agenda: Agenda_namespaceObject,
  Ages: Ages_namespaceObject,
  AirPlay: AirPlay_namespaceObject,
  AirPlayOff: AirPlayOff_namespaceObject,
  AirPlayOn: AirPlayOn_namespaceObject,
  Alert: Alert_namespaceObject,
  AlertOff: AlertOff_namespaceObject,
  AlertOn: AlertOn_namespaceObject,
  AlertUnread: AlertUnread_namespaceObject,
  Android: Android_namespaceObject,
  Apple: Apple_namespaceObject,
  ArrowDown: ArrowDown_namespaceObject,
  ArrowLeft: ArrowLeft_namespaceObject,
  ArrowLeftWithBase: ArrowLeftWithBase_namespaceObject,
  ArrowRight: ArrowRight_namespaceObject,
  ArrowRightWithBase: ArrowRightWithBase_namespaceObject,
  ArrowSideNav: ArrowSideNav_namespaceObject,
  ArrowUp: ArrowUp_namespaceObject,
  Article: Article_namespaceObject,
  Audio: Audio_namespaceObject,
  Audiobook: Audiobook_namespaceObject,
  BackSpace: BackSpace_namespaceObject,
  BackToLive: BackToLive_namespaceObject,
  BankCard: BankCard_namespaceObject,
  Brightness: Brightness_namespaceObject,
  Brightness1: Brightness1_namespaceObject,
  Brightness2: Brightness2_namespaceObject,
  Brightness3: Brightness3_namespaceObject,
  Brightness4: Brightness4_namespaceObject,
  BrightnessFilled: BrightnessFilled_namespaceObject,
  Buffering: Buffering_namespaceObject,
  CapsLock: CapsLock_namespaceObject,
  Category: Category_namespaceObject,
  CategoryFocused: CategoryFocused_namespaceObject,
  Chapter: Chapter_namespaceObject,
  Check: Check_namespaceObject,
  CheckFocused: CheckFocused_namespaceObject,
  Chromecast: Chromecast_namespaceObject,
  ChromecastOff: ChromecastOff_namespaceObject,
  ChromecastOff1: ChromecastOff1_namespaceObject,
  ChromecastOff2: ChromecastOff2_namespaceObject,
  ChromecastOn: ChromecastOn_namespaceObject,
  ChromecastOn1: ChromecastOn1_namespaceObject,
  ChromecastOn2: ChromecastOn2_namespaceObject,
  Clock: Clock_namespaceObject,
  Connected: Connected_namespaceObject,
  ConnectedFocused: ConnectedFocused_namespaceObject,
  ConnectedPremium: ConnectedPremium_namespaceObject,
  ConnectedPremiumColor: ConnectedPremiumColor_namespaceObject,
  ConnectedPremiumFocused: ConnectedPremiumFocused_namespaceObject,
  ConnectedPremiumFocusedColor: ConnectedPremiumFocusedColor_namespaceObject,
  Contact: Contact_namespaceObject,
  Cross: Cross_namespaceObject,
  Csa10: Csa10_namespaceObject,
  Csa12: Csa12_namespaceObject,
  Csa14: Csa14_namespaceObject,
  Csa15: Csa15_namespaceObject,
  Csa16: Csa16_namespaceObject,
  Csa18: Csa18_namespaceObject,
  Csa6: Csa6_namespaceObject,
  Csa9: Csa9_namespaceObject,
  CsaAL: CsaAL_namespaceObject,
  Disconnected: Disconnected_namespaceObject,
  Download: Download_namespaceObject,
  DownloadIssue: DownloadIssue_namespaceObject,
  DownloadPause: DownloadPause_namespaceObject,
  DownloadToGo: DownloadToGo_namespaceObject,
  Downloaded: Downloaded_namespaceObject,
  Downloading: Downloading_namespaceObject,
  Ear: Ear_namespaceObject,
  Edit: Edit_namespaceObject,
  EditFocused: EditFocused_namespaceObject,
  Embed: Embed_namespaceObject,
  Error: Error_namespaceObject,
  ErrorEmoji: ErrorEmoji_namespaceObject,
  EyeOff: EyeOff_namespaceObject,
  EyeOn: EyeOn_namespaceObject,
  Facebook: Facebook_namespaceObject,
  FacebookRectangle: FacebookRectangle_namespaceObject,
  Fire: Fire_namespaceObject,
  FontType: FontType_namespaceObject,
  Football: Football_namespaceObject,
  FootballFocused: FootballFocused_namespaceObject,
  FreemiumLock: FreemiumLock_namespaceObject,
  Genres: Genres_namespaceObject,
  Gift: Gift_namespaceObject,
  GoBack: GoBack_namespaceObject,
  Google: Google_namespaceObject,
  GooglePodcast: GooglePodcast_namespaceObject,
  Help: Help_namespaceObject,
  History: History_namespaceObject,
  Home: Home_namespaceObject,
  HomeFocused: HomeFocused_namespaceObject,
  IdealColor: IdealColor_namespaceObject,
  IdealDefault: IdealDefault_namespaceObject,
  Info: Info_namespaceObject,
  InfoFocused: InfoFocused_namespaceObject,
  InfoLight: InfoLight_namespaceObject,
  Instagram: Instagram_namespaceObject,
  Itunes: Itunes_namespaceObject,
  JustIn: JustIn_namespaceObject,
  KebabMenu: KebabMenu_namespaceObject,
  Kids: Kids_namespaceObject,
  KidsAge1: KidsAge1_namespaceObject,
  KidsAge3: KidsAge3_namespaceObject,
  KidsAge4: KidsAge4_namespaceObject,
  KidsAge6: KidsAge6_namespaceObject,
  KidsAge7: KidsAge7_namespaceObject,
  KidsFamily: KidsFamily_namespaceObject,
  KidsHome: KidsHome_namespaceObject,
  KidsLeave: KidsLeave_namespaceObject,
  KidsMovie: KidsMovie_namespaceObject,
  KidsSearch: KidsSearch_namespaceObject,
  KidsSeries: KidsSeries_namespaceObject,
  Laptop: Laptop_namespaceObject,
  Leaf1: Leaf1_namespaceObject,
  Leaf2: Leaf2_namespaceObject,
  Like: Like_namespaceObject,
  Liked: Liked_namespaceObject,
  Link: Link_namespaceObject,
  ListAdd: ListAdd_namespaceObject,
  ListAdded: ListAdded_namespaceObject,
  ListRemoved: ListRemoved_namespaceObject,
  Live: Live_namespaceObject,
  Loading: Loading_namespaceObject,
  Lock: Lock_namespaceObject,
  Logout: Logout_namespaceObject,
  MagicWand: MagicWand_namespaceObject,
  Monogram: Monogram_namespaceObject,
  Movies: Movies_namespaceObject,
  Offline: Offline_namespaceObject,
  ParentalGuidanceDiscrimination: ParentalGuidanceDiscrimination_namespaceObject,
  ParentalGuidanceDrugs: ParentalGuidanceDrugs_namespaceObject,
  ParentalGuidanceFoulLanguage: ParentalGuidanceFoulLanguage_namespaceObject,
  ParentalGuidanceScary: ParentalGuidanceScary_namespaceObject,
  ParentalGuidanceSex: ParentalGuidanceSex_namespaceObject,
  ParentalGuidanceViolence: ParentalGuidanceViolence_namespaceObject,
  Pause: Pause_namespaceObject,
  Paypal: Paypal_namespaceObject,
  Phone: Phone_namespaceObject,
  Pinterest: Pinterest_namespaceObject,
  Play: Play_namespaceObject,
  Playlist: Playlist_namespaceObject,
  PlaylistFocused: PlaylistFocused_namespaceObject,
  Plus: Plus_namespaceObject,
  Podcast: Podcast_namespaceObject,
  Premium: Premium_namespaceObject,
  PremiumColor: PremiumColor_namespaceObject,
  PrincipalProfile: PrincipalProfile_namespaceObject,
  ProductPlacement: ProductPlacement_namespaceObject,
  Programs: Programs_namespaceObject,
  Purchase: rtlde_Purchase_namespaceObject,
  QRCode: QRCode_namespaceObject,
  RSS: RSS_namespaceObject,
  Refresh: Refresh_namespaceObject,
  RelatedVideos: RelatedVideos_namespaceObject,
  RelatedVideosFocused: RelatedVideosFocused_namespaceObject,
  Remote: Remote_namespaceObject,
  Remove: Remove_namespaceObject,
  Search: Search_namespaceObject,
  SearchFocused: SearchFocused_namespaceObject,
  SeekBackward: SeekBackward_namespaceObject,
  SeekBackwardFeedback: SeekBackwardFeedback_namespaceObject,
  SeekForward: SeekForward_namespaceObject,
  SeekForwardFeedback: SeekForwardFeedback_namespaceObject,
  Series: Series_namespaceObject,
  Settings: rtlde_Settings_namespaceObject,
  SettingsEco1: SettingsEco1_namespaceObject,
  SettingsEco2: SettingsEco2_namespaceObject,
  Share: Share_namespaceObject,
  Share_Android: Share_Android_namespaceObject,
  Share_iOS: Share_iOS_namespaceObject,
  Shield: Shield_namespaceObject,
  SkipNext: SkipNext_namespaceObject,
  SkipNextFocused: SkipNextFocused_namespaceObject,
  SkipPrevious: SkipPrevious_namespaceObject,
  SkipPreviousFocused: SkipPreviousFocused_namespaceObject,
  Sliders: Sliders_namespaceObject,
  Slot: Slot_namespaceObject,
  Space: Space_namespaceObject,
  Speed: Speed_namespaceObject,
  Star: Star_namespaceObject,
  StartOver: StartOver_namespaceObject,
  Television: Television_namespaceObject,
  TelevisionFocused: TelevisionFocused_namespaceObject,
  TextIncrease: TextIncrease_namespaceObject,
  Tiktok: Tiktok_namespaceObject,
  Timer: Timer_namespaceObject,
  TimerFocused: TimerFocused_namespaceObject,
  Tracks: Tracks_namespaceObject,
  TracksFilled: TracksFilled_namespaceObject,
  Trailer: Trailer_namespaceObject,
  Trash: Trash_namespaceObject,
  Twitter: Twitter_namespaceObject,
  UEFA: UEFA_namespaceObject,
  Univers: Univers_namespaceObject,
  Unlock: Unlock_namespaceObject,
  Usabilla: Usabilla_namespaceObject,
  Vocal: Vocal_namespaceObject,
  Volume: Volume_namespaceObject,
  Volume1: Volume1_namespaceObject,
  Volume2: Volume2_namespaceObject,
  Volume3: Volume3_namespaceObject,
  Volume4: Volume4_namespaceObject,
  VolumeDown: VolumeDown_namespaceObject,
  VolumeFilled: VolumeFilled_namespaceObject,
  VolumeOff: VolumeOff_namespaceObject,
  VolumeUp: VolumeUp_namespaceObject,
  Voting: Voting_namespaceObject,
  Warning: Warning_namespaceObject,
  Wave: Wave_namespaceObject,
  Wave1: Wave1_namespaceObject,
  Wave2: Wave2_namespaceObject,
  Wave3: Wave3_namespaceObject,
  Wave4: Wave4_namespaceObject,
  WhatsApp: WhatsApp_namespaceObject,
  Youtube: Youtube_namespaceObject
});
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/controls/AirPlay.svg
const controls_AirPlay_namespaceObject = __webpack_require__.p + "static/media/AirPlay.ff34072c.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/controls/AirPlayOff.svg
const controls_AirPlayOff_namespaceObject = __webpack_require__.p + "static/media/AirPlayOff.31aaff43.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/controls/AirPlayOn.svg
const controls_AirPlayOn_namespaceObject = __webpack_require__.p + "static/media/AirPlayOn.531e8597.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/ArrowDown.svg
const controls_ArrowDown_namespaceObject = __webpack_require__.p + "static/media/ArrowDown.a508a30f.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/ArrowLeftWithBase.svg
const controls_ArrowLeftWithBase_namespaceObject = __webpack_require__.p + "static/media/ArrowLeftWithBase.62bbf707.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/ArrowUp.svg
const controls_ArrowUp_namespaceObject = __webpack_require__.p + "static/media/ArrowUp.2a83c7d9.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/AudioDescription.svg
const AudioDescription_namespaceObject = __webpack_require__.p + "static/media/AudioDescription.6b1009a9.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/BackSpace.svg
const controls_BackSpace_namespaceObject = __webpack_require__.p + "static/media/BackSpace.9f0552b2.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/BackToLive.svg
const controls_BackToLive_namespaceObject = __webpack_require__.p + "static/media/BackToLive.a529dfff.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/BackToLiveHBBTV.svg
const BackToLiveHBBTV_namespaceObject = __webpack_require__.p + "static/media/BackToLiveHBBTV.2f344c33.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/Brightness.svg
const controls_Brightness_namespaceObject = __webpack_require__.p + "static/media/Brightness.1a6ac378.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/Brightness1.svg
const controls_Brightness1_namespaceObject = __webpack_require__.p + "static/media/Brightness1.95d2e3d1.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/Brightness2.svg
const controls_Brightness2_namespaceObject = __webpack_require__.p + "static/media/Brightness2.4314ce4e.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/Brightness3.svg
const controls_Brightness3_namespaceObject = __webpack_require__.p + "static/media/Brightness3.1a6ac378.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/Brightness4.svg
const controls_Brightness4_namespaceObject = __webpack_require__.p + "static/media/Brightness4.e8bd1d2e.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/BrightnessFilled.svg
const controls_BrightnessFilled_namespaceObject = __webpack_require__.p + "static/media/BrightnessFilled.e8bd1d2e.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/controls/Chapter.svg
const controls_Chapter_namespaceObject = __webpack_require__.p + "static/media/Chapter.17f896f4.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/controls/Chromecast.svg
const controls_Chromecast_namespaceObject = __webpack_require__.p + "static/media/Chromecast.f64ca20c.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/controls/ChromecastOff.svg
const controls_ChromecastOff_namespaceObject = __webpack_require__.p + "static/media/ChromecastOff.f64ca20c.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/controls/ChromecastOff1.svg
const controls_ChromecastOff1_namespaceObject = __webpack_require__.p + "static/media/ChromecastOff1.19b79b5c.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/controls/ChromecastOff2.svg
const controls_ChromecastOff2_namespaceObject = __webpack_require__.p + "static/media/ChromecastOff2.8885f29d.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/controls/ChromecastOn.svg
const controls_ChromecastOn_namespaceObject = __webpack_require__.p + "static/media/ChromecastOn.0027e48c.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/controls/ChromecastOn1.svg
const controls_ChromecastOn1_namespaceObject = __webpack_require__.p + "static/media/ChromecastOn1.6a35057e.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/controls/ChromecastOn2.svg
const controls_ChromecastOn2_namespaceObject = __webpack_require__.p + "static/media/ChromecastOn2.57329cf1.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/Contact.svg
const controls_Contact_namespaceObject = __webpack_require__.p + "static/media/Contact.ee88c7d9.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/ErrorEmoji.svg
const controls_ErrorEmoji_namespaceObject = __webpack_require__.p + "static/media/ErrorEmoji.945cd0ed.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/FullscreenOff.svg
const FullscreenOff_namespaceObject = __webpack_require__.p + "static/media/FullscreenOff.a7227844.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/FullscreenOn.svg
const FullscreenOn_namespaceObject = __webpack_require__.p + "static/media/FullscreenOn.b497bd2a.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/Info.svg
const controls_Info_namespaceObject = __webpack_require__.p + "static/media/Info.516b8f41.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/Pause.svg
const controls_Pause_namespaceObject = __webpack_require__.p + "static/media/Pause.c41cf297.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/controls/PictureInPicture.svg
const PictureInPicture_namespaceObject = __webpack_require__.p + "static/media/PictureInPicture.bd8c4e11.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/Play.svg
const controls_Play_namespaceObject = __webpack_require__.p + "static/media/Play.f4bfa5a9.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/Playlist.svg
const controls_Playlist_namespaceObject = __webpack_require__.p + "static/media/Playlist.2b02214e.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/PlaylistFocused.svg
const controls_PlaylistFocused_namespaceObject = __webpack_require__.p + "static/media/PlaylistFocused.1e4eeb53.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/RelatedVideos.svg
const controls_RelatedVideos_namespaceObject = __webpack_require__.p + "static/media/RelatedVideos.c370539d.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/Remote.svg
const controls_Remote_namespaceObject = __webpack_require__.p + "static/media/Remote.8b7928a0.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/Replay.svg
const Replay_namespaceObject = __webpack_require__.p + "static/media/Replay.b3064056.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/SeekBackward.svg
const controls_SeekBackward_namespaceObject = __webpack_require__.p + "static/media/SeekBackward.889f7129.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/SeekBackwardFeedback.svg
const controls_SeekBackwardFeedback_namespaceObject = __webpack_require__.p + "static/media/SeekBackwardFeedback.71381e29.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/SeekForward.svg
const controls_SeekForward_namespaceObject = __webpack_require__.p + "static/media/SeekForward.58aa0f30.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/SeekForwardFeedback.svg
const controls_SeekForwardFeedback_namespaceObject = __webpack_require__.p + "static/media/SeekForwardFeedback.a7323810.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/Settings.svg
const controls_Settings_namespaceObject = __webpack_require__.p + "static/media/Settings.4b321d40.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/SettingsEco1.svg
const controls_SettingsEco1_namespaceObject = __webpack_require__.p + "static/media/SettingsEco1.858a78c2.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/SettingsEco2.svg
const controls_SettingsEco2_namespaceObject = __webpack_require__.p + "static/media/SettingsEco2.00b683f5.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/Share.svg
const controls_Share_namespaceObject = __webpack_require__.p + "static/media/Share.a5c1f298.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/SkipNext.svg
const controls_SkipNext_namespaceObject = __webpack_require__.p + "static/media/SkipNext.1f871238.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/controls/SkipNextFocused.svg
const controls_SkipNextFocused_namespaceObject = __webpack_require__.p + "static/media/SkipNextFocused.e18de880.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/SkipPrevious.svg
const controls_SkipPrevious_namespaceObject = __webpack_require__.p + "static/media/SkipPrevious.72cd2fc7.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/controls/SkipPreviousFocused.svg
const controls_SkipPreviousFocused_namespaceObject = __webpack_require__.p + "static/media/SkipPreviousFocused.871557f2.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/Space.svg
const controls_Space_namespaceObject = __webpack_require__.p + "static/media/Space.2d0bbd6b.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/Speed.svg
const controls_Speed_namespaceObject = __webpack_require__.p + "static/media/Speed.9a7cbc89.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/StartOver.svg
const controls_StartOver_namespaceObject = __webpack_require__.p + "static/media/StartOver.df618be0.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/SwitchAudioIcon.svg
const SwitchAudioIcon_namespaceObject = __webpack_require__.p + "static/media/SwitchAudioIcon.24133bd1.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/SwitchVideoIcon.svg
const SwitchVideoIcon_namespaceObject = __webpack_require__.p + "static/media/SwitchVideoIcon.766f5524.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/Timer.svg
const controls_Timer_namespaceObject = __webpack_require__.p + "static/media/Timer.e46c70d1.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/TimerFocused.svg
const controls_TimerFocused_namespaceObject = __webpack_require__.p + "static/media/TimerFocused.9df49df5.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/Tracks.svg
const controls_Tracks_namespaceObject = __webpack_require__.p + "static/media/Tracks.9a615419.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/TracksFilled.svg
const controls_TracksFilled_namespaceObject = __webpack_require__.p + "static/media/TracksFilled.d6b83940.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/Usabilla.svg
const controls_Usabilla_namespaceObject = __webpack_require__.p + "static/media/Usabilla.6eaeaf75.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/VOST.svg
const VOST_namespaceObject = __webpack_require__.p + "static/media/VOST.b6430488.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/Volume.svg
const controls_Volume_namespaceObject = __webpack_require__.p + "static/media/Volume.f7ec8669.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/Volume1.svg
const controls_Volume1_namespaceObject = __webpack_require__.p + "static/media/Volume1.b5d8cd46.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/Volume2.svg
const controls_Volume2_namespaceObject = __webpack_require__.p + "static/media/Volume2.e855fb0d.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/Volume3.svg
const controls_Volume3_namespaceObject = __webpack_require__.p + "static/media/Volume3.13d70696.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/Volume4.svg
const controls_Volume4_namespaceObject = __webpack_require__.p + "static/media/Volume4.c42ad370.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/VolumeDown.svg
const controls_VolumeDown_namespaceObject = __webpack_require__.p + "static/media/VolumeDown.c2c8ba31.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/VolumeFilled.svg
const controls_VolumeFilled_namespaceObject = __webpack_require__.p + "static/media/VolumeFilled.dacf91a5.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/VolumeOff.svg
const controls_VolumeOff_namespaceObject = __webpack_require__.p + "static/media/VolumeOff.095d6cd1.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/controls/VolumeUp.svg
const controls_VolumeUp_namespaceObject = __webpack_require__.p + "static/media/VolumeUp.c42ad370.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/controls.js





































































/* harmony default export */ const controls = ({
  AirPlay: controls_AirPlay_namespaceObject,
  AirPlayOff: controls_AirPlayOff_namespaceObject,
  AirPlayOn: controls_AirPlayOn_namespaceObject,
  ArrowDown: controls_ArrowDown_namespaceObject,
  ArrowLeftWithBase: controls_ArrowLeftWithBase_namespaceObject,
  ArrowUp: controls_ArrowUp_namespaceObject,
  AudioDescription: AudioDescription_namespaceObject,
  BackSpace: controls_BackSpace_namespaceObject,
  BackToLive: controls_BackToLive_namespaceObject,
  BackToLiveHBBTV: BackToLiveHBBTV_namespaceObject,
  Brightness: controls_Brightness_namespaceObject,
  Brightness1: controls_Brightness1_namespaceObject,
  Brightness2: controls_Brightness2_namespaceObject,
  Brightness3: controls_Brightness3_namespaceObject,
  Brightness4: controls_Brightness4_namespaceObject,
  BrightnessFilled: controls_BrightnessFilled_namespaceObject,
  Chapter: controls_Chapter_namespaceObject,
  Chromecast: controls_Chromecast_namespaceObject,
  ChromecastOff: controls_ChromecastOff_namespaceObject,
  ChromecastOff1: controls_ChromecastOff1_namespaceObject,
  ChromecastOff2: controls_ChromecastOff2_namespaceObject,
  ChromecastOn: controls_ChromecastOn_namespaceObject,
  ChromecastOn1: controls_ChromecastOn1_namespaceObject,
  ChromecastOn2: controls_ChromecastOn2_namespaceObject,
  Contact: controls_Contact_namespaceObject,
  ErrorEmoji: controls_ErrorEmoji_namespaceObject,
  FullscreenOff: FullscreenOff_namespaceObject,
  FullscreenOn: FullscreenOn_namespaceObject,
  Info: controls_Info_namespaceObject,
  Pause: controls_Pause_namespaceObject,
  PictureInPicture: PictureInPicture_namespaceObject,
  Play: controls_Play_namespaceObject,
  Playlist: controls_Playlist_namespaceObject,
  PlaylistFocused: controls_PlaylistFocused_namespaceObject,
  RelatedVideos: controls_RelatedVideos_namespaceObject,
  Remote: controls_Remote_namespaceObject,
  Replay: Replay_namespaceObject,
  SeekBackward: controls_SeekBackward_namespaceObject,
  SeekBackwardFeedback: controls_SeekBackwardFeedback_namespaceObject,
  SeekForward: controls_SeekForward_namespaceObject,
  SeekForwardFeedback: controls_SeekForwardFeedback_namespaceObject,
  Settings: controls_Settings_namespaceObject,
  SettingsEco1: controls_SettingsEco1_namespaceObject,
  SettingsEco2: controls_SettingsEco2_namespaceObject,
  Share: controls_Share_namespaceObject,
  SkipNext: controls_SkipNext_namespaceObject,
  SkipNextFocused: controls_SkipNextFocused_namespaceObject,
  SkipPrevious: controls_SkipPrevious_namespaceObject,
  SkipPreviousFocused: controls_SkipPreviousFocused_namespaceObject,
  Space: controls_Space_namespaceObject,
  Speed: controls_Speed_namespaceObject,
  StartOver: controls_StartOver_namespaceObject,
  SwitchAudioIcon: SwitchAudioIcon_namespaceObject,
  SwitchVideoIcon: SwitchVideoIcon_namespaceObject,
  Timer: controls_Timer_namespaceObject,
  TimerFocused: controls_TimerFocused_namespaceObject,
  Tracks: controls_Tracks_namespaceObject,
  TracksFilled: controls_TracksFilled_namespaceObject,
  Usabilla: controls_Usabilla_namespaceObject,
  VOST: VOST_namespaceObject,
  Volume: controls_Volume_namespaceObject,
  Volume1: controls_Volume1_namespaceObject,
  Volume2: controls_Volume2_namespaceObject,
  Volume3: controls_Volume3_namespaceObject,
  Volume4: controls_Volume4_namespaceObject,
  VolumeDown: controls_VolumeDown_namespaceObject,
  VolumeFilled: controls_VolumeFilled_namespaceObject,
  VolumeOff: controls_VolumeOff_namespaceObject,
  VolumeUp: controls_VolumeUp_namespaceObject
});
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/special/ArrowLeftWithBase.svg
const special_ArrowLeftWithBase_namespaceObject = __webpack_require__.p + "static/media/ArrowLeftWithBase.f7fc7769.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/special/AudioDescription.svg
const special_AudioDescription_namespaceObject = __webpack_require__.p + "static/media/AudioDescription.c5c7ebb4.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/special/BackToLive.svg
const special_BackToLive_namespaceObject = __webpack_require__.p + "static/media/BackToLive.6ed55b8f.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/special/Chapter.svg
const special_Chapter_namespaceObject = __webpack_require__.p + "static/media/Chapter.8ce3ec9e.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/special/Cross.svg
const special_Cross_namespaceObject = __webpack_require__.p + "static/media/Cross.e6075448.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/special/Info.svg
const special_Info_namespaceObject = __webpack_require__.p + "static/media/Info.fe68d825.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/special/Live.svg
const special_Live_namespaceObject = __webpack_require__.p + "static/media/Live.3c45df6e.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/special/MultiDevices.svg
const MultiDevices_namespaceObject = __webpack_require__.p + "static/media/MultiDevices.e62cbb30.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/special/RelatedVideos.svg
const special_RelatedVideos_namespaceObject = __webpack_require__.p + "static/media/RelatedVideos.99ceaac8.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/special/Remote.svg
const special_Remote_namespaceObject = __webpack_require__.p + "static/media/Remote.eb832505.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/special/SkipNext.svg
const special_SkipNext_namespaceObject = __webpack_require__.p + "static/media/SkipNext.2c6cabd0.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/special/SkipNextFocused.svg
const special_SkipNextFocused_namespaceObject = __webpack_require__.p + "static/media/SkipNextFocused.40d33463.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/special/SkipPrevious.svg
const special_SkipPrevious_namespaceObject = __webpack_require__.p + "static/media/SkipPrevious.1e469de5.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/default/special/SkipPreviousFocused.svg
const special_SkipPreviousFocused_namespaceObject = __webpack_require__.p + "static/media/SkipPreviousFocused.1e469de5.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/special/StartOver.svg
const special_StartOver_namespaceObject = __webpack_require__.p + "static/media/StartOver.dad39133.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/special/Tracks.svg
const special_Tracks_namespaceObject = __webpack_require__.p + "static/media/Tracks.573bc853.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/special/Usabilla.svg
const special_Usabilla_namespaceObject = __webpack_require__.p + "static/media/Usabilla.144e136f.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/assets/customer/rtlde/special/VOST.svg
const special_VOST_namespaceObject = __webpack_require__.p + "static/media/VOST.f3221cae.svg";
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/special.js


















/* harmony default export */ const special = ({
  ArrowLeftWithBase: special_ArrowLeftWithBase_namespaceObject,
  AudioDescription: special_AudioDescription_namespaceObject,
  BackToLive: special_BackToLive_namespaceObject,
  Chapter: special_Chapter_namespaceObject,
  Cross: special_Cross_namespaceObject,
  Info: special_Info_namespaceObject,
  Live: special_Live_namespaceObject,
  MultiDevices: MultiDevices_namespaceObject,
  RelatedVideos: special_RelatedVideos_namespaceObject,
  Remote: special_Remote_namespaceObject,
  SkipNext: special_SkipNext_namespaceObject,
  SkipNextFocused: special_SkipNextFocused_namespaceObject,
  SkipPrevious: special_SkipPrevious_namespaceObject,
  SkipPreviousFocused: special_SkipPreviousFocused_namespaceObject,
  StartOver: special_StartOver_namespaceObject,
  Tracks: special_Tracks_namespaceObject,
  Usabilla: special_Usabilla_namespaceObject,
  VOST: special_VOST_namespaceObject
});
;// CONCATENATED MODULE: ./packages/tornado-rdk/icons/src/index.js



var _mapping;






var ICON_COLLECTION = {
  BASIC: 'basic',
  CONTROLS: 'controls',
  SPECIAL: 'special'
};
var objectKeysToLowerCase = function objectKeysToLowerCase(obj) {
  return mapKeys_default()(obj, function (_, k) {
    return k.toLowerCase();
  });
};
var mapping = (_mapping = {}, (0,defineProperty/* default */.Z)(_mapping, ICON_COLLECTION.BASIC, objectKeysToLowerCase(basic)), (0,defineProperty/* default */.Z)(_mapping, ICON_COLLECTION.CONTROLS, objectKeysToLowerCase(controls)), (0,defineProperty/* default */.Z)(_mapping, ICON_COLLECTION.SPECIAL, objectKeysToLowerCase(special)), _mapping);
var getBasePath = memoize_default()(function () {
  return window.location.origin || "".concat(window.location.protocol, "//").concat(window.location.host || window.location.hostname);
});
var getCollectionById = function getCollectionById(collectionId) {
  return mapping[collectionId] || basic;
};
var iconByName = function iconByName(name) {
  var collection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ICON_COLLECTION.BASIC;
  return getCollectionById(collection)[name];
};
var createSvg = function createSvg(callback, stage, url, width, height) {
  var scale = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;
  var canvas = stage.platform.getDrawingCanvas();
  var context = canvas.getContext('2d');
  context.imageSmoothingEnabled = scale === 1;
  var image = new Image();
  image.onload = function () {
    var imageWidth = image.width;
    var imageHeight = image.height;
    var viewBoxWidth = width || 0;
    var viewBoxHeight = height;
    var horizontalRatio = viewBoxWidth ? imageWidth / viewBoxWidth : 0;
    var verticalRatio = viewBoxHeight ? imageHeight / viewBoxHeight : 0;
    var scaleRatio = horizontalRatio > verticalRatio ? viewBoxWidth / imageWidth : viewBoxHeight / imageHeight;
    canvas.width = Math.round(imageWidth * scaleRatio);
    canvas.height = Math.round(imageHeight * scaleRatio);
    canvas.width *= scale;
    canvas.height *= scale;
    context.drawImage(image, 0, 0, canvas.width, canvas.height);
    callback(null, canvas);
  };
  image.onError = function (error) {
    callback(error);
  };
  if (!src_Lightning.Utils.isPS4) {
    image.crossOrigin = 'Anonymous';
  }
  image.src = url;
};
var getSvgTexture = function getSvgTexture(url, w, h) {
  var scale = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  var factory = function factory(callback, stage) {
    if (src_Lightning.Utils.isSpark) {
      stage.platform.createSvg(callback, stage, url, w, h);
    } else {
      createSvg(callback, stage, url, w, h, scale);
    }
  };
  var id = "svg".concat([w, h, scale, url].join(','));
  return src_Lightning.Tools.getCanvasTexture(factory, id);
};






// EXTERNAL MODULE: ./packages/bedrock-rdk/utils/src/env.js
var env = __webpack_require__(59554);
// EXTERNAL MODULE: ./node_modules/.pnpm/superagent@6.1.0/node_modules/superagent/lib/client.js
var lib_client = __webpack_require__(48104);
var lib_client_default = /*#__PURE__*/__webpack_require__.n(lib_client);
;// CONCATENATED MODULE: ./packages/bedrock-rdk/utils/src/http.js



var httpRequestTimeout = 5000;
var getRequestLogger = function getRequestLogger() {
  var debug = (src_default()).debug;
  var requestLogger = function requestLogger(x) {
    return x;
  };
  if (debug) {
    requestLogger = function requestLogger(requestHandler) {
      return requestHandler.on('response', function (response) {
        console.log("".concat(requestHandler.method, " ").concat(response.status, " ").concat(requestHandler.url));
      });
    };
  }
  return requestLogger;
};
var requestGet = function requestGet(path) {
  var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var timeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : httpRequestTimeout;
  return lib_client_default().get(path).set(headers).use(getRequestLogger).query(query).timeout(timeout);
};
var requestPost = function requestPost(path, body) {
  var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var timeout = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : httpRequestTimeout;
  return lib_client_default().post(path).set(headers).use(getRequestLogger).query(query).send(body).timeout(timeout);
};
;// CONCATENATED MODULE: ./packages/bedrock-rdk/utils/src/debug.js












function format(param) {
  if (get_default()(param, 'current') instanceof HTMLElement) {
    var instance = Object.keys(param.current)[0];
    var fiberNode = param.current[instance];
    if (get_default()(fiberNode, 'pendingProps.children')) {
      var children = fiberNode.pendingProps.children;
      if (Array.isArray(children)) {
        var formatedChildren = children.map(format);
        return {
          type: fiberNode.elementType,
          children: formatedChildren
        };
      }
      if (children.$$typeof) {
        return {
          type: fiberNode.elementType,
          child: format(children)
        };
      }
    }
    return {
      type: fiberNode.elementType,
      pendingProps: fiberNode.pendingProps
    };
  }
  if (param && param.$$typeof && param.$$typeof.toString() === 'Symbol(react.element)') {
    return {
      type: param.type,
      props: param.props
    };
  }
  if (param instanceof HTMLElement) {
    return JSON.stringify(param, ['name', 'class', 'data-testid'], 2);
  }
  if (typeof param === 'function') {
    return param.toString();
  }
  return param;
}
var sendLog = function () {
  var _ref = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(messages, type) {
    var logInConsole,
      APP_REMOTE_DEBUGGER,
      finalMessage,
      _args = arguments;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          logInConsole = _args.length > 2 && _args[2] !== undefined ? _args[2] : true;
          if (!(!(src_default()).debug || env.isProdApp)) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return");
        case 3:
          APP_REMOTE_DEBUGGER = null;
          _context.prev = 4;
          finalMessage = messages.map(format).join(' ');
          if (console && logInConsole) {
            (console[type] || console.log).apply(console, [finalMessage]);
          }
          if (!(APP_REMOTE_DEBUGGER && !env.isProdApp)) {
            _context.next = 10;
            break;
          }
          _context.next = 10;
          return requestPost("http://".concat(APP_REMOTE_DEBUGGER, ":5555"), {
            message: finalMessage,
            type: type
          });
        case 10:
          _context.next = 15;
          break;
        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](4);
          console.warn("Log wasnt sent to remote debugger. Reason:\n".concat(_context.t0.message));
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[4, 12]]);
  }));
  return function sendLog(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var logger = {
  log: function log() {
    for (var _len = arguments.length, message = new Array(_len), _key = 0; _key < _len; _key++) {
      message[_key] = arguments[_key];
    }
    return sendLog(message, 'log');
  },
  info: function info() {
    for (var _len2 = arguments.length, message = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      message[_key2] = arguments[_key2];
    }
    return sendLog(message, 'info');
  },
  success: function success() {
    for (var _len3 = arguments.length, message = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      message[_key3] = arguments[_key3];
    }
    return sendLog(message, 'success');
  },
  warn: function warn() {
    for (var _len4 = arguments.length, message = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      message[_key4] = arguments[_key4];
    }
    return sendLog(message, 'warn');
  },
  error: function error() {
    for (var _len5 = arguments.length, message = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      message[_key5] = arguments[_key5];
    }
    return sendLog(message, 'error');
  }
};
/* harmony default export */ const debug = ((/* unused pure expression or super */ null && (logger)));
// EXTERNAL MODULE: ./node_modules/.pnpm/crypto-js@4.0.0/node_modules/crypto-js/hmac-sha1.js
var hmac_sha1 = __webpack_require__(43911);
var hmac_sha1_default = /*#__PURE__*/__webpack_require__.n(hmac_sha1);
;// CONCATENATED MODULE: ./packages/bedrock-rdk/utils/src/deviceId.js




var isValidDeviceId = function isValidDeviceId(deviceId) {
  return deviceId.indexOf('-Z-') !== -1;
};
var randomInt = function randomInt(a, b) {
  var ceilA = Math.ceil(a);
  var floorB = Math.floor(b);
  return Math.floor(Math.random() * (floorB - ceilA)) + ceilA;
};
var fixDeviceId = function fixDeviceId(deviceId) {
  return "".concat(deviceId, "-Z-").concat(randomInt(0, 1e6));
};
var generateDeviceId = function generateDeviceId() {
  var prefix = 'deviceid';
  var uniqueID = hmac_sha1_default()(randomInt(0, 1e6), randomInt(0, 1e6).toString());
  var salt = Date.now();
  var suffix = randomInt(0, 1e6);
  return "".concat(prefix, "-").concat(uniqueID, "-").concat(salt, "-Z-").concat(suffix);
};
/* harmony default export */ const deviceId = (generateDeviceId);
;// CONCATENATED MODULE: ./packages/bedrock-rdk/utils/src/storage/lightningSdkStorage.js






function lightningSdkStorage_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function lightningSdkStorage_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? lightningSdkStorage_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : lightningSdkStorage_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var TEST_KEY = 'storage';
var TEST_VALUE = 'item';
var expirationTimestamp = Date.now() + 365 * 24 * 60 * 60 * 1000;
var maxExpirationTimestamp = 2147483647000;
var expirationDate = function expirationDate(shouldExpire) {
  return shouldExpire ? expirationTimestamp : maxExpirationTimestamp;
};
var LightningSdkStorage = function () {
  function LightningSdkStorage() {
    (0,classCallCheck/* default */.Z)(this, LightningSdkStorage);
    this._storage = Storage;
  }
  (0,createClass/* default */.Z)(LightningSdkStorage, [{
    key: "getItem",
    value: function getItem(key) {
      var _ref = this._storage.get(key) || {},
        _ref$value = _ref.value,
        value = _ref$value === void 0 ? null : _ref$value,
        _ref$expires = _ref.expires,
        expires = _ref$expires === void 0 ? null : _ref$expires;
      var currentTime = Date.now();
      if (expires && currentTime > expires) {
        this._storage.remove(key);
        return null;
      }
      return value;
    }
  }, {
    key: "getItems",
    value: function getItems() {
      var _this = this;
      var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return keys.reduce(function (acc, key) {
        var value = _this.getItem(key);
        return lightningSdkStorage_objectSpread(lightningSdkStorage_objectSpread({}, acc), {}, (0,defineProperty/* default */.Z)({}, key, value));
      }, {});
    }
  }, {
    key: "setItem",
    value: function setItem(key, value) {
      var expire = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var newStorageItem = {
        value: value,
        expires: expirationDate(expire)
      };
      this._storage.set(key, newStorageItem);
      return value;
    }
  }, {
    key: "setItems",
    value: function setItems() {
      var _this2 = this;
      var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var expire = arguments.length > 1 ? arguments[1] : undefined;
      Object.keys(items).forEach(function (key) {
        _this2.setItem(key, items[key], expire);
      });
      return items;
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      this._storage.remove(key);
      return null;
    }
  }, {
    key: "clear",
    value: function clear() {
      this._storage.clear();
      return null;
    }
  }]);
  return LightningSdkStorage;
}();
var isStorageSupported = function isStorageSupported(storage) {
  try {
    storage.setItem(TEST_KEY, TEST_VALUE);
    var storageItem = storage.getItem(TEST_KEY);
    storage.removeItem(TEST_KEY);
    return storageItem === TEST_VALUE;
  } catch (e) {
    throw new Error(e);
  }
};
var platformStorage = new LightningSdkStorage();
;// CONCATENATED MODULE: ./packages/bedrock-rdk/utils/src/storage/platform/default/storage.js

;// CONCATENATED MODULE: ./packages/bedrock-rdk/utils/src/storage/index.js

;// CONCATENATED MODULE: ./packages/bedrock-rdk/utils/src/applaunch.js

function applaunch_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function applaunch_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? applaunch_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : applaunch_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var getApplaunchConfig = function getApplaunchConfig(localId) {
  return applaunch_objectSpread({
    app: (src_default()).app,
    platform: (src_default()).platformCode,
    localDeviceId: localId,
    customizer: (src_default()).customizer
  }, (src_default()).fido.applaunch);
};
;// CONCATENATED MODULE: ./packages/bedrock-rdk/utils/src/clipboard.js



var fallbackCopyTextToClipboard = function fallbackCopyTextToClipboard(text) {
  var textArea = document.createElement('textarea');
  textArea.value = text;
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  try {
    var successful = document.execCommand('copy');
    var msg = successful ? 'successful' : 'unsuccessful';
    console.log("Fallback: Copying text command was ".concat(msg));
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err);
  }
  document.body.removeChild(textArea);
};
var copyTextToClipboard = function () {
  var _ref = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(text) {
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (navigator.clipboard) {
            _context.next = 3;
            break;
          }
          fallbackCopyTextToClipboard(text);
          return _context.abrupt("return");
        case 3:
          try {
            navigator.clipboard.writeText(text);
            console.log('Async: Copying to clipboard was successful!');
          } catch (error) {
            console.error('Async: Could not copy text: ', error);
          }
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function copyTextToClipboard(_x) {
    return _ref.apply(this, arguments);
  };
}();
;// CONCATENATED MODULE: ./packages/bedrock-rdk/utils/src/platform/default/homeId.utils.js
var getHomeId = function getHomeId() {
  return null;
};
var getPubId = function getPubId() {
  return null;
};
;// CONCATENATED MODULE: ./packages/bedrock-rdk/utils/src/homeId.js

;// CONCATENATED MODULE: ./packages/bedrock-rdk/utils/src/img.js

var getImageKeyFromRole = function getImageKeyFromRole(images, role, currentKey, defaultKey) {
  if (currentKey && currentKey !== defaultKey) {
    return currentKey;
  }
  var image = images.find(function (img) {
    return img.role === role;
  });
  return image ? image.external_key : defaultKey;
};
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.object.entries.js
var es_object_entries = __webpack_require__(8262);
;// CONCATENATED MODULE: ./packages/bedrock-rdk/utils/src/object.js









function object_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function object_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? object_ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : object_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var object_isObject = function isObject(value) {
  return _typeof(value) === 'object' && value === Object(value) && !Array.isArray(value);
};
var getObjectWithLowerCasedAttributes = function getObjectWithLowerCasedAttributes(object) {
  return Object.keys(object).reduce(function (lowerCasedObject, attribute) {
    return object_objectSpread(object_objectSpread({}, lowerCasedObject), {}, _defineProperty({}, attribute.toLowerCase(), object[attribute]));
  }, {});
};
var getFilteredObject = function getFilteredObject(object) {
  var excludedValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [undefined, null, false, NaN];
  return Object.entries(object).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      value = _ref2[1];
    return !excludedValues.includes(value);
  }).reduce(function (memo, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      value = _ref4[1];
    return object_objectSpread(object_objectSpread({}, memo), {}, _defineProperty({}, key, value));
  }, {});
};
var deepClone = function deepClone(object) {
  return JSON.parse(JSON.stringify(object));
};
var areFieldsMissing = function areFieldsMissing(fields, opts) {
  return !fields.every(function (key) {
    return Object.keys(opts).includes(key);
  });
};
;// CONCATENATED MODULE: ./packages/bedrock-rdk/utils/src/pictos.js
var CSA_PICTO_INDEX = 1;
var SERVICE_PICTO_INDEX = 2;
var LOCK_PICTO_INDEX = 4;
var getCSAPicto = function getCSAPicto(pictos) {
  return pictos && pictos[CSA_PICTO_INDEX];
};
var getServicePicto = function getServicePicto(pictos) {
  return pictos && pictos[SERVICE_PICTO_INDEX];
};
var getLockPicto = function getLockPicto(pictos) {
  return pictos && pictos[LOCK_PICTO_INDEX];
};
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(47865);
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.number.is-integer.js
var es_number_is_integer = __webpack_require__(35056);
;// CONCATENATED MODULE: ./packages/bedrock-rdk/utils/src/render.js




function renderTimes(iterations, render) {
  if (!Number.isInteger(iterations)) {
    throw Error('First argument of renderTimes() should be an integer.');
  }
  return Array(iterations).fill(null).map(function (value, index) {
    return render(index);
  });
}
;// CONCATENATED MODULE: ./packages/bedrock-rdk/utils/src/selector.js


var getStoredValueFor = function getStoredValueFor(state) {
  return function (key, reducer) {
    throwErrorOrReturnValue(state[reducer][key] === undefined, "This key \"".concat(key, "\" does not exist in the \"").concat(reducer, "\" store"), state[reducer][key]);
  };
};
;// CONCATENATED MODULE: ./packages/bedrock-rdk/utils/src/string.js






var prefixWithOn = function prefixWithOn(text) {
  return "on".concat(text.charAt(0).toUpperCase() + text.slice(1));
};
var removeGivenTextFromString = function removeGivenTextFromString(string, givenText) {
  return string ? string.replace(givenText, '') : null;
};
var cutInLines = function cutInLines(string, maxLengthByLine) {
  if (!string) {
    return '';
  }
  return string.split(' ').reduce(function (acc, part) {
    if (!acc.length) {
      return [part];
    }
    var currentLineLength = acc[acc.length - 1].length;
    if (currentLineLength + part.length < maxLengthByLine) {
      acc[acc.length - 1] = "".concat(acc[acc.length - 1], " ").concat(part);
    } else {
      acc[acc.length] = part;
    }
    return acc;
  }, []);
};
var string_ucfirst = function ucfirst(str) {
  return "".concat(str.charAt(0).toUpperCase()).concat(str.slice(1));
};
;// CONCATENATED MODULE: ./packages/bedrock-rdk/utils/src/testUtils.js




function testUtils_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function testUtils_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? testUtils_ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : testUtils_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var genericActionCreator = function genericActionCreator(type) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return testUtils_objectSpread({
    type: type
  }, payload);
};
var renameObjectKeys = function renameObjectKeys(object, keys, newKeys) {
  var updatedObject = testUtils_objectSpread({}, object);
  keys.forEach(function (currentKeys, index) {
    updatedObject[newKeys[index]] = object[currentKeys];
    delete updatedObject[currentKeys];
  });
  return updatedObject;
};
var expectDispatchActionWithType = function expectDispatchActionWithType(dispatch, type) {
  expect(dispatch).toBeCalledWith(expect.objectContaining({
    type: type
  }));
};
var MockedStore = function () {
  function MockedStore(defaultState) {
    (0,classCallCheck/* default */.Z)(this, MockedStore);
    this.currentState = defaultState;
    this.dispatch = jest.fn();
  }
  (0,createClass/* default */.Z)(MockedStore, [{
    key: "getState",
    value: function getState() {
      return this.currentState;
    }
  }]);
  return MockedStore;
}();
var getMockedStore = function getMockedStore(defaultState) {
  return new MockedStore(defaultState);
};
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.number.is-finite.js
var es_number_is_finite = __webpack_require__(86602);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/forEach.js
var forEach = __webpack_require__(17489);
var forEach_default = /*#__PURE__*/__webpack_require__.n(forEach);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.19.3/node_modules/@bedrock/fido-sdk/es/fido.js







var Fido = function () {
  function Fido() {
    (0,classCallCheck/* default */.Z)(this, Fido);
    this._platformCode = null;
    this._customerCode = null;
    this._appVersion = null;
    this._clientCode = null;
    this._localDeviceId = null;
    this._localHomeId = null;
    this._saltAndSugar = null;
    this._getCurrentTime = function () {
      return Date.now();
    };
    this._waitTimeout = 10000;
    this._maxTimeout = 60000;
    this._imageSalt = '54b55408a530954b553ff79e98';
    this._usedCapacityToken = null;
    this.baseUrlsByAPIType = {};
    this.isInitialized = false;
  }
  (0,createClass/* default */.Z)(Fido, [{
    key: "init",
    value: function init() {
      var _this = this;
      var immutableProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var services = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      if (!this.isInitialized) {
        forEach_default()(immutableProps, function (value, key) {
          var privateKey = "_".concat(key);
          if (key !== 'isInitialized' && key !== 'baseUrlsByAPIType' && _this[privateKey] !== undefined) {
            _this[privateKey] = value;
          }
        });
        if (immutableProps.baseUrlsByAPIType) {
          this.baseUrlsByAPIType = Object.assign({}, immutableProps.baseUrlsByAPIType);
        }
        this.isInitialized = true;
      }
      services.forEach(function (service) {
        if (Array.isArray(service)) {
          var _service = (0,slicedToArray/* default */.Z)(service, 2),
            serviceInstance = _service[0],
            _service$ = _service[1],
            params = _service$ === void 0 ? [] : _service$;
          serviceInstance.init.apply(serviceInstance, (0,toConsumableArray/* default */.Z)(params));
        } else {
          service.init();
        }
      });
    }
  }, {
    key: "get",
    value: function get(key) {
      this.checkInit();
      var privateKey = "_".concat(key);
      return this[privateKey];
    }
  }, {
    key: "set",
    value: function set(key, value) {
      this.checkInit();
      var privateKey = "_".concat(key);
      this[privateKey] = value;
    }
  }, {
    key: "setBaseUrls",
    value: function setBaseUrls(baseUrlsByAPIType) {
      var _this2 = this;
      this.checkInit();
      forEach_default()(baseUrlsByAPIType, function (value, key) {
        _this2.baseUrlsByAPIType[key] = value;
      });
    }
  }, {
    key: "getBaseUrl",
    value: function getBaseUrl(apiType) {
      this.checkInit();
      return this.baseUrlsByAPIType[apiType];
    }
  }, {
    key: "checkInit",
    value: function checkInit() {
      if (!this.isInitialized) {
        throw new Error('You should init Fido before using it');
      }
    }
  }]);
  return Fido;
}();
var fido = new Fido();
// EXTERNAL MODULE: ./node_modules/.pnpm/superagent@8.0.9/node_modules/superagent/lib/client.js
var superagent_lib_client = __webpack_require__(54247);
var superagent_lib_client_default = /*#__PURE__*/__webpack_require__.n(superagent_lib_client);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.19.3/node_modules/@bedrock/fido-sdk/es/errors/fetch.error.js









function fetch_error_createSuper(t) { var r = fetch_error_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function fetch_error_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (fetch_error_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var FetchError = function (_Error) {
  (0,inherits/* default */.Z)(FetchError, _Error);
  var _super = fetch_error_createSuper(FetchError);
  function FetchError() {
    var _this;
    var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var request = arguments.length > 1 ? arguments[1] : undefined;
    var response = arguments.length > 2 ? arguments[2] : undefined;
    (0,classCallCheck/* default */.Z)(this, FetchError);
    _this = _super.call(this);
    try {
      _this.name = _this.constructor.name;
      _this.message = error instanceof Error ? error.toString() : error;
      _this.type = null;
      _this.request = request;
      _this.stack = error instanceof Error ? error.stack : new Error().stack;
    } catch (e) {}
    if (response) {
      var xBackendServer = get_default()(response, ['headers', 'x-backend-server'], '');
      _this.response = response;
      _this.status = response.status;
      _this.xBackendServer = xBackendServer;
    }
    return _this;
  }
  return (0,createClass/* default */.Z)(FetchError);
}((0,wrapNativeSuper/* default */.Z)(Error));
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.19.3/node_modules/@bedrock/fido-sdk/es/utils/fetch.js






var canSendBody = {
  PATCH: true,
  POST: true,
  PUT: true
};
var buildRequest = function buildRequest(url, _ref) {
  var method = _ref.method,
    _ref$body = _ref.body,
    body = _ref$body === void 0 ? {} : _ref$body,
    query = _ref.query,
    headers = _ref.headers,
    responseType = _ref.responseType;
  var req = superagent_lib_client_default()(method, url);
  if (headers) {
    req.set(headers);
  }
  if (query) {
    req.query(query);
  }
  if (responseType) {
    req.responseType(responseType);
  }
  if (canSendBody[method]) {
    return req.send(body);
  }
  return req;
};
var fetch_fetch = function fetch(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return new Promise(function (resolve, reject) {
    options.method = options.method || 'GET';
    options.maxTimeout = options.maxTimeout || fido.get('maxTimeout');
    options.waitTimeout = options.waitTimeout || fido.get('waitTimeout');
    var req = buildRequest(url, options);
    if (options.withCredentials) {
      req.withCredentials();
    }
    if (options.signal) {
      options.signal.addEventListener('abort', function () {
        req.abort();
      });
    }
    if (options.retry) {
      req.retry(options.retry.count, options.retry.callback(options.retry.apiType, options.method));
    }
    req.timeout({
      response: options.waitTimeout,
      deadline: options.maxTimeout
    }).end(function (err, response) {
      if (err) {
        return reject(new FetchError(err, {
          url: url,
          options: options
        }, response));
      }
      if (response.ok) {
        return resolve(response);
      }
      var error = new FetchError("".concat(response.statusText, ":").concat(response.status), {
        url: url,
        options: options
      }, response);
      return reject(error);
    });
  });
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.19.3/node_modules/@bedrock/fido-sdk/es/services/authentication/decorators/decorators-builder.js

var createAddHeaderDecorator = function createAddHeaderDecorator() {
  var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  var applyToArgument = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return function (target, name, descriptor) {
    var fn = descriptor.value;
    descriptor.value = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var argument = args[applyToArgument] || {
        headers: {}
      };
      var headersToAdd = callback.apply(void 0, args);
      if (headersToAdd) {
        argument.headers = Object.assign(Object.assign({}, headersToAdd), argument.headers);
        args[applyToArgument] = argument;
      }
      return fn.apply(this, args);
    };
    return descriptor;
  };
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.19.3/node_modules/@bedrock/fido-sdk/es/utils/fido.utils.js


var addFidoPropertyIfDefined = function addFidoPropertyIfDefined() {
  var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var fidoConfigKey = arguments.length > 1 ? arguments[1] : undefined;
  var targetPropertyName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : fidoConfigKey;
  return function () {
    var cloneTarget = Object.assign({}, target);
    if (fido.get(fidoConfigKey)) {
      cloneTarget[targetPropertyName] = fido.get(fidoConfigKey);
    }
    return cloneTarget;
  };
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.19.3/node_modules/@bedrock/fido-sdk/es/services/authentication/decorators/withCustomerHeader.js


var withCustomerHeader = function withCustomerHeader() {
  var applyToArgument = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return createAddHeaderDecorator(addFidoPropertyIfDefined({}, 'customerCode', 'X-Customer-Name'), applyToArgument);
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.19.3/node_modules/@bedrock/fido-sdk/es/services/authentication/decorators/withRequestTimeoutHeader.js


var withRequestTimeoutHeader = function withRequestTimeoutHeader() {
  var applyToArgument = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return createAddHeaderDecorator(function (url) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return {
      'Request-Timeout': String(options.waitTimeout || fido.get('waitTimeout'))
    };
  }, applyToArgument);
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.19.3/node_modules/@bedrock/fido-sdk/es/services/authentication/decorators/withVersionHeader.js


var withVersionHeader = function withVersionHeader() {
  var applyToArgument = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return createAddHeaderDecorator(addFidoPropertyIfDefined({}, 'appVersion', 'X-Client-Release'), applyToArgument);
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.19.3/node_modules/@bedrock/fido-sdk/es/services/fetcherService.js












var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,esm_typeof/* default */.Z)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var FetcherService = function () {
  function FetcherService() {
    (0,classCallCheck/* default */.Z)(this, FetcherService);
    this.isInitialized = false;
    this.basePath = '';
    this.apiType = '';
    this.displayName = '';
  }
  (0,createClass/* default */.Z)(FetcherService, [{
    key: "init",
    value: function init() {
      throw new Error("You should implement the init function of Fido's ".concat(this.getName()));
    }
  }, {
    key: "externalFetch",
    value: (function () {
      var _externalFetch = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(url, options) {
        var _yield$fetchUtils, body;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetch_fetch(url, options);
            case 2:
              _yield$fetchUtils = _context.sent;
              body = _yield$fetchUtils.body;
              return _context.abrupt("return", body);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function externalFetch(_x, _x2) {
        return _externalFetch.apply(this, arguments);
      }
      return externalFetch;
    }())
  }, {
    key: "fetch",
    value: function () {
      var _fetch = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2(url, options) {
        var _yield$this$fetchWith, body;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.fetchWithResponse(url, options);
            case 2:
              _yield$this$fetchWith = _context2.sent;
              body = _yield$this$fetchWith.body;
              return _context2.abrupt("return", body);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetch(_x3, _x4) {
        return _fetch.apply(this, arguments);
      }
      return fetch;
    }()
  }, {
    key: "fetchWithoutVersionHeaders",
    value: function () {
      var _fetchWithoutVersionHeaders = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee3(url, options) {
        var _yield$fetchUtils2, body;
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return fetch_fetch(url, options);
            case 2:
              _yield$fetchUtils2 = _context3.sent;
              body = _yield$fetchUtils2.body;
              return _context3.abrupt("return", body);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function fetchWithoutVersionHeaders(_x5, _x6) {
        return _fetchWithoutVersionHeaders.apply(this, arguments);
      }
      return fetchWithoutVersionHeaders;
    }()
  }, {
    key: "fetchWithResponse",
    value: function fetchWithResponse(url, options) {
      return fetch_fetch(url, options);
    }
  }, {
    key: "fetchWithStatus",
    value: function () {
      var _fetchWithStatus = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee4(url, options) {
        var _yield$fetchUtils3, status, response;
        return regenerator_default().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return fetch_fetch(url, options);
            case 3:
              _yield$fetchUtils3 = _context4.sent;
              status = _yield$fetchUtils3.status;
              return _context4.abrupt("return", status);
            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](0);
              response = _context4.t0.response;
              if (!response) {
                _context4.next = 13;
                break;
              }
              return _context4.abrupt("return", response.status);
            case 13:
              return _context4.abrupt("return", 0);
            case 14:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 8]]);
      }));
      function fetchWithStatus(_x7, _x8) {
        return _fetchWithStatus.apply(this, arguments);
      }
      return fetchWithStatus;
    }()
  }, {
    key: "getName",
    value: function getName() {
      return this.displayName || this.constructor.name;
    }
  }, {
    key: "getRoutePath",
    value: function getRoutePath(endpoint) {
      var withVersion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var path = "/".concat(this.basePath ? "".concat(this.basePath, "/") : '').concat(endpoint);
      if (withVersion) {
        var baseUrl = fido.getBaseUrl(this.apiType);
        var matches = baseUrl.match(/\/(v[0-9])$/);
        if (matches) {
          return "/".concat(matches[1]).concat(path);
        }
      }
      return path;
    }
  }, {
    key: "getRouteUrl",
    value: function getRouteUrl() {
      var endpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var clientCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : fido.get('clientCode');
      var platformCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : fido.get('platformCode');
      this.checkInit();
      if (!this.apiType) {
        throw new Error("You should define an API type for Fido's ".concat(this.getName()));
      }
      return "".concat(fido.getBaseUrl(this.apiType).replace('%(clientCode)s', clientCode)).concat(this.getRoutePath(endpoint).replace('%(platformCode)s', platformCode));
    }
  }, {
    key: "getHomeOrDeviceId",
    value: function getHomeOrDeviceId() {
      var prefixedId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.checkInit();
      var deviceId = fido.get('localDeviceId');
      var homeId = fido.get('localHomeId');
      if (homeId) {
        return prefixedId ? "homeid-".concat(homeId) : "".concat(homeId);
      }
      return prefixedId ? "deviceid-".concat(deviceId) : "".concat(deviceId);
    }
  }, {
    key: "checkInit",
    value: function checkInit(apiType) {
      if (!this.isInitialized) {
        throw new Error("You should init Fido's ".concat(this.getName(), " before using it"));
      }
      if (!fido.getBaseUrl(apiType || this.apiType)) {
        throw new Error("You should set baseUrl for ".concat(this.getName(), " before using it"));
      }
    }
  }, {
    key: "isInitialized",
    value: function isInitialized() {
      return this.isInitialized;
    }
  }]);
  return FetcherService;
}();
__decorate([withVersionHeader(1), withCustomerHeader(1), withRequestTimeoutHeader(1)], FetcherService.prototype, "fetch", null);
__decorate([withCustomerHeader(1), withRequestTimeoutHeader(1)], FetcherService.prototype, "fetchWithoutVersionHeaders", null);
__decorate([withVersionHeader(1), withCustomerHeader(1), withRequestTimeoutHeader(1)], FetcherService.prototype, "fetchWithResponse", null);
__decorate([withVersionHeader(1), withCustomerHeader(1), withRequestTimeoutHeader(1)], FetcherService.prototype, "fetchWithStatus", null);
// EXTERNAL MODULE: ./node_modules/.pnpm/crypto-js@4.2.0/node_modules/crypto-js/enc-base64.js
var enc_base64 = __webpack_require__(33490);
var enc_base64_default = /*#__PURE__*/__webpack_require__.n(enc_base64);
// EXTERNAL MODULE: ./node_modules/.pnpm/crypto-js@4.2.0/node_modules/crypto-js/md5.js
var md5 = __webpack_require__(59834);
var md5_default = /*#__PURE__*/__webpack_require__.n(md5);
// EXTERNAL MODULE: ./node_modules/.pnpm/crypto-js@4.2.0/node_modules/crypto-js/enc-hex.js
var enc_hex = __webpack_require__(2447);
var enc_hex_default = /*#__PURE__*/__webpack_require__.n(enc_hex);
// EXTERNAL MODULE: ./node_modules/.pnpm/crypto-js@4.2.0/node_modules/crypto-js/enc-utf8.js
var enc_utf8 = __webpack_require__(26551);
var enc_utf8_default = /*#__PURE__*/__webpack_require__.n(enc_utf8);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.19.3/node_modules/@bedrock/fido-sdk/es/services/monitoring/statsdMonitoringService.js











function statsdMonitoringService_createSuper(t) { var r = statsdMonitoringService_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function statsdMonitoringService_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (statsdMonitoringService_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }







var StatsdMonitoringService = function (_FetcherService) {
  (0,inherits/* default */.Z)(StatsdMonitoringService, _FetcherService);
  var _super = statsdMonitoringService_createSuper(StatsdMonitoringService);
  function StatsdMonitoringService() {
    var _this;
    (0,classCallCheck/* default */.Z)(this, StatsdMonitoringService);
    _this = _super.apply(this, arguments);
    _this.apiType = 'monitoring';
    _this.stack = [];
    _this.buildPattern = function (basePattern, encoded) {
      return encoded ? "".concat(basePattern, "&encoded=1") : basePattern;
    };
    _this.buildEncodedNode = function (originalNode) {
      return encodeURIComponent(enc_base64_default().stringify(enc_utf8_default().parse(originalNode)));
    };
    _this.buildNodes = function (tags, encoded) {
      var scope = _this.isClientSide ? 'client' : 'server';
      var prefixedTags = [fido.get('customerCode'), _this.platformCode, scope].concat((0,toConsumableArray/* default */.Z)(tags));
      var node = prefixedTags.join('.');
      return {
        originalNode: node,
        encodedNode: encoded ? _this.buildEncodedNode(node) : node
      };
    };
    return _this;
  }
  (0,createClass/* default */.Z)(StatsdMonitoringService, [{
    key: "init",
    value: function init(isClientSide, _ref) {
      var enabled = _ref.enabled,
        salt = _ref.salt,
        platformCode = _ref.platformCode;
      this.isClientSide = isClientSide;
      this.enabled = enabled;
      if (!this.isInitialized) {
        this.basePath = 'statsd';
        this.salt = salt;
        this.getCurrentTime = fido.get('getCurrentTime');
        this.platformCode = platformCode || fido.get('platformCode');
        this.isInitialized = true;
        this.processStack();
      }
    }
  }, {
    key: "generateToken",
    value: function generateToken(node) {
      var isTimingToken = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var template = isTimingToken ? "".concat(node).concat(this.salt) : "".concat(node, "1").concat(this.salt);
      var hash = md5_default()(template);
      return hash.toString((enc_hex_default()));
    }
  }, {
    key: "sendIncrement",
    value: function sendIncrement() {
      var _this2 = this;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var tags = args[0],
        token = args[1],
        _args$ = args[2],
        encoded = _args$ === void 0 ? false : _args$;
      if (!this.isInitialized) {
        this.stack.push(function () {
          return _this2.sendIncrement.apply(_this2, args);
        });
        return;
      }
      if (!this.enabled) {
        return;
      }
      var _this$buildNodes = this.buildNodes(tags, encoded),
        originalNode = _this$buildNodes.originalNode,
        encodedNode = _this$buildNodes.encodedNode;
      var url = this.getRouteUrl("".concat(encodedNode, "/increment?token=").concat(token || this.generateToken(originalNode)));
      fetch_fetch(this.buildPattern(url, encoded)).catch(function () {});
    }
  }, {
    key: "sendTiming",
    value: function sendTiming() {
      var _this3 = this;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      var tags = args[0],
        duration = args[1],
        token = args[2],
        _args$2 = args[3],
        encoded = _args$2 === void 0 ? false : _args$2;
      if (!this.isInitialized) {
        this.stack.push(function () {
          return _this3.sendTiming.apply(_this3, args);
        });
        return;
      }
      if (!this.enabled) {
        return;
      }
      var _this$buildNodes2 = this.buildNodes(tags, encoded),
        originalNode = _this$buildNodes2.originalNode,
        encodedNode = _this$buildNodes2.encodedNode;
      var url = this.getRouteUrl("".concat(encodedNode, "/timer/").concat(duration, "?token=").concat(token || this.generateToken(originalNode, true)));
      fetch_fetch(this.buildPattern(url, encoded)).catch(function () {});
    }
  }, {
    key: "processStack",
    value: function processStack() {
      if (this.isInitialized) {
        this.stack.forEach(function (sendTags) {
          return sendTags();
        });
        this.stack = [];
      }
    }
  }, {
    key: "sendAppStart",
    value: function sendAppStart(version) {
      this.sendIncrement([version, 'frontend_app_startup_total']);
    }
  }, {
    key: "sendSilentError",
    value: function sendSilentError() {
      this.sendIncrement(['frontend_silent_error_total']);
    }
  }, {
    key: "sendFatalError",
    value: function sendFatalError() {
      this.sendIncrement(['frontend_fatal_error_total']);
    }
  }, {
    key: "sendManualLoginSuccess",
    value: function sendManualLoginSuccess() {
      this.sendIncrement(['frontend_login_total']);
    }
  }, {
    key: "sendAutoLoginSuccess",
    value: function sendAutoLoginSuccess() {
      this.sendIncrement(['frontend_auto_login_total']);
    }
  }, {
    key: "sendManualLoginError",
    value: function sendManualLoginError() {
      this.sendIncrement(['frontend_login_error_total']);
    }
  }, {
    key: "sendRegisterSuccess",
    value: function sendRegisterSuccess() {
      this.sendIncrement(['frontend_register_total']);
    }
  }, {
    key: "sendRegisterError",
    value: function sendRegisterError() {
      this.sendIncrement(['frontend_register_error_total']);
    }
  }, {
    key: "sendCompleteRegistrationSuccess",
    value: function sendCompleteRegistrationSuccess() {
      this.sendIncrement(['frontend_complete_registration_total']);
    }
  }, {
    key: "sendCompleteRegistrationError",
    value: function sendCompleteRegistrationError() {
      this.sendIncrement(['frontend_complete_registration_error_total']);
    }
  }, {
    key: "sendPaymentDone",
    value: function sendPaymentDone(payment) {
      this.sendIncrement([payment, 'frontend_payment_done_total']);
    }
  }, {
    key: "sendPaymentFailure",
    value: function sendPaymentFailure(payment, failure) {
      this.sendIncrement([payment, failure, 'frontend_payment_failure_total']);
    }
  }, {
    key: "sendLayoutRedirection",
    value: function sendLayoutRedirection(frontspace) {
      this.sendIncrement(['frontend_layout', frontspace, 'redirect_total']);
    }
  }, {
    key: "sendProfileSelection",
    value: function sendProfileSelection() {
      this.sendIncrement(['frontend_profile_selection_total']);
    }
  }, {
    key: "sendProfileSelectionFailure",
    value: function sendProfileSelectionFailure() {
      this.sendIncrement(['frontend_profile_selection_failure_total']);
    }
  }, {
    key: "sendProfileAutoSelection",
    value: function sendProfileAutoSelection() {
      this.sendIncrement(['frontend_profile_autoselection_total']);
    }
  }, {
    key: "sendProfileAutoSelectionFailure",
    value: function sendProfileAutoSelectionFailure() {
      this.sendIncrement(['frontend_profile_autoselection_failure_total']);
    }
  }, {
    key: "sendSearchBatchHit",
    value: function sendSearchBatchHit() {
      this.sendIncrement(['frontend_search_total']);
    }
  }, {
    key: "sendUpdatePassword",
    value: function sendUpdatePassword() {
      this.sendIncrement(['frontend_update_password']);
    }
  }]);
  return StatsdMonitoringService;
}(FetcherService);
var statsdMonitoringService = new StatsdMonitoringService();
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.19.3/node_modules/@bedrock/fido-sdk/es/services/monitoring/timer.util.js


var Timer = function () {
  function Timer() {
    var getCurrentTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Date.now;
    (0,classCallCheck/* default */.Z)(this, Timer);
    this.getCurrentTime = getCurrentTime;
    this.startTime = null;
    this.endTime = null;
  }
  (0,createClass/* default */.Z)(Timer, [{
    key: "start",
    value: function start() {
      this.startTime = this.getCurrentTime();
    }
  }, {
    key: "stop",
    value: function stop() {
      this.endTime = this.getCurrentTime();
    }
  }, {
    key: "duration",
    value: function duration() {
      if (this.startTime === null || this.endTime === null) {
        throw new Error('You should start and stop the timer before getting duration');
      }
      return this.endTime - this.startTime;
    }
  }]);
  return Timer;
}();
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.19.3/node_modules/@bedrock/fido-sdk/es/services/monitoring/decorators/withMonitoring.js








var DEFAULT_STATUS_CODE = 0;
var withMonitoring = function withMonitoring() {
  for (var _len = arguments.length, tags = new Array(_len), _key = 0; _key < _len; _key++) {
    tags[_key] = arguments[_key];
  }
  return function (target, key, descriptor) {
    var fn = descriptor.value;
    descriptor.value = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee() {
      var returnValue,
        timer,
        _len2,
        args,
        _key2,
        _args = arguments;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            timer = new Timer(statsdMonitoringService.getCurrentTime);
            timer.start();
            _context.prev = 2;
            for (_len2 = _args.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = _args[_key2];
            }
            _context.next = 6;
            return fn.apply(this, args);
          case 6:
            returnValue = _context.sent;
            _context.next = 13;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](2);
            if (_context.t0 instanceof FetchError) {
              statsdMonitoringService.sendIncrement(['error', 'fido'].concat(tags, [key, get_default()(_context.t0, 'response.status', DEFAULT_STATUS_CODE)]));
            } else {
              statsdMonitoringService.sendIncrement(['error', 'fido', 'method'].concat(tags, [key, 'custom_error']));
            }
            throw _context.t0;
          case 13:
            timer.stop();
            statsdMonitoringService.sendTiming(['fido'].concat(tags, [key]), timer.duration());
            return _context.abrupt("return", returnValue);
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee, this, [[2, 9]]);
    }));
    return descriptor;
  };
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.19.3/node_modules/@bedrock/fido-sdk/es/services/simpleFetcherService.js






function simpleFetcherService_createSuper(t) { var r = simpleFetcherService_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function simpleFetcherService_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (simpleFetcherService_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }



var SimpleFetcherService = function (_FetcherService) {
  (0,inherits/* default */.Z)(SimpleFetcherService, _FetcherService);
  var _super = simpleFetcherService_createSuper(SimpleFetcherService);
  function SimpleFetcherService(serviceName) {
    var _this;
    var basePath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    (0,classCallCheck/* default */.Z)(this, SimpleFetcherService);
    _this = _super.call(this);
    if (!serviceName) {
      throw new Error("You have to instantiate this Fido's service with its name before using it");
    }
    _this.displayName = "".concat(serviceName.charAt(0).toUpperCase() + serviceName.slice(1), "Service");
    _this.apiType = serviceName;
    _this.basePath = basePath;
    return _this;
  }
  (0,createClass/* default */.Z)(SimpleFetcherService, [{
    key: "init",
    value: function init() {
      if (!this.isInitialized) {
        this.isInitialized = true;
        this.monitored = withMonitoring(this.apiType);
      }
    }
  }, {
    key: "fetch",
    value: function fetch() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        headers = _ref.headers;
      var url = this.getRouteUrl();
      return this.monitored(SimpleFetcherService.prototype, 'fetch', {
        value: function value() {
          return fetch_fetch(url, {
            method: 'GET',
            headers: headers
          }).then(function (_ref2) {
            var body = _ref2.body;
            return body;
          });
        }
      }).value();
    }
  }]);
  return SimpleFetcherService;
}(FetcherService);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.19.3/node_modules/@bedrock/fido-sdk/es/services/time/timeService.js

var timeService = new SimpleFetcherService('time');
;// CONCATENATED MODULE: ./packages/bedrock-rdk/utils/src/time.js













var differenceInSeconds = function differenceInSeconds(timestampEnd, timestampStart) {
  return timestampEnd - timestampStart;
};
var differenceInMinutes = function differenceInMinutes(timestampEnd, timestampStart) {
  return (timestampEnd - timestampStart) / 60;
};
var differenceInMs = function differenceInMs(timestampEnd, timestampStart) {
  return (timestampEnd - timestampStart) * 1000;
};
var getElapsedTime = function getElapsedTime() {
  return Math.floor(performance.now());
};
var toSeconds = function toSeconds(msValue) {
  return msValue / 1000;
};
var toMs = function toMs(valueInSeconds) {
  return valueInSeconds * 1000;
};
var secondsToHours = function secondsToHours(valueInSeconds) {
  return valueInSeconds / 3600;
};
var secondsToMinutes = function secondsToMinutes(valueInSeconds) {
  return valueInSeconds / 60 % 60;
};
var secondsRemainder = function secondsRemainder(valueInSeconds) {
  return valueInSeconds % 60;
};
var floorValue = function floorValue(value) {
  return Math.floor(value);
};
var ceilValue = function ceilValue(value) {
  return Math.ceil(value);
};
var toFixedValue = function toFixedValue(value) {
  return parseFloat(value.toFixed(2));
};
var fixedClamp = function fixedClamp(value, min, max) {
  var fixedValue = toFixedValue(value);
  if (fixedValue < min) {
    return min;
  }
  if (fixedValue > max) {
    return max;
  }
  return fixedValue;
};
var time_getTimestamp = function getTimestamp(serverTime, initialElapsedTime) {
  return floorValue(serverTime + toSeconds(getElapsedTime() - initialElapsedTime));
};
var getMsTimestamp = function getMsTimestamp(serverTime, initialElapsedTime) {
  return floorValue(toMs(serverTime) + (getElapsedTime() - initialElapsedTime));
};
var get6PlayTime = function () {
  var _ref = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee() {
    var serverTime;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return timeService.fetch();
        case 3:
          serverTime = _context.sent;
          if (!(!serverTime || typeof serverTime.timestamp !== 'number')) {
            _context.next = 6;
            break;
          }
          throw new Error('Invalid timestamp');
        case 6:
          return _context.abrupt("return", serverTime.timestamp);
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](0);
          throw new Error("Unable to retrieve server time: ".concat(_context.t0.message));
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 9]]);
  }));
  return function get6PlayTime() {
    return _ref.apply(this, arguments);
  };
}();
var getPercentageOfTime = function getPercentageOfTime(_ref2) {
  var timestampStart = _ref2.timestampStart,
    timestampEnd = _ref2.timestampEnd,
    serverTime = _ref2.serverTime,
    initialElapsedTime = _ref2.initialElapsedTime;
  var currentTime = time_getTimestamp(serverTime, initialElapsedTime);
  var programLength = timestampEnd - timestampStart;
  var timePassed = currentTime - timestampStart;
  var percentageOfProgram = timePassed / programLength * 100;
  return percentageOfProgram >= 0 ? percentageOfProgram : 0;
};
var getPercentageOfClipTime = function getPercentageOfClipTime(elapsedTime, clipDuration) {
  var percentageOfClip = elapsedTime / clipDuration * 100;
  return percentageOfClip >= 0 ? percentageOfClip : 0;
};
var withLeadingZero = function withLeadingZero(value) {
  return "".concat(value < 10 ? '0' : '').concat(value);
};
var getTimeFormat = function getTimeFormat(timestamp) {
  if (!Number.isFinite(timestamp)) {
    return '';
  }
  if (timestamp < 0) return '00:00';
  var hours = floorValue(secondsToHours(timestamp));
  var minutes = floorValue(secondsToMinutes(timestamp));
  var seconds = secondsRemainder(timestamp);
  if (timestamp >= 3600) {
    return "".concat(hours, ":").concat(withLeadingZero(minutes), ":").concat(withLeadingZero(seconds));
  }
  return "".concat(withLeadingZero(minutes), ":").concat(withLeadingZero(seconds));
};
var timeUnitsMultipliers = [1, 60, 3600];
var timeTitleToSeconds = function timeTitleToSeconds(title) {
  return title ? title.split(':').reverse().slice(0, timeUnitsMultipliers.length).reduce(function (result, current, index) {
    return result + parseInt(current, 10) * timeUnitsMultipliers[index];
  }, 0) : 0;
};
var isInStartoverTimeSlot = function isInStartoverTimeSlot(_ref3) {
  var timestampStartPreroll = _ref3.timestampStartPreroll,
    timestampEndPreroll = _ref3.timestampEndPreroll,
    timestampStart = _ref3.timestampStart,
    timestampEnd = _ref3.timestampEnd,
    initialElapsedTime = _ref3.initialElapsedTime,
    serverTime = _ref3.serverTime,
    startoverMinDepth = _ref3.startoverMinDepth,
    startoverMaxDepth = _ref3.startoverMaxDepth,
    startoverMinPercentage = _ref3.startoverMinPercentage,
    startoverMaxPercentage = _ref3.startoverMaxPercentage;
  var currentTime = time_getTimestamp(serverTime, initialElapsedTime);
  if (currentTime < timestampEndPreroll) {
    return false;
  }
  var programLength = timestampEnd - timestampStart;
  var lowestTimeAllowed = timestampStart + programLength * startoverMinPercentage / 100;
  var highestTimeAllowed = timestampStart + programLength * startoverMaxPercentage / 100;
  if (differenceInMinutes(timestampEnd, timestampStart) < startoverMinDepth) {
    return false;
  }
  if (differenceInMinutes(currentTime, timestampStartPreroll) >= startoverMaxDepth) {
    return false;
  }
  if (currentTime < lowestTimeAllowed || currentTime > highestTimeAllowed) {
    return false;
  }
  return true;
};
var clearTimeouts = function clearTimeouts(timeoutIds) {
  timeoutIds.forEach(clearTimeout);
};
var videoElapsedTime = function videoElapsedTime(currentTime, startTime) {
  return Math.max(Math.round(currentTime - startTime), 0);
};
var getCurrentTimeInSeconds = function getCurrentTimeInSeconds() {
  return Math.floor(Date.now() / 1000);
};
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isString.js
var lodash_isString = __webpack_require__(56549);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isFunction.js
var lodash_isFunction = __webpack_require__(92042);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isNumber.js
var lodash_isNumber = __webpack_require__(59933);
;// CONCATENATED MODULE: ./packages/bedrock-rdk/utils/src/timer.js




var subscriptions = {};
var resetSetTimeoutByKey = function resetSetTimeoutByKey(key, callback, time) {
  if (!isString(key) || !isFunction(callback) || !isNumber(time)) {
    return;
  }
  var subscription = subscriptions[key];
  if (subscription) {
    clearTimeout(subscription);
  }
  for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }
  subscriptions[key] = setTimeout.apply(void 0, [callback, time].concat(args));
};
var deleteSetTimeoutSubscriptionByKey = function deleteSetTimeoutSubscriptionByKey(key) {
  clearTimeout(subscriptions[key]);
};
;// CONCATENATED MODULE: ./packages/bedrock-rdk/utils/src/video.js




var fileTypes = {
  MP4: ['mp4', 'MP4']
};
var buildFileExtensionsRegex = function buildFileExtensionsRegex(fileExtensions) {
  return new RegExp("\\.(".concat(fileExtensions.join('|'), ")$"));
};
var isMp4 = function isMp4(fileName) {
  return buildFileExtensionsRegex(fileTypes.MP4).test(fileName);
};
;// CONCATENATED MODULE: ./packages/bedrock-rdk/utils/src/index.js
























;// CONCATENATED MODULE: ./src/modules/tornado/icon/customer/default/appCustomer.constants.js

;// CONCATENATED MODULE: ./src/modules/tornado/icon/icon.constants.js

var ICON_TYPE = {
  SERVICE_ICON: 'service-icon',
  SIMPLE_ICON: 'icon'
};
var icon_constants_customerServiceIcon = {
  type: ICON_TYPE.SERVICE_ICON,
  name: env.appCustomer
};
var ICON_COLOR_SUFFIX = {
  dark: '_dark',
  default: '',
  light: '_ghost'
};
var COLOR_LOCKED = ['Live', 'BackToLive', 'Csa6', 'Csa12', 'Csa16', 'Csa18'];
;// CONCATENATED MODULE: ./src/modules/tornado/icon/icon.provider.js










var textureCache = {};
var getServiceIconFromBundle = function getServiceIconFromBundle(name) {
  var colorMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
  var baseUrl = get_default()((src_default()), 'assetsBundle.manifest.baseUrl');
  var icon = get_default()((src_default()), "assetsBundle.manifest.urls.viewbox.".concat(name).concat(ICON_COLOR_SUFFIX[colorMode]));
  if (!baseUrl) {
    return null;
  }
  if (!icon) {
    return null;
  }
  return "".concat(baseUrl, "/").concat(icon);
};
var getServiceIcon = function getServiceIcon(name) {
  var colorMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
  var fullCode = getServiceIconFromBundle(name, colorMode);
  return fullCode;
};
var getIconUrl = function getIconUrl(type, name, collection, colorMode) {
  switch (type) {
    case ICON_TYPE.SERVICE_ICON:
      return getServiceIcon(name, colorMode);
    default:
      return getFullPath(iconByName(name.toLowerCase(), collection));
  }
};
var getTextureByUrl = function getTextureByUrl(url, viewBox, scale) {
  var useCache = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var width = viewBox.w,
    height = viewBox.h;
  var id = [url, width, height, scale].join('_');
  if (useCache && textureCache[id]) {
    return textureCache[id];
  }
  var result = getSvgTexture(url, width, height, scale);
  if (useCache) {
    textureCache[id] = result;
  }
  return result;
};
var getTextureByName = function getTextureByName(picto, viewBox) {
  var scale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var colorMode = arguments.length > 3 ? arguments[3] : undefined;
  var useCache = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  if (!picto || !picto.name || !viewBox) {
    return null;
  }
  var name = picto.name,
    type = picto.type,
    collection = picto.collection;
  var url = getIconUrl(type, name, collection, colorMode);
  return getTextureByUrl(url, viewBox, scale, useCache);
};
var getTextureByIconData = function getTextureByIconData(iconData) {
  if (iconData) {
    var picto = iconData.picto,
      viewBox = iconData.viewBox,
      colorMode = iconData.colorMode;
    if (picto && viewBox) {
      return getTextureByName(picto, viewBox, iconData.scale || 1, colorMode);
    }
  }
  return null;
};
var cleanupIconsCache = function cleanupIconsCache() {
  Object.keys(textureCache).forEach(function (key) {
    delete textureCache[key];
  });
};
;// CONCATENATED MODULE: ./src/logic/features/features.selectors.js
var getAdFeature = function getAdFeature(_ref) {
  var features = _ref.features;
  return features.adFeature;
};
var getAnimateFeature = function getAnimateFeature(_ref2) {
  var features = _ref2.features;
  return features.animateFeature;
};
var getBookmarksFeature = function getBookmarksFeature(_ref3) {
  var features = _ref3.features;
  return features.bookmarksFeature;
};
var getBroadcastLiveFeature = function getBroadcastLiveFeature(_ref4) {
  var features = _ref4.features;
  return features.broadcastLiveFeature;
};
var getCustomizerFeature = function getCustomizerFeature(_ref5) {
  var features = _ref5.features;
  return features.customizerFeature;
};
var getCheckGeoFeature = function getCheckGeoFeature(_ref6) {
  var features = _ref6.features;
  return features.checkGeoFeature;
};
var getContentAdvisorFeature = function getContentAdvisorFeature(_ref7) {
  var features = _ref7.features;
  return features.contentAdvisorFeature;
};
var getDisplayLostConnectionFeature = function getDisplayLostConnectionFeature(_ref8) {
  var features = _ref8.features;
  return features.displayLostConnectionFeature;
};
var getGdprNoticeFeature = function getGdprNoticeFeature(_ref9) {
  var features = _ref9.features;
  return features.gdprNoticeFeature;
};
var getKidsSectionFeature = function getKidsSectionFeature(_ref0) {
  var features = _ref0.features;
  return features.kidsSectionFeature;
};
var getKidsSectionLeaveFeature = function getKidsSectionLeaveFeature(_ref1) {
  var features = _ref1.features;
  return features.kidsSectionLeaveFeature;
};
var getLiveSeekFeature = function getLiveSeekFeature(_ref10) {
  var features = _ref10.features;
  return features.liveSeekFeature;
};
var getMenuPopupFeature = function getMenuPopupFeature(_ref11) {
  var features = _ref11.features;
  return features.menuPopupFeature;
};
var getMultiAudioFeature = function getMultiAudioFeature(_ref12) {
  var features = _ref12.features;
  return features.multiAudioFeature;
};
var getMultiProfileFeature = function getMultiProfileFeature(_ref13) {
  var features = _ref13.features;
  return features.multiprofile;
};
var getMultiProfilesGateAlwaysDisplayed = function getMultiProfilesGateAlwaysDisplayed(_ref14) {
  var features = _ref14.features;
  return features.multiProfilesGateAlwaysDisplayed;
};
var getMultiSubtitlesFeature = function getMultiSubtitlesFeature(_ref15) {
  var features = _ref15.features;
  return features.multiSubtitlesFeature;
};
var getOpenCatalogFeature = function getOpenCatalogFeature(_ref16) {
  var features = _ref16.features;
  return features.openCatalogFeature;
};
var getPairingFeature = function getPairingFeature(_ref17) {
  var features = _ref17.features;
  return features.pairingFeature;
};
var getParentalFilterFeature = function getParentalFilterFeature(_ref18) {
  var features = _ref18.features;
  return features.parentalFilterFeature;
};
var getPlayerAdFeature = function getPlayerAdFeature(_ref19) {
  var features = _ref19.features;
  return features.player_adFeature;
};
var getPlayerAnalyticsFeature = function getPlayerAnalyticsFeature(_ref20) {
  var features = _ref20.features;
  return features.player_analyticsFeature;
};
var getPlayerJingleFeature = function getPlayerJingleFeature(_ref21) {
  var features = _ref21.features;
  return features.player_jingleFeature;
};
var getPlayerLongSeekFeature = function getPlayerLongSeekFeature(_ref22) {
  var features = _ref22.features;
  return features.player_longSeek;
};
var getPlayerNextVideoFeature = function getPlayerNextVideoFeature(_ref23) {
  var features = _ref23.features;
  return features.player_nextVideoFeature;
};
var getPlayerRelatedVideosFeature = function getPlayerRelatedVideosFeature(_ref24) {
  var features = _ref24.features;
  return features.player_relatedVideosFeature;
};
var getPlayerReturnFeature = function getPlayerReturnFeature(_ref25) {
  var features = _ref25.features;
  return features.player_returnFeature;
};
var getPlayerThirdPartiesFeature = function getPlayerThirdPartiesFeature(_ref26) {
  var features = _ref26.features;
  return features.player_thirdPartiesFeature;
};
var getPlayerTimeShiftingFeature = function getPlayerTimeShiftingFeature(_ref27) {
  var features = _ref27.features;
  return features.player_timeShiftingFeature;
};
var getPlayerAdsCountFeature = function getPlayerAdsCountFeature(_ref28) {
  var features = _ref28.features;
  return features.player_adsCount;
};
var getPlayerLBannerFeature = function getPlayerLBannerFeature(_ref29) {
  var features = _ref29.features;
  return features.player_lBanner;
};
var getPlayerTrackPreferencesFeature = function getPlayerTrackPreferencesFeature(_ref30) {
  var features = _ref30.features;
  return features.player_trackPreferencesFeature;
};
var getPlayerPauseAdFeature = function getPlayerPauseAdFeature(_ref31) {
  var features = _ref31.features;
  return features.player_pauseAd;
};
var features_selectors_getPremiumFeature = function getPremiumFeature(_ref32) {
  var features = _ref32.features;
  return features.premiumFeature;
};
var getPrivilegeNavigationFeature = function getPrivilegeNavigationFeature(_ref33) {
  var features = _ref33.features;
  return features.privilegeNavigationFeature;
};
var getPromptBeforeExitFeature = function getPromptBeforeExitFeature(_ref34) {
  var features = _ref34.features;
  return features.promptBeforeExitFeature;
};
var getReplayFeature = function getReplayFeature(_ref35) {
  var features = _ref35.features;
  return features.replayFeature;
};
var getScreensaverFeature = function getScreensaverFeature(_ref36) {
  var features = _ref36.features;
  return features.screensaverFeature;
};
var getSearchFeature = function getSearchFeature(_ref37) {
  var features = _ref37.features;
  return features.searchFeature;
};
var getServicePageFeature = function getServicePageFeature(_ref38) {
  var features = _ref38.features;
  return features.servicePageFeature;
};
var getSplashScreenFeature = function getSplashScreenFeature(_ref39) {
  var features = _ref39.features;
  return features.splashScreenFeature;
};
var getStartoverFeature = function getStartoverFeature(_ref40) {
  var features = _ref40.features;
  return features.startoverFeature;
};
var getStartoverPopupFeature = function getStartoverPopupFeature(_ref41) {
  var features = _ref41.features;
  return features.startoverPopupFeature;
};
var getStoryboardFeature = function getStoryboardFeature(_ref42) {
  var features = _ref42.features;
  return features.storyboardFeature;
};
var getTermsOfUsageFeature = function getTermsOfUsageFeature(_ref43) {
  var features = _ref43.features;
  return features.termsOfUsageFeature;
};
var getUserApiFeature = function getUserApiFeature(_ref44) {
  var features = _ref44.features;
  return features.userApiFeature;
};
var getWatchAgainFeature = function getWatchAgainFeature(_ref45) {
  var features = _ref45.features;
  return features.watchAgainFeature;
};
;// CONCATENATED MODULE: ./src/logic/layout/layout.selectors.js


var getCurrentSectionCode = function getCurrentSectionCode(state) {
  return state.layout.currentSectionCode;
};
var getNavigationSection = function getNavigationSection(state) {
  return !state.user.uid || state.pairing.profileUid ? getCurrentSectionCode(state) : null;
};
var getRequestedEntityType = function getRequestedEntityType(state) {
  return state.layout.requestedEntityType;
};
var getRequestedEntityId = function getRequestedEntityId(state) {
  return state.layout.requestedEntityId;
};
var getLayoutById = function getLayoutById(state, entity, id) {
  var section = getCurrentSectionCode(state);
  return get_default()(state, "layout.".concat(section, ".").concat(entity, ".").concat(id), null);
};
var getCurrentLayout = function getCurrentLayout(state) {
  var entityType = getRequestedEntityType(state);
  var entityId = getRequestedEntityId(state);
  return getLayoutById(state, entityType, entityId);
};
var getLayoutNavigation = function getLayoutNavigation(state) {
  var section = getCurrentSectionCode(state);
  return get_default()(state, "layout.".concat(section, ".navigation"), null);
};
var getCurrentBlockPagination = function getCurrentBlockPagination(state, entityType, entityId, blockIndex) {
  return _get(state, "layout.".concat(getCurrentSectionCode(state), ".").concat(entityType, ".").concat(entityId, ".blocks.").concat(blockIndex, ".content.pagination"));
};
var getCurrentBlockItems = function getCurrentBlockItems(state, entityType, entityId, blockIndex) {
  return _get(state, "layout.".concat(getCurrentSectionCode(state), ".").concat(entityType, ".").concat(entityId, ".blocks.").concat(blockIndex, ".content.items"));
};
var getCurrentLayoutDimensions = function getCurrentLayoutDimensions(state) {
  var entityId = getRequestedEntityId(state);
  var entityType = getRequestedEntityType(state);
  var currentSectionCode = getCurrentSectionCode(state);
  return _get(state, "layout.".concat(currentSectionCode, ".").concat(entityType, ".").concat(entityId, ".analytics.googleAnalytics"), null);
};
var getContentTemplatesOptions = function getContentTemplatesOptions(state) {
  return get_default()(state, 'layout.contentTemplatesOptions', null);
};
;// CONCATENATED MODULE: ./src/logic/pairing/pairing.selectors.js

var getPollingInterval = function getPollingInterval(_ref) {
  var pollingInterval = _ref.pairing.pollingInterval;
  return pollingInterval;
};
var getPairingToken = function getPairingToken(_ref2) {
  var token = _ref2.pairing.token;
  return token;
};
var getPairingURI = function getPairingURI(_ref3) {
  var verificationURI = _ref3.pairing.verificationURI;
  return verificationURI;
};
var getPairingStatus = function getPairingStatus(_ref4) {
  var status = _ref4.pairing.status;
  return status;
};
var getUserEmail = function getUserEmail(_ref5) {
  var email = _ref5.pairing.email;
  return email;
};
var getPhotoUrl = function getPhotoUrl(_ref6) {
  var photoUrl = _ref6.pairing.photoUrl;
  return photoUrl;
};
var getUserFullName = function getUserFullName(_ref7) {
  var _ref7$pairing = _ref7.pairing,
    firstname = _ref7$pairing.firstname,
    lastname = _ref7$pairing.lastname;
  return "".concat(firstname, " ").concat(lastname);
};
var getPremiumServices = function getPremiumServices(_ref8) {
  var subscriptions = _ref8.pairing.subscriptions;
  return subscriptions;
};
var isKidsSection = function isKidsSection(_ref9) {
  var currentSectionCode = _ref9.layout.currentSectionCode;
  return currentSectionCode === 'kids';
};
var getIsUnpairedEntering = function getIsUnpairedEntering(_ref0) {
  var _ref0$pairing$isUnpai = _ref0.pairing.isUnpairedEntering,
    isUnpairedEntering = _ref0$pairing$isUnpai === void 0 ? false : _ref0$pairing$isUnpai;
  return isUnpairedEntering;
};
var getParentalLockStatus = function getParentalLockStatus(_ref1) {
  var parentalControl = _ref1.pairing.parentalControl,
    parentalFilterFeature = _ref1.features.parentalFilterFeature;
  return parentalFilterFeature ? parentalControl || 0 : null;
};
var getHasOffer = function getHasOffer(state) {
  return getPremiumServices(state) && getPremiumServices(state).some(function (service) {
    return service.offer;
  });
};
var getSelectedProfile = function getSelectedProfile(state) {
  return state.pairing.selectedProfileUid;
};
;// CONCATENATED MODULE: ./src/logic/routing/routing.utils.js







var getMatchingSkeleton = function getMatchingSkeleton(entityType, entityId) {
  var section = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'main';
  var hasSkeletonConfig = (src_default()).skeleton && Array.isArray((src_default()).skeleton.patterns);
  if (!hasSkeletonConfig || !entityType) {
    return null;
  }
  return src_default().skeleton.patterns.filter(function (_ref) {
    var pattern = _ref.section;
    return !pattern || section === pattern;
  }).find(function (_ref2) {
    var pattern = _ref2.path;
    try {
      return new RegExp(pattern, 'i').test("app/".concat(entityType, "/").concat(entityId));
    } catch (error) {
      return false;
    }
  }) || null;
};
;// CONCATENATED MODULE: ./src/logic/routing/routing.actions.js







var ROUTING_LOCATION_CHANGE = 'routing/LOCATION_CHANGE';
var ROUTING_SAVE_DEEPLINK = 'routing/SAVE_DEEPLINK';
var ROUTING_SET_IS_TOP_LEVEL_ROUTE = 'routing/SET_IS_TOP_LEVEL_ROUTE';
var LANDING_SHOWN = 'routing/ROUTING_SET_IS_LANDING_SHOWN';
var SHOULD_DISPLAY_LANDING = 'routing/SHOULD_DISPLAY_LANDING';
var SET_ROUTE_SKELETON = 'routing/SET_ROUTE_SKELETON';
var setDeeplinkLocation = function setDeeplinkLocation(deeplink) {
  return {
    type: ROUTING_SAVE_DEEPLINK,
    deeplink: deeplink
  };
};
var setCurrentLocation = function setCurrentLocation(location, path) {
  return {
    type: ROUTING_LOCATION_CHANGE,
    location: location,
    path: path
  };
};
var setIsTopLevelRoute = function setIsTopLevelRoute(isTopLevelRoute) {
  return {
    type: ROUTING_SET_IS_TOP_LEVEL_ROUTE,
    isTopLevelRoute: isTopLevelRoute
  };
};
var landingShown = function landingShown() {
  return {
    type: LANDING_SHOWN
  };
};
var landingShouldBeShown = function landingShouldBeShown() {
  return {
    type: SHOULD_DISPLAY_LANDING
  };
};
var setRouteSkeleton = function setRouteSkeleton(skeleton) {
  return {
    type: SET_ROUTE_SKELETON,
    skeleton: skeleton
  };
};
var hideRouteSkeleton = function hideRouteSkeleton() {
  return {
    type: SET_ROUTE_SKELETON,
    skeleton: null
  };
};
var setRouteSkeletonByEntity = function setRouteSkeletonByEntity(entityType, entityId) {
  return function () {
    var _ref = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(dispatch, getState) {
      var state, currentLayout, hasProfiles, selectedProfileUid, isProfileSelected;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            state = getState();
            currentLayout = getCurrentLayout(state);
            hasProfiles = getMultiProfileFeature(state);
            selectedProfileUid = getSelectedProfile(state);
            isProfileSelected = hasProfiles ? Boolean(selectedProfileUid) : true;
            if (currentLayout || !isProfileSelected) {
              dispatch(setRouteSkeleton());
            } else {
              dispatch(setRouteSkeleton(getMatchingSkeleton(entityType, entityId)));
            }
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isArray.js
var lodash_isArray = __webpack_require__(24669);
var isArray_default = /*#__PURE__*/__webpack_require__.n(lodash_isArray);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/map.js
var map = __webpack_require__(65512);
var map_default = /*#__PURE__*/__webpack_require__.n(map);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/utils/connectAction.js






var connectAction = function connectAction(resolver) {
  var promise = Promise.resolve();
  var waitForPromise = function waitForPromise(awaitedPromise) {
    promise = awaitedPromise;
    return awaitedPromise;
  };
  var connectedAction = function () {
    var _ref = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee() {
      var data,
        _len,
        args,
        _key,
        _args = arguments;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return function () {
              return promise;
            }();
          case 2:
            data = _context.sent;
            for (_len = _args.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = _args[_key];
            }
            resolver.apply(void 0, [data].concat(args));
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function connectedAction() {
      return _ref.apply(this, arguments);
    };
  }();
  return {
    connectedAction: connectedAction,
    waitForPromise: waitForPromise
  };
};
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/has.js
var has = __webpack_require__(56611);
var has_default = /*#__PURE__*/__webpack_require__.n(has);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/noop.js
var noop = __webpack_require__(43226);
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/set.js
var lodash_set = __webpack_require__(35609);
var set_default = /*#__PURE__*/__webpack_require__.n(lodash_set);
;// CONCATENATED MODULE: ./node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/rng.js


























var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);
    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }
  return getRandomValues(rnds8);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/regex.js
/* harmony default export */ const regex = (/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i);
;// CONCATENATED MODULE: ./node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/validate.js

function validate(uuid) {
  return typeof uuid === 'string' && regex.test(uuid);
}
/* harmony default export */ const esm_browser_validate = (validate);
;// CONCATENATED MODULE: ./node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/stringify.js



var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}
function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
  if (!esm_browser_validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }
  return uuid;
}
/* harmony default export */ const esm_browser_stringify = (stringify);
;// CONCATENATED MODULE: ./node_modules/.pnpm/uuid@8.3.2/node_modules/uuid/dist/esm-browser/v4.js


function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)();
  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80;
  if (buf) {
    offset = offset || 0;
    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }
    return buf;
  }
  return esm_browser_stringify(rnds);
}
/* harmony default export */ const esm_browser_v4 = (v4);
// EXTERNAL MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/thirdParty/constants.js
var constants = __webpack_require__(46262);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/thirdParty/abstract/abstractThirdPartyInterface.js















var AbstractThirdPartyInterface = function () {
  function AbstractThirdPartyInterface() {
    (0,classCallCheck/* default */.Z)(this, AbstractThirdPartyInterface);
  }
  (0,createClass/* default */.Z)(AbstractThirdPartyInterface, [{
    key: "getAdTargeting",
    value: (function () {
      var _getAdTargeting = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee() {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", Promise.all(this.callEnginesMethod('getAdTargeting')()).then(function (targetings) {
                return targetings.reduce(function (finalTargeting, targeting) {
                  return Object.assign(Object.assign({}, finalTargeting), targeting);
                }, {});
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getAdTargeting() {
        return _getAdTargeting.apply(this, arguments);
      }
      return getAdTargeting;
    }())
  }]);
  return AbstractThirdPartyInterface;
}();
Object.keys(constants/* ENGINES_EVENT_METHODS */.qy).forEach(function (key) {
  AbstractThirdPartyInterface.prototype[key] = function () {
    return this.callEnginesEventMethod(constants/* ENGINES_EVENT_METHODS */.qy[key]).apply(void 0, arguments);
  };
});
Object.keys(constants/* ENGINES_METHODS */.ks).forEach(function (key) {
  AbstractThirdPartyInterface.prototype[key] = function () {
    return this.callEnginesMethod(constants/* ENGINES_METHODS */.ks[key]).apply(void 0, arguments);
  };
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/thirdParty/eventQueue.js



var EventQueue = function () {
  function EventQueue() {
    var _this = this;
    (0,classCallCheck/* default */.Z)(this, EventQueue);
    this.commitEventQueueIfReady = function (thirdParty) {
      if (typeof thirdParty.engine !== 'function' && (typeof thirdParty.engine.isReady !== 'function' || thirdParty.engine.isReady() && thirdParty.eventQueue.length)) {
        if (thirdParty.eventQueueTimeout) {
          clearTimeout(thirdParty.eventQueueTimeout);
        }
        while (thirdParty.eventQueue.length > 0) {
          thirdParty.eventQueue.pop()(thirdParty);
        }
        return true;
      }
      return false;
    };
    this.queueEvent = function (thirdParty, e) {
      thirdParty.eventQueue.push(e);
      if (typeof thirdParty.engine !== 'function' && typeof thirdParty.engine.isReady === 'function' && !thirdParty.engine.isReady() && !thirdParty.eventQueueTimeout) {
        thirdParty.eventQueueTimeout = setTimeout(function () {
          return _this.commitEventQueueIfReady(thirdParty);
        }, _this.queueDelay);
      }
    };
    this.flushEvents = function () {
      var thirdParties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return thirdParties.forEach(function (thirdParty) {
        thirdParty.eventQueue = [];
      });
    };
  }
  (0,createClass/* default */.Z)(EventQueue, [{
    key: "init",
    value: function init(_ref) {
      var trackingInitDelay = _ref.trackingInitDelay;
      this.queueDelay = trackingInitDelay;
    }
  }]);
  return EventQueue;
}();
var eventQueue = new EventQueue();
// EXTERNAL MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/thirdParty/utils.js
var utils = __webpack_require__(14698);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/thirdParty/thirdPartyControllerService.js























function thirdPartyControllerService_createSuper(t) { var r = thirdPartyControllerService_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function thirdPartyControllerService_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (thirdPartyControllerService_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};









var DEFAULT_OPTIONS = {
  logger: console.info,
  sendErrorToMonitoring: (noop_default()),
  isRecording: false,
  detectBlocker: (noop_default())
};
var DEFAULT_CONFIG = {
  taggingPlans: {},
  initTrackingDelay: constants/* DEFAULT_INIT_DELAY_IN_MS */.Pb
};
var INIT_ERROR_MESSAGE = 'Every third party should be given a "name" and a "key" property';
var ENGINE_OVERRIDE_ERROR_MESSAGE = 'When thirdparty has a pre-defined "engine" property, it must be a function';
var ThirdPartyControllerService = function (_AbstractThirdPartyIn) {
  (0,inherits/* default */.Z)(ThirdPartyControllerService, _AbstractThirdPartyIn);
  var _super = thirdPartyControllerService_createSuper(ThirdPartyControllerService);
  function ThirdPartyControllerService() {
    var _this;
    (0,classCallCheck/* default */.Z)(this, ThirdPartyControllerService);
    _this = _super.apply(this, arguments);
    _this.thirdParties = [];
    _this.initializeThirdParties = function (thirdParties) {
      return thirdParties.map(function (_a) {
        var name = _a.name,
          bootMethod = _a.bootMethod,
          engine = _a.engine,
          rest = __rest(_a, ["name", "bootMethod", "engine"]);
        return Object.assign({
          name: name,
          initialized: false,
          rejected: false,
          boot: bootMethod,
          engine: engine || (0,utils/* lazyLoadEngine */.wQ)(name),
          eventQueue: [],
          eventQueueTimeout: null
        }, rest);
      });
    };
    _this.initThirdPartyEngines = function () {
      var _ref = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(acceptedThirdParties) {
        var enginesStarting, higherPriorityEngines, lowerPriorityEngines;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              enginesStarting = _this.thirdParties.filter(function (_ref2) {
                var name = _ref2.name,
                  initialized = _ref2.initialized;
                return acceptedThirdParties.includes(name) && !initialized;
              });
              _this.logger('Starting engines', enginesStarting);
              higherPriorityEngines = enginesStarting.filter(function (_ref3) {
                var name = _ref3.name;
                return !constants/* DEPENDANT_ENGINES */.xI.includes(name);
              });
              lowerPriorityEngines = enginesStarting.filter(function (_ref4) {
                var name = _ref4.name;
                return constants/* DEPENDANT_ENGINES */.xI.includes(name);
              });
              _context.next = 6;
              return _this.loadThirdParties(higherPriorityEngines);
            case 6:
              _context.next = 8;
              return _this.loadThirdParties(lowerPriorityEngines);
            case 8:
              return _context.abrupt("return", [].concat((0,toConsumableArray/* default */.Z)(higherPriorityEngines), (0,toConsumableArray/* default */.Z)(lowerPriorityEngines)).map(function (thirdParty) {
                return eventQueue.commitEventQueueIfReady(thirdParty);
              }));
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
    _this.rejectThirdPartyEngines = function (rejectedThirdParties) {
      _this.thirdParties.filter(function (_ref5) {
        var name = _ref5.name;
        return rejectedThirdParties.includes(name);
      }).forEach(function (engine) {
        engine.rejected = true;
        engine.eventQueue = [];
      });
    };
    _this.callEnginesEventMethod = function (method) {
      return function (taggingEvent, action, customAttributes) {
        return (0,utils/* getActiveEngineWithMethod */.sA)(_this.thirdParties, method).map(function (thirdParty) {
          var taggingPlan = thirdParty.taggingPlan || _this.config.taggingPlans;
          var stdEvent = (0,utils/* getFormattedEvent */.f6)(taggingEvent, thirdParty);
          eventQueue.queueEvent(thirdParty, function (latestThirdParty) {
            if (_this.isRecording) {
              (0,utils/* storeCallForMock */.c6)(thirdParty.name, method, stdEvent, action, {
                eventKey: get_default()(taggingPlan, stdEvent.key)
              }, customAttributes);
            }
            return get_default()(latestThirdParty.engine, method) && latestThirdParty.engine[method](stdEvent, action, get_default()(taggingPlan, stdEvent.key), customAttributes);
          });
          if (thirdParty.initialized) {
            return eventQueue.commitEventQueueIfReady(thirdParty);
          }
          return false;
        });
      };
    };
    _this.callEnginesMethod = function (method) {
      return function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return (0,utils/* getActiveEngineWithMethod */.sA)(_this.thirdParties, method).map(function (thirdParty) {
          var engine = thirdParty.engine,
            initialized = thirdParty.initialized,
            name = thirdParty.name;
          var engineArgs = get_default()(args, [name], args);
          if (_this.isRecording) {
            engineArgs.push({
              uuid: esm_browser_v4()
            });
          }
          if (initialized || engine.doNotQueue) {
            if (_this.isRecording) {
              utils/* storeCallForMock */.c6.apply(void 0, [name, method].concat((0,toConsumableArray/* default */.Z)(engineArgs)));
            }
            return engine[method].apply(engine, (0,toConsumableArray/* default */.Z)(engineArgs));
          }
          return eventQueue.queueEvent(thirdParty, function (latestThirdParty) {
            var _latestThirdParty$eng;
            if (_this.isRecording) {
              utils/* storeCallForMock */.c6.apply(void 0, [name, method].concat((0,toConsumableArray/* default */.Z)(engineArgs)));
            }
            return get_default()(latestThirdParty.engine, method) && (_latestThirdParty$eng = latestThirdParty.engine)[method].apply(_latestThirdParty$eng, (0,toConsumableArray/* default */.Z)(engineArgs));
          });
        });
      };
    };
    return _this;
  }
  (0,createClass/* default */.Z)(ThirdPartyControllerService, [{
    key: "init",
    value: function init(_ref6) {
      var _ref6$thirdParties = _ref6.thirdParties,
        thirdParties = _ref6$thirdParties === void 0 ? this.thirdParties : _ref6$thirdParties,
        _ref6$config = _ref6.config,
        config = _ref6$config === void 0 ? DEFAULT_CONFIG : _ref6$config,
        _ref6$options = _ref6.options,
        options = _ref6$options === void 0 ? DEFAULT_OPTIONS : _ref6$options;
      this.checkInitParams(thirdParties);
      this.config = config;
      this.logger = options.logger;
      this.isRecording = options.isRecording;
      eventQueue.init(this.config);
      this.monitoring = function (name) {
        return function (error, eventType) {
          var sentryParams = {
            tags: {
              context: name
            }
          };
          var statsdParams = [name, 'error', eventType];
          options.sendErrorToMonitoring(constants/* NAMESPACE_ERROR */.oc, error, sentryParams, statsdParams);
        };
      };
      this.detectBlocker = function (name) {
        return function (value) {
          options.detectBlocker(name, value);
        };
      };
      this.thirdParties = this.initializeThirdParties(thirdParties);
    }
  }, {
    key: "checkInitParams",
    value: function checkInitParams(thirdParties) {
      thirdParties.forEach(function (_a) {
        var name = _a.name,
          key = _a.key,
          thirdParty = __rest(_a, ["name", "key"]);
        if (!key || !name) {
          throw new Error(INIT_ERROR_MESSAGE);
        }
        if (has_default()(thirdParty, 'engine') && typeof thirdParty.engine !== 'function') {
          throw new Error(ENGINE_OVERRIDE_ERROR_MESSAGE);
        }
      });
    }
  }, {
    key: "loadThirdParties",
    value: function loadThirdParties(enginesStarting) {
      var _this2 = this;
      return Promise.all(enginesStarting.map(function () {
        var _ref7 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2(thirdParty) {
          var engine, bootModule, boot, name, initParams, key, builtInitParams;
          return regenerator_default().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return thirdParty.engine();
              case 2:
                thirdParty.engine = _context2.sent;
                engine = thirdParty.engine, bootModule = thirdParty.bootModule, boot = thirdParty.boot, name = thirdParty.name, initParams = thirdParty.initParams, key = thirdParty.key;
                engine.thirdPartyKey = key;
                engine.isRecording = _this2.isRecording;
                engine.sendErrorToMonitoring = _this2.monitoring(name);
                engine.detectBlocker = _this2.detectBlocker(name);
                builtInitParams = typeof initParams === 'function' ? initParams() : initParams;
                if (!(bootModule && bootModule.default && typeof bootModule.default === 'function')) {
                  _context2.next = 13;
                  break;
                }
                bootModule.default(builtInitParams);
                _context2.next = 16;
                break;
              case 13:
                if (!boot) {
                  _context2.next = 16;
                  break;
                }
                _context2.next = 16;
                return boot();
              case 16:
                _this2.logger("app:thirdparty:boot: ".concat(name));
                if (_this2.isRecording) {
                  set_default()(window, "".concat(constants/* MOCK_THIRDPARTY_OBJECT_KEY */.kr, ".").concat(name), []);
                }
                if (!(typeof engine.init === 'function')) {
                  _context2.next = 24;
                  break;
                }
                if (_this2.isRecording) {
                  (0,utils/* storeCallForMock */.c6)(name, 'fido:boot', builtInitParams);
                }
                _context2.next = 22;
                return engine.init(builtInitParams);
              case 22:
                _context2.next = 25;
                break;
              case 24:
                if (_this2.isRecording) {
                  (0,utils/* storeCallForMock */.c6)(name, 'fido:boot:no-init');
                }
              case 25:
                thirdParty.initialized = true;
              case 26:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref7.apply(this, arguments);
        };
      }()));
    }
  }, {
    key: "flushEvents",
    value: function flushEvents() {
      return eventQueue.flushEvents(this.thirdParties);
    }
  }]);
  return ThirdPartyControllerService;
}(AbstractThirdPartyInterface);
var thirdPartyControllerService = new ThirdPartyControllerService();
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/thirdParty/thirdPartyWithLayoutService.js







function thirdPartyWithLayoutService_createSuper(t) { var r = thirdPartyWithLayoutService_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function thirdPartyWithLayoutService_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (thirdPartyWithLayoutService_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }




var ThirdPartyWithLayoutService = function (_ThirdPartyController) {
  (0,inherits/* default */.Z)(ThirdPartyWithLayoutService, _ThirdPartyController);
  var _super = thirdPartyWithLayoutService_createSuper(ThirdPartyWithLayoutService);
  function ThirdPartyWithLayoutService() {
    var _this;
    (0,classCallCheck/* default */.Z)(this, ThirdPartyWithLayoutService);
    _this = _super.call(this);
    var _connectAction = connectAction(_this.sendEventWithLayoutThirdPartyData.bind((0,assertThisInitialized/* default */.Z)(_this))),
      connectedSendEvent = _connectAction.connectedAction,
      waitForSendEventPromise = _connectAction.waitForPromise;
    var _connectAction2 = connectAction(_this.sendPageViewEventWithLayoutThirdPartyData.bind((0,assertThisInitialized/* default */.Z)(_this))),
      connectedSendPageViewEvent = _connectAction2.connectedAction,
      waitForSendPageViewEventPromise = _connectAction2.waitForPromise;
    var _connectAction3 = connectAction(_this.sendClickEventWithLayoutThirdPartyData.bind((0,assertThisInitialized/* default */.Z)(_this))),
      connectedSendClickEvent = _connectAction3.connectedAction,
      waitForSendClickEvent = _connectAction3.waitForPromise;
    var _connectAction4 = connectAction(_this.sendPrintEventWithLayoutThirdPartyData.bind((0,assertThisInitialized/* default */.Z)(_this))),
      connectedSendPrintEvent = _connectAction4.connectedAction,
      waitForSendPrintEvent = _connectAction4.waitForPromise;
    _this.sendEvent = connectedSendEvent;
    _this.sendPageViewEvent = connectedSendPageViewEvent;
    _this.sendClickEvent = connectedSendClickEvent;
    _this.sendPrintEvent = connectedSendPrintEvent;
    _this.waitForPromise = function (promise) {
      waitForSendEventPromise(promise);
      waitForSendPageViewEventPromise(promise);
      waitForSendClickEvent(promise);
      waitForSendPrintEvent(promise);
      return promise;
    };
    return _this;
  }
  (0,createClass/* default */.Z)(ThirdPartyWithLayoutService, [{
    key: "sendEventWithLayoutThirdPartyData",
    value: function sendEventWithLayoutThirdPartyData(data, params, action, layoutThirdPartyData) {
      var _this2 = this;
      setTimeout(function () {
        (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(ThirdPartyWithLayoutService.prototype), "sendEvent", _this2).call(_this2, params, action, _this2.mergeLayoutThirdPartyData(data, layoutThirdPartyData));
      }, 0);
    }
  }, {
    key: "sendPageViewEventWithLayoutThirdPartyData",
    value: function sendPageViewEventWithLayoutThirdPartyData(data, params, location, layoutThirdPartyData) {
      var mergedLayoutThirdPartyData = this.mergeLayoutThirdPartyData(data, layoutThirdPartyData);
      this.callEnginesMethod('setContentGroupsFromLayout')(data, mergedLayoutThirdPartyData);
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(ThirdPartyWithLayoutService.prototype), "sendPageViewEvent", this).call(this, params, location, mergedLayoutThirdPartyData);
    }
  }, {
    key: "sendClickEventWithLayoutThirdPartyData",
    value: function sendClickEventWithLayoutThirdPartyData(data, params, action, layoutThirdPartyData) {
      var _this3 = this;
      setTimeout(function () {
        (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(ThirdPartyWithLayoutService.prototype), "sendClickEvent", _this3).call(_this3, params, action, _this3.mergeLayoutThirdPartyData(data, layoutThirdPartyData));
      }, 0);
    }
  }, {
    key: "sendPrintEventWithLayoutThirdPartyData",
    value: function sendPrintEventWithLayoutThirdPartyData(data, params, action, layoutThirdPartyData) {
      var _this4 = this;
      setTimeout(function () {
        (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(ThirdPartyWithLayoutService.prototype), "sendPrintEvent", _this4).call(_this4, params, action, _this4.mergeLayoutThirdPartyData(data, layoutThirdPartyData));
      }, 0);
    }
  }, {
    key: "mergeLayoutThirdPartyData",
    value: function mergeLayoutThirdPartyData(layout, thirdPartyData) {
      var layoutAnalytics = get_default()(layout, 'analytics', {});
      return layout ? merge_default()({}, layoutAnalytics, thirdPartyData) : thirdPartyData;
    }
  }]);
  return ThirdPartyWithLayoutService;
}(ThirdPartyControllerService);
var thirdPartyWithLayoutService = new ThirdPartyWithLayoutService();
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/includes.js
var includes = __webpack_require__(44840);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(82691);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/fido.js
var es_fido = __webpack_require__(94031);
// EXTERNAL MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/utils/queryParamSerializer.js
var queryParamSerializer = __webpack_require__(97605);
// EXTERNAL MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/utils/fetch.js
var utils_fetch = __webpack_require__(20280);
// EXTERNAL MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/fetcherService.js + 5 modules
var fetcherService = __webpack_require__(1445);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/monitoring/statsdMonitoringService.js











function monitoring_statsdMonitoringService_createSuper(t) { var r = monitoring_statsdMonitoringService_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function monitoring_statsdMonitoringService_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (monitoring_statsdMonitoringService_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }







var statsdMonitoringService_StatsdMonitoringService = function (_FetcherService) {
  (0,inherits/* default */.Z)(StatsdMonitoringService, _FetcherService);
  var _super = monitoring_statsdMonitoringService_createSuper(StatsdMonitoringService);
  function StatsdMonitoringService() {
    var _this;
    (0,classCallCheck/* default */.Z)(this, StatsdMonitoringService);
    _this = _super.apply(this, arguments);
    _this.apiType = 'monitoring';
    _this.stack = [];
    _this.buildPattern = function (basePattern, encoded) {
      return encoded ? "".concat(basePattern, "&encoded=1") : basePattern;
    };
    _this.buildEncodedNode = function (originalNode) {
      return encodeURIComponent(enc_base64_default().stringify(enc_utf8_default().parse(originalNode)));
    };
    _this.buildNodes = function (tags, encoded) {
      var scope = _this.isClientSide ? 'client' : 'server';
      var prefixedTags = [es_fido/* fido */.n.get('customerCode'), _this.platformCode, scope].concat((0,toConsumableArray/* default */.Z)(tags));
      var node = prefixedTags.join('.');
      return {
        originalNode: node,
        encodedNode: encoded ? _this.buildEncodedNode(node) : node
      };
    };
    return _this;
  }
  (0,createClass/* default */.Z)(StatsdMonitoringService, [{
    key: "init",
    value: function init(isClientSide, _ref) {
      var enabled = _ref.enabled,
        salt = _ref.salt,
        platformCode = _ref.platformCode;
      this.isClientSide = isClientSide;
      this.enabled = enabled;
      if (!this.isInitialized) {
        this.basePath = 'statsd';
        this.salt = salt;
        this.getCurrentTime = es_fido/* fido */.n.get('getCurrentTime');
        this.platformCode = platformCode || es_fido/* fido */.n.get('platformCode');
        this.isInitialized = true;
        this.processStack();
      }
    }
  }, {
    key: "generateToken",
    value: function generateToken(node) {
      var isTimingToken = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var template = isTimingToken ? "".concat(node).concat(this.salt) : "".concat(node, "1").concat(this.salt);
      var hash = md5_default()(template);
      return hash.toString((enc_hex_default()));
    }
  }, {
    key: "sendIncrement",
    value: function sendIncrement() {
      var _this2 = this;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var tags = args[0],
        token = args[1],
        _args$ = args[2],
        encoded = _args$ === void 0 ? false : _args$;
      if (!this.isInitialized) {
        this.stack.push(function () {
          return _this2.sendIncrement.apply(_this2, args);
        });
        return;
      }
      if (!this.enabled) {
        return;
      }
      var _this$buildNodes = this.buildNodes(tags, encoded),
        originalNode = _this$buildNodes.originalNode,
        encodedNode = _this$buildNodes.encodedNode;
      var url = this.getRouteUrl("".concat(encodedNode, "/increment?token=").concat(token || this.generateToken(originalNode)));
      (0,utils_fetch/* fetch */.h)(this.buildPattern(url, encoded)).catch(function () {});
    }
  }, {
    key: "sendTiming",
    value: function sendTiming() {
      var _this3 = this;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      var tags = args[0],
        duration = args[1],
        token = args[2],
        _args$2 = args[3],
        encoded = _args$2 === void 0 ? false : _args$2;
      if (!this.isInitialized) {
        this.stack.push(function () {
          return _this3.sendTiming.apply(_this3, args);
        });
        return;
      }
      if (!this.enabled) {
        return;
      }
      var _this$buildNodes2 = this.buildNodes(tags, encoded),
        originalNode = _this$buildNodes2.originalNode,
        encodedNode = _this$buildNodes2.encodedNode;
      var url = this.getRouteUrl("".concat(encodedNode, "/timer/").concat(duration, "?token=").concat(token || this.generateToken(originalNode, true)));
      (0,utils_fetch/* fetch */.h)(this.buildPattern(url, encoded)).catch(function () {});
    }
  }, {
    key: "processStack",
    value: function processStack() {
      if (this.isInitialized) {
        this.stack.forEach(function (sendTags) {
          return sendTags();
        });
        this.stack = [];
      }
    }
  }, {
    key: "sendAppStart",
    value: function sendAppStart(version) {
      this.sendIncrement([version, 'frontend_app_startup_total']);
    }
  }, {
    key: "sendSilentError",
    value: function sendSilentError() {
      this.sendIncrement(['frontend_silent_error_total']);
    }
  }, {
    key: "sendFatalError",
    value: function sendFatalError() {
      this.sendIncrement(['frontend_fatal_error_total']);
    }
  }, {
    key: "sendManualLoginSuccess",
    value: function sendManualLoginSuccess() {
      this.sendIncrement(['frontend_login_total']);
    }
  }, {
    key: "sendAutoLoginSuccess",
    value: function sendAutoLoginSuccess() {
      this.sendIncrement(['frontend_auto_login_total']);
    }
  }, {
    key: "sendManualLoginError",
    value: function sendManualLoginError() {
      this.sendIncrement(['frontend_login_error_total']);
    }
  }, {
    key: "sendRegisterSuccess",
    value: function sendRegisterSuccess() {
      this.sendIncrement(['frontend_register_total']);
    }
  }, {
    key: "sendRegisterError",
    value: function sendRegisterError() {
      this.sendIncrement(['frontend_register_error_total']);
    }
  }, {
    key: "sendCompleteRegistrationSuccess",
    value: function sendCompleteRegistrationSuccess() {
      this.sendIncrement(['frontend_complete_registration_total']);
    }
  }, {
    key: "sendCompleteRegistrationError",
    value: function sendCompleteRegistrationError() {
      this.sendIncrement(['frontend_complete_registration_error_total']);
    }
  }, {
    key: "sendPaymentDone",
    value: function sendPaymentDone(payment) {
      this.sendIncrement([payment, 'frontend_payment_done_total']);
    }
  }, {
    key: "sendPaymentFailure",
    value: function sendPaymentFailure(payment, failure) {
      this.sendIncrement([payment, failure, 'frontend_payment_failure_total']);
    }
  }, {
    key: "sendLayoutRedirection",
    value: function sendLayoutRedirection(frontspace) {
      this.sendIncrement(['frontend_layout', frontspace, 'redirect_total']);
    }
  }, {
    key: "sendProfileSelection",
    value: function sendProfileSelection() {
      this.sendIncrement(['frontend_profile_selection_total']);
    }
  }, {
    key: "sendProfileSelectionFailure",
    value: function sendProfileSelectionFailure() {
      this.sendIncrement(['frontend_profile_selection_failure_total']);
    }
  }, {
    key: "sendProfileAutoSelection",
    value: function sendProfileAutoSelection() {
      this.sendIncrement(['frontend_profile_autoselection_total']);
    }
  }, {
    key: "sendProfileAutoSelectionFailure",
    value: function sendProfileAutoSelectionFailure() {
      this.sendIncrement(['frontend_profile_autoselection_failure_total']);
    }
  }, {
    key: "sendSearchBatchHit",
    value: function sendSearchBatchHit() {
      this.sendIncrement(['frontend_search_total']);
    }
  }, {
    key: "sendUpdatePassword",
    value: function sendUpdatePassword() {
      this.sendIncrement(['frontend_update_password']);
    }
  }]);
  return StatsdMonitoringService;
}(fetcherService/* FetcherService */.x);
var statsdMonitoringService_statsdMonitoringService = new statsdMonitoringService_StatsdMonitoringService();
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/utils/retryRequest.js

var MAX_RETRY_COUNT = 2;
var RETRY_OPTIONS_ERROR_MESSAGE = 'You should provide correct retry options parameters';
var retryRequestCallback = function retryRequestCallback(apiType, method) {
  return function (error) {
    statsdMonitoringService_statsdMonitoringService.sendIncrement(['fido', 'retry', error ? 'error' : 'success', method, apiType]);
  };
};
var buildRetryOptions = function buildRetryOptions(_ref) {
  var apiType = _ref.apiType,
    count = _ref.count;
  if (!apiType || typeof count !== 'number' || count > MAX_RETRY_COUNT) {
    throw new Error(RETRY_OPTIONS_ERROR_MESSAGE);
  }
  return {
    apiType: apiType,
    count: count,
    callback: retryRequestCallback
  };
};
// EXTERNAL MODULE: ./node_modules/.pnpm/crypto-js@4.2.0/node_modules/crypto-js/sha256.js
var sha256 = __webpack_require__(57735);
var sha256_default = /*#__PURE__*/__webpack_require__.n(sha256);
// EXTERNAL MODULE: ./node_modules/.pnpm/jwt-decode@2.2.0/node_modules/jwt-decode/lib/index.js
var lib = __webpack_require__(30588);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/errors/fetch.error.js
var fetch_error = __webpack_require__(39814);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/monitoring/timer.util.js


var timer_util_Timer = function () {
  function Timer() {
    var getCurrentTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Date.now;
    (0,classCallCheck/* default */.Z)(this, Timer);
    this.getCurrentTime = getCurrentTime;
    this.startTime = null;
    this.endTime = null;
  }
  (0,createClass/* default */.Z)(Timer, [{
    key: "start",
    value: function start() {
      this.startTime = this.getCurrentTime();
    }
  }, {
    key: "stop",
    value: function stop() {
      this.endTime = this.getCurrentTime();
    }
  }, {
    key: "duration",
    value: function duration() {
      if (this.startTime === null || this.endTime === null) {
        throw new Error('You should start and stop the timer before getting duration');
      }
      return this.endTime - this.startTime;
    }
  }]);
  return Timer;
}();
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/monitoring/decorators/withMonitoring.js








var withMonitoring_DEFAULT_STATUS_CODE = 0;
var withMonitoring_withMonitoring = function withMonitoring() {
  for (var _len = arguments.length, tags = new Array(_len), _key = 0; _key < _len; _key++) {
    tags[_key] = arguments[_key];
  }
  return function (target, key, descriptor) {
    var fn = descriptor.value;
    descriptor.value = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee() {
      var returnValue,
        timer,
        _len2,
        args,
        _key2,
        _args = arguments;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            timer = new timer_util_Timer(statsdMonitoringService_statsdMonitoringService.getCurrentTime);
            timer.start();
            _context.prev = 2;
            for (_len2 = _args.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = _args[_key2];
            }
            _context.next = 6;
            return fn.apply(this, args);
          case 6:
            returnValue = _context.sent;
            _context.next = 13;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](2);
            if (_context.t0 instanceof fetch_error/* FetchError */.k) {
              statsdMonitoringService_statsdMonitoringService.sendIncrement(['error', 'fido'].concat(tags, [key, get_default()(_context.t0, 'response.status', withMonitoring_DEFAULT_STATUS_CODE)]));
            } else {
              statsdMonitoringService_statsdMonitoringService.sendIncrement(['error', 'fido'].concat(tags, [key, 'custom_error']));
            }
            throw _context.t0;
          case 13:
            timer.stop();
            statsdMonitoringService_statsdMonitoringService.sendTiming(['fido'].concat(tags, [key]), timer.duration());
            return _context.abrupt("return", returnValue);
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee, this, [[2, 9]]);
    }));
    return descriptor;
  };
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/authentication/oidcService.js
















































function oidcService_createSuper(t) { var r = oidcService_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function oidcService_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (oidcService_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var oidcService_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,esm_typeof/* default */.Z)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var monitoring = withMonitoring_withMonitoring('oidc');
var STORAGE_KEYS = {
  ACCESS_TOKEN: 'oidcAccessToken',
  REFRESH_TOKEN: 'oidcRefreshToken',
  ID_TOKEN: 'oidcIdToken',
  CODE_VERIFIER: 'oidcCodeVerifier'
};
var isClient = typeof window !== 'undefined';
var OIDCService = function (_FetcherService) {
  (0,inherits/* default */.Z)(OIDCService, _FetcherService);
  var _super = oidcService_createSuper(OIDCService);
  function OIDCService() {
    var _this;
    (0,classCallCheck/* default */.Z)(this, OIDCService);
    _this = _super.apply(this, arguments);
    _this.accessToken = null;
    _this.refreshToken = null;
    _this.deviceCode = null;
    _this.isInitialized = false;
    _this.codeVerifier = null;
    _this.codeChallenge = null;
    return _this;
  }
  (0,createClass/* default */.Z)(OIDCService, [{
    key: "init",
    value: function init(_ref) {
      var clientId = _ref.clientId,
        clientSecret = _ref.clientSecret,
        endpoints = _ref.endpoints;
      if (!this.isInitialized) {
        this.endpoints = endpoints;
        this.clientId = clientId;
        this.clientSecret = clientSecret;
        this.isInitialized = true;
        if (isClient) {
          this.setAccessToken(localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN));
          this.setRefreshToken(localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN));
          this.setIdToken(localStorage.getItem(STORAGE_KEYS.ID_TOKEN));
        }
      }
    }
  }, {
    key: "getApiUrl",
    value: function getApiUrl(endpoint) {
      return "".concat(es_fido/* fido */.n.getBaseUrl('oidc'), "/").concat(endpoint);
    }
  }, {
    key: "getCustomApiUrl",
    value: function getCustomApiUrl(endpoint) {
      return "".concat(es_fido/* fido */.n.getBaseUrl('oidcCustomApi'), "/").concat(endpoint);
    }
  }, {
    key: "isGuestUser",
    value: function isGuestUser() {
      try {
        return lib_default()(this.accessToken).isGuest;
      } catch (_a) {
        return false;
      }
    }
  }, {
    key: "getOrCreateCodeChallenge",
    value: function getOrCreateCodeChallenge() {
      if (this.codeChallenge) {
        return this.codeChallenge;
      }
      if (!this.codeVerifier) {
        this.getOrCreateCodeVerifier();
      }
      var hash = sha256_default()(this.codeVerifier);
      this.codeChallenge = enc_base64_default().stringify(hash).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
      return this.codeChallenge;
    }
  }, {
    key: "getOrCreateCodeVerifier",
    value: function getOrCreateCodeVerifier() {
      if (this.codeVerifier) {
        return this.codeVerifier;
      }
      if (isClient && sessionStorage.getItem(STORAGE_KEYS.CODE_VERIFIER)) {
        this.codeVerifier = sessionStorage.getItem(STORAGE_KEYS.CODE_VERIFIER);
        return this.codeVerifier;
      }
      var array = new Uint32Array(32);
      window.crypto.getRandomValues(array);
      this.codeVerifier = Array.from(array, function (dec) {
        return "0".concat(dec.toString(16)).substr(-2);
      }).join('');
      sessionStorage.setItem(STORAGE_KEYS.CODE_VERIFIER, this.codeVerifier);
      return this.codeVerifier;
    }
  }, {
    key: "getDeviceCode",
    value: function getDeviceCode() {
      return this.deviceCode;
    }
  }, {
    key: "getOrFetchOidcTokens",
    value: (function () {
      var _getOrFetchOidcTokens = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee() {
        var accessToken, refreshToken, tokens;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.getValidAccessToken();
            case 2:
              accessToken = _context.sent;
              refreshToken = this.getRefreshToken();
              if (accessToken) {
                _context.next = 10;
                break;
              }
              _context.next = 7;
              return this.fetchAnonymousTokens();
            case 7:
              tokens = _context.sent;
              accessToken = tokens.access_token;
              refreshToken = '';
            case 10:
              return _context.abrupt("return", {
                accessToken: accessToken,
                refreshToken: refreshToken
              });
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getOrFetchOidcTokens() {
        return _getOrFetchOidcTokens.apply(this, arguments);
      }
      return getOrFetchOidcTokens;
    }())
  }, {
    key: "fetchConnectedTokens",
    value: (function () {
      var _fetchConnectedTokens = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2() {
        var params,
          _a,
          tokens,
          _args2 = arguments;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              params = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
              if ((_a = this.endpoints) === null || _a === void 0 ? void 0 : _a.TOKEN) {
                _context2.next = 3;
                break;
              }
              throw new Error('Token endpoint is not configured for the current provider.');
            case 3:
              _context2.next = 5;
              return this.externalFetch(this.getApiUrl(this.endpoints.TOKEN), {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: Object.assign({
                  client_id: this.clientId
                }, params)
              });
            case 5:
              tokens = _context2.sent;
              this.setAccessToken(tokens.access_token);
              this.setRefreshToken(tokens.refresh_token);
              this.setIdToken(tokens.id_token);
              return _context2.abrupt("return", tokens);
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchConnectedTokens() {
        return _fetchConnectedTokens.apply(this, arguments);
      }
      return fetchConnectedTokens;
    }())
  }, {
    key: "fetchAnonymousTokens",
    value: (function () {
      var _fetchAnonymousTokens = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee3() {
        var _a, tokens;
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if ((_a = this.endpoints) === null || _a === void 0 ? void 0 : _a.TOKEN) {
                _context3.next = 2;
                break;
              }
              throw new Error('Token endpoint is not configured for the current provider.');
            case 2:
              _context3.next = 4;
              return this.externalFetch(this.getApiUrl(this.endpoints.TOKEN), {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: {
                  client_id: 'anonymous-user',
                  client_secret: this.clientSecret,
                  grant_type: 'client_credentials'
                }
              });
            case 4:
              tokens = _context3.sent;
              this.setAccessToken(tokens.access_token);
              this.refreshToken = '';
              this.idToken = '';
              return _context3.abrupt("return", tokens);
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function fetchAnonymousTokens() {
        return _fetchAnonymousTokens.apply(this, arguments);
      }
      return fetchAnonymousTokens;
    }())
  }, {
    key: "getUserInfo",
    value: (function () {
      var _getUserInfo = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee4() {
        var _a, accessToken;
        return regenerator_default().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if ((_a = this.endpoints) === null || _a === void 0 ? void 0 : _a.USERINFO) {
                _context4.next = 2;
                break;
              }
              throw new Error('UserInfo endpoint is not configured for the current provider.');
            case 2:
              _context4.next = 4;
              return this.getValidAccessToken();
            case 4:
              accessToken = _context4.sent;
              if (accessToken) {
                _context4.next = 7;
                break;
              }
              throw new Error('No access token to fetch user info');
            case 7:
              if (!this.isGuestUser()) {
                _context4.next = 9;
                break;
              }
              return _context4.abrupt("return", Promise.resolve());
            case 9:
              return _context4.abrupt("return", this.externalFetch(this.getApiUrl(this.endpoints.USERINFO), {
                method: 'GET',
                headers: {
                  Authorization: "Bearer ".concat(accessToken)
                }
              }));
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getUserInfo() {
        return _getUserInfo.apply(this, arguments);
      }
      return getUserInfo;
    }())
  }, {
    key: "getAuthorizedUrl",
    value: function getAuthorizedUrl(_ref2) {
      var _ref2$params = _ref2.params,
        params = _ref2$params === void 0 ? [] : _ref2$params,
        _ref2$type = _ref2.type,
        type = _ref2$type === void 0 ? 'login' : _ref2$type;
      var _a, _b;
      var endpoint;
      if (type === 'registration') {
        endpoint = (_a = this.endpoints) === null || _a === void 0 ? void 0 : _a.AUTHORIZATION_WITH_REGISTRATION;
      } else if (type === 'login') {
        endpoint = (_b = this.endpoints) === null || _b === void 0 ? void 0 : _b.AUTHORIZATION_WITH_LOGIN;
      } else {
        throw new Error("Invalid authorization type: ".concat(type, ". Use 'login' or 'registration'."));
      }
      if (!endpoint) {
        throw new Error("Authorization endpoint for type '".concat(type, "' is not configured for the current provider."));
      }
      var url = new URL(this.getApiUrl(endpoint));
      var searchParams = new URLSearchParams(params);
      url.search = searchParams.toString();
      return url.toString();
    }
  }, {
    key: "authorizeDevice",
    value: (function () {
      var _authorizeDevice = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee5() {
        var scopes,
          _a,
          body,
          _args5 = arguments;
        return regenerator_default().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              scopes = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : 'openid profile offline_access';
              if ((_a = this.endpoints) === null || _a === void 0 ? void 0 : _a.DEVICE_AUTHORIZATION) {
                _context5.next = 3;
                break;
              }
              throw new Error('Device authorization endpoint is not configured for the current provider.');
            case 3:
              _context5.next = 5;
              return this.externalFetch(this.getApiUrl(this.endpoints.DEVICE_AUTHORIZATION), {
                method: 'POST',
                body: "scope=".concat(scopes, "&client_id=").concat(this.clientId),
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                }
              });
            case 5:
              body = _context5.sent;
              this.deviceCode = body.device_code;
              return _context5.abrupt("return", body);
            case 8:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function authorizeDevice() {
        return _authorizeDevice.apply(this, arguments);
      }
      return authorizeDevice;
    }())
  }, {
    key: "revokeToken",
    value: (function () {
      var _revokeToken = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee6() {
        var _a, accessToken, response;
        return regenerator_default().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if ((_a = this.endpoints) === null || _a === void 0 ? void 0 : _a.REVOCATION) {
                _context6.next = 2;
                break;
              }
              throw new Error('Revocation endpoint is not configured for the current provider.');
            case 2:
              accessToken = this.getAccessToken();
              if (accessToken) {
                _context6.next = 5;
                break;
              }
              throw new Error('No accessToken to revoke');
            case 5:
              _context6.prev = 5;
              _context6.next = 8;
              return this.externalFetch(this.getApiUrl(this.endpoints.REVOCATION), {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: {
                  token: accessToken,
                  client_id: this.clientId
                }
              });
            case 8:
              response = _context6.sent;
              this.clearTokens();
              return _context6.abrupt("return", response);
            case 13:
              _context6.prev = 13;
              _context6.t0 = _context6["catch"](5);
              throw new Error("Error revoking accessToken: ".concat(_context6.t0));
            case 16:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[5, 13]]);
      }));
      function revokeToken() {
        return _revokeToken.apply(this, arguments);
      }
      return revokeToken;
    }())
  }, {
    key: "getLogoutRedirectUrl",
    value: function getLogoutRedirectUrl(postLogoutUrl) {
      var _a;
      if (!((_a = this.endpoints) === null || _a === void 0 ? void 0 : _a.LOGOUT)) {
        throw new Error('Logout endpoint is not configured for the current provider.');
      }
      var idToken = this.getIdToken();
      if (!idToken) {
        throw new Error('No ID Token to revoke');
      }
      var params = new URLSearchParams({
        id_token_hint: idToken,
        client_id: this.clientId,
        post_logout_redirect_uri: postLogoutUrl
      });
      return "".concat(this.getApiUrl(this.endpoints.LOGOUT), "?").concat(params);
    }
  }, {
    key: "getAccessToken",
    value: function getAccessToken() {
      return this.accessToken;
    }
  }, {
    key: "getRefreshToken",
    value: function getRefreshToken() {
      return this.refreshToken;
    }
  }, {
    key: "getIdToken",
    value: function getIdToken() {
      return this.idToken;
    }
  }, {
    key: "setAccessToken",
    value: function setAccessToken(token) {
      this.accessToken = token;
      if (isClient) {
        localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, token);
      }
    }
  }, {
    key: "setRefreshToken",
    value: function setRefreshToken(token) {
      this.refreshToken = token;
      if (isClient) {
        localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, token);
      }
    }
  }, {
    key: "setIdToken",
    value: function setIdToken(token) {
      this.idToken = token;
      if (isClient) {
        localStorage.setItem(STORAGE_KEYS.ID_TOKEN, token);
      }
    }
  }, {
    key: "clearTokens",
    value: function clearTokens() {
      this.accessToken = null;
      this.refreshToken = null;
      this.idToken = null;
      if (isClient) {
        localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
        localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
        localStorage.removeItem(STORAGE_KEYS.ID_TOKEN);
      }
    }
  }, {
    key: "isTokenValid",
    value: function isTokenValid(token) {
      if (!token) {
        return false;
      }
      try {
        var decodedToken = lib_default()(token);
        return new Date().getTime() < (decodedToken.exp - 10) * 1000;
      } catch (_a) {
        return false;
      }
    }
  }, {
    key: "getValidAccessToken",
    value: (function () {
      var _getValidAccessToken = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee7() {
        return regenerator_default().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              if (this.isTokenValid(this.accessToken)) {
                _context7.next = 4;
                break;
              }
              _context7.next = 4;
              return this.renewAccessToken();
            case 4:
              _context7.next = 9;
              break;
            case 6:
              _context7.prev = 6;
              _context7.t0 = _context7["catch"](0);
              this.accessToken = null;
            case 9:
              return _context7.abrupt("return", this.accessToken);
            case 10:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[0, 6]]);
      }));
      function getValidAccessToken() {
        return _getValidAccessToken.apply(this, arguments);
      }
      return getValidAccessToken;
    }())
  }, {
    key: "checkRefreshTokenValidity",
    value: function checkRefreshTokenValidity() {
      if (!this.isTokenValid(this.refreshToken)) {
        this.refreshToken = null;
      }
      if (isClient) {
        if (!this.isTokenValid(localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN))) {
          localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
        }
      }
    }
  }, {
    key: "checkIdTokenValidity",
    value: function checkIdTokenValidity() {
      if (!this.isTokenValid(this.idToken)) {
        this.idToken = null;
      }
      if (isClient) {
        if (!this.isTokenValid(localStorage.getItem(STORAGE_KEYS.ID_TOKEN))) {
          localStorage.removeItem(STORAGE_KEYS.ID_TOKEN);
        }
      }
    }
  }, {
    key: "renewAccessToken",
    value: (function () {
      var _renewAccessToken = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee8() {
        var _a, refreshToken, response;
        return regenerator_default().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if ((_a = this.endpoints) === null || _a === void 0 ? void 0 : _a.TOKEN) {
                _context8.next = 2;
                break;
              }
              throw new Error('Token endpoint is not configured for the current provider.');
            case 2:
              _context8.prev = 2;
              this.checkRefreshTokenValidity();
              refreshToken = this.getRefreshToken();
              if (!(!refreshToken || refreshToken === '')) {
                _context8.next = 9;
                break;
              }
              _context8.next = 8;
              return this.fetchAnonymousTokens();
            case 8:
              return _context8.abrupt("return");
            case 9:
              _context8.next = 11;
              return this.externalFetch(this.getApiUrl(this.endpoints.TOKEN), {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: {
                  client_id: this.clientId,
                  grant_type: 'refresh_token',
                  refresh_token: refreshToken
                }
              });
            case 11:
              response = _context8.sent;
              if (response.access_token) {
                _context8.next = 14;
                break;
              }
              throw new Error('Invalid response');
            case 14:
              this.setAccessToken(response.access_token);
              this.setRefreshToken(response.refresh_token);
              this.setIdToken(response.id_token);
              _context8.next = 22;
              break;
            case 19:
              _context8.prev = 19;
              _context8.t0 = _context8["catch"](2);
              throw new Error("RefreshToken error: ".concat(_context8.t0));
            case 22:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[2, 19]]);
      }));
      function renewAccessToken() {
        return _renewAccessToken.apply(this, arguments);
      }
      return renewAccessToken;
    }())
  }, {
    key: "logout",
    value: (function () {
      var _logout = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee9() {
        var _a, accessToken, refreshToken, response;
        return regenerator_default().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if ((_a = this.endpoints) === null || _a === void 0 ? void 0 : _a.CUSTOM_LOGOUT) {
                _context9.next = 2;
                break;
              }
              throw new Error('Custom logout endpoint is not configured for the current provider.');
            case 2:
              _context9.next = 4;
              return this.getValidAccessToken();
            case 4:
              accessToken = _context9.sent;
              if (accessToken) {
                _context9.next = 7;
                break;
              }
              throw new Error('Access token is required to logout');
            case 7:
              refreshToken = this.getRefreshToken();
              if (refreshToken) {
                _context9.next = 10;
                break;
              }
              throw new Error('Refresh token is required to logout');
            case 10:
              _context9.next = 12;
              return this.externalFetch(this.getCustomApiUrl(this.endpoints.CUSTOM_LOGOUT), {
                method: 'POST',
                headers: {
                  Authorization: "Bearer ".concat(accessToken)
                },
                body: {
                  clientId: this.clientId,
                  logoutMode: 'CLIENT',
                  refreshToken: refreshToken
                }
              });
            case 12:
              response = _context9.sent;
              this.clearTokens();
              return _context9.abrupt("return", response);
            case 15:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function logout() {
        return _logout.apply(this, arguments);
      }
      return logout;
    }())
  }]);
  return OIDCService;
}(fetcherService/* FetcherService */.x);
oidcService_decorate([monitoring], OIDCService.prototype, "fetchConnectedTokens", null);
oidcService_decorate([monitoring], OIDCService.prototype, "fetchAnonymousTokens", null);
oidcService_decorate([monitoring], OIDCService.prototype, "getUserInfo", null);
oidcService_decorate([monitoring], OIDCService.prototype, "authorizeDevice", null);
oidcService_decorate([monitoring], OIDCService.prototype, "revokeToken", null);
oidcService_decorate([monitoring], OIDCService.prototype, "renewAccessToken", null);
oidcService_decorate([monitoring], OIDCService.prototype, "logout", null);
var oidcService_oidcService = new OIDCService();
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/utils/caching.js




var generateCachingKey = function generateCachingKey() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return JSON.stringify(args);
};
var withNoParallelRequest = function withNoParallelRequest(target, key, descriptor) {
  var cachedValues = {};
  var decoratedFunction = descriptor.value;
  descriptor.value = function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    var cachingKey = generateCachingKey(args);
    var cachedValue = cachedValues[cachingKey];
    if (cachedValue !== undefined) {
      return cachedValue;
    }
    var resultingPromise = decoratedFunction.call.apply(decoratedFunction, [this].concat(args));
    cachedValues[cachingKey] = resultingPromise;
    return resultingPromise.finally(function () {
      delete cachedValues[cachingKey];
    });
  };
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/utils/retryPromise.js


function retryPromise(fn) {
  var retriesLeft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
  var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return new Promise(function (resolve, reject) {
    return fn().then(resolve).catch(function (error) {
      if (retriesLeft <= 1) {
        reject(error);
        return;
      }
      setTimeout(function () {
        retryPromise(fn, retriesLeft - 1, delay * 2).then(resolve, reject);
      }, delay);
    });
  });
}
// EXTERNAL MODULE: ./node_modules/.pnpm/crypto-js@4.2.0/node_modules/crypto-js/hmac-sha1.js
var crypto_js_hmac_sha1 = __webpack_require__(69764);
var crypto_js_hmac_sha1_default = /*#__PURE__*/__webpack_require__.n(crypto_js_hmac_sha1);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/flow.js
var flow = __webpack_require__(14459);
var flow_default = /*#__PURE__*/__webpack_require__.n(flow);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/reject.js
var reject = __webpack_require__(8207);
var reject_default = /*#__PURE__*/__webpack_require__.n(reject);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(84715);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/utils/security.js














var UNSIGNED = 'UNSIGNED';
var DEVICE = 'DEVICE';
var TIMESTAMP = 'TIMESTAMP';
var GIGYA = 'GIGYA';
var FREEMIUM = 'FREEMIUM';
var TOKEN = 'TOKEN';
function getParamsString(params, prefix) {
  return flow_default()(function (x) {
    return map_default()(x, function (value, key) {
      return {
        key: key,
        value: value
      };
    });
  }, function (x) {
    return reject_default()(x, function (_ref) {
      var value = _ref.value;
      return value === undefined;
    });
  }, function (x) {
    return sortBy_default()(x, 'key');
  }, function (x) {
    return x.reduce(function (result, _ref2) {
      var value = _ref2.value,
        key = _ref2.key;
      var prefixedKey = prefix ? "".concat(prefix, "[").concat(key, "]") : key;
      var safeValue = typeof value === 'boolean' ? Number(value) : value;
      return result.concat(safeValue !== null && (0,esm_typeof/* default */.Z)(safeValue) === 'object' ? getParamsString(safeValue, prefixedKey) : "".concat(encodeURIComponent(prefixedKey), "=").concat(encodeURIComponent(safeValue)));
    }, []);
  })(params).join('&');
}
function genTimestampToken(path, params, currentTime, saltAndSugar) {
  if (!saltAndSugar) {
    throw new Error("Fido saltAndSugar parameter should be defined to generate token, received: ".concat(saltAndSugar));
  }
  var paramsString = getParamsString(params);
  var timestamp = Math.floor(parseInt(currentTime, 10) / 1000);
  return {
    token: crypto_js_hmac_sha1_default()("".concat(path).concat(paramsString).concat(Math.floor(timestamp / 60)), saltAndSugar).toString(),
    timestamp: timestamp
  };
}
var genGuid = function genGuid() {
  var time = new Date().getTime();
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (char) {
    var replacement = (time + Math.random() * 16) % 16 | 0;
    time = Math.floor(time / 16);
    if (char === 'x') {
      return replacement.toString(16);
    }
    return (replacement & 0x3 | 0x8).toString(16);
  });
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/utils/securityHeaderBuilder.js



var getTimestampHeader = function getTimestampHeader(path, params, time, saltAndSugar) {
  var timestampToken = genTimestampToken(path, params, time, saltAndSugar);
  return {
    'X-Auth-Token': timestampToken.token,
    'X-Auth-Token-Timestamp': timestampToken.timestamp
  };
};
var getGigyaUserHeader = function getGigyaUserHeader(_ref) {
  var UID = _ref.UID,
    UIDSignature = _ref.UIDSignature,
    signatureTimestamp = _ref.signatureTimestamp;
  return {
    'X-Auth-gigya-uid': UID,
    'X-Auth-gigya-signature': UIDSignature,
    'X-Auth-gigya-signature-timestamp': signatureTimestamp
  };
};
var isSignedGigyaUser = function isSignedGigyaUser(user) {
  return !!(user && user.UIDSignature);
};
var hasProfile = function hasProfile(profile) {
  return !!(profile && profile.profileUid);
};
var getUidTimestampHeader = function getUidTimestampHeader(path, params, time, saltAndSugar, user) {
  var timestampToken = genTimestampToken(path, params, time, saltAndSugar);
  var UID = user.UID;
  return {
    'X-Auth-Token': timestampToken.token,
    'X-Auth-Token-Timestamp': timestampToken.timestamp,
    'X-Auth-gigya-uid': UID
  };
};
var getHeaders = function getHeaders(_ref2, _ref3) {
  var path = _ref2.path,
    body = _ref2.body;
  var user = _ref3.user,
    profile = _ref3.profile;
  var baseHeaders = {
    'X-Customer-Name': es_fido/* fido */.n.get('customerCode'),
    'X-Client-Release': es_fido/* fido */.n.get('appVersion')
  };
  if (es_fido/* fido */.n.get('localDeviceId')) {
    baseHeaders['x-auth-device-id'] = es_fido/* fido */.n.get('localDeviceId');
  } else if (es_fido/* fido */.n.get('localHomeId')) {
    baseHeaders['x-auth-home-id'] = es_fido/* fido */.n.get('localHomeId');
  }
  try {
    if (hasProfile(profile)) {
      baseHeaders['X-Auth-profile-id'] = profile.profileUid;
    }
    if (!user) {
      return Object.assign(Object.assign({}, baseHeaders), getTimestampHeader(path, body, es_fido/* fido */.n.get('getCurrentTime')(), es_fido/* fido */.n.get('saltAndSugar')));
    }
    if (isSignedGigyaUser(user)) {
      return Object.assign(Object.assign({}, baseHeaders), getGigyaUserHeader(user));
    }
    return Object.assign(Object.assign({}, baseHeaders), getUidTimestampHeader(path, body, es_fido/* fido */.n.get('getCurrentTime')(), es_fido/* fido */.n.get('saltAndSugar'), user));
  } catch (e) {
    throw new Error("Something went wrong while generating headers: ".concat(e.message));
  }
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/authentication/tokenService.js














function tokenService_createSuper(t) { var r = tokenService_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function tokenService_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (tokenService_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var tokenService_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,esm_typeof/* default */.Z)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};










var tokenService_monitoring = withMonitoring_withMonitoring('token');
var TokenService = function (_FetcherService) {
  (0,inherits/* default */.Z)(TokenService, _FetcherService);
  var _super = tokenService_createSuper(TokenService);
  function TokenService() {
    var _this;
    (0,classCallCheck/* default */.Z)(this, TokenService);
    _this = _super.apply(this, arguments);
    _this.persistentToken = null;
    _this.decodedPersistentToken = null;
    _this.retry = 0;
    _this.maxRetry = 0;
    _this.advertisingId = null;
    _this.apiType = 'auth';
    _this.subscriptionList = null;
    return _this;
  }
  (0,createClass/* default */.Z)(TokenService, [{
    key: "init",
    value: function init() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        advertisingId = _ref.advertisingId,
        _ref$maxRetry = _ref.maxRetry,
        maxRetry = _ref$maxRetry === void 0 ? 3 : _ref$maxRetry,
        _ref$retryCooldown = _ref.retryCooldown,
        retryCooldown = _ref$retryCooldown === void 0 ? 50 : _ref$retryCooldown,
        _ref$persistentToken = _ref.persistentToken,
        persistentToken = _ref$persistentToken === void 0 ? null : _ref$persistentToken,
        _ref$boxId = _ref.boxId,
        boxId = _ref$boxId === void 0 ? null : _ref$boxId,
        _ref$boxType = _ref.boxType,
        boxType = _ref$boxType === void 0 ? null : _ref$boxType,
        _ref$deviceModel = _ref.deviceModel,
        deviceModel = _ref$deviceModel === void 0 ? null : _ref$deviceModel,
        _ref$deviceName = _ref.deviceName,
        deviceName = _ref$deviceName === void 0 ? null : _ref$deviceName,
        _ref$deviceVersion = _ref.deviceVersion,
        deviceVersion = _ref$deviceVersion === void 0 ? null : _ref$deviceVersion,
        _ref$frontStateAppVer = _ref.frontStateAppVersion,
        frontStateAppVersion = _ref$frontStateAppVer === void 0 ? null : _ref$frontStateAppVer,
        _ref$subscriptionList = _ref.subscriptionList,
        subscriptionList = _ref$subscriptionList === void 0 ? null : _ref$subscriptionList;
      if (!this.isInitialized) {
        this.advertisingId = advertisingId;
        this.maxRetry = maxRetry;
        this.retryCooldown = retryCooldown;
        this.basePath = "platforms/".concat(es_fido/* fido */.n.get('platformCode'));
        this.isInitialized = true;
        this.boxId = boxId;
        this.boxType = boxType;
        this.deviceModel = deviceModel;
        this.deviceName = deviceName;
        this.deviceVersion = deviceVersion;
        this.frontStateAppVersion = frontStateAppVersion;
        this.subscriptionList = subscriptionList;
        this.setToken(persistentToken);
      }
    }
  }, {
    key: "setAdvertisingId",
    value: function setAdvertisingId(advertisingId) {
      this.resetToken();
      this.advertisingId = advertisingId;
    }
  }, {
    key: "setUser",
    value: function setUser(user) {
      this.resetToken();
      this.user = user;
    }
  }, {
    key: "setProfile",
    value: function setProfile(profile) {
      this.resetToken();
      this.profile = profile;
    }
  }, {
    key: "setSubscriptionList",
    value: function setSubscriptionList(subscriptionList) {
      this.resetToken();
      this.subscriptionList = subscriptionList;
    }
  }, {
    key: "resetProfile",
    value: function resetProfile() {
      this.setProfile(null);
    }
  }, {
    key: "resetToken",
    value: function resetToken() {
      this.persistentToken = null;
      this.decodedPersistentToken = null;
    }
  }, {
    key: "setToken",
    value: function setToken(token) {
      this.persistentToken = token;
      this.decodedPersistentToken = null;
      if (token) {
        try {
          this.decodedPersistentToken = lib_default()(token);
        } catch (_a) {}
      }
    }
  }, {
    key: "resetUserAndToken",
    value: function resetUserAndToken() {
      this.resetToken();
      this.user = null;
      this.profile = null;
    }
  }, {
    key: "isTokenValid",
    value: function isTokenValid() {
      if (!this.decodedPersistentToken) {
        return false;
      }
      return es_fido/* fido */.n.get('getCurrentTime')() < (this.decodedPersistentToken.exp - 10) * 1000;
    }
  }, {
    key: "getToken",
    value: (function () {
      var _getToken = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee() {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.persistentToken) {
                _context.next = 4;
                break;
              }
              if (!this.isTokenValid()) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return", this.persistentToken);
            case 3:
              this.resetToken();
            case 4:
              if (!oidcService_oidcService.isInitialized) {
                _context.next = 9;
                break;
              }
              _context.next = 7;
              return this.renewOidcToken();
            case 7:
              _context.next = 11;
              break;
            case 9:
              _context.next = 11;
              return this.renewToken();
            case 11:
              return _context.abrupt("return", this.persistentToken);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getToken() {
        return _getToken.apply(this, arguments);
      }
      return getToken;
    }())
  }, {
    key: "getTokenInformation",
    value: function () {
      var _getTokenInformation = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2() {
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.getToken();
            case 2:
              return _context2.abrupt("return", this.decodedPersistentToken);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getTokenInformation() {
        return _getTokenInformation.apply(this, arguments);
      }
      return getTokenInformation;
    }()
  }, {
    key: "renewToken",
    value: function renewToken() {
      var _this2 = this;
      var url = this.getRouteUrl('getJwt');
      var path = this.getRoutePath('getJwt', true);
      var advertisingId = this.advertisingId,
        boxType = this.boxType,
        boxId = this.boxId,
        deviceVersion = this.deviceVersion,
        deviceModel = this.deviceModel,
        deviceName = this.deviceName,
        frontStateAppVersion = this.frontStateAppVersion;
      var innerWidth = null;
      var innerHeight = null;
      if (typeof window !== 'undefined') {
        innerWidth = get_default()(window, 'innerWidth', null);
        innerHeight = get_default()(window, 'innerHeight', null);
      }
      return retryPromise(function () {
        return _this2.fetch(url, {
          method: 'GET',
          headers: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, boxId && {
            'x-auth-box-id': boxId
          }), boxType && {
            'x-auth-box-type': boxType
          }), advertisingId ? {
            'x-auth-advertising-id': advertisingId
          } : null), deviceVersion ? {
            'x-auth-device-version': deviceVersion
          } : null), deviceName ? {
            'x-auth-device-name': deviceName
          } : null), deviceModel ? {
            'x-auth-device-model': deviceModel
          } : null), frontStateAppVersion ? {
            'x-auth-frontstate-app-version': frontStateAppVersion
          } : null), innerWidth ? {
            'x-auth-device-player-size-width': innerWidth
          } : null), innerHeight ? {
            'x-auth-device-player-size-height': innerHeight
          } : null), _this2.subscriptionList ? {
            'x-external-subscription-access': _this2.subscriptionList
          } : null), getHeaders({
            path: path,
            body: {}
          }, {
            user: _this2.user,
            profile: _this2.profile
          }))
        });
      }, this.maxRetry, this.retryCooldown).then(function (_ref2) {
        var token = _ref2.token;
        _this2.setToken(token);
      }).catch(function (error) {
        throw new fetch_error/* FetchError */.k("tokenService:getJwt:fetch ".concat(error.status, " ").concat(error), null, error.response);
      });
    }
  }, {
    key: "renewOidcToken",
    value: (function () {
      var _renewOidcToken = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee3() {
        var _this3 = this;
        var routePath, routeUrl, url, _yield$oidcService$ge, accessToken, advertisingId, boxType, boxId, deviceVersion, deviceModel, deviceName, frontStateAppVersion, innerWidth, innerHeight;
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              routePath = this.getRoutePath('token');
              routeUrl = this.getRouteUrl('token');
              url = routeUrl.replace(routePath, "/".concat(es_fido/* fido */.n.get('customerCode')).concat(routePath));
              _context3.next = 5;
              return oidcService_oidcService.getOrFetchOidcTokens();
            case 5:
              _yield$oidcService$ge = _context3.sent;
              accessToken = _yield$oidcService$ge.accessToken;
              advertisingId = this.advertisingId, boxType = this.boxType, boxId = this.boxId, deviceVersion = this.deviceVersion, deviceModel = this.deviceModel, deviceName = this.deviceName, frontStateAppVersion = this.frontStateAppVersion;
              innerWidth = null;
              innerHeight = null;
              if (typeof window !== 'undefined') {
                innerWidth = get_default()(window, 'innerWidth', null);
                innerHeight = get_default()(window, 'innerHeight', null);
              }
              return _context3.abrupt("return", retryPromise(function () {
                return _this3.fetch(url, {
                  method: 'GET',
                  headers: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, boxId ? {
                    'x-auth-box-id': boxId
                  } : null), boxType ? {
                    'x-auth-box-type': boxType
                  } : null), advertisingId ? {
                    'x-auth-advertising-id': advertisingId
                  } : null), deviceVersion ? {
                    'x-auth-device-version': deviceVersion
                  } : null), deviceName ? {
                    'x-auth-device-name': deviceName
                  } : null), deviceModel ? {
                    'x-auth-device-model': deviceModel
                  } : null), frontStateAppVersion ? {
                    'x-auth-frontstate-app-version': frontStateAppVersion
                  } : null), innerWidth ? {
                    'x-auth-device-player-size-width': innerWidth
                  } : null), innerHeight ? {
                    'x-auth-device-player-size-height': innerHeight
                  } : null), _this3.subscriptionList ? {
                    'x-external-subscription-access': _this3.subscriptionList
                  } : null), {
                    Authorization: "Bearer ".concat(accessToken)
                  }), getHeaders({
                    body: {}
                  }, {
                    user: _this3.user,
                    profile: _this3.profile
                  }))
                });
              }, this.maxRetry).then(function (_ref3) {
                var token = _ref3.token;
                _this3.setToken(token);
              }).catch(function (error) {
                throw new fetch_error/* FetchError */.k("tokenService:token:fetch ".concat(error.status, " ").concat(error), null, error.response);
              }));
            case 12:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function renewOidcToken() {
        return _renewOidcToken.apply(this, arguments);
      }
      return renewOidcToken;
    }())
  }]);
  return TokenService;
}(fetcherService/* FetcherService */.x);
tokenService_decorate([withNoParallelRequest, tokenService_monitoring], TokenService.prototype, "renewToken", null);
tokenService_decorate([withNoParallelRequest, tokenService_monitoring], TokenService.prototype, "renewOidcToken", null);
var tokenService = new TokenService();
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/authentication/decorators/withJWT.js






var retrieveAndInjectToken = function () {
  var _ref = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(context, fn) {
    var args,
      retrying,
      token,
      argsSaved,
      headers,
      oidcAccessToken,
      _args = arguments;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          args = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
          retrying = _args.length > 3 ? _args[3] : undefined;
          _context.next = 4;
          return tokenService.getToken();
        case 4:
          token = _context.sent;
          argsSaved = Object.assign({}, args);
          if (!oidcService_oidcService.isInitialized) {
            _context.next = 13;
            break;
          }
          _context.next = 9;
          return oidcService_oidcService.getAccessToken();
        case 9:
          oidcAccessToken = _context.sent;
          headers = Object.assign(Object.assign({}, args.headers), {
            Authorization: "Bearer ".concat(oidcAccessToken),
            'X-Bedrock-Token': token
          });
          _context.next = 14;
          break;
        case 13:
          headers = Object.assign(Object.assign({}, args.headers), {
            Authorization: "Bearer ".concat(token)
          });
        case 14:
          return _context.abrupt("return", fn.apply(context, [Object.assign(Object.assign({}, args), {
            headers: headers
          })]).catch(function (error) {
            if (error.status === 498 && !retrying) {
              tokenService.resetToken();
              return retrieveAndInjectToken(context, fn, argsSaved, true);
            }
            throw error;
          }));
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function retrieveAndInjectToken(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var withJWT = function withJWT(target, name, descriptor) {
  var fn = descriptor.value;
  descriptor.value = function (args) {
    return retrieveAndInjectToken(this, fn, args);
  };
  return descriptor;
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/layout/layoutService.js
















function layoutService_createSuper(t) { var r = layoutService_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function layoutService_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (layoutService_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var layoutService_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,esm_typeof/* default */.Z)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};











var layoutService_monitoring = withMonitoring_withMonitoring('layout');
var LayoutService = function (_FetcherService) {
  (0,inherits/* default */.Z)(LayoutService, _FetcherService);
  var _super = layoutService_createSuper(LayoutService);
  function LayoutService() {
    var _this;
    (0,classCallCheck/* default */.Z)(this, LayoutService);
    _this = _super.apply(this, arguments);
    _this.apiType = 'layout';
    _this.defaultSectionCode = 'main';
    _this.checkEntity = function (entityId, entityType) {
      if (!entityId) {
        throw new Error('You should provide a non null entityId');
      }
      if (!entityType) {
        throw new Error('You should provide a non null entityType!');
      }
    };
    return _this;
  }
  (0,createClass/* default */.Z)(LayoutService, [{
    key: "init",
    value: function init(capacityToken) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$defaultLayoutThe = _ref.defaultLayoutTheme,
        defaultLayoutTheme = _ref$defaultLayoutThe === void 0 ? {} : _ref$defaultLayoutThe,
        _ref$retry = _ref.retry,
        retry = _ref$retry === void 0 ? 0 : _ref$retry;
      if (!this.isInitialized) {
        this.basePath = "".concat(es_fido/* fido */.n.get('customerCode'), "/%(platformCode)s");
        this.capacityToken = capacityToken;
        this.defaultLayoutTheme = defaultLayoutTheme;
        this.isInitialized = true;
        this.retryOptions = buildRetryOptions({
          apiType: this.apiType,
          count: retry
        });
      }
    }
  }, {
    key: "setDefaultLayoutTheme",
    value: function setDefaultLayoutTheme(layoutTheme) {
      if (layoutTheme && layoutTheme.backgroundColor && layoutTheme.colorScheme) {
        this.defaultLayoutTheme = layoutTheme;
      }
    }
  }, {
    key: "fetchByEntity",
    value: (function () {
      var _fetchByEntity = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(_ref2) {
        var entityType, entityId, _ref2$sectionCode, sectionCode, _ref2$headers, headers, _ref2$nbPages, nbPages, _ref2$queryParameters, queryParameters, _ref2$withCredentials, withCredentials, _ref2$signal, signal, token, serializedQueryParameters, layout, articleTarget;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              entityType = _ref2.entityType, entityId = _ref2.entityId, _ref2$sectionCode = _ref2.sectionCode, sectionCode = _ref2$sectionCode === void 0 ? this.defaultSectionCode : _ref2$sectionCode, _ref2$headers = _ref2.headers, headers = _ref2$headers === void 0 ? {} : _ref2$headers, _ref2$nbPages = _ref2.nbPages, nbPages = _ref2$nbPages === void 0 ? 2 : _ref2$nbPages, _ref2$queryParameters = _ref2.queryParameters, queryParameters = _ref2$queryParameters === void 0 ? {} : _ref2$queryParameters, _ref2$withCredentials = _ref2.withCredentials, withCredentials = _ref2$withCredentials === void 0 ? false : _ref2$withCredentials, _ref2$signal = _ref2.signal, signal = _ref2$signal === void 0 ? undefined : _ref2$signal;
              this.checkEntity(entityId, entityType);
              token = es_fido/* fido */.n.get('usedCapacityToken') || this.capacityToken;
              if (token === 'beta-all-available') {
                queryParameters.blockPage = 1;
              }
              serializedQueryParameters = (0,queryParamSerializer/* serialize */.q)(Object.assign({
                nbPages: nbPages
              }, queryParameters));
              if (!(entityType === 'article')) {
                _context.next = 14;
                break;
              }
              _context.next = 8;
              return this.fetch(this.getRouteUrl("".concat(sectionCode, "/").concat(es_fido/* fido */.n.get('usedCapacityToken') || this.capacityToken, "/video/clip_52/layout?").concat(serializedQueryParameters)), {
                method: 'GET',
                headers: headers,
                retry: this.retryOptions,
                withCredentials: withCredentials,
                signal: signal
              });
            case 8:
              layout = _context.sent;
              articleTarget = {
                type: 'layout',
                value_layout: {
                  section: 'main',
                  type: 'article',
                  id: entityId,
                  seo: 'this-is-article',
                  parent: {
                    id: '12345',
                    type: 'magazine',
                    seo: 'this-is-magazine'
                  }
                }
              };
              set_default()(layout, 'entity.id', entityId);
              set_default()(layout, 'layout.blocks[0].content.items[0].itemContent.action.target', articleTarget);
              _context.next = 17;
              break;
            case 14:
              _context.next = 16;
              return this.fetch(this.getRouteUrl("".concat(sectionCode, "/").concat(es_fido/* fido */.n.get('usedCapacityToken') || this.capacityToken, "/").concat(entityType, "/").concat(entityId, "/layout?").concat(serializedQueryParameters)), {
                method: 'GET',
                headers: headers,
                retry: this.retryOptions,
                withCredentials: withCredentials,
                signal: signal
              });
            case 16:
              layout = _context.sent;
            case 17:
              return _context.abrupt("return", this.applyDefaultLayoutThemeOnLayout(layout));
            case 18:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchByEntity(_x) {
        return _fetchByEntity.apply(this, arguments);
      }
      return fetchByEntity;
    }())
  }, {
    key: "fetchHeadByEntity",
    value: (function () {
      var _fetchHeadByEntity = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2(_ref3) {
        var entityType, entityId, _ref3$sectionCode, sectionCode, _ref3$headers, headers, _ref3$nbPages, nbPages, _ref3$platformCode, platformCode, _ref3$withCredentials, withCredentials;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              entityType = _ref3.entityType, entityId = _ref3.entityId, _ref3$sectionCode = _ref3.sectionCode, sectionCode = _ref3$sectionCode === void 0 ? this.defaultSectionCode : _ref3$sectionCode, _ref3$headers = _ref3.headers, headers = _ref3$headers === void 0 ? {} : _ref3$headers, _ref3$nbPages = _ref3.nbPages, nbPages = _ref3$nbPages === void 0 ? 2 : _ref3$nbPages, _ref3$platformCode = _ref3.platformCode, platformCode = _ref3$platformCode === void 0 ? es_fido/* fido */.n.get('platformCode') : _ref3$platformCode, _ref3$withCredentials = _ref3.withCredentials, withCredentials = _ref3$withCredentials === void 0 ? false : _ref3$withCredentials;
              this.checkEntity(entityId, entityType);
              return _context2.abrupt("return", this.fetchWithStatus(this.getRouteUrl("".concat(sectionCode, "/").concat(es_fido/* fido */.n.get('usedCapacityToken') || this.capacityToken, "/").concat(entityType, "/").concat(entityId, "/layout?").concat((0,queryParamSerializer/* serialize */.q)({
                nbPages: nbPages
              })), es_fido/* fido */.n.get('clientCode'), platformCode), {
                method: 'HEAD',
                headers: headers,
                retry: this.retryOptions,
                withCredentials: withCredentials
              }));
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchHeadByEntity(_x2) {
        return _fetchHeadByEntity.apply(this, arguments);
      }
      return fetchHeadByEntity;
    }())
  }, {
    key: "fetchBlockPage",
    value: (function () {
      var _fetchBlockPage = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee3(_ref4) {
        var entityType, entityId, blockId, _ref4$sectionCode, sectionCode, _ref4$headers, headers, page, _ref4$nbPages, nbPages, _ref4$queryParameters, queryParameters;
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              entityType = _ref4.entityType, entityId = _ref4.entityId, blockId = _ref4.blockId, _ref4$sectionCode = _ref4.sectionCode, sectionCode = _ref4$sectionCode === void 0 ? this.defaultSectionCode : _ref4$sectionCode, _ref4$headers = _ref4.headers, headers = _ref4$headers === void 0 ? {} : _ref4$headers, page = _ref4.page, _ref4$nbPages = _ref4.nbPages, nbPages = _ref4$nbPages === void 0 ? 1 : _ref4$nbPages, _ref4$queryParameters = _ref4.queryParameters, queryParameters = _ref4$queryParameters === void 0 ? {} : _ref4$queryParameters;
              if (entityId) {
                _context3.next = 3;
                break;
              }
              throw new Error('You should provide a non null entityId');
            case 3:
              if (entityType) {
                _context3.next = 5;
                break;
              }
              throw new Error('You should provide a non null entityType!');
            case 5:
              if (blockId) {
                _context3.next = 7;
                break;
              }
              throw new Error('You should provide a non null blockId !');
            case 7:
              return _context3.abrupt("return", this.fetch(this.getRouteUrl("".concat(sectionCode, "/").concat(es_fido/* fido */.n.get('usedCapacityToken') || this.capacityToken, "/").concat(entityType, "/").concat(entityId, "/block/").concat(blockId, "?").concat((0,queryParamSerializer/* serialize */.q)(Object.assign({
                page: page,
                nbPages: nbPages
              }, queryParameters)))), {
                method: 'GET',
                headers: headers,
                retry: this.retryOptions
              }));
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function fetchBlockPage(_x3) {
        return _fetchBlockPage.apply(this, arguments);
      }
      return fetchBlockPage;
    }())
  }, {
    key: "fetchNavigation",
    value: (function () {
      var _fetchNavigation = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee4(_ref5) {
        var target, _ref5$sectionCode, sectionCode, _ref5$headers, headers;
        return regenerator_default().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              target = _ref5.target, _ref5$sectionCode = _ref5.sectionCode, sectionCode = _ref5$sectionCode === void 0 ? this.defaultSectionCode : _ref5$sectionCode, _ref5$headers = _ref5.headers, headers = _ref5$headers === void 0 ? {} : _ref5$headers;
              if (Object.values(layout_constants/* navigationTargets */.bL).includes(target)) {
                _context4.next = 3;
                break;
              }
              throw new Error("Parameter \"target\" must be one of ".concat(Object.values(layout_constants/* navigationTargets */.bL).join(' | ')));
            case 3:
              return _context4.abrupt("return", this.fetch(this.getRouteUrl("".concat(sectionCode, "/").concat(es_fido/* fido */.n.get('usedCapacityToken') || this.capacityToken, "/navigation/").concat(target)), {
                method: 'GET',
                headers: headers,
                retry: this.retryOptions
              }));
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function fetchNavigation(_x4) {
        return _fetchNavigation.apply(this, arguments);
      }
      return fetchNavigation;
    }())
  }, {
    key: "applyDefaultLayoutThemeOnLayout",
    value: function applyDefaultLayoutThemeOnLayout(layout) {
      var _get2 = get_default()(layout, 'layout.theme', {}),
        backgroundColor = _get2.backgroundColor,
        colorScheme = _get2.colorScheme;
      if (isEmpty_default()(this.defaultLayoutTheme) || backgroundColor && colorScheme) {
        return layout;
      }
      return set_default()(layout, 'layout.theme', this.defaultLayoutTheme);
    }
  }, {
    key: "fetchEpgGrid",
    value: (function () {
      var _fetchEpgGrid = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee5(_ref6) {
        var _ref6$sectionCode, sectionCode, _ref6$headers, headers, _ref6$nbPages, nbPages, queryParameters, token, serializedQueryParameters;
        return regenerator_default().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _ref6$sectionCode = _ref6.sectionCode, sectionCode = _ref6$sectionCode === void 0 ? this.defaultSectionCode : _ref6$sectionCode, _ref6$headers = _ref6.headers, headers = _ref6$headers === void 0 ? {} : _ref6$headers, _ref6$nbPages = _ref6.nbPages, nbPages = _ref6$nbPages === void 0 ? 2 : _ref6$nbPages, queryParameters = _ref6.queryParameters;
              token = es_fido/* fido */.n.get('usedCapacityToken') || this.capacityToken;
              serializedQueryParameters = (0,queryParamSerializer/* serialize */.q)(Object.assign({
                nbPages: nbPages
              }, queryParameters));
              return _context5.abrupt("return", this.fetch(this.getRouteUrl("".concat(sectionCode, "/").concat(token, "/epg_grid?").concat(serializedQueryParameters)), {
                method: 'GET',
                headers: headers,
                retry: this.retryOptions
              }));
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function fetchEpgGrid(_x5) {
        return _fetchEpgGrid.apply(this, arguments);
      }
      return fetchEpgGrid;
    }())
  }, {
    key: "fetchEpgModal",
    value: (function () {
      var _fetchEpgModal = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee6(_ref7) {
        var _ref7$sectionCode, sectionCode, _ref7$headers, headers, queryParameters, id, signal, token, serializedQueryParameters;
        return regenerator_default().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _ref7$sectionCode = _ref7.sectionCode, sectionCode = _ref7$sectionCode === void 0 ? this.defaultSectionCode : _ref7$sectionCode, _ref7$headers = _ref7.headers, headers = _ref7$headers === void 0 ? {} : _ref7$headers, queryParameters = _ref7.queryParameters, id = _ref7.id, signal = _ref7.signal;
              token = es_fido/* fido */.n.get('usedCapacityToken') || this.capacityToken;
              serializedQueryParameters = (0,queryParamSerializer/* serialize */.q)(queryParameters);
              return _context6.abrupt("return", this.fetch(this.getRouteUrl("".concat(sectionCode, "/").concat(token, "/epg_grid/").concat(id, "/modal?").concat(serializedQueryParameters)), {
                method: 'GET',
                headers: headers,
                retry: this.retryOptions,
                signal: signal
              }));
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function fetchEpgModal(_x6) {
        return _fetchEpgModal.apply(this, arguments);
      }
      return fetchEpgModal;
    }())
  }]);
  return LayoutService;
}(fetcherService/* FetcherService */.x);
layoutService_decorate([withJWT, layoutService_monitoring], LayoutService.prototype, "fetchByEntity", null);
layoutService_decorate([withJWT, layoutService_monitoring], LayoutService.prototype, "fetchHeadByEntity", null);
layoutService_decorate([withJWT, layoutService_monitoring], LayoutService.prototype, "fetchBlockPage", null);
layoutService_decorate([withJWT, layoutService_monitoring], LayoutService.prototype, "fetchNavigation", null);
layoutService_decorate([withJWT, layoutService_monitoring], LayoutService.prototype, "fetchEpgGrid", null);
layoutService_decorate([withJWT, layoutService_monitoring], LayoutService.prototype, "fetchEpgModal", null);
var layoutService = new LayoutService();
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/layout/layoutForThirdPartyService.js













function layoutForThirdPartyService_createSuper(t) { var r = layoutForThirdPartyService_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function layoutForThirdPartyService_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (layoutForThirdPartyService_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }






var LayoutForThirdPartyService = function (_LayoutService) {
  (0,inherits/* default */.Z)(LayoutForThirdPartyService, _LayoutService);
  var _super = layoutForThirdPartyService_createSuper(LayoutForThirdPartyService);
  function LayoutForThirdPartyService() {
    (0,classCallCheck/* default */.Z)(this, LayoutForThirdPartyService);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(LayoutForThirdPartyService, [{
    key: "setInitialLayout",
    value: function setInitialLayout(layout) {
      thirdPartyWithLayoutService.waitForPromise(Promise.resolve(layout));
    }
  }, {
    key: "resetLayoutPromise",
    value: function resetLayoutPromise() {
      thirdPartyWithLayoutService.waitForPromise(Promise.resolve());
    }
  }, {
    key: "getAlternativeContentAnalytics",
    value: function getAlternativeContentAnalytics(block, blockAnalytics) {
      var alternativeContentAnalytics = get_default()(block, "alternativeContent.analytics", {});
      return block.alternativeContent ? Object.assign(Object.assign({}, block.alternativeContent), {
        analytics: merge_default()({}, blockAnalytics, alternativeContentAnalytics),
        concurrentBlocks: get_default()(block, "alternativeContent.concurrentBlocks", []).map(function (alternativeBlock) {
          return Object.assign(Object.assign({}, alternativeBlock), {
            analytics: merge_default()({}, blockAnalytics, alternativeContentAnalytics, get_default()(alternativeBlock, "analytics"))
          });
        })
      }) : null;
    }
  }, {
    key: "mapToBlock",
    value: function mapToBlock(block) {
      var blockAnalytics = get_default()(block, 'analytics', {});
      var getItemAnalytics = function getItemAnalytics(item) {
        return merge_default()({}, blockAnalytics, get_default()(item, 'analytics'));
      };
      var items = get_default()(block, 'content.items', []).map(function (item) {
        var itemContent = get_default()(item, 'itemContent');
        return Object.assign(Object.assign({}, item), {
          bookmark: item.bookmark ? Object.assign(Object.assign({}, get_default()(item, 'bookmark', {})), {
            analytics: merge_default()({}, getItemAnalytics(item), get_default()(item, 'bookmark.analytics'))
          }) : null,
          itemContent: Object.assign(Object.assign({}, itemContent), {
            bookmark: itemContent.bookmark ? Object.assign(Object.assign({}, get_default()(itemContent, 'bookmark', {})), {
              analytics: merge_default()({}, getItemAnalytics(itemContent), get_default()(itemContent, 'bookmark.analytics'))
            }) : null
          })
        });
      });
      return Object.assign(Object.assign({}, block), {
        content: Object.assign(Object.assign({}, get_default()(block, 'content')), {
          items: items
        })
      });
    }
  }, {
    key: "mapEntriesV1",
    value: function mapEntriesV1(data) {
      return {
        entries: map_default()(data.entries, function (_ref) {
          var entry = _ref.entry,
            subEntries = _ref.subEntries;
          var entryAnalytics = get_default()(entry, "target.analytics", {});
          var getSubEntryAnalytics = function getSubEntryAnalytics(object) {
            return merge_default()({}, entryAnalytics, get_default()(object, "target.analytics"));
          };
          var itemSubEntries = subEntries.map(function (subEntry) {
            return Object.assign(Object.assign({}, subEntry), {
              target: Object.assign(Object.assign({}, subEntry.target), {
                analytics: getSubEntryAnalytics(subEntry)
              }),
              action: subEntry.action ? Object.assign(Object.assign({}, subEntry.action), {
                target: Object.assign(Object.assign({}, subEntry.target), {
                  analytics: getSubEntryAnalytics(subEntry)
                })
              }) : null
            });
          });
          var actionList = itemSubEntries.map(function (subEntry) {
            return Object.assign(Object.assign({}, subEntry), {
              action: subEntry.action ? Object.assign(Object.assign({}, subEntry.action), {
                target: subEntry.target
              }) : {
                target: subEntry.target
              }
            });
          });
          var target = Object.assign(Object.assign({}, entry.target), {
            analytics: entryAnalytics
          });
          return {
            entry: Object.assign(Object.assign({}, entry), {
              target: target,
              actionList: actionList
            }),
            subEntries: itemSubEntries
          };
        })
      };
    }
  }, {
    key: "fetchByEntity",
    value: function fetchByEntity() {
      var _get3,
        _this = this;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return thirdPartyWithLayoutService.waitForPromise((_get3 = (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(LayoutForThirdPartyService.prototype), "fetchByEntity", this)).call.apply(_get3, [this].concat(args))).then(function (data) {
        return Object.assign(Object.assign({}, data), {
          blocks: data.blocks.map(function (block) {
            return _this.mapToBlock(block);
          })
        });
      });
    }
  }, {
    key: "fetchBlockPage",
    value: function fetchBlockPage() {
      var _get4,
        _this2 = this;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return (_get4 = (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(LayoutForThirdPartyService.prototype), "fetchBlockPage", this)).call.apply(_get4, [this].concat(args)).then(function (data) {
        return _this2.mapToBlock(data);
      });
    }
  }, {
    key: "fetchNavigation",
    value: function fetchNavigation() {
      var _get5,
        _this3 = this;
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      return (_get5 = (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(LayoutForThirdPartyService.prototype), "fetchNavigation", this)).call.apply(_get5, [this].concat(args)).then(function (data) {
        if (isArray_default()(data)) {
          return data;
        }
        return _this3.mapEntriesV1(data);
      });
    }
  }]);
  return LayoutForThirdPartyService;
}(LayoutService);
var layoutForThirdPartyService = new LayoutForThirdPartyService();
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/requiredArgs/index.js
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/isDate/index.js

/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */

function isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/toDate/index.js

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/isValid/index.js



/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */

function isValid(dirtyDate) {
  requiredArgs(1, arguments);

  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }

  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};

var formatDistance = function (token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
};

/* harmony default export */ const _lib_formatDistance = (formatDistance);
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/locale/en-US/_lib/formatLong/index.js

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ const _lib_formatLong = (formatLong);
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};

var formatRelative = function (token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

/* harmony default export */ const _lib_formatRelative = (formatRelative);
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js
function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!

    return valuesArray[index];
  };
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

var ordinalNumber = function (dirtyNumber, _options) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
};

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ const _lib_localize = (localize);
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js
function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }

  return undefined;
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }

  return undefined;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js
function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/locale/en-US/_lib/match/index.js


var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ const _lib_match = (match);
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/locale/en-US/index.js






/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: _lib_formatDistance,
  formatLong: _lib_formatLong,
  formatRelative: _lib_formatRelative,
  localize: _lib_localize,
  match: _lib_match,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
/* harmony default export */ const en_US = (locale);
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/toInteger/index.js
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/addMilliseconds/index.js



/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */

function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/subMilliseconds/index.js



/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */

function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/getUTCDayOfYear/index.js


var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js

 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js


 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/startOfUTCISOWeekYear/index.js


 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js


 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js



 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/startOfUTCWeekYear/index.js



 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  var year = getUTCWeekYear(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, dirtyOptions);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/getUTCWeek/index.js




var getUTCWeek_MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / getUTCWeek_MILLISECONDS_IN_WEEK) + 1;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/addLeadingZeros/index.js
function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/format/lightFormatters/index.js

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters = {
  // Year
  y: function (date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function (date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function (date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function (date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaa':
        return dayPeriodEnumValue;

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function (date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function (date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function (date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function (date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function (date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
/* harmony default export */ const lightFormatters = (formatters);
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/format/formatters/index.js







var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters_formatters = {
  // Era
  G: function (date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return lightFormatters.y(date, token);
  },
  // Local week-numbering year
  Y: function (date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function (date, token) {
    var isoWeekYear = getUTCISOWeekYear(date); // Padding

    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function (date, token, localize, options) {
    var week = getUTCWeek(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function (date, token, localize) {
    var isoWeek = getUTCISOWeek(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function (date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return lightFormatters.d(date, token);
  },
  // Day of year
  D: function (date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return lightFormatters.h(date, token);
  },
  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return lightFormatters.H(date, token);
  },
  // Hour [0-11]
  K: function (date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function (date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function (date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return lightFormatters.m(date, token);
  },
  // Second
  s: function (date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return lightFormatters.s(date, token);
  },
  // Fraction of second
  S: function (date, token) {
    return lightFormatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

/* harmony default export */ const format_formatters = (formatters_formatters);
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/format/longFormatters/index.js
function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
}

function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
}

function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
}

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
/* harmony default export */ const format_longFormatters = (longFormatters);
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/protectedTokens/index.js
var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  }
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/format/index.js









 // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format_format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var locale = options.locale || en_US;
  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = toDate(dirtyDate);

  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = format_longFormatters[firstCharacter];
      return longFormatter(substring, locale.formatLong, formatterOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }

    var formatter = format_formatters[firstCharacter];

    if (formatter) {
      if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }

      if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }

      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}
// EXTERNAL MODULE: ./node_modules/.pnpm/crypto-js@4.2.0/node_modules/crypto-js/sha1.js
var sha1 = __webpack_require__(99968);
var sha1_default = /*#__PURE__*/__webpack_require__.n(sha1);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isInteger.js
var isInteger = __webpack_require__(96789);
var isInteger_default = /*#__PURE__*/__webpack_require__.n(isInteger);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/omit.js
var omit = __webpack_require__(59245);
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/image/image.constants.js
var panoramicSizes = [320, 480, 640, 800, 960, 1120, 1440, 1760, 2080, 2560];
var portraitSizes = [320, 480, 600, 768, 960, 1080, 1200, 1440, 1600, 2048];
var ratios = {
  '15:4': 15 / 4,
  '16:9': 16 / 9,
  '5:3': 5 / 3,
  '3:1': 3,
  '4:1': 4,
  '3:4': 3 / 4,
  '9:16': 9 / 16,
  '2:5': 2 / 5,
  '2:3': 2 / 3,
  '1:1': 1,
  default: 16 / 9
};
var sizes = {
  '15:4': panoramicSizes,
  '16:9': panoramicSizes,
  '5:3': panoramicSizes,
  '3:1': panoramicSizes,
  '4:1': panoramicSizes,
  '3:4': portraitSizes,
  '9:16': portraitSizes,
  '2:5': portraitSizes,
  '2:3': portraitSizes,
  '1:1': portraitSizes,
  default: panoramicSizes
};
var minimumWidthForAvifInPixels = 1080;
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/image/imageService.js












function imageService_createSuper(t) { var r = imageService_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function imageService_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (imageService_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }











var ImageService = function (_FetcherService) {
  (0,inherits/* default */.Z)(ImageService, _FetcherService);
  var _super = imageService_createSuper(ImageService);
  function ImageService() {
    var _this;
    (0,classCallCheck/* default */.Z)(this, ImageService);
    _this = _super.apply(this, arguments);
    _this.apiType = 'image';
    return _this;
  }
  (0,createClass/* default */.Z)(ImageService, [{
    key: "init",
    value: function init() {
      if (!this.isInitialized) {
        this.basePath = 'images';
        this.isInitialized = true;
      }
    }
  }, {
    key: "getUrl",
    value: function getUrl(id, width, height, params) {
      var integerId = parseInt(id, 10);
      if (!isInteger_default()(integerId)) {
        return '';
      }
      var rawUrl = this.getRouteUrl("".concat(integerId, "/raw"));
      var builtParams = Object.assign({
        width: width,
        height: height,
        blur: 0,
        fit: 'scale_crop',
        interlace: 1
      }, params);
      if (builtParams.optimize) {
        delete builtParams.quality;
      } else if (!builtParams.quality) {
        builtParams.optimize = builtParams.optimize || 'high';
      }
      var defineImageFormat = function defineImageFormat(imageParams) {
        if (imageParams.width >= minimumWidthForAvifInPixels) {
          return 'avif';
        }
        return 'webp';
      };
      if (!builtParams.format) {
        builtParams.auto = defineImageFormat(builtParams);
      }
      var queryString = (0,queryParamSerializer/* serialize */.q)(builtParams, function (_ref) {
        var value = _ref.value;
        return value || value === 0;
      });
      if (queryString) {
        var path = this.getRoutePath("".concat(integerId, "/raw?").concat(queryString), true);
        var hash = sha1_default()("".concat(path).concat(es_fido/* fido */.n.get('imageSalt')));
        return "".concat(rawUrl, "?").concat(queryString, "&hash=").concat(hash);
      }
      return rawUrl;
    }
  }, {
    key: "findBestRatio",
    value: function findBestRatio() {
      var initialRatio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ratios.default;
      return Object.keys(ratios).reduce(function (prev, curr) {
        return Math.abs(ratios[curr] - initialRatio) < Math.abs(ratios[prev] - initialRatio) ? curr : prev;
      });
    }
  }, {
    key: "getSources",
    value: function getSources(id, ratio, params) {
      var _this2 = this;
      var sizeList = sizes[ratio] || sizes.default;
      return sizeList.reduce(function (acc, size) {
        var tau = ratios[ratio] || ratios.default;
        var width;
        var height;
        if (tau > 1) {
          width = size;
          height = Math.floor(size / tau);
        } else {
          width = Math.floor(size * tau);
          height = size;
        }
        return Object.assign(Object.assign({}, acc), (0,defineProperty/* default */.Z)({}, width, _this2.getUrl(id, width, height, params)));
      }, {});
    }
  }, {
    key: "prepareItem",
    value: function prepareItem(item) {
      var _this3 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var withWebp = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var itemContent = get_default()(item, 'itemContent', item);
      var preparedItem = Object.assign(Object.assign({}, itemContent), Object.keys(options).reduce(function (acc, key) {
        var itemContentField = get_default()(itemContent, key);
        if (itemContentField) {
          var option = get_default()(options, key);
          var imageOptions = omit_default()(option, ['rotating', 'rotatingOptions']);
          var image = _this3.prepareImage(itemContentField, imageOptions);
          if (withWebp) {
            var imageWebp = _this3.prepareImage(itemContentField, Object.assign(Object.assign({}, imageOptions), {
              format: 'webp'
            }));
            image.srcSetWebp = imageWebp.srcSet;
          }
          if (itemContentField.idsByRatio) {
            image.srcSetsByRatio = {};
            forEach_default()(itemContentField.idsByRatio, function (id, ratio) {
              image.srcSetsByRatio[ratio] = _this3.prepareImage({
                id: id,
                ratio: ratio
              }, imageOptions).srcSet;
            });
          }
          if (option.rotating) {
            var portrait = _this3.prepareImage(Object.assign(Object.assign({}, itemContentField), {
              ratio: '3:4'
            }), Object.assign(Object.assign({}, imageOptions), get_default()(option, 'rotatingOptions', {})));
            if (withWebp) {
              var _imageWebp = _this3.prepareImage(Object.assign(Object.assign({}, itemContentField), {
                ratio: '3:4'
              }), Object.assign(Object.assign(Object.assign({}, imageOptions), get_default()(option, 'rotatingOptions', {})), {
                format: 'webp'
              }));
              portrait.srcSetWebp = _imageWebp.srcSet;
            }
            set_default()(acc, key, {
              landscape: image,
              portrait: portrait
            });
          } else {
            set_default()(acc, key, image);
          }
          set_default()(acc, key, Object.assign(Object.assign({}, get_default()(acc, key)), meta));
        }
        return acc;
      }, {}));
      return Object.assign(Object.assign({}, preparedItem), {
        itemContent: preparedItem
      });
    }
  }, {
    key: "prepareImage",
    value: function prepareImage(_ref2, params) {
      var id = _ref2.id,
        _ref2$caption = _ref2.caption,
        caption = _ref2$caption === void 0 ? '' : _ref2$caption,
        _ref2$ratio = _ref2.ratio,
        ratio = _ref2$ratio === void 0 ? '16:9' : _ref2$ratio;
      var sources = this.getSources(id, ratio, params);
      return {
        srcSet: map_default()(sources, function (url, width) {
          return "".concat(url, " ").concat(width, "w");
        }).join(', '),
        src: sources[Object.keys(sources)[0]],
        caption: caption
      };
    }
  }, {
    key: "prepareItems",
    value: function prepareItems(items, options) {
      var _this4 = this;
      var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var withWebp = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      return items.map(function (item) {
        return _this4.prepareItem(item, options, meta, withWebp);
      });
    }
  }]);
  return ImageService;
}(fetcherService/* FetcherService */.x);
var imageService = new ImageService();
;// CONCATENATED MODULE: ./packages/tornado-rdk/theme/modes.js
var LIGHT_MODE = 'light';
var DARK_MODE = 'dark';
var DEFAULT_MODE = DARK_MODE;
var modes = [DARK_MODE, LIGHT_MODE];
;// CONCATENATED MODULE: ./packages/tornado-rdk/theme/constants.js
var PRIMARY = 'PRIMARY';
var SECONDARY = 'SECONDARY';
var TERTIARY = 'TERTIARY';
var QUATERNARY = 'QUATERNARY';
var QUINARY = 'QUINARY';
var UTILITY1 = 'UTILITY1';
var UTILITY2 = 'UTILITY2';
var UTILITY3 = 'UTILITY3';
var UTILITY4 = 'UTILITY4';
var ECO = 'ECO';
var constants_LIVE = 'LIVE';
var HIGHLIGHT = 'HIGHLIGHT';
var CLOUD_DARK = 'CLOUD_DARK';
var CLOUD_NORMAL = 'CLOUD_NORMAL';
var CLOUD_WHITE = 'CLOUD_WHITE';
var colorNames = [PRIMARY, SECONDARY, TERTIARY, QUATERNARY, QUINARY, UTILITY1, UTILITY2, UTILITY3, UTILITY4, ECO, constants_LIVE, HIGHLIGHT, CLOUD_WHITE, CLOUD_NORMAL, CLOUD_DARK];
;// CONCATENATED MODULE: ./packages/tornado-rdk/theme/utils.js







function utils_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function utils_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? utils_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : utils_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var alphaToHex = function alphaToHex(alpha) {
  return "0x".concat(Math.ceil(255 * alpha).toString(16));
};
var hexToARGB = function hexToARGB(color) {
  var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1.0;
  var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0x00000000;
  return color ? parseInt(color.replace('#', alphaToHex(alpha)), 16) : fallback;
};
var colorsToNumbers = function colorsToNumbers(strings) {
  return Object.keys(strings).reduce(function (colors, colorName) {
    colors[colorName] = hexToARGB(strings[colorName]);
    return colors;
  }, {});
};
var colorsSetToNumbers = function colorsSetToNumbers(colors) {
  return Object.keys(colors).reduce(function (result, mode) {
    var set = colorsToNumbers(colors[mode]);
    return utils_objectSpread(utils_objectSpread({}, result), {}, (0,defineProperty/* default */.Z)({}, mode, set));
  }, {});
};
;// CONCATENATED MODULE: ./packages/tornado-rdk/theme/customer/rtlde/colors.js

var _LIGHT_MODE, _DARK_MODE, _staticColors;



var staticColors = (_staticColors = {}, (0,defineProperty/* default */.Z)(_staticColors, LIGHT_MODE, (_LIGHT_MODE = {}, (0,defineProperty/* default */.Z)(_LIGHT_MODE, PRIMARY, '#000000'), (0,defineProperty/* default */.Z)(_LIGHT_MODE, SECONDARY, '#F7F8F9'), (0,defineProperty/* default */.Z)(_LIGHT_MODE, TERTIARY, '#ffffff'), (0,defineProperty/* default */.Z)(_LIGHT_MODE, QUATERNARY, '#AFB0B6'), (0,defineProperty/* default */.Z)(_LIGHT_MODE, QUINARY, '#5B14B8'), (0,defineProperty/* default */.Z)(_LIGHT_MODE, UTILITY1, '#da3b2b'), (0,defineProperty/* default */.Z)(_LIGHT_MODE, UTILITY2, '#4ed569'), (0,defineProperty/* default */.Z)(_LIGHT_MODE, UTILITY3, '#ffb002'), (0,defineProperty/* default */.Z)(_LIGHT_MODE, UTILITY4, '#4A90E2'), (0,defineProperty/* default */.Z)(_LIGHT_MODE, ECO, '#48b755'), (0,defineProperty/* default */.Z)(_LIGHT_MODE, constants_LIVE, '#E71700'), (0,defineProperty/* default */.Z)(_LIGHT_MODE, HIGHLIGHT, '#e6e6e6'), (0,defineProperty/* default */.Z)(_LIGHT_MODE, CLOUD_DARK, '#000000'), (0,defineProperty/* default */.Z)(_LIGHT_MODE, CLOUD_NORMAL, '#6F7175'), (0,defineProperty/* default */.Z)(_LIGHT_MODE, CLOUD_WHITE, '#ffffff'), _LIGHT_MODE)), (0,defineProperty/* default */.Z)(_staticColors, DARK_MODE, (_DARK_MODE = {}, (0,defineProperty/* default */.Z)(_DARK_MODE, PRIMARY, '#ffffff'), (0,defineProperty/* default */.Z)(_DARK_MODE, SECONDARY, '#F7F8F9'), (0,defineProperty/* default */.Z)(_DARK_MODE, TERTIARY, '#000000'), (0,defineProperty/* default */.Z)(_DARK_MODE, QUATERNARY, '#AFB0B6'), (0,defineProperty/* default */.Z)(_DARK_MODE, QUINARY, '#5B14B8'), (0,defineProperty/* default */.Z)(_DARK_MODE, UTILITY1, '#da3b2b'), (0,defineProperty/* default */.Z)(_DARK_MODE, UTILITY2, '#4ed569'), (0,defineProperty/* default */.Z)(_DARK_MODE, UTILITY3, '#ffb002'), (0,defineProperty/* default */.Z)(_DARK_MODE, UTILITY4, '#4A90E2'), (0,defineProperty/* default */.Z)(_DARK_MODE, ECO, '#48b755'), (0,defineProperty/* default */.Z)(_DARK_MODE, constants_LIVE, '#E71700'), (0,defineProperty/* default */.Z)(_DARK_MODE, HIGHLIGHT, '#252525'), (0,defineProperty/* default */.Z)(_DARK_MODE, CLOUD_DARK, '#000000'), (0,defineProperty/* default */.Z)(_DARK_MODE, CLOUD_NORMAL, '#6F7175'), (0,defineProperty/* default */.Z)(_DARK_MODE, CLOUD_WHITE, '#ffffff'), _DARK_MODE)), _staticColors);
var colors_colors = colorsSetToNumbers(staticColors);
;// CONCATENATED MODULE: ./packages/tornado-rdk/theme/index.js









var getColor = function getColor(_ref) {
  var name = _ref.name,
    _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? DEFAULT_MODE : _ref$mode,
    _ref$alpha = _ref.alpha,
    alpha = _ref$alpha === void 0 ? 1.0 : _ref$alpha;
  var result = colors_colors[mode][name];
  if (alpha < 1.0) {
    return hexToARGB(staticColors[mode][name], alpha);
  }
  return result;
};
var getDarkColor = function getDarkColor(name) {
  var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1.0;
  return getColor({
    name: name,
    alpha: alpha,
    mode: DARK_MODE
  });
};
var getLightColor = function getLightColor(name) {
  var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1.0;
  return getColor({
    name: name,
    alpha: alpha,
    mode: LIGHT_MODE
  });
};
var makeThemeColor = function makeThemeColor(name) {
  var _ref2;
  var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1.0;
  return _ref2 = {}, (0,defineProperty/* default */.Z)(_ref2, DARK_MODE, getDarkColor(name, alpha)), (0,defineProperty/* default */.Z)(_ref2, LIGHT_MODE, getLightColor(name, alpha)), _ref2;
};
;// CONCATENATED MODULE: ./src/modules/tornado/utils/theme.js


var getLayoutTheme = function getLayoutTheme(theme) {
  var parentTheme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var source = theme || {};
  var parent = parentTheme || {};
  var result = {
    backgroundColor: hexToARGB(source.backgroundColor, 1),
    backgroundImage: get_default()(source, 'backgroundImage.id') || '',
    foregroundImage: get_default()(source, 'foregroundImage.id') || '',
    colorScheme: source.colorScheme || parent.colorScheme || DEFAULT_MODE
  };
  return result;
};
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.object.freeze.js
var es_object_freeze = __webpack_require__(76105);
;// CONCATENATED MODULE: ./src/modules/tornado/utils/virtualization.js






var PLACEHOLDER = Object.freeze({
  id: 'placeholder'
});
var ITEMS_TO_KEEP_BETWEEN_SCREENS = 10;
var HOLDER = {};
var PAGE_STATE = {
  LOADED: 'loaded',
  MISSING: 'missing',
  LOADING: 'loading'
};
var getOrCreateTemplatesHolder = function getOrCreateTemplatesHolder(template) {
  if (!HOLDER[template]) {
    HOLDER[template] = [];
  }
  return HOLDER[template];
};
var getFromBuffer = function getFromBuffer(template) {
  var holder = getOrCreateTemplatesHolder(template);
  if (holder.length) {
    return holder.pop();
  }
  return null;
};
var backToBuffer = function backToBuffer(view) {
  if (!view || !view.template) {
    return;
  }
  var holder = getOrCreateTemplatesHolder(view.template);
  if (!holder.includes(view)) {
    holder.push(view);
  }
};
var cleanupBuffer = function cleanupBuffer(view) {
  if (!view || !view.template) {
    return;
  }
  var holder = HOLDER[view.template];
  if (!holder || holder.length <= ITEMS_TO_KEEP_BETWEEN_SCREENS) {
    return;
  }
  HOLDER[view.template] = holder.filter(function (bufferedView) {
    return bufferedView !== view;
  });
};
var cleanupVirtualizationCache = function cleanupVirtualizationCache() {
  Object.keys(HOLDER).forEach(function (key) {
    if (Array.isArray(HOLDER[key])) {
      HOLDER[key].forEach(function (view) {
        if (view && view.parent) {
          view.parent.childList.remove(view);
        }
      });
    }
    delete HOLDER[key];
  });
};
;// CONCATENATED MODULE: ./src/modules/tornado/signals.js
var SELECTED_SIGNAL = 'selected';
var FOCUSED_SIGNAL = 'focused';
var PORTION_REQUESTED_SIGNAL = 'portionRequested';
var INACTIVE_SIGNAL = 'inactive';
var DETACHED_SIGNAL = 'detached';
var NOTIFICATION_SIGNAL = 'notification';
var EPG_SIGNAL = 'epg';
var TEXTURE_LOADED_SIGNAL = 'tx_loaded';
var HIDE_BACKGROUND_SIGNAL = 'hide_background';
var SHOW_BACKGROUND_SIGNAL = 'show_background';
var SHOW_GRID_SIGNAL = 'show_grid';
;// CONCATENATED MODULE: ./src/modules/tornado/row/row.constants.js
var ITEMS_PLACEMENT_TIMEOUT = 100;
var FOCUS_MODE_CENTER = 'center';
var FOCUS_MODE_LEFT = 'left';
var FOCUS_MODES = [FOCUS_MODE_CENTER, FOCUS_MODE_LEFT];
var START_POINT_MODE_CENTER = 'center';
var START_POINT_MODE_LEFT = 'left';
var START_POINT_MODES = [START_POINT_MODE_CENTER, START_POINT_MODE_LEFT];
;// CONCATENATED MODULE: ./src/modules/tornado/utils/sizes.js

var _SCREEN_WIDTH, _SCREEN_HEIGHT;

var SCREEN_WIDTH = (_SCREEN_WIDTH = {}, (0,defineProperty/* default */.Z)(_SCREEN_WIDTH, HD, 1280), (0,defineProperty/* default */.Z)(_SCREEN_WIDTH, FULL_HD, 1920), _SCREEN_WIDTH);
var sizes_SCREEN_HEIGHT = (_SCREEN_HEIGHT = {}, (0,defineProperty/* default */.Z)(_SCREEN_HEIGHT, HD, 720), (0,defineProperty/* default */.Z)(_SCREEN_HEIGHT, FULL_HD, 1080), _SCREEN_HEIGHT);
var identity = function identity(value) {
  return value;
};
var proportional = function proportional(percent) {
  return function (value) {
    return Math.round(value * percent);
  };
};
var middle = proportional(0.5);
var sizes_getScreenSize = function getScreenSize() {
  return window.innerHeight <= 720 ? HD : FULL_HD;
};
var getCenter = function getCenter(parentSize, childSize) {
  return Math.round((parentSize - childSize) / 2);
};
;// CONCATENATED MODULE: ./src/modules/tornado/utils/style.js






var FOCUSED_Z_INDEX = 10;
var UNFOCUSED_Z_INDEX = 0;
var cacheResolver = function cacheResolver(context) {
  return context ? Object.keys(context).map(function (key) {
    return "".concat(key, "=").concat(context[key]);
  }).join(',') : '';
};
var makeDefaultStylingContext = function makeDefaultStylingContext() {
  return {
    screenSize: sizes_getScreenSize(),
    colorMode: DEFAULT_MODE
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/row/row.style.js

var _CONTENT_GAP;


var defaultContext = makeDefaultStylingContext();
var CONTENT_GAP = (_CONTENT_GAP = {}, (0,defineProperty/* default */.Z)(_CONTENT_GAP, HD, 12), (0,defineProperty/* default */.Z)(_CONTENT_GAP, FULL_HD, 12), _CONTENT_GAP);
;// CONCATENATED MODULE: ./src/modules/tornado/row/row.component.js












function row_component_createSuper(t) { var r = row_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function row_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (row_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }






var Row = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Row, _Lightning$Component);
  var _super = row_component_createSuper(Row);
  function Row() {
    (0,classCallCheck/* default */.Z)(this, Row);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Row, [{
    key: "_construct",
    value: function _construct() {
      this._style = defaultContext;
      this._contentGap = CONTENT_GAP[this._style.screenSize];
      this._isRowActive = false;
      this._isRowAttached = false;
      this._resetVirtualization();
      this._leftPadding = 0;
      this._rightPadding = 0;
    }
  }, {
    key: "_active",
    value: function _active() {
      var _this = this;
      this._isRowActive = true;
      if (this._data) {
        if (this._isDataApplied) {
          this._placeItems();
        } else {
          this._timeout = setTimeout(function () {
            _this.data = _this._data;
          }, ITEMS_PLACEMENT_TIMEOUT);
        }
      }
    }
  }, {
    key: "_inactive",
    value: function _inactive() {
      this._isRowActive = false;
      clearTimeout(this._timeout);
    }
  }, {
    key: "_attach",
    value: function _attach() {
      this._isRowAttached = true;
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this._isRowAttached = false;
      this._resetVirtualization();
    }
  }, {
    key: "data",
    set: function set(value) {
      var _this2 = this;
      if (!value) {
        return;
      }
      this.patch({
        w: value.rowSize.w,
        h: value.itemSize.h
      });
      this._data = value;
      if (!this._isRowActive) {
        return;
      }
      var _this$_data = this._data,
        block = _this$_data.block,
        blockIndex = _this$_data.blockIndex,
        itemSize = _this$_data.itemSize,
        itemTemplate = _this$_data.itemTemplate,
        theme = _this$_data.theme;
      var _block$content = block.content,
        items = _block$content.items,
        pagination = _block$content.pagination;
      var _getLayoutTheme = getLayoutTheme(block.theme, theme),
        colorScheme = _getLayoutTheme.colorScheme;
      var isUpdating = this._isDataApplied;
      this._blockIndex = blockIndex;
      this._isDataApplied = true;
      this._colorScheme = colorScheme;
      this._id = block.id;
      this._itemSize = itemSize;
      this._items = items.map(function (item, index) {
        var existingItem = _this2._items[index];
        if (existingItem) {
          existingItem.content = item;
          existingItem.config = itemSize;
          existingItem.template = itemTemplate;
          existingItem.colorScheme = _this2._colorScheme;
          return existingItem;
        }
        return _this2._makeItemData(item, index);
      });
      var totalItems = pagination.totalItems,
        itemsPerPage = pagination.itemsPerPage;
      this._totalItems = totalItems;
      this._itemsPerPage = itemsPerPage;
      this._pages = block.pages;
      this._updateContentPlacementStartPoint();
      this._setIndex(Math.min(this._focusedItemIndex, Math.max(this._totalItems - 1, 0)));
      if (isUpdating) {
        var views = Object.keys(this._views);
        for (var i = 0; i < views.length; i += 1) {
          var viewIndex = views[i];
          if (viewIndex >= this._totalItems) {
            this._backToBuffer(this._views[viewIndex]);
          }
        }
      }
      this._refocus();
    }
  }, {
    key: "id",
    get: function get() {
      return this._id;
    }
  }, {
    key: "focusMode",
    set: function set(value) {
      if (FOCUS_MODES.includes(value) && this._focusMode !== value) {
        this._focusMode = value;
        this.goTo(this._focusedItemIndex);
      }
    }
  }, {
    key: "startPointMode",
    get: function get() {
      return this._startPointMode;
    },
    set: function set(value) {
      if (START_POINT_MODES.includes(value) && this._startPointMode !== value) {
        this._startPointMode = value;
        this._updateContentPlacementStartPoint();
        this.goTo(this._focusedItemIndex);
      }
    }
  }, {
    key: "contentGap",
    get: function get() {
      return this._contentGap;
    },
    set: function set(value) {
      this._contentGap = value;
      this._updateContentPlacementStartPoint();
      this.goTo(this._focusedItemIndex);
    }
  }, {
    key: "leftPadding",
    get: function get() {
      return this._leftPadding;
    },
    set: function set(value) {
      this._leftPadding = value;
      this._updateContentPlacementStartPoint();
      this.goTo(this._focusedItemIndex);
    }
  }, {
    key: "rightPadding",
    get: function get() {
      return this._rightPadding;
    },
    set: function set(value) {
      this._rightPadding = value;
      this._updateContentPlacementStartPoint();
      this.goTo(this._focusedItemIndex);
    }
  }, {
    key: "focusedIndex",
    get: function get() {
      return this._focusedItemIndex;
    },
    set: function set(value) {
      this._focusedItemIndex = value;
    }
  }, {
    key: "goTo",
    value: function goTo(index) {
      this._setIndex(index);
    }
  }, {
    key: "_setIndex",
    value: function _setIndex(index) {
      var shouldAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this._focusedItemIndex = index;
      if (!this._totalItems) {
        return;
      }
      if (shouldAnimate) {
        this._animateTo(this._focusedItemIndex);
      } else {
        this._moveTo(this._focusedItemIndex);
      }
      if (this._isRowActive) {
        this._placeItems();
      }
      this.signal(FOCUSED_SIGNAL, index);
      if (this._itemsPerPage > 0 && this._pages) {
        var currentPage = Math.floor(this._focusedItemIndex / this._itemsPerPage);
        var nextPage = this._pages[0] === PAGE_STATE.LOADED ? currentPage + 1 : 0;
        if (currentPage !== nextPage) {
          this._requestPage(currentPage);
          if (currentPage - 1 >= 0) {
            this._requestPage(currentPage - 1);
          }
        }
        this._requestPage(nextPage);
      }
    }
  }, {
    key: "_requestPage",
    value: function _requestPage(page) {
      if (this._pages[page] !== PAGE_STATE.MISSING) {
        return;
      }
      this.signal(PORTION_REQUESTED_SIGNAL, {
        page: page + 1,
        start: page * this._itemsPerPage,
        id: this.id
      });
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this._placeItems();
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this._views[this._focusedItemIndex];
    }
  }, {
    key: "_makeItemData",
    value: function _makeItemData(content, index) {
      var _this$_data2 = this._data,
        itemSize = _this$_data2.itemSize,
        itemTemplate = _this$_data2.itemTemplate;
      return {
        content: content,
        index: index,
        config: itemSize,
        template: itemTemplate,
        colorScheme: this._colorScheme
      };
    }
  }, {
    key: "_getMaxOffset",
    value: function _getMaxOffset() {
      if (!this._data || !this._totalItems) {
        return 0;
      }
      var itemWidthWithGap = this._data.itemSize.w + this._contentGap;
      var allItemsSize = this._totalItems * itemWidthWithGap - this._contentGap;
      return this.finalW - this._leftPadding - this._rightPadding - allItemsSize;
    }
  }, {
    key: "_updateContentPlacementStartPoint",
    value: function _updateContentPlacementStartPoint() {
      if (!this._data || this._startPointMode === START_POINT_MODE_LEFT) {
        this._startPoint = 0;
        return;
      }
      this._startPoint = Math.max(Math.round(this._getMaxOffset() / 2), 0);
    }
  }, {
    key: "_offsetByIndex",
    value: function _offsetByIndex(index) {
      if (!this._data || !this._totalItems) {
        return 0;
      }
      var itemWidthWithGap = this._data.itemSize.w + this._contentGap;
      var maxOffset = Math.min(this._getMaxOffset(), 0);
      var offset = -index * itemWidthWithGap;
      if (this._focusMode === FOCUS_MODE_CENTER) {
        return Math.max(Math.min(0, offset + Math.round(this.finalW - this._data.itemSize.w) / 2 - this._leftPadding), maxOffset);
      }
      return Math.max(Math.min(0, offset), maxOffset);
    }
  }, {
    key: "_animateTo",
    value: function _animateTo(index) {
      this._offset = this._offsetByIndex(index);
      this.tag('Container').setSmooth('x', this._offset);
    }
  }, {
    key: "_moveTo",
    value: function _moveTo(index) {
      this._offset = this._offsetByIndex(index);
      this.tag('Container').x = this._offset;
    }
  }, {
    key: "_handleLeft",
    value: function _handleLeft() {
      if (this._focusedItemIndex > 0) {
        this._setIndex(this._focusedItemIndex - 1, true);
        return true;
      }
      return false;
    }
  }, {
    key: "_handleRight",
    value: function _handleRight() {
      if (this._focusedItemIndex < this._totalItems - 1) {
        this._setIndex(this._focusedItemIndex + 1, true);
        return true;
      }
      return false;
    }
  }, {
    key: "_getFromBufferOrCreate",
    value: function _getFromBufferOrCreate() {
      var _signals;
      var _this$_data3 = this._data,
        itemType = _this$_data3.itemType,
        itemSize = _this$_data3.itemSize,
        itemTemplate = _this$_data3.itemTemplate;
      var existingView = getFromBuffer(itemTemplate);
      if (existingView) {
        return existingView;
      }
      return this.stage.c({
        type: itemType,
        w: itemSize.w,
        h: itemSize.h,
        template: itemTemplate,
        passSignals: (0,defineProperty/* default */.Z)({}, SELECTED_SIGNAL, true),
        signals: (_signals = {}, (0,defineProperty/* default */.Z)(_signals, INACTIVE_SIGNAL, '_onViewBecomeInactive'), (0,defineProperty/* default */.Z)(_signals, DETACHED_SIGNAL, '_onViewBecomeDetached'), _signals)
      });
    }
  }, {
    key: "_onViewBecomeInactive",
    value: function _onViewBecomeInactive(view) {
      if (this._isRowAttached) {
        this._backToBuffer(view);
      }
    }
  }, {
    key: "_onViewBecomeDetached",
    value: function _onViewBecomeDetached(view) {
      cleanupBuffer(view);
    }
  }, {
    key: "_backToBuffer",
    value: function _backToBuffer(view) {
      var _this3 = this;
      Object.keys(this._views).filter(function (key) {
        return _this3._views[key].id === view.id;
      }).forEach(function (key) {
        delete _this3._views[key];
      });
      backToBuffer(view);
      view.visible = false;
    }
  }, {
    key: "_getItemX",
    value: function _getItemX(index) {
      return this._startPoint + (this._data.itemSize.w + this._contentGap) * index;
    }
  }, {
    key: "_placeItems",
    value: function _placeItems() {
      if (!this._data) {
        return;
      }
      var container = this.tag('Container');
      var viewportWidth = this.finalW;
      var itemWidthWithGap = this._data.itemSize.w + this._contentGap;
      var maximalOffset = this._focusedItemIndex * itemWidthWithGap;
      var left = maximalOffset + this._offset + this._leftPadding;
      var right = viewportWidth - left;
      var itemsLeft = Math.ceil(left / itemWidthWithGap);
      var itemsRight = Math.ceil(right / itemWidthWithGap);
      var toRender = [];
      var startIndex = Math.max(this._focusedItemIndex - itemsLeft, 0);
      var endIndex = Math.min(this._focusedItemIndex + itemsRight, this._totalItems - 1);
      for (var i = startIndex; i <= endIndex; i += 1) {
        toRender.push(i);
      }
      for (var _i = 0; _i < toRender.length; _i += 1) {
        var index = toRender[_i];
        var view = this._views[index];
        if (!view) {
          view = this._getFromBufferOrCreate();
        }
        view.index = index;
        if (this._items[index]) {
          view.item = this._items[index];
        } else {
          view.item = this._makeItemData(PLACEHOLDER, index);
        }
        view.x = this._getItemX(index);
        view.visible = true;
        if (view.parent !== container) {
          container.childList.add(view);
        }
        this._views[index] = view;
      }
    }
  }, {
    key: "_resetVirtualization",
    value: function _resetVirtualization() {
      this._itemBlueprint = {};
      this._data = undefined;
      this._isDataApplied = false;
      this._focusedItemIndex = 0;
      this._offset = 0;
      this._itemsPerPage = 0;
      this._startPoint = 0;
      this._items = [];
      this._views = {};
      this._pages = {};
      this._focusMode = FOCUS_MODE_CENTER;
      this._startPointMode = START_POINT_MODE_LEFT;
    }
  }], [{
    key: "_template",
    value: function _template() {
      var _passSignals2;
      return {
        Container: {},
        passSignals: (_passSignals2 = {}, (0,defineProperty/* default */.Z)(_passSignals2, SELECTED_SIGNAL, true), (0,defineProperty/* default */.Z)(_passSignals2, SHOW_GRID_SIGNAL, true), (0,defineProperty/* default */.Z)(_passSignals2, PORTION_REQUESTED_SIGNAL, true), _passSignals2)
      };
    }
  }]);
  return Row;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/utils/block.js
var getTitle = function getTitle(title) {
  if (!title) {
    return '';
  }
  if (typeof title.long === 'string') {
    return title.long;
  }
  return title.short || '';
};
;// CONCATENATED MODULE: ./src/modules/tornado/block/customer/rtlde/block.constants.js

var _TOP, _BOTTOM, _LEFT, _RIGHT, _TOP2, _BOTTOM2, _FIRST_BLOCK_PADDING, block_constants_CONTENT_GAP;

var block_constants_PADDING = {
  TOP: (_TOP = {}, (0,defineProperty/* default */.Z)(_TOP, HD, 32), (0,defineProperty/* default */.Z)(_TOP, FULL_HD, 32), _TOP),
  BOTTOM: (_BOTTOM = {}, (0,defineProperty/* default */.Z)(_BOTTOM, HD, 16), (0,defineProperty/* default */.Z)(_BOTTOM, FULL_HD, 32), _BOTTOM),
  LEFT: (_LEFT = {}, (0,defineProperty/* default */.Z)(_LEFT, HD, 40), (0,defineProperty/* default */.Z)(_LEFT, FULL_HD, 40), _LEFT),
  RIGHT: (_RIGHT = {}, (0,defineProperty/* default */.Z)(_RIGHT, HD, safetyMargins.horizontal.HD), (0,defineProperty/* default */.Z)(_RIGHT, FULL_HD, safetyMargins.horizontal.FULL_HD), _RIGHT)
};
var TITLE_PADDING = {
  TOP: (_TOP2 = {}, (0,defineProperty/* default */.Z)(_TOP2, HD, 16), (0,defineProperty/* default */.Z)(_TOP2, FULL_HD, 32), _TOP2),
  BOTTOM: (_BOTTOM2 = {}, (0,defineProperty/* default */.Z)(_BOTTOM2, HD, 12), (0,defineProperty/* default */.Z)(_BOTTOM2, FULL_HD, 24), _BOTTOM2)
};
var FIRST_BLOCK_PADDING = (_FIRST_BLOCK_PADDING = {}, (0,defineProperty/* default */.Z)(_FIRST_BLOCK_PADDING, HD, 80), (0,defineProperty/* default */.Z)(_FIRST_BLOCK_PADDING, FULL_HD, 80), _FIRST_BLOCK_PADDING);
var rtlde_block_constants_CONTENT_GAP = (block_constants_CONTENT_GAP = {}, (0,defineProperty/* default */.Z)(block_constants_CONTENT_GAP, HD, 12), (0,defineProperty/* default */.Z)(block_constants_CONTENT_GAP, FULL_HD, 12), block_constants_CONTENT_GAP);
;// CONCATENATED MODULE: ./src/modules/tornado/block/block.constants.js

;// CONCATENATED MODULE: ./src/modules/tornado/block/block.style.js

function block_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function block_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? block_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : block_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }







var block_style_defaultContext = makeDefaultStylingContext();
var EMPTY_BLOCK_STYLE = {
  title: {},
  items: {}
};
var BACKGROUND_INITIAL_ALPHA = 0.001;
var BACKGROUND_LOADED_ALPHA = 1;
var block_style_colors = {
  title: makeThemeColor(PRIMARY)
};
var getTitleStyle = memoize_default()(function (_ref) {
  var screenSize = _ref.screenSize,
    colorMode = _ref.colorMode;
  return {
    y: TITLE_PADDING.TOP[screenSize],
    color: block_style_colors.title[colorMode],
    text: block_style_objectSpread(block_style_objectSpread({}, src_getFont(constants_FONT.KINSHASA_3, screenSize)), {}, {
      verticalAlign: 'middle'
    })
  };
}, cacheResolver);
var getBlockStyle = memoize_default()(function (context) {
  var hasTitle = context.hasTitle,
    isFirstBlock = context.isFirstBlock,
    screenSize = context.screenSize;
  var padding = {
    top: block_constants_PADDING.TOP[screenSize],
    bottom: block_constants_PADDING.BOTTOM[screenSize],
    left: block_constants_PADDING.LEFT[screenSize]
  };
  var firstBlockPadding = FIRST_BLOCK_PADDING[screenSize];
  var titleStyle = getTitleStyle(context);
  var items = {
    y: padding.top
  };
  var title = {
    y: titleStyle.y
  };
  if (hasTitle) {
    items.y = titleStyle.text.lineHeight + TITLE_PADDING.BOTTOM[screenSize];
    if (isFirstBlock) {
      items.y += firstBlockPadding;
      title.y = firstBlockPadding;
    } else {
      items.y += titleStyle.y;
    }
  } else if (isFirstBlock) {
    items.y = firstBlockPadding;
  }
  return {
    title: title,
    items: items,
    padding: padding
  };
}, cacheResolver);
var getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : block_style_defaultContext;
  return {
    Background: {
      w: identity,
      h: identity
    },
    Row: {
      rightPadding: block_constants_PADDING.RIGHT[context.screenSize]
    },
    Title: getTitleStyle(context)
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/block/block.component.js








function block_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function block_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? block_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : block_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function block_component_createSuper(t) { var r = block_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function block_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (block_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }









var Block = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Block, _Lightning$Component);
  var _super = block_component_createSuper(Block);
  function Block() {
    (0,classCallCheck/* default */.Z)(this, Block);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Block, [{
    key: "_construct",
    value: function _construct() {
      this._contentPadding = 0;
      this._style = block_component_objectSpread({}, block_style_defaultContext);
    }
  }, {
    key: "_build",
    value: function _build() {
      this.patch(getInitialStyle(this._style));
    }
  }, {
    key: "_attach",
    value: function _attach() {
      var background = this.tag('Background');
      background.alpha = BACKGROUND_INITIAL_ALPHA;
      background.on('txLoaded', function () {
        background.setSmooth('alpha', BACKGROUND_LOADED_ALPHA);
      });
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this._data = undefined;
      this.tag('Background').removeAllListeners('txLoaded');
    }
  }, {
    key: "data",
    get: function get() {
      return this._data;
    },
    set: function set(value) {
      this._data = value;
      var _this$_data = this._data,
        block = _this$_data.block,
        blockIndex = _this$_data.blockIndex,
        theme = _this$_data.theme,
        rowSize = _this$_data.rowSize;
      var _getLayoutTheme = getLayoutTheme(block.theme, theme),
        colorScheme = _getLayoutTheme.colorScheme,
        backgroundColor = _getLayoutTheme.backgroundColor,
        backgroundImage = _getLayoutTheme.backgroundImage;
      var backgroundImageURL = backgroundImage ? imageService.getUrl(backgroundImage, rowSize.w, rowSize.h, {
        fit: IMAGE_FIT_SCALE_CROP,
        quality: IMAGE_QUALITY,
        format: DEFAULT_IMAGE_FORMAT
      }) : null;
      var titleText = getTitle(block.title);
      var hasTitle = Boolean(titleText);
      var blockStyle = Number.isFinite(blockIndex) ? getBlockStyle({
        hasTitle: hasTitle,
        isFirstBlock: blockIndex === 0,
        screenSize: this._style.screenSize
      }) : EMPTY_BLOCK_STYLE;
      this._style.colorMode = colorScheme;
      this.patch(block_component_objectSpread(block_component_objectSpread({}, rowSize), {}, {
        color: backgroundColor,
        Background: {
          src: backgroundImageURL
        },
        Title: block_component_objectSpread({
          visible: hasTitle,
          color: block_style_colors.title[colorScheme],
          text: {
            text: titleText
          }
        }, blockStyle.title),
        Row: block_component_objectSpread({}, blockStyle.items)
      }));
      this.tag('Row').data = value;
    }
  }, {
    key: "contentPadding",
    get: function get() {
      return this._contentPadding;
    },
    set: function set(value) {
      if (Number.isFinite(value) && this._contentPadding !== value) {
        this.tag('Title').x = value;
        this.tag('Row').patch({
          x: value,
          leftPadding: value
        });
        this._contentPadding = value;
      }
    }
  }, {
    key: "contentGap",
    get: function get() {
      return this.tag('Row').contentGap;
    },
    set: function set(value) {
      this.tag('Row').contentGap = value;
    }
  }, {
    key: "startPointMode",
    get: function get() {
      return this.tag('Row').startPointMode;
    },
    set: function set(value) {
      this.tag('Row').startPointMode = value;
    }
  }, {
    key: "focusMode",
    set: function set(value) {
      this.tag('Row').focusMode = value;
    }
  }, {
    key: "focusedIndex",
    get: function get() {
      return this.tag('Row').focusedIndex;
    },
    set: function set(value) {
      this.tag('Row').focusedIndex = value;
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this.tag('Row');
    }
  }], [{
    key: "_template",
    value: function _template() {
      var _passSignals;
      return merge_default()({
        rect: true,
        Background: {},
        Title: {},
        Row: {
          type: Row
        },
        passSignals: (_passSignals = {}, (0,defineProperty/* default */.Z)(_passSignals, SELECTED_SIGNAL, true), (0,defineProperty/* default */.Z)(_passSignals, SHOW_GRID_SIGNAL, true), (0,defineProperty/* default */.Z)(_passSignals, PORTION_REQUESTED_SIGNAL, true), _passSignals)
      }, getInitialStyle());
    }
  }, {
    key: "getOffsetsByBlockData",
    value: function getOffsetsByBlockData(_ref) {
      var title = _ref.data.title,
        screenSize = _ref.screenSize,
        blockIndex = _ref.blockIndex;
      var hasTitle = Boolean(getTitle(title));
      var _getBlockStyle = getBlockStyle({
          hasTitle: hasTitle,
          isFirstBlock: blockIndex === 0,
          screenSize: screenSize
        }),
        items = _getBlockStyle.items,
        bottom = _getBlockStyle.padding.bottom;
      return {
        top: Number.isFinite(blockIndex) ? items.y : 0,
        bottom: bottom
      };
    }
  }]);
  return Block;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/list/list.constants.js
var templates = {
  List: 'List'
};
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/list/list.component.js






function list_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function list_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? list_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : list_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function list_component_createSuper(t) { var r = list_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function list_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (list_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }



var List = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(List, _Lightning$Component);
  var _super = list_component_createSuper(List);
  function List() {
    (0,classCallCheck/* default */.Z)(this, List);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(List, [{
    key: "_detach",
    value: function _detach() {
      this._data = undefined;
    }
  }, {
    key: "data",
    get: function get() {
      return this._data;
    },
    set: function set(value) {
      this._data = value;
      this.patch(list_component_objectSpread(list_component_objectSpread({}, value.rowSize), {}, {
        Block: {
          data: value
        }
      }));
    }
  }, {
    key: "contentPadding",
    get: function get() {
      return this.tag('Block').contentPadding;
    },
    set: function set(value) {
      this.tag('Block').contentPadding = value;
    }
  }, {
    key: "focusMode",
    get: function get() {
      return this.tag('Block').focusMode;
    },
    set: function set(value) {
      this.tag('Block').focusMode = value;
    }
  }, {
    key: "contentGap",
    get: function get() {
      return this.tag('Block').contentGap;
    },
    set: function set(value) {
      this.tag('Block').contentGap = value;
    }
  }, {
    key: "focusedIndex",
    get: function get() {
      return this.tag('Block').focusedIndex;
    },
    set: function set(value) {
      this.tag('Block').focusedIndex = value;
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this.tag('Block');
    }
  }], [{
    key: "_template",
    value: function _template() {
      return {
        Block: {
          type: Block
        }
      };
    }
  }, {
    key: "getOffsetsByBlockData",
    value: function getOffsetsByBlockData(data) {
      return Block.getOffsetsByBlockData(data);
    }
  }]);
  return List;
}(src_Lightning.Component);
List.Templates = templates;
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/belly/belly.constants.js
var belly_constants_templates = {
  Belly: 'Belly'
};
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/belly/belly.component.js





function belly_component_createSuper(t) { var r = belly_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function belly_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (belly_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }




var Belly = function (_List) {
  (0,inherits/* default */.Z)(Belly, _List);
  var _super = belly_component_createSuper(Belly);
  function Belly() {
    (0,classCallCheck/* default */.Z)(this, Belly);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Belly, null, [{
    key: "_template",
    value: function _template() {
      return {
        Block: {
          type: Block,
          startPointMode: START_POINT_MODE_CENTER
        }
      };
    }
  }]);
  return Belly;
}(List);

Belly.Templates = belly_constants_templates;
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/solo/solo.constants.js
var solo_constants_templates = {
  Solo: 'Solo'
};
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/solo/solo.component.js










function solo_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function solo_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? solo_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : solo_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function solo_component_createSuper(t) { var r = solo_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function solo_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (solo_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }



var Solo = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Solo, _Lightning$Component);
  var _super = solo_component_createSuper(Solo);
  function Solo() {
    (0,classCallCheck/* default */.Z)(this, Solo);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Solo, [{
    key: "_init",
    value: function _init() {
      this._contentPadding = 0;
      this._itemType = '';
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this._data = undefined;
    }
  }, {
    key: "data",
    get: function get() {
      return this._data;
    },
    set: function set(value) {
      this._data = value;
      var _this$_data = this._data,
        block = _this$_data.block,
        blockIndex = _this$_data.blockIndex,
        itemSize = _this$_data.itemSize,
        itemType = _this$_data.itemType;
      var allItems = block.content.items;
      var items = allItems.slice(0, 1).map(function (item, itemIndex) {
        return {
          content: item,
          blockIndex: blockIndex,
          itemIndex: itemIndex,
          config: solo_component_objectSpread({}, itemSize)
        };
      });
      if (this.children.length === items.length) {
        for (var i = 0; i < items.length; i += 1) {
          this.children[i].item = items[i];
        }
        return;
      }
      this.patch(solo_component_objectSpread(solo_component_objectSpread({}, itemSize), {}, {
        children: items.map(function (item) {
          var _passSignals;
          return solo_component_objectSpread(solo_component_objectSpread({}, itemSize), {}, {
            type: itemType,
            item: item,
            passSignals: (_passSignals = {}, (0,defineProperty/* default */.Z)(_passSignals, SELECTED_SIGNAL, true), (0,defineProperty/* default */.Z)(_passSignals, HIDE_BACKGROUND_SIGNAL, true), (0,defineProperty/* default */.Z)(_passSignals, SHOW_BACKGROUND_SIGNAL, true), _passSignals)
          });
        })
      }));
    }
  }, {
    key: "contentPadding",
    get: function get() {
      return this._contentPadding;
    },
    set: function set(value) {
      this._contentPadding = Number.isFinite(value) ? value : 0;
      if (this.children[0]) {
        this.children[0].contentPadding = this._contentPadding;
      }
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this.children[0];
    }
  }], [{
    key: "getOffsetsByBlockData",
    value: function getOffsetsByBlockData(layoutData) {
      var _ref = layoutData || {},
        itemType = _ref.itemType;
      var bottom = itemType && typeof itemType.getBottomMargin === 'function' ? itemType.getBottomMargin(layoutData) : 0;
      return {
        top: 0,
        bottom: Number.isFinite(bottom) ? bottom : 0
      };
    }
  }]);
  return Solo;
}(src_Lightning.Component);

Solo.Templates = solo_component_objectSpread({}, solo_constants_templates);
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/slideShow/slideShow.constants.js
var slideShow_constants_templates = {
  SlideShow: 'SlideShow'
};
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/slideShow/slideShow.style.js
var padding = {
  top: 0,
  bottom: 48
};
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/slideShow/slideShow.component.js









function slideShow_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function slideShow_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? slideShow_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : slideShow_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function slideShow_component_createSuper(t) { var r = slideShow_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function slideShow_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (slideShow_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }




var SlideShow = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(SlideShow, _Lightning$Component);
  var _super = slideShow_component_createSuper(SlideShow);
  function SlideShow() {
    (0,classCallCheck/* default */.Z)(this, SlideShow);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(SlideShow, [{
    key: "_init",
    value: function _init() {
      this._contentPadding = 0;
    }
  }, {
    key: "data",
    get: function get() {
      return this._data;
    },
    set: function set(value) {
      var _passSignals;
      this._data = value;
      var _this$_data = this._data,
        itemSize = _this$_data.itemSize,
        itemType = _this$_data.itemType;
      var _this$children = (0,slicedToArray/* default */.Z)(this.children, 1),
        currentView = _this$children[0];
      if (currentView) {
        currentView.data = value;
        return;
      }
      this.patch(slideShow_component_objectSpread(slideShow_component_objectSpread({}, itemSize), {}, {
        children: [slideShow_component_objectSpread(slideShow_component_objectSpread({}, itemSize), {}, {
          type: itemType,
          focusMode: this._focusMode,
          data: value,
          passSignals: (_passSignals = {}, (0,defineProperty/* default */.Z)(_passSignals, SELECTED_SIGNAL, true), (0,defineProperty/* default */.Z)(_passSignals, PORTION_REQUESTED_SIGNAL, true), _passSignals)
        })]
      }));
    }
  }, {
    key: "contentPadding",
    get: function get() {
      return this._contentPadding;
    },
    set: function set(value) {
      this._contentPadding = Number.isFinite(value) ? value : 0;
      if (this.children[0]) {
        this.children[0].contentPadding = this._contentPadding;
      }
    }
  }, {
    key: "focusMode",
    get: function get() {
      if (!this.children[0]) {
        return null;
      }
      return this.children[0].focusMode;
    },
    set: function set(value) {
      if (value !== this._focusMode) {
        if (this.children[0]) {
          this.children[0].focusMode = value;
        }
        this._focusMode = value;
      }
    }
  }, {
    key: "focusedIndex",
    get: function get() {
      if (!this.children[0]) {
        return 0;
      }
      return this.children[0].focusedIndex;
    },
    set: function set(value) {
      if (this.children[0]) {
        this.children[0].focusedIndex = value;
      }
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this.children[0];
    }
  }], [{
    key: "getOffsetsByBlockData",
    value: function getOffsetsByBlockData() {
      return padding;
    }
  }]);
  return SlideShow;
}(src_Lightning.Component);

SlideShow.Templates = slideShow_component_objectSpread({}, slideShow_constants_templates);
;// CONCATENATED MODULE: ./src/modules/tornado/icon/icon.utils.js
var getScaledTextureSize = function getScaledTextureSize(texture) {
  var scale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  if (scale !== 1 && texture._source) {
    var _texture$_source = texture._source,
      w = _texture$_source.w,
      h = _texture$_source.h;
    return {
      w: Math.round(w / scale),
      h: Math.round(h / scale)
    };
  }
  return null;
};
;// CONCATENATED MODULE: ./src/modules/tornado/utils/colors.js
var colors_WHITE = 0xffffffff;
var colors_TRANSPARENT = 0x00000000;
;// CONCATENATED MODULE: ./src/modules/tornado/icon/icon.component.js










function icon_component_createSuper(t) { var r = icon_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function icon_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (icon_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }





var Icon = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Icon, _Lightning$Component);
  var _super = icon_component_createSuper(Icon);
  function Icon() {
    (0,classCallCheck/* default */.Z)(this, Icon);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Icon, [{
    key: "_construct",
    value: function _construct() {
      this._textureScale = 1;
      this._textureLoadedHandler = this._onTextureLoaded.bind(this);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this.removeAllListeners('txLoaded');
      this._name = undefined;
    }
  }, {
    key: "name",
    get: function get() {
      return this._name;
    }
  }, {
    key: "color",
    get: function get() {
      return (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(Icon.prototype), "color", this);
    },
    set: function set(value) {
      _set((0,getPrototypeOf/* default */.Z)(Icon.prototype), "color", COLOR_LOCKED.includes(this._name) ? colors_WHITE : value, this, true);
    }
  }, {
    key: "iconData",
    set: function set(value) {
      this._textureScale = value.scale || 1;
      if (value.picto && value.picto.name) {
        this._name = value.picto.name;
      }
      this.iconTexture = typeof value.picto === 'string' ? getTextureByUrl(value.picto, value.viewBox, this._textureScale) : getTextureByIconData(value);
    }
  }, {
    key: "iconTexture",
    set: function set(value) {
      this.texture = null;
      this.removeListener('txLoaded', this._textureLoadedHandler);
      if (this._textureScale !== 1) {
        this.on('txLoaded', this._textureLoadedHandler);
      }
      this.texture = value;
    }
  }, {
    key: "_onTextureLoaded",
    value: function _onTextureLoaded(texture) {
      var sizes = getScaledTextureSize(texture, this._textureScale);
      if (sizes) {
        this.patch(sizes);
      }
    }
  }]);
  return Icon;
}(src_Lightning.Component);

;// CONCATENATED MODULE: ./src/modules/tornado/button/customer/rtlde/button.constants.js

var _BORDER_RADIUS, _STROKE_UNFOCUSED, _STROKE_FOCUSED;


var BORDER_RADIUS = (_BORDER_RADIUS = {}, (0,defineProperty/* default */.Z)(_BORDER_RADIUS, HD, 8), (0,defineProperty/* default */.Z)(_BORDER_RADIUS, FULL_HD, 8), _BORDER_RADIUS);
var STROKE_UNFOCUSED = (_STROKE_UNFOCUSED = {}, (0,defineProperty/* default */.Z)(_STROKE_UNFOCUSED, HD, 2), (0,defineProperty/* default */.Z)(_STROKE_UNFOCUSED, FULL_HD, 3), _STROKE_UNFOCUSED);
var STROKE_FOCUSED = (_STROKE_FOCUSED = {}, (0,defineProperty/* default */.Z)(_STROKE_FOCUSED, HD, 2), (0,defineProperty/* default */.Z)(_STROKE_FOCUSED, FULL_HD, 3), _STROKE_FOCUSED);
var STROKE_UNFOCUSED_COLOR = makeThemeColor(PRIMARY, 1.0);
var STROKE_FOCUSED_COLOR = makeThemeColor(PRIMARY, 1.0);
var FILL_UNFOCUSED_COLOR = makeThemeColor(TERTIARY);
var FILL_FOCUSED_COLOR = makeThemeColor(PRIMARY);
var TEXT_UNFOCUSED_COLOR = makeThemeColor(PRIMARY);
var TEXT_FOCUSED_COLOR = makeThemeColor(TERTIARY);
var SCALE_FOCUSED = 1.05;
;// CONCATENATED MODULE: ./src/modules/tornado/button/button.utils.js
var getStrokeWidth = function getStrokeWidth(stroke) {
  return stroke >= 1.5 ? stroke : 1.5;
};
;// CONCATENATED MODULE: ./src/modules/tornado/callToAction/background/buttonTexture.utils.js


var makeButtonTexture = function makeButtonTexture(w, h) {
  var borderRadius = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var borderWidth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var borderColor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var fillColor = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : colors_WHITE;
  return src_Lightning.Tools.getRoundRect(w, h, borderRadius, borderWidth, borderColor, true, fillColor);
};
;// CONCATENATED MODULE: ./src/modules/tornado/callToAction/background/buttonTexture.component.js





function buttonTexture_component_createSuper(t) { var r = buttonTexture_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function buttonTexture_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (buttonTexture_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }


var ButtonTexture = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(ButtonTexture, _Lightning$Component);
  var _super = buttonTexture_component_createSuper(ButtonTexture);
  function ButtonTexture() {
    (0,classCallCheck/* default */.Z)(this, ButtonTexture);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(ButtonTexture, [{
    key: "_construct",
    value: function _construct() {
      this._generatedTextureWidth = 0;
      this._generatedTextureHeight = 0;
      this._fillColor = 0;
      this._borderColor = 0;
      this._borderWidth = 0;
      this._borderRadius = 0;
      this._fillColor = 0;
      this._shouldUpdateTexture = false;
    }
  }, {
    key: "_attach",
    value: function _attach() {
      var _this = this;
      this._shouldUpdateTexture = true;
      this.onUpdate = function (_ref) {
        var finalW = _ref.finalW,
          finalH = _ref.finalH;
        if (finalW !== _this._generatedTextureWidth || finalH !== _this._generatedTextureHeight) {
          _this._generatedTextureWidth = finalW;
          _this._generatedTextureHeight = finalH;
          _this._updateButtonTexture();
        }
      };
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this._shouldUpdateTexture = false;
      this.onUpdate = undefined;
    }
  }, {
    key: "borderColor",
    get: function get() {
      return this._borderColor;
    },
    set: function set(value) {
      this._borderColor = value;
      this._updateButtonTexture();
    }
  }, {
    key: "borderWidth",
    get: function get() {
      return this._borderWidth;
    },
    set: function set(value) {
      this._borderWidth = value;
    }
  }, {
    key: "borderRadius",
    get: function get() {
      return this._borderRadius;
    },
    set: function set(value) {
      this._borderRadius = value;
    }
  }, {
    key: "color",
    get: function get() {
      return this._fillColor;
    },
    set: function set(value) {
      this._fillColor = value;
      this._updateButtonTexture();
    }
  }, {
    key: "_updateButtonTexture",
    value: function _updateButtonTexture() {
      if (!this._shouldUpdateTexture || !this._generatedTextureWidth || !this._generatedTextureHeight) {
        return;
      }
      this.texture = makeButtonTexture(this._generatedTextureWidth, this._generatedTextureHeight, this._borderRadius, this._borderWidth, this._borderColor, this._fillColor);
    }
  }]);
  return ButtonTexture;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/tornado/button/customer/rtlde/button.style.js

var _HEIGHT, _PADDING, _ICON_WIDTH, _ICON_HEIGHT, _ICON_PADDING_LEFT;
function button_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function button_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? button_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : button_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }







var button_style_defaultContext = makeDefaultStylingContext();
var HEIGHT = (_HEIGHT = {}, (0,defineProperty/* default */.Z)(_HEIGHT, HD, 40), (0,defineProperty/* default */.Z)(_HEIGHT, FULL_HD, 56), _HEIGHT);
var button_style_PADDING = (_PADDING = {}, (0,defineProperty/* default */.Z)(_PADDING, HD, 16), (0,defineProperty/* default */.Z)(_PADDING, FULL_HD, 24), _PADDING);
var ICON_WIDTH = (_ICON_WIDTH = {}, (0,defineProperty/* default */.Z)(_ICON_WIDTH, HD, 24), (0,defineProperty/* default */.Z)(_ICON_WIDTH, FULL_HD, 32), _ICON_WIDTH);
var ICON_HEIGHT = (_ICON_HEIGHT = {}, (0,defineProperty/* default */.Z)(_ICON_HEIGHT, HD, 24), (0,defineProperty/* default */.Z)(_ICON_HEIGHT, FULL_HD, 32), _ICON_HEIGHT);
var ICON_PADDING_LEFT = (_ICON_PADDING_LEFT = {}, (0,defineProperty/* default */.Z)(_ICON_PADDING_LEFT, HD, 4), (0,defineProperty/* default */.Z)(_ICON_PADDING_LEFT, FULL_HD, 8), _ICON_PADDING_LEFT);
var getUnFocusedStyle = function getUnFocusedStyle(_ref) {
  var screenSize = _ref.screenSize,
    colorMode = _ref.colorMode;
  return {
    Background: {
      color: FILL_UNFOCUSED_COLOR[colorMode],
      borderColor: STROKE_UNFOCUSED_COLOR[colorMode],
      borderWidth: getStrokeWidth(STROKE_UNFOCUSED[screenSize]),
      type: ButtonTexture,
      smooth: {
        scale: 1.0
      }
    },
    Icon: {
      color: TEXT_UNFOCUSED_COLOR[colorMode]
    },
    Label: {
      color: TEXT_UNFOCUSED_COLOR[colorMode]
    }
  };
};
var getFocusedStyle = function getFocusedStyle(_ref2) {
  var screenSize = _ref2.screenSize,
    colorMode = _ref2.colorMode;
  return {
    Background: {
      color: FILL_FOCUSED_COLOR[colorMode],
      borderColor: STROKE_FOCUSED_COLOR[colorMode],
      borderWidth: getStrokeWidth(STROKE_FOCUSED[screenSize]),
      smooth: {
        scale: SCALE_FOCUSED
      }
    },
    Icon: {
      color: TEXT_FOCUSED_COLOR[colorMode]
    },
    Label: {
      color: TEXT_FOCUSED_COLOR[colorMode]
    }
  };
};
var button_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : button_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  var h = HEIGHT[screenSize];
  var font = src_getFont(constants_FONT.OTTAWA_2, screenSize);
  return merge_default()({
    h: h,
    Background: {
      h: h,
      color: FILL_UNFOCUSED_COLOR[colorMode],
      borderRadius: BORDER_RADIUS[screenSize]
    },
    Icon: {
      y: Math.round((h - ICON_HEIGHT[screenSize]) / 2)
    },
    Label: {
      y: Math.round((h - font.lineHeight) / 2),
      text: button_style_objectSpread(button_style_objectSpread({}, font), {}, {
        verticalAlign: 'middle'
      })
    }
  }, getUnFocusedStyle(context));
};
;// CONCATENATED MODULE: ./src/modules/tornado/button/button.style.js

;// CONCATENATED MODULE: ./src/modules/tornado/shaders/customer/rtlde/focus.shader.js
































function focus_shader_createSuper(t) { var r = focus_shader_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function focus_shader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (focus_shader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }


var FocusShader = function (_Lightning$shaders$We) {
  (0,inherits/* default */.Z)(FocusShader, _Lightning$shaders$We);
  var _super = focus_shader_createSuper(FocusShader);
  function FocusShader(context) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, FocusShader);
    _this = _super.call(this, context);
    _this._radius = 0;
    _this._outline = 0;
    _this._scale = 1.0;
    _this._imageMaskFactor = 0.0;
    _this._strokeColorRaw = colors_TRANSPARENT;
    _this._innerColorRaw = colors_TRANSPARENT;
    _this._strokeColor = _this._getNormalizedColor(_this._strokeColorRaw);
    _this._innerColor = _this._getNormalizedColor(_this._innerColorRaw);
    return _this;
  }
  (0,createClass/* default */.Z)(FocusShader, [{
    key: "scale",
    get: function get() {
      return this._scale;
    },
    set: function set(v) {
      this._scale = Math.max(v, 0);
      this.redraw();
    }
  }, {
    key: "radius",
    get: function get() {
      return this._radius;
    },
    set: function set(v) {
      this._radius = v;
      this.redraw();
    }
  }, {
    key: "strokeColor",
    get: function get() {
      return this._strokeColorRaw;
    },
    set: function set(color) {
      this._strokeColorRaw = color;
      this._strokeColor = this._getNormalizedColor(color);
      this.redraw();
    }
  }, {
    key: "innerColor",
    get: function get() {
      return this._innerColorRaw;
    },
    set: function set(color) {
      this._innerColorRaw = color;
      this._innerColor = this._getNormalizedColor(color);
      this.redraw();
    }
  }, {
    key: "outline",
    get: function get() {
      return this._outline;
    },
    set: function set(v) {
      this._outline = v;
      this.redraw();
    }
  }, {
    key: "useImageMask",
    get: function get() {
      return Boolean(this._imageMaskFactor);
    },
    set: function set(v) {
      this._imageMaskFactor = v ? 1 : 0;
      this.redraw();
    }
  }, {
    key: "_getNormalizedColor",
    value: function _getNormalizedColor(color) {
      var useAlphaChannel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var col = src_Lightning.StageUtils.getRgbaComponentsNormalized(color);
      if (useAlphaChannel) {
        col[0] *= col[3];
        col[1] *= col[3];
        col[2] *= col[3];
      }
      return new Float32Array(col);
    }
  }, {
    key: "setupUniforms",
    value: function setupUniforms(operation) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(FocusShader.prototype), "setupUniforms", this).call(this, operation);
      var owner = operation.shaderOwner;
      var renderPrecision = this.ctx.stage.getRenderPrecision();
      this._setUniform('radius', this._radius, this.gl.uniform1f);
      this._setUniform('strokeColor', this._strokeColor, this.gl.uniform4fv);
      this._setUniform('innerColor', this._innerColor, this.gl.uniform4fv);
      this._setUniform('outline', this._outline * renderPrecision, this.gl.uniform1f);
      this._setUniform('imageMaskFactor', this._imageMaskFactor, this.gl.uniform1f);
      this._setUniform('scale', this._scale, this.gl.uniform1f);
      this._setUniform('resolution', new Float32Array([owner._w * renderPrecision, owner._h * renderPrecision]), this.gl.uniform2fv);
    }
  }]);
  return FocusShader;
}(src_Lightning.shaders.WebGLDefaultShader);

FocusShader.vertexShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    attribute vec2 aVertexPosition;\n    attribute vec2 aTextureCoord;\n\n    uniform vec2 projection;\n    varying vec2 vTextureCoord;\n\n    void main(void){\n        gl_Position = vec4(aVertexPosition.x * projection.x - 1.0, aVertexPosition.y * -abs(projection.y) + 1.0, 0.0, 1.0);\n        vTextureCoord = aTextureCoord;\n        gl_Position.y = -sign(projection.y) * gl_Position.y;\n    }\n";
FocusShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n\n    varying vec2 vTextureCoord;\n\n    uniform vec2 resolution;\n    uniform float radius;\n    uniform float outline;\n    uniform float scale;\n    uniform float imageMaskFactor;\n    uniform vec4 progressColor;\n    uniform vec4 strokeColor;\n    uniform vec4 innerColor;\n\n    float boxDist(vec2 p, vec2 size, float radius) {\n      size -= vec2(radius);\n      vec2 d = abs(p) - size;\n\n      return min(max(d.x, d.y), 0.0) + length(max(d, 0.0)) - radius;\n    }\n\n    float fillMask(float dist) {\n        return clamp(-dist, 0.0, 1.0);\n    }\n\n    vec2 texCoordsWithOffset(float offset) {\n        vec2 texCoordsMultiplier = (1.0 + (offset * 2.0) / resolution);\n        vec2 texCoordsOffset = offset / resolution;\n\n        return vTextureCoord * texCoordsMultiplier - texCoordsOffset;\n    }\n\n    void main() {\n      vec2 halfRes = resolution * 0.5;\n      vec2 halfResOffset = halfRes + 0.5;\n      vec2 texCoords = texCoordsWithOffset(outline / scale);\n\n      float imageMask = 0.0;\n      if (imageMaskFactor > 0.0) {\n        float imageDistance = boxDist(texCoords * resolution - halfRes, halfResOffset, radius / scale);\n        imageMask = fillMask(imageDistance) * imageMaskFactor;\n      }\n\n      float outerRadius = (radius + outline * 0.375) / scale;\n      float borderInnerDistance = boxDist(texCoordsWithOffset((outline * 0.5) / scale) * resolution - halfRes, halfResOffset, outerRadius);\n      float borderOuterDistance = boxDist(vTextureCoord * resolution - halfRes, halfRes, outerRadius + outline * 0.125);\n      vec4 border = mix(strokeColor, innerColor, fillMask(borderInnerDistance));\n      border = mix(vec4(0.0), border, fillMask(borderOuterDistance) - imageMask);\n\n      gl_FragColor = border;\n    }\n";
;// CONCATENATED MODULE: ./src/modules/tornado/shaders/focus.shader.js

/* harmony default export */ const focus_shader = (FocusShader);
;// CONCATENATED MODULE: ./src/modules/tornado/callToAction/background/customer/rtlde/buttonBackground.component.js







function buttonBackground_component_createSuper(t) { var r = buttonBackground_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function buttonBackground_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (buttonBackground_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }


var ButtonBackground = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(ButtonBackground, _Lightning$Component);
  var _super = buttonBackground_component_createSuper(ButtonBackground);
  function ButtonBackground() {
    (0,classCallCheck/* default */.Z)(this, ButtonBackground);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(ButtonBackground, [{
    key: "scale",
    get: function get() {
      return (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(ButtonBackground.prototype), "scale", this);
    },
    set: function set(value) {
      _set((0,getPrototypeOf/* default */.Z)(ButtonBackground.prototype), "scale", value, this, true);
      this.shader.scale = value;
    }
  }, {
    key: "borderColor",
    get: function get() {
      return this.shader.strokeColor;
    },
    set: function set(value) {
      this.shader.strokeColor = value;
    }
  }, {
    key: "innerColor",
    get: function get() {
      return this.shader.innerColor;
    },
    set: function set(value) {
      this.shader.innerColor = value;
    }
  }, {
    key: "borderWidth",
    get: function get() {
      return this.shader.outline;
    },
    set: function set(value) {
      this.shader.outline = value;
    }
  }, {
    key: "borderRadius",
    get: function get() {
      return this.shader.radius;
    },
    set: function set(value) {
      this.shader.radius = value;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return {
        rect: true,
        shader: {
          type: focus_shader
        }
      };
    }
  }]);
  return ButtonBackground;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/tornado/callToAction/background/buttonBackground.component.js

;// CONCATENATED MODULE: ./src/modules/tornado/button/button.component.js






function button_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function button_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? button_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : button_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function button_component_createSuper(t) { var r = button_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function button_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (button_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }






var Button = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Button, _Lightning$Component);
  var _super = button_component_createSuper(Button);
  function Button() {
    (0,classCallCheck/* default */.Z)(this, Button);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Button, [{
    key: "_construct",
    value: function _construct() {
      this._style = button_style_defaultContext;
      this._isIconTxLoading = false;
      this._isLabelTxLoading = false;
      this._minWidth = 0;
    }
  }, {
    key: "_init",
    value: function _init() {
      var _this = this;
      var label = this.tag('Label');
      var icon = this.tag('Icon');
      var screenSize = sizes_getScreenSize();
      var iconWidth = ICON_WIDTH[screenSize];
      var iconPaddingLeft = ICON_PADDING_LEFT[screenSize];
      var padding = button_style_PADDING[screenSize];
      var handleUpdate = function handleUpdate() {
        if (_this._isIconTxLoading || _this._isLabelTxLoading) {
          return;
        }
        var size = padding * 2 + label.finalW;
        var offset = icon.finalW ? iconPaddingLeft + iconWidth : 0;
        var w = Math.max(size + offset, _this._minWidth);
        _this.patch({
          w: w,
          Icon: {
            x: padding
          },
          Label: {
            x: Math.max(padding + offset, Math.round((w - label.finalW) / 2))
          }
        });
      };
      icon.on('txLoaded', function () {
        _this._isIconTxLoading = false;
        handleUpdate();
      });
      label.on('txLoaded', function () {
        _this._isLabelTxLoading = false;
        handleUpdate();
      });
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this.tag('Label').removeAllListeners('txLoaded');
      this.tag('Icon').removeAllListeners('txLoaded');
    }
  }, {
    key: "label",
    set: function set(value) {
      this.tag('Label').text.text = value;
      this._isLabelTxLoading = true;
    }
  }, {
    key: "picto",
    set: function set(value) {
      this._isIconTxLoading = true;
      var screenSize = sizes_getScreenSize();
      this.tag('Icon').iconData = {
        picto: value,
        viewBox: {
          w: ICON_WIDTH[screenSize],
          h: ICON_HEIGHT[screenSize]
        }
      };
    }
  }, {
    key: "colorMode",
    get: function get() {
      return this._style.colorMode;
    },
    set: function set(value) {
      this._style = button_component_objectSpread(button_component_objectSpread({}, this._style), {}, {
        colorMode: value
      });
      this.patch(button_style_getInitialStyle(this._style));
    }
  }, {
    key: "minWidth",
    get: function get() {
      return this._minWidth;
    },
    set: function set(value) {
      this._minWidth = value;
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this.patch(getFocusedStyle(this._style));
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this.patch(getUnFocusedStyle(this._style));
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Background: {
          type: ButtonBackground,
          w: identity
        },
        Fill: {},
        Icon: {
          type: Icon
        },
        Label: {}
      }, button_style_getInitialStyle());
    }
  }]);
  return Button;
}(src_Lightning.Component);
// EXTERNAL MODULE: ./node_modules/.pnpm/sprintf-js@1.1.2/node_modules/sprintf-js/src/sprintf.js
var sprintf = __webpack_require__(24131);
;// CONCATENATED MODULE: ./src/modules/i18n/utils.js







function i18n_utils_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function i18n_utils_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? i18n_utils_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : i18n_utils_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


var pluralizeFunctions = {
  en: function en(number) {
    return number === 0 || number > 1 ? 'other' : 'one';
  },
  fr: function fr(number) {
    return number > 1 ? 'other' : 'one';
  },
  hu: function hu(number, general) {
    if (!general) {
      return 'one';
    }
    return number > 1 ? 'other' : 'one';
  },
  hr: function hr(number, general) {
    if (general) {
      return number > 1 ? 'other' : 'one';
    }
    var numberInString = number.toString();
    var lastDigit = numberInString.charAt(numberInString.length - 1);
    if (number > 4 && number < 21 || ['0', '5', '6', '7', '8', '9'].includes(lastDigit)) {
      return 'many';
    }
    if (lastDigit === '1') {
      return 'one';
    }
    if (lastDigit === '2' || lastDigit === '3' || lastDigit === '4') {
      return 'few';
    }
  }
};
var translate = function translate(lang) {
  var i18nNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var pluralize = pluralizeFunctions[get_default()(lang, '_i18n.lang')] || pluralizeFunctions.fr;
  return function (key) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var number = arguments.length > 2 ? arguments[2] : undefined;
    var general = arguments.length > 3 ? arguments[3] : undefined;
    var combineKey = key;
    if (typeof number !== 'undefined') {
      combineKey = "".concat(key, ".").concat(pluralize(number, general));
    }
    var translation = get_default()(lang, combineKey, combineKey);
    return (0,sprintf.sprintf)(translation, i18n_utils_objectSpread(i18n_utils_objectSpread(i18n_utils_objectSpread({}, data), i18nNames), {}, {
      number: number
    }));
  };
};
var buildList = function buildList(lang) {
  return function (list, maxSize) {
    var separator = _get(lang, '_i18n.separator');
    var lastSeparator = _get(lang, '_i18n.and');
    if (!list || !list.length) {
      return '';
    }
    if (list.length === 1) {
      return list[0];
    }
    var lastIndex = list.length - 1;
    var subList = list.slice(0, lastIndex).join(separator);
    var result = "".concat(subList).concat(lastSeparator).concat(list[lastIndex]);
    return result.length > maxSize ? "".concat(result.substring(0, maxSize), "...") : result;
  };
};
;// CONCATENATED MODULE: ./lang/customer/bedrock/en.json
const en_namespaceObject = JSON.parse('{"account_settings":{"qrcode":{"infos":"Scan the QR code with your smartphone camera to access the settings page or go to ","title":"account_settings.title"},"title":"Settings"},"bookmarks":{"actionLabel":"My list","added":"Bookmark added","noContentAction":"Explore the catalog","noContentDescription":"The content you will add to your list will appear here!","noContentTitle":"Your catalogue is a bit empty.","removed":"Bookmark removed","title":"My list"},"contentInfo":{"actionLabel":"Info"},"date":{"days":{"friday":{"abbreviation":"Fri","complete":"Friday"},"monday":{"abbreviation":"Mon","complete":"Monday"},"saturday":{"abbreviation":"Sat","complete":"Saturday"},"sunday":{"abbreviation":"Sun","complete":"Sunday"},"thursday":{"abbreviation":"Thu","complete":"Thursday"},"tuesday":{"abbreviation":"Tue","complete":"Tuesday"},"wednesday":{"abbreviation":"Wed","complete":"Wednesday"}},"months":{"april":{"abbreviation":"Apr","complete":"April"},"august":{"abbreviation":"Aug","complete":"August"},"december":{"abbreviation":"Dec","complete":"December"},"february":{"abbreviation":"Feb","complete":"February"},"january":{"abbreviation":"Jan","complete":"January"},"july":{"abbreviation":"Jul","complete":"July"},"june":{"abbreviation":"Jun","complete":"June"},"march":{"abbreviation":"Mar","complete":"March"},"may":{"abbreviation":"May","complete":"May"},"november":{"abbreviation":"Nov","complete":"November"},"october":{"abbreviation":"Oct","complete":"October"},"september":{"abbreviation":"Sep","complete":"September"}}},"epgGrid":{"afternoon":"Afternoon","currentWeek":"This week","evening":"Evening","lastWeek":"Last week","live":"Live","morning":"Morning","nextWeek":"Next week","noAction":"This content is not available on live, nor catch up","noProgram":"No program available","today":"Today"},"error":{"csl":"This video has been interrupted because you have exceeded the simultaneous viewing limit allowed by your account.","general":"Oups, something went wrong, please try later.","pairing":"An error occurred during pairing, please try later.","player":"An error occurred during video loading, please try later.","podcast":"Unable to play the podcast. Please try again.","retry":"Retry"},"faq":{"qrcode":{"infos":"Scan the QR code with your smartphone camera to access the FAQ or go to ","title":"Looking for help?"},"title":"FAQ"},"feedback":{"qrcode":{"infos":"Scan the QR code with your smartphone camera to access the feedback form or go to","title":"Share something with us!"},"title":"Send Feedback"},"gdprNotice":{"decline":"Decline all","description":"If you agree, cookies or others trackers are used on this platform by Bedrock and its partners for the purpose of making statistics of visits and to offer you advertisements, services and offers adapted to your centers of interest. For more information and to exercise your rights, please visit our cookies policy page. There you can manage your preferences regarding the use and deposit of cookies and others trackers at any time.","ok":"Accept all","parameters":"Setting my choices"},"global":{"back":"Back","backSave":"Save and go back","backToNavigation":"Back to navigation","cancel":"Cancel","close":"Close","confirmExit":"Do you want to quit?","confirmLive":" Are you sure you want to return to live ?","continue":"Continue","hide":"Hide","isLive":"LIVE","loading":"Loading...","no":"No","numbers":{"number_eight":"eight","number_five":"five","number_four":"four","number_nine":"nine","number_one":"one","number_seven":"seven","number_six":"six","number_three":"three","number_two":"two","number_zero":"zero"},"ok":"OK","open":"Open the application","pressBlue":"Press the blue button","pressRed":"Press the red button","quit":"Quit","returnHome":"Back to home","returnHomeSaved":"Save and back to live","returnSettings":"Back to settings","save":"Save","service":"Service","settings":"Settings","show":"Show","showMore":"Show more","yes":"Yes"},"helpAndContact":{"text":"The help center isn\'t available on TV application. To access it, got to \\"My account\\" on your mobile application, on the web site, or from a web browser, smartphone, tablet or computer, to the page : bedrockstreaming.com","title":"Help and contact"},"information":{"qrcode":{"infos":"Scan the QR code with your smartphone camera to access the account page or go to","title":"information.title"},"title":"Information"},"informations":{"account":"Your account","description":"To update your account information, go on bedrockstreaming.com from your mobile or desktop","parentalFilter":"Parental filter","parentalFilterDescription":"All contents under %(age)s years old are currently protected by your code, on all profiles.","parentalFilterOff":"Deactivated","parentalFilterOn":"Activated","paymentRecurrence":"/ Month","subscription":"Your subscription","title":"My information"},"layout":{"locks":{"live":{"unavailableNotAiring":"Broadcasting not started yet."}}},"leavingKidsSection":{"title":"To leave the children\'s area, enter the following numbers.","wrongCode":"The code is incorrect, please try again."},"legalNotice":{"button":"settings/privacy","title":"Privacy Policy"},"misc":{"scaffold":{"markers":"markers","remote":"remote"}},"nav":{"backToLive":"Back to live","backToNav":"Back to navigation","channelSelector":"Channels","episodes":"Episodes","relatedVideos":"You may also like","subtitles":"Audio and subtitles"},"network":{"failedSubTitle":"Please check your internet connection","failedTitle":"Connection Failed"},"pairing":{"completion":{"button":"OK","description":"Account completion description","title":"Account completion"},"landing":{"catchPhrase":"Unlimited TV and Streaming in a single platform.","connect":"Please do pairing to watch video, use my list and watch profile information.","description":"Watch more than 10,000 hours of series, films, documentaries and kids shows in streaming. And find your favourite TV channels and shows live, replay, previews or full seasons. Enjoy of a free one-month trial.","enter":"Enter","help":"A question ? go to some-url.com/help","pricing":"","signIn":"Connect","signOn":"Subscribe","subscribeOffer":"30 days free trial"},"ssi":{"accept":"Accept","decline":"Decline","description":"Description of SSI plan","title":"Use SSI on this platform"},"subscribe":{"expired":{"description":"You can subscribe to the Bedrock website and application from your computer, tablet or smartphone","redirection":"Visit www.bedrockstreaming.com or the Bedrock mobile application available on the App store","switchAccount":"Change your account","title":"You are no longer subscribed to Bedrock"},"finally":"Once subscribed, it will be sufficient to connect to your account to enjoy Bedrock on your TV","goWeb":"Go to the Bedrock mobile app or the website\\nhttps://www.bedrockstreaming.com to subscribe","how":"How to subscribe to Bedrock?","offers":{"offer1":{"description":"","feature1":"","feature10":"","feature2":"","feature3":"","feature4":"","feature5":"","feature6":"","feature7":"","feature8":"","feature9":"","title":""},"offer2":{"description":"","feature1":"","feature10":"","feature2":"","feature3":"","feature4":"","feature5":"","feature6":"","feature7":"","feature8":"","feature9":"","title":""},"offer3":{"description":"","feature1":"","feature10":"","feature2":"","feature3":"","feature4":"","feature5":"","feature6":"","feature7":"","feature8":"","feature9":"","title":""}}},"token":{"callToActionText":"Enter the following code:","connect":"Connect your TV","magenta":{"accept":"Use with MagentaTV","button":"Via MagentaTV","title":"If you are already a Magenta SMART customer and RTL+ is part of your Magenta package, you can easily log in using this button"},"synchRedirection":"Go to your \\"My Profile\\" space on the website www.bedrockstreaming.com or to the section \\"Synchronize my profile\\" on the Bedrock mobile application"},"welcome":{"disconnect":"Logout","profileChoice":"Choose your profile","title":"Welcome on Bedrock","titleBack":"Welcome back!"}},"parentalCode":{"forgottenCode":"Forgot your parental code?","incorrectCode":"The code is invalid, please try again","instruction":"Enter your parental code to start watching your content","lost":{"catalogReturn":"Go back to the catalogue","instruction":"You can retrieve or change your 4-digit PIN code on Bedrock website or mobile applications. Go to \\"My account\\", \\"Parental Filter\\" section"},"title":"This content is locked","wrongCode":"The parental code seems incorrect. Try again."},"parentalFilter":{"content":"Activate the filter to see public content only.","label":"Parental filter","title":"Trust space"},"player":{"adExtraTitle":"%(contentTitle)s will start soon","adMessage":"Advertisement: Your program will resume soon","advertisement":"Advertisement","audio":"Audio","audioDescription":"Audio description","closedCaption":"Closed caption","info":"Info","loader":"LOADING...","nextVideo":{"askReplay":"Replay video?","nextCountdown":"Next video in","unit":"seconds"},"originalSoundtrack":"Original soundtrack","other":"Other","pauseAdMessage":"Press enter to resume the program","replay":"Start again","skipCredits":"Skip credits","skipIntro":"Skip introduction","subDisable":"Disable","subtitles":"Subtitles"},"popups":{"ageGate":{"body":"By pressing CONTINUE you certify that you are at least 18 years old.","heading":"You are about to watch a content that may contain adult-only scenes."},"geoBlocking":{"body":"Sorry\\nThis content is not available in your area"}},"privacySettings":{"cgu":{"title":"Privacy Policy"},"cookie":{"audienceMeasurement":{"content":"The purpose of these cookies is to analyze the traffic and the use of the Bedrock Platform, to better understand how it is used and to improve your browsing experience and use of the Platform. In particular, these cookies may process data relating to the pages visited, the content viewed, the length of time the pages are visited, the browser you are using to visit these pages, etc.","id":"audienceMeasurement","title":"Cookies for audience measurement"},"description":"This page allows you to configure your choices regarding the use of cookies and other tracking devices. With your consent, cookies or other tracking devices are used on this platform by Bedrock and its partners to generate visit statistics, customize the platform\'s services and provide you with services and offers tailored to your interests. To learn more, please visit our Cookie Policy. The settings made via this module apply to this device only, whether or not you are connected to your Bedrock account. If you have a Bedrock account, the cookie settings will not affect the use of your user profile information provided when you created your account to personalize your editorial and advertising experience based on your interests. We invite you to connect to your account if you wish to control their use. For more information, please visit our Privacy Policy.","personalization":{"content":"The purpose of these cookies is to identify content that may be of interest to you with respect to your activity on the Bedrock Platform in order to offer you a personalized editorial experience based on your interests. Disabling these cookies will prevent Bedrock from offering you a personalized experience and content through cookies.","id":"personalization","title":"Platform customization cookies"},"targetedAdvertising":{"content":"The purpose of these cookies is to improve the relevance of the advertisements and advertising content displayed on the Bedrock Platform as well as on third-party media. When we send you promotional messages or broadcast such messages, our goal is to send you the most relevant advertisements and offers possible, adapted to your needs or truly likely to interest you. Deactivating these cookies has no impact on the volume of advertising you will receive.","id":"targetedAdvertising","title":"Advertising cookies"},"text":""},"title":"Privacy settings"},"profile":{"switch":"Change profile"},"search":{"empty":"There is no search history for now","hint":"Search for programs, videos and thematic","history":"Your latest search","placeholder":"A program, a video, a thematic...","playlist":"Playlist","podcast":"Podcasts","program":"Programs","vc":"short videos","vi":"integral videos"},"sidenav":{"channel":"Channels","home":"Home","profile":"Profile","search":"Search","settings":"Settings"},"startover":{"restart":"Restart program over"},"trailer":{"actionLabel":"Trailer"},"upsell":{"computer":{"button":"From Web","pairedButton":"Already booked? Continue to the content","step1":"Go to %(url)s","step2":"Book the RTL Package that suits for you","step3":"Once your subscription is complete, click on the button below","title":"To play this content","unpairedButton":"Already have the right RTL+ package? Sign in"},"error":"To access this content, a higher plan is required","mobile":{"button":"From your mobile","pairedButton":"Already booked? Continue to the content","step1":"Scan the QR code","step2":"Book the RTL Package that suits for you","step3":"Once your subscription is complete, click on the button below","title":"To play this content","unpairedButton":"Already have the right RTL+ package? Sign in"},"title":"Found what you were looking for"},"userInformation":{"appVersion":"App version","deviceId":"Television id","isp":"Internet service provider","title":"User information","userAgent":"User-Agent"}}');
;// CONCATENATED MODULE: ./lang/customer/rtlde/de.json
const de_namespaceObject = JSON.parse('{"accountInformation":{"qrcode":{"infos":"Scanne den QR-Code mit deiner Smartphone-Kamera oder geh zu den Kontoseite unter","title":"Mein Konto"},"title":"Konto"},"accountSettings":{"qrcode":{"infos":"Scanne den QR-Code mit deiner Smartphone-Kamera oder geh zu den Einstellungen unter","title":"Einstellungen"},"title":"Einstellungen"},"blocking":{"blockedLive":"Fr"},"bookmarks":{"actionLabel":"Meine Inhalte","added":"Du hast dieses Programm zu deinen Inhalten hinzugefügt.","noContentAction":"Katalog durchsuchen","noContentDescription":"Die Inhalte, die du zu deiner Liste hinzufügst, erscheinen hier!","noContentTitle":"Dein Katalog ist leer.","removed":"Du hast dieses Programm aus deinen Inhalten entfernt.","title":"Meine Inhalte"},"confirmation":{"description":"Sie haben jetzt vollen Zugriff von diesem Gerät/Netzwerk aus.\\nJedes Gerät, das mit diesem Netzwerk verbunden ist, wird nun als Teil Ihres Haushalts betrachtet.","title":"Dieses {Gerät/Netzwerk} wurde zu Ihrem Haushalt hinzugefügt"},"consentLock":{"cta":"Datenschutzeinstellungen","description":"Du musst der Anzeige zielgerichteter Werbung zustimmen, um dieses Programm ansehen zu können."},"contentRatingAdvisory":{"subTextMessage":"Durch das Klicken auf \\"WEITER\\" bestätigst du, dass du über 18 Jahre alt bist.","textMessage":"Die Ansicht des folgenden Programms wird Personen über 18 Jahren empfohlen."},"date":{"days":{"friday":{"abbreviation":"Fr","complete":"Freitag"},"monday":{"abbreviation":"Mo","complete":"Montag"},"saturday":{"abbreviation":"Sa","complete":"Samstag"},"sunday":{"abbreviation":"So","complete":"Sonntag"},"thursday":{"abbreviation":"Do","complete":"Donnerstag"},"tuesday":{"abbreviation":"Di","complete":"Dienstag"},"wednesday":{"abbreviation":"Mi","complete":"Mittwoch"}},"months":{"april":{"abbreviation":"Apr","complete":"April"},"august":{"abbreviation":"Aug","complete":"August"},"december":{"abbreviation":"Dez","complete":"Dezember"},"february":{"abbreviation":"Feb","complete":"Februar"},"january":{"abbreviation":"Jan","complete":"Januar"},"july":{"abbreviation":"Jul","complete":"Juli"},"june":{"abbreviation":"Jun","complete":"Juni"},"march":{"abbreviation":"Mär","complete":"März"},"may":{"abbreviation":"Mai","complete":"Mai"},"november":{"abbreviation":"Nov","complete":"November"},"october":{"abbreviation":"Okt","complete":"Oktober"},"september":{"abbreviation":"Sep","complete":"September"}}},"detection":{"action":"Konto bestätigen","description":"Haushalt mit dem Bestätigungscode aktualisieren, der dir gesendet wurde","extraDescription":"Gehörst du zu diesem Konto-Haushalt?","logout":"Abmelden","secondaryAction":"Später bestätigen","tertiaryAction":"Neues Konto erstellen","title":"Dieses Konto wird offenbar außerhalb des Haupt-Haushalts genutzt"},"devicesGate":{"action":"Erneut versuchen","description":"Du hast die maximale Anzahl an Geräten erreicht, die mit deinem Konto verbunden sind. Um fortzufahren, trenne eines der Geräte über die mobile Anwendung oder die Website RTL+ in den Einstellungen. ","secondaryAction":"Abmelden","title":"Gerät entferne"},"epg":{"noAction":"Dieser Inhalt ist weder im Livestream noch auf Abruf verfügbar"},"epgGrid":{"afternoon":"Nachmittags","currentWeek":"Diese Woche","evening":"Abends","lastWeek":"Letzte Woche","live":"Live","modal":{"april":"April","august":"August","december":"Dezember","february":"Februar","friday":"Freitag","january":"Januar","july":"Juli","june":"Juni","march":"März","may":"Mai","monday":"Montag","november":"November","october":"Oktober","saturday":"Samstag","september":"September","sunday":"Sonntag","thursday":"Donnerstag","tuesday":"Dienstag","wednesday":"Mittwoch"},"morning":"Morgens","nextWeek":"Nächste Woche","noAction":"Dieser Inhalt ist weder im Livestream noch auf Abruf verfügbar","noProgram":"Kein Programm verfügbar","today":"Heute"},"error":{"csl":"Dieses Video wurde unterbrochen, da du das Limit für gleichzeitiges Ansehen überschritten hast, das für dein Konto erlaubt ist.","general":"Es ist etwas schiefgelaufen, bitte versuche es später erneut.","layout":"Es ist etwas schiefgelaufen, bitte versuche es später erneut.","noAvailableDetails":"Keine verfügbaren Details zu diesem Fehler","pairing":"Es ist ein Fehler beim Koppeln aufgetreten, bitte versuche es später erneut.","permanent":"Ups, etwas ist schief gelaufen, bitte starten Sie die Anwendung neu.","player":"Es ist ein Fehler beim Laden des Videos aufgetreten, bitte versuche es später erneut.","premium":"Scanne den QR-Code mit deiner Smartphone-Kamera oder geh zu folgender Adresse","pressKeyUpToExit":"Drücken Sie die UP-Taste, um dieses Popup zu schließen","retry":"Erneut versuchen"},"faq":{"qrcode":{"infos":"Scanne den QR-Code mit deiner Smartphone-Kamera oder öffne die FAQ unter","link":"www.bit.ly/1a2b3c","title":"Brauchen Sie Hilfe?"},"title":"FAQ"},"feedback":{"qrcode":{"infos":"Scanne den QR-Code mit deiner Smartphone-Kamera oder öffne das Feedback-Formular unter","title":"Teilen Sie Ihre Erfahrung!"},"title":"Feedback"},"gdprNotice":{"decline":"Alle ablehnen","description":"Wenn du zustimmst, werden Cookies oder andere Tracker auf dieser Plattform von Rtl Plus und seinen Partnern verwendet, um Statistiken über Besuche zu erstellen und dir Werbung, Dienstleistungen und Angebote anzuzeigen, die deinen Interessen entsprechen. Für weitere Informationen und zur Ausübung deiner Rechte, besuche bitte unsere Cookie-Richtlinie. Dort kannst du deine Präferenzen bezüglich der Verwendung und Speicherung von Cookies und anderen Trackern jederzeit verwalten.","ok":"Alle akzeptieren","parameters":"Meine Auswahl festlegen"},"geoblocking":{"errorMessage":"Rtl Plus ist leider nur in Deutschland, Österreich und der Schweiz verfügbar.","exitApplication":"Anwendung beenden","videoErrorMessage":"Zurücksetzen"},"global":{"back":"Zurück","backSave":"Speichern und zurück","backToNavigation":"Zurück zur Navigation","cancel":"Abbrechen","close":"Schließen","confirmExit":"Möchtest du beenden?","confirmLive":"Bist du sicher, dass du zum Live-Programm zurückkehren möchtest?","continue":"Weiter","hide":"Verbergen","info":"Mehr Details","isLive":"LIVE","loading":"Lädt...","no":"Nein","numbers":{"number_eight":"acht","number_five":"fünf","number_four":"vier","number_nine":"neun","number_one":"eins","number_seven":"sieben","number_six":"sechs","number_three":"drei","number_two":"zwei","number_zero":"null"},"ok":"OK","open":"Anwendung öffnen","pressBlue":"Drücke die blaue Taste","pressRed":"Drücke die rote Taste","quit":"Beenden","reset":"Zurücksetzen","returnHome":"Zur Startseite zurück","returnHomeSaved":"Speichern und zurück zu Live","returnHome_hbbtv":"Zurück zu Live","returnSettings":"Zurück zu den Einstellungen","save":"Speichern","selected":"Ausgewählt","service":"Dienst","settings":"Einstellungen","show":"Anzeigen","showMore":"Mehr anzeigen","yes":"Ja"},"informations":{"account":"Dein Konto","description":"Um deine Kontoinformationen zu aktualisieren, besuche plus.rtl.de von deinem Mobilgerät oder Desktop","freeTrial":"Kostenlose Testphase","noSubscription":"Kein Abonnement","parentalFilter":"Jugendschutz","parentalFilterDescription":"Alle Inhalte unter %(age)s Jahren sind derzeit durch deinen Code geschützt, auf allen Profilen.","parentalFilterOff":"Deaktiviert","parentalFilterOn":"Aktiviert","paymentRecurrence":"/ Monat","subscription":"Dein Abonnement","title":"Meine Informationen"},"keyboard":{"addSpace":"Abstand einfügen","deleteCharacter":"Ein Zeichen löschen"},"layout":{"locks":{"contentRating":{"message":"Aus Jugendschutzgründen sind Inhalte ab 16 Jahren ab 22:00 Uhr verfügbar, Inhalte ab 18 Jahren ab 23:00 Uhr. Melde dich an oder schließe ein Abo ab, um jederzeit Zugang zu allen Inhalten zu haben."},"geoBlocked":{"message":"Aus lizenzrechtlichen Gründen kann dieses Video an deinem Standort nicht abgespielt werden."},"live":{"message":"Live ist derzeit nicht verfügbar. Bitte warte oder versuche es später erneut."},"parentalFilter":{"message":"Dieses Video ist aufgrund der Aktivierung des Jugendschutzes nicht zugänglich."},"playerDefault":{"message":"Dieses Video ist nicht verfügbar."},"requireAdvertisingConsent":{"message":"Um dein Programm abzuspielen, benötigen wir deine Zustimmung zur zielgerichteten Werbung."}}},"legalNotice":{"button":"einstellungen/datenschutz","title":"Datenschutzerklärung"},"legalPages":{"cga":{"subTitle":"BITTE LIES DIE ALLGEMEINEN GESCHÄFTSBEDINGUNGEN DES RTL PLUS - ABONNEMENTS SORGFÄLTIG DURCH UND BEWAHRE EINE KOPIE AUF.","subTitleLow":"Aktualisiert am 1. Oktober 2020","title":"ALLGEMEINE ABONNEMENTBEDINGUNGEN"},"cgu":{"subTitle":"BITTE LIES DIESE GESCHÄFTSBEDINGUNGEN SORGFÄLTIG DURCH UND BEWAHRE EINE KOPIE AUF","subTitleLow":"Aktualisiert am 1. Oktober 2020","title":"AGB"},"privacyPolicy":{"title":"Datenschutzerklärung"}},"lock":{"contentRating":"Zur Website von %(appDisplayName)s","parentalFilter":"Dieses Video ist aufgrund der Aktivierung des Jugendschutzes nicht zugänglich."},"misc":{"scaffold":{"debug":"Debug","markers":"Marker","remote":"Fernsteuerung"}},"nav":{"backToLive":"Zurück zu Live","backToNav":"Zurück zur Navigation","channelSelector":"Sender","nextVideo":"Nächstes Video","relatedItems":"Das könnte dir auch gefallen","subtitles":"Audio und Untertitel","synopsis":"Mehr lesen"},"network":{"failedSubTitle":"Bitte überprüfe deine Internetverbindung","failedTitle":"Verbindung fehlgeschlagen"},"pairing":{"completion":{"description":"Um alle Premium Formate auf allen Geräten nutzen zu können, vervollständige jetzt deinen Account. Nutze dazu den Link aus der Registrierungs-Email, die du von der Telekom erhalten hast. Du kannst den Link auch auf  dieser website aufrufen: www.telekom.de/kundencenter/partner. Und keine Sorge - es entstehen keine zusätzlichen Kosten.","title":"Sichere dir jetzt alle Premium Vorteile mit Magenta TV"},"devicesGate":{"description":"Du hast die maximale Anzahl an Geräten erreicht, die mit deinem Konto verbunden sind. Um fortzufahren, trenne eines der Geräte über die mobile Anwendung oder die Website RTL+ in den Einstellungen. ","title":"Gerät entfernen"},"landing":{"catchPhrase":"Unbegrenztes Fernsehen und Streaming auf einer einzigen Plattform.","description":"Sieh dir mehr als 10.000 Stunden Serien, Filme, Dokumentationen und Kindersendungen im Streaming an. Finde deine Lieblingssender und -shows live, im Replay, als Vorschau oder komplette Staffeln. Genieße einen kostenlosen Probemonat.","help":"Eine Frage? Besuche some-url.com/help","paymentRecurrence":"/ Monat","pricing":"Ab 6,99 € / Monat. Ohne Bindung und jederzeit kündbar.","signIn":"Anmelden","signOn":"Abonnieren","subscribeOffer":"30 Tage kostenlos testen"},"ssi":{"accept":"Zustimmen","decline":"Ablehnen","description":"Mit meiner Registrierung akzeptiere ich die AGB und habe die Datenschutzrichtlinie zur Kenntnis genommen.\\nAls registrierter Kunde erhalte ich regelmäßig den RTL+Insider mit Informationen zu Produktleistungen. Dies kann ich jederzeit in meinen Einstellungen ändern. Darüber hinaus erhalte ich vertragsrelevante Kundeninformationen.\\nDieser Verwendung meiner E-Mail-Adresse kann ich jederzeit unter support@rtl.de widersprechen, ohne dass hierfür andere als die Übermittlungskosten nach dem Basistarif entstehen.","title":"Aktiviere jetzt dein RTL+ Paket"},"subscribe":{"button":"Schon gebucht? Zum Inhalt","computer":{"steps":{"step1":"Gehe zu https://my.plus.rtl.de/buchen","step2":"Buche das passende RTL+ Paket","step3":"Sobald dein Abo abgeschlossen ist, klicke auf den Button unten"}},"expired":{"description":"Du kannst ein Abonnement auf der Rtl Plus-Website und der Anwendung von deinem Computer, Tablet oder Smartphone abschließen.","redirection":"Besuche www.plus.rtl.de oder die Rtl Plus Mobile App im App Store.","redirectionQrCode":"Scanne mit deinem Handy den QR-Code auf dem Bildschirm","switchAccount":"Konto wechseln","title":"Du bist nicht mehr bei RTL Plus abonniert."},"finally":"Sobald du abonniert hast, reicht es, dich in deinem Konto anzumelden, um Rtl Plus auf deinem TV zu genießen.","goWeb":"\\"Gehe zur Rtl Plus Mobile App oder zur Website https://www.plus.rtl.de, um ein Abonnement abzuschließen.\\"","goWebQrCode":"Folge den Schritten auf deinem Handy, um dein Abo abzuschließen","how":"Um diesen Inhalt abzuspielen","mobile":{"steps":{"step1":"QR-Code scannen","step2":"Buche das passende RTL+ Paket","step3":"Sobald dein Abo abgeschlossen ist, klicke auf den Button unten"}},"offer":{"back":"Zurück","title":"Dieses Programm ist nur für Abonnenten verfügbar."},"offers":{"offer1":"Serien, Filme & Shows","offer2":"Vor TV-Ausstrahlung schauen","offer3":"RTL+ Originals","title":"Fündig geworden"},"qrCaption":"Scanne den QR-Code mit deinem Handy, um deine App zu öffnen."},"token":{"callToActionText":"Gib den folgenden Code ein:","computer":{"button":"Über das Web","steps":{"step1":"Öffne rtlplus.com/tv-login auf deinem Handy oder PC","step2":"Gib den Code unten auf der Website ein","step3":"Fertig! Dein Fernseher ist jetzt angemeldet"}},"connect":"Bei RTL+ anmelden oder registrieren","magenta":{"accept":"Mit MagentaTV nutzen","button":"Über MagentaTV","title":"Wenn du bereits Magenta SMART Kunde bist und RTL+ ein Teil deines Magenta Paketes ist, kannst du dich ganz einfach über diesen Button einloggen"},"mobile":{"button":"Über dein Smartphone","steps":{"step1":"Scanne mit deinem Handy den QR Code","step2":"Folge den Anweisungen auf deinem Handy und melde dich bei RTL+ an. Dein Fernseher wird automatisch verbunden.","step3":"Abgelaufene Zeit: %(currentTime)s von %(contentDuration)s"}},"shouldUpgradePlan":"Um auf diesen Inhalt zuzugreifen, ist ein höherer Plan erforderlich","synchRedirection":"Melde dich bei RTL+ an, um loszulegen.\\nSo geht’s:"},"welcome":{"disconnect":"Abmelden","profileChoice":"Wähle dein Profil","title":"Willkommen bei Rtl Plus","titleBack":"Willkommen zurück!"}},"parentalCode":{"forgottenCode":"Hast du deinen Jugendschutz-Code vergessen?","incorrectCode":"Der Jugendschutz-Code scheint falsch zu sein. Versuche es erneut.","instruction":"Gib deinen Jugendschutz-Code ein, um deine Inhalte anzusehen.","lost":{"catalogReturn":"Zurück zum Katalog","instruction":"Du kannst deinen 4-stelligen PIN-Code auf der Rtl Plus-Website oder in den mobilen Anwendungen abrufen oder ändern. Gehe zu \\"Mein Konto\\", Abschnitt \\"Jugendschutz\\"."},"title":"Dieser Inhalt ist gesperrt.","wrongCode":"Der Jugendschutz-Code scheint falsch zu sein. Versuche es erneut."},"parentalFilter":{"content":"Aktiviere den Filter, um nur öffentliche Inhalte anzuzeigen.","label":"Jugendschutz","title":"Vertrauensbereich"},"player":{"adMessage":"Werbung","advertisement":"Werbung","audio":"Audio","audioDescription":"Audiodeskription","closedCaption":"Untertitel","elapsedTime":"Abgelaufene Zeit: %(currentTime)s von %(contentDuration)s","endScreen":{"askReplay":"Video erneut abspielen?","nextCountdown":"Nächstes Video in","unit":"Sekunden"},"info":{"description":"Beschreibung","duration":"Dauer","episodeName":"Folgentitel","movie":"Film","series":"Serie"},"loader":"WIRD GELADEN...","nextVideo":{"askReplay":"Video erneut abspielen?","nextCountdown":"Nächstes Video in","unit":"Sekunden"},"one":"Video erneut abspielen?","originalSoundtrack":"Originalton","other":"Sonstiges","pauseAdMessage":"Drücke Enter, um das Programm fortzusetzen","replay":"Erneut starten","skipAd":"Werbung überspringen","skipAllAds":"Alle Werbungen überspringen","skipCredits":"Überspringe Abspann","skipIn":"Überspringen in","skipIntro":"Überspringe Einleitung","skipRecap":"Überspringe Zusammenfassung","subDisable":"Deaktivieren","subtitles":"Untertitel","subtitlesSettings":{"background":{"title":"Hintergrund der Untertitel"},"color":{"black":"Schwarz","blue":"Blau","cyan":"Cyan","green":"Grün","magenta":"Magenta","red":"Rot","title":"Farbe der Untertitel","white":"Weiß","yellow":"Gelb"},"font":{"default":"Standard","title":"Schriftart der Untertitel"},"preview":"Untertitel-Vorschau","reset":"Stile zurücksetzen","size":{"large":"Groß","medium":"Mittel","small":"Klein","title":"Größe der Untertitel","xlarge":"Sehr groß"},"title":"Stil der Untertitel"},"zero":"Nächstes Video in"},"privacySettings":{"cgu":{"title":"Datenschutzerklärung"},"cookie":{"audienceMeasurement":{"content":"Zweck dieser Cookies ist es, den Verkehr und die Nutzung der Rtl Plus-Plattform zu analysieren, um besser zu verstehen, wie sie verwendet wird, und deine Browser-Erfahrung und Nutzung der Plattform zu verbessern. Insbesondere können diese Cookies Daten zu besuchten Seiten, angesehenen Inhalten, der Dauer der Seitenaufrufe, dem von dir verwendeten Browser etc. verarbeiten.","id":"audienceMeasurement","title":"Cookies zur Reichweitenmessung"},"description":"Diese Seite ermöglicht es dir, deine Auswahl bezüglich der Verwendung von Cookies und anderen Tracking-Geräten zu konfigurieren. Mit deiner Zustimmung werden auf dieser Plattform von RTL Plus und seinen Partnern Cookies oder andere Tracking-Geräte verwendet, um Besuchsstatistiken zu erstellen, die Dienste der Plattform zu personalisieren und dir Dienstleistungen und Angebote anzuzeigen, die auf deine Interessen zugeschnitten sind. Um mehr zu erfahren, besuche bitte unsere Cookie-Richtlinie. Die über dieses Modul getroffenen Einstellungen gelten nur für dieses Gerät, unabhängig davon, ob du mit deinem RTL Plus-Konto angemeldet bist oder nicht. Wenn du ein RTL Plus-Konto hast, wirken sich die Cookie-Einstellungen nicht auf die Nutzung der von dir bei der Erstellung deines Kontos bereitgestellten Benutzerprofildaten aus, um deine redaktionelle und Werbeerfahrung basierend auf deinen Interessen zu personalisieren. Wir laden dich ein, dich bei deinem Konto anzumelden, wenn du deren Nutzung kontrollieren möchtest. Weitere Informationen findest du in unserer Datenschutzerklärung.","devicePairing":{"content":"Diese Funktion ermöglicht es uns, Browserdaten von diesem Gerät, für das du zugestimmt hast, mit Browserdaten von einem oder mehreren anderen Geräten zu verknüpfen, die mit deinem Netzwerk verbunden sind und für die du ebenfalls zugestimmt hast. Diese Verknüpfung ermöglicht es uns, unsere Reichweitenmessung zu verfeinern und die Personalisierung deiner Erfahrung auf deinen verschiedenen Geräten zu harmonisieren, je nach den getroffenen Entscheidungen zur Verwendung von Cookies (Reichweitenmessung, Personalisierung, Werbung, die auf deine Interessen zugeschnitten ist).","id":"devicePairing","title":"Verknüpfung verbundener Geräte"},"personalization":{"content":"Der Zweck dieser Cookies ist es, Inhalte zu identifizieren, die für dich von Interesse sein könnten, basierend auf deiner Aktivität auf der RTL Plus-Plattform, um dir eine personalisierte redaktionelle Erfahrung basierend auf deinen Interessen zu bieten. Das Deaktivieren dieser Cookies verhindert, dass RTL Plus dir eine personalisierte Erfahrung und Inhalte über Cookies anbieten kann.","id":"personalization","title":"Plattform-Anpassungs-Cookies"},"targetedAdvertising":{"content":"Der Zweck dieser Cookies ist es, die Relevanz der auf der RTL Plus-Plattform sowie auf Drittanbieter-Medien angezeigten Werbung und Werbeinhalte zu verbessern. Wenn wir dir Werbebotschaften senden oder solche Botschaften ausstrahlen, ist es unser Ziel, dir die relevantesten Werbungen und Angebote zu senden, die auf deine Bedürfnisse zugeschnitten sind oder dich höchstwahrscheinlich interessieren. Das Deaktivieren dieser Cookies hat keinen Einfluss auf die Menge der Werbung, die du erhältst.","id":"targetedAdvertising","title":"Werbe-Cookies"},"text":"Diese Seite ermöglicht es dir, deine Auswahl bezüglich der Verwendung von Cookies und anderen Trackern zu konfigurieren. Wenn du zustimmst, werden auf dieser Plattform von RTL Plus und seinen Partnern Cookies oder andere Tracker verwendet, um Besuchsstatistiken zu erstellen, die Plattformdienste zu personalisieren und dir Dienstleistungen und Angebote anzuzeigen, die auf deine Interessen zugeschnitten sind. Um mehr zu erfahren, gehe zu unserer Cookie-Richtlinie. Die über dieses Modul getroffenen Einstellungen gelten nur für dieses Gerät, unabhängig davon, ob du mit deinem RTL Plus-Konto verbunden bist oder nicht. Wenn du ein RTL Plus-Konto hast, hat die Cookie-Einstellung keinen Einfluss auf die Nutzung der Informationen, die in deinem Benutzerprofil bei der Erstellung deines Kontos bereitgestellt wurden, um deine redaktionelle und Werbeerfahrung gemäß deinen Interessen zu personalisieren. Wir laden dich ein, dich bei deinem Konto anzumelden, wenn du deren Nutzung kontrollieren möchtest. Weitere Informationen findest du in unserer Datenschutzrichtlinie auf plus.rtl.de.","title":"Profil"},"geoblocking":{"errorMessage":"Element %(position)s von %(totalItems)s"},"title":"Datenschutzeinstellungen"},"profile":{"edit":{"avatar":"Avatar aktualisieren","delete":"Löschen","done":"Fertig","kid":"Kinderprofil aktualisieren","name":"Name aktualisieren","title":"Profil aktualisieren"},"select":"Profil","switch":"Profil wechseln"},"programCard":{"noContent":"Der Inhalt ist nicht mehr verfügbar"},"screenReader":{"categories":"Kategorien","checked":"Geprüft","listOfElements":"Element %(position)s von %(totalItems)s","unchecked":"Ungeprüft"},"scroll":{"button":{"down":"Nach unten scrollen zum Inhalt","up":"Zurück zum Inhalt"}},"search":{"empty":"Finde deine nächste Suche hier.","hint":"Suche nach Programmen, Videos und Themen","history":"Deine letzten Suchanfragen","placeholder":"Ein Programm, ein Video, ein Thema...","playlist":"Playlist","podcast":"Podcasts","program":"Programme","vc":"%(numVideos)s Kurzvideos","vi":"%(numVideos)s Vollständige Videos"},"sidenav":{"channel":"Sender","home":"Startseite","profile":"Profil","search":"Suche","settings":"Einstellungen","title":"Hauptnavigation"},"startover":{"restart":"Programm von vorne starten"},"upsell":{"computer":{"button":"Über das Web","pairedButton":"Schon gebucht? Zum Inhalt","step1":"Gehe zu %(url)s","step2":"Buche das passende RTL+ Paket","step3":"Sobald dein Abo abgeschlossen ist, klicke auf den Button unten","title":"Um diesen Inhalt abzuspielen","unpairedButton":"Du hast das passende RTL+ Paket? Anmelden"},"error":"Ein höheres Paket ist erforderlich, um diesen Inhalt zu sehen","mobile":{"button":"Über dein Smartphone","pairedButton":"Schon gebucht? Zum Inhalt","step1":"QR-Code scannen","step2":"Buche das passende RTL+ Paket","step3":"Sobald dein Abo abgeschlossen ist, klicke auf den Button unten","title":"Um diesen Inhalt abzuspielen","unpairedButton":"Du hast das passende RTL+ Paket? Anmelden"},"title":"Fündig geworden"},"user":{"login":"Anmelden"},"userInformation":{"appVersion":"App-Version","deviceId":"Fernseher-ID","isp":"Internetdienstanbieter","title":"Nutzerinformationen","userAgent":"User-Agent"},"verification":{"countdown":"Code erneut senden in %(time)s","description":"Bestätige dieses Gerät mit dem Code, den wir an %(email)s gesendet haben. Der Code ist 15 Minuten gültig.","logout":"Abmelden","resend":"Code erneut senden","title":"Bitte gib den Code aus der E-Mail ein"}}');
;// CONCATENATED MODULE: ./lang/languageNames/de.json
const languageNames_de_namespaceObject = JSON.parse('{"aa":"afar","ab":"abchasisch","ae":"avestisch","af":"afrikaans","ak":"akan","am":"amharisch","an":"aragonesisch","ar":"arabisch","as":"assamesisch","av":"awarisch","ay":"aymara","az":"aserbaidschanisch","ba":"baschkirisch","be":"belarussisch","bg":"bulgarisch","bh":"bihari","bi":"bislama","bm":"bambara","bn":"bengalisch","bo":"tibetisch","br":"bretonisch","bs":"bosnisch","ca":"katalanisch","ce":"tschetschenisch","ch":"chamorro","co":"korsisch","cr":"cree","cs":"tschechisch","cu":"kirchenslawisch","cv":"tschuwaschisch","cy":"walisisch","da":"dänisch","de":"deutsch","dv":"divehi","dz":"bhutanisch","ee":"ewe","el":"griechisch","en":"englisch","eo":"esperanto","es":"spanisch","et":"estnisch","eu":"baskisch","fa":"persisch","ff":"ful","fi":"finnisch","fj":"fidschi","fo":"färöisch","fr":"französisch","fy":"westfriesisch","ga":"irisch","gd":"schottisch-gälisch","gl":"galicisch","gn":"guaraní","gu":"gujarati","gv":"manx","ha":"hausa","he":"hebräisch","hi":"hindi","ho":"hiri motu","hr":"kroatisch","ht":"haitianisch","hu":"ungarisch","hy":"armenisch","hz":"herero","ia":"interlingua","id":"indonesisch","ie":"interlingue","ig":"igbo","ii":"yi","ik":"inupiak","io":"ido","is":"isländisch","it":"italienisch","iu":"inuktitut","ja":"japanisch","jv":"javanisch","ka":"georgisch","kg":"kongo","ki":"kikuyu","kj":"kwanyama","kk":"kasachisch","kl":"grönländisch","km":"khmer","kn":"kannada","ko":"koreanisch","kr":"kanuri","ks":"kaschmiri","ku":"kurdisch","kv":"komi","kw":"kornisch","ky":"kirgisisch","la":"latein","lb":"luxemburgisch","lg":"luganda","li":"limburgisch","ln":"lingala","lo":"laotisch","lt":"litauisch","lu":"luba-katanga","lv":"lettisch","mg":"malagasy","mh":"marschallesisch","mi":"maori","mk":"mazedonisch","ml":"malayalam","mn":"mongolisch","mr":"marathi","ms":"malaiisch","mt":"maltesisch","my":"birmanisch","na":"nauruisch","nb":"norwegisch Bokmål","nd":"nord-ndebele","ne":"nepalesisch","ng":"ndonga","nl":"niederländisch","nn":"nynorsk","no":"norwegisch","nr":"süd-ndebele","nv":"navajo","ny":"chichewa","oc":"okzitanisch","oj":"ojibwe","om":"oromo","or":"oriya","os":"ossetisch","pa":"punjabi","pi":"pali","pl":"polnisch","ps":"paschtu","pt":"portugiesisch","qu":"quechua","rm":"rätoromanisch","rn":"kirundi","ro":"rumänisch","ru":"russisch","rw":"kinyarwanda","sa":"sanskrit","sc":"sardisch","sd":"sindhi","se":"nordsamisch","sg":"sango","si":"singhalesisch","sk":"slowakisch","sl":"slowenisch","sm":"samoanisch","sn":"shona","so":"somali","sq":"albanisch","sr":"serbisch","ss":"siswati","st":"südsotho","su":"sundanesisch","sv":"schwedisch","sw":"swahili","ta":"tamil","te":"telugu","tg":"tadschikisch","th":"thailändisch","ti":"tigrinya","tk":"turkmenisch","tl":"tagalog","tn":"tswana","to":"tongaisch","tr":"türkisch","ts":"tsonga","tt":"tatarisch","tw":"twi","ty":"tahitianisch","ug":"uigurisch","uk":"ukrainisch","ur":"urdu","uz":"usbekisch","ve":"venda","vi":"vietnamesisch","vo":"volapük","wa":"wallonisch","wo":"wolof","xh":"xhosa","yi":"jiddisch","yo":"yoruba","za":"zhuang","zh":"chinesische Sprachen","zu":"zulu"}');
;// CONCATENATED MODULE: ./src/modules/i18n/customer/rtlde.languages.js




var rtlde_languages_dictionary = merge_default()(en_namespaceObject, de_namespaceObject);

;// CONCATENATED MODULE: ./src/modules/i18n/index.js

function i18n_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function i18n_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? i18n_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : i18n_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }




var bundle = i18n_objectSpread(i18n_objectSpread({}, rtlde_languages_dictionary), {}, {
  languages: languageNames_de_namespaceObject
});
var setupI18NOverrides = function setupI18NOverrides(overrides) {
  if (overrides) {
    bundle = merge_default()(bundle, overrides);
  }
};
var destroy = function destroy() {
  bundle = undefined;
};
var t = translate(bundle, (src_default()).i18nNames);
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/grid/grid.style.js










var grid_style_defaultContext = makeDefaultStylingContext();
var grid_style_colors = {
  title: makeThemeColor(PRIMARY)
};
var grid_style_getTitleStyle = memoize_default()(function (_ref) {
  var screenSize = _ref.screenSize,
    colorMode = _ref.colorMode;
  return {
    y: TITLE_PADDING.TOP[screenSize],
    color: grid_style_colors.title[colorMode],
    text: src_getFont(constants_FONT.KINSHASA_3, screenSize)
  };
});
var grid_style_getBlockStyle = memoize_default()(function (context) {
  var hasTitle = context.hasTitle,
    isFirstBlock = context.isFirstBlock,
    screenSize = context.screenSize;
  var padding = {
    top: block_constants_PADDING.TOP[screenSize],
    bottom: block_constants_PADDING.BOTTOM[screenSize],
    left: block_constants_PADDING.LEFT[screenSize]
  };
  var firstBlockPadding = FIRST_BLOCK_PADDING[screenSize];
  var titleStyle = grid_style_getTitleStyle(context);
  var items = {
    y: padding.top
  };
  var title = {
    y: titleStyle.y
  };
  if (hasTitle) {
    items.y = titleStyle.text.lineHeight + TITLE_PADDING.BOTTOM[screenSize];
    if (isFirstBlock) {
      items.y += firstBlockPadding;
      title.y = firstBlockPadding;
    } else {
      items.y += titleStyle.y;
    }
  } else if (isFirstBlock) {
    items.y = firstBlockPadding;
  }
  return {
    title: title,
    items: items,
    padding: padding
  };
});
var grid_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : grid_style_defaultContext;
  return {
    color: colors_TRANSPARENT,
    Background: {
      w: identity,
      h: identity
    },
    Content: {
      Title: grid_style_getTitleStyle(context)
    },
    More: {
      visible: false,
      mountY: 1
    }
  };
};
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/clamp.js
var clamp = __webpack_require__(35636);
var clamp_default = /*#__PURE__*/__webpack_require__.n(clamp);
;// CONCATENATED MODULE: ./src/modules/tornado/progress/progress.utils.js



var safeProgressValue = function safeProgressValue(value) {
  return clamp_default()(value, 0, 1);
};
var getProgress = function getProgress(percentage) {
  return Number.isFinite(percentage) ? percentage / 100 : 0;
};
var getPercentage = function getPercentage(currentTime, clipDuration) {
  return clipDuration && currentTime ? Math.ceil(currentTime * 100 / clipDuration) : 0;
};
var makeProgressBarProperties = function makeProgressBarProperties(percentage) {
  var progress = getProgress(percentage);
  return {
    visible: Boolean(progress),
    progress: progress
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/utils/templates.js
var makeTextPatch = function makeTextPatch(text, wordWrapWidth, color) {
  return {
    visible: Boolean(text),
    color: color,
    text: {
      text: text,
      wordWrapWidth: wordWrapWidth
    }
  };
};
var areContentItemsEqual = function areContentItemsEqual(first, second) {
  return first && second ? first.id === second.id : false;
};
var ICON_POSITION = {
  TOP_LEFT: 0,
  TOP_RIGHT: 1,
  BOTTOM_RIGHT: 3,
  BOTTOM_LEFT: 4,
  CENTER: 5
};
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/flatMap.js
var flatMap = __webpack_require__(47812);
var flatMap_default = /*#__PURE__*/__webpack_require__.n(flatMap);
;// CONCATENATED MODULE: ./src/modules/tornado/stamp/stamp.style.js

var stamp_style_PADDING, stamp_style_BORDER_RADIUS;
function stamp_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function stamp_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? stamp_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : stamp_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






var stamp_style_defaultContext = makeDefaultStylingContext();
var stamp_stamp_style_PADDING = (stamp_style_PADDING = {}, (0,defineProperty/* default */.Z)(stamp_style_PADDING, HD, 4), (0,defineProperty/* default */.Z)(stamp_style_PADDING, FULL_HD, 4), stamp_style_PADDING);
var stamp_stamp_style_BORDER_RADIUS = (stamp_style_BORDER_RADIUS = {}, (0,defineProperty/* default */.Z)(stamp_style_BORDER_RADIUS, HD, 2), (0,defineProperty/* default */.Z)(stamp_style_BORDER_RADIUS, FULL_HD, 2), stamp_style_BORDER_RADIUS);
var stamp_style_colors = {
  text: makeThemeColor(PRIMARY),
  primary: makeThemeColor(CLOUD_NORMAL),
  secondary: makeThemeColor(QUINARY)
};
var TITLE_FONT_TYPE = FONT_TYPE.MAIN;
var getLabelFont = function getLabelFont(screenSize) {
  return src_getFont(constants_FONT.BOSTON_2, screenSize, TITLE_FONT_TYPE);
};
var stamp_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : stamp_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  var font = getLabelFont(screenSize);
  var h = font.lineHeight + stamp_stamp_style_PADDING[screenSize] * 2;
  return merge_default()({
    h: h,
    Background: {
      h: h,
      color: stamp_style_colors.primary[colorMode],
      shader: {
        radius: stamp_stamp_style_BORDER_RADIUS[screenSize]
      },
      w: identity
    },
    Label: {
      y: stamp_stamp_style_PADDING[screenSize],
      color: stamp_style_colors.text[colorMode],
      text: stamp_style_objectSpread(stamp_style_objectSpread({}, font), {}, {
        verticalAlign: 'middle',
        wordWrap: false,
        textOverflow: '...'
      })
    }
  });
};
;// CONCATENATED MODULE: ./src/modules/tornado/stamp/stamp.component.js





function stamp_component_createSuper(t) { var r = stamp_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function stamp_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (stamp_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }



var Stamp = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Stamp, _Lightning$Component);
  var _super = stamp_component_createSuper(Stamp);
  function Stamp() {
    (0,classCallCheck/* default */.Z)(this, Stamp);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Stamp, [{
    key: "_construct",
    value: function _construct() {
      this._style = stamp_style_defaultContext;
    }
  }, {
    key: "_build",
    value: function _build() {
      var _this = this;
      var label = this.tag('Label');
      var handleUpdate = function handleUpdate() {
        var w = label.finalW + stamp_stamp_style_PADDING[_this._style.screenSize] * 2;
        var labelOffsetX = (w - label.finalW) / 2;
        _this.patch({
          w: w,
          Label: {
            x: labelOffsetX
          }
        });
        _this.emit('txLoaded');
      };
      label.on('txLoaded', handleUpdate);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this.tag('Label').removeAllListeners('txLoaded');
    }
  }, {
    key: "label",
    set: function set(value) {
      this.tag('Label').text.text = value;
    }
  }, {
    key: "labelColor",
    set: function set(value) {
      this.tag('Label').color = value;
    }
  }, {
    key: "backgroundColor",
    set: function set(value) {
      this.tag('Background').color = value;
    }
  }, {
    key: "wordWrapWidth",
    set: function set(value) {
      this.tag('Label').text.wordWrapWidth = value;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Background: {
          rect: true,
          shader: {
            type: src_Lightning.shaders.RoundedRectangle
          }
        },
        Label: {}
      }, stamp_style_getInitialStyle());
    }
  }]);
  return Stamp;
}(src_Lightning.Component);

;// CONCATENATED MODULE: ./src/modules/tornado/stamp/stamp.constants.js
var DISPLAY_VARIANT_PRIMARY = 'primary';
var DISPLAY_VARIANT_SECONDARY = 'secondary';
;// CONCATENATED MODULE: ./src/modules/tornado/incentive/incentive.style.js

var _GAP, incentive_style_HEIGHT;
function incentive_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function incentive_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? incentive_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : incentive_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





var incentive_style_defaultContext = makeDefaultStylingContext();
var GAP = (_GAP = {}, (0,defineProperty/* default */.Z)(_GAP, HD, 4), (0,defineProperty/* default */.Z)(_GAP, FULL_HD, 4), _GAP);
var incentive_incentive_style_HEIGHT = (incentive_style_HEIGHT = {}, (0,defineProperty/* default */.Z)(incentive_style_HEIGHT, HD, getLabelFont(HD).lineHeight + stamp_stamp_style_PADDING[HD] * 2), (0,defineProperty/* default */.Z)(incentive_style_HEIGHT, FULL_HD, getLabelFont(FULL_HD).lineHeight + stamp_stamp_style_PADDING[FULL_HD] * 2), incentive_style_HEIGHT);
var incentive_style_colors = {
  text: makeThemeColor(PRIMARY)
};
var getTextTemplate = function getTextTemplate(screenSize) {
  return incentive_style_objectSpread(incentive_style_objectSpread({}, src_getFont(constants_FONT.BOSTON_2, screenSize)), {}, {
    verticalAlign: 'middle',
    wordWrap: false,
    textOverflow: '...'
  });
};
var incentive_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : incentive_style_defaultContext,
    screenSize = _ref.screenSize;
  return {
    h: incentive_incentive_style_HEIGHT[screenSize]
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/incentive/incentive.constants.js
var THEME_STAMP = 'stamp';
var THEME_TEXT = 'text';
var ALIGNMENT_HORIZONTAL = 'horizontal';
var ALIGNMENT_VERTICAL = 'vertical';
var SINGLE_LINE_CHAR_LIMIT = 18;
var MULTI_LINE_CHAR_LIMIT = 18;
;// CONCATENATED MODULE: ./src/modules/tornado/incentive/incentive.utils.js



var getDisplayVariant = function getDisplayVariant(incentive) {
  try {
    return incentive.display.variant.toLowerCase();
  } catch (error) {
    return '';
  }
};
var hasValidDisplayVariant = function hasValidDisplayVariant(incentive) {
  var variant = getDisplayVariant(incentive);
  return variant === DISPLAY_VARIANT_PRIMARY || variant === DISPLAY_VARIANT_SECONDARY;
};
var getLinesCount = function getLinesCount(incentives) {
  if (!incentives || !incentives.length) {
    return false;
  }
  return incentives.filter(hasValidDisplayVariant).reduce(function (result, incentive) {
    return result + (incentive.lines ? incentive.lines.filter(function (line) {
      return line.text;
    }).length : 0);
  }, 0);
};
;// CONCATENATED MODULE: ./src/modules/tornado/incentive/incentive.component.js









function incentive_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function incentive_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? incentive_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : incentive_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function incentive_component_createSuper(t) { var r = incentive_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function incentive_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (incentive_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }








var Incentive = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Incentive, _Lightning$Component);
  var _super = incentive_component_createSuper(Incentive);
  function Incentive() {
    (0,classCallCheck/* default */.Z)(this, Incentive);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Incentive, [{
    key: "_construct",
    value: function _construct() {
      this._style = incentive_style_defaultContext;
      this._childrenLoaded = 0;
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this.children.forEach(function (child) {
        child.removeAllListeners('txLoaded');
      });
    }
  }, {
    key: "data",
    set: function set(_ref) {
      var _this = this;
      var colorMode = _ref.colorMode,
        incentives = _ref.incentives,
        w = _ref.w,
        linesCount = _ref.linesCount,
        _ref$alignment = _ref.alignment,
        alignment = _ref$alignment === void 0 ? ALIGNMENT_HORIZONTAL : _ref$alignment;
      if (!incentives || !incentives.length || !linesCount) {
        if (this.children.length) {
          this.children = [];
        }
        return;
      }
      if (colorMode && colorMode !== this._style.colorMode) {
        this._style = {
          screenSize: this._style.screenSize,
          colorMode: colorMode
        };
      }
      var wordWrapWidth = w && alignment === ALIGNMENT_HORIZONTAL ? Math.round(w / linesCount) : w;
      this.children = flatMap_default()(incentives.filter(hasValidDisplayVariant), function (incentive) {
        var displayVariant = getDisplayVariant(incentive);
        return (incentive.lines || []).map(function (_ref2) {
          var theme = _ref2.theme,
            text = _ref2.text;
          if (!text) {
            return null;
          }
          switch (theme) {
            case THEME_STAMP:
              return {
                type: Stamp,
                label: text,
                labelColor: stamp_style_colors.text[_this._style.colorMode],
                wordWrapWidth: wordWrapWidth - stamp_stamp_style_PADDING[_this._style.screenSize] * 2,
                backgroundColor: displayVariant === DISPLAY_VARIANT_PRIMARY ? stamp_style_colors.primary[_this._style.colorMode] : stamp_style_colors.secondary[_this._style.colorMode]
              };
            case THEME_TEXT:
              {
                return {
                  y: stamp_stamp_style_PADDING[_this._style.screenSize],
                  color: incentive_style_colors.text[_this._style.colorMode],
                  text: incentive_component_objectSpread(incentive_component_objectSpread({}, getTextTemplate(_this._style.screenSize)), {}, {
                    wordWrapWidth: wordWrapWidth,
                    text: text
                  })
                };
              }
            default:
              return null;
          }
        }).filter(Boolean);
      });
      this._childrenLoaded = 0;
      this.children.forEach(function (child) {
        child.once('txLoaded', function () {
          _this._childrenLoaded += 1;
          if (_this._childrenLoaded >= _this.children.length) {
            _this._placeChildren(alignment);
          }
        });
      });
    }
  }, {
    key: "_placeChildren",
    value: function _placeChildren() {
      var _this2 = this;
      var alignment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ALIGNMENT_HORIZONTAL;
      var offset = 0;
      if (alignment === ALIGNMENT_VERTICAL) {
        var w = 0;
        this.children.forEach(function (child) {
          child.y = offset;
          offset += child.finalH + GAP[_this2._style.screenSize];
          w = Math.max(w, child.finalW);
        });
        this.children.forEach(function (child) {
          child.x = Math.round((w - child.finalW) / 2);
        });
        this.patch({
          w: w,
          h: offset
        });
      } else {
        this.children.forEach(function (child) {
          child.x = offset;
          offset += child.finalW + GAP[_this2._style.screenSize];
        });
        this.w = offset;
      }
    }
  }], [{
    key: "_template",
    value: function _template() {
      return incentive_style_getInitialStyle();
    }
  }]);
  return Incentive;
}(src_Lightning.Component);

;// CONCATENATED MODULE: ./src/modules/tornado/shaders/image.shader.js
































function image_shader_createSuper(t) { var r = image_shader_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function image_shader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (image_shader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }


var ImageShader = function (_Lightning$shaders$We) {
  (0,inherits/* default */.Z)(ImageShader, _Lightning$shaders$We);
  var _super = image_shader_createSuper(ImageShader);
  function ImageShader(context) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, ImageShader);
    _this = _super.call(this, context);
    _this._radius = 0;
    _this._scale = 1.0;
    _this._progress = 0.0;
    _this._progressBarColorRaw = colors_TRANSPARENT;
    _this._progressBackgroundColorRaw = colors_TRANSPARENT;
    _this._overlayColorRaw = colors_TRANSPARENT;
    _this._progressBarColor = _this._getNormalizedColor(_this._progressBarColorRaw);
    _this._progressBackgroundColor = _this._getNormalizedColor(_this._progressBackgroundColorRaw);
    _this._overlayColor = _this._getNormalizedColor(_this._overlayColorRaw);
    _this._progressHeight = 0;
    return _this;
  }
  (0,createClass/* default */.Z)(ImageShader, [{
    key: "scale",
    get: function get() {
      return this._scale;
    },
    set: function set(v) {
      this._scale = Math.max(v, 0);
      this.redraw();
    }
  }, {
    key: "radius",
    get: function get() {
      return this._radius;
    },
    set: function set(v) {
      this._radius = v;
      this.redraw();
    }
  }, {
    key: "progressBarColor",
    get: function get() {
      return this._progressBarColorRaw;
    },
    set: function set(color) {
      this._progressBarColorRaw = color;
      this._progressBarColor = this._getNormalizedColor(color);
      this.redraw();
    }
  }, {
    key: "progressBackgroundColor",
    get: function get() {
      return this._progressBackgroundColorRaw;
    },
    set: function set(color) {
      this._progressBackgroundColorRaw = color;
      this._progressBackgroundColor = this._getNormalizedColor(color, false);
      this.redraw();
    }
  }, {
    key: "overlayColor",
    get: function get() {
      return this._overlayColorRaw;
    },
    set: function set(color) {
      this._overlayColorRaw = color;
      this._overlayColor = this._getNormalizedColor(color, false);
      this.redraw();
    }
  }, {
    key: "progressHeight",
    get: function get() {
      return this._progressHeight;
    },
    set: function set(value) {
      this._progressHeight = value;
      this.redraw();
    }
  }, {
    key: "progress",
    get: function get() {
      return this._progress;
    },
    set: function set(num) {
      this._progress = num;
      this.redraw();
    }
  }, {
    key: "_getNormalizedColor",
    value: function _getNormalizedColor(color) {
      var useAlphaChannel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var col = src_Lightning.StageUtils.getRgbaComponentsNormalized(color);
      if (useAlphaChannel) {
        col[0] *= col[3];
        col[1] *= col[3];
        col[2] *= col[3];
      }
      return new Float32Array(col);
    }
  }, {
    key: "setupUniforms",
    value: function setupUniforms(operation) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(ImageShader.prototype), "setupUniforms", this).call(this, operation);
      var owner = operation.shaderOwner;
      var renderPrecision = this.ctx.stage.getRenderPrecision();
      this._setUniform('radius', this._radius, this.gl.uniform1f);
      this._setUniform('progressColor', this._progressBackgroundColor, this.gl.uniform4fv);
      this._setUniform('progressBarColor', this._progressBarColor, this.gl.uniform4fv);
      this._setUniform('overlayColor', this._overlayColor, this.gl.uniform4fv);
      this._setUniform('scale', this._scale, this.gl.uniform1f);
      this._setUniform('progress', this._progress, this.gl.uniform1f);
      this._setUniform('progressHeight', this._progressHeight, this.gl.uniform1f);
      this._setUniform('resolution', new Float32Array([owner._w * renderPrecision, owner._h * renderPrecision]), this.gl.uniform2fv);
    }
  }]);
  return ImageShader;
}(src_Lightning.shaders.WebGLDefaultShader);

ImageShader.vertexShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    attribute vec2 aVertexPosition;\n    attribute vec2 aTextureCoord;\n\n    attribute vec4 aColor;\n    uniform vec2 projection;\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n\n    void main(void){\n        gl_Position = vec4(aVertexPosition.x * projection.x - 1.0, aVertexPosition.y * -abs(projection.y) + 1.0, 0.0, 1.0);\n        vTextureCoord = aTextureCoord;\n        vColor = aColor;\n        gl_Position.y = -sign(projection.y) * gl_Position.y;\n    }\n";
ImageShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n\n    uniform sampler2D uSampler;\n    uniform vec2 resolution;\n    uniform float radius;\n    uniform float scale;\n    uniform float progress;\n    uniform float progressHeight;\n    uniform vec4 progressBarColor;\n    uniform vec4 progressColor;\n    uniform vec4 overlayColor;\n\n    vec3 blendNormal(vec3 base, vec3 blend, float opacity) {\n      return (blend * opacity + base * (1.0 - opacity));\n    }\n\n    float boxDist(vec2 p, vec2 size, float radius) {\n      size -= vec2(radius);\n      vec2 d = abs(p) - size;\n\n      return min(max(d.x, d.y), 0.0) + length(max(d, 0.0)) - radius;\n    }\n\n    float fillMask(float dist) {\n        return clamp(-dist, 0.0, 1.0);\n    }\n\n    vec2 texCoordsWithOffset(float offset) {\n        vec2 texCoordsMultiplier = (1.0 + (offset * 2.0) / resolution);\n        vec2 texCoordsOffset = offset / resolution;\n\n        return vTextureCoord * texCoordsMultiplier - texCoordsOffset;\n    }\n\n    void main() {\n        vec2 halfRes = resolution * 0.5;\n        vec2 halfResOffset = halfRes + 0.5;\n        vec4 texture = texture2D(uSampler, vTextureCoord) * vColor;\n\n        if (overlayColor.a > 0.0) {\n          float topAlpha = 0.3;\n          float bottomAlpha = 0.6;\n          float globalAlpha = 0.1;\n          float topOverlay = clamp(1.0 - (vTextureCoord.y / 0.25), 0.0, 1.0) * topAlpha;\n          float bottomOverlay = clamp((vTextureCoord.y / 0.5 - 1.0), 0.0, 1.0) * bottomAlpha;\n          float overlay = bottomOverlay + topOverlay + globalAlpha;\n          texture = vec4(blendNormal(texture.rgb, overlayColor.rgb, overlay), 1.0);\n        }\n\n        float imageDistance = boxDist(vTextureCoord * resolution - halfRes, halfResOffset, radius / scale);\n        float imageMask = fillMask(imageDistance);\n\n        vec4 image = mix(vec4(0.0), texture, imageMask);\n\n        if (progress > 0.0) {\n          float offset = scale - 1.0;\n          float halfOffset = offset / 2.0;\n          vec2 texCoordsScaled = vTextureCoord * scale;\n\n          float barHeight = progressHeight / resolution.y;\n          float progressXStart = step(halfOffset, texCoordsScaled.x);\n          float progressXEnd = 1.0 - step(progress + halfOffset, texCoordsScaled.x);\n          float progressYStart = step(1.0 - barHeight + halfOffset, texCoordsScaled.y);\n          float progressBgXEnd = 1.0 - step(1.0 + halfOffset, texCoordsScaled.x);\n          float progressBgYEnd = 1.0 - step(1.0 + halfOffset, texCoordsScaled.y);\n          float progressEndMask = progressBgXEnd * progressBgYEnd;\n\n          float progressMask = progressYStart * progressXStart * progressEndMask * imageMask;\n          float progressBarMask = progressMask * progressXEnd;\n\n          image = vec4(blendNormal(image.rgb, progressColor.rgb, progressColor.a * progressMask), 1.0);\n          image = mix(image, progressBarColor, progressBarMask);\n        }\n\n        gl_FragColor = vec4(image.rgb, imageMask);\n    }\n";
;// CONCATENATED MODULE: ./src/modules/tornado/poster/customer/rtlde/poster.utils.js
var shouldDisplayTreatment = function shouldDisplayTreatment(item) {
  if (!item) {
    return false;
  }
  var title = item.title,
    extraTitle = item.extraTitle,
    details = item.details,
    highlight = item.highlight;
  return Boolean(title || extraTitle || details || highlight);
};
;// CONCATENATED MODULE: ./src/modules/tornado/progress/progress.style.js

var progress_style_HEIGHT = 4;
var progress_style_colors = {
  background: makeThemeColor(PRIMARY, 0.3),
  bar: makeThemeColor(SECONDARY)
};
;// CONCATENATED MODULE: ./src/modules/tornado/utils/customer/rtlde/focus.js

var _BORDER_WIDTH, focus_BORDER_RADIUS;


var focus_BORDER_WIDTH = (_BORDER_WIDTH = {}, (0,defineProperty/* default */.Z)(_BORDER_WIDTH, HD, 4), (0,defineProperty/* default */.Z)(_BORDER_WIDTH, FULL_HD, 6), _BORDER_WIDTH);
var rtlde_focus_BORDER_RADIUS = (focus_BORDER_RADIUS = {}, (0,defineProperty/* default */.Z)(focus_BORDER_RADIUS, HD, 4), (0,defineProperty/* default */.Z)(focus_BORDER_RADIUS, FULL_HD, 4), focus_BORDER_RADIUS);
var BORDER_COLOR = makeThemeColor(PRIMARY);
var INNER_BORDER_COLOR = makeThemeColor(TERTIARY);
;// CONCATENATED MODULE: ./src/modules/tornado/utils/focus.js

var focus_SCALE_FOCUSED = 1.05;
;// CONCATENATED MODULE: ./src/modules/tornado/badge/badge.style.js


var badge_style_defaultContext = makeDefaultStylingContext();
var COLOR = makeThemeColor(SECONDARY);
var ICON_COLOR = makeThemeColor(TERTIARY);
var badge_style_BORDER_RADIUS = 4;
var badge_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : badge_style_defaultContext,
    colorMode = _ref.colorMode;
  return {
    color: COLOR[colorMode],
    iconColor: ICON_COLOR[colorMode],
    shader: {
      radius: badge_style_BORDER_RADIUS
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/badge/badge.component.js





function badge_component_createSuper(t) { var r = badge_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function badge_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (badge_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }




var Badge = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Badge, _Lightning$Component);
  var _super = badge_component_createSuper(Badge);
  function Badge() {
    (0,classCallCheck/* default */.Z)(this, Badge);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Badge, [{
    key: "_attach",
    value: function _attach() {
      var _this = this;
      this.tag('Icon').on('txLoaded', function () {
        var icon = _this.tag('Icon');
        _this.patch({
          w: icon.finalW,
          h: icon.finalH
        });
      });
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this.tag('Icon').removeAllListeners('txLoaded');
    }
  }, {
    key: "iconData",
    set: function set(value) {
      this.tag('Icon').iconData = value;
      this.alpha = value ? 1 : 0;
    }
  }, {
    key: "iconColor",
    get: function get() {
      return this.tag('Icon').color;
    },
    set: function set(value) {
      this.tag('Icon').color = value;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        rect: true,
        shader: {
          type: src_Lightning.shaders.RoundedRectangle
        },
        Icon: {
          type: Icon
        }
      }, badge_style_getInitialStyle());
    }
  }]);
  return Badge;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/tornado/poster/customer/rtlde/poster.constants.js

var _ICONS, _ICONS_TYPES, _templates$PosterS, _templates$PosterM, _templates$PosterL, _sizes, _templates$PosterS2, _templates$PosterM2, _templates$PosterL2, _imageOptions;






var TITLES_ORDER = ['ExtraTitle', 'Title'];
var TITLE_FONT_NAME = constants_FONT.BERLIN_1;
var EXTRA_TITLE_FONT_NAME = constants_FONT.OTTAWA_3;
var poster_constants_TITLE_FONT_TYPE = FONT_TYPE.MAIN;
var DISPLAY_ICONS = true;
var DISPLAY_TITLE = true;
var DISPLAY_EXTRA_TITLE = false;
var poster_constants_BORDER_COLOR = makeThemeColor(PRIMARY);
var poster_constants_INNER_BORDER_COLOR = makeThemeColor(TERTIARY);
var POSTER_OVERLAY = makeThemeColor(TERTIARY);
var HIGHLIGHT_COLOR = makeThemeColor(QUATERNARY);
var ICONS = (_ICONS = {}, (0,defineProperty/* default */.Z)(_ICONS, ICON_POSITION.TOP_LEFT, 2), (0,defineProperty/* default */.Z)(_ICONS, ICON_POSITION.TOP_RIGHT, 4), (0,defineProperty/* default */.Z)(_ICONS, ICON_POSITION.BOTTOM_RIGHT, 1), _ICONS);
var ICONS_TYPES = (_ICONS_TYPES = {}, (0,defineProperty/* default */.Z)(_ICONS_TYPES, ICON_POSITION.TOP_LEFT, Icon), (0,defineProperty/* default */.Z)(_ICONS_TYPES, ICON_POSITION.TOP_RIGHT, Badge), (0,defineProperty/* default */.Z)(_ICONS_TYPES, ICON_POSITION.BOTTOM_RIGHT, Icon), _ICONS_TYPES);
var poster_constants_templates = {
  PosterS: 'PosterS',
  PosterM: 'PosterM',
  PosterL: 'PosterL'
};
var poster_constants_sizes = (_sizes = {}, (0,defineProperty/* default */.Z)(_sizes, poster_constants_templates.PosterS, (_templates$PosterS = {}, (0,defineProperty/* default */.Z)(_templates$PosterS, HD, {
  w: 195,
  h: 110
}), (0,defineProperty/* default */.Z)(_templates$PosterS, FULL_HD, {
  w: 250,
  h: 141
}), _templates$PosterS)), (0,defineProperty/* default */.Z)(_sizes, poster_constants_templates.PosterM, (_templates$PosterM = {}, (0,defineProperty/* default */.Z)(_templates$PosterM, HD, {
  w: 247,
  h: 139
}), (0,defineProperty/* default */.Z)(_templates$PosterM, FULL_HD, {
  w: 381,
  h: 214
}), _templates$PosterM)), (0,defineProperty/* default */.Z)(_sizes, poster_constants_templates.PosterL, (_templates$PosterL = {}, (0,defineProperty/* default */.Z)(_templates$PosterL, HD, {
  w: 333,
  h: 187
}), (0,defineProperty/* default */.Z)(_templates$PosterL, FULL_HD, {
  w: 512,
  h: 288
}), _templates$PosterL)), _sizes);
var imageOptions = (_imageOptions = {}, (0,defineProperty/* default */.Z)(_imageOptions, poster_constants_templates.PosterS, (_templates$PosterS2 = {}, (0,defineProperty/* default */.Z)(_templates$PosterS2, HD, {
  PRIMARY: {
    width: 195,
    height: 110
  }
}), (0,defineProperty/* default */.Z)(_templates$PosterS2, FULL_HD, {
  PRIMARY: {
    width: 250,
    height: 141
  }
}), _templates$PosterS2)), (0,defineProperty/* default */.Z)(_imageOptions, poster_constants_templates.PosterM, (_templates$PosterM2 = {}, (0,defineProperty/* default */.Z)(_templates$PosterM2, HD, {
  PRIMARY: {
    width: 247,
    height: 139
  }
}), (0,defineProperty/* default */.Z)(_templates$PosterM2, FULL_HD, {
  PRIMARY: {
    width: 381,
    height: 214
  }
}), _templates$PosterM2)), (0,defineProperty/* default */.Z)(_imageOptions, poster_constants_templates.PosterL, (_templates$PosterL2 = {}, (0,defineProperty/* default */.Z)(_templates$PosterL2, HD, {
  PRIMARY: {
    width: 333,
    height: 187
  }
}), (0,defineProperty/* default */.Z)(_templates$PosterL2, FULL_HD, {
  PRIMARY: {
    width: 512,
    height: 288
  }
}), _templates$PosterL2)), _imageOptions);
;// CONCATENATED MODULE: ./src/modules/tornado/poster/poster.constants.js

;// CONCATENATED MODULE: ./src/modules/tornado/poster/poster.style.js


var _PADDING_TOP, _PADDING_RIGHT, _PADDING_LEFT, _PADDING_BOTTOM, poster_style_ICON_HEIGHT, _IMAGE_OFFSET;
function poster_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function poster_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? poster_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : poster_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }










var poster_style_defaultContext = makeDefaultStylingContext();
var PADDING_TOP = (_PADDING_TOP = {}, (0,defineProperty/* default */.Z)(_PADDING_TOP, HD, 4), (0,defineProperty/* default */.Z)(_PADDING_TOP, FULL_HD, 4), _PADDING_TOP);
var PADDING_RIGHT = (_PADDING_RIGHT = {}, (0,defineProperty/* default */.Z)(_PADDING_RIGHT, HD, 12), (0,defineProperty/* default */.Z)(_PADDING_RIGHT, FULL_HD, 16), _PADDING_RIGHT);
var PADDING_LEFT = (_PADDING_LEFT = {}, (0,defineProperty/* default */.Z)(_PADDING_LEFT, HD, 12), (0,defineProperty/* default */.Z)(_PADDING_LEFT, FULL_HD, 16), _PADDING_LEFT);
var PADDING_BOTTOM = (_PADDING_BOTTOM = {}, (0,defineProperty/* default */.Z)(_PADDING_BOTTOM, HD, 8), (0,defineProperty/* default */.Z)(_PADDING_BOTTOM, FULL_HD, 12), _PADDING_BOTTOM);
var ICON_PADDING_VERTICAL = 4;
var ICON_PADDING_HORIZONTAL = 8;
var poster_poster_style_ICON_HEIGHT = (poster_style_ICON_HEIGHT = {}, (0,defineProperty/* default */.Z)(poster_style_ICON_HEIGHT, HD, 24), (0,defineProperty/* default */.Z)(poster_style_ICON_HEIGHT, FULL_HD, 32), poster_style_ICON_HEIGHT);
var IMAGE_OFFSET = (_IMAGE_OFFSET = {}, (0,defineProperty/* default */.Z)(_IMAGE_OFFSET, HD, focus_BORDER_WIDTH[HD] * 2), (0,defineProperty/* default */.Z)(_IMAGE_OFFSET, FULL_HD, focus_BORDER_WIDTH[FULL_HD] * 2), _IMAGE_OFFSET);
var getDetailsPosition = memoize_default()(function (screenSize) {
  var hasHighlightText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var hasCsa = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return hasHighlightText ? {
    mountX: 1,
    x: function x(_x) {
      return _x - PADDING_RIGHT[screenSize] - (hasCsa ? poster_poster_style_ICON_HEIGHT[screenSize] + ICON_PADDING_HORIZONTAL : 0);
    }
  } : {
    mountX: 0,
    x: PADDING_LEFT[screenSize]
  };
}, function (screenSize, hasHighlightText, hasCsa) {
  return "".concat(screenSize, "_").concat(hasHighlightText, "_").concat(hasCsa);
});
var getIcon = function getIcon(icons, position) {
  return icons ? icons[ICONS[position]] : null;
};
var poster_style_colors = {
  border: poster_constants_BORDER_COLOR,
  innerBorder: poster_constants_INNER_BORDER_COLOR,
  text: makeThemeColor(PRIMARY),
  details: makeThemeColor(PRIMARY, 0.6),
  highlight: HIGHLIGHT_COLOR
};
var poster_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : poster_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  var titleFont = src_getFont(TITLE_FONT_NAME, screenSize, poster_constants_TITLE_FONT_TYPE);
  var extraTitleFont = src_getFont(EXTRA_TITLE_FONT_NAME, screenSize);
  var commonFont = src_getFont(constants_FONT.BERLIN_1, screenSize);
  var commonTextStyle = {
    verticalAlign: 'middle',
    maxLines: 1,
    textOverflow: 'ellipsis',
    maxLinesSuffix: '...',
    wordWrap: false
  };
  return {
    zIndex: UNFOCUSED_Z_INDEX,
    Border: {
      x: -focus_BORDER_WIDTH[screenSize],
      y: -focus_BORDER_WIDTH[screenSize],
      color: colors_TRANSPARENT,
      shader: {
        radius: rtlde_focus_BORDER_RADIUS[screenSize],
        outline: focus_BORDER_WIDTH[screenSize],
        strokeColor: colors_TRANSPARENT,
        innerColor: colors_TRANSPARENT
      }
    },
    Image: {
      shader: {
        radius: rtlde_focus_BORDER_RADIUS[screenSize],
        progressHeight: progress_style_HEIGHT,
        progressBackgroundColor: progress_style_colors.background[colorMode],
        progressBarColor: progress_style_colors.bar[colorMode],
        overlayColor: POSTER_OVERLAY[colorMode]
      }
    },
    ExtraTitle: {
      text: poster_style_objectSpread(poster_style_objectSpread({}, extraTitleFont), commonTextStyle),
      color: poster_style_colors.text[colorMode]
    },
    Title: {
      text: poster_style_objectSpread(poster_style_objectSpread({}, titleFont), commonTextStyle),
      color: poster_style_colors.text[colorMode]
    },
    Details: poster_style_objectSpread(poster_style_objectSpread({}, getDetailsPosition(screenSize)), {}, {
      text: poster_style_objectSpread(poster_style_objectSpread({}, commonFont), commonTextStyle),
      color: poster_style_colors.details[colorMode]
    }),
    Highlights: {
      text: poster_style_objectSpread(poster_style_objectSpread({}, commonFont), commonTextStyle),
      color: poster_style_colors.highlight[colorMode]
    },
    TopLeftIcon: {
      visible: DISPLAY_ICONS,
      x: ICON_PADDING_HORIZONTAL,
      y: ICON_PADDING_VERTICAL
    },
    TopRightIcon: {
      visible: DISPLAY_ICONS,
      mountX: 1,
      x: function x(w) {
        return w - ICON_PADDING_HORIZONTAL;
      },
      y: ICON_PADDING_VERTICAL
    },
    BottomRightIcon: {
      visible: DISPLAY_ICONS,
      mountX: 1,
      x: function x(w) {
        return w - ICON_PADDING_HORIZONTAL;
      },
      y: function y(h) {
        return h - PADDING_BOTTOM[screenSize] - poster_poster_style_ICON_HEIGHT[screenSize];
      },
      alpha: 0.8
    },
    Incentive: {
      x: middle,
      y: middle,
      mount: 0.5
    }
  };
};
var getIconViewBox = memoize_default()(function (screenSize) {
  return {
    h: poster_poster_style_ICON_HEIGHT[screenSize]
  };
});
var poster_style_getFocusedStyle = memoize_default()(function (_ref) {
  var colorMode = _ref.colorMode;
  return {
    zIndex: FOCUSED_Z_INDEX,
    Border: {
      smooth: {
        scale: focus_SCALE_FOCUSED,
        'shader.strokeColor': poster_style_colors.border[colorMode],
        'shader.innerColor': poster_style_colors.innerBorder[colorMode],
        'shader.scale': focus_SCALE_FOCUSED
      }
    },
    Image: {
      smooth: {
        scale: focus_SCALE_FOCUSED,
        'shader.scale': focus_SCALE_FOCUSED
      }
    }
  };
}, cacheResolver);
var unFocusedStyle = {
  zIndex: UNFOCUSED_Z_INDEX,
  Border: {
    smooth: {
      scale: 1,
      'shader.strokeColor': colors_TRANSPARENT,
      'shader.innerColor': colors_TRANSPARENT,
      'shader.scale': 1.0
    }
  },
  Image: {
    smooth: {
      scale: 1,
      'shader.scale': 1.0
    }
  }
};
;// CONCATENATED MODULE: ./src/modules/tornado/poster/poster.component.js








function poster_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function poster_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? poster_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : poster_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function poster_component_createSuper(t) { var r = poster_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function poster_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (poster_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }















var Poster = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Poster, _Lightning$Component);
  var _super = poster_component_createSuper(Poster);
  function Poster() {
    (0,classCallCheck/* default */.Z)(this, Poster);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Poster, [{
    key: "_construct",
    value: function _construct() {
      this._index = 0;
      this._style = poster_component_objectSpread({}, poster_style_defaultContext);
    }
  }, {
    key: "_inactive",
    value: function _inactive() {
      this.signal(INACTIVE_SIGNAL, this);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this._item = undefined;
      this.signal(DETACHED_SIGNAL, this);
    }
  }, {
    key: "index",
    get: function get() {
      return this._index;
    },
    set: function set(value) {
      this._index = value;
    }
  }, {
    key: "item",
    get: function get() {
      return this._item;
    },
    set: function set(_ref) {
      var content = _ref.content,
        config = _ref.config,
        template = _ref.template,
        _ref$colorScheme = _ref.colorScheme,
        colorScheme = _ref$colorScheme === void 0 ? this._style.colorMode : _ref$colorScheme;
      var templateDataAccessPath = [template, this._style.screenSize];
      var progress = getProgress(content.progress);
      if (areContentItemsEqual(this._item, content)) {
        this._item = content;
        this.patch({
          Image: {
            shader: {
              progress: progress
            }
          }
        });
        return;
      }
      this._item = content;
      this._config = config || get_default()(poster_constants_sizes, templateDataAccessPath, {});
      if (colorScheme && colorScheme !== this._style.colorMode) {
        this._style = {
          screenSize: this._style.screenSize,
          colorMode: colorScheme
        };
      }
      var screenSize = this._style.screenSize;
      var _this$_item = this._item,
        title = _this$_item.title,
        extraTitle = _this$_item.extraTitle,
        details = _this$_item.details,
        highlight = _this$_item.highlight,
        pictos = _this$_item.pictos,
        incentives = _this$_item.incentives;
      var bottomRightIcon = getIcon(pictos, ICON_POSITION.BOTTOM_RIGHT);
      var wordWrapWidth = this._config.w - PADDING_LEFT[screenSize] - (bottomRightIcon ? poster_poster_style_ICON_HEIGHT[screenSize] + ICON_PADDING_HORIZONTAL * 2 : PADDING_LEFT[screenSize]);
      var wordWrapWidthFlexible = details ? Math.round(wordWrapWidth / 2) : wordWrapWidth;
      var imageUrl = get_default()(this._item, 'image.src', '');
      var textColor = poster_style_colors.text[colorScheme];
      var borderOffset = IMAGE_OFFSET[screenSize];
      var incentiveLines = getLinesCount(this._item.incentives);
      this.patch({
        Border: {
          w: this._config.w + borderOffset,
          h: this._config.h + borderOffset
        },
        Image: {
          w: this._config.w,
          h: this._config.h,
          src: imageUrl,
          shader: {
            progress: progress,
            overlayColor: shouldDisplayTreatment(this._item) ? POSTER_OVERLAY[this._style.colorMode] : colors_TRANSPARENT
          }
        },
        ExtraTitle: makeTextPatch(DISPLAY_EXTRA_TITLE ? extraTitle : '', wordWrapWidth, textColor),
        Title: makeTextPatch(DISPLAY_TITLE ? title : '', wordWrapWidth, textColor),
        Details: makeTextPatch(details, wordWrapWidthFlexible, poster_style_colors.details[colorScheme]),
        Highlights: makeTextPatch(highlight, wordWrapWidthFlexible, poster_style_colors.highlight[colorScheme]),
        TopLeftIcon: {
          iconData: {
            picto: getIcon(pictos, ICON_POSITION.TOP_LEFT),
            viewBox: getIconViewBox(this._style.screenSize)
          }
        },
        TopRightIcon: {
          iconData: {
            picto: getIcon(pictos, ICON_POSITION.TOP_RIGHT),
            viewBox: getIconViewBox(this._style.screenSize)
          }
        },
        BottomRightIcon: {
          iconData: {
            picto: getIcon(pictos, ICON_POSITION.BOTTOM_RIGHT),
            viewBox: getIconViewBox(this._style.screenSize)
          }
        },
        Incentive: {
          visible: incentiveLines > 0,
          data: {
            w: this._config.w,
            linesCount: incentiveLines,
            incentives: incentives,
            colorMode: this._style.colorMOde,
            alignment: ALIGNMENT_VERTICAL
          }
        }
      });
      this._updateMetadataPosition();
    }
  }, {
    key: "_updateMetadataPosition",
    value: function _updateMetadataPosition() {
      var paddingBottom = PADDING_BOTTOM[this._style.screenSize];
      var paddingLeft = PADDING_LEFT[this._style.screenSize];
      var offset = this._config.h - paddingBottom;
      var _TITLES_ORDER = (0,slicedToArray/* default */.Z)(TITLES_ORDER, 2),
        firstLineTag = _TITLES_ORDER[0],
        secondLineTag = _TITLES_ORDER[1];
      var firstLine = this.tag(firstLineTag);
      var secondLine = this.tag(secondLineTag);
      var details = this.tag('Details');
      var highlights = this.tag('Highlights');
      var bottomRightIcon = this.tag('BottomRightIcon');
      if (details.visible || highlights.visible) {
        offset -= details.text.lineHeight;
        details.patch(getDetailsPosition(this._style.screenSize, highlights.visible, Boolean(bottomRightIcon.name)));
        details.y = offset;
        highlights.x = paddingLeft;
        highlights.y = offset;
      }
      if (secondLine.visible) {
        offset -= secondLine.text.lineHeight;
        secondLine.x = paddingLeft;
        secondLine.y = offset;
      }
      if (firstLine.visible) {
        offset -= firstLine.text.lineHeight;
        firstLine.x = paddingLeft;
        firstLine.y = offset;
      }
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this.patch(poster_style_getFocusedStyle(this._style));
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this.patch(unFocusedStyle);
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      this.signal(SELECTED_SIGNAL, this._item);
      return true;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Border: {
          rect: true,
          shader: {
            type: focus_shader
          }
        },
        Image: {
          shader: {
            type: ImageShader
          }
        },
        TopLeftIcon: {
          type: ICONS_TYPES[ICON_POSITION.TOP_LEFT]
        },
        TopRightIcon: {
          type: ICONS_TYPES[ICON_POSITION.TOP_RIGHT]
        },
        BottomRightIcon: {
          type: ICONS_TYPES[ICON_POSITION.BOTTOM_RIGHT]
        },
        ExtraTitle: {},
        Title: {},
        Details: {},
        Highlights: {},
        Incentive: {
          type: Incentive
        }
      }, poster_style_getInitialStyle());
    }
  }]);
  return Poster;
}(src_Lightning.Component);

Poster.Templates = poster_constants_templates;
Poster.Sizes = poster_constants_sizes;
Poster.ImageOptions = imageOptions;
;// CONCATENATED MODULE: ./src/modules/tornado/portrait/customer/rtlde/portrait.constants.js

var portrait_constants_ICONS, portrait_constants_ICONS_TYPES;



var rtlde_portrait_constants_ICONS = (portrait_constants_ICONS = {}, (0,defineProperty/* default */.Z)(portrait_constants_ICONS, ICON_POSITION.TOP_RIGHT, 4), (0,defineProperty/* default */.Z)(portrait_constants_ICONS, ICON_POSITION.BOTTOM_RIGHT, 1), portrait_constants_ICONS);
var rtlde_portrait_constants_ICONS_TYPES = (portrait_constants_ICONS_TYPES = {}, (0,defineProperty/* default */.Z)(portrait_constants_ICONS_TYPES, ICON_POSITION.TOP_LEFT, Icon), (0,defineProperty/* default */.Z)(portrait_constants_ICONS_TYPES, ICON_POSITION.TOP_RIGHT, Badge), (0,defineProperty/* default */.Z)(portrait_constants_ICONS_TYPES, ICON_POSITION.BOTTOM_RIGHT, Icon), portrait_constants_ICONS_TYPES);
var DISPLAY_PROGRESS = true;
var DISPLAY_TEXT = true;
;// CONCATENATED MODULE: ./src/modules/tornado/portrait/portrait.constants.js

var _templates$Portrait, _templates$Portrait2;


var portrait_constants_templates = {
  Portrait: 'Portrait'
};
var portrait_constants_sizes = (0,defineProperty/* default */.Z)({}, portrait_constants_templates.Portrait, (_templates$Portrait = {}, (0,defineProperty/* default */.Z)(_templates$Portrait, HD, {
  w: 195,
  h: 293
}), (0,defineProperty/* default */.Z)(_templates$Portrait, FULL_HD, {
  w: 250,
  h: 375
}), _templates$Portrait));
var portrait_constants_imageOptions = (0,defineProperty/* default */.Z)({}, portrait_constants_templates.Portrait, (_templates$Portrait2 = {}, (0,defineProperty/* default */.Z)(_templates$Portrait2, HD, {
  PRIMARY: {
    width: 195,
    height: 293
  }
}), (0,defineProperty/* default */.Z)(_templates$Portrait2, FULL_HD, {
  PRIMARY: {
    width: 250,
    height: 375
  }
}), _templates$Portrait2));
;// CONCATENATED MODULE: ./src/modules/tornado/portrait/portrait.style.js

var portrait_style_ICON_HEIGHT;
function portrait_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function portrait_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? portrait_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : portrait_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }











var portrait_style_defaultContext = makeDefaultStylingContext();
var portrait_portrait_style_ICON_HEIGHT = (portrait_style_ICON_HEIGHT = {}, (0,defineProperty/* default */.Z)(portrait_style_ICON_HEIGHT, HD, 24), (0,defineProperty/* default */.Z)(portrait_style_ICON_HEIGHT, FULL_HD, 32), portrait_style_ICON_HEIGHT);
var PADDING_VERTICAL = 4;
var PADDING_HORIZONTAL = 8;
var TEXT_MARGIN_BOTTOM = 8;
var portrait_style_colors = {
  text: makeThemeColor(PRIMARY),
  overlay: makeThemeColor(TERTIARY)
};
var portrait_style_getIconViewBox = memoize_default()(function (screenSize) {
  return {
    h: portrait_portrait_style_ICON_HEIGHT[screenSize]
  };
});
var portrait_style_getIcon = function getIcon(icons, position) {
  return icons ? icons[rtlde_portrait_constants_ICONS[position]] : null;
};
var portrait_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : portrait_style_defaultContext,
    screenSize = _ref.screenSize,
    colorMode = _ref.colorMode;
  var _sizes$templates$Port = portrait_constants_sizes[portrait_constants_templates.Portrait][screenSize],
    w = _sizes$templates$Port.w,
    h = _sizes$templates$Port.h;
  var borderSize = focus_BORDER_WIDTH[screenSize];
  var borderOffset = borderSize * 2;
  return {
    w: w,
    h: h,
    Border: {
      w: w + borderOffset,
      h: h + borderOffset,
      x: -borderSize,
      y: -borderSize,
      color: colors_TRANSPARENT,
      shader: {
        radius: rtlde_focus_BORDER_RADIUS[screenSize],
        outline: focus_BORDER_WIDTH[screenSize],
        strokeColor: colors_TRANSPARENT,
        innerColor: colors_TRANSPARENT
      }
    },
    Image: {
      w: w,
      h: h,
      shader: {
        radius: rtlde_focus_BORDER_RADIUS[screenSize],
        progressHeight: progress_style_HEIGHT,
        progressBackgroundColor: progress_style_colors.background[colorMode],
        progressBarColor: progress_style_colors.bar[colorMode],
        overlayColor: portrait_style_colors.overlay[colorMode]
      }
    },
    Text: {
      x: Math.round(w / 2),
      y: h - progress_style_HEIGHT - TEXT_MARGIN_BOTTOM,
      mountX: 0.5,
      mountY: 1,
      color: portrait_style_colors.text[colorMode],
      text: portrait_style_objectSpread(portrait_style_objectSpread({}, src_getFont(constants_FONT.BOSTON_1, screenSize)), {}, {
        verticalAlign: 'middle',
        wordWrapWidth: w - PADDING_HORIZONTAL * 2
      })
    },
    TopLeftIcon: {
      x: PADDING_HORIZONTAL,
      y: PADDING_VERTICAL
    },
    TopRightIcon: {
      alpha: 0.8,
      mountX: 1,
      x: w,
      y: PADDING_VERTICAL
    },
    BottomRightIcon: {
      mount: 1,
      x: w,
      y: h - progress_style_HEIGHT - PADDING_VERTICAL
    },
    Incentive: {
      x: middle,
      y: middle,
      mount: 0.5
    }
  };
};
var portrait_style_getFocusedStyle = memoize_default()(function (_ref2) {
  var colorMode = _ref2.colorMode;
  return {
    Border: {
      smooth: {
        scale: focus_SCALE_FOCUSED,
        'shader.strokeColor': BORDER_COLOR[colorMode],
        'shader.innerColor': INNER_BORDER_COLOR[colorMode],
        'shader.scale': focus_SCALE_FOCUSED
      }
    },
    Image: {
      smooth: {
        scale: focus_SCALE_FOCUSED,
        'shader.scale': focus_SCALE_FOCUSED
      }
    }
  };
}, cacheResolver);
var portrait_style_unFocusedStyle = {
  Border: {
    smooth: {
      scale: 1,
      'shader.strokeColor': colors_TRANSPARENT,
      'shader.innerColor': colors_TRANSPARENT,
      'shader.scale': 1.0
    }
  },
  Image: {
    smooth: {
      scale: 1,
      'shader.scale': 1.0
    }
  }
};
;// CONCATENATED MODULE: ./src/modules/tornado/portrait/portrait.component.js





function portrait_component_createSuper(t) { var r = portrait_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function portrait_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (portrait_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }













var Portrait = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Portrait, _Lightning$Component);
  var _super = portrait_component_createSuper(Portrait);
  function Portrait() {
    (0,classCallCheck/* default */.Z)(this, Portrait);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Portrait, [{
    key: "_construct",
    value: function _construct() {
      this._style = portrait_style_defaultContext;
    }
  }, {
    key: "_inactive",
    value: function _inactive() {
      this.signal(INACTIVE_SIGNAL, this);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this._item = undefined;
      this.signal(DETACHED_SIGNAL, this);
    }
  }, {
    key: "item",
    get: function get() {
      return this._item;
    },
    set: function set(_ref) {
      var content = _ref.content,
        config = _ref.config,
        template = _ref.template,
        colorScheme = _ref.colorScheme;
      var templateDataAccessPath = [template, this._style.screenSize];
      var progress = DISPLAY_PROGRESS ? getProgress(content.progress) : 0;
      if (areContentItemsEqual(this._item, content)) {
        this._item = content;
        this.patch({
          Image: {
            shader: {
              progress: progress
            }
          }
        });
        return;
      }
      this._item = content;
      this._config = config || get_default()(portrait_constants_sizes, templateDataAccessPath, {});
      var h = this._config.h;
      var _this$_item = this._item,
        pictos = _this$_item.pictos,
        incentives = _this$_item.incentives;
      var screenSize = this._style.screenSize;
      var extraTitle = DISPLAY_TEXT ? this._item.extraTitle : '';
      var imageUrl = get_default()(this._item, 'image.src', '');
      var viewBox = portrait_style_getIconViewBox(screenSize);
      var incentiveLines = getLinesCount(this._item.incentives);
      if (colorScheme && colorScheme !== this._style.colorMode) {
        this._style = {
          screenSize: screenSize,
          colorMode: colorScheme
        };
      }
      this.patch({
        Image: {
          src: imageUrl,
          shader: {
            progress: progress
          }
        },
        Text: {
          y: h - (progress ? progress_style_HEIGHT : 0) - TEXT_MARGIN_BOTTOM,
          text: {
            text: extraTitle || ''
          }
        },
        TopLeftIcon: {
          iconData: {
            picto: portrait_style_getIcon(pictos, ICON_POSITION.TOP_LEFT),
            viewBox: viewBox
          }
        },
        TopRightIcon: {
          iconData: {
            picto: portrait_style_getIcon(pictos, ICON_POSITION.TOP_RIGHT),
            viewBox: viewBox
          }
        },
        BottomRightIcon: {
          iconData: {
            picto: portrait_style_getIcon(pictos, ICON_POSITION.BOTTOM_RIGHT),
            viewBox: viewBox
          }
        },
        Incentive: {
          visible: incentiveLines > 0,
          data: {
            w: this._config.w,
            linesCount: incentiveLines,
            incentives: incentives,
            colorMode: this._style.colorMOde,
            alignment: ALIGNMENT_VERTICAL
          }
        }
      });
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this.patch(portrait_style_getFocusedStyle(this._style));
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this.patch(portrait_style_unFocusedStyle);
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      this.signal(SELECTED_SIGNAL, this._item);
      return true;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Border: {
          rect: true,
          shader: {
            type: focus_shader
          }
        },
        Image: {
          shader: {
            type: ImageShader
          }
        },
        TopLeftIcon: {
          type: rtlde_portrait_constants_ICONS_TYPES[ICON_POSITION.TOP_LEFT]
        },
        TopRightIcon: {
          type: rtlde_portrait_constants_ICONS_TYPES[ICON_POSITION.TOP_RIGHT]
        },
        BottomRightIcon: {
          type: rtlde_portrait_constants_ICONS_TYPES[ICON_POSITION.BOTTOM_RIGHT]
        },
        Incentive: {
          type: Incentive
        }
      }, portrait_style_getInitialStyle());
    }
  }]);
  return Portrait;
}(src_Lightning.Component);

Portrait.Templates = portrait_constants_templates;
Portrait.Sizes = portrait_constants_sizes;
Portrait.ImageOptions = portrait_constants_imageOptions;
;// CONCATENATED MODULE: ./src/modules/tornado/jacket/customer/rtlde/jacket.constants.js

var jacket_constants_ICONS, jacket_constants_ICONS_TYPES;



var rtlde_jacket_constants_ICONS = (jacket_constants_ICONS = {}, (0,defineProperty/* default */.Z)(jacket_constants_ICONS, ICON_POSITION.TOP_LEFT, 2), (0,defineProperty/* default */.Z)(jacket_constants_ICONS, ICON_POSITION.TOP_RIGHT, 4), jacket_constants_ICONS);
var rtlde_jacket_constants_ICONS_TYPES = (jacket_constants_ICONS_TYPES = {}, (0,defineProperty/* default */.Z)(jacket_constants_ICONS_TYPES, ICON_POSITION.TOP_LEFT, Icon), (0,defineProperty/* default */.Z)(jacket_constants_ICONS_TYPES, ICON_POSITION.TOP_RIGHT, Badge), (0,defineProperty/* default */.Z)(jacket_constants_ICONS_TYPES, ICON_POSITION.BOTTOM_RIGHT, Icon), jacket_constants_ICONS_TYPES);
var jacket_constants_DISPLAY_PROGRESS = true;
;// CONCATENATED MODULE: ./src/modules/tornado/jacket/jacket.constants.js

var _templates$Jacket, _templates$Jacket2;


var jacket_constants_templates = {
  Jacket: 'Jacket'
};
var jacket_constants_sizes = (0,defineProperty/* default */.Z)({}, jacket_constants_templates.Jacket, (_templates$Jacket = {}, (0,defineProperty/* default */.Z)(_templates$Jacket, HD, {
  w: 195,
  h: 260
}), (0,defineProperty/* default */.Z)(_templates$Jacket, FULL_HD, {
  w: 250,
  h: 333
}), _templates$Jacket));
var jacket_constants_imageOptions = (0,defineProperty/* default */.Z)({}, jacket_constants_templates.Jacket, (_templates$Jacket2 = {}, (0,defineProperty/* default */.Z)(_templates$Jacket2, HD, {
  PRIMARY: {
    width: 195,
    height: 260
  }
}), (0,defineProperty/* default */.Z)(_templates$Jacket2, FULL_HD, {
  PRIMARY: {
    width: 250,
    height: 333
  }
}), _templates$Jacket2));
;// CONCATENATED MODULE: ./src/modules/tornado/jacket/jacket.style.js

var jacket_style_ICON_HEIGHT, _LOCK_ICON_HEIGHT;
function jacket_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function jacket_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? jacket_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : jacket_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }







var jacket_style_defaultContext = makeDefaultStylingContext();
var jacket_style_ICON_PADDING_VERTICAL = 4;
var jacket_style_ICON_PADDING_HORIZONTAL = 8;
var jacket_jacket_style_ICON_HEIGHT = (jacket_style_ICON_HEIGHT = {}, (0,defineProperty/* default */.Z)(jacket_style_ICON_HEIGHT, HD, 24), (0,defineProperty/* default */.Z)(jacket_style_ICON_HEIGHT, FULL_HD, 32), jacket_style_ICON_HEIGHT);
var LOCK_ICON_HEIGHT = (_LOCK_ICON_HEIGHT = {}, (0,defineProperty/* default */.Z)(_LOCK_ICON_HEIGHT, HD, 32), (0,defineProperty/* default */.Z)(_LOCK_ICON_HEIGHT, FULL_HD, 40), _LOCK_ICON_HEIGHT);
var jacket_style_PADDING_VERTICAL = 4;
var jacket_style_PADDING_HORIZONTAL = 8;
var jacket_style_getIconViewBox = memoize_default()(function (screenSize) {
  return {
    h: jacket_jacket_style_ICON_HEIGHT[screenSize]
  };
});
var jacket_style_getIcon = function getIcon(icons, position) {
  return icons ? icons[rtlde_jacket_constants_ICONS[position]] : null;
};
var jacket_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : jacket_style_defaultContext,
    screenSize = _ref.screenSize;
  var _sizes$templates$Jack = jacket_constants_sizes[jacket_constants_templates.Jacket][screenSize],
    w = _sizes$templates$Jack.w,
    h = _sizes$templates$Jack.h;
  var borderSize = focus_BORDER_WIDTH[screenSize];
  var borderOffset = borderSize * 2;
  return {
    Border: {
      w: w + borderOffset,
      h: h + borderOffset,
      x: -borderSize,
      y: -borderSize,
      color: colors_TRANSPARENT,
      shader: {
        radius: rtlde_focus_BORDER_RADIUS[screenSize],
        outline: focus_BORDER_WIDTH[screenSize],
        strokeColor: colors_TRANSPARENT,
        innerColor: colors_TRANSPARENT
      }
    },
    Image: jacket_style_objectSpread(jacket_style_objectSpread({}, jacket_constants_sizes[screenSize]), {}, {
      shader: {
        radius: rtlde_focus_BORDER_RADIUS[screenSize]
      }
    }),
    TopLeftIcon: {
      x: jacket_style_PADDING_HORIZONTAL,
      y: jacket_style_PADDING_VERTICAL
    },
    TopRightIcon: {
      alpha: 0.8,
      x: w - jacket_style_PADDING_HORIZONTAL - jacket_jacket_style_ICON_HEIGHT[screenSize],
      y: h - jacket_style_PADDING_VERTICAL - jacket_jacket_style_ICON_HEIGHT[screenSize]
    },
    BottomRightIcon: {
      mountX: 1,
      x: w - jacket_style_PADDING_HORIZONTAL,
      y: jacket_style_PADDING_VERTICAL
    },
    Incentive: {
      x: middle,
      y: middle,
      mount: 0.5
    }
  };
};
var jacket_style_getFocusedStyle = memoize_default()(function (_ref2) {
  var colorMode = _ref2.colorMode;
  return {
    Border: {
      smooth: {
        scale: focus_SCALE_FOCUSED,
        'shader.strokeColor': BORDER_COLOR[colorMode],
        'shader.innerColor': INNER_BORDER_COLOR[colorMode],
        'shader.scale': focus_SCALE_FOCUSED
      }
    },
    Image: {
      smooth: {
        scale: focus_SCALE_FOCUSED,
        'shader.scale': focus_SCALE_FOCUSED
      }
    }
  };
}, cacheResolver);
var jacket_style_unFocusedStyle = {
  Border: {
    smooth: {
      scale: 1,
      'shader.strokeColor': colors_TRANSPARENT,
      'shader.innerColor': colors_TRANSPARENT,
      'shader.scale': 1.0
    }
  },
  Image: {
    smooth: {
      scale: 1,
      'shader.scale': 1.0
    }
  }
};
;// CONCATENATED MODULE: ./src/modules/tornado/jacket/jacket.component.js





function jacket_component_createSuper(t) { var r = jacket_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function jacket_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (jacket_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }












var Jacket = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Jacket, _Lightning$Component);
  var _super = jacket_component_createSuper(Jacket);
  function Jacket() {
    (0,classCallCheck/* default */.Z)(this, Jacket);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Jacket, [{
    key: "_construct",
    value: function _construct() {
      this._style = jacket_style_defaultContext;
    }
  }, {
    key: "_inactive",
    value: function _inactive() {
      this.signal(INACTIVE_SIGNAL, this);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this._item = undefined;
      this.signal(DETACHED_SIGNAL, this);
    }
  }, {
    key: "item",
    get: function get() {
      return this._item;
    },
    set: function set(_ref) {
      var content = _ref.content,
        config = _ref.config,
        template = _ref.template,
        colorScheme = _ref.colorScheme;
      var templateDataAccessPath = [template, this._style.screenSize];
      if (this._item && this._item.id === content.id) {
        this._item = content;
        return;
      }
      this._item = content;
      this._config = config || get_default()(jacket_constants_sizes, templateDataAccessPath, {});
      var _this$_item = this._item,
        pictos = _this$_item.pictos,
        image = _this$_item.image,
        incentives = _this$_item.incentives;
      var imageUrl = image && image.src || '';
      var screenSize = this._style.screenSize;
      var viewBox = jacket_style_getIconViewBox(screenSize);
      var incentiveLines = getLinesCount(incentives);
      this._style = {
        screenSize: screenSize,
        colorMode: colorScheme
      };
      this.patch({
        Image: {
          src: imageUrl
        },
        TopLeftIcon: {
          iconData: {
            picto: jacket_style_getIcon(pictos, ICON_POSITION.TOP_LEFT),
            viewBox: viewBox
          }
        },
        TopRightIcon: {
          iconData: {
            picto: jacket_style_getIcon(pictos, ICON_POSITION.TOP_RIGHT),
            viewBox: viewBox
          }
        },
        BottomRightIcon: {
          iconData: {
            picto: jacket_style_getIcon(pictos, ICON_POSITION.BOTTOM_RIGHT),
            viewBox: viewBox
          }
        },
        Incentive: {
          visible: incentiveLines > 0,
          data: {
            linesCount: incentiveLines,
            w: this._config.w,
            incentives: incentives,
            colorMode: this._style.colorMOde,
            alignment: ALIGNMENT_VERTICAL
          }
        }
      });
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this.patch(jacket_style_getFocusedStyle(this._style));
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this.patch(jacket_style_unFocusedStyle);
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      this.signal(SELECTED_SIGNAL, this._item);
      return true;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Border: {
          rect: true,
          shader: {
            type: focus_shader
          }
        },
        Image: {
          shader: {
            type: ImageShader
          }
        },
        TopLeftIcon: {
          type: rtlde_jacket_constants_ICONS_TYPES[ICON_POSITION.TOP_LEFT]
        },
        TopRightIcon: {
          type: rtlde_jacket_constants_ICONS_TYPES[ICON_POSITION.TOP_RIGHT]
        },
        BottomRightIcon: {
          type: rtlde_jacket_constants_ICONS_TYPES[ICON_POSITION.BOTTOM_RIGHT]
        },
        Incentive: {
          type: Incentive
        }
      }, jacket_style_getInitialStyle());
    }
  }]);
  return Jacket;
}(src_Lightning.Component);

Jacket.Templates = jacket_constants_templates;
Jacket.Sizes = jacket_constants_sizes;
Jacket.ImageOptions = jacket_constants_imageOptions;
;// CONCATENATED MODULE: ./src/modules/tornado/card/customer/rtlde/card.constants.js


var card_constants_ICONS, card_constants_ICONS_TYPES, _metadataHeight, _templates$CardS, _templates$CardM, _templates$CardL, card_constants_imageOptions;
function card_constants_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function card_constants_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? card_constants_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : card_constants_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }







var card_constants_DISPLAY_ICONS = true;
var card_constants_DISPLAY_TITLE = true;
var card_constants_DISPLAY_EXTRA_TITLE = true;
var DISPLAY_DETAILS = false;
var IMAGE_MARGIN_BOTTOM = 8;
var card_constants_EXTRA_TITLE_FONT_NAME = constants_FONT.OTTAWA_3;
var EXTRA_TITLE_FONT_TYPE = FONT_TYPE.MAIN;
var card_constants_TITLE_FONT_NAME = constants_FONT.MADRID_3;
var card_constants_TITLE_FONT_TYPE = FONT_TYPE.MAIN;
var card_constants_TITLES_ORDER = ['ExtraTitle', 'Title'];
var EXTRA_TITLE_LINES = 2;
var card_constants_BORDER_COLOR = makeThemeColor(PRIMARY);
var card_constants_INNER_BORDER_COLOR = makeThemeColor(TERTIARY);
var card_constants_HIGHLIGHT_COLOR = makeThemeColor(QUATERNARY);
var rtlde_card_constants_ICONS = (card_constants_ICONS = {}, (0,defineProperty/* default */.Z)(card_constants_ICONS, ICON_POSITION.TOP_LEFT, 2), (0,defineProperty/* default */.Z)(card_constants_ICONS, ICON_POSITION.TOP_RIGHT, 4), (0,defineProperty/* default */.Z)(card_constants_ICONS, ICON_POSITION.BOTTOM_RIGHT, 1), card_constants_ICONS);
var rtlde_card_constants_ICONS_TYPES = (card_constants_ICONS_TYPES = {}, (0,defineProperty/* default */.Z)(card_constants_ICONS_TYPES, ICON_POSITION.TOP_LEFT, Icon), (0,defineProperty/* default */.Z)(card_constants_ICONS_TYPES, ICON_POSITION.TOP_RIGHT, Badge), (0,defineProperty/* default */.Z)(card_constants_ICONS_TYPES, ICON_POSITION.BOTTOM_RIGHT, Icon), card_constants_ICONS_TYPES);
var card_constants_templates = {
  CardS: 'CardS',
  CardM: 'CardM',
  CardL: 'CardL'
};
var metadataHeight = (_metadataHeight = {}, (0,defineProperty/* default */.Z)(_metadataHeight, HD, incentive_incentive_style_HEIGHT[HD] + src_getFont(card_constants_EXTRA_TITLE_FONT_NAME, HD, EXTRA_TITLE_FONT_TYPE).lineHeight * EXTRA_TITLE_LINES + src_getFont(card_constants_TITLE_FONT_NAME, HD, card_constants_TITLE_FONT_TYPE).lineHeight + src_getFont(constants_FONT.BERLIN_1, HD).lineHeight + IMAGE_MARGIN_BOTTOM), (0,defineProperty/* default */.Z)(_metadataHeight, FULL_HD, incentive_incentive_style_HEIGHT[FULL_HD] + src_getFont(card_constants_EXTRA_TITLE_FONT_NAME, FULL_HD, EXTRA_TITLE_FONT_TYPE).lineHeight * EXTRA_TITLE_LINES + src_getFont(card_constants_TITLE_FONT_NAME, FULL_HD, card_constants_TITLE_FONT_TYPE).lineHeight + src_getFont(constants_FONT.BERLIN_1, FULL_HD).lineHeight + IMAGE_MARGIN_BOTTOM), _metadataHeight);
var rtlde_card_constants_imageOptions = (card_constants_imageOptions = {}, (0,defineProperty/* default */.Z)(card_constants_imageOptions, card_constants_templates.CardS, (_templates$CardS = {}, (0,defineProperty/* default */.Z)(_templates$CardS, HD, {
  PRIMARY: {
    width: 195,
    height: 110
  }
}), (0,defineProperty/* default */.Z)(_templates$CardS, FULL_HD, {
  PRIMARY: {
    width: 250,
    height: 141
  }
}), _templates$CardS)), (0,defineProperty/* default */.Z)(card_constants_imageOptions, card_constants_templates.CardM, (_templates$CardM = {}, (0,defineProperty/* default */.Z)(_templates$CardM, HD, {
  PRIMARY: {
    width: 247,
    height: 139
  }
}), (0,defineProperty/* default */.Z)(_templates$CardM, FULL_HD, {
  PRIMARY: {
    width: 302,
    height: 170
  }
}), _templates$CardM)), (0,defineProperty/* default */.Z)(card_constants_imageOptions, card_constants_templates.CardL, (_templates$CardL = {}, (0,defineProperty/* default */.Z)(_templates$CardL, HD, {
  PRIMARY: {
    width: 333,
    height: 187
  }
}), (0,defineProperty/* default */.Z)(_templates$CardL, FULL_HD, {
  PRIMARY: {
    width: 381,
    height: 214
  }
}), _templates$CardL)), card_constants_imageOptions);
var card_constants_sizes = [card_constants_templates.CardS, card_constants_templates.CardM, card_constants_templates.CardL].reduce(function (result, template) {
  var _template;
  return card_constants_objectSpread(card_constants_objectSpread({}, result), {}, (0,defineProperty/* default */.Z)({}, template, (_template = {}, (0,defineProperty/* default */.Z)(_template, HD, {
    w: rtlde_card_constants_imageOptions[template][HD][PRIMARY].width,
    h: rtlde_card_constants_imageOptions[template][HD][PRIMARY].height + metadataHeight[HD]
  }), (0,defineProperty/* default */.Z)(_template, FULL_HD, {
    w: rtlde_card_constants_imageOptions[template][FULL_HD][PRIMARY].width,
    h: rtlde_card_constants_imageOptions[template][FULL_HD][PRIMARY].height + metadataHeight[HD]
  }), _template)));
}, {});
;// CONCATENATED MODULE: ./src/modules/tornado/card/card.constants.js

var card_constants_ICON_HEIGHT;


var card_constants_ICON_PADDING_VERTICAL = 4;
var card_constants_ICON_PADDING_HORIZONTAL = 8;
var card_card_constants_ICON_HEIGHT = (card_constants_ICON_HEIGHT = {}, (0,defineProperty/* default */.Z)(card_constants_ICON_HEIGHT, HD, 24), (0,defineProperty/* default */.Z)(card_constants_ICON_HEIGHT, FULL_HD, 32), card_constants_ICON_HEIGHT);
;// CONCATENATED MODULE: ./src/modules/tornado/card/card.style.js

var card_style_IMAGE_OFFSET;
function card_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function card_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? card_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : card_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }












var card_style_defaultContext = makeDefaultStylingContext();
var card_style_getIconViewBox = memoize_default()(function (screenSize) {
  return {
    h: card_card_constants_ICON_HEIGHT[screenSize]
  };
});
var card_style_colors = {
  text: makeThemeColor(PRIMARY),
  border: card_constants_BORDER_COLOR,
  innerBorder: card_constants_INNER_BORDER_COLOR,
  overlayTop: makeThemeColor(TERTIARY, 0),
  overlayBottom: makeThemeColor(TERTIARY),
  highlight: card_constants_HIGHLIGHT_COLOR
};
var card_card_style_IMAGE_OFFSET = (card_style_IMAGE_OFFSET = {}, (0,defineProperty/* default */.Z)(card_style_IMAGE_OFFSET, HD, focus_BORDER_WIDTH[HD] * 2), (0,defineProperty/* default */.Z)(card_style_IMAGE_OFFSET, FULL_HD, focus_BORDER_WIDTH[FULL_HD] * 2), card_style_IMAGE_OFFSET);
var card_style_getIcon = function getIcon(icons, position) {
  return icons ? icons[rtlde_card_constants_ICONS[position]] : null;
};
var makeBasicTextStyle = function makeBasicTextStyle(_ref) {
  var font = _ref.font,
    _ref$colorMode = _ref.colorMode,
    colorMode = _ref$colorMode === void 0 ? DEFAULT_MODE : _ref$colorMode;
  return {
    color: card_style_colors.text[colorMode],
    text: card_style_objectSpread(card_style_objectSpread({}, font), {}, {
      verticalAlign: 'middle',
      wordWrap: false,
      textOverflow: '...'
    })
  };
};
var makeBasicIconStyle = function makeBasicIconStyle() {
  return {
    alpha: 0.8,
    y: card_constants_ICON_PADDING_VERTICAL
  };
};
var card_style_getDetailsPosition = memoize_default()(function () {
  var hasHighlightText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return hasHighlightText ? {
    mountX: 1,
    x: identity
  } : {
    mountX: 0,
    x: 0
  };
});
var card_style_getInitialStyle = memoize_default()(function () {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : card_style_defaultContext,
    _ref2$screenSize = _ref2.screenSize,
    screenSize = _ref2$screenSize === void 0 ? FULL_HD : _ref2$screenSize,
    _ref2$colorMode = _ref2.colorMode,
    colorMode = _ref2$colorMode === void 0 ? DEFAULT_MODE : _ref2$colorMode;
  return {
    zIndex: UNFOCUSED_Z_INDEX,
    Border: {
      zIndex: 1,
      x: -focus_BORDER_WIDTH[screenSize],
      y: -focus_BORDER_WIDTH[screenSize],
      shader: {
        outline: focus_BORDER_WIDTH[screenSize],
        radius: rtlde_focus_BORDER_RADIUS[screenSize],
        strokeColor: colors_TRANSPARENT
      }
    },
    Image: {
      zIndex: 2,
      shader: {
        radius: rtlde_focus_BORDER_RADIUS[screenSize],
        progressHeight: progress_style_HEIGHT,
        progressBackgroundColor: progress_style_colors.background[colorMode],
        progressBarColor: progress_style_colors.bar[colorMode]
      }
    },
    TopLeftIcon: {
      zIndex: 3,
      x: card_constants_ICON_PADDING_HORIZONTAL,
      y: card_constants_ICON_PADDING_VERTICAL
    },
    TopRightIcon: card_style_objectSpread(card_style_objectSpread({
      zIndex: 3
    }, makeBasicIconStyle()), {}, {
      visible: card_constants_DISPLAY_ICONS,
      mountX: 1,
      x: function x(width) {
        return width - card_constants_ICON_PADDING_HORIZONTAL;
      },
      y: card_constants_ICON_PADDING_VERTICAL
    }),
    BottomRightIcon: {
      zIndex: 3,
      mount: 1,
      x: function x(w) {
        return w - card_constants_ICON_PADDING_HORIZONTAL;
      },
      visible: card_constants_DISPLAY_ICONS,
      alpha: 0.8
    },
    Incentive: {
      zIndex: 0
    },
    ExtraTitle: {
      color: card_style_colors.text[colorMode],
      text: card_style_objectSpread(card_style_objectSpread({}, src_getFont(card_constants_EXTRA_TITLE_FONT_NAME, screenSize, EXTRA_TITLE_FONT_TYPE)), {}, {
        verticalAlign: 'middle',
        wordWrap: true,
        maxLines: EXTRA_TITLE_LINES,
        maxLinesSuffix: '...'
      }),
      colorMode: colorMode
    },
    Title: makeBasicTextStyle({
      font: src_getFont(card_constants_TITLE_FONT_NAME, screenSize, card_constants_TITLE_FONT_TYPE),
      colorMode: colorMode
    }),
    Highlight: {
      text: card_style_objectSpread(card_style_objectSpread({}, src_getFont(constants_FONT.BERLIN_1, screenSize)), {}, {
        verticalAlign: 'middle',
        wordWrap: false,
        textOverflow: '...',
        textColor: card_style_colors.highlight[colorMode]
      })
    },
    Details: card_style_objectSpread(card_style_objectSpread(card_style_objectSpread({}, makeBasicTextStyle({
      font: src_getFont(constants_FONT.BERLIN_1, screenSize),
      colorMode: colorMode
    })), card_style_getDetailsPosition()), {}, {
      alpha: 0.6
    }),
    ProgressBar: {
      mountY: 1
    }
  };
}, cacheResolver);
var card_style_getFocusedStyle = memoize_default()(function (_ref3) {
  var colorMode = _ref3.colorMode;
  return {
    zIndex: FOCUSED_Z_INDEX,
    Border: {
      smooth: {
        scale: focus_SCALE_FOCUSED,
        'shader.strokeColor': card_style_colors.border[colorMode],
        'shader.innerColor': card_style_colors.innerBorder[colorMode],
        'shader.scale': focus_SCALE_FOCUSED
      }
    },
    Image: {
      smooth: {
        scale: focus_SCALE_FOCUSED,
        'shader.scale': focus_SCALE_FOCUSED
      }
    }
  };
}, cacheResolver);
var card_style_unFocusedStyle = {
  zIndex: UNFOCUSED_Z_INDEX,
  Border: {
    smooth: {
      scale: 1,
      'shader.strokeColor': colors_TRANSPARENT,
      'shader.innerColor': colors_TRANSPARENT,
      'shader.scale': 1.0
    }
  },
  Image: {
    smooth: {
      scale: 1,
      'shader.scale': 1.0
    }
  }
};
;// CONCATENATED MODULE: ./src/modules/tornado/card/card.component.js








function card_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function card_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? card_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : card_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function card_component_createSuper(t) { var r = card_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function card_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (card_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }













var Card = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Card, _Lightning$Component);
  var _super = card_component_createSuper(Card);
  function Card() {
    (0,classCallCheck/* default */.Z)(this, Card);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Card, [{
    key: "_construct",
    value: function _construct() {
      this._index = 0;
      this._style = card_component_objectSpread({}, card_style_defaultContext);
    }
  }, {
    key: "_inactive",
    value: function _inactive() {
      this.signal(INACTIVE_SIGNAL, this);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      var _this = this;
      card_constants_TITLES_ORDER.forEach(function (id) {
        var view = _this.tag(id);
        if (view) {
          view.removeAllListeners('txLoaded');
        }
      });
      this._item = undefined;
      this.signal(DETACHED_SIGNAL, this);
    }
  }, {
    key: "index",
    get: function get() {
      return this._index;
    },
    set: function set(value) {
      this._index = value;
    }
  }, {
    key: "item",
    get: function get() {
      return this._item;
    },
    set: function set(_ref) {
      var _this2 = this;
      var content = _ref.content,
        config = _ref.config,
        template = _ref.template,
        _ref$colorScheme = _ref.colorScheme,
        colorScheme = _ref$colorScheme === void 0 ? card_style_defaultContext.colorMode : _ref$colorScheme;
      var templateDataAccessPath = [template, this._style.screenSize];
      var progress = getProgress(content.progress);
      if (areContentItemsEqual(this._item, content)) {
        this._item = content;
        this.patch({
          Image: {
            shader: {
              progress: progress
            }
          }
        });
        return;
      }
      this._item = content;
      this._config = config || card_component_objectSpread({}, get_default()(card_constants_sizes, templateDataAccessPath, {}));
      if (colorScheme && colorScheme !== this._style.colorMode) {
        this._style = {
          screenSize: this._style.screenSize,
          colorMode: colorScheme
        };
      }
      var _this$_item = this._item,
        title = _this$_item.title,
        extraTitle = _this$_item.extraTitle,
        pictos = _this$_item.pictos;
      var wordWrapWidth = this.wordWrapWidth;
      var wordWrapWidthHalf = Math.round(wordWrapWidth / 2);
      var cardImageOptions = get_default()(rtlde_card_constants_imageOptions, templateDataAccessPath, {});
      var textColor = card_style_colors.text[this._style.colorMode];
      var imageUrl = get_default()(this._item, 'image.src', '');
      var offset = card_card_style_IMAGE_OFFSET[this._style.screenSize];
      var topLeftIcon = card_style_getIcon(pictos, ICON_POSITION.TOP_LEFT);
      var topRightIcon = card_style_getIcon(pictos, ICON_POSITION.TOP_RIGHT);
      var bottomRightIcon = card_style_getIcon(pictos, ICON_POSITION.BOTTOM_RIGHT);
      var details = DISPLAY_DETAILS && this._item.details ? this._item.details : '';
      var highlight = this._item.highlight || '';
      var minTextOffset = cardImageOptions.PRIMARY.height + IMAGE_MARGIN_BOTTOM;
      var highlightPatch = makeTextPatch(highlight, details ? wordWrapWidthHalf : wordWrapWidth, textColor);
      var detailsPatch = makeTextPatch(details, highlight ? wordWrapWidthHalf : wordWrapWidth, textColor);
      highlightPatch.y = minTextOffset;
      detailsPatch.y = minTextOffset;
      var incentiveLines = getLinesCount(this._item.incentives);
      this._hasIncentives = incentiveLines > 0;
      this.patch({
        w: this._config.w,
        h: this._config.h,
        Border: {
          w: cardImageOptions.PRIMARY.width + offset,
          h: cardImageOptions.PRIMARY.height + offset
        },
        Image: {
          w: cardImageOptions.PRIMARY.width,
          h: cardImageOptions.PRIMARY.height,
          src: imageUrl,
          shader: {
            progress: progress
          }
        },
        TopLeftIcon: {
          visible: Boolean(topLeftIcon),
          iconData: {
            picto: topLeftIcon,
            viewBox: card_style_getIconViewBox(this._style.screenSize)
          }
        },
        TopRightIcon: {
          visible: Boolean(topRightIcon),
          iconData: {
            picto: topRightIcon,
            viewBox: card_style_getIconViewBox(this._style.screenSize)
          }
        },
        BottomRightIcon: {
          visible: Boolean(bottomRightIcon),
          y: cardImageOptions.PRIMARY.height - card_constants_ICON_PADDING_VERTICAL - progress_style_HEIGHT,
          iconData: {
            picto: bottomRightIcon,
            viewBox: card_style_getIconViewBox(this._style.screenSize)
          }
        },
        Incentive: {
          visible: this._hasIncentives,
          y: cardImageOptions.PRIMARY.height + IMAGE_MARGIN_BOTTOM,
          data: {
            w: cardImageOptions.PRIMARY.width,
            linesCount: incentiveLines,
            incentives: this._item.incentives,
            colorMode: this._style.colorMode
          }
        },
        ExtraTitle: makeTextPatch(card_constants_DISPLAY_EXTRA_TITLE ? extraTitle : '', wordWrapWidth, textColor),
        Title: makeTextPatch(card_constants_DISPLAY_TITLE ? title : '', wordWrapWidth, textColor),
        Highlight: highlightPatch,
        Details: detailsPatch
      });
      card_constants_TITLES_ORDER.forEach(function (id) {
        var view = _this2.tag(id);
        if (view) {
          view.on('txLoaded', _this2._updateMetadataPosition.bind(_this2));
        }
      });
    }
  }, {
    key: "wordWrapWidth",
    get: function get() {
      return this._config ? this._config.w : 0;
    }
  }, {
    key: "_updateMetadataPosition",
    value: function _updateMetadataPosition() {
      var _TITLES_ORDER = (0,slicedToArray/* default */.Z)(card_constants_TITLES_ORDER, 2),
        firstLineTag = _TITLES_ORDER[0],
        secondLineTag = _TITLES_ORDER[1];
      var firstLine = this.tag(firstLineTag);
      var secondLine = this.tag(secondLineTag);
      var highlights = this.tag('Highlight');
      var details = this.tag('Details');
      var incentiveHeight = this._hasIncentives ? incentive_incentive_style_HEIGHT[this._style.screenSize] : 0;
      var offset = this.tag('Image').h + IMAGE_MARGIN_BOTTOM + incentiveHeight;
      if (firstLine.visible) {
        firstLine.y = offset;
        offset += firstLine.finalH;
      }
      if (secondLine.visible) {
        secondLine.y = offset;
        offset += secondLine.finalH;
      }
      if (details.visible || highlights.visible) {
        details.patch(card_style_getDetailsPosition(highlights.visible));
        details.y = offset;
        highlights.y = offset;
      }
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this.patch(card_style_getFocusedStyle(this._style));
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this.patch(card_style_unFocusedStyle);
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      this.signal(SELECTED_SIGNAL, this._item);
      return true;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Border: {
          rect: true,
          shader: {
            type: focus_shader
          }
        },
        Image: {
          shader: {
            type: ImageShader
          }
        },
        TopLeftIcon: {
          type: rtlde_card_constants_ICONS_TYPES[ICON_POSITION.TOP_LEFT]
        },
        TopRightIcon: {
          type: rtlde_card_constants_ICONS_TYPES[ICON_POSITION.TOP_RIGHT]
        },
        BottomRightIcon: {
          type: rtlde_card_constants_ICONS_TYPES[ICON_POSITION.BOTTOM_RIGHT]
        },
        Incentive: {
          type: Incentive
        },
        ExtraTitle: {},
        Title: {},
        Highlight: {},
        Details: {}
      }, card_style_getInitialStyle());
    }
  }]);
  return Card;
}(src_Lightning.Component);

Card.Templates = card_constants_templates;
Card.Sizes = card_constants_sizes;
Card.ImageOptions = rtlde_card_constants_imageOptions;
;// CONCATENATED MODULE: ./src/modules/tornado/totem/customer/rtlde/totem.constants.js

var totem_constants_ICONS, totem_constants_ICONS_TYPES;



var rtlde_totem_constants_ICONS = (totem_constants_ICONS = {}, (0,defineProperty/* default */.Z)(totem_constants_ICONS, ICON_POSITION.TOP_RIGHT, 4), (0,defineProperty/* default */.Z)(totem_constants_ICONS, ICON_POSITION.BOTTOM_RIGHT, 1), totem_constants_ICONS);
var rtlde_totem_constants_ICONS_TYPES = (totem_constants_ICONS_TYPES = {}, (0,defineProperty/* default */.Z)(totem_constants_ICONS_TYPES, ICON_POSITION.TOP_LEFT, Icon), (0,defineProperty/* default */.Z)(totem_constants_ICONS_TYPES, ICON_POSITION.TOP_RIGHT, Badge), (0,defineProperty/* default */.Z)(totem_constants_ICONS_TYPES, ICON_POSITION.BOTTOM_RIGHT, Icon), totem_constants_ICONS_TYPES);
;// CONCATENATED MODULE: ./src/modules/tornado/totem/totem.constants.js

var _templates$Totem, _templates$Totem2;


var totem_constants_templates = {
  Totem: 'Totem'
};
var totem_constants_sizes = (0,defineProperty/* default */.Z)({}, totem_constants_templates.Totem, (_templates$Totem = {}, (0,defineProperty/* default */.Z)(_templates$Totem, HD, {
  w: 161,
  h: 402
}), (0,defineProperty/* default */.Z)(_templates$Totem, FULL_HD, {
  w: 184,
  h: 461
}), _templates$Totem));
var totem_constants_imageOptions = (0,defineProperty/* default */.Z)({}, totem_constants_templates.Totem, (_templates$Totem2 = {}, (0,defineProperty/* default */.Z)(_templates$Totem2, HD, {
  PRIMARY: {
    width: 161,
    height: 402
  }
}), (0,defineProperty/* default */.Z)(_templates$Totem2, FULL_HD, {
  PRIMARY: {
    width: 184,
    height: 461
  }
}), _templates$Totem2));
;// CONCATENATED MODULE: ./src/modules/tornado/totem/totem.style.js

var totem_style_ICON_HEIGHT, totem_style_LOCK_ICON_HEIGHT;







var totem_style_defaultContext = makeDefaultStylingContext();
var totem_totem_style_ICON_HEIGHT = (totem_style_ICON_HEIGHT = {}, (0,defineProperty/* default */.Z)(totem_style_ICON_HEIGHT, HD, 24), (0,defineProperty/* default */.Z)(totem_style_ICON_HEIGHT, FULL_HD, 32), totem_style_ICON_HEIGHT);
var totem_totem_style_LOCK_ICON_HEIGHT = (totem_style_LOCK_ICON_HEIGHT = {}, (0,defineProperty/* default */.Z)(totem_style_LOCK_ICON_HEIGHT, HD, 32), (0,defineProperty/* default */.Z)(totem_style_LOCK_ICON_HEIGHT, FULL_HD, 40), totem_style_LOCK_ICON_HEIGHT);
var totem_style_PADDING_VERTICAL = 4;
var totem_style_PADDING_HORIZONTAL = 8;
var totem_style_getIcon = function getIcon(icons, position) {
  return icons ? icons[rtlde_totem_constants_ICONS[position]] : null;
};
var totem_style_getIconViewBox = memoize_default()(function (screenSize) {
  return {
    h: totem_totem_style_ICON_HEIGHT[screenSize]
  };
});
var totem_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : totem_style_defaultContext,
    screenSize = _ref.screenSize;
  var _sizes$templates$Tote = totem_constants_sizes[totem_constants_templates.Totem][screenSize],
    w = _sizes$templates$Tote.w,
    h = _sizes$templates$Tote.h;
  var borderSize = focus_BORDER_WIDTH[screenSize];
  var borderOffset = borderSize * 2;
  return {
    Border: {
      w: w + borderOffset,
      h: h + borderOffset,
      x: -borderSize,
      y: -borderSize,
      color: colors_TRANSPARENT,
      shader: {
        radius: rtlde_focus_BORDER_RADIUS[screenSize],
        outline: focus_BORDER_WIDTH[screenSize],
        strokeColor: colors_TRANSPARENT,
        innerColor: colors_TRANSPARENT
      }
    },
    Image: {
      w: w,
      h: h,
      shader: {
        radius: rtlde_focus_BORDER_RADIUS[screenSize]
      }
    },
    TopLeftIcon: {
      x: totem_style_PADDING_HORIZONTAL,
      y: totem_style_PADDING_VERTICAL
    },
    TopRightIcon: {
      alpha: 0.8,
      x: w - totem_style_PADDING_HORIZONTAL - totem_totem_style_ICON_HEIGHT[screenSize],
      y: totem_style_PADDING_VERTICAL
    },
    BottomRightIcon: {
      mountX: 1,
      x: w - totem_style_PADDING_HORIZONTAL,
      y: h - totem_style_PADDING_VERTICAL - totem_totem_style_ICON_HEIGHT[screenSize]
    },
    Incentive: {
      x: middle,
      y: middle,
      mount: 0.5
    }
  };
};
var totem_style_getFocusedStyle = memoize_default()(function (_ref2) {
  var colorMode = _ref2.colorMode;
  return {
    Border: {
      smooth: {
        scale: focus_SCALE_FOCUSED,
        'shader.strokeColor': BORDER_COLOR[colorMode],
        'shader.innerColor': INNER_BORDER_COLOR[colorMode],
        'shader.scale': focus_SCALE_FOCUSED
      }
    },
    Image: {
      smooth: {
        scale: focus_SCALE_FOCUSED,
        'shader.scale': focus_SCALE_FOCUSED
      }
    }
  };
}, cacheResolver);
var totem_style_unFocusedStyle = {
  Border: {
    smooth: {
      scale: 1,
      'shader.strokeColor': colors_TRANSPARENT,
      'shader.innerColor': colors_TRANSPARENT,
      'shader.scale': 1.0
    }
  },
  Image: {
    smooth: {
      scale: 1,
      'shader.scale': 1.0
    }
  }
};
;// CONCATENATED MODULE: ./src/modules/tornado/totem/totem.component.js





function totem_component_createSuper(t) { var r = totem_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function totem_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (totem_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }












var Totem = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Totem, _Lightning$Component);
  var _super = totem_component_createSuper(Totem);
  function Totem() {
    (0,classCallCheck/* default */.Z)(this, Totem);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Totem, [{
    key: "_construct",
    value: function _construct() {
      this._style = totem_style_defaultContext;
    }
  }, {
    key: "_inactive",
    value: function _inactive() {
      this.signal(INACTIVE_SIGNAL, this);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this._item = undefined;
      this.signal(DETACHED_SIGNAL, this);
    }
  }, {
    key: "item",
    get: function get() {
      return this._item;
    },
    set: function set(_ref) {
      var content = _ref.content,
        config = _ref.config,
        template = _ref.template,
        _ref$colorScheme = _ref.colorScheme,
        colorScheme = _ref$colorScheme === void 0 ? this._style.colorMode : _ref$colorScheme;
      if (areContentItemsEqual(this._item, content)) {
        this._item = content;
        return;
      }
      var templateDataAccessPath = [template, this._style.screenSize];
      var screenSize = this._style.screenSize;
      this._item = content;
      this._config = config || get_default()(totem_constants_sizes, templateDataAccessPath, {});
      if (colorScheme && colorScheme !== this._style.colorMode) {
        this._style = {
          screenSize: this._style.screenSize,
          colorMode: colorScheme
        };
      }
      var _this$_item = this._item,
        pictos = _this$_item.pictos,
        image = _this$_item.image,
        incentives = _this$_item.incentives;
      var imageUrl = image && image.src || '';
      var viewBox = totem_style_getIconViewBox(screenSize);
      var incentiveLines = getLinesCount(incentives);
      this.patch({
        Image: {
          src: imageUrl
        },
        TopLeftIcon: {
          iconData: {
            picto: totem_style_getIcon(pictos, ICON_POSITION.TOP_LEFT),
            viewBox: viewBox
          }
        },
        TopRightIcon: {
          iconData: {
            picto: totem_style_getIcon(pictos, ICON_POSITION.TOP_RIGHT),
            viewBox: viewBox
          }
        },
        BottomRightIcon: {
          iconData: {
            picto: totem_style_getIcon(pictos, ICON_POSITION.BOTTOM_RIGHT),
            viewBox: viewBox
          }
        },
        Incentive: {
          visible: incentiveLines > 0,
          data: {
            incentives: incentives,
            linesCount: incentiveLines,
            w: this._config.w,
            colorMode: this._style.colorMOde,
            alignment: ALIGNMENT_VERTICAL
          }
        }
      });
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this.patch(totem_style_getFocusedStyle(this._style));
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this.patch(totem_style_unFocusedStyle);
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      this.signal(SELECTED_SIGNAL, this._item);
      return true;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Border: {
          rect: true,
          shader: {
            type: focus_shader
          }
        },
        Image: {
          shader: {
            type: ImageShader
          }
        },
        TopLeftIcon: {
          type: rtlde_totem_constants_ICONS_TYPES[ICON_POSITION.TOP_LEFT]
        },
        TopRightIcon: {
          type: rtlde_totem_constants_ICONS_TYPES[ICON_POSITION.TOP_RIGHT]
        },
        BottomRightIcon: {
          type: rtlde_totem_constants_ICONS_TYPES[ICON_POSITION.BOTTOM_RIGHT]
        },
        Incentive: {
          type: Incentive
        }
      }, totem_style_getInitialStyle());
    }
  }]);
  return Totem;
}(src_Lightning.Component);

Totem.Templates = totem_constants_templates;
Totem.Sizes = totem_constants_sizes;
Totem.ImageOptions = totem_constants_imageOptions;
;// CONCATENATED MODULE: ./src/modules/tornado/horizontal-card/customer/rtlde/horizontalCard.constants.js

var horizontalCard_constants_ICONS, _SIDE_GLASS_ICONS, horizontalCard_constants_ICONS_TYPES, _templates$Horizontal, _templates$Horizontal2;





var horizontalCard_constants_DISPLAY_ICONS = true;
var horizontalCard_constants_DISPLAY_EXTRA_TITLE = true;
var horizontalCard_constants_DISPLAY_DETAILS = false;
var horizontalCard_constants_TITLE_FONT_TYPE = FONT_TYPE.MAIN;
var horizontalCard_constants_TITLE_FONT_NAME = constants_FONT.OTTAWA_3;
var EXTRA_HIGHLIGHT_FONT_NAME = constants_FONT.BERLIN_1;
var EXTRA_HIGHLIGHT_FONT_TYPE = FONT_TYPE.MAIN;
var rtlde_horizontalCard_constants_ICONS = (horizontalCard_constants_ICONS = {}, (0,defineProperty/* default */.Z)(horizontalCard_constants_ICONS, ICON_POSITION.TOP_RIGHT, 4), (0,defineProperty/* default */.Z)(horizontalCard_constants_ICONS, ICON_POSITION.BOTTOM_RIGHT, 1), (0,defineProperty/* default */.Z)(horizontalCard_constants_ICONS, ICON_POSITION.CENTER, 3), horizontalCard_constants_ICONS);
var SIDE_GLASS_ICONS = (_SIDE_GLASS_ICONS = {}, (0,defineProperty/* default */.Z)(_SIDE_GLASS_ICONS, ICON_POSITION.TOP_LEFT, 3), (0,defineProperty/* default */.Z)(_SIDE_GLASS_ICONS, ICON_POSITION.TOP_RIGHT, 4), (0,defineProperty/* default */.Z)(_SIDE_GLASS_ICONS, ICON_POSITION.BOTTOM_RIGHT, 1), (0,defineProperty/* default */.Z)(_SIDE_GLASS_ICONS, ICON_POSITION.CENTER, 3), _SIDE_GLASS_ICONS);
var rtlde_horizontalCard_constants_ICONS_TYPES = (horizontalCard_constants_ICONS_TYPES = {}, (0,defineProperty/* default */.Z)(horizontalCard_constants_ICONS_TYPES, ICON_POSITION.TOP_LEFT, Icon), (0,defineProperty/* default */.Z)(horizontalCard_constants_ICONS_TYPES, ICON_POSITION.TOP_RIGHT, Badge), (0,defineProperty/* default */.Z)(horizontalCard_constants_ICONS_TYPES, ICON_POSITION.BOTTOM_RIGHT, Icon), (0,defineProperty/* default */.Z)(horizontalCard_constants_ICONS_TYPES, ICON_POSITION.CENTER, Icon), horizontalCard_constants_ICONS_TYPES);
var horizontalCard_constants_templates = {
  HorizontalCard: 'HorizontalCard'
};
var horizontalCard_constants_sizes = (0,defineProperty/* default */.Z)({}, horizontalCard_constants_templates.HorizontalCard, (_templates$Horizontal = {}, (0,defineProperty/* default */.Z)(_templates$Horizontal, HD, {
  w: 1024,
  h: 158
}), (0,defineProperty/* default */.Z)(_templates$Horizontal, FULL_HD, {
  w: 1560,
  h: 188
}), _templates$Horizontal));
var horizontalCard_constants_imageOptions = (0,defineProperty/* default */.Z)({}, horizontalCard_constants_templates.HorizontalCard, (_templates$Horizontal2 = {}, (0,defineProperty/* default */.Z)(_templates$Horizontal2, HD, {
  PRIMARY: {
    width: 281,
    height: 159
  }
}), (0,defineProperty/* default */.Z)(_templates$Horizontal2, FULL_HD, {
  PRIMARY: {
    width: 333,
    height: 188
  }
}), _templates$Horizontal2));
;// CONCATENATED MODULE: ./src/modules/tornado/horizontal-card/horizontalCard.constants.js

;// CONCATENATED MODULE: ./src/modules/tornado/horizontal-card/horizontalCard.style.js

var horizontalCard_style_IMAGE_OFFSET, _TEXT_TOP_PADDING, _TEXT_LEFT_PADDING, horizontalCard_style_ICON_HEIGHT, horizontalCard_style_LOCK_ICON_HEIGHT;
function horizontalCard_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function horizontalCard_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? horizontalCard_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : horizontalCard_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }










var horizontalCard_style_defaultContext = makeDefaultStylingContext();
var horizontal_card_horizontalCard_style_IMAGE_OFFSET = (horizontalCard_style_IMAGE_OFFSET = {}, (0,defineProperty/* default */.Z)(horizontalCard_style_IMAGE_OFFSET, HD, focus_BORDER_WIDTH[HD] * 2), (0,defineProperty/* default */.Z)(horizontalCard_style_IMAGE_OFFSET, FULL_HD, focus_BORDER_WIDTH[FULL_HD] * 2), horizontalCard_style_IMAGE_OFFSET);
var TEXT_TOP_PADDING = (_TEXT_TOP_PADDING = {}, (0,defineProperty/* default */.Z)(_TEXT_TOP_PADDING, HD, 16), (0,defineProperty/* default */.Z)(_TEXT_TOP_PADDING, FULL_HD, 16), _TEXT_TOP_PADDING);
var TEXT_LEFT_PADDING = (_TEXT_LEFT_PADDING = {}, (0,defineProperty/* default */.Z)(_TEXT_LEFT_PADDING, HD, 24), (0,defineProperty/* default */.Z)(_TEXT_LEFT_PADDING, FULL_HD, 24), _TEXT_LEFT_PADDING);
var horizontal_card_horizontalCard_style_ICON_HEIGHT = (horizontalCard_style_ICON_HEIGHT = {}, (0,defineProperty/* default */.Z)(horizontalCard_style_ICON_HEIGHT, HD, 24), (0,defineProperty/* default */.Z)(horizontalCard_style_ICON_HEIGHT, FULL_HD, 32), horizontalCard_style_ICON_HEIGHT);
var horizontal_card_horizontalCard_style_LOCK_ICON_HEIGHT = (horizontalCard_style_LOCK_ICON_HEIGHT = {}, (0,defineProperty/* default */.Z)(horizontalCard_style_LOCK_ICON_HEIGHT, HD, 32), (0,defineProperty/* default */.Z)(horizontalCard_style_LOCK_ICON_HEIGHT, FULL_HD, 40), horizontalCard_style_LOCK_ICON_HEIGHT);
var horizontalCard_style_ICON_PADDING_VERTICAL = 4;
var horizontalCard_style_ICON_PADDING_HORIZONTAL = 8;
var horizontalCard_style_getIconViewBox = memoize_default()(function (screenSize) {
  return {
    h: horizontal_card_horizontalCard_style_ICON_HEIGHT[screenSize]
  };
});
var getLockIconViewBox = memoize_default()(function (screenSize) {
  return {
    h: horizontal_card_horizontalCard_style_LOCK_ICON_HEIGHT[screenSize]
  };
});
var getCentralIconHeight = function getCentralIconHeight(screenSize) {
  return horizontalCard_constants_imageOptions[horizontalCard_constants_templates.HorizontalCard][screenSize];
};
var getCentralIconViewBox = memoize_default()(function (screenSize) {
  return {
    h: getCentralIconHeight(screenSize).PRIMARY.height * 0.5,
    w: getCentralIconHeight(screenSize).PRIMARY.height * 0.5
  };
});
var horizontalCard_style_colors = {
  text: makeThemeColor(PRIMARY),
  border: makeThemeColor(PRIMARY),
  innerBorder: INNER_BORDER_COLOR,
  overlayTop: makeThemeColor(TERTIARY, 0),
  overlayBottom: makeThemeColor(TERTIARY),
  gradient: makeThemeColor(TERTIARY)
};
var horizontalCard_style_makeBasicTextStyle = function makeBasicTextStyle(_ref) {
  var font = _ref.font,
    _ref$colorMode = _ref.colorMode,
    colorMode = _ref$colorMode === void 0 ? DEFAULT_MODE : _ref$colorMode;
  return {
    color: horizontalCard_style_colors.text[colorMode],
    text: horizontalCard_style_objectSpread(horizontalCard_style_objectSpread({}, font), {}, {
      verticalAlign: 'middle',
      wordWrap: false,
      textOverflow: '...'
    })
  };
};
var horizontalCard_style_makeBasicIconStyle = function makeBasicIconStyle() {
  return {
    alpha: 0.8
  };
};
var horizontalCard_style_getIcon = function getIcon(icons, position) {
  var sideGlass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var map = sideGlass ? SIDE_GLASS_ICONS : rtlde_horizontalCard_constants_ICONS;
  return icons ? icons[map[position]] : null;
};
var horizontalCard_style_getInitialStyle = memoize_default()(function () {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : horizontalCard_style_defaultContext,
    _ref2$screenSize = _ref2.screenSize,
    screenSize = _ref2$screenSize === void 0 ? FULL_HD : _ref2$screenSize,
    _ref2$colorMode = _ref2.colorMode,
    colorMode = _ref2$colorMode === void 0 ? DEFAULT_MODE : _ref2$colorMode;
  var imageSize = horizontalCard_constants_imageOptions[horizontalCard_constants_templates.HorizontalCard][screenSize].PRIMARY;
  var offset = horizontal_card_horizontalCard_style_IMAGE_OFFSET[screenSize];
  return {
    Border: {
      w: imageSize.width + offset,
      h: imageSize.height + offset,
      x: -focus_BORDER_WIDTH[screenSize],
      y: -focus_BORDER_WIDTH[screenSize],
      shader: {
        outline: focus_BORDER_WIDTH[screenSize],
        radius: rtlde_focus_BORDER_RADIUS[screenSize],
        strokeColor: colors_TRANSPARENT
      }
    },
    Image: {
      w: imageSize.width,
      h: imageSize.height,
      shader: {
        radius: rtlde_focus_BORDER_RADIUS[screenSize],
        progressHeight: progress_style_HEIGHT,
        progressBackgroundColor: progress_style_colors.background[colorMode],
        progressBarColor: progress_style_colors.bar[colorMode]
      }
    },
    Gradient: {
      visible: false,
      x: -1,
      y: -1,
      w: imageSize.width + 2,
      h: imageSize.height + 2,
      rect: true,
      color: horizontalCard_style_colors.gradient[colorMode],
      alpha: 0.6,
      shader: {
        radius: rtlde_focus_BORDER_RADIUS[screenSize]
      }
    },
    ExtraFlexContainer: {
      visible: false,
      alpha: 1,
      w: imageSize.width,
      h: imageSize.height,
      flex: {
        direction: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      },
      ExtraHighlight: horizontalCard_style_makeBasicTextStyle({
        font: src_getFont(EXTRA_HIGHLIGHT_FONT_NAME, screenSize, EXTRA_HIGHLIGHT_FONT_TYPE),
        colorMode: colorMode
      })
    },
    TopLeftIcon: {
      x: horizontalCard_style_ICON_PADDING_HORIZONTAL,
      y: horizontalCard_style_ICON_PADDING_VERTICAL
    },
    TopRightIcon: horizontalCard_style_objectSpread(horizontalCard_style_objectSpread({}, horizontalCard_style_makeBasicIconStyle()), {}, {
      visible: horizontalCard_constants_DISPLAY_ICONS,
      mountX: 1,
      x: imageSize.width - horizontalCard_style_ICON_PADDING_HORIZONTAL,
      y: horizontalCard_style_ICON_PADDING_VERTICAL
    }),
    BottomRightIcon: {
      mount: 1,
      x: imageSize.width - horizontalCard_style_ICON_PADDING_HORIZONTAL,
      visible: horizontalCard_constants_DISPLAY_ICONS,
      alpha: 0.8
    },
    FlexContainer: {
      x: imageSize.width + TEXT_LEFT_PADDING[screenSize],
      h: imageSize.height,
      Title: horizontalCard_style_makeBasicTextStyle({
        font: src_getFont(horizontalCard_constants_TITLE_FONT_NAME, screenSize, horizontalCard_constants_TITLE_FONT_TYPE),
        colorMode: colorMode
      }),
      ExtraTitle: horizontalCard_style_makeBasicTextStyle({
        font: src_getFont(constants_FONT.BERLIN_1, screenSize),
        colorMode: colorMode
      }),
      Highlight: horizontalCard_style_objectSpread(horizontalCard_style_objectSpread({}, horizontalCard_style_makeBasicTextStyle({
        font: src_getFont(constants_FONT.BERLIN_1, screenSize),
        colorMode: colorMode
      })), {}, {
        alpha: 0.6
      }),
      Description: {
        text: horizontalCard_style_objectSpread(horizontalCard_style_objectSpread({}, src_getFont(constants_FONT.BERLIN_1, screenSize)), {}, {
          maxLines: 3,
          verticalAlign: 'middle',
          wordWrap: true,
          maxLinesSuffix: '...'
        })
      },
      Details: horizontalCard_style_objectSpread(horizontalCard_style_objectSpread({}, horizontalCard_style_makeBasicTextStyle({
        font: src_getFont(constants_FONT.BERLIN_1, screenSize),
        colorMode: colorMode
      })), {}, {
        alpha: 0.6
      })
    }
  };
}, cacheResolver);
var horizontalCard_style_getFocusedStyle = memoize_default()(function (_ref3) {
  var colorMode = _ref3.colorMode;
  return {
    Border: {
      smooth: {
        scale: focus_SCALE_FOCUSED,
        'shader.strokeColor': horizontalCard_style_colors.border[colorMode],
        'shader.innerColor': horizontalCard_style_colors.innerBorder[colorMode],
        'shader.scale': focus_SCALE_FOCUSED
      }
    },
    Image: {
      smooth: {
        scale: focus_SCALE_FOCUSED,
        'shader.scale': focus_SCALE_FOCUSED
      }
    },
    Gradient: {
      smooth: {
        scale: focus_SCALE_FOCUSED
      }
    },
    ExtraFlexContainer: {
      smooth: {
        alpha: 0
      }
    }
  };
}, cacheResolver);
var horizontalCard_style_unFocusedStyle = {
  Border: {
    smooth: {
      scale: 1,
      'shader.strokeColor': colors_TRANSPARENT,
      'shader.innerColor': colors_TRANSPARENT,
      'shader.scale': 1.0
    }
  },
  Image: {
    smooth: {
      scale: 1,
      'shader.scale': 1.0
    }
  },
  Gradient: {
    smooth: {
      scale: 1
    }
  },
  ExtraFlexContainer: {
    smooth: {
      alpha: 1
    }
  }
};
;// CONCATENATED MODULE: ./src/modules/tornado/horizontal-card/horizontalCard.component.js







function horizontalCard_component_createSuper(t) { var r = horizontalCard_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function horizontalCard_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (horizontalCard_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }












var HorizontalCard = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(HorizontalCard, _Lightning$Component);
  var _super = horizontalCard_component_createSuper(HorizontalCard);
  function HorizontalCard() {
    (0,classCallCheck/* default */.Z)(this, HorizontalCard);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(HorizontalCard, [{
    key: "_construct",
    value: function _construct() {
      this._index = 0;
      this._style = horizontalCard_style_defaultContext;
    }
  }, {
    key: "_inactive",
    value: function _inactive() {
      this.signal(INACTIVE_SIGNAL, this);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this.tag('Image').removeAllListeners('txLoaded');
      this._item = undefined;
      this.signal(DETACHED_SIGNAL, this);
    }
  }, {
    key: "item",
    get: function get() {
      return this._item;
    },
    set: function set(_ref) {
      var _this = this;
      var content = _ref.content,
        config = _ref.config,
        template = _ref.template,
        sideGlass = _ref.sideGlass,
        _ref$colorScheme = _ref.colorScheme,
        colorScheme = _ref$colorScheme === void 0 ? horizontalCard_style_defaultContext.colorMode : _ref$colorScheme;
      var templateDataAccessPath = [template, this._style.screenSize];
      var progress = getProgress(content.progress);
      if (areContentItemsEqual(this._item, content)) {
        this._item = content;
        this.patch({
          Image: {
            shader: {
              progress: progress
            }
          }
        });
        return;
      }
      this._item = content;
      this._config = config || get_default()(horizontalCard_constants_sizes, templateDataAccessPath, {});
      this._itemTemplate = template;
      var _this$_item = this._item,
        title = _this$_item.title,
        extraTitle = _this$_item.extraTitle,
        details = _this$_item.details,
        highlight = _this$_item.highlight,
        description = _this$_item.description,
        extraHighlight = _this$_item.extraHighlight,
        pictos = _this$_item.pictos;
      var wordWrapWidth = this.wordWrapWidth;
      var textColor = horizontalCard_style_colors.text[colorScheme];
      var imageUrl = get_default()(this._item, 'image.src', '');
      this.tag('Image').once('txLoaded', function () {
        _this.tag('Image').setSmooth('alpha', 1);
      });
      this.patch({
        w: this._config.w,
        h: this._config.h,
        Image: {
          alpha: 0.0001,
          src: imageUrl,
          shader: {
            progress: progress
          }
        },
        ExtraFlexContainer: {
          visible: sideGlass,
          CentralIcon: {
            iconData: {
              picto: horizontalCard_style_getIcon(pictos, ICON_POSITION.CENTER, sideGlass),
              viewBox: getCentralIconViewBox(this._style.screenSize)
            }
          },
          ExtraHighlight: makeTextPatch(extraHighlight, wordWrapWidth, textColor)
        },
        TopLeftIcon: {
          iconData: {
            picto: horizontalCard_style_getIcon(pictos, ICON_POSITION.TOP_LEFT, sideGlass),
            viewBox: horizontalCard_style_getIconViewBox(this._style.screenSize)
          }
        },
        TopRightIcon: {
          iconData: {
            picto: horizontalCard_style_getIcon(pictos, ICON_POSITION.TOP_RIGHT, sideGlass),
            viewBox: horizontalCard_style_getIconViewBox(this._style.screenSize)
          }
        },
        BottomRightIcon: {
          y: this._config.h - horizontalCard_style_ICON_PADDING_VERTICAL - progress_style_HEIGHT,
          iconData: {
            picto: horizontalCard_style_getIcon(pictos, ICON_POSITION.BOTTOM_RIGHT, sideGlass),
            viewBox: horizontalCard_style_getIconViewBox(this._style.screenSize)
          }
        },
        FlexContainer: {
          rect: true,
          color: colors_TRANSPARENT,
          flex: {
            direction: 'column',
            justifyContent: 'center'
          },
          Title: makeTextPatch(title, wordWrapWidth, textColor),
          ExtraTitle: makeTextPatch(horizontalCard_constants_DISPLAY_EXTRA_TITLE ? extraTitle : '', wordWrapWidth, textColor),
          Highlight: makeTextPatch(highlight, wordWrapWidth, textColor),
          Description: makeTextPatch(description, wordWrapWidth, textColor),
          Details: makeTextPatch(horizontalCard_constants_DISPLAY_DETAILS ? details : '', wordWrapWidth, textColor)
        }
      });
    }
  }, {
    key: "wordWrapWidth",
    get: function get() {
      var _get2 = get_default()(horizontalCard_constants_imageOptions, [this._itemTemplate, this._style.screenSize], {}),
        imageWidth = _get2.PRIMARY.width;
      var padding = TEXT_LEFT_PADDING[this._style.screenSize];
      var width = get_default()(this, '_config.w', this.finalW);
      var safetyMargin = safetyMargins.vertical[this._style.screenSize];
      return width - imageWidth - padding - safetyMargin;
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this.patch(horizontalCard_style_getFocusedStyle(this._style));
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this.patch(horizontalCard_style_unFocusedStyle);
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      this.signal(SELECTED_SIGNAL, this._item);
      return true;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Border: {
          rect: true,
          shader: {
            type: focus_shader
          }
        },
        Image: {
          shader: {
            type: ImageShader
          }
        },
        Gradient: {
          shader: {
            type: src_Lightning.shaders.RoundedRectangle
          }
        },
        ExtraFlexContainer: {
          CentralIcon: {
            type: rtlde_horizontalCard_constants_ICONS_TYPES[ICON_POSITION.CENTER]
          },
          ExtraHighlight: {}
        },
        TopLeftIcon: {
          type: rtlde_horizontalCard_constants_ICONS_TYPES[ICON_POSITION.TOP_LEFT]
        },
        TopRightIcon: {
          type: rtlde_horizontalCard_constants_ICONS_TYPES[ICON_POSITION.TOP_RIGHT]
        },
        BottomRightIcon: {
          type: rtlde_horizontalCard_constants_ICONS_TYPES[ICON_POSITION.BOTTOM_RIGHT]
        },
        FlexContainer: {
          Title: {},
          ExtraTitle: {},
          Highlight: {},
          Description: {},
          Details: {}
        }
      }, horizontalCard_style_getInitialStyle());
    }
  }]);
  return HorizontalCard;
}(src_Lightning.Component);

HorizontalCard.Templates = horizontalCard_constants_templates;
HorizontalCard.Sizes = horizontalCard_constants_sizes;
HorizontalCard.ImageOptions = horizontalCard_constants_imageOptions;
;// CONCATENATED MODULE: ./src/modules/tornado/progress/progress.constants.js
var FULLY_SHOWN_PERCENTAGE = 0.95;
;// CONCATENATED MODULE: ./src/modules/tornado/progress/progress.component.js







function progress_component_createSuper(t) { var r = progress_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function progress_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (progress_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }






var Progress = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Progress, _Lightning$Component);
  var _super = progress_component_createSuper(Progress);
  function Progress() {
    (0,classCallCheck/* default */.Z)(this, Progress);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Progress, [{
    key: "_construct",
    value: function _construct() {
      this._progress = 0;
    }
  }, {
    key: "_handleProgressUpdate",
    value: function _handleProgressUpdate() {
      var width = this.finalW || this.w;
      var progressWidth = this._progress > FULLY_SHOWN_PERCENTAGE ? width : width * this._progress;
      this.tag('Bar').w = progressWidth;
    }
  }, {
    key: "w",
    get: function get() {
      return (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(Progress.prototype), "w", this);
    },
    set: function set(value) {
      _set((0,getPrototypeOf/* default */.Z)(Progress.prototype), "w", value, this, true);
      this._handleProgressUpdate();
    }
  }, {
    key: "progress",
    get: function get() {
      return this._progress;
    },
    set: function set(value) {
      this._progress = safeProgressValue(value);
      this._handleProgressUpdate();
    }
  }, {
    key: "colorMode",
    get: function get() {
      return this._colorMode;
    },
    set: function set(value) {
      this._colorMode = value;
      this.patch({
        color: progress_style_colors.background[this._colorMode],
        Bar: {
          color: progress_style_colors.bar[this._colorMode]
        }
      });
    }
  }], [{
    key: "_template",
    value: function _template() {
      return {
        rect: true,
        color: progress_style_colors.background[DEFAULT_MODE],
        h: progress_style_HEIGHT,
        Bar: {
          rect: true,
          color: progress_style_colors.bar[DEFAULT_MODE],
          h: identity
        }
      };
    }
  }]);
  return Progress;
}(src_Lightning.Component);

;// CONCATENATED MODULE: ./src/modules/tornado/horizontal-square/customer/rtlde/horizontalSquare.constants.js


var horizontalSquare_constants_TITLE_FONT_TYPE = FONT_TYPE.MAIN;
var horizontalSquare_constants_TITLE_FONT_NAME = constants_FONT.OTTAWA_3;
var horizontalSquare_constants_EXTRA_HIGHLIGHT_FONT_NAME = constants_FONT.BERLIN_1;
var horizontalSquare_constants_EXTRA_HIGHLIGHT_FONT_TYPE = FONT_TYPE.MAIN;
var horizontalSquare_constants_BORDER_COLOR = makeThemeColor(PRIMARY);
var horizontalSquare_constants_INNER_BORDER_COLOR = makeThemeColor(TERTIARY);
var LINE1_COLOR = makeThemeColor(PRIMARY);
var LINE2_COLOR = makeThemeColor(QUATERNARY);
var LINE3_COLOR = makeThemeColor(QUATERNARY);
;// CONCATENATED MODULE: ./src/modules/tornado/horizontal-square/horizontalSquare.constants.js

var horizontalSquare_constants_templates$Horizontal, horizontalSquare_constants_templates$Horizontal2;


var horizontalSquare_constants_templates = {
  HorizontalSquare: 'HorizontalSquare'
};
var horizontalSquare_constants_sizes = (0,defineProperty/* default */.Z)({}, horizontalSquare_constants_templates.HorizontalSquare, (horizontalSquare_constants_templates$Horizontal = {}, (0,defineProperty/* default */.Z)(horizontalSquare_constants_templates$Horizontal, HD, {
  w: 1024,
  h: 164
}), (0,defineProperty/* default */.Z)(horizontalSquare_constants_templates$Horizontal, FULL_HD, {
  w: 1560,
  h: 200
}), horizontalSquare_constants_templates$Horizontal));
var horizontalSquare_constants_imageOptions = (0,defineProperty/* default */.Z)({}, horizontalSquare_constants_templates.HorizontalSquare, (horizontalSquare_constants_templates$Horizontal2 = {}, (0,defineProperty/* default */.Z)(horizontalSquare_constants_templates$Horizontal2, HD, {
  PRIMARY: {
    width: 120,
    height: 120
  }
}), (0,defineProperty/* default */.Z)(horizontalSquare_constants_templates$Horizontal2, FULL_HD, {
  PRIMARY: {
    width: 144,
    height: 144
  }
}), horizontalSquare_constants_templates$Horizontal2));
;// CONCATENATED MODULE: ./src/modules/tornado/horizontal-square/horizontalSquare.style.js

var horizontalSquare_style_PADDING, _TEXT_GAP, horizontalSquare_style_TEXT_LEFT_PADDING, horizontalSquare_style_IMAGE_OFFSET;
function horizontalSquare_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function horizontalSquare_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? horizontalSquare_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : horizontalSquare_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }








var horizontalSquare_style_defaultContext = makeDefaultStylingContext();
var horizontal_square_horizontalSquare_style_PADDING = (horizontalSquare_style_PADDING = {}, (0,defineProperty/* default */.Z)(horizontalSquare_style_PADDING, HD, 16), (0,defineProperty/* default */.Z)(horizontalSquare_style_PADDING, FULL_HD, 24), horizontalSquare_style_PADDING);
var TEXT_GAP = (_TEXT_GAP = {}, (0,defineProperty/* default */.Z)(_TEXT_GAP, HD, 4), (0,defineProperty/* default */.Z)(_TEXT_GAP, FULL_HD, 4), _TEXT_GAP);
var horizontal_square_horizontalSquare_style_TEXT_LEFT_PADDING = (horizontalSquare_style_TEXT_LEFT_PADDING = {}, (0,defineProperty/* default */.Z)(horizontalSquare_style_TEXT_LEFT_PADDING, HD, 24), (0,defineProperty/* default */.Z)(horizontalSquare_style_TEXT_LEFT_PADDING, FULL_HD, 24), horizontalSquare_style_TEXT_LEFT_PADDING);
var horizontal_square_horizontalSquare_style_IMAGE_OFFSET = (horizontalSquare_style_IMAGE_OFFSET = {}, (0,defineProperty/* default */.Z)(horizontalSquare_style_IMAGE_OFFSET, HD, focus_BORDER_WIDTH[HD] * 2), (0,defineProperty/* default */.Z)(horizontalSquare_style_IMAGE_OFFSET, FULL_HD, focus_BORDER_WIDTH[FULL_HD] * 2), horizontalSquare_style_IMAGE_OFFSET);
var getImageSize = function getImageSize(screenSize) {
  return horizontalSquare_constants_imageOptions[horizontalSquare_constants_templates.HorizontalSquare][screenSize].PRIMARY.height;
};
var horizontalSquare_style_colors = {
  background: makeThemeColor(PRIMARY, 0.1),
  border: horizontalSquare_constants_BORDER_COLOR,
  innerBorder: horizontalSquare_constants_INNER_BORDER_COLOR,
  text: makeThemeColor(PRIMARY)
};
var horizontalSquare_style_makeBasicTextStyle = function makeBasicTextStyle(_ref) {
  var font = _ref.font,
    _ref$colorMode = _ref.colorMode,
    colorMode = _ref$colorMode === void 0 ? DEFAULT_MODE : _ref$colorMode;
  return {
    color: horizontalSquare_style_colors.text[colorMode],
    text: horizontalSquare_style_objectSpread(horizontalSquare_style_objectSpread({}, font), {}, {
      verticalAlign: 'middle',
      wordWrap: false,
      textOverflow: '...'
    })
  };
};
var horizontalSquare_style_makeBasicIconStyle = function makeBasicIconStyle() {
  return {
    alpha: 0.8
  };
};
var horizontalSquare_style_getInitialStyle = function getInitialStyle() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : horizontalSquare_style_defaultContext,
    _ref2$screenSize = _ref2.screenSize,
    screenSize = _ref2$screenSize === void 0 ? FULL_HD : _ref2$screenSize,
    _ref2$colorMode = _ref2.colorMode,
    colorMode = _ref2$colorMode === void 0 ? DEFAULT_MODE : _ref2$colorMode;
  var _sizes$templates$Hori = horizontalSquare_constants_sizes[horizontalSquare_constants_templates.HorizontalSquare][screenSize],
    w = _sizes$templates$Hori.w,
    h = _sizes$templates$Hori.h;
  var gap = TEXT_GAP[screenSize];
  var imageSize = getImageSize(screenSize);
  var verticalOffset = Math.round((h - imageSize) / 2);
  return {
    Background: {
      alpha: 0,
      w: w,
      h: h,
      color: horizontalSquare_style_colors.background[colorMode],
      shader: {
        radius: 8
      }
    },
    Border: {
      x: horizontal_square_horizontalSquare_style_PADDING[screenSize] - focus_BORDER_WIDTH[screenSize],
      y: verticalOffset - focus_BORDER_WIDTH[screenSize],
      w: imageSize + horizontal_square_horizontalSquare_style_IMAGE_OFFSET[screenSize],
      h: imageSize + horizontal_square_horizontalSquare_style_IMAGE_OFFSET[screenSize],
      shader: {
        outline: focus_BORDER_WIDTH[screenSize],
        radius: rtlde_focus_BORDER_RADIUS[screenSize],
        strokeColor: colors_TRANSPARENT
      }
    },
    ScalableContent: {
      x: horizontal_square_horizontalSquare_style_PADDING[screenSize],
      y: verticalOffset,
      w: imageSize,
      h: imageSize,
      shader: {
        stroke: 0,
        strokeColor: horizontalSquare_style_colors.border[colorMode],
        radius: rtlde_focus_BORDER_RADIUS[screenSize]
      }
    },
    FlexContainer: {
      flex: {
        direction: 'column',
        justifyContent: 'center'
      },
      x: horizontal_square_horizontalSquare_style_PADDING[screenSize] + imageSize + horizontal_square_horizontalSquare_style_TEXT_LEFT_PADDING[screenSize],
      y: verticalOffset,
      h: h - verticalOffset * 2,
      Line1: horizontalSquare_style_objectSpread(horizontalSquare_style_objectSpread({}, horizontalSquare_style_makeBasicTextStyle({
        font: src_getFont(horizontalSquare_constants_TITLE_FONT_NAME, screenSize, horizontalSquare_constants_TITLE_FONT_TYPE),
        colorMode: colorMode
      })), {}, {
        flexItem: {
          marginBottom: gap
        }
      }),
      Line2: horizontalSquare_style_objectSpread(horizontalSquare_style_objectSpread({}, horizontalSquare_style_makeBasicTextStyle({
        font: src_getFont(constants_FONT.BERLIN_1, screenSize),
        colorMode: colorMode
      })), {}, {
        flexItem: {
          marginBottom: gap
        }
      }),
      Line3: {
        text: horizontalSquare_style_objectSpread(horizontalSquare_style_objectSpread({}, src_getFont(constants_FONT.BERLIN_1, screenSize)), {}, {
          maxLines: 2,
          verticalAlign: 'middle',
          wordWrap: true,
          maxLinesSuffix: '...'
        }),
        flexItem: {
          marginBottom: gap
        }
      },
      ProgressBar: {
        flexItem: {
          marginTop: 16
        }
      }
    }
  };
};
var horizontalSquare_style_getFocusedStyle = memoize_default()(function (_ref3) {
  var colorMode = _ref3.colorMode;
  return {
    Background: {
      smooth: {
        alpha: 1
      }
    },
    Border: {
      smooth: {
        scale: focus_SCALE_FOCUSED,
        'shader.strokeColor': horizontalSquare_style_colors.border[colorMode],
        'shader.innerColor': horizontalSquare_style_colors.innerBorder[colorMode],
        'shader.scale': focus_SCALE_FOCUSED
      }
    },
    ScalableContent: {
      smooth: {
        scale: 1.05
      }
    }
  };
}, cacheResolver);
var horizontalSquare_style_unFocusedStyle = {
  Background: {
    smooth: {
      alpha: 0
    }
  },
  Border: {
    smooth: {
      scale: 1,
      'shader.strokeColor': colors_TRANSPARENT,
      'shader.innerColor': colors_TRANSPARENT,
      'shader.scale': 1.0
    }
  },
  ScalableContent: {
    smooth: {
      scale: 1
    }
  }
};
;// CONCATENATED MODULE: ./src/modules/tornado/horizontal-square/customer/rtlde/horizontalSquare.utils.js




var getLines = function getLines() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    extraTitle = _ref.extraTitle,
    details = _ref.details,
    highlight = _ref.highlight,
    description = _ref.description;
  return [extraTitle || '', [details, highlight].filter(Boolean).join(' | '), description || ''];
};
;// CONCATENATED MODULE: ./src/modules/tornado/horizontal-square/horizontalSquare.utils.js

;// CONCATENATED MODULE: ./src/modules/tornado/horizontal-square/horizontalSquare.component.js







function horizontalSquare_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function horizontalSquare_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? horizontalSquare_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : horizontalSquare_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function horizontalSquare_component_createSuper(t) { var r = horizontalSquare_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function horizontalSquare_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (horizontalSquare_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }












var HorizontalSquare = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(HorizontalSquare, _Lightning$Component);
  var _super = horizontalSquare_component_createSuper(HorizontalSquare);
  function HorizontalSquare() {
    (0,classCallCheck/* default */.Z)(this, HorizontalSquare);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(HorizontalSquare, [{
    key: "_construct",
    value: function _construct() {
      this._index = 0;
      this._style = horizontalSquare_style_defaultContext;
    }
  }, {
    key: "_inactive",
    value: function _inactive() {
      this.signal(INACTIVE_SIGNAL, this);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this._item = undefined;
      this.signal(DETACHED_SIGNAL, this);
    }
  }, {
    key: "item",
    get: function get() {
      return this._item;
    },
    set: function set(_ref) {
      var content = _ref.content,
        config = _ref.config,
        template = _ref.template,
        _ref$colorScheme = _ref.colorScheme,
        colorScheme = _ref$colorScheme === void 0 ? horizontalSquare_style_defaultContext.colorMode : _ref$colorScheme;
      var templateDataAccessPath = [template, this._style.screenSize];
      var progress = makeProgressBarProperties(content.progress);
      if (areContentItemsEqual(this._item, content)) {
        this._item = content;
        this.patch({
          FlexContainer: {
            Line3: {
              visible: !progress.visible
            },
            ProgressBar: progress
          }
        });
        return;
      }
      this._item = content;
      this._config = config || get_default()(horizontalSquare_constants_sizes, templateDataAccessPath, {});
      this._itemTemplate = template;
      var wordWrapWidth = this.wordWrapWidth;
      var imageUrl = get_default()(this._item, 'image.src', '');
      var _getLines = getLines(this._item),
        _getLines2 = (0,slicedToArray/* default */.Z)(_getLines, 3),
        line1 = _getLines2[0],
        line2 = _getLines2[1],
        line3 = _getLines2[2];
      var screenSize = this._style.screenSize;
      this.patch({
        Background: {
          w: this._config.w,
          h: this._config.h
        },
        ScalableContent: {
          src: imageUrl,
          shader: {
            strokeColor: horizontalSquare_style_colors.border[colorScheme]
          }
        },
        FlexContainer: {
          Line1: makeTextPatch(line1, wordWrapWidth, LINE1_COLOR[colorScheme]),
          Line2: makeTextPatch(line2, wordWrapWidth, LINE2_COLOR[colorScheme]),
          Line3: horizontalSquare_component_objectSpread(horizontalSquare_component_objectSpread({}, makeTextPatch(line3, wordWrapWidth, LINE3_COLOR[colorScheme])), {}, {
            visible: !progress.visible
          }),
          ProgressBar: horizontalSquare_component_objectSpread({
            w: this._config.w - (getImageSize(screenSize) + horizontal_square_horizontalSquare_style_TEXT_LEFT_PADDING[screenSize] + horizontal_square_horizontalSquare_style_PADDING[screenSize] * 2)
          }, progress)
        }
      });
    }
  }, {
    key: "wordWrapWidth",
    get: function get() {
      var _get2 = get_default()(horizontalSquare_constants_imageOptions, [this._itemTemplate, this._style.screenSize], {}),
        imageWidth = _get2.PRIMARY.width;
      var padding = horizontal_square_horizontalSquare_style_TEXT_LEFT_PADDING[this._style.screenSize];
      var width = this._config.w || this.finalW;
      var safetyMargin = safetyMargins.vertical[this._style.screenSize];
      return width - imageWidth - padding - safetyMargin;
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this.patch(horizontalSquare_style_getFocusedStyle(this._style));
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this.patch(horizontalSquare_style_unFocusedStyle);
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      this.signal(SELECTED_SIGNAL, this._item);
      return true;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Background: {
          rect: true,
          shader: {
            type: src_Lightning.shaders.RoundedRectangle
          }
        },
        Border: {
          rect: true,
          shader: {
            type: focus_shader
          }
        },
        ScalableContent: {
          shader: {
            type: src_Lightning.shaders.RoundedRectangle
          }
        },
        FlexContainer: {
          Line1: {},
          Line2: {},
          Line3: {},
          ProgressBar: {
            type: Progress,
            visible: false
          }
        }
      }, horizontalSquare_style_getInitialStyle());
    }
  }]);
  return HorizontalSquare;
}(src_Lightning.Component);

HorizontalSquare.Templates = horizontalSquare_constants_templates;
HorizontalSquare.Sizes = horizontalSquare_constants_sizes;
HorizontalSquare.ImageOptions = horizontalSquare_constants_imageOptions;
;// CONCATENATED MODULE: ./src/modules/tornado/flatRectangle/customer/rtlde/flatRectangle.constants.js

var _templates$FlatRectan, _templates$FlatRectan2;


var flatRectangle_constants_INNER_BORDER_COLOR = makeThemeColor(TERTIARY);
var flatRectangle_constants_templates = {
  FlatRectangle: 'FlatRectangle'
};
var flatRectangle_constants_sizes = (0,defineProperty/* default */.Z)({}, flatRectangle_constants_templates.FlatRectangle, (_templates$FlatRectan = {}, (0,defineProperty/* default */.Z)(_templates$FlatRectan, HD, {
  w: 195,
  h: 52
}), (0,defineProperty/* default */.Z)(_templates$FlatRectan, FULL_HD, {
  w: 302,
  h: 80
}), _templates$FlatRectan));
var flatRectangle_constants_imageOptions = (0,defineProperty/* default */.Z)({}, flatRectangle_constants_templates.FlatRectangle, (_templates$FlatRectan2 = {}, (0,defineProperty/* default */.Z)(_templates$FlatRectan2, HD, {
  PRIMARY: {
    width: 195 * 2,
    height: 52 * 2
  }
}), (0,defineProperty/* default */.Z)(_templates$FlatRectan2, FULL_HD, {
  PRIMARY: {
    width: 302 * 2,
    height: 80 * 2
  }
}), _templates$FlatRectan2));
;// CONCATENATED MODULE: ./src/modules/tornado/flatRectangle/flatRectangle.constants.js

;// CONCATENATED MODULE: ./src/modules/tornado/flatRectangle/flatRectangle.style.js

var _TITLE_MARGIN, _TITLE_HEIGHT;
function flatRectangle_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function flatRectangle_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? flatRectangle_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : flatRectangle_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }









var flatRectangle_style_defaultContext = makeDefaultStylingContext();
var flatRectangle_style_colors = {
  title: makeThemeColor(PRIMARY),
  shadowColor: makeThemeColor(TERTIARY),
  border: makeThemeColor(PRIMARY),
  innerBorder: flatRectangle_constants_INNER_BORDER_COLOR
};
var TITLE_MARGIN = (_TITLE_MARGIN = {}, (0,defineProperty/* default */.Z)(_TITLE_MARGIN, HD, 12), (0,defineProperty/* default */.Z)(_TITLE_MARGIN, FULL_HD, 16), _TITLE_MARGIN);
var TITLE_HEIGHT = (_TITLE_HEIGHT = {}, (0,defineProperty/* default */.Z)(_TITLE_HEIGHT, HD, 30), (0,defineProperty/* default */.Z)(_TITLE_HEIGHT, FULL_HD, 36), _TITLE_HEIGHT);
var SHADOW_OFFSET_X = 2;
var SHADOW_OFFSET_Y = 2;
var flatRectangle_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : flatRectangle_style_defaultContext,
    screenSize = _ref.screenSize,
    colorMode = _ref.colorMode;
  var width = flatRectangle_constants_sizes[flatRectangle_constants_templates.FlatRectangle][screenSize].w;
  var height = flatRectangle_constants_sizes[flatRectangle_constants_templates.FlatRectangle][screenSize].h;
  var titleWidth = Math.floor(width - TITLE_MARGIN[screenSize] * 2);
  var titleMarginTop = Math.floor(height / 2 - TITLE_HEIGHT[screenSize] / 2);
  var offset = focus_BORDER_WIDTH[screenSize] * 2;
  return {
    zIndex: UNFOCUSED_Z_INDEX,
    w: width,
    h: height,
    Border: {
      x: -focus_BORDER_WIDTH[screenSize],
      y: -focus_BORDER_WIDTH[screenSize],
      w: width + offset,
      h: height + offset,
      shader: {
        outline: focus_BORDER_WIDTH[screenSize],
        radius: rtlde_focus_BORDER_RADIUS[screenSize],
        strokeColor: colors_TRANSPARENT
      }
    },
    Image: {
      w: width,
      h: height,
      shader: {
        radius: rtlde_focus_BORDER_RADIUS[screenSize]
      }
    },
    Title: {
      w: titleWidth,
      x: TITLE_MARGIN[screenSize],
      y: titleMarginTop,
      text: flatRectangle_style_objectSpread(flatRectangle_style_objectSpread({}, src_getFont(constants_FONT.OTTAWA_2, screenSize)), {}, {
        textColor: flatRectangle_style_colors.title[colorMode],
        textAlign: 'center',
        maxLines: 1,
        maxLinesSuffix: '...',
        verticalAlign: 'middle',
        shadow: true,
        shadowColor: flatRectangle_style_colors.shadowColor[colorMode],
        shadowOffsetX: SHADOW_OFFSET_X,
        shadowOffsetY: SHADOW_OFFSET_Y
      })
    }
  };
};
var flatRectangle_style_getFocusedStyle = memoize_default()(function (_ref2) {
  var colorMode = _ref2.colorMode;
  return {
    zIndex: FOCUSED_Z_INDEX,
    Border: {
      smooth: {
        scale: focus_SCALE_FOCUSED,
        'shader.strokeColor': flatRectangle_style_colors.border[colorMode],
        'shader.innerColor': flatRectangle_style_colors.innerBorder[colorMode],
        'shader.scale': focus_SCALE_FOCUSED
      }
    },
    Image: {
      smooth: {
        scale: focus_SCALE_FOCUSED,
        'shader.scale': focus_SCALE_FOCUSED
      }
    }
  };
}, cacheResolver);
var flatRectangle_style_unFocusedStyle = {
  zIndex: UNFOCUSED_Z_INDEX,
  Border: {
    smooth: {
      scale: 1,
      'shader.strokeColor': colors_TRANSPARENT,
      'shader.innerColor': colors_TRANSPARENT,
      'shader.scale': 1.0
    }
  },
  Image: {
    smooth: {
      scale: 1,
      'shader.scale': 1.0
    }
  }
};
;// CONCATENATED MODULE: ./src/modules/tornado/flatRectangle/flatRectangle.component.js






function flatRectangle_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function flatRectangle_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? flatRectangle_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : flatRectangle_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function flatRectangle_component_createSuper(t) { var r = flatRectangle_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function flatRectangle_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (flatRectangle_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }








var FlatRectangle = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(FlatRectangle, _Lightning$Component);
  var _super = flatRectangle_component_createSuper(FlatRectangle);
  function FlatRectangle() {
    (0,classCallCheck/* default */.Z)(this, FlatRectangle);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(FlatRectangle, [{
    key: "_construct",
    value: function _construct() {
      this._style = flatRectangle_component_objectSpread({}, flatRectangle_style_defaultContext);
    }
  }, {
    key: "_inactive",
    value: function _inactive() {
      this.signal(INACTIVE_SIGNAL, this);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this._item = undefined;
      this.signal(DETACHED_SIGNAL, this);
    }
  }, {
    key: "item",
    get: function get() {
      return this._item;
    },
    set: function set(_ref) {
      var content = _ref.content,
        _ref$colorScheme = _ref.colorScheme,
        colorScheme = _ref$colorScheme === void 0 ? this._style.colorMode : _ref$colorScheme;
      if (areContentItemsEqual(this._item, content)) {
        this._item = content;
        return;
      }
      this._item = content;
      if (colorScheme && colorScheme !== this._style.colorMode) {
        this._style = {
          screenSize: this._style.screenSize,
          colorMode: colorScheme
        };
      }
      var _this$_item = this._item,
        image = _this$_item.image,
        title = _this$_item.title;
      var src = image ? image.src : '';
      this.patch({
        Image: {
          src: src
        },
        Title: {
          text: {
            text: title || ''
          }
        }
      });
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this.patch(flatRectangle_style_getFocusedStyle(this._style));
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this.patch(flatRectangle_style_unFocusedStyle);
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      this.signal(SELECTED_SIGNAL, this._item);
      return true;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Border: {
          rect: true,
          shader: {
            type: focus_shader
          }
        },
        Image: {
          shader: {
            type: ImageShader
          }
        },
        Title: {}
      }, flatRectangle_style_getInitialStyle());
    }
  }]);
  return FlatRectangle;
}(src_Lightning.Component);

FlatRectangle.Templates = flatRectangle_constants_templates;
FlatRectangle.Sizes = flatRectangle_constants_sizes;
FlatRectangle.ImageOptions = flatRectangle_constants_imageOptions;
;// CONCATENATED MODULE: ./src/modules/tornado/square/customer/rtlde/square.constants.js

var _templates$Square, square_constants_imageOptions, _iconSizes;


var square_constants_BORDER_COLOR = makeThemeColor(PRIMARY);
var square_constants_INNER_BORDER_COLOR = makeThemeColor(TERTIARY);
var square_constants_templates = {
  Square: 'Square'
};
var square_constants_sizes = (0,defineProperty/* default */.Z)({}, square_constants_templates.Square, (_templates$Square = {}, (0,defineProperty/* default */.Z)(_templates$Square, HD, {
  w: 136,
  h: 136
}), (0,defineProperty/* default */.Z)(_templates$Square, FULL_HD, {
  w: 184,
  h: 184
}), _templates$Square));
var rtlde_square_constants_imageOptions = (square_constants_imageOptions = {}, (0,defineProperty/* default */.Z)(square_constants_imageOptions, HD, {
  PRIMARY: {
    width: 136,
    height: 136
  }
}), (0,defineProperty/* default */.Z)(square_constants_imageOptions, FULL_HD, {
  PRIMARY: {
    width: 184,
    height: 184
  }
}), square_constants_imageOptions);
var iconSizes = (_iconSizes = {}, (0,defineProperty/* default */.Z)(_iconSizes, HD, {
  h: 80,
  w: 112
}), (0,defineProperty/* default */.Z)(_iconSizes, FULL_HD, {
  h: 96,
  w: 144
}), _iconSizes);
;// CONCATENATED MODULE: ./src/modules/tornado/square/square.constants.js

;// CONCATENATED MODULE: ./src/modules/tornado/square/square.style.js

var square_style_IMAGE_OFFSET, square_style_BORDER_RADIUS;








var square_style_defaultContext = makeDefaultStylingContext();
var square_square_style_IMAGE_OFFSET = (square_style_IMAGE_OFFSET = {}, (0,defineProperty/* default */.Z)(square_style_IMAGE_OFFSET, HD, focus_BORDER_WIDTH[HD] * 2), (0,defineProperty/* default */.Z)(square_style_IMAGE_OFFSET, FULL_HD, focus_BORDER_WIDTH[FULL_HD] * 2), square_style_IMAGE_OFFSET);
var square_square_style_BORDER_RADIUS = (square_style_BORDER_RADIUS = {}, (0,defineProperty/* default */.Z)(square_style_BORDER_RADIUS, HD, 8), (0,defineProperty/* default */.Z)(square_style_BORDER_RADIUS, FULL_HD, 8), square_style_BORDER_RADIUS);
var square_style_colors = {
  background: makeThemeColor(PRIMARY, 0.1),
  border: square_constants_BORDER_COLOR,
  innerBorder: square_constants_INNER_BORDER_COLOR
};
var square_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : square_style_defaultContext,
    screenSize = _ref.screenSize,
    colorMode = _ref.colorMode;
  return {
    Border: {
      x: -focus_BORDER_WIDTH[screenSize],
      y: -focus_BORDER_WIDTH[screenSize],
      shader: {
        outline: focus_BORDER_WIDTH[screenSize],
        radius: square_square_style_BORDER_RADIUS[screenSize],
        strokeColor: colors_TRANSPARENT
      }
    },
    Image: {
      shader: {
        radius: square_square_style_BORDER_RADIUS[screenSize],
        progressHeight: progress_style_HEIGHT,
        progressBackgroundColor: progress_style_colors.background[colorMode],
        progressBarColor: progress_style_colors.bar[colorMode]
      }
    }
  };
};
var square_style_getFocusedStyle = memoize_default()(function (_ref2) {
  var colorMode = _ref2.colorMode;
  return {
    Border: {
      smooth: {
        scale: focus_SCALE_FOCUSED,
        'shader.strokeColor': square_style_colors.border[colorMode],
        'shader.innerColor': square_style_colors.innerBorder[colorMode],
        'shader.scale': focus_SCALE_FOCUSED
      }
    },
    Image: {
      smooth: {
        scale: focus_SCALE_FOCUSED,
        'shader.scale': focus_SCALE_FOCUSED
      }
    }
  };
}, cacheResolver);
var square_style_unFocusedStyle = {
  Border: {
    smooth: {
      scale: 1,
      'shader.strokeColor': colors_TRANSPARENT,
      'shader.innerColor': colors_TRANSPARENT,
      'shader.scale': 1.0
    }
  },
  Image: {
    smooth: {
      scale: 1,
      'shader.scale': 1.0
    }
  }
};
;// CONCATENATED MODULE: ./src/modules/tornado/square/square.component.js





function square_component_createSuper(t) { var r = square_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function square_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (square_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }








var Square = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Square, _Lightning$Component);
  var _super = square_component_createSuper(Square);
  function Square() {
    (0,classCallCheck/* default */.Z)(this, Square);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Square, [{
    key: "_construct",
    value: function _construct() {
      this._style = square_style_defaultContext;
    }
  }, {
    key: "_inactive",
    value: function _inactive() {
      this.signal(INACTIVE_SIGNAL, this);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this._item = undefined;
      this.signal(DETACHED_SIGNAL, this);
      this.tag('Image').removeAllListeners('txLoaded');
    }
  }, {
    key: "item",
    get: function get() {
      return this._item;
    },
    set: function set(_ref) {
      var content = _ref.content,
        config = _ref.config;
      if (areContentItemsEqual(this._item, content)) {
        this._item = content;
        return;
      }
      this._item = content;
      this._config = config || square_constants_sizes[square_constants_templates.Square][this._style.screenSize];
      var imageUrl = content.image && content.image.src || '';
      var offset = square_square_style_IMAGE_OFFSET[this._style.screenSize];
      var image = this.tag('Image');
      image.once('txLoaded', function () {
        image.setSmooth('alpha', 1);
      });
      this.patch({
        w: this._config.w,
        h: this._config.h,
        Border: {
          w: this._config.w + offset,
          h: this._config.h + offset
        },
        Image: {
          w: this._config.w,
          h: this._config.h,
          src: imageUrl,
          alpha: 0.0001
        }
      });
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this.patch(square_style_getFocusedStyle({
        colorMode: this._style.colorMode
      }));
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this.patch(square_style_unFocusedStyle);
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      this.signal(SELECTED_SIGNAL, this._item);
      return true;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Border: {
          rect: true,
          shader: {
            type: focus_shader
          }
        },
        Image: {
          shader: {
            type: ImageShader
          }
        }
      }, square_style_getInitialStyle());
    }
  }]);
  return Square;
}(src_Lightning.Component);

Square.Templates = square_constants_templates;
Square.Sizes = square_constants_sizes;
Square.ImageOptions = rtlde_square_constants_imageOptions;
;// CONCATENATED MODULE: ./src/modules/tornado/bigSquare/customer/default/bigSquare.constants.js

var _templates$BigSquare, _templates$BigSquare2;

var bigSquare_constants_templates = {
  BigSquare: 'BigSquare'
};
var bigSquare_constants_sizes = (0,defineProperty/* default */.Z)({}, bigSquare_constants_templates.BigSquare, (_templates$BigSquare = {}, (0,defineProperty/* default */.Z)(_templates$BigSquare, HD, {
  w: 195,
  h: 189
}), (0,defineProperty/* default */.Z)(_templates$BigSquare, FULL_HD, {
  w: 250,
  h: 224
}), _templates$BigSquare));
var bigSquare_constants_imageOptions = (0,defineProperty/* default */.Z)({}, bigSquare_constants_templates.BigSquare, (_templates$BigSquare2 = {}, (0,defineProperty/* default */.Z)(_templates$BigSquare2, HD, {
  PRIMARY: {
    width: 80,
    height: 80
  }
}), (0,defineProperty/* default */.Z)(_templates$BigSquare2, FULL_HD, {
  PRIMARY: {
    width: 96,
    height: 96
  }
}), _templates$BigSquare2));
;// CONCATENATED MODULE: ./src/modules/tornado/utils/textures.js

var UNLOADED_TEXTURE_ALPHA = 0.00001;
var makeTextureDescriptor = function makeTextureDescriptor(src, w, h, resizeMode) {
  return {
    type: src_Lightning.textures.ImageTexture,
    src: src,
    resizeMode: {
      type: resizeMode,
      w: w,
      h: h
    }
  };
};
var cover = function cover(src, w, h) {
  return makeTextureDescriptor(src, w, h, 'cover');
};
var contain = function contain(src, w, h) {
  return makeTextureDescriptor(src, w, h, 'contain');
};
;// CONCATENATED MODULE: ./src/modules/tornado/bigSquare/bigSquare.constants.js

;// CONCATENATED MODULE: ./src/modules/tornado/bigSquare/bigSquare.style.js

var _borderWidth, _ICON_SIZE, _CONTENT_PADDING, _IMAGE_SIZE, _TITLE_ICON_BOX_HEIGH;
function bigSquare_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function bigSquare_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? bigSquare_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : bigSquare_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }









var screenSize = sizes_getScreenSize();
var bigSquare_style_defaultContext = makeDefaultStylingContext();
var bigSquare_style_colors = {
  background: makeThemeColor(PRIMARY, 0.1),
  text: makeThemeColor(PRIMARY)
};
var borderWidth = (_borderWidth = {}, (0,defineProperty/* default */.Z)(_borderWidth, HD, 2), (0,defineProperty/* default */.Z)(_borderWidth, FULL_HD, 4), _borderWidth);
var ICON_SIZE = (_ICON_SIZE = {}, (0,defineProperty/* default */.Z)(_ICON_SIZE, HD, 16), (0,defineProperty/* default */.Z)(_ICON_SIZE, FULL_HD, 24), _ICON_SIZE);
var CONTENT_PADDING = (_CONTENT_PADDING = {}, (0,defineProperty/* default */.Z)(_CONTENT_PADDING, HD, 12), (0,defineProperty/* default */.Z)(_CONTENT_PADDING, FULL_HD, 16), _CONTENT_PADDING);
var IMAGE_SIZE = (_IMAGE_SIZE = {}, (0,defineProperty/* default */.Z)(_IMAGE_SIZE, HD, 80), (0,defineProperty/* default */.Z)(_IMAGE_SIZE, FULL_HD, 96), _IMAGE_SIZE);
var TITLE_ICON_BOX_HEIGHT = (_TITLE_ICON_BOX_HEIGH = {}, (0,defineProperty/* default */.Z)(_TITLE_ICON_BOX_HEIGH, HD, 24), (0,defineProperty/* default */.Z)(_TITLE_ICON_BOX_HEIGH, FULL_HD, 30), _TITLE_ICON_BOX_HEIGH);
var PROGRESS_MARGIN_VERTICAL = 16;
var TITLE_MARGIN_LEFT = 4;
var EXTRA_TITLE_MARGIN_TOP = 4;
var PROGRESS_HEIGHT = 4;
var bigSquare_style_getIconViewBox = memoize_default()(function (screenSize) {
  return {
    w: ICON_SIZE[screenSize],
    h: ICON_SIZE[screenSize]
  };
});
var getContainerSize = memoize_default()(function (screenSize) {
  return {
    w: bigSquare_constants_sizes[bigSquare_constants_templates.BigSquare][screenSize].w - CONTENT_PADDING[screenSize] * 2,
    h: bigSquare_constants_sizes[bigSquare_constants_templates.BigSquare][screenSize].h - CONTENT_PADDING[screenSize] * 2
  };
});
var getActualTitleLeftOffset = function getActualTitleLeftOffset(isIconVisible) {
  return isIconVisible ? TITLE_MARGIN_LEFT + ICON_SIZE[screenSize] : 0;
};
var getTitleWrapWidth = memoize_default()(function (screenSize) {
  return getContainerSize(screenSize).w - bigSquare_style_getIconViewBox(screenSize).w - TITLE_MARGIN_LEFT;
});
var getProgressTopOffset = memoize_default()(function (screenSize) {
  return IMAGE_SIZE[screenSize] + PROGRESS_MARGIN_VERTICAL;
});
var getTitleIconBoxTopOffset = memoize_default()(function (screenSize) {
  return IMAGE_SIZE[screenSize] + PROGRESS_HEIGHT + PROGRESS_MARGIN_VERTICAL * 2;
});
var getExtraTitleTopOffset = memoize_default()(function (screenSize) {
  return IMAGE_SIZE[screenSize] + PROGRESS_HEIGHT + TITLE_ICON_BOX_HEIGHT[screenSize] + EXTRA_TITLE_MARGIN_TOP + PROGRESS_MARGIN_VERTICAL * 2;
});
var bigSquare_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : bigSquare_style_defaultContext,
    screenSize = _ref.screenSize,
    colorMode = _ref.colorMode;
  var _sizes$templates$BigS = bigSquare_constants_sizes[bigSquare_constants_templates.BigSquare][screenSize],
    w = _sizes$templates$BigS.w,
    h = _sizes$templates$BigS.h;
  var borderSize = focus_BORDER_WIDTH[screenSize];
  var borderOffset = borderSize * 2;
  var containerSize = getContainerSize(screenSize);
  return {
    Border: {
      w: w + borderOffset,
      h: h + borderOffset,
      x: -borderSize,
      y: -borderSize,
      color: colors_TRANSPARENT,
      shader: {
        radius: rtlde_focus_BORDER_RADIUS[screenSize],
        outline: focus_BORDER_WIDTH[screenSize],
        strokeColor: colors_TRANSPARENT,
        innerColor: colors_TRANSPARENT
      }
    },
    Background: {
      w: w,
      h: h,
      color: colors_TRANSPARENT,
      shader: {
        radius: rtlde_focus_BORDER_RADIUS[screenSize]
      }
    },
    ContentContainer: {
      w: containerSize.w,
      h: containerSize.h,
      x: CONTENT_PADDING[screenSize],
      y: CONTENT_PADDING[screenSize],
      Logo: {
        w: IMAGE_SIZE[screenSize],
        h: IMAGE_SIZE[screenSize]
      },
      Progress: {
        w: getContainerSize(screenSize).w,
        y: getProgressTopOffset(screenSize)
      },
      TitleIconBox: {
        w: identity,
        h: TITLE_ICON_BOX_HEIGHT[screenSize],
        y: getTitleIconBoxTopOffset(screenSize),
        Icon: {
          mountY: 0.5,
          y: middle,
          alpha: 0.8
        },
        Title: {
          color: bigSquare_style_colors.text[colorMode],
          text: bigSquare_style_objectSpread(bigSquare_style_objectSpread({}, src_getFont(constants_FONT.BERLIN_3, screenSize)), {}, {
            maxLines: 1,
            verticalAlign: 'middle',
            wordWrapWidth: getTitleWrapWidth(screenSize)
          })
        }
      },
      ExtraTitle: {
        y: getExtraTitleTopOffset(screenSize),
        color: bigSquare_style_colors.text[colorMode],
        text: bigSquare_style_objectSpread(bigSquare_style_objectSpread({}, src_getFont(constants_FONT.MADRID_1, screenSize)), {}, {
          maxLines: 1,
          verticalAlign: 'middle',
          wordWrapWidth: getContainerSize(screenSize).w
        }),
        alpha: 0.8
      }
    }
  };
};
var bigSquare_style_getFocusedStyle = memoize_default()(function (_ref2) {
  var colorMode = _ref2.colorMode;
  return {
    Border: {
      smooth: {
        scale: focus_SCALE_FOCUSED,
        'shader.strokeColor': BORDER_COLOR[colorMode],
        'shader.innerColor': INNER_BORDER_COLOR[colorMode],
        'shader.scale': focus_SCALE_FOCUSED
      }
    },
    Background: {
      smooth: {
        color: bigSquare_style_colors.background[colorMode],
        scale: focus_SCALE_FOCUSED
      }
    }
  };
}, cacheResolver);
var bigSquare_style_unFocusedStyle = {
  Border: {
    smooth: {
      scale: 1,
      'shader.strokeColor': colors_TRANSPARENT,
      'shader.innerColor': colors_TRANSPARENT,
      'shader.scale': 1.0
    }
  },
  Background: {
    smooth: {
      color: colors_TRANSPARENT,
      scale: 1,
      'shader.scale': 1.0
    }
  }
};
;// CONCATENATED MODULE: ./src/modules/tornado/bigSquare/bigSquare.component.js





function bigSquare_component_createSuper(t) { var r = bigSquare_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function bigSquare_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (bigSquare_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }











var BigSquare = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(BigSquare, _Lightning$Component);
  var _super = bigSquare_component_createSuper(BigSquare);
  function BigSquare() {
    (0,classCallCheck/* default */.Z)(this, BigSquare);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(BigSquare, [{
    key: "_construct",
    value: function _construct() {
      this._style = bigSquare_style_defaultContext;
    }
  }, {
    key: "_inactive",
    value: function _inactive() {
      this.signal(INACTIVE_SIGNAL, this);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this.signal(DETACHED_SIGNAL, this);
    }
  }, {
    key: "item",
    get: function get() {
      return this._item;
    },
    set: function set(_ref) {
      var content = _ref.content,
        colorScheme = _ref.colorScheme;
      var progress = getProgress(content.progress);
      if (areContentItemsEqual(this._item, content)) {
        this._item = content;
        this.patch({
          ContentContainer: {
            Progress: {
              progress: progress
            }
          }
        });
        return;
      }
      this._item = content;
      var screenSize = this._style.screenSize;
      var _this$_item = this._item,
        image = _this$_item.image,
        title = _this$_item.title,
        extraTitle = _this$_item.extraTitle,
        csaPicto = _this$_item.csaPicto;
      var imageUrl = image && image.src || '';
      if (colorScheme && colorScheme !== this._style.colorMode) {
        this._style = {
          screenSize: screenSize,
          colorMode: colorScheme
        };
      }
      this.patch({
        ContentContainer: {
          Logo: {
            visible: true,
            texture: contain(imageUrl, IMAGE_SIZE, IMAGE_SIZE)
          },
          Progress: {
            progress: progress,
            colorMode: this._style.colorMode
          },
          TitleIconBox: {
            Icon: {
              visible: Boolean(csaPicto),
              iconData: {
                picto: csaPicto,
                viewBox: bigSquare_style_getIconViewBox(screenSize)
              }
            },
            Title: {
              visible: Boolean(title),
              text: {
                text: title
              },
              x: getActualTitleLeftOffset(Boolean(csaPicto)),
              color: bigSquare_style_colors.text[this._style.colorMode]
            }
          },
          ExtraTitle: {
            visible: Boolean(extraTitle),
            text: {
              text: extraTitle
            },
            color: bigSquare_style_colors.text[this._style.colorMode]
          }
        }
      });
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this.patch(bigSquare_style_getFocusedStyle(this._style));
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this.patch(bigSquare_style_unFocusedStyle);
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      this.signal(SELECTED_SIGNAL, this._item);
      return true;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Border: {
          rect: true,
          shader: {
            type: focus_shader,
            useImageMask: true
          }
        },
        Background: {
          rect: true,
          shader: {
            type: src_Lightning.shaders.RoundedRectangle
          }
        },
        ContentContainer: {
          Logo: {},
          Progress: {
            type: Progress
          },
          TitleIconBox: {
            Icon: {
              type: Icon
            },
            Title: {}
          },
          ExtraTitle: {}
        }
      }, bigSquare_style_getInitialStyle());
    }
  }]);
  return BigSquare;
}(src_Lightning.Component);

BigSquare.Templates = bigSquare_constants_templates;
BigSquare.Sizes = bigSquare_constants_sizes;
BigSquare.ImageOptions = bigSquare_constants_imageOptions;
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/grid/customer/default/grid.constants.js

var _Card$Templates$CardS, _Card$Templates$CardM, _Card$Templates$CardL, _HorizontalCard$Templ, _HorizontalSquare$Tem, _Jacket$Templates$Jac, _Poster$Templates$Pos, _Poster$Templates$Pos2, _Poster$Templates$Pos3, _Portrait$Templates$P, _Totem$Templates$Tote, _FlatRectangle$Templa, _Square$Templates$Squ, _BigSquare$Templates$, _ITEMS_PER_ROW;











var ITEMS_PER_ROW = (_ITEMS_PER_ROW = {}, (0,defineProperty/* default */.Z)(_ITEMS_PER_ROW, Card.Templates.CardS, (_Card$Templates$CardS = {}, (0,defineProperty/* default */.Z)(_Card$Templates$CardS, HD, 5), (0,defineProperty/* default */.Z)(_Card$Templates$CardS, FULL_HD, 6), _Card$Templates$CardS)), (0,defineProperty/* default */.Z)(_ITEMS_PER_ROW, Card.Templates.CardM, (_Card$Templates$CardM = {}, (0,defineProperty/* default */.Z)(_Card$Templates$CardM, HD, 4), (0,defineProperty/* default */.Z)(_Card$Templates$CardM, FULL_HD, 5), _Card$Templates$CardM)), (0,defineProperty/* default */.Z)(_ITEMS_PER_ROW, Card.Templates.CardL, (_Card$Templates$CardL = {}, (0,defineProperty/* default */.Z)(_Card$Templates$CardL, HD, 3), (0,defineProperty/* default */.Z)(_Card$Templates$CardL, FULL_HD, 4), _Card$Templates$CardL)), (0,defineProperty/* default */.Z)(_ITEMS_PER_ROW, HorizontalCard.Templates.HorizontalCard, (_HorizontalCard$Templ = {}, (0,defineProperty/* default */.Z)(_HorizontalCard$Templ, HD, 1), (0,defineProperty/* default */.Z)(_HorizontalCard$Templ, FULL_HD, 1), _HorizontalCard$Templ)), (0,defineProperty/* default */.Z)(_ITEMS_PER_ROW, HorizontalSquare.Templates.HorizontalSquare, (_HorizontalSquare$Tem = {}, (0,defineProperty/* default */.Z)(_HorizontalSquare$Tem, HD, 1), (0,defineProperty/* default */.Z)(_HorizontalSquare$Tem, FULL_HD, 1), _HorizontalSquare$Tem)), (0,defineProperty/* default */.Z)(_ITEMS_PER_ROW, Jacket.Templates.Jacket, (_Jacket$Templates$Jac = {}, (0,defineProperty/* default */.Z)(_Jacket$Templates$Jac, HD, 5), (0,defineProperty/* default */.Z)(_Jacket$Templates$Jac, FULL_HD, 6), _Jacket$Templates$Jac)), (0,defineProperty/* default */.Z)(_ITEMS_PER_ROW, Poster.Templates.PosterS, (_Poster$Templates$Pos = {}, (0,defineProperty/* default */.Z)(_Poster$Templates$Pos, HD, 5), (0,defineProperty/* default */.Z)(_Poster$Templates$Pos, FULL_HD, 6), _Poster$Templates$Pos)), (0,defineProperty/* default */.Z)(_ITEMS_PER_ROW, Poster.Templates.PosterM, (_Poster$Templates$Pos2 = {}, (0,defineProperty/* default */.Z)(_Poster$Templates$Pos2, HD, 4), (0,defineProperty/* default */.Z)(_Poster$Templates$Pos2, FULL_HD, 4), _Poster$Templates$Pos2)), (0,defineProperty/* default */.Z)(_ITEMS_PER_ROW, Poster.Templates.PosterL, (_Poster$Templates$Pos3 = {}, (0,defineProperty/* default */.Z)(_Poster$Templates$Pos3, HD, 3), (0,defineProperty/* default */.Z)(_Poster$Templates$Pos3, FULL_HD, 3), _Poster$Templates$Pos3)), (0,defineProperty/* default */.Z)(_ITEMS_PER_ROW, Portrait.Templates.Portrait, (_Portrait$Templates$P = {}, (0,defineProperty/* default */.Z)(_Portrait$Templates$P, HD, 5), (0,defineProperty/* default */.Z)(_Portrait$Templates$P, FULL_HD, 6), _Portrait$Templates$P)), (0,defineProperty/* default */.Z)(_ITEMS_PER_ROW, Totem.Templates.Totem, (_Totem$Templates$Tote = {}, (0,defineProperty/* default */.Z)(_Totem$Templates$Tote, HD, 6), (0,defineProperty/* default */.Z)(_Totem$Templates$Tote, FULL_HD, 8), _Totem$Templates$Tote)), (0,defineProperty/* default */.Z)(_ITEMS_PER_ROW, FlatRectangle.Templates.FlatRectangle, (_FlatRectangle$Templa = {}, (0,defineProperty/* default */.Z)(_FlatRectangle$Templa, HD, 5), (0,defineProperty/* default */.Z)(_FlatRectangle$Templa, FULL_HD, 6), _FlatRectangle$Templa)), (0,defineProperty/* default */.Z)(_ITEMS_PER_ROW, Square.Templates.Square, (_Square$Templates$Squ = {}, (0,defineProperty/* default */.Z)(_Square$Templates$Squ, HD, 7), (0,defineProperty/* default */.Z)(_Square$Templates$Squ, FULL_HD, 8), _Square$Templates$Squ)), (0,defineProperty/* default */.Z)(_ITEMS_PER_ROW, BigSquare.Templates.BigSquare, (_BigSquare$Templates$ = {}, (0,defineProperty/* default */.Z)(_BigSquare$Templates$, HD, 5), (0,defineProperty/* default */.Z)(_BigSquare$Templates$, FULL_HD, 6), _BigSquare$Templates$)), _ITEMS_PER_ROW);
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/grid/grid.constants.js

var grid_constants_templates = {
  Grid: 'Grid'
};
var MAX_PREVIEW_ITEMS = 4;
var grid_constants_ITEMS_PLACEMENT_TIMEOUT = 100;
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/grid/grid.component.js













function grid_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function grid_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? grid_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : grid_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function grid_component_createSuper(t) { var r = grid_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function grid_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (grid_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }











var Grid = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Grid, _Lightning$Component);
  var _super = grid_component_createSuper(Grid);
  function Grid() {
    (0,classCallCheck/* default */.Z)(this, Grid);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Grid, [{
    key: "_construct",
    value: function _construct() {
      this._style = grid_style_defaultContext;
      this._viewport = {
        w: SCREEN_WIDTH[this._style.screenSize],
        h: sizes_SCREEN_HEIGHT[this._style.screenSize]
      };
      this._contentGap = rtlde_block_constants_CONTENT_GAP[this._style.screenSize];
      this._isRowActive = false;
      this._isRowAttached = false;
      this._resetVirtualization();
    }
  }, {
    key: "_active",
    value: function _active() {
      var _this = this;
      this._isRowActive = true;
      if (this._data) {
        if (this._isDataApplied) {
          this._placeItems();
        } else {
          this._timeout = setTimeout(function () {
            _this.data = _this._data;
          }, grid_constants_ITEMS_PLACEMENT_TIMEOUT);
        }
      }
    }
  }, {
    key: "_build",
    value: function _build() {
      this.patch(grid_style_getInitialStyle(this._style));
    }
  }, {
    key: "_attach",
    value: function _attach() {
      this._isGridAttached = true;
    }
  }, {
    key: "_inactive",
    value: function _inactive() {
      this._isGridActive = false;
      clearTimeout(this._timeout);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this._isGridAttached = false;
      this._resetVirtualization();
    }
  }, {
    key: "contentGap",
    get: function get() {
      return this._contentGap;
    },
    set: function set(value) {
      this._contentGap = value;
      this._placeItems();
    }
  }, {
    key: "contentPadding",
    get: function get() {
      return this.tag('Content').x;
    },
    set: function set(value) {
      this.tag('Content').x = value;
    }
  }, {
    key: "itemsPerRow",
    get: function get() {
      if (this._itemsPerRow) {
        return this._itemsPerRow;
      }
      var _this$_data = this._data,
        itemsPerRow = _this$_data.itemsPerRow,
        itemTemplate = _this$_data.itemTemplate;
      var screenSize = this._style.screenSize;
      this._itemsPerRow = itemsPerRow || ITEMS_PER_ROW[itemTemplate][screenSize];
      return this._itemsPerRow;
    }
  }, {
    key: "data",
    get: function get() {
      return this._data;
    },
    set: function set(value) {
      var _this2 = this;
      if (!value) {
        return;
      }
      this._data = value;
      if (!this._isRowActive) {
        return;
      }
      var isUpdating = this._isDataApplied;
      this._isDataApplied = true;
      var block = value.block,
        blockIndex = value.blockIndex,
        itemSize = value.itemSize,
        itemTemplate = value.itemTemplate,
        theme = value.theme,
        rowSize = value.rowSize,
        showAllItems = value.showAllItems,
        displayShowMore = value.displayShowMore;
      var _block$content = block.content,
        items = _block$content.items,
        pagination = _block$content.pagination;
      var blockTheme = getLayoutTheme(block.theme, theme);
      var totalItems = pagination.totalItems,
        itemsPerPage = pagination.itemsPerPage;
      var colorScheme = blockTheme.colorScheme;
      this._id = block.id;
      this._itemSize = itemSize;
      this._style = grid_component_objectSpread(grid_component_objectSpread({}, this._style), {}, {
        colorMode: blockTheme.colorScheme
      });
      this._items = (showAllItems || !displayShowMore ? items : items.slice(0, MAX_PREVIEW_ITEMS)).map(function (item, index) {
        var existingItem = _this2._items[index];
        if (existingItem) {
          existingItem.content = item;
          existingItem.config = itemSize;
          existingItem.template = itemTemplate;
          existingItem.colorScheme = _this2._colorScheme;
          return existingItem;
        }
        return _this2._makeItemData(item, index);
      });
      this._pages = block.pages;
      this._totalItems = showAllItems ? totalItems : this._items.length;
      this._itemsPerPage = showAllItems ? itemsPerPage : 0;
      var titleText = getTitle(block.title);
      var hasTitle = Boolean(titleText);
      var blockStyle = grid_style_getBlockStyle({
        hasTitle: hasTitle,
        isFirstBlock: blockIndex === 0,
        screenSize: this._style.screenSize
      });
      var displayShowMoreButton = displayShowMore && !showAllItems && items.length > MAX_PREVIEW_ITEMS;
      this.patch({
        Content: {
          Title: grid_component_objectSpread({
            visible: hasTitle,
            color: grid_style_colors.title[colorScheme],
            text: {
              text: titleText
            }
          }, blockStyle.title),
          Container: grid_component_objectSpread({}, blockStyle.items)
        },
        More: {
          visible: displayShowMoreButton,
          y: rowSize.h - block_constants_PADDING.BOTTOM[this._style.screenSize]
        }
      });
      this._setIndex(Math.min(this._focusedItemIndex, Math.max(this._totalItems - (displayShowMoreButton ? 0 : 1), 0)));
      if (isUpdating) {
        var views = Object.keys(this._views);
        if (views.length > this._totalItems) {
          for (var i = 0; i < views.length; i += 1) {
            var viewIndex = views[i];
            if (viewIndex >= this._totalItems) {
              this._backToBuffer(this._views[viewIndex]);
            }
          }
        }
      }
      this._refocus();
    }
  }, {
    key: "_makeItemData",
    value: function _makeItemData(content, index) {
      var _this$_data2 = this._data,
        itemSize = _this$_data2.itemSize,
        itemTemplate = _this$_data2.itemTemplate;
      return {
        content: content,
        index: index,
        config: itemSize,
        template: itemTemplate,
        colorScheme: this._colorScheme
      };
    }
  }, {
    key: "focusedIndex",
    get: function get() {
      return this._focusedItemIndex;
    },
    set: function set(value) {
      if (this._totalItems) {
        this._focusedItemIndex = Math.min(this.maxIndex, Math.max(value, 0));
      } else {
        this._focusedItemIndex = value;
      }
    }
  }, {
    key: "maxIndex",
    get: function get() {
      if (!Number.isFinite(this._totalItems)) {
        return 0;
      }
      return this._totalItems - (this.tag('More').visible ? 0 : 1);
    }
  }, {
    key: "goTo",
    value: function goTo(index) {
      this._setIndex(index);
    }
  }, {
    key: "_setIndex",
    value: function _setIndex(index) {
      this._focusedItemIndex = index;
      if (!this._totalItems) {
        return;
      }
      if (this._isRowActive) {
        this._placeItems();
      }
      this.signal(FOCUSED_SIGNAL, index);
      if (this._itemsPerPage > 0) {
        var rowHeight = this._data.itemSize.h + this._contentGap;
        var visibleRows = Math.ceil(this._viewport.h / rowHeight) + 1;
        var bufferSize = visibleRows * this.itemsPerRow;
        var nextPage = Math.floor(Math.min(this._focusedItemIndex + bufferSize, this._totalItems - 1) / this._itemsPerPage);
        for (var i = nextPage; i > 0; i -= 1) {
          var isLoaded = this._pages[i] !== PAGE_STATE.MISSING;
          if (isLoaded) {
            continue;
          }
          var start = i * this._itemsPerPage;
          this.signal(PORTION_REQUESTED_SIGNAL, {
            id: this._id,
            page: i + 1,
            start: start
          });
        }
      }
    }
  }, {
    key: "_getFromBufferOrCreate",
    value: function _getFromBufferOrCreate() {
      var _signals;
      var _this$_data3 = this._data,
        itemType = _this$_data3.itemType,
        itemSize = _this$_data3.itemSize,
        itemTemplate = _this$_data3.itemTemplate;
      var existingView = getFromBuffer(itemTemplate);
      if (existingView) {
        return existingView;
      }
      return this.stage.c({
        type: itemType,
        w: itemSize.w,
        h: itemSize.h,
        template: itemTemplate,
        passSignals: (0,defineProperty/* default */.Z)({}, SELECTED_SIGNAL, true),
        signals: (_signals = {}, (0,defineProperty/* default */.Z)(_signals, INACTIVE_SIGNAL, '_onViewBecomeInactive'), (0,defineProperty/* default */.Z)(_signals, DETACHED_SIGNAL, '_onViewBecomeDetached'), _signals)
      });
    }
  }, {
    key: "_onViewBecomeInactive",
    value: function _onViewBecomeInactive(view) {
      if (this._isRowAttached) {
        this._backToBuffer(view);
      }
    }
  }, {
    key: "_onViewBecomeDetached",
    value: function _onViewBecomeDetached(view) {
      cleanupBuffer(view);
    }
  }, {
    key: "_backToBuffer",
    value: function _backToBuffer(view) {
      var _this3 = this;
      Object.keys(this._views).filter(function (key) {
        return _this3._views[key].id === view.id;
      }).forEach(function (key) {
        delete _this3._views[key];
      });
      backToBuffer(view);
      view.visible = false;
    }
  }, {
    key: "_calculateItemPosition",
    value: function _calculateItemPosition(itemSize, index) {
      return {
        x: (itemSize.w + this._contentGap) * (index % this.itemsPerRow),
        y: (itemSize.h + this._contentGap) * Math.floor(index / this.itemsPerRow)
      };
    }
  }, {
    key: "_makeItemRenderer",
    value: function _makeItemRenderer(item, index) {
      var _this$_data4 = this._data,
        itemSize = _this$_data4.itemSize,
        itemType = _this$_data4.itemType;
      return grid_component_objectSpread(grid_component_objectSpread({
        type: itemType,
        w: itemSize.w,
        h: itemSize.h
      }, this._calculateItemPosition(itemSize, index)), {}, {
        item: item,
        passSignals: (0,defineProperty/* default */.Z)({}, SELECTED_SIGNAL, true)
      });
    }
  }, {
    key: "_placeItems",
    value: function _placeItems() {
      if (!this._data) {
        return;
      }
      var container = this.tag('Container');
      var rowHeight = this._data.itemSize.h + this._contentGap;
      var visibleRows = Math.ceil(this._viewport.h / rowHeight) + 1;
      var bufferSize = visibleRows * this.itemsPerRow;
      var toRender = [];
      var startIndex = Math.max(this._focusedItemIndex - bufferSize, 0);
      var endIndex = Math.min(this._focusedItemIndex + bufferSize, this._totalItems - 1);
      for (var i = startIndex; i <= endIndex; i += 1) {
        toRender.push(i);
      }
      for (var _i = 0; _i < toRender.length; _i += 1) {
        var index = toRender[_i];
        var view = this._views[index];
        if (!view) {
          view = this._getFromBufferOrCreate();
        }
        var row = Math.floor(index / this.itemsPerRow);
        var column = index % this.itemsPerRow;
        view.index = index;
        if (this._items[index]) {
          view.item = this._items[index];
        } else {
          view.item = this._makeItemData(PLACEHOLDER, index);
        }
        view.x = column * (this._data.itemSize.w + this._contentGap);
        view.y = row * (this._data.itemSize.h + this._contentGap);
        view.visible = true;
        if (view.parent !== container) {
          container.childList.add(view);
        }
        this._views[index] = view;
      }
    }
  }, {
    key: "_handleUp",
    value: function _handleUp() {
      if (this._focusedItemIndex === this._totalItems) {
        this._setIndex(Number.isFinite(this._lastGridIndex) ? this._lastGridIndex : this._totalItems - 1);
        this._lastGridIndex = undefined;
        return true;
      }
      if (this._focusedItemIndex >= this.itemsPerRow) {
        this._setIndex(this._focusedItemIndex - this.itemsPerRow);
        return false;
      }
      return false;
    }
  }, {
    key: "_handleDown",
    value: function _handleDown() {
      var index = this._focusedItemIndex + this.itemsPerRow;
      if (index <= this._totalItems - 1) {
        this._setIndex(index, true);
      } else {
        var rowCount = Math.ceil(this._totalItems / this.itemsPerRow);
        var currentRow = Math.floor(this._focusedItemIndex / this.itemsPerRow);
        if (currentRow < rowCount - 1) {
          this._setIndex(this._totalItems - 1, true);
        } else if (this._focusedItemIndex < this._totalItems && this.tag('More').visible) {
          this._lastGridIndex = this._focusedItemIndex;
          this._focusedItemIndex = this._totalItems;
          return true;
        }
      }
      return false;
    }
  }, {
    key: "_handleLeft",
    value: function _handleLeft() {
      if (this._focusedItemIndex % this.itemsPerRow === 0) {
        return false;
      }
      if (this._focusedItemIndex > 0) {
        this._setIndex(this._focusedItemIndex - 1);
        return true;
      }
      return false;
    }
  }, {
    key: "_handleRight",
    value: function _handleRight() {
      if (this._focusedItemIndex % this.itemsPerRow === this.itemsPerRow - 1) {
        return false;
      }
      if (this._focusedItemIndex < this.tag('Container').children.length - 1) {
        this._setIndex(this._focusedItemIndex + 1);
        return true;
      }
      return false;
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      if (this._focusedItemIndex === this._totalItems) {
        this.signal(SHOW_GRID_SIGNAL, this._data);
        return true;
      }
      this.signal(SELECTED_SIGNAL, this._items[this._focusedItemIndex]);
      return true;
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this._placeItems();
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      if (this._focusedItemIndex >= this._totalItems) {
        return this._tag('More');
      }
      return this._views[this._focusedItemIndex];
    }
  }, {
    key: "_resetVirtualization",
    value: function _resetVirtualization() {
      this._data = undefined;
      this._isDataApplied = false;
      this._focusedItemIndex = 0;
      this._offset = 0;
      this._itemsPerPage = 0;
      this._startPoint = 0;
      this._lastGridIndex = undefined;
      this._items = [];
      this._views = {};
      this._pages = {};
    }
  }], [{
    key: "_template",
    value: function _template() {
      return {
        Content: {
          Title: {},
          Container: {}
        },
        More: {
          type: Button,
          label: t('global.showMore'),
          x: function x(v) {
            return v / 2;
          }
        }
      };
    }
  }, {
    key: "getOffsetsByBlockData",
    value: function getOffsetsByBlockData(_ref) {
      var data = _ref.data,
        blockIndex = _ref.blockIndex,
        _ref$screenSize = _ref.screenSize,
        screenSize = _ref$screenSize === void 0 ? FULL_HD : _ref$screenSize,
        showAllItems = _ref.showAllItems,
        displayShowMore = _ref.displayShowMore;
      var title = data.title,
        content = data.content;
      var hasTitle = Boolean(getTitle(title));
      var _getBlockStyle = grid_style_getBlockStyle({
          hasTitle: hasTitle,
          isFirstBlock: blockIndex === 0,
          screenSize: screenSize
        }),
        items = _getBlockStyle.items,
        bottom = _getBlockStyle.padding.bottom;
      return {
        top: items.y,
        bottom: bottom + (!showAllItems && displayShowMore && content.items.length > MAX_PREVIEW_ITEMS ? HEIGHT[screenSize] + block_constants_PADDING.BOTTOM[screenSize] : 0)
      };
    }
  }, {
    key: "getRowCount",
    value: function getRowCount(_ref2, screenSize) {
      var content = _ref2.content,
        showAllItems = _ref2.showAllItems,
        displayShowMore = _ref2.displayShowMore;
      var contentTemplateId = content.contentTemplateId,
        items = content.items,
        pagination = content.pagination;
      var slicedCount = displayShowMore ? Math.min(MAX_PREVIEW_ITEMS, items.length) : items.length;
      var count = showAllItems ? pagination.totalItems : slicedCount;
      return Math.ceil(count / ITEMS_PER_ROW[contentTemplateId][screenSize]);
    }
  }, {
    key: "getContentGap",
    value: function getContentGap(screenSize) {
      return rtlde_block_constants_CONTENT_GAP[screenSize];
    }
  }]);
  return Grid;
}(src_Lightning.Component);

Grid.Templates = grid_constants_templates;
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/addHours/index.js



var MILLISECONDS_IN_HOUR = 3600000;
/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the hours added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */

function addHours(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_HOUR);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/startOfDay/index.js


/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */

function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/differenceInMilliseconds/index.js


/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of milliseconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */

function differenceInMilliseconds(dateLeft, dateRight) {
  requiredArgs(2, arguments);
  return toDate(dateLeft).getTime() - toDate(dateRight).getTime();
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/roundingMethods/index.js
var roundingMap = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function (value) {
    return value < 0 ? Math.ceil(value) : Math.floor(value);
  } // Math.trunc is not supported by IE

};
var defaultRoundingMethod = 'trunc';
function getRoundingMethod(method) {
  return method ? roundingMap[method] : roundingMap[defaultRoundingMethod];
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/differenceInSeconds/index.js



/**
 * @name differenceInSeconds
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of seconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * const result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */

function differenceInSeconds_differenceInSeconds(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / 1000;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}
;// CONCATENATED MODULE: ./src/modules/popups/popups.constants.js
var EXIT_POPUP_ID = 'exitPopup';
var COMMON_POPUP_ID = 'commonPopup';
var FATAL_ERROR_POPUP_ID = 'fatalErrorPopup';
var AGE_GATE_POPUP_ID = 'contentRatingAdvisoryPopup';
var GEO_BLOCK_POPUP_ID = 'geoBlockedPopup';
var CSL_BLOCK_POPUP_ID = 'CSLBlockedPopup';
var PROFILES_GATE_POPUP_ID = 'profilesGatePopup';
var KIDS_LEAVE_POPUP_ID = 'kidsLeavePopup';
var BROADCASTING_LOCK_POPUP_ID = 'liveBroadcastingLockPopup';
var FREEMIUM_LOCK_POPUP_ID = 'freemiumLockPopup';
var PARENTAL_CODE_POPUP_ID = 'parentalCodePopup';
var EPG_POPUP_ID = 'epgPopup';
var EPG_LAYOUT_POPUP_ID = 'epgLayoutPopup';
var GRID_POPUP_ID = 'gridPopup';
var SUBSCRIPTION_POPUP_ID = 'subscriptionPopup';
var ACCOUNT_COMPLETION_POPUP_ID = 'accountCompletionPopup';
var CONTENT_RATING_POPUP_ID = 'contentRating';
var PARENTAL_FILTER_POPUP_ID = 'parentalFilter';
;// CONCATENATED MODULE: ./src/logic/popup/popup.constants.js
var POPUP_ID = 'popup/POPUP_ID';
;// CONCATENATED MODULE: ./src/logic/popup/popup.actions.js

var showPopupAction = function showPopupAction(popupId) {
  var popupOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (dispatch) {
    dispatch({
      type: POPUP_ID,
      popupId: popupId,
      popupOptions: popupOptions
    });
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/notifications.js
var NOTIFICATION_LEVEL = {
  SYSTEM: 'SYSTEM',
  SUCCESS: 'SUCCESS',
  WARNING: 'WARNING',
  ERROR: 'ERROR'
};
var makeNotification = function makeNotification(level, text, icon) {
  return {
    level: level,
    text: text,
    icon: icon
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/epg/epgBox/epgBox.style.js

var _IMAGE_WIDTH, epgBox_style_BORDER_RADIUS;
function epgBox_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function epgBox_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? epgBox_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : epgBox_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






var epgBox_style_defaultContext = makeDefaultStylingContext();
var epgBox_style_colors = {
  backgroundUnfocused: makeThemeColor(HIGHLIGHT),
  backgroundFocused: makeThemeColor(CLOUD_NORMAL),
  border: makeThemeColor(PRIMARY),
  text: makeThemeColor(PRIMARY)
};
var IMAGE_WIDTH = (_IMAGE_WIDTH = {}, (0,defineProperty/* default */.Z)(_IMAGE_WIDTH, HD, 73), (0,defineProperty/* default */.Z)(_IMAGE_WIDTH, FULL_HD, 84), _IMAGE_WIDTH);
var epgBox_epgBox_style_BORDER_RADIUS = (epgBox_style_BORDER_RADIUS = {}, (0,defineProperty/* default */.Z)(epgBox_style_BORDER_RADIUS, HD, 8), (0,defineProperty/* default */.Z)(epgBox_style_BORDER_RADIUS, FULL_HD, 8), epgBox_style_BORDER_RADIUS);
var epgBox_style_GAP = 8;
var epgBox_style_ICON_SIZE = 16;
var epgBox_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : epgBox_style_defaultContext,
    screenSize = _ref.screenSize,
    colorMode = _ref.colorMode;
  return {
    zIndex: UNFOCUSED_Z_INDEX,
    Border: {
      shader: {
        radius: epgBox_epgBox_style_BORDER_RADIUS[screenSize],
        strokeColor: colors_TRANSPARENT,
        fillColor: colors_TRANSPARENT,
        stroke: 1.5
      }
    },
    Background: {
      color: epgBox_style_colors.backgroundUnfocused[colorMode],
      shader: {
        radius: 8,
        progressHeight: progress_style_HEIGHT,
        progressBackgroundColor: progress_style_colors.background[colorMode],
        progressBarColor: progress_style_colors.bar[colorMode]
      }
    },
    Image: {
      w: IMAGE_WIDTH[screenSize],
      shader: {
        radius: [epgBox_epgBox_style_BORDER_RADIUS[screenSize], 0, 0, epgBox_epgBox_style_BORDER_RADIUS[screenSize]]
      }
    },
    Container: {
      y: epgBox_style_GAP,
      Time: {
        color: epgBox_style_colors.text[colorMode],
        text: epgBox_style_objectSpread(epgBox_style_objectSpread({}, src_getFont(constants_FONT.BOSTON_1, screenSize)), {}, {
          verticalAlign: 'middle',
          wordWrap: false,
          textOverflow: '...'
        })
      },
      Title: {
        color: epgBox_style_colors.text[colorMode],
        text: epgBox_style_objectSpread(epgBox_style_objectSpread({}, src_getFont(constants_FONT.MADRID_1, screenSize)), {}, {
          verticalAlign: 'middle',
          wordWrap: false,
          textOverflow: '...'
        })
      },
      Row: {
        flex: {
          direction: 'row',
          alignItems: 'center'
        },
        ExtraTitle: {
          color: epgBox_style_colors.text[colorMode],
          text: epgBox_style_objectSpread(epgBox_style_objectSpread({}, src_getFont(constants_FONT.BOSTON_1, screenSize)), {}, {
            verticalAlign: 'middle',
            wordWrap: false,
            textOverflow: '...'
          })
        },
        Icon: {}
      }
    }
  };
};
var epgBox_style_getFocusedStyle = function getFocusedStyle() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : epgBox_style_defaultContext,
    colorMode = _ref2.colorMode;
  return {
    zIndex: FOCUSED_Z_INDEX,
    Border: {
      smooth: {
        'shader.strokeColor': epgBox_style_colors.border[colorMode]
      }
    },
    Background: {
      smooth: {
        color: epgBox_style_colors.backgroundFocused[colorMode]
      }
    }
  };
};
var epgBox_style_getUnFocusedStyle = function getUnFocusedStyle() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : epgBox_style_defaultContext,
    colorMode = _ref3.colorMode;
  return {
    zIndex: UNFOCUSED_Z_INDEX,
    Border: {
      smooth: {
        'shader.strokeColor': colors_TRANSPARENT
      }
    },
    Background: {
      smooth: {
        color: epgBox_style_colors.backgroundUnfocused[colorMode]
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/epg/epgBox/epgBox.constants.js
var epgBox_constants_templates = {
  EpgBox: 'EpgBox'
};
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/epg/epgBox/epgBox.utils.js
var areEPGEntriesEqual = function areEPGEntriesEqual(first, second) {
  if (!first || !second) {
    return false;
  }
  return first.start.title === second.start.title && first.end.title === second.end.title && first.title === second.title && first.extraTitle === second.extraTitle && (first.progressBar && second.progressBar ? first.progressBar.progressValue === second.progressBar.progressValue : !first.progressBar && !second.progressBar);
};
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/epg/epgBox/epgBox.component.js






function epgBox_component_createSuper(t) { var r = epgBox_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function epgBox_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (epgBox_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }











var EpgBox = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(EpgBox, _Lightning$Component);
  var _super = epgBox_component_createSuper(EpgBox);
  function EpgBox() {
    (0,classCallCheck/* default */.Z)(this, EpgBox);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(EpgBox, [{
    key: "_construct",
    value: function _construct() {
      this._style = epgBox_style_defaultContext;
    }
  }, {
    key: "_inactive",
    value: function _inactive() {
      this.signal(INACTIVE_SIGNAL, this);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this._item = undefined;
      this.signal(DETACHED_SIGNAL, this);
      this.tag('Title').removeAllListeners('txLoaded');
      this.tag('Time').removeAllListeners('txLoaded');
      this.tag('ExtraTitle').removeAllListeners('txLoaded');
      this.tag('ExtraTitle').removeAllListeners('txLoaded');
    }
  }, {
    key: "item",
    get: function get() {
      return this._item;
    },
    set: function set(_ref) {
      var content = _ref.content,
        itemWidth = _ref.itemWidth,
        itemHeight = _ref.itemHeight,
        isLastItem = _ref.isLastItem,
        offset = _ref.offset;
      if (areEPGEntriesEqual(this._item, content)) {
        this._item = content;
        return;
      }
      this._item = content;
      this._itemWidth = itemWidth;
      this._itemHeight = itemHeight;
      this._currentWidth = itemWidth;
      this._expandedWidth = 0;
      this._innerPaddingRight = isLastItem ? 0 : epgBox_style_GAP;
      this._offset = offset;
      var w = Math.max(this._itemWidth - this._innerPaddingRight, 1);
      var screenSize = this._style.screenSize;
      var image = content.image ? content.image.id : null;
      var progress = content.progressBar && content.progressBar.progressValue || 0;
      var picto = content.pictos ? content.pictos[1] : null;
      this._containerOffset = image ? IMAGE_WIDTH[screenSize] : 0;
      this._texturesToLoad = 0;
      if (content.start.title || content.end.title) {
        this._texturesToLoad += 1;
      }
      if (content.title) {
        this._texturesToLoad += 1;
      }
      if (content.extraTitle) {
        this._texturesToLoad += 1;
      }
      var titleView = this.tag('Title');
      var timeView = this.tag('Time');
      var extraTitleView = this.tag('ExtraTitle');
      var icon = this.tag('ExtraTitle');
      var handler = this._handleTextLoading.bind(this);
      titleView.once('txLoaded', handler);
      timeView.once('txLoaded', handler);
      extraTitleView.once('txLoaded', handler);
      icon.once('txLoaded', handler);
      this.patch({
        w: w,
        h: itemHeight,
        Border: {
          w: w,
          h: itemHeight
        },
        Background: {
          w: w,
          h: itemHeight,
          shader: {
            progress: progress ? getProgress(progress) : 0
          }
        },
        Image: {
          h: itemHeight,
          src: image ? imageService.getUrl(image, IMAGE_WIDTH[screenSize], itemHeight, {
            fit: IMAGE_FIT_SCALE_CROP,
            quality: IMAGE_QUALITY,
            format: DEFAULT_IMAGE_FORMAT
          }) : null
        },
        Container: {
          x: epgBox_style_GAP + this._containerOffset,
          h: itemHeight,
          Time: {
            visible: Boolean(content.start.title || content.end.title),
            text: {
              text: "".concat(content.start.title, " - ").concat(content.end.title)
            }
          },
          Title: {
            visible: Boolean(content.title),
            text: {
              text: content.title || ''
            }
          },
          Row: {
            visible: Boolean(content.title || picto),
            ExtraTitle: {
              visible: Boolean(content.title),
              text: {
                text: content.extraTitle || ''
              }
            },
            Icon: {
              visible: Boolean(picto),
              iconData: {
                picto: picto,
                viewBox: {
                  w: epgBox_style_ICON_SIZE,
                  h: epgBox_style_ICON_SIZE
                }
              }
            }
          }
        }
      });
    }
  }, {
    key: "itemWidth",
    get: function get() {
      return this._itemWidth;
    }
  }, {
    key: "collapsedWidth",
    get: function get() {
      return this._itemWidth - this._innerPaddingRight;
    }
  }, {
    key: "expandedWidth",
    get: function get() {
      return this._expandedWidth;
    }
  }, {
    key: "offset",
    get: function get() {
      return this._offset;
    }
  }, {
    key: "currentWidth",
    get: function get() {
      return this._currentWidth;
    },
    set: function set(value) {
      this.patch({
        w: value,
        Background: {
          w: value
        },
        Border: {
          w: value
        }
      });
      this._currentWidth = value;
    }
  }, {
    key: "padding",
    get: function get() {
      return epgBox_style_GAP;
    }
  }, {
    key: "minInnerOffset",
    get: function get() {
      return this.padding + this._containerOffset;
    }
  }, {
    key: "innerOffset",
    get: function get() {
      return this.tag('Container').x;
    },
    set: function set(value) {
      this.tag('Container').x = value;
    }
  }, {
    key: "_handleTextLoading",
    value: function _handleTextLoading() {
      this._texturesToLoad -= 1;
      if (this._texturesToLoad > 0) {
        return;
      }
      this._expandedWidth = 0;
      var timeView = this.tag('Time');
      var titleView = this.tag('Title');
      var extraTitleView = this.tag('ExtraTitle');
      var icon = this.tag('Icon');
      var rowView = this.tag('Row');
      var container = this.tag('Container');
      var height = 0;
      if (timeView.visible && timeView.texture && timeView.texture.source) {
        var _timeView$texture$sou = timeView.texture.source,
          w = _timeView$texture$sou.w,
          h = _timeView$texture$sou.h;
        height += h;
        this._expandedWidth = Math.max(this._expandedWidth, w);
      }
      if (titleView.visible && titleView.texture && titleView.texture.source) {
        var _titleView$texture$so = titleView.texture.source,
          _w = _titleView$texture$so.w,
          _h = _titleView$texture$so.h;
        var padding = height ? 8 : 0;
        titleView.y = height + padding;
        height += _h + padding;
        this._expandedWidth = Math.max(this._expandedWidth, _w);
      }
      if (rowView.visible) {
        rowView.y = height;
        var _h2 = 0;
        var _w2 = 0;
        if (extraTitleView.visible && extraTitleView.texture && extraTitleView.texture.source) {
          var _extraTitleView$textu = extraTitleView.texture.source,
            textWidth = _extraTitleView$textu.w,
            textHeight = _extraTitleView$textu.h;
          _w2 += textWidth;
          _h2 = textHeight;
        }
        if (icon.visible) {
          var _icon$texture$source = icon.texture.source,
            iconWidth = _icon$texture$source.w,
            iconHeight = _icon$texture$source.h;
          _w2 += iconWidth;
          _h2 = Math.max(_h2, iconHeight);
        }
        this._expandedWidth = Math.max(this._expandedWidth, _w2);
        height += _h2;
      }
      container.y = Math.round((this._itemHeight - height) / 2);
      this._expandedWidth += epgBox_style_GAP * 2 + this._containerOffset;
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this.patch(epgBox_style_getFocusedStyle(this._style));
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this.currentWidth = Math.max(1, this.collapsedWidth);
      this.x = this.offset;
      this.patch(epgBox_style_getUnFocusedStyle(this._style));
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        clipping: true,
        Background: {
          rect: true,
          shader: {
            type: ImageShader
          }
        },
        Image: {
          shader: {
            type: src_Lightning.shaders.RoundedRectangle
          }
        },
        Border: {
          rect: true,
          shader: {
            type: src_Lightning.shaders.RoundedRectangle
          }
        },
        Container: {
          Time: {},
          Title: {},
          Row: {
            ExtraTitle: {},
            Icon: {
              type: Icon
            }
          }
        }
      }, epgBox_style_getInitialStyle());
    }
  }]);
  return EpgBox;
}(src_Lightning.Component);
EpgBox.templates = epgBox_constants_templates;
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/epg/pill/pill.style.js

var pill_style_HEIGHT, _INCENTIVE_PADDING, pill_style_BORDER_RADIUS;
function pill_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function pill_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? pill_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : pill_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






var pill_style_defaultContext = makeDefaultStylingContext();
var pill_pill_style_HEIGHT = (pill_style_HEIGHT = {}, (0,defineProperty/* default */.Z)(pill_style_HEIGHT, HD, 24), (0,defineProperty/* default */.Z)(pill_style_HEIGHT, FULL_HD, 32), pill_style_HEIGHT);
var INCENTIVE_PADDING = (_INCENTIVE_PADDING = {}, (0,defineProperty/* default */.Z)(_INCENTIVE_PADDING, HD, 16), (0,defineProperty/* default */.Z)(_INCENTIVE_PADDING, FULL_HD, 24), _INCENTIVE_PADDING);
var pill_pill_style_BORDER_RADIUS = (pill_style_BORDER_RADIUS = {}, (0,defineProperty/* default */.Z)(pill_style_BORDER_RADIUS, HD, 12), (0,defineProperty/* default */.Z)(pill_style_BORDER_RADIUS, FULL_HD, 16), pill_style_BORDER_RADIUS);
var pill_style_colors = {
  text: makeThemeColor(PRIMARY),
  background: makeThemeColor(QUINARY)
};
var pill_style_makeBasicTextStyle = function makeBasicTextStyle(_ref) {
  var font = _ref.font,
    _ref$colorMode = _ref.colorMode,
    colorMode = _ref$colorMode === void 0 ? DEFAULT_MODE : _ref$colorMode;
  return {
    color: pill_style_colors.text[colorMode],
    text: pill_style_objectSpread(pill_style_objectSpread({}, font), {}, {
      verticalAlign: 'middle',
      wordWrap: false
    })
  };
};
var pill_style_TITLE_FONT_TYPE = FONT_TYPE.MAIN;
var pill_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : pill_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  var h = pill_pill_style_HEIGHT[screenSize];
  var font = src_getFont(constants_FONT.BOSTON_3, screenSize, pill_style_TITLE_FONT_TYPE);
  return merge_default()({
    h: h,
    Background: {
      h: h,
      color: pill_style_colors.background[colorMode],
      shader: {
        radius: pill_pill_style_BORDER_RADIUS[screenSize]
      },
      w: identity
    },
    Label: pill_style_objectSpread({
      y: Math.round((h - font.lineHeight) / 2)
    }, pill_style_makeBasicTextStyle({
      font: src_getFont(constants_FONT.BOSTON_3, screenSize, pill_style_TITLE_FONT_TYPE),
      colorMode: colorMode
    }))
  });
};
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/epg/pill/pill.component.js





function pill_component_createSuper(t) { var r = pill_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function pill_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (pill_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }



var Pill = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Pill, _Lightning$Component);
  var _super = pill_component_createSuper(Pill);
  function Pill() {
    (0,classCallCheck/* default */.Z)(this, Pill);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Pill, [{
    key: "_construct",
    value: function _construct() {
      this._style = pill_style_defaultContext;
    }
  }, {
    key: "_init",
    value: function _init() {
      var _this = this;
      var label = this.tag('Label');
      var handleUpdate = function handleUpdate() {
        var incentiveWidth = label.finalW + INCENTIVE_PADDING[_this._style.screenSize] * 2;
        var labelOffsetX = (incentiveWidth - label.finalW) / 2;
        _this.patch({
          w: incentiveWidth,
          Label: {
            x: labelOffsetX
          }
        });
      };
      label.on('txLoaded', handleUpdate);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this.tag('Label').removeAllListeners('txLoaded');
    }
  }, {
    key: "label",
    set: function set(value) {
      this.tag('Label').text.text = value;
    }
  }, {
    key: "backgroundColor",
    set: function set(value) {
      this.tag('Background').color = value;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Background: {
          rect: true,
          shader: {
            type: src_Lightning.shaders.RoundedRectangle
          }
        },
        Label: {}
      }, pill_style_getInitialStyle());
    }
  }]);
  return Pill;
}(src_Lightning.Component);

;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/epg/epgTimeline/epgTimeline.style.js

var epgTimeline_style_HEIGHT;
function epgTimeline_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function epgTimeline_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? epgTimeline_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : epgTimeline_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





var epgTimeline_style_defaultContext = makeDefaultStylingContext();
var epgTimeline_epgTimeline_style_HEIGHT = (epgTimeline_style_HEIGHT = {}, (0,defineProperty/* default */.Z)(epgTimeline_style_HEIGHT, HD, 32), (0,defineProperty/* default */.Z)(epgTimeline_style_HEIGHT, FULL_HD, 32), epgTimeline_style_HEIGHT);
var getTextStyle = function getTextStyle(screenSize) {
  return epgTimeline_style_objectSpread(epgTimeline_style_objectSpread({}, src_getFont(constants_FONT.BERLIN_2, screenSize)), {}, {
    verticalAlign: 'middle'
  });
};
var epgTimeline_style_colors = {
  incentive: makeThemeColor(constants_LIVE)
};
var epgTimeline_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : epgTimeline_style_defaultContext,
    colorMode = _ref.colorMode,
    screenSize = _ref.screenSize;
  return {
    Current: {
      backgroundColor: epgTimeline_style_colors.incentive[colorMode],
      y: Math.round((epgTimeline_epgTimeline_style_HEIGHT[screenSize] - pill_pill_style_HEIGHT[screenSize]) / 2)
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/epg/epgTimeline/epgTimeline.component.js







function epgTimeline_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function epgTimeline_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? epgTimeline_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : epgTimeline_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function epgTimeline_component_createSuper(t) { var r = epgTimeline_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function epgTimeline_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (epgTimeline_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }





var EpgTimeline = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(EpgTimeline, _Lightning$Component);
  var _super = epgTimeline_component_createSuper(EpgTimeline);
  function EpgTimeline() {
    (0,classCallCheck/* default */.Z)(this, EpgTimeline);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(EpgTimeline, [{
    key: "_construct",
    value: function _construct() {
      this._style = epgTimeline_style_defaultContext;
      this._maxOffset = 0;
    }
  }, {
    key: "_build",
    value: function _build() {
      var end = 24 * 60;
      var marks = end / 15;
      var children = [];
      var textStyle = getTextStyle(this._style.screenSize);
      var textY = Math.round((32 - textStyle.lineHeight) / 2);
      this._maxOffset = 0;
      for (var i = 0; i <= marks; i += 1) {
        var isHour = i % 4 === 0;
        var h = isHour ? 32 : 16;
        var x = i * 15 * 6;
        children.push({
          rect: true,
          w: 2,
          h: h,
          x: x,
          y: (32 - h) / 2
        });
        if (isHour) {
          var hour = (6 + i * 15 / 60) % 24;
          children.push({
            x: x + 4,
            y: textY,
            text: epgTimeline_component_objectSpread(epgTimeline_component_objectSpread({}, textStyle), {}, {
              text: "".concat(withLeadingZero(hour), ":00")
            })
          });
        }
        this._maxOffset = x;
      }
      this.tag('Marks').children = children;
    }
  }, {
    key: "range",
    set: function set(value) {
      if (!value) {
        return;
      }
      var start = value.start,
        end = value.end;
      if (!start || !end) {
        return;
      }
      this._start = start.getTime();
      this._end = end.getTime();
    }
  }, {
    key: "currentTime",
    set: function set(value) {
      var hour = value.getHours();
      var minute = value.getMinutes();
      var time = value.getTime();
      var offset = (time - this._start) / (this._end - this._start);
      var x = this._maxOffset * offset;
      this.tag('Current').patch({
        visible: x > 0,
        x: this._maxOffset * offset,
        label: "".concat(withLeadingZero(hour), ":").concat(withLeadingZero(minute))
      });
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Marks: {},
        Current: {
          type: Pill
        }
      }, epgTimeline_style_getInitialStyle());
    }
  }]);
  return EpgTimeline;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/tornado/navigation-arrow/navigationArrow.style.js

var _SIZE, navigationArrow_style_BORDER_RADIUS;






var navigationArrow_style_defaultContext = makeDefaultStylingContext();
var SIZE = (_SIZE = {}, (0,defineProperty/* default */.Z)(_SIZE, HD, 56), (0,defineProperty/* default */.Z)(_SIZE, FULL_HD, 64), _SIZE);
var navigation_arrow_navigationArrow_style_BORDER_RADIUS = (navigationArrow_style_BORDER_RADIUS = {}, (0,defineProperty/* default */.Z)(navigationArrow_style_BORDER_RADIUS, HD, SIZE[HD] / 2), (0,defineProperty/* default */.Z)(navigationArrow_style_BORDER_RADIUS, FULL_HD, SIZE[FULL_HD] / 2), navigationArrow_style_BORDER_RADIUS);
var navigationArrow_style_colors = {
  background: makeThemeColor(QUATERNARY, 0.3),
  icon: makeThemeColor(PRIMARY),
  backgroundFocused: makeThemeColor(QUATERNARY),
  iconFocused: makeThemeColor(TERTIARY),
  backgroundDisabled: makeThemeColor(QUATERNARY, 0.1),
  iconDisabled: makeThemeColor(PRIMARY, 0.1)
};
var navigationArrow_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : navigationArrow_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  var size = SIZE[screenSize];
  return merge_default()({
    w: size,
    h: size,
    Background: {
      w: size,
      h: size,
      color: navigationArrow_style_colors.background[colorMode],
      shader: {
        radius: navigation_arrow_navigationArrow_style_BORDER_RADIUS[screenSize]
      }
    },
    Icon: {
      color: navigationArrow_style_colors.icon[colorMode],
      mount: 0.5,
      x: middle,
      y: middle
    }
  });
};
var navigationArrow_style_getFocusedStyle = function getFocusedStyle(_ref) {
  var colorMode = _ref.colorMode;
  return {
    Background: {
      smooth: {
        scale: focus_SCALE_FOCUSED,
        color: navigationArrow_style_colors.backgroundFocused[colorMode]
      }
    },
    Icon: {
      smooth: {
        scale: focus_SCALE_FOCUSED,
        color: navigationArrow_style_colors.iconFocused[colorMode]
      }
    }
  };
};
var navigationArrow_style_getUnFocusedStyle = function getUnFocusedStyle(_ref2) {
  var colorMode = _ref2.colorMode;
  return {
    Background: {
      smooth: {
        scale: 1.0,
        color: navigationArrow_style_colors.background[colorMode]
      }
    },
    Icon: {
      smooth: {
        scale: 1.0,
        color: navigationArrow_style_colors.icon[colorMode]
      }
    }
  };
};
var getDisabledStyle = function getDisabledStyle(_ref3) {
  var colorMode = _ref3.colorMode;
  return {
    Background: {
      smooth: {
        scale: 1.0,
        color: navigationArrow_style_colors.backgroundDisabled[colorMode]
      }
    },
    Icon: {
      smooth: {
        scale: 1.0,
        color: navigationArrow_style_colors.iconDisabled[colorMode]
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/templates/selectors/selector/blockHeader/blockHeader.style.js

var _LINE_HEIGHT, _LABEL_MARGIN_BOTTOM;
function blockHeader_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function blockHeader_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? blockHeader_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : blockHeader_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






var blockHeader_style_defaultContext = makeDefaultStylingContext();
var LINE_HEIGHT = (_LINE_HEIGHT = {}, (0,defineProperty/* default */.Z)(_LINE_HEIGHT, HD, 4), (0,defineProperty/* default */.Z)(_LINE_HEIGHT, FULL_HD, 4), _LINE_HEIGHT);
var LABEL_MARGIN_BOTTOM = (_LABEL_MARGIN_BOTTOM = {}, (0,defineProperty/* default */.Z)(_LABEL_MARGIN_BOTTOM, HD, 3), (0,defineProperty/* default */.Z)(_LABEL_MARGIN_BOTTOM, FULL_HD, 4), _LABEL_MARGIN_BOTTOM);
var blockHeader_style_colors = {
  text: makeThemeColor(PRIMARY),
  line: makeThemeColor(SECONDARY)
};
var DEFAULT_ALPHA = 0.6;
var SELECTED_ALPHA = 1;
var blockHeader_style_getLabelFont = function getLabelFont(screenSize) {
  return src_getFont(constants_FONT.OTTAWA_2, screenSize);
};
var getHeight = function getHeight(screenSize) {
  return blockHeader_style_getLabelFont(screenSize).lineHeight + LABEL_MARGIN_BOTTOM[screenSize] + LINE_HEIGHT[screenSize];
};
var blockHeader_style_getInitialStyle = memoize_default()(function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : blockHeader_style_defaultContext,
    screenSize = _ref.screenSize,
    colorMode = _ref.colorMode;
  return {
    h: getHeight(screenSize),
    Label: {
      alpha: DEFAULT_ALPHA,
      color: blockHeader_style_colors.text[colorMode],
      text: blockHeader_style_objectSpread(blockHeader_style_objectSpread({}, blockHeader_style_getLabelFont(screenSize)), {}, {
        verticalAlign: 'middle'
      })
    },
    Line: {
      mountY: 1,
      h: LINE_HEIGHT[screenSize],
      w: identity,
      y: function y(height) {
        return height - LINE_HEIGHT[screenSize];
      },
      color: blockHeader_style_colors.line[colorMode],
      scaleX: 0
    }
  };
});
var blockHeader_style_getFocusedStyle = function getFocusedStyle(isSelected) {
  return {
    Label: {
      smooth: {
        alpha: SELECTED_ALPHA
      }
    },
    Line: {
      smooth: {
        alpha: isSelected ? SELECTED_ALPHA : DEFAULT_ALPHA,
        scaleX: isSelected ? 1 : 0
      }
    }
  };
};
var blockHeader_style_getUnFocusedStyle = function getUnFocusedStyle(isSelected) {
  return {
    Label: {
      smooth: {
        alpha: DEFAULT_ALPHA
      }
    },
    Line: {
      smooth: {
        alpha: DEFAULT_ALPHA,
        scaleX: isSelected ? 1 : 0
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/epg/epgNav/epgNav.style.js

var epgNav_style_HEIGHT, _TO_LIVE_MARGIN_RIGHT;
function epgNav_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function epgNav_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? epgNav_style_ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : epgNav_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }







var epgNav_style_defaultContext = makeDefaultStylingContext();
var epgNav_epgNav_style_HEIGHT = (epgNav_style_HEIGHT = {}, (0,defineProperty/* default */.Z)(epgNav_style_HEIGHT, HD, 56), (0,defineProperty/* default */.Z)(epgNav_style_HEIGHT, FULL_HD, 64), epgNav_style_HEIGHT);
var TO_LIVE_MARGIN_RIGHT = (_TO_LIVE_MARGIN_RIGHT = {}, (0,defineProperty/* default */.Z)(_TO_LIVE_MARGIN_RIGHT, HD, 0), (0,defineProperty/* default */.Z)(_TO_LIVE_MARGIN_RIGHT, FULL_HD, 0), _TO_LIVE_MARGIN_RIGHT);
var GAP_RIGHT = 40;
var GAP_LEFT = 56;
var epgNav_style_getTextStyle = function getTextStyle(screenSize) {
  return epgNav_style_objectSpread(epgNav_style_objectSpread({}, getFont(FONT.BERLIN_2, screenSize)), {}, {
    verticalAlign: 'middle'
  });
};
var epgNav_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : epgNav_style_defaultContext,
    screenSize = _ref.screenSize;
  var arrowsWidth = SIZE[screenSize] * 2 + GAP_RIGHT;
  var buttonY = Math.round((epgNav_epgNav_style_HEIGHT[screenSize] - HEIGHT[screenSize]) / 2);
  return {
    h: epgNav_epgNav_style_HEIGHT[screenSize],
    LeftContainer: {
      w: SCREEN_WIDTH[screenSize],
      flex: {
        direction: 'row'
      },
      DateSelector: {
        y: buttonY
      },
      Tabs: {
        w: identity,
        y: Math.round((epgNav_epgNav_style_HEIGHT[screenSize] - blockHeader_style_getLabelFont(screenSize).lineHeight) / 2),
        flexItem: {
          grow: 1,
          marginLeft: GAP_LEFT
        }
      }
    },
    ToLive: {
      mountX: 1,
      x: function x(v) {
        return v - arrowsWidth - TO_LIVE_MARGIN_RIGHT[screenSize] - GAP_RIGHT;
      },
      y: buttonY
    },
    Arrows: {
      w: arrowsWidth,
      mountX: 1,
      x: identity,
      ArrowRight: {
        x: SIZE[screenSize] + GAP_RIGHT
      }
    }
  };
};
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/findLastIndex.js
var findLastIndex = __webpack_require__(31521);
var findLastIndex_default = /*#__PURE__*/__webpack_require__.n(findLastIndex);
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/isSameDay/index.js


/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day (and year and month)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * var result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 * 
 * @example
 * // Are 4 September and 4 October in the same day?
 * var result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 * 
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * var result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */

function isSameDay(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
  var dateRightStartOfDay = startOfDay(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/isToday/index.js


/**
 * @name isToday
 * @category Day Helpers
 * @summary Is the given date today?
 * @pure false
 *
 * @description
 * Is the given date today?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is today
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * var result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */

function isToday(dirtyDate) {
  requiredArgs(1, arguments);
  return isSameDay(dirtyDate, Date.now());
}
;// CONCATENATED MODULE: ./src/modules/tornado/navigation-arrow/navigationArrow.constants.js
var ARROW_LEFT = 'ArrowLeft';
var ARROW_RIGHT = 'ArrowRight';
;// CONCATENATED MODULE: ./src/modules/tornado/navigation-arrow/navigationArrow.component.js





function navigationArrow_component_createSuper(t) { var r = navigationArrow_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function navigationArrow_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (navigationArrow_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }






var NavigationArrow = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(NavigationArrow, _Lightning$Component);
  var _super = navigationArrow_component_createSuper(NavigationArrow);
  function NavigationArrow() {
    (0,classCallCheck/* default */.Z)(this, NavigationArrow);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(NavigationArrow, [{
    key: "_construct",
    value: function _construct() {
      this._style = navigationArrow_style_defaultContext;
      this._disabled = false;
      this._focused = false;
    }
  }, {
    key: "disabled",
    get: function get() {
      return this._disabled;
    },
    set: function set(value) {
      if (value === this._disabled) {
        return;
      }
      this._disabled = value;
      if (this._disabled) {
        this.patch(getDisabledStyle(this._style));
      } else if (this._focused) {
        this.patch(navigationArrow_style_getFocusedStyle(this._style));
      } else {
        this.patch(navigationArrow_style_getUnFocusedStyle(this._style));
      }
    }
  }, {
    key: "variant",
    set: function set(value) {
      if (value !== ARROW_LEFT && value !== ARROW_RIGHT) {
        return;
      }
      var size = Math.round(SIZE[this._style.screenSize] / 2);
      this.tag('Icon').iconData = {
        picto: {
          name: value,
          collection: ICON_COLLECTION.BASIC
        },
        viewBox: {
          w: size,
          h: size
        }
      };
    }
  }, {
    key: "_focus",
    value: function _focus() {
      if (this._disabled) {
        this.patch(getDisabledStyle(this._style));
        return;
      }
      this.patch(navigationArrow_style_getFocusedStyle(this._style));
      this._focused = true;
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      if (this._disabled) {
        this.patch(getDisabledStyle(this._style));
      } else {
        this.patch(navigationArrow_style_getUnFocusedStyle(this._style));
      }
      this._focused = false;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Background: {
          rect: true,
          shader: {
            type: src_Lightning.shaders.RoundedRectangle
          }
        },
        Icon: {
          type: Icon
        }
      }, navigationArrow_style_getInitialStyle());
    }
  }]);
  return NavigationArrow;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/tornado/templates/selectors/selector/blockHeader/blockHeader.component.js





function blockHeader_component_createSuper(t) { var r = blockHeader_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function blockHeader_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (blockHeader_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }




var BlockHeader = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(BlockHeader, _Lightning$Component);
  var _super = blockHeader_component_createSuper(BlockHeader);
  function BlockHeader() {
    (0,classCallCheck/* default */.Z)(this, BlockHeader);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(BlockHeader, [{
    key: "_construct",
    value: function _construct() {
      this._style = blockHeader_style_defaultContext;
      this._isFocused = false;
      this._isSelected = false;
    }
  }, {
    key: "_attach",
    value: function _attach() {
      var _this = this;
      var label = this.tag('Label');
      label.on('txLoaded', function () {
        _this.w = label.finalW;
      });
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this.tag('Label').removeAllListeners('txLoaded');
      this._item = undefined;
    }
  }, {
    key: "item",
    get: function get() {
      return this._item;
    },
    set: function set(value) {
      var title = value.title;
      this._item = value;
      this.tag('Label').text = {
        text: typeof title === 'string' ? title : getTitle(title)
      };
    }
  }, {
    key: "isSelected",
    get: function get() {
      return this._isSelected;
    },
    set: function set(value) {
      this._isSelected = value;
      this._updateStyle();
    }
  }, {
    key: "_updateStyle",
    value: function _updateStyle() {
      this.patch(this._isFocused ? blockHeader_style_getFocusedStyle(this._isSelected) : blockHeader_style_getUnFocusedStyle(this._isSelected));
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this._isFocused = true;
      this._updateStyle();
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this._isFocused = false;
      this._updateStyle();
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Label: {},
        Line: {
          rect: true
        }
      }, blockHeader_style_getInitialStyle());
    }
  }]);
  return BlockHeader;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/tornado/templates/selectors/selector/selectorHeader/selectorHeader.style.js

var selectorHeader_style_GAP;




var selectorHeader_style_defaultContext = makeDefaultStylingContext();
var selectorHeader_selectorHeader_style_GAP = (selectorHeader_style_GAP = {}, (0,defineProperty/* default */.Z)(selectorHeader_style_GAP, HD, 32), (0,defineProperty/* default */.Z)(selectorHeader_style_GAP, FULL_HD, 40), selectorHeader_style_GAP);
var selectorHeader_style_getInitialStyle = memoize_default()(function () {
  return {
    Container: {
      flex: {
        direction: 'row'
      }
    }
  };
});
var getTabStyle = memoize_default()(function (screenSize) {
  return {
    flexItem: {
      marginRight: selectorHeader_selectorHeader_style_GAP[screenSize]
    }
  };
});
;// CONCATENATED MODULE: ./src/modules/tornado/templates/selectors/selector/selectorHeader/selectorHeader.component.js








function selectorHeader_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function selectorHeader_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? selectorHeader_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : selectorHeader_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function selectorHeader_component_createSuper(t) { var r = selectorHeader_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function selectorHeader_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (selectorHeader_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }






var SelectorHeader = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(SelectorHeader, _Lightning$Component);
  var _super = selectorHeader_component_createSuper(SelectorHeader);
  function SelectorHeader() {
    (0,classCallCheck/* default */.Z)(this, SelectorHeader);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(SelectorHeader, [{
    key: "_construct",
    value: function _construct() {
      this._focusedTabIndex = 0;
      this._selectedTabIndex = 0;
      this._leftPadding = 0;
      this._rightPadding = 0;
      this._containerWidth = 0;
      this._style = selectorHeader_style_defaultContext;
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this.tag('Container').onUpdate = null;
    }
  }, {
    key: "items",
    set: function set(value) {
      var _this = this;
      var tabStyle = getTabStyle(this._style.screenSize);
      var container = this.tag('Container');
      if (container.children.length === value.length && value.length) {
        container.children.forEach(function (child, index) {
          child.item = value[index];
        });
        return;
      }
      container.children = value.map(function (item) {
        return selectorHeader_component_objectSpread({
          type: BlockHeader,
          item: item
        }, tabStyle);
      });
      container.children[this._selectedTabIndex].isSelected = true;
      container.onUpdate = function () {
        _this._containerWidth = container.flex && container.flex.item && container.flex.item.w || 0;
        _this.goTo(_this._focusedTabIndex, false);
      };
    }
  }, {
    key: "selectedIndex",
    get: function get() {
      return this._selectedTabIndex;
    },
    set: function set(value) {
      var _this2 = this;
      this._selectedTabIndex = value;
      this.tag('Container').children.forEach(function (child, index) {
        child.isSelected = _this2._selectedTabIndex === index;
      });
    }
  }, {
    key: "focusedIndex",
    get: function get() {
      return this._focusedTabIndex;
    },
    set: function set(value) {
      this._focusedTabIndex = value;
    }
  }, {
    key: "leftPadding",
    get: function get() {
      return this._leftPadding;
    },
    set: function set(value) {
      this._leftPadding = value;
      this.goTo(this._focusedItemIndex);
    }
  }, {
    key: "rightPadding",
    get: function get() {
      return this._rightPadding;
    },
    set: function set(value) {
      this._rightPadding = value;
      this.goTo(this._focusedItemIndex);
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      if (this._focusedTabIndex === this._selectedTabIndex) {
        return false;
      }
      var container = this.tag('Container');
      if (container.children[this._selectedTabIndex]) {
        container.children[this._selectedTabIndex].isSelected = false;
      }
      if (container.children[this._focusedTabIndex]) {
        container.children[this._focusedTabIndex].isSelected = true;
      }
      this._selectedTabIndex = this._focusedTabIndex;
      this.signal(SELECTED_SIGNAL, this._selectedTabIndex);
      return true;
    }
  }, {
    key: "goTo",
    value: function goTo() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._focusedTabIndex;
      var animate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var container = this.tag('Container');
      if (!container.children.length) {
        return;
      }
      var flexItem = get_default()(container, "flex._layout.items.".concat(index));
      if (!flexItem) {
        return;
      }
      var totalWidth = container.flex.item.w || this._containerWidth;
      var maxOffset = Math.min(this.finalW - this._leftPadding - this._rightPadding, totalWidth) - totalWidth;
      var offset = -flexItem.x;
      var result = Math.max(Math.min(0, offset), maxOffset);
      if (animate) {
        container.setSmooth('x', result);
      } else {
        container.x = result;
      }
      this._focusedTabIndex = index;
    }
  }, {
    key: "_handleLeft",
    value: function _handleLeft() {
      if (this._focusedTabIndex > 0) {
        this.goTo(this._focusedTabIndex - 1);
        return true;
      }
      return false;
    }
  }, {
    key: "_handleRight",
    value: function _handleRight() {
      if (this._focusedTabIndex < this.tag('Container').children.length - 1) {
        this.goTo(this._focusedTabIndex + 1);
        return true;
      }
      return false;
    }
  }, {
    key: "_captureKey",
    value: function _captureKey() {
      this.tag('Container').onUpdate = null;
      return false;
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this.tag('Container').children[this._focusedTabIndex];
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Container: {}
      }, selectorHeader_style_getInitialStyle());
    }
  }]);
  return SelectorHeader;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/logic/lock/lock.constants.js

var LOCK_POPUPS_MAP = {
  geoBlocked: GEO_BLOCK_POPUP_ID,
  contentRatingAdvisory: AGE_GATE_POPUP_ID,
  leavingKidsSection: KIDS_LEAVE_POPUP_ID,
  live: BROADCASTING_LOCK_POPUP_ID,
  freemium: FREEMIUM_LOCK_POPUP_ID,
  parentalCode: PARENTAL_CODE_POPUP_ID,
  requireSubscription: SUBSCRIPTION_POPUP_ID,
  default: COMMON_POPUP_ID,
  contentRating: CONTENT_RATING_POPUP_ID,
  parentalFilter: PARENTAL_FILTER_POPUP_ID
};
;// CONCATENATED MODULE: ./src/logic/lock/lock.utils.js











var getMappedLockPopup = function getMappedLockPopup(lockId) {
  return LOCK_POPUPS_MAP[lockId] ? LOCK_POPUPS_MAP[lockId] : LOCK_POPUPS_MAP.default;
};
var getReason = function getReason(item) {
  return get_default()(item, 'item.action.target.value_lock.reason');
};
var getOriginalTarget = function getOriginalTarget(item) {
  return get_default()(item, 'item.action.target.value_lock.originalTarget');
};
var getReasonAttributes = function getReasonAttributes(item) {
  return get_default()(item, 'action.target.value_lock.reasonAttributes', []);
};
var isPlayerLocked = function isPlayerLocked(entityType) {
  return [layout_constants/* entities */.jF.video, layout_constants/* entities */.jF.audio, layout_constants/* entities */.jF.radio, layout_constants/* entities */.jF.live].includes(entityType);
};
var getUnlockPathPrefix = function getUnlockPathPrefix(entityType) {
  return isPlayerLocked(entityType) ? '' : 'app/';
};
var getNestedOriginalTarget = function getNestedOriginalTarget(target) {
  if (target.type === 'layout') {
    var layout = target["value_".concat(target.type)];
    return "".concat(getUnlockPathPrefix(layout.type)).concat(layout.type, "/").concat(layout.id);
  }
  if (target.type === 'app') {
    var original = target["value_".concat(target.type)];
    return original && original.reference === BOOKMARKS ? BOOKMARKS_PATH : null;
  }
  if (target.type === 'lock') {
    return getNestedOriginalTarget(target["value_".concat(target.type)].originalTarget);
  }
  return null;
};
var getDeeplinkFromLock = function getDeeplinkFromLock(item) {
  if (!item) {
    return null;
  }
  if (item.video) {
    var id = item.video.id;
    if (!id) {
      return null;
    }
    var path = (window.location.hash || '').replace('#', '');
    if (get_default()(item.video, 'progress.live')) {
      var _entityType = path.startsWith(layout_constants/* entities */.jF.radio) ? layout_constants/* entities */.jF.radio : layout_constants/* entities */.jF.live;
      return "".concat(_entityType, "/").concat(item.video.id);
    }
    var entityType = path.startsWith(layout_constants/* entities */.jF.audio) ? layout_constants/* entities */.jF.audio : layout_constants/* entities */.jF.video;
    return "".concat(entityType, "/").concat(id.startsWith('clip_') ? id : "clip_".concat(id));
  }
  var target = item.target || get_default()(item, 'action.target');
  if (!target || target.type !== 'lock') {
    return null;
  }
  return getNestedOriginalTarget(target);
};
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/epg/epg.constants.js
var epg_constants_templates = {
  HorizontalEpg: 'HorizontalEpg'
};
var PIXELS_PER_MINUTE = 6;
var START_HOUR = 6;
var FOCUS_MODE_NAV = 'navigation';
var FOCUS_MODE_GRID = 'grid';
var MORNING_HOUR = 6;
var AFTERNOON_HOUR = 13;
var EVENING_HOUR = 19;
var TODAY_I18N_KEY = 'epgGrid.today';
var DAYS_OF_THE_WEEK_I18N = ['date.days.sunday', 'date.days.monday', 'date.days.tuesday', 'date.days.wednesday', 'date.days.thursday', 'date.days.friday', 'date.days.saturday'];
var MONTHS_I18N_KEY = ['date.months.january', 'date.months.february', 'date.months.march', 'date.months.april', 'date.months.may', 'date.months.june', 'date.months.july', 'date.months.august', 'date.months.september', 'date.months.october', 'date.months.november', 'date.months.december'];
var ABBREVIATION_I18N_KEY = 'abbreviation';
var COMPLETE_I18N_KEY = 'complete';
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/epg/epg.utils.js





var _excluded = ["start", "end"];
function epg_utils_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function epg_utils_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? epg_utils_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : epg_utils_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }









var getChannelContent = function getChannelContent(base, size) {
  if (!base) {
    return {};
  }
  var image = base.image || {};
  var sizeFallback = size || square_constants_sizes[square_constants_templates.Square][sizes_getScreenSize()].w;
  return epg_utils_objectSpread(epg_utils_objectSpread({}, base), {}, {
    image: epg_utils_objectSpread(epg_utils_objectSpread({}, image), {}, {
      src: imageService.getUrl(base.image.id, sizeFallback, sizeFallback, {
        fit: IMAGE_FIT_SCALE_CROP,
        quality: IMAGE_QUALITY,
        format: DEFAULT_IMAGE_FORMAT
      })
    })
  });
};
var makePlaceholder = function makePlaceholder(start, end) {
  return {
    start: {
      date: start,
      title: format_format(start, 'HH:mm')
    },
    end: {
      date: end,
      title: format_format(end, 'HH:mm')
    },
    title: t('epgGrid.noProgram')
  };
};
var trimEpg = function trimEpg(row, min, max) {
  var programs = row.map(function (_ref) {
    var start = _ref.start,
      end = _ref.end,
      rest = objectWithoutProperties_objectWithoutProperties(_ref, _excluded);
    var startDate = new Date(start.date);
    var endDate = new Date(end.date);
    return epg_utils_objectSpread({
      start: {
        date: startDate,
        title: format_format(startDate, 'HH:mm')
      },
      end: {
        date: endDate,
        title: format_format(endDate, 'HH:mm')
      }
    }, rest);
  });
  var result = [];
  var lastIndex = programs.length - 1;
  var tail = min;
  for (var i = 0; i < programs.length; i += 1) {
    var program = epg_utils_objectSpread({}, programs[i]);
    var end = program.end.date;
    if (end <= min) {
      continue;
    }
    var start = program.start.date;
    if (start >= max) {
      if (tail < max) {
        result.push(makePlaceholder(tail, max));
      }
      break;
    }
    if (start < min) {
      program.start.date = min;
    }
    if (end > max) {
      program.end.date = max;
    }
    if (start > tail) {
      result.push(makePlaceholder(tail, start));
    }
    result.push(program);
    tail = end;
    if (i === lastIndex) {
      if (end < max) {
        result.push(makePlaceholder(end, max));
      }
    }
  }
  return result;
};
var offsetFromStart = function offsetFromStart(start, hour) {
  return start + (hour - START_HOUR) * 60 * 60 * 1000;
};
var formatDate = function formatDate(date) {
  var abbreviated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var day = date.getDay();
  var month = date.getMonth();
  var tail = abbreviated ? ABBREVIATION_I18N_KEY : COMPLETE_I18N_KEY;
  var dayKey = "".concat(DAYS_OF_THE_WEEK_I18N[day], ".").concat(tail);
  var monthKey = "".concat(MONTHS_I18N_KEY[month], ".").concat(tail);
  return "".concat(t(dayKey), " ").concat(date.getDate(), " ").concat(t(monthKey));
};
var isActionAllowed = function isActionAllowed(action) {
  if (!src.featureFlipping.liveSuppressionOnEPGFeature || !action) {
    return true;
  }
  var target = getNestedOriginalTarget(action.target);
  if (!target) {
    return true;
  }
  return !target.startsWith(layout_constants/* entities */.jF.live);
};
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/epg/epgNav/epgNav.constants.js
var SIGNAL_GO_TO_LIVE = 'to_live';
var SIGNAL_OPEN_DATE_SELECTOR = 'open_date_selector';
var SIGNAL_GO_LEFT = 'left';
var SIGNAL_GO_RIGHT = 'right';
var SIGNAL_GO_TO_MORNING = 'morning';
var SIGNAL_GO_TO_AFTERNOON = 'afternoon';
var SIGNAL_GO_TO_EVENING = 'evening';
var TABS = [SIGNAL_GO_TO_MORNING, SIGNAL_GO_TO_AFTERNOON, SIGNAL_GO_TO_EVENING];
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/epg/epgNav/epgNav.component.js







function epgNav_component_createSuper(t) { var r = epgNav_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function epgNav_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (epgNav_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }













var EpgNav = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(EpgNav, _Lightning$Component);
  var _super = epgNav_component_createSuper(EpgNav);
  function EpgNav() {
    (0,classCallCheck/* default */.Z)(this, EpgNav);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(EpgNav, [{
    key: "_build",
    value: function _build() {
      this._style = epgNav_style_defaultContext;
      this._focusable = ['DateSelector', 'Tabs', 'ToLive', 'ArrowLeft', 'ArrowRight'];
      this._focusIndex = 0;
    }
  }, {
    key: "date",
    set: function set(value) {
      var button = this.tag('DateSelector');
      if (value) {
        var date = new Date(value);
        button.label = isToday(date) ? t('epgGrid.today') : formatDate(date, true);
      } else {
        button.label = t('epgGrid.today');
      }
    }
  }, {
    key: "percentage",
    set: function set(value) {
      var left = this.tag('ArrowLeft');
      var right = this.tag('ArrowRight');
      left.disabled = value <= 0;
      right.disabled = value >= 1;
      if (left.disabled) {
        if (this._focusIndex === this._focusable.indexOf('ArrowLeft')) {
          this._focusIndex = this._focusable.indexOf('ArrowRight');
          this._waitForKeyUp = true;
        }
      } else if (right.disabled) {
        if (this._focusIndex === this._focusable.indexOf('ArrowRight')) {
          this._focusIndex = this._focusable.indexOf('ArrowLeft');
          this._waitForKeyUp = true;
        }
      }
      this._refocus();
    }
  }, {
    key: "_handleEnterRelease",
    value: function _handleEnterRelease() {
      this._waitForKeyUp = false;
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      if (this._waitForKeyUp) {
        return;
      }
      switch (this._focusable[this._focusIndex]) {
        case 'DateSelector':
          {
            this.signal(SIGNAL_OPEN_DATE_SELECTOR);
            break;
          }
        case 'ToLive':
          {
            this.signal(SIGNAL_GO_TO_LIVE);
            break;
          }
        case 'ArrowLeft':
          {
            this.signal(SIGNAL_GO_LEFT);
            break;
          }
        case 'ArrowRight':
          {
            this.signal(SIGNAL_GO_RIGHT);
            break;
          }
        default:
          break;
      }
    }
  }, {
    key: "_handleLeft",
    value: function _handleLeft() {
      var _this = this;
      var nextIndex = findLastIndex_default()(this._focusable, function (value, index) {
        return index < _this._focusIndex && !_this.tag(value).disabled;
      });
      if (nextIndex < 0) {
        return false;
      }
      this._focusIndex = nextIndex;
      return true;
    }
  }, {
    key: "_handleRight",
    value: function _handleRight() {
      var _this2 = this;
      var nextIndex = this._focusable.findIndex(function (value, index) {
        return index > _this2._focusIndex && !_this2.tag(value).disabled;
      });
      if (nextIndex < 0) {
        return false;
      }
      this._focusIndex = nextIndex;
      return true;
    }
  }, {
    key: "_handleSelectedTab",
    value: function _handleSelectedTab(index) {
      this.signal(TABS[index]);
      this.tag('Tabs').selectedIndex = -1;
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this.tag(this._focusable[this._focusIndex]);
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this._waitForKeyUp = false;
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this._waitForKeyUp = false;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        LeftContainer: {
          DateSelector: {
            type: Button,
            label: t('epgGrid.today'),
            picto: {
              name: 'Agenda'
            }
          },
          Tabs: {
            type: SelectorHeader,
            signals: (0,defineProperty/* default */.Z)({}, SELECTED_SIGNAL, '_handleSelectedTab'),
            items: [{
              title: t('epgGrid.morning')
            }, {
              title: t('epgGrid.afternoon')
            }, {
              title: t('epgGrid.evening')
            }],
            selectedIndex: -1
          }
        },
        ToLive: {
          type: Button,
          label: t('epgGrid.live'),
          picto: {
            name: 'Live'
          }
        },
        Arrows: {
          ArrowLeft: {
            type: NavigationArrow,
            variant: ARROW_LEFT
          },
          ArrowRight: {
            type: NavigationArrow,
            variant: ARROW_RIGHT
          }
        }
      }, epgNav_style_getInitialStyle());
    }
  }]);
  return EpgNav;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/epg/epg.style.js

var _MAX_VISIBLE_ROWS, _CHANNEL_SIZE, _ARROW_SLIDE_INTERVAL;




var epg_style_defaultContext = makeDefaultStylingContext();
var MAX_VISIBLE_ROWS = (_MAX_VISIBLE_ROWS = {}, (0,defineProperty/* default */.Z)(_MAX_VISIBLE_ROWS, HD, 4), (0,defineProperty/* default */.Z)(_MAX_VISIBLE_ROWS, FULL_HD, 5), _MAX_VISIBLE_ROWS);
var SCROLL_START_ROW = 3;
var epg_style_GAP = 16;
var RIGHT_PADDING = safetyMargins.horizontal;
var CHANNEL_SIZE = (_CHANNEL_SIZE = {}, (0,defineProperty/* default */.Z)(_CHANNEL_SIZE, HD, 96), (0,defineProperty/* default */.Z)(_CHANNEL_SIZE, FULL_HD, 112), _CHANNEL_SIZE);
var TIMELINE_MARGIN_TOP = 32;
var TIMELINE_MARGIN_BOTTOM = 24;
var ARROW_SLIDE_INTERVAL = (_ARROW_SLIDE_INTERVAL = {}, (0,defineProperty/* default */.Z)(_ARROW_SLIDE_INTERVAL, HD, PIXELS_PER_MINUTE * 60), (0,defineProperty/* default */.Z)(_ARROW_SLIDE_INTERVAL, FULL_HD, PIXELS_PER_MINUTE * 90), _ARROW_SLIDE_INTERVAL);
var epg_style_getInitialStyle = function getInitialStyle() {
  var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : epg_style_defaultContext;
  return {
    Title: getTitleStyle(style)
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/epg/epg.component.js
















function epg_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function epg_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? epg_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : epg_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function epg_component_createSuper(t) { var r = epg_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function epg_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (epg_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
























var HorizontalEpg = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(HorizontalEpg, _Lightning$Component);
  var _super = epg_component_createSuper(HorizontalEpg);
  function HorizontalEpg() {
    (0,classCallCheck/* default */.Z)(this, HorizontalEpg);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(HorizontalEpg, [{
    key: "_construct",
    value: function _construct() {
      this._contentPadding = 0;
      this._style = epg_style_defaultContext;
      this._rowsCount = 0;
      this._row = 0;
      this._index = 0;
      this._verticalTraverseStartPoint = undefined;
      this._focusMode = FOCUS_MODE_NAV;
      this._leftMostItems = [];
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this._data = undefined;
      this._leftMostItems = [];
      this._rowsData = null;
      clearTimeout(this._itemFocusTimeout);
      cancelAnimationFrame(this._animationFrameHandle);
    }
  }, {
    key: "rightPadding",
    get: function get() {
      return RIGHT_PADDING[this._style.screenSize];
    }
  }, {
    key: "contentPadding",
    get: function get() {
      return this._contentPadding;
    },
    set: function set(value) {
      this._contentPadding = value;
      if (!this._data) {
        return;
      }
      var x = this._contentPadding + CHANNEL_SIZE[this._style.screenSize] + epg_style_GAP;
      this._gridWidth = this._data.rowSize.w - x;
      this.patch({
        ChannelsVerticalClippingRoot: {
          x: this._contentPadding
        },
        Nav: {
          x: this._contentPadding,
          w: this._data.rowSize.w - this._contentPadding - this.rightPadding
        },
        Grid: {
          x: x,
          w: this._gridWidth
        },
        Title: {
          x: this._contentPadding
        }
      });
      this._goToLive();
      this._refocus();
    }
  }, {
    key: "data",
    get: function get() {
      return this._data;
    },
    set: function set(value) {
      var _this = this;
      if (!value) {
        this.patch({
          Channels: {
            children: []
          },
          Grid: {
            Container: {
              Items: {
                children: []
              }
            }
          },
          Title: {
            text: {
              text: ''
            }
          }
        });
        return;
      }
      this._construct();
      var rows = (get_default()(value, 'block.content.items') || []).filter(function (block) {
        return Boolean(block.epgBox && block.epgBox.length && block.epgBox.some(Boolean));
      });
      var currentDate = get_default()(value, 'block.content.date');
      var text = getTitle(value.block.title);
      var hasTitle = Boolean(text);
      var _this$_style = this._style,
        screenSize = _this$_style.screenSize,
        colorMode = _this$_style.colorMode;
      var _getBlockStyle = getBlockStyle({
          hasTitle: hasTitle,
          isFirstBlock: value.blockIndex === 0,
          screenSize: screenSize
        }),
        items = _getBlockStyle.items,
        title = _getBlockStyle.title;
      var channelSize = CHANNEL_SIZE[this._style.screenSize];
      var x = this._contentPadding + channelSize + epg_style_GAP;
      var w = value.rowSize.w - x;
      var rowsHeight = Math.min(rows.length, MAX_VISIBLE_ROWS[screenSize]) * (channelSize + epg_style_GAP) - epg_style_GAP;
      var timelineOuterHeight = epgTimeline_epgTimeline_style_HEIGHT[screenSize] + TIMELINE_MARGIN_BOTTOM + TIMELINE_MARGIN_TOP;
      var h = rowsHeight + timelineOuterHeight;
      var channelConfig = {
        w: channelSize,
        h: channelSize
      };
      this._limits = [];
      this._gridWidth = w;
      var firstItem = rows[0].epgBox.find(Boolean);
      var start = addHours(startOfDay(new Date(firstItem.start.date)), 6);
      var end = addHours(start, 24);
      var previousStart = this._start;
      this._start = start;
      this._end = end;
      this._data = value;
      this._rowsCount = rows.length;
      this._rowsData = rows.map(function (_ref, i) {
        var box = _ref.epgBox;
        var offset = 0;
        var row = {
          h: channelSize,
          y: i * (channelSize + epg_style_GAP),
          children: trimEpg(box, start, end).map(function (content, index, collection) {
            var start = content.start,
              end = content.end;
            var duration = Math.round(differenceInSeconds_differenceInSeconds(end.date, start.date) / 60);
            var itemWidth = duration * PIXELS_PER_MINUTE;
            var item = {
              type: EpgBox,
              w: itemWidth,
              h: channelSize,
              x: offset,
              item: {
                content: content,
                itemWidth: itemWidth,
                itemHeight: channelSize,
                isLastItem: index === collection.length - 1,
                offset: offset
              }
            };
            offset += itemWidth;
            return item;
          })
        };
        _this._limits[i] = offset;
        return row;
      });
      if (this.tag('Items').children.length === this._rowsCount && previousStart && previousStart.getTime() === this._start.getTime()) {
        this._goToLive();
        this._refocus();
        this._fillData(0);
        return;
      }
      this.patch({
        ChannelsVerticalClippingRoot: {
          x: this._contentPadding,
          y: items.y + epgNav_epgNav_style_HEIGHT[screenSize] + timelineOuterHeight,
          w: CHANNEL_SIZE[this._style.screenSize],
          h: rowsHeight,
          Channels: {
            children: rows.map(function (_ref2, i) {
              var channel = _ref2.channel;
              return {
                type: Square,
                item: {
                  content: getChannelContent(channel),
                  config: channelConfig
                },
                y: i * (channelSize + epg_style_GAP)
              };
            })
          }
        },
        Nav: {
          y: items.y,
          date: currentDate
        },
        Grid: {
          x: x,
          y: items.y + epgNav_epgNav_style_HEIGHT[screenSize],
          w: w,
          h: h,
          Container: {
            h: h,
            Timeline: {
              y: TIMELINE_MARGIN_TOP,
              range: {
                start: start,
                end: end
              }
            },
            GridVerticalClippingRoot: {
              w: PIXELS_PER_MINUTE * 24 * 60,
              h: rowsHeight,
              y: epgTimeline_epgTimeline_style_HEIGHT[screenSize] + TIMELINE_MARGIN_BOTTOM + TIMELINE_MARGIN_TOP,
              Items: {
                children: rows.map(function (_, i) {
                  var row = {
                    h: channelSize,
                    y: i * (channelSize + epg_style_GAP)
                  };
                  return i ? row : epg_component_objectSpread(epg_component_objectSpread({}, _this._rowsData[0]), row);
                })
              }
            }
          }
        },
        Title: epg_component_objectSpread({
          visible: true,
          text: {
            text: text
          }
        }, title)
      });
      this._goToLive();
      this._refocus();
      this._fillData(1);
    }
  }, {
    key: "_fillData",
    value: function _fillData(index) {
      var _this2 = this;
      if (index >= this._rowsCount) {
        return;
      }
      this._animationFrameHandle = requestAnimationFrame(function () {
        _this2._fillRow(index);
        _this2._fillData(index + 1);
      });
    }
  }, {
    key: "_fillRow",
    value: function _fillRow(index) {
      if (!this._rowsData || !this._rowsData[index]) {
        return;
      }
      var row = this.tag('Items').children[index];
      var data = this._rowsData[index];
      if (row.children.length === data.children.length) {
        row.children.forEach(function (child, i) {
          child.item = data.children[i].item;
        });
      } else {
        row.patch(data);
      }
      var left = -this.tag('Container').x;
      for (var i = data.children.length - 1; i >= 0; i -= 1) {
        var view = row.children[i];
        if (view.offset <= left) {
          view.innerOffset = Math.max(left - view.offset + view.padding, view.minInnerOffset);
          this._leftMostItems[index] = view;
          break;
        }
      }
    }
  }, {
    key: "currentBox",
    get: function get() {
      var row = this.tag('Items').children[this._row];
      if (row) {
        return row.children[this._index];
      }
      return undefined;
    }
  }, {
    key: "rightmostOffset",
    get: function get() {
      return this.tag('Grid').finalW - this._limits[this._row] - this.rightPadding;
    }
  }, {
    key: "_goTo",
    value: function _goTo(index) {
      var skipAnimation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      clearTimeout(this._itemFocusTimeout);
      var rowsContainer = this.tag('Items');
      var row = rowsContainer.children[this._row];
      if (!row) {
        return;
      }
      var container = this.tag('Container');
      var view = row.children[index];
      var viewRight = view.offset + view.itemWidth;
      var containerRight = this._gridWidth - this.rightPadding;
      var offset = container.x;
      var containerRightOffset = containerRight - offset;
      if (viewRight > containerRightOffset && (view.offset + view.expandedWidth > containerRightOffset || index === row.children.length - 1)) {
        offset = containerRight - viewRight;
        var constrainedOffset = Math.max(offset, this.rightmostOffset);
        if (!skipAnimation) {
          container.setSmooth('x', constrainedOffset);
          this._notifyContainerMovement(constrainedOffset);
        }
      } else if (view.offset + view.collapsedWidth + offset <= epgBox_style_GAP) {
        offset = -view.offset;
        if (!skipAnimation) {
          container.setSmooth('x', offset);
          this._notifyContainerMovement(offset);
        }
      }
      if (this._focusMode === FOCUS_MODE_NAV) {
        return;
      }
      this._itemFocusTimeout = setTimeout(function () {
        var expandedWidth = Math.max(view.expandedWidth, Math.max(1, view.collapsedWidth));
        var viewRight = view.offset + expandedWidth;
        var itemWidth = expandedWidth + Math.max(0, view.innerOffset - (expandedWidth - view.expandedWidth));
        if (viewRight > containerRight - offset) {
          view.x = view.offset - (itemWidth - view.collapsedWidth);
        }
        view.currentWidth = itemWidth;
      }, 800);
    }
  }, {
    key: "_handleContainerMovedTo",
    value: function _handleContainerMovedTo(target) {
      var rowsContainer = this.tag('Items');
      var channelSize = CHANNEL_SIZE[this._style.screenSize];
      var x = this._contentPadding + channelSize + epg_style_GAP;
      var w = this._data.rowSize.w - x;
      var center = Math.round(w / 2 - target);
      var middleItemIndex = rowsContainer.children[0].children.findIndex(function (_ref3) {
        var x = _ref3.x,
          itemWidth = _ref3.itemWidth;
        return x >= center || x + itemWidth > center;
      });
      if (middleItemIndex > -1) {
        this._index = middleItemIndex;
        this._goTo(this._index, true);
      }
      this._notifyContainerMovement(target);
    }
  }, {
    key: "_notifyContainerMovement",
    value: function _notifyContainerMovement(target) {
      var leftMostItems = [];
      var rowsContainer = this.tag('Items');
      var left = -target;
      for (var i = 0; i < this._rowsCount; i += 1) {
        var row = rowsContainer.children[i];
        for (var j = row.children.length - 1; j >= 0; j -= 1) {
          var view = row.children[j];
          if (view.offset <= left) {
            view.setSmooth('innerOffset', Math.max(left - view.offset + view.padding, view.minInnerOffset), this.stage.transitions.defaultTransitionSettings);
            leftMostItems.push(view);
            break;
          }
        }
      }
      this._leftMostItems.forEach(function (view) {
        if (!leftMostItems.includes(view)) {
          view.setSmooth('innerOffset', view.minInnerOffset, {
            duration: 0
          });
        }
      });
      this._leftMostItems = leftMostItems;
      this.tag('Nav').percentage = target / this.rightmostOffset;
    }
  }, {
    key: "_goToTimestamp",
    value: function _goToTimestamp(value) {
      var animate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!this._data) {
        return;
      }
      var channelSize = CHANNEL_SIZE[this._style.screenSize];
      var x = this._contentPadding + channelSize + epg_style_GAP;
      var w = this._data.rowSize.w - x;
      var rowsContainer = this.tag('Items');
      if (rowsContainer.children.length) {
        var maxOffset = PIXELS_PER_MINUTE * 24 * 60;
        var currentTimeOffset = (value - this._start) / (this._end - this._start);
        var center = maxOffset * currentTimeOffset + channelSize;
        var targetPosition = Math.max(Math.min(0, Math.round(w / 2 - center)), this.rightmostOffset);
        if (animate) {
          this.tag('Container').setSmooth('x', targetPosition);
        } else {
          this.tag('Container').x = targetPosition;
        }
        this._handleContainerMovedTo(targetPosition);
      }
    }
  }, {
    key: "_goToLive",
    value: function _goToLive() {
      var animate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var now = new Date();
      this.tag('Timeline').currentTime = now;
      if (now >= this._start && now <= this._end) {
        this._goToTimestamp(now, animate);
      } else {
        var row = this.tag('Items').children[this._row];
        if (!row) {
          return;
        }
        this._index = this._findNearestIndex(null, row);
        this._handleContainerMovedTo(this.tag('Container').x);
      }
    }
  }, {
    key: "_goLeft",
    value: function _goLeft() {
      var container = this.tag('Container');
      var target = Math.min(container.x + ARROW_SLIDE_INTERVAL[this._style.screenSize], 0);
      this._handleContainerMovedTo(target);
      container.setSmooth('x', target);
    }
  }, {
    key: "_goRight",
    value: function _goRight() {
      var container = this.tag('Container');
      var target = Math.max(container.x - ARROW_SLIDE_INTERVAL[this._style.screenSize], this.rightmostOffset);
      this._handleContainerMovedTo(target);
      container.setSmooth('x', target);
    }
  }, {
    key: "_findNearestIndex",
    value: function _findNearestIndex(view, row) {
      var start = this._verticalTraverseStartPoint || (view ? view.offset : 0);
      if (!this._verticalTraverseStartPoint) {
        this._verticalTraverseStartPoint = start;
      }
      start = Math.max(start, -this.tag('Container').x);
      for (var i = 0; i < row.children.length; i += 1) {
        var candidate = row.children[i];
        if (candidate.offset >= start) {
          return i;
        }
        if (candidate.offset + candidate.itemWidth > start) {
          return i;
        }
      }
      return row.children.length - 1;
    }
  }, {
    key: "_switchToCurrentRow",
    value: function _switchToCurrentRow(fromView) {
      clearTimeout(this._itemFocusTimeout);
      var row = this.tag('Items').children[this._row];
      if (!row) {
        return;
      }
      this._index = this._findNearestIndex(fromView, row);
      var maxVisibleRows = MAX_VISIBLE_ROWS[this._style.screenSize];
      var rows = Math.max(0, Math.min(this._row - SCROLL_START_ROW + 1, this._rowsCount - maxVisibleRows));
      var offset = rows * (CHANNEL_SIZE[this._style.screenSize] + epg_style_GAP);
      this.tag('Items').setSmooth('y', -offset);
      this.tag('Channels').setSmooth('y', -offset);
      var container = this.tag('Container');
      var view = row.children[this._index];
      var expandedWidth = Math.max(view.expandedWidth, Math.max(1, view.collapsedWidth));
      var containerRight = this._gridWidth - this.rightPadding;
      var viewRight = view.offset + expandedWidth + container.x;
      if (viewRight > containerRight) {
        this._goTo(this._index, false);
      } else {
        view.currentWidth = expandedWidth + Math.max(0, view.innerOffset - (expandedWidth - view.expandedWidth));
      }
    }
  }, {
    key: "_handleDown",
    value: function _handleDown() {
      if (this._focusMode === FOCUS_MODE_NAV) {
        this._focusMode = FOCUS_MODE_GRID;
        this._goTo(this._index, false);
        return true;
      }
      if (this._row < this._rowsCount - 1) {
        var currentFocusedView = this.currentBox;
        this._row += 1;
        this._switchToCurrentRow(currentFocusedView);
        return true;
      }
      return false;
    }
  }, {
    key: "_handleUp",
    value: function _handleUp() {
      if (this._row > 0) {
        var currentFocusedView = this.currentBox;
        this._row -= 1;
        this._switchToCurrentRow(currentFocusedView);
        return true;
      }
      if (this._focusMode !== FOCUS_MODE_NAV) {
        this._focusMode = FOCUS_MODE_NAV;
        this._verticalTraverseStartPoint = undefined;
        clearTimeout(this._itemFocusTimeout);
        return true;
      }
      return false;
    }
  }, {
    key: "_handleRight",
    value: function _handleRight() {
      if (this._focusMode === FOCUS_MODE_NAV) {
        return false;
      }
      var row = this.tag('Items').children[this._row];
      if (!row) {
        return false;
      }
      if (this._index < row.children.length - 1) {
        this._index += 1;
        this._verticalTraverseStartPoint = undefined;
        this._goTo(this._index, false);
        return true;
      }
      return false;
    }
  }, {
    key: "_handleLeft",
    value: function _handleLeft() {
      if (this._focusMode === FOCUS_MODE_NAV) {
        return false;
      }
      if (this._index > 0) {
        this._index -= 1;
        this._verticalTraverseStartPoint = undefined;
        this._goTo(this._index, false);
        return true;
      }
      return false;
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      if (this._focusMode === FOCUS_MODE_NAV) {
        return;
      }
      var currentBox = this.currentBox;
      if (currentBox && currentBox.item && currentBox.item.action) {
        if (!isActionAllowed(currentBox.item.action)) {
          return;
        }
        if (currentBox.item.action.target.type && currentBox.item.action.target.value_modal) {
          this._openEpgModal(currentBox.item.action.target.value_modal.id);
          return;
        }
        this.signal(SELECTED_SIGNAL, epg_component_objectSpread({
          id: "".concat(this._row, "_").concat(this._index)
        }, currentBox.item));
      } else {
        this.fireAncestors("$".concat(NOTIFICATION_SIGNAL), makeNotification(NOTIFICATION_LEVEL.SYSTEM, t('epgGrid.noAction')));
      }
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this._focusMode === FOCUS_MODE_NAV ? this.tag('Nav') : this.currentBox;
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this._goTo(this._index, true);
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      clearTimeout(this._itemFocusTimeout);
    }
  }, {
    key: "_handleGoToLive",
    value: function _handleGoToLive() {
      var now = new Date();
      if (now >= this._start && now <= this._end) {
        this._goToLive(true);
        return;
      }
      this.signal(EPG_SIGNAL, {
        date: new Date(),
        blockId: this._data.block.id
      });
    }
  }, {
    key: "_openDateSelector",
    value: function _openDateSelector() {
      lightningjs_redux.dispatch(showPopupAction(EPG_POPUP_ID, {
        date: new Date(),
        selectedDate: this._start,
        blockId: this._data.block.id
      }));
    }
  }, {
    key: "_openEpgModal",
    value: function _openEpgModal(value) {
      if (!value) {
        return;
      }
      lightningjs_redux.dispatch(showPopupAction(EPG_LAYOUT_POPUP_ID, {
        blockId: value.toString()
      }));
    }
  }, {
    key: "_goToHour",
    value: function _goToHour(hour) {
      this._goToTimestamp(offsetFromStart(this._start.getTime(), hour), true);
    }
  }, {
    key: "_goToMorning",
    value: function _goToMorning() {
      this._goToHour(MORNING_HOUR);
    }
  }, {
    key: "_goToAfternoon",
    value: function _goToAfternoon() {
      this._goToHour(AFTERNOON_HOUR);
    }
  }, {
    key: "_goToEvening",
    value: function _goToEvening() {
      this._goToHour(EVENING_HOUR);
    }
  }], [{
    key: "_template",
    value: function _template() {
      var _signals;
      return merge_default()({
        ChannelsVerticalClippingRoot: {
          clipping: true,
          Channels: {}
        },
        Nav: {
          type: EpgNav,
          signals: (_signals = {}, (0,defineProperty/* default */.Z)(_signals, SIGNAL_GO_TO_MORNING, '_goToMorning'), (0,defineProperty/* default */.Z)(_signals, SIGNAL_GO_TO_AFTERNOON, '_goToAfternoon'), (0,defineProperty/* default */.Z)(_signals, SIGNAL_GO_TO_EVENING, '_goToEvening'), (0,defineProperty/* default */.Z)(_signals, SIGNAL_GO_TO_LIVE, '_handleGoToLive'), (0,defineProperty/* default */.Z)(_signals, SIGNAL_OPEN_DATE_SELECTOR, '_openDateSelector'), (0,defineProperty/* default */.Z)(_signals, SIGNAL_GO_LEFT, '_goLeft'), (0,defineProperty/* default */.Z)(_signals, SIGNAL_GO_RIGHT, '_goRight'), _signals)
        },
        Grid: {
          Container: {
            Timeline: {
              type: EpgTimeline
            },
            GridVerticalClippingRoot: {
              clipping: true,
              Items: {}
            }
          },
          clipping: true
        },
        Title: {}
      }, epg_style_getInitialStyle());
    }
  }, {
    key: "getOffsetsByBlockData",
    value: function getOffsetsByBlockData(value) {
      var result = Block.getOffsetsByBlockData(value);
      var count = get_default()(value, 'data.content.items.length') || 0;
      var screenSize = value.screenSize;
      return epg_component_objectSpread(epg_component_objectSpread({}, result), {}, {
        h: Math.min(count, MAX_VISIBLE_ROWS[screenSize]) * (CHANNEL_SIZE[screenSize] + epg_style_GAP) - epg_style_GAP + epgTimeline_epgTimeline_style_HEIGHT[screenSize] + epgNav_epgNav_style_HEIGHT[screenSize] + TIMELINE_MARGIN_BOTTOM + TIMELINE_MARGIN_TOP
      });
    }
  }]);
  return HorizontalEpg;
}(src_Lightning.Component);
HorizontalEpg.Templates = epg_constants_templates;
/* harmony default export */ const epg_component = (HorizontalEpg);
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/index.js

var _blockTemplates;






var blockFallback = List.Templates.List;
var blockTemplates = (_blockTemplates = {}, (0,defineProperty/* default */.Z)(_blockTemplates, List.Templates.List, List), (0,defineProperty/* default */.Z)(_blockTemplates, Belly.Templates.Belly, Belly), (0,defineProperty/* default */.Z)(_blockTemplates, Solo.Templates.Solo, Solo), (0,defineProperty/* default */.Z)(_blockTemplates, SlideShow.Templates.SlideShow, SlideShow), (0,defineProperty/* default */.Z)(_blockTemplates, Grid.Templates.Grid, Grid), (0,defineProperty/* default */.Z)(_blockTemplates, epg_component.Templates.HorizontalEpg, epg_component), _blockTemplates);
var getBlockTemplateById = function getBlockTemplateById(id) {
  return blockTemplates[id] || blockTemplates[blockFallback];
};
;// CONCATENATED MODULE: ./src/modules/tornado/templates/selectors/selector/selector.style.js

var _HEADER_MARGIN_BOTTOM, _RIGHT_PADDING;




var selector_style_defaultContext = makeDefaultStylingContext();
var HEADER_MARGIN_BOTTOM = (_HEADER_MARGIN_BOTTOM = {}, (0,defineProperty/* default */.Z)(_HEADER_MARGIN_BOTTOM, HD, 12), (0,defineProperty/* default */.Z)(_HEADER_MARGIN_BOTTOM, FULL_HD, 16), _HEADER_MARGIN_BOTTOM);
var selector_style_RIGHT_PADDING = (_RIGHT_PADDING = {}, (0,defineProperty/* default */.Z)(_RIGHT_PADDING, HD, safetyMargins.horizontal.HD), (0,defineProperty/* default */.Z)(_RIGHT_PADDING, FULL_HD, safetyMargins.horizontal.FULL_HD), _RIGHT_PADDING);
var getTopBlockHeight = function getTopBlockHeight() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : selector_style_defaultContext,
    screenSize = _ref.screenSize;
  return getHeight(screenSize) + HEADER_MARGIN_BOTTOM[screenSize];
};
var selector_style_getInitialStyle = memoize_default()(function () {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : selector_style_defaultContext;
  return {
    Tabs: {
      rightPadding: safetyMargins.horizontal[context.screenSize]
    },
    Content: {
      y: getTopBlockHeight(context)
    }
  };
}, cacheResolver);
;// CONCATENATED MODULE: ./src/modules/tornado/templates/selectors/selector/selector.utils.js


var getSelectorTabs = function getSelectorTabs(data) {
  var blocks = get_default()(data, 'block.alternativeContent.concurrentBlocks') || [];
  return {
    tabs: blocks.map(function (_ref) {
      var id = _ref.id,
        title = _ref.title;
      return {
        id: id,
        title: title
      };
    }),
    blocks: blocks
  };
};
var getRendererRefByIndex = function getRendererRefByIndex(index) {
  return "Renderer_".concat(index);
};
;// CONCATENATED MODULE: ./src/modules/tornado/templates/selectors/selector/selector.constants.js
var selector_constants_templates = {
  Selector: 'Selector',
  Tab: 'Tab'
};
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/invoke.js
var invoke = __webpack_require__(8957);
var invoke_default = /*#__PURE__*/__webpack_require__.n(invoke);
// EXTERNAL MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/thirdParty/engines/ssaTealiumHttp.engine.js
var ssaTealiumHttp_engine = __webpack_require__(54312);
;// CONCATENATED MODULE: ./src/logic/analytics/engines/tealium/index.js



function tealium_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function tealium_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? tealium_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : tealium_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



var engineName = 'ssaTealiumHttp';
var getEngine = function getEngine() {
  var analytics = (src_default()).analytics;
  var initParams = analytics.initParams,
    trackers = analytics.trackers,
    taggingPlans = analytics.taggingPlans,
    attributesKeysMapping = analytics.attributesKeysMapping;
  return {
    thirdPartyServiceConfig: {
      key: engineName,
      name: engineName,
      bootMethod: function bootMethod() {},
      engine: function engine() {
        return ssaTealiumHttp_engine["default"];
      },
      taggingPlan: get_default()(taggingPlans, engineName, {}),
      initParams: tealium_objectSpread({
        attributesKeysMapping: get_default()(attributesKeysMapping, engineName, {}),
        events: get_default()(taggingPlans, engineName, {}),
        trackers: get_default()(trackers, engineName, {}),
        isSnowplowEnabled: (analytics.engines || []).includes('snowplow')
      }, get_default()(initParams, engineName, {}))
    },
    cleanup: function cleanup() {}
  };
};
;// CONCATENATED MODULE: ./src/logic/analytics/engines/nielsenMediametrie/nielsenMediametrie.engine.js









function nielsenMediametrie_engine_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function nielsenMediametrie_engine_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? nielsenMediametrie_engine_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : nielsenMediametrie_engine_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var NIELSEN_MEDIAMETRIE_NAME = 'nielsenMediametrie';
var EngineStatus = {
  DEFAULT: 'default',
  PLAYING: 'playing',
  PAUSED: 'paused',
  SEEKING: 'seeking'
};
var NielsenEvent = {
  SET_PLAYHEAD_POSITION: 'setPlayheadPosition',
  STOP: 'stop',
  END: 'end',
  LOAD_METADATA: 'loadMetadata'
};
var DEFAULT_ATTRIBUTES = ['currentTime'];
var STATIC_METADATA_KEY = 'nielsenStatic';
var IS_LIVE_KEY = 'nol_c18';
var NielsenMediametrie = function () {
  function NielsenMediametrie() {
    var _this = this;
    (0,classCallCheck/* default */.Z)(this, NielsenMediametrie);
    this.name = NIELSEN_MEDIAMETRIE_NAME;
    this.instance = undefined;
    this.status = EngineStatus.DEFAULT;
    this.metadata = {};
    this._previousArticleMetadata = undefined;
    this.lastSentEvent = undefined;
    this.isActive = function () {
      return !!_this.instance;
    };
    this.time = undefined;
    this.isFirstPlayheadSent = false;
    this.isLive = false;
    this.shouldLoadMetadataAfterInterruption = false;
    this.sdkDebugEnabled = false;
  }
  (0,createClass/* default */.Z)(NielsenMediametrie, [{
    key: "init",
    value: function init(config) {
      var appId = config.appId,
        instanceName = config.instanceName,
        metadata = config.metadata,
        _config$shouldLoadMet = config.shouldLoadMetadataAfterInterruption,
        shouldLoadMetadataAfterInterruption = _config$shouldLoadMet === void 0 ? false : _config$shouldLoadMet,
        _config$sdkDebugEnabl = config.sdkDebugEnabled,
        sdkDebugEnabled = _config$sdkDebugEnabl === void 0 ? false : _config$sdkDebugEnabl;
      this._attributesKeys = DEFAULT_ATTRIBUTES;
      var additionalParams = nielsenMediametrie_engine_objectSpread({}, sdkDebugEnabled && {
        nol_sdkDebug: 'debug'
      });
      this.instance = window.NOLBUNDLE.nlsQ(appId, instanceName, additionalParams);
      this.metadata = metadata;
      this.status = EngineStatus.DEFAULT;
      this.lastSentEvent = undefined;
      this.time = undefined;
      this.isFirstPlayheadSent = false;
      this.shouldLoadMetadataAfterInterruption = shouldLoadMetadataAfterInterruption;
    }
  }, {
    key: "checkIsLive",
    value: function checkIsLive() {
      if (!this.metadata) return;
      this.isLive = /,Y$/.test(this.metadata[IS_LIVE_KEY]);
    }
  }, {
    key: "currentTime",
    set: function set(value) {
      if (!value) return;
      var latestTime = Math.floor(this.isLive ? Date.now() / 1000 : value);
      if (this.time !== latestTime) {
        this.time = latestTime;
        this.sendPlayheadEvent();
      }
    }
  }, {
    key: "setCustomAttributes",
    value: function setCustomAttributes(attributes) {
      var _this2 = this;
      Object.keys(attributes).filter(function (key) {
        return _this2._attributesKeys.includes(key);
      }).forEach(function (key) {
        _this2[key] = attributes[key];
      });
    }
  }, {
    key: "sendMetadata",
    value: function sendMetadata() {
      this.instance.ggPM(NielsenEvent.LOAD_METADATA, this.metadata);
    }
  }, {
    key: "onLoadedData",
    value: function onLoadedData(metadata) {
      this.metadata = metadata;
      this.checkIsLive();
      this.sendMetadata();
    }
  }, {
    key: "onPlaying",
    value: function onPlaying() {
      if (this.shouldLoadMetadataAfterInterruption && this.status === EngineStatus.PAUSED) {
        this.sendMetadata();
      }
      this.status = EngineStatus.PLAYING;
    }
  }, {
    key: "onPause",
    value: function onPause() {
      this.sendStopEvent();
      this.status = EngineStatus.PAUSED;
    }
  }, {
    key: "onBuffering",
    value: function onBuffering() {
      this.sendStopEvent();
    }
  }, {
    key: "onEnded",
    value: function onEnded() {
      this.sendEndEvent();
      this.status = EngineStatus.DEFAULT;
    }
  }, {
    key: "onStop",
    value: function onStop() {
      this.sendEndEvent();
      this.status = EngineStatus.DEFAULT;
    }
  }, {
    key: "onSeeking",
    value: function onSeeking() {
      this.status = EngineStatus.SEEKING;
    }
  }, {
    key: "onSeekTimeUpdate",
    value: function onSeekTimeUpdate() {
      this.status = EngineStatus.SEEKING;
    }
  }, {
    key: "onSeeked",
    value: function onSeeked(params) {
      this.sendStopEvent(params.currentTime);
      this.status = EngineStatus.PLAYING;
    }
  }, {
    key: "onUpdatePlayerConfig",
    value: function onUpdatePlayerConfig(params) {
      var currentTime = params.currentTime,
        analytics = params.analytics;
      this.sendEndEvent(currentTime);
      this.metadata = analytics[this.name].metadata;
      this.instance.ggPM(NielsenEvent.LOAD_METADATA, this.metadata);
    }
  }, {
    key: "sendEvent",
    value: function sendEvent(params, action, eventFields, attributesByThirdParties) {
      switch (params.key) {
        case 'playbackStarted':
          if (params.metadata) {
            this.onLoadedData(params.metadata);
          }
          break;
        case 'playVideo':
          this.onPlaying();
          break;
        case 'pauseVideo':
          this.onPause();
          break;
        case 'playbackStopped':
          this.onEnded();
          break;
        case 'buffering':
          this.onBuffering();
          break;
        case 'bufferingEnded':
          this.onPlaying();
          break;
        case 'complete':
          this.onEnded();
          break;
        case 'replayNextVideo':
          this.sendMetadata();
          break;
        default:
          break;
      }
    }
  }, {
    key: "sendPageViewEvent",
    value: function sendPageViewEvent(params, action, eventFields, attributesByThirdParties) {
      if (!this.instance || !(STATIC_METADATA_KEY in eventFields)) {
        return;
      }
      var articleMetadata = eventFields[STATIC_METADATA_KEY];
      if (this._previousArticleMetadata) {
        this.instance.ggPM('staticend', this._previousArticleMetadata);
      }
      this.instance.ggPM('staticstart', articleMetadata);
      this._previousArticleMetadata = articleMetadata;
    }
  }, {
    key: "sendPlayheadEvent",
    value: function sendPlayheadEvent() {
      if (this.status !== EngineStatus.PLAYING) return;
      this.instance.ggPM(NielsenEvent.SET_PLAYHEAD_POSITION, this.time);
      this.lastSentEvent = NielsenEvent.SET_PLAYHEAD_POSITION;
      if (!this.isFirstPlayheadSent) {
        this.isFirstPlayheadSent = true;
      }
    }
  }, {
    key: "sendStopEvent",
    value: function sendStopEvent() {
      if (this.lastSentEvent === NielsenEvent.STOP || !this.isFirstPlayheadSent) return;
      this.instance.ggPM(NielsenEvent.STOP, this.time);
      this.lastSentEvent = NielsenEvent.STOP;
    }
  }, {
    key: "sendEndEvent",
    value: function sendEndEvent() {
      if (this.lastSentEvent === NielsenEvent.END) return;
      this.instance.ggPM(NielsenEvent.END, this.time);
      this.lastSentEvent = NielsenEvent.END;
      this.isFirstPlayheadSent = false;
    }
  }, {
    key: "release",
    value: function release() {
      this.instance = undefined;
      this.status = EngineStatus.DEFAULT;
      this.metadata = {};
      this.time = undefined;
    }
  }]);
  return NielsenMediametrie;
}();
/* harmony default export */ const nielsenMediametrie_engine = (new NielsenMediametrie());
;// CONCATENATED MODULE: ./src/logic/analytics/engines/nielsenMediametrie/index.js







function nielsenMediametrie_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function nielsenMediametrie_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? nielsenMediametrie_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : nielsenMediametrie_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }




var nielsenMediametrie_engineName = 'nielsenMediametrie';
var nielsenMediametrie_getEngine = function getEngine() {
  var analytics = (src_default()).analytics;
  var taggingPlans = analytics.taggingPlans;
  var initParams = get_default()(analytics, "initParams.".concat(nielsenMediametrie_engineName), {});
  return {
    thirdPartyServiceConfig: {
      key: nielsenMediametrie_engineName,
      name: nielsenMediametrie_engineName,
      bootMethod: function bootMethod() {
        return __webpack_require__(15645);
      },
      engine: function engine() {
        return nielsenMediametrie_engine;
      },
      initParams: nielsenMediametrie_objectSpread({
        events: get_default()(taggingPlans, nielsenMediametrie_engineName, {})
      }, merge_default()(initParams, {
        useLayout: true
      }))
    },
    cleanup: function cleanup() {
      nielsenMediametrie_engine.release();
      delete window.NOLBUNDLE;
      var scripts = Array.from(document.querySelectorAll('script')).filter(function (script) {
        return Boolean(script.src) && (script.src.includes('cdn-gl.nmrodam') || /\/sp-.*\.js/.test(script.src));
      });
      if (scripts && scripts.length) {
        scripts.forEach(function (script) {
          return script.remove();
        });
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/logic/analytics/customer/rtlde/engines.js


var engines = [getEngine(), nielsenMediametrie_getEngine()];
var getEngines = function getEngines() {
  return engines;
};
;// CONCATENATED MODULE: ./src/logic/app/app.selectors.js



function app_selectors_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function app_selectors_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? app_selectors_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : app_selectors_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


var DEFAULT_ARRAY = [];
var DEFAULT_OBJECT = {};
var getAppState = function getAppState(_ref) {
  var app = _ref.app;
  return app;
};
var isAppInitializing = function isAppInitializing(_ref2) {
  var initializing = _ref2.app.initializing;
  return initializing;
};
var isAppInitialized = function isAppInitialized(_ref3) {
  var initialized = _ref3.app.initialized;
  return initialized;
};
var getAnalytics = function getAnalytics(state) {
  return _get(state, 'app.analytics');
};
var getAnalyticsEngines = function getAnalyticsEngines(state) {
  return get_default()(state, 'app.analytics.engines', DEFAULT_ARRAY);
};
var getAnalyticsEvents = function getAnalyticsEvents(state) {
  var enabledEngines = getAnalyticsEngines(state);
  var taggingPlans = get_default()(state, 'app.analytics.taggingPlans', DEFAULT_OBJECT);
  return Object.keys(taggingPlans).reduce(function (result, key) {
    if (enabledEngines.indexOf(key) === -1) {
      return result;
    }
    result = app_selectors_objectSpread(app_selectors_objectSpread({}, result), taggingPlans[key]);
    return result;
  }, {});
};
var getDeviceBrand = function getDeviceBrand(state) {
  return get_default()(state, 'app.deviceBrand');
};
var getDeviceModel = function getDeviceModel(state) {
  return get_default()(state, 'app.deviceModel');
};
var getDeviceVersion = function getDeviceVersion(state) {
  return get_default()(state, 'app.deviceVersion');
};
var isScreensaverVisible = function isScreensaverVisible(_ref4) {
  var displayScreenSaver = _ref4.screensaver.displayScreenSaver;
  return displayScreenSaver;
};
var getCurrentTime = function getCurrentTime(_ref5) {
  var _ref5$app = _ref5.app,
    serverTime = _ref5$app.serverTime,
    initialElapsedTime = _ref5$app.initialElapsedTime;
  return getTimestamp(serverTime, initialElapsedTime);
};
var getCurrentMsTime = function getCurrentMsTime(_ref6) {
  var _ref6$app = _ref6.app,
    serverTime = _ref6$app.serverTime,
    initialElapsedTime = _ref6$app.initialElapsedTime;
  return getMsTimestamp(serverTime, initialElapsedTime);
};
var getServerTime = function getServerTime(_ref7) {
  var serverTime = _ref7.app.serverTime;
  return serverTime;
};
var getInitialElapsedTime = function getInitialElapsedTime(_ref8) {
  var initialElapsedTime = _ref8.app.initialElapsedTime;
  return initialElapsedTime;
};
var getStartoverMinDepth = function getStartoverMinDepth(_ref9) {
  var startoverMinDepth = _ref9.app.startoverMinDepth;
  return startoverMinDepth;
};
var getStartoverMaxDepth = function getStartoverMaxDepth(_ref0) {
  var startoverMaxDepth = _ref0.app.startoverMaxDepth;
  return startoverMaxDepth;
};
var getStartoverMinPercentage = function getStartoverMinPercentage(_ref1) {
  var startoverMinPercentage = _ref1.app.startoverMinPercentage;
  return startoverMinPercentage;
};
var getStartoverMaxPercentage = function getStartoverMaxPercentage(_ref10) {
  var startoverMaxPercentage = _ref10.app.startoverMaxPercentage;
  return startoverMaxPercentage;
};
var isConnected = function isConnected(state) {
  return getAppState(state).connected;
};
var app_selectors_getScreenSize = function getScreenSize(_ref11) {
  var screenSize = _ref11.app.screenSize;
  return screenSize;
};
var getRetriesCount = function getRetriesCount(state) {
  return state.app.initializeRetriesCount;
};
;// CONCATENATED MODULE: ./src/logic/user/user.selectors.js

function user_selectors_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function user_selectors_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? user_selectors_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : user_selectors_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var shouldSynchronizeConsents = function shouldSynchronizeConsents(_ref) {
  var userApiFeature = _ref.app.userApiFeature,
    _ref$user = _ref.user,
    synchronize = _ref$user.synchronize,
    deviceId = _ref$user.deviceId,
    areConsentsSet = _ref$user.areUserPreferencesSet;
  return !synchronize && userApiFeature && areConsentsSet && deviceId;
};
var user_selectors_getDeviceId = function getDeviceId(_ref2) {
  var deviceId = _ref2.user.deviceId;
  return deviceId;
};
var user_selectors_getHomeId = function getHomeId(_ref3) {
  var homeId = _ref3.user.homeId;
  return homeId;
};
var getLocalDeviceId = function getLocalDeviceId(_ref4) {
  var localDeviceId = _ref4.user.localDeviceId;
  return localDeviceId;
};
var getLocalHomeId = function getLocalHomeId(_ref5) {
  var localHomeId = _ref5.user.localHomeId;
  return localHomeId;
};
var user_selectors_getPairingStatus = function getPairingStatus(_ref6) {
  var status = _ref6.pairing.status;
  return status;
};
var getUserState = function getUserState(_ref7) {
  var user = _ref7.user,
    userApiFeature = _ref7.app.userApiFeature;
  return user_selectors_objectSpread(user_selectors_objectSpread({}, user), {}, {
    userApiFeature: userApiFeature
  });
};
var getPairedUser = function getPairedUser(_ref8) {
  var pairing = _ref8.pairing;
  return pairing;
};
var user_selectors_getSelectedProfile = function getSelectedProfile(state) {
  return get_default()(state, 'pairing.profileUid');
};
var user_selectors_getPairingUid = function getPairingUid(state) {
  return get_default()(getPairedUser(state), 'uid');
};
var getCatalogAccess = function getCatalogAccess(_ref9) {
  var catalogAccess = _ref9.pairing.catalogAccess;
  return catalogAccess;
};
var user_selectors_getUid = function getUid(_ref0) {
  var uid = _ref0.user.uid;
  return uid;
};
var getLastViewedClips = function getLastViewedClips(_ref1) {
  var lastClips = _ref1.user.lastClips;
  return lastClips;
};
var getProfileUsername = function getProfileUsername(_ref10) {
  var profileUsername = _ref10.user.profileUsername;
  return profileUsername;
};
var getProfilePhotoId = function getProfilePhotoId(_ref11) {
  var profileAvatarId = _ref11.user.profileAvatarId;
  return profileAvatarId;
};
var isKidsProfile = function isKidsProfile(_ref12) {
  var isKidsProfile = _ref12.user.isKidsProfile;
  return isKidsProfile;
};
var getHasGeoInfo = function getHasGeoInfo(_ref13) {
  var geo = _ref13.user.geo;
  return Boolean(geo);
};
var getCookies = function getCookies(_ref14) {
  var cookies = _ref14.user.cookies;
  return cookies;
};
var areGdprCookiesSet = function areGdprCookiesSet(_ref15) {
  var areUserPreferencesSet = _ref15.user.areUserPreferencesSet;
  return areUserPreferencesSet;
};
var user_selectors_getParentalLockStatus = function getParentalLockStatus(_ref16) {
  var parentalLockStatus = _ref16.user.parentalLockStatus;
  return parentalLockStatus;
};
var getPreviousProfileUid = function getPreviousProfileUid(state) {
  return get_default()(state, 'user.previousProfileUid', null);
};
var getAccountCompletionStatus = function getAccountCompletionStatus(_ref17) {
  var accountComplete = _ref17.user.accountComplete;
  return accountComplete;
};
;// CONCATENATED MODULE: ./src/logic/pairing/pairing.constants.js
var PAIRING_STATUS_PAIRED = 'paired';
var PAIRING_STATUS_PENDING = 'pending';
var REFRESH_AUTH = 'refreshAuth';
var REQUIRE_AUTH = 'requireAuth';
;// CONCATENATED MODULE: ./src/logic/app/app.constants.js
var ERROR_ON_MISSING_CONFIG = 'Something is wrong with the config parameter';
var PROJECT_NAME = 'bedrock-rdk';
var PERSISTENT = {
  DEVICE_ID_KEY: 'deviceId',
  SYNCHRONIZE_KEY: 'synchronize',
  PROFILE_UID_KEY: 'profileUid',
  PREVIOUS_PROFILE_KEY: 'previousProfile'
};
;// CONCATENATED MODULE: ./src/logic/app/app.utils.js










var APP_ENV = "prod";
var initLogger = function initLogger() {
  if (false) {}
};
var removeSplashScreen = function removeSplashScreen() {
  var splash = document.getElementById('splashscreen');
  if (!splash) {
    return;
  }
  if (!window.splashRemovalTimeout) {
    var transition = 'opacity .75s ease-out';
    splash.style.transition = transition;
    splash.setAttribute('style', "-moz-transition: ".concat(transition, ";"));
    splash.setAttribute('style', "-webkit-transition: ".concat(transition, ";"));
    splash.style.opacity = '0';
    window.splashRemovalTimeout = setTimeout(function () {
      return document.body.removeChild(splash);
    }, 1000);
  }
};
var getTenant = function getTenant() {
  return (src_default()).tenant;
};
var getEnv = function getEnv() {
  return APP_ENV || '';
};
var GLOBALS = ['webpackJsonpapp-bedrock-rdk', 'webpackChunkapp_bedrock_rdk', 'sprintf', 'vsprintf', '_', 'devToolsOptions', 'globalsToPreserve', 'splashRemovalTimeout'];
var preserveGlobals = function preserveGlobals() {
  window.globalsToPreserve = Object.keys(window);
};
var cleanupGlobals = function cleanupGlobals() {
  if (window.splashRemovalTimeout) {
    clearTimeout(window.splashRemovalTimeout);
  }
  if (!window.globalsToPreserve) {
    return;
  }
  var keysToCleanup = Object.keys(window).filter(function (key) {
    return !window.globalsToPreserve.includes(key);
  });
  keysToCleanup.forEach(function (key) {
    try {
      delete window[key];
    } catch (error) {
      console.log("[app.utils] Can not remove property \"".concat(key, "\" in the window object"));
    }
  });
  GLOBALS.forEach(function (key) {
    delete window[key];
  });
  if ({"PELO_PLATFORM":"vodafone","APP_VERSION":"1.48.0","OPTIONS":"{\"platform\":\"vodafone\",\"packaged\":false,\"debug\":false,\"skipHook\":false,\"skipNativeBuild\":true,\"skipBundler\":false}","GITHUB_STATE":"/runner/_work/_temp/_runner_file_commands/save_state_6041b297-2e35-451c-a738-c808c6587fef","npm_package_dependencies__babel_runtime":"7.22.3","npm_package_dependencies__pelo_plugins_screen":"workspace:*","npm_package_dependencies_regenerator_runtime":"0.13.11","npm_package_devDependencies_identity_obj_proxy":"3.0.0","npm_package_scripts_build_config_rtlnl":"APP_CUSTOMER=rtlnl node scripts/build-config","KUBERNETES_SERVICE_PORT":"443","KUBERNETES_PORT":"tcp://[fd39:f9c4:855c::1]:443","npm_package_dependencies_immutable_set":"2.1.0","npm_package_devDependencies__storybook_addon_knobs":"6.2.9","npm_package_devDependencies_prettier_eslint_cli":"7.1.0","npm_package_scripts_preinstall":"npx only-allow pnpm","npm_package_devDependencies__storybook_addon_docs":"6.2.9","npm_package_devDependencies_jest":"29.5.0","npm_package_devDependencies_webpack_bundle_analyzer":"4.10.2","npm_package_scripts_dev_rtlnl":"APP_CUSTOMER=rtlnl pnpm dev","npm_config_user_agent":"pnpm/9.14.4 npm/? node/v22.19.0 linux x64","CI":"true","npm_package_dependencies__bedrock_rdk_constants":"workspace:*","npm_package_dependencies__tornado_rdk_theme":"workspace:*","npm_package_dependencies_abortcontroller_polyfill":"1.7.8","npm_package_devDependencies__lightningjs_cli":"2.2.0","npm_package_scripts_build_config_rtlhu":"APP_CUSTOMER=rtlhu node scripts/build-config","npm_package_scripts_prod_rtlnl":"APP_CUSTOMER=rtlnl pnpm prod","HOSTNAME":"app-bedrock-rdk-deploy-wsgds-d6wcd","RUNNER_ENVIRONMENT":"self-hosted","GITHUB_ENV":"/runner/_work/_temp/_runner_file_commands/set_env_6041b297-2e35-451c-a738-c808c6587fef","UPLOAD_SOURCE_MAPS":"false","npm_package_dependencies__bedrock_rdk_utils":"workspace:*","npm_node_execpath":"/opt/hostedtoolcache/node/22.19.0/x64/bin/node","GITHUB_ACTIONS_RUNNER_EXTRA_USER_AGENT":"actions-runner-controller/v0.27.6","RUNNER_EPHEMERAL":"true","SHLVL":"4","npm_package_packageManager":"pnpm@9.14.4","npm_package_dependencies__bedrock_rdk_lng_storybook":"workspace:*","npm_package_dependencies_html_webpack_plugin":"5.5.0","npm_package_devDependencies__swc_core":"1.3.95","npm_package_scripts_dev_rtlhu":"APP_CUSTOMER=rtlhu pnpm dev","npm_package_scripts_nr_create_browser_applications":"node scripts/createNewRelicApps.js","HOME":"/home/runner","npm_package_devDependencies__babel_plugin_proposal_class_properties":"7.18.6","npm_package_devDependencies__bedrock_package_json_loader":"1.2.4","npm_package_devDependencies_jest_webgl_canvas_mock":"0.2.3","npm_package_scripts_prod_rtlhu":"APP_CUSTOMER=rtlhu pnpm prod","RUNNER_ORG":"","AWS_ROLE_ARN":"arn:aws:iam::374115518324:role/irsa/runners/app-bedrock-rdk-deploy","RUNNER_TEMP":"/runner/_work/_temp","GITHUB_EVENT_PATH":"/runner/_work/_temp/_github_workflow/event.json","npm_package_devDependencies_eslint_config_prettier":"9.0.0","npm_package_scripts_lint_filenames":"node scripts/checkFileScopes.js","npm_package_scripts_server":"http-server -c-1 build","npm_package_scripts_storybook_rtlde":"APP_CUSTOMER=rtlde start-storybook -p 6006","DOCKER_ENABLED":"true","GITHUB_REPOSITORY_OWNER":"m6web","npm_package_engines_node":"22.x","npm_package_dependencies__bedrock_html5_engine":"3.6.8","npm_package_devDependencies__6play_ryp":"3.2.4","npm_package_devDependencies__bedrock_github_api_utils":"1.0.1","npm_package_scripts_lint_json":"pnpm sort-keys:json --lint && prettier-eslint --list-different '/{.,}*.json' --ignore-path '**/package.json'","RUNNER_WORKDIR":"/runner/_work","GENERATE_SOURCEMAP":"true","AWS_WEB_IDENTITY_TOKEN_FILE":"/var/run/secrets/eks.amazonaws.com/serviceaccount/token","GITHUB_RETENTION_DAYS":"7","npm_package_devDependencies__pelo_platforms_vodafone":"10.0.0-alpha.1","npm_package_devDependencies_minimist":"1.2.5","npm_package_scripts_i18n_pull":"node ./scripts/i18nPull.js","npm_package_scripts_lint_md":"pnpm prettier-eslint --list-different $PWD/'**/*.md' $PWD/'.*/**/*.md'","GITHUB_REPOSITORY_OWNER_ID":"5","GITHUB_HEAD_REF":"","npm_package_dependencies_redux_thunk":"2.3.0","ACTIONS_RUNNER_HOOK_JOB_STARTED":"/etc/arc/hooks/job-started.sh","npm_package_dependencies_copy_webpack_plugin":"11.0.0","npm_package_devDependencies__swc_plugin_transform_imports":"1.5.94","npm_package_devDependencies_source_map_explorer":"1.6.0","npm_package_cypress_cucumber_preprocessor_stepDefinitions_0":"cypress/e2e/common/*.js","GITHUB_GRAPHQL_URL":"https://github.m6web.fr/api/graphql","REF":"v1.48.0","npm_package_dependencies__tornado_rdk_icons":"workspace:*","npm_package_dependencies_algoliasearch":"4.12.1","npm_package_dependencies_superagent":"3.8.3","npm_package_devDependencies_slack":"11.0.2","npm_package_scripts_build_config":"node scripts/build-config","npm_package_cypress_cucumber_preprocessor_stepDefinitions_1":"cypress/e2e/[filepart]/**/*.js","npm_package_dependencies_jwt_decode":"2.2.0","npm_package_devDependencies__babel_preset_env":"7.12.1","npm_package_scripts_e2e_rtlnl":"APP_CUSTOMER=rtlnl pnpm cypress open --e2e -b chrome","npm_package_pnpm_overrides__lightningjs_core":"2.9.0","npm_package_cypress_cucumber_preprocessor_stepDefinitions_2":"cypress/e2e/[filepart].js","GITHUB_URL":"https://github.m6web.fr/","RUNNER_ASSETS_DIR":"/runnertmp","npm_package_devDependencies__babel_plugin_transform_runtime":"7.22.4","npm_package_devDependencies_inquirer":"8.1.5","npm_package_scripts_dev":"APP_ENV=development pelo run","RUNNER_OS":"Linux","GITHUB_API_URL":"https://github.m6web.fr/api/v3","MAXPROC":"8","RUNNER_LABELS":"self-hosted,app-bedrock-rdk-deploy","npm_package_devDependencies__pelo_platforms_ziggo":"10.0.0-alpha.1","npm_package_devDependencies_eslint_plugin_import":"2.28.1","npm_package_scripts_logs":"node scripts/logs.js","npm_package_scripts_prod":"APP_ENV=prod pelo run","_":"/home/runner/setup-pnpm/node_modules/.bin/pnpm","RUNNER_GROUP":"green-gha-eks-bedrock-tech","HELM_REGISTRY_CONFIG":"/home/runner/.docker/config.json","GITHUB_WORKFLOW":"🏷 Release staging","npm_package_private":"true","npm_package_dependencies_sprintf_js":"1.1.2","npm_package_devDependencies__m6web_eslint_config":"3.5.0","npm_package_devDependencies_jsonlint":"1.6.3","npm_package_scripts_build_rtlnl":"APP_CUSTOMER=rtlnl pnpm build","npm_package_dependencies__bedrock_rdk_media_engine":"workspace:*","npm_package_dependencies_lightningjs_redux":"workspace:*","npm_package_devDependencies__babel_plugin_proposal_decorators":"7.22.3","npm_package_scripts_lint":"pnpm lint:js && pnpm lint:md && pnpm lint:json && pnpm lint:filenames","npm_config_registry":"https://verdaccio.bedrock.tech","GITHUB_RUN_ID":"3165446","npm_package_dependencies__bedrock_fido_sdk":"29.30.0","npm_package_dependencies_core_js":"3.32.1","npm_package_devDependencies__swc_jest":"0.2.29","npm_package_scripts_lint_tf":"terraform fmt -check -recursive -diff .cloud/terraform","npm_package_scripts_sort_keys_json":"node ./scripts/sortKeysJson.js","npm_package_pnpm_overrides_lodash":"4.17.21","GITHUB_REF_TYPE":"branch","GITHUB_WORKFLOW_SHA":"4ff2b3c7a982f2634428e9d3f25c715365c487e8","KUBERNETES_PORT_443_TCP_ADDR":"fd39:f9c4:855c::1","GITHUB_BASE_REF":"","ImageOS":"ubuntu22","npm_package_devDependencies_dotenv_expand":"5.1.0","npm_package_scripts_build_rtlhu":"APP_CUSTOMER=rtlhu pnpm build","GITHUB_WORKFLOW_REF":"m6web/app-bedrock-rdk/.github/workflows/release-deploy-staging.yml@refs/heads/master","GITHUB_ACTION_REPOSITORY":"","npm_config_node_gyp":"/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/dist/node_modules/node-gyp/bin/node-gyp.js","PATH":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.bin:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/dist/node-gyp-bin:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.bin:/opt/hostedtoolcache/node/22.19.0/x64/bin:/home/runner/setup-pnpm/node_modules/.bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin:/home/runner/.local/bin/","RUNNER_TRACKING_ID":"github_d6d391a5-4033-4ac4-8937-906499292394","RUNNER_TOOL_CACHE":"/opt/hostedtoolcache","npm_package_name":"app-bedrock-rdk","npm_package_repository_type":"git","npm_package_dependencies_serve":"14.1.2","npm_package_devDependencies__babel_eslint_parser":"7.22.15","npm_package_scripts_lint_js":"pnpm eslint --max-warnings=0 .pelo.config.js src/ packages/ platforms/ --cache","NODE":"/opt/hostedtoolcache/node/22.19.0/x64/bin/node","GITHUB_ACTION":"__run_4","GITHUB_RUN_NUMBER":"312","GITHUB_TRIGGERING_ACTOR":"skovalchuk-externe","RUNNER_ARCH":"X64","KUBERNETES_PORT_443_TCP_PORT":"443","npm_package_devDependencies_eslint_config_airbnb_base":"15.0.0","npm_package_scripts_analyze":"APP_ENV=detective pnpm build","npm_package_scripts_build_config_rtlde":"APP_CUSTOMER=rtlde node scripts/build-config","npm_config_frozen_lockfile":"","RUN_URL":"https://github.m6web.fr/m6web/app-bedrock-rdk/actions/runs/3165446","KUBERNETES_PORT_443_TCP_PROTO":"tcp","npm_package_dependencies__pelo_plugins_device":"workspace:*","npm_package_devDependencies__bedrock_deploy_event":"0.11.0","npm_package_devDependencies__pelo_platforms_web":"10.0.0-alpha.1","npm_package_devDependencies__swc_helpers":"0.5.3","npm_package_devDependencies_glob":"7.1.6","npm_package_devDependencies_prettier_eslint":"15.0.1","npm_package_dependencies__lightningjs_core":"2.9.0","npm_package_dependencies_history":"4.9.0","npm_package_dependencies_redux":"4.0.5","npm_package_dependencies_swc_minify_webpack_plugin":"2.1.1","npm_package_devDependencies__storybook_theming":"6.2.9","npm_package_devDependencies_eslint":"8.50.0","npm_package_devDependencies_webpack":"5.88.2","npm_package_scripts_dev_rtlde":"APP_CUSTOMER=rtlde pnpm dev","npm_package_scripts_format_md":"prettier-eslint --write $PWD/'**/*.md' $PWD/'.*/**/*.md'","npm_package_scripts_storybook_rtlnl":"APP_CUSTOMER=rtlnl start-storybook -p 6006","RUNNER_NAME":"app-bedrock-rdk-deploy-wsgds-d6wcd","GITHUB_REF_NAME":"master","GITHUB_REPOSITORY":"m6web/app-bedrock-rdk","S3_PATH":"s3://bedrock-rdk-rtlde-staging-vodafone","npm_package_devDependencies__storybook_html":"6.2.9","npm_package_devDependencies_dotenv":"16.0.3","npm_package_scripts_e2e":"pnpm cypress open --e2e -b chrome","npm_package_scripts_prod_rtlde":"APP_CUSTOMER=rtlde pnpm prod","npm_lifecycle_script":"pelo build \"vodafone\" \"--skip-native-build\"","GITHUB_ACTION_REF":"","DEBIAN_FRONTEND":"noninteractive","npm_package_devDependencies__babel_runtime_corejs3":"7.22.3","npm_package_devDependencies__cypress_webpack_preprocessor":"6.0.0","npm_package_devDependencies__pelo_core":"10.0.0-alpha.1","npm_package_devDependencies__storybook_addons":"6.2.9","npm_package_scripts_test":"PELO_PLATFORM=rdk APP_ENV=test node scripts/test --config=config/jest/config.js","GITHUB_REPOSITORY_ID":"2571","GITHUB_ACTIONS":"true","GOPROXY":"https://goproxy.services.bedrock.tech","NODE_PATH":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules/@pelo/cli/bin/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules/@pelo/cli/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules/@pelo/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/bin/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/node_modules","npm_package_repository_url":"https://github.m6web.fr/m6web/app-bedrock-rdk.git","npm_package_version":"1.48.0","npm_package_dependencies__bedrock_ad_engine":"5.29.4","npm_package_devDependencies__m6web_eslint_plugin_i18n":"2.0.1","npm_package_devDependencies_jest_environment_jsdom":"29.5.0","npm_package_scripts_storybook_rtlhu":"APP_CUSTOMER=rtlhu start-storybook -p 6006","npm_package_pnpm_overrides__lightningjs_sdk":"5.5.5","npm_lifecycle_event":"build","ACTIONS_RUNNER_HOOK_JOB_COMPLETED":"/etc/arc/hooks/job-completed.sh","GITHUB_REF_PROTECTED":"true","GONOSUMDB":"github.m6web.fr","GONOPROXY":"none","npm_package_dependencies_uuid":"10.0.0","npm_package_scripts_build":"pelo build \"vodafone\" \"--skip-native-build\"","npm_package_scripts_upload":"node scripts/uploadToMetrologicalAppStore","GITHUB_WORKSPACE":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","GITHUB_JOB":"build","npm_package_author":"Bedrock","npm_package_engines_pnpm":"9.x.x","npm_package_dependencies__bedrock_youbora_adapter_adengine":"1.7.22","npm_package_dependencies_lodash":"4.17.21","npm_package_devDependencies_cypress":"13.3.0","npm_package_devDependencies_http_server":"14.1.1","npm_package_scripts_test_coverage":"PELO_PLATFORM=rdk APP_ENV=test node scripts/test --config=config/jest/config.js --coverage","GITHUB_SHA":"4ff2b3c7a982f2634428e9d3f25c715365c487e8","GOMAXPROC":"8","GITHUB_RUN_ATTEMPT":"1","DOCKER_HOST":"unix:///run/docker.sock","npm_package_dependencies__bedrock_media_engine":"4.13.0","npm_package_devDependencies__pelo_cli":"10.0.0-alpha.1","KUBERNETES_SERVICE_PORT_HTTPS":"443","GOPRIVATE":"*.m6web.fr,*.bedrock.tech","GITHUB_REF":"refs/heads/master","KUBERNETES_PORT_443_TCP":"tcp://[fd39:f9c4:855c::1]:443","GITHUB_ACTOR":"skovalchuk-externe","npm_package_license":"UNLICENSED","npm_package_dependencies_markdown_it":"12.2.0","DOCKERD_IN_RUNNER":"false","npm_package_dependencies_crypto_js":"3.1.9-1","npm_package_dependencies_qrcode":"1.5.4","npm_package_dependencies_stream_browserify":"3.0.0","npm_package_devDependencies_eslint_plugin_prettier":"5.0.0","npm_package_scripts_format":"pnpm format:js && pnpm format:md && pnpm format:lang","npm_package_scripts_update_lang":"run-s 'i18n:pull {1}' format:lang --","GITHUB_PATH":"/runner/_work/_temp/_runner_file_commands/add_path_6041b297-2e35-451c-a738-c808c6587fef","PWD":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","IS_STAGING":"true","APP_ENV":"prod","GITHUB_ACTOR_ID":"627","KUBERNETES_SERVICE_HOST":"fd39:f9c4:855c::1","RUNNER_WORKSPACE":"/runner/_work/app-bedrock-rdk","npm_package_dependencies_path_to_regexp":"3.0.0","npm_package_scripts_explore":"source-map-explorer build/static/js/main.*","npm_package_scripts_format_tf":"terraform fmt -recursive -write=true .cloud/terraform","npm_execpath":"/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/bin/pnpm.cjs","GITHUB_EVENT_NAME":"workflow_dispatch","GITHUB_SERVER_URL":"https://github.m6web.fr","GITHUB_OUTPUT":"/runner/_work/_temp/_runner_file_commands/set_output_6041b297-2e35-451c-a738-c808c6587fef","npm_package_dependencies__bedrock_rdk_config":"workspace:*","npm_package_devDependencies__pelo_platforms_kpn":"10.0.0-alpha.1","npm_package_devDependencies_es_check":"7.1.1","npm_package_devDependencies_fs_extra":"9.1.0","npm_package_devDependencies_swc_mut_cjs_exports":"0.86.17","RUNNER_STATUS_UPDATE_HOOK":"false","npm_package_dependencies_browser_cookies":"1.2.0","npm_package_dependencies_date_fns":"2.28.0","npm_package_devDependencies__badeball_cypress_cucumber_preprocessor":"18.0.6","npm_package_devDependencies_svgo_loader":"3.0.1","npm_package_scripts_build_storybook":"build-storybook -o dist-storybook","npm_command":"run-script","PNPM_SCRIPT_SRC_DIR":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","APP_CUSTOMER":"rtlde","npm_package_dependencies_storybook_addon_themes":"6.1.0","npm_package_devDependencies__storybook_addon_essentials":"6.2.9","npm_package_scripts_format_js":"prettier-eslint --write $PWD/'src/**/*.js' $PWD/'packages/**/*.js' $PWD/'platforms/**/*.js' $PWD/'config/**/*.js'","PNPM_HOME":"/home/runner/setup-pnpm/node_modules/.bin","RUNNER_ENTERPRISE":"","npm_package_dependencies__tornado_rdk_typography":"workspace:*","npm_package_dependencies_babel_loader":"9.1.2","GITHUB_STEP_SUMMARY":"/runner/_work/_temp/_runner_file_commands/step_summary_6041b297-2e35-451c-a738-c808c6587fef","npm_package_dependencies__lightningjs_sdk":"5.5.5","npm_package_dependencies__pelo_plugins_keys":"workspace:*","npm_package_devDependencies_swc_loader":"0.2.3","npm_package_scripts_build_rtlde":"APP_CUSTOMER=rtlde pnpm build","npm_package_scripts_format_lang":"prettier-eslint --write $PWD/'lang/**/*.json'","npm_package_pnpm_overrides_webpack":"5.88.2","npm_package_pnpm_peerDependencyRules_allowedVersions_webpack":"5","INIT_CWD":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","NODE_ENV":"production"}.APP_ID) {
    var id = 'APP_'.concat({"PELO_PLATFORM":"vodafone","APP_VERSION":"1.48.0","OPTIONS":"{\"platform\":\"vodafone\",\"packaged\":false,\"debug\":false,\"skipHook\":false,\"skipNativeBuild\":true,\"skipBundler\":false}","GITHUB_STATE":"/runner/_work/_temp/_runner_file_commands/save_state_6041b297-2e35-451c-a738-c808c6587fef","npm_package_dependencies__babel_runtime":"7.22.3","npm_package_dependencies__pelo_plugins_screen":"workspace:*","npm_package_dependencies_regenerator_runtime":"0.13.11","npm_package_devDependencies_identity_obj_proxy":"3.0.0","npm_package_scripts_build_config_rtlnl":"APP_CUSTOMER=rtlnl node scripts/build-config","KUBERNETES_SERVICE_PORT":"443","KUBERNETES_PORT":"tcp://[fd39:f9c4:855c::1]:443","npm_package_dependencies_immutable_set":"2.1.0","npm_package_devDependencies__storybook_addon_knobs":"6.2.9","npm_package_devDependencies_prettier_eslint_cli":"7.1.0","npm_package_scripts_preinstall":"npx only-allow pnpm","npm_package_devDependencies__storybook_addon_docs":"6.2.9","npm_package_devDependencies_jest":"29.5.0","npm_package_devDependencies_webpack_bundle_analyzer":"4.10.2","npm_package_scripts_dev_rtlnl":"APP_CUSTOMER=rtlnl pnpm dev","npm_config_user_agent":"pnpm/9.14.4 npm/? node/v22.19.0 linux x64","CI":"true","npm_package_dependencies__bedrock_rdk_constants":"workspace:*","npm_package_dependencies__tornado_rdk_theme":"workspace:*","npm_package_dependencies_abortcontroller_polyfill":"1.7.8","npm_package_devDependencies__lightningjs_cli":"2.2.0","npm_package_scripts_build_config_rtlhu":"APP_CUSTOMER=rtlhu node scripts/build-config","npm_package_scripts_prod_rtlnl":"APP_CUSTOMER=rtlnl pnpm prod","HOSTNAME":"app-bedrock-rdk-deploy-wsgds-d6wcd","RUNNER_ENVIRONMENT":"self-hosted","GITHUB_ENV":"/runner/_work/_temp/_runner_file_commands/set_env_6041b297-2e35-451c-a738-c808c6587fef","UPLOAD_SOURCE_MAPS":"false","npm_package_dependencies__bedrock_rdk_utils":"workspace:*","npm_node_execpath":"/opt/hostedtoolcache/node/22.19.0/x64/bin/node","GITHUB_ACTIONS_RUNNER_EXTRA_USER_AGENT":"actions-runner-controller/v0.27.6","RUNNER_EPHEMERAL":"true","SHLVL":"4","npm_package_packageManager":"pnpm@9.14.4","npm_package_dependencies__bedrock_rdk_lng_storybook":"workspace:*","npm_package_dependencies_html_webpack_plugin":"5.5.0","npm_package_devDependencies__swc_core":"1.3.95","npm_package_scripts_dev_rtlhu":"APP_CUSTOMER=rtlhu pnpm dev","npm_package_scripts_nr_create_browser_applications":"node scripts/createNewRelicApps.js","HOME":"/home/runner","npm_package_devDependencies__babel_plugin_proposal_class_properties":"7.18.6","npm_package_devDependencies__bedrock_package_json_loader":"1.2.4","npm_package_devDependencies_jest_webgl_canvas_mock":"0.2.3","npm_package_scripts_prod_rtlhu":"APP_CUSTOMER=rtlhu pnpm prod","RUNNER_ORG":"","AWS_ROLE_ARN":"arn:aws:iam::374115518324:role/irsa/runners/app-bedrock-rdk-deploy","RUNNER_TEMP":"/runner/_work/_temp","GITHUB_EVENT_PATH":"/runner/_work/_temp/_github_workflow/event.json","npm_package_devDependencies_eslint_config_prettier":"9.0.0","npm_package_scripts_lint_filenames":"node scripts/checkFileScopes.js","npm_package_scripts_server":"http-server -c-1 build","npm_package_scripts_storybook_rtlde":"APP_CUSTOMER=rtlde start-storybook -p 6006","DOCKER_ENABLED":"true","GITHUB_REPOSITORY_OWNER":"m6web","npm_package_engines_node":"22.x","npm_package_dependencies__bedrock_html5_engine":"3.6.8","npm_package_devDependencies__6play_ryp":"3.2.4","npm_package_devDependencies__bedrock_github_api_utils":"1.0.1","npm_package_scripts_lint_json":"pnpm sort-keys:json --lint && prettier-eslint --list-different '/{.,}*.json' --ignore-path '**/package.json'","RUNNER_WORKDIR":"/runner/_work","GENERATE_SOURCEMAP":"true","AWS_WEB_IDENTITY_TOKEN_FILE":"/var/run/secrets/eks.amazonaws.com/serviceaccount/token","GITHUB_RETENTION_DAYS":"7","npm_package_devDependencies__pelo_platforms_vodafone":"10.0.0-alpha.1","npm_package_devDependencies_minimist":"1.2.5","npm_package_scripts_i18n_pull":"node ./scripts/i18nPull.js","npm_package_scripts_lint_md":"pnpm prettier-eslint --list-different $PWD/'**/*.md' $PWD/'.*/**/*.md'","GITHUB_REPOSITORY_OWNER_ID":"5","GITHUB_HEAD_REF":"","npm_package_dependencies_redux_thunk":"2.3.0","ACTIONS_RUNNER_HOOK_JOB_STARTED":"/etc/arc/hooks/job-started.sh","npm_package_dependencies_copy_webpack_plugin":"11.0.0","npm_package_devDependencies__swc_plugin_transform_imports":"1.5.94","npm_package_devDependencies_source_map_explorer":"1.6.0","npm_package_cypress_cucumber_preprocessor_stepDefinitions_0":"cypress/e2e/common/*.js","GITHUB_GRAPHQL_URL":"https://github.m6web.fr/api/graphql","REF":"v1.48.0","npm_package_dependencies__tornado_rdk_icons":"workspace:*","npm_package_dependencies_algoliasearch":"4.12.1","npm_package_dependencies_superagent":"3.8.3","npm_package_devDependencies_slack":"11.0.2","npm_package_scripts_build_config":"node scripts/build-config","npm_package_cypress_cucumber_preprocessor_stepDefinitions_1":"cypress/e2e/[filepart]/**/*.js","npm_package_dependencies_jwt_decode":"2.2.0","npm_package_devDependencies__babel_preset_env":"7.12.1","npm_package_scripts_e2e_rtlnl":"APP_CUSTOMER=rtlnl pnpm cypress open --e2e -b chrome","npm_package_pnpm_overrides__lightningjs_core":"2.9.0","npm_package_cypress_cucumber_preprocessor_stepDefinitions_2":"cypress/e2e/[filepart].js","GITHUB_URL":"https://github.m6web.fr/","RUNNER_ASSETS_DIR":"/runnertmp","npm_package_devDependencies__babel_plugin_transform_runtime":"7.22.4","npm_package_devDependencies_inquirer":"8.1.5","npm_package_scripts_dev":"APP_ENV=development pelo run","RUNNER_OS":"Linux","GITHUB_API_URL":"https://github.m6web.fr/api/v3","MAXPROC":"8","RUNNER_LABELS":"self-hosted,app-bedrock-rdk-deploy","npm_package_devDependencies__pelo_platforms_ziggo":"10.0.0-alpha.1","npm_package_devDependencies_eslint_plugin_import":"2.28.1","npm_package_scripts_logs":"node scripts/logs.js","npm_package_scripts_prod":"APP_ENV=prod pelo run","_":"/home/runner/setup-pnpm/node_modules/.bin/pnpm","RUNNER_GROUP":"green-gha-eks-bedrock-tech","HELM_REGISTRY_CONFIG":"/home/runner/.docker/config.json","GITHUB_WORKFLOW":"🏷 Release staging","npm_package_private":"true","npm_package_dependencies_sprintf_js":"1.1.2","npm_package_devDependencies__m6web_eslint_config":"3.5.0","npm_package_devDependencies_jsonlint":"1.6.3","npm_package_scripts_build_rtlnl":"APP_CUSTOMER=rtlnl pnpm build","npm_package_dependencies__bedrock_rdk_media_engine":"workspace:*","npm_package_dependencies_lightningjs_redux":"workspace:*","npm_package_devDependencies__babel_plugin_proposal_decorators":"7.22.3","npm_package_scripts_lint":"pnpm lint:js && pnpm lint:md && pnpm lint:json && pnpm lint:filenames","npm_config_registry":"https://verdaccio.bedrock.tech","GITHUB_RUN_ID":"3165446","npm_package_dependencies__bedrock_fido_sdk":"29.30.0","npm_package_dependencies_core_js":"3.32.1","npm_package_devDependencies__swc_jest":"0.2.29","npm_package_scripts_lint_tf":"terraform fmt -check -recursive -diff .cloud/terraform","npm_package_scripts_sort_keys_json":"node ./scripts/sortKeysJson.js","npm_package_pnpm_overrides_lodash":"4.17.21","GITHUB_REF_TYPE":"branch","GITHUB_WORKFLOW_SHA":"4ff2b3c7a982f2634428e9d3f25c715365c487e8","KUBERNETES_PORT_443_TCP_ADDR":"fd39:f9c4:855c::1","GITHUB_BASE_REF":"","ImageOS":"ubuntu22","npm_package_devDependencies_dotenv_expand":"5.1.0","npm_package_scripts_build_rtlhu":"APP_CUSTOMER=rtlhu pnpm build","GITHUB_WORKFLOW_REF":"m6web/app-bedrock-rdk/.github/workflows/release-deploy-staging.yml@refs/heads/master","GITHUB_ACTION_REPOSITORY":"","npm_config_node_gyp":"/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/dist/node_modules/node-gyp/bin/node-gyp.js","PATH":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.bin:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/dist/node-gyp-bin:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.bin:/opt/hostedtoolcache/node/22.19.0/x64/bin:/home/runner/setup-pnpm/node_modules/.bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin:/home/runner/.local/bin/","RUNNER_TRACKING_ID":"github_d6d391a5-4033-4ac4-8937-906499292394","RUNNER_TOOL_CACHE":"/opt/hostedtoolcache","npm_package_name":"app-bedrock-rdk","npm_package_repository_type":"git","npm_package_dependencies_serve":"14.1.2","npm_package_devDependencies__babel_eslint_parser":"7.22.15","npm_package_scripts_lint_js":"pnpm eslint --max-warnings=0 .pelo.config.js src/ packages/ platforms/ --cache","NODE":"/opt/hostedtoolcache/node/22.19.0/x64/bin/node","GITHUB_ACTION":"__run_4","GITHUB_RUN_NUMBER":"312","GITHUB_TRIGGERING_ACTOR":"skovalchuk-externe","RUNNER_ARCH":"X64","KUBERNETES_PORT_443_TCP_PORT":"443","npm_package_devDependencies_eslint_config_airbnb_base":"15.0.0","npm_package_scripts_analyze":"APP_ENV=detective pnpm build","npm_package_scripts_build_config_rtlde":"APP_CUSTOMER=rtlde node scripts/build-config","npm_config_frozen_lockfile":"","RUN_URL":"https://github.m6web.fr/m6web/app-bedrock-rdk/actions/runs/3165446","KUBERNETES_PORT_443_TCP_PROTO":"tcp","npm_package_dependencies__pelo_plugins_device":"workspace:*","npm_package_devDependencies__bedrock_deploy_event":"0.11.0","npm_package_devDependencies__pelo_platforms_web":"10.0.0-alpha.1","npm_package_devDependencies__swc_helpers":"0.5.3","npm_package_devDependencies_glob":"7.1.6","npm_package_devDependencies_prettier_eslint":"15.0.1","npm_package_dependencies__lightningjs_core":"2.9.0","npm_package_dependencies_history":"4.9.0","npm_package_dependencies_redux":"4.0.5","npm_package_dependencies_swc_minify_webpack_plugin":"2.1.1","npm_package_devDependencies__storybook_theming":"6.2.9","npm_package_devDependencies_eslint":"8.50.0","npm_package_devDependencies_webpack":"5.88.2","npm_package_scripts_dev_rtlde":"APP_CUSTOMER=rtlde pnpm dev","npm_package_scripts_format_md":"prettier-eslint --write $PWD/'**/*.md' $PWD/'.*/**/*.md'","npm_package_scripts_storybook_rtlnl":"APP_CUSTOMER=rtlnl start-storybook -p 6006","RUNNER_NAME":"app-bedrock-rdk-deploy-wsgds-d6wcd","GITHUB_REF_NAME":"master","GITHUB_REPOSITORY":"m6web/app-bedrock-rdk","S3_PATH":"s3://bedrock-rdk-rtlde-staging-vodafone","npm_package_devDependencies__storybook_html":"6.2.9","npm_package_devDependencies_dotenv":"16.0.3","npm_package_scripts_e2e":"pnpm cypress open --e2e -b chrome","npm_package_scripts_prod_rtlde":"APP_CUSTOMER=rtlde pnpm prod","npm_lifecycle_script":"pelo build \"vodafone\" \"--skip-native-build\"","GITHUB_ACTION_REF":"","DEBIAN_FRONTEND":"noninteractive","npm_package_devDependencies__babel_runtime_corejs3":"7.22.3","npm_package_devDependencies__cypress_webpack_preprocessor":"6.0.0","npm_package_devDependencies__pelo_core":"10.0.0-alpha.1","npm_package_devDependencies__storybook_addons":"6.2.9","npm_package_scripts_test":"PELO_PLATFORM=rdk APP_ENV=test node scripts/test --config=config/jest/config.js","GITHUB_REPOSITORY_ID":"2571","GITHUB_ACTIONS":"true","GOPROXY":"https://goproxy.services.bedrock.tech","NODE_PATH":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules/@pelo/cli/bin/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules/@pelo/cli/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules/@pelo/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/bin/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/node_modules","npm_package_repository_url":"https://github.m6web.fr/m6web/app-bedrock-rdk.git","npm_package_version":"1.48.0","npm_package_dependencies__bedrock_ad_engine":"5.29.4","npm_package_devDependencies__m6web_eslint_plugin_i18n":"2.0.1","npm_package_devDependencies_jest_environment_jsdom":"29.5.0","npm_package_scripts_storybook_rtlhu":"APP_CUSTOMER=rtlhu start-storybook -p 6006","npm_package_pnpm_overrides__lightningjs_sdk":"5.5.5","npm_lifecycle_event":"build","ACTIONS_RUNNER_HOOK_JOB_COMPLETED":"/etc/arc/hooks/job-completed.sh","GITHUB_REF_PROTECTED":"true","GONOSUMDB":"github.m6web.fr","GONOPROXY":"none","npm_package_dependencies_uuid":"10.0.0","npm_package_scripts_build":"pelo build \"vodafone\" \"--skip-native-build\"","npm_package_scripts_upload":"node scripts/uploadToMetrologicalAppStore","GITHUB_WORKSPACE":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","GITHUB_JOB":"build","npm_package_author":"Bedrock","npm_package_engines_pnpm":"9.x.x","npm_package_dependencies__bedrock_youbora_adapter_adengine":"1.7.22","npm_package_dependencies_lodash":"4.17.21","npm_package_devDependencies_cypress":"13.3.0","npm_package_devDependencies_http_server":"14.1.1","npm_package_scripts_test_coverage":"PELO_PLATFORM=rdk APP_ENV=test node scripts/test --config=config/jest/config.js --coverage","GITHUB_SHA":"4ff2b3c7a982f2634428e9d3f25c715365c487e8","GOMAXPROC":"8","GITHUB_RUN_ATTEMPT":"1","DOCKER_HOST":"unix:///run/docker.sock","npm_package_dependencies__bedrock_media_engine":"4.13.0","npm_package_devDependencies__pelo_cli":"10.0.0-alpha.1","KUBERNETES_SERVICE_PORT_HTTPS":"443","GOPRIVATE":"*.m6web.fr,*.bedrock.tech","GITHUB_REF":"refs/heads/master","KUBERNETES_PORT_443_TCP":"tcp://[fd39:f9c4:855c::1]:443","GITHUB_ACTOR":"skovalchuk-externe","npm_package_license":"UNLICENSED","npm_package_dependencies_markdown_it":"12.2.0","DOCKERD_IN_RUNNER":"false","npm_package_dependencies_crypto_js":"3.1.9-1","npm_package_dependencies_qrcode":"1.5.4","npm_package_dependencies_stream_browserify":"3.0.0","npm_package_devDependencies_eslint_plugin_prettier":"5.0.0","npm_package_scripts_format":"pnpm format:js && pnpm format:md && pnpm format:lang","npm_package_scripts_update_lang":"run-s 'i18n:pull {1}' format:lang --","GITHUB_PATH":"/runner/_work/_temp/_runner_file_commands/add_path_6041b297-2e35-451c-a738-c808c6587fef","PWD":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","IS_STAGING":"true","APP_ENV":"prod","GITHUB_ACTOR_ID":"627","KUBERNETES_SERVICE_HOST":"fd39:f9c4:855c::1","RUNNER_WORKSPACE":"/runner/_work/app-bedrock-rdk","npm_package_dependencies_path_to_regexp":"3.0.0","npm_package_scripts_explore":"source-map-explorer build/static/js/main.*","npm_package_scripts_format_tf":"terraform fmt -recursive -write=true .cloud/terraform","npm_execpath":"/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/bin/pnpm.cjs","GITHUB_EVENT_NAME":"workflow_dispatch","GITHUB_SERVER_URL":"https://github.m6web.fr","GITHUB_OUTPUT":"/runner/_work/_temp/_runner_file_commands/set_output_6041b297-2e35-451c-a738-c808c6587fef","npm_package_dependencies__bedrock_rdk_config":"workspace:*","npm_package_devDependencies__pelo_platforms_kpn":"10.0.0-alpha.1","npm_package_devDependencies_es_check":"7.1.1","npm_package_devDependencies_fs_extra":"9.1.0","npm_package_devDependencies_swc_mut_cjs_exports":"0.86.17","RUNNER_STATUS_UPDATE_HOOK":"false","npm_package_dependencies_browser_cookies":"1.2.0","npm_package_dependencies_date_fns":"2.28.0","npm_package_devDependencies__badeball_cypress_cucumber_preprocessor":"18.0.6","npm_package_devDependencies_svgo_loader":"3.0.1","npm_package_scripts_build_storybook":"build-storybook -o dist-storybook","npm_command":"run-script","PNPM_SCRIPT_SRC_DIR":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","APP_CUSTOMER":"rtlde","npm_package_dependencies_storybook_addon_themes":"6.1.0","npm_package_devDependencies__storybook_addon_essentials":"6.2.9","npm_package_scripts_format_js":"prettier-eslint --write $PWD/'src/**/*.js' $PWD/'packages/**/*.js' $PWD/'platforms/**/*.js' $PWD/'config/**/*.js'","PNPM_HOME":"/home/runner/setup-pnpm/node_modules/.bin","RUNNER_ENTERPRISE":"","npm_package_dependencies__tornado_rdk_typography":"workspace:*","npm_package_dependencies_babel_loader":"9.1.2","GITHUB_STEP_SUMMARY":"/runner/_work/_temp/_runner_file_commands/step_summary_6041b297-2e35-451c-a738-c808c6587fef","npm_package_dependencies__lightningjs_sdk":"5.5.5","npm_package_dependencies__pelo_plugins_keys":"workspace:*","npm_package_devDependencies_swc_loader":"0.2.3","npm_package_scripts_build_rtlde":"APP_CUSTOMER=rtlde pnpm build","npm_package_scripts_format_lang":"prettier-eslint --write $PWD/'lang/**/*.json'","npm_package_pnpm_overrides_webpack":"5.88.2","npm_package_pnpm_peerDependencyRules_allowedVersions_webpack":"5","INIT_CWD":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","NODE_ENV":"production"}.APP_ID.replace(/[^0-9a-zA-Z_$]/g, '_'));
    delete window[id];
  }
};
var cleanupConfig = function cleanupConfig() {
  Object.keys((src_default())).forEach(function (key) {
    delete (src_default())[key];
  });
};
;// CONCATENATED MODULE: ./src/logic/analytics/customer/default/utils.js




var startEngines = function () {
  var _ref = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(acceptedEngines, rejectedEngines) {
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return thirdPartyWithLayoutService.initThirdPartyEngines(acceptedEngines);
        case 2:
          thirdPartyWithLayoutService.rejectThirdPartyEngines(rejectedEngines);
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function startEngines(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var stopEngines = function stopEngines() {};
;// CONCATENATED MODULE: ./src/logic/analytics/analytics.utils.js








function analytics_utils_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function analytics_utils_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? analytics_utils_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : analytics_utils_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }















var getThirdPartyServicesConfigs = function getThirdPartyServicesConfigs(enabledEngines) {
  var engines = getEngines();
  return Array.isArray(engines) && Array.isArray(enabledEngines) ? engines.filter(function (_ref) {
    var key = _ref.thirdPartyServiceConfig.key;
    return enabledEngines.includes(key);
  }).map(function (engine) {
    return engine.thirdPartyServiceConfig;
  }) : [];
};
var setAttributes = function setAttributes(attributes) {
  thirdPartyWithLayoutService.setCustomAttributes(attributes);
};
var sendEvent = function sendEvent(event, action) {
  var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!event) {
    return;
  }
  var mappings = (src_default()).analytics.attributesKeysMapping;
  var keys = Object.keys(event);
  for (var i = 0; i < keys.length; i += 1) {
    var key = keys[i];
    var mapping = mappings[key];
    if (event[key] && mapping && mapping.platformCode) {
      event[key][mapping.platformCode] = (src_default()).platformCode;
    }
  }
  thirdPartyWithLayoutService.sendEvent(event, action || null, attributes);
};
var setUser = function setUser(userData) {
  try {
    thirdPartyWithLayoutService.userChange(userData);
  } catch (error) {
    console.error('[AnalyticsUtils]: Can not set user UID');
  }
};
var trackGDPRConsent = function trackGDPRConsent(cookieConsents) {
  try {
    var audienceMeasurement = cookieConsents.audienceMeasurement,
      personalization = cookieConsents.personalization,
      targetedAdvertising = cookieConsents.targetedAdvertising;
    var deviceConsents = {
      tracking: {
        consent: audienceMeasurement
      },
      multiDeviceMatching: {
        consent: personalization
      },
      adTargeting: {
        consent: targetedAdvertising
      }
    };
    thirdPartyWithLayoutService.gdprChange(deviceConsents);
  } catch (error) {
    console.error('[AnalyticsUtils]: Can not set device consents');
  }
};
var sendPageView = function sendPageView(pathname) {
  thirdPartyWithLayoutService.sendPageViewEvent(null, {
    pathname: pathname
  }, {});
};
var sendPrintEvent = function sendPrintEvent() {
  thirdPartyWithLayoutService.sendPrintEvent.apply(thirdPartyWithLayoutService, arguments);
};
var setInitialAttributes = function setInitialAttributes(state) {
  var _getUserState = getUserState(state),
    geo = _getUserState.geo;
  setAttributes({
    deviceID: user_selectors_getDeviceId(state),
    userId: user_selectors_getUid(state),
    homeId: user_selectors_getHomeId(state),
    IPhash: geo ? geo.hashIp : null,
    platformCode: (src_default()).platformCode,
    language: (src_default()).language,
    authentified: getPairingStatus(state) === PAIRING_STATUS_PAIRED ? 'yes' : 'no',
    authMethod: 'pairing',
    entityType: 'app',
    adBlockEnabled: false,
    userStatus: getPairingStatus(state) === PAIRING_STATUS_PAIRED ? 'connected' : 'unknown',
    deviceBrand: getDeviceBrand(state),
    userAgent: navigator.userAgent,
    deviceModel: getDeviceModel(state),
    deviceVersion: getDeviceVersion(state),
    boxType: (src_default()).clientCode,
    project: PROJECT_NAME,
    appTenant: getTenant(),
    appEnv: getEnv(),
    appVersion: env.appVersion,
    appCustomer: env.appCustomer,
    appPlatform: env.appPlatform
  });
};
var enginesNamesToEnabledStateMap = function enginesNamesToEnabledStateMap(engines, shouldEnable) {
  return engines.reduce(function (result, engine) {
    return analytics_utils_objectSpread(analytics_utils_objectSpread({}, result), {}, (0,defineProperty/* default */.Z)({}, engine, shouldEnable));
  }, {});
};
var cleanupEngines = function cleanupEngines() {
  stopEngines();
  var engines = getEngines();
  var cleanedUp = 0;
  if (Array.isArray(engines)) {
    engines.forEach(function (engine) {
      try {
        invoke_default()(engine, 'cleanup');
      } finally {
        cleanedUp += 1;
      }
    });
  }
  console.log("[analytics.utils] Engines cleaned up: ".concat(cleanedUp));
};
var overrideGAPageName = function overrideGAPageName(pageName) {
  var state = lightningjs_redux.getState();
  var currentLayout = getCurrentLayout(state);
  if (currentLayout && currentLayout.analytics && currentLayout.analytics.googleAnalytics) {
    currentLayout.analytics.googleAnalytics.pageName = pageName;
  }
};
;// CONCATENATED MODULE: ./src/modules/tornado/templates/selectors/selector/selector.component.js











function selector_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function selector_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? selector_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : selector_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function selector_component_createSuper(t) { var r = selector_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function selector_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (selector_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }











var Selector = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Selector, _Lightning$Component);
  var _super = selector_component_createSuper(Selector);
  function Selector() {
    (0,classCallCheck/* default */.Z)(this, Selector);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Selector, [{
    key: "_construct",
    value: function _construct() {
      this._style = selector_style_defaultContext;
      this._contentPadding = 0;
      this._index = 0;
      this._selectedTabIndex = 0;
      this._rowHeight = 0;
      this._focusableTags = ['Tabs', getRendererRefByIndex(this._selectedTabIndex)];
      this._renderers = {};
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this._data = undefined;
      this._blocks = undefined;
      this._renderers = {};
    }
  }, {
    key: "id",
    get: function get() {
      return this._id;
    }
  }, {
    key: "data",
    get: function get() {
      return this._data;
    },
    set: function set(value) {
      if (!value) {
        return;
      }
      var _getSelectorTabs = getSelectorTabs(value),
        tabs = _getSelectorTabs.tabs,
        blocks = _getSelectorTabs.blocks;
      var header = this.tag('Tabs');
      header.w = value.rowSize.w;
      header.items = tabs;
      this._id = value.block.id;
      this._rowHeight = value.rowSize.h - getTopBlockHeight();
      this._data = value;
      this._blocks = blocks;
      this._handleSelectedTab(this._selectedTabIndex);
    }
  }, {
    key: "contentPadding",
    get: function get() {
      return this._contentPadding;
    },
    set: function set(value) {
      if (this._contentPadding !== value) {
        this._contentPadding = value;
        this.tag('Tabs').patch({
          x: value,
          leftPadding: value
        });
        this.tag('Content').children.forEach(function (child) {
          child.patch({
            x: value,
            leftPadding: value
          });
        });
      }
    }
  }, {
    key: "focusMode",
    get: function get() {
      return this._focusMode;
    },
    set: function set(value) {
      if (value !== this._focusMode) {
        this.tag('Content').children.forEach(function (child) {
          child.focusMode = value;
        });
        this._focusMode = value;
      }
    }
  }, {
    key: "focusedIndex",
    get: function get() {
      var renderer = this._renderers[this._selectedTabIndex];
      if (!renderer) {
        return 0;
      }
      return this._selectedTabIndex << 16 | renderer.focusedIndex & 0xffff;
    },
    set: function set(value) {
      var index = value & 0xffff;
      var tab = value >> 16;
      var renderer = this._getOrCreateRendererAtIndex(tab);
      var tabsView = this.tag('Tabs');
      if (!renderer) {
        return;
      }
      renderer.focusedIndex = index;
      tabsView.selectedIndex = tab;
      tabsView.goTo(tab);
      this._handleSelectedTab(tab);
      this._index = 1;
      this._refocus();
      var block = this._blocks[tab];
      if (!block || !block.content) {
        return;
      }
      var itemsPerPage = block.content.pagination.itemsPerPage;
      var page = Math.ceil(index / itemsPerPage) || 1;
      this._handlePortionRequest({
        page: page,
        start: (page - 1) * itemsPerPage,
        id: block.id
      });
    }
  }, {
    key: "w",
    get: function get() {
      return (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(Selector.prototype), "w", this);
    },
    set: function set(value) {
      _set((0,getPrototypeOf/* default */.Z)(Selector.prototype), "w", value, this, true);
      this.tag('Content').children.forEach(function (child) {
        child.w = value;
      });
    }
  }, {
    key: "_getOrCreateRendererAtIndex",
    value: function _getOrCreateRendererAtIndex(index) {
      var _signals;
      if (this._renderers[index]) {
        return this._renderers[index];
      }
      var renderer = this.stage.c({
        type: Row,
        ref: getRendererRefByIndex(index),
        focusMode: this._focusMode,
        x: this._contentPadding,
        leftPadding: this._contentPadding,
        rightPadding: selector_style_RIGHT_PADDING[this._style.screenSize],
        signals: (_signals = {}, (0,defineProperty/* default */.Z)(_signals, PORTION_REQUESTED_SIGNAL, '_handlePortionRequest'), (0,defineProperty/* default */.Z)(_signals, SELECTED_SIGNAL, '_handleConcurrentBlockSelect'), _signals)
      });
      this.tag('Content').childList.add(renderer);
      this._renderers[index] = renderer;
      return renderer;
    }
  }, {
    key: "_removeRendererAtIndex",
    value: function _removeRendererAtIndex(index) {
      var renderer = this._renderers[index];
      if (!renderer) {
        return;
      }
      try {
        this.tag('Content').childList.remove(renderer);
      } finally {
        this._renderers[index] = null;
      }
    }
  }, {
    key: "_handleSelectedTab",
    value: function _handleSelectedTab() {
      var tabIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._selectedTabIndex;
      var block = this._blocks[tabIndex];
      var renderer = this._getOrCreateRendererAtIndex(tabIndex);
      renderer.contentPadding = this._contentPadding;
      renderer.w = this.finalW;
      renderer.h = this._rowHeight;
      renderer.data = selector_component_objectSpread(selector_component_objectSpread({}, this._data), {}, {
        block: block,
        blockIndex: undefined
      });
      Object.values(this._renderers).filter(Boolean).forEach(function (view) {
        view.visible = view === renderer;
      });
      if (this._selectedTabIndex !== tabIndex) {
        sendEvent(get_default()(this._data, 'block.alternativeContent.analytics'));
      }
      this._focusableTags[1] = renderer.ref;
      if (this._selectedTabIndex !== tabIndex) {
        this._removeRendererAtIndex(this._selectedTabIndex);
      }
      this._selectedTabIndex = tabIndex;
    }
  }, {
    key: "_handleConcurrentBlockSelect",
    value: function _handleConcurrentBlockSelect(item) {
      sendEvent(get_default()(this._blocks, "[".concat(this._selectedTabIndex, "].analytics")));
      this.signal(SELECTED_SIGNAL, item);
    }
  }, {
    key: "_handlePortionRequest",
    value: function _handlePortionRequest(portion) {
      this.signal(PORTION_REQUESTED_SIGNAL, selector_component_objectSpread(selector_component_objectSpread({}, portion), {}, {
        parentId: this.id
      }));
    }
  }, {
    key: "_handleUp",
    value: function _handleUp() {
      if (this._index > 0) {
        this._index -= 1;
        return true;
      }
      return false;
    }
  }, {
    key: "_handleDown",
    value: function _handleDown() {
      if (this._index < this._focusableTags.length - 1) {
        this._index += 1;
        return true;
      }
      return false;
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this.tag(this._focusableTags[this._index]);
    }
  }], [{
    key: "getOffsetsByBlockData",
    value: function getOffsetsByBlockData(layoutData) {
      var data = layoutData.data;
      var blockType = getBlockTemplateById(data.blockTemplateId);
      var blockOffsets = blockType.getOffsetsByBlockData ? blockType.getOffsetsByBlockData(selector_component_objectSpread(selector_component_objectSpread({}, layoutData), {}, {
        blockIndex: undefined
      })) : {
        top: 0,
        bottom: 0
      };
      return selector_component_objectSpread(selector_component_objectSpread({}, blockOffsets), {}, {
        top: getTopBlockHeight()
      });
    }
  }, {
    key: "_template",
    value: function _template() {
      return merge_default()({
        Tabs: {
          type: SelectorHeader,
          signals: (0,defineProperty/* default */.Z)({}, SELECTED_SIGNAL, '_handleSelectedTab')
        },
        Content: {}
      }, selector_style_getInitialStyle());
    }
  }]);
  return Selector;
}(src_Lightning.Component);

Selector.Templates = selector_constants_templates;
;// CONCATENATED MODULE: ./src/modules/tornado/templates/selectors/index.js

var _selectorTemplates;

var selectorTemplates = (_selectorTemplates = {}, (0,defineProperty/* default */.Z)(_selectorTemplates, Selector.Templates.Selector, Selector), (0,defineProperty/* default */.Z)(_selectorTemplates, Selector.Templates.Tab, Selector), _selectorTemplates);
var getSelectorTemplateById = function getSelectorTemplateById(id) {
  return selectorTemplates[id];
};
;// CONCATENATED MODULE: ./src/modules/tornado/cover/customer/default/focus.style.js







var focus_style_defaultContext = {
  screenSize: sizes_getScreenSize(),
  colorMode: DEFAULT_MODE
};
var focus_style_BORDER_COLOR = makeThemeColor(PRIMARY);

var getBorderTexture = memoize_default()(function (_ref, radius) {
  var screenSize = _ref.screenSize,
    colorMode = _ref.colorMode;
  var diameter = radius * 2 + focus_BORDER_WIDTH[screenSize] * 2;
  return src_Lightning.Tools.getRoundRect(diameter, diameter, radius + focus_BORDER_WIDTH[screenSize], focus_BORDER_WIDTH[screenSize] + 1, focus_style_BORDER_COLOR[colorMode], true, colors_TRANSPARENT);
}, function (_ref2, radius) {
  var screenSize = _ref2.screenSize,
    colorMode = _ref2.colorMode;
  return "".concat(screenSize, "_").concat(colorMode, "_").concat(radius);
});
;// CONCATENATED MODULE: ./src/modules/tornado/cover/customer/rtlde/focus.style.js








var rtlde_focus_style_defaultContext = {
  screenSize: sizes_getScreenSize(),
  colorMode: DEFAULT_MODE
};

var getOuterBorderTexture = memoize_default()(function (_ref, radius) {
  var screenSize = _ref.screenSize,
    colorMode = _ref.colorMode;
  var diameter = radius * 2;
  return src_Lightning.Tools.getRoundRect(diameter, diameter, radius, focus_BORDER_WIDTH[screenSize] / 2, focus_style_BORDER_COLOR[colorMode], true, colors_TRANSPARENT);
}, function (_ref2, radius) {
  var screenSize = _ref2.screenSize,
    colorMode = _ref2.colorMode;
  return "".concat(screenSize, "_").concat(colorMode, "_").concat(radius);
});
var getInnerBorderTexture = memoize_default()(function (_ref3, radius) {
  var screenSize = _ref3.screenSize,
    colorMode = _ref3.colorMode;
  var diameter = radius * 2;
  var borderWidth = focus_BORDER_WIDTH[screenSize] / 2;
  return src_Lightning.Tools.getRoundRect(diameter, diameter, radius, borderWidth + 1, INNER_BORDER_COLOR[colorMode], true, colors_TRANSPARENT);
}, function (_ref4, radius) {
  var screenSize = _ref4.screenSize,
    colorMode = _ref4.colorMode;
  return "".concat(screenSize, "_").concat(colorMode, "_").concat(radius);
});
var focus_style_getInitialStyle = function getInitialStyle() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rtlde_focus_style_defaultContext,
    screenSize = _ref5.screenSize;
  var borderWidth = focus_BORDER_WIDTH[screenSize] / 2;
  return {
    Inner: {
      x: borderWidth,
      y: borderWidth
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/cover/customer/rtlde/focus.component.js





function focus_component_createSuper(t) { var r = focus_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function focus_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (focus_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }



var CoverFocus = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(CoverFocus, _Lightning$Component);
  var _super = focus_component_createSuper(CoverFocus);
  function CoverFocus() {
    (0,classCallCheck/* default */.Z)(this, CoverFocus);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(CoverFocus, [{
    key: "_construct",
    value: function _construct() {
      this._radius = 0;
      this._style = rtlde_focus_style_defaultContext;
    }
  }, {
    key: "radius",
    get: function get() {
      return this._radius;
    },
    set: function set(value) {
      if (value !== this._radius) {
        this._radius = value;
        var borderWidth = focus_BORDER_WIDTH[this._style.screenSize];
        var size = this._radius * 2 + borderWidth * 2;
        this.patch({
          w: size,
          h: size,
          texture: getOuterBorderTexture(this._style, this._radius),
          Inner: {
            w: size - borderWidth,
            h: size - borderWidth,
            texture: getInnerBorderTexture(this._style, this._radius)
          }
        });
      }
    }
  }, {
    key: "colorMode",
    get: function get() {
      return this._colorMode;
    },
    set: function set(value) {
      if (value !== this._style.colorMode) {
        this._style = {
          screenSize: this._style.screenSize,
          colorMode: value
        };
        this.patch({
          texture: getOuterBorderTexture(this._style, this._radius),
          Inner: {
            texture: getInnerBorderTexture(this._style, this._radius)
          }
        });
      }
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Inner: {}
      }, focus_style_getInitialStyle());
    }
  }]);
  return CoverFocus;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/tornado/cover/focus.component.js

;// CONCATENATED MODULE: ./src/modules/tornado/cover/customer/default/cover.constants.js

var LABEL_TEXT_TYPE = FONT_TYPE.MAIN;
;// CONCATENATED MODULE: ./src/modules/tornado/cover/cover.constants.js

var _templates$Cover, _templates$Cover2;
function cover_constants_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function cover_constants_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? cover_constants_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : cover_constants_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


var cover_constants_templates = {
  Cover: 'Cover'
};
var cover_constants_sizes = (0,defineProperty/* default */.Z)({}, cover_constants_templates.Cover, (_templates$Cover = {}, (0,defineProperty/* default */.Z)(_templates$Cover, HD, {
  w: 136,
  h: 232
}), (0,defineProperty/* default */.Z)(_templates$Cover, FULL_HD, {
  w: 208,
  h: 336
}), _templates$Cover));
var commonImageOptions = {
  format: TRANSPARENT_IMAGE_FORMAT,
  fit: 'scale_crop'
};
var cover_constants_imageOptions = (0,defineProperty/* default */.Z)({}, cover_constants_templates.Cover, (_templates$Cover2 = {}, (0,defineProperty/* default */.Z)(_templates$Cover2, HD, {
  PRIMARY: cover_constants_objectSpread(cover_constants_objectSpread({}, commonImageOptions), {}, {
    width: 128,
    height: 128
  })
}), (0,defineProperty/* default */.Z)(_templates$Cover2, FULL_HD, {
  PRIMARY: cover_constants_objectSpread(cover_constants_objectSpread({}, commonImageOptions), {}, {
    width: 192,
    height: 192
  })
}), _templates$Cover2));
;// CONCATENATED MODULE: ./src/modules/tornado/cover/cover.style.js

var _IMAGE_PADDING_BOTTOM;
function cover_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function cover_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? cover_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : cover_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }








var cover_style_defaultContext = {
  screenSize: sizes_getScreenSize(),
  colorMode: DEFAULT_MODE
};
var IMAGE_PADDING_BOTTOM = (_IMAGE_PADDING_BOTTOM = {}, (0,defineProperty/* default */.Z)(_IMAGE_PADDING_BOTTOM, HD, 16), (0,defineProperty/* default */.Z)(_IMAGE_PADDING_BOTTOM, FULL_HD, 24), _IMAGE_PADDING_BOTTOM);
var ALPHA_FOCUSED = 1;
var ALPHA_UNFOCUSED = 0.6;
var cover_style_colors = {
  text: makeThemeColor(PRIMARY)
};
var cover_style_getImageSize = function getImageSize(screenSize) {
  return cover_constants_imageOptions[cover_constants_templates.Cover][screenSize].PRIMARY;
};
var getImageRadius = function getImageRadius(screenSize) {
  return Math.round(cover_style_getImageSize(screenSize).width / 2);
};
var getBorderDiameter = function getBorderDiameter(screenSize) {
  return cover_style_getImageSize(screenSize).width + BORDER_WIDTH[screenSize] * 2;
};
var cover_style_getBorderTexture = function getBorderTexture(context) {
  var screenSize = context.screenSize;
  var diameter = getBorderDiameter(screenSize);
  return Lightning.Tools.getRoundRect(diameter, diameter, getImageRadius(screenSize) + BORDER_WIDTH[screenSize], BORDER_WIDTH[screenSize] + 1, WHITE, true, TRANSPARENT);
};
var cover_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : cover_style_defaultContext;
  var _context$screenSize = context.screenSize,
    screenSize = _context$screenSize === void 0 ? FULL_HD : _context$screenSize;
  var w = cover_constants_sizes[cover_constants_templates.Cover][screenSize].w;
  var imageSize = cover_style_getImageSize(screenSize);
  var borderOffset = -focus_BORDER_WIDTH[screenSize];
  return {
    alpha: ALPHA_UNFOCUSED,
    Border: {
      alpha: 0,
      radius: getImageRadius(screenSize),
      x: borderOffset,
      y: borderOffset
    },
    Image: {
      w: imageSize.width,
      h: imageSize.height,
      shader: {
        radius: getImageRadius(screenSize)
      }
    },
    Label: {
      y: imageSize.height + IMAGE_PADDING_BOTTOM[screenSize],
      w: w,
      text: cover_style_objectSpread(cover_style_objectSpread({}, src_getFont(constants_FONT.KINSHASA_3, screenSize, LABEL_TEXT_TYPE)), {}, {
        verticalAlign: 'middle',
        textAlign: 'center',
        wordBreak: true,
        advancedRenderer: true,
        maxLinesSuffix: '...',
        maxLines: 2,
        textOverflow: 'ellipsis'
      })
    }
  };
};
var focusedStyle = {
  alpha: ALPHA_FOCUSED,
  Border: {
    smooth: {
      alpha: 1,
      scale: 1.05
    }
  },
  Image: {
    smooth: {
      scale: 1.05
    }
  }
};
var cover_style_unFocusedStyle = {
  alpha: ALPHA_UNFOCUSED,
  Border: {
    smooth: {
      alpha: 0,
      scale: 1
    }
  },
  Image: {
    smooth: {
      scale: 1
    }
  }
};
;// CONCATENATED MODULE: ./src/modules/tornado/cover/cover.component.js





function cover_component_createSuper(t) { var r = cover_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function cover_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (cover_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }







var Cover = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Cover, _Lightning$Component);
  var _super = cover_component_createSuper(Cover);
  function Cover() {
    (0,classCallCheck/* default */.Z)(this, Cover);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Cover, [{
    key: "_construct",
    value: function _construct() {
      this._style = cover_style_defaultContext;
    }
  }, {
    key: "_inactive",
    value: function _inactive() {
      this.signal(INACTIVE_SIGNAL, this);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this.tag('Image').removeAllListeners('txLoaded');
      this._item = undefined;
      this.signal(DETACHED_SIGNAL, this);
    }
  }, {
    key: "item",
    get: function get() {
      return this._item;
    },
    set: function set(_ref) {
      var _this = this;
      var content = _ref.content,
        colorMode = _ref.colorScheme;
      if (this._item && this._item.id === content.id) {
        this._item = content;
        return;
      }
      this._item = content;
      if (this._style.colorMode !== colorMode) {
        this._style = {
          screenSize: this._style.screenSize,
          colorMode: colorMode
        };
      }
      var _this$_item = this._item,
        image = _this$_item.image,
        title = _this$_item.title;
      this.tag('Image').once('txLoaded', function () {
        _this.tag('Image').setSmooth('alpha', 1);
      });
      this.patch({
        Border: {
          colorMode: colorMode
        },
        Image: {
          alpha: UNLOADED_TEXTURE_ALPHA,
          src: image.src
        },
        Label: {
          visible: Boolean(title),
          color: cover_style_colors.text[colorMode],
          text: {
            text: title
          }
        }
      });
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this.patch(focusedStyle);
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this.patch(cover_style_unFocusedStyle);
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      this.signal(SELECTED_SIGNAL, this._item);
      return true;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Border: {
          type: CoverFocus
        },
        Image: {
          rtt: true,
          shader: {
            type: src_Lightning.shaders.RoundedRectangle
          }
        },
        Label: {}
      }, cover_style_getInitialStyle());
    }
  }]);
  return Cover;
}(src_Lightning.Component);

Cover.Templates = cover_constants_templates;
Cover.Sizes = cover_constants_sizes;
Cover.ImageOptions = cover_constants_imageOptions;
;// CONCATENATED MODULE: ./src/modules/tornado/hero/heroNav/heroNav.style.js

var heroNav_style_LOCK_ICON_HEIGHT, heroNav_style_ICON_HEIGHT, heroNav_style_sizes, heroNav_style_PADDING_LEFT, heroNav_style_PADDING_RIGHT, heroNav_style_PADDING_BOTTOM;
function heroNav_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function heroNav_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? heroNav_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : heroNav_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





var heroNav_style_defaultContext = makeDefaultStylingContext();
var heroNav_heroNav_style_LOCK_ICON_HEIGHT = (heroNav_style_LOCK_ICON_HEIGHT = {}, (0,defineProperty/* default */.Z)(heroNav_style_LOCK_ICON_HEIGHT, HD, 32), (0,defineProperty/* default */.Z)(heroNav_style_LOCK_ICON_HEIGHT, FULL_HD, 40), heroNav_style_LOCK_ICON_HEIGHT);
var heroNav_heroNav_style_ICON_HEIGHT = (heroNav_style_ICON_HEIGHT = {}, (0,defineProperty/* default */.Z)(heroNav_style_ICON_HEIGHT, HD, 24), (0,defineProperty/* default */.Z)(heroNav_style_ICON_HEIGHT, FULL_HD, 32), heroNav_style_ICON_HEIGHT);
var heroNav_heroNav_style_sizes = (heroNav_style_sizes = {}, (0,defineProperty/* default */.Z)(heroNav_style_sizes, HD, {
  w: 247,
  h: 139
}), (0,defineProperty/* default */.Z)(heroNav_style_sizes, FULL_HD, {
  w: 302,
  h: 170
}), heroNav_style_sizes);
var heroNav_heroNav_style_PADDING_LEFT = (heroNav_style_PADDING_LEFT = {}, (0,defineProperty/* default */.Z)(heroNav_style_PADDING_LEFT, HD, 12), (0,defineProperty/* default */.Z)(heroNav_style_PADDING_LEFT, FULL_HD, 16), heroNav_style_PADDING_LEFT);
var heroNav_heroNav_style_PADDING_RIGHT = (heroNav_style_PADDING_RIGHT = {}, (0,defineProperty/* default */.Z)(heroNav_style_PADDING_RIGHT, HD, 12), (0,defineProperty/* default */.Z)(heroNav_style_PADDING_RIGHT, FULL_HD, 16), heroNav_style_PADDING_RIGHT);
var heroNav_heroNav_style_PADDING_BOTTOM = (heroNav_style_PADDING_BOTTOM = {}, (0,defineProperty/* default */.Z)(heroNav_style_PADDING_BOTTOM, HD, 8), (0,defineProperty/* default */.Z)(heroNav_style_PADDING_BOTTOM, FULL_HD, 12), heroNav_style_PADDING_BOTTOM);
var heroNav_style_ICON_PADDING_VERTICAL = 4;
var heroNav_style_ICON_PADDING_HORIZONTAL = 8;
var heroNav_style_getLockIconViewBox = memoize_default()(function (screenSize) {
  return {
    h: heroNav_heroNav_style_LOCK_ICON_HEIGHT[screenSize]
  };
});
var heroNav_style_colors = {
  border: BORDER_COLOR,
  innerBorder: INNER_BORDER_COLOR
};
var heroNav_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : heroNav_style_defaultContext,
    screenSize = _ref.screenSize;
  var borderSize = focus_BORDER_WIDTH[screenSize];
  var borderOffset = borderSize * 2;
  return {
    zIndex: UNFOCUSED_Z_INDEX,
    Border: {
      w: heroNav_heroNav_style_sizes[screenSize].w + borderOffset,
      h: heroNav_heroNav_style_sizes[screenSize].h + borderOffset,
      x: -borderSize,
      y: -borderSize,
      color: colors_TRANSPARENT,
      shader: {
        radius: rtlde_focus_BORDER_RADIUS[screenSize],
        outline: focus_BORDER_WIDTH[screenSize],
        strokeColor: colors_TRANSPARENT,
        innerColor: colors_TRANSPARENT
      }
    },
    Image: heroNav_style_objectSpread(heroNav_style_objectSpread({}, heroNav_heroNav_style_sizes[screenSize]), {}, {
      shader: {
        radius: rtlde_focus_BORDER_RADIUS[screenSize]
      }
    }),
    LockIcon: {
      x: heroNav_style_ICON_PADDING_HORIZONTAL,
      y: heroNav_style_ICON_PADDING_VERTICAL
    }
  };
};
var heroNav_style_getFocusedStyle = memoize_default()(function (_ref2) {
  var colorMode = _ref2.colorMode;
  return {
    zIndex: FOCUSED_Z_INDEX,
    Border: {
      smooth: {
        scale: focus_SCALE_FOCUSED,
        'shader.strokeColor': heroNav_style_colors.border[colorMode],
        'shader.innerColor': heroNav_style_colors.innerBorder[colorMode],
        'shader.scale': focus_SCALE_FOCUSED
      }
    },
    Image: {
      smooth: {
        scale: focus_SCALE_FOCUSED,
        'shader.scale': focus_SCALE_FOCUSED
      }
    }
  };
}, cacheResolver);
var heroNav_style_unFocusedStyle = {
  zIndex: UNFOCUSED_Z_INDEX,
  Border: {
    smooth: {
      scale: 1,
      'shader.strokeColor': colors_TRANSPARENT,
      'shader.innerColor': colors_TRANSPARENT,
      'shader.scale': 1.0
    }
  },
  Image: {
    smooth: {
      scale: 1,
      'shader.scale': 1.0
    }
  }
};
;// CONCATENATED MODULE: ./src/modules/tornado/hero/heroMetadata/customer/default/heroMetadata.constants.js

var _logoSize;

var logoSize = (_logoSize = {}, (0,defineProperty/* default */.Z)(_logoSize, HD, {
  w: 251,
  h: 157
}), (0,defineProperty/* default */.Z)(_logoSize, FULL_HD, {
  w: 382,
  h: 215
}), _logoSize);
;// CONCATENATED MODULE: ./src/modules/tornado/hero/hero.constants.js

var _templates$Hero, _templates$Hero2;





var hero_constants_templates = {
  Hero: 'Hero'
};
var hero_constants_sizes = (0,defineProperty/* default */.Z)({}, hero_constants_templates.Hero, (_templates$Hero = {}, (0,defineProperty/* default */.Z)(_templates$Hero, HD, {
  w: SCREEN_WIDTH[HD],
  h: Math.round(sizes_SCREEN_HEIGHT[HD] * 0.85)
}), (0,defineProperty/* default */.Z)(_templates$Hero, FULL_HD, {
  w: SCREEN_WIDTH[FULL_HD],
  h: Math.round(sizes_SCREEN_HEIGHT[FULL_HD] * 0.85)
}), _templates$Hero));
var hero_constants_imageOptions = (0,defineProperty/* default */.Z)({}, hero_constants_templates.Hero, (_templates$Hero2 = {}, (0,defineProperty/* default */.Z)(_templates$Hero2, HD, {
  PRIMARY: {
    width: hero_constants_sizes[hero_constants_templates.Hero][HD].w,
    height: hero_constants_sizes[hero_constants_templates.Hero][HD].h
  },
  SECONDARY: {
    width: heroNav_heroNav_style_sizes[HD].w,
    height: heroNav_heroNav_style_sizes[HD].h
  },
  LOGO: {
    width: logoSize[HD].w,
    height: logoSize[HD].h,
    fit: IMAGE_FIT_MAX
  }
}), (0,defineProperty/* default */.Z)(_templates$Hero2, FULL_HD, {
  PRIMARY: {
    width: hero_constants_sizes[hero_constants_templates.Hero][FULL_HD].w,
    height: hero_constants_sizes[hero_constants_templates.Hero][FULL_HD].h
  },
  SECONDARY: {
    width: heroNav_heroNav_style_sizes[FULL_HD].w,
    height: heroNav_heroNav_style_sizes[FULL_HD].h
  },
  LOGO: {
    width: logoSize[FULL_HD].w,
    height: logoSize[FULL_HD].h,
    fit: IMAGE_FIT_MAX
  }
}), _templates$Hero2));
;// CONCATENATED MODULE: ./src/modules/tornado/hero/hero.style.js

var hero_style_CONTENT_GAP, hero_style_HEIGHT, hero_style_PADDING_BOTTOM, hero_style_PADDING_LEFT, _METADATA_PADDING_BOT;
function hero_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function hero_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? hero_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : hero_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






var hero_style_defaultContext = makeDefaultStylingContext();
var hero_hero_style_CONTENT_GAP = (hero_style_CONTENT_GAP = {}, (0,defineProperty/* default */.Z)(hero_style_CONTENT_GAP, HD, 12), (0,defineProperty/* default */.Z)(hero_style_CONTENT_GAP, FULL_HD, 12), hero_style_CONTENT_GAP);
var hero_hero_style_HEIGHT = (hero_style_HEIGHT = {}, (0,defineProperty/* default */.Z)(hero_style_HEIGHT, HD, hero_constants_sizes[hero_constants_templates.Hero][HD].h), (0,defineProperty/* default */.Z)(hero_style_HEIGHT, FULL_HD, hero_constants_sizes[hero_constants_templates.Hero][FULL_HD].h), hero_style_HEIGHT);
var hero_hero_style_PADDING_BOTTOM = (hero_style_PADDING_BOTTOM = {}, (0,defineProperty/* default */.Z)(hero_style_PADDING_BOTTOM, HD, 24), (0,defineProperty/* default */.Z)(hero_style_PADDING_BOTTOM, FULL_HD, 32), hero_style_PADDING_BOTTOM);
var hero_hero_style_PADDING_LEFT = (hero_style_PADDING_LEFT = {}, (0,defineProperty/* default */.Z)(hero_style_PADDING_LEFT, HD, 32), (0,defineProperty/* default */.Z)(hero_style_PADDING_LEFT, FULL_HD, 40), hero_style_PADDING_LEFT);
var METADATA_PADDING_BOTTOM = (_METADATA_PADDING_BOT = {}, (0,defineProperty/* default */.Z)(_METADATA_PADDING_BOT, HD, 24), (0,defineProperty/* default */.Z)(_METADATA_PADDING_BOT, FULL_HD, 32), _METADATA_PADDING_BOT);
var getItemsTop = memoize_default()(function (screenSize) {
  return hero_hero_style_HEIGHT[screenSize] - hero_hero_style_PADDING_BOTTOM[screenSize] - heroNav_heroNav_style_sizes[screenSize].h;
});
var getMetadataBottom = memoize_default()(function (screenSize) {
  return getItemsTop(screenSize) - METADATA_PADDING_BOTTOM[screenSize];
});
var hero_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : hero_style_defaultContext;
  var screenSize = context.screenSize;
  var itemsTop = getItemsTop(screenSize);
  var metadataBottom = getMetadataBottom(screenSize);
  var size = hero_constants_sizes[hero_constants_templates.Hero][screenSize];
  var backgroundSize = hero_constants_imageOptions[hero_constants_templates.Hero][screenSize].PRIMARY;
  var background = {
    w: backgroundSize.width,
    h: backgroundSize.height,
    x: size.w,
    mountX: 1
  };
  return hero_style_objectSpread(hero_style_objectSpread({}, size), {}, {
    Background: hero_style_objectSpread({}, background),
    Gradient: hero_style_objectSpread({}, background),
    Metadata: {
      h: metadataBottom,
      mountY: 1,
      y: metadataBottom
    },
    Items: {
      y: itemsTop,
      rightPadding: safetyMargins.horizontal[screenSize]
    }
  });
};
;// CONCATENATED MODULE: ./src/modules/tornado/hero/heroOverlay/heroOverlay.style.js

var filledColor = makeThemeColor(TERTIARY);
var emptyColor = makeThemeColor(TERTIARY, 0);
;// CONCATENATED MODULE: ./src/modules/tornado/hero/heroOverlay/heroOverlay.component.js





function heroOverlay_component_createSuper(t) { var r = heroOverlay_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function heroOverlay_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (heroOverlay_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }




var HeroOverlay = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(HeroOverlay, _Lightning$Component);
  var _super = heroOverlay_component_createSuper(HeroOverlay);
  function HeroOverlay() {
    (0,classCallCheck/* default */.Z)(this, HeroOverlay);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(HeroOverlay, null, [{
    key: "_template",
    value: function _template() {
      return {
        Left: {
          rect: true,
          w: function w(v) {
            return v * 0.75;
          },
          h: identity,
          colorBl: filledColor[DEFAULT_MODE],
          colorUl: filledColor[DEFAULT_MODE],
          colorUr: emptyColor[DEFAULT_MODE],
          colorBr: emptyColor[DEFAULT_MODE]
        },
        Bottom: {
          rect: true,
          w: identity,
          h: middle,
          mountY: 1,
          y: identity,
          colorBl: filledColor[DEFAULT_MODE],
          colorUl: emptyColor[DEFAULT_MODE],
          colorUr: emptyColor[DEFAULT_MODE],
          colorBr: filledColor[DEFAULT_MODE]
        }
      };
    }
  }]);
  return HeroOverlay;
}(src_Lightning.Component);

;// CONCATENATED MODULE: ./src/modules/tornado/hero/heroMetadata/customer/rtlde/heroMetadata.style.js

var heroMetadata_style_sizes, _margins, _paddings;
function heroMetadata_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function heroMetadata_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? heroMetadata_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : heroMetadata_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





var heroMetadata_style_defaultContext = makeDefaultStylingContext();
var rtlde_heroMetadata_style_sizes = (heroMetadata_style_sizes = {}, (0,defineProperty/* default */.Z)(heroMetadata_style_sizes, HD, {
  iconsRow: {
    w: 1000,
    h: 32
  },
  icon: {
    h: 32
  },
  programLogo: {
    w: 251,
    h: 157
  },
  extraDetails: {
    w: 460
  },
  title: {
    w: 460
  }
}), (0,defineProperty/* default */.Z)(heroMetadata_style_sizes, FULL_HD, {
  iconsRow: {
    w: 1000,
    h: 40
  },
  icon: {
    h: 40
  },
  programLogo: {
    w: 382,
    h: 215
  },
  extraDetails: {
    w: 688
  },
  title: {
    w: 688
  }
}), heroMetadata_style_sizes);
var margins = (_margins = {}, (0,defineProperty/* default */.Z)(_margins, HD, {
  serviceIcon: {
    marginRight: 8
  },
  extraDetails: {
    marginRight: 12
  }
}), (0,defineProperty/* default */.Z)(_margins, FULL_HD, {
  serviceIcon: {
    marginRight: 12
  },
  extraDetails: {
    marginRight: 16
  }
}), _margins);
var paddings = (_paddings = {}, (0,defineProperty/* default */.Z)(_paddings, HD, {
  title: {
    paddingTop: 16
  },
  iconsRow: {
    paddingTop: 16
  }
}), (0,defineProperty/* default */.Z)(_paddings, FULL_HD, {
  title: {
    paddingTop: 16
  },
  iconsRow: {
    paddingTop: 24
  }
}), _paddings);
var getSizes = function getSizes() {
  var screenSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : FULL_HD;
  return rtlde_heroMetadata_style_sizes[screenSize];
};
var getMargins = function getMargins() {
  var screenSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : FULL_HD;
  return margins[screenSize];
};
var getPaddings = function getPaddings() {
  var screenSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : FULL_HD;
  return paddings[screenSize];
};
var getTitleFont = memoize_default()(function (screenSize) {
  return src_getFont(constants_FONT.PARIS_3, screenSize);
});
var getExtraDetailsFont = memoize_default()(function (screenSize) {
  return src_getFont(constants_FONT.BERLIN_1, screenSize);
});
var heroMetadata_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : heroMetadata_style_defaultContext,
    screenSize = _ref.screenSize;
  var sizes = getSizes(screenSize);
  var margins = getMargins(screenSize);
  var paddings = getPaddings(screenSize);
  return {
    flex: {
      direction: 'column',
      justifyContent: 'flex-end'
    },
    ProgramLogo: {
      w: sizes.programLogo.w,
      h: sizes.programLogo.h,
      Logo: {
        mountY: 0.5,
        y: middle
      }
    },
    Incentive: {},
    Title: {
      flexItem: {
        marginTop: paddings.title.paddingTop
      },
      text: heroMetadata_style_objectSpread(heroMetadata_style_objectSpread({}, getTitleFont(screenSize)), {}, {
        verticalAlign: 'middle',
        wordWrapWidth: sizes.title.w,
        maxLines: 2,
        maxLinesSuffix: '...'
      })
    },
    IconsRow: {
      h: sizes.iconsRow.h,
      flexItem: {
        marginTop: paddings.iconsRow.paddingTop
      },
      flex: {
        direction: 'row',
        alignItems: 'center'
      },
      ExtraDetails: {
        text: heroMetadata_style_objectSpread(heroMetadata_style_objectSpread({}, getExtraDetailsFont(screenSize)), {}, {
          verticalAlign: 'middle',
          wordWrapWidth: sizes.extraDetails.w,
          maxLines: 1,
          maxLinesSuffix: '...'
        }),
        flexItem: {
          marginRight: margins.extraDetails.marginRight
        }
      },
      CsaIcon: {}
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/hero/heroMetadata/customer/rtlde/heroMetadata.component.js






function heroMetadata_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function heroMetadata_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? heroMetadata_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : heroMetadata_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function heroMetadata_component_createSuper(t) { var r = heroMetadata_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function heroMetadata_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (heroMetadata_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }








var HeroMetadata = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(HeroMetadata, _Lightning$Component);
  var _super = heroMetadata_component_createSuper(HeroMetadata);
  function HeroMetadata() {
    (0,classCallCheck/* default */.Z)(this, HeroMetadata);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(HeroMetadata, [{
    key: "_construct",
    value: function _construct() {
      this._style = heroMetadata_style_defaultContext;
    }
  }, {
    key: "item",
    set: function set(value) {
      var title = value.title,
        extraDetails = value.extraDetails,
        csaPicto = value.csaPicto,
        incentives = value.incentives;
      var logo = get_default()(value, 'logo.src', '');
      var sizes = getSizes(this._style.screenSize);
      var isExtraDetailsVisible = Boolean(extraDetails);
      var isCsaIconVisible = Boolean(csaPicto);
      var isIconsRowVisible = isExtraDetailsVisible || isCsaIconVisible;
      var incentiveLines = getLinesCount(incentives);
      this.patch({
        ProgramLogo: {
          visible: Boolean(logo),
          Logo: {
            texture: heroMetadata_component_objectSpread(heroMetadata_component_objectSpread({}, contain(logo, sizes.programLogo.w, sizes.programLogo.h)), {}, {
              hasAlpha: true
            })
          }
        },
        Incentive: {
          visible: incentiveLines > 0,
          data: {
            linesCount: incentiveLines,
            w: sizes.iconsRow.w,
            incentives: incentives,
            colorMode: this._style.colorMode
          }
        },
        Title: {
          visible: Boolean(title),
          text: {
            text: title
          }
        },
        IconsRow: {
          visible: isIconsRowVisible,
          ExtraDetails: {
            visible: isExtraDetailsVisible,
            text: {
              text: extraDetails
            }
          },
          CsaIcon: {
            visible: isCsaIconVisible,
            iconData: {
              picto: csaPicto,
              viewBox: sizes.icon
            }
          }
        }
      });
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        ProgramLogo: {
          Logo: {}
        },
        Incentive: {
          type: Incentive
        },
        Title: {},
        IconsRow: {
          ServiceIcon: {
            type: Icon
          },
          ExtraDetails: {},
          CsaIcon: {
            type: Icon
          }
        }
      }, heroMetadata_style_getInitialStyle(this._style));
    }
  }]);
  return HeroMetadata;
}(src_Lightning.Component);

;// CONCATENATED MODULE: ./src/modules/tornado/hero/heroMetadata/heroMetadata.component.js

/* harmony default export */ const heroMetadata_component = (HeroMetadata);
;// CONCATENATED MODULE: ./src/modules/tornado/hero/heroNav/heroNav.component.js






function heroNav_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function heroNav_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? heroNav_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : heroNav_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function heroNav_component_createSuper(t) { var r = heroNav_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function heroNav_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (heroNav_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }









var HeroPoster = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(HeroPoster, _Lightning$Component);
  var _super = heroNav_component_createSuper(HeroPoster);
  function HeroPoster() {
    (0,classCallCheck/* default */.Z)(this, HeroPoster);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(HeroPoster, [{
    key: "_construct",
    value: function _construct() {
      this._style = heroNav_style_defaultContext;
    }
  }, {
    key: "_inactive",
    value: function _inactive() {
      this.signal(INACTIVE_SIGNAL, this);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this._item = undefined;
      this.signal(DETACHED_SIGNAL, this);
    }
  }, {
    key: "item",
    get: function get() {
      return this._item;
    },
    set: function set(_ref) {
      var content = _ref.content,
        config = _ref.config,
        template = _ref.template,
        _ref$colorScheme = _ref.colorScheme,
        colorScheme = _ref$colorScheme === void 0 ? this._style.colorMode : _ref$colorScheme;
      var screenSize = this._style.screenSize;
      var templateDataAccessPath = [template, screenSize];
      if (areContentItemsEqual(this._item, content)) {
        this._item = content;
        return;
      }
      this._item = content;
      this._config = config || heroNav_component_objectSpread({}, get_default()(heroNav_heroNav_style_sizes, templateDataAccessPath, {}));
      this._style.colorMode = colorScheme;
      var _this$_item = this._item,
        secondaryImage = _this$_item.secondaryImage,
        lockPicto = _this$_item.lockPicto;
      this.patch({
        Image: {
          src: secondaryImage && secondaryImage.src
        },
        LockIcon: {
          iconData: {
            picto: lockPicto,
            viewBox: heroNav_style_getLockIconViewBox(this._style.screenSize)
          }
        }
      });
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this.patch(heroNav_style_getFocusedStyle(this._style));
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this.patch(heroNav_style_unFocusedStyle);
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      this.signal(SELECTED_SIGNAL, this._item);
      return true;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Border: {
          rect: true,
          shader: {
            type: focus_shader
          }
        },
        Image: {
          shader: {
            type: ImageShader
          }
        },
        LockIcon: {
          type: Icon
        }
      }, heroNav_style_getInitialStyle(this._style));
    }
  }]);
  return HeroPoster;
}(src_Lightning.Component);

;// CONCATENATED MODULE: ./src/modules/tornado/hero/hero.component.js








function hero_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function hero_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? hero_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : hero_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function hero_component_createSuper(t) { var r = hero_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function hero_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (hero_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }











var Hero = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Hero, _Lightning$Component);
  var _super = hero_component_createSuper(Hero);
  function Hero() {
    (0,classCallCheck/* default */.Z)(this, Hero);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Hero, [{
    key: "_construct",
    value: function _construct() {
      this._style = hero_style_defaultContext;
      this._contentPadding = 0;
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this._items = undefined;
      this._style = undefined;
      this._index = undefined;
      this._contentPadding = 0;
    }
  }, {
    key: "id",
    get: function get() {
      return this._id;
    }
  }, {
    key: "data",
    get: function get() {
      return this._data;
    },
    set: function set(value) {
      var block = value.block;
      this._id = block.id;
      this._items = block.content.items;
      this.tag('Items').data = hero_component_objectSpread(hero_component_objectSpread({}, value), {}, {
        itemType: HeroPoster,
        itemTemplate: 'HeroPoster',
        itemSize: heroNav_heroNav_style_sizes[this._style.screenSize]
      });
      this._setIndex(this.focusedIndex);
    }
  }, {
    key: "contentPadding",
    get: function get() {
      return this._contentPadding;
    },
    set: function set(value) {
      if (value === this._contentPadding) {
        return;
      }
      this._contentPadding = Number.isFinite(value) ? value : 0;
      this.tag('Metadata').x = this._contentPadding;
      this.tag('Items').patch({
        x: value,
        leftPadding: value
      });
    }
  }, {
    key: "background",
    set: function set(value) {
      this.tag('Background').src = value;
    }
  }, {
    key: "focusMode",
    get: function get() {
      return this.tag('Items').focusMode;
    },
    set: function set(value) {
      this.tag('Items').focusMode = value;
    }
  }, {
    key: "focusedIndex",
    get: function get() {
      return this.tag('Items').focusedIndex;
    },
    set: function set(value) {
      this.tag('Items').focusedIndex = value;
      this._setIndex(value);
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this.tag('Items');
    }
  }, {
    key: "_setIndex",
    value: function _setIndex(index) {
      if (!this._items || !this._items.length || index === this._index) {
        return;
      }
      this._index = Number.isFinite(index) ? index : 0;
      var currentItem = this._items[this._index];
      if (currentItem) {
        this.tag('Metadata').item = currentItem;
      }
      this.background = get_default()(this._items, "[".concat(this._index, "].image.src"), '');
    }
  }], [{
    key: "_template",
    value: function _template() {
      var _passSignals;
      return merge_default()({
        Background: {},
        Gradient: {
          type: HeroOverlay
        },
        Metadata: {
          type: heroMetadata_component
        },
        Items: {
          type: Row,
          signals: (0,defineProperty/* default */.Z)({}, FOCUSED_SIGNAL, '_setIndex')
        },
        passSignals: (_passSignals = {}, (0,defineProperty/* default */.Z)(_passSignals, SELECTED_SIGNAL, true), (0,defineProperty/* default */.Z)(_passSignals, PORTION_REQUESTED_SIGNAL, true), _passSignals)
      }, hero_style_getInitialStyle());
    }
  }]);
  return Hero;
}(src_Lightning.Component);

Hero.Templates = hero_constants_templates;
Hero.Sizes = hero_constants_sizes;
Hero.ImageOptions = hero_constants_imageOptions;
;// CONCATENATED MODULE: ./src/modules/tornado/callToAction/primary/customer/rtlde/callToAction.constants.js

var callToAction_constants_BORDER_RADIUS, callToAction_constants_STROKE_UNFOCUSED, callToAction_constants_STROKE_FOCUSED, callToAction_constants_HEIGHT, callToAction_constants_PADDING, callToAction_constants_ICON_WIDTH, callToAction_constants_ICON_HEIGHT, callToAction_constants_ICON_PADDING_LEFT, _DEFAULT_BUTTON_WIDTH;



var rtlde_callToAction_constants_BORDER_RADIUS = (callToAction_constants_BORDER_RADIUS = {}, (0,defineProperty/* default */.Z)(callToAction_constants_BORDER_RADIUS, HD, 8), (0,defineProperty/* default */.Z)(callToAction_constants_BORDER_RADIUS, FULL_HD, 8), callToAction_constants_BORDER_RADIUS);
var rtlde_callToAction_constants_STROKE_UNFOCUSED = (callToAction_constants_STROKE_UNFOCUSED = {}, (0,defineProperty/* default */.Z)(callToAction_constants_STROKE_UNFOCUSED, HD, 2), (0,defineProperty/* default */.Z)(callToAction_constants_STROKE_UNFOCUSED, FULL_HD, 3), callToAction_constants_STROKE_UNFOCUSED);
var rtlde_callToAction_constants_STROKE_FOCUSED = (callToAction_constants_STROKE_FOCUSED = {}, (0,defineProperty/* default */.Z)(callToAction_constants_STROKE_FOCUSED, HD, 2), (0,defineProperty/* default */.Z)(callToAction_constants_STROKE_FOCUSED, FULL_HD, 3), callToAction_constants_STROKE_FOCUSED);
var rtlde_callToAction_constants_HEIGHT = (callToAction_constants_HEIGHT = {}, (0,defineProperty/* default */.Z)(callToAction_constants_HEIGHT, HD, 56), (0,defineProperty/* default */.Z)(callToAction_constants_HEIGHT, FULL_HD, 64), callToAction_constants_HEIGHT);
var rtlde_callToAction_constants_PADDING = (callToAction_constants_PADDING = {}, (0,defineProperty/* default */.Z)(callToAction_constants_PADDING, HD, 24), (0,defineProperty/* default */.Z)(callToAction_constants_PADDING, FULL_HD, 24), callToAction_constants_PADDING);
var rtlde_callToAction_constants_ICON_WIDTH = (callToAction_constants_ICON_WIDTH = {}, (0,defineProperty/* default */.Z)(callToAction_constants_ICON_WIDTH, HD, 32), (0,defineProperty/* default */.Z)(callToAction_constants_ICON_WIDTH, FULL_HD, 40), callToAction_constants_ICON_WIDTH);
var rtlde_callToAction_constants_ICON_HEIGHT = (callToAction_constants_ICON_HEIGHT = {}, (0,defineProperty/* default */.Z)(callToAction_constants_ICON_HEIGHT, HD, 32), (0,defineProperty/* default */.Z)(callToAction_constants_ICON_HEIGHT, FULL_HD, 40), callToAction_constants_ICON_HEIGHT);
var rtlde_callToAction_constants_ICON_PADDING_LEFT = (callToAction_constants_ICON_PADDING_LEFT = {}, (0,defineProperty/* default */.Z)(callToAction_constants_ICON_PADDING_LEFT, HD, 8), (0,defineProperty/* default */.Z)(callToAction_constants_ICON_PADDING_LEFT, FULL_HD, 8), callToAction_constants_ICON_PADDING_LEFT);
var DEFAULT_BUTTON_WIDTH = (_DEFAULT_BUTTON_WIDTH = {}, (0,defineProperty/* default */.Z)(_DEFAULT_BUTTON_WIDTH, HD, 56), (0,defineProperty/* default */.Z)(_DEFAULT_BUTTON_WIDTH, FULL_HD, 64), _DEFAULT_BUTTON_WIDTH);
var LABEL_FONT = constants_FONT.OTTAWA_2;
var INFO_ICON_OFFSET = 0;
var INFO_ICON_OFFSET_X = 0;
var FOCUSED_ICON_STYLE = makeThemeColor(TERTIARY);
var UNFOCUSED_ICON_STYLE = makeThemeColor(PRIMARY);
var INNER_UNFOCUSED_COLOR = makeThemeColor(PRIMARY, 0.3);
var callToAction_constants_STROKE_UNFOCUSED_COLOR = makeThemeColor(TERTIARY, 0.0);
var INNER_FOCUSED_COLOR = makeThemeColor(TERTIARY, 1.0);
var callToAction_constants_STROKE_FOCUSED_COLOR = makeThemeColor(PRIMARY, 1.0);
var callToAction_constants_FILL_UNFOCUSED_COLOR = makeThemeColor(TERTIARY, 0.6);
var callToAction_constants_FILL_FOCUSED_COLOR = makeThemeColor(PRIMARY);
var callToAction_constants_TEXT_UNFOCUSED_COLOR = makeThemeColor(PRIMARY);
var callToAction_constants_TEXT_FOCUSED_COLOR = makeThemeColor(TERTIARY);
;// CONCATENATED MODULE: ./src/modules/tornado/callToAction/primary/customer/rtlde/callToAction.style.js

function callToAction_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function callToAction_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? callToAction_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : callToAction_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






var callToAction_style_defaultContext = makeDefaultStylingContext();
var callToAction_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : callToAction_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  var h = rtlde_callToAction_constants_HEIGHT[screenSize];
  var font = src_getFont(LABEL_FONT, screenSize);
  var borderWidth = focus_BORDER_WIDTH[screenSize];
  return {
    h: h,
    Background: {
      x: -borderWidth,
      y: -borderWidth,
      h: h + borderWidth * 2,
      w: function w(v) {
        return v + borderWidth * 2;
      },
      color: callToAction_constants_FILL_UNFOCUSED_COLOR[colorMode],
      borderWidth: borderWidth,
      borderRadius: rtlde_callToAction_constants_BORDER_RADIUS[screenSize],
      borderColor: callToAction_constants_STROKE_UNFOCUSED_COLOR[colorMode],
      innerColor: INNER_UNFOCUSED_COLOR[colorMode]
    },
    Fill: {
      w: identity,
      h: identity,
      rect: true,
      color: callToAction_constants_FILL_UNFOCUSED_COLOR[colorMode],
      shader: {
        type: src_Lightning.shaders.RoundedRectangle,
        radius: rtlde_callToAction_constants_BORDER_RADIUS[screenSize] - 1
      }
    },
    Icon: {
      color: UNFOCUSED_ICON_STYLE[colorMode],
      y: getCenter(h, rtlde_callToAction_constants_ICON_HEIGHT[screenSize])
    },
    Label: {
      color: callToAction_constants_TEXT_UNFOCUSED_COLOR[colorMode],
      y: getCenter(h, font.lineHeight),
      text: callToAction_style_objectSpread(callToAction_style_objectSpread({}, font), {}, {
        verticalAlign: 'middle'
      })
    }
  };
};
var callToAction_style_getUnFocusedStyle = function getUnFocusedStyle(_ref) {
  var colorMode = _ref.colorMode;
  return {
    Background: {
      smooth: {
        color: callToAction_constants_FILL_UNFOCUSED_COLOR[colorMode],
        borderColor: callToAction_constants_STROKE_UNFOCUSED_COLOR[colorMode],
        innerColor: INNER_UNFOCUSED_COLOR[colorMode],
        scale: 1
      }
    },
    Fill: {
      smooth: {
        color: callToAction_constants_FILL_UNFOCUSED_COLOR[colorMode]
      }
    },
    Icon: {
      color: UNFOCUSED_ICON_STYLE[colorMode]
    },
    Label: {
      color: callToAction_constants_TEXT_UNFOCUSED_COLOR[colorMode]
    }
  };
};
var callToAction_style_getFocusedStyle = function getFocusedStyle(_ref2) {
  var colorMode = _ref2.colorMode;
  return {
    Background: {
      smooth: {
        color: callToAction_constants_FILL_FOCUSED_COLOR[colorMode],
        borderColor: callToAction_constants_STROKE_FOCUSED_COLOR[colorMode],
        innerColor: INNER_FOCUSED_COLOR[colorMode],
        scale: 1
      }
    },
    Fill: {
      smooth: {
        color: callToAction_constants_FILL_FOCUSED_COLOR[colorMode]
      }
    },
    Icon: {
      color: FOCUSED_ICON_STYLE[colorMode]
    },
    Label: {
      color: callToAction_constants_TEXT_FOCUSED_COLOR[colorMode]
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/callToAction/primary/callToAction.style.js

;// CONCATENATED MODULE: ./src/modules/tornado/callToAction/primary/callToAction.constants.js

;// CONCATENATED MODULE: ./src/modules/tornado/callToAction/primary/callToAction.component.js





function callToAction_component_createSuper(t) { var r = callToAction_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function callToAction_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (callToAction_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }







var CallToAction = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(CallToAction, _Lightning$Component);
  var _super = callToAction_component_createSuper(CallToAction);
  function CallToAction() {
    (0,classCallCheck/* default */.Z)(this, CallToAction);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(CallToAction, [{
    key: "_construct",
    value: function _construct() {
      this._style = callToAction_style_defaultContext;
      this._hasIcon = false;
    }
  }, {
    key: "_attach",
    value: function _attach() {
      var _this = this;
      var label = this.tag('Label');
      var icon = this.tag('Icon');
      var handleUpdate = function handleUpdate() {
        var screenSize = _this._style.screenSize;
        var iconWidth = _this._hasIcon ? rtlde_callToAction_constants_ICON_WIDTH[screenSize] : 0;
        var iconPaddingLeft = rtlde_callToAction_constants_ICON_PADDING_LEFT[screenSize];
        var padding = rtlde_callToAction_constants_PADDING[screenSize];
        var size = padding * 2 + label.finalW;
        var offset = iconWidth ? iconPaddingLeft + iconWidth : 0;
        var offsetX = padding + offset;
        if (label.finalW === 0) {
          size = DEFAULT_BUTTON_WIDTH[screenSize];
          padding = getCenter(DEFAULT_BUTTON_WIDTH[screenSize], iconWidth);
          offset = INFO_ICON_OFFSET;
          offsetX = INFO_ICON_OFFSET_X;
        }
        var w = size + offset;
        _this.patch({
          w: w,
          Icon: {
            x: padding
          },
          Label: {
            x: offsetX
          }
        });
      };
      icon.on('txLoaded', handleUpdate);
      label.on('txLoaded', handleUpdate);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this.tag('Label').removeAllListeners('txLoaded');
      this.tag('Icon').removeAllListeners('txLoaded');
    }
  }, {
    key: "label",
    set: function set(value) {
      this.tag('Label').text.text = value;
    }
  }, {
    key: "picto",
    set: function set(value) {
      var screenSize = sizes_getScreenSize();
      this._hasIcon = Boolean(value);
      this.tag('Icon').iconData = {
        picto: value,
        viewBox: {
          w: rtlde_callToAction_constants_ICON_WIDTH[screenSize],
          h: rtlde_callToAction_constants_ICON_HEIGHT[screenSize]
        }
      };
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this.patch(callToAction_style_getFocusedStyle(this._style));
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this.patch(callToAction_style_getUnFocusedStyle(this._style));
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Background: {
          type: ButtonBackground,
          w: identity
        },
        Fill: {},
        Icon: {
          type: Icon
        },
        Label: {}
      }, callToAction_style_getInitialStyle());
    }
  }]);
  return CallToAction;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/tornado/solo/customer/default/solo.constants.js

var _logoOptions;

var logoOptions = (_logoOptions = {}, (0,defineProperty/* default */.Z)(_logoOptions, HD, {
  width: 251,
  height: 141
}), (0,defineProperty/* default */.Z)(_logoOptions, FULL_HD, {
  width: 382,
  height: 215
}), _logoOptions);
;// CONCATENATED MODULE: ./src/modules/tornado/solo/solo.constants.js

var _templates$Solo, _templates$Solo2;



var Z_INDEX_NORMAL = 0;
var Z_INDEX_WITH_PROGRAM_INFO = 1000;
var solo_solo_constants_templates = {
  Solo: 'Solo'
};
var solo_constants_sizes = (0,defineProperty/* default */.Z)({}, solo_solo_constants_templates.Solo, (_templates$Solo = {}, (0,defineProperty/* default */.Z)(_templates$Solo, HD, {
  w: SCREEN_WIDTH[HD],
  h: Math.round(sizes_SCREEN_HEIGHT[HD] * 0.85)
}), (0,defineProperty/* default */.Z)(_templates$Solo, FULL_HD, {
  w: SCREEN_WIDTH[FULL_HD],
  h: Math.round(sizes_SCREEN_HEIGHT[FULL_HD] * 0.85)
}), _templates$Solo));
var solo_constants_imageOptions = (0,defineProperty/* default */.Z)({}, solo_solo_constants_templates.Solo, (_templates$Solo2 = {}, (0,defineProperty/* default */.Z)(_templates$Solo2, HD, {
  PRIMARY: {
    width: solo_constants_sizes[solo_solo_constants_templates.Solo][HD].w,
    height: solo_constants_sizes[solo_solo_constants_templates.Solo][HD].h
  }
}), (0,defineProperty/* default */.Z)(_templates$Solo2, FULL_HD, {
  PRIMARY: {
    width: solo_constants_sizes[solo_solo_constants_templates.Solo][FULL_HD].w,
    height: solo_constants_sizes[solo_solo_constants_templates.Solo][FULL_HD].h
  }
}), _templates$Solo2));
;// CONCATENATED MODULE: ./src/modules/tornado/solo/solo.utils.js

var isVisibleCTA = function isVisibleCTA(ctaData) {
  return Boolean(ctaData) && (Boolean(ctaData.label) || Boolean(ctaData.picto));
};
var isVisibleIcon = function isVisibleIcon(iconData) {
  return Boolean(iconData) && Boolean(iconData.name);
};
var isVisibleDetails = function isVisibleDetails(serviceIcon, csaIcon, extraDetails) {
  return isVisibleIcon(serviceIcon) || isVisibleIcon(csaIcon) || Boolean(extraDetails);
};
;// CONCATENATED MODULE: ./src/modules/tornado/programInformation/scroll/scroll.style.js

var _ARROW_SIZE;




var scroll_style_defaultContext = makeDefaultStylingContext();
var ARROW_SIZE = (_ARROW_SIZE = {}, (0,defineProperty/* default */.Z)(_ARROW_SIZE, HD, 56), (0,defineProperty/* default */.Z)(_ARROW_SIZE, FULL_HD, 80), _ARROW_SIZE);
var scroll_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : scroll_style_defaultContext,
    screenSize = _ref.screenSize;
  return {
    Up: {
      mountX: 0.5,
      x: middle,
      y: 0,
      iconData: {
        picto: {
          name: 'ArrowUp',
          type: ICON_TYPE.SIMPLE_ICON
        },
        viewBox: {
          h: ARROW_SIZE[screenSize]
        }
      }
    },
    Pane: {},
    Down: {
      mountX: 0.5,
      mountY: 1,
      x: middle,
      iconData: {
        picto: {
          name: 'ArrowDown',
          type: ICON_TYPE.SIMPLE_ICON
        },
        viewBox: {
          h: ARROW_SIZE[screenSize]
        }
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/programInformation/scroll/scroll.shader.js
































function scroll_shader_createSuper(t) { var r = scroll_shader_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function scroll_shader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (scroll_shader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var ScrollShader = function (_Lightning$shaders$We) {
  (0,inherits/* default */.Z)(ScrollShader, _Lightning$shaders$We);
  var _super = scroll_shader_createSuper(ScrollShader);
  function ScrollShader(context) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, ScrollShader);
    _this = _super.call(this, context);
    _this._top = 1.0;
    _this._bottom = 0;
    return _this;
  }
  (0,createClass/* default */.Z)(ScrollShader, [{
    key: "setupUniforms",
    value: function setupUniforms(operation) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(ScrollShader.prototype), "setupUniforms", this).call(this, operation);
      var owner = operation.shaderOwner;
      var renderPrecision = this.ctx.stage.getRenderPrecision();
      this._setUniform('top', this._top, this.gl.uniform1f);
      this._setUniform('bottom', this._bottom, this.gl.uniform1f);
      this._setUniform('resolution', new Float32Array([owner._w * renderPrecision, owner._h * renderPrecision]), this.gl.uniform2fv);
    }
  }, {
    key: "top",
    get: function get() {
      return this._top;
    },
    set: function set(value) {
      this._top = value;
      this.redraw();
    }
  }, {
    key: "bottom",
    get: function get() {
      return this._bottom;
    },
    set: function set(value) {
      this._bottom = value;
      this.redraw();
    }
  }]);
  return ScrollShader;
}(src_Lightning.shaders.WebGLDefaultShader);

ScrollShader.vertexShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    attribute vec2 aVertexPosition;\n    attribute vec2 aTextureCoord;\n    attribute vec4 aColor;\n\n    uniform vec2 projection;\n\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n\n    void main(void){\n        gl_Position = vec4(aVertexPosition.x * projection.x - 1.0, aVertexPosition.y * -abs(projection.y) + 1.0, 0.0, 1.0);\n        vTextureCoord = aTextureCoord;\n        vColor = aColor;\n        gl_Position.y = -sign(projection.y) * gl_Position.y;\n    }\n";
ScrollShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n\n    varying vec2 vTextureCoord;\n    varying vec2 vProjection;\n    varying vec4 vColor;\n\n    uniform sampler2D uSampler;\n    uniform float top;\n    uniform float bottom;\n\n    void main(void){\n        vec4 color = texture2D(uSampler, vTextureCoord) * vColor;\n\n        float size = 0.1;\n        float multiplier = 1.0 / size;\n\n        float topMask = 1.0 - max((size * top - vTextureCoord.y) * multiplier, 0.0);\n        float bottomMask = 1.0 - max((vTextureCoord.y - 1.0 + size * bottom) * multiplier, 0.0);\n\n        gl_FragColor = color * topMask * bottomMask;\n    }\n";
;// CONCATENATED MODULE: ./src/modules/tornado/programInformation/scroll/scroll.component.js





function scroll_component_createSuper(t) { var r = scroll_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function scroll_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (scroll_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }





var Scroll = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Scroll, _Lightning$Component);
  var _super = scroll_component_createSuper(Scroll);
  function Scroll() {
    (0,classCallCheck/* default */.Z)(this, Scroll);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Scroll, [{
    key: "_construct",
    value: function _construct() {
      this._style = scroll_style_defaultContext;
      this._offset = 0;
      this._contentHeight = 0;
      this._minOffset = 0;
      this._shouldScroll = false;
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this._style = undefined;
      this._offset = 0;
      this._contentHeight = 0;
      this._minOffset = 0;
      this._shouldScroll = false;
    }
  }, {
    key: "content",
    get: function get() {
      return this.tag('Pane').childList.getByRef('Wrapper');
    },
    set: function set(value) {
      var _this = this;
      var pane = this.tag('Pane');
      var current = pane.childList.getByRef('Wrapper');
      if (current) {
        current.removeAllListeners('txLoaded');
        pane.childList.remove(current);
      }
      var child = this.stage.c(value);
      child.on('txLoaded', function () {
        _this._shouldScroll = child.finalH > _this.h;
        var offset = _this._shouldScroll ? ARROW_SIZE[_this._style.screenSize] : 0;
        _this._minOffset = _this.h - child.finalH - ARROW_SIZE[_this._style.screenSize] * 2;
        pane.patch({
          w: _this.w,
          h: _this.h - offset * 2,
          y: offset
        });
        _this.tag('Up').visible = _this._shouldScroll;
        _this.tag('Down').patch({
          visible: _this._shouldScroll,
          y: _this.h
        });
        _this._updateOffset(0);
      });
      child.ref = 'Wrapper';
      pane.childList.add(child);
    }
  }, {
    key: "_updateOffset",
    value: function _updateOffset(direction) {
      var content = this.content;
      if (!content) {
        return;
      }
      var pane = this.tag('Pane');
      content.setSmooth('y', this._offset);
      this.tag('Up').setSmooth('alpha', this._offset >= 0 ? 0 : 1);
      this.tag('Down').setSmooth('alpha', this._offset <= this._minOffset ? 0 : 1);
      pane.setSmooth('shader.top', this._offset >= 0 ? 0 : 1, {
        delay: direction > 0 ? 0.11 : 0
      });
      pane.setSmooth('shader.bottom', this._offset <= this._minOffset ? 0 : 1, {
        delay: direction < 0 ? 0.11 : 0
      });
    }
  }, {
    key: "_handleUp",
    value: function _handleUp() {
      if (!this._shouldScroll) {
        return true;
      }
      this._offset = Math.min(this._offset + 100, 0);
      this._updateOffset(1);
      return true;
    }
  }, {
    key: "_handleDown",
    value: function _handleDown() {
      if (!this._shouldScroll) {
        return true;
      }
      this._offset = Math.max(this._offset - 100, this._minOffset);
      this._updateOffset(-1);
      return true;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Up: {
          type: Icon
        },
        Pane: {
          rtt: true,
          shader: {
            type: ScrollShader
          }
        },
        Down: {
          type: Icon
        }
      }, scroll_style_getInitialStyle());
    }
  }]);
  return Scroll;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/tornado/programInformation/rating/contentAdvisory.style.js

var _MARGIN, contentAdvisory_style_ICON_SIZE;
function contentAdvisory_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function contentAdvisory_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? contentAdvisory_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : contentAdvisory_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }




var MARGIN = (_MARGIN = {}, (0,defineProperty/* default */.Z)(_MARGIN, HD, 16), (0,defineProperty/* default */.Z)(_MARGIN, FULL_HD, 16), _MARGIN);
var rating_contentAdvisory_style_ICON_SIZE = (contentAdvisory_style_ICON_SIZE = {}, (0,defineProperty/* default */.Z)(contentAdvisory_style_ICON_SIZE, HD, 24), (0,defineProperty/* default */.Z)(contentAdvisory_style_ICON_SIZE, FULL_HD, 32), contentAdvisory_style_ICON_SIZE);
var contentAdvisory_style_defaultContext = makeDefaultStylingContext();
var contentAdvisory_style_COLOR = makeThemeColor(PRIMARY, 0.8);
var ICON_MARGIN = -1;
var getContentAdvisoryIconStyle = function getContentAdvisoryIconStyle(picto, screenSize) {
  return {
    visible: Boolean(picto),
    flexItem: {
      marginRight: ICON_MARGIN
    },
    iconData: {
      picto: picto,
      viewBox: {
        w: rating_contentAdvisory_style_ICON_SIZE[screenSize],
        h: rating_contentAdvisory_style_ICON_SIZE[screenSize]
      }
    }
  };
};
var contentAdvisory_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : contentAdvisory_style_defaultContext,
    screenSize = _ref.screenSize;
  return {
    h: rating_contentAdvisory_style_ICON_SIZE[screenSize],
    flex: {
      direction: 'row',
      alignItems: 'center'
    },
    Label: {
      text: contentAdvisory_style_objectSpread(contentAdvisory_style_objectSpread({}, src_getFont(constants_FONT.BERLIN_1, screenSize)), {}, {
        maxLines: 1,
        verticalAlign: 'middle',
        maxLinesSuffix: '...',
        wordWrap: false
      }),
      flexItem: {
        marginRight: MARGIN[screenSize]
      }
    },
    Icons: {
      h: rating_contentAdvisory_style_ICON_SIZE[screenSize],
      flex: {
        direction: 'row',
        alignItems: 'center'
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/programInformation/rating/contentAdvisory.component.js







function contentAdvisory_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function contentAdvisory_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? contentAdvisory_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : contentAdvisory_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function contentAdvisory_component_createSuper(t) { var r = contentAdvisory_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function contentAdvisory_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (contentAdvisory_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }




var ContentAdvisory = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(ContentAdvisory, _Lightning$Component);
  var _super = contentAdvisory_component_createSuper(ContentAdvisory);
  function ContentAdvisory() {
    (0,classCallCheck/* default */.Z)(this, ContentAdvisory);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(ContentAdvisory, [{
    key: "_construct",
    value: function _construct() {
      this._style = contentAdvisory_style_defaultContext;
    }
  }, {
    key: "data",
    set: function set(_ref) {
      var icons = _ref.icons,
        label = _ref.label;
      var screenSize = this._style.screenSize;
      this.patch({
        Label: {
          visible: Boolean(label),
          text: {
            text: label
          }
        },
        Icons: {
          visible: Boolean(icons.length),
          children: icons.map(function (icon) {
            return contentAdvisory_component_objectSpread({
              type: Icon
            }, getContentAdvisoryIconStyle(icon, screenSize));
          })
        }
      });
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Label: {},
        Icons: {}
      }, contentAdvisory_style_getInitialStyle());
    }
  }]);
  return ContentAdvisory;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/tornado/programInformation/description/programDescription.style.js

var _TEXT_MARGIN, _CONTENT_ADVISORY_MAR, programDescription_style_ICON_SIZE, _ICON_MARGINS;
function programDescription_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function programDescription_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? programDescription_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : programDescription_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }




var TEXT_MARGIN = (_TEXT_MARGIN = {}, (0,defineProperty/* default */.Z)(_TEXT_MARGIN, HD, 8), (0,defineProperty/* default */.Z)(_TEXT_MARGIN, FULL_HD, 16), _TEXT_MARGIN);
var CONTENT_ADVISORY_MARGIN = (_CONTENT_ADVISORY_MAR = {}, (0,defineProperty/* default */.Z)(_CONTENT_ADVISORY_MAR, HD, 40), (0,defineProperty/* default */.Z)(_CONTENT_ADVISORY_MAR, FULL_HD, 40), _CONTENT_ADVISORY_MAR);
var description_programDescription_style_ICON_SIZE = (programDescription_style_ICON_SIZE = {}, (0,defineProperty/* default */.Z)(programDescription_style_ICON_SIZE, HD, 24), (0,defineProperty/* default */.Z)(programDescription_style_ICON_SIZE, FULL_HD, 32), programDescription_style_ICON_SIZE);
var programDescription_style_defaultContext = makeDefaultStylingContext();
var ICON_MARGINS = (_ICON_MARGINS = {}, (0,defineProperty/* default */.Z)(_ICON_MARGINS, HD, {
  marginRight: -1
}), (0,defineProperty/* default */.Z)(_ICON_MARGINS, FULL_HD, {
  marginRight: -1
}), _ICON_MARGINS);
var programDescription_style_colors = {
  details: makeThemeColor(PRIMARY, 0.8),
  description: makeThemeColor(PRIMARY),
  highlight: makeThemeColor(PRIMARY, 0.8)
};
var programDescription_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : programDescription_style_defaultContext,
    screenSize = _ref.screenSize;
  var detailsFont = src_getFont(constants_FONT.BERLIN_1, screenSize);
  var descriptionFont = src_getFont(constants_FONT.OTTAWA_1, screenSize);
  return {
    flex: {
      direction: 'column'
    },
    Highlight: {
      text: programDescription_style_objectSpread(programDescription_style_objectSpread({}, detailsFont), {}, {
        maxLinesSuffix: '...',
        maxLines: 1
      }),
      flexItem: {
        marginBottom: TEXT_MARGIN[screenSize]
      }
    },
    ContentAdvisory: {
      flexItem: {
        marginBottom: CONTENT_ADVISORY_MARGIN[screenSize]
      }
    },
    Description: {
      text: programDescription_style_objectSpread(programDescription_style_objectSpread({}, descriptionFont), {}, {
        maxLinesSuffix: '...'
      })
    },
    Details: {
      text: programDescription_style_objectSpread(programDescription_style_objectSpread({}, detailsFont), {}, {
        maxLinesSuffix: '...',
        maxLines: 1
      })
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/programInformation/description/programDescription.component.js









function programDescription_component_createSuper(t) { var r = programDescription_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function programDescription_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (programDescription_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }





var ProgramDescription = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(ProgramDescription, _Lightning$Component);
  var _super = programDescription_component_createSuper(ProgramDescription);
  function ProgramDescription() {
    (0,classCallCheck/* default */.Z)(this, ProgramDescription);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(ProgramDescription, [{
    key: "_construct",
    value: function _construct() {
      this._style = programDescription_style_defaultContext;
    }
  }, {
    key: "_attach",
    value: function _attach() {
      var _this = this;
      [this.tag('Description'), this.tag('Details')].forEach(function (child) {
        child.onUpdate = function () {
          if (_this._emittedHeight !== _this.finalH) {
            _this._emittedHeight = _this.finalH;
            _this.emit('txLoaded');
          }
        };
      });
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this.tag('Description').onUpdate = undefined;
      this.tag('Details').onUpdate = undefined;
      this._emittedHeight = 0;
    }
  }, {
    key: "data",
    set: function set(value) {
      var description = value.description,
        details = value.details,
        highlight = value.highlight,
        extraHighlight = value.extraHighlight,
        contentAdvisory = value.contentAdvisory;
      var colorMode = this._style.colorMode;
      var icons = (contentAdvisory ? contentAdvisory.pictos : []).filter(Boolean);
      this.patch({
        Highlight: makeTextPatch(highlight, this.w, programDescription_style_colors.highlight[colorMode]),
        ContentAdvisory: {
          visible: Boolean(extraHighlight || icons.length),
          data: {
            icons: icons,
            label: extraHighlight
          }
        },
        Description: makeTextPatch(description, this.w, programDescription_style_colors.description[colorMode]),
        Details: makeTextPatch(details, this.w, programDescription_style_colors.details[colorMode])
      });
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Highlight: {},
        ContentAdvisory: {
          type: ContentAdvisory
        },
        Description: {},
        Details: {}
      }, programDescription_style_getInitialStyle());
    }
  }]);
  return ProgramDescription;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/tornado/programInformation/programInformation.style.js

var _LOGO_DIMENSIONS, _LOGO_MARGIN_BOTTOM, _TEXT_WIDTH, _SERVICE_ICON_HEIGHT;
function programInformation_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function programInformation_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? programInformation_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : programInformation_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





var programInformation_style_defaultContext = makeDefaultStylingContext();
var LOGO_DIMENSIONS = (_LOGO_DIMENSIONS = {}, (0,defineProperty/* default */.Z)(_LOGO_DIMENSIONS, HD, {
  width: sizes_SCREEN_HEIGHT[HD] - safetyMargins.horizontal[HD] * 2,
  height: 136
}), (0,defineProperty/* default */.Z)(_LOGO_DIMENSIONS, FULL_HD, {
  width: sizes_SCREEN_HEIGHT[FULL_HD] - safetyMargins.horizontal[FULL_HD] * 2,
  height: 200
}), _LOGO_DIMENSIONS);
var LOGO_MARGIN_BOTTOM = (_LOGO_MARGIN_BOTTOM = {}, (0,defineProperty/* default */.Z)(_LOGO_MARGIN_BOTTOM, HD, 16), (0,defineProperty/* default */.Z)(_LOGO_MARGIN_BOTTOM, FULL_HD, 24), _LOGO_MARGIN_BOTTOM);
var TEXT_WIDTH = (_TEXT_WIDTH = {}, (0,defineProperty/* default */.Z)(_TEXT_WIDTH, HD, 640), (0,defineProperty/* default */.Z)(_TEXT_WIDTH, FULL_HD, 980), _TEXT_WIDTH);
var SERVICE_ICON_HEIGHT = (_SERVICE_ICON_HEIGHT = {}, (0,defineProperty/* default */.Z)(_SERVICE_ICON_HEIGHT, HD, 40), (0,defineProperty/* default */.Z)(_SERVICE_ICON_HEIGHT, FULL_HD, 56), _SERVICE_ICON_HEIGHT);
var programInformation_style_colors = {
  background: makeThemeColor(TERTIARY, 0.8)
};
var programInformation_style_getTitleFont = function getTitleFont(screenSize) {
  return src_getFont(constants_FONT.TOKYO_4, screenSize);
};
var getScrollTop = function getScrollTop(_ref) {
  var isLogoVisible = _ref.isLogoVisible,
    isTitleVisible = _ref.isTitleVisible,
    isServiceIconVisible = _ref.isServiceIconVisible,
    screenSize = _ref.screenSize;
  var result = 0;
  if (isLogoVisible) {
    result += LOGO_DIMENSIONS[screenSize].height + LOGO_MARGIN_BOTTOM[screenSize];
  } else if (isTitleVisible) {
    result += programInformation_style_getTitleFont(screenSize).lineHeight;
  }
  if (isServiceIconVisible) {
    result += SERVICE_ICON_HEIGHT[screenSize];
  }
  return result;
};
var getServiceIconViewBox = function getServiceIconViewBox(screenSize) {
  return {
    h: SERVICE_ICON_HEIGHT[screenSize]
  };
};
var getContainerHeight = function getContainerHeight(screenSize) {
  return sizes_SCREEN_HEIGHT[screenSize] - safetyMargins.vertical[screenSize] * 2;
};
var programInformation_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : programInformation_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  var containerHeight = getContainerHeight(screenSize);
  return {
    alpha: 0,
    w: SCREEN_WIDTH[screenSize],
    h: sizes_SCREEN_HEIGHT[screenSize],
    Overlay: {
      w: SCREEN_WIDTH[screenSize],
      h: sizes_SCREEN_HEIGHT[screenSize],
      color: programInformation_style_colors.background[colorMode]
    },
    ContentContainer: {
      h: containerHeight,
      x: safetyMargins.horizontal[screenSize],
      y: safetyMargins.vertical[screenSize],
      Top: {
        Title: {
          text: programInformation_style_objectSpread(programInformation_style_objectSpread({}, src_getFont(constants_FONT.TOKYO_4, screenSize)), {}, {
            maxLinesSuffix: '...',
            wordWrapWidth: TEXT_WIDTH[screenSize],
            maxLines: 1
          })
        },
        Logo: {
          flexItem: {
            marginBottom: LOGO_MARGIN_BOTTOM[screenSize]
          }
        },
        ServiceIcon: {},
        flex: {
          direction: 'column'
        }
      },
      Scroll: {
        w: TEXT_WIDTH[screenSize],
        h: containerHeight,
        y: 0
      }
    },
    ExitButton: {
      mountX: 1,
      x: SCREEN_WIDTH[screenSize] - safetyMargins.horizontal[screenSize],
      y: safetyMargins.vertical[screenSize]
    }
  };
};
var getProgramInformationFocusedStyle = function getProgramInformationFocusedStyle() {
  return {
    smooth: {
      alpha: 1
    }
  };
};
var getProgramInformationUnFocusedStyle = function getProgramInformationUnFocusedStyle() {
  return {
    smooth: {
      alpha: 0
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/programInformation/programInformation.constants.js
var PROGRAM_INFORMATION_CLOSED_SIGNAL = 'programInformationClosed';
;// CONCATENATED MODULE: ./src/modules/tornado/programInformation/programInformation.component.js





function programInformation_component_createSuper(t) { var r = programInformation_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function programInformation_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (programInformation_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }











var ProgramInformation = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(ProgramInformation, _Lightning$Component);
  var _super = programInformation_component_createSuper(ProgramInformation);
  function ProgramInformation() {
    (0,classCallCheck/* default */.Z)(this, ProgramInformation);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(ProgramInformation, [{
    key: "_construct",
    value: function _construct() {
      this._style = programInformation_style_defaultContext;
    }
  }, {
    key: "data",
    set: function set(content) {
      if (!content) {
        return;
      }
      var screenSize = this._style.screenSize;
      var image = content.image,
        logo = content.logo;
      var logoSrc = logo && logo.src || '';
      var isLogoVisible = Boolean(logoSrc);
      var isServiceIconVisible = Boolean(content.servicePicto);
      this.patch({
        texture: cover(image.src, SCREEN_WIDTH[this._style.screenSize], sizes_SCREEN_HEIGHT[this._style.screenSize]),
        ContentContainer: {
          Top: {
            Title: {
              visible: !isLogoVisible,
              text: {
                text: content.title
              }
            },
            Logo: {
              visible: isLogoVisible,
              texture: contain(logoSrc, LOGO_DIMENSIONS[screenSize].width, LOGO_DIMENSIONS[screenSize].height)
            },
            ServiceIcon: {
              visible: isServiceIconVisible,
              iconData: {
                picto: content.servicePicto,
                viewBox: getServiceIconViewBox(screenSize)
              }
            }
          }
        }
      });
      var scroll = this.tag('Scroll');
      var scrollableView = scroll.content;
      if (scrollableView) {
        scroll.y = getScrollTop({
          isLogoVisible: isLogoVisible,
          isServiceIconVisible: isServiceIconVisible,
          isTitleVisible: Boolean(content.title),
          screenSize: screenSize
        });
        scroll.h = getContainerHeight(screenSize) - scroll.y;
        scrollableView.data = content;
      }
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this.tag('Scroll');
    }
  }, {
    key: "_handleKey",
    value: function _handleKey() {
      return true;
    }
  }, {
    key: "_handleBack",
    value: function _handleBack() {
      this.signal(PROGRAM_INFORMATION_CLOSED_SIGNAL);
      return true;
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      if (this.tag('ExitButton').visible) {
        this.signal(PROGRAM_INFORMATION_CLOSED_SIGNAL);
      }
      return true;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        rect: true,
        Overlay: {
          rect: true
        },
        ContentContainer: {
          Top: {
            Title: {},
            Logo: {},
            ServiceIcon: {
              type: Icon
            }
          },
          Scroll: {
            type: Scroll,
            content: {
              type: ProgramDescription,
              w: TEXT_WIDTH[programInformation_style_defaultContext.screenSize]
            }
          }
        },
        ExitButton: {
          type: Button,
          visible: false,
          picto: {
            name: 'Cross'
          },
          label: t('global.close')
        }
      }, programInformation_style_getInitialStyle());
    }
  }]);
  return ProgramInformation;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/cta/cta.constants.js

/* harmony default export */ const cta_constants = ({
  AUDIO: AUDIO,
  ACCOUNT_SETTINGS: ACCOUNT_SETTINGS,
  BOOKMARK: BOOKMARK,
  BOOKMARKS: BOOKMARKS,
  UNBOOKMARK: UNBOOKMARK,
  LIVE: LIVE,
  LIVES: LIVES,
  PROGRAM: PROGRAM,
  VIDEO: VIDEO,
  SERVICE: SERVICE,
  HOME_ALIAS: HOME_ALIAS,
  SERVICES: SERVICES,
  PROFILE: PROFILE,
  SEARCH: SEARCH,
  SETTINGS: SETTINGS,
  USAGE_TERMS: USAGE_TERMS,
  SUBSCRIPTION_TERMS: SUBSCRIPTION_TERMS,
  LEGAL_CONDITIONS: LEGAL_CONDITIONS,
  PRIVACY_POLICY: PRIVACY_POLICY,
  FOLDERS: FOLDERS,
  FOLDER: FOLDER,
  INFORMATION: INFORMATION,
  CLOSE: CLOSE,
  OPTOUT: common_constants_OPTOUT,
  LOCK: LOCK,
  LOGOUT: LOGOUT,
  FRONTSPACE: common_constants_FRONTSPACE,
  HELP: HELP,
  FEEDBACK: FEEDBACK,
  PROFILES_GATE: PROFILES_GATE,
  PLAY: PLAY,
  RADIO: RADIO
});
;// CONCATENATED MODULE: ./src/modules/tornado/myListCallToAction/customer/default/myListCallToAction.constants.js
var MY_LIST_ICONS = {
  MY_LIST_ICON_BOOKED: {
    name: 'ListAdded',
    type: ' icon'
  },
  MY_LIST_ICON_UNBOOKED: {
    name: 'ListAdd',
    type: 'icon'
  }
};
;// CONCATENATED MODULE: ./src/modules/tornado/myListCallToAction/myListCallToAction.constants.js

/* harmony default export */ const myListCallToAction_constants = (MY_LIST_ICONS);
;// CONCATENATED MODULE: ./src/modules/tornado/callToAction/secondary/customer/rtlde/callToAction.component.js

;// CONCATENATED MODULE: ./src/modules/tornado/callToAction/secondary/callToAction.component.js


;// CONCATENATED MODULE: ./src/modules/tornado/myListCallToAction/myListCallToAction.utils.js

var makeBookmarkAction = function makeBookmarkAction(id, type) {
  return {
    target: (0,defineProperty/* default */.Z)({}, "value_".concat(type), {
      id: id,
      type: type
    })
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/myListCallToAction/myListCallToAction.component.js






function myListCallToAction_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function myListCallToAction_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? myListCallToAction_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : myListCallToAction_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function myListCallToAction_component_createSuper(t) { var r = myListCallToAction_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function myListCallToAction_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (myListCallToAction_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }






var WithBookmarkToggle = function WithBookmarkToggle(base) {
  return function (_base) {
    (0,inherits/* default */.Z)(BookmarkToggle, _base);
    var _super = myListCallToAction_component_createSuper(BookmarkToggle);
    function BookmarkToggle() {
      (0,classCallCheck/* default */.Z)(this, BookmarkToggle);
      return _super.apply(this, arguments);
    }
    (0,createClass/* default */.Z)(BookmarkToggle, [{
      key: "isBookmarked",
      set: function set(value) {
        this._isBookmarked = value;
        this.picto = value ? myListCallToAction_constants.MY_LIST_ICON_BOOKED : myListCallToAction_constants.MY_LIST_ICON_UNBOOKED;
        if (this._item) {
          this._item.state = this._isBookmarked;
          this._item.action = makeBookmarkAction(this._item.id, this._isBookmarked ? cta_constants.UNBOOKMARK : cta_constants.BOOKMARK);
        }
      }
    }, {
      key: "item",
      set: function set(value) {
        if (!value) {
          return;
        }
        this._item = myListCallToAction_component_objectSpread({}, value);
        this.isBookmarked = this._item.state;
      }
    }, {
      key: "blockIndex",
      set: function set(value) {
        this._blockIndex = value;
      }
    }, {
      key: "itemIndex",
      set: function set(value) {
        this._itemIndex = value;
      }
    }, {
      key: "_handleEnter",
      value: function _handleEnter() {
        if (!this._item) {
          return;
        }
        this.signal(SELECTED_SIGNAL, myListCallToAction_component_objectSpread(myListCallToAction_component_objectSpread({}, this._item), {}, {
          blockIndex: this._blockIndex,
          itemIndex: this._itemIndex
        }));
      }
    }]);
    return BookmarkToggle;
  }(base);
};
var MyListButtonPrimary = WithBookmarkToggle(CallToAction);
var MyListButtonSecondary = WithBookmarkToggle(CallToAction);
;// CONCATENATED MODULE: ./src/modules/tornado/solo/customer/default/solo.style.js

var _FLEX_CONTAINER_WIDTH, _FLEX_CONTAINER_HEIGH, _FLEX_CONTAINER_PADDI, _LOGO_PADDING_BOTTOM, _DETAILS_ROW_HEIGHT, _SERVICE_ICON_MARGIN_, _DESCRIPTION_MARGIN_R, _DESCRIPTION_MARGIN_L, _PROGRESS_BAR_MARGIN_, _CTA_ROW_MARGIN_TOP, solo_style_SERVICE_ICON_HEIGHT, _BASIC_ICON_HEIGHT, _CTA_HEIGHT, _CTA_BUTTON_MARGIN_RI;
function solo_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function solo_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? solo_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : solo_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }








var solo_style_defaultContext = makeDefaultStylingContext();
var FLEX_CONTAINER_WIDTH = (_FLEX_CONTAINER_WIDTH = {}, (0,defineProperty/* default */.Z)(_FLEX_CONTAINER_WIDTH, HD, 460), (0,defineProperty/* default */.Z)(_FLEX_CONTAINER_WIDTH, FULL_HD, 688), _FLEX_CONTAINER_WIDTH);
var FLEX_CONTAINER_HEIGHT = (_FLEX_CONTAINER_HEIGH = {}, (0,defineProperty/* default */.Z)(_FLEX_CONTAINER_HEIGH, HD, 400), (0,defineProperty/* default */.Z)(_FLEX_CONTAINER_HEIGH, FULL_HD, 466), _FLEX_CONTAINER_HEIGH);
var FLEX_CONTAINER_PADDING_BOTTOM = (_FLEX_CONTAINER_PADDI = {}, (0,defineProperty/* default */.Z)(_FLEX_CONTAINER_PADDI, HD, 81), (0,defineProperty/* default */.Z)(_FLEX_CONTAINER_PADDI, FULL_HD, 174), _FLEX_CONTAINER_PADDI);
var LOGO_PADDING_BOTTOM = (_LOGO_PADDING_BOTTOM = {}, (0,defineProperty/* default */.Z)(_LOGO_PADDING_BOTTOM, HD, 16), (0,defineProperty/* default */.Z)(_LOGO_PADDING_BOTTOM, FULL_HD, 24), _LOGO_PADDING_BOTTOM);
var DETAILS_ROW_PADDING_BOTTOM = 16;
var DETAILS_ROW_HEIGHT = (_DETAILS_ROW_HEIGHT = {}, (0,defineProperty/* default */.Z)(_DETAILS_ROW_HEIGHT, HD, 32), (0,defineProperty/* default */.Z)(_DETAILS_ROW_HEIGHT, FULL_HD, 40), _DETAILS_ROW_HEIGHT);
var SERVICE_ICON_MARGIN_RIGHT = (_SERVICE_ICON_MARGIN_ = {}, (0,defineProperty/* default */.Z)(_SERVICE_ICON_MARGIN_, HD, 8), (0,defineProperty/* default */.Z)(_SERVICE_ICON_MARGIN_, FULL_HD, 12), _SERVICE_ICON_MARGIN_);
var DESCRIPTION_MARGIN_RIGHT = (_DESCRIPTION_MARGIN_R = {}, (0,defineProperty/* default */.Z)(_DESCRIPTION_MARGIN_R, HD, 12), (0,defineProperty/* default */.Z)(_DESCRIPTION_MARGIN_R, FULL_HD, 16), _DESCRIPTION_MARGIN_R);
var DESCRIPTION_MARGIN_LEFT = (_DESCRIPTION_MARGIN_L = {}, (0,defineProperty/* default */.Z)(_DESCRIPTION_MARGIN_L, HD, 8), (0,defineProperty/* default */.Z)(_DESCRIPTION_MARGIN_L, FULL_HD, 12), _DESCRIPTION_MARGIN_L);
var TITLE_MARGIN_TOP = 16;
var PROGRESS_BAR_WIDTH = 356;
var TITLE_WORD_PERCENTAGE = 0.4;
var PROGRESS_BAR_MARGIN_TOP = (_PROGRESS_BAR_MARGIN_ = {}, (0,defineProperty/* default */.Z)(_PROGRESS_BAR_MARGIN_, HD, 24), (0,defineProperty/* default */.Z)(_PROGRESS_BAR_MARGIN_, FULL_HD, 32), _PROGRESS_BAR_MARGIN_);
var INFO_ICON = {
  name: 'InfoLight',
  type: 'icon'
};
var CTA_ROW_MARGIN_TOP = (_CTA_ROW_MARGIN_TOP = {}, (0,defineProperty/* default */.Z)(_CTA_ROW_MARGIN_TOP, HD, 24), (0,defineProperty/* default */.Z)(_CTA_ROW_MARGIN_TOP, FULL_HD, 32), _CTA_ROW_MARGIN_TOP);
var default_solo_style_SERVICE_ICON_HEIGHT = (solo_style_SERVICE_ICON_HEIGHT = {}, (0,defineProperty/* default */.Z)(solo_style_SERVICE_ICON_HEIGHT, HD, 32), (0,defineProperty/* default */.Z)(solo_style_SERVICE_ICON_HEIGHT, FULL_HD, 40), solo_style_SERVICE_ICON_HEIGHT);
var BASIC_ICON_HEIGHT = (_BASIC_ICON_HEIGHT = {}, (0,defineProperty/* default */.Z)(_BASIC_ICON_HEIGHT, HD, 24), (0,defineProperty/* default */.Z)(_BASIC_ICON_HEIGHT, FULL_HD, 32), _BASIC_ICON_HEIGHT);
var CTA_HEIGHT = (_CTA_HEIGHT = {}, (0,defineProperty/* default */.Z)(_CTA_HEIGHT, HD, 56), (0,defineProperty/* default */.Z)(_CTA_HEIGHT, FULL_HD, 64), _CTA_HEIGHT);
var CTA_BUTTON_MARGIN_RIGHT = (_CTA_BUTTON_MARGIN_RI = {}, (0,defineProperty/* default */.Z)(_CTA_BUTTON_MARGIN_RI, HD, 24), (0,defineProperty/* default */.Z)(_CTA_BUTTON_MARGIN_RI, FULL_HD, 32), _CTA_BUTTON_MARGIN_RI);
var solo_style_getServiceIconViewBox = memoize_default()(function (screenSize) {
  return {
    h: default_solo_style_SERVICE_ICON_HEIGHT[screenSize]
  };
});
var getBasicIconViewBox = memoize_default()(function (screenSize) {
  return {
    h: BASIC_ICON_HEIGHT[screenSize]
  };
});
var solo_style_colors = {
  text: makeThemeColor(PRIMARY)
};
var getTitleWordWrapWidth = function getTitleWordWrapWidth(screenSize) {
  return Math.round(SCREEN_WIDTH[screenSize] * TITLE_WORD_PERCENTAGE);
};
var solo_style_makeBasicTextStyle = function makeBasicTextStyle(_ref) {
  var font = _ref.font,
    colorMode = _ref.colorMode;
  return {
    color: solo_style_colors.text[colorMode],
    text: solo_style_objectSpread(solo_style_objectSpread({}, font), {}, {
      verticalAlign: 'middle',
      wordWrap: true,
      maxLines: 2,
      maxLinesSuffix: '...'
    })
  };
};
var solo_style_getInitialStyle = memoize_default()(function () {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : solo_style_defaultContext,
    _ref2$screenSize = _ref2.screenSize,
    screenSize = _ref2$screenSize === void 0 ? FULL_HD : _ref2$screenSize,
    _ref2$colorMode = _ref2.colorMode,
    colorMode = _ref2$colorMode === void 0 ? DEFAULT_MODE : _ref2$colorMode;
  return {
    Gradient: {
      w: identity,
      h: identity
    },
    FlexContainer: {
      rect: true,
      color: colors_TRANSPARENT,
      w: FLEX_CONTAINER_WIDTH[screenSize],
      h: FLEX_CONTAINER_HEIGHT[screenSize],
      y: solo_constants_imageOptions[solo_solo_constants_templates.Solo][screenSize].PRIMARY.height - FLEX_CONTAINER_HEIGHT[screenSize] - FLEX_CONTAINER_PADDING_BOTTOM[screenSize],
      flex: {
        direction: 'column',
        justifyContent: 'flex-end'
      },
      Logo: {
        flexItem: {
          marginBottom: LOGO_PADDING_BOTTOM[screenSize]
        }
      },
      DetailsFlexContainer: {
        rect: true,
        h: DETAILS_ROW_HEIGHT[screenSize],
        color: colors_TRANSPARENT,
        flex: {
          direction: 'row'
        },
        flexItem: {
          paddingBottom: DETAILS_ROW_PADDING_BOTTOM
        },
        ServiceIcon: {},
        Description: {
          mountY: 0.5,
          y: middle,
          text: solo_style_objectSpread(solo_style_objectSpread({}, src_getFont(constants_FONT.BERLIN_1, screenSize)), {}, {
            maxLines: 1,
            verticalAlign: 'middle'
          }),
          alpha: 0.8,
          flexItem: {
            marginLeft: DESCRIPTION_MARGIN_LEFT[screenSize],
            marginRight: DESCRIPTION_MARGIN_RIGHT[screenSize]
          }
        },
        BasicIcon: {
          flexItem: {
            marginTop: (DETAILS_ROW_HEIGHT[screenSize] - BASIC_ICON_HEIGHT[screenSize]) / 2
          },
          alpha: 0.8
        }
      },
      Title: solo_style_objectSpread(solo_style_objectSpread({}, solo_style_makeBasicTextStyle({
        font: src_getFont(constants_FONT.PARIS_3, screenSize),
        colorMode: colorMode
      })), {}, {
        flexItem: {
          marginTop: TITLE_MARGIN_TOP
        }
      }),
      ProgressBar: {
        w: PROGRESS_BAR_WIDTH,
        mountY: 1,
        flexItem: {
          marginTop: PROGRESS_BAR_MARGIN_TOP[screenSize]
        }
      },
      CTAFlexContainer: {
        rect: true,
        h: CTA_HEIGHT[screenSize],
        w: FLEX_CONTAINER_WIDTH[screenSize],
        color: colors_TRANSPARENT,
        flex: {
          direction: 'row'
        },
        flexItem: {
          marginTop: CTA_ROW_MARGIN_TOP[screenSize]
        },
        PlayButton: {
          flexItem: {
            marginRight: CTA_BUTTON_MARGIN_RIGHT[screenSize]
          }
        },
        MyListButton: {
          flexItem: {
            marginRight: CTA_BUTTON_MARGIN_RIGHT[screenSize]
          }
        },
        InfoButton: {
          picto: INFO_ICON
        }
      }
    }
  };
}, cacheResolver);
;// CONCATENATED MODULE: ./src/modules/tornado/solo/customer/default/solo.component.js











function default_solo_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function default_solo_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? default_solo_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : default_solo_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function default_solo_component_createSuper(t) { var r = default_solo_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function default_solo_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (default_solo_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }





















var solo_component_Solo = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Solo, _Lightning$Component);
  var _super = default_solo_component_createSuper(Solo);
  function Solo() {
    (0,classCallCheck/* default */.Z)(this, Solo);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Solo, [{
    key: "_construct",
    value: function _construct() {
      this._buttons = [];
      this._index = 0;
      this._style = solo_style_defaultContext;
    }
  }, {
    key: "_init",
    value: function _init() {
      var _this = this;
      var serviceIcon = this.tag('ServiceIcon');
      serviceIcon.on('txLoaded', function () {
        serviceIcon.patch({
          flexItem: {
            marginRight: SERVICE_ICON_MARGIN_RIGHT[_this._style.screenSize]
          }
        });
      });
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this.tag('ServiceIcon').removeAllListeners('txLoaded');
    }
  }, {
    key: "item",
    get: function get() {
      return this._item;
    },
    set: function set(_ref) {
      var content = _ref.content,
        blockIndex = _ref.blockIndex,
        itemIndex = _ref.itemIndex,
        config = _ref.config,
        _ref$colorScheme = _ref.colorScheme,
        colorScheme = _ref$colorScheme === void 0 ? solo_style_defaultContext.colorMode : _ref$colorScheme;
      this._item = content;
      var _this$_item = this._item,
        image = _this$_item.image,
        title = _this$_item.title,
        logo = _this$_item.logo,
        progress = _this$_item.progress,
        action = _this$_item.action,
        csaPicto = _this$_item.csaPicto,
        servicePicto = _this$_item.servicePicto,
        extraDetails = _this$_item.extraDetails,
        bookmark = _this$_item.bookmark,
        description = _this$_item.description;
      var textColor = solo_style_colors.text[colorScheme];
      var screenSize = this._style.screenSize;
      var logoSrc = logo && logo.src || '';
      var titleWidth = getTitleWordWrapWidth(screenSize);
      this.patch({
        texture: cover(image.src, config.w, config.h),
        FlexContainer: {
          Logo: {
            visible: Boolean(logoSrc),
            texture: default_solo_component_objectSpread(default_solo_component_objectSpread({}, contain(logoSrc, logoOptions[screenSize].width, logoOptions[screenSize].height)), {}, {
              hasAlpha: true
            })
          },
          DetailsFlexContainer: {
            visible: isVisibleDetails(servicePicto, csaPicto, extraDetails),
            ServiceIcon: {
              visible: isVisibleIcon(servicePicto),
              type: Icon,
              iconData: {
                picto: servicePicto,
                viewBox: solo_style_getServiceIconViewBox(screenSize)
              }
            },
            Description: {
              visible: Boolean(extraDetails),
              text: {
                text: extraDetails
              }
            },
            BasicIcon: {
              visible: isVisibleIcon(csaPicto),
              type: Icon,
              iconData: {
                picto: csaPicto,
                viewBox: getBasicIconViewBox(screenSize)
              }
            }
          },
          Title: default_solo_component_objectSpread({}, makeTextPatch(title, titleWidth, textColor)),
          ProgressBar: default_solo_component_objectSpread({}, makeProgressBarProperties(progress)),
          CTAFlexContainer: {
            PlayButton: {
              type: CallToAction,
              visible: isVisibleCTA(action),
              label: get_default()(action, 'label', ''),
              picto: get_default()(action, 'picto', '')
            },
            MyListButton: {
              type: CallToAction,
              visible: Boolean(bookmark),
              label: t('bookmarks.actionLabel'),
              item: bookmark,
              blockIndex: blockIndex,
              itemIndex: itemIndex
            },
            InfoButton: {
              visible: Boolean(title) || Boolean(description),
              type: CallToAction
            }
          }
        },
        ProgramInformation: {
          data: this._item
        }
      });
      var items = this.tag('CTAFlexContainer').children;
      this._buttons = items.filter(function (item) {
        return item.visible;
      });
    }
  }, {
    key: "contentPadding",
    set: function set(value) {
      this.tag('FlexContainer').x = Number.isFinite(value) ? value : 0;
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this._setIndex();
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this._focused;
    }
  }, {
    key: "_handleRight",
    value: function _handleRight() {
      if (this._index < this._buttons.length - 1) {
        this._setIndex(this._index + 1);
        return true;
      }
      return false;
    }
  }, {
    key: "_handleLeft",
    value: function _handleLeft() {
      if (this._index > 0) {
        this._setIndex(this._index - 1);
        return true;
      }
      return false;
    }
  }, {
    key: "_setIndex",
    value: function _setIndex() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._index;
      this._index = index;
      this._focused = this._buttons[this._index];
      this._refocus();
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      if (this._focused === this.tag('InfoButton')) {
        this._showProgramInformation();
        sendEvent({
          key: 'pressMoreInfo'
        });
      } else {
        this.signal(SELECTED_SIGNAL, this._item);
      }
    }
  }, {
    key: "_showProgramInformation",
    value: function _showProgramInformation() {
      this.zIndex = Z_INDEX_WITH_PROGRAM_INFO;
      this.tag('ProgramInformation').patch(getProgramInformationFocusedStyle());
      this._focused = this.tag('ProgramInformation');
    }
  }, {
    key: "_handleProgramInformationClose",
    value: function _handleProgramInformationClose() {
      this.zIndex = Z_INDEX_NORMAL;
      this.tag('ProgramInformation').patch(getProgramInformationUnFocusedStyle());
      this._setIndex(this._buttons.indexOf(this.tag('InfoButton')));
      sendEvent({
        key: 'closeMoreInfo'
      });
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Gradient: {
          type: HeroOverlay,
          w: identity,
          h: identity
        },
        FlexContainer: {
          Logo: {},
          DetailsFlexContainer: {
            ServiceIcon: {
              type: Icon
            },
            Description: {},
            BasicIcon: {
              type: Icon
            }
          },
          Title: {},
          ProgressBar: {
            type: Progress,
            visible: false
          },
          CTAFlexContainer: {
            PlayButton: {
              type: CallToAction
            },
            MyListButton: {
              type: MyListButtonPrimary,
              passSignals: (0,defineProperty/* default */.Z)({}, SELECTED_SIGNAL, true)
            },
            InfoButton: {
              type: CallToAction
            }
          }
        },
        ProgramInformation: {
          type: ProgramInformation,
          signals: (0,defineProperty/* default */.Z)({}, PROGRAM_INFORMATION_CLOSED_SIGNAL, '_handleProgramInformationClose')
        }
      }, solo_style_getInitialStyle());
    }
  }]);
  return Solo;
}(src_Lightning.Component);

solo_component_Solo.Templates = solo_solo_constants_templates;
solo_component_Solo.Sizes = solo_constants_sizes;
solo_component_Solo.ImageOptions = solo_constants_imageOptions;
;// CONCATENATED MODULE: ./src/modules/tornado/solo/solo.component.js

/* harmony default export */ const solo_component = (solo_component_Solo);
;// CONCATENATED MODULE: ./src/modules/tornado/jumbotron/customer/rtlde/jumbotron.constants.js

var jumbotron_constants_LOGO_DIMENSIONS;

var rtlde_jumbotron_constants_LOGO_DIMENSIONS = (jumbotron_constants_LOGO_DIMENSIONS = {}, (0,defineProperty/* default */.Z)(jumbotron_constants_LOGO_DIMENSIONS, HD, {
  fit: IMAGE_FIT_MAX,
  width: 299,
  height: 168
}), (0,defineProperty/* default */.Z)(jumbotron_constants_LOGO_DIMENSIONS, FULL_HD, {
  fit: IMAGE_FIT_MAX,
  width: 597,
  height: 336
}), jumbotron_constants_LOGO_DIMENSIONS);
var SHOW_EXTRA_DETAILS = false;
var SHOW_SERVICE_ICON = false;
;// CONCATENATED MODULE: ./src/modules/tornado/jumbotron/jumbotron.constants.js

var _templates$Jumbotron, _templates$Jumbotron2;
function jumbotron_constants_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function jumbotron_constants_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? jumbotron_constants_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : jumbotron_constants_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }




var jumbotron_constants_Z_INDEX_NORMAL = 0;
var jumbotron_constants_Z_INDEX_WITH_PROGRAM_INFO = 1000;
var jumbotron_constants_templates = {
  Jumbotron: 'Jumbotron'
};
var jumbotron_constants_sizes = (0,defineProperty/* default */.Z)({}, jumbotron_constants_templates.Jumbotron, (_templates$Jumbotron = {}, (0,defineProperty/* default */.Z)(_templates$Jumbotron, HD, {
  w: SCREEN_WIDTH[HD],
  h: sizes_SCREEN_HEIGHT[HD]
}), (0,defineProperty/* default */.Z)(_templates$Jumbotron, FULL_HD, {
  w: SCREEN_WIDTH[FULL_HD],
  h: sizes_SCREEN_HEIGHT[FULL_HD]
}), _templates$Jumbotron));
var jumbotron_constants_imageOptions = (0,defineProperty/* default */.Z)({}, jumbotron_constants_templates.Jumbotron, (_templates$Jumbotron2 = {}, (0,defineProperty/* default */.Z)(_templates$Jumbotron2, HD, {
  PRIMARY: {
    width: jumbotron_constants_sizes[jumbotron_constants_templates.Jumbotron][HD].w,
    height: jumbotron_constants_sizes[jumbotron_constants_templates.Jumbotron][HD].h
  },
  SECONDARY: {
    width: SCREEN_WIDTH[HD],
    height: sizes_SCREEN_HEIGHT[HD]
  },
  LOGO: jumbotron_constants_objectSpread({}, rtlde_jumbotron_constants_LOGO_DIMENSIONS[HD])
}), (0,defineProperty/* default */.Z)(_templates$Jumbotron2, FULL_HD, {
  PRIMARY: {
    width: jumbotron_constants_sizes[jumbotron_constants_templates.Jumbotron][FULL_HD].w,
    height: jumbotron_constants_sizes[jumbotron_constants_templates.Jumbotron][FULL_HD].h
  },
  SECONDARY: {
    width: SCREEN_WIDTH[FULL_HD],
    height: sizes_SCREEN_HEIGHT[FULL_HD]
  },
  LOGO: jumbotron_constants_objectSpread({}, rtlde_jumbotron_constants_LOGO_DIMENSIONS[FULL_HD])
}), _templates$Jumbotron2));
;// CONCATENATED MODULE: ./src/modules/tornado/jumbotron/customer/default/jumbotron.style.js

var jumbotron_style_FLEX_CONTAINER_WIDTH, _FLEX_CONTAINER_MARGI, jumbotron_style_LOGO_MARGIN_BOTTOM, _DETAILS_ROW_MARGIN_T, _DETAILS_ROW_MARGIN_B, jumbotron_style_DETAILS_ROW_HEIGHT, _CONTENT_ADVISORY_ICO, _contentAdvisoryIconM, _EXTRA_DETAILS_MARGIN, _PICTO_MARGIN_RIGHT, jumbotron_style_CTA_HEIGHT, _CTA_MARGIN_TOP, jumbotron_style_CTA_BUTTON_MARGIN_RI, jumbotron_style_PROGRESS_BAR_MARGIN_, _DESCRIPTION_MARGIN_T, _EXTRA_TITLE_MARGIN_T, _PICTO_MARGIN_TOP, _BASIC_PICTO_DIMENSIO, _SERVICE_PICTO_DIMENS, _LAYOUT_BOTTOM_MARGIN;
function jumbotron_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function jumbotron_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? jumbotron_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : jumbotron_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }









var jumbotron_style_defaultContext = makeDefaultStylingContext();
var default_jumbotron_style_FLEX_CONTAINER_WIDTH = (jumbotron_style_FLEX_CONTAINER_WIDTH = {}, (0,defineProperty/* default */.Z)(jumbotron_style_FLEX_CONTAINER_WIDTH, HD, Math.round(SCREEN_WIDTH[HD] * 0.5)), (0,defineProperty/* default */.Z)(jumbotron_style_FLEX_CONTAINER_WIDTH, FULL_HD, Math.round(SCREEN_WIDTH[FULL_HD] * 0.45)), jumbotron_style_FLEX_CONTAINER_WIDTH);
var FLEX_CONTAINER_MARGIN_BOTTOM = (_FLEX_CONTAINER_MARGI = {}, (0,defineProperty/* default */.Z)(_FLEX_CONTAINER_MARGI, HD, 104), (0,defineProperty/* default */.Z)(_FLEX_CONTAINER_MARGI, FULL_HD, 168), _FLEX_CONTAINER_MARGI);
var default_jumbotron_style_LOGO_MARGIN_BOTTOM = (jumbotron_style_LOGO_MARGIN_BOTTOM = {}, (0,defineProperty/* default */.Z)(jumbotron_style_LOGO_MARGIN_BOTTOM, HD, 8), (0,defineProperty/* default */.Z)(jumbotron_style_LOGO_MARGIN_BOTTOM, FULL_HD, 16), jumbotron_style_LOGO_MARGIN_BOTTOM);
var DETAILS_ROW_MARGIN_TOP = (_DETAILS_ROW_MARGIN_T = {}, (0,defineProperty/* default */.Z)(_DETAILS_ROW_MARGIN_T, HD, 32), (0,defineProperty/* default */.Z)(_DETAILS_ROW_MARGIN_T, FULL_HD, 32), _DETAILS_ROW_MARGIN_T);
var DETAILS_ROW_MARGIN_BOTTOM = (_DETAILS_ROW_MARGIN_B = {}, (0,defineProperty/* default */.Z)(_DETAILS_ROW_MARGIN_B, HD, 40), (0,defineProperty/* default */.Z)(_DETAILS_ROW_MARGIN_B, FULL_HD, 56), _DETAILS_ROW_MARGIN_B);
var default_jumbotron_style_DETAILS_ROW_HEIGHT = (jumbotron_style_DETAILS_ROW_HEIGHT = {}, (0,defineProperty/* default */.Z)(jumbotron_style_DETAILS_ROW_HEIGHT, HD, 24), (0,defineProperty/* default */.Z)(jumbotron_style_DETAILS_ROW_HEIGHT, FULL_HD, 32), jumbotron_style_DETAILS_ROW_HEIGHT);
var CONTENT_ADVISORY_ICON_DIMENSION = (_CONTENT_ADVISORY_ICO = {}, (0,defineProperty/* default */.Z)(_CONTENT_ADVISORY_ICO, HD, {
  w: 40,
  h: 40
}), (0,defineProperty/* default */.Z)(_CONTENT_ADVISORY_ICO, FULL_HD, {
  w: 48,
  h: 48
}), _CONTENT_ADVISORY_ICO);
var contentAdvisoryIconMargin = (_contentAdvisoryIconM = {}, (0,defineProperty/* default */.Z)(_contentAdvisoryIconM, HD, {
  marginRight: 16
}), (0,defineProperty/* default */.Z)(_contentAdvisoryIconM, FULL_HD, {
  marginRight: 16
}), _contentAdvisoryIconM);
var EXTRA_DETAILS_MARGIN_RIGHT = (_EXTRA_DETAILS_MARGIN = {}, (0,defineProperty/* default */.Z)(_EXTRA_DETAILS_MARGIN, HD, 8), (0,defineProperty/* default */.Z)(_EXTRA_DETAILS_MARGIN, FULL_HD, 8), _EXTRA_DETAILS_MARGIN);
var PICTO_MARGIN_RIGHT = (_PICTO_MARGIN_RIGHT = {}, (0,defineProperty/* default */.Z)(_PICTO_MARGIN_RIGHT, HD, 16), (0,defineProperty/* default */.Z)(_PICTO_MARGIN_RIGHT, FULL_HD, 16), _PICTO_MARGIN_RIGHT);
var default_jumbotron_style_CTA_HEIGHT = (jumbotron_style_CTA_HEIGHT = {}, (0,defineProperty/* default */.Z)(jumbotron_style_CTA_HEIGHT, HD, 56), (0,defineProperty/* default */.Z)(jumbotron_style_CTA_HEIGHT, FULL_HD, 64), jumbotron_style_CTA_HEIGHT);
var jumbotron_style_INFO_ICON = {
  name: 'InfoLight',
  type: 'icon'
};
var TRAILER_ICON = {
  name: 'Trailer',
  type: 'icon'
};
var CTA_MARGIN_TOP = (_CTA_MARGIN_TOP = {}, (0,defineProperty/* default */.Z)(_CTA_MARGIN_TOP, HD, 32), (0,defineProperty/* default */.Z)(_CTA_MARGIN_TOP, FULL_HD, 32), _CTA_MARGIN_TOP);
var jumbotron_style_CTA_BUTTON_MARGIN_RIGHT = (jumbotron_style_CTA_BUTTON_MARGIN_RI = {}, (0,defineProperty/* default */.Z)(jumbotron_style_CTA_BUTTON_MARGIN_RI, HD, 24), (0,defineProperty/* default */.Z)(jumbotron_style_CTA_BUTTON_MARGIN_RI, FULL_HD, 32), jumbotron_style_CTA_BUTTON_MARGIN_RI);
var jumbotron_style_PROGRESS_BAR_MARGIN_TOP = (jumbotron_style_PROGRESS_BAR_MARGIN_ = {}, (0,defineProperty/* default */.Z)(jumbotron_style_PROGRESS_BAR_MARGIN_, HD, 32), (0,defineProperty/* default */.Z)(jumbotron_style_PROGRESS_BAR_MARGIN_, FULL_HD, 40), jumbotron_style_PROGRESS_BAR_MARGIN_);
var DESCRIPTION_MARGIN_TOP = (_DESCRIPTION_MARGIN_T = {}, (0,defineProperty/* default */.Z)(_DESCRIPTION_MARGIN_T, HD, 16), (0,defineProperty/* default */.Z)(_DESCRIPTION_MARGIN_T, FULL_HD, 24), _DESCRIPTION_MARGIN_T);
var jumbotron_style_EXTRA_TITLE_MARGIN_TOP = (_EXTRA_TITLE_MARGIN_T = {}, (0,defineProperty/* default */.Z)(_EXTRA_TITLE_MARGIN_T, HD, 24), (0,defineProperty/* default */.Z)(_EXTRA_TITLE_MARGIN_T, FULL_HD, 24), _EXTRA_TITLE_MARGIN_T);
var PICTO_MARGIN_TOP = (_PICTO_MARGIN_TOP = {}, (0,defineProperty/* default */.Z)(_PICTO_MARGIN_TOP, HD, 8), (0,defineProperty/* default */.Z)(_PICTO_MARGIN_TOP, FULL_HD, 16), _PICTO_MARGIN_TOP);
var BASIC_PICTO_DIMENSION = (_BASIC_PICTO_DIMENSIO = {}, (0,defineProperty/* default */.Z)(_BASIC_PICTO_DIMENSIO, HD, 32), (0,defineProperty/* default */.Z)(_BASIC_PICTO_DIMENSIO, FULL_HD, 40), _BASIC_PICTO_DIMENSIO);
var SERVICE_PICTO_DIMENSIONS = (_SERVICE_PICTO_DIMENS = {}, (0,defineProperty/* default */.Z)(_SERVICE_PICTO_DIMENS, HD, {
  width: 40,
  height: 40
}), (0,defineProperty/* default */.Z)(_SERVICE_PICTO_DIMENS, FULL_HD, {
  width: 56,
  height: 56
}), _SERVICE_PICTO_DIMENS);
var LAYOUT_BOTTOM_MARGIN = (_LAYOUT_BOTTOM_MARGIN = {}, (0,defineProperty/* default */.Z)(_LAYOUT_BOTTOM_MARGIN, HD, -64), (0,defineProperty/* default */.Z)(_LAYOUT_BOTTOM_MARGIN, FULL_HD, -112), _LAYOUT_BOTTOM_MARGIN);
var jumbotron_style_getServiceIconViewBox = memoize_default()(function (screenSize) {
  return {
    h: SERVICE_PICTO_DIMENSIONS[screenSize].height
  };
});
var jumbotron_style_getBasicIconViewBox = memoize_default()(function (screenSize) {
  return {
    h: BASIC_PICTO_DIMENSION[screenSize]
  };
});
var jumbotron_style_colors = {
  text: makeThemeColor(PRIMARY)
};
var jumbotron_style_makeBasicTextStyle = function makeBasicTextStyle(_ref) {
  var font = _ref.font,
    _ref$colorMode = _ref.colorMode,
    colorMode = _ref$colorMode === void 0 ? DEFAULT_MODE : _ref$colorMode;
  return {
    color: jumbotron_style_colors.text[colorMode],
    text: jumbotron_style_objectSpread(jumbotron_style_objectSpread({}, font), {}, {
      verticalAlign: 'middle',
      wordWrap: true,
      maxLines: 2,
      maxLinesSuffix: '...'
    })
  };
};
var jumbotron_style_getContentAdvisoryIconStyle = memoize_default()(function (picto, screenSize) {
  return {
    visible: Boolean(picto),
    flexItem: {
      marginRight: contentAdvisoryIconMargin[screenSize].marginRight
    },
    iconData: {
      picto: picto,
      viewBox: CONTENT_ADVISORY_ICON_DIMENSION[screenSize]
    }
  };
}, cacheResolver);
var jumbotron_style_getInitialStyle = memoize_default()(function () {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : jumbotron_style_defaultContext,
    _ref2$screenSize = _ref2.screenSize,
    screenSize = _ref2$screenSize === void 0 ? FULL_HD : _ref2$screenSize,
    _ref2$colorMode = _ref2.colorMode,
    colorMode = _ref2$colorMode === void 0 ? DEFAULT_MODE : _ref2$colorMode;
  var backgroundSize = jumbotron_constants_imageOptions[jumbotron_constants_templates.Jumbotron][screenSize].PRIMARY;
  var background = {
    w: backgroundSize.width,
    h: backgroundSize.height,
    x: jumbotron_constants_sizes[jumbotron_constants_templates.Jumbotron][screenSize].w,
    mountX: 1
  };
  return {
    Background: jumbotron_style_objectSpread({}, background),
    Gradient: jumbotron_style_objectSpread({}, background),
    FlexContainer: jumbotron_style_objectSpread(jumbotron_style_objectSpread({}, jumbotron_constants_sizes[jumbotron_constants_templates.Jumbotron][screenSize]), {}, {
      h: jumbotron_constants_sizes[jumbotron_constants_templates.Jumbotron][screenSize].h - FLEX_CONTAINER_MARGIN_BOTTOM[screenSize],
      flex: {
        direction: 'column',
        justifyContent: 'flex-end'
      },
      Logo: {
        flexItem: {
          marginBottom: default_jumbotron_style_LOGO_MARGIN_BOTTOM[screenSize]
        }
      },
      Incentive: {},
      Title: jumbotron_style_objectSpread({}, jumbotron_style_makeBasicTextStyle({
        font: src_getFont(constants_FONT.OSLO_3, screenSize),
        colorMode: colorMode
      })),
      ServiceIcon: {
        flexItem: {
          marginTop: PICTO_MARGIN_TOP[screenSize]
        }
      },
      ExtraTitle: {
        text: jumbotron_style_objectSpread(jumbotron_style_objectSpread({}, src_getFont(constants_FONT.PARIS_3, screenSize)), {}, {
          maxLines: 1,
          verticalAlign: 'middle'
        }),
        flexItem: {
          marginTop: jumbotron_style_EXTRA_TITLE_MARGIN_TOP[screenSize]
        }
      },
      Description: jumbotron_style_objectSpread(jumbotron_style_objectSpread({}, jumbotron_style_makeBasicTextStyle({
        font: src_getFont(constants_FONT.OTTAWA_2, screenSize),
        colorMode: colorMode
      })), {}, {
        flexItem: {
          marginTop: DESCRIPTION_MARGIN_TOP[screenSize]
        }
      }),
      ProgressBar: {
        w: default_jumbotron_style_FLEX_CONTAINER_WIDTH[screenSize],
        mountY: 1,
        flexItem: {
          marginTop: jumbotron_style_PROGRESS_BAR_MARGIN_TOP[screenSize]
        }
      },
      CTAFlexContainer: {
        rect: true,
        color: colors_TRANSPARENT,
        h: default_jumbotron_style_CTA_HEIGHT[screenSize],
        w: default_jumbotron_style_FLEX_CONTAINER_WIDTH[screenSize],
        flex: {
          direction: 'row'
        },
        flexItem: {
          marginTop: CTA_MARGIN_TOP[screenSize]
        },
        PlayButton: {
          flexItem: {
            marginRight: jumbotron_style_CTA_BUTTON_MARGIN_RIGHT[screenSize]
          }
        },
        MyListButton: {
          flexItem: {
            marginRight: jumbotron_style_CTA_BUTTON_MARGIN_RIGHT[screenSize]
          }
        },
        InfoButton: {
          picto: jumbotron_style_INFO_ICON,
          flexItem: {
            marginRight: jumbotron_style_CTA_BUTTON_MARGIN_RIGHT[screenSize]
          }
        },
        TrailerButton: {}
      },
      DetailsRow: {
        h: default_jumbotron_style_DETAILS_ROW_HEIGHT[screenSize],
        flex: {
          direction: 'row'
        },
        flexItem: {
          marginTop: DETAILS_ROW_MARGIN_TOP[screenSize]
        },
        ExtraDetails: {
          text: jumbotron_style_objectSpread(jumbotron_style_objectSpread({}, src_getFont(constants_FONT.OTTAWA_2, screenSize)), {}, {
            maxLines: 1,
            verticalAlign: 'middle'
          }),
          flexItem: {
            marginRight: EXTRA_DETAILS_MARGIN_RIGHT[screenSize]
          }
        },
        BasicIcon: {
          flexItem: {
            marginRight: PICTO_MARGIN_RIGHT[screenSize]
          },
          mountY: 0.5,
          y: middle
        },
        IconsRow: {
          h: default_jumbotron_style_DETAILS_ROW_HEIGHT[screenSize],
          w: default_jumbotron_style_FLEX_CONTAINER_WIDTH[screenSize],
          flex: {
            direction: 'row',
            alignItems: 'center'
          }
        }
      }
    })
  };
}, cacheResolver);
;// CONCATENATED MODULE: ./src/modules/tornado/jumbotron/jumbotron.utils.js


var isVisibleInformationButton = function isVisibleInformationButton(_ref) {
  var title = _ref.title,
    description = _ref.description;
  return Boolean(title) || Boolean(description);
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/upFrontToken/upFrontTokenService.js








function upFrontTokenService_createSuper(t) { var r = upFrontTokenService_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function upFrontTokenService_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (upFrontTokenService_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var upFrontTokenService_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,esm_typeof/* default */.Z)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};







var upFrontTokenService_monitoring = withMonitoring_withMonitoring('token');
var UpFrontTokenService = function (_FetcherService) {
  (0,inherits/* default */.Z)(UpFrontTokenService, _FetcherService);
  var _super = upFrontTokenService_createSuper(UpFrontTokenService);
  function UpFrontTokenService() {
    var _this;
    (0,classCallCheck/* default */.Z)(this, UpFrontTokenService);
    _this = _super.apply(this, arguments);
    _this.apiType = 'drm';
    return _this;
  }
  (0,createClass/* default */.Z)(UpFrontTokenService, [{
    key: "init",
    value: function init() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$retry = _ref.retry,
        retry = _ref$retry === void 0 ? 0 : _ref$retry;
      if (!this.isInitialized) {
        this.basePath = "customers/".concat(es_fido/* fido */.n.get('customerCode'), "/platforms/").concat(es_fido/* fido */.n.get('platformCode'));
        this.getCurrentTime = es_fido/* fido */.n.get('getCurrentTime');
        this.isInitialized = true;
        this.retryOptions = buildRetryOptions({
          apiType: this.apiType,
          count: retry
        });
      }
    }
  }, {
    key: "getVideoToken",
    value: function getVideoToken(param) {
      var videoId = param.videoId;
      return this.getToken("/videos/".concat(videoId, "/upfront-token"), param);
    }
  }, {
    key: "getLiveToken",
    value: function getLiveToken(param) {
      var channelCode = param.channelCode;
      return this.getToken("/live/".concat(channelCode, "/upfront-token"), param);
    }
  }, {
    key: "getToken",
    value: function getToken(target, param) {
      var user = param.user,
        service = param.service,
        _param$randomize = param.randomize,
        randomize = _param$randomize === void 0 ? false : _param$randomize,
        _param$headers = param.headers,
        headers = _param$headers === void 0 ? {} : _param$headers;
      var userId = user ? user.UID : this.getHomeOrDeviceId(true);
      var query = randomize ? "?".concat((0,queryParamSerializer/* serialize */.q)({
        random: genGuid()
      })) : '';
      var endpoint = "services/".concat(service, "/users/").concat(userId);
      var url = this.getRouteUrl(endpoint + target + query);
      return this.fetch(url, {
        method: 'GET',
        headers: headers,
        retry: this.retryOptions
      }).then(function (_ref2) {
        var token = _ref2.token;
        return token;
      });
    }
  }]);
  return UpFrontTokenService;
}(fetcherService/* FetcherService */.x);
upFrontTokenService_decorate([withJWT, upFrontTokenService_monitoring], UpFrontTokenService.prototype, "getVideoToken", null);
upFrontTokenService_decorate([withJWT, upFrontTokenService_monitoring], UpFrontTokenService.prototype, "getLiveToken", null);
var upFrontTokenService = new UpFrontTokenService();
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+media-engine@4.13.0/node_modules/@bedrock/media-engine/lib/const/asset.constants.js
var FORMAT_PROGRESSIVE_DOWNLOAD = 'http';
var FORMAT_HLS = 'hls';
var FORMAT_WEBVIEW_HLS = 'wvhls';
var FORMAT_HLS_FAIRPLAY = 'hlsfp';
var FORMAT_DASH_UNPROTECTED = 'dash';
var FORMAT_DASH_CENC = 'dashcenc';
var FORMAT_DASH_CENC_MULTI_PERIODS = 'dashcencmp';
var TYPE_SUBTITLE = 'http_subtitle';
var TYPE_SUBTITLE_SM = 'http_subtitle_vtt_sm';
var CONTAINER_HLS = 'm3u8';
var CONTAINER_PROGRESSIVE_DOWNLOAD = 'mp4';
var DEFAULT_FRAGMENT_DURATION = 6;
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+media-engine@4.13.0/node_modules/@bedrock/media-engine/lib/const/scte.events.js
var EXT_X_CUE = 'EXT-X-CUE';
var EXT_X_CUE_OUT = "".concat(EXT_X_CUE, "-OUT");
var EXT_X_CUE_OUT_CONT = "".concat(EXT_X_CUE_OUT, "-CONT");
var EXT_X_CUE_IN = "".concat(EXT_X_CUE, "-IN");
var REGEX_OATCLS_SCTE35 = /^EXT-(?:X-)?OATCLS-SCTE35$/;
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+media-engine@4.13.0/node_modules/@bedrock/media-engine/lib/const/video.events.js
var ABORT = 'abort';
var CAN_PLAY = 'canplay';
var CAN_PLAY_THROUGH = 'canplaythrough';
var DURATION_CHANGE = 'durationchange';
var EMPTIED = 'emptied';
var ENDED = 'ended';
var ERROR = 'error';
var LOADED_DATA = 'loadeddata';
var LOADED_METADATA = 'loadedmetadata';
var TIMED_METADATA = 'timedmetadata';
var SCTE = 'scte';
var LOAD_START = 'loadstart';
var PAUSE = 'pause';
var video_events_PLAY = 'play';
var PLAYING = 'playing';
var PROGRESS = 'progress';
var RATE_CHANGE = 'ratechange';
var SEEKED = 'seeked';
var SEEKING = 'seeking';
var STALLED = 'stalled';
var SUSPEND = 'suspend';
var TIME_UPDATE = 'timeupdate';
var VOLUME_CHANGE = 'volumechange';
var WAITING = 'waiting';
var ENCRYPTED = 'encrypted';
var RETRY = 'retry';
var RETRY_FAILED = 'retryfailed';
var RETRY_SUCCESS = 'retrysuccess';
var LOADED_DRM_LICENSE_DATA = 'license';
var FALLBACK_QUALITY = 'fallback_quality';
var FALLBACK_SOURCE = 'fallback_source';
var FRAGMENT_RETRY = 'fragment_retry';
var FRAGMENT_CHANGED = 'fragment_changed';
var FRAGMENT_RETRY_SUCCESS = 'fragment_retry_success';
var FRAGMENT_RETRY_FAILED = 'fragment_retry_failed';
var RECOVER_FAULTY_SEGMENT = 'recover_faulty_segment';
var TRACKS_CHANGE = 'tracksChange';
var QUALITY_CHANGE = 'qualityChange';
var PREFERRED_QUALITY_CHANGE = 'preferredQualityChange';
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+media-engine@4.13.0/node_modules/@bedrock/media-engine/lib/const/video.events.throttle.js
var PROGRESS_THROTTLE = 1000;
var SEEKING_THROTTLE = 150;
var TIME_UPDATE_THROTTLE = 500;
var RETRY_RESET_TIME = 10000;
var VOLUME_CHANGE_THROTTLE = 100;
var PLAYER_THROTTLE_OPTIONS = {
  leading: true,
  trailing: false
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+media-engine@4.13.0/node_modules/@bedrock/media-engine/lib/const/lang.constants.js
var lang_constants_ISO693Codes = {
  aar: 'aa',
  abk: 'ab',
  afr: 'af',
  aka: 'ak',
  amh: 'am',
  ara: 'ar',
  arg: 'an',
  asm: 'as',
  ava: 'av',
  ave: 'ae',
  aym: 'ay',
  aze: 'az',
  bak: 'ba',
  bam: 'bm',
  bel: 'be',
  ben: 'bn',
  bis: 'bi',
  bod: 'bo',
  bos: 'bs',
  bre: 'br',
  bul: 'bg',
  cat: 'ca',
  ces: 'cs',
  cha: 'ch',
  che: 'ce',
  chu: 'cu',
  chv: 'cv',
  cor: 'kw',
  cos: 'co',
  cre: 'cr',
  cym: 'cy',
  dan: 'da',
  deu: 'de',
  div: 'dv',
  dzo: 'dz',
  ell: 'el',
  eng: 'en',
  epo: 'eo',
  est: 'et',
  eus: 'eu',
  ewe: 'ee',
  fao: 'fo',
  fas: 'fa',
  fij: 'fj',
  fin: 'fi',
  fra: 'fr',
  fry: 'fy',
  ful: 'ff',
  gla: 'gd',
  gle: 'ga',
  glg: 'gl',
  glv: 'gv',
  grn: 'gn',
  guj: 'gu',
  hat: 'ht',
  hau: 'ha',
  hbs: 'sh',
  heb: 'he',
  her: 'hz',
  hin: 'hi',
  hmo: 'ho',
  hrv: 'hr',
  hun: 'hu',
  hye: 'hy',
  ibo: 'ig',
  ido: 'io',
  iii: 'ii',
  iku: 'iu',
  ile: 'ie',
  ina: 'ia',
  ind: 'id',
  ipk: 'ik',
  isl: 'is',
  ita: 'it',
  jav: 'jv',
  jpn: 'ja',
  kal: 'kl',
  kan: 'kn',
  kas: 'ks',
  kat: 'ka',
  kau: 'kr',
  kaz: 'kk',
  khm: 'km',
  kik: 'ki',
  kin: 'rw',
  kir: 'ky',
  kom: 'kv',
  kon: 'kg',
  kor: 'ko',
  kua: 'kj',
  kur: 'ku',
  lao: 'lo',
  lat: 'la',
  lav: 'lv',
  lim: 'li',
  lin: 'ln',
  lit: 'lt',
  ltz: 'lb',
  lub: 'lu',
  lug: 'lg',
  mah: 'mh',
  mal: 'ml',
  mar: 'mr',
  mkd: 'mk',
  mlg: 'mg',
  mlt: 'mt',
  mon: 'mn',
  mri: 'mi',
  msa: 'ms',
  mya: 'my',
  nau: 'na',
  nav: 'nv',
  nbl: 'nr',
  nde: 'nd',
  ndo: 'ng',
  nep: 'ne',
  nld: 'nl',
  nno: 'nn',
  nob: 'nb',
  nor: 'no',
  nya: 'ny',
  oci: 'oc',
  oji: 'oj',
  ori: 'or',
  orm: 'om',
  oss: 'os',
  pan: 'pa',
  pli: 'pi',
  pol: 'pl',
  por: 'pt',
  pus: 'ps',
  que: 'qu',
  roh: 'rm',
  ron: 'ro',
  run: 'rn',
  rus: 'ru',
  sag: 'sg',
  san: 'sa',
  sin: 'si',
  slk: 'sk',
  slv: 'sl',
  sme: 'se',
  smo: 'sm',
  sna: 'sn',
  snd: 'sd',
  som: 'so',
  sot: 'st',
  spa: 'es',
  sqi: 'sq',
  srd: 'sc',
  srp: 'sr',
  ssw: 'ss',
  sun: 'su',
  swa: 'sw',
  swe: 'sv',
  tah: 'ty',
  tam: 'ta',
  tat: 'tt',
  tel: 'te',
  tgk: 'tg',
  tgl: 'tl',
  tha: 'th',
  tir: 'ti',
  ton: 'to',
  tsn: 'tn',
  tso: 'ts',
  tuk: 'tk',
  tur: 'tr',
  twi: 'tw',
  uig: 'ug',
  ukr: 'uk',
  urd: 'ur',
  uzb: 'uz',
  ven: 've',
  vie: 'vi',
  vol: 'vo',
  wln: 'wa',
  wol: 'wo',
  xho: 'xh',
  yid: 'yi',
  yor: 'yo',
  zha: 'za',
  zho: 'zh',
  zul: 'zu'
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+media-engine@4.13.0/node_modules/@bedrock/media-engine/lib/const/errors/details.js
var UNKNOWN = 'UNKNOWN';
var METHOD_MUST_BE_OVERLOADED = 'METHOD_MUST_BE_OVERLOADED';
var NO_CONTAINER = 'NO_CONTAINER';
var NO_SOURCE = 'NO_SOURCE';
var NO_VIDEO_QUALITIES_SUPPORTED = 'NO_VIDEO_QUALITIES_SUPPORTED';
var EVENT_UNKNOWN = 'EVENT_UNKNOWN';
var NO_PLAYER = 'NO_PLAYER';
var CPC_HTTP_ERROR = 'CPC_HTTP_ERROR';
var CPC_GONE_ERROR = 'CPC_GONE_ERROR';
var LAYOUT_FETCHING_ERROR = 'LAYOUT_FETCHING_ERROR';
var AD_UNKNOWN_ERROR = 'AD_UNKNOWN_ERROR';
var AD_REQUEST_FAILED = 'AD_REQUEST_FAILED';
var AD_TIMED_OUT = 'AD_TIMED_OUT';
var AD_NO_SUPPORTED_MEDIA_FILE = 'AD_NO_SUPPORTED_MEDIA_FILE';
var AD_COULD_NOT_PLAY = 'AD_COULD_NOT_PLAY';
var AD_NO_AD_RESPONSE = 'AD_NO_AD_RESPONSE';
var ENGINE_NETWORK_ERROR = 'ENGINE_NETWORK_ERROR';
var ENGINE_UNKNOWN_ERROR = 'ENGINE_UNKNOWN_ERROR';
var ENGINE_TEXT_ERROR = 'ENGINE_TEXT_ERROR';
var ENGINE_MEDIA_ERROR = 'ENGINE_MEDIA_ERROR';
var ENGINE_MANIFEST_ERROR = 'ENGINE_MANIFEST_ERROR';
var ENGINE_STREAMING_ERROR = 'ENGINE_STREAMING_ERROR';
var ENGINE_DRM_ERROR = 'ENGINE_DRM_ERROR';
var ENGINE_PLAYER_ERROR = 'ENGINE_PLAYER_ERROR';
var ENGINE_STORAGE_ERROR = 'ENGINE_STORAGE_ERROR';
var DASH_CAPABILITY_ERROR = 'DASH_CAPABILITY_ERROR';
var DASH_DOWNLOAD_ERROR = 'DASH_DOWNLOAD_ERROR';
var DASH_MANIFEST_ERROR = 'DASH_MANIFEST_ERROR';
var DASH_MEDIA_SOURCE_ERROR = 'DASH_MEDIA_SOURCE_ERROR';
var DASH_KEY_SESSION_ERROR = 'DASH_KEY_SESSION_ERROR';
var DASH_KEY_MESSAGE_ERROR = 'DASH_KEY_MESSAGE_ERROR';
var DASH_TIMED_TEXT_ERROR = 'DASH_TIMED_TEXT_ERROR';
var DASH_OTHER_ERROR = 'DASH_OTHER_ERROR';
var UPFRONT_TOKEN_ERROR = 'UPFRONT_TOKEN_ERROR';
var CSL_CONCURENT_STREAM_LIMIT = 'CSL_CONCURENT_STREAM_LIMIT';
var CSL_USER_HAS_NO_CSL_ACCESS = 'CSL_USER_HAS_NO_CSL_ACCESS';
var DRM_LICENSE_FETCHING_ERROR = 'DRM_LICENSE_FETCHING_ERROR';
var DRM_CERTIFICATE_FETCHING_ERROR = 'DRM_CERTIFICATE_FETCHING_ERROR';
var DRM_CREATE_MEDIA_KEYS_ERROR = 'DRM_CREATE_MEDIA_KEYS_ERROR';
var DRM_CREATE_KEY_SESSION_ERROR = 'DRM_CREATE_KEY_SESSION_ERROR';
var DRM_KEY_SESSION_ERROR = 'DRM_KEY_SESSION_ERROR';
var DRM_HDCP_ERROR = 'DRM_HDCP_ERROR';
var DRM_CERTIFICATE_ERROR = 'DRM_CERTIFICATE_ERROR';
var AUTOPLAY_PREVENTED_ERROR = 'AUTOPLAY_PREVENTED_ERROR';
var MEDIA_PLAYER_LIBRARY_ERROR = 'MEDIA_PLAYER_LIBRARY_ERROR';
var SDK_ERROR = 'SDK_ERROR';
var NETWORK_ERROR = 'NEWTORK_ERROR';
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+media-engine@4.13.0/node_modules/@bedrock/media-engine/lib/utils/id3/id3Parser.utils.js
































function id3Parser_utils_createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = id3Parser_utils_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function id3Parser_utils_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return id3Parser_utils_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? id3Parser_utils_arrayLikeToArray(r, a) : void 0; } }
function id3Parser_utils_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var ID3SYNC = 0x49443300;
var UNSYNC = 0x80;
var EXTHDR = 0x40;
var SYNCSAFE_INT = 0x7f;
var ID3Parser = function () {
  function ID3Parser() {
    (0,classCallCheck/* default */.Z)(this, ID3Parser);
  }
  (0,createClass/* default */.Z)(ID3Parser, null, [{
    key: "getU32",
    value: function getU32(source, offset) {
      return ID3Parser.getU16(source, offset) << 16 | ID3Parser.getU16(source, offset + 2);
    }
  }, {
    key: "getU16",
    value: function getU16(source, offset) {
      return ID3Parser.getU8(source, offset) << 8 | ID3Parser.getU8(source, offset + 1);
    }
  }, {
    key: "getU8",
    value: function getU8(source, offset) {
      return source[offset];
    }
  }, {
    key: "extractLen",
    value: function extractLen(source, offset) {
      return ((ID3Parser.getU8(source, offset) & SYNCSAFE_INT) << 21) + ((ID3Parser.getU8(source, offset + 1) & SYNCSAFE_INT) << 14) + ((ID3Parser.getU8(source, offset + 2) & SYNCSAFE_INT) << 7) + (ID3Parser.getU8(source, offset + 3) & SYNCSAFE_INT);
    }
  }, {
    key: "parseCommaSeparatedString",
    value: function parseCommaSeparatedString(source) {
      var id3 = {};
      var keys = String(source).split(',');
      var _iterator = id3Parser_utils_createForOfIteratorHelper(keys),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var key = _step.value;
          var packet = key.split('=');
          id3[packet[0]] = packet[1];
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return id3;
    }
  }, {
    key: "parseArray",
    value: function parseArray(source) {
      var ta = new Uint8Array(source);
      return ID3Parser.parseUint8Array(ta);
    }
  }, {
    key: "parseUint8Array",
    value: function parseUint8Array(source) {
      var tag = {};
      var offset = 0;
      var sync = ID3Parser.getU32(source, offset);
      offset += 3;
      if ((sync & 0xffffff00) != ID3SYNC) {
        console.log('[yospace.id3Parser] Source data is not an ID3 tag');
        return null;
      }
      var ver = ID3Parser.getU16(source, offset);
      offset += 2;
      if (ver > 0x0400) {
        console.log('[yospace.id3Parser] ID3 tag version too new - not supported');
        return null;
      }
      var flags = ID3Parser.getU8(source, offset++);
      if (flags & UNSYNC || flags & EXTHDR) {
        return null;
      }
      var len = this.extractLen(source, offset);
      offset += 4;
      while (offset < len) {
        var frameID = String.fromCharCode(ID3Parser.getU8(source, offset++)) + String.fromCharCode(ID3Parser.getU8(source, offset++)) + String.fromCharCode(ID3Parser.getU8(source, offset++)) + String.fromCharCode(ID3Parser.getU8(source, offset++));
        var frameLen = this.extractLen(source, offset);
        offset += 4;
        if (frameLen == 0) {
          break;
        }
        offset += 2;
        var frameValue = void 0;
        if (frameID === 'PRIV') {
          frameValue = {
            owner: '',
            value: ''
          };
        } else {
          frameValue = "";
        }
        var keys = (0,esm_typeof/* default */.Z)(frameValue) === 'object' ? Object.keys(frameValue) : undefined;
        var i = 0;
        for (var j = 0; j < frameLen; j++) {
          var c = ID3Parser.getU8(source, offset++);
          if (c >= 0x20 && c < 0x7f) {
            if (keys) {
              frameValue[keys[i]] += String.fromCharCode(c);
            } else {
              frameValue += String.fromCharCode(c);
            }
          } else {
            i++;
          }
        }
        tag[frameID] = frameValue;
      }
      return tag;
    }
  }]);
  return ID3Parser;
}();
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+media-engine@4.13.0/node_modules/@bedrock/media-engine/lib/utils/id3/index.js

// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.typed-array.from.js
var es_typed_array_from = __webpack_require__(27053);
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/getTime/index.js


/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the timestamp
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */

function getTime(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  return timestamp;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/getUnixTime/index.js


/**
 * @name getUnixTime
 * @category Timestamp Helpers
 * @summary Get the seconds timestamp of the given date.
 *
 * @description
 * Get the seconds timestamp of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the timestamp
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05 CET:
 * const result = getUnixTime(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 1330512305
 */

function getUnixTime(dirtyDate) {
  requiredArgs(1, arguments);
  return Math.floor(getTime(dirtyDate) / 1000);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+media-engine@4.13.0/node_modules/@bedrock/media-engine/lib/utils/drm/certificateCacheService.js































var certificateCacheService_excluded = ["data"],
  _excluded2 = ["data"];
function certificateCacheService_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function certificateCacheService_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? certificateCacheService_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : certificateCacheService_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


var defaultKeyTransform = function defaultKeyTransform(drmKey) {
  return "PLAYER_DRM_CERT/".concat(drmKey);
};
var defaultLogger = {
  debug: (lodash_default()).noop,
  error: (lodash_default()).noop
};
var jsonSerializer = {
  from: function from(json) {
    var _JSON$parse = JSON.parse(json),
      data = _JSON$parse.data,
      rest = objectWithoutProperties_objectWithoutProperties(_JSON$parse, certificateCacheService_excluded);
    return certificateCacheService_objectSpread(certificateCacheService_objectSpread({}, rest), {}, {
      data: Uint8Array.from(atob(data), function (c) {
        return c.charCodeAt(0);
      })
    });
  },
  to: function to(_ref) {
    var data = _ref.data,
      rest = objectWithoutProperties_objectWithoutProperties(_ref, _excluded2);
    return JSON.stringify(certificateCacheService_objectSpread({
      data: btoa(String.fromCharCode.apply(null, data))
    }, rest));
  }
};
var certificateCacheService_defaultOptions = {
  logger: defaultLogger,
  keyTransform: defaultKeyTransform,
  serializer: jsonSerializer,
  drm: {
    serviceCacheDuration: 2000
  }
};
var CertificateCacheService = function () {
  function CertificateCacheService() {
    (0,classCallCheck/* default */.Z)(this, CertificateCacheService);
  }
  (0,createClass/* default */.Z)(CertificateCacheService, [{
    key: "configure",
    value: function configure(options) {
      this.options = lodash_default().merge({}, certificateCacheService_defaultOptions, this.options, options);
    }
  }, {
    key: "has",
    value: function has(drmKey) {
      try {
        return !!window.localStorage.getItem(this.options.keyTransform(drmKey));
      } catch (error) {
        this.options.logger.error('DRM', 'CertificateCacheService@get', error);
        return false;
      }
    }
  }, {
    key: "get",
    value: function get(drmKey) {
      try {
        var certificate = window.localStorage.getItem(this.options.keyTransform(drmKey));
        if (!certificate) {
          return undefined;
        }
        var _this$options$seriali = this.options.serializer.from(certificate),
          createdAt = _this$options$seriali.createdAt,
          data = _this$options$seriali.data;
        var now = getUnixTime(Date.now());
        if (createdAt + this.options.drm.serviceCacheDuration <= now) {
          this.options.logger.debug('DRM', 'CertificateCacheService@get', "Cached ".concat(drmKey, " certificate is expired, invalidating it"));
          window.localStorage.removeItem(this.options.keyTransform(drmKey));
          return undefined;
        }
        return data;
      } catch (error) {
        this.options.logger.error('DRM', 'CertificateCacheService@get', error);
        return undefined;
      }
    }
  }, {
    key: "set",
    value: function set(drmKey, certificate) {
      try {
        window.localStorage.setItem(this.options.keyTransform(drmKey), this.options.serializer.to({
          createdAt: getUnixTime(Date.now()),
          data: certificate
        }));
        this.options.logger.debug('DRM', 'CertificateCacheService@set', "Caching ".concat(drmKey, " certificate for one month"));
      } catch (error) {
        this.options.logger.error('DRM', 'CertificateCacheService@set', error);
      }
    }
  }, {
    key: "remove",
    value: function remove(drmKey) {
      try {
        this.options.logger.debug('DRM', 'CertificateCacheService@onError', "Error with Cached ".concat(drmKey, " certificate, invalidating it"));
        window.localStorage.removeItem(this.options.keyTransform(drmKey));
      } catch (error) {
        this.options.logger.error('DRM', 'CertificateCacheService@onError', error);
      }
    }
  }]);
  return CertificateCacheService;
}();
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+media-engine@4.13.0/node_modules/@bedrock/media-engine/lib/engine/defaultOptions.js



var defaultEngineOptions = {
  contentId: undefined,
  metrics: {
    enabled: false,
    handler: (lodash_default()).noop
  },
  logger: {
    debug: (lodash_default()).noop,
    warn: (lodash_default()).noop,
    info: (lodash_default()).noop,
    error: (lodash_default()).noop
  },
  notifier: (lodash_default()).noop,
  dispatcher: (lodash_default()).noop,
  plugins: {},
  engine: {
    autoplay: true
  },
  storage: {
    get: function get(name) {
      return window.localStorage.getItem(name);
    },
    set: function set(name, value) {
      return window.localStorage.setItem(name, value);
    },
    remove: function remove(name) {
      return window.localStorage.removeItem(name);
    }
  },
  drm: {
    reusePersistentSessions: false,
    reusePersistentSessionsExpiration: 3600 * 24 * 7,
    token: {
      handler: function handler() {
        return Promise.reject(new Error('Not implemented'));
      }
    }
  },
  streaming: {
    needPauseFallback: false,
    delayMediaSourceInit: false,
    segmentPrefetchLimit: undefined,
    abr: {
      downgradeBufferBelow: undefined,
      initialBitrate: 800,
      maxBitrate: undefined,
      bufferTime: 30,
      strategy: 'abrDynamic'
    },
    retry: {
      delay: 500,
      handler: (lodash_default()).noop,
      max: 0
    },
    fragment: {
      fallbackQualityOnError: true,
      retry: {
        max: 3,
        delay: 2000,
        timeout: 15000
      }
    },
    manifest: {
      liveUseSuggestedDelay: true,
      liveDefaultPresentationDelay: 12,
      retry: {
        timeout: 15000,
        max: 3
      },
      dash: {
        keySystemsByURI: {
          'urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95': 'com.microsoft.playready.recommendation',
          'urn:uuid:79f0049a-4098-8642-ab92-e65be0885f95': 'com.microsoft.playready.recommendation'
        }
      },
      crossSiteCredentials: false
    },
    preferredTrack: {
      subtitle: null,
      audio: null
    }
  }
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+media-engine@4.13.0/node_modules/@bedrock/media-engine/lib/mediaEngineConfig.js




var mediaEngineConfig_mediaEngineConfig = new (function () {
  function MediaEngineConfig() {
    (0,classCallCheck/* default */.Z)(this, MediaEngineConfig);
    this._lang = null;
    this._isMocked = false;
    this._isDebug = false;
    this._getTime = function () {
      return getUnixTime(Date.now());
    };
    this.isInitialized = false;
  }
  (0,createClass/* default */.Z)(MediaEngineConfig, [{
    key: "init",
    value: function init() {
      var _this = this;
      var immutableProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!this.isInitialized) {
        forEach_default()(immutableProps, function (value, key) {
          var privateKey = "_".concat(key);
          if (key !== 'isInitialized' && _this[privateKey] !== undefined) {
            _this[privateKey] = value;
          }
        });
        this.isInitialized = true;
      }
    }
  }, {
    key: "get",
    value: function get(key) {
      this.checkInit();
      var privateKey = "_".concat(key);
      return this[privateKey];
    }
  }, {
    key: "set",
    value: function set(key, value) {
      this.checkInit();
      var privateKey = "_".concat(key);
      this[privateKey] = value;
    }
  }, {
    key: "checkInit",
    value: function checkInit() {
      if (!this.isInitialized) {
        throw new Error('You should init MediaEngineConfig before using it');
      }
    }
  }]);
  return MediaEngineConfig;
}())();
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+media-engine@4.13.0/node_modules/@bedrock/media-engine/lib/utils/drm/persistentSessionCacheService.js



































function persistentSessionCacheService_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function persistentSessionCacheService_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? persistentSessionCacheService_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : persistentSessionCacheService_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


var STORAGE_KEY = 'drm/persistent-sessions';
var PersistentSessionCacheService = function () {
  function PersistentSessionCacheService() {
    (0,classCallCheck/* default */.Z)(this, PersistentSessionCacheService);
    this.options = defaultEngineOptions;
  }
  (0,createClass/* default */.Z)(PersistentSessionCacheService, [{
    key: "configure",
    value: function configure(options) {
      this.options = options;
    }
  }, {
    key: "isExpired",
    value: function isExpired(_ref) {
      var createdAt = _ref.createdAt;
      var now = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : mediaEngineConfig_mediaEngineConfig.get('getTime')();
      return createdAt + this.options.drm.reusePersistentSessionsExpiration <= now;
    }
  }, {
    key: "persistStore",
    value: function persistStore() {
      var _this = this;
      try {
        var now = mediaEngineConfig_mediaEngineConfig.get('getTime')();
        this.localStore = Object.keys(this.localStore).reduce(function (accumulator, persistentId) {
          var persistentData = _this.localStore[persistentId];
          if (!_this.isExpired(persistentData, now)) {
            accumulator[persistentId] = persistentData;
          }
          return accumulator;
        }, {});
        this.options.storage.set(STORAGE_KEY, JSON.stringify(this.localStore));
      } catch (error) {
        this.options.logger.error(error);
      }
    }
  }, {
    key: "getStore",
    value: function getStore() {
      try {
        var store = JSON.parse(this.options.storage.get(STORAGE_KEY));
        return store || {};
      } catch (error) {
        this.options.logger.error(error);
      }
      return {};
    }
  }, {
    key: "checkForLocalStore",
    value: function checkForLocalStore() {
      if (!this.localStore) {
        this.localStore = this.getStore();
      }
    }
  }, {
    key: "get",
    value: function get(persistentId) {
      this.checkForLocalStore();
      var persistentData = this.localStore[persistentId];
      if (persistentData && !this.isExpired(persistentData)) {
        return persistentData.sessions.map(function (session) {
          return persistentSessionCacheService_objectSpread(persistentSessionCacheService_objectSpread({}, session), {}, {
            initData: Uint8Array.from(atob(session.initData), function (c) {
              return c.charCodeAt(0);
            }),
            initDataType: 'cenc'
          });
        });
      }
      return [];
    }
  }, {
    key: "set",
    value: function set(persistentId, sessions) {
      this.checkForLocalStore();
      if (!sessions.length) {
        return;
      }
      var incomingPersistentData = {
        sessions: sessions.map(function (_ref2) {
          var sessionId = _ref2.sessionId,
            initData = _ref2.initData;
          return {
            sessionId: sessionId,
            initData: btoa(String.fromCharCode.apply(null, initData))
          };
        }),
        createdAt: mediaEngineConfig_mediaEngineConfig.get('getTime')()
      };
      var storedPersistentData = this.localStore[persistentId];
      var sessionsDifference = [];
      if (storedPersistentData) {
        sessionsDifference = incomingPersistentData.sessions.filter(function (_ref3) {
          var storedSessionId = _ref3.sessionId,
            storedInitData = _ref3.initData;
          return !storedPersistentData.sessions.find(function (_ref4) {
            var sessionId = _ref4.sessionId,
              initData = _ref4.initData;
            return storedSessionId === sessionId && storedInitData === initData;
          });
        });
      }
      if (!storedPersistentData || sessionsDifference.length) {
        this.localStore[persistentId] = incomingPersistentData;
        this.persistStore();
      }
    }
  }, {
    key: "remove",
    value: function remove(persistentId) {
      this.checkForLocalStore();
      if (!this.localStore[persistentId]) {
        return;
      }
      this.localStore[persistentId] = undefined;
      delete this.localStore[persistentId];
      this.persistStore();
    }
  }]);
  return PersistentSessionCacheService;
}();
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+media-engine@4.13.0/node_modules/@bedrock/media-engine/lib/utils/drm/index.js


;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+media-engine@4.13.0/node_modules/@bedrock/media-engine/lib/utils/engine.utils.js
var engine_utils_getCurrentBufferSlice = function getCurrentBufferSlice(videoTag) {
  var _ref = videoTag || {},
    buffered = _ref.buffered,
    currentTime = _ref.currentTime;
  var bufferEnd;
  var bufferStart;
  if (currentTime && buffered) {
    for (var i = 0; i < buffered.length; i++) {
      if (currentTime >= buffered.start(i) && currentTime < buffered.end(i)) {
        bufferEnd = buffered.end(i);
        bufferStart = buffered.start(i);
      }
    }
  }
  var bufferLength = bufferEnd && currentTime ? bufferEnd - currentTime : 0;
  return {
    bufferEnd: bufferEnd,
    bufferStart: bufferStart,
    bufferLength: bufferLength
  };
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+media-engine@4.13.0/node_modules/@bedrock/media-engine/lib/utils/mp4.utils.js





























var mp4BoxNameToBinary = function mp4BoxNameToBinary(name) {
  var part1 = name.charCodeAt(0) << 24;
  var part2 = name.charCodeAt(1) << 16;
  var part3 = name.charCodeAt(2) << 8;
  var part4 = name.charCodeAt(3);
  return part1 + part2 + part3 + part4;
};
var binarytoMp4BoxName = function binarytoMp4BoxName(binary) {
  var data = [binary & 0xff];
  var edit = binary >> 8;
  data.push(edit & 0xff);
  edit >>= 8;
  data.push(edit & 0xff);
  edit >>= 8;
  data.push(edit & 0xff);
  return String.fromCharCode.apply(String, _toConsumableArray(data.reverse()));
};
var getMP4Box = function getMP4Box(data, name) {
  var buffer = data.buffer,
    byteOffset = data.byteOffset,
    byteLength = data.byteLength;
  var dataView = new DataView(buffer, byteOffset, byteLength);
  var nameAsBinary = mp4BoxNameToBinary(name);
  for (var offset = 0; offset < byteLength;) {
    var boxLength = dataView.getUint32(offset);
    var boxName = dataView.getUint32(offset + 4);
    if (boxName === nameAsBinary) {
      return data.subarray(offset + 8, offset + boxLength);
    }
    offset += boxLength;
  }
  return new Uint8Array();
};
var stringToBinaryArray = function stringToBinaryArray(string) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
  var length = string.length;
  var ArrayType = size === 16 ? Uint16Array : Uint8Array;
  var array = new ArrayType(length * (size / 8));
  for (var i = 0; i < length; i++) {
    array[i] = string.charCodeAt(i);
  }
  return array;
};
var binaryToHex = function binaryToHex(data) {
  var hex = '';
  for (var offset = 0; offset < data.length; offset++) {
    var stringValue = data[offset].toString(16);
    if (stringValue.length === 1) {
      stringValue = "0".concat(stringValue);
    }
    hex += stringValue;
  }
  return hex;
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+media-engine@4.13.0/node_modules/@bedrock/media-engine/lib/utils/tracks.utils.js











var tracks_utils_excluded = (/* unused pure expression or super */ null && (["roles", "language"])),
  tracks_utils_excluded2 = (/* unused pure expression or super */ null && (["roles", "language"]));
function tracks_utils_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function tracks_utils_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? tracks_utils_ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : tracks_utils_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



var PREFERRED_AUDIO_TRACK_KEY = 'preferredAudioTrack';
var PREFERRED_SUBTITLE_TRACK_KEY = 'preferredSubtitleTrack';
var isForcedTrack = function isForcedTrack(_ref) {
  var roles = _ref.roles;
  return roles.includes('forced_subtitle') || roles.includes('forced-subtitle');
};
var getObjectFromStorage = function getObjectFromStorage(key) {
  try {
    return JSON.parse(window.localStorage.getItem(key)) || {};
  } catch (_unused) {
    return {};
  }
};
var setObjectFromStorage = function setObjectFromStorage(key, value) {
  try {
    window.localStorage.setItem(key, value);
  } catch (_unused2) {}
};
var getPreferredSubtitleTrack = function getPreferredSubtitleTrack() {
  return getObjectFromStorage(PREFERRED_SUBTITLE_TRACK_KEY);
};
var getPreferredAudioTrack = function getPreferredAudioTrack() {
  return getObjectFromStorage(PREFERRED_AUDIO_TRACK_KEY);
};
var setPreferredSubtitleTrack = function setPreferredSubtitleTrack(value) {
  return setObjectFromStorage(PREFERRED_SUBTITLE_TRACK_KEY, value);
};
var setPreferredAudioTrack = function setPreferredAudioTrack(value) {
  return setObjectFromStorage(PREFERRED_AUDIO_TRACK_KEY, value);
};
var filteredRoles = (/* unused pure expression or super */ null && (['main', 'subtitle']));
var roleFilter = function roleFilter(roles) {
  return roles ? roles.filter(function (role) {
    return !filteredRoles.includes(role);
  }) : roles;
};
var trackEquals = function trackEquals(track1) {
  return function (track2) {
    if (!track1 || !track2) {
      return false;
    }
    var rolesTrack1 = roleFilter(track1.roles);
    var rolesTrack2 = roleFilter(track2.roles);
    return track1.language === track2.language && rolesTrack1.length === rolesTrack2.length && _.difference(rolesTrack1, rolesTrack2).length < 1;
  };
};
var applyLocalPreferenceOnTrack = function applyLocalPreferenceOnTrack(key, tracks) {
  if (!tracks) {
    return tracks;
  }
  var storedTrack = getObjectFromStorage(key);
  var preferredTrack = tracks.find(trackEquals(storedTrack));
  if (preferredTrack && !preferredTrack.active) {
    tracks.forEach(function (track) {
      track.active = false;
    });
    preferredTrack.active = true;
  }
  return tracks;
};
var getTrackLabel = function getTrackLabel(label) {
  var labelLower = label.toLowerCase();
  switch (labelLower) {
    case 'vo':
    case 'ov':
    case 'qtz':
    case 'und':
    case 'qaa':
      return 'ov';
    case 'mis':
    case 'qad':
      return 'ad';
    case 'lv':
    case 'vf':
      return mediaEngineConfig_mediaEngineConfig.get('lang');
    default:
      return labelLower;
  }
};
var sortTracksByLabel = function sortTracksByLabel(tracks) {
  return tracks.sort(function (_ref2, _ref3) {
    var label1 = _ref2.label;
    var label2 = _ref3.label;
    return label1.localeCompare(label2);
  });
};
var filterNull = function filterNull() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return args.filter(function (item) {
    return !!item;
  });
};
var concatTrackRoles = function concatTrackRoles() {
  var roles1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var roles2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return _.uniq([].concat(_toConsumableArray(roles1), _toConsumableArray(roles2)));
};
var formatSubtitles = function formatSubtitles(tracks) {
  return tracks ? tracks.map(function (_ref4) {
    var roles = _ref4.roles,
      language = _ref4.language,
      track = _objectWithoutProperties(_ref4, tracks_utils_excluded);
    return tracks_utils_objectSpread(tracks_utils_objectSpread({}, track), {}, {
      language: language.length === 3 ? ISO693Codes[language] || language : language,
      roles: roles || []
    });
  }) : [];
};
var formatAudioTracks = function formatAudioTracks(tracks) {
  return tracks ? tracks.map(function (_ref5) {
    var roles = _ref5.roles,
      language = _ref5.language,
      track = _objectWithoutProperties(_ref5, tracks_utils_excluded2);
    var isAd = getTrackLabel(language) === 'ad';
    var lang = isAd ? mediaEngineConfig.get('lang') : language;
    return tracks_utils_objectSpread(tracks_utils_objectSpread({}, track), {}, {
      language: lang.length === 3 ? ISO693Codes[lang] || lang : lang,
      roles: concatTrackRoles(roles, filterNull(isAd && 'alternate', track.main && 'main'))
    });
  }) : [];
};
var LANG_ALIAS = {
  nb: 'no',
  nn: 'no'
};
var getAlias = function getAlias(lang) {
  return LANG_ALIAS[lang] || lang;
};
var compareISO693_1AndISO693_3 = function compareISO693_1AndISO693_3(lang693_1, lang693_3) {
  return lang_constants_ISO693Codes[lang693_3] === lang693_1 || lang_constants_ISO693Codes[lang693_3] === getAlias(lang693_1);
};
var compareLanguage = function compareLanguage(givenLanguage, expectedLanguage) {
  if (!givenLanguage || !expectedLanguage) {
    return false;
  }
  switch ("".concat(givenLanguage.length, "/").concat(expectedLanguage.length)) {
    case '3/2':
      return compareISO693_1AndISO693_3(expectedLanguage, givenLanguage);
    case '2/3':
      return compareISO693_1AndISO693_3(givenLanguage, expectedLanguage);
    case '3/3':
      return givenLanguage === expectedLanguage;
    case '2/2':
      return givenLanguage === expectedLanguage || getAlias(givenLanguage) === getAlias(expectedLanguage);
    default:
      return false;
  }
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+media-engine@4.13.0/node_modules/@bedrock/media-engine/lib/const/errors/types.js
var UNKNOWN_ERROR = 'UNKNOWN_ERROR';
var JS_ERROR = 'JS_ERROR';
var IMPLEMENTATION_ERROR = 'IMPLEMENTATION_ERROR';
var BRIDGE_ERROR = 'BRIDGE_ERROR';
var ENGINE_ERROR = 'ENGINE_ERROR';
var CPC_ERROR = 'CPC_ERROR';
var AD_ERROR = 'AD_ERROR';
var DRM_ERROR = 'DRM_ERROR';
var CSL_ERROR = 'CSL_ERROR';
var DRM_DEVICE_REVOKED_ERROR = 'DRM_DEVICE_REVOKED_ERROR';
var HLS_ERROR = 'HLS_ERROR';
var DASH_ERROR = 'DASH_ERROR';
var SMOOTH_ERROR = 'SMOOTH_ERROR';
var LOAD_ERROR = 'LOAD_ERROR';
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+media-engine@4.13.0/node_modules/@bedrock/media-engine/lib/const/errors/PlayerError.js




var PlayerError = (0,createClass/* default */.Z)(function PlayerError() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : UNKNOWN_ERROR;
  var details = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : UNKNOWN;
  var fatal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var context = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var reason = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  var content = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
  var monitored = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : true;
  (0,classCallCheck/* default */.Z)(this, PlayerError);
  this.type = type;
  this.details = details;
  this.fatal = fatal;
  this.context = context;
  this.reason = reason;
  this.content = content;
  this.monitored = monitored;
});

;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+media-engine@4.13.0/node_modules/@bedrock/media-engine/lib/const/errors/MediaEngineInternalErrors.js
var INTERNAL_ERROR_OVERLOAD = 'INTERNAL_ERROR_OVERLOAD';
var INTERNAL_ERROR_NO_CONTAINER = 'INTERNAL_ERROR_NO_CONTAINER';
var INTERNAL_ERROR_UNKNOWN = 'INTERNAL_ERROR_UNKNOWN';
var INTERNAL_ERROR_NO_SOURCE = 'INTERNAL_ERROR_NO_SOURCE';
var INTERNAL_ERROR_GET_PLAYER = 'INTERNAL_ERROR_GET_PLAYER';
var INTERNAL_ERROR_SET_SOURCE = 'INTERNAL_ERROR_SET_SOURCE';
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+media-engine@4.13.0/node_modules/@bedrock/media-engine/lib/engine/BaseEngine.js





var BaseEngine = function () {
  function BaseEngine() {
    var _this = this;
    (0,classCallCheck/* default */.Z)(this, BaseEngine);
    this.name = 'AbstractBaseEngine';
    this.source = null;
    this.paused = true;
    this.seeking = false;
    this.startTime = 0;
    this.retries = 0;
    this.needSeekPosition = null;
    this.dispatchMetrics = lodash_default().throttle(function () {
      var _this$options$metrics = _this.options.metrics,
        enabled = _this$options$metrics.enabled,
        handler = _this$options$metrics.handler;
      if (enabled) {
        handler(_this.getMetrics());
      }
    }, 1000, PLAYER_THROTTLE_OPTIONS);
  }
  (0,createClass/* default */.Z)(BaseEngine, [{
    key: "onSeeked",
    value: function onSeeked(event) {
      this.options.dispatcher(event.type, {
        currentTime: this.getCurrentTime()
      });
    }
  }, {
    key: "clearNeedSeekPosition",
    value: function clearNeedSeekPosition(currentTime) {
      if (currentTime !== undefined && this.needSeekPosition !== null && currentTime > this.needSeekPosition) {
        this.needSeekPosition = null;
      }
    }
  }], [{
    key: "seekDirection",
    value: function seekDirection(position, currentTime) {
      return currentTime < position ? "forward" : "backward";
    }
  }, {
    key: "safeSeekPosition",
    value: function safeSeekPosition(position, _ref) {
      var start = _ref.start,
        end = _ref.end;
      return Math.max(start, Math.min(position, end - 1));
    }
  }, {
    key: "getVersion",
    value: function getVersion() {
      return null;
    }
  }]);
  return BaseEngine;
}();
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+media-engine@4.13.0/node_modules/@bedrock/media-engine/lib/engine/Engine.js












function Engine_createSuper(t) { var r = Engine_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function Engine_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (Engine_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }








var Engine = function (_BaseEngine) {
  (0,inherits/* default */.Z)(Engine, _BaseEngine);
  var _super = Engine_createSuper(Engine);
  function Engine() {
    var _this;
    (0,classCallCheck/* default */.Z)(this, Engine);
    _this = _super.apply(this, arguments);
    _this.name = 'AbstractEngine';
    _this.options = defaultEngineOptions;
    _this.source = null;
    return _this;
  }
  (0,createClass/* default */.Z)(Engine, [{
    key: "configure",
    value: function configure(options) {
      this.options = lodash_default().merge({}, defaultEngineOptions, this.options, options);
    }
  }, {
    key: "dispatchInternalError",
    value: function dispatchInternalError(internalErrorType, reason) {
      var content = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var error;
      switch (internalErrorType) {
        case INTERNAL_ERROR_OVERLOAD:
          error = new PlayerError(IMPLEMENTATION_ERROR, METHOD_MUST_BE_OVERLOADED, true, this.name, reason, content);
          break;
        case INTERNAL_ERROR_GET_PLAYER:
          error = new PlayerError(IMPLEMENTATION_ERROR, NO_PLAYER, true, this.name, reason, content);
          break;
        default:
          error = new PlayerError(ENGINE_ERROR, UNKNOWN, true, this.name, reason, content);
          break;
      }
      this.options.dispatcher(ERROR, error);
    }
  }, {
    key: "setStartTime",
    value: function setStartTime(startTime) {
      this.startTime = startTime;
    }
  }, {
    key: "setSource",
    value: function () {
      var _setSource = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(source) {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.source = source;
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function setSource(_x) {
        return _setSource.apply(this, arguments);
      }
      return setSource;
    }()
  }, {
    key: "retryOnFallbackSource",
    value: function retryOnFallbackSource() {
      if (this.source.fallbackSource) {
        this.source = this.source.fallbackSource;
        this.setSource(this.source);
        return true;
      }
      return false;
    }
  }, {
    key: "retry",
    value: function retry(event) {
      var max = this.options.streaming.retry.max;
      this.retries++;
      if (this.retries <= max) {
        this.options.logger.debug(this.name, 'retry', "Tentative ".concat(this.retries, " / ").concat(max));
        var source = this.source;
        if (source && !source.live) {
          this.setStartTime(this.getCurrentTime() || 0);
        }
        this.options.dispatcher(RETRY, event.target);
        return true;
      }
      this.options.dispatcher(RETRY_FAILED, event.target);
      if (this.retryOnFallbackSource()) {
        this.options.dispatcher(FALLBACK_SOURCE, this.source);
        return true;
      }
      this.options.dispatcher(event.type, event.target);
      return false;
    }
  }, {
    key: "setForcedTextTrack",
    value: function setForcedTextTrack() {
      if (!this.engine) {
        return;
      }
      var activeAudioTrack = this.getActiveAudioTrack();
      var activeTextTrack = this.getActiveSubtitleTrack();
      var textTracks = this.getSubtitleTracks();
      if (activeTextTrack && !activeTextTrack.forced || !activeAudioTrack) {
        return;
      }
      var forcedTextTrack = textTracks.find(function (_ref) {
        var forced = _ref.forced,
          language = _ref.language;
        return forced && language === activeAudioTrack.language;
      });
      if (forcedTextTrack) {
        this.setSubtitleTrack(forcedTextTrack);
      } else {
        this.removeSubtitleTrack();
      }
    }
  }, {
    key: "getDefaultTrack",
    value: function getDefaultTrack(tracks, preferredTrack) {
      if (!preferredTrack || !tracks.length) {
        return null;
      }
      var languageFilteredTracks = tracks.filter(function (_ref2) {
        var language = _ref2.language,
          forced = _ref2.forced;
        return !forced && language === preferredTrack.language;
      });
      return (languageFilteredTracks.find(function (_ref3) {
          var roles = _ref3.roles;
          return lodash_default().isEqual(roles, preferredTrack.roles);
        }) || languageFilteredTracks[0]
      );
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      var instance = this.getInstance();
      if (!instance) {
        return undefined;
      }
      return instance.currentTime;
    }
  }, {
    key: "getSubtitleTracks",
    value: function getSubtitleTracks() {
      return [];
    }
  }, {
    key: "getActiveAudioTrack",
    value: function getActiveAudioTrack() {
      return undefined;
    }
  }, {
    key: "getVideoQualities",
    value: function getVideoQualities() {
      return [];
    }
  }, {
    key: "getDrmInfo",
    value: function getDrmInfo() {
      return {};
    }
  }, {
    key: "reset",
    value: function () {
      var _reset = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2() {
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.source = null;
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function reset() {
        return _reset.apply(this, arguments);
      }
      return reset;
    }()
  }, {
    key: "onTracksChanged",
    value: function onTracksChanged(trackType) {
      var audioTracks = this.getAudioTracks();
      var subtitleTracks = this.getSubtitleTracks();
      this.options.dispatcher(TRACKS_CHANGE, {
        audioTracks: audioTracks,
        subtitleTracks: subtitleTracks,
        trackType: trackType
      });
    }
  }, {
    key: "getFixedCurrentTime",
    value: function getFixedCurrentTime(currentTime) {
      return this.needSeekPosition !== null && currentTime < this.needSeekPosition ? this.needSeekPosition : currentTime;
    }
  }]);
  return Engine;
}(BaseEngine);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+media-engine@4.13.0/node_modules/@bedrock/media-engine/lib/engine/Youbora.js







var YouboraManager = (0,createClass/* default */.Z)(function YouboraManager() {
  var _this = this;
  (0,classCallCheck/* default */.Z)(this, YouboraManager);
  this.instance = null;
  this.preload = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee() {
    var _yield$import, NpawPlugin;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return __webpack_require__.e(/* import() */ 241).then(__webpack_require__.t.bind(__webpack_require__, 98241, 23));
        case 2:
          _yield$import = _context.sent;
          NpawPlugin = _yield$import.default;
          _this.Lib = NpawPlugin;
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  this.init = function (options) {
    try {
      var _this$instance;
      if ((_this$instance = _this.instance) !== null && _this$instance !== void 0 && _this$instance.getAdapter()) {
        _this.callAdapterFunction('fireStop');
        _this.setOptions(options);
      } else {
        var accountCode = options.accountCode;
        if (!accountCode || !_this.Lib) {
          console.warn('Youbora V7 - Init: Missing account code or library not loaded');
          return;
        }
        _this.instance = new _this.Lib(accountCode);
        _this.instance.registerDefaultAdapter(undefined, options);
        _this.instance.getAdapter().fireInit();
        _this.instance.diagnostic.setVideoAnalyticsEnabled(true);
        _this.instance.diagnostic.setBalancerEnabled(false);
        _this.instance.diagnostic.setAdsAnalyticsEnabled(false);
      }
    } catch (error) {
      console.error('Youbora V7 - Init', error);
    }
  };
  this.setOptions = function (options) {
    var _this$instance2;
    (_this$instance2 = _this.instance) === null || _this$instance2 === void 0 ? void 0 : _this$instance2.setAnalyticsOptions(options);
  };
  this.isDefined = function () {
    return !!_this.instance;
  };
  this.release = function () {
    if (_this.isDefined()) {
      var _this$instance3;
      _this.fireStop();
      _this.removeAdapter();
      (_this$instance3 = _this.instance) === null || _this$instance3 === void 0 ? void 0 : _this$instance3.diagnostic.report();
      _this.instance = null;
    }
  };
  this.setAdapter = function (player, Adapter) {
    var _this$instance4;
    (_this$instance4 = _this.instance) === null || _this$instance4 === void 0 ? void 0 : _this$instance4.registerAdapterFromClass(player, Adapter);
  };
  this.setAdsAdapter = function (player, Adapter) {
    var _this$instance5;
    (_this$instance5 = _this.instance) === null || _this$instance5 === void 0 ? void 0 : _this$instance5.registerAdsAdapterFromClass(player, Adapter);
  };
  this.getAdapter = function () {
    var _this$instance6;
    return ((_this$instance6 = _this.instance) === null || _this$instance6 === void 0 ? void 0 : _this$instance6.getAdapter()) || null;
  };
  this.getAdsAdapter = function () {
    var _this$instance7;
    return ((_this$instance7 = _this.instance) === null || _this$instance7 === void 0 ? void 0 : _this$instance7.getAdsAdapter()) || null;
  };
  this.removeAdapter = function () {
    var _this$instance8;
    (_this$instance8 = _this.instance) === null || _this$instance8 === void 0 ? void 0 : _this$instance8.removeAdapter();
  };
  this.removeAdsAdapter = function () {
    var _this$instance9;
    (_this$instance9 = _this.instance) === null || _this$instance9 === void 0 ? void 0 : _this$instance9.removeAdsAdapter();
  };
  this.fireFatalError = function (errorName, message) {
    _this.callAdapterFunction('fireError', errorName, message, undefined, undefined, undefined, true);
  };
  this.fireStop = function () {
    _this.callAdapterFunction('fireStop');
  };
  this.destroy = function () {
    var _this$instance0;
    (_this$instance0 = _this.instance) === null || _this$instance0 === void 0 ? void 0 : _this$instance0.destroy();
  };
  this.callAdsAdapterFunction = function (method) {
    var adapter = _this.getAdsAdapter();
    if (adapter && method in adapter) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      adapter[method].bind(adapter).apply(void 0, args);
    }
  };
  this.callAdapterFunction = function (method) {
    var adapter = _this.getAdapter();
    if (adapter && method in adapter) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      adapter[method].bind(adapter).apply(void 0, args);
    }
  };
});
var youboraManager = new YouboraManager();
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+media-engine@4.13.0/node_modules/@bedrock/media-engine/lib/index.js






















;// CONCATENATED MODULE: ./packages/bedrock-rdk/media-engine/src/utils/dash.utils.js






function dash_utils_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function dash_utils_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? dash_utils_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : dash_utils_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var filterContentProtection = function filterContentProtection(valueToKeep) {
  return function (result) {
    if (!result.querySelectorAll) {
      return dash_utils_objectSpread(dash_utils_objectSpread({}, result), {}, {
        children: (result.children || []).map(function (period) {
          return dash_utils_objectSpread(dash_utils_objectSpread({}, period), {}, {
            children: (period.children || []).map(function (node) {
              return node.tagName === 'AdaptationSet' ? dash_utils_objectSpread(dash_utils_objectSpread({}, node), {}, {
                children: (node.children || []).filter(function (child) {
                  return child.tagName !== 'ContentProtection' || child.attributes && typeof child.attributes.schemeIdUri === 'string' && child.attributes.schemeIdUri.toUpperCase() === valueToKeep;
                })
              }) : node;
            })
          });
        })
      });
    }
    Array.from(result.querySelectorAll('AdaptationSet ContentProtection')).filter(function (child) {
      return (child.getAttribute('schemeIdUri') || '').toUpperCase() !== valueToKeep;
    }).forEach(function (child) {
      child.parentNode.removeChild(child);
    });
    return result;
  };
};
var parseAvailabilityStartTime = function parseAvailabilityStartTime(manifest) {
  if (!manifest) {
    return '';
  }
  return manifest.querySelector('MPD').getAttribute('availabilityStartTime') || '';
};
var removeNonPlayReadyDRM = filterContentProtection('URN:UUID:9A04F079-9840-4286-AB92-E65BE0885F95');
var removeNonWidevineDRM = filterContentProtection('URN:UUID:EDEF8BA9-79D6-4ACE-A3C8-27DCD51D21ED');
;// CONCATENATED MODULE: ./packages/bedrock-rdk/media-engine/src/constants/events.js
var MANIFEST_LOADED = 'manifest_loaded';
var TRACKS_CHANGED = 'tracks_changed';
var AUDIO_TRACK_CHANGED = 'audio_track_changed';
var SUBTITLES_TRACK_CHANGED = 'subtitles_track_changed';
var SUBTITLES_UPDATED = 'subtitles_updated';
var LICENSE_LOADED = 'license';
;// CONCATENATED MODULE: ./packages/bedrock-rdk/media-engine/src/utils.js





function src_utils_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function src_utils_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? src_utils_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : src_utils_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var mediaCapabilitiesConfig = {
  initDataTypes: ['cenc'],
  audioCapabilities: [{
    contentType: 'audio/mp4;codecs="mp4a.40.2"'
  }],
  videoCapabilities: [{
    contentType: 'video/mp4;codecs="avc1.42C01E"'
  }, {
    contentType: 'video/mp4;codecs="avc1.42C01F"'
  }, {
    contentType: 'video/mp4;codecs="avc1.64001F"'
  }, {
    contentType: 'video/mp4;codecs="avc1.640028"'
  }, {
    contentType: 'video/mp4;codecs="avc1.640029"'
  }]
};
var isDecryptAccessSupported = function () {
  var _ref = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(system, robustness) {
    var mediaKeySystemAccess;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return navigator.requestMediaKeySystemAccess(system, [src_utils_objectSpread(src_utils_objectSpread({}, mediaCapabilitiesConfig), {}, {
            audioCapabilities: mediaCapabilitiesConfig.audioCapabilities.map(function (capability) {
              return src_utils_objectSpread(src_utils_objectSpread({}, capability), {}, {
                robustness: robustness.audio
              });
            }),
            videoCapabilities: mediaCapabilitiesConfig.videoCapabilities.map(function (capability) {
              return src_utils_objectSpread(src_utils_objectSpread({}, capability), {}, {
                robustness: robustness.video
              });
            })
          })]);
        case 3:
          mediaKeySystemAccess = _context.sent;
          _context.next = 6;
          return mediaKeySystemAccess.createMediaKeys();
        case 6:
          return _context.abrupt("return", true);
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](0);
          return _context.abrupt("return", false);
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 9]]);
  }));
  return function isDecryptAccessSupported(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var fetchUpfrontToken = function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2(handler) {
    var token;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (handler) {
            _context2.next = 2;
            break;
          }
          throw new Error('No DRM token handler provided');
        case 2:
          _context2.next = 4;
          return handler();
        case 4:
          token = _context2.sent;
          if (!(!token || !token.value)) {
            _context2.next = 7;
            break;
          }
          throw new Error('DRM token endpoint returned no data');
        case 7:
          return _context2.abrupt("return", token);
        case 8:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function fetchUpfrontToken(_x3) {
    return _ref2.apply(this, arguments);
  };
}();
;// CONCATENATED MODULE: ./packages/bedrock-rdk/media-engine/src/constants/errors/types.js
var types_UNKNOWN_ERROR = 'UNKNOWN_ERROR';
var types_IMPLEMENTATION_ERROR = 'IMPLEMENTATION_ERROR';
var types_ENGINE_ERROR = 'ENGINE_ERROR';
var types_BRIDGE_ERROR = 'BRIDGE_ERROR';
;// CONCATENATED MODULE: ./packages/bedrock-rdk/media-engine/src/constants/errors/details.js
var details_UNKNOWN = 'UNKNOWN';
var details_METHOD_MUST_BE_OVERLOADED = 'METHOD_MUST_BE_OVERLOADED';
var details_NO_PLAYER = 'NO_PLAYER';
var details_NO_CONTAINER = 'NO_CONTAINER';
var details_NO_SOURCE = 'NO_SOURCE';
var ENGINE_ABORTED = 'ENGINE_ABORTED_ERROR';
var ENGINE_NETWORK = 'ENGINE_NETWORK_ERROR';
var ENGINE_DECODE = 'ENGINE_DECODE_ERROR';
var ENGINE_SRC_NOT_SUPPORTED = 'ENGINE_SRC_NOT_SUPPORTED_ERROR';
var ENGINE_UNKNOWN = 'ENGINE_UNKNOWN';
var details_AUTOPLAY_PREVENTED_ERROR = 'AUTOPLAY_PREVENTED_ERROR';
var details_DASH_CAPABILITY_ERROR = 'DASH_CAPABILITY_ERROR';
var details_DASH_DOWNLOAD_ERROR = 'DASH_DOWNLOAD_ERROR';
var details_DASH_MANIFEST_ERROR = 'DASH_MANIFEST_ERROR';
var details_DASH_MEDIA_SOURCE_ERROR = 'DASH_MEDIA_SOURCE_ERROR';
var details_DASH_KEY_SESSION_ERROR = 'DASH_KEY_SESSION_ERROR';
var details_DASH_KEY_MESSAGE_ERROR = 'DASH_KEY_MESSAGE_ERROR';
var details_DASH_TIMED_TEXT_ERROR = 'DASH_TIMED_TEXT_ERROR';
var details_DASH_OTHER_ERROR = 'DASH_OTHER_ERROR';
;// CONCATENATED MODULE: ./packages/bedrock-rdk/media-engine/src/utils/mediaEngineErrorHelpers.js


var throwMediaEngineError = function throwMediaEngineError() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : types_UNKNOWN_ERROR;
  var initDetail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : details_UNKNOWN;
  var initFatal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var initMonitored = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  return function (_ref) {
    var context = _ref.context,
      reason = _ref.reason,
      content = _ref.content,
      _ref$fatal = _ref.fatal,
      fatal = _ref$fatal === void 0 ? initFatal : _ref$fatal,
      _ref$monitored = _ref.monitored,
      monitored = _ref$monitored === void 0 ? initMonitored : _ref$monitored,
      _ref$detail = _ref.detail,
      detail = _ref$detail === void 0 ? initDetail : _ref$detail;
    return {
      context: context,
      content: content,
      reason: reason,
      type: type,
      fatal: fatal,
      monitored: monitored,
      detail: detail
    };
  };
};
var throwMethodOverloadError = throwMediaEngineError(types_IMPLEMENTATION_ERROR, details_METHOD_MUST_BE_OVERLOADED);
var throwNoPlayerError = throwMediaEngineError(types_IMPLEMENTATION_ERROR, details_NO_PLAYER);
var throwContainerErrorHelper = throwMediaEngineError(types_BRIDGE_ERROR, details_NO_CONTAINER);
var throwNoSourceErrorHelper = throwMediaEngineError(types_BRIDGE_ERROR, details_NO_SOURCE);
var throwEngineErrorHelper = throwMediaEngineError(types_ENGINE_ERROR, undefined);
var throwUnknownErrorHelper = throwMediaEngineError(types_UNKNOWN_ERROR, details_UNKNOWN);
var throwAutoplayErrorHelper = throwMediaEngineError(types_IMPLEMENTATION_ERROR, details_AUTOPLAY_PREVENTED_ERROR);
;// CONCATENATED MODULE: ./packages/bedrock-rdk/media-engine/src/constants/errors/internal.js
var internal_INTERNAL_ERROR_OVERLOAD = 'INTERNAL_ERROR_OVERLOAD';
var internal_INTERNAL_ERROR_NO_CONTAINER = 'INTERNAL_ERROR_NO_CONTAINER';
var internal_INTERNAL_ERROR_UNKNOWN = 'INTERNAL_ERROR_UNKNOWN';
var internal_INTERNAL_ERROR_NO_SOURCE = 'INTERNAL_ERROR_NO_SOURCE';
var internal_INTERNAL_ERROR_GET_PLAYER = 'INTERNAL_ERROR_GET_PLAYER';
var PLAYER_ERROR = 'PLAYER_ERROR';
;// CONCATENATED MODULE: ./packages/bedrock-rdk/media-engine/src/engines/engine.js












var engine_ERROR = ERROR;
var engineValues = {
  ABSTRACT_ENGINE: 'AbstractEngine',
  GET_ATTAINABLE_LIVE_LATENCY: 'getAttainableLiveLatency',
  GET_BUFFER_PROGRESS: 'getBufferProgress',
  GET_DURATION: 'getDuration',
  GET_INSTANCE: 'getInstance',
  GET_PRESENTATION_START_TIME: 'getPresentationStartTime',
  GET_SEEK_WINDOW: 'getSeekWindow',
  GET_VOLUME: 'getVolume',
  INIT: 'init',
  IS_MUTED: 'isMuted',
  START: 'start',
  PLAY: 'play',
  PAUSE: 'pause',
  RELEASE: 'release',
  SEEK: 'seek',
  SET_VOLUME: 'setVolume',
  SET_MUTED: 'setMuted',
  STORE_AUDIO_TRACK: 'storeAudioTrack',
  STORE_SUBTITLE_TRACK: 'storeSubtitleTrack'
};
var engine_Engine = function () {
  function Engine() {
    (0,classCallCheck/* default */.Z)(this, Engine);
    this.name = engineValues.ABSTRACT_ENGINE;
  }
  (0,createClass/* default */.Z)(Engine, [{
    key: "dispatchInternalError",
    value: function dispatchInternalError(internalErrorType, reason) {
      var content = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var error = '';
      switch (internalErrorType) {
        case internal_INTERNAL_ERROR_OVERLOAD:
          error = throwMethodOverloadError({
            context: this.name,
            reason: reason,
            content: content
          });
          break;
        case internal_INTERNAL_ERROR_GET_PLAYER:
          error = throwNoPlayerError({
            context: this.name,
            reason: reason,
            content: content,
            detail: details_NO_PLAYER
          });
          break;
        default:
          error = throwEngineErrorHelper({
            context: this.name,
            reason: reason,
            content: content
          });
          break;
      }
      console.error("[".concat(this.name, "][").concat(internalErrorType, "]: ").concat(reason, " ").concat(content));
      get_default()(this, 'options.dispatcher', (noop_default()))(engine_ERROR, {
        error: error
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      return Promise.resolve();
    }
  }, {
    key: "release",
    value: function release() {
      return this.reset();
    }
  }, {
    key: "getInstance",
    value: function getInstance() {
      this.dispatchInternalError(internal_INTERNAL_ERROR_OVERLOAD, engineValues.GET_INSTANCE);
    }
  }, {
    key: "init",
    value: function init() {
      this.dispatchInternalError(internal_INTERNAL_ERROR_OVERLOAD, engineValues.INIT);
    }
  }, {
    key: "setVolume",
    value: function setVolume(volume) {
      this.dispatchInternalError(internal_INTERNAL_ERROR_OVERLOAD, engineValues.SET_VOLUME, volume);
    }
  }, {
    key: "isMuted",
    value: function isMuted() {
      this.dispatchInternalError(internal_INTERNAL_ERROR_OVERLOAD, engineValues.IS_MUTED);
    }
  }, {
    key: "setMuted",
    value: function setMuted(muted) {
      this.dispatchInternalError(internal_INTERNAL_ERROR_OVERLOAD, engineValues.SET_MUTED, muted);
    }
  }, {
    key: "getVolume",
    value: function getVolume() {
      this.dispatchInternalError(internal_INTERNAL_ERROR_OVERLOAD, engineValues.GET_VOLUME);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      this.dispatchInternalError(internal_INTERNAL_ERROR_OVERLOAD, engineValues.GET_DURATION);
    }
  }, {
    key: "getBufferProgress",
    value: function getBufferProgress() {
      this.dispatchInternalError(internal_INTERNAL_ERROR_OVERLOAD, engineValues.GET_BUFFER_PROGRESS);
    }
  }, {
    key: "getAttainableLiveLatency",
    value: function getAttainableLiveLatency() {
      this.dispatchInternalError(internal_INTERNAL_ERROR_OVERLOAD, engineValues.GET_ATTAINABLE_LIVE_LATENCY);
    }
  }, {
    key: "getSeekWindow",
    value: function getSeekWindow() {
      this.dispatchInternalError(internal_INTERNAL_ERROR_OVERLOAD, engineValues.GET_SEEK_WINDOW);
    }
  }, {
    key: "getPresentationStartTime",
    value: function getPresentationStartTime() {
      this.dispatchInternalError(internal_INTERNAL_ERROR_OVERLOAD, engineValues.GET_PRESENTATION_START_TIME);
    }
  }, {
    key: "seek",
    value: function seek(position) {
      this.dispatchInternalError(internal_INTERNAL_ERROR_OVERLOAD, engineValues.SEEK, position);
    }
  }, {
    key: "play",
    value: function play() {
      this.dispatchInternalError(internal_INTERNAL_ERROR_OVERLOAD, engineValues.PLAY);
    }
  }, {
    key: "pause",
    value: function pause() {
      this.dispatchInternalError(internal_INTERNAL_ERROR_OVERLOAD, engineValues.PAUSE);
    }
  }, {
    key: "start",
    value: function start() {
      this.dispatchInternalError(internal_INTERNAL_ERROR_OVERLOAD, engineValues.START);
    }
  }, {
    key: "setSource",
    value: function setSource(source) {
      this.start(source);
    }
  }]);
  return Engine;
}();
/* harmony default export */ const engine = (engine_Engine);
// EXTERNAL MODULE: ./packages/bedrock-rdk/media-engine/src/engines/oipf/oipf.constants.js
var oipf_constants = __webpack_require__(98026);
;// CONCATENATED MODULE: ./packages/bedrock-rdk/media-engine/src/engines/oipf/oipf.utils.js




var performTracksList = function performTracksList(player, component) {
  var availableTracks = player.getComponents(component);
  if (availableTracks.length) {
    var activeRawComponent = player.getCurrentActiveComponents(component);
    var activeTrackPid = activeRawComponent.length ? activeRawComponent[0].pid : null;
    var result = [];
    for (var i = 0; i < availableTracks.length; i += 1) {
      var track = availableTracks[i];
      var roles = ['main'];
      var language = track.language;
      if (component === player.COMPONENT_TYPE_SUBTITLE) {
        roles = ['subtitle'];
        language = language.split(':')[0];
      }
      if (language && language.length) {
        language = language.toLowerCase().substring(0, 2);
      }
      result.push({
        active: track.pid === activeTrackPid,
        language: language,
        roles: roles,
        id: track.pid,
        raw: track
      });
    }
    return result.sort(function (a, b) {
      return a.id < b.id;
    });
  }
  return [];
};
var makeSourceURL = function makeSourceURL(reference, token, drmSettings) {
  var drmServerURL = drmSettings['com.microsoft.playready'].serverURL;
  var customData = btoa(JSON.stringify({
    userId: token.uid,
    sessionId: drmSettings.sessionId,
    merchant: drmSettings.merchantId,
    authToken: token.value
  }));
  return "".concat(reference, "&custom_data=").concat(customData, "&la_url=").concat(drmServerURL);
};
;// CONCATENATED MODULE: ./packages/bedrock-rdk/media-engine/src/engines/oipf/oipf.engine.js























function oipf_engine_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function oipf_engine_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? oipf_engine_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : oipf_engine_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function oipf_engine_createSuper(t) { var r = oipf_engine_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function oipf_engine_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (oipf_engine_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }











var oipf_engine_TIME_UPDATE_THROTTLE = TIME_UPDATE_THROTTLE;
var OipfEngine = function (_Engine) {
  (0,inherits/* default */.Z)(OipfEngine, _Engine);
  var _super = oipf_engine_createSuper(OipfEngine);
  function OipfEngine() {
    var _this;
    (0,classCallCheck/* default */.Z)(this, OipfEngine);
    _this = _super.call(this);
    _this.name = 'OipfEngine';
    return _this;
  }
  (0,createClass/* default */.Z)(OipfEngine, [{
    key: "init",
    value: function init(options) {
      this.options = options;
      this._player = get_default()(options, 'element');
      try {
        this._player.setFullScreen(true);
        this._nativeConfigObject = window.oipfObjectFactory.createConfigurationObject();
      } catch (error) {
        this.dispatchInternalError(internal_INTERNAL_ERROR_GET_PLAYER, 'OIPF implementation unsupported.', error);
        this.reset();
        return;
      }
      this._seekFrom = -1;
      this._seekTo = 0;
      this.setEventListeners();
    }
  }, {
    key: "start",
    value: function () {
      var _start = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(source) {
        var token, _yield$Promise$all, _yield$Promise$all2;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this._player) {
                _context.next = 3;
                break;
              }
              console.error('[OipfEngine]: Player is not created or already destroyed.');
              return _context.abrupt("return");
            case 3:
              this._startTime = source.startTime || 0;
              this._availabilityStartTimeInSeconds = 0;
              this._isLive = Boolean(source.isLive);
              token = null;
              _context.prev = 7;
              _context.next = 10;
              return Promise.all([fetchUpfrontToken(get_default()(this.options, 'drm.token.handler')), this._extractManifestData(source.reference)]);
            case 10:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = (0,slicedToArray/* default */.Z)(_yield$Promise$all, 1);
              token = _yield$Promise$all2[0];
              _context.next = 20;
              break;
            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](7);
              this.dispatchInternalError(internal_INTERNAL_ERROR_NO_SOURCE, 'OIPFEngine failed to fetch DRM upfront token.', _context.t0);
              this.reset();
              return _context.abrupt("return");
            case 20:
              this._player.data = makeSourceURL(source.reference, token, get_default()(this.options, 'drm.settings'));
              this.options.dispatcher(LOAD_START);
              this.play();
            case 23:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[7, 15]]);
      }));
      function start(_x) {
        return _start.apply(this, arguments);
      }
      return start;
    }()
  }, {
    key: "setEventListeners",
    value: function setEventListeners() {
      var _this2 = this;
      this._player.onPlayStateChange = function () {
        return _this2._onPlayStateChange();
      };
      this._player.onDRMRightsError = function () {
        return _this2._onDRMRightsError();
      };
      this._player.onReadyToPlay = function () {
        return _this2._onReadyToPlay();
      };
      this._player.onPlayPositionChanged = function () {
        return _this2._onPlayPositionChanged();
      };
    }
  }, {
    key: "resetEventListeners",
    value: function resetEventListeners() {
      if (this._player) {
        this._player.onPlayStateChange = null;
        this._player.onDRMRightsError = null;
        this._player.onReadyToPlay = null;
        this._player.onPlayPositionChanged = null;
      }
    }
  }, {
    key: "_extractManifestData",
    value: function () {
      var _extractManifestData2 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2(reference) {
        var manifest, result, availabilityStartTime, adaptationSets, representations;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return requestGet(reference).responseType('document');
            case 3:
              result = _context2.sent;
              manifest = result.body;
              _context2.next = 11;
              break;
            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              console.error('[OipfEngine] Failed to fetch current DASH manifest');
              return _context2.abrupt("return");
            case 11:
              if (this._isLive) {
                try {
                  availabilityStartTime = parseAvailabilityStartTime(manifest);
                  this._availabilityStartTimeInSeconds = toSeconds(new Date(availabilityStartTime).getTime());
                } catch (error) {
                  console.error('[OipfEngine] Failed to parse availability start time');
                }
              }
              try {
                adaptationSets = manifest.querySelectorAll('AdaptationSet[contentType="text"]');
                this._subtitlesRoles = Array.from(adaptationSets).map(function (track) {
                  return Array.from(track.querySelectorAll('Role')).map(function (node) {
                    return node.getAttribute('value');
                  });
                });
              } catch (error) {
                console.error("[OipfEngine] Failed to read subtitles from manifest: ".concat(error));
              }
              try {
                representations = Array.from(this._isLive ? manifest.querySelectorAll('AdaptationSet[mimeType="video/mp4"] Representation') : manifest.querySelectorAll('AdaptationSet[contentType="video"] Representation')).map(function (track) {
                  return {
                    id: track.getAttribute('id'),
                    bandwidth: parseInt(track.getAttribute('bandwidth'), 10),
                    width: parseInt(track.getAttribute('width'), 10),
                    height: parseInt(track.getAttribute('height'), 10)
                  };
                });
                this._player.representations = representations;
              } catch (error) {
                console.error("[OipfEngine] Failed to read video tracks from manifest: ".concat(error));
              }
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 7]]);
      }));
      function _extractManifestData(_x2) {
        return _extractManifestData2.apply(this, arguments);
      }
      return _extractManifestData;
    }()
  }, {
    key: "setAudioTrackById",
    value: function setAudioTrackById(trackId) {
      this._activeAudioTrack = this._changeTrack(this._audioTracks, trackId, this._activeAudioTrack, AUDIO_TRACK_CHANGED);
    }
  }, {
    key: "setSubtitlesTrackById",
    value: function setSubtitlesTrackById(trackId) {
      if (this._activeSubtitlesTrack) {
        this._activeSubtitlesTrack.active = false;
        this._player.unselectComponent(this._activeSubtitlesTrack.raw);
      }
      var track = this._subtitlesTracks.find(function (track) {
        return track.id === trackId;
      });
      if (track) {
        console.log("[OipfEngine] Setting subtitles track by ID: ".concat(trackId, ", ").concat(track.language));
        this._activeSubtitlesTrack = this._changeTrack(this._subtitlesTracks, trackId, this._activeSubtitlesTrack, SUBTITLES_TRACK_CHANGED);
      }
    }
  }, {
    key: "backToLive",
    value: function backToLive() {
      if (!this._player) {
        return;
      }
      var _this$getSeekRange = this.getSeekRange(),
        end = _this$getSeekRange.end;
      if (Number.isFinite(end)) {
        this.seek(end / 1000 + this._availabilityStartTimeInSeconds);
      }
    }
  }, {
    key: "seek",
    value: function seek(position) {
      if (!this._player) {
        return false;
      }
      this._seekFrom = this._getCurrentProgress() + this._availabilityStartTimeInSeconds;
      this._seekTo = position - this._availabilityStartTimeInSeconds - this._getStartDate() / 1000;
      var playTime = toSeconds(get_default()(this._player, 'playTime', 0));
      if (this._seekTo && playTime && this._seekTo >= playTime) {
        this._seekTo -= 2;
      }
      if (this._seekTo !== this._seekFrom) {
        this.options.dispatcher(SEEKING, {
          from: this._seekFrom,
          to: this._seekTo
        });
        return this._player.seek(this._seekTo * 1000);
      }
      return false;
    }
  }, {
    key: "play",
    value: function play() {
      var _this3 = this;
      try {
        this._player.play(1);
        if (this._playbackStarted) {
          return;
        }
        this._onTimeUpdateInterval = setInterval(function () {
          return _this3._onProgressUpdate();
        }, oipf_engine_TIME_UPDATE_THROTTLE);
        this._player.seek(this._isLive ? Date.now() : this._startTime * 1000);
        this._playbackStarted = true;
      } catch (error) {
        console.error('[OipfEngine]: Player is not created or already destroyed.');
      }
    }
  }, {
    key: "pause",
    value: function pause() {
      try {
        this._player.play(0);
      } catch (error) {
        console.error('[OipfEngine]: Player is not created or already destroyed.');
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      clearInterval(this._onTimeUpdateInterval);
      this.resetEventListeners();
      this._onTimeUpdateInterval = null;
      this.options = null;
      if (this._player) {
        try {
          this._player.stop();
        } catch (error) {
          console.error('[OipfEngine]: OIPF implementation in not supported.');
        }
      }
      this._player = null;
      this._subtitlesRoles = null;
      this._playbackInitialized = false;
      this._playbackStarted = false;
      this._tracksDetected = false;
      this._activeAudioTrack = null;
      this._activeSubtitlesTrack = null;
      this._audioTracks = null;
      this._subtitlesTracks = null;
      this._nativeConfigObject = null;
      this._previousPosition = 0;
      this._seekFrom = -1;
    }
  }, {
    key: "player",
    get: function get() {
      return this._player;
    }
  }, {
    key: "getSeekRange",
    value: function getSeekRange() {
      var start = 0;
      var end = 0;
      var playPosition = this._getPlayPosition() + this._getStartDate();
      if (this._player.getAvailablePlayTime) {
        end = playPosition + this._player.getAvailablePlayTime(true);
        start = end >= this._player.getAvailablePlayTime(false) ? end - this._player.getAvailablePlayTime(false) : 0;
      } else {
        var duration = this._player.playTime;
        if (Number.isFinite(duration) && playPosition < duration) {
          start = 0;
          end = duration;
        } else {
          console.error('[OipfEngine]: Seek range is not available. Can not obtain playTime.');
        }
      }
      return {
        start: Number.isFinite(start) ? start : 0,
        end: Number.isFinite(end) ? end : 0
      };
    }
  }, {
    key: "_getPlayPosition",
    value: function _getPlayPosition() {
      return get_default()(this._player, 'playPosition', 0);
    }
  }, {
    key: "_getCurrentProgress",
    value: function _getCurrentProgress() {
      return (this._getPlayPosition() + this._getStartDate()) / 1000;
    }
  }, {
    key: "_getStartDate",
    value: function _getStartDate() {
      return this._isLive ? get_default()(this._player, 'startDate', 0) : 0;
    }
  }, {
    key: "_onPlayStateChange",
    value: function _onPlayStateChange() {
      switch (this._player.playState) {
        case oipf_constants.playerStates.BUFFERING:
          this._onBuffering();
          break;
        case oipf_constants.playerStates.PLAYING:
          this._onPlay();
          break;
        case oipf_constants.playerStates.PAUSED:
          this._onPause();
          break;
        case oipf_constants.playerStates.FINISHED:
          this._onPause();
          this._onEnded();
          break;
        case oipf_constants.playerStates.ERROR:
          this.dispatchInternalError(PLAYER_ERROR, oipf_constants.playerErrorStates[this._player.error].message, {
            code: oipf_constants.playerErrorStates[this._player.error].code
          });
          this.reset();
          break;
        case oipf_constants.playerStates.CONNECTING:
        case oipf_constants.playerStates.STOPPED:
        default:
          console.log("[OipfEngine] Playback state: ".concat(this._player.playState));
          break;
      }
    }
  }, {
    key: "_onDRMRightsError",
    value: function _onDRMRightsError(errorState) {
      this.dispatchInternalError(PLAYER_ERROR, oipf_constants.drmErrorStates[errorState].message, {
        code: oipf_constants.drmErrorStates[errorState].code
      });
      this.reset();
    }
  }, {
    key: "_onReadyToPlay",
    value: function _onReadyToPlay() {
      if (!this._playbackInitialized) {
        this.options.dispatcher(CAN_PLAY);
        this._playbackInitialized = true;
      }
    }
  }, {
    key: "_onPlayPositionChanged",
    value: function _onPlayPositionChanged() {
      if (this._seekFrom >= 0) {
        this.options.dispatcher(SEEKED, {
          from: this._seekFrom,
          to: Math.round(this._getCurrentProgress())
        });
        this._seekFrom = -1;
      }
    }
  }, {
    key: "_onPlay",
    value: function _onPlay() {
      var _this4 = this;
      if (!this._tracksDetected) {
        try {
          this._audioTracks = performTracksList(this._player, this._player.COMPONENT_TYPE_AUDIO);
          this._subtitlesTracks = performTracksList(this._player, this._player.COMPONENT_TYPE_SUBTITLE).map(function (track, index) {
            if (_this4._subtitlesRoles) {
              if (_this4._subtitlesRoles[index]) {
                var roles = _this4._subtitlesRoles[index].join(', ');
                console.log("[OipfEngine] Track ".concat(track.id, ", ").concat(track.language, " roles: ").concat(roles, " at index ").concat(index));
              } else {
                console.log("[OipfEngine] There are no matching roles for track ".concat(track.id, ", ").concat(track.language, " at index ").concat(index));
              }
            } else {
              console.log('[OipfEngine] There are no roles for subtitles at all');
            }
            return oipf_engine_objectSpread(oipf_engine_objectSpread({}, track), {}, {
              roles: _this4._subtitlesRoles && _this4._subtitlesRoles[index] || track.roles
            });
          });
          try {
            var activeSubtitles = this._player.getCurrentActiveComponents(this._player.COMPONENT_TYPE_SUBTITLE);
            for (var i = 0; i < activeSubtitles.length; i += 1) {
              console.log("[OipfEngine] Unselecting default subtitles track ".concat(activeSubtitles[i].pid));
              this._player.unselectComponent(activeSubtitles[i]);
            }
          } catch (error) {
            console.error("[OipfEngine] Can not unselect default subtitles: ".concat(error ? error.message : 'unknown error'));
          }
          if (this._audioTracks || this._subtitlesTracks) {
            this._audioTracks = this._audioTracks || [];
            this._subtitlesTracks = this._subtitlesTracks || [];
            this._tracksDetected = this._audioTracks.length || this._subtitlesTracks.length;
            this.options.dispatcher(TRACKS_CHANGED, {
              audioTracks: this._audioTracks,
              subtitleTracks: this._subtitlesTracks
            });
          }
        } catch (error) {
          console.error("[OipfEngine]: _onPlay : ".concat(error.toString()));
        }
      }
      if (this._playbackStarted) {
        this.options.dispatcher(video_events_PLAY);
        this.options.dispatcher(PLAYING);
      }
    }
  }, {
    key: "_onPause",
    value: function _onPause() {
      this.options.dispatcher(PAUSE);
    }
  }, {
    key: "_onBuffering",
    value: function _onBuffering() {
      this.options.dispatcher(WAITING, {
        isBuffering: true
      });
    }
  }, {
    key: "_onEnded",
    value: function _onEnded() {
      this.options.dispatcher(ENDED);
    }
  }, {
    key: "_onProgressUpdate",
    value: function _onProgressUpdate() {
      var currentTime = this._getCurrentProgress() + this._availabilityStartTimeInSeconds;
      if (currentTime !== this._previousPosition) {
        this.options.dispatcher(TIME_UPDATE, {
          currentTime: currentTime,
          liveEdge: this._isLive ? this.getSeekRange().end / 1000 + this._availabilityStartTimeInSeconds : 0
        });
        this._previousPosition = currentTime;
      }
    }
  }, {
    key: "_changeTrack",
    value: function _changeTrack(tracks, trackId, previousTrack, eventId) {
      var currentTrack = (tracks || []).find(function (track) {
        return track.id === trackId;
      });
      if (currentTrack) {
        currentTrack.active = true;
        if (previousTrack) {
          previousTrack.active = false;
        }
        this.options.dispatcher(eventId, {
          previousTrack: previousTrack,
          currentTrack: currentTrack
        });
        console.log("[OipfEngine] Dispatching ".concat(eventId, " with a track ").concat(currentTrack.id, ", ").concat(currentTrack.language));
        this._player.selectComponent(currentTrack.raw);
        return currentTrack;
      }
      return previousTrack;
    }
  }]);
  return OipfEngine;
}(engine);
;// CONCATENATED MODULE: ./packages/bedrock-rdk/media-engine/src/engines/html5/html5.engine.js
















function html5_engine_createSuper(t) { var r = html5_engine_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function html5_engine_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (html5_engine_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }




var HTML5Engine = function (_Engine) {
  (0,inherits/* default */.Z)(HTML5Engine, _Engine);
  var _super = html5_engine_createSuper(HTML5Engine);
  function HTML5Engine() {
    (0,classCallCheck/* default */.Z)(this, HTML5Engine);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(HTML5Engine, [{
    key: "configure",
    value: function configure(options) {
      this.options = options;
    }
  }, {
    key: "init",
    value: function init(element) {
      this.videoElement = element;
    }
  }, {
    key: "setSource",
    value: function setSource(source) {
      this.start(source);
    }
  }, {
    key: "start",
    value: function start(source) {
      this._playbackAvailable = false;
      this._isFirstTickFired = false;
      this._isTimeFixed = false;
      this._seekStarted = false;
      this.source = source;
      if (!source) {
        this.pause();
        return;
      }
      this.startTime = this.source.startTime || 0;
      var timeParameter = this.startTime ? "#t=".concat(this.startTime) : '';
      if (this.videoElement) {
        if (typeof this.source === 'string') {
          this.videoElement.src = "".concat(this.source).concat(timeParameter);
        } else {
          this.videoElement.src = "".concat(this.source.reference || this.source.src).concat(timeParameter);
        }
      }
    }
  }, {
    key: "play",
    value: function () {
      var _play = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee() {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              console.log('[HTML5Engine] Playback requested');
              try {
                this.videoElement.play();
              } catch (error) {
                if (this.options) {
                  this.options.dispatcher(ERROR, {
                    error: throwAutoplayErrorHelper({
                      type: details_AUTOPLAY_PREVENTED_ERROR,
                      details: "The user hasn't interacted with the domain",
                      fatal: true,
                      context: this.name
                    })
                  });
                }
              }
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function play() {
        return _play.apply(this, arguments);
      }
      return play;
    }()
  }, {
    key: "pause",
    value: function pause() {
      if (!this.videoElement) {
        return;
      }
      try {
        this.videoElement.pause();
        console.log('[HTML5Engine] Paused');
      } catch (error) {}
    }
  }, {
    key: "seek",
    value: function seek(time) {
      if (!this.videoElement) {
        return;
      }
      var fastSeekSupported = Boolean(this.videoElement.fastSeek);
      console.log("[HTML5Engine] Seek requested to ".concat(time, " with seek mode ").concat(fastSeekSupported));
      this._seekStarted = true;
      if (fastSeekSupported) {
        this.videoElement.fastSeek(time);
      } else {
        this.videoElement.currentTime = time;
      }
    }
  }, {
    key: "setEventListeners",
    value: function setEventListeners() {
      var _this = this;
      this.removeEventListeners();
      if (!this.videoElement) {
        return;
      }
      this._handlers = {
        video: {
          canplay: this.onVideoElementCanPlay.bind(this),
          canplaythrough: this.onVideoElementCanPlayThrough.bind(this),
          play: this.onVideoElementPlay.bind(this),
          pause: this.onVideoElementPause.bind(this),
          ended: this.onVideoElementEnded.bind(this),
          error: this.onVideoElementError.bind(this),
          seeked: this.onVideoElementSeeked.bind(this),
          seeking: this.onVideoElementSeeking.bind(this),
          loadstart: this.onVideoElementLoadstart.bind(this),
          timeupdate: this.onVideoElementTimeupdate.bind(this)
        }
      };
      Object.keys(this._handlers.video).forEach(function (key) {
        _this.videoElement.addEventListener(key, _this._handlers.video[key]);
      });
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      var _this2 = this;
      if (!this._handlers) {
        return;
      }
      if (this.videoElement) {
        Object.keys(this._handlers.video).forEach(function (key) {
          _this2.videoElement.removeEventListener(key, _this2._handlers.video[key]);
        });
      }
      this._handlers = null;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.videoElement ? this.videoElement.currentTime : 0;
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.videoElement ? this.videoElement.duration : 0;
    }
  }, {
    key: "setVolume",
    value: function setVolume(volume) {
      if (this.videoElement) {
        this.videoElement.volume = volume;
      }
    }
  }, {
    key: "onVideoElementCanPlay",
    value: function onVideoElementCanPlay() {
      if (!this.videoElement || !this.options || !this.source) {
        return;
      }
      if (!this._playbackAvailable) {
        this._playbackAvailable = true;
        if (Number.isFinite(this.source.startTime) && this.videoElement.currentTime < this.source.startTime) {
          this.videoElement.currentTime = this.startTime;
        }
        this.options.dispatcher(CAN_PLAY, {
          duration: this.videoElement.duration
        });
      }
    }
  }, {
    key: "onVideoElementCanPlayThrough",
    value: function onVideoElementCanPlayThrough() {
      if (!this.videoElement || !this.source) {
        return;
      }
      var duration = this.getDuration();
      console.log("[HTML5Engine] Can play through, duration: ".concat(duration, ", seek started: ").concat(this._seekStarted));
      if (!Number.isFinite(duration)) {
        return;
      }
      this.options.dispatcher(CAN_PLAY_THROUGH, {
        duration: this.videoElement.duration
      });
      if (this._seekStarted) {
        return;
      }
      var diff = Math.abs(this.videoElement.currentTime - this.startTime);
      if (Number.isFinite(this.source.startTime) && diff >= 3 && !this._isTimeFixed) {
        this.videoElement.currentTime = this.source.startTime;
      }
      if (!this._isTimeFixed) {
        this.play();
      }
    }
  }, {
    key: "onVideoElementPlay",
    value: function onVideoElementPlay() {
      if (!this.options) {
        return;
      }
      this.options.dispatcher(video_events_PLAY);
      this.options.dispatcher(PLAYING);
    }
  }, {
    key: "onVideoElementPause",
    value: function onVideoElementPause() {
      if (!this.options) {
        return;
      }
      this.options.dispatcher(PAUSE);
    }
  }, {
    key: "onVideoElementBuffering",
    value: function onVideoElementBuffering(event) {
      if (!this.options) {
        return;
      }
      this.options.dispatcher(WAITING, event);
    }
  }, {
    key: "onVideoElementEnded",
    value: function onVideoElementEnded() {
      console.log('[HTML5Engine] Playback ended');
      if (!this.options) {
        return;
      }
      this.options.dispatcher(ENDED);
    }
  }, {
    key: "onVideoElementError",
    value: function onVideoElementError(event) {
      if (!this.options) {
        return;
      }
      this.options.dispatcher(ERROR, {
        error: {
          message: event && event.target && event.target.error ? event.target.error.message : '',
          fatal: true
        }
      });
    }
  }, {
    key: "onVideoElementSeeking",
    value: function onVideoElementSeeking() {
      if (!this.options) {
        return;
      }
      this.options.dispatcher(SEEKING, {
        from: this._seekFrom,
        to: this._seekTo
      });
    }
  }, {
    key: "onVideoElementSeeked",
    value: function onVideoElementSeeked(event) {
      if (!this.options) {
        return;
      }
      this.options.dispatcher(SEEKED, {
        from: this._seekFrom,
        to: Math.round(event.target.currentTime)
      });
    }
  }, {
    key: "onVideoElementLoadstart",
    value: function onVideoElementLoadstart(event) {
      if (!this.options) {
        return;
      }
      this.options.dispatcher(LOAD_START, event);
    }
  }, {
    key: "onVideoElementTimeupdate",
    value: function onVideoElementTimeupdate(event) {
      if (!this.options) {
        return;
      }
      var currentTime = event.target.currentTime;
      var shouldJumpToStartTime = Number.isFinite(this.source.startTime);
      if (!this._isFirstTickFired) {
        this._isFirstTickFired = true;
        if (shouldJumpToStartTime) {
          this.videoElement.currentTime = this.startTime;
          this._watchForStall();
          return;
        }
      }
      if (!this._isTimeFixed) {
        var diff = Math.abs(currentTime - this.startTime);
        if (shouldJumpToStartTime && diff >= 3) {
          console.log("[HTML5Engine] Current time ".concat(currentTime, " not aligned with ").concat(this.startTime, ", attempting to fix"));
          this.videoElement.currentTime = this.startTime;
          this._watchForStall();
          return;
        }
        if (diff < 3) {
          this._isTimeFixed = true;
          clearInterval(this._antiStallTimer);
        }
      }
      this.options.dispatcher(TIME_UPDATE, {
        currentTime: currentTime
      });
    }
  }, {
    key: "_watchForStall",
    value: function _watchForStall() {
      clearInterval(this._antiStallTimer);
      if (!this.videoElement) {
        return;
      }
      this._lastTime = this.videoElement.currentTime;
      this._antiStallTimer = setInterval(this._checkForStall.bind(this), 500);
    }
  }, {
    key: "_checkForStall",
    value: function _checkForStall() {
      if (!this.videoElement) {
        return;
      }
      if (this._lastTime === this.videoElement.currentTime) {
        this.videoElement.currentTime += 0.1;
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      console.log('[HTML5Engine] Resetting');
      if (this.videoElement) {
        var video = this.videoElement;
        try {
          video.pause();
          console.log('[HTML5Engine] Removing player source');
          video.removeAttribute('src');
          video.load();
          video.src = '';
          video.srcObject = null;
        } catch (error) {
          console.error('[HTML5Engine] Can not cleanup video element source');
        }
      }
      clearInterval(this._antiStallTimer);
      return Promise.resolve();
    }
  }, {
    key: "release",
    value: function release() {
      console.log('[HTML5Engine] Destroying');
      this.removeEventListeners();
      this.reset();
      if (this.videoElement) {
        try {
          this.videoElement.remove();
        } catch (error) {
          console.error('[HTML5Engine] Can not remove video element');
        }
      }
      this.videoElement = null;
      this.source = null;
      this.options = null;
    }
  }]);
  return HTML5Engine;
}(engine);
// EXTERNAL MODULE: ./packages/bedrock-rdk/media-engine/src/youbora/adapters/youbora.vodafone.adapter.js
var youbora_vodafone_adapter = __webpack_require__(57568);
var youbora_vodafone_adapter_default = /*#__PURE__*/__webpack_require__.n(youbora_vodafone_adapter);
// EXTERNAL MODULE: ./node_modules/.pnpm/youboralib@6.8.41/node_modules/youboralib/src/youboralib.js
var youboralib = __webpack_require__(90894);
var youboralib_default = /*#__PURE__*/__webpack_require__.n(youboralib);
;// CONCATENATED MODULE: ./packages/bedrock-rdk/media-engine/src/youbora/youbora.plugin.js



var YouboraPlugin = function () {
  function YouboraPlugin() {
    (0,classCallCheck/* default */.Z)(this, YouboraPlugin);
    this.id = 'youbora';
    this.isInitialized = false;
    this.instance = null;
    this._isDisconnected = false;
  }
  (0,createClass/* default */.Z)(YouboraPlugin, [{
    key: "init",
    value: function init(_ref) {
      var options = _ref.options;
      if (this.isInitialized && this.instance) {
        this.instance.setOptions(options);
        return;
      }
      if (options && options.accountCode) {
        this.instance = new (youboralib_default()).Plugin(options);
        this.isInitialized = true;
      }
    }
  }, {
    key: "release",
    value: function release() {
      if (this.instance) {
        try {
          this.instance.removeAdapter();
        } catch (error) {
          console.error('[YouboraPlugin]: Can not remove video adapter');
        }
        try {
          this.instance.removeAdsAdapter();
        } catch (error) {
          console.error('[YouboraPlugin]: Can not remove ads adapter');
        }
      }
      this.instance = null;
      this.isInitialized = false;
    }
  }, {
    key: "setOptions",
    value: function setOptions(options) {
      if (this.instance) {
        this.instance.setOptions(options);
      }
    }
  }, {
    key: "getAdapter",
    value: function getAdapter() {
      return this.instance ? this.instance.getAdapter() : null;
    }
  }, {
    key: "setAdapter",
    value: function setAdapter(adapter) {
      if (this.instance) {
        this.instance.setAdapter(adapter);
      }
    }
  }, {
    key: "setAdsAdapter",
    value: function setAdsAdapter(adapter) {
      if (this.instance) {
        this.instance.setAdsAdapter(adapter);
      }
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      if (!this.instance) {
        return;
      }
      var adapter = this.instance.getAdapter();
      adapter.disconnect();
      this._isDisconnected = true;
    }
  }, {
    key: "connect",
    value: function connect(engine) {
      if (!this.instance || !this._isDisconnected) {
        return;
      }
      var adapter = this.instance.getAdapter();
      adapter.connect(engine.player);
    }
  }]);
  return YouboraPlugin;
}();

;// CONCATENATED MODULE: ./packages/bedrock-rdk/media-engine/src/youbora/youbora.vodafone.plugin.js






function youbora_vodafone_plugin_createSuper(t) { var r = youbora_vodafone_plugin_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function youbora_vodafone_plugin_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (youbora_vodafone_plugin_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }


var YouboraVodafonePlugin = function (_YouboraPlugin) {
  (0,inherits/* default */.Z)(YouboraVodafonePlugin, _YouboraPlugin);
  var _super = youbora_vodafone_plugin_createSuper(YouboraVodafonePlugin);
  function YouboraVodafonePlugin() {
    (0,classCallCheck/* default */.Z)(this, YouboraVodafonePlugin);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(YouboraVodafonePlugin, [{
    key: "init",
    value: function init(_ref) {
      var options = _ref.options,
        engine = _ref.engine,
        _ref$sendInitEvent = _ref.sendInitEvent,
        sendInitEvent = _ref$sendInitEvent === void 0 ? false : _ref$sendInitEvent;
      var isInitialized = this.isInitialized;
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(YouboraVodafonePlugin.prototype), "init", this).call(this, {
        options: options
      });
      if (!isInitialized) {
        this.setAdapter(new (youbora_vodafone_adapter_default())(engine.player));
        if (sendInitEvent) {
          this.instance.fireInit(null, 'contentSelected');
        }
      }
    }
  }]);
  return YouboraVodafonePlugin;
}(YouboraPlugin);
;// CONCATENATED MODULE: ./packages/bedrock-rdk/media-engine/src/platform/vodafone/index.js





var getPlayerInstance = function getPlayerInstance() {
  return Promise.resolve({
    Engine: OipfEngine,
    plugins: [YouboraVodafonePlugin]
  });
};
var getAdPlayerInstance = function getAdPlayerInstance() {
  return Promise.resolve({
    Engine: HTML5Engine
  });
};
;// CONCATENATED MODULE: ./packages/bedrock-rdk/media-engine/src/constants/subtitles.js
var DISABLED_SUBTITLES = 'disable';
var DISABLED_SUBTITLES_ID = -1;
;// CONCATENATED MODULE: ./packages/bedrock-rdk/media-engine/src/utils/constants/audioTrack.js
var VO = 'vo';
var OV = 'ov';
var QTZ = 'qtz';
var UND = 'und';
var QAA = 'qaa';
var EN = 'en';
var ENG = 'eng';
var MIS = 'mis';
var QAD = 'qad';
var AD = 'ad';
;// CONCATENATED MODULE: ./packages/bedrock-rdk/media-engine/src/utils/audioTrack.utils.js

var getCorrectAudioTrackLabel = function getCorrectAudioTrackLabel(label) {
  var labelLower = (label || '').toLowerCase();
  switch (labelLower) {
    case OV:
    case QTZ:
    case UND:
    case QAA:
      return OV;
    case MIS:
    case QAD:
      return AD;
    default:
      return labelLower;
  }
};


;// CONCATENATED MODULE: ./packages/bedrock-rdk/media-engine/src/index.js






;// CONCATENATED MODULE: ./src/logic/player/player.constants.js

function player_constants_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function player_constants_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? player_constants_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : player_constants_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



var PLAYBACK_STATE_IDLE = 'idle';
var PLAYBACK_STATE_PLAYING = 'playing';
var PLAYBACK_STATE_PAUSED = 'paused';
var PLAYBACK_STATE_ENDED = 'ended';
var PAUSE_AD_STATE = {
  IDLE: 0,
  LOADING: 1,
  DISPLAYING: 2,
  ERROR: 3
};
var LBANNER_STATE = {
  HIDE: 0,
  SHOW: 1
};
var PLAYER_ENTITIES = [layout_constants/* entities */.jF.audio, layout_constants/* entities */.jF.radio, layout_constants/* entities */.jF.video];
var JINGLE_DURATION = 3000;
var AD_JINGLE_DURATION = 1500;
var INTERFACE_DISPLAY_DURATION = 5000;
var SEEK_DEBOUNCE_MS = 800;
var SEEK_THROTTLE_MS = 220;
var SEEK_STEP_SECONDS = 15;
var LIVE_DURATION = (/* unused pure expression or super */ null && (-1));
var MIN_SECONDS_TO_TRACK_PROGRESS = 30;
var PLAYER_ACTIONS_PREFIX = 'player';
var withPlayerPrefix = function withPlayerPrefix(event) {
  return "".concat(PLAYER_ACTIONS_PREFIX, "/").concat(event.toUpperCase());
};
var INITIALIZED = withPlayerPrefix('INITIALIZED');
var LOAD_CONTENT = withPlayerPrefix('LOAD_CONTENT');
var player_constants_MANIFEST_LOADED = withPlayerPrefix('MANIFEST_LOADED');
var BUFFERING = withPlayerPrefix(LOAD_START);
var LOCKED = withPlayerPrefix('LOCKED');
var player_constants_CAN_PLAY = withPlayerPrefix(CAN_PLAY);
var player_constants_CAN_PLAY_THROUGH = withPlayerPrefix(CAN_PLAY_THROUGH);
var player_constants_PLAYING = withPlayerPrefix(PLAYING);
var PAUSED = withPlayerPrefix(PAUSE);
var player_constants_WAITING = withPlayerPrefix(WAITING);
var player_constants_TIME_UPDATE = withPlayerPrefix(TIME_UPDATE);
var player_constants_SEEKING = withPlayerPrefix(SEEKING);
var player_constants_SEEKED = withPlayerPrefix(SEEKED);
var player_constants_ENDED = withPlayerPrefix(ENDED);
var player_constants_TRACKS_CHANGED = withPlayerPrefix(TRACKS_CHANGED);
var player_constants_AUDIO_TRACK_CHANGED = withPlayerPrefix(AUDIO_TRACK_CHANGED);
var player_constants_SUBTITLES_TRACK_CHANGED = withPlayerPrefix(SUBTITLES_TRACK_CHANGED);
var player_constants_SUBTITLES_UPDATED = withPlayerPrefix(SUBTITLES_UPDATED);
var TOP_BAR_BACK = withPlayerPrefix('TOP_BAR_BACK');
var TOP_BAR_START_OVER = withPlayerPrefix('TOP_BAR_START_OVER');
var TOP_BAR_TRACKS = withPlayerPrefix('TOP_BAR_TRACKS');
var TOP_BAR_RELATED_VIDEOS = withPlayerPrefix('TOP_BAR_RELATED_VIDEOS');
var TOP_BAR_BACK_TO_LIVE = withPlayerPrefix('TOP_BAR_BACK_TO_LIVE');
var TOP_BAR_INFO_PAGE = withPlayerPrefix('TOP_BAR_INFO_PAGE');
var RESET = withPlayerPrefix('RESET');
var RESET_LAST_VIEWED_VIDEO_DATA = withPlayerPrefix('RESET_LAST_VIEWED_VIDEO_DATA');
var AD_PROVIDER_LOADED = withPlayerPrefix('AD_PROVIDER_LOADED');
var AD_JINGLE_STARTED = withPlayerPrefix('AD_JINGLE_STARTED');
var AD_JINGLE_COMPLETE = withPlayerPrefix('AD_JINGLE_COMPLETE');
var AD_BREAK_STARTED = withPlayerPrefix('AD_BREAK_STARTED');
var AD_BREAK_ENDED = withPlayerPrefix('AD_BREAK_ENDED');
var AD_PLAYING = withPlayerPrefix('AD_PLAYING');
var AD_BREAK_TIME_UPDATE = withPlayerPrefix('AD_BREAK_TIME_UPDATE');
var AD_PAUSED = withPlayerPrefix('AD_PAUSED');
var AD_ENDED = withPlayerPrefix('AD_ENDED');
var player_constants_AD_ERROR = withPlayerPrefix('AD_ERROR');
var SET_PAUSE_AD = withPlayerPrefix('SET_PAUSE_AD');
var SET_PAUSE_AD_STATE = withPlayerPrefix('SET_PAUSE_AD_STATE');
var APPEND_NEW_METADATA_ITEMS = withPlayerPrefix('APPEND_NEW_METADATA_ITEMS');
var UPDATE_METADATA = withPlayerPrefix(LOADED_METADATA);
var SET_AUDIO_TRACK = withPlayerPrefix('SET_AUDIO_TRACK');
var SET_SUBTITLE_TRACK = withPlayerPrefix('SET_SUBTITLE_TRACK');
var TRACK_PREFERENCES_CHANGED = withPlayerPrefix('TRACK_PREFERENCES_CHANGED');
var SET_CURRENT_METADATA_ITEM = withPlayerPrefix('SET_CURRENT_METADATA_ITEM');
var SET_LBANNER_STATE = withPlayerPrefix('SET_LBANNER_STATE');
var SET_PLAYER_ERROR = withPlayerPrefix('SET_PLAYER_ERROR');
var setPlayerInitialized = function setPlayerInitialized(options) {
  return player_constants_objectSpread(player_constants_objectSpread({}, options), {}, {
    type: INITIALIZED
  });
};
var loadContent = function loadContent() {
  return {
    type: LOAD_CONTENT
  };
};
var lockPlayer = function lockPlayer() {
  return {
    type: LOCKED
  };
};
var playing = function playing() {
  return {
    type: player_constants_PLAYING
  };
};
var paused = function paused() {
  return {
    type: PAUSED
  };
};
var player_constants_reset = function reset() {
  return {
    type: RESET
  };
};
var resetLastViewedData = function resetLastViewedData() {
  return {
    type: RESET_LAST_VIEWED_VIDEO_DATA
  };
};
var adProviderLoaded = function adProviderLoaded() {
  return {
    type: AD_PROVIDER_LOADED
  };
};
var adJingleStarted = function adJingleStarted() {
  return {
    type: AD_JINGLE_STARTED
  };
};
var adJingleComplete = function adJingleComplete() {
  return {
    type: AD_JINGLE_COMPLETE
  };
};
var adBreakStarted = function adBreakStarted(type, totalDuration) {
  return {
    type: AD_BREAK_STARTED,
    adType: type,
    totalDuration: totalDuration
  };
};
var adBreakEnded = function adBreakEnded() {
  return {
    type: AD_BREAK_ENDED
  };
};
var adPlaying = function adPlaying() {
  return {
    type: AD_PLAYING
  };
};
var adBreakTimeUpdate = function adBreakTimeUpdate(timeInSeconds, durationInSeconds) {
  return {
    type: AD_BREAK_TIME_UPDATE,
    currentTime: timeInSeconds,
    totalDuration: durationInSeconds
  };
};
var adPaused = function adPaused() {
  return {
    type: AD_PAUSED
  };
};
var adEnded = function adEnded() {
  return {
    type: AD_ENDED
  };
};
var adError = function adError(_ref) {
  var adRequestUrl = _ref.adRequestUrl,
    content = _ref.content,
    context = _ref.context,
    details = _ref.details,
    fatal = _ref.fatal,
    monitored = _ref.monitored,
    reason = _ref.reason;
  return {
    type: player_constants_AD_ERROR,
    adRequestUrl: adRequestUrl,
    content: content,
    context: context,
    details: details,
    fatal: fatal,
    monitored: monitored,
    reason: reason
  };
};
var setPauseAd = function setPauseAd(ad) {
  return {
    type: SET_PAUSE_AD,
    ad: ad
  };
};
var pauseAdsError = function pauseAdsError() {
  return {
    type: SET_PAUSE_AD_STATE,
    state: PAUSE_AD_STATE.ERROR
  };
};
var pauseAdsDisplaying = function pauseAdsDisplaying() {
  return {
    type: SET_PAUSE_AD_STATE,
    state: PAUSE_AD_STATE.DISPLAYING
  };
};
var setLBannerShow = function setLBannerShow() {
  return {
    type: SET_LBANNER_STATE,
    state: LBANNER_STATE.SHOW
  };
};
var setLBannerHide = function setLBannerHide() {
  return {
    type: SET_LBANNER_STATE,
    state: LBANNER_STATE.HIDE
  };
};
var setPlayerError = function setPlayerError(error) {
  return {
    type: SET_PLAYER_ERROR,
    error: error
  };
};
;// CONCATENATED MODULE: ./src/logic/player/player.selectors.js






var player_selectors_DEFAULT_OBJECT = {};
var getIsAdProviderReady = function getIsAdProviderReady(_ref) {
  var player = _ref.player;
  return player.isAdProviderReady;
};
var getIsAdError = function getIsAdError(_ref2) {
  var player = _ref2.player;
  return player.isAdError;
};
var getCanPlay = function getCanPlay(_ref3) {
  var player = _ref3.player;
  return player.canPlay;
};
var getIsLoadingContent = function getIsLoadingContent(_ref4) {
  var player = _ref4.player;
  return player.isLoadingContent;
};
var getPlaybackState = function getPlaybackState(_ref5) {
  var player = _ref5.player;
  return player.playbackState;
};
var getAdPlaybackState = function getAdPlaybackState(_ref6) {
  var player = _ref6.player;
  return player.adPlaybackState;
};
var getIsStarted = function getIsStarted(_ref7) {
  var player = _ref7.player;
  return player.isStarted;
};
var player_selectors_getIsEnded = function getIsEnded(_ref8) {
  var player = _ref8.player;
  return player.playbackState === PLAYBACK_STATE_ENDED;
};
var getIsBuffering = function getIsBuffering(_ref9) {
  var player = _ref9.player;
  return player.isBuffering;
};
var getIsSeeking = function getIsSeeking(_ref0) {
  var player = _ref0.player;
  return player.isSeeking;
};
var getAudioTracks = function getAudioTracks(_ref1) {
  var player = _ref1.player;
  return player.audioTracks;
};
var getSubtitleTracks = function getSubtitleTracks(_ref10) {
  var player = _ref10.player;
  return player.subtitleTracks;
};
var getSelectedAudioTrack = function getSelectedAudioTrack(_ref11) {
  var player = _ref11.player;
  return player.selectedAudioTrack;
};
var getSelectedSubtitlesTrack = function getSelectedSubtitlesTrack(_ref12) {
  var player = _ref12.player;
  return player.selectedSubtitlesTrack;
};
var getSubtitleCuePoint = function getSubtitleCuePoint(_ref13) {
  var player = _ref13.player;
  return player.subtitleCuePoint;
};
var shouldHideVideoLoader = function shouldHideVideoLoader(_ref14) {
  var player = _ref14.player;
  return player.shouldHideVideoLoader;
};
var getLastPlaybackError = function getLastPlaybackError(_ref15) {
  var player = _ref15.player;
  return player.lastError;
};
var getContentType = function getContentType(_ref16) {
  var player = _ref16.player;
  return player.contentType;
};
var getCurrentMetadataItem = function getCurrentMetadataItem(state) {
  return get_default()(state, 'player.metadataItems', [])[get_default()(state, 'player.currentMetadataItemIndex')];
};
var player_selectors_getTitle = function getTitle(state) {
  return get_default()(getCurrentMetadataItem(state), 'title', '');
};
var getExtraTitle = function getExtraTitle(state) {
  return get_default()(getCurrentMetadataItem(state), 'extraTitle', '');
};
var player_selectors_getCSAPicto = function getCSAPicto(state) {
  return get_default()(getCurrentMetadataItem(state), 'csaPicto');
};
var getHasAgeGate = function getHasAgeGate(state) {
  return _get(player_selectors_getCSAPicto(state), 'name') === 'Csa18';
};
var player_selectors_getDurationInSeconds = function getDurationInSeconds(state) {
  return get_default()(state, 'player.durationInSeconds', 0);
};
var player_selectors_getElapsedTimeInSeconds = function getElapsedTimeInSeconds(state) {
  return get_default()(state, 'player.elapsedTimeInSeconds');
};
var getStartTimeInSeconds = function getStartTimeInSeconds(state) {
  return get_default()(state, 'player.startTimeInSeconds', 0);
};
var getLastViewedClipId = function getLastViewedClipId(state) {
  return get_default()(state, 'player.lastViewedClipId', '');
};
var getLastViewedClipProgress = function getLastViewedClipProgress(state) {
  return get_default()(state, 'player.lastViewedClipProgress', 0);
};
var isJingleEnabled = function isJingleEnabled(state) {
  return getPlayerJingleFeature(state) !== false;
};
var getJingleImageId = function getJingleImageId(state) {
  return isJingleEnabled(state) ? get_default()(state, 'player.jingleImageId', '') : '';
};
var getProgramImageId = function getProgramImageId(state) {
  return isJingleEnabled(state) ? get_default()(state, 'player.programImageId', '') : '';
};
var getPlayerLocked = function getPlayerLocked(state) {
  return _get(state, 'player.playerLocked');
};
var getSideGlassContent = function getSideGlassContent(state) {
  return get_default()(state, 'player.sideGlass');
};
var getContentAdvisory = function getContentAdvisory(state) {
  return get_default()(getCurrentMetadataItem(state), 'contentAdvisory', player_selectors_DEFAULT_OBJECT);
};
var getAnalyticsById = function getAnalyticsById(analyticsId) {
  return function (state) {
    return get_default()(getCurrentMetadataItem(state), "analytics.".concat(analyticsId), player_selectors_DEFAULT_OBJECT);
  };
};
var getAdvertising = function getAdvertising(state) {
  return get_default()(getCurrentMetadataItem(state), 'advertising', player_selectors_DEFAULT_OBJECT);
};
var getAdsProvider = function getAdsProvider(state) {
  var ads = getAdvertising(state);
  return ads.providers ? ads.providers.video : '';
};
var getPauseAdRequestData = function getPauseAdRequestData(state) {
  var isFeatureEnabled = getPlayerPauseAdFeature(state);
  if (!isFeatureEnabled) {
    return false;
  }
  var advertising = get_default()(getCurrentMetadataItem(state), 'advertising');
  if (!advertising) {
    return undefined;
  }
  var provider = get_default()(advertising, 'providers.pause');
  if (!provider) {
    return undefined;
  }
  return advertising[provider];
};
var getPauseAdState = function getPauseAdState(state) {
  return state.player.pauseAdState;
};
var getLBannerState = function getLBannerState(state) {
  return state.player.lBannerState && getPlayerLBannerFeature(state);
};
var getCurrentPauseAd = function getCurrentPauseAd(state) {
  return state.player.pauseAd;
};
var isAdBreakDisplayed = function isAdBreakDisplayed(state) {
  return _get(state, 'player.isAdBreakDisplayed');
};
var getDisplayedAdBreakType = function getDisplayedAdBreakType(state) {
  return get_default()(state, 'player.displayedAdBreakType');
};
var getAdBreakDuration = function getAdBreakDuration(state) {
  return state.player.adBreakDuration;
};
var getAdBreakElapsedTime = function getAdBreakElapsedTime(state) {
  return state.player.adBreakElapsedTime;
};
var getAdJingleDurationInMilliseconds = function getAdJingleDurationInMilliseconds(state) {
  return get_default()(state, 'app.ads.adJingleDurationInMilliseconds', AD_JINGLE_DURATION);
};
var getAdJingleImageId = function getAdJingleImageId(state) {
  return get_default()(state, 'player.adJingleImageId', '');
};
var isPlayingAds = function isPlayingAds(state) {
  return get_default()(state, 'player.isPlayingAds');
};
var isAdJingleDisplayed = function isAdJingleDisplayed(state) {
  return get_default()(state, 'player.isAdJingleDisplayed');
};
var player_selectors_getVideoId = function getVideoId(state) {
  return get_default()(getCurrentMetadataItem(state), 'video.id', '');
};
var player_selectors_getClipId = function getClipId(state) {
  return player_selectors_getVideoId(state).replace('clip_', '');
};
var getVideoSource = function getVideoSource(state) {
  var sourceIndex = get_default()(state, 'player.currentSourceIndex', 0);
  return get_default()(state, "player.sources[".concat(sourceIndex, "]"));
};
var getCurrentAssetType = function getCurrentAssetType(state) {
  var source = getVideoSource(state);
  if (!source) {
    return '';
  }
  var provider = source.provider,
    format = source.format,
    container = source.container;
  return [provider, format, container].join('_');
};
var getIsLive = function getIsLive(state) {
  return get_default()(state, 'player.isLive', false);
};
var shouldSwitchToNextProgram = function shouldSwitchToNextProgram(state) {
  return player_selectors_getElapsedTimeInSeconds(state) >= player_selectors_getDurationInSeconds(state);
};
var shouldLoadNewMetadataItems = function shouldLoadNewMetadataItems(state) {
  var _state$player = state.player,
    currentMetadataItemIndex = _state$player.currentMetadataItemIndex,
    elapsedTimeInSeconds = _state$player.elapsedTimeInSeconds,
    lastMetadataItemIndex = _state$player.lastMetadataItemIndex,
    timeToLoadNewLayout = _state$player.timeToLoadNewLayout,
    isNextLiveLayoutLoading = _state$player.isNextLiveLayoutLoading;
  return !isNextLiveLayoutLoading && timeToLoadNewLayout && currentMetadataItemIndex === lastMetadataItemIndex && elapsedTimeInSeconds >= timeToLoadNewLayout;
};
var isLiveStartOverEnabled = function isLiveStartOverEnabled(state) {
  return Boolean(state.player.liveStartOverFeature);
};
var isLiveSeekEnabled = function isLiveSeekEnabled(state) {
  return Boolean(isLiveStartOverEnabled(state) && getLiveSeekFeature(state));
};
var getLBannerProvider = function getLBannerProvider(state) {
  var ads = getAdvertising(state);
  return ads.providers ? ads.providers.nonlinear : '';
};
;// CONCATENATED MODULE: ./src/modules/player/analytics/platform/vodafone/youbora.constants.js
var DEVICE_CODE = 'VodafoneSTB';
;// CONCATENATED MODULE: ./src/modules/player/analytics/youbora.utils.js








function youbora_utils_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function youbora_utils_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? youbora_utils_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : youbora_utils_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }








var KEY = 'youbora';
var DEEPLINK_ORIGIN = 'deeplink';
var getRealReferrer = function getRealReferrer() {
  if (window.location !== window.parent.location && document.referrer) {
    return new URL(document.referrer);
  }
  return new URL(window.location.href);
};
var getYouboraDataFromLayout = getAnalyticsById(KEY);
var getCatalogCallerOrigin = function getCatalogCallerOrigin(url) {
  var pageData = url.match(/^app\/(\w+)(\/(\w+))?$/);
  if (!pageData) {
    return null;
  }
  var entityType = pageData[1];
  if (entityType === layout_constants/* entities */.jF.alias || entityType === layout_constants/* entities */.jF.frontspace) {
    return pageData[3];
  }
  return entityType;
};
var getPlayerCallerOrigin = function getPlayerCallerOrigin(url) {
  var pageData = url.match(/^(video|live)\/(\w+)$/);
  return pageData ? pageData[1] : null;
};
var getVideoCallerEntity = function getVideoCallerEntity() {
  var history = Router.getHistory();
  var lastHistoryItem = history.pop();
  if (!lastHistoryItem) {
    return DEEPLINK_ORIGIN;
  }
  var hash = lastHistoryItem.hash;
  var matchers = [getPlayerCallerOrigin, getCatalogCallerOrigin];
  for (var i = 0; i < matchers.length; i += 1) {
    var origin = matchers[i](hash);
    if (origin) {
      return origin;
    }
  }
  return DEEPLINK_ORIGIN;
};
var fetchYouboraData = function fetchYouboraData(state) {
  var result = youbora_utils_objectSpread(youbora_utils_objectSpread({
    'user.name': user_selectors_getUid(state),
    referer: getRealReferrer().origin,
    accountCode: src.youbora.accountCode,
    'device.name': env.appPlatform,
    'device.code': DEVICE_CODE,
    'device.brand': getDeviceBrand(state),
    'device.model': getDeviceModel(state),
    'device.type': env.appPlatform === 'web' ? 'web' : 'stb',
    'device.osVersion': getDeviceVersion(state),
    'content.customDimension.7': getCurrentAssetType(state) || 'unref',
    'app.releaseVersion': env.appVersion,
    'content.customDimension.10': env.appCustomer,
    'content.customDimension.14': getVideoCallerEntity()
  }, getYouboraDataFromLayout(state)), {}, {
    'content.customDimension.9': 'rdk',
    'parse.manifest': true
  });
  return result;
};
;// CONCATENATED MODULE: ./src/modules/player/platform/default/player.constants.js
var LOADER_DELAY = 0;
var POST_AD_JINGLE_DELAY = 0.1;
var REUSE_VIDEO_NODE = false;
;// CONCATENATED MODULE: ./src/modules/player/player.constants.js

var PERCENTAGE_EVENT_DURATION = 25;
var AD_BREAK_PRE_ROLL = 'preroll';
var AD_BREAK_MID_ROLL = 'midroll';

;// CONCATENATED MODULE: ./src/modules/video/lBanner/lBanner.constants.js
var L_BANNER_WIDTH_SCALE = 0.2218;
var lBanner_constants_L_BANNER_HEIGHT_SCALE = 0.2222;
;// CONCATENATED MODULE: ./src/modules/video/lBanner/lBanner.utils.js


var getLBannerWidth = function getLBannerWidth() {
  var screenSize = sizes_getScreenSize();
  return Math.floor(SCREEN_WIDTH[screenSize] * L_BANNER_WIDTH_SCALE);
};
var getLBannerHeight = function getLBannerHeight() {
  var screenSize = getScreenSize();
  return Math.floor(SCREEN_HEIGHT[screenSize] * L_BANNER_HEIGHT_SCALE);
};
var getLBannerWidthScale = function getLBannerWidthScale() {
  return L_BANNER_WIDTH_SCALE;
};
var getLBannerHeightScale = function getLBannerHeightScale() {
  return lBanner_constants_L_BANNER_HEIGHT_SCALE;
};
;// CONCATENATED MODULE: ./src/modules/player/platform/vodafone/player.utils.js


var createRenderers = function createRenderers() {
  var container = document.createElement('div');
  container.style.cssText = 'position: fixed; top: 0; left: 0; width: 100%; height: 100%; overflow: hidden;';
  var video = document.createElement('object');
  video.setAttribute('id', 'video');
  video.setAttribute('type', 'application/dash+xml');
  video.style.cssText = 'position: absolute; top: 0; right: 0;';
  container.className = 'video-container';
  container.appendChild(video);
  document.body.appendChild(container);
  return {
    container: container,
    video: video
  };
};
var createAdRenderers = function createAdRenderers() {
  var container = document.createElement('div');
  container.style.cssText = 'position: fixed; top: 0; left: 0; width: 100%; height: 100%; overflow: hidden;';
  var video = document.createElement('video');
  video.setAttribute('crossorigin', 'anonymous');
  video.style.cssText = 'width: 100%; height: 100%; position: absolute; top: 0; right: 0;';
  container.className = 'video-container';
  container.appendChild(video);
  document.body.appendChild(container);
  return {
    container: container,
    video: video
  };
};
var switchLBannerState = function switchLBannerState(videoEl, enable) {
  if (!videoEl) return;
  var fullWidth = SCREEN_WIDTH[sizes_getScreenSize()];
  var fullHeight = sizes_SCREEN_HEIGHT[sizes_getScreenSize()];
  if (enable) {
    var width = Math.floor(fullWidth * (1 - getLBannerWidthScale()));
    var height = Math.floor(fullHeight * (1 - getLBannerHeightScale()));
    videoEl.removeAttribute('_opera_dae_full_screen');
    videoEl.setFullScreen(false);
    videoEl.style.width = "".concat(width, "px");
    videoEl.style.height = "".concat(height, "px");
  } else {
    videoEl.setFullScreen(true);
    videoEl.style.width = "".concat(fullWidth, "px");
    videoEl.style.height = "".concat(fullHeight, "px");
  }
};
;// CONCATENATED MODULE: ./src/modules/player/platform/default/playerConfig.utils.js



var enhancePlayerConfig = function () {
  var _ref = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(config) {
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", config);
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function enhancePlayerConfig(_x) {
    return _ref.apply(this, arguments);
  };
}();
;// CONCATENATED MODULE: ./src/modules/player/player.utils.js










var getOriginUrl = function getOriginUrl(lbCdnUrl) {
  return new Promise(function (resolve, reject) {
    client_default().get(lbCdnUrl).then(function (response) {
      resolve(response.text);
    }).catch(function (error) {
      return reject(error);
    });
  });
};
var getOriginalUrlFromReference = function getOriginalUrlFromReference(reference) {
  if (reference && reference.includes('no-redirect')) {
    return getOriginUrl(reference);
  }
  return Promise.resolve(reference);
};
var fetchPlayerPluginDataById = function fetchPlayerPluginDataById(id, state) {
  switch (id) {
    case KEY:
      return fetchYouboraData(state);
    default:
      return {};
  }
};
var getUserPreference = function getUserPreference(key) {
  var profileUid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return storage.getItem([profileUid, key].filter(Boolean).join('.') || storage.getItem(key)) || '';
};
var calculatePartOfDuration = function calculatePartOfDuration(value, duration) {
  return Math.floor(value / duration * 100 / PERCENTAGE_EVENT_DURATION);
};


;// CONCATENATED MODULE: ./src/logic/error/error.constants.js
var error_constants_ERROR_TYPES = {
  GENERAL: 'general',
  CSL: 'csl',
  PAIRING: 'pairing',
  PLAYER: 'player',
  LAYOUT: 'layout'
};
var error_constants_ERROR_LEVELS = {
  FATAL: 'fatal',
  SILENT: 'silent'
};
var RETRY_ACTIONS = {
  LAYOUT_FETCH: 'layout_fetch'
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/user/userService.js








function userService_createSuper(t) { var r = userService_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function userService_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (userService_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var userService_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,esm_typeof/* default */.Z)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var userService_monitoring = withMonitoring_withMonitoring('user');
var buildUserEndpoint = function buildUserEndpoint(uid, submodule, action) {
  return "users/".concat(uid, "/").concat(submodule, "/").concat(action);
};
var UserService = function (_FetcherService) {
  (0,inherits/* default */.Z)(UserService, _FetcherService);
  var _super = userService_createSuper(UserService);
  function UserService() {
    var _this;
    (0,classCallCheck/* default */.Z)(this, UserService);
    _this = _super.apply(this, arguments);
    _this.apiType = 'userv2';
    return _this;
  }
  (0,createClass/* default */.Z)(UserService, [{
    key: "init",
    value: function init() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$boxType = _ref.boxType,
        boxType = _ref$boxType === void 0 ? es_fido/* fido */.n.get('clientCode') : _ref$boxType;
      if (!this.isInitialized) {
        this.basePath = "platforms/".concat(es_fido/* fido */.n.get('platformCode'));
        this.boxType = boxType;
        this.isInitialized = true;
      }
    }
  }, {
    key: "postNewsletter",
    value: function postNewsletter(uid, action, newsletters) {
      var endpoint = buildUserEndpoint(uid, 'newsletters', action);
      var url = this.getRouteUrl(endpoint);
      var path = this.getRoutePath(endpoint, true);
      return this.fetch(url, {
        method: 'POST',
        body: newsletters,
        headers: getTimestampHeader(path, newsletters, es_fido/* fido */.n.get('getCurrentTime')(), es_fido/* fido */.n.get('saltAndSugar'))
      });
    }
  }, {
    key: "getNewsletterSubscriptions",
    value: function getNewsletterSubscriptions(_ref2) {
      var uid = _ref2.uid,
        _ref2$headers = _ref2.headers,
        headers = _ref2$headers === void 0 ? {} : _ref2$headers;
      if (!uid) {
        throw new Error('You should provide an uid');
      }
      var endpoint = "users/".concat(uid, "/newsletters");
      var url = this.getRouteUrl(endpoint);
      return this.fetch(url, {
        method: 'GET',
        headers: headers
      });
    }
  }, {
    key: "setNewsletterSubscriptions",
    value: function setNewsletterSubscriptions(_ref3) {
      var uid = _ref3.uid,
        newsletters = _ref3.newsletters,
        _ref3$headers = _ref3.headers,
        headers = _ref3$headers === void 0 ? {} : _ref3$headers;
      if (!uid) {
        throw new Error('You should provide an uid');
      }
      var endpoint = "users/".concat(uid, "/newsletters");
      var url = this.getRouteUrl(endpoint);
      return this.fetch(url, {
        method: 'POST',
        headers: headers,
        body: {
          newsletters: map_default()(newsletters, function (value, key) {
            return {
              code: key,
              subscribed: value
            };
          })
        }
      });
    }
  }, {
    key: "getLastViewedClips",
    value: function getLastViewedClips(_ref4) {
      var uid = _ref4.uid,
        _ref4$headers = _ref4.headers,
        headers = _ref4$headers === void 0 ? {} : _ref4$headers,
        _ref4$limit = _ref4.limit,
        limit = _ref4$limit === void 0 ? 50 : _ref4$limit;
      if (!uid) {
        throw new Error('You should provide an uid');
      }
      var endpoint = "users/".concat(uid, "/videos?limit=").concat(limit);
      var url = this.getRouteUrl(endpoint);
      return this.fetch(url, {
        method: 'GET',
        headers: headers
      });
    }
  }, {
    key: "addBookmark",
    value: function addBookmark(_ref5) {
      var entityId = _ref5.entityId,
        entityType = _ref5.entityType,
        _ref5$headers = _ref5.headers,
        headers = _ref5$headers === void 0 ? {} : _ref5$headers;
      if (!entityId || !entityType) {
        throw new Error('You should provide an entityId and a entityType');
      }
      var url = "".concat(es_fido/* fido */.n.getBaseUrl('userv4'), "/").concat(es_fido/* fido */.n.get('customerCode'), "/").concat(es_fido/* fido */.n.get('platformCode'), "/bookmark");
      return this.fetch(url, {
        method: 'PUT',
        body: {
          entityId: entityId,
          entityType: entityType,
          subscribed: true
        },
        headers: headers
      });
    }
  }, {
    key: "removeBookmark",
    value: function removeBookmark(_ref6) {
      var entityId = _ref6.entityId,
        entityType = _ref6.entityType,
        _ref6$headers = _ref6.headers,
        headers = _ref6$headers === void 0 ? {} : _ref6$headers;
      if (!entityId || !entityType) {
        throw new Error('You should provide an entityId and a entityType');
      }
      var url = "".concat(es_fido/* fido */.n.getBaseUrl('userv4'), "/").concat(es_fido/* fido */.n.get('customerCode'), "/").concat(es_fido/* fido */.n.get('platformCode'), "/bookmark");
      return this.fetch(url, {
        method: 'PUT',
        body: {
          entityId: entityId,
          entityType: entityType,
          subscribed: false
        },
        headers: headers
      });
    }
  }, {
    key: "getBookmarks",
    value: function getBookmarks(_ref7) {
      var uid = _ref7.uid,
        _ref7$offset = _ref7.offset,
        offset = _ref7$offset === void 0 ? 0 : _ref7$offset,
        _ref7$limit = _ref7.limit,
        limit = _ref7$limit === void 0 ? 50 : _ref7$limit,
        _ref7$headers = _ref7.headers,
        headers = _ref7$headers === void 0 ? {} : _ref7$headers;
      if (!uid) {
        throw new Error('You should provide an uid');
      }
      var endpoint = "users/".concat(uid, "/programsubscriptions/programs?offset=").concat(offset, "&limit=").concat(limit);
      var url = this.getRouteUrl(endpoint);
      return this.fetch(url, {
        method: 'GET',
        headers: headers
      });
    }
  }, {
    key: "getBookmarksIds",
    value: function getBookmarksIds(_ref8) {
      var uid = _ref8.uid,
        _ref8$headers = _ref8.headers,
        headers = _ref8$headers === void 0 ? {} : _ref8$headers;
      if (!uid) {
        throw new Error('You should provide an uid');
      }
      var endpoint = "users/".concat(uid, "/programsubscriptions");
      var url = this.getRouteUrl(endpoint);
      return this.fetch(url, {
        method: 'GET',
        headers: headers
      });
    }
  }, {
    key: "getUserCustomSegments",
    value: function getUserCustomSegments(_ref9) {
      var uid = _ref9.uid,
        destination = _ref9.destination,
        _ref9$headers = _ref9.headers,
        headers = _ref9$headers === void 0 ? {} : _ref9$headers;
      if (!uid || !destination) {
        throw new Error('You must provide a valid uid and a destination');
      }
      var endpoint = "users/".concat(uid, "/destinations/").concat(destination, "/segments");
      var url = this.getRouteUrl(endpoint);
      return this.fetch(url, {
        method: 'GET',
        headers: headers
      });
    }
  }, {
    key: "getUserSettings",
    value: function getUserSettings() {
      var _ref0 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref0$headers = _ref0.headers,
        headers = _ref0$headers === void 0 ? {} : _ref0$headers;
      var route = "".concat(es_fido/* fido */.n.getBaseUrl('userv3'), "/").concat(es_fido/* fido */.n.get('customerCode'), "/").concat(es_fido/* fido */.n.get('platformCode'), "/account");
      return this.fetch(route, {
        method: 'GET',
        headers: headers
      });
    }
  }, {
    key: "setUserSettings",
    value: function setUserSettings(_ref1) {
      var greenModeActivated = _ref1.greenModeActivated,
        videoSettings = _ref1.videoSettings,
        _ref1$headers = _ref1.headers,
        headers = _ref1$headers === void 0 ? {} : _ref1$headers;
      var route = "".concat(es_fido/* fido */.n.getBaseUrl('userv3'), "/").concat(es_fido/* fido */.n.get('customerCode'), "/").concat(es_fido/* fido */.n.get('platformCode'), "/account");
      return this.fetch(route, {
        method: 'PATCH',
        headers: headers,
        body: {
          greenModeActivated: greenModeActivated,
          videoSettings: {
            videoMaxQuality: videoSettings && videoSettings.videoMaxQuality,
            autoplay: videoSettings && videoSettings.autoplay
          }
        }
      });
    }
  }, {
    key: "setVideoSettings",
    value: function setVideoSettings(_ref10) {
      var videoMaxQuality = _ref10.videoMaxQuality,
        autoplay = _ref10.autoplay,
        trackPreferences = _ref10.trackPreferences,
        _ref10$headers = _ref10.headers,
        headers = _ref10$headers === void 0 ? {} : _ref10$headers;
      var route = "".concat(es_fido/* fido */.n.getBaseUrl('userv3'), "/").concat(es_fido/* fido */.n.get('customerCode'), "/").concat(es_fido/* fido */.n.get('platformCode'), "/videoSettings");
      return this.fetch(route, {
        method: 'PATCH',
        headers: headers,
        body: {
          videoMaxQuality: videoMaxQuality,
          autoplay: autoplay,
          trackPreferences: trackPreferences && trackPreferences.length > 0 ? trackPreferences : undefined
        }
      });
    }
  }, {
    key: "setTrackPreferences",
    value: function setTrackPreferences(_ref11) {
      var audioPreference = _ref11.audioPreference,
        subtitlesPreference = _ref11.subtitlesPreference,
        originalLanguage = _ref11.originalLanguage,
        _ref11$headers = _ref11.headers,
        headers = _ref11$headers === void 0 ? {} : _ref11$headers;
      var route = "".concat(es_fido/* fido */.n.getBaseUrl('userv3'), "/").concat(es_fido/* fido */.n.get('customerCode'), "/").concat(es_fido/* fido */.n.get('platformCode'), "/videoSettings");
      return this.fetch(route, {
        method: 'PATCH',
        headers: headers,
        body: {
          trackPreferences: [{
            originalLanguage: originalLanguage,
            audioPreference: audioPreference,
            subtitlesPreference: subtitlesPreference
          }]
        }
      });
    }
  }, {
    key: "revokeDevice",
    value: function revokeDevice() {
      var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        deviceId = _ref12.deviceId,
        _ref12$headers = _ref12.headers,
        headers = _ref12$headers === void 0 ? {} : _ref12$headers;
      var route = "".concat(es_fido/* fido */.n.getBaseUrl('userv3'), "/").concat(es_fido/* fido */.n.get('customerCode'), "/").concat(es_fido/* fido */.n.get('platformCode'), "/devices/toRevoke");
      return this.fetch(route, {
        method: 'PATCH',
        headers: headers,
        body: {
          deviceId: deviceId
        }
      });
    }
  }, {
    key: "revokeCurrentDevice",
    value: function revokeCurrentDevice() {
      var _ref13 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref13$headers = _ref13.headers,
        headers = _ref13$headers === void 0 ? {} : _ref13$headers;
      var route = "".concat(es_fido/* fido */.n.getBaseUrl('userv3'), "/").concat(es_fido/* fido */.n.get('customerCode'), "/").concat(es_fido/* fido */.n.get('platformCode'), "/devices/revokeCurrentDevice");
      return this.fetch(route, {
        method: 'PATCH',
        headers: headers
      });
    }
  }, {
    key: "getUserSubscriptionType",
    value: function getUserSubscriptionType() {
      var _ref14 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref14$headers = _ref14.headers,
        headers = _ref14$headers === void 0 ? {} : _ref14$headers;
      var route = "".concat(es_fido/* fido */.n.getBaseUrl('userv3'), "/").concat(es_fido/* fido */.n.get('customerCode'), "/").concat(es_fido/* fido */.n.get('platformCode'), "/account/subscriptionType");
      return this.fetch(route, {
        method: 'GET',
        headers: headers
      });
    }
  }, {
    key: "deleteAccount",
    value: function deleteAccount() {
      var _ref15 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref15$headers = _ref15.headers,
        headers = _ref15$headers === void 0 ? {} : _ref15$headers;
      var route = "".concat(es_fido/* fido */.n.getBaseUrl('userv3'), "/").concat(es_fido/* fido */.n.get('customerCode'), "/").concat(es_fido/* fido */.n.get('platformCode'), "/account");
      return this.fetch(route, {
        method: 'DELETE',
        headers: headers
      });
    }
  }]);
  return UserService;
}(fetcherService/* FetcherService */.x);
userService_decorate([userService_monitoring], UserService.prototype, "postNewsletter", null);
userService_decorate([withJWT, userService_monitoring], UserService.prototype, "getNewsletterSubscriptions", null);
userService_decorate([withJWT, userService_monitoring], UserService.prototype, "setNewsletterSubscriptions", null);
userService_decorate([withJWT, userService_monitoring], UserService.prototype, "getLastViewedClips", null);
userService_decorate([withJWT, userService_monitoring], UserService.prototype, "addBookmark", null);
userService_decorate([withJWT, userService_monitoring], UserService.prototype, "removeBookmark", null);
userService_decorate([withJWT, userService_monitoring], UserService.prototype, "getBookmarks", null);
userService_decorate([withJWT, userService_monitoring], UserService.prototype, "getBookmarksIds", null);
userService_decorate([withJWT, userService_monitoring], UserService.prototype, "getUserCustomSegments", null);
userService_decorate([withJWT, userService_monitoring], UserService.prototype, "getUserSettings", null);
userService_decorate([withJWT, userService_monitoring], UserService.prototype, "setUserSettings", null);
userService_decorate([withJWT, userService_monitoring], UserService.prototype, "setVideoSettings", null);
userService_decorate([withJWT, userService_monitoring], UserService.prototype, "setTrackPreferences", null);
userService_decorate([withJWT, userService_monitoring], UserService.prototype, "revokeDevice", null);
userService_decorate([withJWT, userService_monitoring], UserService.prototype, "revokeCurrentDevice", null);
userService_decorate([withJWT, userService_monitoring], UserService.prototype, "getUserSubscriptionType", null);
userService_decorate([withJWT, userService_monitoring], UserService.prototype, "deleteAccount", null);
var userService = new UserService();
;// CONCATENATED MODULE: ./src/modules/pairing/platform/default.js
var hasSSISupport = function hasSSISupport() {
  return false;
};
var rememberSSIDeclined = function rememberSSIDeclined() {};
var shouldSkipSSI = function shouldSkipSSI() {
  return true;
};
;// CONCATENATED MODULE: ./src/logic/pairing/customer/rtlde/pairingProvider.constants.js
var GRANT_TYPE = 'urn:ietf:params:oauth:grant-type:device_code';
var ERROR_AUTHORIZATION_PENDING = 'authorization_pending';
var ERROR_SLOW_DOWN = 'slow_down';
;// CONCATENATED MODULE: ./src/logic/pairing/platform/default.js


var singleSignIn = function singleSignIn() {
  return function () {
    return Promise.resolve(false);
  };
};
var getStatus = function getStatus() {
  return Promise.reject();
};
var exchangePlatformToken = function exchangePlatformToken() {
  return Promise.reject();
};
;// CONCATENATED MODULE: ./src/logic/pairing/customer/rtlde/pairingProvider.actions.js












var fetchOneTimePasscode = function fetchOneTimePasscode() {
  return function () {
    var _ref = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(_, getState) {
      var params, deviceBrand, _yield$oidcService$au, token, verificationURI;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            params = {};
            _context.prev = 1;
            deviceBrand = getDeviceBrand(getState());
            if (deviceBrand) {
              params.boxName = deviceBrand;
            }
            _context.next = 9;
            break;
          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](1);
            throw new Error("Failed deviceBrand getting: ".concat(_context.t0.message));
          case 9:
            _context.next = 11;
            return oidcService_oidcService.authorizeDevice();
          case 11:
            _yield$oidcService$au = _context.sent;
            token = _yield$oidcService$au.user_code;
            verificationURI = _yield$oidcService$au.verification_uri_complete;
            console.log("[PairingProvider.actions] URL: ".concat(verificationURI));
            return _context.abrupt("return", {
              token: token,
              verificationURI: verificationURI
            });
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 6]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
var getProviderPairingStatus = function getProviderPairingStatus() {
  return (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2() {
    var fetchTokensParams, tokens, reason;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          fetchTokensParams = {
            device_code: oidcService_oidcService.getDeviceCode(),
            grant_type: GRANT_TYPE
          };
          _context2.prev = 1;
          _context2.next = 4;
          return oidcService_oidcService.fetchConnectedTokens(fetchTokensParams);
        case 4:
          tokens = _context2.sent;
          if (!tokens) {
            _context2.next = 7;
            break;
          }
          return _context2.abrupt("return", {
            status: PAIRING_STATUS_PAIRED
          });
        case 7:
          _context2.next = 18;
          break;
        case 9:
          _context2.prev = 9;
          _context2.t0 = _context2["catch"](1);
          if (!(typeof _context2.t0.message === 'string')) {
            _context2.next = 17;
            break;
          }
          reason = JSON.parse(_context2.t0.message.replace(/error\s*:\s*/i, ''));
          if (!(reason.error === ERROR_AUTHORIZATION_PENDING)) {
            _context2.next = 15;
            break;
          }
          return _context2.abrupt("return", {
            status: PAIRING_STATUS_PENDING
          });
        case 15:
          if (!(reason.error === ERROR_SLOW_DOWN)) {
            _context2.next = 17;
            break;
          }
          return _context2.abrupt("return", {
            status: PAIRING_STATUS_PENDING,
            slowDown: true
          });
        case 17:
          throw _context2.t0;
        case 18:
          return _context2.abrupt("return", {
            status: PAIRING_STATUS_PENDING
          });
        case 19:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[1, 9]]);
  }));
};
var fetchUser = function fetchUser() {
  return (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee3() {
    var userInfo;
    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return oidcService_oidcService.renewAccessToken();
        case 3:
          _context3.next = 10;
          break;
        case 5:
          _context3.prev = 5;
          _context3.t0 = _context3["catch"](0);
          if (shouldSkipSSI()) {
            _context3.next = 10;
            break;
          }
          _context3.next = 10;
          return singleSignIn();
        case 10:
          _context3.next = 12;
          return oidcService_oidcService.getUserInfo();
        case 12:
          userInfo = _context3.sent;
          if (userInfo && userInfo !== null && userInfo !== void 0 && userInfo.uid) {
            userInfo.firstname = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.preferred_username) || '';
            userInfo.lastname = '';
          }
          return _context3.abrupt("return", userInfo);
        case 15:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 5]]);
  }));
};
var removePairing = function removePairing() {
  return (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee4() {
    return regenerator_default().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          console.log('[OIDC] Revoking current device');
          _context4.next = 4;
          return userService.revokeCurrentDevice();
        case 4:
          _context4.next = 9;
          break;
        case 6:
          _context4.prev = 6;
          _context4.t0 = _context4["catch"](0);
          console.error("[OIDC] Can not revoke current device: ".concat(_context4.t0 ? _context4.t0.message : 'no data'));
        case 9:
          _context4.prev = 9;
          console.log('[OIDC] Logging out from the token provider');
          _context4.next = 13;
          return oidcService_oidcService.logout('ALL');
        case 13:
          _context4.next = 18;
          break;
        case 15:
          _context4.prev = 15;
          _context4.t1 = _context4["catch"](9);
          console.error("[OIDC] Can not log out: ".concat(_context4.t1 ? _context4.t1.message : 'no data'));
        case 18:
          console.log('[OIDC] Clearing local provider tokens');
          oidcService_oidcService.clearTokens();
          console.log('[OIDC] Clearing BAT');
          tokenService.resetUserAndToken();
        case 22:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[0, 6], [9, 15]]);
  }));
};
;// CONCATENATED MODULE: ./src/logic/pairing/unpair.actions.js






var PAIRING_LOGOUT_SUCCESS = 'pairing/LOGOUT_SUCCESS';
var PAIRING_LOGOUT_FAILURE = 'pairing/LOGOUT_FAILURE';
var PAIRING_RESET = 'pairing/RESET';
var logoutSuccess = function logoutSuccess() {
  return {
    type: PAIRING_LOGOUT_SUCCESS
  };
};
var logoutFailure = function logoutFailure(error) {
  return {
    type: PAIRING_LOGOUT_FAILURE,
    error: error
  };
};
var unpair_actions_logout = function logout() {
  return function () {
    var _ref = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(dispatch) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            console.log('[unpair.actions] Removing pairing');
            _context.next = 4;
            return dispatch(removePairing());
          case 4:
            console.log('[unpair.actions] Resetting player state');
            dispatch(player_constants_reset());
            console.log('[unpair.actions] Resetting analytics state');
            setAttributes({
              authentified: 'no',
              userStatus: 'unknown'
            });
            console.log('[unpair.actions] Dispatching logout success');
            dispatch(logoutSuccess());
            _context.next = 15;
            break;
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](0);
            dispatch({
              type: PAIRING_LOGOUT_FAILURE,
              error: _context.t0
            });
          case 15:
            _context.prev = 15;
            console.log('[unpair.actions] Resetting local paring state');
            dispatch({
              type: PAIRING_RESET
            });
            return _context.finish(15);
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 12, 15, 19]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
;// CONCATENATED MODULE: ./src/logic/error/error.actions.js












var error_actions_ERROR = 'error';
var RETRYABLE_ERROR = 'retryable_error';
var error_actions_RETRY = 'retry';
var error_actions_errorAction = function errorAction(level, errorType, message) {
  return function (dispatch) {
    if (!level) {
      console.warn('[Error] Missing error level');
    }
    if (!errorType) {
      console.warn('[Error] Missing error type');
    }
    if (!message) {
      console.warn('[Error] Missing error message');
    }
    console.error("[Error] ".concat(errorType, ": ").concat(message));
    if (level === error_constants_ERROR_LEVELS.FATAL) {
      if (typeof message === 'string' && message.includes('tokenService') && message.includes('498')) {
        console.log('[Error] Authorization issue detected, logging out');
        dispatch(unpair_actions_logout()).finally(function () {
          return navigateToLandingPage();
        });
      } else {
        dispatch(showPopupAction(FATAL_ERROR_POPUP_ID, {}));
      }
    }
    thirdPartyWithLayoutService.sendErrorEvent(new Error("".concat(errorType, " - ").concat(message)));
  };
};
;// CONCATENATED MODULE: ./src/logic/screenSaver/screenSaver.constants.js
var SCREEN_SAVER_DATA = 'screenSaver/SCREEN_SAVER_DATA';
var SCREEN_SAVER_IS_LOCKED = 'screenSaver/IS_LOCKED';
;// CONCATENATED MODULE: ./src/logic/screenSaver/screenSaver.selectors.js

var getScreenSaverData = function getScreenSaverData(state) {
  return get_default()(state, 'screenSaver.screenSaverData');
};
var getScreenSaverIsLocked = function getScreenSaverIsLocked(state) {
  return get_default()(state, 'screenSaver.isLocked');
};
;// CONCATENATED MODULE: ./src/logic/screenSaver/screenSaver.actions.js










var fetchScreenSaverData = function fetchScreenSaverData() {
  var sectionCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'main';
  return function () {
    var _ref = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(dispatch, getState) {
      var state, entity, data;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            state = getState();
            if (!(get_default()(getScreenSaverData(state), 'section') === sectionCode || !getScreensaverFeature(state))) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            entity = {
              entityType: layout_constants/* entities */.jF.frontspace,
              entityId: layout_constants/* frontspaces */.K_.screensaver,
              sectionCode: sectionCode
            };
            data = null;
            _context.prev = 5;
            _context.next = 8;
            return layoutService.fetchByEntity(entity);
          case 8:
            data = _context.sent;
            _context.next = 14;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](5);
            dispatch(error_actions_errorAction(error_constants_ERROR_LEVELS.SILENT, error_constants_ERROR_TYPES.GENERAL, 'Screen Saver fetching error'));
          case 14:
            dispatch({
              type: SCREEN_SAVER_DATA,
              data: data
            });
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[5, 11]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
var setScreenSaverIsLocked = function setScreenSaverIsLocked(isLocked) {
  return {
    type: SCREEN_SAVER_IS_LOCKED,
    data: {
      isLocked: isLocked
    }
  };
};
;// CONCATENATED MODULE: ./lang/languageNames/ISO693-1to3.constants.js
var ISO693_TO_3 = {
  aa: 'aar',
  ab: 'abk',
  ae: 'ave',
  af: 'afr',
  ak: 'aka',
  am: 'amh',
  an: 'arg',
  ar: 'aao',
  as: 'asm',
  av: 'ava',
  ay: 'aym',
  az: 'azb',
  ba: 'bak',
  be: 'bel',
  bg: 'bul',
  bi: 'bis',
  bm: 'bam',
  bn: 'ben',
  bo: 'bod',
  br: 'bre',
  ca: 'cat',
  ce: 'che',
  ch: 'cha',
  co: 'cos',
  cr: 'cre',
  cs: 'ces',
  cu: 'chu',
  cv: 'chv',
  cy: 'cym',
  da: 'dan',
  de: 'deu',
  dv: 'div',
  dz: 'dzo',
  ee: 'ewe',
  el: 'ell',
  en: 'eng',
  eo: 'epo',
  es: 'spa',
  et: 'ekk',
  eu: 'eus',
  fa: 'fas',
  ff: 'ffm',
  fi: 'fin',
  fj: 'fij',
  fo: 'fao',
  fr: 'fra',
  fy: 'fry',
  ga: 'gle',
  gd: 'gla',
  gl: 'glg',
  gn: 'gnw',
  gu: 'guj',
  gv: 'glv',
  ha: 'hau',
  he: 'heb',
  hi: 'hin',
  ho: 'hmo',
  ht: 'hat',
  hu: 'hun',
  hy: 'hye',
  hz: 'her',
  ia: 'ina',
  ie: 'ile',
  ig: 'ibo',
  ii: 'iii',
  ik: 'esi',
  io: 'ido',
  is: 'isl',
  it: 'ita',
  iu: 'ike',
  ja: 'jpn',
  jv: 'jav',
  ka: 'kat',
  kg: 'kng',
  ki: 'kik',
  kj: 'kua',
  kk: 'kaz',
  kl: 'kal',
  km: 'khm',
  kn: 'kan',
  ko: 'kor',
  kr: 'kau',
  ks: 'kas',
  ku: 'ckb',
  kv: 'koi',
  kw: 'cor',
  ky: 'kir',
  la: 'lat',
  lb: 'ltz',
  lg: 'lug',
  li: 'lim',
  ln: 'lin',
  lo: 'lao',
  lt: 'lit',
  lu: 'lub',
  lv: 'lav',
  mg: 'bhr',
  mh: 'mah',
  mi: 'mri',
  mk: 'mkd',
  ml: 'mal',
  mn: 'khk',
  mr: 'mar',
  ms: 'bjn',
  mt: 'mlt',
  my: 'mya',
  na: 'nau',
  nd: 'nde',
  ne: 'dty',
  ng: 'ndo',
  nl: 'nld',
  no: 'nno',
  nr: 'nbl',
  nv: 'nav',
  ny: 'nya',
  oc: 'oci',
  oj: 'ojb',
  om: 'gax',
  or: 'ori',
  os: 'oss',
  pa: 'pan',
  pi: 'pli',
  pl: 'pol',
  ps: 'pbt',
  pt: 'por',
  qu: 'qub',
  rm: 'roh',
  rn: 'run',
  ro: 'ron',
  ru: 'rus',
  rw: 'kin',
  sa: 'san',
  sc: 'sdc',
  sd: 'snd',
  se: 'sme',
  sg: 'sag',
  sh: 'bos',
  si: 'sin',
  sk: 'slk',
  sl: 'slv',
  sm: 'smo',
  sn: 'sna',
  so: 'som',
  sq: 'aae',
  ss: 'ssw',
  st: 'sot',
  su: 'sun',
  sv: 'swe',
  sw: 'swa',
  ta: 'tam',
  te: 'tel',
  tg: 'tgk',
  th: 'tha',
  ti: 'tir',
  tk: 'tuk',
  tl: 'tgl',
  tn: 'tsn',
  to: 'ton',
  tr: 'tur',
  ts: 'tso',
  tt: 'tat',
  ty: 'tah',
  ug: 'uig',
  uk: 'ukr',
  ur: 'urd',
  uz: 'uzb',
  ve: 'ven',
  vi: 'vie',
  vo: 'vol',
  wa: 'wln',
  wo: 'wol',
  xh: 'xho',
  yi: 'ydd',
  yo: 'yor',
  za: 'zch',
  zh: 'cdo',
  zu: 'zul'
};
;// CONCATENATED MODULE: ./src/logic/player/customer/rtlde/player.utils.js













function player_utils_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function player_utils_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? player_utils_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : player_utils_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var DAI_YOSPACE = 'yospace';
var isYospaceAsset = function isYospaceAsset(_ref) {
  var provider = _ref.provider;
  return provider === DAI_YOSPACE;
};
var getDAI = function getDAI(item) {
  var provider = get_default()(item, 'advertising.providers.dai');
  if (!provider) {
    return null;
  }
  return {
    provider: provider,
    targeting: get_default()(item.advertising, "".concat(provider, ".targeting")) || {}
  };
};
var arrangeSources = function arrangeSources(item) {
  var _ref2 = getDAI(item) || {},
    provider = _ref2.provider,
    targeting = _ref2.targeting;
  return (get_default()(item, 'video.assets') || []).filter(Boolean).map(function (source) {
    if (provider !== DAI_YOSPACE) {
      return source;
    }
    if (source.provider === provider) {
      try {
        var url = new URL(source.path);
        if (url.searchParams.get('yo.eb.os') === 'fallback') {
          url.searchParams.delete('yo.eb.os');
        }
        Object.entries(targeting).forEach(function (_ref3) {
          var _ref4 = (0,slicedToArray/* default */.Z)(_ref3, 2),
            key = _ref4[0],
            value = _ref4[1];
          url.searchParams.append(key, value);
        });
        var path = url.toString();
        return player_utils_objectSpread(player_utils_objectSpread({}, source), {}, {
          path: path,
          reference: path
        });
      } catch (error) {
        return source;
      }
    }
    return source;
  }).sort(function (a, b) {
    if (isYospaceAsset(a)) {
      return -1;
    }
    if (isYospaceAsset(b)) {
      return 1;
    }
    return 0;
  });
};
;// CONCATENATED MODULE: ./src/logic/player/player.utils.js







function player_player_utils_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function player_player_utils_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? player_player_utils_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : player_player_utils_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }




var selectNextPlayableSource = function selectNextPlayableSource(_ref) {
  var sources = _ref.sources,
    _ref$hasHardwareDRMSu = _ref.hasHardwareDRMSupport,
    hasHardwareDRMSupport = _ref$hasHardwareDRMSu === void 0 ? false : _ref$hasHardwareDRMSu,
    _ref$startIndex = _ref.startIndex,
    startIndex = _ref$startIndex === void 0 ? 0 : _ref$startIndex;
  return (sources || []).slice(startIndex).findIndex(function (source) {
    if (!source) {
      return false;
    }
    var format = source.format,
      container = source.container;
    if (format === 'dash' || format === 'mp3' || format === 'hls' && container === 'aac') {
      return true;
    }
    if (format === 'dashcenc') {
      var drmType = get_default()(source, 'drm.type', '').toLowerCase();
      var supportedDrmType = hasHardwareDRMSupport ? 'hardware' : 'software';
      return drmType === supportedDrmType;
    }
    return false;
  });
};
var findPlayerBlock = function findPlayerBlock(blocks) {
  if (!blocks) {
    return null;
  }
  return blocks.find(function (_ref2) {
    var templateId = _ref2.templateId;
    return templateId === 'Player';
  });
};
var findCurrentVideoItem = function findCurrentVideoItem(layout, entityId) {
  var blocks = get_default()(layout, 'blocks', []);
  var block = findPlayerBlock(blocks);
  return get_default()(block, 'content.items', []).find(function (item) {
    return get_default()(item, 'video.id', '') === entityId;
  });
};
var findSideGlassBlock = function findSideGlassBlock(layout) {
  var blocks = layout && layout.blocks || [];
  var result = blocks.find(function (block) {
    if (!block) {
      return false;
    }
    return block.blockTemplateId === 'SideGlass';
  });
  if (!result && blocks.length > 1) {
    return blocks[1];
  }
  return result;
};
var getVideoItemImageIdByRole = function getVideoItemImageIdByRole(videoItem, role) {
  return get_default()(videoItem, "video.images.".concat(role, ".id"), '');
};
var player_utils_getJingleImageId = function getJingleImageId(videoItem) {
  return getVideoItemImageIdByRole(videoItem, 'jingle');
};
var player_utils_getAdJingleImageId = function getAdJingleImageId(videoItem) {
  return getVideoItemImageIdByRole(videoItem, 'ad_jingle');
};
var getVideoItemProgramImageId = function getVideoItemProgramImageId(videoItem) {
  return get_default()(videoItem, 'image.id', '');
};
var isPlayerLayout = function isPlayerLayout(layout) {
  var _ref3 = layout ? layout.entity : {},
    type = _ref3.type;
  return type === layout_constants/* entities */.jF.video || type === layout_constants/* entities */.jF.live || type === layout_constants/* entities */.jF.audio || type === layout_constants/* entities */.jF.radio;
};
var toISO693LanguageCode = function toISO693LanguageCode(code) {
  if (!code) {
    return '';
  }
  if (code.length === 3) {
    return code;
  }
  return ISO693_TO_3[code] || '';
};
var parseTrack = function parseTrack(track) {
  return track ? player_player_utils_objectSpread(player_player_utils_objectSpread({}, track), {}, {
    language: toISO693LanguageCode(track.language)
  }) : null;
};
var isForcedSubtitlesTrack = function isForcedSubtitlesTrack(track) {
  return Array.isArray(track.roles) ? track.roles.includes('forced_subtitle') : false;
};
var findForcedSubtitles = function findForcedSubtitles(tracks, language) {
  return tracks.filter(isForcedSubtitlesTrack).find(function (track) {
    return track.language === language;
  });
};
var findPreferredAudioTrack = function findPreferredAudioTrack(tracks, preference) {
  return preference.audioDescription ? tracks.find(function (_ref4) {
    var language = _ref4.language,
      roles = _ref4.roles;
    return Array.isArray(roles) && roles.includes('alternate') && language === preference.language;
  }) : tracks.find(function (_ref5) {
    var language = _ref5.language;
    return language === preference.language;
  });
};
var findMatchingAudioTrack = function findMatchingAudioTrack(tracks, preference, originalLanguage) {
  if (!tracks) {
    return null;
  }
  return preference && findPreferredAudioTrack(tracks, preference) || tracks.find(function (_ref6) {
    var language = _ref6.language;
    return language === originalLanguage;
  }) || tracks[0];
};
var findMatchingSubtitlesTrack = function findMatchingSubtitlesTrack(tracks, preference) {
  if (!tracks || !preference) {
    return null;
  }
  return preference.role ? tracks.find(function (_ref7) {
    var language = _ref7.language,
      roles = _ref7.roles;
    if (language !== preference.language || !Array.isArray(roles)) {
      return false;
    }
    switch (preference.role) {
      case 'sdh':
        return roles.includes('caption');
      case 'standard':
        return roles.length === 1 && roles.includes('subtitle');
      default:
        return false;
    }
  }) : tracks.find(function (_ref8) {
    var language = _ref8.language;
    return language === preference.language;
  });
};
var layoutAudioTrackToUsersPreference = function layoutAudioTrackToUsersPreference(track) {
  return {
    audioLanguage: ISO693_TO_3[track.language] || track.language,
    audioDescription: track.audioDescription || false
  };
};
var layoutTextTrackToUsersPreference = function layoutTextTrackToUsersPreference(track) {
  return {
    subtitleLanguage: ISO693_TO_3[track.language] || track.language,
    role: track.role || 'standard'
  };
};
var audioTrackToPreference = function audioTrackToPreference(track) {
  return {
    language: ISO693_TO_3[track.language] || track.language,
    audioDescription: track.roles ? track.roles.includes('alternate') : false
  };
};
var subtitlesTrackToPreference = function subtitlesTrackToPreference(track) {
  return {
    language: ISO693_TO_3[track.language] || track.language,
    role: track.roles && track.roles.includes('caption') ? 'sdh' : 'standard'
  };
};
var audioPreferenceToManifestTrack = function audioPreferenceToManifestTrack(preference) {
  return preference ? {
    language: preference.language,
    role: preference.audioDescription ? 'alternate' : 'main'
  } : undefined;
};
var textPreferenceToManifestTrack = function textPreferenceToManifestTrack(preference) {
  return preference ? {
    language: preference.language,
    role: preference.role === 'sdh' ? 'caption' : 'main'
  } : undefined;
};
;// CONCATENATED MODULE: ./src/modules/tornado/jumbotron/trailer/trailer.constants.js
var VIDEO_PLAYING_SIGNAL = 'playing';
var VIDEO_ENDED_SIGNAL = 'ended';
;// CONCATENATED MODULE: ./src/modules/tornado/jumbotron/trailer/trailer.component.js

















function trailer_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function trailer_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? trailer_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : trailer_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function trailer_component_createSuper(t) { var r = trailer_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function trailer_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (trailer_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }










var TrailerPlayer = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(TrailerPlayer, _Lightning$Component);
  var _super = trailer_component_createSuper(TrailerPlayer);
  function TrailerPlayer() {
    (0,classCallCheck/* default */.Z)(this, TrailerPlayer);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(TrailerPlayer, [{
    key: "_construct",
    value: function _construct() {
      this._readyToPlay = false;
      this._videoId = null;
    }
  }, {
    key: "_attach",
    value: function _attach() {
      this._readyToPlay = true;
      if (this._videoId) {
        this._loadVideo(this._videoId);
      }
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this._readyToPlay = false;
      this._destroyPlayer();
      this._videoId = null;
    }
  }, {
    key: "asset",
    set: function set(value) {
      if (this._videoId !== value) {
        if (this._videoId) {
          this._destroyPlayer();
        }
        if (this._readyToPlay) {
          this._loadVideo(value);
        }
        this._videoId = value;
      }
    }
  }, {
    key: "_loadVideo",
    value: function () {
      var _loadVideo2 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(videoId) {
        var _yield$Promise$all, _yield$Promise$all2, layout, Engine, sources, index, _createRenderers, videoRef, containerRef, subtitlesContainer, config;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!videoId || !src.featureFlipping.player_trailer)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return Promise.all([layoutService.fetchByEntity({
                entityType: 'video',
                entityId: videoId,
                sectionCode: 'main'
              }), getPlayerInstance()]);
            case 4:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = (0,slicedToArray/* default */.Z)(_yield$Promise$all, 2);
              layout = _yield$Promise$all2[0];
              Engine = _yield$Promise$all2[1].Engine;
              if (this._readyToPlay) {
                _context.next = 10;
                break;
              }
              return _context.abrupt("return");
            case 10:
              sources = get_default()(layout, 'blocks[0].content.items[0].itemContent.video.assets');
              index = selectNextPlayableSource({
                sources: sources
              });
              _createRenderers = createRenderers(), videoRef = _createRenderers.video, containerRef = _createRenderers.container, subtitlesContainer = _createRenderers.subtitles;
              if (!(!sources[index] || !sources[index].reference)) {
                _context.next = 15;
                break;
              }
              return _context.abrupt("return");
            case 15:
              _context.next = 17;
              return enhancePlayerConfig({
                dispatcher: this.playerDispatcher.bind(this),
                drm: {
                  settings: src.video.drm,
                  token: {
                    handler: function handler() {
                      return upFrontTokenService.getVideoToken({
                        videoId: videoId,
                        service: src.defaultService
                      }).then(function (value) {
                        return {
                          value: value
                        };
                      });
                    }
                  }
                },
                element: videoRef,
                mute: !src.featureFlipping.player_trailer_sound,
                subtitlesContainer: subtitlesContainer
              });
            case 17:
              config = _context.sent;
              this._player = new Engine();
              this._player.init(config);
              this._player.start(trailer_component_objectSpread(trailer_component_objectSpread({}, sources[index]), {}, {
                shouldAutoPlay: true
              }));
              this._container = containerRef;
            case 22:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function _loadVideo(_x) {
        return _loadVideo2.apply(this, arguments);
      }
      return _loadVideo;
    }()
  }, {
    key: "_destroyPlayer",
    value: function _destroyPlayer() {
      if (this._player) {
        this._player.reset();
        this._player = null;
      }
      if (this._container) {
        while (this._container.firstChild) {
          this._container.removeChild(this._container.lastChild);
        }
        if (this._container.parentNode) {
          this._container.parentNode.removeChild(this._container);
        }
      }
      if (lightningjs_redux.dispatch) {
        lightningjs_redux.dispatch(setScreenSaverIsLocked(false));
      }
      this._container = null;
    }
  }, {
    key: "play",
    value: function play(startTime) {
      if (!this._player) {
        return;
      }
      if (Number.isFinite(startTime)) {
        this._player.seek(startTime);
      }
      this._player.play();
    }
  }, {
    key: "pause",
    value: function pause() {
      if (!this._player) {
        return;
      }
      if (lightningjs_redux.dispatch) {
        lightningjs_redux.dispatch(setScreenSaverIsLocked(false));
      }
      this._player.pause();
    }
  }, {
    key: "playerDispatcher",
    value: function playerDispatcher(event, payload) {
      if (event === VIDEO_PLAYING_SIGNAL) {
        if (lightningjs_redux.dispatch) {
          lightningjs_redux.dispatch(setScreenSaverIsLocked(true));
        }
        this.signal(VIDEO_PLAYING_SIGNAL);
      } else if (event === VIDEO_ENDED_SIGNAL) {
        this.signal(VIDEO_ENDED_SIGNAL);
      }
    }
  }]);
  return TrailerPlayer;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/tornado/jumbotron/customer/default/jumbotron.component.js












function jumbotron_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function jumbotron_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? jumbotron_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : jumbotron_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function jumbotron_component_createSuper(t) { var r = jumbotron_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function jumbotron_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (jumbotron_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }



























var Jumbotron = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Jumbotron, _Lightning$Component);
  var _super = jumbotron_component_createSuper(Jumbotron);
  function Jumbotron() {
    (0,classCallCheck/* default */.Z)(this, Jumbotron);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Jumbotron, [{
    key: "_construct",
    value: function _construct() {
      this._buttons = [];
      this._index = 0;
      this._style = jumbotron_style_defaultContext;
      this._showingTrailer = false;
    }
  }, {
    key: "_attach",
    value: function _attach() {
      this._trailerStarted = false;
      this._trailerComplete = false;
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this.tag('Background').removeAllListeners('txLoaded');
      if (this._hideBackgroundTimeout) {
        clearTimeout(this._hideBackgroundTimeout);
      }
      this._showingTrailer = false;
      this._focused = null;
    }
  }, {
    key: "item",
    get: function get() {
      return this._item;
    },
    set: function set(_ref) {
      var _this = this;
      var content = _ref.content,
        blockIndex = _ref.blockIndex,
        itemIndex = _ref.itemIndex,
        config = _ref.config,
        _ref$colorScheme = _ref.colorScheme,
        colorScheme = _ref$colorScheme === void 0 ? jumbotron_style_defaultContext.colorMode : _ref$colorScheme;
      var currentImage = get_default()(this._item, 'image.src');
      this._item = content;
      var screenSize = this._style.screenSize;
      var textColor = jumbotron_style_colors.text[colorScheme];
      var _this$_item = this._item,
        image = _this$_item.image,
        title = _this$_item.title,
        logo = _this$_item.logo,
        servicePicto = _this$_item.servicePicto,
        extraTitle = _this$_item.extraTitle,
        description = _this$_item.description,
        progress = _this$_item.progress,
        action = _this$_item.action,
        extraDetails = _this$_item.extraDetails,
        csaPicto = _this$_item.csaPicto,
        bookmark = _this$_item.bookmark,
        secondaryActions = _this$_item.secondaryActions,
        incentives = _this$_item.incentives;
      var contentAdvisoryPictos = get_default()(this._item, 'contentAdvisory.pictos', []);
      var isIconsVisible = contentAdvisoryPictos.some(function (value) {
        return Boolean(value);
      });
      var logoSrc = logo && logo.src || '';
      var isLogoVisible = Boolean(logoSrc);
      var serviceIconVisible = isVisibleIcon(servicePicto);
      var isDetailsRowVisible = SHOW_EXTRA_DETAILS && Boolean(extraDetails) || isVisibleIcon(csaPicto);
      var isBasicIconVisible = Boolean(csaPicto);
      var incentiveLines = getLinesCount(incentives);
      this._trailer = secondaryActions[1];
      var trailerPicto = get_default()(this._trailer, 'picto', TRAILER_ICON);
      var trailerLabel = get_default()(this._trailer, 'label', t('trailer.actionLabel'));
      var trailerId = get_default()(this._trailer, 'target.value_layout.id');
      var patch = {
        Trailer: {
          asset: trailerId
        },
        FlexContainer: {
          Logo: {
            visible: isLogoVisible,
            texture: jumbotron_component_objectSpread(jumbotron_component_objectSpread({}, contain(logoSrc, rtlde_jumbotron_constants_LOGO_DIMENSIONS[screenSize].width, rtlde_jumbotron_constants_LOGO_DIMENSIONS[screenSize].height)), {}, {
              hasAlpha: true
            })
          },
          Incentive: {
            visible: incentiveLines > 0,
            data: {
              linesCount: incentiveLines,
              w: default_jumbotron_style_FLEX_CONTAINER_WIDTH[screenSize],
              incentives: incentives,
              colorMode: this._style.colorMode
            }
          },
          Title: {
            visible: !isLogoVisible && Boolean(title),
            color: textColor,
            text: {
              text: title,
              wordWrapWidth: default_jumbotron_style_FLEX_CONTAINER_WIDTH[screenSize]
            }
          },
          ServiceIcon: {
            visible: SHOW_SERVICE_ICON && serviceIconVisible,
            iconData: {
              picto: servicePicto,
              viewBox: jumbotron_style_getServiceIconViewBox(screenSize)
            }
          },
          ExtraTitle: makeTextPatch(extraTitle, default_jumbotron_style_FLEX_CONTAINER_WIDTH[screenSize], textColor),
          Description: makeTextPatch(description, default_jumbotron_style_FLEX_CONTAINER_WIDTH[screenSize], textColor),
          ProgressBar: makeProgressBarProperties(progress),
          CTAFlexContainer: {
            PlayButton: {
              visible: isVisibleCTA(action),
              label: get_default()(action, 'label', ''),
              picto: get_default()(action, 'picto', '')
            },
            MyListButton: {
              visible: Boolean(bookmark),
              label: t('bookmarks.actionLabel'),
              item: bookmark,
              blockIndex: blockIndex,
              itemIndex: itemIndex
            },
            InfoButton: {
              visible: isVisibleInformationButton(this._item),
              label: t('contentInfo.actionLabel')
            },
            TrailerButton: {
              visible: Boolean(this._trailer && this._trailerComplete),
              picto: trailerPicto,
              label: trailerLabel
            }
          },
          DetailsRow: {
            visible: isDetailsRowVisible,
            ExtraDetails: jumbotron_component_objectSpread({}, makeTextPatch(SHOW_EXTRA_DETAILS ? extraDetails : '', default_jumbotron_style_FLEX_CONTAINER_WIDTH[screenSize], textColor)),
            BasicIcon: {
              visible: isBasicIconVisible,
              iconData: {
                picto: csaPicto,
                viewBox: jumbotron_style_getBasicIconViewBox(screenSize)
              }
            },
            IconsRow: {
              visible: isIconsVisible
            }
          }
        },
        ProgramInformation: {
          data: this._item
        }
      };
      if (currentImage !== image.src) {
        this.tag('Background').once('txLoaded', function () {
          _this.tag('Background').setSmooth('alpha', 1);
        });
        patch.Background = {
          texture: cover(image.src, config.w, config.h),
          alpha: this.stage.textureManager.textureSourceHashmap.has(image.src) ? 1 : 0.0001
        };
      }
      this.patch(patch);
      if (isIconsVisible) {
        this.tag('IconsRow').children = contentAdvisoryPictos.map(function (picto) {
          return jumbotron_component_objectSpread({
            type: Icon
          }, jumbotron_style_getContentAdvisoryIconStyle(picto, _this._style.screenSize));
        });
      }
      var items = this.tag('CTAFlexContainer').children;
      this._buttons = items.filter(function (item) {
        return item.visible;
      });
      this._setIndex();
    }
  }, {
    key: "contentPadding",
    set: function set(value) {
      this.tag('FlexContainer').x = Number.isFinite(value) ? value : 0;
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this._focused;
    }
  }, {
    key: "_focus",
    value: function _focus() {
      var _this2 = this;
      this._isFocused = true;
      if (this._trailerComplete) {
        return;
      }
      this._hideBackgroundTimeout = setTimeout(function () {
        _this2.tag('Trailer').play();
      }, 150);
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this._isFocused = false;
      this.tag('Trailer').pause();
      this._hideTrailer();
    }
  }, {
    key: "_showTrailer",
    value: function _showTrailer() {
      if (!this._isFocused) {
        return;
      }
      this._showingTrailer = true;
      this.tag('Background').setSmooth('alpha', 0.0001);
      this.signal(HIDE_BACKGROUND_SIGNAL);
    }
  }, {
    key: "_hideTrailer",
    value: function _hideTrailer() {
      this._showingTrailer = false;
      this.tag('Background').setSmooth('alpha', 1);
      this.signal(SHOW_BACKGROUND_SIGNAL);
    }
  }, {
    key: "_handleRight",
    value: function _handleRight() {
      if (this._index < this._buttons.length - 1) {
        this._setIndex(this._index + 1);
        return true;
      }
      return false;
    }
  }, {
    key: "_handleLeft",
    value: function _handleLeft() {
      if (this._index > 0) {
        this._setIndex(this._index - 1);
        return true;
      }
      return false;
    }
  }, {
    key: "_setIndex",
    value: function _setIndex() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._index;
      this._index = index;
      this._focused = this._buttons[this._index];
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      if (this._focused === this.tag('InfoButton')) {
        this._showProgramInformation();
        sendEvent({
          key: 'pressMoreInfo'
        });
      } else if (this._focused === this.tag('TrailerButton')) {
        this.signal(SELECTED_SIGNAL, {
          id: 'trailer',
          action: this._trailer
        });
      } else {
        this.signal(SELECTED_SIGNAL, this._item);
      }
    }
  }, {
    key: "_showProgramInformation",
    value: function _showProgramInformation() {
      this.zIndex = jumbotron_constants_Z_INDEX_WITH_PROGRAM_INFO;
      this.tag('ProgramInformation').patch(getProgramInformationFocusedStyle());
      this._focused = this.tag('ProgramInformation');
    }
  }, {
    key: "_handleProgramInformationClose",
    value: function _handleProgramInformationClose() {
      this.zIndex = jumbotron_constants_Z_INDEX_NORMAL;
      this.tag('ProgramInformation').patch(getProgramInformationUnFocusedStyle());
      this._setIndex();
      sendEvent({
        key: 'closeMoreInfo'
      });
    }
  }, {
    key: "_handleVideoPlaying",
    value: function _handleVideoPlaying() {
      this._trailerStarted = true;
      this._trailerComplete = false;
      this._showTrailer();
    }
  }, {
    key: "_handleVideoEnded",
    value: function _handleVideoEnded() {
      this._trailerComplete = true;
      this._trailerStarted = false;
      this._hideTrailer();
      this.tag('TrailerButton').visible = true;
      this._buttons = this.tag('CTAFlexContainer').children.filter(function (item) {
        return item.visible;
      });
    }
  }], [{
    key: "_template",
    value: function _template() {
      var _signals;
      return merge_default()({
        Background: {},
        Gradient: {
          type: HeroOverlay,
          w: identity,
          h: identity
        },
        Trailer: {
          type: TrailerPlayer,
          signals: (_signals = {}, (0,defineProperty/* default */.Z)(_signals, VIDEO_PLAYING_SIGNAL, '_handleVideoPlaying'), (0,defineProperty/* default */.Z)(_signals, VIDEO_ENDED_SIGNAL, '_handleVideoEnded'), _signals)
        },
        FlexContainer: {
          Logo: {},
          Incentive: {
            type: Incentive
          },
          Title: {},
          ServiceIcon: {
            type: Icon
          },
          ExtraTitle: {},
          Description: {},
          ProgressBar: {
            type: Progress
          },
          CTAFlexContainer: {
            PlayButton: {
              type: CallToAction
            },
            MyListButton: {
              type: MyListButtonSecondary,
              passSignals: (0,defineProperty/* default */.Z)({}, SELECTED_SIGNAL, true)
            },
            InfoButton: {
              type: CallToAction
            },
            TrailerButton: {
              type: CallToAction
            }
          },
          DetailsRow: {
            ExtraDetails: {},
            BasicIcon: {
              type: Icon
            },
            IconsRow: {}
          }
        },
        ProgramInformation: {
          type: ProgramInformation,
          signals: (0,defineProperty/* default */.Z)({}, PROGRAM_INFORMATION_CLOSED_SIGNAL, '_handleProgramInformationClose')
        }
      }, jumbotron_style_getInitialStyle());
    }
  }, {
    key: "getBottomMargin",
    value: function getBottomMargin(_ref2) {
      var screenSize = _ref2.screenSize;
      return LAYOUT_BOTTOM_MARGIN[screenSize];
    }
  }]);
  return Jumbotron;
}(src_Lightning.Component);

Jumbotron.Templates = jumbotron_constants_templates;
Jumbotron.Sizes = jumbotron_constants_sizes;
Jumbotron.ImageOptions = jumbotron_constants_imageOptions;
;// CONCATENATED MODULE: ./src/modules/tornado/jumbotron/jumbotron.component.js

/* harmony default export */ const jumbotron_component = (Jumbotron);
;// CONCATENATED MODULE: ./src/modules/tornado/podcast-information/top/podcastInformationTop.style.js

var podcastInformationTop_style_LOGO_DIMENSIONS, podcastInformationTop_style_TEXT_WIDTH, podcastInformationTop_style_GAP;
function podcastInformationTop_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function podcastInformationTop_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? podcastInformationTop_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : podcastInformationTop_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





var podcastInformationTop_style_defaultContext = makeDefaultStylingContext();
var top_podcastInformationTop_style_LOGO_DIMENSIONS = (podcastInformationTop_style_LOGO_DIMENSIONS = {}, (0,defineProperty/* default */.Z)(podcastInformationTop_style_LOGO_DIMENSIONS, HD, {
  width: SCREEN_WIDTH[HD] - safetyMargins.horizontal[HD] * 2,
  height: 150
}), (0,defineProperty/* default */.Z)(podcastInformationTop_style_LOGO_DIMENSIONS, FULL_HD, {
  width: SCREEN_WIDTH[FULL_HD] - safetyMargins.horizontal[FULL_HD] * 2,
  height: 214
}), podcastInformationTop_style_LOGO_DIMENSIONS);
var top_podcastInformationTop_style_TEXT_WIDTH = (podcastInformationTop_style_TEXT_WIDTH = {}, (0,defineProperty/* default */.Z)(podcastInformationTop_style_TEXT_WIDTH, HD, SCREEN_WIDTH[HD] - safetyMargins.horizontal[HD] * 2), (0,defineProperty/* default */.Z)(podcastInformationTop_style_TEXT_WIDTH, FULL_HD, SCREEN_WIDTH[FULL_HD] - safetyMargins.horizontal[FULL_HD] * 2), podcastInformationTop_style_TEXT_WIDTH);
var top_podcastInformationTop_style_GAP = (podcastInformationTop_style_GAP = {}, (0,defineProperty/* default */.Z)(podcastInformationTop_style_GAP, HD, 40), (0,defineProperty/* default */.Z)(podcastInformationTop_style_GAP, FULL_HD, 40), podcastInformationTop_style_GAP);
var podcastInformationTop_style_colors = {
  text: makeThemeColor(PRIMARY)
};
var podcastInformationTop_style_getTitleFont = function getTitleFont(screenSize) {
  return src_getFont(constants_FONT.PARIS_3, screenSize);
};
var podcastInformationTop_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : podcastInformationTop_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  return {
    Logo: {
      flexItem: {
        marginBottom: top_podcastInformationTop_style_GAP[screenSize]
      }
    },
    Title: {
      color: podcastInformationTop_style_colors.text[colorMode],
      text: podcastInformationTop_style_objectSpread(podcastInformationTop_style_objectSpread({}, podcastInformationTop_style_getTitleFont(screenSize)), {}, {
        maxLinesSuffix: '...',
        wordWrapWidth: top_podcastInformationTop_style_TEXT_WIDTH[screenSize],
        maxLines: 2
      })
    },
    flex: {
      direction: 'column'
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/podcast-information/top/podcastInformationTop.component.js





function podcastInformationTop_component_createSuper(t) { var r = podcastInformationTop_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function podcastInformationTop_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (podcastInformationTop_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }




var PodcastInformationTop = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(PodcastInformationTop, _Lightning$Component);
  var _super = podcastInformationTop_component_createSuper(PodcastInformationTop);
  function PodcastInformationTop() {
    (0,classCallCheck/* default */.Z)(this, PodcastInformationTop);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(PodcastInformationTop, [{
    key: "_construct",
    value: function _construct() {
      this._style = podcastInformationTop_style_defaultContext;
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this.tag('Title').removeAllListeners('txLoaded');
    }
  }, {
    key: "data",
    set: function set(content) {
      var _this = this;
      if (!content) {
        return;
      }
      var screenSize = this._style.screenSize;
      var logo = content.image;
      var logoSrc = logo && logo.src || '';
      var height = top_podcastInformationTop_style_GAP[screenSize] + (logoSrc ? top_podcastInformationTop_style_LOGO_DIMENSIONS[screenSize].height : 0) + (content.title ? top_podcastInformationTop_style_GAP[screenSize] : 0);
      if (content.title) {
        this.tag('Title').once('txLoaded', function (texture) {
          _this.h = height + texture.source.h;
          _this.emit('txLoaded');
        });
      } else {
        this.h = height;
        this.emit('txLoaded');
      }
      this.patch({
        Logo: {
          visible: Boolean(logoSrc),
          texture: contain(logoSrc, top_podcastInformationTop_style_LOGO_DIMENSIONS[screenSize].width, top_podcastInformationTop_style_LOGO_DIMENSIONS[screenSize].height)
        },
        Title: {
          visible: Boolean(content.title),
          text: {
            text: content.title
          }
        }
      });
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Logo: {},
        Title: {}
      }, podcastInformationTop_style_getInitialStyle());
    }
  }]);
  return PodcastInformationTop;
}(src_Lightning.Component);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/chunk.js
var chunk = __webpack_require__(41255);
var chunk_default = /*#__PURE__*/__webpack_require__.n(chunk);
;// CONCATENATED MODULE: ./src/modules/tornado/podcast-information/entry/podcastInformationEntry.style.js

function podcastInformationEntry_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function podcastInformationEntry_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? podcastInformationEntry_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : podcastInformationEntry_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



var podcastInformationEntry_style_defaultContext = makeDefaultStylingContext();
var podcastInformationEntry_style_colors = {
  text: makeThemeColor(PRIMARY)
};
var podcastInformationEntry_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : podcastInformationEntry_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  return {
    Title: {
      alpha: 0.8,
      color: podcastInformationEntry_style_colors.text[colorMode],
      text: podcastInformationEntry_style_objectSpread(podcastInformationEntry_style_objectSpread({}, src_getFont(constants_FONT.BERLIN_1, screenSize)), {}, {
        maxLinesSuffix: '...',
        maxLines: 1
      })
    },
    Details: {
      color: podcastInformationEntry_style_colors.text[colorMode],
      text: podcastInformationEntry_style_objectSpread(podcastInformationEntry_style_objectSpread({}, src_getFont(constants_FONT.OTTAWA_1, screenSize)), {}, {
        maxLinesSuffix: '...',
        maxLines: 3
      })
    },
    flex: {
      direction: 'column'
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/podcast-information/entry/podcastInformationEntry.component.js





function podcastInformationEntry_component_createSuper(t) { var r = podcastInformationEntry_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function podcastInformationEntry_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (podcastInformationEntry_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }



var PodcastInformationEntry = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(PodcastInformationEntry, _Lightning$Component);
  var _super = podcastInformationEntry_component_createSuper(PodcastInformationEntry);
  function PodcastInformationEntry() {
    (0,classCallCheck/* default */.Z)(this, PodcastInformationEntry);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(PodcastInformationEntry, [{
    key: "_construct",
    value: function _construct() {
      this._style = podcastInformationEntry_style_defaultContext;
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this.tag('Title').removeAllListeners('txLoaded');
      this.tag('Details').removeAllListeners('txLoaded');
    }
  }, {
    key: "data",
    set: function set(content) {
      if (!content) {
        return;
      }
      this.patch({
        Title: {
          visible: Boolean(content.title),
          text: {
            text: content.title,
            wordWrapWidth: content.w
          }
        },
        Details: {
          visible: Boolean(content.details),
          text: {
            text: content.details,
            wordWrapWidth: content.w
          }
        }
      });
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Title: {},
        Details: {}
      }, podcastInformationEntry_style_getInitialStyle());
    }
  }]);
  return PodcastInformationEntry;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/tornado/podcast-information/description/podcastDescription.style.js

var podcastDescription_style_GAP, _ENTRIES_GAP, _SEPARATOR_HEIGHT;
function podcastDescription_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function podcastDescription_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? podcastDescription_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : podcastDescription_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }




var podcastDescription_style_defaultContext = makeDefaultStylingContext();
var description_podcastDescription_style_GAP = (podcastDescription_style_GAP = {}, (0,defineProperty/* default */.Z)(podcastDescription_style_GAP, HD, 24), (0,defineProperty/* default */.Z)(podcastDescription_style_GAP, FULL_HD, 40), podcastDescription_style_GAP);
var ENTRIES_GAP = (_ENTRIES_GAP = {}, (0,defineProperty/* default */.Z)(_ENTRIES_GAP, HD, 24), (0,defineProperty/* default */.Z)(_ENTRIES_GAP, FULL_HD, 24), _ENTRIES_GAP);
var SEPARATOR_HEIGHT = (_SEPARATOR_HEIGHT = {}, (0,defineProperty/* default */.Z)(_SEPARATOR_HEIGHT, HD, 2), (0,defineProperty/* default */.Z)(_SEPARATOR_HEIGHT, FULL_HD, 4), _SEPARATOR_HEIGHT);
var podcastDescription_style_colors = {
  description: makeThemeColor(PRIMARY),
  separator: makeThemeColor(PRIMARY, 0.3)
};
var podcastDescription_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : podcastDescription_style_defaultContext,
    screenSize = _ref.screenSize,
    colorMode = _ref.colorMode;
  var descriptionFont = src_getFont(constants_FONT.OTTAWA_1, screenSize);
  return {
    flex: {
      direction: 'column'
    },
    Description: {
      flexItem: {
        marginBottom: description_podcastDescription_style_GAP[screenSize]
      },
      text: podcastDescription_style_objectSpread(podcastDescription_style_objectSpread({}, descriptionFont), {}, {
        maxLinesSuffix: '...'
      })
    },
    Separator: {
      flexItem: {
        marginBottom: description_podcastDescription_style_GAP[screenSize]
      },
      rect: true,
      color: podcastDescription_style_colors.separator[colorMode],
      h: SEPARATOR_HEIGHT[screenSize]
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/podcast-information/description/podcastDescription.component.js











function podcastDescription_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function podcastDescription_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? podcastDescription_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : podcastDescription_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function podcastDescription_component_createSuper(t) { var r = podcastDescription_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function podcastDescription_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (podcastDescription_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }






var PodcastDescription = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(PodcastDescription, _Lightning$Component);
  var _super = podcastDescription_component_createSuper(PodcastDescription);
  function PodcastDescription() {
    (0,classCallCheck/* default */.Z)(this, PodcastDescription);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(PodcastDescription, [{
    key: "_construct",
    value: function _construct() {
      this._style = podcastDescription_style_defaultContext;
    }
  }, {
    key: "_attach",
    value: function _attach() {
      var _this = this;
      this.onUpdate = function () {
        if (_this._emittedHeight !== _this.finalH) {
          _this._emittedHeight = _this.finalH;
          _this.emit('txLoaded');
        }
      };
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this.onUpdate = undefined;
      this._emittedHeight = 0;
    }
  }, {
    key: "data",
    set: function set(value) {
      var description = value.description;
      var _this$_style = this._style,
        colorMode = _this$_style.colorMode,
        screenSize = _this$_style.screenSize;
      var w = this.w;
      var additionalMetadata = (value.additionalMetadata || []).filter(function (item) {
        return Boolean(item.details);
      });
      var gap = ENTRIES_GAP[screenSize];
      var columnWidth = Math.round(w / 2) - gap;
      var rows = chunk_default()(additionalMetadata, 2).map(function (chunk, index) {
        return {
          ref: "Row".concat(index),
          flex: {
            direction: 'row'
          },
          flexItem: {
            marginBottom: gap
          },
          w: w,
          children: chunk.map(function (_ref) {
            var title = _ref.title,
              details = _ref.details;
            return {
              type: PodcastInformationEntry,
              data: {
                title: title,
                details: details,
                w: columnWidth
              },
              w: columnWidth,
              flexItem: {
                marginRight: gap
              }
            };
          })
        };
      });
      this.patch(podcastDescription_component_objectSpread({
        Description: makeTextPatch(description, w, podcastDescription_style_colors.description[colorMode]),
        Separator: {
          w: w,
          visible: Boolean(additionalMetadata.length)
        }
      }, rows.reduce(function (result, item) {
        return podcastDescription_component_objectSpread(podcastDescription_component_objectSpread({}, result), {}, (0,defineProperty/* default */.Z)({}, item.ref, item));
      }, {})));
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Description: {},
        Separator: {}
      }, podcastDescription_style_getInitialStyle());
    }
  }]);
  return PodcastDescription;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/tornado/podcast-information/podcastInformation.style.js

var podcastInformation_style_TEXT_WIDTH;




var podcastInformation_style_defaultContext = makeDefaultStylingContext();
var podcast_information_podcastInformation_style_TEXT_WIDTH = (podcastInformation_style_TEXT_WIDTH = {}, (0,defineProperty/* default */.Z)(podcastInformation_style_TEXT_WIDTH, HD, SCREEN_WIDTH[HD] - safetyMargins.horizontal[HD] * 2), (0,defineProperty/* default */.Z)(podcastInformation_style_TEXT_WIDTH, FULL_HD, SCREEN_WIDTH[FULL_HD] - safetyMargins.horizontal[FULL_HD] * 2), podcastInformation_style_TEXT_WIDTH);
var podcastInformation_style_colors = {
  background: makeThemeColor(TERTIARY)
};
var podcastInformation_style_getContainerHeight = function getContainerHeight(screenSize) {
  return sizes_SCREEN_HEIGHT[screenSize] - safetyMargins.vertical[screenSize] * 2;
};
var podcastInformation_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : podcastInformation_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  var containerHeight = podcastInformation_style_getContainerHeight(screenSize);
  return {
    alpha: 0,
    w: SCREEN_WIDTH[screenSize],
    h: sizes_SCREEN_HEIGHT[screenSize],
    Overlay: {
      w: SCREEN_WIDTH[screenSize],
      h: sizes_SCREEN_HEIGHT[screenSize],
      color: podcastInformation_style_colors.background[colorMode]
    },
    ContentContainer: {
      h: containerHeight,
      x: safetyMargins.horizontal[screenSize],
      y: safetyMargins.vertical[screenSize],
      Top: {},
      Scroll: {
        w: podcast_information_podcastInformation_style_TEXT_WIDTH[screenSize],
        h: containerHeight,
        y: 0
      }
    }
  };
};
var podcastInformation_style_getProgramInformationFocusedStyle = function getProgramInformationFocusedStyle() {
  return {
    smooth: {
      alpha: 1
    }
  };
};
var podcastInformation_style_getProgramInformationUnFocusedStyle = function getProgramInformationUnFocusedStyle() {
  return {
    smooth: {
      alpha: 0
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/podcast-information/podcastInformation.constants.js
var podcastInformation_constants_PROGRAM_INFORMATION_CLOSED_SIGNAL = 'programInformationClosed';
;// CONCATENATED MODULE: ./src/modules/tornado/podcast-information/podcastInformation.component.js





function podcastInformation_component_createSuper(t) { var r = podcastInformation_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function podcastInformation_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (podcastInformation_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }







var PodcastInformation = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(PodcastInformation, _Lightning$Component);
  var _super = podcastInformation_component_createSuper(PodcastInformation);
  function PodcastInformation() {
    (0,classCallCheck/* default */.Z)(this, PodcastInformation);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(PodcastInformation, [{
    key: "_construct",
    value: function _construct() {
      this._style = podcastInformation_style_defaultContext;
    }
  }, {
    key: "data",
    set: function set(content) {
      if (!content) {
        return;
      }
      var top = this.tag('Top');
      var scroll = this.tag('Scroll');
      var screenSize = this._style.screenSize;
      var scrollableView = scroll.content;
      if (scrollableView) {
        top.once('txLoaded', function () {
          scroll.y = top.h;
          scroll.h = podcastInformation_style_getContainerHeight(screenSize) - scroll.y;
          scrollableView.data = content;
        });
      }
      top.data = content;
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this.tag('Scroll');
    }
  }, {
    key: "_handleKey",
    value: function _handleKey() {
      return true;
    }
  }, {
    key: "_handleBack",
    value: function _handleBack() {
      this.signal(podcastInformation_constants_PROGRAM_INFORMATION_CLOSED_SIGNAL);
      return true;
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      if (this.tag('ExitButton').visible) {
        this.signal(podcastInformation_constants_PROGRAM_INFORMATION_CLOSED_SIGNAL);
      }
      return true;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Overlay: {
          rect: true
        },
        ContentContainer: {
          Top: {
            type: PodcastInformationTop
          },
          Scroll: {
            type: Scroll,
            content: {
              type: PodcastDescription,
              w: podcast_information_podcastInformation_style_TEXT_WIDTH[podcastInformation_style_defaultContext.screenSize]
            }
          }
        }
      }, podcastInformation_style_getInitialStyle());
    }
  }]);
  return PodcastInformation;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/sidenav/customer/rtlde/sidenav.constants.js

var sidenav_constants_CONTENT_GAP;


var rtlde_sidenav_constants_CONTENT_GAP = (sidenav_constants_CONTENT_GAP = {}, (0,defineProperty/* default */.Z)(sidenav_constants_CONTENT_GAP, HD, 16), (0,defineProperty/* default */.Z)(sidenav_constants_CONTENT_GAP, FULL_HD, 24), sidenav_constants_CONTENT_GAP);
var RESTRICTED_PATHS = [USAGE_TERMS_PATH, PRIVACY_POLICY_PATH, SUBSCRIPTION_TERMS_PATH, LEGAL_CONDITIONS_PATH, SETTINGS_PATH, EXPIRED_SUBSCRIPTION_PATH, VIDEO_PATH, LIVE_PATH];
;// CONCATENATED MODULE: ./src/modules/sidenav/customer/rtlde/sidenav.path.constants.js
var DEFAULT_SERVICE = 'rtlplus_root';
;// CONCATENATED MODULE: ./src/modules/sidenav/sidenav.constants.js

var _WIDTH, _EXPANDED_WIDTH;



var animationDurationInSeconds = 0.3;
var animationConfig = {
  duration: 0.3
};
var WIDTH = (_WIDTH = {}, (0,defineProperty/* default */.Z)(_WIDTH, HD, 152), (0,defineProperty/* default */.Z)(_WIDTH, FULL_HD, 224), _WIDTH);
var EXPANDED_WIDTH = (_EXPANDED_WIDTH = {}, (0,defineProperty/* default */.Z)(_EXPANDED_WIDTH, HD, 304), (0,defineProperty/* default */.Z)(_EXPANDED_WIDTH, FULL_HD, 416), _EXPANDED_WIDTH);
/* harmony default export */ const sidenav_constants = ({
  animationDurationInSeconds: animationDurationInSeconds,
  animationConfig: animationConfig
});
;// CONCATENATED MODULE: ./src/modules/tornado/jumbotron-square/jumbotronSquare.constants.js

var _VERTICAL_PADDING, jumbotronSquare_constants_IMAGE_SIZE, _templates$JumbotronS, _templates$JumbotronS2;
function jumbotronSquare_constants_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function jumbotronSquare_constants_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? jumbotronSquare_constants_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : jumbotronSquare_constants_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



var jumbotronSquare_constants_templates = {
  JumbotronSquare: 'JumbotronSquare'
};
var VERTICAL_PADDING = (_VERTICAL_PADDING = {}, (0,defineProperty/* default */.Z)(_VERTICAL_PADDING, HD, 56), (0,defineProperty/* default */.Z)(_VERTICAL_PADDING, FULL_HD, 56), _VERTICAL_PADDING);
var jumbotron_square_jumbotronSquare_constants_IMAGE_SIZE = (jumbotronSquare_constants_IMAGE_SIZE = {}, (0,defineProperty/* default */.Z)(jumbotronSquare_constants_IMAGE_SIZE, HD, 448), (0,defineProperty/* default */.Z)(jumbotronSquare_constants_IMAGE_SIZE, FULL_HD, 448), jumbotronSquare_constants_IMAGE_SIZE);
var jumbotronSquare_constants_Z_INDEX_NORMAL = 0;
var jumbotronSquare_constants_Z_INDEX_WITH_PROGRAM_INFO = 1000;
var jumbotronSquare_constants_sizes = (0,defineProperty/* default */.Z)({}, jumbotronSquare_constants_templates.JumbotronSquare, (_templates$JumbotronS = {}, (0,defineProperty/* default */.Z)(_templates$JumbotronS, HD, {
  w: SCREEN_WIDTH[HD],
  h: jumbotron_square_jumbotronSquare_constants_IMAGE_SIZE[HD] + VERTICAL_PADDING[HD]
}), (0,defineProperty/* default */.Z)(_templates$JumbotronS, FULL_HD, {
  w: SCREEN_WIDTH[FULL_HD],
  h: jumbotron_square_jumbotronSquare_constants_IMAGE_SIZE[FULL_HD] + VERTICAL_PADDING[FULL_HD]
}), _templates$JumbotronS));
var jumbotronSquare_constants_imageOptions = (0,defineProperty/* default */.Z)({}, jumbotronSquare_constants_templates.JumbotronSquare, (_templates$JumbotronS2 = {}, (0,defineProperty/* default */.Z)(_templates$JumbotronS2, HD, {
  PRIMARY: {
    width: jumbotron_square_jumbotronSquare_constants_IMAGE_SIZE[HD],
    height: jumbotron_square_jumbotronSquare_constants_IMAGE_SIZE[HD]
  },
  LOGO: jumbotronSquare_constants_objectSpread({}, top_podcastInformationTop_style_LOGO_DIMENSIONS[HD])
}), (0,defineProperty/* default */.Z)(_templates$JumbotronS2, FULL_HD, {
  PRIMARY: {
    width: jumbotron_square_jumbotronSquare_constants_IMAGE_SIZE[FULL_HD],
    height: jumbotron_square_jumbotronSquare_constants_IMAGE_SIZE[FULL_HD]
  },
  LOGO: jumbotronSquare_constants_objectSpread({}, top_podcastInformationTop_style_LOGO_DIMENSIONS[FULL_HD])
}), _templates$JumbotronS2));
;// CONCATENATED MODULE: ./src/modules/tornado/jumbotron-square/jumbotronSquare.style.js

var _IMAGE_RADIUS, jumbotronSquare_style_SEPARATOR_HEIGHT, _CONTAINER_A_GAP, _CONTAINER_D_GAP, _CONTAINER_E_GAP, _CONTAINER_H_GAP, _CONTAINER_I_GAP, _BUTTONS_CONTAINER_GA;
function jumbotronSquare_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function jumbotronSquare_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? jumbotronSquare_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : jumbotronSquare_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }







var jumbotronSquare_style_defaultContext = makeDefaultStylingContext();
var jumbotronSquare_style_colors = {
  text: makeThemeColor(PRIMARY),
  separator: makeThemeColor(PRIMARY, 0.3)
};
var IMAGE_RADIUS = (_IMAGE_RADIUS = {}, (0,defineProperty/* default */.Z)(_IMAGE_RADIUS, HD, 4), (0,defineProperty/* default */.Z)(_IMAGE_RADIUS, FULL_HD, 8), _IMAGE_RADIUS);
var jumbotron_square_jumbotronSquare_style_SEPARATOR_HEIGHT = (jumbotronSquare_style_SEPARATOR_HEIGHT = {}, (0,defineProperty/* default */.Z)(jumbotronSquare_style_SEPARATOR_HEIGHT, HD, 2), (0,defineProperty/* default */.Z)(jumbotronSquare_style_SEPARATOR_HEIGHT, FULL_HD, 4), jumbotronSquare_style_SEPARATOR_HEIGHT);
var CONTAINER_A_GAP = (_CONTAINER_A_GAP = {}, (0,defineProperty/* default */.Z)(_CONTAINER_A_GAP, HD, 48), (0,defineProperty/* default */.Z)(_CONTAINER_A_GAP, FULL_HD, 48), _CONTAINER_A_GAP);
var CONTAINER_D_GAP = (_CONTAINER_D_GAP = {}, (0,defineProperty/* default */.Z)(_CONTAINER_D_GAP, HD, 32), (0,defineProperty/* default */.Z)(_CONTAINER_D_GAP, FULL_HD, 32), _CONTAINER_D_GAP);
var CONTAINER_E_GAP = (_CONTAINER_E_GAP = {}, (0,defineProperty/* default */.Z)(_CONTAINER_E_GAP, HD, 8), (0,defineProperty/* default */.Z)(_CONTAINER_E_GAP, FULL_HD, 8), _CONTAINER_E_GAP);
var CONTAINER_H_GAP = (_CONTAINER_H_GAP = {}, (0,defineProperty/* default */.Z)(_CONTAINER_H_GAP, HD, 24), (0,defineProperty/* default */.Z)(_CONTAINER_H_GAP, FULL_HD, 24), _CONTAINER_H_GAP);
var CONTAINER_I_GAP = (_CONTAINER_I_GAP = {}, (0,defineProperty/* default */.Z)(_CONTAINER_I_GAP, HD, 8), (0,defineProperty/* default */.Z)(_CONTAINER_I_GAP, FULL_HD, 8), _CONTAINER_I_GAP);
var BUTTONS_CONTAINER_GAP = (_BUTTONS_CONTAINER_GA = {}, (0,defineProperty/* default */.Z)(_BUTTONS_CONTAINER_GA, HD, 16), (0,defineProperty/* default */.Z)(_BUTTONS_CONTAINER_GA, FULL_HD, 24), _BUTTONS_CONTAINER_GA);
var jumbotronSquare_style_INFO_ICON = {
  name: 'InfoLight',
  type: 'icon'
};
var getLeftContainerWidth = function getLeftContainerWidth(screenSize, offset) {
  return SCREEN_WIDTH[screenSize] - (offset || safetyMargins.horizontal[screenSize]) - jumbotronSquare_constants_imageOptions[jumbotronSquare_constants_templates.JumbotronSquare][screenSize].PRIMARY.width - CONTAINER_A_GAP[screenSize] - safetyMargins.horizontal[screenSize];
};
var jumbotronSquare_style_makeBasicTextStyle = function makeBasicTextStyle(_ref) {
  var font = _ref.font,
    _ref$colorMode = _ref.colorMode,
    colorMode = _ref$colorMode === void 0 ? DEFAULT_MODE : _ref$colorMode,
    _ref$maxLines = _ref.maxLines,
    maxLines = _ref$maxLines === void 0 ? 2 : _ref$maxLines;
  return {
    color: jumbotronSquare_style_colors.text[colorMode],
    text: jumbotronSquare_style_objectSpread(jumbotronSquare_style_objectSpread({}, font), {}, {
      verticalAlign: 'middle',
      wordWrap: true,
      maxLines: maxLines,
      maxLinesSuffix: '...'
    })
  };
};
var jumbotronSquare_style_getInitialStyle = function getInitialStyle() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : jumbotronSquare_style_defaultContext,
    _ref2$screenSize = _ref2.screenSize,
    screenSize = _ref2$screenSize === void 0 ? FULL_HD : _ref2$screenSize,
    _ref2$colorMode = _ref2.colorMode,
    colorMode = _ref2$colorMode === void 0 ? DEFAULT_MODE : _ref2$colorMode;
  var imageSize = jumbotronSquare_constants_imageOptions[jumbotronSquare_constants_templates.JumbotronSquare][screenSize].PRIMARY.width;
  return {
    FlexContainer: {
      x: WIDTH[screenSize] + 40,
      flex: {
        direction: 'row',
        paddingTop: VERTICAL_PADDING[screenSize]
      },
      Image: {
        w: imageSize,
        h: imageSize,
        shader: {
          radius: IMAGE_RADIUS[screenSize]
        },
        flexItem: {
          marginRight: CONTAINER_A_GAP[screenSize]
        }
      },
      ContainerD: {
        flex: {
          direction: 'column'
        },
        ContainerE: {
          flex: {
            direction: 'column'
          },
          flexItem: {
            marginBottom: CONTAINER_D_GAP[screenSize]
          },
          Incentive: {
            flexItem: {
              marginBottom: CONTAINER_E_GAP[screenSize]
            }
          },
          Title: jumbotronSquare_style_objectSpread({
            flexItem: {
              marginBottom: CONTAINER_E_GAP[screenSize]
            }
          }, jumbotronSquare_style_makeBasicTextStyle({
            font: src_getFont(constants_FONT.PARIS_3, screenSize),
            colorMode: colorMode
          })),
          Author: jumbotronSquare_style_objectSpread({
            flexItem: {
              marginBottom: CONTAINER_E_GAP[screenSize]
            },
            alpha: 0.6
          }, jumbotronSquare_style_makeBasicTextStyle({
            font: src_getFont(constants_FONT.OTTAWA_1, screenSize),
            colorMode: colorMode
          }))
        },
        ContainerH: {
          flex: {
            direction: 'column'
          },
          flexItem: {
            marginBottom: CONTAINER_D_GAP[screenSize]
          },
          ProgressBar: {
            flexItem: {
              marginBottom: CONTAINER_H_GAP[screenSize]
            }
          },
          ButtonsContainer: {
            flex: {
              direction: 'row'
            },
            PlayButton: {
              flexItem: {
                marginRight: BUTTONS_CONTAINER_GAP[screenSize]
              }
            },
            MyListButton: {
              flexItem: {
                marginRight: BUTTONS_CONTAINER_GAP[screenSize]
              }
            },
            InfoButton: {
              picto: jumbotronSquare_style_INFO_ICON
            }
          }
        },
        Separator: {
          flexItem: {
            marginBottom: CONTAINER_D_GAP[screenSize]
          },
          rect: true,
          color: jumbotronSquare_style_colors.separator[colorMode],
          h: jumbotron_square_jumbotronSquare_style_SEPARATOR_HEIGHT[screenSize]
        },
        ContainerI: {
          flex: {
            direction: 'column'
          },
          ExtraDetails: jumbotronSquare_style_objectSpread({
            flexItem: {
              marginBottom: CONTAINER_I_GAP[screenSize]
            },
            alpha: 0.6
          }, jumbotronSquare_style_makeBasicTextStyle({
            font: src_getFont(constants_FONT.MADRID_3, screenSize),
            colorMode: colorMode
          })),
          Description: jumbotronSquare_style_objectSpread({}, jumbotronSquare_style_makeBasicTextStyle({
            font: src_getFont(constants_FONT.OTTAWA_1, screenSize),
            colorMode: colorMode,
            maxLines: 3
          }))
        }
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/jumbotron-square/jumbotronSquare.component.js











function jumbotronSquare_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function jumbotronSquare_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? jumbotronSquare_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : jumbotronSquare_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function jumbotronSquare_component_createSuper(t) { var r = jumbotronSquare_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function jumbotronSquare_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (jumbotronSquare_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }





















var JumbotronSquare = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(JumbotronSquare, _Lightning$Component);
  var _super = jumbotronSquare_component_createSuper(JumbotronSquare);
  function JumbotronSquare() {
    (0,classCallCheck/* default */.Z)(this, JumbotronSquare);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(JumbotronSquare, [{
    key: "_construct",
    value: function _construct() {
      this._style = jumbotronSquare_style_defaultContext;
      this._buttons = [];
      this._index = 0;
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this._buttons = null;
      this._focused = null;
    }
  }, {
    key: "item",
    get: function get() {
      return this._item;
    },
    set: function set(_ref) {
      var content = _ref.content,
        blockIndex = _ref.blockIndex,
        itemIndex = _ref.itemIndex,
        config = _ref.config,
        _ref$colorScheme = _ref.colorScheme,
        colorScheme = _ref$colorScheme === void 0 ? jumbotronSquare_style_defaultContext.colorMode : _ref$colorScheme;
      this._item = content;
      var _this$_item = this._item,
        action = _this$_item.action,
        author = _this$_item.author,
        bookmark = _this$_item.bookmark,
        description = _this$_item.description,
        extraDetails = _this$_item.extraDetails,
        image = _this$_item.image,
        incentives = _this$_item.incentives,
        progress = _this$_item.progress,
        title = _this$_item.title;
      var incentiveLines = getLinesCount(incentives);
      var leftWidth = getLeftContainerWidth(this._style.screenSize, this.tag('FlexContainer').x);
      var textColor = jumbotronSquare_style_colors.text[this._style.colorMode];
      this.patch({
        FlexContainer: {
          Image: {
            src: image.src
          },
          ContainerD: {
            w: leftWidth,
            ContainerE: {
              w: leftWidth,
              visible: incentiveLines > 0 || title || author,
              Incentive: {
                visible: incentiveLines > 0,
                data: {
                  linesCount: incentiveLines,
                  w: leftWidth,
                  incentives: incentives,
                  colorMode: this._style.colorMode
                }
              },
              Title: makeTextPatch(title, leftWidth, textColor),
              Author: makeTextPatch(author, leftWidth, textColor)
            },
            ContainerH: {
              ProgressBar: jumbotronSquare_component_objectSpread({
                w: Math.round(leftWidth * 0.33)
              }, makeProgressBarProperties(progress)),
              ButtonsContainer: {
                PlayButton: {
                  visible: isVisibleCTA(action),
                  label: get_default()(action, 'label', ''),
                  picto: get_default()(action, 'picto', '')
                },
                MyListButton: {
                  visible: Boolean(bookmark),
                  label: t('bookmarks.actionLabel'),
                  item: bookmark,
                  blockIndex: blockIndex,
                  itemIndex: itemIndex
                },
                InfoButton: {
                  visible: isVisibleInformationButton(this._item),
                  label: t('contentInfo.actionLabel')
                }
              }
            },
            Separator: {
              w: leftWidth,
              visible: extraDetails || description
            },
            ContainerI: {
              ExtraDetails: makeTextPatch(extraDetails, leftWidth, textColor),
              Description: makeTextPatch(description, leftWidth, textColor)
            }
          }
        },
        ProgramInformation: {
          data: this._item
        }
      });
      this._buttons = this.tag('ButtonsContainer').children.filter(function (item) {
        return item.visible;
      });
      this._setIndex();
    }
  }, {
    key: "contentPadding",
    set: function set(value) {
      this.tag('FlexContainer').x = Number.isFinite(value) ? value : 0;
    }
  }, {
    key: "_setIndex",
    value: function _setIndex() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._index;
      this._index = index;
      this._focused = this._buttons && this._buttons[this._index];
    }
  }, {
    key: "_showProgramInformation",
    value: function _showProgramInformation() {
      this.zIndex = jumbotronSquare_constants_Z_INDEX_WITH_PROGRAM_INFO;
      this.tag('ProgramInformation').patch(podcastInformation_style_getProgramInformationFocusedStyle());
      this._focused = this.tag('ProgramInformation');
    }
  }, {
    key: "_handleProgramInformationClose",
    value: function _handleProgramInformationClose() {
      this.zIndex = jumbotronSquare_constants_Z_INDEX_NORMAL;
      this.tag('ProgramInformation').patch(podcastInformation_style_getProgramInformationUnFocusedStyle());
      this._setIndex();
      sendEvent({
        key: 'closeMoreInfo'
      });
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this._focused;
    }
  }, {
    key: "_handleRight",
    value: function _handleRight() {
      if (!this._buttons) {
        return false;
      }
      if (this._index < this._buttons.length - 1) {
        this._setIndex(this._index + 1);
        return true;
      }
      return false;
    }
  }, {
    key: "_handleLeft",
    value: function _handleLeft() {
      if (this._index > 0) {
        this._setIndex(this._index - 1);
        return true;
      }
      return false;
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      if (this._focused === this.tag('InfoButton')) {
        this._showProgramInformation();
        sendEvent({
          key: 'pressMoreInfo'
        });
      } else {
        this.signal(SELECTED_SIGNAL, this._item);
      }
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        FlexContainer: {
          Image: {
            shader: {
              type: src_Lightning.shaders.RoundedRectangle
            }
          },
          ContainerD: {
            ContainerE: {
              Incentive: {
                type: Incentive
              },
              Title: {},
              Author: {}
            },
            ContainerH: {
              ProgressBar: {
                type: Progress
              },
              ButtonsContainer: {
                PlayButton: {
                  type: CallToAction
                },
                MyListButton: {
                  type: MyListButtonSecondary,
                  passSignals: (0,defineProperty/* default */.Z)({}, SELECTED_SIGNAL, true)
                },
                InfoButton: {
                  type: CallToAction
                }
              }
            },
            Separator: {
              rect: true
            },
            ContainerI: {
              ExtraDetails: {},
              Description: {}
            }
          }
        },
        ProgramInformation: {
          type: PodcastInformation,
          signals: (0,defineProperty/* default */.Z)({}, podcastInformation_constants_PROGRAM_INFORMATION_CLOSED_SIGNAL, '_handleProgramInformationClose')
        }
      }, jumbotronSquare_style_getInitialStyle());
    }
  }, {
    key: "getBottomMargin",
    value: function getBottomMargin(_ref2) {
      var screenSize = _ref2.screenSize;
      return VERTICAL_PADDING[screenSize];
    }
  }]);
  return JumbotronSquare;
}(src_Lightning.Component);

JumbotronSquare.Templates = jumbotronSquare_constants_templates;
JumbotronSquare.Sizes = jumbotronSquare_constants_sizes;
JumbotronSquare.ImageOptions = jumbotronSquare_constants_imageOptions;
;// CONCATENATED MODULE: ./src/modules/tornado/banner/banner.constants.js

var _templates$Banner, _templates$Banner2;

var banner_constants_templates = {
  Banner: 'Banner'
};
var banner_constants_sizes = (0,defineProperty/* default */.Z)({}, banner_constants_templates.Banner, (_templates$Banner = {}, (0,defineProperty/* default */.Z)(_templates$Banner, HD, {
  w: 1024,
  h: 341
}), (0,defineProperty/* default */.Z)(_templates$Banner, FULL_HD, {
  w: 1560,
  h: 520
}), _templates$Banner));
var banner_constants_imageOptions = (0,defineProperty/* default */.Z)({}, banner_constants_templates.Banner, (_templates$Banner2 = {}, (0,defineProperty/* default */.Z)(_templates$Banner2, HD, {
  PRIMARY: {
    width: 1024,
    height: 341
  },
  LOGO: {
    width: 123,
    height: 69
  }
}), (0,defineProperty/* default */.Z)(_templates$Banner2, FULL_HD, {
  PRIMARY: {
    width: 1560,
    height: 520
  },
  LOGO: {
    width: 176,
    height: 99
  }
}), _templates$Banner2));
;// CONCATENATED MODULE: ./src/modules/tornado/banner/banner.style.js

var banner_style_ICON_HEIGHT, banner_style_LOCK_ICON_HEIGHT;
function banner_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function banner_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? banner_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : banner_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }








var banner_style_defaultContext = makeDefaultStylingContext();
var banner_style_SCALE_FOCUSED = 1.02;
var banner_style_PADDING = 24;
var banner_style_LOGO_MARGIN_BOTTOM = 8;
var banner_banner_style_ICON_HEIGHT = (banner_style_ICON_HEIGHT = {}, (0,defineProperty/* default */.Z)(banner_style_ICON_HEIGHT, HD, 24), (0,defineProperty/* default */.Z)(banner_style_ICON_HEIGHT, FULL_HD, 32), banner_style_ICON_HEIGHT);
var banner_banner_style_LOCK_ICON_HEIGHT = (banner_style_LOCK_ICON_HEIGHT = {}, (0,defineProperty/* default */.Z)(banner_style_LOCK_ICON_HEIGHT, HD, 32), (0,defineProperty/* default */.Z)(banner_style_LOCK_ICON_HEIGHT, FULL_HD, 40), banner_style_LOCK_ICON_HEIGHT);
var banner_style_colors = {
  border: makeThemeColor(PRIMARY),
  overlay: makeThemeColor(TERTIARY)
};
var banner_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : banner_style_defaultContext,
    screenSize = _ref.screenSize,
    colorMode = _ref.colorMode;
  var _sizes$templates$Bann = banner_constants_sizes[banner_constants_templates.Banner][screenSize],
    w = _sizes$templates$Bann.w,
    h = _sizes$templates$Bann.h;
  var borderSize = focus_BORDER_WIDTH[screenSize];
  var borderOffset = borderSize * 2;
  return {
    zIndex: UNFOCUSED_Z_INDEX,
    w: w,
    h: h,
    Border: {
      w: w + borderOffset,
      h: h + borderOffset,
      x: -borderSize,
      y: -borderSize,
      color: colors_TRANSPARENT,
      shader: {
        radius: rtlde_focus_BORDER_RADIUS[screenSize],
        outline: focus_BORDER_WIDTH[screenSize],
        strokeColor: colors_TRANSPARENT,
        innerColor: colors_TRANSPARENT
      }
    },
    Image: {
      w: w,
      h: h,
      shader: {
        radius: rtlde_focus_BORDER_RADIUS[screenSize],
        overlayColor: banner_style_colors.overlay[colorMode]
      }
    },
    Content: {
      flex: {
        direction: 'column-reverse'
      },
      w: w - banner_style_PADDING * 2,
      h: h - banner_style_PADDING * 2,
      x: banner_style_PADDING,
      y: banner_style_PADDING,
      Description: {
        text: banner_style_objectSpread(banner_style_objectSpread({}, src_getFont(constants_FONT.OTTAWA_1)), {}, {
          maxLines: 3,
          textOverflow: '...'
        })
      },
      Title: {
        text: banner_style_objectSpread(banner_style_objectSpread({}, src_getFont(constants_FONT.KINSHASA_3)), {}, {
          maxLines: 2,
          textOverflow: '...'
        })
      },
      Logo: {
        w: banner_constants_imageOptions[banner_constants_templates.Banner][screenSize].LOGO.width,
        h: banner_constants_imageOptions[banner_constants_templates.Banner][screenSize].LOGO.height,
        flexItem: {
          marginBottom: banner_style_LOGO_MARGIN_BOTTOM
        }
      }
    }
  };
};
var banner_style_getFocusedStyle = memoize_default()(function (_ref2) {
  var colorMode = _ref2.colorMode;
  return {
    zIndex: FOCUSED_Z_INDEX,
    Border: {
      smooth: {
        scale: banner_style_SCALE_FOCUSED,
        'shader.strokeColor': BORDER_COLOR[colorMode],
        'shader.innerColor': INNER_BORDER_COLOR[colorMode],
        'shader.scale': banner_style_SCALE_FOCUSED
      }
    },
    Image: {
      smooth: {
        scale: banner_style_SCALE_FOCUSED,
        'shader.scale': banner_style_SCALE_FOCUSED
      }
    }
  };
}, cacheResolver);
var banner_style_unFocusedStyle = {
  zIndex: UNFOCUSED_Z_INDEX,
  Border: {
    smooth: {
      scale: 1,
      'shader.strokeColor': colors_TRANSPARENT,
      'shader.innerColor': colors_TRANSPARENT,
      'shader.scale': 1.0
    }
  },
  Image: {
    smooth: {
      scale: 1,
      'shader.scale': 1.0
    }
  }
};
;// CONCATENATED MODULE: ./src/modules/tornado/banner/banner.component.js







function banner_component_createSuper(t) { var r = banner_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function banner_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (banner_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }








var Banner = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Banner, _Lightning$Component);
  var _super = banner_component_createSuper(Banner);
  function Banner() {
    (0,classCallCheck/* default */.Z)(this, Banner);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Banner, [{
    key: "_construct",
    value: function _construct() {
      this._style = banner_style_defaultContext;
    }
  }, {
    key: "_inactive",
    value: function _inactive() {
      this.signal(INACTIVE_SIGNAL, this);
    }
  }, {
    key: "_attach",
    value: function _attach() {
      var _this = this;
      this.tag('Image').on('txLoaded', function () {
        _this.tag('Image').setSmooth('alpha', 1);
      });
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this.tag('Image').removeAllListeners('txLoaded');
      this._item = undefined;
      this.signal(DETACHED_SIGNAL, this);
    }
  }, {
    key: "item",
    get: function get() {
      return this._item;
    },
    set: function set(_ref) {
      var content = _ref.content,
        config = _ref.config,
        template = _ref.template,
        colorScheme = _ref.colorScheme;
      var screenSize = this._style.screenSize;
      var templateDataAccessPath = [template, this._style.screenSize];
      if (this._item && this._item.id === content.id) {
        this._item = content;
        return;
      }
      this._item = content;
      this._config = config || get_default()(banner_constants_sizes, templateDataAccessPath, {});
      this._style = {
        screenSize: screenSize,
        colorMode: colorScheme
      };
      var _this$_item = this._item,
        description = _this$_item.description,
        title = _this$_item.title,
        image = _this$_item.image,
        logo = _this$_item.logo;
      var imageUrl = image && image.src || '';
      var logoUrl = logo && logo.src || '';
      var wordWrapWidth = this._config.w - banner_style_PADDING * 2;
      this.patch({
        w: this._config.w,
        h: this._config.h,
        Image: {
          src: imageUrl,
          alpha: 0.0001
        },
        Content: {
          Description: {
            text: {
              text: description || '',
              visible: Boolean(description),
              wordWrapWidth: wordWrapWidth
            }
          },
          Title: {
            text: {
              text: title || '',
              visible: Boolean(title),
              wordWrapWidth: wordWrapWidth
            }
          },
          Logo: {
            src: logoUrl,
            visible: Boolean(logoUrl)
          }
        }
      });
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this.patch(banner_style_getFocusedStyle(this._style));
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this.patch(banner_style_unFocusedStyle);
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      this.signal(SELECTED_SIGNAL, this._item);
      return true;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Border: {
          rect: true,
          shader: {
            type: focus_shader
          }
        },
        Image: {
          shader: {
            type: ImageShader
          }
        },
        Content: {
          Description: {
            text: {}
          },
          Title: {
            text: {}
          },
          Logo: {}
        }
      }, banner_style_getInitialStyle());
    }
  }]);
  return Banner;
}(src_Lightning.Component);

Banner.Templates = banner_constants_templates;
Banner.Sizes = banner_constants_sizes;
Banner.ImageOptions = banner_constants_imageOptions;
;// CONCATENATED MODULE: ./src/modules/tornado/alert-view/AlertView.constants.js

var _templates$AlertView, _templates$AlertView2;

var AlertView_constants_templates = {
  AlertView: 'AlertView'
};
var AlertView_constants_sizes = (0,defineProperty/* default */.Z)({}, AlertView_constants_templates.AlertView, (_templates$AlertView = {}, (0,defineProperty/* default */.Z)(_templates$AlertView, HD, {
  w: 1280,
  h: 720
}), (0,defineProperty/* default */.Z)(_templates$AlertView, FULL_HD, {
  w: 1920,
  h: 1080
}), _templates$AlertView));
var AlertView_constants_imageOptions = (0,defineProperty/* default */.Z)({}, AlertView_constants_templates.AlertView, (_templates$AlertView2 = {}, (0,defineProperty/* default */.Z)(_templates$AlertView2, HD, {
  width: 1280,
  height: 720
}), (0,defineProperty/* default */.Z)(_templates$AlertView2, FULL_HD, {
  width: 1920,
  height: 1080
}), _templates$AlertView2));
;// CONCATENATED MODULE: ./src/modules/tornado/brand-icon/customer/rtlde/brandIcon.constants.js

var LOGO_ICON = {
  type: ICON_TYPE.SERVICE_ICON,
  name: 'rtlplus_root'
};
var LOGO_ICON_SCALE = 1.0;
var BRAND_ICON_WIDTH_RATIO = 1.6;
;// CONCATENATED MODULE: ./src/modules/tornado/brand-icon/brandIcon.constants.js

var brandIcon_constants_DEFAULT_ALPHA = 0.001;
;// CONCATENATED MODULE: ./src/modules/tornado/brand-icon/customer/rtlde/brandIcon.utils.js

var getLogoIcon = function getLogoIcon() {
  return LOGO_ICON;
};
;// CONCATENATED MODULE: ./src/modules/tornado/brand-icon/brandIcon.utils.js

;// CONCATENATED MODULE: ./src/modules/tornado/brand-icon/brandIcon.component.js







function brandIcon_component_createSuper(t) { var r = brandIcon_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function brandIcon_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (brandIcon_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }





var BrandIcon = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(BrandIcon, _Lightning$Component);
  var _super = brandIcon_component_createSuper(BrandIcon);
  function BrandIcon() {
    (0,classCallCheck/* default */.Z)(this, BrandIcon);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(BrandIcon, [{
    key: "_construct",
    value: function _construct() {
      this._textureScale = LOGO_ICON_SCALE;
      this._textureWidth = 0;
      this._textureHeight = 0;
    }
  }, {
    key: "_attach",
    value: function _attach() {
      var _this = this;
      var icon = this.tag('Icon');
      this._updateWidth = function () {
        _this.tag('Icon').setSmooth('alpha', 1);
        _this.w = _this._textureScale ? Math.round(icon.finalW / _this._textureScale) : icon.finalW;
      };
      icon.on('txLoaded', this._updateWidth);
    }
  }, {
    key: "_active",
    value: function _active() {
      this._isIconActive = true;
      this._updateIconTexture();
    }
  }, {
    key: "_inactive",
    value: function _inactive() {
      this._isIconActive = false;
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this.tag('Icon').removeAllListeners('txLoaded');
    }
  }, {
    key: "textureScale",
    get: function get() {
      return this._textureScale;
    },
    set: function set(value) {
      this._textureScale = value;
      this._updateIconTexture();
    }
  }, {
    key: "w",
    get: function get() {
      return (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(BrandIcon.prototype), "w", this);
    },
    set: function set(value) {
      this.tag('Icon').removeListener('txLoaded', this._updateWidth);
      _set((0,getPrototypeOf/* default */.Z)(BrandIcon.prototype), "w", value, this, true);
      this._textureWidth = value;
      this._updateIconTexture();
    }
  }, {
    key: "h",
    get: function get() {
      return (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(BrandIcon.prototype), "h", this);
    },
    set: function set(value) {
      _set((0,getPrototypeOf/* default */.Z)(BrandIcon.prototype), "h", value, this, true);
      if (BRAND_ICON_WIDTH_RATIO) {
        _set((0,getPrototypeOf/* default */.Z)(BrandIcon.prototype), "w", value * BRAND_ICON_WIDTH_RATIO, this, true);
        this._textureWidth = value * BRAND_ICON_WIDTH_RATIO;
      }
      this._textureHeight = value;
      this._updateIconTexture();
    }
  }, {
    key: "_updateIconTexture",
    value: function _updateIconTexture() {
      if (!this._isIconActive) {
        return;
      }
      this.tag('Icon').iconData = {
        picto: getLogoIcon(),
        scale: this._textureScale,
        viewBox: {
          w: this._textureWidth,
          h: this._textureHeight
        }
      };
    }
  }], [{
    key: "_template",
    value: function _template() {
      return {
        Icon: {
          type: Icon,
          mountY: 0.5,
          alpha: brandIcon_constants_DEFAULT_ALPHA,
          y: middle
        }
      };
    }
  }]);
  return BrandIcon;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/tornado/alert-view/AlertView.style.js

var AlertView_style_GAP, AlertView_style_TEXT_GAP, _LOGO_HEIGHT;
function AlertView_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AlertView_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AlertView_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AlertView_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






var AlertView_style_defaultContext = makeDefaultStylingContext();
var alert_view_AlertView_style_GAP = (AlertView_style_GAP = {}, (0,defineProperty/* default */.Z)(AlertView_style_GAP, HD, 24), (0,defineProperty/* default */.Z)(AlertView_style_GAP, FULL_HD, 32), AlertView_style_GAP);
var alert_view_AlertView_style_TEXT_GAP = (AlertView_style_TEXT_GAP = {}, (0,defineProperty/* default */.Z)(AlertView_style_TEXT_GAP, HD, 8), (0,defineProperty/* default */.Z)(AlertView_style_TEXT_GAP, FULL_HD, 16), AlertView_style_TEXT_GAP);
var LOGO_HEIGHT = (_LOGO_HEIGHT = {}, (0,defineProperty/* default */.Z)(_LOGO_HEIGHT, HD, 40), (0,defineProperty/* default */.Z)(_LOGO_HEIGHT, FULL_HD, 56), _LOGO_HEIGHT);
var getWordWrapWidth = function getWordWrapWidth(screenSize) {
  return Math.round(AlertView_constants_sizes[AlertView_constants_templates.AlertView][screenSize].w * 0.75);
};
var AlertView_style_colors = {
  text: makeThemeColor(PRIMARY),
  background: makeThemeColor(TERTIARY)
};
var AlertView_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : AlertView_style_defaultContext,
    screenSize = _ref.screenSize,
    colorMode = _ref.colorMode;
  var _sizes$templates$Aler = AlertView_constants_sizes[AlertView_constants_templates.AlertView][screenSize],
    w = _sizes$templates$Aler.w,
    h = _sizes$templates$Aler.h;
  var textColor = AlertView_style_colors.text[colorMode];
  var wordWrapWidth = getWordWrapWidth(screenSize);
  return {
    w: w,
    h: h,
    color: AlertView_style_colors.background,
    Background: {
      w: w,
      h: h
    },
    Logo: {
      mountX: 0.5,
      x: middle,
      y: safetyMargins.vertical[screenSize],
      h: LOGO_HEIGHT[screenSize]
    },
    Container: {
      w: w,
      h: h,
      flex: {
        direction: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      },
      Title: {
        text: AlertView_style_objectSpread(AlertView_style_objectSpread({}, src_getFont(constants_FONT.KINSHASA_3)), {}, {
          textColor: textColor,
          wordWrapWidth: wordWrapWidth,
          textAlign: 'center',
          maxLines: 2
        }),
        flexItem: {
          marginBottom: alert_view_AlertView_style_TEXT_GAP[screenSize]
        }
      },
      Description: {
        text: AlertView_style_objectSpread(AlertView_style_objectSpread({}, src_getFont(constants_FONT.OTTAWA_1)), {}, {
          textColor: textColor,
          wordWrapWidth: wordWrapWidth,
          textAlign: 'center',
          maxLines: 5
        }),
        flexItem: {
          marginBottom: alert_view_AlertView_style_TEXT_GAP[screenSize]
        }
      },
      Button: {
        flexItem: {
          marginTop: alert_view_AlertView_style_GAP[screenSize],
          marginBottom: alert_view_AlertView_style_GAP[screenSize]
        }
      },
      ExtraDetails: {
        text: AlertView_style_objectSpread(AlertView_style_objectSpread({}, src_getFont(constants_FONT.OTTAWA_1)), {}, {
          textColor: textColor,
          wordWrapWidth: wordWrapWidth,
          textAlign: 'center',
          maxLines: 3
        })
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/alert-view/AlertView.component.js










function AlertView_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AlertView_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AlertView_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AlertView_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function AlertView_component_createSuper(t) { var r = AlertView_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function AlertView_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (AlertView_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }








var AlertView = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(AlertView, _Lightning$Component);
  var _super = AlertView_component_createSuper(AlertView);
  function AlertView() {
    (0,classCallCheck/* default */.Z)(this, AlertView);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(AlertView, [{
    key: "_construct",
    value: function _construct() {
      this._style = AlertView_style_defaultContext;
      this._contentPadding = 0;
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this.tag('Background').removeAllListeners('txLoaded');
      this._item = undefined;
    }
  }, {
    key: "item",
    set: function set(_ref) {
      var _this = this;
      var content = _ref.content,
        config = _ref.config;
      this.tag('Background').once('txLoaded', function () {
        _this.tag('Background').setSmooth('alpha', 1);
      });
      this._item = content;
      var wordWrapWidth = getWordWrapWidth(this._style.screenSize);
      var textColor = AlertView_style_colors.text[this._style.colorMode];
      this.patch(AlertView_component_objectSpread(AlertView_component_objectSpread({}, config), {}, {
        Background: {
          alpha: 0.0001,
          src: content.image ? content.image.src : ''
        },
        Container: {
          Title: makeTextPatch(content.title || '', wordWrapWidth, textColor),
          Description: makeTextPatch(content.description || '', wordWrapWidth, textColor),
          Button: {
            label: content.action && content.action.label || ''
          },
          ExtraDetails: makeTextPatch(content.extraDetails || '', wordWrapWidth, textColor)
        }
      }));
      this.contentPadding = this._contentPadding;
    }
  }, {
    key: "contentPadding",
    set: function set(value) {
      var offset = Number.isFinite(value) ? value : 0;
      this.patch({
        Logo: {
          x: function x(v) {
            return Math.round((v + offset) / 2);
          }
        },
        Container: {
          x: offset,
          w: AlertView_constants_sizes[AlertView_constants_templates.AlertView][this._style.screenSize].w - offset
        }
      });
      this._contentPadding = value;
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      this.signal(SELECTED_SIGNAL, this._item);
      return true;
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this.tag('Button');
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        rect: true,
        Background: {},
        Logo: {
          type: BrandIcon
        },
        Container: {
          Title: {},
          Description: {},
          Button: {
            type: Button
          },
          ExtraDetails: {}
        }
      }, AlertView_style_getInitialStyle());
    }
  }]);
  return AlertView;
}(src_Lightning.Component);
AlertView.Templates = AlertView_constants_templates;
AlertView.Sizes = AlertView_constants_sizes;
AlertView.ImageOptions = AlertView_constants_imageOptions;
/* harmony default export */ const AlertView_component = (AlertView);
;// CONCATENATED MODULE: ./src/modules/tornado/templates/content.js



var _contentTemplates;
function content_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function content_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? content_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : content_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }




















var contentFallback = Jacket.Templates.Jacket;
var contentTemplates = (_contentTemplates = {}, (0,defineProperty/* default */.Z)(_contentTemplates, Portrait.Templates.Portrait, Portrait), (0,defineProperty/* default */.Z)(_contentTemplates, Poster.Templates.PosterS, Poster), (0,defineProperty/* default */.Z)(_contentTemplates, Poster.Templates.PosterM, Poster), (0,defineProperty/* default */.Z)(_contentTemplates, Poster.Templates.PosterL, Poster), (0,defineProperty/* default */.Z)(_contentTemplates, Jacket.Templates.Jacket, Jacket), (0,defineProperty/* default */.Z)(_contentTemplates, Card.Templates.CardS, Card), (0,defineProperty/* default */.Z)(_contentTemplates, Card.Templates.CardM, Card), (0,defineProperty/* default */.Z)(_contentTemplates, Card.Templates.CardL, Card), (0,defineProperty/* default */.Z)(_contentTemplates, Totem.Templates.Totem, Totem), (0,defineProperty/* default */.Z)(_contentTemplates, Cover.Templates.Cover, Cover), (0,defineProperty/* default */.Z)(_contentTemplates, Hero.Templates.Hero, Hero), (0,defineProperty/* default */.Z)(_contentTemplates, solo_component.Templates.Solo, solo_component), (0,defineProperty/* default */.Z)(_contentTemplates, jumbotron_component.Templates.Jumbotron, jumbotron_component), (0,defineProperty/* default */.Z)(_contentTemplates, JumbotronSquare.Templates.JumbotronSquare, JumbotronSquare), (0,defineProperty/* default */.Z)(_contentTemplates, HorizontalCard.Templates.HorizontalCard, HorizontalCard), (0,defineProperty/* default */.Z)(_contentTemplates, HorizontalSquare.Templates.HorizontalSquare, HorizontalSquare), (0,defineProperty/* default */.Z)(_contentTemplates, Square.Templates.Square, Square), (0,defineProperty/* default */.Z)(_contentTemplates, BigSquare.Templates.BigSquare, BigSquare), (0,defineProperty/* default */.Z)(_contentTemplates, FlatRectangle.Templates.FlatRectangle, FlatRectangle), (0,defineProperty/* default */.Z)(_contentTemplates, Banner.Templates.Banner, Banner), (0,defineProperty/* default */.Z)(_contentTemplates, AlertView_component.Templates.AlertView, AlertView_component), _contentTemplates);
var getContentTemplateByTemplateId = function getContentTemplateByTemplateId(templateId) {
  return contentTemplates[templateId] || contentTemplates[contentFallback];
};
var getContentSizeByContentTemplateId = function getContentSizeByContentTemplateId(contentTemplateId) {
  var contentTemplate = getContentTemplateByTemplateId(contentTemplateId);
  var sizes = get_default()(contentTemplate, "Sizes.".concat(contentTemplateId)) || get_default()(contentTemplate, "Sizes.".concat(contentFallback));
  return sizes[sizes_getScreenSize()] || sizes;
};
var getImageOptionsByContentTemplateId = function getImageOptionsByContentTemplateId(contentTemplateId) {
  var contentTemplate = getContentTemplateByTemplateId(contentTemplateId);
  return get_default()(contentTemplate, "ImageOptions.".concat(contentTemplateId)) || get_default()(contentTemplate, "ImageOptions.".concat(contentFallback));
};
var getContentTemplateOptions = memoize_default()(function () {
  return Object.keys(contentTemplates).reduce(function (result, key) {
    return content_objectSpread(content_objectSpread({}, result), {}, (0,defineProperty/* default */.Z)({}, key, {
      imageOptions: getImageOptionsByContentTemplateId(key),
      size: getContentSizeByContentTemplateId(key)
    }));
  }, {});
});
;// CONCATENATED MODULE: ./src/modules/tornado/templates/index.js



;// CONCATENATED MODULE: ./src/modules/tornado/templates/templateTypes.js



function templateTypes_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function templateTypes_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? templateTypes_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : templateTypes_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var templateTypes = templateTypes_objectSpread(templateTypes_objectSpread({}, Object.keys(contentTemplates).reduce(function (result, key) {
  return templateTypes_objectSpread(templateTypes_objectSpread({}, result), {}, (0,defineProperty/* default */.Z)({}, key, key));
}, {})), {}, {
  Player: 'Player',
  HorizontalEpg: 'HorizontalEpg'
});
var selectorTemplateTypes = {
  Selector: 'Selector',
  Tab: 'Selector'
};
var blockTemplateTypes = {
  List: 'List',
  SlideShow: 'SlideShow',
  Solo: 'Solo',
  Grid: 'Grid',
  Belly: 'Belly',
  SideGlass: 'SideGlass',
  HorizontalEpg: 'HorizontalEpg'
};
;// CONCATENATED MODULE: ./src/logic/lock/lock.selectors.js

var shouldDisplayProfilesGate = function shouldDisplayProfilesGate(state) {
  return get_default()(state, 'lock.shouldDisplayProfilesGate');
};
;// CONCATENATED MODULE: ./src/logic/layout/platform/default/layoutFilter.js
var hasContent = function hasContent(block) {
  return Boolean(block.content);
};
var handleGroupOnPlatform = function handleGroupOnPlatform(group) {
  return group;
};
var titleFilter = function titleFilter(value) {
  return value;
};
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.string.ends-with.js
var es_string_ends_with = __webpack_require__(6285);
// EXTERNAL MODULE: ./node_modules/.pnpm/crypto-js@3.1.9-1/node_modules/crypto-js/sha1.js
var crypto_js_sha1 = __webpack_require__(85734);
var crypto_js_sha1_default = /*#__PURE__*/__webpack_require__.n(crypto_js_sha1);
;// CONCATENATED MODULE: ./src/logic/layout/layout.image.utils.js















function layout_image_utils_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function layout_image_utils_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? layout_image_utils_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : layout_image_utils_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






var getImageQueryString = function getImageQueryString(options) {
  return Object.entries(options).filter(function (_ref) {
    var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
      _ = _ref2[0],
      value = _ref2[1];
    return Boolean(value) || Number.isFinite(value);
  }).sort(function (_ref3, _ref4) {
    var _ref5 = (0,slicedToArray/* default */.Z)(_ref3, 1),
      key1 = _ref5[0];
    var _ref6 = (0,slicedToArray/* default */.Z)(_ref4, 1),
      key2 = _ref6[0];
    return key1 <= key2 ? -1 : 1;
  }).map(function (_ref7) {
    var _ref8 = (0,slicedToArray/* default */.Z)(_ref7, 2),
      key = _ref8[0],
      value = _ref8[1];
    return "".concat(key, "=").concat(encodeURIComponent(value));
  }).join('&');
};
var constructImageOptions = function constructImageOptions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  return options ? layout_image_utils_objectSpread(layout_image_utils_objectSpread({}, IMAGE_ITEMS_DEFAULT_OPTIONS), {}, {
    image: layout_image_utils_objectSpread(layout_image_utils_objectSpread({}, IMAGE_ITEMS_DEFAULT_OPTIONS.image), options.PRIMARY),
    secondaryImage: layout_image_utils_objectSpread(layout_image_utils_objectSpread({}, IMAGE_ITEMS_DEFAULT_OPTIONS.image), options.SECONDARY),
    logo: layout_image_utils_objectSpread(layout_image_utils_objectSpread({}, IMAGE_ITEMS_DEFAULT_OPTIONS.logo), options.LOGO)
  }) : IMAGE_ITEMS_DEFAULT_OPTIONS;
};
var imageOptionsToQueries = function imageOptionsToQueries(options) {
  return Object.entries(options).reduce(function (result, _ref9) {
    var _ref0 = (0,slicedToArray/* default */.Z)(_ref9, 2),
      key = _ref0[0],
      value = _ref0[1];
    result[key] = getImageQueryString(value);
    return result;
  }, {});
};
var getContentImageOptions = memoize_default()(function (contentTemplateId, templatesOptions, screenSize) {
  return imageOptionsToQueries(constructImageOptions(get_default()(templatesOptions, "".concat(contentTemplateId, ".imageOptions.").concat(screenSize))));
}, function (id, _, screenSize) {
  return "".concat(id, "_").concat(screenSize);
});
var getScreenSaverImageOptions = memoize_default()(function (screenSize) {
  return imageOptionsToQueries(constructImageOptions({
    PRIMARY: {
      width: screenSize === FULL_HD ? 1920 : 1280,
      height: screenSize === FULL_HD ? 1080 : 720,
      format: DEFAULT_IMAGE_FORMAT,
      quality: IMAGE_QUALITY
    }
  }));
});
var getImageUrl = function getImageUrl(id, query) {
  var rawUrl = imageService.getRouteUrl("".concat(id, "/raw"));
  var path = imageService.getRoutePath("".concat(id, "/raw?").concat(query), true);
  var hash = crypto_js_sha1_default()("".concat(path).concat(es_fido/* fido */.n.get('imageSalt')));
  if (hash) {
    return "".concat(rawUrl, "?").concat(query, "&hash=").concat(hash);
  }
  return rawUrl;
};
var getItemImage = function getItemImage(image, options) {
  if (image && options) {
    image.src = getImageUrl(image.id, options);
  }
  return image;
};
var prepareItemImages = function prepareItemImages(item, imageOptions) {
  var forceGhostServicePicto = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  item.image = getItemImage(item.image, imageOptions.image);
  item.secondaryImage = getItemImage(item.secondaryImage, imageOptions.secondaryImage);
  item.logo = getItemImage(item.logo, imageOptions.logo);
  item.csaPicto = getCSAPicto(item.pictos);
  item.servicePicto = getServicePicto(item.pictos);
  item.lockPicto = getLockPicto(item.pictos);
  if (forceGhostServicePicto && item.servicePicto && item.servicePicto.name) {
    item.servicePicto.name = item.servicePicto.name.endsWith('_ghost') ? item.servicePicto.name : item.servicePicto.name.replace(/(_dark$|$)/, '_ghost');
  }
  return item;
};
;// CONCATENATED MODULE: ./src/logic/layout/layout.utils.js










var layout_utils_excluded = ["itemContent"],
  layout_utils_excluded2 = ["id", "content"],
  _excluded3 = ["content", "theme"];
function layout_utils_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function layout_utils_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? layout_utils_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : layout_utils_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }








var isScreensaverEntity = function isScreensaverEntity(entityType, entityId) {
  return entityType === layout_constants/* entities */.jF.frontspace && entityId === layout_constants/* frontspaces */.K_.tvapppreview;
};
var isOffersEntity = function isOffersEntity(entityType, entityId) {
  return entityType === layout_constants/* entities */.jF.frontspace && entityId === layout_constants/* frontspaces */.K_.offers;
};
var isProfilesGateEntity = function isProfilesGateEntity(entityType, entityId) {
  return entityType === layout_constants/* entities */.jF.frontspace && entityId === layout_constants/* frontspaces */.K_.profilesgate;
};
var shouldDisplayLanding = function shouldDisplayLanding(data) {
  return get_default()(data, 'entity.id') === layout_constants/* frontspaces */.K_.landing && get_default()(data, 'entity.type') === layout_constants/* entities */.jF.frontspace;
};
var shouldDisplaySubscriptionExpiration = function shouldDisplaySubscriptionExpiration(data) {
  var _data$entity = data.entity,
    entityId = _data$entity.id,
    entityType = _data$entity.type;
  var isEmptyLayout = !get_default()(data, 'blocks.length');
  return isOffersEntity(entityType, entityId) && isEmptyLayout;
};
var isProfilesGates = function isProfilesGates(data) {
  var _data$entity2 = data.entity,
    entityId = _data$entity2.id,
    entityType = _data$entity2.type;
  return isProfilesGateEntity(entityType, entityId);
};
var shouldAutoSelectProfile = function shouldAutoSelectProfile(data, state) {
  var isProfilesGatesSelectedByUser = shouldDisplayProfilesGate(state);
  if (isProfilesGatesSelectedByUser) {
    return false;
  }
  return get_default()(data, 'blocks[0].content.items.length') === 1;
};
var hasAlternativeContent = function hasAlternativeContent(block) {
  return Boolean(block.alternativeContent);
};
var isTemplateIncluded = function isTemplateIncluded(template, collection) {
  return collection.includes(template);
};
var isKnownSelectorTemplateType = function isKnownSelectorTemplateType(block) {
  return Object.keys(selectorTemplateTypes).includes(block.alternativeContent.selectorTemplateId);
};
var isKnownBlockTemplateType = function isKnownBlockTemplateType(block) {
  return Object.keys(blockTemplateTypes).includes(block.blockTemplateId);
};
var isKnownTemplateType = function isKnownTemplateType(block) {
  return Object.keys(templateTypes).includes(block.content.contentTemplateId);
};
var prepareItem = function prepareItem(item) {
  if (!item) {
    return item;
  }
  var itemContent = item.itemContent,
    rest = objectWithoutProperties_objectWithoutProperties(item, layout_utils_excluded);
  return layout_utils_objectSpread(layout_utils_objectSpread(layout_utils_objectSpread({}, rest), itemContent), {}, {
    title: titleFilter(itemContent.title),
    extraTitle: titleFilter(itemContent.extraTitle)
  });
};
var getFormattedItems = function getFormattedItems(items, imageOptions) {
  var forceGhostServicePicto = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return items.map(function (item) {
    return prepareItemImages(prepareItem(item), imageOptions, forceGhostServicePicto);
  });
};
var GHOSTY_TEMPLATES = ['Card', 'Jacket', 'Portrait', 'Poster', 'Totem', 'HorizontalCard'];
var prepareBlock = function prepareBlock(entity, screenSize, contentTemplateOptions) {
  var _ref = entity || {},
    entityId = _ref.entityId,
    entityType = _ref.entityType;
  return function (_ref2) {
    var id = _ref2.id,
      content = _ref2.content,
      block = objectWithoutProperties_objectWithoutProperties(_ref2, layout_utils_excluded2);
    var items = content ? content.items : [];
    var imageOptions = isScreensaverEntity(entityType, entityId) ? getScreenSaverImageOptions(screenSize) : getContentImageOptions(content.contentTemplateId, contentTemplateOptions, screenSize);
    var templateId = block ? block.templateId : '';
    var forceGhostServiceIcon = GHOSTY_TEMPLATES.some(function (templatePrefix) {
      return templateId.startsWith(templatePrefix);
    });
    var title = block.title;
    return layout_utils_objectSpread(layout_utils_objectSpread({}, block), {}, {
      title: title ? {
        long: titleFilter(title.long),
        short: titleFilter(title.short)
      } : title,
      id: id,
      content: layout_utils_objectSpread(layout_utils_objectSpread({}, content), {}, {
        items: getFormattedItems(items, imageOptions, forceGhostServiceIcon)
      })
    });
  };
};
var prepareAlternateContent = function prepareAlternateContent(block) {
  var concurrentBlocks = get_default()(block, 'alternativeContent.concurrentBlocks');
  if (concurrentBlocks && concurrentBlocks.length) {
    var alternativeContent = block.alternativeContent;
    concurrentBlocks[0].id = block.id;
    concurrentBlocks[0].content = block.content;
    var result = alternativeContent.concurrentBlocks.map(function (_ref3) {
      var content = _ref3.content,
        theme = _ref3.theme,
        rest = objectWithoutProperties_objectWithoutProperties(_ref3, _excluded3);
      return layout_utils_objectSpread(layout_utils_objectSpread({}, rest), {}, {
        theme: theme || block.theme,
        content: layout_utils_objectSpread(layout_utils_objectSpread({}, content), {}, {
          pagination: content.items ? content.pagination : layout_utils_objectSpread(layout_utils_objectSpread({}, content.pagination), {}, {
            nextPage: 1
          }),
          items: content.items || []
        })
      });
    });
    return layout_utils_objectSpread(layout_utils_objectSpread({}, block), {}, {
      alternativeContent: layout_utils_objectSpread(layout_utils_objectSpread({}, block.alternativeContent), {}, {
        concurrentBlocks: result
      })
    });
  }
  return block;
};
var prepareLastViewedProgress = function prepareLastViewedProgress(blocks, clipId, clipProgress) {
  for (var i = 0; i < blocks.length; i += 1) {
    var _blocks$i$content$ite = blocks[i].content.items,
      items = _blocks$i$content$ite === void 0 ? [] : _blocks$i$content$ite;
    for (var j = 0; j < items.length; j += 1) {
      var itemId = get_default()(items[j], 'action.target.value_layout.id');
      if (clipId === itemId && items[j].progress === 0) {
        blocks[i].content.items[j].progress = clipProgress;
        return;
      }
    }
  }
};
var cacheBusters = [layout_constants/* entities */.jF.audio, layout_constants/* entities */.jF.video, layout_constants/* entities */.jF.live];
var shouldOmitCache = function shouldOmitCache(entityType) {
  return cacheBusters.includes(entityType);
};
var getLayoutEntityAsString = function getLayoutEntityAsString(layout) {
  if (!layout || !layout.entity) {
    return '';
  }
  var _layout$entity = layout.entity,
    type = _layout$entity.type,
    id = _layout$entity.id;
  return "".concat(type, "_").concat(id);
};
var isValidItemPosition = function isValidItemPosition(blockIndex, itemIndex) {
  return Number.isFinite(blockIndex) && Number.isFinite(itemIndex) && blockIndex >= 0 && itemIndex >= 0;
};

var pagesToLoad = function pagesToLoad(totalItems, itemsPerPage) {
  var items = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var result = {};
  if (!totalItems || !itemsPerPage) {
    return result;
  }
  for (var i = 0; i < totalItems; i += itemsPerPage) {
    var start = i;
    var end = Math.max(Math.min(start + itemsPerPage, totalItems) - 1, 0);
    var page = i / itemsPerPage;
    result[page] = Boolean(items[start] && items[end]) && items[start].content !== PLACEHOLDER && items[end].content !== PLACEHOLDER ? PAGE_STATE.LOADED : PAGE_STATE.MISSING;
  }
  return result;
};
;// CONCATENATED MODULE: ./src/logic/layout/layout.navigation.utils.js






var getNavigationV2 = function getNavigationV2(data) {
  return data ? {
    entries: [data.entries.filter(function (element) {
      return element.entry.id !== 'Brand';
    })]
  } : {
    entries: []
  };
};
var getNavigationV3 = function getNavigationV3(data) {
  return data ? {
    entries: data.map(function (group) {
      return get_default()(group, 'entries', []).map(function (entry) {
        var subEntries = get_default()(entry, 'groups[0].entries', []);
        entry.groups = [];
        return {
          entry: entry,
          subEntries: subEntries
        };
      });
    })
  } : {
    entries: []
  };
};
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/pickBy.js
var pickBy = __webpack_require__(12557);
var pickBy_default = /*#__PURE__*/__webpack_require__.n(pickBy);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/snakeCase.js
var snakeCase = __webpack_require__(69113);
var snakeCase_default = /*#__PURE__*/__webpack_require__.n(snakeCase);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/premium/premium.constants.js
var subscriptionStatus = {
  VALID: 'VALID',
  INVALID: 'INVALID',
  ALREADY_USED_PAYMENT_METHOD: 'ALREADY_USED_PAYMENT_METHOD'
};
var premiumCouponStatus = {
  VALID: 'VALID',
  INVALID: 'INVALID',
  ALREADY_SUBSCRIBED: 'ERR_USER_ALREADY_SUBSCRIBED',
  USED: 'USED',
  EXPIRED: 'EXPIRED',
  LIMIT_REACHED: 'LIMIT_REACHED'
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/premium/premiumService.js
















function premiumService_createSuper(t) { var r = premiumService_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function premiumService_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (premiumService_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var premiumService_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,esm_typeof/* default */.Z)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};








var premiumService_monitoring = withMonitoring_withMonitoring('premium');
var PremiumService = function (_FetcherService) {
  (0,inherits/* default */.Z)(PremiumService, _FetcherService);
  var _super = premiumService_createSuper(PremiumService);
  function PremiumService() {
    var _this;
    (0,classCallCheck/* default */.Z)(this, PremiumService);
    _this = _super.apply(this, arguments);
    _this.apiType = 'stores';
    return _this;
  }
  (0,createClass/* default */.Z)(PremiumService, [{
    key: "init",
    value: function init() {
      if (!this.isInitialized) {
        this.isInitialized = true;
      }
    }
  }, {
    key: "getOffers",
    value: (function () {
      var _getOffers = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(_ref) {
        var headers, products, countryCode;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              headers = _ref.headers, products = _ref.products, countryCode = _ref.countryCode;
              this.checkInit();
              return _context.abrupt("return", this.fetch("".concat(es_fido/* fido */.n.getBaseUrl('stores'), "/customers/").concat(es_fido/* fido */.n.get('customerCode'), "/platforms/").concat(es_fido/* fido */.n.get('platformCode'), "/offers"), {
                method: 'GET',
                headers: headers,
                query: {
                  products: products === null || products === void 0 ? void 0 : products.join(','),
                  countryCode: countryCode
                }
              }));
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getOffers(_x) {
        return _getOffers.apply(this, arguments);
      }
      return getOffers;
    }())
  }, {
    key: "getOrder",
    value: (function () {
      var _getOrder = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2(_ref2) {
        var locale, variantId, couponCode, user, headers, prepareURL;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              locale = _ref2.locale, variantId = _ref2.variantId, couponCode = _ref2.couponCode, user = _ref2.user, headers = _ref2.headers;
              this.checkInit();
              prepareURL = "".concat(es_fido/* fido */.n.getBaseUrl('stores'), "/customers/").concat(es_fido/* fido */.n.get('customerCode'), "/platforms/").concat(es_fido/* fido */.n.get('platformCode'), "/users/").concat(user.UID, "/prepare");
              return _context2.abrupt("return", this.fetch(prepareURL, {
                method: 'POST',
                body: {
                  locale: locale,
                  offer_variant_id: variantId,
                  coupon_code: couponCode
                },
                headers: headers
              }));
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getOrder(_x2) {
        return _getOrder.apply(this, arguments);
      }
      return getOrder;
    }())
  }, {
    key: "changeOffer",
    value: (function () {
      var _changeOffer = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee3(_ref3) {
        var offerCode, variantId, user, headers, prepareURL;
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              offerCode = _ref3.offerCode, variantId = _ref3.variantId, user = _ref3.user, headers = _ref3.headers;
              this.checkInit();
              prepareURL = "".concat(es_fido/* fido */.n.getBaseUrl('stores'), "/customers/").concat(es_fido/* fido */.n.get('customerCode'), "/platforms/").concat(es_fido/* fido */.n.get('platformCode'), "/users/").concat(user.UID, "/offers/").concat(offerCode, "/change");
              return _context3.abrupt("return", this.fetch(prepareURL, {
                method: 'POST',
                body: {
                  offer_variant_id: variantId
                },
                headers: headers
              }));
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function changeOffer(_x3) {
        return _changeOffer.apply(this, arguments);
      }
      return changeOffer;
    }())
  }, {
    key: "cancelDowngrade",
    value: (function () {
      var _cancelDowngrade = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee4(_ref4) {
        var offerCode, user, headers, prepareURL;
        return regenerator_default().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              offerCode = _ref4.offerCode, user = _ref4.user, headers = _ref4.headers;
              this.checkInit();
              prepareURL = "".concat(es_fido/* fido */.n.getBaseUrl('stores'), "/customers/").concat(es_fido/* fido */.n.get('customerCode'), "/platforms/").concat(es_fido/* fido */.n.get('platformCode'), "/users/").concat(user.UID, "/offers/").concat(offerCode, "/change/cancel");
              return _context4.abrupt("return", this.fetch(prepareURL, {
                method: 'POST',
                headers: headers
              }));
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function cancelDowngrade(_x4) {
        return _cancelDowngrade.apply(this, arguments);
      }
      return cancelDowngrade;
    }())
  }, {
    key: "getUserAccess",
    value: (function () {
      var _getUserAccess = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee5(_ref5) {
        var user, _ref5$headers, headers, prepareURL;
        return regenerator_default().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              user = _ref5.user, _ref5$headers = _ref5.headers, headers = _ref5$headers === void 0 ? {} : _ref5$headers;
              this.checkInit();
              prepareURL = "".concat(es_fido/* fido */.n.getBaseUrl('stores'), "/customers/").concat(es_fido/* fido */.n.get('customerCode'), "/platforms/").concat(es_fido/* fido */.n.get('platformCode'), "/users/").concat(user.UID, "/access");
              return _context5.abrupt("return", this.fetch(prepareURL, {
                method: 'GET',
                headers: headers
              }));
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getUserAccess(_x5) {
        return _getUserAccess.apply(this, arguments);
      }
      return getUserAccess;
    }())
  }, {
    key: "getUserSubscriptions",
    value: (function () {
      var _getUserSubscriptions = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee6(_ref6) {
        var user, _ref6$headers, headers, apiURL;
        return regenerator_default().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              user = _ref6.user, _ref6$headers = _ref6.headers, headers = _ref6$headers === void 0 ? {} : _ref6$headers;
              this.checkInit();
              if (user.UID) {
                _context6.next = 4;
                break;
              }
              throw new Error('You should provide a non null uid');
            case 4:
              apiURL = "".concat(es_fido/* fido */.n.getBaseUrl('stores'), "/customers/").concat(es_fido/* fido */.n.get('customerCode'), "/platforms/").concat(es_fido/* fido */.n.get('platformCode'), "/users/").concat(user.UID, "/subscriptions");
              return _context6.abrupt("return", this.fetch(apiURL, {
                method: 'GET',
                headers: headers
              }));
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getUserSubscriptions(_x6) {
        return _getUserSubscriptions.apply(this, arguments);
      }
      return getUserSubscriptions;
    }())
  }, {
    key: "getUserSubscriptionsAfterPaymentUpdate",
    value: (function () {
      var _getUserSubscriptionsAfterPaymentUpdate = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee7(_ref7) {
        var user, _ref7$headers, headers;
        return regenerator_default().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              user = _ref7.user, _ref7$headers = _ref7.headers, headers = _ref7$headers === void 0 ? {} : _ref7$headers;
              headers['X-Refresh'] = true;
              return _context7.abrupt("return", this.getUserSubscriptions({
                user: user,
                headers: headers
              }));
            case 3:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function getUserSubscriptionsAfterPaymentUpdate(_x7) {
        return _getUserSubscriptionsAfterPaymentUpdate.apply(this, arguments);
      }
      return getUserSubscriptionsAfterPaymentUpdate;
    }())
  }, {
    key: "getUserInvoices",
    value: (function () {
      var _getUserInvoices = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee8(_ref8) {
        var user, _ref8$headers, headers, apiURL;
        return regenerator_default().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              user = _ref8.user, _ref8$headers = _ref8.headers, headers = _ref8$headers === void 0 ? {} : _ref8$headers;
              this.checkInit();
              if (user.UID) {
                _context8.next = 4;
                break;
              }
              throw new Error('You should provide a non null uid');
            case 4:
              apiURL = "".concat(es_fido/* fido */.n.getBaseUrl('stores'), "/customers/").concat(es_fido/* fido */.n.get('customerCode'), "/platforms/").concat(es_fido/* fido */.n.get('platformCode'), "/users/").concat(user.UID, "/invoices");
              return _context8.abrupt("return", this.fetch(apiURL, {
                method: 'GET',
                headers: headers
              }));
            case 6:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function getUserInvoices(_x8) {
        return _getUserInvoices.apply(this, arguments);
      }
      return getUserInvoices;
    }())
  }, {
    key: "downloadInvoice",
    value: (function () {
      var _downloadInvoice = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee1(_ref9) {
        var _this2 = this;
        var url, _ref9$headers, headers, downloadWithRedirect, downloadWithManualRedirect;
        return regenerator_default().wrap(function _callee1$(_context1) {
          while (1) switch (_context1.prev = _context1.next) {
            case 0:
              url = _ref9.url, _ref9$headers = _ref9.headers, headers = _ref9$headers === void 0 ? {} : _ref9$headers;
              this.checkInit();
              downloadWithRedirect = function () {
                var _ref0 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee9() {
                  return regenerator_default().wrap(function _callee9$(_context9) {
                    while (1) switch (_context9.prev = _context9.next) {
                      case 0:
                        return _context9.abrupt("return", _this2.fetch(url, {
                          method: 'GET',
                          headers: headers,
                          responseType: 'blob'
                        }));
                      case 1:
                      case "end":
                        return _context9.stop();
                    }
                  }, _callee9);
                }));
                return function downloadWithRedirect() {
                  return _ref0.apply(this, arguments);
                };
              }();
              downloadWithManualRedirect = function () {
                var _ref1 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee0() {
                  var returnUrl;
                  return regenerator_default().wrap(function _callee0$(_context0) {
                    while (1) switch (_context0.prev = _context0.next) {
                      case 0:
                        _context0.next = 2;
                        return _this2.fetch(url, {
                          method: 'GET',
                          headers: Object.assign(Object.assign({}, headers), {
                            'Content-Type': 'application/json'
                          })
                        });
                      case 2:
                        returnUrl = _context0.sent;
                        return _context0.abrupt("return", _this2.fetch(returnUrl.location, {
                          method: 'GET',
                          headers: headers,
                          responseType: 'blob'
                        }));
                      case 4:
                      case "end":
                        return _context0.stop();
                    }
                  }, _callee0);
                }));
                return function downloadWithManualRedirect() {
                  return _ref1.apply(this, arguments);
                };
              }();
              _context1.prev = 4;
              _context1.next = 7;
              return downloadWithRedirect();
            case 7:
              return _context1.abrupt("return", _context1.sent);
            case 10:
              _context1.prev = 10;
              _context1.t0 = _context1["catch"](4);
              return _context1.abrupt("return", downloadWithManualRedirect());
            case 13:
            case "end":
              return _context1.stop();
          }
        }, _callee1, this, [[4, 10]]);
      }));
      function downloadInvoice(_x9) {
        return _downloadInvoice.apply(this, arguments);
      }
      return downloadInvoice;
    }())
  }, {
    key: "cancelSubscription",
    value: (function () {
      var _cancelSubscription = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee10(_ref10) {
        var user, offerCode, _ref10$headers, headers, apiURL;
        return regenerator_default().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              user = _ref10.user, offerCode = _ref10.offerCode, _ref10$headers = _ref10.headers, headers = _ref10$headers === void 0 ? {} : _ref10$headers;
              this.checkInit();
              if (user.UID) {
                _context10.next = 4;
                break;
              }
              throw new Error('You should provide a non null user uid');
            case 4:
              if (offerCode) {
                _context10.next = 6;
                break;
              }
              throw new Error('You should provide a non null offer code');
            case 6:
              apiURL = "".concat(es_fido/* fido */.n.getBaseUrl('stores'), "/customers/").concat(es_fido/* fido */.n.get('customerCode'), "/platforms/").concat(es_fido/* fido */.n.get('platformCode'), "/users/").concat(user.UID, "/offers/").concat(offerCode, "/unsubscribe");
              return _context10.abrupt("return", this.fetch(apiURL, {
                method: 'POST',
                headers: headers
              }));
            case 8:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function cancelSubscription(_x0) {
        return _cancelSubscription.apply(this, arguments);
      }
      return cancelSubscription;
    }())
  }, {
    key: "resumeSubscription",
    value: (function () {
      var _resumeSubscription = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee11(_ref11) {
        var user, offerCode, _ref11$headers, headers, apiURL;
        return regenerator_default().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              user = _ref11.user, offerCode = _ref11.offerCode, _ref11$headers = _ref11.headers, headers = _ref11$headers === void 0 ? {} : _ref11$headers;
              this.checkInit();
              if (user.UID) {
                _context11.next = 4;
                break;
              }
              throw new Error('You should provide a non null user uid');
            case 4:
              if (offerCode) {
                _context11.next = 6;
                break;
              }
              throw new Error('You should provide a non null offer code');
            case 6:
              apiURL = "".concat(es_fido/* fido */.n.getBaseUrl('stores'), "/customers/").concat(es_fido/* fido */.n.get('customerCode'), "/platforms/").concat(es_fido/* fido */.n.get('platformCode'), "/users/").concat(user.UID, "/offers/").concat(offerCode, "/resume");
              return _context11.abrupt("return", this.fetch(apiURL, {
                method: 'POST',
                headers: headers
              }));
            case 8:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function resumeSubscription(_x1) {
        return _resumeSubscription.apply(this, arguments);
      }
      return resumeSubscription;
    }())
  }, {
    key: "consumeCouponCode",
    value: function () {
      var _consumeCouponCode = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee12(_ref12) {
        var user, couponCode, _ref12$headers, headers, response, status, receiptResult, _status;
        return regenerator_default().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              user = _ref12.user, couponCode = _ref12.couponCode, _ref12$headers = _ref12.headers, headers = _ref12$headers === void 0 ? {} : _ref12$headers;
              if (user) {
                _context12.next = 3;
                break;
              }
              throw new Error('You should provide a non null uid');
            case 3:
              if (couponCode) {
                _context12.next = 5;
                break;
              }
              throw new Error('You should provide a non null couponCode');
            case 5:
              response = null;
              _context12.prev = 6;
              _context12.next = 9;
              return this.fetchWithResponse("".concat(es_fido/* fido */.n.getBaseUrl('coupons'), "/customers/").concat(es_fido/* fido */.n.get('customerCode'), "/platforms/").concat(es_fido/* fido */.n.get('platformCode'), "/users/").concat(user.UID, "/coupons"), {
                method: 'POST',
                headers: headers,
                body: {
                  code: couponCode
                }
              });
            case 9:
              response = _context12.sent;
              _context12.next = 18;
              break;
            case 12:
              _context12.prev = 12;
              _context12.t0 = _context12["catch"](6);
              status = _context12.t0.status;
              if (!(status === 400 || status === 404)) {
                _context12.next = 17;
                break;
              }
              return _context12.abrupt("return", {
                status: premiumCouponStatus.INVALID
              });
            case 17:
              throw _context12.t0;
            case 18:
              _context12.prev = 18;
              _context12.next = 21;
              return this.fetch("".concat(es_fido/* fido */.n.getBaseUrl('stores'), "/customers/").concat(es_fido/* fido */.n.get('customerCode'), "/platforms/").concat(es_fido/* fido */.n.get('platformCode'), "/users/").concat(user.UID, "/stores/freecoupons/check"), {
                method: 'POST',
                headers: headers,
                body: {
                  receipt: response.text
                }
              });
            case 21:
              receiptResult = _context12.sent;
              _context12.next = 32;
              break;
            case 24:
              _context12.prev = 24;
              _context12.t1 = _context12["catch"](18);
              _status = _context12.t1.status;
              if (!(_status === 400)) {
                _context12.next = 29;
                break;
              }
              return _context12.abrupt("return", {
                status: premiumCouponStatus.INVALID
              });
            case 29:
              if (!(_status === 409)) {
                _context12.next = 31;
                break;
              }
              return _context12.abrupt("return", {
                status: premiumCouponStatus.ALREADY_SUBSCRIBED
              });
            case 31:
              throw _context12.t1;
            case 32:
              return _context12.abrupt("return", {
                status: premiumCouponStatus.VALID,
                subscribedOffer: receiptResult.offer
              });
            case 33:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this, [[6, 12], [18, 24]]);
      }));
      function consumeCouponCode(_x10) {
        return _consumeCouponCode.apply(this, arguments);
      }
      return consumeCouponCode;
    }()
  }, {
    key: "verifyCoupon",
    value: (function () {
      var _verifyCoupon = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee13(_ref13) {
        var couponCode, _ref13$headers, headers, couponVerificationURL, coupon;
        return regenerator_default().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              couponCode = _ref13.couponCode, _ref13$headers = _ref13.headers, headers = _ref13$headers === void 0 ? {} : _ref13$headers;
              this.checkInit();
              if (couponCode) {
                _context13.next = 4;
                break;
              }
              throw new Error('You should provide a non null couponCode');
            case 4:
              couponVerificationURL = "".concat(es_fido/* fido */.n.getBaseUrl('coupons'), "/premium/platforms/").concat(es_fido/* fido */.n.get('platformCode'), "/coupon/").concat(couponCode, "/expose");
              _context13.prev = 5;
              _context13.next = 8;
              return this.fetch(couponVerificationURL, {
                method: 'GET',
                headers: headers
              });
            case 8:
              coupon = _context13.sent;
              _context13.next = 14;
              break;
            case 11:
              _context13.prev = 11;
              _context13.t0 = _context13["catch"](5);
              return _context13.abrupt("return", {
                status: premiumCouponStatus.INVALID
              });
            case 14:
              return _context13.abrupt("return", coupon);
            case 15:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this, [[5, 11]]);
      }));
      function verifyCoupon(_x11) {
        return _verifyCoupon.apply(this, arguments);
      }
      return verifyCoupon;
    }())
  }, {
    key: "pay",
    value: (function () {
      var _pay = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee14(_ref14) {
        var force, user, storeCode, returnUrl, paymentMethodType, paymentMethodCode, orderId, _ref14$headers, headers, payEndpoint, body, payURL;
        return regenerator_default().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              force = _ref14.force, user = _ref14.user, storeCode = _ref14.storeCode, returnUrl = _ref14.returnUrl, paymentMethodType = _ref14.paymentMethodType, paymentMethodCode = _ref14.paymentMethodCode, orderId = _ref14.orderId, _ref14$headers = _ref14.headers, headers = _ref14$headers === void 0 ? {} : _ref14$headers;
              this.checkInit();
              if (user.UID) {
                _context14.next = 4;
                break;
              }
              throw new Error('You should provide a non null uid');
            case 4:
              payEndpoint = force ? 'forcePay' : 'pay';
              body = pickBy_default()({
                order_id: orderId,
                return_url: returnUrl,
                payment_method_type: paymentMethodType,
                payment_method_code: paymentMethodCode
              });
              payURL = "".concat(es_fido/* fido */.n.getBaseUrl('stores'), "/customers/").concat(es_fido/* fido */.n.get('customerCode'), "/platforms/").concat(es_fido/* fido */.n.get('platformCode'), "/users/").concat(user.UID, "/stores/").concat(storeCode, "/").concat(payEndpoint);
              return _context14.abrupt("return", this.fetch(payURL, {
                method: 'POST',
                body: body,
                headers: headers
              }));
            case 8:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function pay(_x12) {
        return _pay.apply(this, arguments);
      }
      return pay;
    }())
  }, {
    key: "check",
    value: (function () {
      var _check = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee15(_ref15) {
        var UID, storeCode, receipt, _ref15$headers, headers, body, checkURL;
        return regenerator_default().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              UID = _ref15.UID, storeCode = _ref15.storeCode, receipt = _ref15.receipt, _ref15$headers = _ref15.headers, headers = _ref15$headers === void 0 ? {} : _ref15$headers;
              this.checkInit();
              if (UID) {
                _context15.next = 4;
                break;
              }
              throw new Error('You should provide a non null uid');
            case 4:
              body = pickBy_default()({
                receipt: receipt
              });
              checkURL = "".concat(es_fido/* fido */.n.getBaseUrl('stores'), "/customers/").concat(es_fido/* fido */.n.get('customerCode'), "/platforms/").concat(es_fido/* fido */.n.get('platformCode'), "/users/").concat(UID, "/stores/").concat(storeCode, "/check");
              return _context15.abrupt("return", this.fetch(checkURL, {
                method: 'POST',
                body: body,
                headers: headers
              }));
            case 7:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function check(_x13) {
        return _check.apply(this, arguments);
      }
      return check;
    }())
  }, {
    key: "initPaymentMeanChange",
    value: (function () {
      var _initPaymentMeanChange = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee16(_ref16) {
        var user, offerCode, storeCode, returnUrl, paymentMethodType, paymentMethodCode, _ref16$headers, headers, apiURL, filteredParams, body;
        return regenerator_default().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              user = _ref16.user, offerCode = _ref16.offerCode, storeCode = _ref16.storeCode, returnUrl = _ref16.returnUrl, paymentMethodType = _ref16.paymentMethodType, paymentMethodCode = _ref16.paymentMethodCode, _ref16$headers = _ref16.headers, headers = _ref16$headers === void 0 ? {} : _ref16$headers;
              this.checkInit();
              if (user.UID) {
                _context16.next = 4;
                break;
              }
              throw new Error('You should provide a non null user uid');
            case 4:
              if (storeCode) {
                _context16.next = 6;
                break;
              }
              throw new Error('You should provide a non null store code');
            case 6:
              apiURL = "".concat(es_fido/* fido */.n.getBaseUrl('stores'), "/customers/").concat(es_fido/* fido */.n.get('customerCode'), "/platforms/").concat(es_fido/* fido */.n.get('platformCode'), "/users/").concat(user.UID, "/stores/").concat(storeCode, "/initPaymentChange");
              filteredParams = pickBy_default()({
                returnUrl: returnUrl,
                paymentMethodType: paymentMethodType,
                paymentMethodCode: paymentMethodCode,
                offerCode: offerCode
              });
              body = Object.keys(filteredParams).reduce(function (acc, paramKey) {
                return Object.assign(Object.assign({}, acc), (0,defineProperty/* default */.Z)({}, snakeCase_default()(paramKey), filteredParams[paramKey]));
              }, {});
              return _context16.abrupt("return", this.fetch(apiURL, {
                method: 'POST',
                headers: headers,
                body: body
              }));
            case 10:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
      function initPaymentMeanChange(_x14) {
        return _initPaymentMeanChange.apply(this, arguments);
      }
      return initPaymentMeanChange;
    }())
  }]);
  return PremiumService;
}(fetcherService/* FetcherService */.x);
premiumService_decorate([withJWT, premiumService_monitoring], PremiumService.prototype, "getOffers", null);
premiumService_decorate([withJWT, premiumService_monitoring], PremiumService.prototype, "getOrder", null);
premiumService_decorate([withJWT, premiumService_monitoring], PremiumService.prototype, "changeOffer", null);
premiumService_decorate([withJWT, premiumService_monitoring], PremiumService.prototype, "cancelDowngrade", null);
premiumService_decorate([withJWT, premiumService_monitoring], PremiumService.prototype, "getUserAccess", null);
premiumService_decorate([withJWT, withNoParallelRequest, premiumService_monitoring], PremiumService.prototype, "getUserSubscriptions", null);
premiumService_decorate([withJWT, withNoParallelRequest, premiumService_monitoring], PremiumService.prototype, "getUserSubscriptionsAfterPaymentUpdate", null);
premiumService_decorate([withJWT, withNoParallelRequest, premiumService_monitoring], PremiumService.prototype, "getUserInvoices", null);
premiumService_decorate([withJWT, premiumService_monitoring], PremiumService.prototype, "downloadInvoice", null);
premiumService_decorate([withJWT, premiumService_monitoring], PremiumService.prototype, "cancelSubscription", null);
premiumService_decorate([withJWT, premiumService_monitoring], PremiumService.prototype, "resumeSubscription", null);
premiumService_decorate([withJWT, premiumService_monitoring], PremiumService.prototype, "consumeCouponCode", null);
premiumService_decorate([withJWT, premiumService_monitoring], PremiumService.prototype, "verifyCoupon", null);
premiumService_decorate([withJWT, premiumService_monitoring], PremiumService.prototype, "pay", null);
premiumService_decorate([withJWT, premiumService_monitoring], PremiumService.prototype, "check", null);
premiumService_decorate([withJWT, premiumService_monitoring], PremiumService.prototype, "initPaymentMeanChange", null);
var premiumService = new PremiumService();
;// CONCATENATED MODULE: ./src/logic/pairing/pairing.premium.utils.js



var pairing_premium_utils_getPremiumUserContractModel = function getPremiumUserContractModel(subscriptions) {
  return subscriptions ? subscriptions.current.map(function (contract) {
    return {
      offer: get_default()(contract, 'offer.title'),
      features: get_default()(contract, 'offer.features', []).map(function (feature) {
        return feature && feature.code;
      }),
      price: get_default()(contract, 'current_contract.variant.recurring_price') || 0,
      products: get_default()(contract, 'offer.short_products', []).map(function (_ref) {
        var code = _ref.code;
        return code;
      }),
      currency: get_default()(contract, 'current_contract.variant.currency', '')
    };
  }) : [];
};
var getPremiumSubscriptions = function getPremiumSubscriptions(userId) {
  return premiumService.getUserSubscriptions({
    user: {
      UID: userId
    }
  }).then(pairing_premium_utils_getPremiumUserContractModel);
};
;// CONCATENATED MODULE: ./src/logic/pairing/customer/default/pairing.utils.js

var getUserContractModel = (/* unused pure expression or super */ null && (getPremiumUserContractModel));
var getCurrentSubscriptions = getPremiumSubscriptions;
;// CONCATENATED MODULE: ./src/logic/pairing/pairing.utils.js


function pairing_utils_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function pairing_utils_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? pairing_utils_ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : pairing_utils_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var STATUS_PAIRED = 'paired';
var isPaired = function isPaired(status) {
  return status === STATUS_PAIRED;
};
var setClipLastTc = function setClipLastTc(clips, clipId, tc) {
  var currentClips = pairing_utils_objectSpread({}, clips);
  currentClips[clipId] = pairing_utils_objectSpread(pairing_utils_objectSpread({}, currentClips[clipId] || {}), {}, {
    clipid: Number(clipId),
    lasttcseen: tc
  });
  return currentClips;
};

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(31223);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/errors/base.error.js








function base_error_createSuper(t) { var r = base_error_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function base_error_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (base_error_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var BaseFidoError = function (_Error) {
  (0,inherits/* default */.Z)(BaseFidoError, _Error);
  var _super = base_error_createSuper(BaseFidoError);
  function BaseFidoError() {
    var _this;
    (0,classCallCheck/* default */.Z)(this, BaseFidoError);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.stack = new Error().stack;
    _this.name = _this.constructor.name;
    return _this;
  }
  return (0,createClass/* default */.Z)(BaseFidoError);
}((0,wrapNativeSuper/* default */.Z)(Error));
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/errors/user/profile.errors.js





function profile_errors_createSuper(t) { var r = profile_errors_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function profile_errors_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (profile_errors_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var UserMaxAuthorizedProfilesCreatedError = function (_BaseFidoError) {
  (0,inherits/* default */.Z)(UserMaxAuthorizedProfilesCreatedError, _BaseFidoError);
  var _super = profile_errors_createSuper(UserMaxAuthorizedProfilesCreatedError);
  function UserMaxAuthorizedProfilesCreatedError() {
    (0,classCallCheck/* default */.Z)(this, UserMaxAuthorizedProfilesCreatedError);
    return _super.apply(this, arguments);
  }
  return (0,createClass/* default */.Z)(UserMaxAuthorizedProfilesCreatedError);
}(BaseFidoError);
var UserFirstProfileCannotBeKidError = function (_BaseFidoError2) {
  (0,inherits/* default */.Z)(UserFirstProfileCannotBeKidError, _BaseFidoError2);
  var _super2 = profile_errors_createSuper(UserFirstProfileCannotBeKidError);
  function UserFirstProfileCannotBeKidError() {
    (0,classCallCheck/* default */.Z)(this, UserFirstProfileCannotBeKidError);
    return _super2.apply(this, arguments);
  }
  return (0,createClass/* default */.Z)(UserFirstProfileCannotBeKidError);
}(BaseFidoError);
var UserLastProfileCannotBeKidError = function (_BaseFidoError3) {
  (0,inherits/* default */.Z)(UserLastProfileCannotBeKidError, _BaseFidoError3);
  var _super3 = profile_errors_createSuper(UserLastProfileCannotBeKidError);
  function UserLastProfileCannotBeKidError() {
    (0,classCallCheck/* default */.Z)(this, UserLastProfileCannotBeKidError);
    return _super3.apply(this, arguments);
  }
  return (0,createClass/* default */.Z)(UserLastProfileCannotBeKidError);
}(BaseFidoError);
var UserLastAdultProfileCannotBeDeletedError = function (_BaseFidoError4) {
  (0,inherits/* default */.Z)(UserLastAdultProfileCannotBeDeletedError, _BaseFidoError4);
  var _super4 = profile_errors_createSuper(UserLastAdultProfileCannotBeDeletedError);
  function UserLastAdultProfileCannotBeDeletedError() {
    (0,classCallCheck/* default */.Z)(this, UserLastAdultProfileCannotBeDeletedError);
    return _super4.apply(this, arguments);
  }
  return (0,createClass/* default */.Z)(UserLastAdultProfileCannotBeDeletedError);
}(BaseFidoError);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/user/profileService.js








function profileService_createSuper(t) { var r = profileService_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function profileService_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (profileService_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var profileService_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,esm_typeof/* default */.Z)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var profileService_monitoring = withMonitoring_withMonitoring('user');
var profileService_buildUserEndpoint = function buildUserEndpoint(uid) {
  return "users/".concat(uid, "/profiles");
};
var ProfileService = function (_FetcherService) {
  (0,inherits/* default */.Z)(ProfileService, _FetcherService);
  var _super = profileService_createSuper(ProfileService);
  function ProfileService() {
    var _this;
    (0,classCallCheck/* default */.Z)(this, ProfileService);
    _this = _super.apply(this, arguments);
    _this.apiType = 'userv2';
    return _this;
  }
  (0,createClass/* default */.Z)(ProfileService, [{
    key: "init",
    value: function init() {
      if (!this.isInitialized) {
        this.basePath = "platforms/".concat(es_fido/* fido */.n.get('platformCode'));
        this.isInitialized = true;
      }
    }
  }, {
    key: "getProfile",
    value: function getProfile(_ref) {
      var profileUid = _ref.profileUid,
        userUid = _ref.userUid,
        _ref$headers = _ref.headers,
        headers = _ref$headers === void 0 ? {} : _ref$headers;
      if (!profileUid || !userUid) {
        throw new Error('You must provide a profileUid and a userUid');
      }
      var endpoint = "".concat(profileService_buildUserEndpoint(userUid), "/").concat(profileUid);
      var url = this.getRouteUrl(endpoint);
      return this.fetch(url, {
        method: 'GET',
        headers: headers
      });
    }
  }, {
    key: "createProfile",
    value: function createProfile(_ref2) {
      var uid = _ref2.uid,
        profileName = _ref2.profileName,
        profileType = _ref2.profileType,
        birthDate = _ref2.birthDate,
        gender = _ref2.gender,
        avatarId = _ref2.avatarId,
        headers = _ref2.headers;
      var endpoint = profileService_buildUserEndpoint(uid);
      var url = this.getRouteUrl(endpoint);
      return this.fetch(url, {
        method: 'POST',
        headers: headers,
        body: {
          username: profileName,
          profile_type: profileType,
          birthdate: birthDate,
          gender: gender,
          avatar_id: avatarId
        }
      }).catch(function (err) {
        if (err.status === 403) {
          throw new UserFirstProfileCannotBeKidError();
        }
        if (err.status === 423) {
          throw new UserMaxAuthorizedProfilesCreatedError();
        }
        throw err;
      });
    }
  }, {
    key: "listProfiles",
    value: function listProfiles(_ref3) {
      var uid = _ref3.uid,
        headers = _ref3.headers;
      var endpoint = profileService_buildUserEndpoint(uid);
      var url = this.getRouteUrl(endpoint);
      if (!uid) {
        throw new Error('You must provide a uid');
      }
      return this.fetch(url, {
        method: 'GET',
        headers: headers
      });
    }
  }, {
    key: "getAvailableAvatars",
    value: function getAvailableAvatars(_ref4) {
      var uid = _ref4.uid,
        headers = _ref4.headers,
        _ref4$profileType = _ref4.profileType,
        profileType = _ref4$profileType === void 0 ? 'adult' : _ref4$profileType;
      var endpoint = "users/".concat(uid, "/avatars/").concat(profileType);
      var url = this.getRouteUrl(endpoint);
      return this.fetch(url, {
        method: 'GET',
        headers: headers
      });
    }
  }, {
    key: "updateProfile",
    value: function updateProfile(_ref5) {
      var uid = _ref5.uid,
        profileUid = _ref5.profileUid,
        profileName = _ref5.profileName,
        profileType = _ref5.profileType,
        birthDate = _ref5.birthDate,
        gender = _ref5.gender,
        avatarId = _ref5.avatarId,
        headers = _ref5.headers;
      var endpoint = profileService_buildUserEndpoint(uid);
      var url = "".concat(this.getRouteUrl(endpoint), "/").concat(profileUid);
      return this.fetch(url, {
        method: 'PUT',
        headers: headers,
        body: {
          username: profileName,
          profile_type: profileType,
          birthdate: birthDate,
          gender: gender,
          avatar_id: avatarId
        }
      }).catch(function (err) {
        if (err.status === 403) {
          throw new UserLastProfileCannotBeKidError();
        }
        throw err;
      });
    }
  }, {
    key: "deleteProfile",
    value: function deleteProfile(_ref6) {
      var uid = _ref6.uid,
        profileUid = _ref6.profileUid,
        headers = _ref6.headers;
      var endpoint = profileService_buildUserEndpoint(uid);
      var url = "".concat(this.getRouteUrl(endpoint), "/").concat(profileUid);
      return this.fetch(url, {
        method: 'DELETE',
        headers: headers
      }).catch(function (err) {
        if (err.status === 403) {
          throw new UserLastAdultProfileCannotBeDeletedError();
        }
        throw err;
      });
    }
  }]);
  return ProfileService;
}(fetcherService/* FetcherService */.x);
profileService_decorate([withJWT, profileService_monitoring], ProfileService.prototype, "getProfile", null);
profileService_decorate([withJWT, profileService_monitoring], ProfileService.prototype, "createProfile", null);
profileService_decorate([withJWT, profileService_monitoring], ProfileService.prototype, "listProfiles", null);
profileService_decorate([withJWT, profileService_monitoring], ProfileService.prototype, "getAvailableAvatars", null);
profileService_decorate([withJWT, profileService_monitoring], ProfileService.prototype, "updateProfile", null);
profileService_decorate([withJWT, profileService_monitoring], ProfileService.prototype, "deleteProfile", null);
var profileService = new ProfileService();
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/user/gdprService.js







function gdprService_createSuper(t) { var r = gdprService_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function gdprService_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (gdprService_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var gdprService_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,esm_typeof/* default */.Z)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var gdprService_monitoring = withMonitoring_withMonitoring('user');
var GdprService = function (_FetcherService) {
  (0,inherits/* default */.Z)(GdprService, _FetcherService);
  var _super = gdprService_createSuper(GdprService);
  function GdprService() {
    var _this;
    (0,classCallCheck/* default */.Z)(this, GdprService);
    _this = _super.apply(this, arguments);
    _this.apiType = 'userv2';
    return _this;
  }
  (0,createClass/* default */.Z)(GdprService, [{
    key: "init",
    value: function init() {
      if (!this.isInitialized) {
        this.basePath = "platforms/".concat(es_fido/* fido */.n.get('platformCode'));
        this.isInitialized = true;
      }
    }
  }, {
    key: "setUserConsents",
    value: function setUserConsents(_ref) {
      var uid = _ref.uid,
        consents = _ref.consents,
        _ref$headers = _ref.headers,
        headers = _ref$headers === void 0 ? {} : _ref$headers;
      if (!uid || !consents) {
        throw new Error('You should provide an uid and a consents object');
      }
      var endpoint = "users/".concat(uid, "/consents");
      var url = this.getRouteUrl(endpoint);
      return this.fetch(url, {
        method: 'POST',
        headers: headers,
        body: consents
      });
    }
  }, {
    key: "getUserConsents",
    value: function getUserConsents(_ref2) {
      var uid = _ref2.uid,
        _ref2$headers = _ref2.headers,
        headers = _ref2$headers === void 0 ? {} : _ref2$headers;
      if (!uid) {
        throw new Error('You should provide an uid');
      }
      var endpoint = "users/".concat(uid, "/consents");
      var url = this.getRouteUrl(endpoint);
      return this.fetch(url, {
        method: 'GET',
        headers: headers
      });
    }
  }]);
  return GdprService;
}(fetcherService/* FetcherService */.x);
gdprService_decorate([withJWT, gdprService_monitoring], GdprService.prototype, "setUserConsents", null);
gdprService_decorate([withJWT, gdprService_monitoring], GdprService.prototype, "getUserConsents", null);
var gdprService = new GdprService();
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/authentication/decorators/withDeviceHeaders.js


var withDeviceHeaders = function withDeviceHeaders(target, name, descriptor) {
  var fn = descriptor.value;
  descriptor.value = function () {
    var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var headers = Object.assign(Object.assign({}, args.headers), {
      'x-auth-device-id': es_fido/* fido */.n.get('localDeviceId'),
      'x-customer-name': es_fido/* fido */.n.get('customerCode')
    });
    return fn.apply(this, [Object.assign(Object.assign({}, args), {
      headers: headers
    })]);
  };
  return descriptor;
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/simpleFetcherService.js






function services_simpleFetcherService_createSuper(t) { var r = services_simpleFetcherService_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function services_simpleFetcherService_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (services_simpleFetcherService_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }



var simpleFetcherService_SimpleFetcherService = function (_FetcherService) {
  (0,inherits/* default */.Z)(SimpleFetcherService, _FetcherService);
  var _super = services_simpleFetcherService_createSuper(SimpleFetcherService);
  function SimpleFetcherService(serviceName) {
    var _this;
    var basePath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    (0,classCallCheck/* default */.Z)(this, SimpleFetcherService);
    _this = _super.call(this);
    if (!serviceName) {
      throw new Error("You have to instantiate this Fido's service with its name before using it");
    }
    _this.displayName = "".concat(serviceName.charAt(0).toUpperCase() + serviceName.slice(1), "Service");
    _this.apiType = serviceName;
    _this.basePath = basePath;
    return _this;
  }
  (0,createClass/* default */.Z)(SimpleFetcherService, [{
    key: "init",
    value: function init() {
      if (!this.isInitialized) {
        this.isInitialized = true;
        this.monitored = withMonitoring_withMonitoring(this.apiType);
      }
    }
  }, {
    key: "fetch",
    value: function fetch() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        headers = _ref.headers;
      var url = this.getRouteUrl();
      return this.monitored(SimpleFetcherService.prototype, 'fetch', {
        value: function value() {
          return (0,utils_fetch/* fetch */.h)(url, {
            method: 'GET',
            headers: headers
          }).then(function (_ref2) {
            var body = _ref2.body;
            return body;
          });
        }
      }).value();
    }
  }]);
  return SimpleFetcherService;
}(fetcherService/* FetcherService */.x);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/geo/geoService.js








function geoService_createSuper(t) { var r = geoService_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function geoService_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (geoService_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var geoService_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,esm_typeof/* default */.Z)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var GeoService = function (_SimpleFetcherService) {
  (0,inherits/* default */.Z)(GeoService, _SimpleFetcherService);
  var _super = geoService_createSuper(GeoService);
  function GeoService() {
    (0,classCallCheck/* default */.Z)(this, GeoService);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(GeoService, [{
    key: "fetch",
    value: function fetch(options) {
      return (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(GeoService.prototype), "fetch", this).call(this, options);
    }
  }]);
  return GeoService;
}(simpleFetcherService_SimpleFetcherService);
geoService_decorate([withDeviceHeaders], GeoService.prototype, "fetch", null);
var geoService = new GeoService('geo', 'geoInfo');
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/user/parentalControlService.js










function parentalControlService_createSuper(t) { var r = parentalControlService_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function parentalControlService_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (parentalControlService_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var parentalControlService_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,esm_typeof/* default */.Z)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var parentalControlService_monitoring = withMonitoring_withMonitoring('parentalControl');
var ParentalControlService = function (_FetcherService) {
  (0,inherits/* default */.Z)(ParentalControlService, _FetcherService);
  var _super = parentalControlService_createSuper(ParentalControlService);
  function ParentalControlService() {
    var _this;
    (0,classCallCheck/* default */.Z)(this, ParentalControlService);
    _this = _super.apply(this, arguments);
    _this.apiType = 'userv2';
    return _this;
  }
  (0,createClass/* default */.Z)(ParentalControlService, [{
    key: "init",
    value: function init() {
      if (!this.isInitialized) {
        this.basePath = "platforms/".concat(es_fido/* fido */.n.get('platformCode'));
        this.isInitialized = true;
      }
    }
  }, {
    key: "fetchParentalRestriction",
    value: (function () {
      var _fetchParentalRestriction = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(_ref) {
        var _ref$headers, headers, uid, endpoint, route;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _ref$headers = _ref.headers, headers = _ref$headers === void 0 ? {} : _ref$headers, uid = _ref.uid;
              if (uid) {
                _context.next = 3;
                break;
              }
              throw new Error('You should provide an uid');
            case 3:
              endpoint = "users/".concat(uid, "/parentalRestriction?with=code");
              route = this.getRouteUrl(endpoint);
              return _context.abrupt("return", this.fetch(route, {
                method: 'GET',
                headers: headers
              }).then(function (data) {
                return {
                  code: data.code,
                  maxCsaCode: data.maxCsaCode,
                  maxCsaId: data.max_csa_id
                };
              }));
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchParentalRestriction(_x) {
        return _fetchParentalRestriction.apply(this, arguments);
      }
      return fetchParentalRestriction;
    }())
  }, {
    key: "applyParentalRestriction",
    value: (function () {
      var _applyParentalRestriction = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2(_ref2) {
        var _ref2$headers, headers, uid, code, maxCsaCode, maxCsaId, endpoint, route;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _ref2$headers = _ref2.headers, headers = _ref2$headers === void 0 ? {} : _ref2$headers, uid = _ref2.uid, code = _ref2.code, maxCsaCode = _ref2.maxCsaCode, maxCsaId = _ref2.maxCsaId;
              if (uid) {
                _context2.next = 3;
                break;
              }
              throw new Error('You should provide an uid');
            case 3:
              endpoint = "users/".concat(uid, "/parentalRestriction");
              route = this.getRouteUrl(endpoint);
              return _context2.abrupt("return", this.fetch(route, {
                method: 'POST',
                headers: headers,
                body: {
                  code: code,
                  maxCsaCode: maxCsaCode,
                  max_csa_id: maxCsaId
                }
              }));
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function applyParentalRestriction(_x2) {
        return _applyParentalRestriction.apply(this, arguments);
      }
      return applyParentalRestriction;
    }())
  }, {
    key: "removeParentalRestriction",
    value: (function () {
      var _removeParentalRestriction = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee3(_ref3) {
        var _ref3$headers, headers, uid, endpoint, route;
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _ref3$headers = _ref3.headers, headers = _ref3$headers === void 0 ? {} : _ref3$headers, uid = _ref3.uid;
              if (uid) {
                _context3.next = 3;
                break;
              }
              throw new Error('You should provide an uid');
            case 3:
              endpoint = "users/".concat(uid, "/parentalRestriction");
              route = this.getRouteUrl(endpoint);
              return _context3.abrupt("return", this.fetch(route, {
                method: 'DELETE',
                headers: headers
              }));
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function removeParentalRestriction(_x3) {
        return _removeParentalRestriction.apply(this, arguments);
      }
      return removeParentalRestriction;
    }())
  }, {
    key: "checkParentalRestrictionCode",
    value: (function () {
      var _checkParentalRestrictionCode = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee4(_ref4) {
        var _ref4$headers, headers, uid, code, endpoint, route;
        return regenerator_default().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _ref4$headers = _ref4.headers, headers = _ref4$headers === void 0 ? {} : _ref4$headers, uid = _ref4.uid, code = _ref4.code;
              if (uid) {
                _context4.next = 3;
                break;
              }
              throw new Error('You should provide an uid');
            case 3:
              endpoint = "users/".concat(uid, "/parentalRestriction/checkCode");
              route = this.getRouteUrl(endpoint);
              return _context4.abrupt("return", this.fetch(route, {
                method: 'POST',
                headers: headers,
                body: {
                  code: code
                }
              }));
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function checkParentalRestrictionCode(_x4) {
        return _checkParentalRestrictionCode.apply(this, arguments);
      }
      return checkParentalRestrictionCode;
    }())
  }, {
    key: "fetchParentalFilter",
    value: (function () {
      var _fetchParentalFilter = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee5(_ref5) {
        var _ref5$headers, headers, uid, endpoint, route;
        return regenerator_default().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _ref5$headers = _ref5.headers, headers = _ref5$headers === void 0 ? {} : _ref5$headers, uid = _ref5.uid;
              if (uid) {
                _context5.next = 3;
                break;
              }
              throw new Error('You should provide an uid');
            case 3:
              endpoint = "users/".concat(uid, "/parentalfilter");
              route = this.getRouteUrl(endpoint);
              return _context5.abrupt("return", this.fetch(route, {
                method: 'GET',
                headers: headers
              }).then(function (data) {
                return {
                  parentalFilter: data.parental_filter
                };
              }));
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function fetchParentalFilter(_x5) {
        return _fetchParentalFilter.apply(this, arguments);
      }
      return fetchParentalFilter;
    }())
  }, {
    key: "updateParentalFilter",
    value: (function () {
      var _updateParentalFilter = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee6(_ref6) {
        var _ref6$headers, headers, uid, parentalFilter, endpoint, route;
        return regenerator_default().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _ref6$headers = _ref6.headers, headers = _ref6$headers === void 0 ? {} : _ref6$headers, uid = _ref6.uid, parentalFilter = _ref6.parentalFilter;
              if (uid) {
                _context6.next = 3;
                break;
              }
              throw new Error('You should provide an uid');
            case 3:
              endpoint = "users/".concat(uid, "/parentalfilter");
              route = this.getRouteUrl(endpoint);
              return _context6.abrupt("return", this.fetch(route, {
                method: 'POST',
                headers: headers,
                body: {
                  parental_filter: parentalFilter
                }
              }));
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function updateParentalFilter(_x6) {
        return _updateParentalFilter.apply(this, arguments);
      }
      return updateParentalFilter;
    }())
  }]);
  return ParentalControlService;
}(fetcherService/* FetcherService */.x);
parentalControlService_decorate([withJWT, parentalControlService_monitoring], ParentalControlService.prototype, "fetchParentalRestriction", null);
parentalControlService_decorate([withJWT, parentalControlService_monitoring], ParentalControlService.prototype, "applyParentalRestriction", null);
parentalControlService_decorate([withJWT, parentalControlService_monitoring], ParentalControlService.prototype, "removeParentalRestriction", null);
parentalControlService_decorate([withJWT, parentalControlService_monitoring], ParentalControlService.prototype, "checkParentalRestrictionCode", null);
parentalControlService_decorate([withJWT, parentalControlService_monitoring], ParentalControlService.prototype, "fetchParentalFilter", null);
parentalControlService_decorate([withJWT, parentalControlService_monitoring], ParentalControlService.prototype, "updateParentalFilter", null);
var parentalControlService_parentalControlService = new ParentalControlService();
// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.array.reduce-right.js
var es_array_reduce_right = __webpack_require__(76300);
;// CONCATENATED MODULE: ./src/modules/pairing/pairing.utils.js

var PAIRING_METHOD_KEY = 'pairing_method';
var getPairingMethod = function getPairingMethod() {
  return localStorage.getItem(PAIRING_METHOD_KEY);
};
var setPairingMethod = function setPairingMethod(value) {
  return localStorage.setItem(PAIRING_METHOD_KEY, value);
};
;// CONCATENATED MODULE: ./src/modules/pairing/pairing.constants.js
var PAIRING_METHOD = {
  NONE: 'none',
  PAIRING: 'pairing',
  SSI: 'ssi'
};
var SKIP_SSI_KEY = 'skip_SSI';
;// CONCATENATED MODULE: ./src/logic/user/user.utils.js






function user_utils_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function user_utils_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? user_utils_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : user_utils_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


var GDPR_API_CONSENT_KEY_MAPPING = {
  personalization: 'personalization',
  audienceMeasurement: 'analytics',
  targetedAdvertising: 'adtargeting',
  devicePairing: 'multidevicematching'
};
var formatClipsObject = function formatClipsObject(clips) {
  return (clips || []).filter(function (clip) {
    return Boolean(clip && clip.clipid);
  }).reduceRight(function (acc, clip) {
    return user_utils_objectSpread(user_utils_objectSpread({}, acc), {}, (0,defineProperty/* default */.Z)({}, clip.clipid, clip));
  }, {});
};
var getFormattedConsents = function getFormattedConsents(consents) {
  var consentEntries = Object.entries(consents);
  return consentEntries.filter(function (_ref) {
    var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return key !== undefined && value !== undefined;
  }).reduce(function (formattedConsents, _ref3) {
    var _ref4 = (0,slicedToArray/* default */.Z)(_ref3, 2),
      key = _ref4[0],
      value = _ref4[1];
    return user_utils_objectSpread(user_utils_objectSpread({}, formattedConsents), {}, (0,defineProperty/* default */.Z)({}, GDPR_API_CONSENT_KEY_MAPPING[key] || key, {
      consent: value,
      form: 'explicit'
    }));
  }, {});
};
var prefixWithHomeId = function prefixWithHomeId(homeId) {
  if (typeof homeId !== 'string') return null;
  return "homeid-".concat(homeId);
};
var ACCOUNT_COMPLETION_COUNTER = 'account_completion_counter';
var getAccountCompletionCount = function getAccountCompletionCount() {
  return parseInt(localStorage.getItem(ACCOUNT_COMPLETION_COUNTER), 10) || 0;
};
var isAccountCompletionCounterReady = function isAccountCompletionCounterReady() {
  return getAccountCompletionCount() >= 5;
};
var incrementAccountCompletionCounter = function incrementAccountCompletionCounter() {
  if (getPairingMethod() !== PAIRING_METHOD.SSI) {
    return;
  }
  localStorage.setItem(ACCOUNT_COMPLETION_COUNTER, getAccountCompletionCount() + 1);
};
var resetAccountCompletionCounter = function resetAccountCompletionCounter() {
  localStorage.setItem(ACCOUNT_COMPLETION_COUNTER, 0);
};
;// CONCATENATED MODULE: ./src/logic/gdprNotice/gdprNotice.utils.js




function gdprNotice_utils_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function gdprNotice_utils_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? gdprNotice_utils_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : gdprNotice_utils_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


var getRejectedConsents = function getRejectedConsents(consentCategories, userPreferences) {
  return consentCategories ? consentCategories.filter(function (consent) {
    return get_default()(userPreferences, [consent]) === false;
  }) : [];
};
var setAllCookies = function setAllCookies(value) {
  return src.gdprCookies.reduce(function (cookies, cookie) {
    return gdprNotice_utils_objectSpread(gdprNotice_utils_objectSpread({}, cookies), {}, (0,defineProperty/* default */.Z)({}, cookie, value));
  }, {});
};
var areCookiesEmpty = function areCookiesEmpty(cookies) {
  return cookies ? Object.values(cookies).some(function (cookie) {
    return typeof cookie !== 'boolean';
  }) : true;
};
;// CONCATENATED MODULE: ./src/logic/gdprNotice/gdprNotice.constants.js

var _CONSENT_TYPE_TO_ENGI;
var AUDIENCE_MEASUREMENT = 'audienceMeasurement';
var PERSONALIZATION = 'personalization';
var TARGETED_ADVERTISING = 'targetedAdvertising';
var CONSENT_TYPE_TO_ENGINE_MAP = (_CONSENT_TYPE_TO_ENGI = {}, (0,defineProperty/* default */.Z)(_CONSENT_TYPE_TO_ENGI, AUDIENCE_MEASUREMENT, ['googleAnalytics', 'newrelic']), (0,defineProperty/* default */.Z)(_CONSENT_TYPE_TO_ENGI, PERSONALIZATION, ['salesforceCRM']), (0,defineProperty/* default */.Z)(_CONSENT_TYPE_TO_ENGI, TARGETED_ADVERTISING, ['googleAnalytics', 'krxd', 'smartclip']), _CONSENT_TYPE_TO_ENGI);
;// CONCATENATED MODULE: ./src/logic/analytics/analytics.actions.js
















var INITIALIZE_ENGINES = 'analytics/INITIALIZE_ENGINES';
var initializeEngines = function initializeEngines(engines) {
  return {
    type: INITIALIZE_ENGINES,
    engines: engines
  };
};
var ACCEPT_ENGINES = 'analytics/ACCEPT_ENGINES';
var acceptEngines = function acceptEngines(engines) {
  return {
    type: ACCEPT_ENGINES,
    engines: engines
  };
};
var initAnalyticsEngines = function initAnalyticsEngines() {
  return function (dispatch, getState) {
    var state = getState();
    var enabledEngines = getAnalyticsEngines(state);
    var taggingPlans = getAnalyticsEvents(state);
    thirdPartyWithLayoutService.init({
      thirdParties: getThirdPartyServicesConfigs(enabledEngines),
      config: {
        taggingPlans: taggingPlans
      },
      options: {
        logger: (noop_default()),
        sendErrorToMonitoring: (noop_default()),
        isRecording: false
      }
    });
    return dispatch(initializeEngines(enabledEngines));
  };
};
var bootstrapEngines = function bootstrapEngines() {
  return function () {
    var _ref = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(dispatch, getState) {
      var state, engines, rejectedConsents, acceptedEngines, rejectedEngines, initializedEngines;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            state = getState();
            engines = getAnalyticsEngines(state);
            rejectedConsents = getRejectedConsents(src.gdprCookies, get_default()(state, 'user.cookies', []));
            acceptedEngines = [];
            rejectedEngines = [];
            engines.forEach(function (key) {
              var isThirdPartyRejected = rejectedConsents.some(function (consent) {
                return get_default()(CONSENT_TYPE_TO_ENGINE_MAP, [consent], []).includes(key);
              });
              if (isThirdPartyRejected) {
                rejectedEngines.push(key);
              } else {
                acceptedEngines.push(key);
              }
            });
            initializedEngines = thirdPartyWithLayoutService.thirdParties || [];
            initializedEngines.filter(function (_ref2) {
              var name = _ref2.name;
              return acceptedEngines.includes(name);
            }).forEach(function (engine) {
              engine.rejected = false;
            });
            _context.next = 10;
            return startEngines(acceptedEngines, rejectedEngines);
          case 10:
            setInitialAttributes(getState());
            return _context.abrupt("return", dispatch(acceptEngines(acceptedEngines)));
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
;// CONCATENATED MODULE: ./src/logic/user/user.actions.js





function user_actions_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function user_actions_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? user_actions_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : user_actions_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }











var STORAGE_WRITE_FAILURE = 'user/STORAGE_WRITE_FAILURE';
var STORAGE_SUPPORT_FAILURE = 'user/STORAGE_SUPPORT_FAILURE';
var RESTORE_DEVICE_DATA = 'user/RESTORE_DEVICE_DATA';
var RESET_DEVICE_DATA = 'user/RESET_DEVICE_DATA';
var SET_DO_NOT_TRACK = 'user/SET_DO_NOT_TRACK';
var SET_USER_CONSENTS = 'user/SET_USER_CONSENTS';
var GENERATE_DEVICE_ID = 'user/GENERATE_DEVICE_ID';
var UPDATE_DEVICE_ID = 'user/UPDATE_DEVICE_ID';
var SYNCHRONIZE_USER_CONSENTS = 'user/SYNCHRONIZE_USER_CONSENTS';
var CALL_USER_CONSENTS_SUCCESS = 'user/CALL_USER_CONSENTS_SUCCESS';
var CALL_USER_CONSENTS_FAILURE = 'user/CALL_USER_CONSENTS_FAILURE';
var GET_USER_CONSENTS_SUCCESS = 'user/GET_USER_CONSENTS_SUCCESS';
var GET_USER_CONSENTS_FAILURE = 'user/GET_USER_CONSENTS_FAILURE';
var SET_USER_UID = 'user/SET_USER_UID';
var USER_FETCH_LAST_CLIPS_SUCCESS = 'user/FETCH_LAST_CLIPS_SUCCESS';
var USER_FETCH_LAST_CLIPS_FAILURE = 'user/FETCH_LAST_CLIPS_FAILURE';
var USER_RESTORE_PROFILE_UID = 'user/RESTORE_PROFILE_UID';
var PARING_SET_PREVIOUS_PROFILE_UID = 'user/PARING_SET_PREVIOUS_PROFILE_UID';
var CALL_GEO_SUCCESS = 'app/CALL_GEO_SUCCESS';
var CALL_GEO_FAILURE = 'app/CALL_GEO_FAILURE';
var FETCH_PROFILE_INFOS_SUCCESS = 'user/FETCH_PROFILE_INFOS_SUCCESS';
var FETCH_PROFILE_INFOS_FAILURE = 'user/FETCH_PROFILE_INFOS_FAILURE';
var PARENTAL_LOCK_STATUS = 'user/PARENTAL_LOCK_STATUS';
var SET_ACCOUNT_COMPLETE = 'user/SET_ACCOUNT_COMPLETE';
var storageWriteFailure = function storageWriteFailure(error) {
  return {
    type: STORAGE_WRITE_FAILURE,
    error: error
  };
};
var storageSupportFailure = function storageSupportFailure(error) {
  return {
    type: STORAGE_SUPPORT_FAILURE,
    error: error
  };
};
var setPreviousProfileUID = function setPreviousProfileUID(previousProfileUid) {
  return {
    type: PARING_SET_PREVIOUS_PROFILE_UID,
    previousProfileUid: previousProfileUid
  };
};
var user_actions_generateDeviceId = function generateDeviceId() {
  return {
    type: GENERATE_DEVICE_ID,
    deviceId: deviceId()
  };
};
var fetchProfileInfosSuccess = function fetchProfileInfosSuccess(payload) {
  return user_actions_objectSpread({
    type: FETCH_PROFILE_INFOS_SUCCESS
  }, payload);
};
var getUserConsentsSuccess = function getUserConsentsSuccess() {
  return {
    type: GET_USER_CONSENTS_SUCCESS
  };
};
var getUserConsentsFailure = function getUserConsentsFailure(error) {
  return {
    type: GET_USER_CONSENTS_FAILURE,
    error: error.message
  };
};
var completeAccount = function completeAccount() {
  return {
    type: SET_ACCOUNT_COMPLETE
  };
};
var fetchProfileInfos = function fetchProfileInfos(profileUid) {
  return function () {
    var _ref = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(dispatch, getState) {
      var _getState, uid, profileInfos, username, imageExternalKey, isKidsProfile;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _getState = getState(), uid = _getState.pairing.uid;
            _context.prev = 1;
            _context.next = 4;
            return profileService.getProfile({
              profileUid: profileUid,
              userUid: uid
            });
          case 4:
            profileInfos = _context.sent;
            username = profileInfos.username, imageExternalKey = profileInfos.avatar.imageExternalKey, isKidsProfile = profileInfos.is_kid;
            dispatch(fetchProfileInfosSuccess({
              profileAvatarId: imageExternalKey,
              username: username,
              isKidsProfile: isKidsProfile,
              profileUid: profileUid
            }));
            _context.next = 13;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);
            dispatch({
              type: FETCH_PROFILE_INFOS_FAILURE
            });
            dispatch(error_actions_errorAction(error_constants_ERROR_LEVELS.SILENT, error_constants_ERROR_TYPES.GENERAL, _context.t0.message));
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 9]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
var restoreDeviceData = function restoreDeviceData() {
  return {
    type: RESTORE_DEVICE_DATA
  };
};
var updateDeviceId = function updateDeviceId(deviceId) {
  return {
    type: UPDATE_DEVICE_ID,
    deviceId: deviceId
  };
};
var setLocalUserConsents = function setLocalUserConsents(consents) {
  return user_actions_objectSpread({
    type: SET_USER_CONSENTS
  }, consents);
};
var migrateDeviceId = function migrateDeviceId(deviceId) {
  return function (dispatch) {
    if (!deviceId || isValidDeviceId(deviceId)) {
      return;
    }
    var updatedDeviceId = fixDeviceId(deviceId);
    dispatch(updateDeviceId(updatedDeviceId));
  };
};
var setUserConsentsOnApi = function setUserConsentsOnApi(consents) {
  return function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2(dispatch, getState) {
      var cookies, state, deviceId, homeId, formattedConsents;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            cookies = consents.cookies;
            state = getState();
            deviceId = user_selectors_getDeviceId(state);
            homeId = user_selectors_getHomeId(state);
            formattedConsents = getFormattedConsents(cookies);
            _context2.prev = 5;
            _context2.next = 8;
            return gdprService.setUserConsents({
              uid: homeId || deviceId,
              consents: formattedConsents
            });
          case 8:
            dispatch({
              type: CALL_USER_CONSENTS_SUCCESS
            });
            _context2.next = 15;
            break;
          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2["catch"](5);
            dispatch({
              type: CALL_USER_CONSENTS_FAILURE,
              error: _context2.t0.message
            });
            dispatch(error_actions_errorAction(error_constants_ERROR_LEVELS.SILENT, error_constants_ERROR_TYPES.GENERAL, _context2.t0.message));
          case 15:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[5, 11]]);
    }));
    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var setRemoteConsents = function setRemoteConsents(consents) {
  return function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee3(dispatch, getState) {
      var state, _getUserState, deviceId, synchronize, areUserPreferencesSet, cookies, userApiFeature, currentConsents, remoteConsents;
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            state = getState();
            _getUserState = getUserState(state), deviceId = _getUserState.deviceId, synchronize = _getUserState.synchronize, areUserPreferencesSet = _getUserState.areUserPreferencesSet, cookies = _getUserState.cookies;
            userApiFeature = getUserApiFeature(state);
            currentConsents = user_actions_objectSpread(user_actions_objectSpread({}, consents), cookies);
            if (!isEqual_default()(currentConsents, consents)) {
              _context3.next = 6;
              break;
            }
            return _context3.abrupt("return");
          case 6:
            if (!(synchronize === null && !areUserPreferencesSet)) {
              _context3.next = 22;
              break;
            }
            _context3.prev = 7;
            _context3.next = 10;
            return gdprService.getUserConsents({
              uid: deviceId
            });
          case 10:
            remoteConsents = _context3.sent;
            dispatch(getUserConsentsSuccess());
            if (!(Object.keys(remoteConsents).length !== 0)) {
              _context3.next = 16;
              break;
            }
            dispatch(user_actions_generateDeviceId());
            dispatch(setRemoteConsents(consents));
            return _context3.abrupt("return");
          case 16:
            _context3.next = 22;
            break;
          case 18:
            _context3.prev = 18;
            _context3.t0 = _context3["catch"](7);
            dispatch(getUserConsentsFailure(_context3.t0));
            dispatch(error_actions_errorAction(error_constants_ERROR_LEVELS.SILENT, error_constants_ERROR_TYPES.GENERAL, _context3.t0.message));
          case 22:
            if (userApiFeature) {
              dispatch(setUserConsentsOnApi({
                cookies: consents
              }));
            }
          case 23:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[7, 18]]);
    }));
    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var setUserConsents = function setUserConsents(consents) {
  return function (dispatch) {
    trackGDPRConsent(consents);
    dispatch(setRemoteConsents(consents));
    dispatch(setLocalUserConsents(consents));
    dispatch(bootstrapEngines());
  };
};
var setGeoInfo = function setGeoInfo() {
  return function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee4(dispatch) {
      var geoInfo;
      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return geoService.fetch();
          case 3:
            geoInfo = _context4.sent;
            dispatch({
              type: CALL_GEO_SUCCESS,
              data: geoInfo
            });
            _context4.next = 10;
            break;
          case 7:
            _context4.prev = 7;
            _context4.t0 = _context4["catch"](0);
            dispatch({
              type: CALL_GEO_FAILURE
            });
          case 10:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[0, 7]]);
    }));
    return function (_x7) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var setUserUid = function setUserUid(uid) {
  return function (dispatch) {
    dispatch({
      type: SET_USER_UID,
      uid: uid
    });
  };
};
var closeParentalLock = function closeParentalLock() {
  return function (dispatch) {
    return dispatch({
      type: PARENTAL_LOCK_STATUS,
      isUnlocked: false
    });
  };
};
var openParentalLock = function openParentalLock() {
  return function (dispatch) {
    return dispatch({
      type: PARENTAL_LOCK_STATUS,
      isUnlocked: true
    });
  };
};
var fetchLastViewedClipsSuccess = function fetchLastViewedClipsSuccess(lastViewdClips) {
  return function (dispatch) {
    try {
      dispatch({
        type: USER_FETCH_LAST_CLIPS_SUCCESS,
        lastClips: lastViewdClips
      });
    } catch (error) {
      dispatch({
        type: USER_FETCH_LAST_CLIPS_FAILURE,
        error: error
      });
      dispatch(errorAction(ERROR_LEVELS.SILENT, ERROR_TYPES.GENERAL, error.message));
    }
  };
};
var checkParentalRestrictionCode = function checkParentalRestrictionCode(code) {
  return function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee5(dispatch, getState) {
      var _getState2, uid, errorStatus, errorMessage;
      return regenerator_default().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _getState2 = getState(), uid = _getState2.user.uid;
            _context5.prev = 1;
            _context5.next = 4;
            return parentalControlService_parentalControlService.checkParentalRestrictionCode({
              uid: uid,
              code: code
            });
          case 4:
            dispatch(openParentalLock());
            _context5.next = 12;
            break;
          case 7:
            _context5.prev = 7;
            _context5.t0 = _context5["catch"](1);
            errorStatus = get_default()(_context5.t0, 'status');
            errorMessage = get_default()(_context5.t0, 'message', '');
            if (errorStatus && errorStatus === 400) {
              dispatch(closeParentalLock());
            } else {
              dispatch(error_actions_errorAction(error_constants_ERROR_LEVELS.FATAL, error_constants_ERROR_TYPES.GENERAL, errorMessage));
            }
          case 12:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[1, 7]]);
    }));
    return function (_x8, _x9) {
      return _ref5.apply(this, arguments);
    };
  }();
};
;// CONCATENATED MODULE: ./src/logic/error/error.utils.js




var getErrorLevel = function getErrorLevel(error) {
  if (error.fatal || error.request && error.name === fetch_error/* FetchError */.k.name) {
    return error_constants_ERROR_LEVELS.FATAL;
  }
  return error_constants_ERROR_LEVELS.SILENT;
};
var fetchErrorMessage = function fetchErrorMessage(error) {
  var errorCode = get_default()(error, 'content.code', error.code);
  return error.message || errorCode || error.detail;
};
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/clone.js
var clone = __webpack_require__(55824);
var clone_default = /*#__PURE__*/__webpack_require__.n(clone);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/mergeWith.js
var mergeWith = __webpack_require__(53954);
var mergeWith_default = /*#__PURE__*/__webpack_require__.n(mergeWith);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/setWith.js
var setWith = __webpack_require__(45943);
var setWith_default = /*#__PURE__*/__webpack_require__.n(setWith);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/applaunch/config-merger.js
var configMerger = function configMerger(objValue, srcValue) {
  if (srcValue === null || srcValue === undefined) {
    return objValue;
  }
  if (Array.isArray(objValue)) {
    return srcValue;
  }
  return undefined;
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/applaunch/utils.js







var parse = function parse(value) {
  try {
    if (typeof value === 'string') {
      return JSON.parse(value);
    }
    return value;
  } catch (_a) {
    return value;
  }
};
var generateRawData = function generateRawData(sortedData, initialData) {
  return (sortedData || []).reduce(function (reducedData, _ref) {
    var key = _ref.key,
      type = _ref.type,
      value = _ref.value;
    var parsedValue = parse(value);
    if (type === 'jsonpath') {
      return setWith_default()(clone_default()(reducedData), key, parsedValue, (clone_default()));
    }
    return Object.assign(Object.assign({}, reducedData), (0,defineProperty/* default */.Z)({}, key, parsedValue));
  }, initialData || {});
};
var mergeWithConfig = function mergeWithConfig(configData, data) {
  return mergeWith_default()({}, configData, data, configMerger);
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/applaunch/applaunchService.js


















function applaunchService_createSuper(t) { var r = applaunchService_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function applaunchService_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (applaunchService_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var applaunchService_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,esm_typeof/* default */.Z)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};







var applaunchService_monitoring = withMonitoring_withMonitoring('applaunch');
var CUSTOMIZER_VARIANTS_TYPE = {
  DEVICE: 'deviceCustomizerVariants',
  GIGYA: 'gigyaCustomizerVariants',
  PROFILE: 'profileCustomizerVariants'
};
var ApplaunchService = function (_FetcherService) {
  (0,inherits/* default */.Z)(ApplaunchService, _FetcherService);
  var _super = applaunchService_createSuper(ApplaunchService);
  function ApplaunchService() {
    var _this;
    (0,classCallCheck/* default */.Z)(this, ApplaunchService);
    _this = _super.apply(this, arguments);
    _this.apiType = 'applaunch';
    _this.getCustomizerVariants = function () {
      var headers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CUSTOMIZER_VARIANTS_TYPE.DEVICE;
      var _headers$xCustomizer = headers['x-customizer-variants'],
        variants = _headers$xCustomizer === void 0 ? '' : _headers$xCustomizer;
      var value = variants && variants.length ? variants.split(',') : [];
      value.sort();
      return {
        value: JSON.stringify(value),
        key: key,
        type: 'jsonpath'
      };
    };
    _this.reset = function () {
      _this.data = _this.defaultData;
    };
    _this.reload = function () {
      var _assertThisInitialize = (0,assertThisInitialized/* default */.Z)(_this),
        maxAge = _assertThisInitialize.maxAge;
      if (maxAge) {
        if (typeof maxAge === 'string' && _this.data[maxAge]) {
          maxAge = _this.data[maxAge];
        }
        if (typeof maxAge === 'number' && maxAge >= 30) {
          setTimeout(function () {
            _this.getApplaunch();
            _this.reload();
          }, maxAge * 1000);
        }
      }
    };
    _this.mergeData = function (initialData, newData) {
      var sortedData = sortBy_default()(newData, 'key');
      _this.rawData = generateRawData(sortedData, initialData);
      _this.data = mergeWithConfig(_this.config.data, _this.rawData);
      return _this.data;
    };
    return _this;
  }
  (0,createClass/* default */.Z)(ApplaunchService, [{
    key: "init",
    value: function init() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var serviceName = config.app,
        version = config.version,
        customizer = config.customizer,
        timeout = config.timeout,
        maxAge = config.maxAge;
      if (!serviceName) {
        throw new Error("You should provide a service name");
      }
      if (!version) {
        throw new Error("You should provide a version");
      }
      this.applaunchEndPoint = "".concat(serviceName, "-").concat(version, ".json");
      this.config = config;
      this.customizer = customizer;
      this.timeout = timeout;
      this.maxAge = maxAge;
      this.defaultData = data;
      this.data = data;
      this.isInitialized = true;
      return this;
    }
  }, {
    key: "getApplaunch",
    value: function getApplaunch() {
      var _this2 = this;
      if (this.config.disabled) {
        return this.mergeData();
      }
      var url = this.getRouteUrl(this.applaunchEndPoint);
      return this.fetch(url, {
        method: 'GET'
      }).then(function (dataList) {
        return _this2.mergeData({}, dataList);
      });
    }
  }, {
    key: "getCustomization",
    value: (function () {
      var _getCustomization = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(_ref) {
        var _this3 = this;
        var uid, localDeviceId, profileId, _ref$headers, headers, customizerUrl;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              uid = _ref.uid, localDeviceId = _ref.localDeviceId, profileId = _ref.profileId, _ref$headers = _ref.headers, headers = _ref$headers === void 0 ? {} : _ref$headers;
              customizerUrl = (0,sprintf.sprintf)(this.customizer, Object.assign({
                uid: profileId || uid || localDeviceId,
                platform: es_fido/* fido */.n.get('platformCode')
              }, this.config));
              return _context.abrupt("return", this.fetchWithResponse(customizerUrl, {
                method: 'GET',
                headers: headers
              }).then(function (_ref2) {
                var _ref2$headers = _ref2.headers,
                  responseHeaders = _ref2$headers === void 0 ? {} : _ref2$headers,
                  dataObject = _ref2.body;
                var dataList = Object.keys(dataObject).map(function (key) {
                  return dataObject[key];
                });
                var variantType = '';
                if (profileId) {
                  variantType = CUSTOMIZER_VARIANTS_TYPE.PROFILE;
                } else if (uid) {
                  variantType = CUSTOMIZER_VARIANTS_TYPE.GIGYA;
                } else {
                  variantType = CUSTOMIZER_VARIANTS_TYPE.DEVICE;
                }
                dataList.push(_this3.getCustomizerVariants(responseHeaders, variantType));
                return _this3.mergeData(_this3.data, dataList);
              }));
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getCustomization(_x) {
        return _getCustomization.apply(this, arguments);
      }
      return getCustomization;
    }())
  }, {
    key: "getData",
    value: function getData() {
      return this.data;
    }
  }, {
    key: "getRawData",
    value: function getRawData() {
      return this.rawData;
    }
  }]);
  return ApplaunchService;
}(fetcherService/* FetcherService */.x);
applaunchService_decorate([applaunchService_monitoring], ApplaunchService.prototype, "getApplaunch", null);
applaunchService_decorate([withJWT, applaunchService_monitoring], ApplaunchService.prototype, "getCustomization", null);
var applaunchService = new ApplaunchService();
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/pick.js
var pick = __webpack_require__(19334);
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);
;// CONCATENATED MODULE: ./src/logic/features/features.actions.js







function features_actions_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function features_actions_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? features_actions_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : features_actions_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var getFeatureFlipping = function getFeatureFlipping(configuredBannedFeatures, configuredFeatureFlipping) {
  var customizedFeatureFlipping = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!configuredBannedFeatures) {
    throw new Error('Missing banned features from config');
  }
  if (!configuredFeatureFlipping) {
    throw new Error('Missing feature flipping from config');
  }
  var featureFlippingWithCustomization = features_actions_objectSpread(features_actions_objectSpread({}, configuredFeatureFlipping), pick_default()(customizedFeatureFlipping, Object.keys(configuredFeatureFlipping)));
  return Object.entries(featureFlippingWithCustomization).reduce(function (memo, _ref) {
    var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return features_actions_objectSpread(features_actions_objectSpread({}, memo), {}, (0,defineProperty/* default */.Z)({}, key, configuredBannedFeatures.includes(key) ? false : value));
  }, {});
};
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/forOwn.js
var forOwn = __webpack_require__(14287);
var forOwn_default = /*#__PURE__*/__webpack_require__.n(forOwn);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/utils/syncFetch.js

var fetchSync = function fetchSync(url, body, headers) {
  var xhr = new XMLHttpRequest();
  xhr.open('POST', url, false);
  xhr.setRequestHeader('Content-Type', 'application/json');
  forOwn_default()(headers, function (headerValue, headerName) {
    xhr.setRequestHeader(headerName, headerValue);
  });
  return xhr.send(JSON.stringify(body));
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/heartbeat/heartbeat.utils.js


var isLiveSession = function isLiveSession(clipType) {
  try {
    return ['live', 'startover'].includes(clipType);
  } catch (_a) {
    throw new Error('Something is wrong with the clipType');
  }
};
var getUserConfiguration = function getUserConfiguration(user) {
  if (user && user.UID) {
    return {
      uid: user.UID,
      uidType: 'gigya'
    };
  }
  return {
    uid: es_fido/* fido */.n.get('localDeviceId'),
    uidType: 'deviceid'
  };
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/heartbeat/heartbeatService.js


















function heartbeatService_createSuper(t) { var r = heartbeatService_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function heartbeatService_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (heartbeatService_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var heartbeatService_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,esm_typeof/* default */.Z)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};







var heartbeatService_monitoring = withMonitoring_withMonitoring('heartbeat');
var HeartbeatService = function (_FetcherService) {
  (0,inherits/* default */.Z)(HeartbeatService, _FetcherService);
  var _super = heartbeatService_createSuper(HeartbeatService);
  function HeartbeatService() {
    var _this;
    (0,classCallCheck/* default */.Z)(this, HeartbeatService);
    _this = _super.apply(this, arguments);
    _this.apiType = 'heartbeatv2';
    return _this;
  }
  (0,createClass/* default */.Z)(HeartbeatService, [{
    key: "init",
    value: function init() {
      if (!this.isInitialized) {
        this.isInitialized = true;
        this.basePath = "platforms/".concat(es_fido/* fido */.n.get('platformCode'), "/notify");
        this.platformCode = es_fido/* fido */.n.get('platformCode');
        this.monitoring = heartbeatService_monitoring;
      }
    }
  }, {
    key: "createSession",
    value: function createSession() {
      var _this2 = this;
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$sessionData = _ref.sessionData,
        sessionData = _ref$sessionData === void 0 ? null : _ref$sessionData,
        _ref$user = _ref.user,
        user = _ref$user === void 0 ? null : _ref$user,
        _ref$headers = _ref.headers,
        headers = _ref$headers === void 0 ? {} : _ref$headers;
      if (!sessionData || !sessionData.clipType) {
        throw new Error('You should provide a non null sessionData');
      }
      var isLive = isLiveSession(sessionData.clipType);
      var endpoint = "session".concat(isLive ? '_live' : '');
      var url = this.getRouteUrl(endpoint);
      var body = Object.assign(Object.assign({
        platformCode: this.platformCode
      }, getUserConfiguration(user)), sessionData);
      return this.fetch(url, {
        method: 'POST',
        body: body,
        headers: headers
      }).then(function (_ref2) {
        var sessionId = _ref2.sessionId;
        return {
          sessionId: sessionId,
          sendView: _this2.sendView({
            user: user,
            isLive: isLive,
            sessionId: sessionId
          })
        };
      });
    }
  }, {
    key: "sendView",
    value: function sendView() {
      var _this3 = this;
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref3$user = _ref3.user,
        user = _ref3$user === void 0 ? null : _ref3$user,
        _ref3$isLive = _ref3.isLive,
        isLive = _ref3$isLive === void 0 ? false : _ref3$isLive,
        _ref3$sessionId = _ref3.sessionId,
        sessionId = _ref3$sessionId === void 0 ? null : _ref3$sessionId;
      if (typeof isLive !== 'boolean' || !sessionId) {
        throw new Error('Something went wrong during the session creation');
      }
      return function () {
        var _ref4 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(viewData) {
          var isSync,
            endpoint,
            url,
            body,
            token,
            headers,
            urlWithHeaders,
            formData,
            _args = arguments;
          return regenerator_default().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                isSync = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
                if (viewData) {
                  _context.next = 3;
                  break;
                }
                throw new Error('You should provide a non null viewData');
              case 3:
                endpoint = "view".concat(isLive ? '_live' : '');
                url = _this3.getRouteUrl(endpoint);
                body = Object.assign(Object.assign(Object.assign({
                  platformCode: _this3.platformCode
                }, getUserConfiguration(user)), viewData), {
                  sessionId: sessionId
                });
                _context.next = 8;
                return tokenService.getToken();
              case 8:
                token = _context.sent;
                headers = {
                  Authorization: "Bearer ".concat(token)
                };
                if (!isSync) {
                  _context.next = 20;
                  break;
                }
                if (!(navigator.sendBeacon && window.FormData && typeof window.URL === 'function')) {
                  _context.next = 19;
                  break;
                }
                urlWithHeaders = new URL(url);
                urlWithHeaders.searchParams.append('authorization', token);
                urlWithHeaders.searchParams.append('customerName', es_fido/* fido */.n.get('customerCode'));
                urlWithHeaders.searchParams.append('clientRelease', es_fido/* fido */.n.get('appVersion'));
                formData = new FormData();
                Object.keys(body).forEach(function (key) {
                  return formData.append(key, body[key]);
                });
                return _context.abrupt("return", navigator.sendBeacon(urlWithHeaders.href, formData));
              case 19:
                return _context.abrupt("return", fetchSync(url, body, headers));
              case 20:
                return _context.abrupt("return", _this3.monitoring(HeartbeatService.prototype, 'sendView', {
                  value: function value() {
                    return _this3.fetch(url, {
                      method: 'POST',
                      body: body,
                      headers: headers
                    });
                  }
                }).value());
              case 21:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref4.apply(this, arguments);
        };
      }();
    }
  }]);
  return HeartbeatService;
}(fetcherService/* FetcherService */.x);
heartbeatService_decorate([withJWT, heartbeatService_monitoring], HeartbeatService.prototype, "createSession", null);
var heartbeatService = new HeartbeatService();
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/heartbeatv3/heartbeatService.js



















function heartbeatv3_heartbeatService_createSuper(t) { var r = heartbeatv3_heartbeatService_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function heartbeatv3_heartbeatService_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (heartbeatv3_heartbeatService_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var heartbeatv3_heartbeatService_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,esm_typeof/* default */.Z)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var heartbeatv3_heartbeatService_monitoring = withMonitoring_withMonitoring('heartbeat');
var heartbeatService_HeartbeatService = function (_FetcherService) {
  (0,inherits/* default */.Z)(HeartbeatService, _FetcherService);
  var _super = heartbeatv3_heartbeatService_createSuper(HeartbeatService);
  function HeartbeatService() {
    var _this;
    (0,classCallCheck/* default */.Z)(this, HeartbeatService);
    _this = _super.apply(this, arguments);
    _this.apiType = 'heartbeatv3';
    return _this;
  }
  (0,createClass/* default */.Z)(HeartbeatService, [{
    key: "init",
    value: function init() {
      if (!this.isInitialized) {
        this.isInitialized = true;
        this.basePath = "".concat(es_fido/* fido */.n.get('customerCode'), "/").concat(es_fido/* fido */.n.get('platformCode'));
      }
    }
  }, {
    key: "videoStart",
    value: (function () {
      var _videoStart = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee() {
        var _ref,
          _ref$layoutData,
          layoutData,
          _ref$metrics,
          metrics,
          _ref$headers,
          headers,
          _sourceType,
          body,
          url,
          _args = arguments;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _ref = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, _ref$layoutData = _ref.layoutData, layoutData = _ref$layoutData === void 0 ? null : _ref$layoutData, _ref$metrics = _ref.metrics, metrics = _ref$metrics === void 0 ? {} : _ref$metrics, _ref$headers = _ref.headers, headers = _ref$headers === void 0 ? {} : _ref$headers;
              if (!(!layoutData || !layoutData.contentType)) {
                _context.next = 3;
                break;
              }
              throw new Error('You should provide a non null contentType');
            case 3:
              _sourceType = layoutData.contentType === 'live' ? layoutData.contentType : 'vod';
              body = Object.assign({
                sourceType: _sourceType,
                playerContext: this.createPlayerContext(metrics)
              }, layoutData);
              url = this.getServiceRouteUrl(this.basePath, "video_start");
              return _context.abrupt("return", this.fetch(url, {
                method: 'POST',
                body: body,
                headers: headers
              }));
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function videoStart() {
        return _videoStart.apply(this, arguments);
      }
      return videoStart;
    }())
  }, {
    key: "videoConsuming",
    value: (function () {
      var _videoConsuming = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2() {
        var _ref2,
          eventType,
          refToken,
          timecode,
          metrics,
          _ref2$headers,
          headers,
          _ref2$isSync,
          isSync,
          body,
          url,
          token,
          urlWithHeaders,
          formData,
          _args2 = arguments;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _ref2 = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {}, eventType = _ref2.eventType, refToken = _ref2.refToken, timecode = _ref2.timecode, metrics = _ref2.metrics, _ref2$headers = _ref2.headers, headers = _ref2$headers === void 0 ? {} : _ref2$headers, _ref2$isSync = _ref2.isSync, isSync = _ref2$isSync === void 0 ? false : _ref2$isSync;
              if (refToken) {
                _context2.next = 3;
                break;
              }
              throw new Error('You should create a session with videoStart before sending events');
            case 3:
              body = {
                playerContext: this.createPlayerContext(metrics),
                refToken: refToken,
                timecode: timecode
              };
              url = this.getServiceRouteUrl(this.basePath, "video_consuming/".concat(eventType));
              if (isSync) {
                _context2.next = 7;
                break;
              }
              return _context2.abrupt("return", this.fetch(url, {
                method: 'POST',
                body: body,
                headers: headers
              }));
            case 7:
              if (!(!navigator.sendBeacon || !window.FormData || typeof window.URL !== 'function')) {
                _context2.next = 9;
                break;
              }
              return _context2.abrupt("return", fetchSync(url, body, headers));
            case 9:
              _context2.next = 11;
              return tokenService.getToken();
            case 11:
              token = _context2.sent;
              urlWithHeaders = new URL(url);
              urlWithHeaders.searchParams.append('authorization', token);
              urlWithHeaders.searchParams.append('customerName', es_fido/* fido */.n.get('customerCode'));
              urlWithHeaders.searchParams.append('clientRelease', es_fido/* fido */.n.get('appVersion'));
              formData = new FormData();
              formData.append('body', JSON.stringify(body));
              return _context2.abrupt("return", navigator.sendBeacon(urlWithHeaders.href, formData));
            case 19:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function videoConsuming() {
        return _videoConsuming.apply(this, arguments);
      }
      return videoConsuming;
    }())
  }, {
    key: "createPlayerContext",
    value: function createPlayerContext(metrics) {
      return Object.assign({
        bandwidth: 0,
        bitrate: 0,
        bufferSize: 0,
        droppedFrames: 0,
        resolution: 0
      }, metrics);
    }
  }, {
    key: "getServiceRouteUrl",
    value: function getServiceRouteUrl() {
      var basePath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var endpoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var clientCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : es_fido/* fido */.n.get('clientCode');
      this.checkInit();
      if (!this.apiType) {
        throw new Error("You should define an API type for Fido's ".concat(this.getName()));
      }
      return "".concat(es_fido/* fido */.n.getBaseUrl(this.apiType).replace('%(clientCode)s', clientCode), "/").concat(basePath, "/").concat(endpoint);
    }
  }]);
  return HeartbeatService;
}(fetcherService/* FetcherService */.x);
heartbeatv3_heartbeatService_decorate([withJWT, heartbeatv3_heartbeatService_monitoring], heartbeatService_HeartbeatService.prototype, "videoStart", null);
heartbeatv3_heartbeatService_decorate([withJWT, heartbeatv3_heartbeatService_monitoring], heartbeatService_HeartbeatService.prototype, "videoConsuming", null);
var heartbeatServiceV3 = new heartbeatService_HeartbeatService();
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/program/programService.js











function programService_createSuper(t) { var r = programService_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function programService_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (programService_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var programService_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,esm_typeof/* default */.Z)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var programService_monitoring = withMonitoring_withMonitoring('program');
var ProgramService = function (_FetcherService) {
  (0,inherits/* default */.Z)(ProgramService, _FetcherService);
  var _super = programService_createSuper(ProgramService);
  function ProgramService() {
    var _this;
    (0,classCallCheck/* default */.Z)(this, ProgramService);
    _this = _super.apply(this, arguments);
    _this.apiType = 'middlewarev2';
    return _this;
  }
  (0,createClass/* default */.Z)(ProgramService, [{
    key: "init",
    value: function init() {
      if (!this.isInitialized) {
        this.basePath = "platforms/".concat(es_fido/* fido */.n.get('platformCode'), "/services");
        this.isInitialized = true;
      }
    }
  }, {
    key: "fetchByProgramId",
    value: (function () {
      var _fetchByProgramId = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(_ref) {
        var programId, serviceCode, _ref$queryParams, queryParams, _ref$headers, headers;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              programId = _ref.programId, serviceCode = _ref.serviceCode, _ref$queryParams = _ref.queryParams, queryParams = _ref$queryParams === void 0 ? {} : _ref$queryParams, _ref$headers = _ref.headers, headers = _ref$headers === void 0 ? {} : _ref$headers;
              if (programId) {
                _context.next = 3;
                break;
              }
              throw new Error('You should provide a non null programId');
            case 3:
              return _context.abrupt("return", this.fetch(this.getRouteUrl("".concat(serviceCode, "/programs/").concat(programId, "?").concat((0,queryParamSerializer/* serialize */.q)(queryParams))), {
                method: 'GET',
                headers: headers
              }));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchByProgramId(_x) {
        return _fetchByProgramId.apply(this, arguments);
      }
      return fetchByProgramId;
    }())
  }, {
    key: "fetchPrograms",
    value: (function () {
      var _fetchPrograms = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2(_ref2) {
        var serviceCode, csa, offset, limit, _ref2$headers, headers;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              serviceCode = _ref2.serviceCode, csa = _ref2.csa, offset = _ref2.offset, limit = _ref2.limit, _ref2$headers = _ref2.headers, headers = _ref2$headers === void 0 ? {} : _ref2$headers;
              if (serviceCode) {
                _context2.next = 3;
                break;
              }
              throw new Error('You should provide a service code');
            case 3:
              if (csa) {
                _context2.next = 5;
                break;
              }
              throw new Error('You should provide a csa code');
            case 5:
              if (!(typeof offset !== 'number' || isNaN(offset))) {
                _context2.next = 7;
                break;
              }
              throw new Error('You should provide a valid numeric offset');
            case 7:
              if (!(typeof limit !== 'number' || isNaN(limit))) {
                _context2.next = 9;
                break;
              }
              throw new Error('You should provide a valid numeric limit');
            case 9:
              _context2.next = 11;
              return this.fetchWithResponse(this.getRouteUrl("".concat(serviceCode, "/programs?csa=").concat(csa, "&offset=").concat(offset, "&limit=").concat(limit)), {
                method: 'GET',
                headers: headers
              });
            case 11:
              return _context2.abrupt("return", _context2.sent);
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchPrograms(_x2) {
        return _fetchPrograms.apply(this, arguments);
      }
      return fetchPrograms;
    }())
  }, {
    key: "fetchProgramCountsByLetter",
    value: (function () {
      var _fetchProgramCountsByLetter = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee3(_ref3) {
        var serviceCode, csa, _ref3$headers, headers;
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              serviceCode = _ref3.serviceCode, csa = _ref3.csa, _ref3$headers = _ref3.headers, headers = _ref3$headers === void 0 ? {} : _ref3$headers;
              if (serviceCode) {
                _context3.next = 3;
                break;
              }
              throw new Error('You should provide a service code');
            case 3:
              if (csa) {
                _context3.next = 5;
                break;
              }
              throw new Error('You should provide a csa code');
            case 5:
              _context3.next = 7;
              return this.fetch(this.getRouteUrl("".concat(serviceCode, "/programs/first-letters?csa=").concat(csa)), {
                method: 'GET',
                headers: headers
              });
            case 7:
              return _context3.abrupt("return", _context3.sent);
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function fetchProgramCountsByLetter(_x3) {
        return _fetchProgramCountsByLetter.apply(this, arguments);
      }
      return fetchProgramCountsByLetter;
    }())
  }]);
  return ProgramService;
}(fetcherService/* FetcherService */.x);
programService_decorate([withJWT, programService_monitoring], ProgramService.prototype, "fetchByProgramId", null);
programService_decorate([programService_monitoring], ProgramService.prototype, "fetchPrograms", null);
programService_decorate([programService_monitoring], ProgramService.prototype, "fetchProgramCountsByLetter", null);
var programService = new ProgramService();
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/time/timeService.js

var timeService_timeService = new simpleFetcherService_SimpleFetcherService('time');
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/video/videoService.js











function videoService_createSuper(t) { var r = videoService_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function videoService_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (videoService_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var videoService_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,esm_typeof/* default */.Z)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var videoService_monitoring = withMonitoring_withMonitoring('video');
var VideoService = function (_FetcherService) {
  (0,inherits/* default */.Z)(VideoService, _FetcherService);
  var _super = videoService_createSuper(VideoService);
  function VideoService() {
    var _this;
    (0,classCallCheck/* default */.Z)(this, VideoService);
    _this = _super.apply(this, arguments);
    _this.apiType = 'middlewarev2';
    return _this;
  }
  (0,createClass/* default */.Z)(VideoService, [{
    key: "init",
    value: function init() {
      if (!this.isInitialized) {
        this.basePath = "platforms/".concat(es_fido/* fido */.n.get('platformCode'), "/services");
        this.isInitialized = true;
      }
    }
  }, {
    key: "fetchByVideoId",
    value: (function () {
      var _fetchByVideoId = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee() {
        var _ref,
          videoId,
          serviceCode,
          _ref$queryParams,
          queryParams,
          _ref$headers,
          headers,
          _args = arguments;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _ref = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, videoId = _ref.videoId, serviceCode = _ref.serviceCode, _ref$queryParams = _ref.queryParams, queryParams = _ref$queryParams === void 0 ? {} : _ref$queryParams, _ref$headers = _ref.headers, headers = _ref$headers === void 0 ? {} : _ref$headers;
              if (!(!videoId || !serviceCode)) {
                _context.next = 3;
                break;
              }
              throw new Error('You should provide non null videoId and serviceCode');
            case 3:
              _context.prev = 3;
              _context.next = 6;
              return this.fetch(this.getRouteUrl("".concat(serviceCode, "/videos/").concat(videoId, "?").concat((0,queryParamSerializer/* serialize */.q)(queryParams))), {
                method: 'GET',
                headers: headers
              });
            case 6:
              return _context.abrupt("return", _context.sent);
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](3);
              if (!(_context.t0.response && _context.t0.response.status === 410)) {
                _context.next = 13;
                break;
              }
              return _context.abrupt("return", _context.t0.response.body);
            case 13:
              throw _context.t0;
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[3, 9]]);
      }));
      function fetchByVideoId() {
        return _fetchByVideoId.apply(this, arguments);
      }
      return fetchByVideoId;
    }())
  }, {
    key: "fetchNextVideos",
    value: (function () {
      var _fetchNextVideos = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2() {
        var _ref2,
          videoId,
          serviceCode,
          _ref2$queryParams,
          queryParams,
          _ref2$headers,
          headers,
          _args2 = arguments;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _ref2 = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {}, videoId = _ref2.videoId, serviceCode = _ref2.serviceCode, _ref2$queryParams = _ref2.queryParams, queryParams = _ref2$queryParams === void 0 ? {
                csa: 0,
                type: 'vi',
                with: 'clips,freemiumpacks,program_images'
              } : _ref2$queryParams, _ref2$headers = _ref2.headers, headers = _ref2$headers === void 0 ? {} : _ref2$headers;
              if (!(!videoId || !serviceCode)) {
                _context2.next = 3;
                break;
              }
              throw new Error('You should provide non null videoId and serviceCode');
            case 3:
              return _context2.abrupt("return", this.fetch(this.getRouteUrl("".concat(serviceCode, "/videos/").concat(videoId, "/nextvideos?").concat((0,queryParamSerializer/* serialize */.q)(queryParams))), {
                method: 'GET',
                headers: headers
              }));
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchNextVideos() {
        return _fetchNextVideos.apply(this, arguments);
      }
      return fetchNextVideos;
    }())
  }, {
    key: "fetchVideosByProgramId",
    value: (function () {
      var _fetchVideosByProgramId = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee3() {
        var _ref3,
          programId,
          serviceCode,
          _ref3$queryParams,
          queryParams,
          _ref3$headers,
          headers,
          _args3 = arguments;
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _ref3 = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {}, programId = _ref3.programId, serviceCode = _ref3.serviceCode, _ref3$queryParams = _ref3.queryParams, queryParams = _ref3$queryParams === void 0 ? {
                csa: 0,
                offset: 0,
                limit: 20,
                type: 'vi'
              } : _ref3$queryParams, _ref3$headers = _ref3.headers, headers = _ref3$headers === void 0 ? {} : _ref3$headers;
              if (!(!programId || !serviceCode)) {
                _context3.next = 3;
                break;
              }
              throw new Error('You should provide non null programId and serviceCode');
            case 3:
              return _context3.abrupt("return", this.fetch(this.getRouteUrl("".concat(serviceCode, "/programs/").concat(programId, "/videos?").concat((0,queryParamSerializer/* serialize */.q)(queryParams))), {
                method: 'GET',
                headers: headers
              }));
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function fetchVideosByProgramId() {
        return _fetchVideosByProgramId.apply(this, arguments);
      }
      return fetchVideosByProgramId;
    }())
  }, {
    key: "fetchByExternalKey",
    value: (function () {
      var _fetchByExternalKey = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee4() {
        var _ref4,
          externalKey,
          serviceCode,
          _ref4$queryParams,
          queryParams,
          _ref4$headers,
          headers,
          _args4 = arguments;
        return regenerator_default().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _ref4 = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {}, externalKey = _ref4.externalKey, serviceCode = _ref4.serviceCode, _ref4$queryParams = _ref4.queryParams, queryParams = _ref4$queryParams === void 0 ? {
                csa: 0
              } : _ref4$queryParams, _ref4$headers = _ref4.headers, headers = _ref4$headers === void 0 ? {} : _ref4$headers;
              if (!(!externalKey || !serviceCode)) {
                _context4.next = 3;
                break;
              }
              throw new Error('You should provide non null externalKey or serviceCode');
            case 3:
              return _context4.abrupt("return", this.fetch(this.getRouteUrl("".concat(serviceCode, "/videos/external_asset/").concat(externalKey, "?").concat((0,queryParamSerializer/* serialize */.q)(queryParams))), {
                method: 'GET',
                headers: headers
              }));
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function fetchByExternalKey() {
        return _fetchByExternalKey.apply(this, arguments);
      }
      return fetchByExternalKey;
    }())
  }]);
  return VideoService;
}(fetcherService/* FetcherService */.x);
videoService_decorate([withJWT, videoService_monitoring], VideoService.prototype, "fetchByVideoId", null);
videoService_decorate([withJWT, videoService_monitoring], VideoService.prototype, "fetchNextVideos", null);
videoService_decorate([withJWT, videoService_monitoring], VideoService.prototype, "fetchVideosByProgramId", null);
videoService_decorate([withJWT, videoService_monitoring], VideoService.prototype, "fetchByExternalKey", null);
var videoService = new VideoService();
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/freemium/freemium.constants.js
var couponStatus = {
  VALID: 'VALID',
  ALREADY_USED: 'ALREADY_USED',
  INVALID: 'INVALID'
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/freemium/freemiumService.js











function freemiumService_createSuper(t) { var r = freemiumService_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function freemiumService_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (freemiumService_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var freemiumService_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,esm_typeof/* default */.Z)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};








var freemiumService_monitoring = withMonitoring_withMonitoring('freemium');
var FreemiumService = function (_FetcherService) {
  (0,inherits/* default */.Z)(FreemiumService, _FetcherService);
  var _super = freemiumService_createSuper(FreemiumService);
  function FreemiumService() {
    var _this;
    (0,classCallCheck/* default */.Z)(this, FreemiumService);
    _this = _super.apply(this, arguments);
    _this.apiType = 'coupons';
    return _this;
  }
  (0,createClass/* default */.Z)(FreemiumService, [{
    key: "init",
    value: function init() {
      if (!this.isInitialized) {
        this.isInitialized = true;
      }
    }
  }, {
    key: "getUserSubscriptions",
    value: (function () {
      var _getUserSubscriptions = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(_ref) {
        var user, _ref$headers, headers, apiURL;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              user = _ref.user, _ref$headers = _ref.headers, headers = _ref$headers === void 0 ? {} : _ref$headers;
              this.checkInit('userv2');
              if (user.UID) {
                _context.next = 4;
                break;
              }
              throw new Error('You should provide a non null uid');
            case 4:
              apiURL = "".concat(es_fido/* fido */.n.getBaseUrl('userv2'), "/platforms/").concat(es_fido/* fido */.n.get('platformCode'), "/users/").concat(user.UID, "/freemiumsubscriptions");
              return _context.abrupt("return", this.fetch(apiURL, {
                method: 'GET',
                headers: headers
              }));
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getUserSubscriptions(_x) {
        return _getUserSubscriptions.apply(this, arguments);
      }
      return getUserSubscriptions;
    }())
  }, {
    key: "validateSubscriptionWithReceipt",
    value: function validateSubscriptionWithReceipt(receipt, user, _ref2) {
      var _ref2$headers = _ref2.headers,
        headers = _ref2$headers === void 0 ? {} : _ref2$headers;
      this.checkInit('userv2');
      var receiptCheckURL = "".concat(es_fido/* fido */.n.getBaseUrl('userv2'), "/platforms/").concat(es_fido/* fido */.n.get('platformCode'), "/users/").concat(user.UID, "/stores/bedrock-freecoupons/receiptCheck");
      return this.fetch(receiptCheckURL, {
        method: 'POST',
        headers: headers,
        body: {
          receiptData: receipt.data
        }
      });
    }
  }, {
    key: "verifyCoupon",
    value: (function () {
      var _verifyCoupon = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2() {
        var _ref3,
          couponCode,
          user,
          couponVerificationURL,
          userHeaders,
          receipt,
          status,
          result,
          _args2 = arguments;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _ref3 = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {}, couponCode = _ref3.couponCode, user = _ref3.user;
              this.checkInit();
              if (couponCode) {
                _context2.next = 4;
                break;
              }
              throw new Error('You should provide a non null couponCode');
            case 4:
              if (user.UID) {
                _context2.next = 6;
                break;
              }
              throw new Error('You should provide a non null uid');
            case 6:
              couponVerificationURL = "".concat(es_fido/* fido */.n.getBaseUrl('coupons'), "/platforms/").concat(es_fido/* fido */.n.get('platformCode'), "/users/").concat(user.UID, "/coupons");
              userHeaders = getGigyaUserHeader(user);
              receipt = null;
              _context2.prev = 9;
              _context2.next = 12;
              return this.fetch(couponVerificationURL, {
                method: 'POST',
                headers: userHeaders,
                body: {
                  code: couponCode
                }
              });
            case 12:
              receipt = _context2.sent;
              _context2.next = 19;
              break;
            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2["catch"](9);
              status = _context2.t0.status;
              return _context2.abrupt("return", {
                status: status === 400 ? couponStatus.ALREADY_USED : couponStatus.INVALID
              });
            case 19:
              _context2.next = 21;
              return this.validateSubscriptionWithReceipt(receipt, user, {
                headers: userHeaders
              }).catch(function () {
                return null;
              });
            case 21:
              result = _context2.sent;
              return _context2.abrupt("return", {
                status: couponStatus.VALID,
                subscribedPlanCode: get_default()(result, 'subscribed_pack.code', null)
              });
            case 23:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[9, 15]]);
      }));
      function verifyCoupon() {
        return _verifyCoupon.apply(this, arguments);
      }
      return verifyCoupon;
    }())
  }, {
    key: "getOffers",
    value: (function () {
      var _getOffers = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee3() {
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.checkInit();
              return _context3.abrupt("return", this.fetch("https://static.6cloud.fr/m6group_web/6play/".concat(es_fido/* fido */.n.get('customerCode'), "/subscription/plans.json")));
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getOffers() {
        return _getOffers.apply(this, arguments);
      }
      return getOffers;
    }())
  }, {
    key: "getOffersFromLocalServer",
    value: function () {
      var _getOffersFromLocalServer = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee4() {
        return regenerator_default().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.checkInit();
              return _context4.abrupt("return", this.fetch("".concat(window.location.origin, "/get-offers")));
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getOffersFromLocalServer() {
        return _getOffersFromLocalServer.apply(this, arguments);
      }
      return getOffersFromLocalServer;
    }()
  }]);
  return FreemiumService;
}(fetcherService/* FetcherService */.x);
freemiumService_decorate([withJWT, withNoParallelRequest, freemiumService_monitoring], FreemiumService.prototype, "getUserSubscriptions", null);
freemiumService_decorate([freemiumService_monitoring], FreemiumService.prototype, "validateSubscriptionWithReceipt", null);
freemiumService_decorate([freemiumService_monitoring], FreemiumService.prototype, "verifyCoupon", null);
freemiumService_decorate([freemiumService_monitoring], FreemiumService.prototype, "getOffers", null);
var freemiumService = new FreemiumService();
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+fido-sdk@29.30.0/node_modules/@bedrock/fido-sdk/es/services/user/pairingService.js









function pairingService_createSuper(t) { var r = pairingService_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function pairingService_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (pairingService_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var pairingService_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,esm_typeof/* default */.Z)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var pairingService_monitoring = withMonitoring_withMonitoring('user');
var PairingService = function (_FetcherService) {
  (0,inherits/* default */.Z)(PairingService, _FetcherService);
  var _super = pairingService_createSuper(PairingService);
  function PairingService() {
    var _this;
    (0,classCallCheck/* default */.Z)(this, PairingService);
    _this = _super.apply(this, arguments);
    _this.apiType = 'userv2';
    return _this;
  }
  (0,createClass/* default */.Z)(PairingService, [{
    key: "init",
    value: function init() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$boxType = _ref.boxType,
        boxType = _ref$boxType === void 0 ? es_fido/* fido */.n.get('clientCode') : _ref$boxType,
        _ref$prefixedBoxId = _ref.prefixedBoxId,
        prefixedBoxId = _ref$prefixedBoxId === void 0 ? false : _ref$prefixedBoxId;
      if (!this.isInitialized) {
        this.basePath = "platforms/".concat(es_fido/* fido */.n.get('platformCode'));
        this.boxType = boxType;
        this.prefixedBoxId = prefixedBoxId;
        this.isInitialized = true;
      }
    }
  }, {
    key: "getBoxId",
    value: function getBoxId() {
      return this.getHomeOrDeviceId(this.prefixedBoxId);
    }
  }, {
    key: "getPairingToken",
    value: function getPairingToken() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref2$headers = _ref2.headers,
        headers = _ref2$headers === void 0 ? {} : _ref2$headers,
        phoneNumber = _ref2.phoneNumber,
        boxName = _ref2.boxName,
        tokenValidityDurationInMin = _ref2.tokenValidityDurationInMin;
      var endpoint = 'box';
      var url = this.getRouteUrl(endpoint);
      var body = Object.assign(Object.assign(Object.assign({
        boxType: this.boxType,
        boxId: this.getBoxId()
      }, phoneNumber && {
        phoneNumber: phoneNumber
      }), boxName && {
        boxName: boxName
      }), tokenValidityDurationInMin && {
        tokenValidityDurationInMin: tokenValidityDurationInMin
      });
      return this.fetch(url, {
        method: 'POST',
        body: body,
        headers: headers
      });
    }
  }, {
    key: "getPairingStatus",
    value: function getPairingStatus(_ref3) {
      var token = _ref3.token,
        _ref3$headers = _ref3.headers,
        headers = _ref3$headers === void 0 ? {} : _ref3$headers;
      var endpoint = "boxTypes/".concat(this.boxType, "/boxIds/").concat(this.getBoxId(), "/tokens/").concat(token, "/status");
      var url = this.getRouteUrl(endpoint);
      return this.fetch(url, {
        method: 'GET',
        headers: headers
      });
    }
  }, {
    key: "pair",
    value: function pair(_ref4) {
      var _ref4$headers = _ref4.headers,
        headers = _ref4$headers === void 0 ? {} : _ref4$headers,
        uid = _ref4.uid,
        token = _ref4.token;
      if (!uid) {
        throw new Error('You should provide an uid');
      }
      var endpoint = "users/".concat(uid, "/box");
      var url = this.getRouteUrl(endpoint);
      var body = Object.assign({}, token && {
        pair_token: token
      });
      return this.fetch(url, {
        method: 'POST',
        body: body,
        headers: headers
      });
    }
  }, {
    key: "unpair",
    value: function unpair(_ref5) {
      var uid = _ref5.uid,
        _ref5$headers = _ref5.headers,
        headers = _ref5$headers === void 0 ? {} : _ref5$headers;
      if (!uid) {
        throw new Error('You should provide an uid');
      }
      var endpoint = "users/".concat(uid, "/boxTypes/").concat(this.boxType, "/boxIds/").concat(this.getBoxId());
      var url = this.getRouteUrl(endpoint);
      return this.fetch(url, {
        method: 'DELETE',
        headers: headers
      });
    }
  }, {
    key: "unpairAll",
    value: function unpairAll(_ref6) {
      var uid = _ref6.uid,
        _ref6$headers = _ref6.headers,
        headers = _ref6$headers === void 0 ? {} : _ref6$headers;
      if (!uid) {
        throw new Error('You should provide an uid');
      }
      var endpoint = "users/".concat(uid, "/boxes");
      var url = this.getRouteUrl(endpoint);
      return this.fetch(url, {
        method: 'DELETE',
        headers: headers
      });
    }
  }, {
    key: "getPairedUsers",
    value: function getPairedUsers(_ref7) {
      var _ref7$headers = _ref7.headers,
        headers = _ref7$headers === void 0 ? {} : _ref7$headers;
      var endpoint = "boxTypes/".concat(this.boxType, "/boxIds/").concat(this.getBoxId(), "/users");
      var url = this.getRouteUrl(endpoint);
      return this.fetch(url, {
        method: 'GET',
        headers: headers
      });
    }
  }, {
    key: "getThumbnail",
    value: function getThumbnail(_ref8) {
      var uid = _ref8.uid,
        _ref8$headers = _ref8.headers,
        headers = _ref8$headers === void 0 ? {} : _ref8$headers;
      if (!uid) {
        throw new Error('You should provide an uid');
      }
      var endpoint = "boxTypes/".concat(this.boxType, "/boxIds/").concat(this.getBoxId(), "/users/").concat(uid, "/thumbnail");
      var url = this.getRouteUrl(endpoint);
      return this.fetch(url, {
        method: 'GET',
        headers: headers
      });
    }
  }]);
  return PairingService;
}(fetcherService/* FetcherService */.x);
pairingService_decorate([withJWT, pairingService_monitoring], PairingService.prototype, "getPairingToken", null);
pairingService_decorate([withJWT, pairingService_monitoring], PairingService.prototype, "getPairingStatus", null);
pairingService_decorate([withJWT, pairingService_monitoring], PairingService.prototype, "pair", null);
pairingService_decorate([withJWT, pairingService_monitoring], PairingService.prototype, "unpair", null);
pairingService_decorate([withJWT, pairingService_monitoring], PairingService.prototype, "unpairAll", null);
pairingService_decorate([withJWT, pairingService_monitoring], PairingService.prototype, "getPairedUsers", null);
pairingService_decorate([withJWT, pairingService_monitoring], PairingService.prototype, "getThumbnail", null);
var pairingService = new PairingService();
;// CONCATENATED MODULE: ./src/logic/app/fido.oidc.js









var fido_oidc_STORAGE_KEYS = {
  ACCESS_TOKEN: 'oidcAccessToken',
  REFRESH_TOKEN: 'oidcRefreshToken',
  ID_TOKEN: 'oidcIdToken',
  CODE_VERIFIER: 'oidcCodeVerifier'
};
var patchOIDC = function patchOIDC(base) {
  base.isTokenValid = function isTokenValid(token) {
    if (!token) {
      return false;
    }
    try {
      var decodedToken = lib_default()(token);
      if (!decodedToken.exp && !Number.isFinite(decodedToken.exp)) {
        return true;
      }
      return new Date().getTime() < (decodedToken.exp - 10) * 1000;
    } catch (error) {
      return false;
    }
  };
  base.storeToken = function storeToken(token, key) {
    if (!token || token === 'null') {
      localStorage.removeItem(key);
      return null;
    }
    localStorage.setItem(key, token);
    return token;
  };
  base.setAccessToken = function setAccessToken(token) {
    this.accessToken = this.storeToken(token, fido_oidc_STORAGE_KEYS.ACCESS_TOKEN);
    if (!this.accessToken) {
      return;
    }
    try {
      var decodedToken = lib_default()(this.accessToken);
      if (decodedToken.birthdate) {
        lightningjs_redux.dispatch(completeAccount());
      }
    } catch (error) {
      console.error("[OIDC] Can not fetch birthdate from JWT".concat(error ? ": ".concat(error.message) : ''));
    }
  };
  base.setRefreshToken = function setRefreshToken(token) {
    this.refreshToken = this.storeToken(token, fido_oidc_STORAGE_KEYS.REFRESH_TOKEN);
  };
  base.setIdToken = function setIdToken(token) {
    this.idToken = this.storeToken(token, fido_oidc_STORAGE_KEYS.ID_TOKEN);
  };
  base.getOrFetchOidcTokens = function () {
    var _getOrFetchOidcTokens = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee() {
      var _this = this;
      var tokens;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            [fido_oidc_STORAGE_KEYS.ACCESS_TOKEN, fido_oidc_STORAGE_KEYS.REFRESH_TOKEN].forEach(function (tokenKeyName) {
              var token = localStorage.getItem(tokenKeyName);
              var isValid = _this.isTokenValid(token);
              if (!isValid) {
                localStorage.removeItem(tokenKeyName);
              }
            });
            this.setAccessToken(localStorage.getItem(fido_oidc_STORAGE_KEYS.ACCESS_TOKEN));
            this.setRefreshToken(localStorage.getItem(fido_oidc_STORAGE_KEYS.REFRESH_TOKEN));
            this.setIdToken(localStorage.getItem(fido_oidc_STORAGE_KEYS.ID_TOKEN));
            if (!this.accessToken) {
              _context.next = 6;
              break;
            }
            return _context.abrupt("return", {
              accessToken: this.accessToken,
              refreshToken: this.refreshToken
            });
          case 6:
            if (!this.refreshToken) {
              _context.next = 17;
              break;
            }
            _context.prev = 7;
            _context.next = 10;
            return this.renewAccessToken();
          case 10:
            _context.next = 15;
            break;
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](7);
            this.clearTokens();
          case 15:
            _context.next = 21;
            break;
          case 17:
            _context.next = 19;
            return this.fetchAnonymousTokens();
          case 19:
            tokens = _context.sent;
            this.setAccessToken(tokens.access_token);
          case 21:
            return _context.abrupt("return", {
              accessToken: this.accessToken || '',
              refreshToken: this.refreshToken || ''
            });
          case 22:
          case "end":
            return _context.stop();
        }
      }, _callee, this, [[7, 12]]);
    }));
    function getOrFetchOidcTokens() {
      return _getOrFetchOidcTokens.apply(this, arguments);
    }
    return getOrFetchOidcTokens;
  }();
  base.logout = function () {
    var _logout = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2() {
      var _this$endpoints;
      var logoutMode,
        accessToken,
        refreshToken,
        response,
        _args2 = arguments;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            logoutMode = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : 'ALL';
            if ((_this$endpoints = this.endpoints) !== null && _this$endpoints !== void 0 && _this$endpoints.CUSTOM_LOGOUT) {
              _context2.next = 3;
              break;
            }
            throw new Error('Custom logout endpoint is not configured for the current provider.');
          case 3:
            accessToken = this.getAccessToken();
            if (accessToken) {
              _context2.next = 6;
              break;
            }
            throw new Error('Access token is required to logout');
          case 6:
            refreshToken = this.getRefreshToken();
            if (refreshToken) {
              _context2.next = 9;
              break;
            }
            throw new Error('Refresh token is required to logout');
          case 9:
            _context2.next = 11;
            return this.externalFetch(this.getCustomApiUrl(this.endpoints.CUSTOM_LOGOUT), {
              method: 'POST',
              headers: {
                Authorization: "Bearer ".concat(accessToken)
              },
              body: {
                clientId: this.clientId,
                logoutMode: logoutMode,
                refreshToken: refreshToken
              }
            });
          case 11:
            response = _context2.sent;
            this.clearTokens();
            return _context2.abrupt("return", response);
          case 14:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function logout() {
      return _logout.apply(this, arguments);
    }
    return logout;
  }();
};
;// CONCATENATED MODULE: ./src/logic/app/fido.utils.js





function fido_utils_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function fido_utils_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? fido_utils_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : fido_utils_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






var initFidoSDK = function initFidoSDK(getState) {
  var state = getState();
  var homeId = user_selectors_getHomeId(state);
  var localDeviceId = getLocalDeviceId(state);
  var localHomeId = getLocalHomeId(state);
  var deviceId = user_selectors_getDeviceId(state);
  var ID = homeId || deviceId;
  var boxId = homeId || deviceId;
  var localId = localHomeId ? {
    localHomeId: localHomeId
  } : {
    localDeviceId: localDeviceId
  };
  var _Object$values = Object.values(localId),
    _Object$values2 = (0,slicedToArray/* default */.Z)(_Object$values, 1),
    localIdValue = _Object$values2[0];
  if (!(ID && localIdValue)) {
    throw new ReferenceError('The ID and localId are required to initialize fido.');
  }
  patchOIDC(oidcService_oidcService);
  var customerCode = (src_default()).customerCode,
    platformCode = (src_default()).platformCode,
    clientCode = (src_default()).clientCode,
    _config$fido = (src_default()).fido,
    baseUrlsByAPIType = _config$fido.baseUrlsByAPIType,
    saltAndSugar = _config$fido.saltAndSugar,
    imageSalt = _config$fido.imageSalt,
    oidc = (src_default()).oidc;
  var fidoConfig = fido_utils_objectSpread(fido_utils_objectSpread({
    customerCode: customerCode,
    platformCode: platformCode,
    getCurrentTime: function getCurrentTime() {
      return getCurrentMsTime(getState());
    },
    clientCode: clientCode,
    saltAndSugar: saltAndSugar,
    imageSalt: imageSalt,
    appVersion: env.appVersion
  }, localId), {}, {
    baseUrlsByAPIType: {
      monitoring: 'https://mon.m6web.fr'
    }
  });
  var boxType = clientCode;
  var applaunchConfig = getApplaunchConfig(ID);
  var services = [[applaunchService, [applaunchConfig]], geoService, gdprService, heartbeatService, heartbeatServiceV3, imageService, programService, [statsdMonitoringService_statsdMonitoringService, [true, {
    salt: (src_default()).monitoring.salt,
    enabled: true,
    platformCode: env.appPlatform
  }]], timeService_timeService, [tokenService, [{
    advertisingId: getPubId(),
    boxType: boxType,
    boxId: boxId,
    deviceModel: env.appPlatform
  }]], userService, videoService, premiumService, freemiumService, upFrontTokenService, profileService, parentalControlService_parentalControlService, [pairingService, [{
    prefixedBoxId: true
  }]]];
  if (oidc.baseUrl) {
    fidoConfig.baseUrlsByAPIType.oidc = oidc.baseUrl;
    fidoConfig.baseUrlsByAPIType.oidcCustomApi = oidc.customApi;
    services.push([oidcService_oidcService, [{
      clientId: oidc.clientId,
      clientSecret: oidc.clientSecret,
      endpoints: oidc.endpoints
    }]]);
  }
  es_fido/* fido */.n.init(fidoConfig, services);
  es_fido/* fido */.n.setBaseUrls(baseUrlsByAPIType);
};
var updateFidoConfig = function updateFidoConfig(config) {
  var customerCode = config.customerCode,
    platformCode = config.platformCode,
    clientCode = config.clientCode,
    _config$fido2 = config.fido,
    baseUrlsByAPIType = _config$fido2.baseUrlsByAPIType,
    capacityToken = _config$fido2.layoutService.capacityToken,
    saltAndSugar = _config$fido2.saltAndSugar,
    imageSalt = _config$fido2.imageSalt;
  var fidoConfig = {
    customerCode: customerCode,
    platformCode: platformCode,
    clientCode: clientCode,
    saltAndSugar: saltAndSugar,
    imageSalt: imageSalt
  };
  Object.entries(fidoConfig).forEach(function (_ref) {
    var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    es_fido/* fido */.n.set(key, value);
  });
  es_fido/* fido */.n.setBaseUrls(baseUrlsByAPIType);
  layoutService.init(capacityToken);
  layoutForThirdPartyService.init(capacityToken);
};
;// CONCATENATED MODULE: ./src/logic/app/app.config.actions.js








function app_config_actions_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function app_config_actions_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? app_config_actions_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : app_config_actions_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }












var CONFIG_INIT = 'app/CONFIG_INIT';
var configInitApp = function configInitApp(config) {
  return {
    type: CONFIG_INIT,
    config: config
  };
};
var fetchAppLaunchCustomizer = function fetchAppLaunchCustomizer(deviceId, applaunchConfig) {
  try {
    var featureFlipping = getFeatureFlipping((src_default()).bannedFeatures, (src_default()).featureFlipping, applaunchConfig.featureFlipping);
    var customizerFeature = featureFlipping.customizerFeature;
    if (customizerFeature && !src_default().bannedFeatures.includes('customizerFeature')) {
      return applaunchService.getCustomization({
        localDeviceId: deviceId
      }).catch(function (error) {
        console.error("[app.config.actions] Error while fetching customized config: ".concat(error.message));
        return applaunchConfig;
      });
    }
    return Promise.resolve(applaunchConfig);
  } catch (error) {
    return Promise.resolve(applaunchConfig);
  }
};
var applyExternalConfig = function applyExternalConfig(localConfig, externalConfig) {
  var featureFlipping = getFeatureFlipping((src_default()).bannedFeatures, (src_default()).featureFlipping, externalConfig.featureFlipping);
  var enhancedConfig = merge_default()(localConfig, app_config_actions_objectSpread(app_config_actions_objectSpread({}, externalConfig), {}, {
    featureFlipping: featureFlipping
  }));
  updateFidoConfig(enhancedConfig);
  return enhancedConfig;
};
var fetchAppLaunchConfig = function fetchAppLaunchConfig(config) {
  return function () {
    var _ref = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(dispatch, getState) {
      var state, deviceId, applaunchConfig, externalConfig, enhancedConfig;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            state = getState();
            deviceId = getLocalDeviceId(state);
            _context.next = 4;
            return applaunchService.getApplaunch().catch(function () {
              return {};
            });
          case 4:
            applaunchConfig = _context.sent;
            _context.next = 7;
            return fetchAppLaunchCustomizer("deviceid-".concat(deviceId), applaunchConfig);
          case 7:
            externalConfig = _context.sent;
            enhancedConfig = applyExternalConfig(config, externalConfig);
            mediaEngineConfig_mediaEngineConfig.init({
              lang: enhancedConfig.language,
              isDebug: Boolean(enhancedConfig.debug)
            });
            _context.next = 12;
            return dispatch(setGeoInfo());
          case 12:
            setupI18NOverrides(enhancedConfig.translationsOverrides);
            dispatch(configInitApp(enhancedConfig));
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
var refreshCustomizedConfig = function refreshCustomizedConfig(id) {
  return function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2(dispatch, getState) {
      var state, uid, externalConfig, enhancedConfig;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            state = getState();
            if (!getCustomizerFeature(state)) {
              _context2.next = 16;
              break;
            }
            uid = id || user_selectors_getHomeId(state) || user_selectors_getDeviceId(state) || getLocalHomeId(state) || getLocalDeviceId(state);
            _context2.prev = 3;
            _context2.next = 6;
            return applaunchService.getCustomization({
              uid: uid
            });
          case 6:
            externalConfig = _context2.sent;
            enhancedConfig = applyExternalConfig((src_default()), externalConfig);
            mediaEngineConfig_mediaEngineConfig.set('lang', enhancedConfig.language);
            mediaEngineConfig_mediaEngineConfig.set('isDebug', Boolean(enhancedConfig.debug));
            dispatch(configInitApp(enhancedConfig));
            _context2.next = 16;
            break;
          case 13:
            _context2.prev = 13;
            _context2.t0 = _context2["catch"](3);
            dispatch(error_actions_errorAction(error_constants_ERROR_LEVELS.SILENT, error_constants_ERROR_TYPES.GENERAL, 'Failed to get customization data on config refresh'));
          case 16:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[3, 13]]);
    }));
    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};
;// CONCATENATED MODULE: ./src/modules/search/customer/default/search.constants.js

var _templateIdForFacets;

var facets = {
  PLAYLIST: 'playlist',
  PROGRAM: 'program',
  VC: 'vc',
  VI: 'vi',
  PODCAST: 'podcast'
};
var facetsOrder = [facets.PLAYLIST, facets.PROGRAM, facets.VC, facets.VI, facets.PODCAST];
var templateIdForFacets = (_templateIdForFacets = {}, (0,defineProperty/* default */.Z)(_templateIdForFacets, facets.PLAYLIST, templateTypes.PosterM), (0,defineProperty/* default */.Z)(_templateIdForFacets, facets.PROGRAM, templateTypes.PosterM), (0,defineProperty/* default */.Z)(_templateIdForFacets, facets.VI, templateTypes.PosterM), (0,defineProperty/* default */.Z)(_templateIdForFacets, facets.VC, templateTypes.PosterM), (0,defineProperty/* default */.Z)(_templateIdForFacets, facets.PODCAST, templateTypes.HorizontalSquare), _templateIdForFacets);
;// CONCATENATED MODULE: ./src/thirdParty/algolia/algolia.engine.js














/* harmony default export */ const algolia_engine = (new (function () {
  function Algolia() {
    (0,classCallCheck/* default */.Z)(this, Algolia);
    this.sdk = null;
    this.client = null;
    this.indices = null;
  }
  (0,createClass/* default */.Z)(Algolia, [{
    key: "_buildSearchQueryParams",
    value: function _buildSearchQueryParams(query, index) {
      var _this = this;
      if (!this.indices[index]) return [];
      var algolia = (src_default()).algolia;
      var queryResult = Object.values(facets).map(function (facet) {
        return {
          indexName: _this.indices[index],
          query: query,
          params: {
            hitsPerPage: 20,
            facetFilters: algolia.platformCode ? [["metadata.item_type:".concat(facet)], ["metadata.platforms_assets:".concat(algolia.platformCode)]] : ["metadata.item_type:".concat(facet)]
          }
        };
      });
      return queryResult;
    }
  }, {
    key: "init",
    value: function () {
      var _init = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee() {
        var _config$algolia, id, key, indices;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __webpack_require__.e(/* import() */ 927).then(__webpack_require__.t.bind(__webpack_require__, 6927, 23));
            case 2:
              this.sdk = _context.sent;
              _config$algolia = (src_default()).algolia, id = _config$algolia.id, key = _config$algolia.key, indices = _config$algolia.indices;
              this.client = this.sdk.default(id, key);
              this.indices = indices;
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "extractFacetFromQuery",
    value: function extractFacetFromQuery(query) {
      var facetResult = null;
      Object.values(facets).forEach(function (facet) {
        if (query.search(facet) !== -1) {
          facetResult = facet;
        }
      });
      return facetResult;
    }
  }, {
    key: "search",
    value: function search(input) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
      var queryParams = this._buildSearchQueryParams(input, index);
      return this.client.multipleQueries(queryParams);
    }
  }]);
  return Algolia;
}())());
;// CONCATENATED MODULE: ./src/logic/search/search.constants.js
var SEARCH_RESET = 'search/RESET';
var SAVE_SEARCHED_ITEM = 'search/SAVE_SEARCHED_ITEM';
var GET_SEARCHED_ITEM = 'search/GET_SEARCHED_ITEM';
var UPDATE_SEARCHED_ITEMS = 'search/UPDATE_SEARCHED_ITEMS';
var SEARCH_COMPLETE = 'search/SEARCH_COMPLETE';
var SPACE = '_';
var BACKSPACE = '<';
var SEARCH_HISTORY_CAPACITY = 4;
var SEARCH_HISTORY_KEY = '_history';
;// CONCATENATED MODULE: ./src/logic/search/search.utils.js








var search_utils_excluded = ["action"];
function search_utils_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function search_utils_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? search_utils_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : search_utils_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






var prepareActionAnalyticsItems = function prepareActionAnalyticsItems(items) {
  var preparedItems = items.map(function (_ref) {
    var action = _ref.action,
      rest = objectWithoutProperties_objectWithoutProperties(_ref, search_utils_excluded);
    var googleAnalytics = get_default()(action, 'analytics.googleAnalytics', {});
    var newGoogleAnalytics = search_utils_objectSpread(search_utils_objectSpread({}, googleAnalytics), {}, {
      eventAction: googleAnalytics.eventAction || 'program',
      eventCategory: googleAnalytics.eventCategory || 'search'
    });
    return search_utils_objectSpread(search_utils_objectSpread({}, rest), {}, {
      action: search_utils_objectSpread(search_utils_objectSpread({}, action), {}, {
        analytics: search_utils_objectSpread(search_utils_objectSpread({}, action.analytics), {}, {
          googleAnalytics: newGoogleAnalytics
        })
      })
    });
  });
  return preparedItems;
};
var prepareSearchAnalytics = function prepareSearchAnalytics(facet) {
  var preparedItems = prepareActionAnalyticsItems(facet.content.items);
  return search_utils_objectSpread(search_utils_objectSpread({}, facet), {}, {
    content: search_utils_objectSpread(search_utils_objectSpread({}, facet.content), {}, {
      items: preparedItems
    })
  });
};
var mapSearchHits = function mapSearchHits(hits, facet, screenSize, contentTemplatesOptions) {
  var flattenItems = hits.map(function (_ref2) {
    var item = _ref2.item;
    return item;
  });
  var contentTemplateId = templateIdForFacets[facet];
  var imageOptions = getContentImageOptions(contentTemplateId, contentTemplatesOptions, screenSize);
  var forceGhostServiceIcon = contentTemplateId && (contentTemplateId.startsWith('Card') || contentTemplateId.startsWith('Poster'));
  return {
    id: facet,
    content: {
      contentTemplateId: contentTemplateId,
      pagination: {
        itemsPerPage: flattenItems.length,
        nextPage: null,
        totalItems: flattenItems.length
      },
      items: getFormattedItems(flattenItems, imageOptions, forceGhostServiceIcon)
    }
  };
};
var getResultsAsBlocks = function getResultsAsBlocks(results) {
  var blocks = results.filter(function (result) {
    return Boolean(get_default()(result, 'content.items', []).length);
  });
  var sortedBlocks = facetsOrder.reduce(function (acc, facetId) {
    var filteredFacet = blocks.find(function (block) {
      return block.id === facetId;
    });
    if (!filteredFacet) {
      return acc;
    }
    acc.push(search_utils_objectSpread(search_utils_objectSpread({}, prepareSearchAnalytics(filteredFacet)), {}, {
      title: {
        long: t("search.".concat(filteredFacet.id), {
          numVideos: filteredFacet.content.items.length
        })
      },
      blockTemplateId: 'Grid'
    }));
    return acc;
  }, []);
  return sortedBlocks;
};
var formattingInput = function formattingInput(symbol, input) {
  var isDoubleSpace = symbol === SPACE && input[input.length - 1] === ' ';
  var isSpaceAtTheBeginning = symbol === SPACE && input.length === 0;
  if (isDoubleSpace || isSpaceAtTheBeginning) {
    return input;
  }
  switch (symbol) {
    case SPACE:
      input += ' ';
      break;
    case BACKSPACE:
      input = input.slice(0, input.length - 1);
      break;
    default:
      input += symbol;
      break;
  }
  return input;
};
;// CONCATENATED MODULE: ./src/logic/search/search.actions.js














var fetchResults = function fetchResults(input) {
  return function () {
    var _ref = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(dispatch, getState) {
      var algoliaResults, state, screenSize, contentTemplatesOptions, searchIndex, _yield$Algolia$search, results;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            if (algolia_engine.sdk) {
              _context.next = 4;
              break;
            }
            _context.next = 4;
            return algolia_engine.init();
          case 4:
            algoliaResults = [];
            state = getState();
            screenSize = sizes_getScreenSize();
            contentTemplatesOptions = getContentTemplatesOptions(state);
            searchIndex = isKidsSection(state) ? 'kids' : 'default';
            _context.next = 11;
            return algolia_engine.search(input, searchIndex);
          case 11:
            _yield$Algolia$search = _context.sent;
            results = _yield$Algolia$search.results;
            results.forEach(function (result) {
              var _result$hits = result.hits,
                hits = _result$hits === void 0 ? [] : _result$hits,
                _result$params = result.params,
                params = _result$params === void 0 ? '' : _result$params;
              var facet = algolia_engine.extractFacetFromQuery(params);
              if (hits.length > 0 && facet) {
                algoliaResults.push(mapSearchHits(hits, facet, screenSize, contentTemplatesOptions));
              }
            });
            return _context.abrupt("return", algoliaResults);
          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](0);
            dispatch(error_actions_errorAction(error_constants_ERROR_LEVELS.SILENT, error_constants_ERROR_TYPES.PAIRING, _context.t0.message));
            return _context.abrupt("return", []);
          case 21:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 17]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
var searchAll = function searchAll(input) {
  return function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2(dispatch) {
      var results;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return dispatch(fetchResults(input));
          case 2:
            results = _context2.sent;
            return _context2.abrupt("return", dispatch({
              type: SEARCH_COMPLETE,
              results: getResultsAsBlocks(results),
              input: input
            }));
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var resetSearch = function resetSearch() {
  return {
    type: SEARCH_RESET
  };
};
var saveSearchedItem = function saveSearchedItem(searchedItem) {
  return {
    searchedItem: searchedItem,
    type: SAVE_SEARCHED_ITEM
  };
};
var getSearchedItems = function getSearchedItems() {
  return {
    type: GET_SEARCHED_ITEM
  };
};
var updateSearchedItems = function updateSearchedItems(searchedItems) {
  return {
    searchedItems: searchedItems,
    type: UPDATE_SEARCHED_ITEMS
  };
};
;// CONCATENATED MODULE: ./src/logic/pairing/pairing.actions.js




























var PAIRING_SET_POLLING_INTERVAL = 'pairing/SET_POLLING_INTERVAL';
var PAIRING_INCREMENT_POLLING_INTERVAL = 'pairing/PAIRING_INCREMENT_POLLING_INTERVAL';
var PAIRING_FETCH_TOKEN_SUCCESS = 'pairing/FETCH_TOKEN_SUCCESS';
var PAIRING_CLEAR_TOKEN = 'pairing/PAIRING_CLEAR_TOKEN';
var PAIRING_FETCH_TOKEN_FAILURE = 'pairing/FETCH_TOKEN_FAILURE';
var PAIRING_FETCH_STATUS_FAILURE = 'pairing/FETCH_STATUS_FAILURE';
var PAIRING_FETCH_STATUS_SUCCESS = 'pairing/FETCH_STATUS_SUCCESS';
var PAIRING_FETCH_USER_SUCCESS = 'pairing/FETCH_USER_SUCCESS';
var PAIRING_FETCH_USER_FAILURE = 'pairing/FETCH_USER_FAILURE';
var SET_SUBSCRIPTIONS = 'pairing/SET_SUBSCRIPTIONS';
var WELCOME_CONTINUE_BUTTON = 'pairing/WELCOME_CONTINUE_BUTTON';
var TOKEN_BACK_BUTTON = 'pairing/TOKEN_BACK_BUTTON';
var SUBSCRIBE_BACK_BUTTON = 'pairing/SUBSCRIBE_BACK_BUTTON';
var LANDING_SUBSCRIBE_BUTTON = 'pairing/LANDING_SUBSCRIBE_BUTTON';
var LANDING_CONNECT_BUTTON = 'pairing/LANDING_CONNECT_BUTTON';
var RETRY_CONNECT_BUTTON_FOCUS_NAME = 'pairing/RETRY_CONNECT_BUTTON_FOCUS_NAME';
var PAIRING_FETCH_USER_CATALOG_ACCESS_SUCCESS = 'pairing/PAIRING_FETCH_USER_CATALOG_ACCESS_SUCCESS';
var PAIRING_FETCH_USER_CATALOG_ACCESS_FAILURE = 'pairing/PAIRING_FETCH_USER_CATALOG_ACCESS_FAILURE';
var PAIRING_FETCH_FREEMIUM_SERVICES_SUCCESS = 'pairing/PAIRING_FETCH_FREEMIUM_SERVICES_SUCCESS';
var PAIRING_FETCH_FREEMIUM_SERVICES_FAILURE = 'pairing/PAIRING_FETCH_FREEMIUM_SERVICES_FAILURE';
var PAIRING_SET_PARENTAL_LOCK_STATUS = 'pairing/SET_PARENTAL_LOCK_STATUS';
var PAIRING_SET_UNPAIRED_ENTERING = 'pairing/PAIRING_SET_UNPAIRED_ENTERING';
var PAIRING_CLEAR_UNPAIRED_ENTERING = 'pairing/PAIRING_CLEAR_UNPAIRED_ENTERING';
var RENEW_TOKEN_SUCCESS = 'token/RENEW_TOKEN_SUCCESS';
var RENEW_TOKEN_FAILURE = 'token/RENEW_TOKEN_FAILURE';
var CLEAR_USER_PROFILE = 'token/CLEAR_USER_PROFILE';
var SELECT_USER_PROFILE = 'token/SELECT_USER_PROFILE';
var setUnpairedEntering = function setUnpairedEntering() {
  return {
    type: PAIRING_SET_UNPAIRED_ENTERING
  };
};
var clearUnpairedEntering = function clearUnpairedEntering() {
  return {
    type: PAIRING_CLEAR_UNPAIRED_ENTERING
  };
};
var fetchTokenSuccess = function fetchTokenSuccess(token, verificationURI) {
  return {
    type: PAIRING_FETCH_TOKEN_SUCCESS,
    token: token,
    verificationURI: verificationURI
  };
};
var fetchTokenFailure = function fetchTokenFailure() {
  return {
    type: PAIRING_FETCH_TOKEN_FAILURE
  };
};
var fetchStatusSuccess = function fetchStatusSuccess(status) {
  return {
    type: PAIRING_FETCH_STATUS_SUCCESS,
    status: status
  };
};
var fetchStatusFailure = function fetchStatusFailure() {
  return {
    type: PAIRING_FETCH_STATUS_FAILURE
  };
};
var setPollingInterval = function setPollingInterval(pollingInterval) {
  return {
    type: PAIRING_SET_POLLING_INTERVAL,
    pollingInterval: pollingInterval
  };
};
var incrementPollingInterval = function incrementPollingInterval() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5000;
  return {
    type: PAIRING_INCREMENT_POLLING_INTERVAL,
    value: value
  };
};
var renewTokenSuccess = function renewTokenSuccess(profileUid) {
  return {
    type: RENEW_TOKEN_SUCCESS,
    profileUid: profileUid
  };
};
var renewTokenFailure = function renewTokenFailure(error) {
  return {
    type: RENEW_TOKEN_FAILURE,
    error: error
  };
};
var setSubscriptions = function setSubscriptions(subscriptions) {
  return {
    type: SET_SUBSCRIPTIONS,
    subscriptions: subscriptions
  };
};
var selectUserProfile = function selectUserProfile(profileUid) {
  return {
    type: SELECT_USER_PROFILE,
    profileUid: profileUid
  };
};
var clearUserProfile = function clearUserProfile() {
  return {
    type: CLEAR_USER_PROFILE
  };
};
var clearPairingToken = function clearPairingToken() {
  return {
    type: PAIRING_CLEAR_TOKEN
  };
};
var fetchToken = function fetchToken() {
  return function () {
    var _ref = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(dispatch) {
      var _yield$dispatch, token, verificationURI;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return dispatch(fetchOneTimePasscode());
          case 3:
            _yield$dispatch = _context.sent;
            token = _yield$dispatch.token;
            verificationURI = _yield$dispatch.verificationURI;
            if ((src_default()).pairing && (src_default()).pairing.pairingPollInterval) {
              dispatch(setPollingInterval((src_default()).pairing.pairingPollInterval));
            }
            dispatch(fetchTokenSuccess(token, verificationURI));
            _context.next = 14;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](0);
            dispatch(fetchTokenFailure());
            dispatch(error_actions_errorAction(error_constants_ERROR_LEVELS.FATAL, error_constants_ERROR_TYPES.PAIRING, _context.t0.message));
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 10]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
var fetchUserSuccess = function fetchUserSuccess(user) {
  return function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2(dispatch, getState) {
      var state, cookieConsents, shouldDisplayProfilesGate, profileUid;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            try {
              state = getState();
              cookieConsents = getCookies(state);
              tokenService.resetUserAndToken();
              tokenService.setUser({
                UID: user.uid
              });
              setUser({
                UID: user.uid
              });
              trackGDPRConsent(cookieConsents);
              dispatch(landingShown());
              dispatch(clearUnpairedEntering());
              dispatch({
                type: PAIRING_FETCH_USER_SUCCESS,
                user: user
              });
              dispatch(setUserUid(user.uid));
              setAttributes({
                authentified: 'yes',
                userStatus: 'connected'
              });
              sendEvent({
                key: 'pairingSuccess'
              });
              shouldDisplayProfilesGate = getMultiProfilesGateAlwaysDisplayed(state);
              if (!shouldDisplayProfilesGate) {
                profileUid = platformStorage.getItem("".concat(user.uid, ".").concat(PERSISTENT.PROFILE_UID_KEY)) || null;
                if (profileUid) {
                  tokenService.setProfile({
                    profileUid: profileUid
                  });
                  dispatch(selectUserProfile(profileUid));
                  dispatch(fetchProfileInfos(profileUid));
                  dispatch(renewTokenSuccess(profileUid));
                } else {
                  tokenService.setProfile({
                    profileUid: null
                  });
                }
              }
            } catch (error) {
              dispatch({
                type: PAIRING_FETCH_USER_FAILURE,
                error: error
              });
              dispatch(error_actions_errorAction(error_constants_ERROR_LEVELS.SILENT, error_constants_ERROR_TYPES.PAIRING, error.message));
              sendEvent({
                key: 'pairingFail'
              });
            }
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var setParentalControl = function setParentalControl(parentalControlStatus) {
  return {
    type: PAIRING_SET_PARENTAL_LOCK_STATUS,
    parentalControlStatus: parentalControlStatus
  };
};
var fetchParentalLockStatus = function fetchParentalLockStatus() {
  return function () {
    var _ref3 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee3(dispatch, getState) {
      var userId, _yield$parentalContro, maxCsaId;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            userId = getUid(getState());
            _context3.prev = 1;
            _context3.next = 4;
            return parentalControlService.fetchParentalRestriction({
              uid: userId
            });
          case 4:
            _yield$parentalContro = _context3.sent;
            maxCsaId = _yield$parentalContro.maxCsaId;
            dispatch(setParentalControl(maxCsaId));
            _context3.next = 12;
            break;
          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](1);
            dispatch(errorAction(ERROR_LEVELS.SILENT, ERROR_TYPES.PAIRING, _context3.t0.message));
          case 12:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[1, 9]]);
    }));
    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var fetchUserSubscription = function fetchUserSubscription() {
  return function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee4(dispatch, getState) {
      var userId, userSubscriptions;
      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            userId = user_selectors_getUid(getState());
            _context4.prev = 1;
            _context4.next = 4;
            return getCurrentSubscriptions(userId);
          case 4:
            userSubscriptions = _context4.sent;
            dispatch(setSubscriptions(userSubscriptions));
            _context4.next = 11;
            break;
          case 8:
            _context4.prev = 8;
            _context4.t0 = _context4["catch"](1);
            dispatch(error_actions_errorAction(error_constants_ERROR_LEVELS.SILENT, error_constants_ERROR_TYPES.PAIRING, _context4.t0.message));
          case 11:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[1, 8]]);
    }));
    return function (_x6, _x7) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var fetchUserInformation = function fetchUserInformation() {
  return function (dispatch, getState) {
    var isPremiumEnabled = getPremiumFeature(getState());
    if (!isPremiumEnabled) {
      return Promise.resolve();
    }
    return Promise.all([dispatch(fetchUserSubscription()), dispatch(fetchParentalLockStatus())]);
  };
};
var getCurrentPairedUser = function getCurrentPairedUser() {
  return function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee5(dispatch) {
      var pairedUser;
      return regenerator_default().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return dispatch(fetchUser());
          case 3:
            pairedUser = _context5.sent;
            if (pairedUser) {
              dispatch(fetchUserSuccess(pairedUser));
              dispatch(refreshCustomizedConfig(pairedUser.uid));
              setAttributes({
                userId: pairedUser.uid
              });
              sendEvent({
                key: 'pairingSuccess'
              });
            }
            return _context5.abrupt("return", pairedUser);
          case 8:
            _context5.prev = 8;
            _context5.t0 = _context5["catch"](0);
            dispatch(error_actions_errorAction(error_constants_ERROR_LEVELS.SILENT, error_constants_ERROR_TYPES.PAIRING, _context5.t0.message));
            sendEvent({
              key: 'pairingFail'
            });
            return _context5.abrupt("return", null);
          case 13:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[0, 8]]);
    }));
    return function (_x8) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var pairing_actions_getStatus = function getStatus() {
  return function () {
    var _ref6 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee6(dispatch) {
      var _yield$dispatch2, status, slowDown;
      return regenerator_default().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return dispatch(getProviderPairingStatus());
          case 3:
            _yield$dispatch2 = _context6.sent;
            status = _yield$dispatch2.status;
            slowDown = _yield$dispatch2.slowDown;
            if (!isPaired(status)) {
              _context6.next = 11;
              break;
            }
            _context6.next = 9;
            return dispatch(getCurrentPairedUser());
          case 9:
            _context6.next = 12;
            break;
          case 11:
            if (slowDown) {
              dispatch(incrementPollingInterval());
            }
          case 12:
            dispatch(fetchStatusSuccess(status));
            _context6.next = 19;
            break;
          case 15:
            _context6.prev = 15;
            _context6.t0 = _context6["catch"](0);
            dispatch(fetchStatusFailure());
            dispatch(error_actions_errorAction(getErrorLevel(_context6.t0), error_constants_ERROR_TYPES.PAIRING, _context6.t0.message));
          case 19:
          case "end":
            return _context6.stop();
        }
      }, _callee6, null, [[0, 15]]);
    }));
    return function (_x9) {
      return _ref6.apply(this, arguments);
    };
  }();
};
var logout = function logout() {
  return function (dispatch) {
    return dispatch(unpair_actions_logout()).finally(function () {
      return dispatch(resetSearch());
    });
  };
};
;// CONCATENATED MODULE: ./src/logic/layout/platform/default/accountCompletion.js
var checkAccountCompletion = function checkAccountCompletion() {
  return function () {};
};
;// CONCATENATED MODULE: ./src/logic/layout/layout.section.actions.js


var SET_CURRENT_SECTION_CODE = 'navigation/SET_CURRENT_SECTION_CODE';
var setCurrentSectionCode = function setCurrentSectionCode(sectionCode) {
  return function (dispatch, getState) {
    var currentSectionCode = getCurrentSectionCode(getState());
    if (sectionCode === currentSectionCode || !sectionCode) {
      return;
    }
    dispatch(resetSearch());
    dispatch({
      type: SET_CURRENT_SECTION_CODE,
      sectionCode: sectionCode
    });
  };
};
;// CONCATENATED MODULE: ./src/logic/token/customer/rtlde/token.actions.js

var renewToken = function renewToken() {
  return tokenService.renewOidcToken();
};
var refreshToken = function refreshToken() {
  return oidcService.renewAccessToken();
};
;// CONCATENATED MODULE: ./src/logic/token/token.actions.js















var renewJwtWithProfile = function renewJwtWithProfile(profileUid) {
  return function () {
    var _ref = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(dispatch, getState) {
      var _getState, _getState$layout, requestedEntityId, requestedEntityType;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _getState = getState(), _getState$layout = _getState.layout, requestedEntityId = _getState$layout.requestedEntityId, requestedEntityType = _getState$layout.requestedEntityType;
            dispatch(selectUserProfile(profileUid));
            dispatch(setRouteSkeletonByEntity(requestedEntityType, requestedEntityId));
            tokenService.setProfile({
              profileUid: profileUid
            });
            return _context.abrupt("return", renewToken().then(function () {
              dispatch(renewTokenSuccess(profileUid));
              dispatch(fetchProfileInfos(profileUid)).then(function () {
                dispatch(setCurrentSectionCode(isKidsProfile(getState()) ? 'kids' : 'main'));
              });
              dispatch(resetSearch());
            }));
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            tokenService.setProfile(null);
            dispatch(renewTokenFailure(_context.t0));
            dispatch(error_actions_errorAction(error_constants_ERROR_LEVELS.SILENT, error_constants_ERROR_TYPES.PAIRING, _context.t0.message));
            return _context.abrupt("return", Promise.resolve(null));
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 8]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
var resetJwtProfile = function resetJwtProfile() {
  return function (dispatch) {
    tokenService.setProfile(null);
    dispatch(setCurrentSectionCode('main'));
    dispatch(clearUserProfile());
  };
};
;// CONCATENATED MODULE: ./src/logic/lock/refreshAuth.lock.actions.js




var refreshAuth = function refreshAuth(item) {
  return function (dispatch) {
    var section = get_default()(getOriginalTarget(item), 'value_layout.section');
    if (section) {
      dispatch(setCurrentSectionCode(section));
    }
    var reasonAttributes = get_default()(item, 'item.action.target.value_lock.reasonAttributes');
    var profileUid = reasonAttributes.profileUid;
    dispatch(renewJwtWithProfile(profileUid));
  };
};
;// CONCATENATED MODULE: ./src/logic/layout/layout.profile.actions.js


var autoSelectProfile = function autoSelectProfile(data) {
  return function (dispatch) {
    return dispatch(refreshAuth({
      item: get_default()(data, 'blocks[0].content.items[0]')
    }));
  };
};
;// CONCATENATED MODULE: ./src/logic/layout/layout.reducer.utils.js



var getBlockInfo = function getBlockInfo(state, blockId) {
  var parentId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  if (!state || !blockId) {
    return null;
  }
  var requestedEntityId = state.requestedEntityId,
    requestedEntityType = state.requestedEntityType,
    currentSectionCode = state.currentSectionCode;
  var blocks = get_default()(state, [currentSectionCode, requestedEntityType, requestedEntityId, 'blocks'], []);
  var blockToFind = parentId || blockId;
  var blockIndex = blocks.findIndex(function (_ref) {
    var id = _ref.id;
    return id === blockToFind;
  });
  if (blockIndex < 0) {
    return null;
  }
  var target = parentId ? get_default()(blocks[blockIndex], 'alternativeContent.concurrentBlocks', []).find(function (_ref2) {
    var id = _ref2.id;
    return id === blockId;
  }) : blocks[blockIndex];
  if (!target) {
    return null;
  }
  var path = [currentSectionCode, requestedEntityType, requestedEntityId, "blocks[".concat(blockIndex, "]")];
  if (parentId) {
    var targetBlockIndex = blocks[blockIndex].alternativeContent.concurrentBlocks.indexOf(target);
    path.push('alternativeContent', "concurrentBlocks[".concat(targetBlockIndex, "]"));
  }
  return [path, target];
};
;// CONCATENATED MODULE: ./src/logic/layout/layout.actions.js













function layout_actions_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function layout_actions_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? layout_actions_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : layout_actions_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
























var FETCH_NAVIGATION_SUCCESS = 'layout/FETCH_NAVIGATION_SUCCESS';
var SET_CURRENT_ENTITY = 'layout/SET_CURRENT_ENTITY';
var SET_CURRENT_ENTITY_ID = 'layout/SET_CURRENT_ENTITY_ID';
var SET_CURRENT_ENTITY_TYPE = 'layout/SET_CURRENT_ENTITY_TYPE';
var GENERATE_BLOCK_PLACEHOLDERS = 'layout/GENERATE_BLOCK_PLACEHOLDERS';
var FETCH_BLOCK = 'layout/FETCH_BLOCK';
var REPLACE_BLOCK = 'layout/REPLACE_BLOCK';
var CLEAR_CACHE = 'layout/CLEAR_CACHE';
var INVALIDATE_ITEM_CACHE = 'layout/INVALIDATE_ITEM_CACHE';
var SET_REQUESTED_ENTITY = 'layout/SET_REQUESTED_ENTITY';
var SET_CONTENT_TEMPLATES_OPTIONS = 'layout/SET_CONTENT_TEMPLATES_OPTIONS';
var createSuccessActionType = function createSuccessActionType(entity) {
  return "layout/".concat(entity, "/FETCH_LAYOUT_SUCCESS");
};
var fetchedLayoutAction = function fetchedLayoutAction(entity, data, id) {
  return {
    type: createSuccessActionType(entity),
    entity: entity,
    data: data,
    id: id
  };
};
var setContentTemplateOptions = function setContentTemplateOptions(contentTemplatesOptions) {
  return {
    type: SET_CONTENT_TEMPLATES_OPTIONS,
    contentTemplatesOptions: contentTemplatesOptions
  };
};
var setRequestedEntity = function setRequestedEntity(entityType, entityId) {
  return {
    type: SET_REQUESTED_ENTITY,
    entityType: entityType,
    entityId: entityId
  };
};
var clearCache = function clearCache(entityType, entityId, sectionCode) {
  return {
    type: CLEAR_CACHE,
    entityType: entityType,
    entityId: entityId,
    sectionCode: sectionCode
  };
};
var invalidateItemCache = function invalidateItemCache(itemIndex, blockIndex, item) {
  return {
    type: INVALIDATE_ITEM_CACHE,
    itemIndex: itemIndex,
    blockIndex: blockIndex,
    item: item
  };
};
var fetchNavigation = function fetchNavigation(section) {
  return function () {
    var _ref = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(dispatch, getState) {
      var sectionCode, data, navigation;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            sectionCode = section || getCurrentSectionCode(getState());
            console.log("[layout.actions] Loading navigation for ".concat(sectionCode));
            _context.prev = 2;
            _context.next = 5;
            return layoutForThirdPartyService.fetchNavigation({
              target: layout_constants/* navigationTargets */.bL.tv,
              sectionCode: sectionCode
            });
          case 5:
            data = _context.sent;
            navigation = Array.isArray(data) ? getNavigationV3(data) : getNavigationV2(data);
            return _context.abrupt("return", dispatch({
              type: FETCH_NAVIGATION_SUCCESS,
              navigation: layout_actions_objectSpread(layout_actions_objectSpread({}, navigation), {}, {
                entries: navigation.entries.map(function (group) {
                  return handleGroupOnPlatform(group);
                })
              })
            }));
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](2);
            return _context.abrupt("return", dispatch(error_actions_errorAction(error_constants_ERROR_LEVELS.FATAL, error_constants_ERROR_TYPES.LAYOUT, _context.t0.message)));
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 10]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
var fetchLayout = function fetchLayout(entityType, entityId) {
  return function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2(dispatch, getState) {
      var state, start, totalStart, sectionCode, screenSize, contentTemplateOptions, entity, isPlayableEntity, data, target, reasonCode, lastViewedProgress, lastViewedId, result;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            state = getState();
            if (isAppInitialized(state)) {
              _context2.next = 3;
              break;
            }
            return _context2.abrupt("return", false);
          case 3:
            start = Date.now();
            totalStart = start;
            sectionCode = getCurrentSectionCode(state);
            screenSize = app_selectors_getScreenSize(state);
            contentTemplateOptions = getContentTemplatesOptions(state);
            entity = {
              entityType: entityType,
              entityId: entityId,
              sectionCode: sectionCode
            };
            isPlayableEntity = shouldOmitCache(entityType);
            if (isPlayableEntity) {
              dispatch(clearCache(entityType, entityId, sectionCode));
            }
            dispatch(setRequestedEntity(entityType, entityId));
            dispatch(fetchScreenSaverData(sectionCode));
            _context2.prev = 13;
            _context2.next = 16;
            return layoutForThirdPartyService.fetchByEntity(entity);
          case 16:
            data = _context2.sent;
            _context2.next = 22;
            break;
          case 19:
            _context2.prev = 19;
            _context2.t0 = _context2["catch"](13);
            return _context2.abrupt("return", dispatch(error_actions_errorAction(getCurrentLayout(getState()) ? error_constants_ERROR_LEVELS.SILENT : error_constants_ERROR_LEVELS.FATAL, error_constants_ERROR_TYPES.LAYOUT, _context2.t0.message)));
          case 22:
            _context2.prev = 22;
            removeSplashScreen();
            return _context2.finish(22);
          case 25:
            if (!shouldDisplaySubscriptionExpiration(data)) {
              _context2.next = 27;
              break;
            }
            return _context2.abrupt("return", navigateToExpiredSubscriptionPage());
          case 27:
            if (!shouldDisplayLanding(data)) {
              _context2.next = 34;
              break;
            }
            console.log('[layout.actions] Landing layout received, logging out');
            if (!getOpenCatalogFeature(state)) {
              _context2.next = 33;
              break;
            }
            dispatch(setDeeplinkLocation(isPlayableEntity ? "".concat(entityType, "/").concat(entityId) : "app/".concat(entityType, "/").concat(entityId)));
            navigateToLandingPage();
            return _context2.abrupt("return", Promise.resolve());
          case 33:
            return _context2.abrupt("return", dispatch(logout()).finally(function () {
              return navigateToLandingPage();
            }));
          case 34:
            if (!data.redirection) {
              _context2.next = 44;
              break;
            }
            target = "".concat(APP_PATH, "/").concat(data.entity.type, "/").concat(data.entity.id);
            reasonCode = data.redirection.reasonCode;
            if (!(reasonCode === 'device_to_revoke')) {
              _context2.next = 39;
              break;
            }
            return _context2.abrupt("return", dispatch(logout()).finally(function () {
              navigateTo(target, false);
              return dispatch(fetchNavigation('main'));
            }));
          case 39:
            if (!(reasonCode === 'missing_entity')) {
              _context2.next = 41;
              break;
            }
            return _context2.abrupt("return", navigateTo(target, false));
          case 41:
            if (!(reasonCode === 'devices_gate')) {
              _context2.next = 44;
              break;
            }
            dispatch(setDeeplinkLocation(isPlayableEntity ? "".concat(entityType, "/").concat(entityId) : "app/".concat(entityType, "/").concat(entityId)));
            return _context2.abrupt("return", navigateTo(DEVICE_GATE_PATH, false));
          case 44:
            console.log("[layout.action] Loaded in ".concat(Date.now() - start, " ms"));
            start = Date.now();
            data.blocks = data.blocks.filter(function (block) {
              return hasContent(block);
            }).map(function (block) {
              if (!block.blockTemplateId && block.content.blockTemplateId) {
                block.blockTemplateId = block.content.blockTemplateId;
              }
              if (!block.templateId && block.content.contentTemplateId) {
                block.templateId = block.content.contentTemplateId;
              }
              return block;
            }).filter(function (block) {
              return isKnownBlockTemplateType(block) && (hasAlternativeContent(block) ? isKnownSelectorTemplateType(block) : true) && isKnownTemplateType(block);
            }).map(prepareBlock(entity, screenSize, contentTemplateOptions)).map(prepareAlternateContent);
            console.log("[layout.action] Images URLs calculated in ".concat(Date.now() - start, " ms"));
            start = Date.now();
            if (entityType !== 'video' || entityType !== 'audio') {
              lastViewedProgress = getLastViewedClipProgress(getState());
              lastViewedId = getLastViewedClipId(getState());
              if (lastViewedProgress && lastViewedId) {
                prepareLastViewedProgress(data.blocks, lastViewedId, lastViewedProgress);
                dispatch(resetLastViewedData());
              }
            }
            console.log("[layout.action] Viewing history invalidated in ".concat(Date.now() - start, " ms"));
            start = Date.now();
            if (!isProfilesGates(data)) {
              _context2.next = 56;
              break;
            }
            if (!shouldAutoSelectProfile(data, state)) {
              _context2.next = 55;
              break;
            }
            return _context2.abrupt("return", dispatch(autoSelectProfile(data)));
          case 55:
            return _context2.abrupt("return", dispatch(showPopupAction(PROFILES_GATE_POPUP_ID, {
              payload: data
            })));
          case 56:
            result = dispatch(fetchedLayoutAction(entityType, data, entityId));
            console.log("[layout.action] Rendered in ".concat(Date.now() - start, " ms"));
            console.log("[layout.action] Complete in ".concat(Date.now() - totalStart, " ms"));
            dispatch(hideRouteSkeleton());
            if (isPlayableEntity) {
              dispatch(completeAccount());
            } else {
              dispatch(checkAccountCompletion());
            }
            return _context2.abrupt("return", result);
          case 62:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[13, 19, 22, 25]]);
    }));
    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var fetchBlockPage = function fetchBlockPage(_ref3) {
  var blockId = _ref3.id,
    page = _ref3.page,
    start = _ref3.start,
    _ref3$parentId = _ref3.parentId,
    parentId = _ref3$parentId === void 0 ? undefined : _ref3$parentId;
  return function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee3(dispatch, getState) {
      var state, entityType, entityId, blockInfo, _blockInfo, _, existingBlock, sectionCode, data, screenSize, contentTemplateOptions, entity, block;
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            state = getState();
            entityType = getRequestedEntityType(state);
            entityId = getRequestedEntityId(state);
            blockInfo = getBlockInfo(state.layout, blockId, parentId);
            if (blockInfo) {
              _context3.next = 6;
              break;
            }
            return _context3.abrupt("return", Promise.resolve());
          case 6:
            _blockInfo = (0,slicedToArray/* default */.Z)(blockInfo, 2), _ = _blockInfo[0], existingBlock = _blockInfo[1];
            if (!(!existingBlock || !existingBlock.pages || existingBlock.pages[page - 1] !== PAGE_STATE.MISSING)) {
              _context3.next = 9;
              break;
            }
            return _context3.abrupt("return", Promise.resolve());
          case 9:
            sectionCode = getCurrentSectionCode(state);
            dispatch({
              type: GENERATE_BLOCK_PLACEHOLDERS,
              entityType: entityType,
              entityId: entityId,
              sectionCode: sectionCode,
              blockId: blockId,
              parentId: parentId,
              page: page,
              start: start
            });
            _context3.prev = 11;
            _context3.next = 14;
            return layoutForThirdPartyService.fetchBlockPage({
              entityType: entityType,
              entityId: entityId,
              blockId: blockId,
              sectionCode: sectionCode,
              page: page
            });
          case 14:
            data = _context3.sent;
            _context3.next = 20;
            break;
          case 17:
            _context3.prev = 17;
            _context3.t0 = _context3["catch"](11);
            return _context3.abrupt("return", dispatch(error_actions_errorAction(error_constants_ERROR_LEVELS.SILENT, error_constants_ERROR_TYPES.LAYOUT, _context3.t0.message)));
          case 20:
            screenSize = app_selectors_getScreenSize(state);
            contentTemplateOptions = getContentTemplatesOptions(state);
            entity = {
              entityType: entityType,
              entityId: entityId
            };
            block = prepareBlock(entity, screenSize, contentTemplateOptions)(data);
            return _context3.abrupt("return", dispatch({
              type: FETCH_BLOCK,
              pageIndex: page,
              blockId: blockId,
              parentId: parentId,
              totalItems: block.content.pagination ? block.content.pagination.totalItems : null,
              items: block.content.items
            }));
          case 25:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[11, 17]]);
    }));
    return function (_x5, _x6) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var fetchEPGLayout = function fetchEPGLayout(_ref5) {
  var date = _ref5.date,
    blockId = _ref5.blockId;
  return function () {
    var _ref6 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee4(dispatch, getState) {
      var state, sectionCode, day, data, entityType, entityId, entity, screenSize, contentTemplateOptions, block;
      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            state = getState();
            sectionCode = getCurrentSectionCode(state);
            day = format_format(date, 'yyyy-MM-dd');
            _context4.next = 5;
            return layoutService.fetchEpgGrid({
              sectionCode: sectionCode,
              queryParameters: {
                day: day
              }
            });
          case 5:
            data = _context4.sent;
            entityType = getRequestedEntityType(state);
            entityId = getRequestedEntityId(state);
            entity = {
              entityType: entityType,
              entityId: entityId
            };
            screenSize = app_selectors_getScreenSize(state);
            contentTemplateOptions = getContentTemplatesOptions(state);
            block = prepareBlock(entity, screenSize, contentTemplateOptions)(data);
            return _context4.abrupt("return", dispatch({
              type: REPLACE_BLOCK,
              blockId: blockId,
              items: block.content.items,
              date: day
            }));
          case 13:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function (_x7, _x8) {
      return _ref6.apply(this, arguments);
    };
  }();
};
;// CONCATENATED MODULE: ./src/modules/layout/abstractLayout.style.js

var _LEFT_PADDING, _BOTTOM_PADDING;
function abstractLayout_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function abstractLayout_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? abstractLayout_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : abstractLayout_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





var abstractLayout_style_defaultContext = makeDefaultStylingContext();
var LEFT_PADDING = (_LEFT_PADDING = {}, (0,defineProperty/* default */.Z)(_LEFT_PADDING, HD, 40), (0,defineProperty/* default */.Z)(_LEFT_PADDING, FULL_HD, 40), _LEFT_PADDING);
var BOTTOM_PADDING = (_BOTTOM_PADDING = {}, (0,defineProperty/* default */.Z)(_BOTTOM_PADDING, HD, safetyMargins.vertical.HD), (0,defineProperty/* default */.Z)(_BOTTOM_PADDING, FULL_HD, safetyMargins.vertical.FULL_HD), _BOTTOM_PADDING);
var getContentPadding = function getContentPadding() {
  var hasSideNav = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var screenSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var screenDimension = screenSize || abstractLayout_style_defaultContext.screenSize;
  return hasSideNav ? WIDTH[screenDimension] + LEFT_PADDING[screenDimension] : safetyMargins.horizontal[screenDimension];
};
var abstractLayout_style_WIDTH = abstractLayout_style_objectSpread({}, SCREEN_WIDTH);
var abstractLayout_style_HEIGHT = abstractLayout_style_objectSpread({}, sizes_SCREEN_HEIGHT);
var BACKGROUND_COLOR = makeThemeColor(TERTIARY);
var abstractLayout_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : abstractLayout_style_defaultContext;
  var screenSize = context.screenSize;
  return {
    w: abstractLayout_style_WIDTH[screenSize],
    Background: {
      w: abstractLayout_style_WIDTH[screenSize],
      h: abstractLayout_style_HEIGHT[screenSize]
    },
    ContextTitle: {
      alpha: 0
    },
    Blocks: {
      w: abstractLayout_style_WIDTH[screenSize]
    },
    Notifications: {}
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/skeleton/skelton.style.js

var skelton_style_defaultContext = makeDefaultStylingContext();
;// CONCATENATED MODULE: ./src/modules/tornado/shaders/flare.shader.js
































function flare_shader_createSuper(t) { var r = flare_shader_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function flare_shader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (flare_shader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var FlareShader = function (_Lightning$shaders$We) {
  (0,inherits/* default */.Z)(FlareShader, _Lightning$shaders$We);
  var _super = flare_shader_createSuper(FlareShader);
  function FlareShader(ctx) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, FlareShader);
    _this = _super.call(this, ctx);
    _this._lineX = 0.0;
    _this._radius = 0.0;
    _this._rotation = 0.0;
    return _this;
  }
  (0,createClass/* default */.Z)(FlareShader, [{
    key: "lineX",
    get: function get() {
      return this._lineX;
    },
    set: function set(value) {
      this._lineX = value;
      this.redraw();
    }
  }, {
    key: "radius",
    get: function get() {
      return this._radius;
    },
    set: function set(value) {
      this._radius = value;
      this.redraw();
    }
  }, {
    key: "rotation",
    get: function get() {
      return this._rotation;
    },
    set: function set(value) {
      this._rotation = value;
      this.redraw();
    }
  }, {
    key: "setupUniforms",
    value: function setupUniforms(operation) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(FlareShader.prototype), "setupUniforms", this).call(this, operation);
      var ctx = this.ctx,
        gl = this.gl;
      var _ctx$stage = ctx.stage,
        w = _ctx$stage.w,
        h = _ctx$stage.h;
      var _operation$shaderOwne = operation.shaderOwner,
        _w = _operation$shaderOwne._w,
        _h = _operation$shaderOwne._h;
      var renderPrecision = this.ctx.stage.getRenderPrecision();
      this._setUniform('uLineX', this._lineX, gl.uniform1f);
      this._setUniform('uRadius', this._radius, gl.uniform1f);
      this._setUniform('uRotation', this._rotation, gl.uniform1f);
      this._setUniform('uResolution', [w, h], gl.uniform2fv);
      this._setUniform('projection', this._getProjection(operation), gl.uniform2fv, false);
      this._setUniform('uSize', new Float32Array([_w * renderPrecision, _h * renderPrecision]), this.gl.uniform2fv);
    }
  }]);
  return FlareShader;
}(src_Lightning.shaders.WebGLDefaultShader);

FlareShader.vertexShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n\n    attribute vec2 aVertexPosition;\n    attribute vec2 aTextureCoord;\n    attribute vec2 aVertex;\n    attribute vec4 aColor;\n\n    varying vec4 vColor;\n    varying vec2 vTextureCoord;\n\n    uniform vec2 projection;\n\n    void main(void) {\n        gl_Position = vec4(aVertexPosition.x * projection.x - 1.0, aVertexPosition.y * -abs(projection.y) + 1.0, 0.0, 1.0);\n        gl_Position.y = -sign(projection.y) * gl_Position.y;\n\n        vTextureCoord = aTextureCoord;\n        vColor = aColor;\n    }\n";
FlareShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n\n    #define PI 3.14159\n\n    varying vec4 vColor;\n    varying vec2 vTextureCoord;\n\n    uniform vec2 uResolution;\n    uniform vec2 uSize;\n    uniform float uLineX;\n    uniform float uRadius;\n    uniform float uRotation;\n\n    float boxDist(vec2 p, vec2 size, float radius) {\n      size -= vec2(radius);\n      vec2 d = abs(p) - size;\n      return min(max(d.x, d.y), 0.0) + length(max(d, 0.0)) - radius;\n    }\n\n    void main() {\n      float angle = radians(uRotation);\n      float cosA = cos(angle);\n      float sinA = sin(angle);\n      mat2 rotation = mat2(cosA, -sinA, sinA, cosA);\n\n      vec2 uv = ((gl_FragCoord.xy / uResolution.xy) - vec2(0.5)) * rotation + vec2(0.5);\n\n      vec2 halfRes = 0.5 * uSize.xy;\n      float mask = boxDist(vTextureCoord.xy * uSize - halfRes, halfRes - 0.005, uRadius);\n\n      float line = uLineX / uResolution.x;\n      float distanceToLine = uv.x - line;\n      float absoluteDistance = pow(pow(distanceToLine, 2.0), 0.5);\n\n      gl_FragColor = mix(vec4(0.0), vec4(vec3(max(1.0 - absoluteDistance, 0.75)), 1.0) * vColor, clamp(-mask, 0.0, 1.0));\n    }\n";
;// CONCATENATED MODULE: ./src/modules/tornado/skeleton/skeleton.rectangle.component.js





function skeleton_rectangle_component_createSuper(t) { var r = skeleton_rectangle_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function skeleton_rectangle_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (skeleton_rectangle_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }



var SkeletonRectangle = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(SkeletonRectangle, _Lightning$Component);
  var _super = skeleton_rectangle_component_createSuper(SkeletonRectangle);
  function SkeletonRectangle() {
    (0,classCallCheck/* default */.Z)(this, SkeletonRectangle);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(SkeletonRectangle, [{
    key: "_attach",
    value: function _attach() {
      var flareWidth = window.innerWidth * 1.4;
      this.animation({
        duration: 2,
        repeat: -1,
        stopMethod: 'immediate',
        actions: [{
          p: 'shader.lineX',
          v: {
            0: -flareWidth,
            1: flareWidth
          }
        }]
      }).start();
    }
  }, {
    key: "radius",
    set: function set(value) {
      this.shader.radius = value;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return {
        rect: true,
        color: colors_WHITE,
        shader: {
          type: FlareShader,
          radius: 0
        }
      };
    }
  }]);
  return SkeletonRectangle;
}(src_Lightning.Component);

;// CONCATENATED MODULE: ./src/modules/tornado/hero/skeleton/customer/default/hero.skeleton.style.js



function hero_skeleton_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function hero_skeleton_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? hero_skeleton_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : hero_skeleton_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





var hero_skeleton_style_defaultContext = makeDefaultStylingContext();
var hero_skeleton_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : hero_skeleton_style_defaultContext,
    screenSize = _ref.screenSize;
  var sizes = getSizes(screenSize);
  var paddings = getPaddings(screenSize);
  var metadataBottom = getMetadataBottom(screenSize);
  var itemsTop = getItemsTop(screenSize);
  var itemSize = heroNav_heroNav_style_sizes[screenSize];
  var gap = hero_hero_style_CONTENT_GAP[screenSize];
  return {
    Metadata: {
      mountY: 1,
      h: metadataBottom,
      y: metadataBottom,
      flex: {
        direction: 'column',
        justifyContent: 'flex-end'
      },
      ProgramLogo: {
        type: SkeletonRectangle,
        w: sizes.programLogo.w,
        h: sizes.programLogo.h
      },
      IconsRow: {
        type: SkeletonRectangle,
        w: 500,
        h: sizes.iconsRow.h,
        flexItem: {
          marginTop: paddings.iconsRow.paddingTop
        }
      },
      Title: {
        flexItem: {
          marginTop: paddings.title.paddingTop
        },
        h: getTitleFont().lineHeight * 2,
        flex: {
          direction: 'column'
        },
        FirstLine: {
          type: SkeletonRectangle,
          w: 700,
          h: getTitleFont().lineHeight
        },
        SecondLine: {
          type: SkeletonRectangle,
          w: 500,
          h: getTitleFont().lineHeight
        }
      }
    },
    Items: {
      y: itemsTop,
      children: (0,toConsumableArray/* default */.Z)(Array(6)).map(function (_, index) {
        return hero_skeleton_style_objectSpread({
          type: SkeletonRectangle,
          x: index * (itemSize.w + gap)
        }, itemSize);
      })
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/hero/skeleton/customer/default/hero.skeleton.component.js





function hero_skeleton_component_createSuper(t) { var r = hero_skeleton_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function hero_skeleton_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (hero_skeleton_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }




var HeroSkeleton = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(HeroSkeleton, _Lightning$Component);
  var _super = hero_skeleton_component_createSuper(HeroSkeleton);
  function HeroSkeleton() {
    (0,classCallCheck/* default */.Z)(this, HeroSkeleton);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(HeroSkeleton, null, [{
    key: "_template",
    value: function _template() {
      return hero_skeleton_style_getInitialStyle();
    }
  }, {
    key: "getHeight",
    value: function getHeight(data) {
      var _SlideShow$getOffsets = SlideShow.getOffsetsByBlockData(data),
        bottom = _SlideShow$getOffsets.bottom;
      return hero_hero_style_HEIGHT[data.screenSize] + bottom;
    }
  }]);
  return HeroSkeleton;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/tornado/hero/skeleton/hero.skeleton.component.js

;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/list/skeleton/list.skeleton.style.js


var list_skeleton_style_defaultContext = makeDefaultStylingContext();
var list_skeleton_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : list_skeleton_style_defaultContext;
  var titleStyle = getTitleStyle(context);
  return {
    Title: {
      h: titleStyle.text.lineHeight,
      w: 600
    },
    Items: {}
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/list/skeleton/list.skeleton.component.js










function list_skeleton_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function list_skeleton_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? list_skeleton_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : list_skeleton_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function list_skeleton_component_createSuper(t) { var r = list_skeleton_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function list_skeleton_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (list_skeleton_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }








var ListSkeleton = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(ListSkeleton, _Lightning$Component);
  var _super = list_skeleton_component_createSuper(ListSkeleton);
  function ListSkeleton() {
    (0,classCallCheck/* default */.Z)(this, ListSkeleton);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(ListSkeleton, [{
    key: "_construct",
    value: function _construct() {
      this._style = list_skeleton_style_defaultContext;
    }
  }, {
    key: "items",
    set: function set(value) {
      var _this = this;
      if (value) {
        var blockIndex = value.blockIndex,
          itemSize = value.itemSize,
          count = value.count;
        var blockStyle = Number.isFinite(blockIndex) ? getBlockStyle({
          hasTitle: true,
          isFirstBlock: blockIndex === 0,
          screenSize: this._style.screenSize
        }) : EMPTY_BLOCK_STYLE;
        this.patch({
          Title: list_skeleton_component_objectSpread({}, blockStyle.title),
          Items: list_skeleton_component_objectSpread(list_skeleton_component_objectSpread({}, blockStyle.items), {}, {
            children: (0,toConsumableArray/* default */.Z)(Array(count)).map(function (_, i) {
              return list_skeleton_component_objectSpread(list_skeleton_component_objectSpread({
                type: SkeletonRectangle
              }, itemSize), {}, {
                x: i * (itemSize.w + CONTENT_GAP[_this._style.screenSize])
              });
            })
          })
        });
      } else {
        this.tag('Items').children = [];
      }
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Title: {
          type: SkeletonRectangle
        },
        Items: {}
      }, list_skeleton_style_getInitialStyle());
    }
  }, {
    key: "getHeight",
    value: function getHeight(_ref) {
      var screenSize = _ref.screenSize,
        itemTemplate = _ref.itemTemplate,
        blockIndex = _ref.blockIndex;
      var _List$getOffsetsByBlo = List.getOffsetsByBlockData({
          screenSize: screenSize,
          data: {
            title: 'mock'
          },
          blockIndex: blockIndex
        }),
        top = _List$getOffsetsByBlo.top,
        bottom = _List$getOffsetsByBlo.bottom;
      var _getContentSizeByCont = getContentSizeByContentTemplateId(itemTemplate),
        h = _getContentSizeByCont.h;
      return h + top + bottom;
    }
  }]);
  return ListSkeleton;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/tornado/skeleton/skelton.constants.js

var _BLOCKS;



var BLOCKS = (_BLOCKS = {}, (0,defineProperty/* default */.Z)(_BLOCKS, templateTypes.Hero, HeroSkeleton), (0,defineProperty/* default */.Z)(_BLOCKS, blockTemplateTypes.List, ListSkeleton), _BLOCKS);
var DEFAULT_BLOCK_SKELETON = BLOCKS[blockTemplateTypes.List];
var getBlockSkeleton = function getBlockSkeleton(id) {
  return BLOCKS[id] || DEFAULT_BLOCK_SKELETON;
};
;// CONCATENATED MODULE: ./src/modules/tornado/skeleton/skelton.component.js





function skelton_component_createSuper(t) { var r = skelton_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function skelton_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (skelton_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }




var Skeleton = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Skeleton, _Lightning$Component);
  var _super = skelton_component_createSuper(Skeleton);
  function Skeleton() {
    (0,classCallCheck/* default */.Z)(this, Skeleton);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Skeleton, [{
    key: "_construct",
    value: function _construct() {
      this._style = skelton_style_defaultContext;
    }
  }, {
    key: "rows",
    set: function set(value) {
      var offset = 0;
      var children = [];
      for (var i = 0; i < value.length; i += 1) {
        var entry = value[i];
        var hasProps = Boolean(entry.blockTemplate);
        var data = {
          screenSize: this._style.screenSize,
          blockIndex: i,
          itemTemplate: entry.itemTemplate
        };
        var blockSkeletonTemplateId = hasProps ? entry.blockTemplate : entry;
        var block = getBlockSkeleton(blockSkeletonTemplateId);
        var h = block.getHeight(data);
        children.push({
          type: block,
          y: offset,
          h: h,
          items: {
            count: entry.count || 5,
            itemTemplate: entry.itemTemplate,
            itemType: getContentTemplateByTemplateId(entry.itemTemplate),
            itemSize: getContentSizeByContentTemplateId(entry.itemTemplate),
            blockIndex: i
          }
        });
        offset += h;
      }
      this.children = children;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return {
        alpha: 0.25
      };
    }
  }]);
  return Skeleton;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/tornado/skeleton/skelton.provider.js




var SKELETONS = {
  generic: {
    type: Skeleton,
    rows: [templateTypes.Hero, {
      blockTemplate: blockTemplateTypes.List,
      itemTemplate: templateTypes.CardM
    }]
  },
  program: {
    type: Skeleton,
    rows: [templateTypes.Hero, {
      blockTemplate: blockTemplateTypes.List,
      itemTemplate: templateTypes.CardM
    }]
  }
};
var getSkeletonByConfig = function getSkeletonByConfig(config) {
  if (!config) {
    return null;
  }
  if (Array.isArray(config.skeleton)) {
    return {
      type: Skeleton,
      rows: config.skeleton.map(function (name) {
        return BLOCKS[name] ? name : {
          blockTemplate: blockTemplateTypes.List,
          itemTemplate: name
        };
      })
    };
  }
  return config.preset && SKELETONS[config.preset] || null;
};
;// CONCATENATED MODULE: ./src/modules/catalog/platform/default/pageTransition.js


var pageTransition_pageTransition = function pageTransition(pageIn, pageOut) {
  return new Promise(function (resolve) {
    pageIn.visible = true;
    if (pageOut) {
      pageOut.visible = false;
    }
    resolve();
  });
};
;// CONCATENATED MODULE: ./src/logic/routing/routing.selectors.js




var getCurrentPath = function getCurrentPath(state) {
  return get_default()(state, 'routing.currentPath', '');
};
var getCurrentRoute = function getCurrentRoute(state) {
  return get_default()(state, 'routing.currentRoute', '');
};
var isTopLevelRoute = function isTopLevelRoute(state) {
  return get_default()(state, 'routing.isTopLevelRoute', false);
};
var isOpenedViaDeeplink = function isOpenedViaDeeplink(state) {
  return get_default()(state, 'routing.isOpenedViaDeeplink', false);
};
var routing_selectors_shouldDisplayLanding = function shouldDisplayLanding(state) {
  return _get(state, 'routing.shouldDisplayLanding');
};
var isNavigationAllowed = function isNavigationAllowed(state) {
  var isAllowedByRoute = isTopLevelRoute(state);
  var hasProfiles = getPairingStatus(state) === STATUS_PAIRED && getMultiProfileFeature(state);
  var isAllowedByProfile = hasProfiles ? Boolean(get_default()(state, 'pairing.profileUid')) : true;
  return isAllowedByRoute && isAllowedByProfile;
};
var getDeepLink = function getDeepLink(state) {
  return get_default()(state, 'routing.deeplink');
};
var getRouteSkeleton = function getRouteSkeleton(state) {
  return get_default()(state, 'routing.skeleton', '');
};
;// CONCATENATED MODULE: ./src/modules/catalog/page.connector.js



var mapControllers = function mapControllers(instance) {
  return [{
    selector: getCurrentLayout,
    shouldBeInvokedOnConnect: true,
    callback: function callback(value) {
      instance.layout = value;
    }
  }, {
    selector: isTopLevelRoute,
    shouldBeInvokedOnConnect: true,
    callback: function callback(value) {
      instance.hasSideNav = value;
    }
  }, {
    selector: getRouteSkeleton,
    shouldBeInvokedOnConnect: true,
    callback: function callback(value) {
      instance.skeleton = value;
    }
  }];
};
/* harmony default export */ const page_connector = (lightningjs_redux.control(mapControllers));
;// CONCATENATED MODULE: ./src/modules/catalog/page.style.js

function page_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function page_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? page_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : page_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


var page_style_defaultContext = makeDefaultStylingContext();
var RENDERER_HEIGHT = page_style_objectSpread({}, sizes_SCREEN_HEIGHT);
;// CONCATENATED MODULE: ./src/logic/bookmark/bookmark.utils.js






function bookmark_utils_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function bookmark_utils_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? bookmark_utils_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : bookmark_utils_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }




var getUpdatedAnalytics = function getUpdatedAnalytics(isBookmarked) {
  return {
    googleAnalytics: {
      eventAction: isBookmarked ? 'bookmark' : 'unbookmark'
    },
    krxd: {
      appPlatform: env.appPlatform,
      key: isBookmarked ? 'bookmarkAdd' : 'bookmarkRemove'
    },
    ssaTealiumHttp: {
      key: isBookmarked ? 'bookmark' : 'unbookmark'
    }
  };
};
var getBookmarkActionAnalytics = function getBookmarkActionAnalytics(item, bookmarkState) {
  return item.analytics ? Object.keys(item.analytics).reduce(function (result, key) {
    result[key] = bookmark_utils_objectSpread(bookmark_utils_objectSpread({}, item.analytics[key]), get_default()(getUpdatedAnalytics(bookmarkState), key, {}));
    return result;
  }, {}) : {};
};
var bookmark_utils_addBookmark = function () {
  var _ref = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(bookmark, userId) {
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return userService.addBookmark({
            entityId: bookmark.id,
            entityType: bookmark.type,
            uid: userId
          });
        case 3:
          sendEvent(getBookmarkActionAnalytics(bookmark, true));
          _context.next = 8;
          break;
        case 6:
          _context.prev = 6;
          _context.t0 = _context["catch"](0);
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 6]]);
  }));
  return function addBookmark(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var bookmark_utils_removeBookmark = function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2(bookmark, userId) {
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return userService.removeBookmark({
            entityId: bookmark.id,
            entityType: bookmark.type,
            uid: userId
          });
        case 3:
          sendEvent(getBookmarkActionAnalytics(bookmark, false));
          _context2.next = 8;
          break;
        case 6:
          _context2.prev = 6;
          _context2.t0 = _context2["catch"](0);
        case 8:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 6]]);
  }));
  return function removeBookmark(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();
;// CONCATENATED MODULE: ./src/logic/bookmark/bookmark.actions.js



var invalidateCachedBookmarkState = function invalidateCachedBookmarkState(bookmark) {
  return function (dispatch) {
    var blockIndex = bookmark.blockIndex,
      itemIndex = bookmark.itemIndex,
      currentBookmarkState = bookmark.state;
    dispatch(invalidateItemCache(itemIndex, blockIndex, {
      bookmark: {
        state: !currentBookmarkState
      }
    }));
  };
};
var addBookmark = function addBookmark(bookmark) {
  return function (dispatch, getState) {
    dispatch(invalidateCachedBookmarkState(bookmark));
    return bookmark_utils_addBookmark(bookmark, user_selectors_getUid(getState()));
  };
};
var removeBookmark = function removeBookmark(bookmark) {
  return function (dispatch, getState) {
    dispatch(invalidateCachedBookmarkState(bookmark));
    return bookmark_utils_removeBookmark(bookmark, user_selectors_getUid(getState()));
  };
};
;// CONCATENATED MODULE: ./src/logic/lock/lock.actions.js



function lock_actions_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function lock_actions_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? lock_actions_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : lock_actions_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


















var unlockByAuth = function unlockByAuth(item) {
  return function () {
    var _ref = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(dispatch, getState) {
      var state, deeplink;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            state = getState();
            dispatch(player_constants_reset());
            if (!getOpenCatalogFeature(state)) {
              _context.next = 8;
              break;
            }
            deeplink = getDeeplinkFromLock(item);
            if (deeplink) {
              dispatch(setDeeplinkLocation(deeplink));
            }
            navigateToPairingPage();
            _context.next = 11;
            break;
          case 8:
            _context.next = 10;
            return dispatch(logout());
          case 10:
            navigateToLandingPage();
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
var handleLock = function handleLock(actionOptions, lockOptions) {
  return function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2(dispatch, getState) {
      var reason, lock, payload;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            reason = getReason(actionOptions);
            if (!(reason === REQUIRE_AUTH)) {
              _context2.next = 4;
              break;
            }
            dispatch(unlockByAuth(actionOptions.item));
            return _context2.abrupt("return");
          case 4:
            if (!(reason === REFRESH_AUTH)) {
              _context2.next = 7;
              break;
            }
            dispatch(refreshAuth(actionOptions));
            return _context2.abrupt("return");
          case 7:
            lock = get_default()(actionOptions, 'item.action.target.value_lock');
            payload = set_default()(merge_default()({}, actionOptions), 'item.action.target', lock ? lock.originalTarget : null);
            dispatch(showPopupAction(getMappedLockPopup(reason), lock_actions_objectSpread(lock_actions_objectSpread({}, lockOptions), {}, {
              lock: lock,
              payload: payload
            })));
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var SHOW_PROFILES_GATE = 'lock/SHOW_PROFILES_GATE';
var disableProfileAutoSelect = function disableProfileAutoSelect() {
  return {
    type: SHOW_PROFILES_GATE
  };
};
var clearAfterProfileChanged = function clearAfterProfileChanged() {
  return function (dispatch, getState) {
    var section = getCurrentSectionCode(getState());
    dispatch(disableProfileAutoSelect());
    dispatch(resetJwtProfile());
    dispatch(player_constants_reset());
    dispatch(clearCache(layout_constants/* entities */.jF.alias, layout_constants/* aliases */.j3.home, section));
    dispatch(clearCache(layout_constants/* entities */.jF.frontspace, layout_constants/* frontspaces */.K_.bookmarks, section));
  };
};
var checkProfileAutoSelect = function checkProfileAutoSelect(data) {
  return function (dispatch, getState) {
    var items = get_default()(data, 'blocks[0].content.items', []);
    if (items.length === 1) {
      var _getReasonAttributes = getReasonAttributes(items[0]),
        profileUid = _getReasonAttributes.profileUid;
      if (getPreviousProfileUid(getState()) !== profileUid) {
        dispatch(disableProfileAutoSelect());
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/error/error.constants.js
var error_error_constants_ERROR_TYPES = {
  GENERAL: 'general',
  CSL: 'csl',
  PAIRING: 'pairing',
  PLAYER: 'player',
  LAYOUT: 'layout',
  STORAGE: 'storage'
};
var error_error_constants_ERROR_LEVELS = {
  FATAL: 'fatal',
  SILENT: 'silent'
};
var error_constants_RETRY_ACTIONS = {
  LAYOUT_FETCH: 'layout_fetch'
};
;// CONCATENATED MODULE: ./src/modules/cta/cta.utils.js








var getItemTargetValue = function getItemTargetValue(target) {
  return Object.keys(target).filter(function (value) {
    return value.includes('value_');
  })[0];
};
var getItemAnalyticsEvent = function getItemAnalyticsEvent(item) {
  return get_default()(item, 'action.analytics', get_default()(item, 'analytics'));
};
var shouldRefreshAliasHome = function shouldRefreshAliasHome(section, state) {
  var currentSectionCode = getCurrentSectionCode(state);
  return section !== currentSectionCode;
};
var getItemActionType = function getItemActionType(item) {
  if (!item) {
    return null;
  }
  var target = item.action ? item.action.target : item.target;
  if (!target) {
    return item.id;
  }
  var targetValue = getItemTargetValue(target);
  var metadata = target[targetValue];
  var type = metadata.type || metadata.reference || target.type;
  if (type === common_constants_FRONTSPACE && metadata.id === PROFILES_GATE) {
    return cta_constants.PROFILES_GATE;
  }
  return type;
};
var getTargetData = function getTargetData(item) {
  var target = get_default()(item, 'action.target');
  if (!target) {
    return {
      id: item.id
    };
  }
  var targetValue = getItemTargetValue(target);
  return target[targetValue];
};
var getSectionCode = function getSectionCode(item) {
  var target = get_default()(item, 'action.target');
  try {
    var targetTypeMap = {
      layout: 'value_layout'
    };
    var targetValue = targetTypeMap[target.type] || 'value_app';
    var section = target[targetValue].section;
    return section;
  } catch (_unused) {
    return null;
  }
};
var shouldStoreVideoRoute = function shouldStoreVideoRoute(hash) {
  return !/\/video\/.+/.test(hash);
};
;// CONCATENATED MODULE: ./src/modules/cta/cta.actions.js



function cta_actions_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function cta_actions_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? cta_actions_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : cta_actions_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



















var PRESS_BOOKMARKS_BUTTON = 'bookmarks/PRESS_BOOKMARKS_BUTTON';
var PRESS_LOGOUT_BUTTON = 'logout/PRESS_LOGOUT_BUTTON';
var createItemAction = function createItemAction(options) {
  var type = getItemActionType(options.item);
  var targetData = getTargetData(options.item);
  var section = getSectionCode(options.item);
  var event = options.analytics || getItemAnalyticsEvent(options.item);
  var id = targetData.id;
  var reload = shouldRefreshAliasHome(section, lightningjs_redux.getState());
  switch (type) {
    case cta_constants.AUDIO:
      {
        return function () {
          sendEvent(event);
          navigateToAudioPage(id);
        };
      }
    case cta_constants.RADIO:
      {
        return function () {
          sendEvent(event);
          navigateToRadioPage(id);
        };
      }
    case cta_constants.BOOKMARKS:
      return function (dispatch) {
        dispatch(setCurrentSectionCode(section));
        dispatch({
          type: PRESS_BOOKMARKS_BUTTON
        });
        navigateToBookmarksPage();
      };
    case cta_constants.BOOKMARK:
      return function (dispatch) {
        return dispatch(addBookmark(options.item));
      };
    case cta_constants.UNBOOKMARK:
      return function (dispatch) {
        return dispatch(removeBookmark(options.item));
      };
    case cta_constants.CLOSE:
      return function (dispatch) {
        dispatch(setCurrentSectionCode(section));
        sendEvent(event);
        console.log('[CTA] Reloading Home on close');
        navigateToAliasHome({
          reload: reload
        });
      };
    case cta_constants.FOLDER:
      return function (dispatch) {
        dispatch(setCurrentSectionCode(section));
        sendEvent(event);
        navigateToFolderPage(id);
      };
    case cta_constants.FOLDERS:
      return function (dispatch) {
        dispatch(setCurrentSectionCode(section));
        sendEvent(event);
        navigateToFoldersPage();
      };
    case cta_constants.FRONTSPACE:
      return function (dispatch) {
        if (id !== layout_constants/* frontspaces */.K_.offers) {
          dispatch(setCurrentSectionCode(section));
        }
        sendEvent(event);
        navigateToFrontspace(id);
      };
    case cta_constants.PROFILES_GATE:
      return function (dispatch) {
        sendEvent(event);
        dispatch(clearAfterProfileChanged());
        console.log('[CTA] Reloading Home to get Profiles Gate');
        navigateToAliasHome({
          reload: true
        });
      };
    case cta_constants.HOME_ALIAS:
      return function (dispatch) {
        dispatch(setCurrentSectionCode(section));
        sendEvent(event);
        console.log('[CTA] Reloading Home');
        navigateToAliasHome({
          reload: reload
        });
      };
    case cta_constants.INFORMATION:
      return function (dispatch) {
        dispatch(setCurrentSectionCode(section));
        sendEvent(event);
        navigateToInformationPage();
      };
    case cta_constants.USAGE_TERMS:
      return function () {
        navigateToUsageTermsPage();
      };
    case cta_constants.SUBSCRIPTION_TERMS:
      return function (dispatch) {
        dispatch(setCurrentSectionCode(section));
        sendEvent(event);
      };
    case cta_constants.LEGAL_CONDITIONS:
      return function (dispatch) {
        dispatch(setCurrentSectionCode(section));
        sendEvent(event);
        navigateToLegalConditionsPage();
      };
    case cta_constants.PRIVACY_POLICY:
      return function () {
        navigateToPrivacyPolicyPage();
      };
    case cta_constants.LIVE:
      return function () {
        sendEvent(event);
        navigateToLivePage(id);
      };
    case cta_constants.LIVES:
      return function (dispatch) {
        dispatch(setCurrentSectionCode(section));
        sendEvent(event);
        navigateToLivesPage();
      };
    case cta_constants.LOCK:
      sendEvent(event);
      return handleLock({
        item: options.item
      });
    case cta_constants.LOGOUT:
      return function () {
        var _ref = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(dispatch, getState) {
          return regenerator_default().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                console.log('[CTA] Handling logout action');
                rememberSSIDeclined();
                _context.next = 4;
                return dispatch(logout());
              case 4:
                dispatch({
                  type: PRESS_LOGOUT_BUTTON
                });
                sendEvent({
                  key: 'pressLogoutButton'
                });
                dispatch(disableProfileAutoSelect());
                dispatch(resetJwtProfile());
                dispatch(clearCache());
                if (getOpenCatalogFeature(getState())) {
                  dispatch(fetchNavigation('main'));
                  navigateToAliasHome();
                } else {
                  navigateToLandingPage();
                }
              case 10:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }();
    case cta_constants.OPTOUT:
      return function () {
        navigateToSettingsPage();
      };
    case cta_constants.PROFILE:
      return function (dispatch) {
        dispatch(setCurrentSectionCode(section));
        sendEvent(event);
        navigateToProfilePage();
      };
    case cta_constants.PROGRAM:
      return function (dispatch) {
        dispatch(setCurrentSectionCode(section));
        sendEvent(event);
        navigateToProgramPage(id);
      };
    case cta_constants.SEARCH:
      return function (dispatch) {
        dispatch(setCurrentSectionCode(section));
        sendEvent(event);
        navigateToSearchPage();
      };
    case cta_constants.SERVICE:
      return function (dispatch) {
        dispatch(setCurrentSectionCode(section));
        sendEvent(event);
        navigateToServicePage(id);
      };
    case cta_constants.SERVICES:
      return function (dispatch) {
        dispatch(setCurrentSectionCode(section));
        sendEvent(event);
        navigateToServicesPage();
      };
    case cta_constants.VIDEO:
      return function () {
        sendEvent(event);
        navigateToVodPage(id);
      };
    case cta_constants.HELP:
      return function (dispatch) {
        dispatch(setCurrentSectionCode(section));
        overrideGAPageName('main_App_help');
        sendEvent(event);
        navigateToFAQPage();
      };
    case cta_constants.FEEDBACK:
      return function (dispatch) {
        dispatch(setCurrentSectionCode(section));
        overrideGAPageName('main_App_feedback');
        sendEvent(event);
        navigateToFeedbackPage();
      };
    case cta_constants.ACCOUNT_SETTINGS:
      return function (dispatch) {
        dispatch(setCurrentSectionCode(section));
        sendEvent(event);
        navigateToAccountSettingsPage();
      };
    case cta_constants.PLAY:
      return function (dispatch, getState) {
        var state = lightningjs_redux.getState();
        var layout = getCurrentLayout(state);
        var entityType = getRequestedEntityType(state);
        dispatch(setPlayerInitialized(cta_actions_objectSpread({
          layout: layout,
          isLive: entityType === layout_constants/* entities */.jF.live,
          entityType: entityType
        }, options)));
        var source = getVideoSource(getState());
        if (!source) {
          dispatch(error_actions_errorAction(error_error_constants_ERROR_LEVELS.FATAL, error_error_constants_ERROR_TYPES.PLAYER, 'No sources available'));
        }
      };
    default:
  }
  return null;
};
var dispatchItemAction = function dispatchItemAction(item) {
  if (!item) {
    return;
  }
  var action = createItemAction({
    item: item
  });
  if (action) {
    lightningjs_redux.dispatch(action);
  }
};
;// CONCATENATED MODULE: ./src/modules/layout/customer/rtlde/abstractLayout.constants.js
var SHOULD_DISPLAY_CONTEXT_TITLE = false;
var DISPLAY_SHOW_MORE_ON_GRIDS = true;
;// CONCATENATED MODULE: ./src/modules/layout/abstractLayout.utils.js






var getBlockTemplateType = function getBlockTemplateType(block) {
  return getSelectorTemplateById(get_default()(block, 'alternativeContent.selectorTemplateId')) || getBlockTemplateById(block.blockTemplateId);
};
var calculateBlockHeight = function calculateBlockHeight(layoutData) {
  var blockType = layoutData.blockType,
    data = layoutData.data,
    itemSize = layoutData.itemSize,
    screenSize = layoutData.screenSize,
    displayShowMore = layoutData.displayShowMore;
  var rowCounter = blockType.getRowCount;
  var getGap = blockType.getContentGap;
  var rowCount = rowCounter ? rowCounter({
    content: data.content,
    displayShowMore: displayShowMore
  }, screenSize) : 1;
  var itemGap = getGap ? getGap(screenSize) : 0;
  var result = {
    h: (itemSize.h + itemGap) * rowCount,
    top: 0,
    bottom: 0,
    rowCount: rowCount
  };
  var handler = blockType.getOffsetsByBlockData;
  if (handler) {
    var _handler = handler(layoutData),
      top = _handler.top,
      bottom = _handler.bottom,
      h = _handler.h;
    result.top += top;
    result.bottom += bottom;
    result.h = (Number.isFinite(h) ? h : result.h) + top + bottom;
  }
  return result;
};
var couldReuseCurrentViews = function couldReuseCurrentViews(currentBlocks, newBlocks) {
  var checkVerticalBlocksLength = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (!currentBlocks.length || currentBlocks.length !== newBlocks.length) {
    return false;
  }
  for (var i = 0; i < newBlocks.length; i += 1) {
    var newBlock = newBlocks[i];
    var currentBlock = currentBlocks[i];
    if (!currentBlock || !newBlock) {
      return false;
    }
    var blockTemplateId = newBlock.blockTemplateId,
      contentTemplateId = newBlock.content.contentTemplateId;
    if (blockTemplateId !== currentBlock.blockTemplateId || contentTemplateId !== currentBlock.content.contentTemplateId) {
      return false;
    }
    if (checkVerticalBlocksLength && blockTemplateId === Grid.Templates.Grid) {
      var currentItemsCount = get_default()(currentBlock, 'content.items.length', 0);
      var newItemsCount = get_default()(newBlock, 'content.items.length', 0);
      if (currentItemsCount !== newItemsCount) {
        return false;
      }
    }
  }
  return true;
};
var shouldDisplayContextTitle = function shouldDisplayContextTitle(entity, type) {
  return SHOULD_DISPLAY_CONTEXT_TITLE && get_default()(entity, 'type') === type;
};
var shouldDisplayShowMoreButtons = function shouldDisplayShowMoreButtons(entity) {
  return DISPLAY_SHOW_MORE_ON_GRIDS && entity && entity.type === 'program';
};
var createLayoutAction = function createLayoutAction(entityType, entityId, analyticsKey) {
  return {
    item: {
      action: {
        target: {
          type: 'layout',
          value_layout: {
            type: entityType,
            id: entityId
          }
        },
        analytics: {
          key: analyticsKey
        }
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/profilesGate/profilesGate.style.js

var profilesGate_style_CONTENT_GAP, profilesGate_style_LOGO_HEIGHT, _LOGO_Y, _TITLE_MARGIN_BOTTOM;
function profilesGate_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function profilesGate_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? profilesGate_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : profilesGate_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





var profilesGate_style_defaultContext = makeDefaultStylingContext();
var profilesGate_style_getContentPadding = function getContentPadding() {
  var screenSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  var screenDimension = screenSize || profilesGate_style_defaultContext.screenSize;
  return safetyMargins.horizontal[screenDimension];
};
var profilesGate_profilesGate_style_CONTENT_GAP = (profilesGate_style_CONTENT_GAP = {}, (0,defineProperty/* default */.Z)(profilesGate_style_CONTENT_GAP, HD, 40), (0,defineProperty/* default */.Z)(profilesGate_style_CONTENT_GAP, FULL_HD, 40), profilesGate_style_CONTENT_GAP);
var profilesGate_style_WIDTH = profilesGate_style_objectSpread({}, SCREEN_WIDTH);
var profilesGate_profilesGate_style_LOGO_HEIGHT = (profilesGate_style_LOGO_HEIGHT = {}, (0,defineProperty/* default */.Z)(profilesGate_style_LOGO_HEIGHT, HD, 128), (0,defineProperty/* default */.Z)(profilesGate_style_LOGO_HEIGHT, FULL_HD, 152), profilesGate_style_LOGO_HEIGHT);
var LOGO_Y = (_LOGO_Y = {}, (0,defineProperty/* default */.Z)(_LOGO_Y, HD, 88), (0,defineProperty/* default */.Z)(_LOGO_Y, FULL_HD, 104), _LOGO_Y);
var TITLE_MARGIN_BOTTOM = (_TITLE_MARGIN_BOTTOM = {}, (0,defineProperty/* default */.Z)(_TITLE_MARGIN_BOTTOM, HD, 40), (0,defineProperty/* default */.Z)(_TITLE_MARGIN_BOTTOM, FULL_HD, 96), _TITLE_MARGIN_BOTTOM);
var profilesGate_style_colors = {
  background: makeThemeColor(TERTIARY)
};
var profilesGate_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : profilesGate_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  var w = profilesGate_style_WIDTH[screenSize];
  var h = sizes_SCREEN_HEIGHT[screenSize];
  var titleY = LOGO_Y[screenSize] + profilesGate_profilesGate_style_LOGO_HEIGHT[screenSize];
  var titleFont = src_getFont(constants_FONT.PARIS_3, screenSize);
  return {
    w: w,
    h: h,
    alpha: 0,
    Background: {
      w: w,
      h: h,
      color: profilesGate_style_colors.background[colorMode]
    },
    CustomerLogo: {
      mountX: 0.5,
      x: middle,
      y: LOGO_Y[screenSize],
      h: profilesGate_profilesGate_style_LOGO_HEIGHT[screenSize]
    },
    Title: {
      mountX: 0.5,
      x: Math.round(w / 2),
      y: titleY,
      text: titleFont
    },
    Blocks: {
      y: titleY + titleFont.lineHeight + TITLE_MARGIN_BOTTOM[screenSize],
      w: w
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/popups/exitPopup/exitPopup.style.js

var _POPUP_WIDTH, _POPUP_HEIGHT, _TITLE_WIDTH, exitPopup_style_TITLE_HEIGHT, exitPopup_style_FLEX_CONTAINER_HEIGH, _ICON_OFFSET, _TEXT_OFFSET, _BUTTONS_OFFSET, exitPopup_style_ICON_HEIGHT, exitPopup_style_BORDER_RADIUS;
function exitPopup_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function exitPopup_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? exitPopup_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : exitPopup_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






var titleFont = src_getFont(constants_FONT.OTTAWA_1);
var exitPopup_style_defaultContext = makeDefaultStylingContext();
var exitPopup_style_colors = {
  popup: makeThemeColor(TERTIARY),
  popupOverlay: makeThemeColor(TERTIARY, 0.8),
  text: makeThemeColor(PRIMARY)
};
var POPUP_WIDTH = (_POPUP_WIDTH = {}, (0,defineProperty/* default */.Z)(_POPUP_WIDTH, HD, 672), (0,defineProperty/* default */.Z)(_POPUP_WIDTH, FULL_HD, 960), _POPUP_WIDTH);
var POPUP_HEIGHT = (_POPUP_HEIGHT = {}, (0,defineProperty/* default */.Z)(_POPUP_HEIGHT, HD, 196), (0,defineProperty/* default */.Z)(_POPUP_HEIGHT, FULL_HD, 232), _POPUP_HEIGHT);
var TITLE_WIDTH = (_TITLE_WIDTH = {}, (0,defineProperty/* default */.Z)(_TITLE_WIDTH, HD, 512), (0,defineProperty/* default */.Z)(_TITLE_WIDTH, FULL_HD, 776), _TITLE_WIDTH);
var exitPopup_exitPopup_style_TITLE_HEIGHT = (exitPopup_style_TITLE_HEIGHT = {}, (0,defineProperty/* default */.Z)(exitPopup_style_TITLE_HEIGHT, HD, 30), (0,defineProperty/* default */.Z)(exitPopup_style_TITLE_HEIGHT, FULL_HD, 36), exitPopup_style_TITLE_HEIGHT);
var exitPopup_style_FLEX_CONTAINER_HEIGHT = (exitPopup_style_FLEX_CONTAINER_HEIGH = {}, (0,defineProperty/* default */.Z)(exitPopup_style_FLEX_CONTAINER_HEIGH, HD, 41), (0,defineProperty/* default */.Z)(exitPopup_style_FLEX_CONTAINER_HEIGH, FULL_HD, 56), exitPopup_style_FLEX_CONTAINER_HEIGH);
var ICON_OFFSET = (_ICON_OFFSET = {}, (0,defineProperty/* default */.Z)(_ICON_OFFSET, HD, 24), (0,defineProperty/* default */.Z)(_ICON_OFFSET, FULL_HD, 24), _ICON_OFFSET);
var TEXT_OFFSET = (_TEXT_OFFSET = {}, (0,defineProperty/* default */.Z)(_TEXT_OFFSET, HD, 8), (0,defineProperty/* default */.Z)(_TEXT_OFFSET, FULL_HD, 8), _TEXT_OFFSET);
var BUTTONS_OFFSET = (_BUTTONS_OFFSET = {}, (0,defineProperty/* default */.Z)(_BUTTONS_OFFSET, HD, 16), (0,defineProperty/* default */.Z)(_BUTTONS_OFFSET, FULL_HD, 24), _BUTTONS_OFFSET);
var exitPopup_exitPopup_style_ICON_HEIGHT = (exitPopup_style_ICON_HEIGHT = {}, (0,defineProperty/* default */.Z)(exitPopup_style_ICON_HEIGHT, HD, 40), (0,defineProperty/* default */.Z)(exitPopup_style_ICON_HEIGHT, FULL_HD, 48), exitPopup_style_ICON_HEIGHT);
var exitPopup_exitPopup_style_BORDER_RADIUS = (exitPopup_style_BORDER_RADIUS = {}, (0,defineProperty/* default */.Z)(exitPopup_style_BORDER_RADIUS, HD, 24), (0,defineProperty/* default */.Z)(exitPopup_style_BORDER_RADIUS, FULL_HD, 40), exitPopup_style_BORDER_RADIUS);
var exitPopup_style_INFO_ICON = {
  name: 'Warning',
  type: 'icon'
};
var exitPopup_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : exitPopup_style_defaultContext,
    screenSize = _ref.screenSize,
    colorMode = _ref.colorMode;
  return {
    Overlay: {
      rect: true,
      w: SCREEN_WIDTH[screenSize],
      h: sizes_SCREEN_HEIGHT[screenSize],
      color: colors_TRANSPARENT
    },
    Popup: {
      rect: true,
      x: SCREEN_WIDTH[screenSize] / 2 - POPUP_WIDTH[screenSize] / 2,
      y: sizes_SCREEN_HEIGHT[screenSize] / 2 - POPUP_HEIGHT[screenSize] / 2,
      w: POPUP_WIDTH[screenSize],
      h: POPUP_HEIGHT[screenSize],
      borderRadius: exitPopup_exitPopup_style_BORDER_RADIUS[screenSize],
      flex: {
        direction: 'column'
      },
      color: colors_TRANSPARENT,
      Icon: {
        flexItem: {
          marginTop: ICON_OFFSET[screenSize]
        },
        mountX: 0.5,
        x: middle,
        color: exitPopup_style_colors.text[colorMode],
        iconData: {
          picto: exitPopup_style_INFO_ICON,
          viewBox: {
            h: exitPopup_exitPopup_style_ICON_HEIGHT[screenSize]
          }
        }
      },
      Title: {
        visible: false,
        flexItem: {
          marginTop: TEXT_OFFSET[screenSize]
        },
        mountX: 0.5,
        x: middle,
        text: exitPopup_style_objectSpread(exitPopup_style_objectSpread({
          textColor: exitPopup_style_colors.text[colorMode]
        }, titleFont), {}, {
          verticalAlign: 'middle',
          maxLines: 1
        })
      },
      ButtonsFlexContainer: {
        rect: true,
        visible: false,
        h: exitPopup_style_FLEX_CONTAINER_HEIGHT[screenSize],
        w: identity,
        flexItem: {
          marginTop: BUTTONS_OFFSET[screenSize]
        },
        color: colors_TRANSPARENT,
        flex: {
          direction: 'row',
          justifyContent: 'center'
        },
        ExitButton: {
          flexItem: {
            marginRight: BUTTONS_OFFSET[screenSize]
          }
        }
      }
    }
  };
};
var getFinalStyle = function getFinalStyle() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : exitPopup_style_defaultContext,
    colorMode = _ref2.colorMode;
  return {
    Overlay: {
      color: exitPopup_style_colors.popupOverlay[colorMode]
    },
    Popup: {
      color: exitPopup_style_colors.popup[colorMode],
      Title: {
        visible: true
      },
      ButtonsFlexContainer: {
        visible: true
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/popupContainer/popupContainer.constants.js
var HIDE_POPUP_SIGNAL = 'hideFullscreenPopup';
var EXIT_APP_SIGNAL = 'exitApp';
var ROUTE_BACK_SIGNAL = 'routeBack';
;// CONCATENATED MODULE: ./src/modules/tornado/callToAction/background/buttonRectangle.component.js





function buttonRectangle_component_createSuper(t) { var r = buttonRectangle_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function buttonRectangle_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (buttonRectangle_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var ButtonRectangle = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(ButtonRectangle, _Lightning$Component);
  var _super = buttonRectangle_component_createSuper(ButtonRectangle);
  function ButtonRectangle() {
    (0,classCallCheck/* default */.Z)(this, ButtonRectangle);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(ButtonRectangle, [{
    key: "_construct",
    value: function _construct() {
      this._borderColor = 0;
      this._borderWidth = 0;
      this._borderRadius = 0;
    }
  }, {
    key: "borderColor",
    get: function get() {
      return this._borderColor;
    },
    set: function set(value) {
      this._borderColor = value;
      this.patch({
        shader: {
          strokeColor: value
        }
      });
    }
  }, {
    key: "borderWidth",
    get: function get() {
      return this._borderWidth;
    },
    set: function set(value) {
      this._borderWidth = value;
      this.patch({
        shader: {
          stroke: value
        }
      });
    }
  }, {
    key: "borderRadius",
    get: function get() {
      return this._borderRadius;
    },
    set: function set(value) {
      this._borderRadius = value;
      this.patch({
        shader: {
          radius: value
        }
      });
    }
  }], [{
    key: "_template",
    value: function _template() {
      return {
        rect: true,
        shader: {
          type: src_Lightning.shaders.RoundedRectangle
        }
      };
    }
  }]);
  return ButtonRectangle;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/popups/exitPopup/exitPopup.component.js






function exitPopup_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function exitPopup_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? exitPopup_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : exitPopup_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function exitPopup_component_createSuper(t) { var r = exitPopup_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function exitPopup_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (exitPopup_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }










var ExitPopup = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(ExitPopup, _Lightning$Component);
  var _super = exitPopup_component_createSuper(ExitPopup);
  function ExitPopup() {
    (0,classCallCheck/* default */.Z)(this, ExitPopup);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(ExitPopup, [{
    key: "_attach",
    value: function _attach() {
      var _this = this;
      var icon = this.tag('Popup').tag('Icon');
      var handleUpdate = function handleUpdate() {
        _this.patch(exitPopup_component_objectSpread({}, getFinalStyle()));
      };
      icon.on('txLoaded', handleUpdate);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this.tag('Popup').tag('Icon').removeAllListeners('txLoaded');
    }
  }, {
    key: "_build",
    value: function _build() {
      this._index = 0;
      this._actionTypes = [EXIT_APP_SIGNAL, HIDE_POPUP_SIGNAL];
      this._buttons = this.tag('Popup').tag('ButtonsFlexContainer').children;
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this._buttons[this._index];
    }
  }, {
    key: "_handleRight",
    value: function _handleRight() {
      if (this._index < this._buttons.length - 1) {
        this._setIndex(this._index + 1);
        return true;
      }
      return false;
    }
  }, {
    key: "_handleLeft",
    value: function _handleLeft() {
      if (this._index > 0) {
        this._setIndex(this._index - 1);
        return true;
      }
      return true;
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      this.signal(this._actionTypes[this._index]);
    }
  }, {
    key: "_setIndex",
    value: function _setIndex() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._index;
      this._index = index;
    }
  }], [{
    key: "_template",
    value: function _template() {
      var _passSignals;
      return merge_default()({
        w: identity,
        h: identity,
        Overlay: {},
        Popup: {
          type: ButtonRectangle,
          Icon: {
            type: Icon
          },
          Title: {
            text: {
              text: t('global.confirmExit')
            }
          },
          ButtonsFlexContainer: {
            ExitButton: {
              type: Button,
              label: t('global.ok'),
              colorMode: DARK_MODE
            },
            CancelButton: {
              type: Button,
              label: t('global.cancel'),
              colorMode: DARK_MODE
            }
          }
        },
        passSignals: (_passSignals = {}, (0,defineProperty/* default */.Z)(_passSignals, EXIT_APP_SIGNAL, true), (0,defineProperty/* default */.Z)(_passSignals, HIDE_POPUP_SIGNAL, true), _passSignals)
      }, exitPopup_style_getInitialStyle());
    }
  }]);
  return ExitPopup;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/profilesGate/profilesGate.component.js






function profilesGate_component_createSuper(t) { var r = profilesGate_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function profilesGate_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (profilesGate_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }














var ProfilesGate = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(ProfilesGate, _Lightning$Component);
  var _super = profilesGate_component_createSuper(ProfilesGate);
  function ProfilesGate() {
    (0,classCallCheck/* default */.Z)(this, ProfilesGate);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(ProfilesGate, [{
    key: "_construct",
    value: function _construct() {
      this._style = profilesGate_style_defaultContext;
    }
  }, {
    key: "data",
    set: function set(value) {
      this._data = value;
      var _this$_data = this._data,
        blocks = _this$_data.blocks,
        layout = _this$_data.layout;
      if (!blocks || !blocks.length) {
        return;
      }
      var children = [];
      var theme = getLayoutTheme(get_default()(layout, 'theme'));
      var data = blocks[0];
      var title = getTitle(data.title);
      data.title = {};
      var blockType = getBlockTemplateById(data.blockTemplateId);
      var itemType = getContentTemplateByTemplateId(data.content.contentTemplateId);
      var itemSize = getContentSizeByContentTemplateId(data.content.contentTemplateId);
      var blockSize = calculateBlockHeight({
        blockType: blockType,
        data: data,
        itemSize: itemSize
      });
      var w = profilesGate_style_WIDTH[this._style.screenSize];
      children.push({
        type: blockType,
        data: {
          block: data,
          itemSize: itemSize,
          itemType: itemType,
          theme: theme,
          rowSize: {
            w: w,
            h: blockSize.h
          }
        },
        contentGap: profilesGate_profilesGate_style_CONTENT_GAP[this._style.screenSize],
        contentPadding: profilesGate_style_getContentPadding(),
        w: w,
        h: blockSize.h,
        signals: (0,defineProperty/* default */.Z)({}, SELECTED_SIGNAL, '_handleSelected')
      });
      this.patch({
        alpha: 1,
        Background: {
          color: theme.backgroundColor || profilesGate_style_colors.background[this._style.colorMode]
        },
        Title: {
          text: {
            text: title
          }
        },
        Blocks: {
          children: children
        }
      });
      this._refocus();
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this.tag('ExitPopup').visible ? this.tag('ExitPopup') : this.tag('Blocks').children[0];
    }
  }, {
    key: "_handleSelected",
    value: function _handleSelected(item) {
      this.visible = false;
      return lightningjs_redux.dispatch(createItemAction({
        item: item
      }));
    }
  }, {
    key: "_handleBack",
    value: function _handleBack() {
      var exitPopup = this.tag('ExitPopup');
      exitPopup.visible = !exitPopup.visible;
      return true;
    }
  }, {
    key: "_handleExitAppSignal",
    value: function _handleExitAppSignal() {
      this.signal(EXIT_APP_SIGNAL);
    }
  }, {
    key: "_handleHidePopupSignal",
    value: function _handleHidePopupSignal() {
      this.tag('ExitPopup').visible = false;
      this._refocus();
    }
  }], [{
    key: "_template",
    value: function _template() {
      var _signals2, _passSignals;
      return merge_default()({
        Background: {
          rect: true
        },
        CustomerLogo: {
          type: BrandIcon
        },
        Title: {},
        Blocks: {},
        ExitPopup: {
          visible: false,
          type: ExitPopup,
          signals: (_signals2 = {}, (0,defineProperty/* default */.Z)(_signals2, EXIT_APP_SIGNAL, '_handleExitAppSignal'), (0,defineProperty/* default */.Z)(_signals2, HIDE_POPUP_SIGNAL, '_handleHidePopupSignal'), _signals2),
          passSignals: (_passSignals = {}, (0,defineProperty/* default */.Z)(_passSignals, EXIT_APP_SIGNAL, false), (0,defineProperty/* default */.Z)(_passSignals, HIDE_POPUP_SIGNAL, false), _passSignals)
        },
        testId: 'ProfilesGate'
      }, profilesGate_style_getInitialStyle());
    }
  }]);
  return ProfilesGate;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/contextTitle/contextTitle.style.js

var _RECTANGLE_HEIGHT, _PICTO_HEIGHT;
function contextTitle_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function contextTitle_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? contextTitle_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : contextTitle_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






var contextTitle_style_defaultContext = makeDefaultStylingContext();
var RECTANGLE_HEIGHT = (_RECTANGLE_HEIGHT = {}, (0,defineProperty/* default */.Z)(_RECTANGLE_HEIGHT, HD, 88), (0,defineProperty/* default */.Z)(_RECTANGLE_HEIGHT, FULL_HD, 88), _RECTANGLE_HEIGHT);
var PICTO_HEIGHT = (_PICTO_HEIGHT = {}, (0,defineProperty/* default */.Z)(_PICTO_HEIGHT, HD, 60), (0,defineProperty/* default */.Z)(_PICTO_HEIGHT, FULL_HD, 60), _PICTO_HEIGHT);
var contextTitle_style_colors = {
  background: makeThemeColor(TERTIARY)
};
var contextTitle_style_getInitialStyle = memoize_default()(function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : contextTitle_style_defaultContext,
    screenSize = _ref.screenSize,
    colorMode = _ref.colorMode;
  return {
    Rectangle: {
      rect: true,
      zIndex: 2,
      w: SCREEN_WIDTH[screenSize],
      h: RECTANGLE_HEIGHT[screenSize],
      color: contextTitle_style_colors.background[colorMode],
      Label: {
        mount: 0.5,
        x: middle,
        y: middle,
        text: contextTitle_style_objectSpread({}, src_getFont(constants_FONT.OTTAWA_1, screenSize))
      }
    }
  };
});
;// CONCATENATED MODULE: ./src/modules/contextTitle/contextTitle.component.js





function contextTitle_component_createSuper(t) { var r = contextTitle_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function contextTitle_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (contextTitle_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }




var ContextTitle = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(ContextTitle, _Lightning$Component);
  var _super = contextTitle_component_createSuper(ContextTitle);
  function ContextTitle() {
    (0,classCallCheck/* default */.Z)(this, ContextTitle);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(ContextTitle, [{
    key: "data",
    set: function set(value) {
      var title = get_default()(value, 'metadata.title', '');
      this.tag('Rectangle').tag('Label').text = title;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Rectangle: {
          Label: {}
        }
      }, contextTitle_style_getInitialStyle());
    }
  }]);
  return ContextTitle;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/layout/abstractLayout.connect.js


var abstractLayout_connect_mapControllers = function mapControllers(instance) {
  return [{
    selector: isTopLevelRoute,
    shouldBeInvokedOnConnect: true,
    callback: function callback(value) {
      instance.hasSideNav = value;
    }
  }];
};
/* harmony default export */ const abstractLayout_connect = (lightningjs_redux.control(abstractLayout_connect_mapControllers));
;// CONCATENATED MODULE: ./src/modules/app/utils/platform/vodafone/app.utils.js
function closeApp() {
  window.close();
}
;// CONCATENATED MODULE: ./src/modules/app/utils/platform/default/rcu.utils.js
var patchKeyListener = function patchKeyListener() {};
;// CONCATENATED MODULE: ./src/modules/app/utils/app.utils.js










var showSnackbar = function showSnackbar(root, level, message) {
  root.fireAncestors("$".concat(NOTIFICATION_SIGNAL), makeNotification(level, message));
};
var handleInteraction = function handleInteraction(item, root) {
  if (item && item.id && item.id !== PLACEHOLDER.id) {
    lightningjs_redux.dispatch(createItemAction({
      item: item
    }));
    var type = getItemActionType(item);
    if (type === cta_constants.BOOKMARK) {
      showSnackbar(root, NOTIFICATION_LEVEL.SUCCESS, t('bookmarks.added'));
    } else if (type === cta_constants.UNBOOKMARK) {
      showSnackbar(root, NOTIFICATION_LEVEL.SUCCESS, t('bookmarks.removed'));
    }
  }
};
;// CONCATENATED MODULE: ./src/modules/layout/abstractLayout.component.js










function abstractLayout_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function abstractLayout_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? abstractLayout_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : abstractLayout_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function abstractLayout_component_createSuper(t) { var r = abstractLayout_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function abstractLayout_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (abstractLayout_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }




















var AbstractLayout = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(AbstractLayout, _Lightning$Component);
  var _super = abstractLayout_component_createSuper(AbstractLayout);
  function AbstractLayout() {
    (0,classCallCheck/* default */.Z)(this, AbstractLayout);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(AbstractLayout, [{
    key: "_construct",
    value: function _construct() {
      this._positions = [];
      this._indexMap = [];
      this._index = 0;
      this._hasSideNav = false;
      this._style = abstractLayout_style_defaultContext;
      this._verticalOffset = 0;
      this._viewsCount = 0;
    }
  }, {
    key: "_attach",
    value: function _attach() {
      this._unsubscribe = abstractLayout_connect(this);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      if (this._unsubscribe) {
        this._unsubscribe();
        this._unsubscribe = null;
      }
      this._data = undefined;
    }
  }, {
    key: "data",
    get: function get() {
      return this._data;
    },
    set: function set(value) {
      var blocks = value.blocks,
        entity = value.entity,
        layout = value.layout;
      var currentViews = this.tag('Blocks').children;
      var couldReuse = this._shouldRefreshPlacement(value.blocks);
      var contentPadding = getContentPadding(this._hasSideNav);
      this._data = value;
      if (couldReuse) {
        for (var i = 0; i < blocks.length; i += 1) {
          var view = currentViews[i];
          if (view) {
            var block = blocks[i];
            view.patch({
              data: abstractLayout_component_objectSpread(abstractLayout_component_objectSpread({}, view.data), {}, {
                block: block
              }),
              contentPadding: contentPadding
            });
          }
        }
        this._refocus();
        this._restoreFocusedItemIndex();
        return;
      }
      this._positions = [];
      this._indexMap = [];
      var focusMode = src.featureFlipping.leftCornerFocus ? FOCUS_MODE_LEFT : FOCUS_MODE_CENTER;
      var theme = getLayoutTheme(get_default()(layout, 'theme'));
      var screenSize = this._style.screenSize;
      var children = [];
      var width = abstractLayout_style_WIDTH[screenSize];
      var halfOfScreenHeight = abstractLayout_style_HEIGHT[screenSize] / 2;
      var displayShowMore = shouldDisplayShowMoreButtons(entity);
      var offset = 0;
      for (var _i = 0; _i < blocks.length; _i += 1) {
        var _signals;
        var data = blocks[_i];
        var blockType = getBlockTemplateType(data);
        var itemType = getContentTemplateByTemplateId(data.content.contentTemplateId);
        var itemSize = getContentSizeByContentTemplateId(data.content.contentTemplateId);
        var blockSize = calculateBlockHeight({
          blockType: blockType,
          itemType: itemType,
          data: data,
          itemSize: itemSize,
          blockIndex: _i,
          screenSize: screenSize,
          displayShowMore: displayShowMore
        });
        children.push({
          type: blockType,
          focusMode: focusMode,
          data: {
            block: data,
            blockIndex: _i,
            blockTemplate: data.blockTemplateId,
            itemSize: itemSize,
            itemType: itemType,
            itemTemplate: data.content.contentTemplateId,
            theme: theme,
            rowSize: {
              w: width,
              h: blockSize.h
            },
            displayShowMore: displayShowMore
          },
          contentPadding: contentPadding,
          w: width,
          h: blockSize.h,
          y: offset,
          signals: (_signals = {}, (0,defineProperty/* default */.Z)(_signals, SELECTED_SIGNAL, '_handleSelected'), (0,defineProperty/* default */.Z)(_signals, PORTION_REQUESTED_SIGNAL, '_handlePortionRequest'), (0,defineProperty/* default */.Z)(_signals, EPG_SIGNAL, '_handleEpg'), (0,defineProperty/* default */.Z)(_signals, HIDE_BACKGROUND_SIGNAL, '_hideBackground'), (0,defineProperty/* default */.Z)(_signals, SHOW_BACKGROUND_SIGNAL, '_showBackground'), (0,defineProperty/* default */.Z)(_signals, SHOW_GRID_SIGNAL, '_showGrid'), _signals)
        });
        var rowSize = Math.round(blockSize.h / blockSize.rowCount);
        var halfOfRowSize = Math.round(rowSize / 2);
        for (var j = 0; j < blockSize.rowCount; j += 1) {
          this._positions.push(Math.min(halfOfScreenHeight - offset - halfOfRowSize, 0));
          this._indexMap.push(_i);
          offset += rowSize;
        }
      }
      this._backgroundColor = theme.backgroundColor || BACKGROUND_COLOR[this._style.colorMode];
      this.patch({
        Background: {
          color: this._backgroundHidden ? colors_TRANSPARENT : this._backgroundColor
        },
        Blocks: {
          children: children
        }
      });
      if (this._positions.length) {
        if (offset > abstractLayout_style_HEIGHT[screenSize]) {
          var minOffset = abstractLayout_style_HEIGHT[screenSize] - offset - BOTTOM_PADDING[this._style.screenSize];
          this._positions = this._positions.map(function (y) {
            return Math.max(minOffset, y);
          });
        }
        this._setIndex(Math.min(this._index, this._positions.length - 1));
      }
      var verticalOffset = this._getVerticalOffset();
      if (!verticalOffset) {
        this.tag('ContextTitle').alpha = 0;
      }
      if (verticalOffset !== this._verticalOffset) {
        this._verticalOffset = verticalOffset;
        this._setIndex(this._index);
      }
      this._refocus();
      this._restoreFocusedItemIndex();
    }
  }, {
    key: "hasSideNav",
    set: function set(value) {
      if (this._hasSideNav !== value) {
        this._hasSideNav = value;
        this._applyContentPadding();
      }
    }
  }, {
    key: "historyState",
    value: function historyState(history) {
      if (history) {
        var _history$row = history.row,
          row = _history$row === void 0 ? 0 : _history$row,
          _history$column = history.column,
          column = _history$column === void 0 ? 0 : _history$column;
        var index = Number.isFinite(row) ? row : 0;
        this._index = Math.max(index, 0);
        this._column = column;
        this._setIndex(this._index);
        this._restoreFocusedItemIndex();
        return undefined;
      }
      var focusedBlock = this._getFocused();
      return {
        row: this._index,
        column: focusedBlock ? focusedBlock.focusedIndex : 0
      };
    }
  }, {
    key: "_applyContentPadding",
    value: function _applyContentPadding() {
      var value = getContentPadding(this._hasSideNav);
      this.tag('Blocks').children.forEach(function (child) {
        child.contentPadding = value;
      });
    }
  }, {
    key: "_shouldRefreshPlacement",
    value: function _shouldRefreshPlacement(newBlocks) {
      return couldReuseCurrentViews(this._data ? this._data.blocks : [], newBlocks);
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      var views = this.tag('Blocks').children;
      return views && views[this._indexMap[this._index]];
    }
  }, {
    key: "_handleUp",
    value: function _handleUp() {
      if (this._index > 0) {
        var previousBlock = this._getFocused();
        this._setIndex(this._index - 1, true);
        var block = this._getFocused();
        if (block && previousBlock !== block && !block.focusedIndex) {
          block.focusedIndex = block.maxIndex || 0;
        }
        return true;
      }
      return false;
    }
  }, {
    key: "_handleDown",
    value: function _handleDown() {
      if (this._index < this._indexMap.length - 1) {
        this._setIndex(this._index + 1, true);
        return true;
      }
      return false;
    }
  }, {
    key: "_captureKey",
    value: function _captureKey() {
      this._column = undefined;
      return false;
    }
  }, {
    key: "_restoreFocusedItemIndex",
    value: function _restoreFocusedItemIndex() {
      var focusedBlock = this._getFocused();
      if (focusedBlock && Number.isFinite(this._column) && focusedBlock.focusedIndex !== this._column) {
        focusedBlock.focusedIndex = this._column;
      }
    }
  }, {
    key: "_handleSelected",
    value: function _handleSelected(item) {
      handleInteraction(item, this);
    }
  }, {
    key: "_handlePortionRequest",
    value: function _handlePortionRequest(portion) {
      lightningjs_redux.dispatch(fetchBlockPage(portion));
    }
  }, {
    key: "_handleEpg",
    value: function _handleEpg(date) {
      lightningjs_redux.dispatch(fetchEPGLayout(date));
    }
  }, {
    key: "_showGrid",
    value: function _showGrid(block) {
      lightningjs_redux.dispatch(showPopupAction(GRID_POPUP_ID, {
        block: block
      }));
    }
  }, {
    key: "_hideBackground",
    value: function _hideBackground() {
      this._backgroundHidden = true;
      this.tag('Background').setSmooth('color', colors_TRANSPARENT, {
        duration: 0.25
      });
    }
  }, {
    key: "_showBackground",
    value: function _showBackground() {
      this._backgroundHidden = false;
      this.tag('Background').setSmooth('color', this._backgroundColor, {
        duration: 0.025
      });
    }
  }, {
    key: "_setIndex",
    value: function _setIndex() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._index;
      var shouldAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var position = this._positions[index];
      if (!Number.isFinite(position)) {
        return;
      }
      var offset = index === 0 ? this._verticalOffset : 0;
      var targetOffset = position + offset;
      this._index = index;
      if (shouldAnimate) {
        this.tag('Blocks').setSmooth('y', targetOffset);
      } else {
        this.tag('Blocks').y = targetOffset;
      }
    }
  }, {
    key: "_getVerticalOffset",
    value: function _getVerticalOffset() {
      if (this._data) {
        var entity = this._data.entity;
        if (shouldDisplayContextTitle(entity, FOLDER)) {
          this.tag('ContextTitle').patch({
            data: entity,
            alpha: 1
          });
          return RECTANGLE_HEIGHT[this._style.screenSize];
        }
      }
      return 0;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Background: {
          rect: true
        },
        ContextTitle: {
          type: ContextTitle
        },
        Blocks: {}
      }, abstractLayout_style_getInitialStyle());
    }
  }]);
  return AbstractLayout;
}(src_Lightning.Component);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/debounce.js
var lodash_debounce = __webpack_require__(66292);
var debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
;// CONCATENATED MODULE: ./src/modules/tornado/keyboard/keyboard.style.js

var _KEYBOARD_HEIGHT, _KEYBOARD_WIDTH, _KEYBOARD_OFFSET_X, _KEYBOARD_OFFSET_Y;



var keyboard_style_defaultContext = makeDefaultStylingContext();
var KEYBOARD_HEIGHT = (_KEYBOARD_HEIGHT = {}, (0,defineProperty/* default */.Z)(_KEYBOARD_HEIGHT, HD, 163), (0,defineProperty/* default */.Z)(_KEYBOARD_HEIGHT, FULL_HD, 227), _KEYBOARD_HEIGHT);
var KEYBOARD_WIDTH = (_KEYBOARD_WIDTH = {}, (0,defineProperty/* default */.Z)(_KEYBOARD_WIDTH, HD, 489), (0,defineProperty/* default */.Z)(_KEYBOARD_WIDTH, FULL_HD, 729), _KEYBOARD_WIDTH);
var KEYBOARD_OFFSET_X = (_KEYBOARD_OFFSET_X = {}, (0,defineProperty/* default */.Z)(_KEYBOARD_OFFSET_X, HD, 192), (0,defineProperty/* default */.Z)(_KEYBOARD_OFFSET_X, FULL_HD, 264), _KEYBOARD_OFFSET_X);
var KEYBOARD_OFFSET_Y = (_KEYBOARD_OFFSET_Y = {}, (0,defineProperty/* default */.Z)(_KEYBOARD_OFFSET_Y, HD, 120), (0,defineProperty/* default */.Z)(_KEYBOARD_OFFSET_Y, FULL_HD, 205), _KEYBOARD_OFFSET_Y);
var keyboard_style_colors = {
  background: makeThemeColor(TERTIARY)
};
var keyboard_style_screenSize = keyboard_style_defaultContext.screenSize,
  colorMode = keyboard_style_defaultContext.colorMode;

var keyboard_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : keyboard_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  return {
    x: KEYBOARD_OFFSET_X[screenSize],
    y: KEYBOARD_OFFSET_Y[screenSize],
    Background: {
      rect: true,
      h: KEYBOARD_HEIGHT[screenSize],
      w: KEYBOARD_WIDTH[screenSize],
      color: keyboard_style_colors.background[colorMode]
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/keyboard/keyItem/customer/default/keyItem.constants.js
var RADIUS = 4;
var BACKGROUND_UNFOCUSED_OPACITY = 0;
var ICON_BACKGROUND_UNFOCUSED_OPACITY = 0.2;
var FOCUSED_FONT = 'KINSHASA_1';
var UNFOCUSED_FONT = 'KINSHASA_1';
;// CONCATENATED MODULE: ./src/modules/tornado/keyboard/keyItem/keyItem.style.js

var _KEY_HEIGHT, _KEY_WIDTH, _PICTO_DIMENSIONS, _SPECIAL_INDICATOR_OF, _SPECIAL_INDICATOR_SI;
function keyItem_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function keyItem_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? keyItem_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : keyItem_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






var keyItem_style_defaultContext = makeDefaultStylingContext();
var keyItem_style_BORDER_RADIUS = RADIUS;
var KEY_HEIGHT = (_KEY_HEIGHT = {}, (0,defineProperty/* default */.Z)(_KEY_HEIGHT, HD, 40), (0,defineProperty/* default */.Z)(_KEY_HEIGHT, FULL_HD, 56), _KEY_HEIGHT);
var KEY_WIDTH = (_KEY_WIDTH = {}, (0,defineProperty/* default */.Z)(_KEY_WIDTH, HD, 48), (0,defineProperty/* default */.Z)(_KEY_WIDTH, FULL_HD, 72), _KEY_WIDTH);
var PICTO_DIMENSIONS = (_PICTO_DIMENSIONS = {}, (0,defineProperty/* default */.Z)(_PICTO_DIMENSIONS, HD, {
  width: 24,
  height: 24
}), (0,defineProperty/* default */.Z)(_PICTO_DIMENSIONS, FULL_HD, {
  width: 36,
  height: 36
}), _PICTO_DIMENSIONS);
var KEYS_GAP = 1;
var SPECIAL_INDICATOR_RADIUS = 3;
var SPECIAL_INDICATOR_OFFSET_BOTTOM = (_SPECIAL_INDICATOR_OF = {}, (0,defineProperty/* default */.Z)(_SPECIAL_INDICATOR_OF, HD, 2), (0,defineProperty/* default */.Z)(_SPECIAL_INDICATOR_OF, FULL_HD, 4), _SPECIAL_INDICATOR_OF);
var SPECIAL_INDICATOR_SIZE = (_SPECIAL_INDICATOR_SI = {}, (0,defineProperty/* default */.Z)(_SPECIAL_INDICATOR_SI, HD, 4), (0,defineProperty/* default */.Z)(_SPECIAL_INDICATOR_SI, FULL_HD, 6), _SPECIAL_INDICATOR_SI);
var buttonColor = {
  backgroundFocused: makeThemeColor(PRIMARY),
  innerElementUnFocused: makeThemeColor(PRIMARY),
  innerElementFocused: makeThemeColor(TERTIARY),
  specialIndicator: makeThemeColor(CLOUD_NORMAL),
  backgroundUnFocused: makeThemeColor(PRIMARY, BACKGROUND_UNFOCUSED_OPACITY),
  iconBackgroundUnFocused: makeThemeColor(PRIMARY, ICON_BACKGROUND_UNFOCUSED_OPACITY)
};
var keyItem_style_getBasicIconViewBox = memoize_default()(function (screenSize) {
  return {
    h: PICTO_DIMENSIONS[screenSize].height,
    w: PICTO_DIMENSIONS[screenSize].width
  };
});
var keyItem_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : keyItem_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  return {
    Button: {
      rect: true,
      w: KEY_WIDTH[screenSize],
      h: KEY_HEIGHT[screenSize],
      color: buttonColor.backgroundUnFocused[colorMode],
      shader: {
        radius: keyItem_style_BORDER_RADIUS
      },
      SpecialIndicator: {
        rect: true,
        w: SPECIAL_INDICATOR_SIZE[screenSize],
        h: SPECIAL_INDICATOR_SIZE[screenSize],
        x: KEY_WIDTH[screenSize] / 2 - SPECIAL_INDICATOR_SIZE[screenSize] / 2,
        y: KEY_HEIGHT[screenSize] - SPECIAL_INDICATOR_SIZE[screenSize] * 2,
        color: buttonColor.specialIndicator[colorMode],
        shader: {
          radius: SPECIAL_INDICATOR_RADIUS
        }
      }
    }
  };
};
var getStateLetterStyles = memoize_default()(function (_ref) {
  var screenSize = _ref.screenSize,
    colorMode = _ref.colorMode;
  return {
    unfocused: keyItem_style_objectSpread(keyItem_style_objectSpread({}, src_getFont(constants_FONT[FOCUSED_FONT], screenSize)), {}, {
      lineHeight: KEY_HEIGHT[screenSize],
      textColor: buttonColor.innerElementUnFocused[colorMode]
    }),
    focused: keyItem_style_objectSpread(keyItem_style_objectSpread({}, src_getFont(constants_FONT[UNFOCUSED_FONT], screenSize)), {}, {
      lineHeight: KEY_HEIGHT[screenSize],
      textColor: buttonColor.innerElementFocused[colorMode]
    })
  };
}, cacheResolver);
var getBasicLetter = function getBasicLetter(_ref2) {
  var symbol = _ref2.symbol,
    screenSize = _ref2.screenSize,
    colorMode = _ref2.colorMode;
  return {
    Letter: {
      w: KEY_WIDTH[screenSize],
      h: KEY_HEIGHT[screenSize],
      text: keyItem_style_objectSpread(keyItem_style_objectSpread({}, src_getFont(constants_FONT.KINSHASA_1, screenSize)), {}, {
        lineHeight: KEY_HEIGHT[screenSize],
        textColor: buttonColor.innerElementUnFocused[colorMode],
        textAlign: 'center',
        text: symbol,
        verticalAlign: 'middle'
      })
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/keyboard/keyItem/keyItem.component.js





function keyItem_component_createSuper(t) { var r = keyItem_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function keyItem_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (keyItem_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }



var KeyboardItem = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(KeyboardItem, _Lightning$Component);
  var _super = keyItem_component_createSuper(KeyboardItem);
  function KeyboardItem() {
    (0,classCallCheck/* default */.Z)(this, KeyboardItem);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(KeyboardItem, [{
    key: "_setup",
    value: function _setup() {
      this._style = keyItem_style_defaultContext;
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this._setState('Focused');
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this._setState('Unfocused');
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Button: {
          shader: {
            type: src_Lightning.shaders.RoundedRectangle
          },
          SpecialIndicator: {
            visible: false,
            shader: {
              type: src_Lightning.shaders.RoundedRectangle
            }
          }
        }
      }, keyItem_style_getInitialStyle());
    }
  }, {
    key: "_states",
    value: function _states() {
      return [function (_this) {
        (0,inherits/* default */.Z)(Unfocused, _this);
        var _super2 = keyItem_component_createSuper(Unfocused);
        function Unfocused() {
          (0,classCallCheck/* default */.Z)(this, Unfocused);
          return _super2.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(Unfocused, [{
          key: "$enter",
          value: function $enter() {
            if (this.tag('Icon')) {
              this.tag('Button').color = buttonColor.iconBackgroundUnFocused[this._style.colorMode];
              this.tag('Icon').color = buttonColor.innerElementUnFocused[this._style.colorMode];
              return;
            }
            this.tag('Button').color = buttonColor.backgroundUnFocused[this._style.colorMode];
            this.tag('Letter').text = getStateLetterStyles(this._style).unfocused;
          }
        }]);
        return Unfocused;
      }(this), function (_this2) {
        (0,inherits/* default */.Z)(Focused, _this2);
        var _super3 = keyItem_component_createSuper(Focused);
        function Focused() {
          (0,classCallCheck/* default */.Z)(this, Focused);
          return _super3.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(Focused, [{
          key: "$enter",
          value: function $enter() {
            this.tag('Button').color = buttonColor.backgroundFocused[this._style.colorMode];
            if (this.tag('Letter')) this.tag('Letter').text = getStateLetterStyles(this._style).focused;
            if (this.tag('Icon')) this.tag('Icon').color = buttonColor.innerElementFocused[this._style.colorMode];
          }
        }]);
        return Focused;
      }(this)];
    }
  }]);
  return KeyboardItem;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/tornado/keyboard/customer/rtlde/keyboard.constants.js

var _SPECIAL_KEYS;
var LETTER_SELECTED_SIGNAL = 'letterSelected';
var LETTER_REMOVED_SIGNAL = 'letterRemoved';
var keyboard_constants_ITEMS_PER_ROW = 10;
var keyboard_constants_SPACE = '_';
var keyboard_constants_BACKSPACE = '<';
var BUTTON_LENGTH = 2;
var SPECIAL_KEYS = (_SPECIAL_KEYS = {}, (0,defineProperty/* default */.Z)(_SPECIAL_KEYS, keyboard_constants_SPACE, {
  icon: {
    name: 'Space',
    type: 'icon'
  },
  keyLength: BUTTON_LENGTH
}), (0,defineProperty/* default */.Z)(_SPECIAL_KEYS, keyboard_constants_BACKSPACE, {
  icon: {
    name: 'BackSpace',
    type: 'icon'
  },
  keyLength: BUTTON_LENGTH
}), _SPECIAL_KEYS);
var DEFAULT_KEYBOARD = [['a', 'ä'], 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', ['o', 'ö'], 'p', 'q', 'r', ['s', 'ß'], 't', ['u', 'ü'], 'v', 'w', 'x', 'y', 'z', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0', keyboard_constants_SPACE, keyboard_constants_BACKSPACE];
;// CONCATENATED MODULE: ./src/modules/tornado/keyboard/keyboard.constants.js

;// CONCATENATED MODULE: ./src/modules/tornado/keyboard/subKeyboard/subKeyboard.style.js



var subKeyboard_style_defaultContext = makeDefaultStylingContext();
var KEY_PADDING = 4;
var subKeyboard_style_BORDER_RADIUS = 4;
var subKeyboard_style_BORDER_WIDTH = 3;
var MAX_ITEMS_PER_ROW = 4;
var subKeyboard_style_colors = {
  scalableContent: makeThemeColor(TERTIARY),
  background: makeThemeColor(PRIMARY, 0.1),
  border: makeThemeColor(PRIMARY)
};
var subKeyboard_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : subKeyboard_style_defaultContext;
  var colorMode = context.colorMode;
  return {
    visible: false,
    ScalableContent: {
      rect: true,
      w: 0,
      h: 0,
      color: subKeyboard_style_colors.scalableContent[colorMode],
      Background: {
        rect: true,
        w: identity,
        h: identity,
        color: subKeyboard_style_colors.background[colorMode],
        shader: {
          strokeColor: subKeyboard_style_colors.border[colorMode],
          stroke: subKeyboard_style_BORDER_WIDTH,
          radius: subKeyboard_style_BORDER_RADIUS
        }
      },
      Keys: {
        x: KEY_PADDING,
        y: KEY_PADDING
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/keyboard/subKeyboard/subKeyboard.constants.js
var CLOSE_SUB_KEYBOARD_SIGNAL = 'closeSubKeyboard';
;// CONCATENATED MODULE: ./src/modules/tornado/keyboard/subKeyboard/subKeyboard.component.js







function subKeyboard_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function subKeyboard_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? subKeyboard_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : subKeyboard_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function subKeyboard_component_createSuper(t) { var r = subKeyboard_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function subKeyboard_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (subKeyboard_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }







var SubKeyboard = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(SubKeyboard, _Lightning$Component);
  var _super = subKeyboard_component_createSuper(SubKeyboard);
  function SubKeyboard() {
    (0,classCallCheck/* default */.Z)(this, SubKeyboard);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(SubKeyboard, [{
    key: "_init",
    value: function _init() {
      this._index = 0;
      this._items = [];
      this._style = subKeyboard_style_defaultContext;
    }
  }, {
    key: "initialize",
    set: function set(data) {
      var _this = this;
      var items = data.items,
        x = data.x,
        y = data.y;
      this._items = items;
      var numberOfButtons = 0;
      var width;
      var height;
      if (items.length >= MAX_ITEMS_PER_ROW) {
        width = (KEY_WIDTH[this._style.screenSize] + KEYS_GAP) * MAX_ITEMS_PER_ROW;
        height = (KEY_HEIGHT[this._style.screenSize] + KEYS_GAP) * Math.floor(items.length / MAX_ITEMS_PER_ROW);
      } else {
        width = (KEY_WIDTH[this._style.screenSize] + KEYS_GAP) * items.length;
        height = KEY_HEIGHT[this._style.screenSize] + KEYS_GAP;
      }
      this.tag('Keys').children = items.map(function (symbol, index) {
        numberOfButtons += 1;
        return subKeyboard_component_objectSpread({
          type: KeyboardItem,
          x: (KEY_WIDTH[_this._style.screenSize] + KEYS_GAP) * ((numberOfButtons - 1) % MAX_ITEMS_PER_ROW),
          y: (KEY_HEIGHT[_this._style.screenSize] + KEYS_GAP) * Math.floor((numberOfButtons - 1) / MAX_ITEMS_PER_ROW),
          Button: {
            SpecialIndicator: {
              visible: index === 0
            }
          }
        }, getBasicLetter(subKeyboard_component_objectSpread({
          symbol: symbol
        }, _this._style)));
      });
      this.patch({
        x: x,
        y: y,
        visible: true,
        ScalableContent: {
          w: width + KEY_PADDING * 2,
          h: height + KEY_PADDING * 2
        }
      });
    }
  }, {
    key: "_reset",
    value: function _reset() {
      this._index = 0;
      this._items = [];
      this.patch({
        visible: false,
        x: 0,
        y: 0,
        ScalableContent: {
          w: 0,
          h: 0
        }
      });
      this.tag('Keys').children = undefined;
    }
  }, {
    key: "_close",
    value: function _close() {
      this.signal(CLOSE_SUB_KEYBOARD_SIGNAL);
      this._reset();
    }
  }, {
    key: "_handleUp",
    value: function _handleUp() {
      var isNotFirstRow = this._index > MAX_ITEMS_PER_ROW - 1;
      if (isNotFirstRow) {
        this._setIndex(this._index - MAX_ITEMS_PER_ROW);
        return true;
      }
      this._close();
      return false;
    }
  }, {
    key: "_handleDown",
    value: function _handleDown() {
      var isNotLastRow = this._index + MAX_ITEMS_PER_ROW < this._items.length;
      if (isNotLastRow) {
        this._setIndex(this._index + MAX_ITEMS_PER_ROW);
        return true;
      }
      this._close();
      return false;
    }
  }, {
    key: "_handleLeft",
    value: function _handleLeft() {
      var itemsCount = this._items.length;
      var isNotBeginningOfRow = itemsCount > MAX_ITEMS_PER_ROW ? this._index % MAX_ITEMS_PER_ROW !== 0 : this._index > 0;
      if (isNotBeginningOfRow) {
        this._setIndex(this._index - 1);
        return true;
      }
      this._close();
      return false;
    }
  }, {
    key: "_handleRight",
    value: function _handleRight() {
      var itemsCount = this._items.length;
      var isNotEndOfRow = itemsCount > MAX_ITEMS_PER_ROW ? (this._index + 1) % MAX_ITEMS_PER_ROW !== 0 : this._index + 1 < itemsCount;
      if (isNotEndOfRow) {
        this._setIndex(this._index + 1);
        return true;
      }
      this._close();
      return false;
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      this.signal(LETTER_SELECTED_SIGNAL, this._items[this._index]);
    }
  }, {
    key: "_handleBack",
    value: function _handleBack() {
      this._close();
    }
  }, {
    key: "_setIndex",
    value: function _setIndex() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._index;
      this._index = index;
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this.tag('Keys').children[this._index];
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        ScalableContent: {
          Background: {
            shader: {
              type: src_Lightning.shaders.RoundedRectangle
            }
          },
          Keys: {}
        }
      }, subKeyboard_style_getInitialStyle());
    }
  }]);
  return SubKeyboard;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/tornado/keyboard/keyboard.component.js










function keyboard_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function keyboard_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? keyboard_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : keyboard_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function keyboard_component_createSuper(t) { var r = keyboard_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function keyboard_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (keyboard_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }









var keyboard_component_Keyboard = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Keyboard, _Lightning$Component);
  var _super = keyboard_component_createSuper(Keyboard);
  function Keyboard() {
    (0,classCallCheck/* default */.Z)(this, Keyboard);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Keyboard, [{
    key: "_init",
    value: function _init() {
      this._index = 0;
      this._style = keyboard_style_defaultContext;
      this._keyBoardLayout = [0];
      this.numberOfSpecialButtons = 0;
      this.initialize = DEFAULT_KEYBOARD;
    }
  }, {
    key: "initialize",
    set: function set(letterRow) {
      var _this = this;
      var numberOfButtons = 0;
      this.tag('Keys').children = letterRow.map(function (symbol, index) {
        if (Object.keys(SPECIAL_KEYS).includes(symbol)) {
          var _SPECIAL_KEYS$symbol = SPECIAL_KEYS[symbol],
            keyLength = _SPECIAL_KEYS$symbol.keyLength,
            icon = _SPECIAL_KEYS$symbol.icon;
          for (var i = 0; i < keyLength; i += 1) {
            _this._keyBoardLayout[numberOfButtons] = index;
            numberOfButtons += 1;
          }
          _this.numberOfSpecialButtons += keyLength - 1;
          var width = KEY_WIDTH[_this._style.screenSize] + KEYS_GAP;
          var height = KEY_HEIGHT[_this._style.screenSize] + KEYS_GAP;
          var iconViewBox = keyItem_style_getBasicIconViewBox(_this._style.screenSize);
          return {
            type: KeyboardItem,
            x: Math.round(width * ((numberOfButtons - keyLength) % keyboard_constants_ITEMS_PER_ROW)),
            y: Math.round(height * Math.floor((numberOfButtons - keyLength) / keyboard_constants_ITEMS_PER_ROW)),
            Button: {
              color: buttonColor.iconBackgroundUnFocused[_this._style.colorMode],
              w: keyLength * KEY_WIDTH[_this._style.screenSize] + KEYS_GAP
            },
            Icon: {
              type: Icon,
              x: Math.round((keyLength * width - iconViewBox.w) / 2),
              y: Math.round((height - iconViewBox.h) / 2),
              iconData: {
                picto: icon,
                viewBox: iconViewBox
              }
            }
          };
        }
        _this._keyBoardLayout[numberOfButtons] = index;
        numberOfButtons += 1;
        var isMultiple = Array.isArray(symbol);
        var viewSymbol = isMultiple ? symbol[0] : symbol;
        return keyboard_component_objectSpread({
          type: KeyboardItem,
          x: (KEY_WIDTH[_this._style.screenSize] + KEYS_GAP) * ((numberOfButtons - 1) % keyboard_constants_ITEMS_PER_ROW),
          y: (KEY_HEIGHT[_this._style.screenSize] + KEYS_GAP) * Math.floor((numberOfButtons - 1) / keyboard_constants_ITEMS_PER_ROW),
          Button: {
            SpecialIndicator: {
              visible: isMultiple
            }
          }
        }, getBasicLetter(keyboard_component_objectSpread({
          symbol: viewSymbol
        }, _this._style)));
      });
      this._setIndex();
    }
  }, {
    key: "_handleCloseSubKeyboard",
    value: function _handleCloseSubKeyboard() {
      this._focused = this.tag('Keys').children[this._index];
    }
  }, {
    key: "_handleUp",
    value: function _handleUp() {
      var isBelowFirstRow = this._index + this.numberOfSpecialButtons >= keyboard_constants_ITEMS_PER_ROW;
      if (isBelowFirstRow) {
        this._setIndex(this._keyBoardLayout[this._keyBoardLayout.indexOf(this._index) - keyboard_constants_ITEMS_PER_ROW]);
      }
      return false;
    }
  }, {
    key: "_handleDown",
    value: function _handleDown() {
      var lastRowStartIndex = Math.ceil(this._keyBoardLayout.length / keyboard_constants_ITEMS_PER_ROW - 1) * keyboard_constants_ITEMS_PER_ROW;
      var hasNoItemBellow = this._index + keyboard_constants_ITEMS_PER_ROW >= this._keyBoardLayout.length;
      var isLastRow = this._keyBoardLayout.indexOf(this._index) >= lastRowStartIndex;
      if (isLastRow || hasNoItemBellow) return false;
      this._setIndex(this._keyBoardLayout[this._keyBoardLayout.indexOf(this._index) + keyboard_constants_ITEMS_PER_ROW]);
      return true;
    }
  }, {
    key: "_handleLeft",
    value: function _handleLeft() {
      var isBeginningOfRow = this._keyBoardLayout.indexOf(this._index) % keyboard_constants_ITEMS_PER_ROW === 0;
      if (isBeginningOfRow) {
        return false;
      }
      if (this._index > 0) {
        this._setIndex(this._index - 1);
        return true;
      }
      return false;
    }
  }, {
    key: "_handleRight",
    value: function _handleRight() {
      var isEndOfRow = this._keyBoardLayout.lastIndexOf(this._index) % keyboard_constants_ITEMS_PER_ROW < keyboard_constants_ITEMS_PER_ROW - 1;
      if (isEndOfRow) {
        this._setIndex(this._index + 1);
        return true;
      }
      return false;
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      var selectedItem = DEFAULT_KEYBOARD[this._index];
      if (!Array.isArray(selectedItem)) {
        this.signal(LETTER_SELECTED_SIGNAL, selectedItem);
        return;
      }
      var _this$_focused = this._focused,
        x = _this$_focused.x,
        y = _this$_focused.y;
      this.tag('SubKeys').initialize = {
        x: x,
        y: y,
        items: selectedItem
      };
      this._focused = this.tag('SubKeys');
    }
  }, {
    key: "_setIndex",
    value: function _setIndex() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._index;
      this._index = index;
      this._focused = this.tag('Keys').children[this._index];
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this._focused;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Background: {},
        Keys: {},
        SubKeys: {
          type: SubKeyboard,
          signals: (0,defineProperty/* default */.Z)({}, CLOSE_SUB_KEYBOARD_SIGNAL, '_handleCloseSubKeyboard'),
          passSignals: (0,defineProperty/* default */.Z)({}, LETTER_SELECTED_SIGNAL, true)
        }
      }, keyboard_style_getInitialStyle());
    }
  }]);
  return Keyboard;
}(src_Lightning.Component);

;// CONCATENATED MODULE: ./src/modules/search/searchHistory/searchHistory.style.js

var _CONTAINER_WIDTH, _CONTAINER_HEIGHT, _HISTORY_POSITION_X, _SEARCHED_ITEM_POSITI, _HISTORY_POSITION_Y, _vertical;
function searchHistory_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function searchHistory_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? searchHistory_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : searchHistory_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



var searchHistory_style_defaultContext = makeDefaultStylingContext();
var CONTAINER_WIDTH = (_CONTAINER_WIDTH = {}, (0,defineProperty/* default */.Z)(_CONTAINER_WIDTH, HD, 483), (0,defineProperty/* default */.Z)(_CONTAINER_WIDTH, FULL_HD, 732), _CONTAINER_WIDTH);
var CONTAINER_HEIGHT = (_CONTAINER_HEIGHT = {}, (0,defineProperty/* default */.Z)(_CONTAINER_HEIGHT, HD, 219), (0,defineProperty/* default */.Z)(_CONTAINER_HEIGHT, FULL_HD, 299), _CONTAINER_HEIGHT);
var HISTORY_POSITION_X = (_HISTORY_POSITION_X = {}, (0,defineProperty/* default */.Z)(_HISTORY_POSITION_X, HD, 738), (0,defineProperty/* default */.Z)(_HISTORY_POSITION_X, FULL_HD, 1090), _HISTORY_POSITION_X);
var SEARCHED_ITEM_POSITION_Y = (_SEARCHED_ITEM_POSITI = {}, (0,defineProperty/* default */.Z)(_SEARCHED_ITEM_POSITI, HD, 44), (0,defineProperty/* default */.Z)(_SEARCHED_ITEM_POSITI, FULL_HD, 72), _SEARCHED_ITEM_POSITI);
var HISTORY_POSITION_Y = (_HISTORY_POSITION_Y = {}, (0,defineProperty/* default */.Z)(_HISTORY_POSITION_Y, HD, 64), (0,defineProperty/* default */.Z)(_HISTORY_POSITION_Y, FULL_HD, 133), _HISTORY_POSITION_Y);
var EMPTY_HISTORY_LABEL_POSITION = {
  vertical: (_vertical = {}, (0,defineProperty/* default */.Z)(_vertical, HD, 96), (0,defineProperty/* default */.Z)(_vertical, FULL_HD, 136), _vertical)
};
var TITLE_FONT = constants_FONT.KINSHASA_3;
var searchHistory_style_TITLE_FONT_TYPE = FONT_TYPE.MAIN;
var EMPTY_HISTORY_FONT = constants_FONT.KINSHASA_3;
var EMPTY_HISTORY_FONT_TYPE = FONT_TYPE.MAIN;
var searchHistory_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : searchHistory_style_defaultContext,
    screenSize = _ref.screenSize;
  return {
    x: HISTORY_POSITION_X[screenSize],
    y: HISTORY_POSITION_Y[screenSize],
    w: CONTAINER_WIDTH[screenSize],
    h: CONTAINER_HEIGHT[screenSize],
    Title: {
      w: CONTAINER_WIDTH[screenSize],
      text: searchHistory_style_objectSpread(searchHistory_style_objectSpread({}, src_getFont(TITLE_FONT, screenSize, searchHistory_style_TITLE_FONT_TYPE)), {}, {
        maxLines: 1,
        verticalAlign: 'middle',
        textAlign: 'center'
      })
    },
    EmptyHistoryLabel: {
      w: CONTAINER_WIDTH[screenSize],
      y: EMPTY_HISTORY_LABEL_POSITION.vertical[screenSize],
      text: searchHistory_style_objectSpread(searchHistory_style_objectSpread({}, src_getFont(EMPTY_HISTORY_FONT, screenSize, EMPTY_HISTORY_FONT_TYPE)), {}, {
        maxLines: 1,
        verticalAlign: 'middle',
        textAlign: 'center'
      })
    },
    Items: {
      y: SEARCHED_ITEM_POSITION_Y[screenSize],
      flex: {
        direction: 'column',
        justifyContent: 'center'
      }
    },
    cacheResolver: cacheResolver
  };
};
;// CONCATENATED MODULE: ./src/modules/search/searchField/customer/default/searchField.constants.js

var searchField_constants_HEIGHT;

var default_searchField_constants_HEIGHT = (searchField_constants_HEIGHT = {}, (0,defineProperty/* default */.Z)(searchField_constants_HEIGHT, HD, 40), (0,defineProperty/* default */.Z)(searchField_constants_HEIGHT, FULL_HD, 56), searchField_constants_HEIGHT);
var BACKGROUND_RADIUS = 0;
var BAR_OFFSET_LEFT = 8;
var BAR_OPACITY = 0.3;
var TEXT_FONT = 'KINSHASA_2';
;// CONCATENATED MODULE: ./src/modules/search/searchField/searchField.style.js

var searchField_style_WIDTH, _OFFSET;
function searchField_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function searchField_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? searchField_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : searchField_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }








var searchField_style_defaultContext = makeDefaultStylingContext();
var searchField_searchField_style_WIDTH = (searchField_style_WIDTH = {}, (0,defineProperty/* default */.Z)(searchField_style_WIDTH, HD, 489), (0,defineProperty/* default */.Z)(searchField_style_WIDTH, FULL_HD, 729), searchField_style_WIDTH);
var OFFSET = (_OFFSET = {}, (0,defineProperty/* default */.Z)(_OFFSET, HD, 8), (0,defineProperty/* default */.Z)(_OFFSET, FULL_HD, 16), _OFFSET);
var BAR_PADDING_LEFT = BAR_OFFSET_LEFT;
var searchField_style_colors = {
  bar: makeThemeColor(PRIMARY, BAR_OPACITY),
  background: makeThemeColor(TERTIARY),
  text: makeThemeColor(PRIMARY)
};
var getInnerWidth = memoize_default()(function (width, padding) {
  return width - padding * 2;
});
var searchField_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : searchField_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  return {
    x: KEYBOARD_OFFSET_X[screenSize],
    y: KEYBOARD_OFFSET_Y[screenSize] - default_searchField_constants_HEIGHT[screenSize] - OFFSET[screenSize],
    h: default_searchField_constants_HEIGHT[screenSize],
    w: searchField_searchField_style_WIDTH[screenSize],
    clipping: true,
    Background: {
      rect: true,
      h: identity,
      w: identity,
      color: searchField_style_colors.background[colorMode],
      shader: {
        radius: BACKGROUND_RADIUS
      }
    },
    Bar: {
      rect: true,
      h: identity,
      w: identity,
      color: searchField_style_colors.bar[colorMode],
      shader: {
        radius: BACKGROUND_RADIUS
      }
    },
    Label: {
      x: BAR_PADDING_LEFT,
      mountY: 0.5,
      y: middle,
      text: searchField_style_objectSpread(searchField_style_objectSpread({}, src_getFont(constants_FONT[TEXT_FONT], screenSize)), {}, {
        wordWrap: false,
        textColor: searchField_style_colors.text[colorMode],
        verticalAlign: 'middle'
      })
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/search/search.style.js

var _OVERLAY_HEIGHT;







var search_style_defaultContext = makeDefaultStylingContext();
var search_style_BACKGROUND_COLOR = makeThemeColor(TERTIARY);
var getBlockOffset = function getBlockOffset(screenSize) {
  return KEYBOARD_OFFSET_Y[screenSize] + KEYBOARD_HEIGHT[screenSize];
};
var OVERLAY_HEIGHT = (_OVERLAY_HEIGHT = {}, (0,defineProperty/* default */.Z)(_OVERLAY_HEIGHT, HD, 80), (0,defineProperty/* default */.Z)(_OVERLAY_HEIGHT, FULL_HD, 80), _OVERLAY_HEIGHT);
var search_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : search_style_defaultContext,
    screenSize = _ref.screenSize,
    colorMode = _ref.colorMode;
  var overlayOffset = KEYBOARD_OFFSET_Y[screenSize] - OFFSET[screenSize];
  return {
    Background: {
      w: SCREEN_WIDTH[screenSize],
      h: sizes_SCREEN_HEIGHT[screenSize]
    },
    SearchField: {
      zIndex: 4
    },
    Keyboard: {
      zIndex: 3
    },
    SearchedItems: {
      zIndex: 3
    },
    Strip: {
      zIndex: 2,
      w: SCREEN_WIDTH[screenSize],
      h: overlayOffset,
      color: search_style_BACKGROUND_COLOR[colorMode]
    },
    Overlay: {
      zIndex: 2,
      w: SCREEN_WIDTH[screenSize],
      h: OVERLAY_HEIGHT[screenSize],
      y: overlayOffset,
      colorTop: search_style_BACKGROUND_COLOR[colorMode],
      colorBottom: colors_TRANSPARENT
    },
    SearchResultBlock: {
      y: getBlockOffset(screenSize)
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/search/searchField/searchField.constants.js
var MIN_TEXT_LENGTH_TO_SEARCH = 3;
var MAX_TEXT_LENGTH_TO_SEARCH = 128;
var MAX_TEXT_LENGTH_TO_SHOW = 80;
var START_SEARCH = 'handleStartSearch';
;// CONCATENATED MODULE: ./src/modules/search/searchField/searchField.component.js






function searchField_component_createSuper(t) { var r = searchField_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function searchField_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (searchField_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }





var SearchField = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(SearchField, _Lightning$Component);
  var _super = searchField_component_createSuper(SearchField);
  function SearchField() {
    (0,classCallCheck/* default */.Z)(this, SearchField);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(SearchField, [{
    key: "_init",
    value: function _init() {
      this._style = searchField_style_defaultContext;
    }
  }, {
    key: "_build",
    value: function _build() {
      var _this = this;
      var label = this.tag('Label');
      label.on('txLoaded', function () {
        var labelInnerWidth = getInnerWidth(searchField_searchField_style_WIDTH[_this._style.screenSize], BAR_PADDING_LEFT);
        var textWidth = label.finalW;
        if (textWidth > labelInnerWidth) {
          var diff = (textWidth - labelInnerWidth) * -1;
          label.x = diff;
        } else {
          label.x = BAR_PADDING_LEFT;
        }
      });
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this.tag('Label').removeAllListeners('txLoaded');
    }
  }, {
    key: "searchQuery",
    set: function set(value) {
      if (!value) {
        this.tag('Label').text.text = t('search.placeholder');
        return;
      }
      this.tag('Label').text.text = value.length > MAX_TEXT_LENGTH_TO_SHOW ? value.slice(-MAX_TEXT_LENGTH_TO_SHOW) : value;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Background: {
          shader: {
            type: src_Lightning.shaders.RoundedRectangle
          }
        },
        Bar: {
          shader: {
            type: src_Lightning.shaders.RoundedRectangle
          }
        },
        Label: {}
      }, searchField_style_getInitialStyle());
    }
  }]);
  return SearchField;
}(src_Lightning.Component);

;// CONCATENATED MODULE: ./src/logic/search/search.selectors.js

var getSearchResults = function getSearchResults(state) {
  return get_default()(state, 'search');
};
var search_selectors_getSearchedItems = function getSearchedItems(state) {
  return get_default()(state, 'search.searchedItems');
};
var searchFromHistory = function searchFromHistory(state) {
  return get_default()(state, 'search.searchInput');
};
;// CONCATENATED MODULE: ./src/modules/search/search.connect.js


var search_connect_mapControllers = function mapControllers(instance) {
  return {
    searchResult: {
      selector: getSearchResults,
      callback: function callback(value) {
        instance.searchResult = value;
      },
      shouldBeInvokedOnConnect: true
    },
    getSearchedItems: {
      selector: search_selectors_getSearchedItems,
      callback: function callback(value) {
        instance.searchedItems = value;
      }
    },
    searchFromHistory: {
      selector: searchFromHistory,
      callback: function callback(value) {
        instance.searchFromHistory = value;
      }
    }
  };
};
/* harmony default export */ const search_connect = (lightningjs_redux.control(search_connect_mapControllers));
;// CONCATENATED MODULE: ./src/modules/search/blocks/blocks.style.js

function blocks_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function blocks_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? blocks_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : blocks_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





var blocks_style_defaultContext = makeDefaultStylingContext();
var blocks_style_getBlockOffset = function getBlockOffset(screenSize) {
  return KEYBOARD_HEIGHT[screenSize];
};
var blocks_style_getContentPadding = function getContentPadding() {
  var hasSideNav = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var screenSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  return hasSideNav ? SIDEBAR_WIDTH[screenSize || blocks_style_defaultContext.screenSize] : 0;
};
var blocks_style_WIDTH = blocks_style_objectSpread({}, SCREEN_WIDTH);
var blocks_style_HEIGHT = blocks_style_objectSpread({}, sizes_SCREEN_HEIGHT);
var blocks_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : blocks_style_defaultContext;
  var screenSize = context.screenSize;
  return {
    w: blocks_style_WIDTH[screenSize],
    x: PADDING.LEFT[screenSize],
    Blocks: {
      w: blocks_style_WIDTH[screenSize]
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/search/blocks/blocks.component.js







function blocks_component_createSuper(t) { var r = blocks_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function blocks_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (blocks_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }






var SearchResultBlock = function (_AbstractLayout) {
  (0,inherits/* default */.Z)(SearchResultBlock, _AbstractLayout);
  var _super = blocks_component_createSuper(SearchResultBlock);
  function SearchResultBlock() {
    (0,classCallCheck/* default */.Z)(this, SearchResultBlock);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(SearchResultBlock, [{
    key: "hasResults",
    get: function get() {
      return this.tag('Blocks').children.length !== 0;
    }
  }, {
    key: "_handleSelected",
    value: function _handleSelected(item) {
      lightningjs_redux.dispatch(saveSearchedItem(item));
      lightningjs_redux.dispatch(createItemAction({
        item: item
      }));
    }
  }, {
    key: "_setIndex",
    value: function _setIndex() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._index;
      var shouldAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var position = this._positions[index];
      if (!Number.isFinite(position)) {
        return;
      }
      var offset = index === 0 ? 0 : -blocks_style_getBlockOffset(this._style.screenSize);
      var targetOffset = position + offset;
      this._index = index;
      if (shouldAnimate) {
        this.tag('Blocks').setSmooth('y', targetOffset);
      } else {
        this.tag('Blocks').y = targetOffset;
      }
    }
  }, {
    key: "_shouldRefreshPlacement",
    value: function _shouldRefreshPlacement(newBlocks) {
      return couldReuseCurrentViews(this._data ? this._data.blocks : [], newBlocks, true);
    }
  }]);
  return SearchResultBlock;
}(AbstractLayout);

;// CONCATENATED MODULE: ./src/modules/search/searchHistory/searchedItem.style.js

var _ITEM_WIDTH, _ITEM_HEIGHT, _ITEM_MARGIN_BOTTOM, _ICON_MARGIN_TOP, _ICON_MARGIN_BOTTOM, _ICON_MARGIN_LEFT, _ICON_MARGIN_RIGHT, _ICON_DIMENSION;
function searchedItem_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function searchedItem_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? searchedItem_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : searchedItem_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }




var searchedItem_style_defaultContext = makeDefaultStylingContext();
var ITEM_WIDTH = (_ITEM_WIDTH = {}, (0,defineProperty/* default */.Z)(_ITEM_WIDTH, HD, 487), (0,defineProperty/* default */.Z)(_ITEM_WIDTH, FULL_HD, 732), _ITEM_WIDTH);
var ITEM_HEIGHT = (_ITEM_HEIGHT = {}, (0,defineProperty/* default */.Z)(_ITEM_HEIGHT, HD, 40), (0,defineProperty/* default */.Z)(_ITEM_HEIGHT, FULL_HD, 56), _ITEM_HEIGHT);
var ITEM_MARGIN_BOTTOM = (_ITEM_MARGIN_BOTTOM = {}, (0,defineProperty/* default */.Z)(_ITEM_MARGIN_BOTTOM, HD, 4), (0,defineProperty/* default */.Z)(_ITEM_MARGIN_BOTTOM, FULL_HD, 1), _ITEM_MARGIN_BOTTOM);
var ICON_MARGIN_TOP = (_ICON_MARGIN_TOP = {}, (0,defineProperty/* default */.Z)(_ICON_MARGIN_TOP, HD, 8), (0,defineProperty/* default */.Z)(_ICON_MARGIN_TOP, FULL_HD, 16), _ICON_MARGIN_TOP);
var ICON_MARGIN_BOTTOM = (_ICON_MARGIN_BOTTOM = {}, (0,defineProperty/* default */.Z)(_ICON_MARGIN_BOTTOM, HD, 8), (0,defineProperty/* default */.Z)(_ICON_MARGIN_BOTTOM, FULL_HD, 16), _ICON_MARGIN_BOTTOM);
var ICON_MARGIN_LEFT = (_ICON_MARGIN_LEFT = {}, (0,defineProperty/* default */.Z)(_ICON_MARGIN_LEFT, HD, 62), (0,defineProperty/* default */.Z)(_ICON_MARGIN_LEFT, FULL_HD, 55), _ICON_MARGIN_LEFT);
var ICON_MARGIN_RIGHT = (_ICON_MARGIN_RIGHT = {}, (0,defineProperty/* default */.Z)(_ICON_MARGIN_RIGHT, HD, 24), (0,defineProperty/* default */.Z)(_ICON_MARGIN_RIGHT, FULL_HD, 24), _ICON_MARGIN_RIGHT);
var ICON_DIMENSION = (_ICON_DIMENSION = {}, (0,defineProperty/* default */.Z)(_ICON_DIMENSION, HD, {
  w: 24,
  h: 24
}), (0,defineProperty/* default */.Z)(_ICON_DIMENSION, FULL_HD, {
  w: 24,
  h: 24
}), _ICON_DIMENSION);
var searchedItem_style_colors = {
  background: makeThemeColor(CLOUD_NORMAL)[searchedItem_style_defaultContext.colorMode]
};
var searchedItem_style_TITLE_FONT = constants_FONT.BERLIN_1;
var searchedItem_style_TITLE_FONT_TYPE = FONT_TYPE.MAIN;
var BACKGROUND_FOCUSED_COLOR = makeThemeColor(PRIMARY);
var BACKGROUND_UNFOCUSED_COLOR = makeThemeColor(CLOUD_NORMAL);
var searchedItem_style_TEXT_UNFOCUSED_COLOR = makeThemeColor(PRIMARY);
var searchedItem_style_TEXT_FOCUSED_COLOR = makeThemeColor(TERTIARY);
var HISTORY_ICON = {
  name: 'History',
  type: 'icon'
};
var searchedItem_style_getUnFocusedStyle = function getUnFocusedStyle(_ref) {
  var colorMode = _ref.colorMode;
  return {
    color: BACKGROUND_UNFOCUSED_COLOR[colorMode],
    Icon: {
      color: searchedItem_style_TEXT_UNFOCUSED_COLOR[colorMode]
    },
    Title: {
      color: searchedItem_style_TEXT_UNFOCUSED_COLOR[colorMode]
    }
  };
};
var searchedItem_style_getFocusedStyle = function getFocusedStyle(_ref2) {
  var colorMode = _ref2.colorMode;
  return {
    color: BACKGROUND_FOCUSED_COLOR[colorMode],
    Icon: {
      color: searchedItem_style_TEXT_FOCUSED_COLOR[colorMode]
    },
    Title: {
      color: searchedItem_style_TEXT_FOCUSED_COLOR[colorMode]
    }
  };
};
var searchedItem_style_getInitialStyle = function getInitialStyle() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : searchedItem_style_defaultContext,
    screenSize = _ref3.screenSize,
    colorMode = _ref3.colorMode;
  return {
    rect: true,
    color: BACKGROUND_UNFOCUSED_COLOR[colorMode],
    w: ITEM_WIDTH[screenSize],
    h: ITEM_HEIGHT[screenSize],
    flex: {
      direction: 'row',
      alignItems: 'center'
    },
    flexItem: {
      marginBottom: ITEM_MARGIN_BOTTOM[screenSize]
    },
    Icon: {
      flexItem: {
        marginTop: ICON_MARGIN_TOP[screenSize],
        marginBottom: ICON_MARGIN_BOTTOM[screenSize],
        marginLeft: ICON_MARGIN_LEFT[screenSize],
        marginRight: ICON_MARGIN_RIGHT[screenSize]
      }
    },
    Title: {
      text: searchedItem_style_objectSpread(searchedItem_style_objectSpread({}, src_getFont(searchedItem_style_TITLE_FONT, screenSize, searchedItem_style_TITLE_FONT_TYPE)), {}, {
        maxLines: 1,
        verticalAlign: 'middle',
        textAlign: 'center',
        maxLinesSuffix: '...',
        wrap: true,
        wordWrapWidth: ITEM_WIDTH[screenSize] - ICON_MARGIN_LEFT[screenSize] - ICON_DIMENSION[screenSize].w - ICON_MARGIN_RIGHT[screenSize]
      })
    },
    cacheResolver: cacheResolver
  };
};
;// CONCATENATED MODULE: ./src/modules/search/searchHistory/searchedItem.component.js





function searchedItem_component_createSuper(t) { var r = searchedItem_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function searchedItem_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (searchedItem_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }




var SearchedItem = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(SearchedItem, _Lightning$Component);
  var _super = searchedItem_component_createSuper(SearchedItem);
  function SearchedItem() {
    (0,classCallCheck/* default */.Z)(this, SearchedItem);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(SearchedItem, [{
    key: "_construct",
    value: function _construct() {
      this._style = searchedItem_style_defaultContext;
    }
  }, {
    key: "data",
    set: function set(item) {
      this.patch({
        Icon: {
          iconData: {
            picto: HISTORY_ICON,
            viewBox: {
              w: ICON_DIMENSION[this._style.screenSize].w,
              h: ICON_DIMENSION[this._style.screenSize].h
            }
          }
        },
        Title: {
          text: {
            text: item
          }
        }
      });
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this.patch(searchedItem_style_getFocusedStyle(this._style));
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this.patch(searchedItem_style_getUnFocusedStyle(this._style));
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Icon: {
          type: Icon
        },
        Title: {}
      }, searchedItem_style_getInitialStyle());
    }
  }]);
  return SearchedItem;
}(src_Lightning.Component);

;// CONCATENATED MODULE: ./src/modules/search/searchHistory/searchHistory.component.js







function searchHistory_component_createSuper(t) { var r = searchHistory_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function searchHistory_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (searchHistory_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }






var SearchedItems = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(SearchedItems, _Lightning$Component);
  var _super = searchHistory_component_createSuper(SearchedItems);
  function SearchedItems() {
    (0,classCallCheck/* default */.Z)(this, SearchedItems);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(SearchedItems, [{
    key: "_construct",
    value: function _construct() {
      this._style = searchHistory_style_defaultContext;
      this._buttons = [];
      this._searchedItems = [];
      this._index = 0;
    }
  }, {
    key: "searchedItems",
    set: function set(searchedItems) {
      var isHistoryVisible = searchedItems && searchedItems.length > 0;
      this.patch({
        Title: {
          visible: isHistoryVisible,
          text: {
            text: t('search.history')
          }
        },
        EmptyHistoryLabel: {
          visible: !isHistoryVisible,
          text: {
            text: t('search.empty')
          }
        }
      });
      if (isHistoryVisible) {
        this._searchedItems = searchedItems;
        this.tag('Items').children = searchedItems.map(function (item) {
          return {
            type: SearchedItem,
            data: item
          };
        });
      }
      var items = this.tag('Items').children;
      this._buttons = items.filter(function (item) {
        return item;
      });
    }
  }, {
    key: "isVisibleHistory",
    get: function get() {
      return this.tag('Items').children.length > 0;
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this._setIndex();
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this._focused;
    }
  }, {
    key: "_setIndex",
    value: function _setIndex() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._index;
      this._index = index;
      this._focused = this._buttons[this._index];
      this._refocus();
    }
  }, {
    key: "_handleUp",
    value: function _handleUp() {
      if (this._index > 0) {
        this._setIndex(this._index - 1);
        return true;
      }
      return false;
    }
  }, {
    key: "_handleDown",
    value: function _handleDown() {
      if (this._index < this._buttons.length - 1) {
        this._setIndex(this._index + 1);
        return true;
      }
      return false;
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      this.signal(SELECTED_SIGNAL, this._searchedItems[this._index]);
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Title: {},
        EmptyHistoryLabel: {},
        Items: {}
      }, searchHistory_style_getInitialStyle());
    }
  }]);
  return SearchedItems;
}(src_Lightning.Component);

;// CONCATENATED MODULE: ./src/modules/search/search.constants.js
var SEARCH_DEBOUNCE_MS = 800;
;// CONCATENATED MODULE: ./src/modules/search/search.component.js








function search_component_createSuper(t) { var r = search_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function search_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (search_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }





















var Search = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Search, _Lightning$Component);
  var _super = search_component_createSuper(Search);
  function Search() {
    (0,classCallCheck/* default */.Z)(this, Search);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Search, [{
    key: "_construct",
    value: function _construct() {
      var _this = this;
      this._style = search_style_defaultContext;
      this._query = '';
      this._search = debounce_default()(function () {
        if (_this._query) {
          lightningjs_redux.dispatch(searchAll(_this._query));
          sendEvent({
            key: 'searchInput',
            input: _this._query
          });
        }
      }, SEARCH_DEBOUNCE_MS);
    }
  }, {
    key: "_attach",
    value: function _attach() {
      this._unsubscribe = search_connect(this);
      this._focused = this.tag('Keyboard');
      this._isDefaultLayout = false;
      this._isTouched = true;
      this._prevFocused = this.tag('Keyboard');
      lightningjs_redux.dispatch(getSearchedItems());
    }
  }, {
    key: "_detach",
    value: function _detach() {
      if (this._unsubscribe) {
        this._unsubscribe();
        this._unsubscribe = null;
      }
      this._isTouched = false;
      this._focused = undefined;
      this._search.cancel();
      if (this._query.length < MIN_TEXT_LENGTH_TO_SEARCH) {
        lightningjs_redux.dispatch(resetSearch());
      }
    }
  }, {
    key: "historyState",
    value: function historyState(history) {
      var renderer = this.tag('SearchResultBlock');
      if (history) {
        if (Number.isFinite(history.column)) {
          this._focused = renderer;
          this._hideKeyboard(false);
        }
      }
      return renderer.historyState(history);
    }
  }, {
    key: "data",
    set: function set(value) {
      this._defaultLayout = value;
      var theme = getLayoutTheme(get_default()(value, 'layout.theme'));
      var color = theme.backgroundColor || search_style_BACKGROUND_COLOR[this._style.colorMode];
      this.patch({
        Background: {
          color: color
        },
        Strip: {
          color: color
        },
        Overlay: {
          colorTop: color
        }
      });
      if (!this.query || !this.hasSearchResults) {
        this.tag('SearchResultBlock').data = this._defaultLayout;
        this._refocus();
      }
    }
  }, {
    key: "searchResult",
    set: function set(data) {
      var blocks = data.results,
        searchInput = data.searchInput;
      if (this._query === searchInput || !this._isTouched) {
        this.query = searchInput;
        this.hasSearchResults = Boolean(blocks && blocks.length);
        var layoutData = this.hasSearchResults ? {
          blocks: blocks,
          layout: {}
        } : this._defaultLayout;
        if (layoutData) {
          this.tag('SearchResultBlock').data = layoutData;
        }
      }
    }
  }, {
    key: "query",
    get: function get() {
      return this._query;
    },
    set: function set(value) {
      if (value.length > MAX_TEXT_LENGTH_TO_SEARCH) {
        return;
      }
      this._query = value;
      this.tag('SearchField').searchQuery = this._query;
    }
  }, {
    key: "searchedItems",
    set: function set(searchedItems) {
      this.tag('SearchedItems').searchedItems = searchedItems;
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this._focused;
    }
  }, {
    key: "_handleDown",
    value: function _handleDown() {
      var resultsBlock = this.tag('SearchResultBlock');
      if (this._focused !== resultsBlock && resultsBlock.hasResults) {
        this._hideKeyboard();
        this._focused = resultsBlock;
      }
      return true;
    }
  }, {
    key: "_handleUp",
    value: function _handleUp() {
      if (this._focused === this.tag('SearchResultBlock')) {
        this._showKeyboard();
        this._focused = this._prevFocused;
      }
    }
  }, {
    key: "_handleRight",
    value: function _handleRight() {
      if (this._focused === this.tag('Keyboard') && this.tag('SearchedItems').isVisibleHistory) {
        this._focused = this.tag('SearchedItems');
        this._prevFocused = this._focused;
      }
    }
  }, {
    key: "_handleLeft",
    value: function _handleLeft() {
      if (this._focused === this.tag('SearchedItems')) {
        this._focused = this.tag('Keyboard');
        this._prevFocused = this._focused;
      } else if (this._focused === this.tag('Keyboard') || this._focused === this.tag('SearchResultBlock')) {
        return false;
      }
      return true;
    }
  }, {
    key: "_handleKeyPress",
    value: function _handleKeyPress(symbol) {
      this._isTouched = true;
      this.query = formattingInput(symbol, this._query);
      if (this._query.length >= MIN_TEXT_LENGTH_TO_SEARCH) {
        this._search();
      } else {
        this._search.cancel();
        this.tag('SearchResultBlock').data = this._defaultLayout;
      }
    }
  }, {
    key: "_handleSearchFromHistory",
    value: function _handleSearchFromHistory(item) {
      this._isTouched = true;
      this.query = item;
      lightningjs_redux.dispatch(searchAll(this._query));
    }
  }, {
    key: "_hideKeyboard",
    value: function _hideKeyboard() {
      var shouldAnimate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var offset = KEYBOARD_OFFSET_Y[this._style.screenSize];
      if (!shouldAnimate) {
        this.patch({
          SearchResultBlock: {
            y: offset
          },
          Keyboard: {
            y: -offset,
            alpha: 0
          },
          SearchedItems: {
            y: -offset,
            alpha: 0
          }
        });
        return;
      }
      this.patch({
        Keyboard: {
          smooth: {
            y: -offset,
            alpha: 0
          }
        },
        SearchedItems: {
          smooth: {
            y: -offset,
            alpha: 0
          }
        },
        SearchResultBlock: {
          smooth: {
            y: offset
          }
        }
      });
    }
  }, {
    key: "_showKeyboard",
    value: function _showKeyboard() {
      var screenSize = this._style.screenSize;
      this.patch({
        Keyboard: {
          smooth: {
            alpha: 1,
            y: KEYBOARD_OFFSET_Y[screenSize]
          }
        },
        SearchedItems: {
          smooth: {
            alpha: 1,
            y: HISTORY_POSITION_Y[screenSize]
          }
        },
        SearchResultBlock: {
          smooth: {
            y: getBlockOffset(screenSize)
          }
        }
      });
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Background: {
          rect: true
        },
        SearchField: {
          type: SearchField
        },
        Keyboard: {
          type: keyboard_component_Keyboard,
          signals: (0,defineProperty/* default */.Z)({}, LETTER_SELECTED_SIGNAL, '_handleKeyPress')
        },
        SearchedItems: {
          type: SearchedItems,
          signals: (0,defineProperty/* default */.Z)({}, SELECTED_SIGNAL, '_handleSearchFromHistory')
        },
        Strip: {
          rect: true
        },
        Overlay: {
          rect: true
        },
        SearchResultBlock: {
          type: SearchResultBlock
        }
      }, search_style_getInitialStyle());
    }
  }]);
  return Search;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/exploreCatalogue/exploreCatalogue.constants.js

var _BLOCK_GAP;

var BLOCK_GAP = (_BLOCK_GAP = {}, (0,defineProperty/* default */.Z)(_BLOCK_GAP, HD, 16), (0,defineProperty/* default */.Z)(_BLOCK_GAP, FULL_HD, 24), _BLOCK_GAP);
;// CONCATENATED MODULE: ./src/modules/exploreCatalogue/exploreCatalogue.utils.js

function exploreCatalogue_utils_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function exploreCatalogue_utils_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? exploreCatalogue_utils_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : exploreCatalogue_utils_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


var createBlock = function createBlock(color, screenSize, colorMode) {
  return exploreCatalogue_utils_objectSpread(exploreCatalogue_utils_objectSpread({
    rect: true,
    flexItem: {
      marginRight: BLOCK_GAP[screenSize]
    }
  }, poster_constants_sizes[poster_constants_templates.PosterS][screenSize]), {}, {
    color: color[colorMode]
  });
};
;// CONCATENATED MODULE: ./src/modules/exploreCatalogue/exploreCatalogue.style.js


var _MARGIN_BLOCKS_TOP, _MARGIN_TITLE_TOP, _MARGIN_DESCRIPTION_T, _MARGIN_SCREEN_TITLE_, _BLOCK_WIDTH, _BLOCK_HEIGHT;
function exploreCatalogue_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function exploreCatalogue_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? exploreCatalogue_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : exploreCatalogue_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }







var exploreCatalogue_style_defaultContext = makeDefaultStylingContext();
var exploreCatalogue_style_colors = {
  background: makeThemeColor(TERTIARY),
  blocks: [makeThemeColor(PRIMARY, 0.9), makeThemeColor(PRIMARY, 0.6), makeThemeColor(PRIMARY, 0.3), makeThemeColor(PRIMARY, 0.1)]
};
var MARGIN_BLOCKS_TOP = (_MARGIN_BLOCKS_TOP = {}, (0,defineProperty/* default */.Z)(_MARGIN_BLOCKS_TOP, HD, 24), (0,defineProperty/* default */.Z)(_MARGIN_BLOCKS_TOP, FULL_HD, 40), _MARGIN_BLOCKS_TOP);
var MARGIN_TITLE_TOP = (_MARGIN_TITLE_TOP = {}, (0,defineProperty/* default */.Z)(_MARGIN_TITLE_TOP, HD, 40), (0,defineProperty/* default */.Z)(_MARGIN_TITLE_TOP, FULL_HD, 48), _MARGIN_TITLE_TOP);
var MARGIN_DESCRIPTION_TOP = (_MARGIN_DESCRIPTION_T = {}, (0,defineProperty/* default */.Z)(_MARGIN_DESCRIPTION_T, HD, 8), (0,defineProperty/* default */.Z)(_MARGIN_DESCRIPTION_T, FULL_HD, 8), _MARGIN_DESCRIPTION_T);
var MARGIN_SCREEN_TITLE_TOP = (_MARGIN_SCREEN_TITLE_ = {}, (0,defineProperty/* default */.Z)(_MARGIN_SCREEN_TITLE_, HD, 168), (0,defineProperty/* default */.Z)(_MARGIN_SCREEN_TITLE_, FULL_HD, 272), _MARGIN_SCREEN_TITLE_);
var BLOCK_WIDTH = (_BLOCK_WIDTH = {}, (0,defineProperty/* default */.Z)(_BLOCK_WIDTH, HD, 221), (0,defineProperty/* default */.Z)(_BLOCK_WIDTH, FULL_HD, 327), _BLOCK_WIDTH);
var BLOCK_HEIGHT = (_BLOCK_HEIGHT = {}, (0,defineProperty/* default */.Z)(_BLOCK_HEIGHT, HD, 124), (0,defineProperty/* default */.Z)(_BLOCK_HEIGHT, FULL_HD, 184), _BLOCK_HEIGHT);
var exploreCatalogue_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : exploreCatalogue_style_defaultContext,
    screenSize = _ref.screenSize,
    colorMode = _ref.colorMode;
  return {
    Background: {
      w: SCREEN_WIDTH[screenSize],
      h: sizes_SCREEN_HEIGHT[screenSize],
      color: exploreCatalogue_style_colors.background[colorMode]
    },
    Content: {
      x: getContentPadding(),
      flex: {
        direction: 'column'
      },
      MainTitle: {
        flexItem: {
          marginTop: MARGIN_SCREEN_TITLE_TOP[screenSize]
        },
        text: exploreCatalogue_style_objectSpread({}, src_getFont(constants_FONT.PARIS_3, screenSize))
      },
      Blocks: {
        flexItem: {
          marginTop: MARGIN_BLOCKS_TOP[screenSize]
        },
        flex: {},
        children: exploreCatalogue_style_colors.blocks.map(function (color) {
          return createBlock(color, screenSize, colorMode);
        })
      },
      Title: {
        flexItem: {
          marginTop: MARGIN_TITLE_TOP[screenSize]
        },
        text: exploreCatalogue_style_objectSpread({}, src_getFont(constants_FONT.OTTAWA_3, screenSize))
      },
      Description: {
        flexItem: {
          marginTop: MARGIN_DESCRIPTION_TOP[screenSize]
        },
        text: exploreCatalogue_style_objectSpread({}, src_getFont(constants_FONT.BERLIN_1, screenSize))
      },
      Button: {
        flexItem: {
          marginTop: MARGIN_TITLE_TOP[screenSize]
        }
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/exploreCatalogue/exploreCatalogue.component.js





function exploreCatalogue_component_createSuper(t) { var r = exploreCatalogue_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function exploreCatalogue_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (exploreCatalogue_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }










var ExploreCatalogue = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(ExploreCatalogue, _Lightning$Component);
  var _super = exploreCatalogue_component_createSuper(ExploreCatalogue);
  function ExploreCatalogue() {
    (0,classCallCheck/* default */.Z)(this, ExploreCatalogue);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(ExploreCatalogue, [{
    key: "_getFocused",
    value: function _getFocused() {
      return this.tag('Button');
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      return lightningjs_redux.dispatch(createItemAction(createLayoutAction(HOME_ALIAS, layout_constants/* aliases */.j3, 'pressBookmarksButton')));
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Background: {
          rect: true
        },
        Content: {
          MainTitle: {
            text: {
              text: t('bookmarks.title')
            }
          },
          Blocks: {},
          Title: {
            text: {
              text: t('bookmarks.noContentTitle')
            }
          },
          Description: {
            text: {
              text: t('bookmarks.noContentDescription')
            }
          },
          Button: {
            type: Button,
            label: t('bookmarks.noContentAction')
          }
        }
      }, exploreCatalogue_style_getInitialStyle());
    }
  }]);
  return ExploreCatalogue;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/catalog/page.utils.js









var isEPG = function isEPG(entityType, entityId) {
  return entityType === FRONTSPACE && entityId === LAYOUT_FRONTSPACES.epggrid;
};
var isSearch = function isSearch(entityType, entityId) {
  return entityType === common_constants_FRONTSPACE && entityId === layout_constants/* frontspaces */.K_.search;
};
var isProfilesGate = function isProfilesGate(entityType, entityId) {
  return entityType === layout_constants/* entities */.jF.frontspace && entityId === layout_constants/* frontspaces */.K_.profilesgate;
};
var isExploreCatalogue = function isExploreCatalogue(entityType, entityId, areBlocksEmpty) {
  return entityType === common_constants_FRONTSPACE && entityId === layout_constants/* frontspaces */.K_.bookmarks && areBlocksEmpty;
};
var getRenderer = function getRenderer(layout) {
  var _ref = layout.entity || {},
    entityType = _ref.type,
    entityId = _ref.id;
  var areBlocksEmpty = !get_default()(layout, 'blocks.length');
  if (isProfilesGate(entityType, entityId)) {
    return ProfilesGate;
  }
  if (isSearch(entityType, entityId)) {
    return Search;
  }
  if (isExploreCatalogue(entityType, entityId, areBlocksEmpty)) {
    return ExploreCatalogue;
  }
  return AbstractLayout;
};
;// CONCATENATED MODULE: ./src/modules/catalog/page.component.js






function page_component_createSuper(t) { var r = page_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function page_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (page_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }











var Page = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Page, _Lightning$Component);
  var _super = page_component_createSuper(Page);
  function Page() {
    (0,classCallCheck/* default */.Z)(this, Page);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Page, [{
    key: "_onUrlParams",
    value: function _onUrlParams(params) {
      var entityType = params.entityType,
        entityId = params.entityId,
        historyState = params[Router.symbols.historyState];
      this._history = historyState;
      Page.currentTarget = this.id;
      lightningjs_redux.dispatch(fetchLayout(entityType, entityId));
      lightningjs_redux.dispatch(setRouteSkeletonByEntity(entityType, entityId));
    }
  }, {
    key: "_construct",
    value: function _construct() {
      this._style = page_style_defaultContext;
      this._entity = '';
      this._reuseRenderer = true;
    }
  }, {
    key: "_build",
    value: function _build() {
      this._skeletonFadeAnimation = this.tag('Skeleton').animation({
        duration: 0.5,
        actions: [{
          p: 'alpha',
          v: {
            0: 1,
            1: 0
          }
        }],
        stopMethod: 'immediate'
      });
    }
  }, {
    key: "_active",
    value: function _active() {
      var _this = this;
      this._unsubscribe = page_connector(this);
      this._skeletonFadeAnimation.on('finish', function () {
        if (!_this._skeleton) {
          _this.tag('Skeleton').children = [];
        }
      });
    }
  }, {
    key: "_inactive",
    value: function _inactive() {
      this._cleanup();
    }
  }, {
    key: "historyState",
    value: function historyState(history) {
      if (history) {
        this._history = history;
      }
      var renderer = this.tag('Renderer').children[0];
      if (renderer && typeof renderer.historyState === 'function') {
        return renderer.historyState(history);
      }
      return undefined;
    }
  }, {
    key: "layout",
    set: function set(value) {
      var _this2 = this;
      if (!value) {
        return;
      }
      clearTimeout(this._layoutTimeout);
      this._layoutTimeout = setTimeout(function () {
        if (!Page.currentTarget || Page.currentTarget === _this2.id) {
          _this2._applyLayout(value);
        }
      }, 0);
    }
  }, {
    key: "skeleton",
    set: function set(value) {
      if (value && this._skeleton !== value) {
        var skeleton = getSkeletonByConfig(value);
        this._skeletonFadeAnimation.stop();
        if (skeleton) {
          this.tag('Skeleton').patch({
            alpha: 1,
            children: [skeleton]
          });
        }
      } else if (!value) {
        if (this._skeletonFadeAnimation) {
          this._skeletonFadeAnimation.start();
        }
      }
      this._skeleton = value;
    }
  }, {
    key: "hasSideNav",
    set: function set(value) {
      if (this._hasSideNav !== value) {
        this._hasSideNav = value;
        this._applyContentPadding();
      }
    }
  }, {
    key: "pageTransition",
    value: function pageTransition(pageIn, pageOut) {
      return pageTransition_pageTransition(pageIn, pageOut);
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this.tag('Renderer').children[0];
    }
  }, {
    key: "_applyLayout",
    value: function _applyLayout(value) {
      var entity = getLayoutEntityAsString(value);
      var isDifferentLayout = this._entity !== entity;
      this._entity = entity;
      var type = getRenderer(value);
      var _this$tag$children = (0,slicedToArray/* default */.Z)(this.tag('Renderer').children, 1),
        currentRenderer = _this$tag$children[0];
      if ((this._reuseRenderer || !isDifferentLayout) && currentRenderer instanceof type) {
        currentRenderer.data = value;
      } else {
        this.tag('Renderer').children = [{
          type: type,
          h: RENDERER_HEIGHT[this._style.screenSize]
        }];
        var renderer = this.tag('Renderer').children[0];
        this._restoreHistory(renderer);
        renderer.data = value;
        this._refocus();
      }
    }
  }, {
    key: "_applyContentPadding",
    value: function _applyContentPadding() {
      var value = getContentPadding(this._hasSideNav);
      this.tag('Skeleton').x = value;
    }
  }, {
    key: "_restoreHistory",
    value: function _restoreHistory(renderer) {
      if (this._history && typeof renderer.historyState === 'function') {
        renderer.historyState(this._history);
        this._history = undefined;
      }
    }
  }, {
    key: "_cleanup",
    value: function _cleanup() {
      if (this._unsubscribe) {
        this._unsubscribe();
        this._unsubscribe = null;
      }
      clearTimeout(this._layoutTimeout);
      if (this._skeletonFadeAnimation) {
        this._skeletonFadeAnimation.removeAllListeners('finish');
      }
      this._skeleton = null;
      this._skeletonFadeAnimation = null;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return {
        Renderer: {},
        Skeleton: {}
      };
    }
  }]);
  return Page;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/tornado/big-button/customer/rtlde/button.constants.js

var button_constants_BORDER_RADIUS, button_constants_STROKE_UNFOCUSED, button_constants_STROKE_FOCUSED;


var rtlde_button_constants_BORDER_RADIUS = (button_constants_BORDER_RADIUS = {}, (0,defineProperty/* default */.Z)(button_constants_BORDER_RADIUS, HD, 4), (0,defineProperty/* default */.Z)(button_constants_BORDER_RADIUS, FULL_HD, 4), button_constants_BORDER_RADIUS);
var rtlde_button_constants_STROKE_UNFOCUSED = (button_constants_STROKE_UNFOCUSED = {}, (0,defineProperty/* default */.Z)(button_constants_STROKE_UNFOCUSED, HD, 2), (0,defineProperty/* default */.Z)(button_constants_STROKE_UNFOCUSED, FULL_HD, 3), button_constants_STROKE_UNFOCUSED);
var rtlde_button_constants_STROKE_FOCUSED = (button_constants_STROKE_FOCUSED = {}, (0,defineProperty/* default */.Z)(button_constants_STROKE_FOCUSED, HD, 2), (0,defineProperty/* default */.Z)(button_constants_STROKE_FOCUSED, FULL_HD, 3), button_constants_STROKE_FOCUSED);
var button_constants_STROKE_UNFOCUSED_COLOR = makeThemeColor(PRIMARY, 1.0);
var button_constants_STROKE_FOCUSED_COLOR = makeThemeColor(PRIMARY, 1.0);
var button_constants_FILL_UNFOCUSED_COLOR = makeThemeColor(TERTIARY);
var FILL_SELECTED_COLOR = makeThemeColor(PRIMARY, 0.6);
var button_constants_FILL_FOCUSED_COLOR = makeThemeColor(PRIMARY);
var button_constants_TEXT_UNFOCUSED_COLOR = makeThemeColor(PRIMARY);
var TEXT_SELECTED_COLOR = makeThemeColor(TERTIARY);
var button_constants_TEXT_FOCUSED_COLOR = makeThemeColor(TERTIARY);
var button_constants_SCALE_FOCUSED = 1.05;
;// CONCATENATED MODULE: ./src/modules/tornado/big-button/customer/rtlde/button.style.js

var button_style_HEIGHT, rtlde_button_style_PADDING, button_style_ICON_WIDTH, button_style_ICON_HEIGHT, button_style_GAP;
function rtlde_button_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function rtlde_button_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? rtlde_button_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : rtlde_button_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }









var rtlde_button_style_defaultContext = makeDefaultStylingContext();
var rtlde_button_style_HEIGHT = (button_style_HEIGHT = {}, (0,defineProperty/* default */.Z)(button_style_HEIGHT, HD, 72), (0,defineProperty/* default */.Z)(button_style_HEIGHT, FULL_HD, 96), button_style_HEIGHT);
var customer_rtlde_button_style_PADDING = (rtlde_button_style_PADDING = {}, (0,defineProperty/* default */.Z)(rtlde_button_style_PADDING, HD, 40), (0,defineProperty/* default */.Z)(rtlde_button_style_PADDING, FULL_HD, 48), rtlde_button_style_PADDING);
var rtlde_button_style_ICON_WIDTH = (button_style_ICON_WIDTH = {}, (0,defineProperty/* default */.Z)(button_style_ICON_WIDTH, HD, 24), (0,defineProperty/* default */.Z)(button_style_ICON_WIDTH, FULL_HD, 40), button_style_ICON_WIDTH);
var rtlde_button_style_ICON_HEIGHT = (button_style_ICON_HEIGHT = {}, (0,defineProperty/* default */.Z)(button_style_ICON_HEIGHT, HD, 24), (0,defineProperty/* default */.Z)(button_style_ICON_HEIGHT, FULL_HD, 40), button_style_ICON_HEIGHT);
var rtlde_button_style_GAP = (button_style_GAP = {}, (0,defineProperty/* default */.Z)(button_style_GAP, HD, 8), (0,defineProperty/* default */.Z)(button_style_GAP, FULL_HD, 16), button_style_GAP);
var button_style_getUnFocusedStyle = function getUnFocusedStyle(_ref) {
  var screenSize = _ref.screenSize,
    colorMode = _ref.colorMode,
    selected = _ref.selected;
  return {
    Background: {
      borderWidth: getStrokeWidth(rtlde_button_constants_STROKE_UNFOCUSED[screenSize]),
      type: ButtonTexture,
      smooth: {
        color: selected ? FILL_SELECTED_COLOR[colorMode] : button_constants_FILL_UNFOCUSED_COLOR[colorMode],
        borderColor: selected ? colors_TRANSPARENT : button_constants_STROKE_UNFOCUSED_COLOR[colorMode],
        scale: 1.0
      }
    },
    IconLeft: {
      smooth: {
        color: selected ? TEXT_SELECTED_COLOR[colorMode] : button_constants_TEXT_UNFOCUSED_COLOR[colorMode]
      }
    },
    IconRight: {
      smooth: {
        color: selected ? TEXT_SELECTED_COLOR[colorMode] : button_constants_TEXT_UNFOCUSED_COLOR[colorMode]
      }
    },
    Label: {
      smooth: {
        color: selected ? TEXT_SELECTED_COLOR[colorMode] : button_constants_TEXT_UNFOCUSED_COLOR[colorMode]
      }
    }
  };
};
var button_style_getFocusedStyle = function getFocusedStyle(_ref2) {
  var screenSize = _ref2.screenSize,
    colorMode = _ref2.colorMode;
  return {
    Background: {
      borderWidth: getStrokeWidth(rtlde_button_constants_STROKE_FOCUSED[screenSize]),
      smooth: {
        borderColor: button_constants_STROKE_FOCUSED_COLOR[colorMode],
        color: button_constants_FILL_FOCUSED_COLOR[colorMode],
        scale: button_constants_SCALE_FOCUSED
      }
    },
    IconLeft: {
      smooth: {
        color: button_constants_TEXT_FOCUSED_COLOR[colorMode]
      }
    },
    IconRight: {
      smooth: {
        color: button_constants_TEXT_FOCUSED_COLOR[colorMode]
      }
    },
    Label: {
      smooth: {
        color: button_constants_TEXT_FOCUSED_COLOR[colorMode]
      }
    }
  };
};
var rtlde_button_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rtlde_button_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  var h = rtlde_button_style_HEIGHT[screenSize];
  var font = src_getFont(constants_FONT.OTTAWA_3, screenSize);
  return merge_default()({
    h: h,
    Background: {
      h: h,
      color: button_constants_FILL_UNFOCUSED_COLOR[colorMode],
      borderRadius: rtlde_button_constants_BORDER_RADIUS[screenSize]
    },
    IconLeft: {
      y: Math.round((h - rtlde_button_style_ICON_HEIGHT[screenSize]) / 2)
    },
    IconRight: {
      mountX: 1,
      y: Math.round((h - rtlde_button_style_ICON_HEIGHT[screenSize]) / 2)
    },
    Label: {
      mountX: 0.5,
      x: middle,
      y: Math.round((h - font.lineHeight) / 2),
      text: rtlde_button_style_objectSpread(rtlde_button_style_objectSpread({}, font), {}, {
        maxLines: 1,
        verticalAlign: 'middle',
        textAlign: 'center'
      })
    }
  }, button_style_getUnFocusedStyle(context));
};
;// CONCATENATED MODULE: ./src/modules/tornado/big-button/bigButton.style.js

;// CONCATENATED MODULE: ./src/modules/tornado/big-button/bigButton.component.js






function bigButton_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function bigButton_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? bigButton_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : bigButton_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function bigButton_component_createSuper(t) { var r = bigButton_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function bigButton_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (bigButton_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }






var BigButton = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(BigButton, _Lightning$Component);
  var _super = bigButton_component_createSuper(BigButton);
  function BigButton() {
    (0,classCallCheck/* default */.Z)(this, BigButton);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(BigButton, [{
    key: "_construct",
    value: function _construct() {
      this._style = rtlde_button_style_defaultContext;
      this._isLeftIconTxLoading = false;
      this._isRightIconTxLoading = false;
      this._isLabelTxLoading = false;
      this._minWidth = 0;
      this._isFocused = false;
      this._isSelected = false;
    }
  }, {
    key: "_init",
    value: function _init() {
      var _this = this;
      var label = this.tag('Label');
      var leftIcon = this.tag('IconLeft');
      var rightIcon = this.tag('IconRight');
      var screenSize = sizes_getScreenSize();
      var iconWidth = rtlde_button_style_ICON_WIDTH[screenSize];
      var gap = rtlde_button_style_GAP[screenSize];
      var padding = customer_rtlde_button_style_PADDING[screenSize];
      var handleUpdate = function handleUpdate() {
        if (_this._isLeftIconTxLoading || _this._isLabelTxLoading || _this._isRightIconTxLoading) {
          return;
        }
        var leftIconWidth = leftIcon.finalW ? gap + iconWidth : 0;
        var rightIconWidth = rightIcon.finalW ? gap + iconWidth : 0;
        var textWidth = _this.finalW - (padding * 2 + leftIconWidth + rightIconWidth);
        _this.patch({
          IconLeft: {
            x: padding
          },
          IconRight: {
            x: _this.finalW - padding
          },
          Label: {
            text: {
              wordWrapWidth: textWidth
            }
          }
        });
      };
      leftIcon.on('txLoaded', function () {
        _this._isLeftIconTxLoading = false;
        handleUpdate();
      });
      rightIcon.on('txLoaded', function () {
        _this._isRightIconTxLoading = false;
        handleUpdate();
      });
      label.on('txLoaded', function () {
        _this._isLabelTxLoading = false;
        handleUpdate();
      });
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this.tag('Label').removeAllListeners('txLoaded');
      this.tag('IconLeft').removeAllListeners('txLoaded');
      this.tag('IconRight').removeAllListeners('txLoaded');
    }
  }, {
    key: "label",
    set: function set(value) {
      this.tag('Label').text.text = value;
      this._isLabelTxLoading = true;
    }
  }, {
    key: "pictoLeft",
    set: function set(value) {
      this._isLeftIconTxLoading = true;
      var screenSize = sizes_getScreenSize();
      this.tag('IconLeft').iconData = {
        picto: value,
        viewBox: {
          w: rtlde_button_style_ICON_WIDTH[screenSize],
          h: rtlde_button_style_ICON_HEIGHT[screenSize]
        }
      };
    }
  }, {
    key: "pictoRight",
    set: function set(value) {
      this._isRightIconTxLoading = true;
      var screenSize = sizes_getScreenSize();
      this.tag('IconRight').iconData = {
        picto: value,
        viewBox: {
          w: rtlde_button_style_ICON_WIDTH[screenSize],
          h: rtlde_button_style_ICON_HEIGHT[screenSize]
        }
      };
    }
  }, {
    key: "colorMode",
    get: function get() {
      return this._style.colorMode;
    },
    set: function set(value) {
      this._style = bigButton_component_objectSpread(bigButton_component_objectSpread({}, this._style), {}, {
        colorMode: value
      });
      this.patch(rtlde_button_style_getInitialStyle(this._style));
    }
  }, {
    key: "isSelected",
    get: function get() {
      return this._isSelected;
    },
    set: function set(value) {
      this._isSelected = value;
      this._updateStyle();
    }
  }, {
    key: "_updateStyle",
    value: function _updateStyle() {
      this.patch(this._isFocused ? button_style_getFocusedStyle(bigButton_component_objectSpread(bigButton_component_objectSpread({}, this._style), {}, {
        selected: this._isSelected
      })) : button_style_getUnFocusedStyle(bigButton_component_objectSpread(bigButton_component_objectSpread({}, this._style), {}, {
        selected: this._isSelected
      })));
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this._isFocused = true;
      this._updateStyle();
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this._isFocused = false;
      this._updateStyle();
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Background: {
          type: ButtonBackground,
          w: identity
        },
        Fill: {},
        IconLeft: {
          type: Icon
        },
        IconRight: {
          type: Icon
        },
        Label: {}
      }, rtlde_button_style_getInitialStyle());
    }
  }]);
  return BigButton;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/tornado/pairing/feature/feature.style.js

var feature_style_WIDTH, feature_style_HEIGHT, feature_style_MARGIN;
function feature_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function feature_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? feature_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : feature_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





var feature_style_defaultContext = {
  screenSize: sizes_getScreenSize(),
  colorMode: DEFAULT_MODE
};
var _defaultContext$scree = feature_style_defaultContext.screenSize,
  feature_style_screenSize = _defaultContext$scree === void 0 ? FULL_HD : _defaultContext$scree;

var feature_style_colors = {
  text: makeThemeColor(PRIMARY),
  icon: makeThemeColor(UTILITY2)
};
var feature_style_ICON_SIZE = {
  WIDTH: (feature_style_WIDTH = {}, (0,defineProperty/* default */.Z)(feature_style_WIDTH, HD, 16), (0,defineProperty/* default */.Z)(feature_style_WIDTH, FULL_HD, 24), feature_style_WIDTH),
  HEIGHT: (feature_style_HEIGHT = {}, (0,defineProperty/* default */.Z)(feature_style_HEIGHT, HD, 16), (0,defineProperty/* default */.Z)(feature_style_HEIGHT, FULL_HD, 24), feature_style_HEIGHT)
};
var feature_feature_style_MARGIN = (feature_style_MARGIN = {}, (0,defineProperty/* default */.Z)(feature_style_MARGIN, HD, 8), (0,defineProperty/* default */.Z)(feature_style_MARGIN, FULL_HD, 12), feature_style_MARGIN);
var feature_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : feature_style_defaultContext;
  var _context$screenSize = context.screenSize,
    screenSize = _context$screenSize === void 0 ? FULL_HD : _context$screenSize,
    _context$colorMode = context.colorMode,
    colorMode = _context$colorMode === void 0 ? DEFAULT_MODE : _context$colorMode;
  var font = src_getFont(constants_FONT.MADRID_1, screenSize);
  return {
    h: Math.max(feature_style_ICON_SIZE.HEIGHT[screenSize], font.lineHeight),
    flex: {
      direction: 'row'
    },
    Icon: {
      iconData: {
        picto: {
          name: 'Check',
          collection: ICON_COLLECTION.BASIC
        },
        viewBox: {
          w: feature_style_ICON_SIZE.WIDTH[screenSize],
          h: feature_style_ICON_SIZE.HEIGHT[screenSize]
        }
      },
      color: feature_style_colors.icon[colorMode]
    },
    Text: {
      text: feature_style_objectSpread(feature_style_objectSpread({}, font), {}, {
        verticalAlign: 'middle',
        textColor: feature_style_colors.text[colorMode]
      }),
      flexItem: {
        marginLeft: feature_feature_style_MARGIN[screenSize]
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/pairing/feature/feature.component.js







function feature_component_createSuper(t) { var r = feature_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function feature_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (feature_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }




var Feature = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Feature, _Lightning$Component);
  var _super = feature_component_createSuper(Feature);
  function Feature() {
    (0,classCallCheck/* default */.Z)(this, Feature);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Feature, [{
    key: "_construct",
    value: function _construct() {
      this._style = feature_style_defaultContext;
    }
  }, {
    key: "title",
    set: function set(value) {
      this.tag('Text').text.text = value;
    }
  }, {
    key: "w",
    get: function get() {
      return (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(Feature.prototype), "w", this);
    },
    set: function set(value) {
      _set((0,getPrototypeOf/* default */.Z)(Feature.prototype), "w", value, this, true);
      var screenSize = this._style.screenSize;
      this.tag('Text').patch({
        text: {
          wordWrapWidth: value - feature_style_ICON_SIZE.WIDTH[screenSize] - feature_feature_style_MARGIN[screenSize]
        }
      });
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Icon: {
          type: Icon
        },
        Text: {}
      }, feature_style_getInitialStyle());
    }
  }]);
  return Feature;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/tornado/pairing/selector/pairingSelector.style.js

var _SPACER, pairingSelector_style_WIDTH, _SEPARATOR, _STEPS_GAP, _BUTTONS_GAP;




var pairingSelector_style_defaultContext = makeDefaultStylingContext();
var pairingSelector_style_titleFont = src_getFont(constants_FONT.PARIS_3);
var pairingSelector_style_colors = {
  separator: makeThemeColor(PRIMARY, 0.3)
};
var SPACER = (_SPACER = {}, (0,defineProperty/* default */.Z)(_SPACER, HD, 32), (0,defineProperty/* default */.Z)(_SPACER, FULL_HD, 40), _SPACER);
var selector_pairingSelector_style_WIDTH = (pairingSelector_style_WIDTH = {}, (0,defineProperty/* default */.Z)(pairingSelector_style_WIDTH, HD, 412 + SPACER[HD]), (0,defineProperty/* default */.Z)(pairingSelector_style_WIDTH, FULL_HD, 588 + SPACER[FULL_HD]), pairingSelector_style_WIDTH);
var SEPARATOR = (_SEPARATOR = {}, (0,defineProperty/* default */.Z)(_SEPARATOR, HD, 2), (0,defineProperty/* default */.Z)(_SEPARATOR, FULL_HD, 4), _SEPARATOR);
var STEPS_GAP = (_STEPS_GAP = {}, (0,defineProperty/* default */.Z)(_STEPS_GAP, HD, 16), (0,defineProperty/* default */.Z)(_STEPS_GAP, FULL_HD, 24), _STEPS_GAP);
var BUTTONS_GAP = (_BUTTONS_GAP = {}, (0,defineProperty/* default */.Z)(_BUTTONS_GAP, HD, 16), (0,defineProperty/* default */.Z)(_BUTTONS_GAP, FULL_HD, 16), _BUTTONS_GAP);
var pairingSelector_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : pairingSelector_style_defaultContext,
    _ref$screenSize = _ref.screenSize,
    screenSize = _ref$screenSize === void 0 ? FULL_HD : _ref$screenSize,
    _ref$colorMode = _ref.colorMode,
    colorMode = _ref$colorMode === void 0 ? DEFAULT_MODE : _ref$colorMode;
  var leftWidth = selector_pairingSelector_style_WIDTH[screenSize] - SPACER[screenSize];
  return {
    w: selector_pairingSelector_style_WIDTH[screenSize],
    Static: {
      x: safetyMargins.horizontal[screenSize],
      w: leftWidth,
      flex: {
        direction: 'column'
      },
      Title: {
        text: {
          wordWrapWidth: leftWidth,
          maxLines: 2
        },
        flexItem: {
          marginBottom: STEPS_GAP[screenSize]
        }
      },
      Feature0: {
        w: leftWidth,
        flexItem: {
          marginBottom: STEPS_GAP[screenSize]
        }
      },
      Feature1: {
        w: leftWidth,
        flexItem: {
          marginBottom: STEPS_GAP[screenSize]
        }
      },
      Feature2: {
        w: leftWidth,
        flexItem: {
          marginBottom: STEPS_GAP[screenSize]
        }
      }
    },
    Buttons: {
      x: safetyMargins.horizontal[screenSize],
      w: leftWidth,
      flex: {
        direction: 'column',
        justifyContent: 'flex-end',
        alignItems: 'stretch'
      }
    },
    Separator: {
      rect: true,
      x: safetyMargins.horizontal[screenSize] + selector_pairingSelector_style_WIDTH[screenSize],
      w: SEPARATOR[screenSize],
      color: pairingSelector_style_colors.separator[colorMode]
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/pairing/selector/pairingSelector.component.js










function pairingSelector_component_createSuper(t) { var r = pairingSelector_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function pairingSelector_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (pairingSelector_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }






var PairingSelector = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(PairingSelector, _Lightning$Component);
  var _super = pairingSelector_component_createSuper(PairingSelector);
  function PairingSelector() {
    (0,classCallCheck/* default */.Z)(this, PairingSelector);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(PairingSelector, [{
    key: "_construct",
    value: function _construct() {
      this._style = pairingSelector_style_defaultContext;
      this._focusedButton = 0;
    }
  }, {
    key: "h",
    get: function get() {
      return (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(PairingSelector.prototype), "h", this);
    },
    set: function set(value) {
      _set((0,getPrototypeOf/* default */.Z)(PairingSelector.prototype), "h", value, this, true);
      this.patch({
        Static: {
          h: value
        },
        Buttons: {
          h: value
        },
        Separator: {
          h: value
        }
      });
    }
  }, {
    key: "labels",
    set: function set(value) {
      this.patch({
        Static: {
          Title: {
            text: {
              text: value.title
            }
          }
        }
      });
      for (var i = 0; i < 3; i += 1) {
        var text = value.features ? value.features[i] : '';
        this.tag("Feature".concat(i)).patch({
          title: text || '',
          visible: Boolean(text)
        });
      }
    }
  }, {
    key: "buttons",
    set: function set(value) {
      var screenSize = this._style.screenSize;
      var w = selector_pairingSelector_style_WIDTH[screenSize] - SPACER[screenSize];
      var marginBottom = BUTTONS_GAP[this._style.screenSize];
      this.tag('Buttons').children = value.map(function (_ref, index) {
        var label = _ref.label,
          iconLeft = _ref.iconLeft,
          iconRight = _ref.iconRight;
        return {
          type: BigButton,
          w: w,
          ref: "Button".concat(index),
          label: label,
          pictoLeft: {
            type: 'icon',
            name: iconLeft
          },
          pictoRight: {
            type: 'icon',
            name: iconRight
          },
          flexItem: {
            marginBottom: marginBottom
          }
        };
      });
      if (value.length) {
        this.tag('Buttons').children[this._focusedButton].isSelected = true;
      }
    }
  }, {
    key: "selectedButton",
    get: function get() {
      return this.tag('Buttons').children.findIndex(function (button) {
        return button.isSelected;
      });
    },
    set: function set(value) {
      var _this = this;
      this._focusedButton = value;
      this.tag('Buttons').children.forEach(function (button, index) {
        button.isSelected = index === _this._focusedButton;
      });
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this.tag('Buttons').children[this._focusedButton];
    }
  }, {
    key: "_handleUp",
    value: function _handleUp() {
      if (this._focusedButton > 0) {
        this._focusedButton -= 1;
        return true;
      }
      return false;
    }
  }, {
    key: "_handleDown",
    value: function _handleDown() {
      if (this._focusedButton < this.tag('Buttons').children.length - 1) {
        this._focusedButton += 1;
        return true;
      }
      return false;
    }
  }, {
    key: "_handleLeft",
    value: function _handleLeft() {
      return true;
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      var _this2 = this;
      this.tag('Buttons').children.forEach(function (button, index) {
        button.isSelected = index === _this2._focusedButton;
      });
      this.signal(SELECTED_SIGNAL, this._focusedButton);
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Static: {
          Title: {
            text: {
              text: ''
            }
          },
          Feature0: {
            type: Feature
          },
          Feature1: {
            type: Feature
          },
          Feature2: {
            type: Feature
          }
        },
        Buttons: {},
        Separator: {}
      }, pairingSelector_style_getInitialStyle());
    }
  }]);
  return PairingSelector;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/tornado/pairing/step/pairingStep.style.js

var _CIRCLE_SIZE, _CIRCLE_MARGIN_RIGHT;
function pairingStep_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function pairingStep_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? pairingStep_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : pairingStep_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






var pairingStep_style_defaultContext = makeDefaultStylingContext();
var pairingStep_style_colors = {
  text: makeThemeColor(PRIMARY),
  circle: makeThemeColor(SECONDARY)
};
var CIRCLE_SIZE = (_CIRCLE_SIZE = {}, (0,defineProperty/* default */.Z)(_CIRCLE_SIZE, HD, 48), (0,defineProperty/* default */.Z)(_CIRCLE_SIZE, FULL_HD, 56), _CIRCLE_SIZE);
var CIRCLE_MARGIN_RIGHT = (_CIRCLE_MARGIN_RIGHT = {}, (0,defineProperty/* default */.Z)(_CIRCLE_MARGIN_RIGHT, HD, 24), (0,defineProperty/* default */.Z)(_CIRCLE_MARGIN_RIGHT, FULL_HD, 40), _CIRCLE_MARGIN_RIGHT);
var pairingStep_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : pairingStep_style_defaultContext,
    _ref$screenSize = _ref.screenSize,
    screenSize = _ref$screenSize === void 0 ? FULL_HD : _ref$screenSize,
    _ref$colorMode = _ref.colorMode,
    colorMode = _ref$colorMode === void 0 ? DEFAULT_MODE : _ref$colorMode;
  var numberFont = src_getFont(constants_FONT.OTTAWA_3, screenSize);
  var textFont = src_getFont(constants_FONT.OTTAWA_1, screenSize);
  var circleSize = CIRCLE_SIZE[screenSize];
  return {
    h: circleSize,
    Circle: {
      w: circleSize,
      h: circleSize,
      y: middle,
      mountY: 0.5,
      rect: true,
      shader: {
        fillColor: colors_TRANSPARENT,
        strokeColor: pairingStep_style_colors.circle[colorMode],
        stroke: 4,
        radius: Math.round(circleSize / 2)
      }
    },
    DigitContainer: {
      w: circleSize,
      h: circleSize,
      y: middle,
      mountY: 0.5,
      Digit: {
        x: middle,
        y: middle,
        mount: 0.5,
        text: pairingStep_style_objectSpread(pairingStep_style_objectSpread({}, numberFont), {}, {
          textColor: pairingStep_style_colors.text[colorMode],
          verticalAlign: 'middle',
          textAlign: 'center'
        })
      }
    },
    Title: {
      x: circleSize + CIRCLE_MARGIN_RIGHT[screenSize],
      y: middle,
      mountY: 0.5,
      text: pairingStep_style_objectSpread(pairingStep_style_objectSpread({}, textFont), {}, {
        textColor: pairingStep_style_colors.text[colorMode],
        maxLines: 3,
        maxLinesSuffix: '...',
        verticalAlign: 'middle'
      })
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/pairing/step/pairingStep.component.js







function pairingStep_component_createSuper(t) { var r = pairingStep_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function pairingStep_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (pairingStep_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }



var PairingStep = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(PairingStep, _Lightning$Component);
  var _super = pairingStep_component_createSuper(PairingStep);
  function PairingStep() {
    (0,classCallCheck/* default */.Z)(this, PairingStep);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(PairingStep, [{
    key: "_construct",
    value: function _construct() {
      this._style = pairingStep_style_defaultContext;
    }
  }, {
    key: "_active",
    value: function _active() {
      var _this = this;
      var screenSize = this._style.screenSize;
      var circleSize = CIRCLE_SIZE[screenSize];
      var title = this.tag('Title');
      title.on('txLoaded', function () {
        var textHeight = title.finalH;
        _this.patch({
          h: Math.max(textHeight, circleSize)
        });
      });
    }
  }, {
    key: "_inactive",
    value: function _inactive() {
      this.tag('Title').removeAllListeners('txLoaded');
    }
  }, {
    key: "digit",
    get: function get() {
      return this.tag('Digit').text.text;
    },
    set: function set(value) {
      this.tag('Digit').text.text = value;
    }
  }, {
    key: "title",
    get: function get() {
      return this.tag('Title').text.text;
    },
    set: function set(value) {
      this.tag('Title').text.text = value;
    }
  }, {
    key: "w",
    get: function get() {
      return (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(PairingStep.prototype), "w", this);
    },
    set: function set(value) {
      _set((0,getPrototypeOf/* default */.Z)(PairingStep.prototype), "w", value, this, true);
      var screenSize = this._style.screenSize;
      this.patch({
        Title: {
          text: {
            wordWrapWidth: value - CIRCLE_SIZE[screenSize] - CIRCLE_MARGIN_RIGHT[screenSize]
          }
        }
      });
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Circle: {
          shader: {
            type: src_Lightning.shaders.RoundedRectangle
          }
        },
        DigitContainer: {
          Digit: {}
        },
        Title: {}
      }, pairingStep_style_getInitialStyle());
    }
  }]);
  return PairingStep;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/tornado/pairing/pairing.utils.js







function pairing_pairing_utils_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function pairing_pairing_utils_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? pairing_pairing_utils_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : pairing_pairing_utils_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


var makePatch = function makePatch(count, patch) {
  return (0,toConsumableArray/* default */.Z)(Array(count)).map(function (_, i) {
    return i;
  }).reduce(function (result, current) {
    return pairing_pairing_utils_objectSpread(pairing_pairing_utils_objectSpread({}, result), {}, (0,defineProperty/* default */.Z)({}, "Step".concat(current), patch));
  }, {});
};
var makeStepsTemplate = function makeStepsTemplate(count, style) {
  return makePatch(count, pairing_pairing_utils_objectSpread({
    type: PairingStep,
    visible: false
  }, style));
};
var pairing_utils_translate = function translate(key, data) {
  var result = t(key, data);
  return result === key ? null : result;
};
var makeKeys = function makeKeys(base, count) {
  var result = [];
  for (var i = 0; i < count; i += 1) {
    result.push(pairing_utils_translate("".concat(base).concat(i + 1)));
  }
  return result;
};
var displaySteps = function displaySteps(steps, values) {
  var digit = 0;
  steps.forEach(function (view, index) {
    var text = values[index];
    view.title = text;
    view.digit = "0".concat(digit + 1);
    view.visible = Boolean(text);
    if (view.visible) {
      digit += 1;
    }
  });
};
var getSteps = function getSteps(view, count) {
  var base = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Step';
  return (0,toConsumableArray/* default */.Z)(Array(count)).map(function (_, index) {
    return view.tag("".concat(base).concat(index));
  }).filter(Boolean);
};
;// CONCATENATED MODULE: ./src/modules/tornado/pairing/desktop/desktopPairing.style.js

var desktopPairing_style_STEPS_GAP;
function desktopPairing_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function desktopPairing_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? desktopPairing_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : desktopPairing_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }








var desktopPairing_style_defaultContext = makeDefaultStylingContext();
var desktopPairing_style_colors = {
  text: makeThemeColor(PRIMARY)
};
var desktop_desktopPairing_style_STEPS_GAP = (desktopPairing_style_STEPS_GAP = {}, (0,defineProperty/* default */.Z)(desktopPairing_style_STEPS_GAP, HD, 24), (0,defineProperty/* default */.Z)(desktopPairing_style_STEPS_GAP, FULL_HD, 32), desktopPairing_style_STEPS_GAP);
var desktopPairing_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : desktopPairing_style_defaultContext,
    _ref$screenSize = _ref.screenSize,
    screenSize = _ref$screenSize === void 0 ? FULL_HD : _ref$screenSize,
    _ref$colorMode = _ref.colorMode,
    colorMode = _ref$colorMode === void 0 ? DEFAULT_MODE : _ref$colorMode;
  var titleFont = src_getFont(constants_FONT.PARIS_2, screenSize);
  var codeFont = src_getFont(constants_FONT.TOKYO_4, screenSize);
  return desktopPairing_style_objectSpread(desktopPairing_style_objectSpread({
    flex: {
      direction: 'column'
    },
    Title: {
      text: desktopPairing_style_objectSpread(desktopPairing_style_objectSpread({}, titleFont), {}, {
        textColor: desktopPairing_style_colors.text[colorMode],
        maxLines: 2,
        maxLinesSuffix: '...',
        verticalAlign: 'middle'
      }),
      flexItem: {
        marginBottom: 24
      }
    }
  }, makeStepsTemplate(5, {
    flexItem: {
      marginBottom: desktop_desktopPairing_style_STEPS_GAP[screenSize]
    }
  })), {}, {
    Code: {
      x: CIRCLE_SIZE[screenSize] + CIRCLE_MARGIN_RIGHT[screenSize],
      text: desktopPairing_style_objectSpread({}, codeFont)
    },
    Button: {
      flexItem: {
        marginTop: desktop_desktopPairing_style_STEPS_GAP[screenSize]
      },
      visible: false,
      type: Button,
      label: '',
      mountX: 0.5,
      x: middle
    }
  });
};
;// CONCATENATED MODULE: ./src/modules/tornado/pairing/desktop/desktopPairing.component.js











function desktopPairing_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function desktopPairing_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? desktopPairing_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : desktopPairing_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function desktopPairing_component_createSuper(t) { var r = desktopPairing_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function desktopPairing_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (desktopPairing_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }




var DesktopPairing = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(DesktopPairing, _Lightning$Component);
  var _super = desktopPairing_component_createSuper(DesktopPairing);
  function DesktopPairing() {
    (0,classCallCheck/* default */.Z)(this, DesktopPairing);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(DesktopPairing, [{
    key: "_inactive",
    value: function _inactive() {
      this.tag('Code').removeAllListeners('txLoaded');
      this._token = null;
    }
  }, {
    key: "labels",
    set: function set(value) {
      this.tag('Title').text.text = value.title;
      if (value.stepsCount && value.steps) {
        displaySteps(getSteps(this, 5), makeKeys(value.steps, value.stepsCount));
      }
    }
  }, {
    key: "steps",
    set: function set(value) {
      if (!value) {
        return;
      }
      displaySteps(getSteps(this, 5), value);
    }
  }, {
    key: "button",
    set: function set(value) {
      this.tag('Button').patch({
        label: value,
        visible: Boolean(value)
      });
      this._refocus();
    }
  }, {
    key: "w",
    get: function get() {
      return (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(DesktopPairing.prototype), "w", this);
    },
    set: function set(value) {
      _set((0,getPrototypeOf/* default */.Z)(DesktopPairing.prototype), "w", value, this, true);
      this.patch(desktopPairing_component_objectSpread({
        Title: {
          text: {
            wordWrapWidth: value
          }
        }
      }, makePatch(5, {
        w: value
      })));
    }
  }, {
    key: "token",
    set: function set(value) {
      if (value === this._token) {
        return;
      }
      this.tag('Code').text.text = value ? value.split('').join('  ') : '';
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      if (!this.tag('Button').visible) {
        return false;
      }
      this.signal(SELECTED_SIGNAL);
      return true;
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      var button = this.tag('Button');
      return button.visible ? button : undefined;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return desktopPairing_style_getInitialStyle();
    }
  }]);
  return DesktopPairing;
}(src_Lightning.Component);
// EXTERNAL MODULE: ./node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/browser.js
var browser = __webpack_require__(20061);
;// CONCATENATED MODULE: ./src/modules/tornado/pairing/mobile/mobilePairing.style.js

var _CODE_SIZE, _STEPS_MARGIN_LEFT, mobilePairing_style_STEPS_GAP;
function mobilePairing_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function mobilePairing_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? mobilePairing_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : mobilePairing_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }







var mobilePairing_style_defaultContext = makeDefaultStylingContext();
var mobilePairing_style_colors = {
  text: makeThemeColor(PRIMARY)
};
var CODE_SIZE = (_CODE_SIZE = {}, (0,defineProperty/* default */.Z)(_CODE_SIZE, HD, 208), (0,defineProperty/* default */.Z)(_CODE_SIZE, FULL_HD, 274), _CODE_SIZE);
var STEPS_MARGIN_LEFT = (_STEPS_MARGIN_LEFT = {}, (0,defineProperty/* default */.Z)(_STEPS_MARGIN_LEFT, HD, 32), (0,defineProperty/* default */.Z)(_STEPS_MARGIN_LEFT, FULL_HD, 40), _STEPS_MARGIN_LEFT);
var mobile_mobilePairing_style_STEPS_GAP = (mobilePairing_style_STEPS_GAP = {}, (0,defineProperty/* default */.Z)(mobilePairing_style_STEPS_GAP, HD, 24), (0,defineProperty/* default */.Z)(mobilePairing_style_STEPS_GAP, FULL_HD, 32), mobilePairing_style_STEPS_GAP);
var mobilePairing_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mobilePairing_style_defaultContext,
    _ref$screenSize = _ref.screenSize,
    screenSize = _ref$screenSize === void 0 ? FULL_HD : _ref$screenSize,
    _ref$colorMode = _ref.colorMode,
    colorMode = _ref$colorMode === void 0 ? DEFAULT_MODE : _ref$colorMode;
  var titleFont = src_getFont(constants_FONT.PARIS_2, screenSize);
  return {
    flex: {
      direction: 'column'
    },
    Title: {
      text: mobilePairing_style_objectSpread(mobilePairing_style_objectSpread({}, titleFont), {}, {
        textColor: mobilePairing_style_colors.text[colorMode],
        maxLines: 2,
        maxLinesSuffix: '...',
        verticalAlign: 'middle'
      }),
      flexItem: {
        marginBottom: 24
      }
    },
    Content: {
      flex: {
        direction: 'column'
      },
      CodeContainer: {
        flex: {
          direction: 'row'
        },
        Code: {
          w: CODE_SIZE[screenSize],
          h: CODE_SIZE[screenSize]
        },
        Steps: mobilePairing_style_objectSpread({
          flex: {
            direction: 'column'
          },
          flexItem: {
            marginLeft: STEPS_MARGIN_LEFT[screenSize]
          }
        }, makeStepsTemplate(5, {
          flexItem: {
            marginBottom: mobile_mobilePairing_style_STEPS_GAP[screenSize]
          }
        }))
      },
      Button: {
        flexItem: {
          marginTop: mobile_mobilePairing_style_STEPS_GAP[screenSize]
        },
        visible: false,
        type: Button,
        label: '',
        mountX: 0.5,
        x: middle
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/pairing/mobile/mobilePairing.component.js








function mobilePairing_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function mobilePairing_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? mobilePairing_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : mobilePairing_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function mobilePairing_component_createSuper(t) { var r = mobilePairing_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function mobilePairing_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (mobilePairing_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }






var MobilePairing = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(MobilePairing, _Lightning$Component);
  var _super = mobilePairing_component_createSuper(MobilePairing);
  function MobilePairing() {
    (0,classCallCheck/* default */.Z)(this, MobilePairing);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(MobilePairing, [{
    key: "_construct",
    value: function _construct() {
      this._style = mobilePairing_style_defaultContext;
    }
  }, {
    key: "_inactive",
    value: function _inactive() {
      this.tag('Code').removeAllListeners('txLoaded');
      this._token = null;
    }
  }, {
    key: "labels",
    set: function set(value) {
      this.tag('Title').text.text = value.title;
      displaySteps(getSteps(this, 5), makeKeys(value.steps, value.stepsCount));
    }
  }, {
    key: "button",
    set: function set(value) {
      this.tag('Button').patch({
        label: value,
        visible: Boolean(value)
      });
      this._refocus();
    }
  }, {
    key: "w",
    get: function get() {
      return (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(MobilePairing.prototype), "w", this);
    },
    set: function set(value) {
      _set((0,getPrototypeOf/* default */.Z)(MobilePairing.prototype), "w", value, this, true);
      var screenSize = this._style.screenSize;
      var stepsWidth = value - CODE_SIZE[screenSize] - STEPS_MARGIN_LEFT[screenSize];
      this.patch({
        Title: {
          text: {
            wordWrapWidth: value
          }
        },
        Content: {
          CodeContainer: {
            w: value,
            Steps: mobilePairing_component_objectSpread({
              w: stepsWidth
            }, makePatch(5, {
              w: stepsWidth
            }))
          }
        }
      });
    }
  }, {
    key: "url",
    set: function set(value) {
      var _this = this;
      if (value === this._token) {
        return;
      }
      this._token = value;
      var code = this.tag('Code');
      code.alpha = 0.0001;
      if (!value) {
        return;
      }
      code.once('txLoaded', function () {
        code.setSmooth('alpha', 1);
      });
      browser.toDataURL(value, {
        margin: 4,
        width: CODE_SIZE.HD
      }).then(function (dataUrl) {
        var texture = getSvgTexture(dataUrl, CODE_SIZE[_this._style.screenSize], CODE_SIZE[_this._style.screenSize]);
        code.texture = texture;
      });
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      if (!this.tag('Button').visible) {
        return false;
      }
      this.signal(SELECTED_SIGNAL);
      return true;
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      var button = this.tag('Button');
      return button.visible ? button : undefined;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return mobilePairing_style_getInitialStyle();
    }
  }]);
  return MobilePairing;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/tornado/spinner/customer/default/spinner.shader.js






function spinner_shader_createSuper(t) { var r = spinner_shader_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function spinner_shader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (spinner_shader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var spinner_shader_SpinnerShader = function (_Lightning$shaders$We) {
  (0,inherits/* default */.Z)(SpinnerShader, _Lightning$shaders$We);
  var _super = spinner_shader_createSuper(SpinnerShader);
  function SpinnerShader(ctx) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, SpinnerShader);
    _this = _super.call(this, ctx);
    _this._progress = 0.0;
    return _this;
  }
  (0,createClass/* default */.Z)(SpinnerShader, [{
    key: "progress",
    get: function get() {
      return this._progress;
    },
    set: function set(value) {
      this._progress = value;
      this.redraw();
    }
  }, {
    key: "useDefault",
    value: function useDefault() {
      return (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(SpinnerShader.prototype), "useDefault", this).call(this) && this._progress === 0.0;
    }
  }, {
    key: "setupUniforms",
    value: function setupUniforms(operation) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(SpinnerShader.prototype), "setupUniforms", this).call(this, operation);
      var gl = this.gl;
      this._setUniform('projection', this._getProjection(operation), gl.uniform2fv, false);
      this._setUniform('progress', this._progress, gl.uniform1f);
    }
  }, {
    key: "getExtraAttribBytesPerVertex",
    value: function getExtraAttribBytesPerVertex() {
      return 8;
    }
  }, {
    key: "enableAttribs",
    value: function enableAttribs() {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(SpinnerShader.prototype), "enableAttribs", this).call(this);
      this.gl.enableVertexAttribArray(this._attrib('aVertex'));
    }
  }, {
    key: "disableAttribs",
    value: function disableAttribs() {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(SpinnerShader.prototype), "disableAttribs", this).call(this);
      this.gl.disableVertexAttribArray(this._attrib('aVertex'));
    }
  }, {
    key: "setExtraAttribsInBuffer",
    value: function setExtraAttribsInBuffer(operation) {
      var offset = operation.extraAttribsDataByteOffset / 4;
      var floats = operation.quads.floats;
      var length = operation.length;
      for (var i = 0; i < length; i += 1) {
        floats[offset + 0] = 1;
        floats[offset + 1] = -1;
        floats[offset + 2] = 1;
        floats[offset + 3] = 1;
        floats[offset + 4] = -1;
        floats[offset + 5] = 1;
        floats[offset + 6] = -1;
        floats[offset + 7] = -1;
        offset += 8;
      }
    }
  }, {
    key: "beforeDraw",
    value: function beforeDraw(operation) {
      var gl = this.gl;
      gl.vertexAttribPointer(this._attrib('aVertex'), 2, gl.FLOAT, false, this.getExtraAttribBytesPerVertex(), this.getVertexAttribPointerOffset(operation));
    }
  }]);
  return SpinnerShader;
}(src_Lightning.shaders.WebGLDefaultShader);
spinner_shader_SpinnerShader.vertexShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n\n    attribute vec2 aVertexPosition;\n    attribute vec2 aVertex;\n    attribute vec4 aColor;\n\n    varying vec4 vColor;\n    varying vec2 vPosition;\n\n    uniform vec2 projection;\n\n    void main(void) {\n        gl_Position = vec4(aVertexPosition.x * projection.x - 1.0, aVertexPosition.y * -abs(projection.y) + 1.0, 0.0, 1.0);\n        gl_Position.y = -sign(projection.y) * gl_Position.y;\n\n        vPosition = aVertex;\n        vColor = aColor;\n    }\n";
spinner_shader_SpinnerShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n\n    #define PIx2 6.28318530718\n\n    varying vec4 vColor;\n    varying vec2 vPosition;\n\n    uniform float progress;\n\n    void main () {\n      float distance = sqrt(dot(vPosition, vPosition));\n      float externalRadius = 1.0;\n      float internalRadius = 0.86;\n\n      if (distance >= externalRadius || distance <= internalRadius) {\n        discard;\n      }\n\n      float angle = atan(vPosition.x, vPosition.y) / PIx2;\n      if (angle < 0.0) {\n        angle = 1.0 + angle;\n      }\n      angle = 1.0 - angle;\n      if (angle > progress) {\n        discard;\n      }\n\n      gl_FragColor = vColor;\n    }\n";
;// CONCATENATED MODULE: ./src/modules/tornado/spinner/customer/default/spinner.style.js

var color = makeThemeColor(SECONDARY);
var getSpinnerContainerAnimation = function getSpinnerContainerAnimation() {
  return {
    duration: 15,
    repeat: -1,
    stopMethod: 'immediate',
    actions: [{
      p: 'rotation',
      v: {
        0: {
          v: 0,
          sm: 0
        },
        1: {
          v: Math.PI * 2,
          sm: 0
        }
      }
    }]
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/spinner/customer/default/spinner.component.js





function spinner_component_createSuper(t) { var r = spinner_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function spinner_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (spinner_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }





var MAX_PROGRESS = 0.45;
var MIN_PROGRESS = 0.1;
var Spinner = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Spinner, _Lightning$Component);
  var _super = spinner_component_createSuper(Spinner);
  function Spinner() {
    (0,classCallCheck/* default */.Z)(this, Spinner);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Spinner, [{
    key: "_active",
    value: function _active() {
      this._rotationAnimation = this.animation(getSpinnerContainerAnimation());
      this._progressAnimation = this.tag('Inner').animation({
        duration: 1.2,
        repeat: -1,
        stopMethod: 'immediate',
        actions: [{
          p: 'shader.progress',
          v: {
            0: {
              v: MIN_PROGRESS
            },
            0.38: {
              v: MAX_PROGRESS
            },
            1: {
              v: MIN_PROGRESS
            }
          }
        }, {
          p: 'rotation',
          v: {
            0: {
              v: 0
            },
            1: {
              v: Math.PI * 2
            }
          }
        }]
      });
      this._rotationAnimation.start();
      this._progressAnimation.start();
    }
  }, {
    key: "_inactive",
    value: function _inactive() {
      if (this._rotationAnimation) {
        this._rotationAnimation.stop();
      }
      if (this._progressAnimation) {
        this._progressAnimation.stop();
      }
      this._rotationAnimation = null;
      this._progressAnimation = null;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return {
        Inner: {
          w: identity,
          h: identity,
          color: color[DEFAULT_MODE],
          rect: true,
          shader: {
            type: spinner_shader_SpinnerShader,
            progress: MIN_PROGRESS
          }
        }
      };
    }
  }]);
  return Spinner;
}(src_Lightning.Component);

;// CONCATENATED MODULE: ./src/modules/tornado/spinner/spinner.component.js

/* harmony default export */ const spinner_component = (Spinner);
;// CONCATENATED MODULE: ./src/modules/pairing/new/ssi/ssi.style.js

var ssi_style_TEXT_MARGIN, _BUTTONS_MARGIN, _SPINNER_SIZE;
function ssi_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ssi_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ssi_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ssi_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





var ssi_style_defaultContext = makeDefaultStylingContext();
var ssi_style_colors = {
  text: makeThemeColor(PRIMARY)
};
var ssi_ssi_style_TEXT_MARGIN = (ssi_style_TEXT_MARGIN = {}, (0,defineProperty/* default */.Z)(ssi_style_TEXT_MARGIN, HD, 8), (0,defineProperty/* default */.Z)(ssi_style_TEXT_MARGIN, FULL_HD, 8), ssi_style_TEXT_MARGIN);
var BUTTONS_MARGIN = (_BUTTONS_MARGIN = {}, (0,defineProperty/* default */.Z)(_BUTTONS_MARGIN, HD, 24), (0,defineProperty/* default */.Z)(_BUTTONS_MARGIN, FULL_HD, 32), _BUTTONS_MARGIN);
var SPINNER_SIZE = (_SPINNER_SIZE = {}, (0,defineProperty/* default */.Z)(_SPINNER_SIZE, HD, 32), (0,defineProperty/* default */.Z)(_SPINNER_SIZE, FULL_HD, 32), _SPINNER_SIZE);
var ssi_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ssi_style_defaultContext,
    _ref$screenSize = _ref.screenSize,
    screenSize = _ref$screenSize === void 0 ? FULL_HD : _ref$screenSize,
    _ref$colorMode = _ref.colorMode,
    colorMode = _ref$colorMode === void 0 ? DEFAULT_MODE : _ref$colorMode;
  return {
    flex: {
      direction: 'column'
    },
    Title: {
      text: ssi_style_objectSpread(ssi_style_objectSpread({}, src_getFont(constants_FONT.PARIS_2, screenSize)), {}, {
        textColor: ssi_style_colors.text[colorMode]
      }),
      flexItem: {
        marginBottom: ssi_ssi_style_TEXT_MARGIN[screenSize]
      }
    },
    Description: {
      text: ssi_style_objectSpread(ssi_style_objectSpread({}, src_getFont(constants_FONT.OTTAWA_1, screenSize)), {}, {
        textColor: ssi_style_colors.text[colorMode]
      })
    },
    Buttons: {
      flexItem: {
        marginTop: BUTTONS_MARGIN[screenSize]
      },
      flex: {
        alignItems: 'center',
        justifyContent: 'center',
        direction: 'row'
      },
      Accept: {
        flexItem: {
          marginRight: BUTTONS_MARGIN[screenSize]
        }
      },
      Decline: {}
    },
    Spinner: {
      visible: false,
      w: SPINNER_SIZE[screenSize],
      h: SPINNER_SIZE[screenSize],
      x: middle,
      mountX: 0.5,
      flexItem: {
        marginTop: BUTTONS_MARGIN[screenSize]
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/pairing/new/ssi/ssi.component.js







function ssi_component_createSuper(t) { var r = ssi_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function ssi_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (ssi_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }






var SSIPairing = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(SSIPairing, _Lightning$Component);
  var _super = ssi_component_createSuper(SSIPairing);
  function SSIPairing() {
    (0,classCallCheck/* default */.Z)(this, SSIPairing);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(SSIPairing, [{
    key: "_construct",
    value: function _construct() {
      this._index = 0;
    }
  }, {
    key: "w",
    get: function get() {
      return (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(SSIPairing.prototype), "w", this);
    },
    set: function set(value) {
      _set((0,getPrototypeOf/* default */.Z)(SSIPairing.prototype), "w", value, this, true);
      this.patch({
        Title: {
          text: {
            wordWrapWidth: value
          }
        },
        Description: {
          text: {
            wordWrapWidth: value
          }
        },
        Buttons: {
          w: value
        }
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.patch({
        Buttons: {
          visible: true
        },
        Spinner: {
          visible: false
        }
      });
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this._index = 0;
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this.tag('Buttons').children[this._index];
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      var buttons = this.tag('Buttons');
      if (buttons.visible) {
        buttons.visible = false;
        this.tag('Spinner').visible = true;
        this.signal('accept');
      }
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Title: {
          text: {
            text: t('pairing.token.magenta.title')
          }
        },
        Buttons: {
          Accept: {
            type: Button,
            label: t('pairing.token.magenta.accept')
          },
          Decline: {
            type: Button
          }
        },
        Spinner: {
          type: spinner_component
        }
      }, ssi_style_getInitialStyle());
    }
  }]);
  return SSIPairing;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/pairing/new/pairing.style.js

var pairing_style_LOGO_HEIGHT, pairing_style_ICON_MARGIN_BOTTOM;
function pairing_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function pairing_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? pairing_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : pairing_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





var pairing_style_defaultContext = makeDefaultStylingContext();
var pairing_style_colors = {
  background: makeThemeColor(TERTIARY),
  separator: makeThemeColor(PRIMARY, 0.3)
};

var new_pairing_style_LOGO_HEIGHT = (pairing_style_LOGO_HEIGHT = {}, (0,defineProperty/* default */.Z)(pairing_style_LOGO_HEIGHT, HD, 96), (0,defineProperty/* default */.Z)(pairing_style_LOGO_HEIGHT, FULL_HD, 152), pairing_style_LOGO_HEIGHT);
var pairing_style_ICON_MARGIN_TOP = pairing_style_objectSpread({}, safetyMargins.vertical);
var new_pairing_style_ICON_MARGIN_BOTTOM = (pairing_style_ICON_MARGIN_BOTTOM = {}, (0,defineProperty/* default */.Z)(pairing_style_ICON_MARGIN_BOTTOM, HD, 24), (0,defineProperty/* default */.Z)(pairing_style_ICON_MARGIN_BOTTOM, FULL_HD, 24), pairing_style_ICON_MARGIN_BOTTOM);
var pairing_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : pairing_style_defaultContext,
    _ref$screenSize = _ref.screenSize,
    screenSize = _ref$screenSize === void 0 ? FULL_HD : _ref$screenSize,
    _ref$colorMode = _ref.colorMode,
    colorMode = _ref$colorMode === void 0 ? DEFAULT_MODE : _ref$colorMode;
  var top = pairing_style_ICON_MARGIN_TOP[screenSize] + new_pairing_style_LOGO_HEIGHT[screenSize] + new_pairing_style_ICON_MARGIN_BOTTOM[screenSize];
  var containerHeight = sizes_SCREEN_HEIGHT[screenSize] - top - safetyMargins.vertical[screenSize];
  var rightWidth = SCREEN_WIDTH[screenSize] - safetyMargins.horizontal[screenSize] * 2 - selector_pairingSelector_style_WIDTH[screenSize] - SPACER[screenSize];
  return {
    w: SCREEN_WIDTH[screenSize],
    h: sizes_SCREEN_HEIGHT[screenSize],
    Background: {
      w: SCREEN_WIDTH[screenSize],
      h: sizes_SCREEN_HEIGHT[screenSize],
      color: pairing_style_colors.background[colorMode]
    },
    CustomerIcon: {
      y: pairing_style_ICON_MARGIN_TOP[screenSize],
      mountX: 0.5,
      x: middle,
      h: new_pairing_style_LOGO_HEIGHT[screenSize]
    },
    Left: {
      y: top,
      h: containerHeight
    },
    Right: {
      x: safetyMargins.horizontal[screenSize] + selector_pairingSelector_style_WIDTH[screenSize] + SPACER[screenSize],
      y: top,
      h: containerHeight,
      w: rightWidth,
      Mobile: {
        visible: false,
        h: containerHeight,
        w: rightWidth
      },
      Desktop: {
        visible: false,
        h: containerHeight,
        w: rightWidth
      },
      SSI: {
        visible: false,
        w: rightWidth
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/pairing/new/pairing.connector.js



var pairing_connector_mapControllers = function mapControllers(instance) {
  return [{
    selector: getPollingInterval,
    callback: function callback(value) {
      instance.pollingInterval = value;
    }
  }, {
    selector: getDeepLink,
    callback: function callback(value) {
      instance.deeplink = value;
    }
  }, {
    selector: getPairingStatus,
    callback: function callback(value) {
      instance.pairingStatus = value;
    }
  }, {
    selector: getPairingToken,
    callback: function callback(value) {
      instance.token = value;
    }
  }, {
    selector: getPairingURI,
    callback: function callback(value) {
      instance.url = value;
    }
  }];
};
/* harmony default export */ const pairing_connector = (lightningjs_redux.control(pairing_connector_mapControllers));
;// CONCATENATED MODULE: ./src/modules/pairing/new/pairing.component.js













function pairing_component_createSuper(t) { var r = pairing_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function pairing_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (pairing_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

























var Pairing = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Pairing, _Lightning$Component);
  var _super = pairing_component_createSuper(Pairing);
  function Pairing() {
    (0,classCallCheck/* default */.Z)(this, Pairing);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Pairing, [{
    key: "_construct",
    value: function _construct() {
      this._style = pairing_style_defaultContext;
      this._focusedButton = 0;
      this._setState('Left');
      this._pairingIntervalId = null;
      this._tokenTimeout = null;
      this._pollingInterval = 10000;
      this._ssiCompletion = false;
    }
  }, {
    key: "_build",
    value: function _build() {
      var shouldDisplaySSI = hasSSISupport();
      this._views = [shouldDisplaySSI ? 'SSI' : '', 'Mobile', 'Desktop'].filter(Boolean);
      this.tag('Left').buttons = [shouldDisplaySSI && {
        label: t('pairing.token.magenta.button'),
        iconLeft: 'Television',
        iconRight: 'ArrowRight'
      }, {
        label: t('pairing.token.mobile.button'),
        iconLeft: 'QRCode',
        iconRight: 'ArrowRight'
      }, {
        label: t('pairing.token.computer.button'),
        iconLeft: 'Laptop',
        iconRight: 'ArrowRight'
      }].filter(Boolean);
      this.tag(this._views[0]).visible = true;
    }
  }, {
    key: "_active",
    value: function _active() {
      removeSplashScreen();
      this._ssiCompletion = false;
      this._unsubscribe = pairing_connector(this);
      this._requestNewPairingCode();
      this._pairingIntervalId = setInterval(function () {
        return lightningjs_redux.dispatch(pairing_actions_getStatus());
      }, this._pollingInterval);
    }
  }, {
    key: "_inactive",
    value: function _inactive() {
      this._clearTokenTimeout();
      this._clearPairingInterval();
      if (this._unsubscribe) {
        this._unsubscribe();
        this._unsubscribe = null;
      }
      lightningjs_redux.dispatch(clearPairingToken());
    }
  }, {
    key: "_switchViews",
    value: function _switchViews(index) {
      var _this = this;
      this._views.forEach(function (view, i) {
        _this.tag(view).visible = i === index;
      });
    }
  }, {
    key: "_handleAccept",
    value: function () {
      var _handleAccept2 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee() {
        var _yield$getSingleSignI, status, token;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this._ssiCompletion = true;
              _context.prev = 1;
              _context.next = 4;
              return getStatus();
            case 4:
              _yield$getSingleSignI = _context.sent;
              status = _yield$getSingleSignI.status;
              token = _yield$getSingleSignI.token;
              if (!status.displayTos) {
                _context.next = 11;
                break;
              }
              navigateTo('ssi');
              _context.next = 16;
              break;
            case 11:
              _context.next = 13;
              return exchangePlatformToken(token);
            case 13:
              _context.next = 15;
              return lightningjs_redux.dispatch(getCurrentPairedUser());
            case 15:
              this._completePairing();
            case 16:
              _context.next = 22;
              break;
            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](1);
              lightningjs_redux.dispatch(showPopupAction(FATAL_ERROR_POPUP_ID, {
                routeBackOnClose: false,
                exitAppOnClose: false
              }));
              this.tag('SSI').reset();
            case 22:
              this._ssiCompletion = false;
            case 23:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 18]]);
      }));
      function _handleAccept() {
        return _handleAccept2.apply(this, arguments);
      }
      return _handleAccept;
    }()
  }, {
    key: "_requestNewPairingCode",
    value: function _requestNewPairingCode() {
      lightningjs_redux.dispatch(fetchToken());
      lightningjs_redux.dispatch(disableProfileAutoSelect());
    }
  }, {
    key: "_clearTokenTimeout",
    value: function _clearTokenTimeout() {
      if (this._tokenTimeout) {
        clearTimeout(this._tokenTimeout);
      }
    }
  }, {
    key: "_clearPairingInterval",
    value: function _clearPairingInterval() {
      if (this._pairingIntervalId) {
        clearInterval(this._pairingIntervalId);
      }
      this._pairingIntervalId = null;
    }
  }, {
    key: "_completePairing",
    value: function _completePairing() {
      setPairingMethod(PAIRING_METHOD.PAIRING);
      lightningjs_redux.dispatch(clearCache());
      lightningjs_redux.dispatch(fetchNavigation());
      console.log("[Pairing] Moving to deeplink: ".concat(this._deeplink));
      navigateTo(this._deeplink || HOME_PATH, false);
    }
  }, {
    key: "pollingInterval",
    set: function set(value) {
      this._pollingInterval = value;
      if (this._pairingIntervalId) {
        this._clearPairingInterval();
        this._pairingIntervalId = setInterval(function () {
          return lightningjs_redux.dispatch(pairing_actions_getStatus());
        }, this._pollingInterval);
      }
    }
  }, {
    key: "deeplink",
    set: function set(value) {
      this._deeplink = value;
      console.log("[Pairing] Deeplink set: ".concat(this._deeplink));
    }
  }, {
    key: "token",
    set: function set(value) {
      if (!value) return;
      this._clearTokenTimeout();
      this._tokenTimeout = setTimeout(function () {
        return Router.back();
      }, src.pairing.pairingTimeout);
      this.tag('Desktop').token = value;
    }
  }, {
    key: "url",
    set: function set(value) {
      this.tag('Mobile').url = value;
    }
  }, {
    key: "pairingStatus",
    set: function set(status) {
      if (this._ssiCompletion) {
        return;
      }
      if (status === PAIRING_STATUS_PAIRED) {
        this._completePairing();
      }
    }
  }, {
    key: "_handleBack",
    value: function _handleBack() {
      sendEvent({
        key: 'pressTokenBackButton'
      });
      return false;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Background: {
          rect: true
        },
        CustomerIcon: {
          type: BrandIcon
        },
        Left: {
          type: PairingSelector,
          labels: {
            title: t('pairing.token.connect')
          },
          signals: (0,defineProperty/* default */.Z)({}, SELECTED_SIGNAL, '_switchViews')
        },
        Right: {
          SSI: {
            type: SSIPairing,
            signals: {
              accept: '_handleAccept'
            }
          },
          Mobile: {
            type: MobilePairing,
            labels: {
              title: t('pairing.token.synchRedirection'),
              steps: 'pairing.token.mobile.steps.step',
              stepsCount: 2
            }
          },
          Desktop: {
            type: DesktopPairing,
            labels: {
              title: t('pairing.token.synchRedirection'),
              steps: 'pairing.token.computer.steps.step',
              stepsCount: 3
            }
          }
        }
      }, pairing_style_getInitialStyle());
    }
  }, {
    key: "_states",
    value: function _states() {
      return [function (_this2) {
        (0,inherits/* default */.Z)(Left, _this2);
        var _super2 = pairing_component_createSuper(Left);
        function Left() {
          (0,classCallCheck/* default */.Z)(this, Left);
          return _super2.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(Left, [{
          key: "_getFocused",
          value: function _getFocused() {
            return this.tag('Left');
          }
        }, {
          key: "_handleRight",
          value: function _handleRight() {
            if (hasSSISupport()) {
              this._setState('Right');
              return true;
            }
            return false;
          }
        }]);
        return Left;
      }(this), function (_this3) {
        (0,inherits/* default */.Z)(Right, _this3);
        var _super3 = pairing_component_createSuper(Right);
        function Right() {
          (0,classCallCheck/* default */.Z)(this, Right);
          return _super3.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(Right, [{
          key: "_getFocused",
          value: function _getFocused() {
            var _this4 = this;
            return this._views.map(function (id) {
              return _this4.tag(id);
            }).find(function (view) {
              return view.visible;
            });
          }
        }, {
          key: "_handleLeft",
          value: function _handleLeft() {
            if (this._ssiCompletion) {
              return false;
            }
            this._setState('Left');
            return true;
          }
        }]);
        return Right;
      }(this)];
    }
  }]);
  return Pairing;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/pairing/customer/rtlde/pairing.component.js

;// CONCATENATED MODULE: ./src/modules/pairing/pairing.component.js

;// CONCATENATED MODULE: ./src/modules/landing/landing.connector.js


var landing_connector_mapControllers = function mapControllers(instance) {
  return [{
    selector: getIsUnpairedEntering,
    callback: function callback(value) {
      instance.isUnpairedEntering = value;
    },
    shouldBeInvokedOnConnect: true
  }];
};
/* harmony default export */ const landing_connector = (lightningjs_redux.control(landing_connector_mapControllers));
;// CONCATENATED MODULE: ./src/modules/landing/landingButtons/landingButtons.style.js

var landingButtons_style_GAP, _MIN_BUTTON_WIDTH;

var landingButtons_landingButtons_style_GAP = (landingButtons_style_GAP = {}, (0,defineProperty/* default */.Z)(landingButtons_style_GAP, HD, 16), (0,defineProperty/* default */.Z)(landingButtons_style_GAP, FULL_HD, 16), landingButtons_style_GAP);
var MIN_BUTTON_WIDTH = (_MIN_BUTTON_WIDTH = {}, (0,defineProperty/* default */.Z)(_MIN_BUTTON_WIDTH, HD, 175), (0,defineProperty/* default */.Z)(_MIN_BUTTON_WIDTH, FULL_HD, 175), _MIN_BUTTON_WIDTH);
;// CONCATENATED MODULE: ./src/modules/landing/landingButtons/customer/rtlde/landingButtons.constants.js
var DIRECTION = 'column';
;// CONCATENATED MODULE: ./src/modules/landing/landingButtons/landingButtons.constants.js





var ENTER = {
  id: 'Enter',
  label: 'pairing.landing.enter',
  action: function action() {
    console.log('[Landing] Handling ENTER action');
    navigateTo(HOME_PATH);
    lightningjs_redux.dispatch(setUnpairedEntering());
  },
  event: function event() {}
};
var SIGN_ON = {
  id: 'SignOnButton',
  label: 'pairing.landing.signOn',
  ref: 'SignOnButton',
  action: function action() {
    return navigateToExpiredSubscriptionPage();
  },
  event: function event() {
    return sendEvent({
      key: 'pressSubscribeButton'
    });
  }
};
var SIGN_IN = {
  id: 'SignInButton',
  label: 'pairing.landing.signIn',
  action: function action() {
    return navigateTo(PAIRING_PATH);
  },
  event: function event() {
    return sendEvent({
      key: 'pressConnectButton'
    });
  }
};
;// CONCATENATED MODULE: ./src/modules/landing/landingButtons/customer/rtlde/landingButtons.provider.js

var buttons = [SIGN_IN, SIGN_ON];
;// CONCATENATED MODULE: ./src/modules/landing/landingButtons/landingButtons.component.js








function landingButtons_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function landingButtons_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? landingButtons_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : landingButtons_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function landingButtons_component_createSuper(t) { var r = landingButtons_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function landingButtons_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (landingButtons_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }








var LandingButtons = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(LandingButtons, _Lightning$Component);
  var _super = landingButtons_component_createSuper(LandingButtons);
  function LandingButtons() {
    (0,classCallCheck/* default */.Z)(this, LandingButtons);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(LandingButtons, [{
    key: "_construct",
    value: function _construct() {
      this._index = 0;
    }
  }, {
    key: "_build",
    value: function _build() {
      var screenSize = sizes_getScreenSize();
      var isRow = DIRECTION === 'row';
      this.children.forEach(function (child) {
        child.flexItem = isRow ? {
          marginRight: landingButtons_landingButtons_style_GAP[screenSize]
        } : {
          marginBottom: landingButtons_landingButtons_style_GAP[screenSize]
        };
        if (!isRow) {
          child.minWidth = MIN_BUTTON_WIDTH[screenSize];
        }
      });
      this.h = this.children.length * (HEIGHT[screenSize] + landingButtons_landingButtons_style_GAP[screenSize]) - landingButtons_landingButtons_style_GAP[screenSize];
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this.children[this._index];
    }
  }, {
    key: "_handleLeft",
    value: function _handleLeft() {
      if (DIRECTION === 'column') {
        return false;
      }
      if (this._index > 0) {
        this._index -= 1;
        return true;
      }
      return false;
    }
  }, {
    key: "_handleRight",
    value: function _handleRight() {
      if (DIRECTION === 'column') {
        return false;
      }
      if (this._index < this.children.length - 1) {
        this._index = +1;
        return true;
      }
      return false;
    }
  }, {
    key: "_handleUp",
    value: function _handleUp() {
      if (DIRECTION === 'row') {
        return false;
      }
      if (this._index > 0) {
        this._index -= 1;
        return true;
      }
      return false;
    }
  }, {
    key: "_handleDown",
    value: function _handleDown() {
      if (DIRECTION === 'row') {
        return false;
      }
      if (this._index < this.children.length - 1) {
        this._index = +1;
        return true;
      }
      return false;
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      buttons[this._index].action();
      buttons[this._index].event();
    }
  }], [{
    key: "_template",
    value: function _template() {
      return landingButtons_component_objectSpread({
        flex: {
          direction: DIRECTION
        }
      }, buttons.reduce(function (result, _ref) {
        var id = _ref.id,
          label = _ref.label;
        return landingButtons_component_objectSpread(landingButtons_component_objectSpread({}, result), {}, (0,defineProperty/* default */.Z)({}, id, {
          type: Button,
          label: t(label)
        }));
      }, {}));
    }
  }]);
  return LandingButtons;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/landing/customer/rtlde/landing.constants.js

var _WORD_WRAP_WIDTH, landing_constants_PADDING_TOP;




var landing_constants_LOGO_ICON = (/* unused pure expression or super */ null && (customerServiceIcon));
var landing_constants_LOGO_ICON_SCALE = 1;
var CATCH_PHRASE_MAX_LINES = 2;
var CATCH_PHRASE_FONT = constants_FONT.TOKYO_4;
var CATCH_PHRASE_FONT_TYPE = FONT_TYPE.MAIN;
var WORD_WRAP_WIDTH = (_WORD_WRAP_WIDTH = {}, (0,defineProperty/* default */.Z)(_WORD_WRAP_WIDTH, HD, Math.round(SCREEN_WIDTH[HD] * 0.775)), (0,defineProperty/* default */.Z)(_WORD_WRAP_WIDTH, FULL_HD, Math.round(SCREEN_WIDTH[FULL_HD] * 0.775)), _WORD_WRAP_WIDTH);
var rtlde_landing_constants_PADDING_TOP = (landing_constants_PADDING_TOP = {}, (0,defineProperty/* default */.Z)(landing_constants_PADDING_TOP, HD, 0), (0,defineProperty/* default */.Z)(landing_constants_PADDING_TOP, FULL_HD, 0), landing_constants_PADDING_TOP);
var JUSTIFY_CONTENT = 'center';
;// CONCATENATED MODULE: ./src/modules/landing/landing.constants.js

;// CONCATENATED MODULE: ./src/images/customer/rtlde/landing-background-HD.jpg
const landing_background_HD_namespaceObject = __webpack_require__.p + "static/media/landing-background-HD.8219ed5c.jpg";
;// CONCATENATED MODULE: ./src/images/customer/rtlde/landing-background-FULL_HD.jpg
const landing_background_FULL_HD_namespaceObject = __webpack_require__.p + "static/media/landing-background-FULL_HD.62473114.jpg";
;// CONCATENATED MODULE: ./src/modules/landing/customer/rtlde/landing.utils.js





var shouldNavigateToSingleSignIn = function () {
  var _ref = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee() {
    var _yield$getSingleSignI, status;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!shouldSkipSSI()) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return", false);
        case 2:
          _context.prev = 2;
          _context.next = 5;
          return getStatus();
        case 5:
          _yield$getSingleSignI = _context.sent;
          status = _yield$getSingleSignI.status;
          return _context.abrupt("return", status.displayTos);
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", false);
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 10]]);
  }));
  return function shouldNavigateToSingleSignIn() {
    return _ref.apply(this, arguments);
  };
}();
;// CONCATENATED MODULE: ./src/modules/landing/landing.utils.js









var getBackgroundUrl = function getBackgroundUrl(screenSize) {
  var resolution = screenSize || sizes_getScreenSize();
  var imageId = get_default()((src_default()), 'customMedia.landingImage');
  if (imageId) {
    return imageService.getUrl(imageId, SCREEN_WIDTH[screenSize], sizes_SCREEN_HEIGHT[screenSize], {
      fit: IMAGE_FIT_SCALE_CROP,
      quality: IMAGE_QUALITY,
      format: DEFAULT_IMAGE_FORMAT,
      interlace: 1
    });
  }
  return getFullPath(resolution === HD ? landing_background_HD_namespaceObject : landing_background_FULL_HD_namespaceObject);
};
;// CONCATENATED MODULE: ./src/modules/landing/landing.style.js

var landing_style_PADDING_LEFT, landing_style_LOGO_HEIGHT, landing_style_LOGO_MARGIN_BOTTOM, _TEXT_MARGIN_BOTTOM, _TEXT_MARGIN_TOP, _BUTTONS_MARGIN_TOP;
function landing_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function landing_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? landing_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : landing_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






var landing_style_defaultContext = makeDefaultStylingContext();

var landing_landing_style_PADDING_LEFT = (landing_style_PADDING_LEFT = {}, (0,defineProperty/* default */.Z)(landing_style_PADDING_LEFT, HD, 64), (0,defineProperty/* default */.Z)(landing_style_PADDING_LEFT, FULL_HD, 80), landing_style_PADDING_LEFT);
var landing_landing_style_LOGO_HEIGHT = (landing_style_LOGO_HEIGHT = {}, (0,defineProperty/* default */.Z)(landing_style_LOGO_HEIGHT, HD, 152), (0,defineProperty/* default */.Z)(landing_style_LOGO_HEIGHT, FULL_HD, 152), landing_style_LOGO_HEIGHT);
var landing_landing_style_LOGO_MARGIN_BOTTOM = (landing_style_LOGO_MARGIN_BOTTOM = {}, (0,defineProperty/* default */.Z)(landing_style_LOGO_MARGIN_BOTTOM, HD, 0), (0,defineProperty/* default */.Z)(landing_style_LOGO_MARGIN_BOTTOM, FULL_HD, 0), landing_style_LOGO_MARGIN_BOTTOM);
var landing_style_TEXT_MARGIN_BOTTOM = (_TEXT_MARGIN_BOTTOM = {}, (0,defineProperty/* default */.Z)(_TEXT_MARGIN_BOTTOM, HD, 16), (0,defineProperty/* default */.Z)(_TEXT_MARGIN_BOTTOM, FULL_HD, 16), _TEXT_MARGIN_BOTTOM);
var TEXT_MARGIN_TOP = (_TEXT_MARGIN_TOP = {}, (0,defineProperty/* default */.Z)(_TEXT_MARGIN_TOP, HD, 32), (0,defineProperty/* default */.Z)(_TEXT_MARGIN_TOP, FULL_HD, 64), _TEXT_MARGIN_TOP);
var BUTTONS_MARGIN_TOP = (_BUTTONS_MARGIN_TOP = {}, (0,defineProperty/* default */.Z)(_BUTTONS_MARGIN_TOP, HD, 32), (0,defineProperty/* default */.Z)(_BUTTONS_MARGIN_TOP, FULL_HD, 64), _BUTTONS_MARGIN_TOP);
var getLogoViewBox = function getLogoViewBox(screenSize) {
  return {
    h: landing_landing_style_LOGO_HEIGHT[screenSize]
  };
};
var landing_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : landing_style_defaultContext;
  var _context$screenSize = context.screenSize,
    screenSize = _context$screenSize === void 0 ? FULL_HD : _context$screenSize;
  var wordWrapWidth = WORD_WRAP_WIDTH[screenSize];
  return {
    Root: {
      visible: false,
      w: SCREEN_WIDTH[screenSize],
      h: sizes_SCREEN_HEIGHT[screenSize],
      Background: {
        w: SCREEN_WIDTH[screenSize],
        h: sizes_SCREEN_HEIGHT[screenSize],
        src: getBackgroundUrl(screenSize),
        alpha: 0.001,
        scale: 1.05,
        zIndex: 1
      },
      Overlay: {
        w: identity,
        h: identity,
        zIndex: 2
      },
      Content: {
        x: landing_landing_style_PADDING_LEFT[screenSize],
        h: sizes_SCREEN_HEIGHT[screenSize],
        y: rtlde_landing_constants_PADDING_TOP[screenSize],
        flex: {
          justifyContent: JUSTIFY_CONTENT,
          direction: 'column'
        },
        zIndex: 3,
        Logo: {
          h: landing_landing_style_LOGO_HEIGHT[screenSize],
          textureScale: landing_constants_LOGO_ICON_SCALE,
          flexItem: {
            marginBottom: landing_landing_style_LOGO_MARGIN_BOTTOM[screenSize]
          }
        },
        CatchPhrase: {
          text: landing_style_objectSpread(landing_style_objectSpread({}, src_getFont(CATCH_PHRASE_FONT, screenSize, CATCH_PHRASE_FONT_TYPE)), {}, {
            maxLines: CATCH_PHRASE_MAX_LINES,
            textOverflow: '...',
            wordWrapWidth: wordWrapWidth
          }),
          flexItem: {
            marginTop: TEXT_MARGIN_TOP[screenSize],
            marginBottom: landing_style_TEXT_MARGIN_BOTTOM[screenSize]
          }
        },
        Description: {
          text: landing_style_objectSpread(landing_style_objectSpread({}, src_getFont(constants_FONT.KINSHASA_3, screenSize)), {}, {
            maxLines: 3,
            wordWrapWidth: wordWrapWidth
          }),
          flexItem: {
            marginBottom: landing_style_TEXT_MARGIN_BOTTOM[screenSize]
          }
        },
        Pricing: {
          text: landing_style_objectSpread(landing_style_objectSpread({}, src_getFont(constants_FONT.OTTAWA_2, screenSize)), {}, {
            maxLines: 3,
            wordWrapWidth: wordWrapWidth
          })
        },
        Buttons: {
          flexItem: {
            marginTop: BUTTONS_MARGIN_TOP[screenSize]
          }
        }
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/landing/landing.component.js








function landing_component_createSuper(t) { var r = landing_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function landing_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (landing_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }













var Landing = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Landing, _Lightning$Component);
  var _super = landing_component_createSuper(Landing);
  function Landing() {
    (0,classCallCheck/* default */.Z)(this, Landing);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Landing, [{
    key: "_build",
    value: function _build() {
      var background = this.tag('Background');
      background.once('txLoaded', function () {
        background.setSmooth('alpha', 1);
        background.setSmooth('scale', 1, {
          duration: 0.5
        });
      });
    }
  }, {
    key: "_attach",
    value: function _attach() {
      lightningjs_redux.dispatch(landingShown());
    }
  }, {
    key: "_active",
    value: function () {
      var _active2 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee() {
        var proceedWithSSI;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return shouldNavigateToSingleSignIn();
            case 2:
              proceedWithSSI = _context.sent;
              removeSplashScreen();
              if (proceedWithSSI) {
                navigateTo(SSI_PATH);
              } else {
                this.tag('Root').visible = true;
                this._unsubscribe = landing_connector(this);
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function _active() {
        return _active2.apply(this, arguments);
      }
      return _active;
    }()
  }, {
    key: "_inactive",
    value: function _inactive() {
      if (this._unsubscribe) {
        this._unsubscribe();
        this._unsubscribe = null;
      }
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this.tag('Background').removeAllListeners('txLoaded');
    }
  }, {
    key: "isUnpairedEntering",
    set: function set(value) {
      var text = value ? t('pairing.landing.connect') : t('pairing.landing.pricing');
      this.tag('Pricing').text.text = text;
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this.tag('Buttons');
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Root: {
          Background: {},
          Overlay: {
            type: HeroOverlay
          },
          Content: {
            Logo: {
              type: BrandIcon,
              testId: 'CustomerLogo'
            },
            CatchPhrase: {
              text: {
                text: t('pairing.landing.catchPhrase')
              }
            },
            Description: {
              text: {
                text: t('pairing.landing.description')
              }
            },
            Pricing: {
              text: {
                text: t('pairing.landing.pricing')
              }
            },
            Buttons: {
              type: LandingButtons
            }
          }
        },
        testId: 'Landing'
      }, landing_style_getInitialStyle());
    }
  }]);
  return Landing;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/routes/hooks/customer/rtlde/beforeEachRoute.hook.js


var beforeEachRoute_hook_beforeEachRoute = function beforeEachRoute() {
  return Promise.resolve(true);
};
;// CONCATENATED MODULE: ./src/modules/routes/hooks/beforeEachRoute.hook.js

;// CONCATENATED MODULE: ./src/modules/routes/hooks/afterEachRoute.hook.js






var afterEachRoute_hook_afterEachRoute = function afterEachRoute(destination) {
  var url = get_default()(destination, 'url', '');
  if (url && HISTORY_CLEANUP_PAGES.includes(url)) {
    Router.setHistory([]);
  }
  sendPageView(destination.url);
  sendPrintEvent('ViewContent');
};
;// CONCATENATED MODULE: ./src/modules/user/account/account.connector.js



var account_connector_mapControllers = function mapControllers(instance) {
  return {
    layoutNavigation: {
      selector: getLayoutNavigation,
      shouldBeInvokedOnConnect: true,
      callback: function callback(value) {
        instance.navigation = value;
      }
    },
    profileUsername: {
      selector: getProfileUsername,
      shouldBeInvokedOnConnect: true,
      callback: function callback(value) {
        instance.profileUsername = value;
      }
    },
    profileSelected: {
      selector: user_selectors_getSelectedProfile,
      shouldBeInvokedOnConnect: true,
      callback: function callback(value) {
        instance.selectedProfile = value;
      }
    },
    profilePhotoId: {
      selector: getProfilePhotoId,
      shouldBeInvokedOnConnect: true,
      callback: function callback(value) {
        instance.profilePhotoId = value;
      }
    }
  };
};
/* harmony default export */ const account_connector = (lightningjs_redux.control(account_connector_mapControllers));
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/mosaicGrid/mosaicGrid.constant.js

var mosaicGrid_constant_CONTENT_GAP;

var mosaicGrid_mosaicGrid_constant_CONTENT_GAP = (mosaicGrid_constant_CONTENT_GAP = {}, (0,defineProperty/* default */.Z)(mosaicGrid_constant_CONTENT_GAP, HD, 16), (0,defineProperty/* default */.Z)(mosaicGrid_constant_CONTENT_GAP, FULL_HD, 24), mosaicGrid_constant_CONTENT_GAP);
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/mosaicGrid/mosaicGrid.style.js

var mosaicGrid_style_ITEMS_PER_ROW;


var mosaicGrid_style_defaultContext = makeDefaultStylingContext();
var mosaicGrid_mosaicGrid_style_ITEMS_PER_ROW = (mosaicGrid_style_ITEMS_PER_ROW = {}, (0,defineProperty/* default */.Z)(mosaicGrid_style_ITEMS_PER_ROW, HD, 3), (0,defineProperty/* default */.Z)(mosaicGrid_style_ITEMS_PER_ROW, FULL_HD, 4), mosaicGrid_style_ITEMS_PER_ROW);
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/mosaicGrid/mosaicGrid.component.js







function mosaicGrid_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function mosaicGrid_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? mosaicGrid_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : mosaicGrid_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function mosaicGrid_component_createSuper(t) { var r = mosaicGrid_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function mosaicGrid_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (mosaicGrid_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }




var MosaicGrid = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(MosaicGrid, _Lightning$Component);
  var _super = mosaicGrid_component_createSuper(MosaicGrid);
  function MosaicGrid() {
    (0,classCallCheck/* default */.Z)(this, MosaicGrid);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(MosaicGrid, [{
    key: "_init",
    value: function _init() {
      this._index = 0;
      this._items = [];
      this._itemsPerRow = 0;
      this._style = mosaicGrid_style_defaultContext;
      this._contentGap = mosaicGrid_mosaicGrid_constant_CONTENT_GAP[this._style.screenSize];
    }
  }, {
    key: "data",
    set: function set(value) {
      var _this = this;
      var items = value.items,
        itemType = value.itemType,
        itemSize = value.itemSize;
      this._items = items;
      this._itemsPerRow = mosaicGrid_mosaicGrid_style_ITEMS_PER_ROW[this._style.screenSize];
      var currentItemsCount = this.items.length;
      if (currentItemsCount === items.length) {
        return;
      }
      this.tag('Items').children = items.map(function (item, index) {
        return mosaicGrid_component_objectSpread(mosaicGrid_component_objectSpread({
          item: item,
          type: itemType,
          w: itemSize.w,
          h: itemSize.h
        }, _this._calculateItemPosition(itemSize, index)), {}, {
          passSignals: (0,defineProperty/* default */.Z)({}, SELECTED_SIGNAL, true)
        });
      });
      this._refocus();
    }
  }, {
    key: "items",
    get: function get() {
      return this.tag('Items').children;
    }
  }, {
    key: "_calculateItemPosition",
    value: function _calculateItemPosition(itemSize, index) {
      return {
        x: (itemSize.w + this._contentGap) * (index % this._itemsPerRow),
        y: (itemSize.h + this._contentGap) * Math.floor(index / this._itemsPerRow)
      };
    }
  }, {
    key: "_handleUp",
    value: function _handleUp() {
      if (this._index >= this._itemsPerRow) {
        this._setIndex(this._index - this._itemsPerRow);
        return true;
      }
      return false;
    }
  }, {
    key: "_handleDown",
    value: function _handleDown() {
      if (this._index + this._itemsPerRow <= this.items.length - 1) {
        this._setIndex(this._index + this._itemsPerRow);
      }
      return false;
    }
  }, {
    key: "_handleLeft",
    value: function _handleLeft() {
      if (this._index % this._itemsPerRow === 0) {
        return false;
      }
      if (this._index > 0) {
        this._setIndex(this._index - 1);
        return true;
      }
      return false;
    }
  }, {
    key: "_handleRight",
    value: function _handleRight() {
      if (this._index < this.items.length - 1) {
        this._setIndex(this._index + 1);
        return true;
      }
      return false;
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      this.signal(SELECTED_SIGNAL, this._items[this._index]);
      return true;
    }
  }, {
    key: "_setIndex",
    value: function _setIndex() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._index;
      this._index = index;
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this.items[this._index];
    }
  }], [{
    key: "_template",
    value: function _template() {
      return {
        Items: {},
        signals: (0,defineProperty/* default */.Z)({}, SELECTED_SIGNAL, true)
      };
    }
  }]);
  return MosaicGrid;
}(src_Lightning.Component);

;// CONCATENATED MODULE: ./src/modules/user/account/customer/rtlde/account.utils.js


function account_utils_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function account_utils_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? account_utils_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : account_utils_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


var AUTHENTICATED_ONLY = ['info', 'logout'];
var getNavigationFeatures = function getNavigationFeatures(state) {
  var gdprNoticeFeatureEnabled = getGdprNoticeFeature(state);
  var isAuthenticated = user_selectors_getPairingUid(state);
  return account_utils_objectSpread(account_utils_objectSpread({}, isAuthenticated ? undefined : AUTHENTICATED_ONLY.reduce(function (acc, entry) {
    return account_utils_objectSpread(account_utils_objectSpread({}, acc), {}, (0,defineProperty/* default */.Z)({}, entry, false));
  }, {})), {}, {
    privacysettings: gdprNoticeFeatureEnabled,
    profilesgate: false
  });
};
;// CONCATENATED MODULE: ./src/modules/user/account/account.utils.js






















var REPLACEMENT_MAP = {
  account_consentmanagement: common_constants_OPTOUT
};
var makeProfilesGateAction = function makeProfilesGateAction() {
  return {
    item: {
      action: {
        target: {
          type: 'layout',
          value_layout: {
            type: common_constants_FRONTSPACE,
            id: PROFILES_GATE
          }
        },
        analytics: {
          key: 'pressSwitchProfileButton'
        }
      }
    }
  };
};
var makeAuthLockAction = function makeAuthLockAction() {
  return {
    id: 'login',
    picto: {
      type: 'icon',
      name: 'Disconnected'
    },
    groups: [],
    label: t('user.login'),
    target: {
      type: 'lock',
      value_lock: {
        reason: REQUIRE_AUTH,
        originalTarget: {
          type: 'layout',
          value_layout: {
            type: layout_constants/* entities */.jF.alias,
            id: 'home'
          }
        }
      }
    }
  };
};
var mapProfileUnpairedLocks = function mapProfileUnpairedLocks(item) {
  return item;
};
var getProfileEntriesFilter = function getProfileEntriesFilter(state) {
  var profileNavigationFeatures = getNavigationFeatures(state);
  return function (entry) {
    return profileNavigationFeatures[entry.id] !== false;
  };
};
var mapProfileEntries = function mapProfileEntries(item, state) {
  var profileEntriesFilter = getProfileEntriesFilter(state);
  return get_default()(item, 'subEntries', []).filter(profileEntriesFilter);
};
var mapProfileLocks = function mapProfileLocks(item) {
  var isLockAction = get_default()(item, 'target.type', '') === cta_constants.LOCK;
  var isReasonRequireAuth = get_default()(item, 'target.value_lock.reason', '') === REQUIRE_AUTH;
  var originalTarget = get_default()(item, 'target.value_lock.originalTarget', null);
  item.target = isLockAction && isReasonRequireAuth && originalTarget ? originalTarget : item.target;
  return item;
};
var getMapProfileLocks = function getMapProfileLocks(state) {
  var isUserPaired = getPairingStatus(state) === PAIRING_STATUS_PAIRED;
  return isUserPaired ? mapProfileLocks : mapProfileUnpairedLocks;
};
var isActionSupported = function isActionSupported(entry) {
  return src_default().cta.supportedActions.some(function (actionType) {
    return actionType === getItemActionType({
      action: entry
    });
  });
};
var getExtraItem = function getExtraItem(state) {
  if (!getOpenCatalogFeature(state) || user_selectors_getPairingUid(state)) {
    return [];
  }
  return [makeAuthLockAction()];
};
var filterNavigationEntries = function filterNavigationEntries(value, state) {
  var _mapProfileEntries$ma;
  var result = value && value.entries && value.entries.flatMap(function (entry) {
    return entry;
  }).find(function (item) {
    return getItemActionType(item.entry) === PROFILE;
  });
  if (!get_default()(result, 'subEntries.length')) {
    return null;
  }
  return (_mapProfileEntries$ma = mapProfileEntries(result, state).map(getMapProfileLocks(state)).map(function (item) {
    if (!item.target || !item.target.type) {
      return item;
    }
    var action = item.target["value_".concat(item.target.type)];
    if (action) {
      action.reference = REPLACEMENT_MAP[action.reference] || action.reference;
    }
    return item;
  }).filter(isActionSupported)).concat.apply(_mapProfileEntries$ma, (0,toConsumableArray/* default */.Z)(getExtraItem(state)));
};
;// CONCATENATED MODULE: ./src/modules/user/account/account.style.js

var _GRID_MARGIN_TOP, _GRID_PADDING_LEFT;






var account_style_defaultContext = makeDefaultStylingContext();
var GRID_MARGIN_TOP = (_GRID_MARGIN_TOP = {}, (0,defineProperty/* default */.Z)(_GRID_MARGIN_TOP, HD, 152), (0,defineProperty/* default */.Z)(_GRID_MARGIN_TOP, FULL_HD, 256), _GRID_MARGIN_TOP);
var GRID_PADDING_LEFT = (_GRID_PADDING_LEFT = {}, (0,defineProperty/* default */.Z)(_GRID_PADDING_LEFT, HD, 40), (0,defineProperty/* default */.Z)(_GRID_PADDING_LEFT, FULL_HD, 40), _GRID_PADDING_LEFT);
var account_style_colors = {
  background: makeThemeColor(TERTIARY)
};
var account_style_getInitialStyle = memoize_default()(function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : account_style_defaultContext,
    screenSize = _ref.screenSize,
    colorMode = _ref.colorMode;
  return {
    Background: {
      w: SCREEN_WIDTH[screenSize],
      h: sizes_SCREEN_HEIGHT[screenSize],
      color: account_style_colors.background[colorMode]
    },
    Grid: {
      y: GRID_MARGIN_TOP[screenSize],
      x: WIDTH[screenSize] + GRID_PADDING_LEFT[screenSize]
    }
  };
}, cacheResolver);
;// CONCATENATED MODULE: ./src/modules/userInfoBar/userInfoBar.style.js

var userInfoBar_style_WIDTH, _OFFSET_TOP, _OFFSET_RIGHT, _CONTENT_HEIGHT, _BUTTON_HEIGHT, _BUTTON_MARGIN_LEFT, _NAME_MARGIN_TOP, _BUTTON_MARGING_RIGHT;
function userInfoBar_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function userInfoBar_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? userInfoBar_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : userInfoBar_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }




var _makeDefaultStylingCo = makeDefaultStylingContext(),
  userInfoBar_style_screenSize = _makeDefaultStylingCo.screenSize,
  userInfoBar_style_colorMode = _makeDefaultStylingCo.colorMode;
var userInfoBar_userInfoBar_style_WIDTH = (userInfoBar_style_WIDTH = {}, (0,defineProperty/* default */.Z)(userInfoBar_style_WIDTH, HD, 1280), (0,defineProperty/* default */.Z)(userInfoBar_style_WIDTH, FULL_HD, 1920), userInfoBar_style_WIDTH);
var OFFSET_TOP = (_OFFSET_TOP = {}, (0,defineProperty/* default */.Z)(_OFFSET_TOP, HD, 64), (0,defineProperty/* default */.Z)(_OFFSET_TOP, FULL_HD, 88), _OFFSET_TOP);
var OFFSET_RIGHT = (_OFFSET_RIGHT = {}, (0,defineProperty/* default */.Z)(_OFFSET_RIGHT, HD, 64), (0,defineProperty/* default */.Z)(_OFFSET_RIGHT, FULL_HD, 88), _OFFSET_RIGHT);
var CONTENT_HEIGHT = (_CONTENT_HEIGHT = {}, (0,defineProperty/* default */.Z)(_CONTENT_HEIGHT, HD, 48), (0,defineProperty/* default */.Z)(_CONTENT_HEIGHT, FULL_HD, 56), _CONTENT_HEIGHT);
var BUTTON_HEIGHT = (_BUTTON_HEIGHT = {}, (0,defineProperty/* default */.Z)(_BUTTON_HEIGHT, HD, 40), (0,defineProperty/* default */.Z)(_BUTTON_HEIGHT, FULL_HD, 56), _BUTTON_HEIGHT);
var BUTTON_MARGIN_LEFT = (_BUTTON_MARGIN_LEFT = {}, (0,defineProperty/* default */.Z)(_BUTTON_MARGIN_LEFT, HD, 56), (0,defineProperty/* default */.Z)(_BUTTON_MARGIN_LEFT, FULL_HD, 72), _BUTTON_MARGIN_LEFT);
var NAME_MARGIN_TOP = (_NAME_MARGIN_TOP = {}, (0,defineProperty/* default */.Z)(_NAME_MARGIN_TOP, HD, 16), (0,defineProperty/* default */.Z)(_NAME_MARGIN_TOP, FULL_HD, 18), _NAME_MARGIN_TOP);
var BUTTON_MARGING_RIGHT = (_BUTTON_MARGING_RIGHT = {}, (0,defineProperty/* default */.Z)(_BUTTON_MARGING_RIGHT, HD, 64), (0,defineProperty/* default */.Z)(_BUTTON_MARGING_RIGHT, FULL_HD, 88), _BUTTON_MARGING_RIGHT);
var NAME_MARGIN_LEFT = 16;
var NAME_TEXT_COLOR = makeThemeColor(PRIMARY)[userInfoBar_style_colorMode];
var CONTENT_WIDTH = (userInfoBar_userInfoBar_style_WIDTH[userInfoBar_style_screenSize] - OFFSET_RIGHT[userInfoBar_style_screenSize]) / 2;
var getInfoBarOffsetX = function getInfoBarOffsetX() {
  return userInfoBar_userInfoBar_style_WIDTH[userInfoBar_style_screenSize] - OFFSET_RIGHT[userInfoBar_style_screenSize] - CONTENT_WIDTH;
};
var getButtonPaddingTop = function getButtonPaddingTop() {
  return (CONTENT_HEIGHT[userInfoBar_style_screenSize] - BUTTON_HEIGHT[userInfoBar_style_screenSize]) / 2;
};
var userInfoBar_style_getInitialStyle = function getInitialStyle() {
  return {
    Content: {
      x: getInfoBarOffsetX(),
      y: OFFSET_TOP[userInfoBar_style_screenSize],
      w: CONTENT_WIDTH,
      h: CONTENT_HEIGHT[userInfoBar_style_screenSize],
      flex: {
        direction: 'row',
        wrap: true,
        justifyContent: 'flex-end',
        alignContent: 'center'
      },
      Avatar: {},
      Name: {
        flexItem: {
          marginLeft: NAME_MARGIN_LEFT,
          marginTop: NAME_MARGIN_TOP[userInfoBar_style_screenSize]
        },
        text: userInfoBar_style_objectSpread(userInfoBar_style_objectSpread({}, src_getFont(constants_FONT.BERLIN_2, userInfoBar_style_screenSize)), {}, {
          textColor: NAME_TEXT_COLOR
        })
      },
      ProfileChangeButton: {
        flexItem: {
          marginLeft: BUTTON_MARGIN_LEFT[userInfoBar_style_screenSize],
          marginTop: getButtonPaddingTop(),
          marginRight: BUTTON_MARGING_RIGHT[userInfoBar_style_screenSize]
        }
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/avatar/avatar.style.js

var _imageSizes;


var avatar_style_defaultContext = makeDefaultStylingContext();
var imageSizes = (_imageSizes = {}, (0,defineProperty/* default */.Z)(_imageSizes, HD, {
  width: 48,
  height: 48
}), (0,defineProperty/* default */.Z)(_imageSizes, FULL_HD, {
  width: 56,
  height: 56
}), _imageSizes);
var avatar_style_getImageRadius = function getImageRadius(screenSize) {
  return Math.round(imageSizes[screenSize].width / 2);
};
var avatar_style_getImageSize = function getImageSize(screenSize) {
  return imageSizes[screenSize];
};
var avatar_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : avatar_style_defaultContext;
  return {
    w: imageSizes[context.screenSize].width,
    h: imageSizes[context.screenSize].height,
    shader: {
      radius: avatar_style_getImageRadius(context.screenSize)
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/avatar/avatar.utils.js




var getProfilePhotoUrl = memoize_default()(function (_ref) {
  var imageId = _ref.imageId,
    width = _ref.width,
    height = _ref.height;
  return imageService.getUrl(imageId, width, height, {
    format: TRANSPARENT_IMAGE_FORMAT,
    fit: IMAGE_FIT_SCALE_CROP,
    quality: IMAGE_QUALITY
  });
}, cacheResolver);
;// CONCATENATED MODULE: ./src/modules/tornado/avatar/avatar.component.js






function avatar_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function avatar_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? avatar_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : avatar_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function avatar_component_createSuper(t) { var r = avatar_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function avatar_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (avatar_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }




var Avatar = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Avatar, _Lightning$Component);
  var _super = avatar_component_createSuper(Avatar);
  function Avatar() {
    (0,classCallCheck/* default */.Z)(this, Avatar);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Avatar, [{
    key: "_construct",
    value: function _construct() {
      this._style = avatar_style_defaultContext;
    }
  }, {
    key: "photoId",
    set: function set(imageId) {
      if (!imageId) {
        return;
      }
      this.patch({
        src: getProfilePhotoUrl(avatar_component_objectSpread({
          imageId: imageId
        }, avatar_style_getImageSize(this._style.screenSize)))
      });
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        rtt: true,
        shader: {
          type: src_Lightning.shaders.RoundedRectangle
        }
      }, avatar_style_getInitialStyle());
    }
  }]);
  return Avatar;
}(src_Lightning.Component);

;// CONCATENATED MODULE: ./src/modules/user/account/account.constants.js
var CHANGE_PROFILE_SIGNAL = 'changeProfile';
;// CONCATENATED MODULE: ./src/modules/userInfoBar/userInfoBar.component.js





function userInfoBar_component_createSuper(t) { var r = userInfoBar_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function userInfoBar_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (userInfoBar_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }







var UserInfoBar = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(UserInfoBar, _Lightning$Component);
  var _super = userInfoBar_component_createSuper(UserInfoBar);
  function UserInfoBar() {
    (0,classCallCheck/* default */.Z)(this, UserInfoBar);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(UserInfoBar, [{
    key: "photoId",
    set: function set(value) {
      this.tag('Avatar').photoId = value;
    }
  }, {
    key: "userName",
    set: function set(value) {
      this.tag('Name').text.text = value;
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this.tag('ProfileChangeButton');
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      this.signal(CHANGE_PROFILE_SIGNAL);
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Content: {
          Avatar: {
            type: Avatar
          },
          Name: {},
          ProfileChangeButton: {
            type: Button,
            label: t('profile.switch')
          }
        }
      }, userInfoBar_style_getInitialStyle());
    }
  }]);
  return UserInfoBar;
}(src_Lightning.Component);

;// CONCATENATED MODULE: ./src/modules/deviceInfoBar/deviceInfoBar.style.js

var _OFFSET_BOTTOM, deviceInfoBar_style_OFFSET_RIGHT, deviceInfoBar_style_CONTENT_HEIGHT;
function deviceInfoBar_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function deviceInfoBar_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? deviceInfoBar_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : deviceInfoBar_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





var deviceInfoBar_style_makeDefaultStylingCo = makeDefaultStylingContext(),
  deviceInfoBar_style_screenSize = deviceInfoBar_style_makeDefaultStylingCo.screenSize,
  deviceInfoBar_style_colorMode = deviceInfoBar_style_makeDefaultStylingCo.colorMode;
var OFFSET_BOTTOM = (_OFFSET_BOTTOM = {}, (0,defineProperty/* default */.Z)(_OFFSET_BOTTOM, HD, 64), (0,defineProperty/* default */.Z)(_OFFSET_BOTTOM, FULL_HD, 88), _OFFSET_BOTTOM);
var deviceInfoBar_deviceInfoBar_style_OFFSET_RIGHT = (deviceInfoBar_style_OFFSET_RIGHT = {}, (0,defineProperty/* default */.Z)(deviceInfoBar_style_OFFSET_RIGHT, HD, 64), (0,defineProperty/* default */.Z)(deviceInfoBar_style_OFFSET_RIGHT, FULL_HD, 88), deviceInfoBar_style_OFFSET_RIGHT);
var deviceInfoBar_deviceInfoBar_style_CONTENT_HEIGHT = (deviceInfoBar_style_CONTENT_HEIGHT = {}, (0,defineProperty/* default */.Z)(deviceInfoBar_style_CONTENT_HEIGHT, HD, 48), (0,defineProperty/* default */.Z)(deviceInfoBar_style_CONTENT_HEIGHT, FULL_HD, 56), deviceInfoBar_style_CONTENT_HEIGHT);
var TEXT_COLOR = makeThemeColor(PRIMARY)[deviceInfoBar_style_colorMode];
var deviceInfoBar_style_CONTENT_WIDTH = (SCREEN_WIDTH[deviceInfoBar_style_screenSize] - deviceInfoBar_deviceInfoBar_style_OFFSET_RIGHT[deviceInfoBar_style_screenSize]) / 2;
var deviceInfoBar_style_getInfoBarOffsetX = function getInfoBarOffsetX() {
  return SCREEN_WIDTH[deviceInfoBar_style_screenSize] - deviceInfoBar_deviceInfoBar_style_OFFSET_RIGHT[deviceInfoBar_style_screenSize];
};
var getInfoBarOffsetY = function getInfoBarOffsetY() {
  return sizes_SCREEN_HEIGHT[deviceInfoBar_style_screenSize] - OFFSET_BOTTOM[deviceInfoBar_style_screenSize];
};
var deviceInfoBar_style_getInitialStyle = function getInitialStyle() {
  return {
    x: deviceInfoBar_style_getInfoBarOffsetX(),
    y: getInfoBarOffsetY(),
    w: 200,
    h: 60,
    mount: 1,
    flex: {
      direction: 'column',
      wrap: true,
      justifyContent: 'flex-end',
      alignContent: 'flex-end'
    },
    DeviceVersion: {
      text: deviceInfoBar_style_objectSpread(deviceInfoBar_style_objectSpread({}, src_getFont(constants_FONT.BERLIN_2, deviceInfoBar_style_screenSize)), {}, {
        textColor: TEXT_COLOR
      })
    },
    AppVersion: {
      text: deviceInfoBar_style_objectSpread(deviceInfoBar_style_objectSpread({}, src_getFont(constants_FONT.BERLIN_2, deviceInfoBar_style_screenSize)), {}, {
        textColor: TEXT_COLOR
      })
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/deviceInfoBar/deviceInfoBar.connector.js


var deviceInfoBar_connector_mapControllers = function mapControllers(instance) {
  return {
    deviceVersion: {
      selector: getDeviceVersion,
      shouldBeInvokedOnConnect: true,
      callback: function callback(value) {
        instance.deviceVersion = value;
      }
    },
    deviceBrand: {
      selector: getDeviceBrand,
      shouldBeInvokedOnConnect: true,
      callback: function callback(value) {
        instance.deviceBrand = value;
      }
    },
    deviceModel: {
      selector: getDeviceModel,
      shouldBeInvokedOnConnect: true,
      callback: function callback(value) {
        instance.deviceModel = value;
      }
    }
  };
};
/* harmony default export */ const deviceInfoBar_connector = (lightningjs_redux.control(deviceInfoBar_connector_mapControllers));
;// CONCATENATED MODULE: ./src/modules/deviceInfoBar/deviceInfoBar.component.js








function deviceInfoBar_component_createSuper(t) { var r = deviceInfoBar_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function deviceInfoBar_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (deviceInfoBar_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }






var DeviceInfoBar = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(DeviceInfoBar, _Lightning$Component);
  var _super = deviceInfoBar_component_createSuper(DeviceInfoBar);
  function DeviceInfoBar() {
    (0,classCallCheck/* default */.Z)(this, DeviceInfoBar);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(DeviceInfoBar, [{
    key: "deviceVersion",
    set: function set(value) {
      this._deviceVersion = value;
      this.setDeviceVersion();
    }
  }, {
    key: "deviceBrand",
    set: function set(value) {
      this._deviceBrand = value;
      this.setDeviceVersion();
    }
  }, {
    key: "deviceModel",
    set: function set(value) {
      this._deviceModel = value;
      this.setDeviceVersion();
    }
  }, {
    key: "setDeviceVersion",
    value: function setDeviceVersion() {
      var matches = navigator.userAgent.match(/MN=([a-zA-Z0-9]*);/);
      var userAgentModel = get_default()(matches, '[1]');
      var deviceModel = this._deviceModel || userAgentModel;
      var deviceVersion = this._deviceVersion || "".concat(this._deviceBrand, " ").concat(deviceModel);
      this.tag('DeviceVersion').text.text = "Device: ".concat(deviceVersion);
    }
  }, {
    key: "_attach",
    value: function _attach() {
      this._unsubscribe = deviceInfoBar_connector(this);
      this.tag('AppVersion').text.text = "App: ".concat(env.appVersion);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      if (this._unsubscribe) {
        this._unsubscribe();
        this._unsubscribe = null;
      }
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        DeviceVersion: {
          text: {}
        },
        AppVersion: {
          text: {}
        }
      }, deviceInfoBar_style_getInitialStyle());
    }
  }]);
  return DeviceInfoBar;
}(src_Lightning.Component);

;// CONCATENATED MODULE: ./src/modules/user/account/accountCard/accountCard.style.js

var _MOSAIC_CARD_SIZE, _ICON_SIZES, accountCard_style_GAP, accountCard_style_BORDER_RADIUS;
function accountCard_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function accountCard_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? accountCard_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : accountCard_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }








var accountCard_style_defaultContext = makeDefaultStylingContext();
var MOSAIC_CARD_SIZE = (_MOSAIC_CARD_SIZE = {}, (0,defineProperty/* default */.Z)(_MOSAIC_CARD_SIZE, HD, {
  w: 279,
  h: 157
}), (0,defineProperty/* default */.Z)(_MOSAIC_CARD_SIZE, FULL_HD, {
  w: 336,
  h: 189
}), _MOSAIC_CARD_SIZE);
var accountCard_style_PADDING = 8;
var accountCard_style_colors = {
  background: makeThemeColor(TERTIARY),
  icon: makeThemeColor(PRIMARY),
  label: makeThemeColor(PRIMARY)
};
var ICON_SIZES = (_ICON_SIZES = {}, (0,defineProperty/* default */.Z)(_ICON_SIZES, HD, 48), (0,defineProperty/* default */.Z)(_ICON_SIZES, FULL_HD, 56), _ICON_SIZES);
var accountCard_accountCard_style_GAP = (accountCard_style_GAP = {}, (0,defineProperty/* default */.Z)(accountCard_style_GAP, HD, 12), (0,defineProperty/* default */.Z)(accountCard_style_GAP, FULL_HD, 24), accountCard_style_GAP);
var accountCard_accountCard_style_BORDER_RADIUS = (accountCard_style_BORDER_RADIUS = {}, (0,defineProperty/* default */.Z)(accountCard_style_BORDER_RADIUS, HD, 4), (0,defineProperty/* default */.Z)(accountCard_style_BORDER_RADIUS, FULL_HD, 4), accountCard_style_BORDER_RADIUS);
var accountCard_style_getIconViewBox = memoize_default()(function (screenSize) {
  return {
    h: ICON_SIZES[screenSize]
  };
});
var accountCard_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : accountCard_style_defaultContext,
    screenSize = _ref.screenSize,
    colorMode = _ref.colorMode;
  var _MOSAIC_CARD_SIZE$scr = MOSAIC_CARD_SIZE[screenSize],
    w = _MOSAIC_CARD_SIZE$scr.w,
    h = _MOSAIC_CARD_SIZE$scr.h;
  var borderSize = focus_BORDER_WIDTH[screenSize];
  var borderOffset = borderSize * 2;
  return {
    Border: {
      w: w + borderOffset,
      h: h + borderOffset,
      x: -borderSize,
      y: -borderSize,
      color: colors_TRANSPARENT,
      shader: {
        radius: accountCard_accountCard_style_BORDER_RADIUS[screenSize],
        outline: focus_BORDER_WIDTH[screenSize],
        strokeColor: colors_TRANSPARENT,
        innerColor: colors_TRANSPARENT
      }
    },
    Background: {
      w: w,
      h: h,
      shader: {
        fillColor: accountCard_style_colors.background[colorMode],
        radius: accountCard_accountCard_style_BORDER_RADIUS[screenSize]
      }
    },
    Image: {
      w: w,
      h: h,
      shader: {
        radius: accountCard_accountCard_style_BORDER_RADIUS[screenSize]
      }
    },
    Content: {
      w: w,
      h: h,
      flex: {
        direction: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      },
      IconWrapper: {
        w: w,
        h: ICON_SIZES[screenSize] + accountCard_accountCard_style_GAP[screenSize],
        Icon: {
          mountX: 0.5,
          x: middle,
          color: accountCard_style_colors.icon[colorMode]
        }
      },
      Label: {
        color: accountCard_style_colors.label[colorMode],
        text: accountCard_style_objectSpread(accountCard_style_objectSpread({}, src_getFont(constants_FONT.BERLIN_2, screenSize)), {}, {
          wordWrapWidth: w - accountCard_style_PADDING * 2,
          wordWrap: true,
          wordBreak: true,
          advancedRenderer: true,
          textAlign: 'center',
          verticalAlign: 'bottom',
          maxLines: 2,
          maxLinesSuffix: '...'
        })
      }
    }
  };
};
var accountCard_style_getFocusedStyle = function getFocusedStyle(_ref2) {
  var colorMode = _ref2.colorMode;
  return {
    Border: {
      smooth: {
        scale: focus_SCALE_FOCUSED,
        'shader.strokeColor': BORDER_COLOR[colorMode],
        'shader.innerColor': INNER_BORDER_COLOR[colorMode],
        'shader.scale': focus_SCALE_FOCUSED
      }
    },
    Background: {
      smooth: {
        scale: focus_SCALE_FOCUSED,
        'shader.scale': focus_SCALE_FOCUSED
      }
    },
    Image: {
      smooth: {
        scale: focus_SCALE_FOCUSED,
        'shader.scale': focus_SCALE_FOCUSED
      }
    }
  };
};
var accountCard_style_unFocusedStyle = {
  Border: {
    smooth: {
      scale: 1,
      'shader.strokeColor': colors_TRANSPARENT,
      'shader.innerColor': colors_TRANSPARENT,
      'shader.scale': 1.0
    }
  },
  Background: {
    smooth: {
      scale: 1,
      'shader.scale': 1.0
    }
  },
  Image: {
    smooth: {
      scale: 1,
      'shader.scale': 1.0
    }
  }
};
;// CONCATENATED MODULE: ./src/modules/user/account/accountCard/accountCard.component.js





function accountCard_component_createSuper(t) { var r = accountCard_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function accountCard_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (accountCard_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }








var AccountCard = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(AccountCard, _Lightning$Component);
  var _super = accountCard_component_createSuper(AccountCard);
  function AccountCard() {
    (0,classCallCheck/* default */.Z)(this, AccountCard);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(AccountCard, [{
    key: "_construct",
    value: function _construct() {
      this._style = accountCard_style_defaultContext;
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this.tag('Icon').removeAllListeners('txLoaded');
    }
  }, {
    key: "item",
    set: function set(value) {
      var _this = this;
      this._item = value;
      var imageUrl = get_default()(this._item, 'image.src', '');
      this.tag('Icon').once('txLoaded', function () {
        _this.tag('Icon').setSmooth('alpha', 1);
      });
      this.patch({
        Image: {
          texture: imageUrl && imageUrl.length ? cover(imageUrl, MOSAIC_CARD_SIZE[this._style.screenSize].w, MOSAIC_CARD_SIZE[this._style.screenSize].h) : null
        },
        Content: {
          Label: {
            text: {
              text: value.label
            }
          },
          IconWrapper: {
            Icon: {
              alpha: 0.0001,
              iconData: {
                picto: value.picto,
                viewBox: accountCard_style_getIconViewBox(this._style.screenSize)
              }
            }
          }
        }
      });
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this.patch(accountCard_style_getFocusedStyle(this._style));
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this.patch(accountCard_style_unFocusedStyle);
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      this.signal(SELECTED_SIGNAL, this._item);
      return true;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Border: {
          rect: true,
          shader: {
            type: focus_shader
          }
        },
        Background: {
          rect: true,
          shader: {
            type: src_Lightning.shaders.RoundedRectangle
          }
        },
        Image: {
          shader: {
            type: src_Lightning.shaders.RoundedRectangle
          }
        },
        Content: {
          IconWrapper: {
            Icon: {
              type: Icon
            }
          },
          Label: {}
        }
      }, accountCard_style_getInitialStyle());
    }
  }]);
  return AccountCard;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/user/account/account.component.js






function account_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function account_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? account_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : account_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function account_component_createSuper(t) { var r = account_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function account_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (account_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }


















var Account = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Account, _Lightning$Component);
  var _super = account_component_createSuper(Account);
  function Account() {
    (0,classCallCheck/* default */.Z)(this, Account);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Account, [{
    key: "_construct",
    value: function _construct() {
      this._navigation = null;
      this._isProfileSelected = null;
      this._style = account_style_defaultContext;
    }
  }, {
    key: "_active",
    value: function _active() {
      removeSplashScreen();
    }
  }, {
    key: "_attach",
    value: function _attach() {
      this._unsubscribe = account_connector(this);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      if (this._unsubscribe) {
        this._unsubscribe();
        this._unsubscribe = null;
      }
    }
  }, {
    key: "navigation",
    set: function set(value) {
      if (!value || this._navigation === value) {
        return;
      }
      this._navigation = value;
      this._fillGrid(filterNavigationEntries(value, lightningjs_redux.getState()));
    }
  }, {
    key: "profileUsername",
    set: function set(value) {
      if (!value) {
        return;
      }
      this.tag('UserInfoBar').userName = value;
    }
  }, {
    key: "profilePhotoId",
    set: function set(value) {
      this.tag('UserInfoBar').photoId = value;
    }
  }, {
    key: "selectedProfile",
    set: function set(value) {
      this._isProfileSelected = Boolean(value);
      this.tag('UserInfoBar').visible = this._isProfileSelected;
    }
  }, {
    key: "_fillGrid",
    value: function _fillGrid(items) {
      if (!items) {
        this._setState('InfoBar');
        return;
      }
      var screenSize = this._style.screenSize;
      var rowsCount = Math.ceil(items.length / mosaicGrid_mosaicGrid_style_ITEMS_PER_ROW[screenSize]);
      var itemSize = MOSAIC_CARD_SIZE[screenSize];
      var gap = mosaicGrid_mosaicGrid_constant_CONTENT_GAP[screenSize];
      var mosaicHeight = rowsCount * (itemSize.h + gap) - gap;
      var mosaicContainerHeight = sizes_SCREEN_HEIGHT[screenSize];
      this.tag('Grid').patch({
        y: Math.max(Math.round((mosaicContainerHeight - mosaicHeight) / 2), GRID_MARGIN_TOP[screenSize]),
        data: {
          items: items,
          itemType: AccountCard,
          itemSize: itemSize
        },
        signals: (0,defineProperty/* default */.Z)({}, SELECTED_SIGNAL, '_handleSelected')
      });
      this._setState('Grid');
    }
  }, {
    key: "_handleUp",
    value: function _handleUp() {
      if (this._isProfileSelected) this._setState('InfoBar');
      return true;
    }
  }, {
    key: "_handleDown",
    value: function _handleDown() {
      if (this.state === 'InfoBar') {
        this._setState('Grid');
      }
      return true;
    }
  }, {
    key: "_handleSelected",
    value: function _handleSelected(item) {
      lightningjs_redux.dispatch(createItemAction({
        item: account_component_objectSpread(account_component_objectSpread({}, item), {}, {
          action: item
        })
      }));
    }
  }, {
    key: "_handleChangeProfile",
    value: function _handleChangeProfile() {
      lightningjs_redux.dispatch(createItemAction(makeProfilesGateAction()));
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Background: {
          rect: true
        },
        ProfileInfo: {},
        UserInfoBar: {
          type: UserInfoBar,
          signals: (0,defineProperty/* default */.Z)({}, CHANGE_PROFILE_SIGNAL, '_handleChangeProfile')
        },
        Grid: {
          type: MosaicGrid,
          signals: (0,defineProperty/* default */.Z)({}, SELECTED_SIGNAL, '_handleSelected')
        },
        DeviceInfo: {
          type: DeviceInfoBar
        }
      }, account_style_getInitialStyle());
    }
  }, {
    key: "_states",
    value: function _states() {
      return [function (_this) {
        (0,inherits/* default */.Z)(Grid, _this);
        var _super2 = account_component_createSuper(Grid);
        function Grid() {
          (0,classCallCheck/* default */.Z)(this, Grid);
          return _super2.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(Grid, [{
          key: "_getFocused",
          value: function _getFocused() {
            return this.tag('Grid');
          }
        }]);
        return Grid;
      }(this), function (_this2) {
        (0,inherits/* default */.Z)(InfoBar, _this2);
        var _super3 = account_component_createSuper(InfoBar);
        function InfoBar() {
          (0,classCallCheck/* default */.Z)(this, InfoBar);
          return _super3.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(InfoBar, [{
          key: "_getFocused",
          value: function _getFocused() {
            return this.tag('UserInfoBar');
          }
        }]);
        return InfoBar;
      }(this)];
    }
  }]);
  return Account;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/settings/privacySettings/privacySettings.style.js

var _BRAND_ICON_SIZE, _ARROW_PADDING_BOTTOM, privacySettings_style_ARROW_SIZE, _CONTENT_SIDE_MARGIN, _TITLE_PADDING_BOTTOM, _DESCRIPTION_PADDING_;
function privacySettings_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function privacySettings_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? privacySettings_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : privacySettings_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






var BRAND_ICON_SIZE = (_BRAND_ICON_SIZE = {}, (0,defineProperty/* default */.Z)(_BRAND_ICON_SIZE, HD, 64), (0,defineProperty/* default */.Z)(_BRAND_ICON_SIZE, FULL_HD, 72), _BRAND_ICON_SIZE);
var ARROW_PADDING_BOTTOM = (_ARROW_PADDING_BOTTOM = {}, (0,defineProperty/* default */.Z)(_ARROW_PADDING_BOTTOM, HD, 24), (0,defineProperty/* default */.Z)(_ARROW_PADDING_BOTTOM, FULL_HD, 32), _ARROW_PADDING_BOTTOM);
var privacySettings_privacySettings_style_ARROW_SIZE = (privacySettings_style_ARROW_SIZE = {}, (0,defineProperty/* default */.Z)(privacySettings_style_ARROW_SIZE, HD, 96), (0,defineProperty/* default */.Z)(privacySettings_style_ARROW_SIZE, FULL_HD, 128), privacySettings_style_ARROW_SIZE);
var CONTENT_SIDE_MARGIN = (_CONTENT_SIDE_MARGIN = {}, (0,defineProperty/* default */.Z)(_CONTENT_SIDE_MARGIN, HD, 300), (0,defineProperty/* default */.Z)(_CONTENT_SIDE_MARGIN, FULL_HD, 460), _CONTENT_SIDE_MARGIN);
var TITLE_PADDING_BOTTOM = (_TITLE_PADDING_BOTTOM = {}, (0,defineProperty/* default */.Z)(_TITLE_PADDING_BOTTOM, HD, 24), (0,defineProperty/* default */.Z)(_TITLE_PADDING_BOTTOM, FULL_HD, 56), _TITLE_PADDING_BOTTOM);
var DESCRIPTION_PADDING_BOTTOM = (_DESCRIPTION_PADDING_ = {}, (0,defineProperty/* default */.Z)(_DESCRIPTION_PADDING_, HD, 24), (0,defineProperty/* default */.Z)(_DESCRIPTION_PADDING_, FULL_HD, 25), _DESCRIPTION_PADDING_);
var privacySettings_style_defaultContext = makeDefaultStylingContext();
var privacySettings_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : privacySettings_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  var topY = safetyMargins.vertical[screenSize];
  var scrollWrapperY = topY + privacySettings_privacySettings_style_ARROW_SIZE[screenSize] + ARROW_PADDING_BOTTOM[screenSize];
  var scrollWrapperWidth = SCREEN_WIDTH[screenSize] - CONTENT_SIDE_MARGIN[screenSize] * 2;
  var scrollWrapperHeight = sizes_SCREEN_HEIGHT[screenSize] - safetyMargins.vertical[screenSize] - scrollWrapperY - privacySettings_privacySettings_style_ARROW_SIZE[screenSize];
  var titleFont = src_getFont(constants_FONT.KINSHASA_3, screenSize);
  var descriptionFont = src_getFont(constants_FONT.MADRID_1, screenSize);
  var backgroundColor = makeThemeColor(TERTIARY);
  return {
    w: SCREEN_WIDTH[screenSize],
    h: sizes_SCREEN_HEIGHT[screenSize],
    Background: {
      rect: true,
      w: SCREEN_WIDTH[screenSize],
      h: sizes_SCREEN_HEIGHT[screenSize],
      color: backgroundColor[colorMode]
    },
    BackButton: {
      x: safetyMargins.horizontal[screenSize],
      y: topY
    },
    ArrowUp: {
      y: topY,
      mountX: 0.5,
      x: middle,
      visible: false,
      iconData: {
        picto: {
          name: 'ArrowUp',
          type: ICON_TYPE.SIMPLE_ICON
        },
        viewBox: {
          h: privacySettings_privacySettings_style_ARROW_SIZE[screenSize]
        }
      }
    },
    BrandIcon: {
      h: BRAND_ICON_SIZE[screenSize],
      y: topY,
      mountX: 0.5,
      x: middle
    },
    ScrollWrapper: {
      mountX: 0.5,
      x: middle,
      y: scrollWrapperY,
      w: scrollWrapperWidth,
      h: scrollWrapperHeight,
      clipping: true,
      ScrollContent: {
        flex: {
          direction: 'column'
        },
        Title: {
          mountX: 0.5,
          flexItem: {
            marginBottom: TITLE_PADDING_BOTTOM[screenSize]
          },
          x: middle,
          text: privacySettings_style_objectSpread({}, titleFont)
        },
        Description: {
          mountX: 0.5,
          x: middle,
          flexItem: {
            marginBottom: DESCRIPTION_PADDING_BOTTOM[screenSize]
          },
          text: privacySettings_style_objectSpread({
            wordWrapWidth: scrollWrapperWidth
          }, descriptionFont)
        },
        CookieGroups: {
          flex: {
            direction: 'column'
          }
        }
      }
    },
    ArrowDown: {
      mountY: 1,
      y: sizes_SCREEN_HEIGHT[screenSize] - safetyMargins.vertical[screenSize],
      mountX: 0.5,
      x: middle,
      visible: false,
      iconData: {
        picto: {
          name: 'ArrowDown',
          type: ICON_TYPE.SIMPLE_ICON
        },
        viewBox: {
          h: privacySettings_privacySettings_style_ARROW_SIZE[screenSize]
        }
      }
    }
  };
};
var gridPadding = {
  left: 224
};
;// CONCATENATED MODULE: ./src/modules/settings/privacySettings/privacySettings.utils.js



var isUpdated = function isUpdated(savedCookies, selectedCookies) {
  return src.gdprCookies.some(function (category) {
    return savedCookies[category] !== selectedCookies[category];
  }) && !(areCookiesEmpty(savedCookies) && src.gdprCookies.every(function (category) {
    return selectedCookies[category] === false;
  }));
};
var getBackButtonLabel = function getBackButtonLabel(savedCookies, selectedCookies) {
  return isUpdated(savedCookies, selectedCookies) ? t('global.backSave') : t('global.back');
};
;// CONCATENATED MODULE: ./src/modules/settings/privacySettings/privacySettings.connector.js


var privacySettings_connector_mapControllers = function mapControllers(instance) {
  return {
    cookies: {
      selector: getCookies,
      shouldBeInvokedOnConnect: true,
      callback: function callback(value) {
        instance.cookies = value;
      }
    },
    areUserPreferencesSet: {
      selector: areGdprCookiesSet,
      shouldBeInvokedOnConnect: true,
      callback: function callback(value) {
        instance.areGdprCookiesSet = value;
      }
    }
  };
};
/* harmony default export */ const privacySettings_connector = (lightningjs_redux.control(privacySettings_connector_mapControllers));
;// CONCATENATED MODULE: ./src/components/checkBoxBlock/checkBoxBlock.style.js

var checkBoxBlock_style_WIDTH, checkBoxBlock_style_PADDING, _TITLE_PADDING, _TEXT_PADDING_RIGHT;
function checkBoxBlock_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function checkBoxBlock_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? checkBoxBlock_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : checkBoxBlock_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





var checkBoxBlock_style_defaultContext = makeDefaultStylingContext();
var checkBoxBlock_checkBoxBlock_style_WIDTH = (checkBoxBlock_style_WIDTH = {}, (0,defineProperty/* default */.Z)(checkBoxBlock_style_WIDTH, HD, 640), (0,defineProperty/* default */.Z)(checkBoxBlock_style_WIDTH, FULL_HD, 960), checkBoxBlock_style_WIDTH);
var checkBoxBlock_checkBoxBlock_style_PADDING = (checkBoxBlock_style_PADDING = {}, (0,defineProperty/* default */.Z)(checkBoxBlock_style_PADDING, HD, 16), (0,defineProperty/* default */.Z)(checkBoxBlock_style_PADDING, FULL_HD, 24), checkBoxBlock_style_PADDING);
var checkBoxBlock_style_TITLE_PADDING = (_TITLE_PADDING = {}, (0,defineProperty/* default */.Z)(_TITLE_PADDING, HD, 8), (0,defineProperty/* default */.Z)(_TITLE_PADDING, FULL_HD, 8), _TITLE_PADDING);
var TEXT_PADDING_RIGHT = (_TEXT_PADDING_RIGHT = {}, (0,defineProperty/* default */.Z)(_TEXT_PADDING_RIGHT, HD, 48), (0,defineProperty/* default */.Z)(_TEXT_PADDING_RIGHT, FULL_HD, 72), _TEXT_PADDING_RIGHT);
var checkBoxBlock_style_colors = {
  unfocused: makeThemeColor(TERTIARY),
  focused: makeThemeColor(PRIMARY, 0.3)
};
var checkBoxBlock_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : checkBoxBlock_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  var width = checkBoxBlock_checkBoxBlock_style_WIDTH[screenSize];
  var wordWrapWidth = width - TEXT_PADDING_RIGHT[screenSize];
  var titleFont = src_getFont(constants_FONT.BERLIN_3, screenSize);
  var descriptionFont = src_getFont(constants_FONT.BERLIN_1, screenSize);
  return {
    w: width,
    color: checkBoxBlock_style_colors.unfocused[colorMode],
    flex: {
      direction: 'row',
      padding: checkBoxBlock_checkBoxBlock_style_PADDING[screenSize],
      wrap: true
    },
    TextWrapper: {
      flex: {
        direction: 'column'
      },
      w: identity,
      Title: {
        text: checkBoxBlock_style_objectSpread({
          wordWrapWidth: wordWrapWidth,
          wordWrap: true
        }, titleFont),
        paddingBottom: checkBoxBlock_style_TITLE_PADDING[screenSize],
        wordWrap: true
      },
      Description: {
        text: checkBoxBlock_style_objectSpread({
          wordWrapWidth: wordWrapWidth,
          wordWrap: true
        }, descriptionFont)
      }
    },
    Checkbox: {
      mountX: 1,
      x: width - checkBoxBlock_checkBoxBlock_style_PADDING[screenSize]
    },
    Border: {
      borderWidthBottom: 1,
      colorBorder: checkBoxBlock_style_colors.focused[colorMode],
      w: identity,
      mountY: 1,
      x: -checkBoxBlock_checkBoxBlock_style_PADDING[screenSize],
      y: checkBoxBlock_checkBoxBlock_style_PADDING[screenSize]
    }
  };
};
var checkBoxBlock_style_getFocusedStyle = function getFocusedStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : checkBoxBlock_style_defaultContext;
  var colorMode = context.colorMode;
  return {
    color: checkBoxBlock_style_colors.focused[colorMode]
  };
};
var getUnfocusedStyle = function getUnfocusedStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : checkBoxBlock_style_defaultContext;
  var colorMode = context.colorMode;
  return {
    color: checkBoxBlock_style_colors.unfocused[colorMode]
  };
};
;// CONCATENATED MODULE: ./src/components/checkbox/checkbox.style.js

var checkbox_style_SIZE, checkbox_style_ICON_SIZE;





var checkbox_style_defaultContext = makeDefaultStylingContext();
var checkbox_checkbox_style_SIZE = (checkbox_style_SIZE = {}, (0,defineProperty/* default */.Z)(checkbox_style_SIZE, HD, 16), (0,defineProperty/* default */.Z)(checkbox_style_SIZE, FULL_HD, 16), checkbox_style_SIZE);
var checkbox_checkbox_style_ICON_SIZE = (checkbox_style_ICON_SIZE = {}, (0,defineProperty/* default */.Z)(checkbox_style_ICON_SIZE, HD, 12), (0,defineProperty/* default */.Z)(checkbox_style_ICON_SIZE, FULL_HD, 12), checkbox_style_ICON_SIZE);
var checkbox_style_colors = {
  primary: makeThemeColor(PRIMARY),
  primaryDisabled: makeThemeColor(PRIMARY, 0.3)
};
var checkbox_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : checkbox_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  return {
    w: checkbox_checkbox_style_SIZE[screenSize],
    h: checkbox_checkbox_style_SIZE[screenSize],
    Border: {
      borderWidth: 1,
      colorBorder: checkbox_style_colors.primary[colorMode],
      w: identity,
      h: identity
    },
    Icon: {
      mount: 0.5,
      x: middle,
      y: middle,
      w: checkbox_checkbox_style_SIZE[screenSize],
      h: checkbox_checkbox_style_SIZE[screenSize],
      visible: false,
      iconData: {
        picto: {
          name: 'Check',
          type: ICON_TYPE.SIMPLE_ICON
        },
        viewBox: {
          w: checkbox_checkbox_style_ICON_SIZE[screenSize],
          h: checkbox_checkbox_style_ICON_SIZE[screenSize]
        }
      }
    }
  };
};
var checkbox_style_getDisabledStyle = function getDisabledStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : checkbox_style_defaultContext;
  var colorMode = context.colorMode;
  return {
    color: null,
    Border: {
      colorBorder: checkbox_style_colors.primaryDisabled[colorMode]
    },
    Icon: {
      visible: false
    }
  };
};
var getCheckedStyle = function getCheckedStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : checkbox_style_defaultContext;
  var colorMode = context.colorMode;
  return {
    color: checkbox_style_colors.primary[colorMode],
    Border: {
      colorBorder: checkbox_style_colors.primary[colorMode]
    },
    Icon: {
      visible: true
    }
  };
};
;// CONCATENATED MODULE: ./src/components/checkbox/checkbox.component.js





function checkbox_component_createSuper(t) { var r = checkbox_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function checkbox_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (checkbox_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }




var Checkbox = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Checkbox, _Lightning$Component);
  var _super = checkbox_component_createSuper(Checkbox);
  function Checkbox() {
    (0,classCallCheck/* default */.Z)(this, Checkbox);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Checkbox, [{
    key: "_construct",
    value: function _construct() {
      this._checked = false;
      this._disabled = false;
    }
  }, {
    key: "checked",
    set: function set(value) {
      this._checked = value;
      this.patch(value ? getCheckedStyle() : checkbox_style_getInitialStyle());
    }
  }, {
    key: "disabled",
    set: function set(value) {
      this._disabled = value;
      this.patch(value ? checkbox_style_getDisabledStyle() : checkbox_style_getInitialStyle());
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Border: {
          type: src_Lightning.components.BorderComponent
        },
        Icon: {
          type: Icon
        }
      }, checkbox_style_getInitialStyle());
    }
  }]);
  return Checkbox;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/components/checkBoxBlock/checkBoxBlock.component.js







function checkBoxBlock_component_createSuper(t) { var r = checkBoxBlock_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function checkBoxBlock_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (checkBoxBlock_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }




var CheckBoxBlock = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(CheckBoxBlock, _Lightning$Component);
  var _super = checkBoxBlock_component_createSuper(CheckBoxBlock);
  function CheckBoxBlock() {
    (0,classCallCheck/* default */.Z)(this, CheckBoxBlock);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(CheckBoxBlock, [{
    key: "_build",
    value: function _build() {
      this.checked = false;
    }
  }, {
    key: "data",
    set: function set(_ref) {
      var title = _ref.title,
        description = _ref.description;
      this.patch({
        TextWrapper: {
          Title: {
            text: {
              text: title
            }
          },
          Description: {
            text: {
              text: description
            }
          }
        }
      });
    }
  }, {
    key: "checked",
    get: function get() {
      return this._checked;
    },
    set: function set(value) {
      this.tag('Checkbox').checked = value;
      this._checked = value;
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      this.checked = !this.checked;
      return false;
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this.patch(checkBoxBlock_style_getFocusedStyle());
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this.patch(getUnfocusedStyle());
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        rect: true,
        Checkbox: {
          type: Checkbox
        },
        TextWrapper: {
          Title: {},
          Description: {}
        },
        Border: {
          type: src_Lightning.components.BorderComponent
        }
      }, checkBoxBlock_style_getInitialStyle());
    }
  }]);
  return CheckBoxBlock;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/settings/privacySettings/privacySettings.constants.js
var PRIVACY_SETTINGS_EXIT_SIGNAL = 'privacySettingsExit';
;// CONCATENATED MODULE: ./src/modules/settings/privacySettings/privacySettings.component.js

















function privacySettings_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function privacySettings_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? privacySettings_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : privacySettings_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function privacySettings_component_createSuper(t) { var r = privacySettings_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function privacySettings_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (privacySettings_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }














var PrivacySettings = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(PrivacySettings, _Lightning$Component);
  var _super = privacySettings_component_createSuper(PrivacySettings);
  function PrivacySettings() {
    (0,classCallCheck/* default */.Z)(this, PrivacySettings);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(PrivacySettings, [{
    key: "_construct",
    value: function _construct() {
      this._index = 0;
      this._focusable = [];
      this._visibility = [];
      this._positions = [0];
      this._savedCookies = {};
    }
  }, {
    key: "_attach",
    value: function _attach() {
      this._unsubscribe = privacySettings_connector(this);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      if (this._unsubscribe) {
        this._unsubscribe();
        this._unsubscribe = null;
      }
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      this.setPositions();
      return this.focused;
    }
  }, {
    key: "focused",
    get: function get() {
      return this._focusable[this._index];
    }
  }, {
    key: "setPositions",
    value: function setPositions() {
      var _this = this;
      if (this._positions.length > 1) {
        return;
      }
      this.stage.update();
      this._positions = [0];
      var offset = this.tag('CookieGroups').finalY;
      this._visibility = [{
        BrandIcon: true,
        ArrowUp: false,
        ArrowDown: this.tag('ScrollContent').finalH > this.tag('ScrollWrapper').finalH
      }];
      var bottomOffset = this.tag('ScrollWrapper').finalH - this.tag('ScrollContent').finalH;
      var halfOfScreenHeight = this.tag('ScrollWrapper').finalH / 2;
      this.tag('CookieGroups').children.forEach(function (block) {
        var position = Math.min(Math.max(halfOfScreenHeight - offset - Math.round(block.finalH / 2), bottomOffset), 0);
        _this._positions.push(position);
        offset += block.finalH;
        var isBrandIconVisible = position === 0;
        _this._visibility.push({
          BrandIcon: isBrandIconVisible,
          ArrowUp: !isBrandIconVisible,
          ArrowDown: position !== bottomOffset
        });
      });
      this.setIndex();
    }
  }, {
    key: "setIndex",
    value: function setIndex() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._index;
      this._index = index;
      var itemsVisibility = this._visibility[index];
      this.patch({
        ArrowUp: {
          visible: itemsVisibility.ArrowUp
        },
        BrandIcon: {
          visible: itemsVisibility.BrandIcon
        },
        ScrollWrapper: {
          ScrollContent: {
            smooth: {
              y: index ? this._positions[index] : 0
            }
          }
        },
        ArrowDown: {
          visible: itemsVisibility.ArrowDown
        }
      });
    }
  }, {
    key: "selectedCookies",
    get: function get() {
      return this.tag('CookieGroups').children.reduce(function (memo, item) {
        return privacySettings_component_objectSpread(privacySettings_component_objectSpread({}, memo), {}, (0,defineProperty/* default */.Z)({}, item.category, item.checked));
      }, {});
    }
  }, {
    key: "_dispatchSelectedCategories",
    value: function _dispatchSelectedCategories() {
      if (!this._areGdprCookiesSet || isUpdated(this.savedCookies, this.selectedCookies)) {
        var consent = this.selectedCookies;
        lightningjs_redux.dispatch(setUserConsents(consent));
        sendEvent({
          key: 'gdprChangeConsents',
          consentNames: Object.keys(consent).filter(function (key) {
            return consent[key];
          }).join(',')
        });
      }
    }
  }, {
    key: "_handleUp",
    value: function _handleUp() {
      if (this._index > 0) {
        this.setIndex(this._index - 1);
        return true;
      }
      return false;
    }
  }, {
    key: "_handleDown",
    value: function _handleDown() {
      if (this._index < this._focusable.length - 1) {
        this.setIndex(this._index + 1);
        return true;
      }
      return false;
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      if (this.focused === this.tag('BackButton')) {
        this._dispatchSelectedCategories();
        this.signal(PRIVACY_SETTINGS_EXIT_SIGNAL);
      }
      this.tag('BackButton').label = getBackButtonLabel(this.savedCookies, this.selectedCookies, this._areGdprCookiesSet);
      return true;
    }
  }, {
    key: "_handleBack",
    value: function _handleBack() {
      this._dispatchSelectedCategories();
      this.signal(PRIVACY_SETTINGS_EXIT_SIGNAL);
      return true;
    }
  }, {
    key: "_setCheckbox",
    value: function _setCheckbox(category, value) {
      var checkbox = this.tag('CookieGroups').children.find(function (cookieCategory) {
        return cookieCategory.category === category;
      });
      if (checkbox) {
        checkbox.checked = value;
      }
    }
  }, {
    key: "cookies",
    set: function set(value) {
      var _this2 = this;
      this._savedCookies = value;
      this.tag('CookieGroups').children = Object.keys(value).map(function (cookieCategory) {
        return {
          type: CheckBoxBlock,
          data: {
            title: t("privacySettings.cookie.".concat(cookieCategory, ".title")),
            description: t("privacySettings.cookie.".concat(cookieCategory, ".content"))
          },
          category: cookieCategory
        };
      });
      this._focusable = [this.tag('BackButton')].concat((0,toConsumableArray/* default */.Z)(this.tag('CookieGroups').children));
      Object.entries(value).forEach(function (_ref) {
        var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
          category = _ref2[0],
          value = _ref2[1];
        var checkbox = _this2.tag('CookieGroups').children.find(function (cookieCategory) {
          return cookieCategory.category === category;
        });
        if (checkbox) {
          checkbox.checked = typeof value === 'boolean' ? value : false;
        }
      });
    }
  }, {
    key: "areGdprCookiesSet",
    set: function set(value) {
      this._areGdprCookiesSet = value;
    }
  }, {
    key: "savedCookies",
    get: function get() {
      return this._savedCookies;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Background: {},
        BackButton: {
          type: Button,
          label: t('global.back')
        },
        ArrowUp: {
          type: Icon
        },
        BrandIcon: {
          type: BrandIcon
        },
        ScrollWrapper: {
          ScrollContent: {
            Title: {
              text: {
                text: t('privacySettings.title')
              }
            },
            Description: {
              visible: t('privacySettings.cookie.text'),
              text: {
                text: t('privacySettings.cookie.text')
              }
            },
            CookieGroups: {}
          }
        },
        ArrowDown: {
          type: Icon
        }
      }, privacySettings_style_getInitialStyle());
    }
  }]);
  return PrivacySettings;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/settings/settings.component.js






function settings_component_createSuper(t) { var r = settings_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function settings_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (settings_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }




var settings_component_Settings = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Settings, _Lightning$Component);
  var _super = settings_component_createSuper(Settings);
  function Settings() {
    (0,classCallCheck/* default */.Z)(this, Settings);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Settings, [{
    key: "_active",
    value: function _active() {
      removeSplashScreen();
    }
  }, {
    key: "_handleExitPrivacySettings",
    value: function _handleExitPrivacySettings() {
      Router.back();
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this.tag('Settings');
    }
  }], [{
    key: "_template",
    value: function _template() {
      return {
        Settings: {
          type: PrivacySettings,
          signals: (0,defineProperty/* default */.Z)({}, PRIVACY_SETTINGS_EXIT_SIGNAL, '_handleExitPrivacySettings')
        }
      };
    }
  }]);
  return Settings;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/staticPage/staticPage.style.js

var staticPage_style_BRAND_ICON_SIZE, staticPage_style_ARROW_PADDING_BOTTOM, staticPage_style_ARROW_SIZE, staticPage_style_CONTENT_SIDE_MARGIN, _GRADIENT_HEIGHT;





var staticPage_staticPage_style_BRAND_ICON_SIZE = (staticPage_style_BRAND_ICON_SIZE = {}, (0,defineProperty/* default */.Z)(staticPage_style_BRAND_ICON_SIZE, HD, 64), (0,defineProperty/* default */.Z)(staticPage_style_BRAND_ICON_SIZE, FULL_HD, 72), staticPage_style_BRAND_ICON_SIZE);
var staticPage_staticPage_style_ARROW_PADDING_BOTTOM = (staticPage_style_ARROW_PADDING_BOTTOM = {}, (0,defineProperty/* default */.Z)(staticPage_style_ARROW_PADDING_BOTTOM, HD, 24), (0,defineProperty/* default */.Z)(staticPage_style_ARROW_PADDING_BOTTOM, FULL_HD, 32), staticPage_style_ARROW_PADDING_BOTTOM);
var staticPage_staticPage_style_ARROW_SIZE = (staticPage_style_ARROW_SIZE = {}, (0,defineProperty/* default */.Z)(staticPage_style_ARROW_SIZE, HD, 96), (0,defineProperty/* default */.Z)(staticPage_style_ARROW_SIZE, FULL_HD, 128), staticPage_style_ARROW_SIZE);
var staticPage_staticPage_style_CONTENT_SIDE_MARGIN = (staticPage_style_CONTENT_SIDE_MARGIN = {}, (0,defineProperty/* default */.Z)(staticPage_style_CONTENT_SIDE_MARGIN, HD, 300), (0,defineProperty/* default */.Z)(staticPage_style_CONTENT_SIDE_MARGIN, FULL_HD, 460), staticPage_style_CONTENT_SIDE_MARGIN);
var GRADIENT_HEIGHT = (_GRADIENT_HEIGHT = {}, (0,defineProperty/* default */.Z)(_GRADIENT_HEIGHT, HD, 20), (0,defineProperty/* default */.Z)(_GRADIENT_HEIGHT, FULL_HD, 40), _GRADIENT_HEIGHT);
var VIEWPORT_OFFSET_PERCENTAGE = 0.95;
var staticPage_style_defaultContext = makeDefaultStylingContext();
var staticPage_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : staticPage_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  var topY = safetyMargins.vertical[screenSize];
  var scrollWrapperY = topY + staticPage_staticPage_style_ARROW_SIZE[screenSize] + staticPage_staticPage_style_ARROW_PADDING_BOTTOM[screenSize];
  var scrollWrapperWidth = SCREEN_WIDTH[screenSize] - staticPage_staticPage_style_CONTENT_SIDE_MARGIN[screenSize] * 2;
  var scrollWrapperHeight = sizes_SCREEN_HEIGHT[screenSize] - safetyMargins.vertical[screenSize] - scrollWrapperY - staticPage_staticPage_style_ARROW_SIZE[screenSize];
  var colors = {
    background: makeThemeColor(TERTIARY),
    gradientFill: makeThemeColor(TERTIARY),
    transparent: makeThemeColor(TERTIARY, 0)
  };
  return {
    w: SCREEN_WIDTH[screenSize],
    h: sizes_SCREEN_HEIGHT[screenSize],
    Background: {
      rect: true,
      w: SCREEN_WIDTH[screenSize],
      h: sizes_SCREEN_HEIGHT[screenSize],
      color: colors.background[colorMode]
    },
    BackButton: {
      x: safetyMargins.horizontal[screenSize],
      y: topY
    },
    ArrowUp: {
      y: topY,
      mountX: 0.5,
      x: middle,
      visible: false,
      iconData: {
        picto: {
          name: 'ArrowUp',
          type: ICON_TYPE.SIMPLE_ICON
        },
        viewBox: {
          h: staticPage_staticPage_style_ARROW_SIZE[screenSize]
        }
      }
    },
    BrandIcon: {
      h: staticPage_staticPage_style_BRAND_ICON_SIZE[screenSize],
      y: topY,
      mountX: 0.5,
      x: middle
    },
    ScrollWrapper: {
      zIndex: 1,
      mountX: 0.5,
      x: middle,
      y: scrollWrapperY,
      w: scrollWrapperWidth,
      h: scrollWrapperHeight,
      color: colors.background[colorMode],
      rect: true,
      clipping: true,
      GradientTop: {
        w: scrollWrapperWidth,
        h: GRADIENT_HEIGHT[screenSize],
        zIndex: 2,
        rect: true,
        mountX: 0.5,
        x: middle,
        colorUl: colors.gradientFill[colorMode],
        colorUr: colors.gradientFill[colorMode],
        colorBr: colors.transparent[colorMode],
        colorBl: colors.transparent[colorMode]
      },
      ScrollContent: {
        zIndex: 1,
        w: scrollWrapperWidth,
        flex: {
          direction: 'column'
        }
      },
      GradientBottom: {
        w: scrollWrapperWidth,
        h: GRADIENT_HEIGHT[screenSize],
        zIndex: 2,
        rect: true,
        mountX: 0.5,
        x: middle,
        y: scrollWrapperHeight - GRADIENT_HEIGHT[screenSize],
        colorUr: colors.transparent[colorMode],
        colorUl: colors.transparent[colorMode],
        colorBl: colors.gradientFill[colorMode],
        colorBr: colors.gradientFill[colorMode]
      }
    },
    ArrowDown: {
      mountY: 1,
      y: sizes_SCREEN_HEIGHT[screenSize] - safetyMargins.vertical[screenSize],
      mountX: 0.5,
      x: middle,
      visible: false,
      iconData: {
        picto: {
          name: 'ArrowDown',
          type: ICON_TYPE.SIMPLE_ICON
        },
        viewBox: {
          h: staticPage_staticPage_style_ARROW_SIZE[screenSize]
        }
      }
    }
  };
};
var staticPage_style_gridPadding = {
  left: 224
};
// EXTERNAL MODULE: ./node_modules/.pnpm/markdown-it@12.2.0/node_modules/markdown-it/index.js
var markdown_it = __webpack_require__(19404);
var markdown_it_default = /*#__PURE__*/__webpack_require__.n(markdown_it);
;// CONCATENATED MODULE: ./src/modules/tornado/staticFiles/staticFiles.constants.js
var HEADER_1 = 'h1';
var HEADER_2 = 'h2';
var HEADER_3 = 'h3';
var PARAGRAPH = 'p';
var LIST = 'ul';
var ORDERED_LIST = 'ol';
var SINGLE_LINE_COMPONENTS = [HEADER_1, HEADER_2, HEADER_3, PARAGRAPH];
var LISTS = [LIST, ORDERED_LIST];
;// CONCATENATED MODULE: ./src/modules/tornado/staticFiles/staticFiles.utils.js











var parseInlineBlock = function parseInlineBlock(block) {
  var content = '';
  block.children.filter(function (n) {
    return n.type === 'text' || n.type === 'hardbreak';
  }).forEach(function (n) {
    content += n.type === 'hardbreak' ? '\n' : n.content;
  });
  return content;
};
var prepareEnbeddedList = function prepareEnbeddedList(blocks) {
  var getEmptyNode = function getEmptyNode() {
    return {
      originalIndex: undefined,
      content: ''
    };
  };
  var nodes = [];
  var node = getEmptyNode();
  blocks.forEach(function (block) {
    if (block.type === 'list_item_open') {
      node.originalIndex = block.info;
    } else if (block.type === 'list_item_close') {
      nodes.push(node);
      node = getEmptyNode();
    } else if (block.type === 'inline') {
      node.content = block.content;
    }
  });
  return nodes;
};
var prepareBlockValue = function prepareBlockValue(type, blocks) {
  var node = {
    tag: type
  };
  if (SINGLE_LINE_COMPONENTS.includes(type)) {
    node.content = '';
    var block = blocks[0];
    if (block.type === 'inline' && block.children) {
      node.content = parseInlineBlock(block);
    }
  } else if (LISTS.includes(type)) {
    node.content = [];
    node.content = prepareEnbeddedList(blocks);
  }
  return node;
};
var filterNodes = function filterNodes(nodes) {
  var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var openNode = nodes[0];
  var closeType = openNode.type.replace('_open', '_close');
  var closeNode = nodes.find(function (n) {
    return n.type === closeType;
  });
  var stopIndex = nodes.indexOf(closeNode);
  var blockValue = nodes.slice(1, stopIndex);
  values.push(prepareBlockValue(openNode.tag, blockValue));
  var nextBlock = nodes.slice(stopIndex + 1);
  return nextBlock.length ? filterNodes(nextBlock, values) : values;
};
var parseFile = function parseFile(url) {
  return client_default().get(url).then(function (data) {
    return new (markdown_it_default())().parse(data.text);
  });
};
;// CONCATENATED MODULE: ./src/modules/tornado/staticFiles/staticFiles.styles.js

var _PARAGRAPH_MARGIN, _HEADER_1_MARGIN, _HEADER_2_MARGIN, _HEADER_3_MARGIN, _LIST_NODE_MARGIN;
function staticFiles_styles_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function staticFiles_styles_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? staticFiles_styles_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : staticFiles_styles_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



var staticFiles_styles_defaultContext = makeDefaultStylingContext();
var getParagraphFont = function getParagraphFont(screenSize) {
  return src_getFont(constants_FONT.MADRID_1, screenSize);
};
var getHeader1Font = function getHeader1Font(screenSize) {
  return src_getFont(constants_FONT.KINSHASA_3, screenSize);
};
var getHeader2Font = function getHeader2Font(screenSize) {
  return src_getFont(constants_FONT.MADRID_3, screenSize);
};
var getHeader3Font = function getHeader3Font(screenSize) {
  return src_getFont(constants_FONT.KINSHASA_1, screenSize);
};
var PARAGRAPH_MARGIN = (_PARAGRAPH_MARGIN = {}, (0,defineProperty/* default */.Z)(_PARAGRAPH_MARGIN, HD, 24), (0,defineProperty/* default */.Z)(_PARAGRAPH_MARGIN, FULL_HD, 32), _PARAGRAPH_MARGIN);
var HEADER_1_MARGIN = (_HEADER_1_MARGIN = {}, (0,defineProperty/* default */.Z)(_HEADER_1_MARGIN, HD, 24), (0,defineProperty/* default */.Z)(_HEADER_1_MARGIN, FULL_HD, 56), _HEADER_1_MARGIN);
var HEADER_2_MARGIN = (_HEADER_2_MARGIN = {}, (0,defineProperty/* default */.Z)(_HEADER_2_MARGIN, HD, 24), (0,defineProperty/* default */.Z)(_HEADER_2_MARGIN, FULL_HD, 32), _HEADER_2_MARGIN);
var HEADER_3_MARGIN = (_HEADER_3_MARGIN = {}, (0,defineProperty/* default */.Z)(_HEADER_3_MARGIN, HD, 24), (0,defineProperty/* default */.Z)(_HEADER_3_MARGIN, FULL_HD, 32), _HEADER_3_MARGIN);
var LIST_NODE_MARGIN = (_LIST_NODE_MARGIN = {}, (0,defineProperty/* default */.Z)(_LIST_NODE_MARGIN, HD, 24), (0,defineProperty/* default */.Z)(_LIST_NODE_MARGIN, FULL_HD, 56), _LIST_NODE_MARGIN);
var paragraphNodeStyle = function paragraphNodeStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : staticFiles_styles_defaultContext,
    screenSize = _ref.screenSize;
  return {
    flexItem: {
      marginBottom: PARAGRAPH_MARGIN[screenSize]
    },
    text: staticFiles_styles_objectSpread(staticFiles_styles_objectSpread({}, getParagraphFont(screenSize)), {}, {
      verticalAlign: 'bottom'
    })
  };
};
var header1NodeStyle = function header1NodeStyle() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : staticFiles_styles_defaultContext,
    screenSize = _ref2.screenSize;
  return {
    flexItem: {
      marginBottom: HEADER_1_MARGIN[screenSize],
      alignSelf: 'center'
    },
    text: staticFiles_styles_objectSpread(staticFiles_styles_objectSpread({}, getHeader1Font(screenSize)), {}, {
      textAlign: 'center',
      verticalAlign: 'bottom'
    })
  };
};
var header2NodeStyle = function header2NodeStyle() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : staticFiles_styles_defaultContext,
    screenSize = _ref3.screenSize;
  return {
    flexItem: {
      marginBottom: HEADER_2_MARGIN[screenSize],
      alignSelf: 'center'
    },
    text: staticFiles_styles_objectSpread(staticFiles_styles_objectSpread({}, getHeader2Font(screenSize)), {}, {
      textAlign: 'center',
      verticalAlign: 'bottom'
    })
  };
};
var header3NodeStyle = function header3NodeStyle() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : staticFiles_styles_defaultContext,
    screenSize = _ref4.screenSize;
  return {
    flexItem: {
      marginBottom: HEADER_3_MARGIN[screenSize],
      alignSelf: 'center'
    },
    text: staticFiles_styles_objectSpread(staticFiles_styles_objectSpread({}, getHeader3Font(screenSize)), {}, {
      textAlign: 'center',
      verticalAlign: 'bottom'
    })
  };
};
var listNodeStyle = function listNodeStyle() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : staticFiles_styles_defaultContext,
    screenSize = _ref5.screenSize;
  return {
    flexItem: {
      marginBottom: LIST_NODE_MARGIN[screenSize]
    },
    flex: {
      direction: 'column'
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/staticFiles/staticFiles.renders.js






var renderH1Node = function renderH1Node(node, config) {
  var content = node.content;
  var wordWrap = config.wordWrap;
  return merge_default()({
    text: {
      text: content,
      wordWrapWidth: wordWrap
    }
  }, header1NodeStyle(config));
};
var renderH2Node = function renderH2Node(node, config) {
  var content = node.content;
  var wordWrap = config.wordWrap;
  return merge_default()({
    text: {
      text: content,
      wordWrapWidth: wordWrap
    }
  }, header2NodeStyle(config));
};
var renderH3Node = function renderH3Node(node, config) {
  var content = node.content;
  var wordWrap = config.wordWrap;
  return merge_default()({
    text: {
      text: content,
      wordWrapWidth: wordWrap
    }
  }, header3NodeStyle(config));
};
var renderPNode = function renderPNode(node, config) {
  var content = node.content;
  var wordWrap = config.wordWrap;
  return merge_default()({
    text: {
      text: content,
      wordWrapWidth: wordWrap
    }
  }, paragraphNodeStyle(config));
};
var renderListItem = function renderListItem(node, config) {
  var content = node.content;
  var wordWrap = config.wordWrap;
  var text = (0,esm_typeof/* default */.Z)(content) === 'object' && content.originalIndex ? "  ".concat(content.originalIndex, ".  ").concat(content.content) : "  \u2022  ".concat(content.content);
  return merge_default()({
    text: {
      text: text,
      wordWrapWidth: wordWrap
    }
  }, paragraphNodeStyle(config));
};
var renderListNode = function renderListNode(node, config) {
  var content = node.content;
  return merge_default()({
    children: content.map(function (item) {
      return renderListItem({
        content: item
      }, config);
    })
  }, listNodeStyle(config));
};
var renderOrderedListItem = function renderOrderedListItem(node, config) {
  var content = node.content,
    index = node.index;
  var wordWrap = config.wordWrap;
  var text = (0,esm_typeof/* default */.Z)(content) === 'object' && content.originalIndex ? "  ".concat(content.originalIndex, ".  ").concat(content.content) : "  ".concat(index + 1, ".  ").concat(content);
  return merge_default()({
    text: {
      text: text,
      wordWrapWidth: wordWrap
    }
  }, paragraphNodeStyle(config));
};
var renderOrderedListNode = function renderOrderedListNode(node, config) {
  var content = node.content;
  return merge_default()({
    children: content.map(function (item, index) {
      return renderOrderedListItem({
        content: item,
        index: index
      }, config);
    })
  }, listNodeStyle(config));
};
var renderNode = function renderNode(node, config) {
  switch (node.tag) {
    case HEADER_1:
      return renderH1Node(node, config);
    case HEADER_2:
      return renderH2Node(node, config);
    case HEADER_3:
      return renderH3Node(node, config);
    case PARAGRAPH:
      return renderPNode(node, config);
    case LIST:
      return renderListNode(node, config);
    case ORDERED_LIST:
      return renderOrderedListNode(node, config);
    default:
      return {};
  }
};
var renderFile = function renderFile(file, config) {
  var lastItemIndex = file.length - 1;
  return file.map(function (node, i) {
    var isLastItem = i === lastItemIndex;
    var newNode = renderNode(node, config);
    if (newNode.children && newNode.children.length > 0) {
      newNode.children[newNode.children.length - 1].flexItem.marginBottom = 0;
    }
    if (isLastItem) {
      newNode.flexItem.marginBottom = 0;
    }
    return newNode;
  });
};
;// CONCATENATED MODULE: ./src/modules/staticPage/staticPage.component.js







function staticPage_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function staticPage_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? staticPage_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : staticPage_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function staticPage_component_createSuper(t) { var r = staticPage_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function staticPage_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (staticPage_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }











var StaticPage = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(StaticPage, _Lightning$Component);
  var _super = staticPage_component_createSuper(StaticPage);
  function StaticPage() {
    (0,classCallCheck/* default */.Z)(this, StaticPage);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(StaticPage, [{
    key: "_construct",
    value: function _construct() {
      this._index = 0;
      this._containerH = 0;
      this._focusedContent = false;
      this._lastElementTxLoaded = false;
    }
  }, {
    key: "_active",
    value: function _active() {
      removeSplashScreen();
    }
  }, {
    key: "target",
    set: function set(pageName) {
      var _this = this;
      var content = this.tag('ScrollContent');
      var fileURL = [src.staticFiles.base, src.customerCode, src.staticFiles.files[pageName]].join('/');
      parseFile(fileURL).then(function (data) {
        var textItems = renderFile(filterNodes(data), staticPage_component_objectSpread(staticPage_component_objectSpread({}, _this._config), {}, {
          wordWrap: _this.tag('ScrollWrapper').w
        }));
        content.children = textItems;
        var lastElement = content.children.at(-1).children.at(0);
        if (lastElement) {
          lastElement.once('txLoaded', function () {
            _this._lastElementTxLoaded = true;
          });
        }
      }, function (err) {});
      this._updateFocus(true);
    }
  }, {
    key: "viewPortHeight",
    get: function get() {
      return Math.round(this.tag('ScrollWrapper').finalH * VIEWPORT_OFFSET_PERCENTAGE);
    }
  }, {
    key: "_positions",
    get: function get() {
      if (this._isSinglePage()) return 1;
      return Math.ceil(this.tag('ScrollContent').finalH / this.viewPortHeight);
    }
  }, {
    key: "_build",
    value: function _build() {
      var _this2 = this;
      this._config = staticPage_style_defaultContext;
      var content = this.tag('ScrollContent');
      content.onUpdate = function () {
        var finalH = content.finalH;
        if (finalH > 0) {
          _this2.setPositions();
          _this2._updateFocus(!_this2._isSinglePage());
        }
      };
    }
  }, {
    key: "_updateFocus",
    value: function _updateFocus(value) {
      if (this._focusedContent !== value) {
        this._focusedContent = value;
        this._refocus();
      }
    }
  }, {
    key: "_isSinglePage",
    value: function _isSinglePage() {
      var wrapperH = this.tag('ScrollWrapper').finalH;
      return wrapperH > this._containerH;
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      if (this._focusedContent) {
        return undefined;
      }
      var button = this.tag('BackButton');
      if (button && button.visible) {
        return button;
      }
      return undefined;
    }
  }, {
    key: "setPositions",
    value: function setPositions() {
      var contentH = this.tag('ScrollContent').finalH;
      if (this._positions > 0 && this._containerH === contentH) {
        return;
      }
      this._containerH = contentH;
      this.setIndex();
    }
  }, {
    key: "setIndex",
    value: function setIndex() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._index;
      this._index = index;
      var isLastPage = this.tag('ScrollContent').finalH - (this._index + 1) * this.viewPortHeight < this.viewPortHeight;
      var smooth = 0;
      if (isLastPage && this._lastElementTxLoaded) {
        smooth = this.tag('ScrollContent').finalH - this.viewPortHeight;
      } else {
        smooth = index ? this._index * this.viewPortHeight : 0;
      }
      this.patch({
        ArrowUp: {
          visible: this._index > 0
        },
        BrandIcon: {
          visible: this._index === 0
        },
        ScrollWrapper: {
          GradientTop: {
            visible: this._index > 0
          },
          ScrollContent: {
            smooth: {
              y: -smooth
            }
          }
        },
        ArrowDown: {
          visible: this._index < this._positions - 1 && !(isLastPage && this._lastElementTxLoaded)
        }
      });
    }
  }, {
    key: "_handleUp",
    value: function _handleUp() {
      if (this._index > 0) {
        this.setIndex(this._index - 1);
        return true;
      }
      if (this._index === 0 && this._focusedContent) {
        this._updateFocus(false);
        return true;
      }
      return false;
    }
  }, {
    key: "_handleDown",
    value: function _handleDown() {
      if (!this._focusedContent && !this._isSinglePage()) {
        this._updateFocus(true);
        return true;
      }
      if (this._index < this._positions - 1 && !this._isSinglePage()) {
        this.setIndex(this._index + 1);
        return true;
      }
      return false;
    }
  }, {
    key: "_handleBack",
    value: function _handleBack() {
      Router.back();
      return true;
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      if (this._getFocused() === this.tag('BackButton')) {
        Router.back();
        return true;
      }
      return false;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Background: {},
        BackButton: {
          type: Button,
          label: t('global.back'),
          visible: false
        },
        ArrowUp: {
          type: Icon
        },
        BrandIcon: {
          type: BrandIcon
        },
        ScrollWrapper: {
          GradientTop: {},
          ScrollContent: {},
          GradientBottom: {}
        },
        ArrowDown: {
          type: Icon
        }
      }, staticPage_style_getInitialStyle());
    }
  }]);
  return StaticPage;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/subscriptionExpired/new/base/subscriptionExpiredBase.style.js

var subscriptionExpiredBase_style_LOGO_HEIGHT, subscriptionExpiredBase_style_ICON_MARGIN_BOTTOM;
function subscriptionExpiredBase_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function subscriptionExpiredBase_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? subscriptionExpiredBase_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : subscriptionExpiredBase_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





var subscriptionExpiredBase_style_defaultContext = makeDefaultStylingContext();
var subscriptionExpiredBase_style_colors = {
  background: makeThemeColor(TERTIARY),
  separator: makeThemeColor(PRIMARY, 0.3)
};

var base_subscriptionExpiredBase_style_LOGO_HEIGHT = (subscriptionExpiredBase_style_LOGO_HEIGHT = {}, (0,defineProperty/* default */.Z)(subscriptionExpiredBase_style_LOGO_HEIGHT, HD, 96), (0,defineProperty/* default */.Z)(subscriptionExpiredBase_style_LOGO_HEIGHT, FULL_HD, 152), subscriptionExpiredBase_style_LOGO_HEIGHT);
var subscriptionExpiredBase_style_ICON_MARGIN_TOP = subscriptionExpiredBase_style_objectSpread({}, safetyMargins.vertical);
var base_subscriptionExpiredBase_style_ICON_MARGIN_BOTTOM = (subscriptionExpiredBase_style_ICON_MARGIN_BOTTOM = {}, (0,defineProperty/* default */.Z)(subscriptionExpiredBase_style_ICON_MARGIN_BOTTOM, HD, 24), (0,defineProperty/* default */.Z)(subscriptionExpiredBase_style_ICON_MARGIN_BOTTOM, FULL_HD, 24), subscriptionExpiredBase_style_ICON_MARGIN_BOTTOM);
var subscriptionExpiredBase_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : subscriptionExpiredBase_style_defaultContext,
    _ref$screenSize = _ref.screenSize,
    screenSize = _ref$screenSize === void 0 ? FULL_HD : _ref$screenSize,
    _ref$colorMode = _ref.colorMode,
    colorMode = _ref$colorMode === void 0 ? DEFAULT_MODE : _ref$colorMode;
  var top = subscriptionExpiredBase_style_ICON_MARGIN_TOP[screenSize] + base_subscriptionExpiredBase_style_LOGO_HEIGHT[screenSize] + base_subscriptionExpiredBase_style_ICON_MARGIN_BOTTOM[screenSize];
  var containerHeight = sizes_SCREEN_HEIGHT[screenSize] - top - safetyMargins.vertical[screenSize];
  var rightWidth = SCREEN_WIDTH[screenSize] - safetyMargins.horizontal[screenSize] * 2 - selector_pairingSelector_style_WIDTH[screenSize] - SPACER[screenSize];
  return {
    w: SCREEN_WIDTH[screenSize],
    h: sizes_SCREEN_HEIGHT[screenSize],
    Background: {
      w: SCREEN_WIDTH[screenSize],
      h: sizes_SCREEN_HEIGHT[screenSize],
      color: subscriptionExpiredBase_style_colors.background[colorMode]
    },
    CustomerIcon: {
      y: subscriptionExpiredBase_style_ICON_MARGIN_TOP[screenSize],
      mountX: 0.5,
      x: middle,
      h: base_subscriptionExpiredBase_style_LOGO_HEIGHT[screenSize]
    },
    Left: {
      y: top,
      h: containerHeight
    },
    Right: {
      x: safetyMargins.horizontal[screenSize] + selector_pairingSelector_style_WIDTH[screenSize] + SPACER[screenSize],
      y: top,
      h: containerHeight,
      w: rightWidth,
      Mobile: {
        visible: false,
        h: containerHeight,
        w: rightWidth
      },
      Desktop: {
        visible: false,
        h: containerHeight,
        w: rightWidth
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/subscriptionExpired/new/base/subscriptionExpiredBase.connector.js




var subscriptionExpiredBase_connector_mapControllers = function mapControllers(instance) {
  return [{
    shouldBeInvokedOnConnect: true,
    selector: user_selectors_getPairingUid,
    callback: function callback(value) {
      instance.isPaired = Boolean(value);
    }
  }, {
    shouldBeInvokedOnConnect: true,
    selector: getPremiumServices,
    callback: function callback(value) {
      instance.services = value;
    }
  }, {
    shouldBeInvokedOnConnect: true,
    selector: getRequestedEntityType,
    callback: function callback(value) {
      instance.entityType = value;
    }
  }, {
    shouldBeInvokedOnConnect: true,
    selector: getRequestedEntityId,
    callback: function callback(value) {
      instance.entityId = value;
    }
  }];
};
/* harmony default export */ const subscriptionExpiredBase_connector = (lightningjs_redux.control(subscriptionExpiredBase_connector_mapControllers));
;// CONCATENATED MODULE: ./src/modules/subscriptionExpired/new/base/subscriptionExpiredBase.component.js













function subscriptionExpiredBase_component_createSuper(t) { var r = subscriptionExpiredBase_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function subscriptionExpiredBase_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (subscriptionExpiredBase_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }





















var SubscriptionExpiredBase = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(SubscriptionExpiredBase, _Lightning$Component);
  var _super = subscriptionExpiredBase_component_createSuper(SubscriptionExpiredBase);
  function SubscriptionExpiredBase() {
    (0,classCallCheck/* default */.Z)(this, SubscriptionExpiredBase);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(SubscriptionExpiredBase, [{
    key: "_construct",
    value: function _construct() {
      this._style = subscriptionExpiredBase_style_defaultContext;
      this._focusedButton = 0;
      this._lock = null;
      this._views = ['Mobile', 'Desktop'];
    }
  }, {
    key: "_build",
    value: function _build() {
      this.tag(this._views[0]).visible = true;
    }
  }, {
    key: "_active",
    value: function _active() {
      this._unsubscribe = subscriptionExpiredBase_connector(this);
      this._isLoading = true;
      removeSplashScreen();
      this._setState('Left');
    }
  }, {
    key: "_inactive",
    value: function _inactive() {
      this._isLoading = false;
      this._lock = null;
      if (this._unsubscribe) {
        this._unsubscribe();
        this._unsubscribe = null;
      }
      if (this._popupHidingTimeout) {
        clearTimeout(this._popupHidingTimeout);
      }
    }
  }, {
    key: "_switchViews",
    value: function _switchViews(index) {
      var _this = this;
      if (index >= this._views.length) {
        this._hideScreen();
        return;
      }
      this._views.forEach(function (view, i) {
        _this.tag(view).visible = i === index;
      });
    }
  }, {
    key: "isPaired",
    set: function set(value) {
      this._isPaired = value;
    }
  }, {
    key: "lock",
    set: function set(value) {
      this._lock = value;
    }
  }, {
    key: "payload",
    set: function set(value) {
      this._payload = value;
    }
  }, {
    key: "services",
    set: function set(value) {
      this._services = value;
    }
  }, {
    key: "requiredFeatures",
    set: function set(value) {
      this._requiredFeatures = value;
    }
  }, {
    key: "entityType",
    set: function set(value) {
      this._entityType = value;
    }
  }, {
    key: "entityId",
    set: function set(value) {
      this._entityId = value;
    }
  }, {
    key: "_handleUnlockAttempt",
    value: function () {
      var _handleUnlockAttempt2 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee() {
        var _this2 = this;
        var target, prefix;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this._isPaired) {
                _context.next = 5;
                break;
              }
              if (this._lock) {
                target = getNestedOriginalTarget(this._lock.originalTarget);
                if (target) {
                  lightningjs_redux.dispatch(setDeeplinkLocation(target));
                }
              } else if (this._entityType && this._entityId) {
                prefix = getUnlockPathPrefix(this._entityType);
                lightningjs_redux.dispatch(setDeeplinkLocation("".concat(prefix).concat(this._entityType, "/").concat(this._entityId)));
              }
              navigateTo(PAIRING_PATH);
              this._popupHidingTimeout = setTimeout(function () {
                _this2.signal(HIDE_POPUP_SIGNAL);
              }, 100);
              return _context.abrupt("return");
            case 5:
              if (!(this._payload || this._entityType)) {
                _context.next = 12;
                break;
              }
              _context.prev = 6;
              _context.next = 9;
              return lightningjs_redux.dispatch(fetchUserSubscription());
            case 9:
              _context.prev = 9;
              if (this._isLoading) {
                this._resolveLock();
              }
              return _context.finish(9);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[6,, 9, 12]]);
      }));
      function _handleUnlockAttempt() {
        return _handleUnlockAttempt2.apply(this, arguments);
      }
      return _handleUnlockAttempt;
    }()
  }, {
    key: "_resolveLock",
    value: function _resolveLock() {
      if (this._payload) {
        lightningjs_redux.dispatch(createItemAction(this._payload));
      } else if (this._entityType && this._entityId) {
        lightningjs_redux.dispatch(fetchLayout(this._entityType, this._entityId));
      }
      this.signal(HIDE_POPUP_SIGNAL);
    }
  }, {
    key: "_hideScreen",
    value: function _hideScreen() {
      if (this._lock) {
        this.signal(HIDE_POPUP_SIGNAL);
        if (isPlayerLocked(this._entityType)) {
          Router.back();
        }
      } else {
        Router.back();
      }
    }
  }, {
    key: "_handleBack",
    value: function _handleBack() {
      sendEvent({
        key: 'pressTokenBackButton'
      });
      return false;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Background: {
          rect: true
        },
        CustomerIcon: {
          type: BrandIcon
        },
        Left: {
          type: PairingSelector,
          buttons: [{
            label: t('pairing.token.mobile.button'),
            iconLeft: 'QRCode',
            iconRight: 'ArrowRight'
          }, {
            label: t('pairing.token.computer.button'),
            iconLeft: 'Laptop',
            iconRight: 'ArrowRight'
          }, {
            label: t('pairing.subscribe.offer.back')
          }],
          labels: {
            features: [t('pairing.subscribe.offers.offer1'), t('pairing.subscribe.offers.offer2'), t('pairing.subscribe.offers.offer3')],
            title: t('pairing.subscribe.offers.title')
          },
          signals: (0,defineProperty/* default */.Z)({}, SELECTED_SIGNAL, '_switchViews')
        },
        Right: {
          Mobile: {
            type: MobilePairing,
            labels: {
              title: t('pairing.subscribe.how'),
              steps: 'pairing.subscribe.mobile.steps.step',
              stepsCount: 3
            },
            button: t('pairing.subscribe.button'),
            url: src.pairing.subscriptionURL,
            signals: (0,defineProperty/* default */.Z)({}, SELECTED_SIGNAL, '_handleUnlockAttempt')
          },
          Desktop: {
            type: DesktopPairing,
            labels: {
              title: t('pairing.subscribe.how'),
              steps: 'pairing.subscribe.computer.steps.step',
              stepsCount: 3
            },
            button: t('pairing.subscribe.button'),
            signals: (0,defineProperty/* default */.Z)({}, SELECTED_SIGNAL, '_handleUnlockAttempt')
          }
        }
      }, subscriptionExpiredBase_style_getInitialStyle());
    }
  }, {
    key: "_states",
    value: function _states() {
      return [function (_this3) {
        (0,inherits/* default */.Z)(Left, _this3);
        var _super2 = subscriptionExpiredBase_component_createSuper(Left);
        function Left() {
          (0,classCallCheck/* default */.Z)(this, Left);
          return _super2.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(Left, [{
          key: "_getFocused",
          value: function _getFocused() {
            return this.tag('Left');
          }
        }, {
          key: "_handleRight",
          value: function _handleRight() {
            this._setState('Right');
            return true;
          }
        }]);
        return Left;
      }(this), function (_this4) {
        (0,inherits/* default */.Z)(Right, _this4);
        var _super3 = subscriptionExpiredBase_component_createSuper(Right);
        function Right() {
          (0,classCallCheck/* default */.Z)(this, Right);
          return _super3.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(Right, [{
          key: "_getFocused",
          value: function _getFocused() {
            var _this5 = this;
            return this._views.map(function (id) {
              return _this5.tag(id);
            }).find(function (view) {
              return view.visible;
            });
          }
        }, {
          key: "_handleLeft",
          value: function _handleLeft() {
            this._setState('Left');
            return true;
          }
        }]);
        return Right;
      }(this)];
    }
  }]);
  return SubscriptionExpiredBase;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/subscriptionExpired/new/subscription/subscriptionExpired.component.js





function subscriptionExpired_component_createSuper(t) { var r = subscriptionExpired_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function subscriptionExpired_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (subscriptionExpired_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var SubscriptionExpired = function (_SubscriptionExpiredB) {
  (0,inherits/* default */.Z)(SubscriptionExpired, _SubscriptionExpiredB);
  var _super = subscriptionExpired_component_createSuper(SubscriptionExpired);
  function SubscriptionExpired() {
    (0,classCallCheck/* default */.Z)(this, SubscriptionExpired);
    return _super.apply(this, arguments);
  }
  return (0,createClass/* default */.Z)(SubscriptionExpired);
}(SubscriptionExpiredBase);
;// CONCATENATED MODULE: ./src/modules/subscriptionExpired/customer/rtlde/subscriptionExpired.component.js


;// CONCATENATED MODULE: ./src/modules/subscriptionExpired/subscriptionExpired.component.js

;// CONCATENATED MODULE: ./src/modules/qrCode/qrCode.style.js

var _CONTENT_PADDING_TOP, _CONTENT_PADDING_LEFT, _QR_CODE_WRAPPER_PADD, _QR_CODE_WRAPPER_SIZE, _QR_CODE_TITLE_PADDIN, _QR_CODE_IMAGE_PADDIN, _QR_CODE_IMAGE_SIZE, _QR_CODE_INFO_PADDING, _PAGE_TITLE_FONT, _QR_TITLE_FONT, _INFO_WRAP_WIDTH;
function qrCode_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function qrCode_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? qrCode_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : qrCode_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





var qrCode_style_defaultContext = {
  screenSize: sizes_getScreenSize(),
  colorMode: DEFAULT_MODE
};
var qrCode_style_defaultContext$scree = qrCode_style_defaultContext.screenSize,
  qrCode_style_screenSize = qrCode_style_defaultContext$scree === void 0 ? FULL_HD : qrCode_style_defaultContext$scree;

var qrCode_style_colors = {
  background: makeThemeColor(TERTIARY),
  text: makeThemeColor(PRIMARY),
  border: makeThemeColor(PRIMARY, 0.3)
};
var CONTENT_PADDING_TOP = (_CONTENT_PADDING_TOP = {}, (0,defineProperty/* default */.Z)(_CONTENT_PADDING_TOP, HD, 24), (0,defineProperty/* default */.Z)(_CONTENT_PADDING_TOP, FULL_HD, 36), _CONTENT_PADDING_TOP);
var CONTENT_PADDING_LEFT = (_CONTENT_PADDING_LEFT = {}, (0,defineProperty/* default */.Z)(_CONTENT_PADDING_LEFT, HD, 372), (0,defineProperty/* default */.Z)(_CONTENT_PADDING_LEFT, FULL_HD, 698), _CONTENT_PADDING_LEFT);
var QR_CODE_WRAPPER_PADDING_TOP = (_QR_CODE_WRAPPER_PADD = {}, (0,defineProperty/* default */.Z)(_QR_CODE_WRAPPER_PADD, HD, 120), (0,defineProperty/* default */.Z)(_QR_CODE_WRAPPER_PADD, FULL_HD, 202), _QR_CODE_WRAPPER_PADD);
var QR_CODE_WRAPPER_SIZE = (_QR_CODE_WRAPPER_SIZE = {}, (0,defineProperty/* default */.Z)(_QR_CODE_WRAPPER_SIZE, HD, {
  w: 452,
  h: 422
}), (0,defineProperty/* default */.Z)(_QR_CODE_WRAPPER_SIZE, FULL_HD, {
  w: 580,
  h: 598
}), _QR_CODE_WRAPPER_SIZE);
var QR_CODE_TITLE_PADDING_TOP = (_QR_CODE_TITLE_PADDIN = {}, (0,defineProperty/* default */.Z)(_QR_CODE_TITLE_PADDIN, HD, 48), (0,defineProperty/* default */.Z)(_QR_CODE_TITLE_PADDIN, FULL_HD, 64), _QR_CODE_TITLE_PADDIN);
var QR_CODE_IMAGE_PADDING_TOP = (_QR_CODE_IMAGE_PADDIN = {}, (0,defineProperty/* default */.Z)(_QR_CODE_IMAGE_PADDIN, HD, 40), (0,defineProperty/* default */.Z)(_QR_CODE_IMAGE_PADDIN, FULL_HD, 64), _QR_CODE_IMAGE_PADDIN);
var QR_CODE_IMAGE_SIZE = (_QR_CODE_IMAGE_SIZE = {}, (0,defineProperty/* default */.Z)(_QR_CODE_IMAGE_SIZE, HD, {
  w: 162,
  h: 162
}), (0,defineProperty/* default */.Z)(_QR_CODE_IMAGE_SIZE, FULL_HD, {
  w: 250,
  h: 250
}), _QR_CODE_IMAGE_SIZE);
var QR_CODE_INFO_PADDING_TOP = (_QR_CODE_INFO_PADDING = {}, (0,defineProperty/* default */.Z)(_QR_CODE_INFO_PADDING, HD, 40), (0,defineProperty/* default */.Z)(_QR_CODE_INFO_PADDING, FULL_HD, 56), _QR_CODE_INFO_PADDING);
var PAGE_TITLE_FONT = (_PAGE_TITLE_FONT = {}, (0,defineProperty/* default */.Z)(_PAGE_TITLE_FONT, HD, constants_FONT.OTTAWA_3), (0,defineProperty/* default */.Z)(_PAGE_TITLE_FONT, FULL_HD, constants_FONT.PARIS_3), _PAGE_TITLE_FONT);
var QR_TITLE_FONT = (_QR_TITLE_FONT = {}, (0,defineProperty/* default */.Z)(_QR_TITLE_FONT, HD, constants_FONT.KINSHASA_3), (0,defineProperty/* default */.Z)(_QR_TITLE_FONT, FULL_HD, constants_FONT.KINSHASA_3), _QR_TITLE_FONT);
var INFO_WRAP_WIDTH = (_INFO_WRAP_WIDTH = {}, (0,defineProperty/* default */.Z)(_INFO_WRAP_WIDTH, HD, 388), (0,defineProperty/* default */.Z)(_INFO_WRAP_WIDTH, FULL_HD, 485), _INFO_WRAP_WIDTH);
var qrCode_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : qrCode_style_defaultContext;
  var _context$screenSize = context.screenSize,
    screenSize = _context$screenSize === void 0 ? FULL_HD : _context$screenSize,
    _context$colorMode = context.colorMode,
    colorMode = _context$colorMode === void 0 ? DEFAULT_MODE : _context$colorMode;
  return {
    w: SCREEN_WIDTH[screenSize],
    h: sizes_SCREEN_HEIGHT[screenSize],
    Background: {
      rect: true,
      h: identity,
      w: identity,
      color: qrCode_style_colors.background[colorMode]
    },
    Content: {
      x: CONTENT_PADDING_LEFT[screenSize],
      y: CONTENT_PADDING_TOP[screenSize],
      flex: {
        direction: 'column',
        alignItems: 'center'
      },
      PageTitle: {
        text: qrCode_style_objectSpread(qrCode_style_objectSpread({}, src_getFont(PAGE_TITLE_FONT[screenSize], screenSize)), {}, {
          verticalAlign: 'middle',
          textColor: qrCode_style_colors.text[colorMode]
        })
      },
      QRCodeWrapper: {
        flex: {
          direction: 'column',
          alignItems: 'center'
        },
        y: QR_CODE_WRAPPER_PADDING_TOP[screenSize],
        texture: src_Lightning.Tools.getRoundRect(QR_CODE_WRAPPER_SIZE[screenSize].w, QR_CODE_WRAPPER_SIZE[screenSize].h, 8, qrCode_style_colors.border[colorMode] ? 1 : 0, qrCode_style_colors.border[colorMode], true, qrCode_style_colors.background[colorMode]),
        Title: {
          flexItem: {
            marginTop: QR_CODE_TITLE_PADDING_TOP[screenSize]
          },
          text: qrCode_style_objectSpread(qrCode_style_objectSpread({}, src_getFont(QR_TITLE_FONT[screenSize], screenSize)), {}, {
            verticalAlign: 'middle',
            textColor: qrCode_style_colors.text[colorMode]
          })
        },
        Code: {
          flexItem: {
            marginTop: QR_CODE_IMAGE_PADDING_TOP[screenSize]
          },
          rect: true,
          h: QR_CODE_IMAGE_SIZE[screenSize].h,
          w: QR_CODE_IMAGE_SIZE[screenSize].w,
          color: qrCode_style_colors.text[colorMode],
          shader: {
            type: src_Lightning.shaders.RoundedRectangle,
            radius: 8,
            strokeColor: qrCode_style_colors.text[colorMode]
          }
        },
        Info: {
          flexItem: {
            marginTop: QR_CODE_INFO_PADDING_TOP[screenSize]
          },
          text: qrCode_style_objectSpread(qrCode_style_objectSpread({}, src_getFont(constants_FONT.BERLIN_1, screenSize)), {}, {
            maxLines: 3,
            verticalAlign: 'middle',
            wordBreak: true,
            advancedRenderer: true,
            wordWrapWidth: INFO_WRAP_WIDTH[screenSize],
            textAlign: 'center',
            textColor: qrCode_style_colors.text[colorMode]
          })
        }
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/qrCode/qrCode.utils.js
var pageToTranslationMap = {
  information: 'accountInformation',
  account_settings: 'accountSettings'
};
var getPageTranslationKey = function getPageTranslationKey(key) {
  return pageToTranslationMap[key] ? pageToTranslationMap[key] : key;
};
;// CONCATENATED MODULE: ./src/modules/qrCode/qrCode.component.js








function qrCode_component_createSuper(t) { var r = qrCode_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function qrCode_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (qrCode_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }











var QRCodePage = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(QRCodePage, _Lightning$Component);
  var _super = qrCode_component_createSuper(QRCodePage);
  function QRCodePage() {
    (0,classCallCheck/* default */.Z)(this, QRCodePage);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(QRCodePage, [{
    key: "_active",
    value: function _active() {
      var _this = this;
      removeSplashScreen();
      var pageName = Router.getActiveRoute().replace('/', '');
      var codeUrl = get_default()((src_default()), "qrCode.links.".concat(pageName, ".long"));
      var shortUrl = get_default()((src_default()), "qrCode.links.".concat(pageName, ".short"));
      var translationKey = getPageTranslationKey(pageName);
      var screenSize = sizes_getScreenSize();
      browser.toDataURL(codeUrl, {
        margin: 2,
        width: QR_CODE_IMAGE_SIZE[screenSize].w
      }).then(function (dataUrl) {
        var texture = getSvgTexture(dataUrl, QR_CODE_IMAGE_SIZE[screenSize].w, QR_CODE_IMAGE_SIZE[screenSize].h);
        _this.tag('Code').texture = texture;
      });
      this.patch({
        Content: {
          PageTitle: {
            text: {
              text: t("".concat(translationKey, ".title"))
            }
          },
          QRCodeWrapper: {
            Title: {
              text: {
                text: t("".concat(translationKey, ".qrcode.title"))
              }
            },
            Info: {
              text: {
                text: "".concat(t("".concat(translationKey, ".qrcode.infos")), " <b>").concat(shortUrl, "</b>")
              }
            }
          }
        }
      });
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({}, qrCode_style_getInitialStyle());
    }
  }]);
  return QRCodePage;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/user/userInformation/customer/rtlde/userInformation.component.js


;// CONCATENATED MODULE: ./src/modules/user/userInformation/userInformation.component.js


;// CONCATENATED MODULE: ./src/modules/abstractMosaic/abstractMosaic.connector.js



var abstractMosaic_connector_mapControllers = function mapControllers(instance) {
  return {
    currentPath: {
      selector: getCurrentPath,
      shouldBeInvokedOnConnect: true,
      callback: function callback(value) {
        instance.path = value;
      }
    },
    layoutNavigation: {
      selector: getLayoutNavigation,
      shouldBeInvokedOnConnect: true,
      callback: function callback(value) {
        instance.navigation = value;
      }
    }
  };
};
/* harmony default export */ const abstractMosaic_connector = (lightningjs_redux.control(abstractMosaic_connector_mapControllers));
;// CONCATENATED MODULE: ./src/modules/abstractMosaic/abstractMosaic.style.js

var abstractMosaic_style_LEFT_PADDING, _TOP_PADDING;





var abstractMosaic_style_defaultContext = makeDefaultStylingContext();
var abstractMosaic_abstractMosaic_style_LEFT_PADDING = (abstractMosaic_style_LEFT_PADDING = {}, (0,defineProperty/* default */.Z)(abstractMosaic_style_LEFT_PADDING, HD, 96), (0,defineProperty/* default */.Z)(abstractMosaic_style_LEFT_PADDING, FULL_HD, 192), abstractMosaic_style_LEFT_PADDING);
var TOP_PADDING = (_TOP_PADDING = {}, (0,defineProperty/* default */.Z)(_TOP_PADDING, HD, 160), (0,defineProperty/* default */.Z)(_TOP_PADDING, FULL_HD, 240), _TOP_PADDING);
var abstractMosaic_style_colors = {
  background: makeThemeColor(TERTIARY)
};
var abstractMosaic_style_getContentPadding = function getContentPadding() {
  var hasSideNav = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var screenSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var screenDimension = screenSize || sizes_getScreenSize();
  return hasSideNav ? WIDTH[screenDimension] + abstractMosaic_abstractMosaic_style_LEFT_PADDING[screenDimension] : abstractMosaic_abstractMosaic_style_LEFT_PADDING[screenDimension];
};
var abstractMosaic_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : abstractMosaic_style_defaultContext,
    screenSize = _ref.screenSize,
    colorMode = _ref.colorMode;
  return {
    Background: {
      w: SCREEN_WIDTH[screenSize],
      h: sizes_SCREEN_HEIGHT[screenSize],
      color: abstractMosaic_style_colors.background[colorMode]
    },
    Grid: {
      x: abstractMosaic_style_getContentPadding(true, screenSize),
      y: TOP_PADDING[screenSize]
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/mosaic/mosaicCard.style.js

var mosaicCard_style_MOSAIC_CARD_SIZE, mosaicCard_style_ICON_SIZES, mosaicCard_style_BORDER_RADIUS;
function mosaicCard_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function mosaicCard_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? mosaicCard_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : mosaicCard_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }








var mosaicCard_style_defaultContext = makeDefaultStylingContext();
var mosaic_mosaicCard_style_MOSAIC_CARD_SIZE = (mosaicCard_style_MOSAIC_CARD_SIZE = {}, (0,defineProperty/* default */.Z)(mosaicCard_style_MOSAIC_CARD_SIZE, HD, {
  w: 199,
  h: 112
}), (0,defineProperty/* default */.Z)(mosaicCard_style_MOSAIC_CARD_SIZE, FULL_HD, {
  w: 300,
  h: 169
}), mosaicCard_style_MOSAIC_CARD_SIZE);
var mosaicCard_style_PADDING = 8;
var mosaicCard_style_colors = {
  background: makeThemeColor(TERTIARY, 0.3),
  icon: makeThemeColor(PRIMARY),
  label: makeThemeColor(PRIMARY)
};
var mosaic_mosaicCard_style_ICON_SIZES = (mosaicCard_style_ICON_SIZES = {}, (0,defineProperty/* default */.Z)(mosaicCard_style_ICON_SIZES, HD, Math.round(mosaic_mosaicCard_style_MOSAIC_CARD_SIZE[HD].h / 2)), (0,defineProperty/* default */.Z)(mosaicCard_style_ICON_SIZES, FULL_HD, Math.round(mosaic_mosaicCard_style_MOSAIC_CARD_SIZE[FULL_HD].h / 2)), mosaicCard_style_ICON_SIZES);
var mosaic_mosaicCard_style_BORDER_RADIUS = (mosaicCard_style_BORDER_RADIUS = {}, (0,defineProperty/* default */.Z)(mosaicCard_style_BORDER_RADIUS, HD, 4), (0,defineProperty/* default */.Z)(mosaicCard_style_BORDER_RADIUS, FULL_HD, 4), mosaicCard_style_BORDER_RADIUS);
var mosaicCard_style_getIconViewBox = memoize_default()(function (screenSize) {
  return {
    h: mosaic_mosaicCard_style_ICON_SIZES[screenSize]
  };
});
var mosaicCard_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mosaicCard_style_defaultContext,
    screenSize = _ref.screenSize,
    colorMode = _ref.colorMode;
  var _MOSAIC_CARD_SIZE$scr = mosaic_mosaicCard_style_MOSAIC_CARD_SIZE[screenSize],
    w = _MOSAIC_CARD_SIZE$scr.w,
    h = _MOSAIC_CARD_SIZE$scr.h;
  var borderSize = focus_BORDER_WIDTH[screenSize];
  var borderOffset = borderSize * 2;
  return {
    Border: {
      w: w + borderOffset,
      h: h + borderOffset,
      x: -borderSize,
      y: -borderSize,
      color: colors_TRANSPARENT,
      shader: {
        radius: mosaic_mosaicCard_style_BORDER_RADIUS[screenSize],
        outline: focus_BORDER_WIDTH[screenSize],
        strokeColor: colors_TRANSPARENT,
        innerColor: colors_TRANSPARENT
      }
    },
    Background: {
      w: w,
      h: h,
      shader: {
        fillColor: mosaicCard_style_colors.background[colorMode],
        radius: mosaic_mosaicCard_style_BORDER_RADIUS[screenSize]
      }
    },
    Image: {
      w: w,
      h: h,
      shader: {
        radius: mosaic_mosaicCard_style_BORDER_RADIUS[screenSize]
      }
    },
    Content: {
      w: w,
      h: h,
      flex: {
        direction: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      },
      IconWrapper: {
        w: w,
        h: mosaic_mosaicCard_style_ICON_SIZES[screenSize],
        Icon: {
          mountX: 0.5,
          x: middle,
          color: mosaicCard_style_colors.icon[colorMode]
        }
      },
      Label: {
        color: mosaicCard_style_colors.label[colorMode],
        text: mosaicCard_style_objectSpread(mosaicCard_style_objectSpread({}, src_getFont(constants_FONT.BERLIN_2, screenSize)), {}, {
          wordWrapWidth: w - mosaicCard_style_PADDING * 2,
          wordWrap: true,
          wordBreak: true,
          advancedRenderer: true,
          textAlign: 'center',
          verticalAlign: 'bottom',
          maxLines: 2,
          maxLinesSuffix: '...'
        })
      }
    }
  };
};
var mosaicCard_style_getFocusedStyle = function getFocusedStyle(_ref2) {
  var colorMode = _ref2.colorMode;
  return {
    Border: {
      smooth: {
        scale: focus_SCALE_FOCUSED,
        'shader.strokeColor': BORDER_COLOR[colorMode],
        'shader.innerColor': INNER_BORDER_COLOR[colorMode],
        'shader.scale': focus_SCALE_FOCUSED
      }
    },
    Background: {
      smooth: {
        scale: focus_SCALE_FOCUSED,
        'shader.scale': focus_SCALE_FOCUSED
      }
    },
    Image: {
      smooth: {
        scale: focus_SCALE_FOCUSED,
        'shader.scale': focus_SCALE_FOCUSED
      }
    }
  };
};
var mosaicCard_style_unFocusedStyle = {
  Border: {
    smooth: {
      scale: 1,
      'shader.strokeColor': colors_TRANSPARENT,
      'shader.innerColor': colors_TRANSPARENT,
      'shader.scale': 1.0
    }
  },
  Background: {
    smooth: {
      scale: 1,
      'shader.scale': 1.0
    }
  },
  Image: {
    smooth: {
      scale: 1,
      'shader.scale': 1.0
    }
  }
};
;// CONCATENATED MODULE: ./src/modules/abstractMosaic/abstractMosaic.utils.js










var abstractMosaic_utils_getImageUrl = function getImageUrl(item) {
  var screenSize = sizes_getScreenSize();
  item.image.src = imageService.getUrl(item.image.id, mosaic_mosaicCard_style_MOSAIC_CARD_SIZE[screenSize].w, mosaic_mosaicCard_style_MOSAIC_CARD_SIZE[screenSize].h, {
    fit: IMAGE_FIT_SCALE_CROP,
    quality: IMAGE_QUALITY,
    format: DEFAULT_IMAGE_FORMAT
  });
  return item;
};
var abstractMosaic_utils_filterNavigationEntries = function filterNavigationEntries(value, type) {
  var navigationEntry = get_default()(value, 'entries', []).flatMap(function (entry) {
    return entry;
  }).find(function (item) {
    if (getItemActionType({
      action: item.entry
    }) === type) {
      var itemImage = get_default()(item, 'subEntries[0].image');
      if (itemImage) {
        item.subEntries = itemImage.src ? item.subEntries : get_default()(item, 'subEntries').map(function (item) {
          return abstractMosaic_utils_getImageUrl(item);
        });
      }
      return true;
    }
    return false;
  });
  return get_default()(navigationEntry, 'subEntries', []);
};
;// CONCATENATED MODULE: ./src/modules/tornado/mosaic/mosaicCard.component.js





function mosaicCard_component_createSuper(t) { var r = mosaicCard_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function mosaicCard_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (mosaicCard_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }








var MosaicCard = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(MosaicCard, _Lightning$Component);
  var _super = mosaicCard_component_createSuper(MosaicCard);
  function MosaicCard() {
    (0,classCallCheck/* default */.Z)(this, MosaicCard);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(MosaicCard, [{
    key: "_construct",
    value: function _construct() {
      this._style = mosaicCard_style_defaultContext;
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this.tag('Icon').removeAllListeners('txLoaded');
    }
  }, {
    key: "item",
    set: function set(value) {
      var _this = this;
      this._item = value;
      var imageUrl = get_default()(this._item, 'image.src', '');
      this.tag('Icon').once('txLoaded', function () {
        _this.tag('Icon').setSmooth('alpha', 1);
      });
      this.patch({
        Image: {
          texture: imageUrl && imageUrl.length ? cover(imageUrl, mosaic_mosaicCard_style_MOSAIC_CARD_SIZE[this._style.screenSize].w, mosaic_mosaicCard_style_MOSAIC_CARD_SIZE[this._style.screenSize].h) : null
        },
        Content: {
          Label: {
            text: {
              text: value.label || ''
            }
          },
          IconWrapper: {
            Icon: {
              alpha: 0.0001,
              iconData: {
                picto: value.picto,
                viewBox: mosaicCard_style_getIconViewBox(this._style.screenSize)
              }
            }
          }
        }
      });
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this.patch(mosaicCard_style_getFocusedStyle(this._style));
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this.patch(mosaicCard_style_unFocusedStyle);
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      this.signal(SELECTED_SIGNAL, this._item);
      return true;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Border: {
          rect: true,
          shader: {
            type: focus_shader
          }
        },
        Background: {
          rect: true,
          shader: {
            type: src_Lightning.shaders.RoundedRectangle
          }
        },
        Image: {
          shader: {
            type: src_Lightning.shaders.RoundedRectangle
          }
        },
        Content: {
          IconWrapper: {
            Icon: {
              type: Icon
            }
          },
          Label: {}
        }
      }, mosaicCard_style_getInitialStyle());
    }
  }]);
  return MosaicCard;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/abstractMosaic/abstarctMosaic.constants.js


var ITEM_CONFIG = {
  services: {
    item: MosaicCard,
    sizes: mosaic_mosaicCard_style_MOSAIC_CARD_SIZE
  },
  lives: {
    item: MosaicCard,
    sizes: mosaic_mosaicCard_style_MOSAIC_CARD_SIZE
  },
  folders: {
    item: MosaicCard,
    sizes: mosaic_mosaicCard_style_MOSAIC_CARD_SIZE
  }
};
;// CONCATENATED MODULE: ./src/modules/abstractMosaic/abstractMosaic.component.js









function abstractMosaic_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function abstractMosaic_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? abstractMosaic_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : abstractMosaic_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function abstractMosaic_component_createSuper(t) { var r = abstractMosaic_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function abstractMosaic_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (abstractMosaic_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }












var AbstractMosaic = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(AbstractMosaic, _Lightning$Component);
  var _super = abstractMosaic_component_createSuper(AbstractMosaic);
  function AbstractMosaic() {
    (0,classCallCheck/* default */.Z)(this, AbstractMosaic);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(AbstractMosaic, [{
    key: "_init",
    value: function _init() {
      this._style = abstractMosaic_style_defaultContext;
    }
  }, {
    key: "_attach",
    value: function _attach() {
      this._unsubscribe = abstractMosaic_connector(this);
    }
  }, {
    key: "_active",
    value: function _active() {
      removeSplashScreen();
    }
  }, {
    key: "_detach",
    value: function _detach() {
      if (this._unsubscribe) {
        this._unsubscribe();
        this._unsubscribe = null;
      }
    }
  }, {
    key: "navigation",
    set: function set(entries) {
      if (!(entries && this._pageName)) {
        return;
      }
      this.tag('Grid').data = {
        items: abstractMosaic_utils_filterNavigationEntries(entries, this._pageName),
        itemType: ITEM_CONFIG[this._pageName].item,
        itemSize: ITEM_CONFIG[this._pageName].sizes[this._style.screenSize],
        itemsPerRow: ITEM_CONFIG[this._pageName].itemsPerRow
      };
    }
  }, {
    key: "path",
    set: function set(value) {
      if (!value) {
        return;
      }
      this._pageName = [LIVES, FOLDERS, SERVICES].find(function (item) {
        return value.includes(item);
      });
    }
  }, {
    key: "_handleSelected",
    value: function _handleSelected(item) {
      lightningjs_redux.dispatch(createItemAction({
        item: abstractMosaic_component_objectSpread(abstractMosaic_component_objectSpread({}, item), {}, {
          action: item
        })
      }));
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this.tag('Grid');
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Background: {
          rect: true
        },
        Grid: {
          type: MosaicGrid,
          signals: (0,defineProperty/* default */.Z)({}, SELECTED_SIGNAL, '_handleSelected')
        }
      }, abstractMosaic_style_getInitialStyle());
    }
  }]);
  return AbstractMosaic;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/video/videoLoader/videoLoader.style.js

var videoLoader_style_SPINNER_SIZE;




var videoLoader_style_defaultContext = makeDefaultStylingContext();
var videoLoader_videoLoader_style_SPINNER_SIZE = (videoLoader_style_SPINNER_SIZE = {}, (0,defineProperty/* default */.Z)(videoLoader_style_SPINNER_SIZE, HD, 200), (0,defineProperty/* default */.Z)(videoLoader_style_SPINNER_SIZE, FULL_HD, 200), videoLoader_style_SPINNER_SIZE);
var STARTING_ALPHA = 0.001;
var SPINNER_IN_TRANSITION = {
  delay: 0.25
};
var IMAGE_OUT_TRANSITION = {
  duration: 0.3
};
var videoLoader_style_colors = {
  background: makeThemeColor(TERTIARY)
};
var videoLoader_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : videoLoader_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  var spinnerSize = videoLoader_videoLoader_style_SPINNER_SIZE[screenSize];
  return {
    w: SCREEN_WIDTH[screenSize],
    h: sizes_SCREEN_HEIGHT[screenSize],
    color: videoLoader_style_colors.background[colorMode],
    Spinner: {
      alpha: STARTING_ALPHA,
      mount: 0.5,
      w: spinnerSize,
      h: spinnerSize,
      x: middle,
      y: middle
    },
    JingleImage: {
      alpha: STARTING_ALPHA
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/video/videoLoader/videoLoader.connector.js


var videoLoader_connector_mapControllers = function mapControllers(instance) {
  return [{
    selector: getIsLoadingContent,
    shouldBeInvokedOnConnect: true,
    callback: function callback(value) {
      instance.isLoadingContent = value;
    }
  }, {
    selector: getJingleImageId,
    shouldBeInvokedOnConnect: true,
    callback: function callback(value) {
      instance.jingleImageId = value;
    }
  }, {
    selector: getProgramImageId,
    shouldBeInvokedOnConnect: true,
    callback: function callback(value) {
      instance.programImageId = value;
    }
  }];
};
/* harmony default export */ const videoLoader_connector = (lightningjs_redux.control(videoLoader_connector_mapControllers));
;// CONCATENATED MODULE: ./src/modules/video/videoLoader/videoLoader.constants.js
var videoLoader_constants_JINGLE_DURATION = 2000;
var PROGRAM_IMAGE_DURATION = 2000;
var SAFE_COMPETE_TIMEOUT = videoLoader_constants_JINGLE_DURATION + PROGRAM_IMAGE_DURATION + 500;
var COMPLETE_SIGNAL = 'complete';
;// CONCATENATED MODULE: ./src/modules/video/videoLoader/videoLoader.component.js






function videoLoader_component_createSuper(t) { var r = videoLoader_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function videoLoader_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (videoLoader_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }










var VideoLoader = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(VideoLoader, _Lightning$Component);
  var _super = videoLoader_component_createSuper(VideoLoader);
  function VideoLoader() {
    (0,classCallCheck/* default */.Z)(this, VideoLoader);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(VideoLoader, [{
    key: "_attach",
    value: function _attach() {
      var _this = this;
      this._hideAnimation = this.animation({
        duration: 0.5,
        actions: [{
          p: 'alpha',
          v: {
            0: 1,
            1: 0
          }
        }]
      });
      this._hideAnimation.on('finish', function () {
        var jingleImage = _this.tag('JingleImage');
        var programImage = _this.tag('ProgramImage');
        try {
          if (jingleImage.texture) jingleImage.texture.free();
          if (programImage.texture) programImage.texture.free();
        } catch (error) {
          console.error('Can not free Jingle textures:', error);
        } finally {
          jingleImage.texture = null;
          programImage.texture = null;
        }
      });
    }
  }, {
    key: "_active",
    value: function _active() {
      var _this2 = this;
      this._jingleImageAvailable = false;
      this._programImageAvailable = false;
      var jingleImage = this.tag('JingleImage');
      var programImage = this.tag('ProgramImage');
      jingleImage.on('txLoaded', function () {
        jingleImage.removeAllListeners('txLoaded');
        _this2._jingleImageAvailable = true;
      });
      programImage.on('txLoaded', function () {
        programImage.removeAllListeners('txLoaded');
        _this2._programImageAvailable = true;
        if (_this2.state === 'Program') {
          _this2._hideImage('JingleImage');
        } else {
          programImage.alpha = 0;
        }
      });
      this._setState('Spinner');
      this._unsubscribe = videoLoader_connector(this);
    }
  }, {
    key: "_inactive",
    value: function _inactive() {
      if (this._unsubscribe) {
        this._unsubscribe();
        this._unsubscribe = null;
      }
      this._reset();
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this._hideAnimation.removeAllListeners('finish');
      this._hideAnimation = null;
    }
  }, {
    key: "jingleImageId",
    set: function set(value) {
      this._jingleImageAvailable = false;
      this._setImage(value, 'JingleImage');
    }
  }, {
    key: "programImageId",
    set: function set(value) {
      this._programImageAvailable = false;
      this._setImage(value, 'ProgramImage');
    }
  }, {
    key: "isLoadingContent",
    set: function set(value) {
      if (value) {
        this._setState('Jingle');
      }
    }
  }, {
    key: "show",
    value: function show() {
      this.alpha = 1;
      [this.tag('JingleImage'), this.tag('ProgramImage'), this.tag('Spinner')].forEach(function (view) {
        view.alpha = STARTING_ALPHA;
      });
      this._setState('Spinner');
    }
  }, {
    key: "hide",
    value: function hide() {
      var _this3 = this;
      setTimeout(function () {
        _this3._reset();
        if (_this3.alpha) {
          _this3._hideAnimation.start();
        }
      }, LOADER_DELAY);
    }
  }, {
    key: "_reset",
    value: function _reset() {
      this._clearTimeouts();
      this.tag('JingleImage').removeAllListeners('txLoaded');
      this.tag('ProgramImage').removeAllListeners('txLoaded');
    }
  }, {
    key: "_setImage",
    value: function _setImage(imageId, tag) {
      if (imageId) {
        var finalW = this.finalW,
          finalH = this.finalH;
        this.tag(tag).texture = cover(imageService.getUrl(imageId, finalW, finalH, {
          fit: IMAGE_FIT_SCALE_CROP,
          quality: IMAGE_QUALITY,
          format: DEFAULT_IMAGE_FORMAT
        }), finalW, finalH);
      } else {
        this.tag(tag).texture = null;
      }
    }
  }, {
    key: "_hideSpinner",
    value: function _hideSpinner() {
      this.tag('Spinner').setSmooth('alpha', 0);
    }
  }, {
    key: "_hideImage",
    value: function _hideImage(tag) {
      this.tag(tag).setSmooth('alpha', 0, IMAGE_OUT_TRANSITION);
    }
  }, {
    key: "_clearTimeouts",
    value: function _clearTimeouts() {
      if (this._jingleTimeout) {
        clearTimeout(this._jingleTimeout);
      }
      if (this._programImageTimeout) {
        clearTimeout(this._programImageTimeout);
      }
      this._jingleTimeout = null;
      this._programImageTimeout = null;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        rect: true,
        Spinner: {
          type: spinner_component,
          zIndex: 1
        },
        JingleImage: {
          zIndex: 2
        },
        ProgramImage: {
          zIndex: 3
        }
      }, videoLoader_style_getInitialStyle());
    }
  }, {
    key: "_states",
    value: function _states() {
      return [function (_this4) {
        (0,inherits/* default */.Z)(Spinner, _this4);
        var _super2 = videoLoader_component_createSuper(Spinner);
        function Spinner() {
          (0,classCallCheck/* default */.Z)(this, Spinner);
          return _super2.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(Spinner, [{
          key: "$enter",
          value: function $enter() {
            this.tag('Spinner').setSmooth('alpha', 1, SPINNER_IN_TRANSITION);
          }
        }, {
          key: "$exit",
          value: function $exit() {
            if (this._jingleImageAvailable) {
              this._hideSpinner();
            }
          }
        }]);
        return Spinner;
      }(this), function (_this5) {
        (0,inherits/* default */.Z)(Jingle, _this5);
        var _super3 = videoLoader_component_createSuper(Jingle);
        function Jingle() {
          (0,classCallCheck/* default */.Z)(this, Jingle);
          return _super3.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(Jingle, [{
          key: "$enter",
          value: function $enter() {
            var _this6 = this;
            this.tag('JingleImage').setSmooth('alpha', 1);
            this._jingleTimeout = setTimeout(function () {
              _this6._setState('Program');
            }, videoLoader_constants_JINGLE_DURATION);
          }
        }, {
          key: "$exit",
          value: function $exit() {
            if (this._programImageAvailable) {
              this._hideSpinner();
            }
          }
        }]);
        return Jingle;
      }(this), function (_this7) {
        (0,inherits/* default */.Z)(Program, _this7);
        var _super4 = videoLoader_component_createSuper(Program);
        function Program() {
          (0,classCallCheck/* default */.Z)(this, Program);
          return _super4.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(Program, [{
          key: "$enter",
          value: function $enter() {
            this.tag('ProgramImage').setSmooth('alpha', 1);
          }
        }]);
        return Program;
      }(this), function (_this8) {
        (0,inherits/* default */.Z)(Complete, _this8);
        var _super5 = videoLoader_component_createSuper(Complete);
        function Complete() {
          (0,classCallCheck/* default */.Z)(this, Complete);
          return _super5.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(Complete, [{
          key: "$enter",
          value: function $enter() {
            this._reset();
            this.signal(COMPLETE_SIGNAL);
          }
        }]);
        return Complete;
      }(this)];
    }
  }]);
  return VideoLoader;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/player/interface/overlay/overlay.style.js

var _background, _gradient;
function overlay_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function overlay_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? overlay_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : overlay_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





var overlay_style_defaultContext = makeDefaultStylingContext();
var overlay_style_colors = {
  background: makeThemeColor(TERTIARY)
};
var background = (_background = {}, (0,defineProperty/* default */.Z)(_background, HD, {
  w: SCREEN_WIDTH[HD],
  h: sizes_SCREEN_HEIGHT[HD]
}), (0,defineProperty/* default */.Z)(_background, FULL_HD, {
  w: SCREEN_WIDTH[FULL_HD],
  h: sizes_SCREEN_HEIGHT[FULL_HD]
}), _background);
var gradient = (_gradient = {}, (0,defineProperty/* default */.Z)(_gradient, HD, {
  w: SCREEN_WIDTH[HD],
  h: Math.round(sizes_SCREEN_HEIGHT[HD] * 0.25)
}), (0,defineProperty/* default */.Z)(_gradient, FULL_HD, {
  w: SCREEN_WIDTH[FULL_HD],
  h: Math.round(sizes_SCREEN_HEIGHT[FULL_HD] * 0.25)
}), _gradient);
var overlay_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : overlay_style_defaultContext,
    screenSize = _ref.screenSize,
    colorMode = _ref.colorMode;
  return overlay_style_objectSpread(overlay_style_objectSpread({}, background[screenSize]), {}, {
    rect: true,
    color: getDarkColor(TERTIARY, 0.6),
    Top: overlay_style_objectSpread(overlay_style_objectSpread({}, gradient[screenSize]), {}, {
      rect: true,
      colorTop: overlay_style_colors.background[colorMode],
      colorBottom: colors_TRANSPARENT
    }),
    Bottom: overlay_style_objectSpread(overlay_style_objectSpread({}, gradient[screenSize]), {}, {
      rect: true,
      y: background[screenSize].h - gradient[screenSize].h,
      colorTop: colors_TRANSPARENT,
      colorBottom: overlay_style_colors.background[colorMode]
    })
  });
};
;// CONCATENATED MODULE: ./src/modules/player/interface/overlay/overlay.component.js





function overlay_component_createSuper(t) { var r = overlay_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function overlay_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (overlay_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }



var Overlay = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Overlay, _Lightning$Component);
  var _super = overlay_component_createSuper(Overlay);
  function Overlay() {
    (0,classCallCheck/* default */.Z)(this, Overlay);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Overlay, [{
    key: "colorMode",
    get: function get() {
      return this._colorMode;
    },
    set: function set(value) {
      this._colorMode = value;
      this.patch({
        color: overlay_style_colors.background[this._colorMode]
      });
    }
  }, {
    key: "displayBackdrop",
    set: function set(value) {
      this.color = value ? overlay_style_colors.background[this._colorMode] : colors_TRANSPARENT;
    }
  }, {
    key: "displayTop",
    set: function set(value) {
      this.tag('Top').visible = value;
    }
  }, {
    key: "displayBottom",
    set: function set(value) {
      this.tag('Bottom').visible = value;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return overlay_style_getInitialStyle();
    }
  }]);
  return Overlay;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/logic/player/video.constants.js
var ADVISORY_DISPLAY_DURATION_IN_SECONDS = 5;
var CHAPTER_START_OFFSET_IN_SECONDS = 5.2;
var OPENING_CREDITS_CHAPTER_TYPE = 'opening_credits';
var INTRO_CHAPTER_TYPE = 'intro';
var ENDING_CREDITS_CHAPTER_TYPE = 'ending_credits';
var START_CHAPTERS_TYPES = [OPENING_CREDITS_CHAPTER_TYPE, INTRO_CHAPTER_TYPE];
var END_CHAPTERS_TYPES = [ENDING_CREDITS_CHAPTER_TYPE];
;// CONCATENATED MODULE: ./src/logic/player/video.selectors.js






var getNextVideoItem = function getNextVideoItem(state) {
  var section = getCurrentSectionCode(state);
  var layout = get_default()(state, "layout.".concat(section, ".video.").concat(player_selectors_getVideoId(state)));
  return get_default()(layout, 'blocks[0].content.items', []).find(function (item) {
    return item.itemType === 'classic';
  });
};
var getCurrentVideoItem = function getCurrentVideoItem(state) {
  return getCurrentMetadataItem(state);
};
var hasNextVideo = function hasNextVideo(state) {
  return Boolean(getNextVideoItem(state));
};
var shouldDisplayNextVideo = function shouldDisplayNextVideo(state) {
  return getIsEnded(state) && hasNextVideo(state);
};
var getCurrentChapter = function getCurrentChapter(state) {
  return state.player.chapter;
};
var isVideoEnding = function isVideoEnding(state) {
  var timeLeft = player_selectors_getDurationInSeconds(state) - player_selectors_getElapsedTimeInSeconds(state);
  return timeLeft >= 0 && timeLeft <= ADVISORY_DISPLAY_DURATION_IN_SECONDS;
};
;// CONCATENATED MODULE: ./src/modules/video/nextVideo/nextVideo.connector.js



var nextVideo_connector_mapControllers = function mapControllers(instance) {
  return {
    currentVideo: {
      selector: getCurrentVideoItem,
      shouldBeInvokedOnConnect: true,
      callback: function callback(value) {
        instance.currentVideo = value;
      }
    },
    nextVideo: {
      selector: getNextVideoItem,
      shouldBeInvokedOnConnect: true,
      callback: function callback(value) {
        instance.nextVideo = value;
      }
    },
    currentVideoAvailable: {
      selector: getWatchAgainFeature,
      shouldBeInvokedOnConnect: true,
      callback: function callback(value) {
        instance.watchAgain = value;
      }
    }
  };
};
/* harmony default export */ const nextVideo_connector = (lightningjs_redux.control(nextVideo_connector_mapControllers));
;// CONCATENATED MODULE: ./src/modules/video/nextVideo/nextVideo.constants.js
var CLOSE_SIGNAL = 'close';
var REPLAY_VIDEO_SIGNAL = 'replayCurrentVideo';
var NEXT_VIDEO_SIGNAL = 'playNextVideo';
var NEXT_VIDEO_COUNTDOWN = 10;
;// CONCATENATED MODULE: ./src/modules/video/nextVideo/nextVideoItem/nextVideoItem.style.js

var _POSTER_MARGIN_BOTTOM;
function nextVideoItem_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function nextVideoItem_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? nextVideoItem_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : nextVideoItem_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






var nextVideoItem_style_defaultContext = makeDefaultStylingContext();
var POSTER_MARGIN_BOTTOM = (_POSTER_MARGIN_BOTTOM = {}, (0,defineProperty/* default */.Z)(_POSTER_MARGIN_BOTTOM, HD, 16), (0,defineProperty/* default */.Z)(_POSTER_MARGIN_BOTTOM, FULL_HD, 24), _POSTER_MARGIN_BOTTOM);
var nextVideoItem_style_colors = {
  label: makeThemeColor(PRIMARY)
};
var nextVideoItem_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : nextVideoItem_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  var posterSize = poster_constants_sizes[poster_constants_templates.PosterL][screenSize];
  return {
    w: posterSize.w,
    h: sizes_SCREEN_HEIGHT[screenSize],
    Poster: {
      w: posterSize.w,
      h: posterSize.h
    },
    Label: {
      y: posterSize.h + POSTER_MARGIN_BOTTOM[screenSize],
      text: nextVideoItem_style_objectSpread(nextVideoItem_style_objectSpread({}, src_getFont(constants_FONT.KINSHASA_2, screenSize)), {}, {
        maxLines: 2,
        wordWrapWidth: posterSize.w
      }),
      color: nextVideoItem_style_colors.label[colorMode]
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/video/nextVideo/nextVideoItem/nextVideoItem.component.js






function nextVideoItem_component_createSuper(t) { var r = nextVideoItem_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function nextVideoItem_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (nextVideoItem_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }





var NextVideoItem = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(NextVideoItem, _Lightning$Component);
  var _super = nextVideoItem_component_createSuper(NextVideoItem);
  function NextVideoItem() {
    (0,classCallCheck/* default */.Z)(this, NextVideoItem);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(NextVideoItem, [{
    key: "item",
    set: function set(value) {
      this.tag('Poster').item = value;
    }
  }, {
    key: "label",
    set: function set(value) {
      this.tag('Label').text.text = value;
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this.tag('Poster');
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Poster: {
          type: Poster,
          passSignals: (0,defineProperty/* default */.Z)({}, SELECTED_SIGNAL, true)
        },
        Label: {}
      }, nextVideoItem_style_getInitialStyle());
    }
  }]);
  return NextVideoItem;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/video/nextVideo/nextVideo.style.js

var nextVideo_style_GAP, _CONTENT_MARGIN_TOP, nextVideo_style_POSTER_MARGIN_BOTTOM;




var nextVideo_style_defaultContext = makeDefaultStylingContext();
var nextVideo_nextVideo_style_GAP = (nextVideo_style_GAP = {}, (0,defineProperty/* default */.Z)(nextVideo_style_GAP, HD, 64), (0,defineProperty/* default */.Z)(nextVideo_style_GAP, FULL_HD, 96), nextVideo_style_GAP);
var CONTENT_MARGIN_TOP = (_CONTENT_MARGIN_TOP = {}, (0,defineProperty/* default */.Z)(_CONTENT_MARGIN_TOP, HD, 266), (0,defineProperty/* default */.Z)(_CONTENT_MARGIN_TOP, FULL_HD, 396), _CONTENT_MARGIN_TOP);
var nextVideo_nextVideo_style_POSTER_MARGIN_BOTTOM = (nextVideo_style_POSTER_MARGIN_BOTTOM = {}, (0,defineProperty/* default */.Z)(nextVideo_style_POSTER_MARGIN_BOTTOM, HD, 16), (0,defineProperty/* default */.Z)(nextVideo_style_POSTER_MARGIN_BOTTOM, FULL_HD, 24), nextVideo_style_POSTER_MARGIN_BOTTOM);
var nextVideo_style_colors = {
  label: makeThemeColor(PRIMARY)
};
var nextVideo_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : nextVideo_style_defaultContext;
  var screenSize = context.screenSize;
  return {
    w: SCREEN_WIDTH[screenSize],
    h: sizes_SCREEN_HEIGHT[screenSize],
    BackButton: {
      x: safetyMargins.horizontal[screenSize],
      y: safetyMargins.vertical[screenSize]
    },
    Content: {
      y: CONTENT_MARGIN_TOP[screenSize]
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/video/nextVideo/nextVideo.utils.js

function nextVideo_utils_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function nextVideo_utils_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? nextVideo_utils_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : nextVideo_utils_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }




var getVideoItemWithProgress = function getVideoItemWithProgress(content) {
  var progress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return content ? nextVideo_utils_objectSpread(nextVideo_utils_objectSpread({}, content), {}, {
    progress: progress
  }) : null;
};
var makeVideoItem = function makeVideoItem(content, screenSize) {
  if (!content) {
    return null;
  }
  var image = get_default()(content, 'image', {});
  var imageSize = get_default()(imageOptions, [poster_constants_templates.PosterL, screenSize, 'PRIMARY'], {});
  return {
    content: nextVideo_utils_objectSpread(nextVideo_utils_objectSpread({}, content), {}, {
      image: nextVideo_utils_objectSpread(nextVideo_utils_objectSpread({}, image), {}, {
        src: imageService.getUrl(image.id, imageSize.width, imageSize.height, {
          fit: IMAGE_FIT_SCALE_CROP,
          quality: IMAGE_QUALITY,
          format: DEFAULT_IMAGE_FORMAT
        })
      })
    }),
    template: poster_constants_templates.PosterL
  };
};
;// CONCATENATED MODULE: ./src/modules/video/nextVideo/nextVideo.component.js












function nextVideo_component_createSuper(t) { var r = nextVideo_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function nextVideo_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (nextVideo_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

















var NextVideo = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(NextVideo, _Lightning$Component);
  var _super = nextVideo_component_createSuper(NextVideo);
  function NextVideo() {
    (0,classCallCheck/* default */.Z)(this, NextVideo);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(NextVideo, [{
    key: "_construct",
    value: function _construct() {
      this._style = nextVideo_style_defaultContext;
      this._withWatchAgain = false;
      this._reset();
    }
  }, {
    key: "_active",
    value: function _active() {
      var _this = this;
      this.countdown = NEXT_VIDEO_COUNTDOWN;
      this._intervalId = setInterval(function () {
        _this.countdown -= 1;
      }, 1000);
      this._setState('Content');
    }
  }, {
    key: "_attach",
    value: function _attach() {
      this._unsubscribe = nextVideo_connector(this);
      this.tag('Current').visible = false;
      this.tag('Next').visible = false;
    }
  }, {
    key: "_inactive",
    value: function _inactive() {
      if (this._intervalId) {
        clearInterval(this._intervalId);
      }
    }
  }, {
    key: "_detach",
    value: function _detach() {
      if (this._unsubscribe) {
        this._unsubscribe();
        this._unsubscribe = null;
      }
      this._reset();
    }
  }, {
    key: "_handleNextVideoSelected",
    value: function _handleNextVideoSelected(item) {
      sendEvent({
        key: 'playNextVideo'
      });
      this.signal(NEXT_VIDEO_SIGNAL, item);
    }
  }, {
    key: "_handleCurrentVideoSelected",
    value: function _handleCurrentVideoSelected(item) {
      sendEvent({
        key: 'replayNextVideo'
      });
      this.signal(REPLAY_VIDEO_SIGNAL, item);
    }
  }, {
    key: "watchAgain",
    set: function set(value) {
      this._withWatchAgain = value;
      this._setCurrentVideoAsItem();
    }
  }, {
    key: "currentVideo",
    set: function set(value) {
      this._currentVideoItem = value;
      this._setCurrentVideoAsItem();
      var imageId = get_default()(value, 'image.id', '');
      this._setProgramImage(imageId);
    }
  }, {
    key: "nextVideo",
    set: function set(value) {
      this._nextVideoItem = value;
      this._setVideoPosterContent('Next', value);
    }
  }, {
    key: "isAvailable",
    get: function get() {
      return this._withWatchAgain || this.tag('Next').visible;
    }
  }, {
    key: "countdown",
    get: function get() {
      return this._countdown;
    },
    set: function set(value) {
      this._countdown = Math.max(value, 0);
      this.tag('Next').label = [t('player.nextVideo.nextCountdown'), this._countdown, t('player.nextVideo.unit')].join(' ');
      if (this._countdown <= 0 && this._nextVideoItem) {
        this.signal(NEXT_VIDEO_SIGNAL, this._nextVideoItem);
        sendEvent({
          key: 'autoPlayNextVideo'
        });
      }
    }
  }, {
    key: "visible",
    get: function get() {
      return (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(NextVideo.prototype), "visible", this);
    },
    set: function set(value) {
      _set((0,getPrototypeOf/* default */.Z)(NextVideo.prototype), "visible", value, this, true);
      if (value) {
        sendEvent({
          key: 'endscreenDisplayed'
        });
      }
    }
  }, {
    key: "_setProgramImage",
    value: function _setProgramImage(imageId) {
      if (!imageId) {
        this.tag('ProgramImage').texture = null;
        return;
      }
      var finalW = this.finalW,
        finalH = this.finalH;
      this.tag('ProgramImage').texture = cover(imageService.getUrl(imageId, finalW, finalH, {
        fit: IMAGE_FIT_SCALE_CROP,
        quality: IMAGE_QUALITY,
        format: DEFAULT_IMAGE_FORMAT
      }), finalW, finalH);
    }
  }, {
    key: "_setVideoPosterContent",
    value: function _setVideoPosterContent(tag, content) {
      var view = this.tag(tag);
      if (content) {
        view.visible = true;
        view.item = makeVideoItem(content, this._style.screenSize);
      } else {
        view.visible = false;
      }
      this._updateViewsPositions();
    }
  }, {
    key: "_updateViewsPositions",
    value: function _updateViewsPositions() {
      var views = [this.tag('Current'), this.tag('Next')].filter(function (_ref) {
        var visible = _ref.visible;
        return visible;
      });
      var gap = nextVideo_nextVideo_style_GAP[this._style.screenSize];
      var totalWidth = 0;
      views.forEach(function (view) {
        view.x = totalWidth;
        totalWidth += view.w + gap;
      });
      this.tag('Content').x = getCenter(this.w, totalWidth - gap);
    }
  }, {
    key: "_setCurrentVideoAsItem",
    value: function _setCurrentVideoAsItem() {
      if (this._withWatchAgain && this._currentVideoItem) {
        this._setVideoPosterContent('Current', getVideoItemWithProgress(this._currentVideoItem, 100));
      }
    }
  }, {
    key: "_reset",
    value: function _reset() {
      this._focused = null;
      this._withWatchAgain = false;
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this._focused;
    }
  }, {
    key: "_handleBack",
    value: function _handleBack() {
      sendEvent({
        key: 'backNextVideo'
      });
      return false;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        rect: true,
        Overlay: {
          type: Overlay
        },
        ProgramImage: {},
        BackButton: {
          type: Button,
          label: t('global.back'),
          picto: {
            name: 'ArrowLeft'
          }
        },
        Content: {
          Current: {
            type: NextVideoItem,
            label: t('player.nextVideo.askReplay'),
            signals: (0,defineProperty/* default */.Z)({}, SELECTED_SIGNAL, '_handleCurrentVideoSelected')
          },
          Next: {
            type: NextVideoItem,
            signals: (0,defineProperty/* default */.Z)({}, SELECTED_SIGNAL, '_handleNextVideoSelected')
          }
        }
      }, nextVideo_style_getInitialStyle());
    }
  }, {
    key: "_states",
    value: function _states() {
      return [function (_this2) {
        (0,inherits/* default */.Z)(Content, _this2);
        var _super2 = nextVideo_component_createSuper(Content);
        function Content() {
          (0,classCallCheck/* default */.Z)(this, Content);
          return _super2.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(Content, [{
          key: "$enter",
          value: function $enter() {
            this._updateDefaultFocus();
          }
        }, {
          key: "currentVideo",
          set: function set(value) {
            _set((0,getPrototypeOf/* default */.Z)(Content.prototype), "currentVideo", value, this, true);
            this._updateDefaultFocus();
          }
        }, {
          key: "nextVideo",
          set: function set(value) {
            _set((0,getPrototypeOf/* default */.Z)(Content.prototype), "nextVideo", value, this, true);
            this._updateDefaultFocus();
          }
        }, {
          key: "_active",
          value: function _active() {
            (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(Content.prototype), "_active", this).call(this);
            this._updateDefaultFocus();
          }
        }, {
          key: "_updateDefaultFocus",
          value: function _updateDefaultFocus() {
            this._focused = [this.tag('Next'), this.tag('Current')].find(function (_ref2) {
              var visible = _ref2.visible;
              return visible;
            });
          }
        }, {
          key: "_handleLeft",
          value: function _handleLeft() {
            if (this.tag('Current').visible) {
              this._focused = this.tag('Current');
            }
            return true;
          }
        }, {
          key: "_handleRight",
          value: function _handleRight() {
            if (this.tag('Next').visible) {
              this._focused = this.tag('Next');
            }
            return true;
          }
        }, {
          key: "_handleUp",
          value: function _handleUp() {
            this._setState('BackButton');
            return true;
          }
        }]);
        return Content;
      }(this), function (_this3) {
        (0,inherits/* default */.Z)(BackButton, _this3);
        var _super3 = nextVideo_component_createSuper(BackButton);
        function BackButton() {
          (0,classCallCheck/* default */.Z)(this, BackButton);
          return _super3.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(BackButton, [{
          key: "_getFocused",
          value: function _getFocused() {
            return this.tag('BackButton');
          }
        }, {
          key: "_handleEnter",
          value: function _handleEnter() {
            this.signal(CLOSE_SIGNAL);
            sendEvent({
              key: 'backNextVideo'
            });
            return true;
          }
        }, {
          key: "_handleDown",
          value: function _handleDown() {
            this._setState('Content');
            return true;
          }
        }]);
        return BackButton;
      }(this)];
    }
  }]);
  return NextVideo;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/logic/player/live.utils.js





var findCurrentLiveItem = function findCurrentLiveItem(layout, timestamp) {
  var blocks = get_default()(layout, 'blocks', []);
  var block = findPlayerBlock(blocks);
  return get_default()(block, 'content.items', []).find(function (item) {
    var progress = get_default()(item, 'video.progress.live');
    if (!progress) {
      return false;
    }
    var startTimestamp = progress.startTimestamp,
      endTimestamp = progress.endTimestamp;
    if (!Number.isFinite(startTimestamp) || !Number.isFinite(endTimestamp)) {
      return false;
    }
    return timestamp >= startTimestamp && timestamp <= endTimestamp;
  });
};
var getPlayerBlockFromLayout = function getPlayerBlockFromLayout(layout) {
  return findPlayerBlock(get_default()(layout, 'blocks', []));
};
var getMetadataItemsFromLayout = function getMetadataItemsFromLayout(layout) {
  return get_default()(getPlayerBlockFromLayout(layout), 'content.items', []);
};
var findCurrentMetadataItemIndex = function findCurrentMetadataItemIndex(layout, currentBlock) {
  return getMetadataItemsFromLayout(layout).indexOf(currentBlock);
};
var getTimeToRequestNewMetadataInSeconds = function getTimeToRequestNewMetadataInSeconds(timestamp) {
  return Math.round(timestamp * 0.8 + Math.random() * timestamp * 0.15);
};
;// CONCATENATED MODULE: ./src/logic/player/googlePauseAds.utils.js









var googlePauseAds_utils_excluded = ["rdid"];
function googlePauseAds_utils_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function googlePauseAds_utils_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? googlePauseAds_utils_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : googlePauseAds_utils_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



var BASE = 'https://securepubads.g.doubleclick.net/gampad/adx';
var fetchPauseAd = function fetchPauseAd(data) {
  return new Promise(function (resolve, reject) {
    var _ref = data || {},
      path = _ref.path,
      targeting = _ref.targeting;
    var _ref2 = targeting || {},
      rdid = _ref2.rdid,
      rest = objectWithoutProperties_objectWithoutProperties(_ref2, googlePauseAds_utils_excluded);
    var t = rest ? Object.entries(rest).map(function (_ref3) {
      var _ref4 = (0,slicedToArray/* default */.Z)(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];
      return "".concat(key, "=").concat(value);
    }).join('&') : undefined;
    var screenSize = sizes_getScreenSize();
    var params = Object.entries({
      iu: path,
      sz: '1x1',
      c: Date.now(),
      rdid: rdid,
      t: t
    }).map(function (_ref5) {
      var _ref6 = (0,slicedToArray/* default */.Z)(_ref5, 2),
        key = _ref6[0],
        value = _ref6[1];
      return "".concat(key, "=").concat(encodeURIComponent(value));
    }).join('&');
    client_default().get("".concat(BASE, "?").concat(params)).then(function (response) {
      return JSON.parse(response.text);
    }).then(function (data) {
      if (typeof data.file_url === 'string') {
        resolve(data);
      } else {
        resolve(googlePauseAds_utils_objectSpread(googlePauseAds_utils_objectSpread({}, data), {}, {
          file_url: data.file_url[screenSize === HD ? '1280x720' : '1920x1080']
        }));
      }
    }).catch(function (error) {
      return reject(error);
    });
  });
};
;// CONCATENATED MODULE: ./src/logic/player/player.actions.js


















function player_actions_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function player_actions_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? player_actions_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : player_actions_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






















var handleLayoutAction = function handleLayoutAction(action, type) {
  return function (dispatch) {
    switch (type) {
      case cta_constants.LOCK:
        {
          dispatch(lockPlayer());
          dispatch(handleLock(action, {
            routeBackOnClose: true
          }));
          break;
        }
      default:
        {
          dispatch(createItemAction(action));
          break;
        }
    }
  };
};
var initialize = function initialize() {
  return function (dispatch, getState) {
    var state = getState();
    var entityId = getRequestedEntityId(state);
    var layout = getCurrentLayout(state);
    var item = findCurrentVideoItem(layout, entityId);
    var actionType = getItemActionType(item);
    if (actionType === cta_constants.PLAY) {
      var entityType = getRequestedEntityType(state);
      dispatch(setPlayerInitialized({
        entityType: entityType,
        entityId: entityId,
        isLive: entityType === layout_constants/* entities */.jF.live,
        layout: layout,
        item: item
      }));
      var source = getVideoSource(getState());
      if (!source) {
        dispatch(error_actions_errorAction(error_constants_ERROR_LEVELS.FATAL, error_constants_ERROR_TYPES.PLAYER, 'No sources available'));
      }
    } else {
      dispatch(handleLayoutAction({
        item: item
      }, actionType));
    }
  };
};
var fetchPlayerLayout = function fetchPlayerLayout() {
  return function () {
    var _ref = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(dispatch, getState) {
      var state, layout, entityId, dimensions;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            state = getState();
            layout = getCurrentLayout(state);
            if (isPlayerLayout(layout)) {
              entityId = getRequestedEntityId(state);
              dispatch(initialize());
              try {
                dimensions = get_default()(findCurrentVideoItem(layout, entityId), 'analytics.googleAnalytics');
                if (dimensions) {
                  setAttributes(Object.entries(dimensions).filter(function (_ref2) {
                    var _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 1),
                      key = _ref3[0];
                    return key.startsWith('dimension');
                  }).reduce(function (acc, _ref4) {
                    var _ref5 = (0,slicedToArray/* default */.Z)(_ref4, 2),
                      key = _ref5[0],
                      value = _ref5[1];
                    return player_actions_objectSpread(player_actions_objectSpread({}, acc), {}, (0,defineProperty/* default */.Z)({}, key, value));
                  }, {}));
                }
              } catch (error) {
                dispatch(error_actions_errorAction(error_constants_ERROR_LEVELS.SILENT, error_constants_ERROR_TYPES.LAYOUT, 'No custom dimensions'));
              }
            }
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
var player_actions_fetchUpfrontToken = function fetchUpfrontToken(service) {
  return function () {
    var _ref6 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2(_, getState) {
      var state, uid, source, contentId, token, isLive, tokenRequestHandler, tokenAssetData;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            state = getState();
            uid = user_selectors_getUid(state);
            source = getVideoSource(state);
            contentId = get_default()(source, 'drm.config.contentId');
            token = '';
            if (!contentId) {
              _context2.next = 12;
              break;
            }
            isLive = getIsLive(state);
            tokenRequestHandler = isLive ? upFrontTokenService.getLiveToken : upFrontTokenService.getVideoToken;
            tokenAssetData = isLive ? {
              channelCode: contentId
            } : {
              videoId: contentId
            };
            _context2.next = 11;
            return tokenRequestHandler.bind(upFrontTokenService)(player_actions_objectSpread({
              user: {
                UID: uid
              },
              service: service
            }, tokenAssetData));
          case 11:
            token = _context2.sent;
          case 12:
            return _context2.abrupt("return", {
              value: token,
              uid: uid
            });
          case 13:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x3, _x4) {
      return _ref6.apply(this, arguments);
    };
  }();
};
var showAdJingle = function showAdJingle() {
  return function (dispatch, getState) {
    var state = getState();
    dispatch(adJingleStarted());
    if (!getAdJingleImageId(state)) {
      return Promise.resolve();
    }
    return new Promise(function (resolve) {
      setTimeout(function () {
        resolve();
        dispatch(adJingleComplete());
      }, getAdJingleDurationInMilliseconds(state));
    });
  };
};
var switchToNextProgram = function switchToNextProgram() {
  return function (dispatch, getState) {
    var layout = getCurrentLayout(getState());
    var item = findCurrentLiveItem(layout, getCurrentTimeInSeconds());
    if (!item) {
      return;
    }
    var actionType = getItemActionType(item);
    if (actionType === cta_constants.PLAY) {
      dispatch({
        type: SET_CURRENT_METADATA_ITEM,
        layout: layout,
        item: item
      });
    } else {
      dispatch(handleLayoutAction({
        item: item
      }, actionType));
    }
  };
};
var getNewMetadataItems = function getNewMetadataItems() {
  return function () {
    var _ref7 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee3(dispatch, getState) {
      var state, entityId, entityType, sectionCode, entity, data, programs;
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            state = getState();
            entityId = getRequestedEntityId(state);
            entityType = getRequestedEntityType(state);
            sectionCode = getCurrentSectionCode(state);
            entity = {
              entityId: entityId,
              entityType: entityType,
              sectionCode: sectionCode
            };
            _context3.prev = 5;
            _context3.next = 8;
            return layoutForThirdPartyService.fetchByEntity(entity);
          case 8:
            data = _context3.sent;
            programs = getMetadataItemsFromLayout(data);
            return _context3.abrupt("return", programs ? dispatch({
              type: APPEND_NEW_METADATA_ITEMS,
              programs: programs,
              entityType: entityType,
              entityId: entityId
            }) : dispatch(error_actions_errorAction(error_constants_ERROR_LEVELS.SILENT, error_constants_ERROR_TYPES.LAYOUT, 'No Live')));
          case 13:
            _context3.prev = 13;
            _context3.t0 = _context3["catch"](5);
            return _context3.abrupt("return", dispatch(error_actions_errorAction(error_constants_ERROR_LEVELS.FATAL, error_constants_ERROR_TYPES.LAYOUT, _context3.t0.message)));
          case 16:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[5, 13]]);
    }));
    return function (_x5, _x6) {
      return _ref7.apply(this, arguments);
    };
  }();
};
var setAudioTrack = function setAudioTrack(track) {
  return {
    type: SET_AUDIO_TRACK,
    track: track
  };
};
var setSubtitlesTrack = function setSubtitlesTrack(track) {
  return {
    type: SET_SUBTITLE_TRACK,
    track: track
  };
};
var changeTracksPreferences = function changeTracksPreferences(_ref8) {
  var audioTrack = _ref8.audioTrack,
    subtitlesTrack = _ref8.subtitlesTrack;
  return function (dispatch, getState) {
    dispatch({
      type: TRACK_PREFERENCES_CHANGED,
      audioTrack: audioTrack,
      subtitlesTrack: subtitlesTrack
    });
    var state = getState();
    var _state$player = state.player,
      originalLanguage = _state$player.originalLanguage,
      preferences = _state$player.preferences;
    var shouldTrackPreferencesAcrossDevices = getPlayerTrackPreferencesFeature(state);
    if (!shouldTrackPreferencesAcrossDevices || !originalLanguage) {
      return Promise.resolve();
    }
    return userService.setTrackPreferences({
      originalLanguage: originalLanguage,
      audioPreference: layoutAudioTrackToUsersPreference(preferences.audioTrack),
      subtitlesPreference: preferences.textTrack ? layoutTextTrackToUsersPreference(preferences.textTrack) : null
    }).catch(function (error) {
      dispatch(error_actions_errorAction(error_constants_ERROR_LEVELS.SILENT, error_constants_ERROR_TYPES.PLAYER, error.message));
    });
  };
};
var selectAudioTrack = function selectAudioTrack(trackId) {
  return function (dispatch, getState) {
    var state = getState();
    var _state$player2 = state.player,
      audioTracks = _state$player2.audioTracks,
      selectedAudioTrack = _state$player2.selectedAudioTrack,
      subtitleTracks = _state$player2.subtitleTracks,
      selectedSubtitlesTrack = _state$player2.selectedSubtitlesTrack;
    if (selectedAudioTrack === trackId) {
      return;
    }
    var audioTrack = audioTracks.find(function (_ref9) {
      var id = _ref9.id;
      return id === trackId;
    });
    if (!audioTrack) {
      return;
    }
    dispatch(setAudioTrack(audioTrack));
    dispatch(changeTracksPreferences({
      audioTrack: audioTrack
    }));
    var subtitlesTrack = subtitleTracks.find(function (_ref0) {
      var id = _ref0.id;
      return id === selectedSubtitlesTrack;
    });
    if (!subtitlesTrack || isForcedSubtitlesTrack(subtitlesTrack)) {
      var forcedSubtitlesTrack = findForcedSubtitles(subtitleTracks, audioTrack.language);
      dispatch(setSubtitlesTrack(forcedSubtitlesTrack || null));
    }
  };
};
var selectSubtitlesTrack = function selectSubtitlesTrack(trackId) {
  return function (dispatch, getState) {
    var state = getState();
    var _state$player3 = state.player,
      subtitleTracks = _state$player3.subtitleTracks,
      audioTracks = _state$player3.audioTracks,
      selectedAudioTrack = _state$player3.selectedAudioTrack;
    var subtitlesTrack = subtitleTracks.find(function (_ref1) {
      var id = _ref1.id;
      return id === trackId;
    });
    var audioTrack = audioTracks.find(function (_ref10) {
      var id = _ref10.id;
      return id === selectedAudioTrack;
    });
    if (!trackId) {
      dispatch(changeTracksPreferences({
        subtitlesTrack: null
      }));
    }
    if (subtitlesTrack) {
      dispatch(setSubtitlesTrack(subtitlesTrack));
      dispatch(changeTracksPreferences({
        subtitlesTrack: subtitlesTrack
      }));
    } else if (audioTrack) {
      var forcedSubtitlesTrack = findForcedSubtitles(subtitleTracks, audioTrack.language);
      dispatch(setSubtitlesTrack(forcedSubtitlesTrack));
    } else {
      dispatch(setSubtitlesTrack(null));
    }
  };
};
var refreshPauseAd = function refreshPauseAd() {
  return function (dispatch, getState) {
    var state = getState();
    var currentPauseAd = getCurrentPauseAd(state);
    var currentAdReceiveTime = currentPauseAd ? currentPauseAd.receivedAt : 0;
    var timeoutInSeconds = Number.isFinite((src_default()).ads.pauseAdRefreshTimeoutInSeconds) ? (src_default()).ads.pauseAdRefreshTimeoutInSeconds : 30;
    if (Date.now() - currentAdReceiveTime > timeoutInSeconds * 1000) {
      var adRequestData = getPauseAdRequestData(state);
      if (!adRequestData) {
        return;
      }
      dispatch(setPauseAd(null));
      fetchPauseAd(adRequestData).then(function (ad) {
        if (ad) {
          dispatch(setPauseAd(player_actions_objectSpread(player_actions_objectSpread({}, ad), {}, {
            receivedAt: Date.now()
          })));
        } else {
          dispatch(pauseAdsError());
          dispatch(error_actions_errorAction(error_constants_ERROR_LEVELS.SILENT, error_constants_ERROR_TYPES.LAYOUT, 'No pause ad data: ad server returned an empty response'));
        }
      }).catch(function (error) {
        dispatch(pauseAdsError());
        dispatch(error_actions_errorAction(error_constants_ERROR_LEVELS.SILENT, error_constants_ERROR_TYPES.LAYOUT, "No pause ad data: ".concat(error.message)));
      });
    }
  };
};
var playbackError = function playbackError(error) {
  return function (dispatch, getState) {
    var state = getState();
    var path = getCurrentRoute(state);
    var entity = (path || '').split('/')[0];
    var level = getErrorLevel(error);
    var message = fetchErrorMessage(error);
    var contentType = getContentType(state);
    dispatch(error_actions_errorAction(PLAYER_ENTITIES.includes(entity) || level !== error_constants_ERROR_LEVELS.FATAL ? level : error_constants_ERROR_LEVELS.SILENT, error_constants_ERROR_TYPES.PLAYER, message));
    dispatch(setPlayerError({
      level: level,
      message: contentType === layout_constants/* entities */.jF.audio || contentType === layout_constants/* entities */.jF.radio ? t('error.podcast') : message
    }));
  };
};
;// CONCATENATED MODULE: ./packages/bedrock-rdk/media-engine/src/engines/shaka/textDisplayer/v3/textDisplayer.utils.js

var isEqualCuePoint = function isEqualCuePoint(existingCue, newCue) {
  if (!existingCue || !newCue || existingCue.startTime !== newCue.startTime || existingCue.endTime !== newCue.endTime || existingCue.payload !== newCue.payload) {
    return false;
  }
  var existingCueEntries = Object.entries(existingCue);
  for (var i = 0; i < existingCueEntries.length; i += 1) {
    var cueField = existingCueEntries[i][0];
    var cueValue = existingCueEntries[i][1];
    if (cueField === 'startTime' || cueField === 'endTime' || cueField === 'payload') {} else if (cueField === 'nestedCues') {
      if (cueValue.length !== newCue[cueField].length) {
        return false;
      }
      for (var _i = 0; _i < cueValue.length; _i += 1) {
        if (!isEqualCuePoint(cueValue[_i], newCue[cueField][_i])) {
          return false;
        }
      }
    } else if (cueField === 'region' || cueField === 'cellResolution') {
      var cueEntries = Object.entries(cueValue);
      for (var j = 0; j < cueEntries.length; j += 1) {
        if (cueEntries[j][1] !== newCue[cueField][cueEntries[j][0]]) {
          return false;
        }
      }
    } else if (Array.isArray(cueValue)) {
      if (cueValue.length !== newCue[cueField].length) {
        return false;
      }
      for (var _i2 = 0; _i2 < cueValue.length; _i2 += 1) {
        if (cueValue[_i2] !== newCue[cueField][_i2]) {
          return false;
        }
      }
    } else if (cueValue !== newCue[cueField]) {
      return false;
    }
  }
  return true;
};
;// CONCATENATED MODULE: ./packages/bedrock-rdk/media-engine/src/engines/shaka/textDisplayer/platform/default/textDisplayer.utils.js

;// CONCATENATED MODULE: ./packages/bedrock-rdk/media-engine/src/engines/shaka/textDisplayer/textDisplayer.utils.js






var DOUBLED_RGBA_LENGTH = 9;
var getARGBAlpha = function getARGBAlpha(alphaHex) {
  return "0x".concat(alphaHex);
};
var isDoubledRGBA = function isDoubledRGBA(color) {
  return color.length === DOUBLED_RGBA_LENGTH && !Number.isInteger(color);
};
var doubledRGBAToARGB = function doubledRGBAToARGB(color) {
  var alphaHex = getARGBAlpha(color.slice(DOUBLED_RGBA_LENGTH - 2));
  return color.slice(0, -2).replace('#', alphaHex);
};
var textDisplayer_utils_hexToARGB = function hexToARGB(color) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0x00000000;
  if (!color) {
    return fallback;
  }
  if (!isDoubledRGBA(color)) {
    return color;
  }
  return parseInt(doubledRGBAToARGB(color), 16);
};
;// CONCATENATED MODULE: ./packages/bedrock-rdk/media-engine/src/engines/shaka/textDisplayer/textDisplayer.constants.js
var UPDATE_PERIOD = 250;
var CUE_ACTION = {
  DISPLAYED: 'text_displayed',
  REMOVED: 'text_removed'
};
var TEXT_RENDERER_V3 = 3;
var TEXT_RENDERER_V4 = 4;
;// CONCATENATED MODULE: ./src/modules/subtitles/subtitles.constants.js

var DEFAULT_CONTAINER_SCALE = 0.8;
var units = {
  PX: 0,
  PERCENTAGE: 1,
  LINES: 2
};
var writingMode = {
  HORIZONTAL_TOP_TO_BOTTOM: 'horizontal-tb',
  VERTICAL_LEFT_TO_RIGHT: 'vertical-lr',
  VERTICAL_RIGHT_TO_LEFT: 'vertical-rl'
};
var DEFAULT_REGION = 'default';
var DEFAULT_BACKGROUND_COLOR = hexToARGB('#000000', 0);
;// CONCATENATED MODULE: ./src/modules/subtitles/subtitles.style.js

var _INNER_PADDING;
function subtitles_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function subtitles_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? subtitles_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : subtitles_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }







var subtitles_style_defaultContext = makeDefaultStylingContext();
var subtitles_style_colors = {
  text: makeThemeColor(PRIMARY)
};
var getFullContainerWidth = function getFullContainerWidth(screenSize) {
  return SCREEN_WIDTH[screenSize];
};
var getFullContainerHeight = function getFullContainerHeight(screenSize) {
  return sizes_SCREEN_HEIGHT[screenSize];
};
var subtitles_style_getInitialStyle = memoize_default()(function () {
  return {
    Regions: {}
  };
});
var INNER_PADDING = (_INNER_PADDING = {}, (0,defineProperty/* default */.Z)(_INNER_PADDING, HD, 6), (0,defineProperty/* default */.Z)(_INNER_PADDING, FULL_HD, 8), _INNER_PADDING);
var getDefaultRegionStyle = memoize_default()(function (screenSize) {
  var containerWidth = getFullContainerWidth(screenSize);
  var containerHeight = getFullContainerHeight(screenSize);
  return {
    w: containerWidth * DEFAULT_CONTAINER_SCALE,
    h: containerHeight * DEFAULT_CONTAINER_SCALE,
    x: getCenter(containerWidth, containerWidth * DEFAULT_CONTAINER_SCALE),
    y: getCenter(containerHeight, containerHeight * DEFAULT_CONTAINER_SCALE),
    flex: {
      direction: 'column',
      justifyContent: 'flex-end'
    }
  };
});
var getItemStyle = memoize_default()(function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : subtitles_style_defaultContext,
    screenSize = _ref.screenSize;
  var font = src_getFont(constants_FONT.OSLO_2, screenSize);
  var color = subtitles_style_colors.text[DARK_MODE];
  var containerWidth = getFullContainerWidth(screenSize);
  var padding = INNER_PADDING[screenSize];
  return {
    text: subtitles_style_objectSpread(subtitles_style_objectSpread({}, font), {}, {
      textColor: color,
      highlightPaddingLeft: padding,
      paddingLeft: padding,
      highlightPaddingRight: padding,
      paddingRight: padding,
      wordWrapWidth: containerWidth,
      textBaseline: 'alphabetic',
      verticalAlign: 'middle'
    })
  };
});
;// CONCATENATED MODULE: ./src/modules/subtitles/subtitles.utils.js











var displayAlignToFlex = function displayAlignToFlex(displayAlign) {
  switch (displayAlign) {
    case 'before':
      return 'flex-start';
    case 'center':
      return 'center';
    case 'after':
      return 'flex-end';
    default:
      return 'flex-end';
  }
};
var textAlignToFlex = function textAlignToFlex(textAlign) {
  switch (textAlign) {
    case 'left':
    case 'start':
      return 'flex-start';
    case 'right':
    case 'end':
      return 'flex-end';
    case 'center':
      return 'center';
    default:
      return 'flex-start';
  }
};
var getDimensionsByRegion = function getDimensionsByRegion(cue, screenSize) {
  var region = cue.region;
  var supportableUnits = [units.PX, units.PERCENTAGE];
  var containerWidth = getFullContainerWidth(screenSize);
  var containerHeight = getFullContainerHeight(screenSize);
  var usePercentage = region.widthUnits === units.PERCENTAGE;
  if (supportableUnits.includes(region.widthUnits) && supportableUnits.includes(region.heightUnits)) {
    return {
      w: usePercentage ? containerWidth * (region.width / 100) : region.width,
      h: usePercentage ? containerHeight * (region.height / 100) : region.height,
      x: Math.round(containerWidth * (region.viewportAnchorX / 100)),
      y: Math.round(containerHeight * (region.viewportAnchorY / 100)),
      flex: {
        justifyContent: displayAlignToFlex(cue.displayAlign)
      }
    };
  }
  return {};
};
var getDimensionsBySize = function getDimensionsBySize(size, cueWritingMode, screenSize) {
  var containerWidth = getFullContainerWidth(screenSize);
  var containerHeight = getFullContainerHeight(screenSize);
  if (cueWritingMode === writingMode.HORIZONTAL_TOP_TO_BOTTOM) {
    return {
      w: containerWidth * (size / 100)
    };
  }
  return {
    h: containerHeight * (size / 100)
  };
};
var getLengthValueInfo = function getLengthValueInfo(lengthValue) {
  var matches = new RegExp(/(\d*\.?\d+)([a-z]+|%+)/).exec(lengthValue);
  if (!matches) {
    return null;
  }
  return {
    value: Number(matches[1]),
    unit: matches[2]
  };
};
var getAbsoluteLengthInPixels = function getAbsoluteLengthInPixels(value, cue, containerHeight) {
  return containerHeight * value / cue.cellResolution.rows;
};
var convertLengthValue = function convertLengthValue(lengthValue, cue, screenSize) {
  var lengthValueInfo = getLengthValueInfo(lengthValue);
  if (!lengthValueInfo) {
    return lengthValue;
  }
  var fullContainerHeight = getFullContainerHeight(screenSize);
  var unit = lengthValueInfo.unit,
    value = lengthValueInfo.value;
  switch (unit) {
    case '%':
      return getAbsoluteLengthInPixels(value / 100, cue, fullContainerHeight);
    case 'c':
      return getAbsoluteLengthInPixels(value, cue, fullContainerHeight);
    default:
      return lengthValue;
  }
};
var parseColor = function parseColor(hex) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0x00000000;
  var result = parseInt(hex.length === 9 ? "0x".concat(hex.substring(7)).concat(hex.substring(1, 7)) : hex.replace('#', '0x'), 16);
  return Number.isFinite(result) ? result : fallback;
};
;// CONCATENATED MODULE: ./src/modules/subtitles/subtitles.connect.js


var subtitles_connect_mapControllers = function mapControllers(instance) {
  return {
    subtitleCuePoint: {
      selector: getSubtitleCuePoint,
      shouldBeInvokedOnConnect: true,
      callback: function callback(value) {
        instance.updateSubtitles(value);
      }
    }
  };
};
/* harmony default export */ const subtitles_connect = (lightningjs_redux.control(subtitles_connect_mapControllers));
;// CONCATENATED MODULE: ./src/modules/subtitles/subtitles.component.js













var subtitles_component_excluded = ["cuePointState"];
function subtitles_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function subtitles_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? subtitles_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : subtitles_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function subtitles_component_createSuper(t) { var r = subtitles_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function subtitles_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (subtitles_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }









var subtitles_component_Subtitles = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Subtitles, _Lightning$Component);
  var _super = subtitles_component_createSuper(Subtitles);
  function Subtitles() {
    (0,classCallCheck/* default */.Z)(this, Subtitles);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Subtitles, [{
    key: "_construct",
    value: function _construct() {
      this._screenSize = subtitles_style_defaultContext.screenSize;
    }
  }, {
    key: "_attach",
    value: function _attach() {
      this._unsubscribe = subtitles_connect(this);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      if (this._unsubscribe) {
        this._unsubscribe();
        this._unsubscribe = null;
      }
    }
  }, {
    key: "updateSubtitles",
    value: function updateSubtitles(payload) {
      var _this = this;
      if (!payload) {
        return;
      }
      var action = payload.cuePointState,
        parent = objectWithoutProperties_objectWithoutProperties(payload, subtitles_component_excluded);
      if (action === CUE_ACTION.REMOVED) {
        if (isEmpty_default()(parent)) {
          this._clearAllRegions();
        } else {
          this._removeItem(parent);
        }
        return;
      }
      this._parseCue(parent);
      if (parent.version === TEXT_RENDERER_V4) {
        var parentBackgroundColor = parseColor(parent.backgroundColor);
        (parent.nestedCues || []).filter(function (cue) {
          return Boolean(cue.payload);
        }).forEach(function (child) {
          _this._parseCue(subtitles_component_objectSpread(subtitles_component_objectSpread({}, child), {}, {
            backgroundColor: parseColor(child.backgroundColor) || parentBackgroundColor || DEFAULT_BACKGROUND_COLOR,
            region: parent.region
          }));
        });
      } else {
        parent.nestedCues.forEach(function (nestedCue) {
          _this._parseCue(nestedCue, true);
        });
      }
    }
  }, {
    key: "_parseCue",
    value: function _parseCue(cue) {
      if (this._isLineBreak(cue) || !(cue.payload && cue.payload.length)) {
        return;
      }
      var regionId = this._getRegionId(cue);
      if (cue.region && cue.region.id) {
        this._applyRegionStyle(regionId, getDimensionsByRegion(cue, this._screenSize));
      }
      if (cue.size) {
        this._applyRegionStyle(regionId, getDimensionsBySize(cue.size, cue.writingMode, this._screenSize));
      }
      this._addItem(cue);
    }
  }, {
    key: "_getRegionById",
    value: function _getRegionById(regionId) {
      return this.tag("Regions.".concat(regionId));
    }
  }, {
    key: "_applyRegionStyle",
    value: function _applyRegionStyle(regionId, style) {
      if (!this._getRegionById(regionId)) {
        this.tag('Regions').patch((0,defineProperty/* default */.Z)({}, regionId, getDefaultRegionStyle(this._screenSize)));
      }
      this.tag('Regions').patch((0,defineProperty/* default */.Z)({}, regionId, style));
    }
  }, {
    key: "_addItem",
    value: function _addItem(cue) {
      var regionId = this._getRegionId(cue);
      var region = this._getRegionById(regionId);
      var currentCues = region.children;
      var styledItem = merge_default()(getItemStyle(), this._parseCueStyle(cue, region));
      region.children = [].concat((0,toConsumableArray/* default */.Z)(currentCues), [styledItem]);
    }
  }, {
    key: "_removeItem",
    value: function _removeItem(cue, regionId) {
      var _this2 = this;
      var parentRegionId = regionId || this._getRegionId(cue);
      var region = this._getRegionById(parentRegionId);
      if (cue.nestedCues) {
        cue.nestedCues.forEach(function (nestedCue) {
          return _this2._removeItem(nestedCue, parentRegionId);
        });
      }
      if (region) {
        region.children = region.children.filter(function (child) {
          return !isEqualCuePoint(child.metadata, cue);
        });
      }
    }
  }, {
    key: "_clearAllRegions",
    value: function _clearAllRegions() {
      this.tag('Regions').children = [];
    }
  }, {
    key: "_isLineBreak",
    value: function _isLineBreak(cue) {
      return Boolean(cue.lineBreak || cue.spacer);
    }
  }, {
    key: "_getRegionId",
    value: function _getRegionId(cue) {
      if (cue.region && cue.region.id) {
        return "Region_".concat(cue.region.id);
      }
      return "Region_".concat(DEFAULT_REGION);
    }
  }, {
    key: "_parseCueStyle",
    value: function _parseCueStyle(cue, region) {
      var text = {
        text: cue.payload,
        wordWrapWidth: region.finalW
      };
      var result = {
        text: text,
        metadata: cue,
        flexItem: {
          alignSelf: 'center'
        }
      };
      if (cue.backgroundColor) {
        text.highlight = true;
        text.highlightColor = Number.isFinite(cue.backgroundColor) ? cue.backgroundColor : parseColor(cue.backgroundColor);
      }
      if (cue.color) {
        text.textColor = parseColor(cue.color);
      }
      if (cue.fontFamily) {
        text.fontFace = cue.fontFamily;
      }
      if (cue.fontSize) {
        text.fontSize = convertLengthValue(text.fontSize, cue, this._screenSize);
      }
      if (cue.fontStyle) {
        text.fontStyle = cue.fontStyle;
      }
      if (cue.lineHeight) {
        text.lineHeight = cue.lineHeight;
      }
      if (cue.position) {
        if (cue.writingMode === writingMode.HORIZONTAL_TOP_TO_BOTTOM) {
          text.paddingLeft = cue.position;
        }
      }
      return result;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return subtitles_style_getInitialStyle();
    }
  }]);
  return Subtitles;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/player/ads/playbackStateIndicator/playbackStateIndicator.style.js

var playbackStateIndicator_style_ICON_HEIGHT;


var playbackStateIndicator_style_defaultContext = makeDefaultStylingContext();
var playbackStateIndicator_playbackStateIndicator_style_ICON_HEIGHT = (playbackStateIndicator_style_ICON_HEIGHT = {}, (0,defineProperty/* default */.Z)(playbackStateIndicator_style_ICON_HEIGHT, HD, 24), (0,defineProperty/* default */.Z)(playbackStateIndicator_style_ICON_HEIGHT, FULL_HD, 32), playbackStateIndicator_style_ICON_HEIGHT);
var playbackStateIndicator_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : playbackStateIndicator_style_defaultContext;
  var screenSize = context.screenSize;
  return {
    h: playbackStateIndicator_playbackStateIndicator_style_ICON_HEIGHT[screenSize]
  };
};
;// CONCATENATED MODULE: ./src/modules/player/ads/customer/rtlde/ads.constants.js
var DEFAULT_VOLUME_LEVEL = 0.5;
var DISPLAY_SHADOW_OVERLAY = false;
var DISPLAY_AD_METADATA = false;
;// CONCATENATED MODULE: ./src/modules/player/ads/ads.constants.js
var PAUSE_SIGNAL = 'pause';

var PLAY_SIGNAL = 'play';
var AD_ANALYTICS_TYPES = {
  begin: {
    preroll: 'prerollBegins',
    midroll: 'midrollBegins'
  },
  back: {
    preroll: 'pressBackButtonDuringPreroll',
    midroll: 'pressBackButtonDuringMidroll'
  },
  post: {
    preroll: 'postPreroll',
    midroll: 'postMidroll'
  }
};
var TOP_BAR_ITEMS = {
  BACK: 'BACK'
};
var BRIDGE_AD_OCEAN = 'adOcean';
var ADS_COUNTDOWN_DEFAULT_TOTAL_DURATION = 20;
;// CONCATENATED MODULE: ./src/modules/player/ads/customer/default/ads.style.js

var _METADATA_MARGIN_BOTT;
function ads_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ads_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ads_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ads_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






var ads_style_defaultContext = makeDefaultStylingContext();
var ads_style_colors = {
  text: makeThemeColor(PRIMARY)
};
var METADATA_MARGIN_BOTTOM = (_METADATA_MARGIN_BOTT = {}, (0,defineProperty/* default */.Z)(_METADATA_MARGIN_BOTT, HD, 8), (0,defineProperty/* default */.Z)(_METADATA_MARGIN_BOTT, FULL_HD, 16), _METADATA_MARGIN_BOTT);
var ads_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ads_style_defaultContext;
  var screenSize = context.screenSize;
  var margin = {
    x: safetyMargins.horizontal[screenSize],
    y: safetyMargins.vertical[screenSize]
  };
  var playbackStateIndicatorY = sizes_SCREEN_HEIGHT[screenSize] - margin.y;
  return {
    w: SCREEN_WIDTH[screenSize],
    h: sizes_SCREEN_HEIGHT[screenSize],
    Overlay: {
      visible: DISPLAY_SHADOW_OVERLAY
    },
    TopBar: ads_style_objectSpread({
      visible: DISPLAY_AD_METADATA
    }, margin),
    Metadata: {
      visible: DISPLAY_AD_METADATA,
      x: margin.x,
      y: playbackStateIndicatorY - playbackStateIndicator_playbackStateIndicator_style_ICON_HEIGHT[screenSize] - METADATA_MARGIN_BOTTOM[screenSize],
      mountY: 1
    },
    PlaybackStateIndicator: {
      visible: DISPLAY_AD_METADATA,
      x: margin.x,
      y: playbackStateIndicatorY,
      mountY: 1
    },
    Countdown: {
      mountX: 1,
      x: function x(v) {
        return v - safetyMargins.horizontal[screenSize];
      },
      y: safetyMargins.vertical[screenSize],
      displayIcon: false
    },
    AdJingle: {
      w: SCREEN_WIDTH[screenSize],
      h: sizes_SCREEN_HEIGHT[screenSize]
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/player/ads/ads.connector.js



var ads_connector_mapControllers = function mapControllers(instance) {
  return [{
    selector: getAdBreakDuration,
    callback: function callback(value) {
      instance.adBreakDuration = value;
    },
    shouldBeInvokedOnConnect: true
  }, {
    selector: getAdBreakElapsedTime,
    callback: function callback(value) {
      instance.adBreakElapsedTime = value;
    },
    shouldBeInvokedOnConnect: true
  }, {
    selector: getPlayerAdsCountFeature,
    callback: function callback(value) {
      instance.displayAdsCountdown = value;
    },
    shouldBeInvokedOnConnect: true
  }, {
    selector: getAdJingleImageId,
    callback: function callback(value) {
      instance.adJingleImageId = value;
    },
    shouldBeInvokedOnConnect: true
  }, {
    selector: isAdJingleDisplayed,
    callback: function callback(value) {
      instance.isAdJingleDisplayed = value;
    },
    shouldBeInvokedOnConnect: true
  }, {
    selector: player_selectors_getTitle,
    callback: function callback(value) {
      instance.contentTitle = value;
    },
    shouldBeInvokedOnConnect: true
  }, {
    selector: getAdPlaybackState,
    callback: function callback(value) {
      instance.playbackState = value;
    },
    shouldBeInvokedOnConnect: true
  }, {
    selector: getDisplayedAdBreakType,
    callback: function callback(value) {
      instance.displayedAdBreakType = value;
    },
    shouldBeInvokedOnConnect: true
  }, {
    selector: getLBannerState,
    callback: function callback(value) {
      instance.shouldDisplayLBanner = value;
    }
  }];
};
/* harmony default export */ const ads_connector = (lightningjs_redux.control(ads_connector_mapControllers));
;// CONCATENATED MODULE: ./src/modules/player/interface/metadata/metadata.constants.js

var _MAX_TEXT_WIDTH, metadata_constants_TITLE_MARGIN_BOTTOM;

var MAX_TEXT_WIDTH = (_MAX_TEXT_WIDTH = {}, (0,defineProperty/* default */.Z)(_MAX_TEXT_WIDTH, HD, 1000), (0,defineProperty/* default */.Z)(_MAX_TEXT_WIDTH, FULL_HD, 1000), _MAX_TEXT_WIDTH);
var metadata_metadata_constants_TITLE_MARGIN_BOTTOM = (metadata_constants_TITLE_MARGIN_BOTTOM = {}, (0,defineProperty/* default */.Z)(metadata_constants_TITLE_MARGIN_BOTTOM, HD, 4), (0,defineProperty/* default */.Z)(metadata_constants_TITLE_MARGIN_BOTTOM, FULL_HD, 8), metadata_constants_TITLE_MARGIN_BOTTOM);
;// CONCATENATED MODULE: ./src/modules/player/interface/metadata/metadata.style.js

function metadata_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function metadata_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? metadata_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : metadata_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



var metadata_style_defaultContext = makeDefaultStylingContext();
var genericTextStyle = {
  maxLines: 1,
  textBaseline: 'bottom',
  verticalAlign: 'middle'
};
var metadata_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : metadata_style_defaultContext;
  var screenSize = context.screenSize;
  var titleFont = src_getFont(constants_FONT.KINSHASA_1, screenSize);
  var extraTitleFont = src_getFont(constants_FONT.OTTAWA_1, screenSize);
  var wordWrapWidth = MAX_TEXT_WIDTH[screenSize];
  return {
    w: wordWrapWidth,
    h: titleFont.lineHeight + metadata_metadata_constants_TITLE_MARGIN_BOTTOM[screenSize] + extraTitleFont.lineHeight,
    ExtraTitle: {
      mountY: 1,
      text: metadata_style_objectSpread(metadata_style_objectSpread({
        wordWrapWidth: wordWrapWidth
      }, genericTextStyle), extraTitleFont)
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/player/interface/metadata/components/metadataTitle.constants.js

var _CSA_ICON_SIZE, _CSA_ICON_MARGIN;

var CSA_ICON_SIZE = (_CSA_ICON_SIZE = {}, (0,defineProperty/* default */.Z)(_CSA_ICON_SIZE, HD, 24), (0,defineProperty/* default */.Z)(_CSA_ICON_SIZE, FULL_HD, 32), _CSA_ICON_SIZE);
var CSA_ICON_MARGIN = (_CSA_ICON_MARGIN = {}, (0,defineProperty/* default */.Z)(_CSA_ICON_MARGIN, HD, 8), (0,defineProperty/* default */.Z)(_CSA_ICON_MARGIN, FULL_HD, 8), _CSA_ICON_MARGIN);
;// CONCATENATED MODULE: ./src/modules/player/interface/metadata/components/metadataTitle.style.js

function metadataTitle_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function metadataTitle_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? metadataTitle_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : metadataTitle_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






var metadataTitle_style_defaultContext = makeDefaultStylingContext();
var getCSAIconViewBox = memoize_default()(function (screenSize) {
  return {
    h: CSA_ICON_SIZE[screenSize],
    w: CSA_ICON_SIZE[screenSize]
  };
});
var metadataTitle_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : metadataTitle_style_defaultContext;
  var screenSize = context.screenSize;
  var wordWrapWidth = MAX_TEXT_WIDTH[screenSize];
  var titleFont = src_getFont(constants_FONT.KINSHASA_1, screenSize);
  return {
    FlexContainer: {
      flex: {
        direction: 'row',
        alignItems: 'center'
      },
      Title: {
        text: metadataTitle_style_objectSpread(metadataTitle_style_objectSpread({
          wordWrapWidth: wordWrapWidth
        }, genericTextStyle), titleFont)
      },
      CsaIcon: {
        visible: false,
        flexItem: {
          marginLeft: CSA_ICON_MARGIN[screenSize]
        }
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/player/interface/metadata/components/customer/default/metadataTitle.connector.js


var metadataTitle_connector_mapControllers = function mapControllers(instance) {
  return [{
    selector: player_selectors_getCSAPicto,
    callback: function callback(value) {
      instance.csaPicto = value;
    },
    shouldBeInvokedOnConnect: true
  }];
};
/* harmony default export */ const metadataTitle_connector = (lightningjs_redux.control(metadataTitle_connector_mapControllers));
;// CONCATENATED MODULE: ./src/modules/player/interface/metadata/components/customer/default/metadataTitle.component.js





function metadataTitle_component_createSuper(t) { var r = metadataTitle_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function metadataTitle_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (metadataTitle_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }





var MetadataTitle = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(MetadataTitle, _Lightning$Component);
  var _super = metadataTitle_component_createSuper(MetadataTitle);
  function MetadataTitle() {
    (0,classCallCheck/* default */.Z)(this, MetadataTitle);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(MetadataTitle, [{
    key: "_construct",
    value: function _construct() {
      this._style = metadataTitle_style_defaultContext;
      this._csaPicto = null;
      this._hasAgeGate = false;
    }
  }, {
    key: "_attach",
    value: function _attach() {
      this._unsubscribe = metadataTitle_connector(this);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      if (this._unsubscribe) {
        this._unsubscribe();
        this._unsubscribe = null;
      }
    }
  }, {
    key: "title",
    get: function get() {
      return this.tag('Title').text;
    },
    set: function set(value) {
      this.tag('Title').text = value;
    }
  }, {
    key: "csaPicto",
    set: function set(value) {
      this._csaPicto = value;
      this.tag('CsaIcon').visible = Boolean(this._csaPicto);
      this.patch({
        FlexContainer: {
          CsaIcon: {
            visible: true,
            iconData: {
              picto: this._csaPicto,
              viewBox: getCSAIconViewBox(this._style.screenSize)
            }
          }
        }
      });
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        FlexContainer: {
          Title: {},
          CsaIcon: {
            type: Icon
          }
        }
      }, metadataTitle_style_getInitialStyle());
    }
  }]);
  return MetadataTitle;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/player/interface/metadata/components/metadataTitle.component.js

;// CONCATENATED MODULE: ./src/modules/player/interface/metadata/metadata.component.js





function metadata_component_createSuper(t) { var r = metadata_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function metadata_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (metadata_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }




var metadata_component_Metadata = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Metadata, _Lightning$Component);
  var _super = metadata_component_createSuper(Metadata);
  function Metadata() {
    (0,classCallCheck/* default */.Z)(this, Metadata);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Metadata, [{
    key: "_build",
    value: function _build() {
      this._style = metadata_style_defaultContext;
    }
  }, {
    key: "_updatePositions",
    value: function _updatePositions() {
      var extraTitle = this.tag('ExtraTitle');
      var offset = this.finalH;
      if (extraTitle.visible) {
        extraTitle.y = offset;
      }
    }
  }, {
    key: "title",
    get: function get() {
      return this.tag('Title').title;
    },
    set: function set(value) {
      var element = this.tag('Title');
      element.title = value;
      element.visible = Boolean(value);
      this._updatePositions();
    }
  }, {
    key: "extraTitle",
    get: function get() {
      return this.tag('ExtraTitle').text.text;
    },
    set: function set(value) {
      var element = this.tag('ExtraTitle');
      element.text.text = value;
      element.visible = Boolean(value);
      this._updatePositions();
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Title: {
          type: MetadataTitle
        },
        ExtraTitle: {}
      }, metadata_style_getInitialStyle());
    }
  }]);
  return Metadata;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/player/ads/playbackStateIndicator/playbackStateIndicator.utils.js



var makeIcon = function makeIcon(name) {
  return {
    type: Icon,
    iconData: {
      picto: {
        name: name,
        collection: ICON_COLLECTION.CONTROLS
      },
      viewBox: {
        h: playbackStateIndicator_playbackStateIndicator_style_ICON_HEIGHT[playbackStateIndicator_style_defaultContext.screenSize]
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/player/ads/playbackStateIndicator/playbackStateIndicator.component.js





function playbackStateIndicator_component_createSuper(t) { var r = playbackStateIndicator_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function playbackStateIndicator_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (playbackStateIndicator_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }




var PlaybackStateIndicator = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(PlaybackStateIndicator, _Lightning$Component);
  var _super = playbackStateIndicator_component_createSuper(PlaybackStateIndicator);
  function PlaybackStateIndicator() {
    (0,classCallCheck/* default */.Z)(this, PlaybackStateIndicator);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(PlaybackStateIndicator, [{
    key: "_attach",
    value: function _attach() {
      this._setState('Playing');
    }
  }, {
    key: "show",
    value: function show(state) {
      this._setState(state);
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        PlayIcon: makeIcon('Play'),
        PauseIcon: makeIcon('Pause')
      }, playbackStateIndicator_style_getInitialStyle());
    }
  }, {
    key: "_states",
    value: function _states() {
      return [function (_this) {
        (0,inherits/* default */.Z)(Playing, _this);
        var _super2 = playbackStateIndicator_component_createSuper(Playing);
        function Playing() {
          (0,classCallCheck/* default */.Z)(this, Playing);
          return _super2.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(Playing, [{
          key: "$enter",
          value: function $enter() {
            this.tag('PlayIcon').visible = true;
            this.tag('PauseIcon').visible = false;
          }
        }]);
        return Playing;
      }(this), function (_this2) {
        (0,inherits/* default */.Z)(Paused, _this2);
        var _super3 = playbackStateIndicator_component_createSuper(Paused);
        function Paused() {
          (0,classCallCheck/* default */.Z)(this, Paused);
          return _super3.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(Paused, [{
          key: "$enter",
          value: function $enter() {
            this.tag('PlayIcon').visible = false;
            this.tag('PauseIcon').visible = true;
          }
        }]);
        return Paused;
      }(this)];
    }
  }]);
  return PlaybackStateIndicator;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/player/interface/topBar/components/topBarItem.style.js

var topBarItem_style_HEIGHT, topBarItem_style_ICON_SIZE, topBarItem_style_ICON_MARGIN_RIGHT, _SPACER_END;
function topBarItem_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function topBarItem_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? topBarItem_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : topBarItem_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






var topBarItem_style_defaultContext = makeDefaultStylingContext();
var components_topBarItem_style_HEIGHT = (topBarItem_style_HEIGHT = {}, (0,defineProperty/* default */.Z)(topBarItem_style_HEIGHT, HD, 48), (0,defineProperty/* default */.Z)(topBarItem_style_HEIGHT, FULL_HD, 72), topBarItem_style_HEIGHT);
var components_topBarItem_style_ICON_SIZE = (topBarItem_style_ICON_SIZE = {}, (0,defineProperty/* default */.Z)(topBarItem_style_ICON_SIZE, HD, 32), (0,defineProperty/* default */.Z)(topBarItem_style_ICON_SIZE, FULL_HD, 40), topBarItem_style_ICON_SIZE);
var components_topBarItem_style_ICON_MARGIN_RIGHT = (topBarItem_style_ICON_MARGIN_RIGHT = {}, (0,defineProperty/* default */.Z)(topBarItem_style_ICON_MARGIN_RIGHT, HD, 8), (0,defineProperty/* default */.Z)(topBarItem_style_ICON_MARGIN_RIGHT, FULL_HD, 16), topBarItem_style_ICON_MARGIN_RIGHT);
var SPACER_END = (_SPACER_END = {}, (0,defineProperty/* default */.Z)(_SPACER_END, HD, 32), (0,defineProperty/* default */.Z)(_SPACER_END, FULL_HD, 32), _SPACER_END);
var LABEL_UNFOCUSED_ALPHA = 0;
var FOCUSED_ALPHA = 1;
var topBarItem_style_colors = {
  icon: makeThemeColor(PRIMARY),
  iconFocused: makeThemeColor(TERTIARY),
  iconBackground: makeThemeColor(TERTIARY, 0.3),
  iconBackgroundFocused: makeThemeColor(PRIMARY),
  text: makeThemeColor(PRIMARY),
  background: makeThemeColor(TERTIARY, 0.3),
  border: makeThemeColor(PRIMARY, 0.1)
};
var topBarItem_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : topBarItem_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  var font = src_getFont(constants_FONT.OTTAWA_2, screenSize);
  return {
    h: components_topBarItem_style_HEIGHT[screenSize],
    Background: {
      alpha: 0,
      rect: true,
      h: components_topBarItem_style_HEIGHT[screenSize],
      shader: {
        radius: Math.round(components_topBarItem_style_HEIGHT[screenSize] / 2),
        fillColor: topBarItem_style_colors.background[colorMode],
        strokeColor: topBarItem_style_colors.border[colorMode],
        stroke: 1.25
      }
    },
    IconWrapper: {
      w: components_topBarItem_style_HEIGHT[screenSize],
      h: components_topBarItem_style_HEIGHT[screenSize],
      IconBackground: {
        rect: true,
        w: components_topBarItem_style_HEIGHT[screenSize],
        h: components_topBarItem_style_HEIGHT[screenSize],
        shader: {
          fillColor: topBarItem_style_colors.iconBackground[colorMode],
          radius: Math.round(components_topBarItem_style_HEIGHT[screenSize] / 2)
        }
      },
      Icon: {
        color: topBarItem_style_colors.icon[colorMode],
        mount: 0.5,
        x: middle,
        y: middle
      }
    },
    Label: {
      x: components_topBarItem_style_HEIGHT[screenSize] + components_topBarItem_style_ICON_MARGIN_RIGHT[screenSize],
      alpha: LABEL_UNFOCUSED_ALPHA,
      mountY: 0.5,
      y: middle,
      color: topBarItem_style_colors.text[colorMode],
      text: topBarItem_style_objectSpread(topBarItem_style_objectSpread({}, font), {}, {
        verticalAlign: 'middle'
      })
    }
  };
};
var topBarItem_style_getFocusedStyle = memoize_default()(function (_ref) {
  var colorMode = _ref.colorMode;
  return {
    Background: {
      smooth: {
        alpha: 1
      }
    },
    IconWrapper: {
      IconBackground: {
        smooth: {
          'shader.fillColor': topBarItem_style_colors.iconBackgroundFocused[colorMode]
        }
      },
      Icon: {
        smooth: {
          color: topBarItem_style_colors.iconFocused[colorMode]
        }
      }
    },
    Label: {
      smooth: {
        alpha: FOCUSED_ALPHA
      }
    }
  };
}, cacheResolver);
var topBarItem_style_getUnFocusedStyle = memoize_default()(function (_ref2) {
  var colorMode = _ref2.colorMode;
  return {
    Background: {
      smooth: {
        alpha: 0
      }
    },
    IconWrapper: {
      IconBackground: {
        smooth: {
          'shader.fillColor': topBarItem_style_colors.iconBackground[colorMode]
        }
      },
      Icon: {
        smooth: {
          color: topBarItem_style_colors.icon[colorMode]
        }
      }
    },
    Label: {
      smooth: {
        alpha: LABEL_UNFOCUSED_ALPHA
      }
    }
  };
}, cacheResolver);
;// CONCATENATED MODULE: ./src/modules/player/interface/topBar/components/topBarItem.component.js





function topBarItem_component_createSuper(t) { var r = topBarItem_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function topBarItem_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (topBarItem_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }





var TopBarItem = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(TopBarItem, _Lightning$Component);
  var _super = topBarItem_component_createSuper(TopBarItem);
  function TopBarItem() {
    (0,classCallCheck/* default */.Z)(this, TopBarItem);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(TopBarItem, [{
    key: "_construct",
    value: function _construct() {
      this._style = topBarItem_style_defaultContext;
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this.tag('Label').removeAllListeners('txLoaded');
    }
  }, {
    key: "data",
    set: function set(value) {
      var _this = this;
      var text = value.text,
        icon = value.icon;
      var screenSize = this._style.screenSize;
      this.tag('Label').once('txLoaded', function () {
        _this.tag('Background').w = components_topBarItem_style_HEIGHT[screenSize] + components_topBarItem_style_ICON_MARGIN_RIGHT[screenSize] + _this.tag('Label').finalW + SPACER_END[screenSize];
      });
      this.patch({
        IconWrapper: {
          Icon: {
            iconData: {
              viewBox: {
                h: components_topBarItem_style_ICON_SIZE[this._style.screenSize]
              },
              picto: {
                name: icon,
                collection: ICON_COLLECTION.SPECIAL
              }
            }
          }
        },
        Label: {
          text: {
            text: text
          }
        }
      });
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this.patch(topBarItem_style_getFocusedStyle(this._style));
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this.patch(topBarItem_style_getUnFocusedStyle(this._style));
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Background: {
          shader: {
            type: src_Lightning.shaders.RoundedRectangle
          }
        },
        IconWrapper: {
          IconBackground: {
            shader: {
              type: src_Lightning.shaders.RoundedRectangle
            }
          },
          Icon: {
            type: Icon
          }
        },
        Label: {}
      }, topBarItem_style_getInitialStyle());
    }
  }]);
  return TopBarItem;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/player/interface/topBar/topBar.style.js

var topBar_style_GAP;


var topBar_style_defaultContext = makeDefaultStylingContext();
var topBar_topBar_style_GAP = (topBar_style_GAP = {}, (0,defineProperty/* default */.Z)(topBar_style_GAP, HD, 8), (0,defineProperty/* default */.Z)(topBar_style_GAP, FULL_HD, 16), topBar_style_GAP);
;// CONCATENATED MODULE: ./src/modules/player/interface/topBar/topBar.component.js







function topBar_component_createSuper(t) { var r = topBar_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function topBar_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (topBar_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }





var TopBar = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(TopBar, _Lightning$Component);
  var _super = topBar_component_createSuper(TopBar);
  function TopBar() {
    (0,classCallCheck/* default */.Z)(this, TopBar);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(TopBar, [{
    key: "_construct",
    value: function _construct() {
      this._style = topBar_style_defaultContext;
      this._index = 0;
      this._items = [];
    }
  }, {
    key: "items",
    set: function set(value) {
      var _this = this;
      this._items = value;
      this._maxIndex = Math.max(this._items.length - 1, 0);
      var topBarItemHeight = components_topBarItem_style_HEIGHT[this._style.screenSize];
      var container = this.tag('Items');
      if (container.children.length === this._items.length) {
        container.children.forEach(function (view, index) {
          view.data = _this._items[index];
        });
        return;
      }
      container.children = this._items.map(function (data, index) {
        return {
          type: TopBarItem,
          data: data,
          y: (topBarItemHeight + topBar_topBar_style_GAP[_this._style.screenSize]) * index
        };
      });
      this._index = Math.min(this._index, this._maxIndex);
      this._refocus();
    }
  }, {
    key: "index",
    get: function get() {
      return this._index;
    },
    set: function set(value) {
      this._index = value;
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this.tag('Items').children[this._index];
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this.index = 0;
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      var item = this._items[this._index];
      if (item) {
        this.signal(SELECTED_SIGNAL, item);
        return true;
      }
      return false;
    }
  }, {
    key: "_handleUp",
    value: function _handleUp() {
      if (this.index > 0) {
        this.index -= 1;
        return true;
      }
      return false;
    }
  }, {
    key: "_handleDown",
    value: function _handleDown() {
      if (this.index < this._maxIndex) {
        this.index += 1;
        return true;
      }
      return false;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return {
        Items: {}
      };
    }
  }]);
  return TopBar;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/player/interface/pill/pill.shader.js

































function pill_shader_createSuper(t) { var r = pill_shader_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function pill_shader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (pill_shader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var PillShader = function (_Lightning$shaders$We) {
  (0,inherits/* default */.Z)(PillShader, _Lightning$shaders$We);
  var _super = pill_shader_createSuper(PillShader);
  function PillShader(context) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, PillShader);
    _this = _super.call(this, context);
    _this._blend = 0;
    _this._radius = [1, 1, 1, 1];
    _this._stroke = 0;
    _this._progress = 0;
    _this._fc = 0x00ffffff;
    _this._pc = 0x00ffffff;
    _this._fillColor = _this._getNormalizedColor(_this._fc);
    _this._progressColor = _this._getNormalizedColor(_this._pc);
    _this._strokeColor = _this._getNormalizedColor(0x00ffffff);
    return _this;
  }
  (0,createClass/* default */.Z)(PillShader, [{
    key: "blend",
    set: function set(p) {
      this._blend = Math.min(Math.max(p, 0), 1);
    }
  }, {
    key: "radius",
    get: function get() {
      return this._radius;
    },
    set: function set(v) {
      if (Array.isArray(v)) {
        if (v.length === 2) {
          this._radius = [v[0], v[1], v[0], v[1]];
        } else if (v.length === 3) {
          this._radius = [v[0], v[1], v[2], this._radius[3]];
        } else if (v.length === 4) {
          this._radius = v;
        } else {
          this._radius = [v[0], v[0], v[0], v[0]];
        }
      } else {
        this._radius = [v, v, v, v];
      }
      this.redraw();
    }
  }, {
    key: "progress",
    get: function get() {
      return this._progress;
    },
    set: function set(value) {
      this._progress = value;
      this.redraw();
    }
  }, {
    key: "topLeft",
    get: function get() {
      return this._radius[0];
    },
    set: function set(num) {
      this._radius[0] = num;
      this.redraw();
    }
  }, {
    key: "topRight",
    get: function get() {
      return this._radius[1];
    },
    set: function set(num) {
      this._radius[1] = num;
      this.redraw();
    }
  }, {
    key: "bottomRight",
    get: function get() {
      return this._radius[2];
    },
    set: function set(num) {
      this._radius[2] = num;
      this.redraw();
    }
  }, {
    key: "bottomLeft",
    get: function get() {
      return this._radius[4];
    },
    set: function set(num) {
      this._radius[3] = num;
      this.redraw();
    }
  }, {
    key: "strokeColor",
    get: function get() {
      return this._sc;
    },
    set: function set(argb) {
      this._sc = argb;
      this._strokeColor = this._getNormalizedColor(argb);
      this.redraw();
    }
  }, {
    key: "fillColor",
    get: function get() {
      return this._fc;
    },
    set: function set(argb) {
      this._fc = argb;
      this._fillColor = this._getNormalizedColor(argb);
      this.redraw();
    }
  }, {
    key: "progressColor",
    get: function get() {
      return this._pc;
    },
    set: function set(argb) {
      this._pc = argb;
      this._progressColor = this._getNormalizedColor(argb);
      this.redraw();
    }
  }, {
    key: "stroke",
    get: function get() {
      return this._stroke;
    },
    set: function set(num) {
      this._stroke = num;
      this.redraw();
    }
  }, {
    key: "_getNormalizedColor",
    value: function _getNormalizedColor(color) {
      var col = src_Lightning.StageUtils.getRgbaComponentsNormalized(color);
      col[0] *= col[3];
      col[1] *= col[3];
      col[2] *= col[3];
      return new Float32Array(col);
    }
  }, {
    key: "setupUniforms",
    value: function setupUniforms(operation) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(PillShader.prototype), "setupUniforms", this).call(this, operation);
      var owner = operation.shaderOwner;
      var renderPrecision = this.ctx.stage.getRenderPrecision();
      var _radius = this._radius.map(function (r) {
        return (r + 0.5) * renderPrecision;
      });
      this._setUniform('radius', new Float32Array(_radius), this.gl.uniform4fv);
      this._setUniform('alpha', operation.getElementCore(0).renderContext.alpha, this.gl.uniform1f);
      this._setUniform('blend', this._blend, this.gl.uniform1f);
      this._setUniform('strokeColor', this._strokeColor, this.gl.uniform4fv);
      this._setUniform('fillColor', this._fillColor, this.gl.uniform4fv);
      this._setUniform('progressColor', this._progressColor, this.gl.uniform4fv);
      this._setUniform('progress', this._progress, this.gl.uniform1f);
      this._setUniform('stroke', this._stroke * renderPrecision, this.gl.uniform1f);
      this._setUniform('resolution', new Float32Array([owner._w * renderPrecision, owner._h * renderPrecision]), this.gl.uniform2fv);
    }
  }]);
  return PillShader;
}(src_Lightning.shaders.WebGLDefaultShader);

PillShader.vertexShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    attribute vec2 aVertexPosition;\n    attribute vec2 aTextureCoord;\n\n    attribute vec4 aColor;\n    uniform vec2 projection;\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n\n    void main(void){\n        gl_Position = vec4(aVertexPosition.x * projection.x - 1.0, aVertexPosition.y * -abs(projection.y) + 1.0, 0.0, 1.0);\n        vTextureCoord = aTextureCoord;\n        vColor = aColor;\n        gl_Position.y = -sign(projection.y) * gl_Position.y;\n    }\n";
PillShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n\n    #define PI 3.14159265359\n\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n\n    uniform sampler2D uSampler;\n    uniform vec2 resolution;\n    uniform vec4 radius;\n    uniform float stroke;\n    uniform vec4 strokeColor;\n    uniform vec4 fillColor;\n    uniform vec4 progressColor;\n    uniform float progress;\n    uniform float alpha;\n    uniform float fill;\n    uniform float blend;\n\n    float boxDist(vec2 p, vec2 size, float radius){\n        size -= vec2(radius);\n        vec2 d = abs(p) - size;\n        return min(max(d.x, d.y), 0.0) + length(max(d, 0.0)) - radius;\n    }\n\n    float fillMask(float dist){\n        return clamp(-dist, 0.0, 1.0);\n    }\n\n    float innerBorderMask(float dist, float width){\n        float alpha1 = clamp(dist + width, 0.0, 1.0);\n        float alpha2 = clamp(dist, 0.0, 1.0);\n        return alpha1 - alpha2;\n    }\n\n    void main() {\n        vec2 halfRes = 0.5 * resolution.xy;\n        float r = 0.0;\n        if (vTextureCoord.x < 0.5 && vTextureCoord.y < 0.5) {\n            r = radius[0];\n        } else if (vTextureCoord.x >= 0.5 && vTextureCoord.y < 0.5) {\n            r = radius[1];\n        } else if (vTextureCoord.x >= 0.5 && vTextureCoord.y >= 0.5) {\n            r = radius[2];\n        } else {\n            r = radius[3];\n        }\n\n        vec4 pillColor = fillColor;\n        if (vTextureCoord.x < progress) {\n          pillColor.rgb = mix(progressColor.rgb, pillColor.rgb, progressColor.a);\n        }\n\n        float b = boxDist(vTextureCoord.xy * resolution - halfRes, halfRes - 0.005, r);\n        vec4 tex = texture2D(uSampler, vTextureCoord) * vColor;\n        vec4 blend = mix(vec4(1.0) * alpha, tex, blend);\n        vec4 layer1 = mix(vec4(0.0), tex * pillColor, fillMask(b));\n        gl_FragColor = mix(layer1, blend * strokeColor, innerBorderMask(b, stroke));\n    }\n";
;// CONCATENATED MODULE: ./src/modules/player/interface/pill/pill.style.js

var interface_pill_pill_style_HEIGHT, pill_style_ICON_HEIGHT, _HORIZONTAL_PADDING, pill_style_VERTICAL_PADDING, pill_style_GAP;
function pill_pill_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function pill_pill_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? pill_pill_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : pill_pill_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





var pill_pill_style_defaultContext = makeDefaultStylingContext();
var pill_pill_style_colors = {
  background: makeThemeColor(TERTIARY),
  bar: makeThemeColor(PRIMARY, 0.3),
  text: makeThemeColor(PRIMARY)
};
var player_interface_pill_pill_style_HEIGHT = (interface_pill_pill_style_HEIGHT = {}, (0,defineProperty/* default */.Z)(interface_pill_pill_style_HEIGHT, HD, 48), (0,defineProperty/* default */.Z)(interface_pill_pill_style_HEIGHT, FULL_HD, 56), interface_pill_pill_style_HEIGHT);
var pill_pill_style_ICON_HEIGHT = (pill_style_ICON_HEIGHT = {}, (0,defineProperty/* default */.Z)(pill_style_ICON_HEIGHT, HD, 24), (0,defineProperty/* default */.Z)(pill_style_ICON_HEIGHT, FULL_HD, 32), pill_style_ICON_HEIGHT);
var HORIZONTAL_PADDING = (_HORIZONTAL_PADDING = {}, (0,defineProperty/* default */.Z)(_HORIZONTAL_PADDING, HD, 24), (0,defineProperty/* default */.Z)(_HORIZONTAL_PADDING, FULL_HD, 32), _HORIZONTAL_PADDING);
var pill_pill_style_VERTICAL_PADDING = (pill_style_VERTICAL_PADDING = {}, (0,defineProperty/* default */.Z)(pill_style_VERTICAL_PADDING, HD, 12), (0,defineProperty/* default */.Z)(pill_style_VERTICAL_PADDING, FULL_HD, 12), pill_style_VERTICAL_PADDING);
var pill_pill_style_GAP = (pill_style_GAP = {}, (0,defineProperty/* default */.Z)(pill_style_GAP, HD, 8), (0,defineProperty/* default */.Z)(pill_style_GAP, FULL_HD, 8), pill_style_GAP);
var pill_pill_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : pill_pill_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  var primaryFont = src_getFont(constants_FONT.BERLIN_3, screenSize);
  var secondaryFont = src_getFont(constants_FONT.BERLIN_1, screenSize);
  return {
    h: player_interface_pill_pill_style_HEIGHT[screenSize],
    Background: {
      w: identity,
      h: player_interface_pill_pill_style_HEIGHT[screenSize],
      shader: {
        fillColor: pill_pill_style_colors.background[colorMode],
        progressColor: pill_pill_style_colors.bar[colorMode],
        radius: Math.round(player_interface_pill_pill_style_HEIGHT[screenSize] / 2)
      }
    },
    Icon: {
      iconData: {
        picto: {
          name: 'Play',
          type: 'icon'
        },
        viewBox: {
          h: pill_pill_style_ICON_HEIGHT[screenSize]
        }
      },
      y: Math.round((player_interface_pill_pill_style_HEIGHT[screenSize] - pill_pill_style_ICON_HEIGHT[screenSize]) / 2)
    },
    Primary: {
      color: pill_pill_style_colors.text[colorMode],
      y: Math.round((player_interface_pill_pill_style_HEIGHT[screenSize] - primaryFont.lineHeight) / 2),
      text: pill_pill_style_objectSpread(pill_pill_style_objectSpread({}, primaryFont), {}, {
        verticalAlign: 'middle',
        wordWrap: false
      })
    },
    Secondary: {
      color: pill_pill_style_colors.text[colorMode],
      y: Math.round((player_interface_pill_pill_style_HEIGHT[screenSize] - secondaryFont.lineHeight) / 2),
      text: pill_pill_style_objectSpread(pill_pill_style_objectSpread({}, secondaryFont), {}, {
        verticalAlign: 'middle',
        wordWrap: false
      })
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/player/interface/pill/pill.component.js





function pill_pill_component_createSuper(t) { var r = pill_pill_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function pill_pill_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (pill_pill_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }





var pill_component_Pill = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Pill, _Lightning$Component);
  var _super = pill_pill_component_createSuper(Pill);
  function Pill() {
    (0,classCallCheck/* default */.Z)(this, Pill);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Pill, [{
    key: "_init",
    value: function _init() {
      var _this = this;
      this._style = pill_pill_style_defaultContext;
      this._maxWidth = 0;
      var icon = this.tag('Icon');
      var primary = this.tag('Primary');
      var secondary = this.tag('Secondary');
      var handleUpdate = function handleUpdate() {
        var paddingX = HORIZONTAL_PADDING[_this._style.screenSize];
        var gap = pill_pill_style_GAP[_this._style.screenSize];
        var patch = {
          Background: {},
          Icon: {},
          Primary: {},
          Secondary: {}
        };
        patch.Icon.x = paddingX;
        patch.Primary.x = icon.visible ? Math.round(patch.Icon.x + (icon.finalW ? icon.finalW + gap : 0)) : paddingX;
        patch.Secondary.x = Math.round(patch.Primary.x + (primary.finalW ? primary.finalW + gap : 0));
        patch.w = patch.Secondary.x + secondary.finalW + paddingX;
        _this._maxWidth = Math.max(_this._maxWidth, patch.w);
        var minWidth = Math.max(_this._maxWidth, _this._minWidth || 0);
        if (minWidth && patch.w < minWidth) {
          var offset = Math.round((minWidth - patch.w) / 2);
          patch.Icon.x += offset;
          patch.Primary.x += offset;
          patch.Secondary.x += offset;
          patch.w = minWidth;
        }
        patch.Background.w = patch.w;
        _this.patch(patch);
      };
      icon.on('txLoaded', handleUpdate);
      secondary.on('txLoaded', handleUpdate);
      primary.on('txLoaded', handleUpdate);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this._progress = 0;
      this.tag('Primary').removeAllListeners('txLoaded');
      this.tag('Secondary').removeAllListeners('txLoaded');
      this.tag('Icon').removeAllListeners('txLoaded');
    }
  }, {
    key: "minWidth",
    get: function get() {
      return this._minWidth;
    },
    set: function set(value) {
      this._minWidth = value;
    }
  }, {
    key: "progress",
    get: function get() {
      return this._progress;
    },
    set: function set(value) {
      this._progress = value;
      this.tag('Background').shader.progress = value;
    }
  }, {
    key: "title",
    set: function set(value) {
      this.tag('Primary').text.text = value;
    }
  }, {
    key: "body",
    set: function set(value) {
      this.tag('Secondary').text.text = value;
    }
  }, {
    key: "backgroundColor",
    set: function set(value) {
      this.patch({
        Background: {
          shader: {
            fillColor: value
          }
        }
      });
    }
  }, {
    key: "textColor",
    set: function set(value) {
      this.patch({
        Icon: {
          color: value
        },
        Primary: {
          color: value
        },
        Secondary: {
          color: value
        }
      });
    }
  }, {
    key: "displayIcon",
    get: function get() {
      return this.tag('Icon').visible;
    },
    set: function set(value) {
      this.tag('Icon').visible = value;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Background: {
          rect: true,
          shader: {
            type: PillShader
          },
          flexItem: false
        },
        Icon: {
          type: Icon
        },
        Primary: {
          text: {}
        },
        Secondary: {
          text: {}
        }
      }, pill_pill_style_getInitialStyle());
    }
  }]);
  return Pill;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+html5-engine@3.6.8_@bedrock+media-engine@4.13.0/node_modules/@bedrock/html5-engine/lib/const/HTML5Error.js
var MEDIA_ERR_ABORTED = 1;
var MEDIA_ERR_NETWORK = 2;
var MEDIA_ERR_DECODE = 3;
var MEDIA_ERR_SRC_NOT_SUPPORTED = 4;
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+html5-engine@3.6.8_@bedrock+media-engine@4.13.0/node_modules/@bedrock/html5-engine/lib/engine/HTML5Engine.js

















































function HTML5Engine_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function HTML5Engine_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? HTML5Engine_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : HTML5Engine_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function HTML5Engine_createSuper(t) { var r = HTML5Engine_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function HTML5Engine_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (HTML5Engine_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }




var HTML5Engine_filterNull = filterNull,
  HTML5Engine_getTrackLabel = getTrackLabel,
  HTML5Engine_compareLanguage = compareLanguage;
var HTML5Engine_AUTOPLAY_PREVENTED_ERROR = AUTOPLAY_PREVENTED_ERROR;
var HTML5Engine_DEFAULT_FRAGMENT_DURATION = DEFAULT_FRAGMENT_DURATION;
var HTML5Engine_PROGRESS_THROTTLE = PROGRESS_THROTTLE,
  HTML5Engine_TIME_UPDATE_THROTTLE = TIME_UPDATE_THROTTLE,
  HTML5Engine_SEEKING_THROTTLE = SEEKING_THROTTLE,
  HTML5Engine_VOLUME_CHANGE_THROTTLE = VOLUME_CHANGE_THROTTLE,
  HTML5Engine_PLAYER_THROTTLE_OPTIONS = PLAYER_THROTTLE_OPTIONS,
  HTML5Engine_RETRY_RESET_TIME = RETRY_RESET_TIME;
var mapAudioTrack = function mapAudioTrack(audioTrack, id) {
  var originalLanguage = audioTrack.language || audioTrack.label;
  var language = HTML5Engine_getTrackLabel(audioTrack.language || audioTrack.label);
  var lang = mediaEngineConfig_mediaEngineConfig.get('lang');
  return {
    id: id,
    language: language,
    originalLanguage: originalLanguage,
    main: language === lang,
    roles: [audioTrack.label === 'AD' ? 'alternate' : audioTrack.kind],
    active: audioTrack.enabled
  };
};
var mapTextTrack = function mapTextTrack(track, id) {
  var kind = track.kind,
    language = track.language,
    mode = track.mode;
  return {
    id: id,
    language: language,
    originalLanguage: language,
    roles: HTML5Engine_filterNull(kind === 'captions' ? 'caption' : null, 'subtitle'),
    active: mode === 'showing',
    forced: kind === 'forced'
  };
};
var HTML5Engine_HTML5Engine = function (_Engine) {
  (0,inherits/* default */.Z)(HTML5Engine, _Engine);
  var _super = HTML5Engine_createSuper(HTML5Engine);
  function HTML5Engine() {
    var _this;
    (0,classCallCheck/* default */.Z)(this, HTML5Engine);
    _this = _super.call(this);
    _this.defaultHandler = function (event) {
      event.stopPropagation();
      event.preventDefault();
      _this.options.dispatcher(event.type, event.target);
    };
    _this.onProgress = lodash_default().throttle(_this.defaultHandler, HTML5Engine_PROGRESS_THROTTLE, HTML5Engine_PLAYER_THROTTLE_OPTIONS);
    _this.onSeeking = lodash_default().throttle(_this.defaultHandler, HTML5Engine_SEEKING_THROTTLE, HTML5Engine_PLAYER_THROTTLE_OPTIONS);
    _this.onVolumeChange = lodash_default().throttle(_this.defaultHandler, HTML5Engine_VOLUME_CHANGE_THROTTLE, HTML5Engine_PLAYER_THROTTLE_OPTIONS);
    _this.getPresentationStartTime = function () {
      if (_this.engine && typeof _this.engine.getStartDate === 'function') {
        var date = _this.engine.getStartDate();
        if (isValid(date)) {
          return getUnixTime(date);
        }
      }
      return _this.availabilityStartTime;
    };
    _this.onPlaying = function (event) {
      _this.paused = false;
      _this.options.dispatcher(event.type, event.target);
    };
    _this.onError = function (event) {
      if (_this.source) {
        var errorCode = lodash_default().get(event, 'target.error.code');
        if ([MEDIA_ERR_DECODE, MEDIA_ERR_NETWORK, MEDIA_ERR_SRC_NOT_SUPPORTED].includes(errorCode)) {
          _this.debouncedRetry(event);
          return;
        }
        if (_this.retryOnFallbackSource()) {
          _this.options.dispatcher(FALLBACK_SOURCE, _this.source);
          return;
        }
        _this.options.dispatcher(event.type, event.target);
      }
    };
    _this.manageId3 = function () {
      if (_this.source && _this.source.format) {
        return !!(_this.source.format.includes('hls') && _this.engine && _this.engine.textTracks);
      }
      return false;
    };
    _this.onLoadedMetadata = function (event) {
      if (_this.manageId3()) {
        _this.engine.textTracks.addEventListener('addtrack', _this.onAddTrack);
      }
      _this.options.dispatcher(event.type, event.target);
    };
    _this.onAddTrack = function (event) {
      var track = event.track;
      if (track.kind === 'metadata') {
        track.mode = 'hidden';
        track.addEventListener('cuechange', _this.onCueChange);
        lodash_default().delay(function () {
          if (_this.engine) {
            var textTracks = Object.values(_this.engine.textTracks);
            textTracks.forEach(function (textTrack) {
              if (textTrack.kind === 'metadata') {
                textTrack.mode = 'hidden';
              }
            });
          }
        }, 500);
      }
    };
    _this.onCueChange = function (event) {
      var _this$options = _this.options,
        logger = _this$options.logger,
        dispatcher = _this$options.dispatcher;
      logger.debug('HTML5Engine', 'onCueChange', event);
      var activeTrack = event.target;
      var metadata = {};
      if (!activeTrack || !activeTrack.activeCues || activeTrack.activeCues.length < 1) {
        return;
      }
      var _activeTrack$activeCu = activeTrack.activeCues[0],
        id = _activeTrack$activeCu.id,
        endTime = _activeTrack$activeCu.endTime,
        startTime = _activeTrack$activeCu.startTime;
      var id3Data = Array.from(activeTrack.activeCues).reduce(function (acc, cue) {
        var _cue$value = cue.value,
          key = _cue$value.key,
          info = _cue$value.info,
          data = _cue$value.data;
        if (key === 'PRIV') {
          return HTML5Engine_objectSpread(HTML5Engine_objectSpread({}, acc), {}, (0,defineProperty/* default */.Z)({}, key, {
            value: String.fromCharCode.apply(String, (0,toConsumableArray/* default */.Z)(new Uint8Array(data))),
            owner: info
          }));
        }
        return HTML5Engine_objectSpread(HTML5Engine_objectSpread({}, acc), {}, (0,defineProperty/* default */.Z)({}, key, String.fromCharCode.apply(String, (0,toConsumableArray/* default */.Z)(new Uint8Array(data))).slice(1)));
      }, {});
      if (_this.metadataQueue.includes(id3Data)) {
        return;
      }
      _this.metadataQueue.push(id3Data);
      metadata = {
        id: id,
        endTime: endTime,
        startTime: startTime,
        startStream: 0,
        id3Data: id3Data
      };
      dispatcher(TIMED_METADATA, metadata);
    };
    _this.onCanPlay = function (event) {
      if (_this.firstTime) {
        _this.setStartUpTrack();
        _this.firstTime = false;
      }
      if (_this.source.live && !_this.getPresentationStartTime()) {
        var _this$getSeekWindow = _this.getSeekWindow(),
          end = _this$getSeekWindow.end;
        _this.availabilityStartTime = mediaEngineConfig_mediaEngineConfig.get('getTime')() - end;
      }
      _this.options.dispatcher(event.type, event.target);
    };
    _this.onTimeUpdate = lodash_default().throttle(function (event) {
      var _this$options$streami = _this.options.streaming,
        _this$options$streami2 = _this$options$streami === void 0 ? {} : _this$options$streami,
        needPauseFallback = _this$options$streami2.needPauseFallback;
      if (_this.retries > 0) {
        _this.timeSinceReset += HTML5Engine_TIME_UPDATE_THROTTLE;
        if (_this.timeSinceReset > HTML5Engine_RETRY_RESET_TIME) {
          _this.options.dispatcher(RETRY_SUCCESS, event.target);
          _this.retries = 0;
          _this.timeSinceReset = 0;
        }
      }
      if (needPauseFallback) {
        clearTimeout(_this.needPauseFallbackTimeout);
      }
      if (_this.engine) {
        _this.options.dispatcher(event.type, {
          currentTime: _this.getCurrentTime(),
          playhead: _this.engine.currentTime
        });
        if (needPauseFallback) {
          _this.paused = false;
          _this.needPauseFallbackTimeout = setTimeout(function () {
            if (!_this.paused) {
              _this.onPause(new Event('pause'));
            }
          }, 1000);
        }
        _this.dispatchMetrics();
      }
    }, HTML5Engine_TIME_UPDATE_THROTTLE, HTML5Engine_PLAYER_THROTTLE_OPTIONS);
    _this.onPlay = function (event) {
      var _this$options$streami3 = _this.options.streaming,
        _this$options$streami4 = _this$options$streami3 === void 0 ? {} : _this$options$streami3,
        needPauseFallback = _this$options$streami4.needPauseFallback;
      if (needPauseFallback) {
        clearTimeout(_this.needPauseFallbackTimeout);
      }
      _this.paused = false;
      _this.options.dispatcher(event.type, _this.engine);
    };
    _this.onPause = function (event) {
      var _this$options$streami5 = _this.options.streaming,
        _this$options$streami6 = _this$options$streami5 === void 0 ? {} : _this$options$streami5,
        needPauseFallback = _this$options$streami6.needPauseFallback;
      if (needPauseFallback) {
        clearTimeout(_this.needPauseFallbackTimeout);
      }
      _this.paused = true;
      _this.options.dispatcher(event.type, _this.engine);
    };
    _this.onSeeked = function (event) {
      _this.options.dispatcher(event.type, _this.getCurrentTime());
    };
    _this.onTextTracksChange = lodash_default().throttle(function (_ref) {
      var target = _ref.target;
      _this.options.dispatcher(CAN_PLAY, target);
    }, 500, HTML5Engine_PLAYER_THROTTLE_OPTIONS);
    _this.name = 'HTML5Engine';
    _this.metadataQueue = [];
    _this.timeSinceReset = 0;
    return _this;
  }
  (0,createClass/* default */.Z)(HTML5Engine, [{
    key: "getMetrics",
    value: function getMetrics() {
      var _this$source;
      var _this$engine = this.engine,
        videoHeight = _this$engine.videoHeight,
        videoWidth = _this$engine.videoWidth;
      var _this$getCurrentBuffe = this.getCurrentBufferSlice(),
        bufferLength = _this$getCurrentBuffe.bufferLength,
        bufferEnd = _this$getCurrentBuffe.bufferEnd,
        bufferStart = _this$getCurrentBuffe.bufferStart;
      var time = mediaEngineConfig_mediaEngineConfig.get('getTime')();
      return {
        bufferLength: bufferLength,
        bufferEnd: bufferEnd,
        bufferStart: bufferStart,
        latency: (_this$source = this.source) !== null && _this$source !== void 0 && _this$source.live ? time - this.getCurrentTime() : null,
        time: time,
        bufferLevel: null,
        droppedFrames: null,
        bitrate: null,
        networkBandwith: null,
        drmInfo: this.getDrmInfo(),
        videoHeight: videoHeight,
        videoWidth: videoWidth
      };
    }
  }, {
    key: "init",
    value: function init(engineTag) {
      this.engine = engineTag;
      this.startTime = 0;
      this.debouncedRetry = lodash_default().debounce(this.retry, this.options.streaming.retry.delay);
      if (window && mediaEngineConfig_mediaEngineConfig.get('isMocked')) {
        lodash_default().set(window, 'currentEngine', this);
        lodash_default().set(window, 'currentEnginePlayer', engineTag);
      }
    }
  }, {
    key: "setVolume",
    value: function setVolume(volume) {
      this.engine.volume = volume;
    }
  }, {
    key: "setSpeed",
    value: function setSpeed(speed) {
      this.engine.playbackRate = speed;
    }
  }, {
    key: "isMuted",
    value: function isMuted() {
      return this.engine.hasAttribute('muted');
    }
  }, {
    key: "setMuted",
    value: function setMuted(muted) {
      this.engine.muted = muted;
      if (muted) {
        this.engine.setAttribute('muted', '');
      } else {
        this.engine.removeAttribute('muted');
      }
    }
  }, {
    key: "setSource",
    value: function () {
      var _setSource = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(source) {
        var src;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.source = source;
              this.firstTime = true;
              src = this.source.src;
              if (this.startTime) {
                src = "".concat(this.source.src, "#t=").concat(this.startTime);
              }
              this.engine.src = src;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function setSource(_x) {
        return _setSource.apply(this, arguments);
      }
      return setSource;
    }()
  }, {
    key: "getVolume",
    value: function getVolume() {
      return this.engine.volume;
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.engine.duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      var _ref2 = this.source || {},
        live = _ref2.live;
      if (live) {
        return this.getPresentationStartTime() + this.engine.currentTime;
      }
      return this.engine.currentTime;
    }
  }, {
    key: "getBufferProgress",
    value: function getBufferProgress() {
      var buffered = this.engine.buffered;
      if (buffered.length !== 0) {
        return buffered.end(buffered.length - 1);
      }
      return 0;
    }
  }, {
    key: "getCurrentBufferSlice",
    value: function getCurrentBufferSlice() {
      return engine_utils_getCurrentBufferSlice(this.engine);
    }
  }, {
    key: "getBufferStart",
    value: function getBufferStart() {
      var _this$getCurrentBuffe2 = this.getCurrentBufferSlice(),
        bufferStart = _this$getCurrentBuffe2.bufferStart;
      return bufferStart;
    }
  }, {
    key: "getAttainableLiveLatency",
    value: function getAttainableLiveLatency() {
      return HTML5Engine_DEFAULT_FRAGMENT_DURATION;
    }
  }, {
    key: "getSeekWindow",
    value: function getSeekWindow() {
      return {
        start: this.engine.seekable.start(0),
        end: this.engine.seekable.end(0)
      };
    }
  }, {
    key: "seek",
    value: function seek(position) {
      var _this$getSeekWindow2 = this.getSeekWindow(),
        start = _this$getSeekWindow2.start,
        end = _this$getSeekWindow2.end;
      if (this.source.live) {
        var logger = this.options.logger;
        var seekPosition = position - this.getPresentationStartTime();
        logger.debug('HTML5Engine', 'seek', {
          start: start,
          end: end,
          depth: end - start,
          pointZero: this.getPresentationStartTime(),
          currentTime: this.engine.currentTime,
          position: position,
          seekPosition: seekPosition,
          newCurrentTime: Math.max(start, Math.min(seekPosition, end))
        });
        this.engine.currentTime = Math.max(start, Math.min(seekPosition, end));
      } else {
        this.engine.currentTime = Math.max(start, Math.min(position, end - 0.5));
      }
    }
  }, {
    key: "goToLive",
    value: function goToLive() {
      if (this.source.live) {
        this.engine.currentTime = this.getSeekWindow().end;
      }
    }
  }, {
    key: "play",
    value: function () {
      var _play = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2() {
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return this.engine.play();
            case 3:
              _context2.next = 8;
              break;
            case 5:
              _context2.prev = 5;
              _context2.t0 = _context2["catch"](0);
              if (_context2.t0 && _context2.t0.name === 'NotAllowedError') {
                this.options.dispatcher(ERROR, new PlayerError(HTML5Engine_AUTOPLAY_PREVENTED_ERROR, _context2.t0.message, false, this.name));
              }
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 5]]);
      }));
      function play() {
        return _play.apply(this, arguments);
      }
      return play;
    }()
  }, {
    key: "pause",
    value: function pause() {
      this.engine.pause();
    }
  }, {
    key: "isPaused",
    value: function isPaused() {
      return this.paused;
    }
  }, {
    key: "restart",
    value: function restart() {
      this.seek(0);
      this.play();
    }
  }, {
    key: "setEventListeners",
    value: function setEventListeners() {
      var _this2 = this;
      this.removeEventListeners();
      lodash_default().forOwn(video_events_namespaceObject, function (event, key) {
        if (key.indexOf('RETRY') === -1) {
          _this2.engine.addEventListener(event, _this2.getEventHandler(key));
        }
      });
      if (this.engine && this.engine.textTracks) {
        this.engine.textTracks.addEventListener('change', this.onTextTracksChange);
      }
    }
  }, {
    key: "setVideoQuality",
    value: function setVideoQuality() {}
  }, {
    key: "getEventHandler",
    value: function getEventHandler(event) {
      var handler = this.defaultHandler;
      var handlerName = "on".concat(lodash_default().upperFirst(lodash_default().camelCase(event)));
      if (typeof this[handlerName] === 'function') {
        handler = this[handlerName];
      }
      return handler;
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      var _this3 = this;
      lodash_default().forOwn(video_events_namespaceObject, function (event, key) {
        if (key.indexOf('RETRY') === -1) {
          _this3.engine.removeEventListener(event, _this3.getEventHandler(key));
        }
      });
      if (this.engine && this.engine.textTracks) {
        this.engine.textTracks.removeEventListener('change', this.onTextTracksChange);
      }
      if (this.manageId3()) {
        this.engine.textTracks.removeEventListener('addtrack', this.onAddTrack);
      }
    }
  }, {
    key: "getActiveSubtitleTrack",
    value: function getActiveSubtitleTrack() {
      if (!this.engine.textTracks || !this.engine.textTracks.length) {
        return null;
      }
      var textTracks = Array.from(this.engine.textTracks);
      var track = textTracks.find(function (_ref3) {
        var mode = _ref3.mode;
        return mode === 'showing';
      });
      if (!track) {
        return null;
      }
      return mapTextTrack(track, textTracks.indexOf(track));
    }
  }, {
    key: "getSubtitleTracks",
    value: function getSubtitleTracks() {
      if (!this.engine) {
        return [];
      }
      return Array.from(this.engine.textTracks).map(mapTextTrack);
    }
  }, {
    key: "setSubtitleTrack",
    value: function setSubtitleTrack(_ref4) {
      var id = _ref4.id;
      if (!this.engine) {
        return;
      }
      var textTracks = Array.from(this.engine.textTracks);
      textTracks.forEach(function (textTrack, index) {
        var disabledRole = textTrack.kind === 'forced' ? 'disabled' : 'hidden';
        textTrack.mode = index === id ? 'showing' : disabledRole;
      });
      this.onTracksChanged('textTrack');
    }
  }, {
    key: "setForcedTextTrack",
    value: function setForcedTextTrack() {
      if (!this.engine) {
        return;
      }
      var activeAudioTrack = this.getActiveAudioTrack();
      var activeTextTrack = this.getActiveSubtitleTrack();
      var textTracks = this.getSubtitleTracks();
      if (activeTextTrack && !activeTextTrack.forced || !activeAudioTrack) {
        return;
      }
      var forcedTextTrack = textTracks.find(function (_ref5) {
        var forced = _ref5.forced,
          language = _ref5.language;
        return forced && HTML5Engine_compareLanguage(language, activeAudioTrack.originalLanguage);
      });
      if (forcedTextTrack) {
        this.setSubtitleTrack(forcedTextTrack);
      } else {
        this.removeSubtitleTrack();
      }
    }
  }, {
    key: "removeSubtitleTrack",
    value: function removeSubtitleTrack() {
      if (!this.engine) {
        return;
      }
      Array.from(this.engine.textTracks).forEach(function (textTrack) {
        textTrack.mode = 'hidden';
      });
      this.onTracksChanged('textTrack');
    }
  }, {
    key: "getActiveAudioTrack",
    value: function getActiveAudioTrack() {
      if (!this.engine.audioTracks || !this.engine.audioTracks.length) {
        return null;
      }
      var audioTracks = Array.from(this.engine.audioTracks);
      var track = audioTracks.find(function (audioTrack) {
        return audioTrack.enabled;
      });
      if (!track) {
        return null;
      }
      return mapAudioTrack(track, audioTracks.indexOf(track));
    }
  }, {
    key: "getAudioTracks",
    value: function getAudioTracks() {
      if (!this.engine.audioTracks || !this.engine.audioTracks.length) {
        return [];
      }
      return Array.from(this.engine.audioTracks).map(mapAudioTrack);
    }
  }, {
    key: "setAudioTrack",
    value: function setAudioTrack(track) {
      if (!this.engine.audioTracks || !this.engine.audioTracks.length) {
        return;
      }
      Array.from(this.engine.audioTracks).forEach(function (audioTrack, id) {
        audioTrack.enabled = track.id === id;
      });
      clearTimeout(this.needPauseFallbackTimeout);
    }
  }, {
    key: "getInstance",
    value: function getInstance() {
      return this.engine;
    }
  }, {
    key: "release",
    value: function () {
      var _release = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee3() {
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.engine.pause();
              this.engine.removeAttribute('src');
              if (this.engine.load) {
                this.engine.load();
              }
              this.cancelThrottled();
              this.removeEventListeners();
              this.metadataQueue = [];
              this.engine = null;
              clearTimeout(this.needPauseFallbackTimeout);
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function release() {
        return _release.apply(this, arguments);
      }
      return release;
    }()
  }, {
    key: "cancelThrottled",
    value: function cancelThrottled() {
      this.onProgress.cancel();
      this.onSeeking.cancel();
      this.onVolumeChange.cancel();
      this.onTimeUpdate.cancel();
      this.onTextTracksChange.cancel();
      this.dispatchMetrics.cancel();
    }
  }, {
    key: "reset",
    value: function () {
      var _reset = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee4() {
        return regenerator_default().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.cancelThrottled();
              if (this.engine) {
                this.engine.removeAttribute('src');
                if (this.engine.load) {
                  this.engine.load();
                }
              }
              this.source = null;
              this.availabilityStartTime = null;
              this.metadataQueue = [];
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function reset() {
        return _reset.apply(this, arguments);
      }
      return reset;
    }()
  }, {
    key: "getDrmInfo",
    value: function getDrmInfo() {
      return {};
    }
  }, {
    key: "setStartUpTrack",
    value: function setStartUpTrack() {
      var _this4 = this;
      var defaultAudioTrack = this.getDefaultTrack(this.getAudioTracks(), lodash_default().get(this.options, 'streaming.preferredTrack.audio'));
      if (defaultAudioTrack) {
        this.setAudioTrack(defaultAudioTrack);
      }
      setTimeout(function () {
        if (!_this4.engine) {
          return;
        }
        var defaultSubtitleTrack = _this4.getDefaultTrack(_this4.getSubtitleTracks(), lodash_default().get(_this4.options, 'streaming.preferredTrack.subtitle'));
        if (defaultSubtitleTrack) {
          _this4.setSubtitleTrack(defaultSubtitleTrack);
        } else {
          _this4.setForcedTextTrack();
        }
      }, 1000);
    }
  }, {
    key: "getDefaultTrack",
    value: function getDefaultTrack(tracks, preferredTrack) {
      if (!preferredTrack || !tracks.length) {
        return null;
      }
      var languageFilteredTracks = tracks.filter(function (_ref6) {
        var originalLanguage = _ref6.originalLanguage,
          forced = _ref6.forced;
        return !forced && HTML5Engine_compareLanguage(originalLanguage, preferredTrack.originalLanguage);
      });
      return (languageFilteredTracks.find(function (_ref7) {
          var roles = _ref7.roles;
          return lodash_default().isEqual(roles, preferredTrack.roles);
        }) || languageFilteredTracks[0]
      );
    }
  }]);
  return HTML5Engine;
}(Engine);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+html5-engine@3.6.8_@bedrock+media-engine@4.13.0/node_modules/@bedrock/html5-engine/lib/index.js



;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+ad-engine@5.29.4_@bedrock+html5-engine@3.6.8_@bedrock+media-engine@4.13.0__@bedrock+media-engine@4.13.0/node_modules/@bedrock/ad-engine/lib/utils/logger.utils.js


var executeLog = function executeLog() {
  var logLevel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'info';
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Unknown target';
  var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Unknown method';
  if (!mediaEngineConfig_mediaEngineConfig.get('isDebug')) {
    return;
  }
  var fallback = 'log';
  var c = (console[logLevel] && typeof console[logLevel] === 'function' ? console[logLevel] : console[fallback]).bind(console);
  for (var _len = arguments.length, messages = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    messages[_key - 3] = arguments[_key];
  }
  c.apply(void 0, ["[adEngine][".concat(new Date().toLocaleTimeString(), "][").concat(target, "][").concat(method, "] -")].concat(messages));
};
/* harmony default export */ const logger_utils = ({
  info: function info() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return executeLog.apply(void 0, ['info'].concat(args));
  },
  error: function error() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    return executeLog.apply(void 0, ['error'].concat(args));
  },
  debug: function debug() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }
    return executeLog.apply(void 0, ['debug'].concat(args));
  },
  warn: function warn() {
    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }
    return executeLog.apply(void 0, ['warn'].concat(args));
  }
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+ad-engine@5.29.4_@bedrock+html5-engine@3.6.8_@bedrock+media-engine@4.13.0__@bedrock+media-engine@4.13.0/node_modules/@bedrock/ad-engine/lib/bridges/capping.utils.js



var Capping = function () {
  function Capping(config, _ref) {
    var storage = _ref.storage;
    (0,classCallCheck/* default */.Z)(this, Capping);
    this.config = config;
    this.storage = storage;
  }
  (0,createClass/* default */.Z)(Capping, [{
    key: "saveLastBreak",
    value: function saveLastBreak() {
      var type = this.config.type;
      var lastBreakTimestamp = this.getBreakTimestamps();
      lastBreakTimestamp[type] = Date.now();
      this.storage.setItem('lastBreakTimestamp', JSON.stringify(lastBreakTimestamp));
    }
  }, {
    key: "retrieveLastBreakTimestamp",
    value: function retrieveLastBreakTimestamp(type) {
      return this.getBreakTimestamps()[type];
    }
  }, {
    key: "getBreakTimestamps",
    value: function getBreakTimestamps() {
      try {
        return JSON.parse(this.storage.getItem('lastBreakTimestamp')) || {};
      } catch (exception) {
        logger_utils.error('Capping', 'saveLastBreak', exception);
      }
      return {};
    }
  }, {
    key: "canBreak",
    value: function canBreak() {
      var aheadOf = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var _this$config = this.config,
        type = _this$config.type,
        duration = _this$config.duration;
      var lastBreakTimestamp = this.retrieveLastBreakTimestamp(type);
      var breakTime = Date.now() + aheadOf * 1000;
      if (lastBreakTimestamp && lastBreakTimestamp < breakTime) {
        var cappingLimit = lastBreakTimestamp / 1000 + duration;
        if (breakTime / 1000 < cappingLimit) {
          logger_utils.debug('Capping', 'canBreak', 'Minimum time between breaks not elapsed');
          return false;
        }
      }
      return true;
    }
  }]);
  return Capping;
}();
/* harmony default export */ const capping_utils = (Capping);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+ad-engine@5.29.4_@bedrock+html5-engine@3.6.8_@bedrock+media-engine@4.13.0__@bedrock+media-engine@4.13.0/node_modules/@bedrock/ad-engine/lib/bridges/net.util.js












var DEFAULT_MAX_BIT_RATE = 635;
var bandwidthTestImages = ['https://static.6cloud.fr/m6group_web/player/bw.jpg'];
var requestWithoutCache = function requestWithoutCache(url) {
  return superagent_lib_client_default().get("".concat(url, "?t=").concat(Date.now())).set({
    'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=-1,private',
    Expires: '-1'
  }).responseType('blob').timeout(1000);
};
function estimateBandwidthFor(url) {
  var startTime = Date.now();
  return requestWithoutCache(url).then(function (response) {
    var delta = (Date.now() - startTime) / 1000;
    return Math.max(Math.floor(8 * response.body.size / 1000 / delta), DEFAULT_MAX_BIT_RATE);
  }).catch(function () {
    return null;
  });
}
var flattenBandwidths = function flattenBandwidths(bandwidths) {
  var successfulBandwidths = bandwidths.filter(function (bandwidth) {
    return !!bandwidth;
  });
  if (successfulBandwidths.length) {
    return successfulBandwidths.reduce(function (accumulator, value) {
      return accumulator + value;
    }, 0) / successfulBandwidths.length;
  }
  return DEFAULT_MAX_BIT_RATE;
};
var calculateBandwidth = function calculateBandwidth() {
  var downlink = lodash_default().get(navigator, 'connection.downlink');
  if (downlink) {
    var calculatedBandwidth = Math.max(downlink * 1000, DEFAULT_MAX_BIT_RATE);
    logger_utils.debug('Bandwidth', 'calculateBandwidth', "Browser returned a calculated bandwidth of ".concat(calculatedBandwidth, "Kbps"));
    return Promise.resolve(calculatedBandwidth);
  }
  return Promise.all(bandwidthTestImages.map(function (url) {
    return estimateBandwidthFor(url);
  })).then(function (bandwidths) {
    var bandwidth = flattenBandwidths(bandwidths);
    logger_utils.debug('Bandwidth', 'calculateBandwidth', "Calculated a ".concat(bandwidth, "Kbps bandwidth"));
    return bandwidth;
  }).catch(function () {
    return DEFAULT_MAX_BIT_RATE;
  });
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+ad-engine@5.29.4_@bedrock+html5-engine@3.6.8_@bedrock+media-engine@4.13.0__@bedrock+media-engine@4.13.0/node_modules/@bedrock/ad-engine/lib/bridges/ad.bridge.js







function ad_bridge_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ad_bridge_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ad_bridge_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ad_bridge_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



var defaultConfig = {
  capping: {
    type: 'default',
    duration: 0
  },
  minOverlayWidth: 1360,
  hostTargetingSeparator: '?',
  targetingKeysSeparator: '&',
  desiredBitrate: 0
};
var AdBridge = function () {
  function AdBridge(config, eventsHandlers, contentHandlers) {
    var _this = this;
    var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      storage = _ref.storage;
    (0,classCallCheck/* default */.Z)(this, AdBridge);
    this.setAutoPlay = function (autoPlay) {
      _this.shouldAutoPlay = autoPlay;
    };
    this.onTimeUpdate = function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        target = _ref2.target;
      if (target.playbackRate > 1) {
        target.playbackRate = 1;
      }
    };
    if (!storage.setItem || !storage.getItem) {
      throw new Error('Storage must implement setItem and getItem methods.');
    }
    this.storage = storage;
    this.released = false;
    this.config = lodash_default().merge({}, defaultConfig, config);
    this.eventsHandlers = ad_bridge_objectSpread({}, eventsHandlers);
    this.contentHandlers = ad_bridge_objectSpread({}, contentHandlers);
    this.handleInteraction = this.handleInteraction.bind(this);
    this.eventsHandlers.__onBreakEnded = this.eventsHandlers.onBreakEnded;
    this.eventsHandlers.onBreakEnded = function () {
      var _this$eventsHandlers;
      _this.jingles.breakDisplayed = false;
      _this.jingles.sponsorDisplayed = false;
      (_this$eventsHandlers = _this.eventsHandlers).__onBreakEnded.apply(_this$eventsHandlers, arguments);
    };
    this.cuePoints = [];
  }
  (0,createClass/* default */.Z)(AdBridge, [{
    key: "canBreak",
    value: function canBreak() {
      var aheadOf = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (!this.capping.canBreak(aheadOf)) {
        this.eventsHandlers.onBreakCapping();
        return false;
      }
      return true;
    }
  }, {
    key: "triggerSlotOnSeek",
    value: function triggerSlotOnSeek() {}
  }, {
    key: "setContainerRef",
    value: function setContainerRef(containerRef) {
      this.containerRef = containerRef;
    }
  }, {
    key: "setLBannerContainerRef",
    value: function setLBannerContainerRef(lBannerContainerRef) {
      this.lBannerContainerRef = lBannerContainerRef;
    }
  }, {
    key: "setVideoRef",
    value: function setVideoRef(videoRef) {
      this.videoRef = videoRef;
      this.videoEl = videoRef;
      if (this.videoRef && lodash_default().get(this.config, 'options.optiExpo.enabled', false)) {
        this.videoRef.addEventListener('timeupdate', this.onTimeUpdate);
      }
    }
  }, {
    key: "setCompanionRef",
    value: function setCompanionRef(companionRef) {
      this.companionRef = companionRef;
    }
  }, {
    key: "setEventSender",
    value: function setEventSender(sendEvent) {
      this.sendEvent = sendEvent;
    }
  }, {
    key: "__onAdClick",
    value: function __onAdClick(url, callback) {
      var pauseAd = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      if (/^https?:\/\//.test(url)) {
        window.open(url, '_blank');
        if (typeof callback === 'function') {
          callback();
        }
        if (pauseAd) {
          this.pause();
        }
        this.eventsHandlers.onClicked(url);
        return true;
      }
      return false;
    }
  }, {
    key: "handleInteraction",
    value: function handleInteraction() {}
  }, {
    key: "updateCuePoints",
    value: function updateCuePoints(newCuePoints) {
      var _this$eventsHandlers2;
      this.cuePoints = newCuePoints;
      if ((_this$eventsHandlers2 = this.eventsHandlers) !== null && _this$eventsHandlers2 !== void 0 && _this$eventsHandlers2.onAdBreakListUpdate) {
        this.eventsHandlers.onAdBreakListUpdate(newCuePoints);
      }
    }
  }, {
    key: "init",
    value: function () {
      var _init = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee() {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.eventsHandlers.onProviderLoading();
              this.jingles = {
                breakDisplayed: false,
                sponsorDisplayed: false
              };
              this.capping = new capping_utils(this.config.capping, {
                storage: this.storage
              });
              this.updateCuePoints((this.config.breaks || []).map(function (_ref3) {
                var cuePoint = _ref3.cuePoint;
                return cuePoint;
              }));
              this.released = false;
              if (this.config.desiredBitrate) {
                _context.next = 9;
                break;
              }
              _context.next = 8;
              return calculateBandwidth();
            case 8:
              this.config.desiredBitrate = _context.sent;
            case 9:
              this.desiredBitrate = this.config.desiredBitrate;
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "getEstimatedDesiredBitrate",
    value: function getEstimatedDesiredBitrate() {
      return this.config.desiredBitrate;
    }
  }, {
    key: "reload",
    value: function reload() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.config;
      this.config = lodash_default().merge({}, defaultConfig, config);
    }
  }, {
    key: "release",
    value: function release() {
      this.released = true;
      if (this.videoRef) {
        this.videoRef.removeEventListener('timeupdate', this.onTimeUpdate);
      }
    }
  }, {
    key: "contentHasEnded",
    value: function contentHasEnded() {}
  }, {
    key: "contentHasPaused",
    value: function contentHasPaused() {}
  }, {
    key: "contentHasStarted",
    value: function contentHasStarted() {}
  }, {
    key: "contentHasProgressed",
    value: function contentHasProgressed() {}
  }, {
    key: "requestAds",
    value: function requestAds() {}
  }, {
    key: "setVolume",
    value: function setVolume(volume) {
      this.config.volume = volume;
    }
  }, {
    key: "isEnded",
    value: function isEnded() {}
  }, {
    key: "isPaused",
    value: function isPaused() {}
  }, {
    key: "pause",
    value: function pause() {}
  }, {
    key: "play",
    value: function play() {}
  }, {
    key: "stop",
    value: function stop() {}
  }, {
    key: "skipAd",
    value: function skipAd() {}
  }, {
    key: "skipBreak",
    value: function skipBreak() {}
  }, {
    key: "resize",
    value: function resize() {}
  }, {
    key: "addProvider",
    value: function addProvider() {}
  }]);
  return AdBridge;
}();
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock-player+types@0.17.0/node_modules/@bedrock-player/types/lib/types/Advertising/Parser.js
var AD_FORMAT;
(function (AD_FORMAT) {
  AD_FORMAT["VAST"] = "vast";
  AD_FORMAT["VMAP"] = "vmap:vmap";
  AD_FORMAT["UNKNOWN"] = "unknown";
})(AD_FORMAT || (AD_FORMAT = {}));
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock-player+types@0.17.0/node_modules/@bedrock-player/types/lib/types/Advertising/Slot.js
var SlotType;
(function (SlotType) {
  SlotType["PREROLL"] = "preroll";
  SlotType["MIDROLL"] = "midroll";
  SlotType["POSTROLL"] = "postroll";
  SlotType["DISPLAY"] = "display";
  SlotType["OVERLAY"] = "overlay";
  SlotType["SPONSOR"] = "sponsor";
  SlotType["LBANNER"] = "lbanner";
  SlotType["UNKNOWN"] = "unknown";
})(SlotType || (SlotType = {}));
var EMPTY_SLOT = {
  cuePoint: null,
  ads: [],
  buffet: [],
  id: undefined,
  type: SlotType.UNKNOWN,
  loaded: false,
  loading: false,
  pending: false,
  tracking: {
    error: []
  }
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock-player+types@0.17.0/node_modules/@bedrock-player/types/lib/types/Advertising/Tracking.js
var TrackingEvent;
(function (TrackingEvent) {
  TrackingEvent["Error"] = "error";
  TrackingEvent["BreakStart"] = "breakStart";
  TrackingEvent["BreakEnd"] = "breakEnd";
  TrackingEvent["Start"] = "start";
  TrackingEvent["Click"] = "click";
  TrackingEvent["ImpressionEnd"] = "impressionEnd";
  TrackingEvent["Impression"] = "impression";
  TrackingEvent["Complete"] = "complete";
  TrackingEvent["FirstQuartile"] = "firstQuartile";
  TrackingEvent["Midpoint"] = "midpoint";
  TrackingEvent["ThirdQuartile"] = "thirdQuartile";
  TrackingEvent["Mute"] = "mute";
  TrackingEvent["Unmute"] = "unmute";
  TrackingEvent["Fullscreen"] = "fullscreen";
  TrackingEvent["Skip"] = "skip";
  TrackingEvent["EngagedView"] = "engagedView";
  TrackingEvent["Collapse"] = "collapse";
  TrackingEvent["Expand"] = "expand";
  TrackingEvent["Pause"] = "pause";
  TrackingEvent["Resume"] = "resume";
  TrackingEvent["Rewind"] = "rewind";
  TrackingEvent["AcceptInvitation"] = "acceptInvitation";
  TrackingEvent["Close"] = "close";
  TrackingEvent["CloseLinear"] = "closeLinear";
  TrackingEvent["CreativeView"] = "creativeView";
  TrackingEvent["VerificationNotExecuted"] = "verificationNotExecuted";
})(TrackingEvent || (TrackingEvent = {}));
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock-player+types@0.17.0/node_modules/@bedrock-player/types/lib/types/Advertising/index.js



;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock-player+types@0.17.0/node_modules/@bedrock-player/types/lib/index.js


// EXTERNAL MODULE: ./node_modules/.pnpm/core-js@3.32.1/node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__(91057);
// EXTERNAL MODULE: ./node_modules/.pnpm/sax@1.2.4/node_modules/sax/lib/sax.js
var sax = __webpack_require__(69499);
var sax_default = /*#__PURE__*/__webpack_require__.n(sax);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+ad-engine@5.29.4_@bedrock+html5-engine@3.6.8_@bedrock+media-engine@4.13.0__@bedrock+media-engine@4.13.0/node_modules/@bedrock/ad-engine/lib/utils/parser/utils.js
















function parser_utils_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function parser_utils_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? parser_utils_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : parser_utils_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



var timeOffsetRegex = /^(\d{1,2}):(\d{1,2}):((\d{1,2})(\.\d{1,3})?)$/;
var convertTimeToSeconds = function convertTimeToSeconds(time) {
  try {
    var matches = time.match(timeOffsetRegex);
    if (matches) {
      var _matches = (0,slicedToArray/* default */.Z)(matches, 4),
        hours = _matches[1],
        minutes = _matches[2],
        seconds = _matches[3];
      return Number(hours) * 3600 + Number(minutes) * 60 + Number(seconds);
    }
    return 0;
  } catch (_unused) {
    return 0;
  }
};
var textToHtmlElement = function textToHtmlElement(text) {
  return new Promise(function (resolve) {
    var parser = sax_default().parser(false);
    var root = document.createElement('xml');
    var tree = [root];
    parser.looseCase = 'substr';
    parser.onerror = function () {
      parser.error = null;
      parser.resume();
    };
    parser.oncdata = function (cdata) {
      tree[tree.length - 1].textContent = cdata;
    };
    parser.ontext = function (nodeText) {
      var escapedText = nodeText && nodeText.trim().replace(/(\n|\t)/g, '');
      if (escapedText.length > 0) {
        tree[tree.length - 1].textContent = escapedText;
      }
    };
    parser.onopentag = function (node) {
      var parentElement = tree[tree.length - 1];
      var element = document.createElement(node.name);
      lodash_default().forOwn(node.attributes, function (value, key) {
        return element.setAttribute(key, value);
      });
      parentElement.appendChild(element);
      tree.push(element);
    };
    parser.onclosetag = function () {
      tree.pop();
    };
    parser.onend = function () {
      resolve(root);
    };
    parser.write(text.replace(/(&amp;|&)<\//g, '</')).close();
  });
};
var timeValueToSeconds = function timeValueToSeconds(timeValue, contentDuration, logger) {
  if (timeValue === 'start') {
    return 0;
  }
  if (timeOffsetRegex.test(timeValue)) {
    return Math.round(convertTimeToSeconds(timeValue));
  }
  if (/^[0-9]+%$/.test(timeValue)) {
    var percentage = parseInt(timeValue.substring(0, timeValue.length - 1), 10);
    if (lodash_default().isNaN(percentage) || percentage < 0 || percentage > 100) {
      logger.warn('parser.util', 'parseVMAP', 'cuePoint could not be determined in seconds');
      return null;
    }
    return Math.round(percentage / 100 * contentDuration);
  }
  Parser.logger.warn('parser.util', 'parseVMAP', 'cuePoint could not be determined in seconds');
  return null;
};
var mergeArrayWithoutDuplicates = function mergeArrayWithoutDuplicates(target, source) {
  if (lodash_default().isArray(target)) {
    return lodash_default().concat(target, source);
  }
  return undefined;
};
var uniqueAndValid = function uniqueAndValid(value, index, self) {
  return !!value && self.indexOf(value) === index;
};
var mergeTracking = function mergeTracking() {
  for (var _len = arguments.length, trackings = new Array(_len), _key = 0; _key < _len; _key++) {
    trackings[_key] = arguments[_key];
  }
  var distinctKeys = trackings.flatMap(function (tracking) {
    return Object.keys(tracking);
  }).filter(uniqueAndValid);
  return distinctKeys.reduce(function (acc, key) {
    return parser_utils_objectSpread(parser_utils_objectSpread({}, acc), {}, (0,defineProperty/* default */.Z)({}, key, trackings.flatMap(function (tracking) {
      return tracking[key];
    }).filter(uniqueAndValid)));
  }, {});
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+ad-engine@5.29.4_@bedrock+html5-engine@3.6.8_@bedrock+media-engine@4.13.0__@bedrock+media-engine@4.13.0/node_modules/@bedrock/ad-engine/lib/bridges/constants.js
var DEFAULT_CREATIVE_DURATION = 20;
var MAX_VAST_RECURSIVITY = 100;
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+ad-engine@5.29.4_@bedrock+html5-engine@3.6.8_@bedrock+media-engine@4.13.0__@bedrock+media-engine@4.13.0/node_modules/@bedrock/ad-engine/lib/bridges/ad.errors.js
var ad_errors_AD_UNKNOWN_ERROR = 'AD_UNKNOWN_ERROR';
var ad_errors_AD_REQUEST_FAILED = 'AD_REQUEST_FAILED';
var ad_errors_AD_TIMED_OUT = 'AD_TIMED_OUT';
var ad_errors_AD_NO_SUPPORTED_MEDIA_FILE = 'AD_NO_SUPPORTED_MEDIA_FILE';
var ad_errors_AD_COULD_NOT_PLAY = 'AD_COULD_NOT_PLAY';
var ad_errors_AD_NO_AD_RESPONSE = 'AD_NO_AD_RESPONSE';
var vastErrorMessage = {
  100: 'VAST_XML_PARSING_ERROR',
  101: 'VAST_SCHEMA_VALIDATION_ERROR',
  102: 'VAST_VERSION_NOT_SUPPORTED',
  200: 'VAST_TRAFFICKING_ERROR',
  201: 'LINEARITY_MISMATCH',
  202: 'DURATION_MISMATCH',
  203: 'SIZE_MISMATCH',
  206: 'BREAK_SHORTENED',
  300: 'VAST_GENERAL_WRAPPER_ERROR',
  301: 'VAST_URI_TIMEOUT',
  302: 'VAST_WRAPPER_LIMIT_REACHED',
  303: 'VAST_NO_ADS_RESPONSE',
  400: 'VAST_GENERAL_LINEAR_ERROR',
  401: 'VAST_MEDIAFILE_NOT_FOUND',
  402: 'VAST_UNABLE_TO_DOWNLOAD_MEDIAFILE',
  403: 'VAST_UNSUPPORTED_MEDIATYPE_OR_CODEC',
  405: 'VAST_PROGRESSIVE_DOWNLOAD_TIMEOUT',
  406: 'VAST_MISSING_OR_INVALID_MEDIAFILE',
  407: 'VAST_LOADING_RESOURCE_TIMEOUT',
  408: 'VAST_ASSET_LOAD_ERROR',
  409: 'VAST_MEDIA_INITIALIZATION_ERROR',
  410: 'VAST_MEDIA_PLAYBACK_ERROR',
  500: 'VAST_GENERAL_NONLINEAR_ERROR',
  501: 'VAST_NONLINEAR_AD_UNSUPPORTED',
  502: 'VAST_NONLINEAR_ASSET_UNSUPPORTED',
  503: 'VAST_NONLINEAR_SIZE_MISMATCH',
  600: 'VAST_GENERAL_COMPANION_ERROR',
  601: 'VAST_COMPANION_RENDER_ERROR',
  602: 'VAST_COMPANION_CREATIVE_UNSUPPORTED',
  603: 'VAST_COMPANION_SIZE_MISMATCH',
  604: 'VAST_COMPANION_DISPLAY_ERROR',
  900: 'VAST_UNDEFINED_ERROR',
  901: 'VAST_UNDEFINED_ERROR_PLAYER_SPECIFIC',
  1009: 'VAST_RESOURCE_REQUIRED'
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+ad-engine@5.29.4_@bedrock+html5-engine@3.6.8_@bedrock+media-engine@4.13.0__@bedrock+media-engine@4.13.0/node_modules/@bedrock/ad-engine/lib/utils/error.utils.js







function error_utils_createSuper(t) { var r = error_utils_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function error_utils_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (error_utils_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var VastError = function (_Error) {
  (0,inherits/* default */.Z)(VastError, _Error);
  var _super = error_utils_createSuper(VastError);
  function VastError(code) {
    var _this;
    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : vastErrorMessage[code];
    (0,classCallCheck/* default */.Z)(this, VastError);
    _this = _super.call(this, message);
    _this.name = 'VastError';
    _this.code = code;
    return _this;
  }
  return (0,createClass/* default */.Z)(VastError);
}((0,wrapNativeSuper/* default */.Z)(Error));
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+ad-engine@5.29.4_@bedrock+html5-engine@3.6.8_@bedrock+media-engine@4.13.0__@bedrock+media-engine@4.13.0/node_modules/@bedrock/ad-engine/lib/utils/parser/parser.utils.js






























var parser_utils_excluded = ["minsuggestedduration"];

function parser_parser_utils_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function parser_parser_utils_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? parser_parser_utils_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : parser_parser_utils_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






var parser_utils_defaultOptions = {
  contentDuration: 0,
  features: {
    lazy: false
  }
};
var Parser = function () {
  function Parser() {
    (0,classCallCheck/* default */.Z)(this, Parser);
  }
  (0,createClass/* default */.Z)(Parser, null, [{
    key: "setLogger",
    value: function setLogger(logger) {
      Parser.logger = logger;
      Parser.logger = logger;
    }
  }, {
    key: "parseElementAttributes",
    value: function parseElementAttributes(element) {
      return Array.from(element.attributes).reduce(function (accumulator, attribute) {
        var name = attribute.nodeName.toLowerCase();
        if (attribute.value === 'true') {
          accumulator[name] = true;
        } else if (attribute.value === 'false') {
          accumulator[name] = false;
        } else if (lodash_default().isNaN(Number(attribute.value))) {
          accumulator[name] = attribute.value;
        } else {
          accumulator[name] = parseFloat(attribute.value);
        }
        return accumulator;
      }, {});
    }
  }, {
    key: "getTextContent",
    value: function getTextContent(element) {
      var decodeURI = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var textContent = lodash_default().get(element, 'textContent', null);
      if (!textContent) {
        return textContent;
      }
      if (decodeURI) {
        try {
          textContent = window.decodeURI(textContent);
        } catch (exception) {
          Parser.logger.warn('parser.util', 'getTextContent', exception, textContent);
        }
      }
      return textContent;
    }
  }, {
    key: "validateVASTVersion",
    value: function validateVASTVersion(_ref) {
      var version = _ref.version;
      return version > 1 && version < 5;
    }
  }, {
    key: "parseAdImpression",
    value: function parseAdImpression(ad) {
      return Array.from(ad.getElementsByTagName('Impression')).reduce(function (accumulator, impression) {
        var attributes = Parser.parseElementAttributes(impression);
        var uri = Parser.getTextContent(impression, true);
        if (uri && uri.length) {
          var key = attributes.fullvideo === 'true' ? TrackingEvent.ImpressionEnd : TrackingEvent.Impression;
          if (!accumulator[key]) {
            accumulator[key] = [];
          }
          accumulator[key].push(uri);
        }
        return accumulator;
      }, {});
    }
  }, {
    key: "parseTracking",
    value: function parseTracking(tracking) {
      return parser_parser_utils_objectSpread(parser_parser_utils_objectSpread({}, Parser.parseElementAttributes(tracking)), {}, {
        url: Parser.getTextContent(tracking, true)
      });
    }
  }, {
    key: "parseTrackingEvents",
    value: function parseTrackingEvents(creative) {
      var tagName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Tracking';
      var tracking = Array.from(creative.getElementsByTagName(tagName)).map(Parser.parseTracking).reduce(function (accumulator, _ref2) {
        var event = _ref2.event,
          url = _ref2.url;
        if (!accumulator[event]) {
          accumulator[event] = [];
        }
        if (url && url.length) {
          accumulator[event].push(url);
        }
        return accumulator;
      }, {});
      tracking[TrackingEvent.Click] = [].concat(Array.from(creative.getElementsByTagName('ClickTracking')), Array.from(creative.getElementsByTagName('NonLinearClickTracking')), Array.from(creative.getElementsByTagName('CompanionClickTracking'))).map(function (track) {
        return Parser.getTextContent(track, true);
      });
      return tracking;
    }
  }, {
    key: "parseVerification",
    value: function parseVerification(verification) {
      var sanitize = function sanitize(str) {
        return typeof str === 'string' ? str.replace(/\n/g, '').trim() : '';
      };
      var jsResource = verification.getElementsByTagName('JavaScriptResource')[0];
      var verifParameters = verification.getElementsByTagName('VerificationParameters')[0];
      var parameters = sanitize(Parser.getTextContent(verifParameters, true));
      return {
        resource: sanitize(Parser.getTextContent(jsResource, true)),
        vendor: Parser.parseElementAttributes(verification).vendor || '',
        parameters: parameters
      };
    }
  }, {
    key: "parseNonLinearCreative",
    value: function parseNonLinearCreative(creative) {
      var assets = [].concat(Array.from(creative.getElementsByTagName('IFrameResource')), Array.from(creative.getElementsByTagName('HTMLResource')), Array.from(creative.getElementsByTagName('StaticResource'))).map(function (asset) {
        return parser_parser_utils_objectSpread(parser_parser_utils_objectSpread({}, Parser.parseElementAttributes(asset)), {}, {
          type: asset.nodeName.replace(/resource/i, '').toLowerCase(),
          src: Parser.getTextContent(asset, true)
        });
      });
      var _creative$getElements = creative.getElementsByTagName('NonLinear'),
        _creative$getElements2 = (0,slicedToArray/* default */.Z)(_creative$getElements, 1),
        nonLinearTag = _creative$getElements2[0];
      var _ref3 = nonLinearTag && Parser.parseElementAttributes(nonLinearTag) || {},
        minsuggestedduration = _ref3.minsuggestedduration,
        nonLinearParams = objectWithoutProperties_objectWithoutProperties(_ref3, parser_utils_excluded);
      return parser_parser_utils_objectSpread(parser_parser_utils_objectSpread(parser_parser_utils_objectSpread({}, Parser.parseElementAttributes(creative)), nonLinearParams), {}, {
        duration: convertTimeToSeconds(minsuggestedduration),
        assets: assets,
        tracking: Parser.parseTrackingEvents(creative),
        parameters: Parser.getTextContent(creative.getElementsByTagName('AdParameters')[0]),
        clickThroughUrl: Parser.getTextContent(creative.getElementsByTagName('NonLinearClickThrough')[0], true) || Parser.getTextContent(creative.getElementsByTagName('CompanionClickThrough')[0], true),
        linear: false
      });
    }
  }, {
    key: "validateMediaFile",
    value: function validateMediaFile(mediaFile) {
      var isMediaFileValid = !!mediaFile.delivery && !!mediaFile.type && !!Object.prototype.hasOwnProperty.call(mediaFile, 'width') && !!Object.prototype.hasOwnProperty.call(mediaFile, 'height') && !!mediaFile.src && !!mediaFile.src.length;
      if (!isMediaFileValid) {
        return parser_parser_utils_objectSpread(parser_parser_utils_objectSpread({}, mediaFile), {}, {
          isMediaFileValid: isMediaFileValid,
          errorCode: 401
        });
      }
      return parser_parser_utils_objectSpread(parser_parser_utils_objectSpread({}, mediaFile), {}, {
        isMediaFileValid: isMediaFileValid
      });
    }
  }, {
    key: "parseMediaFile",
    value: function parseMediaFile(mediaFile) {
      return parser_parser_utils_objectSpread(parser_parser_utils_objectSpread({
        bitrate: 0
      }, Parser.parseElementAttributes(mediaFile)), {}, {
        src: Parser.getTextContent(mediaFile, true)
      });
    }
  }, {
    key: "getCreativeId",
    value: function getCreativeId(element) {
      var _element$getElementsB, _element$getElementsB2;
      return ((_element$getElementsB = element.getElementsByTagName('AdInfo')) === null || _element$getElementsB === void 0 ? void 0 : (_element$getElementsB2 = _element$getElementsB[0]) === null || _element$getElementsB2 === void 0 ? void 0 : _element$getElementsB2.getAttribute('crea')) || 'unknown';
    }
  }, {
    key: "parseCreative",
    value: function parseCreative(creative) {
      var assets = Array.from(creative.getElementsByTagName('MediaFile')).map(Parser.parseMediaFile).map(Parser.validateMediaFile).sort(function (firstAsset, secondAsset) {
        return secondAsset.width * secondAsset.height * secondAsset.bitrate - firstAsset.width * firstAsset.height * firstAsset.bitrate;
      });
      var duration = convertTimeToSeconds(Parser.getTextContent(creative.getElementsByTagName('Duration')[0]));
      var creativeAttributes = Parser.parseElementAttributes(creative);
      if (typeof creativeAttributes.skipoffset === 'string') {
        creativeAttributes.skipoffset = timeValueToSeconds(creativeAttributes.skipoffset, duration, Parser.logger);
      }
      return parser_parser_utils_objectSpread(parser_parser_utils_objectSpread(parser_parser_utils_objectSpread({
        adid: Parser.getCreativeId(creative.parentElement.parentElement)
      }, Parser.parseElementAttributes(creative.parentElement)), creativeAttributes), {}, {
        assets: assets.filter(function (asset) {
          return asset.isMediaFileValid;
        }),
        errorStack: assets.filter(function (asset) {
          return !asset.isMediaFileValid;
        }).map(function (asset) {
          return asset.errorCode;
        }),
        duration: duration,
        tracking: Parser.parseTrackingEvents(creative),
        parameters: Parser.getTextContent(creative.getElementsByTagName('AdParameters')[0]),
        clickThroughUrl: Parser.getTextContent(creative.getElementsByTagName('ClickThrough')[0], true),
        linear: true
      });
    }
  }, {
    key: "replaceAdTagMacros",
    value: function replaceAdTagMacros(AdTagUri) {
      var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var reducer = function reducer(acc, macroKey) {
        return acc.replace(new RegExp("\\[".concat(macroKey.toUpperCase(), "\\]"), 'g'), queryParams[macroKey]);
      };
      return Object.keys(queryParams).reduce(reducer, AdTagUri);
    }
  }, {
    key: "parseAd",
    value: function () {
      var _parseAd = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(_ref4) {
        var _inheritedProperty$ad, _inheritedProperty$ad2;
        var id, ad, depth, _ref4$redirects, redirects, inheritedProperty, _ref4$queryParams, queryParams, wrapperAttributes, wrapper, linearCreatives, nonLinearCreatives, companions, errorStack, creatives, newTracking, parsedAd, tagUri, _parsedAd$creatives, _parsedAd$creatives$, parsedVAST, hasAssets;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              id = _ref4.id, ad = _ref4.ad, depth = _ref4.depth, _ref4$redirects = _ref4.redirects, redirects = _ref4$redirects === void 0 ? 0 : _ref4$redirects, inheritedProperty = _ref4.inheritedProperty, _ref4$queryParams = _ref4.queryParams, queryParams = _ref4$queryParams === void 0 ? {} : _ref4$queryParams;
              wrapperAttributes = {};
              wrapper = ad.getElementsByTagName('Wrapper')[0];
              if (wrapper) {
                wrapperAttributes = Parser.parseElementAttributes(wrapper);
              }
              linearCreatives = Array.from(ad.getElementsByTagName('Linear')).map(Parser.parseCreative);
              nonLinearCreatives = Array.from(ad.getElementsByTagName('NonLinearAds')).map(Parser.parseNonLinearCreative);
              companions = Array.from(ad.getElementsByTagName('Companion')).map(Parser.parseNonLinearCreative);
              errorStack = [];
              if (!nonLinearCreatives.length || !companions.length) {
                errorStack.push(303);
              }
              creatives = linearCreatives.concat(nonLinearCreatives).map(function (creative) {
                var _inheritedProperty$cr, _inheritedProperty$cr2;
                return parser_parser_utils_objectSpread(parser_parser_utils_objectSpread({}, creative), {}, {
                  tracking: lodash_default().mergeWith(creative.tracking, inheritedProperty === null || inheritedProperty === void 0 ? void 0 : (_inheritedProperty$cr = inheritedProperty.creative) === null || _inheritedProperty$cr === void 0 ? void 0 : _inheritedProperty$cr.tracking, mergeArrayWithoutDuplicates),
                  duration: creative.duration || (inheritedProperty === null || inheritedProperty === void 0 ? void 0 : (_inheritedProperty$cr2 = inheritedProperty.creative) === null || _inheritedProperty$cr2 === void 0 ? void 0 : _inheritedProperty$cr2.duration) || 0
                });
              });
              newTracking = parser_parser_utils_objectSpread(parser_parser_utils_objectSpread({}, Parser.parseAdImpression(ad)), {}, (0,defineProperty/* default */.Z)({}, TrackingEvent.Error, Array.from(ad.getElementsByTagName('Error')).map(function (error) {
                return Parser.getTextContent(error, true);
              })));
              parsedAd = parser_parser_utils_objectSpread(parser_parser_utils_objectSpread(parser_parser_utils_objectSpread({}, wrapperAttributes), Parser.parseElementAttributes(ad)), {}, {
                id: id,
                depth: depth,
                isWrapper: !!wrapper,
                tracking: lodash_default().mergeWith(newTracking, inheritedProperty === null || inheritedProperty === void 0 ? void 0 : (_inheritedProperty$ad = inheritedProperty.ad) === null || _inheritedProperty$ad === void 0 ? void 0 : _inheritedProperty$ad.tracking, mergeArrayWithoutDuplicates),
                creatives: creatives,
                companions: companions,
                duration: Math.max.apply(Math, (0,toConsumableArray/* default */.Z)(creatives.map(function (creative) {
                  return creative.duration;
                })).concat([0])) || undefined,
                title: Parser.getTextContent(ad.getElementsByTagName('AdTitle')[0]),
                system: Parser.getTextContent(ad.getElementsByTagName('AdSystem')[0]),
                redirects: redirects,
                errorStack: errorStack,
                verifications: Array.from(ad.getElementsByTagName('Verification')).map(Parser.parseVerification).concat(inheritedProperty === null || inheritedProperty === void 0 ? void 0 : (_inheritedProperty$ad2 = inheritedProperty.ad) === null || _inheritedProperty$ad2 === void 0 ? void 0 : _inheritedProperty$ad2.verifications).filter(function (verification) {
                  return !!verification;
                })
              });
              tagUri = Parser.getTextContent(ad.getElementsByTagName('VASTAdTagURI')[0], true);
              if (!!wrapper && !tagUri) {
                parsedAd.errorStack.push(300);
              }
              if (!(tagUri && redirects < 5)) {
                _context.next = 19;
                break;
              }
              _context.next = 17;
              return Parser.retrieveAdTagURI({
                adTagURI: Parser.replaceAdTagMacros(tagUri, queryParams),
                redirects: redirects + 1,
                inheritedProperty: {
                  creative: {
                    tracking: parsedAd === null || parsedAd === void 0 ? void 0 : (_parsedAd$creatives = parsedAd.creatives) === null || _parsedAd$creatives === void 0 ? void 0 : (_parsedAd$creatives$ = _parsedAd$creatives[0]) === null || _parsedAd$creatives$ === void 0 ? void 0 : _parsedAd$creatives$.tracking
                  },
                  ad: {
                    tracking: parsedAd.tracking,
                    verifications: parsedAd.verifications
                  }
                },
                queryParams: queryParams,
                onError: function onError(code) {
                  return parsedAd.errorStack.push(code);
                }
              });
            case 17:
              parsedVAST = _context.sent;
              if (parsedVAST) {
                parsedAd.id = lodash_default().get(parsedVAST, 'ads.0.id', parsedAd.id);
                parsedAd.title = lodash_default().get(parsedVAST, 'ads.0.title', parsedAd.title);
                parsedAd.system = lodash_default().get(parsedVAST, 'ads.0.system', parsedAd.system);
                parsedAd.redirects = lodash_default().get(parsedVAST, 'ads.0.redirects', parsedAd.redirects);
                parsedAd.creatives = [];
                parsedAd.wrapperVAST = parsedVAST;
              }
            case 19:
              hasAssets = parsedAd.creatives.some(function (crea) {
                return crea.assets.length;
              });
              if (!hasAssets && !parsedAd.wrapperVAST) {
                Parser.logger.error('parser.util', 'parseAd', 'Wrong format: no asset in Ad');
                parsedAd.creatives = [];
              }
              return _context.abrupt("return", parsedAd);
            case 22:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function parseAd(_x) {
        return _parseAd.apply(this, arguments);
      }
      return parseAd;
    }()
  }, {
    key: "parseVAST",
    value: function () {
      var _parseVAST = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2(vast) {
        var redirects,
          inheritedProperty,
          queryParams,
          parsedVAST,
          errorTracking,
          getVASTElementDepth,
          ads,
          hasSequencing,
          _args2 = arguments;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              redirects = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 0;
              inheritedProperty = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : undefined;
              queryParams = _args2.length > 3 ? _args2[3] : undefined;
              parsedVAST = parser_parser_utils_objectSpread(parser_parser_utils_objectSpread({}, EMPTY_SLOT), {}, {
                id: 0,
                loaded: true,
                errorStack: []
              }, Parser.parseElementAttributes(vast));
              errorTracking = Parser.getTextContent(vast.getElementsByTagName('Error')[0]);
              if (errorTracking) {
                parsedVAST.tracking.error.push(errorTracking);
              }
              getVASTElementDepth = function getVASTElementDepth(element) {
                var depth = 0;
                var currentElement = element;
                while (currentElement.parentElement) {
                  depth++;
                  if (depth > MAX_VAST_RECURSIVITY) return -1;
                  currentElement = currentElement.parentElement;
                }
                return depth - 1;
              };
              _context2.next = 9;
              return Promise.all(Array.from(vast.getElementsByTagName('Ad')).map(function (adElement, index) {
                return Parser.parseAd({
                  id: index,
                  ad: adElement,
                  depth: getVASTElementDepth(adElement),
                  redirects: redirects,
                  inheritedProperty: inheritedProperty,
                  queryParams: queryParams
                });
              }));
            case 9:
              ads = _context2.sent;
              hasSequencing = ads.find(function (_ref5) {
                var sequence = _ref5.sequence;
                return Number.isInteger(sequence);
              });
              if (hasSequencing) {
                parsedVAST.ads = ads.filter(function (_ref6) {
                  var sequence = _ref6.sequence;
                  return Number.isInteger(sequence);
                });
                parsedVAST.buffet = ads.filter(function (_ref7) {
                  var sequence = _ref7.sequence;
                  return !Number.isInteger(sequence);
                });
              } else {
                parsedVAST.ads = ads;
              }
              parsedVAST.ads.sort(function (first, second) {
                return first.sequence - second.sequence;
              });
              parsedVAST.ads.forEach(function (ad) {
                var _ad$errorStack, _ad$creatives;
                (_ad$errorStack = ad.errorStack) === null || _ad$errorStack === void 0 ? void 0 : _ad$errorStack.forEach(function (errorCode) {
                  return parsedVAST.errorStack.push(errorCode);
                });
                (_ad$creatives = ad.creatives) === null || _ad$creatives === void 0 ? void 0 : _ad$creatives.forEach(function (creative) {
                  var _creative$errorStack;
                  (_creative$errorStack = creative.errorStack) === null || _creative$errorStack === void 0 ? void 0 : _creative$errorStack.forEach(function (errorCode) {
                    return parsedVAST.errorStack.push(errorCode);
                  });
                });
              });
              parsedVAST.errorStack = lodash_default().uniq(parsedVAST.errorStack);
              return _context2.abrupt("return", parsedVAST);
            case 16:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function parseVAST(_x2) {
        return _parseVAST.apply(this, arguments);
      }
      return parseVAST;
    }()
  }, {
    key: "retrieveAdTagURI",
    value: function retrieveAdTagURI(_ref8) {
      var adTagURI = _ref8.adTagURI,
        _ref8$redirects = _ref8.redirects,
        redirects = _ref8$redirects === void 0 ? 0 : _ref8$redirects,
        _ref8$inheritedProper = _ref8.inheritedProperty,
        inheritedProperty = _ref8$inheritedProper === void 0 ? undefined : _ref8$inheritedProper,
        _ref8$queryParams = _ref8.queryParams,
        queryParams = _ref8$queryParams === void 0 ? {} : _ref8$queryParams,
        onError = _ref8.onError;
      return superagent_lib_client_default().get(adTagURI).withCredentials().timeout(3000).then(function (response) {
        return textToHtmlElement(response.text).then(function (xml) {
          return Parser.parseVAST(xml.getElementsByTagName('VAST')[0], redirects, inheritedProperty, queryParams);
        });
      }).catch(function (error) {
        if (error.code === 'ECONNABORTED' && error.timeout) {
          Parser.logger.warn('parser.util', '301 - parseAd', error);
          onError === null || onError === void 0 ? void 0 : onError(301);
        } else {
          Parser.logger.warn('parser.util', '100 - parseAd', error);
          onError === null || onError === void 0 ? void 0 : onError(100);
        }
        return null;
      });
    }
  }, {
    key: "retrieveSlot",
    value: function () {
      var _retrieveSlot = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee3(slot, queryParams) {
        var loadedSlot;
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.retrieveAdTagURI({
                adTagURI: slot.adTagURI,
                redirects: 0,
                inheritedProperty: slot.options,
                queryParams: queryParams
              });
            case 2:
              loadedSlot = _context3.sent;
              if (loadedSlot) {
                _context3.next = 5;
                break;
              }
              return _context3.abrupt("return", null);
            case 5:
              return _context3.abrupt("return", parser_parser_utils_objectSpread(parser_parser_utils_objectSpread({}, loadedSlot), {}, {
                id: slot.id,
                cuePoint: slot.cuePoint,
                type: slot.type,
                allowMultipleAds: slot.allowMultipleAds,
                followRedirects: slot.followRedirects,
                tracking: mergeTracking(slot.tracking, loadedSlot.tracking)
              }));
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function retrieveSlot(_x3, _x4) {
        return _retrieveSlot.apply(this, arguments);
      }
      return retrieveSlot;
    }()
  }, {
    key: "parseVMAPAdSource",
    value: function () {
      var _parseVMAPAdSource = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee4(adSource, options) {
        var vast, adTag, adTagURI, _options$features;
        return regenerator_default().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              vast = adSource.getElementsByTagName('VAST')[0];
              if (!vast) {
                _context4.next = 3;
                break;
              }
              return _context4.abrupt("return", Parser.parseVAST(vast));
            case 3:
              adTag = adSource.getElementsByTagName('vmap:AdTagURI')[0];
              adTagURI = Parser.getTextContent(adTag);
              if (!adTagURI) {
                _context4.next = 9;
                break;
              }
              if (!(options !== null && options !== void 0 && (_options$features = options.features) !== null && _options$features !== void 0 && _options$features.lazy)) {
                _context4.next = 8;
                break;
              }
              return _context4.abrupt("return", parser_parser_utils_objectSpread(parser_parser_utils_objectSpread({}, EMPTY_SLOT), {}, {
                adTagURI: adTagURI
              }));
            case 8:
              return _context4.abrupt("return", Parser.retrieveAdTagURI({
                adTagURI: adTagURI,
                redirects: 0,
                queryParams: (options === null || options === void 0 ? void 0 : options.queryParams) || {}
              }));
            case 9:
              return _context4.abrupt("return", Promise.resolve(null));
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function parseVMAPAdSource(_x5, _x6) {
        return _parseVMAPAdSource.apply(this, arguments);
      }
      return parseVMAPAdSource;
    }()
  }, {
    key: "validateVMAPAdSource",
    value: function validateVMAPAdSource(adSource) {
      if (!adSource) {
        return false;
      }
      var adSourceVAST = adSource.getElementsByTagName('VAST')[0];
      if (adSourceVAST && adSourceVAST.childNodes.length === 0) {
        return false;
      }
      var adTagURI = adSource.getElementsByTagName('vmap:AdTagURI')[0];
      if (adTagURI) {
        var adTagURIAttributes = Parser.parseElementAttributes(adTagURI);
        if (!['vast2', 'vast3', 'vast4'].includes(adTagURIAttributes.templatetype)) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "parseVMAP",
    value: function () {
      var _parseVMAP = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee6(vmap, options) {
        var promises;
        return regenerator_default().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              promises = Array.from(vmap.getElementsByTagName('vmap:AdBreak')).map(function () {
                var _ref9 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee5(slot) {
                  var adSource, adTracking, hasValidatedVMAPAdSource, hasValidatedVMAPTrackingEvents, slotAttributes, tracking, timeoffset, cuePoint, parsedVAST, sourceAttributes;
                  return regenerator_default().wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        adSource = slot.getElementsByTagName('vmap:AdSource')[0];
                        adTracking = slot.getElementsByTagName('vmap:TrackingEvents')[0];
                        hasValidatedVMAPAdSource = Parser.validateVMAPAdSource(adSource);
                        hasValidatedVMAPTrackingEvents = !!adTracking;
                        if (!hasValidatedVMAPAdSource) {
                          Parser.logger.error('parser.util', 'parseVMAP', 'Wrong format: no adSource in VMAP');
                        }
                        if (!hasValidatedVMAPTrackingEvents) {
                          Parser.logger.warn('parser.util', 'parseVMAP', 'Wrong format: no adTrackingEvents in VMAP');
                        }
                        if (!(!hasValidatedVMAPAdSource && !hasValidatedVMAPTrackingEvents)) {
                          _context5.next = 8;
                          break;
                        }
                        return _context5.abrupt("return");
                      case 8:
                        Parser.logger.debug('parser.util', 'parseVMAP', 'VMAP validation complete');
                        slotAttributes = Parser.parseElementAttributes(slot);
                        tracking = Parser.parseTrackingEvents(slot, 'vmap:Tracking');
                        if (!tracking[TrackingEvent.Error]) {
                          tracking[TrackingEvent.Error] = [];
                        }
                        timeoffset = slotAttributes.timeoffset;
                        cuePoint = timeValueToSeconds(timeoffset, options.contentDuration, Parser.logger);
                        if (adSource) {
                          _context5.next = 16;
                          break;
                        }
                        return _context5.abrupt("return", parser_parser_utils_objectSpread(parser_parser_utils_objectSpread({}, EMPTY_SLOT), {}, {
                          ads: [],
                          id: slotAttributes.breakid,
                          cuePoint: cuePoint,
                          type: slotAttributes.breaktype,
                          loaded: true,
                          tracking: tracking
                        }));
                      case 16:
                        _context5.next = 18;
                        return Parser.parseVMAPAdSource(adSource, options);
                      case 18:
                        parsedVAST = _context5.sent;
                        if (parsedVAST) {
                          _context5.next = 21;
                          break;
                        }
                        return _context5.abrupt("return", null);
                      case 21:
                        sourceAttributes = Parser.parseElementAttributes(adSource);
                        return _context5.abrupt("return", parser_parser_utils_objectSpread(parser_parser_utils_objectSpread({}, parsedVAST), {}, {
                          id: slotAttributes.breakid,
                          cuePoint: cuePoint,
                          type: slotAttributes.breaktype,
                          allowMultipleAds: sourceAttributes.allowmultipleads,
                          followRedirects: sourceAttributes.followredirects,
                          tracking: mergeTracking(parsedVAST.tracking, tracking)
                        }));
                      case 23:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                return function (_x9) {
                  return _ref9.apply(this, arguments);
                };
              }());
              return _context6.abrupt("return", Promise.all(promises));
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      function parseVMAP(_x7, _x8) {
        return _parseVMAP.apply(this, arguments);
      }
      return parseVMAP;
    }()
  }, {
    key: "parse",
    value: function () {
      var _parse = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee7(text) {
        var opts,
          options,
          xml,
          rootNodeName,
          slots,
          slot,
          _args7 = arguments;
        return regenerator_default().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              opts = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : {};
              options = lodash_default().merge({}, parser_utils_defaultOptions, opts);
              _context7.prev = 2;
              _context7.next = 5;
              return textToHtmlElement(text);
            case 5:
              xml = _context7.sent;
              if (!xml.childNodes.length) {
                _context7.next = 18;
                break;
              }
              rootNodeName = xml.childNodes[0].nodeName.toLowerCase();
              if (!(rootNodeName === AD_FORMAT.VMAP)) {
                _context7.next = 13;
                break;
              }
              _context7.next = 11;
              return Parser.parseVMAP(xml.childNodes[0], options);
            case 11:
              slots = _context7.sent.filter(function (slot) {
                return !!slot;
              });
              return _context7.abrupt("return", {
                format: AD_FORMAT.VMAP,
                slots: slots
              });
            case 13:
              if (!(rootNodeName === AD_FORMAT.VAST)) {
                _context7.next = 18;
                break;
              }
              _context7.next = 16;
              return Parser.parseVAST(xml.childNodes[0]);
            case 16:
              slot = _context7.sent;
              return _context7.abrupt("return", {
                format: AD_FORMAT.VAST,
                slots: [slot]
              });
            case 18:
              return _context7.abrupt("return", {
                format: AD_FORMAT.UNKNOWN,
                slots: []
              });
            case 21:
              _context7.prev = 21;
              _context7.t0 = _context7["catch"](2);
              Parser.logger.error('parser.util', '100 - parse', _context7.t0);
              throw new VastError(100);
            case 25:
            case "end":
              return _context7.stop();
          }
        }, _callee7, null, [[2, 21]]);
      }));
      function parse(_x0) {
        return _parse.apply(this, arguments);
      }
      return parse;
    }()
  }]);
  return Parser;
}();
Parser.logger = {
  info: (lodash_default()).noop,
  error: (lodash_default()).noop,
  debug: (lodash_default()).noop,
  warn: (lodash_default()).noop
};
Parser.convertTimeToSeconds = convertTimeToSeconds;
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+ad-engine@5.29.4_@bedrock+html5-engine@3.6.8_@bedrock+media-engine@4.13.0__@bedrock+media-engine@4.13.0/node_modules/@bedrock/ad-engine/lib/utils/assets.utils.js






function assets_utils_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function assets_utils_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? assets_utils_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : assets_utils_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var chooseLinearAsset = function chooseLinearAsset(assets, _ref) {
  var video = _ref.video,
    width = _ref.width,
    height = _ref.height,
    desiredBitrate = _ref.desiredBitrate,
    _ref$withJavascript = _ref.withJavascript,
    withJavascript = _ref$withJavascript === void 0 ? true : _ref$withJavascript;
  var playableAssets = assets.filter(function (_ref2) {
    var type = _ref2.type,
      apiframework = _ref2.apiframework;
    if ((type === 'application/javascript' || type === 'application/x-javascript') && apiframework === 'VPAID') {
      return withJavascript;
    }
    var canPlay = video.canPlayType(type);
    return canPlay === 'maybe' || canPlay === 'probably';
  });
  if (!playableAssets.length) {
    throw new VastError(403);
  }
  var filteredAssets = playableAssets.filter(function (asset) {
    return asset.width <= width && asset.height <= height;
  }).map(function (asset) {
    return assets_utils_objectSpread(assets_utils_objectSpread({}, asset), {}, {
      fillSpaceRatio: asset.width * asset.height / (width * height)
    });
  }).sort(function (firstItem, secondItem) {
    return secondItem.fillSpaceRatio - firstItem.fillSpaceRatio;
  });
  if (!filteredAssets.length) {
    filteredAssets.push(playableAssets[0]);
  }
  var bitrateFilteredAssets = filteredAssets.filter(function (asset) {
    return asset.bitrate <= desiredBitrate;
  });
  if (!bitrateFilteredAssets.length) {
    var _filteredAssets$slice = filteredAssets.slice(0).sort(function (firstItem, secondItem) {
        return firstItem.bitrate - secondItem.bitrate;
      }),
      _filteredAssets$slice2 = (0,slicedToArray/* default */.Z)(_filteredAssets$slice, 1),
      leastBitrateFilteredAsset = _filteredAssets$slice2[0];
    return leastBitrateFilteredAsset || filteredAssets[0];
  }
  return bitrateFilteredAssets[0];
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+ad-engine@5.29.4_@bedrock+html5-engine@3.6.8_@bedrock+media-engine@4.13.0__@bedrock+media-engine@4.13.0/node_modules/@bedrock/ad-engine/lib/bridges/format.utils.js









function format_utils_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function format_utils_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? format_utils_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : format_utils_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var formatAds = function formatAds(slot) {
  var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var parentId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  if (!slot.ads || depth > MAX_VAST_RECURSIVITY) return [];
  return slot.ads.flatMap(function (ad, index) {
    var id = [parentId, depth, index + 1].filter(Boolean).join('.');
    return [format_utils_objectSpread(format_utils_objectSpread({}, ad), {}, {
      depth: depth,
      parentId: parentId,
      id: id
    })].concat((0,toConsumableArray/* default */.Z)(ad.wrapperVAST ? formatAds(ad.wrapperVAST, depth + 1, id) : []));
  }).sort(function (x, y) {
    return x.sequence - y.sequence;
  }).sort(function (x, y) {
    return x.depth - y.depth;
  });
};
var formatBuffet = function formatBuffet(formattedAds, currentSlot) {
  return [].concat((0,toConsumableArray/* default */.Z)(formattedAds.filter(function (ad) {
    return ad.isWrapper;
  }).flatMap(function (ad) {
    var _ad$wrapperVAST, _ad$wrapperVAST$buffe;
    return ad === null || ad === void 0 ? void 0 : (_ad$wrapperVAST = ad.wrapperVAST) === null || _ad$wrapperVAST === void 0 ? void 0 : (_ad$wrapperVAST$buffe = _ad$wrapperVAST.buffet) === null || _ad$wrapperVAST$buffe === void 0 ? void 0 : _ad$wrapperVAST$buffe.map(function (buffetItem, i) {
      return format_utils_objectSpread(format_utils_objectSpread({}, buffetItem), {}, {
        parentId: ad.id,
        id: "buffet-".concat(ad.id, "-").concat(i + 1)
      });
    });
  })), (0,toConsumableArray/* default */.Z)((currentSlot.buffet || []).map(function (buffetItem, i) {
    return format_utils_objectSpread(format_utils_objectSpread({}, buffetItem), {}, {
      parentId: '',
      id: "buffet-".concat(i + 1)
    });
  })));
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+ad-engine@5.29.4_@bedrock+html5-engine@3.6.8_@bedrock+media-engine@4.13.0__@bedrock+media-engine@4.13.0/node_modules/@bedrock/ad-engine/lib/tracking/tracking.js



var Tracking = function () {
  function Tracking() {
    (0,classCallCheck/* default */.Z)(this, Tracking);
  }
  (0,createClass/* default */.Z)(Tracking, [{
    key: "configure",
    value: function configure(config) {
      this.config = lodash_default().merge({}, this.config, config);
    }
  }, {
    key: "setEventSender",
    value: function setEventSender() {
      throw new Error('Not Implemented Exception');
    }
  }, {
    key: "track",
    value: function track() {
      throw new Error('Not Implemented Exception');
    }
  }]);
  return Tracking;
}();
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+ad-engine@5.29.4_@bedrock+html5-engine@3.6.8_@bedrock+media-engine@4.13.0__@bedrock+media-engine@4.13.0/node_modules/@bedrock/ad-engine/lib/bridges/tracking.util.js












var getTrackingUrl = function getTrackingUrl(tracking) {
  var replacements = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var withHttps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var url = tracking;
  lodash_default().forOwn(replacements, function (value, key) {
    url = url.replace("[".concat(key, "]"), value);
  });
  var random = Date.now().toString();
  url = url.replace("[RANDOM]", random);
  url = url.replace("[CACHEBUSTING]", random);
  url = withHttps ? url : url.replace('https', 'http');
  return url;
};
var createPixel = function createPixel(src) {
  var image = new Image();
  image.src = src;
};
var appendTagsPixel = function appendTagsPixel(pixelConfig, tags) {
  var endpoint = pixelConfig.endpoint,
    paramName = pixelConfig.paramName,
    _pixelConfig$params = pixelConfig.params,
    params = _pixelConfig$params === void 0 ? {} : _pixelConfig$params;
  var queryParameters = Object.keys(params).map(function (key) {
    return "".concat(key, "=").concat(encodeURIComponent(params[key]));
  });
  if (paramName) {
    queryParameters.push("".concat(paramName, "=").concat(encodeURIComponent(tags.join(','))));
  } else {
    queryParameters.push.apply(queryParameters, _toConsumableArray(tags));
  }
  createPixel("".concat(endpoint, "?").concat(queryParameters.join('&')));
};
var track = function track(target, event) {
  var replacements = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var tracking = _.get(target, "tracking.".concat(event));
  var id = _.get(target, 'id') || _.get(target, 'adid');
  Logger.warn('tracking.util', 'track', 'DEPRECATED METHOD, Use tracking manager instead');
  Logger.debug('tracking.util', 'track', "Tracking event <".concat(event, "> for entity ").concat(id));
  if (tracking instanceof Array) {
    tracking.forEach(function (tr) {
      return createPixel(getTrackingUrl(tr, replacements));
    });
  } else if (tracking) {
    createPixel(getTrackingUrl(tracking, replacements));
  }
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+ad-engine@5.29.4_@bedrock+html5-engine@3.6.8_@bedrock+media-engine@4.13.0__@bedrock+media-engine@4.13.0/node_modules/@bedrock/ad-engine/lib/tracking/pixel.tracking.js








function pixel_tracking_createSuper(t) { var r = pixel_tracking_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function pixel_tracking_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (pixel_tracking_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }




var PixelTracking = function (_Tracking) {
  (0,inherits/* default */.Z)(PixelTracking, _Tracking);
  var _super = pixel_tracking_createSuper(PixelTracking);
  function PixelTracking() {
    var _this;
    (0,classCallCheck/* default */.Z)(this, PixelTracking);
    _this = _super.apply(this, arguments);
    _this.name = 'PixelTracking';
    return _this;
  }
  (0,createClass/* default */.Z)(PixelTracking, [{
    key: "track",
    value: function track(target, event) {
      var _this2 = this;
      var replacements = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var tracking = lodash_default().get(target, "tracking.".concat(event));
      if (!tracking) {
        return;
      }
      var id = lodash_default().get(target, 'id') || lodash_default().get(target, 'adid');
      logger_utils.debug(this.name, 'track', "Tracking event <".concat(event, "> for entity ").concat(id));
      if (tracking instanceof Array) {
        tracking.forEach(function (tr) {
          return createPixel(getTrackingUrl(tr, replacements, _this2.config.withHttps));
        });
      } else {
        createPixel(getTrackingUrl(tracking, replacements, this.config.withHttps));
      }
    }
  }]);
  return PixelTracking;
}(Tracking);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+ad-engine@5.29.4_@bedrock+html5-engine@3.6.8_@bedrock+media-engine@4.13.0__@bedrock+media-engine@4.13.0/node_modules/@bedrock/ad-engine/lib/tracking/om.constants.js
var PARTNER_NAME = 'bedrockstreaming';
var ACCESS_MODE = 'full';
var AD_LOADED = 'adLoaded';
var LOADED = 'loaded';
var AD_INIT = 'adInit';
var START = 'start';
var FIRST_QUARTILE = 'firstQuartile';
var MIDPOINT = 'midpoint';
var THIRD_QUARTILE = 'thirdQuartile';
var COMPLETE = 'complete';
var STOP = 'stop';
var BREAK_END = 'breakEnd';
var CLOSE_LINEAR = 'closeLinear';
var CLICK_TRACKING = 'ClickTracking';
var om_constants_PAUSE = 'pause';
var RESUME = 'resume';
var MUTE = 'mute';
var UNMUTE = 'unmute';
var om_constants_VOLUME_CHANGE = 'volumechange';
var FULLSCREEN_CHANGE = 'fullscreenchange';
var WEBKIT_FULLSCREEN_CHANGE = 'webkitfullscreenchange';
var MOZ_FULLSCREEN_CHANGE = 'mozfullscreenchange';
var MS_FULLSCREEN_CHANGE = 'msfullscreenchange';
var SCREEN_MODE_FULLSCREEN = 'fullscreen';
var SCREEN_MODE_NORMAL = 'normal';
var CLICK = 'click';
var om_constants_ERROR = 'error';
var ERROR_TYPE_VIDEO = 'video';
var ERROR_TYPE_GENERIC = 'generic';
var ERROR_TYPE_MEDIA = 'media';
var BEFORE_UNLOAD = 'beforeunload';
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+ad-engine@5.29.4_@bedrock+html5-engine@3.6.8_@bedrock+media-engine@4.13.0__@bedrock+media-engine@4.13.0/node_modules/@bedrock/ad-engine/package.json
const ad_engine_package_namespaceObject = {"i8":"5.29.4"};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+ad-engine@5.29.4_@bedrock+html5-engine@3.6.8_@bedrock+media-engine@4.13.0__@bedrock+media-engine@4.13.0/node_modules/@bedrock/ad-engine/lib/tracking/om.tracking.js















function om_tracking_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function om_tracking_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? om_tracking_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : om_tracking_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function om_tracking_createSuper(t) { var r = om_tracking_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function om_tracking_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (om_tracking_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }





var CLEAR_DELAY_TRACKING_IFRAME = 3000;
var NO_SESSION_EVENTS = [AD_INIT, BREAK_END];
var VIDEO_LISTENED_EVENTS = [om_constants_VOLUME_CHANGE, CLICK, om_constants_ERROR];
var DOCUMENT_LISTENED_EVENTS = [MS_FULLSCREEN_CHANGE, MOZ_FULLSCREEN_CHANGE, WEBKIT_FULLSCREEN_CHANGE];
var WINDOW_LISTENED_EVENTS = [BEFORE_UNLOAD];
var CLEANUP_EVENTS = [BREAK_END];
var OmTracking = function (_Tracking) {
  (0,inherits/* default */.Z)(OmTracking, _Tracking);
  var _super = om_tracking_createSuper(OmTracking);
  function OmTracking(debug) {
    var _this$eventHandlers, _this$handlers;
    var _this;
    (0,classCallCheck/* default */.Z)(this, OmTracking);
    _this = _super.call(this);
    _this.name = 'OmTracking';
    _this.eventHandlers = (_this$eventHandlers = {}, (0,defineProperty/* default */.Z)(_this$eventHandlers, om_constants_VOLUME_CHANGE, function () {
      if (_this.config.video.muted) {
        logger_utils.debug(_this.name, 'track', "Tracking event <".concat(om_constants_VOLUME_CHANGE, "> with volume at 0"));
        _this.mediaEvents.volumeChange(0.0);
      } else {
        logger_utils.debug(_this.name, 'track', "Tracking event <".concat(om_constants_VOLUME_CHANGE, "> with volume at ").concat(_this.config.video.volume));
        _this.mediaEvents.volumeChange(_this.config.video.volume);
      }
    }), (0,defineProperty/* default */.Z)(_this$eventHandlers, FULLSCREEN_CHANGE, function () {
      var state = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen || document.msFullScreen;
      var playerState = state ? 'fullscreen' : 'normal';
      logger_utils.debug(_this.name, 'track', "Player state change to ".concat(playerState));
      _this.mediaEvents.playerStateChange(playerState);
    }), (0,defineProperty/* default */.Z)(_this$eventHandlers, CLICK, function () {
      logger_utils.debug(_this.name, 'track', "Tracking event <".concat(CLICK, ">"));
      _this.mediaEvents.adUserInteraction(CLICK);
    }), (0,defineProperty/* default */.Z)(_this$eventHandlers, om_constants_ERROR, function () {
      logger_utils.error(_this.name, 'track', "Tracking event <".concat(om_constants_ERROR, ">"));
      _this.adSession.error(ERROR_TYPE_VIDEO, _this.config.video.error.message);
    }), (0,defineProperty/* default */.Z)(_this$eventHandlers, BEFORE_UNLOAD, function () {
      logger_utils.debug(_this.name, 'track', "Tracking event <".concat(BEFORE_UNLOAD, ">"));
      _this.releaseAd();
      _this.timeoutRemoveIFrames();
    }), _this$eventHandlers);
    _this.handlers = (_this$handlers = {}, (0,defineProperty/* default */.Z)(_this$handlers, AD_INIT, function () {
      return _this.createSession();
    }), (0,defineProperty/* default */.Z)(_this$handlers, START, function (target) {
      return _this.mediaEvents.start(target.duration, _this.config.video.volume);
    }), (0,defineProperty/* default */.Z)(_this$handlers, FIRST_QUARTILE, function () {
      return _this.mediaEvents.firstQuartile();
    }), (0,defineProperty/* default */.Z)(_this$handlers, MIDPOINT, function () {
      return _this.mediaEvents.midpoint();
    }), (0,defineProperty/* default */.Z)(_this$handlers, THIRD_QUARTILE, function () {
      return _this.mediaEvents.thirdQuartile();
    }), (0,defineProperty/* default */.Z)(_this$handlers, COMPLETE, function () {
      return _this.mediaEvents.complete();
    }), (0,defineProperty/* default */.Z)(_this$handlers, CLICK, function () {
      return _this.mediaEvents.adUserInteraction(CLICK);
    }), (0,defineProperty/* default */.Z)(_this$handlers, CLICK_TRACKING, function () {
      return _this.mediaEvents.adUserInteraction(CLICK);
    }), (0,defineProperty/* default */.Z)(_this$handlers, om_constants_PAUSE, function () {
      return _this.mediaEvents.pause();
    }), (0,defineProperty/* default */.Z)(_this$handlers, RESUME, function () {
      return _this.mediaEvents.resume();
    }), (0,defineProperty/* default */.Z)(_this$handlers, STOP, function () {
      return _this.releaseAd();
    }), (0,defineProperty/* default */.Z)(_this$handlers, BREAK_END, function () {
      return _this.timeoutRemoveIFrames();
    }), (0,defineProperty/* default */.Z)(_this$handlers, CLOSE_LINEAR, function () {
      return _this.releaseAd();
    }), _this$handlers);
    _this.removeIFrames();
    _this.adSession = null;
    _this.adEvents = null;
    _this.mediaEvents = null;
    _this.debug = debug;
    logger_utils.debug(_this.name, 'constructor', "Is debug mode activated : ".concat(_this.debug));
    return _this;
  }
  (0,createClass/* default */.Z)(OmTracking, [{
    key: "configure",
    value: function configure() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      config.active = lodash_default().get(config, 'ad.verifications', []).length > 0;
      this.config = lodash_default().merge({}, this.config, config);
    }
  }, {
    key: "getSessionClient",
    value: function getSessionClient() {
      return window.OmidSessionClient && window.OmidSessionClient.default;
    }
  }, {
    key: "createSession",
    value: function createSession() {
      var _this2 = this;
      if (!this.getSessionClient()) {
        throw new Error('you should have loaded the om sdk when you create a session');
      }
      if (!this.config.video) {
        throw new Error('you should have a video element to create a session');
      }
      if (!this.config.ad) {
        throw new Error('you should have an ad when you create a session');
      }
      var sessionClient = this.getSessionClient();
      var partner = new sessionClient.Partner(PARTNER_NAME, ad_engine_package_namespaceObject.i8);
      var resources = this.config.ad.verifications.filter(function (verification) {
        return !!verification;
      }).map(function (verification) {
        logger_utils.debug(_this2.name, 'createSession', "Resource URL ".concat(verification.resource));
        return new sessionClient.VerificationScriptResource(verification.resource, verification.vendor, verification.parameters, ACCESS_MODE);
      });
      if (this.debug) {
        resources.push(new sessionClient.VerificationScriptResource("".concat(window.location.origin, "/assets/scripts/omsdk/omid-validation-verification-script-v1.js"), 'dummyVendor', JSON.stringify({
          k: 'v'
        }), ACCESS_MODE));
      }
      logger_utils.debug(this.name, 'createSession', "Loaded resources ".concat(JSON.stringify(resources)));
      var context = new sessionClient.Context(partner, resources, window.location.href);
      context.deviceCategory = this.config.deviceCategory;
      context.setVideoElement(this.config.video);
      context.setServiceWindow(window.top);
      this.adSession = new sessionClient.AdSession(context);
      this.registerSessionObserver();
      this.adSession.setCreativeType('video');
      this.adSession.setImpressionType('beginToRender');
      if (!this.adSession.isSupported()) {
        throw new Error('your client/platform is unsupported');
      }
      this.adEvents = new sessionClient.AdEvents(this.adSession);
      this.mediaEvents = new sessionClient.MediaEvents(this.adSession);
      this.adSession.start();
      this.manageWindowEventHandler('add');
      this.manageVideoElementEventHandler('add');
      this.manageDocumentEventHandler('add');
    }
  }, {
    key: "registerSessionObserver",
    value: function registerSessionObserver() {
      var _this3 = this;
      if (!this.adSession) {
        throw new Error('you should have a valid session created');
      }
      this.adSession.registerSessionObserver(function (event) {
        logger_utils.debug(_this3.name, 'registerSessionObserver', "Received a ".concat(event.type, " on adSession"));
        switch (event.type) {
          case 'sessionStart':
            {
              var sessionClient = _this3.getSessionClient();
              var vastProperties = new sessionClient.VastProperties(false, null, true, lodash_default().get(_this3.config, 'slot.type', 'preroll'));
              _this3.adEvents.loaded(vastProperties);
              _this3.adEvents.impressionOccurred();
              break;
            }
          case 'sessionError':
            {
              logger_utils.error(_this3.name, 'registerSessionObserver', "Received an ".concat(event.type, " on adSession"));
              _this3.releaseAd();
              break;
            }
          case 'sessionFinish':
            {
              break;
            }
        }
      });
    }
  }, {
    key: "manageDocumentEventHandler",
    value: function manageDocumentEventHandler() {
      var _this4 = this;
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'remove';
      if (!this.adSession || !this.adEvents || !this.mediaEvents) {
        return;
      }
      var method = "".concat(type, "EventListener");
      lodash_default().forEach(DOCUMENT_LISTENED_EVENTS, function (event) {
        var runEvent = event;
        if (lodash_default().includes([MS_FULLSCREEN_CHANGE, MOZ_FULLSCREEN_CHANGE, WEBKIT_FULLSCREEN_CHANGE], event)) {
          runEvent = FULLSCREEN_CHANGE;
        }
        var handler = _this4.eventHandlers[runEvent];
        if (!handler) {
          return;
        }
        logger_utils.debug(_this4.name, method, "Document ".concat(method, " for event <").concat(event, ">"));
        document[method](event, handler);
      });
    }
  }, {
    key: "manageWindowEventHandler",
    value: function manageWindowEventHandler() {
      var _this5 = this;
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'remove';
      if (!this.adSession || !this.adEvents || !this.mediaEvents) {
        return;
      }
      var method = "".concat(type, "EventListener");
      lodash_default().forEach(WINDOW_LISTENED_EVENTS, function (event) {
        var handler = _this5.eventHandlers[event];
        if (!handler) {
          return;
        }
        logger_utils.debug(_this5.name, method, "Window ".concat(method, " for event <").concat(event, ">"));
        window[method](event, handler);
      });
    }
  }, {
    key: "manageVideoElementEventHandler",
    value: function manageVideoElementEventHandler() {
      var _this6 = this;
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'remove';
      if (!this.adSession || !this.adEvents || !this.mediaEvents) {
        return;
      }
      var method = "".concat(type, "EventListener");
      lodash_default().forEach(VIDEO_LISTENED_EVENTS, function (event) {
        var handler = _this6.eventHandlers[event];
        if (!handler) {
          return;
        }
        logger_utils.debug(_this6.name, method, "Video element ".concat(method, " for event <").concat(event, ">"));
        _this6.config.video[method](event, handler);
      });
    }
  }, {
    key: "releaseAdConf",
    value: function releaseAdConf() {
      this.config = om_tracking_objectSpread(om_tracking_objectSpread({}, this.config), {}, {
        active: false,
        ad: {
          verifications: []
        }
      });
    }
  }, {
    key: "releaseAd",
    value: function releaseAd() {
      if (this.adSession) {
        this.adSession.finish();
      }
      this.manageWindowEventHandler('remove');
      this.manageDocumentEventHandler('remove');
      this.manageVideoElementEventHandler('remove');
      this.releaseAdConf();
      this.adSession = null;
      this.adEvents = null;
      this.mediaEvents = null;
    }
  }, {
    key: "timeoutRemoveIFrames",
    value: function timeoutRemoveIFrames() {
      var _this7 = this;
      logger_utils.debug(this.name, 'timeoutRemoveIFrames');
      setTimeout(function () {
        _this7.removeIFrames();
      }, CLEAR_DELAY_TRACKING_IFRAME);
    }
  }, {
    key: "removeIFrames",
    value: function removeIFrames() {
      logger_utils.debug(this.name, 'removeIFrames');
      var iframes = Array.from(document.querySelectorAll('iframe')).filter(function (_ref) {
        var id = _ref.id;
        return id.includes('omid-verification-script');
      });
      iframes.forEach(function (iframe) {
        return iframe.remove();
      });
    }
  }, {
    key: "track",
    value: function track(target, event) {
      if (!CLEANUP_EVENTS.includes(event) && (!this.config.active || !this.getSessionClient())) {
        return;
      }
      var handler = this.handlers[event];
      if (!handler) {
        return;
      }
      logger_utils.debug(this.name, 'track', "Tracking event <".concat(event, ">"));
      if ((!this.adEvents || !this.mediaEvents) && !NO_SESSION_EVENTS.includes(event)) {
        throw new Error('You should trigger AD_INIT event before triggering other event');
      }
      handler(target);
    }
  }]);
  return OmTracking;
}(Tracking);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+ad-engine@5.29.4_@bedrock+html5-engine@3.6.8_@bedrock+media-engine@4.13.0__@bedrock+media-engine@4.13.0/node_modules/@bedrock/ad-engine/lib/tracking/thirdparties.tracking.js






function thirdparties_tracking_createSuper(t) { var r = thirdparties_tracking_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function thirdparties_tracking_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (thirdparties_tracking_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }


var ThirdPartiesTracking = function (_Tracking) {
  (0,inherits/* default */.Z)(ThirdPartiesTracking, _Tracking);
  var _super = thirdparties_tracking_createSuper(ThirdPartiesTracking);
  function ThirdPartiesTracking(debug) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, ThirdPartiesTracking);
    _this = _super.call(this);
    _this.name = 'ThirdPartiesTracking';
    _this.debug = false;
    _this.enabled = false;
    _this.sendEvent = null;
    _this.debug = debug;
    logger_utils.debug(_this.name, 'constructor', "Is debug mode activated : ".concat(_this.debug));
    return _this;
  }
  (0,createClass/* default */.Z)(ThirdPartiesTracking, [{
    key: "setEventSender",
    value: function setEventSender(sendEvent) {
      if (!sendEvent) {
        return;
      }
      this.sendEvent = sendEvent;
      this.enabled = true;
    }
  }, {
    key: "track",
    value: function track(target, event) {
      logger_utils.debug(this.name, 'track', "Tracking event <".concat(event, ">"), target);
      if (this.enabled) {
        var _this$config$ad, _this$config$ad2, _this$config$slot;
        this.sendEvent({
          adId: (_this$config$ad = this.config.ad) === null || _this$config$ad === void 0 ? void 0 : _this$config$ad.id,
          adTitle: (_this$config$ad2 = this.config.ad) === null || _this$config$ad2 === void 0 ? void 0 : _this$config$ad2.title,
          breakType: (_this$config$slot = this.config.slot) === null || _this$config$slot === void 0 ? void 0 : _this$config$slot.type,
          event: event
        });
      }
    }
  }]);
  return ThirdPartiesTracking;
}(Tracking);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+ad-engine@5.29.4_@bedrock+html5-engine@3.6.8_@bedrock+media-engine@4.13.0__@bedrock+media-engine@4.13.0/node_modules/@bedrock/ad-engine/lib/tracking/tracking.manager.js


















var trackings = [PixelTracking, OmTracking, ThirdPartiesTracking];
var MAPPING_EVENTS = {
  fullscreen: ['fullscreen', 'expand'],
  exitFullscreen: ['exitFullscreen', 'collapse']
};
var TrackingManager = function () {
  function TrackingManager() {
    var debug = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var items = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : trackings;
    var sendEvent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    (0,classCallCheck/* default */.Z)(this, TrackingManager);
    this.trackings = items.map(function (Tracking) {
      var trackingService = new Tracking(debug);
      if (trackingService.name === 'ThirdPartiesTracking') {
        trackingService.setEventSender(sendEvent);
      }
      return trackingService;
    });
  }
  (0,createClass/* default */.Z)(TrackingManager, [{
    key: "configure",
    value: function () {
      var _configure = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(config) {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Promise.all(this.trackings.map(function (tracking) {
                return tracking.configure(config);
              }));
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function configure(_x) {
        return _configure.apply(this, arguments);
      }
      return configure;
    }()
  }, {
    key: "track",
    value: function () {
      var _track = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee5(target, event) {
        var _len,
          args,
          _key,
          _args5 = arguments;
        return regenerator_default().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              for (_len = _args5.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
                args[_key - 2] = _args5[_key];
              }
              _context5.next = 3;
              return Promise.all(this.trackings.map(function () {
                var _ref = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee4(tracking) {
                  return regenerator_default().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        _context4.prev = 0;
                        if (!(MAPPING_EVENTS.fullscreen.indexOf(event) >= 0)) {
                          _context4.next = 5;
                          break;
                        }
                        MAPPING_EVENTS.fullscreen.forEach(function () {
                          var _ref2 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2(mappedEvent) {
                            return regenerator_default().wrap(function _callee2$(_context2) {
                              while (1) switch (_context2.prev = _context2.next) {
                                case 0:
                                  _context2.next = 2;
                                  return tracking.track.apply(tracking, [target, mappedEvent].concat(args));
                                case 2:
                                  return _context2.abrupt("return", _context2.sent);
                                case 3:
                                case "end":
                                  return _context2.stop();
                              }
                            }, _callee2);
                          }));
                          return function (_x5) {
                            return _ref2.apply(this, arguments);
                          };
                        }());
                        _context4.next = 11;
                        break;
                      case 5:
                        if (!(MAPPING_EVENTS.exitFullscreen.indexOf(event) >= 0)) {
                          _context4.next = 9;
                          break;
                        }
                        MAPPING_EVENTS.exitFullscreen.forEach(function () {
                          var _ref3 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee3(mappedEvent) {
                            return regenerator_default().wrap(function _callee3$(_context3) {
                              while (1) switch (_context3.prev = _context3.next) {
                                case 0:
                                  _context3.next = 2;
                                  return tracking.track.apply(tracking, [target, mappedEvent].concat(args));
                                case 2:
                                  return _context3.abrupt("return", _context3.sent);
                                case 3:
                                case "end":
                                  return _context3.stop();
                              }
                            }, _callee3);
                          }));
                          return function (_x6) {
                            return _ref3.apply(this, arguments);
                          };
                        }());
                        _context4.next = 11;
                        break;
                      case 9:
                        _context4.next = 11;
                        return tracking.track.apply(tracking, [target, event].concat(args));
                      case 11:
                        _context4.next = 16;
                        break;
                      case 13:
                        _context4.prev = 13;
                        _context4.t0 = _context4["catch"](0);
                        logger_utils.warn('TrackingManager', "".concat(tracking.name, "@track"), _context4.t0);
                      case 16:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4, null, [[0, 13]]);
                }));
                return function (_x4) {
                  return _ref.apply(this, arguments);
                };
              }()));
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function track(_x2, _x3) {
        return _track.apply(this, arguments);
      }
      return track;
    }()
  }]);
  return TrackingManager;
}();
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+ad-engine@5.29.4_@bedrock+html5-engine@3.6.8_@bedrock+media-engine@4.13.0__@bedrock+media-engine@4.13.0/node_modules/@bedrock/ad-engine/lib/bridges/ad.engine.events.js
var adEvents = {
  REQUEST_COMPLETE: 'REQUEST_COMPLETE',
  SLOT_ENDED: 'SLOT_ENDED',
  SLOT_START: 'SLOT_START',
  ENGINE_ERROR: 'ENGINE_ERROR',
  ERROR_NO_RENDERER: 'ERROR_NO_RENDERER',
  ERROR_PARSE_VAST: 'ERROR_PARSE_VAST',
  ERROR_TIMEOUT: 'ERROR_TIMEOUT',
  AD_ERROR: 'AD_ERROR',
  NO_DURATION_IN_CREATIVE: 'NO_DURATION_IN_CREATIVE',
  AD_INIT: 'AdInit',
  AD_STARTED: 'AdStarted',
  AD_VIDEO_START: 'AdVideoStart',
  AD_STOPPED: 'AdStopped',
  AD_SKIPPED: 'AdSkipped',
  AD_LOADED: 'AdLoaded',
  AD_LINEAR_CHANGE: 'AdLinearChange',
  AD_SIZE_CHANGE: 'AdSizeChange',
  AD_EXPANDED_CHANGE: 'AdExpandedChange',
  AD_DURATION_CHANGE: 'AdDurationChange',
  AD_VOLUME_CHANGE: 'AdVolumeChange',
  AD_IMPRESSION: 'AdImpression',
  AD_CLICK_THRU: 'AdClickThru',
  AD_VIDEO_FIRST_QUARTILE: 'AdVideoFirstQuartile',
  AD_VIDEO_MIDPOINT: 'AdVideoMidpoint',
  AD_VIDEO_THIRD_QUARTILE: 'AdVideoThirdQuartile',
  AD_VIDEO_COMPLETE: 'AdVideoComplete',
  AD_USER_ACCEPT_INVITATION: 'AdUserAcceptInvitation',
  AD_USER_MINIMIZE: 'AdUserMinimize',
  AD_USER_CLOSE: 'AdUserClose',
  AD_PAUSED: 'AdPaused',
  AD_PLAYING: 'AdPlaying',
  AD_LOG: 'AdLog'
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+ad-engine@5.29.4_@bedrock+html5-engine@3.6.8_@bedrock+media-engine@4.13.0__@bedrock+media-engine@4.13.0/node_modules/@bedrock/ad-engine/lib/bridges/ad.types.js
var PREROLL = 'preroll';
var MIDROLL = 'midroll';
var POSTROLL = 'postroll';
var DISPLAY = 'display';
var OVERLAY = 'overlay';
var DAI = 'dai';
var SPONSOR = 'sponsor';
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+ad-engine@5.29.4_@bedrock+html5-engine@3.6.8_@bedrock+media-engine@4.13.0__@bedrock+media-engine@4.13.0/node_modules/@bedrock/ad-engine/lib/utils/reference.utils.js




var uniqueReference = function uniqueReference() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
      v = c == 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+ad-engine@5.29.4_@bedrock+html5-engine@3.6.8_@bedrock+media-engine@4.13.0__@bedrock+media-engine@4.13.0/node_modules/@bedrock/ad-engine/lib/bridges/utils/slots.manager.js











function slots_manager_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function slots_manager_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? slots_manager_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : slots_manager_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






var getSlotType = function getSlotType(slot) {
  if (slot.type === OVERLAY) {
    return SlotType.OVERLAY;
  }
  if (slot.type === SlotType.LBANNER) {
    return slot.type;
  }
  return slot.cuePoint === 0 ? SlotType.PREROLL : SlotType.MIDROLL;
};
var SLOT_ERRORS;
(function (SLOT_ERRORS) {
  SLOT_ERRORS["UNREFERENCED_SLOT_LOAD"] = "Slot should be referenced before being loaded";
  SLOT_ERRORS["UNKNOWN_REFERENCED_SLOT_LOAD"] = "No referenced slot found with given slot.";
  SLOT_ERRORS["EMPTY_SLOT_LOAD"] = "Slot should be given in params for loading an slot";
})(SLOT_ERRORS || (SLOT_ERRORS = {}));
var SlotsManager = function () {
  function SlotsManager() {
    (0,classCallCheck/* default */.Z)(this, SlotsManager);
    this.slots = [];
    this.inProgress = {};
  }
  (0,createClass/* default */.Z)(SlotsManager, [{
    key: "getSlots",
    value: function getSlots() {
      return this.slots;
    }
  }, {
    key: "patchSlot",
    value: function patchSlot(reference, patch) {
      var slot = this.get(reference);
      this.updateSlot(reference, lodash_default().merge({}, slot, patch));
    }
  }, {
    key: "updateSlot",
    value: function updateSlot(reference, updatedSlot) {
      this.slots = this.slots.map(function (item) {
        return item.reference === reference ? updatedSlot : item;
      });
    }
  }, {
    key: "get",
    value: function get(reference) {
      return this.slots.find(function (slot) {
        return slot.reference === reference;
      });
    }
  }, {
    key: "find",
    value: function find(cuePoint, options) {
      if (options && options.preloadTime) {
        return this.slots.find(function (slot) {
          return cuePoint <= slot.cuePoint && slot.cuePoint <= cuePoint + options.preloadTime;
        });
      }
      return this.slots.find(function (slot) {
        return slot.cuePoint === cuePoint;
      });
    }
  }, {
    key: "findFirstPreviousMidroll",
    value: function findFirstPreviousMidroll(cuePoint) {
      return (0,toConsumableArray/* default */.Z)(this.slots).sort(function (slot1, slot2) {
        return slot2.cuePoint - slot1.cuePoint;
      }).find(function (slot) {
        return slot.type === SlotType.MIDROLL && slot.cuePoint <= cuePoint;
      });
    }
  }, {
    key: "findFirstNextMidroll",
    value: function findFirstNextMidroll(cuePoint) {
      return (0,toConsumableArray/* default */.Z)(this.slots).sort(function (slot1, slot2) {
        return slot1.cuePoint - slot2.cuePoint;
      }).find(function (slot) {
        return slot.type === SlotType.MIDROLL && slot.cuePoint >= cuePoint;
      });
    }
  }, {
    key: "findPending",
    value: function findPending(timeCode) {
      return this.slots.find(function (slot) {
        return slot.pending && !slot.loading && timeCode >= slot.cuePoint;
      });
    }
  }, {
    key: "updateSlots",
    value: function updateSlots(slots) {
      this.slots = slots.map(function (parsedResponseSlot) {
        return slots_manager_objectSpread(slots_manager_objectSpread({}, lodash_default().cloneDeep(parsedResponseSlot)), {}, {
          reference: uniqueReference(),
          type: getSlotType(parsedResponseSlot)
        });
      });
    }
  }, {
    key: "slotLoader",
    value: function () {
      var _slotLoader = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(slot, queryParams) {
        var loadedSlot;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!slot || slot.loaded || !slot.adTagURI)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return", slot);
            case 2:
              logger_utils.debug('SlotsManager', 'loadSlot', "Loading Slot (".concat(slot.reference, ") for cuePoint ").concat(slot.cuePoint, " /n url: ").concat(slot.adTagURI));
              _context.next = 5;
              return Parser.retrieveSlot(slot, queryParams);
            case 5:
              loadedSlot = _context.sent;
              if (loadedSlot) {
                _context.next = 10;
                break;
              }
              logger_utils.debug('SlotsManager', 'loadSlot', "Fail when loading slot (".concat(slot.reference, ") for cuePoint ").concat(slot.cuePoint, " /n url: ").concat(slot.adTagURI));
              this.patchSlot(slot.reference, {
                loaded: true,
                loadFailed: true
              });
              return _context.abrupt("return", this.get(slot.reference));
            case 10:
              loadedSlot.reference = slot.reference;
              this.updateSlot(slot.reference, loadedSlot);
              logger_utils.debug('SlotsManager', 'loadSlot', "Successfully load of Slot (".concat(slot.reference, ") for cuePoint ").concat(slot.cuePoint));
              return _context.abrupt("return", loadedSlot);
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function slotLoader(_x, _x2) {
        return _slotLoader.apply(this, arguments);
      }
      return slotLoader;
    }()
  }, {
    key: "preloadLoadSlot",
    value: function () {
      var _preloadLoadSlot = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2(cuePoint, options) {
        var slotToPreload;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              slotToPreload = this.find(cuePoint, options);
              if (!(!slotToPreload || slotToPreload.loaded)) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return");
            case 3:
              logger_utils.debug('SlotsManager', 'loadSlot', "Preloading Slot (".concat(slotToPreload.reference, ") for cuePoint ").concat(slotToPreload.cuePoint));
              _context2.next = 6;
              return this.loadSlot(slotToPreload);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function preloadLoadSlot(_x3, _x4) {
        return _preloadLoadSlot.apply(this, arguments);
      }
      return preloadLoadSlot;
    }()
  }, {
    key: "loadSlot",
    value: function () {
      var _loadSlot = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee3(slot, queryParams) {
        var lastSlotVersion, loadedSlot;
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (slot) {
                _context3.next = 2;
                break;
              }
              throw new Error(SLOT_ERRORS.EMPTY_SLOT_LOAD);
            case 2:
              if (slot.reference) {
                _context3.next = 4;
                break;
              }
              throw new Error(SLOT_ERRORS.UNREFERENCED_SLOT_LOAD);
            case 4:
              lastSlotVersion = this.get(slot.reference);
              if (lastSlotVersion) {
                _context3.next = 7;
                break;
              }
              throw new Error(SLOT_ERRORS.UNKNOWN_REFERENCED_SLOT_LOAD);
            case 7:
              if (!this.inProgress[slot.reference]) {
                this.inProgress[slot.reference] = this.slotLoader(lastSlotVersion, queryParams);
              }
              _context3.next = 10;
              return this.inProgress[slot.reference];
            case 10:
              loadedSlot = _context3.sent;
              delete this.inProgress[slot.reference];
              return _context3.abrupt("return", loadedSlot);
            case 13:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function loadSlot(_x5, _x6) {
        return _loadSlot.apply(this, arguments);
      }
      return loadSlot;
    }()
  }, {
    key: "createLoadingSlot",
    value: function createLoadingSlot(cuePoint, type) {
      var slot = slots_manager_objectSpread(slots_manager_objectSpread({}, EMPTY_SLOT), {}, {
        reference: uniqueReference(),
        cuePoint: cuePoint,
        ads: [],
        loading: true,
        pending: cuePoint !== 0,
        type: type
      });
      this.slots = [slot].concat((0,toConsumableArray/* default */.Z)(this.slots));
      return slot.reference;
    }
  }, {
    key: "loadingSuccess",
    value: function loadingSuccess(reference, patch) {
      var updatedSlot = slots_manager_objectSpread(slots_manager_objectSpread(slots_manager_objectSpread({}, this.get(reference)), lodash_default().cloneDeep(patch)), {}, {
        loading: false
      });
      this.updateSlot(reference, updatedSlot);
    }
  }]);
  return SlotsManager;
}();
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+ad-engine@5.29.4_@bedrock+html5-engine@3.6.8_@bedrock+media-engine@4.13.0__@bedrock+media-engine@4.13.0/node_modules/@bedrock/ad-engine/lib/renderers/renderer.js






function renderer_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function renderer_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? renderer_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : renderer_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


var renderer_Renderer = function () {
  function Renderer(ref, dispatcher) {
    var _this = this;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    (0,classCallCheck/* default */.Z)(this, Renderer);
    this.ref = ref;
    this.options = options;
    this.firstPlayPassed = false;
    this.VideoEngine = options.VideoEngine;
    this.dispatcher = function (event) {
      logger_utils.debug('Renderer', 'dispatcher', event);
      _this.tracking(event);
      return dispatcher(renderer_objectSpread(renderer_objectSpread({}, event), {}, {
        target: _this.creative
      }));
    };
  }
  (0,createClass/* default */.Z)(Renderer, [{
    key: "track",
    value: function track() {
      var tracking = this.options.tracking;
      if (tracking) {
        tracking.track.apply(tracking, arguments);
      }
    }
  }, {
    key: "play",
    value: function play() {}
  }, {
    key: "pause",
    value: function pause() {}
  }, {
    key: "setVolume",
    value: function setVolume(volume) {
      this.options.volume = volume;
    }
  }, {
    key: "getResource",
    value: function getResource() {}
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {}
  }, {
    key: "getDuration",
    value: function getDuration() {}
  }, {
    key: "resize",
    value: function resize(fullscreen) {
      if (this.creative) {
        if (this.creative.fullscreen !== fullscreen) {
          if (fullscreen) {
            this.track(this.creative, 'fullscreen');
          } else {
            this.track(this.creative, 'exitFullscreen');
          }
        }
        this.creative.fullscreen = fullscreen;
      }
    }
  }, {
    key: "setSource",
    value: function setSource() {}
  }, {
    key: "cleanRenderer",
    value: function cleanRenderer() {
      this.creative = null;
    }
  }, {
    key: "stop",
    value: function stop() {}
  }, {
    key: "trackStop",
    value: function trackStop() {
      if (this.creative && !this.creative.completed) {
        this.track(this.creative, 'stop');
      }
    }
  }, {
    key: "release",
    value: function () {
      var _release = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee() {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.trackStop();
              this.stop();
              this.cleanRenderer();
              this.ref = null;
              logger_utils.debug('Renderer', 'release', "The renderer is now released");
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function release() {
        return _release.apply(this, arguments);
      }
      return release;
    }()
  }, {
    key: "reset",
    value: function () {
      var _reset = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2() {
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.trackStop();
              this.cleanRenderer();
              this.firstPlayPassed = false;
              logger_utils.debug('Renderer', 'reset', "The renderer is now reset");
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function reset() {
        return _reset.apply(this, arguments);
      }
      return reset;
    }()
  }, {
    key: "load",
    value: function load(creative) {
      this.creative = creative;
      this.setSource(this.creative.currentAsset);
    }
  }, {
    key: "interactionMade",
    value: function interactionMade() {
      if (this.creative) {
        this.track(this.creative, 'click');
      }
    }
  }, {
    key: "skip",
    value: function skip() {
      if (this.creative) {
        this.dispatcher({
          type: adEvents.AD_SKIPPED
        });
      }
    }
  }, {
    key: "tracking",
    value: function tracking(event) {
      switch (event.type) {
        case adEvents.AD_STARTED:
          this.track(this.creative, 'creativeView');
          this.firstPlayPassed = true;
          break;
        case adEvents.AD_PLAYING:
          if (this.firstPlayPassed) {
            this.track(this.creative, 'resume');
          }
          this.firstPlayPassed = true;
          break;
        case adEvents.AD_PAUSED:
          this.track(this.creative, 'pause');
          break;
        case adEvents.AD_STOPPED:
          this.track(this.creative, 'stop');
          break;
        case adEvents.AD_VOLUME_CHANGE:
          if (event.muted && !this.creative.muted) {
            this.creative.muted = true;
            this.track(this.creative, 'mute');
          } else if (this.creative.muted) {
            this.creative.muted = false;
            this.track(this.creative, 'unmute');
          }
          break;
        case adEvents.AD_VIDEO_START:
          this.track(this.creative, 'start');
          this.firstPlayPassed = true;
          break;
        case adEvents.AD_VIDEO_FIRST_QUARTILE:
          this.track(this.creative, 'firstQuartile');
          break;
        case adEvents.AD_VIDEO_MIDPOINT:
          this.track(this.creative, 'midpoint');
          break;
        case adEvents.AD_VIDEO_THIRD_QUARTILE:
          this.track(this.creative, 'thirdQuartile');
          break;
        case adEvents.AD_VIDEO_COMPLETE:
          this.track(this.creative, 'complete');
          break;
        case adEvents.AD_USER_ACCEPT_INVITATION:
          this.track(this.creative, 'acceptInvitation');
          break;
        case adEvents.AD_USER_MINIMIZE:
          this.track(this.creative, 'collapse');
          break;
        case adEvents.AD_USER_CLOSE:
          this.track(this.creative, 'close');
          break;
        case adEvents.AD_LOADED:
          this.track(this.creative, 'adLoaded');
          break;
        case adEvents.AD_SKIPPED:
          this.track(this.creative, 'skip');
          break;
        default:
          break;
      }
    }
  }]);
  return Renderer;
}();
/* harmony default export */ const renderer = (renderer_Renderer);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+ad-engine@5.29.4_@bedrock+html5-engine@3.6.8_@bedrock+media-engine@4.13.0__@bedrock+media-engine@4.13.0/node_modules/@bedrock/ad-engine/lib/utils/promise.utils.js






var timedOutPromise = function timedOutPromise(promise, time) {
  var timeOutError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Error('timeout');
  var timeoutId;
  return Promise.race([promise, new Promise(function (_, reject) {
    return timeoutId = setTimeout(function () {
      return reject(timeOutError);
    }, time);
  })]).finally(function () {
    return clearTimeout(timeoutId);
  });
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+ad-engine@5.29.4_@bedrock+html5-engine@3.6.8_@bedrock+media-engine@4.13.0__@bedrock+media-engine@4.13.0/node_modules/@bedrock/ad-engine/lib/renderers/video.renderer.js













function video_renderer_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function video_renderer_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? video_renderer_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : video_renderer_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function video_renderer_createSuper(t) { var r = video_renderer_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function video_renderer_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (video_renderer_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }





var AD_PLAY_TIMEOUT_MS = 10000;
var getDefaultQuartiles = function getDefaultQuartiles() {
  return {
    first: false,
    mid: false,
    third: false
  };
};
var VideoRenderer = function (_Renderer) {
  (0,inherits/* default */.Z)(VideoRenderer, _Renderer);
  var _super = video_renderer_createSuper(VideoRenderer);
  function VideoRenderer() {
    var _this;
    (0,classCallCheck/* default */.Z)(this, VideoRenderer);
    _this = _super.apply(this, arguments);
    _this.eventHandler = function () {
      var _ref = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(event) {
        var target,
          position,
          _args = arguments;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              target = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              _context.t0 = event;
              _context.next = _context.t0 === LOAD_START ? 4 : _context.t0 === TIME_UPDATE ? 15 : _context.t0 === ERROR ? 30 : _context.t0 === CAN_PLAY ? 32 : _context.t0 === PAUSE ? 35 : _context.t0 === PLAYING ? 37 : _context.t0 === DURATION_CHANGE ? 40 : _context.t0 === VOLUME_CHANGE ? 42 : _context.t0 === ENDED ? 44 : 46;
              break;
            case 4:
              if (!_this.ref.autoplay) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return");
            case 6:
              _context.prev = 6;
              _context.next = 9;
              return timedOutPromise(Promise.resolve(_this.play()), AD_PLAY_TIMEOUT_MS);
            case 9:
              _context.next = 14;
              break;
            case 11:
              _context.prev = 11;
              _context.t1 = _context["catch"](6);
              _this.dispatcher({
                type: adEvents.AD_ERROR,
                error: {
                  module: 'Video Renderer',
                  fatal: true,
                  code: 400
                }
              });
            case 14:
              return _context.abrupt("break", 47);
            case 15:
              position = parseFloat((_this.engine.getCurrentTime() / _this.engine.getDuration()).toFixed(2));
              _context.t2 = true;
              _context.next = _context.t2 === (position >= 0.25 && !_this.quartiles.first) ? 19 : _context.t2 === (position >= 0.5 && !_this.quartiles.mid) ? 22 : _context.t2 === (position >= 0.75 && !_this.quartiles.third) ? 25 : 28;
              break;
            case 19:
              _this.quartiles.first = true;
              _this.dispatcher({
                type: adEvents.AD_VIDEO_FIRST_QUARTILE
              });
              return _context.abrupt("break", 29);
            case 22:
              _this.quartiles.mid = true;
              _this.dispatcher({
                type: adEvents.AD_VIDEO_MIDPOINT
              });
              return _context.abrupt("break", 29);
            case 25:
              _this.quartiles.third = true;
              _this.dispatcher({
                type: adEvents.AD_VIDEO_THIRD_QUARTILE
              });
              return _context.abrupt("break", 29);
            case 28:
              return _context.abrupt("break", 29);
            case 29:
              return _context.abrupt("break", 47);
            case 30:
              _this.dispatcher({
                type: adEvents.AD_ERROR,
                error: video_renderer_objectSpread(video_renderer_objectSpread({}, target.error), {}, {
                  module: 'Video Renderer',
                  fatal: true,
                  code: 400
                })
              });
              return _context.abrupt("break", 47);
            case 32:
              _this.dispatcher({
                type: adEvents.AD_LOADED
              });
              _this.engine.play();
              return _context.abrupt("break", 47);
            case 35:
              _this.dispatcher({
                type: adEvents.AD_PAUSED
              });
              return _context.abrupt("break", 47);
            case 37:
              if (!_this.firstPlayPassed) {
                _this.dispatcher({
                  type: adEvents.AD_IMPRESSION
                });
                _this.dispatcher({
                  type: adEvents.AD_STARTED
                });
                _this.dispatcher({
                  type: adEvents.AD_VIDEO_START
                });
                _this.firstPlayPassed = true;
              }
              _this.dispatcher({
                type: adEvents.AD_PLAYING
              });
              return _context.abrupt("break", 47);
            case 40:
              _this.dispatcher({
                type: adEvents.AD_DURATION_CHANGE,
                duration: _this.engine.getDuration()
              });
              return _context.abrupt("break", 47);
            case 42:
              _this.dispatcher({
                type: adEvents.AD_VOLUME_CHANGE,
                volume: _this.engine.getVolume(),
                muted: _this.engine.isMuted()
              });
              return _context.abrupt("break", 47);
            case 44:
              _this.dispatcher({
                type: adEvents.AD_VIDEO_COMPLETE
              });
              return _context.abrupt("break", 47);
            case 46:
              return _context.abrupt("break", 47);
            case 47:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[6, 11]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
    return _this;
  }
  (0,createClass/* default */.Z)(VideoRenderer, [{
    key: "setSource",
    value: function () {
      var _setSource = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2(asset) {
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.quartiles = getDefaultQuartiles();
              if (this.engine) {
                _context2.next = 8;
                break;
              }
              this.engine = new this.VideoEngine();
              this.engine.configure({
                dispatcher: this.eventHandler,
                streaming: {
                  retry: {
                    max: 0
                  }
                }
              });
              _context2.next = 6;
              return this.engine.init(this.ref);
            case 6:
              this.engine.setEventListeners();
              this.engine.setVolume(this.options.volume);
            case 8:
              this.engine.setSource(asset);
              if (!this.ref.autoplay) {
                _context2.next = 11;
                break;
              }
              return _context2.abrupt("return");
            case 11:
              _context2.prev = 11;
              _context2.next = 14;
              return timedOutPromise(Promise.resolve(this.engine.play()), AD_PLAY_TIMEOUT_MS);
            case 14:
              _context2.next = 19;
              break;
            case 16:
              _context2.prev = 16;
              _context2.t0 = _context2["catch"](11);
              this.dispatcher({
                type: adEvents.AD_ERROR,
                error: {
                  module: 'Video Renderer',
                  fatal: true,
                  code: 400
                }
              });
            case 19:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[11, 16]]);
      }));
      function setSource(_x2) {
        return _setSource.apply(this, arguments);
      }
      return setSource;
    }()
  }, {
    key: "stop",
    value: function stop() {
      if (this.creative) {
        this.dispatcher({
          type: adEvents.AD_STOPPED
        });
      }
    }
  }, {
    key: "release",
    value: function () {
      var _release = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee3() {
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.engine.release();
            case 2:
              (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(VideoRenderer.prototype), "release", this).call(this);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function release() {
        return _release.apply(this, arguments);
      }
      return release;
    }()
  }, {
    key: "reset",
    value: function () {
      var _reset = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee4() {
        return regenerator_default().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.quartiles = getDefaultQuartiles();
              _context4.prev = 1;
              _context4.next = 4;
              return this.engine.reset();
            case 4:
              _context4.next = 9;
              break;
            case 6:
              _context4.prev = 6;
              _context4.t0 = _context4["catch"](1);
              logger_utils.error('VideoRenderer', 'Failed to reset video engine', _context4.t0);
            case 9:
              (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(VideoRenderer.prototype), "reset", this).call(this);
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[1, 6]]);
      }));
      function reset() {
        return _reset.apply(this, arguments);
      }
      return reset;
    }()
  }, {
    key: "isPaused",
    value: function isPaused() {
      if (this.engine) {
        return this.engine.isPaused();
      }
      return true;
    }
  }, {
    key: "play",
    value: function play() {
      if (this.engine) {
        this.engine.play();
      }
    }
  }, {
    key: "pause",
    value: function pause() {
      if (this.engine) {
        this.engine.pause();
      }
    }
  }, {
    key: "setVolume",
    value: function setVolume(volume) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(VideoRenderer.prototype), "setVolume", this).call(this, volume);
      if (this.engine) {
        this.engine.setVolume(volume);
      }
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      if (this.engine) {
        return this.engine.getCurrentTime();
      }
      return 0;
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      if (this.engine) {
        return this.engine.getDuration();
      }
      return undefined;
    }
  }, {
    key: "getAudioEnabled",
    value: function getAudioEnabled() {
      if (this.ref) {
        return this.ref.volume !== 0 && !this.ref.muted;
      }
    }
  }, {
    key: "getResource",
    value: function getResource() {
      if (this.ref) {
        return this.ref.src;
      }
      return undefined;
    }
  }]);
  return VideoRenderer;
}(renderer);
/* harmony default export */ const video_renderer = (VideoRenderer);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+ad-engine@5.29.4_@bedrock+html5-engine@3.6.8_@bedrock+media-engine@4.13.0__@bedrock+media-engine@4.13.0/node_modules/@bedrock/ad-engine/lib/renderers/vpaid.renderer.js















function vpaid_renderer_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function vpaid_renderer_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? vpaid_renderer_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : vpaid_renderer_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function vpaid_renderer_createSuper(t) { var r = vpaid_renderer_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function vpaid_renderer_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (vpaid_renderer_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }




var vpaid_renderer_ucfirst = function ucfirst(string) {
  return "".concat(string.charAt(0).toUpperCase()).concat(string.substr(1));
};
var getDefaultOptions = function getDefaultOptions() {
  return {
    creativeData: {
      AdParameters: null
    },
    desiredBitrate: 635,
    volume: 0.5,
    timeouts: {
      vpaidAvailability: 8000,
      vpaidAvailabilityInterval: 100,
      vpaidStarted: 5000,
      vpaidLoaded: 5000,
      vpaidStopped: 5000
    }
  };
};
var VPAIDRenderer = function (_Renderer) {
  (0,inherits/* default */.Z)(VPAIDRenderer, _Renderer);
  var _super = vpaid_renderer_createSuper(VPAIDRenderer);
  function VPAIDRenderer(ref, dispatcher) {
    var _this;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    (0,classCallCheck/* default */.Z)(this, VPAIDRenderer);
    _this = _super.call(this, ref, dispatcher, options);
    _this.setUp = function () {
      _this.vpaid = _this.getVPAIDAd();
      if (!_this.vpaid) {
        logger_utils.warn('VPAID Renderer', 'setUp', "VPAID is still unavailable, waiting again for ".concat(_this.options.timeouts.vpaidAvailabilityInterval, "ms"));
        clearTimeout(_this.getVpaidAdTimeout);
        _this.getVpaidAdTimeout = setTimeout(_this.setUp, _this.options.timeouts.vpaidAvailabilityInterval);
        return;
      }
      logger_utils.debug('VPAID Renderer', 'setUp', 'VPAID is available, proceeding', _this.vpaid);
      clearTimeout(_this.getVpaidAdTimeout);
      lodash_default().forOwn(adEvents, function (adEvent) {
        _this.vpaid.subscribe(_this.getEventHandler(adEvent), adEvent);
      });
      logger_utils.debug('VPAID Renderer', 'setUp', 'Initiating the VPAID');
      clearTimeout(_this.vpaidLoadedTimeout);
      _this.vpaidLoadedTimeout = setTimeout(function () {
        logger_utils.error('VPAID Renderer', 'setUp', 'VPAID has not been loaded in the time given');
        _this.dispatcher({
          type: adEvents.AD_ERROR,
          error: {
            message: 'VPAID Loaded Timeout',
            module: 'VPAIDRenderer',
            fatal: true,
            code: 402
          }
        });
      }, _this.options.timeouts.vpaidLoaded);
      _this.vpaid.initAd(_this.ref.offsetWidth, _this.ref.offsetHeight, 'normal', _this.options.desiredBitrate, _this.options.creativeData, _this.options.environmentVars);
    };
    _this.onAdLoaded = function (event) {
      _this.vpaidLoadedTimeout = clearTimeout(_this.vpaidLoadedTimeout);
      logger_utils.debug('VPAID Renderer', 'onAdLoaded', 'VPAID is loaded and ready to play');
      _this.dispatcher(vpaid_renderer_objectSpread(vpaid_renderer_objectSpread({}, event), {}, {
        type: adEvents.AD_LOADED
      }));
      _this.play();
    };
    _this.onAdStarted = function (event) {
      _this.vpaidStartedTimeout = clearTimeout(_this.vpaidStartedTimeout);
      _this.paused = false;
      _this.dispatcher(vpaid_renderer_objectSpread(vpaid_renderer_objectSpread({}, event), {}, {
        type: adEvents.AD_STARTED
      }));
    };
    _this.onAdError = function (event) {
      _this.clean();
      var code = 900;
      var message = '';
      if (typeof event === 'string') {
        var matches = event.match(/AdError ([0-9]+) \((.+)\)/);
        if (matches && matches.length) {
          var _matches = (0,slicedToArray/* default */.Z)(matches, 3);
          code = _matches[1];
          message = _matches[2];
          code = parseInt(code, 10);
        }
      }
      _this.dispatcher({
        type: adEvents.AD_ERROR,
        error: vpaid_renderer_objectSpread(vpaid_renderer_objectSpread(vpaid_renderer_objectSpread({
          message: message,
          code: code
        }, lodash_default().get(event, 'error', {})), lodash_default().get(event, {})), {}, {
          module: 'VPAID Renderer',
          fatal: true
        })
      });
    };
    _this.onAdClickThru = function (url) {
      _this.dispatcher({
        url: url,
        type: adEvents.AD_CLICK_THRU
      });
    };
    _this.onAdStopped = function () {
      _this.dispatcher({
        type: adEvents.AD_STOPPED
      });
      _this.clean();
    };
    _this.onAdPlaying = function () {
      _this.paused = false;
      _this.dispatcher({
        type: adEvents.AD_PLAYING
      });
    };
    _this.onAdPaused = function () {
      _this.paused = true;
      _this.dispatcher({
        type: adEvents.AD_PAUSED
      });
    };
    _this.onAdVideoComplete = function () {
      if (_this.creative) {
        _this.dispatcher({
          type: adEvents.AD_VIDEO_COMPLETE
        });
      }
    };
    _this.iframeRef = null;
    _this.getVpaidAdTimeout = null;
    _this.vpaidStartedTimeout = null;
    _this.vpaidAvailabilityTimeout = null;
    _this.vpaidLoadedTimeout = null;
    _this.vpaid = null;
    _this.paused = true;
    _this.src = null;
    _this.options = lodash_default().merge(getDefaultOptions(), options);
    _this.options.environmentVars = {
      slot: _this.ref,
      videoSlot: _this.ref.querySelector('video'),
      videoSlotCanAutoPlay: true
    };
    logger_utils.debug('VPAID Renderer', 'constructor', 'VPAID has been built with options', _this.options);
    return _this;
  }
  (0,createClass/* default */.Z)(VPAIDRenderer, [{
    key: "getEventHandler",
    value: function getEventHandler(rawEventName) {
      var _this2 = this;
      var eventName = lodash_default().camelCase(rawEventName).replace(/^./, function (firstLetter) {
        return firstLetter.toUpperCase();
      });
      var handlerName = "on".concat(eventName);
      if (!this[handlerName]) {
        this[handlerName] = function (event) {
          return _this2.dispatcher(vpaid_renderer_objectSpread(vpaid_renderer_objectSpread({}, event), {}, {
            type: eventName
          }));
        };
      }
      return this[handlerName];
    }
  }, {
    key: "setSource",
    value: function setSource(asset) {
      var _this3 = this;
      logger_utils.debug('VPAID Renderer', 'setSource', 'Loading source', asset);
      var creativeParameters = undefined;
      if (this.creative && this.creative.parameters) {
        creativeParameters = this.creative.parameters;
      }
      this.options = lodash_default().merge(this.options, {
        creativeData: {
          AdParameters: creativeParameters
        }
      });
      this.iframeRef = document.createElement('iframe');
      this.iframeRef.id = 'vpaidFrame';
      this.iframeRef.allowfullscreen = true;
      this.iframeRef.width = 0;
      this.iframeRef.height = 0;
      this.iframeRef.style.display = 'none';
      this.iframeRef.onload = this.setUp;
      document.body.appendChild(this.iframeRef);
      this.iframeRef.contentWindow.document.open();
      this.iframeRef.contentWindow.document.write("<body><script src=\"".concat(asset.src, "\"></script></body>"));
      this.iframeRef.contentWindow.document.close();
      logger_utils.debug('VPAID Renderer', 'setSource', 'Waiting for the VPAID to be loaded and accessible');
      clearTimeout(this.vpaidAvailabilityTimeout);
      this.vpaidAvailabilityTimeout = setTimeout(function () {
        if (!_this3.getVPAIDAd()) {
          logger_utils.error('VPAID Renderer', 'setSource', 'VPAID is in timeout zone, cleaning the renderer');
          _this3.dispatcher({
            type: adEvents.AD_ERROR,
            error: {
              message: 'VPAID Availability Timeout',
              module: 'VPAIDRenderer',
              fatal: true,
              code: 402
            }
          });
        }
      }, this.options.timeouts.vpaidAvailability);
    }
  }, {
    key: "getVPAIDAd",
    value: function getVPAIDAd() {
      var getVPAIDAd = lodash_default().get(this.iframeRef, 'contentWindow.getVPAIDAd');
      return getVPAIDAd && typeof getVPAIDAd === 'function' && getVPAIDAd();
    }
  }, {
    key: "stop",
    value: function stop() {
      try {
        if (this.vpaid) {
          clearTimeout(this.vpaidStoppedTimeout);
          this.vpaidStoppedTimeout = setTimeout(this.onAdStopped, this.options.timeouts.vpaidStopped);
          this.vpaid.stopAd();
        } else {
          this.clean();
        }
      } catch (exception) {
        logger_utils.error('VPAID Renderer', 'stop', exception);
      }
    }
  }, {
    key: "reset",
    value: function () {
      var _reset = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee() {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(VPAIDRenderer.prototype), "reset", this).call(this);
              this.options = lodash_default().merge(this.options, {
                creativeData: getDefaultOptions().creativeData
              });
              this.paused = true;
              this.src = null;
              this.clean();
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function reset() {
        return _reset.apply(this, arguments);
      }
      return reset;
    }()
  }, {
    key: "clean",
    value: function clean() {
      var _this4 = this;
      if (this.vpaid) {
        try {
          lodash_default().forOwn(adEvents, function (adEvent) {
            _this4.vpaid.unsubscribe(_this4.getEventHandler(adEvent), adEvent);
          });
        } catch (exception) {
          logger_utils.error('VPAID Renderer', 'clean', exception);
        }
      }
      this.getVpaidAdTimeout = clearTimeout(this.getVpaidAdTimeout);
      this.vpaidStartedTimeout = clearTimeout(this.vpaidStartedTimeout);
      this.vpaidAvailabilityTimeout = clearTimeout(this.vpaidAvailabilityTimeout);
      this.vpaidLoadedTimeout = clearTimeout(this.vpaidLoadedTimeout);
      this.vpaidStoppedTimeout = clearTimeout(this.vpaidStoppedTimeout);
      if (this.iframeRef) {
        document.body.removeChild(this.iframeRef);
      }
      this.iframeRef = null;
      this.vpaid = null;
      this.firstPlayPassed = false;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      try {
        if (this.vpaid) {
          return Math.round(this.vpaid.getAdDuration() - this.vpaid.getAdRemainingTime());
        }
      } catch (exception) {
        logger_utils.error('VPAID Renderer', 'getCurrentTime', 'There was an error trying to get the currentTime', exception);
      }
      return 0;
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      if (this.vpaid) {
        return this.vpaid.getAdDuration();
      }
    }
  }, {
    key: "getAudioEnabled",
    value: function getAudioEnabled() {
      if (this.vpaid) {
        return this.vpaid.getAdVolume() !== 0;
      }
    }
  }, {
    key: "getResource",
    value: function getResource() {
      if (this.src) {
        return this.src;
      }
    }
  }, {
    key: "isPaused",
    value: function isPaused() {
      if (this.vpaid) {
        return this.paused;
      }
      return true;
    }
  }, {
    key: "play",
    value: function play() {
      var _this5 = this;
      if (this.vpaid) {
        if (this.firstPlayPassed) {
          this.vpaid.resumeAd();
        } else {
          logger_utils.debug('VPAID Renderer', 'play', 'Starting VPAID');
          clearTimeout(this.vpaidStartedTimeout);
          this.vpaidStartedTimeout = setTimeout(function () {
            if (!_this5.vpaid) {
              logger_utils.warn('VPAID Renderer', 'stopAd', "VPAID has not started in less than ".concat(_this5.options.timeouts.vpaidStarted, "ms, and has already been clean up"));
              return;
            }
            logger_utils.warn('VPAID Renderer', 'stopAd', "VPAID has not started in less than ".concat(_this5.options.timeouts.vpaidStarted, "ms, stopping it"));
            try {
              _this5.vpaid.stopAd();
            } catch (exception) {
              logger_utils.error('VPAID Renderer', 'stopAd', 'An error occurred when trying to stop the VPAID', exception);
            }
          }, this.options.timeouts.vpaidStarted);
          this.setVolume(this.options.volume);
          this.vpaid.startAd();
        }
      }
    }
  }, {
    key: "pause",
    value: function pause() {
      if (this.vpaid) {
        this.vpaid.pauseAd();
      }
    }
  }, {
    key: "setVolume",
    value: function setVolume(volume) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(VPAIDRenderer.prototype), "setVolume", this).call(this, volume);
      if (this.vpaid) {
        this.vpaid.setAdVolume(volume);
      }
    }
  }, {
    key: "resize",
    value: function resize(fullscreen) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(VPAIDRenderer.prototype), "resize", this).call(this, fullscreen);
      if (this.vpaid) {
        this.vpaid.resizeAd(this.ref.offsetWidth, this.ref.offsetHeight, fullscreen ? 'fullscreen' : 'normal');
      }
    }
  }]);
  return VPAIDRenderer;
}(renderer);
/* harmony default export */ const vpaid_renderer = (VPAIDRenderer);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+ad-engine@5.29.4_@bedrock+html5-engine@3.6.8_@bedrock+media-engine@4.13.0__@bedrock+media-engine@4.13.0/node_modules/@bedrock/ad-engine/lib/bridges/companion.util.js
var styleCompanionImage = function styleCompanionImage(ref) {
  ref.removeAttribute('width');
  ref.removeAttribute('height');
  ref.style.position = 'absolute';
  ref.style.width = '100%';
  ref.style.height = '100%';
  ref.style['object-fit'] = 'cover';
  ref.style.left = '50%';
  ref.style.top = '50%';
  ref.style.transform = 'translate(-50%, -50%)';
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+ad-engine@5.29.4_@bedrock+html5-engine@3.6.8_@bedrock+media-engine@4.13.0__@bedrock+media-engine@4.13.0/node_modules/@bedrock/ad-engine/lib/renderers/companion.renderer.js











function companion_renderer_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function companion_renderer_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? companion_renderer_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : companion_renderer_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function companion_renderer_createSuper(t) { var r = companion_renderer_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function companion_renderer_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (companion_renderer_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }




var LISTENED_EVENTS = ['touchend', 'click'];
var CompanionRenderer = function (_Renderer) {
  (0,inherits/* default */.Z)(CompanionRenderer, _Renderer);
  var _super = companion_renderer_createSuper(CompanionRenderer);
  function CompanionRenderer() {
    var _this;
    (0,classCallCheck/* default */.Z)(this, CompanionRenderer);
    _this = _super.apply(this, arguments);
    _this.eventsHandler = function (event) {
      var clickThroughUrl = _this.creative.clickThroughUrl;
      if (clickThroughUrl) {
        event.preventDefault();
        event.stopPropagation();
        _this.dispatcher({
          type: adEvents.AD_CLICK_THRU,
          url: clickThroughUrl
        });
      }
    };
    _this.onLoad = function () {
      _this.dispatcher({
        type: adEvents.AD_LOADED
      });
    };
    return _this;
  }
  (0,createClass/* default */.Z)(CompanionRenderer, [{
    key: "setSource",
    value: function setSource(asset) {
      var _this2 = this;
      switch (asset.type) {
        case 'iframe':
          this.element = document.createElement('iframe');
          this.element.src = asset.src;
          this.element.onload = this.onLoad;
          break;
        case 'html':
          this.element = document.createElement('div');
          this.element.innerHTML = asset.src;
          break;
        case 'static':
          switch (asset.creativetype) {
            case 'image/gif':
            case 'image/jpeg':
            case 'image/png':
              this.element = document.createElement('img');
              this.element.src = asset.src;
              this.element.addEventListener('load', this.onLoad);
              styleCompanionImage(this.element);
              break;
            case 'application/javascript':
            case 'application/x-javascript':
              this.element = document.createElement('script');
              this.element.src = asset.src;
              this.element.onload = this.onLoad;
              break;
            default:
              break;
          }
          break;
        default:
          logger_utils.error('Companion Renderer', 'setSource', "".concat(asset.type, " is not a valid companion type"));
          break;
      }
      if (this.element) {
        logger_utils.debug('Companion Renderer', 'setSource', 'Appending companion element to the companions div', this.element);
        LISTENED_EVENTS.forEach(function (interaction) {
          return _this2.element.addEventListener(interaction, _this2.eventsHandler);
        });
        this.ref.appendChild(this.element);
      }
    }
  }, {
    key: "tracking",
    value: function tracking(event) {
      if (event.type === adEvents.AD_LOADED) {
        return (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(CompanionRenderer.prototype), "tracking", this).call(this, companion_renderer_objectSpread(companion_renderer_objectSpread({}, event), {}, {
          type: adEvents.AD_STARTED
        }));
      }
      return (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(CompanionRenderer.prototype), "tracking", this).call(this, event);
    }
  }, {
    key: "clearElement",
    value: function clearElement() {
      var _this3 = this;
      if (this.element) {
        LISTENED_EVENTS.forEach(function (interaction) {
          return _this3.element.removeEventListener(interaction, _this3.eventsHandler);
        });
        this.element.removeEventListener('load', this.onLoad);
        this.element.onload = null;
        this.ref.removeChild(this.element);
        this.element = null;
      }
    }
  }, {
    key: "release",
    value: function () {
      var _release = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee() {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.clearElement();
              (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(CompanionRenderer.prototype), "release", this).call(this);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function release() {
        return _release.apply(this, arguments);
      }
      return release;
    }()
  }, {
    key: "reset",
    value: function () {
      var _reset = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2() {
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.clearElement();
              (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(CompanionRenderer.prototype), "reset", this).call(this);
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function reset() {
        return _reset.apply(this, arguments);
      }
      return reset;
    }()
  }]);
  return CompanionRenderer;
}(renderer);
/* harmony default export */ const companion_renderer = (CompanionRenderer);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+ad-engine@5.29.4_@bedrock+html5-engine@3.6.8_@bedrock+media-engine@4.13.0__@bedrock+media-engine@4.13.0/node_modules/@bedrock/ad-engine/lib/renderers/nonLinear.renderer.js









function nonLinear_renderer_createSuper(t) { var r = nonLinear_renderer_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function nonLinear_renderer_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (nonLinear_renderer_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }




var nonLinear_renderer_getDefaultOptions = function getDefaultOptions() {
  return {
    timeouts: {
      nonLinearAvailability: 8
    }
  };
};
var NonLinearRenderer = function (_CompanionRenderer) {
  (0,inherits/* default */.Z)(NonLinearRenderer, _CompanionRenderer);
  var _super = nonLinear_renderer_createSuper(NonLinearRenderer);
  function NonLinearRenderer(ref, dispatcher) {
    var _this;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    (0,classCallCheck/* default */.Z)(this, NonLinearRenderer);
    _this = _super.call(this, ref, dispatcher, options);
    _this.nonLinearAvailabilityTimeout = 0;
    _this.stop = function () {
      logger_utils.debug('Non Linear Renderer', 'setSource', 'Non Linear creative is in timeout zone, cleaning the renderer');
      if (_this.nonLinearAvailabilityTimeout) {
        clearTimeout(_this.nonLinearAvailabilityTimeout);
        _this.nonLinearAvailabilityTimeout = null;
      }
      _this.onStop();
    };
    _this.onStop = function () {
      _this.dispatcher({
        type: adEvents.AD_STOPPED
      });
    };
    _this.onLoad = function () {
      _this.dispatcher({
        type: adEvents.AD_LOADED
      });
      _this.nonLinearAvailabilityTimeout = setTimeout(_this.stop, (_this.creative.duration || _this.options.timeouts.nonLinearAvailability) * 1000);
      _this.dispatcher({
        type: adEvents.AD_STARTED
      });
    };
    _this.options = lodash_default().merge(nonLinear_renderer_getDefaultOptions(), options);
    _this.nonLinearAvailabilityTimeout = null;
    return _this;
  }
  (0,createClass/* default */.Z)(NonLinearRenderer, [{
    key: "isPaused",
    value: function isPaused() {
      return true;
    }
  }, {
    key: "clear",
    value: function clear() {
      if (this.nonLinearAvailabilityTimeout) {
        clearTimeout(this.nonLinearAvailabilityTimeout);
        this.nonLinearAvailabilityTimeout = null;
      }
    }
  }, {
    key: "release",
    value: function () {
      var _release = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee() {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.clear();
              (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(NonLinearRenderer.prototype), "release", this).call(this);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function release() {
        return _release.apply(this, arguments);
      }
      return release;
    }()
  }, {
    key: "reset",
    value: function () {
      var _reset = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2() {
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.clear();
              (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(NonLinearRenderer.prototype), "reset", this).call(this);
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function reset() {
        return _reset.apply(this, arguments);
      }
      return reset;
    }()
  }]);
  return NonLinearRenderer;
}(companion_renderer);
/* harmony default export */ const nonLinear_renderer = (NonLinearRenderer);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+ad-engine@5.29.4_@bedrock+html5-engine@3.6.8_@bedrock+media-engine@4.13.0__@bedrock+media-engine@4.13.0/node_modules/@bedrock/ad-engine/lib/renderers/renderer.manager.js



















var LOG_TAG = 'Renderer Manager';
var RendererType;
(function (RendererType) {
  RendererType["VIDEO"] = "video";
  RendererType["VPAID"] = "vpaid";
  RendererType["COMPANION"] = "companion";
  RendererType["NONLINEAR"] = "nonlinear";
  RendererType["LBANNER"] = "lbanner";
})(RendererType || (RendererType = {}));
var RendererManager = function () {
  function RendererManager(_ref) {
    var display = _ref.display,
      options = _ref.options,
      trackingManager = _ref.trackingManager,
      VideoEngine = _ref.VideoEngine,
      triggerEvent = _ref.triggerEvent;
    (0,classCallCheck/* default */.Z)(this, RendererManager);
    this.renderers = {};
    this.currentRenderer = null;
    this.display = display;
    this.options = options;
    this.trackingManager = trackingManager;
    this.VideoEngine = VideoEngine;
    this.triggerEvent = triggerEvent;
  }
  (0,createClass/* default */.Z)(RendererManager, [{
    key: "configureDisplay",
    value: function configureDisplay(display) {
      var fullscreen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.display = display;
      if (this.currentRenderer) {
        this.currentRenderer.resize(fullscreen);
      }
    }
  }, {
    key: "createRenderer",
    value: function createRenderer(rendererType) {
      logger_utils.debug(LOG_TAG, 'createRenderer', "".concat(rendererType, "Renderer requested"));
      switch (rendererType) {
        case RendererType.VIDEO:
          return new video_renderer(this.display.video, this.triggerEvent, {
            volume: this.options.volume,
            VideoEngine: this.VideoEngine,
            tracking: this.trackingManager
          });
        case RendererType.VPAID:
          return new vpaid_renderer(this.display.base, this.triggerEvent, {
            volume: this.options.volume,
            desiredBitrate: this.options.desiredBitrate,
            tracking: this.trackingManager
          });
        case RendererType.COMPANION:
          return new companion_renderer(this.display.companion, this.triggerEvent, {
            tracking: this.trackingManager
          });
        case RendererType.NONLINEAR:
          return new nonLinear_renderer(this.display.base, this.triggerEvent, {
            tracking: this.trackingManager
          });
        case RendererType.LBANNER:
          return new nonLinear_renderer(this.display.lbanner || this.display.base, this.triggerEvent, {
            tracking: this.trackingManager
          });
      }
    }
  }, {
    key: "getRendererType",
    value: function getRendererType(creative) {
      var linear = creative.linear,
        id = creative.id;
      if (linear) {
        var _creative$currentAsse;
        return (creative === null || creative === void 0 ? void 0 : (_creative$currentAsse = creative.currentAsset) === null || _creative$currentAsse === void 0 ? void 0 : _creative$currentAsse.apiframework) === 'VPAID' ? RendererType.VPAID : RendererType.VIDEO;
      }
      if (id === 'contentframe') {
        return RendererType.LBANNER;
      }
      return RendererType.NONLINEAR;
    }
  }, {
    key: "getRenderer",
    value: function getRenderer(rendererType) {
      return this.renderers[rendererType];
    }
  }, {
    key: "storeRenderer",
    value: function storeRenderer(rendererType, renderer) {
      this.renderers[rendererType] = renderer;
    }
  }, {
    key: "selectCompanionRenderer",
    value: function selectCompanionRenderer() {
      var companionRenderer = this.getRenderer(RendererType.COMPANION);
      if (!companionRenderer) {
        companionRenderer = this.createRenderer(RendererType.COMPANION);
        this.storeRenderer(RendererType.COMPANION, companionRenderer);
      }
      return companionRenderer;
    }
  }, {
    key: "selectRenderer",
    value: function selectRenderer(creative) {
      var rendererType = this.getRendererType(creative);
      this.currentRenderer = this.getRenderer(rendererType);
      logger_utils.debug(LOG_TAG, 'selectRenderer', this.currentRenderer);
      if (!this.currentRenderer) {
        var renderer = this.createRenderer(rendererType);
        this.currentRenderer = renderer;
        this.storeRenderer(rendererType, renderer);
      }
    }
  }, {
    key: "load",
    value: function load(creative) {
      this.selectRenderer(creative);
      logger_utils.debug(LOG_TAG, 'load', 'Beginning linear ad playback through the renderer');
      this.currentRenderer.load(creative);
    }
  }, {
    key: "loadCompanion",
    value: function loadCompanion(creative) {
      var companionRenderer = this.selectCompanionRenderer();
      companionRenderer.load(creative);
    }
  }, {
    key: "stopRenderers",
    value: function stopRenderers() {
      logger_utils.debug(LOG_TAG, 'stopRenderers', 'Stop the renderers', this.renderers);
      Object.values(this.renderers).forEach(function (renderer) {
        return renderer.stop();
      });
    }
  }, {
    key: "resetRenderers",
    value: function () {
      var _resetRenderers = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee() {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              logger_utils.debug(LOG_TAG, 'resetRenderers', 'Reset the renderers', this.renderers);
              _context.next = 3;
              return Promise.all(Object.values(this.renderers).map(function (renderer) {
                if (renderer.creative) {
                  return renderer.reset();
                }
                return Promise.resolve();
              }));
            case 3:
              this.currentRenderer = null;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function resetRenderers() {
        return _resetRenderers.apply(this, arguments);
      }
      return resetRenderers;
    }()
  }, {
    key: "releaseRenderers",
    value: function () {
      var _releaseRenderers = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee3() {
        var _this = this;
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              logger_utils.debug(LOG_TAG, 'releaseRenderers', 'Release the renderers');
              this.currentRenderer = null;
              _context3.next = 4;
              return Promise.all(Object.keys(this.renderers).map(function () {
                var _ref2 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2(rendererType) {
                  return regenerator_default().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        _context2.next = 2;
                        return _this.renderers[rendererType].release();
                      case 2:
                        delete _this.renderers[rendererType];
                      case 3:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }()));
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function releaseRenderers() {
        return _releaseRenderers.apply(this, arguments);
      }
      return releaseRenderers;
    }()
  }, {
    key: "getActiveRenderer",
    value: function getActiveRenderer() {
      return this.currentRenderer;
    }
  }]);
  return RendererManager;
}();
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+ad-engine@5.29.4_@bedrock+html5-engine@3.6.8_@bedrock+media-engine@4.13.0__@bedrock+media-engine@4.13.0/node_modules/@bedrock/ad-engine/lib/bridges/ad.engine.js














function ad_engine_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ad_engine_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ad_engine_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ad_engine_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

















Parser.setLogger(logger_utils);
var AdEngine = function () {
  function AdEngine(options, _ref) {
    var _this = this;
    var VideoEngine = _ref.VideoEngine,
      videoRef = _ref.videoRef,
      videoBase = _ref.videoBase,
      sendEvent = _ref.sendEvent;
    (0,classCallCheck/* default */.Z)(this, AdEngine);
    this.endSlot = function (slot) {
      var completed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (slot && !slot.ended) {
        _this.triggerEvent({
          type: adEvents.SLOT_ENDED,
          slot: slot,
          completed: completed
        });
        _this.trackingManager.track(slot, 'breakEnd');
        slot.ended = true;
      }
      if (_this.currentSlot) {
        _this.currentSlot.ended = true;
        _this.currentSlot = null;
      }
      _this.formattedAds = null;
      _this.formattedBuffet = null;
      _this.playedAds = [];
    };
    this.triggerEvent = function (event) {
      lodash_default().get(_this.subscribers, event.type, []).forEach(function (listener) {
        try {
          listener(event);
        } catch (exception) {
          logger_utils.error('Ad Engine', 'triggerEvent', "Exception occurred executing listener for ".concat(event.type), exception);
        }
      });
    };
    this.subscribers = {};
    this.slotsManager = new SlotsManager();
    this.playedAds = [];
    this.display = {
      video: videoRef,
      base: videoBase
    };
    this.trackingManager = new TrackingManager(lodash_default().get(options, 'options.debug', false), undefined, sendEvent);
    this.trackingManager.configure({
      video: videoBase
    });
    this.released = false;
    this.state = {
      request: {
        pending: false,
        loaded: false
      }
    };
    this.options = lodash_default().merge({
      desiredBitrate: 3000,
      cuePoints: [],
      volume: 0.5,
      features: {
        lazy: false,
        preloadTime: 5,
        trackWithHttps: true,
        triggerSlotOnSeek: {
          enabled: false,
          preventDelayWhenFutureBreak: 300,
          seekTriggerDelay: 10000
        }
      }
    }, options);
    var threshold = this.options.contentDuration - Math.max(this.options.features.lastBreakBeforeEndDelay || 0, this.options.features.triggerSlotOnSeek.seekTriggerDelay / 1000, 0);
    this.thresholdLastBreak = Math.max(threshold, 0);
    this.triggerSlotOnSeek = this.options.features.triggerSlotOnSeek.enabled ? lodash_default().debounce(this._triggerSlotOnSeek.bind(this), this.options.features.triggerSlotOnSeek.seekTriggerDelay) : function () {};
    this.trackingManager.configure({
      video: videoBase,
      withHttps: this.options.features.trackWithHttps,
      deviceCategory: this.options.deviceCategory || 'desktop',
      sendEvent: this.options.sendEvent
    });
    this.VideoEngine = VideoEngine;
    this.rendererManager = new RendererManager({
      display: this.display,
      options: this.options,
      trackingManager: this.trackingManager,
      VideoEngine: this.VideoEngine,
      triggerEvent: this.triggerEvent
    });
    logger_utils.debug('Ad Engine', 'constructor', 'AdEngine has been built with options', this.options);
    this.addEventListener(adEvents.AD_IMPRESSION, function () {
      return _this.trackingManager.track(_this.currentAd, 'impression');
    });
    this.addEventListener(adEvents.AD_ERROR, function (_ref2) {
      var _ref2$error = _ref2.error,
        code = _ref2$error.code,
        fatal = _ref2$error.fatal;
      _this.trackingManager.track(_this.currentAd, 'error', {
        ERRORCODE: code || 900,
        ASSETURI: lodash_default().get(_this.getActiveCreative(), 'currentAsset.src', ''),
        CONTENTPLAYHEAD: _this.getCurrentTime()
      });
      if (fatal) {
        setTimeout(function () {
          return _this.playNextAd(true);
        }, 0);
      }
    });
    this.addEventListener(adEvents.AD_SKIPPED, function () {
      return _this.playNextAd();
    });
    this.addEventListener(adEvents.AD_VIDEO_COMPLETE, function () {
      _this.getActiveCreative().completed = true;
      _this.rendererManager.stopRenderers();
    });
    this.addEventListener(adEvents.AD_STOPPED, (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.trackingManager.track(_this.currentAd, 'impressionEnd');
            setTimeout(function () {
              return _this.playNextAd();
            }, 0);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
  }
  (0,createClass/* default */.Z)(AdEngine, [{
    key: "_triggerSlotOnSeek",
    value: function _triggerSlotOnSeek(cuePoint, options) {
      var previousSlot = this.slotsManager.findFirstPreviousMidroll(cuePoint);
      var nextSlot = this.slotsManager.findFirstNextMidroll(cuePoint);
      if (this.currentSlot) {
        return;
      }
      if (nextSlot && !nextSlot.ended && nextSlot.cuePoint - cuePoint <= this.options.features.triggerSlotOnSeek.preventDelayWhenFutureBreak) {
        return;
      }
      if (previousSlot && !previousSlot.ended) {
        this.playSlot(previousSlot, ad_engine_objectSpread(ad_engine_objectSpread({}, options), {}, {
          triggerTime: cuePoint
        }));
      }
    }
  }, {
    key: "onCuePointUpdate",
    value: function () {
      var _onCuePointUpdate = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2(cuePoint) {
        var _this$options, _this$options$feature;
        var preloadTime;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              preloadTime = (_this$options = this.options) === null || _this$options === void 0 ? void 0 : (_this$options$feature = _this$options.features) === null || _this$options$feature === void 0 ? void 0 : _this$options$feature.preloadTime;
              _context2.next = 3;
              return this.slotsManager.preloadLoadSlot(cuePoint, {
                preloadTime: preloadTime
              });
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function onCuePointUpdate(_x) {
        return _onCuePointUpdate.apply(this, arguments);
      }
      return onCuePointUpdate;
    }()
  }, {
    key: "sendVASTError",
    value: function sendVASTError(vast, code) {
      this.trackingManager.track(vast, 'error', {
        ERRORCODE: code || 900
      });
    }
  }, {
    key: "getRequestState",
    value: function getRequestState() {
      return this.state.request;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      if (this.getRenderer()) {
        return this.getRenderer().getCurrentTime();
      }
      return 0;
    }
  }, {
    key: "getTitle",
    value: function getTitle() {
      return this.getCurrentAd().title;
    }
  }, {
    key: "getResource",
    value: function getResource() {
      return lodash_default().get(this.getActiveCreative(), 'currentAsset.src', '');
    }
  }, {
    key: "getPlayrate",
    value: function getPlayrate() {
      if (this.getRenderer()) {
        return this.getRenderer().ref.playbackRate;
      }
      return 1;
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      if (this.getRenderer()) {
        return this.getRenderer().getDuration();
      }
      return 0;
    }
  }, {
    key: "getVersion",
    value: function getVersion() {
      return ad_engine_package_namespaceObject.i8;
    }
  }, {
    key: "validateSlot",
    value: function validateSlot(parsedVAST) {
      var _this2 = this;
      parsedVAST.ads = parsedVAST.ads.filter(function (ad) {
        if (ad.redirects === 5) {
          _this2.sendVASTError(ad, 302);
          return false;
        }
        return true;
      });
      if (!Parser.validateVASTVersion(parsedVAST)) {
        this.sendVASTError(parsedVAST, 102);
      }
    }
  }, {
    key: "submitRequest",
    value: function submitRequest() {
      var _this3 = this;
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var forCuePoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var withCredentials = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      logger_utils.debug('Ad Engine', 'submitRequest', 'Submitting request to the ad server');
      this.state.request.pending = true;
      var slotIndex;
      var type = params.type || PREROLL;
      if (forCuePoint) {
        type = MIDROLL;
        if (params.duration) {
          type = DAI;
        }
      }
      if (forCuePoint !== null) {
        slotIndex = this.slotsManager.createLoadingSlot(forCuePoint, type);
      }
      var _this$options2 = this.options,
        _this$options2$host = _this$options2.host,
        host = _this$options2$host === void 0 ? '' : _this$options2$host,
        contentDuration = _this$options2.contentDuration,
        hostTargetingSeparator = _this$options2.hostTargetingSeparator,
        features = _this$options2.features,
        _this$options2$queryP = _this$options2.queryParams,
        queryParams = _this$options2$queryP === void 0 ? {} : _this$options2$queryP;
      var _params$targeting = params.targeting,
        targeting = _params$targeting === void 0 ? '' : _params$targeting;
      var path = targeting ? "".concat(host).concat(hostTargetingSeparator).concat(targeting) : host;
      var currentRequest = superagent_lib_client_default().get(path).timeout(5000);
      if (headers) {
        currentRequest.set(headers);
      }
      if (withCredentials) {
        currentRequest.withCredentials();
      }
      return currentRequest.then(function (response) {
        switch (response.type) {
          case 'application/xml':
          case 'text/xml':
            {
              return Parser.parse(response.text, {
                contentDuration: contentDuration,
                features: features,
                queryParams: queryParams
              }).then(function (_ref4) {
                var slots = _ref4.slots,
                  format = _ref4.format;
                _this3.state.request.pending = false;
                _this3.state.request.loaded = true;
                if (format === AD_FORMAT.VAST && forCuePoint !== null) {
                  _this3.slotsManager.loadingSuccess(slotIndex, slots[0]);
                } else {
                  _this3.slotsManager.updateSlots(slots);
                }
                logger_utils.debug('Ad Engine', 'submitRequest', "Retrieved ".concat(slots.length, " slot(s) to play"), format, _this3.slotsManager.getSlots());
                _this3.triggerEvent({
                  type: adEvents.REQUEST_COMPLETE,
                  success: true,
                  slots: slots,
                  forCuePoint: forCuePoint
                });
              }).catch(function (error) {
                _this3.triggerEvent({
                  type: adEvents.ENGINE_ERROR,
                  error: {
                    code: adEvents.ERROR_PARSE_VAST,
                    module: 'Ad Engine',
                    message: error.message
                  }
                });
                _this3.triggerEvent({
                  type: adEvents.REQUEST_COMPLETE,
                  success: false
                });
              });
            }
          default:
            _this3.state.request.pending = false;
            _this3.state.request.loaded = true;
            logger_utils.error('Ad Engine', 'submitRequest', "Received an unsupported Content-Type: ".concat(response.type));
            _this3.triggerEvent({
              type: adEvents.REQUEST_COMPLETE,
              success: false
            });
            break;
        }
      }).catch(function (error) {
        logger_utils.error('Ad Engine', 'submitRequest', 'An error has occurred trying to retrieve the ads', error);
        var message = error.message;
        _this3.triggerEvent({
          type: adEvents.ENGINE_ERROR,
          error: {
            code: ad_errors_AD_REQUEST_FAILED,
            module: 'Ad Engine',
            message: message
          }
        });
        _this3.triggerEvent({
          type: adEvents.REQUEST_COMPLETE,
          success: false
        });
      });
    }
  }, {
    key: "registerDisplayBase",
    value: function registerDisplayBase(displayBase) {
      var fullscreen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.display = displayBase;
      this.trackingManager.configure({
        video: displayBase.video
      });
      if (this.rendererManager) {
        this.rendererManager.configureDisplay(displayBase, fullscreen);
      }
    }
  }, {
    key: "playAd",
    value: function () {
      var _playAd = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee3(ad) {
        var _this4 = this;
        var creative, _this$display, base, video, desiredBitrate, linear, assets, width, height, currentAsset;
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.currentAd = ad;
              creative = this.getActiveCreative();
              _this$display = this.display, base = _this$display.base, video = _this$display.video;
              if (!(creative && base && video)) {
                _context3.next = 24;
                break;
              }
              this.trackingManager.configure({
                ad: ad
              });
              this.triggerEvent({
                type: adEvents.AD_INIT
              });
              this.trackingManager.track(ad, AD_INIT);
              desiredBitrate = this.options.desiredBitrate;
              linear = creative.linear, assets = creative.assets;
              width = base.offsetWidth, height = base.offsetHeight;
              _context3.prev = 10;
              creative.currentAsset = linear ? chooseLinearAsset(assets, {
                video: video,
                width: width,
                height: height,
                desiredBitrate: desiredBitrate
              }) : this.chooseNonLinearAsset(assets);
              _context3.next = 18;
              break;
            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3["catch"](10);
              this.triggerEvent({
                type: adEvents.AD_ERROR,
                error: {
                  message: _context3.t0.message,
                  fatal: true,
                  code: _context3.t0.code || 200
                }
              });
              return _context3.abrupt("return");
            case 18:
              currentAsset = creative.currentAsset;
              if (!currentAsset) {
                _context3.next = 24;
                break;
              }
              if (linear && currentAsset.height !== currentAsset.width * 9 / 16) {
                this.trackingManager.track(this.currentAd, 'error', {
                  ERRORCODE: 203
                });
              }
              this.rendererManager.load(creative);
              if (lodash_default().get(this.currentAd, 'companions.length', 0) > 0) {
                this.handleCompanion(lodash_default().last(this.currentAd.companions));
              }
              return _context3.abrupt("return");
            case 24:
              return _context3.abrupt("return", this.playNextAd(!this.currentAd.isWrapper || this.currentAd.fallbackonnoad && !this.formattedAds.some(function (ad) {
                return ad.parentId === _this4.currentAd.id;
              })));
            case 25:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[10, 14]]);
      }));
      function playAd(_x2) {
        return _playAd.apply(this, arguments);
      }
      return playAd;
    }()
  }, {
    key: "handleCompanion",
    value: function handleCompanion(companion) {
      companion.currentAsset = this.chooseCompanionAsset(companion.assets);
      if (companion.currentAsset) {
        this.rendererManager.loadCompanion(companion);
      } else {
        logger_utils.warn('Ad Engine', 'playCompanions', 'No playable asset has been found for the companion', companion);
      }
    }
  }, {
    key: "isAdPlayed",
    value: function isAdPlayed(ad) {
      return this.playedAds.some(function (playedAd) {
        return playedAd.id === ad.id;
      }) || ad.ended;
    }
  }, {
    key: "getNextPlayableAd",
    value: function getNextPlayableAd(previousAd) {
      var _this$formattedAds,
        _this5 = this,
        _ads$find;
      var ads = (_this$formattedAds = this.formattedAds) === null || _this$formattedAds === void 0 ? void 0 : _this$formattedAds.sort(function (x, y) {
        return x.sequence - y.sequence;
      }).sort(function (x, y) {
        return x.depth - y.depth;
      });
      if (!ads) return undefined;
      if (previousAd !== null && previousAd !== void 0 && previousAd.isWrapper) {
        var remainingAdInPreviousWrapper = ads.find(function (_ad) {
          return _ad.parentId === previousAd.id && !_this5.isAdPlayed(_ad);
        });
        if (remainingAdInPreviousWrapper) return remainingAdInPreviousWrapper;
      }
      var nextPlayableAd = ads.filter(function (_ad) {
        return _ad.parentId === ((previousAd === null || previousAd === void 0 ? void 0 : previousAd.parentId) || '');
      }).find(function (_ad) {
        return !_this5.isAdPlayed(_ad) && _ad.id !== previousAd.id;
      });
      var newParentId = (_ads$find = ads.find(function (_ad) {
        return _ad.id === ((previousAd === null || previousAd === void 0 ? void 0 : previousAd.parentId) || '');
      })) === null || _ads$find === void 0 ? void 0 : _ads$find.parentId;
      var relativeDepth = 0;
      while (!nextPlayableAd && newParentId !== undefined) {
        var nodeAds = ads.filter(function (_ad) {
          return _ad.parentId === newParentId;
        });
        nextPlayableAd = nodeAds.find(function (_ad) {
          return !_this5.isAdPlayed(_ad);
        });
        if (!nextPlayableAd) {
          var _ads$find2;
          newParentId = (_ads$find2 = ads.find(function (_ad) {
            return _ad.id === newParentId;
          })) === null || _ads$find2 === void 0 ? void 0 : _ads$find2.parentId;
        }
        relativeDepth++;
        if (relativeDepth > MAX_VAST_RECURSIVITY) return undefined;
      }
      return nextPlayableAd;
    }
  }, {
    key: "getNextPlayableAdBuffet",
    value: function getNextPlayableAdBuffet(previousAd) {
      var _this$formattedBuffet,
        _this6 = this;
      if (!((_this$formattedBuffet = this.formattedBuffet) !== null && _this$formattedBuffet !== void 0 && _this$formattedBuffet.some(function (buffet) {
        return (buffet === null || buffet === void 0 ? void 0 : buffet.parentId) === (previousAd === null || previousAd === void 0 ? void 0 : previousAd.parentId) && !_this6.isAdPlayed(buffet) && !!buffet.creatives.length;
      }))) {
        return undefined;
      }
      if (previousAd.duration || previousAd.isWrapper) {
        var nextAdBuffet = this.formattedBuffet.find(function (buffet) {
          return buffet.parentId === previousAd.parentId && !_this6.isAdPlayed(buffet) && !!buffet.creatives.length && (previousAd.isWrapper || !!buffet.duration && buffet.duration <= previousAd.duration);
        });
        if (nextAdBuffet) logger_utils.debug('Ad Engine', 'playNextAd', 'An ad from the buffet has been selected');
        return nextAdBuffet;
      }
      if (!previousAd.duration) {
        this.triggerEvent({
          type: adEvents.NO_DURATION_IN_CREATIVE,
          error: {
            module: 'Ad Engine',
            code: adEvents.NO_DURATION_IN_CREATIVE
          }
        });
      }
      return undefined;
    }
  }, {
    key: "playNextAd",
    value: function () {
      var _playNextAd = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee4() {
        var preferBuffet,
          currentAd,
          previousAd,
          nextAd,
          _args4 = arguments;
        return regenerator_default().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              preferBuffet = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : false;
              _context4.next = 3;
              return this.rendererManager.resetRenderers();
            case 3:
              currentAd = this.currentAd;
              previousAd = ad_engine_objectSpread({}, currentAd);
              if (currentAd) {
                currentAd.ended = true;
                this.currentAd = null;
              }
              if (!this.released) {
                _context4.next = 9;
                break;
              }
              logger_utils.debug('Ad Engine', 'playNextAd', 'Ad engine is already released');
              return _context4.abrupt("return");
            case 9:
              nextAd = preferBuffet && this.getNextPlayableAdBuffet(previousAd) || this.getNextPlayableAd(previousAd);
              if (!nextAd) {
                _context4.next = 17;
                break;
              }
              logger_utils.debug('Ad Engine', 'playNextAd', 'Next ad queued for play', nextAd);
              this.playedAds.push(nextAd);
              _context4.next = 15;
              return this.playAd(nextAd);
            case 15:
              _context4.next = 19;
              break;
            case 17:
              logger_utils.debug('Ad Engine', 'playNextAd', 'No ads remaining to play, ending the slot');
              this.endSlot(this.currentSlot);
            case 19:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function playNextAd() {
        return _playNextAd.apply(this, arguments);
      }
      return playNextAd;
    }()
  }, {
    key: "playSlot",
    value: function () {
      var _playSlot = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee5(slot) {
        var _this$options3;
        var options,
          _args5 = arguments;
        return regenerator_default().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              options = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};
              if (!(options && options.triggerTime && this.thresholdLastBreak)) {
                _context5.next = 5;
                break;
              }
              if (!(options.triggerTime > this.thresholdLastBreak)) {
                _context5.next = 5;
                break;
              }
              logger_utils.debug('Ad Engine', 'playSlot', 'No break, trigger time after no break threshold', this.options);
              return _context5.abrupt("return");
            case 5:
              _context5.next = 7;
              return this.slotsManager.loadSlot(slot, ((_this$options3 = this.options) === null || _this$options3 === void 0 ? void 0 : _this$options3.queryParams) || {});
            case 7:
              this.currentSlot = _context5.sent;
              this.formattedAds = formatAds(this.currentSlot);
              this.formattedBuffet = formatBuffet(this.formattedAds, this.currentSlot);
              this.validateSlot(this.currentSlot);
              this.trackingManager.configure({
                slot: this.currentSlot
              });
              if (!(options && typeof options.before === 'function')) {
                _context5.next = 15;
                break;
              }
              _context5.next = 15;
              return options.before({
                slot: this.currentSlot
              });
            case 15:
              if (!(this.currentSlot && !this.released)) {
                _context5.next = 20;
                break;
              }
              this.trackingManager.track(this.currentSlot, 'breakStart');
              this.triggerEvent({
                type: adEvents.SLOT_START,
                slot: this.currentSlot
              });
              _context5.next = 20;
              return this.playNextAd();
            case 20:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function playSlot(_x3) {
        return _playSlot.apply(this, arguments);
      }
      return playSlot;
    }()
  }, {
    key: "getSlot",
    value: function getSlot(cuePoint) {
      return this.slotsManager.find(cuePoint);
    }
  }, {
    key: "getSlots",
    value: function getSlots() {
      return this.slotsManager.getSlots();
    }
  }, {
    key: "getPendingSlot",
    value: function getPendingSlot(contentTimePosition) {
      return this.slotsManager.findPending(contentTimePosition);
    }
  }, {
    key: "getActiveCreative",
    value: function getActiveCreative() {
      var _ref5 = this.currentAd || {},
        _ref5$creatives = _ref5.creatives,
        creatives = _ref5$creatives === void 0 ? [] : _ref5$creatives;
      return creatives.find(function (_ref6) {
        var assets = _ref6.assets;
        return assets && assets.length;
      });
    }
  }, {
    key: "getCurrentAsset",
    value: function getCurrentAsset() {
      var activeCreative = this.getActiveCreative();
      return activeCreative && activeCreative.currentAsset;
    }
  }, {
    key: "getCurrentAd",
    value: function getCurrentAd() {
      return this.currentAd;
    }
  }, {
    key: "getCurrentSlot",
    value: function getCurrentSlot() {
      return this.currentSlot;
    }
  }, {
    key: "chooseNonLinearAsset",
    value: function chooseNonLinearAsset(assets) {
      return this.chooseCompanionAsset(assets);
    }
  }, {
    key: "chooseCompanionAsset",
    value: function chooseCompanionAsset(assets) {
      var htmlAsset = assets.find(function (asset) {
        return asset.type === 'html';
      });
      if (htmlAsset) {
        return htmlAsset;
      }
      var staticAsset = assets.find(function (asset) {
        return asset.type === 'static';
      });
      if (staticAsset) {
        return staticAsset;
      }
      var iframeAsset = assets.find(function (asset) {
        return asset.type === 'iframe';
      });
      if (iframeAsset) {
        return iframeAsset;
      }
      return assets[0];
    }
  }, {
    key: "interactionMade",
    value: function interactionMade() {
      if (this.getRenderer()) {
        this.getRenderer().interactionMade();
      }
    }
  }, {
    key: "isPaused",
    value: function isPaused() {
      if (this.getRenderer()) {
        return this.getRenderer().isPaused();
      }
      return true;
    }
  }, {
    key: "getAudioEnabled",
    value: function getAudioEnabled() {
      if (this.getRenderer()) {
        return this.getRenderer().getAudioEnabled();
      }
      return false;
    }
  }, {
    key: "play",
    value: function play() {
      if (this.getRenderer()) {
        this.getRenderer().play();
      }
    }
  }, {
    key: "pause",
    value: function pause() {
      if (this.getRenderer()) {
        this.getRenderer().pause();
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      var _this$triggerSlotOnSe, _this$triggerSlotOnSe2;
      if (this.currentSlot) {
        this.getRenderer().stop();
        this.endSlot(this.currentSlot, false);
      }
      (_this$triggerSlotOnSe = (_this$triggerSlotOnSe2 = this.triggerSlotOnSeek).cancel) === null || _this$triggerSlotOnSe === void 0 ? void 0 : _this$triggerSlotOnSe.call(_this$triggerSlotOnSe2);
    }
  }, {
    key: "skipAd",
    value: function skipAd() {
      if (this.getRenderer()) {
        this.getRenderer().skip();
      }
    }
  }, {
    key: "skipBreak",
    value: function skipBreak() {
      this.skipAd();
      if (this.currentSlot) {
        this.sendVASTError(this.currentSlot, 206);
        this.endSlot(this.currentSlot, false);
      }
    }
  }, {
    key: "setVolume",
    value: function setVolume(volume) {
      this.options.volume = volume;
      if (this.getRenderer()) {
        this.getRenderer().setVolume(volume);
      }
    }
  }, {
    key: "release",
    value: function release() {
      var _this$triggerSlotOnSe3, _this$triggerSlotOnSe4;
      this.released = true;
      this.subscribers = {};
      this.rendererManager.releaseRenderers();
      this.rendererManager = null;
      (_this$triggerSlotOnSe3 = (_this$triggerSlotOnSe4 = this.triggerSlotOnSeek).cancel) === null || _this$triggerSlotOnSe3 === void 0 ? void 0 : _this$triggerSlotOnSe3.call(_this$triggerSlotOnSe4);
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(event, callback) {
      if (!this.subscribers[event]) {
        this.subscribers[event] = [];
      }
      this.subscribers[event].push(callback);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(event, callback) {
      var _this7 = this;
      if (this.subscribers[event]) {
        this.subscribers[event].forEach(function (listener, key) {
          if (callback === listener) {
            delete _this7.subscribers[event][key];
          }
        });
      }
    }
  }, {
    key: "getRenderer",
    value: function getRenderer() {
      if (!this.rendererManager) {
        return null;
      }
      return this.rendererManager.getActiveRenderer();
    }
  }, {
    key: "addProvider",
    value: function addProvider(provider) {
      var slotType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SlotType.LBANNER;
      if (slotType !== SlotType.LBANNER) {
        return;
      }
      var _provider$host = provider.host,
        host = _provider$host === void 0 ? '' : _provider$host,
        hostTargetingSeparator = provider.hostTargetingSeparator,
        targetingKeysSeparator = provider.targetingKeysSeparator,
        targeting = provider.targeting,
        duration = provider.duration;
      var path = targeting ? "".concat(host).concat(hostTargetingSeparator).concat(Object.keys(targeting).map(function (key) {
        return "".concat(key, "=").concat(targeting[key]);
      }).join(targetingKeysSeparator)) : host;
      var newSlots = provider.cuePoints.map(function (cuePoint) {
        return ad_engine_objectSpread(ad_engine_objectSpread({}, EMPTY_SLOT), {}, {
          type: SlotType.LBANNER,
          cuePoint: cuePoint,
          adTagURI: path,
          id: "lbanner-".concat(cuePoint),
          options: {
            creative: {
              duration: duration
            }
          }
        });
      });
      this.slotsManager.updateSlots([].concat((0,toConsumableArray/* default */.Z)(this.slotsManager.getSlots()), (0,toConsumableArray/* default */.Z)(newSlots)));
    }
  }]);
  return AdEngine;
}();
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+ad-engine@5.29.4_@bedrock+html5-engine@3.6.8_@bedrock+media-engine@4.13.0__@bedrock+media-engine@4.13.0/node_modules/@bedrock/ad-engine/lib/bridges/AdError.js



var AdError = (0,createClass/* default */.Z)(function AdError() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ad_errors_AD_UNKNOWN_ERROR;
  var details = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'UNKNOWN';
  var fatal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var context = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var reason = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  var content = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
  var monitored = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : true;
  (0,classCallCheck/* default */.Z)(this, AdError);
  this.type = type;
  this.details = details;
  this.fatal = fatal;
  this.monitored = monitored;
  this.context = context;
  this.reason = reason;
  this.content = content;
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+ad-engine@5.29.4_@bedrock+html5-engine@3.6.8_@bedrock+media-engine@4.13.0__@bedrock+media-engine@4.13.0/node_modules/@bedrock/ad-engine/lib/bridges/slot.utils.js






var slot_utils_isEmpty = function isEmpty(value) {
  return !value || value.length <= 0;
};
var hasAds = function hasAds(slot) {
  if (!slot || slot_utils_isEmpty(slot.ads) && slot_utils_isEmpty(slot.buffet)) {
    return false;
  }
  return [].concat((0,toConsumableArray/* default */.Z)(slot.ads), (0,toConsumableArray/* default */.Z)(slot.buffet || [])).some(function (ad) {
    if (!ad) {
      return false;
    }
    if (!slot_utils_isEmpty(ad.creatives) || !slot_utils_isEmpty(ad.companions)) {
      return true;
    }
    if (ad.wrapperVAST) {
      return hasAds(ad.wrapperVAST);
    }
    return false;
  });
};
var isLinearSlot = function isLinearSlot(slot) {
  return ![DAI, SlotType.LBANNER].includes(slot.type);
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+ad-engine@5.29.4_@bedrock+html5-engine@3.6.8_@bedrock+media-engine@4.13.0__@bedrock+media-engine@4.13.0/node_modules/@bedrock/ad-engine/lib/bridges/abstract.ad.extended.bridge.js




















function abstract_ad_extended_bridge_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function abstract_ad_extended_bridge_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? abstract_ad_extended_bridge_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : abstract_ad_extended_bridge_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function abstract_ad_extended_bridge_createSuper(t) { var r = abstract_ad_extended_bridge_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function abstract_ad_extended_bridge_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (abstract_ad_extended_bridge_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }











var AbstractAdExtendedBridge = function (_AdBridge) {
  (0,inherits/* default */.Z)(AbstractAdExtendedBridge, _AdBridge);
  var _super = abstract_ad_extended_bridge_createSuper(AbstractAdExtendedBridge);
  function AbstractAdExtendedBridge(config, eventsHandlers, contentHandlers) {
    var _this;
    var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      _ref$VideoEngine = _ref.VideoEngine,
      VideoEngine = _ref$VideoEngine === void 0 ? HTML5Engine_HTML5Engine : _ref$VideoEngine,
      _ref$storage = _ref.storage,
      storage = _ref$storage === void 0 ? window.localStorage : _ref$storage;
    (0,classCallCheck/* default */.Z)(this, AbstractAdExtendedBridge);
    _this = _super.call(this, config, eventsHandlers, contentHandlers, {
      VideoEngine: VideoEngine,
      storage: storage
    });
    _this.onRequestComplete = function (response) {
      if (_this.released) {
        return;
      }
      if (response.success) {
        var newCuePoints = response.slots.filter(function (slot) {
          return !slot.ended && !lodash_default().isNaN(slot.cuePoint);
        }).map(function (slot) {
          return slot.cuePoint;
        });
        _this.updateCuePoints(lodash_default().uniq([].concat((0,toConsumableArray/* default */.Z)(_this.cuePoints), (0,toConsumableArray/* default */.Z)(newCuePoints))));
        if (_this.shouldAutoPlay) {
          var slot;
          if (response.forCuePoint) {
            slot = _this.engine.getSlot(response.forCuePoint);
          } else {
            slot = _this.engine.getSlot(0);
          }
          _this.eventsHandlers.onProviderLoaded();
          if (slot && !slot.pending && (slot.adTagURI || hasAds(slot))) {
            _this.startSlot(slot, {
              triggerTime: slot.cuePoint
            });
          } else {
            var _slot;
            var errorStack = (_slot = slot) === null || _slot === void 0 ? void 0 : _slot.errorStack;
            if (!lodash_default().isEmpty(errorStack)) {
              errorStack.forEach(function (errorCode) {
                _this.engine.sendVASTError(slot, errorCode);
              });
            }
            _this.contentHandlers.playerPlay();
          }
        }
      } else {
        _this.eventsHandlers.onProviderLoaded();
        if (_this.shouldAutoPlay) {
          _this.contentHandlers.playerPlay();
        }
      }
    };
    _this.onAdError = function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(event) {
        var error, ad, asset, creative, creativeId, _creativeId$toLowerCa;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              error = new AdError(adEvents.AD_ERROR, lodash_default().get(event, 'error.code'), !!event.error.fatal, lodash_default().get(event, 'error.module'), lodash_default().get(event, 'error.message'));
              error.monitored = error.details !== 1009;
              ad = _this.engine.getCurrentAd();
              asset = _this.engine.getCurrentAsset();
              creative = _this.engine.getActiveCreative();
              creativeId = _this.getAdCreativeId(creative);
              if (ad) {
                error.content = {
                  ad: {
                    id: ad.id || ad.adid,
                    creativeId: (creativeId === null || creativeId === void 0 ? void 0 : (_creativeId$toLowerCa = creativeId.toLowerCase) === null || _creativeId$toLowerCa === void 0 ? void 0 : _creativeId$toLowerCa.call(creativeId)) === 'unknown' && ad !== null && ad !== void 0 && ad.adid ? ad === null || ad === void 0 ? void 0 : ad.adid : creativeId,
                    mediaFile: {
                      url: lodash_default().get(asset, 'src'),
                      mimeType: lodash_default().get(asset, 'type')
                    }
                  }
                };
              }
              error.adRequestUrl = lodash_default().get(_this.engine, 'options.host');
              _this.eventsHandlers.onError(error);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    _this.onAdStarted = function (event) {
      var currentAd = _this.engine.getCurrentAd();
      var creative = _this.engine.getActiveCreative();
      var creativeId = _this.getAdCreativeId(creative);
      _this.eventsHandlers.onStarted({
        type: lodash_default().get(_this.engine.getCurrentSlot(), 'type'),
        creativeId: creativeId,
        mimeType: lodash_default().get(creative, 'currentAsset.type'),
        hasCompanions: !!lodash_default().get(currentAd, 'companions', []).length,
        linear: event.target.linear,
        title: currentAd === null || currentAd === void 0 ? void 0 : currentAd.title,
        duration: creative === null || creative === void 0 ? void 0 : creative.duration,
        adId: currentAd === null || currentAd === void 0 ? void 0 : currentAd.id,
        skipOffset: creative === null || creative === void 0 ? void 0 : creative.skipoffset
      });
    };
    _this.onAdEnded = function (event) {
      _this.endedAdsDuration = _this.endedAdsDuration + event.target.duration;
      _this.eventsHandlers.onEnded(event);
    };
    _this.onAdSkipped = function (event) {
      _this.endedAdsDuration = _this.endedAdsDuration + event.target.duration;
      _this.eventsHandlers.onSkipped(event);
    };
    _this.getAdCreativeId = function (creative) {
      return (creative === null || creative === void 0 ? void 0 : creative.adid) || 'unknown';
    };
    _this.shouldLaunchAdJingle = function (slot) {
      return hasAds(slot) && [].concat((0,toConsumableArray/* default */.Z)(slot.ads), (0,toConsumableArray/* default */.Z)(slot.buffet || [])).some(function (ad) {
        var _ad$creatives;
        return (_ad$creatives = ad.creatives) === null || _ad$creatives === void 0 ? void 0 : _ad$creatives.some(function (creative) {
          var _creative$assets;
          return (_creative$assets = creative.assets) === null || _creative$assets === void 0 ? void 0 : _creative$assets.length;
        });
      });
    };
    _this.beforeSlotStart = function () {
      var _ref4 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2(_ref3) {
        var slot, type;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              slot = _ref3.slot;
              type = slot.type;
              if ([PREROLL, MIDROLL, DAI].includes(type)) {
                _context2.next = 4;
                break;
              }
              return _context2.abrupt("return");
            case 4:
              if (!_this.shouldLaunchAdJingle(slot)) {
                _context2.next = 7;
                break;
              }
              _context2.next = 7;
              return _this.contentHandlers.jingleDisplay('ads');
            case 7:
              _this.updateSlotsDuration();
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref4.apply(this, arguments);
      };
    }();
    _this.onSlotStart = function () {
      var _ref6 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee3(_ref5) {
        var slot, ads, type, reference, errorStack;
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              slot = _ref5.slot;
              ads = slot.ads, type = slot.type, reference = slot.reference, errorStack = slot.errorStack;
              if ([PREROLL, MIDROLL, DAI, SlotType.LBANNER].includes(type)) {
                _context3.next = 4;
                break;
              }
              return _context3.abrupt("return");
            case 4:
              if (isLinearSlot(slot) && hasAds(slot)) {
                _this.contentHandlers.playerPause();
              }
              if (!lodash_default().isEmpty(errorStack)) {
                errorStack.forEach(function (errorCode) {
                  _this.engine.sendVASTError(slot, errorCode);
                });
              }
              _this.eventsHandlers.onBreakStarted({
                type: type,
                silent: !hasAds(slot),
                creativeIds: ads.map(_this.getAdCreativeId),
                reference: reference
              });
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x3) {
        return _ref6.apply(this, arguments);
      };
    }();
    _this.onSlotEnded = function (_ref7) {
      var slot = _ref7.slot,
        completed = _ref7.completed;
      var silent = !hasAds(slot);
      _this.eventsHandlers.onBreakEnded({
        silent: silent,
        duration: _this.slotsDuration
      });
      _this.removeCuePoint(slot.cuePoint);
      if (isLinearSlot(slot) && !silent || slot.type === PREROLL) {
        _this.contentHandlers.playerPlay();
      }
      if (!silent && completed) {
        _this.capping.saveLastBreak();
      }
      _this.endedAdsDuration = 0;
    };
    _this.onAdClick = function (event) {
      if (_this.__onAdClick(event.url)) {
        _this.engine.interactionMade();
      }
    };
    _this.requestAds = function () {
      var extraConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        start = _ref8.start,
        duration = _ref8.duration;
      return _this.engine.submitRequest(abstract_ad_extended_bridge_objectSpread({
        duration: duration
      }, _this.getRequestParameters(0, extraConfig)), Math.round(start));
    };
    _this.AdEngine = AdEngine;
    _this.VideoEngine = VideoEngine;
    _this.slotsDuration = 0;
    _this.endedAdsDuration = 0;
    return _this;
  }
  (0,createClass/* default */.Z)(AbstractAdExtendedBridge, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      return (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(AbstractAdExtendedBridge.prototype), "init", this).call(this).then(function () {
        _this2.engine = new _this2.AdEngine(_this2.config, {
          VideoEngine: _this2.VideoEngine,
          videoEngineConfig: _this2.videoEngineConfig,
          sendEvent: _this2.config.sendEvent
        });
        _this2.engine.registerDisplayBase({
          base: _this2.containerRef,
          lbanner: _this2.lBannerContainerRef,
          video: _this2.videoRef,
          companion: _this2.companionRef
        });
        _this2.manageEventListeners('add');
      });
    }
  }, {
    key: "preloadSlotAhead",
    value: function preloadSlotAhead(lowerCuePoint) {
      var higherCuePoint = lowerCuePoint + 5;
      var actualCuePoint = this.cuePoints.find(function (cuePoint) {
        return cuePoint >= lowerCuePoint && cuePoint <= higherCuePoint;
      });
      if (actualCuePoint) {
        var slot = this.engine.getSlot(actualCuePoint);
        var canBreak = this.canBreak(higherCuePoint - actualCuePoint);
        if (!slot && canBreak) {
          logger_utils.debug('ad.extended.bridge', 'preloadSlotAhead', "Pre-loading slot for cuePoint ".concat(actualCuePoint));
          this.engine.submitRequest(this.getRequestParameters(actualCuePoint, {}), actualCuePoint);
        } else if (!canBreak) {
          this.removeCuePoint(actualCuePoint);
        }
      }
    }
  }, {
    key: "triggerSlotOnSeek",
    value: function triggerSlotOnSeek(cuePoint) {
      if (!this.canBreak()) {
        return;
      }
      this.engine.triggerSlotOnSeek(cuePoint, {
        before: this.beforeSlotStart
      });
    }
  }, {
    key: "handleInteraction",
    value: function handleInteraction() {
      var ad = this.engine.getCurrentAd();
      if (ad && this.__onAdClick(lodash_default().get(ad, 'creatives.0.clickThroughUrl'))) {
        this.engine.interactionMade();
      }
    }
  }, {
    key: "getSlotsDurationWithWrapperVAST",
    value: function getSlotsDurationWithWrapperVAST(currentSlot) {
      var _this3 = this;
      var isWrapperVAST = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return currentSlot.ads.reduce(function (acc, ad) {
        var _ad$creatives$0$durat;
        if (!ad.creatives.length) {
          if (ad !== null && ad !== void 0 && ad.wrapperVAST) {
            return acc + _this3.getSlotsDurationWithWrapperVAST(ad.wrapperVAST, true);
          }
          return acc;
        }
        return acc + ((_ad$creatives$0$durat = ad.creatives[0].duration) !== null && _ad$creatives$0$durat !== void 0 ? _ad$creatives$0$durat : DEFAULT_CREATIVE_DURATION);
      }, 0) || (isWrapperVAST ? 0 : DEFAULT_CREATIVE_DURATION * currentSlot.ads.length);
    }
  }, {
    key: "updateSlotsDuration",
    value: function updateSlotsDuration() {
      var _currentSlot$ads;
      if (!this.engine) {
        return;
      }
      var currentSlot = this.engine.getCurrentSlot();
      if (!currentSlot || !currentSlot.loaded || !((_currentSlot$ads = currentSlot.ads) !== null && _currentSlot$ads !== void 0 && _currentSlot$ads.length)) {
        this.slotsDuration = 0;
        return;
      }
      this.slotsDuration = this.getSlotsDurationWithWrapperVAST(currentSlot);
    }
  }, {
    key: "getSlotsDuration",
    value: function getSlotsDuration() {
      return this.slotsDuration;
    }
  }, {
    key: "getEndedAdsDuration",
    value: function getEndedAdsDuration() {
      return this.endedAdsDuration;
    }
  }, {
    key: "startSlot",
    value: function () {
      var _startSlot = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee4(slot, _ref9) {
        var triggerTime;
        return regenerator_default().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              triggerTime = _ref9.triggerTime;
              if (!(!slot || !this.canBreak())) {
                _context4.next = 5;
                break;
              }
              _context4.next = 4;
              return this.contentHandlers.playerPlay();
            case 4:
              return _context4.abrupt("return");
            case 5:
              logger_utils.debug('abstract.ad.extended.bridge', 'startSlot', "About to start slot", slot);
              this.removeCuePoint(slot.cuePoint);
              slot.pending = false;
              if (!this.released) {
                _context4.next = 10;
                break;
              }
              return _context4.abrupt("return");
            case 10:
              _context4.next = 12;
              return this.engine.playSlot(slot, {
                before: this.beforeSlotStart,
                triggerTime: triggerTime
              });
            case 12:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function startSlot(_x4, _x5) {
        return _startSlot.apply(this, arguments);
      }
      return startSlot;
    }()
  }, {
    key: "manageEventListeners",
    value: function manageEventListeners() {
      var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'add';
      var method = "".concat(prefix, "EventListener");
      this.engine[method](adEvents.REQUEST_COMPLETE, this.onRequestComplete);
      this.engine[method](adEvents.AD_LOADED, this.eventsHandlers.onAdLoaded);
      this.engine[method](adEvents.SLOT_START, this.onSlotStart);
      this.engine[method](adEvents.SLOT_ENDED, this.onSlotEnded);
      this.engine[method](adEvents.ENGINE_ERROR, this.onAdError);
      this.engine[method](adEvents.AD_STARTED, this.onAdStarted);
      this.engine[method](adEvents.AD_PLAYING, this.eventsHandlers.onPlaying);
      this.engine[method](adEvents.AD_PAUSED, this.eventsHandlers.onPaused);
      this.engine[method](adEvents.AD_ERROR, this.onAdError);
      this.engine[method](adEvents.AD_CLICK_THRU, this.onAdClick);
      this.engine[method](adEvents.AD_STOPPED, this.onAdEnded);
      this.engine[method](adEvents.AD_SKIPPED, this.onAdSkipped);
      this.engine[method](adEvents.AD_VIDEO_FIRST_QUARTILE, this.eventsHandlers.onFirstQuartile);
      this.engine[method](adEvents.AD_VIDEO_MIDPOINT, this.eventsHandlers.onMidPoint);
      this.engine[method](adEvents.AD_VIDEO_THIRD_QUARTILE, this.eventsHandlers.onThirdQuartile);
      this.engine[method](adEvents.AD_EXPANDED_CHANGE, this.onExpandToggle);
    }
  }, {
    key: "onExpandToggle",
    value: function onExpandToggle() {
      this.eventsHandlers.onExpandToggle(true);
    }
  }, {
    key: "getOptionalTargeting",
    value: function getOptionalTargeting() {
      return {};
    }
  }, {
    key: "buildTargeting",
    value: function buildTargeting(targeting) {
      var targetingKeysSeparator = this.config.targetingKeysSeparator;
      return Object.keys(targeting).map(function (key) {
        return "".concat(key, "=").concat(targeting[key]);
      }).join(targetingKeysSeparator);
    }
  }, {
    key: "getRequestParameters",
    value: function getRequestParameters() {
      var cuePoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var extraConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _this$config = this.config,
        _this$config$breaks = _this$config.breaks,
        breaks = _this$config$breaks === void 0 ? [] : _this$config$breaks,
        contentTargeting = _this$config.targeting,
        host = _this$config.host;
      var _ref0 = breaks.find(function (_ref1) {
          var breakCuePoint = _ref1.cuePoint;
          return breakCuePoint === cuePoint;
        }) || {},
        breakTargeting = _ref0.targeting;
      var targeting = abstract_ad_extended_bridge_objectSpread(abstract_ad_extended_bridge_objectSpread(abstract_ad_extended_bridge_objectSpread({}, breakTargeting), contentTargeting), this.getOptionalTargeting());
      return abstract_ad_extended_bridge_objectSpread({
        cacheBusting: Date.now(),
        host: host,
        targeting: this.buildTargeting(targeting)
      }, extraConfig);
    }
  }, {
    key: "removeCuePoint",
    value: function removeCuePoint(cuePoint) {
      this.updateCuePoints(this.cuePoints.filter(function (point) {
        return point !== cuePoint;
      }));
    }
  }, {
    key: "contentHasProgressed",
    value: function contentHasProgressed(currentTime) {
      if (!this.engine) {
        return;
      }
      this.engine.onCuePointUpdate(currentTime);
      this.preloadSlotAhead(currentTime);
      var slot;
      if (this.cuePoints.indexOf(currentTime) === -1) {
        slot = this.engine.getPendingSlot(currentTime);
      } else {
        slot = this.engine.getSlot(currentTime);
      }
      if (slot && !slot.ended && !slot.loading) {
        this.startSlot(slot, {
          triggerTime: currentTime
        });
      }
    }
  }, {
    key: "contentHasStarted",
    value: function contentHasStarted() {
      this.shouldAutoPlay = true;
    }
  }, {
    key: "play",
    value: function play() {
      if (this.engine) {
        var _this$engine$getReque = this.engine.getRequestState(),
          pending = _this$engine$getReque.pending,
          loaded = _this$engine$getReque.loaded;
        if (this.engine.getCurrentAd()) {
          this.engine.play();
        } else if (pending) {
          this.shouldAutoPlay = true;
        } else if (loaded) {
          this.eventsHandlers.onProviderLoaded();
          var slot = this.engine.getSlot(0);
          if (slot && !slot.ended) {
            this.startSlot(slot, {
              triggerTime: 0
            });
          } else {
            this.contentHandlers.playerPlay();
          }
        }
      }
    }
  }, {
    key: "isPaused",
    value: function isPaused() {
      if (this.engine) {
        return this.engine.isPaused();
      }
      return true;
    }
  }, {
    key: "pause",
    value: function pause() {
      if (this.engine) {
        this.engine.pause();
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.engine) {
        this.engine.stop();
      }
    }
  }, {
    key: "skipAd",
    value: function skipAd() {
      if (this.engine) {
        this.engine.skipAd();
      }
    }
  }, {
    key: "skipBreak",
    value: function skipBreak() {
      if (this.engine) {
        this.engine.skipBreak();
      }
    }
  }, {
    key: "setVolume",
    value: function setVolume(volume) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(AbstractAdExtendedBridge.prototype), "setVolume", this).call(this, volume);
      if (this.engine) {
        this.engine.setVolume(volume);
      }
    }
  }, {
    key: "resize",
    value: function resize() {
      var fullscreen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (this.engine) {
        this.engine.registerDisplayBase({
          base: this.containerRef,
          lbanner: this.lBannerContainerRef,
          video: this.videoRef,
          companion: this.companionRef
        }, fullscreen);
      }
    }
  }, {
    key: "reload",
    value: function reload(config) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(AbstractAdExtendedBridge.prototype), "reload", this).call(this, config);
      this.release();
    }
  }, {
    key: "release",
    value: function release() {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(AbstractAdExtendedBridge.prototype), "release", this).call(this);
      if (this.engine) {
        this.manageEventListeners('remove');
        this.engine.release();
        this.engine = null;
        delete this.engine;
        this.slotsDuration = 0;
        this.endedAdsDuration = 0;
      }
    }
  }, {
    key: "addProvider",
    value: function addProvider(provider) {
      this.engine.addProvider(provider);
      this.updateCuePoints([].concat((0,toConsumableArray/* default */.Z)(this.cuePoints), (0,toConsumableArray/* default */.Z)(provider.cuePoints)));
    }
  }]);
  return AbstractAdExtendedBridge;
}(AdBridge);
;// CONCATENATED MODULE: ./src/modules/player/ads/bridges/commonBridge.js









function commonBridge_createSuper(t) { var r = commonBridge_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function commonBridge_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (commonBridge_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var CommonBridge = function (_AbstractAdExtendedBr) {
  (0,inherits/* default */.Z)(CommonBridge, _AbstractAdExtendedBr);
  var _super = commonBridge_createSuper(CommonBridge);
  function CommonBridge() {
    var _this;
    (0,classCallCheck/* default */.Z)(this, CommonBridge);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.onSlotEnded = function () {
      _this.eventsHandlers.onBreakEnded();
      _this.contentHandlers.playerPlay();
    };
    return _this;
  }
  (0,createClass/* default */.Z)(CommonBridge, [{
    key: "pause",
    value: function pause() {
      if (this.engine && this.engine.getCurrentAd()) {
        this.engine.pause();
      } else {
        this.contentHandlers.playerPause();
      }
    }
  }, {
    key: "buildTargeting",
    value: function buildTargeting(targeting) {
      return Object.keys(targeting).map(function (key) {
        return "".concat(key, "=").concat(encodeURIComponent(targeting[key]));
      }).join(this.config.targetingKeysSeparator);
    }
  }]);
  return CommonBridge;
}(AbstractAdExtendedBridge);
/* harmony default export */ const commonBridge = ((/* unused pure expression or super */ null && (CommonBridge)));
;// CONCATENATED MODULE: ./src/modules/player/ads/ads.utils.js










var BRIDGES = (0,defineProperty/* default */.Z)({}, BRIDGE_AD_OCEAN, CommonBridge);
var bridgeClassByProviderId = function bridgeClassByProviderId(adsProviderId) {
  return BRIDGES[adsProviderId] || CommonBridge;
};
var ads_utils_createRenderers = function createRenderers(prefix) {
  var _createAdRenderers = createAdRenderers(prefix),
    container = _createAdRenderers.container,
    video = _createAdRenderers.video;
  container.className = 'ads-container';
  var companion = document.createElement('div');
  companion.style.cssText = 'position: fixed; top: 32px; right: 32px; width: 300px; height: 250px; overflow: hidden;';
  container.appendChild(companion);
  return {
    companion: companion,
    container: container,
    video: video
  };
};
var adExitAnalyticsEvent = function adExitAnalyticsEvent(type) {
  var analyticsKey = get_default()(AD_ANALYTICS_TYPES.back, type, null);
  if (analyticsKey) sendEvent({
    key: analyticsKey
  });
};
var getAdsDurationInSeconds = function getAdsDurationInSeconds(adBreak) {
  if (!adBreak || !Array.isArray(adBreak.ads)) {
    return 0;
  }
  return adBreak.ads.map(function (ad) {
    var playableAds = (ad.creatives || []).filter(function (_ref) {
      var assets = _ref.assets;
      return assets.length > 0;
    });
    if (!playableAds.length) {
      return 0;
    }
    var adDuration = playableAds[0].duration;
    return adDuration || ADS_COUNTDOWN_DEFAULT_TOTAL_DURATION;
  }).reduce(function (result, duration) {
    return result + duration;
  }, 0);
};
var updateCountdown = function updateCountdown(view, elapsed, total) {
  var skipAnimation = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  view.body = getTimeFormat(Math.floor(total - elapsed));
  var value = 1.0 - Math.min(Math.max(total ? elapsed / total : 0, 0), 1);
  if (skipAnimation || !view.progress && value) {
    view.progress = value;
  } else {
    view.setSmooth('progress', value, {
      duration: 0.35
    });
  }
};
;// CONCATENATED MODULE: ./src/modules/player/ads/platform/vodafone/lBanner.utils.js


var handleAdPlayerScale = function handleAdPlayerScale(enable) {
  var videoEl = document.querySelector('.ads-container>video');
  if (!videoEl) return;
  var fullWidth = SCREEN_WIDTH[sizes_getScreenSize()];
  var fullHeight = sizes_SCREEN_HEIGHT[sizes_getScreenSize()];
  if (enable) {
    var width = Math.floor(fullWidth * (1 - getLBannerWidthScale()));
    var height = Math.floor(fullHeight * (1 - getLBannerHeightScale()));
    videoEl.style.width = "".concat(width, "px");
    videoEl.style.height = "".concat(height, "px");
  } else {
    videoEl.style.width = "".concat(fullWidth, "px");
    videoEl.style.height = "".concat(fullHeight, "px");
  }
};
;// CONCATENATED MODULE: ./src/modules/player/ads/customer/default/ads.component.js






function ads_component_createSuper(t) { var r = ads_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function ads_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (ads_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }


















var ads_component_Ads = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Ads, _Lightning$Component);
  var _super = ads_component_createSuper(Ads);
  function Ads() {
    (0,classCallCheck/* default */.Z)(this, Ads);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Ads, [{
    key: "_construct",
    value: function _construct() {
      this._shouldDisplayAdJingle = false;
      this._displayedAdBreakType = null;
    }
  }, {
    key: "_attach",
    value: function _attach() {
      this._unsubscribe = ads_connector(this);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      if (this._unsubscribe) {
        this._unsubscribe();
        this._unsubscribe = null;
      }
      this._focused = undefined;
    }
  }, {
    key: "isAdJingleDisplayed",
    set: function set(value) {
      if (value) {
        this._setState('AdJingle');
      }
    }
  }, {
    key: "adJingleImageId",
    set: function set(value) {
      var adJingleView = this.tag('AdJingle');
      if (!value) {
        adJingleView.texture = null;
        return;
      }
      var finalW = adJingleView.finalW,
        finalH = adJingleView.finalH;
      adJingleView.texture = cover(imageService.getUrl(value, finalW, finalH, {
        fit: IMAGE_FIT_SCALE_CROP,
        quality: IMAGE_QUALITY,
        format: DEFAULT_IMAGE_FORMAT
      }), finalW, finalH);
      adJingleView.loadTexture();
    }
  }, {
    key: "contentTitle",
    set: function set(value) {
      this.tag('Metadata').extraTitle = t('player.adExtraTitle', {
        contentTitle: value || ''
      });
    }
  }, {
    key: "shouldDisplayLBanner",
    set: function set(value) {
      handleAdPlayerScale(value);
    }
  }, {
    key: "playbackState",
    set: function set(value) {
      if (value === PLAYBACK_STATE_PLAYING) {
        this._setState('Playing');
      } else if (value === PLAYBACK_STATE_PAUSED) {
        this._setState('Paused');
      } else if (value === PLAYBACK_STATE_ENDED) {
        this._focused = undefined;
      }
    }
  }, {
    key: "displayedAdBreakType",
    set: function set(value) {
      this._displayedAdBreakType = value;
    }
  }, {
    key: "adBreakElapsedTime",
    set: function set(value) {
      this._adBreakElapsedTime = value;
      this._updateCountdown(value < this._adBreakElapsedTime);
    }
  }, {
    key: "adBreakDuration",
    set: function set(value) {
      this._adBreakDuration = value;
      this._updateCountdown();
    }
  }, {
    key: "displayAdsCountdown",
    set: function set(value) {
      this.tag('Countdown').visible = Boolean(value);
    }
  }, {
    key: "_updateCountdown",
    value: function _updateCountdown() {
      var skipAnimation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var view = this.tag('Countdown');
      view.alpha = this._adBreakDuration ? 1 : 0;
      updateCountdown(view, this._adBreakElapsedTime, this._adBreakDuration, skipAnimation);
    }
  }, {
    key: "_pause",
    value: function _pause() {
      this.signal(PAUSE_SIGNAL);
    }
  }, {
    key: "_play",
    value: function _play() {
      this.signal(PLAY_SIGNAL);
    }
  }, {
    key: "_handleBack",
    value: function _handleBack() {
      adExitAnalyticsEvent(this._displayedAdBreakType);
      return false;
    }
  }, {
    key: "_handleUp",
    value: function _handleUp() {
      if (!DISPLAY_AD_METADATA) {
        return false;
      }
      if (!this._focused) {
        this._focused = this.tag('TopBar');
        return true;
      }
      return false;
    }
  }, {
    key: "_handleDown",
    value: function _handleDown() {
      if (!DISPLAY_AD_METADATA) {
        return false;
      }
      if (this._focused) {
        this._focused = undefined;
        return true;
      }
      return false;
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this._focused;
    }
  }, {
    key: "_handleTopBarItemSelected",
    value: function _handleTopBarItemSelected() {
      Router.back();
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Overlay: {
          type: Overlay
        },
        TopBar: {
          type: TopBar,
          items: [{
            id: TOP_BAR_ITEMS.BACK,
            icon: 'ArrowLeftWithBase',
            text: t('nav.backToNav'),
            action: TOP_BAR_BACK
          }],
          signals: (0,defineProperty/* default */.Z)({}, SELECTED_SIGNAL, '_handleTopBarItemSelected')
        },
        Metadata: {
          type: metadata_component_Metadata,
          title: t('player.adMessage'),
          extraTitle: t('player.adExtraTitle')
        },
        PlaybackStateIndicator: {
          type: PlaybackStateIndicator
        },
        Countdown: {
          type: pill_component_Pill,
          title: t('player.adMessage')
        },
        AdJingle: {}
      }, ads_style_getInitialStyle());
    }
  }, {
    key: "_states",
    value: function _states() {
      return [function (_this) {
        (0,inherits/* default */.Z)(Playing, _this);
        var _super2 = ads_component_createSuper(Playing);
        function Playing() {
          (0,classCallCheck/* default */.Z)(this, Playing);
          return _super2.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(Playing, [{
          key: "$enter",
          value: function $enter() {
            this.tag('PlaybackStateIndicator').show('Paused');
            this._focused = undefined;
          }
        }, {
          key: "_handleEnter",
          value: function _handleEnter() {
            this._pause();
            return true;
          }
        }, {
          key: "_handlePause",
          value: function _handlePause() {
            this._pause();
            return true;
          }
        }, {
          key: "_handlePlayPause",
          value: function _handlePlayPause() {
            this._pause();
            return true;
          }
        }]);
        return Playing;
      }(this), function (_this2) {
        (0,inherits/* default */.Z)(Paused, _this2);
        var _super3 = ads_component_createSuper(Paused);
        function Paused() {
          (0,classCallCheck/* default */.Z)(this, Paused);
          return _super3.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(Paused, [{
          key: "$enter",
          value: function $enter() {
            this.tag('PlaybackStateIndicator').show('Playing');
          }
        }, {
          key: "_handleEnter",
          value: function _handleEnter() {
            this._play();
            return true;
          }
        }, {
          key: "_handlePlay",
          value: function _handlePlay() {
            this._play();
            return true;
          }
        }, {
          key: "_handlePlayPause",
          value: function _handlePlayPause() {
            this._play();
            return true;
          }
        }]);
        return Paused;
      }(this), function (_this3) {
        (0,inherits/* default */.Z)(AdJingle, _this3);
        var _super4 = ads_component_createSuper(AdJingle);
        function AdJingle() {
          (0,classCallCheck/* default */.Z)(this, AdJingle);
          return _super4.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(AdJingle, [{
          key: "$enter",
          value: function $enter() {
            this.tag('AdJingle').setSmooth('alpha', 1);
          }
        }, {
          key: "$exit",
          value: function $exit() {
            this.tag('AdJingle').setSmooth('alpha', 0);
          }
        }, {
          key: "_getFocused",
          value: function _getFocused() {
            return this;
          }
        }, {
          key: "_handleUp",
          value: function _handleUp() {
            return true;
          }
        }, {
          key: "_handleDown",
          value: function _handleDown() {
            return true;
          }
        }]);
        return AdJingle;
      }(this)];
    }
  }]);
  return Ads;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/player/ads/ads.component.js

;// CONCATENATED MODULE: ./src/modules/player/player.connector.js


var player_connector_mapControllers = function mapControllers(instance) {
  return [{
    selector: getAdsProvider,
    callback: function callback(value) {
      instance.adsProvider = value;
    },
    shouldBeInvokedOnConnect: true
  }, {
    selector: getAdvertising,
    callback: function callback(value) {
      instance.advertising = value;
    },
    shouldBeInvokedOnConnect: true
  }, {
    selector: getJingleImageId,
    callback: function callback(value) {
      instance.postAdJingleImageId = value;
    },
    shouldBeInvokedOnConnect: true
  }, {
    selector: getIsAdError,
    callback: function callback(value) {
      instance.isAdError = value;
    },
    shouldBeInvokedOnConnect: true
  }, {
    selector: isPlayingAds,
    callback: function callback(value) {
      instance.isPlayingAds = value;
    },
    shouldBeInvokedOnConnect: true
  }, {
    selector: getDisplayedAdBreakType,
    callback: function callback(value) {
      instance.adBreakType = value;
    },
    shouldBeInvokedOnConnect: true
  }, {
    selector: player_selectors_getDurationInSeconds,
    callback: function callback(value) {
      instance.durationInSeconds = value;
    },
    shouldBeInvokedOnConnect: true
  }, {
    selector: getVideoSource,
    callback: function callback(value) {
      instance.source = value;
    },
    shouldBeInvokedOnConnect: true
  }, {
    selector: getIsBuffering,
    callback: function callback(value) {
      instance.isBuffering = value;
    },
    shouldBeInvokedOnConnect: true
  }, {
    selector: shouldHideVideoLoader,
    shouldBeInvokedOnConnect: true,
    callback: function callback(value) {
      instance.shouldHideVideoLoader = value;
    }
  }, {
    selector: player_selectors_getElapsedTimeInSeconds,
    callback: function callback(value) {
      instance.elapsedTimeInSeconds = value;
    }
  }, {
    selector: player_selectors_getIsEnded,
    shouldBeInvokedOnConnect: true,
    callback: function callback(value) {
      instance.isEnded = value;
    }
  }, {
    selector: getSelectedAudioTrack,
    shouldBeInvokedOnConnect: false,
    callback: function callback(value) {
      instance.setAudioTrackById(value);
    }
  }, {
    selector: getSelectedSubtitlesTrack,
    shouldBeInvokedOnConnect: false,
    callback: function callback(value) {
      instance.setSubtitlesTrackById(value);
    }
  }];
};
/* harmony default export */ const player_connector = (lightningjs_redux.control(player_connector_mapControllers));
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+youbora-adapter-adengine@1.7.22_@bedrock+ad-engine@5.29.4_@bedrock+html5-engine@3.6._65ly7qdauijepgq243udpmaft4/node_modules/@bedrock/youbora-adapter-adengine/lib/package.json
const lib_package_namespaceObject = {"i8":"1.7.22"};
;// CONCATENATED MODULE: ./node_modules/.pnpm/@bedrock+youbora-adapter-adengine@1.7.22_@bedrock+ad-engine@5.29.4_@bedrock+html5-engine@3.6._65ly7qdauijepgq243udpmaft4/node_modules/@bedrock/youbora-adapter-adengine/lib/src/adapter.js





var YouboraAdsAdapter = youboralib_default().Adapter.extend({
  getVersion: function getVersion() {
    return lib_package_namespaceObject.i8;
  },
  getPlayhead: function getPlayhead() {
    return this.player.getCurrentTime();
  },
  getPlayrate: function getPlayrate() {
    return this.player.getPlayrate();
  },
  getDuration: function getDuration() {
    return this.player.getDuration();
  },
  getBitrate: function getBitrate() {
    var currentAsset = this.player.getCurrentAsset();
    return lodash_default().get(currentAsset, 'bitrate');
  },
  getRendition: function getRendition() {
    var currentAsset = this.player.getCurrentAsset();
    if (currentAsset) {
      return youboralib_default().Util.buildRenditionString(currentAsset.width, currentAsset.height, this.getBitrate());
    }
    return '';
  },
  getTitle: function getTitle() {
    return this.player.getTitle();
  },
  getResource: function getResource() {
    return this.player.getResource();
  },
  getPlayerVersion: function getPlayerVersion() {
    return this.player.getVersion();
  },
  getPlayerName: function getPlayerName() {
    return 'Bedrock-Ad-Engine';
  },
  getPosition: function getPosition() {
    return this.position;
  },
  getGivenBreaks: function getGivenBreaks() {
    return this.player.getSlots().length;
  },
  getBreaksTime: function getBreaksTime() {
    return this.player.getCurrentSlot().ads.reduce(function (acc, currentAd) {
      return acc + currentAd.creatives[0].duration;
    }, 0);
  },
  getExpectedAds: function getExpectedAds() {
    return this.player.getCurrentSlot().ads.length;
  },
  getGivenAds: function getGivenAds() {
    return this.getExpectedAds();
  },
  getIsVisible: function getIsVisible() {
    return youboralib_default().Util.calculateAdViewability(this.player.display.video);
  },
  getAudioEnabled: function getAudioEnabled() {
    return this.player.getAudioEnabled();
  },
  getIsSkippable: function getIsSkippable() {
    return false;
  },
  getIsFullscreen: function getIsFullscreen() {
    return !!document.fullscreenElement;
  },
  getCreativeId: function getCreativeId() {
    var currentAd = this.player.getCurrentAd();
    return lodash_default().get(currentAd, 'id');
  },
  registerListeners: function registerListeners() {
    this.monitorPlayhead(true, false);
    this.references = {};
    this.references[adEvents.AD_INIT] = this.initListener.bind(this);
    this.references[adEvents.AD_PAUSED] = this.pauseListener.bind(this);
    this.references[adEvents.AD_PLAYING] = this.playingListener.bind(this);
    this.references[adEvents.AD_ERROR] = this.errorListener.bind(this);
    this.references[adEvents.AD_STOPPED] = this.endedListener.bind(this);
    this.references[adEvents.AD_IMPRESSION] = this.impressionListener.bind(this);
    this.references[adEvents.AD_VIDEO_FIRST_QUARTILE] = this.firstQuartileListener.bind(this);
    this.references[adEvents.AD_VIDEO_MIDPOINT] = this.midpointListener.bind(this);
    this.references[adEvents.AD_VIDEO_THIRD_QUARTILE] = this.thirdQuartileListener.bind(this);
    this.references[adEvents.AD_VIDEO_COMPLETE] = this.videoCompleteListener.bind(this);
    this.references[adEvents.SLOT_START] = this.slotStartListener.bind(this);
    this.references[adEvents.SLOT_ENDED] = this.slotEndedListener.bind(this);
    this.references[adEvents.REQUEST_COMPLETE] = this.requestCompleteListener.bind(this);
    this.references[adEvents.NO_DURATION_IN_CREATIVE] = this.noDurationListener.bind(this);
    if (this.player && this.references) {
      for (var key in this.references) {
        this.player.addEventListener(key, this.references[key]);
      }
    }
  },
  unregisterListeners: function unregisterListeners() {
    if (this.monitor) this.monitor.stop();
    if (this.player && this.references) {
      for (var key in this.references) {
        this.player.removeEventListener(key, this.references[key]);
        delete this.references[key];
      }
    }
  },
  initListener: function initListener() {
    if (!this.disable) {
      this.fireStart();
    }
  },
  requestCompleteListener: function requestCompleteListener(response) {
    this.fireInit();
    if (response.success) {
      if (!response.slots.length) {
        this.fireManifest((youboralib_default()).Constants.ManifestError.EMPTY, 'Empty manifest');
      }
    } else {
      this.fireManifest((youboralib_default()).Constants.ManifestError.NO_RESPONSE, 'No response');
    }
  },
  slotStartListener: function slotStartListener() {
    this.disable = false;
    var slot = this.player.getCurrentSlot();
    switch (slot.type) {
      case MIDROLL:
        this.position = (youboralib_default()).Constants.AdPosition.Midroll;
        break;
      case PREROLL:
        this.position = (youboralib_default()).Constants.AdPosition.Preroll;
        break;
      default:
        this.disable = true;
    }
    if (!this.disable) {
      this.fireBreakStart();
    }
  },
  slotEndedListener: function slotEndedListener() {
    if (!this.disable) {
      this.fireBreakStop();
      this.position = (youboralib_default()).Constants.AdPosition.Midroll;
    }
  },
  pauseListener: function pauseListener() {
    if (!this.disable) {
      this.firePause();
    }
  },
  playingListener: function playingListener() {
    if (!this.disable) {
      this.fireStart();
      this.fireJoin();
      this.fireResume();
    }
  },
  errorListener: function errorListener(event) {
    var _event$error = event.error,
      message = _event$error.message,
      code = _event$error.code,
      fatal = _event$error.fatal;
    var fireArgs = [code, message, undefined, fatal ? 'fatal' : 'error'];
    if (fatal) {
      this.fireFatalError.apply(this, fireArgs);
    } else {
      this.fireError.apply(this, fireArgs);
    }
  },
  endedListener: function endedListener() {
    if (!this.disable) {
      this.fireStop();
    }
  },
  impressionListener: function impressionListener() {
    if (!this.disable) {
      this.fireStart();
      this.fireJoin();
      this.fireResume();
    }
  },
  firstQuartileListener: function firstQuartileListener() {
    if (!this.disable) {
      this.fireQuartile(1);
    }
  },
  midpointListener: function midpointListener() {
    if (!this.disable) {
      this.fireQuartile(2);
    }
  },
  thirdQuartileListener: function thirdQuartileListener() {
    if (!this.disable) {
      this.fireQuartile(3);
    }
  },
  videoCompleteListener: function videoCompleteListener() {
    if (!this.disable) {
      this.fireStop();
    }
  },
  noDurationListener: function noDurationListener(event) {
    if (!this.disable) {
      this.errorListener(event);
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/player/ads/ads.adapter.js










function ads_adapter_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ads_adapter_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ads_adapter_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ads_adapter_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }












var AdsAdapter = function () {
  function AdsAdapter() {
    (0,classCallCheck/* default */.Z)(this, AdsAdapter);
  }
  (0,createClass/* default */.Z)(AdsAdapter, [{
    key: "init",
    value: (function () {
      var _init = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(_ref) {
        var _this = this;
        var contentHandlers, contentDuration, providerId, providerConfig, Bridge, _yield$getAdPlayerIns, engine, eventHandlers, _this$_renderers, videoRef, containerRef, companionRef, adBridge;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              contentHandlers = _ref.contentHandlers, contentDuration = _ref.contentDuration, providerId = _ref.providerId, providerConfig = _ref.providerConfig;
              if (!(!providerId || !providerConfig)) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return", null);
            case 3:
              Bridge = bridgeClassByProviderId(providerId);
              if (Bridge) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return", null);
            case 6:
              _context.next = 8;
              return getAdPlayerInstance();
            case 8:
              _yield$getAdPlayerIns = _context.sent;
              engine = _yield$getAdPlayerIns.Engine;
              eventHandlers = {
                onBreakStarted: function onBreakStarted(event) {
                  var _ref2 = event || {},
                    type = _ref2.type,
                    silent = _ref2.silent;
                  if (!silent) {
                    var adBreak = get_default()(_this._adBridge, 'engine.currentSlot');
                    lightningjs_redux.dispatch(adBreakStarted(type, _this._adBridge.getSlotsDuration() || getAdsDurationInSeconds(adBreak)));
                  }
                  var analyticsKey = get_default()(AD_ANALYTICS_TYPES.begin, type, null);
                  if (analyticsKey) {
                    setAttributes({
                      adBreakId: event.reference
                    });
                    sendEvent({
                      key: analyticsKey
                    });
                  }
                },
                onBreakEnded: function onBreakEnded() {
                  if (_this._adBridge) {
                    _this._adBridge.endedAdsDuration = 0;
                  }
                  var type = getDisplayedAdBreakType(lightningjs_redux.getState());
                  lightningjs_redux.dispatch(adBreakEnded());
                  var analyticsKey = get_default()(AD_ANALYTICS_TYPES.post, type, null);
                  if (analyticsKey) {
                    sendEvent({
                      key: analyticsKey
                    });
                  }
                },
                onEnded: function onEnded() {
                  lightningjs_redux.dispatch(adEnded());
                  sendEvent({
                    key: 'adComplete'
                  });
                },
                onError: function onError(error) {
                  if (error) {
                    lightningjs_redux.dispatch(adError(error));
                  }
                },
                onPlaying: function onPlaying() {
                  lightningjs_redux.dispatch(adPlaying());
                },
                onPaused: function onPaused() {
                  lightningjs_redux.dispatch(adPaused());
                },
                onProviderLoaded: function onProviderLoaded() {
                  lightningjs_redux.dispatch(adProviderLoaded());
                },
                onAdLoaded: function onAdLoaded() {},
                onProviderUnloaded: function onProviderUnloaded() {},
                onProviderLoading: function onProviderLoading() {},
                onAdStarted: function onAdStarted() {},
                onStarted: function onStarted(event) {
                  setAttributes({
                    adId: event.adId,
                    adDuration: event.duration
                  });
                  sendEvent({
                    key: 'adStarted'
                  });
                },
                onAdStopped: function onAdStopped() {},
                onAdPaused: function onAdPaused() {},
                onFirstQuartile: function onFirstQuartile() {
                  sendEvent({
                    key: 'adFirstQuartile'
                  });
                },
                onMidPoint: function onMidPoint() {
                  sendEvent({
                    key: 'adMidPoint'
                  });
                },
                onThirdQuartile: function onThirdQuartile() {
                  sendEvent({
                    key: 'adThirdQuartile'
                  });
                },
                onBreakCapping: function onBreakCapping() {}
              };
              this._renderers = ads_utils_createRenderers('ads');
              _this$_renderers = this._renderers, videoRef = _this$_renderers.video, containerRef = _this$_renderers.container, companionRef = _this$_renderers.companion;
              adBridge = new Bridge(ads_adapter_objectSpread(ads_adapter_objectSpread({}, providerConfig), {}, {
                contentDuration: contentDuration,
                features: {
                  lazy: Boolean(src.featureFlipping.player_adLazyVmap)
                },
                volume: providerConfig.volume || DEFAULT_VOLUME_LEVEL
              }), eventHandlers, contentHandlers, {
                VideoEngine: engine,
                storage: platformStorage,
                adEventError: {
                  adUnknownError: 'AD_UNKNOWN_ERROR',
                  adError: 'AD_ERROR'
                }
              });
              adBridge.setContainerRef(containerRef);
              adBridge.setCompanionRef(companionRef);
              adBridge.setVideoRef(videoRef);
              adBridge.contentHasStarted();
              this._adTimeUpdateHandler = this.onAdTimeUpdate.bind(this);
              this._renderers.video.addEventListener('timeupdate', this._adTimeUpdateHandler);
              this._adBridge = adBridge;
              return _context.abrupt("return", {
                bridge: adBridge
              });
            case 22:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function init(_x) {
        return _init.apply(this, arguments);
      }
      return init;
    }())
  }, {
    key: "onAdTimeUpdate",
    value: function onAdTimeUpdate(event) {
      if (!this._adBridge || !event.target || !Number.isFinite(event.target.currentTime)) {
        return;
      }
      lightningjs_redux.dispatch(adBreakTimeUpdate(event.target.currentTime + this._adBridge.getEndedAdsDuration()));
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this._adBridge) {
        try {
          this._adBridge.release();
        } catch (error) {
          lightningjs_redux.dispatch(error_actions_errorAction(error_constants_ERROR_LEVELS.SILENT, error_constants_ERROR_TYPES.GENERAL, error.message));
        }
      }
      this._adBridge = null;
      if (this._renderers) {
        Object.values(this._renderers).forEach(function (renderer) {
          if (renderer && renderer.parentNode) {
            renderer.parentNode.removeChild(renderer);
          }
        });
        if (this._renderers.video) {
          this._renderers.video.removeEventListener('timeupdate', this._adTimeUpdateHandler);
        }
      }
      this._renderers = null;
      this._adTimeUpdateHandler = null;
    }
  }]);
  return AdsAdapter;
}();
;// CONCATENATED MODULE: ./src/modules/player/player.dispatcher.js





var playerDispatcher = function playerDispatcher(event, payload) {
  if (event === ERROR) {
    var error = get_default()(payload, 'error.error', payload.error);
    lightningjs_redux.dispatch(playbackError(error));
    return;
  }
  if (event) {
    lightningjs_redux.dispatch({
      type: withPlayerPrefix(event.toUpperCase()),
      payload: payload
    });
  }
};
;// CONCATENATED MODULE: ./src/modules/player/player.adapter.js























var PlayerAdapter = function () {
  function PlayerAdapter() {
    (0,classCallCheck/* default */.Z)(this, PlayerAdapter);
  }
  (0,createClass/* default */.Z)(PlayerAdapter, [{
    key: "init",
    value: function () {
      var _init = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(settings) {
        var _yield$Promise$all, _yield$Promise$all2, content, ads, state;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Promise.all([this.makeContentPlayer(), this.makeAdsPlayer(settings.ads)]);
            case 2:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = (0,slicedToArray/* default */.Z)(_yield$Promise$all, 2);
              content = _yield$Promise$all2[0];
              ads = _yield$Promise$all2[1];
              state = lightningjs_redux.getState();
              this._plugins = (Array.isArray(content.plugins) ? content.plugins : []).map(function (Plugin) {
                return new Plugin();
              });
              this._plugins.forEach(function (plugin) {
                plugin.init({
                  engine: content.player,
                  options: fetchPlayerPluginDataById(plugin.id, state),
                  sendInitEvent: Boolean(src.featureFlipping.youboraAdsAdapter)
                });
              });
              return _context.abrupt("return", {
                content: content,
                ads: ads
              });
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function init(_x) {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "makeContentPlayer",
    value: function () {
      var _makeContentPlayer = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2() {
        var _yield$this$initVideo, _yield$this$initVideo2, player, plugins;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.initVideo();
            case 2:
              _yield$this$initVideo = _context2.sent;
              _yield$this$initVideo2 = (0,slicedToArray/* default */.Z)(_yield$this$initVideo, 2);
              player = _yield$this$initVideo2[0];
              plugins = _yield$this$initVideo2[1];
              return _context2.abrupt("return", {
                player: player,
                plugins: plugins
              });
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function makeContentPlayer() {
        return _makeContentPlayer.apply(this, arguments);
      }
      return makeContentPlayer;
    }()
  }, {
    key: "initVideo",
    value: function () {
      var _initVideo = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee3() {
        var _yield$getPlayerInsta, Engine, plugins, player, _createRenderers, videoRef, containerRef, subtitlesContainer, state, _ref, audioTrack, textTrack, userPreferences, config;
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return getPlayerInstance();
            case 2:
              _yield$getPlayerInsta = _context3.sent;
              Engine = _yield$getPlayerInsta.Engine;
              plugins = _yield$getPlayerInsta.plugins;
              this.resetVideo();
              player = new Engine();
              _createRenderers = createRenderers('main-player'), videoRef = _createRenderers.video, containerRef = _createRenderers.container, subtitlesContainer = _createRenderers.subtitles;
              this._video = videoRef;
              this._container = containerRef;
              state = lightningjs_redux.getState();
              _ref = state.player.preferences || {}, audioTrack = _ref.audioTrack, textTrack = _ref.textTrack;
              userPreferences = {
                audio: audioPreferenceToManifestTrack(audioTrack),
                text: textPreferenceToManifestTrack(textTrack)
              };
              _context3.next = 15;
              return enhancePlayerConfig({
                dispatcher: playerDispatcher,
                drm: {
                  settings: src.video.drm,
                  token: {
                    handler: function handler() {
                      return lightningjs_redux.dispatch(player_actions_fetchUpfrontToken(src.defaultService));
                    }
                  }
                },
                element: videoRef,
                subtitlesContainer: subtitlesContainer,
                userPreferences: userPreferences
              });
            case 15:
              config = _context3.sent;
              player.init(config);
              if (this._plugins) {
                this._plugins.forEach(function (plugin) {
                  plugin.connect(player);
                });
              }
              return _context3.abrupt("return", [player, plugins]);
            case 19:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function initVideo() {
        return _initVideo.apply(this, arguments);
      }
      return initVideo;
    }()
  }, {
    key: "makeAdsPlayer",
    value: function makeAdsPlayer(settings) {
      if (!this._adsAdapter) {
        this._adsAdapter = new AdsAdapter();
      }
      return this._adsAdapter.init(settings);
    }
  }, {
    key: "notifyAdBridgeInit",
    value: function notifyAdBridgeInit(bridge) {
      if (src.featureFlipping.youboraAdsAdapter && this._plugins && bridge) {
        this._plugins.forEach(function (plugin) {
          if (plugin.setAdsAdapter) {
            plugin.setAdsAdapter(new YouboraAdsAdapter(bridge.engine));
          }
        });
      }
    }
  }, {
    key: "resetVideo",
    value: function resetVideo() {
      if (this._plugins) {
        this._plugins.forEach(function (plugin) {
          plugin.disconnect();
        });
      }
      if (this._container && !REUSE_VIDEO_NODE) {
        while (this._container.firstChild) {
          this._container.removeChild(this._container.lastChild);
        }
        if (this._container.parentNode) {
          this._container.parentNode.removeChild(this._container);
        }
      }
      this._container = null;
      this._video = null;
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this._plugins) {
        this._plugins.forEach(function (plugin) {
          plugin.release();
        });
      }
      this._plugins = [];
      this.resetVideo();
      if (this._adsAdapter) {
        this._adsAdapter.reset();
      }
      this._adsAdapter = null;
    }
  }, {
    key: "firePluginEvent",
    value: function firePluginEvent(eventName) {
      this._plugins.forEach(function (plugin) {
        var adapter = plugin.getAdapter();
        if (adapter && adapter[eventName] && typeof adapter[eventName] === 'function') {
          adapter[eventName]();
        }
      });
    }
  }, {
    key: "firePluginEndedEvent",
    value: function firePluginEndedEvent() {
      this.firePluginEvent('endedListener');
    }
  }, {
    key: "firePluginPauseEvent",
    value: function firePluginPauseEvent() {
      this.firePluginEvent('pauseListener');
    }
  }]);
  return PlayerAdapter;
}();
;// CONCATENATED MODULE: ./src/modules/player/player.style.js

var player_style_SPINNER_SIZE;




var player_style_defaultContext = makeDefaultStylingContext();
var player_player_style_SPINNER_SIZE = (player_style_SPINNER_SIZE = {}, (0,defineProperty/* default */.Z)(player_style_SPINNER_SIZE, HD, 200), (0,defineProperty/* default */.Z)(player_style_SPINNER_SIZE, FULL_HD, 200), player_style_SPINNER_SIZE);
var POST_AD_JINGLE_OUT_TRANSITION = {
  duration: 0.3,
  delay: POST_AD_JINGLE_DELAY
};
var player_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : player_style_defaultContext;
  var screenSize = context.screenSize;
  var spinnerSize = player_player_style_SPINNER_SIZE[screenSize];
  return {
    w: SCREEN_WIDTH[screenSize],
    h: sizes_SCREEN_HEIGHT[screenSize],
    Ads: {},
    PostAdJingle: {
      alpha: 0,
      w: SCREEN_WIDTH[screenSize],
      h: sizes_SCREEN_HEIGHT[screenSize]
    },
    Spinner: {
      alpha: 0,
      mount: 0.5,
      w: spinnerSize,
      h: spinnerSize,
      x: middle,
      y: middle
    },
    Subtitles: {}
  };
};
;// CONCATENATED MODULE: ./src/modules/player/player.component.js













function player_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function player_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? player_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : player_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function player_component_createSuper(t) { var r = player_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function player_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (player_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }




















var Player = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Player, _Lightning$Component);
  var _super = player_component_createSuper(Player);
  function Player() {
    (0,classCallCheck/* default */.Z)(this, Player);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Player, [{
    key: "_construct",
    value: function _construct() {
      this._durationInSeconds = 0;
      this._isAdError = false;
      this._isContentLoadingStarted = false;
      this._containsAds = false;
    }
  }, {
    key: "_attach",
    value: function _attach() {
      this.stage.gc();
    }
  }, {
    key: "_active",
    value: function _active() {
      this._adapter = new PlayerAdapter();
      this._unsubscribe = player_connector(this);
      this.stage.gc();
    }
  }, {
    key: "_inactive",
    value: function _inactive() {
      if (this._unsubscribe) {
        this._unsubscribe();
        this._unsubscribe = null;
      }
      if (lightningjs_redux.dispatch) {
        lightningjs_redux.dispatch(player_constants_reset());
      }
      this._stop();
    }
  }, {
    key: "source",
    set: function set(value) {
      if (this._source !== value) {
        this._source = value;
        if (this._source) {
          this._start();
        } else {
          this._stop();
        }
      }
    }
  }, {
    key: "isBuffering",
    set: function set(value) {
      this.tag('Spinner').setSmooth('alpha', value ? 1 : 0);
    }
  }, {
    key: "shouldHideVideoLoader",
    set: function set(value) {
      if (value) {
        this.tag('PostAdJingle').setSmooth('alpha', 0, POST_AD_JINGLE_OUT_TRANSITION);
      }
    }
  }, {
    key: "elapsedTimeInSeconds",
    set: function set(value) {
      if (this._player) {
        this._elapsedTimeInSeconds = value;
        if (!this._position) {
          this._position = value;
          this._percentageCounter = calculatePartOfDuration(value, this._durationInSeconds);
        }
        if (value >= this._quartiles[this._percentageCounter]) {
          this._percentageCounter += 1;
          sendEvent({
            key: "completion".concat(this._percentageCounter * PERCENTAGE_EVENT_DURATION)
          });
        }
      }
      if (this._adBridge) {
        this._adBridge.contentHasProgressed(value);
      }
    }
  }, {
    key: "durationInSeconds",
    set: function set(value) {
      this._durationInSeconds = value;
      this._quartiles = [value, value, value].map(function (value, index) {
        return value * (index + 1) * PERCENTAGE_EVENT_DURATION * 0.01;
      });
    }
  }, {
    key: "advertising",
    set: function set(value) {
      this._advertising = value;
    }
  }, {
    key: "postAdJingleImageId",
    set: function set(value) {
      var adJingleView = this.tag('PostAdJingle');
      var finalW = adJingleView.finalW,
        finalH = adJingleView.finalH;
      adJingleView.texture = cover(imageService.getUrl(value, finalW, finalH, {
        fit: IMAGE_FIT_SCALE_CROP,
        quality: IMAGE_QUALITY,
        format: DEFAULT_IMAGE_FORMAT
      }), finalW, finalH);
      adJingleView.loadTexture();
    }
  }, {
    key: "adsProvider",
    set: function set(value) {
      this._adsProvider = value;
    }
  }, {
    key: "isAdError",
    set: function set(value) {
      this._isAdError = value;
    }
  }, {
    key: "isPlayingAds",
    set: function set(value) {
      var _this = this;
      this._isPlayingAds = value;
      if (value) {
        this._containsAds = true;
        if (this._player) {
          this._player.reset();
          this.isBuffering = false;
          lightningjs_redux.dispatch(paused());
          this._player = null;
        }
        if (this._adapter) {
          this._adapter.resetVideo();
          lightningjs_redux.dispatch(setScreenSaverIsLocked(true));
        }
      } else if (!this._player && this._source) {
        if (POST_AD_JINGLE_DELAY && this._adBreakType && this._adBreakType.startsWith(AD_BREAK_MID_ROLL)) {
          var jingle = this.tag('PostAdJingle');
          jingle.alpha = 1.0;
        }
        this._adapter.initVideo().then(function (_ref) {
          var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 1),
            player = _ref2[0];
          _this._player = player;
          _this._startContent();
          lightningjs_redux.dispatch(setScreenSaverIsLocked(true));
        });
      }
      this.tag('Ads').visible = value;
      this._refocus();
    }
  }, {
    key: "adBreakType",
    set: function set(value) {
      this._adBreakType = value;
    }
  }, {
    key: "isEnded",
    set: function set(value) {
      console.log('[player.component] content duration on the end event ', this._durationInSeconds);
      if (value) {
        this._adapter.firePluginEndedEvent();
      }
    }
  }, {
    key: "shouldUseAdBridge",
    get: function get() {
      return this._isPlayingAds && this._adBridge && !this._isAdError;
    }
  }, {
    key: "play",
    value: function play() {
      if (this.shouldUseAdBridge) {
        try {
          this._adBridge.play();
        } catch (error) {
          console.error('[Player.component] Could not play', error);
        }
      } else if (this._player) {
        this._player.play();
        this.stage.gc();
      }
      lightningjs_redux.dispatch(setScreenSaverIsLocked(true));
    }
  }, {
    key: "pause",
    value: function pause() {
      if (this.shouldUseAdBridge) {
        this._adBridge.pause();
      } else if (this._player) {
        this._player.pause();
      }
      lightningjs_redux.dispatch(setScreenSaverIsLocked(false));
    }
  }, {
    key: "seek",
    value: function seek(position) {
      console.log('[player.component] seek position ', position);
      if (this._player) {
        this._player.seek(position);
        var method = this._position - position < 0 ? 'forward' : 'backward';
        this._percentageCounter = calculatePartOfDuration(position, this._durationInSeconds);
        this._position = position;
        sendEvent({
          key: method
        });
      }
    }
  }, {
    key: "backToLive",
    value: function backToLive() {
      if (this._player) {
        this._player.backToLive();
      }
    }
  }, {
    key: "setAudioTrackById",
    value: function setAudioTrackById(id) {
      if (this._player) {
        this._player.setAudioTrackById(id);
      }
    }
  }, {
    key: "setSubtitlesTrackById",
    value: function setSubtitlesTrackById(id) {
      if (this._player) {
        this._player.setSubtitlesTrackById(id);
      }
    }
  }, {
    key: "_start",
    value: function () {
      var _start2 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee() {
        var _this2 = this;
        var _yield$this$_adapter$, content, ads;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this._adapter.init({
                ads: {
                  providerId: this._adsProvider,
                  providerConfig: get_default()(this._advertising, this._adsProvider),
                  contentDuration: this._durationInSeconds,
                  contentHandlers: {
                    playerPlay: function playerPlay() {
                      if (!_this2._isContentLoadingStarted) {
                        _this2._startContent();
                      }
                    },
                    jingleDisplay: function jingleDisplay(type) {
                      return lightningjs_redux.dispatch(showAdJingle(type));
                    },
                    playerPause: function playerPause() {
                      _this2._adapter.firePluginPauseEvent();
                    }
                  }
                }
              });
            case 2:
              _yield$this$_adapter$ = _context.sent;
              content = _yield$this$_adapter$.content;
              ads = _yield$this$_adapter$.ads;
              this._player = content.player;
              this._adBridge = ads ? ads.bridge : null;
              if (this._adBridge) {
                this._adBridge.init().then(function () {
                  if (_this2._adBridge) {
                    _this2._adapter.notifyAdBridgeInit(_this2._adBridge);
                    _this2._adBridge.requestAds({}, {
                      start: 0,
                      duration: _this2._durationInSeconds
                    });
                  }
                });
              } else {
                this._startContent();
              }
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function _start() {
        return _start2.apply(this, arguments);
      }
      return _start;
    }()
  }, {
    key: "_startContent",
    value: function () {
      var _startContent2 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2() {
        var shouldAutoPlay, reference, startTime;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (this._source) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              shouldAutoPlay = this._isContentLoadingStarted ? true : this._source.shouldAutoPlay;
              if (!this._isContentLoadingStarted) {
                lightningjs_redux.dispatch(loadContent());
              }
              this._isContentLoadingStarted = true;
              _context2.prev = 5;
              _context2.next = 8;
              return getOriginalUrlFromReference(this._source.reference);
            case 8:
              reference = _context2.sent;
              _context2.next = 14;
              break;
            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](5);
              throw new Error('Failed to fetch manifest redirect');
            case 14:
              if (this._player) {
                startTime = Number.isFinite(this._elapsedTimeInSeconds) ? this._elapsedTimeInSeconds : get_default()(this._source, 'startTime');
                this._player.start(player_component_objectSpread(player_component_objectSpread({}, this._source), {}, {
                  startTime: startTime,
                  shouldAutoPlay: shouldAutoPlay,
                  reference: reference
                }));
              }
            case 15:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[5, 11]]);
      }));
      function _startContent() {
        return _startContent2.apply(this, arguments);
      }
      return _startContent;
    }()
  }, {
    key: "_stop",
    value: function _stop() {
      if (this._player) {
        this._player.reset();
        this._player = null;
      }
      if (this._adapter) {
        this._adapter.reset();
        this._adapter = null;
      }
      if (this._adBridge) {
        this._adBridge.release();
      }
      this._containsAds = false;
      this._isContentLoadingStarted = false;
      if (lightningjs_redux.dispatch) {
        lightningjs_redux.dispatch(setScreenSaverIsLocked(false));
      }
      sendEvent({
        key: 'playbackStopped'
      });
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this.tag('Ads').visible ? this.tag('Ads') : undefined;
    }
  }, {
    key: "setlBannerState",
    value: function setlBannerState(enable) {
      switchLBannerState(this._adapter._video, enable);
    }
  }], [{
    key: "_template",
    value: function _template() {
      var _signals;
      return merge_default()({
        Ads: {
          type: ads_component_Ads,
          signals: (_signals = {}, (0,defineProperty/* default */.Z)(_signals, PAUSE_SIGNAL, 'pause'), (0,defineProperty/* default */.Z)(_signals, PLAY_SIGNAL, 'play'), _signals)
        },
        Spinner: {
          type: spinner_component
        },
        Subtitles: {
          type: subtitles_component_Subtitles
        },
        PostAdJingle: {}
      }, player_style_getInitialStyle());
    }
  }]);
  return Player;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/video/lBanner/lBanner.style.js


var lBanner_style_defaultContext = makeDefaultStylingContext();
var lBanner_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : lBanner_style_defaultContext;
  var screenSize = context.screenSize;
  return {
    w: SCREEN_WIDTH[screenSize],
    h: sizes_SCREEN_HEIGHT[screenSize],
    visible: false
  };
};
;// CONCATENATED MODULE: ./src/modules/video/lBanner/lBanner.connector.js


var lBanner_connector_mapControllers = function mapControllers(instance) {
  return [{
    selector: player_selectors_getElapsedTimeInSeconds,
    shouldBeInvokedOnConnect: true,
    callback: function callback(value) {
      instance.elapsed = value;
    }
  }, {
    selector: getLBannerProvider,
    callback: function callback(value) {
      instance.provider = value;
    },
    shouldBeInvokedOnConnect: true
  }, {
    selector: getAdvertising,
    callback: function callback(value) {
      instance.advertising = value;
    },
    shouldBeInvokedOnConnect: true
  }, {
    selector: getLBannerState,
    callback: function callback(value) {
      instance.lBannerState = value;
    },
    shouldBeInvokedOnConnect: true
  }, {
    selector: isPlayingAds,
    callback: function callback(value) {
      instance.isPlayingAds = value;
    },
    shouldBeInvokedOnConnect: true
  }];
};
/* harmony default export */ const lBanner_connector = (lightningjs_redux.control(lBanner_connector_mapControllers));
;// CONCATENATED MODULE: ./src/modules/video/lBanner/lBanner.component.js







function lBanner_component_createSuper(t) { var r = lBanner_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function lBanner_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (lBanner_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }







var LBanner = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(LBanner, _Lightning$Component);
  var _super = lBanner_component_createSuper(LBanner);
  function LBanner() {
    (0,classCallCheck/* default */.Z)(this, LBanner);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(LBanner, [{
    key: "_attach",
    value: function _attach() {
      this._unsubscribe = lBanner_connector(this);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      if (this._unsubscribe) {
        this._unsubscribe();
        this._unsubscribe = null;
      }
      if (this._displayTimeout) {
        clearTimeout(this._displayTimeout);
      }
      this._shown = null;
    }
  }, {
    key: "show",
    value: function show() {
      this.visible = true;
    }
  }, {
    key: "hide",
    value: function hide() {
      this.visible = false;
    }
  }, {
    key: "elapsed",
    set: function set(value) {
      var _this = this;
      if (this._lBannerState || !this._data || !this.src) {
        return;
      }
      if (this._data.cuePoints.includes(value)) {
        if (this._shown[value]) {
          return;
        }
        this._shown[value] = true;
        lightningjs_redux.dispatch(setLBannerShow());
        this._displayTimeout = setTimeout(function () {
          if (_this._isPlayingAds) {
            return;
          }
          lightningjs_redux.dispatch(setLBannerHide());
        }, this._data.duration * 1000);
      }
    }
  }, {
    key: "provider",
    set: function set(value) {
      this._provider = value;
    }
  }, {
    key: "isPlayingAds",
    set: function set(value) {
      this._isPlayingAds = value;
      if (this._lBannerState && !this._isPlayingAds) {
        lightningjs_redux.dispatch(setLBannerHide());
      }
    }
  }, {
    key: "advertising",
    set: function set(value) {
      var _this2 = this;
      this._advertising = value;
      if (!this._advertising || !this._advertising[this._provider]) {
        return;
      }
      this._data = this._advertising[this._provider];
      this._shown = {};
      requestGet(this._data.host).responseType('document').then(function (response) {
        var manifest = response.body;
        var src = manifest.querySelector('StaticResource').textContent;
        _this2.src = src;
        _this2.loadTexture();
      }).catch(function () {
        _this2.src = '';
      });
    }
  }, {
    key: "lBannerState",
    set: function set(value) {
      this._lBannerState = value;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        rect: true
      }, lBanner_style_getInitialStyle());
    }
  }]);
  return LBanner;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/player/interface/eventMarker/eventMarker.style.js

var _DIAMETER, eventMarker_style_ICON_HEIGHT;







var eventMarker_style_defaultContext = makeDefaultStylingContext();
var eventMarker_style_colors = {
  background: makeThemeColor(SECONDARY)
};
var DIAMETER = (_DIAMETER = {}, (0,defineProperty/* default */.Z)(_DIAMETER, HD, 168), (0,defineProperty/* default */.Z)(_DIAMETER, FULL_HD, 168), _DIAMETER);
var eventMarker_eventMarker_style_ICON_HEIGHT = (eventMarker_style_ICON_HEIGHT = {}, (0,defineProperty/* default */.Z)(eventMarker_style_ICON_HEIGHT, HD, 72), (0,defineProperty/* default */.Z)(eventMarker_style_ICON_HEIGHT, FULL_HD, 72), eventMarker_style_ICON_HEIGHT);
var getTexture = function getTexture(context) {
  var screenSize = context.screenSize;
  var size = DIAMETER[screenSize];
  return src_Lightning.Tools.getRoundRect(size, size, Math.round(size / 2), 0, colors_TRANSPARENT, true, colors_WHITE);
};
var eventMarker_style_getInitialStyle = memoize_default()(function () {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : eventMarker_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  var size = DIAMETER[screenSize];
  var iconStyle = {
    mount: 0.5,
    x: middle,
    y: middle
  };
  return {
    alpha: 0,
    w: size,
    h: size,
    Background: {
      color: eventMarker_style_colors.background[colorMode],
      texture: getTexture(context),
      w: size,
      h: size
    },
    PlayIcon: iconStyle,
    PauseIcon: iconStyle
  };
}, cacheResolver);
;// CONCATENATED MODULE: ./src/modules/player/interface/eventMarker/envetMarker.utils.js



var envetMarker_utils_makeIcon = function makeIcon(name) {
  return {
    type: Icon,
    iconData: {
      picto: {
        name: name,
        collection: ICON_COLLECTION.CONTROLS
      },
      viewBox: {
        h: eventMarker_eventMarker_style_ICON_HEIGHT[eventMarker_style_defaultContext.screenSize]
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/player/interface/eventMarker/eventMarker.component.js






function eventMarker_component_createSuper(t) { var r = eventMarker_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function eventMarker_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (eventMarker_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }




var Toggle = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Toggle, _Lightning$Component);
  var _super = eventMarker_component_createSuper(Toggle);
  function Toggle() {
    (0,classCallCheck/* default */.Z)(this, Toggle);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Toggle, [{
    key: "$enter",
    value: function $enter() {
      if (!this.transitionAnimation) {
        this.transitionAnimation = this.animation({
          duration: 1,
          stopMethod: 'immediate',
          actions: [{
            p: 'scale',
            v: {
              0: {
                v: 1
              },
              1: {
                v: 1.5
              }
            }
          }, {
            p: 'alpha',
            v: {
              0: {
                v: 0
              },
              0.3: {
                v: 0.3
              },
              0.4: {
                v: 0.4
              },
              0.5: {
                v: 0.5
              },
              0.6: {
                v: 0.5
              },
              0.8: {
                v: 0.3
              },
              1: {
                v: 0
              }
            }
          }]
        });
      }
      this.transitionAnimation.start();
    }
  }, {
    key: "show",
    value: function show(state) {
      this._setState(state);
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Background: {},
        PlayIcon: envetMarker_utils_makeIcon('Play'),
        PauseIcon: envetMarker_utils_makeIcon('Pause')
      }, eventMarker_style_getInitialStyle());
    }
  }, {
    key: "_states",
    value: function _states() {
      return [function (_this) {
        (0,inherits/* default */.Z)(Playing, _this);
        var _super2 = eventMarker_component_createSuper(Playing);
        function Playing() {
          (0,classCallCheck/* default */.Z)(this, Playing);
          return _super2.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(Playing, [{
          key: "$enter",
          value: function $enter() {
            this.tag('PlayIcon').visible = true;
            this.tag('PauseIcon').visible = false;
            (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(Playing.prototype), "$enter", this).call(this);
          }
        }]);
        return Playing;
      }(this), function (_this2) {
        (0,inherits/* default */.Z)(Paused, _this2);
        var _super3 = eventMarker_component_createSuper(Paused);
        function Paused() {
          (0,classCallCheck/* default */.Z)(this, Paused);
          return _super3.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(Paused, [{
          key: "$enter",
          value: function $enter() {
            this.tag('PlayIcon').visible = false;
            this.tag('PauseIcon').visible = true;
            (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(Paused.prototype), "$enter", this).call(this);
          }
        }]);
        return Paused;
      }(this)];
    }
  }]);
  return Toggle;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/player/interface/sideGlass/sideGlass.style.js

var sideGlass_style_WIDTH, sideGlass_style_PADDING_LEFT, sideGlass_style_PADDING_TOP, sideGlass_style_PADDING_BOTTOM, sideGlass_style_CONTENT_GAP, sideGlass_style_HorizontalCard$Templ, _PADDINGS;
function sideGlass_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function sideGlass_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? sideGlass_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : sideGlass_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }







var sideGlass_style_defaultContext = makeDefaultStylingContext();
var sideGlass_sideGlass_style_WIDTH = (sideGlass_style_WIDTH = {}, (0,defineProperty/* default */.Z)(sideGlass_style_WIDTH, HD, 640), (0,defineProperty/* default */.Z)(sideGlass_style_WIDTH, FULL_HD, 960), sideGlass_style_WIDTH);
var sideGlass_style_HEIGHT = sideGlass_style_objectSpread({}, sizes_SCREEN_HEIGHT);
var sideGlass_sideGlass_style_PADDING_LEFT = (sideGlass_style_PADDING_LEFT = {}, (0,defineProperty/* default */.Z)(sideGlass_style_PADDING_LEFT, HD, 40), (0,defineProperty/* default */.Z)(sideGlass_style_PADDING_LEFT, FULL_HD, 40), sideGlass_style_PADDING_LEFT);
var sideGlass_sideGlass_style_PADDING_TOP = (sideGlass_style_PADDING_TOP = {}, (0,defineProperty/* default */.Z)(sideGlass_style_PADDING_TOP, HD, safetyMargins.vertical[HD]), (0,defineProperty/* default */.Z)(sideGlass_style_PADDING_TOP, FULL_HD, safetyMargins.vertical[FULL_HD]), sideGlass_style_PADDING_TOP);
var sideGlass_sideGlass_style_PADDING_BOTTOM = (sideGlass_style_PADDING_BOTTOM = {}, (0,defineProperty/* default */.Z)(sideGlass_style_PADDING_BOTTOM, HD, safetyMargins.vertical[HD]), (0,defineProperty/* default */.Z)(sideGlass_style_PADDING_BOTTOM, FULL_HD, safetyMargins.vertical[FULL_HD]), sideGlass_style_PADDING_BOTTOM);
var sideGlass_sideGlass_style_CONTENT_GAP = (sideGlass_style_CONTENT_GAP = {}, (0,defineProperty/* default */.Z)(sideGlass_style_CONTENT_GAP, HD, 16), (0,defineProperty/* default */.Z)(sideGlass_style_CONTENT_GAP, FULL_HD, 16), sideGlass_style_CONTENT_GAP);
var PADDINGS = (_PADDINGS = {}, (0,defineProperty/* default */.Z)(_PADDINGS, HorizontalCard.Templates.HorizontalCard, (sideGlass_style_HorizontalCard$Templ = {}, (0,defineProperty/* default */.Z)(sideGlass_style_HorizontalCard$Templ, HD, 0), (0,defineProperty/* default */.Z)(sideGlass_style_HorizontalCard$Templ, FULL_HD, 0), sideGlass_style_HorizontalCard$Templ)), (0,defineProperty/* default */.Z)(_PADDINGS, HorizontalSquare.Templates.HorizontalSquare, sideGlass_sideGlass_style_PADDING_LEFT), _PADDINGS);
var Z_INDEX_FOCUSED = 1;
var Z_INDEX_UNFOCUSED = 1;
var sideGlass_style_colors = {
  background: makeThemeColor(TERTIARY),
  backgroundOverlay: makeThemeColor(PRIMARY, 0.1)
};
var getContentWidth = function getContentWidth(itemTemplate, screenSize) {
  return sideGlass_sideGlass_style_WIDTH[screenSize] - sideGlass_sideGlass_style_PADDING_LEFT[screenSize] - (PADDINGS[itemTemplate] ? PADDINGS[itemTemplate][screenSize] : 0);
};
var sideGlass_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sideGlass_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  return {
    visible: false,
    x: SCREEN_WIDTH[screenSize],
    w: sideGlass_sideGlass_style_WIDTH[screenSize],
    h: sideGlass_style_HEIGHT[screenSize],
    color: sideGlass_style_colors.background[colorMode],
    BackgroundOverlay: {
      color: sideGlass_style_colors.backgroundOverlay[colorMode],
      w: sideGlass_sideGlass_style_WIDTH[screenSize],
      h: sideGlass_style_HEIGHT[screenSize]
    },
    Container: {
      x: sideGlass_sideGlass_style_PADDING_LEFT[screenSize],
      y: sideGlass_sideGlass_style_PADDING_TOP[screenSize]
    }
  };
};
var sideGlass_style_getFocusedStyle = memoize_default()(function (screenSize) {
  return {
    visible: true,
    smooth: {
      x: SCREEN_WIDTH[screenSize] - sideGlass_sideGlass_style_WIDTH[screenSize]
    }
  };
});
var sideGlass_style_getUnFocusedStyle = memoize_default()(function (screenSize) {
  return {
    smooth: {
      x: SCREEN_WIDTH[screenSize]
    }
  };
});
;// CONCATENATED MODULE: ./src/modules/player/interface/sideGlass/sideGlass.constants.js

var _TEMPLATES;


var sideGlass_constants_CLOSE_SIGNAL = 'close';
var TEMPLATES = (_TEMPLATES = {}, (0,defineProperty/* default */.Z)(_TEMPLATES, HorizontalCard.Templates.HorizontalCard, HorizontalCard), (0,defineProperty/* default */.Z)(_TEMPLATES, HorizontalSquare.Templates.HorizontalSquare, HorizontalSquare), _TEMPLATES);
;// CONCATENATED MODULE: ./src/modules/player/interface/sideGlass/sideGlass.connector.js


var sideGlass_connector_mapControllers = function mapControllers(instance) {
  return [{
    shouldBeInvokedOnConnect: true,
    selector: getSideGlassContent,
    callback: function callback(value) {
      instance.data = value;
    }
  }];
};
/* harmony default export */ const sideGlass_connector = (lightningjs_redux.control(sideGlass_connector_mapControllers));
;// CONCATENATED MODULE: ./src/modules/player/interface/sideGlass/sideGlass.component.js








function sideGlass_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function sideGlass_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? sideGlass_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : sideGlass_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function sideGlass_component_createSuper(t) { var r = sideGlass_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function sideGlass_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (sideGlass_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }










var SideGlass = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(SideGlass, _Lightning$Component);
  var _super = sideGlass_component_createSuper(SideGlass);
  function SideGlass() {
    (0,classCallCheck/* default */.Z)(this, SideGlass);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(SideGlass, [{
    key: "_construct",
    value: function _construct() {
      this._style = sideGlass_style_defaultContext;
      this._index = 0;
      this._maxIndex = 0;
      this._focused = null;
      this._isLiveSideGlass = false;
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this._focused = null;
      if (this._unsubscribe) {
        this._unsubscribe();
      }
    }
  }, {
    key: "_active",
    value: function _active() {
      if (!this._unsubscribe) {
        this._unsubscribe = sideGlass_connector(this);
      }
    }
  }, {
    key: "data",
    set: function set(value) {
      var _this = this;
      if (!value) {
        return;
      }
      var itemTemplate = get_default()(value, 'content.contentTemplateId');
      var template = TEMPLATES[itemTemplate];
      if (!template) {
        itemTemplate = Object.keys(TEMPLATES)[0];
        template = TEMPLATES[itemTemplate];
      }
      var screenSize = this._style.screenSize;
      var block = get_default()(value, 'content.items', []);
      var itemSize = sideGlass_component_objectSpread(sideGlass_component_objectSpread({}, template.Sizes[itemTemplate][this._style.screenSize]), {}, {
        w: getContentWidth(itemTemplate, screenSize)
      });
      var blockTheme = getLayoutTheme(get_default()(value, 'theme'));
      var paddingTop = sideGlass_sideGlass_style_PADDING_TOP[screenSize];
      var paddingBottom = sideGlass_sideGlass_style_PADDING_BOTTOM[screenSize];
      var contentGap = sideGlass_sideGlass_style_CONTENT_GAP[screenSize];
      var panelHeight = sideGlass_style_HEIGHT[screenSize];
      var halfOfScreenHeight = Math.round(panelHeight / 2);
      var halfOfItemHeight = Math.round(itemSize.h / 2);
      var children = [];
      this._positions = [];
      this._maxIndex = block.length - 1;
      var offset = 0;
      var topOffset = paddingTop;
      var bottomOffset = panelHeight - block.length * itemSize.h - this._maxIndex * contentGap - paddingBottom;
      block.forEach(function (content, index) {
        var y = index * (itemSize.h + contentGap);
        children.push(sideGlass_component_objectSpread(sideGlass_component_objectSpread({}, itemSize), {}, {
          type: template,
          y: y,
          item: {
            content: content,
            config: itemSize,
            template: itemTemplate,
            colorScheme: blockTheme.colorScheme,
            sideGlass: true
          },
          signals: (0,defineProperty/* default */.Z)({}, SELECTED_SIGNAL, '_handleSelected')
        }));
        _this._positions.push(Math.min(Math.max(halfOfScreenHeight - offset - halfOfItemHeight, bottomOffset), topOffset));
        offset += itemSize.h + contentGap;
      });
      this.tag('Container').children = children;
      this.index = 0;
      this._refocus();
    }
  }, {
    key: "index",
    get: function get() {
      return this._index;
    },
    set: function set(value) {
      this._index = value;
      var container = this.tag('Container');
      var child = container.children[this._index];
      if (Z_INDEX_FOCUSED !== Z_INDEX_UNFOCUSED) {
        if (this._focused) {
          this._focused.zIndex = Z_INDEX_UNFOCUSED;
        }
        child.zIndex = Z_INDEX_FOCUSED;
      }
      container.setSmooth('y', this._positions[this._index]);
      this._focused = child;
    }
  }, {
    key: "isLiveSideGlass",
    get: function get() {
      return this._isLiveSideGlass;
    },
    set: function set(sideGlassFlag) {
      this._isLiveSideGlass = sideGlassFlag;
    }
  }, {
    key: "_handleSelected",
    value: function _handleSelected(item) {
      var _getTargetData = getTargetData(item),
        id = _getTargetData.id;
      sendEvent({
        key: 'navigationPanelReplay',
        clipId: id
      });
      this.signal(SELECTED_SIGNAL, item);
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this.patch(sideGlass_style_getUnFocusedStyle(this._style.screenSize));
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this.patch(sideGlass_style_getFocusedStyle(this._style.screenSize));
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this.tag('Container').children[this._index];
    }
  }, {
    key: "_handleUp",
    value: function _handleUp() {
      if (this._index > 0) {
        this.index -= 1;
      }
      return true;
    }
  }, {
    key: "_handleDown",
    value: function _handleDown() {
      if (this._index < this._maxIndex) {
        this.index += 1;
      }
      return true;
    }
  }, {
    key: "_fireCloseSignal",
    value: function _fireCloseSignal() {
      this.signal(sideGlass_constants_CLOSE_SIGNAL);
      return true;
    }
  }, {
    key: "_handleBack",
    value: function _handleBack() {
      return this._fireCloseSignal();
    }
  }, {
    key: "_handleLeft",
    value: function _handleLeft() {
      return this._fireCloseSignal();
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        rect: true,
        BackgroundOverlay: {
          rect: true
        },
        Container: {}
      }, sideGlass_style_getInitialStyle());
    }
  }]);
  return SideGlass;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/player/interface/tracks/tracksPanel/tracksPanel.style.js

var tracksPanel_style_TITLE_MARGIN_BOTTOM, tracksPanel_style_PADDING_LEFT;
function tracksPanel_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function tracksPanel_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? tracksPanel_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : tracksPanel_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }




var tracksPanel_style_defaultContext = makeDefaultStylingContext();
var tracksPanel_tracksPanel_style_TITLE_MARGIN_BOTTOM = (tracksPanel_style_TITLE_MARGIN_BOTTOM = {}, (0,defineProperty/* default */.Z)(tracksPanel_style_TITLE_MARGIN_BOTTOM, HD, 12), (0,defineProperty/* default */.Z)(tracksPanel_style_TITLE_MARGIN_BOTTOM, FULL_HD, 16), tracksPanel_style_TITLE_MARGIN_BOTTOM);
var tracksPanel_tracksPanel_style_PADDING_LEFT = (tracksPanel_style_PADDING_LEFT = {}, (0,defineProperty/* default */.Z)(tracksPanel_style_PADDING_LEFT, HD, 80), (0,defineProperty/* default */.Z)(tracksPanel_style_PADDING_LEFT, FULL_HD, 104), tracksPanel_style_PADDING_LEFT);
var tracksPanel_style_colors = {
  title: makeThemeColor(PRIMARY)
};
var tracksPanel_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : tracksPanel_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  var font = src_getFont(constants_FONT.PARIS_2, screenSize);
  return {
    flex: {
      direction: 'column'
    },
    Title: {
      x: tracksPanel_tracksPanel_style_PADDING_LEFT[screenSize],
      color: tracksPanel_style_colors.title[colorMode],
      text: tracksPanel_style_objectSpread({}, font),
      flexItem: {
        marginBottom: tracksPanel_tracksPanel_style_TITLE_MARGIN_BOTTOM[screenSize]
      }
    },
    Items: {
      flex: {
        direction: 'column'
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/radio/radio.style.js

var _BORDER_DIAMETER, _DOT_DIAMETER, radio_style_VERTICAL_PADDING, _BORDER_RIGHT_MARGIN, _TEXT_LABEL_WRAP_WIDT, _base;
function radio_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function radio_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? radio_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : radio_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }







var radio_style_defaultContext = makeDefaultStylingContext();
var BORDER_DIAMETER = (_BORDER_DIAMETER = {}, (0,defineProperty/* default */.Z)(_BORDER_DIAMETER, HD, 24), (0,defineProperty/* default */.Z)(_BORDER_DIAMETER, FULL_HD, 32), _BORDER_DIAMETER);
var DOT_DIAMETER = (_DOT_DIAMETER = {}, (0,defineProperty/* default */.Z)(_DOT_DIAMETER, HD, 12), (0,defineProperty/* default */.Z)(_DOT_DIAMETER, FULL_HD, 16), _DOT_DIAMETER);
var radio_radio_style_VERTICAL_PADDING = (radio_style_VERTICAL_PADDING = {}, (0,defineProperty/* default */.Z)(radio_style_VERTICAL_PADDING, HD, 12), (0,defineProperty/* default */.Z)(radio_style_VERTICAL_PADDING, FULL_HD, 16), radio_style_VERTICAL_PADDING);
var BORDER_RIGHT_MARGIN = (_BORDER_RIGHT_MARGIN = {}, (0,defineProperty/* default */.Z)(_BORDER_RIGHT_MARGIN, HD, 16), (0,defineProperty/* default */.Z)(_BORDER_RIGHT_MARGIN, FULL_HD, 24), _BORDER_RIGHT_MARGIN);
var TEXT_LABEL_WRAP_WIDTH = (_TEXT_LABEL_WRAP_WIDT = {}, (0,defineProperty/* default */.Z)(_TEXT_LABEL_WRAP_WIDT, HD, 500), (0,defineProperty/* default */.Z)(_TEXT_LABEL_WRAP_WIDT, FULL_HD, 770), _TEXT_LABEL_WRAP_WIDT);
var radio_style_colors = {
  base: (_base = {}, (0,defineProperty/* default */.Z)(_base, LIGHT_MODE, getLightColor(TERTIARY)), (0,defineProperty/* default */.Z)(_base, DARK_MODE, getDarkColor(PRIMARY)), _base),
  selected: makeThemeColor(SECONDARY)
};
var getBaseFont = memoize_default()(function (screenSize) {
  return src_getFont(constants_FONT.KINSHASA_1, screenSize);
});
var getInitialHeight = memoize_default()(function (screenSize) {
  return getBaseFont(screenSize).lineHeight + radio_radio_style_VERTICAL_PADDING[screenSize] * 2;
});
var getFinalHeight = memoize_default()(function (finalH) {
  return finalH + radio_radio_style_VERTICAL_PADDING[radio_style_defaultContext.screenSize] * 2;
});
var getRoundedTexture = function getRoundedTexture(diameter, strokeColor, fillColor) {
  return src_Lightning.Tools.getRoundRect(diameter, diameter, Math.round(diameter / 2), strokeColor ? 1 : 0, strokeColor, true, fillColor);
};
var radio_style_getBorderTexture = function getBorderTexture(diameter) {
  return getRoundedTexture(diameter, colors_WHITE, colors_TRANSPARENT);
};
var getDotTexture = function getDotTexture(diameter) {
  return getRoundedTexture(diameter, colors_TRANSPARENT, colors_WHITE);
};
var radio_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : radio_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  var borderDiameter = BORDER_DIAMETER[screenSize];
  var dotDiameter = DOT_DIAMETER[screenSize];
  var center = Math.round((borderDiameter - dotDiameter) / 2);
  var font = getBaseFont(screenSize);
  var h = getInitialHeight(screenSize);
  return {
    h: h,
    Border: {
      w: borderDiameter,
      h: borderDiameter,
      y: Math.round((h - borderDiameter) / 2),
      texture: radio_style_getBorderTexture(borderDiameter),
      color: radio_style_colors.base[colorMode]
    },
    Dot: {
      w: dotDiameter,
      h: dotDiameter,
      x: center,
      y: Math.round((h - dotDiameter) / 2),
      texture: getDotTexture(dotDiameter),
      color: radio_style_colors.base[colorMode],
      scale: 0
    },
    Label: {
      x: borderDiameter + BORDER_RIGHT_MARGIN[screenSize],
      y: radio_radio_style_VERTICAL_PADDING[screenSize],
      text: radio_style_objectSpread(radio_style_objectSpread({}, font), {}, {
        maxLines: 3,
        wordWrapWidth: TEXT_LABEL_WRAP_WIDTH[screenSize],
        verticalAlign: 'middle'
      })
    }
  };
};
var getBaseStyle = memoize_default()(function (_ref) {
  var screenSize = _ref.screenSize,
    colorMode = _ref.colorMode;
  return {
    Border: {
      smooth: {
        color: radio_style_colors.base[colorMode]
      }
    },
    Dot: {
      smooth: {
        scale: 0,
        color: radio_style_colors.base[colorMode]
      }
    },
    Label: {
      text: radio_style_objectSpread({}, getBaseFont(screenSize))
    }
  };
}, cacheResolver);
var getSelectedStyle = memoize_default()(function (_ref2) {
  var screenSize = _ref2.screenSize,
    colorMode = _ref2.colorMode;
  return {
    Border: {
      smooth: {
        color: radio_style_colors.selected[colorMode]
      }
    },
    Dot: {
      smooth: {
        scale: 1,
        color: radio_style_colors.selected[colorMode]
      }
    },
    Label: {
      text: radio_style_objectSpread({}, src_getFont(constants_FONT.KINSHASA_2, screenSize))
    }
  };
}, cacheResolver);
;// CONCATENATED MODULE: ./src/modules/tornado/radio/radio.component.js





function radio_component_createSuper(t) { var r = radio_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function radio_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (radio_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }



var Radio = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Radio, _Lightning$Component);
  var _super = radio_component_createSuper(Radio);
  function Radio() {
    (0,classCallCheck/* default */.Z)(this, Radio);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Radio, [{
    key: "_construct",
    value: function _construct() {
      this._style = radio_style_defaultContext;
      this._isSelected = false;
    }
  }, {
    key: "label",
    get: function get() {
      return this.tag('Label').text.text;
    },
    set: function set(value) {
      this.tag('Label').text.text = value;
    }
  }, {
    key: "isSelected",
    get: function get() {
      return this._isSelected;
    },
    set: function set(value) {
      var newValue = Boolean(value);
      if (this._isSelected !== newValue) {
        this._isSelected = newValue;
        this.patch(this._isSelected ? getSelectedStyle(this._style) : getBaseStyle(this._style));
      }
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Border: {},
        Dot: {},
        Label: {}
      }, radio_style_getInitialStyle());
    }
  }]);
  return Radio;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/player/interface/tracks/trackItem/trackItem.style.js

var trackItem_style_TITLE_MARGIN_BOTTOM, trackItem_style_PADDING_LEFT;





var trackItem_style_defaultContext = makeDefaultStylingContext();

var trackItem_trackItem_style_TITLE_MARGIN_BOTTOM = (trackItem_style_TITLE_MARGIN_BOTTOM = {}, (0,defineProperty/* default */.Z)(trackItem_style_TITLE_MARGIN_BOTTOM, HD, 12), (0,defineProperty/* default */.Z)(trackItem_style_TITLE_MARGIN_BOTTOM, FULL_HD, 16), trackItem_style_TITLE_MARGIN_BOTTOM);
var trackItem_trackItem_style_PADDING_LEFT = (trackItem_style_PADDING_LEFT = {}, (0,defineProperty/* default */.Z)(trackItem_style_PADDING_LEFT, HD, 80), (0,defineProperty/* default */.Z)(trackItem_style_PADDING_LEFT, FULL_HD, 104), trackItem_style_PADDING_LEFT);
var trackItem_style_colors = {
  background: makeThemeColor(PRIMARY, 0.3)
};
var trackItem_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : trackItem_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  return {
    h: getInitialHeight(screenSize),
    Background: {
      w: identity,
      h: identity,
      color: trackItem_style_colors.background[colorMode],
      alpha: 0
    },
    Radio: {
      x: trackItem_trackItem_style_PADDING_LEFT[screenSize]
    }
  };
};
var trackItem_style_unFocusedStyle = {
  Background: {
    smooth: {
      alpha: 0
    }
  }
};
var trackItem_style_focusedStyle = {
  Background: {
    smooth: {
      alpha: 1
    }
  }
};
;// CONCATENATED MODULE: ./src/modules/player/interface/tracks/trackItem/trackItem.component.js





function trackItem_component_createSuper(t) { var r = trackItem_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function trackItem_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (trackItem_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }





var TrackItem = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(TrackItem, _Lightning$Component);
  var _super = trackItem_component_createSuper(TrackItem);
  function TrackItem() {
    (0,classCallCheck/* default */.Z)(this, TrackItem);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(TrackItem, [{
    key: "label",
    get: function get() {
      return this.tag('Radio').label;
    },
    set: function set(value) {
      var _this = this;
      var labelRect = this.tag('Radio').tag('Label');
      labelRect.on('txLoaded', function () {
        _this.h = getFinalHeight(labelRect.finalH);
      });
      this.tag('Radio').label = value;
    }
  }, {
    key: "isSelected",
    get: function get() {
      return this.tag('Radio').isSelected;
    },
    set: function set(value) {
      this.tag('Radio').isSelected = value;
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this.patch(trackItem_style_focusedStyle);
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this.patch(trackItem_style_unFocusedStyle);
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Background: {
          rect: true
        },
        Radio: {
          type: Radio
        }
      }, trackItem_style_getInitialStyle());
    }
  }]);
  return TrackItem;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/player/interface/tracks/tracksPanel/tracksPanel.component.js










function tracksPanel_component_createSuper(t) { var r = tracksPanel_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function tracksPanel_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (tracksPanel_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }





var TracksPanel = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(TracksPanel, _Lightning$Component);
  var _super = tracksPanel_component_createSuper(TracksPanel);
  function TracksPanel() {
    (0,classCallCheck/* default */.Z)(this, TracksPanel);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(TracksPanel, [{
    key: "_construct",
    value: function _construct() {
      this._style = tracksPanel_style_defaultContext;
      this._items = [];
      this._index = 0;
    }
  }, {
    key: "title",
    get: function get() {
      return this.tag('Title').text.text;
    },
    set: function set(value) {
      this.tag('Title').text.text = value;
    }
  }, {
    key: "items",
    get: function get() {
      return this._items;
    },
    set: function set(value) {
      var _this = this;
      this._items = value || [];
      this.patch({
        Items: {
          children: this._items.map(function (track) {
            return {
              type: TrackItem,
              label: track.label,
              w: _this.finalW,
              isSelected: Boolean(track.active)
            };
          })
        }
      });
      this._refocus();
    }
  }, {
    key: "w",
    get: function get() {
      return (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(TracksPanel.prototype), "w", this);
    },
    set: function set(value) {
      _set((0,getPrototypeOf/* default */.Z)(TracksPanel.prototype), "w", value, this, true);
      this.tag('Items').children.forEach(function (child) {
        child.w = value;
      });
    }
  }, {
    key: "index",
    get: function get() {
      return this._index;
    },
    set: function set(value) {
      this._index = value;
    }
  }, {
    key: "setFocusToSelectedItem",
    value: function setFocusToSelectedItem() {
      var selectedItemIndex = this.tag('Items').children.findIndex(function (_ref) {
        var isSelected = _ref.isSelected;
        return isSelected;
      });
      this.index = selectedItemIndex >= 0 ? selectedItemIndex : 0;
      this._refocus();
    }
  }, {
    key: "highlightPreferredTrack",
    value: function highlightPreferredTrack(trackId) {
      var trackToHighLight = this._items.findIndex(function (_ref2) {
        var id = _ref2.id;
        return id === trackId;
      });
      if (trackToHighLight >= 0) {
        var items = this.tag('Items').children;
        for (var i = 0; i < items.length; i += 1) {
          items[i].isSelected = false;
        }
        items[trackToHighLight].isSelected = true;
      }
      this.index = trackToHighLight >= 0 ? trackToHighLight : 0;
      this._refocus();
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this.tag('Items').children[this.index];
    }
  }, {
    key: "_handleUp",
    value: function _handleUp() {
      if (this.index > 0) {
        this.index -= 1;
        return true;
      }
      return false;
    }
  }, {
    key: "_handleDown",
    value: function _handleDown() {
      if (this.index < this.items.length - 1) {
        this.index += 1;
        return true;
      }
      return false;
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      var selectedView = this.tag('Items').children[this._index];
      if (selectedView) {
        this.tag('Items').children.forEach(function (child) {
          child.isSelected = child === selectedView;
        });
        this.signal(SELECTED_SIGNAL, this.items[this._index]);
      }
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Title: {},
        Items: {}
      }, tracksPanel_style_getInitialStyle());
    }
  }]);
  return TracksPanel;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/player/interface/tracks/tracks.connector.js


var tracks_connector_mapControllers = function mapControllers(instance) {
  return [{
    selector: getAudioTracks,
    shouldBeInvokedOnConnect: true,
    callback: function callback(value) {
      instance.audioTracks = value;
    }
  }, {
    selector: getSubtitleTracks,
    shouldBeInvokedOnConnect: true,
    callback: function callback(value) {
      instance.subtitleTracks = value;
    }
  }, {
    selector: getSelectedAudioTrack,
    shouldBeInvokedOnConnect: true,
    callback: function callback(value) {
      instance.selectedAudioTrack = value;
    }
  }, {
    selector: getSelectedSubtitlesTrack,
    shouldBeInvokedOnConnect: true,
    callback: function callback(value) {
      instance.selectedSubtitlesTrack = value;
    }
  }];
};
/* harmony default export */ const tracks_connector = (lightningjs_redux.control(tracks_connector_mapControllers));
;// CONCATENATED MODULE: ./src/modules/player/interface/tracks/tracks.constants.js
var tracks_constants_CLOSE_SIGNAL = 'close';
var AUDIO_TRACK_SELECTED_SIGNAL = 'audioTrackSelected';
var SUBTITLES_TRACK_SELECTED_SIGNAL = 'subtitlesTrackSelected';
;// CONCATENATED MODULE: ./src/modules/player/interface/tracks/tracks.style.js

var tracks_style_WIDTH, _AUDIO_MARGIN_BOTTOM;





var tracks_style_defaultContext = makeDefaultStylingContext();
var tracks_tracks_style_WIDTH = (tracks_style_WIDTH = {}, (0,defineProperty/* default */.Z)(tracks_style_WIDTH, HD, 640), (0,defineProperty/* default */.Z)(tracks_style_WIDTH, FULL_HD, 960), tracks_style_WIDTH);
var AUDIO_MARGIN_BOTTOM = (_AUDIO_MARGIN_BOTTOM = {}, (0,defineProperty/* default */.Z)(_AUDIO_MARGIN_BOTTOM, HD, 8), (0,defineProperty/* default */.Z)(_AUDIO_MARGIN_BOTTOM, FULL_HD, 16), _AUDIO_MARGIN_BOTTOM);
var tracks_style_colors = {
  background: makeThemeColor(TERTIARY),
  backgroundOverlay: makeThemeColor(PRIMARY, 0.1)
};
var tracks_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : tracks_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  var contentViewportHeight = sizes_SCREEN_HEIGHT[screenSize] - safetyMargins.vertical[screenSize];
  var tracksPanelHeight = Math.round(contentViewportHeight / 2);
  return {
    x: SCREEN_WIDTH[screenSize],
    w: tracks_tracks_style_WIDTH[screenSize],
    h: sizes_SCREEN_HEIGHT[screenSize],
    color: tracks_style_colors.background[colorMode],
    BackgroundOverlay: {
      color: tracks_style_colors.backgroundOverlay[colorMode],
      w: tracks_tracks_style_WIDTH[screenSize],
      h: sizes_SCREEN_HEIGHT[screenSize]
    },
    Panels: {
      y: safetyMargins.vertical[screenSize],
      h: contentViewportHeight,
      w: tracks_tracks_style_WIDTH[screenSize],
      AudioTracks: {
        visible: false,
        w: tracks_tracks_style_WIDTH[screenSize],
        flexItem: {
          marginBottom: AUDIO_MARGIN_BOTTOM[screenSize],
          minHeight: tracksPanelHeight,
          grow: 1
        }
      },
      SubtitleTracks: {
        visible: false,
        w: tracks_tracks_style_WIDTH[screenSize],
        flexItem: {
          minHeight: tracksPanelHeight,
          grow: 1
        }
      },
      flex: {
        direction: 'column',
        justifyContent: 'flex-start'
      }
    }
  };
};
var tracks_style_getFocusedStyle = memoize_default()(function (screenSize) {
  return {
    smooth: {
      x: SCREEN_WIDTH[screenSize] - tracks_tracks_style_WIDTH[screenSize]
    }
  };
});
var tracks_style_getUnFocusedStyle = memoize_default()(function (screenSize) {
  return {
    smooth: {
      x: SCREEN_WIDTH[screenSize]
    }
  };
});
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/startCase.js
var startCase = __webpack_require__(47889);
var startCase_default = /*#__PURE__*/__webpack_require__.n(startCase);
;// CONCATENATED MODULE: ./lang/languageNames/ISO693-3to1.constants.js
var ISO693_TO_1 = {
  aar: 'aa',
  abk: 'ab',
  ave: 'ae',
  afr: 'af',
  aka: 'ak',
  amh: 'am',
  arg: 'an',
  ara: 'ar',
  asm: 'as',
  ava: 'av',
  aym: 'ay',
  aze: 'az',
  bak: 'ba',
  bel: 'be',
  bul: 'bg',
  bih: 'bh',
  bis: 'bi',
  bam: 'bm',
  ben: 'bn',
  bod: 'bo',
  tib: 'bo',
  bre: 'br',
  bos: 'bs',
  cat: 'ca',
  che: 'ce',
  cha: 'ch',
  cos: 'co',
  cre: 'cr',
  ces: 'cs',
  cze: 'cs',
  chu: 'cu',
  chv: 'cv',
  cym: 'cy',
  wel: 'cy',
  dan: 'da',
  deu: 'de',
  ger: 'de',
  div: 'dv',
  dzo: 'dz',
  ewe: 'ee',
  ell: 'el',
  gre: 'el',
  eng: 'en',
  epo: 'eo',
  spa: 'es',
  est: 'et',
  baq: 'eu',
  eus: 'eu',
  fas: 'fa',
  per: 'fa',
  ful: 'ff',
  fin: 'fi',
  fij: 'fj',
  fao: 'fo',
  fra: 'fr',
  fre: 'fr',
  fry: 'fy',
  gle: 'ga',
  gla: 'gd',
  glg: 'gl',
  grn: 'gn',
  guj: 'gu',
  glv: 'gv',
  hau: 'ha',
  heb: 'he',
  hin: 'hi',
  hmo: 'ho',
  hrv: 'hr',
  hat: 'ht',
  hun: 'hu',
  arm: 'hy',
  hye: 'hy',
  her: 'hz',
  ina: 'ia',
  ind: 'id',
  ile: 'ie',
  ibo: 'ig',
  iii: 'ii',
  ipk: 'ik',
  ido: 'io',
  ice: 'is',
  isl: 'is',
  ita: 'it',
  iku: 'iu',
  jpn: 'ja',
  jav: 'jv',
  geo: 'ka',
  kat: 'ka',
  kon: 'kg',
  kik: 'ki',
  kua: 'kj',
  kaz: 'kk',
  kal: 'kl',
  khm: 'km',
  kan: 'kn',
  kor: 'ko',
  kau: 'kr',
  kas: 'ks',
  kur: 'ku',
  kom: 'kv',
  cor: 'kw',
  kir: 'ky',
  lat: 'la',
  ltz: 'lb',
  lug: 'lg',
  lim: 'li',
  lin: 'ln',
  lao: 'lo',
  lit: 'lt',
  lub: 'lu',
  lav: 'lv',
  mlg: 'mg',
  mah: 'mh',
  mao: 'mi',
  mri: 'mi',
  mac: 'mk',
  mkd: 'mk',
  mal: 'ml',
  mon: 'mn',
  mar: 'mr',
  may: 'ms',
  msa: 'ms',
  mlt: 'mt',
  bur: 'my',
  mya: 'my',
  nau: 'na',
  nob: 'nb',
  nde: 'nd',
  nep: 'ne',
  ndo: 'ng',
  dut: 'nl',
  nld: 'nl',
  nno: 'nn',
  nor: 'no',
  nbl: 'nr',
  nav: 'nv',
  nya: 'ny',
  oci: 'oc',
  oji: 'oj',
  orm: 'om',
  ori: 'or',
  oss: 'os',
  pan: 'pa',
  pli: 'pi',
  pol: 'pl',
  pus: 'ps',
  por: 'pt',
  que: 'qu',
  roh: 'rm',
  run: 'rn',
  ron: 'ro',
  rum: 'ro',
  rus: 'ru',
  kin: 'rw',
  san: 'sa',
  srd: 'sc',
  snd: 'sd',
  sme: 'se',
  sag: 'sg',
  sin: 'si',
  slk: 'sk',
  slo: 'sk',
  slv: 'sl',
  smo: 'sm',
  sna: 'sn',
  som: 'so',
  alb: 'sq',
  sqi: 'sq',
  srp: 'sr',
  ssw: 'ss',
  sot: 'st',
  sun: 'su',
  swe: 'sv',
  swa: 'sw',
  tam: 'ta',
  tel: 'te',
  tgk: 'tg',
  tha: 'th',
  tir: 'ti',
  tuk: 'tk',
  tgl: 'tl',
  tsn: 'tn',
  ton: 'to',
  tur: 'tr',
  tso: 'ts',
  tat: 'tt',
  twi: 'tw',
  tah: 'ty',
  uig: 'ug',
  ukr: 'uk',
  urd: 'ur',
  uzb: 'uz',
  ven: 've',
  vie: 'vi',
  vol: 'vo',
  wln: 'wa',
  wol: 'wo',
  xho: 'xh',
  yid: 'yi',
  yor: 'yo',
  zha: 'za',
  chi: 'zh',
  zho: 'zh',
  zul: 'zu'
};
;// CONCATENATED MODULE: ./src/modules/player/interface/tracks/customer/default/tracks.utils.js


var getClosedCaptionsLabel = function getClosedCaptionsLabel(label) {
  return "".concat(label, " (").concat(t('player.closedCaption'), ")");
};
;// CONCATENATED MODULE: ./src/modules/player/interface/tracks/tracks.utils.js








var tracks_tracks_utils_excluded = ["language"],
  tracks_tracks_utils_excluded2 = ["label"];
function tracks_tracks_utils_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function tracks_tracks_utils_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? tracks_tracks_utils_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : tracks_tracks_utils_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





var getLabelByLanguageCode = function getLabelByLanguageCode(code) {
  return startCase_default()(t("languages.".concat(ISO693_TO_1[code] || code)));
};
var getAudioTrackLabelByLanguageCode = function getAudioTrackLabelByLanguageCode(code) {
  switch (code) {
    case AD:
      return t('player.audioDescription');
    case OV:
      return t('player.originalSoundtrack');
    default:
      return getLabelByLanguageCode(code);
  }
};
var getSubtitleTrackLabel = function getSubtitleTrackLabel(track) {
  if (!track) {
    return track.label;
  }
  if (track.language === DISABLED_SUBTITLES) {
    return t('player.subDisable');
  }
  var language = getLabelByLanguageCode(track.language);
  if (track.roles && track.roles.includes('caption')) {
    return getClosedCaptionsLabel(language);
  }
  return language;
};
var getTracksWithCorrectLabel = function getTracksWithCorrectLabel(tracks) {
  if (!tracks || !tracks.length) {
    return [];
  }
  return tracks.map(function (_ref) {
    var language = _ref.language,
      track = objectWithoutProperties_objectWithoutProperties(_ref, tracks_tracks_utils_excluded);
    return tracks_tracks_utils_objectSpread(tracks_tracks_utils_objectSpread({}, track), {}, {
      language: language,
      label: getCorrectAudioTrackLabel(language)
    });
  });
};
var tracks_utils_formatAudioTracks = function formatAudioTracks(tracks) {
  return getTracksWithCorrectLabel(tracks).map(function (_ref2) {
    var label = _ref2.label,
      track = objectWithoutProperties_objectWithoutProperties(_ref2, tracks_tracks_utils_excluded2);
    return tracks_tracks_utils_objectSpread(tracks_tracks_utils_objectSpread({}, track), {}, {
      label: getAudioTrackLabelByLanguageCode(label)
    });
  });
};
var formatSubtitlesTracks = function formatSubtitlesTracks(tracks) {
  var tracksWithLabels = getTracksWithCorrectLabel(tracks);
  return [].concat((0,toConsumableArray/* default */.Z)(tracksWithLabels), [{
    id: DISABLED_SUBTITLES_ID,
    active: !tracksWithLabels.some(function (_ref3) {
      var active = _ref3.active;
      return active;
    }),
    language: DISABLED_SUBTITLES
  }]).map(function (track) {
    return tracks_tracks_utils_objectSpread(tracks_tracks_utils_objectSpread({}, track), {}, {
      label: getSubtitleTrackLabel(track)
    });
  });
};
var areForcedSubtitlesOnly = function areForcedSubtitlesOnly(tracks) {
  return tracks.filter(function (_ref4) {
    var id = _ref4.id;
    return id !== DISABLED_SUBTITLES_ID;
  }).every(function (_ref5) {
    var roles = _ref5.roles;
    return roles && roles.includes('forced_subtitle');
  });
};
;// CONCATENATED MODULE: ./src/modules/player/interface/tracks/tracks.component.js










function tracks_component_createSuper(t) { var r = tracks_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function tracks_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (tracks_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }











var Tracks = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Tracks, _Lightning$Component);
  var _super = tracks_component_createSuper(Tracks);
  function Tracks() {
    (0,classCallCheck/* default */.Z)(this, Tracks);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Tracks, [{
    key: "_construct",
    value: function _construct() {
      this._style = tracks_style_defaultContext;
      this._reset();
    }
  }, {
    key: "_attach",
    value: function _attach() {
      this._unsubscribe = tracks_connector(this);
      this._panels = [this.tag('AudioTracks'), this.tag('SubtitleTracks')];
    }
  }, {
    key: "_detach",
    value: function _detach() {
      if (this._unsubscribe) {
        this._unsubscribe();
        this._unsubscribe = null;
      }
      this._reset();
    }
  }, {
    key: "audioTracks",
    set: function set(value) {
      this._setPanelTracks(this.tag('AudioTracks'), tracks_utils_formatAudioTracks(value));
      this.tag('AudioTracks').setFocusToSelectedItem();
    }
  }, {
    key: "subtitleTracks",
    set: function set(value) {
      var selectableSubtitles = (value || []).filter(function (track) {
        return !isForcedSubtitlesTrack(track);
      });
      this._subtitles = formatSubtitlesTracks(selectableSubtitles);
      this._setPanelTracks(this.tag('SubtitleTracks'), this._subtitles);
    }
  }, {
    key: "selectedAudioTrack",
    set: function set(value) {
      this.tag('AudioTracks').highlightPreferredTrack(value);
    }
  }, {
    key: "selectedSubtitlesTrack",
    set: function set(value) {
      var id = value || Number.isFinite(value) ? value : DISABLED_SUBTITLES_ID;
      var track = this._subtitles && this._subtitles.find(function (_ref) {
        var id = _ref.id;
        return id;
      });
      this.tag('SubtitleTracks').highlightPreferredTrack(track ? id : null);
    }
  }, {
    key: "_setPanelTracks",
    value: function _setPanelTracks(panel, tracks) {
      panel.visible = Boolean(tracks.length);
      panel.items = tracks;
      this._focused = this._panels.find(function (panel) {
        return panel.visible;
      });
      this._refocus();
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this.patch(tracks_style_getUnFocusedStyle(this._style.screenSize));
      this.tag('AudioTracks').setFocusToSelectedItem();
      this.tag('SubtitleTracks').index = 0;
      this._focused = this._panels.find(function (panel) {
        return panel.visible;
      });
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this.patch(tracks_style_getFocusedStyle(this._style.screenSize));
    }
  }, {
    key: "_fireCloseSignal",
    value: function _fireCloseSignal() {
      this.signal(tracks_constants_CLOSE_SIGNAL);
      return true;
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this._focused;
    }
  }, {
    key: "_handleBack",
    value: function _handleBack() {
      return this._fireCloseSignal();
    }
  }, {
    key: "_handleLeft",
    value: function _handleLeft() {
      return this._fireCloseSignal();
    }
  }, {
    key: "_handleUp",
    value: function _handleUp() {
      var panel = this.tag('AudioTracks');
      if (panel.visible) {
        this._focused = panel;
      }
      return true;
    }
  }, {
    key: "_handleDown",
    value: function _handleDown() {
      var panel = this.tag('SubtitleTracks');
      if (panel.visible) {
        this._focused = panel;
      }
      return true;
    }
  }, {
    key: "_handleAudioTrackSelection",
    value: function _handleAudioTrackSelection(track) {
      this.signal(AUDIO_TRACK_SELECTED_SIGNAL, track && track.id || null);
    }
  }, {
    key: "_handleSubtitlesTrackSelection",
    value: function _handleSubtitlesTrackSelection(track) {
      var id = track && track.id || null;
      this.signal(SUBTITLES_TRACK_SELECTED_SIGNAL, id === DISABLED_SUBTITLES_ID ? null : id);
    }
  }, {
    key: "_reset",
    value: function _reset() {
      this._focused = null;
      this._selectedProfile = null;
      this._subtitles = undefined;
      this._panels = [];
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        rect: true,
        BackgroundOverlay: {
          rect: true
        },
        Panels: {
          AudioTracks: {
            type: TracksPanel,
            title: t('player.audio'),
            signals: (0,defineProperty/* default */.Z)({}, SELECTED_SIGNAL, '_handleAudioTrackSelection')
          },
          SubtitleTracks: {
            type: TracksPanel,
            title: t('player.subtitles'),
            signals: (0,defineProperty/* default */.Z)({}, SELECTED_SIGNAL, '_handleSubtitlesTrackSelection')
          }
        }
      }, tracks_style_getInitialStyle());
    }
  }]);
  return Tracks;
}(src_Lightning.Component);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/throttle.js
var throttle = __webpack_require__(38209);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
;// CONCATENATED MODULE: ./src/modules/player/interface/sliderThumb/sliderThumb.style.js

var sliderThumb_style_DIAMETER;




var sliderThumb_style_defaultContext = makeDefaultStylingContext();
var sliderThumb_style_colors = {
  handle: makeThemeColor(PRIMARY)
};
var sliderThumb_sliderThumb_style_DIAMETER = (sliderThumb_style_DIAMETER = {}, (0,defineProperty/* default */.Z)(sliderThumb_style_DIAMETER, HD, 22), (0,defineProperty/* default */.Z)(sliderThumb_style_DIAMETER, FULL_HD, 30), sliderThumb_style_DIAMETER);
var sliderThumb_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sliderThumb_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  var size = sliderThumb_sliderThumb_style_DIAMETER[screenSize];
  return {
    color: sliderThumb_style_colors.handle[colorMode],
    texture: src_Lightning.Tools.getRoundRect(size, size, Math.round(size / 2), 0, 0x00000000, true, sliderThumb_style_colors.handle[colorMode])
  };
};
;// CONCATENATED MODULE: ./src/modules/player/interface/sliderThumb/sliderThumb.component.js






function sliderThumb_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function sliderThumb_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? sliderThumb_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : sliderThumb_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function sliderThumb_component_createSuper(t) { var r = sliderThumb_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function sliderThumb_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (sliderThumb_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }


var SliderThumb = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(SliderThumb, _Lightning$Component);
  var _super = sliderThumb_component_createSuper(SliderThumb);
  function SliderThumb() {
    (0,classCallCheck/* default */.Z)(this, SliderThumb);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(SliderThumb, [{
    key: "_construct",
    value: function _construct() {
      this._style = sliderThumb_style_defaultContext;
    }
  }, {
    key: "colorMode",
    get: function get() {
      return this._style.colorMode;
    },
    set: function set(value) {
      this._style = sliderThumb_component_objectSpread(sliderThumb_component_objectSpread({}, this._style), {}, {
        colorMode: value
      });
      this.patch(sliderThumb_style_getInitialStyle(this._style));
    }
  }], [{
    key: "_template",
    value: function _template() {
      return sliderThumb_component_objectSpread({
        rect: true
      }, sliderThumb_style_getInitialStyle());
    }
  }]);
  return SliderThumb;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/player/interface/progressBar/storyboard/storyboard.style.js

var _BORDER_COLOR;



var storyboard_style_BORDER_COLOR = (_BORDER_COLOR = {}, (0,defineProperty/* default */.Z)(_BORDER_COLOR, DARK_MODE, getDarkColor(PRIMARY)), (0,defineProperty/* default */.Z)(_BORDER_COLOR, LIGHT_MODE, getLightColor(SECONDARY)), _BORDER_COLOR);
var storyboard_style_defaultContext = makeDefaultStylingContext();
var VISIBILITY_TRANSITION = {
  duration: 0.3
};
var STORYBOARD_WIDTH = 200;
var STORYBOARD_HEIGHT = 112;
var storyboard_style_BORDER_WIDTH = 2;
var storyboard_style_colors = {
  border: storyboard_style_BORDER_COLOR
};
var storyboard_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : storyboard_style_defaultContext;
  var colorMode = context.colorMode;
  return {
    alpha: 0,
    w: STORYBOARD_WIDTH,
    h: STORYBOARD_HEIGHT,
    Border: {
      borderWidth: storyboard_style_BORDER_WIDTH,
      colorBorder: storyboard_style_colors.border[colorMode],
      w: identity,
      h: identity
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/player/interface/progressBar/storyboard/storyboard.constants.js

var STORYBOARD_DISPLAY_DURATION = 3000;
var ORIGIN_IMAGE_W = 60000;
var FRAME_Y = 0;
var FRAME_W = 200;
var FRAME_H = 112;
var FRAMES_COUNT = 300;
;// CONCATENATED MODULE: ./src/modules/player/interface/progressBar/storyboard/platform/default/storyboard.constants.js
var BIG_FRAME_W = 4000;
;// CONCATENATED MODULE: ./src/modules/player/interface/progressBar/storyboard/storyboard.utils.js




var safeStoryboardValue = function safeStoryboardValue(value) {
  return clamp_default()(value, 0, ORIGIN_IMAGE_W - FRAME_W);
};
var getStoryboardUrl = function getStoryboardUrl(imageId, shift, width) {
  var params = {
    fit: IMAGE_FIT_CROP,
    quality: IMAGE_QUALITY,
    format: DEFAULT_IMAGE_FORMAT,
    crop: "".concat(shift, ",1")
  };
  var url = imageService.getUrl(imageId, width, FRAME_H, params);
  return url;
};
var getStoryboardGroupedFrames = function getStoryboardGroupedFrames(imageId) {
  var framesList = [];
  var steps = ORIGIN_IMAGE_W / BIG_FRAME_W;
  for (var i = 0; i < steps; i += 1) {
    var shift = i * BIG_FRAME_W || 1;
    var image = getStoryboardUrl(imageId, shift, BIG_FRAME_W);
    framesList.push(image);
  }
  return framesList;
};
;// CONCATENATED MODULE: ./src/modules/player/interface/progressBar/storyboard/storyboard.component.js





function storyboard_component_createSuper(t) { var r = storyboard_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function storyboard_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (storyboard_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }






var Storyboard = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Storyboard, _Lightning$Component);
  var _super = storyboard_component_createSuper(Storyboard);
  function Storyboard() {
    (0,classCallCheck/* default */.Z)(this, Storyboard);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Storyboard, [{
    key: "_construct",
    value: function _construct() {
      var _this = this;
      this._frames = null;
      this._image = null;
      this._currentImage = null;
      this._style = storyboard_style_defaultContext;
      this._innerFramePosition = 0;
      this._startAutoHide = debounce_default()(function () {
        _this.setSmooth('alpha', 0, VISIBILITY_TRANSITION);
      }, STORYBOARD_DISPLAY_DURATION);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this._startAutoHide.cancel();
      this._frames = null;
      this._image = null;
      this._currentImage = null;
    }
  }, {
    key: "_setVisible",
    value: function _setVisible() {
      this._startAutoHide();
      this.setSmooth('alpha', 1, VISIBILITY_TRANSITION);
    }
  }, {
    key: "_moveTexture",
    value: function _moveTexture(shift) {
      this.texture.enableClipping(shift, FRAME_Y, FRAME_W, FRAME_H);
      this._setVisible();
    }
  }, {
    key: "_findFrameAndPosition",
    value: function _findFrameAndPosition(position) {
      this._image = this._frames[Math.floor(position / BIG_FRAME_W)];
      this._innerFramePosition = position % BIG_FRAME_W;
    }
  }, {
    key: "imageId",
    set: function set(id) {
      if (id) {
        this._frames = getStoryboardGroupedFrames(id);
      }
    }
  }, {
    key: "isVisible",
    get: function get() {
      return this.alpha === 1;
    }
  }, {
    key: "updateView",
    value: function updateView(seekPosition) {
      if (this._frames && this._frames.length > 0) {
        this._findFrameAndPosition(seekPosition);
        if (!this._currentImage || this._currentImage !== this._image) {
          this._currentImage = this._image;
          this.patch({
            src: this._image
          });
          this._moveTexture(this._innerFramePosition);
          return;
        }
        this._moveTexture(this._innerFramePosition);
      }
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Border: {
          type: src_Lightning.components.BorderComponent
        }
      }, storyboard_style_getInitialStyle());
    }
  }]);
  return Storyboard;
}(src_Lightning.Component);

;// CONCATENATED MODULE: ./src/modules/player/interface/progressBar/seekBar/seekBar.style.js



var seekBar_style_defaultContext = makeDefaultStylingContext();
var seekBar_style_colors = {
  background: makeThemeColor(PRIMARY, 0.3),
  progress: makeThemeColor(SECONDARY),
  live: makeThemeColor(constants_LIVE),
  darkLive: makeThemeColor(TERTIARY, 0.6)
};
var seekBar_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : seekBar_style_defaultContext;
  return {
    color: seekBar_style_colors.background[context.colorMode],
    PlayHeadBar: {
      h: identity,
      w: identity,
      pivotX: 0,
      color: seekBar_style_colors.live[context.colorMode]
    },
    PlayHeadBarOverlay: {
      h: identity,
      w: identity,
      pivotX: 0,
      color: seekBar_style_colors.darkLive[context.colorMode]
    },
    ProgressBar: {
      h: identity,
      w: identity,
      pivotX: 0
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/player/interface/progressBar/seekBar/seekBar.component.js





function seekBar_component_createSuper(t) { var r = seekBar_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function seekBar_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (seekBar_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }



var SeekBar = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(SeekBar, _Lightning$Component);
  var _super = seekBar_component_createSuper(SeekBar);
  function SeekBar() {
    (0,classCallCheck/* default */.Z)(this, SeekBar);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(SeekBar, [{
    key: "_construct",
    value: function _construct() {
      this._style = seekBar_style_defaultContext;
    }
  }, {
    key: "_build",
    value: function _build() {
      this.progress = 0;
      this.playHead = 0;
    }
  }, {
    key: "playHead",
    get: function get() {
      return this._playHead;
    },
    set: function set(value) {
      this._playHead = value;
      this.tag('PlayHeadBar').scaleX = value;
      this.tag('PlayHeadBarOverlay').scaleX = value;
    }
  }, {
    key: "isLive",
    set: function set(value) {
      this.tag('ProgressBar').color = value ? seekBar_style_colors.live[this._style.colorMode] : seekBar_style_colors.progress[this._style.colorMode];
    }
  }, {
    key: "progress",
    get: function get() {
      return this._progress;
    },
    set: function set(value) {
      this._progress = value;
      this.tag('ProgressBar').scaleX = value;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        rect: true,
        PlayHeadBar: {
          rect: true
        },
        PlayHeadBarOverlay: {
          rect: true
        },
        ProgressBar: {
          rect: true
        }
      }, seekBar_style_getInitialStyle());
    }
  }]);
  return SeekBar;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/player/interface/progressBar/progressBar.style.js

var progressBar_style_HEIGHT, _LABEL_OFFSET, _BAR_HEIGHT_UNFOCUSED, _BAR_HEIGHT_FOCUSED, _STORYBOARD_OFFSET_BO;
function progressBar_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function progressBar_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? progressBar_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : progressBar_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }







var progressBar_style_defaultContext = makeDefaultStylingContext();
var progressBar_progressBar_style_HEIGHT = (progressBar_style_HEIGHT = {}, (0,defineProperty/* default */.Z)(progressBar_style_HEIGHT, HD, 30), (0,defineProperty/* default */.Z)(progressBar_style_HEIGHT, FULL_HD, 36), progressBar_style_HEIGHT);
var LABEL_OFFSET = (_LABEL_OFFSET = {}, (0,defineProperty/* default */.Z)(_LABEL_OFFSET, HD, 16), (0,defineProperty/* default */.Z)(_LABEL_OFFSET, FULL_HD, 24), _LABEL_OFFSET);
var BAR_HEIGHT_UNFOCUSED = (_BAR_HEIGHT_UNFOCUSED = {}, (0,defineProperty/* default */.Z)(_BAR_HEIGHT_UNFOCUSED, HD, 8), (0,defineProperty/* default */.Z)(_BAR_HEIGHT_UNFOCUSED, FULL_HD, 8), _BAR_HEIGHT_UNFOCUSED);
var BAR_HEIGHT_FOCUSED = (_BAR_HEIGHT_FOCUSED = {}, (0,defineProperty/* default */.Z)(_BAR_HEIGHT_FOCUSED, HD, 12), (0,defineProperty/* default */.Z)(_BAR_HEIGHT_FOCUSED, FULL_HD, 12), _BAR_HEIGHT_FOCUSED);
var STORYBOARD_OFFSET_BOTTOM = (_STORYBOARD_OFFSET_BO = {}, (0,defineProperty/* default */.Z)(_STORYBOARD_OFFSET_BO, HD, 32), (0,defineProperty/* default */.Z)(_STORYBOARD_OFFSET_BO, FULL_HD, 40), _STORYBOARD_OFFSET_BO);
var progressBar_style_colors = {
  text: makeThemeColor(PRIMARY)
};
var SLIDER_THUMB_TRANSITION = {
  duration: 0.3,
  timingFunction: 'linear'
};
var getTimeLabelsFont = function getTimeLabelsFont(screenSize) {
  return src_getFont(constants_FONT.BERLIN_1, screenSize);
};
var makeTextStyle = function makeTextStyle(_ref) {
  var screenSize = _ref.screenSize,
    colorMode = _ref.colorMode;
  return {
    color: progressBar_style_colors.text[colorMode],
    mountY: 0.5,
    y: middle,
    text: progressBar_style_objectSpread(progressBar_style_objectSpread({}, getTimeLabelsFont(screenSize)), {}, {
      verticalAlign: 'middle'
    })
  };
};
var progressBar_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : progressBar_style_defaultContext;
  var screenSize = context.screenSize;
  var elapsedStyle = makeTextStyle(context);
  elapsedStyle.text.textAlign = 'right';
  return {
    Elapsed: elapsedStyle,
    Bar: {
      mountY: 0.5,
      x: LABEL_OFFSET[screenSize],
      y: middle,
      h: BAR_HEIGHT_UNFOCUSED[screenSize]
    },
    Duration: progressBar_style_objectSpread(progressBar_style_objectSpread({}, makeTextStyle(context)), {}, {
      x: identity,
      mountX: 1
    }),
    SliderThumb: {
      y: middle,
      mount: 0.5,
      scale: 0
    },
    Storyboard: {
      y: -STORYBOARD_HEIGHT - STORYBOARD_OFFSET_BOTTOM[screenSize]
    }
  };
};
var progressBar_style_getUnFocusedStyle = memoize_default()(function (screenSize) {
  return {
    Bar: {
      smooth: {
        h: BAR_HEIGHT_UNFOCUSED[screenSize]
      }
    },
    SliderThumb: {
      smooth: {
        scale: 0
      }
    }
  };
});
var progressBar_style_getFocusedStyle = memoize_default()(function (screenSize) {
  return {
    Bar: {
      smooth: {
        h: BAR_HEIGHT_FOCUSED[screenSize]
      }
    },
    SliderThumb: {
      smooth: {
        scale: 1
      }
    }
  };
});
;// CONCATENATED MODULE: ./src/modules/player/interface/progressBar/progressBar.constants.js
var SEEK_SIGNAL = 'seek';
var progressBar_constants_PAUSE_SIGNAL = 'pause';
var TIME_ASIDE = 'aside';
var TIME_BELOW = 'below';
var TIME_HIDDEN = 'hidden';
var PAUSE_ON_LONG_SEEK = false;
;// CONCATENATED MODULE: ./src/logic/player/live.selectors.js
var getLiveEdgeInSeconds = function getLiveEdgeInSeconds(state) {
  return state.player.liveEdgeInSeconds;
};
var isOnLive = function isOnLive(state) {
  return state.player.isOnLive || false;
};
;// CONCATENATED MODULE: ./src/modules/player/interface/progressBar/progressBar.connector.js




var progressBar_connector_mapControllers = function mapControllers(instance) {
  return [{
    selector: getIsLive,
    shouldBeInvokedOnConnect: true,
    callback: function callback(value) {
      instance.isLive = value;
    }
  }, {
    selector: player_selectors_getDurationInSeconds,
    shouldBeInvokedOnConnect: true,
    callback: function callback(value) {
      instance.duration = value;
    }
  }, {
    selector: player_selectors_getElapsedTimeInSeconds,
    shouldBeInvokedOnConnect: true,
    callback: function callback(value) {
      instance.elapsed = value;
    }
  }, {
    selector: getLiveEdgeInSeconds,
    shouldBeInvokedOnConnect: true,
    callback: function callback(value) {
      instance.playHead = value;
    }
  }, {
    selector: getStoryboardFeature,
    shouldBeInvokedOnConnect: true,
    callback: function callback(value) {
      instance.storyboard = value;
    }
  }, {
    selector: getPlayerLongSeekFeature,
    shouldBeInvokedOnConnect: true,
    callback: function callback(value) {
      instance.longSeekEnabled = value;
    }
  }];
};
/* harmony default export */ const progressBar_connector = (lightningjs_redux.control(progressBar_connector_mapControllers));
;// CONCATENATED MODULE: ./src/modules/player/interface/progressBar/progressBar.component.js









function progressBar_component_createSuper(t) { var r = progressBar_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function progressBar_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (progressBar_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }



















var ProgressBar = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(ProgressBar, _Lightning$Component);
  var _super = progressBar_component_createSuper(ProgressBar);
  function ProgressBar() {
    (0,classCallCheck/* default */.Z)(this, ProgressBar);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(ProgressBar, [{
    key: "_construct",
    value: function _construct() {
      var _this = this;
      this._duration = 0;
      this._elapsed = 0;
      this._progress = 0;
      this._seekEnable = true;
      this._seekDirection = 0;
      this._playHead = 0;
      this._seekTime = 0;
      this._barWidth = 0;
      this._barOffset = 0;
      this._style = progressBar_style_defaultContext;
      this._isLive = false;
      this._isActive = false;
      this._isBuiltCompletely = false;
      this._withStoryboard = false;
      this._variant = TIME_ASIDE;
      this._longSeekEnabled = false;
      this._ticks = 0;
      this._debounceDigitSeek = debounce_default()(function (seekTime) {
        _this.signal(SEEK_SIGNAL, seekTime);
      }, SEEK_DEBOUNCE_MS);
      this._debounceSeek = debounce_default()(function () {
        _this._seekDirection = 0;
        _this._elapsed = _this._seekTime;
        _this.signal(SEEK_SIGNAL, _this._seekTime);
      }, SEEK_DEBOUNCE_MS);
      this._throttleSeek = throttle_default()(function () {
        var step = SEEK_STEP_SECONDS;
        if (_this._longSeekEnabled) {
          if (_this._ticks > 20) {
            step = 120;
          } else if (_this._ticks > 15) {
            step = 60;
          } else if (_this._ticks > 10) {
            step = 30;
          }
          if (_this._ticks > 1 && PAUSE_ON_LONG_SEEK) {
            _this.signal(progressBar_constants_PAUSE_SIGNAL);
          }
        }
        _this._seekTime = clamp_default()(_this._seekTime + step * _this._seekDirection, 0, _this._duration);
        if (_this._isLive && _this._playHead) {
          _this._seekTime = _this._seekTime > _this._playHead ? _this._playHead : _this._seekTime;
        }
        if (_this._isBuiltCompletely) {
          _this._setSeekTime(_this._seekTime);
        }
        _this._ticks += 1;
        _this._debounceSeek();
      }, SEEK_THROTTLE_MS);
    }
  }, {
    key: "_build",
    value: function _build() {
      this.elapsed = 0;
      this._playHead = 0;
    }
  }, {
    key: "_attach",
    value: function _attach() {
      this._unsubscribe = progressBar_connector(this);
    }
  }, {
    key: "_active",
    value: function _active() {
      this._isActive = true;
      this._handleProgressUpdate();
    }
  }, {
    key: "_inactive",
    value: function _inactive() {
      this._isActive = false;
    }
  }, {
    key: "_detach",
    value: function _detach() {
      if (this._unsubscribe) {
        this._unsubscribe();
        this._unsubscribe = null;
      }
      this.tag('Duration').removeAllListeners('txLoaded');
      this._isBuiltCompletely = false;
      this._stopSeeking();
    }
  }, {
    key: "seekEnable",
    get: function get() {
      return this._seekEnable;
    },
    set: function set(value) {
      this._seekEnable = value;
    }
  }, {
    key: "longSeekEnabled",
    get: function get() {
      return this._longSeekEnabled;
    },
    set: function set(value) {
      this._longSeekEnabled = value;
    }
  }, {
    key: "canSeek",
    get: function get() {
      return this._seekEnable && this._duration > 0;
    }
  }, {
    key: "withStoryboard",
    get: function get() {
      return this._withStoryboard && !this._isLive;
    }
  }, {
    key: "elapsed",
    set: function set(value) {
      this._elapsed = value;
      this._updateTime();
    }
  }, {
    key: "playHead",
    set: function set(value) {
      this._playHead = value;
      this.tag('Bar').playHead = safeProgressValue(this._duration > 0 ? value / this._duration : 0);
    }
  }, {
    key: "duration",
    set: function set(value) {
      var duration = this.tag('Duration');
      if (this._duration !== value) {
        duration.text.text = getTimeFormat(value).replace(/\d/g, '0');
        duration.loadTexture();
        var w = duration.finalW;
        this._barOffset = this._variant === TIME_ASIDE ? w + LABEL_OFFSET[this._style.screenSize] : 0;
      }
      this._duration = value;
      this._handleProgressUpdate();
      this._isBuiltCompletely = true;
      if (this._seekDirection !== 0) {
        this._setSeekTime(this._seekTime);
      }
      duration.text.text = getTimeFormat(value);
    }
  }, {
    key: "storyboard",
    set: function set(value) {
      this._withStoryboard = value;
    }
  }, {
    key: "storyboardId",
    set: function set(id) {
      if (this.withStoryboard) {
        this.tag('Storyboard').imageId = id;
      }
    }
  }, {
    key: "isLive",
    set: function set(value) {
      this._isLive = value;
      this.tag('Bar').isLive = value;
    }
  }, {
    key: "w",
    get: function get() {
      return (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(ProgressBar.prototype), "w", this);
    },
    set: function set(value) {
      _set((0,getPrototypeOf/* default */.Z)(ProgressBar.prototype), "w", value, this, true);
      this._handleProgressUpdate();
    }
  }, {
    key: "variant",
    get: function get() {
      return this._variant;
    },
    set: function set(value) {
      this._variant = value;
      var showProgress = this._variant !== TIME_HIDDEN;
      this.patch({
        Elapsed: {
          visible: showProgress
        },
        Duration: {
          visible: showProgress
        }
      });
      this._handleProgressUpdate();
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this.patch(progressBar_style_getFocusedStyle(this._style.screenSize));
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this._stopSeeking();
      this.patch(progressBar_style_getUnFocusedStyle(this._style.screenSize));
    }
  }, {
    key: "_handleKeyRelease",
    value: function _handleKeyRelease() {
      this._ticks = 0;
    }
  }, {
    key: "_handleLeft",
    value: function _handleLeft() {
      return this._handleRewind();
    }
  }, {
    key: "_handleRight",
    value: function _handleRight() {
      return this._handleFastForward();
    }
  }, {
    key: "_handleSkipFastForward",
    value: function _handleSkipFastForward() {
      return this._handleFastForward();
    }
  }, {
    key: "_handleSkipRewind",
    value: function _handleSkipRewind() {
      return this._handleRewind();
    }
  }, {
    key: "_handleRewind",
    value: function _handleRewind() {
      return this._startSeeking(-1);
    }
  }, {
    key: "_handleFastForward",
    value: function _handleFastForward() {
      return this._startSeeking(1);
    }
  }, {
    key: "_handleForward",
    value: function _handleForward() {
      return this._handleFastForward();
    }
  }, {
    key: "_handleKey",
    value: function _handleKey(event) {
      if (this._seekDirection === 0 && this._duration && /^[0-9]$/.test(event.key)) {
        var seekTime = Math.round(this._duration * (parseInt(event.key, 10) / 10));
        this._debounceDigitSeek(seekTime);
        return true;
      }
      return false;
    }
  }, {
    key: "_startSeeking",
    value: function _startSeeking(direction) {
      if (!this.canSeek) {
        return false;
      }
      this._updateTime();
      this._seekDirection = direction;
      this._throttleSeek();
      return true;
    }
  }, {
    key: "_stopSeeking",
    value: function _stopSeeking() {
      this._ticks = 0;
      this._seekDirection = 0;
      this._debounceSeek.cancel();
      this._throttleSeek.cancel();
      this._debounceDigitSeek.cancel();
    }
  }, {
    key: "_handleProgressUpdate",
    value: function _handleProgressUpdate() {
      if (!this._isActive) {
        return;
      }
      this._barWidth = this.finalW - this._barOffset * 2;
      var screenSize = this._style.screenSize;
      var isAside = this._variant === TIME_ASIDE;
      var h = isAside ? progressBar_progressBar_style_HEIGHT[screenSize] : sliderThumb_sliderThumb_style_DIAMETER[screenSize] + LABEL_OFFSET[screenSize] + getTimeLabelsFont(screenSize).lineHeight;
      var y = isAside ? Math.round(h / 2) : h;
      var mountY = isAside ? 0.5 : 1;
      this.patch({
        h: h,
        Elapsed: {
          y: y,
          mountY: mountY
        },
        Bar: {
          x: this._barOffset,
          w: this._barWidth,
          mountY: isAside ? 0.5 : 0,
          y: isAside ? middle : Math.round((sliderThumb_sliderThumb_style_DIAMETER[screenSize] - BAR_HEIGHT_UNFOCUSED[screenSize]) / 2)
        },
        SliderThumb: {
          visible: this.canSeek,
          mountY: isAside ? 0.5 : 0,
          y: isAside ? middle : 0
        },
        Duration: {
          x: this.finalW,
          y: y,
          mountY: mountY,
          mountX: 1
        }
      });
      this._updateTime();
    }
  }, {
    key: "_updateTime",
    value: function _updateTime() {
      this._progress = this._variant === TIME_HIDDEN ? 1 : safeProgressValue(this._duration > 0 ? this._elapsed / this._duration : 0);
      if (this._seekDirection === 0) {
        this._seekTime = this._elapsed;
        this.tag('Elapsed').text.text = getTimeFormat(this._elapsed);
        this.tag('Bar').progress = this._progress;
        this.tag('SliderThumb').x = this._getSliderPosition(this._progress);
      }
    }
  }, {
    key: "_getSliderPosition",
    value: function _getSliderPosition(progress) {
      return this._barOffset + progress * this._barWidth;
    }
  }, {
    key: "_setSeekTime",
    value: function _setSeekTime(time) {
      var shouldAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var progress = Math.min(time / this._duration, 1);
      var sliderThumbPosition = this._getSliderPosition(progress);
      this._updateStoryboard(progress, shouldAnimate);
      if (shouldAnimate) {
        this.tag('SliderThumb').setSmooth('x', sliderThumbPosition, SLIDER_THUMB_TRANSITION);
        this.tag('Bar').setSmooth('progress', progress, SLIDER_THUMB_TRANSITION);
      } else {
        this.tag('SliderThumb').x = sliderThumbPosition;
        this.tag('Bar').progress = progress;
      }
      this.tag('Elapsed').text.text = getTimeFormat(time);
    }
  }, {
    key: "_updateStoryboard",
    value: function _updateStoryboard(progress, shouldAnimate) {
      if (this.withStoryboard) {
        var storyboard = this.tag('Storyboard');
        var storyboardPosition = this._getStoryboardPosition(progress);
        var framePosition = safeStoryboardValue(Math.max(1, Math.floor(FRAMES_COUNT * progress) * FRAME_W));
        storyboard.updateView(framePosition);
        if (shouldAnimate && storyboard.isVisible) {
          storyboard.setSmooth('x', storyboardPosition, SLIDER_THUMB_TRANSITION);
          return;
        }
        storyboard.x = storyboardPosition;
      }
    }
  }, {
    key: "_getStoryboardPosition",
    value: function _getStoryboardPosition(progress) {
      var sliderThumbPosition = this._getSliderPosition(progress);
      var storyboardCenter = Math.round(STORYBOARD_WIDTH / 2);
      var endPoint = this._barWidth + this._barOffset;
      if (endPoint < sliderThumbPosition + storyboardCenter) {
        return endPoint - STORYBOARD_WIDTH;
      }
      if (sliderThumbPosition > storyboardCenter + this._barOffset) {
        return sliderThumbPosition - storyboardCenter;
      }
      return this._barOffset;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Elapsed: {},
        Bar: {
          type: SeekBar
        },
        SliderThumb: {
          type: SliderThumb
        },
        Duration: {},
        Storyboard: {
          type: Storyboard
        }
      }, progressBar_style_getInitialStyle());
    }
  }]);
  return ProgressBar;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/player/interface/programInformation/programInformation.style.js

var programInformation_style_PADDING_TOP, programInformation_style_GAP, programInformation_style_PADDING_RIGHT, programInformation_style_PADDING_LEFT, programInformation_style_WIDTH, programInformation_style_TEXT_WIDTH;
function programInformation_programInformation_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function programInformation_programInformation_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? programInformation_programInformation_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : programInformation_programInformation_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






var programInformation_programInformation_style_defaultContext = makeDefaultStylingContext();
var programInformation_programInformation_style_PADDING_TOP = (programInformation_style_PADDING_TOP = {}, (0,defineProperty/* default */.Z)(programInformation_style_PADDING_TOP, HD, 40), (0,defineProperty/* default */.Z)(programInformation_style_PADDING_TOP, FULL_HD, 56), programInformation_style_PADDING_TOP);
var programInformation_programInformation_style_GAP = (programInformation_style_GAP = {}, (0,defineProperty/* default */.Z)(programInformation_style_GAP, HD, 40), (0,defineProperty/* default */.Z)(programInformation_style_GAP, FULL_HD, 40), programInformation_style_GAP);
var programInformation_programInformation_style_PADDING_RIGHT = (programInformation_style_PADDING_RIGHT = {}, (0,defineProperty/* default */.Z)(programInformation_style_PADDING_RIGHT, HD, 80), (0,defineProperty/* default */.Z)(programInformation_style_PADDING_RIGHT, FULL_HD, 104), programInformation_style_PADDING_RIGHT);
var programInformation_programInformation_style_PADDING_LEFT = (programInformation_style_PADDING_LEFT = {}, (0,defineProperty/* default */.Z)(programInformation_style_PADDING_LEFT, HD, 80), (0,defineProperty/* default */.Z)(programInformation_style_PADDING_LEFT, FULL_HD, 104), programInformation_style_PADDING_LEFT);
var programInformation_programInformation_style_WIDTH = (programInformation_style_WIDTH = {}, (0,defineProperty/* default */.Z)(programInformation_style_WIDTH, HD, 640), (0,defineProperty/* default */.Z)(programInformation_style_WIDTH, FULL_HD, 960), programInformation_style_WIDTH);
var programInformation_programInformation_style_TEXT_WIDTH = (programInformation_style_TEXT_WIDTH = {}, (0,defineProperty/* default */.Z)(programInformation_style_TEXT_WIDTH, HD, programInformation_programInformation_style_WIDTH[HD] - programInformation_programInformation_style_PADDING_RIGHT[HD] - programInformation_programInformation_style_PADDING_LEFT[HD]), (0,defineProperty/* default */.Z)(programInformation_style_TEXT_WIDTH, FULL_HD, programInformation_programInformation_style_WIDTH[FULL_HD] - programInformation_programInformation_style_PADDING_RIGHT[FULL_HD] - programInformation_programInformation_style_PADDING_LEFT[FULL_HD]), programInformation_style_TEXT_WIDTH);
var programInformation_programInformation_style_colors = {
  text: makeThemeColor(PRIMARY),
  backgroundOverlay: makeThemeColor(PRIMARY, 0.1),
  background: makeThemeColor(TERTIARY)
};
var programInformation_programInformation_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : programInformation_programInformation_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  var offsetX = SCREEN_WIDTH[screenSize] + programInformation_programInformation_style_WIDTH[screenSize];
  var color = programInformation_programInformation_style_colors.text[colorMode];
  var titleFont = src_getFont(constants_FONT.TOKYO_4, screenSize);
  var textWidth = programInformation_programInformation_style_TEXT_WIDTH[screenSize];
  return {
    visible: false,
    x: offsetX,
    w: programInformation_programInformation_style_WIDTH[screenSize],
    h: sizes_SCREEN_HEIGHT[screenSize],
    color: programInformation_programInformation_style_colors.background[colorMode],
    BackgroundOverlay: {
      w: programInformation_programInformation_style_WIDTH[screenSize],
      h: sizes_SCREEN_HEIGHT[screenSize],
      color: programInformation_programInformation_style_colors.backgroundOverlay[colorMode]
    },
    Title: {
      x: programInformation_programInformation_style_PADDING_LEFT[screenSize],
      y: programInformation_programInformation_style_PADDING_TOP[screenSize],
      text: programInformation_programInformation_style_objectSpread(programInformation_programInformation_style_objectSpread({}, titleFont), {}, {
        wordWrapWidth: textWidth,
        textColor: color,
        verticalAlign: 'bottom',
        maxLinesSuffix: '...',
        maxLines: 2
      })
    },
    Scroll: {
      visible: false,
      x: programInformation_programInformation_style_PADDING_LEFT[screenSize],
      w: textWidth
    }
  };
};
var programInformation_style_getFocusedStyle = memoize_default()(function (screenSize) {
  return {
    visible: true,
    smooth: {
      x: SCREEN_WIDTH[screenSize] - programInformation_programInformation_style_WIDTH[screenSize]
    }
  };
});
var programInformation_style_getUnFocusedStyle = memoize_default()(function (screenSize) {
  return {
    smooth: {
      x: SCREEN_WIDTH[screenSize]
    }
  };
});
;// CONCATENATED MODULE: ./src/modules/player/interface/programInformation/programInformation.constants.js
var programInformation_constants_PROGRAM_INFORMATION_CLOSED_SIGNAL = 'programInformationClosed';
;// CONCATENATED MODULE: ./src/modules/player/interface/programInformation/programInformation.connector.js


var programInformation_connector_mapControllers = function mapControllers(instance) {
  return [{
    shouldBeInvokedOnConnect: true,
    selector: getCurrentVideoItem,
    callback: function callback(value) {
      instance.data = value;
    }
  }];
};
/* harmony default export */ const programInformation_connector = (lightningjs_redux.control(programInformation_connector_mapControllers));
;// CONCATENATED MODULE: ./src/modules/player/interface/programInformation/programInformation.component.js







function programInformation_programInformation_component_createSuper(t) { var r = programInformation_programInformation_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function programInformation_programInformation_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (programInformation_programInformation_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }









var programInformation_component_ProgramInformation = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(ProgramInformation, _Lightning$Component);
  var _super = programInformation_programInformation_component_createSuper(ProgramInformation);
  function ProgramInformation() {
    (0,classCallCheck/* default */.Z)(this, ProgramInformation);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(ProgramInformation, [{
    key: "_construct",
    value: function _construct() {
      this._style = programInformation_programInformation_style_defaultContext;
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this.tag('Title').removeAllListeners('txLoaded');
      if (this._unsubscribe) {
        this._unsubscribe();
      }
    }
  }, {
    key: "_active",
    value: function _active() {
      if (!this._unsubscribe) {
        this._unsubscribe = programInformation_connector(this);
      }
    }
  }, {
    key: "data",
    set: function set(content) {
      var _this = this;
      if (!content) {
        return;
      }
      this.tag('Title').once('txLoaded', function () {
        var scroll = _this.tag('Scroll');
        var scrollableView = scroll.content;
        if (scrollableView) {
          var titleHeight = _this.tag('Title').finalH;
          var screenSize = _this._style.screenSize;
          scroll.visible = true;
          scroll.y = titleHeight + programInformation_programInformation_style_PADDING_TOP[screenSize] + programInformation_programInformation_style_GAP[screenSize];
          scroll.h = sizes_SCREEN_HEIGHT[screenSize] - scroll.y - safetyMargins.vertical[screenSize];
          scrollableView.data = {
            description: content.description
          };
        }
      });
      this.tag('Title').text.text = content.title;
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this.tag('Scroll');
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this.patch(programInformation_style_getUnFocusedStyle(this._style.screenSize));
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this.patch(programInformation_style_getFocusedStyle(this._style.screenSize));
    }
  }, {
    key: "_handleBack",
    value: function _handleBack() {
      this.signal(programInformation_constants_PROGRAM_INFORMATION_CLOSED_SIGNAL);
    }
  }, {
    key: "_handleLeft",
    value: function _handleLeft() {
      this.signal(programInformation_constants_PROGRAM_INFORMATION_CLOSED_SIGNAL);
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        rect: true,
        BackgroundOverlay: {
          rect: true
        },
        Title: {},
        Scroll: {
          type: Scroll,
          content: {
            type: ProgramDescription,
            w: programInformation_programInformation_style_TEXT_WIDTH[programInformation_programInformation_style_defaultContext.screenSize]
          }
        }
      }, programInformation_programInformation_style_getInitialStyle());
    }
  }]);
  return ProgramInformation;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/player/interface/controls/controls.connector.js



var controls_connector_mapControllers = function mapControllers(instance) {
  return [{
    selector: getIsLive,
    callback: function callback(value) {
      instance.isLive = value;
    }
  }, {
    selector: isLiveSeekEnabled,
    callback: function callback(value) {
      instance.isLiveSeekEnabled = value;
    }
  }, {
    selector: player_selectors_getTitle,
    callback: function callback(value) {
      instance.title = value;
    }
  }, {
    selector: getExtraTitle,
    callback: function callback(value) {
      instance.extraTitle = value;
    }
  }, {
    selector: getCurrentVideoItem,
    callback: function callback(value) {
      instance.programInformation = value;
    }
  }, {
    selector: getCurrentChapter,
    callback: function callback(value) {
      instance.chapter = value;
    }
  }, {
    selector: getLBannerState,
    callback: function callback(value) {
      instance.lBannerState = value;
    }
  }];
};
/* harmony default export */ const controls_connector = (lightningjs_redux.control(controls_connector_mapControllers));
;// CONCATENATED MODULE: ./src/modules/player/interface/controls/controls.style.js

var _METADATA_Y, _PROGRESS_HEIGHT, _PROGRESS_MARGIN_TOP;
function controls_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function controls_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? controls_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : controls_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }




var controls_style_defaultContext = makeDefaultStylingContext();
var METADATA_Y = (_METADATA_Y = {}, (0,defineProperty/* default */.Z)(_METADATA_Y, HD, 566), (0,defineProperty/* default */.Z)(_METADATA_Y, FULL_HD, 880), _METADATA_Y);
var controls_style_PROGRESS_HEIGHT = (_PROGRESS_HEIGHT = {}, (0,defineProperty/* default */.Z)(_PROGRESS_HEIGHT, HD, 30), (0,defineProperty/* default */.Z)(_PROGRESS_HEIGHT, FULL_HD, 36), _PROGRESS_HEIGHT);
var PROGRESS_MARGIN_TOP = (_PROGRESS_MARGIN_TOP = {}, (0,defineProperty/* default */.Z)(_PROGRESS_MARGIN_TOP, HD, 16), (0,defineProperty/* default */.Z)(_PROGRESS_MARGIN_TOP, FULL_HD, 16), _PROGRESS_MARGIN_TOP);
var controls_style_colors = {
  text: makeThemeColor(PRIMARY)
};
var controls_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : controls_style_defaultContext;
  var screenSize = context.screenSize;
  var margin = {
    x: safetyMargins.horizontal[screenSize],
    y: safetyMargins.vertical[screenSize]
  };
  return {
    w: SCREEN_WIDTH[screenSize],
    h: sizes_SCREEN_HEIGHT[screenSize],
    Main: {
      w: SCREEN_WIDTH[screenSize],
      h: sizes_SCREEN_HEIGHT[screenSize],
      alpha: 0,
      transitions: {
        alpha: {
          duration: 0.3
        }
      },
      TopBar: controls_style_objectSpread({}, margin),
      Toggle: {
        mount: 0.5,
        x: middle,
        y: middle
      },
      Metadata: {
        x: margin.x,
        y: METADATA_Y[screenSize]
      },
      SideGlass: {
        zIndex: 2
      },
      Tracks: {
        zIndex: 2
      },
      ProgramInformation: {
        zIndex: 2
      },
      Progress: {
        mountY: 1,
        x: margin.x,
        y: sizes_SCREEN_HEIGHT[screenSize] - margin.y,
        w: SCREEN_WIDTH[screenSize] - margin.x * 2
      }
    },
    AuxiliaryButtons: {
      mount: 1,
      x: SCREEN_WIDTH[screenSize] - margin.x,
      y: sizes_SCREEN_HEIGHT[screenSize] - margin.y - controls_style_PROGRESS_HEIGHT[screenSize] - PROGRESS_MARGIN_TOP[screenSize]
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/player/interface/controls/controls.constants.js

var TOP_BAR_ITEM_SELECTED_SIGNAL = 'topBarItemSelected';
var SIDE_GLASS_ITEM_SELECTED_SIGNAL = 'sideGlassItemSelected';
var PLAYING_STATE = 'Playing';
var PAUSED_STATE = 'Paused';
var CONTROLS_SHOW_SIGNAL = 'onControlsShow';
var CONTROLS_HIDE_SIGNAL = 'onControlsHide';
;// CONCATENATED MODULE: ./src/modules/player/interface/controls/controls.component.js












function controls_component_createSuper(t) { var r = controls_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function controls_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (controls_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
























var Controls = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Controls, _Lightning$Component);
  var _super = controls_component_createSuper(Controls);
  function Controls() {
    (0,classCallCheck/* default */.Z)(this, Controls);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Controls, [{
    key: "_construct",
    value: function _construct() {
      var _this = this;
      this._startAutoHide = debounce_default()(function () {
        _this.hide();
        _this.signal(CONTROLS_HIDE_SIGNAL);
      }, INTERFACE_DISPLAY_DURATION);
      this._index = 0;
    }
  }, {
    key: "_build",
    value: function _build() {
      var _this2 = this;
      this.tag('Main').transition('alpha').on('finish', function () {
        if (_this2.alpha < 1) {
          _this2.focusOnAuxiliaryControls();
        }
      });
      this._focusableItems = [this.tag('TopBar')].concat((0,toConsumableArray/* default */.Z)(this.tag('AuxiliaryButtons').children), [this.tag('Progress')]);
      this._autoHideDisablingViews = [this.tag('SideGlass'), this.tag('Tracks'), this.tag('ProgramInformation')];
      this._visibleFocusableItems = [];
      this._checkFocusableItems();
      this._focusTag('Progress');
    }
  }, {
    key: "_attach",
    value: function _attach() {
      this._unsubscribe = controls_connector(this);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      if (this._unsubscribe) {
        this._unsubscribe();
        this._unsubscribe = null;
      }
      this._focused = undefined;
      this._focusableItems = [];
      this._visibleFocusableItems = [];
      this._autoHideDisablingViews = [];
      this.tag('Main').transition('alpha').removeAllListeners();
      this._startAutoHide.cancel();
    }
  }, {
    key: "isLive",
    set: function set(value) {
      this._isLive = value;
      this.tag('SideGlass').isLiveSideGlass = value;
      this._updateSeekAvailability();
    }
  }, {
    key: "isLiveSeekEnabled",
    set: function set(value) {
      this._liveSeekEnabled = value;
      this._updateSeekAvailability();
    }
  }, {
    key: "topBarItems",
    set: function set(value) {
      this.tag('TopBar').items = value;
    }
  }, {
    key: "title",
    set: function set(value) {
      this.tag('Metadata').title = value;
    }
  }, {
    key: "extraTitle",
    set: function set(value) {
      this.tag('Metadata').extraTitle = value;
    }
  }, {
    key: "programInformation",
    set: function set(value) {
      this.tag('Progress').storyboardId = get_default()(value, 'video.images.storyboard.id', null);
    }
  }, {
    key: "isHidden",
    get: function get() {
      return this.tag('Main').alpha === 0;
    }
  }, {
    key: "displayOverlayBackdrop",
    set: function set(value) {
      this.tag('Overlay').displayBackdrop = value;
    }
  }, {
    key: "displayOverlayTop",
    set: function set(value) {
      this.tag('Overlay').displayTop = value;
    }
  }, {
    key: "displayOverlayBottom",
    set: function set(value) {
      this.tag('Overlay').displayBottom = value;
    }
  }, {
    key: "displayMetadata",
    set: function set(value) {
      this.tag('Metadata').visible = value;
    }
  }, {
    key: "progressBarVariant",
    set: function set(value) {
      this.tag('Progress').variant = value;
    }
  }, {
    key: "lBannerState",
    set: function set(value) {
      this._lBannerState = value;
      this._updateSeekAvailability();
    }
  }, {
    key: "show",
    value: function show(state) {
      this.tag('Toggle').show(state);
    }
  }, {
    key: "hide",
    value: function hide() {
      this.tag('Main').setSmooth('alpha', 0);
      this.focusOnAuxiliaryControls();
    }
  }, {
    key: "focusOnAuxiliaryControls",
    value: function focusOnAuxiliaryControls() {
      var auxiliaryButton = this.tag('AuxiliaryButtons').children.find(function (child) {
        return child.visible;
      });
      if (auxiliaryButton) {
        this._setIndex(this._visibleFocusableItems.indexOf(auxiliaryButton));
      } else {
        this._focusTag('Progress');
      }
      this._refocus();
    }
  }, {
    key: "showSideGlass",
    value: function showSideGlass() {
      this._focused = this.tag('SideGlass');
      this._refocus();
      sendEvent({
        key: 'openSideGlass'
      });
    }
  }, {
    key: "showTracks",
    value: function showTracks() {
      this._focused = this.tag('Tracks');
      this._refocus();
      sendEvent({
        key: 'playerTracksPanelOpen'
      });
    }
  }, {
    key: "showProgramInformation",
    value: function showProgramInformation() {
      this._focused = this.tag('ProgramInformation');
      this._refocus();
      sendEvent({
        key: 'pressSynopsis'
      });
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this._focused;
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this.tag('Main').alpha = 0;
      this._focusTag('Progress');
    }
  }, {
    key: "_captureKey",
    value: function _captureKey() {
      this.showControls();
      return false;
    }
  }, {
    key: "_handleLeft",
    value: function _handleLeft() {
      return true;
    }
  }, {
    key: "_handleUp",
    value: function _handleUp() {
      if (this._index > 0) {
        this._setIndex(this._index - 1);
        return true;
      }
      return false;
    }
  }, {
    key: "_handleDown",
    value: function _handleDown() {
      if (this._index < this._visibleFocusableItems.length - 1) {
        this._setIndex(this._index + 1);
        return true;
      }
      return false;
    }
  }, {
    key: "_setIndex",
    value: function _setIndex() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._index;
      var restartTimer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this._index = index;
      this._focused = this._visibleFocusableItems[this._index];
      if (restartTimer) {
        this._startAutoHide();
      }
    }
  }, {
    key: "_focusTag",
    value: function _focusTag(tagName) {
      var index = this._visibleFocusableItems.indexOf(this.tag(tagName));
      if (index === -1) {
        return;
      }
      this._setIndex(index);
    }
  }, {
    key: "_checkFocusableItems",
    value: function _checkFocusableItems() {
      var restartTimer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this._visibleFocusableItems = this._focusableItems.filter(function (item) {
        return item.visible;
      });
      if (this._focused && !this._focused.visible) {
        this._setIndex(0, restartTimer);
      } else if (this._focused) {
        this._setIndex(this._visibleFocusableItems.indexOf(this._focused), restartTimer);
      }
    }
  }, {
    key: "_handleSidePanelClose",
    value: function _handleSidePanelClose() {
      this._focusTag('TopBar');
      this._refocus();
      this._startAutoHide();
    }
  }, {
    key: "_handleSideGlassClose",
    value: function _handleSideGlassClose() {
      this._handleSidePanelClose();
      sendEvent({
        key: 'closeSideGlass'
      });
    }
  }, {
    key: "_handleTracksPanelClose",
    value: function _handleTracksPanelClose() {
      this._handleSidePanelClose();
      sendEvent({
        key: 'playerTracksPanelClose'
      });
    }
  }, {
    key: "_handleTopBarItemSelected",
    value: function _handleTopBarItemSelected(item) {
      this.signal(TOP_BAR_ITEM_SELECTED_SIGNAL, item);
      if (item && item.action) {
        switch (item.action) {
          case TOP_BAR_INFO_PAGE:
          case TOP_BAR_RELATED_VIDEOS:
          case TOP_BAR_TRACKS:
            this._startAutoHide.cancel();
            break;
          default:
            break;
        }
        lightningjs_redux.dispatch({
          type: item.action
        });
      }
    }
  }, {
    key: "_updateSeekAvailability",
    value: function _updateSeekAvailability() {
      var canSeek = !this._lBannerState;
      this.tag('Progress').seekEnable = this._isLive ? this._liveSeekEnabled : canSeek;
    }
  }, {
    key: "showControls",
    value: function showControls() {
      this.tag('Main').setSmooth('alpha', 1);
      if (!this._autoHideDisablingViews.includes(this._focused)) {
        this._startAutoHide();
      }
      this.signal(CONTROLS_SHOW_SIGNAL);
    }
  }], [{
    key: "_template",
    value: function _template() {
      var _passSignals, _passSignals3;
      return merge_default()({
        Main: {
          Overlay: {
            type: Overlay
          },
          TopBar: {
            type: TopBar,
            signals: (0,defineProperty/* default */.Z)({}, SELECTED_SIGNAL, '_handleTopBarItemSelected')
          },
          Toggle: {
            type: Toggle
          },
          Metadata: {
            type: metadata_component_Metadata
          },
          Progress: {
            type: ProgressBar,
            passSignals: (_passSignals = {}, (0,defineProperty/* default */.Z)(_passSignals, SEEK_SIGNAL, true), (0,defineProperty/* default */.Z)(_passSignals, progressBar_constants_PAUSE_SIGNAL, true), _passSignals)
          },
          SideGlass: {
            type: SideGlass,
            passSignals: (0,defineProperty/* default */.Z)({}, SELECTED_SIGNAL, SIDE_GLASS_ITEM_SELECTED_SIGNAL),
            signals: (0,defineProperty/* default */.Z)({}, sideGlass_constants_CLOSE_SIGNAL, '_handleSideGlassClose')
          },
          Tracks: {
            type: Tracks,
            signals: (0,defineProperty/* default */.Z)({}, tracks_constants_CLOSE_SIGNAL, '_handleTracksPanelClose'),
            passSignals: (_passSignals3 = {}, (0,defineProperty/* default */.Z)(_passSignals3, AUDIO_TRACK_SELECTED_SIGNAL, true), (0,defineProperty/* default */.Z)(_passSignals3, SUBTITLES_TRACK_SELECTED_SIGNAL, true), _passSignals3)
          },
          ProgramInformation: {
            type: programInformation_component_ProgramInformation,
            signals: (0,defineProperty/* default */.Z)({}, programInformation_constants_PROGRAM_INFORMATION_CLOSED_SIGNAL, '_handleSidePanelClose')
          }
        },
        AuxiliaryButtons: {}
      }, controls_style_getInitialStyle());
    }
  }]);
  return Controls;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/video/controls/controls.style.js
var controls_controls_style_getInitialStyle = function getInitialStyle() {
  return {
    AuxiliaryButtons: {
      zIndex: 1,
      SkipChapterButton: {
        mount: 1
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/video/controls/controls.constants.js

var _EVENTS;
var CHAPTERS = {
  INTRO: 'intro',
  OPENING_CREDITS: 'opening_credits',
  ENDING_CREDITS: 'ending_credits'
};
var EVENTS = (_EVENTS = {}, (0,defineProperty/* default */.Z)(_EVENTS, CHAPTERS.INTRO, 'skipIntro'), (0,defineProperty/* default */.Z)(_EVENTS, CHAPTERS.OPENING_CREDITS, 'skipIntro'), (0,defineProperty/* default */.Z)(_EVENTS, CHAPTERS.ENDING_CREDITS, 'skipCredits'), _EVENTS);
;// CONCATENATED MODULE: ./src/modules/video/controls/controls.component.js










function controls_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function controls_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? controls_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : controls_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function controls_controls_component_createSuper(t) { var r = controls_controls_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function controls_controls_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (controls_controls_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }








var VideoControls = function (_Controls) {
  (0,inherits/* default */.Z)(VideoControls, _Controls);
  var _super = controls_controls_component_createSuper(VideoControls);
  function VideoControls() {
    (0,classCallCheck/* default */.Z)(this, VideoControls);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(VideoControls, [{
    key: "_detach",
    value: function _detach() {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(VideoControls.prototype), "_detach", this).call(this);
      this._chapter = null;
    }
  }, {
    key: "chapter",
    set: function set(value) {
      this._chapter = value;
      if (!this._chapter) {
        this._setSkipButtonVisibilityState(false);
        return;
      }
      switch (this._chapter.type) {
        case CHAPTERS.INTRO:
          {
            this._setSkipButtonVisibilityState(true, t('player.skipIntro'));
            break;
          }
        case CHAPTERS.OPENING_CREDITS:
          {
            this._setSkipButtonVisibilityState(true, t('player.skipRecap'));
            break;
          }
        case CHAPTERS.ENDING_CREDITS:
          {
            this._setSkipButtonVisibilityState(true, t('player.skipCredits'));
            break;
          }
        default:
          this._setSkipButtonVisibilityState(false);
          break;
      }
    }
  }, {
    key: "_setSkipButtonVisibilityState",
    value: function _setSkipButtonVisibilityState(showButton) {
      var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var button = this.tag('SkipChapterButton');
      button.label = label || '';
      button.visible = showButton;
      if (this._autoHideDisablingViews.includes(this._focused)) {
        this._visibleFocusableItems = this._focusableItems.filter(function (item) {
          return item.visible;
        });
        return;
      }
      if (showButton && this.isHidden) {
        this._visibleFocusableItems = this._focusableItems.filter(function (item) {
          return item.visible;
        });
        this._setIndex(this._visibleFocusableItems.indexOf(button), false);
      } else {
        this._checkFocusableItems(false);
        if (!showButton) {
          this._focusTag('Progress');
        }
      }
      this._refocus();
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      if (!this._chapter || this._focused !== this.tag('SkipChapterButton')) {
        return false;
      }
      var event = EVENTS[this._chapter.type];
      if (event) {
        sendEvent({
          key: event
        });
        this.signal(SEEK_SIGNAL, this._chapter.tcEnd);
        this._setSkipButtonVisibilityState(false);
        return true;
      }
      return false;
    }
  }], [{
    key: "_template",
    value: function _template() {
      var base = (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(VideoControls), "_template", this).call(this);
      return merge_default()(controls_component_objectSpread(controls_component_objectSpread({}, base), {}, {
        AuxiliaryButtons: controls_component_objectSpread(controls_component_objectSpread({}, base.AuxiliaryButtons), {}, {
          SkipChapterButton: {
            type: CallToAction
          }
        })
      }), controls_controls_style_getInitialStyle());
    }
  }]);
  return VideoControls;
}(Controls);
;// CONCATENATED MODULE: ./src/modules/video/video.connector.js




var video_connector_mapControllers = function mapControllers(instance) {
  return {
    layout: {
      selector: getCurrentLayout,
      shouldBeInvokedOnConnect: true,
      callback: function callback() {
        instance.start();
      }
    },
    canPlay: {
      selector: getCanPlay,
      callback: function callback(value) {
        instance.canPlay = value;
      }
    },
    playbackState: {
      selector: getPlaybackState,
      callback: function callback(value) {
        instance.playbackState = value;
      }
    },
    isLoadingContent: {
      selector: getIsLoadingContent,
      shouldBeInvokedOnConnect: true,
      callback: function callback(value) {
        instance.isLoadingContent = value;
      }
    },
    shouldHideVideoLoader: {
      selector: shouldHideVideoLoader,
      shouldBeInvokedOnConnect: true,
      callback: function callback(value) {
        instance.shouldHideVideoLoader = value;
      }
    },
    isAdBreakDisplayed: {
      selector: isPlayingAds,
      callback: function callback(value) {
        instance.isAdBreakDisplayed = value;
      },
      shouldBeInvokedOnConnect: true
    },
    sideGlass: {
      selector: getSideGlassContent,
      callback: function callback(value) {
        instance.hasRelatedVideos = value;
      }
    },
    audioTracks: {
      selector: getAudioTracks,
      callback: function callback(value) {
        instance.audioTracks = value;
      }
    },
    subtitleTracks: {
      selector: getSubtitleTracks,
      callback: function callback(value) {
        instance.subtitleTracks = value;
      }
    },
    nextVideo: {
      selector: player_selectors_getIsEnded,
      shouldBeInvokedOnConnect: true,
      callback: function callback(value) {
        instance.shouldDisplayNextVideo = value;
      }
    },
    programInformation: {
      selector: getCurrentVideoItem,
      callback: function callback(value) {
        instance.programInformation = value;
      }
    },
    isVideoEnding: {
      selector: isVideoEnding,
      callback: function callback(value) {
        instance.isVideoEnding = value;
      }
    },
    pauseAdState: {
      selector: getPauseAdState,
      callback: function callback(value) {
        instance.pauseAdState = value;
      }
    },
    shouldDisplayLBanner: {
      selector: getLBannerState,
      callback: function callback(value) {
        instance.shouldDisplayLBanner = value;
      }
    }
  };
};
/* harmony default export */ const video_connector = (lightningjs_redux.control(video_connector_mapControllers));
;// CONCATENATED MODULE: ./src/modules/video/video.style.js


var video_style_defaultContext = makeDefaultStylingContext();
var video_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : video_style_defaultContext;
  var screenSize = context.screenSize;
  return {
    w: SCREEN_WIDTH[screenSize],
    h: sizes_SCREEN_HEIGHT[screenSize]
  };
};
;// CONCATENATED MODULE: ./src/modules/video/video.constants.js
var video_constants_TOP_BAR_ITEMS = {
  BACK: 'BACK',
  START_OVER: 'START_OVER',
  TRACKS: 'TRACKS',
  RELATED_VIDEOS: 'RELATED_VIDEOS',
  INFO_PAGE: 'INFO_PAGE'
};
var TRACK_KEYS = {
  PREFERRED_AUDIO_TRACK_LANGUAGE: 'preferredAudioTrackLanguage',
  PREFERRED_SUBTITLE_TRACK_LANGUAGE: 'preferredSubtitleTrackLanguage'
};
;// CONCATENATED MODULE: ./src/modules/video/video.utils.js




var defaultTopBarItems = [{
  id: video_constants_TOP_BAR_ITEMS.BACK,
  icon: 'ArrowLeftWithBase',
  text: t('nav.backToNav'),
  action: TOP_BAR_BACK
}, {
  id: video_constants_TOP_BAR_ITEMS.START_OVER,
  icon: 'StartOver',
  text: t('player.replay'),
  action: TOP_BAR_START_OVER
}, {
  id: video_constants_TOP_BAR_ITEMS.TRACKS,
  icon: 'Tracks',
  text: t('nav.subtitles'),
  action: TOP_BAR_TRACKS
}, {
  id: video_constants_TOP_BAR_ITEMS.RELATED_VIDEOS,
  icon: 'RelatedVideos',
  text: t('nav.relatedItems'),
  action: TOP_BAR_RELATED_VIDEOS
}, {
  id: video_constants_TOP_BAR_ITEMS.INFO_PAGE,
  icon: 'Info',
  text: t('nav.synopsis'),
  action: TOP_BAR_INFO_PAGE
}];
var getTopBarItems = function getTopBarItems(_ref) {
  var hasTracks = _ref.hasTracks,
    hasRelatedVideos = _ref.hasRelatedVideos,
    hasProgramInformation = _ref.hasProgramInformation,
    hasStartOver = _ref.hasStartOver;
  return defaultTopBarItems.filter(function (_ref2) {
    var id = _ref2.id;
    switch (id) {
      case video_constants_TOP_BAR_ITEMS.TRACKS:
        return hasTracks;
      case video_constants_TOP_BAR_ITEMS.RELATED_VIDEOS:
        return hasRelatedVideos;
      case video_constants_TOP_BAR_ITEMS.INFO_PAGE:
        return hasProgramInformation;
      case video_constants_TOP_BAR_ITEMS.START_OVER:
        return hasStartOver;
      default:
        return true;
    }
  });
};
;// CONCATENATED MODULE: ./src/modules/player/interface/contentAdvisory/customer/rtlde/contentAdvisory.constants.js

var _PICTO_MARGIN;

var PICTO_MARGIN = (_PICTO_MARGIN = {}, (0,defineProperty/* default */.Z)(_PICTO_MARGIN, HD, 8), (0,defineProperty/* default */.Z)(_PICTO_MARGIN, FULL_HD, 16), _PICTO_MARGIN);
var SHOULD_DISPLAY = false;
;// CONCATENATED MODULE: ./src/modules/player/interface/contentAdvisory/contentAdvisory.constants.js

var ADVISORY_BEFORE_VIDEO_END_DELAY = 5;
;// CONCATENATED MODULE: ./src/modules/player/interface/contentAdvisory/contentAdvisory.style.js

var contentAdvisory_style_MAX_TEXT_WIDTH, contentAdvisory_style_PADDING_LEFT, contentAdvisory_style_PADDING_TOP, contentAdvisory_style_TITLE_MARGIN_BOTTOM, _ICONS_MARGIN_BOTTOM, contentAdvisory_style_WIDTH, contentAdvisory_style_HEIGHT, _WIDTH2, _HEIGHT2;
function contentAdvisory_contentAdvisory_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function contentAdvisory_contentAdvisory_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? contentAdvisory_contentAdvisory_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : contentAdvisory_contentAdvisory_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






var contentAdvisory_contentAdvisory_style_defaultContext = makeDefaultStylingContext();
var contentAdvisory_contentAdvisory_style_MAX_TEXT_WIDTH = (contentAdvisory_style_MAX_TEXT_WIDTH = {}, (0,defineProperty/* default */.Z)(contentAdvisory_style_MAX_TEXT_WIDTH, HD, 400), (0,defineProperty/* default */.Z)(contentAdvisory_style_MAX_TEXT_WIDTH, FULL_HD, 608), contentAdvisory_style_MAX_TEXT_WIDTH);
var contentAdvisory_contentAdvisory_style_PADDING_LEFT = (contentAdvisory_style_PADDING_LEFT = {}, (0,defineProperty/* default */.Z)(contentAdvisory_style_PADDING_LEFT, HD, 64), (0,defineProperty/* default */.Z)(contentAdvisory_style_PADDING_LEFT, FULL_HD, 96), contentAdvisory_style_PADDING_LEFT);
var contentAdvisory_contentAdvisory_style_PADDING_TOP = (contentAdvisory_style_PADDING_TOP = {}, (0,defineProperty/* default */.Z)(contentAdvisory_style_PADDING_TOP, HD, 40), (0,defineProperty/* default */.Z)(contentAdvisory_style_PADDING_TOP, FULL_HD, 56), contentAdvisory_style_PADDING_TOP);
var contentAdvisory_contentAdvisory_style_TITLE_MARGIN_BOTTOM = (contentAdvisory_style_TITLE_MARGIN_BOTTOM = {}, (0,defineProperty/* default */.Z)(contentAdvisory_style_TITLE_MARGIN_BOTTOM, HD, 4), (0,defineProperty/* default */.Z)(contentAdvisory_style_TITLE_MARGIN_BOTTOM, FULL_HD, 4), contentAdvisory_style_TITLE_MARGIN_BOTTOM);
var ICONS_MARGIN_BOTTOM = (_ICONS_MARGIN_BOTTOM = {}, (0,defineProperty/* default */.Z)(_ICONS_MARGIN_BOTTOM, HD, 16), (0,defineProperty/* default */.Z)(_ICONS_MARGIN_BOTTOM, FULL_HD, 16), _ICONS_MARGIN_BOTTOM);
var contentAdvisory_contentAdvisory_style_ICON_SIZE = {
  WIDTH: (contentAdvisory_style_WIDTH = {}, (0,defineProperty/* default */.Z)(contentAdvisory_style_WIDTH, HD, 32), (0,defineProperty/* default */.Z)(contentAdvisory_style_WIDTH, FULL_HD, 40), contentAdvisory_style_WIDTH),
  HEIGHT: (contentAdvisory_style_HEIGHT = {}, (0,defineProperty/* default */.Z)(contentAdvisory_style_HEIGHT, HD, 32), (0,defineProperty/* default */.Z)(contentAdvisory_style_HEIGHT, FULL_HD, 40), contentAdvisory_style_HEIGHT)
};
var TREATMENT_SIZE = {
  WIDTH: (_WIDTH2 = {}, (0,defineProperty/* default */.Z)(_WIDTH2, HD, 1280), (0,defineProperty/* default */.Z)(_WIDTH2, FULL_HD, 1920), _WIDTH2),
  HEIGHT: (_HEIGHT2 = {}, (0,defineProperty/* default */.Z)(_HEIGHT2, HD, 720), (0,defineProperty/* default */.Z)(_HEIGHT2, FULL_HD, 1080), _HEIGHT2)
};
var contentAdvisory_style_getIconViewBox = memoize_default()(function (screenSize) {
  return {
    w: contentAdvisory_contentAdvisory_style_ICON_SIZE.WIDTH[screenSize],
    h: contentAdvisory_contentAdvisory_style_ICON_SIZE.HEIGHT[screenSize]
  };
});
var contentAdvisory_contentAdvisory_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : contentAdvisory_contentAdvisory_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  var titleFont = src_getFont(constants_FONT.OTTAWA_2, screenSize);
  var descriptionFont = src_getFont(constants_FONT.OTTAWA_1, screenSize);
  var wordWrapWidth = contentAdvisory_contentAdvisory_style_MAX_TEXT_WIDTH[screenSize];
  return {
    visible: SHOULD_DISPLAY,
    Treatment: {
      visible: false,
      rect: true,
      w: TREATMENT_SIZE.WIDTH[screenSize],
      h: TREATMENT_SIZE.HEIGHT[screenSize],
      colorUl: makeThemeColor(TERTIARY, 0.8)[colorMode],
      colorUr: makeThemeColor(TERTIARY, 0)[colorMode],
      colorBr: makeThemeColor(TERTIARY, 0)[colorMode],
      colorBl: makeThemeColor(TERTIARY, 0)[colorMode]
    },
    Content: {
      flex: {
        direction: 'column',
        justifyContent: 'flex-start',
        paddingLeft: contentAdvisory_contentAdvisory_style_PADDING_LEFT[screenSize],
        paddingTop: contentAdvisory_contentAdvisory_style_PADDING_TOP[screenSize]
      },
      zIndex: 2,
      Icons: {
        flex: {
          direction: 'row',
          justifyContent: 'flex-start'
        },
        flexItem: {
          marginBottom: ICONS_MARGIN_BOTTOM[screenSize]
        }
      },
      Title: {
        flexItem: {
          marginBottom: contentAdvisory_contentAdvisory_style_TITLE_MARGIN_BOTTOM[screenSize]
        },
        text: contentAdvisory_contentAdvisory_style_objectSpread(contentAdvisory_contentAdvisory_style_objectSpread({}, titleFont), {}, {
          wordWrapWidth: wordWrapWidth,
          maxLines: 1,
          maxLinesSuffix: '...',
          verticalAlign: 'middle'
        })
      },
      Description: {
        text: contentAdvisory_contentAdvisory_style_objectSpread(contentAdvisory_contentAdvisory_style_objectSpread({}, descriptionFont), {}, {
          wordWrapWidth: wordWrapWidth,
          maxLines: 3,
          maxLinesSuffix: '...',
          verticalAlign: 'middle'
        })
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/player/interface/contentAdvisory/contentAdvisory.connector.js


var contentAdvisory_connector_mapControllers = function mapControllers(instance) {
  return {
    contentAdvisory: {
      selector: getContentAdvisory,
      callback: function callback(value) {
        instance.contentAdvisory = value;
      }
    }
  };
};
/* harmony default export */ const contentAdvisory_connector = (lightningjs_redux.control(contentAdvisory_connector_mapControllers));
;// CONCATENATED MODULE: ./src/modules/player/interface/contentAdvisory/contentAdvisory.component.js









function contentAdvisory_contentAdvisory_component_createSuper(t) { var r = contentAdvisory_contentAdvisory_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function contentAdvisory_contentAdvisory_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (contentAdvisory_contentAdvisory_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }







var contentAdvisory_component_ContentAdvisory = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(ContentAdvisory, _Lightning$Component);
  var _super = contentAdvisory_contentAdvisory_component_createSuper(ContentAdvisory);
  function ContentAdvisory() {
    (0,classCallCheck/* default */.Z)(this, ContentAdvisory);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(ContentAdvisory, [{
    key: "_construct",
    value: function _construct() {
      this._style = contentAdvisory_contentAdvisory_style_defaultContext;
      this._hasData = false;
      this._displayDuration = ADVISORY_DISPLAY_DURATION_IN_SECONDS * 1000;
      this._inProgress = false;
      this._timerId = null;
    }
  }, {
    key: "_build",
    value: function _build() {
      this._hide();
    }
  }, {
    key: "_attach",
    value: function _attach() {
      this._unsubscribe = contentAdvisory_connector(this);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      if (this._unsubscribe) {
        this._unsubscribe();
        this._unsubscribe = null;
      }
      this._destroyTimer();
    }
  }, {
    key: "contentAdvisory",
    set: function set(value) {
      if (value) {
        this._setText(value.title, 'Title');
        this._setText(value.description, 'Description');
        this.pictos = value.pictos;
        this.tag('Treatment').visible = this._hasData;
      } else {
        this._hasData = false;
      }
    }
  }, {
    key: "pictos",
    set: function set(value) {
      var _this = this;
      if (!value) {
        return;
      }
      var iconViewBox = contentAdvisory_style_getIconViewBox(this._style.screenSize);
      var element = this.tag('Icons');
      element.children = value.filter(Boolean).map(function (picto) {
        return {
          type: Icon,
          iconData: {
            picto: picto,
            viewBox: iconViewBox
          },
          flexItem: {
            marginRight: PICTO_MARGIN[_this._style.screenSize]
          }
        };
      });
      this._hasData = this._hasData || Boolean(element.children.length);
    }
  }, {
    key: "_setText",
    value: function _setText(value, tag) {
      var element = this.tag(tag);
      element.text.text = value;
      element.visible = Boolean(value);
      this._hasData = this._hasData || element.visible;
    }
  }, {
    key: "_show",
    value: function _show() {
      this.alpha = 1;
    }
  }, {
    key: "_hide",
    value: function _hide() {
      this.alpha = 0;
    }
  }, {
    key: "_complete",
    value: function _complete() {
      this._hide();
      this._inProgress = false;
    }
  }, {
    key: "_startTimer",
    value: function _startTimer() {
      this._timerId = setTimeout(this._complete.bind(this), this._displayDuration);
    }
  }, {
    key: "_destroyTimer",
    value: function _destroyTimer() {
      if (this._timerId) {
        clearTimeout(this._timerId);
        this._timerId = null;
      }
    }
  }, {
    key: "start",
    value: function start() {
      this._show();
      this._startTimer();
      this._inProgress = true;
    }
  }, {
    key: "pause",
    value: function pause() {
      this._hide();
      if (this._inProgress) {
        this._destroyTimer();
      }
    }
  }, {
    key: "resume",
    value: function resume() {
      if (!this._inProgress) {
        this._hide();
        return;
      }
      this._show();
      this._startTimer();
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Treatment: {},
        Content: {
          Icons: {},
          Title: {},
          Description: {}
        }
      }, contentAdvisory_contentAdvisory_style_getInitialStyle());
    }
  }]);
  return ContentAdvisory;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/player/interface/csaIcon/customer/default/csaIcon.component.js





function csaIcon_component_createSuper(t) { var r = csaIcon_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function csaIcon_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (csaIcon_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var CsaIcon = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(CsaIcon, _Lightning$Component);
  var _super = csaIcon_component_createSuper(CsaIcon);
  function CsaIcon() {
    (0,classCallCheck/* default */.Z)(this, CsaIcon);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(CsaIcon, [{
    key: "handleIcon",
    value: function handleIcon() {}
  }], [{
    key: "_template",
    value: function _template() {
      return {};
    }
  }]);
  return CsaIcon;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/player/interface/csaIcon/csaIcon.component.js

;// CONCATENATED MODULE: ./src/modules/player/google-ads/googlePauseAds.connector.js


var googlePauseAds_connector_mapControllers = function mapControllers(instance) {
  return [{
    selector: getPauseAdRequestData,
    callback: function callback(value) {
      instance.adRequestData = value;
    },
    shouldBeInvokedOnConnect: true
  }, {
    selector: getCurrentPauseAd,
    callback: function callback(value) {
      instance.ad = value;
    },
    shouldBeInvokedOnConnect: true
  }];
};
/* harmony default export */ const googlePauseAds_connector = (lightningjs_redux.control(googlePauseAds_connector_mapControllers));
;// CONCATENATED MODULE: ./src/modules/player/google-ads/googlePauseAds.utils.js


var googlePauseAds_utils_track = function track(urls) {
  return urls ? urls.map(function (url) {
    return client_default().get(url).catch(function () {});
  }) : [];
};
;// CONCATENATED MODULE: ./src/modules/player/google-ads/googlePauseAds.style.js




var googlePauseAds_style_defaultContext = makeDefaultStylingContext();
var googlePauseAds_style_colors = {
  background: makeThemeColor(PRIMARY),
  text: makeThemeColor(TERTIARY)
};
var googlePauseAds_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : googlePauseAds_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  return {
    w: SCREEN_WIDTH[screenSize],
    h: sizes_SCREEN_HEIGHT[screenSize],
    Image: {
      w: SCREEN_WIDTH[screenSize],
      h: sizes_SCREEN_HEIGHT[screenSize]
    },
    Pill: {
      x: safetyMargins.horizontal[screenSize],
      y: safetyMargins.vertical[screenSize],
      backgroundColor: googlePauseAds_style_colors.background[colorMode],
      textColor: googlePauseAds_style_colors.text[colorMode]
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/player/google-ads/googlePauseAds.component.js









function googlePauseAds_component_createSuper(t) { var r = googlePauseAds_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function googlePauseAds_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (googlePauseAds_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }









var GooglePauseAds = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(GooglePauseAds, _Lightning$Component);
  var _super = googlePauseAds_component_createSuper(GooglePauseAds);
  function GooglePauseAds() {
    (0,classCallCheck/* default */.Z)(this, GooglePauseAds);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(GooglePauseAds, [{
    key: "_construct",
    value: function _construct() {
      this._adAvailable = false;
      this._imageAvailable = false;
    }
  }, {
    key: "_attach",
    value: function () {
      var _attach2 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee() {
        var _this = this;
        var image;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this._unsubscribe = googlePauseAds_connector(this);
              image = this.tag('Image');
              image.on('txLoaded', function () {
                _this._imageAvailable = true;
                _this.tag('Pill').visible = true;
                lightningjs_redux.dispatch(pauseAdsDisplaying());
                googlePauseAds_utils_track(_this._trackers);
              });
              image.on('txError', function () {
                _this._imageAvailable = false;
                _this.tag('Pill').visible = false;
                lightningjs_redux.dispatch(pauseAdsError());
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function _attach() {
        return _attach2.apply(this, arguments);
      }
      return _attach;
    }()
  }, {
    key: "_detach",
    value: function _detach() {
      if (this._unsubscribe) {
        this._unsubscribe();
        this._unsubscribe = null;
      }
      this._trackers = null;
      this.tag('Image').removeAllListeners('txLoaded');
      this.tag('Image').removeAllListeners('txError');
    }
  }, {
    key: "isAvailable",
    get: function get() {
      return this._adAvailable;
    }
  }, {
    key: "adRequestData",
    set: function set(value) {
      this._adAvailable = Boolean(value);
    }
  }, {
    key: "ad",
    set: function set(value) {
      var image = this.tag('Image');
      this.tag('Pill').visible = false;
      this._imageAvailable = false;
      if (!value) {
        image.src = null;
        return;
      }
      this._trackers = [];
      if (value.tracking_url) {
        if (value.tracking_url.view) {
          this._trackers.push(value.tracking_url.view);
        }
        if (Array.isArray(value.tracking_url.views)) {
          this._trackers = this._trackers.concat(value.tracking_url.views);
        }
      }
      image.src = value.file_url;
      image.loadTexture();
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Image: {},
        Pill: {
          type: pill_component_Pill,
          title: t('player.advertisement'),
          body: t('player.pauseAdMessage')
        }
      }, googlePauseAds_style_getInitialStyle());
    }
  }]);
  return GooglePauseAds;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/video/video.component.js









function video_component_createSuper(t) { var r = video_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function video_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (video_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }





























var Video = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Video, _Lightning$Component);
  var _super = video_component_createSuper(Video);
  function Video() {
    (0,classCallCheck/* default */.Z)(this, Video);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Video, [{
    key: "_onUrlParams",
    value: function _onUrlParams(_ref) {
      var videoId = _ref.videoId;
      lightningjs_redux.dispatch(player_constants_reset());
      lightningjs_redux.dispatch(fetchLayout(layout_constants/* entities */.jF.video, videoId));
    }
  }, {
    key: "_active",
    value: function _active() {
      this._canPlay = false;
      this._hasRelatedVideos = false;
      this._hasTracks = false;
      this._hasProgramInformation = false;
      this._isShowingControls = false;
      this._isShowingLBanner = false;
      this._isVideoEnding = false;
      this._pauseAdState = null;
      this._isSeeking = false;
      this._setState('Loading');
      this._unsubscribe = video_connector(this);
      this.stage.gc(true);
    }
  }, {
    key: "_inactive",
    value: function _inactive() {
      if (this._unsubscribe) {
        this._unsubscribe();
        this._unsubscribe = null;
      }
    }
  }, {
    key: "isLoadingContent",
    set: function set(value) {
      if (value) {
        this._setState('Loading');
      }
    }
  }, {
    key: "canPlay",
    set: function set(value) {
      this._canPlay = value;
      if (this._canPlay) {
        this._handleVideoStart();
      }
    }
  }, {
    key: "playbackState",
    set: function set(value) {
      if (value === PLAYBACK_STATE_PLAYING) {
        this._setState('Playback.Playing');
      }
    }
  }, {
    key: "shouldHideVideoLoader",
    set: function set(value) {
      if (value) {
        this.tag('Loader').hide();
      }
    }
  }, {
    key: "hasRelatedVideos",
    set: function set(value) {
      this._hasRelatedVideos = value;
      this._updateTopBarItems();
    }
  }, {
    key: "audioTracks",
    set: function set(value) {
      this._hasTracks = this._hasTracks || value && value.length > 1;
      this._updateTopBarItems(value);
    }
  }, {
    key: "subtitleTracks",
    set: function set(value) {
      this._hasTracks = this._hasTracks || value && value.length > 0 && !areForcedSubtitlesOnly(value);
      this._updateTopBarItems(value);
    }
  }, {
    key: "shouldDisplayNextVideo",
    set: function set(value) {
      var nextVideo = this.tag('NextVideo');
      nextVideo.visible = value && nextVideo.isAvailable;
      if (value) {
        if (nextVideo.isAvailable) {
          this._setState('NextVideo');
        } else {
          Router.back();
        }
      }
    }
  }, {
    key: "shouldDisplayLBanner",
    set: function set(value) {
      this._isLBannerEnabled = Boolean(value);
      this._updateTopBarItems();
      if (value) {
        var playerScale = 1 - getLBannerWidthScale();
        var playerX = getLBannerWidth();
        this.tag('Player').setlBannerState(true);
        this.tag('Wrapper').patch({
          smooth: {
            scale: playerScale,
            x: playerX
          }
        });
        this.tag('LBanner').show();
      } else {
        this.tag('Player').setlBannerState(false);
        this.tag('Wrapper').patch({
          smooth: {
            scale: 1,
            x: 0
          }
        });
        this.tag('LBanner').hide();
      }
    }
  }, {
    key: "programInformation",
    set: function set(value) {
      this._hasProgramInformation = Boolean(value && (value.description || value.title));
      this._updateTopBarItems();
    }
  }, {
    key: "isAdBreakDisplayed",
    set: function set(value) {
      if (value) {
        this._setState('Ads');
      }
    }
  }, {
    key: "isSeeking",
    get: function get() {
      return this._isSeeking;
    },
    set: function set(value) {
      this._isSeeking = value;
    }
  }, {
    key: "start",
    value: function start() {
      lightningjs_redux.dispatch(fetchPlayerLayout());
    }
  }, {
    key: "_handleVideoStart",
    value: function _handleVideoStart() {
      this.tag('NextVideo').visible = false;
      this.tag('Player').play();
    }
  }, {
    key: "_handleBack",
    value: function _handleBack() {
      sendEvent({
        key: 'pressBackButtonDuringVideo'
      });
      return false;
    }
  }, {
    key: "_handleStop",
    value: function _handleStop() {
      Router.back();
      return true;
    }
  }, {
    key: "_pause",
    value: function _pause() {
      this.tag('Player').pause();
      this.tag('Controls').show(PAUSED_STATE);
      sendEvent({
        key: 'pauseVideo'
      });
    }
  }, {
    key: "_play",
    value: function _play() {
      this.tag('Player').play();
      this.tag('Controls').show(PLAYING_STATE);
    }
  }, {
    key: "_updateTopBarItems",
    value: function _updateTopBarItems() {
      this.tag('Controls').topBarItems = getTopBarItems({
        hasTracks: this._hasTracks,
        hasRelatedVideos: this._hasRelatedVideos,
        hasProgramInformation: this._hasProgramInformation,
        hasStartOver: !this._isLBannerEnabled
      });
    }
  }, {
    key: "_handleLoaderSequenceComplete",
    value: function _handleLoaderSequenceComplete() {
      this._isLoadingSequenceComplete = true;
    }
  }, {
    key: "_handleSeek",
    value: function _handleSeek(position) {
      console.log('[video.component] content position on seek ', position);
      this.tag('Player').seek(position);
    }
  }, {
    key: "_handleTopBarItemSelection",
    value: function _handleTopBarItemSelection(item) {
      var id = get_default()(item, 'id', '');
      if (id === video_constants_TOP_BAR_ITEMS.BACK) {
        Router.back();
      } else if (id === video_constants_TOP_BAR_ITEMS.START_OVER) {
        this._handleSeek(0);
        this._play();
      } else if (id === video_constants_TOP_BAR_ITEMS.TRACKS) {
        this.tag('Controls').showTracks();
      } else if (id === video_constants_TOP_BAR_ITEMS.RELATED_VIDEOS) {
        this.tag('Controls').showSideGlass();
      } else if (id === video_constants_TOP_BAR_ITEMS.INFO_PAGE) {
        this.tag('Controls').showProgramInformation();
      }
    }
  }, {
    key: "_handleItemAction",
    value: function _handleItemAction(item) {
      dispatchItemAction(item);
    }
  }, {
    key: "_handleAudioTrackSelection",
    value: function _handleAudioTrackSelection(track) {
      if (track) {
        lightningjs_redux.dispatch(selectAudioTrack(track));
      }
    }
  }, {
    key: "_handleSubtitlesTrackSelection",
    value: function _handleSubtitlesTrackSelection(track) {
      lightningjs_redux.dispatch(selectSubtitlesTrack(track));
    }
  }, {
    key: "_handleVideoReplaySelection",
    value: function _handleVideoReplaySelection() {
      this._handleSeek(0);
      this._handleVideoStart();
    }
  }, {
    key: "_handleNextVideoClose",
    value: function _handleNextVideoClose() {
      Router.back();
    }
  }], [{
    key: "_template",
    value: function _template() {
      var _signals, _signals2;
      return merge_default()({
        LBanner: {
          type: LBanner
        },
        Wrapper: {
          Player: {
            type: Player
          },
          Controls: {
            type: VideoControls,
            topBarItems: [],
            signals: (_signals = {}, (0,defineProperty/* default */.Z)(_signals, SEEK_SIGNAL, '_handleSeek'), (0,defineProperty/* default */.Z)(_signals, progressBar_constants_PAUSE_SIGNAL, '_handleProgressBarLongSeek'), (0,defineProperty/* default */.Z)(_signals, TOP_BAR_ITEM_SELECTED_SIGNAL, '_handleTopBarItemSelection'), (0,defineProperty/* default */.Z)(_signals, SIDE_GLASS_ITEM_SELECTED_SIGNAL, '_handleItemAction'), (0,defineProperty/* default */.Z)(_signals, AUDIO_TRACK_SELECTED_SIGNAL, '_handleAudioTrackSelection'), (0,defineProperty/* default */.Z)(_signals, SUBTITLES_TRACK_SELECTED_SIGNAL, '_handleSubtitlesTrackSelection'), (0,defineProperty/* default */.Z)(_signals, CONTROLS_SHOW_SIGNAL, '_onControlsShown'), (0,defineProperty/* default */.Z)(_signals, CONTROLS_HIDE_SIGNAL, '_onControlsHidden'), _signals)
          },
          ContentAdvisory: {
            type: contentAdvisory_component_ContentAdvisory
          },
          CsaIcon: {
            type: CsaIcon
          },
          PauseAds: {
            type: GooglePauseAds,
            visible: false
          },
          NextVideo: {
            type: NextVideo,
            signals: (_signals2 = {}, (0,defineProperty/* default */.Z)(_signals2, CLOSE_SIGNAL, '_handleNextVideoClose'), (0,defineProperty/* default */.Z)(_signals2, REPLAY_VIDEO_SIGNAL, '_handleVideoReplaySelection'), (0,defineProperty/* default */.Z)(_signals2, NEXT_VIDEO_SIGNAL, '_handleItemAction'), _signals2)
          },
          Loader: {
            type: VideoLoader,
            signals: (0,defineProperty/* default */.Z)({}, COMPLETE_SIGNAL, '_handleLoaderSequenceComplete')
          }
        }
      }, video_style_getInitialStyle());
    }
  }, {
    key: "_states",
    value: function _states() {
      return [function (_this) {
        (0,inherits/* default */.Z)(Loading, _this);
        var _super2 = video_component_createSuper(Loading);
        function Loading() {
          (0,classCallCheck/* default */.Z)(this, Loading);
          return _super2.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(Loading, [{
          key: "$enter",
          value: function $enter() {
            this._isLoadingSequenceComplete = false;
            this.tag('Loader').show();
          }
        }]);
        return Loading;
      }(this), function (_this2) {
        (0,inherits/* default */.Z)(Playback, _this2);
        var _super3 = video_component_createSuper(Playback);
        function Playback() {
          (0,classCallCheck/* default */.Z)(this, Playback);
          return _super3.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(Playback, [{
          key: "displayPauseAds",
          set: function set(value) {
            var pauseAds = this.tag('PauseAds');
            var controls = this.tag('Controls');
            if (!pauseAds.isAvailable) {
              controls.visible = true;
              pauseAds.visible = false;
              return;
            }
            if (value) {
              lightningjs_redux.dispatch(refreshPauseAd());
            }
            controls.visible = !value;
            pauseAds.visible = value;
          }
        }, {
          key: "isVideoEnding",
          set: function set(value) {
            this._isVideoEnding = value;
            this._displayContentAdvisoryIfRequired();
          }
        }, {
          key: "_getFocused",
          value: function _getFocused() {
            return this.tag('Controls');
          }
        }, {
          key: "_onControlsShown",
          value: function _onControlsShown() {
            this.tag('ContentAdvisory').pause();
            this._isShowingControls = true;
            this.tag('CsaIcon').handleIcon(false);
          }
        }, {
          key: "_onControlsHidden",
          value: function _onControlsHidden() {
            this._isShowingControls = false;
            this.tag('CsaIcon').handleIcon(true);
          }
        }, {
          key: "_displayContentAdvisoryIfRequired",
          value: function _displayContentAdvisoryIfRequired() {
            if (this._isVideoEnding && !this._isShowingControls) {
              this.tag('ContentAdvisory').start();
            }
          }
        }], [{
          key: "_states",
          value: function _states() {
            return [function (_this3) {
              (0,inherits/* default */.Z)(Playing, _this3);
              var _super4 = video_component_createSuper(Playing);
              function Playing() {
                (0,classCallCheck/* default */.Z)(this, Playing);
                return _super4.apply(this, arguments);
              }
              (0,createClass/* default */.Z)(Playing, [{
                key: "$enter",
                value: function $enter(states) {
                  var previousState = get_default()(states, 'prevState', '');
                  this.tag('ContentAdvisory').start();
                  if (previousState === 'Loading') {
                    this.tag('Controls').showControls();
                  } else if (previousState === 'Playback.Paused') {
                    this.tag('ContentAdvisory').pause();
                  }
                  lightningjs_redux.dispatch(setScreenSaverIsLocked(true));
                  this.isSeeking = false;
                  this.displayPauseAds = false;
                }
              }, {
                key: "$exit",
                value: function $exit() {
                  this.tag('ContentAdvisory').pause();
                }
              }, {
                key: "_handleEnter",
                value: function _handleEnter() {
                  this._handlePauseControl();
                  return true;
                }
              }, {
                key: "_handlePause",
                value: function _handlePause() {
                  this._handlePauseControl();
                  return true;
                }
              }, {
                key: "_handlePlayPause",
                value: function _handlePlayPause() {
                  this._handlePauseControl();
                  return true;
                }
              }, {
                key: "_handlePauseControl",
                value: function _handlePauseControl() {
                  this._pause();
                  this.displayPauseAds = true;
                }
              }, {
                key: "_handleProgressBarLongSeek",
                value: function _handleProgressBarLongSeek() {
                  this.isSeeking = true;
                  this._pause();
                }
              }, {
                key: "_onControlsHidden",
                value: function _onControlsHidden() {
                  this.tag('ContentAdvisory').resume();
                  (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(Playing.prototype), "_onControlsHidden", this).call(this);
                }
              }, {
                key: "playbackState",
                set: function set(value) {
                  if (value === PLAYBACK_STATE_PAUSED) {
                    this._setState('Playback.Paused');
                  }
                }
              }]);
              return Playing;
            }(this), function (_this4) {
              (0,inherits/* default */.Z)(Paused, _this4);
              var _super5 = video_component_createSuper(Paused);
              function Paused() {
                (0,classCallCheck/* default */.Z)(this, Paused);
                return _super5.apply(this, arguments);
              }
              (0,createClass/* default */.Z)(Paused, [{
                key: "$exit",
                value: function $exit() {
                  this.tag('Controls').visible = true;
                }
              }, {
                key: "_getFocused",
                value: function _getFocused() {
                  if (this.isSeeking) {
                    return (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(Paused.prototype), "_getFocused", this).call(this);
                  }
                  var pauseAds = this.tag('PauseAds');
                  return pauseAds.isAvailable && this._pauseAdState !== PAUSE_AD_STATE.ERROR ? pauseAds : (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(Paused.prototype), "_getFocused", this).call(this);
                }
              }, {
                key: "_handleEnter",
                value: function _handleEnter() {
                  this._play();
                  return true;
                }
              }, {
                key: "_handlePlay",
                value: function _handlePlay() {
                  this._play();
                  return true;
                }
              }, {
                key: "_handlePlayPause",
                value: function _handlePlayPause() {
                  this._play();
                  return true;
                }
              }, {
                key: "_play",
                value: function _play() {
                  (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(Paused.prototype), "_play", this).call(this);
                  this.tag('Controls').showControls();
                }
              }, {
                key: "pauseAdState",
                set: function set(value) {
                  this._pauseAdState = value;
                  if (value === PAUSE_AD_STATE.ERROR) {
                    var pauseAds = this.tag('PauseAds');
                    var controls = this.tag('Controls');
                    pauseAds.visible = false;
                    controls.visible = true;
                    controls.showControls();
                  }
                }
              }]);
              return Paused;
            }(this)];
          }
        }]);
        return Playback;
      }(this), function (_this5) {
        (0,inherits/* default */.Z)(Ads, _this5);
        var _super6 = video_component_createSuper(Ads);
        function Ads() {
          (0,classCallCheck/* default */.Z)(this, Ads);
          return _super6.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(Ads, [{
          key: "$enter",
          value: function $enter() {
            this.tag('Loader').hide();
          }
        }, {
          key: "_getFocused",
          value: function _getFocused() {
            return this.tag('Player');
          }
        }]);
        return Ads;
      }(this), function (_this6) {
        (0,inherits/* default */.Z)(NextVideo, _this6);
        var _super7 = video_component_createSuper(NextVideo);
        function NextVideo() {
          (0,classCallCheck/* default */.Z)(this, NextVideo);
          return _super7.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(NextVideo, [{
          key: "$enter",
          value: function $enter() {
            this.tag('Controls').visible = false;
          }
        }, {
          key: "_getFocused",
          value: function _getFocused() {
            return this.tag('NextVideo');
          }
        }]);
        return NextVideo;
      }(this)];
    }
  }]);
  return Video;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/live/live.connector.js





var live_connector_mapControllers = function mapControllers(instance) {
  return {
    shouldSwitchToNextProgram: {
      selector: shouldSwitchToNextProgram,
      callback: function callback(value) {
        instance.shouldSwitchToNextProgram = value;
      }
    },
    shouldLoadNewMetadataItems: {
      selector: shouldLoadNewMetadataItems,
      callback: function callback(value) {
        instance.shouldLoadNewMetadataItems = value;
      }
    },
    layout: {
      selector: getCurrentLayout,
      shouldBeInvokedOnConnect: true,
      callback: function callback() {
        instance.start();
      }
    },
    canPlay: {
      selector: getCanPlay,
      callback: function callback(value) {
        instance.canPlay = value;
      }
    },
    playbackState: {
      selector: getPlaybackState,
      callback: function callback(value) {
        instance.playbackState = value;
      }
    },
    shouldHideVideoLoader: {
      selector: shouldHideVideoLoader,
      shouldBeInvokedOnConnect: true,
      callback: function callback(value) {
        instance.shouldHideVideoLoader = value;
      }
    },
    isLoadingContent: {
      selector: getIsLoadingContent,
      shouldBeInvokedOnConnect: true,
      callback: function callback(value) {
        instance.isLoadingContent = value;
      }
    },
    isAdBreakDisplayed: {
      selector: isPlayingAds,
      callback: function callback(value) {
        instance.isAdBreakDisplayed = value;
      },
      shouldBeInvokedOnConnect: true
    },
    sideGlass: {
      selector: getSideGlassContent,
      callback: function callback(value) {
        instance.hasRelatedVideos = value;
      }
    },
    audioTracks: {
      selector: getAudioTracks,
      callback: function callback(value) {
        instance.audioTracks = value;
      }
    },
    subtitleTracks: {
      selector: getSubtitleTracks,
      callback: function callback(value) {
        instance.subtitleTracks = value;
      }
    },
    programInformation: {
      selector: getCurrentVideoItem,
      callback: function callback(value) {
        instance.programInformation = value;
      }
    },
    isVideoEnding: {
      selector: isVideoEnding,
      callback: function callback(value) {
        instance.isVideoEnding = value;
      }
    },
    startTimeInSeconds: {
      selector: getStartTimeInSeconds,
      callback: function callback(value) {
        instance.startTimeInSeconds = value;
      }
    },
    startOverFeature: {
      selector: isLiveStartOverEnabled,
      shouldBeInvokedOnConnect: true,
      callback: function callback(value) {
        instance.startOverFeature = value;
      }
    },
    isOnLive: {
      selector: isOnLive,
      callback: function callback(value) {
        instance.isOnLive = value;
      }
    }
  };
};
/* harmony default export */ const live_connector = (lightningjs_redux.control(live_connector_mapControllers));
;// CONCATENATED MODULE: ./src/modules/live/live.style.js


var live_style_defaultContext = makeDefaultStylingContext();
var live_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : live_style_defaultContext;
  var screenSize = context.screenSize;
  return {
    w: SCREEN_WIDTH[screenSize],
    h: sizes_SCREEN_HEIGHT[screenSize]
  };
};
;// CONCATENATED MODULE: ./src/modules/live/live.constants.js
var live_constants_TOP_BAR_ITEMS = {
  BACK: 'BACK',
  START_OVER: 'START_OVER',
  BACK_TO_LIVE: 'BACK_TO_LIVE',
  TRACKS: 'TRACKS',
  RELATED_VIDEOS: 'RELATED_VIDEOS',
  INFO_PAGE: 'INFO_PAGE'
};
var live_constants_TRACK_KEYS = {
  PREFERRED_AUDIO_TRACK_LANGUAGE: 'preferredAudioTrackLanguage',
  PREFERRED_SUBTITLE_TRACK_LANGUAGE: 'preferredSubtitleTrackLanguage'
};
;// CONCATENATED MODULE: ./src/modules/live/live.utils.js




var live_utils_defaultTopBarItems = [{
  id: live_constants_TOP_BAR_ITEMS.BACK,
  icon: 'ArrowLeftWithBase',
  text: t('nav.backToNav'),
  action: TOP_BAR_BACK
}, {
  id: live_constants_TOP_BAR_ITEMS.START_OVER,
  icon: 'StartOver',
  text: t('player.replay'),
  action: TOP_BAR_START_OVER
}, {
  id: live_constants_TOP_BAR_ITEMS.BACK_TO_LIVE,
  icon: 'BackToLive',
  text: t('nav.backToLive'),
  action: TOP_BAR_BACK_TO_LIVE
}, {
  id: live_constants_TOP_BAR_ITEMS.TRACKS,
  icon: 'Tracks',
  text: t('nav.subtitles'),
  action: TOP_BAR_TRACKS
}, {
  id: live_constants_TOP_BAR_ITEMS.RELATED_VIDEOS,
  icon: 'RelatedVideos',
  text: t('nav.channelSelector'),
  action: TOP_BAR_RELATED_VIDEOS
}, {
  id: live_constants_TOP_BAR_ITEMS.INFO_PAGE,
  icon: 'Info',
  text: t('nav.synopsis'),
  action: TOP_BAR_INFO_PAGE
}];
var live_utils_getTopBarItems = function getTopBarItems(_ref) {
  var isOnLive = _ref.isOnLive,
    hasTracks = _ref.hasTracks,
    hasRelatedVideos = _ref.hasRelatedVideos,
    hasProgramInformation = _ref.hasProgramInformation,
    startOverFeature = _ref.startOverFeature;
  return live_utils_defaultTopBarItems.filter(function (_ref2) {
    var id = _ref2.id;
    switch (id) {
      case live_constants_TOP_BAR_ITEMS.START_OVER:
        return isOnLive && startOverFeature;
      case live_constants_TOP_BAR_ITEMS.BACK_TO_LIVE:
        return !isOnLive && startOverFeature;
      case live_constants_TOP_BAR_ITEMS.TRACKS:
        return hasTracks;
      case live_constants_TOP_BAR_ITEMS.RELATED_VIDEOS:
        return hasRelatedVideos;
      case live_constants_TOP_BAR_ITEMS.INFO_PAGE:
        return hasProgramInformation;
      default:
        return true;
    }
  });
};
;// CONCATENATED MODULE: ./src/modules/live/live.component.js









function live_component_createSuper(t) { var r = live_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function live_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (live_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }























var Live = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Live, _Lightning$Component);
  var _super = live_component_createSuper(Live);
  function Live() {
    (0,classCallCheck/* default */.Z)(this, Live);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Live, [{
    key: "_active",
    value: function _active() {
      this._canPlay = false;
      this._hasRelatedVideos = false;
      this._hasTracks = false;
      this._hasProgramInformation = false;
      this._isShowingControls = false;
      this._isVideoEnding = false;
      this._isOnLive = true;
      this._startTimeInSeconds = 0;
      this._startOverFeature = false;
      this._setState('Loading');
      this._unsubscribe = live_connector(this);
    }
  }, {
    key: "_onUrlParams",
    value: function _onUrlParams(_ref) {
      var videoId = _ref.videoId;
      lightningjs_redux.dispatch(player_constants_reset());
      lightningjs_redux.dispatch(fetchLayout(layout_constants/* entities */.jF.live, videoId));
    }
  }, {
    key: "_inactive",
    value: function _inactive() {
      if (this._unsubscribe) {
        this._unsubscribe();
        this._unsubscribe = null;
      }
    }
  }, {
    key: "isLoadingContent",
    set: function set(value) {
      if (value) {
        this._setState('Loading');
      }
    }
  }, {
    key: "canPlay",
    set: function set(value) {
      this._canPlay = value;
      if (this._canPlay) {
        this.tag('Player').play();
      }
    }
  }, {
    key: "playbackState",
    set: function set(value) {
      if (value === PLAYBACK_STATE_PLAYING) {
        this._setState('Playback.Playing');
      }
    }
  }, {
    key: "shouldHideVideoLoader",
    set: function set(value) {
      if (value) {
        this.tag('Loader').hide();
      }
    }
  }, {
    key: "hasRelatedVideos",
    set: function set(value) {
      this._hasRelatedVideos = value;
      this._updateTopBarItems();
    }
  }, {
    key: "audioTracks",
    set: function set(value) {
      this._hasTracks = this._hasTracks || value && value.length > 1;
      this._updateTopBarItems(value);
    }
  }, {
    key: "subtitleTracks",
    set: function set(value) {
      this._hasTracks = this._hasTracks || value && value.length > 0 && !areForcedSubtitlesOnly(value);
      this._updateTopBarItems(value);
    }
  }, {
    key: "programInformation",
    set: function set(value) {
      this._hasProgramInformation = Boolean(value && (value.description || value.title));
      this._updateTopBarItems();
    }
  }, {
    key: "startOverFeature",
    set: function set(value) {
      this._startOverFeature = value;
      this._updateTopBarItems();
    }
  }, {
    key: "startTimeInSeconds",
    set: function set(value) {
      this._startTimeInSeconds = value;
    }
  }, {
    key: "isOnLive",
    set: function set(value) {
      this._isOnLive = value;
      this._updateTopBarItems();
    }
  }, {
    key: "isAdBreakDisplayed",
    set: function set(value) {
      if (value) {
        this._setState('Ads');
      }
    }
  }, {
    key: "shouldSwitchToNextProgram",
    set: function set(value) {
      if (value) {
        lightningjs_redux.dispatch(switchToNextProgram());
      }
    }
  }, {
    key: "shouldLoadNewMetadataItems",
    set: function set(value) {
      if (value) {
        lightningjs_redux.dispatch(getNewMetadataItems());
      }
    }
  }, {
    key: "start",
    value: function start() {
      lightningjs_redux.dispatch(fetchPlayerLayout());
    }
  }, {
    key: "_handleBack",
    value: function _handleBack() {
      sendEvent({
        key: 'pressBackButtonDuringVideo'
      });
      return false;
    }
  }, {
    key: "_pause",
    value: function _pause() {
      if (!this._startOverFeature) {
        return;
      }
      this.tag('Player').pause();
      this.tag('Controls').show(PAUSED_STATE);
      sendEvent({
        key: 'pauseVideo'
      });
    }
  }, {
    key: "_play",
    value: function _play() {
      this.tag('Player').play();
      this.tag('Controls').show(PLAYING_STATE);
    }
  }, {
    key: "_updateTopBarItems",
    value: function _updateTopBarItems() {
      this.tag('Controls').topBarItems = live_utils_getTopBarItems({
        isOnLive: this._isOnLive,
        hasTracks: this._hasTracks,
        hasRelatedVideos: this._hasRelatedVideos,
        hasProgramInformation: this._hasProgramInformation,
        startOverFeature: this._startOverFeature
      });
    }
  }, {
    key: "_handleLoaderSequenceComplete",
    value: function _handleLoaderSequenceComplete() {
      this._isLoadingSequenceComplete = true;
      this.tag('Loader').hide();
      this._playVideoIfReady();
    }
  }, {
    key: "_handleSeek",
    value: function _handleSeek(position) {
      this.tag('Player').seek(this._startTimeInSeconds + position);
    }
  }, {
    key: "_handleTopBarItemSelection",
    value: function _handleTopBarItemSelection(item) {
      var id = get_default()(item, 'id', '');
      if (id === live_constants_TOP_BAR_ITEMS.BACK) {
        Router.back();
      } else if (id === live_constants_TOP_BAR_ITEMS.START_OVER) {
        this._handleStartOver();
      } else if (id === live_constants_TOP_BAR_ITEMS.BACK_TO_LIVE) {
        this._handleBackToLive();
      } else if (id === live_constants_TOP_BAR_ITEMS.TRACKS) {
        this.tag('Controls').showTracks();
      } else if (id === live_constants_TOP_BAR_ITEMS.RELATED_VIDEOS) {
        this.tag('Controls').showSideGlass();
      } else if (id === live_constants_TOP_BAR_ITEMS.INFO_PAGE) {
        this.tag('Controls').showProgramInformation();
      }
    }
  }, {
    key: "_handleStartOver",
    value: function _handleStartOver() {
      this._handleSeek(0);
      this._play();
      this.isOnLive = false;
    }
  }, {
    key: "_handleBackToLive",
    value: function _handleBackToLive() {
      lightningjs_redux.dispatch(switchToNextProgram());
      this.tag('Player').backToLive();
      this.isOnLive = true;
    }
  }, {
    key: "_handleItemAction",
    value: function _handleItemAction(item) {
      dispatchItemAction(item);
    }
  }, {
    key: "_handleAudioTrackSelection",
    value: function _handleAudioTrackSelection(track) {
      if (track) {
        lightningjs_redux.dispatch(selectAudioTrack(track));
      }
    }
  }, {
    key: "_handleSubtitlesTrackSelection",
    value: function _handleSubtitlesTrackSelection(track) {
      lightningjs_redux.dispatch(selectSubtitlesTrack(track));
    }
  }, {
    key: "_handleNextVideoClose",
    value: function _handleNextVideoClose() {
      Router.back();
    }
  }], [{
    key: "_template",
    value: function _template() {
      var _signals;
      return merge_default()({
        Player: {
          type: Player
        },
        Controls: {
          type: Controls,
          topBarItems: [],
          signals: (_signals = {}, (0,defineProperty/* default */.Z)(_signals, SEEK_SIGNAL, '_handleSeek'), (0,defineProperty/* default */.Z)(_signals, progressBar_constants_PAUSE_SIGNAL, '_handleProgressBarLongSeek'), (0,defineProperty/* default */.Z)(_signals, TOP_BAR_ITEM_SELECTED_SIGNAL, '_handleTopBarItemSelection'), (0,defineProperty/* default */.Z)(_signals, SIDE_GLASS_ITEM_SELECTED_SIGNAL, '_handleItemAction'), (0,defineProperty/* default */.Z)(_signals, AUDIO_TRACK_SELECTED_SIGNAL, '_handleAudioTrackSelection'), (0,defineProperty/* default */.Z)(_signals, SUBTITLES_TRACK_SELECTED_SIGNAL, '_handleSubtitlesTrackSelection'), (0,defineProperty/* default */.Z)(_signals, CONTROLS_SHOW_SIGNAL, '_onControlsShown'), (0,defineProperty/* default */.Z)(_signals, CONTROLS_HIDE_SIGNAL, '_onControlsHidden'), _signals)
        },
        ContentAdvisory: {
          type: contentAdvisory_component_ContentAdvisory
        },
        Loader: {
          type: VideoLoader,
          signals: (0,defineProperty/* default */.Z)({}, COMPLETE_SIGNAL, '_handleLoaderSequenceComplete')
        }
      }, live_style_getInitialStyle());
    }
  }, {
    key: "_states",
    value: function _states() {
      return [function (_this) {
        (0,inherits/* default */.Z)(Loading, _this);
        var _super2 = live_component_createSuper(Loading);
        function Loading() {
          (0,classCallCheck/* default */.Z)(this, Loading);
          return _super2.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(Loading, [{
          key: "$enter",
          value: function $enter() {
            this._isLoadingSequenceComplete = false;
            this.tag('Loader').show();
          }
        }]);
        return Loading;
      }(this), function (_this2) {
        (0,inherits/* default */.Z)(Playback, _this2);
        var _super3 = live_component_createSuper(Playback);
        function Playback() {
          (0,classCallCheck/* default */.Z)(this, Playback);
          return _super3.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(Playback, [{
          key: "isVideoEnding",
          set: function set(value) {
            this._isVideoEnding = value;
            this._displayContentAdvisoryIfRequired();
          }
        }, {
          key: "_getFocused",
          value: function _getFocused() {
            return this.tag('Controls');
          }
        }, {
          key: "_onControlsShown",
          value: function _onControlsShown() {
            this.tag('ContentAdvisory').pause();
            this._isShowingControls = true;
          }
        }, {
          key: "_onControlsHidden",
          value: function _onControlsHidden() {
            this.tag('ContentAdvisory').resume();
            this._isShowingControls = false;
          }
        }, {
          key: "_displayContentAdvisoryIfRequired",
          value: function _displayContentAdvisoryIfRequired() {
            if (this._isVideoEnding && !this._isShowingControls) {
              this.tag('ContentAdvisory').start();
            }
          }
        }], [{
          key: "_states",
          value: function _states() {
            return [function (_this3) {
              (0,inherits/* default */.Z)(Playing, _this3);
              var _super4 = live_component_createSuper(Playing);
              function Playing() {
                (0,classCallCheck/* default */.Z)(this, Playing);
                return _super4.apply(this, arguments);
              }
              (0,createClass/* default */.Z)(Playing, [{
                key: "$enter",
                value: function $enter(states) {
                  var previousState = get_default()(states, 'prevState', '');
                  this.tag('ContentAdvisory').start();
                  if (previousState === 'Loading') {
                    this.tag('Controls').showControls();
                  } else if (previousState === 'Playback.Paused') {
                    this.tag('ContentAdvisory').pause();
                  }
                  lightningjs_redux.dispatch(setScreenSaverIsLocked(true));
                }
              }, {
                key: "$exit",
                value: function $exit() {
                  this.tag('ContentAdvisory').pause();
                }
              }, {
                key: "_handleEnter",
                value: function _handleEnter() {
                  this._pause();
                  return true;
                }
              }, {
                key: "_handlePause",
                value: function _handlePause() {
                  this._pause();
                  return true;
                }
              }, {
                key: "_handlePlayPause",
                value: function _handlePlayPause() {
                  this._pause();
                  return true;
                }
              }, {
                key: "_handleProgressBarLongSeek",
                value: function _handleProgressBarLongSeek() {
                  this._pause();
                }
              }, {
                key: "_handleLoaderSequenceComplete",
                value: function _handleLoaderSequenceComplete() {
                  (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(Playing.prototype), "_handleLoaderSequenceComplete", this).call(this);
                  this.tag('Controls').showControls();
                }
              }, {
                key: "playbackState",
                set: function set(value) {
                  if (value === PLAYBACK_STATE_PAUSED) {
                    this._setState('Playback.Paused');
                  }
                }
              }]);
              return Playing;
            }(this), function (_this4) {
              (0,inherits/* default */.Z)(Paused, _this4);
              var _super5 = live_component_createSuper(Paused);
              function Paused() {
                (0,classCallCheck/* default */.Z)(this, Paused);
                return _super5.apply(this, arguments);
              }
              (0,createClass/* default */.Z)(Paused, [{
                key: "_handleEnter",
                value: function _handleEnter() {
                  this._play();
                  return true;
                }
              }, {
                key: "_handlePlay",
                value: function _handlePlay() {
                  this._play();
                  return true;
                }
              }, {
                key: "_handlePlayPause",
                value: function _handlePlayPause() {
                  this._play();
                  return true;
                }
              }]);
              return Paused;
            }(this)];
          }
        }]);
        return Playback;
      }(this), function (_this5) {
        (0,inherits/* default */.Z)(Ads, _this5);
        var _super6 = live_component_createSuper(Ads);
        function Ads() {
          (0,classCallCheck/* default */.Z)(this, Ads);
          return _super6.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(Ads, [{
          key: "$enter",
          value: function $enter() {
            this.tag('Loader').hide();
          }
        }, {
          key: "_getFocused",
          value: function _getFocused() {
            return this.tag('Player');
          }
        }]);
        return Ads;
      }(this)];
    }
  }]);
  return Live;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./packages/pelo-plugins/screen/src/platform/constants.js
var HEIGHTS = {
  HD: 720,
  fullHD: 1080,
  UHD: 2160
};
;// CONCATENATED MODULE: ./packages/pelo-plugins/screen/src/platform/default/screen.js




var isHD = function () {
  var _ref = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee() {
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", window.innerHeight < HEIGHTS.fullHD);
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function isHD() {
    return _ref.apply(this, arguments);
  };
}();
var isFullHD = function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2() {
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.abrupt("return", window.innerHeight >= HEIGHTS.fullHD);
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function isFullHD() {
    return _ref2.apply(this, arguments);
  };
}();
var isGreaterOrEqual = function () {
  var _ref3 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee3(resolution) {
    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.abrupt("return", window.innerHeight >= resolution);
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function isGreaterOrEqual(_x) {
    return _ref3.apply(this, arguments);
  };
}();
var isUHD = function () {
  var _ref4 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee4() {
    return regenerator_default().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          return _context4.abrupt("return", false);
        case 1:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function isUHD() {
    return _ref4.apply(this, arguments);
  };
}();
var isHDR = function () {
  var _ref5 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee5() {
    return regenerator_default().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          return _context5.abrupt("return", false);
        case 1:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function isHDR() {
    return _ref5.apply(this, arguments);
  };
}();
var isDolbyVision = function () {
  var _ref6 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee6() {
    return regenerator_default().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          return _context6.abrupt("return", false);
        case 1:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return function isDolbyVision() {
    return _ref6.apply(this, arguments);
  };
}();
;// CONCATENATED MODULE: ./packages/pelo-plugins/screen/index.js


var screenInfo = {
  isHD: isHD,
  isFullHD: isFullHD,
  isGreaterOrEqual: isGreaterOrEqual,
  isUHD: isUHD,
  isHDR: isHDR,
  isDolbyVision: isDolbyVision
};
;// CONCATENATED MODULE: ./src/thirdParty/newrelic/newrelic.engine.js



/* harmony default export */ const newrelic_engine = (new (function () {
  function NewrelicEngine() {
    (0,classCallCheck/* default */.Z)(this, NewrelicEngine);
  }
  (0,createClass/* default */.Z)(NewrelicEngine, [{
    key: "sendError",
    value: function sendError(error) {
      var customAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      invoke_default()(window, 'newrelic.noticeError', error, customAttributes);
    }
  }]);
  return NewrelicEngine;
}())());
;// CONCATENATED MODULE: ./src/thirdParty/newrelic/newrelic.errorHandler.js


var newrelic_errorHandler_ERROR = 'error';
var UNHANDLED_REJECTION = 'unhandledrejection';
var errorEventHandler = function errorEventHandler(error) {
  newrelic_engine.sendError(error.error);
};
var unhandledRejectionEventHandler = function unhandledRejectionEventHandler(error) {
  newrelic_engine.sendError(error.reason);
};
var thirdPartyErrorEventHandler = function thirdPartyErrorEventHandler(error) {
  thirdPartyWithLayoutService.sendErrorEvent(error.error);
};
var thirdPartyUnhandledRejectionEventHandler = function thirdPartyUnhandledRejectionEventHandler(error) {
  thirdPartyWithLayoutService.sendErrorEvent(error.reason);
};
var handleBootErrors = function handleBootErrors() {
  window.addEventListener(newrelic_errorHandler_ERROR, errorEventHandler);
  window.addEventListener(UNHANDLED_REJECTION, unhandledRejectionEventHandler);
};
var unsubscribeBootErrorHandlers = function unsubscribeBootErrorHandlers() {
  window.removeEventListener(newrelic_errorHandler_ERROR, errorEventHandler);
  window.removeEventListener(UNHANDLED_REJECTION, unhandledRejectionEventHandler);
};
var switchToThirdPartyHandlers = function switchToThirdPartyHandlers() {
  window.addEventListener(newrelic_errorHandler_ERROR, thirdPartyErrorEventHandler);
  window.addEventListener(UNHANDLED_REJECTION, thirdPartyUnhandledRejectionEventHandler);
  unsubscribeBootErrorHandlers();
};
var unsubscribeThirdPartyErrorHandlers = function unsubscribeThirdPartyErrorHandlers() {
  window.removeEventListener(newrelic_errorHandler_ERROR, thirdPartyErrorEventHandler);
  window.removeEventListener(UNHANDLED_REJECTION, thirdPartyUnhandledRejectionEventHandler);
};
;// CONCATENATED MODULE: ./src/logic/gdprNotice/gdprNotice.actions.js





var TOGGLE_GDPR_NOTICE = 'gdpr/TOGGLE_GDPR_NOTICE';
var PRESS_GDPR_NOTICE_OK_BUTTON = 'gdpr/PRESS_GDPR_NOTICE_OK_BUTTON';
var PRESS_GDPR_NOTICE_DECLINE_BUTTON = 'gdpr/PRESS_GDPR_NOTICE_DECLINE_BUTTON';
var PRESS_GDPR_NOTICE_PARAMETERS_BUTTON = 'gdpr/PRESS_GDPR_NOTICE_PARAMETERS_BUTTON';
var toggleGdprNotice = function toggleGdprNotice() {
  return {
    type: TOGGLE_GDPR_NOTICE
  };
};
var getConsentNames = function getConsentNames(consents) {
  return Object.keys(consents).filter(function (key) {
    return consents[key].consent;
  });
};
var handleGdprButtonPress = function handleGdprButtonPress(consents) {
  return function (dispatch) {
    dispatch(setUserConsents(consents));
    dispatch(toggleGdprNotice());
  };
};
var pressGdprNoticeDeclineAllButton = function pressGdprNoticeDeclineAllButton() {
  return function (dispatch) {
    var consents = setAllCookies(false);
    dispatch(handleGdprButtonPress(consents));
    sendEvent({
      key: 'gdprRefuse',
      consentNames: getConsentNames(consents)
    });
  };
};
var pressGdprNoticeConsentAllButton = function pressGdprNoticeConsentAllButton() {
  return function (dispatch) {
    var consents = setAllCookies(true);
    sendEvent({
      key: 'pressCookieBannerConsentButton'
    });
    dispatch(handleGdprButtonPress(consents));
    sendEvent({
      key: 'gdprAccept',
      consentNames: getConsentNames(consents)
    });
  };
};
;// CONCATENATED MODULE: ./src/logic/app/app.actions.js











function app_actions_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function app_actions_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? app_actions_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : app_actions_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

























var INITIALIZE_APP = 'app/INITIALIZE_APP';
var INITIALIZE_APP_COMPLETED = 'app/INITIALIZE_APP_COMPLETED';
var INITIALIZE_APP_FAILURE = 'app/INITIALIZE_APP_FAILURE';
var SET_SERVER_TIME = 'app/SET_SERVER_TIME';
var SET_CONNECTED = 'app/SET_CONNECTED';
var SET_SCREEN_SIZE = 'app/SET_SCREEN_SIZE';
var SET_DEVICE_INFO = 'app/SET_DEVICE_INFO';
var setScreenSize = function setScreenSize(screenSize) {
  return {
    type: SET_SCREEN_SIZE,
    size: screenSize
  };
};
var getCurrentScreenSize = function () {
  var _ref = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee() {
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return screenInfo.isGreaterOrEqual(sizes_SCREEN_HEIGHT.HD + 1);
        case 2:
          if (!_context.sent) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return", FULL_HD);
        case 4:
          return _context.abrupt("return", HD);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getCurrentScreenSize() {
    return _ref.apply(this, arguments);
  };
}();
var fetchScreenSize = function fetchScreenSize() {
  return function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2(dispatch, getState) {
      var previousScreenSize, newScreenSize;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            previousScreenSize = app_selectors_getScreenSize(getState());
            _context2.next = 4;
            return getCurrentScreenSize();
          case 4:
            newScreenSize = _context2.sent;
            if (newScreenSize !== previousScreenSize) {
              dispatch(setScreenSize(newScreenSize));
            }
            _context2.next = 12;
            break;
          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](0);
            console.warn("Could not get device screen info: ".concat(_context2.t0.message, " Are you on browser with a specific platform?"));
            dispatch(setScreenSize(HD));
          case 12:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 8]]);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var fetchDeviceInfo = function fetchDeviceInfo() {
  return function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee3(dispatch) {
      var _yield$Promise$all, _yield$Promise$all2, deviceBrand, deviceModel, deviceVersion;
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return Promise.all([deviceInfo.getBrand().catch(function () {
              return '';
            }), deviceInfo.getModel().catch(function () {
              return '';
            }), deviceInfo.getVersion().catch(function () {
              return '';
            })]);
          case 2:
            _yield$Promise$all = _context3.sent;
            _yield$Promise$all2 = (0,slicedToArray/* default */.Z)(_yield$Promise$all, 3);
            deviceBrand = _yield$Promise$all2[0];
            deviceModel = _yield$Promise$all2[1];
            deviceVersion = _yield$Promise$all2[2];
            dispatch({
              type: SET_DEVICE_INFO,
              deviceBrand: deviceBrand,
              deviceModel: deviceModel,
              deviceVersion: deviceVersion
            });
          case 8:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var setServerTime = function setServerTime(serverTime) {
  return {
    type: SET_SERVER_TIME,
    serverTime: serverTime
  };
};
var getAssetsBundle = function getAssetsBundle(config) {
  return function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee4(dispatch) {
      var bundleBaseUrl, bundleVersion, baseUrl, url, manifest;
      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            bundleBaseUrl = get_default()(config, 'assetsBundle.bundleBaseUrl');
            bundleVersion = get_default()(config, 'assetsBundle.bundleVersion');
            if (!(!bundleBaseUrl || !bundleVersion)) {
              _context4.next = 4;
              break;
            }
            return _context4.abrupt("return");
          case 4:
            baseUrl = "".concat(bundleBaseUrl, "/").concat(bundleVersion, "/svg-file");
            url = "".concat(baseUrl, "/manifest.json");
            _context4.prev = 6;
            _context4.next = 9;
            return client_default().get(url).then(function (response) {
              return JSON.parse(response.text);
            });
          case 9:
            manifest = _context4.sent;
            config.assetsBundle.manifest = app_actions_objectSpread({
              baseUrl: baseUrl
            }, manifest);
            _context4.next = 16;
            break;
          case 13:
            _context4.prev = 13;
            _context4.t0 = _context4["catch"](6);
            dispatch(error_actions_errorAction(error_constants_ERROR_LEVELS.SILENT, error_constants_ERROR_TYPES.GENERAL, "Failed to retrieve assets bundle manifest: ".concat(_context4.t0.message)));
          case 16:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[6, 13]]);
    }));
    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var authenticateUser = function authenticateUser() {
  return function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee5(dispatch, getState) {
      var state, user;
      return regenerator_default().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            state = getState();
            if (getPairingFeature(state)) {
              _context5.next = 3;
              break;
            }
            return _context5.abrupt("return");
          case 3:
            if (user_selectors_getPairingStatus(state)) {
              _context5.next = 14;
              break;
            }
            _context5.prev = 4;
            _context5.next = 7;
            return dispatch(getCurrentPairedUser());
          case 7:
            user = _context5.sent;
            _context5.next = 13;
            break;
          case 10:
            _context5.prev = 10;
            _context5.t0 = _context5["catch"](4);
            dispatch(error_actions_errorAction(error_constants_ERROR_LEVELS.SILENT, error_constants_ERROR_TYPES.GENERAL, "Authentication failed: ".concat(_context5.t0.message)));
          case 13:
            if (!user) {
              dispatch(fetchNavigation());
            }
          case 14:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[4, 10]]);
    }));
    return function (_x5, _x6) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var setFallbackServerTime = function setFallbackServerTime() {
  return function (dispatch) {
    return dispatch(setServerTime(Math.floor(Date.now() / 1000)));
  };
};
var fetchServerTime = function fetchServerTime() {
  return function () {
    var _ref6 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee6(dispatch) {
      var serverTime;
      return regenerator_default().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return get6PlayTime();
          case 3:
            serverTime = _context6.sent;
            return _context6.abrupt("return", dispatch(setServerTime(serverTime)));
          case 7:
            _context6.prev = 7;
            _context6.t0 = _context6["catch"](0);
            dispatch(error_actions_errorAction(error_constants_ERROR_LEVELS.SILENT, error_constants_ERROR_TYPES.GENERAL, _context6.t0.message));
            return _context6.abrupt("return", dispatch(setFallbackServerTime()));
          case 11:
          case "end":
            return _context6.stop();
        }
      }, _callee6, null, [[0, 7]]);
    }));
    return function (_x7) {
      return _ref6.apply(this, arguments);
    };
  }();
};
var initProfiles = function initProfiles() {
  return function () {
    var _ref7 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee7(dispatch, getState) {
      var userShouldSelectProfile;
      return regenerator_default().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            userShouldSelectProfile = getMultiProfilesGateAlwaysDisplayed(getState());
            if (userShouldSelectProfile) {
              dispatch(clearUserProfile());
            }
          case 2:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function (_x8, _x9) {
      return _ref7.apply(this, arguments);
    };
  }();
};
var restoreUserProfile = function restoreUserProfile() {
  return function (dispatch, getState) {
    var state = getState();
    var deviceId = user_selectors_getDeviceId(state);
    var userId = user_selectors_getUid(state);
    dispatch(migrateDeviceId(deviceId));
    if (userId) {
      dispatch({
        type: USER_RESTORE_PROFILE_UID
      });
    }
  };
};
var setUserPrivacy = function setUserPrivacy() {
  return function (dispatch, getState) {
    var state = getState();
    var areEmptyCookies = areCookiesEmpty(getCookies(state));
    if (!getGdprNoticeFeature(state)) {
      dispatch(setUserConsents(setAllCookies(false)));
    } else if (areEmptyCookies) {
      dispatch(toggleGdprNotice());
    } else {
      return dispatch(bootstrapEngines());
    }
    return Promise.resolve();
  };
};
var initializeApp = function initializeApp(config) {
  return function () {
    var _ref8 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee8(dispatch, getState) {
      var shouldClearLocalStore, query;
      return regenerator_default().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            if (config) {
              _context8.next = 2;
              break;
            }
            throw new Error(ERROR_ON_MISSING_CONFIG);
          case 2:
            preserveGlobals();
            try {
              query = new URL(document.location).searchParams;
              shouldClearLocalStore = query.get('cleanup') === 'true';
            } catch (error) {
              shouldClearLocalStore = false;
            }
            if (shouldClearLocalStore) {
              platformStorage.clear();
            }
            dispatch(setFallbackServerTime());
            dispatch({
              type: INITIALIZE_APP,
              initialElapsedTime: getElapsedTime()
            });
            dispatch(restoreDeviceData());
            _context8.prev = 8;
            initFidoSDK(getState);
            _context8.next = 12;
            return dispatch(fetchAppLaunchConfig(config));
          case 12:
            _context8.next = 14;
            return Promise.all([dispatch(getAssetsBundle(config)), dispatch(fetchServerTime()), dispatch(fetchScreenSize()), dispatch(fetchDeviceInfo())]);
          case 14:
            dispatch(initAnalyticsEngines());
            switchToThirdPartyHandlers();
            _context8.next = 18;
            return dispatch(initProfiles());
          case 18:
            _context8.next = 20;
            return dispatch(authenticateUser());
          case 20:
            dispatch(restoreUserProfile());
            statsdMonitoringService_statsdMonitoringService.sendAppStart(env.appVersion);
            dispatch({
              type: INITIALIZE_APP_COMPLETED
            });
            dispatch(setUserPrivacy());
            _context8.next = 31;
            break;
          case 26:
            _context8.prev = 26;
            _context8.t0 = _context8["catch"](8);
            console.error('Can not launch app:', _context8.t0);
            dispatch(error_actions_errorAction(error_constants_ERROR_LEVELS.FATAL, error_constants_ERROR_TYPES.GENERAL, _context8.t0.message));
            removeSplashScreen();
          case 31:
          case "end":
            return _context8.stop();
        }
      }, _callee8, null, [[8, 26]]);
    }));
    return function (_x0, _x1) {
      return _ref8.apply(this, arguments);
    };
  }();
};
var setConnected = function setConnected(isConnected) {
  return {
    type: SET_CONNECTED,
    connected: isConnected
  };
};
;// CONCATENATED MODULE: ./src/modules/routes/hooks/boot.hook.js








var boot = function boot() {
  lightningjs_redux.dispatch(setDeeplinkLocation(window.location.hash.replace(/^#/, '')));
  lightningjs_redux.dispatch(setContentTemplateOptions(getContentTemplateOptions()));
  return lightningjs_redux.dispatch(initializeApp((src_default())));
};
;// CONCATENATED MODULE: ./src/modules/routes/platform/default.js

var default_routerConfig = {
  boot: boot
};
;// CONCATENATED MODULE: ./src/modules/pairing/tos/tos.style.js

var tos_style_TEXT_MARGIN, tos_style_BUTTONS_MARGIN, tos_style_SPINNER_SIZE;
function tos_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function tos_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? tos_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : tos_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





var tos_style_defaultContext = makeDefaultStylingContext();
var tos_style_colors = {
  text: makeThemeColor(PRIMARY)
};
var tos_tos_style_TEXT_MARGIN = (tos_style_TEXT_MARGIN = {}, (0,defineProperty/* default */.Z)(tos_style_TEXT_MARGIN, HD, 24), (0,defineProperty/* default */.Z)(tos_style_TEXT_MARGIN, FULL_HD, 32), tos_style_TEXT_MARGIN);
var tos_tos_style_BUTTONS_MARGIN = (tos_style_BUTTONS_MARGIN = {}, (0,defineProperty/* default */.Z)(tos_style_BUTTONS_MARGIN, HD, 24), (0,defineProperty/* default */.Z)(tos_style_BUTTONS_MARGIN, FULL_HD, 32), tos_style_BUTTONS_MARGIN);
var tos_tos_style_SPINNER_SIZE = (tos_style_SPINNER_SIZE = {}, (0,defineProperty/* default */.Z)(tos_style_SPINNER_SIZE, HD, 32), (0,defineProperty/* default */.Z)(tos_style_SPINNER_SIZE, FULL_HD, 32), tos_style_SPINNER_SIZE);
var tos_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : tos_style_defaultContext,
    _ref$screenSize = _ref.screenSize,
    screenSize = _ref$screenSize === void 0 ? FULL_HD : _ref$screenSize,
    _ref$colorMode = _ref.colorMode,
    colorMode = _ref$colorMode === void 0 ? DEFAULT_MODE : _ref$colorMode;
  var w = SCREEN_WIDTH[screenSize] * 0.7;
  return {
    w: SCREEN_WIDTH[screenSize],
    h: sizes_SCREEN_HEIGHT[screenSize],
    flex: {
      direction: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    },
    Title: {
      text: tos_style_objectSpread(tos_style_objectSpread({}, src_getFont(constants_FONT.PARIS_2, screenSize)), {}, {
        textAlign: 'center',
        wordWrapWidth: w,
        textColor: tos_style_colors.text[colorMode]
      }),
      flexItem: {
        marginBottom: tos_tos_style_TEXT_MARGIN[screenSize]
      }
    },
    Description: {
      text: tos_style_objectSpread(tos_style_objectSpread({}, src_getFont(constants_FONT.OTTAWA_1, screenSize)), {}, {
        textAlign: 'center',
        wordWrapWidth: w,
        textColor: tos_style_colors.text[colorMode]
      })
    },
    Buttons: {
      w: w,
      flexItem: {
        marginTop: tos_tos_style_BUTTONS_MARGIN[screenSize]
      },
      flex: {
        alignItems: 'center',
        justifyContent: 'center',
        direction: 'row'
      },
      Accept: {
        flexItem: {
          marginRight: tos_tos_style_BUTTONS_MARGIN[screenSize]
        }
      },
      Decline: {}
    },
    Spinner: {
      visible: false,
      w: tos_tos_style_SPINNER_SIZE[screenSize],
      h: tos_tos_style_SPINNER_SIZE[screenSize],
      flexItem: {
        marginTop: tos_tos_style_BUTTONS_MARGIN[screenSize]
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/pairing/tos/tos.connector.js


var tos_connector_mapControllers = function mapControllers(instance) {
  return [{
    selector: getDeepLink,
    callback: function callback(value) {
      instance.deeplink = value;
    },
    shouldBeInvokedOnConnect: true
  }];
};
/* harmony default export */ const tos_connector = (lightningjs_redux.control(tos_connector_mapControllers));
;// CONCATENATED MODULE: ./src/modules/pairing/tos/tos.component.js








function tos_component_createSuper(t) { var r = tos_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function tos_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (tos_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
















var TermsOfService = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(TermsOfService, _Lightning$Component);
  var _super = tos_component_createSuper(TermsOfService);
  function TermsOfService() {
    (0,classCallCheck/* default */.Z)(this, TermsOfService);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(TermsOfService, [{
    key: "_construct",
    value: function _construct() {
      this._index = 0;
      this._style = tos_style_defaultContext;
    }
  }, {
    key: "_active",
    value: function _active() {
      removeSplashScreen();
      this._unsubscribe = tos_connector(this);
    }
  }, {
    key: "_inactive",
    value: function _inactive() {
      if (this._unsubscribe) {
        this._unsubscribe();
        this._unsubscribe = null;
      }
    }
  }, {
    key: "deeplink",
    set: function set(value) {
      this._deeplink = value;
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this._index = 0;
    }
  }, {
    key: "_handleLeft",
    value: function _handleLeft() {
      this._index = 0;
      return true;
    }
  }, {
    key: "_handleRight",
    value: function _handleRight() {
      this._index = 1;
      return true;
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this.tag('Buttons').children[this._index];
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      if (!this.tag('Buttons').visible) {
        return false;
      }
      if (this._index) {
        this._handleDecline();
      } else {
        this._handleAccept();
      }
      return true;
    }
  }, {
    key: "_handleAccept",
    value: function () {
      var _handleAccept2 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee() {
        var isPaired;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.patch({
                Buttons: {
                  visible: false
                },
                Spinner: {
                  visible: true
                }
              });
              _context.next = 3;
              return singleSignIn(true);
            case 3:
              isPaired = _context.sent;
              if (!isPaired) {
                _context.next = 12;
                break;
              }
              _context.next = 7;
              return lightningjs_redux.dispatch(getCurrentPairedUser());
            case 7:
              lightningjs_redux.dispatch(clearCache());
              lightningjs_redux.dispatch(fetchNavigation());
              navigateTo(this._deeplink || HOME_PATH, false);
              _context.next = 13;
              break;
            case 12:
              lightningjs_redux.dispatch(showPopupAction(FATAL_ERROR_POPUP_ID, {}));
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function _handleAccept() {
        return _handleAccept2.apply(this, arguments);
      }
      return _handleAccept;
    }()
  }, {
    key: "_handleDecline",
    value: function _handleDecline() {
      rememberSSIDeclined();
      navigateTo(HOME_PATH);
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Title: {
          text: {
            text: t('pairing.ssi.title')
          }
        },
        Description: {
          text: {
            text: t('pairing.ssi.description')
          }
        },
        Buttons: {
          Accept: {
            type: Button,
            label: t('pairing.ssi.accept')
          },
          Decline: {
            type: Button,
            label: t('pairing.ssi.decline')
          }
        },
        Spinner: {
          type: spinner_component
        }
      }, tos_style_getInitialStyle());
    }
  }]);
  return TermsOfService;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/audio/autoscroll/autoscroll.shader.js






function autoscroll_shader_createSuper(t) { var r = autoscroll_shader_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function autoscroll_shader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (autoscroll_shader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var AutoscrollShader = function (_Lightning$shaders$We) {
  (0,inherits/* default */.Z)(AutoscrollShader, _Lightning$shaders$We);
  var _super = autoscroll_shader_createSuper(AutoscrollShader);
  function AutoscrollShader(context) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, AutoscrollShader);
    _this = _super.call(this, context);
    _this._top = 1.0;
    _this._bottom = 1.0;
    return _this;
  }
  (0,createClass/* default */.Z)(AutoscrollShader, [{
    key: "setupUniforms",
    value: function setupUniforms(operation) {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(AutoscrollShader.prototype), "setupUniforms", this).call(this, operation);
      this._setUniform('top', this._top, this.gl.uniform1f);
      this._setUniform('bottom', this._bottom, this.gl.uniform1f);
    }
  }, {
    key: "top",
    get: function get() {
      return this._top;
    },
    set: function set(value) {
      this._top = value;
      this.redraw();
    }
  }, {
    key: "bottom",
    get: function get() {
      return this._bottom;
    },
    set: function set(value) {
      this._bottom = value;
      this.redraw();
    }
  }]);
  return AutoscrollShader;
}(src_Lightning.shaders.WebGLDefaultShader);

AutoscrollShader.vertexShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    attribute vec2 aVertexPosition;\n    attribute vec2 aTextureCoord;\n    attribute vec4 aColor;\n\n    uniform vec2 projection;\n\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n\n    void main(void){\n        gl_Position = vec4(aVertexPosition.x * projection.x - 1.0, aVertexPosition.y * -abs(projection.y) + 1.0, 0.0, 1.0);\n        vTextureCoord = aTextureCoord;\n        vColor = aColor;\n        gl_Position.y = -sign(projection.y) * gl_Position.y;\n    }\n";
AutoscrollShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n\n    uniform sampler2D uSampler;\n    uniform float top;\n    uniform float bottom;\n\n    void main(void){\n        vec4 color = texture2D(uSampler, vTextureCoord) * vColor;\n\n        float size = 0.1;\n        float multiplier = 1.0 / size;\n\n        float topMask = 1.0 - max((size * top - vTextureCoord.x) * multiplier, 0.0);\n        float bottomMask = 1.0 - max((vTextureCoord.x - 1.0 + size * bottom) * multiplier, 0.0);\n\n        gl_FragColor = color * topMask * bottomMask;\n    }\n";
;// CONCATENATED MODULE: ./src/modules/audio/autoscroll/autoscroll.component.js






function autoscroll_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function autoscroll_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? autoscroll_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : autoscroll_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function autoscroll_component_createSuper(t) { var r = autoscroll_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function autoscroll_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (autoscroll_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }


var Autoscroll = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Autoscroll, _Lightning$Component);
  var _super = autoscroll_component_createSuper(Autoscroll);
  function Autoscroll() {
    (0,classCallCheck/* default */.Z)(this, Autoscroll);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Autoscroll, [{
    key: "_attach",
    value: function _attach() {
      var _this = this;
      this._direction = -1;
      this.tag('Text').on('txLoaded', function () {
        _this._updateInitialPosition();
      });
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this.tag('Text').removeAllListeners('txLoaded');
      this._cleanupTransition();
      this._animation = null;
    }
  }, {
    key: "font",
    set: function set(value) {
      this.patch({
        Text: {
          text: autoscroll_component_objectSpread({}, value)
        },
        h: value && value.lineHeight || 0
      });
    }
  }, {
    key: "caption",
    set: function set(value) {
      this.tag('Text').text.text = value;
    }
  }, {
    key: "_cleanupTransition",
    value: function _cleanupTransition() {
      var transition = this.tag('Text').transition('x');
      if (transition) {
        transition.stop();
        transition.removeAllListeners('progress');
        transition.removeAllListeners('finish');
      }
    }
  }, {
    key: "_scroll",
    value: function _scroll() {
      var text = this.tag('Text');
      var duration = (text.finalW - this.finalW) / 16;
      text.setSmooth('x', this._direction === -1 ? this.finalW - text.finalW : 0, {
        timingFunction: 'linear',
        delay: 1,
        duration: duration
      });
    }
  }, {
    key: "_updateInitialPosition",
    value: function _updateInitialPosition() {
      var _this2 = this;
      var text = this.tag('Text');
      if (text.finalW <= this.finalW) {
        text.x = Math.round((this.finalW - text.finalW) / 2);
        return;
      }
      text.x = 0;
      this._cleanupTransition();
      text.transition('x').on('progress', function (v) {
        var offset = 0.22;
        if (_this2._direction === -1) {
          _this2.shader.bottom = 1 - Math.max(v - 1 + offset, 0) / offset;
          _this2.shader.top = Math.min(1 - offset + v, 1);
        } else {
          _this2.shader.top = 1 - Math.max(v - 1 + offset, 0) / offset;
          _this2.shader.bottom = Math.min(1 - offset + v, 1);
        }
      });
      text.transition('x').on('finish', function () {
        _this2._direction = _this2._direction === -1 ? 1 : -1;
        _this2._scroll();
      });
      this._scroll();
    }
  }], [{
    key: "_template",
    value: function _template() {
      return {
        rtt: true,
        shader: {
          type: AutoscrollShader,
          top: 1
        },
        Text: {
          text: {
            wordWrap: false,
            textOverflow: false
          }
        }
      };
    }
  }]);
  return Autoscroll;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./node_modules/.pnpm/hls.js@1.6.5/node_modules/hls.js/dist/hls.mjs
// https://caniuse.com/mdn-javascript_builtins_number_isfinite
const isFiniteNumber = Number.isFinite || function (value) {
  return typeof value === 'number' && isFinite(value);
};

// https://caniuse.com/mdn-javascript_builtins_number_issafeinteger
const isSafeInteger = Number.isSafeInteger || function (value) {
  return typeof value === 'number' && Math.abs(value) <= MAX_SAFE_INTEGER;
};
const MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

let ErrorTypes = /*#__PURE__*/function (ErrorTypes) {
  // Identifier for a network error (loading error / timeout ...)
  ErrorTypes["NETWORK_ERROR"] = "networkError";
  // Identifier for a media Error (video/parsing/mediasource error)
  ErrorTypes["MEDIA_ERROR"] = "mediaError";
  // EME (encrypted media extensions) errors
  ErrorTypes["KEY_SYSTEM_ERROR"] = "keySystemError";
  // Identifier for a mux Error (demuxing/remuxing)
  ErrorTypes["MUX_ERROR"] = "muxError";
  // Identifier for all other errors
  ErrorTypes["OTHER_ERROR"] = "otherError";
  return ErrorTypes;
}({});
let ErrorDetails = /*#__PURE__*/function (ErrorDetails) {
  ErrorDetails["KEY_SYSTEM_NO_KEYS"] = "keySystemNoKeys";
  ErrorDetails["KEY_SYSTEM_NO_ACCESS"] = "keySystemNoAccess";
  ErrorDetails["KEY_SYSTEM_NO_SESSION"] = "keySystemNoSession";
  ErrorDetails["KEY_SYSTEM_NO_CONFIGURED_LICENSE"] = "keySystemNoConfiguredLicense";
  ErrorDetails["KEY_SYSTEM_LICENSE_REQUEST_FAILED"] = "keySystemLicenseRequestFailed";
  ErrorDetails["KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED"] = "keySystemServerCertificateRequestFailed";
  ErrorDetails["KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED"] = "keySystemServerCertificateUpdateFailed";
  ErrorDetails["KEY_SYSTEM_SESSION_UPDATE_FAILED"] = "keySystemSessionUpdateFailed";
  ErrorDetails["KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED"] = "keySystemStatusOutputRestricted";
  ErrorDetails["KEY_SYSTEM_STATUS_INTERNAL_ERROR"] = "keySystemStatusInternalError";
  ErrorDetails["KEY_SYSTEM_DESTROY_MEDIA_KEYS_ERROR"] = "keySystemDestroyMediaKeysError";
  ErrorDetails["KEY_SYSTEM_DESTROY_CLOSE_SESSION_ERROR"] = "keySystemDestroyCloseSessionError";
  ErrorDetails["KEY_SYSTEM_DESTROY_REMOVE_SESSION_ERROR"] = "keySystemDestroyRemoveSessionError";
  // Identifier for a manifest load error - data: { url : faulty URL, response : { code: error code, text: error text }}
  ErrorDetails["MANIFEST_LOAD_ERROR"] = "manifestLoadError";
  // Identifier for a manifest load timeout - data: { url : faulty URL, response : { code: error code, text: error text }}
  ErrorDetails["MANIFEST_LOAD_TIMEOUT"] = "manifestLoadTimeOut";
  // Identifier for a manifest parsing error - data: { url : faulty URL, reason : error reason}
  ErrorDetails["MANIFEST_PARSING_ERROR"] = "manifestParsingError";
  // Identifier for a manifest with only incompatible codecs error - data: { url : faulty URL, reason : error reason}
  ErrorDetails["MANIFEST_INCOMPATIBLE_CODECS_ERROR"] = "manifestIncompatibleCodecsError";
  // Identifier for a level which contains no fragments - data: { url: faulty URL, reason: "no fragments found in level", level: index of the bad level }
  ErrorDetails["LEVEL_EMPTY_ERROR"] = "levelEmptyError";
  // Identifier for a level load error - data: { url : faulty URL, response : { code: error code, text: error text }}
  ErrorDetails["LEVEL_LOAD_ERROR"] = "levelLoadError";
  // Identifier for a level load timeout - data: { url : faulty URL, response : { code: error code, text: error text }}
  ErrorDetails["LEVEL_LOAD_TIMEOUT"] = "levelLoadTimeOut";
  // Identifier for a level parse error - data: { url : faulty URL, error: Error, reason: error message }
  ErrorDetails["LEVEL_PARSING_ERROR"] = "levelParsingError";
  // Identifier for a level switch error - data: { level : faulty level Id, event : error description}
  ErrorDetails["LEVEL_SWITCH_ERROR"] = "levelSwitchError";
  // Identifier for an audio track load error - data: { url : faulty URL, response : { code: error code, text: error text }}
  ErrorDetails["AUDIO_TRACK_LOAD_ERROR"] = "audioTrackLoadError";
  // Identifier for an audio track load timeout - data: { url : faulty URL, response : { code: error code, text: error text }}
  ErrorDetails["AUDIO_TRACK_LOAD_TIMEOUT"] = "audioTrackLoadTimeOut";
  // Identifier for a subtitle track load error - data: { url : faulty URL, response : { code: error code, text: error text }}
  ErrorDetails["SUBTITLE_LOAD_ERROR"] = "subtitleTrackLoadError";
  // Identifier for a subtitle track load timeout - data: { url : faulty URL, response : { code: error code, text: error text }}
  ErrorDetails["SUBTITLE_TRACK_LOAD_TIMEOUT"] = "subtitleTrackLoadTimeOut";
  // Identifier for fragment load error - data: { frag : fragment object, response : { code: error code, text: error text }}
  ErrorDetails["FRAG_LOAD_ERROR"] = "fragLoadError";
  // Identifier for fragment load timeout error - data: { frag : fragment object}
  ErrorDetails["FRAG_LOAD_TIMEOUT"] = "fragLoadTimeOut";
  // Identifier for a fragment decryption error event - data: {id : demuxer Id,frag: fragment object, reason : parsing error description }
  ErrorDetails["FRAG_DECRYPT_ERROR"] = "fragDecryptError";
  // Identifier for a fragment parsing error event - data: { id : demuxer Id, reason : parsing error description }
  // will be renamed DEMUX_PARSING_ERROR and switched to MUX_ERROR in the next major release
  ErrorDetails["FRAG_PARSING_ERROR"] = "fragParsingError";
  // Identifier for a fragment or part load skipped because of a GAP tag or attribute
  ErrorDetails["FRAG_GAP"] = "fragGap";
  // Identifier for a remux alloc error event - data: { id : demuxer Id, frag : fragment object, bytes : nb of bytes on which allocation failed , reason : error text }
  ErrorDetails["REMUX_ALLOC_ERROR"] = "remuxAllocError";
  // Identifier for decrypt key load error - data: { frag : fragment object, response : { code: error code, text: error text }}
  ErrorDetails["KEY_LOAD_ERROR"] = "keyLoadError";
  // Identifier for decrypt key load timeout error - data: { frag : fragment object}
  ErrorDetails["KEY_LOAD_TIMEOUT"] = "keyLoadTimeOut";
  // Triggered when an exception occurs while adding a sourceBuffer to MediaSource - data : { error : exception , mimeType : mimeType }
  ErrorDetails["BUFFER_ADD_CODEC_ERROR"] = "bufferAddCodecError";
  // Triggered when source buffer(s) could not be created using level (manifest CODECS attribute), parsed media, or best guess codec(s) - data: { reason : error reason }
  ErrorDetails["BUFFER_INCOMPATIBLE_CODECS_ERROR"] = "bufferIncompatibleCodecsError";
  // Identifier for a buffer append error - data: append error description
  ErrorDetails["BUFFER_APPEND_ERROR"] = "bufferAppendError";
  // Identifier for a buffer appending error event - data: appending error description
  ErrorDetails["BUFFER_APPENDING_ERROR"] = "bufferAppendingError";
  // Identifier for a buffer stalled error event
  ErrorDetails["BUFFER_STALLED_ERROR"] = "bufferStalledError";
  // Identifier for a buffer full event
  ErrorDetails["BUFFER_FULL_ERROR"] = "bufferFullError";
  // Identifier for a buffer seek over hole event
  ErrorDetails["BUFFER_SEEK_OVER_HOLE"] = "bufferSeekOverHole";
  // Identifier for a buffer nudge on stall (playback is stuck although currentTime is in a buffered area)
  ErrorDetails["BUFFER_NUDGE_ON_STALL"] = "bufferNudgeOnStall";
  // Identifier for a Interstitial Asset List load error - data: { url: faulty URL, response: { code: error code, text: error text } }
  ErrorDetails["ASSET_LIST_LOAD_ERROR"] = "assetListLoadError";
  // Identifier for a Interstitial Asset List load timeout - data: { url: faulty URL, response: { code: error code, text: error text } }
  ErrorDetails["ASSET_LIST_LOAD_TIMEOUT"] = "assetListLoadTimeout";
  // Identifier for a Interstitial Asset List parsing error - data: { url : faulty URL, reason : error reason, response : { code: error code, text: error text }}
  ErrorDetails["ASSET_LIST_PARSING_ERROR"] = "assetListParsingError";
  // Identifier for a Interstitial Asset List parsing error - data: { url : faulty URL, reason : error reason, response : { code: error code, text: error text }}
  ErrorDetails["INTERSTITIAL_ASSET_ITEM_ERROR"] = "interstitialAssetItemError";
  // Identifier for an internal exception happening inside hls.js while handling an event
  ErrorDetails["INTERNAL_EXCEPTION"] = "internalException";
  // Identifier for an internal call to abort a loader
  ErrorDetails["INTERNAL_ABORTED"] = "aborted";
  // Triggered when attachMedia fails
  ErrorDetails["ATTACH_MEDIA_ERROR"] = "attachMediaError";
  // Uncategorized error
  ErrorDetails["UNKNOWN"] = "unknown";
  return ErrorDetails;
}({});

let Events = /*#__PURE__*/function (Events) {
  // Fired before MediaSource is attaching to media element
  Events["MEDIA_ATTACHING"] = "hlsMediaAttaching";
  // Fired when MediaSource has been successfully attached to media element
  Events["MEDIA_ATTACHED"] = "hlsMediaAttached";
  // Fired before detaching MediaSource from media element
  Events["MEDIA_DETACHING"] = "hlsMediaDetaching";
  // Fired when MediaSource has been detached from media element
  Events["MEDIA_DETACHED"] = "hlsMediaDetached";
  // Fired when HTMLMediaElement dispatches "ended" event, or stalls at end of VOD program
  Events["MEDIA_ENDED"] = "hlsMediaEnded";
  // Fired after playback stall is resolved with playing, seeked, or ended event following BUFFER_STALLED_ERROR
  Events["STALL_RESOLVED"] = "hlsStallResolved";
  // Fired when the buffer is going to be reset
  Events["BUFFER_RESET"] = "hlsBufferReset";
  // Fired when we know about the codecs that we need buffers for to push into - data: {tracks : { container, codec, levelCodec, initSegment, metadata }}
  Events["BUFFER_CODECS"] = "hlsBufferCodecs";
  // fired when sourcebuffers have been created - data: { tracks : tracks }
  Events["BUFFER_CREATED"] = "hlsBufferCreated";
  // fired when we append a segment to the buffer - data: { segment: segment object }
  Events["BUFFER_APPENDING"] = "hlsBufferAppending";
  // fired when we are done with appending a media segment to the buffer - data : { parent : segment parent that triggered BUFFER_APPENDING, pending : nb of segments waiting for appending for this segment parent}
  Events["BUFFER_APPENDED"] = "hlsBufferAppended";
  // fired when the stream is finished and we want to notify the media buffer that there will be no more data - data: { }
  Events["BUFFER_EOS"] = "hlsBufferEos";
  // fired when all buffers are full to the end of the program, after calling MediaSource.endOfStream() (unless restricted)
  Events["BUFFERED_TO_END"] = "hlsBufferedToEnd";
  // fired when the media buffer should be flushed - data { startOffset, endOffset }
  Events["BUFFER_FLUSHING"] = "hlsBufferFlushing";
  // fired when the media buffer has been flushed - data: { }
  Events["BUFFER_FLUSHED"] = "hlsBufferFlushed";
  // fired to signal that a manifest loading starts - data: { url : manifestURL}
  Events["MANIFEST_LOADING"] = "hlsManifestLoading";
  // fired after manifest has been loaded - data: { levels : [available quality levels], audioTracks : [ available audio tracks ], url : manifestURL, stats : LoaderStats }
  Events["MANIFEST_LOADED"] = "hlsManifestLoaded";
  // fired after manifest has been parsed - data: { levels : [available quality levels], firstLevel : index of first quality level appearing in Manifest}
  Events["MANIFEST_PARSED"] = "hlsManifestParsed";
  // fired when a level switch is requested - data: { level : id of new level }
  Events["LEVEL_SWITCHING"] = "hlsLevelSwitching";
  // fired when a level switch is effective - data: { level : id of new level }
  Events["LEVEL_SWITCHED"] = "hlsLevelSwitched";
  // fired when a level playlist loading starts - data: { url : level URL, level : id of level being loaded}
  Events["LEVEL_LOADING"] = "hlsLevelLoading";
  // fired when a level playlist loading finishes - data: { details : levelDetails object, level : id of loaded level, stats : LoaderStats }
  Events["LEVEL_LOADED"] = "hlsLevelLoaded";
  // fired when a level's details have been updated based on previous details, after it has been loaded - data: { details : levelDetails object, level : id of updated level }
  Events["LEVEL_UPDATED"] = "hlsLevelUpdated";
  // fired when a level's PTS information has been updated after parsing a fragment - data: { details : levelDetails object, level : id of updated level, drift: PTS drift observed when parsing last fragment }
  Events["LEVEL_PTS_UPDATED"] = "hlsLevelPtsUpdated";
  // fired to notify that levels have changed after removing a level - data: { levels : [available quality levels] }
  Events["LEVELS_UPDATED"] = "hlsLevelsUpdated";
  // fired to notify that audio track lists has been updated - data: { audioTracks : audioTracks }
  Events["AUDIO_TRACKS_UPDATED"] = "hlsAudioTracksUpdated";
  // fired when an audio track switching is requested - data: { id : audio track id }
  Events["AUDIO_TRACK_SWITCHING"] = "hlsAudioTrackSwitching";
  // fired when an audio track switch actually occurs - data: { id : audio track id }
  Events["AUDIO_TRACK_SWITCHED"] = "hlsAudioTrackSwitched";
  // fired when an audio track loading starts - data: { url : audio track URL, id : audio track id }
  Events["AUDIO_TRACK_LOADING"] = "hlsAudioTrackLoading";
  // fired when an audio track loading finishes - data: { details : levelDetails object, id : audio track id, stats : LoaderStats }
  Events["AUDIO_TRACK_LOADED"] = "hlsAudioTrackLoaded";
  // fired when an audio tracks's details have been updated based on previous details, after it has been loaded - data: { details : levelDetails object, id : track id }
  Events["AUDIO_TRACK_UPDATED"] = "hlsAudioTrackUpdated";
  // fired to notify that subtitle track lists has been updated - data: { subtitleTracks : subtitleTracks }
  Events["SUBTITLE_TRACKS_UPDATED"] = "hlsSubtitleTracksUpdated";
  // fired to notify that subtitle tracks were cleared as a result of stopping the media
  Events["SUBTITLE_TRACKS_CLEARED"] = "hlsSubtitleTracksCleared";
  // fired when an subtitle track switch occurs - data: { id : subtitle track id }
  Events["SUBTITLE_TRACK_SWITCH"] = "hlsSubtitleTrackSwitch";
  // fired when a subtitle track loading starts - data: { url : subtitle track URL, id : subtitle track id }
  Events["SUBTITLE_TRACK_LOADING"] = "hlsSubtitleTrackLoading";
  // fired when a subtitle track loading finishes - data: { details : levelDetails object, id : subtitle track id, stats : LoaderStats }
  Events["SUBTITLE_TRACK_LOADED"] = "hlsSubtitleTrackLoaded";
  // fired when a subtitle  racks's details have been updated based on previous details, after it has been loaded - data: { details : levelDetails object, id : track id }
  Events["SUBTITLE_TRACK_UPDATED"] = "hlsSubtitleTrackUpdated";
  // fired when a subtitle fragment has been processed - data: { success : boolean, frag : the processed frag }
  Events["SUBTITLE_FRAG_PROCESSED"] = "hlsSubtitleFragProcessed";
  // fired when a set of VTTCues to be managed externally has been parsed - data: { type: string, track: string, cues: [ VTTCue ] }
  Events["CUES_PARSED"] = "hlsCuesParsed";
  // fired when a text track to be managed externally is found - data: { tracks: [ { label: string, kind: string, default: boolean } ] }
  Events["NON_NATIVE_TEXT_TRACKS_FOUND"] = "hlsNonNativeTextTracksFound";
  // fired when the first timestamp is found - data: { id : demuxer id, initPTS: initPTS, timescale: timescale, frag : fragment object }
  Events["INIT_PTS_FOUND"] = "hlsInitPtsFound";
  // fired when a fragment loading starts - data: { frag : fragment object }
  Events["FRAG_LOADING"] = "hlsFragLoading";
  // fired when a fragment loading is progressing - data: { frag : fragment object, { trequest, tfirst, loaded } }
  // FRAG_LOAD_PROGRESS = 'hlsFragLoadProgress',
  // Identifier for fragment load aborting for emergency switch down - data: { frag : fragment object }
  Events["FRAG_LOAD_EMERGENCY_ABORTED"] = "hlsFragLoadEmergencyAborted";
  // fired when a fragment loading is completed - data: { frag : fragment object, payload : fragment payload, stats : LoaderStats }
  Events["FRAG_LOADED"] = "hlsFragLoaded";
  // fired when a fragment has finished decrypting - data: { id : demuxer id, frag: fragment object, payload : fragment payload, stats : { tstart, tdecrypt } }
  Events["FRAG_DECRYPTED"] = "hlsFragDecrypted";
  // fired when Init Segment has been extracted from fragment - data: { id : demuxer id, frag: fragment object, moov : moov MP4 box, codecs : codecs found while parsing fragment }
  Events["FRAG_PARSING_INIT_SEGMENT"] = "hlsFragParsingInitSegment";
  // fired when parsing sei text is completed - data: { id : demuxer id, frag: fragment object, samples : [ sei samples pes ] }
  Events["FRAG_PARSING_USERDATA"] = "hlsFragParsingUserdata";
  // fired when parsing id3 is completed - data: { id : demuxer id, frag: fragment object, samples : [ id3 samples pes ] }
  Events["FRAG_PARSING_METADATA"] = "hlsFragParsingMetadata";
  // fired when data have been extracted from fragment - data: { id : demuxer id, frag: fragment object, data1 : moof MP4 box or TS fragments, data2 : mdat MP4 box or null}
  // FRAG_PARSING_DATA = 'hlsFragParsingData',
  // fired when fragment parsing is completed - data: { id : demuxer id, frag: fragment object }
  Events["FRAG_PARSED"] = "hlsFragParsed";
  // fired when fragment remuxed MP4 boxes have all been appended into SourceBuffer - data: { id : demuxer id, frag : fragment object, stats : LoaderStats }
  Events["FRAG_BUFFERED"] = "hlsFragBuffered";
  // fired when fragment matching with current media position is changing - data : { id : demuxer id, frag : fragment object }
  Events["FRAG_CHANGED"] = "hlsFragChanged";
  // Identifier for a FPS drop event - data: { currentDropped, currentDecoded, totalDroppedFrames }
  Events["FPS_DROP"] = "hlsFpsDrop";
  // triggered when FPS drop triggers auto level capping - data: { level, droppedLevel }
  Events["FPS_DROP_LEVEL_CAPPING"] = "hlsFpsDropLevelCapping";
  // triggered when maxAutoLevel changes - data { autoLevelCapping, levels, maxAutoLevel, minAutoLevel, maxHdcpLevel }
  Events["MAX_AUTO_LEVEL_UPDATED"] = "hlsMaxAutoLevelUpdated";
  // Identifier for an error event - data: { type : error type, details : error details, fatal : if true, hls.js cannot/will not try to recover, if false, hls.js will try to recover,other error specific data }
  Events["ERROR"] = "hlsError";
  // fired when hls.js instance starts destroying. Different from MEDIA_DETACHED as one could want to detach and reattach a media to the instance of hls.js to handle mid-rolls for example - data: { }
  Events["DESTROYING"] = "hlsDestroying";
  // fired when a decrypt key loading starts - data: { frag : fragment object }
  Events["KEY_LOADING"] = "hlsKeyLoading";
  // fired when a decrypt key loading is completed - data: { frag : fragment object, keyInfo : KeyLoaderInfo }
  Events["KEY_LOADED"] = "hlsKeyLoaded";
  // deprecated; please use BACK_BUFFER_REACHED - data : { bufferEnd: number }
  Events["LIVE_BACK_BUFFER_REACHED"] = "hlsLiveBackBufferReached";
  // fired when the back buffer is reached as defined by the backBufferLength config option - data : { bufferEnd: number }
  Events["BACK_BUFFER_REACHED"] = "hlsBackBufferReached";
  // fired after steering manifest has been loaded - data: { steeringManifest: SteeringManifest object, url: steering manifest URL }
  Events["STEERING_MANIFEST_LOADED"] = "hlsSteeringManifestLoaded";
  // fired when asset list has begun loading
  Events["ASSET_LIST_LOADING"] = "hlsAssetListLoading";
  // fired when a valid asset list is loaded
  Events["ASSET_LIST_LOADED"] = "hlsAssetListLoaded";
  // fired when the list of Interstitial Events and Interstitial Schedule is updated
  Events["INTERSTITIALS_UPDATED"] = "hlsInterstitialsUpdated";
  // fired when the buffer reaches an Interstitial Schedule boundary (both Primary segments and Interstitial Assets)
  Events["INTERSTITIALS_BUFFERED_TO_BOUNDARY"] = "hlsInterstitialsBufferedToBoundary";
  // fired when a player instance for an Interstitial Asset has been created
  Events["INTERSTITIAL_ASSET_PLAYER_CREATED"] = "hlsInterstitialAssetPlayerCreated";
  // Interstitial playback started
  Events["INTERSTITIAL_STARTED"] = "hlsInterstitialStarted";
  // InterstitialAsset playback started
  Events["INTERSTITIAL_ASSET_STARTED"] = "hlsInterstitialAssetStarted";
  // InterstitialAsset playback ended
  Events["INTERSTITIAL_ASSET_ENDED"] = "hlsInterstitialAssetEnded";
  // InterstitialAsset playback errored
  Events["INTERSTITIAL_ASSET_ERROR"] = "hlsInterstitialAssetError";
  // Interstitial playback ended
  Events["INTERSTITIAL_ENDED"] = "hlsInterstitialEnded";
  // Interstitial schedule resumed primary playback
  Events["INTERSTITIALS_PRIMARY_RESUMED"] = "hlsInterstitialsPrimaryResumed";
  // Interstitial players dispatch this event when playout limit is reached
  Events["PLAYOUT_LIMIT_REACHED"] = "hlsPlayoutLimitReached";
  // Event DateRange cue "enter" event dispatched
  Events["EVENT_CUE_ENTER"] = "hlsEventCueEnter";
  return Events;
}({});

/**
 * Defines each Event type and payload by Event name. Used in {@link hls.js#HlsEventEmitter} to strongly type the event listener API.
 */

var PlaylistContextType = {
  MANIFEST: "manifest",
  LEVEL: "level",
  AUDIO_TRACK: "audioTrack",
  SUBTITLE_TRACK: "subtitleTrack"
};
var PlaylistLevelType = {
  MAIN: "main",
  AUDIO: "audio",
  SUBTITLE: "subtitle"
};

/*
 * compute an Exponential Weighted moving average
 * - https://en.wikipedia.org/wiki/Moving_average#Exponential_moving_average
 *  - heavily inspired from shaka-player
 */

class EWMA {
  //  About half of the estimated value will be from the last |halfLife| samples by weight.
  constructor(halfLife, estimate = 0, weight = 0) {
    this.halfLife = void 0;
    this.alpha_ = void 0;
    this.estimate_ = void 0;
    this.totalWeight_ = void 0;
    this.halfLife = halfLife;
    // Larger values of alpha expire historical data more slowly.
    this.alpha_ = halfLife ? Math.exp(Math.log(0.5) / halfLife) : 0;
    this.estimate_ = estimate;
    this.totalWeight_ = weight;
  }
  sample(weight, value) {
    const adjAlpha = Math.pow(this.alpha_, weight);
    this.estimate_ = value * (1 - adjAlpha) + adjAlpha * this.estimate_;
    this.totalWeight_ += weight;
  }
  getTotalWeight() {
    return this.totalWeight_;
  }
  getEstimate() {
    if (this.alpha_) {
      const zeroFactor = 1 - Math.pow(this.alpha_, this.totalWeight_);
      if (zeroFactor) {
        return this.estimate_ / zeroFactor;
      }
    }
    return this.estimate_;
  }
}

/*
 * EWMA Bandwidth Estimator
 *  - heavily inspired from shaka-player
 * Tracks bandwidth samples and estimates available bandwidth.
 * Based on the minimum of two exponentially-weighted moving averages with
 * different half-lives.
 */

class EwmaBandWidthEstimator {
  constructor(slow, fast, defaultEstimate, defaultTTFB = 100) {
    this.defaultEstimate_ = void 0;
    this.minWeight_ = void 0;
    this.minDelayMs_ = void 0;
    this.slow_ = void 0;
    this.fast_ = void 0;
    this.defaultTTFB_ = void 0;
    this.ttfb_ = void 0;
    this.defaultEstimate_ = defaultEstimate;
    this.minWeight_ = 0.001;
    this.minDelayMs_ = 50;
    this.slow_ = new EWMA(slow);
    this.fast_ = new EWMA(fast);
    this.defaultTTFB_ = defaultTTFB;
    this.ttfb_ = new EWMA(slow);
  }
  update(slow, fast) {
    const {
      slow_,
      fast_,
      ttfb_
    } = this;
    if (slow_.halfLife !== slow) {
      this.slow_ = new EWMA(slow, slow_.getEstimate(), slow_.getTotalWeight());
    }
    if (fast_.halfLife !== fast) {
      this.fast_ = new EWMA(fast, fast_.getEstimate(), fast_.getTotalWeight());
    }
    if (ttfb_.halfLife !== slow) {
      this.ttfb_ = new EWMA(slow, ttfb_.getEstimate(), ttfb_.getTotalWeight());
    }
  }
  sample(durationMs, numBytes) {
    durationMs = Math.max(durationMs, this.minDelayMs_);
    const numBits = 8 * numBytes;
    // weight is duration in seconds
    const durationS = durationMs / 1000;
    // value is bandwidth in bits/s
    const bandwidthInBps = numBits / durationS;
    this.fast_.sample(durationS, bandwidthInBps);
    this.slow_.sample(durationS, bandwidthInBps);
  }
  sampleTTFB(ttfb) {
    // weight is frequency curve applied to TTFB in seconds
    // (longer times have less weight with expected input under 1 second)
    const seconds = ttfb / 1000;
    const weight = Math.sqrt(2) * Math.exp(-Math.pow(seconds, 2) / 2);
    this.ttfb_.sample(weight, Math.max(ttfb, 5));
  }
  canEstimate() {
    return this.fast_.getTotalWeight() >= this.minWeight_;
  }
  getEstimate() {
    if (this.canEstimate()) {
      // console.log('slow estimate:'+ Math.round(this.slow_.getEstimate()));
      // console.log('fast estimate:'+ Math.round(this.fast_.getEstimate()));
      // Take the minimum of these two estimates.  This should have the effect of
      // adapting down quickly, but up more slowly.
      return Math.min(this.fast_.getEstimate(), this.slow_.getEstimate());
    } else {
      return this.defaultEstimate_;
    }
  }
  getEstimateTTFB() {
    if (this.ttfb_.getTotalWeight() >= this.minWeight_) {
      return this.ttfb_.getEstimate();
    } else {
      return this.defaultTTFB_;
    }
  }
  get defaultEstimate() {
    return this.defaultEstimate_;
  }
  destroy() {}
}

function hls_defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function hls_ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? hls_ownKeys(Object(t), true).forEach(function (r) {
      hls_defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : hls_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}

class hls_Logger {
  constructor(label, logger) {
    this.trace = void 0;
    this.debug = void 0;
    this.log = void 0;
    this.warn = void 0;
    this.info = void 0;
    this.error = void 0;
    const lb = `[${label}]:`;
    this.trace = hls_noop;
    this.debug = logger.debug.bind(null, lb);
    this.log = logger.log.bind(null, lb);
    this.warn = logger.warn.bind(null, lb);
    this.info = logger.info.bind(null, lb);
    this.error = logger.error.bind(null, lb);
  }
}
const hls_noop = function noop() {};
const fakeLogger = {
  trace: hls_noop,
  debug: hls_noop,
  log: hls_noop,
  warn: hls_noop,
  info: hls_noop,
  error: hls_noop
};
function createLogger() {
  return _extends({}, fakeLogger);
}

// let lastCallTime;
// function formatMsgWithTimeInfo(type, msg) {
//   const now = Date.now();
//   const diff = lastCallTime ? '+' + (now - lastCallTime) : '0';
//   lastCallTime = now;
//   msg = (new Date(now)).toISOString() + ' | [' +  type + '] > ' + msg + ' ( ' + diff + ' ms )';
//   return msg;
// }

function consolePrintFn(type, id) {
  const func = self.console[type];
  return func ? func.bind(self.console, `${id ? '[' + id + '] ' : ''}[${type}] >`) : hls_noop;
}
function getLoggerFn(key, debugConfig, id) {
  return debugConfig[key] ? debugConfig[key].bind(debugConfig) : consolePrintFn(key, id);
}
const exportedLogger = createLogger();
function enableLogs(debugConfig, context, id) {
  // check that console is available
  const newLogger = createLogger();
  if (typeof console === 'object' && debugConfig === true || typeof debugConfig === 'object') {
    const keys = [
    // Remove out from list here to hard-disable a log-level
    // 'trace',
    'debug', 'log', 'info', 'warn', 'error'];
    keys.forEach(key => {
      newLogger[key] = getLoggerFn(key, debugConfig, id);
    });
    // Some browsers don't allow to use bind on console object anyway
    // fallback to default if needed
    try {
      newLogger.log(`Debug logs enabled for "${context}" in hls.js version ${"1.6.5"}`);
    } catch (e) {
      /* log fn threw an exception. All logger methods are no-ops. */
      return createLogger();
    }
    // global exported logger uses the same functions as new logger without `id`
    keys.forEach(key => {
      exportedLogger[key] = getLoggerFn(key, debugConfig);
    });
  } else {
    // Reset global exported logger
    _extends(exportedLogger, newLogger);
  }
  return newLogger;
}
const hls_logger = exportedLogger;

function getMediaSource(preferManagedMediaSource = true) {
  if (typeof self === 'undefined') return undefined;
  const mms = (preferManagedMediaSource || !self.MediaSource) && self.ManagedMediaSource;
  return mms || self.MediaSource || self.WebKitMediaSource;
}
function isManagedMediaSource(source) {
  return typeof self !== 'undefined' && source === self.ManagedMediaSource;
}
function isCompatibleTrackChange(currentTracks, requiredTracks) {
  const trackNames = Object.keys(currentTracks);
  const requiredTrackNames = Object.keys(requiredTracks);
  const trackCount = trackNames.length;
  const requiredTrackCount = requiredTrackNames.length;
  return !trackCount || !requiredTrackCount || trackCount === requiredTrackCount && !trackNames.some(name => requiredTrackNames.indexOf(name) === -1);
}

// http://stackoverflow.com/questions/8936984/uint8array-to-string-in-javascript/22373197
// http://www.onicos.com/staff/iz/amuse/javascript/expert/utf.txt
/* utf.js - UTF-8 <=> UTF-16 convertion
 *
 * Copyright (C) 1999 Masanao Izumo <iz@onicos.co.jp>
 * Version: 1.0
 * LastModified: Dec 25 1999
 * This library is free.  You can redistribute it and/or modify it.
 */
/**
 * Converts a UTF-8 array to a string.
 *
 * @param array - The UTF-8 array to convert
 *
 * @returns The string
 *
 * @group Utils
 *
 * @beta
 */
function utf8ArrayToStr(array, exitOnNull = false) {
  if (typeof TextDecoder !== 'undefined') {
    const decoder = new TextDecoder('utf-8');
    const decoded = decoder.decode(array);
    if (exitOnNull) {
      // grab up to the first null
      const idx = decoded.indexOf('\0');
      return idx !== -1 ? decoded.substring(0, idx) : decoded;
    }
    // remove any null characters
    return decoded.replace(/\0/g, '');
  }
  const len = array.length;
  let c;
  let char2;
  let char3;
  let out = '';
  let i = 0;
  while (i < len) {
    c = array[i++];
    if (c === 0x00 && exitOnNull) {
      return out;
    } else if (c === 0x00 || c === 0x03) {
      // If the character is 3 (END_OF_TEXT) or 0 (NULL) then skip it
      continue;
    }
    switch (c >> 4) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
        // 0xxxxxxx
        out += String.fromCharCode(c);
        break;
      case 12:
      case 13:
        // 110x xxxx   10xx xxxx
        char2 = array[i++];
        out += String.fromCharCode((c & 0x1f) << 6 | char2 & 0x3f);
        break;
      case 14:
        // 1110 xxxx  10xx xxxx  10xx xxxx
        char2 = array[i++];
        char3 = array[i++];
        out += String.fromCharCode((c & 0x0f) << 12 | (char2 & 0x3f) << 6 | (char3 & 0x3f) << 0);
        break;
    }
  }
  return out;
}

/**
 *  hex dump helper class
 */

const Hex = {
  hexDump: function (array) {
    let str = '';
    for (let i = 0; i < array.length; i++) {
      let h = array[i].toString(16);
      if (h.length < 2) {
        h = '0' + h;
      }
      str += h;
    }
    return str;
  }
};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var urlToolkit = {exports: {}};

var hasRequiredUrlToolkit;

function requireUrlToolkit () {
	if (hasRequiredUrlToolkit) return urlToolkit.exports;
	hasRequiredUrlToolkit = 1;
	(function (module, exports) {
		// see https://tools.ietf.org/html/rfc1808

		(function (root) {
		  var URL_REGEX =
		    /^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/;
		  var FIRST_SEGMENT_REGEX = /^(?=([^\/?#]*))\1([^]*)$/;
		  var SLASH_DOT_REGEX = /(?:\/|^)\.(?=\/)/g;
		  var SLASH_DOT_DOT_REGEX = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g;

		  var URLToolkit = {
		    // If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
		    // E.g
		    // With opts.alwaysNormalize = false (default, spec compliant)
		    // http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
		    // With opts.alwaysNormalize = true (not spec compliant)
		    // http://a.com/b/cd + /e/f/../g => http://a.com/e/g
		    buildAbsoluteURL: function (baseURL, relativeURL, opts) {
		      opts = opts || {};
		      // remove any remaining space and CRLF
		      baseURL = baseURL.trim();
		      relativeURL = relativeURL.trim();
		      if (!relativeURL) {
		        // 2a) If the embedded URL is entirely empty, it inherits the
		        // entire base URL (i.e., is set equal to the base URL)
		        // and we are done.
		        if (!opts.alwaysNormalize) {
		          return baseURL;
		        }
		        var basePartsForNormalise = URLToolkit.parseURL(baseURL);
		        if (!basePartsForNormalise) {
		          throw new Error('Error trying to parse base URL.');
		        }
		        basePartsForNormalise.path = URLToolkit.normalizePath(
		          basePartsForNormalise.path
		        );
		        return URLToolkit.buildURLFromParts(basePartsForNormalise);
		      }
		      var relativeParts = URLToolkit.parseURL(relativeURL);
		      if (!relativeParts) {
		        throw new Error('Error trying to parse relative URL.');
		      }
		      if (relativeParts.scheme) {
		        // 2b) If the embedded URL starts with a scheme name, it is
		        // interpreted as an absolute URL and we are done.
		        if (!opts.alwaysNormalize) {
		          return relativeURL;
		        }
		        relativeParts.path = URLToolkit.normalizePath(relativeParts.path);
		        return URLToolkit.buildURLFromParts(relativeParts);
		      }
		      var baseParts = URLToolkit.parseURL(baseURL);
		      if (!baseParts) {
		        throw new Error('Error trying to parse base URL.');
		      }
		      if (!baseParts.netLoc && baseParts.path && baseParts.path[0] !== '/') {
		        // If netLoc missing and path doesn't start with '/', assume everthing before the first '/' is the netLoc
		        // This causes 'example.com/a' to be handled as '//example.com/a' instead of '/example.com/a'
		        var pathParts = FIRST_SEGMENT_REGEX.exec(baseParts.path);
		        baseParts.netLoc = pathParts[1];
		        baseParts.path = pathParts[2];
		      }
		      if (baseParts.netLoc && !baseParts.path) {
		        baseParts.path = '/';
		      }
		      var builtParts = {
		        // 2c) Otherwise, the embedded URL inherits the scheme of
		        // the base URL.
		        scheme: baseParts.scheme,
		        netLoc: relativeParts.netLoc,
		        path: null,
		        params: relativeParts.params,
		        query: relativeParts.query,
		        fragment: relativeParts.fragment,
		      };
		      if (!relativeParts.netLoc) {
		        // 3) If the embedded URL's <net_loc> is non-empty, we skip to
		        // Step 7.  Otherwise, the embedded URL inherits the <net_loc>
		        // (if any) of the base URL.
		        builtParts.netLoc = baseParts.netLoc;
		        // 4) If the embedded URL path is preceded by a slash "/", the
		        // path is not relative and we skip to Step 7.
		        if (relativeParts.path[0] !== '/') {
		          if (!relativeParts.path) {
		            // 5) If the embedded URL path is empty (and not preceded by a
		            // slash), then the embedded URL inherits the base URL path
		            builtParts.path = baseParts.path;
		            // 5a) if the embedded URL's <params> is non-empty, we skip to
		            // step 7; otherwise, it inherits the <params> of the base
		            // URL (if any) and
		            if (!relativeParts.params) {
		              builtParts.params = baseParts.params;
		              // 5b) if the embedded URL's <query> is non-empty, we skip to
		              // step 7; otherwise, it inherits the <query> of the base
		              // URL (if any) and we skip to step 7.
		              if (!relativeParts.query) {
		                builtParts.query = baseParts.query;
		              }
		            }
		          } else {
		            // 6) The last segment of the base URL's path (anything
		            // following the rightmost slash "/", or the entire path if no
		            // slash is present) is removed and the embedded URL's path is
		            // appended in its place.
		            var baseURLPath = baseParts.path;
		            var newPath =
		              baseURLPath.substring(0, baseURLPath.lastIndexOf('/') + 1) +
		              relativeParts.path;
		            builtParts.path = URLToolkit.normalizePath(newPath);
		          }
		        }
		      }
		      if (builtParts.path === null) {
		        builtParts.path = opts.alwaysNormalize
		          ? URLToolkit.normalizePath(relativeParts.path)
		          : relativeParts.path;
		      }
		      return URLToolkit.buildURLFromParts(builtParts);
		    },
		    parseURL: function (url) {
		      var parts = URL_REGEX.exec(url);
		      if (!parts) {
		        return null;
		      }
		      return {
		        scheme: parts[1] || '',
		        netLoc: parts[2] || '',
		        path: parts[3] || '',
		        params: parts[4] || '',
		        query: parts[5] || '',
		        fragment: parts[6] || '',
		      };
		    },
		    normalizePath: function (path) {
		      // The following operations are
		      // then applied, in order, to the new path:
		      // 6a) All occurrences of "./", where "." is a complete path
		      // segment, are removed.
		      // 6b) If the path ends with "." as a complete path segment,
		      // that "." is removed.
		      path = path.split('').reverse().join('').replace(SLASH_DOT_REGEX, '');
		      // 6c) All occurrences of "<segment>/../", where <segment> is a
		      // complete path segment not equal to "..", are removed.
		      // Removal of these path segments is performed iteratively,
		      // removing the leftmost matching pattern on each iteration,
		      // until no matching pattern remains.
		      // 6d) If the path ends with "<segment>/..", where <segment> is a
		      // complete path segment not equal to "..", that
		      // "<segment>/.." is removed.
		      while (
		        path.length !== (path = path.replace(SLASH_DOT_DOT_REGEX, '')).length
		      ) {}
		      return path.split('').reverse().join('');
		    },
		    buildURLFromParts: function (parts) {
		      return (
		        parts.scheme +
		        parts.netLoc +
		        parts.path +
		        parts.params +
		        parts.query +
		        parts.fragment
		      );
		    },
		  };

		  module.exports = URLToolkit;
		})(); 
	} (urlToolkit));
	return urlToolkit.exports;
}

var urlToolkitExports = requireUrlToolkit();

class LoadStats {
  constructor() {
    this.aborted = false;
    this.loaded = 0;
    this.retry = 0;
    this.total = 0;
    this.chunkCount = 0;
    this.bwEstimate = 0;
    this.loading = {
      start: 0,
      first: 0,
      end: 0
    };
    this.parsing = {
      start: 0,
      end: 0
    };
    this.buffering = {
      start: 0,
      first: 0,
      end: 0
    };
  }
}

var ElementaryStreamTypes = {
  AUDIO: "audio",
  VIDEO: "video",
  AUDIOVIDEO: "audiovideo"
};
class BaseSegment {
  constructor(base) {
    this._byteRange = null;
    this._url = null;
    this._stats = null;
    this._streams = null;
    // baseurl is the URL to the playlist
    this.base = void 0;
    // relurl is the portion of the URL that comes from inside the playlist.
    this.relurl = void 0;
    if (typeof base === 'string') {
      base = {
        url: base
      };
    }
    this.base = base;
    makeEnumerable(this, 'stats');
  }

  // setByteRange converts a EXT-X-BYTERANGE attribute into a two element array
  setByteRange(value, previous) {
    const params = value.split('@', 2);
    let start;
    if (params.length === 1) {
      start = (previous == null ? void 0 : previous.byteRangeEndOffset) || 0;
    } else {
      start = parseInt(params[1]);
    }
    this._byteRange = [start, parseInt(params[0]) + start];
  }
  get baseurl() {
    return this.base.url;
  }
  get byteRange() {
    if (this._byteRange === null) {
      return [];
    }
    return this._byteRange;
  }
  get byteRangeStartOffset() {
    return this.byteRange[0];
  }
  get byteRangeEndOffset() {
    return this.byteRange[1];
  }
  get elementaryStreams() {
    if (this._streams === null) {
      this._streams = {
        [ElementaryStreamTypes.AUDIO]: null,
        [ElementaryStreamTypes.VIDEO]: null,
        [ElementaryStreamTypes.AUDIOVIDEO]: null
      };
    }
    return this._streams;
  }
  set elementaryStreams(value) {
    this._streams = value;
  }
  get hasStats() {
    return this._stats !== null;
  }
  get hasStreams() {
    return this._streams !== null;
  }
  get stats() {
    if (this._stats === null) {
      this._stats = new LoadStats();
    }
    return this._stats;
  }
  set stats(value) {
    this._stats = value;
  }
  get url() {
    if (!this._url && this.baseurl && this.relurl) {
      this._url = urlToolkitExports.buildAbsoluteURL(this.baseurl, this.relurl, {
        alwaysNormalize: true
      });
    }
    return this._url || '';
  }
  set url(value) {
    this._url = value;
  }
  clearElementaryStreamInfo() {
    const {
      elementaryStreams
    } = this;
    elementaryStreams[ElementaryStreamTypes.AUDIO] = null;
    elementaryStreams[ElementaryStreamTypes.VIDEO] = null;
    elementaryStreams[ElementaryStreamTypes.AUDIOVIDEO] = null;
  }
}
function isMediaFragment(frag) {
  return frag.sn !== 'initSegment';
}

/**
 * Object representing parsed data from an HLS Segment. Found in {@link hls.js#LevelDetails.fragments}.
 */
class Fragment extends BaseSegment {
  constructor(type, base) {
    super(base);
    this._decryptdata = null;
    this._programDateTime = null;
    this._ref = null;
    // Approximate bit rate of the fragment expressed in bits per second (bps) as indicated by the last EXT-X-BITRATE (kbps) tag
    this._bitrate = void 0;
    this.rawProgramDateTime = null;
    this.tagList = [];
    // EXTINF has to be present for a m3u8 to be considered valid
    this.duration = 0;
    // sn notates the sequence number for a segment, and if set to a string can be 'initSegment'
    this.sn = 0;
    // levelkeys are the EXT-X-KEY tags that apply to this segment for decryption
    // core difference from the private field _decryptdata is the lack of the initialized IV
    // _decryptdata will set the IV for this segment based on the segment number in the fragment
    this.levelkeys = void 0;
    // A string representing the fragment type
    this.type = void 0;
    // A reference to the loader. Set while the fragment is loading, and removed afterwards. Used to abort fragment loading
    this.loader = null;
    // A reference to the key loader. Set while the key is loading, and removed afterwards. Used to abort key loading
    this.keyLoader = null;
    // The level/track index to which the fragment belongs
    this.level = -1;
    // The continuity counter of the fragment
    this.cc = 0;
    // The starting Presentation Time Stamp (PTS) of the fragment. Set after transmux complete.
    this.startPTS = void 0;
    // The ending Presentation Time Stamp (PTS) of the fragment. Set after transmux complete.
    this.endPTS = void 0;
    // The starting Decode Time Stamp (DTS) of the fragment. Set after transmux complete.
    this.startDTS = void 0;
    // The ending Decode Time Stamp (DTS) of the fragment. Set after transmux complete.
    this.endDTS = void 0;
    // The start time of the fragment, as listed in the manifest. Updated after transmux complete.
    this.start = 0;
    // The offset time (seconds) of the fragment from the start of the Playlist
    this.playlistOffset = 0;
    // Set by `updateFragPTSDTS` in level-helper
    this.deltaPTS = void 0;
    // The maximum starting Presentation Time Stamp (audio/video PTS) of the fragment. Set after transmux complete.
    this.maxStartPTS = void 0;
    // The minimum ending Presentation Time Stamp (audio/video PTS) of the fragment. Set after transmux complete.
    this.minEndPTS = void 0;
    // Init Segment bytes (unset for media segments)
    this.data = void 0;
    // A flag indicating whether the segment was downloaded in order to test bitrate, and was not buffered
    this.bitrateTest = false;
    // #EXTINF  segment title
    this.title = null;
    // The Media Initialization Section for this segment
    this.initSegment = null;
    // Fragment is the last fragment in the media playlist
    this.endList = void 0;
    // Fragment is marked by an EXT-X-GAP tag indicating that it does not contain media data and should not be loaded
    this.gap = void 0;
    // Deprecated
    this.urlId = 0;
    this.type = type;
  }
  get byteLength() {
    if (this.hasStats) {
      const total = this.stats.total;
      if (total) {
        return total;
      }
    }
    if (this.byteRange) {
      const start = this.byteRange[0];
      const end = this.byteRange[1];
      if (isFiniteNumber(start) && isFiniteNumber(end)) {
        return end - start;
      }
    }
    return null;
  }
  get bitrate() {
    if (this.byteLength) {
      return this.byteLength * 8 / this.duration;
    }
    if (this._bitrate) {
      return this._bitrate;
    }
    return null;
  }
  set bitrate(value) {
    this._bitrate = value;
  }
  get decryptdata() {
    const {
      levelkeys
    } = this;
    if (!levelkeys && !this._decryptdata) {
      return null;
    }
    if (!this._decryptdata && this.levelkeys && !this.levelkeys.NONE) {
      const key = this.levelkeys.identity;
      if (key) {
        this._decryptdata = key.getDecryptData(this.sn);
      } else {
        const keyFormats = Object.keys(this.levelkeys);
        if (keyFormats.length === 1) {
          return this._decryptdata = this.levelkeys[keyFormats[0]].getDecryptData(this.sn);
        }
      }
    }
    return this._decryptdata;
  }
  get end() {
    return this.start + this.duration;
  }
  get endProgramDateTime() {
    if (this.programDateTime === null) {
      return null;
    }
    const duration = !isFiniteNumber(this.duration) ? 0 : this.duration;
    return this.programDateTime + duration * 1000;
  }
  get encrypted() {
    var _this$_decryptdata;
    // At the m3u8-parser level we need to add support for manifest signalled keyformats
    // when we want the fragment to start reporting that it is encrypted.
    // Currently, keyFormat will only be set for identity keys
    if ((_this$_decryptdata = this._decryptdata) != null && _this$_decryptdata.encrypted) {
      return true;
    } else if (this.levelkeys) {
      const keyFormats = Object.keys(this.levelkeys);
      const len = keyFormats.length;
      if (len > 1 || len === 1 && this.levelkeys[keyFormats[0]].encrypted) {
        return true;
      }
    }
    return false;
  }
  get programDateTime() {
    if (this._programDateTime === null && this.rawProgramDateTime) {
      this.programDateTime = Date.parse(this.rawProgramDateTime);
    }
    return this._programDateTime;
  }
  set programDateTime(value) {
    if (!isFiniteNumber(value)) {
      this._programDateTime = this.rawProgramDateTime = null;
      return;
    }
    this._programDateTime = value;
  }
  get ref() {
    if (!isMediaFragment(this)) {
      return null;
    }
    if (!this._ref) {
      this._ref = {
        base: this.base,
        start: this.start,
        duration: this.duration,
        sn: this.sn,
        programDateTime: this.programDateTime
      };
    }
    return this._ref;
  }
  addStart(value) {
    this.setStart(this.start + value);
  }
  setStart(value) {
    this.start = value;
    if (this._ref) {
      this._ref.start = value;
    }
  }
  setDuration(value) {
    this.duration = value;
    if (this._ref) {
      this._ref.duration = value;
    }
  }
  setKeyFormat(keyFormat) {
    if (this.levelkeys) {
      const key = this.levelkeys[keyFormat];
      if (key && !this._decryptdata) {
        this._decryptdata = key.getDecryptData(this.sn);
      }
    }
  }
  abortRequests() {
    var _this$loader, _this$keyLoader;
    (_this$loader = this.loader) == null ? void 0 : _this$loader.abort();
    (_this$keyLoader = this.keyLoader) == null ? void 0 : _this$keyLoader.abort();
  }
  setElementaryStreamInfo(type, startPTS, endPTS, startDTS, endDTS, partial = false) {
    const {
      elementaryStreams
    } = this;
    const info = elementaryStreams[type];
    if (!info) {
      elementaryStreams[type] = {
        startPTS,
        endPTS,
        startDTS,
        endDTS,
        partial
      };
      return;
    }
    info.startPTS = Math.min(info.startPTS, startPTS);
    info.endPTS = Math.max(info.endPTS, endPTS);
    info.startDTS = Math.min(info.startDTS, startDTS);
    info.endDTS = Math.max(info.endDTS, endDTS);
  }
}

/**
 * Object representing parsed data from an HLS Partial Segment. Found in {@link hls.js#LevelDetails.partList}.
 */
class Part extends BaseSegment {
  constructor(partAttrs, frag, base, index, previous) {
    super(base);
    this.fragOffset = 0;
    this.duration = 0;
    this.gap = false;
    this.independent = false;
    this.relurl = void 0;
    this.fragment = void 0;
    this.index = void 0;
    this.duration = partAttrs.decimalFloatingPoint('DURATION');
    this.gap = partAttrs.bool('GAP');
    this.independent = partAttrs.bool('INDEPENDENT');
    this.relurl = partAttrs.enumeratedString('URI');
    this.fragment = frag;
    this.index = index;
    const byteRange = partAttrs.enumeratedString('BYTERANGE');
    if (byteRange) {
      this.setByteRange(byteRange, previous);
    }
    if (previous) {
      this.fragOffset = previous.fragOffset + previous.duration;
    }
  }
  get start() {
    return this.fragment.start + this.fragOffset;
  }
  get end() {
    return this.start + this.duration;
  }
  get loaded() {
    const {
      elementaryStreams
    } = this;
    return !!(elementaryStreams.audio || elementaryStreams.video || elementaryStreams.audiovideo);
  }
}
function getOwnPropertyDescriptorFromPrototypeChain(object, property) {
  const prototype = Object.getPrototypeOf(object);
  if (prototype) {
    const propertyDescriptor = Object.getOwnPropertyDescriptor(prototype, property);
    if (propertyDescriptor) {
      return propertyDescriptor;
    }
    return getOwnPropertyDescriptorFromPrototypeChain(prototype, property);
  }
}
function makeEnumerable(object, property) {
  const d = getOwnPropertyDescriptorFromPrototypeChain(object, property);
  if (d) {
    d.enumerable = true;
    Object.defineProperty(object, property, d);
  }
}

const UINT32_MAX$1 = Math.pow(2, 32) - 1;
const push = [].push;

// We are using fixed track IDs for driving the MP4 remuxer
// instead of following the TS PIDs.
// There is no reason not to do this and some browsers/SourceBuffer-demuxers
// may not like if there are TrackID "switches"
// See https://github.com/video-dev/hls.js/issues/1331
// Here we are mapping our internal track types to constant MP4 track IDs
// With MSE currently one can only have one track of each, and we are muxing
// whatever video/audio rendition in them.
const RemuxerTrackIdConfig = {
  video: 1,
  audio: 2,
  id3: 3,
  text: 4
};
function bin2str(data) {
  return String.fromCharCode.apply(null, data);
}
function readUint16(buffer, offset) {
  const val = buffer[offset] << 8 | buffer[offset + 1];
  return val < 0 ? 65536 + val : val;
}
function readUint32(buffer, offset) {
  const val = readSint32(buffer, offset);
  return val < 0 ? 4294967296 + val : val;
}
function readUint64(buffer, offset) {
  let result = readUint32(buffer, offset);
  result *= Math.pow(2, 32);
  result += readUint32(buffer, offset + 4);
  return result;
}
function readSint32(buffer, offset) {
  return buffer[offset] << 24 | buffer[offset + 1] << 16 | buffer[offset + 2] << 8 | buffer[offset + 3];
}
function writeUint32(buffer, offset, value) {
  buffer[offset] = value >> 24;
  buffer[offset + 1] = value >> 16 & 0xff;
  buffer[offset + 2] = value >> 8 & 0xff;
  buffer[offset + 3] = value & 0xff;
}

// Find "moof" box
function hasMoofData(data) {
  const end = data.byteLength;
  for (let i = 0; i < end;) {
    const size = readUint32(data, i);
    if (size > 8 && data[i + 4] === 0x6d && data[i + 5] === 0x6f && data[i + 6] === 0x6f && data[i + 7] === 0x66) {
      return true;
    }
    i = size > 1 ? i + size : end;
  }
  return false;
}

// Find the data for a box specified by its path
function findBox(data, path) {
  const results = [];
  if (!path.length) {
    // short-circuit the search for empty paths
    return results;
  }
  const end = data.byteLength;
  for (let i = 0; i < end;) {
    const size = readUint32(data, i);
    const type = bin2str(data.subarray(i + 4, i + 8));
    const endbox = size > 1 ? i + size : end;
    if (type === path[0]) {
      if (path.length === 1) {
        // this is the end of the path and we've found the box we were
        // looking for
        results.push(data.subarray(i + 8, endbox));
      } else {
        // recursively search for the next box along the path
        const subresults = findBox(data.subarray(i + 8, endbox), path.slice(1));
        if (subresults.length) {
          push.apply(results, subresults);
        }
      }
    }
    i = endbox;
  }

  // we've finished searching all of data
  return results;
}
function parseSegmentIndex(sidx) {
  const references = [];
  const version = sidx[0];

  // set initial offset, we skip the reference ID (not needed)
  let index = 8;
  const timescale = readUint32(sidx, index);
  index += 4;
  let earliestPresentationTime = 0;
  let firstOffset = 0;
  if (version === 0) {
    earliestPresentationTime = readUint32(sidx, index);
    firstOffset = readUint32(sidx, index + 4);
    index += 8;
  } else {
    earliestPresentationTime = readUint64(sidx, index);
    firstOffset = readUint64(sidx, index + 8);
    index += 16;
  }

  // skip reserved
  index += 2;
  let startByte = sidx.length + firstOffset;
  const referencesCount = readUint16(sidx, index);
  index += 2;
  for (let i = 0; i < referencesCount; i++) {
    let referenceIndex = index;
    const referenceInfo = readUint32(sidx, referenceIndex);
    referenceIndex += 4;
    const referenceSize = referenceInfo & 0x7fffffff;
    const referenceType = (referenceInfo & 0x80000000) >>> 31;
    if (referenceType === 1) {
      hls_logger.warn('SIDX has hierarchical references (not supported)');
      return null;
    }
    const subsegmentDuration = readUint32(sidx, referenceIndex);
    referenceIndex += 4;
    references.push({
      referenceSize,
      subsegmentDuration,
      // unscaled
      info: {
        duration: subsegmentDuration / timescale,
        start: startByte,
        end: startByte + referenceSize - 1
      }
    });
    startByte += referenceSize;

    // Skipping 1 bit for |startsWithSap|, 3 bits for |sapType|, and 28 bits
    // for |sapDelta|.
    referenceIndex += 4;

    // skip to next ref
    index = referenceIndex;
  }
  return {
    earliestPresentationTime,
    timescale,
    version,
    referencesCount,
    references
  };
}

/**
 * Parses an MP4 initialization segment and extracts stream type and
 * timescale values for any declared tracks. Timescale values indicate the
 * number of clock ticks per second to assume for time-based values
 * elsewhere in the MP4.
 *
 * To determine the start time of an MP4, you need two pieces of
 * information: the timescale unit and the earliest base media decode
 * time. Multiple timescales can be specified within an MP4 but the
 * base media decode time is always expressed in the timescale from
 * the media header box for the track:
 * ```
 * moov > trak > mdia > mdhd.timescale
 * moov > trak > mdia > hdlr
 * ```
 * @param initSegment the bytes of the init segment
 * @returns a hash of track type to timescale values or null if
 * the init segment is malformed.
 */

function parseInitSegment(initSegment) {
  const result = [];
  const traks = findBox(initSegment, ['moov', 'trak']);
  for (let i = 0; i < traks.length; i++) {
    const trak = traks[i];
    const tkhd = findBox(trak, ['tkhd'])[0];
    if (tkhd) {
      let version = tkhd[0];
      const trackId = readUint32(tkhd, version === 0 ? 12 : 20);
      const mdhd = findBox(trak, ['mdia', 'mdhd'])[0];
      if (mdhd) {
        version = mdhd[0];
        const timescale = readUint32(mdhd, version === 0 ? 12 : 20);
        const hdlr = findBox(trak, ['mdia', 'hdlr'])[0];
        if (hdlr) {
          const hdlrType = bin2str(hdlr.subarray(8, 12));
          const type = {
            soun: ElementaryStreamTypes.AUDIO,
            vide: ElementaryStreamTypes.VIDEO
          }[hdlrType];
          // Parse codec details
          const stsdBox = findBox(trak, ['mdia', 'minf', 'stbl', 'stsd'])[0];
          const stsd = parseStsd(stsdBox);
          if (type) {
            // Add 'audio', 'video', and 'audiovideo' track records that will map to SourceBuffers
            result[trackId] = {
              timescale,
              type,
              stsd
            };
            result[type] = _objectSpread2({
              timescale,
              id: trackId
            }, stsd);
          } else {
            // Add 'meta' and other track records required by `offsetStartDTS`
            result[trackId] = {
              timescale,
              type: hdlrType,
              stsd
            };
          }
        }
      }
    }
  }
  const trex = findBox(initSegment, ['moov', 'mvex', 'trex']);
  trex.forEach(trex => {
    const trackId = readUint32(trex, 4);
    const track = result[trackId];
    if (track) {
      track.default = {
        duration: readUint32(trex, 12),
        flags: readUint32(trex, 20)
      };
    }
  });
  return result;
}
function parseStsd(stsd) {
  const sampleEntries = stsd.subarray(8);
  const sampleEntriesEnd = sampleEntries.subarray(8 + 78);
  const fourCC = bin2str(sampleEntries.subarray(4, 8));
  let codec = fourCC;
  let supplemental;
  const encrypted = fourCC === 'enca' || fourCC === 'encv';
  if (encrypted) {
    const encBox = findBox(sampleEntries, [fourCC])[0];
    const encBoxChildren = encBox.subarray(fourCC === 'enca' ? 28 : 78);
    const sinfs = findBox(encBoxChildren, ['sinf']);
    sinfs.forEach(sinf => {
      const schm = findBox(sinf, ['schm'])[0];
      if (schm) {
        const scheme = bin2str(schm.subarray(4, 8));
        if (scheme === 'cbcs' || scheme === 'cenc') {
          const frma = findBox(sinf, ['frma'])[0];
          if (frma) {
            // for encrypted content codec fourCC will be in frma
            codec = bin2str(frma);
          }
        }
      }
    });
  }
  const codecFourCC = codec;
  switch (codec) {
    case 'avc1':
    case 'avc2':
    case 'avc3':
    case 'avc4':
      {
        // extract profile + compatibility + level out of avcC box
        const avcCBox = findBox(sampleEntriesEnd, ['avcC'])[0];
        if (avcCBox && avcCBox.length > 3) {
          codec += '.' + toHex(avcCBox[1]) + toHex(avcCBox[2]) + toHex(avcCBox[3]);
          supplemental = parseSupplementalDoViCodec(codecFourCC === 'avc1' ? 'dva1' : 'dvav', sampleEntriesEnd);
        }
        break;
      }
    case 'mp4a':
      {
        const codecBox = findBox(sampleEntries, [fourCC])[0];
        const esdsBox = findBox(codecBox.subarray(28), ['esds'])[0];
        if (esdsBox && esdsBox.length > 7) {
          let i = 4;
          // ES Descriptor tag
          if (esdsBox[i++] !== 0x03) {
            break;
          }
          i = skipBERInteger(esdsBox, i);
          i += 2; // skip es_id;
          const flags = esdsBox[i++];
          if (flags & 0x80) {
            i += 2; // skip dependency es_id
          }
          if (flags & 0x40) {
            i += esdsBox[i++]; // skip URL
          }
          // Decoder config descriptor
          if (esdsBox[i++] !== 0x04) {
            break;
          }
          i = skipBERInteger(esdsBox, i);
          const objectType = esdsBox[i++];
          if (objectType === 0x40) {
            codec += '.' + toHex(objectType);
          } else {
            break;
          }
          i += 12;
          // Decoder specific info
          if (esdsBox[i++] !== 0x05) {
            break;
          }
          i = skipBERInteger(esdsBox, i);
          const firstByte = esdsBox[i++];
          let audioObjectType = (firstByte & 0xf8) >> 3;
          if (audioObjectType === 31) {
            audioObjectType += 1 + ((firstByte & 0x7) << 3) + ((esdsBox[i] & 0xe0) >> 5);
          }
          codec += '.' + audioObjectType;
        }
        break;
      }
    case 'hvc1':
    case 'hev1':
      {
        const hvcCBox = findBox(sampleEntriesEnd, ['hvcC'])[0];
        if (hvcCBox && hvcCBox.length > 12) {
          const profileByte = hvcCBox[1];
          const profileSpace = ['', 'A', 'B', 'C'][profileByte >> 6];
          const generalProfileIdc = profileByte & 0x1f;
          const profileCompat = readUint32(hvcCBox, 2);
          const tierFlag = (profileByte & 0x20) >> 5 ? 'H' : 'L';
          const levelIDC = hvcCBox[12];
          const constraintIndicator = hvcCBox.subarray(6, 12);
          codec += '.' + profileSpace + generalProfileIdc;
          codec += '.' + reverse32BitInt(profileCompat).toString(16).toUpperCase();
          codec += '.' + tierFlag + levelIDC;
          let constraintString = '';
          for (let i = constraintIndicator.length; i--;) {
            const byte = constraintIndicator[i];
            if (byte || constraintString) {
              const encodedByte = byte.toString(16).toUpperCase();
              constraintString = '.' + encodedByte + constraintString;
            }
          }
          codec += constraintString;
        }
        supplemental = parseSupplementalDoViCodec(codecFourCC == 'hev1' ? 'dvhe' : 'dvh1', sampleEntriesEnd);
        break;
      }
    case 'dvh1':
    case 'dvhe':
    case 'dvav':
    case 'dva1':
    case 'dav1':
      {
        codec = parseSupplementalDoViCodec(codec, sampleEntriesEnd) || codec;
        break;
      }
    case 'vp09':
      {
        const vpcCBox = findBox(sampleEntriesEnd, ['vpcC'])[0];
        if (vpcCBox && vpcCBox.length > 6) {
          const profile = vpcCBox[4];
          const level = vpcCBox[5];
          const bitDepth = vpcCBox[6] >> 4 & 0x0f;
          codec += '.' + addLeadingZero(profile) + '.' + addLeadingZero(level) + '.' + addLeadingZero(bitDepth);
        }
        break;
      }
    case 'av01':
      {
        const av1CBox = findBox(sampleEntriesEnd, ['av1C'])[0];
        if (av1CBox && av1CBox.length > 2) {
          const profile = av1CBox[1] >>> 5;
          const level = av1CBox[1] & 0x1f;
          const tierFlag = av1CBox[2] >>> 7 ? 'H' : 'M';
          const highBitDepth = (av1CBox[2] & 0x40) >> 6;
          const twelveBit = (av1CBox[2] & 0x20) >> 5;
          const bitDepth = profile === 2 && highBitDepth ? twelveBit ? 12 : 10 : highBitDepth ? 10 : 8;
          const monochrome = (av1CBox[2] & 0x10) >> 4;
          const chromaSubsamplingX = (av1CBox[2] & 0x08) >> 3;
          const chromaSubsamplingY = (av1CBox[2] & 0x04) >> 2;
          const chromaSamplePosition = av1CBox[2] & 0x03;
          // TODO: parse color_description_present_flag
          // default it to BT.709/limited range for now
          // more info https://aomediacodec.github.io/av1-isobmff/#av1codecconfigurationbox-syntax
          const colorPrimaries = 1;
          const transferCharacteristics = 1;
          const matrixCoefficients = 1;
          const videoFullRangeFlag = 0;
          codec += '.' + profile + '.' + addLeadingZero(level) + tierFlag + '.' + addLeadingZero(bitDepth) + '.' + monochrome + '.' + chromaSubsamplingX + chromaSubsamplingY + chromaSamplePosition + '.' + addLeadingZero(colorPrimaries) + '.' + addLeadingZero(transferCharacteristics) + '.' + addLeadingZero(matrixCoefficients) + '.' + videoFullRangeFlag;
          supplemental = parseSupplementalDoViCodec('dav1', sampleEntriesEnd);
        }
        break;
      }
  }
  return {
    codec,
    encrypted,
    supplemental
  };
}
function parseSupplementalDoViCodec(fourCC, sampleEntriesEnd) {
  const dvvCResult = findBox(sampleEntriesEnd, ['dvvC']); // used by DoVi Profile 8 to 10
  const dvXCBox = dvvCResult.length ? dvvCResult[0] : findBox(sampleEntriesEnd, ['dvcC'])[0]; // used by DoVi Profiles up to 7 and 20
  if (dvXCBox) {
    const doViProfile = dvXCBox[2] >> 1 & 0x7f;
    const doViLevel = dvXCBox[2] << 5 & 0x20 | dvXCBox[3] >> 3 & 0x1f;
    return fourCC + '.' + addLeadingZero(doViProfile) + '.' + addLeadingZero(doViLevel);
  }
}
function reverse32BitInt(val) {
  let result = 0;
  for (let i = 0; i < 32; i++) {
    result |= (val >> i & 1) << 32 - 1 - i;
  }
  return result >>> 0;
}
function skipBERInteger(bytes, i) {
  const limit = i + 5;
  while (bytes[i++] & 0x80 && i < limit) {
    /* do nothing */
  }
  return i;
}
function toHex(x) {
  return ('0' + x.toString(16).toUpperCase()).slice(-2);
}
function addLeadingZero(num) {
  return (num < 10 ? '0' : '') + num;
}
function patchEncyptionData(initSegment, decryptdata) {
  if (!initSegment || !decryptdata) {
    return initSegment;
  }
  const keyId = decryptdata.keyId;
  if (keyId && decryptdata.isCommonEncryption) {
    const traks = findBox(initSegment, ['moov', 'trak']);
    traks.forEach(trak => {
      const stsd = findBox(trak, ['mdia', 'minf', 'stbl', 'stsd'])[0];

      // skip the sample entry count
      const sampleEntries = stsd.subarray(8);
      let encBoxes = findBox(sampleEntries, ['enca']);
      const isAudio = encBoxes.length > 0;
      if (!isAudio) {
        encBoxes = findBox(sampleEntries, ['encv']);
      }
      encBoxes.forEach(enc => {
        const encBoxChildren = isAudio ? enc.subarray(28) : enc.subarray(78);
        const sinfBoxes = findBox(encBoxChildren, ['sinf']);
        sinfBoxes.forEach(sinf => {
          const tenc = parseSinf(sinf);
          if (tenc) {
            // Look for default key id (keyID offset is always 8 within the tenc box):
            const tencKeyId = tenc.subarray(8, 24);
            if (!tencKeyId.some(b => b !== 0)) {
              hls_logger.log(`[eme] Patching keyId in 'enc${isAudio ? 'a' : 'v'}>sinf>>tenc' box: ${Hex.hexDump(tencKeyId)} -> ${Hex.hexDump(keyId)}`);
              tenc.set(keyId, 8);
            }
          }
        });
      });
    });
  }
  return initSegment;
}
function parseSinf(sinf) {
  const schm = findBox(sinf, ['schm'])[0];
  if (schm) {
    const scheme = bin2str(schm.subarray(4, 8));
    if (scheme === 'cbcs' || scheme === 'cenc') {
      return findBox(sinf, ['schi', 'tenc'])[0];
    }
  }
  return null;
}

/*
  For Reference:
  aligned(8) class TrackFragmentHeaderBox
           extends FullBox(‘tfhd’, 0, tf_flags){
     unsigned int(32)  track_ID;
     // all the following are optional fields
     unsigned int(64)  base_data_offset;
     unsigned int(32)  sample_description_index;
     unsigned int(32)  default_sample_duration;
     unsigned int(32)  default_sample_size;
     unsigned int(32)  default_sample_flags
  }
 */

function getSampleData(data, initData, logger) {
  const tracks = {};
  const trafs = findBox(data, ['moof', 'traf']);
  for (let i = 0; i < trafs.length; i++) {
    const traf = trafs[i];
    // There is only one tfhd & trun per traf
    // This is true for CMAF style content, and we should perhaps check the ftyp
    // and only look for a single trun then, but for ISOBMFF we should check
    // for multiple track runs.
    const tfhd = findBox(traf, ['tfhd'])[0];
    // get the track id from the tfhd
    const id = readUint32(tfhd, 4);
    const track = initData[id];
    if (!track) {
      continue;
    }
    const trackTimes = tracks[id] || (tracks[id] = {
      start: NaN,
      duration: 0,
      sampleCount: 0,
      timescale: track.timescale,
      type: track.type
    });
    // get start DTS
    const tfdt = findBox(traf, ['tfdt'])[0];
    if (tfdt) {
      const version = tfdt[0];
      let baseTime = readUint32(tfdt, 4);
      if (version === 1) {
        // If value is too large, assume signed 64-bit. Negative track fragment decode times are invalid, but they exist in the wild.
        // This prevents large values from being used for initPTS, which can cause playlist sync issues.
        // https://github.com/video-dev/hls.js/issues/5303
        if (baseTime === UINT32_MAX$1) {
          logger.warn(`[mp4-demuxer]: Ignoring assumed invalid signed 64-bit track fragment decode time`);
        } else {
          baseTime *= UINT32_MAX$1 + 1;
          baseTime += readUint32(tfdt, 8);
        }
      }
      if (isFiniteNumber(baseTime) && (!isFiniteNumber(trackTimes.start) || baseTime < trackTimes.start)) {
        trackTimes.start = baseTime;
      }
    }
    const trackDefault = track.default;
    const tfhdFlags = readUint32(tfhd, 0) | (trackDefault == null ? void 0 : trackDefault.flags);
    let defaultSampleDuration = (trackDefault == null ? void 0 : trackDefault.duration) || 0;
    if (tfhdFlags & 0x000008) {
      // 0x000008 indicates the presence of the default_sample_duration field
      if (tfhdFlags & 0x000002) {
        // 0x000002 indicates the presence of the sample_description_index field, which precedes default_sample_duration
        // If present, the default_sample_duration exists at byte offset 12
        defaultSampleDuration = readUint32(tfhd, 12);
      } else {
        // Otherwise, the duration is at byte offset 8
        defaultSampleDuration = readUint32(tfhd, 8);
      }
    }
    const truns = findBox(traf, ['trun']);
    let sampleDTS = trackTimes.start || 0;
    let rawDuration = 0;
    let sampleDuration = defaultSampleDuration;
    for (let j = 0; j < truns.length; j++) {
      const trun = truns[j];
      const sampleCount = readUint32(trun, 4);
      const sampleIndex = trackTimes.sampleCount;
      trackTimes.sampleCount += sampleCount;
      // Get duration from samples
      const dataOffsetPresent = trun[3] & 0x01;
      const firstSampleFlagsPresent = trun[3] & 0x04;
      const sampleDurationPresent = trun[2] & 0x01;
      const sampleSizePresent = trun[2] & 0x02;
      const sampleFlagsPresent = trun[2] & 0x04;
      const sampleCompositionTimeOffsetPresent = trun[2] & 0x08;
      let offset = 8;
      let remaining = sampleCount;
      if (dataOffsetPresent) {
        offset += 4;
      }
      if (firstSampleFlagsPresent && sampleCount) {
        const isNonSyncSample = trun[offset + 1] & 0x01;
        if (!isNonSyncSample && trackTimes.keyFrameIndex === undefined) {
          trackTimes.keyFrameIndex = sampleIndex;
        }
        offset += 4;
        if (sampleDurationPresent) {
          sampleDuration = readUint32(trun, offset);
          offset += 4;
        } else {
          sampleDuration = defaultSampleDuration;
        }
        if (sampleSizePresent) {
          offset += 4;
        }
        if (sampleCompositionTimeOffsetPresent) {
          offset += 4;
        }
        sampleDTS += sampleDuration;
        rawDuration += sampleDuration;
        remaining--;
      }
      while (remaining--) {
        if (sampleDurationPresent) {
          sampleDuration = readUint32(trun, offset);
          offset += 4;
        } else {
          sampleDuration = defaultSampleDuration;
        }
        if (sampleSizePresent) {
          offset += 4;
        }
        if (sampleFlagsPresent) {
          const isNonSyncSample = trun[offset + 1] & 0x01;
          if (!isNonSyncSample) {
            if (trackTimes.keyFrameIndex === undefined) {
              trackTimes.keyFrameIndex = trackTimes.sampleCount - (remaining + 1);
              trackTimes.keyFrameStart = sampleDTS;
            }
          }
          offset += 4;
        }
        if (sampleCompositionTimeOffsetPresent) {
          offset += 4;
        }
        sampleDTS += sampleDuration;
        rawDuration += sampleDuration;
      }
      if (!rawDuration && defaultSampleDuration) {
        rawDuration += defaultSampleDuration * sampleCount;
      }
    }
    trackTimes.duration += rawDuration;
  }
  if (!Object.keys(tracks).some(trackId => tracks[trackId].duration)) {
    // If duration samples are not available in the traf use sidx subsegment_duration
    let sidxMinStart = Infinity;
    let sidxMaxEnd = 0;
    const sidxs = findBox(data, ['sidx']);
    for (let i = 0; i < sidxs.length; i++) {
      const sidx = parseSegmentIndex(sidxs[i]);
      if (sidx != null && sidx.references) {
        sidxMinStart = Math.min(sidxMinStart, sidx.earliestPresentationTime / sidx.timescale);
        const subSegmentDuration = sidx.references.reduce((dur, ref) => dur + ref.info.duration || 0, 0);
        sidxMaxEnd = Math.max(sidxMaxEnd, subSegmentDuration + sidx.earliestPresentationTime / sidx.timescale);
      }
    }
    if (sidxMaxEnd && isFiniteNumber(sidxMaxEnd)) {
      Object.keys(tracks).forEach(trackId => {
        if (!tracks[trackId].duration) {
          tracks[trackId].duration = sidxMaxEnd * tracks[trackId].timescale - tracks[trackId].start;
        }
      });
    }
  }
  return tracks;
}

// TODO: Remove `offsetStartDTS` in favor of using `timestampOffset` (issue #5715)
function offsetStartDTS(initData, fmp4, timeOffset) {
  findBox(fmp4, ['moof', 'traf']).forEach(traf => {
    findBox(traf, ['tfhd']).forEach(tfhd => {
      // get the track id from the tfhd
      const id = readUint32(tfhd, 4);
      const track = initData[id];
      if (!track) {
        return;
      }
      // assume a 90kHz clock if no timescale was specified
      const timescale = track.timescale || 90e3;
      // get the base media decode time from the tfdt
      findBox(traf, ['tfdt']).forEach(tfdt => {
        const version = tfdt[0];
        const offset = timeOffset * timescale;
        if (offset) {
          let baseMediaDecodeTime = readUint32(tfdt, 4);
          if (version === 0) {
            baseMediaDecodeTime -= offset;
            baseMediaDecodeTime = Math.max(baseMediaDecodeTime, 0);
            writeUint32(tfdt, 4, baseMediaDecodeTime);
          } else {
            baseMediaDecodeTime *= Math.pow(2, 32);
            baseMediaDecodeTime += readUint32(tfdt, 8);
            baseMediaDecodeTime -= offset;
            baseMediaDecodeTime = Math.max(baseMediaDecodeTime, 0);
            const upper = Math.floor(baseMediaDecodeTime / (UINT32_MAX$1 + 1));
            const lower = Math.floor(baseMediaDecodeTime % (UINT32_MAX$1 + 1));
            writeUint32(tfdt, 4, upper);
            writeUint32(tfdt, 8, lower);
          }
        }
      });
    });
  });
}

// TODO: Check if the last moof+mdat pair is part of the valid range
function segmentValidRange(data) {
  const segmentedRange = {
    valid: null,
    remainder: null
  };
  const moofs = findBox(data, ['moof']);
  if (moofs.length < 2) {
    segmentedRange.remainder = data;
    return segmentedRange;
  }
  const last = moofs[moofs.length - 1];
  // Offset by 8 bytes; findBox offsets the start by as much
  segmentedRange.valid = data.slice(0, last.byteOffset - 8);
  segmentedRange.remainder = data.slice(last.byteOffset - 8);
  return segmentedRange;
}
function appendUint8Array(data1, data2) {
  const temp = new Uint8Array(data1.length + data2.length);
  temp.set(data1);
  temp.set(data2, data1.length);
  return temp;
}
function parseSamples(timeOffset, track) {
  const seiSamples = [];
  const videoData = track.samples;
  const timescale = track.timescale;
  const trackId = track.id;
  let isHEVCFlavor = false;
  const moofs = findBox(videoData, ['moof']);
  moofs.map(moof => {
    const moofOffset = moof.byteOffset - 8;
    const trafs = findBox(moof, ['traf']);
    trafs.map(traf => {
      // get the base media decode time from the tfdt
      const baseTime = findBox(traf, ['tfdt']).map(tfdt => {
        const version = tfdt[0];
        let result = readUint32(tfdt, 4);
        if (version === 1) {
          result *= Math.pow(2, 32);
          result += readUint32(tfdt, 8);
        }
        return result / timescale;
      })[0];
      if (baseTime !== undefined) {
        timeOffset = baseTime;
      }
      return findBox(traf, ['tfhd']).map(tfhd => {
        const id = readUint32(tfhd, 4);
        const tfhdFlags = readUint32(tfhd, 0) & 0xffffff;
        const baseDataOffsetPresent = (tfhdFlags & 0x000001) !== 0;
        const sampleDescriptionIndexPresent = (tfhdFlags & 0x000002) !== 0;
        const defaultSampleDurationPresent = (tfhdFlags & 0x000008) !== 0;
        let defaultSampleDuration = 0;
        const defaultSampleSizePresent = (tfhdFlags & 0x000010) !== 0;
        let defaultSampleSize = 0;
        const defaultSampleFlagsPresent = (tfhdFlags & 0x000020) !== 0;
        let tfhdOffset = 8;
        if (id === trackId) {
          if (baseDataOffsetPresent) {
            tfhdOffset += 8;
          }
          if (sampleDescriptionIndexPresent) {
            tfhdOffset += 4;
          }
          if (defaultSampleDurationPresent) {
            defaultSampleDuration = readUint32(tfhd, tfhdOffset);
            tfhdOffset += 4;
          }
          if (defaultSampleSizePresent) {
            defaultSampleSize = readUint32(tfhd, tfhdOffset);
            tfhdOffset += 4;
          }
          if (defaultSampleFlagsPresent) {
            tfhdOffset += 4;
          }
          if (track.type === 'video') {
            isHEVCFlavor = isHEVC(track.codec);
          }
          findBox(traf, ['trun']).map(trun => {
            const version = trun[0];
            const flags = readUint32(trun, 0) & 0xffffff;
            const dataOffsetPresent = (flags & 0x000001) !== 0;
            let dataOffset = 0;
            const firstSampleFlagsPresent = (flags & 0x000004) !== 0;
            const sampleDurationPresent = (flags & 0x000100) !== 0;
            let sampleDuration = 0;
            const sampleSizePresent = (flags & 0x000200) !== 0;
            let sampleSize = 0;
            const sampleFlagsPresent = (flags & 0x000400) !== 0;
            const sampleCompositionOffsetsPresent = (flags & 0x000800) !== 0;
            let compositionOffset = 0;
            const sampleCount = readUint32(trun, 4);
            let trunOffset = 8; // past version, flags, and sample count

            if (dataOffsetPresent) {
              dataOffset = readUint32(trun, trunOffset);
              trunOffset += 4;
            }
            if (firstSampleFlagsPresent) {
              trunOffset += 4;
            }
            let sampleOffset = dataOffset + moofOffset;
            for (let ix = 0; ix < sampleCount; ix++) {
              if (sampleDurationPresent) {
                sampleDuration = readUint32(trun, trunOffset);
                trunOffset += 4;
              } else {
                sampleDuration = defaultSampleDuration;
              }
              if (sampleSizePresent) {
                sampleSize = readUint32(trun, trunOffset);
                trunOffset += 4;
              } else {
                sampleSize = defaultSampleSize;
              }
              if (sampleFlagsPresent) {
                trunOffset += 4;
              }
              if (sampleCompositionOffsetsPresent) {
                if (version === 0) {
                  compositionOffset = readUint32(trun, trunOffset);
                } else {
                  compositionOffset = readSint32(trun, trunOffset);
                }
                trunOffset += 4;
              }
              if (track.type === ElementaryStreamTypes.VIDEO) {
                let naluTotalSize = 0;
                while (naluTotalSize < sampleSize) {
                  const naluSize = readUint32(videoData, sampleOffset);
                  sampleOffset += 4;
                  if (isSEIMessage(isHEVCFlavor, videoData[sampleOffset])) {
                    const data = videoData.subarray(sampleOffset, sampleOffset + naluSize);
                    parseSEIMessageFromNALu(data, isHEVCFlavor ? 2 : 1, timeOffset + compositionOffset / timescale, seiSamples);
                  }
                  sampleOffset += naluSize;
                  naluTotalSize += naluSize + 4;
                }
              }
              timeOffset += sampleDuration / timescale;
            }
          });
        }
      });
    });
  });
  return seiSamples;
}
function isHEVC(codec) {
  if (!codec) {
    return false;
  }
  const baseCodec = codec.substring(0, 4);
  return baseCodec === 'hvc1' || baseCodec === 'hev1' ||
  // Dolby Vision
  baseCodec === 'dvh1' || baseCodec === 'dvhe';
}
function isSEIMessage(isHEVCFlavor, naluHeader) {
  if (isHEVCFlavor) {
    const naluType = naluHeader >> 1 & 0x3f;
    return naluType === 39 || naluType === 40;
  } else {
    const naluType = naluHeader & 0x1f;
    return naluType === 6;
  }
}
function parseSEIMessageFromNALu(unescapedData, headerSize, pts, samples) {
  const data = discardEPB(unescapedData);
  let seiPtr = 0;
  // skip nal header
  seiPtr += headerSize;
  let payloadType = 0;
  let payloadSize = 0;
  let b = 0;
  while (seiPtr < data.length) {
    payloadType = 0;
    do {
      if (seiPtr >= data.length) {
        break;
      }
      b = data[seiPtr++];
      payloadType += b;
    } while (b === 0xff);

    // Parse payload size.
    payloadSize = 0;
    do {
      if (seiPtr >= data.length) {
        break;
      }
      b = data[seiPtr++];
      payloadSize += b;
    } while (b === 0xff);
    const leftOver = data.length - seiPtr;
    // Create a variable to process the payload
    let payPtr = seiPtr;

    // Increment the seiPtr to the end of the payload
    if (payloadSize < leftOver) {
      seiPtr += payloadSize;
    } else if (payloadSize > leftOver) {
      // Some type of corruption has happened?
      hls_logger.error(`Malformed SEI payload. ${payloadSize} is too small, only ${leftOver} bytes left to parse.`);
      // We might be able to parse some data, but let's be safe and ignore it.
      break;
    }
    if (payloadType === 4) {
      const countryCode = data[payPtr++];
      if (countryCode === 181) {
        const providerCode = readUint16(data, payPtr);
        payPtr += 2;
        if (providerCode === 49) {
          const userStructure = readUint32(data, payPtr);
          payPtr += 4;
          if (userStructure === 0x47413934) {
            const userDataType = data[payPtr++];

            // Raw CEA-608 bytes wrapped in CEA-708 packet
            if (userDataType === 3) {
              const firstByte = data[payPtr++];
              const totalCCs = 0x1f & firstByte;
              const enabled = 0x40 & firstByte;
              const totalBytes = enabled ? 2 + totalCCs * 3 : 0;
              const byteArray = new Uint8Array(totalBytes);
              if (enabled) {
                byteArray[0] = firstByte;
                for (let i = 1; i < totalBytes; i++) {
                  byteArray[i] = data[payPtr++];
                }
              }
              samples.push({
                type: userDataType,
                payloadType,
                pts,
                bytes: byteArray
              });
            }
          }
        }
      }
    } else if (payloadType === 5) {
      if (payloadSize > 16) {
        const uuidStrArray = [];
        for (let i = 0; i < 16; i++) {
          const _b = data[payPtr++].toString(16);
          uuidStrArray.push(_b.length == 1 ? '0' + _b : _b);
          if (i === 3 || i === 5 || i === 7 || i === 9) {
            uuidStrArray.push('-');
          }
        }
        const length = payloadSize - 16;
        const userDataBytes = new Uint8Array(length);
        for (let i = 0; i < length; i++) {
          userDataBytes[i] = data[payPtr++];
        }
        samples.push({
          payloadType,
          pts,
          uuid: uuidStrArray.join(''),
          userData: utf8ArrayToStr(userDataBytes),
          userDataBytes
        });
      }
    }
  }
}

/**
 * remove Emulation Prevention bytes from a RBSP
 */
function discardEPB(data) {
  const length = data.byteLength;
  const EPBPositions = [];
  let i = 1;

  // Find all `Emulation Prevention Bytes`
  while (i < length - 2) {
    if (data[i] === 0 && data[i + 1] === 0 && data[i + 2] === 0x03) {
      EPBPositions.push(i + 2);
      i += 2;
    } else {
      i++;
    }
  }

  // If no Emulation Prevention Bytes were found just return the original
  // array
  if (EPBPositions.length === 0) {
    return data;
  }

  // Create a new array to hold the NAL unit data
  const newLength = length - EPBPositions.length;
  const newData = new Uint8Array(newLength);
  let sourceIndex = 0;
  for (i = 0; i < newLength; sourceIndex++, i++) {
    if (sourceIndex === EPBPositions[0]) {
      // Skip this byte
      sourceIndex++;
      // Remove this position index
      EPBPositions.shift();
    }
    newData[i] = data[sourceIndex];
  }
  return newData;
}
function parseEmsg(data) {
  const version = data[0];
  let schemeIdUri = '';
  let value = '';
  let timeScale = 0;
  let presentationTimeDelta = 0;
  let presentationTime = 0;
  let eventDuration = 0;
  let id = 0;
  let offset = 0;
  if (version === 0) {
    while (bin2str(data.subarray(offset, offset + 1)) !== '\0') {
      schemeIdUri += bin2str(data.subarray(offset, offset + 1));
      offset += 1;
    }
    schemeIdUri += bin2str(data.subarray(offset, offset + 1));
    offset += 1;
    while (bin2str(data.subarray(offset, offset + 1)) !== '\0') {
      value += bin2str(data.subarray(offset, offset + 1));
      offset += 1;
    }
    value += bin2str(data.subarray(offset, offset + 1));
    offset += 1;
    timeScale = readUint32(data, 12);
    presentationTimeDelta = readUint32(data, 16);
    eventDuration = readUint32(data, 20);
    id = readUint32(data, 24);
    offset = 28;
  } else if (version === 1) {
    offset += 4;
    timeScale = readUint32(data, offset);
    offset += 4;
    const leftPresentationTime = readUint32(data, offset);
    offset += 4;
    const rightPresentationTime = readUint32(data, offset);
    offset += 4;
    presentationTime = 2 ** 32 * leftPresentationTime + rightPresentationTime;
    if (!isSafeInteger(presentationTime)) {
      presentationTime = Number.MAX_SAFE_INTEGER;
      hls_logger.warn('Presentation time exceeds safe integer limit and wrapped to max safe integer in parsing emsg box');
    }
    eventDuration = readUint32(data, offset);
    offset += 4;
    id = readUint32(data, offset);
    offset += 4;
    while (bin2str(data.subarray(offset, offset + 1)) !== '\0') {
      schemeIdUri += bin2str(data.subarray(offset, offset + 1));
      offset += 1;
    }
    schemeIdUri += bin2str(data.subarray(offset, offset + 1));
    offset += 1;
    while (bin2str(data.subarray(offset, offset + 1)) !== '\0') {
      value += bin2str(data.subarray(offset, offset + 1));
      offset += 1;
    }
    value += bin2str(data.subarray(offset, offset + 1));
    offset += 1;
  }
  const payload = data.subarray(offset, data.byteLength);
  return {
    schemeIdUri,
    value,
    timeScale,
    presentationTime,
    presentationTimeDelta,
    eventDuration,
    id,
    payload
  };
}
function mp4Box(type, ...payload) {
  const len = payload.length;
  let size = 8;
  let i = len;
  while (i--) {
    size += payload[i].byteLength;
  }
  const result = new Uint8Array(size);
  result[0] = size >> 24 & 0xff;
  result[1] = size >> 16 & 0xff;
  result[2] = size >> 8 & 0xff;
  result[3] = size & 0xff;
  result.set(type, 4);
  for (i = 0, size = 8; i < len; i++) {
    result.set(payload[i], size);
    size += payload[i].byteLength;
  }
  return result;
}
function mp4pssh(systemId, keyids, data) {
  if (systemId.byteLength !== 16) {
    throw new RangeError('Invalid system id');
  }
  let version;
  let kids;
  {
    version = 0;
    kids = new Uint8Array();
  }
  let kidCount;
  if (version > 0) {
    kidCount = new Uint8Array(4);
    if (keyids.length > 0) {
      new DataView(kidCount.buffer).setUint32(0, keyids.length, false);
    }
  } else {
    kidCount = new Uint8Array();
  }
  const dataSize = new Uint8Array(4);
  if (data && data.byteLength > 0) {
    new DataView(dataSize.buffer).setUint32(0, data.byteLength, false);
  }
  return mp4Box([112, 115, 115, 104], new Uint8Array([version, 0x00, 0x00, 0x00 // Flags
  ]), systemId,
  // 16 bytes
  kidCount, kids, dataSize, data || new Uint8Array());
}
function parseMultiPssh(initData) {
  const results = [];
  if (initData instanceof ArrayBuffer) {
    const length = initData.byteLength;
    let offset = 0;
    while (offset + 32 < length) {
      const view = new DataView(initData, offset);
      const pssh = parsePssh(view);
      results.push(pssh);
      offset += pssh.size;
    }
  }
  return results;
}
function parsePssh(view) {
  const size = view.getUint32(0);
  const offset = view.byteOffset;
  const length = view.byteLength;
  if (length < size) {
    return {
      offset,
      size: length
    };
  }
  const type = view.getUint32(4);
  if (type !== 0x70737368) {
    return {
      offset,
      size
    };
  }
  const version = view.getUint32(8) >>> 24;
  if (version !== 0 && version !== 1) {
    return {
      offset,
      size
    };
  }
  const buffer = view.buffer;
  const systemId = Hex.hexDump(new Uint8Array(buffer, offset + 12, 16));
  const dataSizeOrKidCount = view.getUint32(28);
  let kids = null;
  let data = null;
  if (version === 0) {
    if (size - 32 < dataSizeOrKidCount || dataSizeOrKidCount < 22) {
      return {
        offset,
        size
      };
    }
    data = new Uint8Array(buffer, offset + 32, dataSizeOrKidCount);
  } else if (version === 1) {
    if (!dataSizeOrKidCount || length < offset + 32 + dataSizeOrKidCount * 16 + 16) {
      return {
        offset,
        size
      };
    }
    kids = [];
    for (let i = 0; i < dataSizeOrKidCount; i++) {
      kids.push(new Uint8Array(buffer, offset + 32 + i * 16, 16));
    }
  }
  return {
    version,
    systemId,
    kids,
    data,
    offset,
    size
  };
}

const userAgentHevcSupportIsInaccurate = () => {
  return /\(Windows.+Firefox\//i.test(navigator.userAgent);
};

// from http://mp4ra.org/codecs.html
// values indicate codec selection preference (lower is higher priority)
const sampleEntryCodesISO = {
  audio: {
    a3ds: 1,
    'ac-3': 0.95,
    'ac-4': 1,
    alac: 0.9,
    alaw: 1,
    dra1: 1,
    'dts+': 1,
    'dts-': 1,
    dtsc: 1,
    dtse: 1,
    dtsh: 1,
    'ec-3': 0.9,
    enca: 1,
    fLaC: 0.9,
    // MP4-RA listed codec entry for FLAC
    flac: 0.9,
    // legacy browser codec name for FLAC
    FLAC: 0.9,
    // some manifests may list "FLAC" with Apple's tools
    g719: 1,
    g726: 1,
    m4ae: 1,
    mha1: 1,
    mha2: 1,
    mhm1: 1,
    mhm2: 1,
    mlpa: 1,
    mp4a: 1,
    'raw ': 1,
    Opus: 1,
    opus: 1,
    // browsers expect this to be lowercase despite MP4RA says 'Opus'
    samr: 1,
    sawb: 1,
    sawp: 1,
    sevc: 1,
    sqcp: 1,
    ssmv: 1,
    twos: 1,
    ulaw: 1
  },
  video: {
    avc1: 1,
    avc2: 1,
    avc3: 1,
    avc4: 1,
    avcp: 1,
    av01: 0.8,
    dav1: 0.8,
    drac: 1,
    dva1: 1,
    dvav: 1,
    dvh1: 0.7,
    dvhe: 0.7,
    encv: 1,
    hev1: 0.75,
    hvc1: 0.75,
    mjp2: 1,
    mp4v: 1,
    mvc1: 1,
    mvc2: 1,
    mvc3: 1,
    mvc4: 1,
    resv: 1,
    rv60: 1,
    s263: 1,
    svc1: 1,
    svc2: 1,
    'vc-1': 1,
    vp08: 1,
    vp09: 0.9
  },
  text: {
    stpp: 1,
    wvtt: 1
  }
};
function isCodecType(codec, type) {
  const typeCodes = sampleEntryCodesISO[type];
  return !!typeCodes && !!typeCodes[codec.slice(0, 4)];
}
function areCodecsMediaSourceSupported(codecs, type, preferManagedMediaSource = true) {
  return !codecs.split(',').some(codec => !isCodecMediaSourceSupported(codec, type, preferManagedMediaSource));
}
function isCodecMediaSourceSupported(codec, type, preferManagedMediaSource = true) {
  var _MediaSource$isTypeSu;
  const MediaSource = getMediaSource(preferManagedMediaSource);
  return (_MediaSource$isTypeSu = MediaSource == null ? void 0 : MediaSource.isTypeSupported(mimeTypeForCodec(codec, type))) != null ? _MediaSource$isTypeSu : false;
}
function mimeTypeForCodec(codec, type) {
  return `${type}/mp4;codecs=${codec}`;
}
function videoCodecPreferenceValue(videoCodec) {
  if (videoCodec) {
    const fourCC = videoCodec.substring(0, 4);
    return sampleEntryCodesISO.video[fourCC];
  }
  return 2;
}
function codecsSetSelectionPreferenceValue(codecSet) {
  const limitedHevcSupport = userAgentHevcSupportIsInaccurate();
  return codecSet.split(',').reduce((num, fourCC) => {
    const lowerPriority = limitedHevcSupport && isHEVC(fourCC);
    const preferenceValue = lowerPriority ? 9 : sampleEntryCodesISO.video[fourCC];
    if (preferenceValue) {
      return (preferenceValue * 2 + num) / (num ? 3 : 2);
    }
    return (sampleEntryCodesISO.audio[fourCC] + num) / (num ? 2 : 1);
  }, 0);
}
const CODEC_COMPATIBLE_NAMES = {};
function getCodecCompatibleNameLower(lowerCaseCodec, preferManagedMediaSource = true) {
  if (CODEC_COMPATIBLE_NAMES[lowerCaseCodec]) {
    return CODEC_COMPATIBLE_NAMES[lowerCaseCodec];
  }
  const codecsToCheck = {
    // Idealy fLaC and Opus would be first (spec-compliant) but
    // some browsers will report that fLaC is supported then fail.
    // see: https://bugs.chromium.org/p/chromium/issues/detail?id=1422728
    flac: ['flac', 'fLaC', 'FLAC'],
    opus: ['opus', 'Opus'],
    // Replace audio codec info if browser does not support mp4a.40.34,
    // and demuxer can fallback to 'audio/mpeg' or 'audio/mp4;codecs="mp3"'
    'mp4a.40.34': ['mp3']
  }[lowerCaseCodec];
  for (let i = 0; i < codecsToCheck.length; i++) {
    var _getMediaSource;
    if (isCodecMediaSourceSupported(codecsToCheck[i], 'audio', preferManagedMediaSource)) {
      CODEC_COMPATIBLE_NAMES[lowerCaseCodec] = codecsToCheck[i];
      return codecsToCheck[i];
    } else if (codecsToCheck[i] === 'mp3' && (_getMediaSource = getMediaSource(preferManagedMediaSource)) != null && _getMediaSource.isTypeSupported('audio/mpeg')) {
      return '';
    }
  }
  return lowerCaseCodec;
}
const AUDIO_CODEC_REGEXP = /flac|opus|mp4a\.40\.34/i;
function getCodecCompatibleName(codec, preferManagedMediaSource = true) {
  return codec.replace(AUDIO_CODEC_REGEXP, m => getCodecCompatibleNameLower(m.toLowerCase(), preferManagedMediaSource));
}
function replaceVideoCodec(originalCodecs, newVideoCodec) {
  const codecs = [];
  if (originalCodecs) {
    const allCodecs = originalCodecs.split(',');
    for (let i = 0; i < allCodecs.length; i++) {
      if (!isCodecType(allCodecs[i], 'video')) {
        codecs.push(allCodecs[i]);
      }
    }
  }
  if (newVideoCodec) {
    codecs.push(newVideoCodec);
  }
  return codecs.join(',');
}
function pickMostCompleteCodecName(parsedCodec, levelCodec) {
  // Parsing of mp4a codecs strings in mp4-tools from media is incomplete as of d8c6c7a
  // so use level codec is parsed codec is unavailable or incomplete
  if (parsedCodec && (parsedCodec.length > 4 || ['ac-3', 'ec-3', 'alac', 'fLaC', 'Opus'].indexOf(parsedCodec) !== -1)) {
    return parsedCodec;
  }
  if (levelCodec) {
    const levelCodecs = levelCodec.split(',');
    if (levelCodecs.length > 1) {
      if (parsedCodec) {
        for (let i = levelCodecs.length; i--;) {
          if (levelCodecs[i].substring(0, 4) === parsedCodec.substring(0, 4)) {
            return levelCodecs[i];
          }
        }
      }
      return levelCodecs[0];
    }
  }
  return levelCodec || parsedCodec;
}
function convertAVC1ToAVCOTI(videoCodecs) {
  // Convert avc1 codec string from RFC-4281 to RFC-6381 for MediaSource.isTypeSupported
  // Examples: avc1.66.30 to avc1.42001e and avc1.77.30,avc1.66.30 to avc1.4d001e,avc1.42001e.
  const codecs = videoCodecs.split(',');
  for (let i = 0; i < codecs.length; i++) {
    const avcdata = codecs[i].split('.');
    // only convert codec strings starting with avc1 (Examples: avc1.64001f,dvh1.05.07)
    if (avcdata.length > 2 && avcdata[0] === 'avc1') {
      codecs[i] = `avc1.${parseInt(avcdata[1]).toString(16)}${('000' + parseInt(avcdata[2]).toString(16)).slice(-4)}`;
    }
  }
  return codecs.join(',');
}
function fillInMissingAV01Params(videoCodec) {
  // Used to fill in incomplete AV1 playlist CODECS strings for mediaCapabilities.decodingInfo queries
  if (videoCodec.startsWith('av01.')) {
    const av1params = videoCodec.split('.');
    const placeholders = ['0', '111', '01', '01', '01', '0'];
    for (let i = av1params.length; i > 4 && i < 10; i++) {
      av1params[i] = placeholders[i - 4];
    }
    return av1params.join('.');
  }
  return videoCodec;
}
function getM2TSSupportedAudioTypes(preferManagedMediaSource) {
  const MediaSource = getMediaSource(preferManagedMediaSource) || {
    isTypeSupported: () => false
  };
  return {
    mpeg: MediaSource.isTypeSupported('audio/mpeg'),
    mp3: MediaSource.isTypeSupported('audio/mp4; codecs="mp3"'),
    ac3: MediaSource.isTypeSupported('audio/mp4; codecs="ac-3"') 
  };
}
function getCodecsForMimeType(mimeType) {
  return mimeType.replace(/^.+codecs=["']?([^"']+).*$/, '$1');
}

const SUPPORTED_INFO_DEFAULT = {
  supported: true,
  configurations: [],
  decodingInfoResults: [{
    supported: true,
    powerEfficient: true,
    smooth: true
  }]
};
function getUnsupportedResult(error, configurations) {
  return {
    supported: false,
    configurations,
    decodingInfoResults: [{
      supported: false,
      smooth: false,
      powerEfficient: false
    }],
    error
  };
}
const SUPPORTED_INFO_CACHE = {};
function requiresMediaCapabilitiesDecodingInfo(level, audioTracksByGroup, currentVideoRange, currentFrameRate, currentBw, audioPreference) {
  // Only test support when configuration is exceeds minimum options
  const audioGroups = level.audioCodec ? level.audioGroups : null;
  const audioCodecPreference = audioPreference == null ? void 0 : audioPreference.audioCodec;
  const channelsPreference = audioPreference == null ? void 0 : audioPreference.channels;
  const maxChannels = channelsPreference ? parseInt(channelsPreference) : audioCodecPreference ? Infinity : 2;
  let audioChannels = null;
  if (audioGroups != null && audioGroups.length) {
    try {
      if (audioGroups.length === 1 && audioGroups[0]) {
        audioChannels = audioTracksByGroup.groups[audioGroups[0]].channels;
      } else {
        audioChannels = audioGroups.reduce((acc, groupId) => {
          if (groupId) {
            const audioTrackGroup = audioTracksByGroup.groups[groupId];
            if (!audioTrackGroup) {
              throw new Error(`Audio track group ${groupId} not found`);
            }
            // Sum all channel key values
            Object.keys(audioTrackGroup.channels).forEach(key => {
              acc[key] = (acc[key] || 0) + audioTrackGroup.channels[key];
            });
          }
          return acc;
        }, {
          2: 0
        });
      }
    } catch (error) {
      return true;
    }
  }
  return level.videoCodec !== undefined && (level.width > 1920 && level.height > 1088 || level.height > 1920 && level.width > 1088 || level.frameRate > Math.max(currentFrameRate, 30) || level.videoRange !== 'SDR' && level.videoRange !== currentVideoRange || level.bitrate > Math.max(currentBw, 8e6)) || !!audioChannels && isFiniteNumber(maxChannels) && Object.keys(audioChannels).some(channels => parseInt(channels) > maxChannels);
}
function getMediaDecodingInfoPromise(level, audioTracksByGroup, mediaCapabilities) {
  const videoCodecs = level.videoCodec;
  const audioCodecs = level.audioCodec;
  if (!videoCodecs && !audioCodecs || !mediaCapabilities) {
    return Promise.resolve(SUPPORTED_INFO_DEFAULT);
  }
  const configurations = [];
  if (videoCodecs) {
    const baseVideoConfiguration = {
      width: level.width,
      height: level.height,
      bitrate: Math.ceil(Math.max(level.bitrate * 0.9, level.averageBitrate)),
      // Assume a framerate of 30fps since MediaCapabilities will not accept Level default of 0.
      framerate: level.frameRate || 30
    };
    const videoRange = level.videoRange;
    if (videoRange !== 'SDR') {
      baseVideoConfiguration.transferFunction = videoRange.toLowerCase();
    }
    const videoCodecsArray = videoCodecs.split(',');
    // Override Windows Firefox HEVC MediaCapabilities result (https://github.com/video-dev/hls.js/issues/7046)
    const ua = navigator.userAgent;
    if (videoCodecsArray.some(videoCodec => isHEVC(videoCodec)) && userAgentHevcSupportIsInaccurate()) {
      return Promise.resolve(getUnsupportedResult(new Error(`Overriding Windows Firefox HEVC MediaCapabilities result based on user-agent sting: (${ua})`), configurations));
    }
    configurations.push.apply(configurations, videoCodecsArray.map(videoCodec => ({
      type: 'media-source',
      video: _objectSpread2(_objectSpread2({}, baseVideoConfiguration), {}, {
        contentType: mimeTypeForCodec(fillInMissingAV01Params(videoCodec), 'video')
      })
    })));
  }
  if (audioCodecs && level.audioGroups) {
    level.audioGroups.forEach(audioGroupId => {
      var _audioTracksByGroup$g;
      if (!audioGroupId) {
        return;
      }
      (_audioTracksByGroup$g = audioTracksByGroup.groups[audioGroupId]) == null ? void 0 : _audioTracksByGroup$g.tracks.forEach(audioTrack => {
        if (audioTrack.groupId === audioGroupId) {
          const channels = audioTrack.channels || '';
          const channelsNumber = parseFloat(channels);
          if (isFiniteNumber(channelsNumber) && channelsNumber > 2) {
            configurations.push.apply(configurations, audioCodecs.split(',').map(audioCodec => ({
              type: 'media-source',
              audio: {
                contentType: mimeTypeForCodec(audioCodec, 'audio'),
                channels: '' + channelsNumber
                // spatialRendering:
                //   audioCodec === 'ec-3' && channels.indexOf('JOC'),
              }
            })));
          }
        }
      });
    });
  }
  return Promise.all(configurations.map(configuration => {
    // Cache MediaCapabilities promises
    const decodingInfoKey = getMediaDecodingInfoKey(configuration);
    return SUPPORTED_INFO_CACHE[decodingInfoKey] || (SUPPORTED_INFO_CACHE[decodingInfoKey] = mediaCapabilities.decodingInfo(configuration));
  })).then(decodingInfoResults => ({
    supported: !decodingInfoResults.some(info => !info.supported),
    configurations,
    decodingInfoResults
  })).catch(error => ({
    supported: false,
    configurations,
    decodingInfoResults: [],
    error
  }));
}
function getMediaDecodingInfoKey(config) {
  const {
    audio,
    video
  } = config;
  const mediaConfig = video || audio;
  if (mediaConfig) {
    const codec = getCodecsForMimeType(mediaConfig.contentType);
    if (video) {
      return `r${video.height}x${video.width}f${Math.ceil(video.framerate)}${video.transferFunction || 'sd'}_${codec}_${Math.ceil(video.bitrate / 1e5)}`;
    }
    if (audio) {
      return `c${audio.channels}${audio.spatialRendering ? 's' : 'n'}_${codec}`;
    }
  }
  return '';
}

const HdcpLevels = ['NONE', 'TYPE-0', 'TYPE-1', null];
function isHdcpLevel(value) {
  return HdcpLevels.indexOf(value) > -1;
}
const VideoRangeValues = ['SDR', 'PQ', 'HLG'];
function isVideoRange(value) {
  return !!value && VideoRangeValues.indexOf(value) > -1;
}
var HlsSkip = {
  No: "",
  Yes: "YES",
  v2: "v2"
};
function getSkipValue(details) {
  const {
    canSkipUntil,
    canSkipDateRanges,
    age
  } = details;
  // A Client SHOULD NOT request a Playlist Delta Update unless it already
  // has a version of the Playlist that is no older than one-half of the Skip Boundary.
  // @see: https://datatracker.ietf.org/doc/html/draft-pantos-hls-rfc8216bis#section-6.3.7
  const playlistRecentEnough = age < canSkipUntil / 2;
  if (canSkipUntil && playlistRecentEnough) {
    if (canSkipDateRanges) {
      return HlsSkip.v2;
    }
    return HlsSkip.Yes;
  }
  return HlsSkip.No;
}
class HlsUrlParameters {
  constructor(msn, part, skip) {
    this.msn = void 0;
    this.part = void 0;
    this.skip = void 0;
    this.msn = msn;
    this.part = part;
    this.skip = skip;
  }
  addDirectives(uri) {
    const url = new self.URL(uri);
    if (this.msn !== undefined) {
      url.searchParams.set('_HLS_msn', this.msn.toString());
    }
    if (this.part !== undefined) {
      url.searchParams.set('_HLS_part', this.part.toString());
    }
    if (this.skip) {
      url.searchParams.set('_HLS_skip', this.skip);
    }
    return url.href;
  }
}
class Level {
  constructor(data) {
    this._attrs = void 0;
    this.audioCodec = void 0;
    this.bitrate = void 0;
    this.codecSet = void 0;
    this.url = void 0;
    this.frameRate = void 0;
    this.height = void 0;
    this.id = void 0;
    this.name = void 0;
    this.supplemental = void 0;
    this.videoCodec = void 0;
    this.width = void 0;
    this.details = void 0;
    this.fragmentError = 0;
    this.loadError = 0;
    this.loaded = void 0;
    this.realBitrate = 0;
    this.supportedPromise = void 0;
    this.supportedResult = void 0;
    this._avgBitrate = 0;
    this._audioGroups = void 0;
    this._subtitleGroups = void 0;
    // Deprecated (retained for backwards compatibility)
    this._urlId = 0;
    this.url = [data.url];
    this._attrs = [data.attrs];
    this.bitrate = data.bitrate;
    if (data.details) {
      this.details = data.details;
    }
    this.id = data.id || 0;
    this.name = data.name;
    this.width = data.width || 0;
    this.height = data.height || 0;
    this.frameRate = data.attrs.optionalFloat('FRAME-RATE', 0);
    this._avgBitrate = data.attrs.decimalInteger('AVERAGE-BANDWIDTH');
    this.audioCodec = data.audioCodec;
    this.videoCodec = data.videoCodec;
    this.codecSet = [data.videoCodec, data.audioCodec].filter(c => !!c).map(s => s.substring(0, 4)).join(',');
    if ('supplemental' in data) {
      var _data$supplemental;
      this.supplemental = data.supplemental;
      const supplementalVideo = (_data$supplemental = data.supplemental) == null ? void 0 : _data$supplemental.videoCodec;
      if (supplementalVideo && supplementalVideo !== data.videoCodec) {
        this.codecSet += `,${supplementalVideo.substring(0, 4)}`;
      }
    }
    this.addGroupId('audio', data.attrs.AUDIO);
    this.addGroupId('text', data.attrs.SUBTITLES);
  }
  get maxBitrate() {
    return Math.max(this.realBitrate, this.bitrate);
  }
  get averageBitrate() {
    return this._avgBitrate || this.realBitrate || this.bitrate;
  }
  get attrs() {
    return this._attrs[0];
  }
  get codecs() {
    return this.attrs.CODECS || '';
  }
  get pathwayId() {
    return this.attrs['PATHWAY-ID'] || '.';
  }
  get videoRange() {
    return this.attrs['VIDEO-RANGE'] || 'SDR';
  }
  get score() {
    return this.attrs.optionalFloat('SCORE', 0);
  }
  get uri() {
    return this.url[0] || '';
  }
  hasAudioGroup(groupId) {
    return hasGroup(this._audioGroups, groupId);
  }
  hasSubtitleGroup(groupId) {
    return hasGroup(this._subtitleGroups, groupId);
  }
  get audioGroups() {
    return this._audioGroups;
  }
  get subtitleGroups() {
    return this._subtitleGroups;
  }
  addGroupId(type, groupId) {
    if (!groupId) {
      return;
    }
    if (type === 'audio') {
      let audioGroups = this._audioGroups;
      if (!audioGroups) {
        audioGroups = this._audioGroups = [];
      }
      if (audioGroups.indexOf(groupId) === -1) {
        audioGroups.push(groupId);
      }
    } else if (type === 'text') {
      let subtitleGroups = this._subtitleGroups;
      if (!subtitleGroups) {
        subtitleGroups = this._subtitleGroups = [];
      }
      if (subtitleGroups.indexOf(groupId) === -1) {
        subtitleGroups.push(groupId);
      }
    }
  }

  // Deprecated methods (retained for backwards compatibility)
  get urlId() {
    return 0;
  }
  set urlId(value) {}
  get audioGroupIds() {
    return this.audioGroups ? [this.audioGroupId] : undefined;
  }
  get textGroupIds() {
    return this.subtitleGroups ? [this.textGroupId] : undefined;
  }
  get audioGroupId() {
    var _this$audioGroups;
    return (_this$audioGroups = this.audioGroups) == null ? void 0 : _this$audioGroups[0];
  }
  get textGroupId() {
    var _this$subtitleGroups;
    return (_this$subtitleGroups = this.subtitleGroups) == null ? void 0 : _this$subtitleGroups[0];
  }
  addFallback() {}
}
function hasGroup(groups, groupId) {
  if (!groupId || !groups) {
    return false;
  }
  return groups.indexOf(groupId) !== -1;
}

/**
 * @returns Whether we can detect and validate HDR capability within the window context
 */
function isHdrSupported() {
  if (typeof matchMedia === 'function') {
    const mediaQueryList = matchMedia('(dynamic-range: high)');
    const badQuery = matchMedia('bad query');
    if (mediaQueryList.media !== badQuery.media) {
      return mediaQueryList.matches === true;
    }
  }
  return false;
}

/**
 * Sanitizes inputs to return the active video selection options for HDR/SDR.
 * When both inputs are null:
 *
 *    `{ preferHDR: false, allowedVideoRanges: [] }`
 *
 * When `currentVideoRange` non-null, maintain the active range:
 *
 *    `{ preferHDR: currentVideoRange !== 'SDR', allowedVideoRanges: [currentVideoRange] }`
 *
 * When VideoSelectionOption non-null:
 *
 *  - Allow all video ranges if `allowedVideoRanges` unspecified.
 *  - If `preferHDR` is non-null use the value to filter `allowedVideoRanges`.
 *  - Else check window for HDR support and set `preferHDR` to the result.
 *
 * @param currentVideoRange
 * @param videoPreference
 */
function getVideoSelectionOptions(currentVideoRange, videoPreference) {
  let preferHDR = false;
  let allowedVideoRanges = [];
  if (currentVideoRange) {
    preferHDR = currentVideoRange !== 'SDR';
    allowedVideoRanges = [currentVideoRange];
  }
  if (videoPreference) {
    allowedVideoRanges = videoPreference.allowedVideoRanges || VideoRangeValues.slice(0);
    const allowAutoPreferHDR = allowedVideoRanges.join('') !== 'SDR' && !videoPreference.videoCodec;
    preferHDR = videoPreference.preferHDR !== undefined ? videoPreference.preferHDR : allowAutoPreferHDR && isHdrSupported();
    if (!preferHDR) {
      allowedVideoRanges = ['SDR'];
    }
  }
  return {
    preferHDR,
    allowedVideoRanges
  };
}

const omitCircularRefsReplacer = replacer => {
  const known = new WeakSet();
  return (_, value) => {
    if (replacer) {
      value = replacer(_, value);
    }
    if (typeof value === 'object' && value !== null) {
      if (known.has(value)) {
        return;
      }
      known.add(value);
    }
    return value;
  };
};
const hls_stringify = (object, replacer) => JSON.stringify(object, omitCircularRefsReplacer(replacer));

function getStartCodecTier(codecTiers, currentVideoRange, currentBw, audioPreference, videoPreference) {
  const codecSets = Object.keys(codecTiers);
  const channelsPreference = audioPreference == null ? void 0 : audioPreference.channels;
  const audioCodecPreference = audioPreference == null ? void 0 : audioPreference.audioCodec;
  const videoCodecPreference = videoPreference == null ? void 0 : videoPreference.videoCodec;
  const preferStereo = channelsPreference && parseInt(channelsPreference) === 2;
  // Use first level set to determine stereo, and minimum resolution and framerate
  let hasStereo = false;
  let hasCurrentVideoRange = false;
  let minHeight = Infinity;
  let minFramerate = Infinity;
  let minBitrate = Infinity;
  let minIndex = Infinity;
  let selectedScore = 0;
  let videoRanges = [];
  const {
    preferHDR,
    allowedVideoRanges
  } = getVideoSelectionOptions(currentVideoRange, videoPreference);
  for (let i = codecSets.length; i--;) {
    const tier = codecTiers[codecSets[i]];
    hasStereo || (hasStereo = tier.channels[2] > 0);
    minHeight = Math.min(minHeight, tier.minHeight);
    minFramerate = Math.min(minFramerate, tier.minFramerate);
    minBitrate = Math.min(minBitrate, tier.minBitrate);
    const matchingVideoRanges = allowedVideoRanges.filter(range => tier.videoRanges[range] > 0);
    if (matchingVideoRanges.length > 0) {
      hasCurrentVideoRange = true;
    }
  }
  minHeight = isFiniteNumber(minHeight) ? minHeight : 0;
  minFramerate = isFiniteNumber(minFramerate) ? minFramerate : 0;
  const maxHeight = Math.max(1080, minHeight);
  const maxFramerate = Math.max(30, minFramerate);
  minBitrate = isFiniteNumber(minBitrate) ? minBitrate : currentBw;
  currentBw = Math.max(minBitrate, currentBw);
  // If there are no variants with matching preference, set currentVideoRange to undefined
  if (!hasCurrentVideoRange) {
    currentVideoRange = undefined;
  }
  const hasMultipleSets = codecSets.length > 1;
  const codecSet = codecSets.reduce((selected, candidate) => {
    // Remove candiates which do not meet bitrate, default audio, stereo or channels preference, 1080p or lower, 30fps or lower, or SDR/HDR selection if present
    const candidateTier = codecTiers[candidate];
    if (candidate === selected) {
      return selected;
    }
    videoRanges = hasCurrentVideoRange ? allowedVideoRanges.filter(range => candidateTier.videoRanges[range] > 0) : [];
    if (hasMultipleSets) {
      if (candidateTier.minBitrate > currentBw) {
        logStartCodecCandidateIgnored(candidate, `min bitrate of ${candidateTier.minBitrate} > current estimate of ${currentBw}`);
        return selected;
      }
      if (!candidateTier.hasDefaultAudio) {
        logStartCodecCandidateIgnored(candidate, `no renditions with default or auto-select sound found`);
        return selected;
      }
      if (audioCodecPreference && candidate.indexOf(audioCodecPreference.substring(0, 4)) % 5 !== 0) {
        logStartCodecCandidateIgnored(candidate, `audio codec preference "${audioCodecPreference}" not found`);
        return selected;
      }
      if (channelsPreference && !preferStereo) {
        if (!candidateTier.channels[channelsPreference]) {
          logStartCodecCandidateIgnored(candidate, `no renditions with ${channelsPreference} channel sound found (channels options: ${Object.keys(candidateTier.channels)})`);
          return selected;
        }
      } else if ((!audioCodecPreference || preferStereo) && hasStereo && candidateTier.channels['2'] === 0) {
        logStartCodecCandidateIgnored(candidate, `no renditions with stereo sound found`);
        return selected;
      }
      if (candidateTier.minHeight > maxHeight) {
        logStartCodecCandidateIgnored(candidate, `min resolution of ${candidateTier.minHeight} > maximum of ${maxHeight}`);
        return selected;
      }
      if (candidateTier.minFramerate > maxFramerate) {
        logStartCodecCandidateIgnored(candidate, `min framerate of ${candidateTier.minFramerate} > maximum of ${maxFramerate}`);
        return selected;
      }
      if (!videoRanges.some(range => candidateTier.videoRanges[range] > 0)) {
        logStartCodecCandidateIgnored(candidate, `no variants with VIDEO-RANGE of ${hls_stringify(videoRanges)} found`);
        return selected;
      }
      if (videoCodecPreference && candidate.indexOf(videoCodecPreference.substring(0, 4)) % 5 !== 0) {
        logStartCodecCandidateIgnored(candidate, `video codec preference "${videoCodecPreference}" not found`);
        return selected;
      }
      if (candidateTier.maxScore < selectedScore) {
        logStartCodecCandidateIgnored(candidate, `max score of ${candidateTier.maxScore} < selected max of ${selectedScore}`);
        return selected;
      }
    }
    // Remove candiates with less preferred codecs or more errors
    if (selected && (codecsSetSelectionPreferenceValue(candidate) >= codecsSetSelectionPreferenceValue(selected) || candidateTier.fragmentError > codecTiers[selected].fragmentError)) {
      return selected;
    }
    minIndex = candidateTier.minIndex;
    selectedScore = candidateTier.maxScore;
    return candidate;
  }, undefined);
  return {
    codecSet,
    videoRanges,
    preferHDR,
    minFramerate,
    minBitrate,
    minIndex
  };
}
function logStartCodecCandidateIgnored(codeSet, reason) {
  hls_logger.log(`[abr] start candidates with "${codeSet}" ignored because ${reason}`);
}
function getAudioTracksByGroup(allAudioTracks) {
  return allAudioTracks.reduce((audioTracksByGroup, track) => {
    let trackGroup = audioTracksByGroup.groups[track.groupId];
    if (!trackGroup) {
      trackGroup = audioTracksByGroup.groups[track.groupId] = {
        tracks: [],
        channels: {
          2: 0
        },
        hasDefault: false,
        hasAutoSelect: false
      };
    }
    trackGroup.tracks.push(track);
    const channelsKey = track.channels || '2';
    trackGroup.channels[channelsKey] = (trackGroup.channels[channelsKey] || 0) + 1;
    trackGroup.hasDefault = trackGroup.hasDefault || track.default;
    trackGroup.hasAutoSelect = trackGroup.hasAutoSelect || track.autoselect;
    if (trackGroup.hasDefault) {
      audioTracksByGroup.hasDefaultAudio = true;
    }
    if (trackGroup.hasAutoSelect) {
      audioTracksByGroup.hasAutoSelectAudio = true;
    }
    return audioTracksByGroup;
  }, {
    hasDefaultAudio: false,
    hasAutoSelectAudio: false,
    groups: {}
  });
}
function getCodecTiers(levels, audioTracksByGroup, minAutoLevel, maxAutoLevel) {
  return levels.slice(minAutoLevel, maxAutoLevel + 1).reduce((tiers, level, index) => {
    if (!level.codecSet) {
      return tiers;
    }
    const audioGroups = level.audioGroups;
    let tier = tiers[level.codecSet];
    if (!tier) {
      tiers[level.codecSet] = tier = {
        minBitrate: Infinity,
        minHeight: Infinity,
        minFramerate: Infinity,
        minIndex: index,
        maxScore: 0,
        videoRanges: {
          SDR: 0
        },
        channels: {
          '2': 0
        },
        hasDefaultAudio: !audioGroups,
        fragmentError: 0
      };
    }
    tier.minBitrate = Math.min(tier.minBitrate, level.bitrate);
    const lesserWidthOrHeight = Math.min(level.height, level.width);
    tier.minHeight = Math.min(tier.minHeight, lesserWidthOrHeight);
    tier.minFramerate = Math.min(tier.minFramerate, level.frameRate);
    tier.minIndex = Math.min(tier.minIndex, index);
    tier.maxScore = Math.max(tier.maxScore, level.score);
    tier.fragmentError += level.fragmentError;
    tier.videoRanges[level.videoRange] = (tier.videoRanges[level.videoRange] || 0) + 1;
    if (audioGroups) {
      audioGroups.forEach(audioGroupId => {
        if (!audioGroupId) {
          return;
        }
        const audioGroup = audioTracksByGroup.groups[audioGroupId];
        if (!audioGroup) {
          return;
        }
        // Default audio is any group with DEFAULT=YES, or if missing then any group with AUTOSELECT=YES, or all variants
        tier.hasDefaultAudio = tier.hasDefaultAudio || audioTracksByGroup.hasDefaultAudio ? audioGroup.hasDefault : audioGroup.hasAutoSelect || !audioTracksByGroup.hasDefaultAudio && !audioTracksByGroup.hasAutoSelectAudio;
        Object.keys(audioGroup.channels).forEach(channels => {
          tier.channels[channels] = (tier.channels[channels] || 0) + audioGroup.channels[channels];
        });
      });
    }
    return tiers;
  }, {});
}
function getBasicSelectionOption(option) {
  if (!option) {
    return option;
  }
  const {
    lang,
    assocLang,
    characteristics,
    channels,
    audioCodec
  } = option;
  return {
    lang,
    assocLang,
    characteristics,
    channels,
    audioCodec
  };
}
function findMatchingOption(option, tracks, matchPredicate) {
  if ('attrs' in option) {
    const index = tracks.indexOf(option);
    if (index !== -1) {
      return index;
    }
  }
  for (let i = 0; i < tracks.length; i++) {
    const track = tracks[i];
    if (matchesOption(option, track, matchPredicate)) {
      return i;
    }
  }
  return -1;
}
function matchesOption(option, track, matchPredicate) {
  const {
    groupId,
    name,
    lang,
    assocLang,
    default: isDefault
  } = option;
  const forced = option.forced;
  return (groupId === undefined || track.groupId === groupId) && (name === undefined || track.name === name) && (lang === undefined || languagesMatch(lang, track.lang)) && (lang === undefined || track.assocLang === assocLang) && (isDefault === undefined || track.default === isDefault) && (forced === undefined || track.forced === forced) && (!('characteristics' in option) || characteristicsMatch(option.characteristics || '', track.characteristics)) && (matchPredicate === undefined || matchPredicate(option, track));
}
function languagesMatch(languageA, languageB = '--') {
  if (languageA.length === languageB.length) {
    return languageA === languageB;
  }
  return languageA.startsWith(languageB) || languageB.startsWith(languageA);
}
function characteristicsMatch(characteristicsA, characteristicsB = '') {
  const arrA = characteristicsA.split(',');
  const arrB = characteristicsB.split(',');
  // Expects each item to be unique:
  return arrA.length === arrB.length && !arrA.some(el => arrB.indexOf(el) === -1);
}
function audioMatchPredicate(option, track) {
  const {
    audioCodec,
    channels
  } = option;
  return (audioCodec === undefined || (track.audioCodec || '').substring(0, 4) === audioCodec.substring(0, 4)) && (channels === undefined || channels === (track.channels || '2'));
}
function findClosestLevelWithAudioGroup(option, levels, allAudioTracks, searchIndex, matchPredicate) {
  const currentLevel = levels[searchIndex];
  // Are there variants with same URI as current level?
  // If so, find a match that does not require any level URI change
  const variants = levels.reduce((variantMap, level, index) => {
    const uri = level.uri;
    const renditions = variantMap[uri] || (variantMap[uri] = []);
    renditions.push(index);
    return variantMap;
  }, {});
  const renditions = variants[currentLevel.uri];
  if (renditions.length > 1) {
    searchIndex = Math.max.apply(Math, renditions);
  }
  // Find best match
  const currentVideoRange = currentLevel.videoRange;
  const currentFrameRate = currentLevel.frameRate;
  const currentVideoCodec = currentLevel.codecSet.substring(0, 4);
  const matchingVideo = searchDownAndUpList(levels, searchIndex, level => {
    if (level.videoRange !== currentVideoRange || level.frameRate !== currentFrameRate || level.codecSet.substring(0, 4) !== currentVideoCodec) {
      return false;
    }
    const audioGroups = level.audioGroups;
    const tracks = allAudioTracks.filter(track => !audioGroups || audioGroups.indexOf(track.groupId) !== -1);
    return findMatchingOption(option, tracks, matchPredicate) > -1;
  });
  if (matchingVideo > -1) {
    return matchingVideo;
  }
  return searchDownAndUpList(levels, searchIndex, level => {
    const audioGroups = level.audioGroups;
    const tracks = allAudioTracks.filter(track => !audioGroups || audioGroups.indexOf(track.groupId) !== -1);
    return findMatchingOption(option, tracks, matchPredicate) > -1;
  });
}
function searchDownAndUpList(arr, searchIndex, predicate) {
  for (let i = searchIndex; i > -1; i--) {
    if (predicate(arr[i])) {
      return i;
    }
  }
  for (let i = searchIndex + 1; i < arr.length; i++) {
    if (predicate(arr[i])) {
      return i;
    }
  }
  return -1;
}
function useAlternateAudio(audioTrackUrl, hls) {
  var _hls$loadLevelObj;
  return !!audioTrackUrl && audioTrackUrl !== ((_hls$loadLevelObj = hls.loadLevelObj) == null ? void 0 : _hls$loadLevelObj.uri);
}

class AbrController extends hls_Logger {
  constructor(_hls) {
    super('abr', _hls.logger);
    this.hls = void 0;
    this.lastLevelLoadSec = 0;
    this.lastLoadedFragLevel = -1;
    this.firstSelection = -1;
    this._nextAutoLevel = -1;
    this.nextAutoLevelKey = '';
    this.audioTracksByGroup = null;
    this.codecTiers = null;
    this.timer = -1;
    this.fragCurrent = null;
    this.partCurrent = null;
    this.bitrateTestDelay = 0;
    this.rebufferNotice = -1;
    this.bwEstimator = void 0;
    /*
        This method monitors the download rate of the current fragment, and will downswitch if that fragment will not load
        quickly enough to prevent underbuffering
      */
    this._abandonRulesCheck = levelLoaded => {
      var _ref;
      const {
        fragCurrent: frag,
        partCurrent: part,
        hls
      } = this;
      const {
        autoLevelEnabled,
        media
      } = hls;
      if (!frag || !media) {
        return;
      }
      const now = performance.now();
      const stats = part ? part.stats : frag.stats;
      const duration = part ? part.duration : frag.duration;
      const timeLoading = now - stats.loading.start;
      const minAutoLevel = hls.minAutoLevel;
      const loadingFragForLevel = frag.level;
      const currentAutoLevel = this._nextAutoLevel;
      // If frag loading is aborted, complete, or from lowest level, stop timer and return
      if (stats.aborted || stats.loaded && stats.loaded === stats.total || loadingFragForLevel <= minAutoLevel) {
        this.clearTimer();
        // reset forced auto level value so that next level will be selected
        this._nextAutoLevel = -1;
        return;
      }

      // This check only runs if we're in ABR mode
      if (!autoLevelEnabled) {
        return;
      }

      // Must be loading/loaded a new level or be in a playing state
      const fragBlockingSwitch = currentAutoLevel > -1 && currentAutoLevel !== loadingFragForLevel;
      const levelChange = !!levelLoaded || fragBlockingSwitch;
      if (!levelChange && (media.paused || !media.playbackRate || !media.readyState)) {
        return;
      }
      const bufferInfo = hls.mainForwardBufferInfo;
      if (!levelChange && bufferInfo === null) {
        return;
      }
      const ttfbEstimate = this.bwEstimator.getEstimateTTFB();
      const playbackRate = Math.abs(media.playbackRate);
      // To maintain stable adaptive playback, only begin monitoring frag loading after half or more of its playback duration has passed
      if (timeLoading <= Math.max(ttfbEstimate, 1000 * (duration / (playbackRate * 2)))) {
        return;
      }

      // bufferStarvationDelay is an estimate of the amount time (in seconds) it will take to exhaust the buffer
      const bufferStarvationDelay = bufferInfo ? bufferInfo.len / playbackRate : 0;
      const ttfb = stats.loading.first ? stats.loading.first - stats.loading.start : -1;
      const loadedFirstByte = stats.loaded && ttfb > -1;
      const bwEstimate = this.getBwEstimate();
      const levels = hls.levels;
      const level = levels[loadingFragForLevel];
      const expectedLen = Math.max(stats.loaded, Math.round(duration * (frag.bitrate || level.averageBitrate) / 8));
      let timeStreaming = loadedFirstByte ? timeLoading - ttfb : timeLoading;
      if (timeStreaming < 1 && loadedFirstByte) {
        timeStreaming = Math.min(timeLoading, stats.loaded * 8 / bwEstimate);
      }
      const loadRate = loadedFirstByte ? stats.loaded * 1000 / timeStreaming : 0;
      // fragLoadDelay is an estimate of the time (in seconds) it will take to buffer the remainder of the fragment
      const ttfbSeconds = ttfbEstimate / 1000;
      const fragLoadedDelay = loadRate ? (expectedLen - stats.loaded) / loadRate : expectedLen * 8 / bwEstimate + ttfbSeconds;
      // Only downswitch if the time to finish loading the current fragment is greater than the amount of buffer left
      if (fragLoadedDelay <= bufferStarvationDelay) {
        return;
      }
      const bwe = loadRate ? loadRate * 8 : bwEstimate;
      const live = ((_ref = (levelLoaded == null ? void 0 : levelLoaded.details) || this.hls.latestLevelDetails) == null ? void 0 : _ref.live) === true;
      const abrBandWidthUpFactor = this.hls.config.abrBandWidthUpFactor;
      let fragLevelNextLoadedDelay = Number.POSITIVE_INFINITY;
      let nextLoadLevel;
      // Iterate through lower level and try to find the largest one that avoids rebuffering
      for (nextLoadLevel = loadingFragForLevel - 1; nextLoadLevel > minAutoLevel; nextLoadLevel--) {
        // compute time to load next fragment at lower level
        // 8 = bits per byte (bps/Bps)
        const levelNextBitrate = levels[nextLoadLevel].maxBitrate;
        const requiresLevelLoad = !levels[nextLoadLevel].details || live;
        fragLevelNextLoadedDelay = this.getTimeToLoadFrag(ttfbSeconds, bwe, duration * levelNextBitrate, requiresLevelLoad);
        if (fragLevelNextLoadedDelay < Math.min(bufferStarvationDelay, duration + ttfbSeconds)) {
          break;
        }
      }
      // Only emergency switch down if it takes less time to load a new fragment at lowest level instead of continuing
      // to load the current one
      if (fragLevelNextLoadedDelay >= fragLoadedDelay) {
        return;
      }

      // if estimated load time of new segment is completely unreasonable, ignore and do not emergency switch down
      if (fragLevelNextLoadedDelay > duration * 10) {
        return;
      }
      if (loadedFirstByte) {
        // If there has been loading progress, sample bandwidth using loading time offset by minimum TTFB time
        this.bwEstimator.sample(timeLoading - Math.min(ttfbEstimate, ttfb), stats.loaded);
      } else {
        // If there has been no loading progress, sample TTFB
        this.bwEstimator.sampleTTFB(timeLoading);
      }
      const nextLoadLevelBitrate = levels[nextLoadLevel].maxBitrate;
      if (this.getBwEstimate() * abrBandWidthUpFactor > nextLoadLevelBitrate) {
        this.resetEstimator(nextLoadLevelBitrate);
      }
      const bestSwitchLevel = this.findBestLevel(nextLoadLevelBitrate, minAutoLevel, nextLoadLevel, 0, bufferStarvationDelay, 1, 1);
      if (bestSwitchLevel > -1) {
        nextLoadLevel = bestSwitchLevel;
      }
      this.warn(`Fragment ${frag.sn}${part ? ' part ' + part.index : ''} of level ${loadingFragForLevel} is loading too slowly;
      Fragment duration: ${frag.duration.toFixed(3)}
      Time to underbuffer: ${bufferStarvationDelay.toFixed(3)} s
      Estimated load time for current fragment: ${fragLoadedDelay.toFixed(3)} s
      Estimated load time for down switch fragment: ${fragLevelNextLoadedDelay.toFixed(3)} s
      TTFB estimate: ${ttfb | 0} ms
      Current BW estimate: ${isFiniteNumber(bwEstimate) ? bwEstimate | 0 : 'Unknown'} bps
      New BW estimate: ${this.getBwEstimate() | 0} bps
      Switching to level ${nextLoadLevel} @ ${nextLoadLevelBitrate | 0} bps`);
      hls.nextLoadLevel = hls.nextAutoLevel = nextLoadLevel;
      this.clearTimer();
      const abortAndSwitch = () => {
        // Are nextLoadLevel details available or is stream-controller still in "WAITING_LEVEL" state?
        this.clearTimer();
        if (this.fragCurrent === frag && this.hls.loadLevel === nextLoadLevel && nextLoadLevel > 0) {
          const bufferStarvationDelay = this.getStarvationDelay();
          this.warn(`Aborting inflight request ${nextLoadLevel > 0 ? 'and switching down' : ''}
      Fragment duration: ${frag.duration.toFixed(3)} s
      Time to underbuffer: ${bufferStarvationDelay.toFixed(3)} s`);
          frag.abortRequests();
          this.fragCurrent = this.partCurrent = null;
          if (nextLoadLevel > minAutoLevel) {
            let lowestSwitchLevel = this.findBestLevel(this.hls.levels[minAutoLevel].bitrate, minAutoLevel, nextLoadLevel, 0, bufferStarvationDelay, 1, 1);
            if (lowestSwitchLevel === -1) {
              lowestSwitchLevel = minAutoLevel;
            }
            this.hls.nextLoadLevel = this.hls.nextAutoLevel = lowestSwitchLevel;
            this.resetEstimator(this.hls.levels[lowestSwitchLevel].bitrate);
          }
        }
      };
      if (fragBlockingSwitch || fragLoadedDelay > fragLevelNextLoadedDelay * 2) {
        abortAndSwitch();
      } else {
        this.timer = self.setInterval(abortAndSwitch, fragLevelNextLoadedDelay * 1000);
      }
      hls.trigger(Events.FRAG_LOAD_EMERGENCY_ABORTED, {
        frag,
        part,
        stats
      });
    };
    this.hls = _hls;
    this.bwEstimator = this.initEstimator();
    this.registerListeners();
  }
  resetEstimator(abrEwmaDefaultEstimate) {
    if (abrEwmaDefaultEstimate) {
      this.log(`setting initial bwe to ${abrEwmaDefaultEstimate}`);
      this.hls.config.abrEwmaDefaultEstimate = abrEwmaDefaultEstimate;
    }
    this.firstSelection = -1;
    this.bwEstimator = this.initEstimator();
  }
  initEstimator() {
    const config = this.hls.config;
    return new EwmaBandWidthEstimator(config.abrEwmaSlowVoD, config.abrEwmaFastVoD, config.abrEwmaDefaultEstimate);
  }
  registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.FRAG_LOADING, this.onFragLoading, this);
    hls.on(Events.FRAG_LOADED, this.onFragLoaded, this);
    hls.on(Events.FRAG_BUFFERED, this.onFragBuffered, this);
    hls.on(Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
    hls.on(Events.LEVEL_LOADED, this.onLevelLoaded, this);
    hls.on(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
    hls.on(Events.MAX_AUTO_LEVEL_UPDATED, this.onMaxAutoLevelUpdated, this);
    hls.on(Events.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls
    } = this;
    if (!hls) {
      return;
    }
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.FRAG_LOADING, this.onFragLoading, this);
    hls.off(Events.FRAG_LOADED, this.onFragLoaded, this);
    hls.off(Events.FRAG_BUFFERED, this.onFragBuffered, this);
    hls.off(Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
    hls.off(Events.LEVEL_LOADED, this.onLevelLoaded, this);
    hls.off(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
    hls.off(Events.MAX_AUTO_LEVEL_UPDATED, this.onMaxAutoLevelUpdated, this);
    hls.off(Events.ERROR, this.onError, this);
  }
  destroy() {
    this.unregisterListeners();
    this.clearTimer();
    // @ts-ignore
    this.hls = this._abandonRulesCheck = null;
    this.fragCurrent = this.partCurrent = null;
  }
  onManifestLoading(event, data) {
    this.lastLoadedFragLevel = -1;
    this.firstSelection = -1;
    this.lastLevelLoadSec = 0;
    this.fragCurrent = this.partCurrent = null;
    this.onLevelsUpdated();
    this.clearTimer();
  }
  onLevelsUpdated() {
    if (this.lastLoadedFragLevel > -1 && this.fragCurrent) {
      this.lastLoadedFragLevel = this.fragCurrent.level;
    }
    this._nextAutoLevel = -1;
    this.onMaxAutoLevelUpdated();
    this.codecTiers = null;
    this.audioTracksByGroup = null;
  }
  onMaxAutoLevelUpdated() {
    this.firstSelection = -1;
    this.nextAutoLevelKey = '';
  }
  onFragLoading(event, data) {
    const frag = data.frag;
    if (this.ignoreFragment(frag)) {
      return;
    }
    if (!frag.bitrateTest) {
      var _data$part;
      this.fragCurrent = frag;
      this.partCurrent = (_data$part = data.part) != null ? _data$part : null;
    }
    this.clearTimer();
    this.timer = self.setInterval(this._abandonRulesCheck, 100);
  }
  onLevelSwitching(event, data) {
    this.clearTimer();
  }
  onError(event, data) {
    if (data.fatal) {
      return;
    }
    switch (data.details) {
      case ErrorDetails.BUFFER_ADD_CODEC_ERROR:
      case ErrorDetails.BUFFER_APPEND_ERROR:
        // Reset last loaded level so that a new selection can be made after calling recoverMediaError
        this.lastLoadedFragLevel = -1;
        this.firstSelection = -1;
        break;
      case ErrorDetails.FRAG_LOAD_TIMEOUT:
        {
          const frag = data.frag;
          const {
            fragCurrent,
            partCurrent: part
          } = this;
          if (frag && fragCurrent && frag.sn === fragCurrent.sn && frag.level === fragCurrent.level) {
            const now = performance.now();
            const stats = part ? part.stats : frag.stats;
            const timeLoading = now - stats.loading.start;
            const ttfb = stats.loading.first ? stats.loading.first - stats.loading.start : -1;
            const loadedFirstByte = stats.loaded && ttfb > -1;
            if (loadedFirstByte) {
              const ttfbEstimate = this.bwEstimator.getEstimateTTFB();
              this.bwEstimator.sample(timeLoading - Math.min(ttfbEstimate, ttfb), stats.loaded);
            } else {
              this.bwEstimator.sampleTTFB(timeLoading);
            }
          }
          break;
        }
    }
  }
  getTimeToLoadFrag(timeToFirstByteSec, bandwidth, fragSizeBits, isSwitch) {
    const fragLoadSec = timeToFirstByteSec + fragSizeBits / bandwidth;
    const playlistLoadSec = isSwitch ? timeToFirstByteSec + this.lastLevelLoadSec : 0;
    return fragLoadSec + playlistLoadSec;
  }
  onLevelLoaded(event, data) {
    const config = this.hls.config;
    const {
      loading
    } = data.stats;
    const timeLoadingMs = loading.end - loading.first;
    if (isFiniteNumber(timeLoadingMs)) {
      this.lastLevelLoadSec = timeLoadingMs / 1000;
    }
    if (data.details.live) {
      this.bwEstimator.update(config.abrEwmaSlowLive, config.abrEwmaFastLive);
    } else {
      this.bwEstimator.update(config.abrEwmaSlowVoD, config.abrEwmaFastVoD);
    }
    if (this.timer > -1) {
      this._abandonRulesCheck(data.levelInfo);
    }
  }
  onFragLoaded(event, {
    frag,
    part
  }) {
    const stats = part ? part.stats : frag.stats;
    if (frag.type === PlaylistLevelType.MAIN) {
      this.bwEstimator.sampleTTFB(stats.loading.first - stats.loading.start);
    }
    if (this.ignoreFragment(frag)) {
      return;
    }
    // stop monitoring bw once frag loaded
    this.clearTimer();
    // reset forced auto level value so that next level will be selected
    if (frag.level === this._nextAutoLevel) {
      this._nextAutoLevel = -1;
    }
    this.firstSelection = -1;

    // compute level average bitrate
    if (this.hls.config.abrMaxWithRealBitrate) {
      const duration = part ? part.duration : frag.duration;
      const level = this.hls.levels[frag.level];
      const loadedBytes = (level.loaded ? level.loaded.bytes : 0) + stats.loaded;
      const loadedDuration = (level.loaded ? level.loaded.duration : 0) + duration;
      level.loaded = {
        bytes: loadedBytes,
        duration: loadedDuration
      };
      level.realBitrate = Math.round(8 * loadedBytes / loadedDuration);
    }
    if (frag.bitrateTest) {
      const fragBufferedData = {
        stats,
        frag,
        part,
        id: frag.type
      };
      this.onFragBuffered(Events.FRAG_BUFFERED, fragBufferedData);
      frag.bitrateTest = false;
    } else {
      // store level id after successful fragment load for playback
      this.lastLoadedFragLevel = frag.level;
    }
  }
  onFragBuffered(event, data) {
    const {
      frag,
      part
    } = data;
    const stats = part != null && part.stats.loaded ? part.stats : frag.stats;
    if (stats.aborted) {
      return;
    }
    if (this.ignoreFragment(frag)) {
      return;
    }
    // Use the difference between parsing and request instead of buffering and request to compute fragLoadingProcessing;
    // rationale is that buffer appending only happens once media is attached. This can happen when config.startFragPrefetch
    // is used. If we used buffering in that case, our BW estimate sample will be very large.
    const processingMs = stats.parsing.end - stats.loading.start - Math.min(stats.loading.first - stats.loading.start, this.bwEstimator.getEstimateTTFB());
    this.bwEstimator.sample(processingMs, stats.loaded);
    stats.bwEstimate = this.getBwEstimate();
    if (frag.bitrateTest) {
      this.bitrateTestDelay = processingMs / 1000;
    } else {
      this.bitrateTestDelay = 0;
    }
  }
  ignoreFragment(frag) {
    // Only count non-alt-audio frags which were actually buffered in our BW calculations
    return frag.type !== PlaylistLevelType.MAIN || frag.sn === 'initSegment';
  }
  clearTimer() {
    if (this.timer > -1) {
      self.clearInterval(this.timer);
      this.timer = -1;
    }
  }
  get firstAutoLevel() {
    const {
      maxAutoLevel,
      minAutoLevel
    } = this.hls;
    const bwEstimate = this.getBwEstimate();
    const maxStartDelay = this.hls.config.maxStarvationDelay;
    const abrAutoLevel = this.findBestLevel(bwEstimate, minAutoLevel, maxAutoLevel, 0, maxStartDelay, 1, 1);
    if (abrAutoLevel > -1) {
      return abrAutoLevel;
    }
    const firstLevel = this.hls.firstLevel;
    const clamped = Math.min(Math.max(firstLevel, minAutoLevel), maxAutoLevel);
    this.warn(`Could not find best starting auto level. Defaulting to first in playlist ${firstLevel} clamped to ${clamped}`);
    return clamped;
  }
  get forcedAutoLevel() {
    if (this.nextAutoLevelKey) {
      return -1;
    }
    return this._nextAutoLevel;
  }

  // return next auto level
  get nextAutoLevel() {
    const forcedAutoLevel = this.forcedAutoLevel;
    const bwEstimator = this.bwEstimator;
    const useEstimate = bwEstimator.canEstimate();
    const loadedFirstFrag = this.lastLoadedFragLevel > -1;
    // in case next auto level has been forced, and bw not available or not reliable, return forced value
    if (forcedAutoLevel !== -1 && (!useEstimate || !loadedFirstFrag || this.nextAutoLevelKey === this.getAutoLevelKey())) {
      return forcedAutoLevel;
    }

    // compute next level using ABR logic
    const nextABRAutoLevel = useEstimate && loadedFirstFrag ? this.getNextABRAutoLevel() : this.firstAutoLevel;

    // use forced auto level while it hasn't errored more than ABR selection
    if (forcedAutoLevel !== -1) {
      const levels = this.hls.levels;
      if (levels.length > Math.max(forcedAutoLevel, nextABRAutoLevel) && levels[forcedAutoLevel].loadError <= levels[nextABRAutoLevel].loadError) {
        return forcedAutoLevel;
      }
    }

    // save result until state has changed
    this._nextAutoLevel = nextABRAutoLevel;
    this.nextAutoLevelKey = this.getAutoLevelKey();
    return nextABRAutoLevel;
  }
  getAutoLevelKey() {
    return `${this.getBwEstimate()}_${this.getStarvationDelay().toFixed(2)}`;
  }
  getNextABRAutoLevel() {
    const {
      fragCurrent,
      partCurrent,
      hls
    } = this;
    if (hls.levels.length <= 1) {
      return hls.loadLevel;
    }
    const {
      maxAutoLevel,
      config,
      minAutoLevel
    } = hls;
    const currentFragDuration = partCurrent ? partCurrent.duration : fragCurrent ? fragCurrent.duration : 0;
    const avgbw = this.getBwEstimate();
    // bufferStarvationDelay is the wall-clock time left until the playback buffer is exhausted.
    const bufferStarvationDelay = this.getStarvationDelay();
    let bwFactor = config.abrBandWidthFactor;
    let bwUpFactor = config.abrBandWidthUpFactor;

    // First, look to see if we can find a level matching with our avg bandwidth AND that could also guarantee no rebuffering at all
    if (bufferStarvationDelay) {
      const _bestLevel = this.findBestLevel(avgbw, minAutoLevel, maxAutoLevel, bufferStarvationDelay, 0, bwFactor, bwUpFactor);
      if (_bestLevel >= 0) {
        this.rebufferNotice = -1;
        return _bestLevel;
      }
    }
    // not possible to get rid of rebuffering... try to find level that will guarantee less than maxStarvationDelay of rebuffering
    let maxStarvationDelay = currentFragDuration ? Math.min(currentFragDuration, config.maxStarvationDelay) : config.maxStarvationDelay;
    if (!bufferStarvationDelay) {
      // in case buffer is empty, let's check if previous fragment was loaded to perform a bitrate test
      const bitrateTestDelay = this.bitrateTestDelay;
      if (bitrateTestDelay) {
        // if it is the case, then we need to adjust our max starvation delay using maxLoadingDelay config value
        // max video loading delay used in  automatic start level selection :
        // in that mode ABR controller will ensure that video loading time (ie the time to fetch the first fragment at lowest quality level +
        // the time to fetch the fragment at the appropriate quality level is less than ```maxLoadingDelay``` )
        // cap maxLoadingDelay and ensure it is not bigger 'than bitrate test' frag duration
        const maxLoadingDelay = currentFragDuration ? Math.min(currentFragDuration, config.maxLoadingDelay) : config.maxLoadingDelay;
        maxStarvationDelay = maxLoadingDelay - bitrateTestDelay;
        this.info(`bitrate test took ${Math.round(1000 * bitrateTestDelay)}ms, set first fragment max fetchDuration to ${Math.round(1000 * maxStarvationDelay)} ms`);
        // don't use conservative factor on bitrate test
        bwFactor = bwUpFactor = 1;
      }
    }
    const bestLevel = this.findBestLevel(avgbw, minAutoLevel, maxAutoLevel, bufferStarvationDelay, maxStarvationDelay, bwFactor, bwUpFactor);
    if (this.rebufferNotice !== bestLevel) {
      this.rebufferNotice = bestLevel;
      this.info(`${bufferStarvationDelay ? 'rebuffering expected' : 'buffer is empty'}, optimal quality level ${bestLevel}`);
    }
    if (bestLevel > -1) {
      return bestLevel;
    }
    // If no matching level found, see if min auto level would be a better option
    const minLevel = hls.levels[minAutoLevel];
    const autoLevel = hls.loadLevelObj;
    if (autoLevel && (minLevel == null ? void 0 : minLevel.bitrate) < autoLevel.bitrate) {
      return minAutoLevel;
    }
    // or if bitrate is not lower, continue to use loadLevel
    return hls.loadLevel;
  }
  getStarvationDelay() {
    const hls = this.hls;
    const media = hls.media;
    if (!media) {
      return Infinity;
    }
    // playbackRate is the absolute value of the playback rate; if media.playbackRate is 0, we use 1 to load as
    // if we're playing back at the normal rate.
    const playbackRate = media && media.playbackRate !== 0 ? Math.abs(media.playbackRate) : 1.0;
    const bufferInfo = hls.mainForwardBufferInfo;
    return (bufferInfo ? bufferInfo.len : 0) / playbackRate;
  }
  getBwEstimate() {
    return this.bwEstimator.canEstimate() ? this.bwEstimator.getEstimate() : this.hls.config.abrEwmaDefaultEstimate;
  }
  findBestLevel(currentBw, minAutoLevel, maxAutoLevel, bufferStarvationDelay, maxStarvationDelay, bwFactor, bwUpFactor) {
    var _this$hls$latestLevel;
    const maxFetchDuration = bufferStarvationDelay + maxStarvationDelay;
    const lastLoadedFragLevel = this.lastLoadedFragLevel;
    const selectionBaseLevel = lastLoadedFragLevel === -1 ? this.hls.firstLevel : lastLoadedFragLevel;
    const {
      fragCurrent,
      partCurrent
    } = this;
    const {
      levels,
      allAudioTracks,
      loadLevel,
      config
    } = this.hls;
    if (levels.length === 1) {
      return 0;
    }
    const level = levels[selectionBaseLevel];
    const live = !!((_this$hls$latestLevel = this.hls.latestLevelDetails) != null && _this$hls$latestLevel.live);
    const firstSelection = loadLevel === -1 || lastLoadedFragLevel === -1;
    let currentCodecSet;
    let currentVideoRange = 'SDR';
    let currentFrameRate = (level == null ? void 0 : level.frameRate) || 0;
    const {
      audioPreference,
      videoPreference
    } = config;
    const audioTracksByGroup = this.audioTracksByGroup || (this.audioTracksByGroup = getAudioTracksByGroup(allAudioTracks));
    let minStartIndex = -1;
    if (firstSelection) {
      if (this.firstSelection !== -1) {
        return this.firstSelection;
      }
      const codecTiers = this.codecTiers || (this.codecTiers = getCodecTiers(levels, audioTracksByGroup, minAutoLevel, maxAutoLevel));
      const startTier = getStartCodecTier(codecTiers, currentVideoRange, currentBw, audioPreference, videoPreference);
      const {
        codecSet,
        videoRanges,
        minFramerate,
        minBitrate,
        minIndex,
        preferHDR
      } = startTier;
      minStartIndex = minIndex;
      currentCodecSet = codecSet;
      currentVideoRange = preferHDR ? videoRanges[videoRanges.length - 1] : videoRanges[0];
      currentFrameRate = minFramerate;
      currentBw = Math.max(currentBw, minBitrate);
      this.log(`picked start tier ${hls_stringify(startTier)}`);
    } else {
      currentCodecSet = level == null ? void 0 : level.codecSet;
      currentVideoRange = level == null ? void 0 : level.videoRange;
    }
    const currentFragDuration = partCurrent ? partCurrent.duration : fragCurrent ? fragCurrent.duration : 0;
    const ttfbEstimateSec = this.bwEstimator.getEstimateTTFB() / 1000;
    const levelsSkipped = [];
    for (let i = maxAutoLevel; i >= minAutoLevel; i--) {
      var _levelInfo$supportedR;
      const levelInfo = levels[i];
      const upSwitch = i > selectionBaseLevel;
      if (!levelInfo) {
        continue;
      }
      if (config.useMediaCapabilities && !levelInfo.supportedResult && !levelInfo.supportedPromise) {
        const mediaCapabilities = navigator.mediaCapabilities;
        if (typeof (mediaCapabilities == null ? void 0 : mediaCapabilities.decodingInfo) === 'function' && (requiresMediaCapabilitiesDecodingInfo(levelInfo, audioTracksByGroup, currentVideoRange, currentFrameRate, currentBw, audioPreference) || isHEVC(levelInfo.videoCodec)) // Force media capabilities check for HEVC to avoid failure on Windows
        ) {
          levelInfo.supportedPromise = getMediaDecodingInfoPromise(levelInfo, audioTracksByGroup, mediaCapabilities);
          levelInfo.supportedPromise.then(decodingInfo => {
            if (!this.hls) {
              return;
            }
            levelInfo.supportedResult = decodingInfo;
            const levels = this.hls.levels;
            const index = levels.indexOf(levelInfo);
            if (decodingInfo.error) {
              this.warn(`MediaCapabilities decodingInfo error: "${decodingInfo.error}" for level ${index} ${hls_stringify(decodingInfo)}`);
            } else if (!decodingInfo.supported) {
              this.warn(`Unsupported MediaCapabilities decodingInfo result for level ${index} ${hls_stringify(decodingInfo)}`);
              if (index > -1 && levels.length > 1) {
                this.log(`Removing unsupported level ${index}`);
                this.hls.removeLevel(index);
                if (this.hls.loadLevel === -1) {
                  this.hls.nextLoadLevel = 0;
                }
              }
            }
          });
        } else {
          levelInfo.supportedResult = SUPPORTED_INFO_DEFAULT;
        }
      }

      // skip candidates which change codec-family or video-range,
      // and which decrease or increase frame-rate for up and down-switch respectfully
      if (currentCodecSet && levelInfo.codecSet !== currentCodecSet || currentVideoRange && levelInfo.videoRange !== currentVideoRange || upSwitch && currentFrameRate > levelInfo.frameRate || !upSwitch && currentFrameRate > 0 && currentFrameRate < levelInfo.frameRate || levelInfo.supportedResult && !((_levelInfo$supportedR = levelInfo.supportedResult.decodingInfoResults) != null && _levelInfo$supportedR[0].smooth)) {
        if (!firstSelection || i !== minStartIndex) {
          levelsSkipped.push(i);
          continue;
        }
      }
      const levelDetails = levelInfo.details;
      const avgDuration = (partCurrent ? levelDetails == null ? void 0 : levelDetails.partTarget : levelDetails == null ? void 0 : levelDetails.averagetargetduration) || currentFragDuration;
      let adjustedbw;
      // follow algorithm captured from stagefright :
      // https://android.googlesource.com/platform/frameworks/av/+/master/media/libstagefright/httplive/LiveSession.cpp
      // Pick the highest bandwidth stream below or equal to estimated bandwidth.
      // consider only 80% of the available bandwidth, but if we are switching up,
      // be even more conservative (70%) to avoid overestimating and immediately
      // switching back.
      if (!upSwitch) {
        adjustedbw = bwFactor * currentBw;
      } else {
        adjustedbw = bwUpFactor * currentBw;
      }

      // Use average bitrate when starvation delay (buffer length) is gt or eq two segment durations and rebuffering is not expected (maxStarvationDelay > 0)
      const bitrate = currentFragDuration && bufferStarvationDelay >= currentFragDuration * 2 && maxStarvationDelay === 0 ? levelInfo.averageBitrate : levelInfo.maxBitrate;
      const fetchDuration = this.getTimeToLoadFrag(ttfbEstimateSec, adjustedbw, bitrate * avgDuration, levelDetails === undefined);
      const canSwitchWithinTolerance =
      // if adjusted bw is greater than level bitrate AND
      adjustedbw >= bitrate && (
      // no level change, or new level has no error history
      i === lastLoadedFragLevel || levelInfo.loadError === 0 && levelInfo.fragmentError === 0) && (
      // fragment fetchDuration unknown OR live stream OR fragment fetchDuration less than max allowed fetch duration, then this level matches
      // we don't account for max Fetch Duration for live streams, this is to avoid switching down when near the edge of live sliding window ...
      // special case to support startLevel = -1 (bitrateTest) on live streams : in that case we should not exit loop so that findBestLevel will return -1
      fetchDuration <= ttfbEstimateSec || !isFiniteNumber(fetchDuration) || live && !this.bitrateTestDelay || fetchDuration < maxFetchDuration);
      if (canSwitchWithinTolerance) {
        const forcedAutoLevel = this.forcedAutoLevel;
        if (i !== loadLevel && (forcedAutoLevel === -1 || forcedAutoLevel !== loadLevel)) {
          if (levelsSkipped.length) {
            this.trace(`Skipped level(s) ${levelsSkipped.join(',')} of ${maxAutoLevel} max with CODECS and VIDEO-RANGE:"${levels[levelsSkipped[0]].codecs}" ${levels[levelsSkipped[0]].videoRange}; not compatible with "${currentCodecSet}" ${currentVideoRange}`);
          }
          this.info(`switch candidate:${selectionBaseLevel}->${i} adjustedbw(${Math.round(adjustedbw)})-bitrate=${Math.round(adjustedbw - bitrate)} ttfb:${ttfbEstimateSec.toFixed(1)} avgDuration:${avgDuration.toFixed(1)} maxFetchDuration:${maxFetchDuration.toFixed(1)} fetchDuration:${fetchDuration.toFixed(1)} firstSelection:${firstSelection} codecSet:${levelInfo.codecSet} videoRange:${levelInfo.videoRange} hls.loadLevel:${loadLevel}`);
        }
        if (firstSelection) {
          this.firstSelection = i;
        }
        // as we are looping from highest to lowest, this will return the best achievable quality level
        return i;
      }
    }
    // not enough time budget even with quality level 0 ... rebuffering might happen
    return -1;
  }
  set nextAutoLevel(nextLevel) {
    const value = this.deriveNextAutoLevel(nextLevel);
    if (this._nextAutoLevel !== value) {
      this.nextAutoLevelKey = '';
      this._nextAutoLevel = value;
    }
  }
  deriveNextAutoLevel(nextLevel) {
    const {
      maxAutoLevel,
      minAutoLevel
    } = this.hls;
    return Math.min(Math.max(nextLevel, minAutoLevel), maxAutoLevel);
  }
}

const BinarySearch = {
  /**
   * Searches for an item in an array which matches a certain condition.
   * This requires the condition to only match one item in the array,
   * and for the array to be ordered.
   *
   * @param list The array to search.
   * @param comparisonFn
   *      Called and provided a candidate item as the first argument.
   *      Should return:
   *          > -1 if the item should be located at a lower index than the provided item.
   *          > 1 if the item should be located at a higher index than the provided item.
   *          > 0 if the item is the item you're looking for.
   *
   * @returns the object if found, otherwise returns null
   */
  search: function (list, comparisonFn) {
    let minIndex = 0;
    let maxIndex = list.length - 1;
    let currentIndex = null;
    let currentElement = null;
    while (minIndex <= maxIndex) {
      currentIndex = (minIndex + maxIndex) / 2 | 0;
      currentElement = list[currentIndex];
      const comparisonResult = comparisonFn(currentElement);
      if (comparisonResult > 0) {
        minIndex = currentIndex + 1;
      } else if (comparisonResult < 0) {
        maxIndex = currentIndex - 1;
      } else {
        return currentElement;
      }
    }
    return null;
  }
};

/**
 * Returns first fragment whose endPdt value exceeds the given PDT, or null.
 * @param fragments - The array of candidate fragments
 * @param PDTValue - The PDT value which must be exceeded
 * @param maxFragLookUpTolerance - The amount of time that a fragment's start/end can be within in order to be considered contiguous
 */
function findFragmentByPDT(fragments, PDTValue, maxFragLookUpTolerance) {
  if (PDTValue === null || !Array.isArray(fragments) || !fragments.length || !isFiniteNumber(PDTValue)) {
    return null;
  }

  // if less than start
  const startPDT = fragments[0].programDateTime;
  if (PDTValue < (startPDT || 0)) {
    return null;
  }
  const endPDT = fragments[fragments.length - 1].endProgramDateTime;
  if (PDTValue >= (endPDT || 0)) {
    return null;
  }
  for (let seg = 0; seg < fragments.length; ++seg) {
    const frag = fragments[seg];
    if (pdtWithinToleranceTest(PDTValue, maxFragLookUpTolerance, frag)) {
      return frag;
    }
  }
  return null;
}

/**
 * Finds a fragment based on the SN of the previous fragment; or based on the needs of the current buffer.
 * This method compensates for small buffer gaps by applying a tolerance to the start of any candidate fragment, thus
 * breaking any traps which would cause the same fragment to be continuously selected within a small range.
 * @param fragPrevious - The last frag successfully appended
 * @param fragments - The array of candidate fragments
 * @param bufferEnd - The end of the contiguous buffered range the playhead is currently within
 * @param maxFragLookUpTolerance - The amount of time that a fragment's start/end can be within in order to be considered contiguous
 * @returns a matching fragment or null
 */
function findFragmentByPTS(fragPrevious, fragments, bufferEnd = 0, maxFragLookUpTolerance = 0, nextFragLookupTolerance = 0.005) {
  let fragNext = null;
  if (fragPrevious) {
    fragNext = fragments[1 + fragPrevious.sn - fragments[0].sn] || null;
    // check for buffer-end rounding error
    const bufferEdgeError = fragPrevious.endDTS - bufferEnd;
    if (bufferEdgeError > 0 && bufferEdgeError < 0.0000015) {
      bufferEnd += 0.0000015;
    }
    if (fragNext && fragPrevious.level !== fragNext.level && fragNext.end <= fragPrevious.end) {
      fragNext = fragments[2 + fragPrevious.sn - fragments[0].sn] || null;
    }
  } else if (bufferEnd === 0 && fragments[0].start === 0) {
    fragNext = fragments[0];
  }
  // Prefer the next fragment if it's within tolerance
  if (fragNext && ((!fragPrevious || fragPrevious.level === fragNext.level) && fragmentWithinToleranceTest(bufferEnd, maxFragLookUpTolerance, fragNext) === 0 || fragmentWithinFastStartSwitch(fragNext, fragPrevious, Math.min(nextFragLookupTolerance, maxFragLookUpTolerance)))) {
    return fragNext;
  }
  // We might be seeking past the tolerance so find the best match
  const foundFragment = BinarySearch.search(fragments, fragmentWithinToleranceTest.bind(null, bufferEnd, maxFragLookUpTolerance));
  if (foundFragment && (foundFragment !== fragPrevious || !fragNext)) {
    return foundFragment;
  }
  // If no match was found return the next fragment after fragPrevious, or null
  return fragNext;
}
function fragmentWithinFastStartSwitch(fragNext, fragPrevious, nextFragLookupTolerance) {
  if (fragPrevious && fragPrevious.start === 0 && fragPrevious.level < fragNext.level && (fragPrevious.endPTS || 0) > 0) {
    const firstDuration = fragPrevious.tagList.reduce((duration, tag) => {
      if (tag[0] === 'INF') {
        duration += parseFloat(tag[1]);
      }
      return duration;
    }, nextFragLookupTolerance);
    return fragNext.start <= firstDuration;
  }
  return false;
}

/**
 * The test function used by the findFragmentBySn's BinarySearch to look for the best match to the current buffer conditions.
 * @param candidate - The fragment to test
 * @param bufferEnd - The end of the current buffered range the playhead is currently within
 * @param maxFragLookUpTolerance - The amount of time that a fragment's start can be within in order to be considered contiguous
 * @returns 0 if it matches, 1 if too low, -1 if too high
 */
function fragmentWithinToleranceTest(bufferEnd = 0, maxFragLookUpTolerance = 0, candidate) {
  // eagerly accept an accurate match (no tolerance)
  if (candidate.start <= bufferEnd && candidate.start + candidate.duration > bufferEnd) {
    return 0;
  }
  // offset should be within fragment boundary - config.maxFragLookUpTolerance
  // this is to cope with situations like
  // bufferEnd = 9.991
  // frag[Ø] : [0,10]
  // frag[1] : [10,20]
  // bufferEnd is within frag[0] range ... although what we are expecting is to return frag[1] here
  //              frag start               frag start+duration
  //                  |-----------------------------|
  //              <--->                         <--->
  //  ...--------><-----------------------------><---------....
  // previous frag         matching fragment         next frag
  //  return -1             return 0                 return 1
  // logger.log(`level/sn/start/end/bufEnd:${level}/${candidate.sn}/${candidate.start}/${(candidate.start+candidate.duration)}/${bufferEnd}`);
  // Set the lookup tolerance to be small enough to detect the current segment - ensures we don't skip over very small segments
  const candidateLookupTolerance = Math.min(maxFragLookUpTolerance, candidate.duration + (candidate.deltaPTS ? candidate.deltaPTS : 0));
  if (candidate.start + candidate.duration - candidateLookupTolerance <= bufferEnd) {
    return 1;
  } else if (candidate.start - candidateLookupTolerance > bufferEnd && candidate.start) {
    // if maxFragLookUpTolerance will have negative value then don't return -1 for first element
    return -1;
  }
  return 0;
}

/**
 * The test function used by the findFragmentByPdt's BinarySearch to look for the best match to the current buffer conditions.
 * This function tests the candidate's program date time values, as represented in Unix time
 * @param candidate - The fragment to test
 * @param pdtBufferEnd - The Unix time representing the end of the current buffered range
 * @param maxFragLookUpTolerance - The amount of time that a fragment's start can be within in order to be considered contiguous
 * @returns true if contiguous, false otherwise
 */
function pdtWithinToleranceTest(pdtBufferEnd, maxFragLookUpTolerance, candidate) {
  const candidateLookupTolerance = Math.min(maxFragLookUpTolerance, candidate.duration + (candidate.deltaPTS ? candidate.deltaPTS : 0)) * 1000;

  // endProgramDateTime can be null, default to zero
  const endProgramDateTime = candidate.endProgramDateTime || 0;
  return endProgramDateTime - candidateLookupTolerance > pdtBufferEnd;
}
function findNearestWithCC(details, cc, pos) {
  if (details) {
    if (details.startCC <= cc && details.endCC >= cc) {
      let fragments = details.fragments;
      const {
        fragmentHint
      } = details;
      if (fragmentHint) {
        fragments = fragments.concat(fragmentHint);
      }
      let closest;
      BinarySearch.search(fragments, candidate => {
        if (candidate.cc < cc) {
          return 1;
        }
        if (candidate.cc > cc) {
          return -1;
        }
        closest = candidate;
        if (candidate.end <= pos) {
          return 1;
        }
        if (candidate.start > pos) {
          return -1;
        }
        return 0;
      });
      return closest || null;
    }
  }
  return null;
}

function isTimeoutError(error) {
  switch (error.details) {
    case ErrorDetails.FRAG_LOAD_TIMEOUT:
    case ErrorDetails.KEY_LOAD_TIMEOUT:
    case ErrorDetails.LEVEL_LOAD_TIMEOUT:
    case ErrorDetails.MANIFEST_LOAD_TIMEOUT:
      return true;
  }
  return false;
}
function getRetryConfig(loadPolicy, error) {
  const isTimeout = isTimeoutError(error);
  return loadPolicy.default[`${isTimeout ? 'timeout' : 'error'}Retry`];
}
function getRetryDelay(retryConfig, retryCount) {
  // exponential backoff capped to max retry delay
  const backoffFactor = retryConfig.backoff === 'linear' ? 1 : Math.pow(2, retryCount);
  return Math.min(backoffFactor * retryConfig.retryDelayMs, retryConfig.maxRetryDelayMs);
}
function getLoaderConfigWithoutReties(loderConfig) {
  return _objectSpread2(_objectSpread2({}, loderConfig), {
    errorRetry: null,
    timeoutRetry: null
  });
}
function shouldRetry(retryConfig, retryCount, isTimeout, loaderResponse) {
  if (!retryConfig) {
    return false;
  }
  const httpStatus = loaderResponse == null ? void 0 : loaderResponse.code;
  const retry = retryCount < retryConfig.maxNumRetry && (retryForHttpStatus(httpStatus) || !!isTimeout);
  return retryConfig.shouldRetry ? retryConfig.shouldRetry(retryConfig, retryCount, isTimeout, loaderResponse, retry) : retry;
}
function retryForHttpStatus(httpStatus) {
  // Do not retry on status 4xx, status 0 (CORS error), or undefined (decrypt/gap/parse error)
  return httpStatus === 0 && navigator.onLine === false || !!httpStatus && (httpStatus < 400 || httpStatus > 499);
}

var NetworkErrorAction = {
  DoNothing: 0,
  SendEndCallback: 1,
  SendAlternateToPenaltyBox: 2,
  RemoveAlternatePermanently: 3,
  InsertDiscontinuity: 4,
  RetryRequest: 5
};
var ErrorActionFlags = {
  None: 0,
  MoveAllAlternatesMatchingHost: 1,
  MoveAllAlternatesMatchingHDCP: 2,
  SwitchToSDR: 4
};
class ErrorController extends hls_Logger {
  constructor(hls) {
    super('error-controller', hls.logger);
    this.hls = void 0;
    this.playlistError = 0;
    this.penalizedRenditions = {};
    this.hls = hls;
    this.registerListeners();
  }
  registerListeners() {
    const hls = this.hls;
    hls.on(Events.ERROR, this.onError, this);
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
  }
  unregisterListeners() {
    const hls = this.hls;
    if (!hls) {
      return;
    }
    hls.off(Events.ERROR, this.onError, this);
    hls.off(Events.ERROR, this.onErrorOut, this);
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
  }
  destroy() {
    this.unregisterListeners();
    // @ts-ignore
    this.hls = null;
    this.penalizedRenditions = {};
  }
  startLoad(startPosition) {}
  stopLoad() {
    this.playlistError = 0;
  }
  getVariantLevelIndex(frag) {
    return (frag == null ? void 0 : frag.type) === PlaylistLevelType.MAIN ? frag.level : this.hls.loadLevel;
  }
  onManifestLoading() {
    this.playlistError = 0;
    this.penalizedRenditions = {};
  }
  onLevelUpdated() {
    this.playlistError = 0;
  }
  onError(event, data) {
    var _data$frag;
    if (data.fatal) {
      return;
    }
    const hls = this.hls;
    const context = data.context;
    switch (data.details) {
      case ErrorDetails.FRAG_LOAD_ERROR:
      case ErrorDetails.FRAG_LOAD_TIMEOUT:
      case ErrorDetails.KEY_LOAD_ERROR:
      case ErrorDetails.KEY_LOAD_TIMEOUT:
        data.errorAction = this.getFragRetryOrSwitchAction(data);
        return;
      case ErrorDetails.FRAG_PARSING_ERROR:
        // ignore empty segment errors marked as gap
        if ((_data$frag = data.frag) != null && _data$frag.gap) {
          data.errorAction = createDoNothingErrorAction();
          return;
        }
      // falls through
      case ErrorDetails.FRAG_GAP:
      case ErrorDetails.FRAG_DECRYPT_ERROR:
        {
          // Switch level if possible, otherwise allow retry count to reach max error retries
          data.errorAction = this.getFragRetryOrSwitchAction(data);
          data.errorAction.action = NetworkErrorAction.SendAlternateToPenaltyBox;
          return;
        }
      case ErrorDetails.LEVEL_EMPTY_ERROR:
      case ErrorDetails.LEVEL_PARSING_ERROR:
        {
          var _data$context, _data$context$levelDe;
          // Only retry when empty and live
          const levelIndex = data.parent === PlaylistLevelType.MAIN ? data.level : hls.loadLevel;
          if (data.details === ErrorDetails.LEVEL_EMPTY_ERROR && !!((_data$context = data.context) != null && (_data$context$levelDe = _data$context.levelDetails) != null && _data$context$levelDe.live)) {
            data.errorAction = this.getPlaylistRetryOrSwitchAction(data, levelIndex);
          } else {
            // Escalate to fatal if not retrying or switching
            data.levelRetry = false;
            data.errorAction = this.getLevelSwitchAction(data, levelIndex);
          }
        }
        return;
      case ErrorDetails.LEVEL_LOAD_ERROR:
      case ErrorDetails.LEVEL_LOAD_TIMEOUT:
        if (typeof (context == null ? void 0 : context.level) === 'number') {
          data.errorAction = this.getPlaylistRetryOrSwitchAction(data, context.level);
        }
        return;
      case ErrorDetails.AUDIO_TRACK_LOAD_ERROR:
      case ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:
      case ErrorDetails.SUBTITLE_LOAD_ERROR:
      case ErrorDetails.SUBTITLE_TRACK_LOAD_TIMEOUT:
        if (context) {
          const level = hls.loadLevelObj;
          if (level && (context.type === PlaylistContextType.AUDIO_TRACK && level.hasAudioGroup(context.groupId) || context.type === PlaylistContextType.SUBTITLE_TRACK && level.hasSubtitleGroup(context.groupId))) {
            // Perform Pathway switch or Redundant failover if possible for fastest recovery
            // otherwise allow playlist retry count to reach max error retries
            data.errorAction = this.getPlaylistRetryOrSwitchAction(data, hls.loadLevel);
            data.errorAction.action = NetworkErrorAction.SendAlternateToPenaltyBox;
            data.errorAction.flags = ErrorActionFlags.MoveAllAlternatesMatchingHost;
            return;
          }
        }
        return;
      case ErrorDetails.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED:
        {
          const level = hls.loadLevelObj;
          const restrictedHdcpLevel = level == null ? void 0 : level.attrs['HDCP-LEVEL'];
          if (restrictedHdcpLevel) {
            data.errorAction = {
              action: NetworkErrorAction.SendAlternateToPenaltyBox,
              flags: ErrorActionFlags.MoveAllAlternatesMatchingHDCP,
              hdcpLevel: restrictedHdcpLevel
            };
          } else {
            this.keySystemError(data);
          }
        }
        return;
      case ErrorDetails.BUFFER_ADD_CODEC_ERROR:
      case ErrorDetails.REMUX_ALLOC_ERROR:
      case ErrorDetails.BUFFER_APPEND_ERROR:
        // Buffer-controller can set errorAction when append errors can be ignored or resolved locally
        if (!data.errorAction) {
          var _data$level;
          data.errorAction = this.getLevelSwitchAction(data, (_data$level = data.level) != null ? _data$level : hls.loadLevel);
        }
        return;
      case ErrorDetails.INTERNAL_EXCEPTION:
      case ErrorDetails.BUFFER_APPENDING_ERROR:
      case ErrorDetails.BUFFER_FULL_ERROR:
      case ErrorDetails.LEVEL_SWITCH_ERROR:
      case ErrorDetails.BUFFER_STALLED_ERROR:
      case ErrorDetails.BUFFER_SEEK_OVER_HOLE:
      case ErrorDetails.BUFFER_NUDGE_ON_STALL:
        data.errorAction = createDoNothingErrorAction();
        return;
    }
    if (data.type === ErrorTypes.KEY_SYSTEM_ERROR) {
      this.keySystemError(data);
    }
  }
  keySystemError(data) {
    const levelIndex = this.getVariantLevelIndex(data.frag);
    // Do not retry level. Escalate to fatal if switching levels fails.
    data.levelRetry = false;
    data.errorAction = this.getLevelSwitchAction(data, levelIndex);
  }
  getPlaylistRetryOrSwitchAction(data, levelIndex) {
    const hls = this.hls;
    const retryConfig = getRetryConfig(hls.config.playlistLoadPolicy, data);
    const retryCount = this.playlistError++;
    const retry = shouldRetry(retryConfig, retryCount, isTimeoutError(data), data.response);
    if (retry) {
      return {
        action: NetworkErrorAction.RetryRequest,
        flags: ErrorActionFlags.None,
        retryConfig,
        retryCount
      };
    }
    const errorAction = this.getLevelSwitchAction(data, levelIndex);
    if (retryConfig) {
      errorAction.retryConfig = retryConfig;
      errorAction.retryCount = retryCount;
    }
    return errorAction;
  }
  getFragRetryOrSwitchAction(data) {
    const hls = this.hls;
    // Share fragment error count accross media options (main, audio, subs)
    // This allows for level based rendition switching when media option assets fail
    const variantLevelIndex = this.getVariantLevelIndex(data.frag);
    const level = hls.levels[variantLevelIndex];
    const {
      fragLoadPolicy,
      keyLoadPolicy
    } = hls.config;
    const retryConfig = getRetryConfig(data.details.startsWith('key') ? keyLoadPolicy : fragLoadPolicy, data);
    const fragmentErrors = hls.levels.reduce((acc, level) => acc + level.fragmentError, 0);
    // Switch levels when out of retried or level index out of bounds
    if (level) {
      if (data.details !== ErrorDetails.FRAG_GAP) {
        level.fragmentError++;
      }
      const retry = shouldRetry(retryConfig, fragmentErrors, isTimeoutError(data), data.response);
      if (retry) {
        return {
          action: NetworkErrorAction.RetryRequest,
          flags: ErrorActionFlags.None,
          retryConfig,
          retryCount: fragmentErrors
        };
      }
    }
    // Reach max retry count, or Missing level reference
    // Switch to valid index
    const errorAction = this.getLevelSwitchAction(data, variantLevelIndex);
    // Add retry details to allow skipping of FRAG_PARSING_ERROR
    if (retryConfig) {
      errorAction.retryConfig = retryConfig;
      errorAction.retryCount = fragmentErrors;
    }
    return errorAction;
  }
  getLevelSwitchAction(data, levelIndex) {
    const hls = this.hls;
    if (levelIndex === null || levelIndex === undefined) {
      levelIndex = hls.loadLevel;
    }
    const level = this.hls.levels[levelIndex];
    if (level) {
      var _data$frag2, _data$context2;
      const errorDetails = data.details;
      level.loadError++;
      if (errorDetails === ErrorDetails.BUFFER_APPEND_ERROR) {
        level.fragmentError++;
      }
      // Search for next level to retry
      let nextLevel = -1;
      const {
        levels,
        loadLevel,
        minAutoLevel,
        maxAutoLevel
      } = hls;
      if (!hls.autoLevelEnabled && !hls.config.preserveManualLevelOnError) {
        hls.loadLevel = -1;
      }
      const fragErrorType = (_data$frag2 = data.frag) == null ? void 0 : _data$frag2.type;
      // Find alternate audio codec if available on audio codec error
      const isAudioCodecError = fragErrorType === PlaylistLevelType.AUDIO && errorDetails === ErrorDetails.FRAG_PARSING_ERROR || data.sourceBufferName === 'audio' && (errorDetails === ErrorDetails.BUFFER_ADD_CODEC_ERROR || errorDetails === ErrorDetails.BUFFER_APPEND_ERROR);
      const findAudioCodecAlternate = isAudioCodecError && levels.some(({
        audioCodec
      }) => level.audioCodec !== audioCodec);
      // Find alternate video codec if available on video codec error
      const isVideoCodecError = data.sourceBufferName === 'video' && (errorDetails === ErrorDetails.BUFFER_ADD_CODEC_ERROR || errorDetails === ErrorDetails.BUFFER_APPEND_ERROR);
      const findVideoCodecAlternate = isVideoCodecError && levels.some(({
        codecSet,
        audioCodec
      }) => level.codecSet !== codecSet && level.audioCodec === audioCodec);
      const {
        type: playlistErrorType,
        groupId: playlistErrorGroupId
      } = (_data$context2 = data.context) != null ? _data$context2 : {};
      for (let i = levels.length; i--;) {
        const candidate = (i + loadLevel) % levels.length;
        if (candidate !== loadLevel && candidate >= minAutoLevel && candidate <= maxAutoLevel && levels[candidate].loadError === 0) {
          var _level$audioGroups, _level$subtitleGroups;
          const levelCandidate = levels[candidate];
          // Skip level switch if GAP tag is found in next level at same position
          if (errorDetails === ErrorDetails.FRAG_GAP && fragErrorType === PlaylistLevelType.MAIN && data.frag) {
            const levelDetails = levels[candidate].details;
            if (levelDetails) {
              const fragCandidate = findFragmentByPTS(data.frag, levelDetails.fragments, data.frag.start);
              if (fragCandidate != null && fragCandidate.gap) {
                continue;
              }
            }
          } else if (playlistErrorType === PlaylistContextType.AUDIO_TRACK && levelCandidate.hasAudioGroup(playlistErrorGroupId) || playlistErrorType === PlaylistContextType.SUBTITLE_TRACK && levelCandidate.hasSubtitleGroup(playlistErrorGroupId)) {
            // For audio/subs playlist errors find another group ID or fallthrough to redundant fail-over
            continue;
          } else if (fragErrorType === PlaylistLevelType.AUDIO && (_level$audioGroups = level.audioGroups) != null && _level$audioGroups.some(groupId => levelCandidate.hasAudioGroup(groupId)) || fragErrorType === PlaylistLevelType.SUBTITLE && (_level$subtitleGroups = level.subtitleGroups) != null && _level$subtitleGroups.some(groupId => levelCandidate.hasSubtitleGroup(groupId)) || findAudioCodecAlternate && level.audioCodec === levelCandidate.audioCodec || !findAudioCodecAlternate && level.audioCodec !== levelCandidate.audioCodec || findVideoCodecAlternate && level.codecSet === levelCandidate.codecSet) {
            // For video/audio/subs frag errors find another group ID or fallthrough to redundant fail-over
            continue;
          }
          nextLevel = candidate;
          break;
        }
      }
      if (nextLevel > -1 && hls.loadLevel !== nextLevel) {
        data.levelRetry = true;
        this.playlistError = 0;
        return {
          action: NetworkErrorAction.SendAlternateToPenaltyBox,
          flags: ErrorActionFlags.None,
          nextAutoLevel: nextLevel
        };
      }
    }
    // No levels to switch / Manual level selection / Level not found
    // Resolve with Pathway switch, Redundant fail-over, or stay on lowest Level
    return {
      action: NetworkErrorAction.SendAlternateToPenaltyBox,
      flags: ErrorActionFlags.MoveAllAlternatesMatchingHost
    };
  }
  onErrorOut(event, data) {
    var _data$errorAction;
    switch ((_data$errorAction = data.errorAction) == null ? void 0 : _data$errorAction.action) {
      case NetworkErrorAction.DoNothing:
        break;
      case NetworkErrorAction.SendAlternateToPenaltyBox:
        this.sendAlternateToPenaltyBox(data);
        if (!data.errorAction.resolved && data.details !== ErrorDetails.FRAG_GAP) {
          data.fatal = true;
        } else if (/MediaSource readyState: ended/.test(data.error.message)) {
          this.warn(`MediaSource ended after "${data.sourceBufferName}" sourceBuffer append error. Attempting to recover from media error.`);
          this.hls.recoverMediaError();
        }
        break;
      case NetworkErrorAction.RetryRequest:
        // handled by stream and playlist/level controllers
        break;
    }
    if (data.fatal) {
      this.hls.stopLoad();
      return;
    }
  }
  sendAlternateToPenaltyBox(data) {
    const hls = this.hls;
    const errorAction = data.errorAction;
    if (!errorAction) {
      return;
    }
    const {
      flags,
      hdcpLevel,
      nextAutoLevel
    } = errorAction;
    switch (flags) {
      case ErrorActionFlags.None:
        this.switchLevel(data, nextAutoLevel);
        break;
      case ErrorActionFlags.MoveAllAlternatesMatchingHDCP:
        if (hdcpLevel) {
          hls.maxHdcpLevel = HdcpLevels[HdcpLevels.indexOf(hdcpLevel) - 1];
          errorAction.resolved = true;
        }
        this.warn(`Restricting playback to HDCP-LEVEL of "${hls.maxHdcpLevel}" or lower`);
        break;
    }
    // If not resolved by previous actions try to switch to next level
    if (!errorAction.resolved) {
      this.switchLevel(data, nextAutoLevel);
    }
  }
  switchLevel(data, levelIndex) {
    if (levelIndex !== undefined && data.errorAction) {
      this.warn(`switching to level ${levelIndex} after ${data.details}`);
      this.hls.nextAutoLevel = levelIndex;
      data.errorAction.resolved = true;
      // Stream controller is responsible for this but won't switch on false start
      this.hls.nextLoadLevel = this.hls.nextAutoLevel;
      if (data.details === ErrorDetails.BUFFER_ADD_CODEC_ERROR && data.mimeType && data.sourceBufferName !== 'audiovideo') {
        const codec = getCodecsForMimeType(data.mimeType);
        const levels = this.hls.levels;
        for (let i = levels.length; i--;) {
          if (levels[i][`${data.sourceBufferName}Codec`] === codec) {
            this.hls.removeLevel(i);
          }
        }
      }
    }
  }
}
function createDoNothingErrorAction(resolved) {
  const errorAction = {
    action: NetworkErrorAction.DoNothing,
    flags: ErrorActionFlags.None
  };
  if (resolved) {
    errorAction.resolved = true;
  }
  return errorAction;
}

var FragmentState = {
  NOT_LOADED: "NOT_LOADED",
  APPENDING: "APPENDING",
  PARTIAL: "PARTIAL",
  OK: "OK"
};
class FragmentTracker {
  constructor(hls) {
    this.activePartLists = Object.create(null);
    this.endListFragments = Object.create(null);
    this.fragments = Object.create(null);
    this.timeRanges = Object.create(null);
    this.bufferPadding = 0.2;
    this.hls = void 0;
    this.hasGaps = false;
    this.hls = hls;
    this._registerListeners();
  }
  _registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.BUFFER_APPENDED, this.onBufferAppended, this);
    hls.on(Events.FRAG_BUFFERED, this.onFragBuffered, this);
    hls.on(Events.FRAG_LOADED, this.onFragLoaded, this);
  }
  _unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.BUFFER_APPENDED, this.onBufferAppended, this);
    hls.off(Events.FRAG_BUFFERED, this.onFragBuffered, this);
    hls.off(Events.FRAG_LOADED, this.onFragLoaded, this);
  }
  destroy() {
    this._unregisterListeners();
    // @ts-ignore
    this.fragments =
    // @ts-ignore
    this.activePartLists =
    // @ts-ignore
    this.endListFragments = this.timeRanges = null;
  }

  /**
   * Return a Fragment or Part with an appended range that matches the position and levelType
   * Otherwise, return null
   */
  getAppendedFrag(position, levelType) {
    const activeParts = this.activePartLists[levelType];
    if (activeParts) {
      for (let i = activeParts.length; i--;) {
        const activePart = activeParts[i];
        if (!activePart) {
          break;
        }
        const appendedPTS = activePart.end;
        if (activePart.start <= position && appendedPTS !== null && position <= appendedPTS) {
          return activePart;
        }
      }
    }
    return this.getBufferedFrag(position, levelType);
  }

  /**
   * Return a buffered Fragment that matches the position and levelType.
   * A buffered Fragment is one whose loading, parsing and appending is done (completed or "partial" meaning aborted).
   * If not found any Fragment, return null
   */
  getBufferedFrag(position, levelType) {
    return this.getFragAtPos(position, levelType, true);
  }
  getFragAtPos(position, levelType, buffered) {
    const {
      fragments
    } = this;
    const keys = Object.keys(fragments);
    for (let i = keys.length; i--;) {
      const fragmentEntity = fragments[keys[i]];
      if ((fragmentEntity == null ? void 0 : fragmentEntity.body.type) === levelType && (!buffered || fragmentEntity.buffered)) {
        const frag = fragmentEntity.body;
        if (frag.start <= position && position <= frag.end) {
          return frag;
        }
      }
    }
    return null;
  }

  /**
   * Partial fragments effected by coded frame eviction will be removed
   * The browser will unload parts of the buffer to free up memory for new buffer data
   * Fragments will need to be reloaded when the buffer is freed up, removing partial fragments will allow them to reload(since there might be parts that are still playable)
   */
  detectEvictedFragments(elementaryStream, timeRange, playlistType, appendedPart, removeAppending) {
    if (this.timeRanges) {
      this.timeRanges[elementaryStream] = timeRange;
    }
    // Check if any flagged fragments have been unloaded
    // excluding anything newer than appendedPartSn
    const appendedPartSn = (appendedPart == null ? void 0 : appendedPart.fragment.sn) || -1;
    Object.keys(this.fragments).forEach(key => {
      const fragmentEntity = this.fragments[key];
      if (!fragmentEntity) {
        return;
      }
      if (appendedPartSn >= fragmentEntity.body.sn) {
        return;
      }
      if (!fragmentEntity.buffered && (!fragmentEntity.loaded || removeAppending)) {
        if (fragmentEntity.body.type === playlistType) {
          this.removeFragment(fragmentEntity.body);
        }
        return;
      }
      const esData = fragmentEntity.range[elementaryStream];
      if (!esData) {
        return;
      }
      if (esData.time.length === 0) {
        this.removeFragment(fragmentEntity.body);
        return;
      }
      esData.time.some(time => {
        const isNotBuffered = !this.isTimeBuffered(time.startPTS, time.endPTS, timeRange);
        if (isNotBuffered) {
          // Unregister partial fragment as it needs to load again to be reused
          this.removeFragment(fragmentEntity.body);
        }
        return isNotBuffered;
      });
    });
  }

  /**
   * Checks if the fragment passed in is loaded in the buffer properly
   * Partially loaded fragments will be registered as a partial fragment
   */
  detectPartialFragments(data) {
    const timeRanges = this.timeRanges;
    if (!timeRanges || data.frag.sn === 'initSegment') {
      return;
    }
    const frag = data.frag;
    const fragKey = getFragmentKey(frag);
    const fragmentEntity = this.fragments[fragKey];
    if (!fragmentEntity || fragmentEntity.buffered && frag.gap) {
      return;
    }
    const isFragHint = !frag.relurl;
    Object.keys(timeRanges).forEach(elementaryStream => {
      const streamInfo = frag.elementaryStreams[elementaryStream];
      if (!streamInfo) {
        return;
      }
      const timeRange = timeRanges[elementaryStream];
      const partial = isFragHint || streamInfo.partial === true;
      fragmentEntity.range[elementaryStream] = this.getBufferedTimes(frag, data.part, partial, timeRange);
    });
    fragmentEntity.loaded = null;
    if (Object.keys(fragmentEntity.range).length) {
      fragmentEntity.buffered = true;
      const endList = fragmentEntity.body.endList = frag.endList || fragmentEntity.body.endList;
      if (endList) {
        this.endListFragments[fragmentEntity.body.type] = fragmentEntity;
      }
      if (!isPartial(fragmentEntity)) {
        // Remove older fragment parts from lookup after frag is tracked as buffered
        this.removeParts(frag.sn - 1, frag.type);
      }
    } else {
      // remove fragment if nothing was appended
      this.removeFragment(fragmentEntity.body);
    }
  }
  removeParts(snToKeep, levelType) {
    const activeParts = this.activePartLists[levelType];
    if (!activeParts) {
      return;
    }
    this.activePartLists[levelType] = filterParts(activeParts, part => part.fragment.sn >= snToKeep);
  }
  fragBuffered(frag, force) {
    const fragKey = getFragmentKey(frag);
    let fragmentEntity = this.fragments[fragKey];
    if (!fragmentEntity && force) {
      fragmentEntity = this.fragments[fragKey] = {
        body: frag,
        appendedPTS: null,
        loaded: null,
        buffered: false,
        range: Object.create(null)
      };
      if (frag.gap) {
        this.hasGaps = true;
      }
    }
    if (fragmentEntity) {
      fragmentEntity.loaded = null;
      fragmentEntity.buffered = true;
    }
  }
  getBufferedTimes(fragment, part, partial, timeRange) {
    const buffered = {
      time: [],
      partial
    };
    const startPTS = fragment.start;
    const endPTS = fragment.end;
    const minEndPTS = fragment.minEndPTS || endPTS;
    const maxStartPTS = fragment.maxStartPTS || startPTS;
    for (let i = 0; i < timeRange.length; i++) {
      const startTime = timeRange.start(i) - this.bufferPadding;
      const endTime = timeRange.end(i) + this.bufferPadding;
      if (maxStartPTS >= startTime && minEndPTS <= endTime) {
        // Fragment is entirely contained in buffer
        // No need to check the other timeRange times since it's completely playable
        buffered.time.push({
          startPTS: Math.max(startPTS, timeRange.start(i)),
          endPTS: Math.min(endPTS, timeRange.end(i))
        });
        break;
      } else if (startPTS < endTime && endPTS > startTime) {
        const start = Math.max(startPTS, timeRange.start(i));
        const end = Math.min(endPTS, timeRange.end(i));
        if (end > start) {
          buffered.partial = true;
          // Check for intersection with buffer
          // Get playable sections of the fragment
          buffered.time.push({
            startPTS: start,
            endPTS: end
          });
        }
      } else if (endPTS <= startTime) {
        // No need to check the rest of the timeRange as it is in order
        break;
      }
    }
    return buffered;
  }

  /**
   * Gets the partial fragment for a certain time
   */
  getPartialFragment(time) {
    let bestFragment = null;
    let timePadding;
    let startTime;
    let endTime;
    let bestOverlap = 0;
    const {
      bufferPadding,
      fragments
    } = this;
    Object.keys(fragments).forEach(key => {
      const fragmentEntity = fragments[key];
      if (!fragmentEntity) {
        return;
      }
      if (isPartial(fragmentEntity)) {
        startTime = fragmentEntity.body.start - bufferPadding;
        endTime = fragmentEntity.body.end + bufferPadding;
        if (time >= startTime && time <= endTime) {
          // Use the fragment that has the most padding from start and end time
          timePadding = Math.min(time - startTime, endTime - time);
          if (bestOverlap <= timePadding) {
            bestFragment = fragmentEntity.body;
            bestOverlap = timePadding;
          }
        }
      }
    });
    return bestFragment;
  }
  isEndListAppended(type) {
    const lastFragmentEntity = this.endListFragments[type];
    return lastFragmentEntity !== undefined && (lastFragmentEntity.buffered || isPartial(lastFragmentEntity));
  }
  getState(fragment) {
    const fragKey = getFragmentKey(fragment);
    const fragmentEntity = this.fragments[fragKey];
    if (fragmentEntity) {
      if (!fragmentEntity.buffered) {
        return FragmentState.APPENDING;
      } else if (isPartial(fragmentEntity)) {
        return FragmentState.PARTIAL;
      } else {
        return FragmentState.OK;
      }
    }
    return FragmentState.NOT_LOADED;
  }
  isTimeBuffered(startPTS, endPTS, timeRange) {
    let startTime;
    let endTime;
    for (let i = 0; i < timeRange.length; i++) {
      startTime = timeRange.start(i) - this.bufferPadding;
      endTime = timeRange.end(i) + this.bufferPadding;
      if (startPTS >= startTime && endPTS <= endTime) {
        return true;
      }
      if (endPTS <= startTime) {
        // No need to check the rest of the timeRange as it is in order
        return false;
      }
    }
    return false;
  }
  onManifestLoading() {
    this.removeAllFragments();
  }
  onFragLoaded(event, data) {
    // don't track initsegment (for which sn is not a number)
    // don't track frags used for bitrateTest, they're irrelevant.
    if (data.frag.sn === 'initSegment' || data.frag.bitrateTest) {
      return;
    }
    const frag = data.frag;
    // Fragment entity `loaded` FragLoadedData is null when loading parts
    const loaded = data.part ? null : data;
    const fragKey = getFragmentKey(frag);
    this.fragments[fragKey] = {
      body: frag,
      appendedPTS: null,
      loaded,
      buffered: false,
      range: Object.create(null)
    };
  }
  onBufferAppended(event, data) {
    const {
      frag,
      part,
      timeRanges,
      type
    } = data;
    if (frag.sn === 'initSegment') {
      return;
    }
    const playlistType = frag.type;
    if (part) {
      let activeParts = this.activePartLists[playlistType];
      if (!activeParts) {
        this.activePartLists[playlistType] = activeParts = [];
      }
      activeParts.push(part);
    }
    // Store the latest timeRanges loaded in the buffer
    this.timeRanges = timeRanges;
    const timeRange = timeRanges[type];
    this.detectEvictedFragments(type, timeRange, playlistType, part);
  }
  onFragBuffered(event, data) {
    this.detectPartialFragments(data);
  }
  hasFragment(fragment) {
    const fragKey = getFragmentKey(fragment);
    return !!this.fragments[fragKey];
  }
  hasFragments(type) {
    const {
      fragments
    } = this;
    const keys = Object.keys(fragments);
    if (!type) {
      return keys.length > 0;
    }
    for (let i = keys.length; i--;) {
      const fragmentEntity = fragments[keys[i]];
      if ((fragmentEntity == null ? void 0 : fragmentEntity.body.type) === type) {
        return true;
      }
    }
    return false;
  }
  hasParts(type) {
    var _this$activePartLists;
    return !!((_this$activePartLists = this.activePartLists[type]) != null && _this$activePartLists.length);
  }
  removeFragmentsInRange(start, end, playlistType, withGapOnly, unbufferedOnly) {
    if (withGapOnly && !this.hasGaps) {
      return;
    }
    Object.keys(this.fragments).forEach(key => {
      const fragmentEntity = this.fragments[key];
      if (!fragmentEntity) {
        return;
      }
      const frag = fragmentEntity.body;
      if (frag.type !== playlistType || withGapOnly && !frag.gap) {
        return;
      }
      if (frag.start < end && frag.end > start && (fragmentEntity.buffered || unbufferedOnly)) {
        this.removeFragment(frag);
      }
    });
  }
  removeFragment(fragment) {
    const fragKey = getFragmentKey(fragment);
    fragment.clearElementaryStreamInfo();
    const activeParts = this.activePartLists[fragment.type];
    if (activeParts) {
      const snToRemove = fragment.sn;
      this.activePartLists[fragment.type] = filterParts(activeParts, part => part.fragment.sn !== snToRemove);
    }
    delete this.fragments[fragKey];
    if (fragment.endList) {
      delete this.endListFragments[fragment.type];
    }
  }
  removeAllFragments() {
    var _this$hls, _this$hls$latestLevel;
    this.fragments = Object.create(null);
    this.endListFragments = Object.create(null);
    this.activePartLists = Object.create(null);
    this.hasGaps = false;
    const partlist = (_this$hls = this.hls) == null ? void 0 : (_this$hls$latestLevel = _this$hls.latestLevelDetails) == null ? void 0 : _this$hls$latestLevel.partList;
    if (partlist) {
      partlist.forEach(part => part.clearElementaryStreamInfo());
    }
  }
}
function isPartial(fragmentEntity) {
  var _fragmentEntity$range, _fragmentEntity$range2, _fragmentEntity$range3;
  return fragmentEntity.buffered && (fragmentEntity.body.gap || ((_fragmentEntity$range = fragmentEntity.range.video) == null ? void 0 : _fragmentEntity$range.partial) || ((_fragmentEntity$range2 = fragmentEntity.range.audio) == null ? void 0 : _fragmentEntity$range2.partial) || ((_fragmentEntity$range3 = fragmentEntity.range.audiovideo) == null ? void 0 : _fragmentEntity$range3.partial));
}
function getFragmentKey(fragment) {
  return `${fragment.type}_${fragment.level}_${fragment.sn}`;
}
function filterParts(partList, predicate) {
  return partList.filter(part => {
    const keep = predicate(part);
    if (!keep) {
      part.clearElementaryStreamInfo();
    }
    return keep;
  });
}

var DecrypterAesMode = {
  cbc: 0,
  ctr: 1
};

class AESCrypto {
  constructor(subtle, iv, aesMode) {
    this.subtle = void 0;
    this.aesIV = void 0;
    this.aesMode = void 0;
    this.subtle = subtle;
    this.aesIV = iv;
    this.aesMode = aesMode;
  }
  decrypt(data, key) {
    switch (this.aesMode) {
      case DecrypterAesMode.cbc:
        return this.subtle.decrypt({
          name: 'AES-CBC',
          iv: this.aesIV
        }, key, data);
      case DecrypterAesMode.ctr:
        return this.subtle.decrypt({
          name: 'AES-CTR',
          counter: this.aesIV,
          length: 64
        },
        //64 : NIST SP800-38A standard suggests that the counter should occupy half of the counter block
        key, data);
      default:
        throw new Error(`[AESCrypto] invalid aes mode ${this.aesMode}`);
    }
  }
}

// PKCS7
function removePadding(array) {
  const outputBytes = array.byteLength;
  const paddingBytes = outputBytes && new DataView(array.buffer).getUint8(outputBytes - 1);
  if (paddingBytes) {
    return array.slice(0, outputBytes - paddingBytes);
  }
  return array;
}
class AESDecryptor {
  constructor() {
    this.rcon = [0x0, 0x1, 0x2, 0x4, 0x8, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
    this.subMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)];
    this.invSubMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)];
    this.sBox = new Uint32Array(256);
    this.invSBox = new Uint32Array(256);
    this.key = new Uint32Array(0);
    this.ksRows = 0;
    this.keySize = 0;
    this.keySchedule = void 0;
    this.invKeySchedule = void 0;
    this.initTable();
  }

  // Using view.getUint32() also swaps the byte order.
  uint8ArrayToUint32Array_(arrayBuffer) {
    const view = new DataView(arrayBuffer);
    const newArray = new Uint32Array(4);
    for (let i = 0; i < 4; i++) {
      newArray[i] = view.getUint32(i * 4);
    }
    return newArray;
  }
  initTable() {
    const sBox = this.sBox;
    const invSBox = this.invSBox;
    const subMix = this.subMix;
    const subMix0 = subMix[0];
    const subMix1 = subMix[1];
    const subMix2 = subMix[2];
    const subMix3 = subMix[3];
    const invSubMix = this.invSubMix;
    const invSubMix0 = invSubMix[0];
    const invSubMix1 = invSubMix[1];
    const invSubMix2 = invSubMix[2];
    const invSubMix3 = invSubMix[3];
    const d = new Uint32Array(256);
    let x = 0;
    let xi = 0;
    let i = 0;
    for (i = 0; i < 256; i++) {
      if (i < 128) {
        d[i] = i << 1;
      } else {
        d[i] = i << 1 ^ 0x11b;
      }
    }
    for (i = 0; i < 256; i++) {
      let sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
      sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
      sBox[x] = sx;
      invSBox[sx] = x;

      // Compute multiplication
      const x2 = d[x];
      const x4 = d[x2];
      const x8 = d[x4];

      // Compute sub/invSub bytes, mix columns tables
      let t = d[sx] * 0x101 ^ sx * 0x1010100;
      subMix0[x] = t << 24 | t >>> 8;
      subMix1[x] = t << 16 | t >>> 16;
      subMix2[x] = t << 8 | t >>> 24;
      subMix3[x] = t;

      // Compute inv sub bytes, inv mix columns tables
      t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
      invSubMix0[sx] = t << 24 | t >>> 8;
      invSubMix1[sx] = t << 16 | t >>> 16;
      invSubMix2[sx] = t << 8 | t >>> 24;
      invSubMix3[sx] = t;

      // Compute next counter
      if (!x) {
        x = xi = 1;
      } else {
        x = x2 ^ d[d[d[x8 ^ x2]]];
        xi ^= d[d[xi]];
      }
    }
  }
  expandKey(keyBuffer) {
    // convert keyBuffer to Uint32Array
    const key = this.uint8ArrayToUint32Array_(keyBuffer);
    let sameKey = true;
    let offset = 0;
    while (offset < key.length && sameKey) {
      sameKey = key[offset] === this.key[offset];
      offset++;
    }
    if (sameKey) {
      return;
    }
    this.key = key;
    const keySize = this.keySize = key.length;
    if (keySize !== 4 && keySize !== 6 && keySize !== 8) {
      throw new Error('Invalid aes key size=' + keySize);
    }
    const ksRows = this.ksRows = (keySize + 6 + 1) * 4;
    let ksRow;
    let invKsRow;
    const keySchedule = this.keySchedule = new Uint32Array(ksRows);
    const invKeySchedule = this.invKeySchedule = new Uint32Array(ksRows);
    const sbox = this.sBox;
    const rcon = this.rcon;
    const invSubMix = this.invSubMix;
    const invSubMix0 = invSubMix[0];
    const invSubMix1 = invSubMix[1];
    const invSubMix2 = invSubMix[2];
    const invSubMix3 = invSubMix[3];
    let prev;
    let t;
    for (ksRow = 0; ksRow < ksRows; ksRow++) {
      if (ksRow < keySize) {
        prev = keySchedule[ksRow] = key[ksRow];
        continue;
      }
      t = prev;
      if (ksRow % keySize === 0) {
        // Rot word
        t = t << 8 | t >>> 24;

        // Sub word
        t = sbox[t >>> 24] << 24 | sbox[t >>> 16 & 0xff] << 16 | sbox[t >>> 8 & 0xff] << 8 | sbox[t & 0xff];

        // Mix Rcon
        t ^= rcon[ksRow / keySize | 0] << 24;
      } else if (keySize > 6 && ksRow % keySize === 4) {
        // Sub word
        t = sbox[t >>> 24] << 24 | sbox[t >>> 16 & 0xff] << 16 | sbox[t >>> 8 & 0xff] << 8 | sbox[t & 0xff];
      }
      keySchedule[ksRow] = prev = (keySchedule[ksRow - keySize] ^ t) >>> 0;
    }
    for (invKsRow = 0; invKsRow < ksRows; invKsRow++) {
      ksRow = ksRows - invKsRow;
      if (invKsRow & 3) {
        t = keySchedule[ksRow];
      } else {
        t = keySchedule[ksRow - 4];
      }
      if (invKsRow < 4 || ksRow <= 4) {
        invKeySchedule[invKsRow] = t;
      } else {
        invKeySchedule[invKsRow] = invSubMix0[sbox[t >>> 24]] ^ invSubMix1[sbox[t >>> 16 & 0xff]] ^ invSubMix2[sbox[t >>> 8 & 0xff]] ^ invSubMix3[sbox[t & 0xff]];
      }
      invKeySchedule[invKsRow] = invKeySchedule[invKsRow] >>> 0;
    }
  }

  // Adding this as a method greatly improves performance.
  networkToHostOrderSwap(word) {
    return word << 24 | (word & 0xff00) << 8 | (word & 0xff0000) >> 8 | word >>> 24;
  }
  decrypt(inputArrayBuffer, offset, aesIV) {
    const nRounds = this.keySize + 6;
    const invKeySchedule = this.invKeySchedule;
    const invSBOX = this.invSBox;
    const invSubMix = this.invSubMix;
    const invSubMix0 = invSubMix[0];
    const invSubMix1 = invSubMix[1];
    const invSubMix2 = invSubMix[2];
    const invSubMix3 = invSubMix[3];
    const initVector = this.uint8ArrayToUint32Array_(aesIV);
    let initVector0 = initVector[0];
    let initVector1 = initVector[1];
    let initVector2 = initVector[2];
    let initVector3 = initVector[3];
    const inputInt32 = new Int32Array(inputArrayBuffer);
    const outputInt32 = new Int32Array(inputInt32.length);
    let t0, t1, t2, t3;
    let s0, s1, s2, s3;
    let inputWords0, inputWords1, inputWords2, inputWords3;
    let ksRow, i;
    const swapWord = this.networkToHostOrderSwap;
    while (offset < inputInt32.length) {
      inputWords0 = swapWord(inputInt32[offset]);
      inputWords1 = swapWord(inputInt32[offset + 1]);
      inputWords2 = swapWord(inputInt32[offset + 2]);
      inputWords3 = swapWord(inputInt32[offset + 3]);
      s0 = inputWords0 ^ invKeySchedule[0];
      s1 = inputWords3 ^ invKeySchedule[1];
      s2 = inputWords2 ^ invKeySchedule[2];
      s3 = inputWords1 ^ invKeySchedule[3];
      ksRow = 4;

      // Iterate through the rounds of decryption
      for (i = 1; i < nRounds; i++) {
        t0 = invSubMix0[s0 >>> 24] ^ invSubMix1[s1 >> 16 & 0xff] ^ invSubMix2[s2 >> 8 & 0xff] ^ invSubMix3[s3 & 0xff] ^ invKeySchedule[ksRow];
        t1 = invSubMix0[s1 >>> 24] ^ invSubMix1[s2 >> 16 & 0xff] ^ invSubMix2[s3 >> 8 & 0xff] ^ invSubMix3[s0 & 0xff] ^ invKeySchedule[ksRow + 1];
        t2 = invSubMix0[s2 >>> 24] ^ invSubMix1[s3 >> 16 & 0xff] ^ invSubMix2[s0 >> 8 & 0xff] ^ invSubMix3[s1 & 0xff] ^ invKeySchedule[ksRow + 2];
        t3 = invSubMix0[s3 >>> 24] ^ invSubMix1[s0 >> 16 & 0xff] ^ invSubMix2[s1 >> 8 & 0xff] ^ invSubMix3[s2 & 0xff] ^ invKeySchedule[ksRow + 3];
        // Update state
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
        ksRow = ksRow + 4;
      }

      // Shift rows, sub bytes, add round key
      t0 = invSBOX[s0 >>> 24] << 24 ^ invSBOX[s1 >> 16 & 0xff] << 16 ^ invSBOX[s2 >> 8 & 0xff] << 8 ^ invSBOX[s3 & 0xff] ^ invKeySchedule[ksRow];
      t1 = invSBOX[s1 >>> 24] << 24 ^ invSBOX[s2 >> 16 & 0xff] << 16 ^ invSBOX[s3 >> 8 & 0xff] << 8 ^ invSBOX[s0 & 0xff] ^ invKeySchedule[ksRow + 1];
      t2 = invSBOX[s2 >>> 24] << 24 ^ invSBOX[s3 >> 16 & 0xff] << 16 ^ invSBOX[s0 >> 8 & 0xff] << 8 ^ invSBOX[s1 & 0xff] ^ invKeySchedule[ksRow + 2];
      t3 = invSBOX[s3 >>> 24] << 24 ^ invSBOX[s0 >> 16 & 0xff] << 16 ^ invSBOX[s1 >> 8 & 0xff] << 8 ^ invSBOX[s2 & 0xff] ^ invKeySchedule[ksRow + 3];

      // Write
      outputInt32[offset] = swapWord(t0 ^ initVector0);
      outputInt32[offset + 1] = swapWord(t3 ^ initVector1);
      outputInt32[offset + 2] = swapWord(t2 ^ initVector2);
      outputInt32[offset + 3] = swapWord(t1 ^ initVector3);

      // reset initVector to last 4 unsigned int
      initVector0 = inputWords0;
      initVector1 = inputWords1;
      initVector2 = inputWords2;
      initVector3 = inputWords3;
      offset = offset + 4;
    }
    return outputInt32.buffer;
  }
}

class FastAESKey {
  constructor(subtle, key, aesMode) {
    this.subtle = void 0;
    this.key = void 0;
    this.aesMode = void 0;
    this.subtle = subtle;
    this.key = key;
    this.aesMode = aesMode;
  }
  expandKey() {
    const subtleAlgoName = getSubtleAlgoName(this.aesMode);
    return this.subtle.importKey('raw', this.key, {
      name: subtleAlgoName
    }, false, ['encrypt', 'decrypt']);
  }
}
function getSubtleAlgoName(aesMode) {
  switch (aesMode) {
    case DecrypterAesMode.cbc:
      return 'AES-CBC';
    case DecrypterAesMode.ctr:
      return 'AES-CTR';
    default:
      throw new Error(`[FastAESKey] invalid aes mode ${aesMode}`);
  }
}

const CHUNK_SIZE = 16; // 16 bytes, 128 bits

class Decrypter {
  constructor(config, {
    removePKCS7Padding = true
  } = {}) {
    this.logEnabled = true;
    this.removePKCS7Padding = void 0;
    this.subtle = null;
    this.softwareDecrypter = null;
    this.key = null;
    this.fastAesKey = null;
    this.remainderData = null;
    this.currentIV = null;
    this.currentResult = null;
    this.useSoftware = void 0;
    this.enableSoftwareAES = void 0;
    this.enableSoftwareAES = config.enableSoftwareAES;
    this.removePKCS7Padding = removePKCS7Padding;
    // built in decryptor expects PKCS7 padding
    if (removePKCS7Padding) {
      try {
        const browserCrypto = self.crypto;
        if (browserCrypto) {
          this.subtle = browserCrypto.subtle || browserCrypto.webkitSubtle;
        }
      } catch (e) {
        /* no-op */
      }
    }
    this.useSoftware = !this.subtle;
  }
  destroy() {
    this.subtle = null;
    this.softwareDecrypter = null;
    this.key = null;
    this.fastAesKey = null;
    this.remainderData = null;
    this.currentIV = null;
    this.currentResult = null;
  }
  isSync() {
    return this.useSoftware;
  }
  flush() {
    const {
      currentResult,
      remainderData
    } = this;
    if (!currentResult || remainderData) {
      this.reset();
      return null;
    }
    const data = new Uint8Array(currentResult);
    this.reset();
    if (this.removePKCS7Padding) {
      return removePadding(data);
    }
    return data;
  }
  reset() {
    this.currentResult = null;
    this.currentIV = null;
    this.remainderData = null;
    if (this.softwareDecrypter) {
      this.softwareDecrypter = null;
    }
  }
  decrypt(data, key, iv, aesMode) {
    if (this.useSoftware) {
      return new Promise((resolve, reject) => {
        const dataView = ArrayBuffer.isView(data) ? data : new Uint8Array(data);
        this.softwareDecrypt(dataView, key, iv, aesMode);
        const decryptResult = this.flush();
        if (decryptResult) {
          resolve(decryptResult.buffer);
        } else {
          reject(new Error('[softwareDecrypt] Failed to decrypt data'));
        }
      });
    }
    return this.webCryptoDecrypt(new Uint8Array(data), key, iv, aesMode);
  }

  // Software decryption is progressive. Progressive decryption may not return a result on each call. Any cached
  // data is handled in the flush() call
  softwareDecrypt(data, key, iv, aesMode) {
    const {
      currentIV,
      currentResult,
      remainderData
    } = this;
    if (aesMode !== DecrypterAesMode.cbc || key.byteLength !== 16) {
      hls_logger.warn('SoftwareDecrypt: can only handle AES-128-CBC');
      return null;
    }
    this.logOnce('JS AES decrypt');
    // The output is staggered during progressive parsing - the current result is cached, and emitted on the next call
    // This is done in order to strip PKCS7 padding, which is found at the end of each segment. We only know we've reached
    // the end on flush(), but by that time we have already received all bytes for the segment.
    // Progressive decryption does not work with WebCrypto

    if (remainderData) {
      data = appendUint8Array(remainderData, data);
      this.remainderData = null;
    }

    // Byte length must be a multiple of 16 (AES-128 = 128 bit blocks = 16 bytes)
    const currentChunk = this.getValidChunk(data);
    if (!currentChunk.length) {
      return null;
    }
    if (currentIV) {
      iv = currentIV;
    }
    let softwareDecrypter = this.softwareDecrypter;
    if (!softwareDecrypter) {
      softwareDecrypter = this.softwareDecrypter = new AESDecryptor();
    }
    softwareDecrypter.expandKey(key);
    const result = currentResult;
    this.currentResult = softwareDecrypter.decrypt(currentChunk.buffer, 0, iv);
    this.currentIV = currentChunk.slice(-16).buffer;
    if (!result) {
      return null;
    }
    return result;
  }
  webCryptoDecrypt(data, key, iv, aesMode) {
    if (this.key !== key || !this.fastAesKey) {
      if (!this.subtle) {
        return Promise.resolve(this.onWebCryptoError(data, key, iv, aesMode));
      }
      this.key = key;
      this.fastAesKey = new FastAESKey(this.subtle, key, aesMode);
    }
    return this.fastAesKey.expandKey().then(aesKey => {
      // decrypt using web crypto
      if (!this.subtle) {
        return Promise.reject(new Error('web crypto not initialized'));
      }
      this.logOnce('WebCrypto AES decrypt');
      const crypto = new AESCrypto(this.subtle, new Uint8Array(iv), aesMode);
      return crypto.decrypt(data.buffer, aesKey);
    }).catch(err => {
      hls_logger.warn(`[decrypter]: WebCrypto Error, disable WebCrypto API, ${err.name}: ${err.message}`);
      return this.onWebCryptoError(data, key, iv, aesMode);
    });
  }
  onWebCryptoError(data, key, iv, aesMode) {
    const enableSoftwareAES = this.enableSoftwareAES;
    if (enableSoftwareAES) {
      this.useSoftware = true;
      this.logEnabled = true;
      this.softwareDecrypt(data, key, iv, aesMode);
      const decryptResult = this.flush();
      if (decryptResult) {
        return decryptResult.buffer;
      }
    }
    throw new Error('WebCrypto' + (enableSoftwareAES ? ' and softwareDecrypt' : '') + ': failed to decrypt data');
  }
  getValidChunk(data) {
    let currentChunk = data;
    const splitPoint = data.length - data.length % CHUNK_SIZE;
    if (splitPoint !== data.length) {
      currentChunk = data.slice(0, splitPoint);
      this.remainderData = data.slice(splitPoint);
    }
    return currentChunk;
  }
  logOnce(msg) {
    if (!this.logEnabled) {
      return;
    }
    hls_logger.log(`[decrypter]: ${msg}`);
    this.logEnabled = false;
  }
}

const MIN_CHUNK_SIZE = Math.pow(2, 17); // 128kb

class FragmentLoader {
  constructor(config) {
    this.config = void 0;
    this.loader = null;
    this.partLoadTimeout = -1;
    this.config = config;
  }
  destroy() {
    if (this.loader) {
      this.loader.destroy();
      this.loader = null;
    }
  }
  abort() {
    if (this.loader) {
      // Abort the loader for current fragment. Only one may load at any given time
      this.loader.abort();
    }
  }
  load(frag, onProgress) {
    const url = frag.url;
    if (!url) {
      return Promise.reject(new LoadError({
        type: ErrorTypes.NETWORK_ERROR,
        details: ErrorDetails.FRAG_LOAD_ERROR,
        fatal: false,
        frag,
        error: new Error(`Fragment does not have a ${url ? 'part list' : 'url'}`),
        networkDetails: null
      }));
    }
    this.abort();
    const config = this.config;
    const FragmentILoader = config.fLoader;
    const DefaultILoader = config.loader;
    return new Promise((resolve, reject) => {
      if (this.loader) {
        this.loader.destroy();
      }
      if (frag.gap) {
        if (frag.tagList.some(tags => tags[0] === 'GAP')) {
          reject(createGapLoadError(frag));
          return;
        } else {
          // Reset temporary treatment as GAP tag
          frag.gap = false;
        }
      }
      const loader = this.loader = FragmentILoader ? new FragmentILoader(config) : new DefaultILoader(config);
      const loaderContext = createLoaderContext(frag);
      frag.loader = loader;
      const loadPolicy = getLoaderConfigWithoutReties(config.fragLoadPolicy.default);
      const loaderConfig = {
        loadPolicy,
        timeout: loadPolicy.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0,
        highWaterMark: frag.sn === 'initSegment' ? Infinity : MIN_CHUNK_SIZE
      };
      // Assign frag stats to the loader's stats reference
      frag.stats = loader.stats;
      const callbacks = {
        onSuccess: (response, stats, context, networkDetails) => {
          this.resetLoader(frag, loader);
          let payload = response.data;
          if (context.resetIV && frag.decryptdata) {
            frag.decryptdata.iv = new Uint8Array(payload.slice(0, 16));
            payload = payload.slice(16);
          }
          resolve({
            frag,
            part: null,
            payload,
            networkDetails
          });
        },
        onError: (response, context, networkDetails, stats) => {
          this.resetLoader(frag, loader);
          reject(new LoadError({
            type: ErrorTypes.NETWORK_ERROR,
            details: ErrorDetails.FRAG_LOAD_ERROR,
            fatal: false,
            frag,
            response: _objectSpread2({
              url,
              data: undefined
            }, response),
            error: new Error(`HTTP Error ${response.code} ${response.text}`),
            networkDetails,
            stats
          }));
        },
        onAbort: (stats, context, networkDetails) => {
          this.resetLoader(frag, loader);
          reject(new LoadError({
            type: ErrorTypes.NETWORK_ERROR,
            details: ErrorDetails.INTERNAL_ABORTED,
            fatal: false,
            frag,
            error: new Error('Aborted'),
            networkDetails,
            stats
          }));
        },
        onTimeout: (stats, context, networkDetails) => {
          this.resetLoader(frag, loader);
          reject(new LoadError({
            type: ErrorTypes.NETWORK_ERROR,
            details: ErrorDetails.FRAG_LOAD_TIMEOUT,
            fatal: false,
            frag,
            error: new Error(`Timeout after ${loaderConfig.timeout}ms`),
            networkDetails,
            stats
          }));
        }
      };
      if (onProgress) {
        callbacks.onProgress = (stats, context, data, networkDetails) => onProgress({
          frag,
          part: null,
          payload: data,
          networkDetails
        });
      }
      loader.load(loaderContext, loaderConfig, callbacks);
    });
  }
  loadPart(frag, part, onProgress) {
    this.abort();
    const config = this.config;
    const FragmentILoader = config.fLoader;
    const DefaultILoader = config.loader;
    return new Promise((resolve, reject) => {
      if (this.loader) {
        this.loader.destroy();
      }
      if (frag.gap || part.gap) {
        reject(createGapLoadError(frag, part));
        return;
      }
      const loader = this.loader = FragmentILoader ? new FragmentILoader(config) : new DefaultILoader(config);
      const loaderContext = createLoaderContext(frag, part);
      frag.loader = loader;
      // Should we define another load policy for parts?
      const loadPolicy = getLoaderConfigWithoutReties(config.fragLoadPolicy.default);
      const loaderConfig = {
        loadPolicy,
        timeout: loadPolicy.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0,
        highWaterMark: MIN_CHUNK_SIZE
      };
      // Assign part stats to the loader's stats reference
      part.stats = loader.stats;
      loader.load(loaderContext, loaderConfig, {
        onSuccess: (response, stats, context, networkDetails) => {
          this.resetLoader(frag, loader);
          this.updateStatsFromPart(frag, part);
          const partLoadedData = {
            frag,
            part,
            payload: response.data,
            networkDetails
          };
          onProgress(partLoadedData);
          resolve(partLoadedData);
        },
        onError: (response, context, networkDetails, stats) => {
          this.resetLoader(frag, loader);
          reject(new LoadError({
            type: ErrorTypes.NETWORK_ERROR,
            details: ErrorDetails.FRAG_LOAD_ERROR,
            fatal: false,
            frag,
            part,
            response: _objectSpread2({
              url: loaderContext.url,
              data: undefined
            }, response),
            error: new Error(`HTTP Error ${response.code} ${response.text}`),
            networkDetails,
            stats
          }));
        },
        onAbort: (stats, context, networkDetails) => {
          frag.stats.aborted = part.stats.aborted;
          this.resetLoader(frag, loader);
          reject(new LoadError({
            type: ErrorTypes.NETWORK_ERROR,
            details: ErrorDetails.INTERNAL_ABORTED,
            fatal: false,
            frag,
            part,
            error: new Error('Aborted'),
            networkDetails,
            stats
          }));
        },
        onTimeout: (stats, context, networkDetails) => {
          this.resetLoader(frag, loader);
          reject(new LoadError({
            type: ErrorTypes.NETWORK_ERROR,
            details: ErrorDetails.FRAG_LOAD_TIMEOUT,
            fatal: false,
            frag,
            part,
            error: new Error(`Timeout after ${loaderConfig.timeout}ms`),
            networkDetails,
            stats
          }));
        }
      });
    });
  }
  updateStatsFromPart(frag, part) {
    const fragStats = frag.stats;
    const partStats = part.stats;
    const partTotal = partStats.total;
    fragStats.loaded += partStats.loaded;
    if (partTotal) {
      const estTotalParts = Math.round(frag.duration / part.duration);
      const estLoadedParts = Math.min(Math.round(fragStats.loaded / partTotal), estTotalParts);
      const estRemainingParts = estTotalParts - estLoadedParts;
      const estRemainingBytes = estRemainingParts * Math.round(fragStats.loaded / estLoadedParts);
      fragStats.total = fragStats.loaded + estRemainingBytes;
    } else {
      fragStats.total = Math.max(fragStats.loaded, fragStats.total);
    }
    const fragLoading = fragStats.loading;
    const partLoading = partStats.loading;
    if (fragLoading.start) {
      // add to fragment loader latency
      fragLoading.first += partLoading.first - partLoading.start;
    } else {
      fragLoading.start = partLoading.start;
      fragLoading.first = partLoading.first;
    }
    fragLoading.end = partLoading.end;
  }
  resetLoader(frag, loader) {
    frag.loader = null;
    if (this.loader === loader) {
      self.clearTimeout(this.partLoadTimeout);
      this.loader = null;
    }
    loader.destroy();
  }
}
function createLoaderContext(frag, part = null) {
  const segment = part || frag;
  const loaderContext = {
    frag,
    part,
    responseType: 'arraybuffer',
    url: segment.url,
    headers: {},
    rangeStart: 0,
    rangeEnd: 0
  };
  const start = segment.byteRangeStartOffset;
  const end = segment.byteRangeEndOffset;
  if (isFiniteNumber(start) && isFiniteNumber(end)) {
    var _frag$decryptdata;
    let byteRangeStart = start;
    let byteRangeEnd = end;
    if (frag.sn === 'initSegment' && isMethodFullSegmentAesCbc((_frag$decryptdata = frag.decryptdata) == null ? void 0 : _frag$decryptdata.method)) {
      // MAP segment encrypted with method 'AES-128' or 'AES-256' (cbc), when served with HTTP Range,
      // has the unencrypted size specified in the range.
      // Ref: https://tools.ietf.org/html/draft-pantos-hls-rfc8216bis-08#section-6.3.6
      const fragmentLen = end - start;
      if (fragmentLen % 16) {
        byteRangeEnd = end + (16 - fragmentLen % 16);
      }
      if (start !== 0) {
        loaderContext.resetIV = true;
        byteRangeStart = start - 16;
      }
    }
    loaderContext.rangeStart = byteRangeStart;
    loaderContext.rangeEnd = byteRangeEnd;
  }
  return loaderContext;
}
function createGapLoadError(frag, part) {
  const error = new Error(`GAP ${frag.gap ? 'tag' : 'attribute'} found`);
  const errorData = {
    type: ErrorTypes.MEDIA_ERROR,
    details: ErrorDetails.FRAG_GAP,
    fatal: false,
    frag,
    error,
    networkDetails: null
  };
  if (part) {
    errorData.part = part;
  }
  (part ? part : frag).stats.aborted = true;
  return new LoadError(errorData);
}
function isMethodFullSegmentAesCbc(method) {
  return method === 'AES-128' || method === 'AES-256';
}
class LoadError extends Error {
  constructor(data) {
    super(data.error.message);
    this.data = void 0;
    this.data = data;
  }
}

/**
 * @ignore
 * Sub-class specialization of EventHandler base class.
 *
 * TaskLoop allows to schedule a task function being called (optionnaly repeatedly) on the main loop,
 * scheduled asynchroneously, avoiding recursive calls in the same tick.
 *
 * The task itself is implemented in `doTick`. It can be requested and called for single execution
 * using the `tick` method.
 *
 * It will be assured that the task execution method (`tick`) only gets called once per main loop "tick",
 * no matter how often it gets requested for execution. Execution in further ticks will be scheduled accordingly.
 *
 * If further execution requests have already been scheduled on the next tick, it can be checked with `hasNextTick`,
 * and cancelled with `clearNextTick`.
 *
 * The task can be scheduled as an interval repeatedly with a period as parameter (see `setInterval`, `clearInterval`).
 *
 * Sub-classes need to implement the `doTick` method which will effectively have the task execution routine.
 *
 * Further explanations:
 *
 * The baseclass has a `tick` method that will schedule the doTick call. It may be called synchroneously
 * only for a stack-depth of one. On re-entrant calls, sub-sequent calls are scheduled for next main loop ticks.
 *
 * When the task execution (`tick` method) is called in re-entrant way this is detected and
 * we are limiting the task execution per call stack to exactly one, but scheduling/post-poning further
 * task processing on the next main loop iteration (also known as "next tick" in the Node/JS runtime lingo).
 */
class TaskLoop extends hls_Logger {
  constructor(label, logger) {
    super(label, logger);
    this._boundTick = void 0;
    this._tickTimer = null;
    this._tickInterval = null;
    this._tickCallCount = 0;
    this._boundTick = this.tick.bind(this);
  }
  destroy() {
    this.onHandlerDestroying();
    this.onHandlerDestroyed();
  }
  onHandlerDestroying() {
    // clear all timers before unregistering from event bus
    this.clearNextTick();
    this.clearInterval();
  }
  onHandlerDestroyed() {}
  hasInterval() {
    return !!this._tickInterval;
  }
  hasNextTick() {
    return !!this._tickTimer;
  }

  /**
   * @param millis - Interval time (ms)
   * @eturns True when interval has been scheduled, false when already scheduled (no effect)
   */
  setInterval(millis) {
    if (!this._tickInterval) {
      this._tickCallCount = 0;
      this._tickInterval = self.setInterval(this._boundTick, millis);
      return true;
    }
    return false;
  }

  /**
   * @returns True when interval was cleared, false when none was set (no effect)
   */
  clearInterval() {
    if (this._tickInterval) {
      self.clearInterval(this._tickInterval);
      this._tickInterval = null;
      return true;
    }
    return false;
  }

  /**
   * @returns True when timeout was cleared, false when none was set (no effect)
   */
  clearNextTick() {
    if (this._tickTimer) {
      self.clearTimeout(this._tickTimer);
      this._tickTimer = null;
      return true;
    }
    return false;
  }

  /**
   * Will call the subclass doTick implementation in this main loop tick
   * or in the next one (via setTimeout(,0)) in case it has already been called
   * in this tick (in case this is a re-entrant call).
   */
  tick() {
    this._tickCallCount++;
    if (this._tickCallCount === 1) {
      this.doTick();
      // re-entrant call to tick from previous doTick call stack
      // -> schedule a call on the next main loop iteration to process this task processing request
      if (this._tickCallCount > 1) {
        // make sure only one timer exists at any time at max
        this.tickImmediate();
      }
      this._tickCallCount = 0;
    }
  }
  tickImmediate() {
    this.clearNextTick();
    this._tickTimer = self.setTimeout(this._boundTick, 0);
  }

  /**
   * For subclass to implement task logic
   * @abstract
   */
  doTick() {}
}

class ChunkMetadata {
  constructor(level, sn, id, size = 0, part = -1, partial = false) {
    this.level = void 0;
    this.sn = void 0;
    this.part = void 0;
    this.id = void 0;
    this.size = void 0;
    this.partial = void 0;
    this.transmuxing = getNewPerformanceTiming();
    this.buffering = {
      audio: getNewPerformanceTiming(),
      video: getNewPerformanceTiming(),
      audiovideo: getNewPerformanceTiming()
    };
    this.level = level;
    this.sn = sn;
    this.id = id;
    this.size = size;
    this.part = part;
    this.partial = partial;
  }
}
function getNewPerformanceTiming() {
  return {
    start: 0,
    executeStart: 0,
    executeEnd: 0,
    end: 0
  };
}

/**
 * Provides methods dealing with buffer length retrieval for example.
 *
 * In general, a helper around HTML5 MediaElement TimeRanges gathered from `buffered` property.
 *
 * Also @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/buffered
 */

const noopBuffered = {
  length: 0,
  start: () => 0,
  end: () => 0
};
class BufferHelper {
  /**
   * Return true if `media`'s buffered include `position`
   */
  static isBuffered(media, position) {
    if (media) {
      const buffered = BufferHelper.getBuffered(media);
      for (let i = buffered.length; i--;) {
        if (position >= buffered.start(i) && position <= buffered.end(i)) {
          return true;
        }
      }
    }
    return false;
  }
  static bufferedRanges(media) {
    if (media) {
      const timeRanges = BufferHelper.getBuffered(media);
      return BufferHelper.timeRangesToArray(timeRanges);
    }
    return [];
  }
  static timeRangesToArray(timeRanges) {
    const buffered = [];
    for (let i = 0; i < timeRanges.length; i++) {
      buffered.push({
        start: timeRanges.start(i),
        end: timeRanges.end(i)
      });
    }
    return buffered;
  }
  static bufferInfo(media, pos, maxHoleDuration) {
    if (media) {
      const buffered = BufferHelper.bufferedRanges(media);
      if (buffered.length) {
        return BufferHelper.bufferedInfo(buffered, pos, maxHoleDuration);
      }
    }
    return {
      len: 0,
      start: pos,
      end: pos,
      bufferedIndex: -1
    };
  }
  static bufferedInfo(buffered, pos, maxHoleDuration) {
    pos = Math.max(0, pos);
    // sort on buffer.start/smaller end (IE does not always return sorted buffered range)
    if (buffered.length > 1) {
      buffered.sort((a, b) => a.start - b.start || b.end - a.end);
    }
    let bufferedIndex = -1;
    let buffered2 = [];
    if (maxHoleDuration) {
      // there might be some small holes between buffer time range
      // consider that holes smaller than maxHoleDuration are irrelevant and build another
      // buffer time range representations that discards those holes
      for (let i = 0; i < buffered.length; i++) {
        if (pos >= buffered[i].start && pos <= buffered[i].end) {
          bufferedIndex = i;
        }
        const buf2len = buffered2.length;
        if (buf2len) {
          const buf2end = buffered2[buf2len - 1].end;
          // if small hole (value between 0 or maxHoleDuration ) or overlapping (negative)
          if (buffered[i].start - buf2end < maxHoleDuration) {
            // merge overlapping time ranges
            // update lastRange.end only if smaller than item.end
            // e.g.  [ 1, 15] with  [ 2,8] => [ 1,15] (no need to modify lastRange.end)
            // whereas [ 1, 8] with  [ 2,15] => [ 1,15] ( lastRange should switch from [1,8] to [1,15])
            if (buffered[i].end > buf2end) {
              buffered2[buf2len - 1].end = buffered[i].end;
            }
          } else {
            // big hole
            buffered2.push(buffered[i]);
          }
        } else {
          // first value
          buffered2.push(buffered[i]);
        }
      }
    } else {
      buffered2 = buffered;
    }
    let bufferLen = 0;
    let nextStart;

    // bufferStart and bufferEnd are buffer boundaries around current playback position (pos)
    let bufferStart = pos;
    let bufferEnd = pos;
    for (let i = 0; i < buffered2.length; i++) {
      const start = buffered2[i].start;
      const end = buffered2[i].end;
      // logger.log('buf start/end:' + buffered.start(i) + '/' + buffered.end(i));
      if (bufferedIndex === -1 && pos >= start && pos <= end) {
        bufferedIndex = i;
      }
      if (pos + maxHoleDuration >= start && pos < end) {
        // play position is inside this buffer TimeRange, retrieve end of buffer position and buffer length
        bufferStart = start;
        bufferEnd = end;
        bufferLen = bufferEnd - pos;
      } else if (pos + maxHoleDuration < start) {
        nextStart = start;
        break;
      }
    }
    return {
      len: bufferLen,
      start: bufferStart || 0,
      end: bufferEnd || 0,
      nextStart,
      buffered,
      bufferedIndex
    };
  }

  /**
   * Safe method to get buffered property.
   * SourceBuffer.buffered may throw if SourceBuffer is removed from it's MediaSource
   */
  static getBuffered(media) {
    try {
      return media.buffered || noopBuffered;
    } catch (e) {
      hls_logger.log('failed to get media.buffered', e);
      return noopBuffered;
    }
  }
}

const VARIABLE_REPLACEMENT_REGEX = /\{\$([a-zA-Z0-9-_]+)\}/g;
function hasVariableReferences(str) {
  return VARIABLE_REPLACEMENT_REGEX.test(str);
}
function substituteVariables(parsed, value) {
  if (parsed.variableList !== null || parsed.hasVariableRefs) {
    const variableList = parsed.variableList;
    return value.replace(VARIABLE_REPLACEMENT_REGEX, variableReference => {
      const variableName = variableReference.substring(2, variableReference.length - 1);
      const variableValue = variableList == null ? void 0 : variableList[variableName];
      if (variableValue === undefined) {
        parsed.playlistParsingError || (parsed.playlistParsingError = new Error(`Missing preceding EXT-X-DEFINE tag for Variable Reference: "${variableName}"`));
        return variableReference;
      }
      return variableValue;
    });
  }
  return value;
}
function addVariableDefinition(parsed, attr, parentUrl) {
  let variableList = parsed.variableList;
  if (!variableList) {
    parsed.variableList = variableList = {};
  }
  let NAME;
  let VALUE;
  if ('QUERYPARAM' in attr) {
    NAME = attr.QUERYPARAM;
    try {
      const searchParams = new self.URL(parentUrl).searchParams;
      if (searchParams.has(NAME)) {
        VALUE = searchParams.get(NAME);
      } else {
        throw new Error(`"${NAME}" does not match any query parameter in URI: "${parentUrl}"`);
      }
    } catch (error) {
      parsed.playlistParsingError || (parsed.playlistParsingError = new Error(`EXT-X-DEFINE QUERYPARAM: ${error.message}`));
    }
  } else {
    NAME = attr.NAME;
    VALUE = attr.VALUE;
  }
  if (NAME in variableList) {
    parsed.playlistParsingError || (parsed.playlistParsingError = new Error(`EXT-X-DEFINE duplicate Variable Name declarations: "${NAME}"`));
  } else {
    variableList[NAME] = VALUE || '';
  }
}
function importVariableDefinition(parsed, attr, sourceVariableList) {
  const IMPORT = attr.IMPORT;
  if (sourceVariableList && IMPORT in sourceVariableList) {
    let variableList = parsed.variableList;
    if (!variableList) {
      parsed.variableList = variableList = {};
    }
    variableList[IMPORT] = sourceVariableList[IMPORT];
  } else {
    parsed.playlistParsingError || (parsed.playlistParsingError = new Error(`EXT-X-DEFINE IMPORT attribute not found in Multivariant Playlist: "${IMPORT}"`));
  }
}

const DECIMAL_RESOLUTION_REGEX = /^(\d+)x(\d+)$/;
const ATTR_LIST_REGEX = /(.+?)=(".*?"|.*?)(?:,|$)/g;

// adapted from https://github.com/kanongil/node-m3u8parse/blob/master/attrlist.js
class AttrList {
  constructor(attrs, parsed) {
    if (typeof attrs === 'string') {
      attrs = AttrList.parseAttrList(attrs, parsed);
    }
    _extends(this, attrs);
  }
  get clientAttrs() {
    return Object.keys(this).filter(attr => attr.substring(0, 2) === 'X-');
  }
  decimalInteger(attrName) {
    const intValue = parseInt(this[attrName], 10);
    if (intValue > Number.MAX_SAFE_INTEGER) {
      return Infinity;
    }
    return intValue;
  }
  hexadecimalInteger(attrName) {
    if (this[attrName]) {
      let stringValue = (this[attrName] || '0x').slice(2);
      stringValue = (stringValue.length & 1 ? '0' : '') + stringValue;
      const value = new Uint8Array(stringValue.length / 2);
      for (let i = 0; i < stringValue.length / 2; i++) {
        value[i] = parseInt(stringValue.slice(i * 2, i * 2 + 2), 16);
      }
      return value;
    }
    return null;
  }
  hexadecimalIntegerAsNumber(attrName) {
    const intValue = parseInt(this[attrName], 16);
    if (intValue > Number.MAX_SAFE_INTEGER) {
      return Infinity;
    }
    return intValue;
  }
  decimalFloatingPoint(attrName) {
    return parseFloat(this[attrName]);
  }
  optionalFloat(attrName, defaultValue) {
    const value = this[attrName];
    return value ? parseFloat(value) : defaultValue;
  }
  enumeratedString(attrName) {
    return this[attrName];
  }
  enumeratedStringList(attrName, dict) {
    const attrValue = this[attrName];
    return (attrValue ? attrValue.split(/[ ,]+/) : []).reduce((result, identifier) => {
      result[identifier.toLowerCase()] = true;
      return result;
    }, dict);
  }
  bool(attrName) {
    return this[attrName] === 'YES';
  }
  decimalResolution(attrName) {
    const res = DECIMAL_RESOLUTION_REGEX.exec(this[attrName]);
    if (res === null) {
      return undefined;
    }
    return {
      width: parseInt(res[1], 10),
      height: parseInt(res[2], 10)
    };
  }
  static parseAttrList(input, parsed) {
    let match;
    const attrs = {};
    const quote = '"';
    ATTR_LIST_REGEX.lastIndex = 0;
    while ((match = ATTR_LIST_REGEX.exec(input)) !== null) {
      const name = match[1].trim();
      let value = match[2];
      const quotedString = value.indexOf(quote) === 0 && value.lastIndexOf(quote) === value.length - 1;
      let hexadecimalSequence = false;
      if (quotedString) {
        value = value.slice(1, -1);
      } else {
        switch (name) {
          case 'IV':
          case 'SCTE35-CMD':
          case 'SCTE35-IN':
          case 'SCTE35-OUT':
            hexadecimalSequence = true;
        }
      }
      if (parsed && (quotedString || hexadecimalSequence)) {
        {
          value = substituteVariables(parsed, value);
        }
      } else if (!hexadecimalSequence && !quotedString) {
        switch (name) {
          case 'CLOSED-CAPTIONS':
            if (value === 'NONE') {
              break;
            }
          // falls through
          case 'ALLOWED-CPC':
          case 'CLASS':
          case 'ASSOC-LANGUAGE':
          case 'AUDIO':
          case 'BYTERANGE':
          case 'CHANNELS':
          case 'CHARACTERISTICS':
          case 'CODECS':
          case 'DATA-ID':
          case 'END-DATE':
          case 'GROUP-ID':
          case 'ID':
          case 'IMPORT':
          case 'INSTREAM-ID':
          case 'KEYFORMAT':
          case 'KEYFORMATVERSIONS':
          case 'LANGUAGE':
          case 'NAME':
          case 'PATHWAY-ID':
          case 'QUERYPARAM':
          case 'RECENTLY-REMOVED-DATERANGES':
          case 'SERVER-URI':
          case 'STABLE-RENDITION-ID':
          case 'STABLE-VARIANT-ID':
          case 'START-DATE':
          case 'SUBTITLES':
          case 'SUPPLEMENTAL-CODECS':
          case 'URI':
          case 'VALUE':
          case 'VIDEO':
          case 'X-ASSET-LIST':
          case 'X-ASSET-URI':
            // Since we are not checking tag:attribute combination, just warn rather than ignoring attribute
            hls_logger.warn(`${input}: attribute ${name} is missing quotes`);
          // continue;
        }
      }
      attrs[name] = value;
    }
    return attrs;
  }
}

// Avoid exporting const enum so that these values can be inlined

const CLASS_INTERSTITIAL = 'com.apple.hls.interstitial';
function isDateRangeCueAttribute(attrName) {
  return attrName !== "ID" && attrName !== "CLASS" && attrName !== "CUE" && attrName !== "START-DATE" && attrName !== "DURATION" && attrName !== "END-DATE" && attrName !== "END-ON-NEXT";
}
function isSCTE35Attribute(attrName) {
  return attrName === "SCTE35-OUT" || attrName === "SCTE35-IN" || attrName === "SCTE35-CMD";
}
class DateRange {
  constructor(dateRangeAttr, dateRangeWithSameId, tagCount = 0) {
    var _dateRangeWithSameId$;
    this.attr = void 0;
    this.tagAnchor = void 0;
    this.tagOrder = void 0;
    this._startDate = void 0;
    this._endDate = void 0;
    this._dateAtEnd = void 0;
    this._cue = void 0;
    this._badValueForSameId = void 0;
    this.tagAnchor = (dateRangeWithSameId == null ? void 0 : dateRangeWithSameId.tagAnchor) || null;
    this.tagOrder = (_dateRangeWithSameId$ = dateRangeWithSameId == null ? void 0 : dateRangeWithSameId.tagOrder) != null ? _dateRangeWithSameId$ : tagCount;
    if (dateRangeWithSameId) {
      const previousAttr = dateRangeWithSameId.attr;
      for (const key in previousAttr) {
        if (Object.prototype.hasOwnProperty.call(dateRangeAttr, key) && dateRangeAttr[key] !== previousAttr[key]) {
          hls_logger.warn(`DATERANGE tag attribute: "${key}" does not match for tags with ID: "${dateRangeAttr.ID}"`);
          this._badValueForSameId = key;
          break;
        }
      }
      // Merge DateRange tags with the same ID
      dateRangeAttr = _extends(new AttrList({}), previousAttr, dateRangeAttr);
    }
    this.attr = dateRangeAttr;
    if (dateRangeWithSameId) {
      this._startDate = dateRangeWithSameId._startDate;
      this._cue = dateRangeWithSameId._cue;
      this._endDate = dateRangeWithSameId._endDate;
      this._dateAtEnd = dateRangeWithSameId._dateAtEnd;
    } else {
      this._startDate = new Date(dateRangeAttr["START-DATE"]);
    }
    if ("END-DATE" in this.attr) {
      const endDate = (dateRangeWithSameId == null ? void 0 : dateRangeWithSameId.endDate) || new Date(this.attr["END-DATE"]);
      if (isFiniteNumber(endDate.getTime())) {
        this._endDate = endDate;
      }
    }
  }
  get id() {
    return this.attr.ID;
  }
  get class() {
    return this.attr.CLASS;
  }
  get cue() {
    const _cue = this._cue;
    if (_cue === undefined) {
      return this._cue = this.attr.enumeratedStringList(this.attr.CUE ? 'CUE' : 'X-CUE', {
        pre: false,
        post: false,
        once: false
      });
    }
    return _cue;
  }
  get startTime() {
    const {
      tagAnchor
    } = this;
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    if (tagAnchor === null || tagAnchor.programDateTime === null) {
      hls_logger.warn(`Expected tagAnchor Fragment with PDT set for DateRange "${this.id}": ${tagAnchor}`);
      return NaN;
    }
    return tagAnchor.start + (this.startDate.getTime() - tagAnchor.programDateTime) / 1000;
  }
  get startDate() {
    return this._startDate;
  }
  get endDate() {
    const dateAtEnd = this._endDate || this._dateAtEnd;
    if (dateAtEnd) {
      return dateAtEnd;
    }
    const duration = this.duration;
    if (duration !== null) {
      return this._dateAtEnd = new Date(this._startDate.getTime() + duration * 1000);
    }
    return null;
  }
  get duration() {
    if ("DURATION" in this.attr) {
      const duration = this.attr.decimalFloatingPoint("DURATION");
      if (isFiniteNumber(duration)) {
        return duration;
      }
    } else if (this._endDate) {
      return (this._endDate.getTime() - this._startDate.getTime()) / 1000;
    }
    return null;
  }
  get plannedDuration() {
    if ("PLANNED-DURATION" in this.attr) {
      return this.attr.decimalFloatingPoint("PLANNED-DURATION");
    }
    return null;
  }
  get endOnNext() {
    return this.attr.bool("END-ON-NEXT");
  }
  get isInterstitial() {
    return this.class === CLASS_INTERSTITIAL;
  }
  get isValid() {
    return !!this.id && !this._badValueForSameId && isFiniteNumber(this.startDate.getTime()) && (this.duration === null || this.duration >= 0) && (!this.endOnNext || !!this.class) && (!this.attr.CUE || !this.cue.pre && !this.cue.post || this.cue.pre !== this.cue.post) && (!this.isInterstitial || 'X-ASSET-URI' in this.attr || 'X-ASSET-LIST' in this.attr);
  }
}

const DEFAULT_TARGET_DURATION = 10;

/**
 * Object representing parsed data from an HLS Media Playlist. Found in {@link hls.js#Level.details}.
 */
class LevelDetails {
  constructor(baseUrl) {
    this.PTSKnown = false;
    this.alignedSliding = false;
    this.averagetargetduration = void 0;
    this.endCC = 0;
    this.endSN = 0;
    this.fragments = void 0;
    this.fragmentHint = void 0;
    this.partList = null;
    this.dateRanges = void 0;
    this.dateRangeTagCount = 0;
    this.live = true;
    this.requestScheduled = -1;
    this.ageHeader = 0;
    this.advancedDateTime = void 0;
    this.updated = true;
    this.advanced = true;
    this.misses = 0;
    this.startCC = 0;
    this.startSN = 0;
    this.startTimeOffset = null;
    this.targetduration = 0;
    this.totalduration = 0;
    this.type = null;
    this.url = void 0;
    this.m3u8 = '';
    this.version = null;
    this.canBlockReload = false;
    this.canSkipUntil = 0;
    this.canSkipDateRanges = false;
    this.skippedSegments = 0;
    this.recentlyRemovedDateranges = void 0;
    this.partHoldBack = 0;
    this.holdBack = 0;
    this.partTarget = 0;
    this.preloadHint = void 0;
    this.renditionReports = void 0;
    this.tuneInGoal = 0;
    this.deltaUpdateFailed = void 0;
    this.driftStartTime = 0;
    this.driftEndTime = 0;
    this.driftStart = 0;
    this.driftEnd = 0;
    this.encryptedFragments = void 0;
    this.playlistParsingError = null;
    this.variableList = null;
    this.hasVariableRefs = false;
    this.appliedTimelineOffset = void 0;
    this.fragments = [];
    this.encryptedFragments = [];
    this.dateRanges = {};
    this.url = baseUrl;
  }
  reloaded(previous) {
    if (!previous) {
      this.advanced = true;
      this.updated = true;
      return;
    }
    const partSnDiff = this.lastPartSn - previous.lastPartSn;
    const partIndexDiff = this.lastPartIndex - previous.lastPartIndex;
    this.updated = this.endSN !== previous.endSN || !!partIndexDiff || !!partSnDiff || !this.live;
    this.advanced = this.endSN > previous.endSN || partSnDiff > 0 || partSnDiff === 0 && partIndexDiff > 0;
    if (this.updated || this.advanced) {
      this.misses = Math.floor(previous.misses * 0.6);
    } else {
      this.misses = previous.misses + 1;
    }
  }
  get hasProgramDateTime() {
    if (this.fragments.length) {
      return isFiniteNumber(this.fragments[this.fragments.length - 1].programDateTime);
    }
    return false;
  }
  get levelTargetDuration() {
    return this.averagetargetduration || this.targetduration || DEFAULT_TARGET_DURATION;
  }
  get drift() {
    const runTime = this.driftEndTime - this.driftStartTime;
    if (runTime > 0) {
      const runDuration = this.driftEnd - this.driftStart;
      return runDuration * 1000 / runTime;
    }
    return 1;
  }
  get edge() {
    return this.partEnd || this.fragmentEnd;
  }
  get partEnd() {
    var _this$partList;
    if ((_this$partList = this.partList) != null && _this$partList.length) {
      return this.partList[this.partList.length - 1].end;
    }
    return this.fragmentEnd;
  }
  get fragmentEnd() {
    var _this$fragments;
    if ((_this$fragments = this.fragments) != null && _this$fragments.length) {
      return this.fragments[this.fragments.length - 1].end;
    }
    return 0;
  }
  get fragmentStart() {
    var _this$fragments2;
    if ((_this$fragments2 = this.fragments) != null && _this$fragments2.length) {
      return this.fragments[0].start;
    }
    return 0;
  }
  get age() {
    if (this.advancedDateTime) {
      return Math.max(Date.now() - this.advancedDateTime, 0) / 1000;
    }
    return 0;
  }
  get lastPartIndex() {
    var _this$partList2;
    if ((_this$partList2 = this.partList) != null && _this$partList2.length) {
      return this.partList[this.partList.length - 1].index;
    }
    return -1;
  }
  get maxPartIndex() {
    const partList = this.partList;
    if (partList) {
      const lastIndex = this.lastPartIndex;
      if (lastIndex !== -1) {
        for (let i = partList.length; i--;) {
          if (partList[i].index > lastIndex) {
            return partList[i].index;
          }
        }
        return lastIndex;
      }
    }
    return 0;
  }
  get lastPartSn() {
    var _this$partList3;
    if ((_this$partList3 = this.partList) != null && _this$partList3.length) {
      return this.partList[this.partList.length - 1].fragment.sn;
    }
    return this.endSN;
  }
  get expired() {
    if (this.live && this.age && this.misses < 3) {
      const playlistWindowDuration = this.partEnd - this.fragmentStart;
      return this.age > Math.max(playlistWindowDuration, this.totalduration) + this.levelTargetDuration;
    }
    return false;
  }
}

function isFullSegmentEncryption(method) {
  return method === 'AES-128' || method === 'AES-256' || method === 'AES-256-CTR';
}
function getAesModeFromFullSegmentMethod(method) {
  switch (method) {
    case 'AES-128':
    case 'AES-256':
      return DecrypterAesMode.cbc;
    case 'AES-256-CTR':
      return DecrypterAesMode.ctr;
    default:
      throw new Error(`invalid full segment method ${method}`);
  }
}

function base64Decode(base64encodedStr) {
  return Uint8Array.from(atob(base64encodedStr), c => c.charCodeAt(0));
}

// breaking up those two types in order to clarify what is happening in the decoding path.

// http://stackoverflow.com/questions/8936984/uint8array-to-string-in-javascript/22373197
// http://www.onicos.com/staff/iz/amuse/javascript/expert/utf.txt
/* utf.js - UTF-8 <=> UTF-16 convertion
 *
 * Copyright (C) 1999 Masanao Izumo <iz@onicos.co.jp>
 * Version: 1.0
 * LastModified: Dec 25 1999
 * This library is free.  You can redistribute it and/or modify it.
 */

function strToUtf8array(str) {
  return Uint8Array.from(unescape(encodeURIComponent(str)), c => c.charCodeAt(0));
}

function getKeyIdBytes(str) {
  const keyIdbytes = strToUtf8array(str).subarray(0, 16);
  const paddedkeyIdbytes = new Uint8Array(16);
  paddedkeyIdbytes.set(keyIdbytes, 16 - keyIdbytes.length);
  return paddedkeyIdbytes;
}
function changeEndianness(keyId) {
  const swap = function swap(array, from, to) {
    const cur = array[from];
    array[from] = array[to];
    array[to] = cur;
  };
  swap(keyId, 0, 3);
  swap(keyId, 1, 2);
  swap(keyId, 4, 5);
  swap(keyId, 6, 7);
}
function convertDataUriToArrayBytes(uri) {
  // data:[<media type][;attribute=value][;base64],<data>
  const colonsplit = uri.split(':');
  let keydata = null;
  if (colonsplit[0] === 'data' && colonsplit.length === 2) {
    const semicolonsplit = colonsplit[1].split(';');
    const commasplit = semicolonsplit[semicolonsplit.length - 1].split(',');
    if (commasplit.length === 2) {
      const isbase64 = commasplit[0] === 'base64';
      const data = commasplit[1];
      if (isbase64) {
        semicolonsplit.splice(-1, 1); // remove from processing
        keydata = base64Decode(data);
      } else {
        keydata = getKeyIdBytes(data);
      }
    }
  }
  return keydata;
}

/** returns `undefined` is `self` is missing, e.g. in node */
const optionalSelf = typeof self !== 'undefined' ? self : undefined;

/**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Navigator/requestMediaKeySystemAccess
 */
var KeySystems = {
  CLEARKEY: "org.w3.clearkey",
  FAIRPLAY: "com.apple.fps",
  PLAYREADY: "com.microsoft.playready",
  WIDEVINE: "com.widevine.alpha"
};

// Playlist #EXT-X-KEY KEYFORMAT values
var KeySystemFormats = {
  CLEARKEY: "org.w3.clearkey",
  FAIRPLAY: "com.apple.streamingkeydelivery",
  PLAYREADY: "com.microsoft.playready",
  WIDEVINE: "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed"
};
function keySystemFormatToKeySystemDomain(format) {
  switch (format) {
    case KeySystemFormats.FAIRPLAY:
      return KeySystems.FAIRPLAY;
    case KeySystemFormats.PLAYREADY:
      return KeySystems.PLAYREADY;
    case KeySystemFormats.WIDEVINE:
      return KeySystems.WIDEVINE;
    case KeySystemFormats.CLEARKEY:
      return KeySystems.CLEARKEY;
  }
}

// System IDs for which we can extract a key ID from "encrypted" event PSSH
var KeySystemIds = {
  CENC: "1077efecc0b24d02ace33c1e52e2fb4b",
  CLEARKEY: "e2719d58a985b3c9781ab030af78d30e",
  PLAYREADY: "9a04f07998404286ab92e65be0885f95",
  WIDEVINE: "edef8ba979d64acea3c827dcd51d21ed"
};
function keySystemIdToKeySystemDomain(systemId) {
  if (systemId === KeySystemIds.WIDEVINE) {
    return KeySystems.WIDEVINE;
  } else if (systemId === KeySystemIds.PLAYREADY) {
    return KeySystems.PLAYREADY;
  } else if (systemId === KeySystemIds.CENC || systemId === KeySystemIds.CLEARKEY) {
    return KeySystems.CLEARKEY;
  }
}
function keySystemDomainToKeySystemFormat(keySystem) {
  switch (keySystem) {
    case KeySystems.FAIRPLAY:
      return KeySystemFormats.FAIRPLAY;
    case KeySystems.PLAYREADY:
      return KeySystemFormats.PLAYREADY;
    case KeySystems.WIDEVINE:
      return KeySystemFormats.WIDEVINE;
    case KeySystems.CLEARKEY:
      return KeySystemFormats.CLEARKEY;
  }
}
function getKeySystemsForConfig(config) {
  const {
    drmSystems,
    widevineLicenseUrl
  } = config;
  const keySystemsToAttempt = drmSystems ? [KeySystems.FAIRPLAY, KeySystems.WIDEVINE, KeySystems.PLAYREADY, KeySystems.CLEARKEY].filter(keySystem => !!drmSystems[keySystem]) : [];
  if (!keySystemsToAttempt[KeySystems.WIDEVINE] && widevineLicenseUrl) {
    keySystemsToAttempt.push(KeySystems.WIDEVINE);
  }
  return keySystemsToAttempt;
}
const requestMediaKeySystemAccess = function (_optionalSelf$navigat) {
  if (optionalSelf != null && (_optionalSelf$navigat = optionalSelf.navigator) != null && _optionalSelf$navigat.requestMediaKeySystemAccess) {
    return self.navigator.requestMediaKeySystemAccess.bind(self.navigator);
  } else {
    return null;
  }
}();

/**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/MediaKeySystemConfiguration
 */
function getSupportedMediaKeySystemConfigurations(keySystem, audioCodecs, videoCodecs, drmSystemOptions) {
  let initDataTypes;
  switch (keySystem) {
    case KeySystems.FAIRPLAY:
      initDataTypes = ['cenc', 'sinf'];
      break;
    case KeySystems.WIDEVINE:
    case KeySystems.PLAYREADY:
      initDataTypes = ['cenc'];
      break;
    case KeySystems.CLEARKEY:
      initDataTypes = ['cenc', 'keyids'];
      break;
    default:
      throw new Error(`Unknown key-system: ${keySystem}`);
  }
  return createMediaKeySystemConfigurations(initDataTypes, audioCodecs, videoCodecs, drmSystemOptions);
}
function createMediaKeySystemConfigurations(initDataTypes, audioCodecs, videoCodecs, drmSystemOptions) {
  const baseConfig = {
    initDataTypes: initDataTypes,
    persistentState: drmSystemOptions.persistentState || 'optional',
    distinctiveIdentifier: drmSystemOptions.distinctiveIdentifier || 'optional',
    sessionTypes: drmSystemOptions.sessionTypes || [drmSystemOptions.sessionType || 'temporary'],
    audioCapabilities: audioCodecs.map(codec => ({
      contentType: `audio/mp4; codecs=${codec}`,
      robustness: drmSystemOptions.audioRobustness || '',
      encryptionScheme: drmSystemOptions.audioEncryptionScheme || null
    })),
    videoCapabilities: videoCodecs.map(codec => ({
      contentType: `video/mp4; codecs=${codec}`,
      robustness: drmSystemOptions.videoRobustness || '',
      encryptionScheme: drmSystemOptions.videoEncryptionScheme || null
    }))
  };
  return [baseConfig];
}
function isPersistentSessionType(drmSystemOptions) {
  var _drmSystemOptions$ses;
  return drmSystemOptions.sessionType === 'persistent-license' || !!((_drmSystemOptions$ses = drmSystemOptions.sessionTypes) != null && _drmSystemOptions$ses.some(type => type === 'persistent-license'));
}
function parsePlayReadyWRM(keyBytes) {
  const keyBytesUtf16 = new Uint16Array(keyBytes.buffer, keyBytes.byteOffset, keyBytes.byteLength / 2);
  const keyByteStr = String.fromCharCode.apply(null, Array.from(keyBytesUtf16));

  // Parse Playready WRMHeader XML
  const xmlKeyBytes = keyByteStr.substring(keyByteStr.indexOf('<'), keyByteStr.length);
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(xmlKeyBytes, 'text/xml');
  const keyData = xmlDoc.getElementsByTagName('KID')[0];
  if (keyData) {
    const keyId = keyData.childNodes[0] ? keyData.childNodes[0].nodeValue : keyData.getAttribute('VALUE');
    if (keyId) {
      const keyIdArray = base64Decode(keyId).subarray(0, 16);
      // KID value in PRO is a base64-encoded little endian GUID interpretation of UUID
      // KID value in ‘tenc’ is a big endian UUID GUID interpretation of UUID
      changeEndianness(keyIdArray);
      return keyIdArray;
    }
  }
  return null;
}

let keyUriToKeyIdMap = {};
class LevelKey {
  static clearKeyUriToKeyIdMap() {
    keyUriToKeyIdMap = {};
  }
  constructor(method, uri, format, formatversions = [1], iv = null) {
    this.uri = void 0;
    this.method = void 0;
    this.keyFormat = void 0;
    this.keyFormatVersions = void 0;
    this.encrypted = void 0;
    this.isCommonEncryption = void 0;
    this.iv = null;
    this.key = null;
    this.keyId = null;
    this.pssh = null;
    this.method = method;
    this.uri = uri;
    this.keyFormat = format;
    this.keyFormatVersions = formatversions;
    this.iv = iv;
    this.encrypted = method ? method !== 'NONE' : false;
    this.isCommonEncryption = this.encrypted && !isFullSegmentEncryption(method);
  }
  isSupported() {
    // If it's Segment encryption or No encryption, just select that key system
    if (this.method) {
      if (isFullSegmentEncryption(this.method) || this.method === 'NONE') {
        return true;
      }
      if (this.keyFormat === 'identity') {
        // Maintain support for clear SAMPLE-AES with MPEG-3 TS
        return this.method === 'SAMPLE-AES';
      } else {
        switch (this.keyFormat) {
          case KeySystemFormats.FAIRPLAY:
          case KeySystemFormats.WIDEVINE:
          case KeySystemFormats.PLAYREADY:
          case KeySystemFormats.CLEARKEY:
            return ['ISO-23001-7', 'SAMPLE-AES', 'SAMPLE-AES-CENC', 'SAMPLE-AES-CTR'].indexOf(this.method) !== -1;
        }
      }
    }
    return false;
  }
  getDecryptData(sn) {
    if (!this.encrypted || !this.uri) {
      return null;
    }
    if (isFullSegmentEncryption(this.method) && this.uri && !this.iv) {
      if (typeof sn !== 'number') {
        // We are fetching decryption data for a initialization segment
        // If the segment was encrypted with AES-128/256
        // It must have an IV defined. We cannot substitute the Segment Number in.
        hls_logger.warn(`missing IV for initialization segment with method="${this.method}" - compliance issue`);

        // Explicitly set sn to resulting value from implicit conversions 'initSegment' values for IV generation.
        sn = 0;
      }
      const iv = createInitializationVector(sn);
      const decryptdata = new LevelKey(this.method, this.uri, 'identity', this.keyFormatVersions, iv);
      return decryptdata;
    }

    // Initialize keyId if possible
    const keyBytes = convertDataUriToArrayBytes(this.uri);
    if (keyBytes) {
      switch (this.keyFormat) {
        case KeySystemFormats.WIDEVINE:
          // Setting `pssh` on this LevelKey/DecryptData allows HLS.js to generate a session using
          // the playlist-key before the "encrypted" event. (Comment out to only use "encrypted" path.)
          this.pssh = keyBytes;
          // In case of widevine keyID is embedded in PSSH box. Read Key ID.
          if (keyBytes.length >= 22) {
            this.keyId = keyBytes.subarray(keyBytes.length - 22, keyBytes.length - 6);
          }
          break;
        case KeySystemFormats.PLAYREADY:
          {
            const PlayReadyKeySystemUUID = new Uint8Array([0x9a, 0x04, 0xf0, 0x79, 0x98, 0x40, 0x42, 0x86, 0xab, 0x92, 0xe6, 0x5b, 0xe0, 0x88, 0x5f, 0x95]);

            // Setting `pssh` on this LevelKey/DecryptData allows HLS.js to generate a session using
            // the playlist-key before the "encrypted" event. (Comment out to only use "encrypted" path.)
            this.pssh = mp4pssh(PlayReadyKeySystemUUID, null, keyBytes);
            this.keyId = parsePlayReadyWRM(keyBytes);
            break;
          }
        default:
          {
            let keydata = keyBytes.subarray(0, 16);
            if (keydata.length !== 16) {
              const padded = new Uint8Array(16);
              padded.set(keydata, 16 - keydata.length);
              keydata = padded;
            }
            this.keyId = keydata;
            break;
          }
      }
    }

    // Default behavior: assign a new keyId for each uri
    if (!this.keyId || this.keyId.byteLength !== 16) {
      let keyId = keyUriToKeyIdMap[this.uri];
      if (!keyId) {
        const val = Object.keys(keyUriToKeyIdMap).length % Number.MAX_SAFE_INTEGER;
        keyId = new Uint8Array(16);
        const dv = new DataView(keyId.buffer, 12, 4); // Just set the last 4 bytes
        dv.setUint32(0, val);
        keyUriToKeyIdMap[this.uri] = keyId;
      }
      this.keyId = keyId;
    }
    return this;
  }
}
function createInitializationVector(segmentNumber) {
  const uint8View = new Uint8Array(16);
  for (let i = 12; i < 16; i++) {
    uint8View[i] = segmentNumber >> 8 * (15 - i) & 0xff;
  }
  return uint8View;
}

const MASTER_PLAYLIST_REGEX = /#EXT-X-STREAM-INF:([^\r\n]*)(?:[\r\n](?:#[^\r\n]*)?)*([^\r\n]+)|#EXT-X-(SESSION-DATA|SESSION-KEY|DEFINE|CONTENT-STEERING|START):([^\r\n]*)[\r\n]+/g;
const MASTER_PLAYLIST_MEDIA_REGEX = /#EXT-X-MEDIA:(.*)/g;
const IS_MEDIA_PLAYLIST = /^#EXT(?:INF|-X-TARGETDURATION):/m; // Handle empty Media Playlist (first EXTINF not signaled, but TARGETDURATION present)

const LEVEL_PLAYLIST_REGEX_FAST = new RegExp([/#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source,
// duration (#EXTINF:<duration>,<title>), group 1 => duration, group 2 => title
/(?!#) *(\S[^\r\n]*)/.source,
// segment URI, group 3 => the URI (note newline is not eaten)
/#.*/.source // All other non-segment oriented tags will match with all groups empty
].join('|'), 'g');
const LEVEL_PLAYLIST_REGEX_SLOW = new RegExp([/#EXT-X-(PROGRAM-DATE-TIME|BYTERANGE|DATERANGE|DEFINE|KEY|MAP|PART|PART-INF|PLAYLIST-TYPE|PRELOAD-HINT|RENDITION-REPORT|SERVER-CONTROL|SKIP|START):(.+)/.source, /#EXT-X-(BITRATE|DISCONTINUITY-SEQUENCE|MEDIA-SEQUENCE|TARGETDURATION|VERSION): *(\d+)/.source, /#EXT-X-(DISCONTINUITY|ENDLIST|GAP|INDEPENDENT-SEGMENTS)/.source, /(#)([^:]*):(.*)/.source, /(#)(.*)(?:.*)\r?\n?/.source].join('|'));
class M3U8Parser {
  static findGroup(groups, mediaGroupId) {
    for (let i = 0; i < groups.length; i++) {
      const group = groups[i];
      if (group.id === mediaGroupId) {
        return group;
      }
    }
  }
  static resolve(url, baseUrl) {
    return urlToolkitExports.buildAbsoluteURL(baseUrl, url, {
      alwaysNormalize: true
    });
  }
  static isMediaPlaylist(str) {
    return IS_MEDIA_PLAYLIST.test(str);
  }
  static parseMasterPlaylist(string, baseurl) {
    const hasVariableRefs = hasVariableReferences(string) ;
    const parsed = {
      contentSteering: null,
      levels: [],
      playlistParsingError: null,
      sessionData: null,
      sessionKeys: null,
      startTimeOffset: null,
      variableList: null,
      hasVariableRefs
    };
    const levelsWithKnownCodecs = [];
    MASTER_PLAYLIST_REGEX.lastIndex = 0;
    let result;
    while ((result = MASTER_PLAYLIST_REGEX.exec(string)) != null) {
      if (result[1]) {
        var _level$unknownCodecs;
        // '#EXT-X-STREAM-INF' is found, parse level tag  in group 1
        const attrs = new AttrList(result[1], parsed);
        const uri = substituteVariables(parsed, result[2]) ;
        const level = {
          attrs,
          bitrate: attrs.decimalInteger('BANDWIDTH') || attrs.decimalInteger('AVERAGE-BANDWIDTH'),
          name: attrs.NAME,
          url: M3U8Parser.resolve(uri, baseurl)
        };
        const resolution = attrs.decimalResolution('RESOLUTION');
        if (resolution) {
          level.width = resolution.width;
          level.height = resolution.height;
        }
        setCodecs(attrs.CODECS, level);
        const supplementalCodecs = attrs['SUPPLEMENTAL-CODECS'];
        if (supplementalCodecs) {
          level.supplemental = {};
          setCodecs(supplementalCodecs, level.supplemental);
        }
        if (!((_level$unknownCodecs = level.unknownCodecs) != null && _level$unknownCodecs.length)) {
          levelsWithKnownCodecs.push(level);
        }
        parsed.levels.push(level);
      } else if (result[3]) {
        const tag = result[3];
        const attributes = result[4];
        switch (tag) {
          case 'SESSION-DATA':
            {
              // #EXT-X-SESSION-DATA
              const sessionAttrs = new AttrList(attributes, parsed);
              const dataId = sessionAttrs['DATA-ID'];
              if (dataId) {
                if (parsed.sessionData === null) {
                  parsed.sessionData = {};
                }
                parsed.sessionData[dataId] = sessionAttrs;
              }
              break;
            }
          case 'SESSION-KEY':
            {
              // #EXT-X-SESSION-KEY
              const sessionKey = parseKey(attributes, baseurl, parsed);
              if (sessionKey.encrypted && sessionKey.isSupported()) {
                if (parsed.sessionKeys === null) {
                  parsed.sessionKeys = [];
                }
                parsed.sessionKeys.push(sessionKey);
              } else {
                hls_logger.warn(`[Keys] Ignoring invalid EXT-X-SESSION-KEY tag: "${attributes}"`);
              }
              break;
            }
          case 'DEFINE':
            {
              // #EXT-X-DEFINE
              {
                const variableAttributes = new AttrList(attributes, parsed);
                addVariableDefinition(parsed, variableAttributes, baseurl);
              }
              break;
            }
          case 'CONTENT-STEERING':
            {
              // #EXT-X-CONTENT-STEERING
              const contentSteeringAttributes = new AttrList(attributes, parsed);
              parsed.contentSteering = {
                uri: M3U8Parser.resolve(contentSteeringAttributes['SERVER-URI'], baseurl),
                pathwayId: contentSteeringAttributes['PATHWAY-ID'] || '.'
              };
              break;
            }
          case 'START':
            {
              // #EXT-X-START
              parsed.startTimeOffset = parseStartTimeOffset(attributes);
              break;
            }
        }
      }
    }
    // Filter out levels with unknown codecs if it does not remove all levels
    const stripUnknownCodecLevels = levelsWithKnownCodecs.length > 0 && levelsWithKnownCodecs.length < parsed.levels.length;
    parsed.levels = stripUnknownCodecLevels ? levelsWithKnownCodecs : parsed.levels;
    if (parsed.levels.length === 0) {
      parsed.playlistParsingError = new Error('no levels found in manifest');
    }
    return parsed;
  }
  static parseMasterPlaylistMedia(string, baseurl, parsed) {
    let result;
    const results = {};
    const levels = parsed.levels;
    const groupsByType = {
      AUDIO: levels.map(level => ({
        id: level.attrs.AUDIO,
        audioCodec: level.audioCodec
      })),
      SUBTITLES: levels.map(level => ({
        id: level.attrs.SUBTITLES,
        textCodec: level.textCodec
      })),
      'CLOSED-CAPTIONS': []
    };
    let id = 0;
    MASTER_PLAYLIST_MEDIA_REGEX.lastIndex = 0;
    while ((result = MASTER_PLAYLIST_MEDIA_REGEX.exec(string)) !== null) {
      const attrs = new AttrList(result[1], parsed);
      const type = attrs.TYPE;
      if (type) {
        const groups = groupsByType[type];
        const medias = results[type] || [];
        results[type] = medias;
        const lang = attrs.LANGUAGE;
        const assocLang = attrs['ASSOC-LANGUAGE'];
        const channels = attrs.CHANNELS;
        const characteristics = attrs.CHARACTERISTICS;
        const instreamId = attrs['INSTREAM-ID'];
        const media = {
          attrs,
          bitrate: 0,
          id: id++,
          groupId: attrs['GROUP-ID'] || '',
          name: attrs.NAME || lang || '',
          type,
          default: attrs.bool('DEFAULT'),
          autoselect: attrs.bool('AUTOSELECT'),
          forced: attrs.bool('FORCED'),
          lang,
          url: attrs.URI ? M3U8Parser.resolve(attrs.URI, baseurl) : ''
        };
        if (assocLang) {
          media.assocLang = assocLang;
        }
        if (channels) {
          media.channels = channels;
        }
        if (characteristics) {
          media.characteristics = characteristics;
        }
        if (instreamId) {
          media.instreamId = instreamId;
        }
        if (groups != null && groups.length) {
          // If there are audio or text groups signalled in the manifest, let's look for a matching codec string for this track
          // If we don't find the track signalled, lets use the first audio groups codec we have
          // Acting as a best guess
          const groupCodec = M3U8Parser.findGroup(groups, media.groupId) || groups[0];
          assignCodec(media, groupCodec, 'audioCodec');
          assignCodec(media, groupCodec, 'textCodec');
        }
        medias.push(media);
      }
    }
    return results;
  }
  static parseLevelPlaylist(string, baseurl, id, type, levelUrlId, multivariantVariableList) {
    var _LEVEL_PLAYLIST_REGEX;
    const base = {
      url: baseurl
    };
    const level = new LevelDetails(baseurl);
    const fragments = level.fragments;
    const programDateTimes = [];
    // The most recent init segment seen (applies to all subsequent segments)
    let currentInitSegment = null;
    let currentSN = 0;
    let currentPart = 0;
    let totalduration = 0;
    let discontinuityCounter = 0;
    let currentBitrate = 0;
    let prevFrag = null;
    let frag = new Fragment(type, base);
    let result;
    let i;
    let levelkeys;
    let firstPdtIndex = -1;
    let createNextFrag = false;
    let nextByteRange = null;
    let serverControlAttrs;
    LEVEL_PLAYLIST_REGEX_FAST.lastIndex = 0;
    level.m3u8 = string;
    level.hasVariableRefs = hasVariableReferences(string) ;
    if (((_LEVEL_PLAYLIST_REGEX = LEVEL_PLAYLIST_REGEX_FAST.exec(string)) == null ? void 0 : _LEVEL_PLAYLIST_REGEX[0]) !== '#EXTM3U') {
      level.playlistParsingError = new Error('Missing format identifier #EXTM3U');
      return level;
    }
    while ((result = LEVEL_PLAYLIST_REGEX_FAST.exec(string)) !== null) {
      if (createNextFrag) {
        createNextFrag = false;
        frag = new Fragment(type, base);
        // setup the next fragment for part loading
        frag.playlistOffset = totalduration;
        frag.start = totalduration;
        frag.sn = currentSN;
        frag.cc = discontinuityCounter;
        if (currentBitrate) {
          frag.bitrate = currentBitrate;
        }
        frag.level = id;
        if (currentInitSegment) {
          frag.initSegment = currentInitSegment;
          if (currentInitSegment.rawProgramDateTime) {
            frag.rawProgramDateTime = currentInitSegment.rawProgramDateTime;
            currentInitSegment.rawProgramDateTime = null;
          }
          if (nextByteRange) {
            frag.setByteRange(nextByteRange);
            nextByteRange = null;
          }
        }
      }
      const duration = result[1];
      if (duration) {
        // INF
        frag.duration = parseFloat(duration);
        // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
        const title = (' ' + result[2]).slice(1);
        frag.title = title || null;
        frag.tagList.push(title ? ['INF', duration, title] : ['INF', duration]);
      } else if (result[3]) {
        // url
        if (isFiniteNumber(frag.duration)) {
          frag.playlistOffset = totalduration;
          frag.start = totalduration;
          if (levelkeys) {
            setFragLevelKeys(frag, levelkeys, level);
          }
          frag.sn = currentSN;
          frag.level = id;
          frag.cc = discontinuityCounter;
          fragments.push(frag);
          // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
          const uri = (' ' + result[3]).slice(1);
          frag.relurl = substituteVariables(level, uri) ;
          assignProgramDateTime(frag, prevFrag, programDateTimes);
          prevFrag = frag;
          totalduration += frag.duration;
          currentSN++;
          currentPart = 0;
          createNextFrag = true;
        }
      } else {
        result = result[0].match(LEVEL_PLAYLIST_REGEX_SLOW);
        if (!result) {
          hls_logger.warn('No matches on slow regex match for level playlist!');
          continue;
        }
        for (i = 1; i < result.length; i++) {
          if (result[i] !== undefined) {
            break;
          }
        }

        // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
        const tag = (' ' + result[i]).slice(1);
        const value1 = (' ' + result[i + 1]).slice(1);
        const value2 = result[i + 2] ? (' ' + result[i + 2]).slice(1) : null;
        switch (tag) {
          case 'BYTERANGE':
            if (prevFrag) {
              frag.setByteRange(value1, prevFrag);
            } else {
              frag.setByteRange(value1);
            }
            break;
          case 'PROGRAM-DATE-TIME':
            // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
            frag.rawProgramDateTime = value1;
            frag.tagList.push(['PROGRAM-DATE-TIME', value1]);
            if (firstPdtIndex === -1) {
              firstPdtIndex = fragments.length;
            }
            break;
          case 'PLAYLIST-TYPE':
            if (level.type) {
              assignMultipleMediaPlaylistTagOccuranceError(level, tag, result);
            }
            level.type = value1.toUpperCase();
            break;
          case 'MEDIA-SEQUENCE':
            if (level.startSN !== 0) {
              assignMultipleMediaPlaylistTagOccuranceError(level, tag, result);
            } else if (fragments.length > 0) {
              assignMustAppearBeforeSegmentsError(level, tag, result);
            }
            currentSN = level.startSN = parseInt(value1);
            break;
          case 'SKIP':
            {
              if (level.skippedSegments) {
                assignMultipleMediaPlaylistTagOccuranceError(level, tag, result);
              }
              const skipAttrs = new AttrList(value1, level);
              const skippedSegments = skipAttrs.decimalInteger('SKIPPED-SEGMENTS');
              if (isFiniteNumber(skippedSegments)) {
                level.skippedSegments += skippedSegments;
                // This will result in fragments[] containing undefined values, which we will fill in with `mergeDetails`
                for (let _i = skippedSegments; _i--;) {
                  fragments.push(null);
                }
                currentSN += skippedSegments;
              }
              const recentlyRemovedDateranges = skipAttrs.enumeratedString('RECENTLY-REMOVED-DATERANGES');
              if (recentlyRemovedDateranges) {
                level.recentlyRemovedDateranges = (level.recentlyRemovedDateranges || []).concat(recentlyRemovedDateranges.split('\t'));
              }
              break;
            }
          case 'TARGETDURATION':
            if (level.targetduration !== 0) {
              assignMultipleMediaPlaylistTagOccuranceError(level, tag, result);
            }
            level.targetduration = Math.max(parseInt(value1), 1);
            break;
          case 'VERSION':
            if (level.version !== null) {
              assignMultipleMediaPlaylistTagOccuranceError(level, tag, result);
            }
            level.version = parseInt(value1);
            break;
          case 'INDEPENDENT-SEGMENTS':
            break;
          case 'ENDLIST':
            if (!level.live) {
              assignMultipleMediaPlaylistTagOccuranceError(level, tag, result);
            }
            level.live = false;
            break;
          case '#':
            if (value1 || value2) {
              frag.tagList.push(value2 ? [value1, value2] : [value1]);
            }
            break;
          case 'DISCONTINUITY':
            discontinuityCounter++;
            frag.tagList.push(['DIS']);
            break;
          case 'GAP':
            frag.gap = true;
            frag.tagList.push([tag]);
            break;
          case 'BITRATE':
            frag.tagList.push([tag, value1]);
            currentBitrate = parseInt(value1) * 1000;
            if (isFiniteNumber(currentBitrate)) {
              frag.bitrate = currentBitrate;
            } else {
              currentBitrate = 0;
            }
            break;
          case 'DATERANGE':
            {
              const dateRangeAttr = new AttrList(value1, level);
              const dateRange = new DateRange(dateRangeAttr, level.dateRanges[dateRangeAttr.ID], level.dateRangeTagCount);
              level.dateRangeTagCount++;
              if (dateRange.isValid || level.skippedSegments) {
                level.dateRanges[dateRange.id] = dateRange;
              } else {
                hls_logger.warn(`Ignoring invalid DATERANGE tag: "${value1}"`);
              }
              // Add to fragment tag list for backwards compatibility (< v1.2.0)
              frag.tagList.push(['EXT-X-DATERANGE', value1]);
              break;
            }
          case 'DEFINE':
            {
              {
                const variableAttributes = new AttrList(value1, level);
                if ('IMPORT' in variableAttributes) {
                  importVariableDefinition(level, variableAttributes, multivariantVariableList);
                } else {
                  addVariableDefinition(level, variableAttributes, baseurl);
                }
              }
              break;
            }
          case 'DISCONTINUITY-SEQUENCE':
            if (level.startCC !== 0) {
              assignMultipleMediaPlaylistTagOccuranceError(level, tag, result);
            } else if (fragments.length > 0) {
              assignMustAppearBeforeSegmentsError(level, tag, result);
            }
            level.startCC = discontinuityCounter = parseInt(value1);
            break;
          case 'KEY':
            {
              const levelKey = parseKey(value1, baseurl, level);
              if (levelKey.isSupported()) {
                if (levelKey.method === 'NONE') {
                  levelkeys = undefined;
                  break;
                }
                if (!levelkeys) {
                  levelkeys = {};
                }
                if (levelkeys[levelKey.keyFormat]) {
                  levelkeys = _extends({}, levelkeys);
                }
                levelkeys[levelKey.keyFormat] = levelKey;
              } else {
                hls_logger.warn(`[Keys] Ignoring invalid EXT-X-KEY tag: "${value1}"`);
              }
              break;
            }
          case 'START':
            level.startTimeOffset = parseStartTimeOffset(value1);
            break;
          case 'MAP':
            {
              const mapAttrs = new AttrList(value1, level);
              if (frag.duration) {
                // Initial segment tag is after segment duration tag.
                //   #EXTINF: 6.0
                //   #EXT-X-MAP:URI="init.mp4
                const init = new Fragment(type, base);
                setInitSegment(init, mapAttrs, id, levelkeys);
                currentInitSegment = init;
                frag.initSegment = currentInitSegment;
                if (currentInitSegment.rawProgramDateTime && !frag.rawProgramDateTime) {
                  frag.rawProgramDateTime = currentInitSegment.rawProgramDateTime;
                }
              } else {
                // Initial segment tag is before segment duration tag
                // Handle case where EXT-X-MAP is declared after EXT-X-BYTERANGE
                const end = frag.byteRangeEndOffset;
                if (end) {
                  const start = frag.byteRangeStartOffset;
                  nextByteRange = `${end - start}@${start}`;
                } else {
                  nextByteRange = null;
                }
                setInitSegment(frag, mapAttrs, id, levelkeys);
                currentInitSegment = frag;
                createNextFrag = true;
              }
              currentInitSegment.cc = discontinuityCounter;
              break;
            }
          case 'SERVER-CONTROL':
            {
              if (serverControlAttrs) {
                assignMultipleMediaPlaylistTagOccuranceError(level, tag, result);
              }
              serverControlAttrs = new AttrList(value1);
              level.canBlockReload = serverControlAttrs.bool('CAN-BLOCK-RELOAD');
              level.canSkipUntil = serverControlAttrs.optionalFloat('CAN-SKIP-UNTIL', 0);
              level.canSkipDateRanges = level.canSkipUntil > 0 && serverControlAttrs.bool('CAN-SKIP-DATERANGES');
              level.partHoldBack = serverControlAttrs.optionalFloat('PART-HOLD-BACK', 0);
              level.holdBack = serverControlAttrs.optionalFloat('HOLD-BACK', 0);
              break;
            }
          case 'PART-INF':
            {
              if (level.partTarget) {
                assignMultipleMediaPlaylistTagOccuranceError(level, tag, result);
              }
              const partInfAttrs = new AttrList(value1);
              level.partTarget = partInfAttrs.decimalFloatingPoint('PART-TARGET');
              break;
            }
          case 'PART':
            {
              let partList = level.partList;
              if (!partList) {
                partList = level.partList = [];
              }
              const previousFragmentPart = currentPart > 0 ? partList[partList.length - 1] : undefined;
              const index = currentPart++;
              const partAttrs = new AttrList(value1, level);
              const part = new Part(partAttrs, frag, base, index, previousFragmentPart);
              partList.push(part);
              frag.duration += part.duration;
              break;
            }
          case 'PRELOAD-HINT':
            {
              const preloadHintAttrs = new AttrList(value1, level);
              level.preloadHint = preloadHintAttrs;
              break;
            }
          case 'RENDITION-REPORT':
            {
              const renditionReportAttrs = new AttrList(value1, level);
              level.renditionReports = level.renditionReports || [];
              level.renditionReports.push(renditionReportAttrs);
              break;
            }
          default:
            hls_logger.warn(`line parsed but not handled: ${result}`);
            break;
        }
      }
    }
    if (prevFrag && !prevFrag.relurl) {
      fragments.pop();
      totalduration -= prevFrag.duration;
      if (level.partList) {
        level.fragmentHint = prevFrag;
      }
    } else if (level.partList) {
      assignProgramDateTime(frag, prevFrag, programDateTimes);
      frag.cc = discontinuityCounter;
      level.fragmentHint = frag;
      if (levelkeys) {
        setFragLevelKeys(frag, levelkeys, level);
      }
    }
    if (!level.targetduration) {
      level.playlistParsingError = new Error(`#EXT-X-TARGETDURATION is required`);
    }
    const fragmentLength = fragments.length;
    const firstFragment = fragments[0];
    const lastFragment = fragments[fragmentLength - 1];
    totalduration += level.skippedSegments * level.targetduration;
    if (totalduration > 0 && fragmentLength && lastFragment) {
      level.averagetargetduration = totalduration / fragmentLength;
      const lastSn = lastFragment.sn;
      level.endSN = lastSn !== 'initSegment' ? lastSn : 0;
      if (!level.live) {
        lastFragment.endList = true;
      }
      if (firstFragment && level.startCC === undefined) {
        level.startCC = firstFragment.cc;
      }
      /**
       * Backfill any missing PDT values
       * "If the first EXT-X-PROGRAM-DATE-TIME tag in a Playlist appears after
       * one or more Media Segment URIs, the client SHOULD extrapolate
       * backward from that tag (using EXTINF durations and/or media
       * timestamps) to associate dates with those segments."
       * We have already extrapolated forward, but all fragments up to the first instance of PDT do not have their PDTs
       * computed.
       */
      if (firstPdtIndex > 0) {
        backfillProgramDateTimes(fragments, firstPdtIndex);
        if (firstFragment) {
          programDateTimes.unshift(firstFragment);
        }
      }
    } else {
      level.endSN = 0;
      level.startCC = 0;
    }
    if (level.fragmentHint) {
      totalduration += level.fragmentHint.duration;
    }
    level.totalduration = totalduration;
    if (programDateTimes.length && level.dateRangeTagCount && firstFragment) {
      mapDateRanges(programDateTimes, level);
    }
    level.endCC = discontinuityCounter;
    return level;
  }
}
function mapDateRanges(programDateTimes, details) {
  // Make sure DateRanges are mapped to a ProgramDateTime tag that applies a date to a segment that overlaps with its start date
  const programDateTimeCount = programDateTimes.length;
  if (!programDateTimeCount) {
    return;
  }
  const lastProgramDateTime = programDateTimes[programDateTimeCount - 1];
  const playlistEnd = details.live ? Infinity : details.totalduration;
  const dateRangeIds = Object.keys(details.dateRanges);
  for (let i = dateRangeIds.length; i--;) {
    const dateRange = details.dateRanges[dateRangeIds[i]];
    const startDateTime = dateRange.startDate.getTime();
    dateRange.tagAnchor = lastProgramDateTime.ref;
    for (let j = programDateTimeCount; j--;) {
      const fragIndex = findFragmentWithStartDate(details, startDateTime, programDateTimes, j, playlistEnd);
      if (fragIndex !== -1) {
        dateRange.tagAnchor = details.fragments[fragIndex].ref;
        break;
      }
    }
  }
}
function findFragmentWithStartDate(details, startDateTime, programDateTimes, index, endTime) {
  const pdtFragment = programDateTimes[index];
  if (pdtFragment) {
    // find matching range between PDT tags
    const pdtStart = pdtFragment.programDateTime;
    if (startDateTime >= pdtStart || index === 0) {
      var _programDateTimes;
      const durationBetweenPdt = (((_programDateTimes = programDateTimes[index + 1]) == null ? void 0 : _programDateTimes.start) || endTime) - pdtFragment.start;
      if (startDateTime <= pdtStart + durationBetweenPdt * 1000) {
        // map to fragment with date-time range
        const startIndex = programDateTimes[index].sn - details.startSN;
        const fragments = details.fragments;
        if (fragments.length > programDateTimes.length) {
          const endSegment = programDateTimes[index + 1] || fragments[fragments.length - 1];
          const endIndex = endSegment.sn - details.startSN;
          for (let i = endIndex; i > startIndex; i--) {
            const fragStartDateTime = fragments[i].programDateTime;
            if (startDateTime >= fragStartDateTime && startDateTime < fragStartDateTime + fragments[i].duration * 1000) {
              return i;
            }
          }
        }
        return startIndex;
      }
    }
  }
  return -1;
}
function parseKey(keyTagAttributes, baseurl, parsed) {
  var _keyAttrs$METHOD, _keyAttrs$KEYFORMAT;
  // https://tools.ietf.org/html/rfc8216#section-4.3.2.4
  const keyAttrs = new AttrList(keyTagAttributes, parsed);
  const decryptmethod = (_keyAttrs$METHOD = keyAttrs.METHOD) != null ? _keyAttrs$METHOD : '';
  const decrypturi = keyAttrs.URI;
  const decryptiv = keyAttrs.hexadecimalInteger('IV');
  const decryptkeyformatversions = keyAttrs.KEYFORMATVERSIONS;
  // From RFC: This attribute is OPTIONAL; its absence indicates an implicit value of "identity".
  const decryptkeyformat = (_keyAttrs$KEYFORMAT = keyAttrs.KEYFORMAT) != null ? _keyAttrs$KEYFORMAT : 'identity';
  if (decrypturi && keyAttrs.IV && !decryptiv) {
    hls_logger.error(`Invalid IV: ${keyAttrs.IV}`);
  }
  // If decrypturi is a URI with a scheme, then baseurl will be ignored
  // No uri is allowed when METHOD is NONE
  const resolvedUri = decrypturi ? M3U8Parser.resolve(decrypturi, baseurl) : '';
  const keyFormatVersions = (decryptkeyformatversions ? decryptkeyformatversions : '1').split('/').map(Number).filter(Number.isFinite);
  return new LevelKey(decryptmethod, resolvedUri, decryptkeyformat, keyFormatVersions, decryptiv);
}
function parseStartTimeOffset(startAttributes) {
  const startAttrs = new AttrList(startAttributes);
  const startTimeOffset = startAttrs.decimalFloatingPoint('TIME-OFFSET');
  if (isFiniteNumber(startTimeOffset)) {
    return startTimeOffset;
  }
  return null;
}
function setCodecs(codecsAttributeValue, level) {
  let codecs = (codecsAttributeValue || '').split(/[ ,]+/).filter(c => c);
  ['video', 'audio', 'text'].forEach(type => {
    const filtered = codecs.filter(codec => isCodecType(codec, type));
    if (filtered.length) {
      // Comma separated list of all codecs for type
      level[`${type}Codec`] = filtered.map(c => c.split('/')[0]).join(',');
      // Remove known codecs so that only unknownCodecs are left after iterating through each type
      codecs = codecs.filter(codec => filtered.indexOf(codec) === -1);
    }
  });
  level.unknownCodecs = codecs;
}
function assignCodec(media, groupItem, codecProperty) {
  const codecValue = groupItem[codecProperty];
  if (codecValue) {
    media[codecProperty] = codecValue;
  }
}
function backfillProgramDateTimes(fragments, firstPdtIndex) {
  let fragPrev = fragments[firstPdtIndex];
  for (let i = firstPdtIndex; i--;) {
    const frag = fragments[i];
    // Exit on delta-playlist skipped segments
    if (!frag) {
      return;
    }
    frag.programDateTime = fragPrev.programDateTime - frag.duration * 1000;
    fragPrev = frag;
  }
}
function assignProgramDateTime(frag, prevFrag, programDateTimes) {
  if (frag.rawProgramDateTime) {
    programDateTimes.push(frag);
  } else if (prevFrag != null && prevFrag.programDateTime) {
    frag.programDateTime = prevFrag.endProgramDateTime;
  }
}
function setInitSegment(frag, mapAttrs, id, levelkeys) {
  frag.relurl = mapAttrs.URI;
  if (mapAttrs.BYTERANGE) {
    frag.setByteRange(mapAttrs.BYTERANGE);
  }
  frag.level = id;
  frag.sn = 'initSegment';
  if (levelkeys) {
    frag.levelkeys = levelkeys;
  }
  frag.initSegment = null;
}
function setFragLevelKeys(frag, levelkeys, level) {
  frag.levelkeys = levelkeys;
  const {
    encryptedFragments
  } = level;
  if ((!encryptedFragments.length || encryptedFragments[encryptedFragments.length - 1].levelkeys !== levelkeys) && Object.keys(levelkeys).some(format => levelkeys[format].isCommonEncryption)) {
    encryptedFragments.push(frag);
  }
}
function assignMultipleMediaPlaylistTagOccuranceError(level, tag, result) {
  level.playlistParsingError = new Error(`#EXT-X-${tag} must not appear more than once (${result[0]})`);
}
function assignMustAppearBeforeSegmentsError(level, tag, result) {
  level.playlistParsingError = new Error(`#EXT-X-${tag} must appear before the first Media Segment (${result[0]})`);
}

function updateFromToPTS(fragFrom, fragTo) {
  const fragToPTS = fragTo.startPTS;
  // if we know startPTS[toIdx]
  if (isFiniteNumber(fragToPTS)) {
    // update fragment duration.
    // it helps to fix drifts between playlist reported duration and fragment real duration
    let duration = 0;
    let frag;
    if (fragTo.sn > fragFrom.sn) {
      duration = fragToPTS - fragFrom.start;
      frag = fragFrom;
    } else {
      duration = fragFrom.start - fragToPTS;
      frag = fragTo;
    }
    if (frag.duration !== duration) {
      frag.setDuration(duration);
    }
    // we dont know startPTS[toIdx]
  } else if (fragTo.sn > fragFrom.sn) {
    const contiguous = fragFrom.cc === fragTo.cc;
    // TODO: With part-loading end/durations we need to confirm the whole fragment is loaded before using (or setting) minEndPTS
    if (contiguous && fragFrom.minEndPTS) {
      fragTo.setStart(fragFrom.start + (fragFrom.minEndPTS - fragFrom.start));
    } else {
      fragTo.setStart(fragFrom.start + fragFrom.duration);
    }
  } else {
    fragTo.setStart(Math.max(fragFrom.start - fragTo.duration, 0));
  }
}
function updateFragPTSDTS(details, frag, startPTS, endPTS, startDTS, endDTS) {
  const parsedMediaDuration = endPTS - startPTS;
  if (parsedMediaDuration <= 0) {
    hls_logger.warn('Fragment should have a positive duration', frag);
    endPTS = startPTS + frag.duration;
    endDTS = startDTS + frag.duration;
  }
  let maxStartPTS = startPTS;
  let minEndPTS = endPTS;
  const fragStartPts = frag.startPTS;
  const fragEndPts = frag.endPTS;
  if (isFiniteNumber(fragStartPts)) {
    // delta PTS between audio and video
    const deltaPTS = Math.abs(fragStartPts - startPTS);
    if (!isFiniteNumber(frag.deltaPTS)) {
      frag.deltaPTS = deltaPTS;
    } else {
      frag.deltaPTS = Math.max(deltaPTS, frag.deltaPTS);
    }
    maxStartPTS = Math.max(startPTS, fragStartPts);
    startPTS = Math.min(startPTS, fragStartPts);
    startDTS = Math.min(startDTS, frag.startDTS);
    minEndPTS = Math.min(endPTS, fragEndPts);
    endPTS = Math.max(endPTS, fragEndPts);
    endDTS = Math.max(endDTS, frag.endDTS);
  }
  const drift = startPTS - frag.start;
  if (frag.start !== 0) {
    frag.setStart(startPTS);
  }
  frag.setDuration(endPTS - frag.start);
  frag.startPTS = startPTS;
  frag.maxStartPTS = maxStartPTS;
  frag.startDTS = startDTS;
  frag.endPTS = endPTS;
  frag.minEndPTS = minEndPTS;
  frag.endDTS = endDTS;
  const sn = frag.sn;
  // exit if sn out of range
  if (!details || sn < details.startSN || sn > details.endSN) {
    return 0;
  }
  let i;
  const fragIdx = sn - details.startSN;
  const fragments = details.fragments;
  // update frag reference in fragments array
  // rationale is that fragments array might not contain this frag object.
  // this will happen if playlist has been refreshed between frag loading and call to updateFragPTSDTS()
  // if we don't update frag, we won't be able to propagate PTS info on the playlist
  // resulting in invalid sliding computation
  fragments[fragIdx] = frag;
  // adjust fragment PTS/duration from seqnum-1 to frag 0
  for (i = fragIdx; i > 0; i--) {
    updateFromToPTS(fragments[i], fragments[i - 1]);
  }

  // adjust fragment PTS/duration from seqnum to last frag
  for (i = fragIdx; i < fragments.length - 1; i++) {
    updateFromToPTS(fragments[i], fragments[i + 1]);
  }
  if (details.fragmentHint) {
    updateFromToPTS(fragments[fragments.length - 1], details.fragmentHint);
  }
  details.PTSKnown = details.alignedSliding = true;
  return drift;
}
function mergeDetails(oldDetails, newDetails) {
  if (oldDetails === newDetails) {
    return;
  }
  // Track the last initSegment processed. Initialize it to the last one on the timeline.
  let currentInitSegment = null;
  const oldFragments = oldDetails.fragments;
  for (let i = oldFragments.length - 1; i >= 0; i--) {
    const oldInit = oldFragments[i].initSegment;
    if (oldInit) {
      currentInitSegment = oldInit;
      break;
    }
  }
  if (oldDetails.fragmentHint) {
    // prevent PTS and duration from being adjusted on the next hint
    delete oldDetails.fragmentHint.endPTS;
  }
  // check if old/new playlists have fragments in common
  // loop through overlapping SN and update startPTS, cc, and duration if any found
  let PTSFrag;
  mapFragmentIntersection(oldDetails, newDetails, (oldFrag, newFrag, newFragIndex, newFragments) => {
    if ((!newDetails.startCC || newDetails.skippedSegments) && newFrag.cc !== oldFrag.cc) {
      const ccOffset = oldFrag.cc - newFrag.cc;
      for (let i = newFragIndex; i < newFragments.length; i++) {
        newFragments[i].cc += ccOffset;
      }
      newDetails.endCC = newFragments[newFragments.length - 1].cc;
    }
    if (isFiniteNumber(oldFrag.startPTS) && isFiniteNumber(oldFrag.endPTS)) {
      newFrag.setStart(newFrag.startPTS = oldFrag.startPTS);
      newFrag.startDTS = oldFrag.startDTS;
      newFrag.maxStartPTS = oldFrag.maxStartPTS;
      newFrag.endPTS = oldFrag.endPTS;
      newFrag.endDTS = oldFrag.endDTS;
      newFrag.minEndPTS = oldFrag.minEndPTS;
      newFrag.setDuration(oldFrag.endPTS - oldFrag.startPTS);
      if (newFrag.duration) {
        PTSFrag = newFrag;
      }

      // PTS is known when any segment has startPTS and endPTS
      newDetails.PTSKnown = newDetails.alignedSliding = true;
    }
    if (oldFrag.hasStreams) {
      newFrag.elementaryStreams = oldFrag.elementaryStreams;
    }
    newFrag.loader = oldFrag.loader;
    if (oldFrag.hasStats) {
      newFrag.stats = oldFrag.stats;
    }
    if (oldFrag.initSegment) {
      newFrag.initSegment = oldFrag.initSegment;
      currentInitSegment = oldFrag.initSegment;
    }
  });
  const newFragments = newDetails.fragments;
  const fragmentsToCheck = newDetails.fragmentHint ? newFragments.concat(newDetails.fragmentHint) : newFragments;
  if (currentInitSegment) {
    fragmentsToCheck.forEach(frag => {
      var _currentInitSegment;
      if (frag && (!frag.initSegment || frag.initSegment.relurl === ((_currentInitSegment = currentInitSegment) == null ? void 0 : _currentInitSegment.relurl))) {
        frag.initSegment = currentInitSegment;
      }
    });
  }
  if (newDetails.skippedSegments) {
    newDetails.deltaUpdateFailed = newFragments.some(frag => !frag);
    if (newDetails.deltaUpdateFailed) {
      hls_logger.warn('[level-helper] Previous playlist missing segments skipped in delta playlist');
      for (let i = newDetails.skippedSegments; i--;) {
        newFragments.shift();
      }
      newDetails.startSN = newFragments[0].sn;
    } else {
      if (newDetails.canSkipDateRanges) {
        newDetails.dateRanges = mergeDateRanges(oldDetails.dateRanges, newDetails);
      }
      const programDateTimes = oldDetails.fragments.filter(frag => frag.rawProgramDateTime);
      if (oldDetails.hasProgramDateTime && !newDetails.hasProgramDateTime) {
        for (let i = 1; i < fragmentsToCheck.length; i++) {
          if (fragmentsToCheck[i].programDateTime === null) {
            assignProgramDateTime(fragmentsToCheck[i], fragmentsToCheck[i - 1], programDateTimes);
          }
        }
      }
      mapDateRanges(programDateTimes, newDetails);
    }
    newDetails.endCC = newFragments[newFragments.length - 1].cc;
  }
  if (!newDetails.startCC) {
    var _fragPriorToNewStart$;
    const fragPriorToNewStart = getFragmentWithSN(oldDetails, newDetails.startSN - 1);
    newDetails.startCC = (_fragPriorToNewStart$ = fragPriorToNewStart == null ? void 0 : fragPriorToNewStart.cc) != null ? _fragPriorToNewStart$ : newFragments[0].cc;
  }

  // Merge parts
  mapPartIntersection(oldDetails.partList, newDetails.partList, (oldPart, newPart) => {
    newPart.elementaryStreams = oldPart.elementaryStreams;
    newPart.stats = oldPart.stats;
  });

  // if at least one fragment contains PTS info, recompute PTS information for all fragments
  if (PTSFrag) {
    updateFragPTSDTS(newDetails, PTSFrag, PTSFrag.startPTS, PTSFrag.endPTS, PTSFrag.startDTS, PTSFrag.endDTS);
  } else {
    // ensure that delta is within oldFragments range
    // also adjust sliding in case delta is 0 (we could have old=[50-60] and new=old=[50-61])
    // in that case we also need to adjust start offset of all fragments
    adjustSliding(oldDetails, newDetails);
  }
  if (newFragments.length) {
    newDetails.totalduration = newDetails.edge - newFragments[0].start;
  }
  newDetails.driftStartTime = oldDetails.driftStartTime;
  newDetails.driftStart = oldDetails.driftStart;
  const advancedDateTime = newDetails.advancedDateTime;
  if (newDetails.advanced && advancedDateTime) {
    const edge = newDetails.edge;
    if (!newDetails.driftStart) {
      newDetails.driftStartTime = advancedDateTime;
      newDetails.driftStart = edge;
    }
    newDetails.driftEndTime = advancedDateTime;
    newDetails.driftEnd = edge;
  } else {
    newDetails.driftEndTime = oldDetails.driftEndTime;
    newDetails.driftEnd = oldDetails.driftEnd;
    newDetails.advancedDateTime = oldDetails.advancedDateTime;
  }
  if (newDetails.requestScheduled === -1) {
    newDetails.requestScheduled = oldDetails.requestScheduled;
  }
}
function mergeDateRanges(oldDateRanges, newDetails) {
  const {
    dateRanges: deltaDateRanges,
    recentlyRemovedDateranges
  } = newDetails;
  const dateRanges = _extends({}, oldDateRanges);
  if (recentlyRemovedDateranges) {
    recentlyRemovedDateranges.forEach(id => {
      delete dateRanges[id];
    });
  }
  const mergeIds = Object.keys(dateRanges);
  const mergeCount = mergeIds.length;
  if (mergeCount) {
    Object.keys(deltaDateRanges).forEach(id => {
      const mergedDateRange = dateRanges[id];
      const dateRange = new DateRange(deltaDateRanges[id].attr, mergedDateRange);
      if (dateRange.isValid) {
        dateRanges[id] = dateRange;
        if (!mergedDateRange) {
          dateRange.tagOrder += mergeCount;
        }
      } else {
        hls_logger.warn(`Ignoring invalid Playlist Delta Update DATERANGE tag: "${hls_stringify(deltaDateRanges[id].attr)}"`);
      }
    });
  }
  return dateRanges;
}
function mapPartIntersection(oldParts, newParts, intersectionFn) {
  if (oldParts && newParts) {
    let delta = 0;
    for (let i = 0, len = oldParts.length; i <= len; i++) {
      const oldPart = oldParts[i];
      const newPart = newParts[i + delta];
      if (oldPart && newPart && oldPart.index === newPart.index && oldPart.fragment.sn === newPart.fragment.sn) {
        intersectionFn(oldPart, newPart);
      } else {
        delta--;
      }
    }
  }
}
function mapFragmentIntersection(oldDetails, newDetails, intersectionFn) {
  const skippedSegments = newDetails.skippedSegments;
  const start = Math.max(oldDetails.startSN, newDetails.startSN) - newDetails.startSN;
  const end = (oldDetails.fragmentHint ? 1 : 0) + (skippedSegments ? newDetails.endSN : Math.min(oldDetails.endSN, newDetails.endSN)) - newDetails.startSN;
  const delta = newDetails.startSN - oldDetails.startSN;
  const newFrags = newDetails.fragmentHint ? newDetails.fragments.concat(newDetails.fragmentHint) : newDetails.fragments;
  const oldFrags = oldDetails.fragmentHint ? oldDetails.fragments.concat(oldDetails.fragmentHint) : oldDetails.fragments;
  for (let i = start; i <= end; i++) {
    const oldFrag = oldFrags[delta + i];
    let newFrag = newFrags[i];
    if (skippedSegments && !newFrag && oldFrag) {
      // Fill in skipped segments in delta playlist
      newFrag = newDetails.fragments[i] = oldFrag;
    }
    if (oldFrag && newFrag) {
      intersectionFn(oldFrag, newFrag, i, newFrags);
      if (oldFrag.url && oldFrag.url !== newFrag.url) {
        newDetails.playlistParsingError = getSequenceError(`media sequence mismatch ${newFrag.sn}:`, oldDetails, newDetails, oldFrag, newFrag);
        return;
      } else if (oldFrag.cc !== newFrag.cc) {
        newDetails.playlistParsingError = getSequenceError(`discontinuity sequence mismatch (${oldFrag.cc}!=${newFrag.cc})`, oldDetails, newDetails, oldFrag, newFrag);
        return;
      }
    }
  }
}
function getSequenceError(message, oldDetails, newDetails, oldFrag, newFrag) {
  return new Error(`${message} ${newFrag.url}
Playlist starting @${oldDetails.startSN}
${oldDetails.m3u8}

Playlist starting @${newDetails.startSN}
${newDetails.m3u8}`);
}
function adjustSliding(oldDetails, newDetails, matchingStableVariantOrRendition = true) {
  const delta = newDetails.startSN + newDetails.skippedSegments - oldDetails.startSN;
  const oldFragments = oldDetails.fragments;
  const advancedOrStable = delta >= 0;
  let sliding = 0;
  if (advancedOrStable && delta < oldFragments.length) {
    sliding = oldFragments[delta].start;
  } else if (advancedOrStable && newDetails.startSN === oldDetails.endSN + 1) {
    sliding = oldDetails.fragmentEnd;
  } else if (advancedOrStable && matchingStableVariantOrRendition) {
    // align with expected position (updated playlist start sequence is past end sequence of last update)
    sliding = oldDetails.fragmentStart + delta * newDetails.levelTargetDuration;
  } else if (!newDetails.skippedSegments && newDetails.fragmentStart === 0) {
    // align new start with old (playlist switch has a sequence with no overlap and should not be used for alignment)
    sliding = oldDetails.fragmentStart;
  } else {
    // new details already has a sliding offset or has skipped segments
    return;
  }
  addSliding(newDetails, sliding);
}
function addSliding(details, sliding) {
  if (sliding) {
    const fragments = details.fragments;
    for (let i = details.skippedSegments; i < fragments.length; i++) {
      fragments[i].addStart(sliding);
    }
    if (details.fragmentHint) {
      details.fragmentHint.addStart(sliding);
    }
  }
}
function computeReloadInterval(newDetails, distanceToLiveEdgeMs = Infinity) {
  let reloadInterval = 1000 * newDetails.targetduration;
  if (newDetails.updated) {
    // Use last segment duration when shorter than target duration and near live edge
    const fragments = newDetails.fragments;
    const liveEdgeMaxTargetDurations = 4;
    if (fragments.length && reloadInterval * liveEdgeMaxTargetDurations > distanceToLiveEdgeMs) {
      const lastSegmentDuration = fragments[fragments.length - 1].duration * 1000;
      if (lastSegmentDuration < reloadInterval) {
        reloadInterval = lastSegmentDuration;
      }
    }
  } else {
    // estimate = 'miss half average';
    // follow HLS Spec, If the client reloads a Playlist file and finds that it has not
    // changed then it MUST wait for a period of one-half the target
    // duration before retrying.
    reloadInterval /= 2;
  }
  return Math.round(reloadInterval);
}
function getFragmentWithSN(details, sn, fragCurrent) {
  if (!details) {
    return null;
  }
  let fragment = details.fragments[sn - details.startSN];
  if (fragment) {
    return fragment;
  }
  fragment = details.fragmentHint;
  if (fragment && fragment.sn === sn) {
    return fragment;
  }
  if (sn < details.startSN && fragCurrent && fragCurrent.sn === sn) {
    return fragCurrent;
  }
  return null;
}
function getPartWith(details, sn, partIndex) {
  if (!details) {
    return null;
  }
  return findPart(details.partList, sn, partIndex);
}
function findPart(partList, sn, partIndex) {
  if (partList) {
    for (let i = partList.length; i--;) {
      const part = partList[i];
      if (part.index === partIndex && part.fragment.sn === sn) {
        return part;
      }
    }
  }
  return null;
}
function reassignFragmentLevelIndexes(levels) {
  levels.forEach((level, index) => {
    var _level$details;
    (_level$details = level.details) == null ? void 0 : _level$details.fragments.forEach(fragment => {
      fragment.level = index;
      if (fragment.initSegment) {
        fragment.initSegment.level = index;
      }
    });
  });
}

function findFirstFragWithCC(fragments, cc) {
  for (let i = 0, len = fragments.length; i < len; i++) {
    var _fragments$i;
    if (((_fragments$i = fragments[i]) == null ? void 0 : _fragments$i.cc) === cc) {
      return fragments[i];
    }
  }
  return null;
}
function shouldAlignOnDiscontinuities(refDetails, details) {
  if (refDetails) {
    if (details.startCC < refDetails.endCC && details.endCC > refDetails.startCC) {
      return true;
    }
  }
  return false;
}
function adjustFragmentStart(frag, sliding) {
  if (frag) {
    const start = frag.start + sliding;
    frag.start = frag.startPTS = start;
    frag.endPTS = start + frag.duration;
  }
}
function adjustSlidingStart(sliding, details) {
  // Update segments
  const fragments = details.fragments;
  for (let i = 0, len = fragments.length; i < len; i++) {
    adjustFragmentStart(fragments[i], sliding);
  }
  // Update LL-HLS parts at the end of the playlist
  if (details.fragmentHint) {
    adjustFragmentStart(details.fragmentHint, sliding);
  }
  details.alignedSliding = true;
}

/**
 * Using the parameters of the last level, this function computes PTS' of the new fragments so that they form a
 * contiguous stream with the last fragments.
 * The PTS of a fragment lets Hls.js know where it fits into a stream - by knowing every PTS, we know which fragment to
 * download at any given time. PTS is normally computed when the fragment is demuxed, so taking this step saves us time
 * and an extra download.
 * @param lastLevel
 * @param details
 */
function alignStream(switchDetails, details) {
  if (!switchDetails) {
    return;
  }
  alignDiscontinuities(details, switchDetails);
  if (!details.alignedSliding && switchDetails) {
    // If the PTS wasn't figured out via discontinuity sequence that means there was no CC increase within the level.
    // Aligning via Program Date Time should therefore be reliable, since PDT should be the same within the same
    // discontinuity sequence.
    alignMediaPlaylistByPDT(details, switchDetails);
  }
  if (!details.alignedSliding && switchDetails && !details.skippedSegments) {
    // Try to align on sn so that we pick a better start fragment.
    // Do not perform this on playlists with delta updates as this is only to align levels on switch
    // and adjustSliding only adjusts fragments after skippedSegments.
    adjustSliding(switchDetails, details, false);
  }
}

/**
 * Ajust the start of fragments in `details` by the difference in time between fragments of the latest
 * shared discontinuity sequence change.
 * @param lastLevel - The details of the last loaded level
 * @param details - The details of the new level
 */
function alignDiscontinuities(details, refDetails) {
  if (!shouldAlignOnDiscontinuities(refDetails, details)) {
    return;
  }
  const targetCC = Math.min(refDetails.endCC, details.endCC);
  const refFrag = findFirstFragWithCC(refDetails.fragments, targetCC);
  const frag = findFirstFragWithCC(details.fragments, targetCC);
  if (!refFrag || !frag) {
    return;
  }
  hls_logger.log(`Aligning playlist at start of dicontinuity sequence ${targetCC}`);
  const delta = refFrag.start - frag.start;
  adjustSlidingStart(delta, details);
}

/**
 * Ensures appropriate time-alignment between renditions based on PDT.
 * This function assumes the timelines represented in `refDetails` are accurate, including the PDTs
 * for the last discontinuity sequence number shared by both playlists when present,
 * and uses the "wallclock"/PDT timeline as a cross-reference to `details`, adjusting the presentation
 * times/timelines of `details` accordingly.
 * Given the asynchronous nature of fetches and initial loads of live `main` and audio/subtitle tracks,
 * the primary purpose of this function is to ensure the "local timelines" of audio/subtitle tracks
 * are aligned to the main/video timeline, using PDT as the cross-reference/"anchor" that should
 * be consistent across playlists, per the HLS spec.
 * @param details - The details of the rendition you'd like to time-align (e.g. an audio rendition).
 * @param refDetails - The details of the reference rendition with start and PDT times for alignment.
 */
function alignMediaPlaylistByPDT(details, refDetails) {
  if (!details.hasProgramDateTime || !refDetails.hasProgramDateTime) {
    return;
  }
  const fragments = details.fragments;
  const refFragments = refDetails.fragments;
  if (!fragments.length || !refFragments.length) {
    return;
  }

  // Calculate a delta to apply to all fragments according to the delta in PDT times and start times
  // of a fragment in the reference details, and a fragment in the target details of the same discontinuity.
  // If a fragment of the same discontinuity was not found use the middle fragment of both.
  let refFrag;
  let frag;
  const targetCC = Math.min(refDetails.endCC, details.endCC);
  if (refDetails.startCC < targetCC && details.startCC < targetCC) {
    refFrag = findFirstFragWithCC(refFragments, targetCC);
    frag = findFirstFragWithCC(fragments, targetCC);
  }
  if (!refFrag || !frag) {
    refFrag = refFragments[Math.floor(refFragments.length / 2)];
    frag = findFirstFragWithCC(fragments, refFrag.cc) || fragments[Math.floor(fragments.length / 2)];
  }
  const refPDT = refFrag.programDateTime;
  const targetPDT = frag.programDateTime;
  if (!refPDT || !targetPDT) {
    return;
  }
  const delta = (targetPDT - refPDT) / 1000 - (frag.start - refFrag.start);
  adjustSlidingStart(delta, details);
}

/**
 *  TimeRanges to string helper
 */

const TimeRanges = {
  toString: function (r) {
    let log = '';
    const len = r.length;
    for (let i = 0; i < len; i++) {
      log += `[${r.start(i).toFixed(3)}-${r.end(i).toFixed(3)}]`;
    }
    return log;
  }
};

const State = {
  STOPPED: 'STOPPED',
  IDLE: 'IDLE',
  KEY_LOADING: 'KEY_LOADING',
  FRAG_LOADING: 'FRAG_LOADING',
  FRAG_LOADING_WAITING_RETRY: 'FRAG_LOADING_WAITING_RETRY',
  WAITING_TRACK: 'WAITING_TRACK',
  PARSING: 'PARSING',
  PARSED: 'PARSED',
  ENDED: 'ENDED',
  ERROR: 'ERROR',
  WAITING_INIT_PTS: 'WAITING_INIT_PTS',
  WAITING_LEVEL: 'WAITING_LEVEL'
};
class BaseStreamController extends TaskLoop {
  constructor(hls, fragmentTracker, keyLoader, logPrefix, playlistType) {
    super(logPrefix, hls.logger);
    this.hls = void 0;
    this.fragPrevious = null;
    this.fragCurrent = null;
    this.fragmentTracker = void 0;
    this.transmuxer = null;
    this._state = State.STOPPED;
    this.playlistType = void 0;
    this.media = null;
    this.mediaBuffer = null;
    this.config = void 0;
    this.bitrateTest = false;
    this.lastCurrentTime = 0;
    this.nextLoadPosition = 0;
    this.startPosition = 0;
    this.startTimeOffset = null;
    this.retryDate = 0;
    this.levels = null;
    this.fragmentLoader = void 0;
    this.keyLoader = void 0;
    this.levelLastLoaded = null;
    this.startFragRequested = false;
    this.decrypter = void 0;
    this.initPTS = [];
    this.buffering = true;
    this.loadingParts = false;
    this.loopSn = void 0;
    this.onMediaSeeking = () => {
      const {
        config,
        fragCurrent,
        media,
        mediaBuffer,
        state
      } = this;
      const currentTime = media ? media.currentTime : 0;
      const bufferInfo = BufferHelper.bufferInfo(mediaBuffer ? mediaBuffer : media, currentTime, config.maxBufferHole);
      this.log(`media seeking to ${isFiniteNumber(currentTime) ? currentTime.toFixed(3) : currentTime}, state: ${state}`);
      if (this.state === State.ENDED) {
        this.resetLoadingState();
      } else if (fragCurrent) {
        // Seeking while frag load is in progress
        const tolerance = config.maxFragLookUpTolerance;
        const fragStartOffset = fragCurrent.start - tolerance;
        const fragEndOffset = fragCurrent.start + fragCurrent.duration + tolerance;
        // if seeking out of buffered range or into new one
        if (!bufferInfo.len || fragEndOffset < bufferInfo.start || fragStartOffset > bufferInfo.end) {
          const pastFragment = currentTime > fragEndOffset;
          // if the seek position is outside the current fragment range
          if (currentTime < fragStartOffset || pastFragment) {
            if (pastFragment && fragCurrent.loader) {
              this.log('seeking outside of buffer while fragment load in progress, cancel fragment load');
              fragCurrent.abortRequests();
              this.resetLoadingState();
            }
            this.fragPrevious = null;
          }
        }
      }
      if (media) {
        // Remove gap fragments
        this.fragmentTracker.removeFragmentsInRange(currentTime, Infinity, this.playlistType, true);

        // Don't set lastCurrentTime with backward seeks (allows for frag selection with strict tolerances)
        const lastCurrentTime = this.lastCurrentTime;
        if (currentTime > lastCurrentTime) {
          this.lastCurrentTime = currentTime;
        }
        if (!this.loadingParts) {
          const bufferEnd = Math.max(bufferInfo.end, currentTime);
          const shouldLoadParts = this.shouldLoadParts(this.getLevelDetails(), bufferEnd);
          if (shouldLoadParts) {
            this.log(`LL-Part loading ON after seeking to ${currentTime.toFixed(2)} with buffer @${bufferEnd.toFixed(2)}`);
            this.loadingParts = shouldLoadParts;
          }
        }
      }

      // in case seeking occurs although no media buffered, adjust startPosition and nextLoadPosition to seek target
      if (!this.hls.hasEnoughToStart && !bufferInfo.len) {
        this.log(`setting startPosition to ${currentTime} because of seek before start`);
        this.nextLoadPosition = this.startPosition = currentTime;
      }

      // Async tick to speed up processing
      this.tickImmediate();
    };
    this.onMediaEnded = () => {
      // reset startPosition and lastCurrentTime to restart playback @ stream beginning
      this.log(`setting startPosition to 0 because media ended`);
      this.startPosition = this.lastCurrentTime = 0;
    };
    this.playlistType = playlistType;
    this.hls = hls;
    this.fragmentLoader = new FragmentLoader(hls.config);
    this.keyLoader = keyLoader;
    this.fragmentTracker = fragmentTracker;
    this.config = hls.config;
    this.decrypter = new Decrypter(hls.config);
  }
  registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
    hls.on(Events.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
    hls.off(Events.ERROR, this.onError, this);
  }
  doTick() {
    this.onTickEnd();
  }
  onTickEnd() {}
  startLoad(startPosition) {}
  stopLoad() {
    if (this.state === State.STOPPED) {
      return;
    }
    this.fragmentLoader.abort();
    this.keyLoader.abort(this.playlistType);
    const frag = this.fragCurrent;
    if (frag != null && frag.loader) {
      frag.abortRequests();
      this.fragmentTracker.removeFragment(frag);
    }
    this.resetTransmuxer();
    this.fragCurrent = null;
    this.fragPrevious = null;
    this.clearInterval();
    this.clearNextTick();
    this.state = State.STOPPED;
  }
  get startPositionValue() {
    const {
      nextLoadPosition,
      startPosition
    } = this;
    if (startPosition === -1 && nextLoadPosition) {
      return nextLoadPosition;
    }
    return startPosition;
  }
  get bufferingEnabled() {
    return this.buffering;
  }
  pauseBuffering() {
    this.buffering = false;
  }
  resumeBuffering() {
    this.buffering = true;
  }
  get inFlightFrag() {
    return {
      frag: this.fragCurrent,
      state: this.state
    };
  }
  _streamEnded(bufferInfo, levelDetails) {
    // Stream is never "ended" when playlist is live or media is detached
    if (levelDetails.live || !this.media) {
      return false;
    }
    // Stream is not "ended" when nothing is buffered past the start
    const bufferEnd = bufferInfo.end || 0;
    const timelineStart = this.config.timelineOffset || 0;
    if (bufferEnd <= timelineStart) {
      return false;
    }
    // Stream is not "ended" when there is a second buffered range starting before the end of the playlist
    const bufferedRanges = bufferInfo.buffered;
    if (this.config.maxBufferHole && bufferedRanges && bufferedRanges.length > 1) {
      // make sure bufferInfo accounts for any gaps
      bufferInfo = BufferHelper.bufferedInfo(bufferedRanges, bufferInfo.start, 0);
    }
    const nextStart = bufferInfo.nextStart;
    const hasSecondBufferedRange = nextStart && nextStart > timelineStart && nextStart < levelDetails.edge;
    if (hasSecondBufferedRange) {
      return false;
    }
    // Playhead is in unbuffered region. Marking EoS now could result in Safari failing to dispatch "ended" event following seek on start.
    if (this.media.currentTime < bufferInfo.start) {
      return false;
    }
    const partList = levelDetails.partList;
    // Since the last part isn't guaranteed to correspond to the last playlist segment for Low-Latency HLS,
    // check instead if the last part is buffered.
    if (partList != null && partList.length) {
      const lastPart = partList[partList.length - 1];

      // Checking the midpoint of the part for potential margin of error and related issues.
      // NOTE: Technically I believe parts could yield content that is < the computed duration (including potential a duration of 0)
      // and still be spec-compliant, so there may still be edge cases here. Likewise, there could be issues in end of stream
      // part mismatches for independent audio and video playlists/segments.
      const lastPartBuffered = BufferHelper.isBuffered(this.media, lastPart.start + lastPart.duration / 2);
      return lastPartBuffered;
    }
    const playlistType = levelDetails.fragments[levelDetails.fragments.length - 1].type;
    return this.fragmentTracker.isEndListAppended(playlistType);
  }
  getLevelDetails() {
    if (this.levels && this.levelLastLoaded !== null) {
      var _this$levelLastLoaded;
      return (_this$levelLastLoaded = this.levelLastLoaded) == null ? void 0 : _this$levelLastLoaded.details;
    }
  }
  get timelineOffset() {
    const configuredTimelineOffset = this.config.timelineOffset;
    if (configuredTimelineOffset) {
      var _this$getLevelDetails;
      return ((_this$getLevelDetails = this.getLevelDetails()) == null ? void 0 : _this$getLevelDetails.appliedTimelineOffset) || configuredTimelineOffset;
    }
    return 0;
  }
  onMediaAttached(event, data) {
    const media = this.media = this.mediaBuffer = data.media;
    media.removeEventListener('seeking', this.onMediaSeeking);
    media.removeEventListener('ended', this.onMediaEnded);
    media.addEventListener('seeking', this.onMediaSeeking);
    media.addEventListener('ended', this.onMediaEnded);
    const config = this.config;
    if (this.levels && config.autoStartLoad && this.state === State.STOPPED) {
      this.startLoad(config.startPosition);
    }
  }
  onMediaDetaching(event, data) {
    const transferringMedia = !!data.transferMedia;
    const media = this.media;
    if (media === null) {
      return;
    }
    if (media.ended) {
      this.log('MSE detaching and video ended, reset startPosition');
      this.startPosition = this.lastCurrentTime = 0;
    }

    // remove video listeners
    media.removeEventListener('seeking', this.onMediaSeeking);
    media.removeEventListener('ended', this.onMediaEnded);
    if (this.keyLoader && !transferringMedia) {
      this.keyLoader.detach();
    }
    this.media = this.mediaBuffer = null;
    this.loopSn = undefined;
    if (transferringMedia) {
      this.resetLoadingState();
      this.resetTransmuxer();
      return;
    }
    this.loadingParts = false;
    this.fragmentTracker.removeAllFragments();
    this.stopLoad();
  }
  onManifestLoading() {
    this.initPTS = [];
    this.levels = this.levelLastLoaded = this.fragCurrent = null;
    this.lastCurrentTime = this.startPosition = 0;
    this.startFragRequested = false;
  }
  onError(event, data) {}
  onManifestLoaded(event, data) {
    this.startTimeOffset = data.startTimeOffset;
  }
  onHandlerDestroying() {
    this.stopLoad();
    if (this.transmuxer) {
      this.transmuxer.destroy();
      this.transmuxer = null;
    }
    super.onHandlerDestroying();
    // @ts-ignore
    this.hls = this.onMediaSeeking = this.onMediaEnded = null;
  }
  onHandlerDestroyed() {
    this.state = State.STOPPED;
    if (this.fragmentLoader) {
      this.fragmentLoader.destroy();
    }
    if (this.keyLoader) {
      this.keyLoader.destroy();
    }
    if (this.decrypter) {
      this.decrypter.destroy();
    }
    this.hls = this.log = this.warn = this.decrypter = this.keyLoader = this.fragmentLoader = this.fragmentTracker = null;
    super.onHandlerDestroyed();
  }
  loadFragment(frag, level, targetBufferTime) {
    this.startFragRequested = true;
    this._loadFragForPlayback(frag, level, targetBufferTime);
  }
  _loadFragForPlayback(fragment, level, targetBufferTime) {
    const progressCallback = data => {
      const frag = data.frag;
      if (this.fragContextChanged(frag)) {
        this.warn(`${frag.type} sn: ${frag.sn}${data.part ? ' part: ' + data.part.index : ''} of ${this.fragInfo(frag, false, data.part)}) was dropped during download.`);
        this.fragmentTracker.removeFragment(frag);
        return;
      }
      frag.stats.chunkCount++;
      this._handleFragmentLoadProgress(data);
    };
    this._doFragLoad(fragment, level, targetBufferTime, progressCallback).then(data => {
      if (!data) {
        // if we're here we probably needed to backtrack or are waiting for more parts
        return;
      }
      const state = this.state;
      const frag = data.frag;
      if (this.fragContextChanged(frag)) {
        if (state === State.FRAG_LOADING || !this.fragCurrent && state === State.PARSING) {
          this.fragmentTracker.removeFragment(frag);
          this.state = State.IDLE;
        }
        return;
      }
      if ('payload' in data) {
        this.log(`Loaded ${frag.type} sn: ${frag.sn} of ${this.playlistLabel()} ${frag.level}`);
        this.hls.trigger(Events.FRAG_LOADED, data);
      }

      // Pass through the whole payload; controllers not implementing progressive loading receive data from this callback
      this._handleFragmentLoadComplete(data);
    }).catch(reason => {
      if (this.state === State.STOPPED || this.state === State.ERROR) {
        return;
      }
      this.warn(`Frag error: ${(reason == null ? void 0 : reason.message) || reason}`);
      this.resetFragmentLoading(fragment);
    });
  }
  clearTrackerIfNeeded(frag) {
    var _this$mediaBuffer;
    const {
      fragmentTracker
    } = this;
    const fragState = fragmentTracker.getState(frag);
    if (fragState === FragmentState.APPENDING) {
      // Lower the max buffer length and try again
      const playlistType = frag.type;
      const bufferedInfo = this.getFwdBufferInfo(this.mediaBuffer, playlistType);
      const minForwardBufferLength = Math.max(frag.duration, bufferedInfo ? bufferedInfo.len : this.config.maxBufferLength);
      // If backtracking, always remove from the tracker without reducing max buffer length
      const backtrackFragment = this.backtrackFragment;
      const backtracked = backtrackFragment ? frag.sn - backtrackFragment.sn : 0;
      if (backtracked === 1 || this.reduceMaxBufferLength(minForwardBufferLength, frag.duration)) {
        fragmentTracker.removeFragment(frag);
      }
    } else if (((_this$mediaBuffer = this.mediaBuffer) == null ? void 0 : _this$mediaBuffer.buffered.length) === 0) {
      // Stop gap for bad tracker / buffer flush behavior
      fragmentTracker.removeAllFragments();
    } else if (fragmentTracker.hasParts(frag.type)) {
      // In low latency mode, remove fragments for which only some parts were buffered
      fragmentTracker.detectPartialFragments({
        frag,
        part: null,
        stats: frag.stats,
        id: frag.type
      });
      if (fragmentTracker.getState(frag) === FragmentState.PARTIAL) {
        fragmentTracker.removeFragment(frag);
      }
    }
  }
  checkLiveUpdate(details) {
    if (details.updated && !details.live) {
      // Live stream ended, update fragment tracker
      const lastFragment = details.fragments[details.fragments.length - 1];
      this.fragmentTracker.detectPartialFragments({
        frag: lastFragment,
        part: null,
        stats: lastFragment.stats,
        id: lastFragment.type
      });
    }
    if (!details.fragments[0]) {
      details.deltaUpdateFailed = true;
    }
  }
  waitForLive(levelInfo) {
    const details = levelInfo.details;
    return (details == null ? void 0 : details.live) && details.type !== 'EVENT' && (this.levelLastLoaded !== levelInfo || details.expired);
  }
  flushMainBuffer(startOffset, endOffset, type = null) {
    if (!(startOffset - endOffset)) {
      return;
    }
    // When alternate audio is playing, the audio-stream-controller is responsible for the audio buffer. Otherwise,
    // passing a null type flushes both buffers
    const flushScope = {
      startOffset,
      endOffset,
      type
    };
    this.hls.trigger(Events.BUFFER_FLUSHING, flushScope);
  }
  _loadInitSegment(fragment, level) {
    this._doFragLoad(fragment, level).then(data => {
      const frag = data == null ? void 0 : data.frag;
      if (!frag || this.fragContextChanged(frag) || !this.levels) {
        throw new Error('init load aborted');
      }
      return data;
    }).then(data => {
      const {
        hls
      } = this;
      const {
        frag,
        payload
      } = data;
      const decryptData = frag.decryptdata;

      // check to see if the payload needs to be decrypted
      if (payload && payload.byteLength > 0 && decryptData != null && decryptData.key && decryptData.iv && isFullSegmentEncryption(decryptData.method)) {
        const startTime = self.performance.now();
        // decrypt init segment data
        return this.decrypter.decrypt(new Uint8Array(payload), decryptData.key.buffer, decryptData.iv.buffer, getAesModeFromFullSegmentMethod(decryptData.method)).catch(err => {
          hls.trigger(Events.ERROR, {
            type: ErrorTypes.MEDIA_ERROR,
            details: ErrorDetails.FRAG_DECRYPT_ERROR,
            fatal: false,
            error: err,
            reason: err.message,
            frag
          });
          throw err;
        }).then(decryptedData => {
          const endTime = self.performance.now();
          hls.trigger(Events.FRAG_DECRYPTED, {
            frag,
            payload: decryptedData,
            stats: {
              tstart: startTime,
              tdecrypt: endTime
            }
          });
          data.payload = decryptedData;
          return this.completeInitSegmentLoad(data);
        });
      }
      return this.completeInitSegmentLoad(data);
    }).catch(reason => {
      if (this.state === State.STOPPED || this.state === State.ERROR) {
        return;
      }
      this.warn(reason);
      this.resetFragmentLoading(fragment);
    });
  }
  completeInitSegmentLoad(data) {
    const {
      levels
    } = this;
    if (!levels) {
      throw new Error('init load aborted, missing levels');
    }
    const stats = data.frag.stats;
    if (this.state !== State.STOPPED) {
      this.state = State.IDLE;
    }
    data.frag.data = new Uint8Array(data.payload);
    stats.parsing.start = stats.buffering.start = self.performance.now();
    stats.parsing.end = stats.buffering.end = self.performance.now();
    this.tick();
  }
  fragContextChanged(frag) {
    const {
      fragCurrent
    } = this;
    return !frag || !fragCurrent || frag.sn !== fragCurrent.sn || frag.level !== fragCurrent.level;
  }
  fragBufferedComplete(frag, part) {
    const media = this.mediaBuffer ? this.mediaBuffer : this.media;
    this.log(`Buffered ${frag.type} sn: ${frag.sn}${part ? ' part: ' + part.index : ''} of ${this.fragInfo(frag, false, part)} > buffer:${media ? TimeRanges.toString(BufferHelper.getBuffered(media)) : '(detached)'})`);
    if (isMediaFragment(frag)) {
      var _this$levels;
      if (frag.type !== PlaylistLevelType.SUBTITLE) {
        const el = frag.elementaryStreams;
        if (!Object.keys(el).some(type => !!el[type])) {
          // empty segment
          this.state = State.IDLE;
          return;
        }
      }
      const level = (_this$levels = this.levels) == null ? void 0 : _this$levels[frag.level];
      if (level != null && level.fragmentError) {
        this.log(`Resetting level fragment error count of ${level.fragmentError} on frag buffered`);
        level.fragmentError = 0;
      }
    }
    this.state = State.IDLE;
  }
  _handleFragmentLoadComplete(fragLoadedEndData) {
    const {
      transmuxer
    } = this;
    if (!transmuxer) {
      return;
    }
    const {
      frag,
      part,
      partsLoaded
    } = fragLoadedEndData;
    // If we did not load parts, or loaded all parts, we have complete (not partial) fragment data
    const complete = !partsLoaded || partsLoaded.length === 0 || partsLoaded.some(fragLoaded => !fragLoaded);
    const chunkMeta = new ChunkMetadata(frag.level, frag.sn, frag.stats.chunkCount + 1, 0, part ? part.index : -1, !complete);
    transmuxer.flush(chunkMeta);
  }
  _handleFragmentLoadProgress(frag) {}
  _doFragLoad(frag, level, targetBufferTime = null, progressCallback) {
    var _frag$decryptdata;
    this.fragCurrent = frag;
    const details = level == null ? void 0 : level.details;
    if (!this.levels || !details) {
      throw new Error(`frag load aborted, missing level${details ? '' : ' detail'}s`);
    }
    let keyLoadingPromise = null;
    if (frag.encrypted && !((_frag$decryptdata = frag.decryptdata) != null && _frag$decryptdata.key)) {
      this.log(`Loading key for ${frag.sn} of [${details.startSN}-${details.endSN}], ${this.playlistLabel()} ${frag.level}`);
      this.state = State.KEY_LOADING;
      this.fragCurrent = frag;
      keyLoadingPromise = this.keyLoader.load(frag).then(keyLoadedData => {
        if (!this.fragContextChanged(keyLoadedData.frag)) {
          this.hls.trigger(Events.KEY_LOADED, keyLoadedData);
          if (this.state === State.KEY_LOADING) {
            this.state = State.IDLE;
          }
          return keyLoadedData;
        }
      });
      this.hls.trigger(Events.KEY_LOADING, {
        frag
      });
      if (this.fragCurrent === null) {
        keyLoadingPromise = Promise.reject(new Error(`frag load aborted, context changed in KEY_LOADING`));
      }
    } else if (!frag.encrypted) {
      keyLoadingPromise = this.keyLoader.loadClear(frag, details.encryptedFragments);
      if (keyLoadingPromise) {
        this.log(`[eme] blocking frag load until media-keys acquired`);
      }
    }
    const fragPrevious = this.fragPrevious;
    if (isMediaFragment(frag) && (!fragPrevious || frag.sn !== fragPrevious.sn)) {
      const shouldLoadParts = this.shouldLoadParts(level.details, frag.end);
      if (shouldLoadParts !== this.loadingParts) {
        this.log(`LL-Part loading ${shouldLoadParts ? 'ON' : 'OFF'} loading sn ${fragPrevious == null ? void 0 : fragPrevious.sn}->${frag.sn}`);
        this.loadingParts = shouldLoadParts;
      }
    }
    targetBufferTime = Math.max(frag.start, targetBufferTime || 0);
    if (this.loadingParts && isMediaFragment(frag)) {
      const partList = details.partList;
      if (partList && progressCallback) {
        if (targetBufferTime > frag.end && details.fragmentHint) {
          frag = details.fragmentHint;
        }
        const partIndex = this.getNextPart(partList, frag, targetBufferTime);
        if (partIndex > -1) {
          const part = partList[partIndex];
          frag = this.fragCurrent = part.fragment;
          this.log(`Loading ${frag.type} sn: ${frag.sn} part: ${part.index} (${partIndex}/${partList.length - 1}) of ${this.fragInfo(frag, false, part)}) cc: ${frag.cc} [${details.startSN}-${details.endSN}], target: ${parseFloat(targetBufferTime.toFixed(3))}`);
          this.nextLoadPosition = part.start + part.duration;
          this.state = State.FRAG_LOADING;
          let _result;
          if (keyLoadingPromise) {
            _result = keyLoadingPromise.then(keyLoadedData => {
              if (!keyLoadedData || this.fragContextChanged(keyLoadedData.frag)) {
                return null;
              }
              return this.doFragPartsLoad(frag, part, level, progressCallback);
            }).catch(error => this.handleFragLoadError(error));
          } else {
            _result = this.doFragPartsLoad(frag, part, level, progressCallback).catch(error => this.handleFragLoadError(error));
          }
          this.hls.trigger(Events.FRAG_LOADING, {
            frag,
            part,
            targetBufferTime
          });
          if (this.fragCurrent === null) {
            return Promise.reject(new Error(`frag load aborted, context changed in FRAG_LOADING parts`));
          }
          return _result;
        } else if (!frag.url || this.loadedEndOfParts(partList, targetBufferTime)) {
          // Fragment hint has no parts
          return Promise.resolve(null);
        }
      }
    }
    if (isMediaFragment(frag) && this.loadingParts) {
      this.log(`LL-Part loading OFF after next part miss @${targetBufferTime.toFixed(2)}`);
      this.loadingParts = false;
    } else if (!frag.url) {
      // Selected fragment hint for part but not loading parts
      return Promise.resolve(null);
    }
    this.log(`Loading ${frag.type} sn: ${frag.sn} of ${this.fragInfo(frag, false)}) cc: ${frag.cc} ${details ? '[' + details.startSN + '-' + details.endSN + ']' : ''}, target: ${parseFloat(targetBufferTime.toFixed(3))}`);
    // Don't update nextLoadPosition for fragments which are not buffered
    if (isFiniteNumber(frag.sn) && !this.bitrateTest) {
      this.nextLoadPosition = frag.start + frag.duration;
    }
    this.state = State.FRAG_LOADING;

    // Load key before streaming fragment data
    const dataOnProgress = this.config.progressive;
    let result;
    if (dataOnProgress && keyLoadingPromise) {
      result = keyLoadingPromise.then(keyLoadedData => {
        if (!keyLoadedData || this.fragContextChanged(keyLoadedData == null ? void 0 : keyLoadedData.frag)) {
          return null;
        }
        return this.fragmentLoader.load(frag, progressCallback);
      }).catch(error => this.handleFragLoadError(error));
    } else {
      // load unencrypted fragment data with progress event,
      // or handle fragment result after key and fragment are finished loading
      result = Promise.all([this.fragmentLoader.load(frag, dataOnProgress ? progressCallback : undefined), keyLoadingPromise]).then(([fragLoadedData]) => {
        if (!dataOnProgress && fragLoadedData && progressCallback) {
          progressCallback(fragLoadedData);
        }
        return fragLoadedData;
      }).catch(error => this.handleFragLoadError(error));
    }
    this.hls.trigger(Events.FRAG_LOADING, {
      frag,
      targetBufferTime
    });
    if (this.fragCurrent === null) {
      return Promise.reject(new Error(`frag load aborted, context changed in FRAG_LOADING`));
    }
    return result;
  }
  doFragPartsLoad(frag, fromPart, level, progressCallback) {
    return new Promise((resolve, reject) => {
      var _level$details;
      const partsLoaded = [];
      const initialPartList = (_level$details = level.details) == null ? void 0 : _level$details.partList;
      const loadPart = part => {
        this.fragmentLoader.loadPart(frag, part, progressCallback).then(partLoadedData => {
          partsLoaded[part.index] = partLoadedData;
          const loadedPart = partLoadedData.part;
          this.hls.trigger(Events.FRAG_LOADED, partLoadedData);
          const nextPart = getPartWith(level.details, frag.sn, part.index + 1) || findPart(initialPartList, frag.sn, part.index + 1);
          if (nextPart) {
            loadPart(nextPart);
          } else {
            return resolve({
              frag,
              part: loadedPart,
              partsLoaded
            });
          }
        }).catch(reject);
      };
      loadPart(fromPart);
    });
  }
  handleFragLoadError(error) {
    if ('data' in error) {
      const data = error.data;
      if (error.data && data.details === ErrorDetails.INTERNAL_ABORTED) {
        this.handleFragLoadAborted(data.frag, data.part);
      } else {
        this.hls.trigger(Events.ERROR, data);
      }
    } else {
      this.hls.trigger(Events.ERROR, {
        type: ErrorTypes.OTHER_ERROR,
        details: ErrorDetails.INTERNAL_EXCEPTION,
        err: error,
        error,
        fatal: true
      });
    }
    return null;
  }
  _handleTransmuxerFlush(chunkMeta) {
    const context = this.getCurrentContext(chunkMeta);
    if (!context || this.state !== State.PARSING) {
      if (!this.fragCurrent && this.state !== State.STOPPED && this.state !== State.ERROR) {
        this.state = State.IDLE;
      }
      return;
    }
    const {
      frag,
      part,
      level
    } = context;
    const now = self.performance.now();
    frag.stats.parsing.end = now;
    if (part) {
      part.stats.parsing.end = now;
    }
    // See if part loading should be disabled/enabled based on buffer and playback position.
    const levelDetails = this.getLevelDetails();
    const loadingPartsAtEdge = levelDetails && frag.sn > levelDetails.endSN;
    const shouldLoadParts = loadingPartsAtEdge || this.shouldLoadParts(levelDetails, frag.end);
    if (shouldLoadParts !== this.loadingParts) {
      this.log(`LL-Part loading ${shouldLoadParts ? 'ON' : 'OFF'} after parsing segment ending @${frag.end.toFixed(2)}`);
      this.loadingParts = shouldLoadParts;
    }
    this.updateLevelTiming(frag, part, level, chunkMeta.partial);
  }
  shouldLoadParts(details, bufferEnd) {
    if (this.config.lowLatencyMode) {
      if (!details) {
        return this.loadingParts;
      }
      if (details != null && details.partList) {
        var _details$fragmentHint;
        // Buffer must be ahead of first part + duration of parts after last segment
        // and playback must be at or past segment adjacent to part list
        const firstPart = details.partList[0];
        const safePartStart = firstPart.end + (((_details$fragmentHint = details.fragmentHint) == null ? void 0 : _details$fragmentHint.duration) || 0);
        if (bufferEnd >= safePartStart) {
          var _this$media;
          const playhead = this.hls.hasEnoughToStart ? ((_this$media = this.media) == null ? void 0 : _this$media.currentTime) || this.lastCurrentTime : this.getLoadPosition();
          if (playhead > firstPart.start - firstPart.fragment.duration) {
            return true;
          }
        }
      }
    }
    return false;
  }
  getCurrentContext(chunkMeta) {
    const {
      levels,
      fragCurrent
    } = this;
    const {
      level: levelIndex,
      sn,
      part: partIndex
    } = chunkMeta;
    if (!(levels != null && levels[levelIndex])) {
      this.warn(`Levels object was unset while buffering fragment ${sn} of ${this.playlistLabel()} ${levelIndex}. The current chunk will not be buffered.`);
      return null;
    }
    const level = levels[levelIndex];
    const levelDetails = level.details;
    const part = partIndex > -1 ? getPartWith(levelDetails, sn, partIndex) : null;
    const frag = part ? part.fragment : getFragmentWithSN(levelDetails, sn, fragCurrent);
    if (!frag) {
      return null;
    }
    if (fragCurrent && fragCurrent !== frag) {
      frag.stats = fragCurrent.stats;
    }
    return {
      frag,
      part,
      level
    };
  }
  bufferFragmentData(data, frag, part, chunkMeta, noBacktracking) {
    var _buffer;
    if (!data || this.state !== State.PARSING) {
      return;
    }
    const {
      data1,
      data2
    } = data;
    let buffer = data1;
    if (data1 && data2) {
      // Combine the moof + mdat so that we buffer with a single append
      buffer = appendUint8Array(data1, data2);
    }
    if (!((_buffer = buffer) != null && _buffer.length)) {
      return;
    }
    const segment = {
      type: data.type,
      frag,
      part,
      chunkMeta,
      parent: frag.type,
      data: buffer
    };
    this.hls.trigger(Events.BUFFER_APPENDING, segment);
    if (data.dropped && data.independent && !part) {
      if (noBacktracking) {
        return;
      }
      // Clear buffer so that we reload previous segments sequentially if required
      this.flushBufferGap(frag);
    }
  }
  flushBufferGap(frag) {
    const media = this.media;
    if (!media) {
      return;
    }
    // If currentTime is not buffered, clear the back buffer so that we can backtrack as much as needed
    if (!BufferHelper.isBuffered(media, media.currentTime)) {
      this.flushMainBuffer(0, frag.start);
      return;
    }
    // Remove back-buffer without interrupting playback to allow back tracking
    const currentTime = media.currentTime;
    const bufferInfo = BufferHelper.bufferInfo(media, currentTime, 0);
    const fragDuration = frag.duration;
    const segmentFraction = Math.min(this.config.maxFragLookUpTolerance * 2, fragDuration * 0.25);
    const start = Math.max(Math.min(frag.start - segmentFraction, bufferInfo.end - segmentFraction), currentTime + segmentFraction);
    if (frag.start - start > segmentFraction) {
      this.flushMainBuffer(start, frag.start);
    }
  }
  getFwdBufferInfo(bufferable, type) {
    var _this$media2;
    const pos = this.getLoadPosition();
    if (!isFiniteNumber(pos)) {
      return null;
    }
    const backwardSeek = this.lastCurrentTime > pos;
    const maxBufferHole = backwardSeek || (_this$media2 = this.media) != null && _this$media2.paused ? 0 : this.config.maxBufferHole;
    return this.getFwdBufferInfoAtPos(bufferable, pos, type, maxBufferHole);
  }
  getFwdBufferInfoAtPos(bufferable, pos, type, maxBufferHole) {
    const bufferInfo = BufferHelper.bufferInfo(bufferable, pos, maxBufferHole);
    // Workaround flaw in getting forward buffer when maxBufferHole is smaller than gap at current pos
    if (bufferInfo.len === 0 && bufferInfo.nextStart !== undefined) {
      const bufferedFragAtPos = this.fragmentTracker.getBufferedFrag(pos, type);
      if (bufferedFragAtPos && (bufferInfo.nextStart <= bufferedFragAtPos.end || bufferedFragAtPos.gap)) {
        const gapDuration = Math.max(Math.min(bufferInfo.nextStart, bufferedFragAtPos.end) - pos, maxBufferHole);
        return BufferHelper.bufferInfo(bufferable, pos, gapDuration);
      }
    }
    return bufferInfo;
  }
  getMaxBufferLength(levelBitrate) {
    const {
      config
    } = this;
    let maxBufLen;
    if (levelBitrate) {
      maxBufLen = Math.max(8 * config.maxBufferSize / levelBitrate, config.maxBufferLength);
    } else {
      maxBufLen = config.maxBufferLength;
    }
    return Math.min(maxBufLen, config.maxMaxBufferLength);
  }
  reduceMaxBufferLength(threshold, fragDuration) {
    const config = this.config;
    const minLength = Math.max(Math.min(threshold - fragDuration, config.maxBufferLength), fragDuration);
    const reducedLength = Math.max(threshold - fragDuration * 3, config.maxMaxBufferLength / 2, minLength);
    if (reducedLength >= minLength) {
      // reduce max buffer length as it might be too high. we do this to avoid loop flushing ...
      config.maxMaxBufferLength = reducedLength;
      this.warn(`Reduce max buffer length to ${reducedLength}s`);
      return true;
    }
    return false;
  }
  getAppendedFrag(position, playlistType = PlaylistLevelType.MAIN) {
    var _this$fragmentTracker;
    const fragOrPart = (_this$fragmentTracker = this.fragmentTracker) == null ? void 0 : _this$fragmentTracker.getAppendedFrag(position, playlistType);
    if (fragOrPart && 'fragment' in fragOrPart) {
      return fragOrPart.fragment;
    }
    return fragOrPart;
  }
  getNextFragment(pos, levelDetails) {
    const fragments = levelDetails.fragments;
    const fragLen = fragments.length;
    if (!fragLen) {
      return null;
    }

    // find fragment index, contiguous with end of buffer position
    const {
      config
    } = this;
    const start = fragments[0].start;
    const canLoadParts = config.lowLatencyMode && !!levelDetails.partList;
    let frag = null;
    if (levelDetails.live) {
      const initialLiveManifestSize = config.initialLiveManifestSize;
      if (fragLen < initialLiveManifestSize) {
        this.warn(`Not enough fragments to start playback (have: ${fragLen}, need: ${initialLiveManifestSize})`);
        return null;
      }
      // The real fragment start times for a live stream are only known after the PTS range for that level is known.
      // In order to discover the range, we load the best matching fragment for that level and demux it.
      // Do not load using live logic if the starting frag is requested - we want to use getFragmentAtPosition() so that
      // we get the fragment matching that start time
      if (!levelDetails.PTSKnown && !this.startFragRequested && this.startPosition === -1 || pos < start) {
        var _frag;
        if (canLoadParts && !this.loadingParts) {
          this.log(`LL-Part loading ON for initial live fragment`);
          this.loadingParts = true;
        }
        frag = this.getInitialLiveFragment(levelDetails);
        const mainStart = this.hls.startPosition;
        const liveSyncPosition = this.hls.liveSyncPosition;
        const startPosition = frag ? (mainStart !== -1 && mainStart >= start ? mainStart : liveSyncPosition) || frag.start : pos;
        this.log(`Setting startPosition to ${startPosition} to match start frag at live edge. mainStart: ${mainStart} liveSyncPosition: ${liveSyncPosition} frag.start: ${(_frag = frag) == null ? void 0 : _frag.start}`);
        this.startPosition = this.nextLoadPosition = startPosition;
      }
    } else if (pos <= start) {
      // VoD playlist: if loadPosition before start of playlist, load first fragment
      frag = fragments[0];
    }

    // If we haven't run into any special cases already, just load the fragment most closely matching the requested position
    if (!frag) {
      const end = this.loadingParts ? levelDetails.partEnd : levelDetails.fragmentEnd;
      frag = this.getFragmentAtPosition(pos, end, levelDetails);
    }
    let programFrag = this.filterReplacedPrimary(frag, levelDetails);
    if (!programFrag && frag) {
      const curSNIdx = frag.sn - levelDetails.startSN;
      programFrag = this.filterReplacedPrimary(fragments[curSNIdx + 1] || null, levelDetails);
    }
    return this.mapToInitFragWhenRequired(programFrag);
  }
  isLoopLoading(frag, targetBufferTime) {
    const trackerState = this.fragmentTracker.getState(frag);
    return (trackerState === FragmentState.OK || trackerState === FragmentState.PARTIAL && !!frag.gap) && this.nextLoadPosition > targetBufferTime;
  }
  getNextFragmentLoopLoading(frag, levelDetails, bufferInfo, playlistType, maxBufLen) {
    let nextFragment = null;
    if (frag.gap) {
      nextFragment = this.getNextFragment(this.nextLoadPosition, levelDetails);
      if (nextFragment && !nextFragment.gap && bufferInfo.nextStart) {
        // Media buffered after GAP tags should not make the next buffer timerange exceed forward buffer length
        const nextbufferInfo = this.getFwdBufferInfoAtPos(this.mediaBuffer ? this.mediaBuffer : this.media, bufferInfo.nextStart, playlistType, 0);
        if (nextbufferInfo !== null && bufferInfo.len + nextbufferInfo.len >= maxBufLen) {
          // Returning here might result in not finding an audio and video candiate to skip to
          const sn = nextFragment.sn;
          if (this.loopSn !== sn) {
            this.log(`buffer full after gaps in "${playlistType}" playlist starting at sn: ${sn}`);
            this.loopSn = sn;
          }
          return null;
        }
      }
    }
    this.loopSn = undefined;
    return nextFragment;
  }
  get primaryPrefetch() {
    if (interstitialsEnabled(this.hls.config)) {
      var _this$hls$interstitia, _this$hls$interstitia2;
      const playingInterstitial = (_this$hls$interstitia = this.hls.interstitialsManager) == null ? void 0 : (_this$hls$interstitia2 = _this$hls$interstitia.playingItem) == null ? void 0 : _this$hls$interstitia2.event;
      if (playingInterstitial) {
        return true;
      }
    }
    return false;
  }
  filterReplacedPrimary(frag, details) {
    if (!frag) {
      return frag;
    }
    if (interstitialsEnabled(this.hls.config) && frag.type !== PlaylistLevelType.SUBTITLE) {
      // Do not load fragments outside the buffering schedule segment
      const interstitials = this.hls.interstitialsManager;
      const bufferingItem = interstitials == null ? void 0 : interstitials.bufferingItem;
      if (bufferingItem) {
        const bufferingInterstitial = bufferingItem.event;
        if (bufferingInterstitial) {
          // Do not stream fragments while buffering Interstitial Events (except for overlap at the start)
          if (bufferingInterstitial.appendInPlace || Math.abs(frag.start - bufferingItem.start) > 1 || bufferingItem.start === 0) {
            return null;
          }
        } else {
          // Limit fragment loading to media in schedule item
          if (frag.end <= bufferingItem.start && (details == null ? void 0 : details.live) === false) {
            // fragment ends by schedule item start
            // this.fragmentTracker.fragBuffered(frag, true);
            return null;
          }
          if (frag.start > bufferingItem.end && bufferingItem.nextEvent) {
            // fragment is past schedule item end
            // allow some overflow when not appending in place to prevent stalls
            if (bufferingItem.nextEvent.appendInPlace || frag.start - bufferingItem.end > 1) {
              return null;
            }
          }
        }
      }
      // Skip loading of fragments that overlap completely with appendInPlace interstitials
      const playerQueue = interstitials == null ? void 0 : interstitials.playerQueue;
      if (playerQueue) {
        for (let i = playerQueue.length; i--;) {
          const interstitial = playerQueue[i].interstitial;
          if (interstitial.appendInPlace && frag.start >= interstitial.startTime && frag.end <= interstitial.resumeTime) {
            return null;
          }
        }
      }
    }
    return frag;
  }
  mapToInitFragWhenRequired(frag) {
    // If an initSegment is present, it must be buffered first
    if (frag != null && frag.initSegment && !(frag != null && frag.initSegment.data) && !this.bitrateTest) {
      return frag.initSegment;
    }
    return frag;
  }
  getNextPart(partList, frag, targetBufferTime) {
    let nextPart = -1;
    let contiguous = false;
    let independentAttrOmitted = true;
    for (let i = 0, len = partList.length; i < len; i++) {
      const part = partList[i];
      independentAttrOmitted = independentAttrOmitted && !part.independent;
      if (nextPart > -1 && targetBufferTime < part.start) {
        break;
      }
      const loaded = part.loaded;
      if (loaded) {
        nextPart = -1;
      } else if ((contiguous || part.independent || independentAttrOmitted) && part.fragment === frag) {
        nextPart = i;
      }
      contiguous = loaded;
    }
    return nextPart;
  }
  loadedEndOfParts(partList, targetBufferTime) {
    const lastPart = partList[partList.length - 1];
    return lastPart && targetBufferTime > lastPart.start && lastPart.loaded;
  }

  /*
   This method is used find the best matching first fragment for a live playlist. This fragment is used to calculate the
   "sliding" of the playlist, which is its offset from the start of playback. After sliding we can compute the real
   start and end times for each fragment in the playlist (after which this method will not need to be called).
  */
  getInitialLiveFragment(levelDetails) {
    const fragments = levelDetails.fragments;
    const fragPrevious = this.fragPrevious;
    let frag = null;
    if (fragPrevious) {
      if (levelDetails.hasProgramDateTime) {
        // Prefer using PDT, because it can be accurate enough to choose the correct fragment without knowing the level sliding
        this.log(`Live playlist, switching playlist, load frag with same PDT: ${fragPrevious.programDateTime}`);
        frag = findFragmentByPDT(fragments, fragPrevious.endProgramDateTime, this.config.maxFragLookUpTolerance);
      }
      if (!frag) {
        // SN does not need to be accurate between renditions, but depending on the packaging it may be so.
        const targetSN = fragPrevious.sn + 1;
        if (targetSN >= levelDetails.startSN && targetSN <= levelDetails.endSN) {
          const fragNext = fragments[targetSN - levelDetails.startSN];
          // Ensure that we're staying within the continuity range, since PTS resets upon a new range
          if (fragPrevious.cc === fragNext.cc) {
            frag = fragNext;
            this.log(`Live playlist, switching playlist, load frag with next SN: ${frag.sn}`);
          }
        }
        // It's important to stay within the continuity range if available; otherwise the fragments in the playlist
        // will have the wrong start times
        if (!frag) {
          frag = findNearestWithCC(levelDetails, fragPrevious.cc, fragPrevious.end);
          if (frag) {
            this.log(`Live playlist, switching playlist, load frag with same CC: ${frag.sn}`);
          }
        }
      }
    } else {
      // Find a new start fragment when fragPrevious is null
      const liveStart = this.hls.liveSyncPosition;
      if (liveStart !== null) {
        frag = this.getFragmentAtPosition(liveStart, this.bitrateTest ? levelDetails.fragmentEnd : levelDetails.edge, levelDetails);
      }
    }
    return frag;
  }

  /*
  This method finds the best matching fragment given the provided position.
   */
  getFragmentAtPosition(bufferEnd, end, levelDetails) {
    const {
      config
    } = this;
    let {
      fragPrevious
    } = this;
    let {
      fragments,
      endSN
    } = levelDetails;
    const {
      fragmentHint
    } = levelDetails;
    const {
      maxFragLookUpTolerance
    } = config;
    const partList = levelDetails.partList;
    const loadingParts = !!(this.loadingParts && partList != null && partList.length && fragmentHint);
    if (loadingParts && fragmentHint && !this.bitrateTest && partList[partList.length - 1].fragment.sn === fragmentHint.sn) {
      // Include incomplete fragment with parts at end
      fragments = fragments.concat(fragmentHint);
      endSN = fragmentHint.sn;
    }
    let frag;
    if (bufferEnd < end) {
      var _this$media3;
      const backwardSeek = bufferEnd < this.lastCurrentTime;
      const lookupTolerance = backwardSeek || bufferEnd > end - maxFragLookUpTolerance || (_this$media3 = this.media) != null && _this$media3.paused || !this.startFragRequested ? 0 : maxFragLookUpTolerance;
      // Remove the tolerance if it would put the bufferEnd past the actual end of stream
      // Uses buffer and sequence number to calculate switch segment (required if using EXT-X-DISCONTINUITY-SEQUENCE)
      frag = findFragmentByPTS(fragPrevious, fragments, bufferEnd, lookupTolerance);
    } else {
      // reach end of playlist
      frag = fragments[fragments.length - 1];
    }
    if (frag) {
      const curSNIdx = frag.sn - levelDetails.startSN;
      // Move fragPrevious forward to support forcing the next fragment to load
      // when the buffer catches up to a previously buffered range.
      const fragState = this.fragmentTracker.getState(frag);
      if (fragState === FragmentState.OK || fragState === FragmentState.PARTIAL && frag.gap) {
        fragPrevious = frag;
      }
      if (fragPrevious && frag.sn === fragPrevious.sn && (!loadingParts || partList[0].fragment.sn > frag.sn || !levelDetails.live && !loadingParts)) {
        // Force the next fragment to load if the previous one was already selected. This can occasionally happen with
        // non-uniform fragment durations
        const sameLevel = fragPrevious && frag.level === fragPrevious.level;
        if (sameLevel) {
          const nextFrag = fragments[curSNIdx + 1];
          if (frag.sn < endSN && this.fragmentTracker.getState(nextFrag) !== FragmentState.OK) {
            frag = nextFrag;
          } else {
            frag = null;
          }
        }
      }
    }
    return frag;
  }
  alignPlaylists(details, previousDetails, switchDetails) {
    // TODO: If not for `shouldAlignOnDiscontinuities` requiring fragPrevious.cc,
    //  this could all go in level-helper mergeDetails()
    const length = details.fragments.length;
    if (!length) {
      this.warn(`No fragments in live playlist`);
      return 0;
    }
    const slidingStart = details.fragmentStart;
    const firstLevelLoad = !previousDetails;
    const aligned = details.alignedSliding && isFiniteNumber(slidingStart);
    if (firstLevelLoad || !aligned && !slidingStart) {
      alignStream(switchDetails, details);
      const alignedSlidingStart = details.fragmentStart;
      this.log(`Live playlist sliding: ${alignedSlidingStart.toFixed(2)} start-sn: ${previousDetails ? previousDetails.startSN : 'na'}->${details.startSN} fragments: ${length}`);
      return alignedSlidingStart;
    }
    return slidingStart;
  }
  waitForCdnTuneIn(details) {
    // Wait for Low-Latency CDN Tune-in to get an updated playlist
    const advancePartLimit = 3;
    return details.live && details.canBlockReload && details.partTarget && details.tuneInGoal > Math.max(details.partHoldBack, details.partTarget * advancePartLimit);
  }
  setStartPosition(details, sliding) {
    // compute start position if set to -1. use it straight away if value is defined
    let startPosition = this.startPosition;
    if (startPosition < sliding) {
      startPosition = -1;
    }
    const timelineOffset = this.timelineOffset;
    if (startPosition === -1) {
      // Use Playlist EXT-X-START:TIME-OFFSET when set
      // Prioritize Multivariant Playlist offset so that main, audio, and subtitle stream-controller start times match
      const offsetInMultivariantPlaylist = this.startTimeOffset !== null;
      const startTimeOffset = offsetInMultivariantPlaylist ? this.startTimeOffset : details.startTimeOffset;
      if (startTimeOffset !== null && isFiniteNumber(startTimeOffset)) {
        startPosition = sliding + startTimeOffset;
        if (startTimeOffset < 0) {
          startPosition += details.edge;
        }
        startPosition = Math.min(Math.max(sliding, startPosition), sliding + details.totalduration);
        this.log(`Setting startPosition to ${startPosition} for start time offset ${startTimeOffset} found in ${offsetInMultivariantPlaylist ? 'multivariant' : 'media'} playlist`);
        this.startPosition = startPosition;
      } else if (details.live) {
        // Leave this.startPosition at -1, so that we can use `getInitialLiveFragment` logic when startPosition has
        // not been specified via the config or an as an argument to startLoad (#3736).
        startPosition = this.hls.liveSyncPosition || sliding;
        this.log(`Setting startPosition to -1 to start at live edge ${startPosition}`);
        this.startPosition = -1;
      } else {
        this.log(`setting startPosition to 0 by default`);
        this.startPosition = startPosition = 0;
      }
      this.lastCurrentTime = startPosition + timelineOffset;
    }
    this.nextLoadPosition = startPosition + timelineOffset;
  }
  getLoadPosition() {
    var _this$hls;
    const {
      media
    } = this;
    // if we have not yet loaded any fragment, start loading from start position
    let pos = 0;
    if ((_this$hls = this.hls) != null && _this$hls.hasEnoughToStart && media) {
      pos = media.currentTime;
    } else if (this.nextLoadPosition >= 0) {
      pos = this.nextLoadPosition;
    }
    return pos;
  }
  handleFragLoadAborted(frag, part) {
    if (this.transmuxer && frag.type === this.playlistType && isMediaFragment(frag) && frag.stats.aborted) {
      this.warn(`Fragment ${frag.sn}${part ? ' part ' + part.index : ''} of ${this.playlistLabel()} ${frag.level} was aborted`);
      this.resetFragmentLoading(frag);
    }
  }
  resetFragmentLoading(frag) {
    if (!this.fragCurrent || !this.fragContextChanged(frag) && this.state !== State.FRAG_LOADING_WAITING_RETRY) {
      this.state = State.IDLE;
    }
  }
  onFragmentOrKeyLoadError(filterType, data) {
    if (data.chunkMeta && !data.frag) {
      const context = this.getCurrentContext(data.chunkMeta);
      if (context) {
        data.frag = context.frag;
      }
    }
    const frag = data.frag;
    // Handle frag error related to caller's filterType
    if (!frag || frag.type !== filterType || !this.levels) {
      return;
    }
    if (this.fragContextChanged(frag)) {
      var _this$fragCurrent;
      this.warn(`Frag load error must match current frag to retry ${frag.url} > ${(_this$fragCurrent = this.fragCurrent) == null ? void 0 : _this$fragCurrent.url}`);
      return;
    }
    const gapTagEncountered = data.details === ErrorDetails.FRAG_GAP;
    if (gapTagEncountered) {
      this.fragmentTracker.fragBuffered(frag, true);
    }
    // keep retrying until the limit will be reached
    const errorAction = data.errorAction;
    const {
      action,
      flags,
      retryCount = 0,
      retryConfig
    } = errorAction || {};
    const couldRetry = !!errorAction && !!retryConfig;
    const retry = couldRetry && action === NetworkErrorAction.RetryRequest;
    const noAlternate = couldRetry && !errorAction.resolved && flags === ErrorActionFlags.MoveAllAlternatesMatchingHost;
    if (!retry && noAlternate && isMediaFragment(frag) && !frag.endList) {
      this.resetFragmentErrors(filterType);
      this.treatAsGap(frag);
      errorAction.resolved = true;
    } else if ((retry || noAlternate) && retryCount < retryConfig.maxNumRetry) {
      this.resetStartWhenNotLoaded(this.levelLastLoaded);
      const delay = getRetryDelay(retryConfig, retryCount);
      this.warn(`Fragment ${frag.sn} of ${filterType} ${frag.level} errored with ${data.details}, retrying loading ${retryCount + 1}/${retryConfig.maxNumRetry} in ${delay}ms`);
      errorAction.resolved = true;
      this.retryDate = self.performance.now() + delay;
      this.state = State.FRAG_LOADING_WAITING_RETRY;
    } else if (retryConfig && errorAction) {
      this.resetFragmentErrors(filterType);
      if (retryCount < retryConfig.maxNumRetry) {
        // Network retry is skipped when level switch is preferred
        if (!gapTagEncountered && action !== NetworkErrorAction.RemoveAlternatePermanently) {
          errorAction.resolved = true;
        }
      } else {
        this.warn(`${data.details} reached or exceeded max retry (${retryCount})`);
        return;
      }
    } else if (action === NetworkErrorAction.SendAlternateToPenaltyBox) {
      this.state = State.WAITING_LEVEL;
    } else {
      this.state = State.ERROR;
    }
    // Perform next async tick sooner to speed up error action resolution
    this.tickImmediate();
  }
  reduceLengthAndFlushBuffer(data) {
    // if in appending state
    if (this.state === State.PARSING || this.state === State.PARSED) {
      const frag = data.frag;
      const playlistType = data.parent;
      const bufferedInfo = this.getFwdBufferInfo(this.mediaBuffer, playlistType);
      // 0.5 : tolerance needed as some browsers stalls playback before reaching buffered end
      // reduce max buf len if current position is buffered
      const buffered = bufferedInfo && bufferedInfo.len > 0.5;
      if (buffered) {
        this.reduceMaxBufferLength(bufferedInfo.len, (frag == null ? void 0 : frag.duration) || 10);
      }
      const flushBuffer = !buffered;
      if (flushBuffer) {
        // current position is not buffered, but browser is still complaining about buffer full error
        // this happens on IE/Edge, refer to https://github.com/video-dev/hls.js/pull/708
        // in that case flush the whole audio buffer to recover
        this.warn(`Buffer full error while media.currentTime is not buffered, flush ${playlistType} buffer`);
      }
      if (frag) {
        this.fragmentTracker.removeFragment(frag);
        this.nextLoadPosition = frag.start;
      }
      this.resetLoadingState();
      return flushBuffer;
    }
    return false;
  }
  resetFragmentErrors(filterType) {
    if (filterType === PlaylistLevelType.AUDIO) {
      // Reset current fragment since audio track audio is essential and may not have a fail-over track
      this.fragCurrent = null;
    }
    // Fragment errors that result in a level switch or redundant fail-over
    // should reset the stream controller state to idle
    if (!this.hls.hasEnoughToStart) {
      this.startFragRequested = false;
    }
    if (this.state !== State.STOPPED) {
      this.state = State.IDLE;
    }
  }
  afterBufferFlushed(media, bufferType, playlistType) {
    if (!media) {
      return;
    }
    // After successful buffer flushing, filter flushed fragments from bufferedFrags use mediaBuffered instead of media
    // (so that we will check against video.buffered ranges in case of alt audio track)
    const bufferedTimeRanges = BufferHelper.getBuffered(media);
    this.fragmentTracker.detectEvictedFragments(bufferType, bufferedTimeRanges, playlistType);
    if (this.state === State.ENDED) {
      this.resetLoadingState();
    }
  }
  resetLoadingState() {
    this.log('Reset loading state');
    this.fragCurrent = null;
    this.fragPrevious = null;
    if (this.state !== State.STOPPED) {
      this.state = State.IDLE;
    }
  }
  resetStartWhenNotLoaded(level) {
    // if loadedmetadata is not set, it means that first frag request failed
    // in that case, reset startFragRequested flag
    if (!this.hls.hasEnoughToStart) {
      this.startFragRequested = false;
      const details = level ? level.details : null;
      if (details != null && details.live) {
        // Update the start position and return to IDLE to recover live start
        this.log(`resetting startPosition for live start`);
        this.startPosition = -1;
        this.setStartPosition(details, details.fragmentStart);
        this.resetLoadingState();
      } else {
        this.nextLoadPosition = this.startPosition;
      }
    }
  }
  resetWhenMissingContext(chunkMeta) {
    this.warn(`The loading context changed while buffering fragment ${chunkMeta.sn} of ${this.playlistLabel()} ${chunkMeta.level}. This chunk will not be buffered.`);
    this.removeUnbufferedFrags();
    this.resetStartWhenNotLoaded(this.levelLastLoaded);
    this.resetLoadingState();
  }
  removeUnbufferedFrags(start = 0) {
    this.fragmentTracker.removeFragmentsInRange(start, Infinity, this.playlistType, false, true);
  }
  updateLevelTiming(frag, part, level, partial) {
    const details = level.details;
    if (!details) {
      this.warn('level.details undefined');
      return;
    }
    const parsed = Object.keys(frag.elementaryStreams).reduce((result, type) => {
      const info = frag.elementaryStreams[type];
      if (info) {
        const parsedDuration = info.endPTS - info.startPTS;
        if (parsedDuration <= 0) {
          // Destroy the transmuxer after it's next time offset failed to advance because duration was <= 0.
          // The new transmuxer will be configured with a time offset matching the next fragment start,
          // preventing the timeline from shifting.
          this.warn(`Could not parse fragment ${frag.sn} ${type} duration reliably (${parsedDuration})`);
          return result || false;
        }
        const drift = partial ? 0 : updateFragPTSDTS(details, frag, info.startPTS, info.endPTS, info.startDTS, info.endDTS);
        this.hls.trigger(Events.LEVEL_PTS_UPDATED, {
          details,
          level,
          drift,
          type,
          frag,
          start: info.startPTS,
          end: info.endPTS
        });
        return true;
      }
      return result;
    }, false);
    if (!parsed) {
      var _this$transmuxer;
      if (level.fragmentError === 0) {
        // Mark and track the odd empty segment as a gap to avoid reloading
        this.treatAsGap(frag, level);
      }
      if (((_this$transmuxer = this.transmuxer) == null ? void 0 : _this$transmuxer.error) === null) {
        const error = new Error(`Found no media in fragment ${frag.sn} of ${this.playlistLabel()} ${frag.level} resetting transmuxer to fallback to playlist timing`);
        this.warn(error.message);
        this.hls.trigger(Events.ERROR, {
          type: ErrorTypes.MEDIA_ERROR,
          details: ErrorDetails.FRAG_PARSING_ERROR,
          fatal: false,
          error,
          frag,
          reason: `Found no media in msn ${frag.sn} of ${this.playlistLabel()} "${level.url}"`
        });
        if (!this.hls) {
          return;
        }
        this.resetTransmuxer();
      }
      // For this error fallthrough. Marking parsed will allow advancing to next fragment.
    }
    this.state = State.PARSED;
    this.log(`Parsed ${frag.type} sn: ${frag.sn}${part ? ' part: ' + part.index : ''} of ${this.fragInfo(frag, false, part)})`);
    this.hls.trigger(Events.FRAG_PARSED, {
      frag,
      part
    });
  }
  playlistLabel() {
    return this.playlistType === PlaylistLevelType.MAIN ? 'level' : 'track';
  }
  fragInfo(frag, pts = true, part) {
    var _ref, _ref2;
    return `${this.playlistLabel()} ${frag.level} (${part ? 'part' : 'frag'}:[${((_ref = pts && !part ? frag.startPTS : (part || frag).start) != null ? _ref : NaN).toFixed(3)}-${((_ref2 = pts && !part ? frag.endPTS : (part || frag).end) != null ? _ref2 : NaN).toFixed(3)}]${part && frag.type === 'main' ? 'INDEPENDENT=' + (part.independent ? 'YES' : 'NO') : ''}`;
  }
  treatAsGap(frag, level) {
    if (level) {
      level.fragmentError++;
    }
    frag.gap = true;
    this.fragmentTracker.removeFragment(frag);
    this.fragmentTracker.fragBuffered(frag, true);
  }
  resetTransmuxer() {
    var _this$transmuxer2;
    (_this$transmuxer2 = this.transmuxer) == null ? void 0 : _this$transmuxer2.reset();
  }
  recoverWorkerError(data) {
    if (data.event === 'demuxerWorker') {
      this.fragmentTracker.removeAllFragments();
      if (this.transmuxer) {
        this.transmuxer.destroy();
        this.transmuxer = null;
      }
      this.resetStartWhenNotLoaded(this.levelLastLoaded);
      this.resetLoadingState();
    }
  }
  set state(nextState) {
    const previousState = this._state;
    if (previousState !== nextState) {
      this._state = nextState;
      this.log(`${previousState}->${nextState}`);
    }
  }
  get state() {
    return this._state;
  }
}
function interstitialsEnabled(config) {
  return !!config.interstitialsController && config.enableInterstitialPlayback !== false;
}

class ChunkCache {
  constructor() {
    this.chunks = [];
    this.dataLength = 0;
  }
  push(chunk) {
    this.chunks.push(chunk);
    this.dataLength += chunk.length;
  }
  flush() {
    const {
      chunks,
      dataLength
    } = this;
    let result;
    if (!chunks.length) {
      return new Uint8Array(0);
    } else if (chunks.length === 1) {
      result = chunks[0];
    } else {
      result = concatUint8Arrays(chunks, dataLength);
    }
    this.reset();
    return result;
  }
  reset() {
    this.chunks.length = 0;
    this.dataLength = 0;
  }
}
function concatUint8Arrays(chunks, dataLength) {
  const result = new Uint8Array(dataLength);
  let offset = 0;
  for (let i = 0; i < chunks.length; i++) {
    const chunk = chunks[i];
    result.set(chunk, offset);
    offset += chunk.length;
  }
  return result;
}

var eventemitter3 = {exports: {}};

var hasRequiredEventemitter3;

function requireEventemitter3 () {
	if (hasRequiredEventemitter3) return eventemitter3.exports;
	hasRequiredEventemitter3 = 1;
	(function (module) {

		var has = Object.prototype.hasOwnProperty
		  , prefix = '~';

		/**
		 * Constructor to create a storage for our `EE` objects.
		 * An `Events` instance is a plain object whose properties are event names.
		 *
		 * @constructor
		 * @private
		 */
		function Events() {}

		//
		// We try to not inherit from `Object.prototype`. In some engines creating an
		// instance in this way is faster than calling `Object.create(null)` directly.
		// If `Object.create(null)` is not supported we prefix the event names with a
		// character to make sure that the built-in object properties are not
		// overridden or used as an attack vector.
		//
		if (Object.create) {
		  Events.prototype = Object.create(null);

		  //
		  // This hack is needed because the `__proto__` property is still inherited in
		  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
		  //
		  if (!new Events().__proto__) prefix = false;
		}

		/**
		 * Representation of a single event listener.
		 *
		 * @param {Function} fn The listener function.
		 * @param {*} context The context to invoke the listener with.
		 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
		 * @constructor
		 * @private
		 */
		function EE(fn, context, once) {
		  this.fn = fn;
		  this.context = context;
		  this.once = once || false;
		}

		/**
		 * Add a listener for a given event.
		 *
		 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
		 * @param {(String|Symbol)} event The event name.
		 * @param {Function} fn The listener function.
		 * @param {*} context The context to invoke the listener with.
		 * @param {Boolean} once Specify if the listener is a one-time listener.
		 * @returns {EventEmitter}
		 * @private
		 */
		function addListener(emitter, event, fn, context, once) {
		  if (typeof fn !== 'function') {
		    throw new TypeError('The listener must be a function');
		  }

		  var listener = new EE(fn, context || emitter, once)
		    , evt = prefix ? prefix + event : event;

		  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
		  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
		  else emitter._events[evt] = [emitter._events[evt], listener];

		  return emitter;
		}

		/**
		 * Clear event by name.
		 *
		 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
		 * @param {(String|Symbol)} evt The Event name.
		 * @private
		 */
		function clearEvent(emitter, evt) {
		  if (--emitter._eventsCount === 0) emitter._events = new Events();
		  else delete emitter._events[evt];
		}

		/**
		 * Minimal `EventEmitter` interface that is molded against the Node.js
		 * `EventEmitter` interface.
		 *
		 * @constructor
		 * @public
		 */
		function EventEmitter() {
		  this._events = new Events();
		  this._eventsCount = 0;
		}

		/**
		 * Return an array listing the events for which the emitter has registered
		 * listeners.
		 *
		 * @returns {Array}
		 * @public
		 */
		EventEmitter.prototype.eventNames = function eventNames() {
		  var names = []
		    , events
		    , name;

		  if (this._eventsCount === 0) return names;

		  for (name in (events = this._events)) {
		    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
		  }

		  if (Object.getOwnPropertySymbols) {
		    return names.concat(Object.getOwnPropertySymbols(events));
		  }

		  return names;
		};

		/**
		 * Return the listeners registered for a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @returns {Array} The registered listeners.
		 * @public
		 */
		EventEmitter.prototype.listeners = function listeners(event) {
		  var evt = prefix ? prefix + event : event
		    , handlers = this._events[evt];

		  if (!handlers) return [];
		  if (handlers.fn) return [handlers.fn];

		  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
		    ee[i] = handlers[i].fn;
		  }

		  return ee;
		};

		/**
		 * Return the number of listeners listening to a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @returns {Number} The number of listeners.
		 * @public
		 */
		EventEmitter.prototype.listenerCount = function listenerCount(event) {
		  var evt = prefix ? prefix + event : event
		    , listeners = this._events[evt];

		  if (!listeners) return 0;
		  if (listeners.fn) return 1;
		  return listeners.length;
		};

		/**
		 * Calls each of the listeners registered for a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @returns {Boolean} `true` if the event had listeners, else `false`.
		 * @public
		 */
		EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
		  var evt = prefix ? prefix + event : event;

		  if (!this._events[evt]) return false;

		  var listeners = this._events[evt]
		    , len = arguments.length
		    , args
		    , i;

		  if (listeners.fn) {
		    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

		    switch (len) {
		      case 1: return listeners.fn.call(listeners.context), true;
		      case 2: return listeners.fn.call(listeners.context, a1), true;
		      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
		      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
		      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
		      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
		    }

		    for (i = 1, args = new Array(len -1); i < len; i++) {
		      args[i - 1] = arguments[i];
		    }

		    listeners.fn.apply(listeners.context, args);
		  } else {
		    var length = listeners.length
		      , j;

		    for (i = 0; i < length; i++) {
		      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

		      switch (len) {
		        case 1: listeners[i].fn.call(listeners[i].context); break;
		        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
		        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
		        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
		        default:
		          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
		            args[j - 1] = arguments[j];
		          }

		          listeners[i].fn.apply(listeners[i].context, args);
		      }
		    }
		  }

		  return true;
		};

		/**
		 * Add a listener for a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @param {Function} fn The listener function.
		 * @param {*} [context=this] The context to invoke the listener with.
		 * @returns {EventEmitter} `this`.
		 * @public
		 */
		EventEmitter.prototype.on = function on(event, fn, context) {
		  return addListener(this, event, fn, context, false);
		};

		/**
		 * Add a one-time listener for a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @param {Function} fn The listener function.
		 * @param {*} [context=this] The context to invoke the listener with.
		 * @returns {EventEmitter} `this`.
		 * @public
		 */
		EventEmitter.prototype.once = function once(event, fn, context) {
		  return addListener(this, event, fn, context, true);
		};

		/**
		 * Remove the listeners of a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @param {Function} fn Only remove the listeners that match this function.
		 * @param {*} context Only remove the listeners that have this context.
		 * @param {Boolean} once Only remove one-time listeners.
		 * @returns {EventEmitter} `this`.
		 * @public
		 */
		EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
		  var evt = prefix ? prefix + event : event;

		  if (!this._events[evt]) return this;
		  if (!fn) {
		    clearEvent(this, evt);
		    return this;
		  }

		  var listeners = this._events[evt];

		  if (listeners.fn) {
		    if (
		      listeners.fn === fn &&
		      (!once || listeners.once) &&
		      (!context || listeners.context === context)
		    ) {
		      clearEvent(this, evt);
		    }
		  } else {
		    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
		      if (
		        listeners[i].fn !== fn ||
		        (once && !listeners[i].once) ||
		        (context && listeners[i].context !== context)
		      ) {
		        events.push(listeners[i]);
		      }
		    }

		    //
		    // Reset the array, or remove it completely if we have no more listeners.
		    //
		    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
		    else clearEvent(this, evt);
		  }

		  return this;
		};

		/**
		 * Remove all listeners, or those of the specified event.
		 *
		 * @param {(String|Symbol)} [event] The event name.
		 * @returns {EventEmitter} `this`.
		 * @public
		 */
		EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
		  var evt;

		  if (event) {
		    evt = prefix ? prefix + event : event;
		    if (this._events[evt]) clearEvent(this, evt);
		  } else {
		    this._events = new Events();
		    this._eventsCount = 0;
		  }

		  return this;
		};

		//
		// Alias methods names because people roll like that.
		//
		EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
		EventEmitter.prototype.addListener = EventEmitter.prototype.on;

		//
		// Expose the prefix.
		//
		EventEmitter.prefixed = prefix;

		//
		// Allow `EventEmitter` to be imported as module namespace.
		//
		EventEmitter.EventEmitter = EventEmitter;

		//
		// Expose the module.
		//
		{
		  module.exports = EventEmitter;
		} 
	} (eventemitter3));
	return eventemitter3.exports;
}

var eventemitter3Exports = requireEventemitter3();
var hls_EventEmitter = /*@__PURE__*/getDefaultExportFromCjs(eventemitter3Exports);

const version = "1.6.5";

// ensure the worker ends up in the bundle
// If the worker should not be included this gets aliased to empty.js
const workerStore = {};
function hasUMDWorker() {
  return typeof __HLS_WORKER_BUNDLE__ === 'function';
}
function injectWorker() {
  const workerContext = workerStore[version];
  if (workerContext) {
    workerContext.clientCount++;
    return workerContext;
  }
  const blob = new self.Blob([`var exports={};var module={exports:exports};function define(f){f()};define.amd=true;(${__HLS_WORKER_BUNDLE__.toString()})(true);`], {
    type: 'text/javascript'
  });
  const objectURL = self.URL.createObjectURL(blob);
  const worker = new self.Worker(objectURL);
  const result = {
    worker,
    objectURL,
    clientCount: 1
  };
  workerStore[version] = result;
  return result;
}
function loadWorker(path) {
  const workerContext = workerStore[path];
  if (workerContext) {
    workerContext.clientCount++;
    return workerContext;
  }
  const scriptURL = new self.URL(path, self.location.href).href;
  const worker = new self.Worker(scriptURL);
  const result = {
    worker,
    scriptURL,
    clientCount: 1
  };
  workerStore[path] = result;
  return result;
}
function removeWorkerFromStore(path) {
  const workerContext = workerStore[path || version];
  if (workerContext) {
    const clientCount = workerContext.clientCount--;
    if (clientCount === 1) {
      const {
        worker,
        objectURL
      } = workerContext;
      delete workerStore[path || version];
      if (objectURL) {
        // revoke the Object URL that was used to create transmuxer worker, so as not to leak it
        self.URL.revokeObjectURL(objectURL);
      }
      worker.terminate();
    }
  }
}

/**
 * Returns true if an ID3 footer can be found at offset in data
 *
 * @param data - The data to search in
 * @param offset - The offset at which to start searching
 *
 * @returns `true` if an ID3 footer is found
 *
 * @internal
 *
 * @group ID3
 */
function isId3Footer(data, offset) {
  /*
   * The footer is a copy of the header, but with a different identifier
   */
  if (offset + 10 <= data.length) {
    // look for '3DI' identifier
    if (data[offset] === 0x33 && data[offset + 1] === 0x44 && data[offset + 2] === 0x49) {
      // check version is within range
      if (data[offset + 3] < 0xff && data[offset + 4] < 0xff) {
        // check size is within range
        if (data[offset + 6] < 0x80 && data[offset + 7] < 0x80 && data[offset + 8] < 0x80 && data[offset + 9] < 0x80) {
          return true;
        }
      }
    }
  }
  return false;
}

/**
 * Returns true if an ID3 header can be found at offset in data
 *
 * @param data - The data to search in
 * @param offset - The offset at which to start searching
 *
 * @returns `true` if an ID3 header is found
 *
 * @internal
 *
 * @group ID3
 */
function isId3Header(data, offset) {
  /*
   * http://id3.org/id3v2.3.0
   * [0]     = 'I'
   * [1]     = 'D'
   * [2]     = '3'
   * [3,4]   = {Version}
   * [5]     = {Flags}
   * [6-9]   = {ID3 Size}
   *
   * An ID3v2 tag can be detected with the following pattern:
   *  $49 44 33 yy yy xx zz zz zz zz
   * Where yy is less than $FF, xx is the 'flags' byte and zz is less than $80
   */
  if (offset + 10 <= data.length) {
    // look for 'ID3' identifier
    if (data[offset] === 0x49 && data[offset + 1] === 0x44 && data[offset + 2] === 0x33) {
      // check version is within range
      if (data[offset + 3] < 0xff && data[offset + 4] < 0xff) {
        // check size is within range
        if (data[offset + 6] < 0x80 && data[offset + 7] < 0x80 && data[offset + 8] < 0x80 && data[offset + 9] < 0x80) {
          return true;
        }
      }
    }
  }
  return false;
}

/**
 * Read ID3 size
 *
 * @param data - The data to read from
 * @param offset - The offset at which to start reading
 *
 * @returns The size
 *
 * @internal
 *
 * @group ID3
 */
function readId3Size(data, offset) {
  let size = 0;
  size = (data[offset] & 0x7f) << 21;
  size |= (data[offset + 1] & 0x7f) << 14;
  size |= (data[offset + 2] & 0x7f) << 7;
  size |= data[offset + 3] & 0x7f;
  return size;
}

/**
 * Returns any adjacent ID3 tags found in data starting at offset, as one block of data
 *
 * @param data - The data to search in
 * @param offset - The offset at which to start searching
 *
 * @returns The block of data containing any ID3 tags found
 * or `undefined` if no header is found at the starting offset
 *
 * @internal
 *
 * @group ID3
 */
function getId3Data(data, offset) {
  const front = offset;
  let length = 0;
  while (isId3Header(data, offset)) {
    // ID3 header is 10 bytes
    length += 10;
    const size = readId3Size(data, offset + 6);
    length += size;
    if (isId3Footer(data, offset + 10)) {
      // ID3 footer is 10 bytes
      length += 10;
    }
    offset += length;
  }
  if (length > 0) {
    return data.subarray(front, front + length);
  }
  return undefined;
}

function getAudioConfig(observer, data, offset, manifestCodec) {
  const adtsSamplingRates = [96000, 88200, 64000, 48000, 44100, 32000, 24000, 22050, 16000, 12000, 11025, 8000, 7350];
  const byte2 = data[offset + 2];
  const adtsSamplingIndex = byte2 >> 2 & 0xf;
  if (adtsSamplingIndex > 12) {
    const error = new Error(`invalid ADTS sampling index:${adtsSamplingIndex}`);
    observer.emit(Events.ERROR, Events.ERROR, {
      type: ErrorTypes.MEDIA_ERROR,
      details: ErrorDetails.FRAG_PARSING_ERROR,
      fatal: true,
      error,
      reason: error.message
    });
    return;
  }
  // MPEG-4 Audio Object Type (profile_ObjectType+1)
  const adtsObjectType = (byte2 >> 6 & 0x3) + 1;
  const channelCount = data[offset + 3] >> 6 & 0x3 | (byte2 & 1) << 2;
  const codec = 'mp4a.40.' + adtsObjectType;
  /* refer to http://wiki.multimedia.cx/index.php?title=MPEG-4_Audio#Audio_Specific_Config
      ISO/IEC 14496-3 - Table 1.13 — Syntax of AudioSpecificConfig()
    Audio Profile / Audio Object Type
    0: Null
    1: AAC Main
    2: AAC LC (Low Complexity)
    3: AAC SSR (Scalable Sample Rate)
    4: AAC LTP (Long Term Prediction)
    5: SBR (Spectral Band Replication)
    6: AAC Scalable
   sampling freq
    0: 96000 Hz
    1: 88200 Hz
    2: 64000 Hz
    3: 48000 Hz
    4: 44100 Hz
    5: 32000 Hz
    6: 24000 Hz
    7: 22050 Hz
    8: 16000 Hz
    9: 12000 Hz
    10: 11025 Hz
    11: 8000 Hz
    12: 7350 Hz
    13: Reserved
    14: Reserved
    15: frequency is written explictly
    Channel Configurations
    These are the channel configurations:
    0: Defined in AOT Specifc Config
    1: 1 channel: front-center
    2: 2 channels: front-left, front-right
  */
  // audioObjectType = profile => profile, the MPEG-4 Audio Object Type minus 1
  const samplerate = adtsSamplingRates[adtsSamplingIndex];
  let aacSampleIndex = adtsSamplingIndex;
  if (adtsObjectType === 5 || adtsObjectType === 29) {
    // HE-AAC uses SBR (Spectral Band Replication) , high frequencies are constructed from low frequencies
    // there is a factor 2 between frame sample rate and output sample rate
    // multiply frequency by 2 (see table above, equivalent to substract 3)
    aacSampleIndex -= 3;
  }
  const config = [adtsObjectType << 3 | (aacSampleIndex & 0x0e) >> 1, (aacSampleIndex & 0x01) << 7 | channelCount << 3];
  hls_logger.log(`manifest codec:${manifestCodec}, parsed codec:${codec}, channels:${channelCount}, rate:${samplerate} (ADTS object type:${adtsObjectType} sampling index:${adtsSamplingIndex})`);
  return {
    config,
    samplerate,
    channelCount,
    codec,
    parsedCodec: codec,
    manifestCodec
  };
}
function isHeaderPattern$1(data, offset) {
  return data[offset] === 0xff && (data[offset + 1] & 0xf6) === 0xf0;
}
function getHeaderLength(data, offset) {
  return data[offset + 1] & 0x01 ? 7 : 9;
}
function getFullFrameLength(data, offset) {
  return (data[offset + 3] & 0x03) << 11 | data[offset + 4] << 3 | (data[offset + 5] & 0xe0) >>> 5;
}
function canGetFrameLength(data, offset) {
  return offset + 5 < data.length;
}
function isHeader$1(data, offset) {
  // Look for ADTS header | 1111 1111 | 1111 X00X | where X can be either 0 or 1
  // Layer bits (position 14 and 15) in header should be always 0 for ADTS
  // More info https://wiki.multimedia.cx/index.php?title=ADTS
  return offset + 1 < data.length && isHeaderPattern$1(data, offset);
}
function canParse$1(data, offset) {
  return canGetFrameLength(data, offset) && isHeaderPattern$1(data, offset) && getFullFrameLength(data, offset) <= data.length - offset;
}
function probe$1(data, offset) {
  // same as isHeader but we also check that ADTS frame follows last ADTS frame
  // or end of data is reached
  if (isHeader$1(data, offset)) {
    // ADTS header Length
    const headerLength = getHeaderLength(data, offset);
    if (offset + headerLength >= data.length) {
      return false;
    }
    // ADTS frame Length
    const frameLength = getFullFrameLength(data, offset);
    if (frameLength <= headerLength) {
      return false;
    }
    const newOffset = offset + frameLength;
    return newOffset === data.length || isHeader$1(data, newOffset);
  }
  return false;
}
function initTrackConfig(track, observer, data, offset, audioCodec) {
  if (!track.samplerate) {
    const config = getAudioConfig(observer, data, offset, audioCodec);
    if (!config) {
      return;
    }
    _extends(track, config);
  }
}
function getFrameDuration(samplerate) {
  return 1024 * 90000 / samplerate;
}
function parseFrameHeader(data, offset) {
  // The protection skip bit tells us if we have 2 bytes of CRC data at the end of the ADTS header
  const headerLength = getHeaderLength(data, offset);
  if (offset + headerLength <= data.length) {
    // retrieve frame size
    const frameLength = getFullFrameLength(data, offset) - headerLength;
    if (frameLength > 0) {
      // logger.log(`AAC frame, offset/length/total/pts:${offset+headerLength}/${frameLength}/${data.byteLength}`);
      return {
        headerLength,
        frameLength
      };
    }
  }
}
function appendFrame$2(track, data, offset, pts, frameIndex) {
  const frameDuration = getFrameDuration(track.samplerate);
  const stamp = pts + frameIndex * frameDuration;
  const header = parseFrameHeader(data, offset);
  let unit;
  if (header) {
    const {
      frameLength,
      headerLength
    } = header;
    const _length = headerLength + frameLength;
    const missing = Math.max(0, offset + _length - data.length);
    // logger.log(`AAC frame ${frameIndex}, pts:${stamp} length@offset/total: ${frameLength}@${offset+headerLength}/${data.byteLength} missing: ${missing}`);
    if (missing) {
      unit = new Uint8Array(_length - headerLength);
      unit.set(data.subarray(offset + headerLength, data.length), 0);
    } else {
      unit = data.subarray(offset + headerLength, offset + _length);
    }
    const _sample = {
      unit,
      pts: stamp
    };
    if (!missing) {
      track.samples.push(_sample);
    }
    return {
      sample: _sample,
      length: _length,
      missing
    };
  }
  // overflow incomplete header
  const length = data.length - offset;
  unit = new Uint8Array(length);
  unit.set(data.subarray(offset, data.length), 0);
  const sample = {
    unit,
    pts: stamp
  };
  return {
    sample,
    length,
    missing: -1
  };
}

/**
 * Checks if the given data contains an ID3 tag.
 *
 * @param data - The data to check
 * @param offset - The offset at which to start checking
 *
 * @returns `true` if an ID3 tag is found
 *
 * @group ID3
 *
 * @beta
 */
function canParseId3(data, offset) {
  return isId3Header(data, offset) && readId3Size(data, offset + 6) + 10 <= data.length - offset;
}

function toArrayBuffer(view) {
  if (view instanceof ArrayBuffer) {
    return view;
  } else {
    if (view.byteOffset == 0 && view.byteLength == view.buffer.byteLength) {
      // This is a TypedArray over the whole buffer.
      return view.buffer;
    }
    // This is a 'view' on the buffer.  Create a new buffer that only contains
    // the data.  Note that since this isn't an ArrayBuffer, the 'new' call
    // will allocate a new buffer to hold the copy.
    return new Uint8Array(view).buffer;
  }
}

function toUint8(data, offset = 0, length = Infinity) {
  return view(data, offset, length, Uint8Array);
}
function view(data, offset, length, Type) {
  const buffer = unsafeGetArrayBuffer(data);
  let bytesPerElement = 1;
  if ('BYTES_PER_ELEMENT' in Type) {
    bytesPerElement = Type.BYTES_PER_ELEMENT;
  }
  // Absolute end of the |data| view within |buffer|.
  const dataOffset = isArrayBufferView(data) ? data.byteOffset : 0;
  const dataEnd = (dataOffset + data.byteLength) / bytesPerElement;
  // Absolute start of the result within |buffer|.
  const rawStart = (dataOffset + offset) / bytesPerElement;
  const start = Math.floor(Math.max(0, Math.min(rawStart, dataEnd)));
  // Absolute end of the result within |buffer|.
  const end = Math.floor(Math.min(start + Math.max(length, 0), dataEnd));
  return new Type(buffer, start, end - start);
}
function unsafeGetArrayBuffer(view) {
  if (view instanceof ArrayBuffer) {
    return view;
  } else {
    return view.buffer;
  }
}
function isArrayBufferView(obj) {
  return obj && obj.buffer instanceof ArrayBuffer && obj.byteLength !== undefined && obj.byteOffset !== undefined;
}

function decodeId3ImageFrame(frame) {
  const metadataFrame = {
    key: frame.type,
    description: '',
    data: '',
    mimeType: null,
    pictureType: null
  };
  const utf8Encoding = 0x03;
  if (frame.size < 2) {
    return undefined;
  }
  if (frame.data[0] !== utf8Encoding) {
    console.log('Ignore frame with unrecognized character ' + 'encoding');
    return undefined;
  }
  const mimeTypeEndIndex = frame.data.subarray(1).indexOf(0);
  if (mimeTypeEndIndex === -1) {
    return undefined;
  }
  const mimeType = utf8ArrayToStr(toUint8(frame.data, 1, mimeTypeEndIndex));
  const pictureType = frame.data[2 + mimeTypeEndIndex];
  const descriptionEndIndex = frame.data.subarray(3 + mimeTypeEndIndex).indexOf(0);
  if (descriptionEndIndex === -1) {
    return undefined;
  }
  const description = utf8ArrayToStr(toUint8(frame.data, 3 + mimeTypeEndIndex, descriptionEndIndex));
  let data;
  if (mimeType === '-->') {
    data = utf8ArrayToStr(toUint8(frame.data, 4 + mimeTypeEndIndex + descriptionEndIndex));
  } else {
    data = toArrayBuffer(frame.data.subarray(4 + mimeTypeEndIndex + descriptionEndIndex));
  }
  metadataFrame.mimeType = mimeType;
  metadataFrame.pictureType = pictureType;
  metadataFrame.description = description;
  metadataFrame.data = data;
  return metadataFrame;
}

/**
 * Decode an ID3 PRIV frame.
 *
 * @param frame - the ID3 PRIV frame
 *
 * @returns The decoded ID3 PRIV frame
 *
 * @internal
 *
 * @group ID3
 */
function decodeId3PrivFrame(frame) {
  /*
  Format: <text string>\0<binary data>
  */
  if (frame.size < 2) {
    return undefined;
  }
  const owner = utf8ArrayToStr(frame.data, true);
  const privateData = new Uint8Array(frame.data.subarray(owner.length + 1));
  return {
    key: frame.type,
    info: owner,
    data: privateData.buffer
  };
}

/**
 * Decodes an ID3 text frame
 *
 * @param frame - the ID3 text frame
 *
 * @returns The decoded ID3 text frame
 *
 * @internal
 *
 * @group ID3
 */
function decodeId3TextFrame(frame) {
  if (frame.size < 2) {
    return undefined;
  }
  if (frame.type === 'TXXX') {
    /*
    Format:
    [0]   = {Text Encoding}
    [1-?] = {Description}\0{Value}
    */
    let index = 1;
    const description = utf8ArrayToStr(frame.data.subarray(index), true);
    index += description.length + 1;
    const value = utf8ArrayToStr(frame.data.subarray(index));
    return {
      key: frame.type,
      info: description,
      data: value
    };
  }
  /*
  Format:
  [0]   = {Text Encoding}
  [1-?] = {Value}
  */
  const text = utf8ArrayToStr(frame.data.subarray(1));
  return {
    key: frame.type,
    info: '',
    data: text
  };
}

/**
 * Decode a URL frame
 *
 * @param frame - the ID3 URL frame
 *
 * @returns The decoded ID3 URL frame
 *
 * @internal
 *
 * @group ID3
 */
function decodeId3UrlFrame(frame) {
  if (frame.type === 'WXXX') {
    /*
    Format:
    [0]   = {Text Encoding}
    [1-?] = {Description}\0{URL}
    */
    if (frame.size < 2) {
      return undefined;
    }
    let index = 1;
    const description = utf8ArrayToStr(frame.data.subarray(index), true);
    index += description.length + 1;
    const value = utf8ArrayToStr(frame.data.subarray(index));
    return {
      key: frame.type,
      info: description,
      data: value
    };
  }
  /*
  Format:
  [0-?] = {URL}
  */
  const url = utf8ArrayToStr(frame.data);
  return {
    key: frame.type,
    info: '',
    data: url
  };
}

/**
 * Decode an ID3 frame.
 *
 * @param frame - the ID3 frame
 *
 * @returns The decoded ID3 frame
 *
 * @internal
 *
 * @group ID3
 */
function decodeId3Frame(frame) {
  if (frame.type === 'PRIV') {
    return decodeId3PrivFrame(frame);
  } else if (frame.type[0] === 'W') {
    return decodeId3UrlFrame(frame);
  } else if (frame.type === 'APIC') {
    return decodeId3ImageFrame(frame);
  }
  return decodeId3TextFrame(frame);
}

/**
 * Returns the data of an ID3 frame.
 *
 * @param data - The data to read from
 *
 * @returns The data of the ID3 frame
 *
 * @internal
 *
 * @group ID3
 */
function getId3FrameData(data) {
  /*
  Frame ID       $xx xx xx xx (four characters)
  Size           $xx xx xx xx
  Flags          $xx xx
  */
  const type = String.fromCharCode(data[0], data[1], data[2], data[3]);
  const size = readId3Size(data, 4);
  // skip frame id, size, and flags
  const offset = 10;
  return {
    type,
    size,
    data: data.subarray(offset, offset + size)
  };
}

const HEADER_FOOTER_SIZE = 10;
const FRAME_SIZE = 10;
/**
 * Returns an array of ID3 frames found in all the ID3 tags in the id3Data
 *
 * @param id3Data - The ID3 data containing one or more ID3 tags
 *
 * @returns Array of ID3 frame objects
 *
 * @group ID3
 *
 * @beta
 */
function getId3Frames(id3Data) {
  let offset = 0;
  const frames = [];
  while (isId3Header(id3Data, offset)) {
    const size = readId3Size(id3Data, offset + 6);
    if (id3Data[offset + 5] >> 6 & 1) {
      // skip extended header
      offset += HEADER_FOOTER_SIZE;
    }
    // skip past ID3 header
    offset += HEADER_FOOTER_SIZE;
    const end = offset + size;
    // loop through frames in the ID3 tag
    while (offset + FRAME_SIZE < end) {
      const frameData = getId3FrameData(id3Data.subarray(offset));
      const frame = decodeId3Frame(frameData);
      if (frame) {
        frames.push(frame);
      }
      // skip frame header and frame data
      offset += frameData.size + HEADER_FOOTER_SIZE;
    }
    if (isId3Footer(id3Data, offset)) {
      offset += HEADER_FOOTER_SIZE;
    }
  }
  return frames;
}

/**
 * Returns true if the ID3 frame is an Elementary Stream timestamp frame
 *
 * @param frame - the ID3 frame
 *
 * @returns `true` if the ID3 frame is an Elementary Stream timestamp frame
 *
 * @internal
 *
 * @group ID3
 */
function isId3TimestampFrame(frame) {
  return frame && frame.key === 'PRIV' && frame.info === 'com.apple.streaming.transportStreamTimestamp';
}

/**
 * Read a 33 bit timestamp from an ID3 frame.
 *
 * @param timeStampFrame - the ID3 frame
 *
 * @returns The timestamp
 *
 * @internal
 *
 * @group ID3
 */
function readId3Timestamp(timeStampFrame) {
  if (timeStampFrame.data.byteLength === 8) {
    const data = new Uint8Array(timeStampFrame.data);
    // timestamp is 33 bit expressed as a big-endian eight-octet number,
    // with the upper 31 bits set to zero.
    const pts33Bit = data[3] & 0x1;
    let timestamp = (data[4] << 23) + (data[5] << 15) + (data[6] << 7) + data[7];
    timestamp /= 45;
    if (pts33Bit) {
      timestamp += 47721858.84;
    } // 2^32 / 90
    return Math.round(timestamp);
  }
  return undefined;
}

/**
 * Searches for the Elementary Stream timestamp found in the ID3 data chunk
 *
 * @param data - Block of data containing one or more ID3 tags
 *
 * @returns The timestamp
 *
 * @group ID3
 *
 * @beta
 */
function getId3Timestamp(data) {
  const frames = getId3Frames(data);
  for (let i = 0; i < frames.length; i++) {
    const frame = frames[i];
    if (isId3TimestampFrame(frame)) {
      return readId3Timestamp(frame);
    }
  }
  return undefined;
}

let MetadataSchema = /*#__PURE__*/function (MetadataSchema) {
  MetadataSchema["audioId3"] = "org.id3";
  MetadataSchema["dateRange"] = "com.apple.quicktime.HLS";
  MetadataSchema["emsg"] = "https://aomedia.org/emsg/ID3";
  MetadataSchema["misbklv"] = "urn:misb:KLV:bin:1910.1";
  return MetadataSchema;
}({});

function dummyTrack(type = '', inputTimeScale = 90000) {
  return {
    type,
    id: -1,
    pid: -1,
    inputTimeScale,
    sequenceNumber: -1,
    samples: [],
    dropped: 0
  };
}

class BaseAudioDemuxer {
  constructor() {
    this._audioTrack = void 0;
    this._id3Track = void 0;
    this.frameIndex = 0;
    this.cachedData = null;
    this.basePTS = null;
    this.initPTS = null;
    this.lastPTS = null;
  }
  resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
    this._id3Track = {
      type: 'id3',
      id: 3,
      pid: -1,
      inputTimeScale: 90000,
      sequenceNumber: 0,
      samples: [],
      dropped: 0
    };
  }
  resetTimeStamp(deaultTimestamp) {
    this.initPTS = deaultTimestamp;
    this.resetContiguity();
  }
  resetContiguity() {
    this.basePTS = null;
    this.lastPTS = null;
    this.frameIndex = 0;
  }
  canParse(data, offset) {
    return false;
  }
  appendFrame(track, data, offset) {}

  // feed incoming data to the front of the parsing pipeline
  demux(data, timeOffset) {
    if (this.cachedData) {
      data = appendUint8Array(this.cachedData, data);
      this.cachedData = null;
    }
    let id3Data = getId3Data(data, 0);
    let offset = id3Data ? id3Data.length : 0;
    let lastDataIndex;
    const track = this._audioTrack;
    const id3Track = this._id3Track;
    const timestamp = id3Data ? getId3Timestamp(id3Data) : undefined;
    const length = data.length;
    if (this.basePTS === null || this.frameIndex === 0 && isFiniteNumber(timestamp)) {
      this.basePTS = initPTSFn(timestamp, timeOffset, this.initPTS);
      this.lastPTS = this.basePTS;
    }
    if (this.lastPTS === null) {
      this.lastPTS = this.basePTS;
    }

    // more expressive than alternative: id3Data?.length
    if (id3Data && id3Data.length > 0) {
      id3Track.samples.push({
        pts: this.lastPTS,
        dts: this.lastPTS,
        data: id3Data,
        type: MetadataSchema.audioId3,
        duration: Number.POSITIVE_INFINITY
      });
    }
    while (offset < length) {
      if (this.canParse(data, offset)) {
        const frame = this.appendFrame(track, data, offset);
        if (frame) {
          this.frameIndex++;
          this.lastPTS = frame.sample.pts;
          offset += frame.length;
          lastDataIndex = offset;
        } else {
          offset = length;
        }
      } else if (canParseId3(data, offset)) {
        // after a canParse, a call to getId3Data *should* always returns some data
        id3Data = getId3Data(data, offset);
        id3Track.samples.push({
          pts: this.lastPTS,
          dts: this.lastPTS,
          data: id3Data,
          type: MetadataSchema.audioId3,
          duration: Number.POSITIVE_INFINITY
        });
        offset += id3Data.length;
        lastDataIndex = offset;
      } else {
        offset++;
      }
      if (offset === length && lastDataIndex !== length) {
        const partialData = data.slice(lastDataIndex);
        if (this.cachedData) {
          this.cachedData = appendUint8Array(this.cachedData, partialData);
        } else {
          this.cachedData = partialData;
        }
      }
    }
    return {
      audioTrack: track,
      videoTrack: dummyTrack(),
      id3Track,
      textTrack: dummyTrack()
    };
  }
  demuxSampleAes(data, keyData, timeOffset) {
    return Promise.reject(new Error(`[${this}] This demuxer does not support Sample-AES decryption`));
  }
  flush(timeOffset) {
    // Parse cache in case of remaining frames.
    const cachedData = this.cachedData;
    if (cachedData) {
      this.cachedData = null;
      this.demux(cachedData, 0);
    }
    return {
      audioTrack: this._audioTrack,
      videoTrack: dummyTrack(),
      id3Track: this._id3Track,
      textTrack: dummyTrack()
    };
  }
  destroy() {
    this.cachedData = null;
    // @ts-ignore
    this._audioTrack = this._id3Track = undefined;
  }
}

/**
 * Initialize PTS
 * <p>
 *    use timestamp unless it is undefined, NaN or Infinity
 * </p>
 */
const initPTSFn = (timestamp, timeOffset, initPTS) => {
  if (isFiniteNumber(timestamp)) {
    return timestamp * 90;
  }
  const init90kHz = initPTS ? initPTS.baseTime * 90000 / initPTS.timescale : 0;
  return timeOffset * 90000 + init90kHz;
};

/**
 *  MPEG parser helper
 */

let chromeVersion$1 = null;
const BitratesMap = [32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448, 32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 32, 48, 56, 64, 80, 96, 112, 128, 144, 160, 176, 192, 224, 256, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160];
const SamplingRateMap = [44100, 48000, 32000, 22050, 24000, 16000, 11025, 12000, 8000];
const SamplesCoefficients = [
// MPEG 2.5
[0,
// Reserved
72,
// Layer3
144,
// Layer2
12 // Layer1
],
// Reserved
[0,
// Reserved
0,
// Layer3
0,
// Layer2
0 // Layer1
],
// MPEG 2
[0,
// Reserved
72,
// Layer3
144,
// Layer2
12 // Layer1
],
// MPEG 1
[0,
// Reserved
144,
// Layer3
144,
// Layer2
12 // Layer1
]];
const BytesInSlot = [0,
// Reserved
1,
// Layer3
1,
// Layer2
4 // Layer1
];
function appendFrame$1(track, data, offset, pts, frameIndex) {
  // Using http://www.datavoyage.com/mpgscript/mpeghdr.htm as a reference
  if (offset + 24 > data.length) {
    return;
  }
  const header = parseHeader(data, offset);
  if (header && offset + header.frameLength <= data.length) {
    const frameDuration = header.samplesPerFrame * 90000 / header.sampleRate;
    const stamp = pts + frameIndex * frameDuration;
    const sample = {
      unit: data.subarray(offset, offset + header.frameLength),
      pts: stamp,
      dts: stamp
    };
    track.config = [];
    track.channelCount = header.channelCount;
    track.samplerate = header.sampleRate;
    track.samples.push(sample);
    return {
      sample,
      length: header.frameLength,
      missing: 0
    };
  }
}
function parseHeader(data, offset) {
  const mpegVersion = data[offset + 1] >> 3 & 3;
  const mpegLayer = data[offset + 1] >> 1 & 3;
  const bitRateIndex = data[offset + 2] >> 4 & 15;
  const sampleRateIndex = data[offset + 2] >> 2 & 3;
  if (mpegVersion !== 1 && bitRateIndex !== 0 && bitRateIndex !== 15 && sampleRateIndex !== 3) {
    const paddingBit = data[offset + 2] >> 1 & 1;
    const channelMode = data[offset + 3] >> 6;
    const columnInBitrates = mpegVersion === 3 ? 3 - mpegLayer : mpegLayer === 3 ? 3 : 4;
    const bitRate = BitratesMap[columnInBitrates * 14 + bitRateIndex - 1] * 1000;
    const columnInSampleRates = mpegVersion === 3 ? 0 : mpegVersion === 2 ? 1 : 2;
    const sampleRate = SamplingRateMap[columnInSampleRates * 3 + sampleRateIndex];
    const channelCount = channelMode === 3 ? 1 : 2; // If bits of channel mode are `11` then it is a single channel (Mono)
    const sampleCoefficient = SamplesCoefficients[mpegVersion][mpegLayer];
    const bytesInSlot = BytesInSlot[mpegLayer];
    const samplesPerFrame = sampleCoefficient * 8 * bytesInSlot;
    const frameLength = Math.floor(sampleCoefficient * bitRate / sampleRate + paddingBit) * bytesInSlot;
    if (chromeVersion$1 === null) {
      const userAgent = navigator.userAgent || '';
      const result = userAgent.match(/Chrome\/(\d+)/i);
      chromeVersion$1 = result ? parseInt(result[1]) : 0;
    }
    const needChromeFix = !!chromeVersion$1 && chromeVersion$1 <= 87;
    if (needChromeFix && mpegLayer === 2 && bitRate >= 224000 && channelMode === 0) {
      // Work around bug in Chromium by setting channelMode to dual-channel (01) instead of stereo (00)
      data[offset + 3] = data[offset + 3] | 0x80;
    }
    return {
      sampleRate,
      channelCount,
      frameLength,
      samplesPerFrame
    };
  }
}
function isHeaderPattern(data, offset) {
  return data[offset] === 0xff && (data[offset + 1] & 0xe0) === 0xe0 && (data[offset + 1] & 0x06) !== 0x00;
}
function isHeader(data, offset) {
  // Look for MPEG header | 1111 1111 | 111X XYZX | where X can be either 0 or 1 and Y or Z should be 1
  // Layer bits (position 14 and 15) in header should be always different from 0 (Layer I or Layer II or Layer III)
  // More info http://www.mp3-tech.org/programmer/frame_header.html
  return offset + 1 < data.length && isHeaderPattern(data, offset);
}
function canParse(data, offset) {
  const headerSize = 4;
  return isHeaderPattern(data, offset) && headerSize <= data.length - offset;
}
function probe(data, offset) {
  // same as isHeader but we also check that MPEG frame follows last MPEG frame
  // or end of data is reached
  if (offset + 1 < data.length && isHeaderPattern(data, offset)) {
    // MPEG header Length
    const headerLength = 4;
    // MPEG frame Length
    const header = parseHeader(data, offset);
    let frameLength = headerLength;
    if (header != null && header.frameLength) {
      frameLength = header.frameLength;
    }
    const newOffset = offset + frameLength;
    return newOffset === data.length || isHeader(data, newOffset);
  }
  return false;
}

/**
 * AAC demuxer
 */
class AACDemuxer extends BaseAudioDemuxer {
  constructor(observer, config) {
    super();
    this.observer = void 0;
    this.config = void 0;
    this.observer = observer;
    this.config = config;
  }
  resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
    super.resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration);
    this._audioTrack = {
      container: 'audio/adts',
      type: 'audio',
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: 'aac',
      samples: [],
      manifestCodec: audioCodec,
      duration: trackDuration,
      inputTimeScale: 90000,
      dropped: 0
    };
  }

  // Source for probe info - https://wiki.multimedia.cx/index.php?title=ADTS
  static probe(data, logger) {
    if (!data) {
      return false;
    }

    // Check for the ADTS sync word
    // Look for ADTS header | 1111 1111 | 1111 X00X | where X can be either 0 or 1
    // Layer bits (position 14 and 15) in header should be always 0 for ADTS
    // More info https://wiki.multimedia.cx/index.php?title=ADTS
    const id3Data = getId3Data(data, 0);
    let offset = (id3Data == null ? void 0 : id3Data.length) || 0;
    if (probe(data, offset)) {
      return false;
    }
    for (let length = data.length; offset < length; offset++) {
      if (probe$1(data, offset)) {
        logger.log('ADTS sync word found !');
        return true;
      }
    }
    return false;
  }
  canParse(data, offset) {
    return canParse$1(data, offset);
  }
  appendFrame(track, data, offset) {
    initTrackConfig(track, this.observer, data, offset, track.manifestCodec);
    const frame = appendFrame$2(track, data, offset, this.basePTS, this.frameIndex);
    if (frame && frame.missing === 0) {
      return frame;
    }
  }
}

const getAudioBSID = (data, offset) => {
  // check the bsid to confirm ac-3 | ec-3
  let bsid = 0;
  let numBits = 5;
  offset += numBits;
  const temp = new Uint32Array(1); // unsigned 32 bit for temporary storage
  const mask = new Uint32Array(1); // unsigned 32 bit mask value
  const byte = new Uint8Array(1); // unsigned 8 bit for temporary storage
  while (numBits > 0) {
    byte[0] = data[offset];
    // read remaining bits, upto 8 bits at a time
    const bits = Math.min(numBits, 8);
    const shift = 8 - bits;
    mask[0] = 0xff000000 >>> 24 + shift << shift;
    temp[0] = (byte[0] & mask[0]) >> shift;
    bsid = !bsid ? temp[0] : bsid << bits | temp[0];
    offset += 1;
    numBits -= bits;
  }
  return bsid;
};

class AC3Demuxer extends BaseAudioDemuxer {
  constructor(observer) {
    super();
    this.observer = void 0;
    this.observer = observer;
  }
  resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
    super.resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration);
    this._audioTrack = {
      container: 'audio/ac-3',
      type: 'audio',
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: 'ac3',
      samples: [],
      manifestCodec: audioCodec,
      duration: trackDuration,
      inputTimeScale: 90000,
      dropped: 0
    };
  }
  canParse(data, offset) {
    return offset + 64 < data.length;
  }
  appendFrame(track, data, offset) {
    const frameLength = appendFrame(track, data, offset, this.basePTS, this.frameIndex);
    if (frameLength !== -1) {
      const sample = track.samples[track.samples.length - 1];
      return {
        sample,
        length: frameLength,
        missing: 0
      };
    }
  }
  static probe(data) {
    if (!data) {
      return false;
    }
    const id3Data = getId3Data(data, 0);
    if (!id3Data) {
      return false;
    }

    // look for the ac-3 sync bytes
    const offset = id3Data.length;
    if (data[offset] === 0x0b && data[offset + 1] === 0x77 && getId3Timestamp(id3Data) !== undefined &&
    // check the bsid to confirm ac-3
    getAudioBSID(data, offset) < 16) {
      return true;
    }
    return false;
  }
}
function appendFrame(track, data, start, pts, frameIndex) {
  if (start + 8 > data.length) {
    return -1; // not enough bytes left
  }
  if (data[start] !== 0x0b || data[start + 1] !== 0x77) {
    return -1; // invalid magic
  }

  // get sample rate
  const samplingRateCode = data[start + 4] >> 6;
  if (samplingRateCode >= 3) {
    return -1; // invalid sampling rate
  }
  const samplingRateMap = [48000, 44100, 32000];
  const sampleRate = samplingRateMap[samplingRateCode];

  // get frame size
  const frameSizeCode = data[start + 4] & 0x3f;
  const frameSizeMap = [64, 69, 96, 64, 70, 96, 80, 87, 120, 80, 88, 120, 96, 104, 144, 96, 105, 144, 112, 121, 168, 112, 122, 168, 128, 139, 192, 128, 140, 192, 160, 174, 240, 160, 175, 240, 192, 208, 288, 192, 209, 288, 224, 243, 336, 224, 244, 336, 256, 278, 384, 256, 279, 384, 320, 348, 480, 320, 349, 480, 384, 417, 576, 384, 418, 576, 448, 487, 672, 448, 488, 672, 512, 557, 768, 512, 558, 768, 640, 696, 960, 640, 697, 960, 768, 835, 1152, 768, 836, 1152, 896, 975, 1344, 896, 976, 1344, 1024, 1114, 1536, 1024, 1115, 1536, 1152, 1253, 1728, 1152, 1254, 1728, 1280, 1393, 1920, 1280, 1394, 1920];
  const frameLength = frameSizeMap[frameSizeCode * 3 + samplingRateCode] * 2;
  if (start + frameLength > data.length) {
    return -1;
  }

  // get channel count
  const channelMode = data[start + 6] >> 5;
  let skipCount = 0;
  if (channelMode === 2) {
    skipCount += 2;
  } else {
    if (channelMode & 1 && channelMode !== 1) {
      skipCount += 2;
    }
    if (channelMode & 4) {
      skipCount += 2;
    }
  }
  const lfeon = (data[start + 6] << 8 | data[start + 7]) >> 12 - skipCount & 1;
  const channelsMap = [2, 1, 2, 3, 3, 4, 4, 5];
  const channelCount = channelsMap[channelMode] + lfeon;

  // build dac3 box
  const bsid = data[start + 5] >> 3;
  const bsmod = data[start + 5] & 7;
  const config = new Uint8Array([samplingRateCode << 6 | bsid << 1 | bsmod >> 2, (bsmod & 3) << 6 | channelMode << 3 | lfeon << 2 | frameSizeCode >> 4, frameSizeCode << 4 & 0xe0]);
  const frameDuration = 1536 / sampleRate * 90000;
  const stamp = pts + frameIndex * frameDuration;
  const unit = data.subarray(start, start + frameLength);
  track.config = config;
  track.channelCount = channelCount;
  track.samplerate = sampleRate;
  track.samples.push({
    unit,
    pts: stamp
  });
  return frameLength;
}

/**
 * MP3 demuxer
 */
class MP3Demuxer extends BaseAudioDemuxer {
  resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
    super.resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration);
    this._audioTrack = {
      container: 'audio/mpeg',
      type: 'audio',
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: 'mp3',
      samples: [],
      manifestCodec: audioCodec,
      duration: trackDuration,
      inputTimeScale: 90000,
      dropped: 0
    };
  }
  static probe(data) {
    if (!data) {
      return false;
    }

    // check if data contains ID3 timestamp and MPEG sync word
    // Look for MPEG header | 1111 1111 | 111X XYZX | where X can be either 0 or 1 and Y or Z should be 1
    // Layer bits (position 14 and 15) in header should be always different from 0 (Layer I or Layer II or Layer III)
    // More info http://www.mp3-tech.org/programmer/frame_header.html
    const id3Data = getId3Data(data, 0);
    let offset = (id3Data == null ? void 0 : id3Data.length) || 0;

    // Check for ac-3|ec-3 sync bytes and return false if present
    if (id3Data && data[offset] === 0x0b && data[offset + 1] === 0x77 && getId3Timestamp(id3Data) !== undefined &&
    // check the bsid to confirm ac-3 or ec-3 (not mp3)
    getAudioBSID(data, offset) <= 16) {
      return false;
    }
    for (let length = data.length; offset < length; offset++) {
      if (probe(data, offset)) {
        hls_logger.log('MPEG Audio sync word found !');
        return true;
      }
    }
    return false;
  }
  canParse(data, offset) {
    return canParse(data, offset);
  }
  appendFrame(track, data, offset) {
    if (this.basePTS === null) {
      return;
    }
    return appendFrame$1(track, data, offset, this.basePTS, this.frameIndex);
  }
}

const emsgSchemePattern = /\/emsg[-/]ID3/i;
class MP4Demuxer {
  constructor(observer, config) {
    this.remainderData = null;
    this.timeOffset = 0;
    this.config = void 0;
    this.videoTrack = void 0;
    this.audioTrack = void 0;
    this.id3Track = void 0;
    this.txtTrack = void 0;
    this.config = config;
  }
  resetTimeStamp() {}
  resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
    const videoTrack = this.videoTrack = dummyTrack('video', 1);
    const audioTrack = this.audioTrack = dummyTrack('audio', 1);
    const captionTrack = this.txtTrack = dummyTrack('text', 1);
    this.id3Track = dummyTrack('id3', 1);
    this.timeOffset = 0;
    if (!(initSegment != null && initSegment.byteLength)) {
      return;
    }
    const initData = parseInitSegment(initSegment);
    if (initData.video) {
      const {
        id,
        timescale,
        codec,
        supplemental
      } = initData.video;
      videoTrack.id = id;
      videoTrack.timescale = captionTrack.timescale = timescale;
      videoTrack.codec = codec;
      videoTrack.supplemental = supplemental;
    }
    if (initData.audio) {
      const {
        id,
        timescale,
        codec
      } = initData.audio;
      audioTrack.id = id;
      audioTrack.timescale = timescale;
      audioTrack.codec = codec;
    }
    captionTrack.id = RemuxerTrackIdConfig.text;
    videoTrack.sampleDuration = 0;
    videoTrack.duration = audioTrack.duration = trackDuration;
  }
  resetContiguity() {
    this.remainderData = null;
  }
  static probe(data) {
    return hasMoofData(data);
  }
  demux(data, timeOffset) {
    this.timeOffset = timeOffset;
    // Load all data into the avc track. The CMAF remuxer will look for the data in the samples object; the rest of the fields do not matter
    let videoSamples = data;
    const videoTrack = this.videoTrack;
    const textTrack = this.txtTrack;
    if (this.config.progressive) {
      // Split the bytestream into two ranges: one encompassing all data up until the start of the last moof, and everything else.
      // This is done to guarantee that we're sending valid data to MSE - when demuxing progressively, we have no guarantee
      // that the fetch loader gives us flush moof+mdat pairs. If we push jagged data to MSE, it will throw an exception.
      if (this.remainderData) {
        videoSamples = appendUint8Array(this.remainderData, data);
      }
      const segmentedData = segmentValidRange(videoSamples);
      this.remainderData = segmentedData.remainder;
      videoTrack.samples = segmentedData.valid || new Uint8Array();
    } else {
      videoTrack.samples = videoSamples;
    }
    const id3Track = this.extractID3Track(videoTrack, timeOffset);
    textTrack.samples = parseSamples(timeOffset, videoTrack);
    return {
      videoTrack,
      audioTrack: this.audioTrack,
      id3Track,
      textTrack: this.txtTrack
    };
  }
  flush() {
    const timeOffset = this.timeOffset;
    const videoTrack = this.videoTrack;
    const textTrack = this.txtTrack;
    videoTrack.samples = this.remainderData || new Uint8Array();
    this.remainderData = null;
    const id3Track = this.extractID3Track(videoTrack, this.timeOffset);
    textTrack.samples = parseSamples(timeOffset, videoTrack);
    return {
      videoTrack,
      audioTrack: dummyTrack(),
      id3Track,
      textTrack: dummyTrack()
    };
  }
  extractID3Track(videoTrack, timeOffset) {
    const id3Track = this.id3Track;
    if (videoTrack.samples.length) {
      const emsgs = findBox(videoTrack.samples, ['emsg']);
      if (emsgs) {
        emsgs.forEach(data => {
          const emsgInfo = parseEmsg(data);
          if (emsgSchemePattern.test(emsgInfo.schemeIdUri)) {
            const pts = getEmsgStartTime(emsgInfo, timeOffset);
            let duration = emsgInfo.eventDuration === 0xffffffff ? Number.POSITIVE_INFINITY : emsgInfo.eventDuration / emsgInfo.timeScale;
            // Safari takes anything <= 0.001 seconds and maps it to Infinity
            if (duration <= 0.001) {
              duration = Number.POSITIVE_INFINITY;
            }
            const payload = emsgInfo.payload;
            id3Track.samples.push({
              data: payload,
              len: payload.byteLength,
              dts: pts,
              pts: pts,
              type: MetadataSchema.emsg,
              duration: duration
            });
          } else if (this.config.enableEmsgKLVMetadata && emsgInfo.schemeIdUri.startsWith('urn:misb:KLV:bin:1910.1')) {
            const pts = getEmsgStartTime(emsgInfo, timeOffset);
            id3Track.samples.push({
              data: emsgInfo.payload,
              len: emsgInfo.payload.byteLength,
              dts: pts,
              pts: pts,
              type: MetadataSchema.misbklv,
              duration: Number.POSITIVE_INFINITY
            });
          }
        });
      }
    }
    return id3Track;
  }
  demuxSampleAes(data, keyData, timeOffset) {
    return Promise.reject(new Error('The MP4 demuxer does not support SAMPLE-AES decryption'));
  }
  destroy() {
    // @ts-ignore
    this.config = null;
    this.remainderData = null;
    this.videoTrack = this.audioTrack = this.id3Track = this.txtTrack = undefined;
  }
}
function getEmsgStartTime(emsgInfo, timeOffset) {
  return isFiniteNumber(emsgInfo.presentationTime) ? emsgInfo.presentationTime / emsgInfo.timeScale : timeOffset + emsgInfo.presentationTimeDelta / emsgInfo.timeScale;
}

/**
 * SAMPLE-AES decrypter
 */

class SampleAesDecrypter {
  constructor(observer, config, keyData) {
    this.keyData = void 0;
    this.decrypter = void 0;
    this.keyData = keyData;
    this.decrypter = new Decrypter(config, {
      removePKCS7Padding: false
    });
  }
  decryptBuffer(encryptedData) {
    return this.decrypter.decrypt(encryptedData, this.keyData.key.buffer, this.keyData.iv.buffer, DecrypterAesMode.cbc);
  }

  // AAC - encrypt all full 16 bytes blocks starting from offset 16
  decryptAacSample(samples, sampleIndex, callback) {
    const curUnit = samples[sampleIndex].unit;
    if (curUnit.length <= 16) {
      // No encrypted portion in this sample (first 16 bytes is not
      // encrypted, see https://developer.apple.com/library/archive/documentation/AudioVideo/Conceptual/HLS_Sample_Encryption/Encryption/Encryption.html),
      return;
    }
    const encryptedData = curUnit.subarray(16, curUnit.length - curUnit.length % 16);
    const encryptedBuffer = encryptedData.buffer.slice(encryptedData.byteOffset, encryptedData.byteOffset + encryptedData.length);
    this.decryptBuffer(encryptedBuffer).then(decryptedBuffer => {
      const decryptedData = new Uint8Array(decryptedBuffer);
      curUnit.set(decryptedData, 16);
      if (!this.decrypter.isSync()) {
        this.decryptAacSamples(samples, sampleIndex + 1, callback);
      }
    });
  }
  decryptAacSamples(samples, sampleIndex, callback) {
    for (;; sampleIndex++) {
      if (sampleIndex >= samples.length) {
        callback();
        return;
      }
      if (samples[sampleIndex].unit.length < 32) {
        continue;
      }
      this.decryptAacSample(samples, sampleIndex, callback);
      if (!this.decrypter.isSync()) {
        return;
      }
    }
  }

  // AVC - encrypt one 16 bytes block out of ten, starting from offset 32
  getAvcEncryptedData(decodedData) {
    const encryptedDataLen = Math.floor((decodedData.length - 48) / 160) * 16 + 16;
    const encryptedData = new Int8Array(encryptedDataLen);
    let outputPos = 0;
    for (let inputPos = 32; inputPos < decodedData.length - 16; inputPos += 160, outputPos += 16) {
      encryptedData.set(decodedData.subarray(inputPos, inputPos + 16), outputPos);
    }
    return encryptedData;
  }
  getAvcDecryptedUnit(decodedData, decryptedData) {
    const uint8DecryptedData = new Uint8Array(decryptedData);
    let inputPos = 0;
    for (let outputPos = 32; outputPos < decodedData.length - 16; outputPos += 160, inputPos += 16) {
      decodedData.set(uint8DecryptedData.subarray(inputPos, inputPos + 16), outputPos);
    }
    return decodedData;
  }
  decryptAvcSample(samples, sampleIndex, unitIndex, callback, curUnit) {
    const decodedData = discardEPB(curUnit.data);
    const encryptedData = this.getAvcEncryptedData(decodedData);
    this.decryptBuffer(encryptedData.buffer).then(decryptedBuffer => {
      curUnit.data = this.getAvcDecryptedUnit(decodedData, decryptedBuffer);
      if (!this.decrypter.isSync()) {
        this.decryptAvcSamples(samples, sampleIndex, unitIndex + 1, callback);
      }
    });
  }
  decryptAvcSamples(samples, sampleIndex, unitIndex, callback) {
    if (samples instanceof Uint8Array) {
      throw new Error('Cannot decrypt samples of type Uint8Array');
    }
    for (;; sampleIndex++, unitIndex = 0) {
      if (sampleIndex >= samples.length) {
        callback();
        return;
      }
      const curUnits = samples[sampleIndex].units;
      for (;; unitIndex++) {
        if (unitIndex >= curUnits.length) {
          break;
        }
        const curUnit = curUnits[unitIndex];
        if (curUnit.data.length <= 48 || curUnit.type !== 1 && curUnit.type !== 5) {
          continue;
        }
        this.decryptAvcSample(samples, sampleIndex, unitIndex, callback, curUnit);
        if (!this.decrypter.isSync()) {
          return;
        }
      }
    }
  }
}

class BaseVideoParser {
  constructor() {
    this.VideoSample = null;
  }
  createVideoSample(key, pts, dts) {
    return {
      key,
      frame: false,
      pts,
      dts,
      units: [],
      length: 0
    };
  }
  getLastNalUnit(samples) {
    var _VideoSample;
    let VideoSample = this.VideoSample;
    let lastUnit;
    // try to fallback to previous sample if current one is empty
    if (!VideoSample || VideoSample.units.length === 0) {
      VideoSample = samples[samples.length - 1];
    }
    if ((_VideoSample = VideoSample) != null && _VideoSample.units) {
      const units = VideoSample.units;
      lastUnit = units[units.length - 1];
    }
    return lastUnit;
  }
  pushAccessUnit(VideoSample, videoTrack) {
    if (VideoSample.units.length && VideoSample.frame) {
      // if sample does not have PTS/DTS, patch with last sample PTS/DTS
      if (VideoSample.pts === undefined) {
        const samples = videoTrack.samples;
        const nbSamples = samples.length;
        if (nbSamples) {
          const lastSample = samples[nbSamples - 1];
          VideoSample.pts = lastSample.pts;
          VideoSample.dts = lastSample.dts;
        } else {
          // dropping samples, no timestamp found
          videoTrack.dropped++;
          return;
        }
      }
      videoTrack.samples.push(VideoSample);
    }
  }
  parseNALu(track, array, endOfSegment) {
    const len = array.byteLength;
    let state = track.naluState || 0;
    const lastState = state;
    const units = [];
    let i = 0;
    let value;
    let overflow;
    let unitType;
    let lastUnitStart = -1;
    let lastUnitType = 0;
    // logger.log('PES:' + Hex.hexDump(array));

    if (state === -1) {
      // special use case where we found 3 or 4-byte start codes exactly at the end of previous PES packet
      lastUnitStart = 0;
      // NALu type is value read from offset 0
      lastUnitType = this.getNALuType(array, 0);
      state = 0;
      i = 1;
    }
    while (i < len) {
      value = array[i++];
      // optimization. state 0 and 1 are the predominant case. let's handle them outside of the switch/case
      if (!state) {
        state = value ? 0 : 1;
        continue;
      }
      if (state === 1) {
        state = value ? 0 : 2;
        continue;
      }
      // here we have state either equal to 2 or 3
      if (!value) {
        state = 3;
      } else if (value === 1) {
        overflow = i - state - 1;
        if (lastUnitStart >= 0) {
          const unit = {
            data: array.subarray(lastUnitStart, overflow),
            type: lastUnitType
          };
          // logger.log('pushing NALU, type/size:' + unit.type + '/' + unit.data.byteLength);
          units.push(unit);
        } else {
          // lastUnitStart is undefined => this is the first start code found in this PES packet
          // first check if start code delimiter is overlapping between 2 PES packets,
          // ie it started in last packet (lastState not zero)
          // and ended at the beginning of this PES packet (i <= 4 - lastState)
          const lastUnit = this.getLastNalUnit(track.samples);
          if (lastUnit) {
            if (lastState && i <= 4 - lastState) {
              // start delimiter overlapping between PES packets
              // strip start delimiter bytes from the end of last NAL unit
              // check if lastUnit had a state different from zero
              if (lastUnit.state) {
                // strip last bytes
                lastUnit.data = lastUnit.data.subarray(0, lastUnit.data.byteLength - lastState);
              }
            }
            // If NAL units are not starting right at the beginning of the PES packet, push preceding data into previous NAL unit.

            if (overflow > 0) {
              // logger.log('first NALU found with overflow:' + overflow);
              lastUnit.data = appendUint8Array(lastUnit.data, array.subarray(0, overflow));
              lastUnit.state = 0;
            }
          }
        }
        // check if we can read unit type
        if (i < len) {
          unitType = this.getNALuType(array, i);
          // logger.log('find NALU @ offset:' + i + ',type:' + unitType);
          lastUnitStart = i;
          lastUnitType = unitType;
          state = 0;
        } else {
          // not enough byte to read unit type. let's read it on next PES parsing
          state = -1;
        }
      } else {
        state = 0;
      }
    }
    if (lastUnitStart >= 0 && state >= 0) {
      const unit = {
        data: array.subarray(lastUnitStart, len),
        type: lastUnitType,
        state: state
      };
      units.push(unit);
      // logger.log('pushing NALU, type/size/state:' + unit.type + '/' + unit.data.byteLength + '/' + state);
    }
    // no NALu found
    if (units.length === 0) {
      // append pes.data to previous NAL unit
      const lastUnit = this.getLastNalUnit(track.samples);
      if (lastUnit) {
        lastUnit.data = appendUint8Array(lastUnit.data, array);
      }
    }
    track.naluState = state;
    return units;
  }
}

/**
 * Parser for exponential Golomb codes, a variable-bitwidth number encoding scheme used by h264.
 */

class ExpGolomb {
  constructor(data) {
    this.data = void 0;
    this.bytesAvailable = void 0;
    this.word = void 0;
    this.bitsAvailable = void 0;
    this.data = data;
    // the number of bytes left to examine in this.data
    this.bytesAvailable = data.byteLength;
    // the current word being examined
    this.word = 0; // :uint
    // the number of bits left to examine in the current word
    this.bitsAvailable = 0; // :uint
  }

  // ():void
  loadWord() {
    const data = this.data;
    const bytesAvailable = this.bytesAvailable;
    const position = data.byteLength - bytesAvailable;
    const workingBytes = new Uint8Array(4);
    const availableBytes = Math.min(4, bytesAvailable);
    if (availableBytes === 0) {
      throw new Error('no bytes available');
    }
    workingBytes.set(data.subarray(position, position + availableBytes));
    this.word = new DataView(workingBytes.buffer).getUint32(0);
    // track the amount of this.data that has been processed
    this.bitsAvailable = availableBytes * 8;
    this.bytesAvailable -= availableBytes;
  }

  // (count:int):void
  skipBits(count) {
    let skipBytes; // :int
    count = Math.min(count, this.bytesAvailable * 8 + this.bitsAvailable);
    if (this.bitsAvailable > count) {
      this.word <<= count;
      this.bitsAvailable -= count;
    } else {
      count -= this.bitsAvailable;
      skipBytes = count >> 3;
      count -= skipBytes << 3;
      this.bytesAvailable -= skipBytes;
      this.loadWord();
      this.word <<= count;
      this.bitsAvailable -= count;
    }
  }

  // (size:int):uint
  readBits(size) {
    let bits = Math.min(this.bitsAvailable, size); // :uint
    const valu = this.word >>> 32 - bits; // :uint
    if (size > 32) {
      hls_logger.error('Cannot read more than 32 bits at a time');
    }
    this.bitsAvailable -= bits;
    if (this.bitsAvailable > 0) {
      this.word <<= bits;
    } else if (this.bytesAvailable > 0) {
      this.loadWord();
    } else {
      throw new Error('no bits available');
    }
    bits = size - bits;
    if (bits > 0 && this.bitsAvailable) {
      return valu << bits | this.readBits(bits);
    } else {
      return valu;
    }
  }

  // ():uint
  skipLZ() {
    let leadingZeroCount; // :uint
    for (leadingZeroCount = 0; leadingZeroCount < this.bitsAvailable; ++leadingZeroCount) {
      if ((this.word & 0x80000000 >>> leadingZeroCount) !== 0) {
        // the first bit of working word is 1
        this.word <<= leadingZeroCount;
        this.bitsAvailable -= leadingZeroCount;
        return leadingZeroCount;
      }
    }
    // we exhausted word and still have not found a 1
    this.loadWord();
    return leadingZeroCount + this.skipLZ();
  }

  // ():void
  skipUEG() {
    this.skipBits(1 + this.skipLZ());
  }

  // ():void
  skipEG() {
    this.skipBits(1 + this.skipLZ());
  }

  // ():uint
  readUEG() {
    const clz = this.skipLZ(); // :uint
    return this.readBits(clz + 1) - 1;
  }

  // ():int
  readEG() {
    const valu = this.readUEG(); // :int
    if (0x01 & valu) {
      // the number is odd if the low order bit is set
      return 1 + valu >>> 1; // add 1 to make it even, and divide by 2
    } else {
      return -1 * (valu >>> 1); // divide by two then make it negative
    }
  }

  // Some convenience functions
  // :Boolean
  readBoolean() {
    return this.readBits(1) === 1;
  }

  // ():int
  readUByte() {
    return this.readBits(8);
  }

  // ():int
  readUShort() {
    return this.readBits(16);
  }

  // ():int
  readUInt() {
    return this.readBits(32);
  }
}

class AvcVideoParser extends BaseVideoParser {
  parsePES(track, textTrack, pes, endOfSegment) {
    const units = this.parseNALu(track, pes.data, endOfSegment);
    let VideoSample = this.VideoSample;
    let push;
    let spsfound = false;
    // free pes.data to save up some memory
    pes.data = null;

    // if new NAL units found and last sample still there, let's push ...
    // this helps parsing streams with missing AUD (only do this if AUD never found)
    if (VideoSample && units.length && !track.audFound) {
      this.pushAccessUnit(VideoSample, track);
      VideoSample = this.VideoSample = this.createVideoSample(false, pes.pts, pes.dts);
    }
    units.forEach(unit => {
      var _VideoSample2, _VideoSample3;
      switch (unit.type) {
        // NDR
        case 1:
          {
            let iskey = false;
            push = true;
            const data = unit.data;
            // only check slice type to detect KF in case SPS found in same packet (any keyframe is preceded by SPS ...)
            if (spsfound && data.length > 4) {
              // retrieve slice type by parsing beginning of NAL unit (follow H264 spec, slice_header definition) to detect keyframe embedded in NDR
              const sliceType = this.readSliceType(data);
              // 2 : I slice, 4 : SI slice, 7 : I slice, 9: SI slice
              // SI slice : A slice that is coded using intra prediction only and using quantisation of the prediction samples.
              // An SI slice can be coded such that its decoded samples can be constructed identically to an SP slice.
              // I slice: A slice that is not an SI slice that is decoded using intra prediction only.
              // if (sliceType === 2 || sliceType === 7) {
              if (sliceType === 2 || sliceType === 4 || sliceType === 7 || sliceType === 9) {
                iskey = true;
              }
            }
            if (iskey) {
              var _VideoSample;
              // if we have non-keyframe data already, that cannot belong to the same frame as a keyframe, so force a push
              if ((_VideoSample = VideoSample) != null && _VideoSample.frame && !VideoSample.key) {
                this.pushAccessUnit(VideoSample, track);
                VideoSample = this.VideoSample = null;
              }
            }
            if (!VideoSample) {
              VideoSample = this.VideoSample = this.createVideoSample(true, pes.pts, pes.dts);
            }
            VideoSample.frame = true;
            VideoSample.key = iskey;
            break;
            // IDR
          }
        case 5:
          push = true;
          // handle PES not starting with AUD
          // if we have frame data already, that cannot belong to the same frame, so force a push
          if ((_VideoSample2 = VideoSample) != null && _VideoSample2.frame && !VideoSample.key) {
            this.pushAccessUnit(VideoSample, track);
            VideoSample = this.VideoSample = null;
          }
          if (!VideoSample) {
            VideoSample = this.VideoSample = this.createVideoSample(true, pes.pts, pes.dts);
          }
          VideoSample.key = true;
          VideoSample.frame = true;
          break;
        // SEI
        case 6:
          {
            push = true;
            parseSEIMessageFromNALu(unit.data, 1, pes.pts, textTrack.samples);
            break;
            // SPS
          }
        case 7:
          {
            var _track$pixelRatio, _track$pixelRatio2;
            push = true;
            spsfound = true;
            const sps = unit.data;
            const config = this.readSPS(sps);
            if (!track.sps || track.width !== config.width || track.height !== config.height || ((_track$pixelRatio = track.pixelRatio) == null ? void 0 : _track$pixelRatio[0]) !== config.pixelRatio[0] || ((_track$pixelRatio2 = track.pixelRatio) == null ? void 0 : _track$pixelRatio2[1]) !== config.pixelRatio[1]) {
              track.width = config.width;
              track.height = config.height;
              track.pixelRatio = config.pixelRatio;
              track.sps = [sps];
              const codecarray = sps.subarray(1, 4);
              let codecstring = 'avc1.';
              for (let i = 0; i < 3; i++) {
                let h = codecarray[i].toString(16);
                if (h.length < 2) {
                  h = '0' + h;
                }
                codecstring += h;
              }
              track.codec = codecstring;
            }
            break;
          }
        // PPS
        case 8:
          push = true;
          track.pps = [unit.data];
          break;
        // AUD
        case 9:
          push = true;
          track.audFound = true;
          if ((_VideoSample3 = VideoSample) != null && _VideoSample3.frame) {
            this.pushAccessUnit(VideoSample, track);
            VideoSample = null;
          }
          if (!VideoSample) {
            VideoSample = this.VideoSample = this.createVideoSample(false, pes.pts, pes.dts);
          }
          break;
        // Filler Data
        case 12:
          push = true;
          break;
        default:
          push = false;
          break;
      }
      if (VideoSample && push) {
        const units = VideoSample.units;
        units.push(unit);
      }
    });
    // if last PES packet, push samples
    if (endOfSegment && VideoSample) {
      this.pushAccessUnit(VideoSample, track);
      this.VideoSample = null;
    }
  }
  getNALuType(data, offset) {
    return data[offset] & 0x1f;
  }
  readSliceType(data) {
    const eg = new ExpGolomb(data);
    // skip NALu type
    eg.readUByte();
    // discard first_mb_in_slice
    eg.readUEG();
    // return slice_type
    return eg.readUEG();
  }

  /**
   * The scaling list is optionally transmitted as part of a sequence parameter
   * set and is not relevant to transmuxing.
   * @param count the number of entries in this scaling list
   * @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1
   */
  skipScalingList(count, reader) {
    let lastScale = 8;
    let nextScale = 8;
    let deltaScale;
    for (let j = 0; j < count; j++) {
      if (nextScale !== 0) {
        deltaScale = reader.readEG();
        nextScale = (lastScale + deltaScale + 256) % 256;
      }
      lastScale = nextScale === 0 ? lastScale : nextScale;
    }
  }

  /**
   * Read a sequence parameter set and return some interesting video
   * properties. A sequence parameter set is the H264 metadata that
   * describes the properties of upcoming video frames.
   * @returns an object with configuration parsed from the
   * sequence parameter set, including the dimensions of the
   * associated video frames.
   */
  readSPS(sps) {
    const eg = new ExpGolomb(sps);
    let frameCropLeftOffset = 0;
    let frameCropRightOffset = 0;
    let frameCropTopOffset = 0;
    let frameCropBottomOffset = 0;
    let numRefFramesInPicOrderCntCycle;
    let scalingListCount;
    let i;
    const readUByte = eg.readUByte.bind(eg);
    const readBits = eg.readBits.bind(eg);
    const readUEG = eg.readUEG.bind(eg);
    const readBoolean = eg.readBoolean.bind(eg);
    const skipBits = eg.skipBits.bind(eg);
    const skipEG = eg.skipEG.bind(eg);
    const skipUEG = eg.skipUEG.bind(eg);
    const skipScalingList = this.skipScalingList.bind(this);
    readUByte();
    const profileIdc = readUByte(); // profile_idc
    readBits(5); // profileCompat constraint_set[0-4]_flag, u(5)
    skipBits(3); // reserved_zero_3bits u(3),
    readUByte(); // level_idc u(8)
    skipUEG(); // seq_parameter_set_id
    // some profiles have more optional data we don't need
    if (profileIdc === 100 || profileIdc === 110 || profileIdc === 122 || profileIdc === 244 || profileIdc === 44 || profileIdc === 83 || profileIdc === 86 || profileIdc === 118 || profileIdc === 128) {
      const chromaFormatIdc = readUEG();
      if (chromaFormatIdc === 3) {
        skipBits(1);
      } // separate_colour_plane_flag

      skipUEG(); // bit_depth_luma_minus8
      skipUEG(); // bit_depth_chroma_minus8
      skipBits(1); // qpprime_y_zero_transform_bypass_flag
      if (readBoolean()) {
        // seq_scaling_matrix_present_flag
        scalingListCount = chromaFormatIdc !== 3 ? 8 : 12;
        for (i = 0; i < scalingListCount; i++) {
          if (readBoolean()) {
            // seq_scaling_list_present_flag[ i ]
            if (i < 6) {
              skipScalingList(16, eg);
            } else {
              skipScalingList(64, eg);
            }
          }
        }
      }
    }
    skipUEG(); // log2_max_frame_num_minus4
    const picOrderCntType = readUEG();
    if (picOrderCntType === 0) {
      readUEG(); // log2_max_pic_order_cnt_lsb_minus4
    } else if (picOrderCntType === 1) {
      skipBits(1); // delta_pic_order_always_zero_flag
      skipEG(); // offset_for_non_ref_pic
      skipEG(); // offset_for_top_to_bottom_field
      numRefFramesInPicOrderCntCycle = readUEG();
      for (i = 0; i < numRefFramesInPicOrderCntCycle; i++) {
        skipEG();
      } // offset_for_ref_frame[ i ]
    }
    skipUEG(); // max_num_ref_frames
    skipBits(1); // gaps_in_frame_num_value_allowed_flag
    const picWidthInMbsMinus1 = readUEG();
    const picHeightInMapUnitsMinus1 = readUEG();
    const frameMbsOnlyFlag = readBits(1);
    if (frameMbsOnlyFlag === 0) {
      skipBits(1);
    } // mb_adaptive_frame_field_flag

    skipBits(1); // direct_8x8_inference_flag
    if (readBoolean()) {
      // frame_cropping_flag
      frameCropLeftOffset = readUEG();
      frameCropRightOffset = readUEG();
      frameCropTopOffset = readUEG();
      frameCropBottomOffset = readUEG();
    }
    let pixelRatio = [1, 1];
    if (readBoolean()) {
      // vui_parameters_present_flag
      if (readBoolean()) {
        // aspect_ratio_info_present_flag
        const aspectRatioIdc = readUByte();
        switch (aspectRatioIdc) {
          case 1:
            pixelRatio = [1, 1];
            break;
          case 2:
            pixelRatio = [12, 11];
            break;
          case 3:
            pixelRatio = [10, 11];
            break;
          case 4:
            pixelRatio = [16, 11];
            break;
          case 5:
            pixelRatio = [40, 33];
            break;
          case 6:
            pixelRatio = [24, 11];
            break;
          case 7:
            pixelRatio = [20, 11];
            break;
          case 8:
            pixelRatio = [32, 11];
            break;
          case 9:
            pixelRatio = [80, 33];
            break;
          case 10:
            pixelRatio = [18, 11];
            break;
          case 11:
            pixelRatio = [15, 11];
            break;
          case 12:
            pixelRatio = [64, 33];
            break;
          case 13:
            pixelRatio = [160, 99];
            break;
          case 14:
            pixelRatio = [4, 3];
            break;
          case 15:
            pixelRatio = [3, 2];
            break;
          case 16:
            pixelRatio = [2, 1];
            break;
          case 255:
            {
              pixelRatio = [readUByte() << 8 | readUByte(), readUByte() << 8 | readUByte()];
              break;
            }
        }
      }
    }
    return {
      width: Math.ceil((picWidthInMbsMinus1 + 1) * 16 - frameCropLeftOffset * 2 - frameCropRightOffset * 2),
      height: (2 - frameMbsOnlyFlag) * (picHeightInMapUnitsMinus1 + 1) * 16 - (frameMbsOnlyFlag ? 2 : 4) * (frameCropTopOffset + frameCropBottomOffset),
      pixelRatio: pixelRatio
    };
  }
}

class HevcVideoParser extends BaseVideoParser {
  constructor(...args) {
    super(...args);
    this.initVPS = null;
  }
  parsePES(track, textTrack, pes, endOfSegment) {
    const units = this.parseNALu(track, pes.data, endOfSegment);
    let VideoSample = this.VideoSample;
    let push;
    let spsfound = false;
    // free pes.data to save up some memory
    pes.data = null;

    // if new NAL units found and last sample still there, let's push ...
    // this helps parsing streams with missing AUD (only do this if AUD never found)
    if (VideoSample && units.length && !track.audFound) {
      this.pushAccessUnit(VideoSample, track);
      VideoSample = this.VideoSample = this.createVideoSample(false, pes.pts, pes.dts);
    }
    units.forEach(unit => {
      var _VideoSample2, _VideoSample3;
      switch (unit.type) {
        // NON-IDR, NON RANDOM ACCESS SLICE
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
          if (!VideoSample) {
            VideoSample = this.VideoSample = this.createVideoSample(false, pes.pts, pes.dts);
          }
          VideoSample.frame = true;
          push = true;
          break;

        // CRA, BLA (random access picture)
        case 16:
        case 17:
        case 18:
        case 21:
          push = true;
          if (spsfound) {
            var _VideoSample;
            // handle PES not starting with AUD
            // if we have frame data already, that cannot belong to the same frame, so force a push
            if ((_VideoSample = VideoSample) != null && _VideoSample.frame && !VideoSample.key) {
              this.pushAccessUnit(VideoSample, track);
              VideoSample = this.VideoSample = null;
            }
          }
          if (!VideoSample) {
            VideoSample = this.VideoSample = this.createVideoSample(true, pes.pts, pes.dts);
          }
          VideoSample.key = true;
          VideoSample.frame = true;
          break;

        // IDR
        case 19:
        case 20:
          push = true;
          // handle PES not starting with AUD
          // if we have frame data already, that cannot belong to the same frame, so force a push
          if ((_VideoSample2 = VideoSample) != null && _VideoSample2.frame && !VideoSample.key) {
            this.pushAccessUnit(VideoSample, track);
            VideoSample = this.VideoSample = null;
          }
          if (!VideoSample) {
            VideoSample = this.VideoSample = this.createVideoSample(true, pes.pts, pes.dts);
          }
          VideoSample.key = true;
          VideoSample.frame = true;
          break;

        // SEI
        case 39:
          push = true;
          parseSEIMessageFromNALu(unit.data, 2,
          // NALu header size
          pes.pts, textTrack.samples);
          break;

        // VPS
        case 32:
          push = true;
          if (!track.vps) {
            if (typeof track.params !== 'object') {
              track.params = {};
            }
            track.params = _extends(track.params, this.readVPS(unit.data));
            this.initVPS = unit.data;
          }
          track.vps = [unit.data];
          break;

        // SPS
        case 33:
          push = true;
          spsfound = true;
          if (track.vps !== undefined && track.vps[0] !== this.initVPS && track.sps !== undefined && !this.matchSPS(track.sps[0], unit.data)) {
            this.initVPS = track.vps[0];
            track.sps = track.pps = undefined;
          }
          if (!track.sps) {
            const config = this.readSPS(unit.data);
            track.width = config.width;
            track.height = config.height;
            track.pixelRatio = config.pixelRatio;
            track.codec = config.codecString;
            track.sps = [];
            if (typeof track.params !== 'object') {
              track.params = {};
            }
            for (const prop in config.params) {
              track.params[prop] = config.params[prop];
            }
          }
          this.pushParameterSet(track.sps, unit.data, track.vps);
          if (!VideoSample) {
            VideoSample = this.VideoSample = this.createVideoSample(true, pes.pts, pes.dts);
          }
          VideoSample.key = true;
          break;

        // PPS
        case 34:
          push = true;
          if (typeof track.params === 'object') {
            if (!track.pps) {
              track.pps = [];
              const config = this.readPPS(unit.data);
              for (const prop in config) {
                track.params[prop] = config[prop];
              }
            }
            this.pushParameterSet(track.pps, unit.data, track.vps);
          }
          break;

        // ACCESS UNIT DELIMITER
        case 35:
          push = true;
          track.audFound = true;
          if ((_VideoSample3 = VideoSample) != null && _VideoSample3.frame) {
            this.pushAccessUnit(VideoSample, track);
            VideoSample = null;
          }
          if (!VideoSample) {
            VideoSample = this.VideoSample = this.createVideoSample(false, pes.pts, pes.dts);
          }
          break;
        default:
          push = false;
          break;
      }
      if (VideoSample && push) {
        const units = VideoSample.units;
        units.push(unit);
      }
    });
    // if last PES packet, push samples
    if (endOfSegment && VideoSample) {
      this.pushAccessUnit(VideoSample, track);
      this.VideoSample = null;
    }
  }
  pushParameterSet(parameterSets, data, vps) {
    if (vps && vps[0] === this.initVPS || !vps && !parameterSets.length) {
      parameterSets.push(data);
    }
  }
  getNALuType(data, offset) {
    return (data[offset] & 0x7e) >>> 1;
  }
  ebsp2rbsp(arr) {
    const dst = new Uint8Array(arr.byteLength);
    let dstIdx = 0;
    for (let i = 0; i < arr.byteLength; i++) {
      if (i >= 2) {
        // Unescape: Skip 0x03 after 00 00
        if (arr[i] === 0x03 && arr[i - 1] === 0x00 && arr[i - 2] === 0x00) {
          continue;
        }
      }
      dst[dstIdx] = arr[i];
      dstIdx++;
    }
    return new Uint8Array(dst.buffer, 0, dstIdx);
  }
  pushAccessUnit(VideoSample, videoTrack) {
    super.pushAccessUnit(VideoSample, videoTrack);
    if (this.initVPS) {
      this.initVPS = null; // null initVPS to prevent possible track's sps/pps growth until next VPS
    }
  }
  readVPS(vps) {
    const eg = new ExpGolomb(vps);
    // remove header
    eg.readUByte();
    eg.readUByte();
    eg.readBits(4); // video_parameter_set_id
    eg.skipBits(2);
    eg.readBits(6); // max_layers_minus1
    const max_sub_layers_minus1 = eg.readBits(3);
    const temporal_id_nesting_flag = eg.readBoolean();
    // ...vui fps can be here, but empty fps value is not critical for metadata

    return {
      numTemporalLayers: max_sub_layers_minus1 + 1,
      temporalIdNested: temporal_id_nesting_flag
    };
  }
  readSPS(sps) {
    const eg = new ExpGolomb(this.ebsp2rbsp(sps));
    eg.readUByte();
    eg.readUByte();
    eg.readBits(4); //video_parameter_set_id
    const max_sub_layers_minus1 = eg.readBits(3);
    eg.readBoolean(); // temporal_id_nesting_flag

    // profile_tier_level
    const general_profile_space = eg.readBits(2);
    const general_tier_flag = eg.readBoolean();
    const general_profile_idc = eg.readBits(5);
    const general_profile_compatibility_flags_1 = eg.readUByte();
    const general_profile_compatibility_flags_2 = eg.readUByte();
    const general_profile_compatibility_flags_3 = eg.readUByte();
    const general_profile_compatibility_flags_4 = eg.readUByte();
    const general_constraint_indicator_flags_1 = eg.readUByte();
    const general_constraint_indicator_flags_2 = eg.readUByte();
    const general_constraint_indicator_flags_3 = eg.readUByte();
    const general_constraint_indicator_flags_4 = eg.readUByte();
    const general_constraint_indicator_flags_5 = eg.readUByte();
    const general_constraint_indicator_flags_6 = eg.readUByte();
    const general_level_idc = eg.readUByte();
    const sub_layer_profile_present_flags = [];
    const sub_layer_level_present_flags = [];
    for (let i = 0; i < max_sub_layers_minus1; i++) {
      sub_layer_profile_present_flags.push(eg.readBoolean());
      sub_layer_level_present_flags.push(eg.readBoolean());
    }
    if (max_sub_layers_minus1 > 0) {
      for (let i = max_sub_layers_minus1; i < 8; i++) {
        eg.readBits(2);
      }
    }
    for (let i = 0; i < max_sub_layers_minus1; i++) {
      if (sub_layer_profile_present_flags[i]) {
        eg.readUByte(); // sub_layer_profile_space, sub_layer_tier_flag, sub_layer_profile_idc
        eg.readUByte();
        eg.readUByte();
        eg.readUByte();
        eg.readUByte(); // sub_layer_profile_compatibility_flag
        eg.readUByte();
        eg.readUByte();
        eg.readUByte();
        eg.readUByte();
        eg.readUByte();
        eg.readUByte();
      }
      if (sub_layer_level_present_flags[i]) {
        eg.readUByte();
      }
    }
    eg.readUEG(); // seq_parameter_set_id
    const chroma_format_idc = eg.readUEG();
    if (chroma_format_idc == 3) {
      eg.skipBits(1); //separate_colour_plane_flag
    }
    const pic_width_in_luma_samples = eg.readUEG();
    const pic_height_in_luma_samples = eg.readUEG();
    const conformance_window_flag = eg.readBoolean();
    let pic_left_offset = 0,
      pic_right_offset = 0,
      pic_top_offset = 0,
      pic_bottom_offset = 0;
    if (conformance_window_flag) {
      pic_left_offset += eg.readUEG();
      pic_right_offset += eg.readUEG();
      pic_top_offset += eg.readUEG();
      pic_bottom_offset += eg.readUEG();
    }
    const bit_depth_luma_minus8 = eg.readUEG();
    const bit_depth_chroma_minus8 = eg.readUEG();
    const log2_max_pic_order_cnt_lsb_minus4 = eg.readUEG();
    const sub_layer_ordering_info_present_flag = eg.readBoolean();
    for (let i = sub_layer_ordering_info_present_flag ? 0 : max_sub_layers_minus1; i <= max_sub_layers_minus1; i++) {
      eg.skipUEG(); // max_dec_pic_buffering_minus1[i]
      eg.skipUEG(); // max_num_reorder_pics[i]
      eg.skipUEG(); // max_latency_increase_plus1[i]
    }
    eg.skipUEG(); // log2_min_luma_coding_block_size_minus3
    eg.skipUEG(); // log2_diff_max_min_luma_coding_block_size
    eg.skipUEG(); // log2_min_transform_block_size_minus2
    eg.skipUEG(); // log2_diff_max_min_transform_block_size
    eg.skipUEG(); // max_transform_hierarchy_depth_inter
    eg.skipUEG(); // max_transform_hierarchy_depth_intra
    const scaling_list_enabled_flag = eg.readBoolean();
    if (scaling_list_enabled_flag) {
      const sps_scaling_list_data_present_flag = eg.readBoolean();
      if (sps_scaling_list_data_present_flag) {
        for (let sizeId = 0; sizeId < 4; sizeId++) {
          for (let matrixId = 0; matrixId < (sizeId === 3 ? 2 : 6); matrixId++) {
            const scaling_list_pred_mode_flag = eg.readBoolean();
            if (!scaling_list_pred_mode_flag) {
              eg.readUEG(); // scaling_list_pred_matrix_id_delta
            } else {
              const coefNum = Math.min(64, 1 << 4 + (sizeId << 1));
              if (sizeId > 1) {
                eg.readEG();
              }
              for (let i = 0; i < coefNum; i++) {
                eg.readEG();
              }
            }
          }
        }
      }
    }
    eg.readBoolean(); // amp_enabled_flag
    eg.readBoolean(); // sample_adaptive_offset_enabled_flag
    const pcm_enabled_flag = eg.readBoolean();
    if (pcm_enabled_flag) {
      eg.readUByte();
      eg.skipUEG();
      eg.skipUEG();
      eg.readBoolean();
    }
    const num_short_term_ref_pic_sets = eg.readUEG();
    let num_delta_pocs = 0;
    for (let i = 0; i < num_short_term_ref_pic_sets; i++) {
      let inter_ref_pic_set_prediction_flag = false;
      if (i !== 0) {
        inter_ref_pic_set_prediction_flag = eg.readBoolean();
      }
      if (inter_ref_pic_set_prediction_flag) {
        if (i === num_short_term_ref_pic_sets) {
          eg.readUEG();
        }
        eg.readBoolean();
        eg.readUEG();
        let next_num_delta_pocs = 0;
        for (let j = 0; j <= num_delta_pocs; j++) {
          const used_by_curr_pic_flag = eg.readBoolean();
          let use_delta_flag = false;
          if (!used_by_curr_pic_flag) {
            use_delta_flag = eg.readBoolean();
          }
          if (used_by_curr_pic_flag || use_delta_flag) {
            next_num_delta_pocs++;
          }
        }
        num_delta_pocs = next_num_delta_pocs;
      } else {
        const num_negative_pics = eg.readUEG();
        const num_positive_pics = eg.readUEG();
        num_delta_pocs = num_negative_pics + num_positive_pics;
        for (let j = 0; j < num_negative_pics; j++) {
          eg.readUEG();
          eg.readBoolean();
        }
        for (let j = 0; j < num_positive_pics; j++) {
          eg.readUEG();
          eg.readBoolean();
        }
      }
    }
    const long_term_ref_pics_present_flag = eg.readBoolean();
    if (long_term_ref_pics_present_flag) {
      const num_long_term_ref_pics_sps = eg.readUEG();
      for (let i = 0; i < num_long_term_ref_pics_sps; i++) {
        for (let j = 0; j < log2_max_pic_order_cnt_lsb_minus4 + 4; j++) {
          eg.readBits(1);
        }
        eg.readBits(1);
      }
    }
    let min_spatial_segmentation_idc = 0;
    let sar_width = 1,
      sar_height = 1;
    let fps_fixed = true,
      fps_den = 1,
      fps_num = 0;
    eg.readBoolean(); // sps_temporal_mvp_enabled_flag
    eg.readBoolean(); // strong_intra_smoothing_enabled_flag
    let default_display_window_flag = false;
    const vui_parameters_present_flag = eg.readBoolean();
    if (vui_parameters_present_flag) {
      const aspect_ratio_info_present_flag = eg.readBoolean();
      if (aspect_ratio_info_present_flag) {
        const aspect_ratio_idc = eg.readUByte();
        const sar_width_table = [1, 12, 10, 16, 40, 24, 20, 32, 80, 18, 15, 64, 160, 4, 3, 2];
        const sar_height_table = [1, 11, 11, 11, 33, 11, 11, 11, 33, 11, 11, 33, 99, 3, 2, 1];
        if (aspect_ratio_idc > 0 && aspect_ratio_idc < 16) {
          sar_width = sar_width_table[aspect_ratio_idc - 1];
          sar_height = sar_height_table[aspect_ratio_idc - 1];
        } else if (aspect_ratio_idc === 255) {
          sar_width = eg.readBits(16);
          sar_height = eg.readBits(16);
        }
      }
      const overscan_info_present_flag = eg.readBoolean();
      if (overscan_info_present_flag) {
        eg.readBoolean();
      }
      const video_signal_type_present_flag = eg.readBoolean();
      if (video_signal_type_present_flag) {
        eg.readBits(3);
        eg.readBoolean();
        const colour_description_present_flag = eg.readBoolean();
        if (colour_description_present_flag) {
          eg.readUByte();
          eg.readUByte();
          eg.readUByte();
        }
      }
      const chroma_loc_info_present_flag = eg.readBoolean();
      if (chroma_loc_info_present_flag) {
        eg.readUEG();
        eg.readUEG();
      }
      eg.readBoolean(); // neutral_chroma_indication_flag
      eg.readBoolean(); // field_seq_flag
      eg.readBoolean(); // frame_field_info_present_flag
      default_display_window_flag = eg.readBoolean();
      if (default_display_window_flag) {
        pic_left_offset += eg.readUEG();
        pic_right_offset += eg.readUEG();
        pic_top_offset += eg.readUEG();
        pic_bottom_offset += eg.readUEG();
      }
      const vui_timing_info_present_flag = eg.readBoolean();
      if (vui_timing_info_present_flag) {
        fps_den = eg.readBits(32);
        fps_num = eg.readBits(32);
        const vui_poc_proportional_to_timing_flag = eg.readBoolean();
        if (vui_poc_proportional_to_timing_flag) {
          eg.readUEG();
        }
        const vui_hrd_parameters_present_flag = eg.readBoolean();
        if (vui_hrd_parameters_present_flag) {
          //const commonInfPresentFlag = true;
          //if (commonInfPresentFlag) {
          const nal_hrd_parameters_present_flag = eg.readBoolean();
          const vcl_hrd_parameters_present_flag = eg.readBoolean();
          let sub_pic_hrd_params_present_flag = false;
          if (nal_hrd_parameters_present_flag || vcl_hrd_parameters_present_flag) {
            sub_pic_hrd_params_present_flag = eg.readBoolean();
            if (sub_pic_hrd_params_present_flag) {
              eg.readUByte();
              eg.readBits(5);
              eg.readBoolean();
              eg.readBits(5);
            }
            eg.readBits(4); // bit_rate_scale
            eg.readBits(4); // cpb_size_scale
            if (sub_pic_hrd_params_present_flag) {
              eg.readBits(4);
            }
            eg.readBits(5);
            eg.readBits(5);
            eg.readBits(5);
          }
          //}
          for (let i = 0; i <= max_sub_layers_minus1; i++) {
            fps_fixed = eg.readBoolean(); // fixed_pic_rate_general_flag
            const fixed_pic_rate_within_cvs_flag = fps_fixed || eg.readBoolean();
            let low_delay_hrd_flag = false;
            if (fixed_pic_rate_within_cvs_flag) {
              eg.readEG();
            } else {
              low_delay_hrd_flag = eg.readBoolean();
            }
            const cpb_cnt = low_delay_hrd_flag ? 1 : eg.readUEG() + 1;
            if (nal_hrd_parameters_present_flag) {
              for (let j = 0; j < cpb_cnt; j++) {
                eg.readUEG();
                eg.readUEG();
                if (sub_pic_hrd_params_present_flag) {
                  eg.readUEG();
                  eg.readUEG();
                }
                eg.skipBits(1);
              }
            }
            if (vcl_hrd_parameters_present_flag) {
              for (let j = 0; j < cpb_cnt; j++) {
                eg.readUEG();
                eg.readUEG();
                if (sub_pic_hrd_params_present_flag) {
                  eg.readUEG();
                  eg.readUEG();
                }
                eg.skipBits(1);
              }
            }
          }
        }
      }
      const bitstream_restriction_flag = eg.readBoolean();
      if (bitstream_restriction_flag) {
        eg.readBoolean(); // tiles_fixed_structure_flag
        eg.readBoolean(); // motion_vectors_over_pic_boundaries_flag
        eg.readBoolean(); // restricted_ref_pic_lists_flag
        min_spatial_segmentation_idc = eg.readUEG();
      }
    }
    let width = pic_width_in_luma_samples,
      height = pic_height_in_luma_samples;
    if (conformance_window_flag || default_display_window_flag) {
      let chroma_scale_w = 1,
        chroma_scale_h = 1;
      if (chroma_format_idc === 1) {
        // YUV 420
        chroma_scale_w = chroma_scale_h = 2;
      } else if (chroma_format_idc == 2) {
        // YUV 422
        chroma_scale_w = 2;
      }
      width = pic_width_in_luma_samples - chroma_scale_w * pic_right_offset - chroma_scale_w * pic_left_offset;
      height = pic_height_in_luma_samples - chroma_scale_h * pic_bottom_offset - chroma_scale_h * pic_top_offset;
    }
    const profile_space_string = general_profile_space ? ['A', 'B', 'C'][general_profile_space] : '';
    const profile_compatibility_buf = general_profile_compatibility_flags_1 << 24 | general_profile_compatibility_flags_2 << 16 | general_profile_compatibility_flags_3 << 8 | general_profile_compatibility_flags_4;
    let profile_compatibility_rev = 0;
    for (let i = 0; i < 32; i++) {
      profile_compatibility_rev = (profile_compatibility_rev | (profile_compatibility_buf >> i & 1) << 31 - i) >>> 0; // reverse bit position (and cast as UInt32)
    }
    let profile_compatibility_flags_string = profile_compatibility_rev.toString(16);
    if (general_profile_idc === 1 && profile_compatibility_flags_string === '2') {
      profile_compatibility_flags_string = '6';
    }
    const tier_flag_string = general_tier_flag ? 'H' : 'L';
    return {
      codecString: `hvc1.${profile_space_string}${general_profile_idc}.${profile_compatibility_flags_string}.${tier_flag_string}${general_level_idc}.B0`,
      params: {
        general_tier_flag,
        general_profile_idc,
        general_profile_space,
        general_profile_compatibility_flags: [general_profile_compatibility_flags_1, general_profile_compatibility_flags_2, general_profile_compatibility_flags_3, general_profile_compatibility_flags_4],
        general_constraint_indicator_flags: [general_constraint_indicator_flags_1, general_constraint_indicator_flags_2, general_constraint_indicator_flags_3, general_constraint_indicator_flags_4, general_constraint_indicator_flags_5, general_constraint_indicator_flags_6],
        general_level_idc,
        bit_depth: bit_depth_luma_minus8 + 8,
        bit_depth_luma_minus8,
        bit_depth_chroma_minus8,
        min_spatial_segmentation_idc,
        chroma_format_idc: chroma_format_idc,
        frame_rate: {
          fixed: fps_fixed,
          fps: fps_num / fps_den
        }
      },
      width,
      height,
      pixelRatio: [sar_width, sar_height]
    };
  }
  readPPS(pps) {
    const eg = new ExpGolomb(this.ebsp2rbsp(pps));
    eg.readUByte();
    eg.readUByte();
    eg.skipUEG(); // pic_parameter_set_id
    eg.skipUEG(); // seq_parameter_set_id
    eg.skipBits(2); // dependent_slice_segments_enabled_flag, output_flag_present_flag
    eg.skipBits(3); // num_extra_slice_header_bits
    eg.skipBits(2); // sign_data_hiding_enabled_flag, cabac_init_present_flag
    eg.skipUEG();
    eg.skipUEG();
    eg.skipEG(); // init_qp_minus26
    eg.skipBits(2); // constrained_intra_pred_flag, transform_skip_enabled_flag
    const cu_qp_delta_enabled_flag = eg.readBoolean();
    if (cu_qp_delta_enabled_flag) {
      eg.skipUEG();
    }
    eg.skipEG(); // cb_qp_offset
    eg.skipEG(); // cr_qp_offset
    eg.skipBits(4); // pps_slice_chroma_qp_offsets_present_flag, weighted_pred_flag, weighted_bipred_flag, transquant_bypass_enabled_flag
    const tiles_enabled_flag = eg.readBoolean();
    const entropy_coding_sync_enabled_flag = eg.readBoolean();
    let parallelismType = 1; // slice-based parallel decoding
    if (entropy_coding_sync_enabled_flag && tiles_enabled_flag) {
      parallelismType = 0; // mixed-type parallel decoding
    } else if (entropy_coding_sync_enabled_flag) {
      parallelismType = 3; // wavefront-based parallel decoding
    } else if (tiles_enabled_flag) {
      parallelismType = 2; // tile-based parallel decoding
    }
    return {
      parallelismType
    };
  }
  matchSPS(sps1, sps2) {
    // compare without headers and VPS related params
    return String.fromCharCode.apply(null, sps1).substr(3) === String.fromCharCode.apply(null, sps2).substr(3);
  }
}

const PACKET_LENGTH = 188;
class TSDemuxer {
  constructor(observer, config, typeSupported, logger) {
    this.logger = void 0;
    this.observer = void 0;
    this.config = void 0;
    this.typeSupported = void 0;
    this.sampleAes = null;
    this.pmtParsed = false;
    this.audioCodec = void 0;
    this.videoCodec = void 0;
    this._pmtId = -1;
    this._videoTrack = void 0;
    this._audioTrack = void 0;
    this._id3Track = void 0;
    this._txtTrack = void 0;
    this.aacOverFlow = null;
    this.remainderData = null;
    this.videoParser = void 0;
    this.observer = observer;
    this.config = config;
    this.typeSupported = typeSupported;
    this.logger = logger;
    this.videoParser = null;
  }
  static probe(data, logger) {
    const syncOffset = TSDemuxer.syncOffset(data);
    if (syncOffset > 0) {
      logger.warn(`MPEG2-TS detected but first sync word found @ offset ${syncOffset}`);
    }
    return syncOffset !== -1;
  }
  static syncOffset(data) {
    const length = data.length;
    let scanwindow = Math.min(PACKET_LENGTH * 5, length - PACKET_LENGTH) + 1;
    let i = 0;
    while (i < scanwindow) {
      // a TS init segment should contain at least 2 TS packets: PAT and PMT, each starting with 0x47
      let foundPat = false;
      let packetStart = -1;
      let tsPackets = 0;
      for (let j = i; j < length; j += PACKET_LENGTH) {
        if (data[j] === 0x47 && (length - j === PACKET_LENGTH || data[j + PACKET_LENGTH] === 0x47)) {
          tsPackets++;
          if (packetStart === -1) {
            packetStart = j;
            // First sync word found at offset, increase scan length (#5251)
            if (packetStart !== 0) {
              scanwindow = Math.min(packetStart + PACKET_LENGTH * 99, data.length - PACKET_LENGTH) + 1;
            }
          }
          if (!foundPat) {
            foundPat = parsePID(data, j) === 0;
          }
          // Sync word found at 0 with 3 packets, or found at offset least 2 packets up to scanwindow (#5501)
          if (foundPat && tsPackets > 1 && (packetStart === 0 && tsPackets > 2 || j + PACKET_LENGTH > scanwindow)) {
            return packetStart;
          }
        } else if (tsPackets) {
          // Exit if sync word found, but does not contain contiguous packets
          return -1;
        } else {
          break;
        }
      }
      i++;
    }
    return -1;
  }

  /**
   * Creates a track model internal to demuxer used to drive remuxing input
   */
  static createTrack(type, duration) {
    return {
      container: type === 'video' || type === 'audio' ? 'video/mp2t' : undefined,
      type,
      id: RemuxerTrackIdConfig[type],
      pid: -1,
      inputTimeScale: 90000,
      sequenceNumber: 0,
      samples: [],
      dropped: 0,
      duration: type === 'audio' ? duration : undefined
    };
  }

  /**
   * Initializes a new init segment on the demuxer/remuxer interface. Needed for discontinuities/track-switches (or at stream start)
   * Resets all internal track instances of the demuxer.
   */
  resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
    this.pmtParsed = false;
    this._pmtId = -1;
    this._videoTrack = TSDemuxer.createTrack('video');
    this._videoTrack.duration = trackDuration;
    this._audioTrack = TSDemuxer.createTrack('audio', trackDuration);
    this._id3Track = TSDemuxer.createTrack('id3');
    this._txtTrack = TSDemuxer.createTrack('text');
    this._audioTrack.segmentCodec = 'aac';

    // flush any partial content
    this.aacOverFlow = null;
    this.remainderData = null;
    this.audioCodec = audioCodec;
    this.videoCodec = videoCodec;
  }
  resetTimeStamp() {}
  resetContiguity() {
    const {
      _audioTrack,
      _videoTrack,
      _id3Track
    } = this;
    if (_audioTrack) {
      _audioTrack.pesData = null;
    }
    if (_videoTrack) {
      _videoTrack.pesData = null;
    }
    if (_id3Track) {
      _id3Track.pesData = null;
    }
    this.aacOverFlow = null;
    this.remainderData = null;
  }
  demux(data, timeOffset, isSampleAes = false, flush = false) {
    if (!isSampleAes) {
      this.sampleAes = null;
    }
    let pes;
    const videoTrack = this._videoTrack;
    const audioTrack = this._audioTrack;
    const id3Track = this._id3Track;
    const textTrack = this._txtTrack;
    let videoPid = videoTrack.pid;
    let videoData = videoTrack.pesData;
    let audioPid = audioTrack.pid;
    let id3Pid = id3Track.pid;
    let audioData = audioTrack.pesData;
    let id3Data = id3Track.pesData;
    let unknownPID = null;
    let pmtParsed = this.pmtParsed;
    let pmtId = this._pmtId;
    let len = data.length;
    if (this.remainderData) {
      data = appendUint8Array(this.remainderData, data);
      len = data.length;
      this.remainderData = null;
    }
    if (len < PACKET_LENGTH && !flush) {
      this.remainderData = data;
      return {
        audioTrack,
        videoTrack,
        id3Track,
        textTrack
      };
    }
    const syncOffset = Math.max(0, TSDemuxer.syncOffset(data));
    len -= (len - syncOffset) % PACKET_LENGTH;
    if (len < data.byteLength && !flush) {
      this.remainderData = new Uint8Array(data.buffer, len, data.buffer.byteLength - len);
    }

    // loop through TS packets
    let tsPacketErrors = 0;
    for (let start = syncOffset; start < len; start += PACKET_LENGTH) {
      if (data[start] === 0x47) {
        const stt = !!(data[start + 1] & 0x40);
        const pid = parsePID(data, start);
        const atf = (data[start + 3] & 0x30) >> 4;

        // if an adaption field is present, its length is specified by the fifth byte of the TS packet header.
        let offset;
        if (atf > 1) {
          offset = start + 5 + data[start + 4];
          // continue if there is only adaptation field
          if (offset === start + PACKET_LENGTH) {
            continue;
          }
        } else {
          offset = start + 4;
        }
        switch (pid) {
          case videoPid:
            if (stt) {
              if (videoData && (pes = parsePES(videoData, this.logger))) {
                if (this.videoParser === null) {
                  switch (videoTrack.segmentCodec) {
                    case 'avc':
                      this.videoParser = new AvcVideoParser();
                      break;
                    case 'hevc':
                      {
                        this.videoParser = new HevcVideoParser();
                      }
                      break;
                  }
                }
                if (this.videoParser !== null) {
                  this.videoParser.parsePES(videoTrack, textTrack, pes, false);
                }
              }
              videoData = {
                data: [],
                size: 0
              };
            }
            if (videoData) {
              videoData.data.push(data.subarray(offset, start + PACKET_LENGTH));
              videoData.size += start + PACKET_LENGTH - offset;
            }
            break;
          case audioPid:
            if (stt) {
              if (audioData && (pes = parsePES(audioData, this.logger))) {
                switch (audioTrack.segmentCodec) {
                  case 'aac':
                    this.parseAACPES(audioTrack, pes);
                    break;
                  case 'mp3':
                    this.parseMPEGPES(audioTrack, pes);
                    break;
                  case 'ac3':
                    {
                      this.parseAC3PES(audioTrack, pes);
                    }
                    break;
                }
              }
              audioData = {
                data: [],
                size: 0
              };
            }
            if (audioData) {
              audioData.data.push(data.subarray(offset, start + PACKET_LENGTH));
              audioData.size += start + PACKET_LENGTH - offset;
            }
            break;
          case id3Pid:
            if (stt) {
              if (id3Data && (pes = parsePES(id3Data, this.logger))) {
                this.parseID3PES(id3Track, pes);
              }
              id3Data = {
                data: [],
                size: 0
              };
            }
            if (id3Data) {
              id3Data.data.push(data.subarray(offset, start + PACKET_LENGTH));
              id3Data.size += start + PACKET_LENGTH - offset;
            }
            break;
          case 0:
            if (stt) {
              offset += data[offset] + 1;
            }
            pmtId = this._pmtId = parsePAT(data, offset);
            // this.logger.log('PMT PID:'  + this._pmtId);
            break;
          case pmtId:
            {
              if (stt) {
                offset += data[offset] + 1;
              }
              const parsedPIDs = parsePMT(data, offset, this.typeSupported, isSampleAes, this.observer, this.logger);

              // only update track id if track PID found while parsing PMT
              // this is to avoid resetting the PID to -1 in case
              // track PID transiently disappears from the stream
              // this could happen in case of transient missing audio samples for example
              // NOTE this is only the PID of the track as found in TS,
              // but we are not using this for MP4 track IDs.
              videoPid = parsedPIDs.videoPid;
              if (videoPid > 0) {
                videoTrack.pid = videoPid;
                videoTrack.segmentCodec = parsedPIDs.segmentVideoCodec;
              }
              audioPid = parsedPIDs.audioPid;
              if (audioPid > 0) {
                audioTrack.pid = audioPid;
                audioTrack.segmentCodec = parsedPIDs.segmentAudioCodec;
              }
              id3Pid = parsedPIDs.id3Pid;
              if (id3Pid > 0) {
                id3Track.pid = id3Pid;
              }
              if (unknownPID !== null && !pmtParsed) {
                this.logger.warn(`MPEG-TS PMT found at ${start} after unknown PID '${unknownPID}'. Backtracking to sync byte @${syncOffset} to parse all TS packets.`);
                unknownPID = null;
                // we set it to -188, the += 188 in the for loop will reset start to 0
                start = syncOffset - 188;
              }
              pmtParsed = this.pmtParsed = true;
              break;
            }
          case 0x11:
          case 0x1fff:
            break;
          default:
            unknownPID = pid;
            break;
        }
      } else {
        tsPacketErrors++;
      }
    }
    if (tsPacketErrors > 0) {
      emitParsingError(this.observer, new Error(`Found ${tsPacketErrors} TS packet/s that do not start with 0x47`), undefined, this.logger);
    }
    videoTrack.pesData = videoData;
    audioTrack.pesData = audioData;
    id3Track.pesData = id3Data;
    const demuxResult = {
      audioTrack,
      videoTrack,
      id3Track,
      textTrack
    };
    if (flush) {
      this.extractRemainingSamples(demuxResult);
    }
    return demuxResult;
  }
  flush() {
    const {
      remainderData
    } = this;
    this.remainderData = null;
    let result;
    if (remainderData) {
      result = this.demux(remainderData, -1, false, true);
    } else {
      result = {
        videoTrack: this._videoTrack,
        audioTrack: this._audioTrack,
        id3Track: this._id3Track,
        textTrack: this._txtTrack
      };
    }
    this.extractRemainingSamples(result);
    if (this.sampleAes) {
      return this.decrypt(result, this.sampleAes);
    }
    return result;
  }
  extractRemainingSamples(demuxResult) {
    const {
      audioTrack,
      videoTrack,
      id3Track,
      textTrack
    } = demuxResult;
    const videoData = videoTrack.pesData;
    const audioData = audioTrack.pesData;
    const id3Data = id3Track.pesData;
    // try to parse last PES packets
    let pes;
    if (videoData && (pes = parsePES(videoData, this.logger))) {
      if (this.videoParser === null) {
        switch (videoTrack.segmentCodec) {
          case 'avc':
            this.videoParser = new AvcVideoParser();
            break;
          case 'hevc':
            {
              this.videoParser = new HevcVideoParser();
            }
            break;
        }
      }
      if (this.videoParser !== null) {
        this.videoParser.parsePES(videoTrack, textTrack, pes, true);
        videoTrack.pesData = null;
      }
    } else {
      // either avcData null or PES truncated, keep it for next frag parsing
      videoTrack.pesData = videoData;
    }
    if (audioData && (pes = parsePES(audioData, this.logger))) {
      switch (audioTrack.segmentCodec) {
        case 'aac':
          this.parseAACPES(audioTrack, pes);
          break;
        case 'mp3':
          this.parseMPEGPES(audioTrack, pes);
          break;
        case 'ac3':
          {
            this.parseAC3PES(audioTrack, pes);
          }
          break;
      }
      audioTrack.pesData = null;
    } else {
      if (audioData != null && audioData.size) {
        this.logger.log('last AAC PES packet truncated,might overlap between fragments');
      }

      // either audioData null or PES truncated, keep it for next frag parsing
      audioTrack.pesData = audioData;
    }
    if (id3Data && (pes = parsePES(id3Data, this.logger))) {
      this.parseID3PES(id3Track, pes);
      id3Track.pesData = null;
    } else {
      // either id3Data null or PES truncated, keep it for next frag parsing
      id3Track.pesData = id3Data;
    }
  }
  demuxSampleAes(data, keyData, timeOffset) {
    const demuxResult = this.demux(data, timeOffset, true, !this.config.progressive);
    const sampleAes = this.sampleAes = new SampleAesDecrypter(this.observer, this.config, keyData);
    return this.decrypt(demuxResult, sampleAes);
  }
  decrypt(demuxResult, sampleAes) {
    return new Promise(resolve => {
      const {
        audioTrack,
        videoTrack
      } = demuxResult;
      if (audioTrack.samples && audioTrack.segmentCodec === 'aac') {
        sampleAes.decryptAacSamples(audioTrack.samples, 0, () => {
          if (videoTrack.samples) {
            sampleAes.decryptAvcSamples(videoTrack.samples, 0, 0, () => {
              resolve(demuxResult);
            });
          } else {
            resolve(demuxResult);
          }
        });
      } else if (videoTrack.samples) {
        sampleAes.decryptAvcSamples(videoTrack.samples, 0, 0, () => {
          resolve(demuxResult);
        });
      }
    });
  }
  destroy() {
    if (this.observer) {
      this.observer.removeAllListeners();
    }
    // @ts-ignore
    this.config = this.logger = this.observer = null;
    this.aacOverFlow = this.videoParser = this.remainderData = this.sampleAes = null;
    this._videoTrack = this._audioTrack = this._id3Track = this._txtTrack = undefined;
  }
  parseAACPES(track, pes) {
    let startOffset = 0;
    const aacOverFlow = this.aacOverFlow;
    let data = pes.data;
    if (aacOverFlow) {
      this.aacOverFlow = null;
      const frameMissingBytes = aacOverFlow.missing;
      const sampleLength = aacOverFlow.sample.unit.byteLength;
      // logger.log(`AAC: append overflowing ${sampleLength} bytes to beginning of new PES`);
      if (frameMissingBytes === -1) {
        data = appendUint8Array(aacOverFlow.sample.unit, data);
      } else {
        const frameOverflowBytes = sampleLength - frameMissingBytes;
        aacOverFlow.sample.unit.set(data.subarray(0, frameMissingBytes), frameOverflowBytes);
        track.samples.push(aacOverFlow.sample);
        startOffset = aacOverFlow.missing;
      }
    }
    // look for ADTS header (0xFFFx)
    let offset;
    let len;
    for (offset = startOffset, len = data.length; offset < len - 1; offset++) {
      if (isHeader$1(data, offset)) {
        break;
      }
    }
    // if ADTS header does not start straight from the beginning of the PES payload, raise an error
    if (offset !== startOffset) {
      let reason;
      const recoverable = offset < len - 1;
      if (recoverable) {
        reason = `AAC PES did not start with ADTS header,offset:${offset}`;
      } else {
        reason = 'No ADTS header found in AAC PES';
      }
      emitParsingError(this.observer, new Error(reason), recoverable, this.logger);
      if (!recoverable) {
        return;
      }
    }
    initTrackConfig(track, this.observer, data, offset, this.audioCodec);
    let pts;
    if (pes.pts !== undefined) {
      pts = pes.pts;
    } else if (aacOverFlow) {
      // if last AAC frame is overflowing, we should ensure timestamps are contiguous:
      // first sample PTS should be equal to last sample PTS + frameDuration
      const frameDuration = getFrameDuration(track.samplerate);
      pts = aacOverFlow.sample.pts + frameDuration;
    } else {
      this.logger.warn('[tsdemuxer]: AAC PES unknown PTS');
      return;
    }

    // scan for aac samples
    let frameIndex = 0;
    let frame;
    while (offset < len) {
      frame = appendFrame$2(track, data, offset, pts, frameIndex);
      offset += frame.length;
      if (!frame.missing) {
        frameIndex++;
        for (; offset < len - 1; offset++) {
          if (isHeader$1(data, offset)) {
            break;
          }
        }
      } else {
        this.aacOverFlow = frame;
        break;
      }
    }
  }
  parseMPEGPES(track, pes) {
    const data = pes.data;
    const length = data.length;
    let frameIndex = 0;
    let offset = 0;
    const pts = pes.pts;
    if (pts === undefined) {
      this.logger.warn('[tsdemuxer]: MPEG PES unknown PTS');
      return;
    }
    while (offset < length) {
      if (isHeader(data, offset)) {
        const frame = appendFrame$1(track, data, offset, pts, frameIndex);
        if (frame) {
          offset += frame.length;
          frameIndex++;
        } else {
          // logger.log('Unable to parse Mpeg audio frame');
          break;
        }
      } else {
        // nothing found, keep looking
        offset++;
      }
    }
  }
  parseAC3PES(track, pes) {
    {
      const data = pes.data;
      const pts = pes.pts;
      if (pts === undefined) {
        this.logger.warn('[tsdemuxer]: AC3 PES unknown PTS');
        return;
      }
      const length = data.length;
      let frameIndex = 0;
      let offset = 0;
      let parsed;
      while (offset < length && (parsed = appendFrame(track, data, offset, pts, frameIndex++)) > 0) {
        offset += parsed;
      }
    }
  }
  parseID3PES(id3Track, pes) {
    if (pes.pts === undefined) {
      this.logger.warn('[tsdemuxer]: ID3 PES unknown PTS');
      return;
    }
    const id3Sample = _extends({}, pes, {
      type: this._videoTrack ? MetadataSchema.emsg : MetadataSchema.audioId3,
      duration: Number.POSITIVE_INFINITY
    });
    id3Track.samples.push(id3Sample);
  }
}
function parsePID(data, offset) {
  // pid is a 13-bit field starting at the last bit of TS[1]
  return ((data[offset + 1] & 0x1f) << 8) + data[offset + 2];
}
function parsePAT(data, offset) {
  // skip the PSI header and parse the first PMT entry
  return (data[offset + 10] & 0x1f) << 8 | data[offset + 11];
}
function parsePMT(data, offset, typeSupported, isSampleAes, observer, logger) {
  const result = {
    audioPid: -1,
    videoPid: -1,
    id3Pid: -1,
    segmentVideoCodec: 'avc',
    segmentAudioCodec: 'aac'
  };
  const sectionLength = (data[offset + 1] & 0x0f) << 8 | data[offset + 2];
  const tableEnd = offset + 3 + sectionLength - 4;
  // to determine where the table is, we have to figure out how
  // long the program info descriptors are
  const programInfoLength = (data[offset + 10] & 0x0f) << 8 | data[offset + 11];
  // advance the offset to the first entry in the mapping table
  offset += 12 + programInfoLength;
  while (offset < tableEnd) {
    const pid = parsePID(data, offset);
    const esInfoLength = (data[offset + 3] & 0x0f) << 8 | data[offset + 4];
    switch (data[offset]) {
      case 0xcf:
        // SAMPLE-AES AAC
        if (!isSampleAes) {
          logEncryptedSamplesFoundInUnencryptedStream('ADTS AAC', logger);
          break;
        }
      /* falls through */
      case 0x0f:
        // ISO/IEC 13818-7 ADTS AAC (MPEG-2 lower bit-rate audio)
        // logger.log('AAC PID:'  + pid);
        if (result.audioPid === -1) {
          result.audioPid = pid;
        }
        break;

      // Packetized metadata (ID3)
      case 0x15:
        // logger.log('ID3 PID:'  + pid);
        if (result.id3Pid === -1) {
          result.id3Pid = pid;
        }
        break;
      case 0xdb:
        // SAMPLE-AES AVC
        if (!isSampleAes) {
          logEncryptedSamplesFoundInUnencryptedStream('H.264', logger);
          break;
        }
      /* falls through */
      case 0x1b:
        // ITU-T Rec. H.264 and ISO/IEC 14496-10 (lower bit-rate video)
        // logger.log('AVC PID:'  + pid);
        if (result.videoPid === -1) {
          result.videoPid = pid;
        }
        break;

      // ISO/IEC 11172-3 (MPEG-1 audio)
      // or ISO/IEC 13818-3 (MPEG-2 halved sample rate audio)
      case 0x03:
      case 0x04:
        // logger.log('MPEG PID:'  + pid);
        if (!typeSupported.mpeg && !typeSupported.mp3) {
          logger.log('MPEG audio found, not supported in this browser');
        } else if (result.audioPid === -1) {
          result.audioPid = pid;
          result.segmentAudioCodec = 'mp3';
        }
        break;
      case 0xc1:
        // SAMPLE-AES AC3
        if (!isSampleAes) {
          logEncryptedSamplesFoundInUnencryptedStream('AC-3', logger);
          break;
        }
      /* falls through */
      case 0x81:
        {
          if (!typeSupported.ac3) {
            logger.log('AC-3 audio found, not supported in this browser');
          } else if (result.audioPid === -1) {
            result.audioPid = pid;
            result.segmentAudioCodec = 'ac3';
          }
        }
        break;
      case 0x06:
        // stream_type 6 can mean a lot of different things in case of DVB.
        // We need to look at the descriptors. Right now, we're only interested
        // in AC-3 audio, so we do the descriptor parsing only when we don't have
        // an audio PID yet.
        if (result.audioPid === -1 && esInfoLength > 0) {
          let parsePos = offset + 5;
          let remaining = esInfoLength;
          while (remaining > 2) {
            const descriptorId = data[parsePos];
            switch (descriptorId) {
              case 0x6a:
                // DVB Descriptor for AC-3
                {
                  if (typeSupported.ac3 !== true) {
                    logger.log('AC-3 audio found, not supported in this browser for now');
                  } else {
                    result.audioPid = pid;
                    result.segmentAudioCodec = 'ac3';
                  }
                }
                break;
            }
            const descriptorLen = data[parsePos + 1] + 2;
            parsePos += descriptorLen;
            remaining -= descriptorLen;
          }
        }
        break;
      case 0xc2: // SAMPLE-AES EC3
      /* falls through */
      case 0x87:
        emitParsingError(observer, new Error('Unsupported EC-3 in M2TS found'), undefined, logger);
        return result;
      case 0x24:
        // ITU-T Rec. H.265 and ISO/IEC 23008-2 (HEVC)
        {
          if (result.videoPid === -1) {
            result.videoPid = pid;
            result.segmentVideoCodec = 'hevc';
            logger.log('HEVC in M2TS found');
          }
        }
        break;
    }
    // move to the next table entry
    // skip past the elementary stream descriptors, if present
    offset += esInfoLength + 5;
  }
  return result;
}
function emitParsingError(observer, error, levelRetry, logger) {
  logger.warn(`parsing error: ${error.message}`);
  observer.emit(Events.ERROR, Events.ERROR, {
    type: ErrorTypes.MEDIA_ERROR,
    details: ErrorDetails.FRAG_PARSING_ERROR,
    fatal: false,
    levelRetry,
    error,
    reason: error.message
  });
}
function logEncryptedSamplesFoundInUnencryptedStream(type, logger) {
  logger.log(`${type} with AES-128-CBC encryption found in unencrypted stream`);
}
function parsePES(stream, logger) {
  let i = 0;
  let frag;
  let pesLen;
  let pesHdrLen;
  let pesPts;
  let pesDts;
  const data = stream.data;
  // safety check
  if (!stream || stream.size === 0) {
    return null;
  }

  // we might need up to 19 bytes to read PES header
  // if first chunk of data is less than 19 bytes, let's merge it with following ones until we get 19 bytes
  // usually only one merge is needed (and this is rare ...)
  while (data[0].length < 19 && data.length > 1) {
    data[0] = appendUint8Array(data[0], data[1]);
    data.splice(1, 1);
  }
  // retrieve PTS/DTS from first fragment
  frag = data[0];
  const pesPrefix = (frag[0] << 16) + (frag[1] << 8) + frag[2];
  if (pesPrefix === 1) {
    pesLen = (frag[4] << 8) + frag[5];
    // if PES parsed length is not zero and greater than total received length, stop parsing. PES might be truncated
    // minus 6 : PES header size
    if (pesLen && pesLen > stream.size - 6) {
      return null;
    }
    const pesFlags = frag[7];
    if (pesFlags & 0xc0) {
      /* PES header described here : http://dvd.sourceforge.net/dvdinfo/pes-hdr.html
          as PTS / DTS is 33 bit we cannot use bitwise operator in JS,
          as Bitwise operators treat their operands as a sequence of 32 bits */
      pesPts = (frag[9] & 0x0e) * 536870912 +
      // 1 << 29
      (frag[10] & 0xff) * 4194304 +
      // 1 << 22
      (frag[11] & 0xfe) * 16384 +
      // 1 << 14
      (frag[12] & 0xff) * 128 +
      // 1 << 7
      (frag[13] & 0xfe) / 2;
      if (pesFlags & 0x40) {
        pesDts = (frag[14] & 0x0e) * 536870912 +
        // 1 << 29
        (frag[15] & 0xff) * 4194304 +
        // 1 << 22
        (frag[16] & 0xfe) * 16384 +
        // 1 << 14
        (frag[17] & 0xff) * 128 +
        // 1 << 7
        (frag[18] & 0xfe) / 2;
        if (pesPts - pesDts > 60 * 90000) {
          logger.warn(`${Math.round((pesPts - pesDts) / 90000)}s delta between PTS and DTS, align them`);
          pesPts = pesDts;
        }
      } else {
        pesDts = pesPts;
      }
    }
    pesHdrLen = frag[8];
    // 9 bytes : 6 bytes for PES header + 3 bytes for PES extension
    let payloadStartOffset = pesHdrLen + 9;
    if (stream.size <= payloadStartOffset) {
      return null;
    }
    stream.size -= payloadStartOffset;
    // reassemble PES packet
    const pesData = new Uint8Array(stream.size);
    for (let j = 0, dataLen = data.length; j < dataLen; j++) {
      frag = data[j];
      let len = frag.byteLength;
      if (payloadStartOffset) {
        if (payloadStartOffset > len) {
          // trim full frag if PES header bigger than frag
          payloadStartOffset -= len;
          continue;
        } else {
          // trim partial frag if PES header smaller than frag
          frag = frag.subarray(payloadStartOffset);
          len -= payloadStartOffset;
          payloadStartOffset = 0;
        }
      }
      pesData.set(frag, i);
      i += len;
    }
    if (pesLen) {
      // payload size : remove PES header + PES extension
      pesLen -= pesHdrLen + 3;
    }
    return {
      data: pesData,
      pts: pesPts,
      dts: pesDts,
      len: pesLen
    };
  }
  return null;
}

/**
 *  AAC helper
 */

class AAC {
  static getSilentFrame(codec, channelCount) {
    switch (codec) {
      case 'mp4a.40.2':
        if (channelCount === 1) {
          return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x23, 0x80]);
        } else if (channelCount === 2) {
          return new Uint8Array([0x21, 0x00, 0x49, 0x90, 0x02, 0x19, 0x00, 0x23, 0x80]);
        } else if (channelCount === 3) {
          return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x8e]);
        } else if (channelCount === 4) {
          return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x80, 0x2c, 0x80, 0x08, 0x02, 0x38]);
        } else if (channelCount === 5) {
          return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x82, 0x30, 0x04, 0x99, 0x00, 0x21, 0x90, 0x02, 0x38]);
        } else if (channelCount === 6) {
          return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x82, 0x30, 0x04, 0x99, 0x00, 0x21, 0x90, 0x02, 0x00, 0xb2, 0x00, 0x20, 0x08, 0xe0]);
        }
        break;
      // handle HE-AAC below (mp4a.40.5 / mp4a.40.29)
      default:
        if (channelCount === 1) {
          // ffmpeg -y -f lavfi -i "aevalsrc=0:d=0.05" -c:a libfdk_aac -profile:a aac_he -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
          return new Uint8Array([0x1, 0x40, 0x22, 0x80, 0xa3, 0x4e, 0xe6, 0x80, 0xba, 0x8, 0x0, 0x0, 0x0, 0x1c, 0x6, 0xf1, 0xc1, 0xa, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5e]);
        } else if (channelCount === 2) {
          // ffmpeg -y -f lavfi -i "aevalsrc=0|0:d=0.05" -c:a libfdk_aac -profile:a aac_he_v2 -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
          return new Uint8Array([0x1, 0x40, 0x22, 0x80, 0xa3, 0x5e, 0xe6, 0x80, 0xba, 0x8, 0x0, 0x0, 0x0, 0x0, 0x95, 0x0, 0x6, 0xf1, 0xa1, 0xa, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5e]);
        } else if (channelCount === 3) {
          // ffmpeg -y -f lavfi -i "aevalsrc=0|0|0:d=0.05" -c:a libfdk_aac -profile:a aac_he_v2 -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
          return new Uint8Array([0x1, 0x40, 0x22, 0x80, 0xa3, 0x5e, 0xe6, 0x80, 0xba, 0x8, 0x0, 0x0, 0x0, 0x0, 0x95, 0x0, 0x6, 0xf1, 0xa1, 0xa, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5e]);
        }
        break;
    }
    return undefined;
  }
}

/**
 * Generate MP4 Box
 */

const UINT32_MAX = Math.pow(2, 32) - 1;
class MP4 {
  static init() {
    MP4.types = {
      avc1: [],
      // codingname
      avcC: [],
      hvc1: [],
      hvcC: [],
      btrt: [],
      dinf: [],
      dref: [],
      esds: [],
      ftyp: [],
      hdlr: [],
      mdat: [],
      mdhd: [],
      mdia: [],
      mfhd: [],
      minf: [],
      moof: [],
      moov: [],
      mp4a: [],
      '.mp3': [],
      dac3: [],
      'ac-3': [],
      mvex: [],
      mvhd: [],
      pasp: [],
      sdtp: [],
      stbl: [],
      stco: [],
      stsc: [],
      stsd: [],
      stsz: [],
      stts: [],
      tfdt: [],
      tfhd: [],
      traf: [],
      trak: [],
      trun: [],
      trex: [],
      tkhd: [],
      vmhd: [],
      smhd: []
    };
    let i;
    for (i in MP4.types) {
      if (MP4.types.hasOwnProperty(i)) {
        MP4.types[i] = [i.charCodeAt(0), i.charCodeAt(1), i.charCodeAt(2), i.charCodeAt(3)];
      }
    }
    const videoHdlr = new Uint8Array([0x00,
    // version 0
    0x00, 0x00, 0x00,
    // flags
    0x00, 0x00, 0x00, 0x00,
    // pre_defined
    0x76, 0x69, 0x64, 0x65,
    // handler_type: 'vide'
    0x00, 0x00, 0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00, 0x00,
    // reserved
    0x56, 0x69, 0x64, 0x65, 0x6f, 0x48, 0x61, 0x6e, 0x64, 0x6c, 0x65, 0x72, 0x00 // name: 'VideoHandler'
    ]);
    const audioHdlr = new Uint8Array([0x00,
    // version 0
    0x00, 0x00, 0x00,
    // flags
    0x00, 0x00, 0x00, 0x00,
    // pre_defined
    0x73, 0x6f, 0x75, 0x6e,
    // handler_type: 'soun'
    0x00, 0x00, 0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00, 0x00,
    // reserved
    0x53, 0x6f, 0x75, 0x6e, 0x64, 0x48, 0x61, 0x6e, 0x64, 0x6c, 0x65, 0x72, 0x00 // name: 'SoundHandler'
    ]);
    MP4.HDLR_TYPES = {
      video: videoHdlr,
      audio: audioHdlr
    };
    const dref = new Uint8Array([0x00,
    // version 0
    0x00, 0x00, 0x00,
    // flags
    0x00, 0x00, 0x00, 0x01,
    // entry_count
    0x00, 0x00, 0x00, 0x0c,
    // entry_size
    0x75, 0x72, 0x6c, 0x20,
    // 'url' type
    0x00,
    // version 0
    0x00, 0x00, 0x01 // entry_flags
    ]);
    const stco = new Uint8Array([0x00,
    // version
    0x00, 0x00, 0x00,
    // flags
    0x00, 0x00, 0x00, 0x00 // entry_count
    ]);
    MP4.STTS = MP4.STSC = MP4.STCO = stco;
    MP4.STSZ = new Uint8Array([0x00,
    // version
    0x00, 0x00, 0x00,
    // flags
    0x00, 0x00, 0x00, 0x00,
    // sample_size
    0x00, 0x00, 0x00, 0x00 // sample_count
    ]);
    MP4.VMHD = new Uint8Array([0x00,
    // version
    0x00, 0x00, 0x01,
    // flags
    0x00, 0x00,
    // graphicsmode
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00 // opcolor
    ]);
    MP4.SMHD = new Uint8Array([0x00,
    // version
    0x00, 0x00, 0x00,
    // flags
    0x00, 0x00,
    // balance
    0x00, 0x00 // reserved
    ]);
    MP4.STSD = new Uint8Array([0x00,
    // version 0
    0x00, 0x00, 0x00,
    // flags
    0x00, 0x00, 0x00, 0x01]); // entry_count

    const majorBrand = new Uint8Array([105, 115, 111, 109]); // isom
    const avc1Brand = new Uint8Array([97, 118, 99, 49]); // avc1
    const minorVersion = new Uint8Array([0, 0, 0, 1]);
    MP4.FTYP = MP4.box(MP4.types.ftyp, majorBrand, minorVersion, majorBrand, avc1Brand);
    MP4.DINF = MP4.box(MP4.types.dinf, MP4.box(MP4.types.dref, dref));
  }
  static box(type, ...payload) {
    let size = 8;
    let i = payload.length;
    const len = i;
    // calculate the total size we need to allocate
    while (i--) {
      size += payload[i].byteLength;
    }
    const result = new Uint8Array(size);
    result[0] = size >> 24 & 0xff;
    result[1] = size >> 16 & 0xff;
    result[2] = size >> 8 & 0xff;
    result[3] = size & 0xff;
    result.set(type, 4);
    // copy the payload into the result
    for (i = 0, size = 8; i < len; i++) {
      // copy payload[i] array @ offset size
      result.set(payload[i], size);
      size += payload[i].byteLength;
    }
    return result;
  }
  static hdlr(type) {
    return MP4.box(MP4.types.hdlr, MP4.HDLR_TYPES[type]);
  }
  static mdat(data) {
    return MP4.box(MP4.types.mdat, data);
  }
  static mdhd(timescale, duration) {
    duration *= timescale;
    const upperWordDuration = Math.floor(duration / (UINT32_MAX + 1));
    const lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
    return MP4.box(MP4.types.mdhd, new Uint8Array([0x01,
    // version 1
    0x00, 0x00, 0x00,
    // flags
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x02,
    // creation_time
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x03,
    // modification_time
    timescale >> 24 & 0xff, timescale >> 16 & 0xff, timescale >> 8 & 0xff, timescale & 0xff,
    // timescale
    upperWordDuration >> 24, upperWordDuration >> 16 & 0xff, upperWordDuration >> 8 & 0xff, upperWordDuration & 0xff, lowerWordDuration >> 24, lowerWordDuration >> 16 & 0xff, lowerWordDuration >> 8 & 0xff, lowerWordDuration & 0xff, 0x55, 0xc4,
    // 'und' language (undetermined)
    0x00, 0x00]));
  }
  static mdia(track) {
    return MP4.box(MP4.types.mdia, MP4.mdhd(track.timescale || 0, track.duration || 0), MP4.hdlr(track.type), MP4.minf(track));
  }
  static mfhd(sequenceNumber) {
    return MP4.box(MP4.types.mfhd, new Uint8Array([0x00, 0x00, 0x00, 0x00,
    // flags
    sequenceNumber >> 24, sequenceNumber >> 16 & 0xff, sequenceNumber >> 8 & 0xff, sequenceNumber & 0xff // sequence_number
    ]));
  }
  static minf(track) {
    if (track.type === 'audio') {
      return MP4.box(MP4.types.minf, MP4.box(MP4.types.smhd, MP4.SMHD), MP4.DINF, MP4.stbl(track));
    } else {
      return MP4.box(MP4.types.minf, MP4.box(MP4.types.vmhd, MP4.VMHD), MP4.DINF, MP4.stbl(track));
    }
  }
  static moof(sn, baseMediaDecodeTime, track) {
    return MP4.box(MP4.types.moof, MP4.mfhd(sn), MP4.traf(track, baseMediaDecodeTime));
  }
  static moov(tracks) {
    let i = tracks.length;
    const boxes = [];
    while (i--) {
      boxes[i] = MP4.trak(tracks[i]);
    }
    return MP4.box.apply(null, [MP4.types.moov, MP4.mvhd(tracks[0].timescale || 0, tracks[0].duration || 0)].concat(boxes).concat(MP4.mvex(tracks)));
  }
  static mvex(tracks) {
    let i = tracks.length;
    const boxes = [];
    while (i--) {
      boxes[i] = MP4.trex(tracks[i]);
    }
    return MP4.box.apply(null, [MP4.types.mvex, ...boxes]);
  }
  static mvhd(timescale, duration) {
    duration *= timescale;
    const upperWordDuration = Math.floor(duration / (UINT32_MAX + 1));
    const lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
    const bytes = new Uint8Array([0x01,
    // version 1
    0x00, 0x00, 0x00,
    // flags
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x02,
    // creation_time
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x03,
    // modification_time
    timescale >> 24 & 0xff, timescale >> 16 & 0xff, timescale >> 8 & 0xff, timescale & 0xff,
    // timescale
    upperWordDuration >> 24, upperWordDuration >> 16 & 0xff, upperWordDuration >> 8 & 0xff, upperWordDuration & 0xff, lowerWordDuration >> 24, lowerWordDuration >> 16 & 0xff, lowerWordDuration >> 8 & 0xff, lowerWordDuration & 0xff, 0x00, 0x01, 0x00, 0x00,
    // 1.0 rate
    0x01, 0x00,
    // 1.0 volume
    0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00, 0x00,
    // reserved
    0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x40, 0x00, 0x00, 0x00,
    // transformation: unity matrix
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
    // pre_defined
    0xff, 0xff, 0xff, 0xff // next_track_ID
    ]);
    return MP4.box(MP4.types.mvhd, bytes);
  }
  static sdtp(track) {
    const samples = track.samples || [];
    const bytes = new Uint8Array(4 + samples.length);
    let i;
    let flags;
    // leave the full box header (4 bytes) all zero
    // write the sample table
    for (i = 0; i < samples.length; i++) {
      flags = samples[i].flags;
      bytes[i + 4] = flags.dependsOn << 4 | flags.isDependedOn << 2 | flags.hasRedundancy;
    }
    return MP4.box(MP4.types.sdtp, bytes);
  }
  static stbl(track) {
    return MP4.box(MP4.types.stbl, MP4.stsd(track), MP4.box(MP4.types.stts, MP4.STTS), MP4.box(MP4.types.stsc, MP4.STSC), MP4.box(MP4.types.stsz, MP4.STSZ), MP4.box(MP4.types.stco, MP4.STCO));
  }
  static avc1(track) {
    let sps = [];
    let pps = [];
    let i;
    let data;
    let len;
    // assemble the SPSs

    for (i = 0; i < track.sps.length; i++) {
      data = track.sps[i];
      len = data.byteLength;
      sps.push(len >>> 8 & 0xff);
      sps.push(len & 0xff);

      // SPS
      sps = sps.concat(Array.prototype.slice.call(data));
    }

    // assemble the PPSs
    for (i = 0; i < track.pps.length; i++) {
      data = track.pps[i];
      len = data.byteLength;
      pps.push(len >>> 8 & 0xff);
      pps.push(len & 0xff);
      pps = pps.concat(Array.prototype.slice.call(data));
    }
    const avcc = MP4.box(MP4.types.avcC, new Uint8Array([0x01,
    // version
    sps[3],
    // profile
    sps[4],
    // profile compat
    sps[5],
    // level
    0xfc | 3,
    // lengthSizeMinusOne, hard-coded to 4 bytes
    0xe0 | track.sps.length // 3bit reserved (111) + numOfSequenceParameterSets
    ].concat(sps).concat([track.pps.length // numOfPictureParameterSets
    ]).concat(pps))); // "PPS"
    const width = track.width;
    const height = track.height;
    const hSpacing = track.pixelRatio[0];
    const vSpacing = track.pixelRatio[1];
    return MP4.box(MP4.types.avc1, new Uint8Array([0x00, 0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00,
    // reserved
    0x00, 0x01,
    // data_reference_index
    0x00, 0x00,
    // pre_defined
    0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
    // pre_defined
    width >> 8 & 0xff, width & 0xff,
    // width
    height >> 8 & 0xff, height & 0xff,
    // height
    0x00, 0x48, 0x00, 0x00,
    // horizresolution
    0x00, 0x48, 0x00, 0x00,
    // vertresolution
    0x00, 0x00, 0x00, 0x00,
    // reserved
    0x00, 0x01,
    // frame_count
    0x12, 0x64, 0x61, 0x69, 0x6c,
    // dailymotion/hls.js
    0x79, 0x6d, 0x6f, 0x74, 0x69, 0x6f, 0x6e, 0x2f, 0x68, 0x6c, 0x73, 0x2e, 0x6a, 0x73, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
    // compressorname
    0x00, 0x18,
    // depth = 24
    0x11, 0x11]),
    // pre_defined = -1
    avcc, MP4.box(MP4.types.btrt, new Uint8Array([0x00, 0x1c, 0x9c, 0x80,
    // bufferSizeDB
    0x00, 0x2d, 0xc6, 0xc0,
    // maxBitrate
    0x00, 0x2d, 0xc6, 0xc0])),
    // avgBitrate
    MP4.box(MP4.types.pasp, new Uint8Array([hSpacing >> 24,
    // hSpacing
    hSpacing >> 16 & 0xff, hSpacing >> 8 & 0xff, hSpacing & 0xff, vSpacing >> 24,
    // vSpacing
    vSpacing >> 16 & 0xff, vSpacing >> 8 & 0xff, vSpacing & 0xff])));
  }
  static esds(track) {
    const config = track.config;
    return new Uint8Array([0x00,
    // version 0
    0x00, 0x00, 0x00,
    // flags

    0x03,
    // descriptor_type
    0x19,
    // length

    0x00, 0x01,
    // es_id

    0x00,
    // stream_priority

    0x04,
    // descriptor_type
    0x11,
    // length
    0x40,
    // codec : mpeg4_audio
    0x15,
    // stream_type
    0x00, 0x00, 0x00,
    // buffer_size
    0x00, 0x00, 0x00, 0x00,
    // maxBitrate
    0x00, 0x00, 0x00, 0x00,
    // avgBitrate

    0x05,
    // descriptor_type
    0x02,
    // length
    ...config, 0x06, 0x01, 0x02 // GASpecificConfig)); // length + audio config descriptor
    ]);
  }
  static audioStsd(track) {
    const samplerate = track.samplerate || 0;
    return new Uint8Array([0x00, 0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00,
    // reserved
    0x00, 0x01,
    // data_reference_index
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
    // reserved
    0x00, track.channelCount || 0,
    // channelcount
    0x00, 0x10,
    // sampleSize:16bits
    0x00, 0x00, 0x00, 0x00,
    // reserved2
    samplerate >> 8 & 0xff, samplerate & 0xff,
    //
    0x00, 0x00]);
  }
  static mp4a(track) {
    return MP4.box(MP4.types.mp4a, MP4.audioStsd(track), MP4.box(MP4.types.esds, MP4.esds(track)));
  }
  static mp3(track) {
    return MP4.box(MP4.types['.mp3'], MP4.audioStsd(track));
  }
  static ac3(track) {
    return MP4.box(MP4.types['ac-3'], MP4.audioStsd(track), MP4.box(MP4.types.dac3, track.config));
  }
  static stsd(track) {
    const {
      segmentCodec
    } = track;
    if (track.type === 'audio') {
      if (segmentCodec === 'aac') {
        return MP4.box(MP4.types.stsd, MP4.STSD, MP4.mp4a(track));
      }
      if (segmentCodec === 'ac3' && track.config) {
        return MP4.box(MP4.types.stsd, MP4.STSD, MP4.ac3(track));
      }
      if (segmentCodec === 'mp3' && track.codec === 'mp3') {
        return MP4.box(MP4.types.stsd, MP4.STSD, MP4.mp3(track));
      }
    } else {
      if (track.pps && track.sps) {
        if (segmentCodec === 'avc') {
          return MP4.box(MP4.types.stsd, MP4.STSD, MP4.avc1(track));
        }
        if (segmentCodec === 'hevc' && track.vps) {
          return MP4.box(MP4.types.stsd, MP4.STSD, MP4.hvc1(track));
        }
      } else {
        throw new Error(`video track missing pps or sps`);
      }
    }
    throw new Error(`unsupported ${track.type} segment codec (${segmentCodec}/${track.codec})`);
  }
  static tkhd(track) {
    const id = track.id;
    const duration = (track.duration || 0) * (track.timescale || 0);
    const width = track.width || 0;
    const height = track.height || 0;
    const upperWordDuration = Math.floor(duration / (UINT32_MAX + 1));
    const lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
    return MP4.box(MP4.types.tkhd, new Uint8Array([0x01,
    // version 1
    0x00, 0x00, 0x07,
    // flags
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x02,
    // creation_time
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x03,
    // modification_time
    id >> 24 & 0xff, id >> 16 & 0xff, id >> 8 & 0xff, id & 0xff,
    // track_ID
    0x00, 0x00, 0x00, 0x00,
    // reserved
    upperWordDuration >> 24, upperWordDuration >> 16 & 0xff, upperWordDuration >> 8 & 0xff, upperWordDuration & 0xff, lowerWordDuration >> 24, lowerWordDuration >> 16 & 0xff, lowerWordDuration >> 8 & 0xff, lowerWordDuration & 0xff, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
    // reserved
    0x00, 0x00,
    // layer
    0x00, 0x00,
    // alternate_group
    0x00, 0x00,
    // non-audio track volume
    0x00, 0x00,
    // reserved
    0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x40, 0x00, 0x00, 0x00,
    // transformation: unity matrix
    width >> 8 & 0xff, width & 0xff, 0x00, 0x00,
    // width
    height >> 8 & 0xff, height & 0xff, 0x00, 0x00 // height
    ]));
  }
  static traf(track, baseMediaDecodeTime) {
    const sampleDependencyTable = MP4.sdtp(track);
    const id = track.id;
    const upperWordBaseMediaDecodeTime = Math.floor(baseMediaDecodeTime / (UINT32_MAX + 1));
    const lowerWordBaseMediaDecodeTime = Math.floor(baseMediaDecodeTime % (UINT32_MAX + 1));
    return MP4.box(MP4.types.traf, MP4.box(MP4.types.tfhd, new Uint8Array([0x00,
    // version 0
    0x00, 0x00, 0x00,
    // flags
    id >> 24, id >> 16 & 0xff, id >> 8 & 0xff, id & 0xff // track_ID
    ])), MP4.box(MP4.types.tfdt, new Uint8Array([0x01,
    // version 1
    0x00, 0x00, 0x00,
    // flags
    upperWordBaseMediaDecodeTime >> 24, upperWordBaseMediaDecodeTime >> 16 & 0xff, upperWordBaseMediaDecodeTime >> 8 & 0xff, upperWordBaseMediaDecodeTime & 0xff, lowerWordBaseMediaDecodeTime >> 24, lowerWordBaseMediaDecodeTime >> 16 & 0xff, lowerWordBaseMediaDecodeTime >> 8 & 0xff, lowerWordBaseMediaDecodeTime & 0xff])), MP4.trun(track, sampleDependencyTable.length + 16 +
    // tfhd
    20 +
    // tfdt
    8 +
    // traf header
    16 +
    // mfhd
    8 +
    // moof header
    8),
    // mdat header
    sampleDependencyTable);
  }

  /**
   * Generate a track box.
   * @param track a track definition
   */
  static trak(track) {
    track.duration = track.duration || 0xffffffff;
    return MP4.box(MP4.types.trak, MP4.tkhd(track), MP4.mdia(track));
  }
  static trex(track) {
    const id = track.id;
    return MP4.box(MP4.types.trex, new Uint8Array([0x00,
    // version 0
    0x00, 0x00, 0x00,
    // flags
    id >> 24, id >> 16 & 0xff, id >> 8 & 0xff, id & 0xff,
    // track_ID
    0x00, 0x00, 0x00, 0x01,
    // default_sample_description_index
    0x00, 0x00, 0x00, 0x00,
    // default_sample_duration
    0x00, 0x00, 0x00, 0x00,
    // default_sample_size
    0x00, 0x01, 0x00, 0x01 // default_sample_flags
    ]));
  }
  static trun(track, offset) {
    const samples = track.samples || [];
    const len = samples.length;
    const arraylen = 12 + 16 * len;
    const array = new Uint8Array(arraylen);
    let i;
    let sample;
    let duration;
    let size;
    let flags;
    let cts;
    offset += 8 + arraylen;
    array.set([track.type === 'video' ? 0x01 : 0x00,
    // version 1 for video with signed-int sample_composition_time_offset
    0x00, 0x0f, 0x01,
    // flags
    len >>> 24 & 0xff, len >>> 16 & 0xff, len >>> 8 & 0xff, len & 0xff,
    // sample_count
    offset >>> 24 & 0xff, offset >>> 16 & 0xff, offset >>> 8 & 0xff, offset & 0xff // data_offset
    ], 0);
    for (i = 0; i < len; i++) {
      sample = samples[i];
      duration = sample.duration;
      size = sample.size;
      flags = sample.flags;
      cts = sample.cts;
      array.set([duration >>> 24 & 0xff, duration >>> 16 & 0xff, duration >>> 8 & 0xff, duration & 0xff,
      // sample_duration
      size >>> 24 & 0xff, size >>> 16 & 0xff, size >>> 8 & 0xff, size & 0xff,
      // sample_size
      flags.isLeading << 2 | flags.dependsOn, flags.isDependedOn << 6 | flags.hasRedundancy << 4 | flags.paddingValue << 1 | flags.isNonSync, flags.degradPrio & 0xf0 << 8, flags.degradPrio & 0x0f,
      // sample_flags
      cts >>> 24 & 0xff, cts >>> 16 & 0xff, cts >>> 8 & 0xff, cts & 0xff // sample_composition_time_offset
      ], 12 + 16 * i);
    }
    return MP4.box(MP4.types.trun, array);
  }
  static initSegment(tracks) {
    if (!MP4.types) {
      MP4.init();
    }
    const movie = MP4.moov(tracks);
    const result = appendUint8Array(MP4.FTYP, movie);
    return result;
  }
  static hvc1(track) {
    const ps = track.params;
    const units = [track.vps, track.sps, track.pps];
    const NALuLengthSize = 4;
    const config = new Uint8Array([0x01, ps.general_profile_space << 6 | (ps.general_tier_flag ? 32 : 0) | ps.general_profile_idc, ps.general_profile_compatibility_flags[0], ps.general_profile_compatibility_flags[1], ps.general_profile_compatibility_flags[2], ps.general_profile_compatibility_flags[3], ps.general_constraint_indicator_flags[0], ps.general_constraint_indicator_flags[1], ps.general_constraint_indicator_flags[2], ps.general_constraint_indicator_flags[3], ps.general_constraint_indicator_flags[4], ps.general_constraint_indicator_flags[5], ps.general_level_idc, 240 | ps.min_spatial_segmentation_idc >> 8, 255 & ps.min_spatial_segmentation_idc, 252 | ps.parallelismType, 252 | ps.chroma_format_idc, 248 | ps.bit_depth_luma_minus8, 248 | ps.bit_depth_chroma_minus8, 0x00, parseInt(ps.frame_rate.fps), NALuLengthSize - 1 | ps.temporal_id_nested << 2 | ps.num_temporal_layers << 3 | (ps.frame_rate.fixed ? 64 : 0), units.length]);

    // compute hvcC size in bytes
    let length = config.length;
    for (let i = 0; i < units.length; i += 1) {
      length += 3;
      for (let j = 0; j < units[i].length; j += 1) {
        length += 2 + units[i][j].length;
      }
    }
    const hvcC = new Uint8Array(length);
    hvcC.set(config, 0);
    length = config.length;
    // append parameter set units: one vps, one or more sps and pps
    const iMax = units.length - 1;
    for (let i = 0; i < units.length; i += 1) {
      hvcC.set(new Uint8Array([32 + i | (i === iMax ? 128 : 0), 0x00, units[i].length]), length);
      length += 3;
      for (let j = 0; j < units[i].length; j += 1) {
        hvcC.set(new Uint8Array([units[i][j].length >> 8, units[i][j].length & 255]), length);
        length += 2;
        hvcC.set(units[i][j], length);
        length += units[i][j].length;
      }
    }
    const hvcc = MP4.box(MP4.types.hvcC, hvcC);
    const width = track.width;
    const height = track.height;
    const hSpacing = track.pixelRatio[0];
    const vSpacing = track.pixelRatio[1];
    return MP4.box(MP4.types.hvc1, new Uint8Array([0x00, 0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00,
    // reserved
    0x00, 0x01,
    // data_reference_index
    0x00, 0x00,
    // pre_defined
    0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
    // pre_defined
    width >> 8 & 0xff, width & 0xff,
    // width
    height >> 8 & 0xff, height & 0xff,
    // height
    0x00, 0x48, 0x00, 0x00,
    // horizresolution
    0x00, 0x48, 0x00, 0x00,
    // vertresolution
    0x00, 0x00, 0x00, 0x00,
    // reserved
    0x00, 0x01,
    // frame_count
    0x12, 0x64, 0x61, 0x69, 0x6c,
    // dailymotion/hls.js
    0x79, 0x6d, 0x6f, 0x74, 0x69, 0x6f, 0x6e, 0x2f, 0x68, 0x6c, 0x73, 0x2e, 0x6a, 0x73, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
    // compressorname
    0x00, 0x18,
    // depth = 24
    0x11, 0x11]),
    // pre_defined = -1
    hvcc, MP4.box(MP4.types.btrt, new Uint8Array([0x00, 0x1c, 0x9c, 0x80,
    // bufferSizeDB
    0x00, 0x2d, 0xc6, 0xc0,
    // maxBitrate
    0x00, 0x2d, 0xc6, 0xc0])),
    // avgBitrate
    MP4.box(MP4.types.pasp, new Uint8Array([hSpacing >> 24,
    // hSpacing
    hSpacing >> 16 & 0xff, hSpacing >> 8 & 0xff, hSpacing & 0xff, vSpacing >> 24,
    // vSpacing
    vSpacing >> 16 & 0xff, vSpacing >> 8 & 0xff, vSpacing & 0xff])));
  }
}
MP4.types = void 0;
MP4.HDLR_TYPES = void 0;
MP4.STTS = void 0;
MP4.STSC = void 0;
MP4.STCO = void 0;
MP4.STSZ = void 0;
MP4.VMHD = void 0;
MP4.SMHD = void 0;
MP4.STSD = void 0;
MP4.FTYP = void 0;
MP4.DINF = void 0;

const MPEG_TS_CLOCK_FREQ_HZ = 90000;
function toTimescaleFromBase(baseTime, destScale, srcBase = 1, round = false) {
  const result = baseTime * destScale * srcBase; // equivalent to `(value * scale) / (1 / base)`
  return round ? Math.round(result) : result;
}
function toTimescaleFromScale(baseTime, destScale, srcScale = 1, round = false) {
  return toTimescaleFromBase(baseTime, destScale, 1 / srcScale, round);
}
function toMsFromMpegTsClock(baseTime, round = false) {
  return toTimescaleFromBase(baseTime, 1000, 1 / MPEG_TS_CLOCK_FREQ_HZ, round);
}
function toMpegTsClockFromTimescale(baseTime, srcScale = 1) {
  return toTimescaleFromBase(baseTime, MPEG_TS_CLOCK_FREQ_HZ, 1 / srcScale);
}

const MAX_SILENT_FRAME_DURATION = 10 * 1000; // 10 seconds
const AAC_SAMPLES_PER_FRAME = 1024;
const MPEG_AUDIO_SAMPLE_PER_FRAME = 1152;
const AC3_SAMPLES_PER_FRAME = 1536;
let chromeVersion = null;
let safariWebkitVersion = null;
function createMp4Sample(isKeyframe, duration, size, cts) {
  return {
    duration,
    size,
    cts,
    flags: {
      isLeading: 0,
      isDependedOn: 0,
      hasRedundancy: 0,
      degradPrio: 0,
      dependsOn: isKeyframe ? 2 : 1,
      isNonSync: isKeyframe ? 0 : 1
    }
  };
}
class MP4Remuxer {
  constructor(observer, config, typeSupported, logger) {
    this.logger = void 0;
    this.observer = void 0;
    this.config = void 0;
    this.typeSupported = void 0;
    this.ISGenerated = false;
    this._initPTS = null;
    this._initDTS = null;
    this.nextAvcDts = null;
    this.nextAudioPts = null;
    this.videoSampleDuration = null;
    this.isAudioContiguous = false;
    this.isVideoContiguous = false;
    this.videoTrackConfig = void 0;
    this.observer = observer;
    this.config = config;
    this.typeSupported = typeSupported;
    this.logger = logger;
    this.ISGenerated = false;
    if (chromeVersion === null) {
      const userAgent = navigator.userAgent || '';
      const result = userAgent.match(/Chrome\/(\d+)/i);
      chromeVersion = result ? parseInt(result[1]) : 0;
    }
    if (safariWebkitVersion === null) {
      const result = navigator.userAgent.match(/Safari\/(\d+)/i);
      safariWebkitVersion = result ? parseInt(result[1]) : 0;
    }
  }
  destroy() {
    // @ts-ignore
    this.config = this.videoTrackConfig = this._initPTS = this._initDTS = null;
  }
  resetTimeStamp(defaultTimeStamp) {
    this.logger.log('[mp4-remuxer]: initPTS & initDTS reset');
    this._initPTS = this._initDTS = defaultTimeStamp;
  }
  resetNextTimestamp() {
    this.logger.log('[mp4-remuxer]: reset next timestamp');
    this.isVideoContiguous = false;
    this.isAudioContiguous = false;
  }
  resetInitSegment() {
    this.logger.log('[mp4-remuxer]: ISGenerated flag reset');
    this.ISGenerated = false;
    this.videoTrackConfig = undefined;
  }
  getVideoStartPts(videoSamples) {
    // Get the minimum PTS value relative to the first sample's PTS, normalized for 33-bit wrapping
    let rolloverDetected = false;
    const firstPts = videoSamples[0].pts;
    const startPTS = videoSamples.reduce((minPTS, sample) => {
      let pts = sample.pts;
      let delta = pts - minPTS;
      if (delta < -4294967296) {
        // 2^32, see PTSNormalize for reasoning, but we're hitting a rollover here, and we don't want that to impact the timeOffset calculation
        rolloverDetected = true;
        pts = normalizePts(pts, firstPts);
        delta = pts - minPTS;
      }
      if (delta > 0) {
        return minPTS;
      }
      return pts;
    }, firstPts);
    if (rolloverDetected) {
      this.logger.debug('PTS rollover detected');
    }
    return startPTS;
  }
  remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset, flush, playlistType) {
    let video;
    let audio;
    let initSegment;
    let text;
    let id3;
    let independent;
    let audioTimeOffset = timeOffset;
    let videoTimeOffset = timeOffset;

    // If we're remuxing audio and video progressively, wait until we've received enough samples for each track before proceeding.
    // This is done to synchronize the audio and video streams. We know if the current segment will have samples if the "pid"
    // parameter is greater than -1. The pid is set when the PMT is parsed, which contains the tracks list.
    // However, if the initSegment has already been generated, or we've reached the end of a segment (flush),
    // then we can remux one track without waiting for the other.
    const hasAudio = audioTrack.pid > -1;
    const hasVideo = videoTrack.pid > -1;
    const length = videoTrack.samples.length;
    const enoughAudioSamples = audioTrack.samples.length > 0;
    const enoughVideoSamples = flush && length > 0 || length > 1;
    const canRemuxAvc = (!hasAudio || enoughAudioSamples) && (!hasVideo || enoughVideoSamples) || this.ISGenerated || flush;
    if (canRemuxAvc) {
      if (this.ISGenerated) {
        var _videoTrack$pixelRati, _config$pixelRatio, _videoTrack$pixelRati2, _config$pixelRatio2;
        const config = this.videoTrackConfig;
        if (config && (videoTrack.width !== config.width || videoTrack.height !== config.height || ((_videoTrack$pixelRati = videoTrack.pixelRatio) == null ? void 0 : _videoTrack$pixelRati[0]) !== ((_config$pixelRatio = config.pixelRatio) == null ? void 0 : _config$pixelRatio[0]) || ((_videoTrack$pixelRati2 = videoTrack.pixelRatio) == null ? void 0 : _videoTrack$pixelRati2[1]) !== ((_config$pixelRatio2 = config.pixelRatio) == null ? void 0 : _config$pixelRatio2[1])) || !config && enoughVideoSamples || this.nextAudioPts === null && enoughAudioSamples) {
          this.resetInitSegment();
        }
      }
      if (!this.ISGenerated) {
        initSegment = this.generateIS(audioTrack, videoTrack, timeOffset, accurateTimeOffset);
      }
      const isVideoContiguous = this.isVideoContiguous;
      let firstKeyFrameIndex = -1;
      let firstKeyFramePTS;
      if (enoughVideoSamples) {
        firstKeyFrameIndex = findKeyframeIndex(videoTrack.samples);
        if (!isVideoContiguous && this.config.forceKeyFrameOnDiscontinuity) {
          independent = true;
          if (firstKeyFrameIndex > 0) {
            this.logger.warn(`[mp4-remuxer]: Dropped ${firstKeyFrameIndex} out of ${length} video samples due to a missing keyframe`);
            const startPTS = this.getVideoStartPts(videoTrack.samples);
            videoTrack.samples = videoTrack.samples.slice(firstKeyFrameIndex);
            videoTrack.dropped += firstKeyFrameIndex;
            videoTimeOffset += (videoTrack.samples[0].pts - startPTS) / videoTrack.inputTimeScale;
            firstKeyFramePTS = videoTimeOffset;
          } else if (firstKeyFrameIndex === -1) {
            this.logger.warn(`[mp4-remuxer]: No keyframe found out of ${length} video samples`);
            independent = false;
          }
        }
      }
      if (this.ISGenerated) {
        if (enoughAudioSamples && enoughVideoSamples) {
          // timeOffset is expected to be the offset of the first timestamp of this fragment (first DTS)
          // if first audio DTS is not aligned with first video DTS then we need to take that into account
          // when providing timeOffset to remuxAudio / remuxVideo. if we don't do that, there might be a permanent / small
          // drift between audio and video streams
          const startPTS = this.getVideoStartPts(videoTrack.samples);
          const tsDelta = normalizePts(audioTrack.samples[0].pts, startPTS) - startPTS;
          const audiovideoTimestampDelta = tsDelta / videoTrack.inputTimeScale;
          audioTimeOffset += Math.max(0, audiovideoTimestampDelta);
          videoTimeOffset += Math.max(0, -audiovideoTimestampDelta);
        }

        // Purposefully remuxing audio before video, so that remuxVideo can use nextAudioPts, which is calculated in remuxAudio.
        if (enoughAudioSamples) {
          // if initSegment was generated without audio samples, regenerate it again
          if (!audioTrack.samplerate) {
            this.logger.warn('[mp4-remuxer]: regenerate InitSegment as audio detected');
            initSegment = this.generateIS(audioTrack, videoTrack, timeOffset, accurateTimeOffset);
          }
          audio = this.remuxAudio(audioTrack, audioTimeOffset, this.isAudioContiguous, accurateTimeOffset, hasVideo || enoughVideoSamples || playlistType === PlaylistLevelType.AUDIO ? videoTimeOffset : undefined);
          if (enoughVideoSamples) {
            const audioTrackLength = audio ? audio.endPTS - audio.startPTS : 0;
            // if initSegment was generated without video samples, regenerate it again
            if (!videoTrack.inputTimeScale) {
              this.logger.warn('[mp4-remuxer]: regenerate InitSegment as video detected');
              initSegment = this.generateIS(audioTrack, videoTrack, timeOffset, accurateTimeOffset);
            }
            video = this.remuxVideo(videoTrack, videoTimeOffset, isVideoContiguous, audioTrackLength);
          }
        } else if (enoughVideoSamples) {
          video = this.remuxVideo(videoTrack, videoTimeOffset, isVideoContiguous, 0);
        }
        if (video) {
          video.firstKeyFrame = firstKeyFrameIndex;
          video.independent = firstKeyFrameIndex !== -1;
          video.firstKeyFramePTS = firstKeyFramePTS;
        }
      }
    }

    // Allow ID3 and text to remux, even if more audio/video samples are required
    if (this.ISGenerated && this._initPTS && this._initDTS) {
      if (id3Track.samples.length) {
        id3 = flushTextTrackMetadataCueSamples(id3Track, timeOffset, this._initPTS, this._initDTS);
      }
      if (textTrack.samples.length) {
        text = flushTextTrackUserdataCueSamples(textTrack, timeOffset, this._initPTS);
      }
    }
    return {
      audio,
      video,
      initSegment,
      independent,
      text,
      id3
    };
  }
  generateIS(audioTrack, videoTrack, timeOffset, accurateTimeOffset) {
    const audioSamples = audioTrack.samples;
    const videoSamples = videoTrack.samples;
    const typeSupported = this.typeSupported;
    const tracks = {};
    const _initPTS = this._initPTS;
    let computePTSDTS = !_initPTS || accurateTimeOffset;
    let container = 'audio/mp4';
    let initPTS;
    let initDTS;
    let timescale;
    let trackId;
    if (computePTSDTS) {
      initPTS = initDTS = Infinity;
    }
    if (audioTrack.config && audioSamples.length) {
      // let's use audio sampling rate as MP4 time scale.
      // rationale is that there is a integer nb of audio frames per audio sample (1024 for AAC)
      // using audio sampling rate here helps having an integer MP4 frame duration
      // this avoids potential rounding issue and AV sync issue
      audioTrack.timescale = audioTrack.samplerate;
      switch (audioTrack.segmentCodec) {
        case 'mp3':
          if (typeSupported.mpeg) {
            // Chrome and Safari
            container = 'audio/mpeg';
            audioTrack.codec = '';
          } else if (typeSupported.mp3) {
            // Firefox
            audioTrack.codec = 'mp3';
          }
          break;
        case 'ac3':
          audioTrack.codec = 'ac-3';
          break;
      }
      tracks.audio = {
        id: 'audio',
        container: container,
        codec: audioTrack.codec,
        initSegment: audioTrack.segmentCodec === 'mp3' && typeSupported.mpeg ? new Uint8Array(0) : MP4.initSegment([audioTrack]),
        metadata: {
          channelCount: audioTrack.channelCount
        }
      };
      if (computePTSDTS) {
        trackId = audioTrack.id;
        timescale = audioTrack.inputTimeScale;
        if (!_initPTS || timescale !== _initPTS.timescale) {
          // remember first PTS of this demuxing context. for audio, PTS = DTS
          initPTS = initDTS = audioSamples[0].pts - Math.round(timescale * timeOffset);
        } else {
          computePTSDTS = false;
        }
      }
    }
    if (videoTrack.sps && videoTrack.pps && videoSamples.length) {
      // let's use input time scale as MP4 video timescale
      // we use input time scale straight away to avoid rounding issues on frame duration / cts computation
      videoTrack.timescale = videoTrack.inputTimeScale;
      tracks.video = {
        id: 'main',
        container: 'video/mp4',
        codec: videoTrack.codec,
        initSegment: MP4.initSegment([videoTrack]),
        metadata: {
          width: videoTrack.width,
          height: videoTrack.height
        }
      };
      if (computePTSDTS) {
        trackId = videoTrack.id;
        timescale = videoTrack.inputTimeScale;
        if (!_initPTS || timescale !== _initPTS.timescale) {
          const startPTS = this.getVideoStartPts(videoSamples);
          const startOffset = Math.round(timescale * timeOffset);
          initDTS = Math.min(initDTS, normalizePts(videoSamples[0].dts, startPTS) - startOffset);
          initPTS = Math.min(initPTS, startPTS - startOffset);
        } else {
          computePTSDTS = false;
        }
      }
      this.videoTrackConfig = {
        width: videoTrack.width,
        height: videoTrack.height,
        pixelRatio: videoTrack.pixelRatio
      };
    }
    if (Object.keys(tracks).length) {
      this.ISGenerated = true;
      if (computePTSDTS) {
        this._initPTS = {
          baseTime: initPTS,
          timescale: timescale
        };
        this._initDTS = {
          baseTime: initDTS,
          timescale: timescale
        };
      } else {
        initPTS = timescale = undefined;
      }
      return {
        tracks,
        initPTS,
        timescale,
        trackId
      };
    }
  }
  remuxVideo(track, timeOffset, contiguous, audioTrackLength) {
    const timeScale = track.inputTimeScale;
    const inputSamples = track.samples;
    const outputSamples = [];
    const nbSamples = inputSamples.length;
    const initPTS = this._initPTS;
    let nextAvcDts = this.nextAvcDts;
    let offset = 8;
    let mp4SampleDuration = this.videoSampleDuration;
    let firstDTS;
    let lastDTS;
    let minPTS = Number.POSITIVE_INFINITY;
    let maxPTS = Number.NEGATIVE_INFINITY;
    let sortSamples = false;

    // if parsed fragment is contiguous with last one, let's use last DTS value as reference
    if (!contiguous || nextAvcDts === null) {
      const pts = timeOffset * timeScale;
      const cts = inputSamples[0].pts - normalizePts(inputSamples[0].dts, inputSamples[0].pts);
      if (chromeVersion && nextAvcDts !== null && Math.abs(pts - cts - nextAvcDts) < 15000) {
        // treat as contigous to adjust samples that would otherwise produce video buffer gaps in Chrome
        contiguous = true;
      } else {
        // if not contiguous, let's use target timeOffset
        nextAvcDts = pts - cts;
      }
    }

    // PTS is coded on 33bits, and can loop from -2^32 to 2^32
    // PTSNormalize will make PTS/DTS value monotonic, we use last known DTS value as reference value
    const initTime = initPTS.baseTime * timeScale / initPTS.timescale;
    for (let i = 0; i < nbSamples; i++) {
      const sample = inputSamples[i];
      sample.pts = normalizePts(sample.pts - initTime, nextAvcDts);
      sample.dts = normalizePts(sample.dts - initTime, nextAvcDts);
      if (sample.dts < inputSamples[i > 0 ? i - 1 : i].dts) {
        sortSamples = true;
      }
    }

    // sort video samples by DTS then PTS then demux id order
    if (sortSamples) {
      inputSamples.sort(function (a, b) {
        const deltadts = a.dts - b.dts;
        const deltapts = a.pts - b.pts;
        return deltadts || deltapts;
      });
    }

    // Get first/last DTS
    firstDTS = inputSamples[0].dts;
    lastDTS = inputSamples[inputSamples.length - 1].dts;

    // Sample duration (as expected by trun MP4 boxes), should be the delta between sample DTS
    // set this constant duration as being the avg delta between consecutive DTS.
    const inputDuration = lastDTS - firstDTS;
    const averageSampleDuration = inputDuration ? Math.round(inputDuration / (nbSamples - 1)) : mp4SampleDuration || track.inputTimeScale / 30;

    // if fragment are contiguous, detect hole/overlapping between fragments
    if (contiguous) {
      // check timestamp continuity across consecutive fragments (this is to remove inter-fragment gap/hole)
      const delta = firstDTS - nextAvcDts;
      const foundHole = delta > averageSampleDuration;
      const foundOverlap = delta < -1;
      if (foundHole || foundOverlap) {
        if (foundHole) {
          this.logger.warn(`${(track.segmentCodec || '').toUpperCase()}: ${toMsFromMpegTsClock(delta, true)} ms (${delta}dts) hole between fragments detected at ${timeOffset.toFixed(3)}`);
        } else {
          this.logger.warn(`${(track.segmentCodec || '').toUpperCase()}: ${toMsFromMpegTsClock(-delta, true)} ms (${delta}dts) overlapping between fragments detected at ${timeOffset.toFixed(3)}`);
        }
        if (!foundOverlap || nextAvcDts >= inputSamples[0].pts || chromeVersion) {
          firstDTS = nextAvcDts;
          const firstPTS = inputSamples[0].pts - delta;
          if (foundHole) {
            inputSamples[0].dts = firstDTS;
            inputSamples[0].pts = firstPTS;
          } else {
            let isPTSOrderRetained = true;
            for (let i = 0; i < inputSamples.length; i++) {
              if (inputSamples[i].dts > firstPTS && isPTSOrderRetained) {
                break;
              }
              const prevPTS = inputSamples[i].pts;
              inputSamples[i].dts -= delta;
              inputSamples[i].pts -= delta;

              // check to see if this sample's PTS order has changed
              // relative to the next one
              if (i < inputSamples.length - 1) {
                const nextSamplePTS = inputSamples[i + 1].pts;
                const currentSamplePTS = inputSamples[i].pts;
                const currentOrder = nextSamplePTS <= currentSamplePTS;
                const prevOrder = nextSamplePTS <= prevPTS;
                isPTSOrderRetained = currentOrder == prevOrder;
              }
            }
          }
          this.logger.log(`Video: Initial PTS/DTS adjusted: ${toMsFromMpegTsClock(firstPTS, true)}/${toMsFromMpegTsClock(firstDTS, true)}, delta: ${toMsFromMpegTsClock(delta, true)} ms`);
        }
      }
    }
    firstDTS = Math.max(0, firstDTS);
    let nbNalu = 0;
    let naluLen = 0;
    let dtsStep = firstDTS;
    for (let i = 0; i < nbSamples; i++) {
      // compute total/avc sample length and nb of NAL units
      const sample = inputSamples[i];
      const units = sample.units;
      const nbUnits = units.length;
      let sampleLen = 0;
      for (let j = 0; j < nbUnits; j++) {
        sampleLen += units[j].data.length;
      }
      naluLen += sampleLen;
      nbNalu += nbUnits;
      sample.length = sampleLen;

      // ensure sample monotonic DTS
      if (sample.dts < dtsStep) {
        sample.dts = dtsStep;
        dtsStep += averageSampleDuration / 4 | 0 || 1;
      } else {
        dtsStep = sample.dts;
      }
      minPTS = Math.min(sample.pts, minPTS);
      maxPTS = Math.max(sample.pts, maxPTS);
    }
    lastDTS = inputSamples[nbSamples - 1].dts;

    /* concatenate the video data and construct the mdat in place
      (need 8 more bytes to fill length and mpdat type) */
    const mdatSize = naluLen + 4 * nbNalu + 8;
    let mdat;
    try {
      mdat = new Uint8Array(mdatSize);
    } catch (err) {
      this.observer.emit(Events.ERROR, Events.ERROR, {
        type: ErrorTypes.MUX_ERROR,
        details: ErrorDetails.REMUX_ALLOC_ERROR,
        fatal: false,
        error: err,
        bytes: mdatSize,
        reason: `fail allocating video mdat ${mdatSize}`
      });
      return;
    }
    const view = new DataView(mdat.buffer);
    view.setUint32(0, mdatSize);
    mdat.set(MP4.types.mdat, 4);
    let stretchedLastFrame = false;
    let minDtsDelta = Number.POSITIVE_INFINITY;
    let minPtsDelta = Number.POSITIVE_INFINITY;
    let maxDtsDelta = Number.NEGATIVE_INFINITY;
    let maxPtsDelta = Number.NEGATIVE_INFINITY;
    for (let i = 0; i < nbSamples; i++) {
      const VideoSample = inputSamples[i];
      const VideoSampleUnits = VideoSample.units;
      let mp4SampleLength = 0;
      // convert NALU bitstream to MP4 format (prepend NALU with size field)
      for (let j = 0, nbUnits = VideoSampleUnits.length; j < nbUnits; j++) {
        const unit = VideoSampleUnits[j];
        const unitData = unit.data;
        const unitDataLen = unit.data.byteLength;
        view.setUint32(offset, unitDataLen);
        offset += 4;
        mdat.set(unitData, offset);
        offset += unitDataLen;
        mp4SampleLength += 4 + unitDataLen;
      }

      // expected sample duration is the Decoding Timestamp diff of consecutive samples
      let ptsDelta;
      if (i < nbSamples - 1) {
        mp4SampleDuration = inputSamples[i + 1].dts - VideoSample.dts;
        ptsDelta = inputSamples[i + 1].pts - VideoSample.pts;
      } else {
        const config = this.config;
        const lastFrameDuration = i > 0 ? VideoSample.dts - inputSamples[i - 1].dts : averageSampleDuration;
        ptsDelta = i > 0 ? VideoSample.pts - inputSamples[i - 1].pts : averageSampleDuration;
        if (config.stretchShortVideoTrack && this.nextAudioPts !== null) {
          // In some cases, a segment's audio track duration may exceed the video track duration.
          // Since we've already remuxed audio, and we know how long the audio track is, we look to
          // see if the delta to the next segment is longer than maxBufferHole.
          // If so, playback would potentially get stuck, so we artificially inflate
          // the duration of the last frame to minimize any potential gap between segments.
          const gapTolerance = Math.floor(config.maxBufferHole * timeScale);
          const deltaToFrameEnd = (audioTrackLength ? minPTS + audioTrackLength * timeScale : this.nextAudioPts) - VideoSample.pts;
          if (deltaToFrameEnd > gapTolerance) {
            // We subtract lastFrameDuration from deltaToFrameEnd to try to prevent any video
            // frame overlap. maxBufferHole should be >> lastFrameDuration anyway.
            mp4SampleDuration = deltaToFrameEnd - lastFrameDuration;
            if (mp4SampleDuration < 0) {
              mp4SampleDuration = lastFrameDuration;
            } else {
              stretchedLastFrame = true;
            }
            this.logger.log(`[mp4-remuxer]: It is approximately ${deltaToFrameEnd / 90} ms to the next segment; using duration ${mp4SampleDuration / 90} ms for the last video frame.`);
          } else {
            mp4SampleDuration = lastFrameDuration;
          }
        } else {
          mp4SampleDuration = lastFrameDuration;
        }
      }
      const compositionTimeOffset = Math.round(VideoSample.pts - VideoSample.dts);
      minDtsDelta = Math.min(minDtsDelta, mp4SampleDuration);
      maxDtsDelta = Math.max(maxDtsDelta, mp4SampleDuration);
      minPtsDelta = Math.min(minPtsDelta, ptsDelta);
      maxPtsDelta = Math.max(maxPtsDelta, ptsDelta);
      outputSamples.push(createMp4Sample(VideoSample.key, mp4SampleDuration, mp4SampleLength, compositionTimeOffset));
    }
    if (outputSamples.length) {
      if (chromeVersion) {
        if (chromeVersion < 70) {
          // Chrome workaround, mark first sample as being a Random Access Point (keyframe) to avoid sourcebuffer append issue
          // https://code.google.com/p/chromium/issues/detail?id=229412
          const flags = outputSamples[0].flags;
          flags.dependsOn = 2;
          flags.isNonSync = 0;
        }
      } else if (safariWebkitVersion) {
        // Fix for "CNN special report, with CC" in test-streams (Safari browser only)
        // Ignore DTS when frame durations are irregular. Safari MSE does not handle this leading to gaps.
        if (maxPtsDelta - minPtsDelta < maxDtsDelta - minDtsDelta && averageSampleDuration / maxDtsDelta < 0.025 && outputSamples[0].cts === 0) {
          this.logger.warn('Found irregular gaps in sample duration. Using PTS instead of DTS to determine MP4 sample duration.');
          let dts = firstDTS;
          for (let i = 0, len = outputSamples.length; i < len; i++) {
            const nextDts = dts + outputSamples[i].duration;
            const pts = dts + outputSamples[i].cts;
            if (i < len - 1) {
              const nextPts = nextDts + outputSamples[i + 1].cts;
              outputSamples[i].duration = nextPts - pts;
            } else {
              outputSamples[i].duration = i ? outputSamples[i - 1].duration : averageSampleDuration;
            }
            outputSamples[i].cts = 0;
            dts = nextDts;
          }
        }
      }
    }
    // next AVC/HEVC sample DTS should be equal to last sample DTS + last sample duration (in PES timescale)
    mp4SampleDuration = stretchedLastFrame || !mp4SampleDuration ? averageSampleDuration : mp4SampleDuration;
    this.nextAvcDts = nextAvcDts = lastDTS + mp4SampleDuration;
    this.videoSampleDuration = mp4SampleDuration;
    this.isVideoContiguous = true;
    const moof = MP4.moof(track.sequenceNumber++, firstDTS, _extends(track, {
      samples: outputSamples
    }));
    const type = 'video';
    const data = {
      data1: moof,
      data2: mdat,
      startPTS: minPTS / timeScale,
      endPTS: (maxPTS + mp4SampleDuration) / timeScale,
      startDTS: firstDTS / timeScale,
      endDTS: nextAvcDts / timeScale,
      type,
      hasAudio: false,
      hasVideo: true,
      nb: outputSamples.length,
      dropped: track.dropped
    };
    track.samples = [];
    track.dropped = 0;
    return data;
  }
  getSamplesPerFrame(track) {
    switch (track.segmentCodec) {
      case 'mp3':
        return MPEG_AUDIO_SAMPLE_PER_FRAME;
      case 'ac3':
        return AC3_SAMPLES_PER_FRAME;
      default:
        return AAC_SAMPLES_PER_FRAME;
    }
  }
  remuxAudio(track, timeOffset, contiguous, accurateTimeOffset, videoTimeOffset) {
    const inputTimeScale = track.inputTimeScale;
    const mp4timeScale = track.samplerate ? track.samplerate : inputTimeScale;
    const scaleFactor = inputTimeScale / mp4timeScale;
    const mp4SampleDuration = this.getSamplesPerFrame(track);
    const inputSampleDuration = mp4SampleDuration * scaleFactor;
    const initPTS = this._initPTS;
    const rawMPEG = track.segmentCodec === 'mp3' && this.typeSupported.mpeg;
    const outputSamples = [];
    const alignedWithVideo = videoTimeOffset !== undefined;
    let inputSamples = track.samples;
    let offset = rawMPEG ? 0 : 8;
    let nextAudioPts = this.nextAudioPts || -1;

    // window.audioSamples ? window.audioSamples.push(inputSamples.map(s => s.pts)) : (window.audioSamples = [inputSamples.map(s => s.pts)]);

    // for audio samples, also consider consecutive fragments as being contiguous (even if a level switch occurs),
    // for sake of clarity:
    // consecutive fragments are frags with
    //  - less than 100ms gaps between new time offset (if accurate) and next expected PTS OR
    //  - less than 20 audio frames distance
    // contiguous fragments are consecutive fragments from same quality level (same level, new SN = old SN + 1)
    // this helps ensuring audio continuity
    // and this also avoids audio glitches/cut when switching quality, or reporting wrong duration on first audio frame
    const timeOffsetMpegTS = timeOffset * inputTimeScale;
    const initTime = initPTS.baseTime * inputTimeScale / initPTS.timescale;
    this.isAudioContiguous = contiguous = contiguous || inputSamples.length && nextAudioPts > 0 && (accurateTimeOffset && Math.abs(timeOffsetMpegTS - nextAudioPts) < 9000 || Math.abs(normalizePts(inputSamples[0].pts - initTime, timeOffsetMpegTS) - nextAudioPts) < 20 * inputSampleDuration);

    // compute normalized PTS
    inputSamples.forEach(function (sample) {
      sample.pts = normalizePts(sample.pts - initTime, timeOffsetMpegTS);
    });
    if (!contiguous || nextAudioPts < 0) {
      // filter out sample with negative PTS that are not playable anyway
      // if we don't remove these negative samples, they will shift all audio samples forward.
      // leading to audio overlap between current / next fragment
      inputSamples = inputSamples.filter(sample => sample.pts >= 0);

      // in case all samples have negative PTS, and have been filtered out, return now
      if (!inputSamples.length) {
        return;
      }
      if (videoTimeOffset === 0) {
        // Set the start to 0 to match video so that start gaps larger than inputSampleDuration are filled with silence
        nextAudioPts = 0;
      } else if (accurateTimeOffset && !alignedWithVideo) {
        // When not seeking, not live, and LevelDetails.PTSKnown, use fragment start as predicted next audio PTS
        nextAudioPts = Math.max(0, timeOffsetMpegTS);
      } else {
        // if frags are not contiguous and if we cant trust time offset, let's use first sample PTS as next audio PTS
        nextAudioPts = inputSamples[0].pts;
      }
    }

    // If the audio track is missing samples, the frames seem to get "left-shifted" within the
    // resulting mp4 segment, causing sync issues and leaving gaps at the end of the audio segment.
    // In an effort to prevent this from happening, we inject frames here where there are gaps.
    // When possible, we inject a silent frame; when that's not possible, we duplicate the last
    // frame.

    if (track.segmentCodec === 'aac') {
      const maxAudioFramesDrift = this.config.maxAudioFramesDrift;
      for (let i = 0, nextPts = nextAudioPts; i < inputSamples.length; i++) {
        // First, let's see how far off this frame is from where we expect it to be
        const sample = inputSamples[i];
        const pts = sample.pts;
        const delta = pts - nextPts;
        const duration = Math.abs(1000 * delta / inputTimeScale);

        // When remuxing with video, if we're overlapping by more than a duration, drop this sample to stay in sync
        if (delta <= -maxAudioFramesDrift * inputSampleDuration && alignedWithVideo) {
          if (i === 0) {
            this.logger.warn(`Audio frame @ ${(pts / inputTimeScale).toFixed(3)}s overlaps nextAudioPts by ${Math.round(1000 * delta / inputTimeScale)} ms.`);
            this.nextAudioPts = nextAudioPts = nextPts = pts;
          }
        } // eslint-disable-line brace-style

        // Insert missing frames if:
        // 1: We're more than maxAudioFramesDrift frame away
        // 2: Not more than MAX_SILENT_FRAME_DURATION away
        // 3: currentTime (aka nextPtsNorm) is not 0
        // 4: remuxing with video (videoTimeOffset !== undefined)
        else if (delta >= maxAudioFramesDrift * inputSampleDuration && duration < MAX_SILENT_FRAME_DURATION && alignedWithVideo) {
          let missing = Math.round(delta / inputSampleDuration);
          // Adjust nextPts so that silent samples are aligned with media pts. This will prevent media samples from
          // later being shifted if nextPts is based on timeOffset and delta is not a multiple of inputSampleDuration.
          nextPts = pts - missing * inputSampleDuration;
          if (nextPts < 0) {
            missing--;
            nextPts += inputSampleDuration;
          }
          if (i === 0) {
            this.nextAudioPts = nextAudioPts = nextPts;
          }
          this.logger.warn(`[mp4-remuxer]: Injecting ${missing} audio frame @ ${(nextPts / inputTimeScale).toFixed(3)}s due to ${Math.round(1000 * delta / inputTimeScale)} ms gap.`);
          for (let j = 0; j < missing; j++) {
            const newStamp = Math.max(nextPts, 0);
            let fillFrame = AAC.getSilentFrame(track.parsedCodec || track.manifestCodec || track.codec, track.channelCount);
            if (!fillFrame) {
              this.logger.log('[mp4-remuxer]: Unable to get silent frame for given audio codec; duplicating last frame instead.');
              fillFrame = sample.unit.subarray();
            }
            inputSamples.splice(i, 0, {
              unit: fillFrame,
              pts: newStamp
            });
            nextPts += inputSampleDuration;
            i++;
          }
        }
        sample.pts = nextPts;
        nextPts += inputSampleDuration;
      }
    }
    let firstPTS = null;
    let lastPTS = null;
    let mdat;
    let mdatSize = 0;
    let sampleLength = inputSamples.length;
    while (sampleLength--) {
      mdatSize += inputSamples[sampleLength].unit.byteLength;
    }
    for (let j = 0, _nbSamples = inputSamples.length; j < _nbSamples; j++) {
      const audioSample = inputSamples[j];
      const unit = audioSample.unit;
      let pts = audioSample.pts;
      if (lastPTS !== null) {
        // If we have more than one sample, set the duration of the sample to the "real" duration; the PTS diff with
        // the previous sample
        const prevSample = outputSamples[j - 1];
        prevSample.duration = Math.round((pts - lastPTS) / scaleFactor);
      } else {
        if (contiguous && track.segmentCodec === 'aac') {
          // set PTS/DTS to expected PTS/DTS
          pts = nextAudioPts;
        }
        // remember first PTS of our audioSamples
        firstPTS = pts;
        if (mdatSize > 0) {
          /* concatenate the audio data and construct the mdat in place
            (need 8 more bytes to fill length and mdat type) */
          mdatSize += offset;
          try {
            mdat = new Uint8Array(mdatSize);
          } catch (err) {
            this.observer.emit(Events.ERROR, Events.ERROR, {
              type: ErrorTypes.MUX_ERROR,
              details: ErrorDetails.REMUX_ALLOC_ERROR,
              fatal: false,
              error: err,
              bytes: mdatSize,
              reason: `fail allocating audio mdat ${mdatSize}`
            });
            return;
          }
          if (!rawMPEG) {
            const view = new DataView(mdat.buffer);
            view.setUint32(0, mdatSize);
            mdat.set(MP4.types.mdat, 4);
          }
        } else {
          // no audio samples
          return;
        }
      }
      mdat.set(unit, offset);
      const unitLen = unit.byteLength;
      offset += unitLen;
      // Default the sample's duration to the computed mp4SampleDuration, which will either be 1024 for AAC or 1152 for MPEG
      // In the case that we have 1 sample, this will be the duration. If we have more than one sample, the duration
      // becomes the PTS diff with the previous sample
      outputSamples.push(createMp4Sample(true, mp4SampleDuration, unitLen, 0));
      lastPTS = pts;
    }

    // We could end up with no audio samples if all input samples were overlapping with the previously remuxed ones
    const nbSamples = outputSamples.length;
    if (!nbSamples) {
      return;
    }

    // The next audio sample PTS should be equal to last sample PTS + duration
    const lastSample = outputSamples[outputSamples.length - 1];
    this.nextAudioPts = nextAudioPts = lastPTS + scaleFactor * lastSample.duration;

    // Set the track samples from inputSamples to outputSamples before remuxing
    const moof = rawMPEG ? new Uint8Array(0) : MP4.moof(track.sequenceNumber++, firstPTS / scaleFactor, _extends({}, track, {
      samples: outputSamples
    }));

    // Clear the track samples. This also clears the samples array in the demuxer, since the reference is shared
    track.samples = [];
    const start = firstPTS / inputTimeScale;
    const end = nextAudioPts / inputTimeScale;
    const type = 'audio';
    const audioData = {
      data1: moof,
      data2: mdat,
      startPTS: start,
      endPTS: end,
      startDTS: start,
      endDTS: end,
      type,
      hasAudio: true,
      hasVideo: false,
      nb: nbSamples
    };
    this.isAudioContiguous = true;
    return audioData;
  }
}
function normalizePts(value, reference) {
  let offset;
  if (reference === null) {
    return value;
  }
  if (reference < value) {
    // - 2^33
    offset = -8589934592;
  } else {
    // + 2^33
    offset = 8589934592;
  }
  /* PTS is 33bit (from 0 to 2^33 -1)
    if diff between value and reference is bigger than half of the amplitude (2^32) then it means that
    PTS looping occured. fill the gap */
  while (Math.abs(value - reference) > 4294967296) {
    value += offset;
  }
  return value;
}
function findKeyframeIndex(samples) {
  for (let i = 0; i < samples.length; i++) {
    if (samples[i].key) {
      return i;
    }
  }
  return -1;
}
function flushTextTrackMetadataCueSamples(track, timeOffset, initPTS, initDTS) {
  const length = track.samples.length;
  if (!length) {
    return;
  }
  const inputTimeScale = track.inputTimeScale;
  for (let index = 0; index < length; index++) {
    const sample = track.samples[index];
    // setting id3 pts, dts to relative time
    // using this._initPTS and this._initDTS to calculate relative time
    sample.pts = normalizePts(sample.pts - initPTS.baseTime * inputTimeScale / initPTS.timescale, timeOffset * inputTimeScale) / inputTimeScale;
    sample.dts = normalizePts(sample.dts - initDTS.baseTime * inputTimeScale / initDTS.timescale, timeOffset * inputTimeScale) / inputTimeScale;
  }
  const samples = track.samples;
  track.samples = [];
  return {
    samples
  };
}
function flushTextTrackUserdataCueSamples(track, timeOffset, initPTS) {
  const length = track.samples.length;
  if (!length) {
    return;
  }
  const inputTimeScale = track.inputTimeScale;
  for (let index = 0; index < length; index++) {
    const sample = track.samples[index];
    // setting text pts, dts to relative time
    // using this._initPTS and this._initDTS to calculate relative time
    sample.pts = normalizePts(sample.pts - initPTS.baseTime * inputTimeScale / initPTS.timescale, timeOffset * inputTimeScale) / inputTimeScale;
  }
  track.samples.sort((a, b) => a.pts - b.pts);
  const samples = track.samples;
  track.samples = [];
  return {
    samples
  };
}

class PassThroughRemuxer {
  constructor(observer, config, typeSupported, logger) {
    this.logger = void 0;
    this.emitInitSegment = false;
    this.audioCodec = void 0;
    this.videoCodec = void 0;
    this.initData = void 0;
    this.initPTS = null;
    this.initTracks = void 0;
    this.lastEndTime = null;
    this.isVideoContiguous = false;
    this.logger = logger;
  }
  destroy() {}
  resetTimeStamp(defaultInitPTS) {
    this.initPTS = defaultInitPTS;
    this.lastEndTime = null;
  }
  resetNextTimestamp() {
    this.isVideoContiguous = false;
    this.lastEndTime = null;
  }
  resetInitSegment(initSegment, audioCodec, videoCodec, decryptdata) {
    this.audioCodec = audioCodec;
    this.videoCodec = videoCodec;
    this.generateInitSegment(patchEncyptionData(initSegment, decryptdata));
    this.emitInitSegment = true;
  }
  generateInitSegment(initSegment) {
    let {
      audioCodec,
      videoCodec
    } = this;
    if (!(initSegment != null && initSegment.byteLength)) {
      this.initTracks = undefined;
      this.initData = undefined;
      return;
    }
    const initData = this.initData = parseInitSegment(initSegment);

    // Get codec from initSegment
    if (initData.audio) {
      audioCodec = getParsedTrackCodec(initData.audio, ElementaryStreamTypes.AUDIO, this.logger);
    }
    if (initData.video) {
      videoCodec = getParsedTrackCodec(initData.video, ElementaryStreamTypes.VIDEO, this.logger);
    }
    const tracks = {};
    if (initData.audio && initData.video) {
      tracks.audiovideo = {
        container: 'video/mp4',
        codec: audioCodec + ',' + videoCodec,
        supplemental: initData.video.supplemental,
        initSegment,
        id: 'main'
      };
    } else if (initData.audio) {
      tracks.audio = {
        container: 'audio/mp4',
        codec: audioCodec,
        initSegment,
        id: 'audio'
      };
    } else if (initData.video) {
      tracks.video = {
        container: 'video/mp4',
        codec: videoCodec,
        supplemental: initData.video.supplemental,
        initSegment,
        id: 'main'
      };
    } else {
      this.logger.warn('[passthrough-remuxer.ts]: initSegment does not contain moov or trak boxes.');
    }
    this.initTracks = tracks;
  }
  remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset) {
    var _initData, _initData2;
    let {
      initPTS,
      lastEndTime
    } = this;
    const result = {
      audio: undefined,
      video: undefined,
      text: textTrack,
      id3: id3Track,
      initSegment: undefined
    };

    // If we haven't yet set a lastEndDTS, or it was reset, set it to the provided timeOffset. We want to use the
    // lastEndDTS over timeOffset whenever possible; during progressive playback, the media source will not update
    // the media duration (which is what timeOffset is provided as) before we need to process the next chunk.
    if (!isFiniteNumber(lastEndTime)) {
      lastEndTime = this.lastEndTime = timeOffset || 0;
    }

    // The binary segment data is added to the videoTrack in the mp4demuxer. We don't check to see if the data is only
    // audio or video (or both); adding it to video was an arbitrary choice.
    const data = videoTrack.samples;
    if (!(data != null && data.length)) {
      return result;
    }
    const initSegment = {
      initPTS: undefined,
      timescale: undefined,
      trackId: undefined
    };
    let initData = this.initData;
    if (!((_initData = initData) != null && _initData.length)) {
      this.generateInitSegment(data);
      initData = this.initData;
    }
    if (!((_initData2 = initData) != null && _initData2.length)) {
      // We can't remux if the initSegment could not be generated
      this.logger.warn('[passthrough-remuxer.ts]: Failed to generate initSegment.');
      return result;
    }
    if (this.emitInitSegment) {
      initSegment.tracks = this.initTracks;
      this.emitInitSegment = false;
    }
    const trackSampleData = getSampleData(data, initData, this.logger);
    const audioSampleTimestamps = initData.audio ? trackSampleData[initData.audio.id] : null;
    const videoSampleTimestamps = initData.video ? trackSampleData[initData.video.id] : null;
    const videoStartTime = toStartEndOrDefault(videoSampleTimestamps, Infinity);
    const audioStartTime = toStartEndOrDefault(audioSampleTimestamps, Infinity);
    const videoEndTime = toStartEndOrDefault(videoSampleTimestamps, 0, true);
    const audioEndTime = toStartEndOrDefault(audioSampleTimestamps, 0, true);
    let baseOffsetSamples;
    let decodeTime = timeOffset;
    let duration = 0;
    if (audioSampleTimestamps && (!videoSampleTimestamps || !initPTS && audioStartTime < videoStartTime || initPTS && initPTS.trackId === initData.audio.id)) {
      initSegment.trackId = initData.audio.id;
      baseOffsetSamples = audioSampleTimestamps;
      duration = audioEndTime - audioStartTime;
    } else if (videoSampleTimestamps) {
      initSegment.trackId = initData.video.id;
      baseOffsetSamples = videoSampleTimestamps;
      duration = videoEndTime - videoStartTime;
    }
    if (baseOffsetSamples) {
      const timescale = baseOffsetSamples.timescale;
      decodeTime = baseOffsetSamples.start / timescale;
      initSegment.timescale = timescale;
      if (!initPTS) {
        initSegment.initPTS = baseOffsetSamples.start - timeOffset * timescale;
        this.initPTS = initPTS = {
          baseTime: initSegment.initPTS,
          timescale,
          trackId: initSegment.trackId
        };
      }
    }
    if ((accurateTimeOffset || !initPTS) && (isInvalidInitPts(initPTS, decodeTime, timeOffset, duration) || initSegment.timescale !== initPTS.timescale)) {
      initSegment.initPTS = decodeTime - timeOffset;
      if (initPTS && initPTS.timescale === 1) {
        this.logger.warn(`Adjusting initPTS @${timeOffset} from ${initPTS.baseTime / initPTS.timescale} to ${initSegment.initPTS}`);
      }
      this.initPTS = initPTS = {
        baseTime: initSegment.initPTS,
        timescale: 1
      };
    }
    const startTime = audioTrack ? decodeTime - initPTS.baseTime / initPTS.timescale : lastEndTime;
    offsetStartDTS(initData, data, initPTS.baseTime / initPTS.timescale);
    const endTime = startTime + duration;
    if (duration > 0) {
      this.lastEndTime = endTime;
    } else {
      this.logger.warn('Duration parsed from mp4 should be greater than zero');
      this.resetNextTimestamp();
    }
    const hasAudio = !!initData.audio;
    const hasVideo = !!initData.video;
    let type = '';
    if (hasAudio) {
      type += 'audio';
    }
    if (hasVideo) {
      type += 'video';
    }
    const track = {
      data1: data,
      startPTS: startTime,
      startDTS: startTime,
      endPTS: endTime,
      endDTS: endTime,
      type,
      hasAudio,
      hasVideo,
      nb: 1,
      dropped: 0
    };
    result.audio = hasAudio && !hasVideo ? track : undefined;
    result.video = hasVideo ? track : undefined;
    const videoSampleCount = videoSampleTimestamps == null ? void 0 : videoSampleTimestamps.sampleCount;
    if (videoSampleCount) {
      const firstKeyFrame = videoSampleTimestamps.keyFrameIndex;
      const independent = firstKeyFrame !== -1;
      track.nb = videoSampleCount;
      track.dropped = firstKeyFrame === 0 || this.isVideoContiguous ? 0 : independent ? firstKeyFrame : videoSampleCount;
      track.independent = independent;
      track.firstKeyFrame = firstKeyFrame;
      if (independent && videoSampleTimestamps.keyFrameStart) {
        track.firstKeyFramePTS = videoSampleTimestamps.keyFrameStart - initPTS.baseTime / initPTS.timescale;
      }
      if (!this.isVideoContiguous) {
        result.independent = independent;
      }
      this.isVideoContiguous || (this.isVideoContiguous = independent);
      if (track.dropped) {
        this.logger.warn(`fmp4 does not start with IDR: firstIDR ${firstKeyFrame}/${videoSampleCount} dropped: ${track.dropped} pts: ${track.firstKeyFramePTS || 'NA'}`);
      }
    }
    result.initSegment = initSegment;
    result.id3 = flushTextTrackMetadataCueSamples(id3Track, timeOffset, initPTS, initPTS);
    if (textTrack.samples.length) {
      result.text = flushTextTrackUserdataCueSamples(textTrack, timeOffset, initPTS);
    }
    return result;
  }
}
function toStartEndOrDefault(trackTimes, defaultValue, end = false) {
  return (trackTimes == null ? void 0 : trackTimes.start) !== undefined ? (trackTimes.start + (end ? trackTimes.duration : 0)) / trackTimes.timescale : defaultValue;
}
function isInvalidInitPts(initPTS, startDTS, timeOffset, duration) {
  if (initPTS === null) {
    return true;
  }
  // InitPTS is invalid when distance from program would be more than segment duration or a minimum of one second
  const minDuration = Math.max(duration, 1);
  const startTime = startDTS - initPTS.baseTime / initPTS.timescale;
  return Math.abs(startTime - timeOffset) > minDuration;
}
function getParsedTrackCodec(track, type, logger) {
  const parsedCodec = track == null ? void 0 : track.codec;
  if (parsedCodec && parsedCodec.length > 4) {
    return parsedCodec;
  }
  if (type === ElementaryStreamTypes.AUDIO) {
    if (parsedCodec === 'ec-3' || parsedCodec === 'ac-3' || parsedCodec === 'alac') {
      return parsedCodec;
    }
    if (parsedCodec === 'fLaC' || parsedCodec === 'Opus') {
      // Opting not to get `preferManagedMediaSource` from player config for isSupported() check for simplicity
      const preferManagedMediaSource = false;
      return getCodecCompatibleName(parsedCodec, preferManagedMediaSource);
    }
    logger.warn(`Unhandled audio codec "${parsedCodec}" in mp4 MAP`);
    return parsedCodec || 'mp4a';
  }
  // Provide defaults based on codec type
  // This allows for some playback of some fmp4 playlists without CODECS defined in manifest
  logger.warn(`Unhandled video codec "${parsedCodec}" in mp4 MAP`);
  return parsedCodec || 'avc1';
}

let now;
// performance.now() not available on WebWorker, at least on Safari Desktop
try {
  now = self.performance.now.bind(self.performance);
} catch (err) {
  now = Date.now;
}
const muxConfig = [{
  demux: MP4Demuxer,
  remux: PassThroughRemuxer
}, {
  demux: TSDemuxer,
  remux: MP4Remuxer
}, {
  demux: AACDemuxer,
  remux: MP4Remuxer
}, {
  demux: MP3Demuxer,
  remux: MP4Remuxer
}];
{
  muxConfig.splice(2, 0, {
    demux: AC3Demuxer,
    remux: MP4Remuxer
  });
}
class Transmuxer {
  constructor(observer, typeSupported, config, vendor, id, logger) {
    this.asyncResult = false;
    this.logger = void 0;
    this.observer = void 0;
    this.typeSupported = void 0;
    this.config = void 0;
    this.id = void 0;
    this.demuxer = void 0;
    this.remuxer = void 0;
    this.decrypter = void 0;
    this.probe = void 0;
    this.decryptionPromise = null;
    this.transmuxConfig = void 0;
    this.currentTransmuxState = void 0;
    this.observer = observer;
    this.typeSupported = typeSupported;
    this.config = config;
    this.id = id;
    this.logger = logger;
  }
  configure(transmuxConfig) {
    this.transmuxConfig = transmuxConfig;
    if (this.decrypter) {
      this.decrypter.reset();
    }
  }
  push(data, decryptdata, chunkMeta, state) {
    const stats = chunkMeta.transmuxing;
    stats.executeStart = now();
    let uintData = new Uint8Array(data);
    const {
      currentTransmuxState,
      transmuxConfig
    } = this;
    if (state) {
      this.currentTransmuxState = state;
    }
    const {
      contiguous,
      discontinuity,
      trackSwitch,
      accurateTimeOffset,
      timeOffset,
      initSegmentChange
    } = state || currentTransmuxState;
    const {
      audioCodec,
      videoCodec,
      defaultInitPts,
      duration,
      initSegmentData
    } = transmuxConfig;
    const keyData = getEncryptionType(uintData, decryptdata);
    if (keyData && isFullSegmentEncryption(keyData.method)) {
      const decrypter = this.getDecrypter();
      const aesMode = getAesModeFromFullSegmentMethod(keyData.method);

      // Software decryption is synchronous; webCrypto is not
      if (decrypter.isSync()) {
        // Software decryption is progressive. Progressive decryption may not return a result on each call. Any cached
        // data is handled in the flush() call
        let decryptedData = decrypter.softwareDecrypt(uintData, keyData.key.buffer, keyData.iv.buffer, aesMode);
        // For Low-Latency HLS Parts, decrypt in place, since part parsing is expected on push progress
        const loadingParts = chunkMeta.part > -1;
        if (loadingParts) {
          const _data = decrypter.flush();
          decryptedData = _data ? _data.buffer : _data;
        }
        if (!decryptedData) {
          stats.executeEnd = now();
          return emptyResult(chunkMeta);
        }
        uintData = new Uint8Array(decryptedData);
      } else {
        this.asyncResult = true;
        this.decryptionPromise = decrypter.webCryptoDecrypt(uintData, keyData.key.buffer, keyData.iv.buffer, aesMode).then(decryptedData => {
          // Calling push here is important; if flush() is called while this is still resolving, this ensures that
          // the decrypted data has been transmuxed
          const result = this.push(decryptedData, null, chunkMeta);
          this.decryptionPromise = null;
          return result;
        });
        return this.decryptionPromise;
      }
    }
    const resetMuxers = this.needsProbing(discontinuity, trackSwitch);
    if (resetMuxers) {
      const error = this.configureTransmuxer(uintData);
      if (error) {
        this.logger.warn(`[transmuxer] ${error.message}`);
        this.observer.emit(Events.ERROR, Events.ERROR, {
          type: ErrorTypes.MEDIA_ERROR,
          details: ErrorDetails.FRAG_PARSING_ERROR,
          fatal: false,
          error,
          reason: error.message
        });
        stats.executeEnd = now();
        return emptyResult(chunkMeta);
      }
    }
    if (discontinuity || trackSwitch || initSegmentChange || resetMuxers) {
      this.resetInitSegment(initSegmentData, audioCodec, videoCodec, duration, decryptdata);
    }
    if (discontinuity || initSegmentChange || resetMuxers) {
      this.resetInitialTimestamp(defaultInitPts);
    }
    if (!contiguous) {
      this.resetContiguity();
    }
    const result = this.transmux(uintData, keyData, timeOffset, accurateTimeOffset, chunkMeta);
    this.asyncResult = hls_isPromise(result);
    const currentState = this.currentTransmuxState;
    currentState.contiguous = true;
    currentState.discontinuity = false;
    currentState.trackSwitch = false;
    stats.executeEnd = now();
    return result;
  }

  // Due to data caching, flush calls can produce more than one TransmuxerResult (hence the Array type)
  flush(chunkMeta) {
    const stats = chunkMeta.transmuxing;
    stats.executeStart = now();
    const {
      decrypter,
      currentTransmuxState,
      decryptionPromise
    } = this;
    if (decryptionPromise) {
      this.asyncResult = true;
      // Upon resolution, the decryption promise calls push() and returns its TransmuxerResult up the stack. Therefore
      // only flushing is required for async decryption
      return decryptionPromise.then(() => {
        return this.flush(chunkMeta);
      });
    }
    const transmuxResults = [];
    const {
      timeOffset
    } = currentTransmuxState;
    if (decrypter) {
      // The decrypter may have data cached, which needs to be demuxed. In this case we'll have two TransmuxResults
      // This happens in the case that we receive only 1 push call for a segment (either for non-progressive downloads,
      // or for progressive downloads with small segments)
      const decryptedData = decrypter.flush();
      if (decryptedData) {
        // Push always returns a TransmuxerResult if decryptdata is null
        transmuxResults.push(this.push(decryptedData.buffer, null, chunkMeta));
      }
    }
    const {
      demuxer,
      remuxer
    } = this;
    if (!demuxer || !remuxer) {
      // If probing failed, then Hls.js has been given content its not able to handle
      stats.executeEnd = now();
      const emptyResults = [emptyResult(chunkMeta)];
      if (this.asyncResult) {
        return Promise.resolve(emptyResults);
      }
      return emptyResults;
    }
    const demuxResultOrPromise = demuxer.flush(timeOffset);
    if (hls_isPromise(demuxResultOrPromise)) {
      this.asyncResult = true;
      // Decrypt final SAMPLE-AES samples
      return demuxResultOrPromise.then(demuxResult => {
        this.flushRemux(transmuxResults, demuxResult, chunkMeta);
        return transmuxResults;
      });
    }
    this.flushRemux(transmuxResults, demuxResultOrPromise, chunkMeta);
    if (this.asyncResult) {
      return Promise.resolve(transmuxResults);
    }
    return transmuxResults;
  }
  flushRemux(transmuxResults, demuxResult, chunkMeta) {
    const {
      audioTrack,
      videoTrack,
      id3Track,
      textTrack
    } = demuxResult;
    const {
      accurateTimeOffset,
      timeOffset
    } = this.currentTransmuxState;
    this.logger.log(`[transmuxer.ts]: Flushed ${this.id} sn: ${chunkMeta.sn}${chunkMeta.part > -1 ? ' part: ' + chunkMeta.part : ''} of ${this.id === PlaylistLevelType.MAIN ? 'level' : 'track'} ${chunkMeta.level}`);
    const remuxResult = this.remuxer.remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset, true, this.id);
    transmuxResults.push({
      remuxResult,
      chunkMeta
    });
    chunkMeta.transmuxing.executeEnd = now();
  }
  resetInitialTimestamp(defaultInitPts) {
    const {
      demuxer,
      remuxer
    } = this;
    if (!demuxer || !remuxer) {
      return;
    }
    demuxer.resetTimeStamp(defaultInitPts);
    remuxer.resetTimeStamp(defaultInitPts);
  }
  resetContiguity() {
    const {
      demuxer,
      remuxer
    } = this;
    if (!demuxer || !remuxer) {
      return;
    }
    demuxer.resetContiguity();
    remuxer.resetNextTimestamp();
  }
  resetInitSegment(initSegmentData, audioCodec, videoCodec, trackDuration, decryptdata) {
    const {
      demuxer,
      remuxer
    } = this;
    if (!demuxer || !remuxer) {
      return;
    }
    demuxer.resetInitSegment(initSegmentData, audioCodec, videoCodec, trackDuration);
    remuxer.resetInitSegment(initSegmentData, audioCodec, videoCodec, decryptdata);
  }
  destroy() {
    if (this.demuxer) {
      this.demuxer.destroy();
      this.demuxer = undefined;
    }
    if (this.remuxer) {
      this.remuxer.destroy();
      this.remuxer = undefined;
    }
  }
  transmux(data, keyData, timeOffset, accurateTimeOffset, chunkMeta) {
    let result;
    if (keyData && keyData.method === 'SAMPLE-AES') {
      result = this.transmuxSampleAes(data, keyData, timeOffset, accurateTimeOffset, chunkMeta);
    } else {
      result = this.transmuxUnencrypted(data, timeOffset, accurateTimeOffset, chunkMeta);
    }
    return result;
  }
  transmuxUnencrypted(data, timeOffset, accurateTimeOffset, chunkMeta) {
    const {
      audioTrack,
      videoTrack,
      id3Track,
      textTrack
    } = this.demuxer.demux(data, timeOffset, false, !this.config.progressive);
    const remuxResult = this.remuxer.remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset, false, this.id);
    return {
      remuxResult,
      chunkMeta
    };
  }
  transmuxSampleAes(data, decryptData, timeOffset, accurateTimeOffset, chunkMeta) {
    return this.demuxer.demuxSampleAes(data, decryptData, timeOffset).then(demuxResult => {
      const remuxResult = this.remuxer.remux(demuxResult.audioTrack, demuxResult.videoTrack, demuxResult.id3Track, demuxResult.textTrack, timeOffset, accurateTimeOffset, false, this.id);
      return {
        remuxResult,
        chunkMeta
      };
    });
  }
  configureTransmuxer(data) {
    const {
      config,
      observer,
      typeSupported
    } = this;
    // probe for content type
    let mux;
    for (let i = 0, len = muxConfig.length; i < len; i++) {
      var _muxConfig$i$demux;
      if ((_muxConfig$i$demux = muxConfig[i].demux) != null && _muxConfig$i$demux.probe(data, this.logger)) {
        mux = muxConfig[i];
        break;
      }
    }
    if (!mux) {
      return new Error('Failed to find demuxer by probing fragment data');
    }
    // so let's check that current remuxer and demuxer are still valid
    const demuxer = this.demuxer;
    const remuxer = this.remuxer;
    const Remuxer = mux.remux;
    const Demuxer = mux.demux;
    if (!remuxer || !(remuxer instanceof Remuxer)) {
      this.remuxer = new Remuxer(observer, config, typeSupported, this.logger);
    }
    if (!demuxer || !(demuxer instanceof Demuxer)) {
      this.demuxer = new Demuxer(observer, config, typeSupported, this.logger);
      this.probe = Demuxer.probe;
    }
  }
  needsProbing(discontinuity, trackSwitch) {
    // in case of continuity change, or track switch
    // we might switch from content type (AAC container to TS container, or TS to fmp4 for example)
    return !this.demuxer || !this.remuxer || discontinuity || trackSwitch;
  }
  getDecrypter() {
    let decrypter = this.decrypter;
    if (!decrypter) {
      decrypter = this.decrypter = new Decrypter(this.config);
    }
    return decrypter;
  }
}
function getEncryptionType(data, decryptData) {
  let encryptionType = null;
  if (data.byteLength > 0 && (decryptData == null ? void 0 : decryptData.key) != null && decryptData.iv !== null && decryptData.method != null) {
    encryptionType = decryptData;
  }
  return encryptionType;
}
const emptyResult = chunkMeta => ({
  remuxResult: {},
  chunkMeta
});
function hls_isPromise(p) {
  return 'then' in p && p.then instanceof Function;
}
class TransmuxConfig {
  constructor(audioCodec, videoCodec, initSegmentData, duration, defaultInitPts) {
    this.audioCodec = void 0;
    this.videoCodec = void 0;
    this.initSegmentData = void 0;
    this.duration = void 0;
    this.defaultInitPts = void 0;
    this.audioCodec = audioCodec;
    this.videoCodec = videoCodec;
    this.initSegmentData = initSegmentData;
    this.duration = duration;
    this.defaultInitPts = defaultInitPts || null;
  }
}
class TransmuxState {
  constructor(discontinuity, contiguous, accurateTimeOffset, trackSwitch, timeOffset, initSegmentChange) {
    this.discontinuity = void 0;
    this.contiguous = void 0;
    this.accurateTimeOffset = void 0;
    this.trackSwitch = void 0;
    this.timeOffset = void 0;
    this.initSegmentChange = void 0;
    this.discontinuity = discontinuity;
    this.contiguous = contiguous;
    this.accurateTimeOffset = accurateTimeOffset;
    this.trackSwitch = trackSwitch;
    this.timeOffset = timeOffset;
    this.initSegmentChange = initSegmentChange;
  }
}

let transmuxerInstanceCount = 0;
class TransmuxerInterface {
  constructor(_hls, id, onTransmuxComplete, onFlush) {
    this.error = null;
    this.hls = void 0;
    this.id = void 0;
    this.instanceNo = transmuxerInstanceCount++;
    this.observer = void 0;
    this.frag = null;
    this.part = null;
    this.useWorker = void 0;
    this.workerContext = null;
    this.transmuxer = null;
    this.onTransmuxComplete = void 0;
    this.onFlush = void 0;
    this.onWorkerMessage = event => {
      const data = event.data;
      const hls = this.hls;
      if (!hls || !(data != null && data.event) || data.instanceNo !== this.instanceNo) {
        return;
      }
      switch (data.event) {
        case 'init':
          {
            var _this$workerContext;
            const objectURL = (_this$workerContext = this.workerContext) == null ? void 0 : _this$workerContext.objectURL;
            if (objectURL) {
              // revoke the Object URL that was used to create transmuxer worker, so as not to leak it
              self.URL.revokeObjectURL(objectURL);
            }
            break;
          }
        case 'transmuxComplete':
          {
            this.handleTransmuxComplete(data.data);
            break;
          }
        case 'flush':
          {
            this.onFlush(data.data);
            break;
          }

        // pass logs from the worker thread to the main logger
        case 'workerLog':
          {
            if (hls.logger[data.data.logType]) {
              hls.logger[data.data.logType](data.data.message);
            }
            break;
          }
        default:
          {
            data.data = data.data || {};
            data.data.frag = this.frag;
            data.data.part = this.part;
            data.data.id = this.id;
            hls.trigger(data.event, data.data);
            break;
          }
      }
    };
    this.onWorkerError = event => {
      if (!this.hls) {
        return;
      }
      const error = new Error(`${event.message}  (${event.filename}:${event.lineno})`);
      this.hls.config.enableWorker = false;
      this.hls.logger.warn(`Error in "${this.id}" Web Worker, fallback to inline`);
      this.hls.trigger(Events.ERROR, {
        type: ErrorTypes.OTHER_ERROR,
        details: ErrorDetails.INTERNAL_EXCEPTION,
        fatal: false,
        event: 'demuxerWorker',
        error
      });
    };
    const config = _hls.config;
    this.hls = _hls;
    this.id = id;
    this.useWorker = !!config.enableWorker;
    this.onTransmuxComplete = onTransmuxComplete;
    this.onFlush = onFlush;
    const forwardMessage = (ev, data) => {
      data = data || {};
      data.frag = this.frag || undefined;
      if (ev === Events.ERROR) {
        data = data;
        data.parent = this.id;
        data.part = this.part;
        this.error = data.error;
      }
      this.hls.trigger(ev, data);
    };

    // forward events to main thread
    this.observer = new hls_EventEmitter();
    this.observer.on(Events.FRAG_DECRYPTED, forwardMessage);
    this.observer.on(Events.ERROR, forwardMessage);
    const m2tsTypeSupported = getM2TSSupportedAudioTypes(config.preferManagedMediaSource);
    if (this.useWorker && typeof Worker !== 'undefined') {
      const logger = this.hls.logger;
      const canCreateWorker = config.workerPath || hasUMDWorker();
      if (canCreateWorker) {
        try {
          if (config.workerPath) {
            logger.log(`loading Web Worker ${config.workerPath} for "${id}"`);
            this.workerContext = loadWorker(config.workerPath);
          } else {
            logger.log(`injecting Web Worker for "${id}"`);
            this.workerContext = injectWorker();
          }
          const {
            worker
          } = this.workerContext;
          worker.addEventListener('message', this.onWorkerMessage);
          worker.addEventListener('error', this.onWorkerError);
          worker.postMessage({
            instanceNo: this.instanceNo,
            cmd: 'init',
            typeSupported: m2tsTypeSupported,
            id,
            config: hls_stringify(config)
          });
        } catch (err) {
          logger.warn(`Error setting up "${id}" Web Worker, fallback to inline`, err);
          this.terminateWorker();
          this.error = null;
          this.transmuxer = new Transmuxer(this.observer, m2tsTypeSupported, config, '', id, _hls.logger);
        }
        return;
      }
    }
    this.transmuxer = new Transmuxer(this.observer, m2tsTypeSupported, config, '', id, _hls.logger);
  }
  reset() {
    this.frag = null;
    this.part = null;
    if (this.workerContext) {
      const instanceNo = this.instanceNo;
      this.instanceNo = transmuxerInstanceCount++;
      const config = this.hls.config;
      const m2tsTypeSupported = getM2TSSupportedAudioTypes(config.preferManagedMediaSource);
      this.workerContext.worker.postMessage({
        instanceNo: this.instanceNo,
        cmd: 'reset',
        resetNo: instanceNo,
        typeSupported: m2tsTypeSupported,
        id: this.id,
        config: hls_stringify(config)
      });
    }
  }
  terminateWorker() {
    if (this.workerContext) {
      const {
        worker
      } = this.workerContext;
      this.workerContext = null;
      worker.removeEventListener('message', this.onWorkerMessage);
      worker.removeEventListener('error', this.onWorkerError);
      removeWorkerFromStore(this.hls.config.workerPath);
    }
  }
  destroy() {
    if (this.workerContext) {
      this.terminateWorker();
      // @ts-ignore
      this.onWorkerMessage = this.onWorkerError = null;
    } else {
      const transmuxer = this.transmuxer;
      if (transmuxer) {
        transmuxer.destroy();
        this.transmuxer = null;
      }
    }
    const observer = this.observer;
    if (observer) {
      observer.removeAllListeners();
    }
    this.frag = null;
    this.part = null;
    // @ts-ignore
    this.observer = null;
    // @ts-ignore
    this.hls = null;
  }
  push(data, initSegmentData, audioCodec, videoCodec, frag, part, duration, accurateTimeOffset, chunkMeta, defaultInitPTS) {
    var _frag$initSegment, _lastFrag$initSegment;
    chunkMeta.transmuxing.start = self.performance.now();
    const {
      instanceNo,
      transmuxer
    } = this;
    const timeOffset = part ? part.start : frag.start;
    // TODO: push "clear-lead" decrypt data for unencrypted fragments in streams with encrypted ones
    const decryptdata = frag.decryptdata;
    const lastFrag = this.frag;
    const discontinuity = !(lastFrag && frag.cc === lastFrag.cc);
    const trackSwitch = !(lastFrag && chunkMeta.level === lastFrag.level);
    const snDiff = lastFrag ? chunkMeta.sn - lastFrag.sn : -1;
    const partDiff = this.part ? chunkMeta.part - this.part.index : -1;
    const progressive = snDiff === 0 && chunkMeta.id > 1 && chunkMeta.id === (lastFrag == null ? void 0 : lastFrag.stats.chunkCount);
    const contiguous = !trackSwitch && (snDiff === 1 || snDiff === 0 && (partDiff === 1 || progressive && partDiff <= 0));
    const now = self.performance.now();
    if (trackSwitch || snDiff || frag.stats.parsing.start === 0) {
      frag.stats.parsing.start = now;
    }
    if (part && (partDiff || !contiguous)) {
      part.stats.parsing.start = now;
    }
    const initSegmentChange = !(lastFrag && ((_frag$initSegment = frag.initSegment) == null ? void 0 : _frag$initSegment.url) === ((_lastFrag$initSegment = lastFrag.initSegment) == null ? void 0 : _lastFrag$initSegment.url));
    const state = new TransmuxState(discontinuity, contiguous, accurateTimeOffset, trackSwitch, timeOffset, initSegmentChange);
    if (!contiguous || discontinuity || initSegmentChange) {
      this.hls.logger.log(`[transmuxer-interface]: Starting new transmux session for ${frag.type} sn: ${chunkMeta.sn}${chunkMeta.part > -1 ? ' part: ' + chunkMeta.part : ''} ${this.id === PlaylistLevelType.MAIN ? 'level' : 'track'}: ${chunkMeta.level} id: ${chunkMeta.id}
        discontinuity: ${discontinuity}
        trackSwitch: ${trackSwitch}
        contiguous: ${contiguous}
        accurateTimeOffset: ${accurateTimeOffset}
        timeOffset: ${timeOffset}
        initSegmentChange: ${initSegmentChange}`);
      const config = new TransmuxConfig(audioCodec, videoCodec, initSegmentData, duration, defaultInitPTS);
      this.configureTransmuxer(config);
    }
    this.frag = frag;
    this.part = part;

    // Frags with sn of 'initSegment' are not transmuxed
    if (this.workerContext) {
      // post fragment payload as transferable objects for ArrayBuffer (no copy)
      this.workerContext.worker.postMessage({
        instanceNo,
        cmd: 'demux',
        data,
        decryptdata,
        chunkMeta,
        state
      }, data instanceof ArrayBuffer ? [data] : []);
    } else if (transmuxer) {
      const transmuxResult = transmuxer.push(data, decryptdata, chunkMeta, state);
      if (hls_isPromise(transmuxResult)) {
        transmuxResult.then(data => {
          this.handleTransmuxComplete(data);
        }).catch(error => {
          this.transmuxerError(error, chunkMeta, 'transmuxer-interface push error');
        });
      } else {
        this.handleTransmuxComplete(transmuxResult);
      }
    }
  }
  flush(chunkMeta) {
    chunkMeta.transmuxing.start = self.performance.now();
    const {
      instanceNo,
      transmuxer
    } = this;
    if (this.workerContext) {
      this.workerContext.worker.postMessage({
        instanceNo,
        cmd: 'flush',
        chunkMeta
      });
    } else if (transmuxer) {
      const transmuxResult = transmuxer.flush(chunkMeta);
      if (hls_isPromise(transmuxResult)) {
        transmuxResult.then(data => {
          this.handleFlushResult(data, chunkMeta);
        }).catch(error => {
          this.transmuxerError(error, chunkMeta, 'transmuxer-interface flush error');
        });
      } else {
        this.handleFlushResult(transmuxResult, chunkMeta);
      }
    }
  }
  transmuxerError(error, chunkMeta, reason) {
    if (!this.hls) {
      return;
    }
    this.error = error;
    this.hls.trigger(Events.ERROR, {
      type: ErrorTypes.MEDIA_ERROR,
      details: ErrorDetails.FRAG_PARSING_ERROR,
      chunkMeta,
      frag: this.frag || undefined,
      part: this.part || undefined,
      fatal: false,
      error,
      err: error,
      reason
    });
  }
  handleFlushResult(results, chunkMeta) {
    results.forEach(result => {
      this.handleTransmuxComplete(result);
    });
    this.onFlush(chunkMeta);
  }
  configureTransmuxer(config) {
    const {
      instanceNo,
      transmuxer
    } = this;
    if (this.workerContext) {
      this.workerContext.worker.postMessage({
        instanceNo,
        cmd: 'configure',
        config
      });
    } else if (transmuxer) {
      transmuxer.configure(config);
    }
  }
  handleTransmuxComplete(result) {
    result.chunkMeta.transmuxing.end = self.performance.now();
    this.onTransmuxComplete(result);
  }
}

const TICK_INTERVAL$3 = 100; // how often to tick in ms

class AudioStreamController extends BaseStreamController {
  constructor(hls, fragmentTracker, keyLoader) {
    super(hls, fragmentTracker, keyLoader, 'audio-stream-controller', PlaylistLevelType.AUDIO);
    this.mainAnchor = null;
    this.mainFragLoading = null;
    this.audioOnly = false;
    this.bufferedTrack = null;
    this.switchingTrack = null;
    this.trackId = -1;
    this.waitingData = null;
    this.mainDetails = null;
    this.flushing = false;
    this.bufferFlushed = false;
    this.cachedTrackLoadedData = null;
    this.registerListeners();
  }
  onHandlerDestroying() {
    this.unregisterListeners();
    super.onHandlerDestroying();
    this.resetItem();
  }
  resetItem() {
    this.mainDetails = this.mainAnchor = this.mainFragLoading = this.bufferedTrack = this.switchingTrack = this.waitingData = this.cachedTrackLoadedData = null;
  }
  registerListeners() {
    super.registerListeners();
    const {
      hls
    } = this;
    hls.on(Events.LEVEL_LOADED, this.onLevelLoaded, this);
    hls.on(Events.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this);
    hls.on(Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
    hls.on(Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this);
    hls.on(Events.BUFFER_RESET, this.onBufferReset, this);
    hls.on(Events.BUFFER_CREATED, this.onBufferCreated, this);
    hls.on(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
    hls.on(Events.BUFFER_FLUSHED, this.onBufferFlushed, this);
    hls.on(Events.INIT_PTS_FOUND, this.onInitPtsFound, this);
    hls.on(Events.FRAG_LOADING, this.onFragLoading, this);
    hls.on(Events.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  unregisterListeners() {
    const {
      hls
    } = this;
    if (!hls) {
      return;
    }
    super.unregisterListeners();
    hls.off(Events.LEVEL_LOADED, this.onLevelLoaded, this);
    hls.off(Events.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this);
    hls.off(Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
    hls.off(Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this);
    hls.off(Events.BUFFER_RESET, this.onBufferReset, this);
    hls.off(Events.BUFFER_CREATED, this.onBufferCreated, this);
    hls.off(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
    hls.off(Events.BUFFER_FLUSHED, this.onBufferFlushed, this);
    hls.off(Events.INIT_PTS_FOUND, this.onInitPtsFound, this);
    hls.off(Events.FRAG_LOADING, this.onFragLoading, this);
    hls.off(Events.FRAG_BUFFERED, this.onFragBuffered, this);
  }

  // INIT_PTS_FOUND is triggered when the video track parsed in the stream-controller has a new PTS value
  onInitPtsFound(event, {
    frag,
    id,
    initPTS,
    timescale
  }) {
    // Always update the new INIT PTS
    // Can change due level switch
    if (id === PlaylistLevelType.MAIN) {
      const cc = frag.cc;
      const inFlightFrag = this.fragCurrent;
      this.initPTS[cc] = {
        baseTime: initPTS,
        timescale
      };
      this.log(`InitPTS for cc: ${cc} found from main: ${initPTS}/${timescale}`);
      this.mainAnchor = frag;
      // If we are waiting, tick immediately to unblock audio fragment transmuxing
      if (this.state === State.WAITING_INIT_PTS) {
        const waitingData = this.waitingData;
        if (!waitingData && !this.loadingParts || waitingData && waitingData.frag.cc !== cc) {
          this.syncWithAnchor(frag, waitingData == null ? void 0 : waitingData.frag);
        }
      } else if (!this.hls.hasEnoughToStart && inFlightFrag && inFlightFrag.cc !== cc) {
        inFlightFrag.abortRequests();
        this.syncWithAnchor(frag, inFlightFrag);
      } else if (this.state === State.IDLE) {
        this.tick();
      }
    }
  }
  getLoadPosition() {
    if (!this.startFragRequested && this.nextLoadPosition >= 0) {
      return this.nextLoadPosition;
    }
    return super.getLoadPosition();
  }
  syncWithAnchor(mainAnchor, waitingToAppend) {
    var _this$mainFragLoading;
    // Drop waiting fragment if videoTrackCC has changed since waitingFragment was set and initPTS was not found
    const mainFragLoading = ((_this$mainFragLoading = this.mainFragLoading) == null ? void 0 : _this$mainFragLoading.frag) || null;
    if (waitingToAppend) {
      if ((mainFragLoading == null ? void 0 : mainFragLoading.cc) === waitingToAppend.cc) {
        // Wait for loading frag to complete and INIT_PTS_FOUND
        return;
      }
    }
    const targetDiscontinuity = (mainFragLoading || mainAnchor).cc;
    const trackDetails = this.getLevelDetails();
    const pos = this.getLoadPosition();
    const syncFrag = findNearestWithCC(trackDetails, targetDiscontinuity, pos);
    // Only stop waiting for audioFrag.cc if an audio segment of the same discontinuity domain (cc) is found
    if (syncFrag) {
      this.log(`Waiting fragment cc (${waitingToAppend == null ? void 0 : waitingToAppend.cc}) cancelled because video is at cc ${mainAnchor.cc}`);
      this.startFragRequested = false;
      this.nextLoadPosition = syncFrag.start;
      this.resetLoadingState();
      if (this.state === State.IDLE) {
        this.doTickIdle();
      }
    }
  }
  startLoad(startPosition, skipSeekToStartPosition) {
    if (!this.levels) {
      this.startPosition = startPosition;
      this.state = State.STOPPED;
      return;
    }
    const lastCurrentTime = this.lastCurrentTime;
    this.stopLoad();
    this.setInterval(TICK_INTERVAL$3);
    if (lastCurrentTime > 0 && startPosition === -1) {
      this.log(`Override startPosition with lastCurrentTime @${lastCurrentTime.toFixed(3)}`);
      startPosition = lastCurrentTime;
      this.state = State.IDLE;
    } else {
      this.state = State.WAITING_TRACK;
    }
    this.nextLoadPosition = this.lastCurrentTime = startPosition + this.timelineOffset;
    this.startPosition = skipSeekToStartPosition ? -1 : startPosition;
    this.tick();
  }
  doTick() {
    switch (this.state) {
      case State.IDLE:
        this.doTickIdle();
        break;
      case State.WAITING_TRACK:
        {
          const {
            levels,
            trackId
          } = this;
          const currenTrack = levels == null ? void 0 : levels[trackId];
          const details = currenTrack == null ? void 0 : currenTrack.details;
          if (details && !this.waitForLive(currenTrack)) {
            if (this.waitForCdnTuneIn(details)) {
              break;
            }
            this.state = State.WAITING_INIT_PTS;
          }
          break;
        }
      case State.FRAG_LOADING_WAITING_RETRY:
        {
          var _this$media;
          const now = performance.now();
          const retryDate = this.retryDate;
          // if current time is gt than retryDate, or if media seeking let's switch to IDLE state to retry loading
          if (!retryDate || now >= retryDate || (_this$media = this.media) != null && _this$media.seeking) {
            const {
              levels,
              trackId
            } = this;
            this.log('RetryDate reached, switch back to IDLE state');
            this.resetStartWhenNotLoaded((levels == null ? void 0 : levels[trackId]) || null);
            this.state = State.IDLE;
          }
          break;
        }
      case State.WAITING_INIT_PTS:
        {
          // Ensure we don't get stuck in the WAITING_INIT_PTS state if the waiting frag CC doesn't match any initPTS
          const waitingData = this.waitingData;
          if (waitingData) {
            const {
              frag,
              part,
              cache,
              complete
            } = waitingData;
            const mainAnchor = this.mainAnchor;
            if (this.initPTS[frag.cc] !== undefined) {
              this.waitingData = null;
              this.state = State.FRAG_LOADING;
              const payload = cache.flush().buffer;
              const data = {
                frag,
                part,
                payload,
                networkDetails: null
              };
              this._handleFragmentLoadProgress(data);
              if (complete) {
                super._handleFragmentLoadComplete(data);
              }
            } else if (mainAnchor && mainAnchor.cc !== waitingData.frag.cc) {
              this.syncWithAnchor(mainAnchor, waitingData.frag);
            }
          } else {
            this.state = State.IDLE;
          }
        }
    }
    this.onTickEnd();
  }
  resetLoadingState() {
    const waitingData = this.waitingData;
    if (waitingData) {
      this.fragmentTracker.removeFragment(waitingData.frag);
      this.waitingData = null;
    }
    super.resetLoadingState();
  }
  onTickEnd() {
    const {
      media
    } = this;
    if (!(media != null && media.readyState)) {
      // Exit early if we don't have media or if the media hasn't buffered anything yet (readyState 0)
      return;
    }
    this.lastCurrentTime = media.currentTime;
  }
  doTickIdle() {
    var _this$mainFragLoading2;
    const {
      hls,
      levels,
      media,
      trackId
    } = this;
    const config = hls.config;

    // 1. if buffering is suspended
    // 2. if video not attached AND
    //    start fragment already requested OR start frag prefetch not enabled
    // 3. if tracks or track not loaded and selected
    // then exit loop
    // => if media not attached but start frag prefetch is enabled and start frag not requested yet, we will not exit loop
    if (!this.buffering || !media && !this.primaryPrefetch && (this.startFragRequested || !config.startFragPrefetch) || !(levels != null && levels[trackId])) {
      return;
    }
    const levelInfo = levels[trackId];
    const trackDetails = levelInfo.details;
    if (!trackDetails || this.waitForLive(levelInfo) || this.waitForCdnTuneIn(trackDetails)) {
      this.state = State.WAITING_TRACK;
      this.startFragRequested = false;
      return;
    }
    const bufferable = this.mediaBuffer ? this.mediaBuffer : this.media;
    if (this.bufferFlushed && bufferable) {
      this.bufferFlushed = false;
      this.afterBufferFlushed(bufferable, ElementaryStreamTypes.AUDIO, PlaylistLevelType.AUDIO);
    }
    const bufferInfo = this.getFwdBufferInfo(bufferable, PlaylistLevelType.AUDIO);
    if (bufferInfo === null) {
      return;
    }
    if (!this.switchingTrack && this._streamEnded(bufferInfo, trackDetails)) {
      hls.trigger(Events.BUFFER_EOS, {
        type: 'audio'
      });
      this.state = State.ENDED;
      return;
    }
    const bufferLen = bufferInfo.len;
    const maxBufLen = hls.maxBufferLength;
    const fragments = trackDetails.fragments;
    const start = fragments[0].start;
    const loadPosition = this.getLoadPosition();
    const targetBufferTime = this.flushing ? loadPosition : bufferInfo.end;
    if (this.switchingTrack && media) {
      const pos = loadPosition;
      // if currentTime (pos) is less than alt audio playlist start time, it means that alt audio is ahead of currentTime
      if (trackDetails.PTSKnown && pos < start) {
        // if everything is buffered from pos to start or if audio buffer upfront, let's seek to start
        if (bufferInfo.end > start || bufferInfo.nextStart) {
          this.log('Alt audio track ahead of main track, seek to start of alt audio track');
          media.currentTime = start + 0.05;
        }
      }
    }

    // if buffer length is less than maxBufLen, or near the end, find a fragment to load
    if (bufferLen >= maxBufLen && !this.switchingTrack && targetBufferTime < fragments[fragments.length - 1].start) {
      return;
    }
    let frag = this.getNextFragment(targetBufferTime, trackDetails);
    // Avoid loop loading by using nextLoadPosition set for backtracking and skipping consecutive GAP tags
    if (frag && this.isLoopLoading(frag, targetBufferTime)) {
      frag = this.getNextFragmentLoopLoading(frag, trackDetails, bufferInfo, PlaylistLevelType.MAIN, maxBufLen);
    }
    if (!frag) {
      this.bufferFlushed = true;
      return;
    }

    // Request audio segments up to one fragment ahead of main stream-controller
    let mainFragLoading = ((_this$mainFragLoading2 = this.mainFragLoading) == null ? void 0 : _this$mainFragLoading2.frag) || null;
    if (!this.audioOnly && this.startFragRequested && mainFragLoading && isMediaFragment(frag) && !frag.endList && (!trackDetails.live || !this.loadingParts && targetBufferTime < this.hls.liveSyncPosition)) {
      if (this.fragmentTracker.getState(mainFragLoading) === FragmentState.OK) {
        this.mainFragLoading = mainFragLoading = null;
      }
      if (mainFragLoading && isMediaFragment(mainFragLoading)) {
        if (frag.start > mainFragLoading.end) {
          // Get buffered frag at target position from tracker (loaded out of sequence)
          const mainFragAtPos = this.fragmentTracker.getFragAtPos(targetBufferTime, PlaylistLevelType.MAIN);
          if (mainFragAtPos && mainFragAtPos.end > mainFragLoading.end) {
            mainFragLoading = mainFragAtPos;
            this.mainFragLoading = {
              frag: mainFragAtPos,
              targetBufferTime: null
            };
          }
        }
        const atBufferSyncLimit = frag.start > mainFragLoading.end;
        if (atBufferSyncLimit) {
          return;
        }
      }
    }
    this.loadFragment(frag, levelInfo, targetBufferTime);
  }
  onMediaDetaching(event, data) {
    this.bufferFlushed = this.flushing = false;
    super.onMediaDetaching(event, data);
  }
  onAudioTracksUpdated(event, {
    audioTracks
  }) {
    // Reset tranxmuxer is essential for large context switches (Content Steering)
    this.resetTransmuxer();
    this.levels = audioTracks.map(mediaPlaylist => new Level(mediaPlaylist));
  }
  onAudioTrackSwitching(event, data) {
    // if any URL found on new audio track, it is an alternate audio track
    const altAudio = !!data.url;
    this.trackId = data.id;
    const {
      fragCurrent
    } = this;
    if (fragCurrent) {
      fragCurrent.abortRequests();
      this.removeUnbufferedFrags(fragCurrent.start);
    }
    this.resetLoadingState();

    // should we switch tracks ?
    if (altAudio) {
      this.switchingTrack = data;
      // main audio track are handled by stream-controller, just do something if switching to alt audio track
      this.flushAudioIfNeeded(data);
      if (this.state !== State.STOPPED) {
        // switching to audio track, start timer if not already started
        this.setInterval(TICK_INTERVAL$3);
        this.state = State.IDLE;
        this.tick();
      }
    } else {
      // destroy useless transmuxer when switching audio to main
      this.resetTransmuxer();
      this.switchingTrack = null;
      this.bufferedTrack = data;
      this.clearInterval();
    }
  }
  onManifestLoading() {
    super.onManifestLoading();
    this.bufferFlushed = this.flushing = this.audioOnly = false;
    this.resetItem();
    this.trackId = -1;
  }
  onLevelLoaded(event, data) {
    this.mainDetails = data.details;
    const cachedTrackLoadedData = this.cachedTrackLoadedData;
    if (cachedTrackLoadedData) {
      this.cachedTrackLoadedData = null;
      this.onAudioTrackLoaded(Events.AUDIO_TRACK_LOADED, cachedTrackLoadedData);
    }
  }
  onAudioTrackLoaded(event, data) {
    var _trackLevel$details;
    const {
      levels
    } = this;
    const {
      details: newDetails,
      id: trackId,
      groupId,
      track
    } = data;
    if (!levels) {
      this.warn(`Audio tracks reset while loading track ${trackId} "${track.name}" of "${groupId}"`);
      return;
    }
    const mainDetails = this.mainDetails;
    if (!mainDetails || newDetails.endCC > mainDetails.endCC || mainDetails.expired) {
      this.cachedTrackLoadedData = data;
      if (this.state !== State.STOPPED) {
        this.state = State.WAITING_TRACK;
      }
      return;
    }
    this.cachedTrackLoadedData = null;
    this.log(`Audio track ${trackId} "${track.name}" of "${groupId}" loaded [${newDetails.startSN},${newDetails.endSN}]${newDetails.lastPartSn ? `[part-${newDetails.lastPartSn}-${newDetails.lastPartIndex}]` : ''},duration:${newDetails.totalduration}`);
    const trackLevel = levels[trackId];
    let sliding = 0;
    if (newDetails.live || (_trackLevel$details = trackLevel.details) != null && _trackLevel$details.live) {
      this.checkLiveUpdate(newDetails);
      if (newDetails.deltaUpdateFailed) {
        return;
      }
      if (trackLevel.details) {
        var _this$levelLastLoaded;
        sliding = this.alignPlaylists(newDetails, trackLevel.details, (_this$levelLastLoaded = this.levelLastLoaded) == null ? void 0 : _this$levelLastLoaded.details);
      }
      if (!newDetails.alignedSliding) {
        // Align audio rendition with the "main" playlist on discontinuity change
        // or program-date-time (PDT)
        alignDiscontinuities(newDetails, mainDetails);
        if (!newDetails.alignedSliding) {
          alignMediaPlaylistByPDT(newDetails, mainDetails);
        }
        sliding = newDetails.fragmentStart;
      }
    }
    trackLevel.details = newDetails;
    this.levelLastLoaded = trackLevel;

    // compute start position if we are aligned with the main playlist
    if (!this.startFragRequested) {
      this.setStartPosition(mainDetails, sliding);
    }
    this.hls.trigger(Events.AUDIO_TRACK_UPDATED, {
      details: newDetails,
      id: trackId,
      groupId: data.groupId
    });

    // only switch back to IDLE state if we were waiting for track to start downloading a new fragment
    if (this.state === State.WAITING_TRACK && !this.waitForCdnTuneIn(newDetails)) {
      this.state = State.IDLE;
    }

    // trigger handler right now
    this.tick();
  }
  _handleFragmentLoadProgress(data) {
    var _frag$initSegment;
    const frag = data.frag;
    const {
      part,
      payload
    } = data;
    const {
      config,
      trackId,
      levels
    } = this;
    if (!levels) {
      this.warn(`Audio tracks were reset while fragment load was in progress. Fragment ${frag.sn} of level ${frag.level} will not be buffered`);
      return;
    }
    const track = levels[trackId];
    if (!track) {
      this.warn('Audio track is undefined on fragment load progress');
      return;
    }
    const details = track.details;
    if (!details) {
      this.warn('Audio track details undefined on fragment load progress');
      this.removeUnbufferedFrags(frag.start);
      return;
    }
    const audioCodec = config.defaultAudioCodec || track.audioCodec || 'mp4a.40.2';
    let transmuxer = this.transmuxer;
    if (!transmuxer) {
      transmuxer = this.transmuxer = new TransmuxerInterface(this.hls, PlaylistLevelType.AUDIO, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this));
    }

    // Check if we have video initPTS
    // If not we need to wait for it
    const initPTS = this.initPTS[frag.cc];
    const initSegmentData = (_frag$initSegment = frag.initSegment) == null ? void 0 : _frag$initSegment.data;
    if (initPTS !== undefined) {
      // this.log(`Transmuxing ${sn} of [${details.startSN} ,${details.endSN}],track ${trackId}`);
      // time Offset is accurate if level PTS is known, or if playlist is not sliding (not live)
      const accurateTimeOffset = false; // details.PTSKnown || !details.live;
      const partIndex = part ? part.index : -1;
      const partial = partIndex !== -1;
      const chunkMeta = new ChunkMetadata(frag.level, frag.sn, frag.stats.chunkCount, payload.byteLength, partIndex, partial);
      transmuxer.push(payload, initSegmentData, audioCodec, '', frag, part, details.totalduration, accurateTimeOffset, chunkMeta, initPTS);
    } else {
      this.log(`Unknown video PTS for cc ${frag.cc}, waiting for video PTS before demuxing audio frag ${frag.sn} of [${details.startSN} ,${details.endSN}],track ${trackId}`);
      const {
        cache
      } = this.waitingData = this.waitingData || {
        frag,
        part,
        cache: new ChunkCache(),
        complete: false
      };
      cache.push(new Uint8Array(payload));
      if (this.state !== State.STOPPED) {
        this.state = State.WAITING_INIT_PTS;
      }
    }
  }
  _handleFragmentLoadComplete(fragLoadedData) {
    if (this.waitingData) {
      this.waitingData.complete = true;
      return;
    }
    super._handleFragmentLoadComplete(fragLoadedData);
  }
  onBufferReset(/* event: Events.BUFFER_RESET */
  ) {
    // reset reference to sourcebuffers
    this.mediaBuffer = null;
  }
  onBufferCreated(event, data) {
    this.bufferFlushed = this.flushing = false;
    const audioTrack = data.tracks.audio;
    if (audioTrack) {
      this.mediaBuffer = audioTrack.buffer || null;
    }
  }
  onFragLoading(event, data) {
    if (!this.audioOnly && data.frag.type === PlaylistLevelType.MAIN && isMediaFragment(data.frag)) {
      this.mainFragLoading = data;
      if (this.state === State.IDLE) {
        this.tick();
      }
    }
  }
  onFragBuffered(event, data) {
    const {
      frag,
      part
    } = data;
    if (frag.type !== PlaylistLevelType.AUDIO) {
      if (!this.audioOnly && frag.type === PlaylistLevelType.MAIN && !frag.elementaryStreams.video && !frag.elementaryStreams.audiovideo) {
        this.audioOnly = true;
        this.mainFragLoading = null;
      }
      return;
    }
    if (this.fragContextChanged(frag)) {
      // If a level switch was requested while a fragment was buffering, it will emit the FRAG_BUFFERED event upon completion
      // Avoid setting state back to IDLE or concluding the audio switch; otherwise, the switched-to track will not buffer
      this.warn(`Fragment ${frag.sn}${part ? ' p: ' + part.index : ''} of level ${frag.level} finished buffering, but was aborted. state: ${this.state}, audioSwitch: ${this.switchingTrack ? this.switchingTrack.name : 'false'}`);
      return;
    }
    if (isMediaFragment(frag)) {
      this.fragPrevious = frag;
      const track = this.switchingTrack;
      if (track) {
        this.bufferedTrack = track;
        this.switchingTrack = null;
        this.hls.trigger(Events.AUDIO_TRACK_SWITCHED, _objectSpread2({}, track));
      }
    }
    this.fragBufferedComplete(frag, part);
    if (this.media) {
      this.tick();
    }
  }
  onError(event, data) {
    var _data$context;
    if (data.fatal) {
      this.state = State.ERROR;
      return;
    }
    switch (data.details) {
      case ErrorDetails.FRAG_GAP:
      case ErrorDetails.FRAG_PARSING_ERROR:
      case ErrorDetails.FRAG_DECRYPT_ERROR:
      case ErrorDetails.FRAG_LOAD_ERROR:
      case ErrorDetails.FRAG_LOAD_TIMEOUT:
      case ErrorDetails.KEY_LOAD_ERROR:
      case ErrorDetails.KEY_LOAD_TIMEOUT:
        this.onFragmentOrKeyLoadError(PlaylistLevelType.AUDIO, data);
        break;
      case ErrorDetails.AUDIO_TRACK_LOAD_ERROR:
      case ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:
      case ErrorDetails.LEVEL_PARSING_ERROR:
        // in case of non fatal error while loading track, if not retrying to load track, switch back to IDLE
        if (!data.levelRetry && this.state === State.WAITING_TRACK && ((_data$context = data.context) == null ? void 0 : _data$context.type) === PlaylistContextType.AUDIO_TRACK) {
          this.state = State.IDLE;
        }
        break;
      case ErrorDetails.BUFFER_ADD_CODEC_ERROR:
      case ErrorDetails.BUFFER_APPEND_ERROR:
        if (data.parent !== 'audio') {
          return;
        }
        this.resetLoadingState();
        break;
      case ErrorDetails.BUFFER_FULL_ERROR:
        if (data.parent !== 'audio') {
          return;
        }
        if (this.reduceLengthAndFlushBuffer(data)) {
          this.bufferedTrack = null;
          super.flushMainBuffer(0, Number.POSITIVE_INFINITY, 'audio');
        }
        break;
      case ErrorDetails.INTERNAL_EXCEPTION:
        this.recoverWorkerError(data);
        break;
    }
  }
  onBufferFlushing(event, {
    type
  }) {
    if (type !== ElementaryStreamTypes.VIDEO) {
      this.flushing = true;
    }
  }
  onBufferFlushed(event, {
    type
  }) {
    if (type !== ElementaryStreamTypes.VIDEO) {
      this.flushing = false;
      this.bufferFlushed = true;
      if (this.state === State.ENDED) {
        this.state = State.IDLE;
      }
      const mediaBuffer = this.mediaBuffer || this.media;
      if (mediaBuffer) {
        this.afterBufferFlushed(mediaBuffer, type, PlaylistLevelType.AUDIO);
        this.tick();
      }
    }
  }
  _handleTransmuxComplete(transmuxResult) {
    var _id3$samples;
    const id = 'audio';
    const {
      hls
    } = this;
    const {
      remuxResult,
      chunkMeta
    } = transmuxResult;
    const context = this.getCurrentContext(chunkMeta);
    if (!context) {
      this.resetWhenMissingContext(chunkMeta);
      return;
    }
    const {
      frag,
      part,
      level
    } = context;
    const {
      details
    } = level;
    const {
      audio,
      text,
      id3,
      initSegment
    } = remuxResult;

    // Check if the current fragment has been aborted. We check this by first seeing if we're still playing the current level.
    // If we are, subsequently check if the currently loading fragment (fragCurrent) has changed.
    if (this.fragContextChanged(frag) || !details) {
      this.fragmentTracker.removeFragment(frag);
      return;
    }
    this.state = State.PARSING;
    if (this.switchingTrack && audio) {
      this.completeAudioSwitch(this.switchingTrack);
    }
    if (initSegment != null && initSegment.tracks) {
      const mapFragment = frag.initSegment || frag;
      this._bufferInitSegment(level, initSegment.tracks, mapFragment, chunkMeta);
      hls.trigger(Events.FRAG_PARSING_INIT_SEGMENT, {
        frag: mapFragment,
        id,
        tracks: initSegment.tracks
      });
      // Only flush audio from old audio tracks when PTS is known on new audio track
    }
    if (audio) {
      const {
        startPTS,
        endPTS,
        startDTS,
        endDTS
      } = audio;
      if (part) {
        part.elementaryStreams[ElementaryStreamTypes.AUDIO] = {
          startPTS,
          endPTS,
          startDTS,
          endDTS
        };
      }
      frag.setElementaryStreamInfo(ElementaryStreamTypes.AUDIO, startPTS, endPTS, startDTS, endDTS);
      this.bufferFragmentData(audio, frag, part, chunkMeta);
    }
    if (id3 != null && (_id3$samples = id3.samples) != null && _id3$samples.length) {
      const emittedID3 = _extends({
        id,
        frag,
        details
      }, id3);
      hls.trigger(Events.FRAG_PARSING_METADATA, emittedID3);
    }
    if (text) {
      const emittedText = _extends({
        id,
        frag,
        details
      }, text);
      hls.trigger(Events.FRAG_PARSING_USERDATA, emittedText);
    }
  }
  _bufferInitSegment(currentLevel, tracks, frag, chunkMeta) {
    if (this.state !== State.PARSING) {
      return;
    }
    // delete any video track found on audio transmuxer
    if (tracks.video) {
      delete tracks.video;
    }
    if (tracks.audiovideo) {
      delete tracks.audiovideo;
    }

    // include levelCodec in audio and video tracks
    if (!tracks.audio) {
      return;
    }
    const track = tracks.audio;
    track.id = PlaylistLevelType.AUDIO;
    const variantAudioCodecs = currentLevel.audioCodec;
    this.log(`Init audio buffer, container:${track.container}, codecs[level/parsed]=[${variantAudioCodecs}/${track.codec}]`);
    // SourceBuffer will use track.levelCodec if defined
    if (variantAudioCodecs && variantAudioCodecs.split(',').length === 1) {
      track.levelCodec = variantAudioCodecs;
    }
    this.hls.trigger(Events.BUFFER_CODECS, tracks);
    const initSegment = track.initSegment;
    if (initSegment != null && initSegment.byteLength) {
      const segment = {
        type: 'audio',
        frag,
        part: null,
        chunkMeta,
        parent: frag.type,
        data: initSegment
      };
      this.hls.trigger(Events.BUFFER_APPENDING, segment);
    }
    // trigger handler right now
    this.tickImmediate();
  }
  loadFragment(frag, track, targetBufferTime) {
    // only load if fragment is not loaded or if in audio switch
    const fragState = this.fragmentTracker.getState(frag);

    // we force a frag loading in audio switch as fragment tracker might not have evicted previous frags in case of quick audio switch
    if (this.switchingTrack || fragState === FragmentState.NOT_LOADED || fragState === FragmentState.PARTIAL) {
      var _track$details;
      if (!isMediaFragment(frag)) {
        this._loadInitSegment(frag, track);
      } else if ((_track$details = track.details) != null && _track$details.live && !this.initPTS[frag.cc]) {
        this.log(`Waiting for video PTS in continuity counter ${frag.cc} of live stream before loading audio fragment ${frag.sn} of level ${this.trackId}`);
        this.state = State.WAITING_INIT_PTS;
        const mainDetails = this.mainDetails;
        if (mainDetails && mainDetails.fragmentStart !== track.details.fragmentStart) {
          alignMediaPlaylistByPDT(track.details, mainDetails);
        }
      } else {
        super.loadFragment(frag, track, targetBufferTime);
      }
    } else {
      this.clearTrackerIfNeeded(frag);
    }
  }
  flushAudioIfNeeded(switchingTrack) {
    if (this.media && this.bufferedTrack) {
      const {
        name,
        lang,
        assocLang,
        characteristics,
        audioCodec,
        channels
      } = this.bufferedTrack;
      if (!matchesOption({
        name,
        lang,
        assocLang,
        characteristics,
        audioCodec,
        channels
      }, switchingTrack, audioMatchPredicate)) {
        if (useAlternateAudio(switchingTrack.url, this.hls)) {
          this.log('Switching audio track : flushing all audio');
          super.flushMainBuffer(0, Number.POSITIVE_INFINITY, 'audio');
          this.bufferedTrack = null;
        } else {
          // Main is being buffered. Set bufferedTrack so that it is flushed when switching back to alt-audio
          this.bufferedTrack = switchingTrack;
        }
      }
    }
  }
  completeAudioSwitch(switchingTrack) {
    const {
      hls
    } = this;
    this.flushAudioIfNeeded(switchingTrack);
    this.bufferedTrack = switchingTrack;
    this.switchingTrack = null;
    hls.trigger(Events.AUDIO_TRACK_SWITCHED, _objectSpread2({}, switchingTrack));
  }
}

class BasePlaylistController extends hls_Logger {
  constructor(hls, logPrefix) {
    super(logPrefix, hls.logger);
    this.hls = void 0;
    this.canLoad = false;
    this.timer = -1;
    this.hls = hls;
  }
  destroy() {
    this.clearTimer();
    // @ts-ignore
    this.hls = this.log = this.warn = null;
  }
  clearTimer() {
    if (this.timer !== -1) {
      self.clearTimeout(this.timer);
      this.timer = -1;
    }
  }
  startLoad() {
    this.canLoad = true;
    this.loadPlaylist();
  }
  stopLoad() {
    this.canLoad = false;
    this.clearTimer();
  }
  switchParams(playlistUri, previous, current) {
    const renditionReports = previous == null ? void 0 : previous.renditionReports;
    if (renditionReports) {
      let foundIndex = -1;
      for (let i = 0; i < renditionReports.length; i++) {
        const attr = renditionReports[i];
        let uri;
        try {
          uri = new self.URL(attr.URI, previous.url).href;
        } catch (error) {
          this.warn(`Could not construct new URL for Rendition Report: ${error}`);
          uri = attr.URI || '';
        }
        // Use exact match. Otherwise, the last partial match, if any, will be used
        // (Playlist URI includes a query string that the Rendition Report does not)
        if (uri === playlistUri) {
          foundIndex = i;
          break;
        } else if (uri === playlistUri.substring(0, uri.length)) {
          foundIndex = i;
        }
      }
      if (foundIndex !== -1) {
        const attr = renditionReports[foundIndex];
        const msn = parseInt(attr['LAST-MSN']) || (previous == null ? void 0 : previous.lastPartSn);
        let part = parseInt(attr['LAST-PART']) || (previous == null ? void 0 : previous.lastPartIndex);
        if (this.hls.config.lowLatencyMode) {
          const currentGoal = Math.min(previous.age - previous.partTarget, previous.targetduration);
          if (part >= 0 && currentGoal > previous.partTarget) {
            part += 1;
          }
        }
        const skip = current && getSkipValue(current);
        return new HlsUrlParameters(msn, part >= 0 ? part : undefined, skip);
      }
    }
  }
  loadPlaylist(hlsUrlParameters) {
    // Loading is handled by the subclasses
    this.clearTimer();
  }
  loadingPlaylist(playlist, hlsUrlParameters) {
    // Loading is handled by the subclasses
    this.clearTimer();
  }
  shouldLoadPlaylist(playlist) {
    return this.canLoad && !!playlist && !!playlist.url && (!playlist.details || playlist.details.live);
  }
  getUrlWithDirectives(uri, hlsUrlParameters) {
    if (hlsUrlParameters) {
      try {
        return hlsUrlParameters.addDirectives(uri);
      } catch (error) {
        this.warn(`Could not construct new URL with HLS Delivery Directives: ${error}`);
      }
    }
    return uri;
  }
  playlistLoaded(index, data, previousDetails) {
    const {
      details,
      stats
    } = data;

    // Set last updated date-time
    const now = self.performance.now();
    const elapsed = stats.loading.first ? Math.max(0, now - stats.loading.first) : 0;
    details.advancedDateTime = Date.now() - elapsed;

    // shift fragment starts with timelineOffset
    const timelineOffset = this.hls.config.timelineOffset;
    if (timelineOffset !== details.appliedTimelineOffset) {
      const offset = Math.max(timelineOffset || 0, 0);
      details.appliedTimelineOffset = offset;
      details.fragments.forEach(frag => {
        frag.start = frag.playlistOffset + offset;
      });
    }

    // if current playlist is a live playlist, arm a timer to reload it
    if (details.live || previousDetails != null && previousDetails.live) {
      const levelOrTrack = 'levelInfo' in data ? data.levelInfo : data.track;
      details.reloaded(previousDetails);
      // Merge live playlists to adjust fragment starts and fill in delta playlist skipped segments
      if (previousDetails && details.fragments.length > 0) {
        mergeDetails(previousDetails, details);
        const error = details.playlistParsingError;
        if (error) {
          this.warn(error);
          const hls = this.hls;
          if (!hls.config.ignorePlaylistParsingErrors) {
            var _details$fragments$;
            const {
              networkDetails
            } = data;
            hls.trigger(Events.ERROR, {
              type: ErrorTypes.NETWORK_ERROR,
              details: ErrorDetails.LEVEL_PARSING_ERROR,
              fatal: false,
              url: details.url,
              error,
              reason: error.message,
              level: data.level || undefined,
              parent: (_details$fragments$ = details.fragments[0]) == null ? void 0 : _details$fragments$.type,
              networkDetails,
              stats
            });
            return;
          }
          details.playlistParsingError = null;
        }
      }
      if (details.requestScheduled === -1) {
        details.requestScheduled = stats.loading.start;
      }
      const bufferInfo = this.hls.mainForwardBufferInfo;
      const position = bufferInfo ? bufferInfo.end - bufferInfo.len : 0;
      const distanceToLiveEdgeMs = (details.edge - position) * 1000;
      const reloadInterval = computeReloadInterval(details, distanceToLiveEdgeMs);
      if (details.requestScheduled + reloadInterval < now) {
        details.requestScheduled = now;
      } else {
        details.requestScheduled += reloadInterval;
      }
      this.log(`live playlist ${index} ${details.advanced ? 'REFRESHED ' + details.lastPartSn + '-' + details.lastPartIndex : details.updated ? 'UPDATED' : 'MISSED'}`);
      if (!this.canLoad || !details.live) {
        return;
      }
      let deliveryDirectives;
      let msn = undefined;
      let part = undefined;
      if (details.canBlockReload && details.endSN && details.advanced) {
        // Load level with LL-HLS delivery directives
        const lowLatencyMode = this.hls.config.lowLatencyMode;
        const lastPartSn = details.lastPartSn;
        const endSn = details.endSN;
        const lastPartIndex = details.lastPartIndex;
        const hasParts = lastPartIndex !== -1;
        const atLastPartOfSegment = lastPartSn === endSn;
        if (hasParts) {
          // When low latency mode is disabled, request the last part of the next segment
          if (atLastPartOfSegment) {
            msn = endSn + 1;
            part = lowLatencyMode ? 0 : lastPartIndex;
          } else {
            msn = lastPartSn;
            part = lowLatencyMode ? lastPartIndex + 1 : details.maxPartIndex;
          }
        } else {
          msn = endSn + 1;
        }
        // Low-Latency CDN Tune-in: "age" header and time since load indicates we're behind by more than one part
        // Update directives to obtain the Playlist that has the estimated additional duration of media
        const lastAdvanced = details.age;
        const cdnAge = lastAdvanced + details.ageHeader;
        let currentGoal = Math.min(cdnAge - details.partTarget, details.targetduration * 1.5);
        if (currentGoal > 0) {
          if (cdnAge > details.targetduration * 3) {
            // Omit segment and part directives when the last response was more than 3 target durations ago,
            this.log(`Playlist last advanced ${lastAdvanced.toFixed(2)}s ago. Omitting segment and part directives.`);
            msn = undefined;
            part = undefined;
          } else if (previousDetails != null && previousDetails.tuneInGoal && cdnAge - details.partTarget > previousDetails.tuneInGoal) {
            // If we attempted to get the next or latest playlist update, but currentGoal increased,
            // then we either can't catchup, or the "age" header cannot be trusted.
            this.warn(`CDN Tune-in goal increased from: ${previousDetails.tuneInGoal} to: ${currentGoal} with playlist age: ${details.age}`);
            currentGoal = 0;
          } else {
            const segments = Math.floor(currentGoal / details.targetduration);
            msn += segments;
            if (part !== undefined) {
              const parts = Math.round(currentGoal % details.targetduration / details.partTarget);
              part += parts;
            }
            this.log(`CDN Tune-in age: ${details.ageHeader}s last advanced ${lastAdvanced.toFixed(2)}s goal: ${currentGoal} skip sn ${segments} to part ${part}`);
          }
          details.tuneInGoal = currentGoal;
        }
        deliveryDirectives = this.getDeliveryDirectives(details, data.deliveryDirectives, msn, part);
        if (lowLatencyMode || !atLastPartOfSegment) {
          details.requestScheduled = now;
          this.loadingPlaylist(levelOrTrack, deliveryDirectives);
          return;
        }
      } else if (details.canBlockReload || details.canSkipUntil) {
        deliveryDirectives = this.getDeliveryDirectives(details, data.deliveryDirectives, msn, part);
      }
      if (deliveryDirectives && msn !== undefined && details.canBlockReload) {
        details.requestScheduled = stats.loading.first + Math.max(reloadInterval - elapsed * 2, reloadInterval / 2);
      }
      this.scheduleLoading(levelOrTrack, deliveryDirectives, details);
    } else {
      this.clearTimer();
    }
  }
  scheduleLoading(levelOrTrack, deliveryDirectives, updatedDetails) {
    const details = updatedDetails || levelOrTrack.details;
    if (!details) {
      this.loadingPlaylist(levelOrTrack, deliveryDirectives);
      return;
    }
    const now = self.performance.now();
    const requestScheduled = details.requestScheduled;
    if (now >= requestScheduled) {
      this.loadingPlaylist(levelOrTrack, deliveryDirectives);
      return;
    }
    const estimatedTimeUntilUpdate = requestScheduled - now;
    this.log(`reload live playlist ${levelOrTrack.name || levelOrTrack.bitrate + 'bps'} in ${Math.round(estimatedTimeUntilUpdate)} ms`);
    this.clearTimer();
    this.timer = self.setTimeout(() => this.loadingPlaylist(levelOrTrack, deliveryDirectives), estimatedTimeUntilUpdate);
  }
  getDeliveryDirectives(details, previousDeliveryDirectives, msn, part) {
    let skip = getSkipValue(details);
    if (previousDeliveryDirectives != null && previousDeliveryDirectives.skip && details.deltaUpdateFailed) {
      msn = previousDeliveryDirectives.msn;
      part = previousDeliveryDirectives.part;
      skip = HlsSkip.No;
    }
    return new HlsUrlParameters(msn, part, skip);
  }
  checkRetry(errorEvent) {
    const errorDetails = errorEvent.details;
    const isTimeout = isTimeoutError(errorEvent);
    const errorAction = errorEvent.errorAction;
    const {
      action,
      retryCount = 0,
      retryConfig
    } = errorAction || {};
    const retry = !!errorAction && !!retryConfig && (action === NetworkErrorAction.RetryRequest || !errorAction.resolved && action === NetworkErrorAction.SendAlternateToPenaltyBox);
    if (retry) {
      var _errorEvent$context;
      if (retryCount >= retryConfig.maxNumRetry) {
        return false;
      }
      if (isTimeout && (_errorEvent$context = errorEvent.context) != null && _errorEvent$context.deliveryDirectives) {
        // The LL-HLS request already timed out so retry immediately
        this.warn(`Retrying playlist loading ${retryCount + 1}/${retryConfig.maxNumRetry} after "${errorDetails}" without delivery-directives`);
        this.loadPlaylist();
      } else {
        const delay = getRetryDelay(retryConfig, retryCount);
        // Schedule level/track reload
        this.clearTimer();
        this.timer = self.setTimeout(() => this.loadPlaylist(), delay);
        this.warn(`Retrying playlist loading ${retryCount + 1}/${retryConfig.maxNumRetry} after "${errorDetails}" in ${delay}ms`);
      }
      // `levelRetry = true` used to inform other controllers that a retry is happening
      errorEvent.levelRetry = true;
      errorAction.resolved = true;
    }
    return retry;
  }
}

function subtitleOptionsIdentical(trackList1, trackList2) {
  if (trackList1.length !== trackList2.length) {
    return false;
  }
  for (let i = 0; i < trackList1.length; i++) {
    if (!mediaAttributesIdentical(trackList1[i].attrs, trackList2[i].attrs)) {
      return false;
    }
  }
  return true;
}
function mediaAttributesIdentical(attrs1, attrs2, customAttributes) {
  // Media options with the same rendition ID must be bit identical
  const stableRenditionId = attrs1['STABLE-RENDITION-ID'];
  if (stableRenditionId && !customAttributes) {
    return stableRenditionId === attrs2['STABLE-RENDITION-ID'];
  }
  // When rendition ID is not present, compare attributes
  return !(customAttributes || ['LANGUAGE', 'NAME', 'CHARACTERISTICS', 'AUTOSELECT', 'DEFAULT', 'FORCED', 'ASSOC-LANGUAGE']).some(subtitleAttribute => attrs1[subtitleAttribute] !== attrs2[subtitleAttribute]);
}
function subtitleTrackMatchesTextTrack(subtitleTrack, textTrack) {
  return textTrack.label.toLowerCase() === subtitleTrack.name.toLowerCase() && (!textTrack.language || textTrack.language.toLowerCase() === (subtitleTrack.lang || '').toLowerCase());
}

class AudioTrackController extends BasePlaylistController {
  constructor(hls) {
    super(hls, 'audio-track-controller');
    this.tracks = [];
    this.groupIds = null;
    this.tracksInGroup = [];
    this.trackId = -1;
    this.currentTrack = null;
    this.selectDefaultTrack = true;
    this.registerListeners();
  }
  registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.on(Events.LEVEL_LOADING, this.onLevelLoading, this);
    hls.on(Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
    hls.on(Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this);
    hls.on(Events.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.off(Events.LEVEL_LOADING, this.onLevelLoading, this);
    hls.off(Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
    hls.off(Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this);
    hls.off(Events.ERROR, this.onError, this);
  }
  destroy() {
    this.unregisterListeners();
    this.tracks.length = 0;
    this.tracksInGroup.length = 0;
    this.currentTrack = null;
    super.destroy();
  }
  onManifestLoading() {
    this.tracks = [];
    this.tracksInGroup = [];
    this.groupIds = null;
    this.currentTrack = null;
    this.trackId = -1;
    this.selectDefaultTrack = true;
  }
  onManifestParsed(event, data) {
    this.tracks = data.audioTracks || [];
  }
  onAudioTrackLoaded(event, data) {
    const {
      id,
      groupId,
      details
    } = data;
    const trackInActiveGroup = this.tracksInGroup[id];
    if (!trackInActiveGroup || trackInActiveGroup.groupId !== groupId) {
      this.warn(`Audio track with id:${id} and group:${groupId} not found in active group ${trackInActiveGroup == null ? void 0 : trackInActiveGroup.groupId}`);
      return;
    }
    const curDetails = trackInActiveGroup.details;
    trackInActiveGroup.details = data.details;
    this.log(`Audio track ${id} "${trackInActiveGroup.name}" lang:${trackInActiveGroup.lang} group:${groupId} loaded [${details.startSN}-${details.endSN}]`);
    if (id === this.trackId) {
      this.playlistLoaded(id, data, curDetails);
    }
  }
  onLevelLoading(event, data) {
    this.switchLevel(data.level);
  }
  onLevelSwitching(event, data) {
    this.switchLevel(data.level);
  }
  switchLevel(levelIndex) {
    const levelInfo = this.hls.levels[levelIndex];
    if (!levelInfo) {
      return;
    }
    const audioGroups = levelInfo.audioGroups || null;
    const currentGroups = this.groupIds;
    let currentTrack = this.currentTrack;
    if (!audioGroups || (currentGroups == null ? void 0 : currentGroups.length) !== (audioGroups == null ? void 0 : audioGroups.length) || audioGroups != null && audioGroups.some(groupId => (currentGroups == null ? void 0 : currentGroups.indexOf(groupId)) === -1)) {
      this.groupIds = audioGroups;
      this.trackId = -1;
      this.currentTrack = null;
      const audioTracks = this.tracks.filter(track => !audioGroups || audioGroups.indexOf(track.groupId) !== -1);
      if (audioTracks.length) {
        // Disable selectDefaultTrack if there are no default tracks
        if (this.selectDefaultTrack && !audioTracks.some(track => track.default)) {
          this.selectDefaultTrack = false;
        }
        // track.id should match hls.audioTracks index
        audioTracks.forEach((track, i) => {
          track.id = i;
        });
      } else if (!currentTrack && !this.tracksInGroup.length) {
        // Do not dispatch AUDIO_TRACKS_UPDATED when there were and are no tracks
        return;
      }
      this.tracksInGroup = audioTracks;

      // Find preferred track
      const audioPreference = this.hls.config.audioPreference;
      if (!currentTrack && audioPreference) {
        const groupIndex = findMatchingOption(audioPreference, audioTracks, audioMatchPredicate);
        if (groupIndex > -1) {
          currentTrack = audioTracks[groupIndex];
        } else {
          const allIndex = findMatchingOption(audioPreference, this.tracks);
          currentTrack = this.tracks[allIndex];
        }
      }

      // Select initial track
      let trackId = this.findTrackId(currentTrack);
      if (trackId === -1 && currentTrack) {
        trackId = this.findTrackId(null);
      }

      // Dispatch events and load track if needed
      const audioTracksUpdated = {
        audioTracks
      };
      this.log(`Updating audio tracks, ${audioTracks.length} track(s) found in group(s): ${audioGroups == null ? void 0 : audioGroups.join(',')}`);
      this.hls.trigger(Events.AUDIO_TRACKS_UPDATED, audioTracksUpdated);
      const selectedTrackId = this.trackId;
      if (trackId !== -1 && selectedTrackId === -1) {
        this.setAudioTrack(trackId);
      } else if (audioTracks.length && selectedTrackId === -1) {
        var _this$groupIds;
        const error = new Error(`No audio track selected for current audio group-ID(s): ${(_this$groupIds = this.groupIds) == null ? void 0 : _this$groupIds.join(',')} track count: ${audioTracks.length}`);
        this.warn(error.message);
        this.hls.trigger(Events.ERROR, {
          type: ErrorTypes.MEDIA_ERROR,
          details: ErrorDetails.AUDIO_TRACK_LOAD_ERROR,
          fatal: true,
          error
        });
      }
    }
  }
  onError(event, data) {
    if (data.fatal || !data.context) {
      return;
    }
    if (data.context.type === PlaylistContextType.AUDIO_TRACK && data.context.id === this.trackId && (!this.groupIds || this.groupIds.indexOf(data.context.groupId) !== -1)) {
      this.checkRetry(data);
    }
  }
  get allAudioTracks() {
    return this.tracks;
  }
  get audioTracks() {
    return this.tracksInGroup;
  }
  get audioTrack() {
    return this.trackId;
  }
  set audioTrack(newId) {
    // If audio track is selected from API then don't choose from the manifest default track
    this.selectDefaultTrack = false;
    this.setAudioTrack(newId);
  }
  setAudioOption(audioOption) {
    const hls = this.hls;
    hls.config.audioPreference = audioOption;
    if (audioOption) {
      const allAudioTracks = this.allAudioTracks;
      this.selectDefaultTrack = false;
      if (allAudioTracks.length) {
        // First see if current option matches (no switch op)
        const currentTrack = this.currentTrack;
        if (currentTrack && matchesOption(audioOption, currentTrack, audioMatchPredicate)) {
          return currentTrack;
        }
        // Find option in available tracks (tracksInGroup)
        const groupIndex = findMatchingOption(audioOption, this.tracksInGroup, audioMatchPredicate);
        if (groupIndex > -1) {
          const track = this.tracksInGroup[groupIndex];
          this.setAudioTrack(groupIndex);
          return track;
        } else if (currentTrack) {
          // Find option in nearest level audio group
          let searchIndex = hls.loadLevel;
          if (searchIndex === -1) {
            searchIndex = hls.firstAutoLevel;
          }
          const switchIndex = findClosestLevelWithAudioGroup(audioOption, hls.levels, allAudioTracks, searchIndex, audioMatchPredicate);
          if (switchIndex === -1) {
            // could not find matching variant
            return null;
          }
          // and switch level to acheive the audio group switch
          hls.nextLoadLevel = switchIndex;
        }
        if (audioOption.channels || audioOption.audioCodec) {
          // Could not find a match with codec / channels predicate
          // Find a match without channels or codec
          const withoutCodecAndChannelsMatch = findMatchingOption(audioOption, allAudioTracks);
          if (withoutCodecAndChannelsMatch > -1) {
            return allAudioTracks[withoutCodecAndChannelsMatch];
          }
        }
      }
    }
    return null;
  }
  setAudioTrack(newId) {
    const tracks = this.tracksInGroup;

    // check if level idx is valid
    if (newId < 0 || newId >= tracks.length) {
      this.warn(`Invalid audio track id: ${newId}`);
      return;
    }
    this.selectDefaultTrack = false;
    const lastTrack = this.currentTrack;
    const track = tracks[newId];
    const trackLoaded = track.details && !track.details.live;
    if (newId === this.trackId && track === lastTrack && trackLoaded) {
      return;
    }
    this.log(`Switching to audio-track ${newId} "${track.name}" lang:${track.lang} group:${track.groupId} channels:${track.channels}`);
    this.trackId = newId;
    this.currentTrack = track;
    this.hls.trigger(Events.AUDIO_TRACK_SWITCHING, _objectSpread2({}, track));
    // Do not reload track unless live
    if (trackLoaded) {
      return;
    }
    const hlsUrlParameters = this.switchParams(track.url, lastTrack == null ? void 0 : lastTrack.details, track.details);
    this.loadPlaylist(hlsUrlParameters);
  }
  findTrackId(currentTrack) {
    const audioTracks = this.tracksInGroup;
    for (let i = 0; i < audioTracks.length; i++) {
      const track = audioTracks[i];
      if (this.selectDefaultTrack && !track.default) {
        continue;
      }
      if (!currentTrack || matchesOption(currentTrack, track, audioMatchPredicate)) {
        return i;
      }
    }
    if (currentTrack) {
      const {
        name,
        lang,
        assocLang,
        characteristics,
        audioCodec,
        channels
      } = currentTrack;
      for (let i = 0; i < audioTracks.length; i++) {
        const track = audioTracks[i];
        if (matchesOption({
          name,
          lang,
          assocLang,
          characteristics,
          audioCodec,
          channels
        }, track, audioMatchPredicate)) {
          return i;
        }
      }
      for (let i = 0; i < audioTracks.length; i++) {
        const track = audioTracks[i];
        if (mediaAttributesIdentical(currentTrack.attrs, track.attrs, ['LANGUAGE', 'ASSOC-LANGUAGE', 'CHARACTERISTICS'])) {
          return i;
        }
      }
      for (let i = 0; i < audioTracks.length; i++) {
        const track = audioTracks[i];
        if (mediaAttributesIdentical(currentTrack.attrs, track.attrs, ['LANGUAGE'])) {
          return i;
        }
      }
    }
    return -1;
  }
  loadPlaylist(hlsUrlParameters) {
    super.loadPlaylist();
    const audioTrack = this.currentTrack;
    if (!this.shouldLoadPlaylist(audioTrack)) {
      return;
    }
    // Do not load audio rendition with URI matching main variant URI
    if (useAlternateAudio(audioTrack.url, this.hls)) {
      this.scheduleLoading(audioTrack, hlsUrlParameters);
    }
  }
  loadingPlaylist(audioTrack, hlsUrlParameters) {
    super.loadingPlaylist(audioTrack, hlsUrlParameters);
    const id = audioTrack.id;
    const groupId = audioTrack.groupId;
    const url = this.getUrlWithDirectives(audioTrack.url, hlsUrlParameters);
    const details = audioTrack.details;
    const age = details == null ? void 0 : details.age;
    this.log(`Loading audio-track ${id} "${audioTrack.name}" lang:${audioTrack.lang} group:${groupId}${(hlsUrlParameters == null ? void 0 : hlsUrlParameters.msn) !== undefined ? ' at sn ' + hlsUrlParameters.msn + ' part ' + hlsUrlParameters.part : ''}${age && details.live ? ' age ' + age.toFixed(1) + (details.type ? ' ' + details.type || 0 : '') : ''} ${url}`);
    this.hls.trigger(Events.AUDIO_TRACK_LOADING, {
      url,
      id,
      groupId,
      deliveryDirectives: hlsUrlParameters || null,
      track: audioTrack
    });
  }
}

class BufferOperationQueue {
  constructor(sourceBufferReference) {
    this.tracks = void 0;
    this.queues = {
      video: [],
      audio: [],
      audiovideo: []
    };
    this.tracks = sourceBufferReference;
  }
  destroy() {
    this.tracks = this.queues = null;
  }
  append(operation, type, pending) {
    if (this.queues === null || this.tracks === null) {
      return;
    }
    const queue = this.queues[type];
    queue.push(operation);
    if (queue.length === 1 && !pending) {
      this.executeNext(type);
    }
  }
  appendBlocker(type) {
    return new Promise(resolve => {
      const operation = {
        label: 'async-blocker',
        execute: resolve,
        onStart: () => {},
        onComplete: () => {},
        onError: () => {}
      };
      this.append(operation, type);
    });
  }
  prependBlocker(type) {
    return new Promise(resolve => {
      if (this.queues) {
        const operation = {
          label: 'async-blocker-prepend',
          execute: resolve,
          onStart: () => {},
          onComplete: () => {},
          onError: () => {}
        };
        this.queues[type].unshift(operation);
      }
    });
  }
  removeBlockers() {
    if (this.queues === null) {
      return;
    }
    [this.queues.video, this.queues.audio, this.queues.audiovideo].forEach(queue => {
      var _queue$;
      const label = (_queue$ = queue[0]) == null ? void 0 : _queue$.label;
      if (label === 'async-blocker' || label === 'async-blocker-prepend') {
        queue[0].execute();
        queue.splice(0, 1);
      }
    });
  }
  unblockAudio(op) {
    if (this.queues === null) {
      return;
    }
    const queue = this.queues.audio;
    if (queue[0] === op) {
      this.shiftAndExecuteNext('audio');
    }
  }
  executeNext(type) {
    if (this.queues === null || this.tracks === null) {
      return;
    }
    const queue = this.queues[type];
    if (queue.length) {
      const operation = queue[0];
      try {
        // Operations are expected to result in an 'updateend' event being fired. If not, the queue will lock. Operations
        // which do not end with this event must call _onSBUpdateEnd manually
        operation.execute();
      } catch (error) {
        var _this$tracks$type;
        operation.onError(error);
        if (this.queues === null || this.tracks === null) {
          return;
        }

        // Only shift the current operation off, otherwise the updateend handler will do this for us
        const sb = (_this$tracks$type = this.tracks[type]) == null ? void 0 : _this$tracks$type.buffer;
        if (!(sb != null && sb.updating)) {
          this.shiftAndExecuteNext(type);
        }
      }
    }
  }
  shiftAndExecuteNext(type) {
    if (this.queues === null) {
      return;
    }
    this.queues[type].shift();
    this.executeNext(type);
  }
  current(type) {
    var _this$queues;
    return ((_this$queues = this.queues) == null ? void 0 : _this$queues[type][0]) || null;
  }
  toString() {
    const {
      queues,
      tracks
    } = this;
    if (queues === null || tracks === null) {
      return `<destroyed>`;
    }
    return `
${this.list('video')}
${this.list('audio')}
${this.list('audiovideo')}}`;
  }
  list(type) {
    var _this$queues2, _this$tracks;
    return (_this$queues2 = this.queues) != null && _this$queues2[type] || (_this$tracks = this.tracks) != null && _this$tracks[type] ? `${type}: (${this.listSbInfo(type)}) ${this.listOps(type)}` : '';
  }
  listSbInfo(type) {
    var _this$tracks2;
    const track = (_this$tracks2 = this.tracks) == null ? void 0 : _this$tracks2[type];
    const sb = track == null ? void 0 : track.buffer;
    if (!sb) {
      return 'none';
    }
    return `SourceBuffer${sb.updating ? ' updating' : ''}${track.ended ? ' ended' : ''}${track.ending ? ' ending' : ''}`;
  }
  listOps(type) {
    var _this$queues3;
    return ((_this$queues3 = this.queues) == null ? void 0 : _this$queues3[type].map(op => op.label).join(', ')) || '';
  }
}

const VIDEO_CODEC_PROFILE_REPLACE = /(avc[1234]|hvc1|hev1|dvh[1e]|vp09|av01)(?:\.[^.,]+)+/;
const TRACK_REMOVED_ERROR_NAME = 'HlsJsTrackRemovedError';
class HlsJsTrackRemovedError extends Error {
  constructor(message) {
    super(message);
    this.name = TRACK_REMOVED_ERROR_NAME;
  }
}
class BufferController extends hls_Logger {
  constructor(hls, fragmentTracker) {
    super('buffer-controller', hls.logger);
    this.hls = void 0;
    this.fragmentTracker = void 0;
    // The level details used to determine duration, target-duration and live
    this.details = null;
    // cache the self generated object url to detect hijack of video tag
    this._objectUrl = null;
    // A queue of buffer operations which require the SourceBuffer to not be updating upon execution
    this.operationQueue = null;
    // The total number track codecs expected before any sourceBuffers are created (2: audio and video or 1: audiovideo | audio | video)
    this.bufferCodecEventsTotal = 0;
    // A reference to the attached media element
    this.media = null;
    // A reference to the active media source
    this.mediaSource = null;
    // Last MP3 audio chunk appended
    this.lastMpegAudioChunk = null;
    // Audio fragment blocked from appending until corresponding video appends or context changes
    this.blockedAudioAppend = null;
    // Keep track of video append position for unblocking audio
    this.lastVideoAppendEnd = 0;
    // Whether or not to use ManagedMediaSource API and append source element to media element.
    this.appendSource = void 0;
    // Transferred MediaSource information used to detmerine if duration end endstream may be appended
    this.transferData = void 0;
    // Directives used to override default MediaSource handling
    this.overrides = void 0;
    // Error counters
    this.appendErrors = {
      audio: 0,
      video: 0,
      audiovideo: 0
    };
    // Record of required or created buffers by type. SourceBuffer is stored in Track.buffer once created.
    this.tracks = {};
    // Array of SourceBuffer type and SourceBuffer (or null). One entry per TrackSet in this.tracks.
    this.sourceBuffers = [[null, null], [null, null]];
    this._onEndStreaming = event => {
      var _this$mediaSource;
      if (!this.hls) {
        return;
      }
      if (((_this$mediaSource = this.mediaSource) == null ? void 0 : _this$mediaSource.readyState) !== 'open') {
        return;
      }
      this.hls.pauseBuffering();
    };
    this._onStartStreaming = event => {
      if (!this.hls) {
        return;
      }
      this.hls.resumeBuffering();
    };
    // Keep as arrow functions so that we can directly reference these functions directly as event listeners
    this._onMediaSourceOpen = e => {
      const {
        media,
        mediaSource
      } = this;
      if (e) {
        this.log('Media source opened');
      }
      if (!media || !mediaSource) {
        return;
      }
      // once received, don't listen anymore to sourceopen event
      mediaSource.removeEventListener('sourceopen', this._onMediaSourceOpen);
      media.removeEventListener('emptied', this._onMediaEmptied);
      this.updateDuration();
      this.hls.trigger(Events.MEDIA_ATTACHED, {
        media,
        mediaSource: mediaSource
      });
      if (this.mediaSource !== null) {
        this.checkPendingTracks();
      }
    };
    this._onMediaSourceClose = () => {
      this.log('Media source closed');
    };
    this._onMediaSourceEnded = () => {
      this.log('Media source ended');
    };
    this._onMediaEmptied = () => {
      const {
        mediaSrc,
        _objectUrl
      } = this;
      if (mediaSrc !== _objectUrl) {
        this.error(`Media element src was set while attaching MediaSource (${_objectUrl} > ${mediaSrc})`);
      }
    };
    this.hls = hls;
    this.fragmentTracker = fragmentTracker;
    this.appendSource = isManagedMediaSource(getMediaSource(hls.config.preferManagedMediaSource));
    this.initTracks();
    this.registerListeners();
  }
  hasSourceTypes() {
    return Object.keys(this.tracks).length > 0;
  }
  destroy() {
    this.unregisterListeners();
    this.details = null;
    this.lastMpegAudioChunk = this.blockedAudioAppend = null;
    this.transferData = this.overrides = undefined;
    if (this.operationQueue) {
      this.operationQueue.destroy();
      this.operationQueue = null;
    }
    // @ts-ignore
    this.hls = this.fragmentTracker = null;
    // @ts-ignore
    this._onMediaSourceOpen = this._onMediaSourceClose = null;
    // @ts-ignore
    this._onMediaSourceEnded = null;
    // @ts-ignore
    this._onStartStreaming = this._onEndStreaming = null;
  }
  registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
    hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.on(Events.BUFFER_RESET, this.onBufferReset, this);
    hls.on(Events.BUFFER_APPENDING, this.onBufferAppending, this);
    hls.on(Events.BUFFER_CODECS, this.onBufferCodecs, this);
    hls.on(Events.BUFFER_EOS, this.onBufferEos, this);
    hls.on(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
    hls.on(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
    hls.on(Events.FRAG_PARSED, this.onFragParsed, this);
    hls.on(Events.FRAG_CHANGED, this.onFragChanged, this);
    hls.on(Events.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
    hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.off(Events.BUFFER_RESET, this.onBufferReset, this);
    hls.off(Events.BUFFER_APPENDING, this.onBufferAppending, this);
    hls.off(Events.BUFFER_CODECS, this.onBufferCodecs, this);
    hls.off(Events.BUFFER_EOS, this.onBufferEos, this);
    hls.off(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
    hls.off(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
    hls.off(Events.FRAG_PARSED, this.onFragParsed, this);
    hls.off(Events.FRAG_CHANGED, this.onFragChanged, this);
    hls.off(Events.ERROR, this.onError, this);
  }
  transferMedia() {
    const {
      media,
      mediaSource
    } = this;
    if (!media) {
      return null;
    }
    const tracks = {};
    if (this.operationQueue) {
      const updating = this.isUpdating();
      if (!updating) {
        this.operationQueue.removeBlockers();
      }
      const queued = this.isQueued();
      if (updating || queued) {
        this.warn(`Transfering MediaSource with${queued ? ' operations in queue' : ''}${updating ? ' updating SourceBuffer(s)' : ''} ${this.operationQueue}`);
      }
      this.operationQueue.destroy();
    }
    const transferData = this.transferData;
    if (!this.sourceBufferCount && transferData && transferData.mediaSource === mediaSource) {
      _extends(tracks, transferData.tracks);
    } else {
      this.sourceBuffers.forEach(tuple => {
        const [type] = tuple;
        if (type) {
          tracks[type] = _extends({}, this.tracks[type]);
          this.removeBuffer(type);
        }
        tuple[0] = tuple[1] = null;
      });
    }
    return {
      media,
      mediaSource,
      tracks
    };
  }
  initTracks() {
    const tracks = {};
    this.sourceBuffers = [[null, null], [null, null]];
    this.tracks = tracks;
    this.resetQueue();
    this.resetAppendErrors();
    this.lastMpegAudioChunk = this.blockedAudioAppend = null;
    this.lastVideoAppendEnd = 0;
  }
  onManifestLoading() {
    this.bufferCodecEventsTotal = 0;
    this.details = null;
  }
  onManifestParsed(event, data) {
    var _this$transferData;
    // in case of alt audio 2 BUFFER_CODECS events will be triggered, one per stream controller
    // sourcebuffers will be created all at once when the expected nb of tracks will be reached
    // in case alt audio is not used, only one BUFFER_CODEC event will be fired from main stream controller
    // it will contain the expected nb of source buffers, no need to compute it
    let codecEvents = 2;
    if (data.audio && !data.video || !data.altAudio) {
      codecEvents = 1;
    }
    this.bufferCodecEventsTotal = codecEvents;
    this.log(`${codecEvents} bufferCodec event(s) expected.`);
    if ((_this$transferData = this.transferData) != null && _this$transferData.mediaSource && this.sourceBufferCount && codecEvents) {
      this.bufferCreated();
    }
  }
  onMediaAttaching(event, data) {
    const media = this.media = data.media;
    const MediaSource = getMediaSource(this.appendSource);
    this.transferData = this.overrides = undefined;
    if (media && MediaSource) {
      const transferringMedia = !!data.mediaSource;
      if (transferringMedia || data.overrides) {
        this.transferData = data;
        this.overrides = data.overrides;
      }
      const ms = this.mediaSource = data.mediaSource || new MediaSource();
      this.assignMediaSource(ms);
      if (transferringMedia) {
        this._objectUrl = media.src;
        this.attachTransferred();
      } else {
        // cache the locally generated object url
        const objectUrl = this._objectUrl = self.URL.createObjectURL(ms);
        // link video and media Source
        if (this.appendSource) {
          try {
            media.removeAttribute('src');
            // ManagedMediaSource will not open without disableRemotePlayback set to false or source alternatives
            const MMS = self.ManagedMediaSource;
            media.disableRemotePlayback = media.disableRemotePlayback || MMS && ms instanceof MMS;
            removeSourceChildren(media);
            addSource(media, objectUrl);
            media.load();
          } catch (error) {
            media.src = objectUrl;
          }
        } else {
          media.src = objectUrl;
        }
      }
      media.addEventListener('emptied', this._onMediaEmptied);
    }
  }
  assignMediaSource(ms) {
    var _this$transferData2, _ms$constructor;
    this.log(`${((_this$transferData2 = this.transferData) == null ? void 0 : _this$transferData2.mediaSource) === ms ? 'transferred' : 'created'} media source: ${(_ms$constructor = ms.constructor) == null ? void 0 : _ms$constructor.name}`);
    // MediaSource listeners are arrow functions with a lexical scope, and do not need to be bound
    ms.addEventListener('sourceopen', this._onMediaSourceOpen);
    ms.addEventListener('sourceended', this._onMediaSourceEnded);
    ms.addEventListener('sourceclose', this._onMediaSourceClose);
    if (this.appendSource) {
      ms.addEventListener('startstreaming', this._onStartStreaming);
      ms.addEventListener('endstreaming', this._onEndStreaming);
    }
  }
  attachTransferred() {
    const media = this.media;
    const data = this.transferData;
    if (!data || !media) {
      return;
    }
    const requiredTracks = this.tracks;
    const transferredTracks = data.tracks;
    const trackNames = transferredTracks ? Object.keys(transferredTracks) : null;
    const trackCount = trackNames ? trackNames.length : 0;
    const mediaSourceOpenCallback = () => {
      if (this.media && this.mediaSourceOpenOrEnded) {
        this._onMediaSourceOpen();
      }
    };
    if (transferredTracks && trackNames && trackCount) {
      if (!this.tracksReady) {
        // Wait for CODECS event(s)
        this.hls.config.startFragPrefetch = true;
        this.log(`attachTransferred: waiting for SourceBuffer track info`);
        return;
      }
      this.log(`attachTransferred: (bufferCodecEventsTotal ${this.bufferCodecEventsTotal})
required tracks: ${hls_stringify(requiredTracks, (key, value) => key === 'initSegment' ? undefined : value)};
transfer tracks: ${hls_stringify(transferredTracks, (key, value) => key === 'initSegment' ? undefined : value)}}`);
      if (!isCompatibleTrackChange(transferredTracks, requiredTracks)) {
        // destroy attaching media source
        data.mediaSource = null;
        data.tracks = undefined;
        const currentTime = media.currentTime;
        const details = this.details;
        const startTime = Math.max(currentTime, (details == null ? void 0 : details.fragments[0].start) || 0);
        if (startTime - currentTime > 1) {
          this.log(`attachTransferred: waiting for playback to reach new tracks start time ${currentTime} -> ${startTime}`);
          return;
        }
        this.warn(`attachTransferred: resetting MediaSource for incompatible tracks ("${Object.keys(transferredTracks)}"->"${Object.keys(requiredTracks)}") start time: ${startTime} currentTime: ${currentTime}`);
        this.onMediaDetaching(Events.MEDIA_DETACHING, {});
        this.onMediaAttaching(Events.MEDIA_ATTACHING, data);
        media.currentTime = startTime;
        return;
      }
      this.transferData = undefined;
      trackNames.forEach(trackName => {
        const type = trackName;
        const track = transferredTracks[type];
        if (track) {
          const sb = track.buffer;
          if (sb) {
            // Purge fragment tracker of ejected segments for existing buffer
            const fragmentTracker = this.fragmentTracker;
            const playlistType = track.id;
            if (fragmentTracker.hasFragments(playlistType) || fragmentTracker.hasParts(playlistType)) {
              const bufferedTimeRanges = BufferHelper.getBuffered(sb);
              fragmentTracker.detectEvictedFragments(type, bufferedTimeRanges, playlistType, null, true);
            }
            // Transfer SourceBuffer
            const sbIndex = sourceBufferNameToIndex(type);
            const sbTuple = [type, sb];
            this.sourceBuffers[sbIndex] = sbTuple;
            if (sb.updating && this.operationQueue) {
              this.operationQueue.prependBlocker(type);
            }
            this.trackSourceBuffer(type, track);
          }
        }
      });
      mediaSourceOpenCallback();
      this.bufferCreated();
    } else {
      this.log(`attachTransferred: MediaSource w/o SourceBuffers`);
      mediaSourceOpenCallback();
    }
  }
  get mediaSourceOpenOrEnded() {
    var _this$mediaSource2;
    const readyState = (_this$mediaSource2 = this.mediaSource) == null ? void 0 : _this$mediaSource2.readyState;
    return readyState === 'open' || readyState === 'ended';
  }
  onMediaDetaching(event, data) {
    const transferringMedia = !!data.transferMedia;
    this.transferData = this.overrides = undefined;
    const {
      media,
      mediaSource,
      _objectUrl
    } = this;
    if (mediaSource) {
      this.log(`media source ${transferringMedia ? 'transferring' : 'detaching'}`);
      if (transferringMedia) {
        // Detach SourceBuffers without removing from MediaSource
        // and leave `tracks` (required SourceBuffers configuration)
        this.sourceBuffers.forEach(([type]) => {
          if (type) {
            this.removeBuffer(type);
          }
        });
        this.resetQueue();
      } else {
        if (this.mediaSourceOpenOrEnded) {
          const open = mediaSource.readyState === 'open';
          try {
            const sourceBuffers = mediaSource.sourceBuffers;
            for (let i = sourceBuffers.length; i--;) {
              if (open) {
                sourceBuffers[i].abort();
              }
              mediaSource.removeSourceBuffer(sourceBuffers[i]);
            }
            if (open) {
              // endOfStream could trigger exception if any sourcebuffer is in updating state
              // we don't really care about checking sourcebuffer state here,
              // as we are anyway detaching the MediaSource
              // let's just avoid this exception to propagate
              mediaSource.endOfStream();
            }
          } catch (err) {
            this.warn(`onMediaDetaching: ${err.message} while calling endOfStream`);
          }
        }
        // Clean up the SourceBuffers by invoking onBufferReset
        if (this.sourceBufferCount) {
          this.onBufferReset();
        }
      }
      mediaSource.removeEventListener('sourceopen', this._onMediaSourceOpen);
      mediaSource.removeEventListener('sourceended', this._onMediaSourceEnded);
      mediaSource.removeEventListener('sourceclose', this._onMediaSourceClose);
      if (this.appendSource) {
        mediaSource.removeEventListener('startstreaming', this._onStartStreaming);
        mediaSource.removeEventListener('endstreaming', this._onEndStreaming);
      }
      this.mediaSource = null;
      this._objectUrl = null;
    }

    // Detach properly the MediaSource from the HTMLMediaElement as
    // suggested in https://github.com/w3c/media-source/issues/53.
    if (media) {
      media.removeEventListener('emptied', this._onMediaEmptied);
      if (!transferringMedia) {
        if (_objectUrl) {
          self.URL.revokeObjectURL(_objectUrl);
        }

        // clean up video tag src only if it's our own url. some external libraries might
        // hijack the video tag and change its 'src' without destroying the Hls instance first
        if (this.mediaSrc === _objectUrl) {
          media.removeAttribute('src');
          if (this.appendSource) {
            removeSourceChildren(media);
          }
          media.load();
        } else {
          this.warn('media|source.src was changed by a third party - skip cleanup');
        }
      }
      this.media = null;
    }
    this.hls.trigger(Events.MEDIA_DETACHED, data);
  }
  onBufferReset() {
    this.sourceBuffers.forEach(([type]) => {
      if (type) {
        this.resetBuffer(type);
      }
    });
    this.initTracks();
  }
  resetBuffer(type) {
    var _this$tracks$type;
    const sb = (_this$tracks$type = this.tracks[type]) == null ? void 0 : _this$tracks$type.buffer;
    this.removeBuffer(type);
    if (sb) {
      try {
        var _this$mediaSource3;
        if ((_this$mediaSource3 = this.mediaSource) != null && _this$mediaSource3.sourceBuffers.length) {
          this.mediaSource.removeSourceBuffer(sb);
        }
      } catch (err) {
        this.warn(`onBufferReset ${type}`, err);
      }
    }
    delete this.tracks[type];
  }
  removeBuffer(type) {
    this.removeBufferListeners(type);
    this.sourceBuffers[sourceBufferNameToIndex(type)] = [null, null];
    const track = this.tracks[type];
    if (track) {
      track.buffer = undefined;
    }
  }
  resetQueue() {
    if (this.operationQueue) {
      this.operationQueue.destroy();
    }
    this.operationQueue = new BufferOperationQueue(this.tracks);
  }
  onBufferCodecs(event, data) {
    const tracks = this.tracks;
    const trackNames = Object.keys(data);
    this.log(`BUFFER_CODECS: "${trackNames}" (current SB count ${this.sourceBufferCount})`);
    const unmuxedToMuxed = 'audiovideo' in data && (tracks.audio || tracks.video) || tracks.audiovideo && ('audio' in data || 'video' in data);
    const muxedToUnmuxed = !unmuxedToMuxed && this.sourceBufferCount && this.media && trackNames.some(sbName => !tracks[sbName]);
    if (unmuxedToMuxed || muxedToUnmuxed) {
      this.warn(`Unsupported transition between "${Object.keys(tracks)}" and "${trackNames}" SourceBuffers`);
      // Do not add incompatible track ('audiovideo' <-> 'video'/'audio').
      // Allow following onBufferAppending handle to trigger BUFFER_APPEND_ERROR.
      // This will either be resolved by level switch or could be handled with recoverMediaError().
      return;
    }
    trackNames.forEach(trackName => {
      var _this$transferData3, _this$transferData3$t, _trackCodec;
      const parsedTrack = data[trackName];
      const {
        id,
        codec,
        levelCodec,
        container,
        metadata,
        supplemental
      } = parsedTrack;
      let track = tracks[trackName];
      const transferredTrack = (_this$transferData3 = this.transferData) == null ? void 0 : (_this$transferData3$t = _this$transferData3.tracks) == null ? void 0 : _this$transferData3$t[trackName];
      const sbTrack = transferredTrack != null && transferredTrack.buffer ? transferredTrack : track;
      const sbCodec = (sbTrack == null ? void 0 : sbTrack.pendingCodec) || (sbTrack == null ? void 0 : sbTrack.codec);
      const trackLevelCodec = sbTrack == null ? void 0 : sbTrack.levelCodec;
      if (!track) {
        track = tracks[trackName] = {
          buffer: undefined,
          listeners: [],
          codec,
          supplemental,
          container,
          levelCodec,
          metadata,
          id
        };
      }
      // check if SourceBuffer codec needs to change
      const currentCodecFull = pickMostCompleteCodecName(sbCodec, trackLevelCodec);
      const currentCodec = currentCodecFull == null ? void 0 : currentCodecFull.replace(VIDEO_CODEC_PROFILE_REPLACE, '$1');
      let trackCodec = pickMostCompleteCodecName(codec, levelCodec);
      const nextCodec = (_trackCodec = trackCodec) == null ? void 0 : _trackCodec.replace(VIDEO_CODEC_PROFILE_REPLACE, '$1');
      if (trackCodec && currentCodecFull && currentCodec !== nextCodec) {
        if (trackName.slice(0, 5) === 'audio') {
          trackCodec = getCodecCompatibleName(trackCodec, this.appendSource);
        }
        this.log(`switching codec ${sbCodec} to ${trackCodec}`);
        if (trackCodec !== (track.pendingCodec || track.codec)) {
          track.pendingCodec = trackCodec;
        }
        track.container = container;
        this.appendChangeType(trackName, container, trackCodec);
      }
    });
    if (this.tracksReady || this.sourceBufferCount) {
      data.tracks = this.sourceBufferTracks;
    }

    // if sourcebuffers already created, do nothing ...
    if (this.sourceBufferCount) {
      return;
    }
    if (this.mediaSourceOpenOrEnded) {
      this.checkPendingTracks();
    }
  }
  get sourceBufferTracks() {
    return Object.keys(this.tracks).reduce((baseTracks, type) => {
      const track = this.tracks[type];
      baseTracks[type] = {
        id: track.id,
        container: track.container,
        codec: track.codec,
        levelCodec: track.levelCodec
      };
      return baseTracks;
    }, {});
  }
  appendChangeType(type, container, codec) {
    const mimeType = `${container};codecs=${codec}`;
    const operation = {
      label: `change-type=${mimeType}`,
      execute: () => {
        const track = this.tracks[type];
        if (track) {
          const sb = track.buffer;
          if (sb != null && sb.changeType) {
            this.log(`changing ${type} sourceBuffer type to ${mimeType}`);
            sb.changeType(mimeType);
            track.codec = codec;
            track.container = container;
          }
        }
        this.shiftAndExecuteNext(type);
      },
      onStart: () => {},
      onComplete: () => {},
      onError: error => {
        this.warn(`Failed to change ${type} SourceBuffer type`, error);
      }
    };
    this.append(operation, type, this.isPending(this.tracks[type]));
  }
  blockAudio(partOrFrag) {
    var _this$fragmentTracker;
    const pStart = partOrFrag.start;
    const pTime = pStart + partOrFrag.duration * 0.05;
    const atGap = ((_this$fragmentTracker = this.fragmentTracker.getAppendedFrag(pStart, PlaylistLevelType.MAIN)) == null ? void 0 : _this$fragmentTracker.gap) === true;
    if (atGap) {
      return;
    }
    const op = {
      label: 'block-audio',
      execute: () => {
        var _this$fragmentTracker2;
        const videoTrack = this.tracks.video;
        if (this.lastVideoAppendEnd > pTime || videoTrack != null && videoTrack.buffer && BufferHelper.isBuffered(videoTrack.buffer, pTime) || ((_this$fragmentTracker2 = this.fragmentTracker.getAppendedFrag(pTime, PlaylistLevelType.MAIN)) == null ? void 0 : _this$fragmentTracker2.gap) === true) {
          this.blockedAudioAppend = null;
          this.shiftAndExecuteNext('audio');
        }
      },
      onStart: () => {},
      onComplete: () => {},
      onError: error => {
        this.warn('Error executing block-audio operation', error);
      }
    };
    this.blockedAudioAppend = {
      op,
      frag: partOrFrag
    };
    this.append(op, 'audio', true);
  }
  unblockAudio() {
    const {
      blockedAudioAppend,
      operationQueue
    } = this;
    if (blockedAudioAppend && operationQueue) {
      this.blockedAudioAppend = null;
      operationQueue.unblockAudio(blockedAudioAppend.op);
    }
  }
  onBufferAppending(event, eventData) {
    const {
      tracks
    } = this;
    const {
      data,
      type,
      parent,
      frag,
      part,
      chunkMeta
    } = eventData;
    const chunkStats = chunkMeta.buffering[type];
    const sn = frag.sn;
    const bufferAppendingStart = self.performance.now();
    chunkStats.start = bufferAppendingStart;
    const fragBuffering = frag.stats.buffering;
    const partBuffering = part ? part.stats.buffering : null;
    if (fragBuffering.start === 0) {
      fragBuffering.start = bufferAppendingStart;
    }
    if (partBuffering && partBuffering.start === 0) {
      partBuffering.start = bufferAppendingStart;
    }

    // TODO: Only update timestampOffset when audio/mpeg fragment or part is not contiguous with previously appended
    // Adjusting `SourceBuffer.timestampOffset` (desired point in the timeline where the next frames should be appended)
    // in Chrome browser when we detect MPEG audio container and time delta between level PTS and `SourceBuffer.timestampOffset`
    // is greater than 100ms (this is enough to handle seek for VOD or level change for LIVE videos).
    // More info here: https://github.com/video-dev/hls.js/issues/332#issuecomment-257986486
    const audioTrack = tracks.audio;
    let checkTimestampOffset = false;
    if (type === 'audio' && (audioTrack == null ? void 0 : audioTrack.container) === 'audio/mpeg') {
      checkTimestampOffset = !this.lastMpegAudioChunk || chunkMeta.id === 1 || this.lastMpegAudioChunk.sn !== chunkMeta.sn;
      this.lastMpegAudioChunk = chunkMeta;
    }

    // Block audio append until overlapping video append
    const videoTrack = this.tracks.video;
    const videoSb = videoTrack == null ? void 0 : videoTrack.buffer;
    if (videoSb && sn !== 'initSegment') {
      const partOrFrag = part || frag;
      const blockedAudioAppend = this.blockedAudioAppend;
      if (type === 'audio' && parent !== 'main' && !this.blockedAudioAppend) {
        const pStart = partOrFrag.start;
        const pTime = pStart + partOrFrag.duration * 0.05;
        const vbuffered = videoSb.buffered;
        const vappending = this.currentOp('video');
        if (!vbuffered.length && !vappending) {
          // wait for video before appending audio
          this.blockAudio(partOrFrag);
        } else if (!vappending && !BufferHelper.isBuffered(videoSb, pTime) && this.lastVideoAppendEnd < pTime) {
          // audio is ahead of video
          this.blockAudio(partOrFrag);
        }
      } else if (type === 'video') {
        const videoAppendEnd = partOrFrag.end;
        if (blockedAudioAppend) {
          const audioStart = blockedAudioAppend.frag.start;
          if (videoAppendEnd > audioStart || videoAppendEnd < this.lastVideoAppendEnd || BufferHelper.isBuffered(videoSb, audioStart)) {
            this.unblockAudio();
          }
        }
        this.lastVideoAppendEnd = videoAppendEnd;
      }
    }
    const fragStart = (part || frag).start;
    const operation = {
      label: `append-${type}`,
      execute: () => {
        chunkStats.executeStart = self.performance.now();
        if (checkTimestampOffset) {
          const track = this.tracks[type];
          if (track) {
            const sb = track.buffer;
            if (sb) {
              const delta = fragStart - sb.timestampOffset;
              if (Math.abs(delta) >= 0.1) {
                this.log(`Updating audio SourceBuffer timestampOffset to ${fragStart} (delta: ${delta}) sn: ${sn})`);
                sb.timestampOffset = fragStart;
              }
            }
          }
        }
        this.appendExecutor(data, type);
      },
      onStart: () => {
        // logger.debug(`[buffer-controller]: ${type} SourceBuffer updatestart`);
      },
      onComplete: () => {
        // logger.debug(`[buffer-controller]: ${type} SourceBuffer updateend`);
        const end = self.performance.now();
        chunkStats.executeEnd = chunkStats.end = end;
        if (fragBuffering.first === 0) {
          fragBuffering.first = end;
        }
        if (partBuffering && partBuffering.first === 0) {
          partBuffering.first = end;
        }
        const timeRanges = {};
        this.sourceBuffers.forEach(([type, sb]) => {
          if (type) {
            timeRanges[type] = BufferHelper.getBuffered(sb);
          }
        });
        this.appendErrors[type] = 0;
        if (type === 'audio' || type === 'video') {
          this.appendErrors.audiovideo = 0;
        } else {
          this.appendErrors.audio = 0;
          this.appendErrors.video = 0;
        }
        this.hls.trigger(Events.BUFFER_APPENDED, {
          type,
          frag,
          part,
          chunkMeta,
          parent: frag.type,
          timeRanges
        });
      },
      onError: error => {
        var _this$media;
        // in case any error occured while appending, put back segment in segments table
        const event = {
          type: ErrorTypes.MEDIA_ERROR,
          parent: frag.type,
          details: ErrorDetails.BUFFER_APPEND_ERROR,
          sourceBufferName: type,
          frag,
          part,
          chunkMeta,
          error,
          err: error,
          fatal: false
        };
        const mediaError = (_this$media = this.media) == null ? void 0 : _this$media.error;
        if (error.code === DOMException.QUOTA_EXCEEDED_ERR) {
          // QuotaExceededError: http://www.w3.org/TR/html5/infrastructure.html#quotaexceedederror
          // let's stop appending any segments, and report BUFFER_FULL_ERROR error
          event.details = ErrorDetails.BUFFER_FULL_ERROR;
        } else if (error.code === DOMException.INVALID_STATE_ERR && this.mediaSourceOpenOrEnded && !mediaError) {
          // Allow retry for "Failed to execute 'appendBuffer' on 'SourceBuffer': This SourceBuffer is still processing" errors
          event.errorAction = createDoNothingErrorAction(true);
        } else if (error.name === TRACK_REMOVED_ERROR_NAME && this.sourceBufferCount === 0) {
          // Do nothing if sourceBuffers were removed (media is detached and append was not aborted)
          event.errorAction = createDoNothingErrorAction(true);
        } else {
          const appendErrorCount = ++this.appendErrors[type];
          /* with UHD content, we could get loop of quota exceeded error until
            browser is able to evict some data from sourcebuffer. Retrying can help recover.
          */
          this.warn(`Failed ${appendErrorCount}/${this.hls.config.appendErrorMaxRetry} times to append segment in "${type}" sourceBuffer (${mediaError ? mediaError : 'no media error'})`);
          if (appendErrorCount >= this.hls.config.appendErrorMaxRetry || !!mediaError) {
            event.fatal = true;
          }
        }
        this.hls.trigger(Events.ERROR, event);
      }
    };
    this.append(operation, type, this.isPending(this.tracks[type]));
  }
  getFlushOp(type, start, end) {
    this.log(`queuing "${type}" remove ${start}-${end}`);
    return {
      label: 'remove',
      execute: () => {
        this.removeExecutor(type, start, end);
      },
      onStart: () => {
        // logger.debug(`[buffer-controller]: Started flushing ${data.startOffset} -> ${data.endOffset} for ${type} Source Buffer`);
      },
      onComplete: () => {
        // logger.debug(`[buffer-controller]: Finished flushing ${data.startOffset} -> ${data.endOffset} for ${type} Source Buffer`);
        this.hls.trigger(Events.BUFFER_FLUSHED, {
          type
        });
      },
      onError: error => {
        this.warn(`Failed to remove ${start}-${end} from "${type}" SourceBuffer`, error);
      }
    };
  }
  onBufferFlushing(event, data) {
    const {
      type,
      startOffset,
      endOffset
    } = data;
    if (type) {
      this.append(this.getFlushOp(type, startOffset, endOffset), type);
    } else {
      this.sourceBuffers.forEach(([type]) => {
        if (type) {
          this.append(this.getFlushOp(type, startOffset, endOffset), type);
        }
      });
    }
  }
  onFragParsed(event, data) {
    const {
      frag,
      part
    } = data;
    const buffersAppendedTo = [];
    const elementaryStreams = part ? part.elementaryStreams : frag.elementaryStreams;
    if (elementaryStreams[ElementaryStreamTypes.AUDIOVIDEO]) {
      buffersAppendedTo.push('audiovideo');
    } else {
      if (elementaryStreams[ElementaryStreamTypes.AUDIO]) {
        buffersAppendedTo.push('audio');
      }
      if (elementaryStreams[ElementaryStreamTypes.VIDEO]) {
        buffersAppendedTo.push('video');
      }
    }
    const onUnblocked = () => {
      const now = self.performance.now();
      frag.stats.buffering.end = now;
      if (part) {
        part.stats.buffering.end = now;
      }
      const stats = part ? part.stats : frag.stats;
      this.hls.trigger(Events.FRAG_BUFFERED, {
        frag,
        part,
        stats,
        id: frag.type
      });
    };
    if (buffersAppendedTo.length === 0) {
      this.warn(`Fragments must have at least one ElementaryStreamType set. type: ${frag.type} level: ${frag.level} sn: ${frag.sn}`);
    }
    this.blockBuffers(onUnblocked, buffersAppendedTo).catch(error => {
      this.warn(`Fragment buffered callback ${error}`);
      this.stepOperationQueue(this.sourceBufferTypes);
    });
  }
  onFragChanged(event, data) {
    this.trimBuffers();
  }
  get bufferedToEnd() {
    return this.sourceBufferCount > 0 && !this.sourceBuffers.some(([type]) => {
      var _this$tracks$type2, _this$tracks$type3;
      return type && (!((_this$tracks$type2 = this.tracks[type]) != null && _this$tracks$type2.ended) || ((_this$tracks$type3 = this.tracks[type]) == null ? void 0 : _this$tracks$type3.ending));
    });
  }

  // on BUFFER_EOS mark matching sourcebuffer(s) as "ending" and "ended" and queue endOfStream after remaining operations(s)
  // an undefined data.type will mark all buffers as EOS.
  onBufferEos(event, data) {
    var _this$overrides;
    this.sourceBuffers.forEach(([type]) => {
      if (type) {
        const track = this.tracks[type];
        if (!data.type || data.type === type) {
          track.ending = true;
          if (!track.ended) {
            track.ended = true;
            this.log(`${type} buffer reached EOS`);
          }
        }
      }
    });
    const allowEndOfStream = ((_this$overrides = this.overrides) == null ? void 0 : _this$overrides.endOfStream) !== false;
    const allTracksEnding = this.sourceBufferCount > 0 && !this.sourceBuffers.some(([type]) => {
      var _this$tracks$type4;
      return type && !((_this$tracks$type4 = this.tracks[type]) != null && _this$tracks$type4.ended);
    });
    if (allTracksEnding) {
      if (allowEndOfStream) {
        this.log(`Queueing EOS`);
        this.blockUntilOpen(() => {
          this.tracksEnded();
          const {
            mediaSource
          } = this;
          if (!mediaSource || mediaSource.readyState !== 'open') {
            if (mediaSource) {
              this.log(`Could not call mediaSource.endOfStream(). mediaSource.readyState: ${mediaSource.readyState}`);
            }
            return;
          }
          this.log(`Calling mediaSource.endOfStream()`);
          // Allow this to throw and be caught by the enqueueing function
          mediaSource.endOfStream();
          this.hls.trigger(Events.BUFFERED_TO_END, undefined);
        });
      } else {
        this.tracksEnded();
        this.hls.trigger(Events.BUFFERED_TO_END, undefined);
      }
    }
  }
  tracksEnded() {
    this.sourceBuffers.forEach(([type]) => {
      if (type !== null) {
        const track = this.tracks[type];
        if (track) {
          track.ending = false;
        }
      }
    });
  }
  onLevelUpdated(event, {
    details
  }) {
    if (!details.fragments.length) {
      return;
    }
    this.details = details;
    this.updateDuration();
  }
  updateDuration() {
    const durationAndRange = this.getDurationAndRange();
    if (!durationAndRange) {
      return;
    }
    this.blockUntilOpen(() => this.updateMediaSource(durationAndRange));
  }
  onError(event, data) {
    if (data.details === ErrorDetails.BUFFER_APPEND_ERROR && data.frag) {
      var _data$errorAction;
      const nextAutoLevel = (_data$errorAction = data.errorAction) == null ? void 0 : _data$errorAction.nextAutoLevel;
      if (isFiniteNumber(nextAutoLevel) && nextAutoLevel !== data.frag.level) {
        this.resetAppendErrors();
      }
    }
  }
  resetAppendErrors() {
    this.appendErrors = {
      audio: 0,
      video: 0,
      audiovideo: 0
    };
  }
  trimBuffers() {
    const {
      hls,
      details,
      media
    } = this;
    if (!media || details === null) {
      return;
    }
    if (!this.sourceBufferCount) {
      return;
    }
    const config = hls.config;
    const currentTime = media.currentTime;
    const targetDuration = details.levelTargetDuration;

    // Support for deprecated liveBackBufferLength
    const backBufferLength = details.live && config.liveBackBufferLength !== null ? config.liveBackBufferLength : config.backBufferLength;
    if (isFiniteNumber(backBufferLength) && backBufferLength >= 0) {
      const maxBackBufferLength = Math.max(backBufferLength, targetDuration);
      const targetBackBufferPosition = Math.floor(currentTime / targetDuration) * targetDuration - maxBackBufferLength;
      this.flushBackBuffer(currentTime, targetDuration, targetBackBufferPosition);
    }
    if (isFiniteNumber(config.frontBufferFlushThreshold) && config.frontBufferFlushThreshold > 0) {
      const frontBufferLength = Math.max(config.maxBufferLength, config.frontBufferFlushThreshold);
      const maxFrontBufferLength = Math.max(frontBufferLength, targetDuration);
      const targetFrontBufferPosition = Math.floor(currentTime / targetDuration) * targetDuration + maxFrontBufferLength;
      this.flushFrontBuffer(currentTime, targetDuration, targetFrontBufferPosition);
    }
  }
  flushBackBuffer(currentTime, targetDuration, targetBackBufferPosition) {
    this.sourceBuffers.forEach(([type, sb]) => {
      if (sb) {
        const buffered = BufferHelper.getBuffered(sb);
        // when target buffer start exceeds actual buffer start
        if (buffered.length > 0 && targetBackBufferPosition > buffered.start(0)) {
          var _this$details;
          this.hls.trigger(Events.BACK_BUFFER_REACHED, {
            bufferEnd: targetBackBufferPosition
          });

          // Support for deprecated event:
          const track = this.tracks[type];
          if ((_this$details = this.details) != null && _this$details.live) {
            this.hls.trigger(Events.LIVE_BACK_BUFFER_REACHED, {
              bufferEnd: targetBackBufferPosition
            });
          } else if (track != null && track.ended) {
            this.log(`Cannot flush ${type} back buffer while SourceBuffer is in ended state`);
            return;
          }
          this.hls.trigger(Events.BUFFER_FLUSHING, {
            startOffset: 0,
            endOffset: targetBackBufferPosition,
            type
          });
        }
      }
    });
  }
  flushFrontBuffer(currentTime, targetDuration, targetFrontBufferPosition) {
    this.sourceBuffers.forEach(([type, sb]) => {
      if (sb) {
        const buffered = BufferHelper.getBuffered(sb);
        const numBufferedRanges = buffered.length;
        // The buffer is either empty or contiguous
        if (numBufferedRanges < 2) {
          return;
        }
        const bufferStart = buffered.start(numBufferedRanges - 1);
        const bufferEnd = buffered.end(numBufferedRanges - 1);
        // No flush if we can tolerate the current buffer length or the current buffer range we would flush is contiguous with current position
        if (targetFrontBufferPosition > bufferStart || currentTime >= bufferStart && currentTime <= bufferEnd) {
          return;
        }
        this.hls.trigger(Events.BUFFER_FLUSHING, {
          startOffset: bufferStart,
          endOffset: Infinity,
          type
        });
      }
    });
  }

  /**
   * Update Media Source duration to current level duration or override to Infinity if configuration parameter
   * 'liveDurationInfinity` is set to `true`
   * More details: https://github.com/video-dev/hls.js/issues/355
   */
  getDurationAndRange() {
    var _this$overrides2;
    const {
      details,
      mediaSource
    } = this;
    if (!details || !this.media || (mediaSource == null ? void 0 : mediaSource.readyState) !== 'open') {
      return null;
    }
    const playlistEnd = details.edge;
    if (details.live && this.hls.config.liveDurationInfinity) {
      const len = details.fragments.length;
      if (len && details.live && !!mediaSource.setLiveSeekableRange) {
        const start = Math.max(0, details.fragmentStart);
        const end = Math.max(start, playlistEnd);
        return {
          duration: Infinity,
          start,
          end
        };
      }
      return {
        duration: Infinity
      };
    }
    const overrideDuration = (_this$overrides2 = this.overrides) == null ? void 0 : _this$overrides2.duration;
    if (overrideDuration) {
      if (!isFiniteNumber(overrideDuration)) {
        return null;
      }
      return {
        duration: overrideDuration
      };
    }
    const mediaDuration = this.media.duration;
    const msDuration = isFiniteNumber(mediaSource.duration) ? mediaSource.duration : 0;
    if (playlistEnd > msDuration && playlistEnd > mediaDuration || !isFiniteNumber(mediaDuration)) {
      return {
        duration: playlistEnd
      };
    }
    return null;
  }
  updateMediaSource({
    duration,
    start,
    end
  }) {
    const mediaSource = this.mediaSource;
    if (!this.media || !mediaSource || mediaSource.readyState !== 'open') {
      return;
    }
    if (mediaSource.duration !== duration) {
      if (isFiniteNumber(duration)) {
        this.log(`Updating MediaSource duration to ${duration.toFixed(3)}`);
      }
      mediaSource.duration = duration;
    }
    if (start !== undefined && end !== undefined) {
      this.log(`MediaSource duration is set to ${mediaSource.duration}. Setting seekable range to ${start}-${end}.`);
      mediaSource.setLiveSeekableRange(start, end);
    }
  }
  get tracksReady() {
    const pendingTrackCount = this.pendingTrackCount;
    return pendingTrackCount > 0 && (pendingTrackCount >= this.bufferCodecEventsTotal || this.isPending(this.tracks.audiovideo));
  }
  checkPendingTracks() {
    const {
      bufferCodecEventsTotal,
      pendingTrackCount,
      tracks
    } = this;
    this.log(`checkPendingTracks (pending: ${pendingTrackCount} codec events expected: ${bufferCodecEventsTotal}) ${hls_stringify(tracks)}`);
    // Check if we've received all of the expected bufferCodec events. When none remain, create all the sourceBuffers at once.
    // This is important because the MSE spec allows implementations to throw QuotaExceededErrors if creating new sourceBuffers after
    // data has been appended to existing ones.
    // 2 tracks is the max (one for audio, one for video). If we've reach this max go ahead and create the buffers.
    if (this.tracksReady) {
      var _this$transferData4;
      const transferredTracks = (_this$transferData4 = this.transferData) == null ? void 0 : _this$transferData4.tracks;
      if (transferredTracks && Object.keys(transferredTracks).length) {
        this.attachTransferred();
      } else {
        // ok, let's create them now !
        this.createSourceBuffers();
      }
    }
  }
  bufferCreated() {
    if (this.sourceBufferCount) {
      const tracks = {};
      this.sourceBuffers.forEach(([type, buffer]) => {
        if (type) {
          const track = this.tracks[type];
          tracks[type] = {
            buffer,
            container: track.container,
            codec: track.codec,
            supplemental: track.supplemental,
            levelCodec: track.levelCodec,
            id: track.id,
            metadata: track.metadata
          };
        }
      });
      this.hls.trigger(Events.BUFFER_CREATED, {
        tracks
      });
      this.log(`SourceBuffers created. Running queue: ${this.operationQueue}`);
      this.sourceBuffers.forEach(([type]) => {
        this.executeNext(type);
      });
    } else {
      const error = new Error('could not create source buffer for media codec(s)');
      this.hls.trigger(Events.ERROR, {
        type: ErrorTypes.MEDIA_ERROR,
        details: ErrorDetails.BUFFER_INCOMPATIBLE_CODECS_ERROR,
        fatal: true,
        error,
        reason: error.message
      });
    }
  }
  createSourceBuffers() {
    const {
      tracks,
      sourceBuffers,
      mediaSource
    } = this;
    if (!mediaSource) {
      throw new Error('createSourceBuffers called when mediaSource was null');
    }
    for (const trackName in tracks) {
      const type = trackName;
      const track = tracks[type];
      if (this.isPending(track)) {
        const codec = this.getTrackCodec(track, type);
        const mimeType = `${track.container};codecs=${codec}`;
        track.codec = codec;
        this.log(`creating sourceBuffer(${mimeType})${this.currentOp(type) ? ' Queued' : ''} ${hls_stringify(track)}`);
        try {
          const sb = mediaSource.addSourceBuffer(mimeType);
          const sbIndex = sourceBufferNameToIndex(type);
          const sbTuple = [type, sb];
          sourceBuffers[sbIndex] = sbTuple;
          track.buffer = sb;
        } catch (error) {
          var _this$operationQueue;
          this.error(`error while trying to add sourceBuffer: ${error.message}`);
          // remove init segment from queue and delete track info
          this.shiftAndExecuteNext(type);
          (_this$operationQueue = this.operationQueue) == null ? void 0 : _this$operationQueue.removeBlockers();
          delete this.tracks[type];
          this.hls.trigger(Events.ERROR, {
            type: ErrorTypes.MEDIA_ERROR,
            details: ErrorDetails.BUFFER_ADD_CODEC_ERROR,
            fatal: false,
            error,
            sourceBufferName: type,
            mimeType: mimeType,
            parent: track.id
          });
          return;
        }
        this.trackSourceBuffer(type, track);
      }
    }
    this.bufferCreated();
  }
  getTrackCodec(track, trackName) {
    // Use supplemental video codec when supported when adding SourceBuffer (#5558)
    const supplementalCodec = track.supplemental;
    let trackCodec = track.codec;
    if (supplementalCodec && (trackName === 'video' || trackName === 'audiovideo') && areCodecsMediaSourceSupported(supplementalCodec, 'video')) {
      trackCodec = replaceVideoCodec(trackCodec, supplementalCodec);
    }
    const codec = pickMostCompleteCodecName(trackCodec, track.levelCodec);
    if (codec) {
      if (trackName.slice(0, 5) === 'audio') {
        return getCodecCompatibleName(codec, this.appendSource);
      }
      return codec;
    }
    return '';
  }
  trackSourceBuffer(type, track) {
    const buffer = track.buffer;
    if (!buffer) {
      return;
    }
    const codec = this.getTrackCodec(track, type);
    this.tracks[type] = {
      buffer,
      codec,
      container: track.container,
      levelCodec: track.levelCodec,
      supplemental: track.supplemental,
      metadata: track.metadata,
      id: track.id,
      listeners: []
    };
    this.removeBufferListeners(type);
    this.addBufferListener(type, 'updatestart', this.onSBUpdateStart);
    this.addBufferListener(type, 'updateend', this.onSBUpdateEnd);
    this.addBufferListener(type, 'error', this.onSBUpdateError);
    // ManagedSourceBuffer bufferedchange event
    if (this.appendSource) {
      this.addBufferListener(type, 'bufferedchange', (type, event) => {
        // If media was ejected check for a change. Added ranges are redundant with changes on 'updateend' event.
        const removedRanges = event.removedRanges;
        if (removedRanges != null && removedRanges.length) {
          this.hls.trigger(Events.BUFFER_FLUSHED, {
            type: type
          });
        }
      });
    }
  }
  get mediaSrc() {
    var _this$media2, _this$media2$querySel;
    const media = ((_this$media2 = this.media) == null ? void 0 : (_this$media2$querySel = _this$media2.querySelector) == null ? void 0 : _this$media2$querySel.call(_this$media2, 'source')) || this.media;
    return media == null ? void 0 : media.src;
  }
  onSBUpdateStart(type) {
    const operation = this.currentOp(type);
    if (!operation) {
      return;
    }
    operation.onStart();
  }
  onSBUpdateEnd(type) {
    var _this$mediaSource4;
    if (((_this$mediaSource4 = this.mediaSource) == null ? void 0 : _this$mediaSource4.readyState) === 'closed') {
      this.resetBuffer(type);
      return;
    }
    const operation = this.currentOp(type);
    if (!operation) {
      return;
    }
    operation.onComplete();
    this.shiftAndExecuteNext(type);
  }
  onSBUpdateError(type, event) {
    var _this$mediaSource5;
    const error = new Error(`${type} SourceBuffer error. MediaSource readyState: ${(_this$mediaSource5 = this.mediaSource) == null ? void 0 : _this$mediaSource5.readyState}`);
    this.error(`${error}`, event);
    // according to http://www.w3.org/TR/media-source/#sourcebuffer-append-error
    // SourceBuffer errors are not necessarily fatal; if so, the HTMLMediaElement will fire an error event
    this.hls.trigger(Events.ERROR, {
      type: ErrorTypes.MEDIA_ERROR,
      details: ErrorDetails.BUFFER_APPENDING_ERROR,
      sourceBufferName: type,
      error,
      fatal: false
    });
    // updateend is always fired after error, so we'll allow that to shift the current operation off of the queue
    const operation = this.currentOp(type);
    if (operation) {
      operation.onError(error);
    }
  }

  // This method must result in an updateend event; if remove is not called, onSBUpdateEnd must be called manually
  removeExecutor(type, startOffset, endOffset) {
    const {
      media,
      mediaSource
    } = this;
    const track = this.tracks[type];
    const sb = track == null ? void 0 : track.buffer;
    if (!media || !mediaSource || !sb) {
      this.warn(`Attempting to remove from the ${type} SourceBuffer, but it does not exist`);
      this.shiftAndExecuteNext(type);
      return;
    }
    const mediaDuration = isFiniteNumber(media.duration) ? media.duration : Infinity;
    const msDuration = isFiniteNumber(mediaSource.duration) ? mediaSource.duration : Infinity;
    const removeStart = Math.max(0, startOffset);
    const removeEnd = Math.min(endOffset, mediaDuration, msDuration);
    if (removeEnd > removeStart && (!track.ending || track.ended)) {
      track.ended = false;
      this.log(`Removing [${removeStart},${removeEnd}] from the ${type} SourceBuffer`);
      sb.remove(removeStart, removeEnd);
    } else {
      // Cycle the queue
      this.shiftAndExecuteNext(type);
    }
  }

  // This method must result in an updateend event; if append is not called, onSBUpdateEnd must be called manually
  appendExecutor(data, type) {
    const track = this.tracks[type];
    const sb = track == null ? void 0 : track.buffer;
    if (!sb) {
      throw new HlsJsTrackRemovedError(`Attempting to append to the ${type} SourceBuffer, but it does not exist`);
    }
    track.ending = false;
    track.ended = false;
    sb.appendBuffer(data);
  }
  blockUntilOpen(callback) {
    if (this.isUpdating() || this.isQueued()) {
      this.blockBuffers(callback).catch(error => {
        this.warn(`SourceBuffer blocked callback ${error}`);
        this.stepOperationQueue(this.sourceBufferTypes);
      });
    } else {
      try {
        callback();
      } catch (error) {
        this.warn(`Callback run without blocking ${this.operationQueue} ${error}`);
      }
    }
  }
  isUpdating() {
    return this.sourceBuffers.some(([type, sb]) => type && sb.updating);
  }
  isQueued() {
    return this.sourceBuffers.some(([type]) => type && !!this.currentOp(type));
  }
  isPending(track) {
    return !!track && !track.buffer;
  }

  // Enqueues an operation to each SourceBuffer queue which, upon execution, resolves a promise. When all promises
  // resolve, the onUnblocked function is executed. Functions calling this method do not need to unblock the queue
  // upon completion, since we already do it here
  blockBuffers(onUnblocked, bufferNames = this.sourceBufferTypes) {
    if (!bufferNames.length) {
      this.log('Blocking operation requested, but no SourceBuffers exist');
      return Promise.resolve().then(onUnblocked);
    }
    const {
      operationQueue
    } = this;

    // logger.debug(`[buffer-controller]: Blocking ${buffers} SourceBuffer`);
    const blockingOperations = bufferNames.map(type => this.appendBlocker(type));
    const audioBlocked = bufferNames.length > 1 && !!this.blockedAudioAppend;
    if (audioBlocked) {
      this.unblockAudio();
    }
    return Promise.all(blockingOperations).then(result => {
      if (operationQueue !== this.operationQueue) {
        return;
      }
      // logger.debug(`[buffer-controller]: Blocking operation resolved; unblocking ${buffers} SourceBuffer`);
      onUnblocked();
      this.stepOperationQueue(this.sourceBufferTypes);
    });
  }
  stepOperationQueue(bufferNames) {
    bufferNames.forEach(type => {
      var _this$tracks$type5;
      const sb = (_this$tracks$type5 = this.tracks[type]) == null ? void 0 : _this$tracks$type5.buffer;
      // Only cycle the queue if the SB is not updating. There's a bug in Chrome which sets the SB updating flag to
      // true when changing the MediaSource duration (https://bugs.chromium.org/p/chromium/issues/detail?id=959359&can=2&q=mediasource%20duration)
      // While this is a workaround, it's probably useful to have around
      if (!sb || sb.updating) {
        return;
      }
      this.shiftAndExecuteNext(type);
    });
  }
  append(operation, type, pending) {
    if (this.operationQueue) {
      this.operationQueue.append(operation, type, pending);
    }
  }
  appendBlocker(type) {
    if (this.operationQueue) {
      return this.operationQueue.appendBlocker(type);
    }
  }
  currentOp(type) {
    if (this.operationQueue) {
      return this.operationQueue.current(type);
    }
    return null;
  }
  executeNext(type) {
    if (type && this.operationQueue) {
      this.operationQueue.executeNext(type);
    }
  }
  shiftAndExecuteNext(type) {
    if (this.operationQueue) {
      this.operationQueue.shiftAndExecuteNext(type);
    }
  }
  get pendingTrackCount() {
    return Object.keys(this.tracks).reduce((acc, type) => acc + (this.isPending(this.tracks[type]) ? 1 : 0), 0);
  }
  get sourceBufferCount() {
    return this.sourceBuffers.reduce((acc, [type]) => acc + (type ? 1 : 0), 0);
  }
  get sourceBufferTypes() {
    return this.sourceBuffers.map(([type]) => type).filter(type => !!type);
  }
  addBufferListener(type, event, fn) {
    const track = this.tracks[type];
    if (!track) {
      return;
    }
    const buffer = track.buffer;
    if (!buffer) {
      return;
    }
    const listener = fn.bind(this, type);
    track.listeners.push({
      event,
      listener
    });
    buffer.addEventListener(event, listener);
  }
  removeBufferListeners(type) {
    const track = this.tracks[type];
    if (!track) {
      return;
    }
    const buffer = track.buffer;
    if (!buffer) {
      return;
    }
    track.listeners.forEach(l => {
      buffer.removeEventListener(l.event, l.listener);
    });
    track.listeners.length = 0;
  }
}
function removeSourceChildren(node) {
  const sourceChildren = node.querySelectorAll('source');
  [].slice.call(sourceChildren).forEach(source => {
    node.removeChild(source);
  });
}
function addSource(media, url) {
  const source = self.document.createElement('source');
  source.type = 'video/mp4';
  source.src = url;
  media.appendChild(source);
}
function sourceBufferNameToIndex(type) {
  return type === 'audio' ? 1 : 0;
}

class CapLevelController {
  constructor(hls) {
    this.hls = void 0;
    this.autoLevelCapping = void 0;
    this.firstLevel = void 0;
    this.media = void 0;
    this.restrictedLevels = void 0;
    this.timer = void 0;
    this.clientRect = void 0;
    this.streamController = void 0;
    this.hls = hls;
    this.autoLevelCapping = Number.POSITIVE_INFINITY;
    this.firstLevel = -1;
    this.media = null;
    this.restrictedLevels = [];
    this.timer = undefined;
    this.clientRect = null;
    this.registerListeners();
  }
  setStreamController(streamController) {
    this.streamController = streamController;
  }
  destroy() {
    if (this.hls) {
      this.unregisterListener();
    }
    if (this.timer) {
      this.stopCapping();
    }
    this.media = null;
    this.clientRect = null;
    // @ts-ignore
    this.hls = this.streamController = null;
  }
  registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this);
    hls.on(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
    hls.on(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.on(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
    hls.on(Events.BUFFER_CODECS, this.onBufferCodecs, this);
    hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
  }
  unregisterListener() {
    const {
      hls
    } = this;
    hls.off(Events.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this);
    hls.off(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
    hls.off(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.off(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
    hls.off(Events.BUFFER_CODECS, this.onBufferCodecs, this);
    hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
  }
  onFpsDropLevelCapping(event, data) {
    // Don't add a restricted level more than once
    const level = this.hls.levels[data.droppedLevel];
    if (this.isLevelAllowed(level)) {
      this.restrictedLevels.push({
        bitrate: level.bitrate,
        height: level.height,
        width: level.width
      });
    }
  }
  onMediaAttaching(event, data) {
    this.media = data.media instanceof HTMLVideoElement ? data.media : null;
    this.clientRect = null;
    if (this.timer && this.hls.levels.length) {
      this.detectPlayerSize();
    }
  }
  onManifestParsed(event, data) {
    const hls = this.hls;
    this.restrictedLevels = [];
    this.firstLevel = data.firstLevel;
    if (hls.config.capLevelToPlayerSize && data.video) {
      // Start capping immediately if the manifest has signaled video codecs
      this.startCapping();
    }
  }
  onLevelsUpdated(event, data) {
    if (this.timer && isFiniteNumber(this.autoLevelCapping)) {
      this.detectPlayerSize();
    }
  }

  // Only activate capping when playing a video stream; otherwise, multi-bitrate audio-only streams will be restricted
  // to the first level
  onBufferCodecs(event, data) {
    const hls = this.hls;
    if (hls.config.capLevelToPlayerSize && data.video) {
      // If the manifest did not signal a video codec capping has been deferred until we're certain video is present
      this.startCapping();
    }
  }
  onMediaDetaching() {
    this.stopCapping();
    this.media = null;
  }
  detectPlayerSize() {
    if (this.media) {
      if (this.mediaHeight <= 0 || this.mediaWidth <= 0) {
        this.clientRect = null;
        return;
      }
      const levels = this.hls.levels;
      if (levels.length) {
        const hls = this.hls;
        const maxLevel = this.getMaxLevel(levels.length - 1);
        if (maxLevel !== this.autoLevelCapping) {
          hls.logger.log(`Setting autoLevelCapping to ${maxLevel}: ${levels[maxLevel].height}p@${levels[maxLevel].bitrate} for media ${this.mediaWidth}x${this.mediaHeight}`);
        }
        hls.autoLevelCapping = maxLevel;
        if (hls.autoLevelEnabled && hls.autoLevelCapping > this.autoLevelCapping && this.streamController) {
          // if auto level capping has a higher value for the previous one, flush the buffer using nextLevelSwitch
          // usually happen when the user go to the fullscreen mode.
          this.streamController.nextLevelSwitch();
        }
        this.autoLevelCapping = hls.autoLevelCapping;
      }
    }
  }

  /*
   * returns level should be the one with the dimensions equal or greater than the media (player) dimensions (so the video will be downscaled)
   */
  getMaxLevel(capLevelIndex) {
    const levels = this.hls.levels;
    if (!levels.length) {
      return -1;
    }
    const validLevels = levels.filter((level, index) => this.isLevelAllowed(level) && index <= capLevelIndex);
    this.clientRect = null;
    return CapLevelController.getMaxLevelByMediaSize(validLevels, this.mediaWidth, this.mediaHeight);
  }
  startCapping() {
    if (this.timer) {
      // Don't reset capping if started twice; this can happen if the manifest signals a video codec
      return;
    }
    this.autoLevelCapping = Number.POSITIVE_INFINITY;
    self.clearInterval(this.timer);
    this.timer = self.setInterval(this.detectPlayerSize.bind(this), 1000);
    this.detectPlayerSize();
  }
  stopCapping() {
    this.restrictedLevels = [];
    this.firstLevel = -1;
    this.autoLevelCapping = Number.POSITIVE_INFINITY;
    if (this.timer) {
      self.clearInterval(this.timer);
      this.timer = undefined;
    }
  }
  getDimensions() {
    if (this.clientRect) {
      return this.clientRect;
    }
    const media = this.media;
    const boundsRect = {
      width: 0,
      height: 0
    };
    if (media) {
      const clientRect = media.getBoundingClientRect();
      boundsRect.width = clientRect.width;
      boundsRect.height = clientRect.height;
      if (!boundsRect.width && !boundsRect.height) {
        // When the media element has no width or height (equivalent to not being in the DOM),
        // then use its width and height attributes (media.width, media.height)
        boundsRect.width = clientRect.right - clientRect.left || media.width || 0;
        boundsRect.height = clientRect.bottom - clientRect.top || media.height || 0;
      }
    }
    this.clientRect = boundsRect;
    return boundsRect;
  }
  get mediaWidth() {
    return this.getDimensions().width * this.contentScaleFactor;
  }
  get mediaHeight() {
    return this.getDimensions().height * this.contentScaleFactor;
  }
  get contentScaleFactor() {
    let pixelRatio = 1;
    if (!this.hls.config.ignoreDevicePixelRatio) {
      try {
        pixelRatio = self.devicePixelRatio;
      } catch (e) {
        /* no-op */
      }
    }
    return Math.min(pixelRatio, this.hls.config.maxDevicePixelRatio);
  }
  isLevelAllowed(level) {
    const restrictedLevels = this.restrictedLevels;
    return !restrictedLevels.some(restrictedLevel => {
      return level.bitrate === restrictedLevel.bitrate && level.width === restrictedLevel.width && level.height === restrictedLevel.height;
    });
  }
  static getMaxLevelByMediaSize(levels, width, height) {
    if (!(levels != null && levels.length)) {
      return -1;
    }

    // Levels can have the same dimensions but differing bandwidths - since levels are ordered, we can look to the next
    // to determine whether we've chosen the greatest bandwidth for the media's dimensions
    const atGreatestBandwidth = (curLevel, nextLevel) => {
      if (!nextLevel) {
        return true;
      }
      return curLevel.width !== nextLevel.width || curLevel.height !== nextLevel.height;
    };

    // If we run through the loop without breaking, the media's dimensions are greater than every level, so default to
    // the max level
    let maxLevelIndex = levels.length - 1;
    // Prevent changes in aspect-ratio from causing capping to toggle back and forth
    const squareSize = Math.max(width, height);
    for (let i = 0; i < levels.length; i += 1) {
      const level = levels[i];
      if ((level.width >= squareSize || level.height >= squareSize) && atGreatestBandwidth(level, levels[i + 1])) {
        maxLevelIndex = i;
        break;
      }
    }
    return maxLevelIndex;
  }
}

/**
 * Common Media Object Type
 *
 * @internal
 */
const CmObjectType = {
  /**
   * text file, such as a manifest or playlist
   */
  MANIFEST: 'm',
  /**
   * audio only
   */
  AUDIO: 'a',
  /**
   * video only
   */
  VIDEO: 'v',
  /**
   * muxed audio and video
   */
  MUXED: 'av',
  /**
   * init segment
   */
  INIT: 'i',
  /**
   * caption or subtitle
   */
  CAPTION: 'c',
  /**
   * ISOBMFF timed text track
   */
  TIMED_TEXT: 'tt',
  /**
   * cryptographic key, license or certificate.
   */
  KEY: 'k',
  /**
   * other
   */
  OTHER: 'o'
};

/**
 * Common Media Client Data Object Type
 *
 * @group CMCD
 *
 * @beta
 *
 * @enum
 */
const CmcdObjectType = CmObjectType;

/**
 * Common Media Streaming Format
 *
 * @internal
 */
const CmStreamingFormat = {
  /**
   * HTTP Live Streaming (HLS)
   */
  HLS: 'h'};

/**
 * Common Media Client Data Streaming Format
 *
 * @group CMCD
 *
 * @enum
 *
 * @beta
 */
const CmcdStreamingFormat = CmStreamingFormat;

/**
 * CMCD object header name.
 *
 * @group CMCD
 *
 * @beta
 */
const CMCD_OBJECT = 'CMCD-Object';

/**
 * CMCD request header name.
 *
 * @group CMCD
 *
 * @beta
 */
const CMCD_REQUEST = 'CMCD-Request';

/**
 * CMCD session header name.
 *
 * @group CMCD
 *
 * @beta
 */
const CMCD_SESSION = 'CMCD-Session';

/**
 * CMCD status header name.
 *
 * @group CMCD
 *
 * @beta
 */
const CMCD_STATUS = 'CMCD-Status';

/**
 * CMCD header fields.
 *
 * @group CMCD
 *
 * @enum
 *
 * @beta
 */
const CmcdHeaderField = {
  /**
   * keys whose values vary with the object being requested.
   */
  OBJECT: CMCD_OBJECT,
  /**
   * keys whose values vary with each request.
   */
  REQUEST: CMCD_REQUEST,
  /**
   * keys whose values are expected to be invariant over the life of the session.
   */
  SESSION: CMCD_SESSION,
  /**
   * keys whose values do not vary with every request or object.
   */
  STATUS: CMCD_STATUS
};

/**
 * The map of CMCD header fields to official CMCD keys.
 *
 * @internal
 *
 * @group CMCD
 */
const CmcdHeaderMap = {
  [CmcdHeaderField.OBJECT]: ['br', 'd', 'ot', 'tb'],
  [CmcdHeaderField.REQUEST]: ['bl', 'dl', 'mtp', 'nor', 'nrr', 'su'],
  [CmcdHeaderField.SESSION]: ['cid', 'pr', 'sf', 'sid', 'st', 'v'],
  [CmcdHeaderField.STATUS]: ['bs', 'rtp']
};

/**
 * Structured Field Item
 *
 * @group Structured Field
 *
 * @beta
 */
class SfItem {
  constructor(value, params) {
    if (Array.isArray(value)) {
      value = value.map(v => v instanceof SfItem ? v : new SfItem(v));
    }
    this.value = value;
    this.params = params;
  }
}

const DICT = 'Dict';

function hls_format(value) {
  if (Array.isArray(value)) {
    return JSON.stringify(value);
  }
  if (value instanceof Map) {
    return 'Map{}';
  }
  if (value instanceof Set) {
    return 'Set{}';
  }
  if (typeof value === 'object') {
    return JSON.stringify(value);
  }
  return String(value);
}
function throwError(action, src, type, cause) {
  return new Error(`failed to ${action} "${hls_format(src)}" as ${type}`, {
    cause
  });
}

function serializeError(src, type, cause) {
  return throwError('serialize', src, type, cause);
}

/**
 * A class to represent structured field tokens when `Symbol` is not available.
 *
 * @group Structured Field
 *
 * @beta
 */
class SfToken {
  constructor(description) {
    this.description = description;
  }
}

const BARE_ITEM = 'Bare Item';

const BOOLEAN = 'Boolean';

// 4.1.9.  Serializing a Boolean
//
// Given a Boolean as input_boolean, return an ASCII string suitable for
// use in a HTTP field value.
//
// 1.  If input_boolean is not a boolean, fail serialization.
//
// 2.  Let output be an empty string.
//
// 3.  Append "?" to output.
//
// 4.  If input_boolean is true, append "1" to output.
//
// 5.  If input_boolean is false, append "0" to output.
//
// 6.  Return output.
function serializeBoolean(value) {
  if (typeof value !== 'boolean') {
    throw serializeError(value, BOOLEAN);
  }
  return value ? '?1' : '?0';
}

/**
 * Encodes binary data to base64
 *
 * @param binary - The binary data to encode
 * @returns The base64 encoded string
 *
 * @group Utils
 *
 * @beta
 */
function base64encode(binary) {
  return btoa(String.fromCharCode(...binary));
}

const BYTES = 'Byte Sequence';

// 4.1.8.  Serializing a Byte Sequence
//
// Given a Byte Sequence as input_bytes, return an ASCII string suitable
// for use in a HTTP field value.
//
// 1.  If input_bytes is not a sequence of bytes, fail serialization.
//
// 2.  Let output be an empty string.
//
// 3.  Append ":" to output.
//
// 4.  Append the result of base64-encoding input_bytes as per
//     [RFC4648], Section 4, taking account of the requirements below.
//
// 5.  Append ":" to output.
//
// 6.  Return output.
//
// The encoded data is required to be padded with "=", as per [RFC4648],
// Section 3.2.
//
// Likewise, encoded data SHOULD have pad bits set to zero, as per
// [RFC4648], Section 3.5, unless it is not possible to do so due to
// implementation constraints.
function serializeByteSequence(value) {
  if (ArrayBuffer.isView(value) === false) {
    throw serializeError(value, BYTES);
  }
  return `:${base64encode(value)}:`;
}

const INTEGER = 'Integer';

function isInvalidInt(value) {
  return value < -999999999999999 || 999999999999999 < value;
}

// 4.1.4.  Serializing an Integer
//
// Given an Integer as input_integer, return an ASCII string suitable
// for use in a HTTP field value.
//
// 1.  If input_integer is not an integer in the range of
//     -999,999,999,999,999 to 999,999,999,999,999 inclusive, fail
//     serialization.
//
// 2.  Let output be an empty string.
//
// 3.  If input_integer is less than (but not equal to) 0, append "-" to
//     output.
//
// 4.  Append input_integer's numeric value represented in base 10 using
//     only decimal digits to output.
//
// 5.  Return output.
function serializeInteger(value) {
  if (isInvalidInt(value)) {
    throw serializeError(value, INTEGER);
  }
  return value.toString();
}

// 4.1.10.  Serializing a Date
//
// Given a Date as input_integer, return an ASCII string suitable for
// use in an HTTP field value.
// 1.  Let output be "@".
// 2.  Append to output the result of running Serializing an Integer
//     with input_date (Section 4.1.4).
// 3.  Return output.
function serializeDate(value) {
  return `@${serializeInteger(value.getTime() / 1000)}`;
}

/**
 * This implements the rounding procedure described in step 2 of the "Serializing a Decimal" specification.
 * This rounding style is known as "even rounding", "banker's rounding", or "commercial rounding".
 *
 * @param value - The value to round
 * @param precision - The number of decimal places to round to
 * @returns The rounded value
 *
 * @group Utils
 *
 * @beta
 */
function roundToEven(value, precision) {
  if (value < 0) {
    return -roundToEven(-value, precision);
  }
  const decimalShift = Math.pow(10, precision);
  const isEquidistant = Math.abs(value * decimalShift % 1 - 0.5) < Number.EPSILON;
  if (isEquidistant) {
    // If the tail of the decimal place is 'equidistant' we round to the nearest even value
    const flooredValue = Math.floor(value * decimalShift);
    return (flooredValue % 2 === 0 ? flooredValue : flooredValue + 1) / decimalShift;
  } else {
    // Otherwise, proceed as normal
    return Math.round(value * decimalShift) / decimalShift;
  }
}

const DECIMAL = 'Decimal';

// 4.1.5.  Serializing a Decimal
//
// Given a decimal number as input_decimal, return an ASCII string
// suitable for use in a HTTP field value.
//
// 1.   If input_decimal is not a decimal number, fail serialization.
//
// 2.   If input_decimal has more than three significant digits to the
//      right of the decimal point, round it to three decimal places,
//      rounding the final digit to the nearest value, or to the even
//      value if it is equidistant.
//
// 3.   If input_decimal has more than 12 significant digits to the left
//      of the decimal point after rounding, fail serialization.
//
// 4.   Let output be an empty string.
//
// 5.   If input_decimal is less than (but not equal to) 0, append "-"
//      to output.
//
// 6.   Append input_decimal's integer component represented in base 10
//      (using only decimal digits) to output; if it is zero, append
//      "0".
//
// 7.   Append "." to output.
//
// 8.   If input_decimal's fractional component is zero, append "0" to
//      output.
//
// 9.   Otherwise, append the significant digits of input_decimal's
//      fractional component represented in base 10 (using only decimal
//      digits) to output.
//
// 10.  Return output.
function serializeDecimal(value) {
  const roundedValue = roundToEven(value, 3); // round to 3 decimal places
  if (Math.floor(Math.abs(roundedValue)).toString().length > 12) {
    throw serializeError(value, DECIMAL);
  }
  const stringValue = roundedValue.toString();
  return stringValue.includes('.') ? stringValue : `${stringValue}.0`;
}

const STRING = 'String';

const STRING_REGEX = /[\x00-\x1f\x7f]+/;

// 4.1.6.  Serializing a String
//
// Given a String as input_string, return an ASCII string suitable for
// use in a HTTP field value.
//
// 1.  Convert input_string into a sequence of ASCII characters; if
//     conversion fails, fail serialization.
//
// 2.  If input_string contains characters in the range %x00-1f or %x7f
//     (i.e., not in VCHAR or SP), fail serialization.
//
// 3.  Let output be the string DQUOTE.
//
// 4.  For each character char in input_string:
//
//     1.  If char is "\" or DQUOTE:
//
//         1.  Append "\" to output.
//
//     2.  Append char to output.
//
// 5.  Append DQUOTE to output.
//
// 6.  Return output.
function serializeString(value) {
  if (STRING_REGEX.test(value)) {
    throw serializeError(value, STRING);
  }
  return `"${value.replace(/\\/g, `\\\\`).replace(/"/g, `\\"`)}"`;
}

/**
 * Converts a symbol to a string.
 *
 * @param symbol - The symbol to convert.
 *
 * @returns The string representation of the symbol.
 *
 * @internal
 */
function symbolToStr(symbol) {
  return symbol.description || symbol.toString().slice(7, -1);
}

const hls_TOKEN = 'Token';

function serializeToken(token) {
  const value = symbolToStr(token);
  if (/^([a-zA-Z*])([!#$%&'*+\-.^_`|~\w:/]*)$/.test(value) === false) {
    throw serializeError(value, hls_TOKEN);
  }
  return value;
}

// 4.1.3.1.  Serializing a Bare Item
//
// Given an Item as input_item, return an ASCII string suitable for use
// in a HTTP field value.
//
// 1.  If input_item is an Integer, return the result of running
//     Serializing an Integer (Section 4.1.4) with input_item.
//
// 2.  If input_item is a Decimal, return the result of running
//     Serializing a Decimal (Section 4.1.5) with input_item.
//
// 3.  If input_item is a String, return the result of running
//     Serializing a String (Section 4.1.6) with input_item.
//
// 4.  If input_item is a Token, return the result of running
//     Serializing a Token (Section 4.1.7) with input_item.
//
// 5.  If input_item is a Boolean, return the result of running
//     Serializing a Boolean (Section 4.1.9) with input_item.
//
// 6.  If input_item is a Byte Sequence, return the result of running
//     Serializing a Byte Sequence (Section 4.1.8) with input_item.
//
// 7.  If input_item is a Date, return the result of running Serializing
//     a Date (Section 4.1.10) with input_item.
//
// 8.  Otherwise, fail serialization.
function serializeBareItem(value) {
  switch (typeof value) {
    case 'number':
      if (!isFiniteNumber(value)) {
        throw serializeError(value, BARE_ITEM);
      }
      if (Number.isInteger(value)) {
        return serializeInteger(value);
      }
      return serializeDecimal(value);
    case 'string':
      return serializeString(value);
    case 'symbol':
      return serializeToken(value);
    case 'boolean':
      return serializeBoolean(value);
    case 'object':
      if (value instanceof Date) {
        return serializeDate(value);
      }
      if (value instanceof Uint8Array) {
        return serializeByteSequence(value);
      }
      if (value instanceof SfToken) {
        return serializeToken(value);
      }
    default:
      // fail
      throw serializeError(value, BARE_ITEM);
  }
}

const hls_KEY = 'Key';

// 4.1.1.3.  Serializing a Key
//
// Given a key as input_key, return an ASCII string suitable for use in
// a HTTP field value.
//
// 1.  Convert input_key into a sequence of ASCII characters; if
//     conversion fails, fail serialization.
//
// 2.  If input_key contains characters not in lcalpha, DIGIT, "_", "-",
//     ".", or "*" fail serialization.
//
// 3.  If the first character of input_key is not lcalpha or "*", fail
//     serialization.
//
// 4.  Let output be an empty string.
//
// 5.  Append input_key to output.
//
// 6.  Return output.
function serializeKey(value) {
  if (/^[a-z*][a-z0-9\-_.*]*$/.test(value) === false) {
    throw serializeError(value, hls_KEY);
  }
  return value;
}

// 4.1.1.2.  Serializing Parameters
//
// Given an ordered Dictionary as input_parameters (each member having a
// param_name and a param_value), return an ASCII string suitable for
// use in a HTTP field value.
//
// 1.  Let output be an empty string.
//
// 2.  For each param_name with a value of param_value in
//     input_parameters:
//
//     1.  Append ";" to output.
//
//     2.  Append the result of running Serializing a Key
//         (Section 4.1.1.3) with param_name to output.
//
//     3.  If param_value is not Boolean true:
//
//         1.  Append "=" to output.
//
//         2.  Append the result of running Serializing a bare Item
//             (Section 4.1.3.1) with param_value to output.
//
// 3.  Return output.
function serializeParams(params) {
  if (params == null) {
    return '';
  }
  return Object.entries(params).map(([key, value]) => {
    if (value === true) {
      return `;${serializeKey(key)}`; // omit true
    }
    return `;${serializeKey(key)}=${serializeBareItem(value)}`;
  }).join('');
}

// 4.1.3.  Serializing an Item
//
// Given an Item as bare_item and Parameters as item_parameters, return
// an ASCII string suitable for use in a HTTP field value.
//
// 1.  Let output be an empty string.
//
// 2.  Append the result of running Serializing a Bare Item
//     Section 4.1.3.1 with bare_item to output.
//
// 3.  Append the result of running Serializing Parameters
//     Section 4.1.1.2 with item_parameters to output.
//
// 4.  Return output.
function serializeItem(value) {
  if (value instanceof SfItem) {
    return `${serializeBareItem(value.value)}${serializeParams(value.params)}`;
  } else {
    return serializeBareItem(value);
  }
}

// 4.1.1.1.  Serializing an Inner List
//
// Given an array of (member_value, parameters) tuples as inner_list,
// and parameters as list_parameters, return an ASCII string suitable
// for use in a HTTP field value.
//
// 1.  Let output be the string "(".
//
// 2.  For each (member_value, parameters) of inner_list:
//
//     1.  Append the result of running Serializing an Item
//         (Section 4.1.3) with (member_value, parameters) to output.
//
//     2.  If more values remain in inner_list, append a single SP to
//         output.
//
// 3.  Append ")" to output.
//
// 4.  Append the result of running Serializing Parameters
//     (Section 4.1.1.2) with list_parameters to output.
//
// 5.  Return output.
function serializeInnerList(value) {
  return `(${value.value.map(serializeItem).join(' ')})${serializeParams(value.params)}`;
}

// 4.1.2.  Serializing a Dictionary
//
// Given an ordered Dictionary as input_dictionary (each member having a
// member_name and a tuple value of (member_value, parameters)), return
// an ASCII string suitable for use in a HTTP field value.
//
// 1.  Let output be an empty string.
//
// 2.  For each member_name with a value of (member_value, parameters)
//     in input_dictionary:
//
//     1.  Append the result of running Serializing a Key
//         (Section 4.1.1.3) with member's member_name to output.
//
//     2.  If member_value is Boolean true:
//
//         1.  Append the result of running Serializing Parameters
//             (Section 4.1.1.2) with parameters to output.
//
//     3.  Otherwise:
//
//         1.  Append "=" to output.
//
//         2.  If member_value is an array, append the result of running
//             Serializing an Inner List (Section 4.1.1.1) with
//             (member_value, parameters) to output.
//
//         3.  Otherwise, append the result of running Serializing an
//             Item (Section 4.1.3) with (member_value, parameters) to
//             output.
//
//     4.  If more members remain in input_dictionary:
//
//         1.  Append "," to output.
//
//         2.  Append a single SP to output.
//
// 3.  Return output.
function serializeDict(dict, options = {
  whitespace: true
}) {
  if (typeof dict !== 'object') {
    throw serializeError(dict, DICT);
  }
  const entries = dict instanceof Map ? dict.entries() : Object.entries(dict);
  const optionalWhiteSpace = (options === null || options === void 0 ? void 0 : options.whitespace) ? ' ' : '';
  return Array.from(entries).map(([key, item]) => {
    if (item instanceof SfItem === false) {
      item = new SfItem(item);
    }
    let output = serializeKey(key);
    if (item.value === true) {
      output += serializeParams(item.params);
    } else {
      output += '=';
      if (Array.isArray(item.value)) {
        output += serializeInnerList(item);
      } else {
        output += serializeItem(item);
      }
    }
    return output;
  }).join(`,${optionalWhiteSpace}`);
}

/**
 * Encode an object into a structured field dictionary
 *
 * @param value - The structured field dictionary to encode
 * @param options - Encoding options
 *
 * @returns The structured field string
 *
 * @group Structured Field
 *
 * @beta
 */
function encodeSfDict(value, options) {
  return serializeDict(value, options);
}

/**
 * Checks if the given key is a token field.
 *
 * @param key - The key to check.
 *
 * @returns `true` if the key is a token field.
 *
 * @internal
 */
function isTokenField(key) {
  return key === 'ot' || key === 'sf' || key === 'st';
}

/**
 * Checks if the given value is valid
 *
 * @param value - The value to check.
 *
 * @returns `true` if the key is a value is valid.
 *
 * @internal
 */
function hls_isValid(value) {
  if (typeof value === 'number') {
    return isFiniteNumber(value);
  }
  return value != null && value !== '' && value !== false;
}

/**
 * Constructs a relative path from a URL.
 *
 * @param url - The destination URL
 * @param base - The base URL
 * @returns The relative path
 *
 * @group Utils
 *
 * @beta
 */
function urlToRelativePath(url, base) {
  const to = new URL(url);
  const from = new URL(base);
  if (to.origin !== from.origin) {
    return url;
  }
  const toPath = to.pathname.split('/').slice(1);
  const fromPath = from.pathname.split('/').slice(1, -1);
  // remove common parents
  while (toPath[0] === fromPath[0]) {
    toPath.shift();
    fromPath.shift();
  }
  // add back paths
  while (fromPath.length) {
    fromPath.shift();
    toPath.unshift('..');
  }
  return toPath.join('/');
}

const toRounded = value => Math.round(value);
const toUrlSafe = (value, options) => {
  if (options === null || options === void 0 ? void 0 : options.baseUrl) {
    value = urlToRelativePath(value, options.baseUrl);
  }
  return encodeURIComponent(value);
};
const toHundred = value => toRounded(value / 100) * 100;
/**
 * The default formatters for CMCD values.
 *
 * @group CMCD
 *
 * @beta
 */
const CmcdFormatters = {
  /**
   * Bitrate (kbps) rounded integer
   */
  br: toRounded,
  /**
   * Duration (milliseconds) rounded integer
   */
  d: toRounded,
  /**
   * Buffer Length (milliseconds) rounded nearest 100ms
   */
  bl: toHundred,
  /**
   * Deadline (milliseconds) rounded nearest 100ms
   */
  dl: toHundred,
  /**
   * Measured Throughput (kbps) rounded nearest 100kbps
   */
  mtp: toHundred,
  /**
   * Next Object Request URL encoded
   */
  nor: toUrlSafe,
  /**
   * Requested maximum throughput (kbps) rounded nearest 100kbps
   */
  rtp: toHundred,
  /**
   * Top Bitrate (kbps) rounded integer
   */
  tb: toRounded
};

/**
 * Internal CMCD processing function.
 *
 * @param obj - The CMCD object to process.
 * @param map - The mapping function to use.
 * @param options - Options for encoding.
 *
 * @internal
 *
 * @group CMCD
 */
function processCmcd(obj, options) {
  const results = {};
  if (obj == null || typeof obj !== 'object') {
    return results;
  }
  const keys = Object.keys(obj).sort();
  const formatters = _extends({}, CmcdFormatters, options === null || options === void 0 ? void 0 : options.formatters);
  const filter = options === null || options === void 0 ? void 0 : options.filter;
  keys.forEach(key => {
    if (filter === null || filter === void 0 ? void 0 : filter(key)) {
      return;
    }
    let value = obj[key];
    const formatter = formatters[key];
    if (formatter) {
      value = formatter(value, options);
    }
    // Version should only be reported if not equal to 1.
    if (key === 'v' && value === 1) {
      return;
    }
    // Playback rate should only be sent if not equal to 1.
    if (key == 'pr' && value === 1) {
      return;
    }
    // ignore invalid values
    if (!hls_isValid(value)) {
      return;
    }
    if (isTokenField(key) && typeof value === 'string') {
      value = new SfToken(value);
    }
    results[key] = value;
  });
  return results;
}

/**
 * Encode a CMCD object to a string.
 *
 * @param cmcd - The CMCD object to encode.
 * @param options - Options for encoding.
 *
 * @returns The encoded CMCD string.
 *
 * @group CMCD
 *
 * @beta
 */
function encodeCmcd(cmcd, options = {}) {
  if (!cmcd) {
    return '';
  }
  return encodeSfDict(processCmcd(cmcd, options), _extends({
    whitespace: false
  }, options));
}

/**
 * Convert a CMCD data object to request headers
 *
 * @param cmcd - The CMCD data object to convert.
 * @param options - Options for encoding the CMCD object.
 *
 * @returns The CMCD header shards.
 *
 * @group CMCD
 *
 * @beta
 */
function toCmcdHeaders(cmcd, options = {}) {
  const result = {};
  if (!cmcd) {
    return result;
  }
  const entries = Object.entries(cmcd);
  const headerMap = Object.entries(CmcdHeaderMap).concat(Object.entries((options === null || options === void 0 ? void 0 : options.customHeaderMap) || {}));
  const shards = entries.reduce((acc, entry) => {
    var _a, _b;
    const [key, value] = entry;
    const field = ((_a = headerMap.find(entry => entry[1].includes(key))) === null || _a === void 0 ? void 0 : _a[0]) || CmcdHeaderField.REQUEST;
    (_b = acc[field]) !== null && _b !== void 0 ? _b : acc[field] = {};
    acc[field][key] = value;
    return acc;
  }, {});
  return Object.entries(shards).reduce((acc, [field, value]) => {
    acc[field] = encodeCmcd(value, options);
    return acc;
  }, result);
}

/**
 * Append CMCD query args to a header object.
 *
 * @param headers - The headers to append to.
 * @param cmcd - The CMCD object to append.
 * @param options - Encode options.
 *
 * @returns The headers with the CMCD header shards appended.
 *
 * @group CMCD
 *
 * @beta
 */
function appendCmcdHeaders(headers, cmcd, options) {
  return _extends(headers, toCmcdHeaders(cmcd, options));
}

/**
 * CMCD parameter name.
 *
 * @group CMCD
 *
 * @beta
 */
const CMCD_PARAM = 'CMCD';

/**
 * Convert a CMCD data object to a query arg.
 *
 * @param cmcd - The CMCD object to convert.
 * @param options - Options for encoding the CMCD object.
 *
 * @returns The CMCD query arg.
 *
 * @group CMCD
 *
 * @beta
 */
function toCmcdQuery(cmcd, options = {}) {
  if (!cmcd) {
    return '';
  }
  const params = encodeCmcd(cmcd, options);
  return `${CMCD_PARAM}=${encodeURIComponent(params)}`;
}

const REGEX = /CMCD=[^&#]+/;
/**
 * Append CMCD query args to a URL.
 *
 * @param url - The URL to append to.
 * @param cmcd - The CMCD object to append.
 * @param options - Options for encoding the CMCD object.
 *
 * @returns The URL with the CMCD query args appended.
 *
 * @group CMCD
 *
 * @beta
 */
function appendCmcdQuery(url, cmcd, options) {
  // TODO: Replace with URLSearchParams once we drop Safari < 10.1 & Chrome < 49 support.
  // https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams
  const query = toCmcdQuery(cmcd, options);
  if (!query) {
    return url;
  }
  if (REGEX.test(url)) {
    return url.replace(REGEX, query);
  }
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}${query}`;
}

/**
 * Controller to deal with Common Media Client Data (CMCD)
 * @see https://cdn.cta.tech/cta/media/media/resources/standards/pdfs/cta-5004-final.pdf
 */
class CMCDController {
  constructor(hls) {
    this.hls = void 0;
    this.config = void 0;
    this.media = void 0;
    this.sid = void 0;
    this.cid = void 0;
    this.useHeaders = false;
    this.includeKeys = void 0;
    this.initialized = false;
    this.starved = false;
    this.buffering = true;
    this.audioBuffer = void 0;
    this.videoBuffer = void 0;
    this.onWaiting = () => {
      if (this.initialized) {
        this.starved = true;
      }
      this.buffering = true;
    };
    this.onPlaying = () => {
      if (!this.initialized) {
        this.initialized = true;
      }
      this.buffering = false;
    };
    /**
     * Apply CMCD data to a manifest request.
     */
    this.applyPlaylistData = context => {
      try {
        this.apply(context, {
          ot: CmcdObjectType.MANIFEST,
          su: !this.initialized
        });
      } catch (error) {
        this.hls.logger.warn('Could not generate manifest CMCD data.', error);
      }
    };
    /**
     * Apply CMCD data to a segment request
     */
    this.applyFragmentData = context => {
      try {
        const {
          frag,
          part
        } = context;
        const level = this.hls.levels[frag.level];
        const ot = this.getObjectType(frag);
        const data = {
          d: (part || frag).duration * 1000,
          ot
        };
        if (ot === CmcdObjectType.VIDEO || ot === CmcdObjectType.AUDIO || ot == CmcdObjectType.MUXED) {
          data.br = level.bitrate / 1000;
          data.tb = this.getTopBandwidth(ot) / 1000;
          data.bl = this.getBufferLength(ot);
        }
        const next = part ? this.getNextPart(part) : this.getNextFrag(frag);
        if (next != null && next.url && next.url !== frag.url) {
          data.nor = next.url;
        }
        this.apply(context, data);
      } catch (error) {
        this.hls.logger.warn('Could not generate segment CMCD data.', error);
      }
    };
    this.hls = hls;
    const config = this.config = hls.config;
    const {
      cmcd
    } = config;
    if (cmcd != null) {
      config.pLoader = this.createPlaylistLoader();
      config.fLoader = this.createFragmentLoader();
      this.sid = cmcd.sessionId || hls.sessionId;
      this.cid = cmcd.contentId;
      this.useHeaders = cmcd.useHeaders === true;
      this.includeKeys = cmcd.includeKeys;
      this.registerListeners();
    }
  }
  registerListeners() {
    const hls = this.hls;
    hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.on(Events.MEDIA_DETACHED, this.onMediaDetached, this);
    hls.on(Events.BUFFER_CREATED, this.onBufferCreated, this);
  }
  unregisterListeners() {
    const hls = this.hls;
    hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.off(Events.MEDIA_DETACHED, this.onMediaDetached, this);
    hls.off(Events.BUFFER_CREATED, this.onBufferCreated, this);
  }
  destroy() {
    this.unregisterListeners();
    this.onMediaDetached();

    // @ts-ignore
    this.hls = this.config = this.audioBuffer = this.videoBuffer = null;
    // @ts-ignore
    this.onWaiting = this.onPlaying = this.media = null;
  }
  onMediaAttached(event, data) {
    this.media = data.media;
    this.media.addEventListener('waiting', this.onWaiting);
    this.media.addEventListener('playing', this.onPlaying);
  }
  onMediaDetached() {
    if (!this.media) {
      return;
    }
    this.media.removeEventListener('waiting', this.onWaiting);
    this.media.removeEventListener('playing', this.onPlaying);

    // @ts-ignore
    this.media = null;
  }
  onBufferCreated(event, data) {
    var _data$tracks$audio, _data$tracks$video;
    this.audioBuffer = (_data$tracks$audio = data.tracks.audio) == null ? void 0 : _data$tracks$audio.buffer;
    this.videoBuffer = (_data$tracks$video = data.tracks.video) == null ? void 0 : _data$tracks$video.buffer;
  }
  /**
   * Create baseline CMCD data
   */
  createData() {
    var _this$media;
    return {
      v: 1,
      sf: CmcdStreamingFormat.HLS,
      sid: this.sid,
      cid: this.cid,
      pr: (_this$media = this.media) == null ? void 0 : _this$media.playbackRate,
      mtp: this.hls.bandwidthEstimate / 1000
    };
  }

  /**
   * Apply CMCD data to a request.
   */
  apply(context, data = {}) {
    // apply baseline data
    _extends(data, this.createData());
    const isVideo = data.ot === CmcdObjectType.INIT || data.ot === CmcdObjectType.VIDEO || data.ot === CmcdObjectType.MUXED;
    if (this.starved && isVideo) {
      data.bs = true;
      data.su = true;
      this.starved = false;
    }
    if (data.su == null) {
      data.su = this.buffering;
    }

    // TODO: Implement rtp, nrr, dl

    const {
      includeKeys
    } = this;
    if (includeKeys) {
      data = Object.keys(data).reduce((acc, key) => {
        includeKeys.includes(key) && (acc[key] = data[key]);
        return acc;
      }, {});
    }
    const options = {
      baseUrl: context.url
    };
    if (this.useHeaders) {
      if (!context.headers) {
        context.headers = {};
      }
      appendCmcdHeaders(context.headers, data, options);
    } else {
      context.url = appendCmcdQuery(context.url, data, options);
    }
  }
  getNextFrag(fragment) {
    var _this$hls$levels$frag;
    const levelDetails = (_this$hls$levels$frag = this.hls.levels[fragment.level]) == null ? void 0 : _this$hls$levels$frag.details;
    if (levelDetails) {
      const index = fragment.sn - levelDetails.startSN;
      return levelDetails.fragments[index + 1];
    }
    return undefined;
  }
  getNextPart(part) {
    var _this$hls$levels$frag2, _this$hls$levels$frag3;
    const {
      index,
      fragment
    } = part;
    const partList = (_this$hls$levels$frag2 = this.hls.levels[fragment.level]) == null ? void 0 : (_this$hls$levels$frag3 = _this$hls$levels$frag2.details) == null ? void 0 : _this$hls$levels$frag3.partList;
    if (partList) {
      const {
        sn
      } = fragment;
      for (let i = partList.length - 1; i >= 0; i--) {
        const p = partList[i];
        if (p.index === index && p.fragment.sn === sn) {
          return partList[i + 1];
        }
      }
    }
    return undefined;
  }

  /**
   * The CMCD object type.
   */
  getObjectType(fragment) {
    const {
      type
    } = fragment;
    if (type === 'subtitle') {
      return CmcdObjectType.TIMED_TEXT;
    }
    if (fragment.sn === 'initSegment') {
      return CmcdObjectType.INIT;
    }
    if (type === 'audio') {
      return CmcdObjectType.AUDIO;
    }
    if (type === 'main') {
      if (!this.hls.audioTracks.length) {
        return CmcdObjectType.MUXED;
      }
      return CmcdObjectType.VIDEO;
    }
    return undefined;
  }

  /**
   * Get the highest bitrate.
   */
  getTopBandwidth(type) {
    let bitrate = 0;
    let levels;
    const hls = this.hls;
    if (type === CmcdObjectType.AUDIO) {
      levels = hls.audioTracks;
    } else {
      const max = hls.maxAutoLevel;
      const len = max > -1 ? max + 1 : hls.levels.length;
      levels = hls.levels.slice(0, len);
    }
    levels.forEach(level => {
      if (level.bitrate > bitrate) {
        bitrate = level.bitrate;
      }
    });
    return bitrate > 0 ? bitrate : NaN;
  }

  /**
   * Get the buffer length for a media type in milliseconds
   */
  getBufferLength(type) {
    const media = this.media;
    const buffer = type === CmcdObjectType.AUDIO ? this.audioBuffer : this.videoBuffer;
    if (!buffer || !media) {
      return NaN;
    }
    const info = BufferHelper.bufferInfo(buffer, media.currentTime, this.config.maxBufferHole);
    return info.len * 1000;
  }

  /**
   * Create a playlist loader
   */
  createPlaylistLoader() {
    const {
      pLoader
    } = this.config;
    const apply = this.applyPlaylistData;
    const Ctor = pLoader || this.config.loader;
    return class CmcdPlaylistLoader {
      constructor(config) {
        this.loader = void 0;
        this.loader = new Ctor(config);
      }
      get stats() {
        return this.loader.stats;
      }
      get context() {
        return this.loader.context;
      }
      destroy() {
        this.loader.destroy();
      }
      abort() {
        this.loader.abort();
      }
      load(context, config, callbacks) {
        apply(context);
        this.loader.load(context, config, callbacks);
      }
    };
  }

  /**
   * Create a playlist loader
   */
  createFragmentLoader() {
    const {
      fLoader
    } = this.config;
    const apply = this.applyFragmentData;
    const Ctor = fLoader || this.config.loader;
    return class CmcdFragmentLoader {
      constructor(config) {
        this.loader = void 0;
        this.loader = new Ctor(config);
      }
      get stats() {
        return this.loader.stats;
      }
      get context() {
        return this.loader.context;
      }
      destroy() {
        this.loader.destroy();
      }
      abort() {
        this.loader.abort();
      }
      load(context, config, callbacks) {
        apply(context);
        this.loader.load(context, config, callbacks);
      }
    };
  }
}

const PATHWAY_PENALTY_DURATION_MS = 300000;
class ContentSteeringController extends hls_Logger {
  constructor(hls) {
    super('content-steering', hls.logger);
    this.hls = void 0;
    this.loader = null;
    this.uri = null;
    this.pathwayId = '.';
    this._pathwayPriority = null;
    this.timeToLoad = 300;
    this.reloadTimer = -1;
    this.updated = 0;
    this.started = false;
    this.enabled = true;
    this.levels = null;
    this.audioTracks = null;
    this.subtitleTracks = null;
    this.penalizedPathways = {};
    this.hls = hls;
    this.registerListeners();
  }
  registerListeners() {
    const hls = this.hls;
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
    hls.on(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.on(Events.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const hls = this.hls;
    if (!hls) {
      return;
    }
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
    hls.off(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.off(Events.ERROR, this.onError, this);
  }
  pathways() {
    return (this.levels || []).reduce((pathways, level) => {
      if (pathways.indexOf(level.pathwayId) === -1) {
        pathways.push(level.pathwayId);
      }
      return pathways;
    }, []);
  }
  get pathwayPriority() {
    return this._pathwayPriority;
  }
  set pathwayPriority(pathwayPriority) {
    this.updatePathwayPriority(pathwayPriority);
  }
  startLoad() {
    this.started = true;
    this.clearTimeout();
    if (this.enabled && this.uri) {
      if (this.updated) {
        const ttl = this.timeToLoad * 1000 - (performance.now() - this.updated);
        if (ttl > 0) {
          this.scheduleRefresh(this.uri, ttl);
          return;
        }
      }
      this.loadSteeringManifest(this.uri);
    }
  }
  stopLoad() {
    this.started = false;
    if (this.loader) {
      this.loader.destroy();
      this.loader = null;
    }
    this.clearTimeout();
  }
  clearTimeout() {
    if (this.reloadTimer !== -1) {
      self.clearTimeout(this.reloadTimer);
      this.reloadTimer = -1;
    }
  }
  destroy() {
    this.unregisterListeners();
    this.stopLoad();
    // @ts-ignore
    this.hls = null;
    this.levels = this.audioTracks = this.subtitleTracks = null;
  }
  removeLevel(levelToRemove) {
    const levels = this.levels;
    if (levels) {
      this.levels = levels.filter(level => level !== levelToRemove);
    }
  }
  onManifestLoading() {
    this.stopLoad();
    this.enabled = true;
    this.timeToLoad = 300;
    this.updated = 0;
    this.uri = null;
    this.pathwayId = '.';
    this.levels = this.audioTracks = this.subtitleTracks = null;
  }
  onManifestLoaded(event, data) {
    const {
      contentSteering
    } = data;
    if (contentSteering === null) {
      return;
    }
    this.pathwayId = contentSteering.pathwayId;
    this.uri = contentSteering.uri;
    if (this.started) {
      this.startLoad();
    }
  }
  onManifestParsed(event, data) {
    this.audioTracks = data.audioTracks;
    this.subtitleTracks = data.subtitleTracks;
  }
  onError(event, data) {
    const {
      errorAction
    } = data;
    if ((errorAction == null ? void 0 : errorAction.action) === NetworkErrorAction.SendAlternateToPenaltyBox && errorAction.flags === ErrorActionFlags.MoveAllAlternatesMatchingHost) {
      const levels = this.levels;
      let pathwayPriority = this._pathwayPriority;
      let errorPathway = this.pathwayId;
      if (data.context) {
        const {
          groupId,
          pathwayId,
          type
        } = data.context;
        if (groupId && levels) {
          errorPathway = this.getPathwayForGroupId(groupId, type, errorPathway);
        } else if (pathwayId) {
          errorPathway = pathwayId;
        }
      }
      if (!(errorPathway in this.penalizedPathways)) {
        this.penalizedPathways[errorPathway] = performance.now();
      }
      if (!pathwayPriority && levels) {
        // If PATHWAY-PRIORITY was not provided, list pathways for error handling
        pathwayPriority = this.pathways();
      }
      if (pathwayPriority && pathwayPriority.length > 1) {
        this.updatePathwayPriority(pathwayPriority);
        errorAction.resolved = this.pathwayId !== errorPathway;
      }
      if (!errorAction.resolved) {
        this.warn(`Could not resolve ${data.details} ("${data.error.message}") with content-steering for Pathway: ${errorPathway} levels: ${levels ? levels.length : levels} priorities: ${hls_stringify(pathwayPriority)} penalized: ${hls_stringify(this.penalizedPathways)}`);
      }
    }
  }
  filterParsedLevels(levels) {
    // Filter levels to only include those that are in the initial pathway
    this.levels = levels;
    let pathwayLevels = this.getLevelsForPathway(this.pathwayId);
    if (pathwayLevels.length === 0) {
      const pathwayId = levels[0].pathwayId;
      this.log(`No levels found in Pathway ${this.pathwayId}. Setting initial Pathway to "${pathwayId}"`);
      pathwayLevels = this.getLevelsForPathway(pathwayId);
      this.pathwayId = pathwayId;
    }
    if (pathwayLevels.length !== levels.length) {
      this.log(`Found ${pathwayLevels.length}/${levels.length} levels in Pathway "${this.pathwayId}"`);
    }
    return pathwayLevels;
  }
  getLevelsForPathway(pathwayId) {
    if (this.levels === null) {
      return [];
    }
    return this.levels.filter(level => pathwayId === level.pathwayId);
  }
  updatePathwayPriority(pathwayPriority) {
    this._pathwayPriority = pathwayPriority;
    let levels;

    // Evaluate if we should remove the pathway from the penalized list
    const penalizedPathways = this.penalizedPathways;
    const now = performance.now();
    Object.keys(penalizedPathways).forEach(pathwayId => {
      if (now - penalizedPathways[pathwayId] > PATHWAY_PENALTY_DURATION_MS) {
        delete penalizedPathways[pathwayId];
      }
    });
    for (let i = 0; i < pathwayPriority.length; i++) {
      const pathwayId = pathwayPriority[i];
      if (pathwayId in penalizedPathways) {
        continue;
      }
      if (pathwayId === this.pathwayId) {
        return;
      }
      const selectedIndex = this.hls.nextLoadLevel;
      const selectedLevel = this.hls.levels[selectedIndex];
      levels = this.getLevelsForPathway(pathwayId);
      if (levels.length > 0) {
        this.log(`Setting Pathway to "${pathwayId}"`);
        this.pathwayId = pathwayId;
        reassignFragmentLevelIndexes(levels);
        this.hls.trigger(Events.LEVELS_UPDATED, {
          levels
        });
        // Set LevelController's level to trigger LEVEL_SWITCHING which loads playlist if needed
        const levelAfterChange = this.hls.levels[selectedIndex];
        if (selectedLevel && levelAfterChange && this.levels) {
          if (levelAfterChange.attrs['STABLE-VARIANT-ID'] !== selectedLevel.attrs['STABLE-VARIANT-ID'] && levelAfterChange.bitrate !== selectedLevel.bitrate) {
            this.log(`Unstable Pathways change from bitrate ${selectedLevel.bitrate} to ${levelAfterChange.bitrate}`);
          }
          this.hls.nextLoadLevel = selectedIndex;
        }
        break;
      }
    }
  }
  getPathwayForGroupId(groupId, type, defaultPathway) {
    const levels = this.getLevelsForPathway(defaultPathway).concat(this.levels || []);
    for (let i = 0; i < levels.length; i++) {
      if (type === PlaylistContextType.AUDIO_TRACK && levels[i].hasAudioGroup(groupId) || type === PlaylistContextType.SUBTITLE_TRACK && levels[i].hasSubtitleGroup(groupId)) {
        return levels[i].pathwayId;
      }
    }
    return defaultPathway;
  }
  clonePathways(pathwayClones) {
    const levels = this.levels;
    if (!levels) {
      return;
    }
    const audioGroupCloneMap = {};
    const subtitleGroupCloneMap = {};
    pathwayClones.forEach(pathwayClone => {
      const {
        ID: cloneId,
        'BASE-ID': baseId,
        'URI-REPLACEMENT': uriReplacement
      } = pathwayClone;
      if (levels.some(level => level.pathwayId === cloneId)) {
        return;
      }
      const clonedVariants = this.getLevelsForPathway(baseId).map(baseLevel => {
        const attributes = new AttrList(baseLevel.attrs);
        attributes['PATHWAY-ID'] = cloneId;
        const clonedAudioGroupId = attributes.AUDIO && `${attributes.AUDIO}_clone_${cloneId}`;
        const clonedSubtitleGroupId = attributes.SUBTITLES && `${attributes.SUBTITLES}_clone_${cloneId}`;
        if (clonedAudioGroupId) {
          audioGroupCloneMap[attributes.AUDIO] = clonedAudioGroupId;
          attributes.AUDIO = clonedAudioGroupId;
        }
        if (clonedSubtitleGroupId) {
          subtitleGroupCloneMap[attributes.SUBTITLES] = clonedSubtitleGroupId;
          attributes.SUBTITLES = clonedSubtitleGroupId;
        }
        const url = performUriReplacement(baseLevel.uri, attributes['STABLE-VARIANT-ID'], 'PER-VARIANT-URIS', uriReplacement);
        const clonedLevel = new Level({
          attrs: attributes,
          audioCodec: baseLevel.audioCodec,
          bitrate: baseLevel.bitrate,
          height: baseLevel.height,
          name: baseLevel.name,
          url,
          videoCodec: baseLevel.videoCodec,
          width: baseLevel.width
        });
        if (baseLevel.audioGroups) {
          for (let i = 1; i < baseLevel.audioGroups.length; i++) {
            clonedLevel.addGroupId('audio', `${baseLevel.audioGroups[i]}_clone_${cloneId}`);
          }
        }
        if (baseLevel.subtitleGroups) {
          for (let i = 1; i < baseLevel.subtitleGroups.length; i++) {
            clonedLevel.addGroupId('text', `${baseLevel.subtitleGroups[i]}_clone_${cloneId}`);
          }
        }
        return clonedLevel;
      });
      levels.push(...clonedVariants);
      cloneRenditionGroups(this.audioTracks, audioGroupCloneMap, uriReplacement, cloneId);
      cloneRenditionGroups(this.subtitleTracks, subtitleGroupCloneMap, uriReplacement, cloneId);
    });
  }
  loadSteeringManifest(uri) {
    const config = this.hls.config;
    const Loader = config.loader;
    if (this.loader) {
      this.loader.destroy();
    }
    this.loader = new Loader(config);
    let url;
    try {
      url = new self.URL(uri);
    } catch (error) {
      this.enabled = false;
      this.log(`Failed to parse Steering Manifest URI: ${uri}`);
      return;
    }
    if (url.protocol !== 'data:') {
      const throughput = (this.hls.bandwidthEstimate || config.abrEwmaDefaultEstimate) | 0;
      url.searchParams.set('_HLS_pathway', this.pathwayId);
      url.searchParams.set('_HLS_throughput', '' + throughput);
    }
    const context = {
      responseType: 'json',
      url: url.href
    };
    const loadPolicy = config.steeringManifestLoadPolicy.default;
    const legacyRetryCompatibility = loadPolicy.errorRetry || loadPolicy.timeoutRetry || {};
    const loaderConfig = {
      loadPolicy,
      timeout: loadPolicy.maxLoadTimeMs,
      maxRetry: legacyRetryCompatibility.maxNumRetry || 0,
      retryDelay: legacyRetryCompatibility.retryDelayMs || 0,
      maxRetryDelay: legacyRetryCompatibility.maxRetryDelayMs || 0
    };
    const callbacks = {
      onSuccess: (response, stats, context, networkDetails) => {
        this.log(`Loaded steering manifest: "${url}"`);
        const steeringData = response.data;
        if ((steeringData == null ? void 0 : steeringData.VERSION) !== 1) {
          this.log(`Steering VERSION ${steeringData.VERSION} not supported!`);
          return;
        }
        this.updated = performance.now();
        this.timeToLoad = steeringData.TTL;
        const {
          'RELOAD-URI': reloadUri,
          'PATHWAY-CLONES': pathwayClones,
          'PATHWAY-PRIORITY': pathwayPriority
        } = steeringData;
        if (reloadUri) {
          try {
            this.uri = new self.URL(reloadUri, url).href;
          } catch (error) {
            this.enabled = false;
            this.log(`Failed to parse Steering Manifest RELOAD-URI: ${reloadUri}`);
            return;
          }
        }
        this.scheduleRefresh(this.uri || context.url);
        if (pathwayClones) {
          this.clonePathways(pathwayClones);
        }
        const loadedSteeringData = {
          steeringManifest: steeringData,
          url: url.toString()
        };
        this.hls.trigger(Events.STEERING_MANIFEST_LOADED, loadedSteeringData);
        if (pathwayPriority) {
          this.updatePathwayPriority(pathwayPriority);
        }
      },
      onError: (error, context, networkDetails, stats) => {
        this.log(`Error loading steering manifest: ${error.code} ${error.text} (${context.url})`);
        this.stopLoad();
        if (error.code === 410) {
          this.enabled = false;
          this.log(`Steering manifest ${context.url} no longer available`);
          return;
        }
        let ttl = this.timeToLoad * 1000;
        if (error.code === 429) {
          const loader = this.loader;
          if (typeof (loader == null ? void 0 : loader.getResponseHeader) === 'function') {
            const retryAfter = loader.getResponseHeader('Retry-After');
            if (retryAfter) {
              ttl = parseFloat(retryAfter) * 1000;
            }
          }
          this.log(`Steering manifest ${context.url} rate limited`);
          return;
        }
        this.scheduleRefresh(this.uri || context.url, ttl);
      },
      onTimeout: (stats, context, networkDetails) => {
        this.log(`Timeout loading steering manifest (${context.url})`);
        this.scheduleRefresh(this.uri || context.url);
      }
    };
    this.log(`Requesting steering manifest: ${url}`);
    this.loader.load(context, loaderConfig, callbacks);
  }
  scheduleRefresh(uri, ttlMs = this.timeToLoad * 1000) {
    this.clearTimeout();
    this.reloadTimer = self.setTimeout(() => {
      var _this$hls;
      const media = (_this$hls = this.hls) == null ? void 0 : _this$hls.media;
      if (media && !media.ended) {
        this.loadSteeringManifest(uri);
        return;
      }
      this.scheduleRefresh(uri, this.timeToLoad * 1000);
    }, ttlMs);
  }
}
function cloneRenditionGroups(tracks, groupCloneMap, uriReplacement, cloneId) {
  if (!tracks) {
    return;
  }
  Object.keys(groupCloneMap).forEach(audioGroupId => {
    const clonedTracks = tracks.filter(track => track.groupId === audioGroupId).map(track => {
      const clonedTrack = _extends({}, track);
      clonedTrack.details = undefined;
      clonedTrack.attrs = new AttrList(clonedTrack.attrs);
      clonedTrack.url = clonedTrack.attrs.URI = performUriReplacement(track.url, track.attrs['STABLE-RENDITION-ID'], 'PER-RENDITION-URIS', uriReplacement);
      clonedTrack.groupId = clonedTrack.attrs['GROUP-ID'] = groupCloneMap[audioGroupId];
      clonedTrack.attrs['PATHWAY-ID'] = cloneId;
      return clonedTrack;
    });
    tracks.push(...clonedTracks);
  });
}
function performUriReplacement(uri, stableId, perOptionKey, uriReplacement) {
  const {
    HOST: host,
    PARAMS: params,
    [perOptionKey]: perOptionUris
  } = uriReplacement;
  let perVariantUri;
  if (stableId) {
    perVariantUri = perOptionUris == null ? void 0 : perOptionUris[stableId];
    if (perVariantUri) {
      uri = perVariantUri;
    }
  }
  const url = new self.URL(uri);
  if (host && !perVariantUri) {
    url.host = host;
  }
  if (params) {
    Object.keys(params).sort().forEach(key => {
      if (key) {
        url.searchParams.set(key, params[key]);
      }
    });
  }
  return url.href;
}

function addEventListener(el, type, listener) {
  removeEventListener(el, type, listener);
  el.addEventListener(type, listener);
}
function removeEventListener(el, type, listener) {
  el.removeEventListener(type, listener);
}

/**
 * Controller to deal with encrypted media extensions (EME)
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Encrypted_Media_Extensions_API
 *
 * @class
 * @constructor
 */
class EMEController extends hls_Logger {
  constructor(hls) {
    super('eme', hls.logger);
    this.hls = void 0;
    this.config = void 0;
    this.media = null;
    this.keyFormatPromise = null;
    this.keySystemAccessPromises = {};
    this._requestLicenseFailureCount = 0;
    this.mediaKeySessions = [];
    this.keyIdToKeySessionPromise = {};
    this.mediaKeys = null;
    this.setMediaKeysQueue = EMEController.CDMCleanupPromise ? [EMEController.CDMCleanupPromise] : [];
    this.onMediaEncrypted = event => {
      const {
        initDataType,
        initData
      } = event;
      const logMessage = `"${event.type}" event: init data type: "${initDataType}"`;
      this.debug(logMessage);

      // Ignore event when initData is null
      if (initData === null) {
        return;
      }
      if (!this.keyFormatPromise) {
        let keySystems = Object.keys(this.keySystemAccessPromises);
        if (!keySystems.length) {
          keySystems = getKeySystemsForConfig(this.config);
        }
        const keyFormats = keySystems.map(keySystemDomainToKeySystemFormat).filter(k => !!k);
        this.keyFormatPromise = this.getKeyFormatPromise(keyFormats);
      }
      this.keyFormatPromise.then(keySystemFormat => {
        const keySystem = keySystemFormatToKeySystemDomain(keySystemFormat);
        let keyId;
        let keySystemDomain;
        if (initDataType === 'sinf') {
          if (keySystem !== KeySystems.FAIRPLAY) {
            this.warn(`Ignoring unexpected "${event.type}" event with init data type: "${initDataType}" for selected key-system ${keySystem}`);
            return;
          }
          // Match sinf keyId to playlist skd://keyId=
          const json = bin2str(new Uint8Array(initData));
          try {
            const sinf = base64Decode(JSON.parse(json).sinf);
            const tenc = parseSinf(sinf);
            if (!tenc) {
              throw new Error(`'schm' box missing or not cbcs/cenc with schi > tenc`);
            }
            keyId = new Uint8Array(tenc.subarray(8, 24));
            keySystemDomain = KeySystems.FAIRPLAY;
          } catch (error) {
            this.warn(`${logMessage} Failed to parse sinf: ${error}`);
            return;
          }
        } else {
          if (keySystem !== KeySystems.WIDEVINE && keySystem !== KeySystems.PLAYREADY) {
            this.warn(`Ignoring unexpected "${event.type}" event with init data type: "${initDataType}" for selected key-system ${keySystem}`);
            return;
          }
          // Support Widevine/PlayReady clear-lead key-session creation (otherwise depend on playlist keys)
          const psshResults = parseMultiPssh(initData);
          const psshInfos = psshResults.filter(pssh => !!pssh.systemId && keySystemIdToKeySystemDomain(pssh.systemId) === keySystem);
          if (psshInfos.length > 1) {
            this.warn(`${logMessage} Using first of ${psshInfos.length} pssh found for selected key-system ${keySystem}`);
          }
          const psshInfo = psshInfos[0];
          if (!psshInfo) {
            if (psshResults.length === 0 || psshResults.some(pssh => !pssh.systemId)) {
              this.warn(`${logMessage} contains incomplete or invalid pssh data`);
            } else {
              this.log(`ignoring ${logMessage} for ${psshResults.map(pssh => keySystemIdToKeySystemDomain(pssh.systemId)).join(',')} pssh data in favor of playlist keys`);
            }
            return;
          }
          keySystemDomain = keySystemIdToKeySystemDomain(psshInfo.systemId);
          if (psshInfo.version === 0 && psshInfo.data) {
            if (keySystemDomain === KeySystems.WIDEVINE) {
              const offset = psshInfo.data.length - 22;
              keyId = new Uint8Array(psshInfo.data.subarray(offset, offset + 16));
            } else if (keySystemDomain === KeySystems.PLAYREADY) {
              keyId = parsePlayReadyWRM(psshInfo.data);
            }
          }
        }
        if (!keySystemDomain || !keyId) {
          return;
        }
        const keyIdHex = Hex.hexDump(keyId);
        const {
          keyIdToKeySessionPromise,
          mediaKeySessions
        } = this;
        let keySessionContextPromise = keyIdToKeySessionPromise[keyIdHex];
        for (let i = 0; i < mediaKeySessions.length; i++) {
          // Match playlist key
          const keyContext = mediaKeySessions[i];
          const decryptdata = keyContext.decryptdata;
          if (!decryptdata.keyId) {
            continue;
          }
          const oldKeyIdHex = Hex.hexDump(decryptdata.keyId);
          if (keyIdHex === oldKeyIdHex || decryptdata.uri.replace(/-/g, '').indexOf(keyIdHex) !== -1) {
            keySessionContextPromise = keyIdToKeySessionPromise[oldKeyIdHex];
            if (decryptdata.pssh) {
              break;
            }
            delete keyIdToKeySessionPromise[oldKeyIdHex];
            decryptdata.pssh = new Uint8Array(initData);
            decryptdata.keyId = keyId;
            keySessionContextPromise = keyIdToKeySessionPromise[keyIdHex] = keySessionContextPromise.then(() => {
              return this.generateRequestWithPreferredKeySession(keyContext, initDataType, initData, 'encrypted-event-key-match');
            });
            keySessionContextPromise.catch(error => this.handleError(error));
            break;
          }
        }
        if (!keySessionContextPromise) {
          if (keySystemDomain !== keySystem) {
            this.log(`Ignoring "${event.type}" event with ${keySystemDomain} init data for selected key-system ${keySystem}`);
            return;
          }
          // "Clear-lead" (misc key not encountered in playlist)
          keySessionContextPromise = keyIdToKeySessionPromise[keyIdHex] = this.getKeySystemSelectionPromise([keySystemDomain]).then(({
            keySystem,
            mediaKeys
          }) => {
            var _keySystemToKeySystem;
            this.throwIfDestroyed();
            const decryptdata = new LevelKey('ISO-23001-7', keyIdHex, (_keySystemToKeySystem = keySystemDomainToKeySystemFormat(keySystem)) != null ? _keySystemToKeySystem : '');
            decryptdata.pssh = new Uint8Array(initData);
            decryptdata.keyId = keyId;
            return this.attemptSetMediaKeys(keySystem, mediaKeys).then(() => {
              this.throwIfDestroyed();
              const keySessionContext = this.createMediaKeySessionContext({
                decryptdata,
                keySystem,
                mediaKeys
              });
              return this.generateRequestWithPreferredKeySession(keySessionContext, initDataType, initData, 'encrypted-event-no-match');
            });
          });
          keySessionContextPromise.catch(error => this.handleError(error));
        }
      });
    };
    this.onWaitingForKey = event => {
      this.log(`"${event.type}" event`);
    };
    this.hls = hls;
    this.config = hls.config;
    this.registerListeners();
  }
  destroy() {
    this.onDestroying();
    this.onMediaDetached();
    // Remove any references that could be held in config options or callbacks
    const config = this.config;
    config.requestMediaKeySystemAccessFunc = null;
    config.licenseXhrSetup = config.licenseResponseCallback = undefined;
    config.drmSystems = config.drmSystemOptions = {};
    // @ts-ignore
    this.hls = this.config = this.keyIdToKeySessionPromise = null;
    // @ts-ignore
    this.onMediaEncrypted = this.onWaitingForKey = null;
  }
  registerListeners() {
    this.hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    this.hls.on(Events.MEDIA_DETACHED, this.onMediaDetached, this);
    this.hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    this.hls.on(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
    this.hls.on(Events.DESTROYING, this.onDestroying, this);
  }
  unregisterListeners() {
    this.hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    this.hls.off(Events.MEDIA_DETACHED, this.onMediaDetached, this);
    this.hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    this.hls.off(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
    this.hls.off(Events.DESTROYING, this.onDestroying, this);
  }
  getLicenseServerUrl(keySystem) {
    const {
      drmSystems,
      widevineLicenseUrl
    } = this.config;
    const keySystemConfiguration = drmSystems[keySystem];
    if (keySystemConfiguration) {
      return keySystemConfiguration.licenseUrl;
    }

    // For backward compatibility
    if (keySystem === KeySystems.WIDEVINE && widevineLicenseUrl) {
      return widevineLicenseUrl;
    }
  }
  getLicenseServerUrlOrThrow(keySystem) {
    const url = this.getLicenseServerUrl(keySystem);
    if (url === undefined) {
      throw new Error(`no license server URL configured for key-system "${keySystem}"`);
    }
    return url;
  }
  getServerCertificateUrl(keySystem) {
    const {
      drmSystems
    } = this.config;
    const keySystemConfiguration = drmSystems[keySystem];
    if (keySystemConfiguration) {
      return keySystemConfiguration.serverCertificateUrl;
    } else {
      this.log(`No Server Certificate in config.drmSystems["${keySystem}"]`);
    }
  }
  attemptKeySystemAccess(keySystemsToAttempt) {
    const levels = this.hls.levels;
    const uniqueCodec = (value, i, a) => !!value && a.indexOf(value) === i;
    const audioCodecs = levels.map(level => level.audioCodec).filter(uniqueCodec);
    const videoCodecs = levels.map(level => level.videoCodec).filter(uniqueCodec);
    if (audioCodecs.length + videoCodecs.length === 0) {
      videoCodecs.push('avc1.42e01e');
    }
    return new Promise((resolve, reject) => {
      const attempt = keySystems => {
        const keySystem = keySystems.shift();
        this.getMediaKeysPromise(keySystem, audioCodecs, videoCodecs).then(mediaKeys => resolve({
          keySystem,
          mediaKeys
        })).catch(error => {
          if (keySystems.length) {
            attempt(keySystems);
          } else if (error instanceof EMEKeyError) {
            reject(error);
          } else {
            reject(new EMEKeyError({
              type: ErrorTypes.KEY_SYSTEM_ERROR,
              details: ErrorDetails.KEY_SYSTEM_NO_ACCESS,
              error,
              fatal: true
            }, error.message));
          }
        });
      };
      attempt(keySystemsToAttempt);
    });
  }
  requestMediaKeySystemAccess(keySystem, supportedConfigurations) {
    const {
      requestMediaKeySystemAccessFunc
    } = this.config;
    if (!(typeof requestMediaKeySystemAccessFunc === 'function')) {
      let errMessage = `Configured requestMediaKeySystemAccess is not a function ${requestMediaKeySystemAccessFunc}`;
      if (requestMediaKeySystemAccess === null && self.location.protocol === 'http:') {
        errMessage = `navigator.requestMediaKeySystemAccess is not available over insecure protocol ${location.protocol}`;
      }
      return Promise.reject(new Error(errMessage));
    }
    return requestMediaKeySystemAccessFunc(keySystem, supportedConfigurations);
  }
  getMediaKeysPromise(keySystem, audioCodecs, videoCodecs) {
    // This can throw, but is caught in event handler callpath
    const mediaKeySystemConfigs = getSupportedMediaKeySystemConfigurations(keySystem, audioCodecs, videoCodecs, this.config.drmSystemOptions);
    const keySystemAccessPromises = this.keySystemAccessPromises[keySystem];
    let keySystemAccess = keySystemAccessPromises == null ? void 0 : keySystemAccessPromises.keySystemAccess;
    if (!keySystemAccess) {
      this.log(`Requesting encrypted media "${keySystem}" key-system access with config: ${hls_stringify(mediaKeySystemConfigs)}`);
      keySystemAccess = this.requestMediaKeySystemAccess(keySystem, mediaKeySystemConfigs);
      const _keySystemAccessPromises = this.keySystemAccessPromises[keySystem] = {
        keySystemAccess
      };
      keySystemAccess.catch(error => {
        this.log(`Failed to obtain access to key-system "${keySystem}": ${error}`);
      });
      return keySystemAccess.then(mediaKeySystemAccess => {
        this.log(`Access for key-system "${mediaKeySystemAccess.keySystem}" obtained`);
        const certificateRequest = this.fetchServerCertificate(keySystem);
        this.log(`Create media-keys for "${keySystem}"`);
        _keySystemAccessPromises.mediaKeys = mediaKeySystemAccess.createMediaKeys().then(mediaKeys => {
          this.log(`Media-keys created for "${keySystem}"`);
          _keySystemAccessPromises.hasMediaKeys = true;
          return certificateRequest.then(certificate => {
            if (certificate) {
              return this.setMediaKeysServerCertificate(mediaKeys, keySystem, certificate);
            }
            return mediaKeys;
          });
        });
        _keySystemAccessPromises.mediaKeys.catch(error => {
          this.error(`Failed to create media-keys for "${keySystem}"}: ${error}`);
        });
        return _keySystemAccessPromises.mediaKeys;
      });
    }
    return keySystemAccess.then(() => keySystemAccessPromises.mediaKeys);
  }
  createMediaKeySessionContext({
    decryptdata,
    keySystem,
    mediaKeys
  }) {
    this.log(`Creating key-system session "${keySystem}" keyId: ${Hex.hexDump(decryptdata.keyId || [])}`);
    const mediaKeysSession = mediaKeys.createSession();
    const mediaKeySessionContext = {
      decryptdata,
      keySystem,
      mediaKeys,
      mediaKeysSession,
      keyStatus: 'status-pending'
    };
    this.mediaKeySessions.push(mediaKeySessionContext);
    return mediaKeySessionContext;
  }
  renewKeySession(mediaKeySessionContext) {
    const decryptdata = mediaKeySessionContext.decryptdata;
    if (decryptdata.pssh) {
      const keySessionContext = this.createMediaKeySessionContext(mediaKeySessionContext);
      const keyId = this.getKeyIdString(decryptdata);
      const scheme = 'cenc';
      this.keyIdToKeySessionPromise[keyId] = this.generateRequestWithPreferredKeySession(keySessionContext, scheme, decryptdata.pssh.buffer, 'expired');
    } else {
      this.warn(`Could not renew expired session. Missing pssh initData.`);
    }
    this.removeSession(mediaKeySessionContext);
  }
  getKeyIdString(decryptdata) {
    if (!decryptdata) {
      throw new Error('Could not read keyId of undefined decryptdata');
    }
    if (decryptdata.keyId === null) {
      throw new Error('keyId is null');
    }
    return Hex.hexDump(decryptdata.keyId);
  }
  updateKeySession(mediaKeySessionContext, data) {
    var _mediaKeySessionConte;
    const keySession = mediaKeySessionContext.mediaKeysSession;
    this.log(`Updating key-session "${keySession.sessionId}" for keyID ${Hex.hexDump(((_mediaKeySessionConte = mediaKeySessionContext.decryptdata) == null ? void 0 : _mediaKeySessionConte.keyId) || [])}
      } (data length: ${data ? data.byteLength : data})`);
    return keySession.update(data);
  }
  getSelectedKeySystemFormats() {
    return Object.keys(this.keySystemAccessPromises).map(keySystem => ({
      keySystem,
      hasMediaKeys: this.keySystemAccessPromises[keySystem].hasMediaKeys
    })).filter(({
      hasMediaKeys
    }) => !!hasMediaKeys).map(({
      keySystem
    }) => keySystemDomainToKeySystemFormat(keySystem)).filter(keySystem => !!keySystem);
  }
  getKeySystemAccess(keySystemsToAttempt) {
    return this.getKeySystemSelectionPromise(keySystemsToAttempt).then(({
      keySystem,
      mediaKeys
    }) => {
      return this.attemptSetMediaKeys(keySystem, mediaKeys);
    });
  }
  selectKeySystem(keySystemsToAttempt) {
    return new Promise((resolve, reject) => {
      return this.getKeySystemSelectionPromise(keySystemsToAttempt).then(({
        keySystem
      }) => {
        const keySystemFormat = keySystemDomainToKeySystemFormat(keySystem);
        if (keySystemFormat) {
          resolve(keySystemFormat);
        } else {
          reject(new Error(`Unable to find format for key-system "${keySystem}"`));
        }
      }).catch(reject);
    });
  }
  selectKeySystemFormat(frag) {
    const keyFormats = Object.keys(frag.levelkeys || {});
    if (!this.keyFormatPromise) {
      this.log(`Selecting key-system from fragment (sn: ${frag.sn} ${frag.type}: ${frag.level}) key formats ${keyFormats.join(', ')}`);
      this.keyFormatPromise = this.getKeyFormatPromise(keyFormats);
    }
    return this.keyFormatPromise;
  }
  getKeyFormatPromise(keyFormats) {
    const keySystemsInConfig = getKeySystemsForConfig(this.config);
    const keySystemsToAttempt = keyFormats.map(keySystemFormatToKeySystemDomain).filter(value => !!value && keySystemsInConfig.indexOf(value) !== -1);
    return this.selectKeySystem(keySystemsToAttempt);
  }
  loadKey(data) {
    const decryptdata = data.keyInfo.decryptdata;
    const keyId = this.getKeyIdString(decryptdata);
    const keyDetails = `(keyId: ${keyId} format: "${decryptdata.keyFormat}" method: ${decryptdata.method} uri: ${decryptdata.uri})`;
    this.log(`Starting session for key ${keyDetails}`);
    let keyContextPromise = this.keyIdToKeySessionPromise[keyId];
    if (!keyContextPromise) {
      keyContextPromise = this.getKeySystemForKeyPromise(decryptdata).then(({
        keySystem,
        mediaKeys
      }) => {
        this.throwIfDestroyed();
        this.log(`Handle encrypted media sn: ${data.frag.sn} ${data.frag.type}: ${data.frag.level} using key ${keyDetails}`);
        return this.attemptSetMediaKeys(keySystem, mediaKeys).then(() => {
          this.throwIfDestroyed();
          return this.createMediaKeySessionContext({
            keySystem,
            mediaKeys,
            decryptdata
          });
        });
      });
      const keySessionContextPromise = this.keyIdToKeySessionPromise[keyId] = keyContextPromise.then(keySessionContext => {
        const scheme = 'cenc';
        const initData = decryptdata.pssh ? decryptdata.pssh.buffer : null;
        return this.generateRequestWithPreferredKeySession(keySessionContext, scheme, initData, 'playlist-key');
      });
      keySessionContextPromise.catch(error => this.handleError(error));
    }
    return keyContextPromise;
  }
  throwIfDestroyed(message = 'Invalid state') {
    if (!this.hls) {
      throw new Error('invalid state');
    }
  }
  handleError(error) {
    if (!this.hls) {
      return;
    }
    this.error(error.message);
    if (error instanceof EMEKeyError) {
      this.hls.trigger(Events.ERROR, error.data);
    } else {
      this.hls.trigger(Events.ERROR, {
        type: ErrorTypes.KEY_SYSTEM_ERROR,
        details: ErrorDetails.KEY_SYSTEM_NO_KEYS,
        error,
        fatal: true
      });
    }
  }
  getKeySystemForKeyPromise(decryptdata) {
    const keyId = this.getKeyIdString(decryptdata);
    const mediaKeySessionContext = this.keyIdToKeySessionPromise[keyId];
    if (!mediaKeySessionContext) {
      const keySystem = keySystemFormatToKeySystemDomain(decryptdata.keyFormat);
      const keySystemsToAttempt = keySystem ? [keySystem] : getKeySystemsForConfig(this.config);
      return this.attemptKeySystemAccess(keySystemsToAttempt);
    }
    return mediaKeySessionContext;
  }
  getKeySystemSelectionPromise(keySystemsToAttempt) {
    if (!keySystemsToAttempt.length) {
      keySystemsToAttempt = getKeySystemsForConfig(this.config);
    }
    if (keySystemsToAttempt.length === 0) {
      throw new EMEKeyError({
        type: ErrorTypes.KEY_SYSTEM_ERROR,
        details: ErrorDetails.KEY_SYSTEM_NO_CONFIGURED_LICENSE,
        fatal: true
      }, `Missing key-system license configuration options ${hls_stringify({
        drmSystems: this.config.drmSystems
      })}`);
    }
    return this.attemptKeySystemAccess(keySystemsToAttempt);
  }
  attemptSetMediaKeys(keySystem, mediaKeys) {
    if (this.mediaKeys === mediaKeys) {
      return Promise.resolve();
    }
    const queue = this.setMediaKeysQueue.slice();
    this.log(`Setting media-keys for "${keySystem}"`);
    // Only one setMediaKeys() can run at one time, and multiple setMediaKeys() operations
    // can be queued for execution for multiple key sessions.
    const setMediaKeysPromise = Promise.all(queue).then(() => {
      if (!this.media) {
        this.mediaKeys = null;
        throw new Error('Attempted to set mediaKeys without media element attached');
      }
      return this.media.setMediaKeys(mediaKeys);
    });
    this.mediaKeys = mediaKeys;
    this.setMediaKeysQueue.push(setMediaKeysPromise);
    return setMediaKeysPromise.then(() => {
      this.log(`Media-keys set for "${keySystem}"`);
      queue.push(setMediaKeysPromise);
      this.setMediaKeysQueue = this.setMediaKeysQueue.filter(p => queue.indexOf(p) === -1);
    });
  }
  generateRequestWithPreferredKeySession(context, initDataType, initData, reason) {
    var _this$config$drmSyste, _this$config$drmSyste2;
    const generateRequestFilter = (_this$config$drmSyste = this.config.drmSystems) == null ? void 0 : (_this$config$drmSyste2 = _this$config$drmSyste[context.keySystem]) == null ? void 0 : _this$config$drmSyste2.generateRequest;
    if (generateRequestFilter) {
      try {
        const mappedInitData = generateRequestFilter.call(this.hls, initDataType, initData, context);
        if (!mappedInitData) {
          throw new Error('Invalid response from configured generateRequest filter');
        }
        initDataType = mappedInitData.initDataType;
        initData = mappedInitData.initData ? mappedInitData.initData : null;
        context.decryptdata.pssh = initData ? new Uint8Array(initData) : null;
      } catch (error) {
        var _this$hls;
        this.warn(error.message);
        if ((_this$hls = this.hls) != null && _this$hls.config.debug) {
          throw error;
        }
      }
    }
    if (initData === null) {
      this.log(`Skipping key-session request for "${reason}" (no initData)`);
      return Promise.resolve(context);
    }
    const keyId = this.getKeyIdString(context.decryptdata);
    this.log(`Generating key-session request for "${reason}": ${keyId} (init data type: ${initDataType} length: ${initData ? initData.byteLength : null})`);
    const licenseStatus = new hls_EventEmitter();
    const onmessage = context._onmessage = event => {
      const keySession = context.mediaKeysSession;
      if (!keySession) {
        licenseStatus.emit('error', new Error('invalid state'));
        return;
      }
      const {
        messageType,
        message
      } = event;
      this.log(`"${messageType}" message event for session "${keySession.sessionId}" message size: ${message.byteLength}`);
      if (messageType === 'license-request' || messageType === 'license-renewal') {
        this.renewLicense(context, message).catch(error => {
          if (licenseStatus.eventNames().length) {
            licenseStatus.emit('error', error);
          } else {
            this.handleError(error);
          }
        });
      } else if (messageType === 'license-release') {
        if (context.keySystem === KeySystems.FAIRPLAY) {
          this.updateKeySession(context, strToUtf8array('acknowledged'));
          this.removeSession(context);
        }
      } else {
        this.warn(`unhandled media key message type "${messageType}"`);
      }
    };
    const onkeystatuseschange = context._onkeystatuseschange = event => {
      const keySession = context.mediaKeysSession;
      if (!keySession) {
        licenseStatus.emit('error', new Error('invalid state'));
        return;
      }
      this.onKeyStatusChange(context);
      const keyStatus = context.keyStatus;
      licenseStatus.emit('keyStatus', keyStatus);
      if (keyStatus === 'expired') {
        this.warn(`${context.keySystem} expired for key ${keyId}`);
        this.renewKeySession(context);
      }
    };
    addEventListener(context.mediaKeysSession, 'message', onmessage);
    addEventListener(context.mediaKeysSession, 'keystatuseschange', onkeystatuseschange);
    const keyUsablePromise = new Promise((resolve, reject) => {
      licenseStatus.on('error', reject);
      licenseStatus.on('keyStatus', keyStatus => {
        if (keyStatus.startsWith('usable')) {
          resolve();
        } else if (keyStatus === 'output-restricted') {
          reject(new EMEKeyError({
            type: ErrorTypes.KEY_SYSTEM_ERROR,
            details: ErrorDetails.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED,
            fatal: false
          }, 'HDCP level output restricted'));
        } else if (keyStatus === 'internal-error') {
          reject(new EMEKeyError({
            type: ErrorTypes.KEY_SYSTEM_ERROR,
            details: ErrorDetails.KEY_SYSTEM_STATUS_INTERNAL_ERROR,
            fatal: true
          }, `key status changed to "${keyStatus}"`));
        } else if (keyStatus === 'expired') {
          reject(new Error('key expired while generating request'));
        } else {
          this.warn(`unhandled key status change "${keyStatus}"`);
        }
      });
    });
    return context.mediaKeysSession.generateRequest(initDataType, initData).then(() => {
      var _context$mediaKeysSes;
      this.log(`Request generated for key-session "${(_context$mediaKeysSes = context.mediaKeysSession) == null ? void 0 : _context$mediaKeysSes.sessionId}" keyId: ${keyId}`);
    }).catch(error => {
      throw new EMEKeyError({
        type: ErrorTypes.KEY_SYSTEM_ERROR,
        details: ErrorDetails.KEY_SYSTEM_NO_SESSION,
        error,
        fatal: false
      }, `Error generating key-session request: ${error}`);
    }).then(() => keyUsablePromise).catch(error => {
      licenseStatus.removeAllListeners();
      this.removeSession(context);
      throw error;
    }).then(() => {
      licenseStatus.removeAllListeners();
      return context;
    });
  }
  onKeyStatusChange(mediaKeySessionContext) {
    mediaKeySessionContext.mediaKeysSession.keyStatuses.forEach((status, keyId) => {
      // keyStatuses.forEach is not standard API so the callback value looks weird on xboxone
      // xboxone callback(keyId, status) so we need to exchange them
      if (typeof keyId === 'string' && typeof status === 'object') {
        const temp = keyId;
        keyId = status;
        status = temp;
      }
      this.log(`key status change "${status}" for keyStatuses keyId: ${Hex.hexDump('buffer' in keyId ? new Uint8Array(keyId.buffer, keyId.byteOffset, keyId.byteLength) : new Uint8Array(keyId))} session keyId: ${Hex.hexDump(new Uint8Array(mediaKeySessionContext.decryptdata.keyId || []))} uri: ${mediaKeySessionContext.decryptdata.uri}`);
      mediaKeySessionContext.keyStatus = status;
    });
  }
  fetchServerCertificate(keySystem) {
    const config = this.config;
    const Loader = config.loader;
    const certLoader = new Loader(config);
    const url = this.getServerCertificateUrl(keySystem);
    if (!url) {
      return Promise.resolve();
    }
    this.log(`Fetching server certificate for "${keySystem}"`);
    return new Promise((resolve, reject) => {
      const loaderContext = {
        responseType: 'arraybuffer',
        url
      };
      const loadPolicy = config.certLoadPolicy.default;
      const loaderConfig = {
        loadPolicy,
        timeout: loadPolicy.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0
      };
      const loaderCallbacks = {
        onSuccess: (response, stats, context, networkDetails) => {
          resolve(response.data);
        },
        onError: (response, contex, networkDetails, stats) => {
          reject(new EMEKeyError({
            type: ErrorTypes.KEY_SYSTEM_ERROR,
            details: ErrorDetails.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
            fatal: true,
            networkDetails,
            response: _objectSpread2({
              url: loaderContext.url,
              data: undefined
            }, response)
          }, `"${keySystem}" certificate request failed (${url}). Status: ${response.code} (${response.text})`));
        },
        onTimeout: (stats, context, networkDetails) => {
          reject(new EMEKeyError({
            type: ErrorTypes.KEY_SYSTEM_ERROR,
            details: ErrorDetails.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
            fatal: true,
            networkDetails,
            response: {
              url: loaderContext.url,
              data: undefined
            }
          }, `"${keySystem}" certificate request timed out (${url})`));
        },
        onAbort: (stats, context, networkDetails) => {
          reject(new Error('aborted'));
        }
      };
      certLoader.load(loaderContext, loaderConfig, loaderCallbacks);
    });
  }
  setMediaKeysServerCertificate(mediaKeys, keySystem, cert) {
    return new Promise((resolve, reject) => {
      mediaKeys.setServerCertificate(cert).then(success => {
        this.log(`setServerCertificate ${success ? 'success' : 'not supported by CDM'} (${cert == null ? void 0 : cert.byteLength}) on "${keySystem}"`);
        resolve(mediaKeys);
      }).catch(error => {
        reject(new EMEKeyError({
          type: ErrorTypes.KEY_SYSTEM_ERROR,
          details: ErrorDetails.KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED,
          error,
          fatal: true
        }, error.message));
      });
    });
  }
  renewLicense(context, keyMessage) {
    return this.requestLicense(context, new Uint8Array(keyMessage)).then(data => {
      return this.updateKeySession(context, new Uint8Array(data)).catch(error => {
        throw new EMEKeyError({
          type: ErrorTypes.KEY_SYSTEM_ERROR,
          details: ErrorDetails.KEY_SYSTEM_SESSION_UPDATE_FAILED,
          error,
          fatal: true
        }, error.message);
      });
    });
  }
  unpackPlayReadyKeyMessage(xhr, licenseChallenge) {
    // On Edge, the raw license message is UTF-16-encoded XML.  We need
    // to unpack the Challenge element (base64-encoded string containing the
    // actual license request) and any HttpHeader elements (sent as request
    // headers).
    // For PlayReady CDMs, we need to dig the Challenge out of the XML.
    const xmlString = String.fromCharCode.apply(null, new Uint16Array(licenseChallenge.buffer));
    if (!xmlString.includes('PlayReadyKeyMessage')) {
      // This does not appear to be a wrapped message as on Edge.  Some
      // clients do not need this unwrapping, so we will assume this is one of
      // them.  Note that "xml" at this point probably looks like random
      // garbage, since we interpreted UTF-8 as UTF-16.
      xhr.setRequestHeader('Content-Type', 'text/xml; charset=utf-8');
      return licenseChallenge;
    }
    const keyMessageXml = new DOMParser().parseFromString(xmlString, 'application/xml');
    // Set request headers.
    const headers = keyMessageXml.querySelectorAll('HttpHeader');
    if (headers.length > 0) {
      let header;
      for (let i = 0, len = headers.length; i < len; i++) {
        var _header$querySelector, _header$querySelector2;
        header = headers[i];
        const name = (_header$querySelector = header.querySelector('name')) == null ? void 0 : _header$querySelector.textContent;
        const value = (_header$querySelector2 = header.querySelector('value')) == null ? void 0 : _header$querySelector2.textContent;
        if (name && value) {
          xhr.setRequestHeader(name, value);
        }
      }
    }
    const challengeElement = keyMessageXml.querySelector('Challenge');
    const challengeText = challengeElement == null ? void 0 : challengeElement.textContent;
    if (!challengeText) {
      throw new Error(`Cannot find <Challenge> in key message`);
    }
    return strToUtf8array(atob(challengeText));
  }
  setupLicenseXHR(xhr, url, keysListItem, licenseChallenge) {
    const licenseXhrSetup = this.config.licenseXhrSetup;
    if (!licenseXhrSetup) {
      xhr.open('POST', url, true);
      return Promise.resolve({
        xhr,
        licenseChallenge
      });
    }
    return Promise.resolve().then(() => {
      if (!keysListItem.decryptdata) {
        throw new Error('Key removed');
      }
      return licenseXhrSetup.call(this.hls, xhr, url, keysListItem, licenseChallenge);
    }).catch(error => {
      if (!keysListItem.decryptdata) {
        // Key session removed. Cancel license request.
        throw error;
      }
      // let's try to open before running setup
      xhr.open('POST', url, true);
      return licenseXhrSetup.call(this.hls, xhr, url, keysListItem, licenseChallenge);
    }).then(licenseXhrSetupResult => {
      // if licenseXhrSetup did not yet call open, let's do it now
      if (!xhr.readyState) {
        xhr.open('POST', url, true);
      }
      const finalLicenseChallenge = licenseXhrSetupResult ? licenseXhrSetupResult : licenseChallenge;
      return {
        xhr,
        licenseChallenge: finalLicenseChallenge
      };
    });
  }
  requestLicense(keySessionContext, licenseChallenge) {
    const keyLoadPolicy = this.config.keyLoadPolicy.default;
    return new Promise((resolve, reject) => {
      const url = this.getLicenseServerUrlOrThrow(keySessionContext.keySystem);
      this.log(`Sending license request to URL: ${url}`);
      const xhr = new XMLHttpRequest();
      xhr.responseType = 'arraybuffer';
      xhr.onreadystatechange = () => {
        if (!this.hls || !keySessionContext.mediaKeysSession) {
          return reject(new Error('invalid state'));
        }
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            this._requestLicenseFailureCount = 0;
            let data = xhr.response;
            this.log(`License received ${data instanceof ArrayBuffer ? data.byteLength : data}`);
            const licenseResponseCallback = this.config.licenseResponseCallback;
            if (licenseResponseCallback) {
              try {
                data = licenseResponseCallback.call(this.hls, xhr, url, keySessionContext);
              } catch (error) {
                this.error(error);
              }
            }
            resolve(data);
          } else {
            const retryConfig = keyLoadPolicy.errorRetry;
            const maxNumRetry = retryConfig ? retryConfig.maxNumRetry : 0;
            this._requestLicenseFailureCount++;
            if (this._requestLicenseFailureCount > maxNumRetry || xhr.status >= 400 && xhr.status < 500) {
              reject(new EMEKeyError({
                type: ErrorTypes.KEY_SYSTEM_ERROR,
                details: ErrorDetails.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                fatal: true,
                networkDetails: xhr,
                response: {
                  url,
                  data: undefined,
                  code: xhr.status,
                  text: xhr.statusText
                }
              }, `License Request XHR failed (${url}). Status: ${xhr.status} (${xhr.statusText})`));
            } else {
              const attemptsLeft = maxNumRetry - this._requestLicenseFailureCount + 1;
              this.warn(`Retrying license request, ${attemptsLeft} attempts left`);
              this.requestLicense(keySessionContext, licenseChallenge).then(resolve, reject);
            }
          }
        }
      };
      if (keySessionContext.licenseXhr && keySessionContext.licenseXhr.readyState !== XMLHttpRequest.DONE) {
        keySessionContext.licenseXhr.abort();
      }
      keySessionContext.licenseXhr = xhr;
      this.setupLicenseXHR(xhr, url, keySessionContext, licenseChallenge).then(({
        xhr,
        licenseChallenge
      }) => {
        if (keySessionContext.keySystem == KeySystems.PLAYREADY) {
          licenseChallenge = this.unpackPlayReadyKeyMessage(xhr, licenseChallenge);
        }
        xhr.send(licenseChallenge);
      });
    });
  }
  onDestroying() {
    this.unregisterListeners();
    this._clear();
  }
  onMediaAttached(event, data) {
    if (!this.config.emeEnabled) {
      return;
    }
    const media = data.media;

    // keep reference of media
    this.media = media;
    addEventListener(media, 'encrypted', this.onMediaEncrypted);
    addEventListener(media, 'waitingforkey', this.onWaitingForKey);
  }
  onMediaDetached() {
    const media = this.media;
    if (media) {
      removeEventListener(media, 'encrypted', this.onMediaEncrypted);
      removeEventListener(media, 'waitingforkey', this.onWaitingForKey);
      this.media = null;
      this.mediaKeys = null;
    }
  }
  _clear() {
    var _media$setMediaKeys;
    this._requestLicenseFailureCount = 0;
    this.keyIdToKeySessionPromise = {};
    if (!this.mediaKeys && !this.mediaKeySessions.length) {
      return;
    }
    const media = this.media;
    const mediaKeysList = this.mediaKeySessions.slice();
    this.mediaKeySessions = [];
    this.mediaKeys = null;
    LevelKey.clearKeyUriToKeyIdMap();

    // Close all sessions and remove media keys from the video element.
    const keySessionCount = mediaKeysList.length;
    EMEController.CDMCleanupPromise = Promise.all(mediaKeysList.map(mediaKeySessionContext => this.removeSession(mediaKeySessionContext)).concat(media == null ? void 0 : (_media$setMediaKeys = media.setMediaKeys(null)) == null ? void 0 : _media$setMediaKeys.catch(error => {
      var _this$hls2;
      this.log(`Could not clear media keys: ${error}`);
      (_this$hls2 = this.hls) == null ? void 0 : _this$hls2.trigger(Events.ERROR, {
        type: ErrorTypes.OTHER_ERROR,
        details: ErrorDetails.KEY_SYSTEM_DESTROY_MEDIA_KEYS_ERROR,
        fatal: false,
        error: new Error(`Could not clear media keys: ${error}`)
      });
    }))).catch(error => {
      var _this$hls3;
      this.log(`Could not close sessions and clear media keys: ${error}`);
      (_this$hls3 = this.hls) == null ? void 0 : _this$hls3.trigger(Events.ERROR, {
        type: ErrorTypes.OTHER_ERROR,
        details: ErrorDetails.KEY_SYSTEM_DESTROY_CLOSE_SESSION_ERROR,
        fatal: false,
        error: new Error(`Could not close sessions and clear media keys: ${error}`)
      });
    }).then(() => {
      if (keySessionCount) {
        this.log('finished closing key sessions and clearing media keys');
      }
    });
  }
  onManifestLoading() {
    this.keyFormatPromise = null;
  }
  onManifestLoaded(event, {
    sessionKeys
  }) {
    if (!sessionKeys || !this.config.emeEnabled) {
      return;
    }
    if (!this.keyFormatPromise) {
      const keyFormats = sessionKeys.reduce((formats, sessionKey) => {
        if (formats.indexOf(sessionKey.keyFormat) === -1) {
          formats.push(sessionKey.keyFormat);
        }
        return formats;
      }, []);
      this.log(`Selecting key-system from session-keys ${keyFormats.join(', ')}`);
      this.keyFormatPromise = this.getKeyFormatPromise(keyFormats);
    }
  }
  removeSession(mediaKeySessionContext) {
    const {
      mediaKeysSession,
      licenseXhr
    } = mediaKeySessionContext;
    if (mediaKeysSession) {
      this.log(`Remove licenses and keys and close session ${mediaKeysSession.sessionId}`);
      if (mediaKeySessionContext._onmessage) {
        mediaKeysSession.removeEventListener('message', mediaKeySessionContext._onmessage);
        mediaKeySessionContext._onmessage = undefined;
      }
      if (mediaKeySessionContext._onkeystatuseschange) {
        mediaKeysSession.removeEventListener('keystatuseschange', mediaKeySessionContext._onkeystatuseschange);
        mediaKeySessionContext._onkeystatuseschange = undefined;
      }
      if (licenseXhr && licenseXhr.readyState !== XMLHttpRequest.DONE) {
        licenseXhr.abort();
      }
      mediaKeySessionContext.mediaKeysSession = mediaKeySessionContext.decryptdata = mediaKeySessionContext.licenseXhr = undefined;
      const index = this.mediaKeySessions.indexOf(mediaKeySessionContext);
      if (index > -1) {
        this.mediaKeySessions.splice(index, 1);
      }
      const {
        drmSystemOptions
      } = this.config;
      const removePromise = isPersistentSessionType(drmSystemOptions) ? new Promise((resolve, reject) => {
        self.setTimeout(() => reject(new Error(`MediaKeySession.remove() timeout`)), 8000);
        mediaKeysSession.remove().then(resolve);
      }) : Promise.resolve();
      return removePromise.catch(error => {
        var _this$hls4;
        this.log(`Could not remove session: ${error}`);
        (_this$hls4 = this.hls) == null ? void 0 : _this$hls4.trigger(Events.ERROR, {
          type: ErrorTypes.OTHER_ERROR,
          details: ErrorDetails.KEY_SYSTEM_DESTROY_REMOVE_SESSION_ERROR,
          fatal: false,
          error: new Error(`Could not remove session: ${error}`)
        });
      }).then(() => {
        return mediaKeysSession.close();
      }).catch(error => {
        var _this$hls5;
        this.log(`Could not close session: ${error}`);
        (_this$hls5 = this.hls) == null ? void 0 : _this$hls5.trigger(Events.ERROR, {
          type: ErrorTypes.OTHER_ERROR,
          details: ErrorDetails.KEY_SYSTEM_DESTROY_CLOSE_SESSION_ERROR,
          fatal: false,
          error: new Error(`Could not close session: ${error}`)
        });
      });
    }
  }
}
EMEController.CDMCleanupPromise = void 0;
class EMEKeyError extends Error {
  constructor(data, message) {
    super(message);
    this.data = void 0;
    data.error || (data.error = new Error(message));
    this.data = data;
    data.err = data.error;
  }
}

class FPSController {
  constructor(hls) {
    this.hls = void 0;
    this.isVideoPlaybackQualityAvailable = false;
    this.timer = void 0;
    this.media = null;
    this.lastTime = void 0;
    this.lastDroppedFrames = 0;
    this.lastDecodedFrames = 0;
    // stream controller must be provided as a dependency!
    this.streamController = void 0;
    this.hls = hls;
    this.registerListeners();
  }
  setStreamController(streamController) {
    this.streamController = streamController;
  }
  registerListeners() {
    this.hls.on(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
    this.hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
  }
  unregisterListeners() {
    this.hls.off(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
    this.hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
  }
  destroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    this.unregisterListeners();
    this.isVideoPlaybackQualityAvailable = false;
    this.media = null;
  }
  onMediaAttaching(event, data) {
    const config = this.hls.config;
    if (config.capLevelOnFPSDrop) {
      const media = data.media instanceof self.HTMLVideoElement ? data.media : null;
      this.media = media;
      if (media && typeof media.getVideoPlaybackQuality === 'function') {
        this.isVideoPlaybackQualityAvailable = true;
      }
      self.clearInterval(this.timer);
      this.timer = self.setInterval(this.checkFPSInterval.bind(this), config.fpsDroppedMonitoringPeriod);
    }
  }
  onMediaDetaching() {
    this.media = null;
  }
  checkFPS(video, decodedFrames, droppedFrames) {
    const currentTime = performance.now();
    if (decodedFrames) {
      if (this.lastTime) {
        const currentPeriod = currentTime - this.lastTime;
        const currentDropped = droppedFrames - this.lastDroppedFrames;
        const currentDecoded = decodedFrames - this.lastDecodedFrames;
        const droppedFPS = 1000 * currentDropped / currentPeriod;
        const hls = this.hls;
        hls.trigger(Events.FPS_DROP, {
          currentDropped: currentDropped,
          currentDecoded: currentDecoded,
          totalDroppedFrames: droppedFrames
        });
        if (droppedFPS > 0) {
          // hls.logger.log('checkFPS : droppedFPS/decodedFPS:' + droppedFPS/(1000 * currentDecoded / currentPeriod));
          if (currentDropped > hls.config.fpsDroppedMonitoringThreshold * currentDecoded) {
            let currentLevel = hls.currentLevel;
            hls.logger.warn('drop FPS ratio greater than max allowed value for currentLevel: ' + currentLevel);
            if (currentLevel > 0 && (hls.autoLevelCapping === -1 || hls.autoLevelCapping >= currentLevel)) {
              currentLevel = currentLevel - 1;
              hls.trigger(Events.FPS_DROP_LEVEL_CAPPING, {
                level: currentLevel,
                droppedLevel: hls.currentLevel
              });
              hls.autoLevelCapping = currentLevel;
              this.streamController.nextLevelSwitch();
            }
          }
        }
      }
      this.lastTime = currentTime;
      this.lastDroppedFrames = droppedFrames;
      this.lastDecodedFrames = decodedFrames;
    }
  }
  checkFPSInterval() {
    const video = this.media;
    if (video) {
      if (this.isVideoPlaybackQualityAvailable) {
        const videoPlaybackQuality = video.getVideoPlaybackQuality();
        this.checkFPS(video, videoPlaybackQuality.totalVideoFrames, videoPlaybackQuality.droppedVideoFrames);
      } else {
        // HTMLVideoElement doesn't include the webkit types
        this.checkFPS(video, video.webkitDecodedFrameCount, video.webkitDroppedFrameCount);
      }
    }
  }
}

function sendAddTrackEvent(track, videoEl) {
  let event;
  try {
    event = new Event('addtrack');
  } catch (err) {
    // for IE11
    event = document.createEvent('Event');
    event.initEvent('addtrack', false, false);
  }
  event.track = track;
  videoEl.dispatchEvent(event);
}
function addCueToTrack(track, cue) {
  // Sometimes there are cue overlaps on segmented vtts so the same
  // cue can appear more than once in different vtt files.
  // This avoid showing duplicated cues with same timecode and text.
  const mode = track.mode;
  if (mode === 'disabled') {
    track.mode = 'hidden';
  }
  if (track.cues && !track.cues.getCueById(cue.id)) {
    try {
      track.addCue(cue);
      if (!track.cues.getCueById(cue.id)) {
        throw new Error(`addCue is failed for: ${cue}`);
      }
    } catch (err) {
      hls_logger.debug(`[texttrack-utils]: ${err}`);
      try {
        const textTrackCue = new self.TextTrackCue(cue.startTime, cue.endTime, cue.text);
        textTrackCue.id = cue.id;
        track.addCue(textTrackCue);
      } catch (err2) {
        hls_logger.debug(`[texttrack-utils]: Legacy TextTrackCue fallback failed: ${err2}`);
      }
    }
  }
  if (mode === 'disabled') {
    track.mode = mode;
  }
}
function clearCurrentCues(track, enterHandler) {
  // When track.mode is disabled, track.cues will be null.
  // To guarantee the removal of cues, we need to temporarily
  // change the mode to hidden
  const mode = track.mode;
  if (mode === 'disabled') {
    track.mode = 'hidden';
  }
  if (track.cues) {
    for (let i = track.cues.length; i--;) {
      if (enterHandler) {
        track.cues[i].removeEventListener('enter', enterHandler);
      }
      track.removeCue(track.cues[i]);
    }
  }
  if (mode === 'disabled') {
    track.mode = mode;
  }
}
function removeCuesInRange(track, start, end, predicate) {
  const mode = track.mode;
  if (mode === 'disabled') {
    track.mode = 'hidden';
  }
  if (track.cues && track.cues.length > 0) {
    const cues = getCuesInRange(track.cues, start, end);
    for (let i = 0; i < cues.length; i++) {
      if (!predicate || predicate(cues[i])) {
        track.removeCue(cues[i]);
      }
    }
  }
  if (mode === 'disabled') {
    track.mode = mode;
  }
}

// Find first cue starting at or after given time.
// Modified version of binary search O(log(n)).
function getFirstCueIndexFromTime(cues, time) {
  // If first cue starts at or after time, start there
  if (time <= cues[0].startTime) {
    return 0;
  }
  // If the last cue ends before time there is no overlap
  const len = cues.length - 1;
  if (time > cues[len].endTime) {
    return -1;
  }
  let left = 0;
  let right = len;
  let mid;
  while (left <= right) {
    mid = Math.floor((right + left) / 2);
    if (time < cues[mid].startTime) {
      right = mid - 1;
    } else if (time > cues[mid].startTime && left < len) {
      left = mid + 1;
    } else {
      // If it's not lower or higher, it must be equal.
      return mid;
    }
  }
  // At this point, left and right have swapped.
  // No direct match was found, left or right element must be the closest. Check which one has the smallest diff.
  return cues[left].startTime - time < time - cues[right].startTime ? left : right;
}
function getCuesInRange(cues, start, end) {
  const cuesFound = [];
  const firstCueInRange = getFirstCueIndexFromTime(cues, start);
  if (firstCueInRange > -1) {
    for (let i = firstCueInRange, len = cues.length; i < len; i++) {
      const cue = cues[i];
      if (cue.startTime >= start && cue.endTime <= end) {
        cuesFound.push(cue);
      } else if (cue.startTime > end) {
        return cuesFound;
      }
    }
  }
  return cuesFound;
}
function filterSubtitleTracks(textTrackList) {
  const tracks = [];
  for (let i = 0; i < textTrackList.length; i++) {
    const track = textTrackList[i];
    // Edge adds a track without a label; we don't want to use it
    if ((track.kind === 'subtitles' || track.kind === 'captions') && track.label) {
      tracks.push(textTrackList[i]);
    }
  }
  return tracks;
}

class SubtitleTrackController extends BasePlaylistController {
  constructor(hls) {
    super(hls, 'subtitle-track-controller');
    this.media = null;
    this.tracks = [];
    this.groupIds = null;
    this.tracksInGroup = [];
    this.trackId = -1;
    this.currentTrack = null;
    this.selectDefaultTrack = true;
    this.queuedDefaultTrack = -1;
    this.useTextTrackPolling = false;
    this.subtitlePollingInterval = -1;
    this._subtitleDisplay = true;
    this.asyncPollTrackChange = () => this.pollTrackChange(0);
    this.onTextTracksChanged = () => {
      if (!this.useTextTrackPolling) {
        self.clearInterval(this.subtitlePollingInterval);
      }
      // Media is undefined when switching streams via loadSource()
      if (!this.media || !this.hls.config.renderTextTracksNatively) {
        return;
      }
      let textTrack = null;
      const tracks = filterSubtitleTracks(this.media.textTracks);
      for (let i = 0; i < tracks.length; i++) {
        if (tracks[i].mode === 'hidden') {
          // Do not break in case there is a following track with showing.
          textTrack = tracks[i];
        } else if (tracks[i].mode === 'showing') {
          textTrack = tracks[i];
          break;
        }
      }

      // Find internal track index for TextTrack
      const trackId = this.findTrackForTextTrack(textTrack);
      if (this.subtitleTrack !== trackId) {
        this.setSubtitleTrack(trackId);
      }
    };
    this.registerListeners();
  }
  destroy() {
    this.unregisterListeners();
    this.tracks.length = 0;
    this.tracksInGroup.length = 0;
    this.currentTrack = null;
    // @ts-ignore
    this.onTextTracksChanged = this.asyncPollTrackChange = null;
    super.destroy();
  }
  get subtitleDisplay() {
    return this._subtitleDisplay;
  }
  set subtitleDisplay(value) {
    this._subtitleDisplay = value;
    if (this.trackId > -1) {
      this.toggleTrackModes();
    }
  }
  registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.on(Events.LEVEL_LOADING, this.onLevelLoading, this);
    hls.on(Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
    hls.on(Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this);
    hls.on(Events.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.off(Events.LEVEL_LOADING, this.onLevelLoading, this);
    hls.off(Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
    hls.off(Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this);
    hls.off(Events.ERROR, this.onError, this);
  }

  // Listen for subtitle track change, then extract the current track ID.
  onMediaAttached(event, data) {
    this.media = data.media;
    if (!this.media) {
      return;
    }
    if (this.queuedDefaultTrack > -1) {
      this.subtitleTrack = this.queuedDefaultTrack;
      this.queuedDefaultTrack = -1;
    }
    this.useTextTrackPolling = !(this.media.textTracks && 'onchange' in this.media.textTracks);
    if (this.useTextTrackPolling) {
      this.pollTrackChange(500);
    } else {
      this.media.textTracks.addEventListener('change', this.asyncPollTrackChange);
    }
  }
  pollTrackChange(timeout) {
    self.clearInterval(this.subtitlePollingInterval);
    this.subtitlePollingInterval = self.setInterval(this.onTextTracksChanged, timeout);
  }
  onMediaDetaching(event, data) {
    const media = this.media;
    if (!media) {
      return;
    }
    const transferringMedia = !!data.transferMedia;
    self.clearInterval(this.subtitlePollingInterval);
    if (!this.useTextTrackPolling) {
      media.textTracks.removeEventListener('change', this.asyncPollTrackChange);
    }
    if (this.trackId > -1) {
      this.queuedDefaultTrack = this.trackId;
    }

    // Disable all subtitle tracks before detachment so when reattached only tracks in that content are enabled.
    this.subtitleTrack = -1;
    this.media = null;
    if (transferringMedia) {
      return;
    }
    const textTracks = filterSubtitleTracks(media.textTracks);
    // Clear loaded cues on media detachment from tracks
    textTracks.forEach(track => {
      clearCurrentCues(track);
    });
  }
  onManifestLoading() {
    this.tracks = [];
    this.groupIds = null;
    this.tracksInGroup = [];
    this.trackId = -1;
    this.currentTrack = null;
    this.selectDefaultTrack = true;
  }

  // Fired whenever a new manifest is loaded.
  onManifestParsed(event, data) {
    this.tracks = data.subtitleTracks;
  }
  onSubtitleTrackLoaded(event, data) {
    const {
      id,
      groupId,
      details
    } = data;
    const trackInActiveGroup = this.tracksInGroup[id];
    if (!trackInActiveGroup || trackInActiveGroup.groupId !== groupId) {
      this.warn(`Subtitle track with id:${id} and group:${groupId} not found in active group ${trackInActiveGroup == null ? void 0 : trackInActiveGroup.groupId}`);
      return;
    }
    const curDetails = trackInActiveGroup.details;
    trackInActiveGroup.details = data.details;
    this.log(`Subtitle track ${id} "${trackInActiveGroup.name}" lang:${trackInActiveGroup.lang} group:${groupId} loaded [${details.startSN}-${details.endSN}]`);
    if (id === this.trackId) {
      this.playlistLoaded(id, data, curDetails);
    }
  }
  onLevelLoading(event, data) {
    this.switchLevel(data.level);
  }
  onLevelSwitching(event, data) {
    this.switchLevel(data.level);
  }
  switchLevel(levelIndex) {
    const levelInfo = this.hls.levels[levelIndex];
    if (!levelInfo) {
      return;
    }
    const subtitleGroups = levelInfo.subtitleGroups || null;
    const currentGroups = this.groupIds;
    let currentTrack = this.currentTrack;
    if (!subtitleGroups || (currentGroups == null ? void 0 : currentGroups.length) !== (subtitleGroups == null ? void 0 : subtitleGroups.length) || subtitleGroups != null && subtitleGroups.some(groupId => (currentGroups == null ? void 0 : currentGroups.indexOf(groupId)) === -1)) {
      this.groupIds = subtitleGroups;
      this.trackId = -1;
      this.currentTrack = null;
      const subtitleTracks = this.tracks.filter(track => !subtitleGroups || subtitleGroups.indexOf(track.groupId) !== -1);
      if (subtitleTracks.length) {
        // Disable selectDefaultTrack if there are no default tracks
        if (this.selectDefaultTrack && !subtitleTracks.some(track => track.default)) {
          this.selectDefaultTrack = false;
        }
        // track.id should match hls.audioTracks index
        subtitleTracks.forEach((track, i) => {
          track.id = i;
        });
      } else if (!currentTrack && !this.tracksInGroup.length) {
        // Do not dispatch SUBTITLE_TRACKS_UPDATED when there were and are no tracks
        return;
      }
      this.tracksInGroup = subtitleTracks;

      // Find preferred track
      const subtitlePreference = this.hls.config.subtitlePreference;
      if (!currentTrack && subtitlePreference) {
        this.selectDefaultTrack = false;
        const groupIndex = findMatchingOption(subtitlePreference, subtitleTracks);
        if (groupIndex > -1) {
          currentTrack = subtitleTracks[groupIndex];
        } else {
          const allIndex = findMatchingOption(subtitlePreference, this.tracks);
          currentTrack = this.tracks[allIndex];
        }
      }

      // Select initial track
      let trackId = this.findTrackId(currentTrack);
      if (trackId === -1 && currentTrack) {
        trackId = this.findTrackId(null);
      }

      // Dispatch events and load track if needed
      const subtitleTracksUpdated = {
        subtitleTracks
      };
      this.log(`Updating subtitle tracks, ${subtitleTracks.length} track(s) found in "${subtitleGroups == null ? void 0 : subtitleGroups.join(',')}" group-id`);
      this.hls.trigger(Events.SUBTITLE_TRACKS_UPDATED, subtitleTracksUpdated);
      if (trackId !== -1 && this.trackId === -1) {
        this.setSubtitleTrack(trackId);
      }
    }
  }
  findTrackId(currentTrack) {
    const tracks = this.tracksInGroup;
    const selectDefault = this.selectDefaultTrack;
    for (let i = 0; i < tracks.length; i++) {
      const track = tracks[i];
      if (selectDefault && !track.default || !selectDefault && !currentTrack) {
        continue;
      }
      if (!currentTrack || matchesOption(track, currentTrack)) {
        return i;
      }
    }
    if (currentTrack) {
      for (let i = 0; i < tracks.length; i++) {
        const track = tracks[i];
        if (mediaAttributesIdentical(currentTrack.attrs, track.attrs, ['LANGUAGE', 'ASSOC-LANGUAGE', 'CHARACTERISTICS'])) {
          return i;
        }
      }
      for (let i = 0; i < tracks.length; i++) {
        const track = tracks[i];
        if (mediaAttributesIdentical(currentTrack.attrs, track.attrs, ['LANGUAGE'])) {
          return i;
        }
      }
    }
    return -1;
  }
  findTrackForTextTrack(textTrack) {
    if (textTrack) {
      const tracks = this.tracksInGroup;
      for (let i = 0; i < tracks.length; i++) {
        const track = tracks[i];
        if (subtitleTrackMatchesTextTrack(track, textTrack)) {
          return i;
        }
      }
    }
    return -1;
  }
  onError(event, data) {
    if (data.fatal || !data.context) {
      return;
    }
    if (data.context.type === PlaylistContextType.SUBTITLE_TRACK && data.context.id === this.trackId && (!this.groupIds || this.groupIds.indexOf(data.context.groupId) !== -1)) {
      this.checkRetry(data);
    }
  }
  get allSubtitleTracks() {
    return this.tracks;
  }

  /** get alternate subtitle tracks list from playlist **/
  get subtitleTracks() {
    return this.tracksInGroup;
  }

  /** get/set index of the selected subtitle track (based on index in subtitle track lists) **/
  get subtitleTrack() {
    return this.trackId;
  }
  set subtitleTrack(newId) {
    this.selectDefaultTrack = false;
    this.setSubtitleTrack(newId);
  }
  setSubtitleOption(subtitleOption) {
    this.hls.config.subtitlePreference = subtitleOption;
    if (subtitleOption) {
      if (subtitleOption.id === -1) {
        this.setSubtitleTrack(-1);
        return null;
      }
      const allSubtitleTracks = this.allSubtitleTracks;
      this.selectDefaultTrack = false;
      if (allSubtitleTracks.length) {
        // First see if current option matches (no switch op)
        const currentTrack = this.currentTrack;
        if (currentTrack && matchesOption(subtitleOption, currentTrack)) {
          return currentTrack;
        }
        // Find option in current group
        const groupIndex = findMatchingOption(subtitleOption, this.tracksInGroup);
        if (groupIndex > -1) {
          const track = this.tracksInGroup[groupIndex];
          this.setSubtitleTrack(groupIndex);
          return track;
        } else if (currentTrack) {
          // If this is not the initial selection return null
          // option should have matched one in active group
          return null;
        } else {
          // Find the option in all tracks for initial selection
          const allIndex = findMatchingOption(subtitleOption, allSubtitleTracks);
          if (allIndex > -1) {
            return allSubtitleTracks[allIndex];
          }
        }
      }
    }
    return null;
  }
  loadPlaylist(hlsUrlParameters) {
    super.loadPlaylist();
    if (this.shouldLoadPlaylist(this.currentTrack)) {
      this.scheduleLoading(this.currentTrack, hlsUrlParameters);
    }
  }
  loadingPlaylist(currentTrack, hlsUrlParameters) {
    super.loadingPlaylist(currentTrack, hlsUrlParameters);
    const id = currentTrack.id;
    const groupId = currentTrack.groupId;
    const url = this.getUrlWithDirectives(currentTrack.url, hlsUrlParameters);
    const details = currentTrack.details;
    const age = details == null ? void 0 : details.age;
    this.log(`Loading subtitle ${id} "${currentTrack.name}" lang:${currentTrack.lang} group:${groupId}${(hlsUrlParameters == null ? void 0 : hlsUrlParameters.msn) !== undefined ? ' at sn ' + hlsUrlParameters.msn + ' part ' + hlsUrlParameters.part : ''}${age && details.live ? ' age ' + age.toFixed(1) + (details.type ? ' ' + details.type || 0 : '') : ''} ${url}`);
    this.hls.trigger(Events.SUBTITLE_TRACK_LOADING, {
      url,
      id,
      groupId,
      deliveryDirectives: hlsUrlParameters || null,
      track: currentTrack
    });
  }

  /**
   * Disables the old subtitleTrack and sets current mode on the next subtitleTrack.
   * This operates on the DOM textTracks.
   * A value of -1 will disable all subtitle tracks.
   */
  toggleTrackModes() {
    const {
      media
    } = this;
    if (!media) {
      return;
    }
    const textTracks = filterSubtitleTracks(media.textTracks);
    const currentTrack = this.currentTrack;
    let nextTrack;
    if (currentTrack) {
      nextTrack = textTracks.filter(textTrack => subtitleTrackMatchesTextTrack(currentTrack, textTrack))[0];
      if (!nextTrack) {
        this.warn(`Unable to find subtitle TextTrack with name "${currentTrack.name}" and language "${currentTrack.lang}"`);
      }
    }
    [].slice.call(textTracks).forEach(track => {
      if (track.mode !== 'disabled' && track !== nextTrack) {
        track.mode = 'disabled';
      }
    });
    if (nextTrack) {
      const mode = this.subtitleDisplay ? 'showing' : 'hidden';
      if (nextTrack.mode !== mode) {
        nextTrack.mode = mode;
      }
    }
  }

  /**
   * This method is responsible for validating the subtitle index and periodically reloading if live.
   * Dispatches the SUBTITLE_TRACK_SWITCH event, which instructs the subtitle-stream-controller to load the selected track.
   */
  setSubtitleTrack(newId) {
    const tracks = this.tracksInGroup;

    // setting this.subtitleTrack will trigger internal logic
    // if media has not been attached yet, it will fail
    // we keep a reference to the default track id
    // and we'll set subtitleTrack when onMediaAttached is triggered
    if (!this.media) {
      this.queuedDefaultTrack = newId;
      return;
    }

    // exit if track id as already set or invalid
    if (newId < -1 || newId >= tracks.length || !isFiniteNumber(newId)) {
      this.warn(`Invalid subtitle track id: ${newId}`);
      return;
    }
    this.selectDefaultTrack = false;
    const lastTrack = this.currentTrack;
    const track = tracks[newId] || null;
    this.trackId = newId;
    this.currentTrack = track;
    this.toggleTrackModes();
    if (!track) {
      // switch to -1
      this.hls.trigger(Events.SUBTITLE_TRACK_SWITCH, {
        id: newId
      });
      return;
    }
    const trackLoaded = !!track.details && !track.details.live;
    if (newId === this.trackId && track === lastTrack && trackLoaded) {
      return;
    }
    this.log(`Switching to subtitle-track ${newId}` + (track ? ` "${track.name}" lang:${track.lang} group:${track.groupId}` : ''));
    const {
      id,
      groupId = '',
      name,
      type,
      url
    } = track;
    this.hls.trigger(Events.SUBTITLE_TRACK_SWITCH, {
      id,
      groupId,
      name,
      type,
      url
    });
    const hlsUrlParameters = this.switchParams(track.url, lastTrack == null ? void 0 : lastTrack.details, track.details);
    this.loadPlaylist(hlsUrlParameters);
  }
}

/**
 * Generate a random v4 UUID
 *
 * @returns A random v4 UUID
 *
 * @group Utils
 *
 * @beta
 */
function uuid() {
  try {
    return crypto.randomUUID();
  } catch (error) {
    try {
      const url = URL.createObjectURL(new Blob());
      const uuid = url.toString();
      URL.revokeObjectURL(url);
      return uuid.slice(uuid.lastIndexOf('/') + 1);
    } catch (error) {
      let dt = new Date().getTime();
      const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
      });
      return uuid;
    }
  }
}

// From https://github.com/darkskyapp/string-hash
function hash(text) {
  let hash = 5381;
  let i = text.length;
  while (i) {
    hash = hash * 33 ^ text.charCodeAt(--i);
  }
  return (hash >>> 0).toString();
}

const ALIGNED_END_THRESHOLD_SECONDS = 0.025;
let TimelineOccupancy = /*#__PURE__*/function (TimelineOccupancy) {
  TimelineOccupancy[TimelineOccupancy["Point"] = 0] = "Point";
  TimelineOccupancy[TimelineOccupancy["Range"] = 1] = "Range";
  return TimelineOccupancy;
}({});
function generateAssetIdentifier(interstitial, uri, assetListIndex) {
  return `${interstitial.identifier}-${assetListIndex + 1}-${hash(uri)}`;
}
class InterstitialEvent {
  constructor(dateRange, base) {
    this.base = void 0;
    this._duration = null;
    this._timelineStart = null;
    this.appendInPlaceDisabled = void 0;
    this.appendInPlaceStarted = void 0;
    this.dateRange = void 0;
    this.hasPlayed = false;
    this.cumulativeDuration = 0;
    this.resumeOffset = NaN;
    this.playoutLimit = NaN;
    this.restrictions = {
      skip: false,
      jump: false
    };
    this.snapOptions = {
      out: false,
      in: false
    };
    this.assetList = [];
    this.assetListLoader = void 0;
    this.assetListResponse = null;
    this.resumeAnchor = void 0;
    this.error = void 0;
    this.resetOnResume = void 0;
    this.base = base;
    this.dateRange = dateRange;
    this.setDateRange(dateRange);
  }
  setDateRange(dateRange) {
    this.dateRange = dateRange;
    this.resumeOffset = dateRange.attr.optionalFloat('X-RESUME-OFFSET', this.resumeOffset);
    this.playoutLimit = dateRange.attr.optionalFloat('X-PLAYOUT-LIMIT', this.playoutLimit);
    this.restrictions = dateRange.attr.enumeratedStringList('X-RESTRICT', this.restrictions);
    this.snapOptions = dateRange.attr.enumeratedStringList('X-SNAP', this.snapOptions);
  }
  reset() {
    var _this$assetListLoader;
    this.appendInPlaceStarted = false;
    (_this$assetListLoader = this.assetListLoader) == null ? void 0 : _this$assetListLoader.destroy();
    this.assetListLoader = undefined;
    if (!this.supplementsPrimary) {
      this.assetListResponse = null;
      this.assetList = [];
      this._duration = null;
    }
    // `error?` is reset when seeking back over interstitial `startOffset`
    //  using `schedule.resetErrorsInRange(start, end)`.
  }
  isAssetPastPlayoutLimit(assetIndex) {
    var _this$assetList$asset;
    if (assetIndex > 0 && assetIndex >= this.assetList.length) {
      return true;
    }
    const playoutLimit = this.playoutLimit;
    if (assetIndex <= 0 || isNaN(playoutLimit)) {
      return false;
    }
    if (playoutLimit === 0) {
      return true;
    }
    const assetOffset = ((_this$assetList$asset = this.assetList[assetIndex]) == null ? void 0 : _this$assetList$asset.startOffset) || 0;
    return assetOffset > playoutLimit;
  }
  findAssetIndex(asset) {
    const index = this.assetList.indexOf(asset);
    return index;
  }
  get identifier() {
    return this.dateRange.id;
  }
  get startDate() {
    return this.dateRange.startDate;
  }
  get startTime() {
    // Primary media timeline start time
    const startTime = this.dateRange.startTime;
    if (this.snapOptions.out) {
      const frag = this.dateRange.tagAnchor;
      if (frag) {
        return getSnapToFragmentTime(startTime, frag);
      }
    }
    return startTime;
  }
  get startOffset() {
    return this.cue.pre ? 0 : this.startTime;
  }
  get startIsAligned() {
    if (this.startTime === 0 || this.snapOptions.out) {
      return true;
    }
    const frag = this.dateRange.tagAnchor;
    if (frag) {
      const startTime = this.dateRange.startTime;
      const snappedStart = getSnapToFragmentTime(startTime, frag);
      return startTime - snappedStart < 0.1;
    }
    return false;
  }
  get resumptionOffset() {
    const resumeOffset = this.resumeOffset;
    const offset = isFiniteNumber(resumeOffset) ? resumeOffset : this.duration;
    return this.cumulativeDuration + offset;
  }
  get resumeTime() {
    // Primary media timeline resumption time
    const resumeTime = this.startOffset + this.resumptionOffset;
    if (this.snapOptions.in) {
      const frag = this.resumeAnchor;
      if (frag) {
        return getSnapToFragmentTime(resumeTime, frag);
      }
    }
    return resumeTime;
  }
  get appendInPlace() {
    if (this.appendInPlaceStarted) {
      return true;
    }
    if (this.appendInPlaceDisabled) {
      return false;
    }
    if (!this.cue.once && !this.cue.pre &&
    // preroll starts at startPosition before startPosition is known (live)
    this.startIsAligned && (isNaN(this.playoutLimit) && isNaN(this.resumeOffset) || this.resumeOffset && this.duration && Math.abs(this.resumeOffset - this.duration) < ALIGNED_END_THRESHOLD_SECONDS)) {
      return true;
    }
    return false;
  }
  set appendInPlace(value) {
    if (this.appendInPlaceStarted) {
      this.resetOnResume = !value;
      return;
    }
    this.appendInPlaceDisabled = !value;
  }

  // Extended timeline start time
  get timelineStart() {
    if (this._timelineStart !== null) {
      return this._timelineStart;
    }
    return this.startTime;
  }
  set timelineStart(value) {
    this._timelineStart = value;
  }
  get duration() {
    const playoutLimit = this.playoutLimit;
    let duration;
    if (this._duration !== null) {
      duration = this._duration;
    } else if (this.dateRange.duration) {
      duration = this.dateRange.duration;
    } else {
      duration = this.dateRange.plannedDuration || 0;
    }
    if (!isNaN(playoutLimit) && playoutLimit < duration) {
      duration = playoutLimit;
    }
    return duration;
  }
  set duration(value) {
    this._duration = value;
  }
  get cue() {
    return this.dateRange.cue;
  }
  get timelineOccupancy() {
    if (this.dateRange.attr['X-TIMELINE-OCCUPIES'] === 'RANGE') {
      return TimelineOccupancy.Range;
    }
    return TimelineOccupancy.Point;
  }
  get supplementsPrimary() {
    return this.dateRange.attr['X-TIMELINE-STYLE'] === 'PRIMARY';
  }
  get contentMayVary() {
    return this.dateRange.attr['X-CONTENT-MAY-VARY'] !== 'NO';
  }
  get assetUrl() {
    return this.dateRange.attr['X-ASSET-URI'];
  }
  get assetListUrl() {
    return this.dateRange.attr['X-ASSET-LIST'];
  }
  get baseUrl() {
    return this.base.url;
  }
  get assetListLoaded() {
    return this.assetList.length > 0 || this.assetListResponse !== null;
  }
  toString() {
    return eventToString(this);
  }
}
function getSnapToFragmentTime(time, frag) {
  return time - frag.start < frag.duration / 2 && !(Math.abs(time - (frag.start + frag.duration)) < ALIGNED_END_THRESHOLD_SECONDS) ? frag.start : frag.start + frag.duration;
}
function getInterstitialUrl(uri, sessionId, baseUrl) {
  const url = new self.URL(uri, baseUrl);
  if (url.protocol !== 'data:') {
    url.searchParams.set('_HLS_primary_id', sessionId);
  }
  return url;
}
function getNextAssetIndex(interstitial, assetListIndex) {
  while ((_interstitial$assetLi = interstitial.assetList[++assetListIndex]) != null && _interstitial$assetLi.error) {
    var _interstitial$assetLi;
  } /* no-op */
  return assetListIndex;
}
function eventToString(interstitial) {
  return `["${interstitial.identifier}" ${interstitial.cue.pre ? '<pre>' : interstitial.cue.post ? '<post>' : ''}${interstitial.timelineStart.toFixed(2)}-${interstitial.resumeTime.toFixed(2)}]`;
}
function eventAssetToString(asset) {
  const start = asset.timelineStart;
  const duration = asset.duration || 0;
  return `["${asset.identifier}" ${start.toFixed(2)}-${(start + duration).toFixed(2)}]`;
}

class HlsAssetPlayer {
  constructor(HlsPlayerClass, userConfig, interstitial, assetItem) {
    this.hls = void 0;
    this.interstitial = void 0;
    this.assetItem = void 0;
    this.tracks = null;
    this.hasDetails = false;
    this.mediaAttached = null;
    this._currentTime = void 0;
    this._bufferedEosTime = void 0;
    this.checkPlayout = () => {
      if (this.reachedPlayout(this.currentTime)) {
        this.hls.trigger(Events.PLAYOUT_LIMIT_REACHED, {});
      }
    };
    const hls = this.hls = new HlsPlayerClass(userConfig);
    this.interstitial = interstitial;
    this.assetItem = assetItem;
    let uri = assetItem.uri;
    try {
      uri = getInterstitialUrl(uri, userConfig.primarySessionId).href;
    } catch (error) {
      // Ignore error parsing ASSET_URI or adding _HLS_primary_id to it. The
      // issue should surface as an INTERSTITIAL_ASSET_ERROR loading the asset.
    }
    hls.loadSource(uri);
    const detailsLoaded = () => {
      this.hasDetails = true;
    };
    hls.once(Events.LEVEL_LOADED, detailsLoaded);
    hls.once(Events.AUDIO_TRACK_LOADED, detailsLoaded);
    hls.once(Events.SUBTITLE_TRACK_LOADED, detailsLoaded);
    hls.on(Events.MEDIA_ATTACHING, (name, {
      media
    }) => {
      this.removeMediaListeners();
      this.mediaAttached = media;
      const event = this.interstitial;
      if (event.playoutLimit) {
        media.addEventListener('timeupdate', this.checkPlayout);
        if (this.appendInPlace) {
          hls.on(Events.BUFFER_APPENDED, () => {
            const bufferedEnd = this.bufferedEnd;
            if (this.reachedPlayout(bufferedEnd)) {
              this._bufferedEosTime = bufferedEnd;
              hls.trigger(Events.BUFFERED_TO_END, undefined);
            }
          });
        }
      }
    });
  }
  get appendInPlace() {
    var _this$interstitial;
    return ((_this$interstitial = this.interstitial) == null ? void 0 : _this$interstitial.appendInPlace) || false;
  }
  bufferedInPlaceToEnd(media) {
    var _this$hls;
    if (!this.appendInPlace) {
      return false;
    }
    if ((_this$hls = this.hls) != null && _this$hls.bufferedToEnd) {
      return true;
    }
    if (!media || !this._bufferedEosTime) {
      return false;
    }
    const start = this.timelineOffset;
    const bufferInfo = BufferHelper.bufferInfo(media, start, 0);
    const bufferedEnd = this.getAssetTime(bufferInfo.end);
    return bufferedEnd >= this._bufferedEosTime - 0.02;
  }
  reachedPlayout(time) {
    const interstitial = this.interstitial;
    const playoutLimit = interstitial.playoutLimit;
    return this.startOffset + time >= playoutLimit;
  }
  get destroyed() {
    var _this$hls2;
    return !((_this$hls2 = this.hls) != null && _this$hls2.userConfig);
  }
  get assetId() {
    return this.assetItem.identifier;
  }
  get interstitialId() {
    return this.assetItem.parentIdentifier;
  }
  get media() {
    var _this$hls3;
    return ((_this$hls3 = this.hls) == null ? void 0 : _this$hls3.media) || null;
  }
  get bufferedEnd() {
    const media = this.media || this.mediaAttached;
    if (!media) {
      if (this._bufferedEosTime) {
        return this._bufferedEosTime;
      }
      return this.currentTime;
    }
    const bufferInfo = BufferHelper.bufferInfo(media, media.currentTime, 0.001);
    return this.getAssetTime(bufferInfo.end);
  }
  get currentTime() {
    const media = this.media || this.mediaAttached;
    if (!media) {
      return this._currentTime || 0;
    }
    return this.getAssetTime(media.currentTime);
  }
  get duration() {
    const duration = this.assetItem.duration;
    if (!duration) {
      return 0;
    }
    return duration;
  }
  get remaining() {
    const duration = this.duration;
    if (!duration) {
      return 0;
    }
    return Math.max(0, duration - this.currentTime);
  }
  get startOffset() {
    return this.assetItem.startOffset;
  }
  get timelineOffset() {
    var _this$hls4;
    return ((_this$hls4 = this.hls) == null ? void 0 : _this$hls4.config.timelineOffset) || 0;
  }
  set timelineOffset(value) {
    const timelineOffset = this.timelineOffset;
    if (value !== timelineOffset) {
      const diff = value - timelineOffset;
      if (Math.abs(diff) > 1 / 90000) {
        if (this.hasDetails) {
          throw new Error(`Cannot set timelineOffset after playlists are loaded`);
        }
        this.hls.config.timelineOffset = value;
      }
    }
  }
  getAssetTime(time) {
    const timelineOffset = this.timelineOffset;
    const duration = this.duration;
    return Math.min(Math.max(0, time - timelineOffset), duration);
  }
  removeMediaListeners() {
    const media = this.mediaAttached;
    if (media) {
      this._currentTime = media.currentTime;
      this.bufferSnapShot();
      media.removeEventListener('timeupdate', this.checkPlayout);
    }
  }
  bufferSnapShot() {
    if (this.mediaAttached) {
      var _this$hls5;
      if ((_this$hls5 = this.hls) != null && _this$hls5.bufferedToEnd) {
        this._bufferedEosTime = this.bufferedEnd;
      }
    }
  }
  destroy() {
    this.removeMediaListeners();
    this.hls.destroy();
    // @ts-ignore
    this.hls = this.interstitial = null;
    // @ts-ignore
    this.tracks = this.mediaAttached = this.checkPlayout = null;
  }
  attachMedia(data) {
    this.hls.attachMedia(data);
  }
  detachMedia() {
    this.removeMediaListeners();
    this.mediaAttached = null;
    this.hls.detachMedia();
  }
  resumeBuffering() {
    this.hls.resumeBuffering();
  }
  pauseBuffering() {
    this.hls.pauseBuffering();
  }
  transferMedia() {
    this.bufferSnapShot();
    return this.hls.transferMedia();
  }
  resetDetails() {
    const hls = this.hls;
    if (this.hasDetails) {
      hls.stopLoad();
      const deleteDetails = obj => delete obj.details;
      hls.levels.forEach(deleteDetails);
      hls.allAudioTracks.forEach(deleteDetails);
      hls.allSubtitleTracks.forEach(deleteDetails);
      this.hasDetails = false;
    }
  }
  on(event, listener, context) {
    this.hls.on(event, listener);
  }
  once(event, listener, context) {
    this.hls.once(event, listener);
  }
  off(event, listener, context) {
    this.hls.off(event, listener);
  }
  toString() {
    var _this$hls6;
    return `HlsAssetPlayer: ${eventAssetToString(this.assetItem)} ${(_this$hls6 = this.hls) == null ? void 0 : _this$hls6.sessionId} ${this.appendInPlace ? 'append-in-place' : ''}`;
  }
}

const ABUTTING_THRESHOLD_SECONDS = 0.033;
class InterstitialsSchedule extends hls_Logger {
  constructor(onScheduleUpdate, logger) {
    super('interstitials-sched', logger);
    this.onScheduleUpdate = void 0;
    this.eventMap = {};
    this.events = null;
    this.items = null;
    this.durations = {
      primary: 0,
      playout: 0,
      integrated: 0
    };
    this.onScheduleUpdate = onScheduleUpdate;
  }
  destroy() {
    this.reset();
    // @ts-ignore
    this.onScheduleUpdate = null;
  }
  reset() {
    this.eventMap = {};
    this.setDurations(0, 0, 0);
    if (this.events) {
      this.events.forEach(interstitial => interstitial.reset());
    }
    this.events = this.items = null;
  }
  resetErrorsInRange(start, end) {
    if (this.events) {
      return this.events.reduce((count, interstitial) => {
        if (start <= interstitial.startOffset && end > interstitial.startOffset) {
          delete interstitial.error;
          return count + 1;
        }
        return count;
      }, 0);
    }
    return 0;
  }
  get duration() {
    const items = this.items;
    return items ? items[items.length - 1].end : 0;
  }
  get length() {
    return this.items ? this.items.length : 0;
  }
  getEvent(identifier) {
    return identifier ? this.eventMap[identifier] || null : null;
  }
  hasEvent(identifier) {
    return identifier in this.eventMap;
  }
  findItemIndex(item, time) {
    if (item.event) {
      // Find Event Item
      return this.findEventIndex(item.event.identifier);
    }
    // Find Primary Item
    let index = -1;
    if (item.nextEvent) {
      index = this.findEventIndex(item.nextEvent.identifier) - 1;
    } else if (item.previousEvent) {
      index = this.findEventIndex(item.previousEvent.identifier) + 1;
    }
    const items = this.items;
    if (items) {
      if (!items[index]) {
        if (time === undefined) {
          time = item.start;
        }
        index = this.findItemIndexAtTime(time);
      }
      // Only return index of a Primary Item
      while (index >= 0 && (_items$index = items[index]) != null && _items$index.event) {
        var _items$index;
        // If index found is an interstitial it is not a valid result as it should have been matched up top
        // decrement until result is negative (not found) or a primary segment
        index--;
      }
    }
    return index;
  }
  findItemIndexAtTime(timelinePos, timelineType) {
    const items = this.items;
    if (items) {
      for (let i = 0; i < items.length; i++) {
        let timeRange = items[i];
        if (timelineType && timelineType !== 'primary') {
          timeRange = timeRange[timelineType];
        }
        if (timelinePos === timeRange.start || timelinePos > timeRange.start && timelinePos < timeRange.end) {
          return i;
        }
      }
    }
    return -1;
  }
  findJumpRestrictedIndex(startIndex, endIndex) {
    const items = this.items;
    if (items) {
      for (let i = startIndex; i <= endIndex; i++) {
        if (!items[i]) {
          break;
        }
        const event = items[i].event;
        if (event != null && event.restrictions.jump && !event.appendInPlace) {
          return i;
        }
      }
    }
    return -1;
  }
  findEventIndex(identifier) {
    const items = this.items;
    if (items) {
      for (let i = items.length; i--;) {
        var _items$i$event;
        if (((_items$i$event = items[i].event) == null ? void 0 : _items$i$event.identifier) === identifier) {
          return i;
        }
      }
    }
    return -1;
  }
  findAssetIndex(event, timelinePos) {
    const assetList = event.assetList;
    const length = assetList.length;
    if (length > 1) {
      for (let i = 0; i < length; i++) {
        const asset = assetList[i];
        if (!asset.error) {
          const timelineStart = asset.timelineStart;
          if (timelinePos === timelineStart || timelinePos > timelineStart && timelinePos < timelineStart + (asset.duration || 0)) {
            return i;
          }
        }
      }
    }
    return 0;
  }
  get assetIdAtEnd() {
    var _this$items, _this$items2;
    const interstitialAtEnd = (_this$items = this.items) == null ? void 0 : (_this$items2 = _this$items[this.length - 1]) == null ? void 0 : _this$items2.event;
    if (interstitialAtEnd) {
      const assetList = interstitialAtEnd.assetList;
      const assetAtEnd = assetList[assetList.length - 1];
      if (assetAtEnd) {
        return assetAtEnd.identifier;
      }
    }
    return null;
  }
  parseInterstitialDateRanges(mediaSelection, enableAppendInPlace) {
    const details = mediaSelection.main.details;
    const {
      dateRanges
    } = details;
    const previousInterstitialEvents = this.events;
    const interstitialEvents = this.parseDateRanges(dateRanges, {
      url: details.url
    }, enableAppendInPlace);
    const ids = Object.keys(dateRanges);
    const removedInterstitials = previousInterstitialEvents ? previousInterstitialEvents.filter(event => !ids.includes(event.identifier)) : [];
    if (interstitialEvents.length) {
      // pre-rolls, post-rolls, and events with the same start time are played in playlist tag order
      // all other events are ordered by start time
      interstitialEvents.sort((a, b) => {
        const aPre = a.cue.pre;
        const aPost = a.cue.post;
        const bPre = b.cue.pre;
        const bPost = b.cue.post;
        if (aPre && !bPre) {
          return -1;
        }
        if (bPre && !aPre) {
          return 1;
        }
        if (aPost && !bPost) {
          return 1;
        }
        if (bPost && !aPost) {
          return -1;
        }
        if (!aPre && !bPre && !aPost && !bPost) {
          const startA = a.startTime;
          const startB = b.startTime;
          if (startA !== startB) {
            return startA - startB;
          }
        }
        return a.dateRange.tagOrder - b.dateRange.tagOrder;
      });
    }
    this.events = interstitialEvents;

    // Clear removed DateRanges from buffered list (kills playback of active Interstitials)
    removedInterstitials.forEach(interstitial => {
      this.removeEvent(interstitial);
    });
    this.updateSchedule(mediaSelection, removedInterstitials);
  }
  updateSchedule(mediaSelection, removedInterstitials = []) {
    const events = this.events || [];
    if (events.length || removedInterstitials.length || this.length < 2) {
      const currentItems = this.items;
      const updatedItems = this.parseSchedule(events, mediaSelection);
      const updated = removedInterstitials.length || (currentItems == null ? void 0 : currentItems.length) !== updatedItems.length || updatedItems.some((item, i) => {
        return Math.abs(item.playout.start - currentItems[i].playout.start) > 0.005 || Math.abs(item.playout.end - currentItems[i].playout.end) > 0.005;
      });
      if (updated) {
        this.items = updatedItems;
        // call interstitials-controller onScheduleUpdated()
        this.onScheduleUpdate(removedInterstitials, currentItems);
      }
    }
  }
  parseDateRanges(dateRanges, baseData, enableAppendInPlace) {
    const interstitialEvents = [];
    const ids = Object.keys(dateRanges);
    for (let i = 0; i < ids.length; i++) {
      const id = ids[i];
      const dateRange = dateRanges[id];
      if (dateRange.isInterstitial) {
        let interstitial = this.eventMap[id];
        if (interstitial) {
          // Update InterstitialEvent already parsed and mapped
          // This retains already loaded duration and loaded asset list info
          interstitial.setDateRange(dateRange);
        } else {
          interstitial = new InterstitialEvent(dateRange, baseData);
          this.eventMap[id] = interstitial;
          if (enableAppendInPlace === false) {
            interstitial.appendInPlace = enableAppendInPlace;
          }
        }
        interstitialEvents.push(interstitial);
      }
    }
    return interstitialEvents;
  }
  parseSchedule(interstitialEvents, mediaSelection) {
    const schedule = [];
    const details = mediaSelection.main.details;
    const primaryDuration = details.live ? Infinity : details.edge;
    let playoutDuration = 0;

    // Filter events that have errored from the schedule (Primary fallback)
    interstitialEvents = interstitialEvents.filter(event => !event.error && !(event.cue.once && event.hasPlayed));
    if (interstitialEvents.length) {
      // Update Schedule
      this.resolveOffsets(interstitialEvents, mediaSelection);

      // Populate Schedule with Interstitial Event and Primary Segment Items
      let primaryPosition = 0;
      let integratedTime = 0;
      interstitialEvents.forEach((interstitial, i) => {
        const preroll = interstitial.cue.pre;
        const postroll = interstitial.cue.post;
        const previousEvent = interstitialEvents[i - 1] || null;
        const appendInPlace = interstitial.appendInPlace;
        const eventStart = postroll ? primaryDuration : interstitial.startOffset;
        const interstitialDuration = interstitial.duration;
        const timelineDuration = interstitial.timelineOccupancy === TimelineOccupancy.Range ? interstitialDuration : 0;
        const resumptionOffset = interstitial.resumptionOffset;
        const inSameStartTimeSequence = (previousEvent == null ? void 0 : previousEvent.startTime) === eventStart;
        const start = eventStart + interstitial.cumulativeDuration;
        let end = appendInPlace ? start + interstitialDuration : eventStart + resumptionOffset;
        if (preroll || !postroll && eventStart <= 0) {
          // preroll or in-progress midroll
          const integratedStart = integratedTime;
          integratedTime += timelineDuration;
          interstitial.timelineStart = start;
          const playoutStart = playoutDuration;
          playoutDuration += interstitialDuration;
          schedule.push({
            event: interstitial,
            start,
            end,
            playout: {
              start: playoutStart,
              end: playoutDuration
            },
            integrated: {
              start: integratedStart,
              end: integratedTime
            }
          });
        } else if (eventStart <= primaryDuration) {
          if (!inSameStartTimeSequence) {
            const segmentDuration = eventStart - primaryPosition;
            // Do not schedule a primary segment if interstitials are abutting by less than ABUTTING_THRESHOLD_SECONDS
            if (segmentDuration > ABUTTING_THRESHOLD_SECONDS) {
              // primary segment
              const timelineStart = primaryPosition;
              const _integratedStart = integratedTime;
              integratedTime += segmentDuration;
              const _playoutStart = playoutDuration;
              playoutDuration += segmentDuration;
              const primarySegment = {
                previousEvent: interstitialEvents[i - 1] || null,
                nextEvent: interstitial,
                start: timelineStart,
                end: timelineStart + segmentDuration,
                playout: {
                  start: _playoutStart,
                  end: playoutDuration
                },
                integrated: {
                  start: _integratedStart,
                  end: integratedTime
                }
              };
              schedule.push(primarySegment);
            } else if (segmentDuration > 0 && previousEvent) {
              // Add previous event `resumeTime` (based on duration or resumeOffset) so that it ends aligned with this one
              previousEvent.cumulativeDuration += segmentDuration;
              schedule[schedule.length - 1].end = eventStart;
            }
          }
          // midroll / postroll
          if (postroll) {
            end = start;
          }
          interstitial.timelineStart = start;
          const integratedStart = integratedTime;
          integratedTime += timelineDuration;
          const playoutStart = playoutDuration;
          playoutDuration += interstitialDuration;
          schedule.push({
            event: interstitial,
            start,
            end,
            playout: {
              start: playoutStart,
              end: playoutDuration
            },
            integrated: {
              start: integratedStart,
              end: integratedTime
            }
          });
        } else {
          // Interstitial starts after end of primary VOD - not included in schedule
          return;
        }
        const resumeTime = interstitial.resumeTime;
        if (postroll || resumeTime > primaryDuration) {
          primaryPosition = primaryDuration;
        } else {
          primaryPosition = resumeTime;
        }
      });
      if (primaryPosition < primaryDuration) {
        var _schedule;
        // last primary segment
        const timelineStart = primaryPosition;
        const integratedStart = integratedTime;
        const segmentDuration = primaryDuration - primaryPosition;
        integratedTime += segmentDuration;
        const playoutStart = playoutDuration;
        playoutDuration += segmentDuration;
        schedule.push({
          previousEvent: ((_schedule = schedule[schedule.length - 1]) == null ? void 0 : _schedule.event) || null,
          nextEvent: null,
          start: primaryPosition,
          end: timelineStart + segmentDuration,
          playout: {
            start: playoutStart,
            end: playoutDuration
          },
          integrated: {
            start: integratedStart,
            end: integratedTime
          }
        });
      }
      this.setDurations(primaryDuration, playoutDuration, integratedTime);
    } else {
      // no interstials - schedule is one primary segment
      const start = 0;
      schedule.push({
        previousEvent: null,
        nextEvent: null,
        start,
        end: primaryDuration,
        playout: {
          start,
          end: primaryDuration
        },
        integrated: {
          start,
          end: primaryDuration
        }
      });
      this.setDurations(primaryDuration, primaryDuration, primaryDuration);
    }
    return schedule;
  }
  setDurations(primary, playout, integrated) {
    this.durations = {
      primary,
      playout,
      integrated
    };
  }
  resolveOffsets(interstitialEvents, mediaSelection) {
    const details = mediaSelection.main.details;
    const primaryDuration = details.live ? Infinity : details.edge;

    // First resolve cumulative resumption offsets for Interstitials that start at the same DateTime
    let cumulativeDuration = 0;
    let lastScheduledStart = -1;
    interstitialEvents.forEach((interstitial, i) => {
      const preroll = interstitial.cue.pre;
      const postroll = interstitial.cue.post;
      const eventStart = preroll ? 0 : postroll ? primaryDuration : interstitial.startTime;
      this.updateAssetDurations(interstitial);

      // X-RESUME-OFFSET values of interstitials scheduled at the same time are cumulative
      const inSameStartTimeSequence = lastScheduledStart === eventStart;
      if (inSameStartTimeSequence) {
        interstitial.cumulativeDuration = cumulativeDuration;
      } else {
        cumulativeDuration = 0;
        lastScheduledStart = eventStart;
      }
      if (!postroll && interstitial.snapOptions.in) {
        // FIXME: Include audio playlist in snapping
        interstitial.resumeAnchor = findFragmentByPTS(null, details.fragments, interstitial.startOffset + interstitial.resumptionOffset, 0, 0) || undefined;
      }
      // Check if primary fragments align with resumption offset and disable appendInPlace if they do not
      if (interstitial.appendInPlace && !interstitial.appendInPlaceStarted) {
        const alignedSegmentStart = this.primaryCanResumeInPlaceAt(interstitial, mediaSelection);
        if (!alignedSegmentStart) {
          interstitial.appendInPlace = false;
        }
      }
      if (!interstitial.appendInPlace && i + 1 < interstitialEvents.length) {
        // abutting Interstitials must use the same MediaSource strategy, this applies to all whether or not they are back to back:
        const timeBetween = interstitialEvents[i + 1].startTime - interstitialEvents[i].resumeTime;
        if (timeBetween < ABUTTING_THRESHOLD_SECONDS) {
          interstitialEvents[i + 1].appendInPlace = false;
          if (interstitialEvents[i + 1].appendInPlace) {
            this.warn(`Could not change append strategy for abutting event ${interstitial}`);
          }
        }
      }
      // Update cumulativeDuration for next abutting interstitial with the same start date
      const resumeOffset = isFiniteNumber(interstitial.resumeOffset) ? interstitial.resumeOffset : interstitial.duration;
      cumulativeDuration += resumeOffset;
    });
  }
  primaryCanResumeInPlaceAt(interstitial, mediaSelection) {
    const resumeTime = interstitial.resumeTime;
    const resumesInPlaceAt = interstitial.startTime + interstitial.resumptionOffset;
    if (Math.abs(resumeTime - resumesInPlaceAt) > ALIGNED_END_THRESHOLD_SECONDS) {
      this.log(`"${interstitial.identifier}" resumption ${resumeTime} not aligned with estimated timeline end ${resumesInPlaceAt}`);
      return false;
    }
    if (!mediaSelection) {
      this.log(`"${interstitial.identifier}" resumption ${resumeTime} can not be aligned with media (none selected)`);
      return false;
    }
    const playlists = Object.keys(mediaSelection);
    return !playlists.some(playlistType => {
      const details = mediaSelection[playlistType].details;
      const playlistEnd = details.edge;
      if (resumeTime >= playlistEnd) {
        // Live playback - resumption segments are not yet available
        this.log(`"${interstitial.identifier}" resumption ${resumeTime} past ${playlistType} playlist end ${playlistEnd}`);
        // Assume alignment is possible (or reset can take place)
        return false;
      }
      const startFragment = findFragmentByPTS(null, details.fragments, resumeTime);
      if (!startFragment) {
        this.log(`"${interstitial.identifier}" resumption ${resumeTime} does not align with any fragments in ${playlistType} playlist (${details.fragStart}-${details.fragmentEnd})`);
        return true;
      }
      const allowance = playlistType === 'audio' ? 0.175 : 0;
      const alignedWithSegment = Math.abs(startFragment.start - resumeTime) < ALIGNED_END_THRESHOLD_SECONDS + allowance || Math.abs(startFragment.end - resumeTime) < ALIGNED_END_THRESHOLD_SECONDS + allowance;
      if (!alignedWithSegment) {
        this.log(`"${interstitial.identifier}" resumption ${resumeTime} not aligned with ${playlistType} fragment bounds (${startFragment.start}-${startFragment.end} sn: ${startFragment.sn} cc: ${startFragment.cc})`);
        return true;
      }
      return false;
    });
  }
  updateAssetDurations(interstitial) {
    if (!interstitial.assetListLoaded) {
      return;
    }
    const eventStart = interstitial.timelineStart;
    let sumDuration = 0;
    let hasUnknownDuration = false;
    let hasErrors = false;
    interstitial.assetList.forEach((asset, i) => {
      const timelineStart = eventStart + sumDuration;
      asset.startOffset = sumDuration;
      asset.timelineStart = timelineStart;
      hasUnknownDuration || (hasUnknownDuration = asset.duration === null);
      hasErrors || (hasErrors = !!asset.error);
      const duration = asset.error ? 0 : asset.duration || 0;
      sumDuration += duration;
    });
    // Use the sum of known durations when it is greater than the stated duration
    if (hasUnknownDuration && !hasErrors) {
      interstitial.duration = Math.max(sumDuration, interstitial.duration);
    } else {
      interstitial.duration = sumDuration;
    }
  }
  removeEvent(interstitial) {
    interstitial.reset();
    delete this.eventMap[interstitial.identifier];
  }
}
function segmentToString(segment) {
  return `[${segment.event ? '"' + segment.event.identifier + '"' : 'primary'}: ${segment.start.toFixed(2)}-${segment.end.toFixed(2)}]`;
}

class AssetListLoader {
  constructor(hls) {
    this.hls = void 0;
    this.hls = hls;
  }
  destroy() {
    // @ts-ignore
    this.hls = null;
  }
  loadAssetList(interstitial, hlsStartOffset) {
    const assetListUrl = interstitial.assetListUrl;
    let url;
    try {
      url = getInterstitialUrl(assetListUrl, this.hls.sessionId, interstitial.baseUrl);
    } catch (error) {
      const errorData = this.assignAssetListError(interstitial, ErrorDetails.ASSET_LIST_LOAD_ERROR, error, assetListUrl);
      this.hls.trigger(Events.ERROR, errorData);
      return;
    }
    if (hlsStartOffset && url.protocol !== 'data:') {
      url.searchParams.set('_HLS_start_offset', '' + hlsStartOffset);
    }
    const config = this.hls.config;
    const Loader = config.loader;
    const loader = new Loader(config);
    const context = {
      responseType: 'json',
      url: url.href
    };
    const loadPolicy = config.interstitialAssetListLoadPolicy.default;
    const loaderConfig = {
      loadPolicy,
      timeout: loadPolicy.maxLoadTimeMs,
      maxRetry: 0,
      retryDelay: 0,
      maxRetryDelay: 0
    };
    const callbacks = {
      onSuccess: (response, stats, context, networkDetails) => {
        const assetListResponse = response.data;
        const assets = assetListResponse == null ? void 0 : assetListResponse.ASSETS;
        if (!Array.isArray(assets)) {
          const errorData = this.assignAssetListError(interstitial, ErrorDetails.ASSET_LIST_PARSING_ERROR, new Error(`Invalid interstitial asset list`), context.url, stats, networkDetails);
          this.hls.trigger(Events.ERROR, errorData);
          return;
        }
        interstitial.assetListResponse = assetListResponse;
        this.hls.trigger(Events.ASSET_LIST_LOADED, {
          event: interstitial,
          assetListResponse,
          networkDetails
        });
      },
      onError: (error, context, networkDetails, stats) => {
        const errorData = this.assignAssetListError(interstitial, ErrorDetails.ASSET_LIST_LOAD_ERROR, new Error(`Error loading X-ASSET-LIST: HTTP status ${error.code} ${error.text} (${context.url})`), context.url, stats, networkDetails);
        this.hls.trigger(Events.ERROR, errorData);
      },
      onTimeout: (stats, context, networkDetails) => {
        const errorData = this.assignAssetListError(interstitial, ErrorDetails.ASSET_LIST_LOAD_TIMEOUT, new Error(`Timeout loading X-ASSET-LIST (${context.url})`), context.url, stats, networkDetails);
        this.hls.trigger(Events.ERROR, errorData);
      }
    };
    loader.load(context, loaderConfig, callbacks);
    this.hls.trigger(Events.ASSET_LIST_LOADING, {
      event: interstitial
    });
    return loader;
  }
  assignAssetListError(interstitial, details, error, url, stats, networkDetails) {
    interstitial.error = error;
    return {
      type: ErrorTypes.NETWORK_ERROR,
      details,
      fatal: false,
      interstitial,
      url,
      error,
      networkDetails,
      stats
    };
  }
}

function playWithCatch(media) {
  media == null ? void 0 : media.play().catch(() => {
    /* no-op */
  });
}
class InterstitialsController extends hls_Logger {
  constructor(hls, HlsPlayerClass) {
    super('interstitials', hls.logger);
    this.HlsPlayerClass = void 0;
    this.hls = void 0;
    this.assetListLoader = void 0;
    // Last updated LevelDetails
    this.mediaSelection = null;
    this.altSelection = null;
    // Media and MediaSource/SourceBuffers
    this.media = null;
    this.detachedData = null;
    this.requiredTracks = null;
    // Public Interface for Interstitial playback state and control
    this.manager = null;
    // Interstitial Asset Players
    this.playerQueue = [];
    // Timeline position tracking
    this.bufferedPos = -1;
    this.timelinePos = -1;
    // Schedule
    this.schedule = void 0;
    // Schedule playback and buffering state
    this.playingItem = null;
    this.bufferingItem = null;
    this.waitingItem = null;
    this.endedItem = null;
    this.playingAsset = null;
    this.endedAsset = null;
    this.bufferingAsset = null;
    this.shouldPlay = false;
    this.onPlay = () => {
      this.shouldPlay = true;
    };
    this.onPause = () => {
      this.shouldPlay = false;
    };
    this.onSeeking = () => {
      const currentTime = this.currentTime;
      if (currentTime === undefined || this.playbackDisabled) {
        return;
      }
      const diff = currentTime - this.timelinePos;
      const roundingError = Math.abs(diff) < 1 / 705600000; // one flick
      if (roundingError) {
        return;
      }
      const backwardSeek = diff <= -0.01;
      this.timelinePos = currentTime;
      this.bufferedPos = currentTime;

      // Check if seeking out of an item
      const playingItem = this.playingItem;
      if (!playingItem) {
        this.checkBuffer();
        return;
      }
      if (backwardSeek) {
        const resetCount = this.schedule.resetErrorsInRange(currentTime, currentTime - diff);
        if (resetCount) {
          this.updateSchedule();
        }
      }
      this.checkBuffer();
      if (backwardSeek && currentTime < playingItem.start || currentTime >= playingItem.end) {
        var _this$media;
        const scheduleIndex = this.schedule.findItemIndexAtTime(this.timelinePos);
        if (!this.isInterstitial(playingItem) && (_this$media = this.media) != null && _this$media.paused) {
          this.shouldPlay = false;
        }
        if (!backwardSeek) {
          // check if an Interstitial between the current item and target item has an X-RESTRICT JUMP restriction
          const playingIndex = this.findItemIndex(playingItem);
          if (scheduleIndex > playingIndex) {
            const jumpIndex = this.schedule.findJumpRestrictedIndex(playingIndex + 1, scheduleIndex);
            if (jumpIndex > playingIndex) {
              this.setSchedulePosition(jumpIndex);
              return;
            }
          }
        }
        this.setSchedulePosition(scheduleIndex);
        return;
      }
      // Check if seeking out of an asset (assumes same item following above check)
      const playingAsset = this.playingAsset;
      if (!playingAsset) {
        // restart Interstitial at end
        if (this.playingLastItem && this.isInterstitial(playingItem)) {
          const restartAsset = playingItem.event.assetList[0];
          if (restartAsset) {
            this.endedItem = this.playingItem;
            this.playingItem = null;
            this.setScheduleToAssetAtTime(currentTime, restartAsset);
          }
        }
        return;
      }
      const start = playingAsset.timelineStart;
      const duration = playingAsset.duration || 0;
      if (backwardSeek && currentTime < start || currentTime >= start + duration) {
        this.setScheduleToAssetAtTime(currentTime, playingAsset);
      }
    };
    this.onTimeupdate = () => {
      const currentTime = this.currentTime;
      if (currentTime === undefined || this.playbackDisabled) {
        return;
      }

      // Only allow timeupdate to advance primary position, seeking is used for jumping back
      // this prevents primaryPos from being reset to 0 after re-attach
      if (currentTime > this.timelinePos) {
        this.timelinePos = currentTime;
        if (currentTime > this.bufferedPos) {
          this.checkBuffer();
        }
      } else {
        return;
      }

      // Check if playback has entered the next item
      const playingItem = this.playingItem;
      if (!playingItem || this.playingLastItem) {
        return;
      }
      if (currentTime >= playingItem.end) {
        this.timelinePos = playingItem.end;
        const playingIndex = this.findItemIndex(playingItem);
        this.setSchedulePosition(playingIndex + 1);
      }
      // Check if playback has entered the next asset
      const playingAsset = this.playingAsset;
      if (!playingAsset) {
        return;
      }
      const end = playingAsset.timelineStart + (playingAsset.duration || 0);
      if (currentTime >= end) {
        this.setScheduleToAssetAtTime(currentTime, playingAsset);
      }
    };
    // Schedule update callback
    this.onScheduleUpdate = (removedInterstitials, previousItems) => {
      const schedule = this.schedule;
      const playingItem = this.playingItem;
      const interstitialEvents = schedule.events || [];
      const scheduleItems = schedule.items || [];
      const durations = schedule.durations;
      const removedIds = removedInterstitials.map(interstitial => interstitial.identifier);
      const interstitialsUpdated = !!(interstitialEvents.length || removedIds.length);
      if (interstitialsUpdated || previousItems) {
        this.log(`INTERSTITIALS_UPDATED (${interstitialEvents.length}): ${interstitialEvents}
Schedule: ${scheduleItems.map(seg => segmentToString(seg))} pos: ${this.timelinePos}`);
      }
      if (removedIds.length) {
        this.log(`Removed events ${removedIds}`);
      }
      this.playerQueue.forEach(player => {
        if (player.interstitial.appendInPlace) {
          const timelineStart = player.assetItem.timelineStart;
          const diff = player.timelineOffset - timelineStart;
          if (diff) {
            try {
              player.timelineOffset = timelineStart;
            } catch (e) {
              if (Math.abs(diff) > ALIGNED_END_THRESHOLD_SECONDS) {
                this.warn(`${e} ("${player.assetId}" ${player.timelineOffset}->${timelineStart})`);
              }
            }
          }
        }
      });

      // Update schedule item references
      // Do not replace Interstitial playingItem without a match - used for INTERSTITIAL_ASSET_ENDED and INTERSTITIAL_ENDED
      let trimInPlaceForPlayout = null;
      if (playingItem) {
        const updatedPlayingItem = this.updateItem(playingItem, this.timelinePos);
        if (this.itemsMatch(playingItem, updatedPlayingItem)) {
          this.playingItem = updatedPlayingItem;
          this.waitingItem = this.endedItem = null;
          trimInPlaceForPlayout = () => this.trimInPlace(updatedPlayingItem, playingItem);
        }
      } else {
        // Clear waitingItem if it has been removed from the schedule
        this.waitingItem = this.updateItem(this.waitingItem);
        this.endedItem = this.updateItem(this.endedItem);
      }
      // Do not replace Interstitial bufferingItem without a match - used for transfering media element or source
      const bufferingItem = this.bufferingItem;
      if (bufferingItem) {
        const updatedBufferingItem = this.updateItem(bufferingItem, this.bufferedPos);
        if (this.itemsMatch(bufferingItem, updatedBufferingItem)) {
          this.bufferingItem = updatedBufferingItem;
          trimInPlaceForPlayout || (trimInPlaceForPlayout = () => this.trimInPlace(updatedBufferingItem, bufferingItem));
        } else if (bufferingItem.event) {
          // Interstitial removed from schedule (Live -> VOD or other scenario where Start Date is outside the range of VOD Playlist)
          this.bufferingItem = this.playingItem;
          this.clearInterstitial(bufferingItem.event, null);
        }
      }
      removedInterstitials.forEach(interstitial => {
        interstitial.assetList.forEach(asset => {
          this.clearAssetPlayer(asset.identifier, null);
        });
      });
      if (interstitialsUpdated || previousItems) {
        this.hls.trigger(Events.INTERSTITIALS_UPDATED, {
          events: interstitialEvents.slice(0),
          schedule: scheduleItems.slice(0),
          durations,
          removedIds
        });
        if (this.isInterstitial(playingItem) && removedIds.includes(playingItem.event.identifier)) {
          this.warn(`Interstitial "${playingItem.event.identifier}" removed while playing`);
          this.primaryFallback(playingItem.event);
          return;
        }
        if (trimInPlaceForPlayout) {
          trimInPlaceForPlayout();
        }

        // Check is buffered to new Interstitial event boundary
        // (Live update publishes Interstitial with new segment)
        this.checkBuffer();
      }
    };
    this.hls = hls;
    this.HlsPlayerClass = HlsPlayerClass;
    this.assetListLoader = new AssetListLoader(hls);
    this.schedule = new InterstitialsSchedule(this.onScheduleUpdate, hls.logger);
    this.registerListeners();
  }
  registerListeners() {
    const hls = this.hls;
    hls.on(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
    hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
    hls.on(Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
    hls.on(Events.AUDIO_TRACK_UPDATED, this.onAudioTrackUpdated, this);
    hls.on(Events.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this);
    hls.on(Events.SUBTITLE_TRACK_UPDATED, this.onSubtitleTrackUpdated, this);
    hls.on(Events.EVENT_CUE_ENTER, this.onInterstitialCueEnter, this);
    hls.on(Events.ASSET_LIST_LOADED, this.onAssetListLoaded, this);
    hls.on(Events.BUFFER_APPENDED, this.onBufferAppended, this);
    hls.on(Events.BUFFER_FLUSHED, this.onBufferFlushed, this);
    hls.on(Events.BUFFERED_TO_END, this.onBufferedToEnd, this);
    hls.on(Events.MEDIA_ENDED, this.onMediaEnded, this);
    hls.on(Events.ERROR, this.onError, this);
    hls.on(Events.DESTROYING, this.onDestroying, this);
  }
  unregisterListeners() {
    const hls = this.hls;
    if (!hls) {
      return;
    }
    hls.off(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
    hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
    hls.off(Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
    hls.off(Events.AUDIO_TRACK_UPDATED, this.onAudioTrackUpdated, this);
    hls.off(Events.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this);
    hls.off(Events.SUBTITLE_TRACK_UPDATED, this.onSubtitleTrackUpdated, this);
    hls.off(Events.EVENT_CUE_ENTER, this.onInterstitialCueEnter, this);
    hls.off(Events.ASSET_LIST_LOADED, this.onAssetListLoaded, this);
    hls.off(Events.BUFFER_CODECS, this.onBufferCodecs, this);
    hls.off(Events.BUFFER_APPENDED, this.onBufferAppended, this);
    hls.off(Events.BUFFER_FLUSHED, this.onBufferFlushed, this);
    hls.off(Events.BUFFERED_TO_END, this.onBufferedToEnd, this);
    hls.off(Events.MEDIA_ENDED, this.onMediaEnded, this);
    hls.off(Events.ERROR, this.onError, this);
    hls.off(Events.DESTROYING, this.onDestroying, this);
  }
  startLoad() {
    // TODO: startLoad - check for waitingItem and retry by resetting schedule
    this.resumeBuffering();
  }
  stopLoad() {
    // TODO: stopLoad - stop all scheule.events[].assetListLoader?.abort() then delete the loaders
    this.pauseBuffering();
  }
  resumeBuffering() {
    var _this$getBufferingPla;
    (_this$getBufferingPla = this.getBufferingPlayer()) == null ? void 0 : _this$getBufferingPla.resumeBuffering();
  }
  pauseBuffering() {
    var _this$getBufferingPla2;
    (_this$getBufferingPla2 = this.getBufferingPlayer()) == null ? void 0 : _this$getBufferingPla2.pauseBuffering();
  }
  destroy() {
    this.unregisterListeners();
    this.stopLoad();
    if (this.assetListLoader) {
      this.assetListLoader.destroy();
    }
    this.emptyPlayerQueue();
    this.clearScheduleState();
    if (this.schedule) {
      this.schedule.destroy();
    }
    this.media = this.detachedData = this.mediaSelection = this.requiredTracks = this.altSelection = this.manager = null;
    // @ts-ignore
    this.hls = this.HlsPlayerClass = this.schedule = this.log = null;
    // @ts-ignore
    this.assetListLoader = null;
    // @ts-ignore
    this.onPlay = this.onPause = this.onSeeking = this.onTimeupdate = null;
    // @ts-ignore
    this.onScheduleUpdate = null;
  }
  onDestroying() {
    const media = this.primaryMedia || this.media;
    if (media) {
      this.removeMediaListeners(media);
    }
  }
  removeMediaListeners(media) {
    removeEventListener(media, 'play', this.onPlay);
    removeEventListener(media, 'pause', this.onPause);
    removeEventListener(media, 'seeking', this.onSeeking);
    removeEventListener(media, 'timeupdate', this.onTimeupdate);
  }
  onMediaAttaching(event, data) {
    const media = this.media = data.media;
    addEventListener(media, 'seeking', this.onSeeking);
    addEventListener(media, 'timeupdate', this.onTimeupdate);
    addEventListener(media, 'play', this.onPlay);
    addEventListener(media, 'pause', this.onPause);
  }
  onMediaAttached(event, data) {
    const playingItem = this.effectivePlayingItem;
    const detachedMedia = this.detachedData;
    this.detachedData = null;
    if (playingItem === null) {
      this.checkStart();
    } else if (!detachedMedia) {
      // Resume schedule after detached externally
      this.clearScheduleState();
      const playingIndex = this.findItemIndex(playingItem);
      this.setSchedulePosition(playingIndex);
    }
  }
  clearScheduleState() {
    this.playingItem = this.bufferingItem = this.waitingItem = this.endedItem = this.playingAsset = this.endedAsset = this.bufferingAsset = null;
  }
  onMediaDetaching(event, data) {
    const transferringMedia = !!data.transferMedia;
    const media = this.media;
    this.media = null;
    if (transferringMedia) {
      return;
    }
    if (media) {
      this.removeMediaListeners(media);
    }
    // If detachMedia is called while in an Interstitial, detach the asset player as well and reset the schedule position
    if (this.detachedData) {
      const player = this.getBufferingPlayer();
      if (player) {
        this.playingAsset = this.endedAsset = this.bufferingAsset = this.bufferingItem = this.waitingItem = this.detachedData = null;
        player.detachMedia();
      }
      this.shouldPlay = false;
    }
  }
  get interstitialsManager() {
    if (!this.manager) {
      if (!this.hls) {
        return null;
      }
      const c = this;
      const effectiveBufferingItem = () => c.bufferingItem || c.waitingItem;
      const getAssetPlayer = asset => asset ? c.getAssetPlayer(asset.identifier) : asset;
      const getMappedTime = (item, timelineType, asset, controllerField, assetPlayerField) => {
        if (item) {
          let time = item[timelineType].start;
          const interstitial = item.event;
          if (interstitial) {
            if (timelineType === 'playout' || interstitial.timelineOccupancy !== TimelineOccupancy.Point) {
              const assetPlayer = getAssetPlayer(asset);
              if ((assetPlayer == null ? void 0 : assetPlayer.interstitial) === interstitial) {
                time += assetPlayer.assetItem.startOffset + assetPlayer[assetPlayerField];
              }
            }
          } else {
            const value = controllerField === 'bufferedPos' ? getBufferedEnd() : c[controllerField];
            time += value - item.start;
          }
          return time;
        }
        return 0;
      };
      const findMappedTime = (primaryTime, timelineType) => {
        if (primaryTime !== 0 && timelineType !== 'primary' && c.schedule.length) {
          var _c$schedule$items;
          const index = c.schedule.findItemIndexAtTime(primaryTime);
          const item = (_c$schedule$items = c.schedule.items) == null ? void 0 : _c$schedule$items[index];
          if (item) {
            const diff = item[timelineType].start - item.start;
            return primaryTime + diff;
          }
        }
        return primaryTime;
      };
      const getBufferedEnd = () => {
        const value = c.bufferedPos;
        if (value === Number.MAX_VALUE) {
          return getMappedDuration('primary');
        }
        return Math.max(value, 0);
      };
      const getMappedDuration = timelineType => {
        var _c$primaryDetails;
        if ((_c$primaryDetails = c.primaryDetails) != null && _c$primaryDetails.live) {
          // return end of last event item or playlist
          return c.primaryDetails.edge;
        }
        return c.schedule.durations[timelineType];
      };
      const seekTo = (time, timelineType) => {
        var _item$event, _c$schedule$items2;
        const item = c.effectivePlayingItem;
        if (item != null && (_item$event = item.event) != null && _item$event.restrictions.skip) {
          return;
        }
        c.log(`seek to ${time} "${timelineType}"`);
        const playingItem = c.effectivePlayingItem;
        const targetIndex = c.schedule.findItemIndexAtTime(time, timelineType);
        const targetItem = (_c$schedule$items2 = c.schedule.items) == null ? void 0 : _c$schedule$items2[targetIndex];
        const bufferingPlayer = c.getBufferingPlayer();
        const bufferingInterstitial = bufferingPlayer == null ? void 0 : bufferingPlayer.interstitial;
        const appendInPlace = bufferingInterstitial == null ? void 0 : bufferingInterstitial.appendInPlace;
        const seekInItem = playingItem && c.itemsMatch(playingItem, targetItem);
        if (playingItem && (appendInPlace || seekInItem)) {
          // seek in asset player or primary media (appendInPlace)
          const assetPlayer = getAssetPlayer(c.playingAsset);
          const media = (assetPlayer == null ? void 0 : assetPlayer.media) || c.primaryMedia;
          if (media) {
            const currentTime = timelineType === 'primary' ? media.currentTime : getMappedTime(playingItem, timelineType, c.playingAsset, 'timelinePos', 'currentTime');
            const diff = time - currentTime;
            const seekToTime = (appendInPlace ? currentTime : media.currentTime) + diff;
            if (seekToTime >= 0 && (!assetPlayer || appendInPlace || seekToTime <= assetPlayer.duration)) {
              media.currentTime = seekToTime;
              return;
            }
          }
        }
        // seek out of item or asset
        if (targetItem) {
          let seekToTime = time;
          if (timelineType !== 'primary') {
            const primarySegmentStart = targetItem[timelineType].start;
            const diff = time - primarySegmentStart;
            seekToTime = targetItem.start + diff;
          }
          const targetIsPrimary = !c.isInterstitial(targetItem);
          if ((!c.isInterstitial(playingItem) || playingItem.event.appendInPlace) && (targetIsPrimary || targetItem.event.appendInPlace)) {
            const media = c.media || (appendInPlace ? bufferingPlayer == null ? void 0 : bufferingPlayer.media : null);
            if (media) {
              media.currentTime = seekToTime;
            }
          } else if (playingItem) {
            // check if an Interstitial between the current item and target item has an X-RESTRICT JUMP restriction
            const playingIndex = c.findItemIndex(playingItem);
            if (targetIndex > playingIndex) {
              const jumpIndex = c.schedule.findJumpRestrictedIndex(playingIndex + 1, targetIndex);
              if (jumpIndex > playingIndex) {
                c.setSchedulePosition(jumpIndex);
                return;
              }
            }
            let assetIndex = 0;
            if (targetIsPrimary) {
              c.timelinePos = seekToTime;
              c.checkBuffer();
            } else {
              var _targetItem$event;
              const assetList = targetItem == null ? void 0 : (_targetItem$event = targetItem.event) == null ? void 0 : _targetItem$event.assetList;
              if (assetList) {
                const eventTime = time - (targetItem[timelineType] || targetItem).start;
                for (let i = assetList.length; i--;) {
                  const asset = assetList[i];
                  if (asset.duration && eventTime >= asset.startOffset && eventTime < asset.startOffset + asset.duration) {
                    assetIndex = i;
                    break;
                  }
                }
              }
            }
            c.setSchedulePosition(targetIndex, assetIndex);
          }
        }
      };
      const getActiveInterstitial = () => {
        const playingItem = c.effectivePlayingItem;
        if (c.isInterstitial(playingItem)) {
          return playingItem;
        }
        const bufferingItem = effectiveBufferingItem();
        if (c.isInterstitial(bufferingItem)) {
          return bufferingItem;
        }
        return null;
      };
      const interstitialPlayer = {
        get currentTime() {
          const interstitialItem = getActiveInterstitial();
          const playingItem = c.effectivePlayingItem;
          if (playingItem && playingItem === interstitialItem) {
            return getMappedTime(playingItem, 'playout', c.effectivePlayingAsset, 'timelinePos', 'currentTime') - playingItem.playout.start;
          }
          return 0;
        },
        set currentTime(time) {
          const interstitialItem = getActiveInterstitial();
          const playingItem = c.effectivePlayingItem;
          if (playingItem && playingItem === interstitialItem) {
            seekTo(time + playingItem.playout.start, 'playout');
          }
        },
        get duration() {
          const interstitialItem = getActiveInterstitial();
          if (interstitialItem) {
            return interstitialItem.playout.end - interstitialItem.playout.start;
          }
          return 0;
        },
        get assetPlayers() {
          var _getActiveInterstitia;
          const assetList = (_getActiveInterstitia = getActiveInterstitial()) == null ? void 0 : _getActiveInterstitia.event.assetList;
          if (assetList) {
            return assetList.map(asset => c.getAssetPlayer(asset.identifier));
          }
          return [];
        },
        get playingIndex() {
          var _getActiveInterstitia2;
          const interstitial = (_getActiveInterstitia2 = getActiveInterstitial()) == null ? void 0 : _getActiveInterstitia2.event;
          if (interstitial && c.effectivePlayingAsset) {
            return interstitial.findAssetIndex(c.effectivePlayingAsset);
          }
          return -1;
        },
        get scheduleItem() {
          return getActiveInterstitial();
        }
      };
      this.manager = {
        get events() {
          var _c$schedule, _c$schedule$events;
          return ((_c$schedule = c.schedule) == null ? void 0 : (_c$schedule$events = _c$schedule.events) == null ? void 0 : _c$schedule$events.slice(0)) || [];
        },
        get schedule() {
          var _c$schedule2, _c$schedule2$items;
          return ((_c$schedule2 = c.schedule) == null ? void 0 : (_c$schedule2$items = _c$schedule2.items) == null ? void 0 : _c$schedule2$items.slice(0)) || [];
        },
        get interstitialPlayer() {
          if (getActiveInterstitial()) {
            return interstitialPlayer;
          }
          return null;
        },
        get playerQueue() {
          return c.playerQueue.slice(0);
        },
        get bufferingAsset() {
          return c.bufferingAsset;
        },
        get bufferingItem() {
          return effectiveBufferingItem();
        },
        get bufferingIndex() {
          const item = effectiveBufferingItem();
          return c.findItemIndex(item);
        },
        get playingAsset() {
          return c.effectivePlayingAsset;
        },
        get playingItem() {
          return c.effectivePlayingItem;
        },
        get playingIndex() {
          const item = c.effectivePlayingItem;
          return c.findItemIndex(item);
        },
        primary: {
          get bufferedEnd() {
            return getBufferedEnd();
          },
          get currentTime() {
            const timelinePos = c.timelinePos;
            return timelinePos > 0 ? timelinePos : 0;
          },
          set currentTime(time) {
            seekTo(time, 'primary');
          },
          get duration() {
            return getMappedDuration('primary');
          },
          get seekableStart() {
            var _c$primaryDetails2;
            return ((_c$primaryDetails2 = c.primaryDetails) == null ? void 0 : _c$primaryDetails2.fragmentStart) || 0;
          }
        },
        integrated: {
          get bufferedEnd() {
            return getMappedTime(effectiveBufferingItem(), 'integrated', c.bufferingAsset, 'bufferedPos', 'bufferedEnd');
          },
          get currentTime() {
            return getMappedTime(c.effectivePlayingItem, 'integrated', c.effectivePlayingAsset, 'timelinePos', 'currentTime');
          },
          set currentTime(time) {
            seekTo(time, 'integrated');
          },
          get duration() {
            return getMappedDuration('integrated');
          },
          get seekableStart() {
            var _c$primaryDetails3;
            return findMappedTime(((_c$primaryDetails3 = c.primaryDetails) == null ? void 0 : _c$primaryDetails3.fragmentStart) || 0, 'integrated');
          }
        },
        skip: () => {
          const item = c.effectivePlayingItem;
          const event = item == null ? void 0 : item.event;
          if (event && !event.restrictions.skip) {
            const index = c.findItemIndex(item);
            if (event.appendInPlace) {
              const time = item.playout.start + item.event.duration;
              seekTo(time + 0.001, 'playout');
            } else {
              c.advanceAfterAssetEnded(event, index, Infinity);
            }
          }
        }
      };
    }
    return this.manager;
  }

  // Schedule getters
  get effectivePlayingItem() {
    return this.waitingItem || this.playingItem || this.endedItem;
  }
  get effectivePlayingAsset() {
    return this.playingAsset || this.endedAsset;
  }
  get playingLastItem() {
    var _this$schedule;
    const playingItem = this.playingItem;
    const items = (_this$schedule = this.schedule) == null ? void 0 : _this$schedule.items;
    if (!this.playbackStarted || !playingItem || !items) {
      return false;
    }
    return this.findItemIndex(playingItem) === items.length - 1;
  }
  get playbackStarted() {
    return this.effectivePlayingItem !== null;
  }

  // Media getters and event callbacks
  get currentTime() {
    var _this$bufferingItem, _this$bufferingItem$e, _media;
    if (this.mediaSelection === null) {
      // Do not advance before schedule is known
      return undefined;
    }
    // Ignore currentTime when detached for Interstitial playback with source reset
    const queuedForPlayback = this.waitingItem || this.playingItem;
    if (this.isInterstitial(queuedForPlayback) && !queuedForPlayback.event.appendInPlace) {
      return undefined;
    }
    let media = this.media;
    if (!media && (_this$bufferingItem = this.bufferingItem) != null && (_this$bufferingItem$e = _this$bufferingItem.event) != null && _this$bufferingItem$e.appendInPlace) {
      // Observe detached media currentTime when appending in place
      media = this.primaryMedia;
    }
    const currentTime = (_media = media) == null ? void 0 : _media.currentTime;
    if (currentTime === undefined || !isFiniteNumber(currentTime)) {
      return undefined;
    }
    return currentTime;
  }
  get primaryMedia() {
    var _this$detachedData;
    return this.media || ((_this$detachedData = this.detachedData) == null ? void 0 : _this$detachedData.media) || null;
  }
  isInterstitial(item) {
    return !!(item != null && item.event);
  }
  retreiveMediaSource(assetId, toSegment) {
    const player = this.getAssetPlayer(assetId);
    if (player) {
      this.transferMediaFromPlayer(player, toSegment);
    }
  }
  transferMediaFromPlayer(player, toSegment) {
    const appendInPlace = player.interstitial.appendInPlace;
    const playerMedia = player.media;
    if (appendInPlace && playerMedia === this.primaryMedia) {
      this.bufferingAsset = null;
      if (!toSegment || this.isInterstitial(toSegment) && !toSegment.event.appendInPlace) {
        // MediaSource cannot be transfered back to an Interstitial that requires a source reset
        // no-op when toSegment is undefined
        if (toSegment && playerMedia) {
          this.detachedData = {
            media: playerMedia
          };
          return;
        }
      }
      const attachMediaSourceData = player.transferMedia();
      this.log(`transfer MediaSource from ${player} ${hls_stringify(attachMediaSourceData)}`);
      this.detachedData = attachMediaSourceData;
    } else if (toSegment && playerMedia) {
      this.shouldPlay || (this.shouldPlay = !playerMedia.paused);
    }
  }
  transferMediaTo(player, media) {
    var _this$detachedData2, _attachMediaSourceDat;
    if (player.media === media) {
      return;
    }
    let attachMediaSourceData = null;
    const primaryPlayer = this.hls;
    const isAssetPlayer = player !== primaryPlayer;
    const appendInPlace = isAssetPlayer && player.interstitial.appendInPlace;
    const detachedMediaSource = (_this$detachedData2 = this.detachedData) == null ? void 0 : _this$detachedData2.mediaSource;
    let logFromSource;
    if (primaryPlayer.media) {
      if (appendInPlace) {
        attachMediaSourceData = primaryPlayer.transferMedia();
        this.detachedData = attachMediaSourceData;
      }
      logFromSource = `Primary`;
    } else if (detachedMediaSource) {
      const bufferingPlayer = this.getBufferingPlayer();
      if (bufferingPlayer) {
        attachMediaSourceData = bufferingPlayer.transferMedia();
        logFromSource = `${bufferingPlayer}`;
      } else {
        logFromSource = `detached MediaSource`;
      }
    } else {
      logFromSource = `detached media`;
    }
    if (!attachMediaSourceData) {
      if (detachedMediaSource) {
        attachMediaSourceData = this.detachedData;
        this.log(`using detachedData: MediaSource ${hls_stringify(attachMediaSourceData)}`);
      } else if (!this.detachedData || primaryPlayer.media === media) {
        // Keep interstitial media transition consistent
        const playerQueue = this.playerQueue;
        if (playerQueue.length > 1) {
          playerQueue.forEach(queuedPlayer => {
            if (isAssetPlayer && queuedPlayer.interstitial.appendInPlace !== appendInPlace) {
              const interstitial = queuedPlayer.interstitial;
              this.clearInterstitial(queuedPlayer.interstitial, null);
              interstitial.appendInPlace = false;
              if (interstitial.appendInPlace) {
                this.warn(`Could not change append strategy for queued assets ${interstitial}`);
              }
            }
          });
        }
        this.hls.detachMedia();
        this.detachedData = {
          media
        };
      }
    }
    const transferring = attachMediaSourceData && 'mediaSource' in attachMediaSourceData && ((_attachMediaSourceDat = attachMediaSourceData.mediaSource) == null ? void 0 : _attachMediaSourceDat.readyState) !== 'closed';
    const dataToAttach = transferring && attachMediaSourceData ? attachMediaSourceData : media;
    this.log(`${transferring ? 'transfering MediaSource' : 'attaching media'} to ${isAssetPlayer ? player : 'Primary'} from ${logFromSource}`);
    if (dataToAttach === attachMediaSourceData) {
      const isAssetAtEndOfSchedule = isAssetPlayer && player.assetId === this.schedule.assetIdAtEnd;
      // Prevent asset players from marking EoS on transferred MediaSource
      dataToAttach.overrides = {
        duration: this.schedule.duration,
        endOfStream: !isAssetPlayer || isAssetAtEndOfSchedule,
        cueRemoval: !isAssetPlayer
      };
    }
    player.attachMedia(dataToAttach);
  }
  onInterstitialCueEnter() {
    this.onTimeupdate();
  }
  // Scheduling methods
  checkStart() {
    const schedule = this.schedule;
    const interstitialEvents = schedule.events;
    if (!interstitialEvents || this.playbackDisabled || !this.media) {
      return;
    }
    // Check buffered to pre-roll
    if (this.bufferedPos === -1) {
      this.bufferedPos = 0;
    }
    // Start stepping through schedule when playback begins for the first time and we have a pre-roll
    const timelinePos = this.timelinePos;
    const effectivePlayingItem = this.effectivePlayingItem;
    if (timelinePos === -1) {
      const startPosition = this.hls.startPosition;
      this.timelinePos = startPosition;
      if (interstitialEvents.length && interstitialEvents[0].cue.pre) {
        const index = schedule.findEventIndex(interstitialEvents[0].identifier);
        this.setSchedulePosition(index);
      } else if (startPosition >= 0 || !this.primaryLive) {
        const start = this.timelinePos = startPosition > 0 ? startPosition : 0;
        const index = schedule.findItemIndexAtTime(start);
        this.setSchedulePosition(index);
      }
    } else if (effectivePlayingItem && !this.playingItem) {
      const index = schedule.findItemIndex(effectivePlayingItem);
      this.setSchedulePosition(index);
    }
  }
  advanceAfterAssetEnded(interstitial, index, assetListIndex) {
    const nextAssetIndex = getNextAssetIndex(interstitial, assetListIndex);
    if (!interstitial.isAssetPastPlayoutLimit(nextAssetIndex)) {
      // Advance to next asset list item
      this.setSchedulePosition(index, nextAssetIndex);
    } else {
      // Advance to next schedule segment
      // check if we've reached the end of the program
      const scheduleItems = this.schedule.items;
      if (scheduleItems) {
        const nextIndex = index + 1;
        const scheduleLength = scheduleItems.length;
        if (nextIndex >= scheduleLength) {
          this.setSchedulePosition(-1);
          return;
        }
        const resumptionTime = interstitial.resumeTime;
        if (this.timelinePos < resumptionTime) {
          this.timelinePos = resumptionTime;
          this.checkBuffer();
        }
        this.setSchedulePosition(nextIndex);
      }
    }
  }
  setScheduleToAssetAtTime(time, playingAsset) {
    const schedule = this.schedule;
    const parentIdentifier = playingAsset.parentIdentifier;
    const interstitial = schedule.getEvent(parentIdentifier);
    if (interstitial) {
      const itemIndex = schedule.findEventIndex(parentIdentifier);
      const assetListIndex = schedule.findAssetIndex(interstitial, time);
      this.advanceAfterAssetEnded(interstitial, itemIndex, assetListIndex - 1);
    }
  }
  setSchedulePosition(index, assetListIndex) {
    const scheduleItems = this.schedule.items;
    if (!scheduleItems || this.playbackDisabled) {
      return;
    }
    this.log(`setSchedulePosition ${index}, ${assetListIndex}`);
    const scheduledItem = index >= 0 ? scheduleItems[index] : null;
    // Cleanup current item / asset
    const currentItem = this.playingItem;
    const playingLastItem = this.playingLastItem;
    if (this.isInterstitial(currentItem)) {
      var _interstitial$assetLi;
      const interstitial = currentItem.event;
      const playingAsset = this.playingAsset;
      const assetId = playingAsset == null ? void 0 : playingAsset.identifier;
      const player = assetId ? this.getAssetPlayer(assetId) : null;
      if (player && assetId && (!this.eventItemsMatch(currentItem, scheduledItem) || assetListIndex !== undefined && assetId !== ((_interstitial$assetLi = interstitial.assetList) == null ? void 0 : _interstitial$assetLi[assetListIndex].identifier))) {
        var _this$detachedData3;
        const playingAssetListIndex = interstitial.findAssetIndex(playingAsset);
        this.log(`INTERSTITIAL_ASSET_ENDED ${playingAssetListIndex + 1}/${interstitial.assetList.length} ${eventAssetToString(playingAsset)}`);
        this.endedAsset = playingAsset;
        this.playingAsset = null;
        this.hls.trigger(Events.INTERSTITIAL_ASSET_ENDED, {
          asset: playingAsset,
          assetListIndex: playingAssetListIndex,
          event: interstitial,
          schedule: scheduleItems.slice(0),
          scheduleIndex: index,
          player
        });
        this.retreiveMediaSource(assetId, scheduledItem);
        if (player.media && !((_this$detachedData3 = this.detachedData) != null && _this$detachedData3.mediaSource)) {
          player.detachMedia();
        }
      }
      if (!this.eventItemsMatch(currentItem, scheduledItem)) {
        this.endedItem = currentItem;
        this.playingItem = null;
        this.log(`INTERSTITIAL_ENDED ${interstitial} ${segmentToString(currentItem)}`);
        interstitial.hasPlayed = true;
        this.hls.trigger(Events.INTERSTITIAL_ENDED, {
          event: interstitial,
          schedule: scheduleItems.slice(0),
          scheduleIndex: index
        });
        // Exiting an Interstitial
        if (interstitial.cue.once) {
          // Remove interstitial with CUE attribute value of ONCE after it has played
          this.updateSchedule();
          const items = this.schedule.items;
          if (scheduledItem && items) {
            const updatedIndex = this.schedule.findItemIndex(scheduledItem);
            this.advanceSchedule(updatedIndex, items, assetListIndex, currentItem, playingLastItem);
          }
          return;
        }
      }
    }
    this.advanceSchedule(index, scheduleItems, assetListIndex, currentItem, playingLastItem);
  }
  advanceSchedule(index, scheduleItems, assetListIndex, currentItem, playedLastItem) {
    const scheduledItem = index >= 0 ? scheduleItems[index] : null;
    const media = this.primaryMedia;
    // Cleanup out of range Interstitials
    const playerQueue = this.playerQueue;
    if (playerQueue.length) {
      playerQueue.forEach(player => {
        const interstitial = player.interstitial;
        const queuedIndex = this.schedule.findEventIndex(interstitial.identifier);
        if (queuedIndex < index || queuedIndex > index + 1) {
          this.clearInterstitial(interstitial, scheduledItem);
        }
      });
    }
    // Setup scheduled item
    if (this.isInterstitial(scheduledItem)) {
      this.timelinePos = Math.min(Math.max(this.timelinePos, scheduledItem.start), scheduledItem.end);
      // Handle Interstitial
      const interstitial = scheduledItem.event;
      // find asset index
      if (assetListIndex === undefined) {
        assetListIndex = this.schedule.findAssetIndex(interstitial, this.timelinePos);
        const assetIndexCandidate = getNextAssetIndex(interstitial, assetListIndex - 1);
        if (interstitial.isAssetPastPlayoutLimit(assetIndexCandidate)) {
          this.advanceAfterAssetEnded(interstitial, index, assetListIndex);
          return;
        }
        assetListIndex = assetIndexCandidate;
      }
      // Ensure Interstitial is enqueued
      const waitingItem = this.waitingItem;
      if (!this.assetsBuffered(scheduledItem, media)) {
        this.setBufferingItem(scheduledItem);
      }
      let player = this.preloadAssets(interstitial, assetListIndex);
      if (!this.eventItemsMatch(scheduledItem, waitingItem || currentItem)) {
        this.waitingItem = scheduledItem;
        this.log(`INTERSTITIAL_STARTED ${segmentToString(scheduledItem)} ${interstitial.appendInPlace ? 'append in place' : ''}`);
        this.hls.trigger(Events.INTERSTITIAL_STARTED, {
          event: interstitial,
          schedule: scheduleItems.slice(0),
          scheduleIndex: index
        });
      }
      if (!interstitial.assetListLoaded) {
        // Waiting at end of primary content segment
        // Expect setSchedulePosition to be called again once ASSET-LIST is loaded
        this.log(`Waiting for ASSET-LIST to complete loading ${interstitial}`);
        return;
      }
      if (interstitial.assetListLoader) {
        interstitial.assetListLoader.destroy();
        interstitial.assetListLoader = undefined;
      }
      if (!media) {
        this.log(`Waiting for attachMedia to start Interstitial ${interstitial}`);
        return;
      }
      // Update schedule and asset list position now that it can start
      this.waitingItem = this.endedItem = null;
      this.playingItem = scheduledItem;

      // If asset-list is empty or missing asset index, advance to next item
      const assetItem = interstitial.assetList[assetListIndex];
      if (!assetItem) {
        const nextItem = scheduleItems[index + 1];
        const _media2 = this.media;
        if (nextItem && _media2 && !this.isInterstitial(nextItem) && _media2.currentTime < nextItem.start) {
          _media2.currentTime = this.timelinePos = nextItem.start;
        }
        this.advanceAfterAssetEnded(interstitial, index, assetListIndex || 0);
        return;
      }

      // Start Interstitial Playback
      if (!player) {
        player = this.getAssetPlayer(assetItem.identifier);
      }
      if (player === null || player.destroyed) {
        const assetListLength = interstitial.assetList.length;
        this.warn(`asset ${assetListIndex + 1}/${assetListLength} player destroyed ${interstitial}`);
        player = this.createAssetPlayer(interstitial, assetItem, assetListIndex);
      }
      if (!this.eventItemsMatch(scheduledItem, this.bufferingItem)) {
        if (interstitial.appendInPlace && this.isAssetBuffered(assetItem)) {
          return;
        }
      }
      this.startAssetPlayer(player, assetListIndex, scheduleItems, index, media);
      if (this.shouldPlay) {
        playWithCatch(player.media);
      }
    } else if (scheduledItem !== null) {
      this.resumePrimary(scheduledItem, index, currentItem);
      if (this.shouldPlay) {
        playWithCatch(this.hls.media);
      }
    } else if (playedLastItem && this.isInterstitial(currentItem)) {
      // Maintain playingItem state at end of schedule (setSchedulePosition(-1) called to end program)
      // this allows onSeeking handler to update schedule position
      this.endedItem = null;
      this.playingItem = currentItem;
      if (!currentItem.event.appendInPlace) {
        // Media must be re-attached to resume primary schedule if not sharing source
        this.attachPrimary(this.schedule.durations.primary, null);
      }
    }
  }
  get playbackDisabled() {
    return this.hls.config.enableInterstitialPlayback === false;
  }
  get primaryDetails() {
    var _this$mediaSelection, _this$mediaSelection$;
    return (_this$mediaSelection = this.mediaSelection) == null ? void 0 : (_this$mediaSelection$ = _this$mediaSelection.main) == null ? void 0 : _this$mediaSelection$.details;
  }
  get primaryLive() {
    var _this$primaryDetails;
    return !!((_this$primaryDetails = this.primaryDetails) != null && _this$primaryDetails.live);
  }
  resumePrimary(scheduledItem, index, fromItem) {
    var _this$detachedData4;
    this.playingItem = scheduledItem;
    this.playingAsset = this.endedAsset = null;
    this.waitingItem = this.endedItem = null;
    this.bufferedToItem(scheduledItem);
    this.log(`resuming ${segmentToString(scheduledItem)}`);
    if (!((_this$detachedData4 = this.detachedData) != null && _this$detachedData4.mediaSource)) {
      let timelinePos = this.timelinePos;
      if (timelinePos < scheduledItem.start || timelinePos >= scheduledItem.end) {
        timelinePos = this.getPrimaryResumption(scheduledItem, index);
        this.timelinePos = timelinePos;
      }
      this.attachPrimary(timelinePos, scheduledItem);
    }
    if (!fromItem) {
      return;
    }
    const scheduleItems = this.schedule.items;
    if (!scheduleItems) {
      return;
    }
    this.log(`INTERSTITIALS_PRIMARY_RESUMED ${segmentToString(scheduledItem)}`);
    this.hls.trigger(Events.INTERSTITIALS_PRIMARY_RESUMED, {
      schedule: scheduleItems.slice(0),
      scheduleIndex: index
    });
    this.checkBuffer();
  }
  getPrimaryResumption(scheduledItem, index) {
    const itemStart = scheduledItem.start;
    if (this.primaryLive) {
      const details = this.primaryDetails;
      if (index === 0) {
        return this.hls.startPosition;
      } else if (details && (itemStart < details.fragmentStart || itemStart > details.edge)) {
        return this.hls.liveSyncPosition || -1;
      }
    }
    return itemStart;
  }
  isAssetBuffered(asset) {
    const player = this.getAssetPlayer(asset.identifier);
    if (player != null && player.hls) {
      return player.hls.bufferedToEnd;
    }
    const bufferInfo = BufferHelper.bufferInfo(this.primaryMedia, this.timelinePos, 0);
    return bufferInfo.end + 1 >= asset.timelineStart + (asset.duration || 0);
  }
  attachPrimary(timelinePos, item, skipSeekToStartPosition) {
    if (item) {
      this.setBufferingItem(item);
    } else {
      this.bufferingItem = this.playingItem;
    }
    this.bufferingAsset = null;
    const media = this.primaryMedia;
    if (!media) {
      return;
    }
    const hls = this.hls;
    if (hls.media) {
      this.checkBuffer();
    } else {
      this.transferMediaTo(hls, media);
      if (skipSeekToStartPosition) {
        this.startLoadingPrimaryAt(timelinePos, skipSeekToStartPosition);
      }
    }
    if (!skipSeekToStartPosition) {
      // Set primary position to resume time
      this.timelinePos = timelinePos;
      this.startLoadingPrimaryAt(timelinePos, skipSeekToStartPosition);
    }
  }
  startLoadingPrimaryAt(timelinePos, skipSeekToStartPosition) {
    var _hls$mainForwardBuffe;
    const hls = this.hls;
    if (!hls.loadingEnabled || !hls.media || Math.abs((((_hls$mainForwardBuffe = hls.mainForwardBufferInfo) == null ? void 0 : _hls$mainForwardBuffe.start) || hls.media.currentTime) - timelinePos) > 0.5) {
      hls.startLoad(timelinePos, skipSeekToStartPosition);
    } else if (!hls.bufferingEnabled) {
      hls.resumeBuffering();
    }
  }

  // HLS.js event callbacks
  onManifestLoading() {
    this.stopLoad();
    this.schedule.reset();
    this.emptyPlayerQueue();
    this.clearScheduleState();
    this.shouldPlay = false;
    this.bufferedPos = this.timelinePos = -1;
    this.mediaSelection = this.altSelection = this.manager = this.requiredTracks = null;
    // BUFFER_CODECS listener added here for buffer-controller to handle it first where it adds tracks
    this.hls.off(Events.BUFFER_CODECS, this.onBufferCodecs, this);
    this.hls.on(Events.BUFFER_CODECS, this.onBufferCodecs, this);
  }
  onLevelUpdated(event, data) {
    if (data.level === -1) {
      // level was removed
      return;
    }
    const main = this.hls.levels[data.level];
    const currentSelection = _objectSpread2(_objectSpread2({}, this.mediaSelection || this.altSelection), {}, {
      main
    });
    this.mediaSelection = currentSelection;
    this.schedule.parseInterstitialDateRanges(currentSelection, this.hls.config.interstitialAppendInPlace);
    if (!this.effectivePlayingItem && this.schedule.items) {
      this.checkStart();
    }
  }
  onAudioTrackUpdated(event, data) {
    const audio = this.hls.audioTracks[data.id];
    const previousSelection = this.mediaSelection;
    if (!previousSelection) {
      this.altSelection = _objectSpread2(_objectSpread2({}, this.altSelection), {}, {
        audio
      });
      return;
    }
    const currentSelection = _objectSpread2(_objectSpread2({}, previousSelection), {}, {
      audio
    });
    this.mediaSelection = currentSelection;
  }
  onSubtitleTrackUpdated(event, data) {
    const subtitles = this.hls.subtitleTracks[data.id];
    const previousSelection = this.mediaSelection;
    if (!previousSelection) {
      this.altSelection = _objectSpread2(_objectSpread2({}, this.altSelection), {}, {
        subtitles
      });
      return;
    }
    const currentSelection = _objectSpread2(_objectSpread2({}, previousSelection), {}, {
      subtitles
    });
    this.mediaSelection = currentSelection;
  }
  onAudioTrackSwitching(event, data) {
    const audioOption = getBasicSelectionOption(data);
    this.playerQueue.forEach(player => player.hls.setAudioOption(data) || player.hls.setAudioOption(audioOption));
  }
  onSubtitleTrackSwitch(event, data) {
    const subtitleOption = getBasicSelectionOption(data);
    this.playerQueue.forEach(player => player.hls.setSubtitleOption(data) || data.id !== -1 && player.hls.setSubtitleOption(subtitleOption));
  }
  onBufferCodecs(event, data) {
    const requiredTracks = data.tracks;
    if (requiredTracks) {
      this.requiredTracks = requiredTracks;
    }
  }
  onBufferAppended(event, data) {
    this.checkBuffer();
  }
  onBufferFlushed(event, data) {
    const playingItem = this.playingItem;
    if (playingItem && !this.itemsMatch(playingItem, this.bufferingItem) && !this.isInterstitial(playingItem)) {
      const timelinePos = this.timelinePos;
      this.bufferedPos = timelinePos;
      this.checkBuffer();
    }
  }
  onBufferedToEnd(event) {
    // Buffered to post-roll
    const interstitialEvents = this.schedule.events;
    if (this.bufferedPos < Number.MAX_VALUE && interstitialEvents) {
      for (let i = 0; i < interstitialEvents.length; i++) {
        const interstitial = interstitialEvents[i];
        if (interstitial.cue.post) {
          var _this$schedule$items;
          const scheduleIndex = this.schedule.findEventIndex(interstitial.identifier);
          const item = (_this$schedule$items = this.schedule.items) == null ? void 0 : _this$schedule$items[scheduleIndex];
          if (this.isInterstitial(item) && this.eventItemsMatch(item, this.bufferingItem)) {
            this.bufferedToItem(item, 0);
          }
          break;
        }
      }
      this.bufferedPos = Number.MAX_VALUE;
    }
  }
  onMediaEnded(event) {
    const playingItem = this.playingItem;
    if (!this.playingLastItem && playingItem) {
      const playingIndex = this.findItemIndex(playingItem);
      this.setSchedulePosition(playingIndex + 1);
    } else {
      this.shouldPlay = false;
    }
  }
  updateItem(previousItem, time) {
    // find item in this.schedule.items;
    const items = this.schedule.items;
    if (previousItem && items) {
      const index = this.findItemIndex(previousItem, time);
      return items[index] || null;
    }
    return null;
  }
  trimInPlace(updatedItem, itemBeforeUpdate) {
    if (this.isInterstitial(updatedItem) && updatedItem.event.appendInPlace && itemBeforeUpdate.end - updatedItem.end > 0.25) {
      updatedItem.event.assetList.forEach((asset, index) => {
        if (updatedItem.event.isAssetPastPlayoutLimit(index)) {
          this.clearAssetPlayer(asset.identifier, null);
        }
      });
      const flushStart = updatedItem.end + 0.25;
      const bufferInfo = BufferHelper.bufferInfo(this.primaryMedia, flushStart, 0);
      if (bufferInfo.end > flushStart || (bufferInfo.nextStart || 0) > flushStart) {
        this.attachPrimary(flushStart, null);
        this.flushFrontBuffer(flushStart);
      }
    }
  }
  itemsMatch(a, b) {
    return !!b && (a === b || a.event && b.event && this.eventItemsMatch(a, b) || !a.event && !b.event && this.findItemIndex(a) === this.findItemIndex(b));
  }
  eventItemsMatch(a, b) {
    var _b$event;
    return !!b && (a === b || a.event.identifier === ((_b$event = b.event) == null ? void 0 : _b$event.identifier));
  }
  findItemIndex(item, time) {
    return item ? this.schedule.findItemIndex(item, time) : -1;
  }
  updateSchedule() {
    const mediaSelection = this.mediaSelection;
    if (!mediaSelection) {
      return;
    }
    this.schedule.updateSchedule(mediaSelection, []);
  }

  // Schedule buffer control
  checkBuffer(starved) {
    const items = this.schedule.items;
    if (!items) {
      return;
    }
    // Find when combined forward buffer change reaches next schedule segment
    const bufferInfo = BufferHelper.bufferInfo(this.primaryMedia, this.timelinePos, 0);
    if (starved) {
      this.bufferedPos = this.timelinePos;
    }
    starved || (starved = bufferInfo.len < 1);
    this.updateBufferedPos(bufferInfo.end, items, starved);
  }
  updateBufferedPos(bufferEnd, items, bufferIsEmpty) {
    const schedule = this.schedule;
    const bufferingItem = this.bufferingItem;
    if (this.bufferedPos > bufferEnd) {
      return;
    }
    if (items.length === 1 && this.itemsMatch(items[0], bufferingItem)) {
      this.bufferedPos = bufferEnd;
      return;
    }
    const playingItem = this.playingItem;
    const playingIndex = this.findItemIndex(playingItem);
    let bufferEndIndex = schedule.findItemIndexAtTime(bufferEnd);
    if (this.bufferedPos < bufferEnd) {
      var _nextItemToBuffer$eve, _bufferingItem$event;
      const bufferingIndex = this.findItemIndex(bufferingItem);
      const nextToBufferIndex = Math.min(bufferingIndex + 1, items.length - 1);
      const nextItemToBuffer = items[nextToBufferIndex];
      if (bufferEndIndex === -1 && bufferingItem && bufferEnd >= bufferingItem.end || (_nextItemToBuffer$eve = nextItemToBuffer.event) != null && _nextItemToBuffer$eve.appendInPlace && bufferEnd + 0.01 >= nextItemToBuffer.start) {
        bufferEndIndex = nextToBufferIndex;
      }
      if (nextToBufferIndex - playingIndex > 1 && (bufferingItem == null ? void 0 : (_bufferingItem$event = bufferingItem.event) == null ? void 0 : _bufferingItem$event.appendInPlace) === false) {
        // do not advance buffering item past Interstitial that requires source reset
        return;
      }
      this.bufferedPos = bufferEnd;
      if (bufferEndIndex > bufferingIndex && bufferEndIndex > playingIndex) {
        this.bufferedToItem(nextItemToBuffer);
      } else {
        // allow more time than distance from edge for assets to load
        const details = this.primaryDetails;
        if (this.primaryLive && details && bufferEnd > details.edge - details.targetduration && nextItemToBuffer.start < details.edge + this.hls.config.interstitialLiveLookAhead && this.isInterstitial(nextItemToBuffer)) {
          this.preloadAssets(nextItemToBuffer.event, 0);
        }
      }
    } else if (bufferIsEmpty && playingItem && !this.itemsMatch(playingItem, bufferingItem)) {
      if (bufferEndIndex === playingIndex) {
        this.bufferedToItem(playingItem);
      } else if (bufferEndIndex === playingIndex + 1) {
        this.bufferedToItem(items[bufferEndIndex]);
      }
    }
  }
  assetsBuffered(item, media) {
    const assetList = item.event.assetList;
    if (assetList.length === 0) {
      return false;
    }
    return !item.event.assetList.some(asset => {
      const player = this.getAssetPlayer(asset.identifier);
      return !(player != null && player.bufferedInPlaceToEnd(media));
    });
  }
  setBufferingItem(item) {
    const bufferingLast = this.bufferingItem;
    const schedule = this.schedule;
    if (!this.itemsMatch(item, bufferingLast)) {
      const {
        items,
        events
      } = schedule;
      if (!items || !events) {
        return bufferingLast;
      }
      const isInterstitial = this.isInterstitial(item);
      const bufferingPlayer = this.getBufferingPlayer();
      this.bufferingItem = item;
      this.bufferedPos = Math.max(item.start, Math.min(item.end, this.timelinePos));
      const timeRemaining = bufferingPlayer ? bufferingPlayer.remaining : bufferingLast ? bufferingLast.end - this.timelinePos : 0;
      this.log(`INTERSTITIALS_BUFFERED_TO_BOUNDARY ${segmentToString(item)}` + (bufferingLast ? ` (${timeRemaining.toFixed(2)} remaining)` : ''));
      if (!this.playbackDisabled) {
        if (isInterstitial) {
          // primary fragment loading will exit early in base-stream-controller while `bufferingItem` is set to an Interstitial block
          item.event.assetList.forEach(asset => {
            const player = this.getAssetPlayer(asset.identifier);
            if (player) {
              player.resumeBuffering();
            }
          });
        } else {
          this.hls.resumeBuffering();
          this.playerQueue.forEach(player => player.pauseBuffering());
        }
      }
      this.hls.trigger(Events.INTERSTITIALS_BUFFERED_TO_BOUNDARY, {
        events: events.slice(0),
        schedule: items.slice(0),
        bufferingIndex: this.findItemIndex(item),
        playingIndex: this.findItemIndex(this.playingItem)
      });
    } else if (this.bufferingItem !== item) {
      this.bufferingItem = item;
    }
    return bufferingLast;
  }
  bufferedToItem(item, assetListIndex = 0) {
    const bufferingLast = this.setBufferingItem(item);
    if (this.playbackDisabled) {
      return;
    }
    if (this.isInterstitial(item)) {
      // Ensure asset list is loaded
      this.bufferedToEvent(item, assetListIndex);
    } else if (bufferingLast !== null) {
      // If primary player is detached, it is also stopped, restart loading at primary position
      this.bufferingAsset = null;
      const detachedData = this.detachedData;
      if (detachedData) {
        if (detachedData.mediaSource) {
          const skipSeekToStartPosition = true;
          this.attachPrimary(item.start, item, skipSeekToStartPosition);
        } else {
          this.preloadPrimary(item);
        }
      } else {
        // If not detached seek to resumption point
        this.preloadPrimary(item);
      }
    }
  }
  preloadPrimary(item) {
    const index = this.findItemIndex(item);
    const timelinePos = this.getPrimaryResumption(item, index);
    this.startLoadingPrimaryAt(timelinePos);
  }
  bufferedToEvent(item, assetListIndex) {
    const interstitial = item.event;
    const neverLoaded = interstitial.assetList.length === 0 && !interstitial.assetListLoader;
    const playOnce = interstitial.cue.once;
    if (neverLoaded || !playOnce) {
      // Buffered to Interstitial boundary
      const player = this.preloadAssets(interstitial, assetListIndex);
      if (player != null && player.interstitial.appendInPlace) {
        // If we have a player and asset list info, start buffering
        const assetItem = interstitial.assetList[assetListIndex];
        const media = this.primaryMedia;
        if (assetItem && media) {
          this.bufferAssetPlayer(player, media);
        }
      }
    }
  }
  preloadAssets(interstitial, assetListIndex) {
    const uri = interstitial.assetUrl;
    const assetListLength = interstitial.assetList.length;
    const neverLoaded = assetListLength === 0 && !interstitial.assetListLoader;
    const playOnce = interstitial.cue.once;
    if (neverLoaded) {
      const timelineStart = interstitial.timelineStart;
      if (interstitial.appendInPlace) {
        var _playingItem$nextEven;
        const playingItem = this.playingItem;
        if (!this.isInterstitial(playingItem) && (playingItem == null ? void 0 : (_playingItem$nextEven = playingItem.nextEvent) == null ? void 0 : _playingItem$nextEven.identifier) === interstitial.identifier) {
          this.flushFrontBuffer(timelineStart + 0.25);
        }
      }
      let hlsStartOffset;
      let liveStartPosition = 0;
      if (!this.playingItem && this.primaryLive) {
        liveStartPosition = this.hls.startPosition;
        if (liveStartPosition === -1) {
          liveStartPosition = this.hls.liveSyncPosition || 0;
        }
      }
      if (liveStartPosition && !(interstitial.cue.pre || interstitial.cue.post)) {
        const startOffset = liveStartPosition - timelineStart;
        if (startOffset > 0) {
          hlsStartOffset = Math.round(startOffset * 1000) / 1000;
        }
      }
      this.log(`Load interstitial asset ${assetListIndex + 1}/${uri ? 1 : assetListLength} ${interstitial}${hlsStartOffset ? ` live-start: ${liveStartPosition} start-offset: ${hlsStartOffset}` : ''}`);
      if (uri) {
        return this.createAsset(interstitial, 0, 0, timelineStart, interstitial.duration, uri);
      }
      const assetListLoader = this.assetListLoader.loadAssetList(interstitial, hlsStartOffset);
      if (assetListLoader) {
        interstitial.assetListLoader = assetListLoader;
      }
    } else if (!playOnce && assetListLength) {
      // Re-buffered to Interstitial boundary, re-create asset player(s)
      for (let i = assetListIndex; i < assetListLength; i++) {
        const asset = interstitial.assetList[i];
        const playerIndex = this.getAssetPlayerQueueIndex(asset.identifier);
        if ((playerIndex === -1 || this.playerQueue[playerIndex].destroyed) && !asset.error) {
          this.createAssetPlayer(interstitial, asset, i);
        }
      }
      return this.getAssetPlayer(interstitial.assetList[assetListIndex].identifier);
    }
    return null;
  }
  flushFrontBuffer(startOffset) {
    // Force queued flushing of all buffers
    const requiredTracks = this.requiredTracks;
    if (!requiredTracks) {
      return;
    }
    this.log(`Removing front buffer starting at ${startOffset}`);
    const sourceBufferNames = Object.keys(requiredTracks);
    sourceBufferNames.forEach(type => {
      this.hls.trigger(Events.BUFFER_FLUSHING, {
        startOffset,
        endOffset: Infinity,
        type
      });
    });
  }

  // Interstitial Asset Player control
  getAssetPlayerQueueIndex(assetId) {
    const playerQueue = this.playerQueue;
    for (let i = 0; i < playerQueue.length; i++) {
      if (assetId === playerQueue[i].assetId) {
        return i;
      }
    }
    return -1;
  }
  getAssetPlayer(assetId) {
    const index = this.getAssetPlayerQueueIndex(assetId);
    return this.playerQueue[index] || null;
  }
  getBufferingPlayer() {
    const {
      playerQueue,
      primaryMedia
    } = this;
    if (primaryMedia) {
      for (let i = 0; i < playerQueue.length; i++) {
        if (playerQueue[i].media === primaryMedia) {
          return playerQueue[i];
        }
      }
    }
    return null;
  }
  createAsset(interstitial, assetListIndex, startOffset, timelineStart, duration, uri) {
    const assetItem = {
      parentIdentifier: interstitial.identifier,
      identifier: generateAssetIdentifier(interstitial, uri, assetListIndex),
      duration,
      startOffset,
      timelineStart,
      uri
    };
    return this.createAssetPlayer(interstitial, assetItem, assetListIndex);
  }
  createAssetPlayer(interstitial, assetItem, assetListIndex) {
    const primary = this.hls;
    const userConfig = primary.userConfig;
    let videoPreference = userConfig.videoPreference;
    const currentLevel = primary.loadLevelObj || primary.levels[primary.currentLevel];
    if (videoPreference || currentLevel) {
      videoPreference = _extends({}, videoPreference);
      if (currentLevel.videoCodec) {
        videoPreference.videoCodec = currentLevel.videoCodec;
      }
      if (currentLevel.videoRange) {
        videoPreference.allowedVideoRanges = [currentLevel.videoRange];
      }
    }
    const selectedAudio = primary.audioTracks[primary.audioTrack];
    const selectedSubtitle = primary.subtitleTracks[primary.subtitleTrack];
    let startPosition = 0;
    if (this.primaryLive || interstitial.appendInPlace) {
      const timePastStart = this.timelinePos - assetItem.timelineStart;
      if (timePastStart > 1) {
        const duration = assetItem.duration;
        if (duration && timePastStart < duration) {
          startPosition = timePastStart;
        }
      }
    }
    const assetId = assetItem.identifier;
    const playerConfig = _objectSpread2(_objectSpread2({}, userConfig), {}, {
      autoStartLoad: true,
      startFragPrefetch: true,
      primarySessionId: primary.sessionId,
      assetPlayerId: assetId,
      abrEwmaDefaultEstimate: primary.bandwidthEstimate,
      interstitialsController: undefined,
      startPosition,
      liveDurationInfinity: false,
      testBandwidth: false,
      videoPreference,
      audioPreference: selectedAudio || userConfig.audioPreference,
      subtitlePreference: selectedSubtitle || userConfig.subtitlePreference
    });
    if (interstitial.appendInPlace) {
      interstitial.appendInPlaceStarted = true;
      if (assetItem.timelineStart) {
        playerConfig.timelineOffset = assetItem.timelineStart;
      }
    }
    const cmcd = playerConfig.cmcd;
    if (cmcd != null && cmcd.sessionId && cmcd.contentId) {
      playerConfig.cmcd = _extends({}, cmcd, {
        contentId: hash(assetItem.uri)
      });
    }
    if (this.getAssetPlayer(assetId)) {
      this.warn(`Duplicate date range identifier ${interstitial} and asset ${assetId}`);
    }
    const player = new HlsAssetPlayer(this.HlsPlayerClass, playerConfig, interstitial, assetItem);
    this.playerQueue.push(player);
    interstitial.assetList[assetListIndex] = assetItem;
    // Listen for LevelDetails and PTS change to update duration
    const updateAssetPlayerDetails = details => {
      if (details.live) {
        const error = new Error(`Interstitials MUST be VOD assets ${interstitial}`);
        const errorData = {
          fatal: true,
          type: ErrorTypes.OTHER_ERROR,
          details: ErrorDetails.INTERSTITIAL_ASSET_ITEM_ERROR,
          error
        };
        this.handleAssetItemError(errorData, interstitial, this.schedule.findEventIndex(interstitial.identifier), assetListIndex, error.message);
        return;
      }
      // Get time at end of last fragment
      const duration = details.edge - details.fragmentStart;
      const currentAssetDuration = assetItem.duration;
      if (currentAssetDuration === null || duration > currentAssetDuration) {
        this.log(`Interstitial asset "${assetId}" duration change ${currentAssetDuration} > ${duration}`);
        assetItem.duration = duration;
        // Update schedule with new event and asset duration
        this.updateSchedule();
      }
    };
    player.on(Events.LEVEL_UPDATED, (event, {
      details
    }) => updateAssetPlayerDetails(details));
    player.on(Events.LEVEL_PTS_UPDATED, (event, {
      details
    }) => updateAssetPlayerDetails(details));
    const onBufferCodecs = (event, data) => {
      const inQueuPlayer = this.getAssetPlayer(assetId);
      if (inQueuPlayer && data.tracks) {
        inQueuPlayer.off(Events.BUFFER_CODECS, onBufferCodecs);
        inQueuPlayer.tracks = data.tracks;
        const media = this.primaryMedia;
        if (this.bufferingAsset === inQueuPlayer.assetItem && media && !inQueuPlayer.media) {
          this.bufferAssetPlayer(inQueuPlayer, media);
        }
      }
    };
    player.on(Events.BUFFER_CODECS, onBufferCodecs);
    const bufferedToEnd = () => {
      var _this$schedule$items2;
      const inQueuPlayer = this.getAssetPlayer(assetId);
      this.log(`buffered to end of asset ${inQueuPlayer}`);
      if (!inQueuPlayer) {
        return;
      }
      // Preload at end of asset
      const scheduleIndex = this.schedule.findEventIndex(interstitial.identifier);
      const item = (_this$schedule$items2 = this.schedule.items) == null ? void 0 : _this$schedule$items2[scheduleIndex];
      if (this.isInterstitial(item)) {
        const assetListIndex = interstitial.findAssetIndex(assetItem);
        const nextAssetIndex = getNextAssetIndex(interstitial, assetListIndex);
        if (!interstitial.isAssetPastPlayoutLimit(nextAssetIndex)) {
          this.bufferedToItem(item, nextAssetIndex);
        } else {
          var _this$schedule$items3;
          const nextItem = (_this$schedule$items3 = this.schedule.items) == null ? void 0 : _this$schedule$items3[scheduleIndex + 1];
          if (nextItem) {
            this.bufferedToItem(nextItem);
          }
        }
      }
    };
    player.on(Events.BUFFERED_TO_END, bufferedToEnd);
    const endedWithAssetIndex = assetIndex => {
      return () => {
        const inQueuPlayer = this.getAssetPlayer(assetId);
        if (!inQueuPlayer) {
          return;
        }
        this.shouldPlay = true;
        const scheduleIndex = this.schedule.findEventIndex(interstitial.identifier);
        this.advanceAfterAssetEnded(interstitial, scheduleIndex, assetIndex);
      };
    };
    player.once(Events.MEDIA_ENDED, endedWithAssetIndex(assetListIndex));
    player.once(Events.PLAYOUT_LIMIT_REACHED, endedWithAssetIndex(Infinity));
    player.on(Events.ERROR, (event, data) => {
      const inQueuPlayer = this.getAssetPlayer(assetId);
      if (data.details === ErrorDetails.BUFFER_STALLED_ERROR) {
        if (inQueuPlayer != null && inQueuPlayer.media) {
          const assetCurrentTime = inQueuPlayer.currentTime;
          const distanceFromEnd = inQueuPlayer.duration - assetCurrentTime;
          if (assetCurrentTime && interstitial.appendInPlace && distanceFromEnd / inQueuPlayer.media.playbackRate < 0.5) {
            this.log(`Advancing buffer past end of asset ${assetId} ${interstitial} at ${inQueuPlayer.media.currentTime}`);
            bufferedToEnd();
          } else {
            this.warn(`Stalled at ${assetCurrentTime} of ${assetCurrentTime + distanceFromEnd} in asset ${assetId} ${interstitial}`);
            this.onTimeupdate();
            this.checkBuffer(true);
          }
        }
        return;
      }
      this.handleAssetItemError(data, interstitial, this.schedule.findEventIndex(interstitial.identifier), assetListIndex, `Asset player error ${data.error} ${interstitial}`);
    });
    player.on(Events.DESTROYING, () => {
      const inQueuPlayer = this.getAssetPlayer(assetId);
      if (!inQueuPlayer) {
        return;
      }
      const error = new Error(`Asset player destroyed unexpectedly ${assetId}`);
      const errorData = {
        fatal: true,
        type: ErrorTypes.OTHER_ERROR,
        details: ErrorDetails.INTERSTITIAL_ASSET_ITEM_ERROR,
        error
      };
      this.handleAssetItemError(errorData, interstitial, this.schedule.findEventIndex(interstitial.identifier), assetListIndex, error.message);
    });
    this.log(`INTERSTITIAL_ASSET_PLAYER_CREATED ${eventAssetToString(assetItem)}`);
    this.hls.trigger(Events.INTERSTITIAL_ASSET_PLAYER_CREATED, {
      asset: assetItem,
      assetListIndex,
      event: interstitial,
      player
    });
    return player;
  }
  clearInterstitial(interstitial, toSegment) {
    interstitial.assetList.forEach(asset => {
      this.clearAssetPlayer(asset.identifier, toSegment);
    });
    // Remove asset list and resolved duration
    interstitial.reset();
  }
  resetAssetPlayer(assetId) {
    // Reset asset player so that it's timeline can be adjusted without reloading the MVP
    const playerIndex = this.getAssetPlayerQueueIndex(assetId);
    if (playerIndex !== -1) {
      this.log(`reset asset player "${assetId}" after error`);
      const player = this.playerQueue[playerIndex];
      this.transferMediaFromPlayer(player, null);
      player.resetDetails();
    }
  }
  clearAssetPlayer(assetId, toSegment) {
    const playerIndex = this.getAssetPlayerQueueIndex(assetId);
    if (playerIndex !== -1) {
      this.log(`clear asset player "${assetId}" toSegment: ${toSegment ? segmentToString(toSegment) : toSegment}`);
      const player = this.playerQueue[playerIndex];
      this.transferMediaFromPlayer(player, toSegment);
      this.playerQueue.splice(playerIndex, 1);
      player.destroy();
    }
  }
  emptyPlayerQueue() {
    let player;
    while (player = this.playerQueue.pop()) {
      player.destroy();
    }
    this.playerQueue = [];
  }
  startAssetPlayer(player, assetListIndex, scheduleItems, scheduleIndex, media) {
    const {
      interstitial,
      assetItem,
      assetId
    } = player;
    const assetListLength = interstitial.assetList.length;
    const playingAsset = this.playingAsset;
    this.endedAsset = null;
    this.playingAsset = assetItem;
    if (!playingAsset || playingAsset.identifier !== assetId) {
      if (playingAsset) {
        // Exiting another Interstitial asset
        this.clearAssetPlayer(playingAsset.identifier, scheduleItems[scheduleIndex]);
        delete playingAsset.error;
      }
      this.log(`INTERSTITIAL_ASSET_STARTED ${assetListIndex + 1}/${assetListLength} ${eventAssetToString(assetItem)}`);
      this.hls.trigger(Events.INTERSTITIAL_ASSET_STARTED, {
        asset: assetItem,
        assetListIndex,
        event: interstitial,
        schedule: scheduleItems.slice(0),
        scheduleIndex,
        player
      });
    }

    // detach media and attach to interstitial player if it does not have another element attached
    this.bufferAssetPlayer(player, media);
  }
  bufferAssetPlayer(player, media) {
    var _this$schedule$items4, _this$detachedData5;
    const {
      interstitial,
      assetItem
    } = player;
    const scheduleIndex = this.schedule.findEventIndex(interstitial.identifier);
    const item = (_this$schedule$items4 = this.schedule.items) == null ? void 0 : _this$schedule$items4[scheduleIndex];
    if (!item) {
      return;
    }
    this.setBufferingItem(item);
    this.bufferingAsset = assetItem;
    const bufferingPlayer = this.getBufferingPlayer();
    if (bufferingPlayer === player) {
      return;
    }
    const appendInPlaceNext = interstitial.appendInPlace;
    if (appendInPlaceNext && (bufferingPlayer == null ? void 0 : bufferingPlayer.interstitial.appendInPlace) === false) {
      // Media is detached and not available to append in place
      return;
    }
    const activeTracks = (bufferingPlayer == null ? void 0 : bufferingPlayer.tracks) || ((_this$detachedData5 = this.detachedData) == null ? void 0 : _this$detachedData5.tracks) || this.requiredTracks;
    if (appendInPlaceNext && assetItem !== this.playingAsset) {
      // Do not buffer another item if tracks are unknown or incompatible
      if (!player.tracks) {
        return;
      }
      if (activeTracks && !isCompatibleTrackChange(activeTracks, player.tracks)) {
        const error = new Error(`Asset ${eventAssetToString(assetItem)} SourceBuffer tracks ('${Object.keys(player.tracks)}') are not compatible with primary content tracks ('${Object.keys(activeTracks)}')`);
        const errorData = {
          fatal: true,
          type: ErrorTypes.OTHER_ERROR,
          details: ErrorDetails.INTERSTITIAL_ASSET_ITEM_ERROR,
          error
        };
        const assetListIndex = interstitial.findAssetIndex(assetItem);
        this.handleAssetItemError(errorData, interstitial, scheduleIndex, assetListIndex, error.message);
        return;
      }
    }
    this.transferMediaTo(player, media);
  }
  handleAssetItemError(data, interstitial, scheduleIndex, assetListIndex, errorMessage) {
    if (data.details === ErrorDetails.BUFFER_STALLED_ERROR) {
      return;
    }
    const assetItem = interstitial.assetList[assetListIndex];
    this.warn(`INTERSTITIAL_ASSET_ERROR ${assetItem ? eventAssetToString(assetItem) : assetItem} ${data.error}`);
    const assetId = assetItem == null ? void 0 : assetItem.identifier;
    const playerIndex = this.getAssetPlayerQueueIndex(assetId);
    const player = this.playerQueue[playerIndex] || null;
    const items = this.schedule.items;
    const interstitialAssetError = _extends({}, data, {
      fatal: false,
      errorAction: createDoNothingErrorAction(true),
      asset: assetItem,
      assetListIndex,
      event: interstitial,
      schedule: items,
      scheduleIndex,
      player
    });
    this.hls.trigger(Events.INTERSTITIAL_ASSET_ERROR, interstitialAssetError);
    if (!data.fatal) {
      return;
    }
    const playingAsset = this.playingAsset;
    const error = new Error(errorMessage);
    if (assetItem) {
      this.clearAssetPlayer(assetId, null);
      assetItem.error = error;
    }

    // If all assets in interstitial fail, mark the interstitial with an error
    if (!interstitial.assetList.some(asset => !asset.error)) {
      interstitial.error = error;
    } else if (interstitial.appendInPlace) {
      // Reset level details and reload/parse media playlists to align with updated schedule
      for (let i = assetListIndex; i < interstitial.assetList.length; i++) {
        this.resetAssetPlayer(interstitial.assetList[i].identifier);
      }
      this.updateSchedule();
    }
    if (interstitial.error) {
      this.primaryFallback(interstitial);
    } else if (playingAsset && playingAsset.identifier === assetId) {
      this.advanceAfterAssetEnded(interstitial, scheduleIndex, assetListIndex);
    }
  }
  primaryFallback(interstitial) {
    // Fallback to Primary by on current or future events by updating schedule to skip errored interstitials/assets
    const flushStart = interstitial.timelineStart;
    const playingItem = this.effectivePlayingItem;
    // Update schedule now that interstitial/assets are flagged with `error` for fallback
    this.updateSchedule();
    if (playingItem) {
      this.log(`Fallback to primary from event "${interstitial.identifier}" start: ${flushStart} pos: ${this.timelinePos} playing: ${playingItem ? segmentToString(playingItem) : '<none>'} error: ${interstitial.error}`);
      let timelinePos = this.timelinePos;
      if (timelinePos === -1) {
        timelinePos = this.hls.startPosition;
      }
      const newPlayingItem = this.updateItem(playingItem, timelinePos);
      if (this.itemsMatch(playingItem, newPlayingItem)) {
        this.clearInterstitial(interstitial, null);
      }
      if (interstitial.appendInPlace) {
        this.attachPrimary(flushStart, null);
        this.flushFrontBuffer(flushStart);
      }
      const scheduleIndex = this.schedule.findItemIndexAtTime(timelinePos);
      this.setSchedulePosition(scheduleIndex);
    } else {
      this.checkStart();
    }
  }

  // Asset List loading
  onAssetListLoaded(event, data) {
    var _this$bufferingItem2;
    const interstitial = data.event;
    const interstitialId = interstitial.identifier;
    const assets = data.assetListResponse.ASSETS;
    if (!this.schedule.hasEvent(interstitialId)) {
      // Interstitial with id was removed
      return;
    }
    const eventStart = interstitial.timelineStart;
    const previousDuration = interstitial.duration;
    let sumDuration = 0;
    assets.forEach((asset, assetListIndex) => {
      const duration = parseFloat(asset.DURATION);
      this.createAsset(interstitial, assetListIndex, sumDuration, eventStart + sumDuration, duration, asset.URI);
      sumDuration += duration;
    });
    interstitial.duration = sumDuration;
    this.log(`Loaded asset-list with duration: ${sumDuration} (was: ${previousDuration}) ${interstitial}`);
    const waitingItem = this.waitingItem;
    const waitingForItem = (waitingItem == null ? void 0 : waitingItem.event.identifier) === interstitialId;

    // Update schedule now that asset.DURATION(s) are parsed
    this.updateSchedule();
    const bufferingEvent = (_this$bufferingItem2 = this.bufferingItem) == null ? void 0 : _this$bufferingItem2.event;

    // If buffer reached Interstitial, start buffering first asset
    if (waitingForItem) {
      var _this$schedule$items5;
      // Advance schedule when waiting for asset list data to play
      const scheduleIndex = this.schedule.findEventIndex(interstitialId);
      const item = (_this$schedule$items5 = this.schedule.items) == null ? void 0 : _this$schedule$items5[scheduleIndex];
      if (item) {
        if (!this.playingItem && this.timelinePos > item.end) {
          // Abandon if new duration is reduced enough to land playback in primary start
          const index = this.schedule.findItemIndexAtTime(this.timelinePos);
          if (index !== scheduleIndex) {
            interstitial.error = new Error(`Interstitial no longer within playback range ${this.timelinePos} ${interstitial}`);
            this.primaryFallback(interstitial);
            return;
          }
        }
        this.setBufferingItem(item);
      }
      this.setSchedulePosition(scheduleIndex);
    } else if ((bufferingEvent == null ? void 0 : bufferingEvent.identifier) === interstitialId && bufferingEvent.appendInPlace) {
      // If buffering (but not playback) has reached this item transfer media-source
      const assetItem = interstitial.assetList[0];
      const player = this.getAssetPlayer(assetItem.identifier);
      const media = this.primaryMedia;
      if (assetItem && player && media) {
        this.bufferAssetPlayer(player, media);
      }
    }
  }
  onError(event, data) {
    switch (data.details) {
      case ErrorDetails.ASSET_LIST_PARSING_ERROR:
      case ErrorDetails.ASSET_LIST_LOAD_ERROR:
      case ErrorDetails.ASSET_LIST_LOAD_TIMEOUT:
        {
          const interstitial = data.interstitial;
          if (interstitial) {
            this.primaryFallback(interstitial);
          }
          break;
        }
      case ErrorDetails.BUFFER_STALLED_ERROR:
        {
          this.onTimeupdate();
          this.checkBuffer(true);
          break;
        }
    }
  }
}

const TICK_INTERVAL$2 = 500; // how often to tick in ms

class SubtitleStreamController extends BaseStreamController {
  constructor(hls, fragmentTracker, keyLoader) {
    super(hls, fragmentTracker, keyLoader, 'subtitle-stream-controller', PlaylistLevelType.SUBTITLE);
    this.currentTrackId = -1;
    this.tracksBuffered = [];
    this.mainDetails = null;
    this.registerListeners();
  }
  onHandlerDestroying() {
    this.unregisterListeners();
    super.onHandlerDestroying();
    this.mainDetails = null;
  }
  registerListeners() {
    super.registerListeners();
    const {
      hls
    } = this;
    hls.on(Events.LEVEL_LOADED, this.onLevelLoaded, this);
    hls.on(Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this);
    hls.on(Events.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this);
    hls.on(Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this);
    hls.on(Events.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this);
    hls.on(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
  }
  unregisterListeners() {
    super.unregisterListeners();
    const {
      hls
    } = this;
    hls.off(Events.LEVEL_LOADED, this.onLevelLoaded, this);
    hls.off(Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this);
    hls.off(Events.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this);
    hls.off(Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this);
    hls.off(Events.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this);
    hls.off(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
  }
  startLoad(startPosition, skipSeekToStartPosition) {
    this.stopLoad();
    this.state = State.IDLE;
    this.setInterval(TICK_INTERVAL$2);
    this.nextLoadPosition = this.lastCurrentTime = startPosition + this.timelineOffset;
    this.startPosition = skipSeekToStartPosition ? -1 : startPosition;
    this.tick();
  }
  onManifestLoading() {
    super.onManifestLoading();
    this.mainDetails = null;
  }
  onMediaDetaching(event, data) {
    this.tracksBuffered = [];
    super.onMediaDetaching(event, data);
  }
  onLevelLoaded(event, data) {
    this.mainDetails = data.details;
  }
  onSubtitleFragProcessed(event, data) {
    const {
      frag,
      success
    } = data;
    if (isMediaFragment(frag)) {
      this.fragPrevious = frag;
    }
    this.state = State.IDLE;
    if (!success) {
      return;
    }
    const buffered = this.tracksBuffered[this.currentTrackId];
    if (!buffered) {
      return;
    }

    // Create/update a buffered array matching the interface used by BufferHelper.bufferedInfo
    // so we can re-use the logic used to detect how much has been buffered
    let timeRange;
    const fragStart = frag.start;
    for (let i = 0; i < buffered.length; i++) {
      if (fragStart >= buffered[i].start && fragStart <= buffered[i].end) {
        timeRange = buffered[i];
        break;
      }
    }
    const fragEnd = frag.start + frag.duration;
    if (timeRange) {
      timeRange.end = fragEnd;
    } else {
      timeRange = {
        start: fragStart,
        end: fragEnd
      };
      buffered.push(timeRange);
    }
    this.fragmentTracker.fragBuffered(frag);
    this.fragBufferedComplete(frag, null);
    if (this.media) {
      this.tick();
    }
  }
  onBufferFlushing(event, data) {
    const {
      startOffset,
      endOffset
    } = data;
    if (startOffset === 0 && endOffset !== Number.POSITIVE_INFINITY) {
      const endOffsetSubtitles = endOffset - 1;
      if (endOffsetSubtitles <= 0) {
        return;
      }
      data.endOffsetSubtitles = Math.max(0, endOffsetSubtitles);
      this.tracksBuffered.forEach(buffered => {
        for (let i = 0; i < buffered.length;) {
          if (buffered[i].end <= endOffsetSubtitles) {
            buffered.shift();
            continue;
          } else if (buffered[i].start < endOffsetSubtitles) {
            buffered[i].start = endOffsetSubtitles;
          } else {
            break;
          }
          i++;
        }
      });
      this.fragmentTracker.removeFragmentsInRange(startOffset, endOffsetSubtitles, PlaylistLevelType.SUBTITLE);
    }
  }

  // If something goes wrong, proceed to next frag, if we were processing one.
  onError(event, data) {
    const frag = data.frag;
    if ((frag == null ? void 0 : frag.type) === PlaylistLevelType.SUBTITLE) {
      if (data.details === ErrorDetails.FRAG_GAP) {
        this.fragmentTracker.fragBuffered(frag, true);
      }
      if (this.fragCurrent) {
        this.fragCurrent.abortRequests();
      }
      if (this.state !== State.STOPPED) {
        this.state = State.IDLE;
      }
    }
  }

  // Got all new subtitle levels.
  onSubtitleTracksUpdated(event, {
    subtitleTracks
  }) {
    if (this.levels && subtitleOptionsIdentical(this.levels, subtitleTracks)) {
      this.levels = subtitleTracks.map(mediaPlaylist => new Level(mediaPlaylist));
      return;
    }
    this.tracksBuffered = [];
    this.levels = subtitleTracks.map(mediaPlaylist => {
      const level = new Level(mediaPlaylist);
      this.tracksBuffered[level.id] = [];
      return level;
    });
    this.fragmentTracker.removeFragmentsInRange(0, Number.POSITIVE_INFINITY, PlaylistLevelType.SUBTITLE);
    this.fragPrevious = null;
    this.mediaBuffer = null;
  }
  onSubtitleTrackSwitch(event, data) {
    var _this$levels;
    this.currentTrackId = data.id;
    if (!((_this$levels = this.levels) != null && _this$levels.length) || this.currentTrackId === -1) {
      this.clearInterval();
      return;
    }

    // Check if track has the necessary details to load fragments
    const currentTrack = this.levels[this.currentTrackId];
    if (currentTrack != null && currentTrack.details) {
      this.mediaBuffer = this.mediaBufferTimeRanges;
    } else {
      this.mediaBuffer = null;
    }
    if (currentTrack && this.state !== State.STOPPED) {
      this.setInterval(TICK_INTERVAL$2);
    }
  }

  // Got a new set of subtitle fragments.
  onSubtitleTrackLoaded(event, data) {
    var _track$details;
    const {
      currentTrackId,
      levels
    } = this;
    const {
      details: newDetails,
      id: trackId
    } = data;
    if (!levels) {
      this.warn(`Subtitle tracks were reset while loading level ${trackId}`);
      return;
    }
    const track = levels[trackId];
    if (trackId >= levels.length || !track) {
      return;
    }
    this.log(`Subtitle track ${trackId} loaded [${newDetails.startSN},${newDetails.endSN}]${newDetails.lastPartSn ? `[part-${newDetails.lastPartSn}-${newDetails.lastPartIndex}]` : ''},duration:${newDetails.totalduration}`);
    this.mediaBuffer = this.mediaBufferTimeRanges;
    let sliding = 0;
    if (newDetails.live || (_track$details = track.details) != null && _track$details.live) {
      const mainDetails = this.mainDetails;
      if (newDetails.deltaUpdateFailed || !mainDetails) {
        return;
      }
      const mainSlidingStartFragment = mainDetails.fragments[0];
      if (!track.details) {
        if (newDetails.hasProgramDateTime && mainDetails.hasProgramDateTime) {
          alignMediaPlaylistByPDT(newDetails, mainDetails);
          sliding = newDetails.fragmentStart;
        } else if (mainSlidingStartFragment) {
          // line up live playlist with main so that fragments in range are loaded
          sliding = mainSlidingStartFragment.start;
          addSliding(newDetails, sliding);
        }
      } else {
        var _this$levelLastLoaded;
        sliding = this.alignPlaylists(newDetails, track.details, (_this$levelLastLoaded = this.levelLastLoaded) == null ? void 0 : _this$levelLastLoaded.details);
        if (sliding === 0 && mainSlidingStartFragment) {
          // realign with main when there is no overlap with last refresh
          sliding = mainSlidingStartFragment.start;
          addSliding(newDetails, sliding);
        }
      }
    }
    track.details = newDetails;
    this.levelLastLoaded = track;
    if (trackId !== currentTrackId) {
      return;
    }
    this.hls.trigger(Events.SUBTITLE_TRACK_UPDATED, {
      details: newDetails,
      id: trackId,
      groupId: data.groupId
    });

    // trigger handler right now
    this.tick();

    // If playlist is misaligned because of bad PDT or drift, delete details to resync with main on reload
    if (newDetails.live && !this.fragCurrent && this.media && this.state === State.IDLE) {
      const foundFrag = findFragmentByPTS(null, newDetails.fragments, this.media.currentTime, 0);
      if (!foundFrag) {
        this.warn('Subtitle playlist not aligned with playback');
        track.details = undefined;
      }
    }
  }
  _handleFragmentLoadComplete(fragLoadedData) {
    const {
      frag,
      payload
    } = fragLoadedData;
    const decryptData = frag.decryptdata;
    const hls = this.hls;
    if (this.fragContextChanged(frag)) {
      return;
    }
    // check to see if the payload needs to be decrypted
    if (payload && payload.byteLength > 0 && decryptData != null && decryptData.key && decryptData.iv && isFullSegmentEncryption(decryptData.method)) {
      const startTime = performance.now();
      // decrypt the subtitles
      this.decrypter.decrypt(new Uint8Array(payload), decryptData.key.buffer, decryptData.iv.buffer, getAesModeFromFullSegmentMethod(decryptData.method)).catch(err => {
        hls.trigger(Events.ERROR, {
          type: ErrorTypes.MEDIA_ERROR,
          details: ErrorDetails.FRAG_DECRYPT_ERROR,
          fatal: false,
          error: err,
          reason: err.message,
          frag
        });
        throw err;
      }).then(decryptedData => {
        const endTime = performance.now();
        hls.trigger(Events.FRAG_DECRYPTED, {
          frag,
          payload: decryptedData,
          stats: {
            tstart: startTime,
            tdecrypt: endTime
          }
        });
      }).catch(err => {
        this.warn(`${err.name}: ${err.message}`);
        this.state = State.IDLE;
      });
    }
  }
  doTick() {
    if (!this.media) {
      this.state = State.IDLE;
      return;
    }
    if (this.state === State.IDLE) {
      const {
        currentTrackId,
        levels
      } = this;
      const track = levels == null ? void 0 : levels[currentTrackId];
      if (!track || !levels.length || !track.details) {
        return;
      }
      if (this.waitForLive(track)) {
        return;
      }
      const {
        config
      } = this;
      const currentTime = this.getLoadPosition();
      const bufferedInfo = BufferHelper.bufferedInfo(this.tracksBuffered[this.currentTrackId] || [], currentTime, config.maxBufferHole);
      const {
        end: targetBufferTime,
        len: bufferLen
      } = bufferedInfo;
      const trackDetails = track.details;
      const maxBufLen = this.hls.maxBufferLength + trackDetails.levelTargetDuration;
      if (bufferLen > maxBufLen) {
        return;
      }
      const fragments = trackDetails.fragments;
      const fragLen = fragments.length;
      const end = trackDetails.edge;
      let foundFrag = null;
      const fragPrevious = this.fragPrevious;
      if (targetBufferTime < end) {
        const tolerance = config.maxFragLookUpTolerance;
        const lookupTolerance = targetBufferTime > end - tolerance ? 0 : tolerance;
        foundFrag = findFragmentByPTS(fragPrevious, fragments, Math.max(fragments[0].start, targetBufferTime), lookupTolerance);
        if (!foundFrag && fragPrevious && fragPrevious.start < fragments[0].start) {
          foundFrag = fragments[0];
        }
      } else {
        foundFrag = fragments[fragLen - 1];
      }
      foundFrag = this.filterReplacedPrimary(foundFrag, track.details);
      if (!foundFrag) {
        return;
      }
      // Load earlier fragment in same discontinuity to make up for misaligned playlists and cues that extend beyond end of segment
      const curSNIdx = foundFrag.sn - trackDetails.startSN;
      const prevFrag = fragments[curSNIdx - 1];
      if (prevFrag && prevFrag.cc === foundFrag.cc && this.fragmentTracker.getState(prevFrag) === FragmentState.NOT_LOADED) {
        foundFrag = prevFrag;
      }
      if (this.fragmentTracker.getState(foundFrag) === FragmentState.NOT_LOADED) {
        // only load if fragment is not loaded
        const fragToLoad = this.mapToInitFragWhenRequired(foundFrag);
        if (fragToLoad) {
          this.loadFragment(fragToLoad, track, targetBufferTime);
        }
      }
    }
  }
  loadFragment(frag, level, targetBufferTime) {
    if (!isMediaFragment(frag)) {
      this._loadInitSegment(frag, level);
    } else {
      super.loadFragment(frag, level, targetBufferTime);
    }
  }
  get mediaBufferTimeRanges() {
    return new BufferableInstance(this.tracksBuffered[this.currentTrackId] || []);
  }
}
class BufferableInstance {
  constructor(timeranges) {
    this.buffered = void 0;
    const getRange = (name, index, length) => {
      index = index >>> 0;
      if (index > length - 1) {
        throw new DOMException(`Failed to execute '${name}' on 'TimeRanges': The index provided (${index}) is greater than the maximum bound (${length})`);
      }
      return timeranges[index][name];
    };
    this.buffered = {
      get length() {
        return timeranges.length;
      },
      end(index) {
        return getRange('end', index, timeranges.length);
      },
      start(index) {
        return getRange('start', index, timeranges.length);
      }
    };
  }
}

/**
 *
 * This code was ported from the dash.js project at:
 *   https://github.com/Dash-Industry-Forum/dash.js/blob/development/externals/cea608-parser.js
 *   https://github.com/Dash-Industry-Forum/dash.js/commit/8269b26a761e0853bb21d78780ed945144ecdd4d#diff-71bc295a2d6b6b7093a1d3290d53a4b2
 *
 * The original copyright appears below:
 *
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2015-2016, DASH Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  1. Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  2. Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 *  Exceptions from regular ASCII. CodePoints are mapped to UTF-16 codes
 */

const specialCea608CharsCodes = {
  0x2a: 0xe1,
  // lowercase a, acute accent
  0x5c: 0xe9,
  // lowercase e, acute accent
  0x5e: 0xed,
  // lowercase i, acute accent
  0x5f: 0xf3,
  // lowercase o, acute accent
  0x60: 0xfa,
  // lowercase u, acute accent
  0x7b: 0xe7,
  // lowercase c with cedilla
  0x7c: 0xf7,
  // division symbol
  0x7d: 0xd1,
  // uppercase N tilde
  0x7e: 0xf1,
  // lowercase n tilde
  0x7f: 0x2588,
  // Full block
  // THIS BLOCK INCLUDES THE 16 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x11 AND LOW BETWEEN 0x30 AND 0x3F
  // THIS MEANS THAT \x50 MUST BE ADDED TO THE VALUES
  0x80: 0xae,
  // Registered symbol (R)
  0x81: 0xb0,
  // degree sign
  0x82: 0xbd,
  // 1/2 symbol
  0x83: 0xbf,
  // Inverted (open) question mark
  0x84: 0x2122,
  // Trademark symbol (TM)
  0x85: 0xa2,
  // Cents symbol
  0x86: 0xa3,
  // Pounds sterling
  0x87: 0x266a,
  // Music 8'th note
  0x88: 0xe0,
  // lowercase a, grave accent
  0x89: 0x20,
  // transparent space (regular)
  0x8a: 0xe8,
  // lowercase e, grave accent
  0x8b: 0xe2,
  // lowercase a, circumflex accent
  0x8c: 0xea,
  // lowercase e, circumflex accent
  0x8d: 0xee,
  // lowercase i, circumflex accent
  0x8e: 0xf4,
  // lowercase o, circumflex accent
  0x8f: 0xfb,
  // lowercase u, circumflex accent
  // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x12 AND LOW BETWEEN 0x20 AND 0x3F
  0x90: 0xc1,
  // capital letter A with acute
  0x91: 0xc9,
  // capital letter E with acute
  0x92: 0xd3,
  // capital letter O with acute
  0x93: 0xda,
  // capital letter U with acute
  0x94: 0xdc,
  // capital letter U with diaresis
  0x95: 0xfc,
  // lowercase letter U with diaeresis
  0x96: 0x2018,
  // opening single quote
  0x97: 0xa1,
  // inverted exclamation mark
  0x98: 0x2a,
  // asterisk
  0x99: 0x2019,
  // closing single quote
  0x9a: 0x2501,
  // box drawings heavy horizontal
  0x9b: 0xa9,
  // copyright sign
  0x9c: 0x2120,
  // Service mark
  0x9d: 0x2022,
  // (round) bullet
  0x9e: 0x201c,
  // Left double quotation mark
  0x9f: 0x201d,
  // Right double quotation mark
  0xa0: 0xc0,
  // uppercase A, grave accent
  0xa1: 0xc2,
  // uppercase A, circumflex
  0xa2: 0xc7,
  // uppercase C with cedilla
  0xa3: 0xc8,
  // uppercase E, grave accent
  0xa4: 0xca,
  // uppercase E, circumflex
  0xa5: 0xcb,
  // capital letter E with diaresis
  0xa6: 0xeb,
  // lowercase letter e with diaresis
  0xa7: 0xce,
  // uppercase I, circumflex
  0xa8: 0xcf,
  // uppercase I, with diaresis
  0xa9: 0xef,
  // lowercase i, with diaresis
  0xaa: 0xd4,
  // uppercase O, circumflex
  0xab: 0xd9,
  // uppercase U, grave accent
  0xac: 0xf9,
  // lowercase u, grave accent
  0xad: 0xdb,
  // uppercase U, circumflex
  0xae: 0xab,
  // left-pointing double angle quotation mark
  0xaf: 0xbb,
  // right-pointing double angle quotation mark
  // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x13 AND LOW BETWEEN 0x20 AND 0x3F
  0xb0: 0xc3,
  // Uppercase A, tilde
  0xb1: 0xe3,
  // Lowercase a, tilde
  0xb2: 0xcd,
  // Uppercase I, acute accent
  0xb3: 0xcc,
  // Uppercase I, grave accent
  0xb4: 0xec,
  // Lowercase i, grave accent
  0xb5: 0xd2,
  // Uppercase O, grave accent
  0xb6: 0xf2,
  // Lowercase o, grave accent
  0xb7: 0xd5,
  // Uppercase O, tilde
  0xb8: 0xf5,
  // Lowercase o, tilde
  0xb9: 0x7b,
  // Open curly brace
  0xba: 0x7d,
  // Closing curly brace
  0xbb: 0x5c,
  // Backslash
  0xbc: 0x5e,
  // Caret
  0xbd: 0x5f,
  // Underscore
  0xbe: 0x7c,
  // Pipe (vertical line)
  0xbf: 0x223c,
  // Tilde operator
  0xc0: 0xc4,
  // Uppercase A, umlaut
  0xc1: 0xe4,
  // Lowercase A, umlaut
  0xc2: 0xd6,
  // Uppercase O, umlaut
  0xc3: 0xf6,
  // Lowercase o, umlaut
  0xc4: 0xdf,
  // Esszett (sharp S)
  0xc5: 0xa5,
  // Yen symbol
  0xc6: 0xa4,
  // Generic currency sign
  0xc7: 0x2503,
  // Box drawings heavy vertical
  0xc8: 0xc5,
  // Uppercase A, ring
  0xc9: 0xe5,
  // Lowercase A, ring
  0xca: 0xd8,
  // Uppercase O, stroke
  0xcb: 0xf8,
  // Lowercase o, strok
  0xcc: 0x250f,
  // Box drawings heavy down and right
  0xcd: 0x2513,
  // Box drawings heavy down and left
  0xce: 0x2517,
  // Box drawings heavy up and right
  0xcf: 0x251b // Box drawings heavy up and left
};

/**
 * Utils
 */
const getCharForByte = byte => String.fromCharCode(specialCea608CharsCodes[byte] || byte);
const NR_ROWS = 15;
const NR_COLS = 100;
// Tables to look up row from PAC data
const rowsLowCh1 = {
  0x11: 1,
  0x12: 3,
  0x15: 5,
  0x16: 7,
  0x17: 9,
  0x10: 11,
  0x13: 12,
  0x14: 14
};
const rowsHighCh1 = {
  0x11: 2,
  0x12: 4,
  0x15: 6,
  0x16: 8,
  0x17: 10,
  0x13: 13,
  0x14: 15
};
const rowsLowCh2 = {
  0x19: 1,
  0x1a: 3,
  0x1d: 5,
  0x1e: 7,
  0x1f: 9,
  0x18: 11,
  0x1b: 12,
  0x1c: 14
};
const rowsHighCh2 = {
  0x19: 2,
  0x1a: 4,
  0x1d: 6,
  0x1e: 8,
  0x1f: 10,
  0x1b: 13,
  0x1c: 15
};
const backgroundColors = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta', 'black', 'transparent'];
class CaptionsLogger {
  constructor() {
    this.time = null;
    this.verboseLevel = 0;
  }
  log(severity, msg) {
    if (this.verboseLevel >= severity) {
      const m = typeof msg === 'function' ? msg() : msg;
      hls_logger.log(`${this.time} [${severity}] ${m}`);
    }
  }
}
const numArrayToHexArray = function numArrayToHexArray(numArray) {
  const hexArray = [];
  for (let j = 0; j < numArray.length; j++) {
    hexArray.push(numArray[j].toString(16));
  }
  return hexArray;
};
class PenState {
  constructor() {
    this.foreground = 'white';
    this.underline = false;
    this.italics = false;
    this.background = 'black';
    this.flash = false;
  }
  reset() {
    this.foreground = 'white';
    this.underline = false;
    this.italics = false;
    this.background = 'black';
    this.flash = false;
  }
  setStyles(styles) {
    const attribs = ['foreground', 'underline', 'italics', 'background', 'flash'];
    for (let i = 0; i < attribs.length; i++) {
      const style = attribs[i];
      if (styles.hasOwnProperty(style)) {
        this[style] = styles[style];
      }
    }
  }
  isDefault() {
    return this.foreground === 'white' && !this.underline && !this.italics && this.background === 'black' && !this.flash;
  }
  equals(other) {
    return this.foreground === other.foreground && this.underline === other.underline && this.italics === other.italics && this.background === other.background && this.flash === other.flash;
  }
  copy(newPenState) {
    this.foreground = newPenState.foreground;
    this.underline = newPenState.underline;
    this.italics = newPenState.italics;
    this.background = newPenState.background;
    this.flash = newPenState.flash;
  }
  toString() {
    return 'color=' + this.foreground + ', underline=' + this.underline + ', italics=' + this.italics + ', background=' + this.background + ', flash=' + this.flash;
  }
}

/**
 * Unicode character with styling and background.
 * @constructor
 */
class StyledUnicodeChar {
  constructor() {
    this.uchar = ' ';
    this.penState = new PenState();
  }
  reset() {
    this.uchar = ' ';
    this.penState.reset();
  }
  setChar(uchar, newPenState) {
    this.uchar = uchar;
    this.penState.copy(newPenState);
  }
  setPenState(newPenState) {
    this.penState.copy(newPenState);
  }
  equals(other) {
    return this.uchar === other.uchar && this.penState.equals(other.penState);
  }
  copy(newChar) {
    this.uchar = newChar.uchar;
    this.penState.copy(newChar.penState);
  }
  isEmpty() {
    return this.uchar === ' ' && this.penState.isDefault();
  }
}

/**
 * CEA-608 row consisting of NR_COLS instances of StyledUnicodeChar.
 * @constructor
 */
class hls_Row {
  constructor(logger) {
    this.chars = [];
    this.pos = 0;
    this.currPenState = new PenState();
    this.cueStartTime = null;
    this.logger = void 0;
    for (let i = 0; i < NR_COLS; i++) {
      this.chars.push(new StyledUnicodeChar());
    }
    this.logger = logger;
  }
  equals(other) {
    for (let i = 0; i < NR_COLS; i++) {
      if (!this.chars[i].equals(other.chars[i])) {
        return false;
      }
    }
    return true;
  }
  copy(other) {
    for (let i = 0; i < NR_COLS; i++) {
      this.chars[i].copy(other.chars[i]);
    }
  }
  isEmpty() {
    let empty = true;
    for (let i = 0; i < NR_COLS; i++) {
      if (!this.chars[i].isEmpty()) {
        empty = false;
        break;
      }
    }
    return empty;
  }

  /**
   *  Set the cursor to a valid column.
   */
  setCursor(absPos) {
    if (this.pos !== absPos) {
      this.pos = absPos;
    }
    if (this.pos < 0) {
      this.logger.log(3, 'Negative cursor position ' + this.pos);
      this.pos = 0;
    } else if (this.pos > NR_COLS) {
      this.logger.log(3, 'Too large cursor position ' + this.pos);
      this.pos = NR_COLS;
    }
  }

  /**
   * Move the cursor relative to current position.
   */
  moveCursor(relPos) {
    const newPos = this.pos + relPos;
    if (relPos > 1) {
      for (let i = this.pos + 1; i < newPos + 1; i++) {
        this.chars[i].setPenState(this.currPenState);
      }
    }
    this.setCursor(newPos);
  }

  /**
   * Backspace, move one step back and clear character.
   */
  backSpace() {
    this.moveCursor(-1);
    this.chars[this.pos].setChar(' ', this.currPenState);
  }
  insertChar(byte) {
    if (byte >= 0x90) {
      // Extended char
      this.backSpace();
    }
    const char = getCharForByte(byte);
    if (this.pos >= NR_COLS) {
      this.logger.log(0, () => 'Cannot insert ' + byte.toString(16) + ' (' + char + ') at position ' + this.pos + '. Skipping it!');
      return;
    }
    this.chars[this.pos].setChar(char, this.currPenState);
    this.moveCursor(1);
  }
  clearFromPos(startPos) {
    let i;
    for (i = startPos; i < NR_COLS; i++) {
      this.chars[i].reset();
    }
  }
  clear() {
    this.clearFromPos(0);
    this.pos = 0;
    this.currPenState.reset();
  }
  clearToEndOfRow() {
    this.clearFromPos(this.pos);
  }
  getTextString() {
    const chars = [];
    let empty = true;
    for (let i = 0; i < NR_COLS; i++) {
      const char = this.chars[i].uchar;
      if (char !== ' ') {
        empty = false;
      }
      chars.push(char);
    }
    if (empty) {
      return '';
    } else {
      return chars.join('');
    }
  }
  setPenStyles(styles) {
    this.currPenState.setStyles(styles);
    const currChar = this.chars[this.pos];
    currChar.setPenState(this.currPenState);
  }
}

/**
 * Keep a CEA-608 screen of 32x15 styled characters
 * @constructor
 */
class CaptionScreen {
  constructor(logger) {
    this.rows = [];
    this.currRow = NR_ROWS - 1;
    this.nrRollUpRows = null;
    this.lastOutputScreen = null;
    this.logger = void 0;
    for (let i = 0; i < NR_ROWS; i++) {
      this.rows.push(new hls_Row(logger));
    }
    this.logger = logger;
  }
  reset() {
    for (let i = 0; i < NR_ROWS; i++) {
      this.rows[i].clear();
    }
    this.currRow = NR_ROWS - 1;
  }
  equals(other) {
    let equal = true;
    for (let i = 0; i < NR_ROWS; i++) {
      if (!this.rows[i].equals(other.rows[i])) {
        equal = false;
        break;
      }
    }
    return equal;
  }
  copy(other) {
    for (let i = 0; i < NR_ROWS; i++) {
      this.rows[i].copy(other.rows[i]);
    }
  }
  isEmpty() {
    let empty = true;
    for (let i = 0; i < NR_ROWS; i++) {
      if (!this.rows[i].isEmpty()) {
        empty = false;
        break;
      }
    }
    return empty;
  }
  backSpace() {
    const row = this.rows[this.currRow];
    row.backSpace();
  }
  clearToEndOfRow() {
    const row = this.rows[this.currRow];
    row.clearToEndOfRow();
  }

  /**
   * Insert a character (without styling) in the current row.
   */
  insertChar(char) {
    const row = this.rows[this.currRow];
    row.insertChar(char);
  }
  setPen(styles) {
    const row = this.rows[this.currRow];
    row.setPenStyles(styles);
  }
  moveCursor(relPos) {
    const row = this.rows[this.currRow];
    row.moveCursor(relPos);
  }
  setCursor(absPos) {
    this.logger.log(2, 'setCursor: ' + absPos);
    const row = this.rows[this.currRow];
    row.setCursor(absPos);
  }
  setPAC(pacData) {
    this.logger.log(2, () => 'pacData = ' + hls_stringify(pacData));
    let newRow = pacData.row - 1;
    if (this.nrRollUpRows && newRow < this.nrRollUpRows - 1) {
      newRow = this.nrRollUpRows - 1;
    }

    // Make sure this only affects Roll-up Captions by checking this.nrRollUpRows
    if (this.nrRollUpRows && this.currRow !== newRow) {
      // clear all rows first
      for (let i = 0; i < NR_ROWS; i++) {
        this.rows[i].clear();
      }

      // Copy this.nrRollUpRows rows from lastOutputScreen and place it in the newRow location
      // topRowIndex - the start of rows to copy (inclusive index)
      const topRowIndex = this.currRow + 1 - this.nrRollUpRows;
      // We only copy if the last position was already shown.
      // We use the cueStartTime value to check this.
      const lastOutputScreen = this.lastOutputScreen;
      if (lastOutputScreen) {
        const prevLineTime = lastOutputScreen.rows[topRowIndex].cueStartTime;
        const time = this.logger.time;
        if (prevLineTime !== null && time !== null && prevLineTime < time) {
          for (let i = 0; i < this.nrRollUpRows; i++) {
            this.rows[newRow - this.nrRollUpRows + i + 1].copy(lastOutputScreen.rows[topRowIndex + i]);
          }
        }
      }
    }
    this.currRow = newRow;
    const row = this.rows[this.currRow];
    if (pacData.indent !== null) {
      const indent = pacData.indent;
      const prevPos = Math.max(indent - 1, 0);
      row.setCursor(pacData.indent);
      pacData.color = row.chars[prevPos].penState.foreground;
    }
    const styles = {
      foreground: pacData.color,
      underline: pacData.underline,
      italics: pacData.italics,
      background: 'black',
      flash: false
    };
    this.setPen(styles);
  }

  /**
   * Set background/extra foreground, but first do back_space, and then insert space (backwards compatibility).
   */
  setBkgData(bkgData) {
    this.logger.log(2, () => 'bkgData = ' + hls_stringify(bkgData));
    this.backSpace();
    this.setPen(bkgData);
    this.insertChar(0x20); // Space
  }
  setRollUpRows(nrRows) {
    this.nrRollUpRows = nrRows;
  }
  rollUp() {
    if (this.nrRollUpRows === null) {
      this.logger.log(3, 'roll_up but nrRollUpRows not set yet');
      return; // Not properly setup
    }
    this.logger.log(1, () => this.getDisplayText());
    const topRowIndex = this.currRow + 1 - this.nrRollUpRows;
    const topRow = this.rows.splice(topRowIndex, 1)[0];
    topRow.clear();
    this.rows.splice(this.currRow, 0, topRow);
    this.logger.log(2, 'Rolling up');
    // this.logger.log(VerboseLevel.TEXT, this.get_display_text())
  }

  /**
   * Get all non-empty rows with as unicode text.
   */
  getDisplayText(asOneRow) {
    asOneRow = asOneRow || false;
    const displayText = [];
    let text = '';
    let rowNr = -1;
    for (let i = 0; i < NR_ROWS; i++) {
      const rowText = this.rows[i].getTextString();
      if (rowText) {
        rowNr = i + 1;
        if (asOneRow) {
          displayText.push('Row ' + rowNr + ": '" + rowText + "'");
        } else {
          displayText.push(rowText.trim());
        }
      }
    }
    if (displayText.length > 0) {
      if (asOneRow) {
        text = '[' + displayText.join(' | ') + ']';
      } else {
        text = displayText.join('\n');
      }
    }
    return text;
  }
  getTextAndFormat() {
    return this.rows;
  }
}

// var modes = ['MODE_ROLL-UP', 'MODE_POP-ON', 'MODE_PAINT-ON', 'MODE_TEXT'];

class Cea608Channel {
  constructor(channelNumber, outputFilter, logger) {
    this.chNr = void 0;
    this.outputFilter = void 0;
    this.mode = void 0;
    this.verbose = void 0;
    this.displayedMemory = void 0;
    this.nonDisplayedMemory = void 0;
    this.lastOutputScreen = void 0;
    this.currRollUpRow = void 0;
    this.writeScreen = void 0;
    this.cueStartTime = void 0;
    this.logger = void 0;
    this.chNr = channelNumber;
    this.outputFilter = outputFilter;
    this.mode = null;
    this.verbose = 0;
    this.displayedMemory = new CaptionScreen(logger);
    this.nonDisplayedMemory = new CaptionScreen(logger);
    this.lastOutputScreen = new CaptionScreen(logger);
    this.currRollUpRow = this.displayedMemory.rows[NR_ROWS - 1];
    this.writeScreen = this.displayedMemory;
    this.mode = null;
    this.cueStartTime = null; // Keeps track of where a cue started.
    this.logger = logger;
  }
  reset() {
    this.mode = null;
    this.displayedMemory.reset();
    this.nonDisplayedMemory.reset();
    this.lastOutputScreen.reset();
    this.outputFilter.reset();
    this.currRollUpRow = this.displayedMemory.rows[NR_ROWS - 1];
    this.writeScreen = this.displayedMemory;
    this.mode = null;
    this.cueStartTime = null;
  }
  getHandler() {
    return this.outputFilter;
  }
  setHandler(newHandler) {
    this.outputFilter = newHandler;
  }
  setPAC(pacData) {
    this.writeScreen.setPAC(pacData);
  }
  setBkgData(bkgData) {
    this.writeScreen.setBkgData(bkgData);
  }
  setMode(newMode) {
    if (newMode === this.mode) {
      return;
    }
    this.mode = newMode;
    this.logger.log(2, () => 'MODE=' + newMode);
    if (this.mode === 'MODE_POP-ON') {
      this.writeScreen = this.nonDisplayedMemory;
    } else {
      this.writeScreen = this.displayedMemory;
      this.writeScreen.reset();
    }
    if (this.mode !== 'MODE_ROLL-UP') {
      this.displayedMemory.nrRollUpRows = null;
      this.nonDisplayedMemory.nrRollUpRows = null;
    }
    this.mode = newMode;
  }
  insertChars(chars) {
    for (let i = 0; i < chars.length; i++) {
      this.writeScreen.insertChar(chars[i]);
    }
    const screen = this.writeScreen === this.displayedMemory ? 'DISP' : 'NON_DISP';
    this.logger.log(2, () => screen + ': ' + this.writeScreen.getDisplayText(true));
    if (this.mode === 'MODE_PAINT-ON' || this.mode === 'MODE_ROLL-UP') {
      this.logger.log(1, () => 'DISPLAYED: ' + this.displayedMemory.getDisplayText(true));
      this.outputDataUpdate();
    }
  }
  ccRCL() {
    // Resume Caption Loading (switch mode to Pop On)
    this.logger.log(2, 'RCL - Resume Caption Loading');
    this.setMode('MODE_POP-ON');
  }
  ccBS() {
    // BackSpace
    this.logger.log(2, 'BS - BackSpace');
    if (this.mode === 'MODE_TEXT') {
      return;
    }
    this.writeScreen.backSpace();
    if (this.writeScreen === this.displayedMemory) {
      this.outputDataUpdate();
    }
  }
  ccAOF() {
    // Reserved (formerly Alarm Off)
  }
  ccAON() {
    // Reserved (formerly Alarm On)
  }
  ccDER() {
    // Delete to End of Row
    this.logger.log(2, 'DER- Delete to End of Row');
    this.writeScreen.clearToEndOfRow();
    this.outputDataUpdate();
  }
  ccRU(nrRows) {
    // Roll-Up Captions-2,3,or 4 Rows
    this.logger.log(2, 'RU(' + nrRows + ') - Roll Up');
    this.writeScreen = this.displayedMemory;
    this.setMode('MODE_ROLL-UP');
    this.writeScreen.setRollUpRows(nrRows);
  }
  ccFON() {
    // Flash On
    this.logger.log(2, 'FON - Flash On');
    this.writeScreen.setPen({
      flash: true
    });
  }
  ccRDC() {
    // Resume Direct Captioning (switch mode to PaintOn)
    this.logger.log(2, 'RDC - Resume Direct Captioning');
    this.setMode('MODE_PAINT-ON');
  }
  ccTR() {
    // Text Restart in text mode (not supported, however)
    this.logger.log(2, 'TR');
    this.setMode('MODE_TEXT');
  }
  ccRTD() {
    // Resume Text Display in Text mode (not supported, however)
    this.logger.log(2, 'RTD');
    this.setMode('MODE_TEXT');
  }
  ccEDM() {
    // Erase Displayed Memory
    this.logger.log(2, 'EDM - Erase Displayed Memory');
    this.displayedMemory.reset();
    this.outputDataUpdate(true);
  }
  ccCR() {
    // Carriage Return
    this.logger.log(2, 'CR - Carriage Return');
    this.writeScreen.rollUp();
    this.outputDataUpdate(true);
  }
  ccENM() {
    // Erase Non-Displayed Memory
    this.logger.log(2, 'ENM - Erase Non-displayed Memory');
    this.nonDisplayedMemory.reset();
  }
  ccEOC() {
    // End of Caption (Flip Memories)
    this.logger.log(2, 'EOC - End Of Caption');
    if (this.mode === 'MODE_POP-ON') {
      const tmp = this.displayedMemory;
      this.displayedMemory = this.nonDisplayedMemory;
      this.nonDisplayedMemory = tmp;
      this.writeScreen = this.nonDisplayedMemory;
      this.logger.log(1, () => 'DISP: ' + this.displayedMemory.getDisplayText());
    }
    this.outputDataUpdate(true);
  }
  ccTO(nrCols) {
    // Tab Offset 1,2, or 3 columns
    this.logger.log(2, 'TO(' + nrCols + ') - Tab Offset');
    this.writeScreen.moveCursor(nrCols);
  }
  ccMIDROW(secondByte) {
    // Parse MIDROW command
    const styles = {
      flash: false
    };
    styles.underline = secondByte % 2 === 1;
    styles.italics = secondByte >= 0x2e;
    if (!styles.italics) {
      const colorIndex = Math.floor(secondByte / 2) - 0x10;
      const colors = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta'];
      styles.foreground = colors[colorIndex];
    } else {
      styles.foreground = 'white';
    }
    this.logger.log(2, 'MIDROW: ' + hls_stringify(styles));
    this.writeScreen.setPen(styles);
  }
  outputDataUpdate(dispatch = false) {
    const time = this.logger.time;
    if (time === null) {
      return;
    }
    if (this.outputFilter) {
      if (this.cueStartTime === null && !this.displayedMemory.isEmpty()) {
        // Start of a new cue
        this.cueStartTime = time;
      } else {
        if (!this.displayedMemory.equals(this.lastOutputScreen)) {
          this.outputFilter.newCue(this.cueStartTime, time, this.lastOutputScreen);
          if (dispatch && this.outputFilter.dispatchCue) {
            this.outputFilter.dispatchCue();
          }
          this.cueStartTime = this.displayedMemory.isEmpty() ? null : time;
        }
      }
      this.lastOutputScreen.copy(this.displayedMemory);
    }
  }
  cueSplitAtTime(t) {
    if (this.outputFilter) {
      if (!this.displayedMemory.isEmpty()) {
        if (this.outputFilter.newCue) {
          this.outputFilter.newCue(this.cueStartTime, t, this.displayedMemory);
        }
        this.cueStartTime = t;
      }
    }
  }
}

// Will be 1 or 2 when parsing captions

class Cea608Parser {
  constructor(field, out1, out2) {
    this.channels = void 0;
    this.currentChannel = 0;
    this.cmdHistory = createCmdHistory();
    this.logger = void 0;
    const logger = this.logger = new CaptionsLogger();
    this.channels = [null, new Cea608Channel(field, out1, logger), new Cea608Channel(field + 1, out2, logger)];
  }
  getHandler(channel) {
    return this.channels[channel].getHandler();
  }
  setHandler(channel, newHandler) {
    this.channels[channel].setHandler(newHandler);
  }

  /**
   * Add data for time t in forms of list of bytes (unsigned ints). The bytes are treated as pairs.
   */
  addData(time, byteList) {
    this.logger.time = time;
    for (let i = 0; i < byteList.length; i += 2) {
      const a = byteList[i] & 0x7f;
      const b = byteList[i + 1] & 0x7f;
      let cmdFound = false;
      let charsFound = null;
      if (a === 0 && b === 0) {
        continue;
      } else {
        this.logger.log(3, () => '[' + numArrayToHexArray([byteList[i], byteList[i + 1]]) + '] -> (' + numArrayToHexArray([a, b]) + ')');
      }
      const cmdHistory = this.cmdHistory;
      const isControlCode = a >= 0x10 && a <= 0x1f;
      if (isControlCode) {
        // Skip redundant control codes
        if (hasCmdRepeated(a, b, cmdHistory)) {
          setLastCmd(null, null, cmdHistory);
          this.logger.log(3, () => 'Repeated command (' + numArrayToHexArray([a, b]) + ') is dropped');
          continue;
        }
        setLastCmd(a, b, this.cmdHistory);
        cmdFound = this.parseCmd(a, b);
        if (!cmdFound) {
          cmdFound = this.parseMidrow(a, b);
        }
        if (!cmdFound) {
          cmdFound = this.parsePAC(a, b);
        }
        if (!cmdFound) {
          cmdFound = this.parseBackgroundAttributes(a, b);
        }
      } else {
        setLastCmd(null, null, cmdHistory);
      }
      if (!cmdFound) {
        charsFound = this.parseChars(a, b);
        if (charsFound) {
          const currChNr = this.currentChannel;
          if (currChNr && currChNr > 0) {
            const channel = this.channels[currChNr];
            channel.insertChars(charsFound);
          } else {
            this.logger.log(2, 'No channel found yet. TEXT-MODE?');
          }
        }
      }
      if (!cmdFound && !charsFound) {
        this.logger.log(2, () => "Couldn't parse cleaned data " + numArrayToHexArray([a, b]) + ' orig: ' + numArrayToHexArray([byteList[i], byteList[i + 1]]));
      }
    }
  }

  /**
   * Parse Command.
   * @returns True if a command was found
   */
  parseCmd(a, b) {
    const cond1 = (a === 0x14 || a === 0x1c || a === 0x15 || a === 0x1d) && b >= 0x20 && b <= 0x2f;
    const cond2 = (a === 0x17 || a === 0x1f) && b >= 0x21 && b <= 0x23;
    if (!(cond1 || cond2)) {
      return false;
    }
    const chNr = a === 0x14 || a === 0x15 || a === 0x17 ? 1 : 2;
    const channel = this.channels[chNr];
    if (a === 0x14 || a === 0x15 || a === 0x1c || a === 0x1d) {
      if (b === 0x20) {
        channel.ccRCL();
      } else if (b === 0x21) {
        channel.ccBS();
      } else if (b === 0x22) {
        channel.ccAOF();
      } else if (b === 0x23) {
        channel.ccAON();
      } else if (b === 0x24) {
        channel.ccDER();
      } else if (b === 0x25) {
        channel.ccRU(2);
      } else if (b === 0x26) {
        channel.ccRU(3);
      } else if (b === 0x27) {
        channel.ccRU(4);
      } else if (b === 0x28) {
        channel.ccFON();
      } else if (b === 0x29) {
        channel.ccRDC();
      } else if (b === 0x2a) {
        channel.ccTR();
      } else if (b === 0x2b) {
        channel.ccRTD();
      } else if (b === 0x2c) {
        channel.ccEDM();
      } else if (b === 0x2d) {
        channel.ccCR();
      } else if (b === 0x2e) {
        channel.ccENM();
      } else if (b === 0x2f) {
        channel.ccEOC();
      }
    } else {
      // a == 0x17 || a == 0x1F
      channel.ccTO(b - 0x20);
    }
    this.currentChannel = chNr;
    return true;
  }

  /**
   * Parse midrow styling command
   */
  parseMidrow(a, b) {
    let chNr = 0;
    if ((a === 0x11 || a === 0x19) && b >= 0x20 && b <= 0x2f) {
      if (a === 0x11) {
        chNr = 1;
      } else {
        chNr = 2;
      }
      if (chNr !== this.currentChannel) {
        this.logger.log(0, 'Mismatch channel in midrow parsing');
        return false;
      }
      const channel = this.channels[chNr];
      if (!channel) {
        return false;
      }
      channel.ccMIDROW(b);
      this.logger.log(3, () => 'MIDROW (' + numArrayToHexArray([a, b]) + ')');
      return true;
    }
    return false;
  }

  /**
   * Parse Preable Access Codes (Table 53).
   * @returns {Boolean} Tells if PAC found
   */
  parsePAC(a, b) {
    let row;
    const case1 = (a >= 0x11 && a <= 0x17 || a >= 0x19 && a <= 0x1f) && b >= 0x40 && b <= 0x7f;
    const case2 = (a === 0x10 || a === 0x18) && b >= 0x40 && b <= 0x5f;
    if (!(case1 || case2)) {
      return false;
    }
    const chNr = a <= 0x17 ? 1 : 2;
    if (b >= 0x40 && b <= 0x5f) {
      row = chNr === 1 ? rowsLowCh1[a] : rowsLowCh2[a];
    } else {
      // 0x60 <= b <= 0x7F
      row = chNr === 1 ? rowsHighCh1[a] : rowsHighCh2[a];
    }
    const channel = this.channels[chNr];
    if (!channel) {
      return false;
    }
    channel.setPAC(this.interpretPAC(row, b));
    this.currentChannel = chNr;
    return true;
  }

  /**
   * Interpret the second byte of the pac, and return the information.
   * @returns pacData with style parameters
   */
  interpretPAC(row, byte) {
    let pacIndex;
    const pacData = {
      color: null,
      italics: false,
      indent: null,
      underline: false,
      row: row
    };
    if (byte > 0x5f) {
      pacIndex = byte - 0x60;
    } else {
      pacIndex = byte - 0x40;
    }
    pacData.underline = (pacIndex & 1) === 1;
    if (pacIndex <= 0xd) {
      pacData.color = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta', 'white'][Math.floor(pacIndex / 2)];
    } else if (pacIndex <= 0xf) {
      pacData.italics = true;
      pacData.color = 'white';
    } else {
      pacData.indent = Math.floor((pacIndex - 0x10) / 2) * 4;
    }
    return pacData; // Note that row has zero offset. The spec uses 1.
  }

  /**
   * Parse characters.
   * @returns An array with 1 to 2 codes corresponding to chars, if found. null otherwise.
   */
  parseChars(a, b) {
    let channelNr;
    let charCodes = null;
    let charCode1 = null;
    if (a >= 0x19) {
      channelNr = 2;
      charCode1 = a - 8;
    } else {
      channelNr = 1;
      charCode1 = a;
    }
    if (charCode1 >= 0x11 && charCode1 <= 0x13) {
      // Special character
      let oneCode;
      if (charCode1 === 0x11) {
        oneCode = b + 0x50;
      } else if (charCode1 === 0x12) {
        oneCode = b + 0x70;
      } else {
        oneCode = b + 0x90;
      }
      this.logger.log(2, () => "Special char '" + getCharForByte(oneCode) + "' in channel " + channelNr);
      charCodes = [oneCode];
    } else if (a >= 0x20 && a <= 0x7f) {
      charCodes = b === 0 ? [a] : [a, b];
    }
    if (charCodes) {
      this.logger.log(3, () => 'Char codes =  ' + numArrayToHexArray(charCodes).join(','));
    }
    return charCodes;
  }

  /**
   * Parse extended background attributes as well as new foreground color black.
   * @returns True if background attributes are found
   */
  parseBackgroundAttributes(a, b) {
    const case1 = (a === 0x10 || a === 0x18) && b >= 0x20 && b <= 0x2f;
    const case2 = (a === 0x17 || a === 0x1f) && b >= 0x2d && b <= 0x2f;
    if (!(case1 || case2)) {
      return false;
    }
    let index;
    const bkgData = {};
    if (a === 0x10 || a === 0x18) {
      index = Math.floor((b - 0x20) / 2);
      bkgData.background = backgroundColors[index];
      if (b % 2 === 1) {
        bkgData.background = bkgData.background + '_semi';
      }
    } else if (b === 0x2d) {
      bkgData.background = 'transparent';
    } else {
      bkgData.foreground = 'black';
      if (b === 0x2f) {
        bkgData.underline = true;
      }
    }
    const chNr = a <= 0x17 ? 1 : 2;
    const channel = this.channels[chNr];
    channel.setBkgData(bkgData);
    return true;
  }

  /**
   * Reset state of parser and its channels.
   */
  reset() {
    for (let i = 0; i < Object.keys(this.channels).length; i++) {
      const channel = this.channels[i];
      if (channel) {
        channel.reset();
      }
    }
    setLastCmd(null, null, this.cmdHistory);
  }

  /**
   * Trigger the generation of a cue, and the start of a new one if displayScreens are not empty.
   */
  cueSplitAtTime(t) {
    for (let i = 0; i < this.channels.length; i++) {
      const channel = this.channels[i];
      if (channel) {
        channel.cueSplitAtTime(t);
      }
    }
  }
}
function setLastCmd(a, b, cmdHistory) {
  cmdHistory.a = a;
  cmdHistory.b = b;
}
function hasCmdRepeated(a, b, cmdHistory) {
  return cmdHistory.a === a && cmdHistory.b === b;
}
function createCmdHistory() {
  return {
    a: null,
    b: null
  };
}

/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var VTTCue = (function () {
  if (optionalSelf != null && optionalSelf.VTTCue) {
    return self.VTTCue;
  }
  const AllowedDirections = ['', 'lr', 'rl'];
  const AllowedAlignments = ['start', 'middle', 'end', 'left', 'right'];
  function isAllowedValue(allowed, value) {
    if (typeof value !== 'string') {
      return false;
    }
    // necessary for assuring the generic conforms to the Array interface
    if (!Array.isArray(allowed)) {
      return false;
    }
    // reset the type so that the next narrowing works well
    const lcValue = value.toLowerCase();
    // use the allow list to narrow the type to a specific subset of strings
    if (~allowed.indexOf(lcValue)) {
      return lcValue;
    }
    return false;
  }
  function findDirectionSetting(value) {
    return isAllowedValue(AllowedDirections, value);
  }
  function findAlignSetting(value) {
    return isAllowedValue(AllowedAlignments, value);
  }
  function extend(obj, ...rest) {
    let i = 1;
    for (; i < arguments.length; i++) {
      const cobj = arguments[i];
      for (const p in cobj) {
        obj[p] = cobj[p];
      }
    }
    return obj;
  }
  function VTTCue(startTime, endTime, text) {
    const cue = this;
    const baseObj = {
      enumerable: true
    };
    /**
     * Shim implementation specific properties. These properties are not in
     * the spec.
     */

    // Lets us know when the VTTCue's data has changed in such a way that we need
    // to recompute its display state. This lets us compute its display state
    // lazily.
    cue.hasBeenReset = false;

    /**
     * VTTCue and TextTrackCue properties
     * http://dev.w3.org/html5/webvtt/#vttcue-interface
     */

    let _id = '';
    let _pauseOnExit = false;
    let _startTime = startTime;
    let _endTime = endTime;
    let _text = text;
    let _region = null;
    let _vertical = '';
    let _snapToLines = true;
    let _line = 'auto';
    let _lineAlign = 'start';
    let _position = 50;
    let _positionAlign = 'middle';
    let _size = 50;
    let _align = 'middle';
    Object.defineProperty(cue, 'id', extend({}, baseObj, {
      get: function () {
        return _id;
      },
      set: function (value) {
        _id = '' + value;
      }
    }));
    Object.defineProperty(cue, 'pauseOnExit', extend({}, baseObj, {
      get: function () {
        return _pauseOnExit;
      },
      set: function (value) {
        _pauseOnExit = !!value;
      }
    }));
    Object.defineProperty(cue, 'startTime', extend({}, baseObj, {
      get: function () {
        return _startTime;
      },
      set: function (value) {
        if (typeof value !== 'number') {
          throw new TypeError('Start time must be set to a number.');
        }
        _startTime = value;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'endTime', extend({}, baseObj, {
      get: function () {
        return _endTime;
      },
      set: function (value) {
        if (typeof value !== 'number') {
          throw new TypeError('End time must be set to a number.');
        }
        _endTime = value;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'text', extend({}, baseObj, {
      get: function () {
        return _text;
      },
      set: function (value) {
        _text = '' + value;
        this.hasBeenReset = true;
      }
    }));

    // todo: implement VTTRegion polyfill?
    Object.defineProperty(cue, 'region', extend({}, baseObj, {
      get: function () {
        return _region;
      },
      set: function (value) {
        _region = value;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'vertical', extend({}, baseObj, {
      get: function () {
        return _vertical;
      },
      set: function (value) {
        const setting = findDirectionSetting(value);
        // Have to check for false because the setting an be an empty string.
        if (setting === false) {
          throw new SyntaxError('An invalid or illegal string was specified.');
        }
        _vertical = setting;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'snapToLines', extend({}, baseObj, {
      get: function () {
        return _snapToLines;
      },
      set: function (value) {
        _snapToLines = !!value;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'line', extend({}, baseObj, {
      get: function () {
        return _line;
      },
      set: function (value) {
        if (typeof value !== 'number' && value !== 'auto') {
          throw new SyntaxError('An invalid number or illegal string was specified.');
        }
        _line = value;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'lineAlign', extend({}, baseObj, {
      get: function () {
        return _lineAlign;
      },
      set: function (value) {
        const setting = findAlignSetting(value);
        if (!setting) {
          throw new SyntaxError('An invalid or illegal string was specified.');
        }
        _lineAlign = setting;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'position', extend({}, baseObj, {
      get: function () {
        return _position;
      },
      set: function (value) {
        if (value < 0 || value > 100) {
          throw new Error('Position must be between 0 and 100.');
        }
        _position = value;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'positionAlign', extend({}, baseObj, {
      get: function () {
        return _positionAlign;
      },
      set: function (value) {
        const setting = findAlignSetting(value);
        if (!setting) {
          throw new SyntaxError('An invalid or illegal string was specified.');
        }
        _positionAlign = setting;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'size', extend({}, baseObj, {
      get: function () {
        return _size;
      },
      set: function (value) {
        if (value < 0 || value > 100) {
          throw new Error('Size must be between 0 and 100.');
        }
        _size = value;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'align', extend({}, baseObj, {
      get: function () {
        return _align;
      },
      set: function (value) {
        const setting = findAlignSetting(value);
        if (!setting) {
          throw new SyntaxError('An invalid or illegal string was specified.');
        }
        _align = setting;
        this.hasBeenReset = true;
      }
    }));

    /**
     * Other <track> spec defined properties
     */

    // http://www.whatwg.org/specs/web-apps/current-work/multipage/the-video-element.html#text-track-cue-display-state
    cue.displayState = undefined;
  }

  /**
   * VTTCue methods
   */

  VTTCue.prototype.getCueAsHTML = function () {
    // Assume WebVTT.convertCueToDOMTree is on the global.
    const WebVTT = self.WebVTT;
    return WebVTT.convertCueToDOMTree(self, this.text);
  };
  // this is a polyfill hack
  return VTTCue;
})();

/*
 * Source: https://github.com/mozilla/vtt.js/blob/master/dist/vtt.js
 */

class StringDecoder {
  decode(data, options) {
    if (!data) {
      return '';
    }
    if (typeof data !== 'string') {
      throw new Error('Error - expected string data.');
    }
    return decodeURIComponent(encodeURIComponent(data));
  }
}

// Try to parse input as a time stamp.
function parseTimeStamp(input) {
  function computeSeconds(h, m, s, f) {
    return (h | 0) * 3600 + (m | 0) * 60 + (s | 0) + parseFloat(f || 0);
  }
  const m = input.match(/^(?:(\d+):)?(\d{2}):(\d{2})(\.\d+)?/);
  if (!m) {
    return null;
  }
  if (parseFloat(m[2]) > 59) {
    // Timestamp takes the form of [hours]:[minutes].[milliseconds]
    // First position is hours as it's over 59.
    return computeSeconds(m[2], m[3], 0, m[4]);
  }
  // Timestamp takes the form of [hours (optional)]:[minutes]:[seconds].[milliseconds]
  return computeSeconds(m[1], m[2], m[3], m[4]);
}

// A settings object holds key/value pairs and will ignore anything but the first
// assignment to a specific key.
class hls_Settings {
  constructor() {
    this.values = Object.create(null);
  }
  // Only accept the first assignment to any key.
  set(k, v) {
    if (!this.get(k) && v !== '') {
      this.values[k] = v;
    }
  }
  // Return the value for a key, or a default value.
  // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
  // a number of possible default values as properties where 'defaultKey' is
  // the key of the property that will be chosen; otherwise it's assumed to be
  // a single value.
  get(k, dflt, defaultKey) {
    if (defaultKey) {
      return this.has(k) ? this.values[k] : dflt[defaultKey];
    }
    return this.has(k) ? this.values[k] : dflt;
  }
  // Check whether we have a value for a key.
  has(k) {
    return k in this.values;
  }
  // Accept a setting if its one of the given alternatives.
  alt(k, v, a) {
    for (let n = 0; n < a.length; ++n) {
      if (v === a[n]) {
        this.set(k, v);
        break;
      }
    }
  }
  // Accept a setting if its a valid (signed) integer.
  integer(k, v) {
    if (/^-?\d+$/.test(v)) {
      // integer
      this.set(k, parseInt(v, 10));
    }
  }
  // Accept a setting if its a valid percentage.
  percent(k, v) {
    if (/^([\d]{1,3})(\.[\d]*)?%$/.test(v)) {
      const percent = parseFloat(v);
      if (percent >= 0 && percent <= 100) {
        this.set(k, percent);
        return true;
      }
    }
    return false;
  }
}

// Helper function to parse input into groups separated by 'groupDelim', and
// interpret each group as a key/value pair separated by 'keyValueDelim'.
function parseOptions(input, callback, keyValueDelim, groupDelim) {
  const groups = groupDelim ? input.split(groupDelim) : [input];
  for (const i in groups) {
    if (typeof groups[i] !== 'string') {
      continue;
    }
    const kv = groups[i].split(keyValueDelim);
    if (kv.length !== 2) {
      continue;
    }
    const k = kv[0];
    const v = kv[1];
    callback(k, v);
  }
}
const defaults = new VTTCue(0, 0, '');
// 'middle' was changed to 'center' in the spec: https://github.com/w3c/webvtt/pull/244
//  Safari doesn't yet support this change, but FF and Chrome do.
const center = defaults.align === 'middle' ? 'middle' : 'center';
function parseCue(input, cue, regionList) {
  // Remember the original input if we need to throw an error.
  const oInput = input;
  // 4.1 WebVTT timestamp
  function consumeTimeStamp() {
    const ts = parseTimeStamp(input);
    if (ts === null) {
      throw new Error('Malformed timestamp: ' + oInput);
    }

    // Remove time stamp from input.
    input = input.replace(/^[^\sa-zA-Z-]+/, '');
    return ts;
  }

  // 4.4.2 WebVTT cue settings
  function consumeCueSettings(input, cue) {
    const settings = new hls_Settings();
    parseOptions(input, function (k, v) {
      let vals;
      switch (k) {
        case 'region':
          // Find the last region we parsed with the same region id.
          for (let i = regionList.length - 1; i >= 0; i--) {
            if (regionList[i].id === v) {
              settings.set(k, regionList[i].region);
              break;
            }
          }
          break;
        case 'vertical':
          settings.alt(k, v, ['rl', 'lr']);
          break;
        case 'line':
          vals = v.split(',');
          settings.integer(k, vals[0]);
          if (settings.percent(k, vals[0])) {
            settings.set('snapToLines', false);
          }
          settings.alt(k, vals[0], ['auto']);
          if (vals.length === 2) {
            settings.alt('lineAlign', vals[1], ['start', center, 'end']);
          }
          break;
        case 'position':
          vals = v.split(',');
          settings.percent(k, vals[0]);
          if (vals.length === 2) {
            settings.alt('positionAlign', vals[1], ['start', center, 'end', 'line-left', 'line-right', 'auto']);
          }
          break;
        case 'size':
          settings.percent(k, v);
          break;
        case 'align':
          settings.alt(k, v, ['start', center, 'end', 'left', 'right']);
          break;
      }
    }, /:/, /\s/);

    // Apply default values for any missing fields.
    cue.region = settings.get('region', null);
    cue.vertical = settings.get('vertical', '');
    let line = settings.get('line', 'auto');
    if (line === 'auto' && defaults.line === -1) {
      // set numeric line number for Safari
      line = -1;
    }
    cue.line = line;
    cue.lineAlign = settings.get('lineAlign', 'start');
    cue.snapToLines = settings.get('snapToLines', true);
    cue.size = settings.get('size', 100);
    cue.align = settings.get('align', center);
    let position = settings.get('position', 'auto');
    if (position === 'auto' && defaults.position === 50) {
      // set numeric position for Safari
      position = cue.align === 'start' || cue.align === 'left' ? 0 : cue.align === 'end' || cue.align === 'right' ? 100 : 50;
    }
    cue.position = position;
  }
  function skipWhitespace() {
    input = input.replace(/^\s+/, '');
  }

  // 4.1 WebVTT cue timings.
  skipWhitespace();
  cue.startTime = consumeTimeStamp(); // (1) collect cue start time
  skipWhitespace();
  if (input.slice(0, 3) !== '-->') {
    // (3) next characters must match '-->'
    throw new Error("Malformed time stamp (time stamps must be separated by '-->'): " + oInput);
  }
  input = input.slice(3);
  skipWhitespace();
  cue.endTime = consumeTimeStamp(); // (5) collect cue end time

  // 4.1 WebVTT cue settings list.
  skipWhitespace();
  consumeCueSettings(input, cue);
}
function fixLineBreaks(input) {
  return input.replace(/<br(?: \/)?>/gi, '\n');
}
class VTTParser {
  constructor() {
    this.state = 'INITIAL';
    this.buffer = '';
    this.decoder = new StringDecoder();
    this.regionList = [];
    this.cue = null;
    this.oncue = void 0;
    this.onparsingerror = void 0;
    this.onflush = void 0;
  }
  parse(data) {
    const _this = this;

    // If there is no data then we won't decode it, but will just try to parse
    // whatever is in buffer already. This may occur in circumstances, for
    // example when flush() is called.
    if (data) {
      // Try to decode the data that we received.
      _this.buffer += _this.decoder.decode(data, {
        stream: true
      });
    }
    function collectNextLine() {
      let buffer = _this.buffer;
      let pos = 0;
      buffer = fixLineBreaks(buffer);
      while (pos < buffer.length && buffer[pos] !== '\r' && buffer[pos] !== '\n') {
        ++pos;
      }
      const line = buffer.slice(0, pos);
      // Advance the buffer early in case we fail below.
      if (buffer[pos] === '\r') {
        ++pos;
      }
      if (buffer[pos] === '\n') {
        ++pos;
      }
      _this.buffer = buffer.slice(pos);
      return line;
    }

    // 3.2 WebVTT metadata header syntax
    function parseHeader(input) {
      parseOptions(input, function (k, v) {
        // switch (k) {
        // case 'region':
        // 3.3 WebVTT region metadata header syntax
        // console.log('parse region', v);
        // parseRegion(v);
        // break;
        // }
      }, /:/);
    }

    // 5.1 WebVTT file parsing.
    try {
      let line = '';
      if (_this.state === 'INITIAL') {
        // We can't start parsing until we have the first line.
        if (!/\r\n|\n/.test(_this.buffer)) {
          return this;
        }
        line = collectNextLine();
        // strip of UTF-8 BOM if any
        // https://en.wikipedia.org/wiki/Byte_order_mark#UTF-8
        const m = line.match(/^(ï»¿)?WEBVTT([ \t].*)?$/);
        if (!(m != null && m[0])) {
          throw new Error('Malformed WebVTT signature.');
        }
        _this.state = 'HEADER';
      }
      let alreadyCollectedLine = false;
      while (_this.buffer) {
        // We can't parse a line until we have the full line.
        if (!/\r\n|\n/.test(_this.buffer)) {
          return this;
        }
        if (!alreadyCollectedLine) {
          line = collectNextLine();
        } else {
          alreadyCollectedLine = false;
        }
        switch (_this.state) {
          case 'HEADER':
            // 13-18 - Allow a header (metadata) under the WEBVTT line.
            if (/:/.test(line)) {
              parseHeader(line);
            } else if (!line) {
              // An empty line terminates the header and starts the body (cues).
              _this.state = 'ID';
            }
            continue;
          case 'NOTE':
            // Ignore NOTE blocks.
            if (!line) {
              _this.state = 'ID';
            }
            continue;
          case 'ID':
            // Check for the start of NOTE blocks.
            if (/^NOTE($|[ \t])/.test(line)) {
              _this.state = 'NOTE';
              break;
            }
            // 19-29 - Allow any number of line terminators, then initialize new cue values.
            if (!line) {
              continue;
            }
            _this.cue = new VTTCue(0, 0, '');
            _this.state = 'CUE';
            // 30-39 - Check if self line contains an optional identifier or timing data.
            if (line.indexOf('-->') === -1) {
              _this.cue.id = line;
              continue;
            }
          // Process line as start of a cue.
          /* falls through */
          case 'CUE':
            // 40 - Collect cue timings and settings.
            if (!_this.cue) {
              _this.state = 'BADCUE';
              continue;
            }
            try {
              parseCue(line, _this.cue, _this.regionList);
            } catch (e) {
              // In case of an error ignore rest of the cue.
              _this.cue = null;
              _this.state = 'BADCUE';
              continue;
            }
            _this.state = 'CUETEXT';
            continue;
          case 'CUETEXT':
            {
              const hasSubstring = line.indexOf('-->') !== -1;
              // 34 - If we have an empty line then report the cue.
              // 35 - If we have the special substring '-->' then report the cue,
              // but do not collect the line as we need to process the current
              // one as a new cue.
              if (!line || hasSubstring && (alreadyCollectedLine = true)) {
                // We are done parsing self cue.
                if (_this.oncue && _this.cue) {
                  _this.oncue(_this.cue);
                }
                _this.cue = null;
                _this.state = 'ID';
                continue;
              }
              if (_this.cue === null) {
                continue;
              }
              if (_this.cue.text) {
                _this.cue.text += '\n';
              }
              _this.cue.text += line;
            }
            continue;
          case 'BADCUE':
            // 54-62 - Collect and discard the remaining cue.
            if (!line) {
              _this.state = 'ID';
            }
        }
      }
    } catch (e) {
      // If we are currently parsing a cue, report what we have.
      if (_this.state === 'CUETEXT' && _this.cue && _this.oncue) {
        _this.oncue(_this.cue);
      }
      _this.cue = null;
      // Enter BADWEBVTT state if header was not parsed correctly otherwise
      // another exception occurred so enter BADCUE state.
      _this.state = _this.state === 'INITIAL' ? 'BADWEBVTT' : 'BADCUE';
    }
    return this;
  }
  flush() {
    const _this = this;
    try {
      // Finish decoding the stream.
      // _this.buffer += _this.decoder.decode();
      // Synthesize the end of the current cue or region.
      if (_this.cue || _this.state === 'HEADER') {
        _this.buffer += '\n\n';
        _this.parse();
      }
      // If we've flushed, parsed, and we're still on the INITIAL state then
      // that means we don't have enough of the stream to parse the first
      // line.
      if (_this.state === 'INITIAL' || _this.state === 'BADWEBVTT') {
        throw new Error('Malformed WebVTT signature.');
      }
    } catch (e) {
      if (_this.onparsingerror) {
        _this.onparsingerror(e);
      }
    }
    if (_this.onflush) {
      _this.onflush();
    }
    return this;
  }
}

const LINEBREAKS = /\r\n|\n\r|\n|\r/g;

// String.prototype.startsWith is not supported in IE11
const startsWith = function startsWith(inputString, searchString, position = 0) {
  return inputString.slice(position, position + searchString.length) === searchString;
};
const cueString2millis = function cueString2millis(timeString) {
  let ts = parseInt(timeString.slice(-3));
  const secs = parseInt(timeString.slice(-6, -4));
  const mins = parseInt(timeString.slice(-9, -7));
  const hours = timeString.length > 9 ? parseInt(timeString.substring(0, timeString.indexOf(':'))) : 0;
  if (!isFiniteNumber(ts) || !isFiniteNumber(secs) || !isFiniteNumber(mins) || !isFiniteNumber(hours)) {
    throw Error(`Malformed X-TIMESTAMP-MAP: Local:${timeString}`);
  }
  ts += 1000 * secs;
  ts += 60 * 1000 * mins;
  ts += 60 * 60 * 1000 * hours;
  return ts;
};

// Create a unique hash id for a cue based on start/end times and text.
// This helps timeline-controller to avoid showing repeated captions.
function generateCueId(startTime, endTime, text) {
  return hash(startTime.toString()) + hash(endTime.toString()) + hash(text);
}
const calculateOffset = function calculateOffset(vttCCs, cc, presentationTime) {
  let currCC = vttCCs[cc];
  let prevCC = vttCCs[currCC.prevCC];

  // This is the first discontinuity or cues have been processed since the last discontinuity
  // Offset = current discontinuity time
  if (!prevCC || !prevCC.new && currCC.new) {
    vttCCs.ccOffset = vttCCs.presentationOffset = currCC.start;
    currCC.new = false;
    return;
  }

  // There have been discontinuities since cues were last parsed.
  // Offset = time elapsed
  while ((_prevCC = prevCC) != null && _prevCC.new) {
    var _prevCC;
    vttCCs.ccOffset += currCC.start - prevCC.start;
    currCC.new = false;
    currCC = prevCC;
    prevCC = vttCCs[currCC.prevCC];
  }
  vttCCs.presentationOffset = presentationTime;
};
function parseWebVTT(vttByteArray, initPTS, vttCCs, cc, timeOffset, callBack, errorCallBack) {
  const parser = new VTTParser();
  // Convert byteArray into string, replacing any somewhat exotic linefeeds with "\n", then split on that character.
  // Uint8Array.prototype.reduce is not implemented in IE11
  const vttLines = utf8ArrayToStr(new Uint8Array(vttByteArray)).trim().replace(LINEBREAKS, '\n').split('\n');
  const cues = [];
  const init90kHz = initPTS ? toMpegTsClockFromTimescale(initPTS.baseTime, initPTS.timescale) : 0;
  let cueTime = '00:00.000';
  let timestampMapMPEGTS = 0;
  let timestampMapLOCAL = 0;
  let parsingError;
  let inHeader = true;
  parser.oncue = function (cue) {
    // Adjust cue timing; clamp cues to start no earlier than - and drop cues that don't end after - 0 on timeline.
    const currCC = vttCCs[cc];
    let cueOffset = vttCCs.ccOffset;

    // Calculate subtitle PTS offset
    const webVttMpegTsMapOffset = (timestampMapMPEGTS - init90kHz) / 90000;

    // Update offsets for new discontinuities
    if (currCC != null && currCC.new) {
      if (timestampMapLOCAL !== undefined) {
        // When local time is provided, offset = discontinuity start time - local time
        cueOffset = vttCCs.ccOffset = currCC.start;
      } else {
        calculateOffset(vttCCs, cc, webVttMpegTsMapOffset);
      }
    }
    if (webVttMpegTsMapOffset) {
      if (!initPTS) {
        parsingError = new Error('Missing initPTS for VTT MPEGTS');
        return;
      }
      // If we have MPEGTS, offset = presentation time + discontinuity offset
      cueOffset = webVttMpegTsMapOffset - vttCCs.presentationOffset;
    }
    const duration = cue.endTime - cue.startTime;
    const startTime = normalizePts((cue.startTime + cueOffset - timestampMapLOCAL) * 90000, timeOffset * 90000) / 90000;
    cue.startTime = Math.max(startTime, 0);
    cue.endTime = Math.max(startTime + duration, 0);

    //trim trailing webvtt block whitespaces
    const text = cue.text.trim();

    // Fix encoding of special characters
    cue.text = decodeURIComponent(encodeURIComponent(text));

    // If the cue was not assigned an id from the VTT file (line above the content), create one.
    if (!cue.id) {
      cue.id = generateCueId(cue.startTime, cue.endTime, text);
    }
    if (cue.endTime > 0) {
      cues.push(cue);
    }
  };
  parser.onparsingerror = function (error) {
    parsingError = error;
  };
  parser.onflush = function () {
    if (parsingError) {
      errorCallBack(parsingError);
      return;
    }
    callBack(cues);
  };

  // Go through contents line by line.
  vttLines.forEach(line => {
    if (inHeader) {
      // Look for X-TIMESTAMP-MAP in header.
      if (startsWith(line, 'X-TIMESTAMP-MAP=')) {
        // Once found, no more are allowed anyway, so stop searching.
        inHeader = false;
        // Extract LOCAL and MPEGTS.
        line.slice(16).split(',').forEach(timestamp => {
          if (startsWith(timestamp, 'LOCAL:')) {
            cueTime = timestamp.slice(6);
          } else if (startsWith(timestamp, 'MPEGTS:')) {
            timestampMapMPEGTS = parseInt(timestamp.slice(7));
          }
        });
        try {
          // Convert cue time to seconds
          timestampMapLOCAL = cueString2millis(cueTime) / 1000;
        } catch (error) {
          parsingError = error;
        }
        // Return without parsing X-TIMESTAMP-MAP line.
        return;
      } else if (line === '') {
        inHeader = false;
      }
    }
    // Parse line by default.
    parser.parse(line + '\n');
  });
  parser.flush();
}

const IMSC1_CODEC = 'stpp.ttml.im1t';

// Time format: h:m:s:frames(.subframes)
const HMSF_REGEX = /^(\d{2,}):(\d{2}):(\d{2}):(\d{2})\.?(\d+)?$/;

// Time format: hours, minutes, seconds, milliseconds, frames, ticks
const TIME_UNIT_REGEX = /^(\d*(?:\.\d*)?)(h|m|s|ms|f|t)$/;
const textAlignToLineAlign = {
  left: 'start',
  center: 'center',
  right: 'end',
  start: 'start',
  end: 'end'
};
function parseIMSC1(payload, initPTS, callBack, errorCallBack) {
  const results = findBox(new Uint8Array(payload), ['mdat']);
  if (results.length === 0) {
    errorCallBack(new Error('Could not parse IMSC1 mdat'));
    return;
  }
  const ttmlList = results.map(mdat => utf8ArrayToStr(mdat));
  const syncTime = toTimescaleFromScale(initPTS.baseTime, 1, initPTS.timescale);
  try {
    ttmlList.forEach(ttml => callBack(parseTTML(ttml, syncTime)));
  } catch (error) {
    errorCallBack(error);
  }
}
function parseTTML(ttml, syncTime) {
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(ttml, 'text/xml');
  const tt = xmlDoc.getElementsByTagName('tt')[0];
  if (!tt) {
    throw new Error('Invalid ttml');
  }
  const defaultRateInfo = {
    frameRate: 30,
    subFrameRate: 1,
    frameRateMultiplier: 0,
    tickRate: 0
  };
  const rateInfo = Object.keys(defaultRateInfo).reduce((result, key) => {
    result[key] = tt.getAttribute(`ttp:${key}`) || defaultRateInfo[key];
    return result;
  }, {});
  const trim = tt.getAttribute('xml:space') !== 'preserve';
  const styleElements = collectionToDictionary(getElementCollection(tt, 'styling', 'style'));
  const regionElements = collectionToDictionary(getElementCollection(tt, 'layout', 'region'));
  const cueElements = getElementCollection(tt, 'body', '[begin]');
  return [].map.call(cueElements, cueElement => {
    const cueText = getTextContent(cueElement, trim);
    if (!cueText || !cueElement.hasAttribute('begin')) {
      return null;
    }
    const startTime = parseTtmlTime(cueElement.getAttribute('begin'), rateInfo);
    const duration = parseTtmlTime(cueElement.getAttribute('dur'), rateInfo);
    let endTime = parseTtmlTime(cueElement.getAttribute('end'), rateInfo);
    if (startTime === null) {
      throw timestampParsingError(cueElement);
    }
    if (endTime === null) {
      if (duration === null) {
        throw timestampParsingError(cueElement);
      }
      endTime = startTime + duration;
    }
    const cue = new VTTCue(startTime - syncTime, endTime - syncTime, cueText);
    cue.id = generateCueId(cue.startTime, cue.endTime, cue.text);
    const region = regionElements[cueElement.getAttribute('region')];
    const style = styleElements[cueElement.getAttribute('style')];

    // Apply styles to cue
    const styles = getTtmlStyles(region, style, styleElements);
    const {
      textAlign
    } = styles;
    if (textAlign) {
      // cue.positionAlign not settable in FF~2016
      const lineAlign = textAlignToLineAlign[textAlign];
      if (lineAlign) {
        cue.lineAlign = lineAlign;
      }
      cue.align = textAlign;
    }
    _extends(cue, styles);
    return cue;
  }).filter(cue => cue !== null);
}
function getElementCollection(fromElement, parentName, childName) {
  const parent = fromElement.getElementsByTagName(parentName)[0];
  if (parent) {
    return [].slice.call(parent.querySelectorAll(childName));
  }
  return [];
}
function collectionToDictionary(elementsWithId) {
  return elementsWithId.reduce((dict, element) => {
    const id = element.getAttribute('xml:id');
    if (id) {
      dict[id] = element;
    }
    return dict;
  }, {});
}
function getTextContent(element, trim) {
  return [].slice.call(element.childNodes).reduce((str, node, i) => {
    var _node$childNodes;
    if (node.nodeName === 'br' && i) {
      return str + '\n';
    }
    if ((_node$childNodes = node.childNodes) != null && _node$childNodes.length) {
      return getTextContent(node, trim);
    } else if (trim) {
      return str + node.textContent.trim().replace(/\s+/g, ' ');
    }
    return str + node.textContent;
  }, '');
}
function getTtmlStyles(region, style, styleElements) {
  const ttsNs = 'http://www.w3.org/ns/ttml#styling';
  let regionStyle = null;
  const styleAttributes = ['displayAlign', 'textAlign', 'color', 'backgroundColor', 'fontSize', 'fontFamily'
  // 'fontWeight',
  // 'lineHeight',
  // 'wrapOption',
  // 'fontStyle',
  // 'direction',
  // 'writingMode'
  ];
  const regionStyleName = region != null && region.hasAttribute('style') ? region.getAttribute('style') : null;
  if (regionStyleName && styleElements.hasOwnProperty(regionStyleName)) {
    regionStyle = styleElements[regionStyleName];
  }
  return styleAttributes.reduce((styles, name) => {
    const value = getAttributeNS(style, ttsNs, name) || getAttributeNS(region, ttsNs, name) || getAttributeNS(regionStyle, ttsNs, name);
    if (value) {
      styles[name] = value;
    }
    return styles;
  }, {});
}
function getAttributeNS(element, ns, name) {
  if (!element) {
    return null;
  }
  return element.hasAttributeNS(ns, name) ? element.getAttributeNS(ns, name) : null;
}
function timestampParsingError(node) {
  return new Error(`Could not parse ttml timestamp ${node}`);
}
function parseTtmlTime(timeAttributeValue, rateInfo) {
  if (!timeAttributeValue) {
    return null;
  }
  let seconds = parseTimeStamp(timeAttributeValue);
  if (seconds === null) {
    if (HMSF_REGEX.test(timeAttributeValue)) {
      seconds = parseHoursMinutesSecondsFrames(timeAttributeValue, rateInfo);
    } else if (TIME_UNIT_REGEX.test(timeAttributeValue)) {
      seconds = parseTimeUnits(timeAttributeValue, rateInfo);
    }
  }
  return seconds;
}
function parseHoursMinutesSecondsFrames(timeAttributeValue, rateInfo) {
  const m = HMSF_REGEX.exec(timeAttributeValue);
  const frames = (m[4] | 0) + (m[5] | 0) / rateInfo.subFrameRate;
  return (m[1] | 0) * 3600 + (m[2] | 0) * 60 + (m[3] | 0) + frames / rateInfo.frameRate;
}
function parseTimeUnits(timeAttributeValue, rateInfo) {
  const m = TIME_UNIT_REGEX.exec(timeAttributeValue);
  const value = Number(m[1]);
  const unit = m[2];
  switch (unit) {
    case 'h':
      return value * 3600;
    case 'm':
      return value * 60;
    case 'ms':
      return value * 1000;
    case 'f':
      return value / rateInfo.frameRate;
    case 't':
      return value / rateInfo.tickRate;
  }
  return value;
}

class OutputFilter {
  constructor(timelineController, trackName) {
    this.timelineController = void 0;
    this.cueRanges = [];
    this.trackName = void 0;
    this.startTime = null;
    this.endTime = null;
    this.screen = null;
    this.timelineController = timelineController;
    this.trackName = trackName;
  }
  dispatchCue() {
    if (this.startTime === null) {
      return;
    }
    this.timelineController.addCues(this.trackName, this.startTime, this.endTime, this.screen, this.cueRanges);
    this.startTime = null;
  }
  newCue(startTime, endTime, screen) {
    if (this.startTime === null || this.startTime > startTime) {
      this.startTime = startTime;
    }
    this.endTime = endTime;
    this.screen = screen;
    this.timelineController.createCaptionsTrack(this.trackName);
  }
  reset() {
    this.cueRanges = [];
    this.startTime = null;
  }
}

class TimelineController {
  constructor(hls) {
    this.hls = void 0;
    this.media = null;
    this.config = void 0;
    this.enabled = true;
    this.Cues = void 0;
    this.textTracks = [];
    this.tracks = [];
    this.initPTS = [];
    this.unparsedVttFrags = [];
    this.captionsTracks = {};
    this.nonNativeCaptionsTracks = {};
    this.cea608Parser1 = void 0;
    this.cea608Parser2 = void 0;
    this.lastCc = -1;
    // Last video (CEA-608) fragment CC
    this.lastSn = -1;
    // Last video (CEA-608) fragment MSN
    this.lastPartIndex = -1;
    // Last video (CEA-608) fragment Part Index
    this.prevCC = -1;
    // Last subtitle fragment CC
    this.vttCCs = newVTTCCs();
    this.captionsProperties = void 0;
    this.hls = hls;
    this.config = hls.config;
    this.Cues = hls.config.cueHandler;
    this.captionsProperties = {
      textTrack1: {
        label: this.config.captionsTextTrack1Label,
        languageCode: this.config.captionsTextTrack1LanguageCode
      },
      textTrack2: {
        label: this.config.captionsTextTrack2Label,
        languageCode: this.config.captionsTextTrack2LanguageCode
      },
      textTrack3: {
        label: this.config.captionsTextTrack3Label,
        languageCode: this.config.captionsTextTrack3LanguageCode
      },
      textTrack4: {
        label: this.config.captionsTextTrack4Label,
        languageCode: this.config.captionsTextTrack4LanguageCode
      }
    };
    hls.on(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
    hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
    hls.on(Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this);
    hls.on(Events.FRAG_LOADING, this.onFragLoading, this);
    hls.on(Events.FRAG_LOADED, this.onFragLoaded, this);
    hls.on(Events.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this);
    hls.on(Events.FRAG_DECRYPTED, this.onFragDecrypted, this);
    hls.on(Events.INIT_PTS_FOUND, this.onInitPtsFound, this);
    hls.on(Events.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this);
    hls.on(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
  }
  destroy() {
    const {
      hls
    } = this;
    hls.off(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
    hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
    hls.off(Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this);
    hls.off(Events.FRAG_LOADING, this.onFragLoading, this);
    hls.off(Events.FRAG_LOADED, this.onFragLoaded, this);
    hls.off(Events.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this);
    hls.off(Events.FRAG_DECRYPTED, this.onFragDecrypted, this);
    hls.off(Events.INIT_PTS_FOUND, this.onInitPtsFound, this);
    hls.off(Events.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this);
    hls.off(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
    // @ts-ignore
    this.hls = this.config = this.media = null;
    this.cea608Parser1 = this.cea608Parser2 = undefined;
  }
  initCea608Parsers() {
    const channel1 = new OutputFilter(this, 'textTrack1');
    const channel2 = new OutputFilter(this, 'textTrack2');
    const channel3 = new OutputFilter(this, 'textTrack3');
    const channel4 = new OutputFilter(this, 'textTrack4');
    this.cea608Parser1 = new Cea608Parser(1, channel1, channel2);
    this.cea608Parser2 = new Cea608Parser(3, channel3, channel4);
  }
  addCues(trackName, startTime, endTime, screen, cueRanges) {
    // skip cues which overlap more than 50% with previously parsed time ranges
    let merged = false;
    for (let i = cueRanges.length; i--;) {
      const cueRange = cueRanges[i];
      const overlap = intersection(cueRange[0], cueRange[1], startTime, endTime);
      if (overlap >= 0) {
        cueRange[0] = Math.min(cueRange[0], startTime);
        cueRange[1] = Math.max(cueRange[1], endTime);
        merged = true;
        if (overlap / (endTime - startTime) > 0.5) {
          return;
        }
      }
    }
    if (!merged) {
      cueRanges.push([startTime, endTime]);
    }
    if (this.config.renderTextTracksNatively) {
      const track = this.captionsTracks[trackName];
      this.Cues.newCue(track, startTime, endTime, screen);
    } else {
      const cues = this.Cues.newCue(null, startTime, endTime, screen);
      this.hls.trigger(Events.CUES_PARSED, {
        type: 'captions',
        cues,
        track: trackName
      });
    }
  }

  // Triggered when an initial PTS is found; used for synchronisation of WebVTT.
  onInitPtsFound(event, {
    frag,
    id,
    initPTS,
    timescale
  }) {
    const {
      unparsedVttFrags
    } = this;
    if (id === PlaylistLevelType.MAIN) {
      this.initPTS[frag.cc] = {
        baseTime: initPTS,
        timescale
      };
    }

    // Due to asynchronous processing, initial PTS may arrive later than the first VTT fragments are loaded.
    // Parse any unparsed fragments upon receiving the initial PTS.
    if (unparsedVttFrags.length) {
      this.unparsedVttFrags = [];
      unparsedVttFrags.forEach(frag => {
        this.onFragLoaded(Events.FRAG_LOADED, frag);
      });
    }
  }
  getExistingTrack(label, language) {
    const {
      media
    } = this;
    if (media) {
      for (let i = 0; i < media.textTracks.length; i++) {
        const textTrack = media.textTracks[i];
        if (canReuseVttTextTrack(textTrack, {
          name: label,
          lang: language,
          characteristics: 'transcribes-spoken-dialog,describes-music-and-sound'})) {
          return textTrack;
        }
      }
    }
    return null;
  }
  createCaptionsTrack(trackName) {
    if (this.config.renderTextTracksNatively) {
      this.createNativeTrack(trackName);
    } else {
      this.createNonNativeTrack(trackName);
    }
  }
  createNativeTrack(trackName) {
    if (this.captionsTracks[trackName]) {
      return;
    }
    const {
      captionsProperties,
      captionsTracks,
      media
    } = this;
    const {
      label,
      languageCode
    } = captionsProperties[trackName];
    // Enable reuse of existing text track.
    const existingTrack = this.getExistingTrack(label, languageCode);
    if (!existingTrack) {
      const textTrack = this.createTextTrack('captions', label, languageCode);
      if (textTrack) {
        // Set a special property on the track so we know it's managed by Hls.js
        textTrack[trackName] = true;
        captionsTracks[trackName] = textTrack;
      }
    } else {
      captionsTracks[trackName] = existingTrack;
      clearCurrentCues(captionsTracks[trackName]);
      sendAddTrackEvent(captionsTracks[trackName], media);
    }
  }
  createNonNativeTrack(trackName) {
    if (this.nonNativeCaptionsTracks[trackName]) {
      return;
    }
    // Create a list of a single track for the provider to consume
    const trackProperties = this.captionsProperties[trackName];
    if (!trackProperties) {
      return;
    }
    const label = trackProperties.label;
    const track = {
      _id: trackName,
      label,
      kind: 'captions',
      default: trackProperties.media ? !!trackProperties.media.default : false,
      closedCaptions: trackProperties.media
    };
    this.nonNativeCaptionsTracks[trackName] = track;
    this.hls.trigger(Events.NON_NATIVE_TEXT_TRACKS_FOUND, {
      tracks: [track]
    });
  }
  createTextTrack(kind, label, lang) {
    const media = this.media;
    if (!media) {
      return;
    }
    return media.addTextTrack(kind, label, lang);
  }
  onMediaAttaching(event, data) {
    this.media = data.media;
    if (!data.mediaSource) {
      this._cleanTracks();
    }
  }
  onMediaDetaching(event, data) {
    const transferringMedia = !!data.transferMedia;
    this.media = null;
    if (transferringMedia) {
      return;
    }
    const {
      captionsTracks
    } = this;
    Object.keys(captionsTracks).forEach(trackName => {
      clearCurrentCues(captionsTracks[trackName]);
      delete captionsTracks[trackName];
    });
    this.nonNativeCaptionsTracks = {};
  }
  onManifestLoading() {
    // Detect discontinuity in video fragment (CEA-608) parsing
    this.lastCc = -1;
    this.lastSn = -1;
    this.lastPartIndex = -1;
    // Detect discontinuity in subtitle manifests
    this.prevCC = -1;
    this.vttCCs = newVTTCCs();
    // Reset tracks
    this._cleanTracks();
    this.tracks = [];
    this.captionsTracks = {};
    this.nonNativeCaptionsTracks = {};
    this.textTracks = [];
    this.unparsedVttFrags = [];
    this.initPTS = [];
    if (this.cea608Parser1 && this.cea608Parser2) {
      this.cea608Parser1.reset();
      this.cea608Parser2.reset();
    }
  }
  _cleanTracks() {
    // clear outdated subtitles
    const {
      media
    } = this;
    if (!media) {
      return;
    }
    const textTracks = media.textTracks;
    if (textTracks) {
      for (let i = 0; i < textTracks.length; i++) {
        clearCurrentCues(textTracks[i]);
      }
    }
  }
  onSubtitleTracksUpdated(event, data) {
    const tracks = data.subtitleTracks || [];
    const hasIMSC1 = tracks.some(track => track.textCodec === IMSC1_CODEC);
    if (this.config.enableWebVTT || hasIMSC1 && this.config.enableIMSC1) {
      const listIsIdentical = subtitleOptionsIdentical(this.tracks, tracks);
      if (listIsIdentical) {
        this.tracks = tracks;
        return;
      }
      this.textTracks = [];
      this.tracks = tracks;
      if (this.config.renderTextTracksNatively) {
        const media = this.media;
        const inUseTracks = media ? filterSubtitleTracks(media.textTracks) : null;
        this.tracks.forEach((track, index) => {
          // Reuse tracks with the same label and lang, but do not reuse 608/708 tracks
          let textTrack;
          if (inUseTracks) {
            let inUseTrack = null;
            for (let i = 0; i < inUseTracks.length; i++) {
              if (inUseTracks[i] && canReuseVttTextTrack(inUseTracks[i], track)) {
                inUseTrack = inUseTracks[i];
                inUseTracks[i] = null;
                break;
              }
            }
            if (inUseTrack) {
              textTrack = inUseTrack;
            }
          }
          if (textTrack) {
            clearCurrentCues(textTrack);
          } else {
            const textTrackKind = captionsOrSubtitlesFromCharacteristics(track);
            textTrack = this.createTextTrack(textTrackKind, track.name, track.lang);
            if (textTrack) {
              textTrack.mode = 'disabled';
            }
          }
          if (textTrack) {
            this.textTracks.push(textTrack);
          }
        });
        // Warn when video element has captions or subtitle TextTracks carried over from another source
        if (inUseTracks != null && inUseTracks.length) {
          const unusedTextTracks = inUseTracks.filter(t => t !== null).map(t => t.label);
          if (unusedTextTracks.length) {
            this.hls.logger.warn(`Media element contains unused subtitle tracks: ${unusedTextTracks.join(', ')}. Replace media element for each source to clear TextTracks and captions menu.`);
          }
        }
      } else if (this.tracks.length) {
        // Create a list of tracks for the provider to consume
        const tracksList = this.tracks.map(track => {
          return {
            label: track.name,
            kind: track.type.toLowerCase(),
            default: track.default,
            subtitleTrack: track
          };
        });
        this.hls.trigger(Events.NON_NATIVE_TEXT_TRACKS_FOUND, {
          tracks: tracksList
        });
      }
    }
  }
  onManifestLoaded(event, data) {
    if (this.config.enableCEA708Captions && data.captions) {
      data.captions.forEach(captionsTrack => {
        const instreamIdMatch = /(?:CC|SERVICE)([1-4])/.exec(captionsTrack.instreamId);
        if (!instreamIdMatch) {
          return;
        }
        const trackName = `textTrack${instreamIdMatch[1]}`;
        const trackProperties = this.captionsProperties[trackName];
        if (!trackProperties) {
          return;
        }
        trackProperties.label = captionsTrack.name;
        if (captionsTrack.lang) {
          // optional attribute
          trackProperties.languageCode = captionsTrack.lang;
        }
        trackProperties.media = captionsTrack;
      });
    }
  }
  closedCaptionsForLevel(frag) {
    const level = this.hls.levels[frag.level];
    return level == null ? void 0 : level.attrs['CLOSED-CAPTIONS'];
  }
  onFragLoading(event, data) {
    // if this frag isn't contiguous, clear the parser so cues with bad start/end times aren't added to the textTrack
    if (this.enabled && data.frag.type === PlaylistLevelType.MAIN) {
      var _data$part$index, _data$part;
      const {
        cea608Parser1,
        cea608Parser2,
        lastSn
      } = this;
      const {
        cc,
        sn
      } = data.frag;
      const partIndex = (_data$part$index = (_data$part = data.part) == null ? void 0 : _data$part.index) != null ? _data$part$index : -1;
      if (cea608Parser1 && cea608Parser2) {
        if (sn !== lastSn + 1 || sn === lastSn && partIndex !== this.lastPartIndex + 1 || cc !== this.lastCc) {
          cea608Parser1.reset();
          cea608Parser2.reset();
        }
      }
      this.lastCc = cc;
      this.lastSn = sn;
      this.lastPartIndex = partIndex;
    }
  }
  onFragLoaded(event, data) {
    const {
      frag,
      payload
    } = data;
    if (frag.type === PlaylistLevelType.SUBTITLE) {
      // If fragment is subtitle type, parse as WebVTT.
      if (payload.byteLength) {
        const decryptData = frag.decryptdata;
        // fragment after decryption has a stats object
        const decrypted = 'stats' in data;
        // If the subtitles are not encrypted, parse VTTs now. Otherwise, we need to wait.
        if (decryptData == null || !decryptData.encrypted || decrypted) {
          const trackPlaylistMedia = this.tracks[frag.level];
          const vttCCs = this.vttCCs;
          if (!vttCCs[frag.cc]) {
            vttCCs[frag.cc] = {
              start: frag.start,
              prevCC: this.prevCC,
              new: true
            };
            this.prevCC = frag.cc;
          }
          if (trackPlaylistMedia && trackPlaylistMedia.textCodec === IMSC1_CODEC) {
            this._parseIMSC1(frag, payload);
          } else {
            this._parseVTTs(data);
          }
        }
      } else {
        // In case there is no payload, finish unsuccessfully.
        this.hls.trigger(Events.SUBTITLE_FRAG_PROCESSED, {
          success: false,
          frag,
          error: new Error('Empty subtitle payload')
        });
      }
    }
  }
  _parseIMSC1(frag, payload) {
    const hls = this.hls;
    parseIMSC1(payload, this.initPTS[frag.cc], cues => {
      this._appendCues(cues, frag.level);
      hls.trigger(Events.SUBTITLE_FRAG_PROCESSED, {
        success: true,
        frag: frag
      });
    }, error => {
      hls.logger.log(`Failed to parse IMSC1: ${error}`);
      hls.trigger(Events.SUBTITLE_FRAG_PROCESSED, {
        success: false,
        frag: frag,
        error
      });
    });
  }
  _parseVTTs(data) {
    var _frag$initSegment;
    const {
      frag,
      payload
    } = data;
    // We need an initial synchronisation PTS. Store fragments as long as none has arrived
    const {
      initPTS,
      unparsedVttFrags
    } = this;
    const maxAvCC = initPTS.length - 1;
    if (!initPTS[frag.cc] && maxAvCC === -1) {
      unparsedVttFrags.push(data);
      return;
    }
    const hls = this.hls;
    // Parse the WebVTT file contents.
    const payloadWebVTT = (_frag$initSegment = frag.initSegment) != null && _frag$initSegment.data ? appendUint8Array(frag.initSegment.data, new Uint8Array(payload)).buffer : payload;
    parseWebVTT(payloadWebVTT, this.initPTS[frag.cc], this.vttCCs, frag.cc, frag.start, cues => {
      this._appendCues(cues, frag.level);
      hls.trigger(Events.SUBTITLE_FRAG_PROCESSED, {
        success: true,
        frag: frag
      });
    }, error => {
      const missingInitPTS = error.message === 'Missing initPTS for VTT MPEGTS';
      if (missingInitPTS) {
        unparsedVttFrags.push(data);
      } else {
        this._fallbackToIMSC1(frag, payload);
      }
      // Something went wrong while parsing. Trigger event with success false.
      hls.logger.log(`Failed to parse VTT cue: ${error}`);
      if (missingInitPTS && maxAvCC > frag.cc) {
        return;
      }
      hls.trigger(Events.SUBTITLE_FRAG_PROCESSED, {
        success: false,
        frag: frag,
        error
      });
    });
  }
  _fallbackToIMSC1(frag, payload) {
    // If textCodec is unknown, try parsing as IMSC1. Set textCodec based on the result
    const trackPlaylistMedia = this.tracks[frag.level];
    if (!trackPlaylistMedia.textCodec) {
      parseIMSC1(payload, this.initPTS[frag.cc], () => {
        trackPlaylistMedia.textCodec = IMSC1_CODEC;
        this._parseIMSC1(frag, payload);
      }, () => {
        trackPlaylistMedia.textCodec = 'wvtt';
      });
    }
  }
  _appendCues(cues, fragLevel) {
    const hls = this.hls;
    if (this.config.renderTextTracksNatively) {
      const textTrack = this.textTracks[fragLevel];
      // WebVTTParser.parse is an async method and if the currently selected text track mode is set to "disabled"
      // before parsing is done then don't try to access currentTrack.cues.getCueById as cues will be null
      // and trying to access getCueById method of cues will throw an exception
      // Because we check if the mode is disabled, we can force check `cues` below. They can't be null.
      if (!textTrack || textTrack.mode === 'disabled') {
        return;
      }
      cues.forEach(cue => addCueToTrack(textTrack, cue));
    } else {
      const currentTrack = this.tracks[fragLevel];
      if (!currentTrack) {
        return;
      }
      const track = currentTrack.default ? 'default' : 'subtitles' + fragLevel;
      hls.trigger(Events.CUES_PARSED, {
        type: 'subtitles',
        cues,
        track
      });
    }
  }
  onFragDecrypted(event, data) {
    const {
      frag
    } = data;
    if (frag.type === PlaylistLevelType.SUBTITLE) {
      this.onFragLoaded(Events.FRAG_LOADED, data);
    }
  }
  onSubtitleTracksCleared() {
    this.tracks = [];
    this.captionsTracks = {};
  }
  onFragParsingUserdata(event, data) {
    if (!this.enabled || !this.config.enableCEA708Captions) {
      return;
    }
    const {
      frag,
      samples
    } = data;
    if (frag.type === PlaylistLevelType.MAIN && this.closedCaptionsForLevel(frag) === 'NONE') {
      return;
    }
    // If the event contains captions (found in the bytes property), push all bytes into the parser immediately
    // It will create the proper timestamps based on the PTS value
    for (let i = 0; i < samples.length; i++) {
      const ccBytes = samples[i].bytes;
      if (ccBytes) {
        if (!this.cea608Parser1) {
          this.initCea608Parsers();
        }
        const ccdatas = this.extractCea608Data(ccBytes);
        this.cea608Parser1.addData(samples[i].pts, ccdatas[0]);
        this.cea608Parser2.addData(samples[i].pts, ccdatas[1]);
      }
    }
  }
  onBufferFlushing(event, {
    startOffset,
    endOffset,
    endOffsetSubtitles,
    type
  }) {
    const {
      media
    } = this;
    if (!media || media.currentTime < endOffset) {
      return;
    }
    // Clear 608 caption cues from the captions TextTracks when the video back buffer is flushed
    // Forward cues are never removed because we can loose streamed 608 content from recent fragments
    if (!type || type === 'video') {
      const {
        captionsTracks
      } = this;
      Object.keys(captionsTracks).forEach(trackName => removeCuesInRange(captionsTracks[trackName], startOffset, endOffset));
    }
    if (this.config.renderTextTracksNatively) {
      // Clear VTT/IMSC1 subtitle cues from the subtitle TextTracks when the back buffer is flushed
      if (startOffset === 0 && endOffsetSubtitles !== undefined) {
        const {
          textTracks
        } = this;
        Object.keys(textTracks).forEach(trackName => removeCuesInRange(textTracks[trackName], startOffset, endOffsetSubtitles));
      }
    }
  }
  extractCea608Data(byteArray) {
    const actualCCBytes = [[], []];
    const count = byteArray[0] & 0x1f;
    let position = 2;
    for (let j = 0; j < count; j++) {
      const tmpByte = byteArray[position++];
      const ccbyte1 = 0x7f & byteArray[position++];
      const ccbyte2 = 0x7f & byteArray[position++];
      if (ccbyte1 === 0 && ccbyte2 === 0) {
        continue;
      }
      const ccValid = (0x04 & tmpByte) !== 0; // Support all four channels
      if (ccValid) {
        const ccType = 0x03 & tmpByte;
        if (0x00 /* CEA608 field1*/ === ccType || 0x01 /* CEA608 field2*/ === ccType) {
          // Exclude CEA708 CC data.
          actualCCBytes[ccType].push(ccbyte1);
          actualCCBytes[ccType].push(ccbyte2);
        }
      }
    }
    return actualCCBytes;
  }
}
function captionsOrSubtitlesFromCharacteristics(track) {
  if (track.characteristics) {
    if (/transcribes-spoken-dialog/gi.test(track.characteristics) && /describes-music-and-sound/gi.test(track.characteristics)) {
      return 'captions';
    }
  }
  return 'subtitles';
}
function canReuseVttTextTrack(inUseTrack, manifestTrack) {
  return !!inUseTrack && inUseTrack.kind === captionsOrSubtitlesFromCharacteristics(manifestTrack) && subtitleTrackMatchesTextTrack(manifestTrack, inUseTrack);
}
function intersection(x1, x2, y1, y2) {
  return Math.min(x2, y2) - Math.max(x1, y1);
}
function newVTTCCs() {
  return {
    ccOffset: 0,
    presentationOffset: 0,
    0: {
      start: 0,
      prevCC: -1,
      new: true
    }
  };
}

const WHITESPACE_CHAR = /\s/;
const Cues = {
  newCue(track, startTime, endTime, captionScreen) {
    const result = [];
    let row;
    // the type data states this is VTTCue, but it can potentially be a TextTrackCue on old browsers
    let cue;
    let indenting;
    let indent;
    let text;
    const Cue = self.VTTCue || self.TextTrackCue;
    for (let r = 0; r < captionScreen.rows.length; r++) {
      row = captionScreen.rows[r];
      indenting = true;
      indent = 0;
      text = '';
      if (!row.isEmpty()) {
        var _track$cues;
        for (let c = 0; c < row.chars.length; c++) {
          if (WHITESPACE_CHAR.test(row.chars[c].uchar) && indenting) {
            indent++;
          } else {
            text += row.chars[c].uchar;
            indenting = false;
          }
        }
        // To be used for cleaning-up orphaned roll-up captions
        row.cueStartTime = startTime;

        // Give a slight bump to the endTime if it's equal to startTime to avoid a SyntaxError in IE
        if (startTime === endTime) {
          endTime += 0.0001;
        }
        if (indent >= 16) {
          indent--;
        } else {
          indent++;
        }
        const cueText = fixLineBreaks(text.trim());
        const id = generateCueId(startTime, endTime, cueText);

        // If this cue already exists in the track do not push it
        if (!(track != null && (_track$cues = track.cues) != null && _track$cues.getCueById(id))) {
          cue = new Cue(startTime, endTime, cueText);
          cue.id = id;
          cue.line = r + 1;
          cue.align = 'left';
          // Clamp the position between 10 and 80 percent (CEA-608 PAC indent code)
          // https://dvcs.w3.org/hg/text-tracks/raw-file/default/608toVTT/608toVTT.html#positioning-in-cea-608
          // Firefox throws an exception and captions break with out of bounds 0-100 values
          cue.position = 10 + Math.min(80, Math.floor(indent * 8 / 32) * 10);
          result.push(cue);
        }
      }
    }
    if (track && result.length) {
      // Sort bottom cues in reverse order so that they render in line order when overlapping in Chrome
      result.sort((cueA, cueB) => {
        if (cueA.line === 'auto' || cueB.line === 'auto') {
          return 0;
        }
        if (cueA.line > 8 && cueB.line > 8) {
          return cueB.line - cueA.line;
        }
        return cueA.line - cueB.line;
      });
      result.forEach(cue => addCueToTrack(track, cue));
    }
    return result;
  }
};

function fetchSupported() {
  if (
  // @ts-ignore
  self.fetch && self.AbortController && self.ReadableStream && self.Request) {
    try {
      new self.ReadableStream({}); // eslint-disable-line no-new
      return true;
    } catch (e) {
      /* noop */
    }
  }
  return false;
}
const BYTERANGE = /(\d+)-(\d+)\/(\d+)/;
class FetchLoader {
  constructor(config) {
    this.fetchSetup = void 0;
    this.requestTimeout = void 0;
    this.request = null;
    this.response = null;
    this.controller = void 0;
    this.context = null;
    this.config = null;
    this.callbacks = null;
    this.stats = void 0;
    this.loader = null;
    this.fetchSetup = config.fetchSetup || getRequest;
    this.controller = new self.AbortController();
    this.stats = new LoadStats();
  }
  destroy() {
    this.loader = this.callbacks = this.context = this.config = this.request = null;
    this.abortInternal();
    this.response = null;
    // @ts-ignore
    this.fetchSetup = this.controller = this.stats = null;
  }
  abortInternal() {
    if (this.controller && !this.stats.loading.end) {
      this.stats.aborted = true;
      this.controller.abort();
    }
  }
  abort() {
    var _this$callbacks;
    this.abortInternal();
    if ((_this$callbacks = this.callbacks) != null && _this$callbacks.onAbort) {
      this.callbacks.onAbort(this.stats, this.context, this.response);
    }
  }
  load(context, config, callbacks) {
    const stats = this.stats;
    if (stats.loading.start) {
      throw new Error('Loader can only be used once.');
    }
    stats.loading.start = self.performance.now();
    const initParams = getRequestParameters(context, this.controller.signal);
    const isArrayBuffer = context.responseType === 'arraybuffer';
    const LENGTH = isArrayBuffer ? 'byteLength' : 'length';
    const {
      maxTimeToFirstByteMs,
      maxLoadTimeMs
    } = config.loadPolicy;
    this.context = context;
    this.config = config;
    this.callbacks = callbacks;
    this.request = this.fetchSetup(context, initParams);
    self.clearTimeout(this.requestTimeout);
    config.timeout = maxTimeToFirstByteMs && isFiniteNumber(maxTimeToFirstByteMs) ? maxTimeToFirstByteMs : maxLoadTimeMs;
    this.requestTimeout = self.setTimeout(() => {
      if (this.callbacks) {
        this.abortInternal();
        this.callbacks.onTimeout(stats, context, this.response);
      }
    }, config.timeout);
    const fetchPromise = hls_isPromise(this.request) ? this.request.then(self.fetch) : self.fetch(this.request);
    fetchPromise.then(response => {
      var _this$callbacks2;
      this.response = this.loader = response;
      const first = Math.max(self.performance.now(), stats.loading.start);
      self.clearTimeout(this.requestTimeout);
      config.timeout = maxLoadTimeMs;
      this.requestTimeout = self.setTimeout(() => {
        if (this.callbacks) {
          this.abortInternal();
          this.callbacks.onTimeout(stats, context, this.response);
        }
      }, maxLoadTimeMs - (first - stats.loading.start));
      if (!response.ok) {
        const {
          status,
          statusText
        } = response;
        throw new hls_FetchError(statusText || 'fetch, bad network response', status, response);
      }
      stats.loading.first = first;
      stats.total = getContentLength(response.headers) || stats.total;
      const onProgress = (_this$callbacks2 = this.callbacks) == null ? void 0 : _this$callbacks2.onProgress;
      if (onProgress && isFiniteNumber(config.highWaterMark)) {
        return this.loadProgressively(response, stats, context, config.highWaterMark, onProgress);
      }
      if (isArrayBuffer) {
        return response.arrayBuffer();
      }
      if (context.responseType === 'json') {
        return response.json();
      }
      return response.text();
    }).then(responseData => {
      var _this$callbacks3, _this$callbacks4;
      const response = this.response;
      if (!response) {
        throw new Error('loader destroyed');
      }
      self.clearTimeout(this.requestTimeout);
      stats.loading.end = Math.max(self.performance.now(), stats.loading.first);
      const total = responseData[LENGTH];
      if (total) {
        stats.loaded = stats.total = total;
      }
      const loaderResponse = {
        url: response.url,
        data: responseData,
        code: response.status
      };
      const onProgress = (_this$callbacks3 = this.callbacks) == null ? void 0 : _this$callbacks3.onProgress;
      if (onProgress && !isFiniteNumber(config.highWaterMark)) {
        onProgress(stats, context, responseData, response);
      }
      (_this$callbacks4 = this.callbacks) == null ? void 0 : _this$callbacks4.onSuccess(loaderResponse, stats, context, response);
    }).catch(error => {
      var _this$callbacks5;
      self.clearTimeout(this.requestTimeout);
      if (stats.aborted) {
        return;
      }
      // CORS errors result in an undefined code. Set it to 0 here to align with XHR's behavior
      // when destroying, 'error' itself can be undefined
      const code = !error ? 0 : error.code || 0;
      const text = !error ? null : error.message;
      (_this$callbacks5 = this.callbacks) == null ? void 0 : _this$callbacks5.onError({
        code,
        text
      }, context, error ? error.details : null, stats);
    });
  }
  getCacheAge() {
    let result = null;
    if (this.response) {
      const ageHeader = this.response.headers.get('age');
      result = ageHeader ? parseFloat(ageHeader) : null;
    }
    return result;
  }
  getResponseHeader(name) {
    return this.response ? this.response.headers.get(name) : null;
  }
  loadProgressively(response, stats, context, highWaterMark = 0, onProgress) {
    const chunkCache = new ChunkCache();
    const reader = response.body.getReader();
    const pump = () => {
      return reader.read().then(data => {
        if (data.done) {
          if (chunkCache.dataLength) {
            onProgress(stats, context, chunkCache.flush().buffer, response);
          }
          return Promise.resolve(new ArrayBuffer(0));
        }
        const chunk = data.value;
        const len = chunk.length;
        stats.loaded += len;
        if (len < highWaterMark || chunkCache.dataLength) {
          // The current chunk is too small to to be emitted or the cache already has data
          // Push it to the cache
          chunkCache.push(chunk);
          if (chunkCache.dataLength >= highWaterMark) {
            // flush in order to join the typed arrays
            onProgress(stats, context, chunkCache.flush().buffer, response);
          }
        } else {
          // If there's nothing cached already, and the chache is large enough
          // just emit the progress event
          onProgress(stats, context, chunk.buffer, response);
        }
        return pump();
      }).catch(() => {
        /* aborted */
        return Promise.reject();
      });
    };
    return pump();
  }
}
function getRequestParameters(context, signal) {
  const initParams = {
    method: 'GET',
    mode: 'cors',
    credentials: 'same-origin',
    signal,
    headers: new self.Headers(_extends({}, context.headers))
  };
  if (context.rangeEnd) {
    initParams.headers.set('Range', 'bytes=' + context.rangeStart + '-' + String(context.rangeEnd - 1));
  }
  return initParams;
}
function getByteRangeLength(byteRangeHeader) {
  const result = BYTERANGE.exec(byteRangeHeader);
  if (result) {
    return parseInt(result[2]) - parseInt(result[1]) + 1;
  }
}
function getContentLength(headers) {
  const contentRange = headers.get('Content-Range');
  if (contentRange) {
    const byteRangeLength = getByteRangeLength(contentRange);
    if (isFiniteNumber(byteRangeLength)) {
      return byteRangeLength;
    }
  }
  const contentLength = headers.get('Content-Length');
  if (contentLength) {
    return parseInt(contentLength);
  }
}
function getRequest(context, initParams) {
  return new self.Request(context.url, initParams);
}
class hls_FetchError extends Error {
  constructor(message, code, details) {
    super(message);
    this.code = void 0;
    this.details = void 0;
    this.code = code;
    this.details = details;
  }
}

const AGE_HEADER_LINE_REGEX = /^age:\s*[\d.]+\s*$/im;
class XhrLoader {
  constructor(config) {
    this.xhrSetup = void 0;
    this.requestTimeout = void 0;
    this.retryTimeout = void 0;
    this.retryDelay = void 0;
    this.config = null;
    this.callbacks = null;
    this.context = null;
    this.loader = null;
    this.stats = void 0;
    this.xhrSetup = config ? config.xhrSetup || null : null;
    this.stats = new LoadStats();
    this.retryDelay = 0;
  }
  destroy() {
    this.callbacks = null;
    this.abortInternal();
    this.loader = null;
    this.config = null;
    this.context = null;
    this.xhrSetup = null;
  }
  abortInternal() {
    const loader = this.loader;
    self.clearTimeout(this.requestTimeout);
    self.clearTimeout(this.retryTimeout);
    if (loader) {
      loader.onreadystatechange = null;
      loader.onprogress = null;
      if (loader.readyState !== 4) {
        this.stats.aborted = true;
        loader.abort();
      }
    }
  }
  abort() {
    var _this$callbacks;
    this.abortInternal();
    if ((_this$callbacks = this.callbacks) != null && _this$callbacks.onAbort) {
      this.callbacks.onAbort(this.stats, this.context, this.loader);
    }
  }
  load(context, config, callbacks) {
    if (this.stats.loading.start) {
      throw new Error('Loader can only be used once.');
    }
    this.stats.loading.start = self.performance.now();
    this.context = context;
    this.config = config;
    this.callbacks = callbacks;
    this.loadInternal();
  }
  loadInternal() {
    const {
      config,
      context
    } = this;
    if (!config || !context) {
      return;
    }
    const xhr = this.loader = new self.XMLHttpRequest();
    const stats = this.stats;
    stats.loading.first = 0;
    stats.loaded = 0;
    stats.aborted = false;
    const xhrSetup = this.xhrSetup;
    if (xhrSetup) {
      Promise.resolve().then(() => {
        if (this.loader !== xhr || this.stats.aborted) return;
        return xhrSetup(xhr, context.url);
      }).catch(error => {
        if (this.loader !== xhr || this.stats.aborted) return;
        xhr.open('GET', context.url, true);
        return xhrSetup(xhr, context.url);
      }).then(() => {
        if (this.loader !== xhr || this.stats.aborted) return;
        this.openAndSendXhr(xhr, context, config);
      }).catch(error => {
        var _this$callbacks2;
        // IE11 throws an exception on xhr.open if attempting to access an HTTP resource over HTTPS
        (_this$callbacks2 = this.callbacks) == null ? void 0 : _this$callbacks2.onError({
          code: xhr.status,
          text: error.message
        }, context, xhr, stats);
        return;
      });
    } else {
      this.openAndSendXhr(xhr, context, config);
    }
  }
  openAndSendXhr(xhr, context, config) {
    if (!xhr.readyState) {
      xhr.open('GET', context.url, true);
    }
    const headers = context.headers;
    const {
      maxTimeToFirstByteMs,
      maxLoadTimeMs
    } = config.loadPolicy;
    if (headers) {
      for (const header in headers) {
        xhr.setRequestHeader(header, headers[header]);
      }
    }
    if (context.rangeEnd) {
      xhr.setRequestHeader('Range', 'bytes=' + context.rangeStart + '-' + (context.rangeEnd - 1));
    }
    xhr.onreadystatechange = this.readystatechange.bind(this);
    xhr.onprogress = this.loadprogress.bind(this);
    xhr.responseType = context.responseType;
    // setup timeout before we perform request
    self.clearTimeout(this.requestTimeout);
    config.timeout = maxTimeToFirstByteMs && isFiniteNumber(maxTimeToFirstByteMs) ? maxTimeToFirstByteMs : maxLoadTimeMs;
    this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), config.timeout);
    xhr.send();
  }
  readystatechange() {
    const {
      context,
      loader: xhr,
      stats
    } = this;
    if (!context || !xhr) {
      return;
    }
    const readyState = xhr.readyState;
    const config = this.config;

    // don't proceed if xhr has been aborted
    if (stats.aborted) {
      return;
    }

    // >= HEADERS_RECEIVED
    if (readyState >= 2) {
      if (stats.loading.first === 0) {
        stats.loading.first = Math.max(self.performance.now(), stats.loading.start);
        // readyState >= 2 AND readyState !==4 (readyState = HEADERS_RECEIVED || LOADING) rearm timeout as xhr not finished yet
        if (config.timeout !== config.loadPolicy.maxLoadTimeMs) {
          self.clearTimeout(this.requestTimeout);
          config.timeout = config.loadPolicy.maxLoadTimeMs;
          this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), config.loadPolicy.maxLoadTimeMs - (stats.loading.first - stats.loading.start));
        }
      }
      if (readyState === 4) {
        self.clearTimeout(this.requestTimeout);
        xhr.onreadystatechange = null;
        xhr.onprogress = null;
        const status = xhr.status;
        // http status between 200 to 299 are all successful
        const useResponseText = xhr.responseType === 'text' ? xhr.responseText : null;
        if (status >= 200 && status < 300) {
          const data = useResponseText != null ? useResponseText : xhr.response;
          if (data != null) {
            var _this$callbacks3, _this$callbacks4;
            stats.loading.end = Math.max(self.performance.now(), stats.loading.first);
            const len = xhr.responseType === 'arraybuffer' ? data.byteLength : data.length;
            stats.loaded = stats.total = len;
            stats.bwEstimate = stats.total * 8000 / (stats.loading.end - stats.loading.first);
            const onProgress = (_this$callbacks3 = this.callbacks) == null ? void 0 : _this$callbacks3.onProgress;
            if (onProgress) {
              onProgress(stats, context, data, xhr);
            }
            const _response = {
              url: xhr.responseURL,
              data: data,
              code: status
            };
            (_this$callbacks4 = this.callbacks) == null ? void 0 : _this$callbacks4.onSuccess(_response, stats, context, xhr);
            return;
          }
        }

        // Handle bad status or nullish response
        const retryConfig = config.loadPolicy.errorRetry;
        const retryCount = stats.retry;
        // if max nb of retries reached or if http status between 400 and 499 (such error cannot be recovered, retrying is useless), return error
        const response = {
          url: context.url,
          data: undefined,
          code: status
        };
        if (shouldRetry(retryConfig, retryCount, false, response)) {
          this.retry(retryConfig);
        } else {
          var _this$callbacks5;
          hls_logger.error(`${status} while loading ${context.url}`);
          (_this$callbacks5 = this.callbacks) == null ? void 0 : _this$callbacks5.onError({
            code: status,
            text: xhr.statusText
          }, context, xhr, stats);
        }
      }
    }
  }
  loadtimeout() {
    if (!this.config) return;
    const retryConfig = this.config.loadPolicy.timeoutRetry;
    const retryCount = this.stats.retry;
    if (shouldRetry(retryConfig, retryCount, true)) {
      this.retry(retryConfig);
    } else {
      var _this$context;
      hls_logger.warn(`timeout while loading ${(_this$context = this.context) == null ? void 0 : _this$context.url}`);
      const callbacks = this.callbacks;
      if (callbacks) {
        this.abortInternal();
        callbacks.onTimeout(this.stats, this.context, this.loader);
      }
    }
  }
  retry(retryConfig) {
    const {
      context,
      stats
    } = this;
    this.retryDelay = getRetryDelay(retryConfig, stats.retry);
    stats.retry++;
    hls_logger.warn(`${status ? 'HTTP Status ' + status : 'Timeout'} while loading ${context == null ? void 0 : context.url}, retrying ${stats.retry}/${retryConfig.maxNumRetry} in ${this.retryDelay}ms`);
    // abort and reset internal state
    this.abortInternal();
    this.loader = null;
    // schedule retry
    self.clearTimeout(this.retryTimeout);
    this.retryTimeout = self.setTimeout(this.loadInternal.bind(this), this.retryDelay);
  }
  loadprogress(event) {
    const stats = this.stats;
    stats.loaded = event.loaded;
    if (event.lengthComputable) {
      stats.total = event.total;
    }
  }
  getCacheAge() {
    let result = null;
    if (this.loader && AGE_HEADER_LINE_REGEX.test(this.loader.getAllResponseHeaders())) {
      const ageHeader = this.loader.getResponseHeader('age');
      result = ageHeader ? parseFloat(ageHeader) : null;
    }
    return result;
  }
  getResponseHeader(name) {
    if (this.loader && new RegExp(`^${name}:\\s*[\\d.]+\\s*$`, 'im').test(this.loader.getAllResponseHeaders())) {
      return this.loader.getResponseHeader(name);
    }
    return null;
  }
}

/**
 * @deprecated use fragLoadPolicy.default
 */

/**
 * @deprecated use manifestLoadPolicy.default and playlistLoadPolicy.default
 */

const defaultLoadPolicy = {
  maxTimeToFirstByteMs: 8000,
  maxLoadTimeMs: 20000,
  timeoutRetry: null,
  errorRetry: null
};

/**
 * @ignore
 * If possible, keep hlsDefaultConfig shallow
 * It is cloned whenever a new Hls instance is created, by keeping the config
 * shallow the properties are cloned, and we don't end up manipulating the default
 */
const hlsDefaultConfig = _objectSpread2(_objectSpread2({
  autoStartLoad: true,
  // used by stream-controller
  startPosition: -1,
  // used by stream-controller
  defaultAudioCodec: undefined,
  // used by stream-controller
  debug: false,
  // used by logger
  capLevelOnFPSDrop: false,
  // used by fps-controller
  capLevelToPlayerSize: false,
  // used by cap-level-controller
  ignoreDevicePixelRatio: false,
  // used by cap-level-controller
  maxDevicePixelRatio: Number.POSITIVE_INFINITY,
  // used by cap-level-controller
  preferManagedMediaSource: true,
  initialLiveManifestSize: 1,
  // used by stream-controller
  maxBufferLength: 30,
  // used by stream-controller
  backBufferLength: Infinity,
  // used by buffer-controller
  frontBufferFlushThreshold: Infinity,
  startOnSegmentBoundary: false,
  // used by stream-controller
  maxBufferSize: 60 * 1000 * 1000,
  // used by stream-controller
  maxFragLookUpTolerance: 0.25,
  // used by stream-controller
  maxBufferHole: 0.1,
  // used by stream-controller and gap-controller
  detectStallWithCurrentTimeMs: 1250,
  // used by gap-controller
  highBufferWatchdogPeriod: 2,
  // used by gap-controller
  nudgeOffset: 0.1,
  // used by gap-controller
  nudgeMaxRetry: 3,
  // used by gap-controller
  nudgeOnVideoHole: true,
  // used by gap-controller
  liveSyncMode: 'edge',
  // used by stream-controller
  liveSyncDurationCount: 3,
  // used by latency-controller
  liveSyncOnStallIncrease: 1,
  // used by latency-controller
  liveMaxLatencyDurationCount: Infinity,
  // used by latency-controller
  liveSyncDuration: undefined,
  // used by latency-controller
  liveMaxLatencyDuration: undefined,
  // used by latency-controller
  maxLiveSyncPlaybackRate: 1,
  // used by latency-controller
  liveDurationInfinity: false,
  // used by buffer-controller
  /**
   * @deprecated use backBufferLength
   */
  liveBackBufferLength: null,
  // used by buffer-controller
  maxMaxBufferLength: 600,
  // used by stream-controller
  enableWorker: true,
  // used by transmuxer
  workerPath: null,
  // used by transmuxer
  enableSoftwareAES: true,
  // used by decrypter
  startLevel: undefined,
  // used by level-controller
  startFragPrefetch: false,
  // used by stream-controller
  fpsDroppedMonitoringPeriod: 5000,
  // used by fps-controller
  fpsDroppedMonitoringThreshold: 0.2,
  // used by fps-controller
  appendErrorMaxRetry: 3,
  // used by buffer-controller
  ignorePlaylistParsingErrors: false,
  loader: XhrLoader,
  // loader: FetchLoader,
  fLoader: undefined,
  // used by fragment-loader
  pLoader: undefined,
  // used by playlist-loader
  xhrSetup: undefined,
  // used by xhr-loader
  licenseXhrSetup: undefined,
  // used by eme-controller
  licenseResponseCallback: undefined,
  // used by eme-controller
  abrController: AbrController,
  bufferController: BufferController,
  capLevelController: CapLevelController,
  errorController: ErrorController,
  fpsController: FPSController,
  stretchShortVideoTrack: false,
  // used by mp4-remuxer
  maxAudioFramesDrift: 1,
  // used by mp4-remuxer
  forceKeyFrameOnDiscontinuity: true,
  // used by ts-demuxer
  abrEwmaFastLive: 3,
  // used by abr-controller
  abrEwmaSlowLive: 9,
  // used by abr-controller
  abrEwmaFastVoD: 3,
  // used by abr-controller
  abrEwmaSlowVoD: 9,
  // used by abr-controller
  abrEwmaDefaultEstimate: 5e5,
  // 500 kbps  // used by abr-controller
  abrEwmaDefaultEstimateMax: 5e6,
  // 5 mbps
  abrBandWidthFactor: 0.95,
  // used by abr-controller
  abrBandWidthUpFactor: 0.7,
  // used by abr-controller
  abrMaxWithRealBitrate: false,
  // used by abr-controller
  maxStarvationDelay: 4,
  // used by abr-controller
  maxLoadingDelay: 4,
  // used by abr-controller
  minAutoBitrate: 0,
  // used by hls
  emeEnabled: false,
  // used by eme-controller
  widevineLicenseUrl: undefined,
  // used by eme-controller
  drmSystems: {},
  // used by eme-controller
  drmSystemOptions: {},
  // used by eme-controller
  requestMediaKeySystemAccessFunc: requestMediaKeySystemAccess ,
  // used by eme-controller
  requireKeySystemAccessOnStart: false,
  // used by eme-controller
  testBandwidth: true,
  progressive: false,
  lowLatencyMode: true,
  cmcd: undefined,
  enableDateRangeMetadataCues: true,
  enableEmsgMetadataCues: true,
  enableEmsgKLVMetadata: false,
  enableID3MetadataCues: true,
  enableInterstitialPlayback: true,
  interstitialAppendInPlace: true,
  interstitialLiveLookAhead: 10,
  useMediaCapabilities: true,
  preserveManualLevelOnError: false,
  certLoadPolicy: {
    default: defaultLoadPolicy
  },
  keyLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 8000,
      maxLoadTimeMs: 20000,
      timeoutRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1000,
        maxRetryDelayMs: 20000,
        backoff: 'linear'
      },
      errorRetry: {
        maxNumRetry: 8,
        retryDelayMs: 1000,
        maxRetryDelayMs: 20000,
        backoff: 'linear'
      }
    }
  },
  manifestLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: Infinity,
      maxLoadTimeMs: 20000,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1000,
        maxRetryDelayMs: 8000
      }
    }
  },
  playlistLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 10000,
      maxLoadTimeMs: 20000,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 2,
        retryDelayMs: 1000,
        maxRetryDelayMs: 8000
      }
    }
  },
  fragLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 10000,
      maxLoadTimeMs: 120000,
      timeoutRetry: {
        maxNumRetry: 4,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 6,
        retryDelayMs: 1000,
        maxRetryDelayMs: 8000
      }
    }
  },
  steeringManifestLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 10000,
      maxLoadTimeMs: 20000,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1000,
        maxRetryDelayMs: 8000
      }
    } 
  },
  interstitialAssetListLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 10000,
      maxLoadTimeMs: 30000,
      timeoutRetry: {
        maxNumRetry: 0,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 0,
        retryDelayMs: 1000,
        maxRetryDelayMs: 8000
      }
    } 
  },
  // These default settings are deprecated in favor of the above policies
  // and are maintained for backwards compatibility
  manifestLoadingTimeOut: 10000,
  manifestLoadingMaxRetry: 1,
  manifestLoadingRetryDelay: 1000,
  manifestLoadingMaxRetryTimeout: 64000,
  levelLoadingTimeOut: 10000,
  levelLoadingMaxRetry: 4,
  levelLoadingRetryDelay: 1000,
  levelLoadingMaxRetryTimeout: 64000,
  fragLoadingTimeOut: 20000,
  fragLoadingMaxRetry: 6,
  fragLoadingRetryDelay: 1000,
  fragLoadingMaxRetryTimeout: 64000
}, timelineConfig()), {}, {
  subtitleStreamController: SubtitleStreamController ,
  subtitleTrackController: SubtitleTrackController ,
  timelineController: TimelineController ,
  audioStreamController: AudioStreamController ,
  audioTrackController: AudioTrackController ,
  emeController: EMEController ,
  cmcdController: CMCDController ,
  contentSteeringController: ContentSteeringController ,
  interstitialsController: InterstitialsController 
});
function timelineConfig() {
  return {
    cueHandler: Cues,
    // used by timeline-controller
    enableWebVTT: true,
    // used by timeline-controller
    enableIMSC1: true,
    // used by timeline-controller
    enableCEA708Captions: true,
    // used by timeline-controller
    captionsTextTrack1Label: 'English',
    // used by timeline-controller
    captionsTextTrack1LanguageCode: 'en',
    // used by timeline-controller
    captionsTextTrack2Label: 'Spanish',
    // used by timeline-controller
    captionsTextTrack2LanguageCode: 'es',
    // used by timeline-controller
    captionsTextTrack3Label: 'Unknown CC',
    // used by timeline-controller
    captionsTextTrack3LanguageCode: '',
    // used by timeline-controller
    captionsTextTrack4Label: 'Unknown CC',
    // used by timeline-controller
    captionsTextTrack4LanguageCode: '',
    // used by timeline-controller
    renderTextTracksNatively: true
  };
}

/**
 * @ignore
 */
function mergeConfig(defaultConfig, userConfig, logger) {
  if ((userConfig.liveSyncDurationCount || userConfig.liveMaxLatencyDurationCount) && (userConfig.liveSyncDuration || userConfig.liveMaxLatencyDuration)) {
    throw new Error("Illegal hls.js config: don't mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration");
  }
  if (userConfig.liveMaxLatencyDurationCount !== undefined && (userConfig.liveSyncDurationCount === undefined || userConfig.liveMaxLatencyDurationCount <= userConfig.liveSyncDurationCount)) {
    throw new Error('Illegal hls.js config: "liveMaxLatencyDurationCount" must be greater than "liveSyncDurationCount"');
  }
  if (userConfig.liveMaxLatencyDuration !== undefined && (userConfig.liveSyncDuration === undefined || userConfig.liveMaxLatencyDuration <= userConfig.liveSyncDuration)) {
    throw new Error('Illegal hls.js config: "liveMaxLatencyDuration" must be greater than "liveSyncDuration"');
  }
  const defaultsCopy = deepCpy(defaultConfig);

  // Backwards compatibility with deprecated config values
  const deprecatedSettingTypes = ['manifest', 'level', 'frag'];
  const deprecatedSettings = ['TimeOut', 'MaxRetry', 'RetryDelay', 'MaxRetryTimeout'];
  deprecatedSettingTypes.forEach(type => {
    const policyName = `${type === 'level' ? 'playlist' : type}LoadPolicy`;
    const policyNotSet = userConfig[policyName] === undefined;
    const report = [];
    deprecatedSettings.forEach(setting => {
      const deprecatedSetting = `${type}Loading${setting}`;
      const value = userConfig[deprecatedSetting];
      if (value !== undefined && policyNotSet) {
        report.push(deprecatedSetting);
        const settings = defaultsCopy[policyName].default;
        userConfig[policyName] = {
          default: settings
        };
        switch (setting) {
          case 'TimeOut':
            settings.maxLoadTimeMs = value;
            settings.maxTimeToFirstByteMs = value;
            break;
          case 'MaxRetry':
            settings.errorRetry.maxNumRetry = value;
            settings.timeoutRetry.maxNumRetry = value;
            break;
          case 'RetryDelay':
            settings.errorRetry.retryDelayMs = value;
            settings.timeoutRetry.retryDelayMs = value;
            break;
          case 'MaxRetryTimeout':
            settings.errorRetry.maxRetryDelayMs = value;
            settings.timeoutRetry.maxRetryDelayMs = value;
            break;
        }
      }
    });
    if (report.length) {
      logger.warn(`hls.js config: "${report.join('", "')}" setting(s) are deprecated, use "${policyName}": ${hls_stringify(userConfig[policyName])}`);
    }
  });
  return _objectSpread2(_objectSpread2({}, defaultsCopy), userConfig);
}
function deepCpy(obj) {
  if (obj && typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return obj.map(deepCpy);
    }
    return Object.keys(obj).reduce((result, key) => {
      result[key] = deepCpy(obj[key]);
      return result;
    }, {});
  }
  return obj;
}

/**
 * @ignore
 */
function enableStreamingMode(config, logger) {
  const currentLoader = config.loader;
  if (currentLoader !== FetchLoader && currentLoader !== XhrLoader) {
    // If a developer has configured their own loader, respect that choice
    logger.log('[config]: Custom loader detected, cannot enable progressive streaming');
    config.progressive = false;
  } else {
    const canStreamProgressively = fetchSupported();
    if (canStreamProgressively) {
      config.loader = FetchLoader;
      config.progressive = true;
      config.enableSoftwareAES = true;
      logger.log('[config]: Progressive streaming enabled, using FetchLoader');
    }
  }
}

const MAX_START_GAP_JUMP = 2.0;
const SKIP_BUFFER_HOLE_STEP_SECONDS = 0.1;
const SKIP_BUFFER_RANGE_START = 0.05;
const TICK_INTERVAL$1 = 100;
class GapController extends TaskLoop {
  constructor(hls, fragmentTracker) {
    super('gap-controller', hls.logger);
    this.hls = null;
    this.fragmentTracker = null;
    this.media = null;
    this.mediaSource = void 0;
    this.nudgeRetry = 0;
    this.stallReported = false;
    this.stalled = null;
    this.moved = false;
    this.seeking = false;
    this.buffered = {};
    this.lastCurrentTime = 0;
    this.ended = 0;
    this.waiting = 0;
    this.onMediaPlaying = () => {
      this.ended = 0;
      this.waiting = 0;
    };
    this.onMediaWaiting = () => {
      var _this$media;
      if ((_this$media = this.media) != null && _this$media.seeking) {
        return;
      }
      this.waiting = self.performance.now();
      this.tick();
    };
    this.onMediaEnded = () => {
      if (this.hls) {
        var _this$media2;
        // ended is set when triggering MEDIA_ENDED so that we do not trigger it again on stall or on tick with media.ended
        this.ended = ((_this$media2 = this.media) == null ? void 0 : _this$media2.currentTime) || 1;
        this.hls.trigger(Events.MEDIA_ENDED, {
          stalled: false
        });
      }
    };
    this.hls = hls;
    this.fragmentTracker = fragmentTracker;
    this.registerListeners();
  }
  registerListeners() {
    const {
      hls
    } = this;
    if (hls) {
      hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
      hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
      hls.on(Events.BUFFER_APPENDED, this.onBufferAppended, this);
    }
  }
  unregisterListeners() {
    const {
      hls
    } = this;
    if (hls) {
      hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
      hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
      hls.off(Events.BUFFER_APPENDED, this.onBufferAppended, this);
    }
  }
  destroy() {
    super.destroy();
    this.unregisterListeners();
    this.media = this.hls = this.fragmentTracker = null;
    this.mediaSource = undefined;
  }
  onMediaAttached(event, data) {
    this.setInterval(TICK_INTERVAL$1);
    this.mediaSource = data.mediaSource;
    const media = this.media = data.media;
    addEventListener(media, 'playing', this.onMediaPlaying);
    addEventListener(media, 'waiting', this.onMediaWaiting);
    addEventListener(media, 'ended', this.onMediaEnded);
  }
  onMediaDetaching(event, data) {
    this.clearInterval();
    const {
      media
    } = this;
    if (media) {
      removeEventListener(media, 'playing', this.onMediaPlaying);
      removeEventListener(media, 'waiting', this.onMediaWaiting);
      removeEventListener(media, 'ended', this.onMediaEnded);
      this.media = null;
    }
    this.mediaSource = undefined;
  }
  onBufferAppended(event, data) {
    this.buffered = data.timeRanges;
  }
  get hasBuffered() {
    return Object.keys(this.buffered).length > 0;
  }
  tick() {
    var _this$media3;
    if (!((_this$media3 = this.media) != null && _this$media3.readyState) || !this.hasBuffered) {
      return;
    }
    const currentTime = this.media.currentTime;
    this.poll(currentTime, this.lastCurrentTime);
    this.lastCurrentTime = currentTime;
  }

  /**
   * Checks if the playhead is stuck within a gap, and if so, attempts to free it.
   * A gap is an unbuffered range between two buffered ranges (or the start and the first buffered range).
   *
   * @param lastCurrentTime - Previously read playhead position
   */
  poll(currentTime, lastCurrentTime) {
    var _this$hls, _this$hls2;
    const config = (_this$hls = this.hls) == null ? void 0 : _this$hls.config;
    if (!config) {
      return;
    }
    const media = this.media;
    if (!media) {
      return;
    }
    const {
      seeking
    } = media;
    const seeked = this.seeking && !seeking;
    const beginSeek = !this.seeking && seeking;
    const pausedEndedOrHalted = media.paused && !seeking || media.ended || media.playbackRate === 0;
    this.seeking = seeking;

    // The playhead is moving, no-op
    if (currentTime !== lastCurrentTime) {
      if (lastCurrentTime) {
        this.ended = 0;
      }
      this.moved = true;
      if (!seeking) {
        this.nudgeRetry = 0;
        // When crossing between buffered video time ranges, but not audio, flush pipeline with seek (Chrome)
        if (config.nudgeOnVideoHole && !pausedEndedOrHalted && currentTime > lastCurrentTime) {
          this.nudgeOnVideoHole(currentTime, lastCurrentTime);
        }
      }
      if (this.waiting === 0) {
        this.stallResolved(currentTime);
      }
      return;
    }

    // Clear stalled state when beginning or finishing seeking so that we don't report stalls coming out of a seek
    if (beginSeek || seeked) {
      if (seeked) {
        this.stallResolved(currentTime);
      }
      return;
    }

    // The playhead should not be moving
    if (pausedEndedOrHalted) {
      this.nudgeRetry = 0;
      this.stallResolved(currentTime);
      // Fire MEDIA_ENDED to workaround event not being dispatched by browser
      if (!this.ended && media.ended && this.hls) {
        this.ended = currentTime || 1;
        this.hls.trigger(Events.MEDIA_ENDED, {
          stalled: false
        });
      }
      return;
    }
    if (!BufferHelper.getBuffered(media).length) {
      this.nudgeRetry = 0;
      return;
    }

    // Resolve stalls at buffer holes using the main buffer, whose ranges are the intersections of the A/V sourcebuffers
    const bufferInfo = BufferHelper.bufferInfo(media, currentTime, 0);
    const nextStart = bufferInfo.nextStart || 0;
    const fragmentTracker = this.fragmentTracker;
    if (seeking && fragmentTracker && this.hls) {
      // Is there a fragment loading/parsing/appending before currentTime?
      const inFlightDependency = getInFlightDependency(this.hls.inFlightFragments, currentTime);

      // Waiting for seeking in a buffered range to complete
      const hasEnoughBuffer = bufferInfo.len > MAX_START_GAP_JUMP;
      // Next buffered range is too far ahead to jump to while still seeking
      const noBufferHole = !nextStart || inFlightDependency || nextStart - currentTime > MAX_START_GAP_JUMP && !fragmentTracker.getPartialFragment(currentTime);
      if (hasEnoughBuffer || noBufferHole) {
        return;
      }
      // Reset moved state when seeking to a point in or before a gap/hole
      this.moved = false;
    }

    // Skip start gaps if we haven't played, but the last poll detected the start of a stall
    // The addition poll gives the browser a chance to jump the gap for us
    const levelDetails = (_this$hls2 = this.hls) == null ? void 0 : _this$hls2.latestLevelDetails;
    if (!this.moved && this.stalled !== null && fragmentTracker) {
      // There is no playable buffer (seeked, waiting for buffer)
      const isBuffered = bufferInfo.len > 0;
      if (!isBuffered && !nextStart) {
        return;
      }
      // Jump start gaps within jump threshold
      const startJump = Math.max(nextStart, bufferInfo.start || 0) - currentTime;

      // When joining a live stream with audio tracks, account for live playlist window sliding by allowing
      // a larger jump over start gaps caused by the audio-stream-controller buffering a start fragment
      // that begins over 1 target duration after the video start position.
      const isLive = !!(levelDetails != null && levelDetails.live);
      const maxStartGapJump = isLive ? levelDetails.targetduration * 2 : MAX_START_GAP_JUMP;
      const partialOrGap = fragmentTracker.getPartialFragment(currentTime);
      if (startJump > 0 && (startJump <= maxStartGapJump || partialOrGap)) {
        if (!media.paused) {
          this._trySkipBufferHole(partialOrGap);
        }
        return;
      }
    }

    // Start tracking stall time
    const detectStallWithCurrentTimeMs = config.detectStallWithCurrentTimeMs;
    const tnow = self.performance.now();
    const tWaiting = this.waiting;
    let stalled = this.stalled;
    if (stalled === null) {
      // Use time of recent "waiting" event
      if (tWaiting > 0 && tnow - tWaiting < detectStallWithCurrentTimeMs) {
        stalled = this.stalled = tWaiting;
      } else {
        this.stalled = tnow;
        return;
      }
    }
    const stalledDuration = tnow - stalled;
    if (!seeking && (stalledDuration >= detectStallWithCurrentTimeMs || tWaiting) && this.hls) {
      var _this$mediaSource;
      // Dispatch MEDIA_ENDED when media.ended/ended event is not signalled at end of stream
      if (((_this$mediaSource = this.mediaSource) == null ? void 0 : _this$mediaSource.readyState) === 'ended' && !(levelDetails != null && levelDetails.live) && Math.abs(currentTime - ((levelDetails == null ? void 0 : levelDetails.edge) || 0)) < 1) {
        if (this.ended) {
          return;
        }
        this.ended = currentTime || 1;
        this.hls.trigger(Events.MEDIA_ENDED, {
          stalled: true
        });
        return;
      }
      // Report stalling after trying to fix
      this._reportStall(bufferInfo);
      if (!this.media || !this.hls) {
        return;
      }
    }
    const bufferedWithHoles = BufferHelper.bufferInfo(media, currentTime, config.maxBufferHole);
    this._tryFixBufferStall(bufferedWithHoles, stalledDuration, currentTime);
  }
  stallResolved(currentTime) {
    const stalled = this.stalled;
    if (stalled && this.hls) {
      this.stalled = null;
      // The playhead is now moving, but was previously stalled
      if (this.stallReported) {
        const stalledDuration = self.performance.now() - stalled;
        this.log(`playback not stuck anymore @${currentTime}, after ${Math.round(stalledDuration)}ms`);
        this.stallReported = false;
        this.waiting = 0;
        this.hls.trigger(Events.STALL_RESOLVED, {});
      }
    }
  }
  nudgeOnVideoHole(currentTime, lastCurrentTime) {
    var _this$buffered$audio;
    // Chrome will play one second past a hole in video buffered time ranges without rendering any video from the subsequent range and then stall as long as audio is buffered:
    // https://github.com/video-dev/hls.js/issues/5631
    // https://issues.chromium.org/issues/40280613#comment10
    // Detect the potential for this situation and proactively seek to flush the video pipeline once the playhead passes the start of the video hole.
    // When there are audio and video buffers and currentTime is past the end of the first video buffered range...
    const videoSourceBuffered = this.buffered.video;
    if (this.hls && this.media && this.fragmentTracker && (_this$buffered$audio = this.buffered.audio) != null && _this$buffered$audio.length && videoSourceBuffered && videoSourceBuffered.length > 1 && currentTime > videoSourceBuffered.end(0)) {
      // and audio is buffered at the playhead
      const audioBufferInfo = BufferHelper.bufferedInfo(BufferHelper.timeRangesToArray(this.buffered.audio), currentTime, 0);
      if (audioBufferInfo.len > 1 && lastCurrentTime >= audioBufferInfo.start) {
        const videoTimes = BufferHelper.timeRangesToArray(videoSourceBuffered);
        const lastBufferedIndex = BufferHelper.bufferedInfo(videoTimes, lastCurrentTime, 0).bufferedIndex;
        // nudge when crossing into another video buffered range (hole).
        if (lastBufferedIndex > -1 && lastBufferedIndex < videoTimes.length - 1) {
          const bufferedIndex = BufferHelper.bufferedInfo(videoTimes, currentTime, 0).bufferedIndex;
          const holeStart = videoTimes[lastBufferedIndex].end;
          const holeEnd = videoTimes[lastBufferedIndex + 1].start;
          if ((bufferedIndex === -1 || bufferedIndex > lastBufferedIndex) && holeEnd - holeStart < 1 &&
          // `maxBufferHole` may be too small and setting it to 0 should not disable this feature
          currentTime - holeStart < 2) {
            const error = new Error(`nudging playhead to flush pipeline after video hole. currentTime: ${currentTime} hole: ${holeStart} -> ${holeEnd} buffered index: ${bufferedIndex}`);
            this.warn(error.message);
            // Magic number to flush the pipeline without interuption to audio playback:
            this.media.currentTime += 0.000001;
            const frag = this.fragmentTracker.getPartialFragment(currentTime) || undefined;
            const bufferInfo = BufferHelper.bufferInfo(this.media, currentTime, 0);
            this.hls.trigger(Events.ERROR, {
              type: ErrorTypes.MEDIA_ERROR,
              details: ErrorDetails.BUFFER_SEEK_OVER_HOLE,
              fatal: false,
              error,
              reason: error.message,
              frag,
              buffer: bufferInfo.len,
              bufferInfo
            });
          }
        }
      }
    }
  }

  /**
   * Detects and attempts to fix known buffer stalling issues.
   * @param bufferInfo - The properties of the current buffer.
   * @param stalledDurationMs - The amount of time Hls.js has been stalling for.
   * @private
   */
  _tryFixBufferStall(bufferInfo, stalledDurationMs, currentTime) {
    var _this$hls3, _this$hls4;
    const {
      fragmentTracker,
      media
    } = this;
    const config = (_this$hls3 = this.hls) == null ? void 0 : _this$hls3.config;
    if (!media || !fragmentTracker || !config) {
      return;
    }
    const levelDetails = (_this$hls4 = this.hls) == null ? void 0 : _this$hls4.latestLevelDetails;
    const partial = fragmentTracker.getPartialFragment(currentTime);
    if (partial || levelDetails != null && levelDetails.live && currentTime < levelDetails.fragmentStart) {
      // Try to skip over the buffer hole caused by a partial fragment
      // This method isn't limited by the size of the gap between buffered ranges
      const targetTime = this._trySkipBufferHole(partial);
      // we return here in this case, meaning
      // the branch below only executes when we haven't seeked to a new position
      if (targetTime || !this.media) {
        return;
      }
    }

    // if we haven't had to skip over a buffer hole of a partial fragment
    // we may just have to "nudge" the playlist as the browser decoding/rendering engine
    // needs to cross some sort of threshold covering all source-buffers content
    // to start playing properly.
    const bufferedRanges = bufferInfo.buffered;
    const adjacentTraversal = this.adjacentTraversal(bufferInfo, currentTime);
    if ((bufferedRanges && bufferedRanges.length > 1 && bufferInfo.len > config.maxBufferHole || bufferInfo.nextStart && (bufferInfo.nextStart - currentTime < config.maxBufferHole || adjacentTraversal)) && (stalledDurationMs > config.highBufferWatchdogPeriod * 1000 || this.waiting)) {
      this.warn('Trying to nudge playhead over buffer-hole');
      // Try to nudge currentTime over a buffer hole if we've been stalling for the configured amount of seconds
      // We only try to jump the hole if it's under the configured size
      this._tryNudgeBuffer(bufferInfo);
    }
  }
  adjacentTraversal(bufferInfo, currentTime) {
    const fragmentTracker = this.fragmentTracker;
    const nextStart = bufferInfo.nextStart;
    if (fragmentTracker && nextStart) {
      const current = fragmentTracker.getFragAtPos(currentTime, PlaylistLevelType.MAIN);
      const next = fragmentTracker.getFragAtPos(nextStart, PlaylistLevelType.MAIN);
      if (current && next) {
        return next.sn - current.sn < 2;
      }
    }
    return false;
  }

  /**
   * Triggers a BUFFER_STALLED_ERROR event, but only once per stall period.
   * @param bufferLen - The playhead distance from the end of the current buffer segment.
   * @private
   */
  _reportStall(bufferInfo) {
    const {
      hls,
      media,
      stallReported,
      stalled
    } = this;
    if (!stallReported && stalled !== null && media && hls) {
      // Report stalled error once
      this.stallReported = true;
      const error = new Error(`Playback stalling at @${media.currentTime} due to low buffer (${hls_stringify(bufferInfo)})`);
      this.warn(error.message);
      hls.trigger(Events.ERROR, {
        type: ErrorTypes.MEDIA_ERROR,
        details: ErrorDetails.BUFFER_STALLED_ERROR,
        fatal: false,
        error,
        buffer: bufferInfo.len,
        bufferInfo,
        stalled: {
          start: stalled
        }
      });
    }
  }

  /**
   * Attempts to fix buffer stalls by jumping over known gaps caused by partial fragments
   * @param partial - The partial fragment found at the current time (where playback is stalling).
   * @private
   */
  _trySkipBufferHole(partial) {
    var _this$hls5;
    const {
      fragmentTracker,
      media
    } = this;
    const config = (_this$hls5 = this.hls) == null ? void 0 : _this$hls5.config;
    if (!media || !fragmentTracker || !config) {
      return 0;
    }

    // Check if currentTime is between unbuffered regions of partial fragments
    const currentTime = media.currentTime;
    const bufferInfo = BufferHelper.bufferInfo(media, currentTime, 0);
    const startTime = currentTime < bufferInfo.start ? bufferInfo.start : bufferInfo.nextStart;
    if (startTime && this.hls) {
      const bufferStarved = bufferInfo.len <= config.maxBufferHole;
      const waiting = bufferInfo.len > 0 && bufferInfo.len < 1 && media.readyState < 3;
      const gapLength = startTime - currentTime;
      if (gapLength > 0 && (bufferStarved || waiting)) {
        // Only allow large gaps to be skipped if it is a start gap, or all fragments in skip range are partial
        if (gapLength > config.maxBufferHole) {
          let startGap = false;
          if (currentTime === 0) {
            const startFrag = fragmentTracker.getAppendedFrag(0, PlaylistLevelType.MAIN);
            if (startFrag && startTime < startFrag.end) {
              startGap = true;
            }
          }
          if (!startGap) {
            const startProvisioned = partial || fragmentTracker.getAppendedFrag(currentTime, PlaylistLevelType.MAIN);
            if (startProvisioned) {
              var _this$hls$loadLevelOb;
              // Do not seek when selected variant playlist is unloaded
              if (!((_this$hls$loadLevelOb = this.hls.loadLevelObj) != null && _this$hls$loadLevelOb.details)) {
                return 0;
              }
              // Do not seek when required fragments are inflight or appending
              const inFlightDependency = getInFlightDependency(this.hls.inFlightFragments, startTime);
              if (inFlightDependency) {
                return 0;
              }
              // Do not seek if we can't walk tracked fragments to end of gap
              let moreToLoad = false;
              let pos = startProvisioned.end;
              while (pos < startTime) {
                const provisioned = fragmentTracker.getPartialFragment(pos);
                if (provisioned) {
                  pos += provisioned.duration;
                } else {
                  moreToLoad = true;
                  break;
                }
              }
              if (moreToLoad) {
                return 0;
              }
            }
          }
        }
        const targetTime = Math.max(startTime + SKIP_BUFFER_RANGE_START, currentTime + SKIP_BUFFER_HOLE_STEP_SECONDS);
        this.warn(`skipping hole, adjusting currentTime from ${currentTime} to ${targetTime}`);
        this.moved = true;
        media.currentTime = targetTime;
        if (!(partial != null && partial.gap)) {
          const error = new Error(`fragment loaded with buffer holes, seeking from ${currentTime} to ${targetTime}`);
          this.hls.trigger(Events.ERROR, {
            type: ErrorTypes.MEDIA_ERROR,
            details: ErrorDetails.BUFFER_SEEK_OVER_HOLE,
            fatal: false,
            error,
            reason: error.message,
            frag: partial || undefined,
            buffer: bufferInfo.len,
            bufferInfo
          });
        }
        return targetTime;
      }
    }
    return 0;
  }

  /**
   * Attempts to fix buffer stalls by advancing the mediaElement's current time by a small amount.
   * @private
   */
  _tryNudgeBuffer(bufferInfo) {
    const {
      hls,
      media,
      nudgeRetry
    } = this;
    const config = hls == null ? void 0 : hls.config;
    if (!media || !config) {
      return 0;
    }
    const currentTime = media.currentTime;
    this.nudgeRetry++;
    if (nudgeRetry < config.nudgeMaxRetry) {
      const targetTime = currentTime + (nudgeRetry + 1) * config.nudgeOffset;
      // playback stalled in buffered area ... let's nudge currentTime to try to overcome this
      const error = new Error(`Nudging 'currentTime' from ${currentTime} to ${targetTime}`);
      this.warn(error.message);
      media.currentTime = targetTime;
      hls.trigger(Events.ERROR, {
        type: ErrorTypes.MEDIA_ERROR,
        details: ErrorDetails.BUFFER_NUDGE_ON_STALL,
        error,
        fatal: false,
        buffer: bufferInfo.len,
        bufferInfo
      });
    } else {
      const error = new Error(`Playhead still not moving while enough data buffered @${currentTime} after ${config.nudgeMaxRetry} nudges`);
      this.error(error.message);
      hls.trigger(Events.ERROR, {
        type: ErrorTypes.MEDIA_ERROR,
        details: ErrorDetails.BUFFER_STALLED_ERROR,
        error,
        fatal: true,
        buffer: bufferInfo.len,
        bufferInfo
      });
    }
  }
}
function getInFlightDependency(inFlightFragments, currentTime) {
  const main = inFlight(inFlightFragments.main);
  if (main && main.start <= currentTime) {
    return main;
  }
  const audio = inFlight(inFlightFragments.audio);
  if (audio && audio.start <= currentTime) {
    return audio;
  }
  return null;
}
function inFlight(inFlightData) {
  if (!inFlightData) {
    return null;
  }
  switch (inFlightData.state) {
    case State.IDLE:
    case State.STOPPED:
    case State.ENDED:
    case State.ERROR:
      return null;
  }
  return inFlightData.frag;
}

const MIN_CUE_DURATION = 0.25;
function getCueClass() {
  if (typeof self === 'undefined') return undefined;
  return self.VTTCue || self.TextTrackCue;
}
function createCueWithDataFields(Cue, startTime, endTime, data, type) {
  let cue = new Cue(startTime, endTime, '');
  try {
    cue.value = data;
    if (type) {
      cue.type = type;
    }
  } catch (e) {
    cue = new Cue(startTime, endTime, hls_stringify(type ? _objectSpread2({
      type
    }, data) : data));
  }
  return cue;
}

// VTTCue latest draft allows an infinite duration, fallback
// to MAX_VALUE if necessary
const MAX_CUE_ENDTIME = (() => {
  const Cue = getCueClass();
  try {
    Cue && new Cue(0, Number.POSITIVE_INFINITY, '');
  } catch (e) {
    return Number.MAX_VALUE;
  }
  return Number.POSITIVE_INFINITY;
})();
function hexToArrayBuffer(str) {
  return Uint8Array.from(str.replace(/^0x/, '').replace(/([\da-fA-F]{2}) ?/g, '0x$1 ').replace(/ +$/, '').split(' ')).buffer;
}
class ID3TrackController {
  constructor(hls) {
    this.hls = void 0;
    this.id3Track = null;
    this.media = null;
    this.dateRangeCuesAppended = {};
    this.removeCues = true;
    this.onEventCueEnter = () => {
      if (!this.hls) {
        return;
      }
      this.hls.trigger(Events.EVENT_CUE_ENTER, {});
    };
    this.hls = hls;
    this._registerListeners();
  }
  destroy() {
    this._unregisterListeners();
    this.id3Track = null;
    this.media = null;
    this.dateRangeCuesAppended = {};
    // @ts-ignore
    this.hls = this.onEventCueEnter = null;
  }
  _registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
    hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this);
    hls.on(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
    hls.on(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
    hls.on(Events.LEVEL_PTS_UPDATED, this.onLevelPtsUpdated, this);
  }
  _unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
    hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this);
    hls.off(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
    hls.off(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
    hls.off(Events.LEVEL_PTS_UPDATED, this.onLevelPtsUpdated, this);
  }
  // Add ID3 metatadata text track.
  onMediaAttaching(event, data) {
    var _data$overrides;
    this.media = data.media;
    if (((_data$overrides = data.overrides) == null ? void 0 : _data$overrides.cueRemoval) === false) {
      this.removeCues = false;
    }
  }
  onMediaAttached() {
    const details = this.hls.latestLevelDetails;
    if (details) {
      this.updateDateRangeCues(details);
    }
  }
  onMediaDetaching(event, data) {
    this.media = null;
    const transferringMedia = !!data.transferMedia;
    if (transferringMedia) {
      return;
    }
    if (this.id3Track) {
      if (this.removeCues) {
        clearCurrentCues(this.id3Track, this.onEventCueEnter);
      }
      this.id3Track = null;
    }
    this.dateRangeCuesAppended = {};
  }
  onManifestLoading() {
    this.dateRangeCuesAppended = {};
  }
  createTrack(media) {
    const track = this.getID3Track(media.textTracks);
    track.mode = 'hidden';
    return track;
  }
  getID3Track(textTracks) {
    if (!this.media) {
      return;
    }
    for (let i = 0; i < textTracks.length; i++) {
      const textTrack = textTracks[i];
      if (textTrack.kind === 'metadata' && textTrack.label === 'id3') {
        // send 'addtrack' when reusing the textTrack for metadata,
        // same as what we do for captions
        sendAddTrackEvent(textTrack, this.media);
        return textTrack;
      }
    }
    return this.media.addTextTrack('metadata', 'id3');
  }
  onFragParsingMetadata(event, data) {
    if (!this.media) {
      return;
    }
    const {
      hls: {
        config: {
          enableEmsgMetadataCues,
          enableID3MetadataCues
        }
      }
    } = this;
    if (!enableEmsgMetadataCues && !enableID3MetadataCues) {
      return;
    }
    const {
      samples
    } = data;

    // create track dynamically
    if (!this.id3Track) {
      this.id3Track = this.createTrack(this.media);
    }
    const Cue = getCueClass();
    if (!Cue) {
      return;
    }
    for (let i = 0; i < samples.length; i++) {
      const type = samples[i].type;
      if (type === MetadataSchema.emsg && !enableEmsgMetadataCues || !enableID3MetadataCues) {
        continue;
      }
      const frames = getId3Frames(samples[i].data);
      if (frames) {
        const startTime = samples[i].pts;
        let endTime = startTime + samples[i].duration;
        if (endTime > MAX_CUE_ENDTIME) {
          endTime = MAX_CUE_ENDTIME;
        }
        const timeDiff = endTime - startTime;
        if (timeDiff <= 0) {
          endTime = startTime + MIN_CUE_DURATION;
        }
        for (let j = 0; j < frames.length; j++) {
          const frame = frames[j];
          // Safari doesn't put the timestamp frame in the TextTrack
          if (!isId3TimestampFrame(frame)) {
            // add a bounds to any unbounded cues
            this.updateId3CueEnds(startTime, type);
            const cue = createCueWithDataFields(Cue, startTime, endTime, frame, type);
            if (cue) {
              this.id3Track.addCue(cue);
            }
          }
        }
      }
    }
  }
  updateId3CueEnds(startTime, type) {
    var _this$id3Track;
    const cues = (_this$id3Track = this.id3Track) == null ? void 0 : _this$id3Track.cues;
    if (cues) {
      for (let i = cues.length; i--;) {
        const cue = cues[i];
        if (cue.type === type && cue.startTime < startTime && cue.endTime === MAX_CUE_ENDTIME) {
          cue.endTime = startTime;
        }
      }
    }
  }
  onBufferFlushing(event, {
    startOffset,
    endOffset,
    type
  }) {
    const {
      id3Track,
      hls
    } = this;
    if (!hls) {
      return;
    }
    const {
      config: {
        enableEmsgMetadataCues,
        enableID3MetadataCues
      }
    } = hls;
    if (id3Track && (enableEmsgMetadataCues || enableID3MetadataCues)) {
      let predicate;
      if (type === 'audio') {
        predicate = cue => cue.type === MetadataSchema.audioId3 && enableID3MetadataCues;
      } else if (type === 'video') {
        predicate = cue => cue.type === MetadataSchema.emsg && enableEmsgMetadataCues;
      } else {
        predicate = cue => cue.type === MetadataSchema.audioId3 && enableID3MetadataCues || cue.type === MetadataSchema.emsg && enableEmsgMetadataCues;
      }
      removeCuesInRange(id3Track, startOffset, endOffset, predicate);
    }
  }
  onLevelUpdated(event, {
    details
  }) {
    this.updateDateRangeCues(details, true);
  }
  onLevelPtsUpdated(event, data) {
    if (Math.abs(data.drift) > 0.01) {
      this.updateDateRangeCues(data.details);
    }
  }
  updateDateRangeCues(details, removeOldCues) {
    if (!this.media || !details.hasProgramDateTime || !this.hls.config.enableDateRangeMetadataCues) {
      return;
    }
    const {
      id3Track
    } = this;
    const {
      dateRanges
    } = details;
    const ids = Object.keys(dateRanges);
    let dateRangeCuesAppended = this.dateRangeCuesAppended;
    // Remove cues from track not found in details.dateRanges
    if (id3Track && removeOldCues) {
      var _id3Track$cues;
      if ((_id3Track$cues = id3Track.cues) != null && _id3Track$cues.length) {
        const idsToRemove = Object.keys(dateRangeCuesAppended).filter(id => !ids.includes(id));
        for (let i = idsToRemove.length; i--;) {
          const id = idsToRemove[i];
          const cues = dateRangeCuesAppended[id].cues;
          delete dateRangeCuesAppended[id];
          Object.keys(cues).forEach(key => {
            try {
              const cue = cues[key];
              cue.removeEventListener('enter', this.onEventCueEnter);
              id3Track.removeCue(cue);
            } catch (e) {
              /* no-op */
            }
          });
        }
      } else {
        dateRangeCuesAppended = this.dateRangeCuesAppended = {};
      }
    }
    // Exit if the playlist does not have Date Ranges or does not have Program Date Time
    const lastFragment = details.fragments[details.fragments.length - 1];
    if (ids.length === 0 || !isFiniteNumber(lastFragment == null ? void 0 : lastFragment.programDateTime)) {
      return;
    }
    if (!this.id3Track) {
      this.id3Track = this.createTrack(this.media);
    }
    const Cue = getCueClass();
    for (let i = 0; i < ids.length; i++) {
      const id = ids[i];
      const dateRange = dateRanges[id];
      const startTime = dateRange.startTime;

      // Process DateRanges to determine end-time (known DURATION, END-DATE, or END-ON-NEXT)
      const appendedDateRangeCues = dateRangeCuesAppended[id];
      const cues = (appendedDateRangeCues == null ? void 0 : appendedDateRangeCues.cues) || {};
      let durationKnown = (appendedDateRangeCues == null ? void 0 : appendedDateRangeCues.durationKnown) || false;
      let endTime = MAX_CUE_ENDTIME;
      const {
        duration,
        endDate
      } = dateRange;
      if (endDate && duration !== null) {
        endTime = startTime + duration;
        durationKnown = true;
      } else if (dateRange.endOnNext && !durationKnown) {
        const nextDateRangeWithSameClass = ids.reduce((candidateDateRange, id) => {
          if (id !== dateRange.id) {
            const otherDateRange = dateRanges[id];
            if (otherDateRange.class === dateRange.class && otherDateRange.startDate > dateRange.startDate && (!candidateDateRange || dateRange.startDate < candidateDateRange.startDate)) {
              return otherDateRange;
            }
          }
          return candidateDateRange;
        }, null);
        if (nextDateRangeWithSameClass) {
          endTime = nextDateRangeWithSameClass.startTime;
          durationKnown = true;
        }
      }

      // Create TextTrack Cues for each MetadataGroup Item (select DateRange attribute)
      // This is to emulate Safari HLS playback handling of DateRange tags
      const attributes = Object.keys(dateRange.attr);
      for (let j = 0; j < attributes.length; j++) {
        const key = attributes[j];
        if (!isDateRangeCueAttribute(key)) {
          continue;
        }
        const cue = cues[key];
        if (cue) {
          if (durationKnown && !appendedDateRangeCues.durationKnown) {
            cue.endTime = endTime;
          } else if (Math.abs(cue.startTime - startTime) > 0.01) {
            cue.startTime = startTime;
            cue.endTime = endTime;
          }
        } else if (Cue) {
          let data = dateRange.attr[key];
          if (isSCTE35Attribute(key)) {
            data = hexToArrayBuffer(data);
          }
          const payload = {
            key,
            data
          };
          const _cue = createCueWithDataFields(Cue, startTime, endTime, payload, MetadataSchema.dateRange);
          if (_cue) {
            _cue.id = id;
            this.id3Track.addCue(_cue);
            cues[key] = _cue;
            if (this.hls.config.interstitialsController) {
              if (key === 'X-ASSET-LIST' || key === 'X-ASSET-URL') {
                _cue.addEventListener('enter', this.onEventCueEnter);
              }
            }
          }
        }
      }

      // Keep track of processed DateRanges by ID for updating cues with new DateRange tag attributes
      dateRangeCuesAppended[id] = {
        cues,
        dateRange,
        durationKnown
      };
    }
  }
}

class LatencyController {
  constructor(hls) {
    this.hls = void 0;
    this.config = void 0;
    this.media = null;
    this.currentTime = 0;
    this.stallCount = 0;
    this._latency = null;
    this._targetLatencyUpdated = false;
    this.onTimeupdate = () => {
      const {
        media
      } = this;
      const levelDetails = this.levelDetails;
      if (!media || !levelDetails) {
        return;
      }
      this.currentTime = media.currentTime;
      const latency = this.computeLatency();
      if (latency === null) {
        return;
      }
      this._latency = latency;

      // Adapt playbackRate to meet target latency in low-latency mode
      const {
        lowLatencyMode,
        maxLiveSyncPlaybackRate
      } = this.config;
      if (!lowLatencyMode || maxLiveSyncPlaybackRate === 1 || !levelDetails.live) {
        return;
      }
      const targetLatency = this.targetLatency;
      if (targetLatency === null) {
        return;
      }
      const distanceFromTarget = latency - targetLatency;
      // Only adjust playbackRate when within one target duration of targetLatency
      // and more than one second from under-buffering.
      // Playback further than one target duration from target can be considered DVR playback.
      const liveMinLatencyDuration = Math.min(this.maxLatency, targetLatency + levelDetails.targetduration);
      const inLiveRange = distanceFromTarget < liveMinLatencyDuration;
      if (inLiveRange && distanceFromTarget > 0.05 && this.forwardBufferLength > 1) {
        const max = Math.min(2, Math.max(1.0, maxLiveSyncPlaybackRate));
        const rate = Math.round(2 / (1 + Math.exp(-0.75 * distanceFromTarget - this.edgeStalled)) * 20) / 20;
        const playbackRate = Math.min(max, Math.max(1, rate));
        this.changeMediaPlaybackRate(media, playbackRate);
      } else if (media.playbackRate !== 1 && media.playbackRate !== 0) {
        this.changeMediaPlaybackRate(media, 1);
      }
    };
    this.hls = hls;
    this.config = hls.config;
    this.registerListeners();
  }
  get levelDetails() {
    var _this$hls;
    return ((_this$hls = this.hls) == null ? void 0 : _this$hls.latestLevelDetails) || null;
  }
  get latency() {
    return this._latency || 0;
  }
  get maxLatency() {
    const {
      config
    } = this;
    if (config.liveMaxLatencyDuration !== undefined) {
      return config.liveMaxLatencyDuration;
    }
    const levelDetails = this.levelDetails;
    return levelDetails ? config.liveMaxLatencyDurationCount * levelDetails.targetduration : 0;
  }
  get targetLatency() {
    const levelDetails = this.levelDetails;
    if (levelDetails === null || this.hls === null) {
      return null;
    }
    const {
      holdBack,
      partHoldBack,
      targetduration
    } = levelDetails;
    const {
      liveSyncDuration,
      liveSyncDurationCount,
      lowLatencyMode
    } = this.config;
    const userConfig = this.hls.userConfig;
    let targetLatency = lowLatencyMode ? partHoldBack || holdBack : holdBack;
    if (this._targetLatencyUpdated || userConfig.liveSyncDuration || userConfig.liveSyncDurationCount || targetLatency === 0) {
      targetLatency = liveSyncDuration !== undefined ? liveSyncDuration : liveSyncDurationCount * targetduration;
    }
    const maxLiveSyncOnStallIncrease = targetduration;
    return targetLatency + Math.min(this.stallCount * this.config.liveSyncOnStallIncrease, maxLiveSyncOnStallIncrease);
  }
  set targetLatency(latency) {
    this.stallCount = 0;
    this.config.liveSyncDuration = latency;
    this._targetLatencyUpdated = true;
  }
  get liveSyncPosition() {
    const liveEdge = this.estimateLiveEdge();
    const targetLatency = this.targetLatency;
    if (liveEdge === null || targetLatency === null) {
      return null;
    }
    const levelDetails = this.levelDetails;
    if (levelDetails === null) {
      return null;
    }
    const edge = levelDetails.edge;
    const syncPosition = liveEdge - targetLatency - this.edgeStalled;
    const min = edge - levelDetails.totalduration;
    const max = edge - (this.config.lowLatencyMode && levelDetails.partTarget || levelDetails.targetduration);
    return Math.min(Math.max(min, syncPosition), max);
  }
  get drift() {
    const levelDetails = this.levelDetails;
    if (levelDetails === null) {
      return 1;
    }
    return levelDetails.drift;
  }
  get edgeStalled() {
    const levelDetails = this.levelDetails;
    if (levelDetails === null) {
      return 0;
    }
    const maxLevelUpdateAge = (this.config.lowLatencyMode && levelDetails.partTarget || levelDetails.targetduration) * 3;
    return Math.max(levelDetails.age - maxLevelUpdateAge, 0);
  }
  get forwardBufferLength() {
    const {
      media
    } = this;
    const levelDetails = this.levelDetails;
    if (!media || !levelDetails) {
      return 0;
    }
    const bufferedRanges = media.buffered.length;
    return (bufferedRanges ? media.buffered.end(bufferedRanges - 1) : levelDetails.edge) - this.currentTime;
  }
  destroy() {
    this.unregisterListeners();
    this.onMediaDetaching();
    this.hls = null;
  }
  registerListeners() {
    const {
      hls
    } = this;
    if (!hls) {
      return;
    }
    hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
    hls.on(Events.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls
    } = this;
    if (!hls) {
      return;
    }
    hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
    hls.off(Events.ERROR, this.onError, this);
  }
  onMediaAttached(event, data) {
    this.media = data.media;
    this.media.addEventListener('timeupdate', this.onTimeupdate);
  }
  onMediaDetaching() {
    if (this.media) {
      this.media.removeEventListener('timeupdate', this.onTimeupdate);
      this.media = null;
    }
  }
  onManifestLoading() {
    this._latency = null;
    this.stallCount = 0;
  }
  onLevelUpdated(event, {
    details
  }) {
    if (details.advanced) {
      this.onTimeupdate();
    }
    if (!details.live && this.media) {
      this.media.removeEventListener('timeupdate', this.onTimeupdate);
    }
  }
  onError(event, data) {
    var _this$levelDetails;
    if (data.details !== ErrorDetails.BUFFER_STALLED_ERROR) {
      return;
    }
    this.stallCount++;
    if (this.hls && (_this$levelDetails = this.levelDetails) != null && _this$levelDetails.live) {
      this.hls.logger.warn('[latency-controller]: Stall detected, adjusting target latency');
    }
  }
  changeMediaPlaybackRate(media, playbackRate) {
    var _this$hls2, _this$targetLatency;
    if (media.playbackRate === playbackRate) {
      return;
    }
    (_this$hls2 = this.hls) == null ? void 0 : _this$hls2.logger.debug(`[latency-controller]: latency=${this.latency.toFixed(3)}, targetLatency=${(_this$targetLatency = this.targetLatency) == null ? void 0 : _this$targetLatency.toFixed(3)}, forwardBufferLength=${this.forwardBufferLength.toFixed(3)}: adjusting playback rate from ${media.playbackRate} to ${playbackRate}`);
    media.playbackRate = playbackRate;
  }
  estimateLiveEdge() {
    const levelDetails = this.levelDetails;
    if (levelDetails === null) {
      return null;
    }
    return levelDetails.edge + levelDetails.age;
  }
  computeLatency() {
    const liveEdge = this.estimateLiveEdge();
    if (liveEdge === null) {
      return null;
    }
    return liveEdge - this.currentTime;
  }
}

class LevelController extends BasePlaylistController {
  constructor(hls, contentSteeringController) {
    super(hls, 'level-controller');
    this._levels = [];
    this._firstLevel = -1;
    this._maxAutoLevel = -1;
    this._startLevel = void 0;
    this.currentLevel = null;
    this.currentLevelIndex = -1;
    this.manualLevelIndex = -1;
    this.steering = void 0;
    this.onParsedComplete = void 0;
    this.steering = contentSteeringController;
    this._registerListeners();
  }
  _registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
    hls.on(Events.LEVEL_LOADED, this.onLevelLoaded, this);
    hls.on(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
    hls.on(Events.FRAG_BUFFERED, this.onFragBuffered, this);
    hls.on(Events.ERROR, this.onError, this);
  }
  _unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
    hls.off(Events.LEVEL_LOADED, this.onLevelLoaded, this);
    hls.off(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
    hls.off(Events.FRAG_BUFFERED, this.onFragBuffered, this);
    hls.off(Events.ERROR, this.onError, this);
  }
  destroy() {
    this._unregisterListeners();
    this.steering = null;
    this.resetLevels();
    super.destroy();
  }
  stopLoad() {
    const levels = this._levels;

    // clean up live level details to force reload them, and reset load errors
    levels.forEach(level => {
      level.loadError = 0;
      level.fragmentError = 0;
    });
    super.stopLoad();
  }
  resetLevels() {
    this._startLevel = undefined;
    this.manualLevelIndex = -1;
    this.currentLevelIndex = -1;
    this.currentLevel = null;
    this._levels = [];
    this._maxAutoLevel = -1;
  }
  onManifestLoading(event, data) {
    this.resetLevels();
  }
  onManifestLoaded(event, data) {
    const preferManagedMediaSource = this.hls.config.preferManagedMediaSource;
    const levels = [];
    const redundantSet = {};
    const generatePathwaySet = {};
    let resolutionFound = false;
    let videoCodecFound = false;
    let audioCodecFound = false;
    data.levels.forEach(levelParsed => {
      const attributes = levelParsed.attrs;
      let {
        audioCodec,
        videoCodec
      } = levelParsed;
      if (audioCodec) {
        // Returns empty and set to undefined for 'mp4a.40.34' with fallback to 'audio/mpeg' SourceBuffer
        levelParsed.audioCodec = audioCodec = getCodecCompatibleName(audioCodec, preferManagedMediaSource) || undefined;
      }
      if (videoCodec) {
        videoCodec = levelParsed.videoCodec = convertAVC1ToAVCOTI(videoCodec);
      }

      // only keep levels with supported audio/video codecs
      const {
        width,
        height,
        unknownCodecs
      } = levelParsed;
      let unknownUnsupportedCodecCount = unknownCodecs ? unknownCodecs.length : 0;
      if (unknownCodecs) {
        // Treat unknown codec as audio or video codec based on passing `isTypeSupported` check
        // (allows for playback of any supported codec even if not indexed in utils/codecs)
        for (let i = unknownUnsupportedCodecCount; i--;) {
          const unknownCodec = unknownCodecs[i];
          if (this.isAudioSupported(unknownCodec)) {
            levelParsed.audioCodec = audioCodec = audioCodec ? `${audioCodec},${unknownCodec}` : unknownCodec;
            unknownUnsupportedCodecCount--;
            sampleEntryCodesISO.audio[audioCodec.substring(0, 4)] = 2;
          } else if (this.isVideoSupported(unknownCodec)) {
            levelParsed.videoCodec = videoCodec = videoCodec ? `${videoCodec},${unknownCodec}` : unknownCodec;
            unknownUnsupportedCodecCount--;
            sampleEntryCodesISO.video[videoCodec.substring(0, 4)] = 2;
          }
        }
      }
      resolutionFound || (resolutionFound = !!(width && height));
      videoCodecFound || (videoCodecFound = !!videoCodec);
      audioCodecFound || (audioCodecFound = !!audioCodec);
      if (unknownUnsupportedCodecCount || audioCodec && !this.isAudioSupported(audioCodec) || videoCodec && !this.isVideoSupported(videoCodec)) {
        this.log(`Some or all CODECS not supported "${attributes.CODECS}"`);
        return;
      }
      const {
        CODECS,
        'FRAME-RATE': FRAMERATE,
        'HDCP-LEVEL': HDCP,
        'PATHWAY-ID': PATHWAY,
        RESOLUTION,
        'VIDEO-RANGE': VIDEO_RANGE
      } = attributes;
      const contentSteeringPrefix = `${PATHWAY || '.'}-`;
      const levelKey = `${contentSteeringPrefix}${levelParsed.bitrate}-${RESOLUTION}-${FRAMERATE}-${CODECS}-${VIDEO_RANGE}-${HDCP}`;
      if (!redundantSet[levelKey]) {
        const level = this.createLevel(levelParsed);
        redundantSet[levelKey] = level;
        generatePathwaySet[levelKey] = 1;
        levels.push(level);
      } else if (redundantSet[levelKey].uri !== levelParsed.url && !levelParsed.attrs['PATHWAY-ID']) {
        // Assign Pathway IDs to Redundant Streams (default Pathways is ".". Redundant Streams "..", "...", and so on.)
        // Content Steering controller to handles Pathway fallback on error
        const pathwayCount = generatePathwaySet[levelKey] += 1;
        levelParsed.attrs['PATHWAY-ID'] = new Array(pathwayCount + 1).join('.');
        const level = this.createLevel(levelParsed);
        redundantSet[levelKey] = level;
        levels.push(level);
      } else {
        redundantSet[levelKey].addGroupId('audio', attributes.AUDIO);
        redundantSet[levelKey].addGroupId('text', attributes.SUBTITLES);
      }
    });
    this.filterAndSortMediaOptions(levels, data, resolutionFound, videoCodecFound, audioCodecFound);
  }
  createLevel(levelParsed) {
    const level = new Level(levelParsed);
    const supplemental = levelParsed.supplemental;
    if (supplemental != null && supplemental.videoCodec && !this.isVideoSupported(supplemental.videoCodec)) {
      const error = new Error(`SUPPLEMENTAL-CODECS not supported "${supplemental.videoCodec}"`);
      this.log(error.message);
      level.supportedResult = getUnsupportedResult(error, []);
    }
    return level;
  }
  isAudioSupported(codec) {
    return areCodecsMediaSourceSupported(codec, 'audio', this.hls.config.preferManagedMediaSource);
  }
  isVideoSupported(codec) {
    return areCodecsMediaSourceSupported(codec, 'video', this.hls.config.preferManagedMediaSource);
  }
  filterAndSortMediaOptions(filteredLevels, data, resolutionFound, videoCodecFound, audioCodecFound) {
    let audioTracks = [];
    let subtitleTracks = [];
    let levels = filteredLevels;

    // remove audio-only and invalid video-range levels if we also have levels with video codecs or RESOLUTION signalled
    if ((resolutionFound || videoCodecFound) && audioCodecFound) {
      levels = levels.filter(({
        videoCodec,
        videoRange,
        width,
        height
      }) => (!!videoCodec || !!(width && height)) && isVideoRange(videoRange));
    }
    if (levels.length === 0) {
      // Dispatch error after MANIFEST_LOADED is done propagating
      Promise.resolve().then(() => {
        if (this.hls) {
          let message = 'no level with compatible codecs found in manifest';
          let reason = message;
          if (data.levels.length) {
            reason = `one or more CODECS in variant not supported: ${hls_stringify(data.levels.map(level => level.attrs.CODECS).filter((value, index, array) => array.indexOf(value) === index))}`;
            this.warn(reason);
            message += ` (${reason})`;
          }
          const error = new Error(message);
          this.hls.trigger(Events.ERROR, {
            type: ErrorTypes.MEDIA_ERROR,
            details: ErrorDetails.MANIFEST_INCOMPATIBLE_CODECS_ERROR,
            fatal: true,
            url: data.url,
            error,
            reason
          });
        }
      });
      return;
    }
    if (data.audioTracks) {
      audioTracks = data.audioTracks.filter(track => !track.audioCodec || this.isAudioSupported(track.audioCodec));
      // Assign ids after filtering as array indices by group-id
      assignTrackIdsByGroup(audioTracks);
    }
    if (data.subtitles) {
      subtitleTracks = data.subtitles;
      assignTrackIdsByGroup(subtitleTracks);
    }
    // start bitrate is the first bitrate of the manifest
    const unsortedLevels = levels.slice(0);
    // sort levels from lowest to highest
    levels.sort((a, b) => {
      if (a.attrs['HDCP-LEVEL'] !== b.attrs['HDCP-LEVEL']) {
        return (a.attrs['HDCP-LEVEL'] || '') > (b.attrs['HDCP-LEVEL'] || '') ? 1 : -1;
      }
      // sort on height before bitrate for cap-level-controller
      if (resolutionFound && a.height !== b.height) {
        return a.height - b.height;
      }
      if (a.frameRate !== b.frameRate) {
        return a.frameRate - b.frameRate;
      }
      if (a.videoRange !== b.videoRange) {
        return VideoRangeValues.indexOf(a.videoRange) - VideoRangeValues.indexOf(b.videoRange);
      }
      if (a.videoCodec !== b.videoCodec) {
        const valueA = videoCodecPreferenceValue(a.videoCodec);
        const valueB = videoCodecPreferenceValue(b.videoCodec);
        if (valueA !== valueB) {
          return valueB - valueA;
        }
      }
      if (a.uri === b.uri && a.codecSet !== b.codecSet) {
        const valueA = codecsSetSelectionPreferenceValue(a.codecSet);
        const valueB = codecsSetSelectionPreferenceValue(b.codecSet);
        if (valueA !== valueB) {
          return valueB - valueA;
        }
      }
      if (a.averageBitrate !== b.averageBitrate) {
        return a.averageBitrate - b.averageBitrate;
      }
      return 0;
    });
    let firstLevelInPlaylist = unsortedLevels[0];
    if (this.steering) {
      levels = this.steering.filterParsedLevels(levels);
      if (levels.length !== unsortedLevels.length) {
        for (let i = 0; i < unsortedLevels.length; i++) {
          if (unsortedLevels[i].pathwayId === levels[0].pathwayId) {
            firstLevelInPlaylist = unsortedLevels[i];
            break;
          }
        }
      }
    }
    this._levels = levels;

    // find index of first level in sorted levels
    for (let i = 0; i < levels.length; i++) {
      if (levels[i] === firstLevelInPlaylist) {
        var _this$hls$userConfig;
        this._firstLevel = i;
        const firstLevelBitrate = firstLevelInPlaylist.bitrate;
        const bandwidthEstimate = this.hls.bandwidthEstimate;
        this.log(`manifest loaded, ${levels.length} level(s) found, first bitrate: ${firstLevelBitrate}`);
        // Update default bwe to first variant bitrate as long it has not been configured or set
        if (((_this$hls$userConfig = this.hls.userConfig) == null ? void 0 : _this$hls$userConfig.abrEwmaDefaultEstimate) === undefined) {
          const startingBwEstimate = Math.min(firstLevelBitrate, this.hls.config.abrEwmaDefaultEstimateMax);
          if (startingBwEstimate > bandwidthEstimate && bandwidthEstimate === this.hls.abrEwmaDefaultEstimate) {
            this.hls.bandwidthEstimate = startingBwEstimate;
          }
        }
        break;
      }
    }

    // Audio is only alternate if manifest include a URI along with the audio group tag,
    // and this is not an audio-only stream where levels contain audio-only
    const audioOnly = audioCodecFound && !videoCodecFound;
    const config = this.hls.config;
    const altAudioEnabled = !!(config.audioStreamController && config.audioTrackController);
    const edata = {
      levels,
      audioTracks,
      subtitleTracks,
      sessionData: data.sessionData,
      sessionKeys: data.sessionKeys,
      firstLevel: this._firstLevel,
      stats: data.stats,
      audio: audioCodecFound,
      video: videoCodecFound,
      altAudio: altAudioEnabled && !audioOnly && audioTracks.some(t => !!t.url)
    };
    this.hls.trigger(Events.MANIFEST_PARSED, edata);
  }
  get levels() {
    if (this._levels.length === 0) {
      return null;
    }
    return this._levels;
  }
  get loadLevelObj() {
    return this.currentLevel;
  }
  get level() {
    return this.currentLevelIndex;
  }
  set level(newLevel) {
    const levels = this._levels;
    if (levels.length === 0) {
      return;
    }
    // check if level idx is valid
    if (newLevel < 0 || newLevel >= levels.length) {
      // invalid level id given, trigger error
      const error = new Error('invalid level idx');
      const fatal = newLevel < 0;
      this.hls.trigger(Events.ERROR, {
        type: ErrorTypes.OTHER_ERROR,
        details: ErrorDetails.LEVEL_SWITCH_ERROR,
        level: newLevel,
        fatal,
        error,
        reason: error.message
      });
      if (fatal) {
        return;
      }
      newLevel = Math.min(newLevel, levels.length - 1);
    }
    const lastLevelIndex = this.currentLevelIndex;
    const lastLevel = this.currentLevel;
    const lastPathwayId = lastLevel ? lastLevel.attrs['PATHWAY-ID'] : undefined;
    const level = levels[newLevel];
    const pathwayId = level.attrs['PATHWAY-ID'];
    this.currentLevelIndex = newLevel;
    this.currentLevel = level;
    if (lastLevelIndex === newLevel && lastLevel && lastPathwayId === pathwayId) {
      return;
    }
    this.log(`Switching to level ${newLevel} (${level.height ? level.height + 'p ' : ''}${level.videoRange ? level.videoRange + ' ' : ''}${level.codecSet ? level.codecSet + ' ' : ''}@${level.bitrate})${pathwayId ? ' with Pathway ' + pathwayId : ''} from level ${lastLevelIndex}${lastPathwayId ? ' with Pathway ' + lastPathwayId : ''}`);
    const levelSwitchingData = {
      level: newLevel,
      attrs: level.attrs,
      details: level.details,
      bitrate: level.bitrate,
      averageBitrate: level.averageBitrate,
      maxBitrate: level.maxBitrate,
      realBitrate: level.realBitrate,
      width: level.width,
      height: level.height,
      codecSet: level.codecSet,
      audioCodec: level.audioCodec,
      videoCodec: level.videoCodec,
      audioGroups: level.audioGroups,
      subtitleGroups: level.subtitleGroups,
      loaded: level.loaded,
      loadError: level.loadError,
      fragmentError: level.fragmentError,
      name: level.name,
      id: level.id,
      uri: level.uri,
      url: level.url,
      urlId: 0,
      audioGroupIds: level.audioGroupIds,
      textGroupIds: level.textGroupIds
    };
    this.hls.trigger(Events.LEVEL_SWITCHING, levelSwitchingData);
    // check if we need to load playlist for this level
    const levelDetails = level.details;
    if (!levelDetails || levelDetails.live) {
      // level not retrieved yet, or live playlist we need to (re)load it
      const hlsUrlParameters = this.switchParams(level.uri, lastLevel == null ? void 0 : lastLevel.details, levelDetails);
      this.loadPlaylist(hlsUrlParameters);
    }
  }
  get manualLevel() {
    return this.manualLevelIndex;
  }
  set manualLevel(newLevel) {
    this.manualLevelIndex = newLevel;
    if (this._startLevel === undefined) {
      this._startLevel = newLevel;
    }
    if (newLevel !== -1) {
      this.level = newLevel;
    }
  }
  get firstLevel() {
    return this._firstLevel;
  }
  set firstLevel(newLevel) {
    this._firstLevel = newLevel;
  }
  get startLevel() {
    // Setting hls.startLevel (this._startLevel) overrides config.startLevel
    if (this._startLevel === undefined) {
      const configStartLevel = this.hls.config.startLevel;
      if (configStartLevel !== undefined) {
        return configStartLevel;
      }
      return this.hls.firstAutoLevel;
    }
    return this._startLevel;
  }
  set startLevel(newLevel) {
    this._startLevel = newLevel;
  }
  get pathways() {
    if (this.steering) {
      return this.steering.pathways();
    }
    return [];
  }
  get pathwayPriority() {
    if (this.steering) {
      return this.steering.pathwayPriority;
    }
    return null;
  }
  set pathwayPriority(pathwayPriority) {
    if (this.steering) {
      const pathwaysList = this.steering.pathways();
      const filteredPathwayPriority = pathwayPriority.filter(pathwayId => {
        return pathwaysList.indexOf(pathwayId) !== -1;
      });
      if (pathwayPriority.length < 1) {
        this.warn(`pathwayPriority ${pathwayPriority} should contain at least one pathway from list: ${pathwaysList}`);
        return;
      }
      this.steering.pathwayPriority = filteredPathwayPriority;
    }
  }
  onError(event, data) {
    if (data.fatal || !data.context) {
      return;
    }
    if (data.context.type === PlaylistContextType.LEVEL && data.context.level === this.level) {
      this.checkRetry(data);
    }
  }

  // reset errors on the successful load of a fragment
  onFragBuffered(event, {
    frag
  }) {
    if (frag !== undefined && frag.type === PlaylistLevelType.MAIN) {
      const el = frag.elementaryStreams;
      if (!Object.keys(el).some(type => !!el[type])) {
        return;
      }
      const level = this._levels[frag.level];
      if (level != null && level.loadError) {
        this.log(`Resetting level error count of ${level.loadError} on frag buffered`);
        level.loadError = 0;
      }
    }
  }
  onLevelLoaded(event, data) {
    var _data$deliveryDirecti2;
    const {
      level,
      details
    } = data;
    const curLevel = data.levelInfo;
    if (!curLevel) {
      var _data$deliveryDirecti;
      this.warn(`Invalid level index ${level}`);
      if ((_data$deliveryDirecti = data.deliveryDirectives) != null && _data$deliveryDirecti.skip) {
        details.deltaUpdateFailed = true;
      }
      return;
    }

    // only process level loaded events matching with expected level or prior to switch when media playlist is loaded directly
    if (curLevel === this.currentLevel || data.withoutMultiVariant) {
      // reset level load error counter on successful level loaded only if there is no issues with fragments
      if (curLevel.fragmentError === 0) {
        curLevel.loadError = 0;
      }
      // Ignore matching details populated by loading a Media Playlist directly
      let previousDetails = curLevel.details;
      if (previousDetails === data.details && previousDetails.advanced) {
        previousDetails = undefined;
      }
      this.playlistLoaded(level, data, previousDetails);
    } else if ((_data$deliveryDirecti2 = data.deliveryDirectives) != null && _data$deliveryDirecti2.skip) {
      // received a delta playlist update that cannot be merged
      details.deltaUpdateFailed = true;
    }
  }
  loadPlaylist(hlsUrlParameters) {
    super.loadPlaylist();
    if (this.shouldLoadPlaylist(this.currentLevel)) {
      this.scheduleLoading(this.currentLevel, hlsUrlParameters);
    }
  }
  loadingPlaylist(currentLevel, hlsUrlParameters) {
    super.loadingPlaylist(currentLevel, hlsUrlParameters);
    const url = this.getUrlWithDirectives(currentLevel.uri, hlsUrlParameters);
    const currentLevelIndex = this.currentLevelIndex;
    const pathwayId = currentLevel.attrs['PATHWAY-ID'];
    const details = currentLevel.details;
    const age = details == null ? void 0 : details.age;
    this.log(`Loading level index ${currentLevelIndex}${(hlsUrlParameters == null ? void 0 : hlsUrlParameters.msn) !== undefined ? ' at sn ' + hlsUrlParameters.msn + ' part ' + hlsUrlParameters.part : ''}${pathwayId ? ' Pathway ' + pathwayId : ''}${age && details.live ? ' age ' + age.toFixed(1) + (details.type ? ' ' + details.type || 0 : '') : ''} ${url}`);
    this.hls.trigger(Events.LEVEL_LOADING, {
      url,
      level: currentLevelIndex,
      levelInfo: currentLevel,
      pathwayId: currentLevel.attrs['PATHWAY-ID'],
      id: 0,
      // Deprecated Level urlId
      deliveryDirectives: hlsUrlParameters || null
    });
  }
  get nextLoadLevel() {
    if (this.manualLevelIndex !== -1) {
      return this.manualLevelIndex;
    } else {
      return this.hls.nextAutoLevel;
    }
  }
  set nextLoadLevel(nextLevel) {
    this.level = nextLevel;
    if (this.manualLevelIndex === -1) {
      this.hls.nextAutoLevel = nextLevel;
    }
  }
  removeLevel(levelIndex) {
    var _this$currentLevel;
    if (this._levels.length === 1) {
      return;
    }
    const levels = this._levels.filter((level, index) => {
      if (index !== levelIndex) {
        return true;
      }
      if (this.steering) {
        this.steering.removeLevel(level);
      }
      if (level === this.currentLevel) {
        this.currentLevel = null;
        this.currentLevelIndex = -1;
        if (level.details) {
          level.details.fragments.forEach(f => f.level = -1);
        }
      }
      return false;
    });
    reassignFragmentLevelIndexes(levels);
    this._levels = levels;
    if (this.currentLevelIndex > -1 && (_this$currentLevel = this.currentLevel) != null && _this$currentLevel.details) {
      this.currentLevelIndex = this.currentLevel.details.fragments[0].level;
    }
    if (this.manualLevelIndex > -1) {
      this.manualLevelIndex = this.currentLevelIndex;
    }
    const maxLevel = levels.length - 1;
    this._firstLevel = Math.min(this._firstLevel, maxLevel);
    if (this._startLevel) {
      this._startLevel = Math.min(this._startLevel, maxLevel);
    }
    this.hls.trigger(Events.LEVELS_UPDATED, {
      levels
    });
  }
  onLevelsUpdated(event, {
    levels
  }) {
    this._levels = levels;
  }
  checkMaxAutoUpdated() {
    const {
      autoLevelCapping,
      maxAutoLevel,
      maxHdcpLevel
    } = this.hls;
    if (this._maxAutoLevel !== maxAutoLevel) {
      this._maxAutoLevel = maxAutoLevel;
      this.hls.trigger(Events.MAX_AUTO_LEVEL_UPDATED, {
        autoLevelCapping,
        levels: this.levels,
        maxAutoLevel,
        minAutoLevel: this.hls.minAutoLevel,
        maxHdcpLevel
      });
    }
  }
}
function assignTrackIdsByGroup(tracks) {
  const groups = {};
  tracks.forEach(track => {
    const groupId = track.groupId || '';
    track.id = groups[groupId] = groups[groupId] || 0;
    groups[groupId]++;
  });
}

function getSourceBuffer() {
  return self.SourceBuffer || self.WebKitSourceBuffer;
}
function isMSESupported() {
  const mediaSource = getMediaSource();
  if (!mediaSource) {
    return false;
  }

  // if SourceBuffer is exposed ensure its API is valid
  // Older browsers do not expose SourceBuffer globally so checking SourceBuffer.prototype is impossible
  const sourceBuffer = getSourceBuffer();
  return !sourceBuffer || sourceBuffer.prototype && typeof sourceBuffer.prototype.appendBuffer === 'function' && typeof sourceBuffer.prototype.remove === 'function';
}
function isSupported() {
  if (!isMSESupported()) {
    return false;
  }
  const mediaSource = getMediaSource();
  return typeof (mediaSource == null ? void 0 : mediaSource.isTypeSupported) === 'function' && (['avc1.42E01E,mp4a.40.2', 'av01.0.01M.08', 'vp09.00.50.08'].some(codecsForVideoContainer => mediaSource.isTypeSupported(mimeTypeForCodec(codecsForVideoContainer, 'video'))) || ['mp4a.40.2', 'fLaC'].some(codecForAudioContainer => mediaSource.isTypeSupported(mimeTypeForCodec(codecForAudioContainer, 'audio'))));
}
function changeTypeSupported() {
  var _sourceBuffer$prototy;
  const sourceBuffer = getSourceBuffer();
  return typeof (sourceBuffer == null ? void 0 : (_sourceBuffer$prototy = sourceBuffer.prototype) == null ? void 0 : _sourceBuffer$prototy.changeType) === 'function';
}

const TICK_INTERVAL = 100; // how often to tick in ms

class StreamController extends BaseStreamController {
  constructor(hls, fragmentTracker, keyLoader) {
    super(hls, fragmentTracker, keyLoader, 'stream-controller', PlaylistLevelType.MAIN);
    this.audioCodecSwap = false;
    this.level = -1;
    this._forceStartLoad = false;
    this._hasEnoughToStart = false;
    this.altAudio = 0;
    this.audioOnly = false;
    this.fragPlaying = null;
    this.fragLastKbps = 0;
    this.couldBacktrack = false;
    this.backtrackFragment = null;
    this.audioCodecSwitch = false;
    this.videoBuffer = null;
    this.onMediaPlaying = () => {
      // tick to speed up FRAG_CHANGED triggering
      this.tick();
    };
    this.onMediaSeeked = () => {
      const media = this.media;
      const currentTime = media ? media.currentTime : null;
      if (currentTime === null || !isFiniteNumber(currentTime)) {
        return;
      }
      this.log(`Media seeked to ${currentTime.toFixed(3)}`);

      // If seeked was issued before buffer was appended do not tick immediately
      if (!this.getBufferedFrag(currentTime)) {
        return;
      }
      const bufferInfo = this.getFwdBufferInfoAtPos(media, currentTime, PlaylistLevelType.MAIN, 0);
      if (bufferInfo === null || bufferInfo.len === 0) {
        this.warn(`Main forward buffer length at ${currentTime} on "seeked" event ${bufferInfo ? bufferInfo.len : 'empty'})`);
        return;
      }

      // tick to speed up FRAG_CHANGED triggering
      this.tick();
    };
    this.registerListeners();
  }
  registerListeners() {
    super.registerListeners();
    const {
      hls
    } = this;
    hls.on(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.on(Events.LEVEL_LOADING, this.onLevelLoading, this);
    hls.on(Events.LEVEL_LOADED, this.onLevelLoaded, this);
    hls.on(Events.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this);
    hls.on(Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
    hls.on(Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this);
    hls.on(Events.BUFFER_CREATED, this.onBufferCreated, this);
    hls.on(Events.BUFFER_FLUSHED, this.onBufferFlushed, this);
    hls.on(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
    hls.on(Events.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  unregisterListeners() {
    super.unregisterListeners();
    const {
      hls
    } = this;
    hls.off(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.off(Events.LEVEL_LOADED, this.onLevelLoaded, this);
    hls.off(Events.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this);
    hls.off(Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
    hls.off(Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this);
    hls.off(Events.BUFFER_CREATED, this.onBufferCreated, this);
    hls.off(Events.BUFFER_FLUSHED, this.onBufferFlushed, this);
    hls.off(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
    hls.off(Events.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  onHandlerDestroying() {
    // @ts-ignore
    this.onMediaPlaying = this.onMediaSeeked = null;
    this.unregisterListeners();
    super.onHandlerDestroying();
  }
  startLoad(startPosition, skipSeekToStartPosition) {
    if (this.levels) {
      const {
        lastCurrentTime,
        hls
      } = this;
      this.stopLoad();
      this.setInterval(TICK_INTERVAL);
      this.level = -1;
      if (!this.startFragRequested) {
        // determine load level
        let startLevel = hls.startLevel;
        if (startLevel === -1) {
          if (hls.config.testBandwidth && this.levels.length > 1) {
            // -1 : guess start Level by doing a bitrate test by loading first fragment of lowest quality level
            startLevel = 0;
            this.bitrateTest = true;
          } else {
            startLevel = hls.firstAutoLevel;
          }
        }
        // set new level to playlist loader : this will trigger start level load
        // hls.nextLoadLevel remains until it is set to a new value or until a new frag is successfully loaded
        hls.nextLoadLevel = startLevel;
        this.level = hls.loadLevel;
        this._hasEnoughToStart = !!skipSeekToStartPosition;
      }
      // if startPosition undefined but lastCurrentTime set, set startPosition to last currentTime
      if (lastCurrentTime > 0 && startPosition === -1 && !skipSeekToStartPosition) {
        this.log(`Override startPosition with lastCurrentTime @${lastCurrentTime.toFixed(3)}`);
        startPosition = lastCurrentTime;
      }
      this.state = State.IDLE;
      this.nextLoadPosition = this.lastCurrentTime = startPosition + this.timelineOffset;
      this.startPosition = skipSeekToStartPosition ? -1 : startPosition;
      this.tick();
    } else {
      this._forceStartLoad = true;
      this.state = State.STOPPED;
    }
  }
  stopLoad() {
    this._forceStartLoad = false;
    super.stopLoad();
  }
  doTick() {
    switch (this.state) {
      case State.WAITING_LEVEL:
        {
          const {
            levels,
            level
          } = this;
          const currentLevel = levels == null ? void 0 : levels[level];
          const details = currentLevel == null ? void 0 : currentLevel.details;
          if (details && (!details.live || this.levelLastLoaded === currentLevel && !this.waitForLive(currentLevel))) {
            if (this.waitForCdnTuneIn(details)) {
              break;
            }
            this.state = State.IDLE;
            break;
          } else if (this.hls.nextLoadLevel !== this.level) {
            this.state = State.IDLE;
            break;
          }
          break;
        }
      case State.FRAG_LOADING_WAITING_RETRY:
        {
          var _this$media;
          const now = self.performance.now();
          const retryDate = this.retryDate;
          // if current time is gt than retryDate, or if media seeking let's switch to IDLE state to retry loading
          if (!retryDate || now >= retryDate || (_this$media = this.media) != null && _this$media.seeking) {
            const {
              levels,
              level
            } = this;
            const currentLevel = levels == null ? void 0 : levels[level];
            this.resetStartWhenNotLoaded(currentLevel || null);
            this.state = State.IDLE;
          }
        }
        break;
    }
    if (this.state === State.IDLE) {
      this.doTickIdle();
    }
    this.onTickEnd();
  }
  onTickEnd() {
    var _this$media2;
    super.onTickEnd();
    if ((_this$media2 = this.media) != null && _this$media2.readyState && this.media.seeking === false) {
      this.lastCurrentTime = this.media.currentTime;
    }
    this.checkFragmentChanged();
  }
  doTickIdle() {
    const {
      hls,
      levelLastLoaded,
      levels,
      media
    } = this;

    // if start level not parsed yet OR
    // if video not attached AND start fragment already requested OR start frag prefetch not enabled
    // exit loop, as we either need more info (level not parsed) or we need media to be attached to load new fragment
    if (levelLastLoaded === null || !media && !this.primaryPrefetch && (this.startFragRequested || !hls.config.startFragPrefetch)) {
      return;
    }

    // If the "main" level is audio-only but we are loading an alternate track in the same group, do not load anything
    if (this.altAudio && this.audioOnly) {
      return;
    }
    const level = this.buffering ? hls.nextLoadLevel : hls.loadLevel;
    if (!(levels != null && levels[level])) {
      return;
    }
    const levelInfo = levels[level];

    // if buffer length is less than maxBufLen try to load a new fragment

    const bufferInfo = this.getMainFwdBufferInfo();
    if (bufferInfo === null) {
      return;
    }
    const lastDetails = this.getLevelDetails();
    if (lastDetails && this._streamEnded(bufferInfo, lastDetails)) {
      const data = {};
      if (this.altAudio === 2) {
        data.type = 'video';
      }
      this.hls.trigger(Events.BUFFER_EOS, data);
      this.state = State.ENDED;
      return;
    }
    if (!this.buffering) {
      return;
    }

    // set next load level : this will trigger a playlist load if needed
    if (hls.loadLevel !== level && hls.manualLevel === -1) {
      this.log(`Adapting to level ${level} from level ${this.level}`);
    }
    this.level = hls.nextLoadLevel = level;
    const levelDetails = levelInfo.details;
    // if level info not retrieved yet, switch state and wait for level retrieval
    // if live playlist, ensure that new playlist has been refreshed to avoid loading/try to load
    // a useless and outdated fragment (that might even introduce load error if it is already out of the live playlist)
    if (!levelDetails || this.state === State.WAITING_LEVEL || this.waitForLive(levelInfo)) {
      this.level = level;
      this.state = State.WAITING_LEVEL;
      this.startFragRequested = false;
      return;
    }
    const bufferLen = bufferInfo.len;

    // compute max Buffer Length that we could get from this load level, based on level bitrate. don't buffer more than 60 MB and more than 30s
    const maxBufLen = this.getMaxBufferLength(levelInfo.maxBitrate);

    // Stay idle if we are still with buffer margins
    if (bufferLen >= maxBufLen) {
      return;
    }
    if (this.backtrackFragment && this.backtrackFragment.start > bufferInfo.end) {
      this.backtrackFragment = null;
    }
    const targetBufferTime = this.backtrackFragment ? this.backtrackFragment.start : bufferInfo.end;
    let frag = this.getNextFragment(targetBufferTime, levelDetails);
    // Avoid backtracking by loading an earlier segment in streams with segments that do not start with a key frame (flagged by `couldBacktrack`)
    if (this.couldBacktrack && !this.fragPrevious && frag && isMediaFragment(frag) && this.fragmentTracker.getState(frag) !== FragmentState.OK) {
      var _this$backtrackFragme;
      const backtrackSn = ((_this$backtrackFragme = this.backtrackFragment) != null ? _this$backtrackFragme : frag).sn;
      const fragIdx = backtrackSn - levelDetails.startSN;
      const backtrackFrag = levelDetails.fragments[fragIdx - 1];
      if (backtrackFrag && frag.cc === backtrackFrag.cc) {
        frag = backtrackFrag;
        this.fragmentTracker.removeFragment(backtrackFrag);
      }
    } else if (this.backtrackFragment && bufferInfo.len) {
      this.backtrackFragment = null;
    }
    // Avoid loop loading by using nextLoadPosition set for backtracking and skipping consecutive GAP tags
    if (frag && this.isLoopLoading(frag, targetBufferTime)) {
      const gapStart = frag.gap;
      if (!gapStart) {
        // Cleanup the fragment tracker before trying to find the next unbuffered fragment
        const type = this.audioOnly && !this.altAudio ? ElementaryStreamTypes.AUDIO : ElementaryStreamTypes.VIDEO;
        const mediaBuffer = (type === ElementaryStreamTypes.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
        if (mediaBuffer) {
          this.afterBufferFlushed(mediaBuffer, type, PlaylistLevelType.MAIN);
        }
      }
      frag = this.getNextFragmentLoopLoading(frag, levelDetails, bufferInfo, PlaylistLevelType.MAIN, maxBufLen);
    }
    if (!frag) {
      return;
    }
    if (frag.initSegment && !frag.initSegment.data && !this.bitrateTest) {
      frag = frag.initSegment;
    }
    this.loadFragment(frag, levelInfo, targetBufferTime);
  }
  loadFragment(frag, level, targetBufferTime) {
    // Check if fragment is not loaded
    const fragState = this.fragmentTracker.getState(frag);
    if (fragState === FragmentState.NOT_LOADED || fragState === FragmentState.PARTIAL) {
      if (!isMediaFragment(frag)) {
        this._loadInitSegment(frag, level);
      } else if (this.bitrateTest) {
        this.log(`Fragment ${frag.sn} of level ${frag.level} is being downloaded to test bitrate and will not be buffered`);
        this._loadBitrateTestFrag(frag, level);
      } else {
        super.loadFragment(frag, level, targetBufferTime);
      }
    } else {
      this.clearTrackerIfNeeded(frag);
    }
  }
  getBufferedFrag(position) {
    return this.fragmentTracker.getBufferedFrag(position, PlaylistLevelType.MAIN);
  }
  followingBufferedFrag(frag) {
    if (frag) {
      // try to get range of next fragment (500ms after this range)
      return this.getBufferedFrag(frag.end + 0.5);
    }
    return null;
  }

  /*
    on immediate level switch :
     - pause playback if playing
     - cancel any pending load request
     - and trigger a buffer flush
  */
  immediateLevelSwitch() {
    this.abortCurrentFrag();
    this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
  }

  /**
   * try to switch ASAP without breaking video playback:
   * in order to ensure smooth but quick level switching,
   * we need to find the next flushable buffer range
   * we should take into account new segment fetch time
   */
  nextLevelSwitch() {
    const {
      levels,
      media
    } = this;
    // ensure that media is defined and that metadata are available (to retrieve currentTime)
    if (media != null && media.readyState) {
      let fetchdelay;
      const fragPlayingCurrent = this.getAppendedFrag(media.currentTime);
      if (fragPlayingCurrent && fragPlayingCurrent.start > 1) {
        // flush buffer preceding current fragment (flush until current fragment start offset)
        // minus 1s to avoid video freezing, that could happen if we flush keyframe of current video ...
        this.flushMainBuffer(0, fragPlayingCurrent.start - 1);
      }
      const levelDetails = this.getLevelDetails();
      if (levelDetails != null && levelDetails.live) {
        const bufferInfo = this.getMainFwdBufferInfo();
        // Do not flush in live stream with low buffer
        if (!bufferInfo || bufferInfo.len < levelDetails.targetduration * 2) {
          return;
        }
      }
      if (!media.paused && levels) {
        // add a safety delay of 1s
        const nextLevelId = this.hls.nextLoadLevel;
        const nextLevel = levels[nextLevelId];
        const fragLastKbps = this.fragLastKbps;
        if (fragLastKbps && this.fragCurrent) {
          fetchdelay = this.fragCurrent.duration * nextLevel.maxBitrate / (1000 * fragLastKbps) + 1;
        } else {
          fetchdelay = 0;
        }
      } else {
        fetchdelay = 0;
      }
      // this.log('fetchdelay:'+fetchdelay);
      // find buffer range that will be reached once new fragment will be fetched
      const bufferedFrag = this.getBufferedFrag(media.currentTime + fetchdelay);
      if (bufferedFrag) {
        // we can flush buffer range following this one without stalling playback
        const nextBufferedFrag = this.followingBufferedFrag(bufferedFrag);
        if (nextBufferedFrag) {
          // if we are here, we can also cancel any loading/demuxing in progress, as they are useless
          this.abortCurrentFrag();
          // start flush position is in next buffered frag. Leave some padding for non-independent segments and smoother playback.
          const maxStart = nextBufferedFrag.maxStartPTS ? nextBufferedFrag.maxStartPTS : nextBufferedFrag.start;
          const fragDuration = nextBufferedFrag.duration;
          const startPts = Math.max(bufferedFrag.end, maxStart + Math.min(Math.max(fragDuration - this.config.maxFragLookUpTolerance, fragDuration * (this.couldBacktrack ? 0.5 : 0.125)), fragDuration * (this.couldBacktrack ? 0.75 : 0.25)));
          this.flushMainBuffer(startPts, Number.POSITIVE_INFINITY);
        }
      }
    }
  }
  abortCurrentFrag() {
    const fragCurrent = this.fragCurrent;
    this.fragCurrent = null;
    this.backtrackFragment = null;
    if (fragCurrent) {
      fragCurrent.abortRequests();
      this.fragmentTracker.removeFragment(fragCurrent);
    }
    switch (this.state) {
      case State.KEY_LOADING:
      case State.FRAG_LOADING:
      case State.FRAG_LOADING_WAITING_RETRY:
      case State.PARSING:
      case State.PARSED:
        this.state = State.IDLE;
        break;
    }
    this.nextLoadPosition = this.getLoadPosition();
  }
  flushMainBuffer(startOffset, endOffset) {
    super.flushMainBuffer(startOffset, endOffset, this.altAudio === 2 ? 'video' : null);
  }
  onMediaAttached(event, data) {
    super.onMediaAttached(event, data);
    const media = data.media;
    addEventListener(media, 'playing', this.onMediaPlaying);
    addEventListener(media, 'seeked', this.onMediaSeeked);
  }
  onMediaDetaching(event, data) {
    const {
      media
    } = this;
    if (media) {
      removeEventListener(media, 'playing', this.onMediaPlaying);
      removeEventListener(media, 'seeked', this.onMediaSeeked);
    }
    this.videoBuffer = null;
    this.fragPlaying = null;
    super.onMediaDetaching(event, data);
    const transferringMedia = !!data.transferMedia;
    if (transferringMedia) {
      return;
    }
    this._hasEnoughToStart = false;
  }
  onManifestLoading() {
    super.onManifestLoading();
    // reset buffer on manifest loading
    this.log('Trigger BUFFER_RESET');
    this.hls.trigger(Events.BUFFER_RESET, undefined);
    this.couldBacktrack = false;
    this.fragLastKbps = 0;
    this.fragPlaying = this.backtrackFragment = null;
    this.altAudio = 0;
    this.audioOnly = false;
  }
  onManifestParsed(event, data) {
    // detect if we have different kind of audio codecs used amongst playlists
    let aac = false;
    let heaac = false;
    data.levels.forEach(level => {
      const codec = level.audioCodec;
      if (codec) {
        aac = aac || codec.indexOf('mp4a.40.2') !== -1;
        heaac = heaac || codec.indexOf('mp4a.40.5') !== -1;
      }
    });
    this.audioCodecSwitch = aac && heaac && !changeTypeSupported();
    if (this.audioCodecSwitch) {
      this.log('Both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC');
    }
    this.levels = data.levels;
    this.startFragRequested = false;
  }
  onLevelLoading(event, data) {
    const {
      levels
    } = this;
    if (!levels || this.state !== State.IDLE) {
      return;
    }
    const level = data.levelInfo;
    if (!level.details || level.details.live && (this.levelLastLoaded !== level || level.details.expired) || this.waitForCdnTuneIn(level.details)) {
      this.state = State.WAITING_LEVEL;
    }
  }
  onLevelLoaded(event, data) {
    var _curLevel$details;
    const {
      levels,
      startFragRequested
    } = this;
    const newLevelId = data.level;
    const newDetails = data.details;
    const duration = newDetails.totalduration;
    if (!levels) {
      this.warn(`Levels were reset while loading level ${newLevelId}`);
      return;
    }
    this.log(`Level ${newLevelId} loaded [${newDetails.startSN},${newDetails.endSN}]${newDetails.lastPartSn ? `[part-${newDetails.lastPartSn}-${newDetails.lastPartIndex}]` : ''}, cc [${newDetails.startCC}, ${newDetails.endCC}] duration:${duration}`);
    const curLevel = data.levelInfo;
    const fragCurrent = this.fragCurrent;
    if (fragCurrent && (this.state === State.FRAG_LOADING || this.state === State.FRAG_LOADING_WAITING_RETRY)) {
      if (fragCurrent.level !== data.level && fragCurrent.loader) {
        this.abortCurrentFrag();
      }
    }
    let sliding = 0;
    if (newDetails.live || (_curLevel$details = curLevel.details) != null && _curLevel$details.live) {
      var _this$levelLastLoaded;
      this.checkLiveUpdate(newDetails);
      if (newDetails.deltaUpdateFailed) {
        return;
      }
      sliding = this.alignPlaylists(newDetails, curLevel.details, (_this$levelLastLoaded = this.levelLastLoaded) == null ? void 0 : _this$levelLastLoaded.details);
    }
    // override level info
    curLevel.details = newDetails;
    this.levelLastLoaded = curLevel;
    if (!startFragRequested) {
      this.setStartPosition(newDetails, sliding);
    }
    this.hls.trigger(Events.LEVEL_UPDATED, {
      details: newDetails,
      level: newLevelId
    });

    // only switch back to IDLE state if we were waiting for level to start downloading a new fragment
    if (this.state === State.WAITING_LEVEL) {
      if (this.waitForCdnTuneIn(newDetails)) {
        // Wait for Low-Latency CDN Tune-in
        return;
      }
      this.state = State.IDLE;
    }
    if (startFragRequested && newDetails.live) {
      this.synchronizeToLiveEdge(newDetails);
    }

    // trigger handler right now
    this.tick();
  }
  synchronizeToLiveEdge(levelDetails) {
    const {
      config,
      media
    } = this;
    if (!media) {
      return;
    }
    const liveSyncPosition = this.hls.liveSyncPosition;
    const currentTime = this.getLoadPosition();
    const start = levelDetails.fragmentStart;
    const end = levelDetails.edge;
    const withinSlidingWindow = currentTime >= start - config.maxFragLookUpTolerance && currentTime <= end;
    // Continue if we can seek forward to sync position or if current time is outside of sliding window
    if (liveSyncPosition !== null && media.duration > liveSyncPosition && (currentTime < liveSyncPosition || !withinSlidingWindow)) {
      // Continue if buffer is starving or if current time is behind max latency
      const maxLatency = config.liveMaxLatencyDuration !== undefined ? config.liveMaxLatencyDuration : config.liveMaxLatencyDurationCount * levelDetails.targetduration;
      if (!withinSlidingWindow && media.readyState < 4 || currentTime < end - maxLatency) {
        if (!this._hasEnoughToStart) {
          this.nextLoadPosition = liveSyncPosition;
        }
        // Only seek if ready and there is not a significant forward buffer available for playback
        if (media.readyState) {
          this.warn(`Playback: ${currentTime.toFixed(3)} is located too far from the end of live sliding playlist: ${end}, reset currentTime to : ${liveSyncPosition.toFixed(3)}`);
          if (this.config.liveSyncMode === 'buffered') {
            var _bufferInfo$buffered;
            const bufferInfo = BufferHelper.bufferInfo(media, liveSyncPosition, 0);
            if (!(bufferInfo != null && (_bufferInfo$buffered = bufferInfo.buffered) != null && _bufferInfo$buffered.length)) {
              media.currentTime = liveSyncPosition;
              return;
            }
            const isLiveSyncInBuffer = bufferInfo.start <= currentTime;
            if (isLiveSyncInBuffer) {
              media.currentTime = liveSyncPosition;
              return;
            }
            const {
              nextStart
            } = BufferHelper.bufferedInfo(bufferInfo.buffered, currentTime, 0);
            if (nextStart) {
              media.currentTime = nextStart;
            }
          } else {
            media.currentTime = liveSyncPosition;
          }
        }
      }
    }
  }
  _handleFragmentLoadProgress(data) {
    var _frag$initSegment;
    const frag = data.frag;
    const {
      part,
      payload
    } = data;
    const {
      levels
    } = this;
    if (!levels) {
      this.warn(`Levels were reset while fragment load was in progress. Fragment ${frag.sn} of level ${frag.level} will not be buffered`);
      return;
    }
    const currentLevel = levels[frag.level];
    if (!currentLevel) {
      this.warn(`Level ${frag.level} not found on progress`);
      return;
    }
    const details = currentLevel.details;
    if (!details) {
      this.warn(`Dropping fragment ${frag.sn} of level ${frag.level} after level details were reset`);
      this.fragmentTracker.removeFragment(frag);
      return;
    }
    const videoCodec = currentLevel.videoCodec;

    // time Offset is accurate if level PTS is known, or if playlist is not sliding (not live)
    const accurateTimeOffset = details.PTSKnown || !details.live;
    const initSegmentData = (_frag$initSegment = frag.initSegment) == null ? void 0 : _frag$initSegment.data;
    const audioCodec = this._getAudioCodec(currentLevel);

    // transmux the MPEG-TS data to ISO-BMFF segments
    // this.log(`Transmuxing ${frag.sn} of [${details.startSN} ,${details.endSN}],level ${frag.level}, cc ${frag.cc}`);
    const transmuxer = this.transmuxer = this.transmuxer || new TransmuxerInterface(this.hls, PlaylistLevelType.MAIN, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this));
    const partIndex = part ? part.index : -1;
    const partial = partIndex !== -1;
    const chunkMeta = new ChunkMetadata(frag.level, frag.sn, frag.stats.chunkCount, payload.byteLength, partIndex, partial);
    const initPTS = this.initPTS[frag.cc];
    transmuxer.push(payload, initSegmentData, audioCodec, videoCodec, frag, part, details.totalduration, accurateTimeOffset, chunkMeta, initPTS);
  }
  onAudioTrackSwitching(event, data) {
    const hls = this.hls;
    // if any URL found on new audio track, it is an alternate audio track
    const fromAltAudio = this.altAudio === 2;
    const altAudio = useAlternateAudio(data.url, hls);
    // if we switch on main audio, ensure that main fragment scheduling is synced with media.buffered
    // don't do anything if we switch to alt audio: audio stream controller is handling it.
    // we will just have to change buffer scheduling on audioTrackSwitched
    if (!altAudio) {
      if (this.mediaBuffer !== this.media) {
        this.log('Switching on main audio, use media.buffered to schedule main fragment loading');
        this.mediaBuffer = this.media;
        const fragCurrent = this.fragCurrent;
        // we need to refill audio buffer from main: cancel any frag loading to speed up audio switch
        if (fragCurrent) {
          this.log('Switching to main audio track, cancel main fragment load');
          fragCurrent.abortRequests();
          this.fragmentTracker.removeFragment(fragCurrent);
        }
        // destroy transmuxer to force init segment generation (following audio switch)
        this.resetTransmuxer();
        // switch to IDLE state to load new fragment
        this.resetLoadingState();
      } else if (this.audioOnly) {
        // Reset audio transmuxer so when switching back to main audio we're not still appending where we left off
        this.resetTransmuxer();
      }
      // If switching from alt to main audio, flush all audio and trigger track switched
      if (fromAltAudio) {
        this.fragmentTracker.removeAllFragments();
        hls.once(Events.BUFFER_FLUSHED, () => {
          var _this$hls;
          (_this$hls = this.hls) == null ? void 0 : _this$hls.trigger(Events.AUDIO_TRACK_SWITCHED, data);
        });
        hls.trigger(Events.BUFFER_FLUSHING, {
          startOffset: 0,
          endOffset: Number.POSITIVE_INFINITY,
          type: null
        });
        return;
      }
      hls.trigger(Events.AUDIO_TRACK_SWITCHED, data);
    } else {
      this.altAudio = 1;
    }
  }
  onAudioTrackSwitched(event, data) {
    const altAudio = useAlternateAudio(data.url, this.hls);
    if (altAudio) {
      const videoBuffer = this.videoBuffer;
      // if we switched on alternate audio, ensure that main fragment scheduling is synced with video sourcebuffer buffered
      if (videoBuffer && this.mediaBuffer !== videoBuffer) {
        this.log('Switching on alternate audio, use video.buffered to schedule main fragment loading');
        this.mediaBuffer = videoBuffer;
      }
    }
    this.altAudio = altAudio ? 2 : 0;
    this.tick();
  }
  onBufferCreated(event, data) {
    const tracks = data.tracks;
    let mediaTrack;
    let name;
    let alternate = false;
    for (const type in tracks) {
      const track = tracks[type];
      if (track.id === 'main') {
        name = type;
        mediaTrack = track;
        // keep video source buffer reference
        if (type === 'video') {
          const videoTrack = tracks[type];
          if (videoTrack) {
            this.videoBuffer = videoTrack.buffer;
          }
        }
      } else {
        alternate = true;
      }
    }
    if (alternate && mediaTrack) {
      this.log(`Alternate track found, use ${name}.buffered to schedule main fragment loading`);
      this.mediaBuffer = mediaTrack.buffer;
    } else {
      this.mediaBuffer = this.media;
    }
  }
  onFragBuffered(event, data) {
    const {
      frag,
      part
    } = data;
    const bufferedMainFragment = frag.type === PlaylistLevelType.MAIN;
    if (bufferedMainFragment) {
      if (this.fragContextChanged(frag)) {
        // If a level switch was requested while a fragment was buffering, it will emit the FRAG_BUFFERED event upon completion
        // Avoid setting state back to IDLE, since that will interfere with a level switch
        this.warn(`Fragment ${frag.sn}${part ? ' p: ' + part.index : ''} of level ${frag.level} finished buffering, but was aborted. state: ${this.state}`);
        if (this.state === State.PARSED) {
          this.state = State.IDLE;
        }
        return;
      }
      const stats = part ? part.stats : frag.stats;
      this.fragLastKbps = Math.round(8 * stats.total / (stats.buffering.end - stats.loading.first));
      if (isMediaFragment(frag)) {
        this.fragPrevious = frag;
      }
      this.fragBufferedComplete(frag, part);
    }
    const media = this.media;
    if (!media) {
      return;
    }
    if (!this._hasEnoughToStart && BufferHelper.getBuffered(media).length) {
      this._hasEnoughToStart = true;
      this.seekToStartPos();
    }
    if (bufferedMainFragment) {
      this.tick();
    }
  }
  get hasEnoughToStart() {
    return this._hasEnoughToStart;
  }
  onError(event, data) {
    var _data$context;
    if (data.fatal) {
      this.state = State.ERROR;
      return;
    }
    switch (data.details) {
      case ErrorDetails.FRAG_GAP:
      case ErrorDetails.FRAG_PARSING_ERROR:
      case ErrorDetails.FRAG_DECRYPT_ERROR:
      case ErrorDetails.FRAG_LOAD_ERROR:
      case ErrorDetails.FRAG_LOAD_TIMEOUT:
      case ErrorDetails.KEY_LOAD_ERROR:
      case ErrorDetails.KEY_LOAD_TIMEOUT:
        this.onFragmentOrKeyLoadError(PlaylistLevelType.MAIN, data);
        break;
      case ErrorDetails.LEVEL_LOAD_ERROR:
      case ErrorDetails.LEVEL_LOAD_TIMEOUT:
      case ErrorDetails.LEVEL_PARSING_ERROR:
        // in case of non fatal error while loading level, if level controller is not retrying to load level, switch back to IDLE
        if (!data.levelRetry && this.state === State.WAITING_LEVEL && ((_data$context = data.context) == null ? void 0 : _data$context.type) === PlaylistContextType.LEVEL) {
          this.state = State.IDLE;
        }
        break;
      case ErrorDetails.BUFFER_ADD_CODEC_ERROR:
      case ErrorDetails.BUFFER_APPEND_ERROR:
        if (data.parent !== 'main') {
          return;
        }
        this.resetLoadingState();
        break;
      case ErrorDetails.BUFFER_FULL_ERROR:
        if (data.parent !== 'main') {
          return;
        }
        if (this.reduceLengthAndFlushBuffer(data)) {
          this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
        }
        break;
      case ErrorDetails.INTERNAL_EXCEPTION:
        this.recoverWorkerError(data);
        break;
    }
  }
  onFragLoadEmergencyAborted() {
    this.state = State.IDLE;
    // if loadedmetadata is not set, it means that we are emergency switch down on first frag
    // in that case, reset startFragRequested flag
    if (!this._hasEnoughToStart) {
      this.startFragRequested = false;
      this.nextLoadPosition = this.lastCurrentTime;
    }
    this.tickImmediate();
  }
  onBufferFlushed(event, {
    type
  }) {
    if (type !== ElementaryStreamTypes.AUDIO || !this.altAudio) {
      const mediaBuffer = (type === ElementaryStreamTypes.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
      if (mediaBuffer) {
        this.afterBufferFlushed(mediaBuffer, type, PlaylistLevelType.MAIN);
        this.tick();
      }
    }
  }
  onLevelsUpdated(event, data) {
    if (this.level > -1 && this.fragCurrent) {
      this.level = this.fragCurrent.level;
      if (this.level === -1) {
        this.resetWhenMissingContext(this.fragCurrent);
      }
    }
    this.levels = data.levels;
  }
  swapAudioCodec() {
    this.audioCodecSwap = !this.audioCodecSwap;
  }

  /**
   * Seeks to the set startPosition if not equal to the mediaElement's current time.
   */
  seekToStartPos() {
    const {
      media
    } = this;
    if (!media) {
      return;
    }
    const currentTime = media.currentTime;
    let startPosition = this.startPosition;
    // only adjust currentTime if different from startPosition or if startPosition not buffered
    // at that stage, there should be only one buffered range, as we reach that code after first fragment has been buffered
    if (startPosition >= 0 && currentTime < startPosition) {
      if (media.seeking) {
        this.log(`could not seek to ${startPosition}, already seeking at ${currentTime}`);
        return;
      }

      // Offset start position by timeline offset
      const timelineOffset = this.timelineOffset;
      if (timelineOffset && startPosition) {
        startPosition += timelineOffset;
      }
      const details = this.getLevelDetails();
      const buffered = BufferHelper.getBuffered(media);
      const bufferStart = buffered.length ? buffered.start(0) : 0;
      const delta = bufferStart - startPosition;
      const skipTolerance = Math.max(this.config.maxBufferHole, this.config.maxFragLookUpTolerance);
      if (this.config.startOnSegmentBoundary || delta > 0 && (delta < skipTolerance || this.loadingParts && delta < 2 * ((details == null ? void 0 : details.partTarget) || 0))) {
        this.log(`adjusting start position by ${delta} to match buffer start`);
        startPosition += delta;
        this.startPosition = startPosition;
      }
      if (currentTime < startPosition) {
        this.log(`seek to target start position ${startPosition} from current time ${currentTime} buffer start ${bufferStart}`);
        media.currentTime = startPosition;
      }
    }
  }
  _getAudioCodec(currentLevel) {
    let audioCodec = this.config.defaultAudioCodec || currentLevel.audioCodec;
    if (this.audioCodecSwap && audioCodec) {
      this.log('Swapping audio codec');
      if (audioCodec.indexOf('mp4a.40.5') !== -1) {
        audioCodec = 'mp4a.40.2';
      } else {
        audioCodec = 'mp4a.40.5';
      }
    }
    return audioCodec;
  }
  _loadBitrateTestFrag(fragment, level) {
    fragment.bitrateTest = true;
    this._doFragLoad(fragment, level).then(data => {
      const {
        hls
      } = this;
      const frag = data == null ? void 0 : data.frag;
      if (!frag || this.fragContextChanged(frag)) {
        return;
      }
      level.fragmentError = 0;
      this.state = State.IDLE;
      this.startFragRequested = false;
      this.bitrateTest = false;
      const stats = frag.stats;
      // Bitrate tests fragments are neither parsed nor buffered
      stats.parsing.start = stats.parsing.end = stats.buffering.start = stats.buffering.end = self.performance.now();
      hls.trigger(Events.FRAG_LOADED, data);
      frag.bitrateTest = false;
    });
  }
  _handleTransmuxComplete(transmuxResult) {
    var _id3$samples;
    const id = this.playlistType;
    const {
      hls
    } = this;
    const {
      remuxResult,
      chunkMeta
    } = transmuxResult;
    const context = this.getCurrentContext(chunkMeta);
    if (!context) {
      this.resetWhenMissingContext(chunkMeta);
      return;
    }
    const {
      frag,
      part,
      level
    } = context;
    const {
      video,
      text,
      id3,
      initSegment
    } = remuxResult;
    const {
      details
    } = level;
    // The audio-stream-controller handles audio buffering if Hls.js is playing an alternate audio track
    const audio = this.altAudio ? undefined : remuxResult.audio;

    // Check if the current fragment has been aborted. We check this by first seeing if we're still playing the current level.
    // If we are, subsequently check if the currently loading fragment (fragCurrent) has changed.
    if (this.fragContextChanged(frag)) {
      this.fragmentTracker.removeFragment(frag);
      return;
    }
    this.state = State.PARSING;
    if (initSegment) {
      if (initSegment != null && initSegment.tracks) {
        const mapFragment = frag.initSegment || frag;
        this._bufferInitSegment(level, initSegment.tracks, mapFragment, chunkMeta);
        hls.trigger(Events.FRAG_PARSING_INIT_SEGMENT, {
          frag: mapFragment,
          id,
          tracks: initSegment.tracks
        });
      }

      // This would be nice if Number.isFinite acted as a typeguard, but it doesn't. See: https://github.com/Microsoft/TypeScript/issues/10038
      const initPTS = initSegment.initPTS;
      const timescale = initSegment.timescale;
      if (isFiniteNumber(initPTS)) {
        this.initPTS[frag.cc] = {
          baseTime: initPTS,
          timescale
        };
        hls.trigger(Events.INIT_PTS_FOUND, {
          frag,
          id,
          initPTS,
          timescale
        });
      }
    }

    // Avoid buffering if backtracking this fragment
    if (video && details) {
      if (audio && video.type === 'audiovideo') {
        this.logMuxedErr(frag);
      }
      const prevFrag = details.fragments[frag.sn - 1 - details.startSN];
      const isFirstFragment = frag.sn === details.startSN;
      const isFirstInDiscontinuity = !prevFrag || frag.cc > prevFrag.cc;
      if (remuxResult.independent !== false) {
        const {
          startPTS,
          endPTS,
          startDTS,
          endDTS
        } = video;
        if (part) {
          part.elementaryStreams[video.type] = {
            startPTS,
            endPTS,
            startDTS,
            endDTS
          };
        } else {
          if (video.firstKeyFrame && video.independent && chunkMeta.id === 1 && !isFirstInDiscontinuity) {
            this.couldBacktrack = true;
          }
          if (video.dropped && video.independent) {
            // Backtrack if dropped frames create a gap after currentTime

            const bufferInfo = this.getMainFwdBufferInfo();
            const targetBufferTime = (bufferInfo ? bufferInfo.end : this.getLoadPosition()) + this.config.maxBufferHole;
            const startTime = video.firstKeyFramePTS ? video.firstKeyFramePTS : startPTS;
            if (!isFirstFragment && targetBufferTime < startTime - this.config.maxBufferHole && !isFirstInDiscontinuity) {
              this.backtrack(frag);
              return;
            } else if (isFirstInDiscontinuity) {
              // Mark segment with a gap to avoid loop loading
              frag.gap = true;
            }
            // Set video stream start to fragment start so that truncated samples do not distort the timeline, and mark it partial
            frag.setElementaryStreamInfo(video.type, frag.start, endPTS, frag.start, endDTS, true);
          } else if (isFirstFragment && startPTS - (details.appliedTimelineOffset || 0) > MAX_START_GAP_JUMP) {
            // Mark segment with a gap to skip large start gap
            frag.gap = true;
          }
        }
        frag.setElementaryStreamInfo(video.type, startPTS, endPTS, startDTS, endDTS);
        if (this.backtrackFragment) {
          this.backtrackFragment = frag;
        }
        this.bufferFragmentData(video, frag, part, chunkMeta, isFirstFragment || isFirstInDiscontinuity);
      } else if (isFirstFragment || isFirstInDiscontinuity) {
        // Mark segment with a gap to avoid loop loading
        frag.gap = true;
      } else {
        this.backtrack(frag);
        return;
      }
    }
    if (audio) {
      const {
        startPTS,
        endPTS,
        startDTS,
        endDTS
      } = audio;
      if (part) {
        part.elementaryStreams[ElementaryStreamTypes.AUDIO] = {
          startPTS,
          endPTS,
          startDTS,
          endDTS
        };
      }
      frag.setElementaryStreamInfo(ElementaryStreamTypes.AUDIO, startPTS, endPTS, startDTS, endDTS);
      this.bufferFragmentData(audio, frag, part, chunkMeta);
    }
    if (details && id3 != null && (_id3$samples = id3.samples) != null && _id3$samples.length) {
      const emittedID3 = {
        id,
        frag,
        details,
        samples: id3.samples
      };
      hls.trigger(Events.FRAG_PARSING_METADATA, emittedID3);
    }
    if (details && text) {
      const emittedText = {
        id,
        frag,
        details,
        samples: text.samples
      };
      hls.trigger(Events.FRAG_PARSING_USERDATA, emittedText);
    }
  }
  logMuxedErr(frag) {
    this.warn(`${isMediaFragment(frag) ? 'Media' : 'Init'} segment with muxed audiovideo where only video expected: ${frag.url}`);
  }
  _bufferInitSegment(currentLevel, tracks, frag, chunkMeta) {
    if (this.state !== State.PARSING) {
      return;
    }
    this.audioOnly = !!tracks.audio && !tracks.video;

    // if audio track is expected to come from audio stream controller, discard any coming from main
    if (this.altAudio && !this.audioOnly) {
      delete tracks.audio;
      if (tracks.audiovideo) {
        this.logMuxedErr(frag);
      }
    }
    // include levelCodec in audio and video tracks
    const {
      audio,
      video,
      audiovideo
    } = tracks;
    if (audio) {
      let audioCodec = pickMostCompleteCodecName(audio.codec, currentLevel.audioCodec);
      // Add level and profile to make up for passthrough-remuxer not being able to parse full codec
      // (logger warning "Unhandled audio codec...")
      if (audioCodec === 'mp4a') {
        audioCodec = 'mp4a.40.5';
      }
      // Handle `audioCodecSwitch`
      const ua = navigator.userAgent.toLowerCase();
      if (this.audioCodecSwitch) {
        if (audioCodec) {
          if (audioCodec.indexOf('mp4a.40.5') !== -1) {
            audioCodec = 'mp4a.40.2';
          } else {
            audioCodec = 'mp4a.40.5';
          }
        }
        // In the case that AAC and HE-AAC audio codecs are signalled in manifest,
        // force HE-AAC, as it seems that most browsers prefers it.
        // don't force HE-AAC if mono stream, or in Firefox
        const audioMetadata = audio.metadata;
        if (audioMetadata && 'channelCount' in audioMetadata && (audioMetadata.channelCount || 1) !== 1 && ua.indexOf('firefox') === -1) {
          audioCodec = 'mp4a.40.5';
        }
      }
      // HE-AAC is broken on Android, always signal audio codec as AAC even if variant manifest states otherwise
      if (audioCodec && audioCodec.indexOf('mp4a.40.5') !== -1 && ua.indexOf('android') !== -1 && audio.container !== 'audio/mpeg') {
        // Exclude mpeg audio
        audioCodec = 'mp4a.40.2';
        this.log(`Android: force audio codec to ${audioCodec}`);
      }
      if (currentLevel.audioCodec && currentLevel.audioCodec !== audioCodec) {
        this.log(`Swapping manifest audio codec "${currentLevel.audioCodec}" for "${audioCodec}"`);
      }
      audio.levelCodec = audioCodec;
      audio.id = PlaylistLevelType.MAIN;
      this.log(`Init audio buffer, container:${audio.container}, codecs[selected/level/parsed]=[${audioCodec || ''}/${currentLevel.audioCodec || ''}/${audio.codec}]`);
      delete tracks.audiovideo;
    }
    if (video) {
      video.levelCodec = currentLevel.videoCodec;
      video.id = PlaylistLevelType.MAIN;
      const parsedVideoCodec = video.codec;
      if ((parsedVideoCodec == null ? void 0 : parsedVideoCodec.length) === 4) {
        // Make up for passthrough-remuxer not being able to parse full codec
        // (logger warning "Unhandled video codec...")
        switch (parsedVideoCodec) {
          case 'hvc1':
          case 'hev1':
            video.codec = 'hvc1.1.6.L120.90';
            break;
          case 'av01':
            video.codec = 'av01.0.04M.08';
            break;
          case 'avc1':
            video.codec = 'avc1.42e01e';
            break;
        }
      }
      this.log(`Init video buffer, container:${video.container}, codecs[level/parsed]=[${currentLevel.videoCodec || ''}/${parsedVideoCodec}]${video.codec !== parsedVideoCodec ? ' parsed-corrected=' + video.codec : ''}${video.supplemental ? ' supplemental=' + video.supplemental : ''}`);
      delete tracks.audiovideo;
    }
    if (audiovideo) {
      this.log(`Init audiovideo buffer, container:${audiovideo.container}, codecs[level/parsed]=[${currentLevel.codecs}/${audiovideo.codec}]`);
      delete tracks.video;
      delete tracks.audio;
    }
    const trackTypes = Object.keys(tracks);
    if (trackTypes.length) {
      this.hls.trigger(Events.BUFFER_CODECS, tracks);
      if (!this.hls) {
        // Exit after fatal tracks error
        return;
      }
      // loop through tracks that are going to be provided to bufferController
      trackTypes.forEach(trackName => {
        const track = tracks[trackName];
        const initSegment = track.initSegment;
        if (initSegment != null && initSegment.byteLength) {
          this.hls.trigger(Events.BUFFER_APPENDING, {
            type: trackName,
            data: initSegment,
            frag,
            part: null,
            chunkMeta,
            parent: frag.type
          });
        }
      });
    }
    // trigger handler right now
    this.tickImmediate();
  }
  getMainFwdBufferInfo() {
    // Observe video SourceBuffer (this.mediaBuffer) only when alt-audio is used, otherwise observe combined media buffer
    const bufferOutput = this.mediaBuffer && this.altAudio === 2 ? this.mediaBuffer : this.media;
    return this.getFwdBufferInfo(bufferOutput, PlaylistLevelType.MAIN);
  }
  get maxBufferLength() {
    const {
      levels,
      level
    } = this;
    const levelInfo = levels == null ? void 0 : levels[level];
    if (!levelInfo) {
      return this.config.maxBufferLength;
    }
    return this.getMaxBufferLength(levelInfo.maxBitrate);
  }
  backtrack(frag) {
    this.couldBacktrack = true;
    // Causes findFragments to backtrack through fragments to find the keyframe
    this.backtrackFragment = frag;
    this.resetTransmuxer();
    this.flushBufferGap(frag);
    this.fragmentTracker.removeFragment(frag);
    this.fragPrevious = null;
    this.nextLoadPosition = frag.start;
    this.state = State.IDLE;
  }
  checkFragmentChanged() {
    const video = this.media;
    let fragPlayingCurrent = null;
    if (video && video.readyState > 1 && video.seeking === false) {
      const currentTime = video.currentTime;
      /* if video element is in seeked state, currentTime can only increase.
        (assuming that playback rate is positive ...)
        As sometimes currentTime jumps back to zero after a
        media decode error, check this, to avoid seeking back to
        wrong position after a media decode error
      */

      if (BufferHelper.isBuffered(video, currentTime)) {
        fragPlayingCurrent = this.getAppendedFrag(currentTime);
      } else if (BufferHelper.isBuffered(video, currentTime + 0.1)) {
        /* ensure that FRAG_CHANGED event is triggered at startup,
          when first video frame is displayed and playback is paused.
          add a tolerance of 100ms, in case current position is not buffered,
          check if current pos+100ms is buffered and use that buffer range
          for FRAG_CHANGED event reporting */
        fragPlayingCurrent = this.getAppendedFrag(currentTime + 0.1);
      }
      if (fragPlayingCurrent) {
        this.backtrackFragment = null;
        const fragPlaying = this.fragPlaying;
        const fragCurrentLevel = fragPlayingCurrent.level;
        if (!fragPlaying || fragPlayingCurrent.sn !== fragPlaying.sn || fragPlaying.level !== fragCurrentLevel) {
          this.fragPlaying = fragPlayingCurrent;
          this.hls.trigger(Events.FRAG_CHANGED, {
            frag: fragPlayingCurrent
          });
          if (!fragPlaying || fragPlaying.level !== fragCurrentLevel) {
            this.hls.trigger(Events.LEVEL_SWITCHED, {
              level: fragCurrentLevel
            });
          }
        }
      }
    }
  }
  get nextLevel() {
    const frag = this.nextBufferedFrag;
    if (frag) {
      return frag.level;
    }
    return -1;
  }
  get currentFrag() {
    var _this$media3;
    if (this.fragPlaying) {
      return this.fragPlaying;
    }
    const currentTime = ((_this$media3 = this.media) == null ? void 0 : _this$media3.currentTime) || this.lastCurrentTime;
    if (isFiniteNumber(currentTime)) {
      return this.getAppendedFrag(currentTime);
    }
    return null;
  }
  get currentProgramDateTime() {
    var _this$media4;
    const currentTime = ((_this$media4 = this.media) == null ? void 0 : _this$media4.currentTime) || this.lastCurrentTime;
    if (isFiniteNumber(currentTime)) {
      const details = this.getLevelDetails();
      const frag = this.currentFrag || (details ? findFragmentByPTS(null, details.fragments, currentTime) : null);
      if (frag) {
        const programDateTime = frag.programDateTime;
        if (programDateTime !== null) {
          const epocMs = programDateTime + (currentTime - frag.start) * 1000;
          return new Date(epocMs);
        }
      }
    }
    return null;
  }
  get currentLevel() {
    const frag = this.currentFrag;
    if (frag) {
      return frag.level;
    }
    return -1;
  }
  get nextBufferedFrag() {
    const frag = this.currentFrag;
    if (frag) {
      return this.followingBufferedFrag(frag);
    }
    return null;
  }
  get forceStartLoad() {
    return this._forceStartLoad;
  }
}

class KeyLoader {
  constructor(config) {
    this.config = void 0;
    this.keyUriToKeyInfo = {};
    this.emeController = null;
    this.config = config;
  }
  abort(type) {
    for (const uri in this.keyUriToKeyInfo) {
      const loader = this.keyUriToKeyInfo[uri].loader;
      if (loader) {
        var _loader$context;
        if (type && type !== ((_loader$context = loader.context) == null ? void 0 : _loader$context.frag.type)) {
          return;
        }
        loader.abort();
      }
    }
  }
  detach() {
    for (const uri in this.keyUriToKeyInfo) {
      const keyInfo = this.keyUriToKeyInfo[uri];
      // Remove cached EME keys on detach
      if (keyInfo.mediaKeySessionContext || keyInfo.decryptdata.isCommonEncryption) {
        delete this.keyUriToKeyInfo[uri];
      }
    }
  }
  destroy() {
    this.detach();
    for (const uri in this.keyUriToKeyInfo) {
      const loader = this.keyUriToKeyInfo[uri].loader;
      if (loader) {
        loader.destroy();
      }
    }
    this.keyUriToKeyInfo = {};
  }
  createKeyLoadError(frag, details = ErrorDetails.KEY_LOAD_ERROR, error, networkDetails, response) {
    return new LoadError({
      type: ErrorTypes.NETWORK_ERROR,
      details,
      fatal: false,
      frag,
      response,
      error,
      networkDetails
    });
  }
  loadClear(loadingFrag, encryptedFragments) {
    if (this.emeController && this.config.emeEnabled && !this.emeController.getSelectedKeySystemFormats().length) {
      // access key-system with nearest key on start (loading frag is unencrypted)
      if (encryptedFragments.length) {
        const {
          sn,
          cc
        } = loadingFrag;
        for (let i = 0; i < encryptedFragments.length; i++) {
          const frag = encryptedFragments[i];
          if (cc <= frag.cc && (sn === 'initSegment' || frag.sn === 'initSegment' || sn < frag.sn)) {
            return this.emeController.selectKeySystemFormat(frag).then(keySystemFormat => {
              frag.setKeyFormat(keySystemFormat);
              if (this.emeController && this.config.requireKeySystemAccessOnStart) {
                const keySystem = keySystemFormatToKeySystemDomain(keySystemFormat);
                if (keySystem) {
                  return this.emeController.getKeySystemAccess([keySystem]);
                }
              }
            });
          }
        }
      } else if (this.config.requireKeySystemAccessOnStart) {
        const keySystemsInConfig = getKeySystemsForConfig(this.config);
        if (keySystemsInConfig.length) {
          return this.emeController.getKeySystemAccess(keySystemsInConfig);
        }
      }
    }
    return null;
  }
  load(frag) {
    if (!frag.decryptdata && frag.encrypted && this.emeController && this.config.emeEnabled) {
      // Multiple keys, but none selected, resolve in eme-controller
      return this.emeController.selectKeySystemFormat(frag).then(keySystemFormat => {
        return this.loadInternal(frag, keySystemFormat);
      });
    }
    return this.loadInternal(frag);
  }
  loadInternal(frag, keySystemFormat) {
    var _keyInfo, _keyInfo2;
    if (keySystemFormat) {
      frag.setKeyFormat(keySystemFormat);
    }
    const decryptdata = frag.decryptdata;
    if (!decryptdata) {
      const error = new Error(keySystemFormat ? `Expected frag.decryptdata to be defined after setting format ${keySystemFormat}` : 'Missing decryption data on fragment in onKeyLoading');
      return Promise.reject(this.createKeyLoadError(frag, ErrorDetails.KEY_LOAD_ERROR, error));
    }
    const uri = decryptdata.uri;
    if (!uri) {
      return Promise.reject(this.createKeyLoadError(frag, ErrorDetails.KEY_LOAD_ERROR, new Error(`Invalid key URI: "${uri}"`)));
    }
    let keyInfo = this.keyUriToKeyInfo[uri];
    if ((_keyInfo = keyInfo) != null && _keyInfo.decryptdata.key) {
      decryptdata.key = keyInfo.decryptdata.key;
      return Promise.resolve({
        frag,
        keyInfo
      });
    }
    // Return key load promise as long as it does not have a mediakey session with an unusable key status
    if ((_keyInfo2 = keyInfo) != null && _keyInfo2.keyLoadPromise) {
      var _keyInfo$mediaKeySess;
      switch ((_keyInfo$mediaKeySess = keyInfo.mediaKeySessionContext) == null ? void 0 : _keyInfo$mediaKeySess.keyStatus) {
        case undefined:
        case 'status-pending':
        case 'usable':
        case 'usable-in-future':
          return keyInfo.keyLoadPromise.then(keyLoadedData => {
            // Return the correct fragment with updated decryptdata key and loaded keyInfo
            decryptdata.key = keyLoadedData.keyInfo.decryptdata.key;
            return {
              frag,
              keyInfo
            };
          });
      }
      // If we have a key session and status and it is not pending or usable, continue
      // This will go back to the eme-controller for expired keys to get a new keyLoadPromise
    }

    // Load the key or return the loading promise
    keyInfo = this.keyUriToKeyInfo[uri] = {
      decryptdata,
      keyLoadPromise: null,
      loader: null,
      mediaKeySessionContext: null
    };
    switch (decryptdata.method) {
      case 'ISO-23001-7':
      case 'SAMPLE-AES':
      case 'SAMPLE-AES-CENC':
      case 'SAMPLE-AES-CTR':
        if (decryptdata.keyFormat === 'identity') {
          // loadKeyHTTP handles http(s) and data URLs
          return this.loadKeyHTTP(keyInfo, frag);
        }
        return this.loadKeyEME(keyInfo, frag);
      case 'AES-128':
      case 'AES-256':
      case 'AES-256-CTR':
        return this.loadKeyHTTP(keyInfo, frag);
      default:
        return Promise.reject(this.createKeyLoadError(frag, ErrorDetails.KEY_LOAD_ERROR, new Error(`Key supplied with unsupported METHOD: "${decryptdata.method}"`)));
    }
  }
  loadKeyEME(keyInfo, frag) {
    const keyLoadedData = {
      frag,
      keyInfo
    };
    if (this.emeController && this.config.emeEnabled) {
      const keySessionContextPromise = this.emeController.loadKey(keyLoadedData);
      if (keySessionContextPromise) {
        return (keyInfo.keyLoadPromise = keySessionContextPromise.then(keySessionContext => {
          keyInfo.mediaKeySessionContext = keySessionContext;
          return keyLoadedData;
        })).catch(error => {
          // Remove promise for license renewal or retry
          keyInfo.keyLoadPromise = null;
          throw error;
        });
      }
    }
    return Promise.resolve(keyLoadedData);
  }
  loadKeyHTTP(keyInfo, frag) {
    const config = this.config;
    const Loader = config.loader;
    const keyLoader = new Loader(config);
    frag.keyLoader = keyInfo.loader = keyLoader;
    return keyInfo.keyLoadPromise = new Promise((resolve, reject) => {
      const loaderContext = {
        keyInfo,
        frag,
        responseType: 'arraybuffer',
        url: keyInfo.decryptdata.uri
      };

      // maxRetry is 0 so that instead of retrying the same key on the same variant multiple times,
      // key-loader will trigger an error and rely on stream-controller to handle retry logic.
      // this will also align retry logic with fragment-loader
      const loadPolicy = config.keyLoadPolicy.default;
      const loaderConfig = {
        loadPolicy,
        timeout: loadPolicy.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0
      };
      const loaderCallbacks = {
        onSuccess: (response, stats, context, networkDetails) => {
          const {
            frag,
            keyInfo,
            url: uri
          } = context;
          if (!frag.decryptdata || keyInfo !== this.keyUriToKeyInfo[uri]) {
            return reject(this.createKeyLoadError(frag, ErrorDetails.KEY_LOAD_ERROR, new Error('after key load, decryptdata unset or changed'), networkDetails));
          }
          keyInfo.decryptdata.key = frag.decryptdata.key = new Uint8Array(response.data);

          // detach fragment key loader on load success
          frag.keyLoader = null;
          keyInfo.loader = null;
          resolve({
            frag,
            keyInfo
          });
        },
        onError: (response, context, networkDetails, stats) => {
          this.resetLoader(context);
          reject(this.createKeyLoadError(frag, ErrorDetails.KEY_LOAD_ERROR, new Error(`HTTP Error ${response.code} loading key ${response.text}`), networkDetails, _objectSpread2({
            url: loaderContext.url,
            data: undefined
          }, response)));
        },
        onTimeout: (stats, context, networkDetails) => {
          this.resetLoader(context);
          reject(this.createKeyLoadError(frag, ErrorDetails.KEY_LOAD_TIMEOUT, new Error('key loading timed out'), networkDetails));
        },
        onAbort: (stats, context, networkDetails) => {
          this.resetLoader(context);
          reject(this.createKeyLoadError(frag, ErrorDetails.INTERNAL_ABORTED, new Error('key loading aborted'), networkDetails));
        }
      };
      keyLoader.load(loaderContext, loaderConfig, loaderCallbacks);
    });
  }
  resetLoader(context) {
    const {
      frag,
      keyInfo,
      url: uri
    } = context;
    const loader = keyInfo.loader;
    if (frag.keyLoader === loader) {
      frag.keyLoader = null;
      keyInfo.loader = null;
    }
    delete this.keyUriToKeyInfo[uri];
    if (loader) {
      loader.destroy();
    }
  }
}

function mapContextToLevelType(context) {
  const {
    type
  } = context;
  switch (type) {
    case PlaylistContextType.AUDIO_TRACK:
      return PlaylistLevelType.AUDIO;
    case PlaylistContextType.SUBTITLE_TRACK:
      return PlaylistLevelType.SUBTITLE;
    default:
      return PlaylistLevelType.MAIN;
  }
}
function getResponseUrl(response, context) {
  let url = response.url;
  // responseURL not supported on some browsers (it is used to detect URL redirection)
  // data-uri mode also not supported (but no need to detect redirection)
  if (url === undefined || url.indexOf('data:') === 0) {
    // fallback to initial URL
    url = context.url;
  }
  return url;
}
class PlaylistLoader {
  constructor(hls) {
    this.hls = void 0;
    this.loaders = Object.create(null);
    this.variableList = null;
    this.onManifestLoaded = this.checkAutostartLoad;
    this.hls = hls;
    this.registerListeners();
  }
  startLoad(startPosition) {}
  stopLoad() {
    this.destroyInternalLoaders();
  }
  registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.LEVEL_LOADING, this.onLevelLoading, this);
    hls.on(Events.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this);
    hls.on(Events.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
    hls.on(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
  }
  unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.LEVEL_LOADING, this.onLevelLoading, this);
    hls.off(Events.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this);
    hls.off(Events.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
    hls.off(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
  }

  /**
   * Returns defaults or configured loader-type overloads (pLoader and loader config params)
   */
  createInternalLoader(context) {
    const config = this.hls.config;
    const PLoader = config.pLoader;
    const Loader = config.loader;
    const InternalLoader = PLoader || Loader;
    const loader = new InternalLoader(config);
    this.loaders[context.type] = loader;
    return loader;
  }
  getInternalLoader(context) {
    return this.loaders[context.type];
  }
  resetInternalLoader(contextType) {
    if (this.loaders[contextType]) {
      delete this.loaders[contextType];
    }
  }

  /**
   * Call `destroy` on all internal loader instances mapped (one per context type)
   */
  destroyInternalLoaders() {
    for (const contextType in this.loaders) {
      const loader = this.loaders[contextType];
      if (loader) {
        loader.destroy();
      }
      this.resetInternalLoader(contextType);
    }
  }
  destroy() {
    this.variableList = null;
    this.unregisterListeners();
    this.destroyInternalLoaders();
  }
  onManifestLoading(event, data) {
    const {
      url
    } = data;
    this.variableList = null;
    this.load({
      id: null,
      level: 0,
      responseType: 'text',
      type: PlaylistContextType.MANIFEST,
      url,
      deliveryDirectives: null,
      levelOrTrack: null
    });
  }
  onLevelLoading(event, data) {
    const {
      id,
      level,
      pathwayId,
      url,
      deliveryDirectives,
      levelInfo
    } = data;
    this.load({
      id,
      level,
      pathwayId,
      responseType: 'text',
      type: PlaylistContextType.LEVEL,
      url,
      deliveryDirectives,
      levelOrTrack: levelInfo
    });
  }
  onAudioTrackLoading(event, data) {
    const {
      id,
      groupId,
      url,
      deliveryDirectives,
      track
    } = data;
    this.load({
      id,
      groupId,
      level: null,
      responseType: 'text',
      type: PlaylistContextType.AUDIO_TRACK,
      url,
      deliveryDirectives,
      levelOrTrack: track
    });
  }
  onSubtitleTrackLoading(event, data) {
    const {
      id,
      groupId,
      url,
      deliveryDirectives,
      track
    } = data;
    this.load({
      id,
      groupId,
      level: null,
      responseType: 'text',
      type: PlaylistContextType.SUBTITLE_TRACK,
      url,
      deliveryDirectives,
      levelOrTrack: track
    });
  }
  onLevelsUpdated(event, data) {
    // abort and delete loader of removed levels
    const loader = this.loaders[PlaylistContextType.LEVEL];
    if (loader) {
      const context = loader.context;
      if (context && !data.levels.some(lvl => lvl === context.levelOrTrack)) {
        loader.abort();
        delete this.loaders[PlaylistContextType.LEVEL];
      }
    }
  }
  load(context) {
    var _context$deliveryDire;
    const config = this.hls.config;

    // logger.debug(`[playlist-loader]: Loading playlist of type ${context.type}, level: ${context.level}, id: ${context.id}`);

    // Check if a loader for this context already exists
    let loader = this.getInternalLoader(context);
    if (loader) {
      const logger = this.hls.logger;
      const loaderContext = loader.context;
      if (loaderContext && loaderContext.levelOrTrack === context.levelOrTrack && (loaderContext.url === context.url || loaderContext.deliveryDirectives && !context.deliveryDirectives)) {
        // same URL can't overlap, or wait for blocking request
        if (loaderContext.url === context.url) {
          logger.log(`[playlist-loader]: ignore ${context.url} ongoing request`);
        } else {
          logger.log(`[playlist-loader]: ignore ${context.url} in favor of ${loaderContext.url}`);
        }
        return;
      }
      logger.log(`[playlist-loader]: aborting previous loader for type: ${context.type}`);
      loader.abort();
    }

    // apply different configs for retries depending on
    // context (manifest, level, audio/subs playlist)
    let loadPolicy;
    if (context.type === PlaylistContextType.MANIFEST) {
      loadPolicy = config.manifestLoadPolicy.default;
    } else {
      loadPolicy = _extends({}, config.playlistLoadPolicy.default, {
        timeoutRetry: null,
        errorRetry: null
      });
    }
    loader = this.createInternalLoader(context);

    // Override level/track timeout for LL-HLS requests
    // (the default of 10000ms is counter productive to blocking playlist reload requests)
    if (isFiniteNumber((_context$deliveryDire = context.deliveryDirectives) == null ? void 0 : _context$deliveryDire.part)) {
      let levelDetails;
      if (context.type === PlaylistContextType.LEVEL && context.level !== null) {
        levelDetails = this.hls.levels[context.level].details;
      } else if (context.type === PlaylistContextType.AUDIO_TRACK && context.id !== null) {
        levelDetails = this.hls.audioTracks[context.id].details;
      } else if (context.type === PlaylistContextType.SUBTITLE_TRACK && context.id !== null) {
        levelDetails = this.hls.subtitleTracks[context.id].details;
      }
      if (levelDetails) {
        const partTarget = levelDetails.partTarget;
        const targetDuration = levelDetails.targetduration;
        if (partTarget && targetDuration) {
          const maxLowLatencyPlaylistRefresh = Math.max(partTarget * 3, targetDuration * 0.8) * 1000;
          loadPolicy = _extends({}, loadPolicy, {
            maxTimeToFirstByteMs: Math.min(maxLowLatencyPlaylistRefresh, loadPolicy.maxTimeToFirstByteMs),
            maxLoadTimeMs: Math.min(maxLowLatencyPlaylistRefresh, loadPolicy.maxTimeToFirstByteMs)
          });
        }
      }
    }
    const legacyRetryCompatibility = loadPolicy.errorRetry || loadPolicy.timeoutRetry || {};
    const loaderConfig = {
      loadPolicy,
      timeout: loadPolicy.maxLoadTimeMs,
      maxRetry: legacyRetryCompatibility.maxNumRetry || 0,
      retryDelay: legacyRetryCompatibility.retryDelayMs || 0,
      maxRetryDelay: legacyRetryCompatibility.maxRetryDelayMs || 0
    };
    const loaderCallbacks = {
      onSuccess: (response, stats, context, networkDetails) => {
        const loader = this.getInternalLoader(context);
        this.resetInternalLoader(context.type);
        const string = response.data;

        // Validate if it is an M3U8 at all
        if (string.indexOf('#EXTM3U') !== 0) {
          this.handleManifestParsingError(response, context, new Error('no EXTM3U delimiter'), networkDetails || null, stats);
          return;
        }
        stats.parsing.start = performance.now();
        if (M3U8Parser.isMediaPlaylist(string) || context.type !== PlaylistContextType.MANIFEST) {
          this.handleTrackOrLevelPlaylist(response, stats, context, networkDetails || null, loader);
        } else {
          this.handleMasterPlaylist(response, stats, context, networkDetails);
        }
      },
      onError: (response, context, networkDetails, stats) => {
        this.handleNetworkError(context, networkDetails, false, response, stats);
      },
      onTimeout: (stats, context, networkDetails) => {
        this.handleNetworkError(context, networkDetails, true, undefined, stats);
      }
    };

    // logger.debug(`[playlist-loader]: Calling internal loader delegate for URL: ${context.url}`);

    loader.load(context, loaderConfig, loaderCallbacks);
  }
  checkAutostartLoad() {
    if (!this.hls) {
      return;
    }
    const {
      config: {
        autoStartLoad,
        startPosition
      },
      forceStartLoad
    } = this.hls;
    if (autoStartLoad || forceStartLoad) {
      this.hls.logger.log(`${autoStartLoad ? 'auto' : 'force'} startLoad with configured startPosition ${startPosition}`);
      this.hls.startLoad(startPosition);
    }
  }
  handleMasterPlaylist(response, stats, context, networkDetails) {
    const hls = this.hls;
    const string = response.data;
    const url = getResponseUrl(response, context);
    const parsedResult = M3U8Parser.parseMasterPlaylist(string, url);
    if (parsedResult.playlistParsingError) {
      this.handleManifestParsingError(response, context, parsedResult.playlistParsingError, networkDetails, stats);
      return;
    }
    const {
      contentSteering,
      levels,
      sessionData,
      sessionKeys,
      startTimeOffset,
      variableList
    } = parsedResult;
    this.variableList = variableList;
    const {
      AUDIO: audioTracks = [],
      SUBTITLES: subtitles,
      'CLOSED-CAPTIONS': captions
    } = M3U8Parser.parseMasterPlaylistMedia(string, url, parsedResult);
    if (audioTracks.length) {
      // check if we have found an audio track embedded in main playlist (audio track without URI attribute)
      const embeddedAudioFound = audioTracks.some(audioTrack => !audioTrack.url);

      // if no embedded audio track defined, but audio codec signaled in quality level,
      // we need to signal this main audio track this could happen with playlists with
      // alt audio rendition in which quality levels (main)
      // contains both audio+video. but with mixed audio track not signaled
      if (!embeddedAudioFound && levels[0].audioCodec && !levels[0].attrs.AUDIO) {
        this.hls.logger.log('[playlist-loader]: audio codec signaled in quality level, but no embedded audio track signaled, create one');
        audioTracks.unshift({
          type: 'main',
          name: 'main',
          groupId: 'main',
          default: false,
          autoselect: false,
          forced: false,
          id: -1,
          attrs: new AttrList({}),
          bitrate: 0,
          url: ''
        });
      }
    }
    hls.trigger(Events.MANIFEST_LOADED, {
      levels,
      audioTracks,
      subtitles,
      captions,
      contentSteering,
      url,
      stats,
      networkDetails,
      sessionData,
      sessionKeys,
      startTimeOffset,
      variableList
    });
  }
  handleTrackOrLevelPlaylist(response, stats, context, networkDetails, loader) {
    const hls = this.hls;
    const {
      id,
      level,
      type
    } = context;
    const url = getResponseUrl(response, context);
    const levelId = isFiniteNumber(level) ? level : isFiniteNumber(id) ? id : 0;
    const levelType = mapContextToLevelType(context);
    const levelDetails = M3U8Parser.parseLevelPlaylist(response.data, url, levelId, levelType, 0, this.variableList);

    // We have done our first request (Manifest-type) and receive
    // not a master playlist but a chunk-list (track/level)
    // We fire the manifest-loaded event anyway with the parsed level-details
    // by creating a single-level structure for it.
    if (type === PlaylistContextType.MANIFEST) {
      const singleLevel = {
        attrs: new AttrList({}),
        bitrate: 0,
        details: levelDetails,
        name: '',
        url
      };
      levelDetails.requestScheduled = stats.loading.start + computeReloadInterval(levelDetails, 0);
      hls.trigger(Events.MANIFEST_LOADED, {
        levels: [singleLevel],
        audioTracks: [],
        url,
        stats,
        networkDetails,
        sessionData: null,
        sessionKeys: null,
        contentSteering: null,
        startTimeOffset: null,
        variableList: null
      });
    }

    // save parsing time
    stats.parsing.end = performance.now();

    // extend the context with the new levelDetails property
    context.levelDetails = levelDetails;
    this.handlePlaylistLoaded(levelDetails, response, stats, context, networkDetails, loader);
  }
  handleManifestParsingError(response, context, error, networkDetails, stats) {
    this.hls.trigger(Events.ERROR, {
      type: ErrorTypes.NETWORK_ERROR,
      details: ErrorDetails.MANIFEST_PARSING_ERROR,
      fatal: context.type === PlaylistContextType.MANIFEST,
      url: response.url,
      err: error,
      error,
      reason: error.message,
      response,
      context,
      networkDetails,
      stats
    });
  }
  handleNetworkError(context, networkDetails, timeout = false, response, stats) {
    let message = `A network ${timeout ? 'timeout' : 'error' + (response ? ' (status ' + response.code + ')' : '')} occurred while loading ${context.type}`;
    if (context.type === PlaylistContextType.LEVEL) {
      message += `: ${context.level} id: ${context.id}`;
    } else if (context.type === PlaylistContextType.AUDIO_TRACK || context.type === PlaylistContextType.SUBTITLE_TRACK) {
      message += ` id: ${context.id} group-id: "${context.groupId}"`;
    }
    const error = new Error(message);
    this.hls.logger.warn(`[playlist-loader]: ${message}`);
    let details = ErrorDetails.UNKNOWN;
    let fatal = false;
    const loader = this.getInternalLoader(context);
    switch (context.type) {
      case PlaylistContextType.MANIFEST:
        details = timeout ? ErrorDetails.MANIFEST_LOAD_TIMEOUT : ErrorDetails.MANIFEST_LOAD_ERROR;
        fatal = true;
        break;
      case PlaylistContextType.LEVEL:
        details = timeout ? ErrorDetails.LEVEL_LOAD_TIMEOUT : ErrorDetails.LEVEL_LOAD_ERROR;
        fatal = false;
        break;
      case PlaylistContextType.AUDIO_TRACK:
        details = timeout ? ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT : ErrorDetails.AUDIO_TRACK_LOAD_ERROR;
        fatal = false;
        break;
      case PlaylistContextType.SUBTITLE_TRACK:
        details = timeout ? ErrorDetails.SUBTITLE_TRACK_LOAD_TIMEOUT : ErrorDetails.SUBTITLE_LOAD_ERROR;
        fatal = false;
        break;
    }
    if (loader) {
      this.resetInternalLoader(context.type);
    }
    const errorData = {
      type: ErrorTypes.NETWORK_ERROR,
      details,
      fatal,
      url: context.url,
      loader,
      context,
      error,
      networkDetails,
      stats
    };
    if (response) {
      const url = (networkDetails == null ? void 0 : networkDetails.url) || context.url;
      errorData.response = _objectSpread2({
        url,
        data: undefined
      }, response);
    }
    this.hls.trigger(Events.ERROR, errorData);
  }
  handlePlaylistLoaded(levelDetails, response, stats, context, networkDetails, loader) {
    const hls = this.hls;
    const {
      type,
      level,
      id,
      groupId,
      deliveryDirectives
    } = context;
    const url = getResponseUrl(response, context);
    const parent = mapContextToLevelType(context);
    const levelIndex = typeof context.level === 'number' && parent === PlaylistLevelType.MAIN ? level : undefined;
    if (!levelDetails.fragments.length) {
      const _error = levelDetails.playlistParsingError = new Error('No Segments found in Playlist');
      hls.trigger(Events.ERROR, {
        type: ErrorTypes.NETWORK_ERROR,
        details: ErrorDetails.LEVEL_EMPTY_ERROR,
        fatal: false,
        url,
        error: _error,
        reason: _error.message,
        response,
        context,
        level: levelIndex,
        parent,
        networkDetails,
        stats
      });
      return;
    }
    if (!levelDetails.targetduration) {
      levelDetails.playlistParsingError = new Error('Missing Target Duration');
    }
    const error = levelDetails.playlistParsingError;
    if (error) {
      this.hls.logger.warn(error);
      if (!hls.config.ignorePlaylistParsingErrors) {
        hls.trigger(Events.ERROR, {
          type: ErrorTypes.NETWORK_ERROR,
          details: ErrorDetails.LEVEL_PARSING_ERROR,
          fatal: false,
          url,
          error,
          reason: error.message,
          response,
          context,
          level: levelIndex,
          parent,
          networkDetails,
          stats
        });
        return;
      }
      levelDetails.playlistParsingError = null;
    }
    if (levelDetails.live && loader) {
      if (loader.getCacheAge) {
        levelDetails.ageHeader = loader.getCacheAge() || 0;
      }
      if (!loader.getCacheAge || isNaN(levelDetails.ageHeader)) {
        levelDetails.ageHeader = 0;
      }
    }
    switch (type) {
      case PlaylistContextType.MANIFEST:
      case PlaylistContextType.LEVEL:
        hls.trigger(Events.LEVEL_LOADED, {
          details: levelDetails,
          levelInfo: context.levelOrTrack || hls.levels[0],
          level: levelIndex || 0,
          id: id || 0,
          stats,
          networkDetails,
          deliveryDirectives,
          withoutMultiVariant: type === PlaylistContextType.MANIFEST
        });
        break;
      case PlaylistContextType.AUDIO_TRACK:
        hls.trigger(Events.AUDIO_TRACK_LOADED, {
          details: levelDetails,
          track: context.levelOrTrack,
          id: id || 0,
          groupId: groupId || '',
          stats,
          networkDetails,
          deliveryDirectives
        });
        break;
      case PlaylistContextType.SUBTITLE_TRACK:
        hls.trigger(Events.SUBTITLE_TRACK_LOADED, {
          details: levelDetails,
          track: context.levelOrTrack,
          id: id || 0,
          groupId: groupId || '',
          stats,
          networkDetails,
          deliveryDirectives
        });
        break;
    }
  }
}

/**
 * The `Hls` class is the core of the HLS.js library used to instantiate player instances.
 * @public
 */
class Hls {
  /**
   * Get the video-dev/hls.js package version.
   */
  static get version() {
    return version;
  }

  /**
   * Check if the required MediaSource Extensions are available.
   */
  static isMSESupported() {
    return isMSESupported();
  }

  /**
   * Check if MediaSource Extensions are available and isTypeSupported checks pass for any baseline codecs.
   */
  static isSupported() {
    return isSupported();
  }

  /**
   * Get the MediaSource global used for MSE playback (ManagedMediaSource, MediaSource, or WebKitMediaSource).
   */
  static getMediaSource() {
    return getMediaSource();
  }
  static get Events() {
    return Events;
  }
  static get MetadataSchema() {
    return MetadataSchema;
  }
  static get ErrorTypes() {
    return ErrorTypes;
  }
  static get ErrorDetails() {
    return ErrorDetails;
  }

  /**
   * Get the default configuration applied to new instances.
   */
  static get DefaultConfig() {
    if (!Hls.defaultConfig) {
      return hlsDefaultConfig;
    }
    return Hls.defaultConfig;
  }

  /**
   * Replace the default configuration applied to new instances.
   */
  static set DefaultConfig(defaultConfig) {
    Hls.defaultConfig = defaultConfig;
  }

  /**
   * Creates an instance of an HLS client that can attach to exactly one `HTMLMediaElement`.
   * @param userConfig - Configuration options applied over `Hls.DefaultConfig`
   */
  constructor(userConfig = {}) {
    /**
     * The runtime configuration used by the player. At instantiation this is combination of `hls.userConfig` merged over `Hls.DefaultConfig`.
     */
    this.config = void 0;
    /**
     * The configuration object provided on player instantiation.
     */
    this.userConfig = void 0;
    /**
     * The logger functions used by this player instance, configured on player instantiation.
     */
    this.logger = void 0;
    this.coreComponents = void 0;
    this.networkControllers = void 0;
    this._emitter = new hls_EventEmitter();
    this._autoLevelCapping = -1;
    this._maxHdcpLevel = null;
    this.abrController = void 0;
    this.bufferController = void 0;
    this.capLevelController = void 0;
    this.latencyController = void 0;
    this.levelController = void 0;
    this.streamController = void 0;
    this.audioStreamController = void 0;
    this.subtititleStreamController = void 0;
    this.audioTrackController = void 0;
    this.subtitleTrackController = void 0;
    this.interstitialsController = void 0;
    this.gapController = void 0;
    this.emeController = void 0;
    this.cmcdController = void 0;
    this._media = null;
    this._url = null;
    this._sessionId = void 0;
    this.triggeringException = void 0;
    this.started = false;
    const logger = this.logger = enableLogs(userConfig.debug || false, 'Hls instance', userConfig.assetPlayerId);
    const config = this.config = mergeConfig(Hls.DefaultConfig, userConfig, logger);
    this.userConfig = userConfig;
    if (config.progressive) {
      enableStreamingMode(config, logger);
    }

    // core controllers and network loaders
    const {
      abrController: _AbrController,
      bufferController: _BufferController,
      capLevelController: _CapLevelController,
      errorController: _ErrorController,
      fpsController: _FpsController
    } = config;
    const errorController = new _ErrorController(this);
    const abrController = this.abrController = new _AbrController(this);
    // FragmentTracker must be defined before StreamController because the order of event handling is important
    const fragmentTracker = new FragmentTracker(this);
    const _InterstitialsController = config.interstitialsController;
    const interstitialsController = _InterstitialsController ? this.interstitialsController = new _InterstitialsController(this, Hls) : null;
    const bufferController = this.bufferController = new _BufferController(this, fragmentTracker);
    const capLevelController = this.capLevelController = new _CapLevelController(this);
    const fpsController = new _FpsController(this);
    const playListLoader = new PlaylistLoader(this);
    const _ContentSteeringController = config.contentSteeringController;
    // Instantiate ConentSteeringController before LevelController to receive Multivariant Playlist events first
    const contentSteering = _ContentSteeringController ? new _ContentSteeringController(this) : null;
    const levelController = this.levelController = new LevelController(this, contentSteering);
    const id3TrackController = new ID3TrackController(this);
    const keyLoader = new KeyLoader(this.config);
    const streamController = this.streamController = new StreamController(this, fragmentTracker, keyLoader);
    const gapController = this.gapController = new GapController(this, fragmentTracker);

    // Cap level controller uses streamController to flush the buffer
    capLevelController.setStreamController(streamController);
    // fpsController uses streamController to switch when frames are being dropped
    fpsController.setStreamController(streamController);
    const networkControllers = [playListLoader, levelController, streamController];
    if (interstitialsController) {
      networkControllers.splice(1, 0, interstitialsController);
    }
    if (contentSteering) {
      networkControllers.splice(1, 0, contentSteering);
    }
    this.networkControllers = networkControllers;
    const coreComponents = [abrController, bufferController, gapController, capLevelController, fpsController, id3TrackController, fragmentTracker];
    this.audioTrackController = this.createController(config.audioTrackController, networkControllers);
    const AudioStreamControllerClass = config.audioStreamController;
    if (AudioStreamControllerClass) {
      networkControllers.push(this.audioStreamController = new AudioStreamControllerClass(this, fragmentTracker, keyLoader));
    }
    // Instantiate subtitleTrackController before SubtitleStreamController to receive level events first
    this.subtitleTrackController = this.createController(config.subtitleTrackController, networkControllers);
    const SubtitleStreamControllerClass = config.subtitleStreamController;
    if (SubtitleStreamControllerClass) {
      networkControllers.push(this.subtititleStreamController = new SubtitleStreamControllerClass(this, fragmentTracker, keyLoader));
    }
    this.createController(config.timelineController, coreComponents);
    keyLoader.emeController = this.emeController = this.createController(config.emeController, coreComponents);
    this.cmcdController = this.createController(config.cmcdController, coreComponents);
    this.latencyController = this.createController(LatencyController, coreComponents);
    this.coreComponents = coreComponents;

    // Error controller handles errors before and after all other controllers
    // This listener will be invoked after all other controllers error listeners
    networkControllers.push(errorController);
    const onErrorOut = errorController.onErrorOut;
    if (typeof onErrorOut === 'function') {
      this.on(Events.ERROR, onErrorOut, errorController);
    }
    // Autostart load handler
    this.on(Events.MANIFEST_LOADED, playListLoader.onManifestLoaded, playListLoader);
  }
  createController(ControllerClass, components) {
    if (ControllerClass) {
      const controllerInstance = new ControllerClass(this);
      if (components) {
        components.push(controllerInstance);
      }
      return controllerInstance;
    }
    return null;
  }

  // Delegate the EventEmitter through the public API of Hls.js
  on(event, listener, context = this) {
    this._emitter.on(event, listener, context);
  }
  once(event, listener, context = this) {
    this._emitter.once(event, listener, context);
  }
  removeAllListeners(event) {
    this._emitter.removeAllListeners(event);
  }
  off(event, listener, context = this, once) {
    this._emitter.off(event, listener, context, once);
  }
  listeners(event) {
    return this._emitter.listeners(event);
  }
  emit(event, name, eventObject) {
    return this._emitter.emit(event, name, eventObject);
  }
  trigger(event, eventObject) {
    if (this.config.debug) {
      return this.emit(event, event, eventObject);
    } else {
      try {
        return this.emit(event, event, eventObject);
      } catch (error) {
        this.logger.error('An internal error happened while handling event ' + event + '. Error message: "' + error.message + '". Here is a stacktrace:', error);
        // Prevent recursion in error event handlers that throw #5497
        if (!this.triggeringException) {
          this.triggeringException = true;
          const fatal = event === Events.ERROR;
          this.trigger(Events.ERROR, {
            type: ErrorTypes.OTHER_ERROR,
            details: ErrorDetails.INTERNAL_EXCEPTION,
            fatal,
            event,
            error
          });
          this.triggeringException = false;
        }
      }
    }
    return false;
  }
  listenerCount(event) {
    return this._emitter.listenerCount(event);
  }

  /**
   * Dispose of the instance
   */
  destroy() {
    this.logger.log('destroy');
    this.trigger(Events.DESTROYING, undefined);
    this.detachMedia();
    this.removeAllListeners();
    this._autoLevelCapping = -1;
    this._url = null;
    this.networkControllers.forEach(component => component.destroy());
    this.networkControllers.length = 0;
    this.coreComponents.forEach(component => component.destroy());
    this.coreComponents.length = 0;
    // Remove any references that could be held in config options or callbacks
    const config = this.config;
    config.xhrSetup = config.fetchSetup = undefined;
    // @ts-ignore
    this.userConfig = null;
  }

  /**
   * Attaches Hls.js to a media element
   */
  attachMedia(data) {
    if (!data || 'media' in data && !data.media) {
      const error = new Error(`attachMedia failed: invalid argument (${data})`);
      this.trigger(Events.ERROR, {
        type: ErrorTypes.OTHER_ERROR,
        details: ErrorDetails.ATTACH_MEDIA_ERROR,
        fatal: true,
        error
      });
      return;
    }
    this.logger.log(`attachMedia`);
    if (this._media) {
      this.logger.warn(`media must be detached before attaching`);
      this.detachMedia();
    }
    const attachMediaSource = 'media' in data;
    const media = attachMediaSource ? data.media : data;
    const attachingData = attachMediaSource ? data : {
      media
    };
    this._media = media;
    this.trigger(Events.MEDIA_ATTACHING, attachingData);
  }

  /**
   * Detach Hls.js from the media
   */
  detachMedia() {
    this.logger.log('detachMedia');
    this.trigger(Events.MEDIA_DETACHING, {});
    this._media = null;
  }

  /**
   * Detach HTMLMediaElement, MediaSource, and SourceBuffers without reset, for attaching to another instance
   */
  transferMedia() {
    this._media = null;
    const transferMedia = this.bufferController.transferMedia();
    this.trigger(Events.MEDIA_DETACHING, {
      transferMedia
    });
    return transferMedia;
  }

  /**
   * Set the source URL. Can be relative or absolute.
   */
  loadSource(url) {
    this.stopLoad();
    const media = this.media;
    const loadedSource = this._url;
    const loadingSource = this._url = urlToolkitExports.buildAbsoluteURL(self.location.href, url, {
      alwaysNormalize: true
    });
    this._autoLevelCapping = -1;
    this._maxHdcpLevel = null;
    this.logger.log(`loadSource:${loadingSource}`);
    if (media && loadedSource && (loadedSource !== loadingSource || this.bufferController.hasSourceTypes())) {
      // Remove and re-create MediaSource
      this.detachMedia();
      this.attachMedia(media);
    }
    // when attaching to a source URL, trigger a playlist load
    this.trigger(Events.MANIFEST_LOADING, {
      url: url
    });
  }

  /**
   * Gets the currently loaded URL
   */
  get url() {
    return this._url;
  }

  /**
   * Whether or not enough has been buffered to seek to start position or use `media.currentTime` to determine next load position
   */
  get hasEnoughToStart() {
    return this.streamController.hasEnoughToStart;
  }

  /**
   * Get the startPosition set on startLoad(position) or on autostart with config.startPosition
   */
  get startPosition() {
    return this.streamController.startPositionValue;
  }

  /**
   * Start loading data from the stream source.
   * Depending on default config, client starts loading automatically when a source is set.
   *
   * @param startPosition - Set the start position to stream from.
   * Defaults to -1 (None: starts from earliest point)
   */
  startLoad(startPosition = -1, skipSeekToStartPosition) {
    this.logger.log(`startLoad(${startPosition + (skipSeekToStartPosition ? ', <skip seek to start>' : '')})`);
    this.started = true;
    this.resumeBuffering();
    for (let i = 0; i < this.networkControllers.length; i++) {
      this.networkControllers[i].startLoad(startPosition, skipSeekToStartPosition);
      if (!this.started || !this.networkControllers) {
        break;
      }
    }
  }

  /**
   * Stop loading of any stream data.
   */
  stopLoad() {
    this.logger.log('stopLoad');
    this.started = false;
    for (let i = 0; i < this.networkControllers.length; i++) {
      this.networkControllers[i].stopLoad();
      if (this.started || !this.networkControllers) {
        break;
      }
    }
  }

  /**
   * Returns whether loading, toggled with `startLoad()` and `stopLoad()`, is active or not`.
   */
  get loadingEnabled() {
    return this.started;
  }

  /**
   * Returns state of fragment loading toggled by calling `pauseBuffering()` and `resumeBuffering()`.
   */
  get bufferingEnabled() {
    return this.streamController.bufferingEnabled;
  }

  /**
   * Resumes stream controller segment loading after `pauseBuffering` has been called.
   */
  resumeBuffering() {
    if (!this.bufferingEnabled) {
      this.logger.log(`resume buffering`);
      this.networkControllers.forEach(controller => {
        if (controller.resumeBuffering) {
          controller.resumeBuffering();
        }
      });
    }
  }

  /**
   * Prevents stream controller from loading new segments until `resumeBuffering` is called.
   * This allows for media buffering to be paused without interupting playlist loading.
   */
  pauseBuffering() {
    if (this.bufferingEnabled) {
      this.logger.log(`pause buffering`);
      this.networkControllers.forEach(controller => {
        if (controller.pauseBuffering) {
          controller.pauseBuffering();
        }
      });
    }
  }
  get inFlightFragments() {
    const inFlightData = {
      [PlaylistLevelType.MAIN]: this.streamController.inFlightFrag
    };
    if (this.audioStreamController) {
      inFlightData[PlaylistLevelType.AUDIO] = this.audioStreamController.inFlightFrag;
    }
    if (this.subtititleStreamController) {
      inFlightData[PlaylistLevelType.SUBTITLE] = this.subtititleStreamController.inFlightFrag;
    }
    return inFlightData;
  }

  /**
   * Swap through possible audio codecs in the stream (for example to switch from stereo to 5.1)
   */
  swapAudioCodec() {
    this.logger.log('swapAudioCodec');
    this.streamController.swapAudioCodec();
  }

  /**
   * When the media-element fails, this allows to detach and then re-attach it
   * as one call (convenience method).
   *
   * Automatic recovery of media-errors by this process is configurable.
   */
  recoverMediaError() {
    this.logger.log('recoverMediaError');
    const media = this._media;
    const time = media == null ? void 0 : media.currentTime;
    this.detachMedia();
    if (media) {
      this.attachMedia(media);
      if (time) {
        this.startLoad(time);
      }
    }
  }
  removeLevel(levelIndex) {
    this.levelController.removeLevel(levelIndex);
  }

  /**
   * @returns a UUID for this player instance
   */
  get sessionId() {
    let _sessionId = this._sessionId;
    if (!_sessionId) {
      _sessionId = this._sessionId = uuid();
    }
    return _sessionId;
  }

  /**
   * @returns an array of levels (variants) sorted by HDCP-LEVEL, RESOLUTION (height), FRAME-RATE, CODECS, VIDEO-RANGE, and BANDWIDTH
   */
  get levels() {
    const levels = this.levelController.levels;
    return levels ? levels : [];
  }

  /**
   * @returns LevelDetails of last loaded level (variant) or `null` prior to loading a media playlist.
   */
  get latestLevelDetails() {
    return this.streamController.getLevelDetails() || null;
  }

  /**
   * @returns Level object of selected level (variant) or `null` prior to selecting a level or once the level is removed.
   */
  get loadLevelObj() {
    return this.levelController.loadLevelObj;
  }

  /**
   * Index of quality level (variant) currently played
   */
  get currentLevel() {
    return this.streamController.currentLevel;
  }

  /**
   * Set quality level index immediately. This will flush the current buffer to replace the quality asap. That means playback will interrupt at least shortly to re-buffer and re-sync eventually. Set to -1 for automatic level selection.
   */
  set currentLevel(newLevel) {
    this.logger.log(`set currentLevel:${newLevel}`);
    this.levelController.manualLevel = newLevel;
    this.streamController.immediateLevelSwitch();
  }

  /**
   * Index of next quality level loaded as scheduled by stream controller.
   */
  get nextLevel() {
    return this.streamController.nextLevel;
  }

  /**
   * Set quality level index for next loaded data.
   * This will switch the video quality asap, without interrupting playback.
   * May abort current loading of data, and flush parts of buffer (outside currently played fragment region).
   * @param newLevel - Pass -1 for automatic level selection
   */
  set nextLevel(newLevel) {
    this.logger.log(`set nextLevel:${newLevel}`);
    this.levelController.manualLevel = newLevel;
    this.streamController.nextLevelSwitch();
  }

  /**
   * Return the quality level of the currently or last (of none is loaded currently) segment
   */
  get loadLevel() {
    return this.levelController.level;
  }

  /**
   * Set quality level index for next loaded data in a conservative way.
   * This will switch the quality without flushing, but interrupt current loading.
   * Thus the moment when the quality switch will appear in effect will only be after the already existing buffer.
   * @param newLevel - Pass -1 for automatic level selection
   */
  set loadLevel(newLevel) {
    this.logger.log(`set loadLevel:${newLevel}`);
    this.levelController.manualLevel = newLevel;
  }

  /**
   * get next quality level loaded
   */
  get nextLoadLevel() {
    return this.levelController.nextLoadLevel;
  }

  /**
   * Set quality level of next loaded segment in a fully "non-destructive" way.
   * Same as `loadLevel` but will wait for next switch (until current loading is done).
   */
  set nextLoadLevel(level) {
    this.levelController.nextLoadLevel = level;
  }

  /**
   * Return "first level": like a default level, if not set,
   * falls back to index of first level referenced in manifest
   */
  get firstLevel() {
    return Math.max(this.levelController.firstLevel, this.minAutoLevel);
  }

  /**
   * Sets "first-level", see getter.
   */
  set firstLevel(newLevel) {
    this.logger.log(`set firstLevel:${newLevel}`);
    this.levelController.firstLevel = newLevel;
  }

  /**
   * Return the desired start level for the first fragment that will be loaded.
   * The default value of -1 indicates automatic start level selection.
   * Setting hls.nextAutoLevel without setting a startLevel will result in
   * the nextAutoLevel value being used for one fragment load.
   */
  get startLevel() {
    const startLevel = this.levelController.startLevel;
    if (startLevel === -1 && this.abrController.forcedAutoLevel > -1) {
      return this.abrController.forcedAutoLevel;
    }
    return startLevel;
  }

  /**
   * set  start level (level of first fragment that will be played back)
   * if not overrided by user, first level appearing in manifest will be used as start level
   * if -1 : automatic start level selection, playback will start from level matching download bandwidth
   * (determined from download of first segment)
   */
  set startLevel(newLevel) {
    this.logger.log(`set startLevel:${newLevel}`);
    // if not in automatic start level detection, ensure startLevel is greater than minAutoLevel
    if (newLevel !== -1) {
      newLevel = Math.max(newLevel, this.minAutoLevel);
    }
    this.levelController.startLevel = newLevel;
  }

  /**
   * Whether level capping is enabled.
   * Default value is set via `config.capLevelToPlayerSize`.
   */
  get capLevelToPlayerSize() {
    return this.config.capLevelToPlayerSize;
  }

  /**
   * Enables or disables level capping. If disabled after previously enabled, `nextLevelSwitch` will be immediately called.
   */
  set capLevelToPlayerSize(shouldStartCapping) {
    const newCapLevelToPlayerSize = !!shouldStartCapping;
    if (newCapLevelToPlayerSize !== this.config.capLevelToPlayerSize) {
      if (newCapLevelToPlayerSize) {
        this.capLevelController.startCapping(); // If capping occurs, nextLevelSwitch will happen based on size.
      } else {
        this.capLevelController.stopCapping();
        this.autoLevelCapping = -1;
        this.streamController.nextLevelSwitch(); // Now we're uncapped, get the next level asap.
      }
      this.config.capLevelToPlayerSize = newCapLevelToPlayerSize;
    }
  }

  /**
   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
   */
  get autoLevelCapping() {
    return this._autoLevelCapping;
  }

  /**
   * Returns the current bandwidth estimate in bits per second, when available. Otherwise, `NaN` is returned.
   */
  get bandwidthEstimate() {
    const {
      bwEstimator
    } = this.abrController;
    if (!bwEstimator) {
      return NaN;
    }
    return bwEstimator.getEstimate();
  }
  set bandwidthEstimate(abrEwmaDefaultEstimate) {
    this.abrController.resetEstimator(abrEwmaDefaultEstimate);
  }
  get abrEwmaDefaultEstimate() {
    const {
      bwEstimator
    } = this.abrController;
    if (!bwEstimator) {
      return NaN;
    }
    return bwEstimator.defaultEstimate;
  }

  /**
   * get time to first byte estimate
   * @type {number}
   */
  get ttfbEstimate() {
    const {
      bwEstimator
    } = this.abrController;
    if (!bwEstimator) {
      return NaN;
    }
    return bwEstimator.getEstimateTTFB();
  }

  /**
   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
   */
  set autoLevelCapping(newLevel) {
    if (this._autoLevelCapping !== newLevel) {
      this.logger.log(`set autoLevelCapping:${newLevel}`);
      this._autoLevelCapping = newLevel;
      this.levelController.checkMaxAutoUpdated();
    }
  }
  get maxHdcpLevel() {
    return this._maxHdcpLevel;
  }
  set maxHdcpLevel(value) {
    if (isHdcpLevel(value) && this._maxHdcpLevel !== value) {
      this._maxHdcpLevel = value;
      this.levelController.checkMaxAutoUpdated();
    }
  }

  /**
   * True when automatic level selection enabled
   */
  get autoLevelEnabled() {
    return this.levelController.manualLevel === -1;
  }

  /**
   * Level set manually (if any)
   */
  get manualLevel() {
    return this.levelController.manualLevel;
  }

  /**
   * min level selectable in auto mode according to config.minAutoBitrate
   */
  get minAutoLevel() {
    const {
      levels,
      config: {
        minAutoBitrate
      }
    } = this;
    if (!levels) return 0;
    const len = levels.length;
    for (let i = 0; i < len; i++) {
      if (levels[i].maxBitrate >= minAutoBitrate) {
        return i;
      }
    }
    return 0;
  }

  /**
   * max level selectable in auto mode according to autoLevelCapping
   */
  get maxAutoLevel() {
    const {
      levels,
      autoLevelCapping,
      maxHdcpLevel
    } = this;
    let maxAutoLevel;
    if (autoLevelCapping === -1 && levels != null && levels.length) {
      maxAutoLevel = levels.length - 1;
    } else {
      maxAutoLevel = autoLevelCapping;
    }
    if (maxHdcpLevel) {
      for (let i = maxAutoLevel; i--;) {
        const hdcpLevel = levels[i].attrs['HDCP-LEVEL'];
        if (hdcpLevel && hdcpLevel <= maxHdcpLevel) {
          return i;
        }
      }
    }
    return maxAutoLevel;
  }
  get firstAutoLevel() {
    return this.abrController.firstAutoLevel;
  }

  /**
   * next automatically selected quality level
   */
  get nextAutoLevel() {
    return this.abrController.nextAutoLevel;
  }

  /**
   * this setter is used to force next auto level.
   * this is useful to force a switch down in auto mode:
   * in case of load error on level N, hls.js can set nextAutoLevel to N-1 for example)
   * forced value is valid for one fragment. upon successful frag loading at forced level,
   * this value will be resetted to -1 by ABR controller.
   */
  set nextAutoLevel(nextLevel) {
    this.abrController.nextAutoLevel = nextLevel;
  }

  /**
   * get the datetime value relative to media.currentTime for the active level Program Date Time if present
   */
  get playingDate() {
    return this.streamController.currentProgramDateTime;
  }
  get mainForwardBufferInfo() {
    return this.streamController.getMainFwdBufferInfo();
  }
  get maxBufferLength() {
    return this.streamController.maxBufferLength;
  }

  /**
   * Find and select the best matching audio track, making a level switch when a Group change is necessary.
   * Updates `hls.config.audioPreference`. Returns the selected track, or null when no matching track is found.
   */
  setAudioOption(audioOption) {
    var _this$audioTrackContr;
    return ((_this$audioTrackContr = this.audioTrackController) == null ? void 0 : _this$audioTrackContr.setAudioOption(audioOption)) || null;
  }
  /**
   * Find and select the best matching subtitle track, making a level switch when a Group change is necessary.
   * Updates `hls.config.subtitlePreference`. Returns the selected track, or null when no matching track is found.
   */
  setSubtitleOption(subtitleOption) {
    var _this$subtitleTrackCo;
    return ((_this$subtitleTrackCo = this.subtitleTrackController) == null ? void 0 : _this$subtitleTrackCo.setSubtitleOption(subtitleOption)) || null;
  }

  /**
   * Get the complete list of audio tracks across all media groups
   */
  get allAudioTracks() {
    const audioTrackController = this.audioTrackController;
    return audioTrackController ? audioTrackController.allAudioTracks : [];
  }

  /**
   * Get the list of selectable audio tracks
   */
  get audioTracks() {
    const audioTrackController = this.audioTrackController;
    return audioTrackController ? audioTrackController.audioTracks : [];
  }

  /**
   * index of the selected audio track (index in audio track lists)
   */
  get audioTrack() {
    const audioTrackController = this.audioTrackController;
    return audioTrackController ? audioTrackController.audioTrack : -1;
  }

  /**
   * selects an audio track, based on its index in audio track lists
   */
  set audioTrack(audioTrackId) {
    const audioTrackController = this.audioTrackController;
    if (audioTrackController) {
      audioTrackController.audioTrack = audioTrackId;
    }
  }

  /**
   * get the complete list of subtitle tracks across all media groups
   */
  get allSubtitleTracks() {
    const subtitleTrackController = this.subtitleTrackController;
    return subtitleTrackController ? subtitleTrackController.allSubtitleTracks : [];
  }

  /**
   * get alternate subtitle tracks list from playlist
   */
  get subtitleTracks() {
    const subtitleTrackController = this.subtitleTrackController;
    return subtitleTrackController ? subtitleTrackController.subtitleTracks : [];
  }

  /**
   * index of the selected subtitle track (index in subtitle track lists)
   */
  get subtitleTrack() {
    const subtitleTrackController = this.subtitleTrackController;
    return subtitleTrackController ? subtitleTrackController.subtitleTrack : -1;
  }
  get media() {
    return this._media;
  }

  /**
   * select an subtitle track, based on its index in subtitle track lists
   */
  set subtitleTrack(subtitleTrackId) {
    const subtitleTrackController = this.subtitleTrackController;
    if (subtitleTrackController) {
      subtitleTrackController.subtitleTrack = subtitleTrackId;
    }
  }

  /**
   * Whether subtitle display is enabled or not
   */
  get subtitleDisplay() {
    const subtitleTrackController = this.subtitleTrackController;
    return subtitleTrackController ? subtitleTrackController.subtitleDisplay : false;
  }

  /**
   * Enable/disable subtitle display rendering
   */
  set subtitleDisplay(value) {
    const subtitleTrackController = this.subtitleTrackController;
    if (subtitleTrackController) {
      subtitleTrackController.subtitleDisplay = value;
    }
  }

  /**
   * get mode for Low-Latency HLS loading
   */
  get lowLatencyMode() {
    return this.config.lowLatencyMode;
  }

  /**
   * Enable/disable Low-Latency HLS part playlist and segment loading, and start live streams at playlist PART-HOLD-BACK rather than HOLD-BACK.
   */
  set lowLatencyMode(mode) {
    this.config.lowLatencyMode = mode;
  }

  /**
   * Position (in seconds) of live sync point (ie edge of live position minus safety delay defined by ```hls.config.liveSyncDuration```)
   * @returns null prior to loading live Playlist
   */
  get liveSyncPosition() {
    return this.latencyController.liveSyncPosition;
  }

  /**
   * Estimated position (in seconds) of live edge (ie edge of live playlist plus time sync playlist advanced)
   * @returns 0 before first playlist is loaded
   */
  get latency() {
    return this.latencyController.latency;
  }

  /**
   * maximum distance from the edge before the player seeks forward to ```hls.liveSyncPosition```
   * configured using ```liveMaxLatencyDurationCount``` (multiple of target duration) or ```liveMaxLatencyDuration```
   * @returns 0 before first playlist is loaded
   */
  get maxLatency() {
    return this.latencyController.maxLatency;
  }

  /**
   * target distance from the edge as calculated by the latency controller
   */
  get targetLatency() {
    return this.latencyController.targetLatency;
  }
  set targetLatency(latency) {
    this.latencyController.targetLatency = latency;
  }

  /**
   * the rate at which the edge of the current live playlist is advancing or 1 if there is none
   */
  get drift() {
    return this.latencyController.drift;
  }

  /**
   * set to true when startLoad is called before MANIFEST_PARSED event
   */
  get forceStartLoad() {
    return this.streamController.forceStartLoad;
  }

  /**
   * ContentSteering pathways getter
   */
  get pathways() {
    return this.levelController.pathways;
  }

  /**
   * ContentSteering pathwayPriority getter/setter
   */
  get pathwayPriority() {
    return this.levelController.pathwayPriority;
  }
  set pathwayPriority(pathwayPriority) {
    this.levelController.pathwayPriority = pathwayPriority;
  }

  /**
   * returns true when all SourceBuffers are buffered to the end
   */
  get bufferedToEnd() {
    var _this$bufferControlle;
    return !!((_this$bufferControlle = this.bufferController) != null && _this$bufferControlle.bufferedToEnd);
  }

  /**
   * returns Interstitials Program Manager
   */
  get interstitialsManager() {
    var _this$interstitialsCo;
    return ((_this$interstitialsCo = this.interstitialsController) == null ? void 0 : _this$interstitialsCo.interstitialsManager) || null;
  }

  /**
   * returns mediaCapabilities.decodingInfo for a variant/rendition
   */
  getMediaDecodingInfo(level, audioTracks = this.allAudioTracks) {
    const audioTracksByGroup = getAudioTracksByGroup(audioTracks);
    return getMediaDecodingInfoPromise(level, audioTracksByGroup, navigator.mediaCapabilities);
  }
}
Hls.defaultConfig = void 0;


//# sourceMappingURL=hls.mjs.map

;// CONCATENATED MODULE: ./packages/bedrock-rdk/media-engine/src/engines/hls/hls.engine.js











function hls_engine_createSuper(t) { var r = hls_engine_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function hls_engine_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (hls_engine_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }



var HLSEngine = function (_Engine) {
  (0,inherits/* default */.Z)(HLSEngine, _Engine);
  var _super = hls_engine_createSuper(HLSEngine);
  function HLSEngine() {
    (0,classCallCheck/* default */.Z)(this, HLSEngine);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(HLSEngine, [{
    key: "configure",
    value: function configure(options) {
      this.options = options;
    }
  }, {
    key: "init",
    value: function init(element) {
      this.videoElement = element;
      this._player = new Hls({
        enableID3MetadataCues: true,
        enableEmsgMetadataCues: true,
        enableDateRangeMetadataCues: true
      });
    }
  }, {
    key: "setSource",
    value: function setSource(source) {
      this.start(source);
    }
  }, {
    key: "start",
    value: function start(source) {
      this._playbackAvailable = false;
      this.source = source;
      if (!source) {
        this.pause();
        return;
      }
      this.startTime = this.source.startTime || 0;
      var timeParameter = this.startTime ? "#t=".concat(this.startTime) : '';
      if (this.videoElement) {
        this._player.loadSource("".concat(this.source.reference || this.source.src).concat(timeParameter));
        this._player.attachMedia(this.videoElement);
      }
    }
  }, {
    key: "play",
    value: function play() {
      console.log('[HLSEngine] Playback requested');
      if (this.videoElement) {
        this.videoElement.play();
      }
    }
  }, {
    key: "pause",
    value: function pause() {
      console.log('[HLSEngine] Pause requested');
      if (this.videoElement) {
        this.videoElement.pause();
      }
    }
  }, {
    key: "seek",
    value: function seek() {}
  }, {
    key: "setEventListeners",
    value: function setEventListeners() {
      var _this = this;
      this.removeEventListeners();
      this._handlers = {
        video: {
          canplay: this.onVideoElementCanPlay.bind(this),
          play: this.onVideoElementPlay.bind(this),
          pause: this.onVideoElementPause.bind(this),
          ended: this.onVideoElementEnded.bind(this),
          error: this.onVideoElementError.bind(this),
          loadstart: this.onVideoElementLoadstart.bind(this),
          timeupdate: this.onVideoElementTimeupdate.bind(this)
        },
        player: (0,defineProperty/* default */.Z)({}, Hls.Events.FRAG_BUFFERED, this.onFragmentBuffered.bind(this))
      };
      if (this.videoElement) {
        Object.keys(this._handlers.video).forEach(function (key) {
          _this.videoElement.addEventListener(key, _this._handlers.video[key]);
        });
      }
      if (this._player) {
        Object.keys(this._handlers.player).forEach(function (key) {
          _this._player.on(key, _this._handlers.player[key]);
        });
      }
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      var _this2 = this;
      if (!this._handlers) {
        return;
      }
      if (this.videoElement) {
        Object.keys(this._handlers.video).forEach(function (key) {
          _this2.videoElement.removeEventListener(key, _this2._handlers.video[key]);
        });
      }
      if (this._player) {
        Object.keys(this._handlers.player).forEach(function (key) {
          _this2._player.off(key, _this2._handlers.player[key]);
        });
      }
      this._handlers = null;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.videoElement ? this.videoElement.currentTime : 0;
    }
  }, {
    key: "setVolume",
    value: function setVolume(volume) {
      if (this.videoElement) {
        this.videoElement.volume = volume;
      }
    }
  }, {
    key: "onVideoElementCanPlay",
    value: function onVideoElementCanPlay() {
      console.log("[HLSEngine] Can play, firing event: ".concat(!this._playbackAvailable));
      if (!this.videoElement || !this.options) {
        return;
      }
      if (!this._playbackAvailable) {
        this._playbackAvailable = true;
        this.options.dispatcher(CAN_PLAY);
      }
      this.options.dispatcher(PLAYING);
    }
  }, {
    key: "onVideoElementPlay",
    value: function onVideoElementPlay() {
      console.log('[HLSEngine] Playing');
      if (this.videoElement && this._player) {
        this.videoElement.currentTime = this._player.liveSyncPosition;
      }
      if (!this.options) {
        return;
      }
      this.options.dispatcher(video_events_PLAY);
      this.options.dispatcher(PLAYING);
    }
  }, {
    key: "onVideoElementPause",
    value: function onVideoElementPause() {
      if (!this.options) {
        return;
      }
      this.options.dispatcher(PAUSE);
    }
  }, {
    key: "onVideoElementBuffering",
    value: function onVideoElementBuffering(event) {
      if (!this.options) {
        return;
      }
      this.options.dispatcher(WAITING, event);
    }
  }, {
    key: "onVideoElementEnded",
    value: function onVideoElementEnded() {
      if (!this.options) {
        return;
      }
      this.options.dispatcher(ENDED);
    }
  }, {
    key: "onVideoElementError",
    value: function onVideoElementError(event) {
      console.log('[HLSEngine] Error:', this.videoElement.error);
      console.log('[HLSEngine] Source:', this.source);
      if (!this.options) {
        return;
      }
      this.options.dispatcher(ERROR, event.target);
    }
  }, {
    key: "onVideoElementSeeking",
    value: function onVideoElementSeeking() {
      if (!this.options) {
        return;
      }
      this.options.dispatcher(SEEKING, {
        from: this._seekFrom,
        to: this._seekTo
      });
    }
  }, {
    key: "onVideoElementLoadstart",
    value: function onVideoElementLoadstart(event) {
      console.log('[HLSEngine] Started loading');
      if (!this.options) {
        return;
      }
      this.options.dispatcher(LOAD_START, event);
    }
  }, {
    key: "onVideoElementTimeupdate",
    value: function onVideoElementTimeupdate(event) {
      if (!this.options) {
        return;
      }
      this.options.dispatcher(TIME_UPDATE, {
        currentTime: event.target.currentTime
      });
    }
  }, {
    key: "onFragmentBuffered",
    value: function onFragmentBuffered(_, content) {
      if (!content || !content.frag) {
        return;
      }
      if (!this._playbackAvailable) {
        this.onVideoElementCanPlay();
      }
      this.options.dispatcher(LOADED_METADATA, {
        extraTitle: content.frag.title || ''
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      console.log('[HLSEngine] Resetting');
      if (this.videoElement) {
        var video = this.videoElement;
        try {
          console.log('[HLSEngine] Pausing video element');
          video.pause();
          console.log('[HLSEngine] Removing player source');
          video.removeAttribute('src');
          video.load();
          video.src = '';
          video.srcObject = null;
        } catch (error) {
          console.error('[HLSEngine] Can not cleanup video element source');
        }
      }
      return Promise.resolve();
    }
  }, {
    key: "release",
    value: function release() {
      console.log('[HLSEngine] Destroying');
      this.removeEventListeners();
      this.reset();
      if (this._player) {
        this._player.destroy();
      }
      if (this.videoElement) {
        try {
          this.videoElement.remove();
        } catch (error) {
          console.error('[HLSEngine] Can not remove video element');
        }
      }
      this.videoElement = null;
      this.source = null;
      this.options = null;
      this._player = null;
    }
  }]);
  return HLSEngine;
}(engine);
;// CONCATENATED MODULE: ./src/modules/audio/player.adapter.js






function player_adapter_createSuper(t) { var r = player_adapter_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function player_adapter_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (player_adapter_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }



var player_adapter_AudioPlayer = function (_HTML5Engine) {
  (0,inherits/* default */.Z)(AudioPlayer, _HTML5Engine);
  var _super = player_adapter_createSuper(AudioPlayer);
  function AudioPlayer() {
    (0,classCallCheck/* default */.Z)(this, AudioPlayer);
    return _super.apply(this, arguments);
  }
  return (0,createClass/* default */.Z)(AudioPlayer);
}(HTML5Engine);
var audioPlayer;
var currentPlayerId = null;
var getAudioPlayerInstance = function getAudioPlayerInstance() {
  return audioPlayer;
};
var destroyAudioPlayer = function destroyAudioPlayer() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'audio-player';
  var player = getAudioPlayerInstance();
  if (player) {
    player.release();
  }
  if (id) {
    var node = document.getElementById(id);
    try {
      if (node) {
        node.remove();
      }
    } finally {
      currentPlayerId = null;
    }
  }
  return true;
};
var initAudioPlayer = function initAudioPlayer() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'audio-player';
  if (document.getElementById(id)) {
    return;
  }
  destroyAudioPlayer(currentPlayerId);
  currentPlayerId = id;
  audioPlayer = id.startsWith('audio') ? new player_adapter_AudioPlayer() : new HLSEngine();
  var element = document.createElement('audio');
  element.setAttribute('id', id);
  element.setAttribute('autoplay', true);
  document.body.appendChild(element);
  audioPlayer.configure({
    dispatcher: playerDispatcher
  });
  audioPlayer.init(element);
  audioPlayer.setEventListeners();
};
;// CONCATENATED MODULE: ./src/modules/audio/audio.connector.js



var audio_connector_mapControllers = function mapControllers(instance) {
  return [{
    selector: getPlaybackState,
    shouldBeInvokedOnConnect: true,
    callback: function callback(value) {
      instance.playbackState = value;
    }
  }, {
    selector: getCurrentLayout,
    shouldBeInvokedOnConnect: true,
    callback: function callback() {
      instance.start();
    }
  }, {
    selector: getCanPlay,
    shouldBeInvokedOnConnect: true,
    callback: function callback(value) {
      instance.canPlay = value;
    }
  }, {
    selector: getCurrentMetadataItem,
    shouldBeInvokedOnConnect: true,
    callback: function callback(value) {
      instance.metadata = value;
    }
  }, {
    selector: getSideGlassContent,
    shouldBeInvokedOnConnect: true,
    callback: function callback(value) {
      instance.hasRelatedEpisodes = Boolean(value);
    }
  }];
};
/* harmony default export */ const audio_connector = (lightningjs_redux.control(audio_connector_mapControllers));
;// CONCATENATED MODULE: ./src/modules/audio/audio.style.js

var _COVER_SIZE, audio_style_SPINNER_SIZE, _IMAGE_MARGIN, audio_style_TEXT_MARGIN;
function audio_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function audio_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? audio_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : audio_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






var audio_style_defaultContext = makeDefaultStylingContext();
var COVER_SIZE = (_COVER_SIZE = {}, (0,defineProperty/* default */.Z)(_COVER_SIZE, HD, 256), (0,defineProperty/* default */.Z)(_COVER_SIZE, FULL_HD, 440), _COVER_SIZE);
var audio_audio_style_SPINNER_SIZE = (audio_style_SPINNER_SIZE = {}, (0,defineProperty/* default */.Z)(audio_style_SPINNER_SIZE, HD, 200), (0,defineProperty/* default */.Z)(audio_style_SPINNER_SIZE, FULL_HD, 200), audio_style_SPINNER_SIZE);
var audio_style_colors = {
  text: makeThemeColor(PRIMARY),
  shadow: makeThemeColor(TERTIARY),
  background: makeThemeColor(TERTIARY)
};
var TEXT_SHADOW_OFFSET_X = 0;
var TEXT_SHADOW_OFFSET_Y = 2;
var IMAGE_MARGIN = (_IMAGE_MARGIN = {}, (0,defineProperty/* default */.Z)(_IMAGE_MARGIN, HD, 16), (0,defineProperty/* default */.Z)(_IMAGE_MARGIN, FULL_HD, 24), _IMAGE_MARGIN);
var audio_audio_style_TEXT_MARGIN = (audio_style_TEXT_MARGIN = {}, (0,defineProperty/* default */.Z)(audio_style_TEXT_MARGIN, HD, 4), (0,defineProperty/* default */.Z)(audio_style_TEXT_MARGIN, FULL_HD, 4), audio_style_TEXT_MARGIN);
var IMAGE_INITIAL_ALPHA = 0.0001;
var audio_style_getTitleFont = function getTitleFont(screenSize) {
  return src_getFont(constants_FONT.PARIS_3, screenSize);
};
var getExtraTitleFont = function getExtraTitleFont(screenSize) {
  return src_getFont(constants_FONT.KINSHASA_1, screenSize);
};
var audio_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : audio_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  var w = SCREEN_WIDTH[screenSize];
  var h = sizes_SCREEN_HEIGHT[screenSize];
  var coverSize = COVER_SIZE[screenSize];
  var middleX = Math.round(w / 2);
  var middleY = Math.round(h / 2);
  var coverMiddle = Math.round(coverSize / 2);
  var commonTextConfig = {
    textColor: audio_style_colors.text[colorMode],
    shadow: true,
    shadowColor: audio_style_colors.shadow[colorMode],
    shadowOffsetX: TEXT_SHADOW_OFFSET_X,
    shadowOffsetY: TEXT_SHADOW_OFFSET_Y,
    textAlign: 'center',
    maxLines: 1,
    maxLinesSuffix: '...',
    verticalAlign: 'middle'
  };
  return {
    w: w,
    h: h,
    Background: {
      w: w,
      h: h,
      colorTop: audio_style_colors.background[colorMode],
      colorBottom: audio_style_colors.background[colorMode]
    },
    Content: {
      w: coverSize,
      h: coverSize,
      x: middleX,
      y: middleY,
      mount: 0.5,
      Cover: {
        alpha: IMAGE_INITIAL_ALPHA,
        w: coverSize,
        h: coverSize,
        Shadow: {
          amount: 3,
          mount: 0.5,
          w: coverSize * 2,
          h: coverSize * 2,
          x: coverMiddle,
          y: coverMiddle,
          content: {
            rect: true,
            color: 0x2f000000,
            x: coverMiddle,
            y: coverMiddle + 16,
            w: coverSize + 8,
            h: coverSize + 8,
            shader: {
              type: src_Lightning.shaders.RoundedRectangle,
              radius: 8
            }
          }
        },
        Image: {
          w: coverSize,
          h: coverSize,
          shader: {
            radius: 8
          }
        }
      },
      Title: {
        mountX: 0.5,
        x: middle,
        w: w - safetyMargins.horizontal[screenSize] * 2,
        font: audio_style_objectSpread(audio_style_objectSpread({}, audio_style_getTitleFont(screenSize)), commonTextConfig)
      },
      ExtraTitle: {
        mountX: 0.5,
        x: middle,
        w: w - safetyMargins.horizontal[screenSize] * 2,
        font: audio_style_objectSpread(audio_style_objectSpread({}, getExtraTitleFont(screenSize)), commonTextConfig)
      }
    },
    Controls: {},
    Spinner: {
      alpha: 0,
      mount: 0.5,
      w: audio_audio_style_SPINNER_SIZE[screenSize],
      h: audio_audio_style_SPINNER_SIZE[screenSize],
      x: middle,
      y: middle
    }
  };
};
var getControlsVisibleStyle = function getControlsVisibleStyle(screenSize) {
  return {
    Content: {
      smooth: {
        y: Math.round(sizes_SCREEN_HEIGHT[screenSize] / 2)
      },
      Title: {
        smooth: {
          alpha: 1
        }
      },
      ExtraTitle: {
        smooth: {
          alpha: 1
        }
      }
    }
  };
};
var getControlsHiddenStyle = function getControlsHiddenStyle(screenSize, coverOffset) {
  return {
    Content: {
      smooth: {
        y: Math.round(sizes_SCREEN_HEIGHT[screenSize] / 2) + (coverOffset || 0)
      },
      Title: {
        smooth: {
          alpha: 0
        }
      },
      ExtraTitle: {
        smooth: {
          alpha: 0
        }
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/audio/audio.constants.js
var audio_constants_TOP_BAR_ITEMS = {
  BACK: 'BACK',
  EPISODES: 'EPISODES'
};
;// CONCATENATED MODULE: ./src/modules/audio/audio.utils.js















var audio_utils_toHex = function toHex(red, green, blue) {
  return blue | green << 8 | red << 16;
};
var audio_utils_format = function format(input, args) {
  var list = input.map(function (colors) {
    var _colors$split$map = colors.split(',').map(Number),
      _colors$split$map2 = (0,slicedToArray/* default */.Z)(_colors$split$map, 3),
      r = _colors$split$map2[0],
      g = _colors$split$map2[1],
      b = _colors$split$map2[2];
    return 0xff000000 + audio_utils_toHex(r, g, b);
  });
  return args.amount === 1 || list.length === 1 ? list[0] : list;
};
var group = function group(number, grouping) {
  var grouped = Math.round(number / grouping) * grouping;
  return Math.min(grouped, 255);
};
var extractProminentColors = function extractProminentColors(data, args) {
  var colors = {};
  for (var i = 0; i < data.length; i += 40) {
    var rgb = [group(data[i], args.group), group(data[i + 1], args.group), group(data[i + 2], args.group)].join();
    colors[rgb] = colors[rgb] ? colors[rgb] + 1 : 1;
  }
  return audio_utils_format(Object.entries(colors).sort(function (_ref, _ref2) {
    var _ref3 = (0,slicedToArray/* default */.Z)(_ref, 2),
      a = _ref3[1];
    var _ref4 = (0,slicedToArray/* default */.Z)(_ref2, 2),
      b = _ref4[1];
    return a > b ? -1 : 1;
  }).slice(0, args.amount).map(function (_ref5) {
    var _ref6 = (0,slicedToArray/* default */.Z)(_ref5, 1),
      rgb = _ref6[0];
    return rgb;
  }), args);
};
var getColors = function getColors(stage, url) {
  return new Promise(function (resolve, reject) {
    var canvas = stage.platform.getDrawingCanvas();
    var context = canvas.getContext('2d');
    context.imageSmoothingEnabled = true;
    var image = new Image();
    image.onload = function () {
      var imageWidth = image.width;
      var imageHeight = image.height;
      canvas.width = Math.round(imageWidth);
      canvas.height = Math.round(imageHeight);
      context.drawImage(image, 0, 0, canvas.width, canvas.height);
      var _context$getImageData = context.getImageData(0, 0, canvas.width, canvas.height),
        data = _context$getImageData.data;
      resolve(extractProminentColors(data, {
        amount: 2,
        group: 15
      }));
    };
    image.onError = function (error) {
      reject(error);
    };
    image.crossOrigin = 'Anonymous';
    image.src = url;
  });
};
var audio_utils_defaultTopBarItems = [{
  id: audio_constants_TOP_BAR_ITEMS.BACK,
  icon: 'ArrowLeftWithBase',
  text: t('nav.backToNav'),
  action: TOP_BAR_BACK
}, {
  id: audio_constants_TOP_BAR_ITEMS.EPISODES,
  icon: 'Chapter',
  text: t('nav.episodes'),
  action: TOP_BAR_RELATED_VIDEOS
}];
var audio_utils_getTopBarItems = function getTopBarItems() {
  var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    hasRelatedEpisodes = _ref7.hasRelatedEpisodes;
  return audio_utils_defaultTopBarItems.filter(function (_ref8) {
    var id = _ref8.id;
    switch (id) {
      case audio_constants_TOP_BAR_ITEMS.EPISODES:
        return hasRelatedEpisodes;
      default:
        return true;
    }
  });
};
;// CONCATENATED MODULE: ./src/modules/audio/audio.component.js










function audio_component_createSuper(t) { var r = audio_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function audio_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (audio_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }




















var audio_component_AudioPlayer = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(AudioPlayer, _Lightning$Component);
  var _super = audio_component_createSuper(AudioPlayer);
  function AudioPlayer() {
    (0,classCallCheck/* default */.Z)(this, AudioPlayer);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(AudioPlayer, [{
    key: "_build",
    value: function _build() {
      this._style = audio_style_defaultContext;
      this._coverOffset = 0;
      this._autoHideTimeout = null;
    }
  }, {
    key: "_onUrlParams",
    value: function _onUrlParams(_ref) {
      var audioId = _ref.audioId;
      this._entityType = window.location.hash.replace('#', '').split('/').shift();
      this._entityId = audioId;
      initAudioPlayer("".concat(this._entityType, "-player"));
      this._isResumed = this._clipId === this._entityId;
      this.tag('Controls').progressBarVariant = this._entityType === layout_constants/* entities */.jF.radio ? TIME_HIDDEN : TIME_BELOW;
      if (this._isResumed) {
        this.tag('Controls').showControls();
        this.tag('Spinner').alpha = 0;
        getAudioPlayerInstance().play();
        lightningjs_redux.dispatch(clearCache(this._entityType, this._clipId, 'main'));
      } else {
        this.tag('Cover').alpha = IMAGE_INITIAL_ALPHA;
        this.tag('Spinner').setSmooth('alpha', 1);
        this._onControlsHidden();
        this.metadata = null;
        lightningjs_redux.dispatch(player_constants_reset());
        lightningjs_redux.dispatch(fetchLayout(this._entityType, audioId));
      }
    }
  }, {
    key: "_attach",
    value: function _attach() {
      this._unsubscribe = audio_connector(this);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      if (this._unsubscribe) {
        this._unsubscribe();
        this._unsubscribe = null;
      }
      this._playbackState = undefined;
      this._hasRelatedEpisodes = false;
      this.tag('Image').removeAllListeners('txLoaded');
    }
  }, {
    key: "canPlay",
    set: function set(value) {
      if (value) {
        this.tag('Controls').showControls();
        this.tag('Spinner').setSmooth('alpha', 0);
      }
    }
  }, {
    key: "playbackState",
    set: function set(value) {
      switch (value) {
        case PLAYBACK_STATE_PLAYING:
          this._setState('Playing');
          break;
        case PLAYBACK_STATE_PAUSED:
          this._setState('Paused');
          break;
        case PLAYBACK_STATE_ENDED:
          if (this._playbackState === PLAYBACK_STATE_PLAYING || this._playbackState === PLAYBACK_STATE_PAUSED) {
            Router.back();
          }
          break;
        default:
          break;
      }
      this._playbackState = value;
    }
  }, {
    key: "metadata",
    set: function set(value) {
      var _this = this;
      this._clipId = get_default()(value, 'video.id');
      var title = get_default()(value, 'title') || '';
      var extraTitle = get_default()(value, 'extraTitle') || '';
      var image = get_default()(value, 'image.idsByRatio.1:1') || get_default()(value, 'image.id') || '';
      var _this$_style = this._style,
        screenSize = _this$_style.screenSize,
        colorMode = _this$_style.colorMode;
      var coverSize = COVER_SIZE[screenSize];
      var imageSource = imageService.getUrl(image, coverSize, coverSize, {
        fit: IMAGE_FIT_SCALE_CROP,
        quality: IMAGE_QUALITY,
        format: DEFAULT_IMAGE_FORMAT
      });
      var patch = {
        Content: {
          Cover: {
            Image: {
              src: imageSource
            }
          },
          Title: {
            caption: title
          },
          ExtraTitle: {
            caption: extraTitle
          }
        }
      };
      var offset = COVER_SIZE[screenSize] + IMAGE_MARGIN[screenSize];
      if (title) {
        patch.Content.Title.y = offset;
        offset += audio_style_getTitleFont(screenSize).lineHeight;
      }
      if (extraTitle) {
        offset += audio_audio_style_TEXT_MARGIN[screenSize];
        patch.Content.ExtraTitle.y = offset;
        offset += getExtraTitleFont(screenSize).lineHeight;
      }
      this._coverOffset = (offset - COVER_SIZE[screenSize]) / 2;
      patch.Content.h = offset;
      this.tag('Image').removeAllListeners('txLoaded');
      this.tag('Image').once('txLoaded', function () {
        _this.tag('Cover').setSmooth('alpha', 1);
        getColors(_this.stage, imageSource).catch(function () {
          return [audio_style_colors.background[colorMode], audio_style_colors.background[colorMode]];
        }).then(function (_ref2) {
          var _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 2),
            bottom = _ref3[0],
            top = _ref3[1];
          _this.tag('Background').patch({
            smooth: {
              colorTop: top,
              colorBottom: bottom
            }
          });
        });
      });
      this.patch(patch);
    }
  }, {
    key: "hasRelatedEpisodes",
    set: function set(value) {
      this._hasRelatedEpisodes = value;
      this.tag('Controls').topBarItems = audio_utils_getTopBarItems({
        hasRelatedEpisodes: this._hasRelatedEpisodes
      });
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this.tag('Controls');
    }
  }, {
    key: "_handleTopBarItemSelection",
    value: function _handleTopBarItemSelection(item) {
      var id = item && item.id || '';
      if (id === audio_constants_TOP_BAR_ITEMS.BACK) {
        Router.back();
      } else if (id === audio_constants_TOP_BAR_ITEMS.EPISODES) {
        this.tag('Controls').showSideGlass();
      }
    }
  }, {
    key: "_handleItemAction",
    value: function _handleItemAction(item) {
      dispatchItemAction(item);
    }
  }, {
    key: "_onControlsShown",
    value: function _onControlsShown() {
      this.patch(getControlsVisibleStyle(this._style.screenSize));
    }
  }, {
    key: "_onControlsHidden",
    value: function _onControlsHidden() {
      this.patch(getControlsHiddenStyle(this._style.screenSize, this._coverOffset));
    }
  }, {
    key: "_handleSeek",
    value: function _handleSeek(position) {
      getAudioPlayerInstance().seek(position);
    }
  }, {
    key: "start",
    value: function start() {
      lightningjs_redux.dispatch(fetchPlayerLayout());
    }
  }], [{
    key: "_template",
    value: function _template() {
      var _signals;
      return merge_default()({
        Background: {
          rect: true
        },
        Content: {
          Cover: {
            Shadow: {
              type: src_Lightning.components.FastBlurComponent
            },
            Image: {
              shader: {
                type: src_Lightning.shaders.RoundedRectangle
              }
            }
          },
          Title: {
            type: Autoscroll
          },
          ExtraTitle: {
            type: Autoscroll
          }
        },
        Controls: {
          type: Controls,
          displayOverlayBackdrop: false,
          displayOverlayTop: false,
          displayMetadata: false,
          progressBarVariant: TIME_BELOW,
          signals: (_signals = {}, (0,defineProperty/* default */.Z)(_signals, SEEK_SIGNAL, '_handleSeek'), (0,defineProperty/* default */.Z)(_signals, TOP_BAR_ITEM_SELECTED_SIGNAL, '_handleTopBarItemSelection'), (0,defineProperty/* default */.Z)(_signals, SIDE_GLASS_ITEM_SELECTED_SIGNAL, '_handleItemAction'), (0,defineProperty/* default */.Z)(_signals, CONTROLS_SHOW_SIGNAL, '_onControlsShown'), (0,defineProperty/* default */.Z)(_signals, CONTROLS_HIDE_SIGNAL, '_onControlsHidden'), _signals),
          topBarItems: audio_utils_getTopBarItems()
        },
        Spinner: {
          type: spinner_component
        }
      }, audio_style_getInitialStyle());
    }
  }, {
    key: "_states",
    value: function _states() {
      return [function (_this2) {
        (0,inherits/* default */.Z)(Playing, _this2);
        var _super2 = audio_component_createSuper(Playing);
        function Playing() {
          (0,classCallCheck/* default */.Z)(this, Playing);
          return _super2.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(Playing, [{
          key: "_handlePauseControl",
          value: function _handlePauseControl() {
            getAudioPlayerInstance().pause();
            this.tag('Controls').show(PAUSED_STATE);
          }
        }, {
          key: "_handlePlayPause",
          value: function _handlePlayPause() {
            this._handlePauseControl();
            return true;
          }
        }, {
          key: "_handleEnter",
          value: function _handleEnter() {
            this._handlePauseControl();
            return true;
          }
        }]);
        return Playing;
      }(this), function (_this3) {
        (0,inherits/* default */.Z)(Paused, _this3);
        var _super3 = audio_component_createSuper(Paused);
        function Paused() {
          (0,classCallCheck/* default */.Z)(this, Paused);
          return _super3.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(Paused, [{
          key: "$enter",
          value: function $enter(_ref4) {
            var prevState = _ref4.prevState;
            if (prevState) {
              this.tag('Controls').showControls();
            }
          }
        }, {
          key: "_handlePlayControl",
          value: function _handlePlayControl() {
            getAudioPlayerInstance().play();
            this.tag('Controls').show(PLAYING_STATE);
          }
        }, {
          key: "_handlePlayPause",
          value: function _handlePlayPause() {
            this._handlePlayControl();
            return true;
          }
        }, {
          key: "_handleEnter",
          value: function _handleEnter() {
            this._handlePlayControl();
            return true;
          }
        }, {
          key: "_handleBack",
          value: function _handleBack() {
            getAudioPlayerInstance().pause();
            return false;
          }
        }]);
        return Paused;
      }(this)];
    }
  }]);
  return AudioPlayer;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/routes/customer/rtlde/routes.js


var routes_routes = [{
  path: 'audio/:audioId',
  component: audio_component_AudioPlayer,
  widgets: ['CookieConsent', 'SnackBar', 'Popup'],
  options: {
    preventStorage: true,
    reuseInstance: false
  }
}, {
  path: 'radio/:audioId',
  component: audio_component_AudioPlayer,
  widgets: ['CookieConsent', 'SnackBar', 'Popup'],
  options: {
    preventStorage: true,
    reuseInstance: false
  }
}, {
  path: 'ssi',
  component: TermsOfService,
  widgets: ['CookieConsent', 'Popup']
}];
;// CONCATENATED MODULE: ./src/modules/deviceGate/deviceGate.style.js

var deviceGate_style_GAP, deviceGate_style_TEXT_GAP, deviceGate_style_LOGO_HEIGHT;
function deviceGate_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function deviceGate_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? deviceGate_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : deviceGate_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





var deviceGate_style_defaultContext = makeDefaultStylingContext();
var deviceGate_deviceGate_style_GAP = (deviceGate_style_GAP = {}, (0,defineProperty/* default */.Z)(deviceGate_style_GAP, HD, 24), (0,defineProperty/* default */.Z)(deviceGate_style_GAP, FULL_HD, 32), deviceGate_style_GAP);
var deviceGate_deviceGate_style_TEXT_GAP = (deviceGate_style_TEXT_GAP = {}, (0,defineProperty/* default */.Z)(deviceGate_style_TEXT_GAP, HD, 8), (0,defineProperty/* default */.Z)(deviceGate_style_TEXT_GAP, FULL_HD, 16), deviceGate_style_TEXT_GAP);
var deviceGate_deviceGate_style_LOGO_HEIGHT = (deviceGate_style_LOGO_HEIGHT = {}, (0,defineProperty/* default */.Z)(deviceGate_style_LOGO_HEIGHT, HD, 40), (0,defineProperty/* default */.Z)(deviceGate_style_LOGO_HEIGHT, FULL_HD, 56), deviceGate_style_LOGO_HEIGHT);
var deviceGate_style_getWordWrapWidth = function getWordWrapWidth(screenSize) {
  return Math.round(SCREEN_WIDTH[screenSize] * 0.75);
};
var deviceGate_style_colors = {
  text: makeThemeColor(PRIMARY),
  background: makeThemeColor(TERTIARY)
};
var deviceGate_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : deviceGate_style_defaultContext,
    screenSize = _ref.screenSize,
    colorMode = _ref.colorMode;
  var w = SCREEN_WIDTH[screenSize];
  var h = sizes_SCREEN_HEIGHT[screenSize];
  var textColor = deviceGate_style_colors.text[colorMode];
  var wordWrapWidth = deviceGate_style_getWordWrapWidth(screenSize);
  return {
    w: w,
    h: h,
    color: deviceGate_style_colors.background,
    Background: {
      w: w,
      h: h
    },
    Logo: {
      mountX: 0.5,
      x: middle,
      y: safetyMargins.vertical[screenSize],
      h: deviceGate_deviceGate_style_LOGO_HEIGHT[screenSize]
    },
    Container: {
      w: w,
      h: h,
      flex: {
        direction: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      },
      Title: {
        text: deviceGate_style_objectSpread(deviceGate_style_objectSpread({}, src_getFont(constants_FONT.KINSHASA_3)), {}, {
          textColor: textColor,
          wordWrapWidth: wordWrapWidth,
          textAlign: 'center',
          maxLines: 2
        }),
        flexItem: {
          marginBottom: deviceGate_deviceGate_style_TEXT_GAP[screenSize]
        }
      },
      Description: {
        text: deviceGate_style_objectSpread(deviceGate_style_objectSpread({}, src_getFont(constants_FONT.OTTAWA_1)), {}, {
          textColor: textColor,
          wordWrapWidth: wordWrapWidth,
          textAlign: 'center',
          maxLines: 5
        }),
        flexItem: {
          marginBottom: deviceGate_deviceGate_style_TEXT_GAP[screenSize]
        }
      },
      Buttons: {
        flex: {
          direction: 'row'
        },
        flexItem: {
          marginTop: deviceGate_deviceGate_style_GAP[screenSize],
          marginBottom: deviceGate_deviceGate_style_GAP[screenSize]
        },
        Retry: {
          flexItem: {
            marginRight: deviceGate_deviceGate_style_GAP[screenSize]
          }
        },
        Logout: {}
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/deviceGate/deviceGate.connector.js


var deviceGate_connector_mapControllers = function mapControllers(instance) {
  return [{
    selector: getDeepLink,
    callback: function callback(value) {
      instance.deeplink = value;
    },
    shouldBeInvokedOnConnect: true
  }];
};
/* harmony default export */ const deviceGate_connector = (lightningjs_redux.control(deviceGate_connector_mapControllers));
;// CONCATENATED MODULE: ./src/modules/deviceGate/deviceGate.component.js








function deviceGate_component_createSuper(t) { var r = deviceGate_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function deviceGate_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (deviceGate_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }












var DeviceGate = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(DeviceGate, _Lightning$Component);
  var _super = deviceGate_component_createSuper(DeviceGate);
  function DeviceGate() {
    (0,classCallCheck/* default */.Z)(this, DeviceGate);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(DeviceGate, [{
    key: "_construct",
    value: function _construct() {
      this._index = 0;
    }
  }, {
    key: "_active",
    value: function _active() {
      removeSplashScreen();
      this._unsubscribe = deviceGate_connector(this);
    }
  }, {
    key: "_inactive",
    value: function _inactive() {
      if (this._unsubscribe) {
        this._unsubscribe();
        this._unsubscribe = null;
      }
    }
  }, {
    key: "deeplink",
    set: function set(value) {
      this._deeplink = value;
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this.tag('Buttons').children[this._index];
    }
  }, {
    key: "_handleLeft",
    value: function _handleLeft() {
      this._index = Math.max(this._index - 1, 0);
      return true;
    }
  }, {
    key: "_handleRight",
    value: function _handleRight() {
      this._index = Math.min(this._index + 1, 1);
      return true;
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      if (this._index) {
        lightningjs_redux.dispatch(unpair_actions_logout()).finally(function () {
          lightningjs_redux.dispatch(fetchNavigation('main'));
          navigateToAliasHome(false);
        });
      } else {
        navigateTo(this._deeplink || HOME_PATH, false);
      }
      return true;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Background: {},
        Logo: {
          type: BrandIcon
        },
        Container: {
          Title: {
            text: {
              text: t('pairing.devicesGate.title')
            }
          },
          Description: {
            text: {
              text: t('pairing.devicesGate.description')
            }
          },
          Buttons: {
            Retry: {
              type: Button,
              label: t('error.retry')
            },
            Logout: {
              type: Button,
              label: t('pairing.welcome.disconnect')
            }
          }
        }
      }, deviceGate_style_getInitialStyle());
    }
  }]);
  return DeviceGate;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/routes/routes.js










function routes_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function routes_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? routes_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : routes_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function routes_createSuper(t) { var r = routes_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function routes_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (routes_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }





















var ErrorHandler = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(ErrorHandler, _Lightning$Component);
  var _super = routes_createSuper(ErrorHandler);
  function ErrorHandler() {
    (0,classCallCheck/* default */.Z)(this, ErrorHandler);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(ErrorHandler, [{
    key: "_active",
    value: function _active() {
      Router.navigate('app/alias/home', false);
    }
  }]);
  return ErrorHandler;
}(src_Lightning.Component);
/* harmony default export */ const modules_routes_routes = (routes_objectSpread(routes_objectSpread({}, default_routerConfig), {}, {
  root: HOME_PATH,
  beforeEachRoute: function beforeEachRoute(from, to) {
    lightningjs_redux.dispatch(setCurrentLocation(to.url, to.route.path));
    console.log("[routes] Navigating to: ".concat(to.url));
    return beforeEachRoute_hook_beforeEachRoute(from, to);
  },
  afterEachRoute: function afterEachRoute(destination) {
    return afterEachRoute_hook_afterEachRoute(destination);
  },
  routes: [].concat((0,toConsumableArray/* default */.Z)(routes_routes), [{
    path: 'video/:videoId',
    component: Video,
    widgets: ['CookieConsent', 'SnackBar', 'Popup', 'ScreenSaver'],
    options: {
      preventStorage: true,
      reuseInstance: false
    }
  }, {
    path: 'live/:videoId',
    component: Live,
    widgets: ['CookieConsent', 'SnackBar', 'Popup', 'ScreenSaver'],
    options: {
      preventStorage: true,
      reuseInstance: false
    }
  }, {
    path: 'app/:entityType/:entityId',
    component: Page,
    widgets: ['Sidenav', 'SnackBar', 'CookieConsent', 'Popup', 'ScreenSaver'],
    options: {
      reuseInstance: false
    }
  }, {
    path: 'app/frontspace/offers',
    component: SubscriptionExpired,
    widgets: ['CookieConsent', 'Popup', 'ScreenSaver']
  }, {
    path: PAIRING_PATH,
    component: Pairing,
    widgets: ['CookieConsent', 'Popup']
  }, {
    path: LANDING_PATH,
    component: Landing,
    widgets: ['CookieConsent', 'Popup'],
    options: {
      clearHistory: true
    }
  }, {
    path: DEVICE_GATE_PATH,
    component: DeviceGate,
    widgets: ['CookieConsent', 'Popup', 'ScreenSaver'],
    options: {
      clearHistory: true
    }
  }, {
    path: EXPIRED_SUBSCRIPTION_PATH,
    component: SubscriptionExpired,
    widgets: ['CookieConsent', 'SnackBar', 'Popup']
  }, {
    path: PROFILE_PATH,
    component: Account,
    widgets: ['Sidenav', 'CookieConsent', 'Popup', 'ScreenSaver']
  }, {
    path: SETTINGS_PATH,
    component: settings_component_Settings,
    widgets: ['Sidenav', 'CookieConsent', 'Popup']
  }, {
    path: INFORMATION_PATH,
    component: QRCodePage,
    widgets: ['Sidenav', 'CookieConsent', 'Popup']
  }, {
    path: FOLDERS_PATH,
    component: AbstractMosaic,
    widgets: ['Sidenav', 'CookieConsent', 'Popup', 'ScreenSaver']
  }, {
    path: SERVICES_PATH,
    component: AbstractMosaic,
    widgets: ['Sidenav', 'CookieConsent', 'Popup', 'ScreenSaver']
  }, {
    path: LIVES_PATH,
    component: AbstractMosaic,
    widgets: ['Sidenav', 'CookieConsent', 'Popup']
  }, {
    path: USAGE_TERMS_PATH,
    before: function before(page) {
      page.target = 'termsOfUsage';
      return Promise.resolve();
    },
    component: StaticPage,
    widgets: ['CookieConsent', 'Popup']
  }, {
    path: LEGAL_CONDITIONS_PATH,
    before: function before(page) {
      page.target = 'legalConditions';
      return Promise.resolve();
    },
    component: StaticPage,
    widgets: ['CookieConsent', 'Popup']
  }, {
    path: PRIVACY_POLICY_PATH,
    before: function before(page) {
      page.target = 'privacyPolicy';
      return Promise.resolve();
    },
    component: StaticPage,
    widgets: ['CookieConsent', 'Popup']
  }, {
    path: FAQ_PATH,
    component: QRCodePage,
    widgets: ['Sidenav']
  }, {
    path: ACCOUNT_SETTINGS_PATH,
    component: QRCodePage,
    widgets: ['Sidenav']
  }, {
    path: FEEDBACK_PATH,
    component: QRCodePage,
    widgets: ['Sidenav']
  }, {
    path: '*',
    component: Page,
    widgets: ['CookieConsent', 'Popup']
  }, {
    path: '!',
    component: ErrorHandler
  }])
}));
;// CONCATENATED MODULE: ./src/modules/sidenav/miniPlayer/spectrum/bars.style.js

var bars_style_HEIGHT, _BAR_WIDTH, bars_style_GAP, bars_style_WIDTH;



var bars_style_defaultContext = makeDefaultStylingContext();
var bars_style_colors = {
  background: makeThemeColor(PRIMARY, 0.1),
  bar: makeThemeColor(SECONDARY)
};
var spectrum_bars_style_HEIGHT = (bars_style_HEIGHT = {}, (0,defineProperty/* default */.Z)(bars_style_HEIGHT, HD, 24), (0,defineProperty/* default */.Z)(bars_style_HEIGHT, FULL_HD, 32), bars_style_HEIGHT);
var BAR_WIDTH = (_BAR_WIDTH = {}, (0,defineProperty/* default */.Z)(_BAR_WIDTH, HD, 3), (0,defineProperty/* default */.Z)(_BAR_WIDTH, FULL_HD, 4), _BAR_WIDTH);
var spectrum_bars_style_GAP = (bars_style_GAP = {}, (0,defineProperty/* default */.Z)(bars_style_GAP, HD, 1), (0,defineProperty/* default */.Z)(bars_style_GAP, FULL_HD, 2), bars_style_GAP);
var getWidth = function getWidth(screenSize) {
  return 4 * (BAR_WIDTH[screenSize] + spectrum_bars_style_GAP[screenSize]) - spectrum_bars_style_GAP[screenSize];
};
var spectrum_bars_style_WIDTH = (bars_style_WIDTH = {}, (0,defineProperty/* default */.Z)(bars_style_WIDTH, HD, getWidth(HD)), (0,defineProperty/* default */.Z)(bars_style_WIDTH, FULL_HD, getWidth(FULL_HD)), bars_style_WIDTH);
var bars_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : bars_style_defaultContext,
    screenSize = _ref.screenSize;
  return {
    h: spectrum_bars_style_HEIGHT[screenSize]
  };
};
;// CONCATENATED MODULE: ./src/modules/sidenav/miniPlayer/spectrum/bars.component.js







function bars_component_createSuper(t) { var r = bars_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function bars_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (bars_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }


var Bars = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Bars, _Lightning$Component);
  var _super = bars_component_createSuper(Bars);
  function Bars() {
    (0,classCallCheck/* default */.Z)(this, Bars);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Bars, [{
    key: "_attach",
    value: function _attach() {
      this._style = bars_style_defaultContext;
      var _this$_style = this._style,
        screenSize = _this$_style.screenSize,
        colorMode = _this$_style.colorMode;
      var h = spectrum_bars_style_HEIGHT[screenSize];
      var w = BAR_WIDTH[screenSize];
      var gap = spectrum_bars_style_GAP[screenSize];
      var children = [];
      for (var i = 0; i < 4; i += 1) {
        children.push({
          ref: "Bar".concat(i),
          rect: true,
          w: w,
          h: h,
          x: i * (w + gap),
          y: h,
          mountY: 1,
          color: bars_style_colors.bar[colorMode]
        });
      }
      this.patch({
        children: children,
        w: spectrum_bars_style_WIDTH[screenSize]
      });
      this._timeouts = {};
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this.stop();
      this._timeouts = null;
      this._style = null;
    }
  }, {
    key: "start",
    value: function start() {
      var _this = this;
      this.children.forEach(function (child) {
        _this._startBarAnimation(child);
      });
    }
  }, {
    key: "stop",
    value: function stop() {
      var _this2 = this;
      var displayMinimalLevel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.children.forEach(function (child) {
        _this2._stopBarAnimation(child);
        child.setSmooth('h', displayMinimalLevel ? 1 : 0);
      });
      if (this._timeouts) {
        Object.keys(this._timeouts).forEach(function (key) {
          clearTimeout(_this2._timeouts[key]);
          _this2._timeouts[key] = null;
        });
      }
    }
  }, {
    key: "_startBarAnimation",
    value: function _startBarAnimation(bar) {
      var _this3 = this;
      var height = spectrum_bars_style_HEIGHT[this._style.screenSize];
      bar.transition('h').on('finish', function () {
        var timeout = setTimeout(function () {
          return bar.setSmooth('h', Math.round(Math.random() * height));
        }, 16);
        _this3._timeouts[bar.ref] = timeout;
      });
      bar.setSmooth('h', Math.round(Math.random() * height));
    }
  }, {
    key: "_stopBarAnimation",
    value: function _stopBarAnimation(bar) {
      var transition = bar.transition('h');
      if (transition) {
        transition.stop();
        transition.removeAllListeners('finish');
      }
    }
  }], [{
    key: "_template",
    value: function _template() {
      return bars_style_getInitialStyle();
    }
  }]);
  return Bars;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/sidenav/miniPlayer/miniPlayer.connect.js


var miniPlayer_connect_mapControllers = function mapControllers(instance) {
  return [{
    selector: getPlaybackState,
    callback: function callback(value) {
      instance.playbackState = value;
    }
  }, {
    selector: getVideoSource,
    callback: function callback(value) {
      instance.source = value;
    }
  }, {
    selector: getCurrentMetadataItem,
    callback: function callback(value) {
      instance.metadata = value;
    }
  }, {
    selector: getLastPlaybackError,
    callback: function callback(value) {
      instance.playbackError = value;
    }
  }];
};
/* harmony default export */ const miniPlayer_connect = (lightningjs_redux.control(miniPlayer_connect_mapControllers));
;// CONCATENATED MODULE: ./src/modules/sidenav/miniPlayer/miniPlayer.style.js

var miniPlayer_style_WIDTH, miniPlayer_style_HEIGHT, miniPlayer_style_PADDING, miniPlayer_style_GAP, miniPlayer_style_COVER_SIZE, _BORDER, _DEFAULT_WIDTH;
function miniPlayer_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function miniPlayer_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? miniPlayer_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : miniPlayer_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }







var miniPlayer_style_defaultContext = makeDefaultStylingContext();
var miniPlayer_style_colors = {
  background: makeThemeColor(PRIMARY, 0.1),
  text: makeThemeColor(PRIMARY),
  border: makeThemeColor(PRIMARY)
};
var miniPlayer_miniPlayer_style_WIDTH = (miniPlayer_style_WIDTH = {}, (0,defineProperty/* default */.Z)(miniPlayer_style_WIDTH, HD, 152), (0,defineProperty/* default */.Z)(miniPlayer_style_WIDTH, FULL_HD, 224), miniPlayer_style_WIDTH);
var miniPlayer_miniPlayer_style_HEIGHT = (miniPlayer_style_HEIGHT = {}, (0,defineProperty/* default */.Z)(miniPlayer_style_HEIGHT, HD, 72), (0,defineProperty/* default */.Z)(miniPlayer_style_HEIGHT, FULL_HD, 88), miniPlayer_style_HEIGHT);
var miniPlayer_miniPlayer_style_PADDING = (miniPlayer_style_PADDING = {}, (0,defineProperty/* default */.Z)(miniPlayer_style_PADDING, HD, 12), (0,defineProperty/* default */.Z)(miniPlayer_style_PADDING, FULL_HD, 16), miniPlayer_style_PADDING);
var miniPlayer_miniPlayer_style_GAP = (miniPlayer_style_GAP = {}, (0,defineProperty/* default */.Z)(miniPlayer_style_GAP, HD, 24), (0,defineProperty/* default */.Z)(miniPlayer_style_GAP, FULL_HD, 24), miniPlayer_style_GAP);
var miniPlayer_miniPlayer_style_COVER_SIZE = (miniPlayer_style_COVER_SIZE = {}, (0,defineProperty/* default */.Z)(miniPlayer_style_COVER_SIZE, HD, 48), (0,defineProperty/* default */.Z)(miniPlayer_style_COVER_SIZE, FULL_HD, 56), miniPlayer_style_COVER_SIZE);
var BORDER = (_BORDER = {}, (0,defineProperty/* default */.Z)(_BORDER, HD, 2), (0,defineProperty/* default */.Z)(_BORDER, FULL_HD, 4), _BORDER);
var DEFAULT_WIDTH = (_DEFAULT_WIDTH = {}, (0,defineProperty/* default */.Z)(_DEFAULT_WIDTH, HD, 304), (0,defineProperty/* default */.Z)(_DEFAULT_WIDTH, FULL_HD, 416), _DEFAULT_WIDTH);
var TRANSITION_CONFIG = {
  duration: 0.3
};
var miniPlayer_style_getExtraTitleFont = function getExtraTitleFont(screenSize) {
  return src_getFont(constants_FONT.BERLIN_1, screenSize);
};
var miniPlayer_style_getTitleFont = function getTitleFont(screenSize) {
  return src_getFont(constants_FONT.MADRID_3, screenSize);
};
var miniPlayer_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : miniPlayer_style_defaultContext,
    screenSize = _ref.screenSize,
    colorMode = _ref.colorMode;
  var commonTextConfig = {
    textColor: miniPlayer_style_colors.text[colorMode],
    textAlign: 'center',
    maxLines: 1,
    maxLinesSuffix: '...',
    verticalAlign: 'middle'
  };
  var extraTitleFont = miniPlayer_style_getExtraTitleFont(screenSize);
  var titleFont = miniPlayer_style_getTitleFont(screenSize);
  var textX = miniPlayer_miniPlayer_style_PADDING[screenSize] * 2 + miniPlayer_miniPlayer_style_COVER_SIZE[screenSize];
  var textWidth = DEFAULT_WIDTH[screenSize] - miniPlayer_miniPlayer_style_COVER_SIZE[screenSize] - miniPlayer_miniPlayer_style_PADDING[screenSize] * 3 - miniPlayer_miniPlayer_style_GAP[screenSize] - spectrum_bars_style_WIDTH[screenSize];
  return {
    h: miniPlayer_miniPlayer_style_HEIGHT[screenSize],
    Background: {
      w: function w(value) {
        return value;
      },
      h: miniPlayer_miniPlayer_style_HEIGHT[screenSize],
      color: miniPlayer_style_colors.background[colorMode],
      alpha: 0,
      shader: {
        type: src_Lightning.shaders.RoundedRectangle,
        stroke: 0,
        strokeColor: colors_TRANSPARENT,
        radius: 4
      }
    },
    Spectrum: {
      y: Math.round((miniPlayer_miniPlayer_style_HEIGHT[screenSize] - spectrum_bars_style_HEIGHT[screenSize]) / 2)
    },
    Cover: {
      alpha: 0,
      w: miniPlayer_miniPlayer_style_COVER_SIZE[screenSize],
      h: miniPlayer_miniPlayer_style_COVER_SIZE[screenSize],
      x: miniPlayer_miniPlayer_style_PADDING[screenSize],
      y: Math.round((miniPlayer_miniPlayer_style_HEIGHT[screenSize] - miniPlayer_miniPlayer_style_COVER_SIZE[screenSize]) / 2),
      shader: {
        type: src_Lightning.shaders.RoundedRectangle,
        radius: 4
      }
    },
    ExtraTitle: {
      x: textX,
      y: miniPlayer_miniPlayer_style_PADDING[screenSize],
      w: textWidth,
      font: miniPlayer_style_objectSpread(miniPlayer_style_objectSpread({}, extraTitleFont), commonTextConfig)
    },
    Title: {
      x: textX,
      y: miniPlayer_miniPlayer_style_PADDING[screenSize] + extraTitleFont.lineHeight,
      w: textWidth,
      font: miniPlayer_style_objectSpread(miniPlayer_style_objectSpread({}, titleFont), commonTextConfig)
    }
  };
};
var miniPlayer_style_getFocusedStyle = function getFocusedStyle(_ref2) {
  var colorMode = _ref2.colorMode,
    screenSize = _ref2.screenSize;
  return {
    Background: {
      smooth: {
        'shader.strokeColor': miniPlayer_style_colors.border[colorMode],
        'shader.stroke': BORDER[screenSize],
        radius: 4 + BORDER[screenSize]
      }
    }
  };
};
var miniPlayer_style_getUnFocusedStyle = function getUnFocusedStyle() {
  return {
    Background: {
      smooth: {
        'shader.strokeColor': colors_TRANSPARENT,
        'shader.stroke': 0,
        radius: 4
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/sidenav/miniPlayer/miniPlayer.constants.js
var HIDE_SIGNAL = 'hide';
;// CONCATENATED MODULE: ./src/modules/sidenav/miniPlayer/customer/rtlde/miniPlayer.component.js






function miniPlayer_component_createSuper(t) { var r = miniPlayer_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function miniPlayer_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (miniPlayer_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
















var MiniPlayer = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(MiniPlayer, _Lightning$Component);
  var _super = miniPlayer_component_createSuper(MiniPlayer);
  function MiniPlayer() {
    (0,classCallCheck/* default */.Z)(this, MiniPlayer);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(MiniPlayer, [{
    key: "_construct",
    value: function _construct() {
      this._style = miniPlayer_style_defaultContext;
      this._isRadio = false;
    }
  }, {
    key: "_attach",
    value: function _attach() {
      this._unsubscribe = miniPlayer_connect(this);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      if (this._unsubscribe) {
        this._unsubscribe();
        this._unsubscribe = null;
      }
    }
  }, {
    key: "isActive",
    get: function get() {
      return this._playbackState === PLAYBACK_STATE_PLAYING || this._playbackState === PLAYBACK_STATE_PAUSED;
    }
  }, {
    key: "metadata",
    set: function set(value) {
      this._clipId = get_default()(value, 'video.id');
      var extraTitle = get_default()(value, 'extraTitle') || '';
      var title = get_default()(value, 'title') || '';
      var image = get_default()(value, 'image.idsByRatio.1:1') || get_default()(value, 'image.id') || '';
      var screenSize = this._style.screenSize;
      var coverSize = miniPlayer_miniPlayer_style_COVER_SIZE[screenSize];
      this.patch({
        Cover: {
          src: imageService.getUrl(image, coverSize, coverSize, {
            fit: IMAGE_FIT_SCALE_CROP,
            quality: IMAGE_QUALITY,
            format: DEFAULT_IMAGE_FORMAT
          })
        },
        ExtraTitle: {
          caption: extraTitle
        },
        Title: {
          caption: title
        }
      });
      if (image) {
        this.tag('Cover').loadTexture();
      }
    }
  }, {
    key: "source",
    set: function set(value) {
      var audioPlayer = getAudioPlayerInstance();
      if (!audioPlayer) {
        return;
      }
      if (!value) {
        audioPlayer.pause();
        this.tag('Spectrum').stop();
        return;
      }
      this._isRadio = value.provider === 'radio';
      if (audioPlayer.source && audioPlayer.source.reference === value.reference) {
        audioPlayer.play();
        return;
      }
      audioPlayer.pause();
      if (value.format === 'mp3' || value.format === 'hls') {
        audioPlayer.setSource(value);
        audioPlayer.play();
      } else {
        destroyAudioPlayer();
      }
    }
  }, {
    key: "playbackError",
    set: function set(value) {
      var audioPlayer = getAudioPlayerInstance();
      if (!value || !audioPlayer) {
        return;
      }
      if (!this.isOnAudioPlayerScreen) {
        showSnackbar(this, NOTIFICATION_LEVEL.ERROR, value.message);
      }
      this.tag('Spectrum').stop();
      destroyAudioPlayer();
      lightningjs_redux.dispatch(player_constants_reset());
    }
  }, {
    key: "playbackState",
    set: function set(value) {
      if (!this._clipId && (value === PLAYBACK_STATE_PLAYING || value === PLAYBACK_STATE_PAUSED)) {
        this.tag('Spectrum').stop();
        return;
      }
      this._playbackState = value;
      switch (value) {
        case PLAYBACK_STATE_PLAYING:
          {
            this.tag('Spectrum').start();
            break;
          }
        case PLAYBACK_STATE_PAUSED:
          {
            this.tag('Spectrum').stop(true);
            break;
          }
        case PLAYBACK_STATE_ENDED:
          {
            this.tag('Spectrum').stop();
            if (this.isOnAudioPlayerScreen) {
              Router.back();
              destroyAudioPlayer();
              lightningjs_redux.dispatch(player_constants_reset());
            }
            break;
          }
        default:
          {
            this.tag('Spectrum').stop();
            break;
          }
      }
      var isVisible = this._playbackState === PLAYBACK_STATE_PLAYING || this._playbackState === PLAYBACK_STATE_PAUSED;
      if (!isVisible) {
        this.signal(HIDE_SIGNAL);
      }
      this.visible = isVisible;
    }
  }, {
    key: "isOnAudioPlayerScreen",
    get: function get() {
      var route = Router.getActiveRoute();
      return route.startsWith(layout_constants/* entities */.jF.audio) || route.startsWith(layout_constants/* entities */.jF.live);
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this.patch(miniPlayer_style_getFocusedStyle(this._style));
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this.patch(miniPlayer_style_getUnFocusedStyle(this._style));
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      if (!this._clipId) {
        return false;
      }
      if (this._isRadio) {
        navigateToRadioPage(this._clipId);
      } else {
        navigateToAudioPage(this._clipId);
      }
      return true;
    }
  }, {
    key: "_handlePlay",
    value: function _handlePlay() {
      if (this._playbackState === PLAYBACK_STATE_PLAYING) {
        getAudioPlayerInstance().pause();
        return true;
      }
      return false;
    }
  }, {
    key: "_handlePause",
    value: function _handlePause() {
      if (this._playbackState === PLAYBACK_STATE_PAUSED) {
        getAudioPlayerInstance().play();
        return true;
      }
      return false;
    }
  }, {
    key: "_handlePlayPause",
    value: function _handlePlayPause() {
      return this._handlePlay() || this._handlePause();
    }
  }, {
    key: "open",
    value: function open(width) {
      var screenSize = this._style.screenSize;
      var barsWidth = this.tag('Spectrum').w;
      var textWidth = width - miniPlayer_miniPlayer_style_COVER_SIZE[screenSize] - miniPlayer_miniPlayer_style_PADDING[screenSize] * 3 - miniPlayer_miniPlayer_style_GAP[screenSize] - barsWidth;
      this.patch({
        Background: {
          smooth: {
            alpha: [this._playbackState === PLAYBACK_STATE_PLAYING || this._playbackState === PLAYBACK_STATE_PAUSED ? 1 : 0, TRANSITION_CONFIG]
          }
        },
        Spectrum: {
          smooth: {
            x: [width - miniPlayer_miniPlayer_style_PADDING[screenSize] - barsWidth, TRANSITION_CONFIG]
          }
        },
        Cover: {
          smooth: {
            alpha: [1, TRANSITION_CONFIG]
          }
        },
        ExtraTitle: {
          w: textWidth,
          smooth: {
            alpha: 1
          }
        },
        Title: {
          w: textWidth,
          smooth: {
            alpha: 1
          }
        }
      });
    }
  }, {
    key: "close",
    value: function close(width) {
      this.patch({
        Background: {
          smooth: {
            alpha: [0, TRANSITION_CONFIG]
          }
        },
        Spectrum: {
          smooth: {
            x: [Math.round((width - this.tag('Spectrum').w) / 2), TRANSITION_CONFIG]
          }
        },
        Cover: {
          smooth: {
            alpha: [0, TRANSITION_CONFIG]
          }
        },
        ExtraTitle: {
          smooth: {
            alpha: 0
          }
        },
        Title: {
          smooth: {
            alpha: 0
          }
        }
      });
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Background: {
          rect: true
        },
        Spectrum: {
          type: Bars
        },
        Cover: {},
        ExtraTitle: {
          type: Autoscroll
        },
        Title: {
          type: Autoscroll
        }
      }, miniPlayer_style_getInitialStyle());
    }
  }]);
  return MiniPlayer;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/sidenav/miniPlayer/miniPlayer.component.js

;// CONCATENATED MODULE: ./src/modules/sidenav/customer/default/sidenavIcon/sidenavIcon.style.js

var sidenavIcon_style_HEIGHT, sidenavIcon_style_WIDTH, sidenavIcon_style_HEIGHT2, _ICON_PADDING;




var sidenavIcon_style_defaultContext = makeDefaultStylingContext();
var sidenavIcon_style_colors = {
  icon: makeThemeColor(PRIMARY),
  focusedIcon: makeThemeColor(TERTIARY)
};
var sidenavIcon_sidenavIcon_style_HEIGHT = (sidenavIcon_style_HEIGHT = {}, (0,defineProperty/* default */.Z)(sidenavIcon_style_HEIGHT, HD, 48), (0,defineProperty/* default */.Z)(sidenavIcon_style_HEIGHT, FULL_HD, 72), sidenavIcon_style_HEIGHT);
var sidenavIcon_style_ICON_SIZE = {
  WIDTH: (sidenavIcon_style_WIDTH = {}, (0,defineProperty/* default */.Z)(sidenavIcon_style_WIDTH, HD, 24), (0,defineProperty/* default */.Z)(sidenavIcon_style_WIDTH, FULL_HD, 32), sidenavIcon_style_WIDTH),
  HEIGHT: (sidenavIcon_style_HEIGHT2 = {}, (0,defineProperty/* default */.Z)(sidenavIcon_style_HEIGHT2, HD, 24), (0,defineProperty/* default */.Z)(sidenavIcon_style_HEIGHT2, FULL_HD, 32), sidenavIcon_style_HEIGHT2)
};
var ICON_PADDING = (_ICON_PADDING = {}, (0,defineProperty/* default */.Z)(_ICON_PADDING, HD, 16), (0,defineProperty/* default */.Z)(_ICON_PADDING, FULL_HD, 16), _ICON_PADDING);
var sidenavIcon_style_getImageSize = function getImageSize(screenSize) {
  return {
    w: sidenavIcon_style_ICON_SIZE.WIDTH[screenSize],
    h: sidenavIcon_style_ICON_SIZE.WIDTH[screenSize]
  };
};
var sidenavIcon_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sidenavIcon_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  var x = safetyMargins.horizontal[screenSize];
  var y = Math.round((sidenavIcon_sidenavIcon_style_HEIGHT[screenSize] - sidenavIcon_style_ICON_SIZE.HEIGHT[screenSize]) / 2);
  return {
    Icon: {
      x: x,
      y: y,
      color: sidenavIcon_style_colors.icon[colorMode]
    },
    Image: {
      x: x,
      y: y,
      shader: {
        radius: sidenavIcon_style_ICON_SIZE.HEIGHT[screenSize] / 2
      }
    }
  };
};
var sidenavIcon_style_getIconViewBox = memoize_default()(function (screenSize) {
  return {
    w: sidenavIcon_style_ICON_SIZE.WIDTH[screenSize],
    h: sidenavIcon_style_ICON_SIZE.HEIGHT[screenSize]
  };
});
;// CONCATENATED MODULE: ./src/modules/sidenav/customer/default/sidenavIcon/sidenavIcon.component.js





function sidenavIcon_component_createSuper(t) { var r = sidenavIcon_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function sidenavIcon_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (sidenavIcon_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }






var SidenavIcon = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(SidenavIcon, _Lightning$Component);
  var _super = sidenavIcon_component_createSuper(SidenavIcon);
  function SidenavIcon() {
    (0,classCallCheck/* default */.Z)(this, SidenavIcon);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(SidenavIcon, [{
    key: "_detach",
    value: function _detach() {
      this.tag('Image').removeAllListeners('txLoaded');
      this.tag('Icon').removeAllListeners('txLoaded');
    }
  }, {
    key: "_construct",
    value: function _construct() {
      this._style = sidenavIcon_style_defaultContext;
    }
  }, {
    key: "content",
    set: function set(value) {
      var _ref = value || {},
        picto = _ref.picto,
        image = _ref.image;
      var _getImageSize = sidenavIcon_style_getImageSize(this._style.screenSize),
        w = _getImageSize.w,
        h = _getImageSize.h;
      var src = image && image.id ? imageService.getUrl(image.id, w, h, {
        fit: IMAGE_FIT_SCALE_CROP,
        quality: IMAGE_QUALITY,
        format: TRANSPARENT_IMAGE_FORMAT
      }) : '';
      var view = this.tag(src ? 'Image' : 'Icon');
      view.on('txLoaded', function () {
        view.setSmooth('alpha', 1);
      });
      this.patch({
        Icon: {
          alpha: 0.0001,
          visible: !src,
          iconData: {
            picto: picto,
            viewBox: sidenavIcon_style_getIconViewBox(this._style.screenSize)
          }
        },
        Image: {
          alpha: 0.0001,
          w: w,
          h: h,
          visible: Boolean(src),
          src: src
        }
      });
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Icon: {
          type: Icon
        },
        Image: {
          shader: {
            type: src_Lightning.shaders.RoundedRectangle
          }
        }
      }, sidenavIcon_style_getInitialStyle());
    }
  }]);
  return SidenavIcon;
}(src_Lightning.Component);

;// CONCATENATED MODULE: ./src/modules/sidenav/sidenavItem/sidenavItem.style.js

var sidenavItem_style_HEIGHT, sidenavItem_style_ICON_PADDING, _INDICATOR_WIDTH;
function sidenavItem_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function sidenavItem_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? sidenavItem_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : sidenavItem_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }








var sidenavItem_style_defaultContext = makeDefaultStylingContext();
var sidenavItem_style_colors = {
  background: makeThemeColor(PRIMARY),
  label: makeThemeColor(PRIMARY),
  focusedLabel: makeThemeColor(TERTIARY),
  indicator: makeThemeColor(SECONDARY)
};
var ALPHA_INACTIVE = 0.3;
var ALPHA_ACTIVE = 1;
var sidenavItem_sidenavItem_style_HEIGHT = (sidenavItem_style_HEIGHT = {}, (0,defineProperty/* default */.Z)(sidenavItem_style_HEIGHT, HD, 48), (0,defineProperty/* default */.Z)(sidenavItem_style_HEIGHT, FULL_HD, 72), sidenavItem_style_HEIGHT);
var sidenavItem_sidenavItem_style_ICON_PADDING = (sidenavItem_style_ICON_PADDING = {}, (0,defineProperty/* default */.Z)(sidenavItem_style_ICON_PADDING, HD, 16), (0,defineProperty/* default */.Z)(sidenavItem_style_ICON_PADDING, FULL_HD, 16), sidenavItem_style_ICON_PADDING);
var INDICATOR_WIDTH = (_INDICATOR_WIDTH = {}, (0,defineProperty/* default */.Z)(_INDICATOR_WIDTH, HD, 4), (0,defineProperty/* default */.Z)(_INDICATOR_WIDTH, FULL_HD, 8), _INDICATOR_WIDTH);
var getIndicatorPosition = function getIndicatorPosition(value, screenSize) {
  return (value ? EXPANDED_WIDTH[screenSize] : WIDTH[screenSize]) - INDICATOR_WIDTH[screenSize];
};
var sidenavItem_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sidenavItem_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  var offset = safetyMargins.horizontal[screenSize];
  var font = src_getFont(constants_FONT.OTTAWA_2, screenSize);
  return {
    h: sidenavItem_sidenavItem_style_HEIGHT[screenSize],
    alpha: ALPHA_INACTIVE,
    Background: {
      w: identity,
      h: sidenavItem_sidenavItem_style_HEIGHT[screenSize],
      alpha: 0,
      color: sidenavItem_style_colors.background[colorMode]
    },
    Indicator: {
      alpha: 0,
      rect: true,
      h: sidenavItem_sidenavItem_style_HEIGHT[screenSize],
      w: INDICATOR_WIDTH[screenSize],
      x: getIndicatorPosition(false, screenSize),
      color: sidenavItem_style_colors.indicator[colorMode]
    },
    Label: {
      text: sidenavItem_style_objectSpread(sidenavItem_style_objectSpread({}, font), {}, {
        verticalAlign: 'middle'
      }),
      alpha: 0,
      x: offset + sidenavIcon_style_ICON_SIZE.WIDTH[screenSize] + sidenavItem_sidenavItem_style_ICON_PADDING[screenSize],
      y: Math.round((sidenavItem_sidenavItem_style_HEIGHT[screenSize] - font.lineHeight) / 2)
    }
  };
};
var getStateStyles = memoize_default()(function (_ref) {
  var colorMode = _ref.colorMode,
    screenSize = _ref.screenSize;
  return {
    unfocused: {
      w: WIDTH[screenSize],
      Background: {
        w: WIDTH[screenSize],
        alpha: 0
      },
      SidenavIcon: {
        Icon: {
          color: sidenavIcon_style_colors.icon[colorMode]
        }
      },
      Label: {
        color: sidenavItem_style_colors.label[colorMode]
      }
    },
    focused: {
      alpha: ALPHA_ACTIVE,
      w: EXPANDED_WIDTH[screenSize],
      Background: {
        w: EXPANDED_WIDTH[screenSize],
        alpha: 1
      },
      SidenavIcon: {
        Icon: {
          color: sidenavIcon_style_colors.focusedIcon[colorMode]
        }
      },
      Label: {
        color: sidenavItem_style_colors.focusedLabel[colorMode]
      }
    }
  };
}, cacheResolver);
;// CONCATENATED MODULE: ./src/modules/sidenav/customer/default/sidenavItem.constants.js
var SHOW_INDICATOR = true;
;// CONCATENATED MODULE: ./src/modules/sidenav/sidenavItem/sidenavItem.component.js






function sidenavItem_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function sidenavItem_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? sidenavItem_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : sidenavItem_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function sidenavItem_component_createSuper(t) { var r = sidenavItem_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function sidenavItem_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (sidenavItem_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }






var SidenavItem = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(SidenavItem, _Lightning$Component);
  var _super = sidenavItem_component_createSuper(SidenavItem);
  function SidenavItem() {
    (0,classCallCheck/* default */.Z)(this, SidenavItem);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(SidenavItem, [{
    key: "_construct",
    value: function _construct() {
      this._style = sidenavItem_style_defaultContext;
      this._isSelected = false;
      this._actionPath = '';
    }
  }, {
    key: "item",
    get: function get() {
      return this._item;
    },
    set: function set(value) {
      this._item = value;
      this.patch({
        Label: {
          text: {
            text: value.content.label
          }
        },
        SidenavIcon: {
          content: value.content
        }
      });
    }
  }, {
    key: "actionPath",
    get: function get() {
      return this._actionPath;
    },
    set: function set(value) {
      this._actionPath = value;
    }
  }, {
    key: "expanded",
    set: function set(value) {
      this.tag('Label').setSmooth('alpha', value ? 1 : 0, animationConfig);
      this.tag('Indicator').x = getIndicatorPosition(value, this._style.screenSize);
    }
  }, {
    key: "colorMode",
    get: function get() {
      return this._style.colorMode;
    },
    set: function set(value) {
      this._style = sidenavItem_component_objectSpread(sidenavItem_component_objectSpread({}, this._style), {}, {
        colorMode: value
      });
      this._updateColorMode();
    }
  }, {
    key: "isSelected",
    get: function get() {
      return this._isSelected;
    },
    set: function set(value) {
      if (this._isSelected === value) {
        return;
      }
      this._isSelected = value;
      this._updateAlpha();
      this.tag('Indicator').alpha = SHOW_INDICATOR ? value : 0;
    }
  }, {
    key: "_updateColorMode",
    value: function _updateColorMode() {
      this.patch({
        color: sidenavItem_style_colors.background[this.colorMode]
      });
      this.$enter();
    }
  }, {
    key: "_updateAlpha",
    value: function _updateAlpha() {
      this.alpha = this.isSelected ? ALPHA_ACTIVE : ALPHA_INACTIVE;
      this.tag('SidenavIcon').isSelected = this.isSelected;
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this._setState('Focused');
      this.alpha = ALPHA_ACTIVE;
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this._setState('Unfocused');
      this._updateAlpha();
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Background: {
          rect: true
        },
        SidenavIcon: {
          type: SidenavIcon
        },
        Indicator: {},
        Label: {}
      }, sidenavItem_style_getInitialStyle());
    }
  }, {
    key: "_states",
    value: function _states() {
      return [function (_this) {
        (0,inherits/* default */.Z)(Unfocused, _this);
        var _super2 = sidenavItem_component_createSuper(Unfocused);
        function Unfocused() {
          (0,classCallCheck/* default */.Z)(this, Unfocused);
          return _super2.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(Unfocused, [{
          key: "$enter",
          value: function $enter() {
            this.patch(getStateStyles(this._style).unfocused);
          }
        }]);
        return Unfocused;
      }(this), function (_this2) {
        (0,inherits/* default */.Z)(Focused, _this2);
        var _super3 = sidenavItem_component_createSuper(Focused);
        function Focused() {
          (0,classCallCheck/* default */.Z)(this, Focused);
          return _super3.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(Focused, [{
          key: "$enter",
          value: function $enter() {
            this.patch(getStateStyles(this._style).focused);
          }
        }]);
        return Focused;
      }(this)];
    }
  }]);
  return SidenavItem;
}(src_Lightning.Component);

;// CONCATENATED MODULE: ./src/modules/sidenav/sidenavLogo/customer/rtlde/sidenavLogo.connect.js


var sidenavLogo_connect_mapControllers = function mapControllers(instance) {
  return [{
    selector: getCurrentRoute,
    callback: function callback() {
      instance.updateLogo();
    }
  }];
};
/* harmony default export */ const sidenavLogo_connect = (lightningjs_redux.control(sidenavLogo_connect_mapControllers));
;// CONCATENATED MODULE: ./src/modules/sidenav/sidenav.style.js

var _MAIN_LOGO_HEIGHT, _KIDS_LOGO_WIDTH, sidenav_style_LOGO_MARGIN_BOTTOM, sidenav_style_PADDING_TOP, _ITEM_GAP, sidenav_style_PADDING_BOTTOM, sidenav_style_PADDING_LEFT, _MINI_PLAYER_MARGIN;









var sidenav_style_defaultContext = makeDefaultStylingContext();
var sidenav_style_colors = {
  background: makeThemeColor(TERTIARY),
  border: makeThemeColor(PRIMARY, 0.3),
  overlay: makeThemeColor(TERTIARY),
  empty: makeThemeColor(TERTIARY, 0)
};
var MAIN_LOGO_HEIGHT = (_MAIN_LOGO_HEIGHT = {}, (0,defineProperty/* default */.Z)(_MAIN_LOGO_HEIGHT, HD, 72), (0,defineProperty/* default */.Z)(_MAIN_LOGO_HEIGHT, FULL_HD, 96), _MAIN_LOGO_HEIGHT);
var KIDS_LOGO_WIDTH = (_KIDS_LOGO_WIDTH = {}, (0,defineProperty/* default */.Z)(_KIDS_LOGO_WIDTH, HD, 216), (0,defineProperty/* default */.Z)(_KIDS_LOGO_WIDTH, FULL_HD, 280), _KIDS_LOGO_WIDTH);
var getKidsIconViewBox = memoize_default()(function (screenSize) {
  return {
    w: KIDS_LOGO_WIDTH[screenSize],
    h: MAIN_LOGO_HEIGHT[screenSize]
  };
});
var getMainIconViewBox = memoize_default()(function (screenSize) {
  return {
    h: MAIN_LOGO_HEIGHT[screenSize],
    w: MAIN_LOGO_HEIGHT[screenSize] * BRAND_ICON_WIDTH_RATIO
  };
});
var sidenav_sidenav_style_LOGO_MARGIN_BOTTOM = (sidenav_style_LOGO_MARGIN_BOTTOM = {}, (0,defineProperty/* default */.Z)(sidenav_style_LOGO_MARGIN_BOTTOM, HD, 56), (0,defineProperty/* default */.Z)(sidenav_style_LOGO_MARGIN_BOTTOM, FULL_HD, 96), sidenav_style_LOGO_MARGIN_BOTTOM);
var sidenav_sidenav_style_PADDING_TOP = (sidenav_style_PADDING_TOP = {}, (0,defineProperty/* default */.Z)(sidenav_style_PADDING_TOP, HD, 40), (0,defineProperty/* default */.Z)(sidenav_style_PADDING_TOP, FULL_HD, 56), sidenav_style_PADDING_TOP);
var ITEM_GAP = (_ITEM_GAP = {}, (0,defineProperty/* default */.Z)(_ITEM_GAP, HD, 24), (0,defineProperty/* default */.Z)(_ITEM_GAP, FULL_HD, 36), _ITEM_GAP);
var sidenav_sidenav_style_PADDING_BOTTOM = (sidenav_style_PADDING_BOTTOM = {}, (0,defineProperty/* default */.Z)(sidenav_style_PADDING_BOTTOM, HD, safetyMargins.vertical[HD]), (0,defineProperty/* default */.Z)(sidenav_style_PADDING_BOTTOM, FULL_HD, safetyMargins.vertical[FULL_HD]), sidenav_style_PADDING_BOTTOM);
var sidenav_sidenav_style_PADDING_LEFT = (sidenav_style_PADDING_LEFT = {}, (0,defineProperty/* default */.Z)(sidenav_style_PADDING_LEFT, HD, safetyMargins.horizontal[HD]), (0,defineProperty/* default */.Z)(sidenav_style_PADDING_LEFT, FULL_HD, safetyMargins.horizontal[FULL_HD]), sidenav_style_PADDING_LEFT);
var MINI_PLAYER_MARGIN = (_MINI_PLAYER_MARGIN = {}, (0,defineProperty/* default */.Z)(_MINI_PLAYER_MARGIN, HD, 16), (0,defineProperty/* default */.Z)(_MINI_PLAYER_MARGIN, FULL_HD, 24), _MINI_PLAYER_MARGIN);
var sidenav_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sidenav_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  return {
    alpha: 0,
    color: sidenav_style_colors.background[colorMode],
    w: WIDTH[screenSize],
    h: sizes_SCREEN_HEIGHT[screenSize],
    Gradient: {
      alpha: 0,
      x: EXPANDED_WIDTH[screenSize] / 2,
      rect: true,
      w: SCREEN_WIDTH[screenSize] - EXPANDED_WIDTH[screenSize],
      h: sizes_SCREEN_HEIGHT[screenSize],
      colorLeft: sidenav_style_colors.overlay[colorMode],
      colorRight: sidenav_style_colors.empty[colorMode]
    },
    Items: {
      w: WIDTH[screenSize],
      h: sizes_SCREEN_HEIGHT[screenSize]
    },
    Border: {
      x: EXPANDED_WIDTH[screenSize] - 1,
      alpha: 0,
      w: 1,
      h: sizes_SCREEN_HEIGHT[screenSize],
      color: sidenav_style_colors.border[colorMode]
    },
    Logo: {
      alpha: 0,
      x: sidenav_sidenav_style_PADDING_LEFT[screenSize],
      y: sidenav_sidenav_style_PADDING_TOP[screenSize]
    },
    MiniPlayerWrapper: {
      mountY: 1,
      y: sizes_SCREEN_HEIGHT[screenSize] - safetyMargins.vertical[screenSize],
      w: function w(value) {
        return value - MINI_PLAYER_MARGIN[screenSize] * 2;
      },
      h: miniPlayer_miniPlayer_style_HEIGHT[screenSize],
      MiniPlayer: {
        x: MINI_PLAYER_MARGIN[screenSize],
        w: identity
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/sidenav/sidenavLogo/sidenavLogo.utils.js

var sidenavLogo_utils_getLogoViewBox = function getLogoViewBox(screenSize) {
  return getMainIconViewBox(screenSize);
};

;// CONCATENATED MODULE: ./src/modules/sidenav/sidenavLogo/sidenavLogo.constants.js

;// CONCATENATED MODULE: ./src/modules/sidenav/sidenavLogo/customer/rtlde/sidenavLogo.constants.js

var MIN_INDEX = 1;
var MAX_INDEX = 12;
var UPDATE_TIMEOUT_MS = 300;
;// CONCATENATED MODULE: ./src/modules/sidenav/sidenavLogo/customer/rtlde/sidenavLogo.component.js





function sidenavLogo_component_createSuper(t) { var r = sidenavLogo_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function sidenavLogo_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (sidenavLogo_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }







var SidenavLogo = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(SidenavLogo, _Lightning$Component);
  var _super = sidenavLogo_component_createSuper(SidenavLogo);
  function SidenavLogo() {
    (0,classCallCheck/* default */.Z)(this, SidenavLogo);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(SidenavLogo, [{
    key: "_construct",
    value: function _construct() {
      this._style = {
        screenSize: sizes_getScreenSize()
      };
    }
  }, {
    key: "_attach",
    value: function _attach() {
      var _this = this;
      this._unsubscribe = sidenavLogo_connect(this);
      this.tag('Icon').on('txLoaded', function () {
        var icon = _this.tag('Icon');
        _this.patch({
          w: icon.finalW,
          h: icon.finalH
        });
      });
    }
  }, {
    key: "_detach",
    value: function _detach() {
      if (this._unsubscribe) {
        this._unsubscribe();
        this._unsubscribe = null;
      }
      clearTimeout(this._logoUpdateTimeout);
      this.tag('Icon').removeAllListeners('txLoaded');
    }
  }, {
    key: "updateLogo",
    value: function updateLogo() {
      var _this2 = this;
      this._logoUpdateTimeout = setTimeout(function () {
        _this2.tag('Icon').iconData = {
          picto: {
            type: ICON_TYPE.SERVICE_ICON,
            name: "rtlplus_root_alternate_".concat(MIN_INDEX + Math.floor(Math.random() * MAX_INDEX))
          },
          scale: LOGO_ICON_SCALE,
          viewBox: sidenavLogo_utils_getLogoViewBox(_this2._style.screenSize)
        };
      }, UPDATE_TIMEOUT_MS);
    }
  }], [{
    key: "_template",
    value: function _template() {
      return {
        Icon: {
          type: Icon
        }
      };
    }
  }]);
  return SidenavLogo;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/sidenav/sidenavLogo/sidenavLogo.component.js

;// CONCATENATED MODULE: ./src/modules/sidenav/sidenav.connect.js




var sidenav_connect_mapControllers = function mapControllers(instance) {
  return {
    currentRoute: {
      selector: getCurrentRoute,
      callback: function callback(value) {
        instance.currentRoute = value;
      }
    },
    isNavigationAllowed: {
      selector: isNavigationAllowed,
      callback: function callback(value) {
        instance.isActive = value;
      }
    },
    navigation: {
      selector: getLayoutNavigation,
      callback: function callback(value) {
        instance.navigation = value;
      }
    },
    section: {
      selector: getNavigationSection,
      callback: function callback(value) {
        instance.section = value;
      }
    },
    isAppInitialized: {
      selector: isAppInitialized,
      callback: function callback(value) {
        instance.couldRequestNavigationLayout = value;
      }
    }
  };
};
/* harmony default export */ const sidenav_connect = (lightningjs_redux.control(sidenav_connect_mapControllers));
;// CONCATENATED MODULE: ./src/modules/sidenav/sidenav.utils.js







var actionToPath = function actionToPath(item) {
  var type = getItemActionType(item);
  var targetData = getTargetData(item);
  var id = targetData.id;
  switch (type) {
    case cta_constants.BOOKMARKS:
      return BOOKMARKS_PATH;
    case cta_constants.BOOKMARK:
      return '';
    case cta_constants.UNBOOKMARK:
      return '';
    case cta_constants.CLOSE:
      return HOME_PATH;
    case cta_constants.FOLDER:
      return "".concat(FOLDER_PATH, "/").concat(id);
    case cta_constants.FOLDERS:
      return FOLDERS_PATH;
    case cta_constants.FRONTSPACE:
      return "".concat(FRONTSPACE_PATH, "/").concat(id);
    case cta_constants.HOME_ALIAS:
      return HOME_PATH;
    case cta_constants.INFORMATION:
      return INFORMATION_PATH;
    case cta_constants.USAGE_TERMS:
      return USAGE_TERMS_PATH;
    case cta_constants.SUBSCRIPTION_TERMS:
      return SUBSCRIPTION_TERMS_PATH;
    case cta_constants.LEGAL_CONDITIONS:
      return LEGAL_CONDITIONS_PATH;
    case cta_constants.LIVE:
      return '';
    case cta_constants.LIVES:
      return LIVES_PATH;
    case cta_constants.LOCK:
      return '';
    case cta_constants.LOGOUT:
      return '';
    case cta_constants.OPTOUT:
      return SETTINGS_PATH;
    case cta_constants.PROFILE:
      return PROFILE_PATH;
    case cta_constants.PROGRAM:
      return PROGRAM_PATH;
    case cta_constants.SEARCH:
      return SEARCH_PATH;
    case cta_constants.SERVICE:
      return "".concat(SERVICE_PATH, "/").concat(id);
    case cta_constants.SERVICES:
      return SERVICES_PATH;
    case cta_constants.VIDEO:
      return VIDEO_PATH;
    case cta_constants.HELP:
      return '';
    default:
      break;
  }
  return '';
};
var isSameNavigationItem = function isSameNavigationItem(a, b) {
  if (!a || !b || !a.entry || !b.entry) {
    return false;
  }
  if (a.entry.id !== b.entry.id) {
    return false;
  }
  if (a.entry.image) {
    if (!b.entry.image) {
      return false;
    }
    if (a.image.id !== b.image.id) {
      return false;
    }
  } else if (b.entry.image) {
    return false;
  }
  if (a.subentries) {
    if (!b.subentries) {
      return false;
    }
    if (a.subentries.length !== b.subentries.length) {
      return false;
    }
    for (var i = 0; i < a.subentries.length; i += 1) {
      if (a.subentries[i].id !== b.subentries[i].id) {
        return false;
      }
    }
  } else if (b.subentries) {
    return false;
  }
  return true;
};
var isSameNavigation = function isSameNavigation(a, b) {
  if (!a || !b || !a.entries || !b.entries) {
    return false;
  }
  if (a.entries.length !== b.entries.length) {
    return false;
  }
  for (var i = 0; i < a.entries.length; i += 1) {
    if (!isSameNavigationItem(a.entries[i], b.entries[i])) {
      return false;
    }
  }
  return true;
};
;// CONCATENATED MODULE: ./src/modules/sidenav/sidenav.component.js














function sidenav_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function sidenav_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? sidenav_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : sidenav_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function sidenav_component_createSuper(t) { var r = sidenav_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function sidenav_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (sidenav_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
















var Sidenav = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Sidenav, _Lightning$Component);
  var _super = sidenav_component_createSuper(Sidenav);
  function Sidenav() {
    (0,classCallCheck/* default */.Z)(this, Sidenav);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Sidenav, [{
    key: "_construct",
    value: function _construct() {
      this._isActive = false;
      this._section = null;
      this._navigation = null;
      this._isMiniPlayerFocused = false;
      this._index = 0;
      this._itemsCount = 0;
      this._currentRoute = '';
      this._currentPaths = [];
      this._currentSections = [];
      this._style = sidenav_style_defaultContext;
    }
  }, {
    key: "_attach",
    value: function _attach() {
      this._unsubscribe = sidenav_connect(this);
    }
  }, {
    key: "_active",
    value: function _active() {
      var screenSize = this._style.screenSize;
      var w = WIDTH[screenSize];
      this.tag('MiniPlayer').close(w - MINI_PLAYER_MARGIN[screenSize] * 2);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      if (this._unsubscribe) {
        this._unsubscribe();
        this._unsubscribe = null;
      }
      this._isMiniPlayerFocused = false;
    }
  }, {
    key: "isActive",
    get: function get() {
      return this._isActive;
    },
    set: function set(value) {
      if (this._isActive !== value) {
        this.alpha = value ? 1 : 0;
        this._isActive = value;
      }
    }
  }, {
    key: "couldRequestNavigationLayout",
    set: function set(value) {
      this._couldRequestNavigationLayout = value;
      if (this._couldRequestNavigationLayout && this._section) {
        this.logoSection = this._section;
      }
    }
  }, {
    key: "section",
    set: function set(value) {
      if (this._section !== value) {
        this._navigation = null;
        this._doTheThing();
        this.logoSection = value;
        this._section = value;
      }
    }
  }, {
    key: "logoSection",
    set: function set(value) {
      this.tag('Logo').section = value;
    }
  }, {
    key: "colorMode",
    get: function get() {
      return this._style.colorMode;
    },
    set: function set(value) {
      this._style = sidenav_component_objectSpread(sidenav_component_objectSpread({}, this._style), {}, {
        colorMode: value
      });
      this.patch({
        color: sidenav_style_colors.background[this._style.colorMode]
      });
    }
  }, {
    key: "navigation",
    get: function get() {
      return this._navigation;
    },
    set: function set(value) {
      if (!isSameNavigation(this._navigation, value)) {
        this._navigation = value;
        this._doTheThing();
      }
    }
  }, {
    key: "_doTheThing",
    value: function _doTheThing() {
      var _this = this;
      if (this._navigation && this._navigation.entries) {
        var screenSize = this._style.screenSize;
        var entries = this._navigation.entries;
        var itemHeight = sidenavItem_sidenavItem_style_HEIGHT[screenSize];
        var contentGap = rtlde_sidenav_constants_CONTENT_GAP[screenSize];
        var itemGap = ITEM_GAP[screenSize];
        this._itemsCount = entries.map(function (entry) {
          return entry.length;
        }).reduce(function (a, b) {
          return a + b;
        }, 0);
        var groupCount = 0;
        var gap = 0;
        this.tag('Items').children = entries.flatMap(function (group) {
          _this._setIndex(Math.min(Math.max(_this._index, 0), _this._itemsCount - 1));
          _this._currentPaths = group.map(function (_ref) {
            var entry = _ref.entry;
            return actionToPath({
              action: entry
            });
          });
          _this._currentSections = group.map(function (_ref2) {
            var entry = _ref2.entry;
            return getSectionCode({
              action: entry
            });
          });
          var itemOffset = itemHeight + contentGap;
          var itemsSize = itemOffset * _this._itemsCount - contentGap;
          var offset = Math.round((_this.finalH - itemsSize) / 2);
          var children = group.map(function (_ref3, index) {
            var entry = _ref3.entry;
            return {
              type: SidenavItem,
              w: WIDTH[screenSize],
              y: offset + (index + groupCount) * itemOffset + gap,
              ref: "SidenavItem".concat(index),
              item: {
                label: entry.label,
                content: entry
              },
              actionPath: _this._currentPaths[index],
              actionSection: _this._currentSections[index],
              expanded: Boolean(_this._isFocused)
            };
          });
          groupCount += group.length;
          gap += itemGap;
          return children;
        });
      } else {
        this.tag('Items').children = [];
      }
      this._updateSideNav();
    }
  }, {
    key: "currentRoute",
    set: function set(value) {
      this._currentRoute = value;
      this._updateSideNav();
    }
  }, {
    key: "isItemSelected",
    value: function isItemSelected(item) {
      if (item.actionSection !== this._section) {
        return false;
      }
      if (item.actionPath === this._currentRoute) {
        return true;
      }
      if (DEFAULT_SERVICE && this._currentRoute === "app/service/".concat(DEFAULT_SERVICE)) {
        return item.actionPath === HOME_PATH;
      }
      return false;
    }
  }, {
    key: "_updateSideNav",
    value: function _updateSideNav() {
      var _this2 = this;
      this.tag('Items').children.forEach(function (item, index) {
        var isSelected = _this2.isItemSelected(item);
        item.isSelected = isSelected;
        _this2._index = isSelected ? index : _this2._index;
      });
    }
  }, {
    key: "_setIndex",
    value: function _setIndex() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._index;
      this._index = index;
    }
  }, {
    key: "_focus",
    value: function _focus() {
      var screenSize = this._style.screenSize;
      var w = EXPANDED_WIDTH[screenSize];
      this.setSmooth('w', w, animationConfig);
      this._setIndex();
      this.tag('Items').children.forEach(function (child) {
        child.expanded = true;
      });
      this.tag('Logo').setSmooth('alpha', 1);
      this.tag('Border').setSmooth('alpha', 1, {
        delay: 0.15,
        duration: 0.2
      });
      this.tag('Gradient').setSmooth('alpha', 1, animationConfig);
      this.tag('MiniPlayer').open(w - MINI_PLAYER_MARGIN[screenSize] * 2);
      this._isFocused = true;
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      var _this3 = this;
      var screenSize = this._style.screenSize;
      var w = WIDTH[screenSize];
      this.setSmooth('w', w, animationConfig);
      this.tag('Items').children.forEach(function (child, index) {
        child.expanded = false;
        if (_this3.isItemSelected(child)) {
          _this3._index = index;
        }
      });
      this.tag('Logo').setSmooth('alpha', 0);
      this.tag('Border').setSmooth('alpha', 0, {
        duration: 0.2
      });
      this.tag('Gradient').setSmooth('alpha', 0, animationConfig);
      this.tag('MiniPlayer').close(w - MINI_PLAYER_MARGIN[screenSize] * 2);
      this._isMiniPlayerFocused = false;
      this._isFocused = false;
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this._isMiniPlayerFocused ? this.tag('MiniPlayer') : this.tag('Items').children[this._index];
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      if (!this._navigation || !this._navigation.entries) {
        return false;
      }
      var itemToAction = this._navigation.entries.flatMap(function (entry) {
        return entry;
      })[this._index].entry;
      var itemType = get_default()(itemToAction, 'target.type', '');
      lightningjs_redux.dispatch(createItemAction({
        item: {
          action: itemToAction
        }
      }));
      if (itemType !== 'lock') {
        this._returnToPage();
      }
      return true;
    }
  }, {
    key: "_handleUp",
    value: function _handleUp() {
      if (this._isMiniPlayerFocused) {
        this._isMiniPlayerFocused = false;
        return true;
      }
      if (this._index > 0) {
        this._setIndex(this._index - 1);
        return true;
      }
      return false;
    }
  }, {
    key: "_handleDown",
    value: function _handleDown() {
      if (this._index < this._itemsCount - 1) {
        this._setIndex(this._index + 1);
        return true;
      }
      if (!this._isMiniPlayerFocused && this.tag('MiniPlayer').isActive) {
        this._isMiniPlayerFocused = true;
      }
      return false;
    }
  }, {
    key: "_hideMiniPlayer",
    value: function _hideMiniPlayer() {
      this._isMiniPlayerFocused = false;
      this._refocus();
    }
  }, {
    key: "_handleRight",
    value: function _handleRight() {
      return false;
    }
  }, {
    key: "_handleBack",
    value: function _handleBack() {
      this._returnToPage();
      return true;
    }
  }, {
    key: "_returnToPage",
    value: function _returnToPage() {
      Router.focusPage();
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        rect: true,
        Gradient: {},
        Items: {},
        Border: {
          rect: true
        },
        Logo: {
          type: SidenavLogo
        },
        MiniPlayerWrapper: {
          MiniPlayer: {
            type: MiniPlayer,
            signals: (0,defineProperty/* default */.Z)({}, HIDE_SIGNAL, '_hideMiniPlayer')
          }
        }
      }, sidenav_style_getInitialStyle());
    }
  }]);
  return Sidenav;
}(src_Lightning.Component);

;// CONCATENATED MODULE: ./src/modules/app/platform/default/app.style.js

function app_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function app_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? app_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : app_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }




var app_style_defaultContext = makeDefaultStylingContext();
var app_style_WIDTH = app_style_objectSpread({}, SCREEN_WIDTH);
var app_style_HEIGHT = app_style_objectSpread({}, sizes_SCREEN_HEIGHT);
var app_style_colors = {
  background: makeThemeColor(TERTIARY),
  transparent: colors_TRANSPARENT
};
var app_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : app_style_defaultContext;
  var screenSize = context.screenSize;
  return {
    color: app_style_colors.transparent,
    w: app_style_WIDTH[screenSize],
    h: app_style_HEIGHT[screenSize],
    Widgets: {
      SnackBar: {
        w: app_style_WIDTH[screenSize],
        y: app_style_HEIGHT[screenSize],
        mountY: 1
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/logic/gdprNotice/gdprNotice.selectors.js

var getGdprNoticeVisibility = function getGdprNoticeVisibility(state) {
  return get_default()(state, 'gdpr.isGdprNoticeVisible');
};
var getGdprNoticeDuration = function getGdprNoticeDuration(state) {
  return _get(state, 'gdpr.gdprNoticeDuration');
};
;// CONCATENATED MODULE: ./src/logic/popup/popup.selectors.js

var getPopupData = function getPopupData(state) {
  return get_default()(state, 'popup.popupData');
};
;// CONCATENATED MODULE: ./src/modules/app/platform/default/app.connector.js






var app_connector_mapControllers = function mapControllers(instance) {
  return {
    promptBeforeExitFeature: {
      selector: getPromptBeforeExitFeature,
      callback: function callback(value) {
        instance.promptBeforeExitFeature = value;
      }
    },
    gdprNoticeVisibility: {
      selector: getGdprNoticeVisibility,
      callback: function callback(value) {
        instance.shouldDisplayCookieConsent = value;
      }
    },
    showPopup: {
      selector: getPopupData,
      callback: function callback(value) {
        instance.popUp = value;
      }
    },
    isAppInitialized: {
      selector: isAppInitialized,
      shouldBeInvokedOnConnect: true,
      callback: function callback(value) {
        instance.isAppInitialized = value;
      }
    },
    isOpenedViaDeeplink: {
      selector: isOpenedViaDeeplink,
      shouldBeInvokedOnConnect: true,
      callback: function callback(value) {
        instance.isOpenedViaDeeplink = value;
      }
    },
    currentRoute: {
      selector: getCurrentRoute,
      callback: function callback(value) {
        instance.currentRoute = value;
      }
    }
  };
};
/* harmony default export */ const app_connector = (lightningjs_redux.control(app_connector_mapControllers));
;// CONCATENATED MODULE: ./src/modules/popupContainer/popupContainer.style.js


var popupContainer_style_defaultContext = makeDefaultStylingContext();
var popupContainer_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : popupContainer_style_defaultContext;
  var screenSize = context.screenSize;
  return {
    alpha: 0,
    w: SCREEN_WIDTH[screenSize],
    h: sizes_SCREEN_HEIGHT[screenSize]
  };
};
;// CONCATENATED MODULE: ./src/modules/popups/commonPopup/commonPopup.style.js

var commonPopup_style_CONTENT_SIDE_MARGIN, _DESCRIPTION_TOP_MARG, _BUTTONS_TOP_MARGIN, commonPopup_style_LOGO_HEIGHT, _LOGO_OFFSET_TOP;
function commonPopup_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function commonPopup_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? commonPopup_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : commonPopup_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






var commonPopup_style_defaultContext = makeDefaultStylingContext();
var commonPopup_commonPopup_style_CONTENT_SIDE_MARGIN = (commonPopup_style_CONTENT_SIDE_MARGIN = {}, (0,defineProperty/* default */.Z)(commonPopup_style_CONTENT_SIDE_MARGIN, HD, 320), (0,defineProperty/* default */.Z)(commonPopup_style_CONTENT_SIDE_MARGIN, FULL_HD, 480), commonPopup_style_CONTENT_SIDE_MARGIN);
var DESCRIPTION_TOP_MARGIN = (_DESCRIPTION_TOP_MARG = {}, (0,defineProperty/* default */.Z)(_DESCRIPTION_TOP_MARG, HD, 8), (0,defineProperty/* default */.Z)(_DESCRIPTION_TOP_MARG, FULL_HD, 16), _DESCRIPTION_TOP_MARG);
var BUTTONS_TOP_MARGIN = (_BUTTONS_TOP_MARGIN = {}, (0,defineProperty/* default */.Z)(_BUTTONS_TOP_MARGIN, HD, 24), (0,defineProperty/* default */.Z)(_BUTTONS_TOP_MARGIN, FULL_HD, 32), _BUTTONS_TOP_MARGIN);
var commonPopup_commonPopup_style_LOGO_HEIGHT = (commonPopup_style_LOGO_HEIGHT = {}, (0,defineProperty/* default */.Z)(commonPopup_style_LOGO_HEIGHT, HD, 40), (0,defineProperty/* default */.Z)(commonPopup_style_LOGO_HEIGHT, FULL_HD, 56), commonPopup_style_LOGO_HEIGHT);
var LOGO_OFFSET_TOP = (_LOGO_OFFSET_TOP = {}, (0,defineProperty/* default */.Z)(_LOGO_OFFSET_TOP, HD, 40), (0,defineProperty/* default */.Z)(_LOGO_OFFSET_TOP, FULL_HD, 56), _LOGO_OFFSET_TOP);
var commonPopup_style_colors = {
  background: makeThemeColor(TERTIARY)
};
var commonPopup_style_getInitialStyle = memoize_default()(function () {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : commonPopup_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  var titleFont = src_getFont(constants_FONT.KINSHASA_3, screenSize);
  var descriptionFont = src_getFont(constants_FONT.OTTAWA_2, screenSize);
  var wordWrapWidth = SCREEN_WIDTH[screenSize] - commonPopup_commonPopup_style_CONTENT_SIDE_MARGIN[screenSize] * 2;
  return {
    rect: true,
    color: commonPopup_style_colors.background[colorMode],
    h: sizes_SCREEN_HEIGHT[screenSize],
    w: SCREEN_WIDTH[screenSize],
    Icon: {
      x: middle,
      y: LOGO_OFFSET_TOP[screenSize],
      mountX: 0.5,
      textureScale: 1.5,
      h: commonPopup_commonPopup_style_LOGO_HEIGHT[screenSize]
    },
    FlexContainer: {
      x: middle,
      y: middle,
      mountY: 0.5,
      flex: {
        direction: 'column',
        justifyContent: 'center'
      },
      Title: {
        mountX: 0.5,
        text: commonPopup_style_objectSpread({
          textAlign: 'center',
          wordWrapWidth: wordWrapWidth,
          maxLines: 5,
          maxLinesSuffix: '...'
        }, titleFont)
      },
      Description: {
        flexItem: {
          marginTop: DESCRIPTION_TOP_MARGIN[screenSize]
        },
        mountX: 0.5,
        text: commonPopup_style_objectSpread({
          textAlign: 'center',
          wordWrapWidth: wordWrapWidth
        }, descriptionFont)
      },
      OkButton: {
        flexItem: {
          marginTop: BUTTONS_TOP_MARGIN[screenSize]
        },
        mountX: 0.5,
        colorMode: colorMode
      }
    }
  };
});
;// CONCATENATED MODULE: ./src/modules/popups/abstractPopup/abstractPopup.component.js





function abstractPopup_component_createSuper(t) { var r = abstractPopup_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function abstractPopup_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (abstractPopup_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }


var AbstractPopup = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(AbstractPopup, _Lightning$Component);
  var _super = abstractPopup_component_createSuper(AbstractPopup);
  function AbstractPopup() {
    (0,classCallCheck/* default */.Z)(this, AbstractPopup);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(AbstractPopup, [{
    key: "_handleBack",
    value: function _handleBack() {
      this.signal(this._getCloseActionSignal());
      return true;
    }
  }, {
    key: "_getCloseActionSignal",
    value: function _getCloseActionSignal() {
      if (this._checkHistoryAvailable()) {
        return ROUTE_BACK_SIGNAL;
      }
      if (this._exitAppOnClose) {
        return EXIT_APP_SIGNAL;
      }
      return HIDE_POPUP_SIGNAL;
    }
  }, {
    key: "_checkHistoryAvailable",
    value: function _checkHistoryAvailable() {
      return this._routeBackOnClose && Router.getHistory().length > 0;
    }
  }, {
    key: "routeBackOnClose",
    get: function get() {
      return this._routeBackOnClose;
    },
    set: function set(value) {
      this._routeBackOnClose = value;
    }
  }, {
    key: "exitAppOnClose",
    set: function set(value) {
      this._exitAppOnClose = value;
    }
  }]);
  return AbstractPopup;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/popups/commonPopup/commonPopup.component.js






function commonPopup_component_createSuper(t) { var r = commonPopup_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function commonPopup_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (commonPopup_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }







var CommonPopup = function (_AbstractPopup) {
  (0,inherits/* default */.Z)(CommonPopup, _AbstractPopup);
  var _super = commonPopup_component_createSuper(CommonPopup);
  function CommonPopup() {
    (0,classCallCheck/* default */.Z)(this, CommonPopup);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(CommonPopup, [{
    key: "_active",
    value: function _active() {
      this.tag('OkButton').label = this._getCloseButtonCaption();
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this.tag('OkButton');
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      this.signal(this._getCloseActionSignal());
      return true;
    }
  }, {
    key: "_getCloseButtonCaption",
    value: function _getCloseButtonCaption() {
      switch (this._getCloseActionSignal()) {
        case EXIT_APP_SIGNAL:
          return t('global.quit');
        case ROUTE_BACK_SIGNAL:
        default:
          return t('global.back');
      }
    }
  }, {
    key: "title",
    set: function set(value) {
      this.tag('Title').text.text = t(value);
    }
  }, {
    key: "message",
    set: function set(value) {
      this.tag('Description').text.text = value;
    }
  }], [{
    key: "_template",
    value: function _template() {
      var _passSignals;
      return merge_default()(commonPopup_style_getInitialStyle(), {
        Icon: {
          type: BrandIcon
        },
        FlexContainer: {
          Title: {
            text: {
              text: t('error.general')
            }
          },
          OkButton: {
            type: Button,
            label: t('global.ok')
          }
        },
        passSignals: (_passSignals = {}, (0,defineProperty/* default */.Z)(_passSignals, HIDE_POPUP_SIGNAL, true), (0,defineProperty/* default */.Z)(_passSignals, ROUTE_BACK_SIGNAL, true), (0,defineProperty/* default */.Z)(_passSignals, EXIT_APP_SIGNAL, true), _passSignals)
      });
    }
  }]);
  return CommonPopup;
}(AbstractPopup);
;// CONCATENATED MODULE: ./src/modules/popups/ageGatePopup/ageGatePopup.style.js

var ageGatePopup_style_CONTENT_SIDE_MARGIN, _TITLE_TOP_MARGIN, ageGatePopup_style_DESCRIPTION_TOP_MARG, ageGatePopup_style_BUTTONS_MARGIN, ageGatePopup_style_BUTTONS_TOP_MARGIN, ageGatePopup_style_WIDTH, ageGatePopup_style_HEIGHT;
function ageGatePopup_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ageGatePopup_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ageGatePopup_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ageGatePopup_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }







var ageGatePopup_style_defaultContext = makeDefaultStylingContext();
var ageGatePopup_ageGatePopup_style_CONTENT_SIDE_MARGIN = (ageGatePopup_style_CONTENT_SIDE_MARGIN = {}, (0,defineProperty/* default */.Z)(ageGatePopup_style_CONTENT_SIDE_MARGIN, HD, 320), (0,defineProperty/* default */.Z)(ageGatePopup_style_CONTENT_SIDE_MARGIN, FULL_HD, 480), ageGatePopup_style_CONTENT_SIDE_MARGIN);
var TITLE_TOP_MARGIN = (_TITLE_TOP_MARGIN = {}, (0,defineProperty/* default */.Z)(_TITLE_TOP_MARGIN, HD, 16), (0,defineProperty/* default */.Z)(_TITLE_TOP_MARGIN, FULL_HD, 24), _TITLE_TOP_MARGIN);
var ageGatePopup_style_DESCRIPTION_TOP_MARGIN = (ageGatePopup_style_DESCRIPTION_TOP_MARG = {}, (0,defineProperty/* default */.Z)(ageGatePopup_style_DESCRIPTION_TOP_MARG, HD, 8), (0,defineProperty/* default */.Z)(ageGatePopup_style_DESCRIPTION_TOP_MARG, FULL_HD, 16), ageGatePopup_style_DESCRIPTION_TOP_MARG);
var ageGatePopup_ageGatePopup_style_BUTTONS_MARGIN = (ageGatePopup_style_BUTTONS_MARGIN = {}, (0,defineProperty/* default */.Z)(ageGatePopup_style_BUTTONS_MARGIN, HD, 8), (0,defineProperty/* default */.Z)(ageGatePopup_style_BUTTONS_MARGIN, FULL_HD, 12), ageGatePopup_style_BUTTONS_MARGIN);
var ageGatePopup_ageGatePopup_style_BUTTONS_TOP_MARGIN = (ageGatePopup_style_BUTTONS_TOP_MARGIN = {}, (0,defineProperty/* default */.Z)(ageGatePopup_style_BUTTONS_TOP_MARGIN, HD, 24), (0,defineProperty/* default */.Z)(ageGatePopup_style_BUTTONS_TOP_MARGIN, FULL_HD, 32), ageGatePopup_style_BUTTONS_TOP_MARGIN);
var ageGatePopup_style_ICON_SIZE = {
  WIDTH: (ageGatePopup_style_WIDTH = {}, (0,defineProperty/* default */.Z)(ageGatePopup_style_WIDTH, HD, 60), (0,defineProperty/* default */.Z)(ageGatePopup_style_WIDTH, FULL_HD, 72), ageGatePopup_style_WIDTH),
  HEIGHT: (ageGatePopup_style_HEIGHT = {}, (0,defineProperty/* default */.Z)(ageGatePopup_style_HEIGHT, HD, 60), (0,defineProperty/* default */.Z)(ageGatePopup_style_HEIGHT, FULL_HD, 72), ageGatePopup_style_HEIGHT)
};
var CSA18_ICON = {
  name: 'Csa18',
  type: 'icon'
};
var ageGatePopup_style_getIconViewBox = memoize_default()(function (screenSize) {
  return {
    w: ageGatePopup_style_ICON_SIZE.WIDTH[screenSize],
    h: ageGatePopup_style_ICON_SIZE.HEIGHT[screenSize]
  };
});
var ageGatePopup_style_colors = {
  background: makeThemeColor(TERTIARY),
  darkering: makeThemeColor(TERTIARY, 0.8)
};
var ageGatePopup_style_getInitialStyle = memoize_default()(function () {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ageGatePopup_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  var titleFont = src_getFont(constants_FONT.KINSHASA_3, screenSize);
  var descriptionFont = src_getFont(constants_FONT.OTTAWA_2, screenSize);
  var wordWrapWidth = SCREEN_WIDTH[screenSize] - ageGatePopup_ageGatePopup_style_CONTENT_SIDE_MARGIN[screenSize] * 2;
  return {
    rect: true,
    color: ageGatePopup_style_colors.background[colorMode],
    h: sizes_SCREEN_HEIGHT[screenSize],
    w: SCREEN_WIDTH[screenSize],
    BackgroundPoster: {
      w: identity,
      h: identity
    },
    Darkering: {
      w: identity,
      h: identity,
      rect: true,
      color: ageGatePopup_style_colors.darkering[colorMode]
    },
    FlexContainer: {
      x: middle,
      y: middle,
      mountY: 0.5,
      flex: {
        direction: 'column',
        justifyContent: 'center'
      },
      IconWrapper: {
        rect: true,
        color: colors_TRANSPARENT,
        mountX: 0.5,
        w: ageGatePopup_style_getIconViewBox(screenSize).w,
        h: ageGatePopup_style_getIconViewBox(screenSize).h,
        Icon: {
          iconData: {
            picto: CSA18_ICON,
            viewBox: ageGatePopup_style_getIconViewBox(screenSize)
          }
        }
      },
      Title: {
        flexItem: {
          marginTop: TITLE_TOP_MARGIN[screenSize]
        },
        mountX: 0.5,
        text: ageGatePopup_style_objectSpread({
          textAlign: 'center',
          wordWrapWidth: wordWrapWidth,
          maxLines: 2,
          maxLinesSuffix: '...'
        }, titleFont)
      },
      Description: {
        flexItem: {
          marginTop: ageGatePopup_style_DESCRIPTION_TOP_MARGIN[screenSize]
        },
        mountX: 0.5,
        text: ageGatePopup_style_objectSpread({
          textAlign: 'center',
          wordWrapWidth: wordWrapWidth
        }, descriptionFont)
      },
      ButtonsSection: {
        flexItem: {
          marginTop: ageGatePopup_ageGatePopup_style_BUTTONS_TOP_MARGIN[screenSize]
        },
        flex: {
          direction: 'row',
          justifyContent: 'center'
        },
        mountX: 0.5,
        CancelButton: {
          flexItem: {
            marginRight: ageGatePopup_ageGatePopup_style_BUTTONS_MARGIN[screenSize]
          },
          colorMode: colorMode
        },
        OkButton: {
          flexItem: {
            marginLeft: ageGatePopup_ageGatePopup_style_BUTTONS_MARGIN[screenSize]
          },
          colorMode: colorMode
        }
      }
    }
  };
});
;// CONCATENATED MODULE: ./src/modules/popups/ageGatePopup/ageGatePopup.component.js






function ageGatePopup_component_createSuper(t) { var r = ageGatePopup_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function ageGatePopup_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (ageGatePopup_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }













var AgeGatePopup = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(AgeGatePopup, _Lightning$Component);
  var _super = ageGatePopup_component_createSuper(AgeGatePopup);
  function AgeGatePopup() {
    (0,classCallCheck/* default */.Z)(this, AgeGatePopup);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(AgeGatePopup, [{
    key: "routeBackOnClose",
    set: function set(value) {
      this._routeBackOnClose = value;
    }
  }, {
    key: "payload",
    set: function set(value) {
      this._payload = value;
      var finalW = this.finalW,
        finalH = this.finalH;
      var item = value.item;
      this.tag('BackgroundPoster').texture = cover(imageService.getUrl(getVideoItemProgramImageId(item), finalW, finalH, {
        fit: IMAGE_FIT_SCALE_CROP,
        quality: IMAGE_QUALITY,
        format: DEFAULT_IMAGE_FORMAT
      }), finalW, finalH);
    }
  }, {
    key: "_build",
    value: function _build() {
      this._index = 0;
      this._buttons = this.tag('ButtonsSection').children;
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this._buttons[this._index];
    }
  }, {
    key: "_handleRight",
    value: function _handleRight() {
      if (this._index < this._buttons.length - 1) {
        this._setIndex(this._index + 1);
        return true;
      }
      return false;
    }
  }, {
    key: "_handleLeft",
    value: function _handleLeft() {
      if (this._index > 0) {
        this._setIndex(this._index - 1);
        return true;
      }
      return true;
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      if (this._index === 1 && this._payload) {
        this.signal(HIDE_POPUP_SIGNAL);
        lightningjs_redux.dispatch(createItemAction(this._payload));
      } else {
        this.signal(this._routeBackOnClose ? ROUTE_BACK_SIGNAL : HIDE_POPUP_SIGNAL);
      }
      return true;
    }
  }, {
    key: "_handleBack",
    value: function _handleBack() {
      this.signal(this._routeBackOnClose ? ROUTE_BACK_SIGNAL : HIDE_POPUP_SIGNAL);
      return true;
    }
  }, {
    key: "_setIndex",
    value: function _setIndex(value) {
      this._index = value;
    }
  }], [{
    key: "_template",
    value: function _template() {
      var _passSignals;
      return merge_default()(ageGatePopup_style_getInitialStyle(), {
        FlexContainer: {
          IconWrapper: {
            Icon: {
              type: Icon
            }
          },
          Title: {
            text: {
              text: t('popups.ageGate.heading')
            }
          },
          Description: {
            text: {
              text: t('popups.ageGate.body')
            }
          },
          ButtonsSection: {
            CancelButton: {
              type: Button,
              label: t('global.cancel')
            },
            OkButton: {
              type: Button,
              label: t('global.continue')
            }
          }
        },
        passSignals: (_passSignals = {}, (0,defineProperty/* default */.Z)(_passSignals, HIDE_POPUP_SIGNAL, true), (0,defineProperty/* default */.Z)(_passSignals, ROUTE_BACK_SIGNAL, true), _passSignals)
      });
    }
  }]);
  return AgeGatePopup;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/popups/geoBlockPopup/geoBlockPopup.style.js

var geoBlockPopup_style_CONTENT_SIDE_MARGIN, geoBlockPopup_style_DESCRIPTION_TOP_MARG, geoBlockPopup_style_BUTTONS_TOP_MARGIN, geoBlockPopup_style_LOGO_HEIGHT;
function geoBlockPopup_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function geoBlockPopup_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? geoBlockPopup_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : geoBlockPopup_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






var geoBlockPopup_style_defaultContext = makeDefaultStylingContext();
var geoBlockPopup_geoBlockPopup_style_CONTENT_SIDE_MARGIN = (geoBlockPopup_style_CONTENT_SIDE_MARGIN = {}, (0,defineProperty/* default */.Z)(geoBlockPopup_style_CONTENT_SIDE_MARGIN, HD, 320), (0,defineProperty/* default */.Z)(geoBlockPopup_style_CONTENT_SIDE_MARGIN, FULL_HD, 480), geoBlockPopup_style_CONTENT_SIDE_MARGIN);
var geoBlockPopup_style_DESCRIPTION_TOP_MARGIN = (geoBlockPopup_style_DESCRIPTION_TOP_MARG = {}, (0,defineProperty/* default */.Z)(geoBlockPopup_style_DESCRIPTION_TOP_MARG, HD, 8), (0,defineProperty/* default */.Z)(geoBlockPopup_style_DESCRIPTION_TOP_MARG, FULL_HD, 16), geoBlockPopup_style_DESCRIPTION_TOP_MARG);
var geoBlockPopup_geoBlockPopup_style_BUTTONS_TOP_MARGIN = (geoBlockPopup_style_BUTTONS_TOP_MARGIN = {}, (0,defineProperty/* default */.Z)(geoBlockPopup_style_BUTTONS_TOP_MARGIN, HD, 40), (0,defineProperty/* default */.Z)(geoBlockPopup_style_BUTTONS_TOP_MARGIN, FULL_HD, 40), geoBlockPopup_style_BUTTONS_TOP_MARGIN);
var geoBlockPopup_geoBlockPopup_style_LOGO_HEIGHT = (geoBlockPopup_style_LOGO_HEIGHT = {}, (0,defineProperty/* default */.Z)(geoBlockPopup_style_LOGO_HEIGHT, HD, 56), (0,defineProperty/* default */.Z)(geoBlockPopup_style_LOGO_HEIGHT, FULL_HD, 96), geoBlockPopup_style_LOGO_HEIGHT);
var geoBlockPopup_style_colors = {
  background: makeThemeColor(TERTIARY)
};
var geoBlockPopup_style_getInitialStyle = memoize_default()(function () {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : geoBlockPopup_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  var descriptionFont = src_getFont(constants_FONT.OTTAWA_2, screenSize);
  var wordWrapWidth = SCREEN_WIDTH[screenSize] - geoBlockPopup_geoBlockPopup_style_CONTENT_SIDE_MARGIN[screenSize] * 2;
  return {
    rect: true,
    color: geoBlockPopup_style_colors.background[colorMode],
    h: sizes_SCREEN_HEIGHT[screenSize],
    w: SCREEN_WIDTH[screenSize],
    FlexContainer: {
      x: middle,
      y: middle,
      mountY: 0.5,
      flex: {
        direction: 'column',
        justifyContent: 'center'
      },
      Icon: {
        mountX: 0.5,
        textureScale: 1.5,
        h: geoBlockPopup_geoBlockPopup_style_LOGO_HEIGHT[screenSize]
      },
      Description: {
        flexItem: {
          marginTop: geoBlockPopup_style_DESCRIPTION_TOP_MARGIN[screenSize]
        },
        mountX: 0.5,
        text: geoBlockPopup_style_objectSpread({
          textAlign: 'center',
          wordWrapWidth: wordWrapWidth
        }, descriptionFont)
      },
      OkButton: {
        flexItem: {
          marginTop: geoBlockPopup_geoBlockPopup_style_BUTTONS_TOP_MARGIN[screenSize]
        },
        mountX: 0.5,
        colorMode: colorMode
      }
    }
  };
});
;// CONCATENATED MODULE: ./src/modules/popups/geoBlockPopup/geoBlockPopup.component.js






function geoBlockPopup_component_createSuper(t) { var r = geoBlockPopup_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function geoBlockPopup_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (geoBlockPopup_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }







var GeoBlockPopup = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(GeoBlockPopup, _Lightning$Component);
  var _super = geoBlockPopup_component_createSuper(GeoBlockPopup);
  function GeoBlockPopup() {
    (0,classCallCheck/* default */.Z)(this, GeoBlockPopup);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(GeoBlockPopup, [{
    key: "_getFocused",
    value: function _getFocused() {
      return this.tag('OkButton');
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      return this._handleExitPopup();
    }
  }, {
    key: "_handleBack",
    value: function _handleBack() {
      return this._handleExitPopup();
    }
  }, {
    key: "_handleExitPopup",
    value: function _handleExitPopup() {
      this.signal(ROUTE_BACK_SIGNAL);
      return true;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()(geoBlockPopup_style_getInitialStyle(), {
        FlexContainer: {
          Icon: {
            type: BrandIcon
          },
          Description: {
            text: {
              text: t('layout.locks.geoBlocked.message')
            }
          },
          OkButton: {
            type: Button,
            label: t('global.close')
          }
        },
        passSignals: (0,defineProperty/* default */.Z)({}, ROUTE_BACK_SIGNAL, true)
      });
    }
  }]);
  return GeoBlockPopup;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/popups/profilesGatePopup/profilesGatePopup.component.js







function profilesGatePopup_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function profilesGatePopup_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? profilesGatePopup_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : profilesGatePopup_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function profilesGatePopup_component_createSuper(t) { var r = profilesGatePopup_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function profilesGatePopup_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (profilesGatePopup_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }





var ProfilesGatePopup = function (_ProfilesGate) {
  (0,inherits/* default */.Z)(ProfilesGatePopup, _ProfilesGate);
  var _super = profilesGatePopup_component_createSuper(ProfilesGatePopup);
  function ProfilesGatePopup() {
    (0,classCallCheck/* default */.Z)(this, ProfilesGatePopup);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(ProfilesGatePopup, [{
    key: "payload",
    set: function set(value) {
      lightningjs_redux.dispatch(checkProfileAutoSelect(value));
      this.data = value;
    }
  }, {
    key: "_handleSelected",
    value: function _handleSelected(item) {
      this.signal(HIDE_POPUP_SIGNAL);
      return lightningjs_redux.dispatch(createItemAction({
        item: item
      }));
    }
  }], [{
    key: "_template",
    value: function _template() {
      var _passSignals;
      return profilesGatePopup_component_objectSpread(profilesGatePopup_component_objectSpread({}, (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(ProfilesGatePopup), "_template", this).call(this)), {}, {
        passSignals: (_passSignals = {}, (0,defineProperty/* default */.Z)(_passSignals, HIDE_POPUP_SIGNAL, true), (0,defineProperty/* default */.Z)(_passSignals, EXIT_APP_SIGNAL, true), _passSignals)
      });
    }
  }]);
  return ProfilesGatePopup;
}(ProfilesGate);
;// CONCATENATED MODULE: ./src/modules/popups/kidsLeavePopup/kidsLeavePopup.style.js

var kidsLeavePopup_style_CONTENT_MARGIN_TOP, _CONTENT_MARGIN_LEFT, _CONTENT_WIDTH, kidsLeavePopup_style_CONTENT_HEIGHT, kidsLeavePopup_style_TITLE_HEIGHT, kidsLeavePopup_style_TITLE_WIDTH, _BUTTON_OFFSET_LEFT, _EXCEPTION_HEIGHT;
function kidsLeavePopup_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function kidsLeavePopup_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? kidsLeavePopup_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : kidsLeavePopup_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





var kidsLeavePopup_style_defaultContext = makeDefaultStylingContext();
var kidsLeavePopup_style_colors = {
  background: makeThemeColor(TERTIARY),
  title: makeThemeColor(PRIMARY),
  exception: makeThemeColor(UTILITY1)
};
var kidsLeavePopup_kidsLeavePopup_style_CONTENT_MARGIN_TOP = (kidsLeavePopup_style_CONTENT_MARGIN_TOP = {}, (0,defineProperty/* default */.Z)(kidsLeavePopup_style_CONTENT_MARGIN_TOP, HD, 144), (0,defineProperty/* default */.Z)(kidsLeavePopup_style_CONTENT_MARGIN_TOP, FULL_HD, 264), kidsLeavePopup_style_CONTENT_MARGIN_TOP);
var CONTENT_MARGIN_LEFT = (_CONTENT_MARGIN_LEFT = {}, (0,defineProperty/* default */.Z)(_CONTENT_MARGIN_LEFT, HD, 422), (0,defineProperty/* default */.Z)(_CONTENT_MARGIN_LEFT, FULL_HD, 715), _CONTENT_MARGIN_LEFT);
var kidsLeavePopup_style_CONTENT_WIDTH = (_CONTENT_WIDTH = {}, (0,defineProperty/* default */.Z)(_CONTENT_WIDTH, HD, 436), (0,defineProperty/* default */.Z)(_CONTENT_WIDTH, FULL_HD, 491), _CONTENT_WIDTH);
var kidsLeavePopup_kidsLeavePopup_style_CONTENT_HEIGHT = (kidsLeavePopup_style_CONTENT_HEIGHT = {}, (0,defineProperty/* default */.Z)(kidsLeavePopup_style_CONTENT_HEIGHT, HD, 451), (0,defineProperty/* default */.Z)(kidsLeavePopup_style_CONTENT_HEIGHT, FULL_HD, 549), kidsLeavePopup_style_CONTENT_HEIGHT);
var getContentSettings = function getContentSettings(screenSize) {
  return {
    w: kidsLeavePopup_style_CONTENT_WIDTH[screenSize],
    h: kidsLeavePopup_kidsLeavePopup_style_CONTENT_HEIGHT[screenSize],
    y: kidsLeavePopup_kidsLeavePopup_style_CONTENT_MARGIN_TOP[screenSize],
    x: CONTENT_MARGIN_LEFT[screenSize],
    flex: {
      direction: 'column',
      alignItems: 'center'
    }
  };
};
var kidsLeavePopup_kidsLeavePopup_style_TITLE_HEIGHT = (kidsLeavePopup_style_TITLE_HEIGHT = {}, (0,defineProperty/* default */.Z)(kidsLeavePopup_style_TITLE_HEIGHT, HD, 72), (0,defineProperty/* default */.Z)(kidsLeavePopup_style_TITLE_HEIGHT, FULL_HD, 96), kidsLeavePopup_style_TITLE_HEIGHT);
var kidsLeavePopup_kidsLeavePopup_style_TITLE_WIDTH = (kidsLeavePopup_style_TITLE_WIDTH = {}, (0,defineProperty/* default */.Z)(kidsLeavePopup_style_TITLE_WIDTH, HD, 436), (0,defineProperty/* default */.Z)(kidsLeavePopup_style_TITLE_WIDTH, FULL_HD, 491), kidsLeavePopup_style_TITLE_WIDTH);
var BUTTON_OFFSET_LEFT = (_BUTTON_OFFSET_LEFT = {}, (0,defineProperty/* default */.Z)(_BUTTON_OFFSET_LEFT, HD, 20), (0,defineProperty/* default */.Z)(_BUTTON_OFFSET_LEFT, FULL_HD, 70), _BUTTON_OFFSET_LEFT);
var EXCEPTION_HEIGHT = (_EXCEPTION_HEIGHT = {}, (0,defineProperty/* default */.Z)(_EXCEPTION_HEIGHT, HD, 24), (0,defineProperty/* default */.Z)(_EXCEPTION_HEIGHT, FULL_HD, 30), _EXCEPTION_HEIGHT);
var getTitleSettings = function getTitleSettings(screenSize, colorMode) {
  return {
    text: kidsLeavePopup_style_objectSpread(kidsLeavePopup_style_objectSpread({}, src_getFont(constants_FONT.KINSHASA_2, screenSize)), {}, {
      maxLines: 2,
      maxLinesSuffix: '...',
      wordWrapWidth: kidsLeavePopup_kidsLeavePopup_style_TITLE_WIDTH[screenSize],
      textAlign: 'center',
      textColor: kidsLeavePopup_style_colors.title[colorMode]
    })
  };
};
var PASSWORD_OFFSET_TOP = 32;
var EXCEPTION_OFFSET = 12;
var kidsLeavePopup_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : kidsLeavePopup_style_defaultContext,
    screenSize = _ref.screenSize,
    colorMode = _ref.colorMode;
  return {
    zIndex: 1,
    Background: {
      w: SCREEN_WIDTH[screenSize],
      h: sizes_SCREEN_HEIGHT[screenSize],
      color: kidsLeavePopup_style_colors.background[colorMode],
      alpha: 0.9
    },
    Button: {
      x: safetyMargins.horizontal[screenSize],
      y: safetyMargins.vertical[screenSize]
    },
    Content: kidsLeavePopup_style_objectSpread(kidsLeavePopup_style_objectSpread({}, getContentSettings(screenSize)), {}, {
      Title: kidsLeavePopup_style_objectSpread({}, getTitleSettings(screenSize, colorMode)),
      PasswordBlock: {
        flexItem: {
          marginTop: PASSWORD_OFFSET_TOP
        }
      },
      Exception: {
        flexItem: {
          marginTop: EXCEPTION_OFFSET
        },
        h: EXCEPTION_HEIGHT[screenSize],
        alpha: 0,
        text: kidsLeavePopup_style_objectSpread(kidsLeavePopup_style_objectSpread({}, src_getFont(constants_FONT.BERLIN_1, screenSize)), {}, {
          textColor: kidsLeavePopup_style_colors.exception[colorMode],
          verticalAlign: 'middle'
        })
      },
      Keyboard: {
        flexItem: {
          marginTop: EXCEPTION_OFFSET
        }
      }
    })
  };
};
;// CONCATENATED MODULE: ./src/modules/popups/kidsLeavePopup/password/password.style.js

var _PASSWORD_WIDTH, _TEXT_PASSWORD_HEIGHT;
function password_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function password_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? password_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : password_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }




var password_style_defaultContext = makeDefaultStylingContext();
var password_style_colors = {
  title: makeThemeColor(PRIMARY)
};
var PASSWORD_WIDTH = (_PASSWORD_WIDTH = {}, (0,defineProperty/* default */.Z)(_PASSWORD_WIDTH, HD, 436), (0,defineProperty/* default */.Z)(_PASSWORD_WIDTH, FULL_HD, 491), _PASSWORD_WIDTH);
var TEXT_PASSWORD_HEIGHT = (_TEXT_PASSWORD_HEIGHT = {}, (0,defineProperty/* default */.Z)(_TEXT_PASSWORD_HEIGHT, HD, 36), (0,defineProperty/* default */.Z)(_TEXT_PASSWORD_HEIGHT, FULL_HD, 48), _TEXT_PASSWORD_HEIGHT);
var TEXT_PASSWORD_MARGIN_BOTTOM = 24;
var password_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : password_style_defaultContext,
    screenSize = _ref.screenSize,
    colorMode = _ref.colorMode;
  return {
    flex: {
      direction: 'column',
      alignItems: 'center'
    },
    TextPassword: {
      flexItem: {
        marginBottom: TEXT_PASSWORD_MARGIN_BOTTOM
      },
      h: TEXT_PASSWORD_HEIGHT[screenSize],
      visible: false,
      text: password_style_objectSpread(password_style_objectSpread({}, src_getFont(constants_FONT.KINSHASA_1, screenSize)), {}, {
        maxLines: 1,
        maxLinesSuffix: '...',
        wordWrapWidth: PASSWORD_WIDTH[screenSize],
        textAlign: 'center',
        textColor: password_style_colors.title[colorMode],
        verticalAlign: 'middle'
      })
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/popups/kidsLeavePopup/kidsLeavePopup.constant.js
var numbersKeys = ['number_zero', 'number_one', 'number_two', 'number_three', 'number_four', 'number_five', 'number_six', 'number_seven', 'number_eight', 'number_nine'];
var passwordCharacters = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
var PASSWORD_LENGTH = 3;
;// CONCATENATED MODULE: ./src/modules/popups/kidsLeavePopup/password/password.utils.js






var getPasswordString = function getPasswordString(password) {
  if (!password || password.split('').length !== PASSWORD_LENGTH) return '';
  var passwordParts = password.split('').map(function (key) {
    return t("global.numbers.".concat(numbersKeys[+key])).toUpperCase();
  });
  return passwordParts.join(' - ');
};
;// CONCATENATED MODULE: ./src/modules/tornado/restrictedInput/restrictedInput.style.js
var FOCUSED_ITEM_ALPHA = 1;
var UNFOCUSED_ITEM_ALPHA = 0.3;
var restrictedInput_style_getInitialStyle = function getInitialStyle() {
  return {
    flex: {
      direction: 'row',
      alignItems: 'center'
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/restrictedInput/restrictedInputItem/restrictedInputItem.style.js

var restrictedInputItem_style_BORDER_WIDTH, _PASSWORD_ITEM_WIDTH, _PASSWORD_ITEM_HEIGHT, _PASSWORD_ITEM_OFFSET;
function restrictedInputItem_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function restrictedInputItem_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? restrictedInputItem_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : restrictedInputItem_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






var restrictedInputItem_style_defaultContext = makeDefaultStylingContext();
var restrictedInputItem_style_colors = {
  border: makeThemeColor(PRIMARY)
};
var restrictedInputItem_restrictedInputItem_style_BORDER_WIDTH = (restrictedInputItem_style_BORDER_WIDTH = {}, (0,defineProperty/* default */.Z)(restrictedInputItem_style_BORDER_WIDTH, HD, 2), (0,defineProperty/* default */.Z)(restrictedInputItem_style_BORDER_WIDTH, FULL_HD, 4), restrictedInputItem_style_BORDER_WIDTH);
var PASSWORD_ITEM_WIDTH = (_PASSWORD_ITEM_WIDTH = {}, (0,defineProperty/* default */.Z)(_PASSWORD_ITEM_WIDTH, HD, 74), (0,defineProperty/* default */.Z)(_PASSWORD_ITEM_WIDTH, FULL_HD, 99), _PASSWORD_ITEM_WIDTH);
var PASSWORD_ITEM_HEIGHT = (_PASSWORD_ITEM_HEIGHT = {}, (0,defineProperty/* default */.Z)(_PASSWORD_ITEM_HEIGHT, HD, 158), (0,defineProperty/* default */.Z)(_PASSWORD_ITEM_HEIGHT, FULL_HD, 195), _PASSWORD_ITEM_HEIGHT);
var PASSWORD_ITEM_OFFSET = (_PASSWORD_ITEM_OFFSET = {}, (0,defineProperty/* default */.Z)(_PASSWORD_ITEM_OFFSET, HD, 6), (0,defineProperty/* default */.Z)(_PASSWORD_ITEM_OFFSET, FULL_HD, 8), _PASSWORD_ITEM_OFFSET);
var restrictedInputItem_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : restrictedInputItem_style_defaultContext,
    screenSize = _ref.screenSize,
    colorMode = _ref.colorMode;
  return {
    w: PASSWORD_ITEM_WIDTH[screenSize],
    h: PASSWORD_ITEM_HEIGHT[screenSize],
    flexItem: {
      marginRight: PASSWORD_ITEM_OFFSET[screenSize],
      marginLeft: PASSWORD_ITEM_OFFSET[screenSize]
    },
    Border: {
      alpha: UNFOCUSED_ITEM_ALPHA,
      borderWidth: restrictedInputItem_restrictedInputItem_style_BORDER_WIDTH[screenSize],
      colorBorder: restrictedInputItem_style_colors.border[colorMode],
      w: PASSWORD_ITEM_WIDTH[screenSize],
      h: PASSWORD_ITEM_HEIGHT[screenSize]
    },
    Number: {
      mountX: 0.5,
      mountY: 0.5,
      x: middle,
      y: middle,
      text: restrictedInputItem_style_objectSpread(restrictedInputItem_style_objectSpread({}, src_getFont(constants_FONT.TOKYO_4, screenSize)), {}, {
        verticalAlign: 'middle'
      })
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/restrictedInput/restrictedInputItem/restrictedInputItem.component.js





function restrictedInputItem_component_createSuper(t) { var r = restrictedInputItem_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function restrictedInputItem_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (restrictedInputItem_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }



var RestrictedInputItem = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(RestrictedInputItem, _Lightning$Component);
  var _super = restrictedInputItem_component_createSuper(RestrictedInputItem);
  function RestrictedInputItem() {
    (0,classCallCheck/* default */.Z)(this, RestrictedInputItem);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(RestrictedInputItem, [{
    key: "borderColor",
    set: function set(color) {
      this.tag('Border').colorBorder = color.color;
      this.borderAlpha = color.opacity;
    }
  }, {
    key: "borderAlpha",
    set: function set(value) {
      this.tag('Border').alpha = value;
    }
  }, {
    key: "itemContent",
    set: function set(value) {
      if (!value) return;
      this.tag('Number').text.text = value;
    }
  }, {
    key: "clearItemContent",
    value: function clearItemContent() {
      this.tag('Number').text.text = '';
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Border: {
          type: src_Lightning.components.BorderComponent
        },
        Number: {
          text: {
            text: ''
          }
        }
      }, restrictedInputItem_style_getInitialStyle());
    }
  }]);
  return RestrictedInputItem;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/tornado/restrictedInput/restrictedInput.component.js






function restrictedInput_component_createSuper(t) { var r = restrictedInput_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function restrictedInput_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (restrictedInput_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }




var RestrictedInput = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(RestrictedInput, _Lightning$Component);
  var _super = restrictedInput_component_createSuper(RestrictedInput);
  function RestrictedInput() {
    (0,classCallCheck/* default */.Z)(this, RestrictedInput);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(RestrictedInput, [{
    key: "_init",
    value: function _init() {
      this._length = 0;
      this._currentItem = 0;
    }
  }, {
    key: "length",
    set: function set(value) {
      this._length = value;
      this._initializeInput();
    }
  }, {
    key: "borderCellColor",
    set: function set(color) {
      this.children.forEach(function (child) {
        child.borderColor = color;
      });
    }
  }, {
    key: "_initializeInput",
    value: function _initializeInput() {
      var items = [];
      for (var i = 0; i < this._length; i += 1) {
        items.push({
          type: RestrictedInputItem
        });
      }
      this.children = items;
      this.children[this._currentItem].borderAlpha = FOCUSED_ITEM_ALPHA;
    }
  }, {
    key: "updateBorder",
    value: function updateBorder() {
      var _this = this;
      this.children.forEach(function (child, index) {
        child.borderAlpha = index === _this._currentItem ? FOCUSED_ITEM_ALPHA : UNFOCUSED_ITEM_ALPHA;
      });
    }
  }, {
    key: "push",
    value: function push(value) {
      if (this._currentItem === this._length || !value) return;
      this.children[this._currentItem].itemContent = value;
      this._currentItem += 1;
      this.updateBorder();
    }
  }, {
    key: "pop",
    value: function pop() {
      this._currentItem = Math.max(this._currentItem - 1, 0);
      this.children[this._currentItem].clearItemContent();
      this.updateBorder();
    }
  }, {
    key: "clearInput",
    value: function clearInput() {
      this._currentItem = 0;
      this.children.forEach(function (inputItem) {
        inputItem.clearItemContent();
      });
      this.children[this._currentItem].borderAlpha = FOCUSED_ITEM_ALPHA;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({}, restrictedInput_style_getInitialStyle());
    }
  }]);
  return RestrictedInput;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/popups/kidsLeavePopup/password/password.component.js





function password_component_createSuper(t) { var r = password_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function password_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (password_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }






var Password = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(Password, _Lightning$Component);
  var _super = password_component_createSuper(Password);
  function Password() {
    (0,classCallCheck/* default */.Z)(this, Password);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Password, [{
    key: "_init",
    value: function _init() {
      this.tag('InputPassword').length = PASSWORD_LENGTH;
    }
  }, {
    key: "push",
    value: function push(digit) {
      this.tag('InputPassword').push(digit);
    }
  }, {
    key: "pop",
    value: function pop() {
      this.tag('InputPassword').pop();
    }
  }, {
    key: "clearPasswordInput",
    value: function clearPasswordInput() {
      this.tag('InputPassword').clearInput();
    }
  }, {
    key: "borderCellColor",
    set: function set(color) {
      this.tag('InputPassword').borderCellColor = color;
    }
  }, {
    key: "cells",
    set: function set(length) {
      this.tag('InputPassword').length = length;
    }
  }, {
    key: "setPasswordText",
    value: function setPasswordText(value) {
      var text = getPasswordString(value);
      this.tag('TextPassword').visible = Boolean(text);
      this.tag('TextPassword').text.text = text;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        TextPassword: {
          text: {
            text: ''
          }
        },
        InputPassword: {
          type: RestrictedInput
        }
      }, password_style_getInitialStyle());
    }
  }]);
  return Password;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/popups/kidsLeavePopup/kidsLeavePopup.utils.js

var generatePassword = function generatePassword(length) {
  var result = '';
  for (var i = 0; i < length; i += 1) {
    result += passwordCharacters[Math.floor(Math.random() * passwordCharacters.length)];
  }
  return result;
};
;// CONCATENATED MODULE: ./src/modules/tornado/keyboard/keyboardNumbers/customer/default/keyboardNumbers.style.js

var keyboardNumbers_style_KEYBOARD_HEIGHT, keyboardNumbers_style_KEYBOARD_WIDTH, keyboardNumbers_style_ICON_SIZE;




var keyboardNumbers_style_defaultContext = makeDefaultStylingContext();
var default_keyboardNumbers_style_KEYBOARD_HEIGHT = (keyboardNumbers_style_KEYBOARD_HEIGHT = {}, (0,defineProperty/* default */.Z)(keyboardNumbers_style_KEYBOARD_HEIGHT, HD, 81), (0,defineProperty/* default */.Z)(keyboardNumbers_style_KEYBOARD_HEIGHT, FULL_HD, 113), keyboardNumbers_style_KEYBOARD_HEIGHT);
var default_keyboardNumbers_style_KEYBOARD_WIDTH = (keyboardNumbers_style_KEYBOARD_WIDTH = {}, (0,defineProperty/* default */.Z)(keyboardNumbers_style_KEYBOARD_WIDTH, HD, 244), (0,defineProperty/* default */.Z)(keyboardNumbers_style_KEYBOARD_WIDTH, FULL_HD, 364), keyboardNumbers_style_KEYBOARD_WIDTH);
var keyboardNumbers_style_colors = {
  background: makeThemeColor(TERTIARY)
};
var default_keyboardNumbers_style_ICON_SIZE = (keyboardNumbers_style_ICON_SIZE = {}, (0,defineProperty/* default */.Z)(keyboardNumbers_style_ICON_SIZE, HD, 24), (0,defineProperty/* default */.Z)(keyboardNumbers_style_ICON_SIZE, FULL_HD, 36), keyboardNumbers_style_ICON_SIZE);
var keyboardNumbers_style_screenSize = keyboardNumbers_style_defaultContext.screenSize,
  keyboardNumbers_style_colorMode = keyboardNumbers_style_defaultContext.colorMode;

var keyboardNumbers_style_getBasicIconViewBox = memoize_default()(function (screenSize) {
  return {
    h: default_keyboardNumbers_style_ICON_SIZE[screenSize],
    w: default_keyboardNumbers_style_ICON_SIZE[screenSize]
  };
});
var keyboardNumbers_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : keyboardNumbers_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  return {
    h: default_keyboardNumbers_style_KEYBOARD_HEIGHT[screenSize],
    w: default_keyboardNumbers_style_KEYBOARD_WIDTH[screenSize],
    Background: {
      rect: true,
      h: default_keyboardNumbers_style_KEYBOARD_HEIGHT[screenSize],
      w: default_keyboardNumbers_style_KEYBOARD_WIDTH[screenSize],
      color: keyboardNumbers_style_colors.background[colorMode]
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/keyboard/keyboardNumbers/customer/default/keyboardNumbers.constants.js
var keyboardNumbers_constants_ITEMS_PER_ROW = 10;
var keyboardNumbers_constants_DEFAULT_KEYBOARD = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
;// CONCATENATED MODULE: ./src/modules/tornado/keyboard/keyboardNumbers/customer/default/keyboardNumbers.component.js










function keyboardNumbers_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function keyboardNumbers_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? keyboardNumbers_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : keyboardNumbers_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function keyboardNumbers_component_createSuper(t) { var r = keyboardNumbers_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function keyboardNumbers_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (keyboardNumbers_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }








var KeyboardNumbers = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(KeyboardNumbers, _Lightning$Component);
  var _super = keyboardNumbers_component_createSuper(KeyboardNumbers);
  function KeyboardNumbers() {
    (0,classCallCheck/* default */.Z)(this, KeyboardNumbers);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(KeyboardNumbers, [{
    key: "_init",
    value: function _init() {
      this._index = 0;
      this._itemsPerRow = keyboardNumbers_constants_ITEMS_PER_ROW;
      this._style = keyboardNumbers_style_defaultContext;
      this.keys = [];
      this.renderKeyboard();
    }
  }, {
    key: "itemsPerRow",
    get: function get() {
      return this._itemsPerRow;
    },
    set: function set(value) {
      this._itemsPerRow = value || keyboardNumbers_constants_ITEMS_PER_ROW;
    }
  }, {
    key: "renderKeyboard",
    value: function renderKeyboard() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this._keys = value || keyboardNumbers_constants_DEFAULT_KEYBOARD;
      this._renderKeys(this._keys);
      this.visible = true;
      this._setIndex(0);
      this._refocus();
    }
  }, {
    key: "_renderKeys",
    value: function _renderKeys(characters) {
      var _this = this;
      var iconViewBox = keyboardNumbers_style_getBasicIconViewBox(this._style.screenSize);
      this.patch({
        Keys: {
          children: characters.map(function (symbol, index) {
            var icon = SPECIAL_KEYS[symbol] ? SPECIAL_KEYS[symbol].icon : null;
            var result = keyboardNumbers_component_objectSpread({
              type: KeyboardItem,
              x: (KEY_WIDTH[_this._style.screenSize] + KEYS_GAP) * (index % _this._itemsPerRow),
              y: (KEY_HEIGHT[_this._style.screenSize] + KEYS_GAP) * Math.floor(index / _this._itemsPerRow)
            }, icon ? undefined : getBasicLetter(keyboardNumbers_component_objectSpread({
              symbol: symbol
            }, _this._style)));
            if (icon) {
              result.Icon = {
                type: Icon,
                x: Math.round((KEY_WIDTH[_this._style.screenSize] - iconViewBox.w) / 2),
                y: Math.round((KEY_HEIGHT[_this._style.screenSize] - iconViewBox.h) / 2),
                color: buttonColor.innerElementUnFocused[_this._style.colorMode],
                iconData: {
                  picto: icon,
                  viewBox: iconViewBox
                }
              };
              result.Button = {
                color: buttonColor.iconBackgroundUnFocused[_this._style.colorMode]
              };
            }
            return result;
          })
        },
        w: (KEY_WIDTH[this._style.screenSize] + KEYS_GAP) * this._itemsPerRow,
        h: (KEY_HEIGHT[this._style.screenSize] + KEYS_GAP) * Math.ceil(characters.length / this._itemsPerRow)
      });
    }
  }, {
    key: "_handleUp",
    value: function _handleUp() {
      if (this._index >= this._itemsPerRow) {
        this._setIndex(this._index - this._itemsPerRow);
        return true;
      }
      return false;
    }
  }, {
    key: "_handleDown",
    value: function _handleDown() {
      var isNotLastRow = this._index + this._itemsPerRow < this._keys.length;
      if (isNotLastRow) {
        this._setIndex(this._index + this._itemsPerRow);
      }
      return false;
    }
  }, {
    key: "_handleLeft",
    value: function _handleLeft() {
      if (this._index > 0) {
        this._setIndex(this._index - 1);
      }
      return false;
    }
  }, {
    key: "_handleRight",
    value: function _handleRight() {
      if (this._index < this._keys.length - 1) {
        this._setIndex(this._index + 1);
      }
      return false;
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      this.signal(LETTER_SELECTED_SIGNAL, this._keys[this._index]);
      return true;
    }
  }, {
    key: "_setIndex",
    value: function _setIndex() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._index;
      this._index = index;
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this._setIndex();
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this.tag('Keys').children[this._index];
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        visible: false,
        Background: {},
        Keys: {}
      }, keyboardNumbers_style_getInitialStyle());
    }
  }]);
  return KeyboardNumbers;
}(src_Lightning.Component);

;// CONCATENATED MODULE: ./src/modules/tornado/keyboard/keyboardNumbers/keyboardNumbers.component.js

/* harmony default export */ const keyboardNumbers_component = (KeyboardNumbers);
;// CONCATENATED MODULE: ./src/modules/popups/kidsLeavePopup/kidsLeavePopup.component.js






function kidsLeavePopup_component_createSuper(t) { var r = kidsLeavePopup_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function kidsLeavePopup_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (kidsLeavePopup_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }














var KidsLeave = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(KidsLeave, _Lightning$Component);
  var _super = kidsLeavePopup_component_createSuper(KidsLeave);
  function KidsLeave() {
    (0,classCallCheck/* default */.Z)(this, KidsLeave);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(KidsLeave, [{
    key: "payload",
    set: function set(value) {
      this._payload = value;
    }
  }, {
    key: "isEmptyPassword",
    get: function get() {
      return this.password === '';
    }
  }, {
    key: "isAllPassword",
    get: function get() {
      return this.password.length === PASSWORD_LENGTH;
    }
  }, {
    key: "_init",
    value: function _init() {
      this.generatedPassword = generatePassword(PASSWORD_LENGTH);
      this.password = '';
      this.tag('Keyboard').renderKeyboard(passwordCharacters);
      this.tag('PasswordBlock').setPasswordText(this.generatedPassword);
      this._setState('Keyboard');
    }
  }, {
    key: "_handleSelectedLetter",
    value: function _handleSelectedLetter(letter) {
      if (this.isEmptyPassword) this._resetPasswordView();
      this._updatePassword(letter);
      if (this.isAllPassword) this._validatePassword();
    }
  }, {
    key: "_updatePassword",
    value: function _updatePassword(value) {
      this.tag('PasswordBlock').push(value);
      this.password += value;
    }
  }, {
    key: "_validatePassword",
    value: function _validatePassword() {
      if (this.generatedPassword === this.password) {
        set_default()(this._payload, 'item.action.target.value_layout.type', 'profilesgate');
        this.signal(HIDE_POPUP_SIGNAL);
        lightningjs_redux.dispatch(createItemAction(this._payload));
        return;
      }
      this.password = '';
      this._showException();
    }
  }, {
    key: "_resetPasswordView",
    value: function _resetPasswordView() {
      this.tag('PasswordBlock').clearPasswordInput();
      this._hideException();
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      this.signal(HIDE_POPUP_SIGNAL);
      return true;
    }
  }, {
    key: "_showException",
    value: function _showException() {
      this.tag('Exception').alpha = 1;
    }
  }, {
    key: "_hideException",
    value: function _hideException() {
      this.tag('Exception').alpha = 0;
    }
  }, {
    key: "_handleDown",
    value: function _handleDown() {
      this._setState('Keyboard');
      return false;
    }
  }, {
    key: "_handleUp",
    value: function _handleUp() {
      this._setState('Button');
      return false;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Background: {
          rect: true
        },
        Button: {
          type: Button,
          label: t('global.back')
        },
        Content: {
          Title: {
            text: {
              text: t('leavingKidsSection.title')
            }
          },
          PasswordBlock: {
            type: Password
          },
          Exception: {
            text: {
              text: t('leavingKidsSection.wrongCode')
            }
          },
          Keyboard: {
            type: keyboardNumbers_component,
            signals: (0,defineProperty/* default */.Z)({}, LETTER_SELECTED_SIGNAL, '_handleSelectedLetter')
          }
        },
        passSignals: (0,defineProperty/* default */.Z)({}, HIDE_POPUP_SIGNAL, true)
      }, kidsLeavePopup_style_getInitialStyle());
    }
  }, {
    key: "_states",
    value: function _states() {
      return [function (_this) {
        (0,inherits/* default */.Z)(Keyboard, _this);
        var _super2 = kidsLeavePopup_component_createSuper(Keyboard);
        function Keyboard() {
          (0,classCallCheck/* default */.Z)(this, Keyboard);
          return _super2.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(Keyboard, [{
          key: "_getFocused",
          value: function _getFocused() {
            return this.tag('Keyboard');
          }
        }]);
        return Keyboard;
      }(this), function (_this2) {
        (0,inherits/* default */.Z)(Button, _this2);
        var _super3 = kidsLeavePopup_component_createSuper(Button);
        function Button() {
          (0,classCallCheck/* default */.Z)(this, Button);
          return _super3.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(Button, [{
          key: "_getFocused",
          value: function _getFocused() {
            return this.tag('Button');
          }
        }]);
        return Button;
      }(this)];
    }
  }]);
  return KidsLeave;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/popups/parentalCodePopup/parentalCode.style.js

var parentalCode_style_LOGO_HEIGHT, parentalCode_style_TITLE_WIDTH, parentalCode_style_EXCEPTION_HEIGHT, _PASSWORD_OFFSET_TOP;
function parentalCode_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function parentalCode_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? parentalCode_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : parentalCode_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





var parentalCode_style_defaultContext = makeDefaultStylingContext();
var parentalCode_style_colors = {
  background: makeThemeColor(TERTIARY),
  title: makeThemeColor(PRIMARY),
  exception: makeThemeColor(UTILITY1),
  border: makeThemeColor(PRIMARY)
};
var parentalCodePopup_parentalCode_style_LOGO_HEIGHT = (parentalCode_style_LOGO_HEIGHT = {}, (0,defineProperty/* default */.Z)(parentalCode_style_LOGO_HEIGHT, HD, 96), (0,defineProperty/* default */.Z)(parentalCode_style_LOGO_HEIGHT, FULL_HD, 152), parentalCode_style_LOGO_HEIGHT);
var parentalCodePopup_parentalCode_style_TITLE_WIDTH = (parentalCode_style_TITLE_WIDTH = {}, (0,defineProperty/* default */.Z)(parentalCode_style_TITLE_WIDTH, HD, 900), (0,defineProperty/* default */.Z)(parentalCode_style_TITLE_WIDTH, FULL_HD, 955), parentalCode_style_TITLE_WIDTH);
var parentalCodePopup_parentalCode_style_EXCEPTION_HEIGHT = (parentalCode_style_EXCEPTION_HEIGHT = {}, (0,defineProperty/* default */.Z)(parentalCode_style_EXCEPTION_HEIGHT, HD, 56), (0,defineProperty/* default */.Z)(parentalCode_style_EXCEPTION_HEIGHT, FULL_HD, 64), parentalCode_style_EXCEPTION_HEIGHT);
var parentalCode_style_PASSWORD_OFFSET_TOP = (_PASSWORD_OFFSET_TOP = {}, (0,defineProperty/* default */.Z)(_PASSWORD_OFFSET_TOP, HD, 56), (0,defineProperty/* default */.Z)(_PASSWORD_OFFSET_TOP, FULL_HD, 64), _PASSWORD_OFFSET_TOP);
var parentalCode_style_EXCEPTION_OFFSET = 12;
var FORGOT_CODE_BUTTON_OFFSET = 40;
var parentalCode_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : parentalCode_style_defaultContext,
    screenSize = _ref.screenSize,
    colorMode = _ref.colorMode;
  return {
    zIndex: 1,
    Background: {
      w: SCREEN_WIDTH[screenSize],
      h: sizes_SCREEN_HEIGHT[screenSize],
      color: parentalCode_style_colors.background[colorMode]
    },
    Input: {
      Button: {
        x: safetyMargins.horizontal[screenSize],
        y: safetyMargins.vertical[screenSize]
      },
      Content: {
        w: SCREEN_WIDTH[screenSize] - safetyMargins.horizontal[screenSize] * 2,
        h: sizes_SCREEN_HEIGHT[screenSize] - safetyMargins.vertical[screenSize] * 2,
        x: safetyMargins.horizontal[screenSize],
        y: safetyMargins.vertical[screenSize],
        flex: {
          direction: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        },
        CustomerIcon: {
          h: parentalCodePopup_parentalCode_style_LOGO_HEIGHT[screenSize]
        },
        Title: {
          text: parentalCode_style_objectSpread(parentalCode_style_objectSpread({}, src_getFont(constants_FONT.PARIS_3, screenSize)), {}, {
            maxLines: 2,
            maxLinesSuffix: '...',
            wordWrapWidth: parentalCodePopup_parentalCode_style_TITLE_WIDTH[screenSize],
            textAlign: 'center',
            textColor: parentalCode_style_colors.title[colorMode]
          })
        },
        PasswordBlock: {
          flexItem: {
            marginTop: parentalCode_style_PASSWORD_OFFSET_TOP[screenSize]
          }
        },
        ExceptionWrapper: {
          h: parentalCodePopup_parentalCode_style_EXCEPTION_HEIGHT[screenSize],
          Exception: {
            alpha: 0,
            x: middle,
            y: middle,
            mount: 0.5,
            text: parentalCode_style_objectSpread(parentalCode_style_objectSpread({}, src_getFont(constants_FONT.OTTAWA_2, screenSize)), {}, {
              textColor: parentalCode_style_colors.exception[colorMode],
              verticalAlign: 'middle'
            })
          }
        },
        Keyboard: {
          flexItem: {
            marginTop: parentalCode_style_EXCEPTION_OFFSET
          }
        },
        ForgotCodeButton: {
          flexItem: {
            marginTop: FORGOT_CODE_BUTTON_OFFSET
          }
        }
      }
    },
    ForgotCodeHint: {
      visible: false
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/popups/parentalCodePopup/parentalCode.constants.js
var parentalCode_constants_passwordCharacters = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '<'];
var parentalCode_constants_PASSWORD_LENGTH = 4;
var EXCEPTION_INTERVAL = 2000;

;// CONCATENATED MODULE: ./src/modules/popups/parentalCodePopup/hint/forgotCodeHint.style.js

var forgotCodeHint_style_CONTENT_WIDTH, forgotCodeHint_style_CONTENT_HEIGHT;
function forgotCodeHint_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function forgotCodeHint_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? forgotCodeHint_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : forgotCodeHint_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





var forgotCodeHint_style_defaultContext = makeDefaultStylingContext();
var forgotCodeHint_style_colors = {
  background: makeThemeColor(TERTIARY),
  title: makeThemeColor(PRIMARY)
};
var hint_forgotCodeHint_style_CONTENT_WIDTH = (forgotCodeHint_style_CONTENT_WIDTH = {}, (0,defineProperty/* default */.Z)(forgotCodeHint_style_CONTENT_WIDTH, HD, SCREEN_WIDTH[HD] - safetyMargins.horizontal[HD] * 2), (0,defineProperty/* default */.Z)(forgotCodeHint_style_CONTENT_WIDTH, FULL_HD, SCREEN_WIDTH[FULL_HD] - safetyMargins.horizontal[FULL_HD] * 2), forgotCodeHint_style_CONTENT_WIDTH);
var hint_forgotCodeHint_style_CONTENT_HEIGHT = (forgotCodeHint_style_CONTENT_HEIGHT = {}, (0,defineProperty/* default */.Z)(forgotCodeHint_style_CONTENT_HEIGHT, HD, sizes_SCREEN_HEIGHT[HD] - safetyMargins.vertical[HD] * 2), (0,defineProperty/* default */.Z)(forgotCodeHint_style_CONTENT_HEIGHT, FULL_HD, sizes_SCREEN_HEIGHT[FULL_HD] - safetyMargins.vertical[FULL_HD] * 2), forgotCodeHint_style_CONTENT_HEIGHT);
var forgotCodeHint_style_TEXT_OFFSET = 40;
var forgotCodeHint_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : forgotCodeHint_style_defaultContext,
    screenSize = _ref.screenSize,
    colorMode = _ref.colorMode;
  return {
    zIndex: 1,
    Background: {
      w: SCREEN_WIDTH[screenSize],
      h: sizes_SCREEN_HEIGHT[screenSize],
      color: forgotCodeHint_style_colors.background[colorMode]
    },
    BackButton: {
      x: safetyMargins.horizontal[screenSize],
      y: safetyMargins.vertical[screenSize]
    },
    Content: {
      w: hint_forgotCodeHint_style_CONTENT_WIDTH[screenSize],
      h: hint_forgotCodeHint_style_CONTENT_HEIGHT[screenSize],
      x: safetyMargins.horizontal[screenSize],
      y: safetyMargins.vertical[screenSize],
      flex: {
        direction: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      },
      Title: {
        text: forgotCodeHint_style_objectSpread(forgotCodeHint_style_objectSpread({}, src_getFont(constants_FONT.PARIS_3, screenSize)), {}, {
          maxLines: 2,
          maxLinesSuffix: '...',
          wordWrapWidth: hint_forgotCodeHint_style_CONTENT_WIDTH[screenSize],
          textAlign: 'center',
          textColor: forgotCodeHint_style_colors.title[colorMode]
        })
      },
      Body: {
        flexItem: {
          marginTop: forgotCodeHint_style_TEXT_OFFSET
        },
        text: forgotCodeHint_style_objectSpread(forgotCodeHint_style_objectSpread({}, src_getFont(constants_FONT.OTTAWA_1, screenSize)), {}, {
          maxLines: 2,
          maxLinesSuffix: '...',
          wordWrapWidth: hint_forgotCodeHint_style_CONTENT_WIDTH[screenSize],
          textAlign: 'center',
          textColor: forgotCodeHint_style_colors.title[colorMode]
        })
      },
      HomeButton: {
        flexItem: {
          marginTop: forgotCodeHint_style_TEXT_OFFSET
        }
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/popups/parentalCodePopup/hint/forgotCodeHint.constants.js
var forgotCodeHint_constants_HIDE_SIGNAL = 'hide';
var HOME_SIGNAL = 'home';
;// CONCATENATED MODULE: ./src/modules/popups/parentalCodePopup/hint/forgotCodeHint.component.js





function forgotCodeHint_component_createSuper(t) { var r = forgotCodeHint_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function forgotCodeHint_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (forgotCodeHint_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }






var ForgotCodeHint = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(ForgotCodeHint, _Lightning$Component);
  var _super = forgotCodeHint_component_createSuper(ForgotCodeHint);
  function ForgotCodeHint() {
    (0,classCallCheck/* default */.Z)(this, ForgotCodeHint);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(ForgotCodeHint, [{
    key: "_init",
    value: function _init() {
      this._style = forgotCodeHint_style_defaultContext;
      this.password = '';
      this._exceptionInterval = null;
    }
  }, {
    key: "_active",
    value: function _active() {
      this._setState('HomeButton');
    }
  }, {
    key: "_handleUp",
    value: function _handleUp() {
      return true;
    }
  }, {
    key: "_handleDown",
    value: function _handleDown() {
      return true;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Background: {
          rect: true
        },
        BackButton: {
          type: Button,
          label: t('global.back')
        },
        Content: {
          Title: {
            text: {
              text: t('parentalCode.forgottenCode')
            }
          },
          Body: {
            text: {
              text: t('parentalCode.lost.instruction')
            }
          },
          HomeButton: {
            type: Button,
            label: t('parentalCode.lost.catalogReturn')
          }
        }
      }, forgotCodeHint_style_getInitialStyle(), {});
    }
  }, {
    key: "_states",
    value: function _states() {
      return [function (_this) {
        (0,inherits/* default */.Z)(BackButton, _this);
        var _super2 = forgotCodeHint_component_createSuper(BackButton);
        function BackButton() {
          (0,classCallCheck/* default */.Z)(this, BackButton);
          return _super2.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(BackButton, [{
          key: "_getFocused",
          value: function _getFocused() {
            return this.tag('BackButton');
          }
        }, {
          key: "_handleDown",
          value: function _handleDown() {
            this._setState('HomeButton');
            return true;
          }
        }, {
          key: "_handleEnter",
          value: function _handleEnter() {
            this.signal(forgotCodeHint_constants_HIDE_SIGNAL);
            return true;
          }
        }]);
        return BackButton;
      }(this), function (_this2) {
        (0,inherits/* default */.Z)(HomeButton, _this2);
        var _super3 = forgotCodeHint_component_createSuper(HomeButton);
        function HomeButton() {
          (0,classCallCheck/* default */.Z)(this, HomeButton);
          return _super3.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(HomeButton, [{
          key: "_getFocused",
          value: function _getFocused() {
            return this.tag('HomeButton');
          }
        }, {
          key: "_handleUp",
          value: function _handleUp() {
            this._setState('BackButton');
            return true;
          }
        }, {
          key: "_handleEnter",
          value: function _handleEnter() {
            this.signal(HOME_SIGNAL);
            return true;
          }
        }]);
        return HomeButton;
      }(this)];
    }
  }]);
  return ForgotCodeHint;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/popups/parentalCodePopup/parentalCode.connector.js


var parentalCode_connector_mapControllers = function mapControllers(instance) {
  return [{
    selector: user_selectors_getParentalLockStatus,
    condition: function condition() {
      return true;
    },
    callback: function callback(value) {
      instance.handlePopup(value);
    }
  }];
};
/* harmony default export */ const parentalCode_connector = (lightningjs_redux.control(parentalCode_connector_mapControllers));
;// CONCATENATED MODULE: ./src/modules/popups/parentalCodePopup/parentalCode.component.js







function parentalCode_component_createSuper(t) { var r = parentalCode_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function parentalCode_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (parentalCode_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }


















var ParentalCode = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(ParentalCode, _Lightning$Component);
  var _super = parentalCode_component_createSuper(ParentalCode);
  function ParentalCode() {
    (0,classCallCheck/* default */.Z)(this, ParentalCode);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(ParentalCode, [{
    key: "routeBackOnClose",
    set: function set(value) {
      this._routeBackOnClose = value;
    }
  }, {
    key: "_init",
    value: function _init() {
      this._style = parentalCode_style_defaultContext;
      this.password = '';
      this._exceptionInterval = null;
      this._isUnlocked = false;
      var keyboard = this.tag('Keyboard');
      keyboard.itemsPerRow = parentalCode_constants_passwordCharacters.length;
      keyboard.renderKeyboard(parentalCode_constants_passwordCharacters);
      this.tag('PasswordBlock').cells = parentalCode_constants_PASSWORD_LENGTH;
      this._setState('Keyboard');
    }
  }, {
    key: "_attach",
    value: function _attach() {
      this._unsubscribe = parentalCode_connector(this);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this._clearExceptionInterval();
      this._cleanup();
    }
  }, {
    key: "_cleanup",
    value: function _cleanup() {
      if (this._unsubscribe) {
        this._unsubscribe();
        this._unsubscribe = null;
      }
      lightningjs_redux.dispatch(closeParentalLock());
    }
  }, {
    key: "payload",
    set: function set(value) {
      this._payload = value;
    }
  }, {
    key: "isEmptyPassword",
    get: function get() {
      return this.password === '';
    }
  }, {
    key: "isAllPassword",
    get: function get() {
      return this.password.length === parentalCode_constants_PASSWORD_LENGTH;
    }
  }, {
    key: "handlePopup",
    value: function handlePopup(value) {
      var _this = this;
      if (value) {
        this.signal(HIDE_POPUP_SIGNAL);
        lightningjs_redux.dispatch(createItemAction(this._payload));
        return;
      }
      if (this._isUnlocked !== value) {
        this._showException();
        this._clearExceptionInterval();
        this._exceptionInterval = setTimeout(function () {
          return _this._hideException();
        }, EXCEPTION_INTERVAL);
      }
      this._isUnlocked = value;
    }
  }, {
    key: "_handleSelectedLetter",
    value: function _handleSelectedLetter(letter) {
      if (this.isAllPassword) {
        return;
      }
      if (this.isEmptyPassword) {
        this._resetPasswordView();
      }
      this._updatePassword(letter);
    }
  }, {
    key: "_updatePassword",
    value: function _updatePassword(value) {
      switch (value) {
        case keyboard_constants_BACKSPACE:
          {
            this.password = this.password.slice(0, this.password.length ? this.password.length - 1 : 0);
            this.tag('PasswordBlock').pop();
            break;
          }
        default:
          {
            this.password += value;
            this.tag('PasswordBlock').push(value);
            if (this.isAllPassword) {
              this._validatePassword();
            }
          }
      }
    }
  }, {
    key: "_validatePassword",
    value: function _validatePassword() {
      if (this.password.length === parentalCode_constants_PASSWORD_LENGTH) {
        this._isUnlocked = undefined;
        lightningjs_redux.dispatch(checkParentalRestrictionCode(this.password));
      }
    }
  }, {
    key: "_clearExceptionInterval",
    value: function _clearExceptionInterval() {
      if (this._exceptionInterval) {
        clearTimeout(this._exceptionInterval);
      }
    }
  }, {
    key: "_resetPasswordView",
    value: function _resetPasswordView() {
      this._hideException();
    }
  }, {
    key: "_handleBack",
    value: function _handleBack() {
      this.signal(this._routeBackOnClose ? ROUTE_BACK_SIGNAL : HIDE_POPUP_SIGNAL);
      return true;
    }
  }, {
    key: "_showException",
    value: function _showException() {
      this.patch({
        Input: {
          Content: {
            PasswordBlock: {
              borderCellColor: {
                color: parentalCode_style_colors.exception[this._style.colorMode],
                opacity: 1
              }
            }
          }
        }
      });
      this.tag('Exception').alpha = 1;
    }
  }, {
    key: "_hideException",
    value: function _hideException() {
      this.patch({
        Input: {
          Content: {
            PasswordBlock: {
              borderCellColor: {
                color: parentalCode_style_colors.border[this._style.colorMode],
                opacity: 0.3
              }
            }
          }
        }
      });
      this.tag('PasswordBlock').clearPasswordInput();
      this.tag('Exception').alpha = 0;
      this.password = '';
      this._clearExceptionInterval();
    }
  }], [{
    key: "_template",
    value: function _template() {
      var _signals2, _passSignals;
      return merge_default()({
        Background: {
          rect: true
        },
        Input: {
          Button: {
            type: Button,
            label: t('global.back')
          },
          Content: {
            CustomerIcon: {
              type: BrandIcon
            },
            Title: {
              text: {
                text: t('parentalCode.instruction')
              }
            },
            PasswordBlock: {
              type: Password
            },
            ExceptionWrapper: {
              Exception: {
                text: {
                  text: t('parentalCode.incorrectCode')
                }
              }
            },
            Keyboard: {
              type: keyboardNumbers_component,
              signals: (0,defineProperty/* default */.Z)({}, LETTER_SELECTED_SIGNAL, '_handleSelectedLetter')
            },
            ForgotCodeButton: {
              type: Button,
              label: t('parentalCode.forgottenCode')
            }
          }
        },
        ForgotCodeHint: {
          type: ForgotCodeHint,
          signals: (_signals2 = {}, (0,defineProperty/* default */.Z)(_signals2, HOME_SIGNAL, '_handleHomeSignal'), (0,defineProperty/* default */.Z)(_signals2, forgotCodeHint_constants_HIDE_SIGNAL, '_handleHideSignal'), _signals2)
        },
        passSignals: (_passSignals = {}, (0,defineProperty/* default */.Z)(_passSignals, ROUTE_BACK_SIGNAL, true), (0,defineProperty/* default */.Z)(_passSignals, HIDE_POPUP_SIGNAL, true), _passSignals)
      }, parentalCode_style_getInitialStyle());
    }
  }, {
    key: "_states",
    value: function _states() {
      return [function (_this2) {
        (0,inherits/* default */.Z)(Button, _this2);
        var _super2 = parentalCode_component_createSuper(Button);
        function Button() {
          (0,classCallCheck/* default */.Z)(this, Button);
          return _super2.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(Button, [{
          key: "_getFocused",
          value: function _getFocused() {
            return this.tag('Button');
          }
        }, {
          key: "_handleEnter",
          value: function _handleEnter() {
            this.signal(this._routeBackOnClose ? ROUTE_BACK_SIGNAL : HIDE_POPUP_SIGNAL);
            return true;
          }
        }, {
          key: "_handleDown",
          value: function _handleDown() {
            this._setState('Keyboard');
            return true;
          }
        }]);
        return Button;
      }(this), function (_this3) {
        (0,inherits/* default */.Z)(Keyboard, _this3);
        var _super3 = parentalCode_component_createSuper(Keyboard);
        function Keyboard() {
          (0,classCallCheck/* default */.Z)(this, Keyboard);
          return _super3.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(Keyboard, [{
          key: "_getFocused",
          value: function _getFocused() {
            return this.tag('Keyboard');
          }
        }, {
          key: "_handleUp",
          value: function _handleUp() {
            this._setState('Button');
            return true;
          }
        }, {
          key: "_handleDown",
          value: function _handleDown() {
            this._setState('ForgotCode');
            return true;
          }
        }]);
        return Keyboard;
      }(this), function (_this4) {
        (0,inherits/* default */.Z)(ForgotCode, _this4);
        var _super4 = parentalCode_component_createSuper(ForgotCode);
        function ForgotCode() {
          (0,classCallCheck/* default */.Z)(this, ForgotCode);
          return _super4.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(ForgotCode, [{
          key: "_getFocused",
          value: function _getFocused() {
            return this.tag('ForgotCodeButton');
          }
        }, {
          key: "_handleEnter",
          value: function _handleEnter() {
            this._setState('ForgotCode.Open');
            return true;
          }
        }, {
          key: "_handleUp",
          value: function _handleUp() {
            this._setState('Keyboard');
            return true;
          }
        }], [{
          key: "_states",
          value: function _states() {
            return [function (_this5) {
              (0,inherits/* default */.Z)(Open, _this5);
              var _super5 = parentalCode_component_createSuper(Open);
              function Open() {
                (0,classCallCheck/* default */.Z)(this, Open);
                return _super5.apply(this, arguments);
              }
              (0,createClass/* default */.Z)(Open, [{
                key: "$enter",
                value: function $enter() {
                  this.tag('ForgotCodeHint').visible = true;
                }
              }, {
                key: "$exit",
                value: function $exit() {
                  this.tag('ForgotCodeHint').visible = false;
                }
              }, {
                key: "_getFocused",
                value: function _getFocused() {
                  return this.tag('ForgotCodeHint');
                }
              }, {
                key: "_handleBack",
                value: function _handleBack() {
                  this._handleHideSignal();
                  return true;
                }
              }, {
                key: "_handleHomeSignal",
                value: function _handleHomeSignal() {
                  navigateToAliasHome();
                  this.signal(HIDE_POPUP_SIGNAL);
                }
              }, {
                key: "_handleHideSignal",
                value: function _handleHideSignal() {
                  this._setState('ForgotCode');
                }
              }]);
              return Open;
            }(this)];
          }
        }]);
        return ForgotCode;
      }(this)];
    }
  }]);
  return ParentalCode;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/popups/cslLockPopup/cslLockPopup.component.js







function cslLockPopup_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function cslLockPopup_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? cslLockPopup_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : cslLockPopup_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function cslLockPopup_component_createSuper(t) { var r = cslLockPopup_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function cslLockPopup_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (cslLockPopup_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }


var CSLLockPopup = function (_CommonPopup) {
  (0,inherits/* default */.Z)(CSLLockPopup, _CommonPopup);
  var _super = cslLockPopup_component_createSuper(CSLLockPopup);
  function CSLLockPopup() {
    (0,classCallCheck/* default */.Z)(this, CSLLockPopup);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(CSLLockPopup, null, [{
    key: "_template",
    value: function _template() {
      return cslLockPopup_component_objectSpread(cslLockPopup_component_objectSpread({}, (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(CSLLockPopup), "_template", this).call(this)), {}, {
        title: t('error.csl')
      });
    }
  }]);
  return CSLLockPopup;
}(CommonPopup);
;// CONCATENATED MODULE: ./src/modules/popups/gridPopup/gridPopup.style.js




var gridPopup_style_defaultContext = makeDefaultStylingContext();
var gridPopup_style_colors = {
  background: makeThemeColor(TERTIARY)
};
var gridPopup_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : gridPopup_style_defaultContext,
    screenSize = _ref.screenSize,
    colorMode = _ref.colorMode;
  var w = SCREEN_WIDTH[screenSize];
  var h = sizes_SCREEN_HEIGHT[screenSize];
  return {
    w: w,
    h: h,
    color: gridPopup_style_colors.background[colorMode],
    Grid: {
      x: safetyMargins.horizontal[screenSize]
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/popups/gridPopup/gridPopup.connect.js


var gridPopup_connect_mapControllers = function mapControllers(instance) {
  return [{
    selector: getCurrentLayout,
    shouldBeInvokedOnConnect: true,
    callback: function callback(value) {
      instance.layout = value;
    }
  }];
};
/* harmony default export */ const gridPopup_connect = (lightningjs_redux.control(gridPopup_connect_mapControllers));
;// CONCATENATED MODULE: ./src/modules/popups/gridPopup/gridPopup.component.js









function gridPopup_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function gridPopup_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? gridPopup_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : gridPopup_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function gridPopup_component_createSuper(t) { var r = gridPopup_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function gridPopup_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (gridPopup_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }













var GridPopup = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(GridPopup, _Lightning$Component);
  var _super = gridPopup_component_createSuper(GridPopup);
  function GridPopup() {
    (0,classCallCheck/* default */.Z)(this, GridPopup);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(GridPopup, [{
    key: "_construct",
    value: function _construct() {
      this._style = gridPopup_style_defaultContext;
      this._blockIndex = undefined;
    }
  }, {
    key: "_active",
    value: function _active() {
      this._unsubscribe = gridPopup_connect(this);
    }
  }, {
    key: "_inactive",
    value: function _inactive() {
      if (this._unsubscribe) {
        this._unsubscribe();
      }
      this._layout = undefined;
      this._block = undefined;
    }
  }, {
    key: "layout",
    set: function set(value) {
      if (!value) {
        return;
      }
      this._layout = value;
      this._renderGrid();
    }
  }, {
    key: "block",
    set: function set(value) {
      if (!value) {
        return;
      }
      this._block = value;
      this._renderGrid();
    }
  }, {
    key: "_renderGrid",
    value: function _renderGrid() {
      if (!this._layout || !this._block || !Number.isFinite(this._block.blockIndex)) {
        return;
      }
      var screenSize = this._style.screenSize;
      var view = this.tag('Grid');
      var block = this._layout.blocks[this._block.blockIndex];
      var w = SCREEN_WIDTH[screenSize] - safetyMargins.horizontal[screenSize];
      var h = sizes_SCREEN_HEIGHT[screenSize];
      if (view.data) {
        view.data = gridPopup_component_objectSpread(gridPopup_component_objectSpread({}, this._block), {}, {
          rowSize: {
            w: w,
            h: h
          },
          blockIndex: 0,
          block: block,
          showAllItems: true
        });
        return;
      }
      var itemSize = this._block.itemSize;
      var blockSize = Grid.getOffsetsByBlockData({
        data: block,
        blockIndex: 0,
        showAllItems: true
      });
      var rowsCount = Grid.getRowCount({
        content: block.content,
        showAllItems: true
      }, screenSize);
      var gap = Grid.getContentGap(screenSize);
      var rowSize = itemSize.h + gap;
      var halfOfScreenHeight = Math.round(h / 2);
      var halfOfRowSize = Math.round(rowSize / 2);
      var offset = 0;
      this._positions = [];
      this._index = 0;
      for (var i = 0; i < rowsCount; i += 1) {
        this._positions.push(Math.min(halfOfScreenHeight - halfOfRowSize - blockSize.top - offset, 0));
        offset += rowSize;
      }
      if (this._positions.length && offset > h) {
        var minOffset = h - offset - safetyMargins.vertical[screenSize] - blockSize.top - gap;
        this._positions = this._positions.map(function (y) {
          return Math.max(minOffset, y);
        });
      }
      view.data = gridPopup_component_objectSpread(gridPopup_component_objectSpread({}, this._block), {}, {
        rowSize: {
          w: w,
          h: h
        },
        block: block,
        blockIndex: 0,
        showAllItems: true
      });
    }
  }, {
    key: "_handlePortionRequest",
    value: function _handlePortionRequest(portion) {
      lightningjs_redux.dispatch(fetchBlockPage(portion));
    }
  }, {
    key: "_handleSelected",
    value: function _handleSelected(item) {
      if (item && item.id && item.id !== PLACEHOLDER.id) {
        this.signal(HIDE_POPUP_SIGNAL);
        lightningjs_redux.dispatch(createItemAction({
          item: item
        }));
      }
    }
  }, {
    key: "_setIndex",
    value: function _setIndex() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._index;
      var position = this._positions[index];
      if (!Number.isFinite(position)) {
        return;
      }
      this._index = index;
      this.tag('Grid').setSmooth('y', position);
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this.tag('Grid');
    }
  }, {
    key: "_handleUp",
    value: function _handleUp() {
      if (this._index > 0) {
        this._setIndex(this._index - 1);
      }
      return true;
    }
  }, {
    key: "_handleDown",
    value: function _handleDown() {
      if (this._index < this._positions.length - 1) {
        this._setIndex(this._index + 1);
      }
      return true;
    }
  }], [{
    key: "_template",
    value: function _template() {
      var _signals;
      return merge_default()({
        rect: true,
        passSignals: (0,defineProperty/* default */.Z)({}, HIDE_POPUP_SIGNAL, true),
        Grid: {
          type: Grid,
          signals: (_signals = {}, (0,defineProperty/* default */.Z)(_signals, PORTION_REQUESTED_SIGNAL, '_handlePortionRequest'), (0,defineProperty/* default */.Z)(_signals, SELECTED_SIGNAL, '_handleSelected'), _signals)
        }
      }, gridPopup_style_getInitialStyle());
    }
  }]);
  return GridPopup;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/popups/contentRatingLockPopup/contentRatingLockPopup.component.js







function contentRatingLockPopup_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function contentRatingLockPopup_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? contentRatingLockPopup_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : contentRatingLockPopup_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function contentRatingLockPopup_component_createSuper(t) { var r = contentRatingLockPopup_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function contentRatingLockPopup_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (contentRatingLockPopup_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var ContentRatingLockPopup = function (_CommonPopup) {
  (0,inherits/* default */.Z)(ContentRatingLockPopup, _CommonPopup);
  var _super = contentRatingLockPopup_component_createSuper(ContentRatingLockPopup);
  function ContentRatingLockPopup() {
    (0,classCallCheck/* default */.Z)(this, ContentRatingLockPopup);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(ContentRatingLockPopup, null, [{
    key: "_template",
    value: function _template() {
      return contentRatingLockPopup_component_objectSpread(contentRatingLockPopup_component_objectSpread({}, (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(ContentRatingLockPopup), "_template", this).call(this)), {}, {
        title: 'layout.locks.contentRating.message'
      });
    }
  }]);
  return ContentRatingLockPopup;
}(CommonPopup);
;// CONCATENATED MODULE: ./src/modules/popups/parentalFilterPopupLock/parentalFilterPopupLock.component.js







function parentalFilterPopupLock_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function parentalFilterPopupLock_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? parentalFilterPopupLock_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : parentalFilterPopupLock_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function parentalFilterPopupLock_component_createSuper(t) { var r = parentalFilterPopupLock_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function parentalFilterPopupLock_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (parentalFilterPopupLock_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var ParentalFilterPopupLock = function (_CommonPopup) {
  (0,inherits/* default */.Z)(ParentalFilterPopupLock, _CommonPopup);
  var _super = parentalFilterPopupLock_component_createSuper(ParentalFilterPopupLock);
  function ParentalFilterPopupLock() {
    (0,classCallCheck/* default */.Z)(this, ParentalFilterPopupLock);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(ParentalFilterPopupLock, null, [{
    key: "_template",
    value: function _template() {
      return parentalFilterPopupLock_component_objectSpread(parentalFilterPopupLock_component_objectSpread({}, (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(ParentalFilterPopupLock), "_template", this).call(this)), {}, {
        title: 'layout.locks.parentalFilter.message'
      });
    }
  }]);
  return ParentalFilterPopupLock;
}(CommonPopup);
;// CONCATENATED MODULE: ./src/modules/popups/broadcastingLockPopup/broadcastingLockPopup.component.js







function broadcastingLockPopup_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function broadcastingLockPopup_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? broadcastingLockPopup_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : broadcastingLockPopup_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function broadcastingLockPopup_component_createSuper(t) { var r = broadcastingLockPopup_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function broadcastingLockPopup_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (broadcastingLockPopup_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var BroadcastingLockPopup = function (_CommonPopup) {
  (0,inherits/* default */.Z)(BroadcastingLockPopup, _CommonPopup);
  var _super = broadcastingLockPopup_component_createSuper(BroadcastingLockPopup);
  function BroadcastingLockPopup() {
    (0,classCallCheck/* default */.Z)(this, BroadcastingLockPopup);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(BroadcastingLockPopup, null, [{
    key: "_template",
    value: function _template() {
      return broadcastingLockPopup_component_objectSpread(broadcastingLockPopup_component_objectSpread({}, (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(BroadcastingLockPopup), "_template", this).call(this)), {}, {
        title: 'layout.locks.live.unavailableNotAiring'
      });
    }
  }]);
  return BroadcastingLockPopup;
}(CommonPopup);
;// CONCATENATED MODULE: ./src/modules/popups/freemiumLockPopup/freemiumLockPopup.component.js







function freemiumLockPopup_component_createSuper(t) { var r = freemiumLockPopup_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function freemiumLockPopup_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (freemiumLockPopup_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }





var FreemiumLockPopup = function (_SubscriptionExpired) {
  (0,inherits/* default */.Z)(FreemiumLockPopup, _SubscriptionExpired);
  var _super = freemiumLockPopup_component_createSuper(FreemiumLockPopup);
  function FreemiumLockPopup() {
    (0,classCallCheck/* default */.Z)(this, FreemiumLockPopup);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(FreemiumLockPopup, [{
    key: "routeBackOnClose",
    set: function set(value) {
      this._routeBackOnClose = value;
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      this.signal(this._getCloseActionSignal());
      return true;
    }
  }, {
    key: "_getCloseActionSignal",
    value: function _getCloseActionSignal() {
      if (this._checkHistoryAvailable()) {
        return ROUTE_BACK_SIGNAL;
      }
      return HIDE_POPUP_SIGNAL;
    }
  }, {
    key: "_checkHistoryAvailable",
    value: function _checkHistoryAvailable() {
      return this._routeBackOnClose && Router.getHistory().length > 0;
    }
  }], [{
    key: "_template",
    value: function _template() {
      var _passSignals;
      return merge_default()((0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(FreemiumLockPopup), "_template", this).call(this), {
        Content: {
          ChangeButton: {
            label: t('global.close')
          }
        },
        passSignals: (_passSignals = {}, (0,defineProperty/* default */.Z)(_passSignals, HIDE_POPUP_SIGNAL, true), (0,defineProperty/* default */.Z)(_passSignals, ROUTE_BACK_SIGNAL, true), _passSignals)
      });
    }
  }]);
  return FreemiumLockPopup;
}(SubscriptionExpired);
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/startOfWeek/index.js



/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/differenceInCalendarWeeks/index.js



var differenceInCalendarWeeks_MILLISECONDS_IN_WEEK = 604800000;
/**
 * @name differenceInCalendarWeeks
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Number} the number of calendar weeks
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   { weekStartsOn: 1 }
 * )
 * //=> 2
 */

function differenceInCalendarWeeks(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  requiredArgs(2, arguments);
  var startOfWeekLeft = startOfWeek(dirtyDateLeft, dirtyOptions);
  var startOfWeekRight = startOfWeek(dirtyDateRight, dirtyOptions);
  var timestampLeft = startOfWeekLeft.getTime() - getTimezoneOffsetInMilliseconds(startOfWeekLeft);
  var timestampRight = startOfWeekRight.getTime() - getTimezoneOffsetInMilliseconds(startOfWeekRight); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round((timestampLeft - timestampRight) / differenceInCalendarWeeks_MILLISECONDS_IN_WEEK);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/addDays/index.js



/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */

function addDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  date.setDate(date.getDate() + amount);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/addWeeks/index.js



/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */

function addWeeks(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  var days = amount * 7;
  return addDays(dirtyDate, days);
}
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/epg/epgPopup/epgPopupHeader/epgPopupHeader.style.js

function epgPopupHeader_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function epgPopupHeader_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? epgPopupHeader_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : epgPopupHeader_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





var epgPopupHeader_style_defaultContext = makeDefaultStylingContext();
var epgPopupHeader_style_colors = {
  backdrop: makeThemeColor(TERTIARY, 0.5),
  background: makeThemeColor(TERTIARY),
  text: makeThemeColor(PRIMARY)
};
var epgPopupHeader_style_GAP = 8;
var epgPopupHeader_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : epgPopupHeader_style_defaultContext,
    colorMode = _ref.colorMode,
    screenSize = _ref.screenSize;
  var font = src_getFont(constants_FONT.KINSHASA_2, screenSize);
  return {
    ArrowLeft: {},
    ArrowRight: {
      x: identity,
      mountX: 1
    },
    Title: {
      color: epgPopupHeader_style_colors.text[colorMode],
      x: SIZE[screenSize] + epgPopupHeader_style_GAP,
      y: Math.round((SIZE[screenSize] - font.lineHeight) / 2),
      w: function w(v) {
        return v - SIZE[screenSize] * 2 - epgPopupHeader_style_GAP * 2;
      },
      text: epgPopupHeader_style_objectSpread(epgPopupHeader_style_objectSpread({}, font), {}, {
        textAlign: 'center',
        verticalAlign: 'middle',
        wordWrap: false,
        textOverflow: '...'
      })
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/epg/epgPopup/epgPopupHeader/epgPopupHeader.component.js





function epgPopupHeader_component_createSuper(t) { var r = epgPopupHeader_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function epgPopupHeader_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (epgPopupHeader_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }







var EpgPopupHeader = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(EpgPopupHeader, _Lightning$Component);
  var _super = epgPopupHeader_component_createSuper(EpgPopupHeader);
  function EpgPopupHeader() {
    (0,classCallCheck/* default */.Z)(this, EpgPopupHeader);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(EpgPopupHeader, [{
    key: "_construct",
    value: function _construct() {
      this._style = epgPopupHeader_style_defaultContext;
      this._titles = [t('epgGrid.lastWeek'), t('epgGrid.currentWeek'), t('epgGrid.nextWeek')];
      this._index = 1;
    }
  }, {
    key: "_build",
    value: function _build() {
      this._focused = 'ArrowLeft';
      this.title = this._titles[this._index];
    }
  }, {
    key: "title",
    set: function set(value) {
      this.tag('Title').text.text = value;
    }
  }, {
    key: "index",
    set: function set(value) {
      if (value !== this._index) {
        this._index = value;
        this.title = this._titles[this._index];
        this.tag('ArrowLeft').disabled = this._index < 1;
        this.tag('ArrowRight').disabled = this._index > 1;
        if (this.tag('ArrowLeft').disabled) {
          this._focused = 'ArrowRight';
        } else if (this.tag('ArrowRight').disabled) {
          this._focused = 'ArrowLeft';
        }
        this.signal(SELECTED_SIGNAL, this._index - 1);
      }
    }
  }, {
    key: "_handleLeft",
    value: function _handleLeft() {
      if (this.tag('ArrowLeft').disabled) {
        return true;
      }
      this._focused = 'ArrowLeft';
      return true;
    }
  }, {
    key: "_handleRight",
    value: function _handleRight() {
      if (this.tag('ArrowRight').disabled) {
        return true;
      }
      this._focused = 'ArrowRight';
      return true;
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      if (this._focused === 'ArrowLeft') {
        this.index = Math.max(this._index - 1, 0);
      } else if (this._focused === 'ArrowRight') {
        this.index = Math.min(this._index + 1, this._titles.length - 1);
      }
      return true;
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this.tag(this._focused);
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        ArrowLeft: {
          type: NavigationArrow,
          variant: ARROW_LEFT
        },
        ArrowRight: {
          type: NavigationArrow,
          variant: ARROW_RIGHT
        },
        Title: {}
      }, epgPopupHeader_style_getInitialStyle());
    }
  }]);
  return EpgPopupHeader;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/epg/epgPopup/epgPopupEntry/epgPopupEntry.style.js

function epgPopupEntry_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function epgPopupEntry_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? epgPopupEntry_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : epgPopupEntry_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





var epgPopupEntry_style_defaultContext = makeDefaultStylingContext();
var epgPopupEntry_style_colors = {
  backgroundFocused: makeThemeColor(PRIMARY, 0.3),
  backgroundSelected: makeThemeColor(PRIMARY, 0.8),
  backgroundFocusedSelected: makeThemeColor(PRIMARY, 0.9),
  text: makeThemeColor(PRIMARY),
  textSelected: makeThemeColor(TERTIARY)
};
var epgPopupEntry_style_PADDING = 12;
var getBasicFont = function getBasicFont(screenSize) {
  return src_getFont(constants_FONT.OTTAWA_2, screenSize);
};
var getFocusedSelectedFont = function getFocusedSelectedFont(screenSize) {
  return src_getFont(constants_FONT.OTTAWA_3, screenSize);
};
var epgPopupEntry_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : epgPopupEntry_style_defaultContext,
    colorMode = _ref.colorMode,
    screenSize = _ref.screenSize;
  var font = getBasicFont(screenSize);
  var h = Math.max(font.lineHeight + epgPopupEntry_style_PADDING * 2, 40);
  return {
    w: identity,
    h: h,
    Background: {
      w: identity,
      h: h,
      color: colors_TRANSPARENT,
      shader: {
        radius: 8
      }
    },
    Title: {
      color: epgPopupEntry_style_colors.text[colorMode],
      x: middle,
      y: middle,
      mount: 0.5,
      text: epgPopupEntry_style_objectSpread(epgPopupEntry_style_objectSpread({}, font), {}, {
        verticalAlign: 'middle',
        wordWrap: false,
        textOverflow: '...'
      })
    }
  };
};
var epgPopupEntry_style_getUnFocusedStyle = function getUnFocusedStyle(_ref2, selected) {
  var screenSize = _ref2.screenSize,
    colorMode = _ref2.colorMode;
  var font = selected ? getFocusedSelectedFont(screenSize) : getBasicFont(screenSize);
  return {
    Background: {
      smooth: {
        color: selected ? epgPopupEntry_style_colors.backgroundSelected[colorMode] : colors_TRANSPARENT
      }
    },
    Title: {
      smooth: {
        color: selected ? epgPopupEntry_style_colors.textSelected[colorMode] : epgPopupEntry_style_colors.text[colorMode]
      },
      text: epgPopupEntry_style_objectSpread({}, font)
    }
  };
};
var epgPopupEntry_style_getFocusedStyle = function getFocusedStyle(_ref3, selected) {
  var screenSize = _ref3.screenSize,
    colorMode = _ref3.colorMode;
  var font = selected ? getFocusedSelectedFont(screenSize) : getBasicFont(screenSize);
  return {
    Background: {
      smooth: {
        color: selected ? epgPopupEntry_style_colors.backgroundFocusedSelected[colorMode] : epgPopupEntry_style_colors.backgroundFocused[colorMode]
      }
    },
    Title: {
      smooth: {
        color: selected ? epgPopupEntry_style_colors.textSelected[colorMode] : epgPopupEntry_style_colors.text[colorMode]
      },
      text: epgPopupEntry_style_objectSpread({}, font)
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/epg/epgPopup/epgPopupEntry/epgPopupEntry.component.js





function epgPopupEntry_component_createSuper(t) { var r = epgPopupEntry_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function epgPopupEntry_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (epgPopupEntry_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }




var EpgPopupEntry = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(EpgPopupEntry, _Lightning$Component);
  var _super = epgPopupEntry_component_createSuper(EpgPopupEntry);
  function EpgPopupEntry() {
    (0,classCallCheck/* default */.Z)(this, EpgPopupEntry);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(EpgPopupEntry, [{
    key: "_construct",
    value: function _construct() {
      this._style = epgPopupEntry_style_defaultContext;
      this._selected = false;
      this._focused = false;
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this._date = undefined;
    }
  }, {
    key: "date",
    get: function get() {
      return this._date;
    },
    set: function set(value) {
      this._date = value;
    }
  }, {
    key: "title",
    set: function set(value) {
      this.tag('Title').text.text = value;
    }
  }, {
    key: "selected",
    get: function get() {
      return this._selected;
    },
    set: function set(value) {
      this._selected = value;
      this._updateStyle();
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this._focused = true;
      this._updateStyle();
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this._focused = false;
      this._updateStyle();
    }
  }, {
    key: "_updateStyle",
    value: function _updateStyle() {
      if (this._focused) {
        this.patch(epgPopupEntry_style_getFocusedStyle(this._style, this._selected));
      } else {
        this.patch(epgPopupEntry_style_getUnFocusedStyle(this._style, this._selected));
      }
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      this.signal(SELECTED_SIGNAL, this.date);
      return true;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Background: {
          rect: true,
          shader: {
            type: src_Lightning.shaders.RoundedRectangle
          }
        },
        Title: {}
      }, epgPopupEntry_style_getInitialStyle());
    }
  }]);
  return EpgPopupEntry;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/epg/epgPopup/epgPopup.style.js

var epgPopup_style_WIDTH;





var epgPopup_style_defaultContext = makeDefaultStylingContext();
var epgPopup_epgPopup_style_WIDTH = (epgPopup_style_WIDTH = {}, (0,defineProperty/* default */.Z)(epgPopup_style_WIDTH, HD, 600), (0,defineProperty/* default */.Z)(epgPopup_style_WIDTH, FULL_HD, 600), epgPopup_style_WIDTH);
var epgPopup_style_PADDING_VERTICAL = 56;
var epgPopup_style_PADDING_HORIZONTAL = 32;
var epgPopup_style_GAP = 32;
var LIST_GAP = 16;
var epgPopup_style_colors = {
  backdrop: makeThemeColor(TERTIARY, 0.5),
  background: makeThemeColor(TERTIARY)
};
var getExpandedPosition = function getExpandedPosition(_ref) {
  var screenSize = _ref.screenSize;
  return SCREEN_WIDTH[screenSize] - epgPopup_epgPopup_style_WIDTH[screenSize];
};
var epgPopup_style_getInitialStyle = function getInitialStyle() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : epgPopup_style_defaultContext,
    colorMode = _ref2.colorMode,
    screenSize = _ref2.screenSize;
  var w = epgPopup_epgPopup_style_WIDTH[screenSize];
  var containerY = epgPopup_style_PADDING_VERTICAL + SIZE[screenSize] + epgPopup_style_GAP;
  return {
    w: SCREEN_WIDTH[screenSize],
    h: sizes_SCREEN_HEIGHT[screenSize],
    color: epgPopup_style_colors.backdrop[colorMode],
    Container: {
      color: epgPopup_style_colors.background[colorMode],
      x: SCREEN_WIDTH[screenSize],
      w: w,
      h: sizes_SCREEN_HEIGHT[screenSize],
      Header: {
        x: epgPopup_style_PADDING_HORIZONTAL,
        y: epgPopup_style_PADDING_VERTICAL,
        w: w - epgPopup_style_PADDING_HORIZONTAL * 2
      },
      List: {
        x: epgPopup_style_PADDING_HORIZONTAL,
        y: containerY,
        w: w - epgPopup_style_PADDING_HORIZONTAL * 2,
        h: sizes_SCREEN_HEIGHT[screenSize] - containerY - epgPopup_style_PADDING_VERTICAL,
        flex: {
          direction: 'column',
          justifyContent: 'center'
        }
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/epg/epgPopup/epgPopup.component.js








function epgPopup_component_createSuper(t) { var r = epgPopup_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function epgPopup_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (epgPopup_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }














var EpgPopup = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(EpgPopup, _Lightning$Component);
  var _super = epgPopup_component_createSuper(EpgPopup);
  function EpgPopup() {
    (0,classCallCheck/* default */.Z)(this, EpgPopup);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(EpgPopup, [{
    key: "_construct",
    value: function _construct() {
      this._style = epgPopup_style_defaultContext;
      this._offset = 0;
    }
  }, {
    key: "_active",
    value: function _active() {
      this.patch({
        Container: {
          smooth: {
            x: getExpandedPosition(this._style)
          }
        }
      });
      this._setState('List');
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this._date = undefined;
    }
  }, {
    key: "blockId",
    get: function get() {
      return this._blockId;
    },
    set: function set(value) {
      this._blockId = value;
    }
  }, {
    key: "date",
    get: function get() {
      return this._date;
    },
    set: function set(value) {
      this._date = value;
      this._updateDate();
    }
  }, {
    key: "selectedDate",
    get: function get() {
      return this._selectedDate;
    },
    set: function set(value) {
      this._selectedDate = value;
      sendEvent({
        key: 'epgDateSelect',
        date: this._selectedDate
      });
      this._updateDate();
    }
  }, {
    key: "_handleBack",
    value: function _handleBack() {
      this.signal(HIDE_POPUP_SIGNAL);
      return true;
    }
  }, {
    key: "_handleEntrySelected",
    value: function _handleEntrySelected(date) {
      this.tag('List').children.forEach(function (child) {
        child.selected = isSameDay(child.date, date);
      });
      lightningjs_redux.dispatch(fetchEPGLayout({
        date: date,
        blockId: this.blockId
      }));
      this.signal(HIDE_POPUP_SIGNAL);
    }
  }, {
    key: "_handleWeekSelected",
    value: function _handleWeekSelected(offset) {
      this._offset = offset;
      this._update();
    }
  }, {
    key: "_updateDate",
    value: function _updateDate() {
      if (!this._date || !this._selectedDate) {
        return;
      }
      this._offset = clamp_default()(differenceInCalendarWeeks(this._selectedDate, this._date, {
        weekStartsOn: 1
      }), -1, 1);
      this.tag('Header').index = this._offset + 1;
      this._update();
    }
  }, {
    key: "_update",
    value: function _update() {
      var _this = this;
      var start = startOfWeek(addWeeks(this._date, this._offset), {
        weekStartsOn: 1
      });
      var now = new Date();
      var days = [];
      for (var i = 0; i < 7; i += 1) {
        days.push(addDays(start, i));
      }
      this.tag('List').children = days.map(function (dayOfWeek) {
        var isToday = isSameDay(dayOfWeek, now);
        var isSelected = isSameDay(dayOfWeek, _this._selectedDate);
        return {
          type: EpgPopupEntry,
          title: isToday ? t('epgGrid.today') : formatDate(dayOfWeek),
          selected: isSelected,
          date: dayOfWeek,
          signals: (0,defineProperty/* default */.Z)({}, SELECTED_SIGNAL, '_handleEntrySelected'),
          flexItem: {
            marginBottom: LIST_GAP
          }
        };
      });
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        rect: true,
        passSignals: (0,defineProperty/* default */.Z)({}, HIDE_POPUP_SIGNAL, true),
        Container: {
          rect: true,
          Header: {
            type: EpgPopupHeader,
            title: t('epgGrid.currentWeek'),
            signals: (0,defineProperty/* default */.Z)({}, SELECTED_SIGNAL, '_handleWeekSelected')
          }
        },
        List: {}
      }, epgPopup_style_getInitialStyle());
    }
  }, {
    key: "_states",
    value: function _states() {
      return [function (_this2) {
        (0,inherits/* default */.Z)(Header, _this2);
        var _super2 = epgPopup_component_createSuper(Header);
        function Header() {
          (0,classCallCheck/* default */.Z)(this, Header);
          return _super2.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(Header, [{
          key: "_getFocused",
          value: function _getFocused() {
            return this.tag('Header');
          }
        }, {
          key: "_handleDown",
          value: function _handleDown() {
            this._setState('List');
          }
        }]);
        return Header;
      }(this), function (_this3) {
        (0,inherits/* default */.Z)(List, _this3);
        var _super3 = epgPopup_component_createSuper(List);
        function List() {
          (0,classCallCheck/* default */.Z)(this, List);
          return _super3.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(List, [{
          key: "$enter",
          value: function $enter() {
            this._index = 0;
          }
        }, {
          key: "_handleUp",
          value: function _handleUp() {
            if (this._index > 0) {
              this._index -= 1;
            } else {
              this._setState('Header');
            }
            return true;
          }
        }, {
          key: "_handleDown",
          value: function _handleDown() {
            if (this._index < this.tag('List').children.length - 1) {
              this._index += 1;
            }
            return true;
          }
        }, {
          key: "_getFocused",
          value: function _getFocused() {
            return this.tag('List').children[this._index];
          }
        }]);
        return List;
      }(this)];
    }
  }]);
  return EpgPopup;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/subscriptionExpired/new/upsell/upsell.component.js









function upsell_component_createSuper(t) { var r = upsell_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function upsell_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (upsell_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

















var Upsell = function (_SubscriptionExpiredB) {
  (0,inherits/* default */.Z)(Upsell, _SubscriptionExpiredB);
  var _super = upsell_component_createSuper(Upsell);
  function Upsell() {
    (0,classCallCheck/* default */.Z)(this, Upsell);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(Upsell, [{
    key: "_active",
    value: function _active() {
      (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(Upsell.prototype), "_active", this).call(this);
      var url = getPairingMethod() === PAIRING_METHOD.SSI ? src.pairing.ssiURL : src.pairing.upsellURL;
      this.patch({
        Right: {
          Mobile: {
            url: url
          },
          Desktop: {
            steps: [t('upsell.computer.step1', {
              url: url
            }), t('upsell.computer.step2'), t('upsell.computer.step3')]
          }
        }
      });
    }
  }, {
    key: "isPaired",
    set: function set(value) {
      this._isPaired = value;
      var key = value ? 'pairedButton' : 'unpairedButton';
      this.tag('Desktop').button = pairing_utils_translate("upsell.computer.".concat(key));
      this.tag('Mobile').button = pairing_utils_translate("upsell.mobile.".concat(key));
    }
  }, {
    key: "_resolveLock",
    value: function _resolveLock() {
      var required = this._requiredFeatures && this._requiredFeatures.length ? this._requiredFeatures : [];
      var available = this._services && this._services.length ? this._services : [];
      var offersMatching = !required.length || (available.length ? this._services.some(function (service) {
        return required.every(function (product) {
          return service.products.includes(product);
        });
      }) : false);
      if (offersMatching) {
        lightningjs_redux.dispatch(createItemAction(this._payload));
        this.signal(HIDE_POPUP_SIGNAL);
      } else {
        this.fireAncestors("$".concat(NOTIFICATION_SIGNAL), makeNotification(NOTIFICATION_LEVEL.ERROR, t('upsell.error')));
      }
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Background: {
          rect: true
        },
        CustomerIcon: {
          type: BrandIcon
        },
        Left: {
          type: PairingSelector,
          buttons: [{
            label: t('upsell.mobile.button'),
            iconLeft: 'QRCode',
            iconRight: 'ArrowRight'
          }, {
            label: t('upsell.computer.button'),
            iconLeft: 'Laptop',
            iconRight: 'ArrowRight'
          }, {
            label: t('global.back')
          }],
          labels: {
            title: t('upsell.title')
          },
          signals: (0,defineProperty/* default */.Z)({}, SELECTED_SIGNAL, '_switchViews')
        },
        Right: {
          Mobile: {
            type: MobilePairing,
            labels: {
              title: t('upsell.mobile.title'),
              steps: 'upsell.mobile.step',
              stepsCount: 3
            },
            url: src.pairing.upsellURL,
            signals: (0,defineProperty/* default */.Z)({}, SELECTED_SIGNAL, '_handleUnlockAttempt')
          },
          Desktop: {
            type: DesktopPairing,
            labels: {
              title: t('upsell.computer.title')
            },
            steps: [t('upsell.computer.step1', {
              url: src.pairing.upsellURL
            }), t('upsell.computer.step2'), t('upsell.computer.step3')],
            signals: (0,defineProperty/* default */.Z)({}, SELECTED_SIGNAL, '_handleUnlockAttempt')
          }
        }
      }, subscriptionExpiredBase_style_getInitialStyle());
    }
  }]);
  return Upsell;
}(SubscriptionExpiredBase);
;// CONCATENATED MODULE: ./src/modules/popups/subscriptionPopup/subscriptionPopup.utils.js

var getUpsell = function getUpsell(lock) {
  if (!(src_default()).featureFlipping.upsellFlow) {
    return null;
  }
  if (!lock) {
    return null;
  }
  var unlockTarget = lock.reasonAttributes ? lock.reasonAttributes.unlockTarget : null;
  if (!unlockTarget) {
    return null;
  }
  var upsell = unlockTarget["value_".concat(unlockTarget.type)];
  return upsell && upsell.reference === 'upsell' ? upsell : null;
};
;// CONCATENATED MODULE: ./src/modules/popups/subscriptionPopup/subscriptionPopup.connector.js


var subscriptionPopup_connector_mapControllers = function mapControllers(instance) {
  return [{
    shouldBeInvokedOnConnect: true,
    selector: getRequestedEntityType,
    callback: function callback(value) {
      instance.entityType = value;
    }
  }];
};
/* harmony default export */ const subscriptionPopup_connector = (lightningjs_redux.control(subscriptionPopup_connector_mapControllers));
;// CONCATENATED MODULE: ./src/modules/popups/subscriptionPopup/subscriptionPopup.component.js






function subscriptionPopup_component_createSuper(t) { var r = subscriptionPopup_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function subscriptionPopup_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (subscriptionPopup_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }







var SubscriptionPopup = function (_AbstractPopup) {
  (0,inherits/* default */.Z)(SubscriptionPopup, _AbstractPopup);
  var _super = subscriptionPopup_component_createSuper(SubscriptionPopup);
  function SubscriptionPopup() {
    (0,classCallCheck/* default */.Z)(this, SubscriptionPopup);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(SubscriptionPopup, [{
    key: "_active",
    value: function _active() {
      this._unsubscribe = subscriptionPopup_connector(this);
    }
  }, {
    key: "_inactive",
    value: function _inactive() {
      if (this._unsubscribe) {
        this._unsubscribe();
        this._unsubscribe = null;
      }
    }
  }, {
    key: "entityType",
    set: function set(value) {
      this.routeBackOnClose = this.routeBackOnClose || isPlayerLocked(value);
    }
  }, {
    key: "payload",
    set: function set(value) {
      this.tag('Regular').payload = value;
      this.tag('Upsell').payload = value;
    }
  }, {
    key: "lock",
    set: function set(value) {
      var upsell = getUpsell(value);
      this.tag('Regular').visible = !upsell;
      this.tag('Upsell').visible = !!upsell;
      var tag = upsell ? 'Upsell' : 'Regular';
      this.tag(tag).requiredFeatures = upsell.details ? upsell.details.products : [];
      this.tag(tag).lock = value;
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      var regular = this.tag('Regular');
      var upsell = this.tag('Upsell');
      if (regular.visible) {
        return regular;
      }
      if (upsell.visible) {
        return upsell;
      }
      return undefined;
    }
  }], [{
    key: "_template",
    value: function _template() {
      var _passSignals, _passSignals2, _passSignals3;
      return {
        Regular: {
          type: SubscriptionExpired,
          passSignals: (_passSignals = {}, (0,defineProperty/* default */.Z)(_passSignals, HIDE_POPUP_SIGNAL, true), (0,defineProperty/* default */.Z)(_passSignals, ROUTE_BACK_SIGNAL, true), _passSignals)
        },
        Upsell: {
          type: Upsell,
          passSignals: (_passSignals2 = {}, (0,defineProperty/* default */.Z)(_passSignals2, HIDE_POPUP_SIGNAL, true), (0,defineProperty/* default */.Z)(_passSignals2, ROUTE_BACK_SIGNAL, true), _passSignals2)
        },
        passSignals: (_passSignals3 = {}, (0,defineProperty/* default */.Z)(_passSignals3, HIDE_POPUP_SIGNAL, true), (0,defineProperty/* default */.Z)(_passSignals3, ROUTE_BACK_SIGNAL, true), (0,defineProperty/* default */.Z)(_passSignals3, EXIT_APP_SIGNAL, true), _passSignals3)
      };
    }
  }]);
  return SubscriptionPopup;
}(AbstractPopup);
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/epg/programCard/programCardError/programCardError.component.js






var programCardError_component_WIDTH, programCardError_component_HEIGHT;
function programCardError_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function programCardError_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? programCardError_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : programCardError_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function programCardError_component_createSuper(t) { var r = programCardError_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function programCardError_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (programCardError_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }







var programCardError_component_screenSize = 'FULL_HD';
var programCardError_component_ICON_SIZE = {
  WIDTH: (programCardError_component_WIDTH = {}, (0,defineProperty/* default */.Z)(programCardError_component_WIDTH, HD, 24), (0,defineProperty/* default */.Z)(programCardError_component_WIDTH, FULL_HD, 32), programCardError_component_WIDTH),
  HEIGHT: (programCardError_component_HEIGHT = {}, (0,defineProperty/* default */.Z)(programCardError_component_HEIGHT, HD, 24), (0,defineProperty/* default */.Z)(programCardError_component_HEIGHT, FULL_HD, 32), programCardError_component_HEIGHT)
};
var ERROR_ICON = {
  name: 'ErrorEmoji',
  type: 'icon'
};
var programCardError_component_getIconViewBox = memoize_default()(function (screenSize) {
  return {
    w: programCardError_component_ICON_SIZE.WIDTH[screenSize],
    h: programCardError_component_ICON_SIZE.HEIGHT[screenSize]
  };
});
var ProgramCardError = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(ProgramCardError, _Lightning$Component);
  var _super = programCardError_component_createSuper(ProgramCardError);
  function ProgramCardError() {
    (0,classCallCheck/* default */.Z)(this, ProgramCardError);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(ProgramCardError, null, [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        flex: {
          direction: 'row',
          justifyContent: 'center'
        },
        Icon: {
          flexItem: {
            marginRight: 12
          },
          type: Icon,
          iconData: {
            picto: ERROR_ICON,
            viewBox: programCardError_component_getIconViewBox(programCardError_component_screenSize)
          }
        },
        Title: {
          flexItem: {
            marginTop: 6,
            marginRight: 12
          },
          text: programCardError_component_objectSpread(programCardError_component_objectSpread({}, src_getFont(constants_FONT.OTTAWA_3, programCardError_component_screenSize)), {}, {
            text: t('programCard.noContent')
          })
        }
      });
    }
  }]);
  return ProgramCardError;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/epg/programCard/programCard.style.js

var programCard_style_WIDTH, programCard_style_HEIGHT, programCard_style_ITEM_WIDTH, _IMAGE_DIMENSIONS, programCard_style_ITEM_HEIGHT, _CONTAINER_SPACER, programCard_style_GAP, _CTA_GAP, programCard_style_PICTO_MARGIN_RIGHT, programCard_style_CTA_BUTTON_MARGIN_RI, programCard_style_LOGO_DIMENSIONS, _LOGO_PADDING, _TWELVE_PIXELS_PADDIN;
function programCard_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function programCard_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? programCard_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : programCard_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






var programCard_style_defaultContext = makeDefaultStylingContext();
var programCard_style_colors = {
  backgroundUnfocused: makeThemeColor(HIGHLIGHT),
  backgroundFocused: makeThemeColor(CLOUD_NORMAL),
  border: makeThemeColor(PRIMARY),
  text: makeThemeColor(PRIMARY),
  filledColor: makeThemeColor(TERTIARY),
  gradientFill: makeThemeColor(TERTIARY),
  transparent: makeThemeColor(TERTIARY, 0)
};
var SCREEN_SIZE = {
  WIDTH: (programCard_style_WIDTH = {}, (0,defineProperty/* default */.Z)(programCard_style_WIDTH, HD, 1280), (0,defineProperty/* default */.Z)(programCard_style_WIDTH, FULL_HD, 1920), programCard_style_WIDTH),
  HEIGHT: (programCard_style_HEIGHT = {}, (0,defineProperty/* default */.Z)(programCard_style_HEIGHT, HD, 720), (0,defineProperty/* default */.Z)(programCard_style_HEIGHT, FULL_HD, 1080), programCard_style_HEIGHT)
};
var programCard_programCard_style_ITEM_WIDTH = (programCard_style_ITEM_WIDTH = {}, (0,defineProperty/* default */.Z)(programCard_style_ITEM_WIDTH, HD, 618), (0,defineProperty/* default */.Z)(programCard_style_ITEM_WIDTH, FULL_HD, 680), programCard_style_ITEM_WIDTH);
var IMAGE_DIMENSIONS = (_IMAGE_DIMENSIONS = {}, (0,defineProperty/* default */.Z)(_IMAGE_DIMENSIONS, HD, {
  width: 618,
  height: 348
}), (0,defineProperty/* default */.Z)(_IMAGE_DIMENSIONS, FULL_HD, {
  width: 680,
  height: 382
}), _IMAGE_DIMENSIONS);
var programCard_programCard_style_ITEM_HEIGHT = (programCard_style_ITEM_HEIGHT = {}, (0,defineProperty/* default */.Z)(programCard_style_ITEM_HEIGHT, HD, 720), (0,defineProperty/* default */.Z)(programCard_style_ITEM_HEIGHT, FULL_HD, 1080), programCard_style_ITEM_HEIGHT);
var CONTAINER_SPACER = (_CONTAINER_SPACER = {}, (0,defineProperty/* default */.Z)(_CONTAINER_SPACER, HD, 208), (0,defineProperty/* default */.Z)(_CONTAINER_SPACER, FULL_HD, 248), _CONTAINER_SPACER);
var programCard_programCard_style_GAP = (programCard_style_GAP = {}, (0,defineProperty/* default */.Z)(programCard_style_GAP, HD, 18), (0,defineProperty/* default */.Z)(programCard_style_GAP, FULL_HD, 32), programCard_style_GAP);
var CTA_GAP = (_CTA_GAP = {}, (0,defineProperty/* default */.Z)(_CTA_GAP, HD, 9), (0,defineProperty/* default */.Z)(_CTA_GAP, FULL_HD, 16), _CTA_GAP);
var programCard_programCard_style_PICTO_MARGIN_RIGHT = (programCard_style_PICTO_MARGIN_RIGHT = {}, (0,defineProperty/* default */.Z)(programCard_style_PICTO_MARGIN_RIGHT, HD, 9), (0,defineProperty/* default */.Z)(programCard_style_PICTO_MARGIN_RIGHT, FULL_HD, 16), programCard_style_PICTO_MARGIN_RIGHT);
var programCard_style_CTA_BUTTON_MARGIN_RIGHT = (programCard_style_CTA_BUTTON_MARGIN_RI = {}, (0,defineProperty/* default */.Z)(programCard_style_CTA_BUTTON_MARGIN_RI, HD, 24), (0,defineProperty/* default */.Z)(programCard_style_CTA_BUTTON_MARGIN_RI, FULL_HD, 32), programCard_style_CTA_BUTTON_MARGIN_RI);
var programCard_programCard_style_LOGO_DIMENSIONS = (programCard_style_LOGO_DIMENSIONS = {}, (0,defineProperty/* default */.Z)(programCard_style_LOGO_DIMENSIONS, HD, {
  width: 152,
  height: 86
}), (0,defineProperty/* default */.Z)(programCard_style_LOGO_DIMENSIONS, FULL_HD, {
  width: 248,
  height: 140
}), programCard_style_LOGO_DIMENSIONS);
var LOGO_PADDING = (_LOGO_PADDING = {}, (0,defineProperty/* default */.Z)(_LOGO_PADDING, HD, 253), (0,defineProperty/* default */.Z)(_LOGO_PADDING, FULL_HD, 288), _LOGO_PADDING);
var TWELVE_PIXELS_PADDING = (_TWELVE_PIXELS_PADDIN = {}, (0,defineProperty/* default */.Z)(_TWELVE_PIXELS_PADDIN, HD, 7), (0,defineProperty/* default */.Z)(_TWELVE_PIXELS_PADDIN, FULL_HD, 12), _TWELVE_PIXELS_PADDIN);
var SPECIAL_PADDING = 168;
var programCard_style_BASIC_PICTO_DIMENSION = 24;
var programCard_style_getInitialStyle = function getInitialStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : programCard_style_defaultContext,
    screenSize = _ref.screenSize,
    colorMode = _ref.colorMode;
  return {
    x: SCREEN_SIZE.WIDTH[screenSize] - programCard_programCard_style_ITEM_WIDTH[screenSize],
    Background: {
      rect: true,
      color: programCard_style_colors.filledColor[colorMode],
      w: programCard_programCard_style_ITEM_WIDTH[screenSize],
      h: programCard_programCard_style_ITEM_HEIGHT[screenSize]
    },
    Image: {
      w: IMAGE_DIMENSIONS[screenSize].width,
      h: IMAGE_DIMENSIONS[screenSize].height
    },
    Gradient: {
      rect: true,
      colorUl: programCard_style_colors.transparent[colorMode],
      colorUr: programCard_style_colors.transparent[colorMode],
      colorBr: programCard_style_colors.gradientFill[colorMode],
      colorBl: programCard_style_colors.gradientFill[colorMode],
      w: IMAGE_DIMENSIONS[screenSize].width,
      h: IMAGE_DIMENSIONS[screenSize].height
    },
    Container: {
      x: programCard_programCard_style_GAP[screenSize] + CTA_GAP[screenSize],
      flex: {
        direction: 'column'
      },
      Logo: {
        flexItem: {
          marginTop: LOGO_PADDING[screenSize]
        }
      },
      Title: {
        color: programCard_style_colors.text[colorMode],
        flexItem: {
          marginTop: programCard_programCard_style_GAP[screenSize]
        },
        text: programCard_style_objectSpread(programCard_style_objectSpread({}, src_getFont(constants_FONT.PARIS_3, screenSize)), {}, {
          verticalAlign: 'middle',
          wordWrapWidth: programCard_programCard_style_ITEM_WIDTH[screenSize] - programCard_programCard_style_GAP[screenSize] * 2 - CTA_GAP[screenSize] * 2,
          maxLines: 2,
          textOverflow: '...'
        })
      },
      ProgramCardError: {
        flexItem: {
          marginTop: programCard_programCard_style_GAP[screenSize]
        },
        w: programCard_programCard_style_ITEM_WIDTH[screenSize] - programCard_programCard_style_GAP[screenSize] - CTA_GAP[screenSize] * 2
      },
      CTAContainer: {
        w: programCard_programCard_style_ITEM_WIDTH[screenSize] - programCard_programCard_style_GAP[screenSize] - CTA_GAP[screenSize] * 2,
        flexItem: {
          marginTop: programCard_programCard_style_GAP[screenSize]
        },
        flex: {
          direction: 'row'
        },
        PlayButton: {
          flexItem: {
            marginRight: programCard_style_CTA_BUTTON_MARGIN_RIGHT[screenSize]
          }
        },
        MyListButton: {
          flexItem: {
            marginRight: programCard_style_CTA_BUTTON_MARGIN_RIGHT[screenSize]
          }
        }
      },
      DetailsContainer: {
        flexItem: {
          marginTop: programCard_programCard_style_GAP[screenSize]
        },
        flex: {
          direction: 'column'
        },
        w: programCard_programCard_style_ITEM_WIDTH[screenSize] - programCard_programCard_style_GAP[screenSize] * 2 - CTA_GAP[screenSize] * 2,
        Details: {
          color: programCard_style_colors.text[colorMode],
          w: programCard_programCard_style_ITEM_WIDTH[screenSize] - programCard_programCard_style_GAP[screenSize] * 2 - CTA_GAP[screenSize] * 2,
          text: programCard_style_objectSpread(programCard_style_objectSpread({}, src_getFont(constants_FONT.OTTAWA_3, screenSize)), {}, {
            verticalAlign: 'middle',
            wordWrapWidth: programCard_programCard_style_ITEM_WIDTH[screenSize] - programCard_programCard_style_GAP[screenSize] * 2 - CTA_GAP[screenSize] * 2,
            wordWrap: false,
            textOverflow: '...'
          })
        },
        Time: {
          color: programCard_style_colors.text[colorMode],
          flexItem: {
            marginTop: CTA_GAP[screenSize]
          },
          text: programCard_style_objectSpread(programCard_style_objectSpread({}, src_getFont(constants_FONT.OTTAWA_3, screenSize)), {}, {
            verticalAlign: 'middle',
            wordWrap: false,
            textOverflow: '...'
          })
        },
        ProgressBar: {
          color: programCard_style_colors.backgroundUnfocused[colorMode],
          w: programCard_programCard_style_ITEM_WIDTH[screenSize] - programCard_programCard_style_GAP[screenSize] * 2 - CTA_GAP[screenSize] * 2,
          h: progress_style_HEIGHT,
          flexItem: {
            marginTop: CTA_GAP[screenSize]
          }
        },
        Description: {
          color: programCard_style_colors.text[colorMode],
          flexItem: {
            marginTop: TWELVE_PIXELS_PADDING[screenSize]
          },
          w: programCard_programCard_style_ITEM_WIDTH[screenSize] - programCard_programCard_style_GAP[screenSize] * 2 - CTA_GAP[screenSize] * 2,
          text: programCard_style_objectSpread(programCard_style_objectSpread({}, src_getFont(constants_FONT.OTTAWA_1, screenSize)), {}, {
            verticalAlign: 'middle',
            maxLines: 5,
            textOverflow: '...'
          })
        },
        ExtraDetails: {
          color: programCard_style_colors.text[colorMode],
          flexItem: {
            marginTop: TWELVE_PIXELS_PADDING[screenSize]
          },
          w: programCard_programCard_style_ITEM_WIDTH[screenSize] - programCard_programCard_style_GAP[screenSize] * 2 - CTA_GAP[screenSize] * 2,
          text: programCard_style_objectSpread(programCard_style_objectSpread({}, src_getFont(constants_FONT.BERLIN_2, screenSize)), {}, {
            verticalAlign: 'middle',
            maxLines: 5,
            textOverflow: '...'
          })
        },
        IconRow: {
          flex: {
            direction: 'row'
          },
          ServiceIcon: {
            flexItem: {
              marginTop: TWELVE_PIXELS_PADDING[screenSize],
              marginRight: programCard_programCard_style_PICTO_MARGIN_RIGHT[screenSize]
            }
          },
          Picto1: {
            flexItem: {
              marginTop: TWELVE_PIXELS_PADDING[screenSize],
              marginRight: programCard_programCard_style_PICTO_MARGIN_RIGHT[screenSize]
            }
          }
        },
        Button: {
          flexItem: {
            marginTop: TWELVE_PIXELS_PADDING[screenSize]
          }
        }
      }
    }
  };
};
var programCard_style_getBasicIconViewBox = memoize_default()(function () {
  return {
    h: programCard_style_BASIC_PICTO_DIMENSION
  };
});
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/epg/programCard/programCard.constants.js
var SECTION_CODE = 'main';
var programCard_constants_MY_LIST_ICONS = {
  MY_LIST_ICON_BOOKED: {
    name: 'Check',
    type: ' icon'
  },
  MY_LIST_ICON_UNBOOKED: {
    name: 'Plus',
    type: 'icon'
  }
};
;// CONCATENATED MODULE: ./src/modules/tornado/templates/blocks/epg/programCard/programCard.component.js












function programCard_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function programCard_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? programCard_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : programCard_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function programCard_component_createSuper(t) { var r = programCard_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function programCard_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (programCard_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }






















var ProgramCard = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(ProgramCard, _Lightning$Component);
  var _super = programCard_component_createSuper(ProgramCard);
  function ProgramCard() {
    (0,classCallCheck/* default */.Z)(this, ProgramCard);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(ProgramCard, [{
    key: "_construct",
    value: function _construct() {
      this._style = programCard_style_defaultContext;
    }
  }, {
    key: "_init",
    value: function _init() {
      this._index = 0;
      this._focused = this.tag('CTAContainer').children[this._index];
    }
  }, {
    key: "_inactive",
    value: function _inactive() {
      this.signal(INACTIVE_SIGNAL, this);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this._item = undefined;
      this.signal(DETACHED_SIGNAL, this);
      this._focused = undefined;
    }
  }, {
    key: "blockId",
    get: function get() {
      return this._blockId;
    },
    set: function set(value) {
      this._blockId = value;
      this._getDataForCard(value);
    }
  }, {
    key: "_showEpgModal",
    value: function _showEpgModal(content) {
      this.content = content;
      var screenSize = this._style.screenSize;
      var _this$content = this.content,
        title = _this$content.title,
        details = _this$content.details,
        extraDetails = _this$content.extraDetails,
        action = _this$content.action,
        pictos = _this$content.pictos,
        progressBar = _this$content.progressBar,
        logo = _this$content.logo,
        image = _this$content.image,
        contentAdvisory = _this$content.contentAdvisory,
        description = _this$content.description,
        secondaryActions = _this$content.secondaryActions,
        bookmark = _this$content.bookmark;
      var csaPicto = getCSAPicto(contentAdvisory.pictos);
      var servicePicto = getServicePicto(pictos);
      var isBasicIconVisible = Boolean(csaPicto);
      var serviceIconVisible = Boolean(servicePicto);
      var logoSrc = imageService.getUrl(logo.id, programCard_programCard_style_LOGO_DIMENSIONS[screenSize].width, programCard_programCard_style_LOGO_DIMENSIONS[screenSize].height, {
        fit: IMAGE_FIT_MAX,
        quality: IMAGE_QUALITY,
        format: TRANSPARENT_IMAGE_FORMAT
      });
      var myListItem = secondaryActions[0];
      var isPrimaryActionSupported = isActionAllowed(action);
      var patch = {
        Image: {
          src: imageService.getUrl(image.id, IMAGE_DIMENSIONS[screenSize].width, IMAGE_DIMENSIONS[screenSize].height, {
            fit: IMAGE_FIT_SCALE_CROP,
            quality: IMAGE_QUALITY,
            format: DEFAULT_IMAGE_FORMAT
          })
        },
        Gradient: {},
        Container: {
          Logo: {
            texture: programCard_component_objectSpread(programCard_component_objectSpread({}, contain(logoSrc, programCard_programCard_style_LOGO_DIMENSIONS[screenSize].width, programCard_programCard_style_LOGO_DIMENSIONS[screenSize].height)), {}, {
              hasAlpha: true
            })
          },
          Title: {
            visible: Boolean(title),
            text: {
              text: title
            }
          },
          ProgramCardError: {
            visible: false,
            type: ProgramCardError
          },
          CTAContainer: {
            visible: Boolean(action && isPrimaryActionSupported),
            PlayButton: {
              visible: isPrimaryActionSupported,
              label: action ? action.label : '',
              picto: action ? action.picto : ''
            },
            MyListButton: {
              visible: Boolean(myListItem),
              picto: myListItem ? myListItem.picto : ''
            }
          },
          DetailsContainer: {
            Details: {
              visible: Boolean(details),
              text: {
                text: details
              }
            },
            Time: {},
            ProgressBar: programCard_component_objectSpread({}, makeProgressBarProperties(progressBar)),
            Description: {
              visible: Boolean(description),
              text: {
                text: description
              }
            },
            ExtraDetails: {
              visible: Boolean(extraDetails),
              text: {
                text: extraDetails
              }
            },
            IconRow: {
              ServiceIcon: {
                visible: serviceIconVisible,
                iconData: {
                  picto: servicePicto,
                  viewBox: programCard_style_getBasicIconViewBox(screenSize)
                }
              },
              Picto1: {
                visible: isBasicIconVisible,
                iconData: {
                  picto: csaPicto,
                  viewBox: programCard_style_getBasicIconViewBox(screenSize)
                }
              }
            },
            Button: {
              visible: true,
              label: secondaryActions[1].label
            }
          }
        }
      };
      this.patch(patch);
      if (!action) {
        this._handleNoContentState(secondaryActions);
      }
      if (!this.tag('CTAContainer').visible) {
        this._index = undefined;
        this._focused = this.tag('Button');
      }
      this._refocus();
      if (bookmark) {
        bookmark.action = makeBookmarkAction(bookmark.id, bookmark.state ? cta_constants.UNBOOKMARK : cta_constants.BOOKMARK);
      }
      sendEvent({
        key: 'epgModalOpen'
      });
    }
  }, {
    key: "_getDataForCard",
    value: function () {
      var _getDataForCard2 = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(id) {
        var _this = this;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return layoutService.fetchEpgModal({
                SECTION_CODE: SECTION_CODE,
                id: id
              }).then(function (response) {
                return _this._showEpgModal(response.blocks[0].content.items[0].itemContent);
              }).catch(function (error) {
                return _this._handleErrorState(error);
              });
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function _getDataForCard(_x) {
        return _getDataForCard2.apply(this, arguments);
      }
      return _getDataForCard;
    }()
  }, {
    key: "_handleErrorState",
    value: function _handleErrorState(error) {
      console.log('Handle error', error);
    }
  }, {
    key: "_handleNoContentState",
    value: function _handleNoContentState(context) {
      this.patch({
        Container: {
          CTAContainer: {
            visible: false
          },
          ProgramCardError: {
            visible: true
          },
          DetailsContainer: {
            Button: {
              visible: true,
              label: context[1].label
            }
          }
        }
      });
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this._focused;
    }
  }, {
    key: "_handleRight",
    value: function _handleRight() {
      if (this._index < this.tag('CTAContainer').children.filter(function (child) {
        return child.visible;
      }).length - 1) {
        this._index += 1;
        this._setIndex(this._index);
        return true;
      }
      return false;
    }
  }, {
    key: "_handleLeft",
    value: function _handleLeft() {
      if (this._index > 0) {
        this._index -= 1;
        this._setIndex(this._index);
        return true;
      }
      return false;
    }
  }, {
    key: "_setIndex",
    value: function _setIndex(index) {
      this._focused = this.tag('CTAContainer').children[index];
    }
  }, {
    key: "_handleDown",
    value: function _handleDown() {
      if (this.tag('Button').visible) {
        this._focused = this.tag('Button');
      }
      return true;
    }
  }, {
    key: "_handleUp",
    value: function _handleUp() {
      if (this.tag('CTAContainer').visible) {
        this._focused = this.tag('CTAContainer').children[this._index];
      }
      return true;
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      if (this._focused === this.tag('PlayButton')) {
        handleInteraction(this.content, this);
        this.signal(HIDE_POPUP_SIGNAL);
      } else if (this._focused === this.tag('MyListButton')) {
        handleInteraction(this.content.bookmark, this);
        this.picto = this.content.bookmark.state ? programCard_constants_MY_LIST_ICONS.MY_LIST_ICON_UNBOOKED : programCard_constants_MY_LIST_ICONS.MY_LIST_ICON_BOOKED;
        this.tag('Container.CTAContainer.MyListButton').patch({
          picto: this.picto
        });
        this.content.bookmark.state = !this.content.bookmark.state;
      } else if (this._focused === this.tag('Container.DetailsContainer.Button')) {
        this.content.action = this.content.secondaryActions[1];
        handleInteraction(this.content, this);
        this.signal(HIDE_POPUP_SIGNAL);
      }
      sendEvent({
        key: 'epgModalClose'
      });
      return true;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        passSignals: (0,defineProperty/* default */.Z)({}, HIDE_POPUP_SIGNAL, true),
        Background: {},
        Image: {},
        Gradient: {},
        Container: {
          Logo: {},
          Title: {},
          ProgramCardError: {
            visible: false,
            type: ProgramCardError
          },
          CTAContainer: {
            visible: false,
            PlayButton: {
              type: CallToAction
            },
            MyListButton: {
              visible: false,
              type: CallToAction
            }
          },
          DetailsContainer: {
            Details: {},
            Time: {},
            ProgressBar: {
              visible: false,
              type: Progress
            },
            Description: {},
            ExtraDetails: {},
            IconRow: {
              ServiceIcon: {
                type: Icon
              },
              Picto1: {
                type: Icon
              }
            },
            Button: {
              visible: false,
              type: Button
            }
          }
        }
      }, programCard_style_getInitialStyle());
    }
  }]);
  return ProgramCard;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/popups/accountCompletionPopup/accountCompletionPopup.style.js

var accountCompletionPopup_style_CONTENT_SIDE_MARGIN, accountCompletionPopup_style_DESCRIPTION_TOP_MARG, accountCompletionPopup_style_BUTTONS_TOP_MARGIN, accountCompletionPopup_style_LOGO_HEIGHT, accountCompletionPopup_style_LOGO_OFFSET_TOP;
function accountCompletionPopup_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function accountCompletionPopup_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? accountCompletionPopup_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : accountCompletionPopup_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






var accountCompletionPopup_style_defaultContext = makeDefaultStylingContext();
var accountCompletionPopup_accountCompletionPopup_style_CONTENT_SIDE_MARGIN = (accountCompletionPopup_style_CONTENT_SIDE_MARGIN = {}, (0,defineProperty/* default */.Z)(accountCompletionPopup_style_CONTENT_SIDE_MARGIN, HD, 320), (0,defineProperty/* default */.Z)(accountCompletionPopup_style_CONTENT_SIDE_MARGIN, FULL_HD, 480), accountCompletionPopup_style_CONTENT_SIDE_MARGIN);
var accountCompletionPopup_style_DESCRIPTION_TOP_MARGIN = (accountCompletionPopup_style_DESCRIPTION_TOP_MARG = {}, (0,defineProperty/* default */.Z)(accountCompletionPopup_style_DESCRIPTION_TOP_MARG, HD, 8), (0,defineProperty/* default */.Z)(accountCompletionPopup_style_DESCRIPTION_TOP_MARG, FULL_HD, 16), accountCompletionPopup_style_DESCRIPTION_TOP_MARG);
var accountCompletionPopup_accountCompletionPopup_style_BUTTONS_TOP_MARGIN = (accountCompletionPopup_style_BUTTONS_TOP_MARGIN = {}, (0,defineProperty/* default */.Z)(accountCompletionPopup_style_BUTTONS_TOP_MARGIN, HD, 24), (0,defineProperty/* default */.Z)(accountCompletionPopup_style_BUTTONS_TOP_MARGIN, FULL_HD, 32), accountCompletionPopup_style_BUTTONS_TOP_MARGIN);
var accountCompletionPopup_accountCompletionPopup_style_LOGO_HEIGHT = (accountCompletionPopup_style_LOGO_HEIGHT = {}, (0,defineProperty/* default */.Z)(accountCompletionPopup_style_LOGO_HEIGHT, HD, 40), (0,defineProperty/* default */.Z)(accountCompletionPopup_style_LOGO_HEIGHT, FULL_HD, 56), accountCompletionPopup_style_LOGO_HEIGHT);
var accountCompletionPopup_accountCompletionPopup_style_LOGO_OFFSET_TOP = (accountCompletionPopup_style_LOGO_OFFSET_TOP = {}, (0,defineProperty/* default */.Z)(accountCompletionPopup_style_LOGO_OFFSET_TOP, HD, 40), (0,defineProperty/* default */.Z)(accountCompletionPopup_style_LOGO_OFFSET_TOP, FULL_HD, 56), accountCompletionPopup_style_LOGO_OFFSET_TOP);
var accountCompletionPopup_style_colors = {
  background: makeThemeColor(TERTIARY)
};
var accountCompletionPopup_style_getInitialStyle = memoize_default()(function () {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : accountCompletionPopup_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  var titleFont = src_getFont(constants_FONT.KINSHASA_3, screenSize);
  var descriptionFont = src_getFont(constants_FONT.OTTAWA_2, screenSize);
  var wordWrapWidth = SCREEN_WIDTH[screenSize] - accountCompletionPopup_accountCompletionPopup_style_CONTENT_SIDE_MARGIN[screenSize] * 2;
  return {
    rect: true,
    color: accountCompletionPopup_style_colors.background[colorMode],
    h: sizes_SCREEN_HEIGHT[screenSize],
    w: SCREEN_WIDTH[screenSize],
    Icon: {
      x: middle,
      y: accountCompletionPopup_accountCompletionPopup_style_LOGO_OFFSET_TOP[screenSize],
      mountX: 0.5,
      textureScale: 1.5,
      h: accountCompletionPopup_accountCompletionPopup_style_LOGO_HEIGHT[screenSize]
    },
    FlexContainer: {
      x: middle,
      y: middle,
      mountY: 0.5,
      flex: {
        direction: 'column',
        justifyContent: 'center'
      },
      Title: {
        mountX: 0.5,
        text: accountCompletionPopup_style_objectSpread({
          textAlign: 'center',
          wordWrapWidth: wordWrapWidth,
          maxLines: 2,
          maxLinesSuffix: '...'
        }, titleFont)
      },
      Description: {
        flexItem: {
          marginTop: accountCompletionPopup_style_DESCRIPTION_TOP_MARGIN[screenSize]
        },
        mountX: 0.5,
        text: accountCompletionPopup_style_objectSpread({
          textAlign: 'center',
          wordWrapWidth: wordWrapWidth
        }, descriptionFont)
      },
      OkButton: {
        flexItem: {
          marginTop: accountCompletionPopup_accountCompletionPopup_style_BUTTONS_TOP_MARGIN[screenSize]
        },
        mountX: 0.5,
        colorMode: colorMode
      }
    }
  };
});
;// CONCATENATED MODULE: ./src/modules/popups/accountCompletionPopup/accountCompletionPopup.component.js






function accountCompletionPopup_component_createSuper(t) { var r = accountCompletionPopup_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function accountCompletionPopup_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (accountCompletionPopup_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }







var AccountCompletionPopup = function (_AbstractPopup) {
  (0,inherits/* default */.Z)(AccountCompletionPopup, _AbstractPopup);
  var _super = accountCompletionPopup_component_createSuper(AccountCompletionPopup);
  function AccountCompletionPopup() {
    (0,classCallCheck/* default */.Z)(this, AccountCompletionPopup);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(AccountCompletionPopup, [{
    key: "_active",
    value: function _active() {
      this.tag('OkButton').label = this._getCloseButtonCaption();
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this.tag('OkButton');
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      this.signal(this._getCloseActionSignal());
      return true;
    }
  }, {
    key: "_getCloseButtonCaption",
    value: function _getCloseButtonCaption() {
      switch (this._getCloseActionSignal()) {
        case EXIT_APP_SIGNAL:
          return t('global.quit');
        case ROUTE_BACK_SIGNAL:
        default:
          return t('global.back');
      }
    }
  }], [{
    key: "_template",
    value: function _template() {
      var _passSignals;
      return merge_default()(accountCompletionPopup_style_getInitialStyle(), {
        Icon: {
          type: BrandIcon
        },
        FlexContainer: {
          Title: {
            text: {
              text: t('pairing.completion.title')
            }
          },
          Description: {
            text: {
              text: t('pairing.completion.description')
            }
          },
          OkButton: {
            type: Button,
            label: t('global.close')
          }
        },
        passSignals: (_passSignals = {}, (0,defineProperty/* default */.Z)(_passSignals, HIDE_POPUP_SIGNAL, true), (0,defineProperty/* default */.Z)(_passSignals, ROUTE_BACK_SIGNAL, true), (0,defineProperty/* default */.Z)(_passSignals, EXIT_APP_SIGNAL, true), _passSignals)
      });
    }
  }]);
  return AccountCompletionPopup;
}(AbstractPopup);
;// CONCATENATED MODULE: ./src/modules/popups/index.js


















var getPopupByID = function getPopupByID(id) {
  var popup = {};
  switch (id) {
    case GEO_BLOCK_POPUP_ID:
      popup = {
        type: GeoBlockPopup
      };
      break;
    case AGE_GATE_POPUP_ID:
      popup = {
        type: AgeGatePopup,
        routeBackOnClose: true
      };
      break;
    case PROFILES_GATE_POPUP_ID:
      popup = {
        type: ProfilesGatePopup
      };
      break;
    case KIDS_LEAVE_POPUP_ID:
      popup = {
        type: KidsLeave
      };
      break;
    case EXIT_POPUP_ID:
      popup = {
        type: ExitPopup
      };
      break;
    case FATAL_ERROR_POPUP_ID:
      popup = {
        type: CommonPopup,
        routeBackOnClose: true,
        exitAppOnClose: true
      };
      break;
    case BROADCASTING_LOCK_POPUP_ID:
      popup = {
        type: BroadcastingLockPopup
      };
      break;
    case FREEMIUM_LOCK_POPUP_ID:
      popup = {
        type: FreemiumLockPopup
      };
      break;
    case PARENTAL_CODE_POPUP_ID:
      popup = {
        type: ParentalCode
      };
      break;
    case CSL_BLOCK_POPUP_ID:
      popup = {
        type: CSLLockPopup,
        routeBackOnClose: true
      };
      break;
    case EPG_POPUP_ID:
      popup = {
        type: EpgPopup
      };
      break;
    case EPG_LAYOUT_POPUP_ID:
      popup = {
        type: ProgramCard
      };
      break;
    case GRID_POPUP_ID:
      popup = {
        type: GridPopup
      };
      break;
    case SUBSCRIPTION_POPUP_ID:
      popup = {
        type: SubscriptionPopup
      };
      break;
    case ACCOUNT_COMPLETION_POPUP_ID:
      popup = {
        type: AccountCompletionPopup
      };
      break;
    case CONTENT_RATING_POPUP_ID:
      popup = {
        type: ContentRatingLockPopup
      };
      break;
    case PARENTAL_FILTER_POPUP_ID:
      popup = {
        type: ParentalFilterPopupLock
      };
      break;
    case COMMON_POPUP_ID:
    default:
      popup = {
        type: CommonPopup
      };
      break;
  }
  popup.popupId = id;
  return popup;
};
;// CONCATENATED MODULE: ./src/modules/popupContainer/popupContainer.component.js






function popupContainer_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function popupContainer_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? popupContainer_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : popupContainer_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function popupContainer_component_createSuper(t) { var r = popupContainer_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function popupContainer_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (popupContainer_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }





var PopupContainer = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(PopupContainer, _Lightning$Component);
  var _super = popupContainer_component_createSuper(PopupContainer);
  function PopupContainer() {
    (0,classCallCheck/* default */.Z)(this, PopupContainer);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(PopupContainer, [{
    key: "content",
    set: function set(value) {
      var data = merge_default()(getPopupByID(value.id), value.options);
      this._popupId = data.popupId;
      this.children = [this.stage.c(popupContainer_component_objectSpread(popupContainer_component_objectSpread({}, data), {}, {
        ref: 'Content'
      }))];
    }
  }, {
    key: "popupId",
    get: function get() {
      return this._popupId;
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this.alpha = 1;
    }
  }, {
    key: "_handleLeft",
    value: function _handleLeft() {
      return true;
    }
  }, {
    key: "_handleRight",
    value: function _handleRight() {
      return true;
    }
  }, {
    key: "_handleBack",
    value: function _handleBack() {
      this.signal(HIDE_POPUP_SIGNAL);
      return true;
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this.tag('Content');
    }
  }, {
    key: "reset",
    value: function reset() {
      this._popupId = null;
      this.alpha = 0;
      this.children = [];
    }
  }], [{
    key: "_template",
    value: function _template() {
      return popupContainer_style_getInitialStyle();
    }
  }]);
  return PopupContainer;
}(src_Lightning.Component);

;// CONCATENATED MODULE: ./src/modules/gdprBanner/customer/default/gdprBanner.style.js

var gdprBanner_style_CONTENT_SIDE_MARGIN, _BUTTON_MARGIN_RIGHT, gdprBanner_style_PADDING_BOTTOM, gdprBanner_style_PADDING_TOP, gdprBanner_style_DESCRIPTION_PADDING_;
function gdprBanner_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function gdprBanner_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? gdprBanner_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : gdprBanner_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





var gdprBanner_style_defaultContext = makeDefaultStylingContext();
var default_gdprBanner_style_CONTENT_SIDE_MARGIN = (gdprBanner_style_CONTENT_SIDE_MARGIN = {}, (0,defineProperty/* default */.Z)(gdprBanner_style_CONTENT_SIDE_MARGIN, HD, 152), (0,defineProperty/* default */.Z)(gdprBanner_style_CONTENT_SIDE_MARGIN, FULL_HD, 232), gdprBanner_style_CONTENT_SIDE_MARGIN);
var BUTTON_MARGIN_RIGHT = (_BUTTON_MARGIN_RIGHT = {}, (0,defineProperty/* default */.Z)(_BUTTON_MARGIN_RIGHT, HD, 24), (0,defineProperty/* default */.Z)(_BUTTON_MARGIN_RIGHT, FULL_HD, 24), _BUTTON_MARGIN_RIGHT);
var default_gdprBanner_style_PADDING_BOTTOM = (gdprBanner_style_PADDING_BOTTOM = {}, (0,defineProperty/* default */.Z)(gdprBanner_style_PADDING_BOTTOM, HD, safetyMargins.vertical[HD]), (0,defineProperty/* default */.Z)(gdprBanner_style_PADDING_BOTTOM, FULL_HD, safetyMargins.vertical[FULL_HD]), gdprBanner_style_PADDING_BOTTOM);
var default_gdprBanner_style_PADDING_TOP = (gdprBanner_style_PADDING_TOP = {}, (0,defineProperty/* default */.Z)(gdprBanner_style_PADDING_TOP, HD, 32), (0,defineProperty/* default */.Z)(gdprBanner_style_PADDING_TOP, FULL_HD, 48), gdprBanner_style_PADDING_TOP);
var gdprBanner_style_DESCRIPTION_PADDING_BOTTOM = (gdprBanner_style_DESCRIPTION_PADDING_ = {}, (0,defineProperty/* default */.Z)(gdprBanner_style_DESCRIPTION_PADDING_, HD, 32), (0,defineProperty/* default */.Z)(gdprBanner_style_DESCRIPTION_PADDING_, FULL_HD, 48), gdprBanner_style_DESCRIPTION_PADDING_);
var gdprBanner_style_colors = {
  background: makeThemeColor(TERTIARY)
};
var gdprBanner_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : gdprBanner_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  var descriptionFont = src_getFont(constants_FONT.OTTAWA_1, screenSize);
  var wordWrapWidth = SCREEN_WIDTH[screenSize] - default_gdprBanner_style_CONTENT_SIDE_MARGIN[screenSize] * 2;
  return {
    rect: true,
    w: SCREEN_WIDTH[screenSize],
    mountY: 1,
    y: sizes_SCREEN_HEIGHT[screenSize],
    x: 0,
    color: gdprBanner_style_colors.background[colorMode],
    flex: {
      direction: 'column',
      paddingBottom: default_gdprBanner_style_PADDING_BOTTOM[screenSize]
    },
    Description: {
      flexItem: {
        marginBottom: gdprBanner_style_DESCRIPTION_PADDING_BOTTOM[screenSize]
      },
      x: default_gdprBanner_style_CONTENT_SIDE_MARGIN[screenSize],
      y: default_gdprBanner_style_PADDING_TOP[screenSize],
      text: gdprBanner_style_objectSpread({
        textAlign: 'center',
        wordWrapWidth: wordWrapWidth
      }, descriptionFont)
    },
    ButtonsRow: {
      flex: {
        direction: 'row',
        justifyContent: 'center'
      },
      flexItem: {
        marginTop: gdprBanner_style_DESCRIPTION_PADDING_BOTTOM[screenSize]
      },
      AcceptAll: {
        flexItem: {
          marginRight: BUTTON_MARGIN_RIGHT[screenSize]
        }
      },
      Settings: {
        flexItem: {
          marginRight: BUTTON_MARGIN_RIGHT[screenSize]
        }
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/gdprBanner/gdprBanner.constants.js
var PRIVACY_DECLINE_ALL = 'declineAll';
var PRIVACY_CONSENT_ALL = 'consentAll';
var PRIVACY_SELECT = 'selectPrivacy';
;// CONCATENATED MODULE: ./src/modules/cookieConsent/cookieConcent.constants.js
var SHOW_PRIVACY_SETTINGS_SIGNAL = 'privacySettingsExit';
;// CONCATENATED MODULE: ./src/modules/gdprBanner/customer/default/gdprBanner.component.js





function gdprBanner_component_createSuper(t) { var r = gdprBanner_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function gdprBanner_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (gdprBanner_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }









var GdprBanner = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(GdprBanner, _Lightning$Component);
  var _super = gdprBanner_component_createSuper(GdprBanner);
  function GdprBanner() {
    (0,classCallCheck/* default */.Z)(this, GdprBanner);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(GdprBanner, [{
    key: "_construct",
    value: function _construct() {
      this._index = 0;
    }
  }, {
    key: "_build",
    value: function _build() {
      this._buttons = this.tag('ButtonsRow').children;
    }
  }, {
    key: "_setIndex",
    value: function _setIndex() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._index;
      this._index = index;
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this._setIndex();
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this._setIndex(0);
    }
  }, {
    key: "_getFocused",
    value: function _getFocused() {
      return this._buttons[this._index];
    }
  }, {
    key: "_handleEnter",
    value: function _handleEnter() {
      switch (this._getFocused().action) {
        case PRIVACY_CONSENT_ALL:
          lightningjs_redux.dispatch(pressGdprNoticeConsentAllButton());
          return true;
        case PRIVACY_DECLINE_ALL:
          lightningjs_redux.dispatch(pressGdprNoticeDeclineAllButton());
          return true;
        case PRIVACY_SELECT:
          this.signal(SHOW_PRIVACY_SETTINGS_SIGNAL);
          return true;
        default:
          return false;
      }
    }
  }, {
    key: "_handleRight",
    value: function _handleRight() {
      if (this._index < this._buttons.length - 1) {
        this._setIndex(this._index + 1);
        return true;
      }
      return true;
    }
  }, {
    key: "_handleBack",
    value: function _handleBack() {
      return true;
    }
  }, {
    key: "_handleLeft",
    value: function _handleLeft() {
      if (this._index > 0) {
        this._setIndex(this._index - 1);
        return true;
      }
      return true;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Description: {
          text: {
            text: t('gdprNotice.description')
          }
        },
        ButtonsRow: {
          AcceptAll: {
            type: Button,
            label: t('gdprNotice.ok'),
            action: PRIVACY_CONSENT_ALL
          },
          Settings: {
            type: Button,
            label: t('gdprNotice.parameters'),
            action: PRIVACY_SELECT
          },
          DeclineAll: {
            type: Button,
            label: t('gdprNotice.decline'),
            action: PRIVACY_DECLINE_ALL
          }
        }
      }, gdprBanner_style_getInitialStyle());
    }
  }]);
  return GdprBanner;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/gdprBanner/gdprBanner.component.js

;// CONCATENATED MODULE: ./src/modules/cookieConsent/cookieConsent.component.js






function cookieConsent_component_createSuper(t) { var r = cookieConsent_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function cookieConsent_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (cookieConsent_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }








var CookieConsent = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(CookieConsent, _Lightning$Component);
  var _super = cookieConsent_component_createSuper(CookieConsent);
  function CookieConsent() {
    (0,classCallCheck/* default */.Z)(this, CookieConsent);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(CookieConsent, [{
    key: "_focus",
    value: function _focus() {
      this._setState('GdprBanner');
      this.patch({
        alpha: 1
      });
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this.patch({
        alpha: 0
      });
    }
  }, {
    key: "_handleExitPrivacySettings",
    value: function _handleExitPrivacySettings() {
      lightningjs_redux.dispatch(toggleGdprNotice());
    }
  }, {
    key: "_handleShowPrivacySettings",
    value: function _handleShowPrivacySettings() {
      sendEvent({
        key: 'pressCookieBannerSetupButton'
      });
      this._setState('Settings');
    }
  }], [{
    key: "_template",
    value: function _template() {
      return {
        GdprBanner: {
          visible: false,
          type: GdprBanner,
          signals: (0,defineProperty/* default */.Z)({}, SHOW_PRIVACY_SETTINGS_SIGNAL, '_handleShowPrivacySettings')
        },
        Settings: {
          visible: false,
          type: PrivacySettings,
          signals: (0,defineProperty/* default */.Z)({}, PRIVACY_SETTINGS_EXIT_SIGNAL, '_handleExitPrivacySettings')
        }
      };
    }
  }, {
    key: "_states",
    value: function _states() {
      return [function (_this) {
        (0,inherits/* default */.Z)(GdprBanner, _this);
        var _super2 = cookieConsent_component_createSuper(GdprBanner);
        function GdprBanner() {
          (0,classCallCheck/* default */.Z)(this, GdprBanner);
          return _super2.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(GdprBanner, [{
          key: "$enter",
          value: function $enter() {
            this.tag('GdprBanner').visible = true;
            this.tag('Settings').visible = false;
          }
        }, {
          key: "_getFocused",
          value: function _getFocused() {
            return this.tag('GdprBanner');
          }
        }]);
        return GdprBanner;
      }(this), function (_this2) {
        (0,inherits/* default */.Z)(Settings, _this2);
        var _super3 = cookieConsent_component_createSuper(Settings);
        function Settings() {
          (0,classCallCheck/* default */.Z)(this, Settings);
          return _super3.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(Settings, [{
          key: "_handleRight",
          value: function _handleRight() {
            return true;
          }
        }, {
          key: "$enter",
          value: function $enter() {
            this.tag('GdprBanner').visible = false;
            this.tag('Settings').visible = true;
          }
        }, {
          key: "_getFocused",
          value: function _getFocused() {
            return this.tag('Settings');
          }
        }]);
        return Settings;
      }(this)];
    }
  }]);
  return CookieConsent;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/logic/screenSaver/screenSaver.utils.js




var getItemTitle = function getItemTitle(item) {
  var content = get_default()(item, 'itemContent');
  return get_default()(content, 'title') || get_default()(content, 'extraTitle') || get_default()(content, 'image.caption') || '';
};
var getScreenSaverItemsData = function getScreenSaverItemsData(data) {
  var entity = get_default()(data, 'entity.id');
  if (entity === layout_constants/* frontspaces */.K_.screensaver) {
    var items = get_default()(data, 'blocks[0].content.items') || [];
    return items.filter(function (item) {
      return get_default()(item, 'itemContent.image.id');
    }).map(function (item) {
      return {
        details: get_default()(item, 'itemContent.extraDetails') || '',
        title: getItemTitle(item),
        imageId: get_default()(item, 'itemContent.image.id')
      };
    });
  }
  return [];
};
var getNextIndex = function getNextIndex(index, collection) {
  return (index + 1) % collection.length;
};
var checkLayoutsNotEqual = function checkLayoutsNotEqual(a, b) {
  return a && b ? a.layoutId !== b.layoutId : !a && b;
};
;// CONCATENATED MODULE: ./src/modules/screenSaver/screenSaver.connector.js



var screenSaver_connector_mapControllers = function mapControllers(instance) {
  return {
    screenSaverData: {
      selector: getScreenSaverData,
      condition: function condition(_ref) {
        var previousProp = _ref.previousProp,
          currentProp = _ref.currentProp;
        return checkLayoutsNotEqual(previousProp, currentProp);
      },
      callback: function callback(value) {
        instance.items = value.items;
      }
    },
    isLocked: {
      selector: getScreenSaverIsLocked,
      callback: function callback(isLocked) {
        instance.isLocked = isLocked;
      }
    }
  };
};
/* harmony default export */ const screenSaver_connector = (lightningjs_redux.control(screenSaver_connector_mapControllers));
;// CONCATENATED MODULE: ./src/modules/screenSaver/screenSaver.constants.js

var SHOW_SCREENSAVER_SIGNAL = 'show';
var HIDE_SCREENSAVER_SIGNAL = 'hide';
var SCREEN_SAVER_COUNTDOWN = 120000;
var ITERATION_TOTAL_DURATION = 8;
var SCREEN_APPEAR_DURATION = 0.15;
var LOGO_APPEAR_DURATION = 1;
var LABEL_SWAP_DURATION_OFFSET = 6.5;
var LABEL_APPEAR_DURATION = 3;
var LABEL_APPEAR_DELAY = 0.5;
var LABEL_FADE_IN_DURATION = 3.5;
var LABEL_FADE_OUT_DURATION = 1;
var BACKGROUND_DURATION = 6.9;
var BACKGROUND_FADE_IN_DURATION = 2;
var BACKGROUND_FADE_OUT_FAST = 1;
var BACKGROUND_FADE_OUT_SLOW = 2;
var BACKGROUND_FADE_DELAY = 0.5;
var BACKGROUND_IDLE_SUSTAIN = 2;
var FADE_IN = 0;
var FADE_OUT = 1;
var BANNED_POPUPS = [PROFILES_GATE_POPUP_ID];
var BANNED_WIDGETS = ['CookieConsent'];
;// CONCATENATED MODULE: ./src/modules/screenSaver/screenSaver.style.js


var screenSaver_style_LOGO_HEIGHT, _LOGO_X_OFFSET, _LOGO_Y_OFFSET, _DESCRIPTION_START_X_, _DESCRIPTION_X_OFFSET, _DESCRIPTION_BOTTOM_M;
function screenSaver_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function screenSaver_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? screenSaver_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : screenSaver_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }







var screenSaver_style_defaultContext = makeDefaultStylingContext();
var screenSaver_style_colors = {
  background: makeThemeColor(TERTIARY),
  title: makeThemeColor(PRIMARY),
  details: makeThemeColor(PRIMARY, 0.5),
  gradientFill: makeThemeColor(TERTIARY),
  transparent: makeThemeColor(TERTIARY, 0)
};
var BACKGROUND_STYLES = [{
  pivot: 0,
  zoom: {
    zoomStart: 1,
    zoomEnd: 1.11
  }
}, {
  pivot: 1,
  zoom: {
    zoomStart: 1,
    zoomEnd: 1.06
  }
}, {
  zoom: {
    zoomStart: 1.25,
    zoomEnd: 1
  }
}, {
  pivot: 1,
  zoom: {
    zoomStart: 1,
    zoomEnd: 1.18
  }
}, {
  zoom: {
    zoomStart: 1,
    zoomEnd: 1.12
  }
}];
var screenSaver_screenSaver_style_LOGO_HEIGHT = (screenSaver_style_LOGO_HEIGHT = {}, (0,defineProperty/* default */.Z)(screenSaver_style_LOGO_HEIGHT, HD, 92), (0,defineProperty/* default */.Z)(screenSaver_style_LOGO_HEIGHT, FULL_HD, 104), screenSaver_style_LOGO_HEIGHT);
var LOGO_X_OFFSET = (_LOGO_X_OFFSET = {}, (0,defineProperty/* default */.Z)(_LOGO_X_OFFSET, HD, 64), (0,defineProperty/* default */.Z)(_LOGO_X_OFFSET, FULL_HD, 64), _LOGO_X_OFFSET);
var LOGO_Y_OFFSET = (_LOGO_Y_OFFSET = {}, (0,defineProperty/* default */.Z)(_LOGO_Y_OFFSET, HD, 32), (0,defineProperty/* default */.Z)(_LOGO_Y_OFFSET, FULL_HD, 32), _LOGO_Y_OFFSET);
var DESCRIPTION_START_X_OFFSET = (_DESCRIPTION_START_X_ = {}, (0,defineProperty/* default */.Z)(_DESCRIPTION_START_X_, HD, 28), (0,defineProperty/* default */.Z)(_DESCRIPTION_START_X_, FULL_HD, 28), _DESCRIPTION_START_X_);
var DESCRIPTION_X_OFFSET = (_DESCRIPTION_X_OFFSET = {}, (0,defineProperty/* default */.Z)(_DESCRIPTION_X_OFFSET, HD, 64), (0,defineProperty/* default */.Z)(_DESCRIPTION_X_OFFSET, FULL_HD, 64), _DESCRIPTION_X_OFFSET);
var DESCRIPTION_BOTTOM_MARGIN = (_DESCRIPTION_BOTTOM_M = {}, (0,defineProperty/* default */.Z)(_DESCRIPTION_BOTTOM_M, HD, 58), (0,defineProperty/* default */.Z)(_DESCRIPTION_BOTTOM_M, FULL_HD, 58), _DESCRIPTION_BOTTOM_M);
var screenSaver_style_getInitialStyle = memoize_default()(function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : screenSaver_style_defaultContext,
    screenSize = _ref.screenSize,
    colorMode = _ref.colorMode;
  var titleFont = src_getFont(constants_FONT.OSLO_3, screenSize);
  var detailsFont = src_getFont(constants_FONT.KINSHASA_2, screenSize);
  return {
    alpha: 0,
    color: screenSaver_style_colors.background[colorMode],
    h: sizes_SCREEN_HEIGHT[screenSize],
    w: SCREEN_WIDTH[screenSize],
    BackgroundContainer: {
      w: identity,
      h: identity
    },
    Gradient: {
      rect: true,
      w: identity,
      h: identity,
      colorBl: screenSaver_style_colors.gradientFill[colorMode],
      colorUl: screenSaver_style_colors.gradientFill[colorMode],
      colorUr: screenSaver_style_colors.transparent[colorMode],
      colorBr: screenSaver_style_colors.transparent[colorMode]
    },
    Logo: {
      x: LOGO_X_OFFSET[screenSize],
      y: LOGO_Y_OFFSET[screenSize],
      textureScale: 1.5,
      h: screenSaver_screenSaver_style_LOGO_HEIGHT[screenSize]
    },
    Label: {
      x: DESCRIPTION_START_X_OFFSET[screenSize],
      y: sizes_SCREEN_HEIGHT[screenSize] - DESCRIPTION_BOTTOM_MARGIN[screenSize],
      mountY: 1,
      flex: {
        direction: 'column'
      },
      Title: {
        text: screenSaver_style_objectSpread({
          textColor: screenSaver_style_colors.title[colorMode]
        }, titleFont)
      },
      Details: {
        text: screenSaver_style_objectSpread({
          textColor: screenSaver_style_colors.details[colorMode]
        }, detailsFont)
      }
    }
  };
}, cacheResolver);
var getDescriptionAppearAnimStyle = memoize_default()(function () {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : screenSaver_style_defaultContext;
  var screenSize = context.screenSize;
  return {
    duration: LABEL_APPEAR_DURATION,
    repeat: 0,
    stopMethod: 'immediate',
    delay: LABEL_APPEAR_DELAY,
    actions: [{
      p: 'x',
      v: {
        0: {
          v: DESCRIPTION_START_X_OFFSET[screenSize],
          s: 0.1
        },
        1: {
          v: DESCRIPTION_X_OFFSET[screenSize],
          sm: 1
        }
      }
    }]
  };
}, cacheResolver);
var getDummyAnimStyle = function getDummyAnimStyle(duration) {
  return {
    duration: duration,
    repeat: 0,
    stopMethod: 'immediate'
  };
};
var getFadeAnimStyle = function getFadeAnimStyle(direction, duration) {
  var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return {
    duration: duration,
    repeat: 0,
    delay: delay,
    stopMethod: 'immediate',
    actions: [{
      p: 'alpha',
      v: {
        0: Number(direction !== 0),
        1: Number(direction === 0)
      }
    }]
  };
};
var getBackgroundIdleAnimStyle = memoize_default()(function (_ref2) {
  var zoomStart = _ref2.zoomStart,
    zoomEnd = _ref2.zoomEnd;
  return {
    duration: ITERATION_TOTAL_DURATION + BACKGROUND_IDLE_SUSTAIN,
    repeat: 0,
    stopMethod: 'immediate',
    actions: [{
      p: 'scale',
      v: {
        0: {
          v: zoomStart,
          sm: 0
        },
        1: {
          v: zoomEnd,
          sm: 0
        }
      }
    }]
  };
}, cacheResolver);
;// CONCATENATED MODULE: ./src/modules/screenSaver/screenSaver.component.js







function screenSaver_component_createSuper(t) { var r = screenSaver_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function screenSaver_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (screenSaver_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }










var ScreenSaver = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(ScreenSaver, _Lightning$Component);
  var _super = screenSaver_component_createSuper(ScreenSaver);
  function ScreenSaver() {
    (0,classCallCheck/* default */.Z)(this, ScreenSaver);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(ScreenSaver, [{
    key: "_build",
    value: function _build() {
      var _this = this;
      this._index = 0;
      this._container = this.tag('BackgroundContainer');
      this._label = this.tag('Label');
      this._label.patch({
        appear: this._label.animation(getDescriptionAppearAnimStyle()),
        fadeIn: this._label.animation(getFadeAnimStyle(FADE_IN, LABEL_FADE_IN_DURATION, LABEL_APPEAR_DELAY)),
        fadeOut: this._label.animation(getFadeAnimStyle(FADE_OUT, LABEL_FADE_OUT_DURATION))
      });
      this._appearAnimation = this.animation(getFadeAnimStyle(FADE_IN, SCREEN_APPEAR_DURATION));
      this._logoAppearAnimation = this.tag('Logo').animation(getFadeAnimStyle(FADE_IN, LOGO_APPEAR_DURATION));
      this._labelSwapTimer = this.animation(getDummyAnimStyle(LABEL_SWAP_DURATION_OFFSET));
      this._backgroundSwapTimer = this.animation(getDummyAnimStyle(BACKGROUND_DURATION));
      this._iterationTimer = this.animation(getDummyAnimStyle(ITERATION_TOTAL_DURATION));
      this._labelSwapTimer.on('finish', function () {
        return _this._onLabelSwapTimerFinished();
      });
      this._backgroundSwapTimer.on('finish', function () {
        return _this._onBackgroundSwapTimerFinished();
      });
      this._iterationTimer.on('finish', function () {
        return _this._onIterationTimerFinished();
      });
      this._label.fadeOut.on('finish', function () {
        return _this._onLabelFadeOutFinished();
      });
      this._isLocked = false;
    }
  }, {
    key: "_attach",
    value: function _attach() {
      this._unsubscribe = screenSaver_connector(this);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      if (this._unsubscribe) {
        this._unsubscribe();
        this._unsubscribe = null;
      }
      this._reset();
    }
  }, {
    key: "items",
    set: function set(value) {
      var _this2 = this;
      var finalW = this.finalW,
        finalH = this.finalH;
      this._items = value;
      if (this._items.length === 1) {
        for (var i = 0; i < BACKGROUND_STYLES.length - 1; i += 1) {
          this._items.push(this._items[0]);
        }
      }
      var backgroundStyleIndex = -1;
      this._container.children = this._items.map(function () {
        backgroundStyleIndex = getNextIndex(backgroundStyleIndex, BACKGROUND_STYLES);
        return BACKGROUND_STYLES[backgroundStyleIndex];
      });
      this._container.children.forEach(function (item, index) {
        item.patch({
          alpha: 0,
          fadeIn: item.animation(getFadeAnimStyle(FADE_IN, BACKGROUND_FADE_IN_DURATION, BACKGROUND_FADE_DELAY)),
          fadeOut: item.animation(getFadeAnimStyle(FADE_OUT, BACKGROUND_FADE_OUT_FAST)),
          idle: item.animation(getBackgroundIdleAnimStyle(item.zoom)),
          texture: cover(imageService.getUrl(_this2._items[index].imageId, finalW, finalH, {
            fit: IMAGE_FIT_SCALE_CROP,
            quality: IMAGE_QUALITY,
            format: DEFAULT_IMAGE_FORMAT
          }), finalW, finalH)
        });
        item.texture.load();
      });
      if (this.canBeShown) {
        this.resetTimer();
      }
    }
  }, {
    key: "canBeShown",
    get: function get() {
      return this.visible && !this._isLocked && Boolean(this._items && this._items.length);
    }
  }, {
    key: "isShown",
    get: function get() {
      return this.alpha > 0;
    }
  }, {
    key: "isLocked",
    set: function set(value) {
      this._isLocked = value;
    }
  }, {
    key: "resetTimer",
    value: function resetTimer() {
      var _this3 = this;
      if (this._screenSaverTimeout) {
        clearTimeout(this._screenSaverTimeout);
      }
      if (this.isShown) {
        return;
      }
      this._screenSaverTimeout = setTimeout(function () {
        _this3.signal(SHOW_SCREENSAVER_SIGNAL);
      }, SCREEN_SAVER_COUNTDOWN);
    }
  }, {
    key: "_handleKey",
    value: function _handleKey() {
      this.signal(HIDE_SCREENSAVER_SIGNAL);
      this.resetTimer();
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this._appearAnimation.start();
      this._startSequence();
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      this._reset();
    }
  }, {
    key: "_startSequence",
    value: function _startSequence() {
      this._container.children.forEach(function (item) {
        item.alpha = 0;
      });
      this._logoAppearAnimation.start();
      this._startBackgroundAnimation(0, true);
      this._startLabelAnimation(0, true);
      this._processSequence();
    }
  }, {
    key: "_processSequence",
    value: function _processSequence() {
      this._labelSwapTimer.start();
      this._backgroundSwapTimer.start();
      this._iterationTimer.start();
    }
  }, {
    key: "_onLabelSwapTimerFinished",
    value: function _onLabelSwapTimerFinished() {
      if (this.isShown) {
        this._label.fadeOut.start();
      }
    }
  }, {
    key: "_onBackgroundSwapTimerFinished",
    value: function _onBackgroundSwapTimerFinished() {
      if (this.isShown) {
        this._container.children[this._index].fadeOut.start();
        this._startBackgroundAnimation(getNextIndex(this._index, this._items));
      }
    }
  }, {
    key: "_onIterationTimerFinished",
    value: function _onIterationTimerFinished() {
      if (this.isShown) {
        this._index = getNextIndex(this._index, this._items);
        this._processSequence();
      }
    }
  }, {
    key: "_onLabelFadeOutFinished",
    value: function _onLabelFadeOutFinished() {
      if (this.isShown) {
        this._startLabelAnimation(getNextIndex(this._index, this._items));
      }
    }
  }, {
    key: "_startLabelAnimation",
    value: function _startLabelAnimation(index) {
      var skipDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var currentItem = this._items[index];
      this.tag('Label').patch({
        Title: {
          text: {
            text: currentItem.title
          }
        },
        Details: {
          text: {
            text: currentItem.details
          }
        }
      });
      this._label.appear.start();
      this._label.fadeIn.start();
      if (skipDelay) {
        this._label.appear.skipDelay();
        this._label.fadeIn.skipDelay();
      }
    }
  }, {
    key: "_startBackgroundAnimation",
    value: function _startBackgroundAnimation(index) {
      var skipDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this._container.children[index].fadeIn.start();
      if (skipDelay) {
        this._container.children[index].fadeIn.skipDelay();
      }
      this._container.children[index].idle.start();
    }
  }, {
    key: "_reset",
    value: function _reset() {
      if (this._screenSaverTimeout) {
        clearTimeout(this._screenSaverTimeout);
      }
      this._container.children.forEach(function (item) {
        item.fadeIn.stopNow();
        item.fadeOut.stopNow();
        item.idle.stopNow();
      });
      this._label.appear.stopNow();
      this._label.fadeIn.stopNow();
      this._label.fadeOut.stopNow();
      this._appearAnimation.stopNow();
      this._logoAppearAnimation.stopNow();
      this._labelSwapTimer.stopNow();
      this._backgroundSwapTimer.stopNow();
      this._iterationTimer.stopNow();
      this._index = 0;
      this.alpha = 0;
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()(screenSaver_style_getInitialStyle(), {
        rect: true,
        Logo: {
          type: BrandIcon
        }
      });
    }
  }]);
  return ScreenSaver;
}(src_Lightning.Component);

;// CONCATENATED MODULE: ./src/modules/tornado/snack-bar/snackBar.style.js

var _text, snackBar_style_background, snackBar_style_HEIGHT, snackBar_style_ICON_SIZE, snackBar_style_ICON_MARGIN_RIGHT;
function snackBar_style_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function snackBar_style_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? snackBar_style_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : snackBar_style_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }







var snackBar_style_defaultContext = makeDefaultStylingContext();
var tertiary = makeThemeColor(TERTIARY);
var snackBar_style_colors = {
  text: (_text = {}, (0,defineProperty/* default */.Z)(_text, NOTIFICATION_LEVEL.SYSTEM, tertiary), (0,defineProperty/* default */.Z)(_text, NOTIFICATION_LEVEL.SUCCESS, tertiary), (0,defineProperty/* default */.Z)(_text, NOTIFICATION_LEVEL.WARNING, tertiary), (0,defineProperty/* default */.Z)(_text, NOTIFICATION_LEVEL.ERROR, makeThemeColor(PRIMARY)), _text),
  background: (snackBar_style_background = {}, (0,defineProperty/* default */.Z)(snackBar_style_background, NOTIFICATION_LEVEL.SYSTEM, makeThemeColor(UTILITY4)), (0,defineProperty/* default */.Z)(snackBar_style_background, NOTIFICATION_LEVEL.SUCCESS, makeThemeColor(UTILITY2)), (0,defineProperty/* default */.Z)(snackBar_style_background, NOTIFICATION_LEVEL.WARNING, makeThemeColor(UTILITY3)), (0,defineProperty/* default */.Z)(snackBar_style_background, NOTIFICATION_LEVEL.ERROR, makeThemeColor(UTILITY1)), snackBar_style_background)
};
var snack_bar_snackBar_style_HEIGHT = (snackBar_style_HEIGHT = {}, (0,defineProperty/* default */.Z)(snackBar_style_HEIGHT, FULL_HD, 68 + safetyMargins.vertical[FULL_HD]), (0,defineProperty/* default */.Z)(snackBar_style_HEIGHT, HD, 64 + safetyMargins.vertical[HD]), snackBar_style_HEIGHT);
var snack_bar_snackBar_style_ICON_SIZE = (snackBar_style_ICON_SIZE = {}, (0,defineProperty/* default */.Z)(snackBar_style_ICON_SIZE, FULL_HD, 32), (0,defineProperty/* default */.Z)(snackBar_style_ICON_SIZE, HD, 32), snackBar_style_ICON_SIZE);
var snack_bar_snackBar_style_ICON_MARGIN_RIGHT = (snackBar_style_ICON_MARGIN_RIGHT = {}, (0,defineProperty/* default */.Z)(snackBar_style_ICON_MARGIN_RIGHT, FULL_HD, 16), (0,defineProperty/* default */.Z)(snackBar_style_ICON_MARGIN_RIGHT, HD, 16), snackBar_style_ICON_MARGIN_RIGHT);
var snackBar_style_getInitialStyle = function getInitialStyle() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : snackBar_style_defaultContext;
  var screenSize = context.screenSize,
    colorMode = context.colorMode;
  var h = snack_bar_snackBar_style_HEIGHT[screenSize];
  return {
    h: h,
    Content: {
      w: identity,
      h: h,
      y: h,
      color: snackBar_style_colors.background[NOTIFICATION_LEVEL.SYSTEM][colorMode],
      Inner: {
        w: identity,
        h: h - safetyMargins.vertical[screenSize],
        Icon: {
          iconData: {
            picto: {
              name: 'CheckFocused',
              collection: ICON_COLLECTION.BASIC
            },
            viewBox: {
              h: snack_bar_snackBar_style_ICON_SIZE[screenSize]
            }
          },
          color: snackBar_style_colors.text[NOTIFICATION_LEVEL.SYSTEM][colorMode],
          flexItem: {
            marginRight: snack_bar_snackBar_style_ICON_MARGIN_RIGHT[screenSize]
          }
        },
        Caption: {
          text: snackBar_style_objectSpread(snackBar_style_objectSpread({}, src_getFont(constants_FONT.OTTAWA_2)), {}, {
            verticalAlign: 'middle',
            textColor: snackBar_style_colors.text[NOTIFICATION_LEVEL.SYSTEM][colorMode]
          })
        },
        flex: {
          direction: 'row',
          justifyContent: 'center',
          alignItems: 'center'
        }
      }
    }
  };
};
;// CONCATENATED MODULE: ./src/modules/tornado/snack-bar/snackBar.constants.js
var HIDE_TIMEOUT = 2500;
;// CONCATENATED MODULE: ./src/modules/tornado/snack-bar/snackBar.component.js





function snackBar_component_createSuper(t) { var r = snackBar_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function snackBar_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (snackBar_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }







var SnackBar = function (_Lightning$Component) {
  (0,inherits/* default */.Z)(SnackBar, _Lightning$Component);
  var _super = snackBar_component_createSuper(SnackBar);
  function SnackBar() {
    (0,classCallCheck/* default */.Z)(this, SnackBar);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(SnackBar, [{
    key: "_construct",
    value: function _construct() {
      this._style = snackBar_style_defaultContext;
    }
  }, {
    key: "_detach",
    value: function _detach() {
      if (this._hideTimeout) {
        clearTimeout(this._hideTimeout);
        this._hideTimeout = undefined;
      }
    }
  }, {
    key: "push",
    value: function push(notification) {
      var _this = this;
      if (!notification) {
        return;
      }
      var contentColor = get_default()(snackBar_style_colors.text, [notification.level, this._style.colorMode]);
      var icon = notification.icon || {
        name: notification.level === NOTIFICATION_LEVEL.SUCCESS ? 'CheckFocused' : 'Info'
      };
      this.tag('Content').patch({
        smooth: {
          color: get_default()(snackBar_style_colors.background, [notification.level, this._style.colorMode]),
          y: 0
        },
        Inner: {
          Icon: {
            color: contentColor,
            iconData: {
              picto: icon,
              viewBox: {
                h: snack_bar_snackBar_style_ICON_SIZE[this._style.screenSize]
              }
            }
          },
          Caption: {
            text: {
              text: notification.text,
              textColor: contentColor
            }
          }
        }
      });
      if (this._hideTimeout) {
        clearTimeout(this._hideTimeout);
      }
      this._hideTimeout = setTimeout(function () {
        _this.tag('Content').setSmooth('y', snack_bar_snackBar_style_HEIGHT[_this._style.screenSize]);
      }, HIDE_TIMEOUT);
    }
  }], [{
    key: "_template",
    value: function _template() {
      return merge_default()({
        Content: {
          rect: true,
          Inner: {
            Icon: {
              type: Icon
            },
            Caption: {
              text: {}
            }
          }
        }
      }, snackBar_style_getInitialStyle());
    }
  }]);
  return SnackBar;
}(src_Lightning.Component);
;// CONCATENATED MODULE: ./src/modules/app/platform/default/app.component.js












var app_component_excluded = ["url"];
function app_component_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function app_component_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? app_component_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : app_component_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function app_component_createSuper(t) { var r = app_component_isNativeReflectConstruct(); return function () { var e, o = (0,getPrototypeOf/* default */.Z)(t); if (r) { var s = (0,getPrototypeOf/* default */.Z)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0,possibleConstructorReturn/* default */.Z)(this, e); }; }
function app_component_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (app_component_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }




























var App = function (_Router$App) {
  (0,inherits/* default */.Z)(App, _Router$App);
  var _super = app_component_createSuper(App);
  function App() {
    (0,classCallCheck/* default */.Z)(this, App);
    return _super.apply(this, arguments);
  }
  (0,createClass/* default */.Z)(App, [{
    key: "_construct",
    value: function _construct() {
      this._style = app_style_defaultContext;
    }
  }, {
    key: "_setup",
    value: function _setup() {
      Router.startRouter(modules_routes_routes, this);
    }
  }, {
    key: "_attach",
    value: function _attach() {
      this._unsubscribe = app_connector(this);
      this.tag('ScreenSaver').resetTimer();
      patchKeyListener(this);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      if (this._unsubscribe) {
        this._unsubscribe();
        this._unsubscribe = null;
      }
      this._cleanup();
    }
  }, {
    key: "isAppInitialized",
    set: function set(value) {
      this._isAppInitialized = value;
    }
  }, {
    key: "isOpenedViaDeeplink",
    set: function set(value) {
      this._shouldNavigateToHomeOnBack = value;
    }
  }, {
    key: "promptBeforeExitFeature",
    set: function set(value) {
      this._promptBeforeExitFeature = value;
    }
  }, {
    key: "shouldDisplayCookieConsent",
    set: function set(value) {
      lightningjs_redux.dispatch(setScreenSaverIsLocked(value));
      if (value) {
        this._setState('Widgets.CookieConsent');
      }
    }
  }, {
    key: "popUp",
    set: function set(value) {
      if (value) {
        this.tag('Popup').content = value;
        Router.focusWidget('Popup');
      }
    }
  }, {
    key: "currentRoute",
    set: function set(value) {
      var livePath = "".concat(LIVE_PATH, "/");
      var videoPath = "".concat(VIDEO_PATH, "/");
      this._currentRoute = value;
      if (value.includes(livePath) || value.includes(videoPath)) {
        this.patch({
          color: app_style_colors.transparent
        });
      }
    }
  }, {
    key: "_captureKey",
    value: function _captureKey() {
      this.tag('ScreenSaver').resetTimer();
      return false;
    }
  }, {
    key: "_handleLeft",
    value: function _handleLeft() {
      var sidenav = this.tag('Sidenav');
      var isNavigationActive = sidenav.visible && sidenav.isActive;
      if (!isNavigationActive) {
        console.warn('[app] Navigation is not active');
        return false;
      }
      var activeWidget = Router.getActiveWidget();
      if (activeWidget && activeWidget.ref !== 'Sidenav') {
        return false;
      }
      this.tag('Pages').setSmooth('x', EXPANDED_WIDTH[this._style.screenSize] - WIDTH[this._style.screenSize], animationConfig);
      Router.focusWidget('Sidenav');
      return true;
    }
  }, {
    key: "$notification",
    value: function $notification(notification) {
      this.tag('SnackBar').push(notification);
    }
  }, {
    key: "_handleAppClose",
    value: function _handleAppClose() {
      if (this._shouldNavigateToHomeOnBack && !DEEP_LINK_EXCLUSIONS.includes(this._currentRoute)) {
        Router.navigate(HOME_PATH);
        return;
      }
      if (this._isAppInitialized && this._promptBeforeExitFeature) {
        lightningjs_redux.dispatch(showPopupAction(EXIT_POPUP_ID));
      } else {
        this._handleExitApp();
      }
    }
  }, {
    key: "_handleExitApp",
    value: function _handleExitApp() {
      this._cleanup();
      closeApp(this.application);
    }
  }, {
    key: "_cleanup",
    value: function _cleanup() {
      if (this._cleanupComplete) {
        return;
      }
      console.log('[app.component] Shutting down analytics engines');
      cleanupEngines();
      console.log('[app.component] Removing redundant window globals added during the app lifecycle');
      cleanupGlobals();
      console.log('[app.component] Purging views virtualization cache');
      cleanupVirtualizationCache();
      cleanupIconsCache();
      console.log('[app.component] Purging layout API cache');
      lightningjs_redux.dispatch(clearCache());
      console.log('[app.component] Removing unsubscribed Redux observers');
      lightningjs_redux.cleanup();
      console.log('[app.component] Removing error handling observers');
      unsubscribeThirdPartyErrorHandlers();
      destroy();
      cleanupConfig();
      this._cleanupComplete = true;
    }
  }, {
    key: "_hidePopUp",
    value: function _hidePopUp() {
      this.tag('Popup').reset();
      Router.restoreFocus();
    }
  }, {
    key: "_handleRouteBack",
    value: function _handleRouteBack() {
      Router.back();
      this._hidePopUp();
    }
  }, {
    key: "_showScreensaver",
    value: function _showScreensaver() {
      if (this.tag('ScreenSaver').canBeShown) {
        Router.focusWidget('ScreenSaver');
      }
    }
  }], [{
    key: "getFonts",
    value: function getFonts() {
      return dictionary_descriptors.map(function (_ref) {
        var url = _ref.url,
          rest = objectWithoutProperties_objectWithoutProperties(_ref, app_component_excluded);
        return app_component_objectSpread({
          url: getFullPath(url)
        }, rest);
      });
    }
  }, {
    key: "_template",
    value: function _template() {
      var _signals, _signals2;
      return merge_default()(app_component_objectSpread(app_component_objectSpread({}, (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(App), "_template", this).call(this)), {}, {
        rect: true,
        forceZIndexContext: true,
        Pages: {
          zIndex: 0
        },
        Widgets: {
          zIndex: 100,
          forceZIndexContext: true,
          Sidenav: {
            type: Sidenav,
            zIndex: 101
          },
          Popup: {
            type: PopupContainer,
            zIndex: 103,
            signals: (_signals = {}, (0,defineProperty/* default */.Z)(_signals, EXIT_APP_SIGNAL, '_handleExitApp'), (0,defineProperty/* default */.Z)(_signals, HIDE_POPUP_SIGNAL, '_hidePopUp'), (0,defineProperty/* default */.Z)(_signals, ROUTE_BACK_SIGNAL, '_handleRouteBack'), _signals)
          },
          SnackBar: {
            type: SnackBar,
            zIndex: 104
          },
          CookieConsent: {
            type: CookieConsent,
            zIndex: 105
          },
          ScreenSaver: {
            type: ScreenSaver,
            zIndex: 106,
            signals: (_signals2 = {}, (0,defineProperty/* default */.Z)(_signals2, SHOW_SCREENSAVER_SIGNAL, '_showScreensaver'), (0,defineProperty/* default */.Z)(_signals2, HIDE_SCREENSAVER_SIGNAL, '_hideScreensaver'), _signals2)
          }
        }
      }), app_style_getInitialStyle());
    }
  }, {
    key: "_states",
    value: function _states() {
      var _get$call = (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(App), "_states", this).call(this),
        _get$call2 = (0,slicedToArray/* default */.Z)(_get$call, 2),
        Loading = _get$call2[0],
        WidgetsBaseState = _get$call2[1];
      return [Loading, function (_WidgetsBaseState) {
        (0,inherits/* default */.Z)(Widgets, _WidgetsBaseState);
        var _super2 = app_component_createSuper(Widgets);
        function Widgets() {
          (0,classCallCheck/* default */.Z)(this, Widgets);
          return _super2.apply(this, arguments);
        }
        (0,createClass/* default */.Z)(Widgets, [{
          key: "currentWidgetRef",
          get: function get() {
            return this._widget ? this._widget.ref : '';
          }
        }, {
          key: "reload",
          value: function reload(widget) {
            this._previousWidgetRef = this.currentWidgetRef;
            (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(Widgets.prototype), "reload", this).call(this, widget);
          }
        }, {
          key: "_showScreensaver",
          value: function _showScreensaver() {
            var currentWidgetRef = this.currentWidgetRef;
            if (currentWidgetRef === 'Popup') {
              var popUpContainer = this.tag('Popup');
              if (BANNED_POPUPS.includes(popUpContainer.popupId)) {
                return;
              }
            }
            if (!BANNED_WIDGETS.includes(currentWidgetRef)) {
              (0,esm_get/* default */.Z)((0,getPrototypeOf/* default */.Z)(Widgets.prototype), "_showScreensaver", this).call(this);
            }
          }
        }, {
          key: "_hideScreensaver",
          value: function _hideScreensaver() {
            var previousWidget = this._previousWidgetRef ? this.tag("Widgets.".concat(this._previousWidgetRef)) : null;
            if (previousWidget) {
              this.reload(previousWidget);
            } else {
              Router.restoreFocus();
            }
          }
        }, {
          key: "_handleRight",
          value: function _handleRight() {
            Router.restoreFocus();
          }
        }, {
          key: "_handleKey",
          value: function _handleKey() {
            return false;
          }
        }, {
          key: "$exit",
          value: function $exit() {
            this.tag('Pages').setSmooth('x', 0, animationConfig);
            this.tag('ScreenSaver').resetTimer();
            this._widget = null;
            this._previousWidgetRef = '';
          }
        }], [{
          key: "_states",
          value: function _states() {
            return [function (_this) {
              (0,inherits/* default */.Z)(CookieConsent, _this);
              var _super3 = app_component_createSuper(CookieConsent);
              function CookieConsent() {
                (0,classCallCheck/* default */.Z)(this, CookieConsent);
                return _super3.apply(this, arguments);
              }
              (0,createClass/* default */.Z)(CookieConsent, [{
                key: "shouldDisplayCookieConsent",
                set: function set(value) {
                  lightningjs_redux.dispatch(setScreenSaverIsLocked(value));
                  if (value) {
                    return;
                  }
                  var popUpContainer = this.tag('Popup');
                  if (popUpContainer.popupId) {
                    Router.focusWidget('Popup');
                    this.reload(popUpContainer);
                  } else {
                    Router.restoreFocus();
                  }
                }
              }, {
                key: "popUp",
                set: function set(value) {
                  if (value) {
                    this.tag('Popup').content = value;
                  }
                }
              }, {
                key: "_hidePopUp",
                value: function _hidePopUp() {
                  this.tag('Popup').reset();
                }
              }, {
                key: "_getFocused",
                value: function _getFocused() {
                  return this.tag('CookieConsent');
                }
              }]);
              return CookieConsent;
            }(this)];
          }
        }]);
        return Widgets;
      }(WidgetsBaseState)];
    }
  }]);
  return App;
}(Router.App);

;// CONCATENATED MODULE: ./src/modules/polyfills/performance/performance.polyfill.js
var setupPerformancePolyfill = function setupPerformancePolyfill(window) {
  var startOffset = Date.now ? Date.now() : +new Date();
  var performance = window.performance || {};
  if (!performance.now) {
    var polyfill = function polyfill() {
      return (Date.now ? Date.now() : +new Date()) - startOffset;
    };
    performance.now = performance.webkitNow || performance.mozNow || performance.msNow || polyfill;
  }
  if (!performance.mark) {
    performance.mark = function () {};
  }
  if (!performance.measure) {
    performance.measure = function () {};
  }
  window.performance = performance;
};
;// CONCATENATED MODULE: ./src/modules/polyfills/platform/default.js

var default_setup = function setup(window) {
  setupPerformancePolyfill(window);
};
// EXTERNAL MODULE: ./node_modules/.pnpm/symbol-observable@1.2.0/node_modules/symbol-observable/es/index.js + 1 modules
var es = __webpack_require__(61603);
;// CONCATENATED MODULE: ./node_modules/.pnpm/redux@4.0.5/node_modules/redux/es/redux.js


/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function redux_isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!redux_isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[es/* default */.Z] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[es/* default */.Z] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
  return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!redux_isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + ActionTypes.INIT + " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {}

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {}

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) { var warningMessage; }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

function redux_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function redux_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function redux_objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      redux_ownKeys(source, true).forEach(function (key) {
        redux_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      redux_ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return redux_objectSpread2({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (false) {}



;// CONCATENATED MODULE: ./node_modules/.pnpm/redux-thunk@2.3.0_redux@4.0.5/node_modules/redux-thunk/es/index.js
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

/* harmony default export */ const redux_thunk_es = (thunk);
;// CONCATENATED MODULE: ./src/logic/analytics/analytics.reducer.js

function analytics_reducer_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function analytics_reducer_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? analytics_reducer_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : analytics_reducer_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


var initialState = {};
/* harmony default export */ const analytics_reducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case INITIALIZE_ENGINES:
      {
        return analytics_reducer_objectSpread(analytics_reducer_objectSpread({}, state), enginesNamesToEnabledStateMap(action.engines, false));
      }
    case ACCEPT_ENGINES:
      {
        return analytics_reducer_objectSpread(analytics_reducer_objectSpread({}, state), enginesNamesToEnabledStateMap(action.engines, true));
      }
    default:
      {
        return state;
      }
  }
});
;// CONCATENATED MODULE: ./src/logic/app/app.reducer.js

function app_reducer_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function app_reducer_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? app_reducer_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : app_reducer_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


var app_reducer_initialState = {
  ads: null,
  deviceBrand: '',
  deviceModel: '',
  deviceVersion: '',
  initializing: false,
  initialized: false,
  initialElapsedTime: null,
  initializeRetriesCount: 0,
  serverTime: null,
  hasKeysControl: true,
  startoverMinDepth: null,
  startoverMaxDepth: null,
  startoverMinPercentage: null,
  startoverMaxPercentage: null,
  country: null,
  currentService: null,
  connected: true,
  screenSize: null
};
/* harmony default export */ const app_reducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : app_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case INITIALIZE_APP:
      {
        return app_reducer_objectSpread(app_reducer_objectSpread({}, state), {}, {
          initializing: true,
          initialElapsedTime: action.initialElapsedTime,
          initializeRetriesCount: state.initializeRetriesCount + 1
        });
      }
    case INITIALIZE_APP_COMPLETED:
      {
        return app_reducer_objectSpread(app_reducer_objectSpread({}, state), {}, {
          initializing: false,
          initialized: true
        });
      }
    case SET_SERVER_TIME:
      return app_reducer_objectSpread(app_reducer_objectSpread({}, state), {}, {
        serverTime: action.serverTime
      });
    case CONFIG_INIT:
      {
        var _action$config = action.config,
          ads = _action$config.ads,
          country = _action$config.country,
          monitoring = _action$config.monitoring,
          customizer = _action$config.customizer,
          analytics = _action$config.analytics,
          _action$config$starto = _action$config.startover,
          startoverMinDepth = _action$config$starto.startoverMinDepth,
          startoverMaxDepth = _action$config$starto.startoverMaxDepth,
          startoverMinPercentage = _action$config$starto.startoverMinPercentage,
          startoverMaxPercentage = _action$config$starto.startoverMaxPercentage;
        return app_reducer_objectSpread(app_reducer_objectSpread({}, state), {}, {
          ads: ads,
          country: country,
          monitoring: monitoring,
          customizer: customizer,
          analytics: analytics,
          startoverMinDepth: startoverMinDepth,
          startoverMaxDepth: startoverMaxDepth,
          startoverMinPercentage: startoverMinPercentage,
          startoverMaxPercentage: startoverMaxPercentage
        });
      }
    case SET_CONNECTED:
      {
        return app_reducer_objectSpread(app_reducer_objectSpread({}, state), {}, {
          connected: action.connected
        });
      }
    case SET_SCREEN_SIZE:
      {
        return app_reducer_objectSpread(app_reducer_objectSpread({}, state), {}, {
          screenSize: action.size
        });
      }
    case SET_DEVICE_INFO:
      {
        var deviceBrand = action.deviceBrand,
          deviceModel = action.deviceModel,
          deviceVersion = action.deviceVersion;
        return app_reducer_objectSpread(app_reducer_objectSpread({}, state), {}, {
          deviceBrand: deviceBrand || '',
          deviceModel: deviceModel || '',
          deviceVersion: deviceVersion || ''
        });
      }
    default:
      return state;
  }
});
;// CONCATENATED MODULE: ./src/logic/features/features.reducer.js

function features_reducer_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function features_reducer_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? features_reducer_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : features_reducer_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var features_reducer_initialState = {};
/* harmony default export */ const features_reducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : features_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action && action.type) {
    case CONFIG_INIT:
      {
        return features_reducer_objectSpread(features_reducer_objectSpread({}, state), action.config.featureFlipping);
      }
    default:
      {
        return state;
      }
  }
});
// EXTERNAL MODULE: ./node_modules/.pnpm/crypto-js@3.1.9-1/node_modules/crypto-js/sha256.js
var crypto_js_sha256 = __webpack_require__(49635);
var crypto_js_sha256_default = /*#__PURE__*/__webpack_require__.n(crypto_js_sha256);
;// CONCATENATED MODULE: ./src/logic/user/user.reducer.js




var user_reducer_excluded = ["type"];
function user_reducer_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function user_reducer_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? user_reducer_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : user_reducer_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }








var user_reducer_initialState = {
  accountComplete: false,
  cookies: {},
  areUserPreferencesSet: false,
  deviceId: null,
  homeId: null,
  synchronize: false,
  localDeviceId: null,
  localHomeId: null,
  uid: null,
  profileUid: null,
  geo: null,
  lastClips: {},
  profileAvatarId: null,
  profileUsername: null,
  parentalLockStatus: false,
  previousProfileUid: null
};
/* harmony default export */ const user_reducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : user_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case CONFIG_INIT:
      {
        var cookies = action.cookies;
        return user_reducer_objectSpread(user_reducer_objectSpread({}, state), {}, {
          cookies: cookies,
          areUserPreferencesSet: !areCookiesEmpty(cookies)
        });
      }
    case RESTORE_DEVICE_DATA:
      {
        var deviceId = action.deviceId,
          homeId = action.homeId,
          synchronize = action.synchronize;
        return user_reducer_objectSpread(user_reducer_objectSpread({}, state), {}, {
          deviceId: deviceId,
          homeId: prefixWithHomeId(homeId),
          localDeviceId: removeGivenTextFromString(deviceId, 'deviceid-'),
          localHomeId: homeId,
          synchronize: synchronize
        });
      }
    case SET_USER_CONSENTS:
      {
        var type = action.type,
          _cookies = objectWithoutProperties_objectWithoutProperties(action, user_reducer_excluded);
        return user_reducer_objectSpread(user_reducer_objectSpread({}, state), {}, {
          cookies: _cookies,
          areUserPreferencesSet: true,
          synchronize: false
        });
      }
    case GENERATE_DEVICE_ID:
      {
        return user_reducer_objectSpread(user_reducer_objectSpread({}, state), {}, {
          deviceId: action.deviceId,
          localDeviceId: removeGivenTextFromString(action.deviceId, 'deviceid-')
        });
      }
    case UPDATE_DEVICE_ID:
      {
        return user_reducer_objectSpread(user_reducer_objectSpread({}, state), {}, {
          deviceId: action.deviceId,
          localDeviceId: removeGivenTextFromString(action.deviceId, 'deviceid-'),
          synchronize: false
        });
      }
    case SYNCHRONIZE_USER_CONSENTS:
      {
        return user_reducer_objectSpread(user_reducer_objectSpread({}, state), {}, {
          synchronize: true
        });
      }
    case CALL_GEO_SUCCESS:
      {
        var ip = action.data.ip;
        return user_reducer_objectSpread(user_reducer_objectSpread({}, state), {}, {
          geo: user_reducer_objectSpread(user_reducer_objectSpread({}, action.data), {}, {
            hashIp: crypto_js_sha256_default()(ip).toString()
          })
        });
      }
    case SET_USER_UID:
      {
        return user_reducer_objectSpread(user_reducer_objectSpread({}, state), {}, {
          uid: action.uid
        });
      }
    case USER_FETCH_LAST_CLIPS_SUCCESS:
      return user_reducer_objectSpread(user_reducer_objectSpread({}, state), {}, {
        lastClips: formatClipsObject(action.lastClips)
      });
    case FETCH_PROFILE_INFOS_SUCCESS:
      return user_reducer_objectSpread(user_reducer_objectSpread({}, state), {}, {
        profileAvatarId: action.profileAvatarId,
        profileUsername: action.username,
        isKidsProfile: action.isKidsProfile
      });
    case RENEW_TOKEN_SUCCESS:
      return user_reducer_objectSpread(user_reducer_objectSpread({}, state), {}, {
        profileUid: action.profileUid
      });
    case PARENTAL_LOCK_STATUS:
      return user_reducer_objectSpread(user_reducer_objectSpread({}, state), {}, {
        parentalLockStatus: action.isUnlocked
      });
    case PARING_SET_PREVIOUS_PROFILE_UID:
      return user_reducer_objectSpread(user_reducer_objectSpread({}, state), {}, {
        previousProfileUid: action.previousProfileUid
      });
    case SET_ACCOUNT_COMPLETE:
      {
        return user_reducer_objectSpread(user_reducer_objectSpread({}, state), {}, {
          accountComplete: true
        });
      }
    case PAIRING_RESET:
      {
        return user_reducer_objectSpread(user_reducer_objectSpread({}, user_reducer_initialState), {}, {
          cookies: state.cookies || {}
        });
      }
    default:
      return state;
  }
});
// EXTERNAL MODULE: ./node_modules/.pnpm/immutable-set@2.1.0/node_modules/immutable-set/lib/set.js
var lib_set = __webpack_require__(36449);
;// CONCATENATED MODULE: ./src/logic/layout/layout.reducer.js









function layout_reducer_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function layout_reducer_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? layout_reducer_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : layout_reducer_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }









var layout_reducer_initialState = {
  navigation: null,
  currentService: null,
  currentSectionCode: 'main',
  currentEntityType: null,
  currentEntityId: null,
  requestedEntityId: null,
  requestedEntityType: null
};
/* harmony default export */ const layout_reducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : layout_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var FETCHED_LAYOUT_ACTION = createSuccessActionType(action.entity);
  switch (action.type) {
    case FETCHED_LAYOUT_ACTION:
      {
        var entity = action.entity,
          id = action.id,
          data = action.data;
        var currentSectionCode = state.currentSectionCode;
        var isBookmarks = entity === layout_constants/* entities */.jF.frontspace && id === layout_constants/* frontspaces */.K_.bookmarks;
        var oldBlocks = get_default()(state, [currentSectionCode, entity, id, 'blocks'], []);
        data.blocks = data.blocks.map(function (block) {
          var _block$content = block.content,
            items = _block$content.items,
            pagination = _block$content.pagination;
          block.pages = pagesToLoad(pagination.totalItems, pagination.itemsPerPage, items);
          if (block.alternativeContent && block.alternativeContent.concurrentBlocks) {
            block.alternativeContent.concurrentBlocks = block.alternativeContent.concurrentBlocks.map(function (concurrentBlock, index) {
              var pagination = concurrentBlock.content.pagination;
              concurrentBlock.pages = pagesToLoad(pagination.totalItems, pagination.itemsPerPage, index ? [] : items);
              return concurrentBlock;
            });
          }
          return block;
        });
        if (oldBlocks.length && oldBlocks.length === data.blocks.length) {
          data.blocks = oldBlocks.map(function (oldBlock, index) {
            var newBlock = data.blocks[index];
            var featureId = newBlock.featureId;
            var isUserSpecificBlock = isBookmarks || featureId === 'bookmarks_by_user' || featureId === 'playback_by_user';
            if (oldBlock.content.items.length !== newBlock.content.items.length) {
              var count = isUserSpecificBlock ? newBlock.content.pagination.totalItems : Math.max(oldBlock.content.items.length, newBlock.content.items.length);
              var items = [];
              for (var i = 0; i < count; i += 1) {
                items.push(newBlock.content.items[i] || oldBlock.content.items[i] || PLACEHOLDER);
              }
              newBlock.content.items = items;
              if (!isUserSpecificBlock) {
                newBlock.content.pagination = oldBlock.content.pagination;
              }
            }
            var newAlt = newBlock.alternativeContent;
            var oldAlt = oldBlock.alternativeContent;
            if (newAlt && oldAlt) {
              for (var _i = 0; _i < newAlt.concurrentBlocks.length; _i += 1) {
                if (oldAlt.concurrentBlocks[_i]) {
                  newAlt.concurrentBlocks[_i] = layout_reducer_objectSpread(layout_reducer_objectSpread({}, oldAlt.concurrentBlocks[_i]), {}, {
                    pages: newAlt.concurrentBlocks[_i].pages
                  });
                }
              }
              if (newAlt.concurrentBlocks.length) {
                var content = newAlt.concurrentBlocks[0].content;
                if (content.items) {
                  var _content$items;
                  (_content$items = content.items).splice.apply(_content$items, [0, newBlock.content.items.length].concat((0,toConsumableArray/* default */.Z)(newBlock.content.items)));
                } else {
                  content.items = newBlock.content.items;
                }
              }
            }
            return newBlock;
          });
        }
        return layout_reducer_objectSpread(layout_reducer_objectSpread({}, state), {}, (0,defineProperty/* default */.Z)({
          currentService: entity === 'service' ? id : state.currentService
        }, currentSectionCode, layout_reducer_objectSpread(layout_reducer_objectSpread({}, state[currentSectionCode]), {}, (0,defineProperty/* default */.Z)({}, entity, layout_reducer_objectSpread(layout_reducer_objectSpread({}, state[currentSectionCode] && state[currentSectionCode][entity]), {}, (0,defineProperty/* default */.Z)({}, id, data))))));
      }
    case FETCH_BLOCK:
      {
        var blockId = action.blockId,
          newItems = action.items,
          pageIndex = action.pageIndex,
          parentId = action.parentId,
          newTotalItems = action.totalItems;
        var blockInfo = getBlockInfo(state, blockId, parentId);
        if (!blockInfo) {
          return state;
        }
        var _blockInfo = (0,slicedToArray/* default */.Z)(blockInfo, 2),
          path = _blockInfo[0],
          block = _blockInfo[1];
        var _block$content2 = block.content,
          currentItems = _block$content2.items,
          pagination = _block$content2.pagination;
        var lastLoadedPage = block.lastLoadedPage || 0;
        var page = pageIndex - 1;
        var totalItems = page > lastLoadedPage && newTotalItems || pagination.totalItems;
        var start = page * pagination.itemsPerPage;
        var end = start + newItems.length;
        var items = [];
        for (var i = 0; i < currentItems.length; i += 1) {
          items.push(i >= start && i < end ? newItems[i - start] : currentItems[i]);
        }
        return (0,lib_set/* default */.Z)(state, path.join('.'), layout_reducer_objectSpread(layout_reducer_objectSpread({}, block), {}, {
          lastLoadedPage: Math.max(page, lastLoadedPage),
          pages: layout_reducer_objectSpread(layout_reducer_objectSpread(layout_reducer_objectSpread({}, pagesToLoad(totalItems, pagination.itemsPerPage, items)), block.pages), {}, (0,defineProperty/* default */.Z)({}, page, PAGE_STATE.LOADED)),
          content: layout_reducer_objectSpread(layout_reducer_objectSpread({}, block.content), {}, {
            items: items,
            pagination: layout_reducer_objectSpread(layout_reducer_objectSpread({}, block.content.pagination), {}, {
              totalItems: totalItems
            })
          })
        }));
      }
    case GENERATE_BLOCK_PLACEHOLDERS:
      {
        var _blockInfo2 = getBlockInfo(state, action.blockId, action.parentId);
        if (!_blockInfo2) {
          return state;
        }
        var _blockInfo3 = (0,slicedToArray/* default */.Z)(_blockInfo2, 2),
          _path = _blockInfo3[0],
          _block = _blockInfo3[1];
        var _block$content3 = _block.content,
          _items = _block$content3.items,
          _pagination = _block$content3.pagination;
        var _start = Math.min(_items.length, action.start);
        var count = Math.min(_pagination.totalItems - _items.length, Math.max(action.start - _items.length, 0) + _pagination.itemsPerPage);
        var placeholders = [];
        for (var _i2 = 0; _i2 < count; _i2 += 1) {
          if (!_items[_start + _i2]) {
            placeholders.push(PLACEHOLDER);
          }
        }
        var _pageIndex = action.page - 1;
        return (0,lib_set/* default */.Z)(state, _path.join('.'), layout_reducer_objectSpread(layout_reducer_objectSpread({}, _block), {}, {
          content: layout_reducer_objectSpread(layout_reducer_objectSpread({}, _block.content), {}, {
            items: _items.concat(placeholders)
          }),
          pages: layout_reducer_objectSpread(layout_reducer_objectSpread({}, _block.pages), {}, (0,defineProperty/* default */.Z)({}, _pageIndex, PAGE_STATE.LOADING))
        }));
      }
    case CLEAR_CACHE:
      {
        var entityType = action.entityType,
          entityId = action.entityId,
          sectionCode = action.sectionCode;
        var _path2 = [sectionCode, entityType, entityId].filter(Boolean);
        if (!_path2.length) {
          return layout_reducer_objectSpread(layout_reducer_objectSpread({}, state), {}, {
            main: {},
            kids: {}
          });
        }
        var pathToOmit = _path2.pop();
        return layout_reducer_objectSpread({
          contentTemplatesOptions: state.contentTemplatesOptions
        }, (0,lib_set/* default */.Z)(state, _path2.join('.'), omit_default()(get_default()(state, _path2.join('.')), pathToOmit)));
      }
    case INVALIDATE_ITEM_CACHE:
      {
        var itemIndex = action.itemIndex,
          blockIndex = action.blockIndex;
        if (!isValidItemPosition(blockIndex, itemIndex) || !action.item) {
          return state;
        }
        var requestedEntityId = state.requestedEntityId,
          requestedEntityType = state.requestedEntityType,
          _currentSectionCode = state.currentSectionCode;
        var _path3 = "".concat(_currentSectionCode, ".").concat(requestedEntityType, ".").concat(requestedEntityId, ".blocks[").concat(blockIndex, "].content.items[").concat(itemIndex, "]");
        var item = get_default()(state, _path3);
        return item ? (0,lib_set/* default */.Z)(state, _path3, merge_default()({}, item, action.item)) : state;
      }
    case REPLACE_BLOCK:
      {
        var _blockId = action.blockId,
          _newItems = action.items,
          newDate = action.date;
        var _requestedEntityId = state.requestedEntityId,
          _requestedEntityType = state.requestedEntityType,
          _currentSectionCode2 = state.currentSectionCode;
        var blocks = get_default()(state, [_currentSectionCode2, _requestedEntityType, _requestedEntityId, 'blocks'], []);
        var _blockIndex = blocks.findIndex(function (_ref) {
          var id = _ref.id;
          return id === _blockId;
        });
        var _path4 = [_currentSectionCode2, _requestedEntityType, _requestedEntityId, "blocks[".concat(_blockIndex, "]"), 'content'].join('.');
        return (0,lib_set/* default */.Z)(state, _path4, layout_reducer_objectSpread(layout_reducer_objectSpread({}, get_default()(state, _path4, {})), {}, {
          items: _newItems,
          date: newDate
        }));
      }
    case FETCH_NAVIGATION_SUCCESS:
      {
        if (!action.navigation) return state;
        return (0,lib_set/* default */.Z)(state, [state.currentSectionCode, 'navigation'], action.navigation);
      }
    case SET_CURRENT_ENTITY:
      {
        return layout_reducer_objectSpread(layout_reducer_objectSpread({}, state), {}, {
          currentEntityType: action.entityType,
          currentEntityId: action.entityId
        });
      }
    case SET_CURRENT_ENTITY_TYPE:
      {
        return layout_reducer_objectSpread(layout_reducer_objectSpread({}, state), {}, {
          currentEntityType: action.entityType
        });
      }
    case SET_CURRENT_ENTITY_ID:
      {
        return layout_reducer_objectSpread(layout_reducer_objectSpread({}, state), {}, {
          currentEntityId: action.entityId
        });
      }
    case SET_CURRENT_SECTION_CODE:
      {
        return layout_reducer_objectSpread(layout_reducer_objectSpread({}, state), {}, {
          currentSectionCode: action.sectionCode
        });
      }
    case SET_REQUESTED_ENTITY:
      {
        return layout_reducer_objectSpread(layout_reducer_objectSpread({}, state), {}, {
          requestedEntityId: action.entityId,
          requestedEntityType: action.entityType
        });
      }
    case SET_CONTENT_TEMPLATES_OPTIONS:
      {
        return layout_reducer_objectSpread(layout_reducer_objectSpread({}, state), {}, {
          contentTemplatesOptions: action.contentTemplatesOptions
        });
      }
    default:
      {
        return state;
      }
  }
});
;// CONCATENATED MODULE: ./src/logic/lock/lock.reducer.js

function lock_reducer_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function lock_reducer_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? lock_reducer_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : lock_reducer_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var lock_reducer_initialState = {
  shouldDisplayProfilesGate: false
};
/* harmony default export */ const lock_reducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : lock_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action && action.type) {
    case SHOW_PROFILES_GATE:
      {
        return lock_reducer_objectSpread(lock_reducer_objectSpread({}, state), {}, {
          shouldDisplayProfilesGate: true
        });
      }
    default:
      {
        return state;
      }
  }
});
;// CONCATENATED MODULE: ./src/logic/pairing/pairing.reducer.js

function pairing_reducer_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function pairing_reducer_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? pairing_reducer_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : pairing_reducer_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }




var pairing_reducer_initialState = {
  token: null,
  verificationURI: null,
  status: null,
  email: '',
  subscriptions: null,
  catalogAccess: null,
  photoUrl: null,
  firstname: '',
  lastname: '',
  parentalControl: null,
  isUnpairedEntering: false,
  profileUid: null,
  selectedProfileUid: null,
  pollingInterval: src.pairing.pairingPollInterval
};
/* harmony default export */ const pairing_reducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : pairing_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case PAIRING_SET_POLLING_INTERVAL:
      {
        return pairing_reducer_objectSpread(pairing_reducer_objectSpread({}, state), {}, {
          pollingInterval: action.pollingInterval
        });
      }
    case PAIRING_INCREMENT_POLLING_INTERVAL:
      {
        return pairing_reducer_objectSpread(pairing_reducer_objectSpread({}, state), {}, {
          pollingInterval: (state.pollingInterval || pairing_reducer_initialState.pollingInterval) + 5000
        });
      }
    case PAIRING_SET_PARENTAL_LOCK_STATUS:
      return pairing_reducer_objectSpread(pairing_reducer_objectSpread({}, state), {}, {
        parentalControl: action.parentalControlStatus
      });
    case PAIRING_FETCH_TOKEN_SUCCESS:
      return pairing_reducer_objectSpread(pairing_reducer_objectSpread({}, state), {}, {
        token: action.token,
        verificationURI: action.verificationURI
      });
    case PAIRING_CLEAR_TOKEN:
      return pairing_reducer_objectSpread(pairing_reducer_objectSpread({}, state), {}, {
        token: null,
        verificationURI: null
      });
    case PAIRING_FETCH_STATUS_SUCCESS:
      return pairing_reducer_objectSpread(pairing_reducer_objectSpread({}, state), {}, {
        status: action.status
      });
    case PAIRING_FETCH_USER_SUCCESS:
      return pairing_reducer_objectSpread(pairing_reducer_objectSpread(pairing_reducer_objectSpread({}, state), action.user), {}, {
        status: STATUS_PAIRED
      });
    case SET_SUBSCRIPTIONS:
      return pairing_reducer_objectSpread(pairing_reducer_objectSpread({}, state), {}, {
        subscriptions: action.subscriptions
      });
    case PAIRING_LOGOUT_SUCCESS:
      return pairing_reducer_objectSpread(pairing_reducer_objectSpread({}, pairing_reducer_initialState), {}, {
        isUnpairedEntering: state.isUnpairedEntering
      });
    case RENEW_TOKEN_SUCCESS:
      return pairing_reducer_objectSpread(pairing_reducer_objectSpread({}, state), {}, {
        profileUid: action.profileUid
      });
    case SELECT_USER_PROFILE:
      return pairing_reducer_objectSpread(pairing_reducer_objectSpread({}, state), {}, {
        selectedProfileUid: action.profileUid
      });
    case CLEAR_USER_PROFILE:
      return pairing_reducer_objectSpread(pairing_reducer_objectSpread({}, state), {}, {
        profileUid: null,
        selectedProfileUid: null
      });
    case PAIRING_SET_UNPAIRED_ENTERING:
      return pairing_reducer_objectSpread(pairing_reducer_objectSpread({}, state), {}, {
        isUnpairedEntering: true
      });
    case PAIRING_CLEAR_UNPAIRED_ENTERING:
      return pairing_reducer_objectSpread(pairing_reducer_objectSpread({}, state), {}, {
        isUnpairedEntering: false
      });
    case PAIRING_RESET:
      {
        return pairing_reducer_initialState;
      }
    default:
      return state;
  }
});
;// CONCATENATED MODULE: ./src/logic/player/player.reducer.js









var player_reducer_excluded = ["type"];
function player_reducer_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function player_reducer_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? player_reducer_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : player_reducer_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }







var player_reducer_initialState = {
  isLive: false,
  isStarted: false,
  canPlay: false,
  isLoadingContent: false,
  isBuffering: false,
  playbackState: PLAYBACK_STATE_IDLE,
  adPlaybackState: PLAYBACK_STATE_IDLE,
  adBreakDuration: 0,
  adBreakElapsedTime: 0,
  isPlayingAds: false,
  isAdJingleDisplayed: false,
  isAdProviderReady: false,
  isAdError: false,
  isAdBreakDisplayed: false,
  pauseAd: null,
  pauseAdState: PAUSE_AD_STATE.IDLE,
  displayedAdBreakType: null,
  durationInSeconds: 0,
  startTimeInSeconds: 0,
  elapsedTimeInSeconds: undefined,
  liveEdgeInSeconds: 0,
  timeUpdateTicks: 0,
  isOnLive: false,
  shouldHideVideoLoader: false,
  currentSourceIndex: null,
  sideGlass: null,
  programImageId: '',
  jingleImageId: '',
  sources: [],
  contentType: '',
  preferences: null,
  originalLanguage: '',
  selectedSubtitlesTrack: null,
  selectedAudioTrack: null,
  audioTracks: [],
  subtitleTracks: [],
  subtitleCuePoint: null,
  chapter: null,
  chapters: [],
  playerLocked: false,
  metadataItems: [],
  currentMetadataItemIndex: 0,
  lastMetadataItemIndex: 0,
  isNextLiveLayoutLoading: false,
  timeToLoadNewLayout: 0,
  liveStartOverFeature: false,
  lastViewedClipId: '',
  lastViewedClipProgress: 0,
  lastError: null
};
/* harmony default export */ const player_reducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : player_reducer_initialState;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    type = _ref.type,
    data = objectWithoutProperties_objectWithoutProperties(_ref, player_reducer_excluded);
  switch (type) {
    case LOCKED:
      {
        return player_reducer_objectSpread(player_reducer_objectSpread({}, player_reducer_initialState), {}, {
          playerLocked: true
        });
      }
    case INITIALIZED:
      {
        var layout = data.layout,
          isLive = data.isLive,
          item = data.item,
          entityId = data.entityId,
          entityType = data.entityType;
        var startTimeInSeconds = isLive ? get_default()(item, 'video.progress.live.startTimestamp', 0) : 0;
        var endTimeInSeconds = isLive ? get_default()(item, 'video.progress.live.endTimestamp', 0) : timeTitleToSeconds(get_default()(item, 'video.progress.endTitle'));
        var durationInSeconds = endTimeInSeconds - startTimeInSeconds;
        var elapsedTimeInSeconds = isLive ? undefined : get_default()(item, 'video.progress.tcResume', 0);
        var sources = arrangeSources(item).map(function (source) {
          source.isLive = isLive;
          source.shouldAutoPlay = isLive;
          source.startTime = endTimeInSeconds - elapsedTimeInSeconds >= 5 ? elapsedTimeInSeconds : undefined;
          return source;
        });
        var playerBlock = findPlayerBlock(get_default()(layout, 'blocks'));
        var lastMetadataItemIndex = get_default()(playerBlock, 'content.items.length', 0) - 1;
        var timeToLoadNewLayout = getTimeToRequestNewMetadataInSeconds(durationInSeconds);
        var liveStartOverFeature = isLive ? get_default()(item, 'video.features.startOver', false) : false;
        var originalLanguage = get_default()(item, 'video.originalLanguage') || '';
        var result = player_reducer_objectSpread(player_reducer_objectSpread({}, player_reducer_initialState), {}, {
          sources: sources,
          preferences: get_default()(item, 'video.features.preferences') || {},
          originalLanguage: originalLanguage,
          lastMetadataItemIndex: lastMetadataItemIndex,
          timeToLoadNewLayout: timeToLoadNewLayout,
          currentSourceIndex: selectNextPlayableSource({
            sources: sources
          }),
          programImageId: getVideoItemProgramImageId(item),
          jingleImageId: player_utils_getJingleImageId(item),
          adJingleImageId: player_utils_getAdJingleImageId(item),
          sideGlass: findSideGlassBlock(layout),
          durationInSeconds: durationInSeconds,
          startTimeInSeconds: startTimeInSeconds,
          elapsedTimeInSeconds: elapsedTimeInSeconds,
          chapters: (get_default()(item, 'video.chapters') || []).map(function (_ref2) {
            var tcEnd = _ref2.tcEnd,
              tcStart = _ref2.tcStart,
              type = _ref2.type;
            return {
              tcStart: Math.min(tcStart + CHAPTER_START_OFFSET_IN_SECONDS, tcEnd),
              tcEnd: tcEnd,
              type: type
            };
          }),
          metadataItems: isLive ? getMetadataItemsFromLayout(layout) : [item],
          isLive: isLive,
          liveStartOverFeature: liveStartOverFeature,
          lastViewedClipId: entityId,
          contentType: entityType
        });
        return result;
      }
    case LOAD_CONTENT:
      return player_reducer_objectSpread(player_reducer_objectSpread({}, state), {}, {
        isLoadingContent: true
      });
    case player_constants_MANIFEST_LOADED:
      {
        if (!Number.isFinite(state.elapsedTimeInSeconds) && state.isLive) {
          return player_reducer_objectSpread(player_reducer_objectSpread({}, state), {}, {
            elapsedTimeInSeconds: Math.round(Date.now() / 1000) - state.startTimeInSeconds - get_default()(data, 'payload.presentationDelay', 0)
          });
        }
        return state;
      }
    case SET_CURRENT_METADATA_ITEM:
      {
        var _layout = data.layout,
          _item = data.item;
        var _startTimeInSeconds = get_default()(_item, 'video.progress.live.startTimestamp', 0);
        var _endTimeInSeconds = get_default()(_item, 'video.progress.live.endTimestamp', 0);
        var _durationInSeconds = _endTimeInSeconds - _startTimeInSeconds;
        var currentMetadataItemIndex = findCurrentMetadataItemIndex(_layout, _item);
        var _timeToLoadNewLayout = getTimeToRequestNewMetadataInSeconds(_durationInSeconds);
        return player_reducer_objectSpread(player_reducer_objectSpread({}, state), {}, {
          startTimeInSeconds: _startTimeInSeconds,
          durationInSeconds: _durationInSeconds,
          currentMetadataItemIndex: currentMetadataItemIndex,
          timeToLoadNewLayout: _timeToLoadNewLayout
        });
      }
    case APPEND_NEW_METADATA_ITEMS:
      {
        return player_reducer_objectSpread(player_reducer_objectSpread({}, state), {}, {
          metadataItems: state.metadataItems.concat(data.programs)
        });
      }
    case UPDATE_METADATA:
      {
        if (!data.payload) {
          return state;
        }
        var _currentMetadataItemIndex = state.currentMetadataItemIndex;
        var currentItem = state.metadataItems[_currentMetadataItemIndex];
        if (!currentItem) {
          return state;
        }
        var fieldsToUpdate = Object.keys(data.payload).filter(function (key) {
          return currentItem[key] !== data.payload[key];
        });
        if (!fieldsToUpdate.length) {
          return state;
        }
        return player_reducer_objectSpread(player_reducer_objectSpread({}, state), {}, {
          metadataItems: state.metadataItems.map(function (value, index) {
            return index === _currentMetadataItemIndex ? player_reducer_objectSpread(player_reducer_objectSpread({}, value), data.payload) : value;
          })
        });
      }
    case RESET:
      return player_reducer_objectSpread(player_reducer_objectSpread({}, player_reducer_initialState), {}, {
        lastViewedClipId: state.lastViewedClipId,
        lastViewedClipProgress: state.elapsedTimeInSeconds > MIN_SECONDS_TO_TRACK_PROGRESS ? getPercentage(state.elapsedTimeInSeconds, state.durationInSeconds) : 0
      });
    case RESET_LAST_VIEWED_VIDEO_DATA:
      return player_reducer_objectSpread(player_reducer_objectSpread({}, state), {}, {
        lastViewedClipId: '',
        lastViewedClipProgress: 0
      });
    case player_constants_CAN_PLAY:
      {
        var duration = get_default()(data, 'payload.duration');
        return player_reducer_objectSpread(player_reducer_objectSpread({}, state), {}, {
          canPlay: true,
          durationInSeconds: Number.isFinite(duration) ? Math.round(duration) : state.durationInSeconds,
          isLoadingContent: false
        });
      }
    case player_constants_CAN_PLAY_THROUGH:
      {
        var _duration = get_default()(data, 'payload.duration');
        return player_reducer_objectSpread(player_reducer_objectSpread({}, state), {}, {
          durationInSeconds: Number.isFinite(_duration) ? Math.round(_duration) : state.durationInSeconds
        });
      }
    case player_constants_PLAYING:
      return player_reducer_objectSpread(player_reducer_objectSpread({}, state), {}, {
        timeUpdateTicks: 0,
        isBuffering: false,
        playbackState: PLAYBACK_STATE_PLAYING
      });
    case PAUSED:
      return player_reducer_objectSpread(player_reducer_objectSpread({}, state), {}, {
        playbackState: PLAYBACK_STATE_PAUSED
      });
    case player_constants_WAITING:
      return player_reducer_objectSpread(player_reducer_objectSpread({}, state), {}, {
        isBuffering: data.payload.isBuffering
      });
    case player_constants_TIME_UPDATE:
      {
        var _data$payload = data.payload,
          currentTime = _data$payload.currentTime,
          liveEdge = _data$payload.liveEdge;
        var elapsedFromStart = Math.round(currentTime) - state.startTimeInSeconds;
        var _elapsedTimeInSeconds = !state.isLive && elapsedFromStart > state.durationInSeconds ? state.elapsedTimeInSeconds : elapsedFromStart;
        var liveEdgeInSeconds = Number.isFinite(liveEdge) ? Math.round(liveEdge) - state.startTimeInSeconds : 0;
        var timeUpdateTicks = state.timeUpdateTicks + (state.playbackState === PLAYBACK_STATE_PLAYING ? 1 : 0);
        var shouldHideVideoLoader = state.shouldHideVideoLoader || timeUpdateTicks >= 2;
        var chapter = state.isLive ? null : state.chapters.find(function (_ref3) {
          var tcStart = _ref3.tcStart,
            tcEnd = _ref3.tcEnd;
          return _elapsedTimeInSeconds >= tcStart && _elapsedTimeInSeconds <= tcEnd;
        });
        return player_reducer_objectSpread(player_reducer_objectSpread({}, state), {}, {
          isStarted: true,
          chapter: chapter,
          timeUpdateTicks: timeUpdateTicks,
          shouldHideVideoLoader: shouldHideVideoLoader,
          elapsedTimeInSeconds: _elapsedTimeInSeconds,
          liveEdgeInSeconds: liveEdgeInSeconds,
          isOnLive: Math.abs(liveEdgeInSeconds - _elapsedTimeInSeconds) < 5
        });
      }
    case player_constants_TRACKS_CHANGED:
      {
        if (!data.payload) {
          return state;
        }
        var selectedAudioTrack = state.selectedAudioTrack,
          selectedSubtitlesTrack = state.selectedSubtitlesTrack,
          _originalLanguage = state.originalLanguage;
        var subtitleTracks = (data.payload.subtitleTracks || []).map(parseTrack);
        var audioTracks = (data.payload.audioTracks || []).map(parseTrack);
        var preferences = state.preferences || {};
        var audioTrack = selectedAudioTrack && audioTracks.find(function (_ref4) {
          var id = _ref4.id;
          return id === selectedAudioTrack;
        }) || findMatchingAudioTrack(audioTracks, preferences.audioTrack, _originalLanguage);
        var subtitlesTrack = selectedSubtitlesTrack && subtitleTracks.find(function (_ref5) {
          var id = _ref5.id;
          return id === selectedSubtitlesTrack;
        }) || findMatchingSubtitlesTrack(subtitleTracks, preferences.textTrack) || (audioTrack ? findForcedSubtitles(subtitleTracks, audioTrack.language) : null);
        return player_reducer_objectSpread(player_reducer_objectSpread({}, state), {}, {
          subtitleTracks: subtitleTracks,
          audioTracks: audioTracks,
          selectedSubtitlesTrack: subtitlesTrack ? subtitlesTrack.id : null,
          selectedAudioTrack: audioTrack ? audioTrack.id : null
        });
      }
    case SET_AUDIO_TRACK:
      {
        return player_reducer_objectSpread(player_reducer_objectSpread({}, state), {}, {
          selectedAudioTrack: data.track ? data.track.id : null
        });
      }
    case SET_SUBTITLE_TRACK:
      {
        return player_reducer_objectSpread(player_reducer_objectSpread({}, state), {}, {
          selectedSubtitlesTrack: data.track ? data.track.id : null
        });
      }
    case TRACK_PREFERENCES_CHANGED:
      {
        var _audioTrack = data.audioTrack,
          _subtitlesTrack = data.subtitlesTrack;
        var _preferences = state.preferences || {};
        var currentTextTrack = _preferences.textTrack,
          currentAudioTrack = _preferences.audioTrack;
        var preferredAudioTrack = currentAudioTrack;
        if (_audioTrack) {
          preferredAudioTrack = audioTrackToPreference(_audioTrack);
        }
        var preferredTextTrack = currentTextTrack;
        if (_subtitlesTrack === null) {
          preferredTextTrack = null;
        } else if (_subtitlesTrack) {
          preferredTextTrack = subtitlesTrackToPreference(_subtitlesTrack);
        }
        return player_reducer_objectSpread(player_reducer_objectSpread({}, state), {}, {
          preferences: player_reducer_objectSpread(player_reducer_objectSpread({}, _preferences), {}, {
            audioTrack: preferredAudioTrack,
            textTrack: preferredTextTrack
          })
        });
      }
    case player_constants_SUBTITLES_UPDATED:
      {
        return player_reducer_objectSpread(player_reducer_objectSpread({}, state), {}, {
          subtitleCuePoint: data.payload
        });
      }
    case player_constants_ENDED:
      {
        return player_reducer_objectSpread(player_reducer_objectSpread({}, state), {}, {
          isBuffering: false,
          playbackState: PLAYBACK_STATE_ENDED
        });
      }
    case AD_JINGLE_STARTED:
      {
        return player_reducer_objectSpread(player_reducer_objectSpread({}, state), {}, {
          isAdBreakDisplayed: true,
          isPlayingAds: true,
          isAdJingleDisplayed: Boolean(state.adJingleImageId),
          selectedSubtitlesTrack: null,
          selectedAudioTrack: null
        });
      }
    case AD_PROVIDER_LOADED:
      {
        return player_reducer_objectSpread(player_reducer_objectSpread({}, state), {}, {
          isAdProviderReady: true
        });
      }
    case player_constants_AD_ERROR:
      {
        return player_reducer_objectSpread(player_reducer_objectSpread({}, state), {}, {
          isAdError: true
        });
      }
    case AD_BREAK_STARTED:
      {
        var adType = data.adType,
          totalDuration = data.totalDuration;
        return player_reducer_objectSpread(player_reducer_objectSpread({}, state), {}, {
          isAdBreakDisplayed: true,
          shouldHideVideoLoader: false,
          timeUpdateTicks: 0,
          adBreakElapsedTime: 0,
          adBreakDuration: totalDuration,
          displayedAdBreakType: adType,
          selectedSubtitlesTrack: null,
          selectedAudioTrack: null
        });
      }
    case AD_BREAK_ENDED:
      {
        return player_reducer_objectSpread(player_reducer_objectSpread({}, state), {}, {
          isAdBreakDisplayed: false,
          isPlayingAds: false,
          displayedAdBreakType: null
        });
      }
    case AD_PLAYING:
      {
        return player_reducer_objectSpread(player_reducer_objectSpread({}, state), {}, {
          adPlaybackState: PLAYBACK_STATE_PLAYING,
          isAdError: false,
          isAdJingleDisplayed: false
        });
      }
    case AD_BREAK_TIME_UPDATE:
      {
        return player_reducer_objectSpread(player_reducer_objectSpread({}, state), {}, {
          adBreakElapsedTime: data.currentTime,
          adBreakDuration: Number.isFinite(data.totalDuration) ? data.totalDuration : state.adBreakDuration
        });
      }
    case AD_PAUSED:
      {
        return player_reducer_objectSpread(player_reducer_objectSpread({}, state), {}, {
          adPlaybackState: PLAYBACK_STATE_PAUSED
        });
      }
    case AD_ENDED:
      {
        return player_reducer_objectSpread(player_reducer_objectSpread({}, state), {}, {
          adPlaybackState: PLAYBACK_STATE_ENDED
        });
      }
    case SET_PAUSE_AD:
      {
        var pauseAd = data.ad;
        return player_reducer_objectSpread(player_reducer_objectSpread({}, state), {}, {
          pauseAd: pauseAd,
          pauseAdState: PAUSE_AD_STATE.LOADING
        });
      }
    case SET_PAUSE_AD_STATE:
      {
        return player_reducer_objectSpread(player_reducer_objectSpread({}, state), {}, {
          pauseAdState: data.state
        });
      }
    case SET_LBANNER_STATE:
      {
        return player_reducer_objectSpread(player_reducer_objectSpread({}, state), {}, {
          lBannerState: data.state
        });
      }
    case SET_PLAYER_ERROR:
      {
        return player_reducer_objectSpread(player_reducer_objectSpread({}, state), {}, {
          lastError: data.error
        });
      }
    default:
      return state;
  }
});
;// CONCATENATED MODULE: ./src/logic/routing/routing.reducer.js



function routing_reducer_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function routing_reducer_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? routing_reducer_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : routing_reducer_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


var routing_reducer_initialState = {
  deeplink: '',
  isOpenedViaDeeplink: false,
  currentRoute: '',
  currentPath: '',
  skeleton: null,
  isTopLevelRoute: false,
  shouldDisplayLanding: true
};
/* harmony default export */ const routing_reducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : routing_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case ROUTING_SAVE_DEEPLINK:
      {
        var deeplink = action.deeplink && !DEEP_LINK_EXCLUSIONS.includes(action.deeplink) ? action.deeplink : '';
        return routing_reducer_objectSpread(routing_reducer_objectSpread({}, state), {}, {
          deeplink: deeplink,
          isOpenedViaDeeplink: state.isOpenedViaDeeplink || Boolean(deeplink)
        });
      }
    case ROUTING_LOCATION_CHANGE:
      return routing_reducer_objectSpread(routing_reducer_objectSpread({}, state), {}, {
        currentRoute: action.location,
        currentPath: action.path
      });
    case ROUTING_SET_IS_TOP_LEVEL_ROUTE:
      return routing_reducer_objectSpread(routing_reducer_objectSpread({}, state), {}, {
        isTopLevelRoute: action.isTopLevelRoute
      });
    case LANDING_SHOWN:
      return routing_reducer_objectSpread(routing_reducer_objectSpread({}, state), {}, {
        shouldDisplayLanding: false
      });
    case SHOULD_DISPLAY_LANDING:
      return routing_reducer_objectSpread(routing_reducer_objectSpread({}, state), {}, {
        shouldDisplayLanding: true
      });
    case SET_ROUTE_SKELETON:
      return routing_reducer_objectSpread(routing_reducer_objectSpread({}, state), {}, {
        skeleton: action.skeleton || null
      });
    default:
      return state;
  }
});
;// CONCATENATED MODULE: ./src/logic/search/search.reducer.js

function search_reducer_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function search_reducer_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? search_reducer_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : search_reducer_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var search_reducer_initialState = {
  results: [],
  searchInput: '',
  searchedItems: []
};
/* harmony default export */ const search_reducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : search_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case SEARCH_COMPLETE:
      return search_reducer_objectSpread(search_reducer_objectSpread({}, state), {}, {
        searchInput: action.input,
        results: action.results
      });
    case UPDATE_SEARCHED_ITEMS:
      return search_reducer_objectSpread(search_reducer_objectSpread({}, state), {}, {
        searchedItems: action.searchedItems
      });
    case SEARCH_RESET:
      return search_reducer_initialState;
    default:
      return state;
  }
});
;// CONCATENATED MODULE: ./src/logic/gdprNotice/gdprNotice.reducer.js

function gdprNotice_reducer_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function gdprNotice_reducer_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? gdprNotice_reducer_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : gdprNotice_reducer_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var gdprNotice_reducer_initialState = {
  isGdprNoticeVisible: false
};
/* harmony default export */ const gdprNotice_reducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : gdprNotice_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case TOGGLE_GDPR_NOTICE:
      {
        return gdprNotice_reducer_objectSpread(gdprNotice_reducer_objectSpread({}, state), {}, {
          isGdprNoticeVisible: !state.isGdprNoticeVisible
        });
      }
    default:
      return state;
  }
});
;// CONCATENATED MODULE: ./src/logic/popup/popup.reducer.js

function popup_reducer_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function popup_reducer_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? popup_reducer_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : popup_reducer_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var popup_reducer_initialState = {
  popupData: null
};
/* harmony default export */ const popup_reducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : popup_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case POPUP_ID:
      {
        return popup_reducer_objectSpread(popup_reducer_objectSpread({}, state), {}, {
          popupData: {
            id: action.popupId,
            options: action.popupOptions
          }
        });
      }
    default:
      return state;
  }
});
;// CONCATENATED MODULE: ./src/logic/screenSaver/screenSaver.reducer.js

function screenSaver_reducer_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function screenSaver_reducer_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? screenSaver_reducer_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : screenSaver_reducer_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



var screenSaver_reducer_initialState = {
  screenSaverData: null,
  isLocked: false
};
/* harmony default export */ const screenSaver_reducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : screenSaver_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var screenSaverData = {
    section: get_default()(action.data, 'layout.section'),
    layoutId: get_default()(action.data, 'layout.id'),
    items: getScreenSaverItemsData(action.data)
  };
  switch (action.type) {
    case SCREEN_SAVER_DATA:
      {
        return screenSaver_reducer_objectSpread(screenSaver_reducer_objectSpread({}, state), {}, {
          screenSaverData: screenSaverData
        });
      }
    case SCREEN_SAVER_IS_LOCKED:
      {
        return screenSaver_reducer_objectSpread(screenSaver_reducer_objectSpread({}, state), {}, {
          isLocked: get_default()(action.data, 'isLocked')
        });
      }
    default:
      return state;
  }
});
;// CONCATENATED MODULE: ./src/reducers.js

function reducers_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function reducers_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? reducers_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : reducers_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }













var fakeInitialState = {};
var fakeReducer = function fakeReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fakeInitialState;
  return reducers_objectSpread({}, state);
};
/* harmony default export */ const reducers = ({
  analytics: analytics_reducer,
  app: app_reducer,
  features: features_reducer,
  error: function error() {
    return fakeReducer;
  },
  layout: layout_reducer,
  lock: lock_reducer,
  parentalCode: function parentalCode() {
    return fakeReducer;
  },
  pairing: pairing_reducer,
  player: player_reducer,
  routing: routing_reducer,
  search: search_reducer,
  user: user_reducer,
  gdpr: gdprNotice_reducer,
  popup: popup_reducer,
  screenSaver: screenSaver_reducer
});
;// CONCATENATED MODULE: ./src/middlewares/storage.middleware.js










function storage_middleware_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function storage_middleware_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? storage_middleware_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : storage_middleware_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


















var getConsents = function getConsents() {
  return src.gdprCookies.reduce(function (memo, cookieName) {
    if (!cookieName) {
      return memo;
    }
    return storage_middleware_objectSpread(storage_middleware_objectSpread({}, memo), {}, (0,defineProperty/* default */.Z)({}, cookieName, platformStorage.getItem(cookieName)));
  }, {});
};
var getFilteredConsents = function getFilteredConsents(action) {
  return Object.entries(action).reduce(function (memo, _ref) {
    var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
      cookieName = _ref2[0],
      cookieValue = _ref2[1];
    if (!src.gdprCookies.includes(cookieName)) {
      return memo;
    }
    return storage_middleware_objectSpread(storage_middleware_objectSpread({}, memo), {}, (0,defineProperty/* default */.Z)({}, cookieName, cookieValue));
  }, {});
};
var getUserId = function getUserId(store) {
  try {
    var _store$getState = store.getState(),
      _store$getState$user = _store$getState.user,
      profileUid = _store$getState$user.profileUid,
      uid = _store$getState$user.uid;
    return profileUid || uid;
  } catch (error) {
    return null;
  }
};
var makePreferencesKey = function makePreferencesKey(key, userProfile) {
  return [userProfile, key].filter(Boolean).join('.');
};
var storage_middleware_saveSearchedItem = function saveSearchedItem(store, item) {
  var id = getUserId(store);
  var section = getCurrentSectionCode(store.getState());
  if (id && section) {
    var history = platformStorage.getItem("".concat(id + SEARCH_HISTORY_KEY, "_").concat(section));
    var parsedHistory = history ? JSON.parse(history) : [];
    parsedHistory.unshift(item);
    var result = parsedHistory.filter(function (historyItem, index) {
      return historyItem !== item || index === 0;
    });
    try {
      platformStorage.setItem("".concat(id + SEARCH_HISTORY_KEY, "_").concat(section), JSON.stringify(result.slice(0, SEARCH_HISTORY_CAPACITY)));
    } catch (error) {
      store.dispatch(storageWriteFailure(error));
    }
  }
};
var storage_middleware_getSearchedItems = function getSearchedItems(store) {
  var id = getUserId(store);
  var section = getCurrentSectionCode(store.getState());
  try {
    return JSON.parse(platformStorage.getItem("".concat(id + SEARCH_HISTORY_KEY, "_").concat(section))) || [];
  } catch (error) {
    return null;
  }
};
/* harmony default export */ const storage_middleware = (function (store) {
  return function (next) {
    return function (action) {
      var state = store.getState();
      var currentAction = storage_middleware_objectSpread({}, action);
      switch (currentAction.type) {
        case RESTORE_DEVICE_DATA:
          {
            currentAction[PERSISTENT.DEVICE_ID_KEY] = platformStorage.getItem(PERSISTENT.DEVICE_ID_KEY);
            currentAction[PERSISTENT.SYNCHRONIZE_KEY] = platformStorage.getItem(PERSISTENT.SYNCHRONIZE_KEY);
            currentAction.homeId = getHomeId();
            currentAction = storage_middleware_objectSpread({}, currentAction);
            break;
          }
        case CONFIG_INIT:
          {
            currentAction = storage_middleware_objectSpread(storage_middleware_objectSpread({}, currentAction), {}, {
              cookies: getConsents()
            });
            break;
          }
        case INITIALIZED:
          {
            incrementAccountCompletionCounter();
            var shouldTrackPreferencesAcrossDevices = getPlayerTrackPreferencesFeature(state);
            if (!shouldTrackPreferencesAcrossDevices) {
              var audioLanguage = platformStorage.getItem(makePreferencesKey(TRACK_KEYS.PREFERRED_AUDIO_TRACK_LANGUAGE, state.user.profileUid));
              var subtitlesLanguage = platformStorage.getItem(makePreferencesKey(TRACK_KEYS.PREFERRED_SUBTITLE_TRACK_LANGUAGE, state.user.profileUid));
              var subtitles = null;
              var audio = null;
              if (subtitlesLanguage) {
                subtitles = {
                  language: subtitlesLanguage,
                  role: 'standard'
                };
                if (subtitlesLanguage.language) {
                  subtitles = {
                    language: subtitlesLanguage.language,
                    role: subtitlesLanguage.role || 'standard'
                  };
                }
              }
              if (audioLanguage) {
                audio = {
                  language: audioLanguage,
                  audioDescription: false
                };
                if (audioLanguage.language) {
                  audio = {
                    language: audioLanguage.language,
                    audioDescription: audioLanguage.audioDescription || false
                  };
                }
              }
              currentAction = storage_middleware_objectSpread(storage_middleware_objectSpread({}, currentAction), {}, {
                item: storage_middleware_objectSpread(storage_middleware_objectSpread({}, currentAction.item), {}, {
                  video: storage_middleware_objectSpread(storage_middleware_objectSpread({}, currentAction.item.video), {}, {
                    features: storage_middleware_objectSpread(storage_middleware_objectSpread({}, currentAction.item.video.features), {}, {
                      preferences: storage_middleware_objectSpread(storage_middleware_objectSpread({}, currentAction.item.video.features.preferences), {}, {
                        textTrack: subtitles,
                        audioTrack: audio || currentAction.item.video.features.preferences.audioTrack
                      })
                    })
                  })
                })
              });
            }
            break;
          }
        default:
          break;
      }
      next(currentAction);
      var uid = user_selectors_getUid(state);
      switch (currentAction.type) {
        case RESTORE_DEVICE_DATA:
          {
            try {
              isStorageSupported(platformStorage);
            } catch (error) {
              store.dispatch(storageSupportFailure(error));
            }
            if (!currentAction.deviceId && !currentAction.homeId) {
              store.dispatch(user_actions_generateDeviceId());
            }
            break;
          }
        case INITIALIZE_APP_COMPLETED:
          {
            if (shouldSynchronizeConsents(state)) {
              var userConsents = getConsents();
              store.dispatch(setUserConsentsOnApi({
                cookies: userConsents,
                deviceId: user_selectors_getDeviceId(state),
                homeId: getHomeId(state)
              }));
            }
            break;
          }
        case RESET_DEVICE_DATA:
          {
            platformStorage.clear();
            break;
          }
        case SET_USER_CONSENTS:
          {
            try {
              var consentCookies = getFilteredConsents(currentAction);
              platformStorage.setItems(storage_middleware_objectSpread(storage_middleware_objectSpread({}, consentCookies), {}, (0,defineProperty/* default */.Z)({}, PERSISTENT.SYNCHRONIZE_KEY, false)));
            } catch (error) {
              store.dispatch(storageWriteFailure(error));
            }
            break;
          }
        case GENERATE_DEVICE_ID:
          {
            try {
              platformStorage.setItem(PERSISTENT.DEVICE_ID_KEY, currentAction.deviceId, false);
            } catch (error) {
              store.dispatch(storageWriteFailure(error));
            }
            break;
          }
        case UPDATE_DEVICE_ID:
          {
            platformStorage.setItem(PERSISTENT.DEVICE_ID_KEY, currentAction.deviceId, false);
            platformStorage.setItem(PERSISTENT.SYNCHRONIZE_KEY, false);
            break;
          }
        case CALL_USER_CONSENTS_SUCCESS:
          {
            try {
              platformStorage.setItem(PERSISTENT.SYNCHRONIZE_KEY, true);
              store.dispatch({
                type: SYNCHRONIZE_USER_CONSENTS
              });
            } catch (error) {
              store.dispatch(storageWriteFailure(error));
            }
            break;
          }
        case RENEW_TOKEN_SUCCESS:
          {
            try {
              var shouldDisplayProfilesGateOnNextVisit = getMultiProfilesGateAlwaysDisplayed(state);
              if (!shouldDisplayProfilesGateOnNextVisit) {
                platformStorage.setItem("".concat(uid, ".").concat(PERSISTENT.PROFILE_UID_KEY), currentAction.profileUid);
              }
            } catch (error) {
              store.dispatch(storageWriteFailure(error));
            }
            break;
          }
        case CLEAR_USER_PROFILE:
          {
            try {
              platformStorage.removeItem("".concat(uid, ".").concat(PERSISTENT.PROFILE_UID_KEY));
            } catch (error) {
              store.dispatch(storageWriteFailure(error));
            }
            break;
          }
        case USER_RESTORE_PROFILE_UID:
          {
            var previousProfileUid = platformStorage.getItem(PERSISTENT.PREVIOUS_PROFILE_KEY);
            if (previousProfileUid) {
              store.dispatch(setPreviousProfileUID(previousProfileUid));
            }
            break;
          }
        case FETCH_PROFILE_INFOS_SUCCESS:
          {
            var _currentAction = currentAction,
              profileUid = _currentAction.profileUid;
            try {
              platformStorage.setItem(PERSISTENT.PREVIOUS_PROFILE_KEY, profileUid, true);
            } catch (error) {
              store.dispatch(storageWriteFailure(error));
            }
            break;
          }
        case PAIRING_LOGOUT_SUCCESS:
          {
            try {
              platformStorage.removeItem(PERSISTENT.PREVIOUS_PROFILE_KEY);
            } catch (error) {
              store.dispatch(storageWriteFailure(error));
            }
            break;
          }
        case TRACK_PREFERENCES_CHANGED:
          {
            try {
              var _store$getState2 = store.getState(),
                preferences = _store$getState2.player.preferences,
                _profileUid = _store$getState2.user.profileUid;
              if (preferences.audioTrack) {
                platformStorage.setItem(makePreferencesKey(TRACK_KEYS.PREFERRED_AUDIO_TRACK_LANGUAGE, _profileUid), preferences.audioTrack);
              }
              platformStorage.setItem(makePreferencesKey(TRACK_KEYS.PREFERRED_SUBTITLE_TRACK_LANGUAGE, _profileUid), preferences.textTrack);
            } catch (error) {
              store.dispatch(storageWriteFailure(error));
            }
            break;
          }
        case SAVE_SEARCHED_ITEM:
          {
            try {
              var title = action.searchedItem.title;
              if (title) {
                storage_middleware_saveSearchedItem(store, title);
              }
            } catch (error) {
              store.dispatch(storageWriteFailure(error));
            }
            break;
          }
        case GET_SEARCHED_ITEM:
          {
            var searchedItems = storage_middleware_getSearchedItems(store);
            if (searchedItems) {
              store.dispatch(updateSearchedItems(searchedItems));
            }
            break;
          }
        case PAIRING_RESET:
          {
            setPairingMethod(PAIRING_METHOD.NONE);
            break;
          }
        default:
      }
    };
  };
});
;// CONCATENATED MODULE: ./src/middlewares/routing.middleware.js














var actionsToPaths = memoize_default()(function (navigation) {
  return get_default()(navigation, 'entries', []).flatMap(function (group) {
    return group.map(function (_ref) {
      var entry = _ref.entry;
      return actionToPath({
        action: entry
      });
    });
  });
});
var routing_middleware_isTopLevelRoute = function isTopLevelRoute(route) {
  return !RESTRICTED_PATHS.some(function (path) {
    return route.startsWith(path);
  });
};
/* harmony default export */ const routing_middleware = (function (_ref2) {
  var getState = _ref2.getState,
    dispatch = _ref2.dispatch;
  return function (next) {
    return function (action) {
      switch (action.type) {
        case ROUTING_LOCATION_CHANGE:
          {
            var navigation = getLayoutNavigation(getState());
            dispatch(setIsTopLevelRoute(routing_middleware_isTopLevelRoute(action.path, navigation)));
            break;
          }
        case FETCH_NAVIGATION_SUCCESS:
          {
            var _navigation = action.navigation;
            var route = getCurrentPath(getState());
            dispatch(setIsTopLevelRoute(routing_middleware_isTopLevelRoute(route, _navigation)));
            break;
          }
        case RENEW_TOKEN_SUCCESS:
          {
            var _getState = getState(),
              _getState$layout = _getState.layout,
              requestedEntityId = _getState$layout.requestedEntityId,
              requestedEntityType = _getState$layout.requestedEntityType;
            if (!requestedEntityType || !requestedEntityId) {
              break;
            }
            dispatch(fetchLayout(requestedEntityType, requestedEntityId));
            break;
          }
        case FETCH_PROFILE_INFOS_SUCCESS:
          {
            var section = action.isKidsProfile ? 'kids' : 'main';
            dispatch(fetchNavigation(section));
            break;
          }
        case FETCH_PROFILE_INFOS_FAILURE:
          {
            dispatch(fetchNavigation('main'));
            break;
          }
        default:
          break;
      }
      return next(action);
    };
  };
});
;// CONCATENATED MODULE: ./src/modules/heartbeat/engines/heartbeat/heartbeat.engine.js








var heartbeat_engine_excluded = ["UID"];
function heartbeat_engine_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function heartbeat_engine_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? heartbeat_engine_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : heartbeat_engine_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



var HeartbeatEngine = function () {
  function HeartbeatEngine() {
    (0,classCallCheck/* default */.Z)(this, HeartbeatEngine);
    this._reset();
  }
  (0,createClass/* default */.Z)(HeartbeatEngine, [{
    key: "_reset",
    value: function _reset() {
      this._sessionId = '';
      this._sendView = undefined;
      this._ticker = undefined;
      this._sessionData = undefined;
      this._viewData = undefined;
      this._currentTimeInSeconds = 0;
      this._lastTimeInSeconds = undefined;
      this._cslErrorHandler = undefined;
      this._heartbeatInterval = src.heartbeat.heartbeatInterval || 240000;
      this._sequenceNumber = 0;
    }
  }, {
    key: "currentTimeInSeconds",
    get: function get() {
      return this._currentTimeInSeconds;
    },
    set: function set(value) {
      this._currentTimeInSeconds = value;
    }
  }, {
    key: "createSession",
    value: function () {
      var _createSession = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee(data) {
        var session, cslErrorHandler, view, startTime, UID, sessionData, secondsFromStart, _yield$heartbeatServi, sessionId, sendView;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              session = data.session, cslErrorHandler = data.cslErrorHandler, view = data.view, startTime = data.startTime;
              UID = session.UID, sessionData = objectWithoutProperties_objectWithoutProperties(session, heartbeat_engine_excluded);
              secondsFromStart = Number.isFinite(startTime) ? startTime : 0;
              this._reset();
              this._currentTimeInSeconds = secondsFromStart;
              this._sessionData = sessionData;
              this._viewData = view;
              this._cslErrorHandler = cslErrorHandler;
              _context.next = 11;
              return heartbeatService.createSession(UID ? {
                sessionData: sessionData,
                user: {
                  UID: UID
                }
              } : {
                sessionData: sessionData
              });
            case 11:
              _yield$heartbeatServi = _context.sent;
              sessionId = _yield$heartbeatServi.sessionId;
              sendView = _yield$heartbeatServi.sendView;
              this._sessionId = sessionId;
              this._sendView = sendView;
              return _context.abrupt("return", sessionId);
            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](0);
              console.error(['Session creation failed:', _context.t0]);
              return _context.abrupt("return", null);
            case 23:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 19]]);
      }));
      function createSession(_x) {
        return _createSession.apply(this, arguments);
      }
      return createSession;
    }()
  }, {
    key: "resume",
    value: function resume() {
      var _this = this;
      var isAfterSeek = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.sendHeartbeat(isAfterSeek);
      if (this._ticker) {
        return;
      }
      this._ticker = setInterval(function () {
        return _this.sendHeartbeat();
      }, this._heartbeatInterval);
    }
  }, {
    key: "pause",
    value: function pause() {
      this.sendHeartbeat();
      clearInterval(this._ticker);
      this._ticker = undefined;
    }
  }, {
    key: "sendHeartbeat",
    value: function () {
      var _sendHeartbeat = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee2() {
        var isAfterSeek,
          tc,
          tcRelative,
          sequenceNumber,
          _yield$this$_sendView,
          viewInformation,
          _args2 = arguments;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              isAfterSeek = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : false;
              if (!(!this._sendView || !this._sessionData)) {
                _context2.next = 4;
                break;
              }
              console.warn(['Session is not started yet, tick will be skipped']);
              return _context2.abrupt("return");
            case 4:
              tc = this._currentTimeInSeconds;
              tcRelative = !Number.isFinite(this._lastTimeInSeconds) || isAfterSeek ? 0 : Math.abs(tc - this._lastTimeInSeconds);
              sequenceNumber = this._sequenceNumber;
              this._sequenceNumber += 1;
              this._lastTimeInSeconds = this._currentTimeInSeconds;
              _context2.prev = 9;
              _context2.next = 12;
              return this._sendView(heartbeat_engine_objectSpread(heartbeat_engine_objectSpread({}, this._viewData), {}, {
                tc: tc,
                tcRelative: tcRelative > 900 ? 0 : tcRelative,
                sequenceNumber: sequenceNumber
              }));
            case 12:
              _yield$this$_sendView = _context2.sent;
              viewInformation = _yield$this$_sendView.view_information;
              if (viewInformation && viewInformation.csl && viewInformation.csl.allowed === false) {
                if (this._cslErrorHandler) {
                  this._cslErrorHandler();
                }
                thirdPartyWithLayoutService.sendErrorEvent(new Error("player - CSL restriction failed: ".concat(viewInformation.csl)));
              }
              _context2.next = 21;
              break;
            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2["catch"](9);
              console.error(['Tick failed:', _context2.t0]);
              thirdPartyWithLayoutService.sendErrorEvent(new Error('player - CSL tick failed'));
            case 21:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[9, 17]]);
      }));
      function sendHeartbeat() {
        return _sendHeartbeat.apply(this, arguments);
      }
      return sendHeartbeat;
    }()
  }, {
    key: "destroy",
    value: function destroy() {
      clearInterval(this._ticker);
      this.sendHeartbeat();
      this._reset();
    }
  }, {
    key: "adResume",
    value: function adResume() {}
  }, {
    key: "adPause",
    value: function adPause() {}
  }, {
    key: "adEnd",
    value: function adEnd() {}
  }]);
  return HeartbeatEngine;
}();
/* harmony default export */ const heartbeat_engine = (new HeartbeatEngine());
;// CONCATENATED MODULE: ./src/logic/heartbeat/heartbeat.selectors.js


var getHeartbeatV2 = getAnalyticsById('heartbeat-v2');
var getHeartbeatV3 = getAnalyticsById('heartbeat-v3');
var getHeartbeatState = function getHeartbeatState(state) {
  return _get(state, 'heartbeat');
};
var getHeartbeatInterval = function getHeartbeatInterval(state) {
  return _get(state, 'heartbeat.heartbeatInterval');
};
var isHeartbeatEnabled = function isHeartbeatEnabled(state) {
  return _get(state, 'heartbeat.enabled');
};
var heartbeat_selectors_getVideoClipType = function getVideoClipType(state) {
  return _get(getHeartbeatV2(state), 'session.clipType', '');
};
var heartbeat_selectors_getProgramId = function getProgramId(state) {
  return _get(getHeartbeatV2(state), 'session.programId', '');
};
var heartbeat_selectors_getServiceCode = function getServiceCode(state) {
  return _get(getHeartbeatV2(state), 'session.serviceCode', '');
};
var getHeartbeatSessionId = function getHeartbeatSessionId(state) {
  return _get(state, 'heartbeat.sessionId');
};
;// CONCATENATED MODULE: ./src/modules/heartbeat/engines/heartbeat/heartbeat.utils.js




var getSessionInitialProps = function getSessionInitialProps(state) {
  return {
    uidType: getPairingUid(state) ? UID_TYPE_GIGYA : UID_TYPE_DEVICE_ID,
    clipId: getClipId(state),
    videoId: getVideoId(state),
    clipDuration: getDurationInSeconds(state),
    clipType: getVideoClipType(state),
    programId: getProgramId(state),
    serviceCode: getServiceCode(state),
    UID: getUid(state),
    startTime: getElapsedTimeInSeconds(state)
  };
};
;// CONCATENATED MODULE: ./src/modules/heartbeat/index.js


var Heartbeat = new HeartbeatEngine();
;// CONCATENATED MODULE: ./src/middlewares/heartbeat.middleware.js

function heartbeat_middleware_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function heartbeat_middleware_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? heartbeat_middleware_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : heartbeat_middleware_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }








var cslErrorHandler = function cslErrorHandler(dispatch) {
  return function () {
    dispatch(showPopupAction(CSL_BLOCK_POPUP_ID, {}));
    dispatch(player_constants_reset());
  };
};
/* harmony default export */ const heartbeat_middleware = (function (_ref) {
  var getState = _ref.getState,
    dispatch = _ref.dispatch;
  return function (next) {
    return function (action) {
      var forward = next(action);
      switch (action.type) {
        case INITIALIZED:
          {
            var state = getState();
            var initialProps = getHeartbeatV2(state);
            Heartbeat.createSession(heartbeat_middleware_objectSpread(heartbeat_middleware_objectSpread({}, initialProps), {}, {
              startTime: getIsLive(state) ? getStartTimeInSeconds(state) : player_selectors_getElapsedTimeInSeconds(state),
              cslErrorHandler: cslErrorHandler(dispatch)
            })).then(function (sessionId) {
              if (sessionId) {
                setAttributes({
                  heartbeatSessionId: sessionId
                });
              }
            });
            break;
          }
        case player_constants_PLAYING:
          {
            Heartbeat.resume();
            break;
          }
        case PAUSED:
          {
            Heartbeat.pause();
            break;
          }
        case player_constants_TIME_UPDATE:
          {
            var _state = getState();
            Heartbeat.currentTimeInSeconds = player_selectors_getElapsedTimeInSeconds(_state);
            break;
          }
        case player_constants_SEEKING:
          {
            var _state2 = getState();
            Heartbeat.currentTimeInSeconds = get_default()(action, 'payload.from', player_selectors_getElapsedTimeInSeconds(_state2));
            Heartbeat.pause();
            break;
          }
        case player_constants_SEEKED:
          {
            var _state3 = getState();
            Heartbeat.currentTimeInSeconds = getIsLive(_state3) ? player_selectors_getElapsedTimeInSeconds(_state3) : get_default()(action, 'payload.to', player_selectors_getElapsedTimeInSeconds(_state3));
            Heartbeat.resume(true);
            break;
          }
        case RESET:
          {
            Heartbeat.destroy();
            break;
          }
        case AD_BREAK_STARTED:
          {
            Heartbeat.adResume(true);
            break;
          }
        case AD_PLAYING:
          {
            Heartbeat.adResume();
            break;
          }
        case AD_PAUSED:
          {
            Heartbeat.adPause();
            break;
          }
        case AD_ENDED:
          {
            Heartbeat.adEnd();
            break;
          }
        default:
          break;
      }
      return forward;
    };
  };
});
;// CONCATENATED MODULE: ./src/middlewares/analytics.middleware.js

var _ACTION_TO_TAGGING_PL;





var ACTION_TO_TAGGING_PLAN = (_ACTION_TO_TAGGING_PL = {}, (0,defineProperty/* default */.Z)(_ACTION_TO_TAGGING_PL, TOP_BAR_RELATED_VIDEOS, 'pressViewRelatedVideo'), (0,defineProperty/* default */.Z)(_ACTION_TO_TAGGING_PL, TOP_BAR_TRACKS, 'pressAudioSettingsVideo'), (0,defineProperty/* default */.Z)(_ACTION_TO_TAGGING_PL, TOP_BAR_START_OVER, 'pressStartOverVideo'), (0,defineProperty/* default */.Z)(_ACTION_TO_TAGGING_PL, TOP_BAR_BACK_TO_LIVE, 'pressBackToLiveVideo'), (0,defineProperty/* default */.Z)(_ACTION_TO_TAGGING_PL, TOP_BAR_BACK, 'pressBackButtonDuringVideo'), _ACTION_TO_TAGGING_PL);
/* harmony default export */ const analytics_middleware = (function (_ref) {
  var getState = _ref.getState;
  return function (next) {
    return function (action) {
      switch (action.type) {
        case FETCH_PROFILE_INFOS_SUCCESS:
          {
            setAttributes({
              isKidsProfile: action.isKidsProfile,
              userProfile: action.profileUid
            });
            sendEvent({
              key: 'profileSelected'
            });
            break;
          }
        case INITIALIZED:
          {
            var analytics = action.item.analytics || {};
            var progress = get_default()(action.item, 'video.progress') || {};
            var currentTime = progress.tcResume || 0;
            setAttributes({
              currentTime: currentTime,
              isLive: action.isLive,
              duration: action.item.video.duration,
              videoEndScreen: progress.endscreenDisplayTc || 0,
              newProgramAnalyticsConfiguration: analytics
            });
            break;
          }
        case player_constants_PLAYING:
          {
            sendEvent({
              key: 'playVideo'
            });
            break;
          }
        case player_constants_AUDIO_TRACK_CHANGED:
          {
            var language = get_default()(action, 'payload.currentTrack.language');
            setAttributes({
              playerActiveAudioLanguage: language
            });
            sendEvent({
              key: 'audioTrackChanged',
              language: language
            });
            break;
          }
        case player_constants_SUBTITLES_TRACK_CHANGED:
          {
            var _language = get_default()(action, 'payload.currentTrack.language');
            setAttributes({
              playerActiveTextLanguage: _language
            });
            sendEvent({
              key: 'subtitlesTrackChanged',
              language: _language
            });
            break;
          }
        case player_constants_TIME_UPDATE:
          {
            var state = getState();
            var isStarted = getIsStarted(state);
            if (!isStarted) {
              sendEvent({
                key: 'autoPlay'
              });
            }
            setAttributes({
              currentTime: action.payload.currentTime - (state.player.startTimeInSeconds || 0)
            });
            break;
          }
        case player_constants_WAITING:
          {
            var isBuffering = get_default()(action, 'payload.isBuffering') || false;
            sendEvent({
              key: isBuffering ? 'buffering' : 'bufferingEnded'
            });
            break;
          }
        case player_constants_SEEKING:
          {
            sendEvent({
              key: 'seek'
            });
            break;
          }
        case player_constants_SEEKED:
          {
            var _state = getState();
            if (!_state.player.isLive) {
              setAttributes({
                currentTime: (action.payload.to || 0) - (_state.player.startTimeInSeconds || 0)
              });
            }
            sendEvent({
              key: 'seekEnded'
            });
            break;
          }
        case player_constants_ENDED:
          {
            sendEvent({
              key: 'complete'
            });
            break;
          }
        default:
          break;
      }
      var key = ACTION_TO_TAGGING_PLAN[action.type];
      if (key) {
        sendEvent({
          key: key
        });
      }
      var result = next(action);
      if (action.type === INITIALIZED) {
        var _state2 = getState();
        var source = getVideoSource(_state2);
        if (source) {
          setAttributes({
            videoQuality: source.video_quality && typeof source.video_quality === 'string' ? source.video_quality.toLowerCase() : null
          });
          sendEvent({
            key: 'playbackStarted',
            analytics: action.item.analytics
          });
        }
      }
      return result;
    };
  };
});
;// CONCATENATED MODULE: ./src/store.js










var composeEnhancers =  false ? 0 : compose;
var middlewares = [redux_thunk_es, storage_middleware, routing_middleware, heartbeat_middleware, analytics_middleware].filter(Boolean);
var initStore = function initStore() {
  return createStore(combineReducers(reducers), composeEnhancers(applyMiddleware.apply(void 0, (0,toConsumableArray/* default */.Z)(middlewares))));
};
;// CONCATENATED MODULE: ./src/index.js








default_setup(window);
var appLauncher = function AppLauncher(appSettings, platformSettings, appStoreData) {
  var settings = getSettings(appSettings, platformSettings);
  lightningjs_redux.init(initStore());
  return Launch(App, settings.appSettings, settings.platformSettings, appStoreData || {});
};
if ({"PELO_PLATFORM":"vodafone","APP_VERSION":"1.48.0","OPTIONS":"{\"platform\":\"vodafone\",\"packaged\":false,\"debug\":false,\"skipHook\":false,\"skipNativeBuild\":true,\"skipBundler\":false}","GITHUB_STATE":"/runner/_work/_temp/_runner_file_commands/save_state_6041b297-2e35-451c-a738-c808c6587fef","npm_package_dependencies__babel_runtime":"7.22.3","npm_package_dependencies__pelo_plugins_screen":"workspace:*","npm_package_dependencies_regenerator_runtime":"0.13.11","npm_package_devDependencies_identity_obj_proxy":"3.0.0","npm_package_scripts_build_config_rtlnl":"APP_CUSTOMER=rtlnl node scripts/build-config","KUBERNETES_SERVICE_PORT":"443","KUBERNETES_PORT":"tcp://[fd39:f9c4:855c::1]:443","npm_package_dependencies_immutable_set":"2.1.0","npm_package_devDependencies__storybook_addon_knobs":"6.2.9","npm_package_devDependencies_prettier_eslint_cli":"7.1.0","npm_package_scripts_preinstall":"npx only-allow pnpm","npm_package_devDependencies__storybook_addon_docs":"6.2.9","npm_package_devDependencies_jest":"29.5.0","npm_package_devDependencies_webpack_bundle_analyzer":"4.10.2","npm_package_scripts_dev_rtlnl":"APP_CUSTOMER=rtlnl pnpm dev","npm_config_user_agent":"pnpm/9.14.4 npm/? node/v22.19.0 linux x64","CI":"true","npm_package_dependencies__bedrock_rdk_constants":"workspace:*","npm_package_dependencies__tornado_rdk_theme":"workspace:*","npm_package_dependencies_abortcontroller_polyfill":"1.7.8","npm_package_devDependencies__lightningjs_cli":"2.2.0","npm_package_scripts_build_config_rtlhu":"APP_CUSTOMER=rtlhu node scripts/build-config","npm_package_scripts_prod_rtlnl":"APP_CUSTOMER=rtlnl pnpm prod","HOSTNAME":"app-bedrock-rdk-deploy-wsgds-d6wcd","RUNNER_ENVIRONMENT":"self-hosted","GITHUB_ENV":"/runner/_work/_temp/_runner_file_commands/set_env_6041b297-2e35-451c-a738-c808c6587fef","UPLOAD_SOURCE_MAPS":"false","npm_package_dependencies__bedrock_rdk_utils":"workspace:*","npm_node_execpath":"/opt/hostedtoolcache/node/22.19.0/x64/bin/node","GITHUB_ACTIONS_RUNNER_EXTRA_USER_AGENT":"actions-runner-controller/v0.27.6","RUNNER_EPHEMERAL":"true","SHLVL":"4","npm_package_packageManager":"pnpm@9.14.4","npm_package_dependencies__bedrock_rdk_lng_storybook":"workspace:*","npm_package_dependencies_html_webpack_plugin":"5.5.0","npm_package_devDependencies__swc_core":"1.3.95","npm_package_scripts_dev_rtlhu":"APP_CUSTOMER=rtlhu pnpm dev","npm_package_scripts_nr_create_browser_applications":"node scripts/createNewRelicApps.js","HOME":"/home/runner","npm_package_devDependencies__babel_plugin_proposal_class_properties":"7.18.6","npm_package_devDependencies__bedrock_package_json_loader":"1.2.4","npm_package_devDependencies_jest_webgl_canvas_mock":"0.2.3","npm_package_scripts_prod_rtlhu":"APP_CUSTOMER=rtlhu pnpm prod","RUNNER_ORG":"","AWS_ROLE_ARN":"arn:aws:iam::374115518324:role/irsa/runners/app-bedrock-rdk-deploy","RUNNER_TEMP":"/runner/_work/_temp","GITHUB_EVENT_PATH":"/runner/_work/_temp/_github_workflow/event.json","npm_package_devDependencies_eslint_config_prettier":"9.0.0","npm_package_scripts_lint_filenames":"node scripts/checkFileScopes.js","npm_package_scripts_server":"http-server -c-1 build","npm_package_scripts_storybook_rtlde":"APP_CUSTOMER=rtlde start-storybook -p 6006","DOCKER_ENABLED":"true","GITHUB_REPOSITORY_OWNER":"m6web","npm_package_engines_node":"22.x","npm_package_dependencies__bedrock_html5_engine":"3.6.8","npm_package_devDependencies__6play_ryp":"3.2.4","npm_package_devDependencies__bedrock_github_api_utils":"1.0.1","npm_package_scripts_lint_json":"pnpm sort-keys:json --lint && prettier-eslint --list-different '/{.,}*.json' --ignore-path '**/package.json'","RUNNER_WORKDIR":"/runner/_work","GENERATE_SOURCEMAP":"true","AWS_WEB_IDENTITY_TOKEN_FILE":"/var/run/secrets/eks.amazonaws.com/serviceaccount/token","GITHUB_RETENTION_DAYS":"7","npm_package_devDependencies__pelo_platforms_vodafone":"10.0.0-alpha.1","npm_package_devDependencies_minimist":"1.2.5","npm_package_scripts_i18n_pull":"node ./scripts/i18nPull.js","npm_package_scripts_lint_md":"pnpm prettier-eslint --list-different $PWD/'**/*.md' $PWD/'.*/**/*.md'","GITHUB_REPOSITORY_OWNER_ID":"5","GITHUB_HEAD_REF":"","npm_package_dependencies_redux_thunk":"2.3.0","ACTIONS_RUNNER_HOOK_JOB_STARTED":"/etc/arc/hooks/job-started.sh","npm_package_dependencies_copy_webpack_plugin":"11.0.0","npm_package_devDependencies__swc_plugin_transform_imports":"1.5.94","npm_package_devDependencies_source_map_explorer":"1.6.0","npm_package_cypress_cucumber_preprocessor_stepDefinitions_0":"cypress/e2e/common/*.js","GITHUB_GRAPHQL_URL":"https://github.m6web.fr/api/graphql","REF":"v1.48.0","npm_package_dependencies__tornado_rdk_icons":"workspace:*","npm_package_dependencies_algoliasearch":"4.12.1","npm_package_dependencies_superagent":"3.8.3","npm_package_devDependencies_slack":"11.0.2","npm_package_scripts_build_config":"node scripts/build-config","npm_package_cypress_cucumber_preprocessor_stepDefinitions_1":"cypress/e2e/[filepart]/**/*.js","npm_package_dependencies_jwt_decode":"2.2.0","npm_package_devDependencies__babel_preset_env":"7.12.1","npm_package_scripts_e2e_rtlnl":"APP_CUSTOMER=rtlnl pnpm cypress open --e2e -b chrome","npm_package_pnpm_overrides__lightningjs_core":"2.9.0","npm_package_cypress_cucumber_preprocessor_stepDefinitions_2":"cypress/e2e/[filepart].js","GITHUB_URL":"https://github.m6web.fr/","RUNNER_ASSETS_DIR":"/runnertmp","npm_package_devDependencies__babel_plugin_transform_runtime":"7.22.4","npm_package_devDependencies_inquirer":"8.1.5","npm_package_scripts_dev":"APP_ENV=development pelo run","RUNNER_OS":"Linux","GITHUB_API_URL":"https://github.m6web.fr/api/v3","MAXPROC":"8","RUNNER_LABELS":"self-hosted,app-bedrock-rdk-deploy","npm_package_devDependencies__pelo_platforms_ziggo":"10.0.0-alpha.1","npm_package_devDependencies_eslint_plugin_import":"2.28.1","npm_package_scripts_logs":"node scripts/logs.js","npm_package_scripts_prod":"APP_ENV=prod pelo run","_":"/home/runner/setup-pnpm/node_modules/.bin/pnpm","RUNNER_GROUP":"green-gha-eks-bedrock-tech","HELM_REGISTRY_CONFIG":"/home/runner/.docker/config.json","GITHUB_WORKFLOW":"🏷 Release staging","npm_package_private":"true","npm_package_dependencies_sprintf_js":"1.1.2","npm_package_devDependencies__m6web_eslint_config":"3.5.0","npm_package_devDependencies_jsonlint":"1.6.3","npm_package_scripts_build_rtlnl":"APP_CUSTOMER=rtlnl pnpm build","npm_package_dependencies__bedrock_rdk_media_engine":"workspace:*","npm_package_dependencies_lightningjs_redux":"workspace:*","npm_package_devDependencies__babel_plugin_proposal_decorators":"7.22.3","npm_package_scripts_lint":"pnpm lint:js && pnpm lint:md && pnpm lint:json && pnpm lint:filenames","npm_config_registry":"https://verdaccio.bedrock.tech","GITHUB_RUN_ID":"3165446","npm_package_dependencies__bedrock_fido_sdk":"29.30.0","npm_package_dependencies_core_js":"3.32.1","npm_package_devDependencies__swc_jest":"0.2.29","npm_package_scripts_lint_tf":"terraform fmt -check -recursive -diff .cloud/terraform","npm_package_scripts_sort_keys_json":"node ./scripts/sortKeysJson.js","npm_package_pnpm_overrides_lodash":"4.17.21","GITHUB_REF_TYPE":"branch","GITHUB_WORKFLOW_SHA":"4ff2b3c7a982f2634428e9d3f25c715365c487e8","KUBERNETES_PORT_443_TCP_ADDR":"fd39:f9c4:855c::1","GITHUB_BASE_REF":"","ImageOS":"ubuntu22","npm_package_devDependencies_dotenv_expand":"5.1.0","npm_package_scripts_build_rtlhu":"APP_CUSTOMER=rtlhu pnpm build","GITHUB_WORKFLOW_REF":"m6web/app-bedrock-rdk/.github/workflows/release-deploy-staging.yml@refs/heads/master","GITHUB_ACTION_REPOSITORY":"","npm_config_node_gyp":"/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/dist/node_modules/node-gyp/bin/node-gyp.js","PATH":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.bin:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/dist/node-gyp-bin:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.bin:/opt/hostedtoolcache/node/22.19.0/x64/bin:/home/runner/setup-pnpm/node_modules/.bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin:/home/runner/.local/bin/","RUNNER_TRACKING_ID":"github_d6d391a5-4033-4ac4-8937-906499292394","RUNNER_TOOL_CACHE":"/opt/hostedtoolcache","npm_package_name":"app-bedrock-rdk","npm_package_repository_type":"git","npm_package_dependencies_serve":"14.1.2","npm_package_devDependencies__babel_eslint_parser":"7.22.15","npm_package_scripts_lint_js":"pnpm eslint --max-warnings=0 .pelo.config.js src/ packages/ platforms/ --cache","NODE":"/opt/hostedtoolcache/node/22.19.0/x64/bin/node","GITHUB_ACTION":"__run_4","GITHUB_RUN_NUMBER":"312","GITHUB_TRIGGERING_ACTOR":"skovalchuk-externe","RUNNER_ARCH":"X64","KUBERNETES_PORT_443_TCP_PORT":"443","npm_package_devDependencies_eslint_config_airbnb_base":"15.0.0","npm_package_scripts_analyze":"APP_ENV=detective pnpm build","npm_package_scripts_build_config_rtlde":"APP_CUSTOMER=rtlde node scripts/build-config","npm_config_frozen_lockfile":"","RUN_URL":"https://github.m6web.fr/m6web/app-bedrock-rdk/actions/runs/3165446","KUBERNETES_PORT_443_TCP_PROTO":"tcp","npm_package_dependencies__pelo_plugins_device":"workspace:*","npm_package_devDependencies__bedrock_deploy_event":"0.11.0","npm_package_devDependencies__pelo_platforms_web":"10.0.0-alpha.1","npm_package_devDependencies__swc_helpers":"0.5.3","npm_package_devDependencies_glob":"7.1.6","npm_package_devDependencies_prettier_eslint":"15.0.1","npm_package_dependencies__lightningjs_core":"2.9.0","npm_package_dependencies_history":"4.9.0","npm_package_dependencies_redux":"4.0.5","npm_package_dependencies_swc_minify_webpack_plugin":"2.1.1","npm_package_devDependencies__storybook_theming":"6.2.9","npm_package_devDependencies_eslint":"8.50.0","npm_package_devDependencies_webpack":"5.88.2","npm_package_scripts_dev_rtlde":"APP_CUSTOMER=rtlde pnpm dev","npm_package_scripts_format_md":"prettier-eslint --write $PWD/'**/*.md' $PWD/'.*/**/*.md'","npm_package_scripts_storybook_rtlnl":"APP_CUSTOMER=rtlnl start-storybook -p 6006","RUNNER_NAME":"app-bedrock-rdk-deploy-wsgds-d6wcd","GITHUB_REF_NAME":"master","GITHUB_REPOSITORY":"m6web/app-bedrock-rdk","S3_PATH":"s3://bedrock-rdk-rtlde-staging-vodafone","npm_package_devDependencies__storybook_html":"6.2.9","npm_package_devDependencies_dotenv":"16.0.3","npm_package_scripts_e2e":"pnpm cypress open --e2e -b chrome","npm_package_scripts_prod_rtlde":"APP_CUSTOMER=rtlde pnpm prod","npm_lifecycle_script":"pelo build \"vodafone\" \"--skip-native-build\"","GITHUB_ACTION_REF":"","DEBIAN_FRONTEND":"noninteractive","npm_package_devDependencies__babel_runtime_corejs3":"7.22.3","npm_package_devDependencies__cypress_webpack_preprocessor":"6.0.0","npm_package_devDependencies__pelo_core":"10.0.0-alpha.1","npm_package_devDependencies__storybook_addons":"6.2.9","npm_package_scripts_test":"PELO_PLATFORM=rdk APP_ENV=test node scripts/test --config=config/jest/config.js","GITHUB_REPOSITORY_ID":"2571","GITHUB_ACTIONS":"true","GOPROXY":"https://goproxy.services.bedrock.tech","NODE_PATH":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules/@pelo/cli/bin/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules/@pelo/cli/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules/@pelo/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/bin/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/node_modules","npm_package_repository_url":"https://github.m6web.fr/m6web/app-bedrock-rdk.git","npm_package_version":"1.48.0","npm_package_dependencies__bedrock_ad_engine":"5.29.4","npm_package_devDependencies__m6web_eslint_plugin_i18n":"2.0.1","npm_package_devDependencies_jest_environment_jsdom":"29.5.0","npm_package_scripts_storybook_rtlhu":"APP_CUSTOMER=rtlhu start-storybook -p 6006","npm_package_pnpm_overrides__lightningjs_sdk":"5.5.5","npm_lifecycle_event":"build","ACTIONS_RUNNER_HOOK_JOB_COMPLETED":"/etc/arc/hooks/job-completed.sh","GITHUB_REF_PROTECTED":"true","GONOSUMDB":"github.m6web.fr","GONOPROXY":"none","npm_package_dependencies_uuid":"10.0.0","npm_package_scripts_build":"pelo build \"vodafone\" \"--skip-native-build\"","npm_package_scripts_upload":"node scripts/uploadToMetrologicalAppStore","GITHUB_WORKSPACE":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","GITHUB_JOB":"build","npm_package_author":"Bedrock","npm_package_engines_pnpm":"9.x.x","npm_package_dependencies__bedrock_youbora_adapter_adengine":"1.7.22","npm_package_dependencies_lodash":"4.17.21","npm_package_devDependencies_cypress":"13.3.0","npm_package_devDependencies_http_server":"14.1.1","npm_package_scripts_test_coverage":"PELO_PLATFORM=rdk APP_ENV=test node scripts/test --config=config/jest/config.js --coverage","GITHUB_SHA":"4ff2b3c7a982f2634428e9d3f25c715365c487e8","GOMAXPROC":"8","GITHUB_RUN_ATTEMPT":"1","DOCKER_HOST":"unix:///run/docker.sock","npm_package_dependencies__bedrock_media_engine":"4.13.0","npm_package_devDependencies__pelo_cli":"10.0.0-alpha.1","KUBERNETES_SERVICE_PORT_HTTPS":"443","GOPRIVATE":"*.m6web.fr,*.bedrock.tech","GITHUB_REF":"refs/heads/master","KUBERNETES_PORT_443_TCP":"tcp://[fd39:f9c4:855c::1]:443","GITHUB_ACTOR":"skovalchuk-externe","npm_package_license":"UNLICENSED","npm_package_dependencies_markdown_it":"12.2.0","DOCKERD_IN_RUNNER":"false","npm_package_dependencies_crypto_js":"3.1.9-1","npm_package_dependencies_qrcode":"1.5.4","npm_package_dependencies_stream_browserify":"3.0.0","npm_package_devDependencies_eslint_plugin_prettier":"5.0.0","npm_package_scripts_format":"pnpm format:js && pnpm format:md && pnpm format:lang","npm_package_scripts_update_lang":"run-s 'i18n:pull {1}' format:lang --","GITHUB_PATH":"/runner/_work/_temp/_runner_file_commands/add_path_6041b297-2e35-451c-a738-c808c6587fef","PWD":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","IS_STAGING":"true","APP_ENV":"prod","GITHUB_ACTOR_ID":"627","KUBERNETES_SERVICE_HOST":"fd39:f9c4:855c::1","RUNNER_WORKSPACE":"/runner/_work/app-bedrock-rdk","npm_package_dependencies_path_to_regexp":"3.0.0","npm_package_scripts_explore":"source-map-explorer build/static/js/main.*","npm_package_scripts_format_tf":"terraform fmt -recursive -write=true .cloud/terraform","npm_execpath":"/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/bin/pnpm.cjs","GITHUB_EVENT_NAME":"workflow_dispatch","GITHUB_SERVER_URL":"https://github.m6web.fr","GITHUB_OUTPUT":"/runner/_work/_temp/_runner_file_commands/set_output_6041b297-2e35-451c-a738-c808c6587fef","npm_package_dependencies__bedrock_rdk_config":"workspace:*","npm_package_devDependencies__pelo_platforms_kpn":"10.0.0-alpha.1","npm_package_devDependencies_es_check":"7.1.1","npm_package_devDependencies_fs_extra":"9.1.0","npm_package_devDependencies_swc_mut_cjs_exports":"0.86.17","RUNNER_STATUS_UPDATE_HOOK":"false","npm_package_dependencies_browser_cookies":"1.2.0","npm_package_dependencies_date_fns":"2.28.0","npm_package_devDependencies__badeball_cypress_cucumber_preprocessor":"18.0.6","npm_package_devDependencies_svgo_loader":"3.0.1","npm_package_scripts_build_storybook":"build-storybook -o dist-storybook","npm_command":"run-script","PNPM_SCRIPT_SRC_DIR":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","APP_CUSTOMER":"rtlde","npm_package_dependencies_storybook_addon_themes":"6.1.0","npm_package_devDependencies__storybook_addon_essentials":"6.2.9","npm_package_scripts_format_js":"prettier-eslint --write $PWD/'src/**/*.js' $PWD/'packages/**/*.js' $PWD/'platforms/**/*.js' $PWD/'config/**/*.js'","PNPM_HOME":"/home/runner/setup-pnpm/node_modules/.bin","RUNNER_ENTERPRISE":"","npm_package_dependencies__tornado_rdk_typography":"workspace:*","npm_package_dependencies_babel_loader":"9.1.2","GITHUB_STEP_SUMMARY":"/runner/_work/_temp/_runner_file_commands/step_summary_6041b297-2e35-451c-a738-c808c6587fef","npm_package_dependencies__lightningjs_sdk":"5.5.5","npm_package_dependencies__pelo_plugins_keys":"workspace:*","npm_package_devDependencies_swc_loader":"0.2.3","npm_package_scripts_build_rtlde":"APP_CUSTOMER=rtlde pnpm build","npm_package_scripts_format_lang":"prettier-eslint --write $PWD/'lang/**/*.json'","npm_package_pnpm_overrides_webpack":"5.88.2","npm_package_pnpm_peerDependencyRules_allowedVersions_webpack":"5","INIT_CWD":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","NODE_ENV":"production"}.APP_ID) {
  var id = 'APP_'.concat({"PELO_PLATFORM":"vodafone","APP_VERSION":"1.48.0","OPTIONS":"{\"platform\":\"vodafone\",\"packaged\":false,\"debug\":false,\"skipHook\":false,\"skipNativeBuild\":true,\"skipBundler\":false}","GITHUB_STATE":"/runner/_work/_temp/_runner_file_commands/save_state_6041b297-2e35-451c-a738-c808c6587fef","npm_package_dependencies__babel_runtime":"7.22.3","npm_package_dependencies__pelo_plugins_screen":"workspace:*","npm_package_dependencies_regenerator_runtime":"0.13.11","npm_package_devDependencies_identity_obj_proxy":"3.0.0","npm_package_scripts_build_config_rtlnl":"APP_CUSTOMER=rtlnl node scripts/build-config","KUBERNETES_SERVICE_PORT":"443","KUBERNETES_PORT":"tcp://[fd39:f9c4:855c::1]:443","npm_package_dependencies_immutable_set":"2.1.0","npm_package_devDependencies__storybook_addon_knobs":"6.2.9","npm_package_devDependencies_prettier_eslint_cli":"7.1.0","npm_package_scripts_preinstall":"npx only-allow pnpm","npm_package_devDependencies__storybook_addon_docs":"6.2.9","npm_package_devDependencies_jest":"29.5.0","npm_package_devDependencies_webpack_bundle_analyzer":"4.10.2","npm_package_scripts_dev_rtlnl":"APP_CUSTOMER=rtlnl pnpm dev","npm_config_user_agent":"pnpm/9.14.4 npm/? node/v22.19.0 linux x64","CI":"true","npm_package_dependencies__bedrock_rdk_constants":"workspace:*","npm_package_dependencies__tornado_rdk_theme":"workspace:*","npm_package_dependencies_abortcontroller_polyfill":"1.7.8","npm_package_devDependencies__lightningjs_cli":"2.2.0","npm_package_scripts_build_config_rtlhu":"APP_CUSTOMER=rtlhu node scripts/build-config","npm_package_scripts_prod_rtlnl":"APP_CUSTOMER=rtlnl pnpm prod","HOSTNAME":"app-bedrock-rdk-deploy-wsgds-d6wcd","RUNNER_ENVIRONMENT":"self-hosted","GITHUB_ENV":"/runner/_work/_temp/_runner_file_commands/set_env_6041b297-2e35-451c-a738-c808c6587fef","UPLOAD_SOURCE_MAPS":"false","npm_package_dependencies__bedrock_rdk_utils":"workspace:*","npm_node_execpath":"/opt/hostedtoolcache/node/22.19.0/x64/bin/node","GITHUB_ACTIONS_RUNNER_EXTRA_USER_AGENT":"actions-runner-controller/v0.27.6","RUNNER_EPHEMERAL":"true","SHLVL":"4","npm_package_packageManager":"pnpm@9.14.4","npm_package_dependencies__bedrock_rdk_lng_storybook":"workspace:*","npm_package_dependencies_html_webpack_plugin":"5.5.0","npm_package_devDependencies__swc_core":"1.3.95","npm_package_scripts_dev_rtlhu":"APP_CUSTOMER=rtlhu pnpm dev","npm_package_scripts_nr_create_browser_applications":"node scripts/createNewRelicApps.js","HOME":"/home/runner","npm_package_devDependencies__babel_plugin_proposal_class_properties":"7.18.6","npm_package_devDependencies__bedrock_package_json_loader":"1.2.4","npm_package_devDependencies_jest_webgl_canvas_mock":"0.2.3","npm_package_scripts_prod_rtlhu":"APP_CUSTOMER=rtlhu pnpm prod","RUNNER_ORG":"","AWS_ROLE_ARN":"arn:aws:iam::374115518324:role/irsa/runners/app-bedrock-rdk-deploy","RUNNER_TEMP":"/runner/_work/_temp","GITHUB_EVENT_PATH":"/runner/_work/_temp/_github_workflow/event.json","npm_package_devDependencies_eslint_config_prettier":"9.0.0","npm_package_scripts_lint_filenames":"node scripts/checkFileScopes.js","npm_package_scripts_server":"http-server -c-1 build","npm_package_scripts_storybook_rtlde":"APP_CUSTOMER=rtlde start-storybook -p 6006","DOCKER_ENABLED":"true","GITHUB_REPOSITORY_OWNER":"m6web","npm_package_engines_node":"22.x","npm_package_dependencies__bedrock_html5_engine":"3.6.8","npm_package_devDependencies__6play_ryp":"3.2.4","npm_package_devDependencies__bedrock_github_api_utils":"1.0.1","npm_package_scripts_lint_json":"pnpm sort-keys:json --lint && prettier-eslint --list-different '/{.,}*.json' --ignore-path '**/package.json'","RUNNER_WORKDIR":"/runner/_work","GENERATE_SOURCEMAP":"true","AWS_WEB_IDENTITY_TOKEN_FILE":"/var/run/secrets/eks.amazonaws.com/serviceaccount/token","GITHUB_RETENTION_DAYS":"7","npm_package_devDependencies__pelo_platforms_vodafone":"10.0.0-alpha.1","npm_package_devDependencies_minimist":"1.2.5","npm_package_scripts_i18n_pull":"node ./scripts/i18nPull.js","npm_package_scripts_lint_md":"pnpm prettier-eslint --list-different $PWD/'**/*.md' $PWD/'.*/**/*.md'","GITHUB_REPOSITORY_OWNER_ID":"5","GITHUB_HEAD_REF":"","npm_package_dependencies_redux_thunk":"2.3.0","ACTIONS_RUNNER_HOOK_JOB_STARTED":"/etc/arc/hooks/job-started.sh","npm_package_dependencies_copy_webpack_plugin":"11.0.0","npm_package_devDependencies__swc_plugin_transform_imports":"1.5.94","npm_package_devDependencies_source_map_explorer":"1.6.0","npm_package_cypress_cucumber_preprocessor_stepDefinitions_0":"cypress/e2e/common/*.js","GITHUB_GRAPHQL_URL":"https://github.m6web.fr/api/graphql","REF":"v1.48.0","npm_package_dependencies__tornado_rdk_icons":"workspace:*","npm_package_dependencies_algoliasearch":"4.12.1","npm_package_dependencies_superagent":"3.8.3","npm_package_devDependencies_slack":"11.0.2","npm_package_scripts_build_config":"node scripts/build-config","npm_package_cypress_cucumber_preprocessor_stepDefinitions_1":"cypress/e2e/[filepart]/**/*.js","npm_package_dependencies_jwt_decode":"2.2.0","npm_package_devDependencies__babel_preset_env":"7.12.1","npm_package_scripts_e2e_rtlnl":"APP_CUSTOMER=rtlnl pnpm cypress open --e2e -b chrome","npm_package_pnpm_overrides__lightningjs_core":"2.9.0","npm_package_cypress_cucumber_preprocessor_stepDefinitions_2":"cypress/e2e/[filepart].js","GITHUB_URL":"https://github.m6web.fr/","RUNNER_ASSETS_DIR":"/runnertmp","npm_package_devDependencies__babel_plugin_transform_runtime":"7.22.4","npm_package_devDependencies_inquirer":"8.1.5","npm_package_scripts_dev":"APP_ENV=development pelo run","RUNNER_OS":"Linux","GITHUB_API_URL":"https://github.m6web.fr/api/v3","MAXPROC":"8","RUNNER_LABELS":"self-hosted,app-bedrock-rdk-deploy","npm_package_devDependencies__pelo_platforms_ziggo":"10.0.0-alpha.1","npm_package_devDependencies_eslint_plugin_import":"2.28.1","npm_package_scripts_logs":"node scripts/logs.js","npm_package_scripts_prod":"APP_ENV=prod pelo run","_":"/home/runner/setup-pnpm/node_modules/.bin/pnpm","RUNNER_GROUP":"green-gha-eks-bedrock-tech","HELM_REGISTRY_CONFIG":"/home/runner/.docker/config.json","GITHUB_WORKFLOW":"🏷 Release staging","npm_package_private":"true","npm_package_dependencies_sprintf_js":"1.1.2","npm_package_devDependencies__m6web_eslint_config":"3.5.0","npm_package_devDependencies_jsonlint":"1.6.3","npm_package_scripts_build_rtlnl":"APP_CUSTOMER=rtlnl pnpm build","npm_package_dependencies__bedrock_rdk_media_engine":"workspace:*","npm_package_dependencies_lightningjs_redux":"workspace:*","npm_package_devDependencies__babel_plugin_proposal_decorators":"7.22.3","npm_package_scripts_lint":"pnpm lint:js && pnpm lint:md && pnpm lint:json && pnpm lint:filenames","npm_config_registry":"https://verdaccio.bedrock.tech","GITHUB_RUN_ID":"3165446","npm_package_dependencies__bedrock_fido_sdk":"29.30.0","npm_package_dependencies_core_js":"3.32.1","npm_package_devDependencies__swc_jest":"0.2.29","npm_package_scripts_lint_tf":"terraform fmt -check -recursive -diff .cloud/terraform","npm_package_scripts_sort_keys_json":"node ./scripts/sortKeysJson.js","npm_package_pnpm_overrides_lodash":"4.17.21","GITHUB_REF_TYPE":"branch","GITHUB_WORKFLOW_SHA":"4ff2b3c7a982f2634428e9d3f25c715365c487e8","KUBERNETES_PORT_443_TCP_ADDR":"fd39:f9c4:855c::1","GITHUB_BASE_REF":"","ImageOS":"ubuntu22","npm_package_devDependencies_dotenv_expand":"5.1.0","npm_package_scripts_build_rtlhu":"APP_CUSTOMER=rtlhu pnpm build","GITHUB_WORKFLOW_REF":"m6web/app-bedrock-rdk/.github/workflows/release-deploy-staging.yml@refs/heads/master","GITHUB_ACTION_REPOSITORY":"","npm_config_node_gyp":"/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/dist/node_modules/node-gyp/bin/node-gyp.js","PATH":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.bin:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/dist/node-gyp-bin:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.bin:/opt/hostedtoolcache/node/22.19.0/x64/bin:/home/runner/setup-pnpm/node_modules/.bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin:/home/runner/.local/bin/","RUNNER_TRACKING_ID":"github_d6d391a5-4033-4ac4-8937-906499292394","RUNNER_TOOL_CACHE":"/opt/hostedtoolcache","npm_package_name":"app-bedrock-rdk","npm_package_repository_type":"git","npm_package_dependencies_serve":"14.1.2","npm_package_devDependencies__babel_eslint_parser":"7.22.15","npm_package_scripts_lint_js":"pnpm eslint --max-warnings=0 .pelo.config.js src/ packages/ platforms/ --cache","NODE":"/opt/hostedtoolcache/node/22.19.0/x64/bin/node","GITHUB_ACTION":"__run_4","GITHUB_RUN_NUMBER":"312","GITHUB_TRIGGERING_ACTOR":"skovalchuk-externe","RUNNER_ARCH":"X64","KUBERNETES_PORT_443_TCP_PORT":"443","npm_package_devDependencies_eslint_config_airbnb_base":"15.0.0","npm_package_scripts_analyze":"APP_ENV=detective pnpm build","npm_package_scripts_build_config_rtlde":"APP_CUSTOMER=rtlde node scripts/build-config","npm_config_frozen_lockfile":"","RUN_URL":"https://github.m6web.fr/m6web/app-bedrock-rdk/actions/runs/3165446","KUBERNETES_PORT_443_TCP_PROTO":"tcp","npm_package_dependencies__pelo_plugins_device":"workspace:*","npm_package_devDependencies__bedrock_deploy_event":"0.11.0","npm_package_devDependencies__pelo_platforms_web":"10.0.0-alpha.1","npm_package_devDependencies__swc_helpers":"0.5.3","npm_package_devDependencies_glob":"7.1.6","npm_package_devDependencies_prettier_eslint":"15.0.1","npm_package_dependencies__lightningjs_core":"2.9.0","npm_package_dependencies_history":"4.9.0","npm_package_dependencies_redux":"4.0.5","npm_package_dependencies_swc_minify_webpack_plugin":"2.1.1","npm_package_devDependencies__storybook_theming":"6.2.9","npm_package_devDependencies_eslint":"8.50.0","npm_package_devDependencies_webpack":"5.88.2","npm_package_scripts_dev_rtlde":"APP_CUSTOMER=rtlde pnpm dev","npm_package_scripts_format_md":"prettier-eslint --write $PWD/'**/*.md' $PWD/'.*/**/*.md'","npm_package_scripts_storybook_rtlnl":"APP_CUSTOMER=rtlnl start-storybook -p 6006","RUNNER_NAME":"app-bedrock-rdk-deploy-wsgds-d6wcd","GITHUB_REF_NAME":"master","GITHUB_REPOSITORY":"m6web/app-bedrock-rdk","S3_PATH":"s3://bedrock-rdk-rtlde-staging-vodafone","npm_package_devDependencies__storybook_html":"6.2.9","npm_package_devDependencies_dotenv":"16.0.3","npm_package_scripts_e2e":"pnpm cypress open --e2e -b chrome","npm_package_scripts_prod_rtlde":"APP_CUSTOMER=rtlde pnpm prod","npm_lifecycle_script":"pelo build \"vodafone\" \"--skip-native-build\"","GITHUB_ACTION_REF":"","DEBIAN_FRONTEND":"noninteractive","npm_package_devDependencies__babel_runtime_corejs3":"7.22.3","npm_package_devDependencies__cypress_webpack_preprocessor":"6.0.0","npm_package_devDependencies__pelo_core":"10.0.0-alpha.1","npm_package_devDependencies__storybook_addons":"6.2.9","npm_package_scripts_test":"PELO_PLATFORM=rdk APP_ENV=test node scripts/test --config=config/jest/config.js","GITHUB_REPOSITORY_ID":"2571","GITHUB_ACTIONS":"true","GOPROXY":"https://goproxy.services.bedrock.tech","NODE_PATH":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules/@pelo/cli/bin/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules/@pelo/cli/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules/@pelo/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/@pelo+cli@10.0.0-alpha.1_@babel+core@7.27.4_@swc+core@1.3.95_@swc+helpers@0.5.3__@types+webpa_eyh3qr2suoq7louvyapz62n3cq/node_modules:/runner/_work/app-bedrock-rdk/app-bedrock-rdk/node_modules/.pnpm/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/bin/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules:/home/runner/setup-pnpm/node_modules/.pnpm/node_modules","npm_package_repository_url":"https://github.m6web.fr/m6web/app-bedrock-rdk.git","npm_package_version":"1.48.0","npm_package_dependencies__bedrock_ad_engine":"5.29.4","npm_package_devDependencies__m6web_eslint_plugin_i18n":"2.0.1","npm_package_devDependencies_jest_environment_jsdom":"29.5.0","npm_package_scripts_storybook_rtlhu":"APP_CUSTOMER=rtlhu start-storybook -p 6006","npm_package_pnpm_overrides__lightningjs_sdk":"5.5.5","npm_lifecycle_event":"build","ACTIONS_RUNNER_HOOK_JOB_COMPLETED":"/etc/arc/hooks/job-completed.sh","GITHUB_REF_PROTECTED":"true","GONOSUMDB":"github.m6web.fr","GONOPROXY":"none","npm_package_dependencies_uuid":"10.0.0","npm_package_scripts_build":"pelo build \"vodafone\" \"--skip-native-build\"","npm_package_scripts_upload":"node scripts/uploadToMetrologicalAppStore","GITHUB_WORKSPACE":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","GITHUB_JOB":"build","npm_package_author":"Bedrock","npm_package_engines_pnpm":"9.x.x","npm_package_dependencies__bedrock_youbora_adapter_adengine":"1.7.22","npm_package_dependencies_lodash":"4.17.21","npm_package_devDependencies_cypress":"13.3.0","npm_package_devDependencies_http_server":"14.1.1","npm_package_scripts_test_coverage":"PELO_PLATFORM=rdk APP_ENV=test node scripts/test --config=config/jest/config.js --coverage","GITHUB_SHA":"4ff2b3c7a982f2634428e9d3f25c715365c487e8","GOMAXPROC":"8","GITHUB_RUN_ATTEMPT":"1","DOCKER_HOST":"unix:///run/docker.sock","npm_package_dependencies__bedrock_media_engine":"4.13.0","npm_package_devDependencies__pelo_cli":"10.0.0-alpha.1","KUBERNETES_SERVICE_PORT_HTTPS":"443","GOPRIVATE":"*.m6web.fr,*.bedrock.tech","GITHUB_REF":"refs/heads/master","KUBERNETES_PORT_443_TCP":"tcp://[fd39:f9c4:855c::1]:443","GITHUB_ACTOR":"skovalchuk-externe","npm_package_license":"UNLICENSED","npm_package_dependencies_markdown_it":"12.2.0","DOCKERD_IN_RUNNER":"false","npm_package_dependencies_crypto_js":"3.1.9-1","npm_package_dependencies_qrcode":"1.5.4","npm_package_dependencies_stream_browserify":"3.0.0","npm_package_devDependencies_eslint_plugin_prettier":"5.0.0","npm_package_scripts_format":"pnpm format:js && pnpm format:md && pnpm format:lang","npm_package_scripts_update_lang":"run-s 'i18n:pull {1}' format:lang --","GITHUB_PATH":"/runner/_work/_temp/_runner_file_commands/add_path_6041b297-2e35-451c-a738-c808c6587fef","PWD":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","IS_STAGING":"true","APP_ENV":"prod","GITHUB_ACTOR_ID":"627","KUBERNETES_SERVICE_HOST":"fd39:f9c4:855c::1","RUNNER_WORKSPACE":"/runner/_work/app-bedrock-rdk","npm_package_dependencies_path_to_regexp":"3.0.0","npm_package_scripts_explore":"source-map-explorer build/static/js/main.*","npm_package_scripts_format_tf":"terraform fmt -recursive -write=true .cloud/terraform","npm_execpath":"/home/runner/setup-pnpm/node_modules/.pnpm/pnpm@9.14.4/node_modules/pnpm/bin/pnpm.cjs","GITHUB_EVENT_NAME":"workflow_dispatch","GITHUB_SERVER_URL":"https://github.m6web.fr","GITHUB_OUTPUT":"/runner/_work/_temp/_runner_file_commands/set_output_6041b297-2e35-451c-a738-c808c6587fef","npm_package_dependencies__bedrock_rdk_config":"workspace:*","npm_package_devDependencies__pelo_platforms_kpn":"10.0.0-alpha.1","npm_package_devDependencies_es_check":"7.1.1","npm_package_devDependencies_fs_extra":"9.1.0","npm_package_devDependencies_swc_mut_cjs_exports":"0.86.17","RUNNER_STATUS_UPDATE_HOOK":"false","npm_package_dependencies_browser_cookies":"1.2.0","npm_package_dependencies_date_fns":"2.28.0","npm_package_devDependencies__badeball_cypress_cucumber_preprocessor":"18.0.6","npm_package_devDependencies_svgo_loader":"3.0.1","npm_package_scripts_build_storybook":"build-storybook -o dist-storybook","npm_command":"run-script","PNPM_SCRIPT_SRC_DIR":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","APP_CUSTOMER":"rtlde","npm_package_dependencies_storybook_addon_themes":"6.1.0","npm_package_devDependencies__storybook_addon_essentials":"6.2.9","npm_package_scripts_format_js":"prettier-eslint --write $PWD/'src/**/*.js' $PWD/'packages/**/*.js' $PWD/'platforms/**/*.js' $PWD/'config/**/*.js'","PNPM_HOME":"/home/runner/setup-pnpm/node_modules/.bin","RUNNER_ENTERPRISE":"","npm_package_dependencies__tornado_rdk_typography":"workspace:*","npm_package_dependencies_babel_loader":"9.1.2","GITHUB_STEP_SUMMARY":"/runner/_work/_temp/_runner_file_commands/step_summary_6041b297-2e35-451c-a738-c808c6587fef","npm_package_dependencies__lightningjs_sdk":"5.5.5","npm_package_dependencies__pelo_plugins_keys":"workspace:*","npm_package_devDependencies_swc_loader":"0.2.3","npm_package_scripts_build_rtlde":"APP_CUSTOMER=rtlde pnpm build","npm_package_scripts_format_lang":"prettier-eslint --write $PWD/'lang/**/*.json'","npm_package_pnpm_overrides_webpack":"5.88.2","npm_package_pnpm_peerDependencyRules_allowedVersions_webpack":"5","INIT_CWD":"/runner/_work/app-bedrock-rdk/app-bedrock-rdk","NODE_ENV":"production"}.APP_ID.replace(/[^0-9a-zA-Z_$]/g, '_'));
  window[id] = appLauncher;
}
/* harmony default export */ const src_0 = (appLauncher);
;// CONCATENATED MODULE: ./src/boot.js









var boot_boot = function () {
  var _ref = (0,asyncToGenerator/* default */.Z)(regenerator_default().mark(function _callee() {
    var model, _getSettings, platformSettings, app, canvas;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return handleDeeplink();
        case 2:
          _context.next = 4;
          return deviceInfo.getModel();
        case 4:
          model = _context.sent;
          window.RDK_MODEL_NAME = model;
          _getSettings = getSettings(), platformSettings = _getSettings.platformSettings;
          if (true) {
            _context.next = 10;
            break;
          }
          _context.next = 10;
          return __webpack_require__.e(/* import() */ 421).then(__webpack_require__.t.bind(__webpack_require__, 99421, 23));
        case 10:
          app = src_0();
          canvas = app.stage.getCanvas();
          document.body.appendChild(canvas);
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function boot() {
    return _ref.apply(this, arguments);
  };
}();
boot_boot();
})();

/******/ })()
;